import { useState, useCallback, useEffect } from 'react';

// *********************************************
// Apollo Layout Branding types
// Used to convert the raw branding data from the LXP API into a format that can be used by the Apollo Layout
// *********************************************
var LAYOUT_SCHEMA = "NavigationBranding";

function _define_property$8(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$7(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$8(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$6(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$6(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$6(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
// **********************************************************
// Layout API Utils
// **********************************************************
/**
 * Convert Layout API response to BrandingState
 */ function layoutToBranding(response) {
    var _response_Components__Parameters, _response_Components_;
    var branding = response ? JSON.parse((_response_Components_ = response.Components[0]) === null || _response_Components_ === void 0 ? void 0 : (_response_Components__Parameters = _response_Components_.Parameters) === null || _response_Components__Parameters === void 0 ? void 0 : _response_Components__Parameters.data) : null;
    // Force reset dirty flags
    if (branding) {
        branding.navigation.isDirty = false;
        branding.endorsements.isDirty = false;
        branding.orgInfo.isDirty = false;
    }
    return branding;
}
/**
 * Convert BrandingState to Layout API schema
 */ function brandingToLayout(param) {
    var navigation = param.navigation;
    return {
        SchemaName: LAYOUT_SCHEMA,
        Components: [
            {
                ComponentName: "branding-v3",
                Parameters: {
                    data: JSON.stringify({
                        navigation: navigation
                    })
                }
            }
        ]
    };
}
/**
 * Update target LayoutAspect with Navigation state
 */ function navigationToAspect(state, aspect) {
    var _aspect_brand, _aspect_brand1, _aspect_brand2, _aspect_brand3;
    var colors = state.colors, logo = state.logo, mark = state.mark;
    return _object_spread_props$6(_object_spread$7({}, aspect), {
        brand: _object_spread_props$6(_object_spread$7({}, aspect.brand), {
            colors: colors,
            logo: _object_spread_props$6(_object_spread$7({}, (_aspect_brand = aspect.brand) === null || _aspect_brand === void 0 ? void 0 : _aspect_brand.logo), {
                url: (logo === null || logo === void 0 ? void 0 : logo.url) || ((_aspect_brand1 = aspect.brand) === null || _aspect_brand1 === void 0 ? void 0 : _aspect_brand1.logo.url) || "",
                altText: logo === null || logo === void 0 ? void 0 : logo.altText
            }),
            mark: _object_spread_props$6(_object_spread$7({}, (_aspect_brand2 = aspect.brand) === null || _aspect_brand2 === void 0 ? void 0 : _aspect_brand2.mark), {
                url: (mark === null || mark === void 0 ? void 0 : mark.url) || ((_aspect_brand3 = aspect.brand) === null || _aspect_brand3 === void 0 ? void 0 : _aspect_brand3.mark.url) || "",
                altText: mark === null || mark === void 0 ? void 0 : mark.altText
            })
        })
    });
}
function getHexColorFromCSSVariable(variableName) {
    if (!variableName || !variableName.startsWith("var(") && !variableName.startsWith("--")) return variableName;
    variableName = variableName.replace(/var\((--[\w-]+)\)/, "$1");
    var computedStyle = getComputedStyle(document.documentElement);
    var colorValue = computedStyle.getPropertyValue(variableName);
    // Check if the color is already in hex format
    if (colorValue.startsWith("#")) {
        return colorValue;
    }
    // Convert RGB/RGBA to hex
    var rgbMatch = colorValue.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)/);
    if (rgbMatch) {
        var r = parseInt(rgbMatch[1]).toString(16).padStart(2, "0");
        var g = parseInt(rgbMatch[2]).toString(16).padStart(2, "0");
        var b = parseInt(rgbMatch[3]).toString(16).padStart(2, "0");
        return "#".concat(r).concat(g).concat(b);
    }
    // Return the color value as it is not in a recognized format
    return colorValue;
}

function asyncGeneratorStep$3(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator$3(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$3(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$3(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property$7(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$6(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$7(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$5(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$5(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _ts_generator$3(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var sameOriginRequestInit$2 = {
    credentials: "same-origin",
    method: "GET",
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
    }
};
var loadBranding = function() {
    var _ref = _async_to_generator$3(function(user, orgInfo) {
        var apiEnabled, layout, _tmp;
        var _arguments = arguments;
        return _ts_generator$3(this, function(_state) {
            switch(_state.label){
                case 0:
                    apiEnabled = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : true;
                    if (!apiEnabled) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        loadLayoutBranding(orgInfo.organizationId)
                    ];
                case 1:
                    _tmp = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    _tmp = null;
                    _state.label = 3;
                case 3:
                    layout = _tmp;
                    layout || (layout = loadCustomizedBranding(orgInfo, apiEnabled));
                    layout || (layout = loadLegacyBranding(orgInfo));
                    return [
                        2,
                        layout
                    ];
            }
        });
    });
    return function loadBranding(user, orgInfo) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Load branding from the new Layout API
 *
 * @Todo: use semantic REST e.g.  '/orgs/{orgId}/layout/<LAYOUT_SCHEMA>'
 *        support GET, POST, and PUT with same endpoint
 */ var loadLayoutBranding = function() {
    var _ref = _async_to_generator$3(function(orgId) {
        var response, layout;
        return _ts_generator$3(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        fetch("/api/layout/".concat(LAYOUT_SCHEMA, "?orgId=").concat(orgId), sameOriginRequestInit$2)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    layout = _state.sent();
                    return [
                        2,
                        layoutToBranding(layout)
                    ];
                case 3:
                    _state.sent();
                    // console.error('Error loading layout branding', error);
                    return [
                        2,
                        null
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function loadLayoutBranding(orgId) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Load legacy branding; from the authenticated user information
 */ function loadLegacyBranding(orgInfo) {
    var branding = orgInfo === null || orgInfo === void 0 ? void 0 : orgInfo.organizationBranding;
    return branding ? {
        navigation: {
            colors: {
                background: branding.brandColor,
                text: branding.useLightText ? "#ffffff" : getHexColorFromCSSVariable("--apollo-color-neutral-800")
            },
            mark: {
                backgroundColor: branding.brandColor,
                altText: orgInfo.name,
                url: orgInfo.image,
                imageType: "mark",
                progress: 0
            },
            logo: {
                backgroundColor: branding.brandColor,
                altText: orgInfo.name,
                url: orgInfo.image,
                imageType: "logo",
                progress: 0
            }
        }
    } : null;
}
/**
 * Save branding to the new Layout API
 */ var saveLayoutBranding = function() {
    var _ref = _async_to_generator$3(function(navigationBranding, orgInfo) {
        var orgBranding, fullBranding, error;
        return _ts_generator$3(this, function(_state) {
            switch(_state.label){
                case 0:
                    orgBranding = orgInfo.organizationBranding;
                    fullBranding = _object_spread_props$5(_object_spread$6({}, navigationBranding), {
                        orgInfo: {
                            isDirty: false,
                            orgName: orgInfo.name || "",
                            useInOnboarding: orgBranding === null || orgBranding === void 0 ? void 0 : orgBranding.organizationNameInOnboarding
                        },
                        endorsements: {
                            isDirty: false,
                            endorsement: {
                                altText: "Degreed",
                                url: orgInfo.endorsedImage,
                                imageType: "endorsement",
                                progress: 0
                            }
                        }
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        fetch("/api/layout/".concat(LAYOUT_SCHEMA, "?orgId=").concat(orgInfo.organizationId), _object_spread_props$5(_object_spread$6({}, sameOriginRequestInit$2), {
                            method: "POST",
                            body: JSON.stringify(brandingToLayout(fullBranding))
                        }))
                    ];
                case 2:
                    _state.sent();
                    return [
                        2,
                        true
                    ];
                case 3:
                    error = _state.sent();
                    console.error("Error saving branding to Layout API", error);
                    return [
                        2,
                        false
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function saveLayoutBranding(navigationBranding, orgInfo) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * The branding is not yet available in the new Layout API.
 * Check if we have a v2 customized branding (eg 'wells-fargo.config.json').
 *
 * If yes
 *  - convert customization to branding
 *  - save the branding to the new Layout API
 *  - return the branding
 */ function loadCustomizedBranding(orgInfo) {
    var apiEnabled = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var _brand_mark, _brand_mark1, _brand_logo, _brand_logo1;
    var brand = findCustomization(orgInfo.organizationId);
    var colors = brand === null || brand === void 0 ? void 0 : brand.colors;
    var state = brand && colors ? {
        navigation: {
            colors: {
                background: colors.background,
                text: getHexColorFromCSSVariable(colors.text),
                highlight: colors.highlight,
                separator: getHexColorFromCSSVariable(colors.separator || colors.text)
            },
            mark: {
                backgroundColor: colors.background,
                altText: (_brand_mark = brand.mark) === null || _brand_mark === void 0 ? void 0 : _brand_mark.altText,
                url: (_brand_mark1 = brand.mark) === null || _brand_mark1 === void 0 ? void 0 : _brand_mark1.url,
                imageType: "mark",
                progress: 0
            },
            logo: {
                backgroundColor: colors.background,
                altText: (_brand_logo = brand.logo) === null || _brand_logo === void 0 ? void 0 : _brand_logo.altText,
                url: (_brand_logo1 = brand.logo) === null || _brand_logo1 === void 0 ? void 0 : _brand_logo1.url,
                imageType: "logo",
                progress: 0
            }
        }
    } : null;
    if (state && apiEnabled) {
        console.info("Wells-Fargo (orgId = ".concat(orgInfo.organizationId, ") branding upgraded to v3 (Oct, 2024) Layout API"));
        saveLayoutBranding(state, orgInfo);
    }
    return state;
}
/**
 * This is the branding customization snapshot for Wells Fargo, July 2024
 * This function is only used to auto-update those customizations to Oct 2024 Layout API
 *
 * NOTE: these settings are from the `wells-fargo.config.json` file
 */ function findCustomization(orgId) {
    switch(orgId){
        case 901724:
        case 700059:
        case 700043:
            return {
                mark: {
                    url: "data:image/svg+xml,%3Csvg id='Layer_1' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' viewBox='0 0 32 32'%3E%3Cdefs%3E%3Cstyle%3E .cls-1 %7B fill: %23d71e28; %7D .cls-1, .cls-2, .cls-3 %7B stroke-width: 0px; %7D .cls-4 %7B clip-path: url(%23clippath); %7D .cls-2 %7B fill: none; %7D .cls-3 %7B fill: %23fff; %7D %3C/style%3E%3CclipPath id='clippath'%3E%3Crect class='cls-2' x='.5' y='8.2' width='31' height='15.6'/%3E%3C/clipPath%3E%3C/defs%3E%3Crect class='cls-3' y='0' width='32' height='32'/%3E%3Cg class='cls-4'%3E%3Cpath class='cls-1' d='M2.7,14.4l-1.5-5.3h-.7v-.8h2.8v.8h-.8l1,3.6,1.2-4.4h1.2l1.2,4.4,1-3.7h-.8v-.8h7.3v2h-.6v-.2c-.3-.7-.4-1-1-1h-1.4v1.8h1.7c0,.1,0,.3,0,.4s0,.3,0,.4h-1.7v1.9h1.5c.6,0,.8-.2,1-1v-.3h.7v2.1h-5.2v-.8h.7v-4.5h-1.2l-1.5,5.3h-1.2l-1.2-4.4-1.3,4.4h-1.2ZM20.3,12.4h-.6v.3c-.2.8-.5,1-1.1,1h-1.2v-4.5h.8v-.8h-2.8v.8h.7v4.5h-.7v.8h4.9v-2.1ZM25.8,12.4h-.6v.3c-.2.8-.5,1-1.1,1h-1.2v-4.5h.8v-.8h-2.8v.8h.7v4.5h-.7v.8h4.9v-2.1ZM31.3,12.8c0-1-.6-1.6-1.7-1.9l-1.1-.3c-.6-.1-.9-.4-.9-.8s.4-.8,1.2-.8,1.3.3,1.4,1v.3h.7v-1.5c-.7-.4-1.4-.5-2.2-.5-1.5,0-2.4.7-2.4,1.8s.6,1.5,1.6,1.8l1.1.2c.7.2,1,.4,1,.9s-.4.9-1.3.9-1.5-.4-1.7-1.1v-.4h-.7v1.7c.8.4,1.5.6,2.6.6,1.5,0,2.4-.7,2.4-1.9h0ZM5,18.3c.6,0,.8.3,1,1v.2h.7v-2H1.5v.8h.7v4.5h-.7v.8h2.9v-.8h-.9v-1.8h1.8c0-.1,0-.3,0-.4s0-.3,0-.4h-1.8v-1.9h1.5ZM18.2,22.9c0,0,0,.2,0,.4s0,.3,0,.4c-.2,0-.4,0-.7,0-.8,0-1.2-.3-1.3-1.1v-.3c-.1-.9-.4-1.2-1.4-1.2h-.5v1.8h.8v.8h-5.4v-.8h.7l-.4-1.1h-2.2l-.4,1.1h.7v.8h-2.3v-.8h.6l2.1-5.3h1.1l2.2,5.3h1.2v-4.5h-.7v-.8h3.5c1.2,0,2,.6,2,1.6s-.8,1.5-1.6,1.5h0c.8,0,1.1.5,1.2,1.2v.3c0,.5.2.7.6.7s.1,0,.2,0h0ZM9.8,21l-.8-2.3-.8,2.3h1.7ZM16.5,19.3c0-.6-.4-1-1.2-1h-1v1.9h1c.8,0,1.2-.4,1.2-1ZM21.8,20.9c0,.2,0,.3,0,.4h1v1.5c-.3.1-.7.2-1,.2-1.2,0-1.9-.9-1.9-2.4s.6-2.4,1.8-2.4,1.2.4,1.5,1.1v.2h.7v-1.5c-.8-.4-1.5-.5-2.3-.5-1.9,0-3.2,1.3-3.2,3.2s1.2,3.2,3.2,3.2,1.6-.2,2.4-.6v-2.7h-2.3c0,.1,0,.2,0,.4h0ZM31.5,20.6c0,1.9-1.3,3.2-3.2,3.2s-3.2-1.3-3.2-3.2,1.4-3.2,3.2-3.2,3.2,1.3,3.2,3.2ZM30.1,20.6c0-1.5-.6-2.4-1.8-2.4s-1.8.9-1.8,2.4.6,2.4,1.8,2.4,1.8-.9,1.8-2.4Z'/%3E%3C/g%3E%3C/svg%3E",
                    altText: "Wells Fargo logo"
                },
                logo: {
                    url: "data:image/svg+xml,%3Csvg width='152' height='32' viewBox='0 0 152 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='152' height='32' fill='white'/%3E%3Cpath d='M41.7015 17.8635H42.8732V21.7537H33.0912V20.3364H34.4753V11.7758H32.2315L29.3835 21.7537H27.1197L24.8095 13.4853L22.4328 21.7537H20.1691L17.3012 11.7758H16V10.3585H21.3076V11.7758H19.7774L21.6827 18.6468L23.9597 10.3585H26.3032L28.63 18.6601L30.5021 11.7758H28.9055V10.3585H42.7072V14.0529H41.5355L41.4227 13.6147C41.0642 12.2472 40.6891 11.7758 39.6004 11.7758H36.8984V15.2113H40.1713C40.3007 15.4868 40.3505 15.6827 40.3505 15.9914C40.3505 16.3167 40.3007 16.5291 40.1713 16.8046H36.8984V20.3364H39.7132C40.7721 20.3364 41.2434 19.8816 41.5687 18.4311L41.6982 17.8601L41.7015 17.8635ZM51.9881 18.4344C51.6628 19.8816 51.208 20.3397 50.1326 20.3397H47.8688V11.7758H49.4156V10.3585H44.0615V11.7758H45.4457V20.3397H44.0615V21.757H53.2925V17.8668H52.1208L51.9914 18.4377L51.9881 18.4344ZM62.2414 18.4344C61.9161 19.8816 61.4614 20.3397 60.3859 20.3397H58.1222V11.7758H59.669V10.3585H54.3149V11.7758H55.699V20.3397H54.3149V21.757H63.5459V17.8668H62.3742L62.2447 18.4377L62.2414 18.4344ZM70.8185 15.0819L68.7506 14.6105C67.5457 14.335 67.0412 13.8604 67.0412 13.0637C67.0412 12.1044 67.8046 11.5003 69.3049 11.5003C70.8053 11.5003 71.6816 12.0381 72.0235 13.306L72.1695 13.8604H73.3412V11.0423C72.0235 10.3751 70.6227 10.0332 69.2054 10.0332C66.4204 10.0332 64.6313 11.3676 64.6313 13.5152C64.6313 15.1748 65.6736 16.3963 67.6751 16.8345L69.7431 17.2892C71.0609 17.5813 71.5488 18.1025 71.5488 18.9655C71.5488 20.0243 70.7522 20.6085 69.1556 20.6085C67.3499 20.6085 66.4204 19.8916 66.0122 18.524L65.7997 17.8236H64.628V21.0135C66.1084 21.7471 67.5258 22.0724 69.4311 22.0724C72.1662 22.0724 73.9553 20.7048 73.9553 18.5738C73.9553 16.7847 72.8632 15.5466 70.8119 15.0752L70.8185 15.0819ZM86.509 11.7758C87.601 11.7758 87.9728 12.2472 88.3313 13.6147L88.4441 14.0529H89.6158V10.3585H79.8006V11.7758H81.1848V20.3397H79.8006V21.757H85.2377V20.3397H83.6112V17.017H86.9637C87.0932 16.7415 87.143 16.5291 87.143 16.2038C87.143 15.8785 87.0932 15.6993 86.9637 15.4238H83.6112V11.7758H86.509ZM111.314 20.4691C111.41 20.6484 111.46 20.8608 111.46 21.1363C111.46 21.4118 111.41 21.6243 111.314 21.8035C110.956 21.8533 110.501 21.8832 110.046 21.8832C108.466 21.8832 107.703 21.2326 107.524 19.719L107.457 19.148C107.261 17.505 106.724 16.8677 104.935 16.8677H104.038V20.3364H105.585V21.7537H95.3483V20.3364H96.6827L95.9325 18.3016H91.7004L90.9502 20.3364H92.3178V21.7537H88.0027V20.3364H89.1412L93.131 10.3585H95.2952L99.3647 20.3364H101.609V11.7758H100.224V10.3585H106.767C109.094 10.3585 110.607 11.5136 110.607 13.3691C110.607 15.2246 109.094 16.1839 107.63 16.2503V16.3001C109.11 16.4129 109.714 17.2428 109.86 18.5306L109.927 19.1314C110.023 20.0741 110.219 20.499 110.969 20.499C111.098 20.499 111.215 20.4824 111.311 20.4658L111.314 20.4691ZM95.4114 16.9208L93.8148 12.6057L92.2182 16.9208H95.4081H95.4114ZM108.158 13.6015C108.158 12.4131 107.424 11.7792 105.96 11.7792H104.038V15.4404H105.96C107.407 15.4404 108.158 14.7732 108.158 13.6015ZM117.88 16.5656C117.88 16.8909 117.93 17.1033 118.059 17.3622H119.998V20.2434C119.364 20.5023 118.726 20.6185 118.076 20.6185C115.732 20.6185 114.511 18.9422 114.511 16.0445C114.511 13.1467 115.732 11.4705 117.946 11.4705C119.427 11.4705 120.29 12.204 120.794 13.472L120.973 13.9268H122.145V11.0091C120.681 10.3087 119.36 10 117.83 10C114.249 10 111.839 12.3932 111.839 16.0544C111.839 19.7156 114.182 22.079 117.83 22.079C119.281 22.079 120.778 21.6707 122.387 20.8741V15.7955H118.056C117.926 16.0544 117.877 16.2503 117.877 16.5623L117.88 16.5656ZM136 16.0445C136 19.5928 133.477 22.0823 129.946 22.0823C126.414 22.0823 123.891 19.5928 123.891 16.0445C123.891 12.4961 126.447 10.0066 129.946 10.0066C133.444 10.0066 136 12.5127 136 16.0445ZM133.331 16.0445C133.331 13.1633 132.143 11.4871 129.946 11.4871C127.748 11.4871 126.56 13.1633 126.56 16.0445C126.56 18.9256 127.732 20.6019 129.946 20.6019C132.16 20.6019 133.331 18.9422 133.331 16.0445Z' fill='%23D71E28'/%3E%3C/svg%3E%0A",
                    altText: "Wells Fargo logo"
                },
                colors: {
                    background: "#ffffff",
                    text: "var(--apollo-color-neutral-800)",
                    highlight: "#3B3331",
                    separator: "var(--apollo-color-neutral-200)"
                }
            };
        default:
            return undefined;
    }
}

function _class_call_check$2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties$2(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class$2(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$2(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$2(Constructor, staticProps);
    return Constructor;
}
function _define_property$6(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var LogTracker = /*#__PURE__*/ function() {
    function LogTracker(title, options) {
        _class_call_check$2(this, LogTracker);
        _define_property$6(this, "title", void 0);
        _define_property$6(this, "message", void 0);
        _define_property$6(this, "registry", void 0);
        _define_property$6(this, "key", void 0);
        _define_property$6(this, "value", void 0);
        this.title = title;
        this.message = "keys missing";
        this.registry = [];
        this.key = "i18n";
        this.value = "en";
        if (options) {
            this.key = options.key;
            this.value = options.value;
            this.message = options.message || "";
        }
    }
    _create_class$2(LogTracker, [
        {
            key: "findEntryBy",
            value: function findEntryBy(key) {
                var _this = this;
                return this.registry.reduce(function(result, it) {
                    return result || it[_this.key] === key ? it : null;
                }, null);
            }
        },
        {
            key: "track",
            value: function track(key, value) {
                if (!this.findEntryBy(key)) {
                    var _obj;
                    this.registry.push((_obj = {}, _define_property$6(_obj, this.key, key), _define_property$6(_obj, this.value, value), _obj));
                }
            }
        },
        {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            key: "report",
            value: function report(passThru) {
                if (this.registry.length) {
                    var msg = "".concat(this.title, " ").concat(this.message, ":");
                    console.warn(msg, this.registry);
                }
                return passThru;
            }
        }
    ]);
    return LogTracker;
}();

function _assert_this_initialized$1(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties$1(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class$1(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$1(Constructor, staticProps);
    return Constructor;
}
function _define_property$5(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of$1(o) {
    _get_prototype_of$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of$1(o);
}
function _inherits$1(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of$1(subClass, superClass);
}
function _object_spread$5(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$5(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$4(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$4(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$4(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return$1(self, call) {
    if (call && (_type_of$3(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized$1(self);
}
function _set_prototype_of$1(o, p) {
    _set_prototype_of$1 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of$1(o, p);
}
function _type_of$3(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super$1(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct$1();
    return function _createSuperInternal() {
        var Super = _get_prototype_of$1(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of$1(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return$1(this, result);
    };
}
var PermissionTracker = /*#__PURE__*/ function(LogTracker) {
    _inherits$1(PermissionTracker, LogTracker);
    var _super = _create_super$1(PermissionTracker);
    function PermissionTracker(context) {
        _class_call_check$1(this, PermissionTracker);
        return _super.call(this, "Permission Guards for ".concat(context, " navigation"), {
            key: "menu",
            value: "blocked by"
        });
    }
    _create_class$1(PermissionTracker, [
        {
            key: "track",
            value: function track(key, value, url) {
                if (!this.findEntryBy(key)) {
                    var _obj;
                    var entry = (_obj = {}, _define_property$5(_obj, this.key, key), _define_property$5(_obj, this.value, value), _obj);
                    if (url) entry.url = url;
                    this.registry.push(entry);
                }
            }
        }
    ]);
    return PermissionTracker;
}(LogTracker);
// ***********************************************************************
// Internal Tracking utils
// ***********************************************************************
var blockedGuards = {};
var trackerFor = function(which) {
    if (!blockedGuards[which]) {
        blockedGuards[which] = new PermissionTracker(which);
    }
    return blockedGuards[which];
};
// ***********************************************************************
// Guard Lookups
// ***********************************************************************
/**
 * Update node visibility based on parent and child guard permissions
 * NOTE: this will also log any items with blocked (visible = false) access.
 */ var checkPermssionsFor = function(context) {
    var tracker = trackerFor(context);
    var checkPermissionFn = function(node, guards) {
        var isVisible = guards.reduce(function(result, g) {
            var numChildren = Object.keys(g.children || {}).length;
            var rootAuthorized = g.permissions && g.settings && g.featureFlags;
            var childNotAuthorized = !g.isAuthorized && rootAuthorized && numChildren;
            var url = node.href || node.routerLink || node.url || "";
            var append = function(source, extra) {
                return source ? "".concat(source, ", ").concat(extra) : extra;
            };
            var blockers = "";
            if (!g.permissions) blockers = append(blockers, "[permissions]");
            if (!g.settings) blockers = append(blockers, "[settings]");
            if (!g.featureFlags) blockers = append(blockers, "[featureFlags]");
            if (childNotAuthorized) blockers = append(blockers, "[no children authorized]");
            if (blockers) tracker.track(g.name, blockers, url);
            // All guards must be authorized, and - for each guard -
            // all permissions, settings, and featureFlags must be authorized
            return result && g.isAuthorized;
        }, true);
        node.visible = isVisible;
    };
    return [
        checkPermissionFn,
        tracker.report.bind(tracker)
    ];
};
// **********************************************************************
// Public Utils
// **********************************************************************
/**
 * Make are GuardItem instance; which may contain optional children
 * Parent permissions will also check for ANY child permissions.
 *
 * @param name
 * @param permissionsState  list of user permissions
 * @param settingsState     list of organization settings
 * @param featureFlagsState list of featureFlags
 */ var makeGuard = function(name) {
    var permissionsState = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], settingsState = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], featureFlagsState = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
    var evaluate = function(targets) {
        return !!targets.reduce(function(result, p) {
            return result && !!p;
        }, true);
    };
    var permissions = evaluate(permissionsState);
    var settings = evaluate(settingsState);
    var featureFlags = evaluate(featureFlagsState);
    var isAuthorized = permissions && settings && featureFlags;
    var guard = {
        name: toCamelCase$1(name),
        permissions: permissions,
        settings: settings,
        featureFlags: featureFlags,
        isAuthorized: isAuthorized,
        children: {},
        registry: {},
        /**
     * Child guard accessor (by ID)
     */ child: function(id) {
            var source = guard.registry[toCamelCase$1(id)];
            if (!source) throw new Error("Uknown child guard ".concat(id, " in ").concat(guard.name));
            return source;
        },
        /**
     * Child guard registrations
     */ addChildren: function(items) {
            // Track all children (if any)
            var registry = (items || []).reduce(function(results, it) {
                var fullName = "".concat(guard.name, " > ").concat(toCamelCase$1(it.name));
                return _object_spread_props$4(_object_spread$5({}, results), _define_property$5({}, it.name, _object_spread_props$4(_object_spread$5({}, it), {
                    name: fullName
                })));
            }, {});
            // Do ANY registered children authorize; this allows a parent to authorize ANY child
            var anyChildAuthorized = Object.keys(registry).reduce(function(authorized, key) {
                return authorized || registry[key].isAuthorized;
            }, false);
            // Update fields
            guard.registry = registry;
            guard.isAuthorized = permissions && settings && featureFlags && anyChildAuthorized;
            return guard;
        }
    };
    return guard;
};
var toCamelCase$1 = function(source) {
    return source.replace(/^\w/, function(c) {
        return c.toUpperCase();
    });
};

/**
 * Build collection of PermissionsGuards for Admin Navigation
 */ var Permissions_forLxpAdmin = function(options) {
    var authUser = options.authUser, orgInfo = options.orgInfo, featureFlags = options.featureFlags;
    var permissions = orgInfo.permissions;
    var settings = orgInfo.settings;
    var skillsClient = function() {
        return settings.skillInventoryClient || settings.skillAnalyticsClient || authUser.isSkillAnalyticsClient || authUser.isSkillInventoryClient;
    };
    var bulkUpload = function() {
        return {
            permissions: (authUser === null || authUser === void 0 ? void 0 : authUser.canBulkUpload) && (permissions.uploadCompletions || permissions.uploadContent || permissions.uploadGroups || permissions.uploadOpportunities || permissions.uploadRequiredLearning || permissions.uploadUserUpdates || permissions.uploadClientUser || permissions.uploadRoles || permissions.uploadSkills),
            settings: !settings.disableBulkUpload
        };
    };
    var insights = makeGuard("insights", [
        permissions.viewReports
    ]).addChildren([
        makeGuard("learning"),
        makeGuard("skills", [
            permissions.viewReports
        ], [
            !settings.disableRatingsInsights
        ]),
        makeGuard("skillTrends", [
            permissions.viewReports
        ], [
            !settings.disableRatingsInsights
        ])
    ]);
    var people = makeGuard("people").addChildren([
        makeGuard("users", [
            permissions.viewMembers
        ], [], []),
        makeGuard("groups", [
            permissions.manageGroups || permissions.createAdministrativeGroups
        ], [
            !skillsClient()
        ]),
        makeGuard("segments", [
            permissions.manageSegments
        ], [], [
            featureFlags.orgManagement.segmentsUI
        ]),
        makeGuard("manageAttributes", [
            permissions.manageAttributes
        ], [], []),
        makeGuard("permissions", [
            permissions.editPermissions
        ], [], [])
    ]);
    var catalog = makeGuard("catalog").addChildren([
        makeGuard("content", [
            permissions.manageContent
        ], [], []),
        makeGuard("academies", [
            authUser.acmCanViewAcademyAdmin
        ], [], []),
        makeGuard("pathways", [
            permissions.managePathways
        ], [
            !skillsClient()
        ], []),
        makeGuard("plans", [
            permissions.manageTargets
        ], [
            settings.enableCareerPathing
        ], []),
        makeGuard("skill-dev", [], [
            !settings.enableCareerPathing,
            settings.supportTargets
        ])
    ]);
    var skills = makeGuard("skills", [
        permissions.manageSkills
    ], [
        settings.useInternalJobSkills
    ]).addChildren([
        makeGuard("dashboard", [], [
            settings.enableSkillsPlatform
        ], [
            featureFlags.degreedSkillsOctober2024
        ]),
        makeGuard("inventory", [], [
            settings.enableSkillsPlatform
        ], [
            featureFlags.degreedSkillsOctober2024
        ]),
        makeGuard("scales", [
            permissions.manageSkillsPlatform
        ], [
            settings.enableSkillsPlatform
        ], [
            featureFlags.degreedSkillsOctober2024
        ]),
        makeGuard("org-skills", [], [], [
            !featureFlags.degreedSkillsOctober2024
        ]),
        makeGuard("roles", [], [], []),
        makeGuard("skill-standards", [], [
            settings.enableSkillStandards
        ]),
        makeGuard("publish", [], [
            settings.enableSkillsPlatform
        ], [
            featureFlags.degreedSkillsOctober2024
        ]),
        makeGuard("settings", [], [], [])
    ]);
    var marketplace = makeGuard("content Marketplace", [], [
        settings.enableContentMarketplace
    ], []);
    var automations = makeGuard("automations", [
        permissions.manageBusinessRules
    ], [], []);
    var reporting = makeGuard("reporting", [
        authUser.canViewReporting
    ], [
        settings.enableReportingInApp,
        !skillsClient()
    ]).addChildren([
        makeGuard("reports", [
            authUser.canViewReporting
        ], [
            settings.enableReportingInApp,
            !skillsClient()
        ]),
        makeGuard("presets", [
            authUser.canViewReporting
        ], [
            settings.enableReportingInApp
        ]),
        makeGuard("categories", [
            authUser.canViewReporting
        ], [
            settings.enableReportingInApp
        ]),
        makeGuard("ftp", [
            permissions.manageReportingFTPScheduler
        ]),
        makeGuard("configurations", [
            permissions.manageReportingTransmitterConfigurations,
            permissions.manageReportingInApp
        ]),
        makeGuard("segments", [
            permissions.manageSegments,
            permissions.manageReportingInApp
        ]),
        makeGuard("analytics", [
            authUser.canManageOrganization
        ], [
            settings.enableAdvancedSkillAnalytics
        ], [
            featureFlags.insights.insightsSkillAnalytics
        ])
    ]);
    var integrations = makeGuard("integrations").addChildren([
        makeGuard("connected", [
            permissions.manageIntegrations
        ]),
        makeGuard("directory", [
            permissions.manageIntegrations
        ]),
        makeGuard("api-keys", [
            permissions.manageOrgApiKeys
        ]),
        makeGuard("file-upload", [
            bulkUpload().permissions
        ], [
            bulkUpload().settings,
            !settings.isClientProvider,
            !skillsClient()
        ]),
        makeGuard("file-log", [
            bulkUpload().permissions
        ], [
            bulkUpload().settings,
            !settings.isClientProvider,
            !skillsClient()
        ]),
        makeGuard("webhooks", [
            authUser.canManageOrganization
        ], [], [
            featureFlags.orgManagement.showWebhooksAdmin
        ])
    ]);
    var settingsGuard = makeGuard("settings", [
        permissions.editSettings || permissions.editPermissions
    ], [
        !skillsClient()
    ]).addChildren([
        makeGuard("branding", [
            permissions.editSettings
        ], [
            !settings.hideMasterOrgSettings
        ]),
        makeGuard("home", [], [
            !settings.disableHomeAdminSettings,
            permissions.editSettings
        ], [
            featureFlags.personalizedLearning
        ]),
        makeGuard("help-menu", [
            permissions.editSettings
        ]),
        makeGuard("communication", [
            permissions.editCommunications
        ], [
            !settings.isClientProvider
        ]),
        makeGuard("faq", [
            permissions.editSettings
        ], [
            !settings.isClientProvider
        ]),
        makeGuard("messaging", [
            permissions.editSettings
        ], [
            !settings.disablePopupMessages
        ]),
        makeGuard("security", [
            permissions.editSettings
        ], [], [
            featureFlags.sessionManagement
        ])
    ]);
    var extendedEnterprise = makeGuard("extended Enterprise", [
        authUser === null || authUser === void 0 ? void 0 : authUser.hasChannel
    ]);
    // Return custom collection of permissions guards...
    // use permissions checks on Apollo "Admin" navigation menus
    return {
        insights: insights,
        people: people,
        catalog: catalog,
        skills: skills,
        marketplace: marketplace,
        automations: automations,
        reporting: reporting,
        integrations: integrations,
        settings: settingsGuard,
        extendedEnterprise: extendedEnterprise
    };
};
/**
 * For ACM Learner, build collection of PermissionsGuards
 */ var Permissions_forAcmLearner = function(acm) {
    var _acm_academiesCount, _acm_user, _acm_user1;
    var canApprovePrograms = function() {
        return acm.isApprover && !!programIncentivesAvailableToUsersWithManagerApprovalCount || !!academiesWithCurrentUserAsAssignedApprover;
    };
    var canShowPermissions = function() {
        var _acm_customProgramPermissions, _acm_academyPermissions;
        return !!(((_acm_customProgramPermissions = acm.customProgramPermissions) === null || _acm_customProgramPermissions === void 0 ? void 0 : _acm_customProgramPermissions.length) || ((_acm_academyPermissions = acm.academyPermissions) === null || _acm_academyPermissions === void 0 ? void 0 : _acm_academyPermissions.length) && acm.isFeatureFlagOn.Academies);
    };
    var _ref = acm.incentivesCount || {}, programIncentivesAvailableToUsersWithManagerApprovalCount = _ref.programIncentivesAvailableToUsersWithManagerApprovalCount, academiesWithCurrentUserAsAssignedApprover = _ref.academiesWithCurrentUserAsAssignedApprover, resourcesAvailableToUsersWithManagerApprovalCount = _ref.resourcesAvailableToUsersWithManagerApprovalCount;
    var home = makeGuard("home");
    var marketplace = makeGuard("marketplace", [
        acm.incentivesCountIsSuccess,
        acm.showPrograms.any
    ]);
    var academies = makeGuard("academies", [
        acm.isAcademiesOn
    ], [
        acm.academiesCountIsSuccess,
        !!((_acm_academiesCount = acm.academiesCount) === null || _acm_academiesCount === void 0 ? void 0 : _acm_academiesCount.publishedAcademiesAvailableToUserCount)
    ]);
    var teamInsights = makeGuard("teamInsights", [
        (_acm_user = acm.user) === null || _acm_user === void 0 ? void 0 : _acm_user.isManager
    ], [], [
        acm.isFeatureFlagOn.TeamInsights
    ]);
    var approvals = makeGuard("approvals").addChildren([
        makeGuard("programs", [], [
            canApprovePrograms()
        ]),
        makeGuard("resources", [], [
            acm.isApprover,
            !!resourcesAvailableToUsersWithManagerApprovalCount
        ])
    ]);
    var permissions = makeGuard("permissions", [
        canShowPermissions()
    ]);
    var account = makeGuard("account").addChildren([
        makeGuard("settings"),
        makeGuard("logout")
    ]);
    var showAdminView = makeGuard("showAdminView", [
        (_acm_user1 = acm.user) === null || _acm_user1 === void 0 ? void 0 : _acm_user1.isAdmin
    ]);
    return {
        home: home,
        marketplace: marketplace,
        academies: academies,
        teamInsights: teamInsights,
        approvals: approvals,
        permissions: permissions,
        account: account,
        showAdminView: showAdminView
    };
};
/**
 * For ACM Admin, build collection of PermissionsGuards
 */ var Permissions_forAcmAdmin = function(acm) {
    var _acm_learningBudgetInfo_, _acm_learningBudgetInfo;
    var _ref = acm.incentivesCount || {}, programIncentivesAvailableToUsersWithManagerApprovalCount = _ref.programIncentivesAvailableToUsersWithManagerApprovalCount, academiesWithCurrentUserAsAssignedApprover = _ref.academiesWithCurrentUserAsAssignedApprover, resourcesAvailableToUsersWithManagerApprovalCount = _ref.resourcesAvailableToUsersWithManagerApprovalCount;
    var isVirtualCard = ((_acm_learningBudgetInfo = acm.learningBudgetInfo) === null || _acm_learningBudgetInfo === void 0 ? void 0 : (_acm_learningBudgetInfo_ = _acm_learningBudgetInfo[0]) === null || _acm_learningBudgetInfo_ === void 0 ? void 0 : _acm_learningBudgetInfo_.incentiveType) === "Prepayment";
    var canApprovePrograms = function() {
        return acm.isApprover && !!programIncentivesAvailableToUsersWithManagerApprovalCount || !!academiesWithCurrentUserAsAssignedApprover;
    };
    var learning = makeGuard("learning").addChildren([
        makeGuard("marketplace"),
        makeGuard("academies", [], [], [
            acm.isFeatureFlagOn.Academies
        ])
    ]);
    var people = makeGuard("people");
    var licenses = makeGuard("licenses", [], [], [
        acm.isFeatureFlagOn.Licenses
    ]);
    var incentives = makeGuard("incentives", [], [], [
        acm.isFeatureFlagOn.Incentives
    ]);
    var approvals = makeGuard("approvals").addChildren([
        makeGuard("programs", [], [
            canApprovePrograms()
        ]),
        makeGuard("resources", [], [
            acm.isApprover,
            !!resourcesAvailableToUsersWithManagerApprovalCount
        ])
    ]);
    var reports = makeGuard("reports");
    var qa = makeGuard("qa", [
        !acm.isProduction,
        !acm.isBeta
    ]);
    var settingsAdmin = makeGuard("admin-settings", [
        isVirtualCard
    ], [], [
        !acm.isFeatureFlagOn.HideAdminSettings
    ]);
    var settignsDeveloper = makeGuard("developer-admin", [
        !acm.isProduction,
        !acm.isBeta
    ]);
    return {
        learning: learning,
        people: people,
        licenses: licenses,
        incentives: incentives,
        approvals: approvals,
        reports: reports,
        qa: qa,
        settingsAdmin: settingsAdmin,
        settignsDeveloper: settignsDeveloper
    };
};

function _array_like_to_array$4(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$4(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit$4(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$4() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array$4(arr, i) {
    return _array_with_holes$4(arr) || _iterable_to_array_limit$4(arr, i) || _unsupported_iterable_to_array$4(arr, i) || _non_iterable_rest$4();
}
function _unsupported_iterable_to_array$4(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$4(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$4(o, minLen);
}
var _lostKeys = new LogTracker("i18n warning");
function updatei18n(configuration, translate) {
    var MAPPINGS = {
        i18n: "text",
        headerTitleI18n: "headerTitle",
        buttonI18n: "buttonText",
        titleI18n: "titleText"
    };
    var i18n = i18nWithLog(translate);
    var visitor = function(node, key) {
        // For each node, check if it has an translation field
        switch(key){
            case "i18n":
            case "headerTitleI18n":
            case "buttonI18n":
            case "titleI18n":
                {
                    var field = MAPPINGS[key];
                    node[field] = i18n(node[key], node[field]);
                    break;
                }
        }
    };
    configuration = traverse(configuration, visitor);
    // Warn if any i18n keys are missing from the localization bundle!
    _lostKeys.report();
    return configuration;
}
/**
 * For all navigation nodes, set `visible` to true unless explicitly set to false
 */ function updateVisibility(configuration) {
    var isAspect = function(configuration) {
        return !configuration["admin"] && !configuration["learner"];
    };
    var visitNavigation = function(node) {
        // Force explicity visibility settings
        if (node.visible !== false) node.visible = true;
    };
    if (isAspect(configuration)) {
        traverse(configuration.navigation, visitNavigation);
        traverse(configuration.features, visitNavigation);
    } else {
        traverse(configuration.admin, visitNavigation);
        traverse(configuration.learner, visitNavigation);
    }
    return configuration;
}
/**
 * Apply feature flags, org permissions, and user settings.
 * Note: This configuration has three aspects: ACM Admin, ACM Learner, and LXP Admin
 */ var updateWithFilters = function(configuration, param) {
    var acm = param.acm, lxp = param.lxp;
    if (!acm) return updateLxpAdminNavigation(configuration, lxp); // Aspect comes from lxp.json, acm-lxp.json or skills-platform.json
    configuration = updateAcmLearnerNavigation(configuration, acm); // Aspect comes from acm.json
    configuration = updateAcmAdminNavigation(configuration, acm); // Aspect comes from acm.json
    return configuration;
};
/**
 * Replace all `<user>` tokens with current user's vanityUrl from their viewerProfile
 * * Replace all `<orgId>` tokens with current user's defaultOrgId
 * @param configuration LayoutConfiguration
 * @param authUser AuthUser
 */ function updateUser(configuration, user) {
    var hasProfile = !!(user === null || user === void 0 ? void 0 : user.viewerProfile);
    var userName = (user === null || user === void 0 ? void 0 : user.viewerProfile.vanityUrl) || "";
    var visitLinks = function(node, key) {
        switch(key){
            case "href":
            case "routerLink":
                {
                    var text = node[key];
                    if ((text === null || text === void 0 ? void 0 : text.includes("<user>")) && hasProfile) node[key] = text.replace("<user>", userName);
                    if (text === null || text === void 0 ? void 0 : text.includes("<orgId>")) node[key] = text.replace("<orgId>", user === null || user === void 0 ? void 0 : user.defaultOrgId.toString());
                    break;
                }
        }
    };
    // @TODO - need to update the profile image
    //
    // const visitDGATs = (node: LayoutNode) => {
    //   switch (node.dgat) {
    //     case 'global.navigation.learner.sidebar.profile': { // Update Profile image
    //       let profileImage = user?.viewerProfile.picture;
    //       if (hasProfile && profileImage) {
    //         if (profileImage.startsWith('~')) {
    //           profileImage = environment.getBlobUrl(profileImage);
    //           node.image = profileImage;
    //         }
    //       }
    //       break;
    //     }
    //   }
    // };
    configuration = traverse(configuration, visitLinks);
    // configuration = traverse(configuration, visitDGATs);
    return configuration;
}
function updateNavigationBranding(config, branding) {
    if (branding) {
        config.admin = config.admin ? navigationToAspect(branding, config.admin) : undefined;
        config.learner = config.learner ? navigationToAspect(branding, config.learner) : undefined;
    }
    return config;
}
// *************************************************
// Private Utilities
// *************************************************
/**
 * Update the Degreed "Admin" view (instead of the Learner view) items 
 * 
 * NOTE: This is for the React SKaaS application which does NOT have a Learner view
 *       Some items require admin access based on feature flags and user permissions
 */ function updateLxpAdminNavigation(configuration, lxp) {
    var guards = Permissions_forLxpAdmin(lxp);
    var _checkPermssionsFor = _sliced_to_array$4(checkPermssionsFor("LxP Admin"), 2), checkPermissions = _checkPermssionsFor[0], showPermissionLog = _checkPermssionsFor[1];
    var visitDGATs = function(node, key) {
        if (key === "dgat") {
            switch(node.dgat){
                // Insights (menu):
                case "global.navigation.admin.sidebar.dashboard":
                    checkPermissions(node, [
                        guards.insights
                    ]);
                    break;
                case "global.navigation.admin.sidebar.dashboard.learning":
                    checkPermissions(node, [
                        guards.insights.child("learning")
                    ]);
                    break;
                case "global.navigation.admin.sidebar.dashboard.skills":
                    checkPermissions(node, [
                        guards.insights.child("skills")
                    ]);
                    break;
                case "global.navigation.admin.sidebar.dashboard.skill-trends":
                    checkPermissions(node, [
                        guards.insights.child("skillTrends")
                    ]);
                    break;
                // People (menu):
                case "global.navigation.admin.sidebar.people":
                    checkPermissions(node, [
                        guards.people
                    ]);
                    break;
                case "global.navigation.admin.sidebar.people.users":
                    checkPermissions(node, [
                        guards.people.child("users")
                    ]);
                    break;
                case "global.navigation.admin.sidebar.people.groups":
                    checkPermissions(node, [
                        guards.people.child("groups")
                    ]);
                    break;
                case "global.navigation.admin.sidebar.people.segments":
                    checkPermissions(node, [
                        guards.people.child("segments")
                    ]);
                    break;
                case "global.navigation.admin.sidebar.people.user-attributes":
                    checkPermissions(node, [
                        guards.people.child("manageAttributes")
                    ]);
                    break;
                case "global.navigation.admin.sidebar.people.permissions":
                    checkPermissions(node, [
                        guards.people.child("permissions")
                    ]);
                    break;
                // Catalog (menu):
                case "global.navigation.admin.sidebar.catalog":
                    checkPermissions(node, [
                        guards.catalog
                    ]);
                    break;
                case "global.navigation.admin.sidebar.catalog.content":
                    checkPermissions(node, [
                        guards.catalog.child("content")
                    ]);
                    break;
                case "global.navigation.admin.sidebar.catalog.academies":
                    checkPermissions(node, [
                        guards.catalog.child("academies")
                    ]);
                    break;
                case "global.navigation.admin.sidebar.catalog.pathways":
                    checkPermissions(node, [
                        guards.catalog.child("pathways")
                    ]);
                    break;
                case "global.navigation.admin.sidebar.catalog.plans":
                    checkPermissions(node, [
                        guards.catalog.child("plans")
                    ]);
                    break;
                case "global.navigation.admin.sidebar.catalog.skill-dev":
                    checkPermissions(node, [
                        guards.catalog.child("skill-dev")
                    ]);
                    break;
                // Skills (menu):
                case "global.navigation.admin.sidebar.skills":
                    checkPermissions(node, [
                        guards.skills
                    ]);
                    break;
                case "global.navigation.admin.sidebar.skills.dashboard":
                    checkPermissions(node, [
                        guards.skills.child("dashboard")
                    ]);
                    break;
                case "global.navigation.admin.sidebar.skills.inventory":
                    checkPermissions(node, [
                        guards.skills.child("inventory")
                    ]);
                    break;
                case "global.navigation.admin.sidebar.skills.scales":
                    checkPermissions(node, [
                        guards.skills.child("scales")
                    ]);
                    break;
                case "global.navigation.admin.sidebar.skills.skill-list":
                    checkPermissions(node, [
                        guards.skills.child("org-skills")
                    ]);
                    break;
                case "global.navigation.admin.sidebar.skills.roles":
                    checkPermissions(node, [
                        guards.skills.child("roles")
                    ]);
                    break;
                case "global.navigation.admin.sidebar.skills.skill-standards":
                    checkPermissions(node, [
                        guards.skills.child("skill-standards")
                    ]);
                    break;
                case "global.navigation.admin.sidebar.skills.publish":
                    checkPermissions(node, [
                        guards.skills.child("publish")
                    ]);
                    break;
                case "global.navigation.admin.sidebar.skills.settings":
                    checkPermissions(node, [
                        guards.skills.child("settings")
                    ]);
                    break;
                // Content MarketPlace (menu):
                case "global.navigation.admin.sidebar.content-marketplace":
                    checkPermissions(node, [
                        guards.marketplace
                    ]);
                    break;
                // Automation (menu):
                case "global.navigation.admin.sidebar.automations":
                    checkPermissions(node, [
                        guards.automations
                    ]);
                    break;
                // Reporting (menu):
                case "global.navigation.admin.sidebar.reporting":
                    checkPermissions(node, [
                        guards.reporting
                    ]);
                    break;
                case "global.navigation.admin.sidebar.reporting.reports":
                    checkPermissions(node, [
                        guards.reporting.child("reports")
                    ]);
                    break;
                case "global.navigation.admin.sidebar.reporting.presets":
                    checkPermissions(node, [
                        guards.reporting.child("presets")
                    ]);
                    break;
                case "global.navigation.admin.sidebar.reporting.categories":
                    checkPermissions(node, [
                        guards.reporting.child("categories")
                    ]);
                    break;
                case "global.navigation.admin.sidebar.reporting.ftp":
                    checkPermissions(node, [
                        guards.reporting.child("ftp")
                    ]);
                    break;
                case "global.navigation.admin.sidebar.reporting.configurations":
                    checkPermissions(node, [
                        guards.reporting.child("configurations")
                    ]);
                    break;
                case "global.navigation.admin.sidebar.reporting.segments":
                    checkPermissions(node, [
                        guards.reporting.child("segments")
                    ]);
                    break;
                case "global.navigation.admin.sidebar.reporting.advanced-analytics":
                    checkPermissions(node, [
                        guards.reporting.child("analytics")
                    ]);
                    break;
                // Integrations (menu):
                case "global.navigation.admin.sidebar.integrations":
                    checkPermissions(node, [
                        guards.integrations
                    ]);
                    break;
                case "global.navigation.admin.sidebar.integrations.connected":
                    checkPermissions(node, [
                        guards.integrations.child("connected")
                    ]);
                    break;
                case "global.navigation.admin.sidebar.integrations.directory":
                    checkPermissions(node, [
                        guards.integrations.child("directory")
                    ]);
                    break;
                case "global.navigation.admin.sidebar.integrations.api-keys":
                    checkPermissions(node, [
                        guards.integrations.child("api-keys")
                    ]);
                    break;
                case "global.navigation.admin.sidebar.integrations.file-upload":
                    checkPermissions(node, [
                        guards.integrations.child("file-upload")
                    ]);
                    break;
                case "global.navigation.admin.sidebar.integrations.file-log":
                    checkPermissions(node, [
                        guards.integrations.child("file-log")
                    ]);
                    break;
                case "global.navigation.admin.sidebar.integrations.webhooks":
                    checkPermissions(node, [
                        guards.integrations.child("webhooks")
                    ]);
                    break;
                // Settings (menu):
                case "global.navigation.admin.sidebar.settings":
                    checkPermissions(node, [
                        guards.settings
                    ]);
                    break;
                case "global.navigation.admin.sidebar.settings.branding":
                    checkPermissions(node, [
                        guards.settings.child("branding")
                    ]);
                    break;
                case "global.navigation.admin.sidebar.settings.home":
                    checkPermissions(node, [
                        guards.settings.child("home")
                    ]);
                    break;
                case "global.navigation.admin.sidebar.settings.help-menu":
                    checkPermissions(node, [
                        guards.settings.child("help-menu")
                    ]);
                    break;
                case "global.navigation.admin.sidebar.settings.communication":
                    checkPermissions(node, [
                        guards.settings.child("communication")
                    ]);
                    break;
                case "global.navigation.admin.sidebar.settings.faq":
                    checkPermissions(node, [
                        guards.settings.child("faq")
                    ]);
                    break;
                case "global.navigation.admin.sidebar.settings.messaging":
                    checkPermissions(node, [
                        guards.settings.child("messaging")
                    ]);
                    break;
                case "global.navigation.admin.sidebar.settings.security":
                    checkPermissions(node, [
                        guards.settings.child("security")
                    ]);
                    break;
                // Extended Enterprise (menu):
                case "global.navigation.admin.sidebar.extended-enterprise":
                    checkPermissions(node, [
                        guards.extendedEnterprise
                    ]);
                    break;
            }
        }
    };
    return showPermissionLog(traverse(configuration, visitDGATs));
}
/**
 * Update the ACM "Learner" navigation items based on feature flags and user permissions
 */ function updateAcmLearnerNavigation(configuration, acm) {
    var guards = Permissions_forAcmLearner(acm);
    var _checkPermssionsFor = _sliced_to_array$4(checkPermssionsFor("ACM Learner"), 2), checkPermissions = _checkPermssionsFor[0], showPermissionLog = _checkPermssionsFor[1];
    var visitDGATs = function(node, key, parent) {
        if (key === "dgat") {
            switch(node.dgat){
                case "global.navigation.learner.sidebar.home":
                    checkPermissions(node, [
                        guards.home
                    ]);
                    break;
                case "global.navigation.learner.sidebar.marketplace":
                    checkPermissions(node, [
                        guards.marketplace
                    ]);
                    break;
                case "global.navigation.learner.sidebar.academies":
                    checkPermissions(node, [
                        guards.academies
                    ]);
                    break;
                case "global.navigation.learner.sidebar.team-insights":
                    checkPermissions(node, [
                        guards.teamInsights
                    ]);
                    break;
                case "global.navigation.learner.sidebar.approvals":
                    checkPermissions(node, [
                        guards.approvals
                    ]);
                    break;
                case "global.navigation.learner.sidebar.approvals.programs":
                    checkPermissions(node, [
                        guards.approvals.child("programs")
                    ]);
                    break;
                case "global.navigation.learner.sidebar.approvals.resources":
                    checkPermissions(node, [
                        guards.approvals.child("resources")
                    ]);
                    break;
                case "global.navigation.learner.sidebar.permissions":
                    checkPermissions(node, [
                        guards.permissions
                    ]);
                    break;
                case "global.navigation.learner.sidebar.account":
                    checkPermissions(node, [
                        guards.account
                    ]);
                    break;
                case "global.navigation.learner.sidebar.account.settings":
                    checkPermissions(node, [
                        guards.account.child("settings")
                    ]);
                    break;
                case "global.navigation.learner.sidebar.account.logout":
                    checkPermissions(node, [
                        guards.account.child("logout")
                    ]);
                    break;
                case "global.navigation.learner.features.show-admin-view":
                    checkPermissions(node, [
                        guards.showAdminView
                    ]);
                    break;
            }
        }
    };
    return showPermissionLog(traverse(configuration, visitDGATs));
}
/**
 * Update the ACM "Admin" view (instead of the Learner view) items requiring admin access based on feature flags and user permissions
 */ function updateAcmAdminNavigation(configuration, acm) {
    var guards = Permissions_forAcmAdmin(acm);
    var _checkPermssionsFor = _sliced_to_array$4(checkPermssionsFor("ACM Admin"), 2), checkPermissions = _checkPermssionsFor[0], showPermissionLog = _checkPermssionsFor[1];
    var visitDGATs = function(node, key, parent) {
        if (key === "dgat") {
            switch(node.dgat){
                case "global.navigation.admin.sidebar.learning":
                    checkPermissions(node, [
                        guards.learning
                    ]);
                    break;
                case "global.navigation.admin.sidebar.learning.marketplace":
                    checkPermissions(node, [
                        guards.learning.child("marketplace")
                    ]);
                    break;
                case "global.navigation.admin.sidebar.learning.academies":
                    checkPermissions(node, [
                        guards.learning.child("academies")
                    ]);
                    break;
                case "global.navigation.admin.sidebar.people":
                    checkPermissions(node, [
                        guards.people
                    ]);
                    break;
                case "global.navigation.admin.sidebar.licenses":
                    checkPermissions(node, [
                        guards.licenses
                    ]);
                    break;
                case "global.navigation.admin.sidebar.incentives":
                    checkPermissions(node, [
                        guards.incentives
                    ]);
                    break;
                case "global.navigation.admin.sidebar.approvals":
                    checkPermissions(node, [
                        guards.approvals
                    ]);
                    break;
                case "global.navigation.admin.sidebar.approvals.programs":
                    checkPermissions(node, [
                        guards.approvals.child("programs")
                    ]);
                    break;
                case "global.navigation.admin.sidebar.approvals.resources":
                    checkPermissions(node, [
                        guards.approvals.child("resources")
                    ]);
                    break;
                case "global.navigation.admin.sidebar.reports":
                    checkPermissions(node, [
                        guards.reports
                    ]);
                    break;
                case "global.navigation.admin.sidebar.admin-settings":
                    checkPermissions(node, [
                        guards.settingsAdmin
                    ]);
                    break;
                case "global.navigation.admin.sidebar.qa":
                    checkPermissions(node, [
                        guards.qa
                    ]);
                    break;
                case "global.navigation.admin.sidebar.developer-admin":
                    checkPermissions(node, [
                        guards.settignsDeveloper
                    ]);
                    break;
            }
        }
    };
    return showPermissionLog(traverse(configuration, visitDGATs));
}
/**
 * config = updateHelpMenu(config, organizationId, helpMenu)
 * Update the help menu items based on the organization's support info
 */ function updateHelpMenu(configuration, organizationId, supportInfo) {
    if (!organizationId) supportInfo = {
        phone: "800.311.7061"
    };
    var visitDGATs = function(node, key, parent) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var updateByKey = function(field, value) {
            var allowEmpty = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            var isVisible = value || allowEmpty;
            node.visible = isVisible;
            if (isVisible) node[field] = value || "";
        };
        if (key === "dgat") {
            switch(node.dgat){
                case "global.navigation.admin.sidebar.help.knowledge-center":
                case "global.navigation.learner.sidebar.help.knowledge-center":
                    updateByKey("href", supportInfo === null || supportInfo === void 0 ? void 0 : supportInfo.helpLink);
                    break;
                case "global.navigation.admin.sidebar.help.faq":
                case "global.navigation.learner.sidebar.help.faq":
                    updateByKey("href", supportInfo === null || supportInfo === void 0 ? void 0 : supportInfo.faq);
                    break;
                case "global.navigation.admin.sidebar.help.cookie-notice":
                case "global.navigation.learner.sidebar.help.cookie-notice":
                    node.visible = supportInfo === null || supportInfo === void 0 ? void 0 : supportInfo.showCookieLink;
                    break;
                case "global.navigation.admin.sidebar.help.custom-link":
                case "global.navigation.learner.sidebar.help.custom-link":
                    updateByKey("text", supportInfo === null || supportInfo === void 0 ? void 0 : supportInfo.customText);
                    updateByKey("href", supportInfo === null || supportInfo === void 0 ? void 0 : supportInfo.customLink);
                    break;
                case "global.navigation.admin.sidebar.help.support-phone":
                case "global.navigation.learner.sidebar.help.support-phone":
                    updateByKey("text", supportInfo === null || supportInfo === void 0 ? void 0 : supportInfo.phone);
                    updateByKey("href", (supportInfo === null || supportInfo === void 0 ? void 0 : supportInfo.phone) ? "tel:".concat(supportInfo.phone) : "");
                    break;
                case "global.navigation.admin.sidebar.help.support-email":
                case "global.navigation.learner.sidebar.help.support-email":
                    {
                        var hasEmail = (supportInfo === null || supportInfo === void 0 ? void 0 : supportInfo.email) && !(supportInfo === null || supportInfo === void 0 ? void 0 : supportInfo.email.includes("@degreed.com"));
                        updateByKey("text", hasEmail ? supportInfo.email : "");
                        updateByKey("href", hasEmail ? "mailto:".concat(supportInfo.email) : "");
                    }
                    break;
            }
        }
    };
    return traverse(configuration, visitDGATs);
}
/**
 * Translation util that logs missing translations
 * Keys can be comma-separated to try multiple keys until a valid translation is found
 * Note: Left-most key is the most recent... right-most key is the fallback
 */ var i18nWithLog = function(translate) {
    return function(key, fallback) {
        var allKeys = key.replace(/\s+/g, "").split(","); // This will remove all whitespace
        // Find "most recent" translation
        var value = "";
        var selectedKey = "";
        for(var i = 0; i < allKeys.length; i++){
            if (!value && allKeys[i]) {
                selectedKey = allKeys[i];
                value = translate(fallback, selectedKey) || "";
                // If ngx/translate returns the key, it means the translation is missing
                if (value === selectedKey) value = "";
            }
            if (!value) _lostKeys.track(selectedKey, fallback);
        }
        return value || fallback;
    };
};
// Depth-first node tree scanning
var traverse = function(node, visit, parent) {
    for(var key in node){
        if (typeof node[key] === "object") {
            visit(node, key, parent);
            traverse(node[key], visit, node);
        } else {
            visit(node, key, parent);
        }
    }
    return node;
};

function _instanceof$2(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _type_of$2(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function n$1(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    if ("production" !== process.env.NODE_ENV) {
        var _$i = Y$1[n], o = _$i ? "function" == typeof _$i ? _$i.apply(null, t) : _$i : "unknown error nr: " + n;
        throw Error("[Immer] " + o);
    }
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r$1(n) {
    return !!n && !!n[Q$1];
}
function t$1(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z$1;
    }(n) || Array.isArray(n) || !!n[L$1] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L$1]) || s$1(n) || v$1(n));
}
function i$1(n, r, t) {
    void 0 === t && (t = !1), 0 === o$1(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == (typeof e === "undefined" ? "undefined" : _type_of$2(e)) || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o$1(n) {
    var r = n[Q$1];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s$1(n) ? 2 : v$1(n) ? 3 : 0;
}
function u$1(n, r) {
    return 2 === o$1(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a$1(n, r) {
    return 2 === o$1(n) ? n.get(r) : n[r];
}
function f$1(n, r, t) {
    var e = o$1(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c$1(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s$1(n) {
    return X$1 && _instanceof$2(n, Map);
}
function v$1(n) {
    return q$1 && _instanceof$2(n, Set);
}
function p$1(n) {
    return n.o || n.t;
}
function l$1(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q$1];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var _$i = t[e], o = r[_$i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[_$i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[_$i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d$1(n, e) {
    return void 0 === e && (e = !1), y$1(n) || r$1(n) || !t$1(n) || (o$1(n) > 1 && (n.set = n.add = n.clear = n.delete = h$1), Object.freeze(n), e && i$1(n, function(n, r) {
        return d$1(r, !0);
    }, !0)), n;
}
function h$1() {
    n$1(2);
}
function y$1(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b$1(r) {
    var t = tn[r];
    return t || n$1(18, r), t;
}
function _$1() {
    return "production" === process.env.NODE_ENV || U$1 || n$1(0), U$1;
}
function j$1(n, r) {
    r && (b$1("Patches"), n.u = [], n.s = [], n.v = r);
}
function g$1(n) {
    O$1(n), n.p.forEach(S$1), n.p = null;
}
function O$1(n) {
    n === U$1 && (U$1 = n.l);
}
function w$1(n) {
    return U$1 = {
        p: [],
        l: U$1,
        h: n,
        m: !0,
        _: 0
    };
}
function S$1(n) {
    var r = n[Q$1];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P$1(r, e) {
    e._ = e.p.length;
    var _$i = e.p[0], o = void 0 !== r && r !== _$i;
    return e.h.O || b$1("ES5").S(e, r, o), o ? (_$i[Q$1].P && (g$1(e), n$1(4)), t$1(r) && (r = M$1(e, r), e.l || x$1(e, r)), e.u && b$1("Patches").M(_$i[Q$1].t, r, e.u, e.s)) : r = M$1(e, _$i, []), g$1(e), e.u && e.v(e.u, e.s), r !== H$1 ? r : void 0;
}
function M$1(n, r, t) {
    if (y$1(r)) return r;
    var e = r[Q$1];
    if (!e) return i$1(r, function(i, o) {
        return A$1(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x$1(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l$1(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i$1(u, function(r, i) {
            return A$1(n, e, o, r, i, t, a);
        }), x$1(n, o, !1), t && n.u && b$1("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A$1(e, i, o, a, c, s, v) {
    if ("production" !== process.env.NODE_ENV && c === o && n$1(5), r$1(c)) {
        var p = M$1(e, c, s && i && 3 !== i.i && !u$1(i.R, a) ? s.concat(a) : void 0);
        if (f$1(o, a, p), !r$1(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t$1(c) && !y$1(c)) {
        if (!e.h.D && e._ < 1) return;
        M$1(e, c), i && i.A.l || x$1(e, c);
    }
}
function x$1(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d$1(r, t);
}
function z$1(n, r) {
    var t = n[Q$1];
    return (t ? p$1(t) : n)[r];
}
function I$1(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k$1(n) {
    n.P || (n.P = !0, n.l && k$1(n.l));
}
function E$1(n) {
    n.o || (n.o = l$1(n.t));
}
function N$1(n, r, t) {
    var e = s$1(r) ? b$1("MapSet").F(r, t) : v$1(r) ? b$1("MapSet").T(r, t) : n.O ? function(n, r) {
        var _$t = Array.isArray(n), e = {
            i: _$t ? 1 : 0,
            A: r ? r.A : _$1(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, _$i = e, o = en;
        _$t && (_$i = [
            e
        ], o = on);
        var u = Proxy.revocable(_$i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b$1("ES5").J(r, t);
    return (t ? t.A : _$1()).p.push(e), e;
}
function R$1(e) {
    return r$1(e) || n$1(22, e), function n(r) {
        if (!t$1(r)) return r;
        var _$e, u = r[Q$1], c = o$1(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b$1("ES5").K(u))) return u.t;
            u.I = !0, _$e = D$1(r, c), u.I = !1;
        } else _$e = D$1(r, c);
        return i$1(_$e, function(r, t) {
            u && a$1(u.t, r) === t || f$1(_$e, r, n(t));
        }), 3 === c ? new Set(_$e) : _$e;
    }(e);
}
function D$1(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l$1(n);
}
var G$1, U$1, W$1 = "undefined" != typeof Symbol && "symbol" == _type_of$2(Symbol("x")), X$1 = "undefined" != typeof Map, q$1 = "undefined" != typeof Set, B$1 = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H$1 = W$1 ? Symbol.for("immer-nothing") : ((G$1 = {})["immer-nothing"] = !0, G$1), L$1 = W$1 ? Symbol.for("immer-draftable") : "__$immer_draftable", Q$1 = W$1 ? Symbol.for("immer-state") : "__$immer_state", Y$1 = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z$1 = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function nn(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function get(n, r) {
        if (r === Q$1) return n;
        var e = p$1(n);
        if (!u$1(e, r)) return function(n, r, t) {
            var e, _$i = I$1(r, t);
            return _$i ? "value" in _$i ? _$i.value : null === (e = _$i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var _$i = e[r];
        return n.I || !t$1(_$i) ? _$i : _$i === z$1(n.t, r) ? (E$1(n), n.o[r] = N$1(n.A.h, _$i, n)) : _$i;
    },
    has: function has(n, r) {
        return r in p$1(n);
    },
    ownKeys: function ownKeys(n) {
        return Reflect.ownKeys(p$1(n));
    },
    set: function set(n, r, t) {
        var e = I$1(p$1(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var _$i = z$1(p$1(n), r), o = null == _$i ? void 0 : _$i[Q$1];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c$1(t, _$i) && (void 0 !== t || u$1(n.t, r))) return !0;
            E$1(n), k$1(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function deleteProperty(n, r) {
        return void 0 !== z$1(n.t, r) || r in n.t ? (n.R[r] = !1, E$1(n), k$1(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(n, r) {
        var t = p$1(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function defineProperty() {
        n$1(11);
    },
    getPrototypeOf: function getPrototypeOf(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function setPrototypeOf() {
        n$1(12);
    }
}, on = {};
i$1(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return "production" !== process.env.NODE_ENV && isNaN(parseInt(t)) && n$1(13), on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return "production" !== process.env.NODE_ENV && "length" !== t && isNaN(parseInt(t)) && n$1(14), en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var _$e = this;
        this.O = B$1, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = _$e;
                return function(n) {
                    var _$r = this;
                    void 0 === n && (n = u);
                    for(var _$t = arguments.length, _$e = Array(_$t > 1 ? _$t - 1 : 0), _$o = 1; _$o < _$t; _$o++)_$e[_$o - 1] = arguments[_$o];
                    return a.produce(n, function(n) {
                        var _$t;
                        return (_$t = i).call.apply(_$t, [
                            _$r,
                            n
                        ].concat(_$e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n$1(6), void 0 !== o && "function" != typeof o && n$1(7), t$1(r)) {
                var c = w$1(_$e), s = N$1(_$e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g$1(c) : O$1(c);
                }
                return "undefined" != typeof Promise && _instanceof$2(f, Promise) ? f.then(function(n) {
                    return j$1(c, o), P$1(n, c);
                }, function(n) {
                    throw g$1(c), n;
                }) : (j$1(c, o), P$1(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H$1 && (f = void 0), _$e.D && d$1(f, !0), o) {
                    var p = [], l = [];
                    b$1("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n$1(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, _$i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)_$i[o - 1] = arguments[o];
                return _$e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(_$i));
                });
            };
            var t, _$i, o = _$e.produce(n, r, function(n, r) {
                t = n, _$i = r;
            });
            return "undefined" != typeof Promise && _instanceof$2(o, Promise) ? o.then(function(n) {
                return [
                    n,
                    t,
                    _$i
                ];
            }) : [
                o,
                t,
                _$i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var _$i = e.prototype;
    return _$i.createDraft = function(e) {
        t$1(e) || n$1(8), r$1(e) && (e = R$1(e));
        var _$i = w$1(this), o = N$1(this, e, void 0);
        return o[Q$1].C = !0, O$1(_$i), o;
    }, _$i.finishDraft = function(r, t) {
        var _$e = r && r[Q$1];
        "production" !== process.env.NODE_ENV && (_$e && _$e.C || n$1(9), _$e.I && n$1(10));
        var _$i = _$e.A;
        return j$1(_$i, t), P$1(void 0, _$i);
    }, _$i.setAutoFreeze = function(n) {
        this.D = n;
    }, _$i.setUseProxies = function(r) {
        r && !B$1 && n$1(20), this.O = r;
    }, _$i.applyPatches = function(n, t) {
        var _$e;
        for(_$e = t.length - 1; _$e >= 0; _$e--){
            var _$i = t[_$e];
            if (0 === _$i.path.length && "replace" === _$i.op) {
                n = _$i.value;
                break;
            }
        }
        _$e > -1 && (t = t.slice(_$e + 1));
        var o = b$1("Patches").$;
        return r$1(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un; an.produce; an.produceWithPatches.bind(an); an.setAutoFreeze.bind(an); an.setUseProxies.bind(an); an.applyPatches.bind(an); an.createDraft.bind(an); an.finishDraft.bind(an);

function _array_like_to_array$3(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$3(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes$1(arr) {
    if (Array.isArray(arr)) return _array_like_to_array$3(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property$4(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _instanceof$1(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array$1(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit$3(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$3() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread$1() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$4(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$3(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$3(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$3(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of$1(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _sliced_to_array$3(arr, i) {
    return _array_with_holes$3(arr) || _iterable_to_array_limit$3(arr, i) || _unsupported_iterable_to_array$3(arr, i) || _non_iterable_rest$3();
}
function _to_array(arr) {
    return _array_with_holes$3(arr) || _iterable_to_array$1(arr) || _unsupported_iterable_to_array$3(arr) || _non_iterable_rest$3();
}
function _to_consumable_array$1(arr) {
    return _array_without_holes$1(arr) || _iterable_to_array$1(arr) || _unsupported_iterable_to_array$3(arr) || _non_iterable_spread$1();
}
function _type_of$1(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array$3(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$3(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$3(o, minLen);
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
var isString = function(obj) {
    return typeof obj === "string";
};
var defer = function() {
    var res;
    var rej;
    var promise = new Promise(function(resolve, reject) {
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
};
var makeString = function(object) {
    if (object == null) return "";
    return "" + object;
};
var copy = function(a, s, t) {
    a.forEach(function(m) {
        if (s[m]) t[m] = s[m];
    });
};
var lastOfPathSeparatorRegExp = /###/g;
var cleanKey = function(key) {
    return key && key.indexOf("###") > -1 ? key.replace(lastOfPathSeparatorRegExp, ".") : key;
};
var canNotTraverseDeeper = function(object) {
    return !object || isString(object);
};
var getLastOfPath = function(object, path, Empty) {
    var stack = !isString(path) ? path : path.split(".");
    var stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if (canNotTraverseDeeper(object)) return {};
        var key = cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) {
            object = object[key];
        } else {
            object = {};
        }
        ++stackIndex;
    }
    if (canNotTraverseDeeper(object)) return {};
    return {
        obj: object,
        k: cleanKey(stack[stackIndex])
    };
};
var setPath = function(object, path, newValue) {
    var _getLastOfPath = getLastOfPath(object, path, Object), obj = _getLastOfPath.obj, k = _getLastOfPath.k;
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    var e = path[path.length - 1];
    var p = path.slice(0, path.length - 1);
    var last = getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = "".concat(p[p.length - 1], ".").concat(e);
        p = p.slice(0, p.length - 1);
        last = getLastOfPath(object, p, Object);
        if ((last === null || last === void 0 ? void 0 : last.obj) && typeof last.obj["".concat(last.k, ".").concat(e)] !== "undefined") {
            last.obj = undefined;
        }
    }
    last.obj["".concat(last.k, ".").concat(e)] = newValue;
};
var pushPath = function(object, path, newValue, concat) {
    var _getLastOfPath = getLastOfPath(object, path, Object), obj = _getLastOfPath.obj, k = _getLastOfPath.k;
    obj[k] = obj[k] || [];
    obj[k].push(newValue);
};
var getPath = function(object, path) {
    var _getLastOfPath = getLastOfPath(object, path), obj = _getLastOfPath.obj, k = _getLastOfPath.k;
    if (!obj) return undefined;
    return obj[k];
};
var getPathWithDefaults = function(data, defaultData, key) {
    var value = getPath(data, key);
    if (value !== undefined) {
        return value;
    }
    return getPath(defaultData, key);
};
var deepExtend = function(target, source, overwrite) {
    for(var prop in source){
        if (prop !== "__proto__" && prop !== "constructor") {
            if (prop in target) {
                if (isString(target[prop]) || _instanceof$1(target[prop], String) || isString(source[prop]) || _instanceof$1(source[prop], String)) {
                    if (overwrite) target[prop] = source[prop];
                } else {
                    deepExtend(target[prop], source[prop], overwrite);
                }
            } else {
                target[prop] = source[prop];
            }
        }
    }
    return target;
};
var regexEscape = function(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
};
var _entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;"
};
var escape = function(data) {
    if (isString(data)) {
        return data.replace(/[&<>"'\/]/g, function(s) {
            return _entityMap[s];
        });
    }
    return data;
};
var RegExpCache = /*#__PURE__*/ function() {
    function RegExpCache(capacity) {
        _class_call_check(this, RegExpCache);
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
    _create_class(RegExpCache, [
        {
            key: "getRegExp",
            value: function getRegExp(pattern) {
                var regExpFromCache = this.regExpMap.get(pattern);
                if (regExpFromCache !== undefined) {
                    return regExpFromCache;
                }
                var regExpNew = new RegExp(pattern);
                if (this.regExpQueue.length === this.capacity) {
                    this.regExpMap.delete(this.regExpQueue.shift());
                }
                this.regExpMap.set(pattern, regExpNew);
                this.regExpQueue.push(pattern);
                return regExpNew;
            }
        }
    ]);
    return RegExpCache;
}();
var chars = [
    " ",
    ",",
    "?",
    "!",
    ";"
];
var looksLikeObjectPathRegExpCache = new RegExpCache(20);
var looksLikeObjectPath = function(key, nsSeparator, keySeparator) {
    nsSeparator = nsSeparator || "";
    keySeparator = keySeparator || "";
    var possibleChars = chars.filter(function(c) {
        return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
    });
    if (possibleChars.length === 0) return true;
    var r = looksLikeObjectPathRegExpCache.getRegExp("(".concat(possibleChars.map(function(c) {
        return c === "?" ? "\\?" : c;
    }).join("|"), ")"));
    var matched = !r.test(key);
    if (!matched) {
        var ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) {
            matched = true;
        }
    }
    return matched;
};
var deepFind = function deepFind(obj, path) {
    var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ".";
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    var tokens = path.split(keySeparator);
    var current = obj;
    for(var i = 0; i < tokens.length;){
        if (!current || typeof current !== "object") {
            return undefined;
        }
        var next = void 0;
        var nextPath = "";
        for(var j = i; j < tokens.length; ++j){
            if (j !== i) {
                nextPath += keySeparator;
            }
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    "string",
                    "number",
                    "boolean"
                ].indexOf(typeof next === "undefined" ? "undefined" : _type_of$1(next)) > -1 && j < tokens.length - 1) {
                    continue;
                }
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
};
var getCleanedCode = function(code) {
    return code === null || code === void 0 ? void 0 : code.replace("_", "-");
};
var consoleLogger = {
    type: "logger",
    log: function log(args) {
        this.output("log", args);
    },
    warn: function warn(args) {
        this.output("warn", args);
    },
    error: function error(args) {
        this.output("error", args);
    },
    output: function output(type, args) {
        var _console_type_apply, _console_type, _console;
        (_console = console) === null || _console === void 0 ? void 0 : (_console_type = _console[type]) === null || _console_type === void 0 ? void 0 : (_console_type_apply = _console_type.apply) === null || _console_type_apply === void 0 ? void 0 : _console_type_apply.call(_console_type, console, args);
    }
};
var Logger = /*#__PURE__*/ function() {
    function Logger(concreteLogger) {
        _class_call_check(this, Logger);
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.init(concreteLogger, options);
    }
    _create_class(Logger, [
        {
            key: "init",
            value: function init(concreteLogger) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                this.prefix = options.prefix || "i18next:";
                this.logger = concreteLogger || consoleLogger;
                this.options = options;
                this.debug = options.debug;
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return this.forward(args, "log", "", true);
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++){
                    args[_key2] = arguments[_key2];
                }
                return this.forward(args, "warn", "", true);
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++){
                    args[_key3] = arguments[_key3];
                }
                return this.forward(args, "error", "");
            }
        },
        {
            key: "deprecate",
            value: function deprecate() {
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++){
                    args[_key4] = arguments[_key4];
                }
                return this.forward(args, "warn", "WARNING DEPRECATED: ", true);
            }
        },
        {
            key: "forward",
            value: function forward(args, lvl, prefix, debugOnly) {
                if (debugOnly && !this.debug) return null;
                if (isString(args[0])) args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
                return this.logger[lvl](args);
            }
        },
        {
            key: "create",
            value: function create(moduleName) {
                return new Logger(this.logger, _object_spread$4({}, {
                    prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
                }, this.options));
            }
        },
        {
            key: "clone",
            value: function clone(options) {
                options = options || this.options;
                options.prefix = options.prefix || this.prefix;
                return new Logger(this.logger, options);
            }
        }
    ]);
    return Logger;
}();
var baseLogger = new Logger();
var EventEmitter = /*#__PURE__*/ function() {
    function EventEmitter() {
        _class_call_check(this, EventEmitter);
        this.observers = {};
    }
    _create_class(EventEmitter, [
        {
            key: "on",
            value: function on(events, listener) {
                var _this = this;
                events.split(" ").forEach(function(event) {
                    if (!_this.observers[event]) _this.observers[event] = new Map();
                    var numListeners = _this.observers[event].get(listener) || 0;
                    _this.observers[event].set(listener, numListeners + 1);
                });
                return this;
            }
        },
        {
            key: "off",
            value: function off(event, listener) {
                if (!this.observers[event]) return;
                if (!listener) {
                    delete this.observers[event];
                    return;
                }
                this.observers[event].delete(listener);
            }
        },
        {
            key: "emit",
            value: function emit(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                if (this.observers[event]) {
                    var cloned = Array.from(this.observers[event].entries());
                    cloned.forEach(function(_ref) {
                        var _$_ref = _sliced_to_array$3(_ref, 2), observer = _$_ref[0], numTimesAdded = _$_ref[1];
                        for(var i = 0; i < numTimesAdded; i++){
                            observer.apply(void 0, _to_consumable_array$1(args));
                        }
                    });
                }
                if (this.observers["*"]) {
                    var cloned1 = Array.from(this.observers["*"].entries());
                    cloned1.forEach(function(_ref2) {
                        var _$_ref2 = _sliced_to_array$3(_ref2, 2), observer = _$_ref2[0], numTimesAdded = _$_ref2[1];
                        for(var i = 0; i < numTimesAdded; i++){
                            observer.apply(observer, [
                                event
                            ].concat(_to_consumable_array$1(args)));
                        }
                    });
                }
            }
        }
    ]);
    return EventEmitter;
}();
var ResourceStore = /*#__PURE__*/ function(EventEmitter) {
    _inherits(ResourceStore, EventEmitter);
    var _super = _create_super(ResourceStore);
    function ResourceStore(data) {
        _class_call_check(this, ResourceStore);
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                "translation"
            ],
            defaultNS: "translation"
        };
        _this = _super.call(this);
        _this.data = data || {};
        _this.options = options;
        if (_this.options.keySeparator === undefined) {
            _this.options.keySeparator = ".";
        }
        if (_this.options.ignoreJSONStructure === undefined) {
            _this.options.ignoreJSONStructure = true;
        }
        return _this;
    }
    _create_class(ResourceStore, [
        {
            key: "addNamespaces",
            value: function addNamespaces(ns) {
                if (this.options.ns.indexOf(ns) < 0) {
                    this.options.ns.push(ns);
                }
            }
        },
        {
            key: "removeNamespaces",
            value: function removeNamespaces(ns) {
                var index = this.options.ns.indexOf(ns);
                if (index > -1) {
                    this.options.ns.splice(index, 1);
                }
            }
        },
        {
            key: "getResource",
            value: function getResource(lng, ns, key) {
                var _this_data_lng, _this_data;
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
                var path;
                if (lng.indexOf(".") > -1) {
                    path = lng.split(".");
                } else {
                    path = [
                        lng,
                        ns
                    ];
                    if (key) {
                        if (Array.isArray(key)) {
                            var _path;
                            (_path = path).push.apply(_path, _to_consumable_array$1(key));
                        } else if (isString(key) && keySeparator) {
                            var _path1;
                            (_path1 = path).push.apply(_path1, _to_consumable_array$1(key.split(keySeparator)));
                        } else {
                            path.push(key);
                        }
                    }
                }
                var result = getPath(this.data, path);
                if (!result && !ns && !key && lng.indexOf(".") > -1) {
                    lng = path[0];
                    ns = path[1];
                    key = path.slice(2).join(".");
                }
                if (result || !ignoreJSONStructure || !isString(key)) return result;
                return deepFind((_this_data = this.data) === null || _this_data === void 0 ? void 0 : (_this_data_lng = _this_data[lng]) === null || _this_data_lng === void 0 ? void 0 : _this_data_lng[ns], key, keySeparator);
            }
        },
        {
            key: "addResource",
            value: function addResource(lng, ns, key, value) {
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
                    silent: false
                };
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var path = [
                    lng,
                    ns
                ];
                if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf(".") > -1) {
                    path = lng.split(".");
                    value = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                setPath(this.data, path, value);
                if (!options.silent) this.emit("added", lng, ns, key, value);
            }
        },
        {
            key: "addResources",
            value: function addResources(lng, ns, resources) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
                    silent: false
                };
                for(var m in resources){
                    if (isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
                        silent: true
                    });
                }
                if (!options.silent) this.emit("added", lng, ns, resources);
            }
        },
        {
            key: "addResourceBundle",
            value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
                    silent: false,
                    skipCopy: false
                };
                var path = [
                    lng,
                    ns
                ];
                if (lng.indexOf(".") > -1) {
                    path = lng.split(".");
                    deep = resources;
                    resources = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                var pack = getPath(this.data, path) || {};
                if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
                if (deep) {
                    deepExtend(pack, resources, overwrite);
                } else {
                    pack = _object_spread$4({}, pack, resources);
                }
                setPath(this.data, path, pack);
                if (!options.silent) this.emit("added", lng, ns, resources);
            }
        },
        {
            key: "removeResourceBundle",
            value: function removeResourceBundle(lng, ns) {
                if (this.hasResourceBundle(lng, ns)) {
                    delete this.data[lng][ns];
                }
                this.removeNamespaces(ns);
                this.emit("removed", lng, ns);
            }
        },
        {
            key: "hasResourceBundle",
            value: function hasResourceBundle(lng, ns) {
                return this.getResource(lng, ns) !== undefined;
            }
        },
        {
            key: "getResourceBundle",
            value: function getResourceBundle(lng, ns) {
                if (!ns) ns = this.options.defaultNS;
                return this.getResource(lng, ns);
            }
        },
        {
            key: "getDataByLanguage",
            value: function getDataByLanguage(lng) {
                return this.data[lng];
            }
        },
        {
            key: "hasLanguageSomeTranslations",
            value: function hasLanguageSomeTranslations(lng) {
                var data = this.getDataByLanguage(lng);
                var n = data && Object.keys(data) || [];
                return !!n.find(function(v) {
                    return data[v] && Object.keys(data[v]).length > 0;
                });
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.data;
            }
        }
    ]);
    return ResourceStore;
}(EventEmitter);
var postProcessor = {
    processors: {},
    addPostProcessor: function addPostProcessor(module) {
        this.processors[module.name] = module;
    },
    handle: function handle(processors, value, key, options, translator) {
        var _this = this;
        processors.forEach(function(processor) {
            var _this_processors_processor;
            var _this_processors_processor_process;
            value = (_this_processors_processor_process = (_this_processors_processor = _this.processors[processor]) === null || _this_processors_processor === void 0 ? void 0 : _this_processors_processor.process(value, key, options, translator)) !== null && _this_processors_processor_process !== void 0 ? _this_processors_processor_process : value;
        });
        return value;
    }
};
var checkedLoadedFor = {};
var Translator = /*#__PURE__*/ function(EventEmitter) {
    _inherits(Translator, EventEmitter);
    var _super = _create_super(Translator);
    function Translator(services) {
        _class_call_check(this, Translator);
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        _this = _super.call(this);
        copy([
            "resourceStore",
            "languageUtils",
            "pluralResolver",
            "interpolator",
            "backendConnector",
            "i18nFormat",
            "utils"
        ], services, _assert_this_initialized(_this));
        _this.options = options;
        if (_this.options.keySeparator === undefined) {
            _this.options.keySeparator = ".";
        }
        _this.logger = baseLogger.create("translator");
        return _this;
    }
    _create_class(Translator, [
        {
            key: "changeLanguage",
            value: function changeLanguage(lng) {
                if (lng) this.language = lng;
            }
        },
        {
            key: "exists",
            value: function exists(key) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                if (key === undefined || key === null) {
                    return false;
                }
                var resolved = this.resolve(key, options);
                return (resolved === null || resolved === void 0 ? void 0 : resolved.res) !== undefined;
            }
        },
        {
            key: "extractFromKey",
            value: function extractFromKey(key, options) {
                var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
                if (nsSeparator === undefined) nsSeparator = ":";
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var namespaces = options.ns || this.options.defaultNS || [];
                var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
                var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);
                if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
                    var m = key.match(this.interpolator.nestingRegexp);
                    if (m && m.length > 0) {
                        return {
                            key: key,
                            namespaces: isString(namespaces) ? [
                                namespaces
                            ] : namespaces
                        };
                    }
                    var parts = key.split(nsSeparator);
                    if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
                    key = parts.join(keySeparator);
                }
                return {
                    key: key,
                    namespaces: isString(namespaces) ? [
                        namespaces
                    ] : namespaces
                };
            }
        },
        {
            key: "translate",
            value: function translate(keys, options, lastKey) {
                var _this = this;
                if (typeof options !== "object" && this.options.overloadTranslationOptionHandler) {
                    options = this.options.overloadTranslationOptionHandler(arguments);
                }
                if (typeof options === "object") options = _object_spread$4({}, options);
                if (!options) options = {};
                if (keys === undefined || keys === null) return "";
                if (!Array.isArray(keys)) keys = [
                    String(keys)
                ];
                var returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var _this_extractFromKey = this.extractFromKey(keys[keys.length - 1], options), key = _this_extractFromKey.key, namespaces = _this_extractFromKey.namespaces;
                var namespace = namespaces[namespaces.length - 1];
                var lng = options.lng || this.language;
                var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
                if ((lng === null || lng === void 0 ? void 0 : lng.toLowerCase()) === "cimode") {
                    if (appendNamespaceToCIMode) {
                        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
                        if (returnDetails) {
                            return {
                                res: "".concat(namespace).concat(nsSeparator).concat(key),
                                usedKey: key,
                                exactUsedKey: key,
                                usedLng: lng,
                                usedNS: namespace,
                                usedParams: this.getUsedParamsDetails(options)
                            };
                        }
                        return "".concat(namespace).concat(nsSeparator).concat(key);
                    }
                    if (returnDetails) {
                        return {
                            res: key,
                            usedKey: key,
                            exactUsedKey: key,
                            usedLng: lng,
                            usedNS: namespace,
                            usedParams: this.getUsedParamsDetails(options)
                        };
                    }
                    return key;
                }
                var resolved = this.resolve(keys, options);
                var res = resolved === null || resolved === void 0 ? void 0 : resolved.res;
                var resUsedKey = (resolved === null || resolved === void 0 ? void 0 : resolved.usedKey) || key;
                var resExactUsedKey = (resolved === null || resolved === void 0 ? void 0 : resolved.exactUsedKey) || key;
                var resType = Object.prototype.toString.apply(res);
                var noObject = [
                    "[object Number]",
                    "[object Function]",
                    "[object RegExp]"
                ];
                var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
                var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
                var handleAsObject = !isString(res) && typeof res !== "boolean" && typeof res !== "number";
                if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(isString(joinArrays) && Array.isArray(res))) {
                    if (!options.returnObjects && !this.options.returnObjects) {
                        if (!this.options.returnedObjectHandler) {
                            this.logger.warn("accessing an object - but returnObjects options is not enabled!");
                        }
                        var r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, _object_spread_props$3(_object_spread$4({}, options), {
                            ns: namespaces
                        })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
                        if (returnDetails) {
                            resolved.res = r;
                            resolved.usedParams = this.getUsedParamsDetails(options);
                            return resolved;
                        }
                        return r;
                    }
                    if (keySeparator) {
                        var resTypeIsArray = Array.isArray(res);
                        var copy = resTypeIsArray ? [] : {};
                        var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                        for(var m in res){
                            if (Object.prototype.hasOwnProperty.call(res, m)) {
                                var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
                                copy[m] = this.translate(deepKey, _object_spread$4({}, options, {
                                    joinArrays: false,
                                    ns: namespaces
                                }));
                                if (copy[m] === deepKey) copy[m] = res[m];
                            }
                        }
                        res = copy;
                    }
                } else if (handleAsObjectInI18nFormat && isString(joinArrays) && Array.isArray(res)) {
                    res = res.join(joinArrays);
                    if (res) res = this.extendTranslation(res, keys, options, lastKey);
                } else {
                    var usedDefault = false;
                    var usedKey = false;
                    var needsPluralHandling = options.count !== undefined && !isString(options.count);
                    var hasDefaultValue = Translator.hasDefaultValue(options);
                    var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : "";
                    var defaultValueSuffixOrdinalFallback = options.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, {
                        ordinal: false
                    }) : "";
                    var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0;
                    var defaultValue = needsZeroSuffixLookup && options["defaultValue".concat(this.options.pluralSeparator, "zero")] || options["defaultValue".concat(defaultValueSuffix)] || options["defaultValue".concat(defaultValueSuffixOrdinalFallback)] || options.defaultValue;
                    if (!this.isValidLookup(res) && hasDefaultValue) {
                        usedDefault = true;
                        res = defaultValue;
                    }
                    if (!this.isValidLookup(res)) {
                        usedKey = true;
                        res = key;
                    }
                    var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
                    var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
                    var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
                    if (usedKey || usedDefault || updateMissing) {
                        this.logger.log(updateMissing ? "updateKey" : "missingKey", lng, namespace, key, updateMissing ? defaultValue : res);
                        if (keySeparator) {
                            var fk = this.resolve(key, _object_spread_props$3(_object_spread$4({}, options), {
                                keySeparator: false
                            }));
                            if (fk && fk.res) this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
                        }
                        var lngs = [];
                        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                        if (this.options.saveMissingTo === "fallback" && fallbackLngs && fallbackLngs[0]) {
                            for(var i = 0; i < fallbackLngs.length; i++){
                                lngs.push(fallbackLngs[i]);
                            }
                        } else if (this.options.saveMissingTo === "all") {
                            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                        } else {
                            lngs.push(options.lng || this.language);
                        }
                        var send = function(l, k, specificDefaultValue) {
                            var _this_backendConnector;
                            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                            if (_this.options.missingKeyHandler) {
                                _this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                            } else if ((_this_backendConnector = _this.backendConnector) === null || _this_backendConnector === void 0 ? void 0 : _this_backendConnector.saveMissing) {
                                _this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                            }
                            _this.emit("missingKey", l, namespace, k, res);
                        };
                        if (this.options.saveMissing) {
                            if (this.options.saveMissingPlurals && needsPluralHandling) {
                                lngs.forEach(function(language) {
                                    var suffixes = _this.pluralResolver.getSuffixes(language, options);
                                    if (needsZeroSuffixLookup && options["defaultValue".concat(_this.options.pluralSeparator, "zero")] && suffixes.indexOf("".concat(_this.options.pluralSeparator, "zero")) < 0) {
                                        suffixes.push("".concat(_this.options.pluralSeparator, "zero"));
                                    }
                                    suffixes.forEach(function(suffix) {
                                        send([
                                            language
                                        ], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                                    });
                                });
                            } else {
                                send(lngs, key, defaultValue);
                            }
                        }
                    }
                    res = this.extendTranslation(res, keys, options, resolved, lastKey);
                    if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
                    if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                        res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace, ":").concat(key) : key, usedDefault ? res : undefined);
                    }
                }
                if (returnDetails) {
                    resolved.res = res;
                    resolved.usedParams = this.getUsedParamsDetails(options);
                    return resolved;
                }
                return res;
            }
        },
        {
            key: "extendTranslation",
            value: function extendTranslation(res, key, options, resolved, lastKey) {
                var _this_i18nFormat;
                var _this = this;
                if ((_this_i18nFormat = this.i18nFormat) === null || _this_i18nFormat === void 0 ? void 0 : _this_i18nFormat.parse) {
                    res = this.i18nFormat.parse(res, _object_spread$4({}, this.options.interpolation.defaultVariables, options), options.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
                        resolved: resolved
                    });
                } else if (!options.skipInterpolation) {
                    var _options_interpolation;
                    if (options.interpolation) this.interpolator.init(_object_spread$4({}, options, {
                        interpolation: _object_spread$4({}, this.options.interpolation, options.interpolation)
                    }));
                    var skipOnVariables = isString(res) && ((options === null || options === void 0 ? void 0 : (_options_interpolation = options.interpolation) === null || _options_interpolation === void 0 ? void 0 : _options_interpolation.skipOnVariables) !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
                    var nestBef;
                    if (skipOnVariables) {
                        var nb = res.match(this.interpolator.nestingRegexp);
                        nestBef = nb && nb.length;
                    }
                    var data = options.replace && !isString(options.replace) ? options.replace : options;
                    if (this.options.interpolation.defaultVariables) data = _object_spread$4({}, this.options.interpolation.defaultVariables, data);
                    res = this.interpolator.interpolate(res, data, options.lng || this.language || resolved.usedLng, options);
                    if (skipOnVariables) {
                        var na = res.match(this.interpolator.nestingRegexp);
                        var nestAft = na && na.length;
                        if (nestBef < nestAft) options.nest = false;
                    }
                    if (!options.lng && resolved && resolved.res) options.lng = this.language || resolved.usedLng;
                    if (options.nest !== false) res = this.interpolator.nest(res, function() {
                        var _this1;
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = arguments[_key];
                        }
                        if ((lastKey === null || lastKey === void 0 ? void 0 : lastKey[0]) === args[0] && !options.context) {
                            _this.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
                            return null;
                        }
                        return (_this1 = _this).translate.apply(_this1, _to_consumable_array$1(args).concat([
                            key
                        ]));
                    }, options);
                    if (options.interpolation) this.interpolator.reset();
                }
                var postProcess = options.postProcess || this.options.postProcess;
                var postProcessorNames = isString(postProcess) ? [
                    postProcess
                ] : postProcess;
                if (res !== undefined && res !== null && (postProcessorNames === null || postProcessorNames === void 0 ? void 0 : postProcessorNames.length) && options.applyPostProcessor !== false) {
                    res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _object_spread$4({
                        i18nResolved: _object_spread_props$3(_object_spread$4({}, resolved), {
                            usedParams: this.getUsedParamsDetails(options)
                        })
                    }, options) : options, this);
                }
                return res;
            }
        },
        {
            key: "resolve",
            value: function resolve(keys) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var found;
                var usedKey;
                var exactUsedKey;
                var usedLng;
                var usedNS;
                if (isString(keys)) keys = [
                    keys
                ];
                keys.forEach(function(k) {
                    if (_this.isValidLookup(found)) return;
                    var extracted = _this.extractFromKey(k, options);
                    var key = extracted.key;
                    usedKey = key;
                    var namespaces = extracted.namespaces;
                    if (_this.options.fallbackNS) namespaces = namespaces.concat(_this.options.fallbackNS);
                    var needsPluralHandling = options.count !== undefined && !isString(options.count);
                    var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0;
                    var needsContextHandling = options.context !== undefined && (isString(options.context) || typeof options.context === "number") && options.context !== "";
                    var codes = options.lngs ? options.lngs : _this.languageUtils.toResolveHierarchy(options.lng || _this.language, options.fallbackLng);
                    namespaces.forEach(function(ns) {
                        var _this_utils, _this_utils1;
                        if (_this.isValidLookup(found)) return;
                        usedNS = ns;
                        if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && ((_this_utils = _this.utils) === null || _this_utils === void 0 ? void 0 : _this_utils.hasLoadedNamespace) && !((_this_utils1 = _this.utils) === null || _this_utils1 === void 0 ? void 0 : _this_utils1.hasLoadedNamespace(usedNS))) {
                            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
                            _this.logger.warn('key "'.concat(usedKey, '" for languages "').concat(codes.join(", "), '" won\'t get resolved as namespace "').concat(usedNS, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                        }
                        codes.forEach(function(code) {
                            var _this_i18nFormat;
                            if (_this.isValidLookup(found)) return;
                            usedLng = code;
                            var finalKeys = [
                                key
                            ];
                            if ((_this_i18nFormat = _this.i18nFormat) === null || _this_i18nFormat === void 0 ? void 0 : _this_i18nFormat.addLookupKeys) {
                                _this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                            } else {
                                var pluralSuffix;
                                if (needsPluralHandling) pluralSuffix = _this.pluralResolver.getSuffix(code, options.count, options);
                                var zeroSuffix = "".concat(_this.options.pluralSeparator, "zero");
                                var ordinalPrefix = "".concat(_this.options.pluralSeparator, "ordinal").concat(_this.options.pluralSeparator);
                                if (needsPluralHandling) {
                                    finalKeys.push(key + pluralSuffix);
                                    if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) {
                                        finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, _this.options.pluralSeparator));
                                    }
                                    if (needsZeroSuffixLookup) {
                                        finalKeys.push(key + zeroSuffix);
                                    }
                                }
                                if (needsContextHandling) {
                                    var contextKey = "".concat(key).concat(_this.options.contextSeparator).concat(options.context);
                                    finalKeys.push(contextKey);
                                    if (needsPluralHandling) {
                                        finalKeys.push(contextKey + pluralSuffix);
                                        if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) {
                                            finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, _this.options.pluralSeparator));
                                        }
                                        if (needsZeroSuffixLookup) {
                                            finalKeys.push(contextKey + zeroSuffix);
                                        }
                                    }
                                }
                            }
                            var possibleKey;
                            while(possibleKey = finalKeys.pop()){
                                if (!_this.isValidLookup(found)) {
                                    exactUsedKey = possibleKey;
                                    found = _this.getResource(code, ns, possibleKey, options);
                                }
                            }
                        });
                    });
                });
                return {
                    res: found,
                    usedKey: usedKey,
                    exactUsedKey: exactUsedKey,
                    usedLng: usedLng,
                    usedNS: usedNS
                };
            }
        },
        {
            key: "isValidLookup",
            value: function isValidLookup(res) {
                return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === "");
            }
        },
        {
            key: "getResource",
            value: function getResource(code, ns, key) {
                var _this_i18nFormat;
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                if ((_this_i18nFormat = this.i18nFormat) === null || _this_i18nFormat === void 0 ? void 0 : _this_i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
                return this.resourceStore.getResource(code, ns, key, options);
            }
        },
        {
            key: "getUsedParamsDetails",
            value: function getUsedParamsDetails() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var optionsKeys = [
                    "defaultValue",
                    "ordinal",
                    "context",
                    "replace",
                    "lng",
                    "lngs",
                    "fallbackLng",
                    "ns",
                    "keySeparator",
                    "nsSeparator",
                    "returnObjects",
                    "returnDetails",
                    "joinArrays",
                    "postProcess",
                    "interpolation"
                ];
                var useOptionsReplaceForData = options.replace && !isString(options.replace);
                var data = useOptionsReplaceForData ? options.replace : options;
                if (useOptionsReplaceForData && typeof options.count !== "undefined") {
                    data.count = options.count;
                }
                if (this.options.interpolation.defaultVariables) {
                    data = _object_spread$4({}, this.options.interpolation.defaultVariables, data);
                }
                if (!useOptionsReplaceForData) {
                    data = _object_spread$4({}, data);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = optionsKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var key = _step.value;
                            delete data[key];
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                return data;
            }
        }
    ], [
        {
            key: "hasDefaultValue",
            value: function hasDefaultValue(options) {
                var prefix = "defaultValue";
                for(var option in options){
                    if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) {
                        return true;
                    }
                }
                return false;
            }
        }
    ]);
    return Translator;
}(EventEmitter);
var LanguageUtil = /*#__PURE__*/ function() {
    function LanguageUtil(options) {
        _class_call_check(this, LanguageUtil);
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = baseLogger.create("languageUtils");
    }
    _create_class(LanguageUtil, [
        {
            key: "getScriptPartFromCode",
            value: function getScriptPartFromCode(code) {
                code = getCleanedCode(code);
                if (!code || code.indexOf("-") < 0) return null;
                var p = code.split("-");
                if (p.length === 2) return null;
                p.pop();
                if (p[p.length - 1].toLowerCase() === "x") return null;
                return this.formatLanguageCode(p.join("-"));
            }
        },
        {
            key: "getLanguagePartFromCode",
            value: function getLanguagePartFromCode(code) {
                code = getCleanedCode(code);
                if (!code || code.indexOf("-") < 0) return code;
                var p = code.split("-");
                return this.formatLanguageCode(p[0]);
            }
        },
        {
            key: "formatLanguageCode",
            value: function formatLanguageCode(code) {
                if (isString(code) && code.indexOf("-") > -1) {
                    var formattedCode = Intl.getCanonicalLocales(code)[0];
                    if (formattedCode && this.options.lowerCaseLng) {
                        formattedCode = formattedCode.toLowerCase();
                    }
                    if (formattedCode) return formattedCode;
                    if (this.options.lowerCaseLng) {
                        return code.toLowerCase();
                    }
                    return code;
                }
                return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
            }
        },
        {
            key: "isSupportedCode",
            value: function isSupportedCode(code) {
                if (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) {
                    code = this.getLanguagePartFromCode(code);
                }
                return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
            }
        },
        {
            key: "getBestMatchFromCodes",
            value: function getBestMatchFromCodes(codes) {
                var _this = this;
                if (!codes) return null;
                var found;
                codes.forEach(function(code) {
                    if (found) return;
                    var cleanedLng = _this.formatLanguageCode(code);
                    if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
                });
                if (!found && this.options.supportedLngs) {
                    codes.forEach(function(code) {
                        if (found) return;
                        var lngOnly = _this.getLanguagePartFromCode(code);
                        if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
                        found = _this.options.supportedLngs.find(function(supportedLng) {
                            if (supportedLng === lngOnly) return supportedLng;
                            if (supportedLng.indexOf("-") < 0 && lngOnly.indexOf("-") < 0) return;
                            if (supportedLng.indexOf("-") > 0 && lngOnly.indexOf("-") < 0 && supportedLng.substring(0, supportedLng.indexOf("-")) === lngOnly) return supportedLng;
                            if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
                        });
                    });
                }
                if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
                return found;
            }
        },
        {
            key: "getFallbackCodes",
            value: function getFallbackCodes(fallbacks, code) {
                if (!fallbacks) return [];
                if (typeof fallbacks === "function") fallbacks = fallbacks(code);
                if (isString(fallbacks)) fallbacks = [
                    fallbacks
                ];
                if (Array.isArray(fallbacks)) return fallbacks;
                if (!code) return fallbacks.default || [];
                var found = fallbacks[code];
                if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
                if (!found) found = fallbacks[this.formatLanguageCode(code)];
                if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
                if (!found) found = fallbacks.default;
                return found || [];
            }
        },
        {
            key: "toResolveHierarchy",
            value: function toResolveHierarchy(code, fallbackCode) {
                var _this = this;
                var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
                var codes = [];
                var addCode = function(c) {
                    if (!c) return;
                    if (_this.isSupportedCode(c)) {
                        codes.push(c);
                    } else {
                        _this.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
                    }
                };
                if (isString(code) && (code.indexOf("-") > -1 || code.indexOf("_") > -1)) {
                    if (this.options.load !== "languageOnly") addCode(this.formatLanguageCode(code));
                    if (this.options.load !== "languageOnly" && this.options.load !== "currentOnly") addCode(this.getScriptPartFromCode(code));
                    if (this.options.load !== "currentOnly") addCode(this.getLanguagePartFromCode(code));
                } else if (isString(code)) {
                    addCode(this.formatLanguageCode(code));
                }
                fallbackCodes.forEach(function(fc) {
                    if (codes.indexOf(fc) < 0) addCode(_this.formatLanguageCode(fc));
                });
                return codes;
            }
        }
    ]);
    return LanguageUtil;
}();
var suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
var dummyRule = {
    select: function(count) {
        return count === 1 ? "one" : "other";
    },
    resolvedOptions: function() {
        return {
            pluralCategories: [
                "one",
                "other"
            ]
        };
    }
};
var PluralResolver = /*#__PURE__*/ function() {
    function PluralResolver(languageUtils) {
        _class_call_check(this, PluralResolver);
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = baseLogger.create("pluralResolver");
        this.pluralRulesCache = {};
    }
    _create_class(PluralResolver, [
        {
            key: "addRule",
            value: function addRule(lng, obj) {
                this.rules[lng] = obj;
            }
        },
        {
            key: "clearCache",
            value: function clearCache() {
                this.pluralRulesCache = {};
            }
        },
        {
            key: "getRule",
            value: function getRule(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var cleanedCode = getCleanedCode(code === "dev" ? "en" : code);
                var type = options.ordinal ? "ordinal" : "cardinal";
                var cacheKey = JSON.stringify({
                    cleanedCode: cleanedCode,
                    type: type
                });
                if (cacheKey in this.pluralRulesCache) {
                    return this.pluralRulesCache[cacheKey];
                }
                var rule;
                try {
                    rule = new Intl.PluralRules(cleanedCode, {
                        type: type
                    });
                } catch (err) {
                    if (!Intl) {
                        this.logger.error("No Intl support, please use an Intl polyfill!");
                        return dummyRule;
                    }
                    if (!code.match(/-|_/)) return dummyRule;
                    var lngPart = this.languageUtils.getLanguagePartFromCode(code);
                    rule = this.getRule(lngPart, options);
                }
                this.pluralRulesCache[cacheKey] = rule;
                return rule;
            }
        },
        {
            key: "needsPlural",
            value: function needsPlural(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (!rule) rule = this.getRule("dev", options);
                return (rule === null || rule === void 0 ? void 0 : rule.resolvedOptions().pluralCategories.length) > 1;
            }
        },
        {
            key: "getPluralFormsOfKey",
            value: function getPluralFormsOfKey(code, key) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return this.getSuffixes(code, options).map(function(suffix) {
                    return "".concat(key).concat(suffix);
                });
            }
        },
        {
            key: "getSuffixes",
            value: function getSuffixes(code) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (!rule) rule = this.getRule("dev", options);
                if (!rule) return [];
                return rule.resolvedOptions().pluralCategories.sort(function(pluralCategory1, pluralCategory2) {
                    return suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2];
                }).map(function(pluralCategory) {
                    return "".concat(_this.options.prepend).concat(options.ordinal ? "ordinal".concat(_this.options.prepend) : "").concat(pluralCategory);
                });
            }
        },
        {
            key: "getSuffix",
            value: function getSuffix(code, count) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var rule = this.getRule(code, options);
                if (rule) {
                    return "".concat(this.options.prepend).concat(options.ordinal ? "ordinal".concat(this.options.prepend) : "").concat(rule.select(count));
                }
                this.logger.warn("no plural rule found for: ".concat(code));
                return this.getSuffix("dev", count, options);
            }
        }
    ]);
    return PluralResolver;
}();
var deepFindWithDefaults = function deepFindWithDefaults(data, defaultData, key) {
    var keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ".";
    var ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    var path = getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && isString(key)) {
        path = deepFind(data, key, keySeparator);
        if (path === undefined) path = deepFind(defaultData, key, keySeparator);
    }
    return path;
};
var regexSafe = function(val) {
    return val.replace(/\$/g, "$$$$");
};
var Interpolator = /*#__PURE__*/ function() {
    function Interpolator() {
        _class_call_check(this, Interpolator);
        var _options_interpolation;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = baseLogger.create("interpolator");
        this.options = options;
        this.format = (options === null || options === void 0 ? void 0 : (_options_interpolation = options.interpolation) === null || _options_interpolation === void 0 ? void 0 : _options_interpolation.format) || function(value) {
            return value;
        };
        this.init(options);
    }
    _create_class(Interpolator, [
        {
            key: "init",
            value: function init() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!options.interpolation) options.interpolation = {
                    escapeValue: true
                };
                var _options_interpolation = options.interpolation, escape$1 = _options_interpolation.escape, escapeValue = _options_interpolation.escapeValue, useRawValueToEscape = _options_interpolation.useRawValueToEscape, prefix = _options_interpolation.prefix, prefixEscaped = _options_interpolation.prefixEscaped, suffix = _options_interpolation.suffix, suffixEscaped = _options_interpolation.suffixEscaped, formatSeparator = _options_interpolation.formatSeparator, unescapeSuffix = _options_interpolation.unescapeSuffix, unescapePrefix = _options_interpolation.unescapePrefix, nestingPrefix = _options_interpolation.nestingPrefix, nestingPrefixEscaped = _options_interpolation.nestingPrefixEscaped, nestingSuffix = _options_interpolation.nestingSuffix, nestingSuffixEscaped = _options_interpolation.nestingSuffixEscaped, nestingOptionsSeparator = _options_interpolation.nestingOptionsSeparator, maxReplaces = _options_interpolation.maxReplaces, alwaysFormat = _options_interpolation.alwaysFormat;
                this.escape = escape$1 !== undefined ? escape$1 : escape;
                this.escapeValue = escapeValue !== undefined ? escapeValue : true;
                this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
                this.prefix = prefix ? regexEscape(prefix) : prefixEscaped || "{{";
                this.suffix = suffix ? regexEscape(suffix) : suffixEscaped || "}}";
                this.formatSeparator = formatSeparator || ",";
                this.unescapePrefix = unescapeSuffix ? "" : unescapePrefix || "-";
                this.unescapeSuffix = this.unescapePrefix ? "" : unescapeSuffix || "";
                this.nestingPrefix = nestingPrefix ? regexEscape(nestingPrefix) : nestingPrefixEscaped || regexEscape("$t(");
                this.nestingSuffix = nestingSuffix ? regexEscape(nestingSuffix) : nestingSuffixEscaped || regexEscape(")");
                this.nestingOptionsSeparator = nestingOptionsSeparator || ",";
                this.maxReplaces = maxReplaces || 1000;
                this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
                this.resetRegExp();
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.options) this.init(this.options);
            }
        },
        {
            key: "resetRegExp",
            value: function resetRegExp() {
                var getOrResetRegExp = function(existingRegExp, pattern) {
                    if ((existingRegExp === null || existingRegExp === void 0 ? void 0 : existingRegExp.source) === pattern) {
                        existingRegExp.lastIndex = 0;
                        return existingRegExp;
                    }
                    return new RegExp(pattern, "g");
                };
                this.regexp = getOrResetRegExp(this.regexp, "".concat(this.prefix, "(.+?)").concat(this.suffix));
                this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix));
                this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix));
            }
        },
        {
            key: "interpolate",
            value: function interpolate(str, data, lng, options) {
                var _this = this;
                var _options_interpolation;
                var match;
                var value;
                var replaces;
                var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
                var handleFormat = function(key) {
                    if (key.indexOf(_this.formatSeparator) < 0) {
                        var path = deepFindWithDefaults(data, defaultData, key, _this.options.keySeparator, _this.options.ignoreJSONStructure);
                        return _this.alwaysFormat ? _this.format(path, undefined, lng, _object_spread_props$3(_object_spread$4({}, options, data), {
                            interpolationkey: key
                        })) : path;
                    }
                    var p = key.split(_this.formatSeparator);
                    var k = p.shift().trim();
                    var f = p.join(_this.formatSeparator).trim();
                    return _this.format(deepFindWithDefaults(data, defaultData, k, _this.options.keySeparator, _this.options.ignoreJSONStructure), f, lng, _object_spread_props$3(_object_spread$4({}, options, data), {
                        interpolationkey: k
                    }));
                };
                this.resetRegExp();
                var missingInterpolationHandler = (options === null || options === void 0 ? void 0 : options.missingInterpolationHandler) || this.options.missingInterpolationHandler;
                var skipOnVariables = (options === null || options === void 0 ? void 0 : (_options_interpolation = options.interpolation) === null || _options_interpolation === void 0 ? void 0 : _options_interpolation.skipOnVariables) !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
                var todos = [
                    {
                        regex: this.regexpUnescape,
                        safeValue: function(val) {
                            return regexSafe(val);
                        }
                    },
                    {
                        regex: this.regexp,
                        safeValue: function(val) {
                            return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
                        }
                    }
                ];
                todos.forEach(function(todo) {
                    replaces = 0;
                    while(match = todo.regex.exec(str)){
                        var matchedVar = match[1].trim();
                        value = handleFormat(matchedVar);
                        if (value === undefined) {
                            if (typeof missingInterpolationHandler === "function") {
                                var temp = missingInterpolationHandler(str, match, options);
                                value = isString(temp) ? temp : "";
                            } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) {
                                value = "";
                            } else if (skipOnVariables) {
                                value = match[0];
                                continue;
                            } else {
                                _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));
                                value = "";
                            }
                        } else if (!isString(value) && !_this.useRawValueToEscape) {
                            value = makeString(value);
                        }
                        var safeValue = todo.safeValue(value);
                        str = str.replace(match[0], safeValue);
                        if (skipOnVariables) {
                            todo.regex.lastIndex += value.length;
                            todo.regex.lastIndex -= match[0].length;
                        } else {
                            todo.regex.lastIndex = 0;
                        }
                        replaces++;
                        if (replaces >= _this.maxReplaces) {
                            break;
                        }
                    }
                });
                return str;
            }
        },
        {
            key: "nest",
            value: function nest(str, fc) {
                var _this = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var match;
                var value;
                var clonedOptions;
                var handleHasOptions = function(key, inheritedOptions) {
                    var sep = _this.nestingOptionsSeparator;
                    if (key.indexOf(sep) < 0) return key;
                    var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
                    var optionsString = "{".concat(c[1]);
                    key = c[0];
                    optionsString = _this.interpolate(optionsString, clonedOptions);
                    var matchedSingleQuotes = optionsString.match(/'/g);
                    var matchedDoubleQuotes = optionsString.match(/"/g);
                    var _matchedSingleQuotes_length;
                    if (((_matchedSingleQuotes_length = matchedSingleQuotes === null || matchedSingleQuotes === void 0 ? void 0 : matchedSingleQuotes.length) !== null && _matchedSingleQuotes_length !== void 0 ? _matchedSingleQuotes_length : 0) % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) {
                        optionsString = optionsString.replace(/'/g, '"');
                    }
                    try {
                        clonedOptions = JSON.parse(optionsString);
                        if (inheritedOptions) clonedOptions = _object_spread$4({}, inheritedOptions, clonedOptions);
                    } catch (e) {
                        _this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
                        return "".concat(key).concat(sep).concat(optionsString);
                    }
                    if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(_this.prefix) > -1) delete clonedOptions.defaultValue;
                    return key;
                };
                while(match = this.nestingRegexp.exec(str)){
                    var formatters = [];
                    clonedOptions = _object_spread$4({}, options);
                    clonedOptions = clonedOptions.replace && !isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
                    clonedOptions.applyPostProcessor = false;
                    delete clonedOptions.defaultValue;
                    var doReduce = false;
                    if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                        var r = match[1].split(this.formatSeparator).map(function(elem) {
                            return elem.trim();
                        });
                        match[1] = r.shift();
                        formatters = r;
                        doReduce = true;
                    }
                    value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
                    if (value && match[0] === str && !isString(value)) return value;
                    if (!isString(value)) value = makeString(value);
                    if (!value) {
                        this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
                        value = "";
                    }
                    if (doReduce) {
                        value = formatters.reduce(function(v, f) {
                            return _this.format(v, f, options.lng, _object_spread_props$3(_object_spread$4({}, options), {
                                interpolationkey: match[1].trim()
                            }));
                        }, value.trim());
                    }
                    str = str.replace(match[0], value);
                    this.regexp.lastIndex = 0;
                }
                return str;
            }
        }
    ]);
    return Interpolator;
}();
var parseFormatStr = function(formatStr) {
    var formatName = formatStr.toLowerCase().trim();
    var formatOptions = {};
    if (formatStr.indexOf("(") > -1) {
        var p = formatStr.split("(");
        formatName = p[0].toLowerCase().trim();
        var optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === "currency" && optStr.indexOf(":") < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === "relativetime" && optStr.indexOf(":") < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            var opts = optStr.split(";");
            opts.forEach(function(opt) {
                if (opt) {
                    var _opt_split = _to_array(opt.split(":")), key = _opt_split[0], rest = _opt_split.slice(1);
                    var val = rest.join(":").trim().replace(/^'+|'+$/g, "");
                    var trimmedKey = key.trim();
                    if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
                    if (val === "false") formatOptions[trimmedKey] = false;
                    if (val === "true") formatOptions[trimmedKey] = true;
                    if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
                }
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
};
var createCachedFormatter = function(fn) {
    var cache = {};
    return function(val, lng, options) {
        var optForCache = options;
        if (options && options.interpolationkey && options.formatParams && options.formatParams[options.interpolationkey] && options[options.interpolationkey]) {
            optForCache = _object_spread_props$3(_object_spread$4({}, optForCache), _define_property$4({}, options.interpolationkey, undefined));
        }
        var key = lng + JSON.stringify(optForCache);
        var formatter = cache[key];
        if (!formatter) {
            formatter = fn(getCleanedCode(lng), options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
};
var Formatter = /*#__PURE__*/ function() {
    function Formatter() {
        _class_call_check(this, Formatter);
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = baseLogger.create("formatter");
        this.options = options;
        this.formats = {
            number: createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.NumberFormat(lng, _object_spread$4({}, opt));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            currency: createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.NumberFormat(lng, _object_spread_props$3(_object_spread$4({}, opt), {
                    style: "currency"
                }));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            datetime: createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.DateTimeFormat(lng, _object_spread$4({}, opt));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            relativetime: createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.RelativeTimeFormat(lng, _object_spread$4({}, opt));
                return function(val) {
                    return formatter.format(val, opt.range || "day");
                };
            }),
            list: createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.ListFormat(lng, _object_spread$4({}, opt));
                return function(val) {
                    return formatter.format(val);
                };
            })
        };
        this.init(options);
    }
    _create_class(Formatter, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                this.formatSeparator = options.interpolation.formatSeparator || ",";
            }
        },
        {
            key: "add",
            value: function add(name, fc) {
                this.formats[name.toLowerCase().trim()] = fc;
            }
        },
        {
            key: "addCached",
            value: function addCached(name, fc) {
                this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
            }
        },
        {
            key: "format",
            value: function format(value, format, lng) {
                var _this = this;
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var formats = format.split(this.formatSeparator);
                if (formats.length > 1 && formats[0].indexOf("(") > 1 && formats[0].indexOf(")") < 0 && formats.find(function(f) {
                    return f.indexOf(")") > -1;
                })) {
                    var lastIndex = formats.findIndex(function(f) {
                        return f.indexOf(")") > -1;
                    });
                    formats[0] = [
                        formats[0]
                    ].concat(_to_consumable_array$1(formats.splice(1, lastIndex))).join(this.formatSeparator);
                }
                var result = formats.reduce(function(mem, f) {
                    var _parseFormatStr = parseFormatStr(f), formatName = _parseFormatStr.formatName, formatOptions = _parseFormatStr.formatOptions;
                    if (_this.formats[formatName]) {
                        var formatted = mem;
                        try {
                            var _options_formatParams;
                            var valOptions = (options === null || options === void 0 ? void 0 : (_options_formatParams = options.formatParams) === null || _options_formatParams === void 0 ? void 0 : _options_formatParams[options.interpolationkey]) || {};
                            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                            formatted = _this.formats[formatName](mem, l, _object_spread$4({}, formatOptions, options, valOptions));
                        } catch (error) {
                            _this.logger.warn(error);
                        }
                        return formatted;
                    } else {
                        _this.logger.warn("there was no format function for ".concat(formatName));
                    }
                    return mem;
                }, value);
                return result;
            }
        }
    ]);
    return Formatter;
}();
var removePending = function(q, name) {
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
};
var Connector = /*#__PURE__*/ function(EventEmitter) {
    _inherits(Connector, EventEmitter);
    var _super = _create_super(Connector);
    function Connector(backend, store, services) {
        _class_call_check(this, Connector);
        var _this;
        var _this_backend_init, _this_backend;
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        _this = _super.call(this);
        _this.backend = backend;
        _this.store = store;
        _this.services = services;
        _this.languageUtils = services.languageUtils;
        _this.options = options;
        _this.logger = baseLogger.create("backendConnector");
        _this.waitingReads = [];
        _this.maxParallelReads = options.maxParallelReads || 10;
        _this.readingCalls = 0;
        _this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        _this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        _this.state = {};
        _this.queue = [];
        (_this_backend = _this.backend) === null || _this_backend === void 0 ? void 0 : (_this_backend_init = _this_backend.init) === null || _this_backend_init === void 0 ? void 0 : _this_backend_init.call(_this_backend, services, options.backend, options);
        return _this;
    }
    _create_class(Connector, [
        {
            key: "queueLoad",
            value: function queueLoad(languages, namespaces, options, callback) {
                var _this = this;
                var toLoad = {};
                var pending = {};
                var toLoadLanguages = {};
                var toLoadNamespaces = {};
                languages.forEach(function(lng) {
                    var hasAllNamespaces = true;
                    namespaces.forEach(function(ns) {
                        var name = "".concat(lng, "|").concat(ns);
                        if (!options.reload && _this.store.hasResourceBundle(lng, ns)) {
                            _this.state[name] = 2;
                        } else if (_this.state[name] < 0) ;
                        else if (_this.state[name] === 1) {
                            if (pending[name] === undefined) pending[name] = true;
                        } else {
                            _this.state[name] = 1;
                            hasAllNamespaces = false;
                            if (pending[name] === undefined) pending[name] = true;
                            if (toLoad[name] === undefined) toLoad[name] = true;
                            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                        }
                    });
                    if (!hasAllNamespaces) toLoadLanguages[lng] = true;
                });
                if (Object.keys(toLoad).length || Object.keys(pending).length) {
                    this.queue.push({
                        pending: pending,
                        pendingCount: Object.keys(pending).length,
                        loaded: {},
                        errors: [],
                        callback: callback
                    });
                }
                return {
                    toLoad: Object.keys(toLoad),
                    pending: Object.keys(pending),
                    toLoadLanguages: Object.keys(toLoadLanguages),
                    toLoadNamespaces: Object.keys(toLoadNamespaces)
                };
            }
        },
        {
            key: "loaded",
            value: function loaded(name, err, data) {
                var s = name.split("|");
                var lng = s[0];
                var ns = s[1];
                if (err) this.emit("failedLoading", lng, ns, err);
                if (!err && data) {
                    this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
                        skipCopy: true
                    });
                }
                this.state[name] = err ? -1 : 2;
                if (err && data) this.state[name] = 0;
                var loaded = {};
                this.queue.forEach(function(q) {
                    pushPath(q.loaded, [
                        lng
                    ], ns);
                    removePending(q, name);
                    if (err) q.errors.push(err);
                    if (q.pendingCount === 0 && !q.done) {
                        Object.keys(q.loaded).forEach(function(l) {
                            if (!loaded[l]) loaded[l] = {};
                            var loadedKeys = q.loaded[l];
                            if (loadedKeys.length) {
                                loadedKeys.forEach(function(n) {
                                    if (loaded[l][n] === undefined) loaded[l][n] = true;
                                });
                            }
                        });
                        q.done = true;
                        if (q.errors.length) {
                            q.callback(q.errors);
                        } else {
                            q.callback();
                        }
                    }
                });
                this.emit("loaded", loaded);
                this.queue = this.queue.filter(function(q) {
                    return !q.done;
                });
            }
        },
        {
            key: "read",
            value: function read(lng, ns, fcName) {
                var _this = this;
                var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
                var callback = arguments.length > 5 ? arguments[5] : undefined;
                if (!lng.length) return callback(null, {});
                if (this.readingCalls >= this.maxParallelReads) {
                    this.waitingReads.push({
                        lng: lng,
                        ns: ns,
                        fcName: fcName,
                        tried: tried,
                        wait: wait,
                        callback: callback
                    });
                    return;
                }
                this.readingCalls++;
                var resolver = function(err, data) {
                    _this.readingCalls--;
                    if (_this.waitingReads.length > 0) {
                        var next = _this.waitingReads.shift();
                        _this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
                    }
                    if (err && data && tried < _this.maxRetries) {
                        setTimeout(function() {
                            _this.read.call(_this, lng, ns, fcName, tried + 1, wait * 2, callback);
                        }, wait);
                        return;
                    }
                    callback(err, data);
                };
                var fc = this.backend[fcName].bind(this.backend);
                if (fc.length === 2) {
                    try {
                        var r = fc(lng, ns);
                        if (r && typeof r.then === "function") {
                            r.then(function(data) {
                                return resolver(null, data);
                            }).catch(resolver);
                        } else {
                            resolver(null, r);
                        }
                    } catch (err) {
                        resolver(err);
                    }
                    return;
                }
                return fc(lng, ns, resolver);
            }
        },
        {
            key: "prepareLoading",
            value: function prepareLoading(languages, namespaces) {
                var _this = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var callback = arguments.length > 3 ? arguments[3] : undefined;
                if (!this.backend) {
                    this.logger.warn("No backend was added via i18next.use. Will not load resources.");
                    return callback && callback();
                }
                if (isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
                if (isString(namespaces)) namespaces = [
                    namespaces
                ];
                var toLoad = this.queueLoad(languages, namespaces, options, callback);
                if (!toLoad.toLoad.length) {
                    if (!toLoad.pending.length) callback();
                    return null;
                }
                toLoad.toLoad.forEach(function(name) {
                    _this.loadOne(name);
                });
            }
        },
        {
            key: "load",
            value: function load(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {}, callback);
            }
        },
        {
            key: "reload",
            value: function reload(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {
                    reload: true
                }, callback);
            }
        },
        {
            key: "loadOne",
            value: function loadOne(name) {
                var _this = this;
                var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                var s = name.split("|");
                var lng = s[0];
                var ns = s[1];
                this.read(lng, ns, "read", undefined, undefined, function(err, data) {
                    if (err) _this.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
                    if (!err && data) _this.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
                    _this.loaded(name, err, data);
                });
            }
        },
        {
            key: "saveMissing",
            value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
                var _this_services_utils, _this_services, _this_services_utils1, _this_services1, _this_backend;
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : function() {};
                if (((_this_services = this.services) === null || _this_services === void 0 ? void 0 : (_this_services_utils = _this_services.utils) === null || _this_services_utils === void 0 ? void 0 : _this_services_utils.hasLoadedNamespace) && !((_this_services1 = this.services) === null || _this_services1 === void 0 ? void 0 : (_this_services_utils1 = _this_services1.utils) === null || _this_services_utils1 === void 0 ? void 0 : _this_services_utils1.hasLoadedNamespace(namespace))) {
                    this.logger.warn('did not save key "'.concat(key, '" as the namespace "').concat(namespace, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                    return;
                }
                if (key === undefined || key === null || key === "") return;
                if ((_this_backend = this.backend) === null || _this_backend === void 0 ? void 0 : _this_backend.create) {
                    var opts = _object_spread_props$3(_object_spread$4({}, options), {
                        isUpdate: isUpdate
                    });
                    var fc = this.backend.create.bind(this.backend);
                    if (fc.length < 6) {
                        try {
                            var r;
                            if (fc.length === 5) {
                                r = fc(languages, namespace, key, fallbackValue, opts);
                            } else {
                                r = fc(languages, namespace, key, fallbackValue);
                            }
                            if (r && typeof r.then === "function") {
                                r.then(function(data) {
                                    return clb(null, data);
                                }).catch(clb);
                            } else {
                                clb(null, r);
                            }
                        } catch (err) {
                            clb(err);
                        }
                    } else {
                        fc(languages, namespace, key, fallbackValue, clb, opts);
                    }
                }
                if (!languages || !languages[0]) return;
                this.store.addResource(languages[0], namespace, key, fallbackValue);
            }
        }
    ]);
    return Connector;
}(EventEmitter);
var get = function() {
    return {
        debug: false,
        initAsync: true,
        ns: [
            "translation"
        ],
        defaultNS: [
            "translation"
        ],
        fallbackLng: [
            "dev"
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: "all",
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: ".",
        nsSeparator: ":",
        pluralSeparator: "_",
        contextSeparator: "_",
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: "fallback",
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function(args) {
            var ret = {};
            if (typeof args[1] === "object") ret = args[1];
            if (isString(args[1])) ret.defaultValue = args[1];
            if (isString(args[2])) ret.tDescription = args[2];
            if (typeof args[2] === "object" || typeof args[3] === "object") {
                var options = args[3] || args[2];
                Object.keys(options).forEach(function(key) {
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: function(value) {
                return value;
            },
            prefix: "{{",
            suffix: "}}",
            formatSeparator: ",",
            unescapePrefix: "-",
            nestingPrefix: "$t(",
            nestingSuffix: ")",
            nestingOptionsSeparator: ",",
            maxReplaces: 1000,
            skipOnVariables: true
        }
    };
};
var transformOptions = function(options) {
    var _options_supportedLngs_indexOf, _options_supportedLngs;
    if (isString(options.ns)) options.ns = [
        options.ns
    ];
    if (isString(options.fallbackLng)) options.fallbackLng = [
        options.fallbackLng
    ];
    if (isString(options.fallbackNS)) options.fallbackNS = [
        options.fallbackNS
    ];
    if (((_options_supportedLngs = options.supportedLngs) === null || _options_supportedLngs === void 0 ? void 0 : (_options_supportedLngs_indexOf = _options_supportedLngs.indexOf) === null || _options_supportedLngs_indexOf === void 0 ? void 0 : _options_supportedLngs_indexOf.call(_options_supportedLngs, "cimode")) < 0) {
        options.supportedLngs = options.supportedLngs.concat([
            "cimode"
        ]);
    }
    if (typeof options.initImmediate === "boolean") options.initAsync = options.initImmediate;
    return options;
};
var noop = function() {};
var bindMemberFunctions = function(inst) {
    var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach(function(mem) {
        if (typeof inst[mem] === "function") {
            inst[mem] = inst[mem].bind(inst);
        }
    });
};
var I18n = /*#__PURE__*/ function(EventEmitter) {
    _inherits(I18n, EventEmitter);
    var _super = _create_super(I18n);
    function I18n() {
        _class_call_check(this, I18n);
        var _this;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var callback = arguments.length > 1 ? arguments[1] : undefined;
        _this = _super.call(this);
        _this.options = transformOptions(options);
        _this.services = {};
        _this.logger = baseLogger;
        _this.modules = {
            external: []
        };
        bindMemberFunctions(_assert_this_initialized(_this));
        if (callback && !_this.isInitialized && !options.isClone) {
            if (!_this.options.initAsync) {
                _this.init(options, callback);
                return _possible_constructor_return(_this, _assert_this_initialized(_this));
            }
            setTimeout(function() {
                _this.init(options, callback);
            }, 0);
        }
        return _this;
    }
    _create_class(I18n, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                var _this1 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 ? arguments[1] : undefined;
                this.isInitializing = true;
                if (typeof options === "function") {
                    callback = options;
                    options = {};
                }
                if (!options.defaultNS && options.defaultNS !== false && options.ns) {
                    if (isString(options.ns)) {
                        options.defaultNS = options.ns;
                    } else if (options.ns.indexOf("translation") < 0) {
                        options.defaultNS = options.ns[0];
                    }
                }
                var defOpts = get();
                this.options = _object_spread$4({}, defOpts, this.options, transformOptions(options));
                this.options.interpolation = _object_spread$4({}, defOpts.interpolation, this.options.interpolation);
                if (options.keySeparator !== undefined) {
                    this.options.userDefinedKeySeparator = options.keySeparator;
                }
                if (options.nsSeparator !== undefined) {
                    this.options.userDefinedNsSeparator = options.nsSeparator;
                }
                var createClassOnDemand = function(ClassOrObject) {
                    if (!ClassOrObject) return null;
                    if (typeof ClassOrObject === "function") return new ClassOrObject();
                    return ClassOrObject;
                };
                if (!this.options.isClone) {
                    if (this.modules.logger) {
                        baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
                    } else {
                        baseLogger.init(null, this.options);
                    }
                    var formatter;
                    if (this.modules.formatter) {
                        formatter = this.modules.formatter;
                    } else {
                        formatter = Formatter;
                    }
                    var lu = new LanguageUtil(this.options);
                    this.store = new ResourceStore(this.options.resources, this.options);
                    var s = this.services;
                    s.logger = baseLogger;
                    s.resourceStore = this.store;
                    s.languageUtils = lu;
                    s.pluralResolver = new PluralResolver(lu, {
                        prepend: this.options.pluralSeparator,
                        simplifyPluralSuffix: this.options.simplifyPluralSuffix
                    });
                    if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                        s.formatter = createClassOnDemand(formatter);
                        s.formatter.init(s, this.options);
                        this.options.interpolation.format = s.formatter.format.bind(s.formatter);
                    }
                    s.interpolator = new Interpolator(this.options);
                    s.utils = {
                        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
                    };
                    s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
                    s.backendConnector.on("*", function(event) {
                        var _this;
                        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                            args[_key - 1] = arguments[_key];
                        }
                        (_this = _this1).emit.apply(_this, [
                            event
                        ].concat(_to_consumable_array$1(args)));
                    });
                    if (this.modules.languageDetector) {
                        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                        if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
                    }
                    if (this.modules.i18nFormat) {
                        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                        if (s.i18nFormat.init) s.i18nFormat.init(this);
                    }
                    this.translator = new Translator(this.services, this.options);
                    this.translator.on("*", function(event) {
                        var _this;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++){
                            args[_key2 - 1] = arguments[_key2];
                        }
                        (_this = _this1).emit.apply(_this, [
                            event
                        ].concat(_to_consumable_array$1(args)));
                    });
                    this.modules.external.forEach(function(m) {
                        if (m.init) m.init(_this);
                    });
                }
                this.format = this.options.interpolation.format;
                if (!callback) callback = noop;
                if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
                    var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                    if (codes.length > 0 && codes[0] !== "dev") this.options.lng = codes[0];
                }
                if (!this.services.languageDetector && !this.options.lng) {
                    this.logger.warn("init: no languageDetector is used and no lng is defined");
                }
                var storeApi = [
                    "getResource",
                    "hasResourceBundle",
                    "getResourceBundle",
                    "getDataByLanguage"
                ];
                storeApi.forEach(function(fcName) {
                    _this[fcName] = function() {
                        var _this_store;
                        return (_this_store = _this1.store)[fcName].apply(_this_store, arguments);
                    };
                });
                var storeApiChained = [
                    "addResource",
                    "addResources",
                    "addResourceBundle",
                    "removeResourceBundle"
                ];
                storeApiChained.forEach(function(fcName) {
                    _this[fcName] = function() {
                        var _this_store;
                        (_this_store = _this1.store)[fcName].apply(_this_store, arguments);
                        return _this1;
                    };
                });
                var deferred = defer();
                var load = function() {
                    var finish = function(err, t) {
                        _this.isInitializing = false;
                        if (_this.isInitialized && !_this.initializedStoreOnce) _this.logger.warn("init: i18next is already initialized. You should call init just once!");
                        _this.isInitialized = true;
                        if (!_this.options.isClone) _this.logger.log("initialized", _this.options);
                        _this.emit("initialized", _this.options);
                        deferred.resolve(t);
                        callback(err, t);
                    };
                    if (_this.languages && !_this.isInitialized) return finish(null, _this.t.bind(_this));
                    _this.changeLanguage(_this.options.lng, finish);
                };
                if (this.options.resources || !this.options.initAsync) {
                    load();
                } else {
                    setTimeout(load, 0);
                }
                return deferred;
            }
        },
        {
            key: "loadResources",
            value: function loadResources(language) {
                var _this = this;
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
                var usedCallback = callback;
                var usedLng = isString(language) ? language : this.language;
                if (typeof language === "function") usedCallback = language;
                if (!this.options.resources || this.options.partialBundledLanguages) {
                    var _this_options_preload_forEach, _this_options_preload;
                    if ((usedLng === null || usedLng === void 0 ? void 0 : usedLng.toLowerCase()) === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
                    var toLoad = [];
                    var append = function(lng) {
                        if (!lng) return;
                        if (lng === "cimode") return;
                        var lngs = _this.services.languageUtils.toResolveHierarchy(lng);
                        lngs.forEach(function(l) {
                            if (l === "cimode") return;
                            if (toLoad.indexOf(l) < 0) toLoad.push(l);
                        });
                    };
                    if (!usedLng) {
                        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                        fallbacks.forEach(function(l) {
                            return append(l);
                        });
                    } else {
                        append(usedLng);
                    }
                    (_this_options_preload = this.options.preload) === null || _this_options_preload === void 0 ? void 0 : (_this_options_preload_forEach = _this_options_preload.forEach) === null || _this_options_preload_forEach === void 0 ? void 0 : _this_options_preload_forEach.call(_this_options_preload, function(l) {
                        return append(l);
                    });
                    this.services.backendConnector.load(toLoad, this.options.ns, function(e) {
                        if (!e && !_this.resolvedLanguage && _this.language) _this.setResolvedLanguage(_this.language);
                        usedCallback(e);
                    });
                } else {
                    usedCallback(null);
                }
            }
        },
        {
            key: "reloadResources",
            value: function reloadResources(lngs, ns, callback) {
                var deferred = defer();
                if (typeof lngs === "function") {
                    callback = lngs;
                    lngs = undefined;
                }
                if (typeof ns === "function") {
                    callback = ns;
                    ns = undefined;
                }
                if (!lngs) lngs = this.languages;
                if (!ns) ns = this.options.ns;
                if (!callback) callback = noop;
                this.services.backendConnector.reload(lngs, ns, function(err) {
                    deferred.resolve();
                    callback(err);
                });
                return deferred;
            }
        },
        {
            key: "use",
            value: function use(module) {
                if (!module) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
                if (!module.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
                if (module.type === "backend") {
                    this.modules.backend = module;
                }
                if (module.type === "logger" || module.log && module.warn && module.error) {
                    this.modules.logger = module;
                }
                if (module.type === "languageDetector") {
                    this.modules.languageDetector = module;
                }
                if (module.type === "i18nFormat") {
                    this.modules.i18nFormat = module;
                }
                if (module.type === "postProcessor") {
                    postProcessor.addPostProcessor(module);
                }
                if (module.type === "formatter") {
                    this.modules.formatter = module;
                }
                if (module.type === "3rdParty") {
                    this.modules.external.push(module);
                }
                return this;
            }
        },
        {
            key: "setResolvedLanguage",
            value: function setResolvedLanguage(l) {
                if (!l || !this.languages) return;
                if ([
                    "cimode",
                    "dev"
                ].indexOf(l) > -1) return;
                for(var li = 0; li < this.languages.length; li++){
                    var lngInLngs = this.languages[li];
                    if ([
                        "cimode",
                        "dev"
                    ].indexOf(lngInLngs) > -1) continue;
                    if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                        this.resolvedLanguage = lngInLngs;
                        break;
                    }
                }
            }
        },
        {
            key: "changeLanguage",
            value: function changeLanguage(lng, callback) {
                var _this = this;
                var _this2 = this;
                this.isLanguageChangingTo = lng;
                var deferred = defer();
                this.emit("languageChanging", lng);
                var setLngProps = function(l) {
                    _this.language = l;
                    _this.languages = _this.services.languageUtils.toResolveHierarchy(l);
                    _this.resolvedLanguage = undefined;
                    _this.setResolvedLanguage(l);
                };
                var done = function(err, l) {
                    if (l) {
                        setLngProps(l);
                        _this.translator.changeLanguage(l);
                        _this.isLanguageChangingTo = undefined;
                        _this.emit("languageChanged", l);
                        _this.logger.log("languageChanged", l);
                    } else {
                        _this.isLanguageChangingTo = undefined;
                    }
                    deferred.resolve(function() {
                        var _this21;
                        return (_this21 = _this2).t.apply(_this21, arguments);
                    });
                    if (callback) callback(err, function() {
                        var _this21;
                        return (_this21 = _this2).t.apply(_this21, arguments);
                    });
                };
                var setLng = function(lngs) {
                    if (!lng && !lngs && _this.services.languageDetector) lngs = [];
                    var l = isString(lngs) ? lngs : _this.services.languageUtils.getBestMatchFromCodes(lngs);
                    if (l) {
                        var _this_services_languageDetector_cacheUserLanguage, _this_services_languageDetector;
                        if (!_this.language) {
                            setLngProps(l);
                        }
                        if (!_this.translator.language) _this.translator.changeLanguage(l);
                        (_this_services_languageDetector = _this.services.languageDetector) === null || _this_services_languageDetector === void 0 ? void 0 : (_this_services_languageDetector_cacheUserLanguage = _this_services_languageDetector.cacheUserLanguage) === null || _this_services_languageDetector_cacheUserLanguage === void 0 ? void 0 : _this_services_languageDetector_cacheUserLanguage.call(_this_services_languageDetector, l);
                    }
                    _this.loadResources(l, function(err) {
                        done(err, l);
                    });
                };
                if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
                    setLng(this.services.languageDetector.detect());
                } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
                    if (this.services.languageDetector.detect.length === 0) {
                        this.services.languageDetector.detect().then(setLng);
                    } else {
                        this.services.languageDetector.detect(setLng);
                    }
                } else {
                    setLng(lng);
                }
                return deferred;
            }
        },
        {
            key: "getFixedT",
            value: function getFixedT(lng, ns, keyPrefix) {
                var _this3 = this;
                var fixedT = function fixedT1(key, opts) {
                    var options;
                    if (typeof opts !== "object") {
                        for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++){
                            rest[_key3 - 2] = arguments[_key3];
                        }
                        options = _this3.options.overloadTranslationOptionHandler([
                            key,
                            opts
                        ].concat(rest));
                    } else {
                        options = _object_spread$4({}, opts);
                    }
                    options.lng = options.lng || fixedT.lng;
                    options.lngs = options.lngs || fixedT.lngs;
                    options.ns = options.ns || fixedT.ns;
                    if (options.keyPrefix !== "") options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
                    var keySeparator = _this3.options.keySeparator || ".";
                    var resultKey;
                    if (options.keyPrefix && Array.isArray(key)) {
                        resultKey = key.map(function(k) {
                            return "".concat(options.keyPrefix).concat(keySeparator).concat(k);
                        });
                    } else {
                        resultKey = options.keyPrefix ? "".concat(options.keyPrefix).concat(keySeparator).concat(key) : key;
                    }
                    return _this3.t(resultKey, options);
                };
                if (isString(lng)) {
                    fixedT.lng = lng;
                } else {
                    fixedT.lngs = lng;
                }
                fixedT.ns = ns;
                fixedT.keyPrefix = keyPrefix;
                return fixedT;
            }
        },
        {
            key: "t",
            value: function t() {
                var _this_translator;
                var _this_translator1;
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++){
                    args[_key4] = arguments[_key4];
                }
                return (_this_translator1 = this.translator) === null || _this_translator1 === void 0 ? void 0 : (_this_translator = _this_translator1).translate.apply(_this_translator, _to_consumable_array$1(args));
            }
        },
        {
            key: "exists",
            value: function exists() {
                var _this_translator;
                var _this_translator1;
                for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++){
                    args[_key5] = arguments[_key5];
                }
                return (_this_translator1 = this.translator) === null || _this_translator1 === void 0 ? void 0 : (_this_translator = _this_translator1).exists.apply(_this_translator, _to_consumable_array$1(args));
            }
        },
        {
            key: "setDefaultNamespace",
            value: function setDefaultNamespace(ns) {
                this.options.defaultNS = ns;
            }
        },
        {
            key: "hasLoadedNamespace",
            value: function hasLoadedNamespace(ns) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (!this.isInitialized) {
                    this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages);
                    return false;
                }
                if (!this.languages || !this.languages.length) {
                    this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages);
                    return false;
                }
                var lng = options.lng || this.resolvedLanguage || this.languages[0];
                var fallbackLng = this.options ? this.options.fallbackLng : false;
                var lastLng = this.languages[this.languages.length - 1];
                if (lng.toLowerCase() === "cimode") return true;
                var loadNotPending = function(l, n) {
                    var loadState = _this.services.backendConnector.state["".concat(l, "|").concat(n)];
                    return loadState === -1 || loadState === 0 || loadState === 2;
                };
                if (options.precheck) {
                    var preResult = options.precheck(this, loadNotPending);
                    if (preResult !== undefined) return preResult;
                }
                if (this.hasResourceBundle(lng, ns)) return true;
                if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
                if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
                return false;
            }
        },
        {
            key: "loadNamespaces",
            value: function loadNamespaces(ns, callback) {
                var _this = this;
                var deferred = defer();
                if (!this.options.ns) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                if (isString(ns)) ns = [
                    ns
                ];
                ns.forEach(function(n) {
                    if (_this.options.ns.indexOf(n) < 0) _this.options.ns.push(n);
                });
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "loadLanguages",
            value: function loadLanguages(lngs, callback) {
                var _this = this;
                var deferred = defer();
                if (isString(lngs)) lngs = [
                    lngs
                ];
                var preloaded = this.options.preload || [];
                var newLngs = lngs.filter(function(lng) {
                    return preloaded.indexOf(lng) < 0 && _this.services.languageUtils.isSupportedCode(lng);
                });
                if (!newLngs.length) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                this.options.preload = preloaded.concat(newLngs);
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "dir",
            value: function dir(lng) {
                var _this_languages, _this_services;
                if (!lng) lng = this.resolvedLanguage || (((_this_languages = this.languages) === null || _this_languages === void 0 ? void 0 : _this_languages.length) > 0 ? this.languages[0] : this.language);
                if (!lng) return "rtl";
                var rtlLngs = [
                    "ar",
                    "shu",
                    "sqr",
                    "ssh",
                    "xaa",
                    "yhd",
                    "yud",
                    "aao",
                    "abh",
                    "abv",
                    "acm",
                    "acq",
                    "acw",
                    "acx",
                    "acy",
                    "adf",
                    "ads",
                    "aeb",
                    "aec",
                    "afb",
                    "ajp",
                    "apc",
                    "apd",
                    "arb",
                    "arq",
                    "ars",
                    "ary",
                    "arz",
                    "auz",
                    "avl",
                    "ayh",
                    "ayl",
                    "ayn",
                    "ayp",
                    "bbz",
                    "pga",
                    "he",
                    "iw",
                    "ps",
                    "pbt",
                    "pbu",
                    "pst",
                    "prp",
                    "prd",
                    "ug",
                    "ur",
                    "ydd",
                    "yds",
                    "yih",
                    "ji",
                    "yi",
                    "hbo",
                    "men",
                    "xmn",
                    "fa",
                    "jpr",
                    "peo",
                    "pes",
                    "prs",
                    "dv",
                    "sam",
                    "ckb"
                ];
                var languageUtils = ((_this_services = this.services) === null || _this_services === void 0 ? void 0 : _this_services.languageUtils) || new LanguageUtil(get());
                return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
            }
        },
        {
            key: "cloneInstance",
            value: function cloneInstance() {
                var _this = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
                var forkResourceStore = options.forkResourceStore;
                if (forkResourceStore) delete options.forkResourceStore;
                var mergedOptions = _object_spread$4({}, this.options, options, {
                    isClone: true
                });
                var clone = new I18n(mergedOptions);
                if (options.debug !== undefined || options.prefix !== undefined) {
                    clone.logger = clone.logger.clone(options);
                }
                var membersToCopy = [
                    "store",
                    "services",
                    "language"
                ];
                membersToCopy.forEach(function(m) {
                    clone[m] = _this[m];
                });
                clone.services = _object_spread$4({}, this.services);
                clone.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                if (forkResourceStore) {
                    clone.store = new ResourceStore(this.store.data, mergedOptions);
                    clone.services.resourceStore = clone.store;
                }
                clone.translator = new Translator(clone.services, mergedOptions);
                clone.translator.on("*", function(event) {
                    var _clone;
                    for(var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++){
                        args[_key6 - 1] = arguments[_key6];
                    }
                    (_clone = clone).emit.apply(_clone, [
                        event
                    ].concat(_to_consumable_array$1(args)));
                });
                clone.init(mergedOptions, callback);
                clone.translator.options = mergedOptions;
                clone.translator.backendConnector.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                return clone;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    options: this.options,
                    store: this.store,
                    language: this.language,
                    languages: this.languages,
                    resolvedLanguage: this.resolvedLanguage
                };
            }
        }
    ], [
        {
            key: "createInstance",
            value: function createInstance() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 ? arguments[1] : undefined;
                return new I18n(options, callback);
            }
        }
    ]);
    return I18n;
}(EventEmitter);
var instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;
instance.createInstance;
instance.dir;
instance.init;
instance.loadResources;
instance.reloadResources;
instance.use;
instance.changeLanguage;
instance.getFixedT;
instance.t;
instance.exists;
instance.setDefaultNamespace;
instance.hasLoadedNamespace;
instance.loadNamespaces;
instance.loadLanguages;

var matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var htmlEntities = {
    "&amp;": "&",
    "&#38;": "&",
    "&lt;": "<",
    "&#60;": "<",
    "&gt;": ">",
    "&#62;": ">",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#34;": '"',
    "&nbsp;": " ",
    "&#160;": " ",
    "&copy;": "\xa9",
    "&#169;": "\xa9",
    "&reg;": "\xae",
    "&#174;": "\xae",
    "&hellip;": "…",
    "&#8230;": "…",
    "&#x2F;": "/",
    "&#47;": "/"
};
var unescapeHtmlEntity = function(m) {
    return htmlEntities[m];
};
var unescape$1 = function(text) {
    return text.replace(matchHtmlEntity, unescapeHtmlEntity);
};

function _define_property$3(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$3(target, key, source[key]);
        });
    }
    return target;
}
var defaultOptions = {
    bindI18n: "languageChanged",
    bindI18nStore: "",
    transEmptyNodeValue: "",
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: "",
    transKeepBasicHtmlNodesFor: [
        "br",
        "strong",
        "i",
        "p"
    ],
    useSuspense: true,
    unescape: unescape$1
};
var setDefaults = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    defaultOptions = _object_spread$3({}, defaultOptions, options);
};

var initReactI18next = {
    type: "3rdParty",
    init: function init(instance) {
        setDefaults(instance.options.react);
    }
};

var workdaySkillRemoved_Message$1 = "{{ skillName }} has been removed from your profile.";
var workdaySkillRemoved_Plural$1 = "Skills from Workday have been updated: \n{{ skillsRemovedHtml }}\n{{ viewSkillHtml }}";
var workdaySkillRemoved_Single$1 = "Skills from Workday have been updated: {{ skillName }} has been removed from your profile.\n{{ viewSkillHtml }}";
var workdaySkillAdded_Plural$1 = "Your Workday synced skills have been updated.  {{ number }} Skills have been synced to your profile.\n{{ viewSkillsHtml }}";
var workdaySkillAdded_Single$1 = "Your Workday synced skills have been updated.  {{ skillName }} has been synced to your profile.\n{{ viewSkillHtml }}";
var workdaySkillAdded_WorkdayIntegrationDisabled$1 = "Workday skills integration has been deactivated. Your Workday skills will no longer synchronize with your Degreed Profile.\n{{ viewSkillsHtml }}";
var workdaySkillAdded_WorkdayIntegrationEnabled$1 = "Workday skills integration has been activated, connecting and synchronizing the skills on your Workday profile to your profile in Degreed.\n{{ viewSkillsHtml }}";
var Webhooks_ActivityDownload$1 = "Download Activity Log";
var Webhooks_ActivityDownloadConfirmation$1 = "This Log will contain data from [Month/Day/Year] to [Month/Day/Year]. Please update your date filter if you want to receive data from a different date range.";
var Webhooks_ActivityDownloadLogBtn$1 = "Download Log";
var Webhooks_ActivityDownloadSuccessfully$1 = "Activity Log downloaded successfully!";
var Webhooks_ActivityFilterCheckbox$1 = "Sent/Received,\nRetry 1,\nRetry 2,\nRetry 3,\nFailed,\nTest Message";
var Webhooks_ActivityLog$1 = "Activity Log";
var Webhooks_ActivityLogDescription$1 = "Short description goes here Lorem ipsum dolor sit amet consectetur.";
var Webhooks_ActivityLogErrorOrgid$1 = "Error getting activity logs by org id";
var Webhooks_ActivityLogEventType$1 = "Event Type";
var Webhooks_ActivityLogFailed$1 = "Failed to copy to clipboard.";
var Webhooks_ActivityLogInvalid$1 = "Invalid JSON payload.";
var Webhooks_ActivityLogNoLogs$1 = "No activity logs found";
var Webhooks_ActivityLogRefresh$1 = "Refresh Log";
var Webhooks_ActivityLogResponseCode$1 = "Response Code";
var Webhooks_ActivityLogResponseTime$1 = "Response Time";
var Webhooks_ActivityLogRetries$1 = "RETRIES";
var Webhooks_ActivityLogRetryCopyPaylod$1 = "Copy Payload";
var Webhooks_ActivityLogTimestamp$1 = "Time stamp";
var Webhooks_ActivityLogTry$1 = "Try adjusting the filters or check back later.";
var Webhooks_ActivityLogView$1 = "View Activity";
var Webhooks_ActivityRetriesQueue$1 = "Retries Queue";
var Webhooks_ActivityViewLog$1 = "View Activity Logs";
var Webhooks_AddWebhook$1 = "Add Webhook";
var Webhooks_AuthorizationType$1 = "AUTHORIZATION TYPE";
var Webhooks_AvgLatency$1 = "Average Latency";
var Webhooks_AvgTime$1 = "Average Time to Response";
var Webhooks_CreateWebhook$1 = "Create Webhook";
var Webhooks_DeleteSuccessfully$1 = "Success! Your webhook has been deleted";
var Webhooks_DeleteWebhook$1 = "Delete Webhook";
var Webhooks_DeleteWebhookConfirmationMessage$1 = 'Are you sure you want to delete this webhook subscription? This action is permanent and cannot be undone. \u2028\u2028Consider setting this webhook subscription to "paused" if you want to be able to restart it.';
var Webhooks_DeleteWebhookConfirmationPrimaryBtn$1 = "Delete";
var Webhooks_DeleteWebhookConfirmationSecondaryBtn$1 = "Cancel";
var Webhooks_DescriptionAddWebhook$1 = "There is nothing here yet";
var Webhooks_EndpointUrl$1 = "Endpoint URL";
var Webhooks_ErrorCreatingOrUpdatingWebhook$1 = "Please fill in all required fields";
var Webhooks_Events_LearningProgressEvent$1 = "Learning Progress Updated";
var Webhooks_Events_LearningProgressEvent_Description$1 = "When progress is made on a resource. Resources include: All content types (videos, Books, Courses, Events, etc.), Skill Plans, Pathways, Plans, Academies, etc.";
var Webhooks_Events_PathwayCompletedEvent$1 = "Pathway Completed";
var Webhooks_Events_PathwayCompletedEvent_Description$1 = "This event is logged anytime a followed pathway is completed.";
var Webhooks_Events_PathwayCreatedEvent$1 = "Pathway Created";
var Webhooks_Events_PathwayCreatedEvent_Description$1 = "This event is logged anytime a pathway is created.";
var Webhooks_Events_PathwayEnrolledEvent$1 = "Pathway Followed";
var Webhooks_Events_PathwayEnrolledEvent_Description$1 = "This event is logged anytime a pathway is followed.";
var Webhooks_Events_PathwayUnenrolledEvent$1 = "Pathway Unfollowed";
var Webhooks_Events_PathwayUnenrolledEvent_Description$1 = "This event is logged anytime a pathway is unfollowed.";
var Webhooks_Events_PathwayUpdatedEvent$1 = "Pathway Updated";
var Webhooks_Events_PathwayUpdatedEvent_Description$1 = "This event is logged anytime a Pathway is updated.";
var Webhooks_Events_PathwayViewedEvent$1 = "Pathway Viewed";
var Webhooks_Events_PathwayViewedEvent_Description$1 = "This event is logged anytime a pathway is viewed within the UI. If the user refreshes the page, then the Pathway Viewed event will be logged an additional time.";
var Webhooks_Events_QueueItemCreatedEvent$1 = "Item Saved";
var Webhooks_Events_QueueItemCreatedEvent_Description$1 = "This event is logged anytime a resource is saved to the “saved-for-later” item queue. Resources include: All Content Types (videos, Books, Courses, Events, etc.), Skill Plans, Pathways, Events, Badges, Position, Degree Assessment, Pathway Certificate, Award, Accomplishment, Skill Episode/Podcast, Group, User, Tag, Target, Task, Input, Free-Form Text, Link Text, Post, Opportunity, Section, Academy, etc.";
var Webhooks_Events_QueueItemRemovedEvent$1 = "Saved Item Removed";
var Webhooks_Events_QueueItemRemovedEvent_Description$1 = "This event is logged anytime a resource is removed from the saved-for-later items. Resources include: All Content Types (videos, Books, Courses, Events, etc.), Skill Plans, Pathways, Events, Badges, Position, Degree Assessment, Pathway Certificate, Award, Accomplishment, Skill Episode/Podcast, Group, User, Tag, Target, Task, Input, Free-Form Text, Link Text, Post, Opportunity, Section, Academy, etc.";
var Webhooks_Events_RecommendationCreatedEvent$1 = "Item Recommended";
var Webhooks_Events_RecommendationCreatedEvent_Description$1 = "This event is logged anytime a resource is recommended. Resources include: All Content Types (videos, Books, Courses, Events, etc.), Skill Plans, Pathways, Events, Badges, Position, Degree Assessment, Pathway Certificate, Award, Accomplishment, Skill Episode/Podcast, Group, User, Tag, Target, Task, Input, Free-Form Text, Link Text, Post, Opportunity, Section, Academy, etc.";
var Webhooks_Events_TargetCreatedEvent$1 = "Plan or Directory Created";
var Webhooks_Events_TargetCreatedEvent_Description$1 = "This event is logged anytime a plan or directory is created.";
var Webhooks_Events_TargetDeletedEvent$1 = "Plan or Directory Deleted";
var Webhooks_Events_TargetDeletedEvent_Description$1 = "This event is logged anytime a plan or directory is deleted";
var Webhooks_Events_TargetFollowedEvent$1 = "User Followed Plan or Directory";
var Webhooks_Events_TargetFollowedEvent_Description$1 = "This event is logged anytime a plan or directory is followed.";
var Webhooks_Events_TargetUnfollowedEvent$1 = "Plan or Directory Unfollowed";
var Webhooks_Events_TargetUnfollowedEvent_Description$1 = "This event is logged anytime a plan or directory is unfollowed.";
var Webhooks_Events_UserCommentAddedEvent$1 = "Comment Added";
var Webhooks_Events_UserCommentAddedEvent_Description$1 = "This event is logged anytime a comment is made.";
var Webhooks_Events_UserCommentDeletedEvent$1 = "Comment Deleted";
var Webhooks_Events_UserCommentDeletedEvent_Description$1 = "This event is logged anytime a comment is removed/deleted.";
var Webhooks_Events_UserCreatedGroupEvent$1 = "Group Created";
var Webhooks_Events_UserCreatedGroupEvent_Description$1 = "This event is logged anytime a group is created.";
var Webhooks_Events_UserDeletedGroupEvent$1 = "User Removed From Group";
var Webhooks_Events_UserDeletedGroupEvent_Description$1 = "This event is logged anytime a user is removed from a group.";
var Webhooks_Events_UserFollowedEvent$1 = "User Followed";
var Webhooks_Events_UserFollowedEvent_Description$1 = "This event is logged anytime a user is followed.";
var Webhooks_Events_UserInputCreatedEvent$1 = "Completion Added";
var Webhooks_Events_UserInputCreatedEvent_Description$1 = "This event is logged anytime content is completed (i.e. article, course, book, video, event, task, episode/podcast, etc.). These completions can occur via the UI, V2 API, and integrations.";
var Webhooks_Events_UserInputViewedEvent$1 = "Content Viewed";
var Webhooks_Events_UserInputViewedEvent_Description$1 = "This event is logged anytime a piece of content is viewed. This includes when a content card is selected, or a link is used to navigate directly to the content page within the Degreed UI (i.e. article, course, book, video, event, task, episode/podcast, etc.).";
var Webhooks_Events_UserInterestAddedEvent$1 = "Skill Added to User";
var Webhooks_Events_UserInterestAddedEvent_Description$1 = "This event is logged anytime a skill is added to a user.";
var Webhooks_Events_UserInterestRemovedEvent$1 = "Skill Removed from User";
var Webhooks_Events_UserInterestRemovedEvent_Description$1 = "This event is logged anytime a skill is removed from a user.";
var Webhooks_Events_UserInvitedToGroupEvent$1 = "User Invited to Group";
var Webhooks_Events_UserInvitedToGroupEvent_Description$1 = "This event is logged anytime a user is invited to join a group.";
var Webhooks_Events_UserJoinedGroupEvent$1 = "User Joined a Group";
var Webhooks_Events_UserJoinedGroupEvent_Description$1 = "This event is logged anytime a user joins a group.";
var Webhooks_Events_UserLeftGroupEvent$1 = "User Left Group";
var Webhooks_Events_UserLeftGroupEvent_Description$1 = "This event is logged anytime a user leaves a group.";
var Webhooks_Events_UserLoginEvent$1 = "User Logged In";
var Webhooks_Events_UserLoginEvent_Description$1 = "This event is logged anytime a user logs in.";
var Webhooks_Events_UserResourceDeletedEvent$1 = "Completion Removed";
var Webhooks_Events_UserResourceDeletedEvent_Description$1 = "This event is logged anytime a resource is deleted, or marked incomplete. These events can occur via the UI, V2 API, and integrations. Resources include: All Content Types (videos, Books, Courses, Events, etc.), Skill Plans, Pathways, Events, Badges, Position, Degree Assessment, Pathway Certificate, Award, Accomplishment, Skill Episode/Podcast, Group, User, Tag, Target, Task, Input, Free-Form Text, Link Text, Post, Opportunity, Section, Academy, etc.";
var Webhooks_Events_UserResourceRatingEvent$1 = "Content Liked";
var Webhooks_Events_UserResourceRatingEvent_Description$1 = "This event is logged anytime a resource is liked (thumbs up).";
var Webhooks_Events_UserTagRatingCompletedEvent$1 = "Skill Rating Created";
var Webhooks_Events_UserTagRatingCompletedEvent_Description$1 = "When a user rates a user skill, either for themselves or as a manager.";
var Webhooks_EventsSelected$1 = "Events Selected";
var Webhooks_EventType$1 = "Event by Type";
var Webhooks_EventTypesColumn$1 = "Description";
var Webhooks_Get$1 = "Get started by adding a webhook";
var Webhooks_Heading$1 = "Webhooks";
var Webhooks_HeadingManage$1 = "Manage Webhooks";
var Webhooks_HeadingNew$1 = "New Webhook";
var Webhooks_HMAC$1 = "HMAC";
var Webhooks_HMACSecret$1 = "HMAC Secret";
var Webhooks_HMACSecretEncrypted$1 = "This can also be known as the signing key and will be encrypted with SHA-256";
var Webhooks_HMACSignatureHeader$1 = "Signature Header";
var Webhooks_HMACSignatureHeaderEncrypted$1 = "The Signature Header will be encrypted with SHA-256 in Base 64";
var Webhooks_ID$1 = "Webhook Id";
var Webhooks_NoWebhook$1 = "Get started by adding a webhook";
var Webhooks_OAuth2$1 = "OAuth 2";
var Webhooks_OAuthClientUrl$1 = "Client URL";
var Webhooks_On$1 = "On";
var Webhooks_Paused$1 = "Paused";
var Webhooks_Payload$1 = "Payloads";
var Webhooks_PayloadsSent$1 = "Payloads Sent";
var Webhooks_PayloadType$1 = "PAYLOAD TYPE";
var Webhooks_Security$1 = "Security";
var Webhooks_Status_Failure$1 = "Failure";
var Webhooks_Status_Retry$1 = "Retry 1";
var Webhooks_Status_Retry2$1 = "Retry 2";
var Webhooks_Status_Retry3$1 = "Retry 3";
var Webhooks_Status_Success$1 = "Success";
var Webhooks_Status_WebhookCreated$1 = "Webhook Created";
var Webhooks_Stopped$1 = "Stopped";
var Webhooks_Test$1 = "Testing Webhook";
var Webhooks_TestDescription$1 = "We are sending your endpoint a test message";
var Webhooks_WebhookCreatedSuccessfully$1 = "Success! Your webhook has been created";
var Webhooks_WebhookName$1 = "Webhook Name";
var Webhooks_WebhookUpdatedSuccessfully$1 = "Webhook updated successfully";
var verificationModal_ImageAlt$1 = "Example photo of a woman holding her ID";
var verificationModal_Instructions$1 = "Upload a photo of yourself holding a government issued photo ID such as a driver's license, identity card, or passport. Make sure your ID is readable in the photo. If you do not have a photo ID matching your preferred name or have questions, please email {{startAnchor}}support@degreed.com{{endAnchor}}.";
var verificationModal_ProvidePhoto$1 = "Upload a file";
var verificationModal_RequiredPhoto$1 = "A photo of yourself holding an ID card is required";
var verificationModal_Submit$1 = "Add Photo ID";
var verificationForm_AuthInstructions$1 = "To continue please log in to your existing Degreed account or choose a password to create a new degreed account.";
var verificationForm_AuthLoginLink$1 = "Log in to your Degreed account";
var verificationForm_AuthPasswordLabel$1 = "Choose password to create a new account";
var verificationForm_AuthTitle$1 = "Degreed account";
var verificationForm_Change$1 = "Change";
var verificationForm_EmailLabel$1 = "Email address";
var verificationForm_ErrorGettingForm$1 = "There was a problem loading your information";
var verificationForm_ErrorSavingForm$1 = "There was a problem saving your information";
var verificationForm_FirstNameLabel$1 = "First Name";
var verificationForm_LastNameLabel$1 = "Last Name";
var verificationForm_LinkedInLabel$1 = "LinkedIn URL";
var verificationForm_LinkedInPlaceholder$1 = "linkedin.com/in/username";
var verificationForm_Optional$1 = "(optional)";
var verificationForm_PhoneLabel$1 = "Phone number";
var verificationForm_PhonePlaceholder$1 = "xxx-xxx-xxxx";
var verificationForm_PhotoLabel$1 = "Photo ID";
var verificationForm_PhotoRequirements$1 = "Upload a photo of yourself holding an ID card. The ID card must be easily visible.";
var verificationForm_PhotoTileLabel$1 = "Your Photo ID";
var verificationForm_Submit$1 = "Save & Next";
var verificationForm_TwitterLabel$1 = "Twitter URL";
var verificationForm_TwitterPlaceholder$1 = "twitter.com/username";
var UserTaskSvc_Error$1 = "Sorry! There was a problem accessing your tasks.";
var UserTagRatingRequested_Complete_NotificationTitleFormat$1 = "You rated {{nameHtml}} in {{tag}}";
var UserTagRatingRequested_NotificationTitleFormat$1 = "{{nameHtml}} requested a {{ratingType}} from you in {{tag}}";
var UserTagRatingRequested_Self_CompleteNotificationTitleFormat$1 = "You rated yourself in {{tag}}";
var UserTagRatingRequested_Self_NotificationTitleFormat$1 = "{{nameHtml}} requested you to rate yourself in the skill {{tag}}";
var UserTagRatingCompleted_NotificationTitleFormat$1 = "{{nameHtml}} has rated you a level {{level}} in {{tag}}";
var UserStaticSettingsSvc_AssociatedPersonalEmail$1 = "Sorry! Your personal email can't be the same as an existing primary email in the system.";
var UserStaticSettingsSvc_DuplicateOrgEmail$1 = "Sorry! You can’t have the same email address for your primary and secondary email. Please update your secondary email before saving.";
var UserStaticSettingsSvc_DuplicateProfileName$1 = "Sorry! This Profile Name is taken.";
var UserStaticSettingsSvc_Failure$1 = "Sorry! We couldn’t update your profile settings.";
var UserStaticSettingsSvc_InvalidPersonalEmail$1 = "Sorry! Your secondary email is not valid. Please update your secondary email before saving.";
var UserStaticSettingsSvc_InvalidProfileName$1 = "Sorry! That Profile Name is not valid. Profile names must be unique, and special characters are not allowed (numbers or letters only).";
var UserStaticSettingsSvc_Success$1 = "Profile settings successfully updated.";
var UsersSvc_FindUsersError$1 = "Sorry! There was a problem finding people matching the name you entered.";
var UsersSvc_GetOpportunityPreferencesError$1 = "There was an error getting the opportunity preferences";
var UsersSvc_GetRecommendedError$1 = "Sorry! There was a problem getting shares.";
var UsersSvc_GetUserError$1 = "An error occurred retrieving user details.";
var UsersSvc_UpdateOpportunityPreferencesError$1 = "There was an error updating your opportunity preferences";
var UserSettingsSvc_CommunicationSettingsSaved$1 = "Your communication preferences have been saved";
var UserSettingsSvc_CommunicationSettingsSavedFailed$1 = "Sorry! There was a problem saving your notification preference.";
var UserSettingsSvc_DescAssignedLearning$1 = "Assigned Learning";
var UserSettingsSvc_DescAssignmentReminder$1 = "Assignment Reminder";
var UserSettingsSvc_DescEndorsementRequest$1 = "Skill Review Endorsement Requests";
var UserSettingsSvc_DescFollowers$1 = "New followers";
var UserSettingsSvc_DescFollowingActivity$1 = "New activity from those you follow";
var UserSettingsSvc_DescGoals$1 = "New and completed goals";
var UserSettingsSvc_DescGroupPostAdded$1 = "New group post";
var UserSettingsSvc_DescMention$1 = "Mention";
var UserSettingsSvc_DescNewComment$1 = "New comments";
var UserSettingsSvc_DescNewGoal$1 = "New goals";
var UserSettingsSvc_DescRecommendations$1 = "New shares";
var UserSettingsSvc_DescReplyComment$1 = "Reply";
var UserSettingsSvc_DescSocialNotify$1 = "New follower";
var UserSettingsSvc_DescTodaysLearning$1 = "A list of your Feed items";
var UserSettingsSvc_EmailAddressesError$1 = "An error occurred while retrieving your email addresses.";
var UserSettingsSvc_JobRoleSaveFailed$1 = "An error occurred storing your job role.";
var UserSettingsSvc_NotificationSettingsSaved$1 = "Your notification preference has been saved.";
var UserSettingsSvc_NotificationSettingsSavedFailed$1 = "Sorry! There was a problem saving your notification preference.";
var UserSettingsSvc_NotificationTestSendFailed$1 = "Sorry! There was a problem testing the notification.";
var UserSettingsSvc_NotificationTestSent$1 = "Notification test sent!";
var UserSettingsSvc_NotificationTypeDisplayText106$1 = "Stay up to date with these informative emails";
var UserSettingsSvc_NotificationTypeDisplayText34$1 = "Send me an email about each of the following events as they occur";
var UserSettingsSvc_NotificationTypeDisplayText35$1 = "Daily digest";
var UserSettingsSvc_NotificationTypeDisplayText37$1 = "Weekly digest";
var UserSettingsSvc_NotificationTypeDisplayText61$1 = "Occasional tips";
var UserSettingsSvc_NotificationTypeDisplayText77$1 = "Skills Checkup";
var UserSettingsSvc_PrivacySettingsSaved$1 = "Your privacy settings have been saved.";
var UserSettingsSvc_PrivacySettingsSaveFailed$1 = "Sorry! There was a problem saving your settings.";
var UserSettingsSvc_SettingsNotPublic$1 = "Profile Settings are not Public";
var UserSettingsSvc_TryLoggingIn$1 = "If you want to view this, try logging in";
var UserProfileSvc_ProblemAccessingCollection$1 = "Sorry! There was a problem accessing your profile collection.";
var UserProfileSvc_ProblemAccessingSignalSummary$1 = "Sorry! There was a problem accessing your skill signals";
var UserProfileSvc_ProblemDeletingCollectionItem$1 = "Sorry! There was a problem deleting from your collection.";
var UserProfileSvc_ProblemUpdatingCollectionItem$1 = "Sorry! There was a problem updating your collection";
var UserProfileSvc_ProblemUpdatingSkillCheckup$1 = "Sorry! There was a problem dismissing your Skill Checkup";
var UserPrivacyCtrl_Continue$1 = "Continue";
var UserPrivacyCtrl_Organization$1 = "Organization";
var UserPrivacyCtrl_PrivacyWarningHeader$1 = "Privacy warning";
var UserPrivacyCtrl_ToOrgProfileFormat$1 = "By changing your profile to 'Visible to my organization only', the following information will be available to {{OrgName}} users on this platform:<br/><br/><strong>Your name</strong>, <strong>your learning collection</strong> ({{OrgNameSingular}} members), <strong>your insights</strong> (including leader board information).<br/><br/>Non-{{OrgNameSingular}} users will not be able to follow you (i.e. be informed of your learning activity).";
var UserPrivacyCtrl_ToOrgProfileFromAnonymousFormat$1 = "By changing your profile to 'Visible to my organization only', the following information will be available to {{OrgName}} users on this platform:<br/><br/><strong>Your name</strong>, <strong>your learning collection</strong> ({{OrgName}} members), <strong>your insights</strong> (including leader board information).<br/><br/>Non-{{OrgName}} users will not be able to follow you (i.e. be informed of your learning activity), and your information will be visible in organization's reports.";
var UserPrivacyCtrl_ToPrivateProfile$1 = "By changing your profile to private, the following information will no longer be visible to all users on this platform:<br/><br/><strong>Your name</strong>, <strong>your learning collection</strong>, <strong>your insights</strong> (including leader board information).<br/><br/>Other users will no longer be able to follow you (i.e. be informed of your learning activity).";
var UserPrivacyCtrl_ToPrivateProfileInOrgFormat$1 = "By changing your profile to private, the following information will no longer be visible to public or {{OrgName}} users on this platform:<br/><br/><strong>Your name</strong>, <strong>your learning collection</strong> ({{OrgName}} content will not be visible to non-{{OrgNameSingular}} members), <strong>your insights</strong> (including leader board information).<br/><br/>Other users will no longer be able to follow you (i.e. be informed of your learning activity).";
var UserPrivacyCtrl_ToPrivateProfileInOrgFromAnonymousFormat$1 = "By changing your profile to private, the following information will no longer be visible to public or {{OrgName}} users on this platform:<br/><br/><strong>Your name</strong>, <strong>your learning collection</strong> ({{OrgName}} content will not be visible to non-{{OrgName}} members), <strong>your insights</strong> (including leader board information).<br/><br/>Other users will no longer be able to follow you (i.e. be informed of your learning activity), and your information will not be visible in organization's reports.";
var UserPrivacyCtrl_ToPublicProfile$1 = "By changing your profile to public, the following information will become visible to all users on this platform:<br><br><strong>Your name</strong>, <strong>your learning collection</strong>, <strong>your insights</strong> (including leader board information).<br><br>Other users will also be able to follow you (i.e. be informed of your learning activity).";
var UserPrivacyCtrl_ToPublicProfileInOrgFormat$1 = "By changing your profile to public, the following information will become visible to public (external to all {{OrgName}} users on this platform):<br/><br/><strong>Your name</strong>, <strong>your learning collection</strong> ({{OrgName}} content will not be visible to non-{{OrgNameSingular}} members), <strong>your insights</strong> (including leader board information).<br/><br/>Other public users will also be able to follow you (i.e. be informed of your learning activity).";
var UserPrivacyCtrl_ToPublicProfileInOrgFromAnonymousFormat$1 = "By changing your profile to public, the following information will become visible to public (external to all {{OrgName}} users on this platform):<br/><br/><strong>Your name</strong>, <strong>your learning collection</strong> ({{OrgName}} content will not be visible to non-{{OrgName}} members), <strong>your insights</strong> (including leader board information).<br/><br/>Other public users will also be able to follow you (i.e. be informed of your learning activity), and your information will be visible in organization's reports.";
var UserPrivacyCtrl_YourOrganization$1 = "Your organization";
var UserPositionSvc_ExperienceError$1 = "Sorry! There was a problem accessing your experience.";
var UserOutcomeSvc_AddingError$1 = "Sorry! There was a problem saving the form.";
var UserOutcomeSvc_RemovingError$1 = "Sorry! There was a problem deleting your content.";
var UserOutcomeSvc_RetreivingError$1 = "Sorry! There was a problem getting details.";
var UserOutcomeSvc_UpdatingError$1 = "Sorry! There was a problem saving your changes.";
var UserOutcomeSkillSvc_EightToTen$1 = "8-10 years";
var UserOutcomeSkillSvc_ElevenToFourteen$1 = "11-14 years";
var UserOutcomeSkillSvc_FifteenToTwenty$1 = "15-20 years";
var UserOutcomeSkillSvc_FiveToSeven$1 = "5-7 years";
var UserOutcomeSkillSvc_TwentyPlus$1 = "20+ years";
var UserOutcomeSkillSvc_TwoToFour$1 = "2-4 years";
var UserOutcomeSkillSvc_ZeroToOne$1 = "0-1 year";
var UserOutcomeDegreeSvc_AddingCoursesError$1 = "Sorry! There was a problem adding courses to your profile.";
var UserOutcomeDegreeSvc_Associates$1 = "Associates";
var UserOutcomeDegreeSvc_Bachelors$1 = "Bachelors";
var UserOutcomeDegreeSvc_Diploma$1 = "Diploma";
var UserOutcomeDegreeSvc_Doctorate$1 = "Doctorate";
var UserOutcomeDegreeSvc_Magister$1 = "Magister";
var UserOutcomeDegreeSvc_Masters$1 = "Masters";
var UserOutcomeDegreeSvc_PartialAssociates$1 = "Partial Associates";
var UserOutcomeDegreeSvc_PartialBachelors$1 = "Partial Bachelors";
var UserOutcomeDegreeSvc_PartialDoctorate$1 = "Partial Doctorate";
var UserOutcomeDegreeSvc_PartialMasters$1 = "Partial Masters";
var UserOutcomeDegreeSvc_PreDiploma$1 = "Pre-Diploma";
var UserOrganizationSvc_NotificationError$1 = "Sorry! There was a problem accessing organization information.";
var UserMediaSvc_MediaError$1 = "Sorry! There was a problem accessing your media.";
var UserInsightsSvc_ErrorLearningCounts$1 = "Sorry! There was a problem retrieving learning counts.";
var UserInsightsSvc_ErrorPersonalInfo$1 = "Sorry! There was a problem accessing the profile information.";
var UserInputsSvc_AccessProfileError$1 = "Sorry! There was a problem accessing the profile items.";
var UserInputsSvc_AddToProfileError$1 = "Sorry! There was a problem adding to your profile.";
var UserInputsSvc_DeleteFromProfileError$1 = "Sorry! There was a problem deleting from your profile.";
var UserInputsSvc_SuccessfulAddNotifyFormat$1 = "Congratulations on completing that {{input}}!";
var UserInputsSvc_UpdateProfileError$1 = "Sorry! There was a problem updating your profile.";
var UserInputProvidersSvc_ProfileProvidersError$1 = "Sorry! There was a problem accessing your profile providers.";
var UserInputProvidersSvc_ProviderLicensesError$1 = "Sorry! There was a problem accessing your provider licenses.";
var UserInfoPartial_BioModalTitle$1 = "{{name}} Bio";
var UserInfoPartial_ChangePrivacySettings$1 = "click to change privacy settings";
var UserInfoPartial_EditProfile$1 = "Settings";
var UserInfoPartial_FollowerCountFormat$1 = "{{followerCount}} Followers";
var UserInfoPartial_FollowFormat$1 = "Follow";
var UserInfoPartial_FollowingCountFormat$1 = "{{followeesCount}} Following";
var UserInfoPartial_FoundingScholar$1 = "Founding Scholar";
var UserInfoPartial_StopFollowingFormat$1 = "Stop following";
var UserInfoPartial_VisibleToMe$1 = "Visible to me only";
var UserInfoPartial_VisibleToOrg$1 = "Visible to the organization";
var UserInfoPartial_VisibleToPublic$1 = "Visible to the public";
var UserInfoPartial_VisibleToPublicAndOrg$1 = "Visible to the public and the organization";
var UserGroupsSvc_ProblemAccessingGroup$1 = "Sorry! There was a problem accessing groups.";
var UserEventSvc_EventError$1 = "Sorry! There was a problem accessing your events.";
var UserEpisodeSvc_EpisodeError$1 = "Sorry! There was a problem accessing your episodes.";
var UserEmailAddressesSvc_ErrorValidatingEmail$1 = "Sorry! There was a problem validating your email address.";
var UserCourseSvc_CourseError$1 = "Sorry! There was a problem accessing your courses.";
var UserController_Achievements$1 = "Achievements";
var UserController_AddEmailAddress$1 = "Add email address";
var UserController_AddingSecondEmail$1 = "Adding a second email helps protect your account and your points.";
var UserController_AddPersonalEmail$1 = "Add a personal email address";
var UserController_AddSkills$1 = "Add Skills";
var UserController_AddToCollectionDescription$1 = "The collection is used to collect all of your learning, experiences, achievements, pathways and plans.";
var UserController_AddToCollectionOther$1 = "No {{classifier}} in this collection";
var UserController_AddToCollectionSelf$1 = "Add {{classifier}} to your collection";
var UserController_BulkEdit$1 = "Bulk Edit";
var UserController_BulkEditSelectLabel$1 = "Select for bulk editing";
var UserController_CaptureLearningFormat$1 = "Capture all your learning - professional, informal, in the moment, and on the go - and get credit for it.";
var UserController_CategoryFilter$1 = "Category Filter";
var UserController_Collection$1 = "Collection";
var UserController_CollectionDescription$1 = "Here, you can find all your learning, experience, achievements, pathways and plans.";
var UserController_ConnectedEmail$1 = "Connected Email Accounts";
var UserController_ConsumerPrimaryEmailDesc$1 = "This is the email address which will be used for email notifications and login.";
var UserController_Content$1 = "Content";
var UserController_DashboardTitle$1 = "Feed";
var UserController_DegreedButton$1 = "Install the Degreed Button";
var UserController_DegreedGroups$1 = "a collaborative learning environment where employees and teams inspire, challenge, and help each other grow.";
var UserController_Delete$1 = "Delete";
var UserController_DeleteProfile$1 = "Are you sure you want to delete your Degreed profile?";
var UserController_EditCategories$1 = "Edit Skills";
var UserController_EmailAddress$1 = "Email Address";
var UserController_EmailAddressChangeInfo$1 = "To confirm email changes, follow the instructions sent to your primary email";
var UserController_EmailPreferences$1 = "Email Preferences";
var UserController_EmptyProfile$1 = "Profile Is Empty";
var UserController_EnterEmail$1 = "Enter an email address";
var UserController_FilterCollection$1 = "Filter Collection";
var UserController_FindLearning$1 = "Find Something to Learn";
var UserController_FollowersSubHeading$1 = "Followers:";
var UserController_FollowersTitle$1 = "Followers";
var UserController_FollowFormat$1 = "Follow learning activities for {{name}}";
var UserController_FollowingSubHeading$1 = "Following:";
var UserController_For$1 = "for";
var UserController_GoogleUsernamePlaceholder$1 = "Google+ username";
var UserController_GreetingFormat$1 = "Hello, {0}";
var UserController_GroupsTitle$1 = "Groups";
var UserController_In$1 = "in";
var UserController_Insights$1 = "Insights";
var UserController_InviteAll$1 = "Invite All";
var UserController_InviteFriends$1 = "Invite Friends";
var UserController_ItemsSelected$1 = "selected";
var UserController_JoinGroups$1 = "+ Join Groups";
var UserController_LastName$1 = "Last Name";
var UserController_Loading$1 = "Loading...";
var UserController_ManagedProfileMessageFormat$1 = "Your profile settings are being managed by {0}";
var UserController_NameTaken$1 = "Sorry, this name has been taken.";
var UserController_NameTakenError$1 = "Sorry, this name has been taken.";
var UserController_NoFriends$1 = "Don't see your friends?";
var UserController_NoLearningTracked$1 = "hasn't tracked any learning yet.";
var UserController_NoPersonalEmail$1 = "Oops, you haven't entered a personal email";
var UserController_NoResults$1 = "No Results Found";
var UserController_NoResultsFound$1 = "No results found.";
var UserController_NoSkills$1 = "hasn't added any skills or topics yet.";
var UserController_NothingCompleted$1 = "hasn't completed anything yet.";
var UserController_NotificationEmailInfoFormat$1 = "Email notifications will be sent to your {{orgName}} email address";
var UserController_NotificationSettings$1 = "Notification Settings";
var UserController_Opportunities$1 = "Opportunities";
var UserController_Overview$1 = "Overview";
var UserController_Pathways$1 = "Pathways";
var UserController_PersonalEmail$1 = "Personal Email";
var UserController_PersonalEmailEnableOptions$1 = "Providing a personal email address will enable the options below.";
var UserController_PersonalEmailError$1 = "Your personal email must be different from your organizational email";
var UserController_PersonalEmailOptions$1 = "Providing a personal email address will enable the options below.";
var UserController_PostAComment$1 = "Post a comment";
var UserController_PrimaryEmailDesc$1 = "This\xa0is\xa0your\xa0main\xa0address which\xa0will\xa0be\xa0used\xa0for\xa0email\xa0notifications.";
var UserController_PrivateProfile$1 = "This profile is not public.";
var UserController_PrivateProfileExplanation$1 = "If you think you should be able to view it, try logging in.";
var UserController_Profile$1 = "Overview";
var UserController_Progression$1 = "Progression";
var UserController_QueueTitle$1 = "Saved For Later";
var UserController_RecommendationsTitle$1 = "Shared";
var UserController_RequiredAssigned$1 = "Required & Assigned";
var UserController_RequiredAssignedCount$1 = "Required & Assigned ({{count}})";
var UserController_RequiredLearningTitle$1 = "Assigned";
var UserController_Saved$1 = "Saved";
var UserController_SaveSettingsErrorMessage$1 = "Whoops! Looks like that profile email address isn't valid. Please try again.";
var UserController_ScoreYourEducation$1 = "Score your lifelong education with degreed.";
var UserController_SecondaryEmailDesc$1 = "This is your backup address. It helps protect your account and points.";
var UserController_SelectAll$1 = "Select All";
var UserController_SelectLoginEmail$1 = "Select the address to login with and where you would like us to send email notifications.";
var UserController_ShortQueueTitle$1 = "Saved";
var UserController_ShowHowFarFormat$1 = "Show How Far You've Come";
var UserController_ShowLess$1 = "Show Less";
var UserController_ShowMore$1 = "Show More";
var UserController_Skills$1 = "Skills";
var UserController_StepFour$1 = "Step 4:";
var UserController_StepOne$1 = "Step 1:";
var UserController_StepThree$1 = "Step 3:";
var UserController_StepTwo$1 = "Step 2:";
var UserController_StopFollowingFormat$1 = "Stop following learning activities for {{name}}";
var UserController_ThisUserPrivate$1 = "This profile is private";
var UserController_TodaysLearningFeedTitle$1 = "Feed";
var UserController_TodaysLearningTitle$1 = "Feed";
var UserController_TrackLearningAltTag$1 = "Find, track, and measure ALL your learning";
var UserController_TryHere$1 = "Try Here";
var UserController_TurnOnIntegration$1 = "Turn on your first Integration";
var UserController_TwitterUsername$1 = "Twitter username";
var UserController_Type$1 = "Type";
var UserController_Unsubscribe$1 = "Unsubscribe";
var UserController_UnsubscribeWarning$1 = "If you choose to unsubscribe, <strong>all</strong> Degreed emails will be unavailable to you (including those your company may ask to be sent, account confirmation requests, and reset password instructions). This cannot be reversed without contacting Degreed directly.";
var UserController_UnsubTitle$1 = "Unsubscribed";
var UserController_UpdateAccount$1 = "Update your Account";
var UserController_Verified$1 = "Verified";
var UserController_Verify$1 = "Verify";
var UserController_VerifyOwnership$1 = "Verify your ownership of this address by receiving a verification email";
var UserBookSvc_BookAccessError$1 = "Sorry! There was a problem accessing your books.";
var UserBookSvc_BookAddError$1 = "Sorry! There was a problem adding this book.";
var UserBookSvc_BookUpdateError$1 = "Sorry! There was a problem updating this book.";
var UserAssessmentSvc_AssessmentsError$1 = "Sorry! There was a problem accessing your assessments.";
var User_Account$1 = "Account";
var User_AdditionalContentLanguages$1 = "Additional Content Languages";
var User_BioLabel$1 = "Biography";
var User_CategoryExample$1 = "example: leadership, accounting, web development, politics, communication";
var User_CategoryExplanation$1 = "Topics help you discover and categorize learning.";
var User_CategoryQuestion$1 = "What do you want to learn?";
var User_ChangePassword$1 = "Change Password";
var User_CharactersRemaining$1 = "Characters Remaining";
var User_Communications$1 = "Communications";
var User_ContentLanguage$1 = "Content Language";
var User_DailyDigestA11yHelpText$1 = 'On toggling the state of the "Daily Digest" checkbox, the content will update below.';
var User_DeleteProfile$1 = "Delete Profile";
var User_DisplayLanguage$1 = "Display Language";
var User_Email$1 = "Email";
var User_EmailCommunicationsDesc$1 = "Send me an email about each of the following events as they occur.";
var User_EmailNotificationsDesc$1 = "Send me an email about each of the following events as they occur.";
var User_EmailNotificationsLabel$1 = "Email Notifications";
var User_EmailUpdatesDesc$1 = "Stay up to date with these informative emails.";
var User_EmailUpdatesLabel$1 = "Email Updates";
var User_Extensions$1 = "Degreed Button";
var User_Family$1 = "Family Accounts";
var User_FamilyAccountAdd$1 = "Create Family Account";
var User_FamilyAccountCreateError$1 = "Sorry! There was a problem creating a new account.";
var User_FamilyAccountCreateSuccess$1 = "Success! A new family account has been created.";
var User_FamilyAccountGetError$1 = "Sorry! There was a problem retrieving account information.";
var User_FamilyAccountInstructions$1 = '<p>This service does not collect personal information, as defined by the Children\'s Online Privacy Protection Act, from children under age 13. You may view your child\'s log-in activity or request deletion of your child’s account by emailing <a class="link" href="mailto:support@degreed.com">support@degreed.com</a> with your request. The service includes links to sites operated by third parties.  The Bank provides these links only as a convenience to you and is not responsible for the content contained at those sites or the privacy or other practices of the third parties that operate them.  Solely you are responsible for determining whether any third-party site is appropriate for your child.</p><p>By using the service, you agree to the <a class="link" href="/about/terms">terms</a> on behalf of yourself and each of your children.  Please read our <a class="link" href="/about/privacy">Privacy Notice</a>.</p>';
var User_FamilyAccountsHeader$1 = "Your Family Accounts";
var User_FamilyCreateAccountFormat$1 = "Create '{{programName}}' Account";
var User_FamilyEmptyStateHeader$1 = "Let's learn together";
var User_FamilyLegendFormat$1 = "Member Account {{ memberIndex }}";
var User_FamilyPasswordLabel$1 = "Password";
var User_FamilyProgramLabel$1 = "Program";
var User_FamilyUsernameLabelFormat$1 = "Username Member {{ memberIndex }}";
var User_FirstNameLabel$1 = "First Name";
var User_Integrations$1 = "Integrations";
var User_LanguageExplanation$1 = "Degreed suggests content in this language if available. Changes take effect within 24 hours.";
var User_LastNameLabel$1 = "Last Name";
var User_LocationLabel$1 = "Location";
var User_ManagedProfileMessageFormat$1 = "Your profile settings are being managed by {0}";
var User_Notifications$1 = "Notifications";
var User_NotificationsA11yHelpText$1 = 'On toggling the state of the "Email Notifications" checkbox, the content will update below.';
var User_PageTitle$1 = "Settings";
var User_Personal$1 = "Personal";
var User_PreferenceSurveysDescription$1 = "See in-app surveys and opportunities to improve your experience.";
var User_PreferenceSurveysTitle$1 = "Participate in Degreed Research";
var User_PreferenceTipsDescription$1 = "See in-app prompts showing best practices for Degreed.";
var User_PreferenceTipsTitle$1 = "See Tips and Tricks";
var User_PreferredContent$1 = "Preferred Content Language";
var User_Profile$1 = "Profile";
var User_ProfileName$1 = "Profile Name";
var User_ProfilePrivacyLabel$1 = "Profile Privacy";
var User_ProfileUrlExplanation$1 = "This will be your profile URL (e.g. {{domainName}}/profile/profilename)";
var User_ResetOnboarding$1 = "Reset Onboarding";
var User_SaveSettings$1 = "Save Settings";
var User_SystemLanguage$1 = "Degreed Display Language";
var User_SystemLanguageExplanation$1 = "Language for buttons and messages in Degreed. This does not affect the language of content items, including content suggested by Degreed.";
var User_UpdatesA11yHelpText$1 = 'On toggling the state of the "Email Updates" checkbox, the content will update below.';
var UserEmailAddress_VerificationSuccessful$1 = "Your email has been verified!";
var UserEvaluationEndorsementCompleted_NotificationTitleFormat$1 = "{{nameHtml}} has completed the endorsement of your Skill Review in {{tag}}";
var UserEvaluationEndorsementRequested_NotificationTitleFormat$1 = "{{nameHtml}} asked you to endorse their Skill Review in {{tag}}";
var UserGoalsSvc_GoalAccessError$1 = "Sorry! There was a problem accessing your goals.";
var UserGoalsSvc_GoalExistsError$1 = "You already have a goal for this item.";
var UserInputsController_Praise1$1 = "Way to go!";
var UserInputsController_Praise2$1 = "Excellent!";
var UserInputsController_Praise3$1 = "Nice job!";
var UserInputsController_Praise4$1 = "Great work!";
var UserInputsController_Praise5$1 = "Impressive!";
var UserInputsController_Praise6$1 = "We're impressed!";
var UserInputsController_Praise7$1 = "Keep up the good work!";
var UserInputsController_Reward1AccomplishmentPluralFormat$1 = "You've added {0} accomplishments to your profile.";
var UserInputsController_Reward1AccomplishmentSingular$1 = "You've added 1 accomplishment to your profile.";
var UserInputsController_Reward1ArticlePluralFormat$1 = "You've added {0} articles to your profile.";
var UserInputsController_Reward1ArticleSingular$1 = "You've added 1 article to your profile.";
var UserInputsController_Reward1AssessmentPluralFormat$1 = "You've added {0} assessments to your profile.";
var UserInputsController_Reward1AssessmentSingular$1 = "You've added 1 assessment to your profile.";
var UserInputsController_Reward1AwardPluralFormat$1 = "You've added {0} awards to your profile.";
var UserInputsController_Reward1AwardSingular$1 = "You've added 1 award to your profile.";
var UserInputsController_Reward1BadgePluralFormat$1 = "You've added {0} badges to your profile.";
var UserInputsController_Reward1BadgeSingular$1 = "You've added 1 badge to your profile.";
var UserInputsController_Reward1BookPluralFormat$1 = "You've added {0} books to your profile.";
var UserInputsController_Reward1BookSingular$1 = "You've added 1 book to your profile.";
var UserInputsController_Reward1CertificatePluralFormat$1 = "You've added {0} certificates to your profile.";
var UserInputsController_Reward1CertificateSingular$1 = "You've added 1 certificate to your profile.";
var UserInputsController_Reward1CoursePluralFormat$1 = "You've added {0} courses to your profile.";
var UserInputsController_Reward1CourseSingular$1 = "You've added 1 course to your profile.";
var UserInputsController_Reward1DegreePluralFormat$1 = "You've added {0} degrees to your profile.";
var UserInputsController_Reward1DegreeSingular$1 = "You've added 1 degree to your profile.";
var UserInputsController_Reward1EpisodePluralFormat$1 = "You've added {0} podcast episodes to your profile.";
var UserInputsController_Reward1EpisodeSingular$1 = "You've added 1 podcast episode to your profile.";
var UserInputsController_Reward1EventPluralFormat$1 = "You've added {0} events to your profile.";
var UserInputsController_Reward1EventSingular$1 = "You've added 1 event to your profile.";
var UserInputsController_Reward1ItemPluralFormat$1 = "You've added {0} learning items to your profile.";
var UserInputsController_Reward1ItemSingular$1 = "You've added 1 learning item to your profile.";
var UserInputsController_Reward1PositionPluralFormat$1 = "You've added {0} experiences to your profile.";
var UserInputsController_Reward1PositionSingular$1 = "You've added 1 experience to your profile.";
var UserInputsController_Reward1SkillPluralFormat$1 = "You've added {0} skills to your profile.";
var UserInputsController_Reward1SkillSingular$1 = "You've added 1 skill to your profile.";
var UserInputsController_Reward1VideoPluralFormat$1 = "You've added {0} videos to your profile.";
var UserInputsController_Reward1VideoSingular$1 = "You've added 1 video to your profile.";
var UserInputsController_Reward2AccomplishmentPluralFormat$1 = "That's {0} accomplishments you've completed.";
var UserInputsController_Reward2AccomplishmentSingular$1 = "That's 1 accomplishment you've completed.";
var UserInputsController_Reward2ArticlePluralFormat$1 = "That's {0} articles you've completed.";
var UserInputsController_Reward2ArticleSingular$1 = "That's 1 article you've completed.";
var UserInputsController_Reward2AssessmentPluralFormat$1 = "That's {0} assessments you've completed.";
var UserInputsController_Reward2AssessmentSingular$1 = "That's 1 assessment you've completed.";
var UserInputsController_Reward2AwardPluralFormat$1 = "That's {0} awards you've completed.";
var UserInputsController_Reward2AwardSingular$1 = "That's 1 award you've completed.";
var UserInputsController_Reward2BadgePluralFormat$1 = "That's {0} badges you've completed.";
var UserInputsController_Reward2BadgeSingular$1 = "That's 1 badge you've completed.";
var UserInputsController_Reward2BookPluralFormat$1 = "That's {0} books you've completed.";
var UserInputsController_Reward2BookSingular$1 = "That's 1 book you've completed.";
var UserInputsController_Reward2CertificatePluralFormat$1 = "That's {0} certificates you've completed.";
var UserInputsController_Reward2CertificateSingular$1 = "That's 1 certificate you've completed.";
var UserInputsController_Reward2CoursePluralFormat$1 = "That's {0} courses you've completed.";
var UserInputsController_Reward2CourseSingular$1 = "That's 1 course you've completed.";
var UserInputsController_Reward2DegreePluralFormat$1 = "That's {0} degrees you've completed.";
var UserInputsController_Reward2DegreeSingular$1 = "That's 1 degree you've completed.";
var UserInputsController_Reward2EpisodePluralFormat$1 = "That's {0} podcast episodes you've completed.";
var UserInputsController_Reward2EpisodeSingular$1 = "That's 1 podcast episode you've completed.";
var UserInputsController_Reward2EventPluralFormat$1 = "That's {0} events you've completed.";
var UserInputsController_Reward2EventSingular$1 = "That's 1 event you've completed.";
var UserInputsController_Reward2ItemPluralFormat$1 = "That's {0} learning items you've completed.";
var UserInputsController_Reward2ItemSingular$1 = "That's 1 learning item you've completed.";
var UserInputsController_Reward2PositionPluralFormat$1 = "That's {0} experiences you've completed.";
var UserInputsController_Reward2PositionSingular$1 = "That's 1 experience you've completed.";
var UserInputsController_Reward2SkillPluralFormat$1 = "That's {0} skills you've completed.";
var UserInputsController_Reward2SkillSingular$1 = "That's 1 skill you've completed.";
var UserInputsController_Reward2VideoPluralFormat$1 = "That's {0} videos you've completed.";
var UserInputsController_Reward2VideoSingular$1 = "That's 1 video you've completed.";
var Uploader_Canceled$1 = "Upload canceled";
var Uploader_Completed$1 = "Upload Completed";
var Uploader_DefaultLimitNotice_Size$1 = "Files can be up to {{size}}MB in size.";
var Uploader_DefaultLimitNotice_Type$1 = "Files can be {{types}}.";
var Uploader_DefaultLimitNotice_TypeAndSize$1 = "Files can be {{types}} up to {{size}}MB in size.";
var Uploader_FileTypeError$1 = "Sorry! You can only upload {{filePattern}} type files.";
var Uploader_SizeLimitMet$1 = "File is too large";
var Uploader_UnknownError$1 = "An unknown error occurred while uploading";
var unsubscribeTemplate_ChangeSettings$1 = "Change email settings";
var TrackableLinkCtrl_AutoEnroll$1 = "Trackable Link";
var TrackableLinkCtrl_CopiedLink$1 = "Copied to clipboard";
var TrackableLinkCtrl_CopyLink$1 = "Copy Link";
var TrackableLinkCtrl_CopyLinkAgain$1 = "Copy Again";
var TrackableLinkCtrl_DeleteLinkModalBodyText$1 = "Are you sure you want to delete the trackable link <strong>{{linkName}}</strong>?";
var TrackableLinkCtrl_DeleteLinkModalHeader$1 = "Are you sure you want to delete the trackable link?";
var TrackableLinkCtrl_EditModalTitle$1 = "Edit Trackable Link";
var TrackableLinkCtrl_FormTitle$1 = "How are you using this link?";
var TrackableLinkCtrl_FormTitlePlaceholder$1 = "i.e. Reminder Email, January Cohort Invite Email";
var TrackableLinkCtrl_LinkDescription$1 = "Use these links to promote this item in your organization. See who clicked and followed via this link in the {{aTagStart}}Trackable Links section{{aTagEnd}} of Insights.";
var TrackableLinkCtrl_ModalTitle$1 = "Create Trackable Link";
var TrackableLinkCtrl_NewLink$1 = "New Trackable Link";
var TrackableLinkCtrl_StartTracking$1 = "Start Tracking";
var TrackableLinkCtrl_TableHeaderClicks$1 = "Clicks";
var TrackableLinkCtrl_TableHeaderCreator$1 = "Creator";
var TrackableLinkCtrl_TableHeaderDate$1 = "Date created";
var TrackableLinkCtrl_TableHeaderEnrolls$1 = "Follows";
var TrackableLinkCtrl_TableHeaderLink$1 = "Link name";
var TrackableLinkCtrl_Title$1 = "Trackable Links";
var TrackableLinkCtrl_TitleCreated$1 = "Trackable Link Created";
var TopCompletionsChart_CatalogTypeAllProviders$1 = "All Providers";
var TopCompletionsChart_CatalogTypeCatalog$1 = "Content Items";
var TopCompletionsChart_CatalogTypeExternalCatalogProviders$1 = "External Catalog Providers";
var TopCompletionsChart_CatalogTypeInternalCatalogProviders$1 = "Internal Catalog Providers";
var TopCompletionsChart_CatalogTypeLearner$1 = "Learners";
var TopCompletionsChart_CompletionsColumn$1 = "Completions";
var TopCompletionsChart_NameColumn$1 = "Name";
var TopCompletionsChart_NameFormat$1 = "Top {{count}} Completions";
var TopCompletionsChart_NoResults$1 = "No Results";
var TipSvc_OnboardError$1 = "Sorry! There was a problem accessing your onboarding history.";
var TipSvc_OnboardResetSuccess$1 = "Successfully reset Onboarding";
var TipSvc_SavedItemsModal$1 = 'Items you Save for Later display in your Profile\'s "Saved" tab. You can also access these items from the "Saved" link on your Home page.';
var TipSvc_SavedItemsModalHome$1 = 'Items you save for later can be found in your "Saved" page on Home.';
var TipSvc_ViewSavedItems$1 = "View saved items";
var TeamInsights_SpiderChart_BottomText$1 = "Only 5 team members can be displayed on this chart";
var TeamInsights_SpiderChart_LegendTitle$1 = "Team Members";
var TeamInsights_SpiderChart_RadarTitle$1 = "Skill Radar";
var Team_AllReports$1 = "All Reports";
var Team_AllTeamMembers$1 = "All Team Members";
var Team_AssignmentEmailBodyDueSoon$1 = "The assignment {{assignmentName}} is due on {{dueDate}}. Please log in to Degreed and complete {{assignmentName}} by the due date. {{assignmentLink}}";
var Team_AssignmentEmailBodyOverdue$1 = "The assignment {{assignmentName}} was due on {{dueDate}} and is now overdue. Please log in to Degreed and complete {{assignmentName}} as soon as possible. {{assignmentLink}}";
var Team_AssignmentLink$1 = "Assignment Link";
var Team_AssignmentName$1 = "Assignment Name";
var Team_AssignmentNameDueSoon$1 = "{{assignmentName}} is due soon";
var Team_AssignmentNameOverdue$1 = "{{assignmentName}} is overdue";
var Team_AssignmentReminder$1 = "Assignment Reminder";
var Team_AssignmentReminders$1 = "Assignment Reminders";
var Team_Assignments$1 = "Assignments";
var Team_AssignmentsDueSoonDesc$1 = "Incomplete team assignments approaching the assigned due date";
var Team_AssignmentsIncompleteDesc$1 = "All current assignments not yet completed";
var Team_AssignmentsOverdueDesc$1 = "Incomplete team assignments past the assigned due date";
var Team_Chart_Disclaimer$1 = "\xa9 Degreed.com. All Rights Reserved. Generated by Degreed.";
var Team_Chart_FullScreenText$1 = "Enter Fullscreen";
var Team_CompletionDetails$1 = "Completion Details";
var Team_ContactAssignor$1 = "Contact Assignor";
var Team_CountMandatory$1 = "{{totalMandatory}} Mandatory";
var Team_CountMandatorySingular$1 = "{{totalMandatory}} Mandatory";
var Team_CountRequired$1 = "{{totalRequired}} Required";
var Team_CountRequiredSingular$1 = "{{totalRequired}} Required";
var Team_CustomEmailMessage$1 = "Custom Email Message";
var Team_Customizable$1 = "Customizable";
var Team_DirectReportsOnly$1 = "Direct Reports Only";
var Team_DismissAssignment$1 = "Dismiss Assignment";
var Team_DismissAssignmentDesc$1 = "Dismissing {{assignmentName}} for {{userName}} will permanently remove the assignment from your manager view only. The assignment will still be visible for other managers, on reports, and in {{userName}}'s assignment list. This action can not be undone.";
var Team_ErrorLoadingManagers$1 = "There was a problem loading the list of managers.";
var Team_FilterbySkillsFilter_Title$1 = "Filter by Skills";
var Team_FocusFilterDisabledTooltip$1 = "You have not made a selection of Team Focus Skills yet. You can select Team Focus Skills in the Team Skills tab.";
var Team_FocusFilterNoResultsTooltip$1 = "There are no Team Focus Skills in your current search results";
var Team_FocusLabel$1 = "Team Focus Only";
var Team_FocusSkills_Add$1 = "Add to Team Focus Skills";
var Team_FocusSkills_AddFormat$1 = "Add {{ title }} to Team Focus Skills";
var Team_FocusSkills_Remove$1 = "Remove from Team Focus Skills";
var Team_FocusSkills_RemoveFormat$1 = "Remove {{ title }} from Team Focus Skills";
var Team_Group_Shared_And_Private_Message$1 = "Private or anonymous learners' completions are not included in the overall % Complete metric.";
var Team_Insights_ActiveLearnerTitle$1 = "Most Active Learners";
var Team_Insights_ActiveLearnerTooltip$1 = "The top 10 team members who have the most content completions during this period.";
var Team_Insights_AssignedLearnings_Empty_Message$1 = "No items were assigned.";
var Team_Insights_AssignedLearningsTitle$1 = "Assignments";
var Team_Insights_AverageCompletions_Label$1 = "Avg. Completions";
var Team_Insights_AveragePoints_Label$1 = "Avg. Points Earned";
var Team_Insights_AveragePoints_Tooltip$1 = "Average number of points earned per team member during this period";
var Team_Insights_AveragePointsEarned_Label$1 = "Avg. Points Earned";
var Team_Insights_AvgCompletions_Label$1 = "Avg. Completions";
var Team_Insights_AvgCompletions_Tooltip$1 = "Average number of content completions per team member during this period";
var Team_Insights_AvgPointsEarned_Label$1 = "Avg. Points Earned";
var Team_Insights_AvgPointsEarned_Tooltip$1 = "Average number of points earned per team member during this period";
var Team_Insights_PopularSkillsTitle$1 = "Popular Skills";
var Team_Insights_PopularSkillsTooltip$1 = "The top 10 Skills, as determined by the total number of your team’s completed content items associated to each Skill.";
var Team_Insights_Range_Last30Days$1 = "in the last 30 days";
var Team_Insights_TotalCompletions_Label$1 = "Total Completions";
var Team_Insights_TotalCompletions_Tooltip$1 = "Includes any content marked complete during this period";
var Team_Insights_TotalPoints_Label$1 = "Total Points";
var Team_Insights_TotalPoints_Tooltip$1 = "Includes any content marked complete during this period";
var Team_Insights_View_Assignment_Aria$1 = "View {{ assignmentName }}";
var Team_Insights_ViewAssignment$1 = "View {{ assignmentName }}";
var Team_InsightSkills_NoSkillRating$1 = "No skill rating";
var Team_JobRelatedSkills$1 = "Job-Related Skills";
var Team_LearnerName$1 = "Learner Name";
var Team_LearningInsights$1 = "Learning Insights";
var Team_ManagerName$1 = "Manager Name";
var Team_MSTeamsNotification$1 = "Also sends a Microsoft Teams notification, if enabled";
var Team_MyTeam$1 = "My Team";
var Team_NewAssignment$1 = "New Assignment";
var Team_NoAssignments$1 = "Your team has no assignments";
var Team_NoAssignmentsDesc$1 = "Once learning has been assigned to your team, it will appear here.";
var Team_NoRating$1 = "No rating";
var Team_NotOnProfile$1 = "Not on profile";
var Team_OptOutAutoDescription$1 = "By making your profile private, you can no longer opt in or out of Skill Coach, and your Skill data is no longer visible to your manager.";
var Team_OptOutMessage$1 = "Opted-out of Skill Coach";
var Team_OptOutTitleModal$1 = "Skill Coach Notification";
var Team_PleaseCompleteDueSoon$1 = "Please complete the assignment by {{dueDate}}.";
var Team_PleaseCompleteOverdue$1 = "Please complete the assignment as soon as possible.";
var Team_RatedJobSkills$1 = "Rated Skills";
var Team_RatedSkillsHeader_Tooltip$1 = "Indicates the number of skills with a self or manager rating vs the total skills for that user";
var Team_Rating_History_SetRating$1 = "{{ name }} set the rating to {{ level }}";
var Team_Recipients$1 = "Recipients";
var Team_RecommendationSent$1 = "Recommendation sent successfully!";
var Team_RecommendSkills_ButtonText$1 = "Recommend Skills";
var Team_ReminderSent$1 = "Reminders sent successfully";
var Team_RemindersSent$1 = "Reminders sent successfully";
var Team_ReminderTypes$1 = "Reminder Types";
var Team_ScreenReader_Chart_Description_SkillSpiderChart$1 = "This polar spider chart shows the relationship between team members and their related skills.";
var Team_SelectRecipient$1 = "Select at least one recipient";
var Team_SelectReminder$1 = "Select at least one reminder type to see a preview.";
var Team_SelectReminderType$1 = "Select at least one reminder type";
var Team_SendReminder$1 = "Send Reminder";
var Team_SendReminders$1 = "Send Reminders";
var Team_SkillInsights$1 = "Skill Insights";
var Team_SkillProfile$1 = "Skill Profile";
var Team_Skills$1 = "Team Skills";
var Team_Skills_AverageRatingAction$1 = "{{name}} average rating is {{count}}: {{action}}";
var Team_Skills_FocusSkill_MaxLimit$1 = "You have reached the limit of Team Focus Skills";
var Team_Skills_FocusSkillAction$1 = "{{name}} is a focus skill on {{count}} profiles: {{action}}";
var Team_Skills_FocusSkillAction_Singular$1 = "{{name}} is a focus skill on 1 profile: {{action}}";
var Team_Skills_OnProfile$1 = "On Profile";
var Team_Skills_OnProfileAction$1 = "{{name}} is on {{count}} profiles: {{action}}";
var Team_Skills_OnProfileAction_Singular$1 = "{{name}} is on 1 profile: {{action}}";
var Team_Skills_OpenRatingListModal$1 = "Open team member rating list modal";
var Team_Skills_OptInToggle_MoM_Off$1 = "By opting into Skill Coach, your manager has access to your data to help you develop your skills.";
var Team_Skills_OptInToggle_MoM_On$1 = "By opting into Skill Coach, your manager, and their managers, have access to your data to help you develop your skills.";
var Team_Skills_RatingCount$1 = "Rating Count";
var Team_Skills_RatingCountAction$1 = "{{name}} rating count is {{count}}: {{action}}";
var Team_Skills_RemoveFocusSkill_Success$1 = "The skill was removed from your selection successfully";
var Team_Skills_SetFocusSkill_Failure$1 = "The skill was not added";
var Team_Skills_SetFocusSkill_Success$1 = "The skill was added to your selection successfully";
var Team_Skills_SkillChangePublished_NotificationContent$1 = "Your organization has updated one or more skills, which may affect your ratings.\n{{ skillChangePublishedHtml }}";
var Team_Skills_VisibilityTooltip$1 = "Visible to you, your manager, and their managers because you are opted-in to Skill Coach.";
var Team_Skills_VisibilityTooltip_NoMoManager$1 = "Visible to you and your manager because you are opted-in to Skill Coach.";
var Team_SpiderChart_BottomText$1 = "Only {{ numTeamMembers }} team members can be displayed on this chart";
var Team_SpiderChart_LegendTitle$1 = "Team Members";
var Team_SpiderChart_PointLabel$1 = "{{user}} is rated level {{level}} for {{skill}}";
var Team_SpiderChart_RadarTitle$1 = "Skill Radar";
var Team_SubjectAssignmentNameDueSoon$1 = "Subject: Reminder: {{assignmentName}} is due soon";
var Team_SubjectAssignmentNameOverdue$1 = "Subject: Reminder: {{assignmentName}} is overdue";
var Team_TeamFocusSkillTooltip$1 = "Select up to 15 Skills from your team’s Skills list that are most important to you.";
var Team_TeamFormat$1 = "{{owner}}'s Team";
var Team_TeamMembers$1 = "Team Members";
var Team_ThankYou$1 = "Thank you";
var Team_UpdateManagerRatingSuccessMessage$1 = "Manager rating is set. Your team member will be notified about new skill rating.";
var Team_UpdatePeerRatingSuccessMessage$1 = "Peer rating is set. Your team member will be notified about new skill rating.";
var Team_UpdateSkillTargetSuccessMessage$1 = "You set the Skill Target. {{requester}} will receive a notification about the set Skill Target.";
var Team_ViewReports$1 = "View Reports";
var Team_ViewSkillsProfile$1 = "View Skills Profile";
var Team_WelcomeBanner_Description$1 = "Use Skill Coach to analyze your team's skills and support each team member's individual skill development. We recommend you regularly connect with your team members to discuss their skill development plans and progress.";
var Team_WelcomeBanner_Title$1 = "Manage and Support your Team's Skill Growth";
var TaskFormCtrl_Add$1 = "Add Task";
var TaskFormCtrl_AddImage$1 = "Add Image";
var TaskFormCtrl_AddToCatalogFormat$1 = "Add this task to {{orgName}}'s catalog";
var TaskFormCtrl_Description$1 = "Description";
var TaskFormCtrl_Edit$1 = "Edit Task";
var TaskFormCtrl_ImagePreviewAltText$1 = "Content Image Preview";
var TaskFormCtrl_Save$1 = "Save Task";
var TaskFormCtrl_Site$1 = "Task Url";
var TaskFormCtrl_Title$1 = "Title";
var TaskFormCtrl_TitleError$1 = "A task title is required";
var TaskFormCtrl_Url$1 = "Task URL (include http:// or https://)";
var TaskFormCtrl_ValidUrl$1 = "Please use a valid and complete URL";
var TaskFormCtrl_WhatDidYouLearnLong$1 = "What did you learn from completing this task?";
var TaskFormCtrl_WhatDidYouLearnShort$1 = "What did you learn?";
var TargetsSvc_AddAuthorError$1 = "Sorry! There was a problem adding an author.";
var TargetsSvc_AddError$1 = "Sorry! There was a problem adding the {{targetType}}.";
var TargetsSvc_AddResourceError$1 = "Sorry! There was a problem adding to the {{targetType}}.";
var TargetsSvc_AddSectionError$1 = "Sorry! There was a problem adding a section.";
var TargetsSvc_AddSuccess$1 = "The {{targetType}} was added successfully!";
var TargetsSvc_CloneError$1 = "Sorry! There was a problem cloning the {{targetType}}.";
var TargetsSvc_CloneSuccess$1 = "The {{targetType}} was added successfully!";
var TargetsSvc_DeleteAuthorError$1 = "Sorry! There was a problem deleting an author.";
var TargetsSvc_DeleteError$1 = "Sorry! There was a problem deleting the {{targetType}}.";
var TargetsSvc_DeleteResourceError$1 = "Sorry! There was a problem deleting from the {{targetType}}.";
var TargetsSvc_DeleteSuccess$1 = "The {{targetType}} '{{targetTitle}}' was deleted successfully!";
var TargetsSvc_DetailsError$1 = "Sorry! We can't load the content. Reload the page to try again.";
var TargetsSvc_Error$1 = "Sorry! There was a problem retrieving matching {{targetTypePlural}}.";
var TargetsSvc_FeaturedError$1 = "Sorry! There was a problem saving your changes.";
var TargetsSvc_FollowError$1 = "Sorry! There was a problem following the plan.";
var TargetsSvc_GetUserError$1 = "Sorry! There was a problem retrieving users.";
var TargetsSvc_MakeFeaturedNotification$1 = "Featured item added successfully";
var TargetsSvc_RemoveFeaturedNotification$1 = "Item is no longer featured";
var TargetsSvc_ReorderResourceError$1 = "Sorry! There was a problem moving the item.";
var TargetsSvc_RetrieveError$1 = "Sorry! There was a problem retrieving the content.";
var TargetsSvc_SetNotVisibleSuccess$1 = "This {{targetType}} is no longer visible for your organization.";
var TargetsSvc_SetTargetNameError$1 = "Sorry! There's already a plan with the same name. Please choose a different name for this plan.";
var TargetsSvc_SetVisibleSuccess$1 = "This {{targetType}} is now visible for your organization.";
var TargetsSvc_SuggestionError$1 = "Sorry! There was a problem retrieving suggestions.";
var TargetsSvc_TargetLevelError$1 = "Sorry! There was a problem setting a target level.";
var TargetsSvc_TypeBrowse$1 = "Browse";
var TargetsSvc_TypeBrowse_Specific$1 = "Browse";
var TargetsSvc_TypeDirectory$1 = "Directory";
var TargetsSvc_TypeDirectory_Specific$1 = "Directory";
var TargetsSvc_TypeDirectorys$1 = "Directories";
var TargetsSvc_TypeDirectorys_Specific$1 = "Directories";
var TargetsSvc_TypeFeatured_Specific$1 = "Featured Plan";
var TargetsSvc_TypeJobRole$1 = "Plan";
var TargetsSvc_TypeJobRole_Specific$1 = "Skill Plan";
var TargetsSvc_TypeJobRoles$1 = "Plans";
var TargetsSvc_TypeJobRoles_Specific$1 = "Skill Plans";
var TargetsSvc_TypeRole$1 = "Role";
var TargetsSvc_TypeRole_Specific$1 = "Role Plan";
var TargetsSvc_TypeRoles$1 = "Role Plans";
var TargetsSvc_TypeRoles_Specific$1 = "Role Plans";
var TargetsSvc_TypeSkillPlan$1 = "Plan";
var TargetsSvc_TypeSkillPlan_Specific$1 = "Skill Plan";
var TargetsSvc_TypeSkillPlans$1 = "Plans";
var TargetsSvc_TypeSkillPlans_Specific$1 = "Skill Plans";
var TargetsSvc_TypeTarget$1 = "Plan";
var TargetsSvc_TypeTarget_Specific$1 = "Skill Plan";
var TargetsSvc_TypeTargets$1 = "Plans";
var TargetsSvc_TypeTargets_Specific$1 = "Skill Plans";
var TargetsSvc_UnfollowError$1 = "Sorry! There was a problem unfollowing the plan.";
var TargetsSvc_UpdateAuthorsError$1 = "Sorry! There was a problem updating the collaborators.";
var TargetsSvc_UpdateError$1 = "Sorry! There was a problem updating the {{targetType}}.";
var TargetsSvc_UpdateSuccess$1 = "The {{targetType}} was updated successfully!";
var TargetsSvc_UpdateVisibilityError$1 = "Sorry! There was a problem updating the visibility.";
var TargetsSvc_UsersTitle$1 = "People who are following this";
var TargetsCtrl_BulkChangeVisibility$1 = "Change Visibility of 1 Page";
var TargetsCtrl_BulkChangeVisibilityPlural$1 = "Change Visibility of {{count}} Directories";
var TargetsCtrl_DeletePluralPrompt$1 = "Are you sure you want to delete {{ count }} directories?";
var TargetsCtrl_DeletePrompt$1 = "Are you sure you want to delete this directory?";
var Targets_MoveConfirmationMessage$1 = "This will permanently move the plan from the organization's catalog to the global catalog.";
var Targets_MoveSuccessMessage$1 = "Successfully moved plan!";
var TargetResourcesForm_Filters_Catalog$1 = "Catalog";
var TargetResourcesForm_Filters_PlansAndPathways$1 = "Plans and Pathways";
var TargetResourcesForm_Filters_Resources$1 = "Resources";
var TargetResourcesForm_InputHelp$1 = "Search for specific pieces of content";
var TargetResourcesForm_NoResults$1 = "Not found, add anyway?";
var TargetResourcesForm_NoResultsFound$1 = "No results found.";
var TargetResourcesForm_ResourceAuthors$1 = "By {{authors}}";
var TargetResourcesForm_SearchMixedPlaceholder$1 = "Search Catalog, Skills, Groups, People, and Providers";
var TargetResourcesForm_SearchPlaceHolder$1 = "Search for {{targetResourceType}}...";
var TargetResourcesForm_Selected$1 = "Selected";
var TargetResourcesForm_Suggestions$1 = "Suggestions";
var TargetResourcesForm_Title$1 = "Add {{targetResourceType}}";
var TargetResources_AddResources$1 = "Add Resources";
var TargetResources_CreateADirectory$1 = "Create a Directory";
var TargetResources_CreateAResourceFormat$1 = "Create a {{targetResourceType}}";
var TargetResources_CreateATarget$1 = "Create a Plan";
var TargetResources_DirectoryPlural$1 = "Directories";
var TargetResources_Group$1 = "Group";
var TargetResources_GroupPlural$1 = "Groups";
var TargetResources_InputPlural$1 = "Content";
var TargetResources_NoDirectorysSelectedYet$1 = "No directories selected yet.";
var TargetResources_NoGroupsSelectedYet$1 = "No groups selected yet.";
var TargetResources_NoTargetsSelectedYet$1 = "No plans selected yet.";
var TargetResources_PathwayPlural$1 = "Pathways";
var TargetResources_ProviderPlural$1 = "Providers";
var TargetResources_TagPlural$1 = "Skills";
var TargetResources_Target$1 = "Plan";
var TargetResources_TargetAndDirectoryPlural$1 = "Plans and Directories";
var TargetResources_TargetOrDirectory$1 = "Plan or Directory";
var TargetResources_TargetPlural$1 = "Plans";
var TargetResources_UserPlural$1 = "People";
var TargetFormCtrl_TargetGroupsToolTip$1 = "This will make it easier for these groups to find this plan";
var TargetForm_AutopopulateInfo$1 = "Automatically fill this plan with suggested items.";
var TargetForm_AutopopulateTitle$1 = "Autopopulate";
var TargetForm_CreateButton$1 = "Create {{targetType}}";
var TargetForm_CreateTitle$1 = "Create {{targetType}}";
var TargetForm_Description$1 = "Description";
var TargetForm_DescriptionPlaceholder$1 = "This plan will help in your development as a...";
var TargetForm_EditTitle$1 = "Edit {{targetType}}";
var TargetForm_FormDescription$1 = "Plans help individuals, groups, and the entire organization grow in a guided, planned way.";
var TargetForm_IsEndorsedInfo$1 = "If checked, an icon appears on the card to show you endorsed this.";
var TargetForm_IsEndorsedTitle$1 = "Endorsed";
var TargetForm_Name$1 = "Title";
var TargetForm_NameError$1 = "Please specify a title.";
var TargetForm_NamePrompt$1 = "e.g. Sales Manager";
var TargetForm_RolePlanCreationNotice$1 = "Creating a role plan will create a role for your organization.";
var TargetForm_SelectVisibility$1 = "Select visibility";
var TargetForm_SetPrimaryPlan$1 = "Set as primary plan";
var TargetForm_Visibility$1 = "Visibility";
var TargetForm_VisibilityBoostToGroup$1 = "Boost to these groups";
var TargetForm_VisibilityBoostToGroupTooltip$1 = "This plan will be boosted to group members in their global search results.";
var TargetForm_VisibilityLimitToGroup$1 = "Limit visibility to these groups";
var TargetCtrl_AcceptAutosuggest$1 = "Apply Suggestions";
var TargetCtrl_AddDirectories$1 = "Add Directories";
var TargetCtrl_AddDirectorys$1 = "Add Directories";
var TargetCtrl_AddGroups$1 = "Add Groups";
var TargetCtrl_AddInputs$1 = "Add Content";
var TargetCtrl_AddOpportunities$1 = "Add Opportunities";
var TargetCtrl_AddPages$1 = "Add Plans";
var TargetCtrl_AddPathways$1 = "Add Pathways";
var TargetCtrl_AddProviders$1 = "Add Providers";
var TargetCtrl_AddTags$1 = "Add Skills";
var TargetCtrl_AddTargetAndDirectoryPlural$1 = "Add Plans and Directories";
var TargetCtrl_AddTargetPlural$1 = "Add Plans";
var TargetCtrl_AddTargets$1 = "Add Plan";
var TargetCtrl_AddUsers$1 = "Add People";
var TargetCtrl_AutoFill$1 = "Would you like us to automatically fill this page with skills, pathways, groups, people and content?";
var TargetCtrl_AutosuggestNotice$1 = "Apply these auto-populated suggestions";
var TargetCtrl_ConfirmCloseButton$1 = "Yes, close";
var TargetCtrl_ConfirmDeleteButton$1 = "Yes, delete";
var TargetCtrl_DeleteInstructions$1 = "Type {{delete}} in capital letters to confirm";
var TargetCtrl_DeletePluralPrompt$1 = "Are you sure you want to delete {{ count }} plans?";
var TargetCtrl_DeletePrompt$1 = "Are you sure you would like to delete {{targetTitle}}?";
var TargetCtrl_DeletePromptDescription$1 = "You cannot undo this action.";
var TargetCtrl_Groups$1 = "Groups";
var TargetCtrl_Inputs$1 = "Content";
var TargetCtrl_NotVisibleNotice$1 = "This {{targetType}} is currently not visible for your organization.";
var TargetCtrl_Pathways$1 = "Pathways";
var TargetCtrl_PrimaryPlanDeselection$1 = "Are you sure you no longer want this plan to be your primary plan?";
var TargetCtrl_PrimaryPlanSelection$1 = "Are you sure you want to make this your primary plan? Your existing primary plan will no longer be indicated as your primary plan.";
var TargetCtrl_SetTargetLevel$1 = "Set a target level";
var TargetCtrl_SetVisible$1 = "Make visible";
var TargetCtrl_SetVisibleNotAllowed$1 = "This {{targetType}} does not contain any resources so it cannot be made visible for your organization. Add some resources, then try again.";
var TargetCtrl_SuggestionApplySuccess$1 = "Suggestions were successfully applied";
var TargetCtrl_Tags$1 = "Skills";
var TargetCtrl_TargetAndDirectoryPlural$1 = "Plans and Directories";
var TargetCtrl_TargetPlural$1 = "Plans";
var TargetCtrl_Users$1 = "People";
var TargetCtrl_WelcomeBack$1 = "Welcome back to your plan";
var TargetCtrl_YesAutopopulate$1 = "Yes, autopopulate";
var TargetAuthorsForm_A11yAuthorDescription$1 = "{{authorname}}. Click to manage all collaborators.";
var TargetAuthorsForm_Authors$1 = "Collaborators";
var TargetAuthorsForm_Save$1 = "Save changes";
var TargetAuthorsForm_SearchPeopleGroupsPlaceHolder$1 = "Search for people or groups";
var TargetAuthorsForm_SearchPlaceHolder$1 = "Search for people...";
var TargetAuthorsForm_Title$1 = "Manage Collaborators";
var TargetAuthorsForm_TitleAdd$1 = "Add Collaborators";
var Target_Delete$1 = "Delete";
var Target_EditDetails$1 = "Edit details";
var Target_Empty$1 = "Nothing has been added yet";
var Target_SetAuthoring$1 = "Add content";
var Target_SetNotAuthoring$1 = "Finished adding";
var Target_TargetLevelFormat$1 = "Target level {{level}}";
var TagsSvc_AddFocusSkillSuccess$1 = "Focus skill added successfully!";
var TagsSvc_AddSkillError$1 = "There was an error adding your skill.";
var TagsSvc_AddSkillsError$1 = "There was an error adding your skills.";
var TagsSvc_AddSkillsSuccess$1 = "Skills successfully added!";
var TagsSvc_AddSkillSuccess$1 = "Skill successfully added!";
var TagsSvc_CategoryAvailable$1 = "Sorry! There was a problem retrieving available categories.";
var TagsSvc_CategoryError$1 = "Sorry! There was a problem accessing your top categories.";
var TagsSvc_CategoryRetrieval$1 = "Sorry! There was a problem retrieving your categories.";
var TagsSvc_CategorySaves$1 = "Sorry! There was a problem saving your categories.";
var TagsSvc_ConvertSkills$1 = "Convert Skills";
var TagsSvc_ConvertWorkdaySkillsDescription$1 = "Selected skills will be converted to their Workday equivalents";
var TagsSvc_CreateError$1 = "Sorry! There was a problem saving your categories.";
var TagsSvc_CredentialableTagsError$1 = "Sorry! There was a problem retrieving skills.";
var TagsSvc_DeleteTagRatingError$1 = "There was an error canceling your rating. Try again.";
var TagsSvc_FocusSkillAlreadyAdded$1 = "Focus Skill already exists.";
var TagsSvc_GetTagError$1 = "An error occurred getting tag information.";
var TagsSvc_GetTagRatingDataError$1 = "Sorry, your skill ratings are unavailable at this time.";
var TagsSvc_GetTagRatingError$1 = "An error occurred getting rating information.";
var TagsSvc_MatchingCategoryError$1 = "Sorry! There was a problem retrieving matching categories.";
var TagsSvc_RateTagError$1 = "An error occurred while saving the rating.";
var TagsSvc_RecommendSkillError$1 = "There was a problem sending the skill recommendation";
var TagsSvc_RemoveFocusSkillSuccess$1 = "Focus skill removed successfully!";
var TagsSvc_RemoveSkillError$1 = "There was an error removing your skill.";
var TagsSvc_Replace$1 = "Replace";
var TagsSvc_ReplaceFocusInterestModalDescription$1 = "You already have <b>4 focus skills</b> selected. By choosing one of the skills below you can replace that focus skill.";
var TagsSvc_ReplaceFocusInterestModalTitle$1 = "Replace Focus Skill";
var TagsSvc_RequestTagRatingError$1 = "An error occurred requesting a rating.";
var TagsSvc_SkillsTagsError$1 = "Sorry! There was a problem retrieving skills.";
var TagsSvc_UpdateAssociateRatingSuccess$1 = "You completed the {{ratingType}}. {{requester}} will receive a notification about the completed skill rating.";
var TagsSvc_UpdateFocusSkillsError$1 = "Sorry! There was a problem saving your focus skills.";
var TagsSvc_UpdatePrivacyError$1 = "Sorry!  There was an error updating the privacy setting.";
var TagsSvc_UseWorkdaySkillNames$1 = "Use Workday skill names?";
var TagsSvc_WorkdayCanonicalSkillConversionInstructions$1 = "Skills you are adding have slightly different names within Workday. Use matching Workday skill names when available to ensure consistency in your profile across both platforms. Skills with corresponding Workday equivalents will be merged into a single, synced Workday skill. Exiting this modal will not add these skills to your profile.";
var TagsSearch_A11yTopTagsHint$1 = "Using the buttons below the text field, you can select suggested skills.";
var TagsSearch_SkillProficiencyLevelDocumentationLabel$1 = "Visit Degreed Skills for proficiency level descriptions";
var TagsFormCtrl_AddSkillsOrTopics$1 = "Add Skills";
var TagsFormCtrl_SearchForSkill$1 = "Search for skill";
var TagsEdit_AddCategories$1 = "Skills";
var TagsEdit_CategoriesMessage$1 = "Adding skills helps you track everything you learn. You can change your skills on your Profile page.";
var TagsCtrl_Category$1 = "Please add at least one skill.";
var TagsCtrl_CategoryHint$1 = "Tip: Enter a skill name, then you can choose from the list or use the enter key";
var TagsCtrl_SkillsPlaceholder$1 = "Enter a skill";
var TagsCtrl_SuggestedSkillsError$1 = "There was an error loading your skill suggestions";
var TagsCtrl_SuggestedSkillsForSkill$1 = 'Skill suggestions based on "{{skillName}}"';
var TagsCtrl_SuggestedSkillsLoading$1 = "Loading skill suggestions...";
var TagsCtrl_SuggestedSkillsTitle$1 = "Skill suggestions";
var TagRatingItem_TargetLevelFormat$1 = "Target Level: {{level}}";
var TagRating_AskForNewRating$1 = "Ask for a New Rating";
var TagRating_CancelRequest$1 = "Cancel request";
var TagRating_CancelRequestConfirmationFormat$1 = "You have a pending {{tagName}} rating request to {{raterName}}. Do you want to keep or cancel the request?";
var TagRating_CancelRequestConfirmationFormatNoManager$1 = "You have a pending {{tagName}} rating request to a deactivated user. Do you want cancel the request?";
var TagRating_ChangeRating$1 = "Change rating";
var TagRating_DeleteRatingFormat$1 = "Are you sure you want to delete the rating for {{tagName}}?";
var TagRating_KeepRequest$1 = "Keep Request";
var TagRating_PendingManagerRequest$1 = "Pending Manager Rating Request";
var TagRating_PendingPeerRequest$1 = "Pending Peer Rating Request";
var TagRating_SkillTargetSetFormat$1 = "{{nameHtml}} Updated your target to level {{level}}";
var TagRating_YouWereRatedFormat$1 = "{{nameHtml}} Rated you a level {{level}}";
var SkillTrends_CustomAttributes_ErrorMessage$1 = "Could not load attributes";
var SkillTrends_Declining$1 = "Declining";
var SkillTrends_Emerging$1 = "Emerging";
var SkillTrends_FilterByGroups$1 = "Filter by Groups";
var SkillTrends_FilterBySegments$1 = "Filter by Segments";
var SkillTrends_Groups_ErrorMessage$1 = "Could not load groups";
var SkillTrends_JobRoles_ErrorMessage$1 = "Could not load job roles";
var SkillTrends_NoMatchingGroups$1 = "No matching groups found";
var SkillTrends_NoMatchingSegments$1 = "No matching segments found";
var SkillTrends_NoResultsInfo$1 = "There isn’t enough information to display this data.";
var SkillTrends_NoResultsLabel$1 = "No Results";
var SkillTrends_NotEnoughDataLabel$1 = "No data is available for this chart";
var SkillTrends_SkillGaps_Chart_NoResults$1 = "No Results";
var SkillTrends_SkillGaps_Chart_NoResults_Info$1 = "There isn't enough information to display this data.";
var SkillTrends_SkillGaps_Chart_SeriesName_SkillGap$1 = "Skill Gap";
var SkillTrends_SkillGaps_Chart_SeriesName_SkillRating$1 = "Skill Rating";
var SkillTrends_SkillGaps_Chart_SeriesName_SkillTarget$1 = "Skill Target";
var SkillTrends_SkillGaps_Chart_Title$1 = "Gaps";
var SkillTrends_SkillGaps_Filters_JobRoles_Label$1 = "Job Roles";
var SkillTrends_SkillGaps_Filters_RatingTypes_Label$1 = "Rating Types";
var SkillTrends_SkillGaps_Filters_RatingTypes_Option_All$1 = "All";
var SkillTrends_SkillGaps_Filters_RatingTypes_Option_Manager$1 = "Manager";
var SkillTrends_SkillGaps_Filters_RatingTypes_Option_Peer$1 = "Peer";
var SkillTrends_SkillGaps_Filters_RatingTypes_Option_Self$1 = "Self";
var SkillTrends_SkillGaps_Filters_RatingTypes_Option_SkillReview$1 = "Skill Review";
var SkillTrends_SkillGaps_NoJobRolesMessage$1 = "To view this chart, add role plans with skills that have targets.";
var SkillTrends_SkillGaps_Section_Title$1 = "Gaps";
var SkillTrends_SkillGaps_Section_Tooltip$1 = "The job role with the highest number of users is preselected. You can switch job roles to view skill gaps in different roles.";
var SkillTrends_Tooltip_Declining$1 = "Skills with the greatest decrease in activity for the current time period, compared to the previous time period of the same length.";
var SkillTrends_Tooltip_Emerging$1 = "Skills with the greatest increase in activity for the current time period, compared to the previous time period of the same length.";
var SkillTrends_Tooltip_Trending$1 = "Skills with the most activity overall for the current time period. Movement up or down compares the current time period to the previous time period of the same length.";
var SkillTrends_Top$1 = "Top";
var SkillTrends_TopSearches_Title$1 = "Top Searches";
var SkillTrends_TopSearches_Tooltip$1 = "Skills with the greatest number of searches for the current time period. Movement up or down compares the current time period to the previous time period of the same length.";
var SkillTrends_Trending$1 = "Trending";
var SkillStd_AddDescription$1 = "Add Description";
var SkillStd_AddSkillToProfile$1 = "Add Skill To Profile";
var SkillStd_AddTitle$1 = "Add title";
var SkillStd_CreateSkillStandards$1 = "Create Skill Standards";
var SkillStd_DeleteSegmentMsg$1 = 'Removing "{{ segmentName }}" detaches it from all segments in "{{ skillStandardsName }}". This action is immediate and cannot be undone.\r\n\r\nAre you sure you would like to remove "{{ segmentName }}"?';
var SkillStd_DeleteSkillStandardsError$1 = "Sorry! There was a problem deleting the skill standard.";
var SkillStd_DeleteSkillStandardsSegmentError$1 = "Sorry! There was a problem removing the skill standard segment.";
var SkillStd_DeleteSkillStandardsSegmentSuccess$1 = "The skill standards segment {{name}} was removed successfully!";
var SkillStd_DeleteSkillStandardsSuccess$1 = "The skill standard {{name}} was deleted successfully!";
var SkillStd_DescriptionPlaceholder$1 = "Provide a description for your users";
var SkillStd_DescriptionSuggestionPlaceholder$1 = "Briefly describe what this Skill Standard is about.";
var SkillStd_EditDescription$1 = "Edit Description";
var SkillStd_EditSkillStandards$1 = "Edit Skill Standards";
var SkillStd_emptyStateAddSomethingToShowHere$1 = "When you add something, it will show here.";
var SkillStd_MaximumAddedSegmentsDesc$1 = "You can add up to {{ value }} segments per Skill Standards";
var SkillStd_MaximumAddedSegmentsReached$1 = "You’ve reached the maximum allowable number of segments for this Skill Standards";
var SkillStd_MinimumVisibleSkillWarning$1 = "At least one skill must be visible in order to publish this Segment.";
var SkillStd_NoVisibleSkills$1 = "No Visible Skills";
var SkillStd_NoVisibleSkillsUnpublishBody$1 = "There are no visible skills in {{segmentName}}. At least one skill must be visible to publish this segment.";
var SkillStd_NoVisibleSkillsUnpublishBodySecondary$1 = "Are you sure you want to unpublish {{segmentName}}?";
var SkillStd_PersonalSkillTarget$1 = "Personal Skill Target";
var SkillStd_PublishSegment$1 = "Publish Segment";
var SkillStd_RecommendedSkillsMessage$1 = "Your organization recommends these skills for your professional development.";
var SkillStd_RemoveSegment$1 = "Remove Segment";
var SkillStd_RemoveSegmentBody$1 = "Removing {{ segmentName }} affects all skill relationships for this segment. This action is immediate and cannot be undone.";
var SkillStd_RemoveSkill$1 = "Remove Skill";
var SkillStd_RemoveSkillBody$1 = "Removing {{skillName}} detaches it from all segments in {{ skillStandardsName}}. This action is immediate and cannot be undone.";
var SkillStd_RemoveSkillBodySecondary$1 = "Are you sure you would like to remove {{ skillName }}?";
var SkillStd_RemoveSkillError$1 = "Sorry! There was a problem removing the skill from the skill standard.";
var SkillStd_RemoveSkillSuccess$1 = "You’ve successfully removed {{ skillName }} from {{ skillStandard }}";
var SkillStd_RequirementStatus$1 = "Requirement Status";
var SkillStd_SegmentAddedSuccessPlural$1 = "You’ve successfully added segments to {{ skillStandardsName }}";
var SkillStd_SegmentAddedSuccessSingle$1 = "You’ve successfully added a segment to {{ skillStandardsName }}";
var SkillStd_SegmentPublishRequirementsNotMet$1 = "{{ name }} could not be published. Please make sure all requirements are met to publish this segment.";
var SkillStd_Segments$1 = "Segments";
var SkillStd_SkillAddedSuccessPlural$1 = "You’ve successfully added skills to {{ skillStandardsName }}";
var SkillStd_SkillAddedSuccessSingle$1 = "You’ve successfully added a skill to {{ skillStandardsName }}";
var SkillStd_SkillRemovedSegmentUnpublished_Multiple$1 = "{{ skillName }} was removed. {{ count }} Segments were unpublished.";
var SkillStd_SkillRemovedSegmentUnpublished_Single$1 = "{{ skillName }} was removed. {{ segmentName }} has been unpublished.";
var SkillStd_SkillRequired$1 = "Critical";
var SkillStd_SkillSet$1 = "Skill Set";
var SkillStd_SkillSetRelationships$1 = "Skill Set Relationships";
var SkillStd_SkillStandards$1 = "Skill Standards";
var SkillStd_SkillStandardsProfileSectionSubtitle$1 = "These Skill Standards have been curated for you by your admin";
var SkillStd_SkillTargets$1 = "Skill Targets";
var SkillStd_SkillVisible$1 = "Visible";
var SkillStd_Status_NoSegments$1 = "No Segments";
var SkillStd_Status_UnpublishedSegments$1 = "Unpublished Segments";
var SkillStd_SuccessfullyPublished$1 = "{{ name }} has been successfully published.";
var SkillStd_SuccessfullyUnpublished$1 = "{{ name }} has been successfully unpublished.";
var SkillStd_TitleAlreadyExistsError$1 = "This title already exists. Please enter a new title.";
var SkillStd_TitleSuggestionPlaceholder$1 = "E.g. New Employee Onboarding";
var SkillStd_Unpublished$1 = "Unpublished";
var SkillStd_UnpublishedSegmentsWarning$1 = "Unpublished Segments have been added to this Skill Standard. These Segments will not be active until they have been published to the organization.";
var SkillStd_UnpublishSegment$1 = "Unpublish Segment";
var SkillStd_UnpublishSegmentMsg$1 = "Unpublishing this segment will affect the way all of its associated skills display to all users within the segment.";
var SkillStd_UnpublishSegmentMsgConfirm$1 = "Are you sure you want to unpublish this segment?";
var SkillStd_UnpublishSegmentName$1 = "Unpublish {{segmentName}}";
var SkillsSvc_AddPrimarySkillSource$1 = "Add Primary Skill Source";
var SkillsSvc_AddRoleError$1 = "Sorry! There was a problem adding the role.";
var SkillsSvc_AddRoleSuccess$1 = "The role was added successfully!";
var SkillsSvc_AddSkill$1 = "Add Skill";
var SkillsSvc_AddSkillError$1 = "Sorry! There was a problem adding the skill.";
var SkillsSvc_AddSkillNameInputDescription$1 = "Add English spelling first. Translations can be managed once skill is saved.";
var SkillsSvc_AddSkillSource$1 = "Add Skill Source";
var SkillsSvc_AddSkillSuccess$1 = "The skill was added successfully!";
var SkillsSvc_AddTranslations$1 = "Add Translations...";
var SkillsSvc_AttemptPublishAgain$1 = "Try to publish again. If the problem persists, please contact Degreed Support.";
var SkillsSvc_Categories$1 = "Categories";
var SkillsSvc_Category$1 = "Category";
var SkillsSvc_CategoryCreateAgainError$1 = "Something went wrong while creating the category. Try again.";
var SkillsSvc_CategorySuccessfullyCreated$1 = "Category Successfully Created";
var SkillsSvc_CategorySuccessfullyUpdated$1 = "Category successfully updated.";
var SkillsSvc_CountSkillCategoriesPlural$1 = "+{{ count }} Categories";
var SkillsSvc_CountSkillCategoriesSingular$1 = "+1 Category";
var SkillsSvc_CountSkillSynonymsPlural$1 = "+{{ count }} Synonymous Skills";
var SkillsSvc_CountSkillSynonymsSingular$1 = "+1 Synonymous Skill";
var SkillsSvc_CreateSkillTip$1 = "<strong>PRO TIP:</strong> Let Degreed do the work for you. Add the skill name in English first, then save to get suggested skill descriptions, synonyms, and more from the Degreed canonical skill list.";
var SkillsSvc_CTASourcesDesc$1 = "Collections of skills used to define the {{ orgName }} skill inventory";
var SkillsSvc_CTASuggestionsDesc$1 = "Keep {{ orgName }} skills up to date by reviewing suggested updates";
var SkillsSvc_CTAUnpublishedChangesDesc$1 = "Publish changes to update the {{ orgName }} LXP";
var SkillsSvc_CTAUnpublishedSkills$1 = "Unpublished Skills";
var SkillsSvc_CurrentDescription$1 = "<strong>Current Description:</strong> {{description}}";
var SkillsSvc_CurrentSynonymousSkills$1 = "Current Synonymous Skills";
var SkillsSvc_CurrentTitle$1 = "Current Title: {{title}}";
var SkillsSvc_DeleteLanguageTranslation$1 = "Delete the {{language}} translation for the skill {{skillName}}";
var SkillsSvc_DeleteRoleError$1 = "Sorry! There was a problem deleting the role.";
var SkillsSvc_DeleteRoleSuccess$1 = "The role '{{name}}' was deleted successfully!";
var SkillsSvc_DeleteSkillError$1 = "Sorry! There was a problem deleting the skill.";
var SkillsSvc_DeleteSkillSource$1 = "Delete Skill Source";
var SkillsSvc_DeleteSkillSourceDescription$1 = "Delete the Skill Source {{Source_Name}} for the organization.";
var SkillsSvc_DeleteSkillSuccess$1 = "The skill '{{name}}' was deleted successfully!";
var SkillsSvc_DeleteTranslation$1 = "Delete Translation";
var SkillsSvc_EditRoleError$1 = "Sorry! There was a problem saving the role.";
var SkillsSvc_EditRoleSuccess$1 = "The role was saved successfully!";
var SkillsSvc_EditSkill$1 = "Edit Skill";
var SkillsSvc_EditSkillError$1 = "Sorry! There was a problem saving the skill.";
var SkillsSvc_EditSkillSuccess$1 = "The skill was saved successfully!";
var SkillsSvc_EditsToSkills$1 = '"Edits to {{unpublishedChangesCount}} skills"';
var SkillsSvc_EnableEndorseSkillOption$1 = "If enabled, an icon appears on the card to show you endorsed this skill.";
var SkillsSvc_EnableSkillReview$1 = "Enable for Skill Review";
var SkillsSvc_EndorseSkill$1 = "Endorse Skill";
var SkillsSvc_FileUploadSuccessful$1 = "File Upload Successful";
var SkillsSvc_FileUploadSuccessfulDescription$1 = "{{fileName}} uploaded to {{skillSourceName}}";
var SkillsSvc_GetStarted_Dashboard$1 = "Get Started with Degreed Skills and superpower your learning.";
var SkillsSvc_GetStarted_Dashboard_Description$1 = "First things first, add a skill source and its skills to your Inventory.";
var SkillsSvc_ImportantPublishingInfo$1 = "Important Publishing Information";
var SkillsSvc_IntegrationSourceEditTip$1 = "Integrations are defined by an external source, have limited editing options, and cannot be deleted. To disable a skills integration, {{contactSupportHtml}}";
var SkillsSvc_ItemsAreNowAvailable$1 = "Items are now available in the LXP.";
var SkillsSvc_JobRoles$1 = "Job Roles";
var SkillsSvc_JobRolesDescription$1 = "Groups of related skills based on shared characteristics, functions, or domains of expertise.";
var SkillsSvc_LimitVisibilityToTheseGroups$1 = "Limit visibility to these groups";
var SkillsSvc_ManageCategories$1 = "Manage Categories";
var SkillsSvc_ManageSources$1 = "Manage Sources";
var SkillsSvc_MoreItems$1 = "+ {{count}} others";
var SkillsSvc_NewSkillDescription$1 = "New Skill Description";
var SkillsSvc_NewSkillSpelling$1 = "New Skill Spelling";
var SkillsSvc_NoPublishedHistory$1 = "No published history";
var SkillsSvc_OnboardingAddedNotification$1 = "Item added to suggestions successfully";
var SkillsSvc_OnboardingError$1 = "Sorry! There was a problem saving your changes.";
var SkillsSvc_OnboardingRemovedNotification$1 = "Item removed successfully";
var SkillsSvc_OneMoreItem$1 = "+ 1 other";
var SkillsSvc_OneTranslationSavedMsg$1 = "{{count}} translation was added to {{skillName}}";
var SkillsSvc_OrgNameSkillsOnly$1 = "{{ orgName }} Skills Only";
var SkillsSvc_PrimarySourceEditTip$1 = "This is the primary skill source for {{orgName}} and cannot be deleted.";
var SkillsSvc_Proficiency$1 = "Proficiency";
var SkillsSvc_Proficiency_Custom$1 = "custom";
var SkillsSvc_Proficiency_Default$1 = "default";
var SkillsSvc_Proficiency_Description_SubTitle$1 = "Customize the skill proficiency description for this skill.";
var SkillsSvc_Proficiency_Description_Title$1 = "Skill proficiency description";
var SkillsSvc_Proficiency_InferDescription$1 = "Infer Description";
var SkillsSvc_Proficiency_Reset_Description$1 = "Reset Descriptions";
var SkillsSvc_Proficiency_Reset_Description_Content$1 = "Resetting the skill proficiency level descriptions for {{skillName}} will default all descriptions back to your default organization level descriptions.";
var SkillsSvc_PromoteSkillToOrg$1 = "+ Add to {{orgName}} Skills";
var SkillsSvc_Proprietary$1 = "Proprietary";
var SkillsSvc_ProprietarySkillOption$1 = "Proprietary skills will not have recommended descriptions, synonyms, or related skills.";
var SkillsSvc_ProprietaryToOrgLabel$1 = "Proprietary to {{orgName}}";
var SkillsSvc_PublishChangesToOrgName$1 = "Publish changes to update the {{ orgName }} LXP.";
var SkillsSvc_PublishedSuccessfully$1 = "Published Successfully";
var SkillsSvc_PublishSkillCount$1 = "Publish {{publishSkillCount}} Skills";
var SkillsSvc_PublishToLxp$1 = "Publish To LXP";
var SkillsSvc_PublishWarning$1 = "You are about to publish the following to all learners in your organization's Degreed LXP instance.";
var SkillsSvc_RetrieveError$1 = "Sorry! There was a problem retrieving the content.";
var SkillsSvc_ReviewSuggestions$1 = "Review Suggestions";
var SkillsSvc_RolesBulkUploadNotice$1 = "The file you uploaded is being processed. Changes based on this file may take up to 4 hours to appear in Degreed.";
var SkillsSvc_RoleSuggestions$1 = "Role Suggestions";
var SkillsSvc_Save_Upload$1 = "Save and Upload";
var SkillsSvc_SearchGroups$1 = "Search groups";
var SkillsSvc_SearchRoles$1 = "Search roles";
var SkillsSvc_SearchSkillCategories$1 = "Search Categories";
var SkillsSvc_SearchSkills$1 = "Search skills";
var SkillsSvc_SillAlreadyExistsInOrg$1 = "Skill already in {{orgName}} skills inventory.";
var SkillsSvc_SkillCategories$1 = "Skill Categories";
var SkillsSvc_SkillCategoriesDescription$1 = "Groups of related skills based on shared characteristics, functions, or domains of expertise.";
var SkillsSvc_SkillId$1 = "Skill ID";
var SkillsSvc_SkillReviewEnableOption$1 = "Allow Skill Review in this skill for learners who belong to this organization.";
var SkillsSvc_SkillReviewVisibility$1 = "Skill Review Visibility";
var SkillsSvc_SkillReviewVisibilityDescription$1 = "Define who has access to skill review ratings";
var SkillsSvc_SkillsBulkUploadNotice$1 = "The file you uploaded is being processed. Changes based on this file may take up to 4 hours to appear in Degreed.";
var SkillsSvc_SkillSourceCreated$1 = "{{skillSourceName}} Created Successfully!";
var SkillsSvc_SkillSourceCreatedDescription$1 = "Upload your skills file to finish creating this skill source.";
var SkillsSvc_SkillSourceDescription$1 = "Skill Source Description";
var SkillsSvc_SkillSourceName$1 = "Skill Source Name";
var SkillsSvc_SkillSources$1 = "Skill Sources";
var SkillsSvc_SkillSuggestionDrawerTitle$1 = "Skill Suggestions";
var SkillsSvc_SkillSynonymError$1 = "{{skillName}} already added as {{synonymName}}";
var SkillsSvc_SkillTitle$1 = "Skill Title";
var SkillsSvc_SkillUpdatedSuccessfully$1 = "Changes to {{skillName}} saved successfully.";
var SkillsSvc_SkipForNow$1 = "Skip for now";
var SkillsSvc_SourceAlreadyExistsInOrg$1 = "Skill source name already in {{orgName}} skills inventory.";
var SkillsSvc_SuggestedSkillDescription$1 = "Suggested Skill Description";
var SkillsSvc_SuggestedSkillTitle$1 = "Suggested Skill Title";
var SkillsSvc_SuggestedSynonymousSkills$1 = "Suggested Synonymous Skills";
var SkillsSvc_suggestions_sub_header_text$1 = "Inferred suggestions from Degreed’s normalized skill set.";
var SkillsSvc_SuggestionsApplied$1 = "{{number}} suggestions for {{skillName}} applied.";
var SkillsSvc_SuggestionsDeclined$1 = "{{number}} suggestions for {{skillName}} declined.";
var SkillsSvc_SynonymAlreadyExistsMessaging$1 = "A synonym label can only be linked to one skill. If you are unable to add it here, it's already linked to another skill.";
var SkillsSvc_SynonymousSkills$1 = "Synonymous Skills";
var SkillsSvc_SynonymousSkills_MergeModal_button$1 = "Merge Skills";
var SkillsSvc_SynonymousSkills_MergeModal_paragraph_1$1 = "{{synonymousSkillName}} is currently active in the {{orgName}} skill inventory. If you publish it as a synonym for {{skillName}},  {{synonymousSkillName}} will be hidden, and its information will be merged under {{skillName}} throughout the Degreed LXP.";
var SkillsSvc_SynonymousSkills_MergeModal_paragraph_2$1 = "If you remove it as a synonym while it is still in draft state, {{synonymousSkillName}} will become available again in the {{orgName}} skill inventory.";
var SkillsSvc_SynonymousSkills_MergeModal_title$1 = "Merge skills";
var SkillsSvc_SynonymousSkillsDescription$1 = "Alternative spelling, terms or phrases used interchangeably with Skill Name.";
var SkillsSvc_TotalSuggestionsSelected$1 = "Total suggestions selected";
var SkillsSvc_Translations$1 = "{{skillName}} Translations";
var SkillsSvc_TranslationsSaved$1 = "Translations saved";
var SkillsSvc_TranslationsSavedMsg$1 = "{{count}} translations were added to {{skillName}}";
var SkillsSvc_TryAgainOrContactSupport$1 = "Try again and if the problem persists, contact Degreed support.";
var SkillsSvc_UnpublishedChange$1 = "{{ number }} unpublished change";
var SkillsSvc_UnpublishedChanges$1 = "{{ number }} unpublished changes";
var SkillsSvc_UnpublishedChanges_None$1 = "{{ zero }} unpublished changes";
var SkillsSvc_UpdateError$1 = "Sorry! There was a problem updating the skill.";
var SkillsSvc_UpdateRoleError$1 = "Sorry! There was a problem updating the role.";
var SkillsSvc_UpdateRoleSuccess$1 = "The role was updated successfully!";
var SkillsSvc_UploadRoleError$1 = "Sorry! There was a problem uploading the roles.";
var SkillsSvc_UploadSkillError$1 = "Sorry! There was a problem uploading the skills.";
var SkillsSvc_UsersTitle$1 = "People who are following this";
var SkillsSvc_ZeroTranslationSavedMsg$1 = "{{count}} translations were added to {{skillName}}";
var SkillSectionsChart_AboveTarget$1 = "Above Target (Level {{ratingNumber}})";
var SkillSectionsChart_AllSectionSkills$1 = "All Section Skills";
var SkillSectionsChart_AtTarget$1 = "At Target (Level {{ratingNumber}})";
var SkillSectionsChart_AvgRatingFormat$1 = "{{avg}} average rating";
var SkillSectionsChart_BelowTarget$1 = "Below Target (Level {{ratingNumber}})";
var SkillSectionsChart_Level$1 = "Level {{ratingNumber}}";
var SkillSectionsChart_NoData$1 = "Add skills to this section to see how they are performing.";
var SkillSectionsChart_NoRatings$1 = "There are no ratings yet.";
var SkillSectionsChart_NoTarget$1 = "This skill does not have a target.";
var SkillSectionsChart_PercentFormat$1 = "{{numberPercent}}%";
var SkillSectionsChart_PercentOfRatings$1 = "% of ratings";
var SkillSectionsChart_PlanFollowersFormat$1 = "({{followerCount}}) of plan followers have a rating for this skill.";
var SkillSectionsChart_PlanRatingsFormat$1 = "({{ratingsAboveTargetCount}}) of ratings are at or above the target level.";
var SkillSectionsChart_PluralRatings$1 = "ratings";
var SkillSectionsChart_ReviewCertificationNotAvailable$1 = "Skill Review/Degreed Certification is not available for this skill yet.";
var SkillSectionsChart_SingularRating$1 = "rating";
var SkillSectionsChart_SkillCertifications$1 = "Degreed Certified";
var SkillSectionsChart_SkillFollowersFormat$1 = "({{followersCount}}) of learners in {{orgName}} follow this skill";
var SkillSectionsChart_SkillRatingsBreakdown$1 = "Skill Rating Breakdown";
var SkillSectionsChart_SkillRatingsFormat$1 = "({{ratingsCount}}) of learners in {{orgName}} rated this skill";
var SkillSectionsChart_Team_NoRatings$1 = "No ratings to display.";
var SkillSectionsChart_TeamMembers_AvgFormat$1 = '<span class="color-ocean">{{avg}}</span> average rating';
var SkillSectionsChart_TeamMembers_FollowFormat$1 = "({{followersCount}}) of team members follow this skill";
var SkillSectionsChart_TeamMembers_RatingsFormat$1 = "({{ratingsCount}}) of team members rated this skill";
var SkillSearchCtrl_ComingSoon$1 = "Coming Soon";
var SkillSearchCtrl_EmailAddress$1 = "Email Address";
var SkillSearchCtrl_GetCertifiedToday$1 = "Get your {{name}} skill certified today, starting at ${{price}}";
var SkillSearchCtrl_GetNotified$1 = "Get Notified";
var SkillSearchCtrl_NoMatch$1 = "Degreed Skill Certification is currently not available for this skill. Enter your email to sign up for notifications when new skills are added.";
var SkillSearchCtrl_SearchForSkill$1 = "Search for a Skill";
var SkillRegistrySearch_SkillRegistrySuggestions$1 = "Skills Registry Suggestions";
var SkillRatingTypeChart_Legend_Manager$1 = "Manager";
var SkillRatingTypeChart_Legend_Peer$1 = "Peer";
var SkillRatingTypeChart_Legend_Self$1 = "Self";
var SkillRatingTypeChart_Legend_SkillReview$1 = "Skill Review";
var SkillRatingTypeChart_LegendTitle$1 = "Total";
var SkillRatingTypeChart_Title$1 = "Ratings";
var SkillRatingTypeChart_TooltipText$1 = "Includes the total number of all skill ratings by type, and the number of ratings for each type, for the current time period.";
var SkillRatingTypeChart_XAxis_Label$1 = "Date Range";
var SkillRatingTypeChart_YAxis_Label$1 = "Total Skill Rating";
var SkillRatingsChart_AllTypes$1 = "All Types";
var SkillRatingsChart_AlphabeticalOrder$1 = "Alphabetical";
var SkillRatingsChart_Average$1 = "Average";
var SkillRatingsChart_AverageSkillRating$1 = "Average skill rating";
var SkillRatingsChart_avgSkillRatingFormat$1 = "{{avg}} average skill rating";
var SkillRatingsChart_certified$1 = "certified";
var SkillRatingsChart_DegreedCertified$1 = "Degreed Certified";
var SkillRatingsChart_Description$1 = "Only skills with ratings for two or more individuals appear on this chart.";
var SkillRatingsChart_EmptyStateText$1 = "No rating data to display.<br>Only skills with ratings for {{ x }} or more individuals appear on this chart.";
var SkillRatingsChart_Evaluations$1 = "Skill Reviews";
var SkillRatingsChart_High$1 = "High";
var SkillRatingsChart_learner$1 = "1 learner";
var SkillRatingsChart_learnerPluralFormat$1 = "{{numOfLearners}} learners";
var SkillRatingsChart_Low$1 = "Low";
var SkillRatingsChart_manager$1 = "manager";
var SkillRatingsChart_ManagerRatings$1 = "Manager Ratings";
var SkillRatingsChart_Medium$1 = "Medium";
var SkillRatingsChart_MostRatings$1 = "Most ratings";
var SkillRatingsChart_NoData$1 = "No ratings to display.<br>Only skills with ratings for two or more individuals appear on this chart.";
var SkillRatingsChart_NumberOfSkillsShownPluralFormat$1 = "{{tagCount}} of {{totalTagCount}} skills";
var SkillRatingsChart_NumberOfSkillsShownSingularFormat$1 = "{{tagCount}} of {{totalTagCount}} skill";
var SkillRatingsChart_NumberOfSkillsShownTopFormat$1 = "Top {{tagCount}} of {{totalTagCount}} skills";
var SkillRatingsChart_Range$1 = "Range";
var SkillRatingsChart_Rating$1 = "Rating";
var SkillRatingsChart_Ratings$1 = "Ratings:";
var SkillRatingsChart_RatingType$1 = "All types";
var SkillRatingsChart_Representativeness$1 = "Representation:";
var SkillRatingsChart_review$1 = "review";
var SkillRatingsChart_Rigor$1 = "Rigor:";
var SkillRatingsChart_self$1 = "self";
var SkillRatingsChart_SelfRatings$1 = "Self Ratings";
var SkillRatingsChart_SkillInventory$1 = "Skill Inventory";
var SkillRatingsChart_StatsTitle$1 = "Data Considerations";
var SkillRatingsChart_TargetLevel$1 = "Target Level";
var SkillRatingsChart_Text$1 = "Only skills with ratings for {{ x }} or more individuals appear on this chart.";
var SkillRatingsChart_TotalRatingsFormat$1 = "{{total}} learners";
var SkillRatingsChart_TotalSkillRatings$1 = "Total skill ratings";
var SkillProgressionChart_AvgRating$1 = "{{number}} average skill rating";
var SkillProgressionChart_AvgSkillRating$1 = "Average skill rating";
var SkillProgressionChart_NumberOfLearners$1 = "Number of learners";
var SkillProgressionChart_NumberOfRatingsPlural$1 = "{{number}} ratings";
var SkillProgressionChart_NumberOfRatingsSingle$1 = "{{number}} rating";
var SkillProgressionChart_Ratings$1 = "{{number}} learners";
var SkillProgressionChart_SkillProgression$1 = "Skill Progression";
var SkillProgressionChart_SkillSupply$1 = "Skill Supply";
var SkillProgressionChart_SubtitlePluralFormat$1 = "{{ topCount }} of {{ totalCount }} skills";
var SkillProgressionChart_SubtitleSingularFormat$1 = "{{ topCount }} of {{ totalCount }} skill";
var SkillProgressionChart_SubtitleTopFormat$1 = "Top {{ topCount }} of {{ totalCount }} skills";
var SkillProgressionChart_Title$1 = "Skill Growth";
var SkillProgressionChart_XAxis$1 = "Date range";
var SkillProgressionChart_YAxis$1 = "Number of learners";
var SkillInsights_MinimumRatingNotice$1 = "Only skills with ratings for two or more individuals appear on this page.";
var SkillInsights_RatingNotice$1 = "Only skills with ratings for {{ x }} or more individuals appear on this page.";
var SkillFormCtrl_AddLink$1 = "Add Link";
var SkillFormCtrl_Description$1 = "Description";
var SkillFormCtrl_SkillCategory$1 = "Please add at least one category.";
var SkillFormCtrl_SkillDescription$1 = "A skill description is required.";
var SkillFormCtrl_Url$1 = "URL";
var SkillActivityChart_Title$1 = "Activity";
var SkillActivityChart_TooltipText$1 = "Shows the level of activity by type for each skill, for the current time period. Skills with the most activity are listed first.";
var singleRecommendation_groupAlreadyCompletedArticleDateFormat$1 = "{{nameHtml}} shared  the article {{title}} with {{groupNameHtml}}, but you’ve already read it! Great job, overachiever.";
var singleRecommendation_groupAlreadyCompletedArticleFormat$1 = "{{nameHtml}} shared the article {{title}} with {{groupNameHtml}}, but you’ve already read it! Great job, overachiever.";
var singleRecommendation_groupAlreadyCompletedAssessmentDateFormat$1 = "{{nameHtml}} shared the assessment {{title}} with {{groupNameHtml}}, but you’ve already completed it! Great job, overachiever.";
var singleRecommendation_groupAlreadyCompletedAssessmentFormat$1 = "{{nameHtml}} shared the assessment {{title}} with {{groupNameHtml}}, but you’ve already completed it! Great job, overachiever.";
var singleRecommendation_groupAlreadyCompletedBookFormat$1 = "{{nameHtml}} shared the book {{title}} with {{groupNameHtml}}, but you’ve already read it! Great job, overachiever.";
var singleRecommendation_groupAlreadyCompletedCourseFormat$1 = "{{nameHtml}} shared the course {{title}} with {{groupNameHtml}}, but you’ve already completed it! Great job, overachiever.";
var singleRecommendation_groupAlreadyCompletedEpisodeDateFormat$1 = "{{nameHtml}} shared an episode {{title}} with {{groupNameHtml}}, but you’ve already listened to it! Great job, overachiever.";
var singleRecommendation_groupAlreadyCompletedEpisodeFormat$1 = "{{nameHtml}} shared an episode {{title}} with {{groupNameHtml}}, but you’ve already listened to it! Great job, overachiever.";
var singleRecommendation_groupAlreadyCompletedEventDateFormat$1 = "{{nameHtml}} shared the event {{title}} with {{groupNameHtml}}, but you’ve already attended to it! Great job, overachiever.";
var singleRecommendation_groupAlreadyCompletedEventFormat$1 = "{{nameHtml}} shared the event {{title}} with {{groupNameHtml}}, but you’ve already attended to it! Great job, overachiever.";
var singleRecommendation_GroupAlreadyCompletedFormat$1 = "{{nameHtml}} shared this {{type}} with {{groupNameHtml}}, but you’ve already completed it. Great job!";
var singleRecommendation_groupAlreadyCompletedPathwayDateFormat$1 = "{{nameHtml}} share the pathway {{title}} with {{groupNameHtml}}, but you’ve already completed it! Great job, overachiever.";
var singleRecommendation_groupAlreadyCompletedPathwayFormat$1 = "{{nameHtml}} shared the pathway {{title}} with {{groupNameHtml}}, but you’ve already completed it! Great job, overachiever.";
var singleRecommendation_groupAlreadyCompletedVideoDateFormat$1 = "{{nameHtml}} shared the video {{title}} with {{groupNameHtml}}, but you’ve already watched it! Great job, overachiever.";
var singleRecommendation_groupAlreadyCompletedVideoFormat$1 = "{{nameHtml}} shared the video {{title}} with {{groupNameHtml}}, but you’ve already watched it! Great job, overachiever.";
var singleRecommendation_groupArticleDateFormat$1 = "{{nameHtml}} shared the article {{title}} with {{groupNameHtml}}";
var singleRecommendation_groupArticleFormat$1 = "{{nameHtml}} shared this article with {{groupNameHtml}}";
var singleRecommendation_groupAssessmentDateFormat$1 = "{{nameHtml}} shared the assessment {{title}} with {{groupNameHtml}}";
var singleRecommendation_groupAssessmentFormat$1 = "{{nameHtml}} shared the assessment {{title}} with {{groupNameHtml}}";
var singleRecommendation_groupBookDateFormat$1 = "{{nameHtml}} shared the book {{title}} with {{groupNameHtml}}";
var singleRecommendation_groupBookFormat$1 = "{{nameHtml}} shared the book {{title}} with {{groupNameHtml}}";
var singleRecommendation_groupCourseDateFormat$1 = "{{nameHtml}} shared the course {{title}} with {{groupNameHtml}}";
var singleRecommendation_groupCourseFormat$1 = "{{nameHtml}} shared  the course {{title}} with {{groupNameHtml}}";
var singleRecommendation_groupEpisodeDateFormat$1 = "{{nameHtml}} shared an episode {{title}} with {{groupNameHtml}}";
var singleRecommendation_groupEpisodeFormat$1 = "{{nameHtml}} shared an episode {{title}} with {{groupNameHtml}}";
var singleRecommendation_groupEventDateFormat$1 = "{{nameHtml}} shared the event {{title}} with {{groupNameHtml}}";
var singleRecommendation_groupEventFormat$1 = "{{nameHtml}} shared the event {{title}} with {{groupNameHtml}}";
var singleRecommendation_GroupFollowFormat$1 = "{{nameHtml}} shared this with {{groupNameHtml}}.";
var singleRecommendation_GroupFormat$1 = "{{nameHtml}} shared this with {{groupNameHtml}}";
var singleRecommendation_groupPathwayDateFormat$1 = "{{nameHtml}} shared the pathway {{title}} with {{groupNameHtml}}";
var singleRecommendation_groupPathwayFormat$1 = "{{nameHtml}} shared the pathway {{title}} with {{groupNameHtml}}";
var singleRecommendation_groupTargetDateFormat$1 = "{{nameHtml}} shared the role {{title}} with {{groupNameHtml}}";
var singleRecommendation_groupTargetFormat$1 = "{{nameHtml}} shared the plan {{title}} with {{groupNameHtml}}";
var singleRecommendation_groupVideoDateFormat$1 = "{{nameHtml}} shared the video {{title}} with {{groupNameHtml}}";
var singleRecommendation_groupVideoFormat$1 = "{{nameHtml}} shared the video {{title}} with {{groupNameHtml}}";
var singleRecommendation_GroupYouAlreadyFollowFormat$1 = "{{nameHtml}} shared this with {{groupNameHtml}}, but you’re already following it.";
var singleRecommendation_youAlreadyCompletedArticleDateFormat$1 = "{{nameHtml}} shared the article {{title}} with you, but you’ve already read it! Great job, overachiever.";
var singleRecommendation_youAlreadyCompletedArticleFormat$1 = "{{nameHtml}} shared the article {{title}} with you, but you’ve already read it! Great job, overachiever.";
var singleRecommendation_youAlreadyCompletedAssessmentDateFormat$1 = "{{nameHtml}} shared the assessment {{title}} with you";
var singleRecommendation_youAlreadyCompletedAssessmentFormat$1 = "{{nameHtml}} shared the assessment {{title}} with you";
var singleRecommendation_youAlreadyCompletedBookFormat$1 = "{{nameHtml}} shared the book {{title}} with you, but you’ve already read it! Great job, overachiever.";
var singleRecommendation_youAlreadyCompletedCourseDateFormat$1 = "{{nameHtml}} shared the course {{title}} with you, but you’ve already completed it! Great job, overachiever.";
var singleRecommendation_youAlreadyCompletedCourseFormat$1 = "{{nameHtml}} shared the course {{title}} with you, but you’ve already completed it! Great job, overachiever.";
var singleRecommendation_youAlreadyCompletedEpisodeDateFormat$1 = "{{nameHtml}} shared an episode {{title}} with you, but you’ve already listened to it! Great job, overachiever.";
var singleRecommendation_youAlreadyCompletedEpisodeFormat$1 = "{{nameHtml}}shared an episode {{title}} with you, but you’ve already listened to it! Great job, overachiever.";
var singleRecommendation_youAlreadyCompletedEventDateFormat$1 = "{{nameHtml}} shared the event {{title}} with you, but you’ve already attended it! Great job, overachiever.";
var singleRecommendation_youAlreadyCompletedEventFormat$1 = "{{nameHtml}} shared the event {{title}} with you , but you’ve already attended it! Great job, overachiever.";
var singleRecommendation_YouAlreadyCompletedFormat$1 = "{{nameHtml}} shared this with you, but you’ve already completed it. Great job!";
var singleRecommendation_youAlreadyCompletedPathwayFormat$1 = "{{nameHtml}} shared this with you, but you’ve already followed it. Great job!";
var singleRecommendation_youAlreadyCompletedTargetDateFormat$1 = "{{nameHtml}} shared the role {{title}} with you, but you’ve already followed it! Great job, overachiever.";
var singleRecommendation_youAlreadyCompletedTargetFormat$1 = "{{nameHtml}} shared the plan {{title}}, but you’ve already followed it! Great job, overachiever.";
var singleRecommendation_youAlreadyCompletedVideoDateFormat$1 = "{{nameHtml}} shared the video {{title}} with you, but you’ve already watched it! Great job, overachiever.";
var singleRecommendation_youAlreadyCompletedVideoFormat$1 = "{{nameHtml}} shared the video {{title}} with you, but you’ve already watched it! Great job, overachiever.";
var singleRecommendation_YouAlreadyFollowFormat$1 = "{{nameHtml}} shared this with you, but you’re already following it.";
var singleRecommendation_youArticleFormat$1 = "{{nameHtml}} shared the article {{title}} with you";
var singleRecommendation_youAssessmentDateFormat$1 = "{{nameHtml}} shared the assessment {{title}} with you";
var singleRecommendation_youAssessmentFormat$1 = "{{nameHtml}} shared the assessment {{title}} with you";
var singleRecommendation_youBookDateFormat$1 = "{{nameHtml}} shared the book {{title}} with you";
var singleRecommendation_youBookFormat$1 = "{{nameHtml}} shared the book {{title}} with you";
var singleRecommendation_youCourseDateFormat$1 = "{{nameHtml}} shared the course {{title}} with you";
var singleRecommendation_youCourseFormat$1 = "{{nameHtml}} shared the course {{title}} with you";
var singleRecommendation_youEpisodeDateFormat$1 = "{{nameHtml}} shared an episode {{title}} with you";
var singleRecommendation_youEpisodeFormat$1 = "{{nameHtml}} shared an episode {{title}} with you";
var singleRecommendation_youEventDateFormat$1 = "{{nameHtml}} shared the event {{title}} with you";
var singleRecommendation_youEventFormat$1 = "{{nameHtml}} shared the event {{title}} with you";
var singleRecommendation_YouFollowFormat$1 = "{{nameHtml}} shared the {{type}} {{title}} with you.";
var singleRecommendation_YouFormat$1 = "{{nameHtml}} shared this with you";
var singleRecommendation_youPathwayDateFormat$1 = "{{nameHtml}} shared the pathway {{title}} with you";
var singleRecommendation_youPathwayFormat$1 = "{{nameHtml}} shared the pathway {{title}} with you";
var singleRecommendation_youPositionDateFormat$1 = "{{nameHtml}} shared the position {{title}} with you";
var singleRecommendation_youTargetDateFormat$1 = "{{nameHtml}} shared the role {{title}} with you";
var singleRecommendation_youTargetFormat$1 = "{{nameHtml}} shared the plan {{title}} with you";
var singleRecommendation_youVideoDateFormat$1 = "{{nameHtml}} shared the video {{title}} with you";
var singleRecommendation_youVideoFormat$1 = "{{nameHtml}} shared the video {{title}} with you";
var signupForm_CreatePasswordLabel$1 = "Choose a password";
var signupForm_CreatePasswordPlaceholder$1 = "Keep it secret!";
var signupForm_CreatePasswordTooltip$1 = "Password must be at least 8 characters long and contain 1 number & 1 letter.";
var signupForm_EmailExists$1 = "This email address is already in use. Did you mean to {{startAnchor}}log in?{{endAnchor}}";
var signupForm_EmailPlaceholder$1 = "jane@acme.com";
var signupForm_EmailStateTooltip$1 = "On the next page you will be able to sign up, enter your password, or reset your password.";
var signupForm_FirstNamePlaceholder$1 = "Jane";
var signupForm_HasAccountCTA$1 = "Already have an account?";
var signupForm_InvalidEmailSignup$1 = "Hmm, this doesn't seem to be an email address. Try again.";
var signupForm_InvalidEula$1 = "You must accept the terms of use and privacy policy.";
var signupForm_InvalidFirstName$1 = "Please enter your first name.";
var signupForm_InvalidPassword$1 = "Password must be at least 8 characters long and contain 1 number & 1 letter.";
var signupForm_LastNamePlaceholder$1 = "Smith";
var signupForm_LogInNow$1 = "Log in now";
var signupForm_NoAccount$1 = "Hmm, we can't find that account. Try entering again or {{startAnchor}}create a new account.{{endAnchor}}";
var signupForm_PasswordLabel$1 = "Now enter your password";
var signupForm_RegisterEmailLabel$1 = "What is your email address?";
var signupForm_RegisterFirstNameLabel$1 = "First name";
var signupForm_RegisterLastNameLabel$1 = "Last name";
var signupForm_SignUpTitle$1 = "Sign up.";
var SessionTimeoutModal_Body$1 = "Your session is set to timeout due to inactivity in {{ secondsRemaining }} seconds.";
var SessionTimeoutModal_StillHere$1 = "I'm still here";
var searchTags_UserTagsAddButton$1 = "+ Add";
var searchTags_UserTagsHint$1 = "hint: add multiple skills with commas.";
var SearchResultItem_AddToBin$1 = "Add to Bin";
var scholarshipIntroModal_CreateAccount$1 = "Step 2: Create a Salesforce Developer Account";
var scholarshipIntroModal_CreateAccountDescription$1 = "To complete your application you'll need to sign up for a FREE Developer Account & complete the Salesforce Pathway.";
var scholarshipIntroModal_CreateAccountLabel$1 = "Create an Account";
var resourceAssociationRemoved_ActionFormat$1 = "{{nameHtml}} deleted this {{type}} from the {{resourceTitle}} {{resourceType}}";
var resourceAssociationRemoved_ActionNoUserFormat$1 = '<span class="font-semibold">Your organization&apos;s latest catalog import</span> deleted this {{type}} from the {{resourceTitle}} {{resourceType}}';
var resetPasswordForm_ConfirmPasswordError$1 = "Passwords do not match.";
var resetPasswordForm_ConfirmPasswordLabel$1 = "Re-enter your new password";
var resetPasswordForm_ConfirmPasswordPlaceholder$1 = "Type it one more time";
var resetPasswordForm_ExpiredPassword$1 = "Your password is expired. Please reset your password";
var resetPasswordForm_Info$1 = "Enter a new password for your account.";
var resetPasswordForm_InvalidConfirmPassword$1 = "Passwords do not match.";
var resetPasswordForm_InvalidEmail$1 = "Please enter your email address.";
var resetPasswordForm_InvalidPassword$1 = "Password must be at least 8 characters long and contain 1 number & 1 letter.";
var resetPasswordForm_NewPasswordLabel$1 = "Choose a new password";
var resetPasswordForm_NewPasswordPlaceholder$1 = "Keep it secret!";
var requiredLearning_notificationDateFormat$1 = "You have a new {{startHtml}}Required Learning{{endHtml}} item due on {{date}}";
var RequestRating_Header$1 = "Request Manager Rating";
var RequestRating_Label$1 = "Search to find your manager";
var RequestRating_Message1Format$1 = "{0} requested that you rate their skill level in {1}";
var RequestRating_RateNow$1 = "Rate Now";
var RequestRating_Self_Message1Format$1 = "{0} requested that you rate yourself in {1}";
var RequestRating_Self_Subject$1 = "{0} has requested you rate yourself.";
var RequestRating_SendRequest$1 = "Send Request";
var RequestRating_Subject$1 = "{0} has requested you rate them.";
var RequestRating_SuccessMessage$1 = "Request sent successfully";
var requestGroupMembership_Accept$1 = "Accept";
var requestGroupMembership_Approved$1 = "Approved";
var requestGroupMembership_Decline$1 = "Decline";
var requestGroupMembership_Denied$1 = "Denied";
var requestGroupMembership_Plural$1 = "{{nameHtml}} and {{number}} others have requested group membership for {{groupNameHtml}}";
var requestGroupMembership_Single$1 = "{{nameHtml}} has requested group membership for {{groupNameHtml}}";
var ReportingContentSvc_All$1 = "All types";
var ReportingContentSvc_ChartIDflexPathwaySections$1 = "Pathways";
var ReportingContentSvc_ChartIDlearningChart$1 = "Learning Summary";
var ReportingContentSvc_ChartIDpopularCategories$1 = "Popular Skills";
var ReportingContentSvc_ChartIDpopularProviders$1 = "Popular Providers";
var ReportingContentSvc_ChartIDpopularSearches$1 = "Popular Searches";
var ReportingContentSvc_ChartIDrecommendationsStatus$1 = "Shared or Assigned";
var ReportingContentSvc_ChartIDskillRatings$1 = "Skill Rating Summary";
var ReportingContentSvc_ChartIDtopGroups$1 = "Top Active Groups";
var ReportingContentSvc_ExternalContent$1 = "External Content";
var ReportingContentSvc_ImageAltText$1 = "blurred placeholder screenshot used as an example for how this report might look";
var ReportingContentSvc_InternalContent$1 = "Internal Content";
var ReportingContentSvc_Name$1 = "Name";
var ReportingContentSvc_NotEnoughActivity$1 = "Not Enough Activity";
var ReportingContentSvc_Points$1 = "Points";
var ReportingContentSvc_ReportsNotAvailable$1 = "There isn’t enough information for the selected filters.";
var ReportingContentSvc_TotalContentViewed$1 = "Total content viewed";
var ReportingContentSvc_TotalItemsAdded$1 = "Total items added";
var ReportingContentSvc_TotalItemsCompleted$1 = "Total items completed";
var ReportingContentSvc_TotalPointsEarned$1 = "Total points earned";
var Reporting_Transmitters_BOM$1 = "Suppress BOM";
var Reporting_Transmitters_Configurations$1 = "Configurations";
var Reporting_Transmitters_Configurations_Selection$1 = "FTP Configurations";
var Reporting_Transmitters_CreateEdit_AuthenticationType$1 = "Authentication type";
var Reporting_Transmitters_CreateEdit_BOMTooltip$1 = "Suppress the default Byte Order Mark (BOM) in the report file. This should be left as NO unless it is necessary to strip it out";
var Reporting_Transmitters_CreateEdit_ConnectionStatus$1 = "Connection Status:";
var Reporting_Transmitters_CreateEdit_ConnectionStatusCheck$1 = "Check connection";
var Reporting_Transmitters_CreateEdit_ConnectionStatusFail$1 = "Failed to connect";
var Reporting_Transmitters_CreateEdit_ConnectionStatusNotConnected$1 = "Connecting...";
var Reporting_Transmitters_CreateEdit_ConnectionStatusSuccess$1 = "Connection established";
var Reporting_Transmitters_CreateEdit_CredentialsNote$1 = "For security reasons, credentials cannot be shown. Updates to the username, password, or private key will overwrite existing values.";
var Reporting_Transmitters_CreateEdit_HeaderCreate$1 = "Create Configuration";
var Reporting_Transmitters_CreateEdit_HeaderUpdate$1 = "Edit Configuration";
var Reporting_Transmitters_CreateEdit_HostPlaceholder$1 = "yourftpserveraddress.com";
var Reporting_Transmitters_CreateEdit_Password$1 = "Password";
var Reporting_Transmitters_CreateEdit_PasswordPlaceholder$1 = "Enter password";
var Reporting_Transmitters_CreateEdit_PortNumberError$1 = "Must be a number";
var Reporting_Transmitters_CreateEdit_PrivateKey$1 = "Private key";
var Reporting_Transmitters_CreateEdit_PrivateKeyPlaceholder$1 = "Enter private key";
var Reporting_Transmitters_CreateEdit_Subfolder$1 = "Subfolder Path";
var Reporting_Transmitters_CreateEdit_SubfolderPlaceholder$1 = "Enter subfolder path";
var Reporting_Transmitters_CreateEdit_TitlePlaceholder$1 = "Enter configuration title";
var Reporting_Transmitters_CreateEdit_TypePlaceholder$1 = "Select a type";
var Reporting_Transmitters_CreateEdit_TypeTootltip$1 = "Client Provided is an internal file that exists outside of Degreed. Degreed FTP is an external file that exists inside Degreed";
var Reporting_Transmitters_CreateEdit_Username$1 = "Username";
var Reporting_Transmitters_CreateEdit_UsernamePlaceholder$1 = "Enter Username";
var Reporting_Transmitters_CreateNew$1 = "Create New";
var Reporting_Transmitters_Default$1 = "Default";
var Reporting_Transmitters_Error_Create$1 = "Error creating transmitter configuration";
var Reporting_Transmitters_Error_Delete$1 = "Error deleting transmitter configuration";
var Reporting_Transmitters_Error_Get$1 = "Error retrieving transmitter configuration";
var Reporting_Transmitters_Error_GetAll$1 = "Error retrieving transmitter configurations";
var Reporting_Transmitters_Error_GetPGPKey$1 = "Error retrieving PGP encryption key";
var Reporting_Transmitters_Error_SavePGPKey$1 = "Error saving PGP encryption key";
var Reporting_Transmitters_Error_Update$1 = "Error updating transmitter configuration";
var Reporting_Transmitters_Host$1 = "Host";
var Reporting_Transmitters_PGPEncrypted$1 = "PGP Encrypted";
var Reporting_Transmitters_PGPExtension$1 = "PGP Extension";
var Reporting_Transmitters_Port$1 = "Port";
var Reporting_Transmitters_SetupPGPKey$1 = "Setup PGP Key";
var Reporting_Transmitters_SetupPGPKeyLabel$1 = "Enter Public Key";
var Reporting_Transmitters_SetupPGPKeyPlaceholder$1 = "Enter your PGP key here";
var Reporting_Transmitters_SetupPGPKeyPlaceholderFilled$1 = "The last {{count}} characters of your current key are: {{chars}}";
var Reporting_Transmitters_SetupPGPKeyTooltip$1 = "One PGP Key will apply for all configurations created";
var Reporting_Transmitters_SFTP$1 = "SFTP";
var Reporting_Transmitters_Success_Create$1 = "Successfully created transmitter configuration";
var Reporting_Transmitters_Success_Delete$1 = "Successfully deleted transmitter configuration";
var Reporting_Transmitters_Success_SavePGPKey$1 = "Successfully saved PGP encryption key";
var Reporting_Transmitters_Success_Update$1 = "Successfully updated transmitter configuration";
var Reporting_Transmitters_Title$1 = "Title";
var Reporting_Transmitters_Type$1 = "Type";
var Reporting_Transmitters_TypeOptionClientProvided$1 = "Client Provided FTP";
var Reporting_Transmitters_TypeOptionDegreed$1 = "Degreed FTP";
var ReportingInApp_Actions_ChooseReportType$1 = "Choose Report Type";
var ReportingInApp_Actions_CreateNewReport$1 = "Create new Report";
var ReportingInApp_Actions_EditSchedule$1 = "Edit Schedule";
var ReportingInApp_Actions_GenerateReport$1 = "Generate Full Report";
var ReportingInApp_Actions_OpenDownloads$1 = "Open Reports";
var ReportingInApp_Actions_PreviewReport$1 = "Preview Report";
var ReportingInApp_Actions_ScheduleReport$1 = "Schedule Report";
var ReportingInApp_Actions_ViewReport$1 = "View Report";
var ReportingInApp_Categories$1 = "Categories";
var ReportingInApp_Create$1 = "Create New";
var ReportingInApp_CustomFields$1 = "Custom Fields";
var ReportingInApp_DataTable_DeliveredDate$1 = "Delivered Date (UTC)";
var ReportingInApp_DataTable_LastRun$1 = "Last Run (UTC)";
var ReportingInApp_DataTable_NextRun$1 = "Next Run (UTC)";
var ReportingInApp_DataTable_ReportTitle$1 = "Report Title";
var ReportingInApp_DataTable_ReportType$1 = "Report Type";
var ReportingInApp_DataTable_Status$1 = "Status";
var ReportingInApp_DataTable_TimePeriod$1 = "Time Period";
var ReportingInApp_Downloads$1 = "Downloads";
var ReportingInApp_Downloads_Description$1 = "Reports that are scheduled, processing or ready for download will be listed on this page.";
var ReportingInApp_Downloads_RemovalNotice$1 = "Reports are removed after 7 days";
var ReportingInApp_FileFormat_CommaDelimited$1 = "Comma Separated Values";
var ReportingInApp_FileFormat_Excel$1 = "Excel";
var ReportingInApp_Filters_Button_Filter$1 = "Filter";
var ReportingInApp_Filters_Modal_Button_AddColumn$1 = "Add column";
var ReportingInApp_Filters_Modal_Button_Remove$1 = "Remove filter";
var ReportingInApp_Filters_Modal_Header_Title$1 = "Filter";
var ReportingInApp_Filters_Modal_Header_Tooltip$1 = "You can add up to 5 Column Name";
var ReportingInApp_Filters_Modal_Hint_Number$1 = "Enter only one numeric value";
var ReportingInApp_Filters_Modal_Hint_String$1 = "You can enter up to {{count}} values";
var ReportingInApp_Filters_Modal_Label_Column$1 = "Column name";
var ReportingInApp_Filters_Modal_Label_Date$1 = "Date";
var ReportingInApp_Filters_Modal_Label_Operator$1 = "Operator";
var ReportingInApp_Filters_Modal_Label_Value$1 = "Value(s)";
var ReportingInApp_Filters_Modal_Operator_Contains$1 = "Contains";
var ReportingInApp_Filters_Modal_Operator_DoesNotEqual$1 = "Does not equal";
var ReportingInApp_Filters_Modal_Operator_Empty$1 = "Empty";
var ReportingInApp_Filters_Modal_Operator_EndsWith$1 = "Ends with";
var ReportingInApp_Filters_Modal_Operator_Equals$1 = "Equals";
var ReportingInApp_Filters_Modal_Operator_EqualsOrGreaterThan$1 = "Equals or greater than";
var ReportingInApp_Filters_Modal_Operator_EqualsOrLessThan$1 = "Equals or less than";
var ReportingInApp_Filters_Modal_Operator_Exact$1 = "Exact";
var ReportingInApp_Filters_Modal_Operator_StartsWith$1 = "Starts with";
var ReportingInApp_Filters_Modal_Placeholder_Column$1 = "Select a column";
var ReportingInApp_Filters_Modal_Placeholder_Operator$1 = "Select an operator";
var ReportingInApp_Filters_Modal_Placeholder_Value$1 = "Value";
var ReportingInApp_Filters_Modal_UnselectedColumn_Notice$1 = "This column is not selected in the Change Columns drop-down. You can filter the report by this column, but the column will not display in the report results";
var ReportingInApp_GeneratedReports$1 = "Generated Reports";
var ReportingInApp_ReportCategories$1 = "Report Categories";
var ReportingInApp_ReportCategory_ACM_Description$1 = "View details about your Academies and Content Marketplace Programs.";
var ReportingInApp_ReportCategory_ACM_Title$1 = "Academy and Content Marketplace";
var ReportingInApp_ReportCategory_Assignments_Description$1 = "View details about assignments within your organization.";
var ReportingInApp_ReportCategory_Assignments_Title$1 = "Assignments";
var ReportingInApp_ReportCategory_Content_Description$1 = "View details about content engagement within your organization.";
var ReportingInApp_ReportCategory_Content_Title$1 = "Content";
var ReportingInApp_ReportCategory_Opportunities_Description$1 = "View details about opportunities within your organization.";
var ReportingInApp_ReportCategory_Opportunities_Title$1 = "Opportunities";
var ReportingInApp_ReportCategory_Skills_Description$1 = "View details about skills and their usage within your organization.";
var ReportingInApp_ReportCategory_Skills_Title$1 = "Skills";
var ReportingInApp_ReportCategory_User_Description$1 = "View detailed information on the user groups.";
var ReportingInApp_ReportCategory_User_Title$1 = "User";
var ReportingInApp_ReportCategorySection_Details_Description$1 = "These reports give you detailed data for each occurrence of an activity.";
var ReportingInApp_ReportCategorySection_Details_Title$1 = "Detail Reports";
var ReportingInApp_ReportCategorySection_Summary_Description$1 = "These reports give you summarized data, including a count of how many times an activity occurred.";
var ReportingInApp_ReportCategorySection_Summary_Title$1 = "Summary Reports";
var ReportingInApp_ReportColumn_AbsoluteParticipantCount$1 = "Absolute Participant Count";
var ReportingInApp_ReportColumn_AcademyId$1 = "Academy ID";
var ReportingInApp_ReportColumn_AcademyName$1 = "Academy Name";
var ReportingInApp_ReportColumn_AcademyProgressPercent$1 = "Academy Progress Percent";
var ReportingInApp_ReportColumn_AcademyTitle$1 = "Academy Title";
var ReportingInApp_ReportColumn_AcademyUrl$1 = "Academy URL";
var ReportingInApp_ReportColumn_Active$1 = "Active";
var ReportingInApp_ReportColumn_AdditionalLearning$1 = "Additional Learning";
var ReportingInApp_ReportColumn_ApplicationStage$1 = "Application Stage";
var ReportingInApp_ReportColumn_ApplicationUrl$1 = "Application URL";
var ReportingInApp_ReportColumn_Approver$1 = "Approver";
var ReportingInApp_ReportColumn_ApproverEmail$1 = "Approver Email";
var ReportingInApp_ReportColumn_ApproverFirstName$1 = "Approver First Name";
var ReportingInApp_ReportColumn_ApproverId$1 = "Approver ID";
var ReportingInApp_ReportColumn_ApproverLastName$1 = "Approver Last Name";
var ReportingInApp_ReportColumn_ApproverName$1 = "Approver Name";
var ReportingInApp_ReportColumn_AssignedDate$1 = "Assigned Date";
var ReportingInApp_ReportColumn_AssigneeEmail$1 = "Assignee Email";
var ReportingInApp_ReportColumn_AssigneeEmployeeId$1 = "Assignee Employee ID";
var ReportingInApp_ReportColumn_AssigneeFirstName$1 = "Assignee First Name";
var ReportingInApp_ReportColumn_AssigneeLastName$1 = "Assignee Last Name";
var ReportingInApp_ReportColumn_AssigneeUserName$1 = "Assignee User Name";
var ReportingInApp_ReportColumn_AssignerEmail$1 = "Assignor Email";
var ReportingInApp_ReportColumn_AssignerEmployeeId$1 = "Assignor Employee ID";
var ReportingInApp_ReportColumn_AssignerFirstName$1 = "Assignor First Name";
var ReportingInApp_ReportColumn_AssignerLastName$1 = "Assignor Last Name";
var ReportingInApp_ReportColumn_AssignerUserName$1 = "Assignor User Name";
var ReportingInApp_ReportColumn_AssignmentIsCompleted$1 = "Is Completed";
var ReportingInApp_ReportColumn_AssignmentsCompleted$1 = "Assignments Completed";
var ReportingInApp_ReportColumn_AssinmentStatus$1 = "Assignment Status";
var ReportingInApp_ReportColumn_AverageCompletionPercent$1 = "Average Completion Percent";
var ReportingInApp_ReportColumn_AverageManagerRatingsAdded$1 = "Average Manager Ratings Added";
var ReportingInApp_ReportColumn_AverageMangerRating$1 = "Average Manager Rating";
var ReportingInApp_ReportColumn_AverageOptOutCount$1 = "Average Opt-out Count";
var ReportingInApp_ReportColumn_AveragePeerRatings$1 = "Average Peer Ratings";
var ReportingInApp_ReportColumn_AverageSelfRating$1 = "Average Self Rating";
var ReportingInApp_ReportColumn_AverageSkillTargetRating$1 = "Average Skill Target Rating";
var ReportingInApp_ReportColumn_AverageSkillTargetsAdded$1 = "Average Skill Targets Added";
var ReportingInApp_ReportColumn_AverageTeamFocusSkills$1 = "Average Team Focus Skills";
var ReportingInApp_ReportColumn_AverageTeamSize$1 = "Average Team Size";
var ReportingInApp_ReportColumn_BeingFollowedEmployeeId$1 = "Being Followed Employee ID";
var ReportingInApp_ReportColumn_BeingFollowedUserEmail$1 = "Being Followed User Email";
var ReportingInApp_ReportColumn_BeingFollowedUserFirstName$1 = "Being Followed User First Name";
var ReportingInApp_ReportColumn_BeingFollowedUserLastName$1 = "Being Followed User Last Name";
var ReportingInApp_ReportColumn_BeingFollowedUserName$1 = "Being Followed User Name";
var ReportingInApp_ReportColumn_Category$1 = "Category";
var ReportingInApp_ReportColumn_Collaborators$1 = "Collaborators";
var ReportingInApp_ReportColumn_CollaboratorsEmployeeId$1 = "Collaborators Employee ID";
var ReportingInApp_ReportColumn_CollaboratorsUserName$1 = "Collaborators User Name";
var ReportingInApp_ReportColumn_CompletedContent$1 = "Completed Content";
var ReportingInApp_ReportColumn_CompletedCount$1 = "Total Users 100%";
var ReportingInApp_ReportColumn_CompletedDate$1 = "Completed Date";
var ReportingInApp_ReportColumn_CompletedOn$1 = "Completed On";
var ReportingInApp_ReportColumn_CompletedRequiredContent$1 = "Number of Completed Required Content ";
var ReportingInApp_ReportColumn_CompletionCompletedDate$1 = "Completed Date";
var ReportingInApp_ReportColumn_CompletionCreatedDate$1 = "Created Date";
var ReportingInApp_ReportColumn_CompletionDate$1 = "Last Resource Completed or Skill Add Date";
var ReportingInApp_ReportColumn_CompletionIsVerified$1 = "Completion is Verified";
var ReportingInApp_ReportColumn_CompletionPercent$1 = "Completion Percent";
var ReportingInApp_ReportColumn_CompletionPercentage$1 = "Completion Percentage";
var ReportingInApp_ReportColumn_CompletionPoints$1 = "Completion Points";
var ReportingInApp_ReportColumn_Completions$1 = "Completions";
var ReportingInApp_ReportColumn_CompletionTags$1 = "Completion Tags (Topics)";
var ReportingInApp_ReportColumn_CompletionUserRating$1 = "Completion User Rating";
var ReportingInApp_ReportColumn_ContentCompleted$1 = "Content Completed";
var ReportingInApp_ReportColumn_ContentCompletedCount$1 = "Content Completed";
var ReportingInApp_ReportColumn_ContentCompletedDate$1 = "Content Completed Date";
var ReportingInApp_ReportColumn_ContentDescription$1 = "Content Description";
var ReportingInApp_ReportColumn_ContentDuration$1 = "Content Duration";
var ReportingInApp_ReportColumn_ContentDurationType$1 = "Content Duration Type";
var ReportingInApp_ReportColumn_ContentId$1 = "Content ID";
var ReportingInApp_ReportColumn_ContentOwnerName$1 = "Content Owner Name";
var ReportingInApp_ReportColumn_ContentProvider$1 = "Content Provider";
var ReportingInApp_ReportColumn_ContentTitle$1 = "Content Title";
var ReportingInApp_ReportColumn_ContentType$1 = "Content Type";
var ReportingInApp_ReportColumn_ContentUrl$1 = "Content URL";
var ReportingInApp_ReportColumn_Contributors$1 = "Contributors";
var ReportingInApp_ReportColumn_Cost$1 = "Cost";
var ReportingInApp_ReportColumn_CostCenter$1 = "Cost Center";
var ReportingInApp_ReportColumn_CreatedBy$1 = "Created By";
var ReportingInApp_ReportColumn_CreatedByEmail$1 = "Created By Email";
var ReportingInApp_ReportColumn_CreatedByEmployeeId$1 = "Created By Employee ID";
var ReportingInApp_ReportColumn_CreatedByFirstName$1 = "Created By First Name";
var ReportingInApp_ReportColumn_CreatedById$1 = "Created By ID";
var ReportingInApp_ReportColumn_CreatedByLastName$1 = "Created By Last Name";
var ReportingInApp_ReportColumn_CreatedByName$1 = "Created By Name";
var ReportingInApp_ReportColumn_CreatedByUserName$1 = "Created By User Name";
var ReportingInApp_ReportColumn_CreatedDate$1 = "Created Date";
var ReportingInApp_ReportColumn_CreatedDateOfOpportunity$1 = "Created Date of Opportunity";
var ReportingInApp_ReportColumn_CreatedOn$1 = "Created On";
var ReportingInApp_ReportColumn_Currency$1 = "Currency";
var ReportingInApp_ReportColumn_DailyDigestEmail$1 = "Daily Digest Email";
var ReportingInApp_ReportColumn_DateAdded$1 = "Date Added";
var ReportingInApp_ReportColumn_DateApprovedOrDeclined$1 = "Date Approved or Declined";
var ReportingInApp_ReportColumn_DateInvited$1 = "Date Invited";
var ReportingInApp_ReportColumn_DateJoined$1 = "Date Joined";
var ReportingInApp_ReportColumn_DateOfLastContentCompletion$1 = "Latest Completion Date";
var ReportingInApp_ReportColumn_DateSearched$1 = "Date Searched";
var ReportingInApp_ReportColumn_DateShared$1 = "Date Shared";
var ReportingInApp_ReportColumn_DateUserInterested$1 = "Date User Interested";
var ReportingInApp_ReportColumn_DateViewed$1 = "Date Viewed";
var ReportingInApp_ReportColumn_Department$1 = "Department";
var ReportingInApp_ReportColumn_Description$1 = "Description";
var ReportingInApp_ReportColumn_DirectReportEmail$1 = "Direct Report Email";
var ReportingInApp_ReportColumn_DirectReportFirstName$1 = "Direct Report First Name";
var ReportingInApp_ReportColumn_DirectReportId$1 = "Direct Report ID";
var ReportingInApp_ReportColumn_DirectReportLastName$1 = "Direct Report Last Name";
var ReportingInApp_ReportColumn_DirectReportName$1 = "Direct Report Name";
var ReportingInApp_ReportColumn_Discriminator$1 = "Discriminator";
var ReportingInApp_ReportColumn_DueDate$1 = "Due Date";
var ReportingInApp_ReportColumn_DueDateLocal$1 = "Due Date Local";
var ReportingInApp_ReportColumn_Duration$1 = "Duration";
var ReportingInApp_ReportColumn_DurationInMinutes$1 = "Duration In Minutes";
var ReportingInApp_ReportColumn_DurationUnitName$1 = "Duration Unit Name";
var ReportingInApp_ReportColumn_DurationUnits$1 = "Duration Units";
var ReportingInApp_ReportColumn_EmployeeId$1 = "Employee ID";
var ReportingInApp_ReportColumn_Endorsed$1 = "Endorsed";
var ReportingInApp_ReportColumn_Enrolled$1 = "Enrolled";
var ReportingInApp_ReportColumn_EnrolledUsers$1 = "Enrolled Users";
var ReportingInApp_ReportColumn_EstimatedLearningHours$1 = "Estimated Learning Hours";
var ReportingInApp_ReportColumn_EstimatedLearningMinutes$1 = "Estimated Learning Minutes";
var ReportingInApp_ReportColumn_ExtractionDate$1 = "ReportingInApp_ReportColumn_ExtractionDate";
var ReportingInApp_ReportColumn_Feedback$1 = "Feedback";
var ReportingInApp_ReportColumn_FirstLogin$1 = "First Login";
var ReportingInApp_ReportColumn_FollowerEmployeeId$1 = "Follower Employee ID";
var ReportingInApp_ReportColumn_FollowerManagerId$1 = "Follower Manager ID";
var ReportingInApp_ReportColumn_FollowerManagerName$1 = "Follower Manager Name";
var ReportingInApp_ReportColumn_FollowerUserEmail$1 = "Follower User Email";
var ReportingInApp_ReportColumn_FollowerUserFirstName$1 = "Follower User First Name";
var ReportingInApp_ReportColumn_FollowerUserLastName$1 = "Follower User Last Name";
var ReportingInApp_ReportColumn_FollowerUserName$1 = "Follower User Name";
var ReportingInApp_ReportColumn_FollowerUserStatus$1 = "Follower User Status";
var ReportingInApp_ReportColumn_Group$1 = "Group";
var ReportingInApp_ReportColumn_GroupName$1 = "Group Name";
var ReportingInApp_ReportColumn_GroupRole$1 = "Group Role";
var ReportingInApp_ReportColumn_GroupsVisibility$1 = "Groups Visibility";
var ReportingInApp_ReportColumn_InterestedEmail$1 = "Interested Email";
var ReportingInApp_ReportColumn_InterestedEmployeeId$1 = "Interested Employee ID";
var ReportingInApp_ReportColumn_InterestedUserFirstName$1 = "Interested User First Name";
var ReportingInApp_ReportColumn_InterestedUserLastName$1 = "Interested User Last Name";
var ReportingInApp_ReportColumn_InterestedUserName$1 = "Interested User Name";
var ReportingInApp_ReportColumn_InterestedUserSkillMatch$1 = "Interested User Skill Match";
var ReportingInApp_ReportColumn_InterestedUserStage$1 = "Interested User Stage";
var ReportingInApp_ReportColumn_InternalExternalContent$1 = "Internal/External Content";
var ReportingInApp_ReportColumn_InternalId$1 = "Internal ID";
var ReportingInApp_ReportColumn_InternalManagerRatings$1 = "Manager Ratings";
var ReportingInApp_ReportColumn_InternalSelfRatings$1 = "Self Ratings";
var ReportingInApp_ReportColumn_InternalSkillReviews$1 = "Skill Reviews";
var ReportingInApp_ReportColumn_IsCompanySpecificProgram$1 = "Is Company Specific Program";
var ReportingInApp_ReportColumn_IsFollowing$1 = "Following";
var ReportingInApp_ReportColumn_ItemId$1 = "Item ID";
var ReportingInApp_ReportColumn_ItemName$1 = "Item Name";
var ReportingInApp_ReportColumn_ItemType$1 = "Item Type";
var ReportingInApp_ReportColumn_JobRole$1 = "Job Role";
var ReportingInApp_ReportColumn_Language$1 = "Language";
var ReportingInApp_ReportColumn_LastLogin$1 = "Last Login";
var ReportingInApp_ReportColumn_LastRatedDate$1 = "Last Rated Date";
var ReportingInApp_ReportColumn_LastUpdated$1 = "Last Updated";
var ReportingInApp_ReportColumn_LastUpdateDate$1 = "Last Update Date";
var ReportingInApp_ReportColumn_LastUpdatedOfOpportunity$1 = "Last Updated of Opportunity";
var ReportingInApp_ReportColumn_LatestCompletionDate$1 = "Latest Completion Date";
var ReportingInApp_ReportColumn_LearnerStatus$1 = "Learner Status";
var ReportingInApp_ReportColumn_LessonDescription$1 = "Lesson Description";
var ReportingInApp_ReportColumn_LessonNumber$1 = "Lesson Number";
var ReportingInApp_ReportColumn_LessonTitle$1 = "Lesson Title";
var ReportingInApp_ReportColumn_Location$1 = "Location";
var ReportingInApp_ReportColumn_LoggedInDate$1 = "Logged In Date";
var ReportingInApp_ReportColumn_ManagerCount$1 = "Manager Count";
var ReportingInApp_ReportColumn_ManagerEmail$1 = "Manager Email";
var ReportingInApp_ReportColumn_ManagerEmployeeId$1 = "Manager Employee ID";
var ReportingInApp_ReportColumn_ManagerFirstName$1 = "Manager First Name";
var ReportingInApp_ReportColumn_ManagerId$1 = "Manager ID";
var ReportingInApp_ReportColumn_ManagerLastName$1 = "Manager Last Name";
var ReportingInApp_ReportColumn_ManagerName$1 = "Manager Name";
var ReportingInApp_ReportColumn_ManagerRating$1 = "Manager Ratings";
var ReportingInApp_ReportColumn_ManagerRatingAverage$1 = "Average Manager Rating";
var ReportingInApp_ReportColumn_MarketplaceTitle$1 = "Marketplace Title";
var ReportingInApp_ReportColumn_MenteeEmail$1 = "Mentee Email";
var ReportingInApp_ReportColumn_MenteeEmployeeId$1 = "Mentee Employee ID";
var ReportingInApp_ReportColumn_MenteeUserFirstName$1 = "Mentee User First Name";
var ReportingInApp_ReportColumn_MenteeUserLastName$1 = "Mentee User Last Name";
var ReportingInApp_ReportColumn_MenteeUserName$1 = "Mentee User Name";
var ReportingInApp_ReportColumn_MentorEmployeeId$1 = "Mentor Employee ID";
var ReportingInApp_ReportColumn_MentorUserEmail$1 = "Mentor User Email";
var ReportingInApp_ReportColumn_MentorUserFirstName$1 = "Mentor User First Name";
var ReportingInApp_ReportColumn_MentorUserLastName$1 = "Mentor User Last Name";
var ReportingInApp_ReportColumn_MentorUserName$1 = "Mentor User Name";
var ReportingInApp_ReportColumn_Nominated$1 = "Nominated";
var ReportingInApp_ReportColumn_NoReply$1 = "No Reply";
var ReportingInApp_ReportColumn_NumberOfInterestedCandidates$1 = "Number of Interested Candidates";
var ReportingInApp_ReportColumn_NumberOfMatchedCandidates$1 = "Number of Matched Candidates";
var ReportingInApp_ReportColumn_NumberOfRequiredSkills$1 = "Number of Required Skills";
var ReportingInApp_ReportColumn_NumberOfSelectedCandidates$1 = "Number of Selected Candidates";
var ReportingInApp_ReportColumn_NumberOfShares$1 = "Number of Shares";
var ReportingInApp_ReportColumn_NumberOfShortlistedCandidates$1 = "Number of Shortlisted Candidates";
var ReportingInApp_ReportColumn_OpportunityDescription$1 = "Opportunity Description";
var ReportingInApp_ReportColumn_OpportunityId$1 = "Opportunity ID";
var ReportingInApp_ReportColumn_OpportunityIsObsolete$1 = "Opportunity is Obsolete";
var ReportingInApp_ReportColumn_OpportunityOwnerEmployeeId$1 = "Opportunity Owner Employee ID";
var ReportingInApp_ReportColumn_OpportunityOwnerUserName$1 = "Opportunity Owner User Name";
var ReportingInApp_ReportColumn_OpportunitySkills$1 = "Opportunity Skills";
var ReportingInApp_ReportColumn_OpportunityStatus$1 = "Opportunity Status";
var ReportingInApp_ReportColumn_OpportunityTitle$1 = "Opportunity Title";
var ReportingInApp_ReportColumn_OpportunityType$1 = "Opportunity Type";
var ReportingInApp_ReportColumn_OpportunityUrl$1 = "Opportunity URL";
var ReportingInApp_ReportColumn_OpportunityVisibility$1 = "Opportunity Visibility";
var ReportingInApp_ReportColumn_OptOut$1 = "Opt-out";
var ReportingInApp_ReportColumn_OptOutCount$1 = "Opt-out Count";
var ReportingInApp_ReportColumn_Order$1 = "Order";
var ReportingInApp_ReportColumn_PathwayCompletedCount$1 = "Pathways Completed";
var ReportingInApp_ReportColumn_PathwayContentCount$1 = "Total Pathway Content";
var ReportingInApp_ReportColumn_PathwayFollowDate$1 = "Follow Date";
var ReportingInApp_ReportColumn_PathwayFollowedCount$1 = "Pathways Followed/Assigned";
var ReportingInApp_ReportColumn_PathwayId$1 = "Pathway ID";
var ReportingInApp_ReportColumn_PathwayProgress$1 = "Pathway Progress";
var ReportingInApp_ReportColumn_PathwayRequiredContentCount$1 = "Total Required Pathway Content";
var ReportingInApp_ReportColumn_Pathways$1 = "Pathways";
var ReportingInApp_ReportColumn_PathwayTitle$1 = "Pathway Title";
var ReportingInApp_ReportColumn_PathwayTopic$1 = "Pathway Topic";
var ReportingInApp_ReportColumn_PathwayType$1 = "Pathway Type";
var ReportingInApp_ReportColumn_PathwayUrl$1 = "Pathway URL";
var ReportingInApp_ReportColumn_PathwayUserCount$1 = "Total Users Active in Pathway";
var ReportingInApp_ReportColumn_PeerRatings$1 = "Peer Ratings";
var ReportingInApp_ReportColumn_PercentOfSkillsMatched$1 = "Percent of Skills Matched";
var ReportingInApp_ReportColumn_PermissionRole$1 = "Permission Role";
var ReportingInApp_ReportColumn_PlanFollowedCount$1 = "Plans Followed";
var ReportingInApp_ReportColumn_PlanId$1 = "Plan ID";
var ReportingInApp_ReportColumn_Plans$1 = "Plans";
var ReportingInApp_ReportColumn_PlanTitle$1 = "Plan Title";
var ReportingInApp_ReportColumn_PlanType$1 = "Plan Type";
var ReportingInApp_ReportColumn_PlanUrl$1 = "Plan URL";
var ReportingInApp_ReportColumn_PreapprovalRequired$1 = "Preapproval Required";
var ReportingInApp_ReportColumn_ProfilePrivacy$1 = "Profile Privacy";
var ReportingInApp_ReportColumn_ProgramCostAmount$1 = "Program Cost Amount";
var ReportingInApp_ReportColumn_ProgramCostCurrency$1 = "Program Cost Currency";
var ReportingInApp_ReportColumn_ProgramDuration$1 = "Program Duration";
var ReportingInApp_ReportColumn_ProgramDurationUnit$1 = "Program Duration Unit";
var ReportingInApp_ReportColumn_ProgramId$1 = "Program ID";
var ReportingInApp_ReportColumn_ProgramLength$1 = "Program Length";
var ReportingInApp_ReportColumn_ProgramLengthUnit$1 = "Program Length Unit";
var ReportingInApp_ReportColumn_ProgramName$1 = "Program Name";
var ReportingInApp_ReportColumn_ProgramTitle$1 = "Program Title";
var ReportingInApp_ReportColumn_Provider$1 = "Provider";
var ReportingInApp_ReportColumn_ProviderName$1 = "Provider Name";
var ReportingInApp_ReportColumn_PublishedDate$1 = "Published Date";
var ReportingInApp_ReportColumn_RealTimeEmailNotification$1 = "Real Time Email Notification";
var ReportingInApp_ReportColumn_RecipientEmail$1 = "Recipient Email";
var ReportingInApp_ReportColumn_RecipientEmployeeId$1 = "Recipient Employee ID";
var ReportingInApp_ReportColumn_RecipientGroupName$1 = "Recipient Group Name";
var ReportingInApp_ReportColumn_RecipientUserFirstName$1 = "Recipient User First Name";
var ReportingInApp_ReportColumn_RecipientUserLastName$1 = "Recipient User Last Name";
var ReportingInApp_ReportColumn_RecipientUserName$1 = "Recipient User Name";
var ReportingInApp_ReportColumn_RecommendationType$1 = "Recommendation Type";
var ReportingInApp_ReportColumn_RepliedNo$1 = "Replied No";
var ReportingInApp_ReportColumn_RepliedYes$1 = "Replied Yes";
var ReportingInApp_ReportColumn_RequestedAmount$1 = "Requested Amount";
var ReportingInApp_ReportColumn_RequestedAmountCurrency$1 = "Requested Amount Currency";
var ReportingInApp_ReportColumn_RequestedAmountUSD$1 = "Requested Amount USD";
var ReportingInApp_ReportColumn_RequestedDate$1 = "Requested Date";
var ReportingInApp_ReportColumn_RequestId$1 = "Request ID";
var ReportingInApp_ReportColumn_RequestType$1 = "Request Type";
var ReportingInApp_ReportColumn_Required$1 = "Required";
var ReportingInApp_ReportColumn_RequiredSkill$1 = "Required";
var ReportingInApp_ReportColumn_ResourceId$1 = "Resource ID";
var ReportingInApp_ReportColumn_ResourceTitle$1 = "Resource Title";
var ReportingInApp_ReportColumn_ResourceType$1 = "Resource Type";
var ReportingInApp_ReportColumn_ResourceUrl$1 = "Resource URL";
var ReportingInApp_ReportColumn_RestrictedAccess$1 = "Restricted Access";
var ReportingInApp_ReportColumn_RsvpStatus$1 = "RSVP Status";
var ReportingInApp_ReportColumn_SearchCount$1 = "Search Count";
var ReportingInApp_ReportColumn_SearchTerm$1 = "Search Term";
var ReportingInApp_ReportColumn_SectionContentCount$1 = "Section Content Count";
var ReportingInApp_ReportColumn_SectionDescription$1 = "Section Description";
var ReportingInApp_ReportColumn_SectionNumber$1 = "Section Number";
var ReportingInApp_ReportColumn_SectionOrder$1 = "Section Order";
var ReportingInApp_ReportColumn_SectionTitle$1 = "Section Title";
var ReportingInApp_ReportColumn_SegmentName$1 = "Segment Name";
var ReportingInApp_ReportColumn_SelfRating$1 = "Self Ratings";
var ReportingInApp_ReportColumn_SelfRatingAverage$1 = "Average Self Rating";
var ReportingInApp_ReportColumn_SharedByEmail$1 = "Shared By Email";
var ReportingInApp_ReportColumn_SharedByEmployeeId$1 = "Shared By Employee ID";
var ReportingInApp_ReportColumn_SharedByFirstName$1 = "Shared By User First Name";
var ReportingInApp_ReportColumn_SharedByLastName$1 = "Shared By User Last Name";
var ReportingInApp_ReportColumn_SharedByUserName$1 = "Shared By User Name";
var ReportingInApp_ReportColumn_ShareStatus$1 = "Share Status";
var ReportingInApp_ReportColumn_SkillAddedCount$1 = "Skills Added";
var ReportingInApp_ReportColumn_SkillCertificationRating$1 = "Skill Certification Rating";
var ReportingInApp_ReportColumn_SkillFocusCount$1 = "Skill Focus Count";
var ReportingInApp_ReportColumn_SkillFocusedDate$1 = "Skill Focused Date";
var ReportingInApp_ReportColumn_SkillFollowDate$1 = "Skill Follow Date";
var ReportingInApp_ReportColumn_SkillFollowedDate$1 = "Skill Followed Date";
var ReportingInApp_ReportColumn_SkillIsFocused$1 = "Skill is Focused";
var ReportingInApp_ReportColumn_SkillLevelAverage$1 = "Skill Level Average";
var ReportingInApp_ReportColumn_SkillName$1 = "Skill Name";
var ReportingInApp_ReportColumn_SkillRatedCount$1 = "Skills Rated";
var ReportingInApp_ReportColumn_SkillRatedDate$1 = "Skill Rated Date";
var ReportingInApp_ReportColumn_SkillRating$1 = "Skill Rating";
var ReportingInApp_ReportColumn_SkillRatingLabel$1 = "Skill Rating Label";
var ReportingInApp_ReportColumn_SkillRatingPrivacy$1 = "Skill Rating Privacy";
var ReportingInApp_ReportColumn_SkillRatingType$1 = "Skill Rating Type";
var ReportingInApp_ReportColumn_SkillReviewAverage$1 = "Average Skill Review";
var ReportingInApp_ReportColumn_Skills$1 = "Skills";
var ReportingInApp_ReportColumn_SkillStandardName$1 = "Skill Standard Name";
var ReportingInApp_ReportColumn_Source$1 = "Source";
var ReportingInApp_ReportColumn_StartDate$1 = "Start Date";
var ReportingInApp_ReportColumn_Status$1 = "Status";
var ReportingInApp_ReportColumn_StatusChangeDate$1 = "Status Change Date";
var ReportingInApp_ReportColumn_StepNumber$1 = "Step Number";
var ReportingInApp_ReportColumn_StepTitle$1 = "Step Title";
var ReportingInApp_ReportColumn_StepType$1 = "Step Type";
var ReportingInApp_ReportColumn_SubmissionType$1 = "Submission Type";
var ReportingInApp_ReportColumn_Summary$1 = "Summary";
var ReportingInApp_ReportColumn_TargetFollowDate$1 = "Follow Date";
var ReportingInApp_ReportColumn_TargetLevel$1 = "Target Level";
var ReportingInApp_ReportColumn_TargetRating$1 = "Skill Targets";
var ReportingInApp_ReportColumn_TeamFocusSkillList$1 = "Team Focus Skill List";
var ReportingInApp_ReportColumn_TeamFocusSkillsRatings$1 = "Team Focus Skills Ratings";
var ReportingInApp_ReportColumn_TeamSize$1 = "Team Size";
var ReportingInApp_ReportColumn_TextResponse$1 = "Text Response";
var ReportingInApp_ReportColumn_ThumbnailUrl$1 = "Thumbnail URL";
var ReportingInApp_ReportColumn_ThumbsDown$1 = "Thumbs Down";
var ReportingInApp_ReportColumn_ThumbsUp$1 = "Thumbs Up";
var ReportingInApp_ReportColumn_Title$1 = "Title";
var ReportingInApp_ReportColumn_TotalAcademyContent$1 = "Total Academy Content";
var ReportingInApp_ReportColumn_TotalAssignments$1 = "Total Assignments";
var ReportingInApp_ReportColumn_TotalDailyLogins$1 = "Total Daily Logins";
var ReportingInApp_ReportColumn_TotalLearningHours$1 = "Total Learning Hours";
var ReportingInApp_ReportColumn_TotalLearningMinutes$1 = "Total Learning Minutes";
var ReportingInApp_ReportColumn_TotalManagerRatings$1 = "Total Manager Ratings";
var ReportingInApp_ReportColumn_TotalManagerRatingsAdded$1 = "Total Manager Ratings Added";
var ReportingInApp_ReportColumn_TotalPathwayContent$1 = "Total Pathway Content";
var ReportingInApp_ReportColumn_TotalPeerRatings$1 = "Total Peer Ratings";
var ReportingInApp_ReportColumn_TotalPoints$1 = "Total Points";
var ReportingInApp_ReportColumn_TotalRequiredPathwayContent$1 = "Total Required Content in Pathway";
var ReportingInApp_ReportColumn_TotalSelfRatings$1 = "Total Self Ratings";
var ReportingInApp_ReportColumn_TotalSkillReviews$1 = "Total Skill Reviews";
var ReportingInApp_ReportColumn_TotalSkillsFocused$1 = "Total Skills Focused";
var ReportingInApp_ReportColumn_TotalSkillsFollowed$1 = "Total Skills Followed";
var ReportingInApp_ReportColumn_TotalSkillTargetsAdded$1 = "Total Skill Targets Added";
var ReportingInApp_ReportColumn_TotalTeamFocusSkills$1 = "Total Team Focus Skills";
var ReportingInApp_ReportColumn_TotalUsersActive$1 = "Total Users Active in Plan";
var ReportingInApp_ReportColumn_TotalUsersActiveInAcademy$1 = "Total Users Active in Academy";
var ReportingInApp_ReportColumn_Type$1 = "Type";
var ReportingInApp_ReportColumn_UnmatchedSkills$1 = "Unmatched Skills";
var ReportingInApp_ReportColumn_Url$1 = "URL";
var ReportingInApp_ReportColumn_UserCompanyId$1 = "User Company ID";
var ReportingInApp_ReportColumn_UserCompletionStatus$1 = "User Completion Status";
var ReportingInApp_ReportColumn_UserCreatedDate$1 = "User Created Date";
var ReportingInApp_ReportColumn_UserEmail$1 = "User Email";
var ReportingInApp_ReportColumn_UserFirstName$1 = "User First Name";
var ReportingInApp_ReportColumn_UserId$1 = "User ID";
var ReportingInApp_ReportColumn_UserLastName$1 = "User Last Name";
var ReportingInApp_ReportColumn_UserName$1 = "User Name";
var ReportingInApp_ReportColumn_UserNote$1 = "User Note";
var ReportingInApp_ReportColumn_UserPlanStatus$1 = "User Plan Status";
var ReportingInApp_ReportColumn_UsersAddingSkills$1 = "Users Adding Skills";
var ReportingInApp_ReportColumn_UsersCompletingContent$1 = "Users Completing Content";
var ReportingInApp_ReportColumn_UsersCompletingPathways$1 = "Users Completing Pathways";
var ReportingInApp_ReportColumn_UsersFollowingPathways$1 = "Users Following Pathways";
var ReportingInApp_ReportColumn_UsersFollowingPlans$1 = "Users Following Plans";
var ReportingInApp_ReportColumn_UsersRatingSkills$1 = "Users Rating Skills";
var ReportingInApp_ReportColumn_UserStatus$1 = "User Status";
var ReportingInApp_ReportColumn_UserTopics$1 = "User Topics";
var ReportingInApp_ReportColumn_VerifiedLearningHours$1 = "Verified Learning Hours";
var ReportingInApp_ReportColumn_VerifiedLearningMinutes$1 = "Verified Learning Minutes";
var ReportingInApp_ReportColumn_ViewCountAndroid$1 = "View Count Android";
var ReportingInApp_ReportColumn_ViewCountAndroidApp$1 = "View Count Android App";
var ReportingInApp_ReportColumn_ViewCountAndroidBrowser$1 = "View Count Android Browser";
var ReportingInApp_ReportColumn_ViewCountDesktop$1 = "View Count Desktop";
var ReportingInApp_ReportColumn_ViewCountIos$1 = "View Count iOS";
var ReportingInApp_ReportColumn_ViewCountIOSApp$1 = "View Count iOS App";
var ReportingInApp_ReportColumn_ViewCountIOSBrowser$1 = "View Count iOS Browser";
var ReportingInApp_ReportColumn_ViewCountWeb$1 = "View Count Web";
var ReportingInApp_ReportColumn_ViewedDate$1 = "Viewed Date";
var ReportingInApp_ReportColumn_Visibility$1 = "Visibility";
var ReportingInApp_ReportColumn_WeeklyDigestEmail$1 = "Weekly Digest Email";
var ReportingInApp_ReportGenerate_FileFormat_Label$1 = "File Type";
var ReportingInApp_ReportGenerate_FileFormatRowLimitWarning$1 = "Reports with 1 million rows or more are only available in CSV";
var ReportingInApp_ReportGenerate_Header$1 = "Enter a title for this report";
var ReportingInApp_ReportGenerate_SavePreset_Label$1 = "Save this report configuration as a preset";
var ReportingInApp_ReportGenerate_SubmitButton$1 = "Generate";
var ReportingInApp_ReportPreview$1 = "Report Preview";
var ReportingInApp_ReportPreview_ChangeColumns$1 = "Change Columns";
var ReportingInApp_ReportPreview_DownloadNotificationMessage$1 = "Your report is generating! When it's finished, you can download it on the Reports page.";
var ReportingInApp_ReportPreview_PreviewingRowsOfFormat$1 = "Previewing {{count}} of {{total}} Rows";
var ReportingInApp_ReportPreview_UseCustomDateRange$1 = "Use a Custom Date Range";
var ReportingInApp_ReportPreview_UTCDatesNote$1 = "All Dates are UTC";
var ReportingInApp_Reports$1 = "Reports";
var ReportingInApp_ReportType_AcademiesContentCompletionOverview_Description$1 = "Use the Academy Content Completions Overview report to understand the overall percent completion by step and to see RSVP details for events.";
var ReportingInApp_ReportType_AcademiesContentCompletionOverview_Title$1 = "Academies - Content Completion Overview";
var ReportingInApp_ReportType_AcademiesDetailedByUser_Description$1 = "View details data about users content completions within  Academies";
var ReportingInApp_ReportType_AcademiesDetailedByUser_Title$1 = "Academies (Detailed by User)";
var ReportingInApp_ReportType_AcademiesLastLogin_Description$1 = "List of all users assigned to the Academy, the date they were invited to the platform and their last login.";
var ReportingInApp_ReportType_AcademiesLastLogin_Title$1 = "Academies - Last Login";
var ReportingInApp_ReportType_AcademiesMarketplaceProgramStatus_Description$1 = "Use the Academy Marketplace Program Status report to review the status of the marketplace program approval within an Academy.";
var ReportingInApp_ReportType_AcademiesMarketplaceProgramStatus_Title$1 = "Academies - Marketplace Program Status";
var ReportingInApp_ReportType_AcademiesProgressByUser_Description$1 = "Detailed list of completion by user and component for the Academy.";
var ReportingInApp_ReportType_AcademiesProgressByUser_Title$1 = "Academies - Progress By User";
var ReportingInApp_ReportType_AcademiesSummaryByAcademy_Description$1 = "View about each Academy including number of active users and users with 100% completion";
var ReportingInApp_ReportType_AcademiesSummaryByAcademy_Title$1 = "Academies (Summary by Academy)";
var ReportingInApp_ReportType_AcademiesSummaryByUser_Description$1 = "View summary data about users interacting with Academies - including number of items completed and the percentage of the Academy completed";
var ReportingInApp_ReportType_AcademiesSummaryByUser_Title$1 = "Academies (Summary by User)";
var ReportingInApp_ReportType_AcademyAndMarketplaceLoginsSummary_Description$1 = "View user login summary data.";
var ReportingInApp_ReportType_AcademyAndMarketplaceLoginsSummary_Title$1 = "Academy and Marketplace Logins (Summary)";
var ReportingInApp_ReportType_AcademyCompletionsByUser_Description$1 = "Use the Academy Completion by User report to understand the name of all users in the Academy and their percent completion.";
var ReportingInApp_ReportType_AcademyCompletionsByUser_Title$1 = "Academy - Completions By User";
var ReportingInApp_ReportType_AcademyProjectsDetailedByUser_Description$1 = "View details about the Academy Projects including user and status information";
var ReportingInApp_ReportType_AcademyProjectsDetailedByUser_Title$1 = "Academy Projects (Detailed by User)";
var ReportingInApp_ReportType_ActiveOpportunitiesDetailed_Description$1 = "View a detailed list of applicants for active opportunities by application stage.";
var ReportingInApp_ReportType_ActiveOpportunitiesDetailed_Title$1 = "Active Opportunities (Detailed)";
var ReportingInApp_ReportType_ApprovalsDetailedByUser_Description$1 = "This report returns program requests and their statuses";
var ReportingInApp_ReportType_ApprovalsDetailedByUser_Title$1 = "Approvals (Detailed by User)";
var ReportingInApp_ReportType_AssignmentActivityEmployee_Description$1 = "View a summary of each assignment in your organization, including the resource title, numbers of learners assigned, total number of assignment completions, and more.";
var ReportingInApp_ReportType_AssignmentActivityEmployee_Title$1 = "Assignment (Summary by Assignment)";
var ReportingInApp_ReportType_AssignmentsByUser_Description$1 = "View details about your learners' assignments such as resource titles, the assignee's name and user ID, the assignor's name and user ID, due dates, completion dates, and more.";
var ReportingInApp_ReportType_AssignmentsByUser_Title$1 = "Assignment (Detailed by User)";
var ReportingInApp_ReportType_CompletionActivityUser_Description$1 = "View summary data about each learner's completion activity, including latest completion date, number of items completed, and more.";
var ReportingInApp_ReportType_CompletionActivityUser_Title$1 = "Completions (Summary by User)";
var ReportingInApp_ReportType_CompletionsByUser_Description$1 = "View details about each learner's completion activity, including completion dates and more.";
var ReportingInApp_ReportType_CompletionsByUser_Title$1 = "Completions (Detailed by User)";
var ReportingInApp_ReportType_ContentCatalog_Description$1 = "View a list of both internal and external content with details that include provider information. ";
var ReportingInApp_ReportType_ContentCatalog_Title$1 = "Content Catalog (Detailed)";
var ReportingInApp_ReportType_ContentView_Description$1 = "Summary data on viewed content, including content type and browser information.";
var ReportingInApp_ReportType_ContentView_Title$1 = "Content View (Summary)";
var ReportingInApp_ReportType_CustomProgramCompletionsByUser_Description$1 = "Detailed list of completion by user and component for the Custom Program";
var ReportingInApp_ReportType_CustomProgramCompletionsByUser_Title$1 = "Custom Program - Completions by User";
var ReportingInApp_ReportType_CustomProgramOverallProgress_Description$1 = "Percent completion of each component of the Custom Program and number of enrolled users.";
var ReportingInApp_ReportType_CustomProgramOverallProgress_Title$1 = "Custom Program - Overall Progress";
var ReportingInApp_ReportType_CustomProgramPercentProgressByUser_Description$1 = "Name of all users in the Custom Program and their percent completion.";
var ReportingInApp_ReportType_CustomProgramPercentProgressByUser_Title$1 = "Custom Program - Percent Progress by User";
var ReportingInApp_ReportType_CustomProgramProjects_Description$1 = "List of all Custom Program project submissions, facilitator feedback and completion dates";
var ReportingInApp_ReportType_CustomProgramProjects_Title$1 = "Custom Program Projects";
var ReportingInApp_ReportType_CustomProgramUsersLoggedIn_Description$1 = "List of all users assigned to the Custom Program and their last login";
var ReportingInApp_ReportType_CustomProgramUsersLoggedIn_Title$1 = "Custom Program Users Logged In";
var ReportingInApp_ReportType_FollowersDetailed_Description$1 = "View data on users following other users";
var ReportingInApp_ReportType_FollowersDetailed_Title$1 = "Followers (Detailed)";
var ReportingInApp_ReportType_LearningHoursExecutiveSummary_Description$1 = "Summary level of learning hours by verified and estimated duration";
var ReportingInApp_ReportType_LearningHoursExecutiveSummary_Title$1 = "Learning Hours (Executive Summary)";
var ReportingInApp_ReportType_LearningHoursSummarybyUser_Description$1 = "Displays the verified and estimated hours of learning per user";
var ReportingInApp_ReportType_LearningHoursSummarybyUser_Title$1 = "Learning Hours (Summary by User)";
var ReportingInApp_ReportType_Logins_Description$1 = "View user login summary data.";
var ReportingInApp_ReportType_Logins_Title$1 = "Logins (Summary)";
var ReportingInApp_ReportType_MentoringDetail_Description$1 = "View a detailed list of mentees and mentors and the current status of mentorship.";
var ReportingInApp_ReportType_MentoringDetail_Title$1 = "Mentoring (Detailed)";
var ReportingInApp_ReportType_OpportunitiesInterestedActivityDetailed_Description$1 = "View a detailed list of users interested in opportunities. Includes data on both the user and the opportunity.";
var ReportingInApp_ReportType_OpportunitiesInterestedActivityDetailed_Title$1 = "Opportunities Interested Activity (Detailed)";
var ReportingInApp_ReportType_OpportunitiesViewDataSummary_Description$1 = "View summary data on the number of views for each opportunity.";
var ReportingInApp_ReportType_OpportunitiesViewDataSummary_Title$1 = "Opportunities View Data (Summary)";
var ReportingInApp_ReportType_PathwayDetailByUser_Description$1 = "View details about users’ content completions within a followed or assigned Pathway.";
var ReportingInApp_ReportType_PathwayDetailByUser_Title$1 = "Pathway (Detailed by User)";
var ReportingInApp_ReportType_PathwaySummaryByPathway_Description$1 = "View summary data about each Pathway, including the number of active users and the number of users with 100% completion.";
var ReportingInApp_ReportType_PathwaySummaryByPathway_Title$1 = "Pathway (Summary by Pathway)";
var ReportingInApp_ReportType_PathwaySummaryByUser_Description$1 = "View summary data about users following or assigned a Pathway, including the number of items completed, and the percentage of the Pathway completed.";
var ReportingInApp_ReportType_PathwaySummaryByUser_Title$1 = "Pathway (Summary by User)";
var ReportingInApp_ReportType_PlanDetailByUser_Description$1 = "View details of user’s content completions within a followed or assigned Plan.";
var ReportingInApp_ReportType_PlanDetailByUser_Title$1 = "Plan (Detailed by User)";
var ReportingInApp_ReportType_PlanSummaryByPlan_Description$1 = "View summary data about each Plan, including the number of users following the Plan.";
var ReportingInApp_ReportType_PlanSummaryByPlan_Title$1 = "Plan (Summary by Plan)";
var ReportingInApp_ReportType_PlanSummaryByUser_Description$1 = "View summary data about the users following or assigned a Plan, including the number of items completed.";
var ReportingInApp_ReportType_PlanSummaryByUser_Title$1 = "Plan (Summary by User)";
var ReportingInApp_ReportType_PublishedAcademiesDetailed_Description$1 = "View the content within published Academies";
var ReportingInApp_ReportType_PublishedAcademiesDetailed_Title$1 = "Published Academies (Detailed)";
var ReportingInApp_ReportType_PublishedOpportunitiesSummary_Description$1 = "View a summary list of opportunities including description, and number of interested, matched and selected candidates.";
var ReportingInApp_ReportType_PublishedOpportunitiesSummary_Title$1 = "Published Opportunities (Summary)";
var ReportingInApp_ReportType_PublishedPathwaysDetailed_Description$1 = "View the content within published Pathways including section and lesson information.";
var ReportingInApp_ReportType_PublishedPathwaysDetailed_Title$1 = "Published Pathways (Detailed)";
var ReportingInApp_ReportType_SearchSummary_Description$1 = "View search terms and the number of times the term was searched.";
var ReportingInApp_ReportType_SearchSummary_Title$1 = "Search (Summary)";
var ReportingInApp_ReportType_SharedDetailed_Description$1 = "View data on shared items, including who shared the item and who was the recipient.";
var ReportingInApp_ReportType_SharedDetailed_Title$1 = "Shared (Detailed)";
var ReportingInApp_ReportType_SharedOpportunitiesDetailed_Description$1 = "View a detailed list of shared opportunities including data on both the users sharing and the recipients. ";
var ReportingInApp_ReportType_SharedOpportunitiesDetailed_Title$1 = "Shared Opportunities (Detailed)";
var ReportingInApp_ReportType_SkillActivityEmployee_Description$1 = "View a summary of each skill in your organization, including the total number of profiles to which it is added, the number of times it is set as a Focus Skill, the number of times it is set to a Team Focus Skill (Skill Coach only), skill rating averages, and more.";
var ReportingInApp_ReportType_SkillActivityEmployee_Title$1 = "Skill (Summary by Skill)";
var ReportingInApp_ReportType_SkillCoachDetailedByManager_Description$1 = "View details about manager activity in the Skill Coach program.";
var ReportingInApp_ReportType_SkillCoachDetailedByManager_Title$1 = "Skill Coach (Detailed by Manager)";
var ReportingInApp_ReportType_SkillCoachOverall_Description$1 = "View a summary of the Skill Coach program. Displays number of managers participating and summary of their activity in Skill Coach. ";
var ReportingInApp_ReportType_SkillCoachOverall_Title$1 = "Skill Coach (Overall Summary)";
var ReportingInApp_ReportType_SkillCoachSummaryByManager_Description$1 = "View a summary of manager activity in the Skill Coach program.";
var ReportingInApp_ReportType_SkillCoachSummaryByManager_Title$1 = "Skill Coach (Summary by Manager)";
var ReportingInApp_ReportType_SkillFollowedDetailedByUser_Description$1 = "View data on the skills that users are following";
var ReportingInApp_ReportType_SkillFollowedDetailedByUser_Title$1 = "Skill Followed (Detailed by User)";
var ReportingInApp_ReportType_SkillsByUser_Description$1 = "View details about each learner’s interactions (such as ratings given, rating types, user-added dates, and more) for each skill in your Skills Taxonomy.";
var ReportingInApp_ReportType_SkillsByUser_Title$1 = "Skills (Detailed by User)";
var ReportingInApp_ReportType_SkillStandardDetailedByUser_Description$1 = "View a detailed view of users ratings within Skill Standards.";
var ReportingInApp_ReportType_SkillStandardDetailedByUser_Title$1 = "Skill Standard (Detailed by User)";
var ReportingInApp_ReportType_SummaryOfProgressAcademiesCustomPrograms_Description$1 = "Summary of percent progress and absolute participate count for each Academy and Custom Program.";
var ReportingInApp_ReportType_SummaryOfProgressAcademiesCustomPrograms_Title$1 = "Summary of Progress (Academies & Custom Programs)";
var ReportingInApp_ReportType_UserGroups_Description$1 = "View detailed information on the user groups.";
var ReportingInApp_ReportType_UserGroups_Title$1 = "User Groups (Detailed)";
var ReportingInApp_ReportType_UserSummary_Description$1 = "View user information including last login and points.";
var ReportingInApp_ReportType_UserSummary_Title$1 = "User (Summary)";
var ReportingInApp_ReportType_VWRptUserSummaryAnonymized_Description$1 = "";
var ReportingInApp_ReportType_VWRptUserSummaryAnonymized_Title$1 = "UserSummary";
var ReportingInApp_SavedPresets$1 = "Presets";
var ReportingInApp_SavedPresets_ConfirmDelete$1 = "Are you sure you would like to delete this saved preset?";
var ReportingInApp_SavedPresets_Description$1 = "After creating a report, you can save the settings and filters to use again later. Saved presets will be listed on this page.";
var ReportingInApp_SavedPresets_Error_DeletePreset$1 = "Failed to delete saved presets";
var ReportingInApp_SavedPresets_PresetDeleted$1 = "Saved presets successfully deleted";
var ReportingInApp_Scheduled_MaxReportsNotice$1 = "Schedule up to 30 reports";
var ReportingInApp_ScheduledReports$1 = "Scheduled Reports";
var ReportingInApp_Segments$1 = "Segments";
var ReportingInApp_Segments_DropdownFilter_TitleSelected$1 = "Segments Selected";
var ReportingInApp_Segments_Error_GetSegements$1 = "Error getting reporting segments";
var ReportingInApp_Segments_Error_GetUserForSegments$1 = "Error retrieving users";
var ReportingInApp_Segments_Error_UpdateUserForSegments$1 = "Error updating reporting user for segments";
var ReportingInApp_Segments_Modal_Info$1 = "Search by name to add report users for this segment.";
var ReportingInApp_Segments_Modal_Title$1 = "Edit Report Permission for {{segmentName}}";
var ReportingInApp_Segments_Modal_UserListTitle$1 = "Approved Users";
var ReportingInApp_Segments_Success_UpdateUserForSegments$1 = "Successfully updated reporting users for segment";
var ReportingInApp_Segments_View_Attributes$1 = "Attributes";
var ReportingInApp_Segments_View_EditReportPermissions$1 = "Edit Report Permissions";
var ReportingInApp_Segments_View_ReportPermissions$1 = "Report Permissions";
var ReportingInApp_Segments_View_SegmentName$1 = "Segment Name";
var ReportingInApp_Status_Download$1 = "Ready for Download";
var ReportingInApp_Status_Error$1 = "Error";
var ReportingInApp_Status_InProgress$1 = "Processing";
var ReportingInApp_Status_Unknown$1 = "Unknown";
var replyToPost_GroupPluralFormat$1 = "{{nameHtml}} and {{number}} others replied to your post in {{groupNameHtml}}";
var replyToPost_GroupSingleFormat$1 = "{{nameHtml}} replied to your post in {{groupNameHtml}}";
var replyToPost_PluralFormat$1 = "{{nameHtml}} and {{number}} others replied to your post";
var replyToPost_SingleFormat$1 = "{{nameHtml}} replied to your post ";
var replyToComment_CommentGroupPluralFormat$1 = "{{nameHtml}} and {{number}} others replied to your comment in {{groupNameHtml}}";
var replyToComment_CommentGroupSingleFormat$1 = "{{nameHtml}} replied to your comment in {{groupNameHtml}}";
var replyToComment_CommentPluralFormat$1 = "{{nameHtml}} and {{number}} others replied to your comment";
var replyToComment_CommentSingleFormat$1 = "{{nameHtml}} replied to your comment";
var replyToComment_TakeawayGroupPluralFormat$1 = "{{nameHtml}} and {{number}} others replied to your takeaway in {{groupNameHtml}}";
var replyToComment_TakeawayGroupSingleFormat$1 = "{{nameHtml}} replied to your takeaway in {{groupNameHtml}}";
var replyToComment_TakeawayPluralFormat$1 = "There are {{number}} replies to your takeaway on {{takeawayTitleHtml}}";
var replyToComment_TakeawaySingleFormat$1 = "{{nameHtml}} replied to your takeaway on {{takeawayTitleHtml}}";
var RecommendationsSvc_DeleteConfirmationFormat$1 = "Are you sure you want to delete <br> {{title}}?";
var RecommendationsSvc_GetUsersError$1 = "An error occurred getting a list of shares.";
var RecommendationsSvc_InputAssignedFormat$1 = "{{title}} has been successfully assigned.";
var RecommendationsSvc_InputAssignedFormatIneligibleAdmin$1 = "{{title}} has been assigned! However, some people you recommended it to aren’t eligible to complete a Skill Review for this skill. Edit this skill to enable it for Skill Review.";
var RecommendationsSvc_InputAssignedFormatIneligibleLearner$1 = "{{title}} has been assigned! However, some people you recommended it to aren’t eligible to complete a Skill Review for this skill. For more information, contact your admin.";
var RecommendationsSvc_InputAssignedFormatNoEligibleUsersAdmin$1 = "{{title}} could not be assigned because none of the people you selected are eligible to complete a Skill Review for this skill. Edit this skill to enable it for Skill Review.";
var RecommendationsSvc_InputAssignedFormatNoEligibleUsersLearner$1 = "{{title}} could not be assigned because none of the people you selected are eligible to complete a Skill Review for this skill. For more information, contact your admin.";
var RecommendationsSvc_InputRecommendedFormat$1 = "{{title}} has been successfully recommended.";
var RecommendationsSvc_InputRecommendedFormatIneligibleAdmin$1 = "{{title}} has been recommended! However, some people you recommended it to aren’t eligible to complete a Skill Review for this skill. Edit this skill to enable it for Skill Review.";
var RecommendationsSvc_InputRecommendedFormatIneligibleLearner$1 = "{{title}} has been recommended! However, some people you recommended it to aren’t eligible to complete a Skill Review for this skill. For more information, contact your admin.";
var RecommendationsSvc_InputRecommendedFormatNoEligibleUsersAdmin$1 = "{{title}} could not be recommended because none of the people you selected are eligible to complete a Skill Review for this skill. Edit this skill to enable it for Skill Review.";
var RecommendationsSvc_InputRecommendedFormatNoEligibleUsersLearner$1 = "{{title}} could not be recommended because none of the people you selected are eligible to complete a Skill Review for this skill. For more information, contact your admin.";
var RecommendationsSvc_ProblemAccessingRecommendations$1 = "Sorry! There was a problem with accessing your shares.";
var RecommendationsSvc_ProblemAddingRecommendations$1 = "Sorry! There was a problem adding this recommendation.";
var RecommendationsSvc_ProblemDeleteRecommendationsFormat$1 = "Sorry! There was a problem deleting the share";
var RecommendationsSvc_ProblemSearchingGroups$1 = "Sorry! There was a problem searching groups.";
var RecommendationsSvc_ProblemSearchingMembers$1 = "Sorry! There was a problem searching members.";
var RecommendationsSvc_ProblemUpdatingRecommendation$1 = "Sorry! There was a problem updating this share.";
var RecommendationsSvc_SharedWith$1 = "Shared With";
var RecommendationsSvc_SuccessDelete$1 = "Shared has been successfully deleted.";
var RecommendationsSvc_SuccessDeleteAssignment$1 = "Assignment has been successfully deleted.";
var RecommendationsSvc_UpdateAssignment$1 = "Assignment has been successfully updated.";
var RecommendationsSvc_UpdateRecommendation$1 = "Share has been successfully updated.";
var RecommendationsSvc_UsersTitle$1 = "People who shared this";
var RecommendationsOverviewCtrl_DismissDialogDescription$1 = "This will no longer be assigned to you.";
var RecommendationPolicyModal_Acknowledge$1 = "I acknowledge";
var RecommendationPolicyModal_Title$1 = "Sharing Policy";
var recommendationForm_AddToProfileFormat$1 = "Add {{itemName}} to Profile";
var recommendationForm_AssignItem$1 = "Assign this {{itemType}}";
var recommendationForm_BackToAddingNames$1 = "Back to adding names and groups";
var recommendationForm_CharacterCount$1 = "{{characterCount}} characters remaining";
var recommendationForm_ConfirmDelete$1 = "Are you sure you want to delete this share?";
var recommendationForm_CopyUrl$1 = "Copy URL";
var recommendationForm_dateLabel$1 = "Due by";
var recommendationForm_dateToggle$1 = "Assign";
var recommendationForm_dateToggleInfo$1 = "Prioritize learning with an optional due date.";
var recommendationForm_EmailRecommendation$1 = "Share via email";
var recommendationForm_FindPeopleConsumerPlaceholder$1 = "Search by name";
var recommendationForm_FindPeoplePlaceholder$1 = "Search by name or group";
var recommendationForm_HasRecommendedSkills$1 = "has recommended the following skills. <br> Click on the + to add to your profile";
var recommendationForm_MemberCount$1 = "{{memberCount}} Members | Group";
var recommendationForm_NoResults$1 = "No results found";
var recommendationForm_OnlyOrgMembers$1 = "*Assigned learning option not available to followers outside your organization.";
var recommendationForm_PickADate$1 = "Pick a date";
var recommendationForm_RecommendInput$1 = "Share this {{inputType}}";
var recommendationForm_RecommendItem$1 = "Share this {{itemType}}";
var recommendationForm_RecommendItem_Academy$1 = "Share this Academy";
var recommendationForm_RecommendItem_Article$1 = "Share this Article";
var recommendationForm_RecommendItem_Assessment$1 = "Share this Assessment";
var recommendationForm_RecommendItem_Book$1 = "Share this Book";
var recommendationForm_RecommendItem_Course$1 = "Share this Course";
var recommendationForm_RecommendItem_Episode$1 = "Share this Podcast";
var recommendationForm_RecommendItem_Event$1 = "Share this Event";
var recommendationForm_RecommendItem_Opportunity$1 = "Share this Opportunity";
var recommendationForm_RecommendItem_Pathway$1 = "Share this Pathway";
var recommendationForm_RecommendItem_Plan$1 = "Share this Plan";
var recommendationForm_RecommendItem_Podcast$1 = "Share this Podcast";
var recommendationForm_RecommendItem_Post$1 = "Share this Post";
var recommendationForm_RecommendItem_Tag$1 = "Recommend a Skill Rating";
var recommendationForm_RecommendItem_Target$1 = "Share this Plan";
var recommendationForm_RecommendItem_Task$1 = "Share this Task";
var recommendationForm_RecommendItem_Video$1 = "Share this Video";
var recommendationForm_RecommendSkillInput$1 = "Recommend a Skill Rating";
var recommendationForm_SearchByName$1 = "Search by name";
var recommendationForm_SearchLabel$1 = "Search by name or group";
var recommendationForm_SearchLabelConsumer$1 = "Search your public followers by name";
var recommendationForm_submitButtonPlural$1 = "Share with {{recommendeeCount}} people";
var recommendationForm_submitButtonPluralAssign$1 = "Assign to {{recommendeeCount}} people";
var recommendationForm_submitButtonSingular$1 = "Share with 1 person";
var recommendationForm_submitButtonSingularAssign$1 = "Assign to 1 person";
var recommendationForm_UpdateItem$1 = "Update this {{itemType}}";
var recommendationForm_ViewSkillsOnProfile$1 = "View Skills on Profile";
var recommendationForm_WhyAssignedUpdate$1 = "Update your note on why you are assigning this";
var recommendationForm_WhyRecommendedUpdate$1 = "Update your note on why you are sharing this";
var recommendationForm_WhyRecommending$1 = "Message";
var recommendationForm_WhyRecommendingPlaceholder$1 = "Add a message on why you are sharing this";
var recommendationDetail_DueDateFormat$1 = "Due {{dueDate}}";
var recommendationDetail_LevelFormat$1 = "Level {{statusDetails}}";
var recommendationDetail_StatusComplete$1 = "Complete";
var recommendationDetail_StatusDismissed$1 = "Dismissed";
var recommendationDetail_StatusPending$1 = "Pending";
var recommendationDetail_StatusPrivate$1 = "Private";
var recommendationDetail_StatusQueued$1 = "Saved for Later";
var RecommendationCtrl_SelectADate$1 = "Please select a date";
var QueueSvc_InternalError$1 = "Sorry! There was a problem. It’s not your fault, we are working hard to fix the problem.";
var QueueSvc_ItemAddedFormat$1 = "{{item}} has been saved!";
var QueueSvc_UsersTitle$1 = "People who saved this";
var QueueCtrl_CompletedMovedToCollection$1 = "The completed item successfully moved to collection";
var QueueCtrl_EmptyStateDescription$1 = "Anything that you save will be shown here.";
var QueueCtrl_EmptyStateTitle$1 = "No Saved Items";
var QueueCtrl_InternalError$1 = "Sorry! There was a problem performing this action. It’s not your fault, we are working hard to fix the problem.";
var QueueCtrl_NoItemsSaved$1 = "You don't have any items saved.";
var QueueCtrl_RemoveSavedItems$1 = "Are you sure you want to remove this from your saved items?";
var QueueCtrl_SavedDescription$1 = "Saved items can be collected and completed or shared at a later date.";
var QueueCtrl_SaveInstructionsFormat$1 = "You can save items using the {{startBookmarklet}}Degreed Button{{endTag}}, or by finding content to learn on your {{startLearning}}Degreed Home Page{{endTag}}.";
var QueueCtrl_SaveUrlForLater$1 = "Save a URL for later";
var PublicError_HomePageButton$1 = "Go to Home Page";
var ProviderSummary_agileunternehmen$1 = "Blog from Dr. Dominic Lindner with content around the digitization and agility of companies. Includes scientific content translated into practice and recommendations from practitioners.";
var ProviderSummary_aicpa$1 = "The American Institute of Certified Public Accountants is the world’s largest member association representing the accounting profession.";
var ProviderSummary_alura$1 = "Alura provides immersive technology training 100% in Portuguese.";
var ProviderSummary_anderspink$1 = "Anders Pink automatically curates content from around the web and is customizable to the topics and skills that matter to you most.  The briefing feeds update every day with fresh content from quality sites.  Preview this collection of popular feeds and help your learners to spend less time searching, and more time engaging with recent, relevant content.";
var ProviderSummary_arcitura$1 = "Arcitura Education Inc. is a global provider of progressive, vendor-neutral  IT training and certification programs.";
var ProviderSummary_ascm$1 = "The Association for Supply Chain Management (ASCM) is the largest nonprofit association for supply chain, unbiased partner, offers globally recognized supply chain certifications, and end-to-end training.";
var ProviderSummary_awstraining$1 = "AWS Training and Certification is the only set of training programs and offerings built by the experts at AWS.";
var ProviderSummary_babbel$1 = "A leader in the online language learning industry, Babbel is international with millions of active subscribers.";
var ProviderSummary_bigdatainsider$1 = "BigData-Insider is the information portal for all topics relating to the management and analysis of large amounts of data.";
var ProviderSummary_blinkist$1 = "Blinkist distills key insights from nonfiction books into powerful 15-minute reads or listens.";
var ProviderSummary_business2community$1 = "Business 2 Community covers breaking news and top trends in Social Media, Digital Marketing, Content Marketing, Social Selling, Social Business and More";
var ProviderSummary_businessinsider$1 = "Business Insider reports from inside companies across tech, finance, retail and the all industries that matter to the leaders of today and tomorrow.";
var ProviderSummary_busuupremium$1 = "Busuu provides courses in 12 different languages on web and mobile to more than 100 million learners worldwide.";
var ProviderSummary_cbtnuggets$1 = "CBT Nuggets offers for in-demand technology training available anytime, anywhere.";
var ProviderSummary_centerforcreativeleadership$1 = "The Center for Creative Leadership is a top-ranked, global provider of leadership development.";
var ProviderSummary_cisconetworkingacademy$1 = "Cisco Networking Academy is a global IT and cybersecurity education program that partners with learning institutions around the world to empower all people with career opportunities.";
var ProviderSummary_crehana$1 = "EdTech Startup that aims to create user-centered and adaptive digital learning environments.";
var ProviderSummary_cybrary$1 = "Cybrary is a learning center based on the collective knowledge from the cybersecurity industry's top experts and leading organizations and is dedicated to users and teams wanting to gain, improve, assess, and certify their cybersecurity skills.";
var ProviderSummary_datacamp$1 = "DataCamp is the skills development platform for data-driven professionals and organizations with a goal of upskilling in data science and machine learning.";
var ProviderSummary_degreedmeta$1 = "Degreed’s original content and curated pathways.";
var ProviderSummary_deloitteinsights$1 = "On the Press Room, host Tanya Ott interviews thought leaders and change makers on developments in business strategy, emerging technologies, growth, innovation, performance, and more.";
var ProviderSummary_duarte$1 = "Duarte helps brands and professionals create and deliver presentations and communication which inspire audiences to action.";
var ProviderSummary_edx$1 = "edX is a massive open online course (MOOC) provider that hosts online university-level courses in a wide range of disciplines to a worldwide student body.";
var ProviderSummary_emtrain$1 = "Emtrain helps employees navigate inclusion, respect, and ethics questions to foster healthy workplace cultures.";
var ProviderSummary_entrepreneur$1 = "Entrepreneur is an American magazine that carries news stories about entrepreneurship, small business management, and business.";
var ProviderSummary_exitcertified$1 = "ExitCertified (Tech Data) helps learners gain vital IT skills and the ability to advance to the next level in a chosen field.";
var ProviderSummary_financialedge$1 = "Financial Edge Training specializes in developing professionals' technical skills in investment banking, asset management, project finance and much more.";
var ProviderSummary_fortinet$1 = "This offering provides comprehensive free courses to prepare users to become NSE-certified at all mastery levels.";
var ProviderSummary_fortytwocourses$1 = "42courses is an e-learning platform with practical, accredited on-demand learning taught by real-world business leaders and brands.";
var ProviderSummary_futurelearn$1 = "FutureLearn offers a diverse selection of MOOCs from leading universities and cultural institutions from around the world.";
var ProviderSummary_getabstract$1 = "GetAbstract creates abstracts of a range of books and articles for business customers, delivered in summaries of the most relevant books.";
var ProviderSummary_ghsp$1 = "GHSP is a no-fee, open-access, peer-reviewed, online journal aimed to improve health practice";
var ProviderSummary_goskills$1 = "GoSkills is an online learning platform that helps anyone learn business skills to reach their personal and professional goals.";
var ProviderSummary_greatlearning$1 = "Great Learning offers professional certifications from world-class universities in the most in-demand domains.";
var ProviderSummary_growwithgoogle$1 = "Google Career Certificates offers flexible online training for job-ready skills you can put to work.";
var ProviderSummary_handelsblatt$1 = "Handelsblatt is a German language business and financial newspaper covering global business.";
var ProviderSummary_hrcom$1 = "HR.com is the largest social networking site for HR professionals with articles, case studies, newsletters, polls, discussion forums, blogs and webcasts.";
var ProviderSummary_hubspotacademy$1 = "HubSpot Academy has free online training for inbound marketing, sales, and customer service professionals.";
var ProviderSummary_ideou$1 = "Learn IDEO's approach to design thinking and creative problem solving through IDEO U—an online school that equips individuals with the tools and mindsets necessary to ignite creative confidence and tackle complex challenges.";
var ProviderSummary_industryofthings$1 = "Industry of Things is a German-language online portal that focuses on the practical use of the Internet of Things, M2M and Industry 4.0 applications.";
var ProviderSummary_invisionapp$1 = "InVision offers digital product design tips, news, and inspiration.";
var ProviderSummary_itprotv$1 = "ITProTV offers online IT training videos with hands-on interactive labs to enhance IT knowledge and prepare for IT certification exams.";
var ProviderSummary_joshbersin$1 = "Josh Bersin’s blog provides insights on work, talent, learning, leadership, and HR technology.";
var ProviderSummary_kenblanchardcompanies$1 = "The Ken Blanchard Companies offer research-backed leadership development solutions, training programs, and coaching that inspire others and create results.";
var ProviderSummary_kes$1 = "KES is an innovation content platform based on technology, behavior and creativity with the mission to help executives and companies form a new business mindset.";
var ProviderSummary_khanacademy$1 = "Khan Academy supplies a free online collection of micro-lectures via video tutorials in nearly 30 languages and has delivered over 600 million lessons worldwide.";
var ProviderSummary_loma$1 = "LOMA is a trade association that offers training and development programs covering management, operations, research, and best practices in the life insurance industry.";
var ProviderSummary_mandel$1 = "Mandel Communications delivers training, coaching, and workshops focused on strengthening presentation, conversation, and facilitation skills.";
var ProviderSummary_masterclass$1 = "MasterClass produces online classes taught by renowned personalities in their respective fields.";
var ProviderSummary_mckinsey$1 = "McKinsey & Company provides the latest business insights with thousands of articles and reports on the biggest opportunities and most challenging issues today.";
var ProviderSummary_methods$1 = "Learn the Methods of leadership from some of the best CEOs, executive coaches, thought leaders and business thinkers on the planet.";
var ProviderSummary_microsoftlearn$1 = "Microsoft Learn offers training to upskill on Microsoft products and services through task-based, interactive learning, localized into many different languages.";
var ProviderSummary_mindtools$1 = "Use MindTools.com resources to learn more than 2800 management, leadership and personal effectiveness skills, helping you to be happy and successful at your job.";
var ProviderSummary_mitsloanmgmtreview$1 = "MIT Sloan Management Review is a research-based magazine and digital platform for business executives published at the Massachusetts Institute of Technology.";
var ProviderSummary_platzi$1 = "Platzi is an online platform that trains the next generation of technology professionals.";
var ProviderSummary_pluralsight$1 = "Pluralsight offers a variety of video training courses for software developers, IT administrators, and creative professionals.";
var ProviderSummary_racismreview$1 = "Racism Review is a collaborative blog that highlights sociological research on race and racism.";
var ProviderSummary_redshelf$1 = "RedShelf is an EdTech company helping to improve education through the use of digital instructional resources.";
var ProviderSummary_safari$1 = "Safari Books Online is an on-demand digital library that delivers expert content in both book and video form from the world’s leading authors in technology and business.";
var ProviderSummary_scoopnewsgroup$1 = "Scoop News Group is the leading public sector tech media company in the United States";
var ProviderSummary_simplilearn$1 = "Simplilearn provides online education and in-house training for professional certification courses.";
var ProviderSummary_skillshare$1 = "Skillshare is an online learning community of non-accredited educational videos available through subscription. The main course categories are creative arts, design, entrepreneurship, lifestyle, technology, and many more subtopics.";
var ProviderSummary_softwareengineeringinstitute$1 = "SEI at Carnegie Mellon conducts software engineering research in acquisition, architecture and product lines, process improvement and performance measurement, security, and system interoperability and dependability.";
var ProviderSummary_soundview$1 = "Soundview provides time-saving summaries and key insights from bestselling business books.";
var ProviderSummary_springerprofessional$1 = "Springer Professional is a provider of classic and digital specialist media in the areas of economics, science, engineering and social studies in the German-speaking world.";
var ProviderSummary_tedatwork$1 = "TED@Work takes powerful and bold TED Talks and re-imagines them for workplace learning with a new framework and practical tools. This TED@Work Preview features 10 sample pathways from the full license-only catalog.";
var ProviderSummary_udacity$1 = "Udacity advances your career with online courses in programming, data science, artificial intelligence, digital marketing, and more.";
var ProviderSummary_whil$1 = "Whil is a platform focused on reducing stress, increasing resilience and improving mental wellbeing.";
var ProviderSummary_workingvoices$1 = "Working Voices offers short, bite-sized articles, videos, courses, tips, and techniques for improving professional skills in and out of the workplace.";
var ProfileSkillStd_CollaboratorOnly$1 = "Collaborator Only";
var ProfileSkillStd_EmptyStateDescription$1 = "Any Skill Standards you create or have assigned will show here.";
var ProfileSkillStd_EmptyStateTitle$1 = "No Skill Standards";
var ProfilePlans_EmptyDescription$1 = "Create, share, and follow Learning Plans.";
var ProfilePlans_EmptyStateDescription$1 = "Any plans you create or follow will show here.";
var ProfilePlans_EmptyStateTitle$1 = "No Plans";
var ProfilePlans_FindPlans$1 = "Find a Plan to Follow";
var ProfilePlans_NoPlans$1 = "No Plans to Show";
var ProfilePlans_NoPlansDescription$1 = "{{name}} hasn't created or followed any plans.";
var ProfilePathways_Authoring$1 = "Authoring";
var ProfilePathways_Completed$1 = "Completed";
var ProfilePathways_CreateNewPathway$1 = "Create Pathway";
var ProfilePathways_CreatePathway$1 = "Create a Pathway";
var ProfilePathways_EmptyDescription$1 = "Create, share, and follow Learning Pathways.";
var ProfilePathways_EmptyStateDescription$1 = "Any pathways you create or follow will show here.";
var ProfilePathways_EmptyStateTitle$1 = "No Pathways";
var ProfilePathways_EmptyTitle$1 = "Start Your Journey";
var ProfilePathways_Enrolled$1 = "Enrolled";
var ProfilePathways_FindPathways$1 = "Find a Pathway to Follow";
var ProfilePathways_FindPathwaysAria$1 = "Find something to learn";
var ProfilePathways_Following$1 = "Following";
var ProfilePathways_LearnTypesAlt$1 = "Find, track, and measure ALL your learning";
var ProfilePathways_NoPathways$1 = "No Pathways to Show";
var ProfilePathways_UserNoPathwaysFormat$1 = "{{profileName}} hasn't created or followed any pathways.";
var ProfileCtrl_AddGroup$1 = "Add Group";
var ProfileCtrl_AllCategories$1 = "All Categories";
var ProfileCtrl_ArticlesRead$1 = "Articles Read";
var ProfileCtrl_AssessmentsCompleted$1 = "Assessments Completed";
var ProfileCtrl_BooksRead$1 = "Books Read";
var ProfileCtrl_BulkDeleteFormat$1 = "Delete Collection Items";
var ProfileCtrl_BulkDeleteSingle$1 = "Are you sure you want to delete the selected item?";
var ProfileCtrl_CoursesCompleted$1 = "Courses Completed";
var ProfileCtrl_CreateGroup$1 = "Create a Group";
var ProfileCtrl_DeleteCollectionGenericItemBody$1 = "These items will no longer count toward your overall points and will no longer appear in your profile.";
var ProfileCtrl_DeleteCollectionGenericItemBodySingle$1 = "Are you sure you want to delete your selected item? Once deleted, it will not show on your profile.";
var ProfileCtrl_DeleteCollectionItemBodyFormat$1 = "This {{type}} will no longer count toward your overall points and will no longer appear in your profile.";
var ProfileCtrl_DeleteCollectionItemHeaderFormat$1 = "Are you sure you want to delete this {{type}}?";
var ProfileCtrl_DeleteCollectionItemNotifierFormat$1 = "{{itemTitle}} has been deleted.";
var ProfileCtrl_DeleteCollectionMultipleItemsNotifierFormat$1 = "{{selectedLength}} items have been deleted.";
var ProfileCtrl_DeleteProviderItemNotifierFormat$1 = "Items from '{{providerName}}' have been deleted.";
var ProfileCtrl_DeleteProviderItemPromptFormat$1 = "Are you sure you want to delete the items from '{{providerName}}'?";
var ProfileCtrl_EditCollectionItemNotifierFormat$1 = "{{itemTitle}} has been updated!";
var ProfileCtrl_EditCollectionMultipleItemsNotifierFormat$1 = "{{selectedLength}} items have been updated.";
var ProfileCtrl_EventsAttended$1 = "Events Attended";
var ProfileCtrl_ExperienceDatePresent$1 = "Present";
var ProfileCtrl_ExperienceDateYears$1 = "Years";
var ProfileCtrl_ExperienceReported$1 = "Experience Reported";
var ProfileCtrl_FindGroups$1 = "Find a group to join";
var ProfileCtrl_GroupsDescription$1 = "Groups are a social tool to engage learners, encourage discussions around learning and enable learners to find the most relevant content for their job or learning goals.";
var ProfileCtrl_NoExactMatches$1 = "No exact matches";
var ProfileCtrl_NoExactMatchesHelp$1 = "Try changing or removing some of your filters or adjusting your search area.";
var ProfileCtrl_OwnerEmptyStateBody$1 = "Record all your learning, experiences, achievements, pathways and plans here.";
var ProfileCtrl_OwnerEmptyStateTitle$1 = "Your collection is empty";
var ProfileCtrl_PathwaysDescription$1 = "Pathways are guided paths for content that track a learner's completion progress. Pathways contain content items specific to a subject or topic and can be organized by sections and subsections of related items.";
var ProfileCtrl_PlansDescription$1 = "A plan is a collection of relevant Skills, Pathways, Groups, People and learning content items that can help learners improve their skills in their current positions, or prepare them for new roles.";
var ProfileCtrl_PodcastsCompleted$1 = "Podcast Episodes Completed";
var ProfileCtrl_PointsEarnedTitle$1 = "Points Earned";
var ProfileCtrl_ShareProfile$1 = "Share Profile";
var ProfileCtrl_ShareProfilePrivate$1 = "Your Profile is Private";
var ProfileCtrl_ShareProfileSuccess$1 = "Profile link copied!";
var ProfileCtrl_ShareSkillSuccess$1 = "Skill link copied!";
var ProfileCtrl_SkillStdDescription$1 = "Skill Standards are the skills that your organization values most. You can use this set of skills to help focus your learning to achieve Skill Targets.";
var ProfileCtrl_VideosWatched$1 = "Videos Watched";
var ProfileCtrl_ViewSkillSignals$1 = "View Skill Signals";
var problemModalContent_4xxOr5xxError$1 = "I see a 4xx or 5xx error";
var problemModalContent_AccessDenied$1 = "I don't have permission to access this item";
var problemModalContent_AdditionalDetails$1 = "Additional Details";
var problemModalContent_AdditionalDetailsPlaceholder$1 = "Provide more details about the problem";
var problemModalContent_ApplicationQuestions$1 = "I have questions about this application";
var problemModalContent_ApplicationTroubleCompleting$1 = "I'm having trouble completing this application";
var problemModalContent_AttachScreenshot$1 = "Attach Screenshot";
var problemModalContent_BrokenLink$1 = "I can't access this link or this link appears to be broken.";
var problemModalContent_BrowserBlocked$1 = "The content is not loading (browser/blocked site)";
var problemModalContent_ChangeGroupVisibility$1 = "I want to change the visibility of this group";
var problemModalContent_ChangingProfile$1 = "I'm trying to change something on my profile";
var problemModalContent_CompletedOverdueSeveralDays$1 = "I've completed this content days ago and it still shows as Overdue";
var problemModalContent_CompletedOverdueToday$1 = "I've completed this content today but it still shows as Overdue";
var problemModalContent_ContactPermission$1 = "You have permission to contact me with additional questions.";
var problemModalContent_ContentDurationIncorrect$1 = "The duration for the content is incorrect";
var problemModalContent_ContentInappropriate$1 = "This content is inappropriate";
var problemModalContent_ContentMisassigned$1 = "This content should not have been assigned to me";
var problemModalContent_ContentNotAppropriateForWorkplace$1 = "This content is not appropriate for a professional workplace";
var problemModalContent_ContentNotRelevant$1 = "The content is not relevant to my interests";
var problemModalContent_ContentNotSafeForWork$1 = "The content is not safe for work";
var problemModalContent_ContentSomethingIncorrect$1 = "There is something incorrect about the content";
var problemModalContent_ContentTypeIncorrect$1 = "The content type is incorrect";
var problemModalContent_DefaultQuestions$1 = "I have questions about this item";
var problemModalContent_DefaultRelevance$1 = "This item is not relevant";
var problemModalContent_ErrorWithProvider$1 = "There is something wrong with this provider";
var problemModalContent_FileRestrictionDescription$1 = "Files can be images (.jpg, .jpeg, .gif, png) up to 5MB in size.";
var problemModalContent_FileTypes$1 = "Files can be images (.jpg, .jpeg, .gif, png) up to {{filesizeLimit}} in size.";
var problemModalContent_Flag$1 = "This item is inappropriate";
var problemModalContent_IncorrectPoints$1 = "The amount of points allocated is incorrect";
var problemModalContent_IssuesJoining$1 = "Users are having issues joining this group";
var problemModalContent_LinkAppearsBroken$1 = "I can't access this link or this link appears to be broken";
var problemModalContent_OpportunityIrrelevant$1 = "This opportunity is not relevant";
var problemModalContent_OpportunityQuestions$1 = "I have questions about this opportunity";
var problemModalContent_Other$1 = "Other";
var problemModalContent_OtherInstructions$1 = "For other issues, please visit the {{knowledgeCenterLinkStart}}Degreed Knowledge Center{{knowledgeCenterLinkEnd}}";
var problemModalContent_PaidContent$1 = "I have to subscribe or pay to access this content";
var problemModalContent_PermissionOrLicense$1 = "I can't access this due to a permission or license error message";
var problemModalContent_ProfileNotAppropriate$1 = "This profile is not appropriate";
var problemModalContent_Reason$1 = "What's the Problem?";
var problemModalContent_ReasonPlaceholder$1 = "Describe the Problem";
var problemModalContent_RequiredLearningWarning$1 = "It can take up to 48 hours for Required Learning to clear.";
var problemModalContent_ShouldNotBeConnected$1 = "This provider should no longer be connected";
var problemModalContent_SubissuePlaceholder$1 = "Choose one";
var problemModalContent_Subreason$1 = "What do you need help with?";
var problemModalContent_TeamIncorrectInsights$1 = "The insights for this team are incorrect";
var problemModalContent_TeamIncorrectMembers$1 = "The members in this team are incorrect";
var problemModalContent_Title$1 = "Report a Problem";
var problemModalContent_UnableToShare$1 = "I'm unable to share content to this group";
var problemModalContent_UploadScreenshotDetail$1 = "For faster resolution of the problem, please include a screenshot with your detailed description of the issue.";
var problemModalContent_UploadScreenshotMessage$1 = "Drag and drop or click to upload an image";
var primaryPlanSelectionModal_YesContinue$1 = "Yes, continue";
var PrePay_CertificateApplication$1 = "Certificate Application";
var PrePay_ChooseSkill$1 = "Choose Skill";
var PrePay_Payment$1 = "Payment";
var PrePay_YourInformation$1 = "Your Information";
var PostFormCtrl_AnotherPathway$1 = "another pathway";
var PostFormCtrl_AreYouSure$1 = "Changes you have made will be lost. Are you sure you want to close?";
var PostFormCtrl_ClonedEditMessage$1 = "This Post was originally created in {{pathwayName}}. The pathway you are editing has been cloned from the original pathway and its included Posts can only be edited in the original pathway context.";
var PostFormCtrl_Content$1 = "Content";
var PostFormCtrl_CreatePost$1 = "Create Post";
var PostFormCtrl_CreatePostSave$1 = "Post";
var PostFormCtrl_EditingDescription$1 = "Changes to this post will affect any cloned pathways in which this post appears.";
var PostFormCtrl_EditPost$1 = "Edit Post";
var PostFormCtrl_EditPostSave$1 = "Save";
var PostFormCtrl_Title$1 = "Title";
var PostFormCtrl_TitleLength$1 = "Title must be 255 characters or less.";
var PostFormCtrl_TitleRequired$1 = "A title is required.";
var PositionFormCtrl_AddCategory$1 = "Please add at least one category.";
var PositionFormCtrl_AddExperience$1 = "Add Experience";
var PositionFormCtrl_AverageHours$1 = "Please specify the average number of hours you worked each week.";
var PositionFormCtrl_CompanyOrg$1 = "Company or Organization";
var PositionFormCtrl_CurrentPosition$1 = "This is my current position";
var PositionFormCtrl_DescribeExperience$1 = "Describe your experience";
var PositionFormCtrl_Description$1 = "Description";
var PositionFormCtrl_EditExperience$1 = "Edit Experience";
var PositionFormCtrl_EndAfterStart$1 = "The end date must be after the start date.";
var PositionFormCtrl_EndDate$1 = "End Date";
var PositionFormCtrl_EndDateError$1 = "Please specify the date you left this experience.";
var PositionFormCtrl_ExpDescriptionLength$1 = "Experience description must be 5000 characters or less.";
var PositionFormCtrl_ExperienceTitle$1 = "Experience Title";
var PositionFormCtrl_HoursPerWeek$1 = "Hours per Week";
var PositionFormCtrl_IntermediatePosition$1 = "Intermediate";
var PositionFormCtrl_JuniorPosition$1 = "Junior";
var PositionFormCtrl_MenteeName$1 = "Mentee Name";
var PositionFormCtrl_MentorName$1 = "Mentor Name";
var PositionFormCtrl_Organization$1 = "Organization";
var PositionFormCtrl_PositionTitle$1 = "Position Title";
var PositionFormCtrl_RequiredOrg$1 = "A organization name is required.";
var PositionFormCtrl_RequiredTitle$1 = "A title is required.";
var PositionFormCtrl_SaveExperience$1 = "Save Experience";
var PositionFormCtrl_SelectType$1 = "Select Type";
var PositionFormCtrl_Seniority$1 = "Seniority";
var PositionFormCtrl_SeniorPosition$1 = "Senior";
var PositionFormCtrl_StartDate$1 = "Start Date";
var PositionFormCtrl_StartDateError$1 = "Please specify the date you started this experience.";
var PositionFormCtrl_Title$1 = "Title";
var PositionFormCtrl_WholeWeekHours$1 = "Whole Numbers Only";
var PlanTagList_NoTags$1 = "This plan doesn’t have any skills yet.";
var PlanTagList_ShowAllTags$1 = "Show all your skills...";
var PlanTagList_ViewPlan$1 = "View Plan";
var PlanTagList_ViewSkillsInPlan$1 = "View All Skills in Plan";
var PlanDropdown_ChoosePlan$1 = "Choose Your Plan";
var PlanDropdown_FollowPlan$1 = "Find a plan to follow";
var PlanDropdown_NoPrimaryPlan$1 = "You don't have a primary plan yet. Select a learning plan from the Choose Your Plan menu to mark it as your primary plan.";
var PlanDropdown_PrimaryPlanTooltip$1 = "Your Primary Plan";
var PlanDropdown_Title$1 = "Your Plans";
var PersonalSkillView_AddSkill$1 = "Add skill";
var PersonalSkillView_AddSkillInstructions$1 = "You can rate yourself in this skill or you can add it without rating.  You can always come back to change your rating.";
var PersonalSkillView_AddTarget$1 = "Add Target";
var PersonalSkillView_AllSkills$1 = "All Skills";
var PersonalSkillView_AverageRating$1 = "Average Rating";
var PersonalSkillView_EvaluationRating$1 = "Skill Review";
var PersonalSkillView_FindSkillContent$1 = "Find skill content";
var PersonalSkillView_FocusSkill$1 = "Focus Skill";
var PersonalSkillView_FocusSkills$1 = "Focus Skills";
var PersonalSkillView_LastUpdated$1 = "Last Rated";
var PersonalSkillView_ManagerRating$1 = "Manager Rating";
var PersonalSkillView_ManagerRatingFormat$1 = "Manager Rating for {{skill}}: {{rating}}";
var PersonalSkillView_NoSkills$1 = "{{teamMemberName}} has not yet added any Skills to their profile";
var PersonalSkillView_RequestSelfRating$1 = "Request Self Rating";
var PersonalSkillView_RequestSelfRating_Title$1 = 'Request Self Rating for "{{ skillTitle }}"';
var PersonalSkillView_Search_Placeholder$1 = "Search for a Skill";
var PersonalSkillView_SelfRating$1 = "Self Rating";
var PersonalSkillView_SelfRatingFormat$1 = "Self Rating for {{skill}}: {{rating}}";
var PersonalSkillView_SkillDescription$1 = "Skill Description";
var PersonalSkillView_SkillProgression$1 = "Skill progression";
var PersonalSkillView_SkillProgressionChartSubtitle1$1 = 'Add and rate your focus skills in <a href="{{ personalSkillProfile }}" class="link">your skill profile</a> to see this insight';
var PersonalSkillView_SkillProgressionChartSubtitle2$1 = "Your skill ratings over time";
var PersonalSkillView_SkillProgressionChartSubtitle3$1 = 'Add and rate your skills in <a href="{{ personalSkillProfile }}" class="link">your skill profile</a> to see this insight';
var PersonalSkillView_SkillReviewFormat$1 = "Skill Review for {{skill}}: {{rating}}";
var PersonalSkillView_SkillTarget$1 = "Skill Target";
var PersonalSkillView_SkillTargetFormat$1 = "Skill Target for {{skill}}: {{rating}}";
var PersonalSkillView_SkillTargetJobTargetFormat$1 = "Job Target Level: {{level}}";
var PersonalSkillView_SkillTargetModalTitle$1 = "Set a target level";
var PersonalSkillView_SkillTargetModalTitleFormat$1 = 'Set a skill target for "{{skill}}"';
var PersonalSkillView_TeamFocusSkills$1 = "Team Focus Skills";
var PersonalSkillView_Top10SkillsAddSkill$1 = "Do you have this skill? Add it!";
var PersonalSkillView_Top10SkillsAvgRating$1 = "Add your rating to see average";
var PersonalSkillView_Top10SkillsSubtitle1$1 = "You only see the average rating for skills you have added and rated.";
var PersonalSkillView_Top10SkillsSubtitle2$1 = "There is not enough data to populate this insight.";
var PersonalSkillView_Top10SkillsSubtitle3$1 = "There are not enough other users in your role to populate this insight.";
var PersonalSkillView_Top10SkillsSubtitle4$1 = 'Add your job role in <a href="{{ profileSettings }}" class="link">Profile Settings</a> to display this insight.';
var PersonalSkillView_Top10SkillsTitle1$1 = "Top {{ count }} skills for my job role";
var PersonalSkillView_Top10SkillsTitle2$1 = "Top skills for my job role";
var PersonalSkillView_YourRating$1 = "Your Rating";
var PeopleCtrl_AllPeople$1 = "All People";
var PathwayTopContent_Empty$1 = "Add content to this section to see how it's performing.";
var PathwayTopContent_Title$1 = "Top Content";
var PathwayTopContent_ViewAllContext$1 = "View All Top Content";
var PathwaySectionsChart_CompletedTooltipFormat$1 = "{{percentage}}% Completed";
var PathwaySectionsChart_EnrolledTooltipFormat$1 = "{{percentage}}% Enrolled";
var PathwaySectionsChart_FollowingTooltipFormat$1 = "{{percentage}}% Following";
var PathwaySectionsChart_NoData$1 = "Add pathways to this section to see how they are performing.";
var PathwaySectionsChart_Started$1 = "Started";
var PathwaySectionsChart_StartedTooltipFormat$1 = "{{percentage}}% Started";
var PathwaySectionsChart_Title$1 = "Percent of Plan’s Followers";
var Pathways_A11yItemsReordered$1 = "Items have been reordered within the lesson.";
var Pathways_A11yLessonsReordered$1 = "Lessons have been reordered within the section.";
var Pathways_A11ySectionsReordered$1 = "Sections have been reordered on the page.";
var Pathways_AddANote$1 = "Add a note for learners";
var Pathways_AddAuthorNote$1 = "Add Author Note";
var Pathways_AddByType$1 = "Add by Type";
var Pathways_AddContent$1 = "Add Content";
var Pathways_AddContentItemsSuccess$1 = "Successfully Added Content Items";
var Pathways_AddContentItemSuccess$1 = "Successfully Added Content Item";
var Pathways_AddingInputTypeError$1 = "Sorry! There was a problem adding the {{inputType}} to the pathway.";
var Pathways_AddItemError$1 = "Sorry! There was a problem adding the item to the pathway.";
var Pathways_AddItemPermissionError$1 = "Sorry! This item may not be added to the selected pathway. The item might be specific to an organization or you do not have permission.";
var Pathways_AdditionalContentSuccess$1 = "Successfully marked as Additional Content";
var Pathways_AddLesson$1 = "Add Lesson";
var Pathways_AddLessonError$1 = "Sorry! There was a problem adding the pathway lesson.";
var Pathways_AddOneItem$1 = "Add 1 Item";
var Pathways_AddSection$1 = "Add Section";
var Pathways_AddSectionError$1 = "Sorry! There was a problem adding the pathway section.";
var Pathways_AddSubsection$1 = "Create Subsection";
var Pathways_AddXItems$1 = "Add {{count}} Items";
var Pathways_Article$1 = "Article";
var Pathways_Assessment$1 = "Assessment";
var Pathways_AuthorAccessError$1 = "Sorry! There was a problem accessing pathway author information.";
var Pathways_AuthoredPathwayError$1 = "Sorry! There was a problem accessing your authored pathways.";
var Pathways_BackButton$1 = "Back to Pathways";
var Pathways_BackToBrowse$1 = "Back to Browse";
var Pathways_Bin$1 = "Hold for Later";
var Pathways_Book$1 = "Book";
var Pathways_Collaborators$1 = "Collaborators";
var Pathways_CollapseLesson$1 = "Collapse Lesson";
var Pathways_CollapseLessons$1 = "Collapse Lessons";
var Pathways_CompletedColumn$1 = "Completion";
var Pathways_CompletedItemsFormat$1 = "Completed {{totalCompletedItems}} of {{totalItems}}";
var Pathways_CompletionNotificationModalTitle$1 = "Did you complete items from the {{pathwayName}} pathway?";
var Pathways_ConfirmCompletions$1 = "Confirm Completions";
var Pathways_ConfirmDeleteLesson$1 = "Are you sure you want to remove this lesson? This will move the lesson's content to the Hold For Later tab.";
var Pathways_ConfirmDeleteSubsection$1 = "Are you sure you want to remove this subsection? This will move the subsection's content to the Hold For Later tab.";
var Pathways_ConfirmRemoveItem$1 = "Are you sure you want to remove this item? This will move the item to the Hold For Later tab.";
var Pathways_ConfirmRemoveSection$1 = "Removing a section deletes its subsections and places the content items in the Hold For Later tab. Are you sure you want to remove this section?";
var Pathways_Course$1 = "Course";
var Pathways_CreatedSection$1 = "Successfully created section.";
var Pathways_CreatedSubsection$1 = "Successfully created subsection.";
var Pathways_CreateSection$1 = "Create Section";
var Pathways_DeletedSection$1 = "Successfully deleted section.";
var Pathways_DeletedSubsection$1 = "Successfully Deleted Subsection";
var Pathways_DeleteError$1 = "Sorry! There was a problem deleting the pathway.";
var Pathways_DeleteItem$1 = "Remove";
var Pathways_DeleteitemError$1 = "Sorry! There was a problem deleting the pathway item.";
var Pathways_DeleteLesson$1 = "Delete Lesson";
var Pathways_DeletelessonError$1 = "Sorry! There was a problem deleting the pathway subsection.";
var Pathways_DeleteNote$1 = "Delete Note";
var Pathways_DeletePathwayBody$1 = "Are you sure you want to delete this pathway?\n<br>\nYou cannot undo this action.";
var Pathways_DeleteSection$1 = "Delete Section";
var Pathways_DeletesectionError$1 = "Sorry! There was a problem deleting the pathway section.";
var Pathways_DeleteStepError$1 = "Sorry! There was a problem deleting the pathway item.";
var Pathways_DeleteSubsection$1 = "Delete Subsection";
var Pathways_Description$1 = "Pathway Description";
var Pathways_DescriptionPlaceholder$1 = "Pathway description goes here";
var Pathways_EditCatalogItemHelper$1 = "Changes to this item will be applied to your organization’s content catalog.";
var Pathways_Edited$1 = "Edited";
var Pathways_EditingDescription$1 = "Changes here will appear only in this pathway.";
var Pathways_EditLocalContentHelper$1 = "Changes made to this content will only apply in this pathway.";
var Pathways_EditPathway$1 = "Edit Pathway";
var Pathways_EditPermissionError$1 = "Sorry! You need the author pathways permission to create pathways for the specified organization. If editing collaborators, at least one member needs the author pathways permission.";
var Pathways_EmptyBinMessage$1 = "Here you can hold items for later use. Add something here by clicking 'move to' on a content item.";
var Pathways_EnrollError$1 = "Sorry! There was a problem enrolling you in the pathway.";
var Pathways_Episode$1 = "Episode";
var Pathways_ErrorMessage$1 = "Sorry! There was a problem performing this action. It’s not your fault, we are working hard to fix the problem.";
var Pathways_Event$1 = "Event";
var Pathways_ExistingContentTypeError$1 = "You cannot add an existing item as a different content type.";
var Pathways_ExpandLesson$1 = "Expand Lesson";
var Pathways_FeedbackAverage$1 = "Average";
var Pathways_FeedbackCommentsPlaceholder$1 = "Write your comments here";
var Pathways_FeedbackCommentsTitle$1 = "What did you like or dislike about this content?";
var Pathways_FeedbackDescription$1 = "Help us improve this pathway by reviewing the quality of the content you just completed.";
var Pathways_FeedbackExcellent$1 = "Excellent";
var Pathways_FeedbackGood$1 = "Good";
var Pathways_FeedbackOverallRating$1 = "How would you rate the overall content quality in this pathway?";
var Pathways_FeedbackPoor$1 = "Poor";
var Pathways_FeedbackSubmit$1 = "Submit Feedback";
var Pathways_FeedbackSubmitted$1 = "Feedback Submitted!";
var Pathways_FeedbackSubmittedDescription$1 = "Thank you for your feedback! Our curation team will carefully review your input to help us improve this pathway. We appreciate your contribution and are dedicated to providing the best content possible. Stay tuned for updates!";
var Pathways_FeedbackTitle$1 = "Rate Your Learning Experience";
var Pathways_FeedbackVeryGood$1 = "Very Good";
var Pathways_FollowedDate$1 = "Followed Date";
var Pathways_FollowError$1 = "Sorry! There was a problem following the pathway.";
var Pathways_Followers$1 = "Followers";
var Pathways_Following$1 = "Following";
var Pathways_FollowingCountFormat$1 = "{{count}} Following";
var Pathways_GetItemsError$1 = "Sorry! There was a problem retrieving your Pathway Items.";
var Pathways_HoldForLater$1 = "Hold for Later";
var Pathways_HoldForLaterError$1 = "Sorry! There was a problem moving items to Hold for Later.";
var Pathways_Insights$1 = "Insights";
var Pathways_ItemCountFormat$1 = "{{count}} Items";
var Pathways_ItemCountSingular$1 = "1 Item";
var Pathways_ItemSavedFormat$1 = "{{title}} has been saved!";
var Pathways_ItemsReordered$1 = "Items have been reordered within the subsection.";
var Pathways_LessonCountFormat$1 = "{{count}} Lessons";
var Pathways_LessonCountSingular$1 = "1 Lesson";
var Pathways_LessonDescriptionLabel$1 = "Lesson Description";
var Pathways_LessonDescriptionPlaceholder$1 = "Lesson description goes here";
var Pathways_LessonItemsAllOptional$1 = "This section contains only additional learning items, which do not count toward your overall pathway progress.";
var Pathways_LessonLabelFormat$1 = "Lesson {{number}}";
var Pathways_LessonNumberFormat$1 = "Lesson {{number}}";
var Pathways_LessonTitleLabel$1 = "Lesson Title";
var Pathways_LessonTitlePlaceholder$1 = "Lesson title goes here";
var Pathways_MakeFeatureNotification$1 = "Featured pathway added successfully";
var Pathways_MakeOptional$1 = "Mark as Additional Learning";
var Pathways_MakeRequired$1 = "Remove as Additional Learning";
var Pathways_MarkAsOptional$1 = "Mark as Optional";
var Pathways_MarkAsRequired$1 = "Mark as Required";
var Pathways_MoveConfirmationMessage$1 = "This will permanently move the pathway from the organization's catalog to the global catalog.";
var Pathways_MovedItem$1 = "Successfully Moved Item";
var Pathways_MovedLesson$1 = "Successfully Moved Lesson";
var Pathways_MovedSubsection$1 = "Successfully Moved Subsection";
var Pathways_MovedToHoldForLater$1 = "Moved items to Hold for Later.";
var Pathways_MoveItem$1 = "Move To...";
var Pathways_MoveItemError$1 = "Sorry! There was a problem moving the pathway items.";
var Pathways_MoveItemTo$1 = "Move Item To";
var Pathways_MoveLessonError$1 = "Sorry! There was a problem moving the pathway lessons.";
var Pathways_MoveLessonTo$1 = "Move Lesson To";
var Pathways_MoveSectionError$1 = "Sorry! There was a problem moving the pathway sections.";
var Pathways_MoveSubsectionError$1 = "Sorry! There was a problem moving the pathway subsections.";
var Pathways_MoveSuccessMessage$1 = "Successfully moved pathway!";
var Pathways_MoveWarningHostedContent$1 = "This will remove hosted content from the pathway.";
var Pathways_NewPathwayItemsNotification$1 = "{{newItems}} were added to the Pathway {{pathwayTitle}}.";
var Pathways_NoAccessDescriptionText$1 = "Looks like you don't have access to this page.<br>\nIf you feel like this is an error, please contact our support team.";
var Pathways_NoAccessHeaderText$1 = "Uh Oh!";
var Pathways_NoGroup$1 = "no group";
var Pathways_NoteFromAuthor$1 = "Author's Note";
var Pathways_OptionalContent$1 = "Additional Learning";
var Pathways_OptionalContentTooltip$1 = "Doesn't count against pathway progress";
var Pathways_OptionalItemCountFormat$1 = "{{count}} Optional Items";
var Pathways_OptionalItemCountSingular$1 = "1 Optional Item";
var Pathways_OrgManagedNotification$1 = "Adding org-managed items will make this Pathway org-managed.";
var Pathways_OutOfDate$1 = "The Pathway is out of date.";
var Pathways_Pathway$1 = "Pathway";
var Pathways_PathwayAccessError$1 = "Sorry! There was a problem accessing the pathways.";
var Pathways_PathwayDetailAccessError$1 = "Sorry! There was a problem accessing pathway details.";
var Pathways_PathwayInfoAccessError$1 = "Sorry! There was a problem accessing pathway information.";
var Pathways_PathwayItemError$1 = "Sorry! There was a problem accessing the pathway items.";
var Pathways_PathwayPrivateMessage$1 = "This pathway is private.<br>In order to share it, make it visible in pathway settings.";
var Pathways_Post$1 = "Post";
var Pathways_PrivacyCollaborators$1 = "Private to collaborators";
var Pathways_PrivacyGroupName$1 = "Visible to {{groupName}}";
var Pathways_PrivacyGroups$1 = "Visible to {{groupLength}} groups";
var Pathways_PrivacyOrg$1 = "Visible to organization";
var Pathways_PrivacyOwner$1 = "Private to you";
var Pathways_PrivacyProfile$1 = "Visible on your Profile";
var Pathways_PrivatePathway$1 = "<p>This pathway is private.<br>In order to share it, make it visible in pathway settings.</p>";
var Pathways_RefreshForLatestChange$1 = "Please refresh this page to update this Pathway with the latest change.";
var Pathways_RemoveFeaturedNotification$1 = "Pathway is no longer featured";
var Pathways_RemoveItemError$1 = "Sorry! There was a problem removing the item.";
var Pathways_ReorderedSections$1 = "Successfully reordered sections.";
var Pathways_ReorderItemError$1 = "Sorry! There was a problem reordering pathway items.";
var Pathways_ReorderItems$1 = "Reorder Items";
var Pathways_ReorderItemsTitleFormat$1 = "Reorder Items in Lesson {{lessonNumber}}";
var Pathways_ReorderLessonError$1 = "Sorry! There was a problem reordering pathway subsections.";
var Pathways_ReorderLessons$1 = "Reorder Lessons";
var Pathways_ReorderLessonsTitleFormat$1 = "Reorder Lessons in Section {{sectionNumber}}";
var Pathways_ReorderSections$1 = "Reorder Sections";
var Pathways_ReorderSubsectionItemsTitleFormat$1 = "Reorder Items in Subsection {{lessonNumber}}";
var Pathways_ReorderSubsections$1 = "Reorder Subsections";
var Pathways_ReorderSubsectionsTitleFormat$1 = "Reorder Subsections in Section {{sectionNumber}}";
var Pathways_RequiredContentSuccess$1 = "Successfully marked as Required Content";
var Pathways_RestoreToOriginal$1 = "Restore to Original";
var Pathways_SaveError$1 = "Sorry! There was a problem saving your changes.";
var Pathways_SearchCatalog$1 = "Search Catalog";
var Pathways_SearchError$1 = "Sorry! There was a problem retrieving results.";
var Pathways_SectionCountFormat$1 = "{{count}} Sections";
var Pathways_SectionDescLimit$1 = "Enter up to 2000 characters. A <strong>Read More</strong> link displays after the first 180 characters.";
var Pathways_SectionDescriptionLabel$1 = "Section description for: Section number {{ sectionNumber }}";
var Pathways_SectionDescriptionPlaceholder$1 = "Section description goes here";
var Pathways_sectionLabelFormat$1 = "Section {{n}}";
var Pathways_SectionNumberFormat$1 = "Section {{number}}";
var Pathways_SectionNumberTitleFormat$1 = "Section {{sectionNumber}} {{sectionTitle}}";
var Pathways_SectionTitleLabel$1 = "Section title for: Section number {{ sectionNumber }}";
var Pathways_SectionTitlePlaceholder$1 = "Section title";
var Pathways_SelectACatalog$1 = "Select a Catalog";
var Pathways_SetPathwayNameError$1 = "Sorry! There's already a pathway with the same name. Please choose a different name for this pathway.";
var Pathways_ShowMoreLessons$1 = "{{count}} More Lessons";
var Pathways_ShowOneMoreLesson$1 = "1 More Lesson";
var Pathways_SubsectionCountFormat$1 = "{{count}} Subsections";
var Pathways_SubsectionCountSingular$1 = "1 Subsection";
var Pathways_SubsectionDescriptionLabel$1 = "Subsection description for: Section number {{ sectionNumber }}, subsection number {{ subsectionNumber }}";
var Pathways_SubsectionDescriptionPlaceholder$1 = "Subsection description goes here";
var Pathways_SubsectionNumberFormat$1 = "Subsection {{number}}";
var Pathways_SubsectionsReordered$1 = "Subsections have been reordered within the section.";
var Pathways_SubsectionTitleLabel$1 = "Subsection title for: Section number {{ sectionNumber }}, subsection number {{ subsectionNumber }}";
var Pathways_SubsectionTitlePlaceholder$1 = "Subsection title goes here";
var Pathways_Task$1 = "Task";
var Pathways_Title$1 = "Pathway Name";
var Pathways_TitlePlaceholder$1 = "Pathway Name Goes Here";
var Pathways_UnfollowError$1 = "Sorry! There was a problem unfollowing the pathway.";
var Pathways_UntitledLesson$1 = "Untitled Subsection";
var Pathways_UntitledSection$1 = "Untitled Section";
var Pathways_UpdateError$1 = "Sorry! There was a problem updating the pathway.";
var Pathways_UpdateVisibilityError$1 = "Sorry! There was a problem updating the pathway visibility.";
var Pathways_Video$1 = "Video";
var Pathways_WithdrawFromPathway$1 = "Are you sure you want to unfollow this pathway?";
var Pathways_WithdrawFromPathwayBody$1 = "Content from this pathway will no longer appear in your Feed.";
var PathwaysLayout_Enrollees$1 = "Enrollees";
var PathwayPrivacyModal_BulkChangeVisibility$1 = "Change Visibility of 1 Pathway";
var PathwayPrivacyModal_BulkChangeVisibilityPlural$1 = "Change Visibility of {{count}} Pathways";
var PathwayPrivacyModal_ChangeVisibility$1 = "Change the visibility of {{title}}";
var PathwayPrivacyModal_ConfirmationModalBody$1 = "You will no longer be able to manage this pathway or find it listed in your organization's pathway list. This action can only be reversed by the pathway's collaborators. Are you sure you want to do this?";
var PathwayPrivacyModal_ConfirmationModalConfirm$1 = "change visibility";
var PathwayPrivacyModal_ConfirmationModalHeader$1 = "Change pathway visibiilty";
var PathwayPrivacyModal_EditSettings$1 = "Edit pathway settings";
var PathwayPrivacyModal_FoundWhere$1 = "Visibility";
var PathwayPrivacyModal_OnlySetGroups$1 = "Only these groups will see this pathway in the pathway gallery";
var PathwayPrivacyModal_OnlySetGroupsToolTip$1 = "Other groups can still receive this pathway as a recommendation, etc.";
var PathwayPrivacyModal_SaveVisibility$1 = "Save Visibility";
var PathwayPrivacyModal_SelectAGroupError$1 = "Please search and select a group.";
var PathwayPrivacyModal_TargetGroups$1 = "Target These Groups (optional)";
var PathwayPrivacyModal_TargetGroupsDirectoryToolTip$1 = "This will make it easier for these groups to find this directory";
var PathwayPrivacyModal_TargetGroupsPlanToolTip$1 = "This will make it easier for these groups to find this plan";
var PathwayPrivacyModal_TargetGroupsToolTip$1 = "This will make it easier for these groups to find this pathway";
var PathwayEnrollmentSource_AmountSent$1 = "Amount sent";
var PathwayEnrollmentSource_Assignments$1 = "Assignments";
var PathwayEnrollmentSource_BusinessRules$1 = "Automations";
var PathwayEnrollmentSource_OtherTooltip$1 = "Users that follow the pathway after searching, browsing, or clicking a link that is not trackable.";
var PathwayEnrollmentSource_Title$1 = "Follow Source";
var PathwayEnrollmentSource_TrackableLinks$1 = "Trackable Links";
var pathwayAddEditModal_AddCollaborator$1 = "Add people to collaborate on this pathway";
var pathwayAddEditModal_AddCollaborators$1 = "+ Add Collaborators";
var pathwayAddEditModal_AddPathway_Success$1 = "The pathway was added successfully!";
var pathwayAddEditModal_Authors$1 = "Pathway Collaborators";
var pathwayAddEditModal_BadgeEligibilityLabel$1 = "Eligible for badge upon completion";
var pathwayAddEditModal_BadgeUuid$1 = "Badge UUID";
var pathwayAddEditModal_CloneOfPathwayFormat$1 = "[Clone of] {{title}}";
var pathwayAddEditModal_CollaboratorsDescription$1 = "Collaborators will be able to edit this pathway";
var pathwayAddEditModal_ConfirmDelete$1 = "Are you sure you want to delete this pathway?";
var pathwayAddEditModal_CreatePathway$1 = "Create Pathway";
var pathwayAddEditModal_DeletedFormat$1 = "{{pathwayName}} has been deleted.";
var pathwayAddEditModal_Description$1 = "Description";
var pathwayAddEditModal_DescriptionDetail$1 = "Briefly describe what your pathway is about.";
var pathwayAddEditModal_DescriptionLength$1 = "Pathway description must be 2000 characters or less.";
var pathwayAddEditModal_DescriptionMissing$1 = "Please enter a valid description";
var pathwayAddEditModal_DoNotDisplayDuration$1 = "Hide estimated pathway duration";
var pathwayAddEditModal_DoNotDisplayDurationNote$1 = "If checked, pathways will not display estimated duration for the pathway or sections.";
var pathwayAddEditModal_DoNotDisplayHeaderImage$1 = "Do not display header image on pathway page";
var pathwayAddEditModal_DoNotDisplayHeaderImageNote$1 = "If checked, pathways do not display the blurred pathway image as a header.";
var pathwayAddEditModal_EditPathway$1 = "Edit Pathway";
var pathwayAddEditModal_EndorsedByOrg$1 = "Endorsed";
var pathwayAddEditModal_EndorsedByOrgNote$1 = "If checked, an icon appears on the card to show you endorsed this.";
var pathwayAddEditModal_EndorsedContentByOrgNote$1 = "Endorsed Pathways, and all content items within the Pathways, are promoted in search results.";
var pathwayAddEditModal_ImagePreview$1 = "Pathway Image Preview";
var pathwayAddEditModal_NameLength$1 = "Pathway name must be 255 characters or less.";
var pathwayAddEditModal_NameRequired$1 = "A pathway name is required.";
var pathwayAddEditModal_NeedCollaboratorPermission$1 = "At least one collaborator needs the Author Pathways permission.";
var pathwayAddEditModal_Or$1 = "or";
var pathwayAddEditModal_PathwayName$1 = "Pathway Name";
var pathwayAddEditModal_PathwayNameEg$1 = "E.g. New Employee Onboarding";
var pathwayAddEditModal_PathwayPrimaryContact$1 = "Pathway Primary Contact";
var pathwayAddEditModal_PathwaySettingsChannelDesc$1 = "You can update permissions and settings later.";
var pathwayAddEditModal_PathwaySettingsDesc$1 = "You can update permissions and settings later. Your pathway will be Private to Collaborators unless you change the Pathway Visibility.";
var pathwayAddEditModal_PrimaryContactRequired$1 = "A primary contact is required";
var pathwayAddEditModal_Remove$1 = "remove";
var pathwayAddEditModal_SavePathway$1 = "Save Pathway";
var pathwayAddEditModal_SavingPathway$1 = "Saving Pathway";
var pathwayAddEditModal_SearchCollaborators$1 = "Search for collaborators by name";
var pathwayAddEditModal_SearchPeopleGroupsPlaceHolder$1 = "Search for people or groups";
var pathwayAddEditModal_ShowPathwayContentRating$1 = "Show Pathway Content Rating";
var pathwayAddEditModal_ShowPathwayContentRatingNote$1 = "If checked, learners will be able to rate the Pathway content.";
var pathwayAddEditModal_TitleofPathway$1 = "Title of the pathway in the gallery.";
var pathwayAddEditModal_VisibleToOrg$1 = "Allow collaborators to publish this pathway to the organization";
var pathwayAddEditModal_VisibleToOrgWarning$1 = "Users with the Manage Pathways permission can view or edit if checked";
var PathwayActivity_OpportunityTitle$1 = "Opportunity Activity";
var PathwayActivity_PathwayTitle$1 = "Pathway Activity";
var PathwayActivity_PlanTitle$1 = "Plan Activity";
var PathwayActivity_SelectionAriaLabel$1 = "Selection of filters for pathway activity chart";
var PathwayActivity_TooltipClickedApply$1 = "{{ count }} users clicked apply";
var PathwayActivity_TooltipCompletions$1 = "{{ count }} users completed.";
var PathwayActivity_TooltipEnroll$1 = "{{ count }} users enrolled.";
var PathwayActivity_TooltipFollow$1 = "{{ count }} users followed.";
var PathwayActivity_TooltipInterested$1 = "{{ count }} users interested.";
var PathwayActivity_TooltipTotalViews$1 = "{{count}} total views.";
var PathwayActivity_TooltipViews$1 = "{{ count }} users viewed.";
var PathwayActivity_TooltipViewsTotal$1 = "{{count}} total views.";
var PathwayActivity_TotalViews$1 = "Total Views";
var PathwayActivity_Users$1 = "Users";
var PathwayActivity_UsersViewed$1 = "Users Viewed";
var Pagination_AriaLabelDefault$1 = "Pagination";
var Pagination_GoToPageFormat$1 = "Go to page {{ number }}";
var Pagination_OfYFormat$1 = "of {{totalCount}}";
var Pagination_OfYResultsFormat$1 = "of {{totalCount}} results";
var Pagination_ResultsOverview$1 = "Showing {{fromIndex}} to {{toIndex}} of {{totalCount}} results";
var OutcomeRatingOptionsSvc_ClaimsMostly$1 = "Mostly";
var OutcomeRatingOptionsSvc_ClaimsNotWell$1 = "Not Well";
var OutcomeRatingOptionsSvc_ClaimsSlightly$1 = "Slightly";
var OutcomeRatingOptionsSvc_ClaimsSomewhat$1 = "Somewhat";
var OutcomeRatingOptionsSvc_ClaimsVeryWell$1 = "Very Well";
var OutcomeRatingOptionsSvc_DifficultyExtremely$1 = "Extremely Difficult";
var OutcomeRatingOptionsSvc_DifficultyNot$1 = "Not Difficult";
var OutcomeRatingOptionsSvc_DifficultySlightly$1 = "Slightly Difficult";
var OutcomeRatingOptionsSvc_DifficultySomewhat$1 = "Somewhat Difficult";
var OutcomeRatingOptionsSvc_DifficultyVery$1 = "Very Difficult";
var OutcomeRatingOptionsSvc_MasteryCapable$1 = "Capable";
var OutcomeRatingOptionsSvc_MasteryDistinguished$1 = "Distinguished";
var OutcomeRatingOptionsSvc_MasteryEmerging$1 = "Emerging";
var OutcomeRatingOptionsSvc_MasteryExperienced$1 = "Experienced";
var OutcomeRatingOptionsSvc_MasteryMaster$1 = "Master";
var OutcomeRatingOptionsSvc_MasteryNovice$1 = "Novice";
var OutcomeRatingOptionsSvc_RelevancyMostly$1 = "Mostly Relevant";
var OutcomeRatingOptionsSvc_RelevancyNot$1 = "Not Relevant";
var OutcomeRatingOptionsSvc_RelevancySlightly$1 = "Slightly Relevant";
var OutcomeRatingOptionsSvc_RelevancySomewhat$1 = "Somewhat Relevant";
var OutcomeRatingOptionsSvc_RelevancyVery$1 = "Very Relevant";
var OutcomeRatingOptionsSvc_SignificanceExtremely$1 = "Extremely Significant";
var OutcomeRatingOptionsSvc_SignificanceNot$1 = "Not Significant";
var OutcomeRatingOptionsSvc_SignificanceSlightly$1 = "Slightly Significant";
var OutcomeRatingOptionsSvc_SignificanceSomewhat$1 = "Somewhat Significant";
var OutcomeRatingOptionsSvc_SignificanceVery$1 = "Very Significant";
var OutcomeRatingOptionsSvc_SimilarityMostly$1 = "Mostly Similar";
var OutcomeRatingOptionsSvc_SimilarityNot$1 = "Not Similar";
var OutcomeRatingOptionsSvc_SimilaritySlightly$1 = "Slightly Similar";
var OutcomeRatingOptionsSvc_SimilaritySomewhat$1 = "Somewhat Similar";
var OutcomeRatingOptionsSvc_SimilarityVery$1 = "Very Similar";
var OutcomeRatingOptionsSvc_SupportNeutral$1 = "Neutral";
var OutcomeRatingOptionsSvc_SupportPoor$1 = "Poorly";
var OutcomeRatingOptionsSvc_SupportVeryPoor$1 = "Very Poorly";
var OutcomeRatingOptionsSvc_SupportVeryWell$1 = "Very Well";
var OutcomeRatingOptionsSvc_SupportWell$1 = "Well";
var OrgTargetsCtrl_CreateTarget$1 = "Create a {{targetType}}";
var OrgTargetsCtrl_DeletePrompt$1 = "Are you sure you want to delete {{targetTitle}}?";
var OrgTargetsCtrl_Description$1 = "Description";
var OrgTargetsCtrl_FollowerCount$1 = "Followers";
var OrgTargetsCtrl_NoJobRolesMessage$1 = "No plans to show";
var OrgTargetsCtrl_SearchForJobRole$1 = "Search for a plan";
var OrgTargetsCtrl_Title$1 = "Title";
var OrgTargetsCtrl_Visibility$1 = "Visibility";
var OrgSvc_AddFAQContactSuccess$1 = "Success! FAQ contact added.";
var OrgSvc_AddFAQError$1 = "Sorry! There was a problem adding the FAQ.";
var OrgSvc_DeleteFAQError$1 = "Sorry! There was a problem deleting the FAQ.";
var OrgSvc_FAQEmailError$1 = "Sorry! There was a problem adding the FAQ email.";
var OrgSvc_OrgError$1 = "Sorry! There was a problem accessing organization information.";
var OrgSvc_OrgJoinSuccess$1 = "Organization joined successfully.";
var OrgSvc_ResetPrivacyAcceptanceError$1 = "There was an error resetting the Enforce Data Privacy Acceptance Message";
var OrgSvc_SendInviteError$1 = "Sorry! There was a problem sending the invites.";
var OrgSvc_SendInviteSuccess$1 = "Success! The invites are on their way.";
var OrgSvc_UpdateFAQError$1 = "Sorry! There was a problem updating the FAQ.";
var OrgSvc_UpdateLinksError$1 = "Sorry!  There was a problem updating the links";
var OrgSvc_UpdateMessagesError$1 = "Sorry!  There was a problem updating the messages.";
var OrgSvc_UpdateProviderError$1 = "There was an error updating the provider settings.";
var OrgSvc_UpdateProviderSuccess$1 = "Provider settings updated successfully.";
var OrgSkillsNav_Roles$1 = "Roles";
var OrgSkillsNav_Skills$1 = "Skills";
var OrgSkills_AC_OnboardingAdd$1 = "Suggest in Welcome Tour";
var OrgSkills_AC_OnboardingRemove$1 = "Don't Suggest in Tour";
var OrgSkills_AC_PlanMark$1 = "Mark as Plan";
var OrgSkills_AC_PlanView$1 = "Edit Plan";
var OrgSkills_AddRole$1 = "Add a Role";
var OrgSkills_AddRoleHeading$1 = "Add Role";
var OrgSkills_AddSkill$1 = "Add a Skill";
var OrgSkills_AddSkillButton$1 = "Add Skills";
var OrgSkills_AddSkills$1 = "Add Skills";
var OrgSkills_AddSkillTitle$1 = "Add Skill";
var OrgSkills_AlreadyAddedSkill$1 = "Awesome work! You already added this skill to your profile.";
var OrgSkills_ApplySuggestions$1 = "Apply Suggestions";
var OrgSkills_BackToRoles$1 = "Back to Roles";
var OrgSkills_ContentCount$1 = "Content";
var OrgSkills_CountSelected$1 = "{{ count }} Selected";
var OrgSkills_CreateSkills$1 = "Create Skills";
var OrgSkills_CurrentSkills$1 = "Current Skills";
var OrgSkills_DeleteItem$1 = "Are you sure you want to permanently delete {{ name }}?";
var OrgSkills_DescCharLimit$1 = "Characters remaining: {{count}}";
var OrgSkills_DescCharLimitExceeded$1 = "Character limit exceeded.";
var OrgSkills_DescPlaceholder$1 = "Short description of the skill";
var OrgSkills_DownloadRoles$1 = "Download List";
var OrgSkills_DownloadSkills$1 = "Download List";
var OrgSkills_EditRoleHeading$1 = "Edit Role";
var OrgSkills_EditSkillTitle$1 = "Edit Skill";
var OrgSkills_EnableSkillReview$1 = "Enable for Skill Review";
var OrgSkills_EnableSkillReviewHelpText$1 = "Allow Skill Review in this skill for learners who belong to this organization.";
var OrgSkills_Endorsed$1 = "Endorsed";
var OrgSkills_EndorsedSkillTooltip$1 = "This skill is endorsed";
var OrgSkills_EndorseSkill$1 = "Endorse the skill";
var OrgSkills_EndorseSkillHelpText$1 = "If enabled, an icon appears on the card to show you endorsed this.";
var OrgSkills_EquivalentSkillsHintSubtitle$1 = "This will help us track and refine relationships of skills and roles.";
var OrgSkills_EquivalentSkillsHintTitle$1 = "Tag equivalent skills that you associate with this custom skill";
var OrgSkills_EquivalentSkillsTip$1 = "Tip: Enter a skill name, then you can choose from the list or use the enter key";
var OrgSkills_EquivalentSkillsTitle$1 = "Equivalent Skills";
var OrgSkills_FollowerCount$1 = "Followers";
var OrgSkills_GeneratingSkills$1 = "Generating skills...";
var OrgSkills_GeneratingSuggestions$1 = "Generating suggestions...";
var OrgSkills_MarkedAsPlan$1 = "Marked as Plan";
var OrgSkills_MatchedSkill$1 = "Matched Skill";
var OrgSkills_MatchedSkillButtonAlt$1 = "{{providerName}} {{matchedSkillName}} is matched to {{degreedSkillName}}.  Click to remove";
var OrgSkills_MatchSkill$1 = "Match this skill";
var OrgSkills_MatchSkillPlaceholder$1 = "Enter a skill";
var OrgSkills_NoEquivalentSkillsFound$1 = "No results found. This skill may not exist yet.";
var OrgSkills_NoLevel$1 = "No Level";
var OrgSkills_NoRolesAdded$1 = "No roles have been added to this organization.";
var OrgSkills_NoSkillsAdded$1 = "No skills have been added to this organization.";
var OrgSkills_NoSkillsResultsFound$1 = "No results, add it anyway?";
var OrgSkills_NumberSkillSuggestions$1 = "{{ count }} Skill Suggestions";
var OrgSkills_OnboardingFeatured$1 = "Featured In Onboarding";
var OrgSkills_PathwayCount$1 = "Pathways";
var OrgSkills_Plan$1 = "Plan";
var OrgSkills_Plans$1 = "Plans";
var OrgSkills_Recommend$1 = "Recommend";
var OrgSkills_RecommendModalTitle$1 = "Recommend Skills";
var OrgSkills_RecommendSkills$1 = "Recommend Skills";
var OrgSkills_RecommendSkillsFormat$1 = "Recommend {{number}} Skills";
var OrgSkills_RecommendSkillsPluralFormat$1 = "Recommend {{number}} Skills";
var OrgSkills_RecommendSkillsSingleFormat$1 = "Recommend 1 Skill";
var OrgSkills_ReviewSkills$1 = "Review skills";
var OrgSkills_Role$1 = "Name";
var OrgSkills_RoleAlreadyPlan$1 = "This role was previously marked as a plan.";
var OrgSkills_RoleDescription$1 = "Role Description";
var OrgSkills_RoleDescriptionPlaceholder$1 = "Enter a description";
var OrgSkills_RoleIncludeInOnboarding$1 = "Suggest role in welcome tour";
var OrgSkills_RoleIncludeInOnboardingInfo$1 = "Enable to suggest this role to new users before they search.";
var OrgSkills_RoleMakePlan$1 = "Mark as plan";
var OrgSkills_RoleMakePlanInfo$1 = "Create a plan with this set of skills. You can add content later.";
var OrgSkills_RolePlaceholder$1 = "Product Designer";
var OrgSkills_SearchForSkills$1 = "Search for skills...";
var OrgSkills_SearchPlaceholder$1 = "Search for skills...";
var OrgSkills_SeeSkillOverview$1 = "See Skill Overview";
var OrgSkills_Selected$1 = "Selected";
var OrgSkills_SelectSkillLevel$1 = "Select Skill Level";
var OrgSkills_ShowAsPlan$1 = "Marked as Plan";
var OrgSkills_SimilarSkillsTitle$1 = "Similar Skills";
var OrgSkills_Skill$1 = "Skill";
var OrgSkills_SkillDetailsTitle$1 = "Skill Details";
var OrgSkills_SkillLevel$1 = "Skill level: {{skillLevel}}";
var OrgSkills_SkillNameExists$1 = "This name already exists";
var OrgSkills_SkillPlaceholder$1 = "Enter skill name";
var OrgSkills_SkillProfile$1 = "Skill Profile";
var OrgSkills_SkillReview$1 = "Skill Review";
var OrgSkills_SkillReviewEnabled$1 = "Organization";
var OrgSkills_SkillReviewEnabledGroup$1 = "Group";
var OrgSkills_Skills$1 = "Skills";
var OrgSkills_SkillsListInfo$1 = "Enter a skill name, then you can choose from the list or use the enter key";
var OrgSkills_SkillsListPlaceholder$1 = "Enter a skill";
var OrgSkills_SkillToRoleSuggestions$1 = "Skill to Role Suggestions";
var OrgSkills_SlowChangesWarn$1 = "Changes to data in this table may not appear immediately.";
var OrgSkills_Source$1 = "Source";
var OrgSkills_SuccessAddingSingleSkill$1 = "You successfully added 1 new skill.";
var OrgSkills_SuggestedSkills$1 = "Suggested Skills";
var OrgSkills_TranslatedTitle$1 = "Translated title:";
var OrgSkills_UpdateSkills$1 = "Update Skills";
var OrgSkills_UploadFile$1 = "Upload File";
var OrgSkills_UploadOpportunitiesNotice$1 = "The file you uploaded is being processed. Changes based on this file may take up to 4 hours to appear in Degreed.";
var OrgSkills_UploadRoles$1 = "Upload Roles";
var OrgSkills_UploadRolesDescription$1 = "You can upload multiple roles at once by including them in a file with the following template.";
var OrgSkills_UploadSkills$1 = "Upload Skills";
var OrgSkills_UploadSkills_ToSource$1 = "Upload Skills to {{SourceName}}";
var OrgSkills_UploadSkillsDescription$1 = "You can update multiple skills at once by including them in a file with the following template. You only need to include the skills you want to update.";
var OrgSkills_ViewRolePlan$1 = "View Role Plan";
var OrgSkills_VisibilitySkillReview$1 = "Skill Review visibility";
var OrgSkills_WorkdaySimilarSkillsInfo$1 = "Linked skills are automatically set by the Workday integration. These skills are limited to the taxonomy skills in your organization’s Workday and Degreed skills catalogs.";
var OrgSettingsSupport_Description$1 = "Customize the help menu with your contact and support information";
var OrgSettingsSupport_EmailLabel$1 = "Email address";
var OrgSettingsSupport_FaqUrlLabel$1 = "FAQ URL";
var OrgSettingsSupport_FaqUrlPlaceholder$1 = "https://degreed.com/faq";
var OrgSettingsSupport_InvalidEmail$1 = "Please enter a valid email address";
var OrgSettingsSupport_InvalidFaqUrl$1 = "Please enter a valid URL";
var OrgSettingsSupport_PhoneLabel$1 = "Phone number";
var OrgSettingsSupport_PhonePlaceholder$1 = "(123) 456-7890";
var OrgSettingsSupport_Title$1 = "Support Management";
var OrgSettingsSupport_UpdateSuccessMessage$1 = "Organization support management settings updated successfully.";
var OrgSettingsNav_Branding$1 = "Branding";
var OrgSettingsNav_BusinessRules$1 = "Business Rules";
var OrgSettingsNav_Communication$1 = "Communication";
var OrgSettingsNav_HelpMenu$1 = "Help Menu";
var OrgSettingsNav_Learning$1 = "Learning";
var OrgSettingsNav_Links$1 = "Links";
var OrgSettingsNav_ManageAttributes$1 = "Manage Attributes";
var OrgSettingsNav_Messages$1 = "Messages";
var OrgSettingsNav_Messaging$1 = "Messaging";
var OrgSettingsNav_Permissions$1 = "Permissions";
var OrgSettingsNav_Providers$1 = "Providers";
var OrgSettingsLinks_AddLink$1 = "Add Link";
var OrgSettingsLinks_AddSection$1 = "Add Section";
var OrgSettingsLinks_Description$1 = "Customize the Learner Home page by adding a section of important links.";
var OrgSettingsLinks_LinkMaximum$1 = "(5 link maximum)";
var OrgSettingsLinks_LinkTitle$1 = "Link Name";
var OrgSettingsLinks_LinkTitlePlaceholder$1 = "Short name of the resource";
var OrgSettingsLinks_LinkUrl$1 = "Link URL";
var OrgSettingsLinks_RemoveLink$1 = "Remove Link";
var OrgSettingsLinks_RemoveSection$1 = "Remove Section";
var OrgSettingsLinks_SectionTitle$1 = "Section Title";
var OrgSettingsLinks_Title$1 = "Organization Links";
var OrgSettingsLinks_TitlePlaceholder$1 = "{{orgName}} Links";
var OrgSettingsLinks_UpdateSuccessMessage$1 = "Organization Links Successfully Updated";
var OrgSettingsLinks_UrlPlaceholder$1 = "http://resourceurl.com";
var OrgSettingsEndorsed_ImageSize$1 = "Recommended size is 48px high and max 144px wide";
var OrgSettingsEndorsed_RemoveEndorseIcon$1 = "Remove uploaded endorse item icon";
var OrgSettingsEndorsed_Subtitle$1 = "Add a visual to items that you'd like to highlight";
var OrgSettingsEndorsed_Title$1 = "Endorsements";
var OrgSettingsCtrl_AcademiesHeaderUploadSize$1 = "Recommended size is at least 258px high and 1152px wide";
var OrgSettingsCtrl_AssignedLearningCustomizationDiscardConfirm$1 = "Your Assigned Learning card customization will be lost. Are you sure you want to proceed?";
var OrgSettingsCtrl_ChangesCancelConfirm$1 = "Changes you have made to {{ title }} will be lost. Are you sure you want to proceed?";
var OrgSettingsCtrl_ChangesCanceledSuccessMessage$1 = "Your changes to {{ title }} have been discarded successfully.";
var OrgSettingsCtrl_ContrastWarning$1 = "The combination of colors does NOT meet WCAG 4.5:1 contrast ratio requirements";
var OrgSettingsCtrl_EmailRequirements$1 = "Joining Requires An Email Address From";
var OrgSettingsCtrl_EmailRequirementsHint$1 = "hint: add multiple domains with commas.";
var OrgSettingsCtrl_ManageOrgName$1 = "Manage {0}";
var OrgSettingsCtrl_MessagingTabLabel$1 = "You can customize messages that appear throughout Degreed to give users important information as they need it.";
var OrgSettingsCtrl_MessagingTabPlaceholder$1 = "Add a custom message";
var OrgSettingsCtrl_OrgDescription$1 = "Description";
var OrgSettingsCtrl_OrgName$1 = "Organization Name";
var OrgSettingsCtrl_OrgNameInOnboarding$1 = "Use organization name in onboarding";
var OrgSettingsCtrl_OrgNameValidationMessage$1 = "Please specify a name for the organization.";
var OrgSettingsCtrl_Title$1 = "Organization Details";
var OrgSettingsCtrl_UpdateLinksSuccessMessage$1 = "Settings updated successfully. It may take a few minutes to complete the changes.";
var OrgSettingsCtrl_UpdateSuccessMessage$1 = "Organization settings updated successfully.";
var OrgSettings_AcceptJobRoleFromClientUserFile_Desc$1 = "Enable to allow Job Roles to be set for a user from a ClientUser file.";
var OrgSettings_AddCard$1 = "Add Card";
var OrgSettings_AdminNotifications$1 = "Admin Notifications";
var OrgSettings_AllowEmailPasswordReset_Desc$1 = "Allow learners to reset their Degreed account passwords via email.";
var OrgSettings_AllowEmailPasswordReset_Name$1 = "Password Reset via Email";
var OrgSettings_AllowInteractionAcrossOrganizations_Desc$1 = "For extended enterprises, this enables social sharing across organizations for the orgs that have this flag enabled. Including following learners across organizations, sharing content across organizations, and allows ratings and comments to be visible across organizations.";
var OrgSettings_AllowInteractionAcrossOrganizations_Name$1 = "Allow Learner Interaction Across Organizations";
var OrgSettings_AllowOrgTransfer_Desc$1 = "For extended enterprises, enable the automatic transfer of a learner's profile when a learner is transferred to a new organization. This feature requires a consistent unique ID across organizations. For example: An EmployeeID or other ID that does not change when the learner transfers to a new organization.";
var OrgSettings_AllowOrgTransfer_Name$1 = "Automatic Transfer of Learners Across Organization";
var OrgSettings_AllowSkillSuggestions_Desc$1 = "Use Degreed AI Inference to suggest skills to users.";
var OrgSettings_AllowSkillSuggestions_Name$1 = "Allow Skill Suggestions";
var OrgSettings_AllowSsoUserIdUpdate_Desc$1 = "AllowSsoUserIdUpdate";
var OrgSettings_AllowSsoUserIdUpdate_Name$1 = "AllowSsoUserIdUpdate";
var OrgSettings_AnonymizeCredsparkUsers_Desc$1 = "Anonymize first name, last name, IP Address, and email for Credspark";
var OrgSettings_AnonymizeCredsparkUsers_Name$1 = "Anonymize Credspark Users";
var OrgSettings_AnonymizePrivateUsers_Desc$1 = "Learners who set their profile as private will be anonymized throughout the platform and insights.";
var OrgSettings_AnonymizePrivateUsers_Name$1 = "Anonymize Private Learners";
var OrgSettings_AnonymizeZendeskUsers_Desc$1 = "Users of this organization will be logged into Zendesk with their alias information.";
var OrgSettings_AnonymizeZendeskUsers_Name$1 = "Anonymize Zendesk Users";
var OrgSettings_AppFeedback_GroupDesc$1 = "Enable settings for learners to provide Degreed feedback.";
var OrgSettings_AppFeedback_GroupDisplayName$1 = "App Feedback";
var OrgSettings_AppGuidance_GroupDesc$1 = "Enable In-App tips to appear across the product for education on key features.";
var OrgSettings_AppGuidance_GroupDisplayName$1 = "App Guidance";
var OrgSettings_AssignedLearning_Desc$1 = "Notifies learners when they have a new learning assignment.";
var OrgSettings_AssignedLearning_Name$1 = "Assigned Learning";
var OrgSettings_AssignedLearningDescription$1 = "Assigned Learning includes assigned or required learning with a due date.";
var OrgSettings_AssignedLearningSaveSuccess$1 = "Assigned Learning card was successfully saved.";
var OrgSettings_AuditUserGeneratedData_Desc$1 = "This flag enables the Degreed system to begin capturing social text data.  If clients are interested in this feature, it's important to enable the flag as soon as possible, because the data can't be collected retroactively. This feature was added to comply with US FINRA regulations for Ameriprise and RBC, but may not be a good choice for non-financial firms with employees in other countries.";
var OrgSettings_AuditUserGeneratedData_Name$1 = "Social Text Audit";
var OrgSettings_AuthenticationSettings$1 = "Authentication Settings";
var OrgSettings_BuildSkillsEmail_Desc$1 = "Prompts learners to build skills by consuming learning content, and marking items complete.";
var OrgSettings_BuildSkillsEmail_Name$1 = "Onboarding Email Day 5: Build Your Skills";
var OrgSettings_ButtonTitleRequired$1 = "A button title is required.";
var OrgSettings_CardDescription$1 = "Card Description";
var OrgSettings_CardDescriptionPlaceholder$1 = "Add a short description to explain what this card is about";
var OrgSettings_CardNumber$1 = "Card {{number}}";
var OrgSettings_CardPositionAriaText$1 = "Position: {{positionNumber}} of {{totalNumber}}";
var OrgSettings_CardTitle$1 = "Card Title";
var OrgSettings_CardTitlePlaceholder$1 = "Add a card title";
var OrgSettings_CardType$1 = "Card Type";
var OrgSettings_CareersFooterMessage_Desc$1 = "Provides a legal disclaimer at the bottom of the Roles page. This feature should NOT be enabled for clients unless they specifically ask.";
var OrgSettings_CareersFooterMessage_Name$1 = "Career Footer Message (Legal Disclaimer)";
var OrgSettings_ClientAdobeAnalyticsId_Desc$1 = "Adobe Analytics (AA) id of the organization. When supplied, AA code will fire and be tied to the id specified.";
var OrgSettings_ClientAdobeAnalyticsId_Name$1 = "Client Adobe Analytics Id";
var OrgSettings_ClientGoogleAnalyticsId_Desc$1 = "Google Analytics (GA) id of the organization. When supplied, GA code will fire and be tied to the id specified. This is in addition to existing GA code that fires for Degreed for internal tracking.";
var OrgSettings_ClientGoogleAnalyticsId_Name$1 = "Client Google Analytics Id";
var OrgSettings_ClientTypeOverride_Desc$1 = "An override should be selected only for orgs that have Skill Inventory or Skill Analytics and do not have the LXP. For LXP clients, including clients with Skill Analytics, set the standard settings in the ops tool.";
var OrgSettings_ClientTypeOverride_Name$1 = "Client Type Override";
var OrgSettings_ClientTypeOverride_Selection_None$1 = "None";
var OrgSettings_ClientTypeOverride_Selection_SkillAnalytics$1 = "Skill Analytics Client";
var OrgSettings_ClientTypeOverride_Selection_SkillInventory$1 = "Skill Inventory Client";
var OrgSettings_CmsCascadeDeleteFileImport_Desc$1 = "CMS content flagged for deletion via file or API will also be removed from pathways/bins, plans/directories, and recommendations/assignments. Cascade delete will only work for CMS content or provider content stored in the CMS. Cascade delete will not run for other provider content.";
var OrgSettings_CmsCascadeDeleteFileImport_Name$1 = "Cascade Delete: Enforce for Org Content Items";
var OrgSettings_CmsCascadeDeleteNotifyUsers_Desc$1 = "Notifications will be sent both in-app and email to authors or recipients based on the cascade delete result.  The email will be one per day with a rollup of all items for that learner, the email is not sent if the in-app notification is read before email goes out.  Notifications go to authors for pathways and plans/directories and to recipients for recommendations/assignments.";
var OrgSettings_CmsCascadeDeleteNotifyUsers_Name$1 = "Cascade Delete: Send Notifications";
var OrgSettings_CompleteViewedItems_Desc$1 = "Prompts Learners to Complete Viewed Items.";
var OrgSettings_CompleteViewedItems_Name$1 = "Complete Viewed Items";
var OrgSettings_Confirmation$1 = "Reset Acceptance";
var OrgSettings_ContentModeratorOptions_Desc$1 = "Set Content Moderating Threshold Description";
var OrgSettings_ContentModeratorOptions_Name$1 = "Set Content Moderating Threshold";
var OrgSettings_ContentSettings$1 = "Content Settings";
var OrgSettings_CreateManagerGroups_Desc$1 = "Enable automatic creation of manager teams/groups";
var OrgSettings_CredSparkEnabled_Desc$1 = "Enables the CredSpark integration. Jira ticket is required to complete the setup. We need CredSpark details: ID and token. Once its enabled for an org, you can turn it off/on using this setting. ";
var OrgSettings_CredSparkEnabled_Name$1 = "CredSpark Assessment Integration";
var OrgSettings_CustomizeCard$1 = "Customize Card";
var OrgSettings_CustomizeCardDescription$1 = "Do you want to customize the title and/or description for this card?";
var OrgSettings_CustomizeHelpMenu$1 = "Customize the help menu for your organization";
var OrgSettings_CustomMessageDesc$1 = "Custom messages will not be translated into learners' language preferences";
var OrgSettings_CustomOnboardingText_Default$1 = "Do you have the skills you need to take on tomorrow?\r\nLet's find out by building your {{orgName}} Profile. Your profile is used to find resources personalized to your role, skills, and goals.";
var OrgSettings_CustomOnboardingText_Desc$1 = "Changes the text on the first page of onboarding.";
var OrgSettings_CustomOnboardingText_Name$1 = "Custom Onboarding Text";
var OrgSettings_CustomRatingLevelNames_Desc$1 = "Specify the custom skill labels one per line starting with level 1";
var OrgSettings_CustomRatingLevelNames_Name$1 = "Custom Skill Level Labels";
var OrgSettings_CustomRatingScale_Desc$1 = "Select a maximum value for the custom rating scale";
var OrgSettings_CustomRatingScale_Name$1 = "Custom Rating Scale";
var OrgSettings_CustomRatingScale_Selection_Eight$1 = "8";
var OrgSettings_CustomRatingScale_Selection_Five$1 = "5";
var OrgSettings_CustomRatingScale_Selection_Four$1 = "4";
var OrgSettings_CustomRatingScale_Selection_Nine$1 = "9";
var OrgSettings_CustomRatingScale_Selection_Seven$1 = "7";
var OrgSettings_CustomRatingScale_Selection_Six$1 = "6";
var OrgSettings_CustomRatingScale_Selection_Ten$1 = "10";
var OrgSettings_DailySummaryEmail_Desc$1 = "A daily email with Today's Learning and Degreed activity";
var OrgSettings_DailySummaryEmail_Name$1 = "Daily Digest";
var OrgSettings_DateReceived$1 = "Date Received (UTC)";
var OrgSettings_DefaultAssignmentsSort_Desc$1 = "Set the default column the Assignments page should be sorted on.";
var OrgSettings_DefaultAssignmentsSort_Name$1 = "Default Assignments Sort Column";
var OrgSettings_DefaultAssignmentsSort_Selection_AssignmentType$1 = "Assignment Type";
var OrgSettings_DefaultAssignmentsSort_Selection_DueDate$1 = "Due Date (default)";
var OrgSettings_DefaultMessage$1 = "Default Message";
var OrgSettings_DefaultPrivacyLevel_Desc$1 = "Default user privacy for an organization. All new users created via the user file and SSO will recieve this default privacy level. ";
var OrgSettings_DefaultPrivacyLevel_Name$1 = "Default Privacy Level";
var OrgSettings_DefaultPWResetUI_Desc$1 = "Enables the ability to reset organization user's password to default organization password";
var OrgSettings_DefaultPWResetUI_Name$1 = "Enable Default Password Reset UI";
var OrgSettings_DefaultUserPassword_Desc$1 = "Sets a default password for all new learners, which they will be prompted to change upon login.";
var OrgSettings_DefaultUserPassword_Name$1 = "Default User Password";
var OrgSettings_DegreedCareerMobility$1 = "Degreed Opportunity Marketplace";
var OrgSettings_DegreedFeatures$1 = "Degreed Features";
var OrgSettings_DegreedLearnUponUserSync$1 = "Degreed LearnUpon User Sync";
var OrgSettings_DegreedSurveys_Desc$1 = "Learners see in-app surveys and calls to participate in research to improve the Degreed experience.";
var OrgSettings_DegreedSurveys_Name$1 = "Participate in Degreed User Research";
var OrgSettings_DegreedTalent_Desc$1 = "Opportunity Marketplace Product that is available for an additional fee.";
var OrgSettings_DegreedTalent_Name$1 = "Degreed Opportunity Marketplace";
var OrgSettings_DeleteCardAriaText$1 = "Delete card number {{cardNumber}}";
var OrgSettings_DeleteCardSuccess$1 = "{{cardType}} was successfully deleted.";
var OrgSettings_DeleteLink$1 = "Delete Link";
var OrgSettings_DeleteLinkModalMessage$1 = 'Are you sure you want to delete the "{{startEmphasisTag}}{{linkTitle}}{{endEmphasisTag}}" link from this card?';
var OrgSettings_DeleteLinkSuccess$1 = "Saved link was successfully deleted.";
var OrgSettings_DeleteSavedLink$1 = "Delete Saved Link";
var OrgSettings_Delimiter_Desc$1 = "Value to delimit csv files. Default is comma (,).";
var OrgSettings_Delimiter_Name$1 = "File Delimiter";
var OrgSettings_DenyComments_Desc$1 = "Disables the takeaway feature for all learners of the organization. Only BofA (29) and Ameriprise Financial (481) have this set. *We do not recommend disabling this feature for clients.*";
var OrgSettings_DenyComments_Name$1 = "Disable Takeaways";
var OrgSettings_DGAssistant_GroupDesc$1 = "Settings for Assistant";
var OrgSettings_DGAssistant_GroupDisplayName$1 = "Assistant Settings";
var OrgSettings_DGAssistantQuickResponse_Desc$1 = "Enable for fast response.";
var OrgSettings_DGAssistantQuickResponse_Name$1 = "Quick Replies";
var OrgSettings_DisableAnalytics_Desc$1 = "Turns off 3rd party analytics: Drift, FullStory, Engagio, and Google Analytics. This org flag is rarely used.  *We do not recommend disabling this feature for clients.*";
var OrgSettings_DisableAnalytics_Name$1 = "Disable Third-Party Analytics Tracking";
var OrgSettings_DisableAssignedLearning_Desc$1 = 'Disables the "Assignment" feature where learners can recommend content with a date. This Org Flag is rarely used. *We do not recommend disabling this feature for clients.*';
var OrgSettings_DisableAssignedLearning_Name$1 = "Disable Assigned Learning";
var OrgSettings_DisableAssignedLearningTab_Desc$1 = "Hides the assigned learning tab on the learner's homepage.";
var OrgSettings_DisableAssignedLearningTab_Name$1 = "Disable Assigned Learning Tab (Learner Hub)";
var OrgSettings_DisableBulkUpload_Desc$1 = "Disable learners from being able to upload template file to bulk add items";
var OrgSettings_DisableBulkUpload_Name$1 = "Disable Bulk Upload";
var OrgSettings_DisableCollaboratorsHeader_Desc$1 = "This hides the list of collaborators from appearing at the top of the pathway, plans, or directories. This features is turned on by default for all organizations.";
var OrgSettings_DisableCollaboratorsHeader_Name$1 = "Hide List of Pathway/Plan/Directories Collaborators";
var OrgSettings_DisableContent2skills_Desc$1 = "When checked, it disables the use of DS Content to Skill inference service for the organization.";
var OrgSettings_DisableContent2skills_Name$1 = "Disable content2skills inference";
var OrgSettings_DisableDegreedMarketplace_Desc$1 = "When disabled, learners will not see Degreed Marketplace for Organization.";
var OrgSettings_DisableDegreedMarketplace_Name$1 = "Disable Degreed Marketplace";
var OrgSettings_DisableEndorsedSearchResultsSection_Desc$1 = "Disables the Endorsed Search Result section at the top of search results.";
var OrgSettings_DisableEndorsedSearchResultsSection_Name$1 = "Disable Endorsed Search Results Section";
var OrgSettings_DisableEngagedLearner_Desc$1 = "Disable all Active Learner emblems throughout Degreed.";
var OrgSettings_DisableEngagedLearner_Name$1 = "Disable Active Learner Status";
var OrgSettings_DisableHomeAdminSettings_Desc$1 = "This setting will remove the ability for org admins to customize insight cards, organizational announcements and links and will hide the home tab in the settings area.";
var OrgSettings_DisableHomeAdminSettings_Name$1 = "Disable Home Admin Settings";
var OrgSettings_DisableIndividualSkillsData_Desc$1 = "Disables the role-based permission in Manage Org > Permissions that controls the drilldown to a list of learners in Org Skill Insights.";
var OrgSettings_DisableIndividualSkillsData_Name$1 = "Disable Individual Skill Data in Org-Level Skill Insights";
var OrgSettings_DisableInviteOrgMember_Desc$1 = "Disables organization member invite permission";
var OrgSettings_DisableInviteOrgMember_Name$1 = "Disable Org Member Invite";
var OrgSettings_DisableKnowledgeCenter_Desc$1 = "Disables Knowledge Center permission and the link in the help box on the bottom right corner";
var OrgSettings_DisableKnowledgeCenter_Name$1 = "Disable Knowledge Center";
var OrgSettings_DisableLearnerSkillsRegistry_Desc$1 = "When disabled, learners will not see Skills Registry suggestions when adding a Skill e.g. to a plan or pathway";
var OrgSettings_DisableLearnerSkillsRegistry_Name$1 = "Disable Learner Skills Registry";
var OrgSettings_DisableLearningCampaigns_Desc$1 = "This disables the Trackable Links on Pathway Insights that were released July 2018 and on Plan Insights released April 2019. This feature is turned on by default for all organizations.";
var OrgSettings_DisableLearningCampaigns_Name$1 = "Disable Trackable Links to Pathways and Plans";
var OrgSettings_DisableManageContent_Desc$1 = "Disables Manage Content permission and managing contents in Content page";
var OrgSettings_DisableManageContent_Name$1 = "Disable Manage Content";
var OrgSettings_DisableMedalliaScript_Desc$1 = "Disables tracking by Medallia.";
var OrgSettings_DisableMedalliaScript_Name$1 = "Reduce Tracking";
var OrgSettings_DisableMentorshipReview_Desc$1 = "Disables the option to give and request skill ratings, give and request feedback and add mentorship experiences to the profile when completing a mentorship. Disabling is not recommended.";
var OrgSettings_DisableMentorshipReview_Name$1 = "Disable Mentorship Review";
var OrgSettings_DisablePathwayHeaderImage_Desc$1 = "This will remove/disable the header image at the top of the pathway page which serves as the background for the pathway title. This will disable the header image for all org pathways. Header images can still be enabled per pathway in the pathway settings. This is only applicable for the new pathway design.";
var OrgSettings_DisablePathwayHeaderImage_Name$1 = "Disable header image for all org pathways";
var OrgSettings_DisablePersonalizedLearningTab_Desc$1 = "Hides the personalized learning tab on the learner's homepage.";
var OrgSettings_DisablePersonalizedLearningTab_Name$1 = "Disable Personalized Learning Tab (Learner Hub)";
var OrgSettings_DisablePopupMessages_Desc$1 = "Hides 'Messaging' tab where pop up messages can be configured";
var OrgSettings_DisablePopupMessages_Name$1 = "Disable Pop-Up Messages";
var OrgSettings_DisableProfileSkillSuggestions_Desc$1 = "Disables the skill suggestions feature found in the profile overview and skills modal";
var OrgSettings_DisableProfileSkillSuggestions_Name$1 = "Disable profile skill suggestions";
var OrgSettings_DisableRatingsInsights_Desc$1 = "Disable/Hide the Skill Ratings graph on the Org Insights page and the Skill Insights graphs on Plan Insights. Only BofA, 507 SunCME have this set. We do not recommend this feature be disabled for clients.";
var OrgSettings_DisableRatingsInsights_Name$1 = "Disable Skill Ratings Insights";
var OrgSettings_DisableResumeParsingInOnboarding_Desc$1 = "Disables the Resume Parsing feature for an organization's users in employee Onboarding.";
var OrgSettings_DisableSearchRelatedSkills_Desc$1 = "When disabled, Related Skills will not be suggested on the search results page.";
var OrgSettings_DisableSearchRelatedSkills_Name$1 = "Disable Search Related Skills";
var OrgSettings_DisableSkillsVisualization_Desc$1 = "Hides the skills visualization section on the learner's homepage.";
var OrgSettings_DisableSkillsVisualization_Name$1 = "Disable Skills Visualization (Learner Hub)";
var OrgSettings_DisableThirdPartyExperienceManagement_Desc$1 = "Disables tracking by Third Party Scripts.";
var OrgSettings_DisableThirdPartyExperienceManagement_Name$1 = "Reduce Tracking";
var OrgSettings_DisableTopLearnerInsights_Desc$1 = "Disable all Top Learner Insights graphs on the organization insights page";
var OrgSettings_DisableTopLearnerInsights_Name$1 = "DisableTopLearnerInsights";
var OrgSettings_DisableUserGeneratedContent_Desc$1 = "Disable Degreed's Learner-Generated Video Content feature.";
var OrgSettings_DisableUserGeneratedContent_Name$1 = "Disable Learner-Generated Video Content";
var OrgSettings_DiscardCardChanges$1 = "Your card customization will be lost.";
var OrgSettings_DownloadablePathwayReportEmployeeIdentifier_Desc$1 = "Select the value(s) to use for identifying Employees in the downloadable Pathway report";
var OrgSettings_DownloadablePathwayReportEmployeeIdentifier_Name$1 = "Downloadable Pathway Report Employee Identifier";
var OrgSettings_DownloadablePathwayReportEmployeeIdentifier_Selection_Both$1 = "Both Employee ID and Email";
var OrgSettings_DownloadablePathwayReportEmployeeIdentifier_Selection_EmployeeIdOnly$1 = "Employee ID";
var OrgSettings_DownloadablePathwayReportEmployeeIdentifier_Selection_OrganizationEmailOnly$1 = "Employee Email";
var OrgSettings_DownloadableReportPermissionReadOnly_Desc$1 = 'Disables the "Download Reports" permission and the "Download Pathway Details Report" permission so even Admins are not able to edit which roles have this permission. This was added for Bank of America so they could disable the permission for all Roles, including the Admin role, then disable the permission so even admins aren\'t able to Download Reports.';
var OrgSettings_DownloadableReportPermissionReadOnly_Name$1 = "Disable Download Reports Permission";
var OrgSettings_EmailSettings$1 = "Email Settings";
var OrgSettings_EmailSettings_Desc$1 = "Tells the learner about turning on their daily emails.";
var OrgSettings_EmailSettings_GroupDesc$1 = "Default informative email settings for new users.";
var OrgSettings_EmailSettings_GroupDisplayName$1 = "Email Settings";
var OrgSettings_EmailSettings_Name$1 = "Email settings";
var OrgSettings_EmployeeProcessing$1 = "Employee Processing";
var OrgSettings_EnableActiveUserInsights_Desc$1 = "Enables active users graph (which also shows new versus returning users) to be shown on the organization insights page";
var OrgSettings_EnableActiveUserInsights_Name$1 = "Enable Active User Insights";
var OrgSettings_EnableAdvancedSkillAnalytics_Desc$1 = "Enable advanced skill analytics visualizations.";
var OrgSettings_EnableAdvancedSkillAnalytics_Name$1 = "Enable Advanced Skill Analytics";
var OrgSettings_EnableAISkillInference_Desc$1 = "Infer skills to job roles across your organization.";
var OrgSettings_EnableAISkillInference_Name$1 = "Enable Degreed AI Skill Inference";
var OrgSettings_EnableCareerPathing_Desc$1 = "Flexible framework for building out a hierarchy of content.";
var OrgSettings_EnableCareerPathing_Name$1 = "Career Pathing  (Plans must also be enabled)";
var OrgSettings_EnableCustomRatingLevelNames_Desc$1 = "Allow each skill level to have a different label";
var OrgSettings_EnableCustomRatingLevelNames_Name$1 = "Custom Skill Level Labels";
var OrgSettings_EnableCustomRatingScale_Desc$1 = "Allow org to have a custom rating scale";
var OrgSettings_EnableCustomRatingScale_Name$1 = "Custom Rating Scale";
var OrgSettings_EnableCustomRecommendationTypes_Desc$1 = "Enables custom recommendation types (Mandatory, Recommended)";
var OrgSettings_EnableCustomRecommendationTypes_Name$1 = "Enable Custom Recommendation Types";
var OrgSettings_EnableDCMPilot_Desc$1 = "Use Groups to Control Visibility of the Opportunity Marketplace in Degreed through Group membership. Opportunity Marketplace and the Group setting will be visible to users with Technical Admin and Admin role.";
var OrgSettings_EnableDCMPilot_Name$1 = "Enable DCM for POC/Pilot";
var OrgSettings_EnableDirectoriesOnBrowse_Desc$1 = "If enabled, the Browse page will show the Directories tab, allowing users to browse Directories.";
var OrgSettings_EnableDirectoriesOnBrowse_Name$1 = "Enable Directories tab on Browse page";
var OrgSettings_EnableEngage_Desc$1 = "Enables the Engage application and functionality for the organization.";
var OrgSettings_EnableEngage_Name$1 = "Enable Engage";
var OrgSettings_EnableEvaluationEndorsements_Desc$1 = "This adds a step requiring an endorser for skill review";
var OrgSettings_EnableEvaluationEndorsements_Name$1 = "Enable social validation for skill review";
var OrgSettings_EnableManagerOfManager_Desc$1 = "Turns on the Manager-of-Manager Filters in the Skill Coach experience";
var OrgSettings_EnableManagerOfManager_Name$1 = "Activate Skill Coach Manager-of-Manager Filters";
var OrgSettings_EnableManagerRatings_Desc$1 = "Enables the ability for Managers to give skill ratings for their employees.";
var OrgSettings_EnableManagerRatings_Name$1 = "Manager Ratings";
var OrgSettings_EnableMentorshipOpportunities_Desc$1 = "In order to see Mentoring in the app, the org must also be using Career Mobility.";
var OrgSettings_EnableMentorshipOpportunities_Name$1 = "Enable Mentorship Opportunities";
var OrgSettings_EnableMobileBiometricAuth_Desc$1 = "Enables biometric authentication capabilities in the mobile app. Customize the biometric authentication timeout by modifying the OAuth Refresh Token Timeout for Mobile app setting.";
var OrgSettings_EnableMobileBiometricAuth_Name$1 = "Biometric Authentication for Mobile Devices";
var OrgSettings_EnableNewReportingFTPConnection_Desc$1 = "Enable new method for transmitting reports to a clients FTP.";
var OrgSettings_EnableOptionalEvaluationEndorsement_Desc$1 = "Endorser step in skill review becomes optional when checked";
var OrgSettings_EnableOptionalEvaluationEndorsement_Name$1 = "Enable social validation (optional) for skill review";
var OrgSettings_EnableOrgInsightsSkillsTab_Desc$1 = "FOR INTERNAL USE ONLY - Enable Skill Insights tab in Org Insights (Deprecated)";
var OrgSettings_EnableOrgInsightsSkillsTab_Name$1 = "FOR INTERNAL USE ONLY - Enable Skill Insights tab in Org Insights";
var OrgSettings_EnablePathwayBadgeTrigger_Desc$1 = "Enables pathway badge trigger option in the Pathway settings for users with Manage Pathway permission.";
var OrgSettings_EnablePathwayBadgeTrigger_Name$1 = "Enable Pathway Badge Trigger";
var OrgSettings_EnablePeerRatings_Desc$1 = "Enables the ability for Users to request Peer skill ratings";
var OrgSettings_EnablePeerRatings_Name$1 = "Peer Ratings";
var OrgSettings_EnablePluralsightSkillsIntegration_Desc$1 = "Shows Pluralsight skills to the user. These skills are pulled in via the Pluralsight Skills Collector.";
var OrgSettings_EnablePluralsightSkillsIntegration_Name$1 = "Enable Pluralsight Skills Integration";
var OrgSettings_EnablePreferredContentLanguagesFilter_Desc$1 = "Only allow content tagged with the user's preferred content languages in home recommendations and search.";
var OrgSettings_EnablePreferredContentLanguagesFilter_Name$1 = "Enable Preferred Content Languages Filter";
var OrgSettings_EnablePrimaryPlanOnDashboard_Desc$1 = 'Enabling this will replace the skills and plans sidebar on the home page ("dashboard") with a primary plan component at the top that includes skills on the learner\'s primary plan.';
var OrgSettings_EnablePrimaryPlanOnDashboard_Name$1 = "Enable Primary Plan on Homepage";
var OrgSettings_EnableProvidersInUI_Desc$1 = "Adds a tab to allow orgs to feature public catalog providers";
var OrgSettings_EnableProvidersInUI_Name$1 = "Providers In the UI";
var OrgSettings_EnableSkillCoachOptInSettingForAll_Desc$1 = "If enabled, all users in this org will see the option to opt-in or out of Skill Coach in their Profile Settings";
var OrgSettings_EnableSkillCoachOptInSettingForAll_Name$1 = "Enable Skill Coach Opt-In Setting for All Users";
var OrgSettings_EnableSkillInsightsDashboard_Desc$1 = "The + version of the Insights Skills tab is for Skill Review clients ONLY. When TRUE, the Insights Skill tab will have additional modules that are unavailable to non-Skill Review clients.";
var OrgSettings_EnableSkillInsightsDashboard_Name$1 = "Enable Skill Insights+ (for Skill Review clients only)";
var OrgSettings_EnableSkillsCertification_Desc$1 = "Enable Skill Certification for all supported skills. This is not normally enabled because orgs will purchase specific skills instead.";
var OrgSettings_EnableSkillsCertification_Name$1 = "Skill Certification for all supported skills";
var OrgSettings_EnableSkillsEvaluation_Desc$1 = "‘Skills Review’ is a shorter process for completing a first-step in the skill certification process that gives user an initial skill level. When turned on, users can start a Skill Review from the skill rating modal (for the skills we support). ";
var OrgSettings_EnableSkillsEvaluation_Name$1 = "Skills Review";
var OrgSettings_EnableSkillsPlatform_Desc$1 = "Warning: This is under development and should not be added to any environments without approval";
var OrgSettings_EnableSkillsPlatform_Name$1 = "Enable Skills Platform";
var OrgSettings_EnableSkillStandards_Desc$1 = "Enable Skill Standards for the organization. Default is false.";
var OrgSettings_EnableSkillStandards_Name$1 = "Enable Skill Standards";
var OrgSettings_EnableTeamSpace_Desc$1 = "Turns on the Skill Coach functionality for the organization";
var OrgSettings_EnableTeamSpace_Name$1 = "Activate Skill Coach";
var OrgSettings_EnableUserSearchFilterByJobRole_Desc$1 = "For user searches, display the facet that aggregates job roles.";
var OrgSettings_EnableUserSearchFilterByJobRole_Name$1 = "Enable User Search Filter By Job Role";
var OrgSettings_EnableUserSearchFilterByLocation_Desc$1 = "For user searches, display the facet that aggregates location data.";
var OrgSettings_EnableUserSearchFilterByLocation_Name$1 = "Enable User Search Filter By Location";
var OrgSettings_EnforceDataPrivacyAcceptance_Desc$1 = "Require users to accept this message before using Degreed. Users who do not accept the message will not be allowed to access Degreed.";
var OrgSettings_EnforceDataPrivacyAcceptance_Name$1 = "Enforce Data Privacy Acceptance";
var OrgSettings_EnforceDataPrivacyAcceptanceBody_PlaceHolder$1 = "Add an enforce data privacy acceptance message";
var OrgSettings_EnforceDataPrivacyAcceptanceBody_PopupLabel$1 = "Enforce Data Privacy Acceptance Body";
var OrgSettings_EnforceDataPrivacyAcceptanceConfirmation_Default$1 = "I confirm that I have read and understand the Terms and Conditions";
var OrgSettings_EnforceDataPrivacyAcceptanceConfirmation_PlaceHolder$1 = "Add a custom confirmation text";
var OrgSettings_EnforceDataPrivacyAcceptanceConfirmation_PopupLabel$1 = "Enforce Data Privacy Acceptance Confirmation";
var OrgSettings_EnforceDataPrivacyAcceptanceHeader_Default$1 = "Degreed Terms and Conditions";
var OrgSettings_EnforceDataPrivacyAcceptanceHeader_PlaceHolder$1 = "Add a custom header";
var OrgSettings_EnforceDataPrivacyAcceptanceHeader_PopupLabel$1 = "Enforce Data Privacy Acceptance Header";
var OrgSettings_EnforceDataPrivacyAcceptanceTitle_Default$1 = "Please review and accept the following Terms and Conditions to use Degreed";
var OrgSettings_EnforceDataPrivacyAcceptanceTitle_PlaceHolder$1 = "Add a custom title";
var OrgSettings_EnforceDataPrivacyAcceptanceTitle_PopupLabel$1 = "Enforce Data Privacy Acceptance Title";
var OrgSettings_EnforceDegreedDataPrivacyAcceptance_Desc$1 = "Require users to accept the Degreed Privacy Policy before using Degreed.  Users who do not accept the message will not be allowed to access Degreed.";
var OrgSettings_EnforceDegreedDataPrivacyAcceptance_Name$1 = "Enforce Degreed Data Privacy Acceptance";
var OrgSettings_EngagementFeatures$1 = "Engagement Features";
var OrgSettings_ErrorMessage$1 = "Error Message";
var OrgSettings_EstimatedDurationDefaults_Desc$1 = 'These are the default duration values per input type which will be used for reporting when an input\'s duration is null. These values are stored in the ISO 8601 format. Example:  "PT2H5M"';
var OrgSettings_EstimatedDurationDefaults_Name$1 = "Estimated Duration Default Values";
var OrgSettings_ExternalLink$1 = "External Link";
var OrgSettings_ExternalLinkPlaceholder$1 = "Add an external link.";
var OrgSettings_ExternalLinkRequired$1 = "An external link is required.";
var OrgSettings_FileDetails$1 = "File Details";
var OrgSettings_FileInformation$1 = "File Information";
var OrgSettings_FileName_Desc$1 = 'Specify a name with a parameter for naming. For example "filename{0}.csv".';
var OrgSettings_FileName_Name$1 = "File Name";
var OrgSettings_FtpNotificationEmail_Desc$1 = "Enables all email notifications for FTP inbound files. Add one email per line. All emails go to all recipients.";
var OrgSettings_FtpNotificationEmail_Name$1 = "FTP Inbound Emails";
var OrgSettings_FtpStatusFileOptions_Desc$1 = "Generate a report file for every inbound FTP file with detailed information on each row.";
var OrgSettings_FtpStatusFileOptions_Name$1 = "Inbound FTP Row Level Detail Report";
var OrgSettings_FtpStatusFileOptions_Selection_AllRows$1 = "All Rows";
var OrgSettings_FtpStatusFileOptions_Selection_Disabled$1 = "Off";
var OrgSettings_FtpStatusFileOptions_Selection_OnlyProblems$1 = "Only Problems";
var OrgSettings_GoalProgressEmail_Desc$1 = "Prompts users to follow pathways.";
var OrgSettings_GoalProgressEmail_Name$1 = "Onboarding Email Day 10: What’s Your Goal?";
var OrgSettings_GroupPostAdded_Desc$1 = "Notifies learners when there is a new post within one of their groups.";
var OrgSettings_GroupPostAdded_Name$1 = "New Group Post";
var OrgSettings_Groups_Desc$1 = "When a user import file is uploaded: Add will append to the user's existing. Replace will overwrite/replace the user's existing.";
var OrgSettings_Groups_Name$1 = "Groups";
var OrgSettings_Hide_Overview_Achievement_Desc$1 = "Hides the Profile overview Achievement Section from all users in the Organisation.  The Profile overview Achievement Section will no longer be seen when users are viewing their own profile or the profile of others.";
var OrgSettings_Hide_Overview_Experience_Desc$1 = "Hides the Profile overview Experience Section on all profiles in the Organisation.  The Profile overview Experience Section will no longer be seen when users are viewing their own profile or the profile of others.";
var OrgSettings_Hide_Overview_Tab_Desc$1 = "Hides the Profile overview tab from all users in the Organisation.  The Profile overview tab will no longer be seen when users are viewing their own profile or the profile of others.";
var OrgSettings_HideExternalCatalog_Desc$1 = "Hides the option to select the external catalog for all users in the organizations. Used for Client Partners like HBP, but not recommended for other clients.";
var OrgSettings_HideExternalCatalog_Name$1 = "Hide External Catalog";
var OrgSettings_HideOverviewAchievement_Desc$1 = "Hides the Profile overview Achievement Section from all users in the Organisation.  The Profile overview Achievement Section will no longer be seen when users are viewing their own profile or the profile of others. This does not apply to public profile being viewed by anonymous users.";
var OrgSettings_HideOverviewAchievement_Name$1 = "Hide Overview Achievement";
var OrgSettings_HideOverviewExperience_Desc$1 = "Hides the Profile overview Experience Section on all profiles in the Organisation.  The Profile overview Experience Section will no longer be seen when users are viewing their own profile or the profile of others. This does not apply to public profile being viewed by anonymous users.";
var OrgSettings_HideOverviewExperience_Name$1 = "Hide Overview Experience";
var OrgSettings_HideOverviewTab_Desc$1 = "Hides the Profile overview tab from all users in the Organisation.  The Profile overview tab will no longer be seen when users are viewing their own profile or the profile of others. This does not apply to public profile being viewed by anonymous users.";
var OrgSettings_HideOverviewTab_Name$1 = "Hide Overview Tab";
var OrgSettings_HidePersonalEmailInUserProfileSettings_Desc$1 = "Hides the personal email field in the User Profile Settings, so a user cannot add a personal email";
var OrgSettings_HidePersonalEmailInUserProfileSettings_Name$1 = "Hide Personal Email In Profile Settings";
var OrgSettings_HidePersonalIntegrationsInUserProfileSettings_Desc$1 = "Hides the personal integrations tab in the User Profile Settings so that users cannot configure their own integrations";
var OrgSettings_HidePersonalIntegrationsInUserProfileSettings_Name$1 = "Hide Personal Integrations Tab In Profile Settings";
var OrgSettings_HideSocialLinks_Desc$1 = "Disables the Google and Slack integrations.";
var OrgSettings_HideSocialLinks_Name$1 = "Disable Social Sharing";
var OrgSettings_HideUserEmail_Desc$1 = "Hide user's email addresses on the user card in Degreed.";
var OrgSettings_HideUserEmail_Name$1 = "Disable Displaying of User's Email";
var OrgSettings_Home_PublishModal_AssignedLearning$1 = "Assigned Learning";
var OrgSettings_Home_PublishModal_Body$1 = "You are about to publish the following cards to your organization's homepage:";
var OrgSettings_Home_PublishModal_Body_PublishNew$1 = "You are about to {{startBold}}publish{{endBold}} the following cards to your organization's homepage:";
var OrgSettings_Home_PublishModal_Body_PublishOld$1 = "The following cards will remain {{startBold}}published{{endBold}} and unchanged:";
var OrgSettings_Home_PublishModal_Body_Unpublish$1 = "You are about to {{startBold}}unpublish{{endBold}} the following cards from your organization’s homepage:";
var OrgSettings_Home_PublishModal_Body_Unpublish_Sub$1 = "The following cards will be {{startBold}}unpublished{{endBold}} from the homepage:";
var OrgSettings_Home_PublishModal_Confirm$1 = "Do you want to proceed?";
var OrgSettings_Home_PublishModal_Link_PluralLinks$1 = "Link ({{ linkCount }} links)";
var OrgSettings_Home_PublishModal_Link_PluralLinksPluralSegments$1 = "Link ({{ linkCount }} links and {{ segmentCount }} segments)";
var OrgSettings_Home_PublishModal_Link_PluralLinksSingleSegment$1 = "Link ({{ linkCount }} links and {{ segmentCount }} segment)";
var OrgSettings_Home_PublishModal_Link_SingleLink$1 = "Link ({{ linkCount }} link)";
var OrgSettings_Home_PublishModal_Link_SingleLinkPluralSegments$1 = "Link ({{ linkCount }} link and {{ segmentCount }} segments)";
var OrgSettings_Home_PublishModal_Link_SingleLinkSingleSegment$1 = "Link ({{ linkCount }} link and {{ segmentCount }} segment)";
var OrgSettings_HomeDescription$1 = "Configure the learner home page to your organization's needs.";
var OrgSettings_HomeInsightCards$1 = "Insight Cards";
var OrgSettings_HomeLinksSection$1 = "Links Section";
var OrgSettings_HomeOrgAnnouncement$1 = "Organization Announcement";
var OrgSettings_HomePageTile$1 = "Home";
var OrgSettings_HomeSectionsReorderSuccess$1 = "Home sections successfully reordered.";
var OrgSettings_InApp_GroupDesc$1 = "In-App Messages display at the top of a learner’s feed.";
var OrgSettings_InApp_GroupDisplayName$1 = "In-app Messages";
var OrgSettings_InAppTips_Desc$1 = "In-App tips and tours guide learners through key functionality.";
var OrgSettings_InAppTips_Name$1 = "In-App Tips";
var OrgSettings_InsightCardsMaximum$1 = "{{numberOfCards}} card maximum";
var OrgSettings_InsightCardsPublishUpdateSuccess$1 = "Insight card publishing successfully updated.";
var OrgSettings_InsightCardsReorderSuccess$1 = "Insight cards successfully reordered.";
var OrgSettings_InsightCardsSaveSingleSuccess$1 = "Insight card successfully saved.";
var OrgSettings_InsightCardsSaveSuccess$1 = "Insight cards successfully saved.";
var OrgSettings_InsightCardsUnpublishSingleSuccess$1 = "Insight card successfully unpublished.";
var OrgSettings_InsightCardsUnpublishSuccess$1 = "Insight cards successfully unpublished.";
var OrgSettings_IntegrationEmailSettings_Desc$1 = "Enables all email notifications for Provider Integration failures. Add one email per line.";
var OrgSettings_IntegrationEmailSettings_Name$1 = "Provider Integration Failure Emails";
var OrgSettings_InternalLink$1 = "Internal Link";
var OrgSettings_IsClientProvider_Desc$1 = "This is a HBP specific org setting that will hide several features HBP including: Global Add, Quick Add (dashboard), organization FAQ tab, cloning for pathways, group posts, Integrations tab on profile, links to Degreed button on empty state collection page, Featured Providers on browse (pending implementation), Featured Content on browse (pending implementation), and Shows ‘New Content’ on browse (pending implementation).";
var OrgSettings_IsClientProvider_Name$1 = "Client Provider";
var OrgSettings_IsDefaultCatalog_Desc$1 = "Set the Internal catalog as the default catalog for users in search and browse.";
var OrgSettings_IsDefaultCatalog_Name$1 = "Default to Internal Catalog";
var OrgSettings_KeepManagerGroupsInSync_Desc$1 = "When a user file is uploaded, update the manager relationships. If manager groups is turned on also update group membership accordingly.";
var OrgSettings_KeepManagerGroupsInSync_Name$1 = "Sync Manager Relationships";
var OrgSettings_LearningFeeds$1 = "Learning Feeds";
var OrgSettings_LimitGroupFeedActions_Desc$1 = "Items in group feed will be limited to Group Posts, Recommendations, and Assigned items.";
var OrgSettings_LimitGroupFeedActions_Name$1 = "Limit Group Feed Items";
var OrgSettings_LinkButtonPlaceholder$1 = "e.g 'Visit Page'; 'View More'...";
var OrgSettings_LinkButtonTitle$1 = "Button Title";
var OrgSettings_LinkDescription$1 = "Link Description";
var OrgSettings_LinkDescriptionPlaceholder$1 = "Add a short description to explain what your link is about";
var OrgSettings_LinkDescriptionRequired$1 = "A link description is required.";
var OrgSettings_LinkInternalUrlPlaceholder$1 = "Search for a plan, pathway or content item.";
var OrgSettings_LinkInternalUrlRequired$1 = "An internal link is required.";
var OrgSettings_LinkPlaceholder$1 = "Add Link Title";
var OrgSettings_LinkSaveSuccess$1 = "Link was successfully saved.";
var OrgSettings_LinkSegmentRequired$1 = "A segment is required.";
var OrgSettings_LinkSegments$1 = "Segments";
var OrgSettings_LinkSegmentsDescription$1 = "Degreed segments help your organization target the right audience for this link.";
var OrgSettings_LinkSegmentsTooltip$1 = "Search {{orgName}} Segments";
var OrgSettings_LinkSelectSource$1 = "Select Link Source";
var OrgSettings_LinkTitle$1 = "Link Title";
var OrgSettings_LinkTitleDuplicateError$1 = "This link title is already used in this card. Please enter a different link title.";
var OrgSettings_LinkTitleRequired$1 = "A link title is required.";
var OrgSettings_LinkUseSegments$1 = "Use Segments";
var OrgSettings_LockProfilePrivacy_Desc$1 = "Lock Profile Privacy";
var OrgSettings_LockProfilePrivacy_Name$1 = "Lock Profile Privacy";
var OrgSettings_LockSkillManagerRatingVisibility_Desc$1 = "Ensures all future Manager Ratings are Private (Limited Visibility if opted into Skill Coach) and does not allow users to change the visibility.";
var OrgSettings_LockSkillManagerRatingVisibility_Name$1 = "Lock Skill Manager Ratings to Private";
var OrgSettings_LockSkillPeerRatingVisibility_Desc$1 = "Ensures all future Peer Ratings are Private (Limited Visibility if opted into Skill Coach) and does not allow users to change the visibility.";
var OrgSettings_LockSkillPeerRatingVisibility_Name$1 = "Lock Skill Peer Ratings to Private";
var OrgSettings_LockSkillSelfRatingVisibility_Desc$1 = "Ensures all future Self-Ratings are Private (Limited Visibility if opted into Skill Coach) and does not allow users to change the visibility.";
var OrgSettings_LockSkillSelfRatingVisibility_Name$1 = "Lock Skill Self-Ratings to Private";
var OrgSettings_LU_AdminUserId_Desc$1 = "The unique numeric identifier of a LearnUpon admin user, who receives the summary email";
var OrgSettings_LU_AdminUserId_Name$1 = "LearnUpon Admin User ID";
var OrgSettings_LU_ApiBaseUrl_DefaultText$1 = "https://yourdomain.learnupon.com/api/v1/";
var OrgSettings_LU_ApiBaseUrl_Desc$1 = "LearnUpon Base Api Url to POST csv file.";
var OrgSettings_LU_ApiBaseUrl_Name$1 = "API URI";
var OrgSettings_LU_ApiPassword_Desc$1 = "Api Password for LearnUpon";
var OrgSettings_LU_ApiPassword_Name$1 = "API Password";
var OrgSettings_LU_ApiUsername_Desc$1 = "Api Username for LearnUpon";
var OrgSettings_LU_ApiUsername_Name$1 = "API Username";
var OrgSettings_LU_BulkGroupSync_Desc$1 = "If set to true, indicates you want a full group sync: default is false";
var OrgSettings_LU_BulkGroupSync_Name$1 = "Batch Group Sync";
var OrgSettings_LU_BulkInviteUsers_Desc$1 = "If set to true, indicates you are inviting, not creating, users: default is false, to create users";
var OrgSettings_LU_BulkInviteUsers_Name$1 = "Batch Invite Users";
var OrgSettings_LU_BulkProcessUnenrollments_Desc$1 = "If set to true, the attribute unenrolls users from courses and paths, when you remove users from groups: default is false. Requires group_sync set to true";
var OrgSettings_LU_BulkProcessUnenrollments_Name$1 = "Batch Process Unenrollment";
var OrgSettings_LU_BulkUpdateUsers_Desc$1 = "Indicates if existing users should be updated as well as creating/inviting new users.";
var OrgSettings_LU_BulkUpdateUsers_Name$1 = "Batch Update Users";
var OrgSettings_LU_CustomDataColumns_Desc$1 = "List of custom user data attributes configured in LearnUpon.";
var OrgSettings_LU_CustomDataColumns_Name$1 = "Custom User Attributes";
var OrgSettings_LU_DefaultEnabled_Desc$1 = "Indicates if users should be enabled.";
var OrgSettings_LU_DefaultEnabled_Name$1 = "User Enabled Default";
var OrgSettings_LU_DefaultExpires_Desc$1 = "Indicates the default expires date to use. Format should be mm/dd/yyyy";
var OrgSettings_LU_DefaultExpires_Name$1 = "User Expires Default";
var OrgSettings_LU_DefaultGroupSync_Desc$1 = "Indicates the value to use for the group_sync column";
var OrgSettings_LU_DefaultGroupSync_Name$1 = "User Group Default";
var OrgSettings_LU_DefaultMustChangePassword_Desc$1 = "Indicates if users must change password after first login.";
var OrgSettings_LU_DefaultMustChangePassword_Name$1 = "User MustChangePassword Default";
var OrgSettings_LU_DefaultPassword_Desc$1 = "Indicates the default user password to assign";
var OrgSettings_LU_DefaultPassword_Name$1 = "User Password Default";
var OrgSettings_LU_GroupSync_Name$1 = "Default Group Sync";
var OrgSettings_MarketplaceWarning_Default$1 = "You are now visiting the Degreed Marketplace. This marketplace contains paid content from external content providers.";
var OrgSettings_MarketplaceWarning_Desc$1 = "This message appears when learners choose to view the Degreed Marketplace.";
var OrgSettings_MarketplaceWarning_Name$1 = "Marketplace Warning";
var OrgSettings_MaxDescription$1 = "Make this description as short as possible ({{max}} characters max.)";
var OrgSettings_MaxInputDescription$1 = "Make this {{input}} as short as possible ({{char}} characters max.)";
var OrgSettings_MaxTitleDescription$1 = "Make this title as short as possible ({{max}} characters max.)";
var OrgSettings_MentionInComment_Desc$1 = "Notifies learners when they have been tagged in a takeaway.";
var OrgSettings_MentionInComment_Name$1 = "@Mention";
var OrgSettings_MinimumAggregatedLearningInsightsUserCount_Desc$1 = "Specifies the minimum count of users required for aggregated learning insights data to be shown";
var OrgSettings_MinimumAggregatedLearningInsightsUserCount_Name$1 = "Minimum Aggregated Learning Insights User Count";
var OrgSettings_MinimumSkillUserCount_Desc$1 = "Specifies the minimum count of users required for aggregated skill data to be shown";
var OrgSettings_MinimumSkillUserCount_Name$1 = "Minimum Skill User Count";
var OrgSettings_MobileBiometricAuth_Desc$1 = "Enables biometric authentication capabilities in the mobile app. Customize the biometric authentication timeout by modifying the OAuth Refresh Token Timeout for Mobile app setting.";
var OrgSettings_MobileBiometricAuth_Name$1 = "Biometric Authentication for Mobile Devices";
var OrgSettings_MobileClientSessionTimeout_Desc$1 = "Allowing for Biometric login on the mobile app. This will work best with a longer OAuthSessionTimeout and have this session timeout shorter to trigger a biometric login to refresh the session. Resulting in a secure and longer session for the end user.";
var OrgSettings_MobileClientSessionTimeout_Name$1 = "Biometric Session Timeout for Mobile app";
var OrgSettings_MonthlyActivity_Error$1 = "A learning metric is required for this card. Select one from the dropdown menu.";
var OrgSettings_MonthlyActivityDescription$1 = "Monthly Activity helps learners track their monthly learning effort in Degreed.";
var OrgSettings_MonthlyActivityTypes_ItemsCompleted$1 = "Items Completed";
var OrgSettings_MonthlyActivityTypes_ItemsViewed$1 = "Items Viewed";
var OrgSettings_MonthlyActivityTypes_LearningDuration$1 = "Learning Duration";
var OrgSettings_MonthlyActivityTypes_PointsEarned$1 = "Points Earned";
var OrgSettings_MonthlyActivityWithType$1 = "Monthly Activity ({{ type }})";
var OrgSettings_NewLink$1 = "New Link";
var OrgSettings_NotificationEmails_GroupDesc$1 = "Sends an email to learners about each of the following events as they occur.";
var OrgSettings_NotificationEmails_GroupDisplayName$1 = "Notification Emails";
var OrgSettings_NotRecommended$1 = "Not Recommended";
var OrgSettings_OAuthRefreshTokenTimeout_Desc$1 = "Controls the OAuth refresh token timeout and defaults to 60 days. Override the default by entering a custom timeout in minutes. This will be used by the API and the mobile apps only. This value should be longer than the OAuth Access Token Timeout for API and Mobile App, as it provides a grace period for refreshing the session without reauthenticating once the OAuth Access Token Timeout for API and Mobile App period has elapsed.";
var OrgSettings_OAuthRefreshTokenTimeout_Name$1 = "OAuth Refresh Token Timeout for API and Mobile app";
var OrgSettings_OAuthSessionTimeout_Desc$1 = "Controls the OAuth access token timeout and defaults to 5 minutes. Override the default by entering a custom timeout in minutes. This will be used by the API and mobile apps only. This value should be significantly shorter than the OAuth Refresh Token Timeout for API and Mobile App to force the client to reauthenticate using the refresh token on a regular basis. This value must be shorter than the refresh token timeout to allow the refresh token to function properly (suggested time is between 5-10 minutes).";
var OrgSettings_OAuthSessionTimeout_Name$1 = "OAuth Access Token Timeout for API and Mobile app";
var OrgSettings_Onboarding_GroupDesc$1 = "Emails sent to new learners in Degreed to help them get started.";
var OrgSettings_Onboarding_GroupDisplayName$1 = "Onboarding Emails";
var OrgSettings_OnboardingExperience$1 = "Onboarding Experience";
var OrgSettings_OnboardingExperience_GroupDesc$1 = "Customize the first page of the onboarding experience.";
var OrgSettings_OnboardingExperience_GroupDisplayName$1 = "Onboarding Messaging";
var OrgSettings_OnboardingMessage_Default$1 = "Begin by uploading your resume to automatically populate past job roles and skills.";
var OrgSettings_OnboardingMessage_Desc$1 = "This message appears below the onboarding title.";
var OrgSettings_OnboardingMessage_Name$1 = "Onboarding Message";
var OrgSettings_OnboardingRateSkillsIsMandatory_Desc$1 = "Require a minimum number of skills to be rated when onboarding";
var OrgSettings_OnboardingRateSkillsIsMandatory_Name$1 = "Onboarding Skill Rating is Mandatory";
var OrgSettings_OnboardingTitle_Default$1 = "Craft your profile for personalized resources tailored to your role, skills, and goals.";
var OrgSettings_OnboardingTitle_Desc$1 = "This is the primary message of your organization's onboarding experience.";
var OrgSettings_OnboardingTitle_Name$1 = "Onboarding Title";
var OrgSettings_OnboardingWelcomeGreeting_Desc$1 = 'Show "Welcome [First Name]" above the onboarding title.';
var OrgSettings_OnboardingWelcomeGreeting_Name$1 = "Welcome Greeting";
var OrgSettings_OpportunitiesActivityStartDate_Desc$1 = "The date (and time) at which to start calculating and showing activities for opportunities. This should be a UTC formatted string, default set to '2021-10-05T00:00:00Z' (midnight on October 5th 2021).";
var OrgSettings_OpportunitiesActivityStartDate_Name$1 = "Opportunities Activity Start Date";
var OrgSettings_OrganizationEmailFromName_Desc$1 = "When turned on, the Sender Preview will show 'Degreed at {org name}' instead of just '{org name}'.";
var OrgSettings_OrganizationEmailFromName_Name$1 = "Sender Preview";
var OrgSettings_OrganizationEmailLogo_Desc$1 = "Store a different version of the organization logo for email usage.";
var OrgSettings_OrganizationEmailLogo_Name$1 = "Organization Email Logo";
var OrgSettings_OrgIntroEmailMessage_Desc$1 = "Two emails will be sent to each learner after the learner's account is created. The first email will include the login email address and the second email will include the default password. This email should only enabled for organizations that are using username and password to login to Degreed. To enable this feature, enter a custom message for the email.";
var OrgSettings_OrgIntroEmailMessage_Name$1 = "Username/Password Instructions";
var OrgSettings_OrgSupportInfoCustomLink_Desc$1 = "Include a link to your organization’s own help resources.";
var OrgSettings_OrgSupportInfoCustomLink_Name$1 = "Custom Link";
var OrgSettings_OrgSupportInfoCustomLink_Placeholder$1 = "Short name of the resource";
var OrgSettings_OrgSupportInfoCustomLinkURL_Placeholder$1 = "http://resourceurl.com";
var OrgSettings_OrgSupportInfoEmail_Desc$1 = "Add a custom support email address for your organization.";
var OrgSettings_OrgSupportInfoEmail_Label$1 = "Email Address";
var OrgSettings_OrgSupportInfoEmail_Name$1 = "Email Address";
var OrgSettings_OrgSupportInfoEmail_Placeholder$1 = "support@your-organization.com";
var OrgSettings_OrgSupportInfoFaq_Desc$1 = "Add a custom FAQ link. If a custom FAQ link is not added, this setting defaults to Degreed’s FAQ when enabled.";
var OrgSettings_OrgSupportInfoFaq_Label$1 = "Frequently Asked Questions URL";
var OrgSettings_OrgSupportInfoFaq_Name$1 = "Frequently Asked Questions";
var OrgSettings_OrgSupportInfoFaq_Placeholder$1 = "http://resourceurl.com";
var OrgSettings_OrgSupportInfoLinkText_Label$1 = "Link Name";
var OrgSettings_OrgSupportInfoLinkText_Placeholder$1 = "Short name of the resource";
var OrgSettings_OrgSupportInfoLinkURL_Label$1 = "Link URL";
var OrgSettings_OrgSupportInfoLinkURL_Placeholder$1 = "http://resourceurl.com";
var OrgSettings_OrgSupportInfoPhone_Desc$1 = "Add a custom phone number.  If a phone number is not added, this setting defaults to Degreed's support phone number when enabled.";
var OrgSettings_OrgSupportInfoPhone_Label$1 = "Phone Number";
var OrgSettings_OrgSupportInfoPhone_Name$1 = "Phone Number";
var OrgSettings_OrgSupportInfoPhone_Placeholder$1 = "800.311.7061";
var OrgSettings_OtherEmails_GroupDesc$1 = "Emails to drive engagement with Degreed.";
var OrgSettings_OtherEmails_GroupDisplayName$1 = "Other Emails";
var OrgSettings_PasswordExpirationPeriod_DefaultText$1 = "Input custom expiration period in Days";
var OrgSettings_PasswordExpirationPeriod_Desc$1 = "The number of days before a password expires can be customized here.";
var OrgSettings_PasswordExpirationPeriod_Name$1 = "Password Expiration Time Period";
var OrgSettings_PathwayFeedbackSurvey_Desc$1 = "Displays a checkbox in the pathway modal to users with the Manage Org Pathway permission to let learners rate pathway content.";
var OrgSettings_PathwayFeedbackSurvey_Name$1 = "Pathway Feedback Survey";
var OrgSettings_PermissionRoles_Desc$1 = "Add on creation: Only update the user’s role on user creation. When the user is created, use the Role in the file if passed in the file or if no role is passed in the file, assign user the default (Member) role. Update every time: Update the user’s role every time a file is loaded when the role is passed in the file. If no role passed in file, then don't update.";
var OrgSettings_PermissionRoles_Name$1 = "Permission Roles";
var OrgSettings_PersistSessionCookie_Desc$1 = "When user is signing in, this denotes if the session should be persistent.";
var OrgSettings_PersistSessionCookie_Name$1 = "Persist Session Cookie";
var OrgSettings_PointsDecommission_Desc$1 = "Hides points from profile activity, profile learning summary, completion action buttons, and learning insight cards in skill coach.";
var OrgSettings_PointsDecommission_Name$1 = "Points Decommission";
var OrgSettings_PreventPublicProfiles_Desc$1 = "Hides the “Public” profile option from the user profile for everyone in the organization (prevents users from setting their profile as public).";
var OrgSettings_PreventPublicProfiles_Name$1 = "Prevent Public Profiles";
var OrgSettings_PrivacyChangeToOrganizationMessage_Default$1 = "By changing your profile to 'Visible to my organization only', the following information will be available to {{OrgName}} users on this platform:<br/><br/><strong>Your name</strong>, <strong>your learning collection</strong> ({{OrgNameSingular}} members), <strong>your insights</strong> (including leader board information).<br/><br/>Non-{{OrgNameSingular}} users will not be able to follow you (i.e. be informed of your learning activity).";
var OrgSettings_PrivacyChangeToOrganizationMessage_Desc$1 = "Profile privacy message displayed when learner changes profile privacy to visible to org.";
var OrgSettings_PrivacyChangeToOrganizationMessage_Name$1 = "Visible to Organization Profile Message";
var OrgSettings_PrivacyChangeToPrivateMessage_Default$1 = "By changing your profile to private, the following information will no longer be visible to public or {{OrgName}} users on this platform:<br/><br/><strong>Your name</strong>, <strong>your learning collection</strong> ({{OrgName}} content will not be visible to non-{{OrgNameSingular}} members), <strong>your insights</strong> (including leader board information).<br/><br/>Other users will no longer be able to follow you (i.e. be informed of your learning activity).";
var OrgSettings_PrivacyChangeToPrivateMessage_Desc$1 = "Profile privacy message displayed when user changes profile privacy to visible to private.";
var OrgSettings_PrivacyChangeToPrivateMessage_Name$1 = "Private Profile Message";
var OrgSettings_PrivacyChangeToPublicMessage_Default$1 = "By changing your profile to public, the following information will become visible to public (external to all {{OrgName}} users on this platform):<br/><br/><strong>Your name</strong>, <strong>your learning collection</strong> ({{OrgName}} content will not be visible to non-{{OrgNameSingular}} members), and <strong>your insights</strong> (including leader board information).<br/><br/>Other public users will also be able to follow you (i.e. be informed of your learning activity).";
var OrgSettings_PrivacyChangeToPublicMessage_Desc$1 = "Profile privacy message displayed when user changes profile privacy to visible to public.";
var OrgSettings_PrivacyChangeToPublicMessage_Name$1 = "Public Profile Message";
var OrgSettings_PrivacySettings$1 = "Privacy Settings";
var OrgSettings_ProfileOverviewTabDefault_Desc$1 = "Set the default skills summary that is shown on the profile overview.  This does not apply to public profile being viewed by anonymous users.";
var OrgSettings_ProfileOverviewTabDefault_Name$1 = "Default Skill Summary on Profile Overview";
var OrgSettings_ProfileOverviewTabDefault_Selection_Focus$1 = "Focus Skills";
var OrgSettings_ProfileOverviewTabDefault_Selection_Top$1 = "Top skills (default)";
var OrgSettings_ProfilePrivacyUpdate_GroupDesc$1 = "This message appears when a learner makes changes to their profile privacy setting.";
var OrgSettings_ProfilePrivacyUpdate_GroupDisplayName$1 = "Profile Privacy Change Warnings";
var OrgSettings_Providers_Desc$1 = "When a user import file is uploaded: Add will append to the user's existing. Replace will overwrite/replace the user's existing.";
var OrgSettings_Providers_Name$1 = "Providers";
var OrgSettings_PublishCards$1 = "Publish Cards";
var OrgSettings_PublishCardsAriaText$1 = "Please update at least one card in order to publish";
var OrgSettings_PublishCardsSingleSuccess$1 = "Insight card successfully published.";
var OrgSettings_PublishCardsSuccess$1 = "Insight cards were successfully published.";
var OrgSettings_PublishChanges$1 = "Publish Changes";
var OrgSettings_QuickLinks$1 = "Quick Links";
var OrgSettings_RapRedirectUrl_Desc$1 = "When turned on, all Report A Problem tickets will be redirected to a custom URL.  This will also bypass any support tickets usually sent to Degreed Support.";
var OrgSettings_RapRedirectUrl_Label$1 = "Custom URL";
var OrgSettings_RapRedirectUrl_Name$1 = "Enable URL Redirect";
var OrgSettings_RapRedirectUrl_Placeholder$1 = "Enter a URL";
var OrgSettings_RateSkillsEmail_Desc$1 = "Prompts learners to rate their skills.";
var OrgSettings_RateSkillsEmail_Name$1 = "Onboarding Email Day 7: Measure Your Skills";
var OrgSettings_RatingsVisibilityPublic_Desc$1 = "Enable to allow Ratings to be Publicly visible across the organization.";
var OrgSettings_Recommendations_Desc$1 = "Notifies learners when another person has shared content with them.";
var OrgSettings_Recommendations_Name$1 = "New Shares";
var OrgSettings_RemoveCard$1 = "Remove Card";
var OrgSettings_RemoveCardConfirmation$1 = "You will be losing all custom information already added to this card if you decided to remove it.";
var OrgSettings_RemoveCardConfirmation_Body$1 = "You will be losing all custom information already added to this card if you decide to remove it.";
var OrgSettings_RemoveCardProceed_Confirm$1 = "Would you like to proceed?";
var OrgSettings_ReorderCards$1 = "Reorder Cards";
var OrgSettings_ReorderCardsAriaText$1 = "Please add at least two cards to enable reordering";
var OrgSettings_ReorderHomeSections$1 = "Reorder Home Sections";
var OrgSettings_ReorderInsightCards$1 = "Reorder Insight Cards";
var OrgSettings_ReorderInvalidCardsAriaText$1 = "Please ensure all card fields are valid to enable reordering";
var OrgSettings_ReplyToComment_Desc$1 = "Notifies learners when another person has replied to their takeaway.";
var OrgSettings_ReplyToComment_Name$1 = "Reply";
var OrgSettings_ReportAProblem_GroupDesc$1 = "Redirect users to a custom URL for all Report A Problem tickets.";
var OrgSettings_ReportAProblem_GroupDisplayName$1 = "Report A Problem URL Redirect";
var OrgSettings_ReportEmailSettings_Desc$1 = "Enables all email notification for FTP outbound failure files. Add one email per line.";
var OrgSettings_ReportEmailSettings_Name$1 = "Outbound Report Failure Emails";
var OrgSettings_ReportingDateFormat_Desc$1 = 'The date time format for report filenames.  Default: "yyyyMMddHHmmss"';
var OrgSettings_ReportingDateFormat_Name$1 = "Date Time Format";
var OrgSettings_ReportingFTPConnection_Name$1 = "Client Reporting FTP Connection Settings";
var OrgSettings_ReportingOrganizationNameAlias_Desc$1 = "Used to override the Org name that is part of a reports filename.";
var OrgSettings_ReportingOrganizationNameAlias_Name$1 = "Organization Name Alias";
var OrgSettings_ReportingTimeZone_Desc$1 = 'Reports will be ran with UTC time by default. Use this to override to a different timezone. Ex: "Mountain Standard Time" or "West Asia Standard Time"';
var OrgSettings_ReportingTimeZone_Name$1 = "Reporting Time Zone";
var OrgSettings_RequireInternalCredentialReviews_Desc$1 = "This org flag is only relevant for organizations using Skill Certification. When enabled, only fellow employees will be able to do peer reviews.";
var OrgSettings_RequireInternalCredentialReviews_Name$1 = "Require Internal Skill Certification Reviews";
var OrgSettings_ResetAcceptance$1 = "Reset message for all users";
var OrgSettings_ResetDefaultMessage$1 = "Reset default message";
var OrgSettings_ResetPrivacyAcceptanceHeader$1 = "Reset 'Enforce Data Privacy Acceptance' Message";
var OrgSettings_ResetPrivacyAcceptanceSuccess$1 = "The Data Privacy message has been reset";
var OrgSettings_ResetPrivacyAcceptanceWarning$1 = "You are about to reset this message for all users. Do you want to continue?";
var OrgSettings_RestrictDuplicateEmailsOnUserFile_Desc$1 = "This flag will reject any rows that have a duplicate email value in a ClientUser file. (Ex: If two rows have duplicate emails, both of those values should be rejected)";
var OrgSettings_RestrictDuplicateEmailsOnUserFile_Name$1 = "Restrict Duplicate Emails";
var OrgSettings_RestrictExtension_Desc$1 = "Disables the Personal settings Extension page and usage of extension and bookmarklet";
var OrgSettings_RestrictExtension_Name$1 = "Disable Extension/Bookmarklet";
var OrgSettings_RestrictITunesExternalPodcastLinks_Desc$1 = "This disables the ability for users to launch itunes podcast from links found in the catalog. User can still see the podcast link, but can't launch the content. We do not recommend this feature to be disabled for clients. (Only BofA has this set)";
var OrgSettings_RestrictITunesExternalPodcastLinks_Name$1 = "Disable Links to External iTunes Podcasts";
var OrgSettings_RestrictMobileApp_Desc$1 = "Blocks access to logging into the Degreed mobile app.\nBlocks SINA message and pop up that go to the Mobile app.";
var OrgSettings_RestrictMobileApp_Name$1 = "Restrict Mobile App";
var OrgSettings_RestrictMobileAppInChina_Desc$1 = "Blocks access to logging into the Degreed mobile app for users in China. Change this setting only after approval from the privacy team.";
var OrgSettings_RestrictMobileAppInChina_Name$1 = "Restrict Mobile App in China (CLIENT SIGNATURE REQUIRED)";
var OrgSettings_RunRulesSkippedRecords_Desc$1 = "New Business Rules Processor only. Forces business rules to be run on inbound record even when no changes are detected.";
var OrgSettings_RunRulesSkippedRecords_Name$1 = "Run Business Rules on Skipped Records";
var OrgSettings_SavedLinks$1 = "Saved Links";
var OrgSettings_SavedLinksCount$1 = "Saved Links: {{numberOfSavedLinks}}";
var OrgSettings_Security_ApiSectionDescription$1 = "This setting will apply to any API tokens created";
var OrgSettings_Security_ApiSectionTitle$1 = "API Access Token";
var OrgSettings_Security_ApiTimeoutDescription$1 = "This will be the length of time an API token will be valid until a new one has to be generated. (max. 60 days, default = 60 days)";
var OrgSettings_Security_ApiTimeOutError$1 = "Value must be longer than {{min}} minutes and shorter than {{max}} minutes.";
var OrgSettings_Security_ApiTimeOutResetAriaLabel$1 = "Reset API access token timeout Duration";
var OrgSettings_Security_ApiTimeoutTitle$1 = "Access Token";
var OrgSettings_Security_ChromeSectionDescription$1 = "This setting will apply to all users using the Degreed Chrome Extension.";
var OrgSettings_Security_ChromeSectionTitle$1 = "Chrome Extension";
var OrgSettings_Security_ChromeTimeoutDescription$1 = "Regardless of activity, the user will be forced to log in after this period. (max. 365 days, default = 60 days)";
var OrgSettings_Security_ChromeTimeOutResetAriaLabel$1 = "Reset Chrome Timeout Duration";
var OrgSettings_Security_ChromeTimeoutTitle$1 = "Chrome Extension Timeout";
var OrgSettings_Security_ExtensionTimeOutError$1 = "Value must be longer than {{min}} minutes and shorter than {{max}} minutes.";
var OrgSettings_Security_InactivityTimeOutDescription$1 = "How long a session cookie will remain active after it has been idle. (min. 2 minutes, max. 100 days, default = 14 days)";
var OrgSettings_Security_InactivityTimeOutError$1 = "Value must be longer than 2 minutes and shorter than 100 days.";
var OrgSettings_Security_InactivityTimeOutIntervalAriaLabel$1 = "Inactivity Timeout Interval";
var OrgSettings_Security_InactivityTimeOutResetAriaLabel$1 = "Reset Inactivity Timeout Duration";
var OrgSettings_Security_InactivityTimeOutTitle$1 = "Inactivity Time-Out";
var OrgSettings_Security_LoginTimeOutDescription$1 = "Regardless of how long the user is active, they will have to re-login after this period of time. (min. 2 minutes, max. 365 days, default = 30 days)";
var OrgSettings_Security_LoginTimeOutError$1 = "Value must be longer than 2 minutes and shorter than 365 days.";
var OrgSettings_Security_LoginTimeOutIntervalAriaLabel$1 = "Login Timeout Interval";
var OrgSettings_Security_LoginTimeOutResetAriaLabel$1 = "Reset Login Timeout Duration";
var OrgSettings_Security_LoginTimeOutTitle$1 = "Log In Time-Out";
var OrgSettings_Security_LogOutAllUsers$1 = "Log Out All Users";
var OrgSettings_Security_LogOutWarningText$1 = "Publishing these changes will cause all of your users to be logged out. They will have to re-enter their credentials to be log back in.";
var OrgSettings_Security_MobileSectionDescription$1 = "This setting will apply to all users accessing the system through native mobile apps downloaded through the Android  or IOS app stores";
var OrgSettings_Security_MobileSectionTitle$1 = "Mobile Apps";
var OrgSettings_Security_MobileTimeoutDescription$1 = "Regardless of activity, users will be forced to login after the period. (max. 365 days, default = 60 days)";
var OrgSettings_Security_MobileTimeOutError$1 = "Value must be longer than {{min}} minutes and shorter than {{max}} minutes.";
var OrgSettings_Security_MobileTimeOutResetAriaLabel$1 = "Reset Mobile Timeout Duration";
var OrgSettings_Security_MobileTimeoutTitle$1 = "Mobile Timeout";
var OrgSettings_Security_NonPersistentSessionDescription$1 = "If a user closes their browser their session will expire. A user's browser settings can impact this setting.";
var OrgSettings_Security_NonPersistentSessionTitle$1 = "Non-Persistent Session";
var OrgSettings_Security_PageTitle$1 = "Security";
var OrgSettings_Security_PersistentSessionDescription$1 = "Allows the user to retain their session cookie when re-opening the browser on the same device.";
var OrgSettings_Security_PersistentSessionTitle$1 = "Persistent Session";
var OrgSettings_Security_SessionCookieModeTitle$1 = "Session Cookie Mode";
var OrgSettings_Security_WebSectionDescription$1 = "These settings will apply to all users accessing the system through a traditional web or mobile web browser.";
var OrgSettings_Security_WebSectionTitle$1 = "Web App";
var OrgSettings_SegmentsDuplicateError$1 = "The following segment(s) have already been used for a different link in this card: {{segments}}. Please choose another segment.";
var OrgSettings_SegmentsMaxError$1 = "Up to {{maxNumberOfSegments}} segments can be added";
var OrgSettings_SelectLearningMetric$1 = "Select Learning Metric";
var OrgSettings_SelectLearningMetricPlaceholder$1 = "Select the learning metric you want to show learners";
var OrgSettings_SendAllRapTicketsToClient_Desc$1 = "When enabled, this sends all report-a-problem tickets to the client listed Tier 1 email addresses";
var OrgSettings_SendAllRapTicketsToClient_Name$1 = "Send All Report-A-Problem Tickets to Client";
var OrgSettings_ServiceNowIntegrationConfiguration_Desc$1 = "When configured, Tier 1 support tickets will be sent into a client’s ServiceNow instance";
var OrgSettings_ServiceNowIntegrationConfiguration_Name$1 = "ServiceNow Integration Configuration";
var OrgSettings_SessionTimeoutAbsoluteConfig_Desc$1 = 'Specifies the longest time in minutes a user can be authenticated despite activity or sliding expirations and the display unit (Minutes, Hours, or Days) to use on the administering page. The following is an example of the expected JSON format: {"SessionTimeoutAbsoluteDisplayUnit":"Days","SessionTimeoutAbsoluteMinutes":10080}';
var OrgSettings_SessionTimeoutAbsoluteConfig_Name$1 = "Absolute Session Timeout Config";
var OrgSettings_SessionTimeoutInactivityConfig_Desc$1 = 'Specifies the session timeout in minutes for user inactivity and the display unit (Minutes, Hours, or Days) to use on the administering page. The following is an example of the expected JSON format: {"SessionTimeoutInactivityDisplayUnit":"Hours","SessionTimeoutInactivityMinutes":10080}';
var OrgSettings_SessionTimeoutInactivityConfig_Name$1 = "Inactive Session Timeout Config";
var OrgSettings_SetEvaluationsPrivateByDefault_Desc$1 = "Visibility of completed Skill Reviews is set to public by default. When checked, the visibility of newly completed Skill Reviews will be set to private by default.";
var OrgSettings_SetEvaluationsPrivateByDefault_Name$1 = "Set Skill Reviews Private by Default";
var OrgSettings_ShouldTransformTaxonomy_Desc$1 = "This setting determines if Title Casing and other transformations will be applied to Jobs and Skills Taxonomy";
var OrgSettings_ShouldTransformTaxonomy_Name$1 = "Apply Transformations to Taxonomy";
var OrgSettings_ShowAllProvidersInSearchFacet_Desc$1 = "Used for browse & search. It controls what values are returned in the provider facet. Show all the internal (preferred) providers whether we found results for those providers w/ the specified search term or not. So a 0 would show up for the preferred provider even if no results were found. ";
var OrgSettings_ShowAllProvidersInSearchFacet_Name$1 = "Show Org Providers in Search even if 0 found";
var OrgSettings_ShowCookiePolicyLink_Desc$1 = "Add a link to the Degreed cookie notice";
var OrgSettings_ShowCookiePolicyLink_Name$1 = "Cookie Notice";
var OrgSettings_ShowExternalContentWarning_Default$1 = "You are continuing to the External catalog comprising public sources and external content providers not owned or vetted by your company.";
var OrgSettings_ShowExternalContentWarning_Desc$1 = "This message appears when learners choose to view external resources instead of your organization's internal catalog.";
var OrgSettings_ShowExternalContentWarning_Name$1 = "External Catalog Warning";
var OrgSettings_ShowGroupMembershipSource_Desc$1 = "The method in which a user joined the group.";
var OrgSettings_ShowGroupMembershipSource_Name$1 = "Show Group Membership Source";
var OrgSettings_ShowSlackIntegration_Desc$1 = "Allow users to connect the Degreed Slack integration to their accounts.";
var OrgSettings_ShowSlackIntegration_Name$1 = "Slack Integration";
var OrgSettings_Size$1 = "Size";
var OrgSettings_SizeKiloByte$1 = "Size (KB)";
var OrgSettings_SkillCoachFullOrgAccess_Desc$1 = 'Ignores pre-release groups and turns on the feature for all managers. ("Activate Skill Coach" must also be activated)';
var OrgSettings_SkillCoachFullOrgAccess_Name$1 = "Activate Skill Coach for Entire Organization";
var OrgSettings_SkillInventoryClientOverride_Desc$1 = "This setting is only relevant for new orgs using the free-public skill inventory product and overrides but does not change any default LXP settings. This limits the org to selected skill measurement tools and insights.";
var OrgSettings_SkillInventoryClientOverride_Name$1 = "Skill Inventory Client Override";
var OrgSettings_Skills_Desc$1 = "When opportunities are imported via file or integration this option will either adds\\appends skills to the opportunity in Degreed or replace the skills in Degreed.";
var OrgSettings_Skills_Name$1 = "Add\\Replace Skills";
var OrgSettings_SkillsCheckupEmail_Desc$1 = "When enabled, this email goes out to all employees of the organization every 3 months prompting the employee to update their skill ratings for the skills they have added to their profile.";
var OrgSettings_SkillsCheckupEmail_Name$1 = "Skills Checkup Email";
var OrgSettings_SkipEmailLookup_Desc$1 = "During user file processing, do not use email as an identifier to find an existing account";
var OrgSettings_SkipEmailLookup_Name$1 = "Skip Email Lookup";
var OrgSettings_SocialNotify_Desc$1 = "Notifies learners when another person has started following them.";
var OrgSettings_SocialNotify_Name$1 = "New Follower";
var OrgSettings_SocialSettings$1 = "Social Settings";
var OrgSettings_SsoAutoCreateProfile_Desc$1 = "Automatically create a Degreed account when a user signs in via the SSO provider.";
var OrgSettings_SsoAutoCreateProfile_Name$1 = "Auto-Create User Accounts via SSO";
var OrgSettings_SuggestInternalContentOnly_Desc$1 = "Content in the Degreed feed can come from: Pathways in the External catalog\nWhen this setting is enabled, Pathways from the external catalog will not be included in feed results for learners. Since external pathways are the only external catalog content that can be shown in the feed, this affectively removes external catalog content from feed results.";
var OrgSettings_SuggestInternalContentOnly_Name$1 = "Suggest Internal Content Only";
var OrgSettings_SuggestTags_Desc$1 = "Display skills in search results.";
var OrgSettings_SuggestTags_Name$1 = "Suggest Skills in Search";
var OrgSettings_SuggestTargets_Desc$1 = "Display Plans and Directories in Search and Browse Results.";
var OrgSettings_SuggestTargets_Name$1 = "Suggest Plans and Directories in Search and Browse";
var OrgSettings_SupportTargets_Desc$1 = "Enables Plans for an organization. If disabled, both Plans and Career Pathing will not work for the organization.";
var OrgSettings_SupportTargets_Name$1 = "Plans (Note: Disabling this will disable Career Pathing)";
var OrgSettings_Tier1UserSupportTicketsEmailSettings_Desc$1 = "Email user-reported problems to the following list of addresses. One email address per line.";
var OrgSettings_Tier1UserSupportTicketsEmailSettings_Name$1 = "Tier1 User Support Tickets Emails";
var OrgSettings_ToggleOff$1 = "{{settingName}} is turned off.";
var OrgSettings_ToggleOn$1 = "{{settingName}} is turned on.";
var OrgSettings_TotalInstance$1 = "Total Instance";
var OrgSettings_TotalInstanceCount_PluralFormat$1 = "{{ count }} Instances";
var OrgSettings_TotalInstanceCount_Single$1 = "1 Instance";
var OrgSettings_TotalInstances$1 = "Total Instances";
var OrgSettings_TotalRow$1 = "Total Row";
var OrgSettings_TotalRows$1 = "Total Rows";
var OrgSettings_TotalRowsCount_PluralFormat$1 = "{{ count }} rows";
var OrgSettings_TotalRowsCount_Single$1 = "1 row";
var OrgSettings_TrackLearning_Desc$1 = "Informs learners they can mark items complete in the feed.";
var OrgSettings_TrackLearning_Name$1 = "Track Learning";
var OrgSettings_TrackLearningOnGo_Desc$1 = "Informs learners there is a mobile app for learning on the go.";
var OrgSettings_TrackLearningOnGo_Name$1 = "Track Learning on the Go (mobile learning)";
var OrgSettings_UnpublishCards$1 = "Unpublish Cards";
var OrgSettings_UntitledLinkTitle$1 = "Untitled Link";
var OrgSettings_UpdateCard$1 = "Update Card";
var OrgSettings_UpdateEmails_GroupDesc$1 = "Default settings only for new Degreed users. These settings do not affect email settings for current users";
var OrgSettings_UpdateEmails_GroupDisplayName$1 = "Default Update Email Settings";
var OrgSettings_UpdatePublishing$1 = "Update Publishing";
var OrgSettings_UpdateUserTagRatings_Desc$1 = "Prompts learners to update their skill ratings.";
var OrgSettings_UpdateUserTagRatings_Name$1 = "Enable Skills Checkup";
var OrgSettings_UpdateUserTagRatingsEmail_Desc$1 = "When enabled, this email goes out to all employees of the organization every 3 months prompting the employee to update their skill ratings for the skills they have added to their profile.";
var OrgSettings_UpdateUserTagRatingsEmail_Name$1 = "Skills Checkup Email";
var OrgSettings_UpdateUserTags_Desc$1 = "Prompts learners to review and change their learning topics.";
var OrgSettings_UpdateUserTags_Name$1 = "Update Skills";
var OrgSettings_UrlScanExemptDomains_Desc$1 = "Administrators can enter domains and subdomains in this field to be excluded in the URL scans for Broken Links. When a domain or subdomain is excluded, the Manage Broken Links tab will not report any errors on those links.";
var OrgSettings_UrlScanExemptDomains_Name$1 = "URL Scan Excluded Domains";
var OrgSettings_UseInternalJobSkills_Desc$1 = "When this flag is enabled, Degreed will use the organization's jobs and skills taxonomy rather than Degreed's for Onboarding and when building Plans and Role Plans. This feature makes sense for an organization that has a comprehensive and robust taxonomy of jobs at their company with associated skills. Few organizations would want this feature turned on. ";
var OrgSettings_UseInternalJobSkills_Name$1 = "Use Organization's Job Skills";
var OrgSettings_UserNotificationEmail_Desc$1 = "Emails triggered by events as they occur in Degreed";
var OrgSettings_UserNotificationEmail_Name$1 = "Notification Emails";
var OrgSettings_UseZendeskWebWidget_Desc$1 = "Enable Zendesk Web Widget for this organization";
var OrgSettings_UseZendeskWebWidget_Name$1 = "Use Zendesk Web Widget";
var OrgSettings_WeeklySummaryEmail_Desc$1 = "A weekly email with learning recommendations and Degreed activity";
var OrgSettings_WeeklySummaryEmail_Name$1 = "Weekly Digest";
var OrgSettings_WelcomeEmail_Desc$1 = "An engagement email that is sent to all new learners of Degreed to help get them started using Degreed.";
var OrgSettings_WelcomeEmail_Name$1 = "Onboarding Email Day 1: Welcome to Degreed";
var OrgSettings_WelcomeIntro_Desc$1 = "Degreed onboarding experience and welcome tour that helps a learner set up their profile and get started on Degreed.";
var OrgSettings_WelcomeIntro_Name$1 = "New Learner Welcome Tour";
var OrgSettings_WeMissYouEmail_Desc$1 = "An engagement email sent to learners who have been inactive in Degreed for 30 days.";
var OrgSettings_WeMissYouEmail_Name$1 = "We Miss You Email";
var OrgSettings_WhatSkillsEmail_Desc$1 = "The goal of this email is to help new learners realize Degreed is about building skills - prompts learners to add skills to their profile.";
var OrgSettings_WhatSkillsEmail_Name$1 = "Onboarding Email Day 2: What Skills do you Need?";
var OrgSettings_WhitelistedDomains_Desc$1 = "Administrators can designate specific domains to be recognized as hosting internal content. This allows administrators to not only designate specific domains, but also use wildcards to capture related subdomains.";
var OrgSettings_WhitelistedDomains_Name$1 = "Allowed Domains";
var OrgSettings_WhiteListFtpAccessIpAddresses_Desc$1 = "Only a user with the listed IP Addresses may access this org’s FTP files";
var OrgSettings_WhiteListFtpAccessIpAddresses_Name$1 = "Whitelist FTP Access through IP Addresses";
var OrgSettings_ZendeskWidgetKey_Desc$1 = "Sets the Zendesk Widget Key (Managed by EEs) that controls which bot version is used by the widget.";
var OrgSettings_ZendeskWidgetKey_Name$1 = "Zendesk Web Widget Key";
var OrgSecurityCtrl_CreateGroups$1 = "Create Groups";
var OrgSecurityCtrl_DefaultRoleTextFormat$1 = 'The default role for new members of your organization is "{{name}}"';
var OrgSecurityCtrl_RolesUpdatedSuccessMessage$1 = "Organization roles updated successfully.";
var OrgReportSchedule_Frequency_Daily$1 = "Daily (every day)";
var OrgReportSchedule_Frequency_DailyMondayThruFriday$1 = "Daily (Mon-Fri)";
var OrgReportSchedule_Frequency_Monthly$1 = "Monthly (sent on the 1st)";
var OrgReportSchedule_Frequency_Quarterly$1 = "Quarterly (sent on the 1st)";
var OrgReportSchedule_Frequency_WeeklyOnMonday$1 = "Weekly (sent on Mon)";
var OrgReportSchedule_Frequency_WeeklyOnSunday$1 = "Weekly (sent on Sun)";
var OrgReportingCtrl_All$1 = "All";
var OrgReportingCtrl_AllCompletedContent$1 = "All Completed Content";
var OrgReportingCtrl_AllGroups$1 = "All groups";
var OrgReportingCtrl_AllSkills$1 = "All Skills";
var OrgReportingCtrl_AllTopics$1 = "All Skills";
var OrgReportingCtrl_And$1 = "and";
var OrgReportingCtrl_Count$1 = "Count";
var OrgReportingCtrl_DateMaxValidation$1 = "Please select no more than 365 days";
var OrgReportingCtrl_DateMaxValidationFormat$1 = "Please select no more than {{numDays}} days";
var OrgReportingCtrl_DownloadableReports$1 = "Downloadable Reports";
var OrgReportingCtrl_ErrorWithProvider$1 = "There is something wrong with this provider";
var OrgReportingCtrl_ExternalCatalog$1 = "External Catalog";
var OrgReportingCtrl_ExternalContent$1 = "External Content";
var OrgReportingCtrl_FilterByGroup$1 = "Filter by group";
var OrgReportingCtrl_FilterByLocation$1 = "Filter by location";
var OrgReportingCtrl_FilterByOrg$1 = "Filter by organization";
var OrgReportingCtrl_FilterBySkill$1 = "Filter by skill";
var OrgReportingCtrl_FullCatalog$1 = "Full Catalog";
var OrgReportingCtrl_InputsAdded$1 = "Inputs Added";
var OrgReportingCtrl_Insights$1 = "Insights";
var OrgReportingCtrl_InternalCatalog$1 = "Internal Catalog";
var OrgReportingCtrl_InternalContent$1 = "Internal Content";
var OrgReportingCtrl_ItemsAdded$1 = "Items Added";
var OrgReportingCtrl_KpiItemsAddedName$1 = "Completed Items";
var OrgReportingCtrl_KpiItemsAddedTooltip$1 = "Includes any content marked complete during this period";
var OrgReportingCtrl_KpiLoginsName$1 = "Active Users";
var OrgReportingCtrl_KpiLoginsTooltip$1 = "An active user is someone who has logged in at least once in this period";
var OrgReportingCtrl_KpiOrgExpertsName$1 = "Experts in {{metricSecondary}} skills";
var OrgReportingCtrl_KpiOrgExpertsTooltip$1 = "This is the number of learners who have a 6-8 rating in any skill, and the number of skills those learners have 6-8 ratings in.";
var OrgReportingCtrl_KpiRecommendationsName$1 = "Shared Items";
var OrgReportingCtrl_KpiRecommendationsTooltip$1 = "Includes content shared with individuals or groups in this period";
var OrgReportingCtrl_KPIS_Error$1 = "We ran into a problem while trying to load your KPIs.";
var OrgReportingCtrl_KpiSkillRatedUsersName$1 = "Rated in at least 1 skill";
var OrgReportingCtrl_KpiSkillRatedUsersTooltip$1 = "This is the percentage of learners who have one or more skill ratings. Higher percentages mean that skill insights include more of your learners.";
var OrgReportingCtrl_KpiViewsName$1 = "Viewed Items";
var OrgReportingCtrl_KpiViewsTooltip$1 = "Includes content and achievement items viewed during this period";
var OrgReportingCtrl_LearningSummary$1 = "Learning Summary";
var OrgReportingCtrl_Members$1 = "Members";
var OrgReportingCtrl_MinimumAggregatedLearningInsightsUserCount$1 = "All groups that have fewer than {{number}} users will not show up in this list.";
var OrgReportingCtrl_Name$1 = "Name";
var OrgReportingCtrl_NoMatchingGroups$1 = "No matching groups found";
var OrgReportingCtrl_NoMatchingLocations$1 = "No matching locations found";
var OrgReportingCtrl_NoMatchingOrgs$1 = "No matching orgs found";
var OrgReportingCtrl_NoMatchingSkills$1 = "No matching skills found";
var OrgReportingCtrl_NoMatchingStatus$1 = "No matching status found";
var OrgReportingCtrl_NoMatchingTypes$1 = "No matching types found";
var OrgReportingCtrl_NoResults$1 = "Your filters returned no results";
var OrgReportingCtrl_Points$1 = "Points";
var OrgReportingCtrl_ResultsFormat$1 = "{{count}} results";
var OrgReportingCtrl_ShouldNotBeConnected$1 = "This provider should no longer be connected";
var OrgReportingCtrl_TimesAdded$1 = "Times Added";
var OrgReportingCtrl_TopResultsFormat$1 = "Top {{count}} results";
var OrgReportingCtrl_TotalContentViewed$1 = "Total content viewed";
var OrgReportingCtrl_TotalItemsAdded$1 = "Total items added";
var OrgReportingCtrl_TotalPointsEarned$1 = "Total points earned";
var OrgRatingScaleChange_NotificationContent$1 = "{{ orgName }}'s rating proficiency scale has been updated. Please review your\nskills for accuracy.\n{{ viewNewRatingScaleHtml }}";
var OrgRatingScaleChange_NotificationDescription$1 = "Your organization's Skill Rating Levels changed from an {{oldRatingScale}}-point Skill Rating scale to a new {{newRatingScale}}-point Skill Rating scale. This change helps to optimize skill development and align your skill data to your organization.";
var OrgRatingScaleChange_NotificationTitle$1 = "New Skill Rating Levels";
var orgProviderLicenseModal_ContinueButtonFormat$1 = "Continue to {{providerName}}";
var orgProviderLicenseModal_CreatedLicenseFormat$1 = "We've created your {{providerName}} license.";
var orgProviderLicenseModal_InstructionsFormat$1 = "Access is required for this provider.";
var orgProviderLicenseModal_LicenseErrorFormat$1 = "We had a problem creating a {{providerName}} license for you. Please try again or {{anchorOpen}}go straight to free content{{anchorClose}}.";
var orgProviderLicenseModal_MessageErrorFormat$1 = "Whoops! We weren’t able to access your licensing agreement. You can return to Search {{anchorOpen}} here {{anchorClose}}.";
var OrgPlans_AddTargetOrDirectory$1 = "Add a Plan or Directory";
var OrgPlans_AllTypes$1 = "Types";
var OrgPlans_BundleInfo$1 = "Directories cannot be assigned to bundles.  If you would like to bulk add to bundles, please update your selections.";
var OrgPlans_ChooseType$1 = "Would you like to create a Plan or Directory?";
var OrgPlans_ChooseTypeHelpFormat$1 = "If you are not sure, {{aStart}}learn more about them{{aEnd}}";
var OrgPlans_CloneBrowse$1 = "Clone Browse";
var OrgPlans_CloneDirectory$1 = "Clone Directory";
var OrgPlans_ClonePlan$1 = "Clone Plan";
var OrgPlans_CloneRole$1 = "Clone Role";
var OrgPlans_CloneTarget$1 = "Clone Plan";
var OrgPlans_CreateBulkRoles$1 = "Or {{startButton}}create multiple plans{{endButton}} with a template";
var OrgPlans_CreatedBy$1 = "Created by";
var OrgPlans_CreateDirectory$1 = "Create Directory";
var OrgPlans_CreateRole$1 = "Create Role";
var OrgPlans_CreateTarget$1 = "Create Plan";
var OrgPlans_CreateTargetOrDirectory$1 = "Create a Plan or Directory";
var OrgPlans_CustomTitlesAndDescriptionsNotLocalized$1 = "Custom titles and descriptions will not be localized.";
var OrgPlans_CustomTitlesAndTextNotLocalized$1 = "Custom titles and text will not be localized.";
var OrgPlans_DeletePluralPrompt$1 = "Are you sure you want to delete {{ count }} plans?";
var OrgPlans_DeletePrompt$1 = "Are you sure you want to delete 1 plan?";
var OrgPlans_Description$1 = "Description";
var OrgPlans_DescriptionPlaceholder$1 = "Short description about the plan";
var OrgPlans_Directory$1 = "Directory";
var OrgPlans_DirectoryDescription$1 = "A navigation page to help people find plans";
var OrgPlans_DirectoryDescriptionPlaceholder$1 = "The Finance department has a mission";
var OrgPlans_DirectoryImageAlt$1 = "Figure of a directory";
var OrgPlans_DirectoryTitlePlaceholder$1 = "e.g. Finance";
var OrgPlans_DisplayTypePlaceholder$1 = "Used for Career Pathing";
var OrgPlans_EditBrowse$1 = "Edit Browse";
var OrgPlans_EditDirectory$1 = "Edit Directory";
var OrgPlans_EditFeatured$1 = "Edit Featured";
var OrgPlans_EditFeaturedPermissionError$1 = "You do not have the required permissions to edit the Featured Plan. Contact your Degreed admin for access.";
var OrgPlans_EditRole$1 = "Edit Role Plan";
var OrgPlans_EditTarget$1 = "Edit Plan";
var OrgPlans_Featured$1 = "Featured";
var OrgPlans_FollowerCount$1 = "Followers";
var OrgPlans_ImageUpload$1 = "Image";
var OrgPlans_NoPlansAdded$1 = "No plans have been created for this organization.";
var OrgPlans_NoPlansFound$1 = "No plans match your search term.";
var OrgPlans_OnBrowseTooltip$1 = "This page will show up as a section on the Browse page";
var OrgPlans_OnFeaturedTooltip$1 = "This Plan displays as your organization’s Featured page in Degreed.";
var OrgPlans_Pages$1 = "Directories";
var OrgPlans_Parent$1 = "Parent";
var OrgPlans_Plan$1 = "Plan";
var OrgPlans_PlanDescription$1 = "A collection of items to help followers grow in a skill, role, or career track";
var OrgPlans_PlanImageAlt$1 = "Figure of a plan";
var OrgPlans_Plans$1 = "Plans";
var OrgPlans_Purpose$1 = "Purpose";
var OrgPlans_SetAsPrimaryPlan$1 = "Set as primary plan";
var OrgPlans_SkillPlanPlaceholder$1 = "Used for personal development";
var OrgPlans_Subtitle$1 = "Subtitle";
var OrgPlans_SubtitlePlaceholder$1 = "Mention a line of business or area of expertise";
var OrgPlans_SubtitleTooltip$1 = "Visible in cards on Plans";
var OrgPlans_TargetDescriptionPlaceholder$1 = "Short description about the plan";
var OrgPlans_Template$1 = "Template";
var OrgPlans_Title$1 = "Title";
var OrgPlans_TitlePlaceholder$1 = "e.g. Sales Manager";
var OrgPlans_Type$1 = "Type";
var OrgPlans_TypeBrowse$1 = "Browse";
var OrgPlans_TypeDirectory$1 = "Directory";
var OrgPlans_TypeFeatured$1 = "Featured";
var OrgPlans_TypeRole$1 = "Role Plan";
var OrgPlans_Types$1 = "Types";
var OrgPlans_TypeTarget$1 = "Plan";
var OrgPlans_Visibility$1 = "Visibility";
var OrgPathwayManagerCtrl_AddCollaborators$1 = "Add Collaborators";
var OrgPathwayManagerCtrl_AuthorColumn$1 = "Authors";
var OrgPathwayManagerCtrl_ConfirmDeleteButton$1 = "Yes, Delete Pathways";
var OrgPathwayManagerCtrl_Delete$1 = "Delete";
var OrgPathwayManagerCtrl_DeleteInstructions$1 = "Type {{delete}} in capital letters to confirm";
var OrgPathwayManagerCtrl_DeletePluralPrompt$1 = "Are you sure you want to delete {{ count }} pathways?";
var OrgPathwayManagerCtrl_DeletePrompt$1 = "Are you sure you want to delete 1 pathway?";
var OrgPathwayManagerCtrl_DeletePromptDescription$1 = "You cannot undo this action.";
var OrgPathwayManagerCtrl_EndorsedPathwaysDescription$1 = "Endorsed Pathways, and content items within the Pathway, are boosted in search results.";
var OrgPathwayManagerCtrl_EnrolledColumn$1 = "Enrolled";
var OrgPathwayManagerCtrl_FeaturedColumn$1 = "Featured";
var OrgPathwayManagerCtrl_FollowingColumn$1 = "Followers";
var OrgPathwayManagerCtrl_ItemsSelected$1 = "selected";
var OrgPathwayManagerCtrl_LastUpdatedColumn$1 = "Last Updated";
var OrgPathwayManagerCtrl_ManagePathwaysDescription$1 = "Add, edit, and delete Pathways, add Collaborators, edit Visibility, and add or remove Endorsements";
var OrgPathwayManagerCtrl_NameColumn$1 = "Name";
var OrgPathwayManagerCtrl_UpdateVisibility$1 = "Edit Visibility";
var OrgPathwayManagerCtrl_Visibility0$1 = "Collaborators";
var OrgPathwayManagerCtrl_Visibility1$1 = "Organization";
var OrgPathwayManagerCtrl_Visibility2$1 = "Groups";
var OrgPathwayManagerCtrl_Visibility3$1 = "Public Profile";
var OrgPathwayManagerCtrl_VisibilityColumn$1 = "Visibility";
var OrgOpportunity_EngagementInsights_Tab$1 = "Engagement Insights";
var OrgOpportunity_OpenInsights_Tab$1 = "Open Insights";
var OrgMembersCtrl_Admin$1 = "Admin";
var OrgMembersCtrl_AnonUsersCountFormat$1 = "{{count}} anonymous users";
var OrgMembersCtrl_AnonUsersCountSingle$1 = "1 anonymous user";
var OrgMembersCtrl_CountOfMembersFormat$1 = "{{count}} members";
var OrgMembersCtrl_DateJoined$1 = "Date Joined";
var OrgMembersCtrl_InviteMembers$1 = "Invite members";
var OrgMembersCtrl_InviteUsers$1 = "Invite users";
var OrgMembersCtrl_LastActive$1 = "Last Active";
var OrgMembersCtrl_MemberInfoErrorMsg$1 = "Sorry! There was a problem accessing member information.";
var OrgMembersCtrl_MemberSettingsText$1 = "Member settings";
var OrgMembersCtrl_Name$1 = "Name";
var OrgMembersCtrl_NoMembersMessage$1 = "No members in this organization match your search term";
var OrgMembersCtrl_People$1 = "People";
var OrgMembersCtrl_Points$1 = "Points";
var OrgMembersCtrl_Private$1 = "Private";
var OrgMembersCtrl_PrivateTooltip$1 = "Private profile";
var OrgMembersCtrl_PrivateToOrg$1 = "Private to Org";
var OrgMembersCtrl_Public$1 = "Public";
var OrgMembersCtrl_PublicTooltip$1 = "Visible to the public and the organization";
var OrgMembersCtrl_PublicToOrgTooltip$1 = "Visible to the organization";
var OrgMembersCtrl_ResendInvites$1 = "Re-send invites";
var OrgMembersCtrl_Role$1 = "Role";
var OrgMembersCtrl_SearchForMember$1 = "Search for a member";
var OrgMembersCtrl_SearchForUser$1 = "Search for a user";
var OrgMembersCtrl_SeatsRemainingFormat$1 = "{{count}} seat remaining";
var OrgMembersCtrl_SeatsRemainingPluralFormat$1 = "{{count}} seats remaining";
var OrgMembersCtrl_SeatsRemainingTooltip$1 = "This value is calculated by subtracting the number of Seats Used (Activated Users) from the Total Seats Available (as defined in your contract). Activated Users are users who logged in at least once, are not deleted, and are still associated with your organization";
var OrgMembersCtrl_UsersCountFormat$1 = "{{count}} users";
var OrgMembersCtrl_Visibility$1 = "Visibility";
var OrgMemberFormCtrl_ConfirmRemoval$1 = "Confirm removal";
var OrgMemberFormCtrl_ConfirmRemovalMessage$1 = "Are you sure you want to remove this user? If you do, your organization's data will be permanently removed from their profile.";
var OrgMemberFormCtrl_EmailPasswordReset$1 = "Email Password Reset Link";
var OrgMemberFormCtrl_EmailResetPasswordSuccessMessageFormat$1 = "Reset password email successfully sent to {{name}}";
var OrgMemberFormCtrl_Groups$1 = "Groups";
var OrgMemberFormCtrl_History$1 = "History";
var OrgMemberFormCtrl_MemberSince$1 = "{{firstName}} has been a member of this organization since {{dateJoined}}.";
var OrgMemberFormCtrl_None$1 = "(none)";
var OrgMemberFormCtrl_PasswordManagement$1 = "Password Management";
var OrgMemberFormCtrl_PendingMember$1 = "Pending Member";
var OrgMemberFormCtrl_RemovedMemberSuccessMessage$1 = "The user has been successfully removed.";
var OrgMemberFormCtrl_RemoveFromOrg$1 = "Remove From Organization";
var OrgMemberFormCtrl_Removing$1 = "Removing...";
var OrgMemberFormCtrl_ResetPasswordDesc$1 = "Email a password reset link to the user’s primary email address.";
var OrgMemberFormCtrl_ResetPasswordOnLogin$1 = "Require user to change password after first log in";
var OrgMemberFormCtrl_ResetPasswordToDefault$1 = "Reset Password to Default";
var OrgMemberFormCtrl_ResetPasswordToDefaultDesc$1 = "Reset the user’s password to the organization’s default. The user will be prompted to change their password the next time they log in.";
var OrgMemberFormCtrl_ResetPasswordToDefaultSuccess$1 = "Password successfully reset to the organization’s default";
var OrgMemberFormCtrl_Role$1 = "Role";
var OrgMemberFormCtrl_RolePermissions$1 = "{{name}} permissions: {{permissions}}";
var OrgMemberFormCtrl_Title$1 = "Edit User Settings";
var OrgMemberFormCtrl_UpdatedMemberRoleSuccessMessage$1 = "Updated role for {{name}}";
var OrgMemberFormCtrl_ViewUserSettings$1 = "View User Settings";
var OrgManage_AdvancedSSOCreated$1 = "Advanced - Integration SSO created.";
var OrgManage_Analytics_MenuItem_Label$1 = "Discover";
var OrgManage_Analytics_MenuItem_Text$1 = "Degreed Analytics";
var OrgManage_CollectorDisabled$1 = "The Collector has been disabled.";
var OrgManage_ConnectorDisabled$1 = "The Connector has been disabled.";
var OrgManage_ConnectorDisableFailed$1 = "Failed to disable the Connector.";
var OrgManage_Engage_MenuItem_Label$1 = "Automate";
var OrgManage_Engage_MenuItem_Text$1 = "Engage";
var OrgManage_EnterpriseProviderDisconnected$1 = "Enterprise provider disconnected.";
var OrgManage_Error_Get$1 = "Sorry! There was a problem retrieving the content.";
var OrgManage_ErrorCreatingProviderSSODetails$1 = "Failed to create the organization provider SSO details.";
var OrgManage_ErrorMessageCollectors$1 = "Failed to retrieve the Collectors.";
var OrgManage_ErrorMessageCollectorsOptions$1 = "Failed to retrieve the Collector Options.";
var OrgManage_ErrorMessageConnectors$1 = "Failed to retrieve Connectors.";
var OrgManage_ErrorMessageConnectorsOptions$1 = "Failed to retrieve the Connector options.";
var OrgManage_ErrorMessageIntegrationProviders$1 = "Failed to retrieve the list of all Integration Providers.";
var OrgManage_ErrorMessageProvider$1 = "Failed to retrieve the Provider.";
var OrgManage_ErrorMessageProviderDetails$1 = "Failed to retrieve the Provider details.";
var OrgManage_ErrorMessageProvidersList$1 = "Failed to retrieve the list of all Providers.";
var OrgManage_ErrorSavingMessageCollectorsOptions$1 = "Failed to save the collector Options.";
var OrgManage_ErrorSavingMessageConnectorsOptions$1 = "Failed to save the Connector options.";
var OrgManage_ErrorUpdatingProviderSSODetails$1 = "Failed to update the organization provider SSO details.";
var OrgManage_ExtendedEnterprise$1 = "Extended Enterprise";
var OrgManage_FailedProviderSSODetails$1 = "Failed to retrieve the provider SSO details.";
var OrgManage_FAQ_AddFAQ$1 = "Add FAQ";
var OrgManage_FAQ_Answer$1 = "Answer";
var OrgManage_FAQ_AnswerPlaceholder$1 = "Write the answer here";
var OrgManage_FAQ_ConfirmDelete$1 = "Are you sure you want to delete this FAQ?";
var OrgManage_FAQ_CreateFAQPage$1 = "Create an FAQ page";
var OrgManage_FAQ_CreateFAQPageInstructions$1 = "Add some frequently asked questions for your organization. Learners are able to view the FAQ page from the help menu.";
var OrgManage_FAQ_CustomizeFAQ$1 = "Customize the FAQ page for your organization.";
var OrgManage_FAQ_Delete$1 = "Delete FAQ";
var OrgManage_FAQ_Edit$1 = "Edit FAQ";
var OrgManage_FAQ_Error_CreateFAQ$1 = "There was an error creating the FAQ";
var OrgManage_FAQ_Error_DeleteFAQ$1 = "There was an error deleting the FAQ";
var OrgManage_FAQ_Error_GetFAQs$1 = "There was an error retrieving the FAQs.";
var OrgManage_FAQ_Error_UpdateFAQ$1 = "There was an error updating the FAQ";
var OrgManage_FAQ_FaqCreated$1 = "FAQ has been created";
var OrgManage_FAQ_FaqDeleted$1 = "The FAQ has been deleted";
var OrgManage_FAQ_FaqUpdated$1 = "FAQ has been updated";
var OrgManage_FAQ_MaxFAQsMsg$1 = "Some FAQs may not be shown";
var OrgManage_FAQ_NoFAQs$1 = "No FAQs exist for your organization right now.";
var OrgManage_FAQ_Question$1 = "Question";
var OrgManage_FAQ_QuestionPlaceholder$1 = "Write a frequently asked question here";
var OrgManage_FAQ_TryNarrowingSearch$1 = "Try narrowing your search.";
var OrgManage_LearningExperience$1 = "Learning Experience";
var OrgManage_Manage$1 = "Manage";
var OrgManage_MoreFormat$1 = "+ {{remainder}} others";
var OrgManage_OauthCredentials_apiKeyCreated$1 = "API Key Created";
var OrgManage_OauthCredentials_ApiKeyCreatedHeaderModal$1 = "Save your API Key";
var OrgManage_OauthCredentials_apiKeysTab$1 = "API Keys";
var OrgManage_OauthCredentials_clientKeyLabel$1 = "Client Id";
var OrgManage_OauthCredentials_clientPasswordLabel$1 = "Client Secret:";
var OrgManage_OauthCredentials_ConfirmDelete$1 = "Are you sure you want to revoke the credentials?";
var OrgManage_OauthCredentials_copiedClipboardTooltip$1 = "Copied!";
var OrgManage_OauthCredentials_copyAndSaveKey$1 = "Please copy this secret and save it somewhere safe";
var OrgManage_OauthCredentials_copyClipboardTooltip$1 = "Copy";
var OrgManage_OauthCredentials_Create$1 = "Create New";
var OrgManage_OauthCredentials_Created$1 = "The credentials have been created!";
var OrgManage_OauthCredentials_CreatedByLabel$1 = "Created by";
var OrgManage_OauthCredentials_CredentialsRevoked$1 = "The credentials have been revoked.";
var OrgManage_OauthCredentials_defaultEmptyProviderCode$1 = "[organization key]";
var OrgManage_OauthCredentials_Delete$1 = "Revoke API Key Credentials";
var OrgManage_OauthCredentials_descriptionPlaceholder$1 = "Description";
var OrgManage_OauthCredentials_EditCredentials$1 = "Modify API Key";
var OrgManage_OauthCredentials_editCredentialsTooltip$1 = "Edit Credentials";
var OrgManage_OauthCredentials_ErrorSavingCredentials$1 = "There was an error in saving the credentials";
var OrgManage_OauthCredentials_NamePlaceholder$1 = "Name";
var OrgManage_OauthCredentials_NewCredentials$1 = "Create New API Key";
var OrgManage_OauthCredentials_organizationKeysLabel$1 = "Organization Keys (Limit 2)";
var OrgManage_OauthCredentials_providerKeysLabel$1 = "Provider Keys (No Limit)";
var OrgManage_OauthCredentials_providerLabel$1 = "Provider";
var OrgManage_OauthCredentials_providerPlaceholder$1 = "Search for Providers";
var OrgManage_OauthCredentials_revokeTooltip$1 = "Revoke Credentials";
var OrgManage_OauthCredentials_Scope_completions$1 = "Completions";
var OrgManage_OauthCredentials_Scope_completionsRead$1 = "Read Completions";
var OrgManage_OauthCredentials_Scope_completionsWrite$1 = "Write Completions";
var OrgManage_OauthCredentials_Scope_content$1 = "Content";
var OrgManage_OauthCredentials_Scope_contentRead$1 = "Read Content";
var OrgManage_OauthCredentials_Scope_contentWrite$1 = "Write Content";
var OrgManage_OauthCredentials_Scope_customAttribute$1 = "Custom Attributes";
var OrgManage_OauthCredentials_Scope_Licenses$1 = "Licenses";
var OrgManage_OauthCredentials_Scope_ProviderUsers$1 = "Provider Users";
var OrgManage_OauthCredentials_Scope_r$1 = "R";
var OrgManage_OauthCredentials_Scope_read$1 = "Read";
var OrgManage_OauthCredentials_Scope_readCompletions$1 = "Read Completions";
var OrgManage_OauthCredentials_Scope_readContent$1 = "Read Content";
var OrgManage_OauthCredentials_Scope_readRequiredLearning$1 = "Read Required Learning";
var OrgManage_OauthCredentials_Scope_readUsers$1 = "Read Users";
var OrgManage_OauthCredentials_Scope_requiredLearning$1 = "Required Learning";
var OrgManage_OauthCredentials_Scope_requiredLearning_Bundles$1 = "Bundles";
var OrgManage_OauthCredentials_Scope_requiredLearning_Logins$1 = "Logins";
var OrgManage_OauthCredentials_Scope_requiredLearning_SharedItems$1 = "Shared Items";
var OrgManage_OauthCredentials_Scope_requiredLearning_SkillPlans$1 = "Skill Plans";
var OrgManage_OauthCredentials_Scope_requiredLearning_SkillRatings$1 = "Skill Ratings";
var OrgManage_OauthCredentials_Scope_requiredLearning_TodaysLearning$1 = "Today's Learning";
var OrgManage_OauthCredentials_Scope_requiredLearning_UserBadges$1 = "User Badges";
var OrgManage_OauthCredentials_Scope_requiredLearning_UserSkills$1 = "User Skills";
var OrgManage_OauthCredentials_Scope_requiredLearningRead$1 = "Read Required Learning";
var OrgManage_OauthCredentials_Scope_requiredLearningWrite$1 = "Write Required Learning";
var OrgManage_OauthCredentials_Scope_rw$1 = "R/W";
var OrgManage_OauthCredentials_Scope_SelfEnrolledLearning$1 = "Self Enrolled Learning";
var OrgManage_OauthCredentials_Scope_UserBadges$1 = "User Badges";
var OrgManage_OauthCredentials_Scope_users$1 = "Users";
var OrgManage_OauthCredentials_Scope_usersRead$1 = "Read Users";
var OrgManage_OauthCredentials_Scope_usersWrite$1 = "Write Users";
var OrgManage_OauthCredentials_Scope_write$1 = "Write";
var OrgManage_OauthCredentials_Scope_writeCompletions$1 = "Write Completions";
var OrgManage_OauthCredentials_Scope_writeContent$1 = "Write Content";
var OrgManage_OauthCredentials_Scope_writeRequiredLearning$1 = "Write Required Learning";
var OrgManage_OauthCredentials_Scope_writeUsers$1 = "Write Users";
var OrgManage_OauthCredentials_Scope_Xapi$1 = "xAPI";
var OrgManage_OauthCredentials_ScopesLabel$1 = "Scopes";
var OrgManage_OauthCredentials_Updated$1 = "The credentials have been updated!";
var OrgManage_OauthCredentials_warningManageCredentials$1 = "When you select Write scopes, you are automatically granted Read scopes. If you deselect Read, Write is automatically deselected.";
var OrgManage_OauthCredentials_wontShowKeyAgain$1 = "For security reasons we cannot show it to you again.";
var OrgManage_OneMore$1 = "+ 1 other";
var OrgManage_Opportunities_Add$1 = "Add Opportunity";
var OrgManage_Opportunities_AddCollaborators$1 = "Add Collaborators";
var OrgManage_Opportunities_AtLeastOneSkill$1 = "Add at least 1 skill";
var OrgManage_Opportunities_BulkChangeVisibility$1 = "Change visibility of 1 opportunity";
var OrgManage_Opportunities_BulkChangeVisibilityPlural$1 = "Change visibility of {{count}} opportunities";
var OrgManage_Opportunities_BulkCloseAllHeader$1 = "Close {{totalCount}} opportunities?";
var OrgManage_Opportunities_BulkClosedSuccess$1 = "{{allowedCount}} opportunities closed successfully";
var OrgManage_Opportunities_BulkCloseError$1 = "Sorry! There was a problem closing the opportunities.";
var OrgManage_Opportunities_BulkCloseExternalError$1 = "{{notAllowedCount}} external opportunities were not closed";
var OrgManage_Opportunities_BulkCloseHeader$1 = "Close {{allowedCount}} of {{totalCount}} opportunities?";
var OrgManage_Opportunities_BulkCloseNotify$1 = "Notify unselected candidates that they were not selected and the opportunity has been closed.";
var OrgManage_Opportunities_BulkCloseWarning$1 = "If you close these opportunities you will not be able to re-open them in the future. This can not be undone.";
var OrgManage_Opportunities_BulkCloseWarningExternal$1 = "*{{notAllowedCount}} external opportunities can not be closed.";
var OrgManage_Opportunities_BulkDeleteAllHeader$1 = "Delete {{totalCount}} opportunities?";
var OrgManage_Opportunities_BulkDeleteError$1 = "Sorry! There was a problem deleting the opportunities.";
var OrgManage_Opportunities_BulkDeleteExternalError$1 = "{{notAllowedCount}} external opportunities were not deleted";
var OrgManage_Opportunities_BulkDeleteExternalFail$1 = "{{notAllowedCount}} external opportunities were not deleted";
var OrgManage_Opportunities_BulkDeleteHeader$1 = "Delete {{allowedCount}} of {{totalCount}} opportunities?";
var OrgManage_Opportunities_BulkDeleteSuccess$1 = "{{allowedCount}} opportunities deleted successfully";
var OrgManage_Opportunities_BulkDeleteWarning$1 = "If you delete these they will be permanently removed.<br>This can not be undone.";
var OrgManage_Opportunities_BulkDeleteWarningExternal$1 = "*{{notAllowedCount}} external opportunities can not be deleted.";
var OrgManage_Opportunities_ChooseDurationType$1 = "Choose duration type";
var OrgManage_Opportunities_Close$1 = "Close";
var OrgManage_Opportunities_ClosedOnlyOpportunities$1 = "Only show closed opportunities";
var OrgManage_Opportunities_ClosePrompt_Description$1 = "If you close this opportunity you will not be able to re-open it in the future. This cannot be undone.";
var OrgManage_Opportunities_ClosePrompt_Header$1 = "Close {{ opportunityTitle }}?";
var OrgManage_Opportunities_ClosePrompt_NoSelect$1 = "Looks like you haven't selected anyone for this opportunity yet? Selecting candidates will help with history reporting";
var OrgManage_Opportunities_ClosePrompt_SendNotification$1 = "Notify unselected candidates that the opportunity was closed.";
var OrgManage_Opportunities_ClosePrompt_Title$1 = "Close {{ opportunityTitle }}?";
var OrgManage_Opportunities_Cols_Collaborators$1 = "Collaborators";
var OrgManage_Opportunities_Cols_Interested$1 = "Interested";
var OrgManage_Opportunities_Cols_LastUpdated$1 = "Last Updated";
var OrgManage_Opportunities_Cols_Skills$1 = "Skills";
var OrgManage_Opportunities_Cols_Source$1 = "Source";
var OrgManage_Opportunities_Cols_Title$1 = "Title";
var OrgManage_Opportunities_Cols_Type$1 = "Type";
var OrgManage_Opportunities_Cols_Visibility$1 = "Visibility";
var OrgManage_Opportunities_Create$1 = "Create Opportunity";
var OrgManage_Opportunities_DateCompare$1 = "Select a valid date";
var OrgManage_Opportunities_DatePicker$1 = "Pick a date";
var OrgManage_Opportunities_Delete$1 = "Delete";
var OrgManage_Opportunities_Delete_Confirmation$1 = "Deleting opportunities will remove them from all search results. Are you sure you want to delete them?";
var OrgManage_Opportunities_Delete_Confirmation_Singular$1 = "Deleting this opportunity will remove it from all search results. Are you sure you want to delete it?";
var OrgManage_Opportunities_Delete_Notice_Generic$1 = "This action will be permanent and cannot be undone:";
var OrgManage_Opportunities_Delete_Notice_Specific$1 = "You're about to delete the following opportunities.";
var OrgManage_Opportunities_Delete_Notice_Specific_Singular$1 = "You're about to delete the following opportunity.";
var OrgManage_Opportunities_Delete_Undeletable$1 = "These external opportunities cannot be deleted:";
var OrgManage_Opportunities_Delete_Undeletable_Singular$1 = "This external opportunity cannot be deleted:";
var OrgManage_Opportunities_DeleteOpportunities$1 = "Delete Opportunities";
var OrgManage_Opportunities_DeleteOpportunity$1 = "Delete Opportunity";
var OrgManage_Opportunities_DeletePrompt_Description$1 = "If you do, it will be removed from search results.";
var OrgManage_Opportunities_DeletePrompt_Title$1 = "Are you sure you would like to delete this opportunity?";
var OrgManage_Opportunities_DepartmentPlaceholder$1 = "Enter department related to opportunity";
var OrgManage_Opportunities_DescMaxChars$1 = "{{limit}} characters remaining";
var OrgManage_Opportunities_DescPlaceholder$1 = "Short description of the opportunity";
var OrgManage_Opportunities_Edit$1 = "Edit Opportunity";
var OrgManage_Opportunities_EditSkills$1 = "Edit Skills";
var OrgManage_Opportunities_EditTargetLevel$1 = "Edit Target Level";
var OrgManage_Opportunities_EditVisibility$1 = "Edit Visibility";
var OrgManage_Opportunities_Error_Add$1 = "Sorry! There was a problem adding the opportunity.";
var OrgManage_Opportunities_Error_Close$1 = "Sorry! There was a problem closing the opportunity.";
var OrgManage_Opportunities_Error_Delete$1 = "Sorry! There was a problem deleting the opportunity.";
var OrgManage_Opportunities_Error_Edit$1 = "Sorry! There was a problem updating the opportunity.";
var OrgManage_Opportunities_Error_EditCollaborators$1 = "Sorry! There was a problem adding collaborators.";
var OrgManage_Opportunities_Error_EditSkills$1 = "Sorry! There was a problem updating the opportunity's skills.";
var OrgManage_Opportunities_Error_EditVisibility$1 = "Sorry! There was a problem updating the visibility.";
var OrgManage_Opportunities_Error_Share$1 = "Sorry! There was a problem sharing the opportunity.";
var OrgManage_Opportunities_Filters_Current_Collaborator$1 = "{{fullName}} (you)";
var OrgManage_Opportunities_Filters_Status_closed$1 = "Closed";
var OrgManage_Opportunities_Filters_Status_open$1 = "Open";
var OrgManage_Opportunities_Invalid_Field$1 = "This field is not valid.";
var OrgManage_Opportunities_JobRoles_SkillAdded$1 = "{{numberOfSkills}} Skills added successfully based on the role '{{jobRoleName}}'";
var OrgManage_Opportunities_MoreFormat$1 = "and {{remainder}} more";
var OrgManage_Opportunities_NoItemsAdded$1 = "No opportunities have been added to this organization.";
var OrgManage_Opportunities_OfDays$1 = "# of days";
var OrgManage_Opportunities_OfHours$1 = "# of hours";
var OrgManage_Opportunities_OfMonths$1 = "# of months";
var OrgManage_Opportunities_OfWeeks$1 = "# of weeks";
var OrgManage_Opportunities_OneMore$1 = "and 1 more";
var OrgManage_Opportunities_OptIn$1 = "Opt In";
var OrgManage_Opportunities_OptIn_Description$1 = "By indicating that you are interested in this opportunity, you are giving permission for Degreed users within your organization who manage opportunities to see your <strong>name</strong>, <strong>email</strong>, <strong>location</strong>, <strong>job role</strong>, and <strong>skill information</strong>.";
var OrgManage_Opportunities_OptIn_Header$1 = "Opt in to opportunities?";
var OrgManage_Opportunities_Required_Field$1 = "This is a required field";
var OrgManage_Opportunities_SearchPlaceholder$1 = "Search {{count}} opportunities";
var OrgManage_Opportunities_ShowClosed$1 = "Show closed only";
var OrgManage_Opportunities_StartDatePlaceholder$1 = "Pick or enter a date";
var OrgManage_Opportunities_Success_Add$1 = "The opportunity '{{title}}' was added successfully!";
var OrgManage_Opportunities_Success_AddCollaboratorPluralToOpportunity$1 = "{{count}} collaborators added to 1 opportunity successfully.";
var OrgManage_Opportunities_Success_AddCollaboratorPluralToOpportunityPlural$1 = "{{collaboratorCount}} collaborators added to {{opportunityCount}} opportunities successfully.";
var OrgManage_Opportunities_Success_AddCollaboratorToOpportunity$1 = "1 collaborator added to 1 opportunity successfully.";
var OrgManage_Opportunities_Success_AddCollaboratorToOpportunityPlural$1 = "1 collaborator added to {{count}} opportunities successfully.";
var OrgManage_Opportunities_Success_Close$1 = "The opportunity '{{opportunityTitle}}' has been closed";
var OrgManage_Opportunities_Success_Delete$1 = "The opportunity '{{title}}' was deleted successfully!";
var OrgManage_Opportunities_Success_EditVisibility$1 = "Visibility edited for 1 opportunity successfully.";
var OrgManage_Opportunities_Success_EditVisibilityPlural$1 = "Visibility edited for {{count}} opportunities successfully.";
var OrgManage_Opportunities_Success_Update$1 = "The opportunity '{{title}}' was updated successfully!";
var OrgManage_Opportunities_Tab_Description$1 = "Description";
var OrgManage_Opportunities_Tab_Details$1 = "Details";
var OrgManage_Opportunities_Tab_Skills$1 = "Skills";
var OrgManage_Opportunities_ThreeToTenSkills$1 = "We recommend between 3 - 10 skills to help find the best matches";
var OrgManage_Opportunities_TitlePlaceholder$1 = "Enter title of the opportunity";
var OrgManage_Opportunities_TypePlaceholder$1 = "Select a type";
var OrgManage_Opportunities_Upload$1 = "Upload Opportunities";
var OrgManage_Opportunities_UploadDescription$1 = "You can upload multiple opportunities at once by including them in a file with the following template.";
var OrgManage_Opportunities_UploadError$1 = "Sorry! There was a problem uploading the opportunities.";
var OrgManage_Opportunities_UploadFile$1 = "Upload File";
var OrgManage_Opportunities_UploadOpportunities$1 = "Upload Opportunities";
var OrgManage_Opportunities_UploadSuccess$1 = "The file you uploaded is being processed. Changes based on this file may take up to 4 hours to appear in Degreed.";
var OrgManage_Opportunities_Valid_Date$1 = "Select a valid date";
var OrgManage_Opportunities_Valid_Duration$1 = "Enter valid duration";
var OrgManage_Opportunities_Valid_Duration_Type$1 = "Select duration type";
var OrgManage_Opportunities_Valid_Job_Role$1 = "Select a valid job role";
var OrgManage_Opportunities_Valid_MaxLength$1 = "This field is too long. Reduce by {{number}}.";
var OrgManage_Opportunities_Valid_MinLength$1 = "This field is too short. Add {{number}} characters.";
var OrgManage_Opportunities_VisibleCollaborators$1 = "Private to collaborators";
var OrgManage_Opportunities_VisibleGroups$1 = "Visible only for specific groups";
var OrgManage_Opportunities_VisibleOrganization$1 = "Visible to the entire organization";
var OrgManage_OrgProviders_Created$1 = "The Provider's Information has been Created";
var OrgManage_OrgProviders_createProviderButton$1 = "Add Provider";
var OrgManage_OrgProviders_createProviderLabel$1 = "Add Provider";
var OrgManage_OrgProviders_editOrgProviderTooltip$1 = "Edit Organization Provider";
var OrgManage_OrgProviders_ErrorMessage$1 = "There was an error saving the provider";
var OrgManage_OrgProviders_featuredColumnHeader$1 = "Featured";
var OrgManage_OrgProviders_globalLicenseColumnHeader$1 = "Global License";
var OrgManage_OrgProviders_hiddenColumnHeader$1 = "Hidden?";
var OrgManage_OrgProviders_hiddenLabel$1 = "Hidden";
var OrgManage_OrgProviders_licensingColumnHeader$1 = "Licensing";
var OrgManage_OrgProviders_LicensingConfirmation_DefaultDescription$1 = "Once completed, please allow between 24 and 36 hours for the completion(s) to be reflected in your Degreed profile. If you are in the process of implementing Success Factors, you will not be able to access this content.";
var OrgManage_OrgProviders_LicensingConfirmation_LicenseAlreadyRequested$1 = "You’ve sent a license request for this content.";
var OrgManage_OrgProviders_LicensingConfirmation_NoLicenseFound$1 = "We weren't able to access your licensing agreement for this provider.";
var OrgManage_OrgProviders_LicensingConfirmation_NoProviderFound$1 = "We weren't able to access this provider.";
var OrgManage_OrgProviders_LicensingConfirmation_PageTitle$1 = "License Confirmation for {{ ProviderName }}";
var OrgManage_OrgProviders_LicensingConfirmation_ProviderHeader$1 = "{{ ProviderName }} Licensing";
var OrgManage_OrgProviders_LicensingConfirmation_ProviderHomepage$1 = "Provider Homepage";
var OrgManage_OrgProviders_LicensingConfirmation_RequestLicense$1 = "Request License";
var OrgManage_OrgProviders_LicensingConfirmation_SearchForProviderContent$1 = "Search for Content";
var OrgManage_OrgProviders_providerNameColumnHeader$1 = "Provider Name";
var OrgManage_OrgProviders_providersLabel$1 = "Providers";
var OrgManage_OrgProviders_providersPlaceholder$1 = "Search Providers";
var OrgManage_OrgProviders_providersTab$1 = "Integrations";
var OrgManage_OrgProviders_Updated$1 = "The Provider's Information has been Updated";
var OrgManage_ProviderDisconnected$1 = "Provider disconnected.";
var OrgManage_ReportSchedule_AggregateRange$1 = "All time (Skill Reports are aggregate)";
var OrgManage_ReportSchedule_Cols_Frequency$1 = "Frequency";
var OrgManage_ReportSchedule_Cols_FtpConfig$1 = "FTP Configurations";
var OrgManage_ReportSchedule_Cols_LastExport$1 = "Last Export";
var OrgManage_ReportSchedule_Cols_ReportType$1 = "Report Type";
var OrgManage_ReportSchedule_Cols_TimePeriod$1 = "Time Period";
var OrgManage_ReportSchedule_Cols_Version$1 = "Version";
var OrgManage_ReportSchedule_ConfirmDelete$1 = "Are you sure you would like to delete this report schedule?";
var OrgManage_ReportSchedule_DownloadFolder$1 = "Scheduled reports are downloaded to your organization's FTP folder.";
var OrgManage_ReportSchedule_DuplicateReportScheduleError$1 = "The selected report has already been scheduled for the selected time period and frequency";
var OrgManage_ReportSchedule_EditReportSchedule$1 = "Edit Report Schedule";
var OrgManage_ReportSchedule_Error_DeleteSchedule$1 = "There was an error deleting the report schedule.";
var OrgManage_ReportSchedule_Error_GetDateRanges$1 = "There was an error retrieving available date ranges.";
var OrgManage_ReportSchedule_Error_GetFrequencies$1 = "There was an error retrieving available report frequencies.";
var OrgManage_ReportSchedule_Error_GetReportMethods$1 = "There was an error retrieving the available reports.";
var OrgManage_ReportSchedule_Error_GetSchedules$1 = "There was an error retrieving the report schedules.";
var OrgManage_ReportSchedule_Error_UpdateSchedule$1 = "There was an error in saving the report schedule.";
var OrgManage_ReportSchedule_Frequency_Daily$1 = "Daily (every day)";
var OrgManage_ReportSchedule_Frequency_DailyMondayThruFriday$1 = "Daily (Mon-Fri)";
var OrgManage_ReportSchedule_Frequency_Monthly$1 = "Monthly";
var OrgManage_ReportSchedule_Frequency_Quarterly$1 = "Quarterly";
var OrgManage_ReportSchedule_Frequency_WeeklyOnMonday$1 = "Weekly (sent on Mon)";
var OrgManage_ReportSchedule_Frequency_WeeklyOnSunday$1 = "Weekly (sent on Sun)";
var OrgManage_ReportSchedule_FTP$1 = "FTP";
var OrgManage_ReportSchedule_FtpConfig$1 = "Choose an FTP Configuration";
var OrgManage_ReportSchedule_NewReportSchedule$1 = "Add New Report Schedule";
var OrgManage_ReportSchedule_Range_Last10Days$1 = "Last 10 Days";
var OrgManage_ReportSchedule_Range_Last15Days$1 = "Last 15 Days";
var OrgManage_ReportSchedule_Range_Last1Days$1 = "Last 1 Day";
var OrgManage_ReportSchedule_Range_Last2Days$1 = "Last 2 Days";
var OrgManage_ReportSchedule_Range_Last30Days$1 = "Last 30 Days";
var OrgManage_ReportSchedule_Range_Last3Days$1 = "Last 3 Days";
var OrgManage_ReportSchedule_Range_Last60Days$1 = "Last 60 Days";
var OrgManage_ReportSchedule_Range_Last7Days$1 = "Last 7 Days";
var OrgManage_ReportSchedule_Range_Last90Days$1 = "Last 90 Days";
var OrgManage_ReportSchedule_Range_LastFullMonth$1 = "Last Full Month";
var OrgManage_ReportSchedule_Range_LastFullQuarter$1 = "Last Full Quarter";
var OrgManage_ReportSchedule_Range_LastFullYear$1 = "Last Full Year";
var OrgManage_ReportSchedule_Range_MonthToDate$1 = "Month-To-Date";
var OrgManage_ReportSchedule_Range_PreviousMonth$1 = "Previous Month";
var OrgManage_ReportSchedule_Range_PreviousQuarter$1 = "Previous Quarter";
var OrgManage_ReportSchedule_Range_QuarterToDate$1 = "Quarter-To-Date";
var OrgManage_ReportSchedule_Range_YearToDate$1 = "Year-To-Date";
var OrgManage_ReportSchedule_ReportMaximum$1 = "(10 report maximum)";
var OrgManage_ReportSchedule_ReportName$1 = "Report Name";
var OrgManage_ReportSchedule_ReportSchedule$1 = "Report Schedule";
var OrgManage_ReportSchedule_ScheduleAdded$1 = "The report schedule was created successfully!";
var OrgManage_ReportSchedule_ScheduleCreated$1 = "The report schedule was created successfully!";
var OrgManage_ReportSchedule_ScheduleDeleted$1 = "Report schedule deleted";
var OrgManage_ReportSchedule_ScheduleReport$1 = "Schedule Report";
var OrgManage_ReportSchedule_ScheduleUpdated$1 = "The report schedule has been updated!";
var OrgManage_ReportSchedule_SelectFrequency$1 = "Choose how often the report will run";
var OrgManage_ReportSchedule_SelectReportType$1 = "Select the type of report";
var OrgManage_ReportSchedule_SelectTimePeriod$1 = "Choose the time period";
var OrgManage_ReportSchedule_SelectVersion$1 = "Select the version";
var OrgManage_ReportSchedule_UploadFile$1 = "Upload File";
var OrgManage_SettingsError_OrgSupportInfoEmail_pattern$1 = "You must enter a custom email address outside of the @degreed.com domain to enable this setting.";
var OrgManage_SwitchTo$1 = "Switch To";
var OrgManage_UpdatedMessageCollectorsInformation$1 = "The Collector's Information has been Updated.";
var OrgManage_UpdatedMessageConnectorsInformation$1 = "The Connector's information has been updated.";
var OrgManage_UpdatedProviderRebranding$1 = "Provider rebranding updated.";
var OrgManage_UpdateUsers$1 = "Update Users";
var OrgManage_UploadOpportunitiesError$1 = "Sorry! There was a problem uploading the opportunities.";
var OrgManage_UploadUsers$1 = "Upload Users";
var orgInviteFlowModal_Compiling$1 = "Compiling your learning Feed";
var orgInviteFlowModal_DiscoverContentInfo$1 = "Discover content based on your network, groups, and interests to keep up with what your team is learning and follow industry trends.";
var orgInviteFlowModal_GotIt$1 = "Got it!";
var orgInviteFlowModal_GroupConversation$1 = "Group Conversation";
var orgInviteFlowModal_GroupConversations$1 = "Group conversations";
var orgInviteFlowModal_InviteMessageFormat$1 = "You've been invited to track your learning with <strong>{{orgName}}</strong> on Degreed!";
var orgInviteFlowModal_LearnAsTeam$1 = "Start learning as a team";
var orgInviteFlowModal_LetsGetStarted$1 = "Let's get started!";
var orgInviteFlowModal_PersonalizedLearning$1 = "Personalized learning";
var orgInviteFlowModal_PersonalLearning$1 = "Personal Learning";
var orgInviteFlowModal_Recommendations$1 = "Shares";
var orgInviteFlowModal_RecommendInfo$1 = "When you think a team member or group would benefit from a specific learning item, share it directly with them and it will appear in their learning view.";
var orgInviteFlowModal_ResendVerification$1 = "Resend Verification";
var orgInviteFlowModal_SeeMemberLearning$1 = "See what your team members are learning across your organization and groups";
var orgInviteFlowModal_SocialGroupFeed$1 = "Tell a team member why you shared learning with them or discuss something you found interesting from your organization or group feed.";
var orgInviteFlowModal_UnableToJoin$1 = "Unable to join organization";
var orgInviteFlowModal_UnableToJoin_Desc$1 = "Unable to join organization because you are already a member of another organization. Please log in with a different account to join this organization, or contact your organization's administrator for assistance.";
var orgInviteFlowModal_VerificationSentFormat$1 = "Verification email sent to <br><strong>{{userEmail}}</strong><br><br>Please click the verify link in the email to start using Degreed with the {{orgName}} organization.";
var orgInviteFlowModal_VerifyEmailFormat$1 = "yourname@{{verifyEmail}}";
var orgInviteFlowModal_VerifyInstructions$1 = "Please verify your email to get started";
var orgInternalContentVisibilitySelector_GroupVisibilityPlaceholder$1 = "Enter the name of an administrative group";
var orgInternalContentVisibilitySelector_OrgVisibilityPlaceholder$1 = "Enter the name of an open, closed, or private group";
var orgInternalContentVisibilitySelector_TargetGroupsLabel$1 = "Target specific groups (optional)";
var orgInternalContentVisibilitySelector_Title$1 = "Visibility";
var orgInternalContentVisibilitySelector_VisibleToGroups$1 = "Visible to specific groups";
var orgInternalContentVisibilitySelector_VisibleToOrganization$1 = "Visible to organization";
var OrgInternalContentSvc_DeletionConfirmationMessageFormat$1 = "Are you sure you want to delete <br> {{title}}?";
var OrgInternalContentSvc_InputType$1 = "(Content Type)";
var OrgInternalContentSvc_InternalContentError$1 = "Sorry! There was a problem accessing organization information.";
var OrgInternalContentSvc_ItemsDeletedSuccessMessage$1 = " items have been removed";
var OrgInternalContentSvc_ItemsDeletionError$1 = "We were unable to remove {{inputsCount}} items, please try again.";
var OrgInternalContentSvc_ItemsRestoredSuccessMessage$1 = "Restored {{inputsCount}} items";
var OrgInternalContentSvc_ItemsRestoreError$1 = "We were unable to restore {{inputsCount}} items, please try again.";
var OrgInternalContentSvc_ItemsUpdatedSuccessMessage$1 = "Updated {{inputsCount}} items";
var OrgInternalContentSvc_ItemsUpdateError$1 = "We were unable to update {{inputsCount}} items, please try again.";
var OrgInternalContentSvc_ItemUpdateDuplicateError$1 = "A duplicate input exists with URL: {{url}}";
var OrgInternalContentSvc_ItemWTitleDeletedSuccessMessage$1 = " has been deleted";
var OrgInternalContentSvc_ItemWTitleDeletionError$1 = "We were unable to remove {{title}}, please try again.";
var OrgInternalContentSvc_ProviderName$1 = "(Provider Name)";
var OrgInternalContentSvc_SingleItemUpdatedSuccessMessage$1 = "Updated 1 item";
var OrgInternalContentSvc_Summary$1 = "No Description";
var OrgInternalContentSvc_Tags$1 = "No Tags";
var OrgInternalContentSvc_Title$1 = "(Title)";
var OrgInternalContentModalCtrl_DuplicatesDescriptionLabel$1 = "Description:";
var OrgInternalContentModalCtrl_DuplicatesGroupsCount$1 = "{{count}} groups";
var OrgInternalContentModalCtrl_DuplicatesGroupsLabel$1 = "Groups:";
var OrgInternalContentModalCtrl_DuplicatesHeader$1 = "Duplicates ({{count}})";
var OrgInternalContentModalCtrl_DuplicatesTopicsCount$1 = "{{count}} skills";
var OrgInternalContentModalCtrl_DuplicatesTopicsLabel$1 = "Skills:";
var OrgInternalContentCtrl_AddGroups$1 = "Add Groups";
var OrgInternalContentCtrl_AddToPathway$1 = "Add to Pathway";
var OrgInternalContentCtrl_AddTopics$1 = "Add Skills";
var OrgInternalContentCtrl_AssessmentUnavailableError$1 = "Sorry! This assessment is not available.";
var OrgInternalContentCtrl_BulkEditItemsFormat$1 = "Bulk Edit: {{count}} Items Selected";
var OrgInternalContentCtrl_ClearCategories$1 = "Clear categories";
var OrgInternalContentCtrl_ContentOwner$1 = "Owner";
var OrgInternalContentCtrl_ContentTitle$1 = "Catalog";
var OrgInternalContentCtrl_CourseProperties$1 = "Course Properties";
var OrgInternalContentCtrl_Delete$1 = "Delete";
var OrgInternalContentCtrl_DialogConfirmBulkDeleteItems$1 = "Are you sure you want to remove {{count}} items from your internal catalog?";
var OrgInternalContentCtrl_DialogConfirmClearCategories$1 = "Are you sure you want to clear existing categories from selected items?";
var OrgInternalContentCtrl_DialogConfirmDeleteItemFormat$1 = "Are you sure you want to delete {{title}}?";
var OrgInternalContentCtrl_Edit$1 = "Edit";
var OrgInternalContentCtrl_FlagAsInappropriate$1 = "Flag as Inappropriate";
var OrgInternalContentCtrl_GenericError$1 = "Sorry! There was a problem performing this action. It’s not your fault, we are working hard to fix the problem.";
var OrgInternalContentCtrl_InputMetricCompletions$1 = "Completions";
var OrgInternalContentCtrl_InputMetricDateAdded$1 = "Date Added";
var OrgInternalContentCtrl_InputMetricDateUpdated$1 = "Date Updated";
var OrgInternalContentCtrl_InputMetricNone$1 = "None";
var OrgInternalContentCtrl_InputMetricRating$1 = "Ratings";
var OrgInternalContentCtrl_InputMetricRecommendations$1 = "Shares";
var OrgInternalContentCtrl_InputMetricTakeaways$1 = "Takeaways";
var OrgInternalContentCtrl_InputMetricViews$1 = "Views";
var OrgInternalContentCtrl_InternalProvider$1 = "Internal";
var OrgInternalContentCtrl_MakeASelection$1 = "Make a selection below";
var OrgInternalContentCtrl_MoreDetails$1 = "More Details";
var OrgInternalContentCtrl_Recommend$1 = "Share";
var OrgInternalContentCtrl_RemoveItems$1 = "Remove {{count}} items";
var OrgInternalContentCtrl_ReportAProblem$1 = "Report a Problem";
var OrgInternalContentCtrl_ReSyncDetails$1 = "Re-sync details";
var OrgInternalContentCtrl_SearchCatalog$1 = "Search Catalog";
var OrgInternalContentCtrl_SearchErrorMessage$1 = "Sorry! There was a problem retrieving your internal content results.";
var OrgInternalContentCtrl_SetGoal$1 = "Set Goal";
var OrgInternalContentCtrl_SuccessfulAddContent$1 = "Successfully added {{title}}";
var OrgInternalContentCtrl_SuccessfulUpdateContent$1 = "Successfully updated {{title}}";
var OrgInternalContentCtrl_ValidateCategoryRequired$1 = "Please add at least one category.";
var OrgInternalContentCtrl_ValidateNeedEndDate$1 = "Having a start date, requires an end date.";
var OrgInternalContentCtrl_ValidateNumber$1 = "Must be a valid, reasonable number.";
var OrgInternalContentCtrl_ValidateScormRequired$1 = "A scorm package is required when checked.";
var OrgInternalContentCtrl_ValidateTitleRequired$1 = "A title is required.";
var OrgInternalContentCtrl_ValidateURLMayBeInvalid$1 = "This URL may be invalid.";
var OrgInternalContentCtrl_ViewDetails$1 = "View Details";
var OrgInternalContentCtrl_ViewInGoals$1 = "View in Goals";
var OrgInternalContent_AddNewContentFormat$1 = "Add New {{inputType}}";
var OrgInternalContent_AddNewDisplayArticle$1 = "Add New Article";
var OrgInternalContent_AddNewDisplayAssessment$1 = "Add New Assessment";
var OrgInternalContent_AddNewDisplayCourse$1 = "Add New Course";
var OrgInternalContent_AddNewDisplayEpisode$1 = "Add New Podcast";
var OrgInternalContent_AddNewDisplayEvent$1 = "Add New Event";
var OrgInternalContent_AddNewDisplayPost$1 = "Add New Post";
var OrgInternalContent_AddNewDisplayVideo$1 = "Add New Video";
var OrgInternalContent_ContentType$1 = "Content Type";
var OrgInternalContent_ContentUse$1 = "The content is being used in:";
var OrgInternalContent_DeleteAllReferences$1 = "Delete from Catalog and all other references.";
var OrgInternalContent_DeleteCatalogOnly$1 = "Delete from Catalog only.";
var OrgInternalContent_DeleteCatalogOnlyDesc$1 = "If the content has been added to bundles, all associations with those bundles will be removed. Users will no longer see this content item in the bundle that was shared with them.";
var OrgInternalContent_DeleteSingleContentFormat$1 = "Are you sure you want to delete {{title}}?";
var OrgInternalContent_EditContentFormat$1 = "Edit {{inputType}}";
var OrgInternalContent_RestrictedContentNote$1 = "<strong>Note:</strong> This {{inputType}} is restricted to a certain audience and may not be accessible to everyone in the organization.";
var OrgInternalContent_ValidateCategoryRequired$1 = "Please add at least one category.";
var OrgInternalContent_ValidateGroupSelectionRequired$1 = "Enter the groups this should be visible to";
var OrgInternalContent_ValidateNeedEndDate$1 = "Having a start date, requires an end date.";
var OrgInternalContent_ValidateNumber$1 = "Must be a valid, reasonable number.";
var OrgInternalContent_ValidateScormRequired$1 = "A scorm package is required when checked.";
var OrgInternalContent_ValidateTitleRequired$1 = "A title is required.";
var OrgInternalContent_ValidateURLMayBeInvalid$1 = "This URL may be invalid.";
var OrgGroupsCtrl_AdministrativeDynamic$1 = "Administrative (Dynamic)";
var OrgGroupsCtrl_AdministrativeGroup$1 = "Administrative";
var OrgGroupsCtrl_AdministrativeStatic$1 = "Administrative (Static)";
var OrgGroupsCtrl_AvailableGroupsHeading$1 = "Available Groups";
var OrgGroupsCtrl_BecomeMember$1 = "Become a member of this group";
var OrgGroupsCtrl_Closed$1 = "Closed";
var OrgGroupsCtrl_ClosedGroup$1 = "Closed";
var OrgGroupsCtrl_CreateAGroup$1 = "Create a Group";
var OrgGroupsCtrl_DeletePluralPrompt$1 = "Are you sure you want to delete {{ count }} groups?";
var OrgGroupsCtrl_DeletePrompt$1 = "Are you sure you want to delete this group?";
var OrgGroupsCtrl_Dynamic$1 = "Dynamic";
var OrgGroupsCtrl_GroupMembers$1 = "Members";
var OrgGroupsCtrl_GroupName$1 = "Name";
var OrgGroupsCtrl_GroupsTitle$1 = "Groups";
var OrgGroupsCtrl_GroupVisibility$1 = "Visibility";
var OrgGroupsCtrl_JoinGroup$1 = "Join the group: {{name}}";
var OrgGroupsCtrl_Leave$1 = "Leave";
var OrgGroupsCtrl_LeaveGroup$1 = "Leave the group: {{name}}";
var OrgGroupsCtrl_LeaveGroupModalBodyText$1 = "You will no longer receive group emails or items shared to the group.";
var OrgGroupsCtrl_LeaveGroupModalHeader$1 = "Are you sure you want to leave the group?";
var OrgGroupsCtrl_MyGroupsHeading$1 = "My Groups";
var OrgGroupsCtrl_NoGroupsCreatedMessage$1 = "No groups have been created for this organization.";
var OrgGroupsCtrl_NoGroupsMatchMessage$1 = "No groups in this organization match your search term.";
var OrgGroupsCtrl_NumberOfMembersFormat$1 = "{{count}} Members";
var OrgGroupsCtrl_Open$1 = "Open";
var OrgGroupsCtrl_OpenGroup$1 = "Open";
var OrgGroupsCtrl_Private$1 = "Private";
var OrgGroupsCtrl_PrivateGroup$1 = "Private";
var OrgGroupsCtrl_RequestGroupMembership$1 = "Request membership to: {{name}}";
var OrgGroupsCtrl_RequestMembership$1 = "Request membership in this group";
var OrgGroupsCtrl_RequestPending$1 = "Request Pending";
var OrgGroupsCtrl_SearchforGroup$1 = "Search for a group";
var OrgGroupsCtrl_Static$1 = "Static";
var OrgGroupsCtrl_ThreeOrLess$1 = "3 or less";
var OrgGroupsCtrl_ThreeOrLessMembers$1 = "3 or less members";
var OrgGroupsCtrl_UploadGroups$1 = "Upload Groups";
var OrgGroupsCtrl_UploadGroupsDescription$1 = "You can upload multiple groups at once by including them in a file with the following template.";
var OrgGroupsCtrl_UploadGroupsError$1 = "Sorry! There was a problem uploading the groups.";
var OrgFtp_AllyText_CloseDetailsFormat$1 = "Close detail view for {{ error }}";
var OrgFtp_AllyText_SeeDetailsFormat$1 = "See details for {{ error }}";
var OrgFtp_ChangedRowPluralFormat$1 = "{{ count }} rows were processed";
var OrgFtp_ChangedRowSingleFormat$1 = "1 row was processed";
var OrgFtp_ClientUserFileWarning$1 = "The User File affects automations, reporting, and other critical operations. If your organization uses an automated user file, any changes uploaded may be overwritten the next time an automated file is processed.";
var OrgFtp_ContactSupport$1 = "Contact Support";
var OrgFtp_CorrectYourRows$1 = "Please check your file to correct these rows.";
var OrgFtp_Discard$1 = "Discard";
var OrgFtp_DiscardConfirmationMessage$1 = "When you discard a file, the system does not process it. Are you sure you want to discard this file?";
var OrgFtp_DiscardFile$1 = "Discard File";
var OrgFtp_DragAndDrop$1 = "Drag and drop or click to upload";
var OrgFtp_DragAndDropImage$1 = "Drag and Drop or click to upload an image";
var OrgFtp_ErrorDiscardingFile$1 = "There was an error discarding the file";
var OrgFtp_ErrorFileDetails$1 = "There was an error retrieving the file details";
var OrgFtp_ErrorUnknownFormat$1 = 'An error of type "{{ error }}" was encountered';
var OrgFtp_File_Error_DelimiterNotFound_Description$1 = "Please check the file for special characters and resubmit.";
var OrgFtp_File_Error_DelimiterNotFound_Title$1 = "Special Character Found";
var OrgFtp_File_Error_DescriptionColumnMissing_Description$1 = "The Description column is required for this file. Add this column with a value for each user, then resubmit.";
var OrgFtp_File_Error_DescriptionColumnMissing_Title$1 = "Description Column Missing";
var OrgFtp_File_Error_DuplicateColumnFound_Description$1 = "Column names must be unique.";
var OrgFtp_File_Error_DuplicateColumnFound_Title$1 = "Duplicate Column Found";
var OrgFtp_File_Error_ErrorParsingFile_Description$1 = "Please check if your file type and name matches the required configuration.";
var OrgFtp_File_Error_ErrorParsingFile_Title$1 = "Cannot Open File";
var OrgFtp_File_Error_ErrorParsingRows_Description$1 = "Please check if your file type and name matches the required configuration.";
var OrgFtp_File_Error_ErrorParsingRows_Title$1 = "Cannot Parse Rows";
var OrgFtp_File_Error_ExternalIdColumnMissing_Description$1 = "The External ID column is required for this file. Add this column with a value for each user, then resubmit.";
var OrgFtp_File_Error_ExternalIdColumnMissing_Title$1 = "External ID Column Missing";
var OrgFtp_File_Error_FileIsEmpty_Description$1 = "File appears to be empty. Please resubmit.";
var OrgFtp_File_Error_FileIsEmpty_Title$1 = "File Is Empty";
var OrgFtp_File_Error_FileNotFound_Description$1 = "We could not locate the file in our attempt to process. Please resubmit.";
var OrgFtp_File_Error_FileNotFound_Title$1 = "File Not Found";
var OrgFtp_File_Error_InvalidFields_Description$1 = 'This file has invalid fields ("Value" and "Type") and will not be processed.';
var OrgFtp_File_Error_InvalidFields_Title$1 = "Invalid Fields";
var OrgFtp_File_Error_NameColumnMissing_Description$1 = "The Name column is required for this file. Add this column with a value for each user, then resubmit.";
var OrgFtp_File_Error_NameColumnMissing_Title$1 = "Name Column Missing";
var OrgFtp_File_Error_NoColumnsFound_Description$1 = "Files must contain required columns.";
var OrgFtp_File_Error_NoColumnsFound_Title$1 = "No Columns Found";
var OrgFtp_File_Error_NoDatabaseFileInfo_Description$1 = "Please check if your file type and name matches the required configuration";
var OrgFtp_File_Error_NoDatabaseFileInfo_Title$1 = "Unrecognized Filename";
var OrgFtp_File_Error_NoFileInfoReturned_Description$1 = "Please check if your file type and name matches the required configuration.";
var OrgFtp_File_Error_NoFileInfoReturned_Title$1 = "Unrecognized Filename";
var OrgFtp_File_Error_NotifyParseFailure_Description$1 = "This file appears to contain no records. Please check your file and resubmit.";
var OrgFtp_File_Error_NotifyParseFailure_Title$1 = "File Contains No Records";
var OrgFtp_File_Error_ProcessingError_Description$1 = 'Users were successfully imported, but an unknown error occurred in the last processing step. Please contact <a href="mailto:support@degreed.com">support@degreed.com</a>';
var OrgFtp_File_Error_TypeColumnMissing_Description$1 = "The Type column is required for this file. Add this column with a value for each user, then resubmit.";
var OrgFtp_File_Error_TypeColumnMissing_Title$1 = "Type Column Missing";
var OrgFtp_File_Error_UniqueIdColumnMissing_Description$1 = "The UniqueID column is required for user files. Add this column with a value for each user, then resubmit.";
var OrgFtp_File_Error_UniqueIdColumnMissing_Title$1 = "Unique ID Column Missing";
var OrgFtp_File_Error_Unknown_Description$1 = 'An unidentified error has occurred. Please submit a ticket at <a href="https://degreed.zendesk.com/hc/requests/new">https://degreed.zendesk.com/hc/requests/new</a> with the file name so we can assist with troubleshooting.';
var OrgFtp_File_Error_Unknown_Title$1 = "Unknown Error";
var OrgFtp_File_Error_UnrecognizedExtension_Description$1 = "Degreed supports .csv or .txt for plain text delimited files, or .xls or .xlsx for excel files.";
var OrgFtp_File_Error_UnrecognizedExtension_Title$1 = "Unrecognized Extension";
var OrgFtp_File_Error_UnsupportedExtension_Description$1 = "Degreed supports .csv or .txt for plain text delimited files, or .xls or .xlsx for excel files.";
var OrgFtp_File_Error_UnsupportedExtension_Title$1 = "Unrecognized Extension";
var OrgFtp_File_Error_ValueColumnMissing_Description$1 = "The Value column is required for this file. Add this column with a value for each user, then resubmit.";
var OrgFtp_File_Error_ValueColumnMissing_Title$1 = "Value Column Missing";
var OrgFtp_File_Rejected_Error_Format$1 = "<strong>'{{error}}'</strong> error occurred while processing the file.  Please fix the error and try again.";
var OrgFtp_FileError$1 = "This file cannot be processed because of an error";
var OrgFtp_LandingPage_Description_BulkOpportunities$1 = "Add, update, or delete Opportunities";
var OrgFtp_LandingPage_Description_BulkTaxonomyRoles$1 = "Add and update roles";
var OrgFtp_LandingPage_Description_BulkTaxonomySkills$1 = "Add and update skills";
var OrgFtp_LandingPage_Description_ClientUser$1 = "Add, update, or delete users";
var OrgFtp_LandingPage_Description_Completion$1 = "Add, update, or delete learning completions";
var OrgFtp_LandingPage_Description_Content$1 = "Add, update, or delete content";
var OrgFtp_LandingPage_Description_Groups$1 = "Add, update, or delete Groups";
var OrgFtp_LandingPage_Description_RequiredLearning$1 = "Add, update, or delete required learning";
var OrgFtp_LandingPage_Description_UserUpdate$1 = "Add, update, or delete user attributes";
var OrgFtp_LandingPage_Type_Badge$1 = "Badge";
var OrgFtp_LandingPage_Type_BulkOpportunities$1 = "Opportunities";
var OrgFtp_LandingPage_Type_BulkTaxonomyRoles$1 = "Roles";
var OrgFtp_LandingPage_Type_BulkTaxonomySkills$1 = "Skills";
var OrgFtp_LandingPage_Type_ClientUser$1 = "Add Users";
var OrgFtp_LandingPage_Type_Completion$1 = "Completion";
var OrgFtp_LandingPage_Type_Content$1 = "Content";
var OrgFtp_LandingPage_Type_Groups$1 = "Groups";
var OrgFtp_LandingPage_Type_JobRole$1 = "Job Role";
var OrgFtp_LandingPage_Type_Opportunity$1 = "Opportunity";
var OrgFtp_LandingPage_Type_RequiredLearning$1 = "Required Learning";
var OrgFtp_LandingPage_Type_Skill$1 = "Skill";
var OrgFtp_LandingPage_Type_SkillAssessment$1 = "Skill Assessment";
var OrgFtp_LandingPage_Type_UserUpdate$1 = "User Update";
var OrgFtp_Note$1 = "Note";
var OrgFtp_PendingChangedRowPluralFormat$1 = "{{ count }} rows will be processed";
var OrgFtp_PendingChangedRowSingleFormat$1 = "1 row will be processed";
var OrgFtp_PendingFileWarning$1 = "This file is not finished processing. If you leave this page, your file will not process and your changes will be lost.";
var OrgFtp_PendingRejectedRowPluralFormat$1 = "{{ count }} rows will be rejected";
var OrgFtp_PendingRejectedRowSingleFormat$1 = "1 row will be rejected";
var OrgFtp_PendingWarningRowPluralFormat$1 = "{{ count }} rows will have warnings";
var OrgFtp_PendingWarningRowSingleFormat$1 = "1 row will have warnings";
var OrgFtp_PreviewingXOfYRows_PluralFormat$1 = "Previewing 10 of {{ total }} rows";
var OrgFtp_Processing$1 = "This file is currently being processed.";
var OrgFtp_ProcessingError$1 = "This file was partially processed but encountered a post-processing error";
var OrgFtp_RejectedRowPluralFormat$1 = "{{ count }} rows were rejected";
var OrgFtp_RejectedRowSingleFormat$1 = "1 row was rejected";
var OrgFtp_ReviewAndSubmit$1 = "Review and Submit";
var OrgFtp_Row_Error_ConflictingRecord_Description$1 = "This file contains conflicting records";
var OrgFtp_Row_Error_ConflictingRecord_Title$1 = "Conflicting Records";
var OrgFtp_Row_Error_ContentNotFound_Description$1 = "This content was not found in your organization";
var OrgFtp_Row_Error_ContentNotFound_Title$1 = "Content Not Found";
var OrgFtp_Row_Error_CustomAttributeTypeMissmatch_Description$1 = "Unable to convert custom attribute value to the specified data type";
var OrgFtp_Row_Error_CustomAttributeTypeMissmatch_Title$1 = "Attribute Type Mismatch";
var OrgFtp_Row_Error_DuplicateCategoryName_Title$1 = "Duplicate Category Name";
var OrgFtp_Row_Error_DuplicateEmail_Description$1 = "The following rows contain duplicate email addresses. All rows with duplicate emails are rejected.";
var OrgFtp_Row_Error_DuplicateEmail_Title$1 = "Duplicate Emails Found";
var OrgFtp_Row_Error_DuplicateExternalId_Title$1 = "Duplicate External Id";
var OrgFtp_Row_Error_DuplicateLocalizeSkillName_Title$1 = "Duplicate Localized Skill Name";
var OrgFtp_Row_Error_DuplicateRow_Description$1 = "The following rows are duplicates. All duplicate rows are rejected.";
var OrgFtp_Row_Error_DuplicateRow_Title$1 = "Duplicate Row Found";
var OrgFtp_Row_Error_DuplicateSkillName_Title$1 = "Duplicate Skill Name";
var OrgFtp_Row_Error_DuplicateSynonym_Title$1 = "Duplicate Synonym";
var OrgFtp_Row_Error_EmptyContentType_Description$1 = "The following rows are missing a Content Type";
var OrgFtp_Row_Error_EmptyContentType_Title$1 = "Empty Content Type";
var OrgFtp_Row_Error_EmptyUpdateType_Description$1 = "The following rows are missing an Update Type.";
var OrgFtp_Row_Error_EmptyUpdateType_Title$1 = "Empty Update Type";
var OrgFtp_Row_Error_FieldExceedsMaxLength_Title$1 = "Field Exceeds Max Length";
var OrgFtp_Row_Error_InvalidDuration_Description$1 = "Duration is not a numeric value";
var OrgFtp_Row_Error_InvalidDuration_Title$1 = "Invalid Duration";
var OrgFtp_Row_Error_InvalidLanguageCode_Title$1 = "Invalid Language Code";
var OrgFtp_Row_Error_InvalidLearningMinutes_Description$1 = "Learning Minutes is not a numeric value";
var OrgFtp_Row_Error_InvalidLearningMinutes_Title$1 = "Invalid Learning Minutes";
var OrgFtp_Row_Error_MaximumRowWidthExceeded_Description$1 = "The following rows have exceeded the maximum allowable row width.";
var OrgFtp_Row_Error_MaximumRowWidthExceeded_Title$1 = "Maximum Row Width Exceeded";
var OrgFtp_Row_Error_MissingRequiredColumn_Description$1 = "The following rows are missing a required column.";
var OrgFtp_Row_Error_MissingRequiredColumn_Title$1 = "Missing Required Column";
var OrgFtp_Row_Error_Unknown_Description$1 = 'An unidentified error has occurred. Please submit a ticket at <a href="https://degreed.zendesk.com/hc/requests/new">https://degreed.zendesk.com/hc/requests/new</a> with the file name so we can assist with troubleshooting.';
var OrgFtp_Row_Error_Unknown_Title$1 = "Unknown Error";
var OrgFtp_Row_Error_UnknownCategoryName_Title$1 = "Unknown Category Name";
var OrgFtp_Row_Error_UnknownContentType_Description$1 = "The following rows include an unknown Content Type.";
var OrgFtp_Row_Error_UnknownContentType_Title$1 = "Unknown Content Type";
var OrgFtp_Row_Error_UnknownGroup_Description$1 = "Create the Group Name before adding or removing users.";
var OrgFtp_Row_Error_UnknownGroup_Title$1 = "Unknown Group Name";
var OrgFtp_Row_Error_UnknownPathway_Description$1 = "Create the Pathway Name before adding or removing users.";
var OrgFtp_Row_Error_UnknownPathway_Title$1 = "Unknown Pathway Name";
var OrgFtp_Row_Error_UnknownPlan_Description$1 = "Create the Plan Name before adding or removing users.";
var OrgFtp_Row_Error_UnknownPlan_Title$1 = "Unknown Plan Name";
var OrgFtp_Row_Error_UnknownSkillName_Title$1 = "Unknown Skill Name";
var OrgFtp_Row_Error_UnknownSkillPlan_Description$1 = "Create the Plan Name before adding or removing users.";
var OrgFtp_Row_Error_UnknownSkillPlan_Title$1 = "Unknown Plan Name";
var OrgFtp_Row_Error_UnknownUpdateType_Description$1 = "The following rows include an unknown Update Type.";
var OrgFtp_Row_Error_UnknownUpdateType_Title$1 = "Unknown Update Type";
var OrgFtp_Row_Error_UnsupportedDisplayLanguage_Description$1 = "The following rows include an unsupported Display Language.";
var OrgFtp_Row_Error_UnsupportedDisplayLanguage_Title$1 = "Unsupported Display Language";
var OrgFtp_Row_Error_UnsupportedFileContentType_Description$1 = "The following rows include an unsupported Content Type.";
var OrgFtp_Row_Error_UnsupportedFileContentType_Title$1 = "Unsupported File Content Type";
var OrgFtp_Row_Error_UserNotFound_Description$1 = "This user was not found in your organization";
var OrgFtp_Row_Error_UserNotFound_Title$1 = "User Not Found";
var OrgFtp_RowNumber$1 = "Row Number";
var OrgFtp_Select$1 = "Select";
var OrgFtp_SelectFileTypeToUpload$1 = "Select the type of file you would like to use.";
var OrgFtp_StatusBadge_Error$1 = "Processed with Errors";
var OrgFtp_StatusBadge_Pending$1 = "Pending";
var OrgFtp_StatusBadge_Processing$1 = "Processing";
var OrgFtp_StatusBadge_ProcessingError$1 = "Post Processing Error";
var OrgFtp_StatusBadge_Rejected$1 = "Rejected";
var OrgFtp_StatusBadge_Success$1 = "Processed Successfully";
var OrgFtp_StatusBadge_Warning$1 = "Processed with Warnings";
var OrgFtp_SubmitFile$1 = "Submit File";
var OrgFtp_Success$1 = "Success!";
var OrgFtp_TemplateInstructions$1 = "Template Instructions";
var OrgFtp_TemplateInstructions_LongFormInstructions_Header1$1 = "Download the template to get started";
var OrgFtp_TemplateInstructions_LongFormInstructions_Header2$1 = "Enter your data";
var OrgFtp_TemplateInstructions_LongFormInstructions_Header3$1 = "Rename and save";
var OrgFtp_TemplateInstructions_LongFormInstructions_Link1$1 = "Download Template";
var OrgFtp_TemplateInstructions_LongFormInstructions_Para2$1 = 'Complete the template by entering your data and following the instructions in the "Field Explanations" and/or "File Guide" tabs.';
var OrgFtp_TemplateInstructions_LongFormInstructions_Para3$1 = "Use the recommended file name format: {{nameFormat}}.";
var OrgFtp_TemplateInstructions_LongFormInstructions_Para4$1 = "File names should be unique. If multiple files are generated on the same day, minutes (MM) and seconds (SS) can be added to the date stamp.";
var OrgFtp_TemplateInstructions_LongFormInstructions_Para5$1 = "Visit the  {{knowledgeCenterLinkStart}}Knowledge Center{{knowledgeCenterLinkEnd}} for more information.";
var OrgFtp_ThereMightBeSomeDelay$1 = "There might be some delay before the changes from your file are reflected in Degreed.";
var OrgFtp_Types_RowsWithErrors$1 = "Rejected Rows";
var OrgFtp_Types_RowsWithWarnings$1 = "Rows with Warnings";
var OrgFtp_TypesTooltips_RowsWithErrors$1 = "Rows of data that contained errors and Degreed did not process.";
var OrgFtp_TypesTooltips_RowsWithWarnings$1 = "Rows that Degreed processed but contained unknown values, which were ignored.";
var OrgFtp_UploadFile$1 = "Upload File";
var OrgFtp_ViewFileDetails$1 = "View File Details";
var OrgFtp_ViewFileLog$1 = "View File Log";
var OrgFtp_WarningRowPluralFormat$1 = "{{ count }} rows have warnings";
var OrgFtp_WarningRowSingleFormat$1 = "1 row has warnings";
var OrgFtp_WillBeRejectedRowPluralFormat$1 = "{{ count }} rows will be rejected";
var OrgFtp_WillBeRejectedRowSingleFormat$1 = "1 row will be rejected";
var OrgFtp_WillChangeRowPluralFormat$1 = "{{ count }} rows will be processed";
var OrgFtp_WillChangeRowSingleFormat$1 = "1 row will be processed";
var OrgFtp_WillHaveWarningRowPluralFormat$1 = "{{ count }} rows will have warnings";
var OrgFtp_WillHaveWarningRowSingleFormat$1 = "1 row will have warnings";
var OrgFtp_YourFileIsBeingProcessed$1 = "Your {{ type }} File is now being processed";
var OrgFaqCtrl_AnswerText$1 = "Answer text will appear here.";
var OrgFaqCtrl_EnterSearchTerm$1 = "Enter a search term above.";
var OrgFaqCtrl_FaqHeading$1 = "FAQ";
var OrgFaqCtrl_MaxResultsNarrowYourSearch$1 = "Some FAQs may not be shown. Try narrowing your search.";
var OrgFaqCtrl_NewQuestion$1 = "New Question";
var OrgFaqCtrl_NoFaqsFoundFormat$1 = "No FAQs for {{orgName}} were found.";
var OrgFaqCtrl_RemoveFaqButton$1 = "Remove FAQ";
var OrgFaqCtrl_RemoveFaqConfirmContinue$1 = "Are you sure you want to continue?";
var OrgFaqCtrl_RemoveFaqDescriptionFormat$1 = "This will permanently remove {{question}} from your organization's FAQs.";
var OrgFaqCtrl_RemoveFaqHeadingFormat$1 = "Remove {{question}}";
var OrgFaqCtrl_SearchForFaq$1 = "Search for a FAQ";
var OrgAnnouncement_ActivateDesc$1 = "Activate the announcement to go live to all users. Deactivating will hide the announcement.";
var OrgAnnouncement_ActivateLabel$1 = "Activate Announcement";
var OrgAnnouncement_AddALink$1 = "Add a Link";
var OrgAnnouncement_BlankDescription$1 = "This is a placeholder message to show a preview of what the end results will be. By customizing the field above the text fields can be edited.";
var OrgAnnouncement_Desc$1 = "Share an announcement with your organization on the Home page.";
var OrgAnnouncement_DescriptionPlaceholder$1 = "A description of a Pathway, Plan or Content Item";
var OrgAnnouncement_ImageDesc$1 = "Recommended size is 114px high and max 190px wide.";
var OrgAnnouncement_ImageDescNew$1 = "Recommended size is 348px wide and 192px high.";
var OrgAnnouncement_Label$1 = "Organization Announcement";
var OrgAnnouncement_LinkNamePlaceholder$1 = "View Pathway";
var OrgAnnouncement_LinkUrlHelperText$1 = "Add a link to any page or item within Degreed.";
var OrgAnnouncement_RetrievingError$1 = "There was an error retrieving the organization announcement.";
var OrgAnnouncement_TitlePlaceholder$1 = "The title of the item you are sharing";
var OrganizationsController_AddFAQs$1 = "Add FAQs";
var OrganizationsController_BackToOrgFormat$1 = "Back to {{orgName}}";
var OrganizationsController_Branding$1 = "Branding - Settings";
var OrganizationsController_Content$1 = "Catalog";
var OrganizationsController_EditImage$1 = "Edit Image";
var OrganizationsController_EstimateInfo$1 = "The links scan will run in the background and will take approximately {{time}} to complete. \nYou will get notified when scan results are ready to review.";
var OrganizationsController_FAQ$1 = "FAQ";
var OrganizationsController_FileLog$1 = "File Log";
var OrganizationsController_FileUpload$1 = "File Upload";
var OrganizationsController_Groups$1 = "Groups";
var OrganizationsController_HelpMenu$1 = "Help Menu - Settings";
var OrganizationsController_Home$1 = "Home Page - Settings";
var OrganizationsController_Insights$1 = "Insights";
var OrganizationsController_InsightsAndUsage$1 = "Insights & Usage";
var OrganizationsController_InvitedMessageOne$1 = "has invited you to join them on Degreed. You are now a member of the";
var OrganizationsController_InviteMessageTwo$1 = "Organization on Degreed. You can now participate in this organizations groups and learn with your coworkers.";
var OrganizationsController_JobRoles$1 = "Plans";
var OrganizationsController_Links$1 = "Custom Links - Settings";
var OrganizationsController_ManageAdvanced$1 = "Manage Advanced";
var OrganizationsController_ManageCatalog$1 = "Manage Catalog";
var OrganizationsController_ManageFAQ$1 = "Manage FAQ";
var OrganizationsController_ManageGroups$1 = "Manage Groups";
var OrganizationsController_ManageJobRoles$1 = "Manage Plans";
var OrganizationsController_ManageOpportunities$1 = "Manage Opportunities";
var OrganizationsController_ManagePathways$1 = "Manage Pathways";
var OrganizationsController_ManagePeople$1 = "Manage People";
var OrganizationsController_ManagePlans$1 = "Manage Plans";
var OrganizationsController_ManagePublishedPathways$1 = "Manage Published Pathways";
var OrganizationsController_ManageSkills$1 = "Manage Skills";
var OrganizationsController_Messaging$1 = "Messaging";
var OrganizationsController_NotEnoughActivity$1 = "Not Enough Activity";
var OrganizationsController_Opportunities$1 = "Opportunities";
var OrganizationsController_OrganizationDetails$1 = "Organization Details";
var OrganizationsController_Pages$1 = "Pages";
var OrganizationsController_Pathways$1 = "Pathways";
var OrganizationsController_People$1 = "People";
var OrganizationsController_Permissions$1 = "Permissions - Settings";
var OrganizationsController_Plans$1 = "Plans";
var OrganizationsController_Providers$1 = "Providers - Settings";
var OrganizationsController_Reporting$1 = "Reporting";
var OrganizationsController_ReportsNotAvailable$1 = "Reports are available once learning resources have been added during the specified time period.";
var OrganizationsController_ScanPreferences$1 = "Scan Preferences";
var OrganizationsController_Segments$1 = "Segments";
var OrganizationsController_SelectContentTypes$1 = "Select content type(s)";
var OrganizationsController_Settings$1 = "Settings";
var OrganizationsController_Skills$1 = "Skills I/O";
var OrganizationsController_SkillToRoleSuggestions$1 = "Skill to Role Suggestions";
var OrganizationsController_StartScan$1 = "Start Scan";
var OrganizationsController_SubmitQuestion$1 = "Submit a question";
var OrganizationsController_WelcomeToDegreed$1 = "Welcome to Degreed Learning Management";
var opportunityNewAuthor_NotificationTitleFormat$1 = "{{opportunityAuthor}} added you as a collaborator to an opportunity";
var OpportunityApplicantSelected_NotificationTitleFormat$1 = "{{opportunityAuthor}} selected you for their opportunity";
var Opportunities_AcceptMenteeModal_AcceptFormatted$1 = "Accept {{ name }}";
var Opportunities_AcceptMenteeModal_AvailabilityDescription$1 = "When off, you will not receive new mentorship requests.";
var Opportunities_AcceptMenteeModal_AvailabilityLabel$1 = "Mentorship Availability";
var Opportunities_AcceptMenteeModal_ConnectLabel$1 = "How would you like to connect?";
var Opportunities_AcceptMenteeModal_ConnectLabel_Error$1 = "Preferred contact method";
var Opportunities_AcceptMenteeModal_ConnectPlaceholder$1 = "Select One";
var Opportunities_AcceptMenteeModal_Description$1 = "Congratulations on your new mentorship connection!";
var Opportunities_AcceptMenteeModal_Error$1 = "Sorry! There was a problem approving this mentorship.";
var Opportunities_AcceptMenteeModal_SubmitButtonText$1 = "Accept";
var Opportunities_AcceptMenteeModal_Success$1 = "Mentorship accepted successfully.";
var Opportunities_AcceptMenteeModal_Success_Multi$1 = "Mentorship and mentor availability updated successfully.";
var Opportunities_Actions_Edit$1 = "Edit Opportunity";
var Opportunities_ActiveFormat$1 = "{{count}} Active";
var Opportunities_Activity_AsCollaborator$1 = "Added as collaborator";
var Opportunities_Activity_NewCandidates$1 = "{{candidates}} new candidates";
var Opportunities_Activity_NoInterestForDays$1 = "No interest for {{days}} days";
var Opportunities_Activity_NoInterestSevenDays$1 = "No interest for 7 days";
var Opportunities_Activity_OpenMoreThanDays$1 = "Open more than {{days}} days";
var Opportunities_AllGroups$1 = "All Groups";
var Opportunities_AllLocations$1 = "All Locations";
var Opportunities_AllSkills$1 = "All Skills";
var Opportunities_AllStatuses$1 = "All Statuses";
var Opportunities_AllTypes$1 = "All Types";
var Opportunities_Apply$1 = "Apply";
var Opportunities_ArchiveCandidatesModal_Header_Bulk$1 = "Archive {{ number }} Candidates";
var Opportunities_ArchiveCandidatesModal_Header_Singular$1 = "Archive Candidate";
var Opportunities_ArchiveCandidatesModal_Labels_Notify_Bulk$1 = "Notify unselected candidates that they have been archived";
var Opportunities_ArchiveCandidatesModal_Labels_Notify_Singular$1 = "Notify unselected candidate that they have been archived";
var Opportunities_ArchiveCandidatesModal_Labels_RejectionMessage$1 = "Rejection Message";
var Opportunities_ArchiveCandidatesModal_Labels_RejectionMessage_Placeholder$1 = "Enter a custom message here";
var Opportunities_ArchiveCandidatesModal_SubmitButtonText$1 = "Archive";
var Opportunities_Archived$1 = "Archived";
var Opportunities_BrowseOpportunities$1 = "Browse Opportunities";
var Opportunities_Candidates_Cols_DateAdded$1 = "Added";
var Opportunities_Candidates_Cols_JobTitle$1 = "Job Role";
var Opportunities_Candidates_Cols_Location$1 = "Location";
var Opportunities_Candidates_Cols_Name$1 = "Name";
var Opportunities_Candidates_Cols_SkillMatch$1 = "Skill Match";
var Opportunities_Candidates_Cols_Stage$1 = "Stage";
var Opportunities_Candidates_Cols_Status$1 = "Status";
var Opportunities_Candidates_Cols_TargetMet$1 = "Target Met";
var Opportunities_Candidates_Email_RejectionMessage$1 = "Rejection Message";
var Opportunities_Candidates_Error_Get$1 = "Sorry! There was a problem retrieving the candidates.";
var Opportunities_Candidates_Modal_Award$1 = "Yes, award";
var Opportunities_Candidates_Modal_UpdateApplicant_Description$1 = "This will send a notification to the recipient.";
var Opportunities_Candidates_Modal_UpdateApplicant_Title$1 = "Are you sure you want to award this opportunity?";
var Opportunities_Candidates_Modal_UpdateApplicantPrompt_CloseOpp$1 = "Close this opportunity (this can't be undone)";
var Opportunities_Candidates_Modal_UpdateApplicantPrompt_Congratulations$1 = "Congratulations on choosing a candidate! How would you like to finalize this opportunity?";
var Opportunities_Candidates_Modal_UpdateApplicantPrompt_Congratulations_Plural$1 = "Congratulations on choosing candidates! How would you like to finalize this opportunity?";
var Opportunities_Candidates_Modal_UpdateApplicantPrompt_Description$1 = "A notification will be sent to the candidate you selected.";
var Opportunities_Candidates_Modal_UpdateApplicantPrompt_Description_Plural$1 = "A notification will be sent to the candidates you selected.";
var Opportunities_Candidates_Modal_UpdateApplicantPrompt_NotifyUnselected$1 = "Notify unselected candidates that the opportunity is closed";
var Opportunities_Candidates_Modal_UpdateApplicantPrompt_SubmitButton$1 = "Select Candidate";
var Opportunities_Candidates_Modal_UpdateApplicantPrompt_SubmitButton_Plural$1 = "Select Candidates";
var Opportunities_Candidates_Modal_UpdateApplicantPrompt_Title$1 = "You Found a Candidate!";
var Opportunities_Candidates_Modal_UpdateApplicantPrompt_Title_Plural$1 = "You Found Candidates!";
var Opportunities_Candidates_Notice_NoCandidates$1 = "No candidates match this opportunity.";
var Opportunities_Candidates_Search_Placeholder$1 = "Search candidates";
var Opportunities_Candidates_ShowArchived$1 = "Show archived only";
var Opportunities_Candidates_Stage_Archived$1 = "Archive";
var Opportunities_Candidates_Stage_None$1 = "Not Specified";
var Opportunities_Candidates_Stage_Select$1 = "Selected";
var Opportunities_Candidates_Stage_Selected$1 = "Select";
var Opportunities_Candidates_Stage_Shortlisted$1 = "Shortlist";
var Opportunities_Candidates_Status_Interested$1 = "Interested";
var Opportunities_Candidates_Status_InviteSent$1 = "Shared";
var Opportunities_Candidates_Status_NoResponse$1 = "No response";
var Opportunities_Candidates_Status_NotInterested$1 = "Not interested";
var Opportunities_Candidates_UserHasNotOptedIn$1 = "This user has not yet opted in to sharing this information.";
var Opportunities_CareerMobility$1 = "Career Mobility";
var Opportunities_ChartXAxisTitle$1 = "Date";
var Opportunities_ClosedOnDate$1 = "Closed on {{date}}";
var Opportunities_ConnectWithButton_Status_Accepted$1 = "Your Mentor";
var Opportunities_ConnectWithButton_Status_None$1 = "Request Mentor";
var Opportunities_ConnectWithButton_Status_Requested$1 = "Requested Mentor";
var Opportunities_ConnectWithModal_ConnectWithFormatted$1 = "Connect with {{ name }}";
var Opportunities_ConnectWithModal_Description$1 = "We want to make sure that your mentorship is going to be as smooth as possible. To ensure that, we would love to know what you’re expecting.";
var Opportunities_ConnectWithModal_Error$1 = "Sorry! There was an error connecting with this mentor.";
var Opportunities_ConnectWithModal_Labels_FocusSkills$1 = "Focus Skills";
var Opportunities_ConnectWithModal_Labels_FocusSkills_Description$1 = "You and your mentor do not have any matching Focus Skills. Your Focus Skills (below) will be sent to this mentor to help them understand your mentoring needs.";
var Opportunities_ConnectWithModal_Labels_FocusSkills_Description_NoSkillsExplainer$1 = "You do not have any Focus Skills set in {{startAnchor}}your profile{{endAnchor}}. We recommend you set at least one Focus Skill before reaching out to a mentor, as Focus Skills help them to understand your mentoring needs.";
var Opportunities_ConnectWithModal_Labels_MatchingSkills$1 = "Matching Skills";
var Opportunities_ConnectWithModal_Labels_MatchingSkills_Description$1 = "You and this mentor match on the following Focus Skills, which will be sent to this mentor to help them understand your mentoring needs.";
var Opportunities_ConnectWithModal_Labels_Reason$1 = "Why would you like to be mentored?";
var Opportunities_ConnectWithModal_OpenModal$1 = "Request Mentor";
var Opportunities_ConnectWithModal_Placeholders_Reason$1 = "What is your motivation for reaching out to this mentor?";
var Opportunities_ConnectWithModal_SubmitButton$1 = "Send request";
var Opportunities_ConnectWithModal_Success$1 = "Request sent successfully.";
var Opportunities_ConnectWithModal_Success_Mentors_Removed$1 = "You have successfully ended this mentorship.";
var Opportunities_ConnectWithModal_Success_Updated$1 = "Mentorship updated successfully.";
var Opportunities_DataUpdateTimelineExplanation$1 = "Views and Interest data updates daily at 12:00 AM UTC. The details of the matched and unmatched data update between 12:00 AM and 1:00 AM UTC.";
var Opportunities_DeclineMenteeModal_DeclineFormatted$1 = "Decline {{ name }}";
var Opportunities_DeclineMenteeModal_Description$1 = "Help this mentee understand why a mentorship with you may not be the right fit.";
var Opportunities_DeclineMenteeModal_Error$1 = "Sorry! There was a problem declining this mentorship.";
var Opportunities_DeclineMenteeModal_ExplanationLabel$1 = "Note to Mentee";
var Opportunities_DeclineMenteeModal_ExplanationPlaceholder$1 = "Add a note";
var Opportunities_DeclineMenteeModal_SubmitButtonText$1 = "Decline";
var Opportunities_DeclineMenteeModal_Success$1 = "Mentorship declined successfully.";
var Opportunities_DeclineMenteeModal_Success_Multi$1 = "Mentorship and mentor availability updated.";
var Opportunities_Discard$1 = "Discard";
var Opportunities_DiscardChanges$1 = "Are you sure you want to discard these changes?";
var Opportunities_Discover_Error_Get$1 = "Sorry! There was a problem retrieving the candidates.";
var Opportunities_Discover_NoItems_ActionDescription$1 = "Open up the visibility for this opportunity and we'll provide candidates to discover.";
var Opportunities_Discover_NoItems_ActionDescription_Public$1 = "Try adding a related role or some more skills to discover potential candidates.";
var Opportunities_Discover_NoItems_Headline$1 = "Looks like this opportunity isn't visible yet";
var Opportunities_Discover_NoItems_Headline_Public$1 = "Looks like there are no matches for this opportunity";
var Opportunities_Discover_ResultsDisclaimer$1 = "Results are based on skill match from across the organization, are influenced by many factors, and may not include all possible candidates.";
var Opportunities_EngagementAriaLabel$1 = "Learn more about Engagement Insights for Opportunities";
var Opportunities_Error_AddExperience$1 = "Sorry! There was a problem adding the opportunity as experience.";
var Opportunities_Error_Get$1 = "Sorry! There was a problem retrieving the opportunities.";
var Opportunities_Error_GetApplicantData$1 = "Sorry! There was a problem getting the applicant data.";
var Opportunities_Error_GetMentors$1 = "Sorry! There was a problem retrieving the mentors.";
var Opportunities_Error_Loading$1 = "Sorry! There was a problem loading the opportunities.";
var Opportunities_Error_Skill_Delete$1 = "Sorry! There was a problem deleting the skill.";
var Opportunities_Error_Target_Delete$1 = "Opportunities_Error_";
var Opportunities_Error_UpdateApplicantsStage$1 = "Sorry! There was a problem updating the applicants' stage.";
var Opportunities_Error_UpdateApplicantStage$1 = "Sorry! There was a problem updating the applicant's stage.";
var Opportunities_Errors_OpportunityIsInvalid$1 = "This opportunity has an issue that must be addressed.";
var Opportunities_Errors_OpportunityIsInvalid_Tab$1 = "This tab has errors.";
var Opportunities_ExcellentFitLabel$1 = "Excellent Fit";
var Opportunities_GetError$1 = "There was a problem getting opportunities.";
var Opportunities_GoodFitLabel$1 = "Good Fit";
var Opportunities_InterestByMatchedCandidates$1 = "Interest by matched candidates";
var Opportunities_InterestByUnmatchedCandidates$1 = "Interest by unmatched candidates";
var Opportunities_InterestConfirmed$1 = "A notification has been sent about your interest in the opportunity.";
var Opportunities_Interested$1 = "Interested";
var Opportunities_Interested_NoItems_ActionDescription$1 = "Check out the discover tab to find potential candidates";
var Opportunities_Interested_NoItems_CustomNoItemsMessage$1 = "Some candidates have been hidden by the selected filters.";
var Opportunities_Interested_NoItems_Headline$1 = "No one has shown any interest yet";
var Opportunities_Interested_NoResult$1 = "No results for";
var Opportunities_InterestNotConfirmedError$1 = "There was an error. Your interest in the opportunity was not confirmed.";
var Opportunities_InterestNotRemovedError$1 = "There was an error. Your interest in the opportunity was not removed.";
var Opportunities_InterestRemoved$1 = "You have been removed as a candidate from this opportunity.";
var Opportunities_JobRoleNotSpecified$1 = "Not specified";
var Opportunities_Marketplace$1 = "Marketplace";
var Opportunities_Marketplace_BasedOn_Focus$1 = "Based on your Focus Skills";
var Opportunities_Marketplace_BasedOn_Goals$1 = "Based on your Career Goals";
var Opportunities_Marketplace_BasedOn_Recent$1 = "Most recently updated";
var Opportunities_Marketplace_BasedOn_Skills$1 = "Based on your Skills";
var Opportunities_Marketplace_LaneTypes_Mentors$1 = "Connect with a Mentor";
var Opportunities_Marketplace_LaneTypes_Permanent$1 = "Full-Time Opportunities";
var Opportunities_Marketplace_LaneTypes_Projects$1 = "Projects & Tasks";
var Opportunities_Marketplace_LaneTypes_Temporary$1 = "Stretch Assignments";
var Opportunities_MatchedCandidateExplanation$1 = "Matched candidate: The opportunity is presented to the user because user profile criteria is met. {{startAnchor}}Learn more{{endAnchor}}";
var Opportunities_MatchedSkills$1 = "Matched";
var Opportunities_MatchingSkills$1 = "MATCHING SKILLS: {{matchingSkillsCount}} OF {{totalSkillsCount}}";
var Opportunities_Mentees$1 = "Mentees";
var Opportunities_MenteeSkills$1 = "Mentee Skills";
var Opportunities_Mentoring$1 = "Mentoring";
var Opportunities_Mentoring_Columns_Connect$1 = "Connect by";
var Opportunities_Mentors$1 = "Mentors";
var Opportunities_MentorSkills$1 = "Mentor Skills";
var Opportunities_Meta_Closed$1 = "Closed";
var Opportunities_Meta_Location$1 = "Location";
var Opportunities_Meta_PublishDate$1 = "Created On";
var Opportunities_Meta_PublishDateString$1 = "Created on {{ date }}";
var Opportunities_Meta_Type$1 = "Type";
var Opportunities_Meta_Visibility$1 = "Visibility";
var Opportunities_MoreDetailsMentorshipModal_Info$1 = "The note hasn't been filled in.";
var Opportunities_MoreDetailsMentorshipModal_Warning$1 = "The note hasn't been filled in and the mentee has no skills available.";
var Opportunities_MyOpportunities$1 = "My Opportunities";
var Opportunities_MyOpportunitiesCollaboratingOn$1 = "Collaborating on";
var Opportunities_MyOpportunitiesCompleted$1 = "Completed";
var Opportunities_MyOpportunitiesEmptyStateText$1 = 'Opportunities relevant to you will be suggested on your <a href="{{ homePageUrl }}" class="link">home page</a>. You can also <a href="/career/opportunities" target="_self" class="link">browse opportunities</a>';
var Opportunities_MyOpportunitiesEmptyStateTitle$1 = "You don't have any opportunities here";
var Opportunities_MyOpportunitiesInterested$1 = "Interested";
var Opportunities_MyOpportunitiesSavedForLater$1 = "Saved For Later";
var Opportunities_MyOpportunitiesSelected$1 = "Selected";
var Opportunities_MyOpportunitiesSharedWithMe$1 = "Shared With Me";
var Opportunities_NoMentorship$1 = "No new Mentorship connections";
var Opportunities_NoResultsForBrowse$1 = "There are no Opportunities that match your current search. Please modify your filter selections.";
var Opportunities_NoResultsForSearch$1 = 'There are no Opportunities that match "{{searchTerm}}". Please modify your search term(s).';
var Opportunities_NotFound_DescriptionText$1 = "You may not have permission to see this opportunity or this opportunity may not exist.";
var Opportunities_OpenedOnDate$1 = "Opened on {{date}}";
var Opportunities_OpenOpportunities$1 = "Open Opportunities";
var Opportunities_OpenOpportunitiesByJobRoleFormat$1 = "Open opportunities by job role";
var Opportunities_OpenOpportunitiesByType$1 = "Open opportunities by type";
var Opportunities_OpenOpportunitiesByTypeFormat$1 = "Top Open Opportunities by Type";
var Opportunities_OpportunityEngagement$1 = "Opportunity Engagement";
var Opportunities_OtherSkills$1 = "Other Skills";
var Opportunities_PartialFitLabel$1 = "Partial Fit";
var Opportunities_RecentSearches$1 = "Recent Searches";
var Opportunities_Relation$1 = "Relationship";
var Opportunities_Relation_Author$1 = "Collaborator";
var Opportunities_Relation_InterestedApplicant$1 = "Interested";
var Opportunities_Relation_SavedForLaterByUser$1 = "Saved for later";
var Opportunities_Relation_SelectedApplicant$1 = "Selected";
var Opportunities_RemoveArchive$1 = "Remove Archive";
var Opportunities_RemoveArchived$1 = "Remove Archive";
var Opportunities_RemoveInterest$1 = "Remove Interest";
var Opportunities_RemoveSelected$1 = "Remove Select";
var Opportunities_RemoveShortlist$1 = "Remove Shortlist";
var Opportunities_RemoveShortlisted$1 = "Remove Shortlisted";
var Opportunities_ResultRange$1 = "Results {{ start }}-{{ end }} of {{ total }}";
var Opportunities_SavedForLater$1 = "Saved for later";
var Opportunities_Selected$1 = "Selected";
var Opportunities_SelectedCandidates$1 = "Selected Candidates";
var Opportunities_SelectedCandidatesTooltip$1 = "Week over week count of candidates selected for opportunities";
var Opportunities_SelectedMatchedCandidates$1 = "Selected matched candidates";
var Opportunities_SelectedUnmatchedCandidates$1 = "Selected unmatched candidates";
var Opportunities_SharedWithYou$1 = "Shared with you";
var Opportunities_Shortlisted$1 = "Shortlisted";
var Opportunities_ShowingCountOfTotalOpportunities$1 = "showing {{ count }} of {{ total }} opportunities";
var Opportunities_ShowInterest$1 = "Show Interest";
var Opportunities_SkillMatchFullLabel$1 = "{{matched}} of {{total}} Skills";
var Opportunities_SkillMatchLabel$1 = "{{matched}} of {{total}}";
var Opportunities_Skills_AddSkillPlaceholder$1 = "Search for skills to add...";
var Opportunities_Skills_AddSkillRating$1 = "Add Skill Rating";
var Opportunities_Skills_AddSkillsAltText$1 = "Add Skills";
var Opportunities_Skills_AddTargetLevel$1 = "Add Target Level";
var Opportunities_Skills_EditSkillRating$1 = "Edit Skill Rating";
var Opportunities_Skills_EditTargetLevel$1 = "Edit Target Level";
var Opportunities_Skills_Following_But_No_Rating$1 = "This skill was added to the profile without any ratings";
var Opportunities_Skills_Menu_AddTargetLevel$1 = "Add target level";
var Opportunities_Skills_Menu_EditTargetLevel$1 = "Edit target level";
var Opportunities_Skills_Menu_RemoveTargetLevel$1 = "Remove target";
var Opportunities_Skills_Modal_AddTargetHeader$1 = "Rate your expertise in '{{ skillName }}'";
var Opportunities_Skills_Modal_EditTargetHeader$1 = "Rate your expertise in '{{ skillName }}'";
var Opportunities_Skills_RemoveSkillRating$1 = "Remove Skill Rating";
var Opportunities_SkillsMatchLabel$1 = "match";
var Opportunities_SkillsMatchPercentage$1 = "{{percent}}%";
var Opportunities_Success_AddExperience$1 = "This opportunity has been added to your experience successfully.";
var Opportunities_Success_Clone$1 = "The opportunity '{{title}}' was added successfully!";
var Opportunities_Success_UpdateApplicantStage$1 = "Success! The applicant's stage has been updated.";
var Opportunities_SuggestedLearning$1 = "Suggested Learning";
var Opportunities_SuggestedLearning_Description$1 = "This section provides suggested learnings to upgrade your skills for this opportunity";
var Opportunities_TopLocations$1 = "Top Locations";
var Opportunities_TopOpportunitiesByJobRoleFormat$1 = "Top {{count}} Opportunities by Job Role";
var Opportunities_TopOpportunitiesByJobRoleFormatNoCount$1 = "Top Opportunities by Job Role";
var Opportunities_TopOpportunitiesByTypeFormat$1 = "Top {{count}} Open Opportunities by Type";
var Opportunities_TopSkillsInDemandFormat$1 = "Top {{count}} Skills in Demand";
var Opportunities_TypeDynamicTeamAssignment$1 = "Dynamic Team Assignment";
var Opportunities_TypeJobDescription$1 = "A paid position of regular employment";
var Opportunities_TypeLookingForMentee$1 = "Looking For Mentee";
var Opportunities_TypeLookingForMentor$1 = "Looking For Mentor";
var Opportunities_TypeMenteeship$1 = "Menteeship";
var Opportunities_TypeMenteeshipDescription$1 = "Receiving guidance from a mentor, especially an experienced person";
var Opportunities_TypeMentorship$1 = "Mentorship";
var Opportunities_TypeMentorshipDescription$1 = "Providing guidance to an individual";
var Opportunities_TypeOther$1 = "Other";
var Opportunities_TypeOtherDescription$1 = "Any other type of experience";
var Opportunities_TypePeerMentoring$1 = "Peer Mentoring";
var Opportunities_TypePermanent$1 = "Permanent";
var Opportunities_TypeProBono$1 = "Pro Bono";
var Opportunities_TypeProject$1 = "Project";
var Opportunities_TypeProjectDescription$1 = "An individual or collaborative enterprise that is planned to achieve a particular aim";
var Opportunities_TypeReverseMentoring$1 = "Reverse Mentoring";
var Opportunities_TypeSecondment$1 = "Secondment";
var Opportunities_TypeShadowing$1 = "Shadowing";
var Opportunities_TypeShadowingDescription$1 = "Follow and observe someone closely";
var Opportunities_TypeStretchAssignment$1 = "Stretch Assignment";
var Opportunities_TypeStretchAssignmentDescription$1 = "A project or task that is currently beyond your level of knowledge or skill";
var Opportunities_TypeTemporary$1 = "Temporary";
var Opportunities_TypeVolunteer$1 = "Volunteer";
var Opportunities_UnmatchedCandidateExplanation$1 = "Unmatched candidate: The opportunity is not presented to the user because user profile criteria is not met. {{startAnchor}}Learn more{{endAnchor}}";
var Opportunities_UnmatchedSkills$1 = "Unmatched";
var Opportunities_UnsavedChanges$1 = "There are unsaved changes";
var Opportunities_UserRateSkillsModal_Header$1 = "Stand out as a candidate by rating your skills";
var Opportunities_View_Error_Get$1 = "Sorry! There was a problem retrieving the opportunity.";
var Opportunities_ViewAll$1 = "View all opportunities";
var Opportunities_ViewAllCollaborators$1 = "View all collaborators";
var Opportunities_ViewByMatchedCandidates$1 = "Views by matched candidates";
var Opportunities_ViewByUnmatchedCandidates$1 = "Views by unmatched candidates";
var Opportunities_Viewing$1 = "Viewing";
var Opportunities_ViewOpportunity$1 = "View Opportunity";
var Opportunities_ViewsAndInterest$1 = "Views and Interest";
var Opportunities_ViewsAndInterestsTooltip$1 = "Week over week unique views and interest for opportunities";
var Opportunities_YourOpportunities$1 = "Your Opportunities";
var OnboardingFooter_GetStarted$1 = "Get Started";
var OnboardingFooter_NextStep$1 = "Next Step";
var OnboardingFooter_PreviousStep$1 = "Previous Step";
var OnboardingFooter_RatingDisabledStatus$1 = "{{ ratings }} of 3 ratings added";
var OnboardingFooter_SeeMyProfile$1 = "See My Profile";
var OnboardingFooter_SkipStep$1 = "Skip Step";
var OnboardingFooter_StartLearning$1 = "Start Learning";
var OnboardingFooter_StepperLabel$1 = "Step {{stepNumber}} of {{stepTotal}}";
var OnboardingFooter_SubmitRating$1 = "Submit Rating";
var Onboarding_A11yAssignedStepName$1 = "Assigned";
var Onboarding_A11yResumeReviewStepName$1 = "Review Resume";
var Onboarding_A11yRoleSelectStepName$1 = "Role Select";
var Onboarding_A11ySkillAdded$1 = "You added {{skillName}} to your skills list.";
var Onboarding_A11ySkillAlreadyAdded$1 = "{{skillName}} is included in the list of “Skills you may be interested in”.";
var Onboarding_A11ySkillsStepName$1 = "Skills";
var Onboarding_A11yStartLearningStepName$1 = "Start Learning";
var Onboarding_AddedSkill$1 = "Added Skill";
var Onboarding_AdditionalSkillsDescription$1 = "Choose the skills that you have so we can better curate your learning experience.";
var Onboarding_AdditionalSkillsInterstedIn$1 = "Skills you may be interested in";
var Onboarding_AdditionalSkillsTitle$1 = "Select Additional Skills You Have";
var Onboarding_AISkillsSuggestDesc$1 = "Use the Degreed AI model to suggest skills";
var Onboarding_AISkillsSuggestLabel$1 = "Allow Degreed AI to Suggest Skills";
var Onboarding_AreYouSureDescription$1 = "<p>With a Skill Rating Level of <strong>1</strong>, you have some knowledge about this skill and are starting to learn the tools and processes associated to it. </p>\r\n<p>Once you submit this Skill Rating Level, it displays on the Skill card on your profile. <p>";
var Onboarding_AreYouSureHeading$1 = "Submit Your Skill Rating Level";
var Onboarding_AssignedSkillsDescription$1 = "The following skills are recommended for all {{currentRole}} and will be added to your profile. However, you can click a skill to deselect it and it will not be added to your profile.";
var Onboarding_AssignedSkillsError$1 = "Select at least one skill to proceed to the next step.";
var Onboarding_AssignedSkillsHeader$1 = "There are {{count}} Skills Assigned to the {{roleName}} Role";
var Onboarding_AssignedSkillsInformationTooltip$1 = "Your role can be updated at any time in your profile settings.";
var Onboarding_AssignedSkillsWarning$1 = "We recommend keeping your assigned skills selected.  The selected skills provide you with role-based learning and resources.";
var Onboarding_BackupEmailAddressDesc$1 = "Backup Email Address";
var Onboarding_ExperienceDatePresent$1 = "Present";
var Onboarding_ExperienceDateYears$1 = "Years";
var Onboarding_ExportLinkedInResume$1 = "Export your resume from LinkedIn";
var Onboarding_ExportLinkedInResumeInstructions$1 = 'Download your LinkedIn resume by logging into your profile, clicking the "Me" icon, then "View Profile", and selecting "Save to PDF".';
var Onboarding_FocusSkillTooltip$1 = "Choose up to four Focus Skills by selecting the stars for each skill. Focus Skills are skills that you want to actively develop or improve.";
var Onboarding_FoundExperienceHeader$1 = "We Found {{count}} Experiences on Your Resume";
var Onboarding_LearnFromAnySource$1 = "Learn from Any Source";
var Onboarding_LearnInstructions$1 = "We'll connect all the resources you’ll need to learn and grow, like millions of courses, videos, books, and more!";
var Onboarding_LinkedInLink$1 = "Go to LinkedIn";
var Onboarding_LoadMore$1 = "Load More";
var Onboarding_ProfileSkill$1 = "Profile Skill";
var Onboarding_ProgressInstructions$1 = "We’re here to help you discover, learn, and progress in the skills you need for the future.";
var Onboarding_ProgressInYourSkills$1 = "Progress in Your Skills";
var Onboarding_RatingOverflowImgAlt$1 = "abstract illustration representing a user profile";
var Onboarding_RatingOverflowInstructions$1 = "You're all done for now. You can always rate more skills on your profile later.";
var Onboarding_RatingOverflowTitle$1 = "Great Job!";
var Onboarding_ResetTipsBody$1 = "This will re-enable all onboarding dialogs throughout Degreed, including the Welcome page.";
var Onboarding_ResetTipsHeader$1 = "Are you sure you want to reset onboarding?";
var Onboarding_ResumeAdditionalSkills$1 = "We have found {{count}} skills in your resume. You will be able to review, edit, and add additional skills on the next step.";
var Onboarding_ResumeLastModifiedDateMessage$1 = "Your last resume upload was {{date}}";
var Onboarding_ResumeReviewPageDescription$1 = "To personalize your Degreed experience, we'll add {{experiencesNumber}} experiences and {{skillsNumber}} skills from your resume to your profile. You will be able to review, edit, and add skills on the next step.";
var Onboarding_ResumeReviewTitle$1 = "Review Experiences from Resume Upload";
var Onboarding_ResumeSkill$1 = "Resume Skill";
var Onboarding_ReviewExperienceDescription$1 = "Review the roles from your resume.  These experiences will be added to your profile to personalize your Degreed experience.";
var Onboarding_ReviewOptionalSkillsDescription$1 = "Although skill ratings are not required, adding them to your profile provides a starting point to track your progress. It is also recommended to select up to four focus skills using the star icons to personalize your learning experience. These are the skills you want to actively develop.";
var Onboarding_ReviewOptionalSkillsHeader$1 = "Complete your Skills Profile";
var Onboarding_ReviewSkills_Description$1 = "You've added {{addedSkills}} skills matching your job role and past work experience. Complete your profile by adding at least three self-ratings and selecting up to four focus skills to enhance suggestions for skill, content and opportunities. \r\n<br><br>If any of your skills are missing, search and add them now.";
var Onboarding_ReviewSkills_Description_Empty$1 = "No skills matching your job role or past experience were found. To complete your skills profile, add at least three self-ratings and select up to four focus skills.\n<br><br>If any of your skills are missing, search and add them now.";
var Onboarding_ReviewSkillsDescription$1 = "To get the best personalized experience in {{orgName}}, let's complete your skills profile. Add at least three self ratings to skills and tell us which skills you would like to Focus on.<br><br>If you don't see a skill you have or want to work on, simply search for it and add it now.";
var Onboarding_ReviewSkillsHeader$1 = "Finalize Your Skills Profile";
var Onboarding_RoleSkill$1 = "Role Skill";
var Onboarding_RolesStepDescription$1 = "Your role is the foundation of your skill profile and personalizes your {{orgName}} experience.";
var Onboarding_RolesStepTitle$1 = "Select Your Role";
var Onboarding_SavingError$1 = "Sorry! There was a problem saving your onboarding history.";
var Onboarding_SearchRoles_NoRoleAssigned$1 = "No Role Assigned";
var Onboarding_SearchRoles_SearchForRole$1 = "Search for role";
var Onboarding_SearchRoles_VisitIntegration$1 = "Visit {{integrationName}} to add a role.";
var Onboarding_SearchSkills_AddSkills$1 = "Add any skill you'd like";
var Onboarding_SearchSkills_SearchForSkills$1 = "Search for skills";
var Onboarding_SearchSkills_SuggestionsHeading$1 = "{{numberOfSkills}} suggestions for '{{roleName}}'";
var Onboarding_SearchSkills_TopSkills$1 = "Top Skills";
var Onboarding_SecondaryEmailDesc$1 = "This helps protect your account and points";
var Onboarding_SectionTitle$1 = "Onboarding";
var Onboarding_SeeSuggestedSkills$1 = "See Suggested Skills";
var Onboarding_SkillSelectionRequiredTooltip$1 = "You must select at least one skill to continue";
var Onboarding_Step1CategoriesImgAlt$1 = "abstract illustration representing many types of content";
var Onboarding_Step1IdeasImgAlt$1 = "abstract illustration representing thoughts and ideas";
var Onboarding_Step1Title$1 = "Welcome to Degreed";
var Onboarding_Step2Instructions$1 = "First, tell us what job you have, or want, so that we can help you find skills or topics you might want to learn about.";
var Onboarding_Step2InstructionsIntegration$1 = "Your organization assigned your job role from {{integrationName}}.  You can add or edit your role in {{integrationName}}.";
var Onboarding_Step2InstructionsSkillInventory$1 = "First, tell us what job you have so that we can help you add your current skills.";
var Onboarding_Step2Title$1 = "Select Your Role";
var Onboarding_Step2TitleIntegration$1 = "Your Role";
var Onboarding_Step3Instructions$1 = "Now, choose some skills you would like to develop so we can better curate your learning experience.";
var Onboarding_Step3InstructionsSkillInventory$1 = "Now, create your skill profile by telling us about the skills you have.";
var Onboarding_Step3Title$1 = "Select the Skills You Want to Develop";
var Onboarding_Step3TitleSkillInventory$1 = "Tell Us How Awesome You Are";
var Onboarding_Step4Instructions$1 = "Rate your skills to find relevant learning content and to keep track of your progress.";
var Onboarding_Step4InstructionsSkillInventory$1 = "Rate your skills to start tracking your skill development and see how your skills match the job you want and your current job.";
var Onboarding_Step4Title$1 = "It's Time to Rate Yourself on Your Skills!";
var Onboarding_Step5Instructions$1 = "We have found thousands of articles, videos, books, and courses that will help you develop your skills. Get started by exploring your personalized learning feed.";
var Onboarding_Step5Title$1 = "You're All Done!";
var Onboarding_StepParse$1 = "Parse";
var Onboarding_StepResults$1 = "Results";
var Onboarding_StepUpload$1 = "Upload";
var Onboarding_SuggestedSkill$1 = "Suggested Skill";
var Onboarding_TrackYourSkills$1 = "Tell the world how awesome you are";
var Onboarding_TrackYourSkillsInstructions$1 = "Start building your profile today, the first step in showing your organization all the skills you bring to the team.";
var Onboarding_UploadResume$1 = "Upload Resume";
var Onboarding_UploadResumeDescription$1 = "{{orgName}} will add your work experience and extract skills from each of your past job roles from your resume.";
var Onboarding_UploadResumeDescriptionTemp$1 = "{{orgName}} will extract skills from your resume to add to your profile.";
var Onboarding_UploadResumeHeader$1 = "Upload Your Resume to Add Previous Experience";
var Onboarding_UploadResumeHeaderTemp$1 = "Upload Your Resume to Add Skills";
var Onboarding_Welcome$1 = "Welcome {{username}}";
var Onboarding_WelcomeDetails$1 = "Let's find out by building your {{orgName}} Profile.  Your profile is used to find resources personalized to your role, skills, and goals.";
var Onboarding_WelcomeHeading$1 = "Do you have the skills you need to take on tomorrow?";
var Onboarding_WelcomeInstructions$1 = "Begin by uploading your resume to automatically populate past job roles and skills, or provide a personal email address to save your profile for access anywhere.";
var Onboarding_WelcomeMountainIllustration$1 = "Mountain illustration representing Degreed assisting you with your learning journey";
var Onboarding_WelcomeTitle$1 = "Craft your profile for personalized resources tailored to your role, skills, and goals.";
var OnboardingController_PageTitle$1 = "Welcome";
var NotificationsCtrl_YouHaveRequiredLearningPluralFormat$1 = "You have {{count}} Required Learning items";
var NotificationsCtrl_YouHaveRequiredLearningSingular$1 = "You have 1 Required Learning item";
var NotificationManager_SocialConnectionJoinedFormat$1 = "Your friend {0} joined Degreed.";
var NotificationManager_UnsubscribeFormat$1 = "You have been unsubscribed from the {{type}}.";
var NotificationFeedCtrl_NotificationCountFormat$1 = "{{notificationItemCount}} new notifications";
var Notification_AutomationNotification$1 = "Your Admin has sent a message";
var Notification_CompleteViewedItemsStepArticle$1 = "Do you want to mark this article complete?";
var Notification_CompleteViewedItemsStepArticleItem1$1 = "Mark Complete";
var Notification_CompleteViewedItemsStepArticleItem2$1 = "Skip";
var Notification_CompleteViewedItemsStepEpisode$1 = "Do you want to mark this podcast complete?";
var Notification_CompleteViewedItemsStepEpisodeItem1$1 = "Mark Complete";
var Notification_CompleteViewedItemsStepEpisodeItem2$1 = "Skip";
var Notification_CompleteViewedItemsStepFirstFormat$1 = "There are {0} items that you have viewed on Degreed recently, but didn't complete yet. Do you want to review them?";
var Notification_CompleteViewedItemsStepFirstFormatItem1$1 = "Review Items";
var Notification_CompleteViewedItemsStepFirstFormatItem2$1 = "Dismiss";
var Notification_CompleteViewedItemsStepFirstSingular$1 = "There is 1 item that you have viewed on Degreed recently, but didn't complete yet. Do you want to review it?";
var Notification_CompleteViewedItemsStepFirstSingularItem1$1 = "Review Item";
var Notification_CompleteViewedItemsStepFirstSingularItem2$1 = "Dismiss";
var Notification_CompleteViewedItemsStepPost$1 = "Do you want to mark this post complete?";
var Notification_CompleteViewedItemsStepThanksFormat$1 = '<strong>Yay! Congratulations!</strong> You just earned {{pointsEarned}} points by completing these {{completedCount}} items. You can find them again later in <a href="/me?p=1#/overview" class="link">your collection</a>.';
var Notification_CompleteViewedItemsStepVideo$1 = "Do you want to mark this video complete?";
var Notification_CompleteViewedItemsStepVideoItem1$1 = "Mark Complete";
var Notification_CompleteViewedItemsStepVideoItem2$1 = "Skip";
var Notification_EnableDailyEmailStep1$1 = "How's my favorite learner doing?";
var Notification_EnableDailyEmailStep1Item1$1 = "Great thanks!";
var Notification_EnableDailyEmailStep1Item2$1 = "I don't like talking to robots";
var Notification_EnableDailyEmailStep2$1 = "Glad to hear it! Would you be interested in having daily learning recommendations delivered to your inbox?";
var Notification_EnableDailyEmailStep2Item1$1 = "Yes please!";
var Notification_EnableDailyEmailStep2Item2$1 = "Not right now";
var Notification_EnableDailyEmailStep3$1 = "I get that all the time. There was a weird paperclip who gave us a bad reputation. Before you go, could I interest you in daily learning recommendations delivered to your inbox?";
var Notification_EnableDailyEmailStep3Item1$1 = "Sure!";
var Notification_EnableDailyEmailStep3Item2$1 = "No thanks!";
var Notification_EnableDailyEmailStep4$1 = "Fantastic! Look for your first email tomorrow morning!";
var Notification_EnableDailyEmailStep5$1 = "No problem. Have a great day of learning!";
var Notification_InstallNativeAppStep1$1 = "Hey! Glad to see you're enjoying Degreed. Do you already know about our mobile app for learning on the go?";
var Notification_InstallNativeAppStep1Item1$1 = "No, what is that?";
var Notification_InstallNativeAppStep1Item2$1 = "Yes I do!";
var Notification_InstallNativeAppStep2$1 = "Well, our apps allow you to find and capture learning anywhere. Just click the link you prefer to install, then get back to learning!";
var Notification_InstallNativeAppStep2Item1$1 = "iOS";
var Notification_InstallNativeAppStep2Item2$1 = "Android";
var Notification_InstallNativeAppStep3$1 = "Cool, glad you already know. We haven't seen any activity from the app yet, so we just wanted to be sure! Here are links in case you want to install.";
var Notification_InstallNativeAppStep3Item1$1 = "iOS";
var Notification_InstallNativeAppStep3Item2$1 = "Android";
var Notification_InstallNativeAppStep3Item3$1 = "Thanks";
var Notification_MultipleAssessmentsFoundAddSkills$1 = "We have found {{skillCount}} assessments on {{providerName}} that you might want to add to your profile.";
var Notification_MultipleAssessmentsFoundReviewSkills$1 = "We have found {{assessmentCount}} {{providerName}} skill assessments and we have added the ratings to the skills on your profile.";
var Notification_NewSkillsProviderAdded$1 = "{{providerName}} integration was added by {{organizationName}}. You can now add a {{providerName}} assessment to your skills.";
var Notification_PathwayContentCompletionReminder$1 = "You viewed items from the pathway {{pathwayname}} but didn’t mark them complete.";
var Notification_PrimaryTargetSetStepMainFormat$1 = "Hey there! To help you focus on the skills you care most about, we automatically set <strong>{0}</strong> as your primary plan. If you want to change focus, you can choose a different primary plan by selecting another from the list on the Home page.";
var Notification_PrimaryTargetSetStepMainFormatItem1$1 = "Great!";
var Notification_RecommendedBulkGeneric_NotificationTitleFormat$1 = "{{nameHtml}} recommended items to add to your profile.";
var Notification_RecommendedSkills_NotificationTitleFormat$1 = "{{nameHtml}} recommended skills to add to your profile.";
var Notification_ReviewItems$1 = "Review Items";
var Notification_SingleAssessmentFoundAddSkill$1 = 'We found an assessment for "{{skillName}}" on {{providerName}}. You might want to add this skill to your profile.';
var Notification_SingleAssessmentFoundReviewSkill$1 = 'We have found your {{providerName}} skill assessment of "{{skillName}}" and we have added the rating of "{{ratingLevel}}" to the skill on your profile.';
var Notification_SkillMatched$1 = '"{{skillName}}" was matched to another skill by your administrator and will now be referred to as "{{matchedToName}}".';
var Notification_SkillsAddedToProfileFromJobRole_Plural$1 = "Your organization added {{ count }} skills for the {{ role }} role to your profile. Review and rate your skills to improve recommendations.\n{{ viewSkillsHtml }}";
var Notification_SkillsAddedToProfileFromJobRole_Single$1 = "Your organization added {{ count }} skill for the {{ role }} role to your profile. Review and rate your skills to improve recommendations.\n{{ viewSkillsHtml }}";
var Notification_TitleFormat_OpportunityClosed$1 = "{{opportunityAuthor}} closed their opportunity";
var Notification_TitleFormat_OpportunityInterested$1 = "{{nameHtml}} is interested in the opportunity";
var Notification_TrackYourLearningStep1$1 = "Hey there! We can give you better items in your feed if you mark items complete. Would you like to learn how?";
var Notification_TrackYourLearningStep1Item1$1 = "Yes, please!";
var Notification_TrackYourLearningStep1Item2$1 = "Nope, I'm good";
var Notification_TrackYourLearningStep2$1 = "Fantastic. Anywhere you see content on Degreed, you can click the ✔︎ icon. This marks it complete. You can see all your completed content on your profile.";
var Notification_TrackYourLearningStep2Item1$1 = "Thanks!";
var Notification_TrackYourLearningStep2Item2$1 = "Show me another way to complete content";
var Notification_TrackYourLearningStep3$1 = "You can also click the “+” button at the top to add items. You can add videos, articles and more from any website. You can also add work experience and other things that are part of your learning.";
var Notification_TrackYourLearningStep3Item1$1 = "Thank you!";
var Notification_TrackYourLearningStep3Item2$1 = "Don't stop now, how else can I add?";
var Notification_TrackYourLearningStep4$1 = "You’ll like this next one. We have a mobile extension. From any page on the web, you can click the button and we’ll track your completion in Degreed.";
var Notification_TrackYourLearningStep4Item1$1 = "Thanks!";
var Notification_TrackYourLearningStep4Item2$1 = "Give me one more!";
var Notification_TrackYourLearningStep5$1 = "I like you, you’re serious about this learning stuff! You should turn on our integrations. That way, when you complete content on other platforms, they are automatically tracked on Degreed as well!";
var Notification_TrackYourLearningStep5Item1$1 = "Take me to integrations";
var Notification_TrackYourLearningStep5Item2$1 = "Thanks! I'll check back later";
var Notification_TrackYourLearningStep6$1 = "Have a great day of learning!";
var Notification_TrackYourLearningStep7$1 = "No problem. Have a great day of learning!";
var Notification_UpdateUserTagRatingsOnProfileStep1$1 = "It's time for your Skills Checkup!  Update your skill ratings and the skills you follow to reflect your progress.";
var Notification_UpdateUserTagRatingsOnProfileStep1Item1$1 = "Update Ratings";
var Notification_UpdateUserTagRatingsOnProfileStep1Item2$1 = "Done Rating";
var Notification_UpdateUserTagRatingsOnProfileStep2$1 = "Looking good!  Thanks for updating your skill ratings.  We'll make sure to remind you to update them again when you've made progress.";
var Notification_UpdateUserTagRatingsOnProfileStep2Item1$1 = "Finish Checkup";
var Notification_UpdateUserTagRatingsStep1$1 = "It's time for your Skill Checkup! Update your skill ratings to reflect your progress.";
var Notification_UpdateUserTagRatingsStep1Item1$1 = "Update Ratings";
var Notification_UpdateUserTagRatingsStep1Item2$1 = "Dismiss";
var Notification_UpdateUserTagsStep1$1 = "Hey, you've been using Degreed for a while now. Much of what you see is determined by the skills you've indicated you're interested in. Would you like to review and possibly change those now?";
var Notification_UpdateUserTagsStep1Item1$1 = "Sure!";
var Notification_UpdateUserTagsStep1Item2$1 = "No thanks, I'm good";
var Notification_UpdateUserTagsStep2$1 = "Great. Your skills are managed on your Profile Overview page (just telling you in case you want to adjust them again later). Click this button to change them!";
var Notification_UpdateUserTagsStep2Item1$1 = "Edit Skills";
var Notification_UpdateUserTagsStep3$1 = "No problem. You can always manage your skills from your Profile Overview page.";
var Notification_UserTagSetGoal_NotificationTitleFormat$1 = "{{nameHtml}} has updated your skill target for {{tag}} to {{level}}";
var Notification_ViewOnProfile$1 = "View on Profile";
var NotificationSvc_Notifications$1 = "Sorry! There was a problem accessing notifications.";
var newUserFollower_PluralFormat$1 = "{{nameHtml}} and {{number}} others are now following you";
var newUserFollower_SingleFormat$1 = "{{nameHtml}} is now following you";
var newTargetResource_Description$1 = "{{targetAuthor}} added an item to the plan {{targetTitle}}";
var newTargetAuthor_DescriptionFormat$1 = "{{targetAuthor}} added you as a collaborator to a plan {{targetTitle}}";
var newPathwayAuthor_DescriptionFormat$1 = "{{pathwayAuthor}} added you as a collaborator to a pathway {{pathwayName}}";
var NavigationSvc_LearnTitle$1 = "Learn";
var NavigationSvc_MainMenu$1 = "Main Menu";
var NavigationSvc_TodayTitle$1 = "Home";
var NativeInviteBanner_AppTagline$1 = "Make Learning a Daily Habit";
var NativeInviteBanner_AppTitle$1 = "Degreed";
var NativeInviteBanner_GetOnAppStore$1 = "Download on the App Store";
var NativeInviteBanner_GetOnPlayStore$1 = "Get it on Google Play";
var NativeInviteBanner_Open$1 = "Open";
var NativeInviteBanner_OpenInApp$1 = "Open in app";
var NativeInviteBanner_RedirectTitle$1 = "Degreed App - Redirecting...";
var MsTeams_AboutAppTitle$1 = "Learning should work for the workforce.";
var MsTeams_AccountNotAssociated$1 = "This user is not associated with a Degreed account. Please access the Degreed App from Microsoft Teams in a web browser and then refresh this page.";
var MsTeams_AddToCalendarButton$1 = "Add to Calendar";
var MsTeams_AddToCalendarSuccess$1 = "Successfully added to your MS Teams calendar";
var MsTeams_AddToCalendarTitle$1 = "Add this to your MS Teams Calendar";
var MsTeams_BotCapabilitiesTitle$1 = "Here are some of the things the Degreed bot can do";
var MsTeams_ChatErrorResponse$1 = "Sorry, I didn’t understand your request. Type ‘help’ to see what I can do";
var MsTeams_CommandsTitle$1 = "Here are the commands you can use with this app";
var MsTeams_DegreedBotDescription$1 = "Here’s your friendly reminder from Degreed to learn, share, and collaborate with your coworkers.";
var MsTeams_DegreedBotLongDescription$1 = "Degreed is the learning platform relied on by millions of employees from hundreds of global companies to build skills for today and tomorrow. Degreed connects self-directed learning, skill building, education access and insights so your organization can adapt faster and your people can advance farther. The Degreed app helps you discover learning content, build skills, and successfully take on new career challenges.\r\n\r\nIn order to use this app, you need to have an active Degreed account. If you do not have an account, please contact us at https://degreed.zendesk.com/hc so we can help you get set up with your account within your organization.";
var MsTeams_DegreedBotShortDescription$1 = "The Degreed Microsoft Teams App connects you to your Degreed learning, Skills, and career opportunities, so you’re ready to take your career to the next level whenever, and wherever, you want.";
var MsTeams_DegreedLongDescription$1 = "Degreed gives you everything you need to build the skills for what’s next. With the Degreed Microsoft Teams App, you can rapidly reinvent old skill sets or build new ones, without breaking your flow of work, to successfully take on new career challenges.";
var MsTeams_DegreedShortDescription$1 = "The Degreed Microsoft Teams App connects you to your Degreed learning, Skills, and career opportunities, so you’re ready to take your career to the next level whenever, and wherever, you want.";
var MsTeams_FeaturedPageDescription$1 = "Continue learning with curated content from your organization!";
var MsTeams_FeaturedPageLink$1 = "Featured Page";
var MsTeams_FeaturedPageTitle$1 = "The Featured Page";
var MsTeams_HelpDescription$1 = "Display a list of available commands";
var MsTeams_InstallationSuccess$1 = "Congratulations! You’ve successfully installed the Degreed Microsoft Teams App.";
var MsTeams_InstallationSuccessTitle$1 = "Use Degreed to help you learn, share, and collaborate with your coworkers. Please note: an existing Degreed account is required for access to the app, please contact our Customer Success team at support@degreed.com for additional help.";
var MsTeams_LeavingAppMessaging$1 = "You are leaving the Degreed Teams app, are you sure you want to proceed?";
var MsTeams_LoginWithDegreedBtn$1 = "Login With Degreed";
var MsTeams_NoDegreedAccount$1 = "We're sorry your account has not been configured with the Degreed app. Please contact your administrator or the Degreed Support Team for further assistance.";
var MsTeams_NoDegreedAccountSubtitle$1 = "Oops! We ran into an issue";
var MsTeams_NoNotifications$1 = "You don’t have any notifications at this time. Check back soon!";
var MsTeams_NotificationAssignedDescription$1 = "Send notifications when content items are assigned to you";
var MsTeams_NotificationOpportunityDescription$1 = "Send notifications when opportunities are shared";
var MsTeams_NotificationPersonFollowedDescription$1 = "Send notifications when people follow you";
var MsTeams_NotificationSharedDescription$1 = "Send notifications when content items are shared with you";
var MsTeams_NoUnreadNotifications$1 = "Looks like you’re caught up! You have no unread notifications";
var MsTeams_OnboardingAssignments$1 = "Access all of your past, upcoming, and overdue assignments.";
var MsTeams_OnboardingPathways$1 = "Access all the Pathways you follow and author. Pathways are guided learning paths of content that track your completion progress.";
var MsTeams_OnboardingPlans$1 = "View all of the Plans you follow and author. Plans are a collection of related Skills, Pathways, Groups, people, and learning content items.";
var MsTeams_OnboardingSaved$1 = "Revisit all of your Saved items, including those you saved from the Degreed Mobile App and the Degreed Web App.";
var MsTeams_OnboardingShared$1 = "View any content items that other people in your organization share with you, as well as the items you share with them.";
var MsTeams_OnboardingStartTour$1 = "Start the Tour";
var MsTeams_OnboardingTitle$1 = "Check out the content below to see what you can do with the Degreed app in Microsoft Teams.";
var MsTeams_PleaseSignIn$1 = "Please sign in.";
var MsTeams_PopupBlockedAlertDescription$1 = "Your browser settings blocked our Login popup. Click retry to allow this popup to display.";
var MsTeams_PopupBlockedAlertTitle$1 = "Popup Blocked";
var MsTeams_ShowAllNotifications$1 = "Show all notifications";
var MsTeams_ShowUnread$1 = "Show unread";
var MsTeams_ShowUnreadNotifications$1 = "Show unread notifications";
var MsTeams_SignedInFailure$1 = "Hmm. Something went wrong. Let's try again.";
var MsTeams_SignedInSuccess$1 = "You successfully signed in. Type ‘help’ to get started!";
var MsTeams_SignedOutSuccess$1 = "You have successfully signed out of Degreed";
var MsTeams_SignIn$1 = "Sign in";
var MsTeams_SignInRequired$1 = "To continue, you must sign in.";
var MsTeams_SignOut$1 = "Sign out";
var MsTeams_SignOutDescription$1 = "Sign out of the Degreed app";
var ModalSvc_AreYouSure$1 = "Are you sure you want to close this?";
var MentorshipNewRequest_NotificationTitleFormat$1 = "{{mentorshipMentee}} requested you as a mentor.";
var MentorshipFeedbackRequest_NotificationTitleFormat$1 = "{{mentorshipUser}} requested feedback on your mentorship.";
var MentorshipFeedbackReceived_NotificationTitleFormat$1 = "{{nameHtml}} sent feedback on your recent Mentorship connection.";
var MentorshipDeclinedRequest_NotificationTitleFormat$1 = "{{mentorshipMentor}} has declined your mentorship request.";
var MentorshipCompleted_NotificationTitleFormat$1 = "Your mentorship with {{mentorshipUser}} is complete.";
var MentorshipAcceptedRequest_NotificationTitleFormat$1 = "{{mentorshipMentor}} has accepted your mentorship request.";
var Mentoring_FeedbackGiven$1 = "Feedback Given";
var Mentoring_FeedbackReceived$1 = "Feedback Received";
var Mentoring_GiveFeedback$1 = "Give Feedback";
var Mentoring_GiveFeedback_FeedbackShared$1 = "Feedback Shared.";
var Mentoring_GiveFeedback_MenteeActionButton$1 = "Add Feedback";
var Mentoring_GiveFeedback_MenteeSubNote$1 = "Give feedback to your mentee about your experience.";
var Mentoring_GiveFeedback_MentorSubNote$1 = "Give feedback to your mentor about their progress.";
var Mentoring_PeerRating$1 = "Peer Rating";
var Mentoring_PeerRating_MenteeSubNote$1 = "Ask your mentee to rate selected skills.";
var Mentoring_PeerRating_MentorSubNote$1 = "Ask your mentor to rate selected skills.";
var Mentoring_PeerRating_Requested$1 = "Peer Rating Requested.";
var Mentoring_PeerRatingRequest$1 = "Peer Rating Request";
var Mentoring_PeerRatingRequest_Placeholder$1 = "Add a message to your request...";
var Mentoring_PlaceholderShareMessage$1 = "Share a message with your feedback...";
var Mentoring_RequestFeedback$1 = "Request Feedback";
var Mentoring_RequestFeedback_MenteeSubNote$1 = "Ask your mentee for feedback.";
var Mentoring_RequestFeedback_MentorSubNote$1 = "Ask your mentor for feedback.";
var Mentoring_RequestFeedback_Requested$1 = "Feedback Requested.";
var Mentoring_ReviewMenteeship$1 = "Review Menteeship";
var Mentoring_ReviewMentorship$1 = "Review Mentorship";
var Mentoring_ShareFeedback$1 = "Share Feedback";
var mentionInComment_GroupPluralFormat$1 = "{{nameHtml}} and {{number}} others mentioned you in {{groupNameHtml}}";
var mentionInComment_GroupSingleFormat$1 = "{{nameHtml}} mentioned you in {{groupNameHtml}}";
var mentionInComment_PluralFormat$1 = "{{nameHtml}} and {{number}} others mentioned you";
var mentionInComment_SingleFormat$1 = "{{nameHtml}} mentioned you";
var MediaFormCtrl_AddArticle$1 = "Add Article";
var MediaFormCtrl_AddedArticleSuccessFormat$1 = "Great work reading {{title}}!";
var MediaFormCtrl_AddGroups$1 = "Add Groups";
var MediaFormCtrl_AddingGroupsInfo$1 = "Adding groups will help users find content that is associated to groups they belong to.";
var MediaFormCtrl_AddPost$1 = "Add Post";
var MediaFormCtrl_AddToCatalogFormat$1 = "Add this article to {{orgName}}'s catalog";
var MediaFormCtrl_AddVideo$1 = "Add Video";
var MediaFormCtrl_AddVideoToCatalogFormat$1 = "Add this video to {{orgName}}'s catalog";
var MediaFormCtrl_ArticleUrl$1 = "Article URL";
var MediaFormCtrl_Category$1 = "Please add at least one category.";
var MediaFormCtrl_EditArticle$1 = "Edit Article";
var MediaFormCtrl_EditPost$1 = "Edit Post";
var MediaFormCtrl_EditVideo$1 = "Edit Video";
var MediaFormCtrl_ErrorUnaccessibleArticle$1 = "(unable to get details about this article because it may not be publicly accessible)";
var MediaFormCtrl_ErrorUnaccessiblePost$1 = "(unable to get details about this post because it may not be publicly accessible)";
var MediaFormCtrl_ErrorUnaccessibleVideo$1 = "(unable to get details about this video because it may not be publicly accessible)";
var MediaFormCtrl_ICreatedVideo$1 = "I created the content in this video";
var MediaFormCtrl_IWroteArticle$1 = "I wrote this article";
var MediaFormCtrl_IWrotePost$1 = "I wrote this post";
var MediaFormCtrl_NarratorFormat$1 = "Narrated by {{name}}";
var MediaFormCtrl_NewContentOwner$1 = "A new content owner required.";
var MediaFormCtrl_Provider$1 = "Provider";
var MediaFormCtrl_SaveArticle$1 = "Save Article";
var MediaFormCtrl_SavePost$1 = "Save Post";
var MediaFormCtrl_SaveVideo$1 = "Save Video";
var MediaFormCtrl_SelectionRequired$1 = "A selection is required.";
var MediaFormCtrl_Skills_Placeholder$1 = "Search for skills or select from suggestions below";
var MediaFormCtrl_Summary$1 = "Summary";
var MediaFormCtrl_Title$1 = "Title";
var MediaFormCtrl_Title_Placeholder$1 = "Add a title";
var MediaFormCtrl_TitleRequired$1 = "A title is required.";
var MediaFormCtrl_UrlError$1 = "The url is not publicly accessible, so cannot be added to our public library.";
var MediaFormCtrl_UrlOrRecordingRequired$1 = "A valid URL or video recording is required.";
var MediaFormCtrl_UrlOrUploadRequired$1 = "A valid URL or article upload is required.";
var MediaFormCtrl_UrlOrVideoUploadOrRecordingRequired$1 = "A valid URL, video upload or video recording is required.";
var MediaFormCtrl_UrlOrVideoUploadRequired$1 = "A valid URL or video upload is required.";
var MediaFormCtrl_UrlRequired$1 = "A valid URL is required.";
var MediaFormCtrl_ValidContentOwnerRequired$1 = "A valid content owner is required.";
var MediaFormCtrl_ValidNumberLength$1 = "Length must be a valid, reasonable number or left blank.";
var MediaFormCtrl_VideoLength$1 = "Video Length (minutes)";
var MediaFormCtrl_VideoSuccessFormat$1 = "Great work watching {{title}} !";
var MediaFormCtrl_VideoUrl$1 = "Video URL";
var MediaFormCtrl_WhatDidYouLearnLong$1 = "What did you learn from this article?";
var MediaFormCtrl_WhatDidYouLearnShort$1 = "What did you learn?";
var MediaFormCtrl_WhatDidYouLearnVideoLong$1 = "What did you learn from this video?";
var Markdown_ContentLength$1 = "Content is over the character limit.";
var Markdown_EditorHelperFormat$1 = "Images supported: {{supportedFiletypes}} up to {{filesizeLimit}}.";
var Markdown_MarkdownLearnMore$1 = "Learn more";
var Markdown_MarkdownSupported$1 = "Limited markdown is supported.";
var Markdown_toolbarA11y_addImage$1 = "Attach an image";
var Markdown_toolbarA11y_bold$1 = "Add bold text";
var Markdown_toolbarA11y_italic$1 = "Add italic text";
var Markdown_toolbarA11y_link$1 = "Add a link";
var Markdown_toolbarA11y_ol$1 = "Add a numbered list";
var Markdown_toolbarA11y_quote$1 = "Insert a quote";
var Markdown_toolbarA11y_ul$1 = "Add a bulleted list";
var Markdown_UploadErrorMessage$1 = "Sorry! There was a problem with the upload process";
var loginForm_EmailLabel$1 = "What is your email or username?";
var loginForm_EmailStateTooltip$1 = "On the next page, you will be able to enter or reset your password.";
var loginForm_InvalidEmail$1 = "Please enter your username or email address";
var loginForm_LoggingInAs$1 = "Logging in as {{startBold}}{{email}}{{endBold}}";
var loginForm_NoAccount$1 = "We're unable to find that account. If you are using Degreed with your company, contact your administrator.";
var loginForm_NoAccountCTA$1 = "No account yet?";
var loginForm_PasswordHelper$1 = "Password. Passwords must be at least 8 characters long and include 1 number & 1 letter.";
var loginForm_PasswordLabel$1 = "Now enter your password";
var loginForm_PasswordPlaceholder$1 = "Password";
var loginForm_PasswordPromptNoSSO$1 = "Log in with your password if SSO is not accessible at this time.";
var loginForm_SignUpNow$1 = "Sign up now";
var loginForm_SsoMessage$1 = "Good news! {{orgName}} uses Single Sign-On (SSO) to log in to Degreed. Click Continue to be taken there.";
var loginForm_WelcomeBackTitle$1 = "Welcome back.";
var loginForm_WelcomeTitle$1 = "Welcome.";
var LiveEvents_Hybrid$1 = "Hybrid";
var LiveEvents_JoinSession$1 = "Join Session";
var LiveEvents_RegisteredCheckboxLabel$1 = "I’ve registered for this {{inputType}}";
var LiveEvents_RegisteredCheckboxTooltip$1 = "Select this to have the {{inputType}} display on your Saved for Later page.";
var LiveEvents_RegisteredLabel$1 = "I registered for this session";
var LiveEvents_RegisterOnWebsiteFormat$1 = "Register on {{ name }} website";
var LiveEvents_RegistrationInstructions$1 = "Choose a session and register on the {{name}} website";
var LiveEvents_SessionsCardLabel$1 = "Live Sessions ({{count}})";
var likeGroupActivity_GoalAddedPluralFormat$1 = '{{nameHtml}} and {{number}} others liked your new goal "{{goalHtml}}" in {{groupNameHtml}}';
var likeGroupActivity_GoalAddedSingleFormat$1 = '{{nameHtml}} liked your new goal "{{goalHtml}}" in {{groupNameHtml}}';
var likeGroupActivity_GoalRemovedPluralFormat$1 = '{{nameHtml}} and {{number}} others liked your deleted goal "{{goalHtml}}" in {{groupNameHtml}}';
var likeGroupActivity_GoalRemovedSingleFormat$1 = '{{nameHtml}} liked your deleted goal "{{goalHtml}}" in {{groupNameHtml}}';
var likeGroupActivity_GoalUpdatedPluralFormat$1 = '{{nameHtml}} and {{number}} others liked your updated goal "{{goalHtml}}" in {{groupNameHtml}}';
var likeGroupActivity_GoalUpdatedSingleFormat$1 = '{{nameHtml}} liked your updated goal "{{goalHtml}}" in {{groupNameHtml}}';
var likeGroupActivity_GroupAddedPluralFormat$1 = '{{nameHtml}} and {{number}} others liked your new group "{{groupNameHtml}}"';
var likeGroupActivity_GroupAddedSingleFormat$1 = '{{nameHtml}} liked your new group "{{groupNameHtml}}"';
var likeGroupActivity_GroupPostPluralFormat$1 = "{{nameHtml}} and {{number}} others liked your post in {{groupNameHtml}}";
var likeGroupActivity_GroupPostSingleFormat$1 = "{{nameHtml}} liked your post in {{groupNameHtml}}";
var likeGroupActivity_GroupUpdatedPluralFormat$1 = "{{nameHtml}} and {{number}} others liked your group update in {{groupNameHtml}}";
var likeGroupActivity_GroupUpdatedSingleFormat$1 = "{{nameHtml}} liked your group update in {{groupNameHtml}}";
var likeGroupActivity_InputRecommendedSingleFormat$1 = '{{nameHtml}} liked your share of "{{inputTitleHtml}}" to {{groupNameHtml}}';
var likeGroupActivity_UserAddedPluralFormat$1 = "{{nameHtml}} and {{number}} others liked your addition of {{user}} to {{groupNameHtml}}";
var likeGroupActivity_UserAddedSingleFormat$1 = "{{nameHtml}} liked your addition of {{user}} to {{groupNameHtml}}";
var likeGroupActivity_UserInputPluralFormat$1 = "{{nameHtml}} and {{number}} others liked your {{inputType}} {{inputTitleHtml}} in {{groupNameHtml}}";
var likeGroupActivity_UserInputSingleFormat$1 = "{{nameHtml}} liked your {{inputType}} {{inputTitleHtml}} in {{groupNameHtml}}";
var likeComment_PluralFormat$1 = "{{nameHtml}} and {{number}} others liked your comment";
var likeComment_PluralGroupFormat$1 = "{{nameHtml}} and {{number}} others liked your comment in {{groupNameHtml}}";
var likeComment_SingleFormat$1 = "{{nameHtml}} liked your comment";
var likeComment_SingleGroupFormat$1 = "{{nameHtml}} liked your comment in {{groupNameHtml}}";
var LearningSearch_ActiveSubscription$1 = "Active Subscription";
var LearningSearch_BackToSearch$1 = "Back to Search";
var LearningSearch_Careers$1 = "Careers";
var LearningSearch_Clear$1 = "Clear";
var LearningSearch_ClearFilters$1 = "Clear Filters";
var LearningSearch_ClosedGroup$1 = "Closed Group";
var LearningSearch_CompletedAllFormat$1 = "Congratulations! You completed all the matching {{inputType}} in this catalog for now. Try another content type next!";
var LearningSearch_Content$1 = "Content";
var LearningSearch_DefaultSearchTerm$1 = "Education";
var LearningSearch_DidYouMean$1 = "Did you mean {{suggestedTermHtml}}";
var LearningSearch_Directories$1 = "Pages";
var LearningSearch_ErrorContactSupport$1 = "If this issue continues, {{hrefStart}}Contact Support{{hrefEnd}}.";
var LearningSearch_ErrorDescription$1 = "We had an issue retrieving your search results. Reload or refresh this page to try again.";
var LearningSearch_ErrorTitle$1 = "Oops, something went wrong";
var LearningSearch_ErrorTitleSideBar$1 = "Oops, something went wrong. Reload or refresh this page to try again.";
var LearningSearch_FilterApplied$1 = "1 Filter Applied";
var LearningSearch_FiltersApplied$1 = "{{count}} Filters Applied";
var LearningSearch_GoToMarketplace$1 = "Go to Marketplace";
var LearningSearch_GoToSearch$1 = "Go to Search Page";
var LearningSearch_Groups$1 = "Groups";
var LearningSearch_GroupsLandingSearchInput$1 = "Groups for:";
var LearningSearch_Hmm$1 = "Hmm.";
var LearningSearch_JobRoles$1 = "Plans";
var LearningSearch_Learning$1 = "Learning";
var LearningSearch_LoadMoreEndorsed$1 = "Load more endorsed content";
var LearningSearch_LookingFor$1 = "I'm looking for...";
var LearningSearch_More$1 = "more";
var LearningSearch_MoreFilters$1 = "More Filters";
var LearningSearch_MoreFormat$1 = "{{count}} more {{itemname}}";
var LearningSearch_MostPopular$1 = "Most Popular";
var LearningSearch_MostRecent$1 = "Most Recent";
var LearningSearch_MostRelevant$1 = "Most Relevant";
var LearningSearch_NoResultsFound$1 = "We didn't find any results for {{termHtml}}";
var LearningSearch_NoResultsFoundAdvice$1 = "Check your spelling or try a different search term.";
var LearningSearch_NoResultsFoundMsg$1 = 'We didn’t find any results for "{{ searchTerm }}"';
var LearningSearch_NoResultsFoundTitle$1 = "No Results Found";
var LearningSearch_NoSidebarFormat$1 = "There are no related {{type}} results found.";
var LearningSearch_OpenGroup$1 = "Open Group";
var LearningSearch_OpportunitiesTitle$1 = "Opportunities";
var LearningSearch_OppsLandingSearchInput$1 = "Opportunities for:";
var LearningSearch_OppsSidebarTooltip$1 = "{{matches}} out of {{totalSkills}} Skills";
var LearningSearch_Pathways$1 = "Pathways";
var LearningSearch_PathwaysAndPlans$1 = "Pathways & Plans";
var LearningSearch_People$1 = "People";
var LearningSearch_PeopleAndGroups$1 = "People & Groups";
var LearningSearch_PeopleLandingSearchInput$1 = "People for:";
var LearningSearch_Popular$1 = "Popular";
var LearningSearch_ProviderNoResultsFoundAdvice$1 = "Contact your Degreed Site Administrator to ask if they can add it.";
var LearningSearch_ProviderNotPartOfCatalog$1 = '"{{providerName}}" is not part of your catalog.';
var LearningSearch_QA$1 = "Q&A";
var LearningSearch_RangeCount$1 = "{{ rangeStart }}-{{ rangeEnd }} of {{ totalNumResults }}";
var LearningSearch_RangeCountPlus$1 = "{{ rangeStart }}-{{ rangeEnd }} of {{ totalNumResults }}+";
var LearningSearch_Recent$1 = "Recent";
var LearningSearch_Relevant$1 = "Relevant";
var LearningSearch_RemoveFiltersAdvice$1 = "Try removing some of your filters.";
var LearningSearch_ResetFiltersAdvice$1 = "Try resetting your filters or updating your default preferred language settings.";
var LearningSearch_ResetFiltersMsg$1 = "Try resetting your filters or updating your default preferred language settings.";
var LearningSearch_ResultsCount$1 = "{{count}} results";
var LearningSearch_ResultsCount_PluralFormat$1 = "{{count}} results";
var LearningSearch_ResultsCount_SingleFormat$1 = "{{count}} result";
var LearningSearch_ResultSetRangeCount$1 = "Results {{ rangeStart }}-{{ rangeEnd }} of {{ totalNumResults }}";
var LearningSearch_ResultSetRangeCountPlus$1 = "Results {{ rangeStart }}-{{ rangeEnd }} of {{ totalNumResults }}+";
var LearningSearch_ResultsFor$1 = 'Results for "{{searchTerm}}"';
var LearningSearch_Roles$1 = "Roles";
var LearningSearch_SearchedInsteadFor$1 = "Searched instead for {{suggestedTermHtml}}";
var LearningSearch_SearchError$1 = "Sorry! There was a problem retrieving learning results.";
var LearningSearch_SearchFilters$1 = "Search Filters";
var LearningSearch_SearchFiltersDescription$1 = "On checking any of the below checkboxes, main content will update";
var LearningSearch_ShowFilters$1 = "Show Filters";
var LearningSearch_ShowingResultsFor$1 = "Showing results for {{termHtml}}";
var LearningSearch_Skills$1 = "Skills";
var LearningSearch_SkillsLandingSearchInput$1 = "Skills for:";
var LearningSearch_SkillsResults$1 = "Skills results for";
var LearningSearch_Subscription$1 = "Subscription";
var LearningSearch_SuggestedSearches$1 = "Related Skills";
var LearningSearch_Title$1 = "Search";
var LearningSearch_Top$1 = "Top";
var LearningSearch_Trending$1 = "Trending";
var LearningSearch_ViewAll$1 = "View All";
var LearningSearch_ViewMore$1 = "View More";
var LearningCtrl_ActiveSubscription$1 = "Active Subscription";
var LearningCtrl_DefaultSearchTerm$1 = "Education";
var LearningCtrl_SearchError$1 = "Sorry! There was a problem retrieving learning results.";
var LearningCtrl_Subscription$1 = "Subscription";
var LearningController_ActiveSubscription$1 = "Indicates Active Subscription";
var LearningController_All$1 = "All";
var LearningController_Content$1 = "Content";
var LearningController_FeaturedContent$1 = "Featured Content";
var LearningController_FeaturedCourseProviders$1 = "Featured Course Providers";
var LearningController_FeaturedPathways$1 = "Featured Pathways";
var LearningController_FindSomething$1 = "Find something to learn";
var LearningController_More$1 = "More";
var LearningController_NoCategories$1 = "No Categories Specified";
var LearningController_Pathways$1 = "Pathways";
var LearningController_People$1 = "People";
var LearningController_QA$1 = "Q&A";
var LearningController_RefineResults$1 = "Refine Results";
var LearningController_SuggestedPeopleToFollow$1 = "Suggested People to Follow";
var LearningController_Top$1 = "Top";
var LearningController_TopCategories$1 = "Top Categories";
var LearningController_Type$1 = "Type";
var LearningController_ViewAll$1 = "View All";
var LearningController_VisitSite$1 = "Visit {{Name}} Site";
var LearningController_YourTopCategories$1 = "Your Top Categories";
var LearningBrowse_FeaturedContent$1 = "Featured Content";
var LearningBrowse_FeaturedCourseProviders$1 = "Featured Providers";
var LearningBrowse_FeaturedPathways$1 = "Featured Pathways";
var LearningBrowse_FeaturedTargets$1 = "Featured";
var LearningBrowse_NewContent$1 = "New Content";
var LearningBrowse_SuggestedGroups$1 = "Suggested Groups to Join";
var LearningBrowse_SuggestedJobRoles$1 = "Suggested Plans to Follow";
var LearningBrowse_SuggestedOpportunities$1 = "Suggested Opportunities";
var LearningBrowse_SuggestedPeopleToFollow$1 = "Suggested People to Follow";
var LearnerHome_ActivityFrom$1 = "Activity From";
var LearnerHome_ActivityIn$1 = "Activity In";
var LearnerHome_BasedOnYourSkills$1 = "Based on your Skills";
var LearnerHome_ConnectDesc$1 = "Connect with learners who share your learning interests and mentors who can support you on your learning journey.";
var LearnerHome_ConnectLearners$1 = "Connect with Learners";
var LearnerHome_ConnectLearnersDesc$1 = "Connect and network with learners who share your learning interests.";
var LearnerHome_ConnectMentors$1 = "Connect with Mentors";
var LearnerHome_ConnectMentorsDesc$1 = "Connect with mentors who can guide and support you on your learning journey.";
var LearnerHome_ConnectWithPeopleTitle$1 = "Connect";
var LearnerHome_ContinueLearning$1 = "Continue Learning";
var LearnerHome_FindMentors$1 = "Find Mentors";
var LearnerHome_GroupViewMoreLink$1 = "Visit the group";
var LearnerHome_GroupViewMoreTitle$1 = "Want to see more activity?";
var LearnerHome_ItemsCompleted$1 = "Items Completed";
var LearnerHome_ItemsCompletedDesc$1 = "Learning content you have completed in Degreed this month.";
var LearnerHome_ItemsDelta$1 = "+{{count}} items this month";
var LearnerHome_ItemsViewed$1 = "Items Viewed";
var LearnerHome_ItemsViewedDesc$1 = "Learning content you have viewed in Degreed this month.";
var LearnerHome_LearningBudget$1 = "Learning Budget";
var LearnerHome_LearningDelta$1 = "+{{count}} minutes this month";
var LearnerHome_LearningTime$1 = "Learning Time";
var LearnerHome_LearningTimeDesc$1 = "Time you have spent learning in Degreed this month.";
var LearnerHome_MentorConnect$1 = "Connect with a Mentor";
var LearnerHome_MentorshipExpertise$1 = "Mentorship Expertise";
var LearnerHome_NoChanges$1 = "No changes from last month";
var LearnerHome_OpportunitiesViewMoreLink$1 = "More Opportunities";
var LearnerHome_OpportunityViewMoreLink$1 = "View all of your opportunity matches";
var LearnerHome_OpportunityViewMoreTitle$1 = "Looking for additional opportunities?";
var LearnerHome_PeopleToFollow$1 = "People to Follow";
var LearnerHome_PeopleYouFollow$1 = "People You Follow";
var LearnerHome_PointsDelta$1 = "+{{count}} points this month";
var LearnerHome_PointsEarned$1 = "Points Earned";
var LearnerHome_PointsEarnedDesc$1 = "Points you have earned in Degreed this month.";
var LearnerHome_RecentActivity$1 = "Recent Activity";
var LearnerHome_RecentlyViewed$1 = "Recently Viewed Content";
var LearnerHome_RequestMentorship$1 = "Request Mentorship";
var LearnerHome_SearchPeople$1 = "Search People";
var LearnerHome_SkillExplore$1 = "Skill To Explore";
var LearnerHome_SkillsToFollow$1 = "Skills To Follow";
var LearnerHome_TrendingAtOrgSubtitle$1 = "Learning content trending within your organization.";
var LearnerHome_TrendingAtOrgTitle$1 = "Trending at {{orgName}}";
var LearnerHome_TrendingWithin$1 = "Trending Within";
var LearnerHome_UseYourBudget$1 = "Use Your Budget";
var LearnerHome_ViewMoreLink$1 = "Search more on {{term}}";
var LearnerHome_ViewMoreMentorsLink$1 = "Browse for more mentors";
var LearnerHome_ViewMoreTitle$1 = "Didn’t find what you were looking for?";
var LearnerHome_ViewMoreUserLink$1 = "Browse for more people to follow";
var LearnerHome_ViewMoreUserTitle$1 = "Didn’t find who you were looking for?";
var LearnerHome_ViewYourBalance$1 = "View Your Balance";
var LearnerHome_WelcomeSectionSubTitle$1 = "Welcome to your personalized Learning Hub in Degreed.";
var LearnerHome_WelcomeSectionSubTitleShort$1 = "Welcome to your personalized Learning Hub.";
var LearnerHome_WelcomeSectionTitle$1 = "Hello, {{firstName}}";
var KPI_AddedSkillsByOthersAverage$1 = "Average Number of Added Skills for My Role";
var KPI_AddedSkillsByOthersAverageToolTip$1 = "The average number of skills added by others in your role.";
var KPI_AverageRating$1 = "average rating";
var KPI_AvgFormat$1 = "{{average}} avg";
var KPI_DaysSinceLastRating$1 = "Days Passed Since Last Skill Rating";
var KPI_DaysSinceLastRatingToolTip$1 = "The number of days since your last skill rating. This does not change based on the date range selected.";
var KPI_Decrease$1 = "Decrease";
var KPI_Increase$1 = "Increase";
var KPI_JobRoleSkillCount$1 = "Top Skills for My Role";
var KPI_JobRoleSkillCountToolTip$1 = "The count of how many top added skills you have out of the top 10 skills added by others in your role.";
var KPI_NoChange$1 = "No increase or decrease";
var KPI_NoJobRoleToolTip$1 = "Add your job role in Profile Settings to display this insight.";
var KPI_NotApplicableToolTip$1 = "There are not enough other users in your role to populate this insight.";
var KPI_OpportunityApplyName$1 = "Clicked Apply";
var KPI_OpportunityApplyTooltip$1 = "{{count}} users have clicked apply on this opportunity since {{startDate}}.";
var KPI_OpportunityDaysOpenName$1 = "Days Open";
var KPI_OpportunityDaysOpenTooltip$1 = "For open opportunities, this is the number of days that the opportunity has been open. For closed, this is the number of days the opportunity was open.";
var KPI_OpportunityInterestedName$1 = "Interested";
var KPI_OpportunityInterestedTooltip$1 = "{{count}} users expressed interest in this opportunity since {{startDate}}.";
var KPI_OpportunitySelectedName$1 = "Selected";
var KPI_OpportunitySelectedTooltip$1 = "The total number of candidates selected for the opportunity";
var KPI_OpportunityUniqueViewsName$1 = "Opportunity Views";
var KPI_OpportunityUniqueViewsTooltip$1 = "The total number of unique user views for the opportunity.";
var KPI_OpportunityUsersName$1 = "Users Viewed";
var KPI_OpportunityUsersTooltip$1 = "{{count}} users viewed this opportunity at least once since {{startDate}}.";
var KPI_OpportunityViewsName$1 = "Views";
var KPI_OpportunityViewsTooltip$1 = "This opportunity has been viewed {{count}} times since {{ startDate }}, including by returning viewers.";
var KPI_OrgOpportunityActiveOpportunitiesName$1 = "Open Opportunities";
var KPI_OrgOpportunityActiveOpportunitiesTooltip$1 = "The overall count of open opportunities.";
var KPI_OrgOpportunityApplicantsInOpportunitiesName$1 = "Total interested";
var KPI_OrgOpportunityApplicantsInOpportunitiesTooltip$1 = "The overall count of users interested in open opportunities.";
var KPI_OrgOpportunityOpportunitiesWithInterestName$1 = "Total opportunities saved for later";
var KPI_OrgOpportunityOpportunitiesWithInterestTooltip$1 = "The overall count of open opportunities that one or more user(s) has saved.";
var KPI_OrgOpportunityOpportunityUniqueUserViewName$1 = "Open Opportunity Views";
var KPI_OrgOpportunityOpportunityUniqueUserViewTooltip$1 = "The total number of unique user views for distinct opportunities.";
var KPI_OrgOpportunitySelectedCandidatesName$1 = "Selected Candidates Past 30 Days";
var KPI_OrgOpportunitySelectedCandidatesTooltip$1 = "The total number of candidates selected for opportunities in the past 30 days.";
var KPI_OverTheLastXDays$1 = "in the last {{number}} days";
var KPI_OverTheLastXYears$1 = "in the last {{number}} years";
var KPI_OverTheLastYear$1 = "in the last year";
var KPI_PathwayCompletedName$1 = "Follower Completions";
var KPI_PathwayCompletedTooltip$1 = "{{ count }} learners marked all items complete since {{ startDate }}.";
var KPI_PathwayEnrollName$1 = "Followers";
var KPI_PathwayEnrollTooltip$1 = "{{ count }} learners currently follow this pathway.";
var KPI_PathwayViewsName$1 = "Follower Views";
var KPI_PathwayViewsTooltip$1 = "{{ count }} learners viewed this pathway at least once since {{ startDate }}.";
var KPI_PersonalSkillProgression_Empty$1 = "Add skills to your skill profile to populate this metric";
var KPI_RatedSkillsByOthersAverage$1 = "Average Number of Rated Skills for My Role";
var KPI_RatedSkillsByOthersAverageToolTip$1 = "The average number of skills rated by others in your role.";
var KPI_SkillsAdded$1 = "Skills Added in the Last {{number}} Days";
var KPI_SkillsAddedPast12$1 = "Skills Added in the Past Year";
var KPI_SkillsAddedPast12ToolTip$1 = "The total number of skills added to the learner’s profile in the selected time period.";
var KPI_SkillsAddedToolTip$1 = "The total number of skills added to the learner’s profile in the selected time period.";
var KPI_SkillsRated$1 = "Skills Rated in the Last {{number}} Days";
var KPI_SkillsRatedPast12$1 = "Skills Rated in the Past Year";
var KPI_SkillsRatedPast12ToolTip$1 = "The total number of unique skills that were rated in the selected time period.";
var KPI_SkillsRatedToolTip$1 = "The total number of unique skills that were rated in the selected time period.";
var KPI_TargetFollowersName$1 = "Followers";
var KPI_TargetFollowersTooltip$1 = "Number of users currently following the Plan";
var KPI_TargetViewsName$1 = "Follower Views";
var KPI_TargetViewsTooltip$1 = "{{count}} learners viewed this plan at least once since {{ startDate }}.";
var InviteAddPeopleCtrl_FollowPersonFormat$1 = "Follow {{count}} More Person";
var InviteAddPeopleCtrl_FollowPersonsFormat$1 = "Follow {{count}} More People";
var InviteAddCategoriesCtrl_FollowCategoriesFormat$1 = "Follow {{count}} More Skills";
var InviteAddCategoriesCtrl_FollowCategoryFormat$1 = "Follow {{count}} More Category";
var IntegrationsSvc_AlisonDescription$1 = "Import all courses from my Alison profile daily.<br><strong>Note:</strong> Requires a public Alison profile.";
var IntegrationsSvc_AlisonLabelText$1 = "Alison User Name/User Id";
var IntegrationsSvc_AlisonPlaceholderText$1 = "User Id/User Name";
var IntegrationsSvc_AlisonUrl$1 = "http://alison.com/profile/";
var IntegrationsSvc_AutoNotifyLabelFormat$1 = "Automatically notify me when my {{friendType}} join Degreed.";
var IntegrationsSvc_CodecademyDescription$1 = "Import completed courses from Codecademy daily.<br><strong>Note:</strong> Requires a public Codecademy profile.";
var IntegrationsSvc_CodecademyLabelText$1 = "Codeacademy User Name";
var IntegrationsSvc_CodecademyPlaceholderText$1 = "Username";
var IntegrationsSvc_CodecademyUrl$1 = "http://www.codecademy.com/";
var IntegrationsSvc_CodeSchoolDescription$1 = "Import completed courses from Code School daily.<br><strong>Note:</strong> Requires a public Code School profile.";
var IntegrationsSvc_CodeSchoolLabelText$1 = "Code School User Name";
var IntegrationsSvc_CodeSchoolPlaceholderText$1 = "Username";
var IntegrationsSvc_CodeSchoolUrl$1 = "https://www.codeschool.com/users/";
var IntegrationsSvc_Contacts$1 = "Contacts";
var IntegrationsSvc_Followers$1 = "Followers";
var IntegrationsSvc_Friends$1 = "Friends";
var IntegrationsSvc_GoodreadsDescription$1 = "Import books I have marked 'read' in Goodreads daily.<br><strong>Note:</strong> Edit your Goodreads profile to specify a username.";
var IntegrationsSvc_GoodreadsLabelText$1 = "Goodreads User Name";
var IntegrationsSvc_GoodreadsPlaceholderText$1 = "Username";
var IntegrationsSvc_GoogleplusFriends$1 = "Google Contacts";
var IntegrationsSvc_KhanAcademyDescription$1 = "Import my completed videos and assessments from Khan Academy daily.<br><strong>Note:</strong> All Khan Academy content is available for free at www.khanacademy.org";
var IntegrationsSvc_KhanAcademyLabelText$1 = "Khan Academy User Name";
var IntegrationsSvc_KhanAcademyPlaceholderText$1 = "Username";
var IntegrationsSvc_NoFriendsDescription$1 = "None of your {{friendType}} have joined Degreed yet, but we'll let you know when they do!";
var IntegrationsSvc_NoGoogleplusFriendsHeader$1 = "No contacts found.";
var IntegrationsSvc_PluralsightDescription$1 = "Import completed courses from Pluralsight daily.<br><strong>Note:</strong> This integration requires a public Pluralsight profile with the 'Completed courses' tile visible.";
var IntegrationsSvc_PluralsightLabelText$1 = "Pluralsight User Name";
var IntegrationsSvc_PluralsightPlaceholderText$1 = "Username";
var IntegrationsSvc_PluralsightUrl$1 = "http://app.pluralsight.com/profile/";
var IntegrationsSvc_PocketDescription$1 = "Import articles I have marked as 'archived' in Pocket daily.";
var IntegrationsSvc_PocketLabelText$1 = "Pocket User Name";
var IntegrationsSvc_PocketPlaceholderText$1 = "Username";
var IntegrationsSvc_SkillshareDescription$1 = "Import all courses from my Skillshare profile daily.<br><strong>Note</strong>: Requires a public Skillshare profile.";
var IntegrationsSvc_SkillshareLabelText$1 = "Skillshare User Name/User Id";
var IntegrationsSvc_SkillsharePlaceholderText$1 = "User Name/User Id";
var IntegrationsSvc_SkillshareUrl$1 = "https://www.skillshare.com/user/";
var IntegrationsSvc_SkillshareUrlext$1 = "Shillshare User Name/User Id";
var IntegrationsSvc_SlackDescription$1 = "Get Today’s Learning and shared content delivered through slack.";
var IntegrationsSvc_TreehouseDescription$1 = "Import completed courses from Treehouse daily.<br><strong>Note:</strong> Requires a public Treehouse profile.";
var IntegrationsSvc_TreehouseLabelText$1 = "Treehouse User Name";
var IntegrationsSvc_TreehousePlaceholderText$1 = "Username";
var IntegrationsSvc_TreehouseUrl$1 = "http://www.teamtreehouse.com/";
var IntegrationsSvc_UdemyDescription$1 = "Import all courses from my Udemy profile daily.<br><strong>Note:</strong> Requires a public Udemy profile with visible courses.";
var IntegrationsSvc_UdemyLabelText$1 = "Udemy User Id";
var IntegrationsSvc_UdemyPlaceholderText$1 = "User Id";
var IntegrationsSvc_UdemyUrl$1 = "https://www.udemy.com/u/";
var IntegrationsSvc_ViewContacts$1 = "View Contacts";
var IntegrationsSvc_ViewFollowers$1 = "View Followers";
var IntegrationsSvc_ViewFriends$1 = "View Friends";
var Integrations_Add_Type_Completion$1 = "Add Completion Connector";
var Integrations_Add_Type_Content$1 = "Add Content Connector";
var Integrations_Add_Type_Skill$1 = "Add Skill Connector";
var Integrations_Add_Type_SkillAssessment$1 = "Add Skill Assessment Connector";
var Integrations_AdvancedSSO$1 = "Advanced SSO";
var Integrations_AlisonImportError$1 = "Whoops! Something went wrong importing your courses from Alison. Please verify your unique Alison user id.";
var Integrations_AlisonPublicProfile$1 = "Requires a public Alison profile.";
var Integrations_AlisonUserId$1 = "Alison User Id";
var Integrations_AlisonUserIdUserName$1 = "Alison User Id/Alison User Name";
var Integrations_APIKeys$1 = "API Keys";
var Integrations_BasicSSO$1 = "Basic SSO";
var Integrations_ClientId$1 = "Client Id";
var Integrations_ClientSecret$1 = "Client Secret";
var Integrations_CodecademyImportError$1 = "Whoops! Something went wrong importing your courses from Codecademy. Please verify your username.";
var Integrations_CodecademyPublicProfile$1 = "Requires a public Codecademy profile.";
var Integrations_CodecademyUsername$1 = "Codecademy username";
var Integrations_CodeSchoolImportError$1 = "Whoops! Something went wrong importing your courses from Code School. Please verify your username.";
var Integrations_CodeSchoolPublicProfile$1 = "Requires a public Code School profile.";
var Integrations_CodeSchoolUsername$1 = "Code School username";
var Integrations_ConfigureConnector_CreateAPI$1 = "You need to configure a connector or create an API key to activate your integration.";
var Integrations_Connect$1 = "Connect";
var Integrations_Connected$1 = "Connected";
var Integrations_ConnectIntegrations$1 = "Degreed integrations make it easy to show off what you know. Simply connect to these services and import completed items to your Degreed profile.";
var Integrations_ConnectorSync_Type_Badge$1 = "Sync badges to Degreed from {{providerName}}";
var Integrations_ConnectorSync_Type_BulkOpportunities$1 = "Sync bulk opportunities to Degreed from {{providerName}}";
var Integrations_ConnectorSync_Type_Completion$1 = "Sync completions to Degreed from {{providerName}}";
var Integrations_ConnectorSync_Type_Content$1 = "Sync content to Degreed from {{providerName}}";
var Integrations_ConnectorSync_Type_Opportunity$1 = "Sync opportunities to Degreed from {{providerName}}";
var Integrations_ConnectorSync_Type_RequiredLearning$1 = "Sync required learning to Degreed from {{providerName}}";
var Integrations_ConnectorSync_Type_Skill$1 = "Sync skills to Degreed from {{providerName}}";
var Integrations_ConnectorSync_Type_SkillAssessment$1 = "Sync skill assessments to Degreed from {{providerName}}";
var Integrations_ConnectorSyncMustVerify$1 = "You must verify before saving.";
var Integrations_ConnectorSyncNightly$1 = "Please allow 24 hours for data to sync. Data syncs nightly.";
var Integrations_ConsumerSetup$1 = "Consumer Setup";
var Integrations_ConsumerSetupMetadata$1 = "Content can be enabled by Degreed Admins to be indexed in Degreed. Learners who click on this content will hit a paywall";
var Integrations_ContactYourCEP$1 = "Contact your Client Engagement Partner for assistance";
var Integrations_ContentProviders$1 = "Content Providers";
var Integrations_ContentRemain$1 = "Content that is already part of pathways or plans will remain.";
var Integrations_ContentSyncPendingMeta$1 = "Allow 24 hours for {{ providerName }} to sync. {{ providerName }} syncs nightly.";
var Integrations_ContentVisibility$1 = "Content Visibility";
var Integrations_CourseraImportError$1 = "Whoops! Something went wrong importing your courses from Coursera.";
var Integrations_CourseraPublicProfile$1 = "Requires a public Coursera profile.";
var Integrations_CourseraUserId$1 = "Coursera User Id";
var Integrations_CustomVisitLink$1 = "Custom Visit Link";
var Integrations_DeleteAnyAssociated$1 = "Delete any associated user licenses that may exist";
var Integrations_DeleteAnyContent$1 = "Delete any content from {{ providerName }}";
var Integrations_DeleteAnyIncomplete$1 = "Delete any incomplete required learning (user completions will be kept), if required learning is configured";
var Integrations_DISABLE$1 = "DISABLE";
var Integrations_DisableConnector$1 = "Disable Connector";
var Integrations_DisableProvider$1 = "Disable Provider";
var Integrations_DisablingConnectorWill$1 = "Disabling this connector will delete any content from {{ providerName }} in your Degreed instance.";
var Integrations_DisablingProviderWill$1 = "Disabling this provider will do the following:";
var Integrations_Disconnect$1 = "Disconnect";
var Integrations_Edit_Type_Completion$1 = "Edit Completion Connector";
var Integrations_Edit_Type_Content$1 = "Edit Content Connector";
var Integrations_Edit_Type_Skill$1 = "Edit Skill Connector";
var Integrations_Edit_Type_SkillAssessment$1 = "Edit Skill Assessment Connector";
var Integrations_EditGoodreadsProfile$1 = "Edit your Goodreads profile to specify a username.";
var Integrations_EmailAssertionName$1 = "Email Assertion Name";
var Integrations_Enable$1 = "Enable";
var Integrations_EnableSSO$1 = "Enable SSO";
var Integrations_EnterpriseAccountId$1 = "Enterprise Account Id";
var Integrations_EnterpriseSetMetadata$1 = "Content is available with an enterprise license";
var Integrations_EnterpriseSetup$1 = "Enterprise";
var Integrations_EnterpriseSetupMetadata$1 = "Content is available with an enterprise license";
var Integrations_EverybodyCanSee$1 = "Everybody can see it";
var Integrations_FailedImport$1 = "An error occurred setting up your integration. Please try again later.";
var Integrations_FallbackContentImage$1 = "Fallback Content Image";
var Integrations_FilterIntegrations$1 = "Filter Integrations";
var Integrations_FirstNameAssertionName$1 = "First Name Assertion Name";
var Integrations_FreeOneClickSetup$1 = "Free One-Click";
var Integrations_GenerateAPIKey$1 = "Generate API Key";
var Integrations_GenerateAPIKeyProvider$1 = "Generate an API key for this provider";
var Integrations_GlobalVisibility$1 = "Global Visibility";
var Integrations_GoodreadsImportError$1 = "Whoops! Something went wrong importing your books from Goodreads. Please re-enable Goodreads integration above and we'll try again.";
var Integrations_GoodreadsUsername$1 = "Goodreads username";
var Integrations_GoodreadsUsernameEdit$1 = "Goodreads username (edit your Goodreads profile to specify a username)";
var Integrations_ImageForProviderCard$1 = "This is the image displayed for the provider's card.";
var Integrations_ImageForProviderFavicon$1 = "This is the image displayed for the provider's favicon.";
var Integrations_ImageForProviderLogo$1 = "This is the image displayed for the provider's logo.";
var Integrations_ImportAlisonCourses$1 = "Import my completed courses from Alison";
var Integrations_ImportAlisonDaily$1 = "Import all courses from my Alison profile daily.";
var Integrations_ImportArchivedPocket$1 = "Import my archived articles from Pocket";
var Integrations_ImportCodecademyDaily$1 = "Import completed courses from Codecademy daily.";
var Integrations_ImportCodeSchoolDaily$1 = "Import completed courses from Code School daily.";
var Integrations_ImportCompletedCodecademy$1 = "Import my completed courses from Codecademy";
var Integrations_ImportCompletedCodeSchool$1 = "Import my completed courses from Code School";
var Integrations_ImportCompletedKhanAcademy$1 = "Import my completed videos from Khan Academy";
var Integrations_ImportCompletedPluralsight$1 = "Import my completed courses from Pluralsight";
var Integrations_ImportCompletedSkillshare$1 = "Import my completed courses from Skillshare";
var Integrations_ImportCompletedTreehouse$1 = "Import my completed courses from Treehouse";
var Integrations_ImportCompletedUdemy$1 = "Import my completed courses from Udemy";
var Integrations_ImportCourseraCourses$1 = "Import my completed courses from Coursera";
var Integrations_ImportCourseraDaily$1 = "Import all courses from my Coursera profile daily.";
var Integrations_ImportGoodreadsDaily$1 = "Import books I have marked 'read' in Goodreads daily.";
var Integrations_ImportKhanAcademyDaily$1 = "Import my completed videos and assessments from Khan Academy daily.";
var Integrations_ImportNow$1 = "Import Now";
var Integrations_ImportPluralsightDaily$1 = "Import completed courses from Pluralsight daily.";
var Integrations_ImportPocketDaily$1 = "Import articles I have marked as 'archived' in Pocket daily.";
var Integrations_ImportReadabilityDaily$1 = "Import articles I have marked as 'archived' in Readability daily.";
var Integrations_ImportReadArticlesReadability$1 = "Import my read articles from Readability";
var Integrations_ImportReadGoodreads$1 = "Import my read books from Goodreads";
var Integrations_ImportSkillshareDaily$1 = "Import all courses from my Skillshare profile daily.";
var Integrations_ImportTreehouseDaily$1 = "Import completed courses from Treehouse daily.";
var Integrations_ImportUdemyDaily$1 = "Import all courses from my Udemy profile daily.";
var Integrations_IntegrationsDirectory$1 = "Integrations Directory";
var Integrations_KhanAcademyContentFree$1 = "All Khan Academy content is available for free at";
var Integrations_KhanAcademyImportError$1 = "Whoops! Something went wrong importing your videos from Khan Academy. Please re-enable Kahn Academy integration above and we'll try again.";
var Integrations_KhanAcademyUsername$1 = "Khan Academy username";
var Integrations_LastImported$1 = "Last Imported:";
var Integrations_LastNameAssertionName$1 = "Last Name Assertion Name";
var Integrations_LastSyncDate$1 = "Last Sync: {{ date }}";
var Integrations_LimitedVisibility$1 = "Limited Visibility";
var Integrations_Linkedin$1 = "LinkedIn";
var Integrations_Never$1 = "Never";
var Integrations_Note$1 = "Note:";
var Integrations_NoteForPNG$1 = "The image must be a PNG file with a pixel size of 200px high and 200px wide.";
var Integrations_NoteForSVG$1 = "The image must be a vector SVG file.";
var Integrations_OnlyShowIfLicense$1 = "Only show if a user has a license";
var Integrations_Or$1 = "or";
var Integrations_OrgId$1 = "Org Id";
var Integrations_PaidOneClick$1 = "Paid One-Click";
var Integrations_PaidOneClickSetup$1 = "Public Content";
var Integrations_PluralsightImportError$1 = "Whoops! Something went wrong importing your courses from Pluralsight. Please verify your username.";
var Integrations_PluralsightPublicProfile$1 = "This integration requires a public Pluralsight profile with the 'Completed courses' tile visible.";
var Integrations_PluralsightUsername$1 = "Pluralsight username";
var Integrations_PocketImportError$1 = "Whoops! Something went wrong syncing with Pocket. Please re-enable Pocket integration above and we'll try again.";
var Integrations_PocketUsername$1 = "Pocket username";
var Integrations_PortalId$1 = "Portal Id";
var Integrations_PortalName$1 = "Portal Name";
var Integrations_PromptForLicense$1 = "Prompt for License";
var Integrations_ProviderAssertionConsumerService$1 = "Provider Assertion Consumer Service (ACS) URL";
var Integrations_ProviderEntityID$1 = "Provider Entity ID";
var Integrations_ProviderLogo$1 = "Provider Logo";
var Integrations_ReadabilityImportError$1 = "Whoops! Something went wrong importing your articles from Readability. Please re-enable Readability integration above and we'll try again.";
var Integrations_ReadabilityUsername$1 = "Readability username";
var Integrations_RecommendGoogleplus$1 = "Share items with your Connections on Google+.";
var Integrations_RecommendLinkedin$1 = "Share items with your Connections on LinkedIn.";
var Integrations_RecommendTwitter$1 = "Share items with your Followers on Twitter.";
var Integrations_SaveIntegrations$1 = "Save Integrations";
var Integrations_ShouldDisableConnector$1 = "Are you sure you want to disable this connector?";
var Integrations_ShouldDisableIntegration$1 = "Are you sure you want to disable this integration?";
var Integrations_ShowConnectedOnly$1 = "Show Connected Only";
var Integrations_SignSAMLAssertion$1 = "Sign SAML Assertion?";
var Integrations_SignSAMLResponse$1 = "Sign SAML Response?";
var Integrations_SkillshareImportError$1 = "Whoops! Something went wrong importing your courses from Skillshare.";
var Integrations_SkillshareIserId$1 = "Skillshare User Id";
var Integrations_SkillshareProfileRequired$1 = "Requires a public Skillshare profile.";
var Integrations_SkillshareUserName$1 = "Skillshare User Name";
var Integrations_SkillshareUserNameId$1 = "Skillshare User Name/Skillshare User Id";
var Integrations_SlackDescription$1 = "Get Today's Learning and shared content delivered through slack.";
var Integrations_SlackDescriptionConsumer$1 = "Get Today's Learning delivered through Slack.";
var Integrations_SlackTodaysLearningTitle$1 = "Have you seen this in Today's Learning on Degreed yet?";
var Integrations_SlackTodaysLearningTitleFormat$1 = "Today's Learning for {0}";
var Integrations_SocialAccounts$1 = "Social Accounts";
var Integrations_SSO_EnabledContentURL$1 = "SSO enabled content URLs";
var Integrations_SSO_IsEnabled$1 = "SSO is enabled for this provider";
var Integrations_SuccessfullImport$1 = "Nice work syncing your account with Degreed.";
var Integrations_TreehouseImportError$1 = "Whoops! Something went wrong importing your courses from Treehouse. Please verify your username.";
var Integrations_TreehousePublicProfile$1 = "Requires a public Treehouse profile.";
var Integrations_TreehouseUsername$1 = "Treehouse username";
var Integrations_Twitter$1 = "Twitter";
var Integrations_TypeDisable$1 = "Type 'DISABLE'";
var Integrations_TypeTerm$1 = "Type '{{ term }}'";
var Integrations_UdemyImportError$1 = "Whoops! Something went wrong importing your courses from Udemy.";
var Integrations_UdemyUserId$1 = "Udemy User Id";
var Integrations_UdemyVisibleCourses$1 = "Requires a public Udemy profile with visible courses.";
var Integrations_UnableToVerify$1 = "Unable to verify. Check the details and try again.";
var Integrations_UserGrantedLicense$1 = "Users will be granted a license after accepting the prompt";
var Integrations_UserIDAssertionName$1 = "User ID Assertion Name";
var Integrations_UserIdentifierSamlSubject$1 = "User Identifier / SAML Subject Name";
var Integrations_VerifyCourseraPublicProfile$1 = "Please verify your Coursera profile is public.";
var Integrations_VerifyPublicCodecademy$1 = "Please verify your Codecademy profile is public.";
var Integrations_VerifyPublicUdemyProfile$1 = "Please verify your Udemy profile is public.";
var Integrations_VerifySkillsharePublic$1 = "Please verify your Skillshare profile is public.";
var Integrations_VerifySkillshareUserId$1 = "Please verify your unique Skillshare user id.";
var Integrations_VerifyUniqueCourseraUserId$1 = "Please verify your unique Coursera user id.";
var Integrations_VerifyUniqueUserId$1 = "Please verify your unique Udemy user id.";
var Integrations_ViewConnections$1 = "View Connections";
var Integrations_ViewFollowers$1 = "View Followers";
var Integrations_ViewFriends$1 = "View Friends";
var InsightsNav_SkillTrends$1 = "Skill Trends";
var InputsSvc_AddItemError$1 = "An error occurred adding the item.";
var InputsSvc_CompletedError$1 = "Sorry! There was a problem completing the item.";
var InputsSvc_CompletedSuccess$1 = "Learning item completed.";
var InputsSvc_DismissSuggestedError$1 = "Sorry! There was a problem dismissing the item.";
var InputsSvc_DismissSuggestedSuccess$1 = "Learning item dismissed.";
var InputsSvc_EditContentDuplicateError$1 = "Duplicate content already exists.";
var InputsSvc_GeneralError$1 = "Sorry! There was a problem accessing the library items.";
var InputsSvc_GetAssessmentError$1 = "Sorry! There was a problem accessing assessments.";
var InputsSvc_GetBookError$1 = "Sorry! There was a problem accessing books.";
var InputsSvc_GetCourseError$1 = "Sorry! There was a problem accessing courses.";
var InputsSvc_GetCourseMetadataError$1 = "Sorry! There was a problem finding information about the URL.";
var InputsSvc_GetEpisodeError$1 = "Sorry! There was a problem accessing episodes.";
var InputsSvc_GetEventError$1 = "Sorry! There was a problem accessing events.";
var InputsSvc_GetMediaError$1 = "Sorry! There was a problem accessing media.";
var InputsSvc_GetMediaMetadataError$1 = "Sorry! There was a problem finding information about the URL.";
var InputsSvc_GetSuggestedError$1 = "Sorry! There was a problem getting the items.";
var InputsSvc_GetUserError$1 = "Sorry! There was a problem retrieving top users.";
var InputsSvc_PeopleCompleted$1 = "{{count}} People have completed this";
var InputsSvc_PeopleLiked$1 = "{{count}} People have liked this";
var InputsSvc_PeopleShared$1 = "{{count}} People have shared this";
var InputsSvc_PersonCompleted$1 = "1 Person has completed this";
var InputsSvc_PersonLiked$1 = "1 Person has liked this";
var InputsSvc_PersonShared$1 = "1 Person has shared this";
var InputsSvc_ProfileDismissed$1 = "Profile dismissed.";
var InputsSvc_QueueError$1 = "Sorry! There was a problem saving the item for later.";
var InputsSvc_QueueSuccess$1 = "Learning item saved for later.";
var InputsSvc_UsersTitle$1 = "People who completed this";
var InputSessionForm_Address$1 = "Address";
var InputSessionForm_AddSessionDetails$1 = "Add Session Details";
var InputSessionForm_BasicInformation$1 = "Basic Information";
var InputSessionForm_DateTime$1 = "Date & Time";
var InputSessionForm_DateTimeNew$1 = "Date and Time";
var InputSessionForm_DeletionAlert$1 = "Saving your changes with Session Details off deletes all details. To keep your changes, turn the Session Details back on before saving.";
var InputSessionForm_DifferentUrl$1 = "Use a different registration URL";
var InputSessionForm_EndTime$1 = "End Time";
var InputSessionForm_EventEnds$1 = "Event ends";
var InputSessionForm_EventStarts$1 = "Event starts";
var InputSessionForm_EventStreamLinkLabel$1 = "Link to the Live Event stream";
var InputSessionForm_EventStreamLinkPlaceholder$1 = "Link to the event stream (eg. Zoom, Google Meetings)";
var InputSessionForm_EventTimeZone$1 = "Event time zone";
var InputSessionForm_InPerson$1 = "In-Person";
var InputSessionForm_IntegratedDetailsNotEditable$1 = "Session details from integrated items are not editable in Degreed";
var InputSessionForm_InvalidDate$1 = "Please select a valid date";
var InputSessionForm_InvalidTime$1 = "Please enter a valid time";
var InputSessionForm_InvalidTimeNew$1 = "Please select a valid time";
var InputSessionForm_LocationType$1 = "Location type";
var InputSessionForm_LocationUrl$1 = "Location URL";
var InputSessionForm_LocationUrl_Placeholder$1 = "Add a link to the event live stream";
var InputSessionForm_LocationUrlDescription$1 = "Link to the online {{inputType}}";
var InputSessionForm_Online$1 = "Online";
var InputSessionForm_PhysicalLocation$1 = "Physical location of the Live Event";
var InputSessionForm_Registration$1 = "Registration";
var InputSessionForm_RegistrationAvailable$1 = "Registration is available";
var InputSessionForm_RegistrationAvailableNew$1 = "Registration available";
var InputSessionForm_RegistrationUrl$1 = "Registration URL";
var InputSessionForm_SameUrl$1 = "Registration URL is same as {{ inputType }} Website URL";
var InputSessionForm_SameUrlNew$1 = "Registration URL is the same as the {{inputType}} website URL";
var InputSessionForm_SearchAddress$1 = "Search for venue address";
var InputSessionForm_StartTime$1 = "Start Time";
var InputSessionForm_Timezone$1 = "Timezone";
var InputsController_AssessmentUnavailable$1 = "This assessment is no longer available.";
var InputsController_Average$1 = "Average";
var InputsController_FriendlyErrorMessage$1 = "You must set a first and last name on your Settings page before you can view this course.";
var InputsController_From$1 = "from";
var InputsController_Login$1 = "Login";
var InputsController_NoRatings$1 = "no ratings";
var InputsController_S$1 = "s";
var InputsController_Signup$1 = "Signup";
var InputsController_User$1 = "user";
var InputsController_YourRating$1 = "Your Rating:";
var InputRatingsSvc_ErrorNotification$1 = "Sorry! There was a problem saving your rating. It’s not your fault, we are working hard to fix the problem.";
var InputRatingsSvc_SavedCompleteSuccess$1 = "Rating saved and {{type}} marked complete";
var InputRatingsSvc_SaveRatingError$1 = "Sorry! There was a problem saving your rating. It’s not your fault, we are working hard to fix the problem.";
var InputRatingsSvc_SaveRatingSuccess$1 = "Your rating has been saved.";
var InputCard_PreviewInputFormat$1 = "Preview {{inputType}}";
var inappropriateModalContent_Instructions$1 = "If you report this item, the Degreed support team will investigate the issue. If the content is from the External catalog, Degreed support removes inappropriate content. If this is internal content, your organization's Degreed administrator will make a final decision, then remove it if it is inappropriate.";
var inappropriateModalContent_Reason$1 = "Tell us why this content is inappropriate";
var inappropriateModalContent_ReasonValidationError$1 = "Must provide a reason";
var inappropriateModalContent_Title$1 = "Report Inappropriate Content";
var ImageEditSvc_ImagedUpdated$1 = "Your image has been updated.";
var ImageEditSvc_ImageUploadError$1 = "Whoops - something went wrong. Please try uploading your image again.";
var ImageEditSvc_ImageUploadTooBig$1 = "Oops, that's too big! Try an image smaller than 25MB.";
var ImageEditSvc_OpenBadgeParseError$1 = "Error: Invalid badge image. Valid digital badge images include encrypted data about your earned digital badge and are available from the badge provider. Upload a valid badge image and try again.";
var GroupSvc_BulkDeleteError$1 = "Sorry! There was a problem deleting the groups.";
var GroupSvc_BulkDeleteGroupsSuccess$1 = "Group(s) deleted successfully.";
var GroupSvc_ErrorNotification$1 = "Sorry! There was a problem accessing groups.";
var GroupSvc_GroupInvitesNotification$1 = "Success! The invites are on their way.";
var GroupSvc_GroupInvitesNotificationError$1 = "Sorry! There was a problem sending the invites.";
var GroupSvc_GroupJoinNotification$1 = "Group joined successfully.";
var GroupSvc_GroupLeaveNotification$1 = "Group left successfully.";
var GroupSvc_GroupMembershipNotification$1 = "Group membership request sent!";
var GroupSvc_GroupSettingsTitle$1 = "Create Group";
var GroupSettingsCtrl_AdministrativeGroup$1 = "Administrative";
var GroupSettingsCtrl_AdministrativeNewTip$1 = "Only admins can see and interact with Administrative groups. All others will not know they're in the group or see the group in the list of groups.";
var GroupSettingsCtrl_AdministrativeTip$1 = "Only admins can see and interact with Administrative groups. All others will not know they're in the group or see the group in the list of groups.";
var GroupSettingsCtrl_ClosedGroup$1 = "Closed";
var GroupSettingsCtrl_ClosedNewTip$1 = "Anyone in your organization can find this group but must be invited to join. You will automatically be added to the group.";
var GroupSettingsCtrl_ClosedTip$1 = "Anyone in your organization can find this group but must be invited to join.";
var GroupSettingsCtrl_CreateBulkGroups$1 = "Or create multiple Groups with a";
var GroupSettingsCtrl_CustomTooltip$1 = "When a group member adds content matching these skills it will appear in the group feed";
var GroupSettingsCtrl_Description$1 = "Description";
var GroupSettingsCtrl_DuplicateName$1 = "This group already exists within the organization.";
var GroupSettingsCtrl_DynamicMembership$1 = "Dynamic Membership";
var GroupSettingsCtrl_DynamicMembership_Info$1 = "Group membership is dynamic based on user attributes.";
var GroupSettingsCtrl_DynamicMembership_Instructions$1 = "Select up to 20 attributes to define this dynamic group";
var GroupSettingsCtrl_EnableOpportunities$1 = "Enable Opportunities for group";
var GroupSettingsCtrl_GroupAddedSuccess$1 = "Group added successfully.";
var GroupSettingsCtrl_GroupName$1 = "Group Name";
var GroupSettingsCtrl_GroupNameFormat$1 = "{{groupName}} Group";
var GroupSettingsCtrl_GroupUpdatePrivacySuccess$1 = "Group settings updated successfully. Refreshing page...";
var GroupSettingsCtrl_GroupUpdateSuccess$1 = "Group settings updated successfully.";
var GroupSettingsCtrl_NameExists$1 = "There is already a group with this name in {{org}}.";
var GroupSettingsCtrl_OpenGroup$1 = "Open";
var GroupSettingsCtrl_OpenNewTip$1 = "Anyone in your organization can find and join this group. The group may be closed later.";
var GroupSettingsCtrl_OpenTip$1 = "Anyone in your organization can find and join this group.";
var GroupSettingsCtrl_PrivacySettings$1 = "Privacy Settings";
var GroupSettingsCtrl_PrivateGroup$1 = "Private";
var GroupSettingsCtrl_PrivateNewTip$1 = "Only users you invite to this group can see it.";
var GroupSettingsCtrl_PrivateTip$1 = "Only users you invite to this group can see it.";
var GroupSettingsCtrl_ProblemWithGroups$1 = "Sorry! There was a problem accessing groups.";
var GroupSettingsCtrl_SaveGroup$1 = "Save Group";
var GroupSettingsCtrl_SpecifyCategory$1 = "Please add at least one category.";
var GroupSettingsCtrl_SpecifyDescription$1 = "Please specify a description for the group.";
var GroupSettingsCtrl_SpecifyName$1 = "Please specify a name for the group.";
var GroupSecurityCtrl_UpdateRolesSuccess$1 = "Group roles updated successfully. Reloading permissions...";
var GroupsController_About$1 = "About This Group";
var GroupsController_BecomeAMember$1 = "Become a member of this group";
var GroupsController_ClickRequestMembership$1 = "Click to request membership in this group.";
var GroupsController_ClickToJoin$1 = "Click to join this group.";
var GroupsController_Feed$1 = "Feed";
var GroupsController_GroupMembershipPending$1 = "Group Membership Pending";
var GroupsController_GroupPostVisibility$1 = "Posts are only visible to this group";
var GroupsController_GroupSettingsTitle$1 = "Create Group";
var GroupsController_Insights$1 = "Insights";
var GroupsController_Joining$1 = "Joining...";
var GroupsController_Members$1 = "Members";
var GroupsController_RequestedMembershipOne$1 = "You have requested membership to this";
var GroupsController_RequestedMembershipTwo$1 = "group.";
var GroupsController_RequestMembership$1 = "Request membership in this group";
var GroupsController_Settings$1 = "Settings";
var groupPostAdded_Format$1 = "{{nameHtml}} posted in {{groupNameHtml}}";
var groupPostAdded_GroupFormat$1 = "{{nameHtml}} posted in {{groupNameHtml}}";
var groupPostAdded_SingleFormat$1 = "{{nameHtml}} posted to {{groupNameHtml}}";
var GroupMembersCtrl_AnyTime$1 = "Any Time";
var GroupMembersCtrl_ApproveInvite$1 = "Approve";
var GroupMembersCtrl_DateJoined$1 = "Date Joined";
var GroupMembersCtrl_DateRequestsOrInvited$1 = "Request / Invitation Date";
var GroupMembersCtrl_DeclineInvite$1 = "Decline";
var GroupMembersCtrl_EditUserSettings$1 = "Edit User Settings";
var GroupMembersCtrl_ErrorNotification$1 = "'Sorry! There was a problem accessing member information.'";
var GroupMembersCtrl_FocusSkills$1 = "Focus Skills";
var GroupMembersCtrl_JobTitle$1 = "Job Title";
var GroupMembersCtrl_LastActive$1 = "Last Active";
var GroupMembersCtrl_LastXDaysFormat$1 = "Last {{dayCount}} days";
var GroupMembersCtrl_MembershipSource$1 = "Membership Source";
var GroupMembersCtrl_MembershipSource_AnalyticsPipeline$1 = "Automations";
var GroupMembersCtrl_MembershipSource_BusinessRulesAPI$1 = "Automations";
var GroupMembersCtrl_MembershipSource_BusinessRulesFtp$1 = "Business Rules";
var GroupMembersCtrl_MembershipSource_ClientUserFile$1 = "User File";
var GroupMembersCtrl_MembershipSource_ScheduledAutomation$1 = "Automations";
var GroupMembersCtrl_MembershipSource_UserAttributeFile$1 = "User Update File";
var GroupMembersCtrl_MembershipSource_v2API$1 = "API";
var GroupMembersCtrl_MembershipSource_Web$1 = "Degreed App";
var GroupMembersCtrl_Name$1 = "Name";
var GroupMembersCtrl_Of$1 = "of";
var GroupMembersCtrl_Points$1 = "Points";
var GroupMembersCtrl_RatedJobSkills$1 = "Job-Related Skills";
var GroupMembersCtrl_Remove$1 = "Remove";
var GroupMembersCtrl_ResendInvite$1 = "Resend Invitation";
var GroupMembersCtrl_Results$1 = "Results";
var GroupMembersCtrl_ResultsPerPage$1 = "Results per page:";
var GroupMembersCtrl_SendEmail$1 = "Send Email";
var GroupMembersCtrl_SetToAdmin$1 = "Set as Admin";
var GroupMembersCtrl_SetToMember$1 = "Set as Member";
var GroupMembersCtrl_ViewPendingMembers$1 = "Show {{memberCount}} pending members";
var GroupMemberFormCtrl_UpdateMemberRoleFormat$1 = "Updated role for {{memberName}}";
var GroupInviteCtrl_AddPeopleToGroup$1 = "Add people to group";
var GroupInviteCtrl_InviteEmailInstructions$1 = "Send invites to other members of your organization to join your group.";
var GroupInviteCtrl_InviteLinkInstructions$1 = "Quickly invite members of your organization to join your group using this invite link.";
var GroupInviteCtrl_InvitePeople$1 = "Invite People";
var GroupInviteCtrl_SearchByName$1 = "Search by name";
var GroupInviteCtrl_SendInviteTo$1 = "Invite will be sent to:";
var groupInviteAccepted_PluralFormat$1 = "{{nameHtml}} and {{number}} others accepted your invite to the {{groupNameHtml}} group";
var groupInviteAccepted_SingleFormat$1 = "{{nameHtml}} accepted your invite to the {{groupNameHtml}} group";
var GroupInsightsCtrl_All$1 = "All";
var GroupInsightsCtrl_GroupCategories$1 = "Group Categories";
var GroupInsightsCtrl_Month$1 = "Month";
var GroupInsightsCtrl_Week$1 = "Week";
var GroupInsightsCtrl_Year$1 = "Year";
var GroupFormSvc_ConfirmRemoval$1 = "Confirm removal";
var GroupFormSvc_ConfirmRemovalMessage$1 = "Are you sure you want to remove this user?";
var GroupFormSvc_EditUserSettings$1 = "Edit User Settings";
var GroupFormSvc_History$1 = "History";
var GroupFormSvc_MemberRequestDateFormat$1 = "{{memberName}} was invited on {{dateRequestedHtml}}";
var GroupFormSvc_MemberSinceFormat$1 = "{{memberName}} has been a member of this group since {{dateJoined}}";
var GroupFormSvc_PendingMember$1 = "Pending Member";
var GroupFormSvc_RemoveFromGroup$1 = "Remove From Group";
var GroupFormSvc_Removing$1 = "Removing...";
var GroupFormSvc_Role$1 = "Role";
var GroupFormSvc_RolePermissions$1 = "{{name}} permissions: {{permissions}}";
var GroupFormSvc_TopCategories$1 = "Top Skills";
var GroupDeleteCtrl_DeleteGroupConfirm$1 = "Are you sure you want to delete this group?";
var GroupDeleteCtrl_DeleteGroupError$1 = '"Sorry! There was a problem deleting the group."';
var GroupDeleteCtrl_DeleteGroupInfoDescription$1 = "This group will be deleted for all members of the group. All goals associated with this group will also be deleted.";
var GroupDeleteCtrl_DeleteGroupSuccess$1 = "Group deleted successfully.";
var GroupCtrl_EmptyStateDescription$1 = "When you join a group, it will show here.";
var GroupCtrl_EmptyStateTitle$1 = "No Groups";
var GroupCtrl_GroupRemovalWarning$1 = "{{name}} will no longer be able to receive group emails or items shared to the group";
var GroupCtrl_LeaveGroupHeader$1 = "Are you sure you want to leave the group?";
var GroupCtrl_LeaveGroupSummary$1 = "You will no longer receive group emails or items shared to the group.";
var GroupCtrl_MemberRemovedSuccessfully$1 = "{{memberName}} was removed successfully";
var GroupCtrl_MyTeam$1 = "Your Team";
var GroupCtrl_RemoveFromGroup$1 = "Remove {{name}} from group?";
var GroupCtrl_SetAsPrimary$1 = "Set as 'Your Team'";
var GroupCtrl_UnsetAsPrimary$1 = "Unset as 'Your Team'";
var GroupContextSvc_ErrorNotification$1 = "Sorry! There was a problem accessing organization information.";
var GoalFormSvc_ByThisDate$1 = "by this date";
var GoalFormSvc_CompleteThisFormat$1 = "Complete this {{referenceType}}";
var GoalFormSvc_CreateGoal$1 = "Create Goal";
var GoalFormSvc_CreateGroupGoal$1 = "Create a goal for a specific group?";
var GoalFormSvc_DeleteGoal$1 = "Delete this goal";
var GoalFormSvc_EarnPoints$1 = "Earn Points";
var GoalFormSvc_EarnPointsMessage$1 = "Earn this many more points (whole number)";
var GoalFormSvc_EditGoal$1 = "Edit Goal";
var GoalFormSvc_GroupGoalProgress$1 = "Group Goal Progress";
var GoalFormSvc_GroupTooltip$1 = "Selecting a group will allow you to create a goal for all members in that group.";
var GoalFormSvc_InThisCategory$1 = "in this category";
var GoalFormSvc_ItemAddedFormat$1 = "{{item}} has been saved for later!";
var GoalFormSvc_JustMe$1 = "No (just me)";
var GoalFormSvc_NumberOfPoints$1 = "Number of points";
var GoalFormSvc_WhichGroupsTitle$1 = "Which groups do you want to create a goal for?";
var forgotPasswordForm_EmailLabel$1 = "What is your email address?";
var forgotPasswordForm_EmailPlaceholder$1 = "steve@acme.com";
var forgotPasswordForm_InvalidEmail$1 = "Please enter your valid email address.";
var forgotPasswordForm_Message$1 = "Please enter your primary email address to have a password reset email sent to you.";
var forgotPasswordForm_Success$1 = "We've sent an email to the address you provided with instructions for how to reset your password.";
var forgotPasswordForm_SuccessMessage$1 = "Your password was successfully reset. You can now log in to your account using your new password.";
var forgotPasswordForm_Title$1 = "Reset password";
var followTargetForm_GroupHeader$1 = "Join {{count}} groups";
var followTargetForm_GroupHeaderSingular$1 = "Join 1 group";
var followTargetForm_Instructions$1 = 'You are about to follow the {{targetType}} "{{targetTitle}}." If you follow it, the best content from this {{targetType}} and selected resources below will appear in your learning Feed.';
var followTargetForm_NoResources$1 = "This {{targetType}} has no additional resources to select. By following this {{targetType}}, you will be notified if additional resources are added.";
var followTargetForm_PathwayHeader$1 = "Enroll in {{count}} pathways";
var followTargetForm_PathwayHeaderSingular$1 = "Enroll in 1 pathway";
var followTargetForm_selectTitleFormat$1 = "Select {{title}}";
var followTargetForm_Submit$1 = "Follow {{targetType}}";
var followTargetForm_TagHeader$1 = "Follow {{count}} skills";
var followTargetForm_TagHeaderSingular$1 = "Follow 1 skill";
var followTargetForm_TargetHeader$1 = "Follow {{count}} plans";
var followTargetForm_TargetHeaderSingular$1 = "Follow 1 plan";
var followTargetForm_Title$1 = "Following a {{targetType}}";
var followTargetForm_UserHeader$1 = "Follow {{count}} people";
var followTargetForm_UserHeaderSingular$1 = "Follow 1 person";
var FollowingSvc_Continue$1 = "Continue";
var FollowingSvc_FollowerCountsError$1 = "Sorry! There was a problem retrieving follower counts. It’s not your fault, we are working hard to fix the problem.";
var FollowingSvc_FollowerInfoError$1 = "Sorry! There was a problem retrieving information about who you follow.";
var FollowingSvc_FollowError$1 = "Sorry! An error occurred trying to follow this person.";
var FollowingSvc_FollowNotification$1 = "You are now following this person.";
var FollowingSvc_FollowNotificationFormat$1 = "You are now following {{person}}";
var FollowingSvc_FollowUserNotification$1 = "Selecting to follow this user will mean that your name and picture will be displayed on the Followers page for this user.";
var FollowingSvc_InteralFollowError$1 = "Sorry! There was a problem retrieving followers. It’s not your fault, we are working hard to fix the problem.";
var FollowingSvc_InternalRetrievalError$1 = "Sorry! There was a problem retrieving users that this user follows. It’s not your fault, we are working hard to fix the problem.";
var FollowingSvc_UnfollowError$1 = "Sorry! An error occurred trying to unfollow this person.";
var FollowingSvc_UnfollowNotificationFormat$1 = "You are no longer following {{person}}";
var FlexSvc_AddItems$1 = "Add items";
var FlexSvc_AddLinkTextsDescription$1 = "Only contains a link";
var FlexSvc_AddResources$1 = "Add Resources";
var FlexSvc_CombinedResources$1 = "Combined Resources";
var FlexSvc_FreeformTextDescription$1 = "Only contains image and text";
var FlexSvc_MixedResources$1 = "Mixed Resources";
var FlexSvc_MixedResourcesDescription$1 = "Can contain content, plans, pathways, skills, people, groups, and providers";
var FlexSvc_OpportunitiesDescription$1 = "Only contains opportunities";
var FlexSvc_TextAndImage$1 = "Text and Image";
var FlexEdSvc_FlexEdError$1 = "Sorry! There was a problem accessing your FlexED information.";
var flexEdModal_AllFieldsRequiredError$1 = "All fields are required.";
var flexEdModal_Close$1 = "Close";
var flexEdModal_ConnectCardButton$1 = "Connect card";
var flexEdModal_ContactYourAdminMessage$1 = "Contact your administrator if you don't already have a FlexED card and think you should.";
var flexEdModal_FirstName$1 = "First Name";
var flexEdModal_InvalidNumberError$1 = " Please enter a valid number.";
var flexEdModal_LastFour$1 = "Last 4 digits of your FlexED card";
var flexEdModal_LastName$1 = "Last Name";
var flexEdModal_LinkYourFlexEdCard$1 = "Link your FlexED card";
var flexEdModal_MultipleCardsError$1 = " There are multiple cards that match the information you provided. Please contact your administrator.";
var flexEdModal_NameDoesNotMatchCardError$1 = " Please check you have entered your information correctly. If that doesn't solve the problem, please contact your administrator.";
var flexEdModal_NameOnCard$1 = "Name as it appears on card";
var flexEdModal_SavedNewInformation$1 = "We've saved your new FlexED information";
var flexEdModal_SaveInfoButton$1 = "Save info";
var flexEdModal_SuccessfullyConnected$1 = "You've successfully connected your FlexED card!";
var flexEdModal_ViewMyFlexEd$1 = "View my FlexED";
var flexEdModal_ViewYourExpenditures$1 = "View your expenditures and manage your card by clicking on the FlexED total in your admin menu.";
var FlexEdCtrl_Amount$1 = "Amount";
var FlexEdCtrl_Balance$1 = "Balance";
var FlexEdCtrl_BalanceError$1 = "Sorry! There was a problem retrieving your FlexED balance.";
var FlexEdCtrl_Date$1 = "Date";
var FlexEdCtrl_Description$1 = "Description";
var FlexEdCtrl_ErrorRetrieving$1 = "There was an error retrieving your FlexED information.";
var FlexEdCtrl_FlexEdTitle$1 = "FlexED";
var FlexEdCtrl_FlexEdTransactionsTitle$1 = "FlexED Transactions";
var FlexEdCtrl_UpdateCardInfo$1 = "Update card info";
var FlexCtrl_AddPrimaryContact$1 = "Add Primary Contact";
var FlexCtrl_AddProperties$1 = "Add Properties";
var FlexCtrl_AddSection$1 = "Add Section";
var FlexCtrl_AutoSuggestError$1 = "Sorry, we don’t have suggestions for this plan yet. You can still customize your plan with content, people, and groups!";
var FlexCtrl_ChooseSectionType$1 = "Choose a Section Type";
var FlexCtrl_EditingStatusMessage$1 = "You are editing this {{pageType}}.";
var FlexCtrl_EditPageType$1 = "Edit {{pageType}}";
var FlexCtrl_EditPlanType$1 = "Edit {{planType}}";
var FlexCtrl_EditPrimaryContact$1 = "Edit Primary Contact";
var FlexCtrl_EditProperties$1 = "Edit Properties";
var FlexCtrl_EditSettings$1 = "Edit Settings";
var FlexCtrl_NothingHere$1 = "There is nothing here";
var FlexCtrl_NothingHereDescription$1 = "When you add a section to your Plan it will show here.";
var FlexCtrl_PrimaryContact$1 = "Primary Contact";
var FlexCtrl_ReorderSections$1 = "Reorder Sections";
var FlexCtrl_SavePrimaryContact$1 = "Save Primary Contact";
var FlexCtrl_SettingsType$1 = "{{pageType}} Settings";
var FlexCtrl_ViewDirectory$1 = "View Directory";
var FlexCtrl_ViewPageType$1 = "View {{pageType}}";
var FlexCtrl_ViewPlanType$1 = "FlexCtrl_ViewPlanType";
var firstPathwayModal_Enrolled$1 = "You've enrolled in a pathway";
var firstPathwayModal_Followed$1 = "You've followed a pathway";
var firstPathwayModal_ViewPathways$1 = "View pathways";
var firstPathwayModal_WhyTheyHelp$1 = "Pathways help you map out content to learn from. Find your pathways in the Profile tab.";
var FeedSvc_Dismiss$1 = "Dismiss";
var FeedbackSvc_ErrorMessage$1 = "Sorry! We were unable to receive your request.";
var FeedbackSvc_ThankyouMessage$1 = "Thank you, we received your message.";
var FeedbackPartial_CitiCollaborate$1 = "Citi Collaborate";
var FeedbackPartial_FAQ$1 = "FAQ";
var FeedbackPartial_HereToHelp$1 = "We're here to help.";
var FeedbackPartial_KnowledgeCenter$1 = "Knowledge Center";
var FeedbackPartial_OSSLicense$1 = "OSS License Information";
var FeedbackPartial_PhoneNumber$1 = "phone number:";
var FeedbackPartial_PrivacyPolicy$1 = "Privacy Policy";
var FeedbackPartial_SendAMessage$1 = "Send us a message";
var FacetFilter_ActiveSubscription$1 = "Active Subscription";
var FacetFilter_More$1 = "More";
var FacetFilter_None$1 = "None";
var FacetFilter_SortAlpha$1 = "a-z";
var FacetFilter_SortAlphaReverse$1 = "z-a";
var FacetFilter_SortNumeric$1 = "#";
var FacetFilter_VisitSite$1 = "Visit {{Name}} Site";
var FacetFilter_YourTopCategories$1 = "Your Top Categories";
var ExternalProvidersSvc_ErrorMatchingResults$1 = "Sorry! There was a problem finding matching results.";
var ExternalProvidersSvc_ErrorRetrievingDetailsFormat$1 = "Sorry! There was a problem retrieving the {{type}} details. Please try again later.";
var ExternalProvidersSvc_ErrorRetrivingListFormat$1 = "Sorry! There was a problem retrieving the {{type}} list. Please try again later.";
var externalContentModal_HeaderFormat$1 = "Leaving {{catalogName}} Catalog";
var Ext_AddALesson$1 = "Add a new lesson";
var Ext_AddAPathway$1 = "Add a new pathway";
var Ext_AddASection$1 = "Add a new section";
var Ext_AddATitle$1 = "Please add a title";
var Ext_AddCommentError$1 = "There was a problem adding this comment";
var Ext_AddedToCatalogSuccess$1 = "Added to the catalog";
var Ext_AddedToPlan$1 = "Added to Plan";
var Ext_Adding$1 = "Adding...";
var Ext_AddingInputFormat$1 = "Adding {{inputType}}...";
var Ext_AddNotificationNote$1 = "Add a note on why you are recommending this (optional)";
var Ext_AddPathwayFor$1 = "This pathway is intended for...";
var Ext_AddPathwayTitle$1 = "New Pathway's Title";
var Ext_AddRecommendationNote$1 = "Add a note on why you are sharing this (optional)";
var Ext_AddSuccess$1 = "Added successfully";
var Ext_AddTakeaway$1 = "Add a Takeaway";
var Ext_AddToCatalog$1 = "Add To Catalog";
var Ext_AddToCatalogFormat$1 = "Add {{inputType}} to the {{orgName}} catalog";
var Ext_AddToPathway$1 = "Add to Pathway";
var Ext_AddTopics$1 = "Add Skills";
var Ext_AddTopicsOrSkills$1 = "Add skills";
var Ext_AddTopicsOrTakeAway$1 = "Add Skills or Takeaways";
var Ext_AddToPlan$1 = "Add to Plan";
var Ext_AuthBlurb$1 = "Find, capture, and measure all your learning from the best materials across thousands of platforms.";
var Ext_BookInfoUnavailable$1 = "This book's information isn't available for adding";
var Ext_CharacterCount$1 = "{{count}} characters remaining";
var Ext_CharactersRemainingFormat$1 = "{{count}} characters remaining";
var Ext_ClearSearch$1 = "Clear your search";
var Ext_Close$1 = "Close";
var Ext_ConfirmDetails$1 = "Confirm Details";
var Ext_Continue$1 = "Continue";
var Ext_CreatePlan$1 = "Create Plan";
var Ext_EnterTopics$1 = "Enter skills";
var Ext_Error$1 = "Oops...";
var Ext_ErrorMessage$1 = "Sorry, something went wrong";
var Ext_ErrorSharing$1 = "There was a problem sharing this content";
var Ext_ExistsInCMS$1 = "This item already exists in the catalog.";
var Ext_GroupMemberCount$1 = "{{count}} Members | Group";
var Ext_InputAddedFormat$1 = "{{inputType}} Added";
var Ext_ItemAdded$1 = "Item Added";
var Ext_ItemSaved$1 = "Item Saved";
var Ext_Lesson$1 = "Lesson";
var Ext_LessonAddError$1 = "We were unable to add this lesson";
var Ext_LessonFormat$1 = "Lesson {{lessonNumber}}";
var Ext_LessonPlaceholder$1 = "Select a Lesson";
var Ext_Loading$1 = "Loading...";
var Ext_LogoAlt$1 = "Go to Degreed";
var Ext_LogOut$1 = "Log out";
var Ext_MarkCompleteError$1 = "There was a problem marking this complete";
var Ext_MarkCompleteFormat$1 = "Mark Complete: {{title}}";
var Ext_MemberCountFormat$1 = "{{count}} members";
var Ext_MenuMarkComplete$1 = "Mark Complete";
var Ext_MenuRecommend$1 = "Share";
var Ext_MenuSaveForLater$1 = "Save for Later";
var Ext_Message$1 = "Message";
var Ext_NewNotificationsFormat$1 = "{{count}} new notifications";
var Ext_Next$1 = "Next";
var Ext_NoAccount$1 = "Don't have an account?";
var Ext_NoNotifications$1 = "No new notifications";
var Ext_NoPlansYet$1 = "No plans have been created yet for you to add to.";
var Ext_NotificationCountFormat$1 = "{{count}} Notifications";
var Ext_Pathway$1 = "Pathway";
var Ext_PathwayAddError$1 = "We were unable to save this pathway";
var Ext_PathwayAddItemError$1 = "Sorry! There was a problem adding the item to the pathway.";
var Ext_PathwayAddItemPermissionError$1 = "Sorry! This item may not be added to the selected pathway.";
var Ext_PathwayDetailAccessError$1 = "Sorry! There was a problem accessing pathway details.";
var Ext_PathwayEnrollError$1 = "There was a problem enrolling you in this pathway";
var Ext_PathwayError$1 = "We were unable to get your pathways";
var Ext_PathwayLessonsError$1 = "We were unable to get this pathway's lessons";
var Ext_PathwayPlaceholder$1 = "Select a Pathway";
var Ext_PathwayTitle$1 = "Add to Pathway";
var Ext_PathwayUnenrollError$1 = "There was a problem unenrolling you from this pathway";
var Ext_PdfErrorMessage$1 = "We could not render the PDF because it is hosted in an unsecured location";
var Ext_PlansCreate$1 = "Create From Profile";
var Ext_PlansModalTitle$1 = "Add to Plan";
var Ext_PlansPlaceholder$1 = "Select a Plan";
var Ext_PointsShort$1 = "Pts";
var Ext_PrivacyOnlyMe$1 = "Only Me (private)";
var Ext_RecommandationSentPluralFormat$1 = "Recommendation successfully sent to {{count}} people";
var Ext_RecommandationSentSingle$1 = "Recommendation successfully sent to 1 person";
var Ext_Recommend$1 = "Share";
var Ext_RecommendationSentPluralFormat$1 = "Successfully shared with {{count}} people";
var Ext_RecommendationSentSingle$1 = "Successfully shared with 1 person";
var Ext_RecommendationViaEmail$1 = "Share via email";
var Ext_Recommending$1 = "Sharing...";
var Ext_RecommendingToPluralFormat$1 = "Sharing with {{count}} people";
var Ext_RecommendingToSingle$1 = "Sharing with 1 person";
var Ext_RecommendToPluralFormat$1 = "Share with {{count}} people";
var Ext_RecommendToSingle$1 = "Share with 1 person";
var Ext_RelatedSkills$1 = "Related Skills";
var Ext_Retry$1 = "Whoops, please retry";
var Ext_Save$1 = "Save";
var Ext_SaveButton$1 = "Saving";
var Ext_SaveForLaterError$1 = "There was a problem saving this for later";
var Ext_SaveRatingError$1 = "Sorry! There was a problem saving your rating. It’s not your fault, we are working hard to fix the problem.";
var Ext_Saving$1 = "Saving...";
var Ext_SavingError$1 = "Couldn't save. Please retry.";
var Ext_SavingItem$1 = "Saving Item...";
var Ext_SearchError$1 = "There was a problem loading this search";
var Ext_SearchGroups$1 = "Enter the name of a group";
var Ext_SearchResultArticlesHeadingFormat$1 = "Articles About {{searchTerm}}";
var Ext_SearchResultBooksHeadingFormat$1 = "Books About {{searchTerm}}";
var Ext_SearchResultNoneFound$1 = "No results found. Please try a new search.";
var Ext_SearchResultPathwaysHeadingFormat$1 = "Your pathways about {{searchTerm}}";
var Ext_SearchResultPeopleHeadingFormat$1 = "People also interested in {{searchTerm}}";
var Ext_SearchResultTitleFormat$1 = 'Results for "{{searchTerm}}"';
var Ext_SearchResultVideosHeadingFormat$1 = "Videos About {{searchTerm}}";
var Ext_Section$1 = "Section";
var Ext_SectionAddError$1 = "Ext_SectionAddError";
var Ext_SectionFormat$1 = "Section {{sectionNumber}}";
var Ext_SectionPlaceholder$1 = "Select a Section";
var Ext_SelectAGroup$1 = "Please select at least one group.";
var Ext_SelectALesson$1 = "Select a lesson";
var Ext_SelectAPathway$1 = "Select a pathway";
var Ext_SelectASection$1 = "Select a section";
var Ext_SelectLesson$1 = "Please choose a lesson";
var Ext_SelectPathway$1 = "Please choose a pathway";
var Ext_SelectPlan$1 = "Select Plan";
var Ext_SelectRecommendees$1 = "Select the group and people to share this content with";
var Ext_SelectRecommendeesPlaceholder$1 = "Enter the name of a group or person";
var Ext_SelectSection$1 = "Please choose a section";
var Ext_SelectSkillPlan$1 = "Please choose a plan";
var Ext_SharedContentSuccess$1 = "You successfully shared this {{contentType}}";
var Ext_ShareSomethingAboutFormat$1 = "Share something about this";
var Ext_ShareTitle$1 = "Share with groups and users";
var Ext_SignIn$1 = "Log in";
var Ext_SignInTitle$1 = "Please log in";
var Ext_SignUpLink$1 = "Sign Up";
var Ext_TagsModalTitle$1 = "Add Skills";
var Ext_TagsSuggestionError$1 = "Sorry! There was a problem retrieving suggestions.";
var Ext_TakeawayAdded$1 = "Takeaway Added Successfully";
var Ext_TakeawayPlaceholder$1 = "What did you learn from this?";
var Ext_TargetAddError$1 = "There was a problem adding this directory to your plan";
var Ext_TargetGetError$1 = "There was a problem getting your plans";
var Ext_TargetGetSectionsError$1 = "There was a problem getting your plan's sections.";
var Ext_Title$1 = "Add to Degreed";
var Ext_TopicAddedPlural$1 = "Skills Added Successfully";
var Ext_TopicAddedSingle$1 = "Skill Added Successfully";
var Ext_TopicAndTakeawayAddedPlural$1 = "Skills and Takeaway Added Successfully";
var Ext_TopicAndTakeawayAddedSingle$1 = "Skill and Takeaway Added Successfully";
var Ext_ViewAllOnDegreed$1 = "View All on Degreed";
var Ext_ViewDuplicate$1 = "View Duplicate";
var Ext_ViewPlan$1 = "View Your Plan";
var Ext_ViewSavedItems$1 = "View Saved Items";
var Ext_ViewYourPathway$1 = "View Your Pathway";
var Ext_WhyRecommending$1 = "Add a message on why you are sharing this";
var EventFormCtrl_AddEvent$1 = "Add Event";
var EventFormCtrl_AddToCatalogFormat$1 = "Add this event to {{orgName}}'s catalog";
var EventFormCtrl_Attendee$1 = "Attendee";
var EventFormCtrl_Category$1 = "Please add at least one category.";
var EventFormCtrl_DateAttended$1 = "Date Attended";
var EventFormCtrl_Description$1 = "Description";
var EventFormCtrl_EditEvent$1 = "Edit Event";
var EventFormCtrl_EventLength$1 = "Event Length";
var EventFormCtrl_EventLengthError$1 = "An event length is required.";
var EventFormCtrl_EventSite$1 = "Event Web Site (URL)";
var EventFormCtrl_EventTitle$1 = "Event Title";
var EventFormCtrl_EventTitleError$1 = "An event title is required.";
var EventFormCtrl_EventUrl$1 = "Event URL (include http:// or https://)";
var EventFormCtrl_HowInvolved$1 = "How Were You Involved?";
var EventFormCtrl_Keynote$1 = "Keynote";
var EventFormCtrl_OneDay$1 = "1 day";
var EventFormCtrl_OneHour$1 = "1 hour";
var EventFormCtrl_Panelist$1 = "Panelist";
var EventFormCtrl_Presenter$1 = "Presenter";
var EventFormCtrl_SaveEvent$1 = "Save Event";
var EventFormCtrl_ThreeToEightHours$1 = "3-8 hours";
var EventFormCtrl_ThreeToFiveDays$1 = "3-5 days";
var EventFormCtrl_Title$1 = "Title";
var EventFormCtrl_TwoDays$1 = "2 days";
var EventFormCtrl_TwoHours$1 = "2 hours";
var EventFormCtrl_ValidUrl$1 = "Please use a valid and complete URL.";
var EventFormCtrl_WeekOrMore$1 = "A week or more";
var EventFormCtrl_WhatDidYouLearnLong$1 = "What did you learn from this event?";
var EventFormCtrl_WhatDidYouLearnShort$1 = "What did you learn?";
var EvaluationSvc_DeleteError$1 = "Sorry! There was a problem deleting the Skill Review.";
var EvaluationSvc_DeleteSuccess$1 = "Skill Review deleted successfully.";
var EvaluationSvc_RetrieveError$1 = "An error occurred while retrieving evaluations";
var EvaluationSvc_SetResultsError$1 = "An error occurred storing question results.";
var EvaluationSvc_SubmitError$1 = "An error occurred while submitting.";
var EvalNav_Heading$1 = "Skill Review Navigation";
var EvalNav_Introduction$1 = "Introduction";
var EvalNav_ResultsDescription$1 = "Get your rating";
var EvalNav_ResultsTitle$1 = "Skill Level";
var EvalNav_SelectEndorser$1 = "Select Endorser";
var EvalApp_Cancel$1 = "Cancel Skill Review";
var EvalApp_MainTitle$1 = "Skill Review";
var EvalApp_Results_Breakdown$1 = "Breakdown";
var EvalApp_Results_Congratulations$1 = "Congratulations!";
var EvalApp_Results_ExtraMile$1 = "If you want to receive a certificate for your skill level, you can provide evidence for your skill and get {{aStart}}Degreed Certified{{aEnd}}";
var EvalApp_Results_GoToFeed$1 = "Go to Feed";
var EvalApp_Results_GoToProfile$1 = "Go to Profile";
var EvalApp_Results_LevelDeclarationFormat$1 = "Based on your responses, you are a {{aStart}} level {{level}}{{aEnd}} in {{skillName}}.";
var EvalApp_Stay$1 = "Stay in review";
var Eval_ApplicationAlreadyEndorsed$1 = "You've already reviewed {{personName}}'s application";
var Eval_ApplicationAlreadyEndorsedDesc$1 = "Thanks! There’s nothing more to do for now.";
var Eval_ApplicationEndorsed$1 = "Thank you";
var Eval_ApplicationEndorsedDesc$1 = "You’ve successfully endorsed {{personName}}’s application.";
var Eval_ApplicationNotEndorsedDesc$1 = "You’ve declined to endorse {{personName}}'s application.";
var Eval_ApplicationOutOfDate$1 = "You’re done! No further action is needed.";
var Eval_ApplicationOutOfDateDesc$1 = "This Skill Review endorsement request was closed and your endorsement is no longer required.";
var Eval_ApproveApplication$1 = "Endorse Application";
var Eval_EndorseApplication$1 = "Endorse Application";
var Eval_EndorsementDesc$1 = "{{personName}} has asked you to endorse their Skill Review. Skill Review is a scientifically-designed questionnaire to help assess someone’s skill level. You will be asked to endorse or request changes to the Skill Review depending on whether the responses provided and result are a good reflection of {{personName}}’s skill.";
var Eval_EndorsementHeader$1 = "{{personName}} - Level {{level}} in {{evaluationName}} - Skill Review";
var Eval_EndorsementNav$1 = "Skill Review Endorsement Navigation";
var Eval_GoBackHome$1 = "Go Home";
var Eval_LeaveRemarks$1 = "Leave Remarks";
var Eval_LevelInItem$1 = "Level {{level}} in {{item}}";
var Eval_NextStep$1 = "Next step";
var Eval_OptionalQuestionDesc_Endorser$1 = "Selecting an endorser is optional. Having an endorser is extra evidence of your skill level.";
var Eval_Question_AdvanceStateOfArt$1 = "Do you help advance the state of the art in this skill?";
var Eval_Question_AdvanceStateOfArtExample$1 = "What is your most recent, innovative advancement that you have contributed to this field?";
var Eval_Question_AlternativeApproaches$1 = "While using this skill, how often do you consider alternative approaches to solving a problem?";
var Eval_Question_AnticipateCommProblems$1 = "While using this skill, how often do you anticipate and resolve communication problems within teams?";
var Eval_Question_AnticipateRequirements$1 = "While using this skill, how often do you anticipate the interests and requirements of others?";
var Eval_Question_ApplyFrequency$1 = "How frequently do you apply this skill?";
var Eval_Question_ApplyJob$1 = "Do you apply this skill in your current job?";
var Eval_Question_ApplyNewTheories$1 = "How often do you apply new theories, techniques, or methods to your work in this skill?";
var Eval_Question_ApproachTheory$1 = "Which of the following best describes how you approach the theory of this field?";
var Eval_Question_ArticulateChallenge$1 = "If there is a significant challenge in a project you are leading in this skill, how often are you the one who articulates the challenge?";
var Eval_Question_ArticulateChallengeExample$1 = "Give an example of a time you articulated a significant challenge for a project you were leading.";
var Eval_Question_BuildConsensus$1 = "While using this skill, how often do you build consensus in a group environment?";
var Eval_Question_BuildConsensusExample$1 = "Describe how you have built consensus about an idea or project in a group.";
var Eval_Question_Collaboration$1 = "When you're planning your work in this skill, do you collaborate with others?";
var Eval_Question_CommunicateDifficultSubjects$1 = "How comfortable are you communicating about difficult subjects in this field?";
var Eval_Question_CommunicationAbilities$1 = "Which best describes your communication abilities in this skill?";
var Eval_Question_ComplexTasks$1 = "How comfortable are you with complex tasks in this field?";
var Eval_Question_ContributeProfessionalDevelopment$1 = "Which best describes how you contribute to the professional development of others in this skill?";
var Eval_Question_ContributeProfessionalDevelopmentExample$1 = "How have you influenced the professional development of other people with this skill?";
var Eval_Question_ContributingToObjectives$1 = "How often do you consider whether your work in this skill is contributing to your objectives?";
var Eval_Question_CrossDiscipline$1 = "While using this skill, how often do you work with people who are in a different discipline?";
var Eval_Question_DefineGroupProcess$1 = "Do you define the work processes that the group follows?";
var Eval_Question_DefineGroupRoles$1 = "Do you help define the roles of each member of the group?";
var Eval_Question_DescribeKnowledge$1 = "How would you describe your knowledge of this skill?";
var Eval_Question_DevelopGroupPotential$1 = "While using this skill in groups, do you look for and develop areas of potential within the group?";
var Eval_Question_DevelopGroupPotentialExample$1 = "Describe an instance when you developed an area of potential in a group or organization.";
var Eval_Question_DirectOthers$1 = "Do you direct the work and roles of others in a field related to this skill?";
var Eval_Question_DirectOthersExample$1 = "How do you direct the work and the roles of other peers in this field?";
var Eval_Question_EvaluateProcesses$1 = "How often do you evaluate the strengths and weaknesses of processes in this skill?";
var Eval_Question_EvaluateProcessesExample$1 = "Describe when you evaluated the strengths and weaknesses of a process related to this skill.";
var Eval_Question_EvaluateWork$1 = "After you complete a task or project in this skill, do you evaluate the effectiveness of your work?";
var Eval_Question_FindSolutions$1 = "While using this skill, how often do you find solutions to a problem that others had not found?";
var Eval_Question_FindSolutionsExample$1 = "Describe when you discovered a solution to a problem that no one else thought of or considered.";
var Eval_Question_FrequencyUnanticipatedProblems$1 = "While using this skill, how often do you encounter problems you didn't anticipate?";
var Eval_Question_HelpGroupEffective$1 = "While using this skill, do you help other people in your groups be more effective?";
var Eval_Question_ImpactOnField$1 = "Do your actions related to this skill have a significant impact beyond your organization?";
var Eval_Question_ImpactOnFieldExample$1 = "Briefly describe how your actions have had a significant impact beyond your organization.";
var Eval_Question_ImpactOthers$1 = "How often do you consider how your choices in this skill will impact other functional areas?";
var Eval_Question_ImproveSkill$1 = "Is this a skill you want to improve?";
var Eval_Question_InnovativeContributionExample$1 = "Provide details about when you presented innovative contributions related to this skill to a broad community.";
var Eval_Question_JobTitle$1 = "What is your job title?";
var Eval_Question_LeadGroup$1 = "Have you led a group in this field?";
var Eval_Question_LeadGroupExample$1 = "Provide an example of a group that you have led in this field.";
var Eval_Question_LeadOrg$1 = "Have you led an organization in this field?";
var Eval_Question_LeadOrgExample$1 = "Provide an example of an organization that you have led in this field.";
var Eval_Question_Learn$1 = "How often do you learn about relevant new concepts and advancements in this skill?";
var Eval_Question_LearnExample$1 = "Briefly describe one thing you've recently learned about this skill.";
var Eval_Question_LearnFromOthers$1 = "How effective are you at learning about this skill from others?";
var Eval_Question_LevelOfResponsibility$1 = "Which best describes your level of responsibility in this skill?";
var Eval_Question_LimitsExample$1 = "Describe a specific limitation or challenge in this field.";
var Eval_Question_LimitsOfField$1 = "Can you identify the current challenges and limitations of this field?";
var Eval_Question_MasterStateOfArt$1 = "Have you mastered the latest ideas, technologies, and features related to this skill?";
var Eval_Question_NumberOfMethods$1 = "While using this skill, which best describes you?";
var Eval_Question_OverallGuidance$1 = "How often is your work in this skill subject to overall guidance from someone else?";
var Eval_Question_PracticalAbilities$1 = "How would you describe your practical abilities in this field?";
var Eval_Question_PresentationAbilities$1 = "Which best describes your presentation abilities in this skill?";
var Eval_Question_PrestipulatedTasks$1 = "How effective are you at carrying out tasks in this skill with pre-stipulated rules?";
var Eval_Question_ProblemsCanSolve$1 = "How would you describe the problems you can solve with this skill?";
var Eval_Question_ProjectResponsibility$1 = "How often do you take responsibility for new projects in this skill?";
var Eval_Question_RelatedSkills$1 = "What other important skills are related to this skill?";
var Eval_Question_RequirementsChange$1 = "How often do the requirements for your projects in this skill change?";
var Eval_Question_SkillDuration$1 = "How long have you used this skill?";
var Eval_Question_SocietalImplications$1 = "How often do you consider the societal, economic, and cultural implications of your work in this skill?";
var Eval_Question_StrategicJudgements$1 = "How effective are you at making strategic judgments related to technical or management tasks in this field?";
var Eval_Question_StrategicProblemExample$1 = "Provide an example of a strategic problem you have identified and solved related to this skill.";
var Eval_Question_Teamwork$1 = "Which of the following describes you when working with a team?";
var Eval_Question_TechnicalKnowledge$1 = "Which best describes your technical and theoretical knowledge of this skill?";
var Eval_Question_TypesUnanticipatedProblems$1 = "What kinds of problems do you encounter that you didn't anticipate?";
var Eval_Question_UnclearTasks$1 = "Can you handle tasks in this skill without clearly-defined rules?";
var Eval_Question_UnderstandRelatedSkills$1 = "How well do you understand these related skills?";
var Eval_Question_WellKnown$1 = "Do most people who have this skill know who you are?";
var Eval_Question_WellKnownExample$1 = "In your estimate, how many people have been influenced by your work in this skill.";
var Eval_Question_WorkInGroup$1 = "While using this skill, do you work in a group setting?";
var Eval_QuestionDesc_Endorser$1 = "Choose someone from your organization who has worked with you enough in this skill to endorse your responses. Your endorser will be able to see all of the responses you provide throughout the skill review and the resulting skill level.";
var Eval_QuestionDesc_HonorCode$1 = "<p>Skill Review is a scientifically-designed questionnaire to help you assess your skill level. The process is designed to ask you simple questions about your experience which are then used to calculate your level.</p><p>The process depends on you answering the questions as accurately as possible. You may notice the occasional prompt to provide an example to help ensure you're being objective.</p><p>We hope the process helps you self reflect on your areas of strength and weakness in this skill. Once you receive your skill level, you can showcase your expertise to your organization or plan your next steps for development.</p>";
var Eval_ReflectSkillDescription$1 = "Do you feel the information provided is reflecting {{personName}}’s actual skill level or does it need changes?";
var Eval_RequestChanges$1 = "Request Changes";
var Eval_Response_1_2Years$1 = "1 - 2 years";
var Eval_Response_11_Years$1 = "11+ years";
var Eval_Response_3_5Years$1 = "3 - 5 years";
var Eval_Response_6_10Years$1 = "6 - 10 years";
var Eval_Response_AcceptHonorCode$1 = "I will answer the questions as accurately as possible";
var Eval_Response_AcknowledgeOthers$1 = "I acknowledge other points of view";
var Eval_Response_AdvancedSkills$1 = "I have advanced, specialized technical skills";
var Eval_Response_BasicKnowledge$1 = "I know the basics";
var Eval_Response_BasicSkills$1 = "I have basic practical skills";
var Eval_Response_BroadSkills$1 = "I have a broad range of practical skills";
var Eval_Response_CommunicateContextually$1 = "I can communicate about solutions in a manner that is contextually appropriate to cross-disciplinary audiences";
var Eval_Response_CommunicateEffectively$1 = "I can communicate effectively about solutions to complex problems";
var Eval_Response_ComplexCommunication$1 = "I can address subject matters that are highly complex, unfamiliar, or technical";
var Eval_Response_ComplexProblems$1 = "Complex problems";
var Eval_Response_ComprehensiveTechTheoryKnowledge$1 = "I have comprehensive, specialized knowledge in these skills";
var Eval_Response_ConvincingOthers$1 = "I spend most of my time convincing others of my point of view";
var Eval_Response_CurrentLimits$1 = "I explore the current limits of theory, knowledge, and practice";
var Eval_Response_Daily$1 = "Daily";
var Eval_Response_DeepKnowledge$1 = "I have deep theoretical and professional knowledge, including core theories and practices";
var Eval_Response_DemonstrateBasics$1 = "I can demonstrate and explain the basics to others";
var Eval_Response_DifferentApproaches$1 = "I evaluate different theories and approaches to solve problems";
var Eval_Response_DirectDevelopment$1 = "I direct the professional development of others";
var Eval_Response_ExtendedSkills$1 = "I have an extended, broad range of specialized practical skills";
var Eval_Response_ExtensiveKnowledge$1 = "I have extensive knowledge of major theories, methods, and schools of practice";
var Eval_Response_ExtensiveTechTheoryKnowledge$1 = "I have extensive knowledge in these skills";
var Eval_Response_FewProblems$1 = "Few or no problems";
var Eval_Response_FewTechniques$1 = "I rely on a few tried and true methods and techniques";
var Eval_Response_FocusOnMyDevelopment$1 = "I focus on my own development";
var Eval_Response_FocusOnMyWork$1 = "I mostly focus on my own work";
var Eval_Response_FocusOnTask$1 = "I focus on the task at hand";
var Eval_Response_IntroduceInnovativeContributions$1 = "I introduce innovative contributions to a broad community";
var Eval_Response_LearningGuidance$1 = "I instruct others with well-founded learning guidance";
var Eval_Response_LessThan1Year$1 = "Less than a year";
var Eval_Response_LimitedTechTheoryKnowledge$1 = "I have limited knowledge of these skills";
var Eval_Response_MakePeopleMoreEffective$1 = "I actively find ways to make other people more effective";
var Eval_Response_Monthly$1 = "Monthly";
var Eval_Response_MostAspects$1 = "My knowledge covers most aspects of this skill";
var Eval_Response_No$1 = "No";
var Eval_Response_NotComfortable$1 = "Not comfortable";
var Eval_Response_NoTechTheoryKnowledge$1 = "I don't understand these skills very well";
var Eval_Response_NotSure$1 = "Not sure";
var Eval_Response_NotVery$1 = "Not very";
var Eval_Response_NovelProblems$1 = "I identify and solve novel problems related to the research, development, or innovation of this skill";
var Eval_Response_Often$1 = "Often";
var Eval_Response_OncePerYear$1 = "Once every few years";
var Eval_Response_OngoingSupport$1 = "I offer ongoing support to others";
var Eval_Response_Partially$1 = "Partially";
var Eval_Response_PresentArguments$1 = "I can present arguments and solutions to complex problems";
var Eval_Response_PresentInformation$1 = "I present clear, timely, and relevant information to appropriate recipients";
var Eval_Response_PresentNone$1 = "I don't present information to others";
var Eval_Response_Rarely$1 = "Rarely";
var Eval_Response_ResponsibilityGiven$1 = "I take responsibility for the work given to me";
var Eval_Response_ResponsibilityOverall$1 = "I take responsibility for overall objectives and results";
var Eval_Response_ResponsibilityPlanning$1 = "I take responsibility for planning and developing projects and initiatives";
var Eval_Response_SensitiveCommunication$1 = "I can address matters that are moderately sensitive, controversial, or likely to be questioned or challenged";
var Eval_Response_SeveralMethods$1 = "I evaluate several methods and techniques based on the situation";
var Eval_Response_SeveralPerYear$1 = "Several times a year";
var Eval_Response_SimpleProblems$1 = "Simple problems";
var Eval_Response_SolveSimpleProblems$1 = "I can solve simple problems";
var Eval_Response_SolveStrategicProblems$1 = "I can solve broad strategic problems";
var Eval_Response_SolveUnfamiliarProblems$1 = "I can solve unfamiliar problems";
var Eval_Response_SolveVarietyProblems$1 = "I can solve a wide variety of complex problems";
var Eval_Response_SomeKnowledge$1 = "I understand some technical and theoretical concepts";
var Eval_Response_Sometimes$1 = "Sometimes";
var Eval_Response_Somewhat$1 = "Somewhat";
var Eval_Response_SomewhatComfortable$1 = "Somewhat comfortable";
var Eval_Response_Specific$1 = "Most of my knowledge is related to a specific part of this skill";
var Eval_Response_StrategicProblems$1 = "Strategic problems";
var Eval_Response_SupportOthers$1 = "I support other people in their roles";
var Eval_Response_Tangential$1 = "My knowledge covers this skill and tangential skills";
var Eval_Response_UncomfortableCommunication$1 = "I'm not comfortable communicating about difficult subjects";
var Eval_Response_UnderstandOthers$1 = "I actively work to understand and reflect other’s point of view";
var Eval_Response_Very$1 = "Very";
var Eval_Response_VeryComfortable$1 = "Very comfortable";
var Eval_Response_Weekly$1 = "Weekly";
var Eval_Response_Yes$1 = "Yes";
var Eval_ResponseDesc_AcceptHonorCode$1 = "<p>Skill Review is a scientifically-designed questionnaire to help you assess your skill level. The process is designed to ask you simple questions about your experience which are then used to calculate your level.</p><p>The process depends on you answering the questions as accurately as possible. You may notice the occasional prompt to provide an example to help ensure you're being objective.</p><p>We hope the process helps you self reflect on your areas of strength and weakness in this skill. Once you receive your skill level, you can showcase your expertise to your organization or plan your next steps for development.</p>";
var Eval_SaveEndorsementError$1 = "An error occurred saving the review.";
var Eval_Step_Application$1 = "Application";
var Eval_Step_AutonomyResponsibility$1 = "Autonomy and Responsibility";
var Eval_Step_Background$1 = "Skill Background";
var Eval_Step_CommunicationTeaching$1 = "Communication and Teaching";
var Eval_Step_DemonstrationOfCriteria$1 = "Skill Details";
var Eval_Step_EndorseDecline$1 = "Endorse or Decline";
var Eval_Step_Endorsement$1 = "Invite Endorser";
var Eval_Step_General$1 = "Skill Background";
var Eval_Step_Introduction$1 = "Introduction";
var Eval_Step_Knowledge$1 = "Knowledge";
var Eval_Step_PlanningEvaluation$1 = "Planning and Evaluation";
var Eval_Step_Questionnaire$1 = "Questionnaire";
var Eval_Step_ReceiveResults$1 = "Receive Results";
var Eval_Step_ReviewApplication$1 = "Review Application";
var Eval_Step_TeamworkLeadership$1 = "Teamwork and Leadership";
var Eval_StepDesc_Application$1 = "Results of {{personName}}'s Skill Review Application.";
var Eval_StepDesc_EndorseDecline$1 = "Assess if the application reflects the actual skill level of {{personName}}.";
var Eval_StepDesc_EndorseIntroduction$1 = "Explanation of what a Skill Review is.";
var Eval_StepDesc_General$1 = "A quick overview";
var Eval_StepDesc_ReviewApplication$1 = "Results of {{personName}}'s Skill Review application.";
var ErrorPages_ErrorTitle$1 = "Oops. We can't find the page you're looking for.";
var ErrorPages_ErrorTitle500$1 = "Oops. Something went wrong.";
var ErrorPages_FaultSolution$1 = "Our site has changed a lot lately and stuff has moved. Try retyping the address, report a problem, or go to the homepage.";
var ErrorPages_HomepageButton$1 = "Degreed Homepage";
var ErrorPages_ReportBugButton$1 = "Report a Problem";
var ErrorPages_VerifyEmailErrorText$1 = "Oh oh! This link is expired. Check your email for a new verification link.";
var ErrorPages_VerifyEmailErrorTitle$1 = "Link Expired";
var EpisodeFormCtrl_AddPodcast$1 = "Add Podcast Episode";
var EpisodeFormCtrl_Category$1 = "Please add at least one category.";
var EpisodeFormCtrl_ChooseEpisode$1 = "Choose Episode";
var EpisodeFormCtrl_DateCompleted$1 = "Date Completed";
var EpisodeFormCtrl_EditPodcast$1 = "Edit Podcast Episode";
var EpisodeFormCtrl_EnterPodcastName$1 = "Enter Podcast Name";
var EpisodeFormCtrl_Episode$1 = "Episode";
var EpisodeFormCtrl_EpisodeError$1 = "Sorry! There was a problem accessing your episodes.";
var EpisodeFormCtrl_ICreatedEpisode$1 = "I created this episode";
var EpisodeFormCtrl_LengthInMinutes$1 = "Length (Minutes)";
var EpisodeFormCtrl_Loading$1 = "Loading...";
var EpisodeFormCtrl_NoEpisodes$1 = "No Episodes Found";
var EpisodeFormCtrl_NoMatch$1 = "(Unable to find a matching podcast or author name. Note that explicit podcasts are filtered from search.)";
var EpisodeFormCtrl_PodcastName$1 = "Podcast Name";
var EpisodeFormCtrl_SaveEpisode$1 = "Save Episode";
var EpisodeFormCtrl_SelectEpisode$1 = "Please select an episode from the list.";
var EpisodeFormCtrl_SelectTitle$1 = "Title is required";
var EpisodeFormCtrl_ValidNumber$1 = "The length must be a valid number or left blank";
var EpisodeFormCtrl_WhatDidYouLearnLong$1 = "What did you learn from this podcast episode?";
var EpisodeFormCtrl_WhatDidYouLearnShort$1 = "What did you learn?";
var endorsersForm_applicantsEmailValidationMessage$1 = "Please provide the endorser's email address, not your own email address";
var endorsersForm_Header$1 = "Who can endorse you for this skill?";
var endorsersForm_Instructions$1 = '<p class="par">In this step, provide contact information for three endorsers, who can vouch for the accuracy of your statements about your process and past performance in {{credentialName}}. They should all have first-hand knowledge of your skill, such as people you worked with on a project where you used the skill.</p>\n\n<p class="par">An endorsement will only take about 15 minutes. The endorser will be asked to give you a rating in terms of accuracy and proficiency for each skill behavior. We will send an email to your endorsers when you submit your application.</p>\n\n<p class="par">The names of your endorsers will appear on your final certificate.</p>';
var endorsersForm_InstructionsFour$1 = "If you submit your application by the deadline, we will email your endorsers shortly after {{date}}.";
var endorsersForm_InstructionsOne$1 = "In this step, provide contact information for three endorsers, who can vouch for the accuracy of your statements about your process and past performance in {{credentialName}}. They should all have first-hand knowledge of your skill, like people you worked with on a project where you used it.";
var endorsersForm_InstructionsThree$1 = "The names of your endorsers will appear on your final certificate.";
var endorsersForm_InstructionsTwo$1 = "An endorsement will only take about 15 minutes. There is no writing involved. The endorser will be asked to give you a rating in terms of accuracy and proficiency for each skill behavior.";
var endorsersForm_InvalidEmailValidationMessage$1 = "Please enter a valid email address.";
var endorsersForm_sameEmailValidationMessage$1 = "This email address is the same as another endorser's email address. Please provide a unique email address for each endorser.";
var endorsersForm_SectionHeader1$1 = "Who is your first endorser?";
var endorsersForm_SectionHeader2$1 = "Who is your second endorser?";
var endorsersForm_SectionHeader3$1 = "Who is your third endorser?";
var endorsersForm_Tip$1 = "Choose people who you can trust to respond to a request to endorse you. You may want to give them a heads up that you've selected them to vouch for you.";
var endorsersForm_ValidationMessage$1 = "This field is required.";
var endorserForm_EditHeader$1 = "Edit Endorser";
var endorserForm_EmailLabel$1 = "What is this endorser’s email address?";
var endorserForm_EmailPlaceholder$1 = "e.g. Username@email.com";
var endorserForm_FirstNameLabel$1 = "What is their first name?";
var endorserForm_InvitationLabel$1 = "If you want, you can add a personal message to your endorser.";
var endorserForm_LastNameLabel$1 = "What is their last name?";
var endorserForm_PositionLabel$1 = "What is your endorser’s job? Include both the job role and the affiliation.";
var endorserForm_PositionPlaceholder$1 = "e.g. CEO at Degreed";
var endorserForm_RelationshipLabel$1 = "How do you know this endorser?";
var endorserForm_RelationshipPlaceholder$1 = "e.g. Current manager";
var EndorsementSvc_ErrorGetting$1 = "Sorry! There was an error retrieving the endorsement details.";
var EndorsementSvc_ErrorSaving$1 = "Sorry! There was a problem saving your selection.";
var EndorsementOptionsSvc_ContributionLarge$1 = "Large contribution";
var EndorsementOptionsSvc_ContributionModerate$1 = "Moderate contribution";
var EndorsementOptionsSvc_ContributionNone$1 = "Did not contribute";
var EndorsementOptionsSvc_ContributionSmall$1 = "Small contribution";
var EndorsementOptionsSvc_ContributionVeryLarge$1 = "Very large contribution";
var EndorsementOptionsSvc_DifficultyExtremely$1 = "Extremely Difficult";
var EndorsementOptionsSvc_DifficultyNot$1 = "Not Difficult";
var EndorsementOptionsSvc_DifficultySlightly$1 = "Slightly Difficult";
var EndorsementOptionsSvc_DifficultySomewhat$1 = "Somewhat Difficult";
var EndorsementOptionsSvc_DifficultyVery$1 = "Very Difficult";
var EndorsementOptionsSvc_ExpertLevel1$1 = "30th percentile or below";
var EndorsementOptionsSvc_ExpertLevel2$1 = "30th to 49th percentile";
var EndorsementOptionsSvc_ExpertLevel3$1 = "50th to 69th percentile";
var EndorsementOptionsSvc_ExpertLevel4$1 = "70th to 89th percentile";
var EndorsementOptionsSvc_ExpertLevel5$1 = "90th to 99th percentile";
var EndorsementOptionsSvc_MasteryCapable$1 = "Capable";
var EndorsementOptionsSvc_MasteryDistinguished$1 = "Distinguished";
var EndorsementOptionsSvc_MasteryEmerging$1 = "Emerging";
var EndorsementOptionsSvc_MasteryExperienced$1 = "Experienced";
var EndorsementOptionsSvc_MasteryMaster$1 = "Master";
var EndorsementOptionsSvc_MasteryNovice$1 = "Novice";
var EndorsementOptionsSvc_People0To5$1 = "0-5 People";
var EndorsementOptionsSvc_People11To20$1 = "11-20 People";
var EndorsementOptionsSvc_People151Plus$1 = "151+ People";
var EndorsementOptionsSvc_People21To40$1 = "21-40 People";
var EndorsementOptionsSvc_People41To80$1 = "41-80 People";
var EndorsementOptionsSvc_People6To10$1 = "6-10 People";
var EndorsementOptionsSvc_People81To150$1 = "81-150 People";
var EndorsementOptionsSvc_Percentile30Minus$1 = "30th percentile or below";
var EndorsementOptionsSvc_Percentile30To49$1 = "30th to 49th percentile";
var EndorsementOptionsSvc_Percentile50To69$1 = "50th to 69th percentile";
var EndorsementOptionsSvc_Percentile70To89$1 = "70th to 89th percentile";
var EndorsementOptionsSvc_Percentile90To99$1 = "90th to 99th percentile";
var EndorsementOptionsSvc_RelationshipClientOfFormat$1 = "You were a client of {{name}}";
var EndorsementOptionsSvc_RelationshipDifferentCompanyFormat$1 = "You worked with {{name}} but at different companies";
var EndorsementOptionsSvc_RelationshipDifferentGroupFormat$1 = "You worked with {{name}} in different groups";
var EndorsementOptionsSvc_RelationshipManagedFormat$1 = "You managed {{name}} directly";
var EndorsementOptionsSvc_RelationshipMentorFormat$1 = "You were a mentor for {{name}}";
var EndorsementOptionsSvc_RelationshipReportedToFormat$1 = "You reported directly to {{name}}";
var EndorsementOptionsSvc_RelationshipSameGroupFormat$1 = "You worked with {{name}} in the same group";
var EndorsementOptionsSvc_RelationshipSeniorToFormat$1 = "You were senior to {{name}} but didn\xe2€™t manage directly";
var EndorsementOptionsSvc_RelationshipSeniorToYouFormat$1 = "{{name}} was senior to you but didn\xe2€™t manage you directly";
var EndorsementOptionsSvc_RelationshipStudents$1 = "You were students together";
var EndorsementOptionsSvc_RelationshipTeacherFormat$1 = "You were a teacher of {{name}}";
var EndorsementOptionsSvc_RelationshipYourCientFormat$1 = "{{name}} was a client of yours";
var EndorsementOptionsSvc_SignificanceExtremely$1 = "Extremely Significant";
var EndorsementOptionsSvc_SignificanceNot$1 = "Not Significant";
var EndorsementOptionsSvc_SignificanceSlightly$1 = "Slightly Significant";
var EndorsementOptionsSvc_SignificanceSomewhat$1 = "Somewhat Significant";
var EndorsementOptionsSvc_SignificanceVery$1 = "Very Significant";
var EndorsementOptionsSvc_VerifyNo$1 = "No, something is incorrect";
var EndorsementOptionsSvc_VerifyPartial$1 = "Partially, I have knowledge of some of the information";
var EndorsementOptionsSvc_VerifyUnknown$1 = "No, I don't have knowledge of any of the information";
var EndorsementOptionsSvc_VerifyYes$1 = "Yes, everything looks correct";
var EndorsementOptionsSvc_Years0To1$1 = "0-1 Year";
var EndorsementOptionsSvc_Years11To14$1 = "11-14 Years";
var EndorsementOptionsSvc_Years15To20$1 = "15-20 Years";
var EndorsementOptionsSvc_Years21Plus$1 = "21+ Years";
var EndorsementOptionsSvc_Years2To4$1 = "2-4 Years";
var EndorsementOptionsSvc_Years5To7$1 = "5-7 Years";
var EndorsementOptionsSvc_Years8To10$1 = "8-10 Years";
var EmbeddedLearning_ComingSoon$1 = "Coming Soon!";
var EmbeddedLearning_RelatedArticles$1 = "Related articles";
var EmbeddedLearning_RelatedPathways$1 = "Related pathways";
var EmbeddedLearning_RelatedVideos$1 = "Related videos";
var EmailAddressVerificationCtrl_VerificationEmailSentFormat$1 = "Verification email sent to {{email}}";
var downloadReportOutcome_FailureFormat$1 = "There was an error generating the {{name}} report you requested.";
var downloadReportOutcome_SuccessFormat$1 = "Your {{name}} report is available for download.";
var Download_DownloadFile$1 = "Download File";
var dgXpBar_NewPointsFormat$1 = "{{newPoints}} pts";
var dgXpBar_NextGoalFormat$1 = "{{nextGoal}} pts";
var dgWordLimit_LimitToFormat$1 = "{{number}} words maximum.";
var dgWordLimit_MinLimitFormat$1 = "{{number}} words minimum.";
var dgWordLimit_WordCount$1 = "Word Count";
var dgWordLimit_WordLimitReached$1 = "Word limit exceeded";
var dgWordLimit_WordsRemaining$1 = "Words remaining:";
var dgVideoPlayer_BrowserError$1 = "Your browser is unable to play this video.";
var dgVideoPlayer_EncodingMessage$1 = "We're still processing this new video for your browser.<br>Try again later.";
var dgVBarChart_A11yTipFormat$1 = "{{count}} {{inputType}}, {{totalPoints}} total in {{monthName}}";
var dgVBarChart_A11yTipFormatRange$1 = "{{count}} {{inputType}}, {{totalPoints}} total from {{startDate}} to {{endDate}}";
var dgVBarChart_ChartFilterA11y$1 = "On selecting an input, the chart will update";
var dgVBarChart_ContentItems$1 = "Content Items";
var dgVBarChart_Date$1 = "Date";
var dgVBarChart_DisplayTypeLabel$1 = "Show";
var dgVBarChart_DisplayTypePlaceholder$1 = "Choose Data Type";
var dgVBarChart_InputTypeLabel$1 = "from";
var dgVBarChart_InputTypePlaceholder$1 = "Choose Content Type";
var dgVBarChart_NoPointsTipFormat$1 = "Total: {{totalPoints}}";
var dgVBarChart_PeriodLabel$1 = "this";
var dgVBarChart_PeriodPlaceholder$1 = "Period";
var dgVBarChart_Points$1 = "Points";
var dgVBarChart_PointsTipFormat$1 = "<b>{{date}}</b><br/>{{item}}: {{itemPoints}}<br/>Total: {{totalPoints}}";
var dgVBarChart_TopicLabel$1 = "in";
var dgVBarChart_ViewLearningCompletions$1 = "View Learning Completion Details";
var dgValidatedField_WhoopsMessageFormat$1 = "Whoops! {{message}}";
var dgUtilityBar_AddToProfileInProgress$1 = "Sorry! You can’t add content here right now. Go to your Profile or the Home page and try again.";
var dgUtilityBar_AddToProfileTitle$1 = "Add to profile";
var dgUtilityBar_FindSomethingToLearnPlaceholder$1 = "Find something to learn";
var dgUtilityBar_FlexEdFormat$1 = "{{available}} FlexED";
var dgUtilityBar_InProgress$1 = "In Progress";
var dgUtilityBar_ManageOrg$1 = "Manage {{orgName}}";
var dgUtilityBar_MasteryPointsFormat$1 = "{{masteryPoints}} pts";
var dgUtilityBar_PersonalInformationTitle$1 = "Personal Information";
var dgUtilityBar_SearchLabel$1 = "Expand Search";
var dgUtilityBar_SelectAnotherSkill$1 = "Choose another skill";
var dgUtilityBar_SelectASkill$1 = "Choose a skill";
var dgUserTile_Follow$1 = "Follow";
var dgUserTile_Following$1 = "Following";
var dgUserTile_Unfollow$1 = "Unfollow";
var dgUsersSearch_Follow$1 = "Follow";
var dgUsersSearch_FollowUserFormat$1 = "Follow {{username}}'s learning activities";
var dgUsersSearch_NoResults$1 = "No people found that match your search criteria.";
var dgUsersSearch_SearchDescription$1 = "Degreed helps you keep up with the latest in what people are learning and discovering.";
var dgUsersSearch_SearchLabel$1 = "Search for people";
var dgUsersSearch_SearchPlaceholder$1 = 'Find people to follow by category. Or search names using quotes. ie "Jane Doe"';
var dgUsersSearch_SearchTitle$1 = "Connect with Others";
var dgUsersSearch_UnFollow$1 = "Following";
var dgUsersSearch_UnfollowUserFormat$1 = "Stop following {{username}}'s learning activities";
var dgUserProfilePrivacy_ProfileSettingDescriptionFormat$1 = "This setting impacts the visibility of your learning activities and whether or not your profile can be discovered by other {{orgName}} learners.";
var dgUserProfilePrivacy_VisibleToMeOnly$1 = "Visible to me only";
var dgUserProfilePrivacy_VisibleToMeOnlyDesc$1 = "Only you can view your profile and learning activities";
var dgUserProfilePrivacy_VisibleToMeOnlyLabel$1 = "Private";
var dgUserProfilePrivacy_VisibleToOrgDesc$1 = "Only people from your organization with a Degreed account can view your profile and learning activities";
var dgUserProfilePrivacy_VisibleToOrgLabel$1 = "Organization";
var dgUserProfilePrivacy_VisibleToOrgOnly$1 = "Visible to my organization only";
var dgUserProfilePrivacy_VisibleToPublic$1 = "Visible to the public";
var dgUserProfilePrivacy_VisibleToPublicDesc$1 = "Everybody can view your profile and learning activities.";
var dgUserProfilePrivacy_VisibleToPublicInOrg$1 = "Visible to the public and my organization";
var dgUserProfilePrivacy_VisibleToPublicLabel$1 = "Public";
var dgUserProfile_BecomeMentorSearchTitle$1 = "Skills you'd like to mentor";
var dgUserProfile_BecomeMentorSelectTitle$1 = "Receive mentorship requests from within your organization";
var dgUserProfile_BecomeMentorTitle$1 = "Become a Mentor";
var dgUserProfile_IntegrationAssigned$1 = "{{integrationName}} assigned this job role to you.";
var dgUserProfile_OppTypesInterestedTitle$1 = "I'm interested in seeing opportunities in Degreed home";
var dgUserProfile_OppTypesSelectTitle$1 = "Select the types you’re interested in seeing on Degreed home";
var dgUserProfile_OppTypesTitle$1 = "Opportunity Types";
var dgUserProfile_OptInLabel$1 = "Opt-in";
var dgUserProfile_PersonalInformationLabel$1 = "Personal Information";
var dgUserProfile_PictureLabel$1 = "Picture";
var dgUserProfile_PrivacyLockedMessage$1 = "Some of your profile settings are managed by {{OrgName}}";
var dgUserProfile_PrivacyVisibilityLabel$1 = "Visibility";
var dgUserProfile_SkillCoachLabel$1 = "Skill Coach";
var dgUserProfile_TeamProgramDesc$1 = "Join Skill Coach to allow your manager to help you develop your skills";
var dgUserProfile_TeamProgramDescSkillInventory$1 = "Join Skill Coach to allow your manager to help you develop your skills.";
var dgUserProfile_TeamProgramJoinDesc$1 = "When you opt into Skill Coach, your manager can view your skill data to help you in your skill development.";
var dgUserProfile_TeamProgramJoinHeader$1 = "Opt In";
var dgUserProfile_TeamProgramLabel$1 = "Skill Coach";
var dgUserProfile_TeamProgramLeaveDesc$1 = "With Skill Coach, your manager can view your skill data to help you in your skill development. To prevent your manager from viewing this data, select Opt Out.";
var dgUserProfile_TeamProgramLeaveHeader$1 = "Opt Out";
var dgUserOverview_Channel$1 = "Global Admin Tools";
var dgUserOverview_ConnectFlexedCard$1 = "Connect your FlexED card";
var dgUserOverview_FlexEd$1 = "FlexED";
var dgUserOverview_Logout$1 = "Log Out";
var dgUserOverview_Points$1 = "{{newPoints}} points";
var dgUserOverview_Profile$1 = "Your Profile";
var dgUserOverview_Settings$1 = "Profile Settings";
var dgUserOverview_SkillCertification$1 = "Skill Certification";
var dgUserOverview_SkillReview$1 = "Skill Review";
var dgUserOverview_SwitchOrganization$1 = "Switch Organization";
var dgUserOutcomeItem_AdditionalInfo$1 = "Additional information";
var dgUserOutcomeItem_AwardIssuer$1 = "The award issuer";
var dgUserOutcomeItem_ContentTypeOverview$1 = "{{contentType}} Overview";
var dgUserOutcomeItem_DidntSpecify$1 = "The candidate did not specify.";
var dgUserOutcomeItem_EarningCertificate$1 = "Candidate's activity in earning this certificate";
var dgUserOutcomeItem_HowEarned$1 = "How the award was earned";
var dgUserOutcomeItem_HowWasAchieved$1 = "How this accomplishment was achieved";
var dgUserOutcomeItem_SelectivityAward$1 = "The selectivity of this award";
var dgUserOutcomeItem_SelectivityCertificate$1 = "The selectivity of this certificate";
var dgUserOutcomeItem_SkillCandidate$1 = "Candidate's process for using the skill";
var dgUserOutcomeItem_WhenWasApplied$1 = "Example of when this skill was applied";
var dgUserOutcomeItem_WhoElseContributed$1 = "Who else contributed to this accomplishment";
var dgUserOutcomeItem_WhyUseCandidate$1 = "Why candidate uses the process described above";
var dgUserOutcomeEditForm_AccomplishmentDate$1 = "I reached this accomplishment on a single date.";
var dgUserOutcomeEditForm_AchievedDate$1 = "Achieved on";
var dgUserOutcomeEditForm_ActiveCert$1 = "For which dates is the certificate active?";
var dgUserOutcomeEditForm_AddAccomplishment$1 = "Add an Accomplishment";
var dgUserOutcomeEditForm_AddADegree$1 = "Add a Degree";
var dgUserOutcomeEditForm_AddAward$1 = "Add an Award";
var dgUserOutcomeEditForm_AddBadge$1 = "Add a Badge";
var dgUserOutcomeEditForm_AddBadgeUrl$1 = "Add the URL from any Open Badge";
var dgUserOutcomeEditForm_AddCertificate$1 = "Add a Certificate";
var dgUserOutcomeEditForm_AddDegree$1 = "Add Degree";
var dgUserOutcomeEditForm_AdditionalSkillInfo$1 = "Provide any additional information that may be useful in assessing this skill.";
var dgUserOutcomeEditForm_AddSkill$1 = "Add a Skill";
var dgUserOutcomeEditForm_AwardedDate$1 = "Awarded on";
var dgUserOutcomeEditForm_BadgeIssuer$1 = "Issuer";
var dgUserOutcomeEditForm_BadgeName$1 = "Badge Name";
var dgUserOutcomeEditForm_BadgeProvider$1 = "Badge Provider";
var dgUserOutcomeEditForm_BadgeUrlJson$1 = "Badge Url (ending in .json)";
var dgUserOutcomeEditForm_CategoryAwardsDescription$1 = "Tip: Enter a skill name, then you can choose from the list or use the enter key";
var dgUserOutcomeEditForm_CategoryDescription$1 = "Tip: Enter a skill name, then you can choose from the list or use the enter key";
var dgUserOutcomeEditForm_CertificateGrouping$1 = "Tip: Enter a skill name, then you can choose from the list or use the enter key";
var dgUserOutcomeEditForm_CertNumber$1 = "Enter the certificate #, if applicable";
var dgUserOutcomeEditForm_CollegeUniversity$1 = "College or University";
var dgUserOutcomeEditForm_ConceptualizeSkillFormat$1 = "Example: I can conceptualize a product scope and construct a timeline for the development and release of key features.";
var dgUserOutcomeEditForm_Country$1 = "Country";
var dgUserOutcomeEditForm_DateCompleted$1 = "Date Completed";
var dgUserOutcomeEditForm_DateGraduated$1 = "Date Graduated";
var dgUserOutcomeEditForm_DegreeGrouping$1 = "Tip: Enter a skill name, then you can choose from the list or use the enter key";
var dgUserOutcomeEditForm_DegreeLevel$1 = "Degree Level";
var dgUserOutcomeEditForm_DegreeLevelExample$1 = "e.g. Bachelor's";
var dgUserOutcomeEditForm_DegreeTitleExample$1 = "e.g. B.S. Computer Science";
var dgUserOutcomeEditForm_DescribeAccomplishment$1 = "Describe your Accomplishment";
var dgUserOutcomeEditForm_DescribeSkill$1 = "Describe your Skill";
var dgUserOutcomeEditForm_DescribeUseOfSkill$1 = "Describe your process for using this skill";
var dgUserOutcomeEditForm_DescribeWhyUseOfSkill$1 = "Why do you use the process you described?";
var dgUserOutcomeEditForm_DoesCertExpire$1 = "This certificate does not expire";
var dgUserOutcomeEditForm_EditAccomplishment$1 = "Edit Accomplishment";
var dgUserOutcomeEditForm_EditAward$1 = "Edit Award";
var dgUserOutcomeEditForm_EditBadge$1 = "Edit Badge";
var dgUserOutcomeEditForm_EditCertificate$1 = "Edit Certificate";
var dgUserOutcomeEditForm_EditDegree$1 = "Edit Degree";
var dgUserOutcomeEditForm_EndDate$1 = "End Date";
var dgUserOutcomeEditForm_ExpandedClientBase$1 = 'Example: "Expanded client base by 78% in three years."';
var dgUserOutcomeEditForm_Expiration$1 = "Expiration";
var dgUserOutcomeEditForm_FieldOfStudy$1 = "Field of Study";
var dgUserOutcomeEditForm_FormatDescription$1 = "Format description in the form of 'I can...'";
var dgUserOutcomeEditForm_GPA$1 = "GPA";
var dgUserOutcomeEditForm_GPAExample$1 = "e.g. 4.0, 3.1";
var dgUserOutcomeEditForm_HeldSkill$1 = "How long have you held this skill?";
var dgUserOutcomeEditForm_IncludeTypicalCourses$1 = "Also add typical courses for this degree to my profile";
var dgUserOutcomeEditForm_IssuedBy$1 = "Issued by";
var dgUserOutcomeEditForm_IssuerUrl$1 = "URL of Issuer";
var dgUserOutcomeEditForm_MozillaBadge$1 = "Mozilla Open Badges help to allow any organization to issue, manage and display digital badges. This helps learners everywhere get recognition for skills and achievements that happen online or outside of school.";
var dgUserOutcomeEditForm_OpenBadgeLabelFormat$1 = "Learn more about  {{startAnchor}}Mozilla's Open Badge Project{{endAnchor}}.";
var dgUserOutcomeEditForm_OrganizedCharity$1 = 'Example: "Organized charity event with 200 volunteers that raised over $100,000."';
var dgUserOutcomeEditForm_OutsideUS$1 = "This degree was earned outside the US";
var dgUserOutcomeEditForm_QuantitativeDescriptions$1 = "Quantitative descriptions are strongest.";
var dgUserOutcomeEditForm_RateProficiency$1 = "Rate your proficiency";
var dgUserOutcomeEditForm_SaveBadge$1 = "Save Badge";
var dgUserOutcomeEditForm_SaveDegree$1 = "Save Degree";
var dgUserOutcomeEditForm_SaveToProfile$1 = "Save to Profile";
var dgUserOutcomeEditForm_SelectCategories$1 = "Skills";
var dgUserOutcomeEditForm_SelectField$1 = "Select a field closely matching yours";
var dgUserOutcomeEditForm_SkilGrouping$1 = "Tip: Enter a skill name, then you can choose from the list or use the enter key";
var dgUserOutcomeEditForm_SkillCandidateAbbrFormat$1 = "{{startAbbr}}ex.{{endAbbr}} I can source candidates and accurately analyze their skills and fit for a specific position.";
var dgUserOutcomeEditForm_SkillEvidence$1 = "Provide evidentiary links to materials or sources that support your expertise";
var dgUserOutcomeEditForm_SkillEvidenceAbbrFormat$1 = "{{startAbbr}}ex.{{endAbbr}} Published articles, interviews, podcasts, presentations, etc.";
var dgUserOutcomeEditForm_SkillGrouping$1 = "Tip: Enter a skill name, then you can choose from the list or use the enter key";
var dgUserOutcomeEditForm_SkillHistory$1 = "You may wish to include any educational resources, people, past experiences, or challenges that have influenced your process.";
var dgUserOutcomeEditForm_SkillInstance$1 = "Describe an instance when you applied this skill";
var dgUserOutcomeEditForm_SkillUse$1 = "Briefly describe how often you apply this skill";
var dgUserOutcomeEditForm_SkillUseDetail$1 = "Provide details such as the steps you took, the challenges you faced, your rationale, and your results.";
var dgUserOutcomeEditForm_SkillUseDetails$1 = "Provide details such as the steps you took, the challenges you faced, your rationale, and your results.";
var dgUserOutcomeEditForm_StartDate$1 = "Start Date";
var dgUserOutcomeEditForm_TitleOfAward$1 = "Title of Award";
var dgUserOutcomeEditForm_TitleOfCertificate$1 = "Title of the Certificate";
var dgUserOutcomeEditForm_TitleOfDegree$1 = "Title of Degree";
var dgUserOutcomeEditForm_UniversityCountry$1 = "University Country";
var dgUserOutcomeEditForm_UniversityName$1 = "University Name";
var dgUserOutcomeEditForm_UploadAnImage$1 = "Upload an image";
var dgUserOutcomeEditForm_UploadBadge$1 = "Upload Badge";
var dgUserOutcomeEditForm_UploadDegreeImage$1 = "Upload an image of your degree";
var dgUserOutcomeEditForm_UploadImageOfCertificate$1 = "Upload an image of the certificate";
var dgUserOutcomeEditForm_WhatDidYouDo$1 = "What did you have to do in order to earn the award?";
var dgUserOutcomeEditForm_WhatTimeSpan$1 = "What time span does this accomplishment cover?";
var dgUserOutcomeEditForm_WhenDidYouReceiveAward$1 = "When did you receive this award?";
var dgUserOrganizationPicker_Everyone$1 = "Everyone (public)";
var dgUserOrganizationPicker_Loading$1 = "loading...";
var dgUserOrganizationPicker_OnlyMe$1 = "Only Me (Personal)";
var dgUserInfo_LinkCopied$1 = "Link Copied!";
var dgUserGoalItem_ViewGroup$1 = "View Group";
var dgUserEvaluationEndorsement_approved$1 = "Approved your Skill Review in {{tagName}}";
var dgUserEvaluationEndorsement_complete_endorsementRequested$1 = "{{personNameHtml}} asked you to endorse their Skill Review in {{skillNameHtml}}, and you already reviewed it. Thanks!";
var dgUserEvaluationEndorsement_endorsementCompleted$1 = "{{personNameHtml}} endorsed your Skill Review in {{skillNameHtml}}";
var dgUserEvaluationEndorsement_endorsementRequested$1 = "{{personNameHtml}} asked you to endorse their Skill Review in {{skillNameHtml}}";
var dgUserEvaluationEndorsement_endorsementRequestedChanges$1 = "{{personNameHtml}} requested changes to your Skill Review in {{skillNameHtml}}";
var dgUserEvaluationEndorsement_endosed$1 = "Endorsed your Skill Review in {{tagName}}";
var dgUserEvaluationEndorsement_goToApplication$1 = "Go to Application";
var dgUserEvaluationEndorsement_requestedChanges$1 = "Requested changes in your Skill Review in {{tagName}}";
var dgUserDeleteProfile_DeletedProfileConfirmed$1 = "Your account is being deleted. We're sad to see you go.<br>You will be redirected shortly.";
var dgUserDeleteProfile_DeleteProfileConfirmation$1 = "Are you sure you want to delete your Degreed profile?";
var dgUserDeleteProfile_No$1 = "No";
var dgUserDeleteProfile_Yes$1 = "Yes";
var dgTrackableLink_Trackable$1 = "Trackable";
var dgTopGroups_AdministrativeGroup$1 = "Administrative Group";
var dgTopGroups_ClosedGroup$1 = "Closed Group";
var dgTopGroups_Empty$1 = "No top active groups";
var dgTopGroups_LinkToGroups$1 = "All groups";
var dgTopGroups_PrivateGroup$1 = "Private Group";
var dgThumbs_Dislike$1 = "Dislike";
var dgThumbs_Like$1 = "Like";
var dgThumbs_NotDisliked$1 = "Not disliked";
var dgThumbs_RemoveDislike$1 = "Remove Dislike";
var dgThumbs_RemoveLike$1 = "Remove Like";
var dgThumbs_Undislike$1 = "Undislike";
var dgThSort_SortAscendingFormat$1 = "Sort {{columnName}} by ascending";
var dgThSort_SortDescendingFormat$1 = "Sort {{columnName}} by descending";
var dgThSort_SortedAscendingFormat$1 = "Sorted by {{columnName}} ascending";
var dgThSort_SortedDescendingFormat$1 = "Sorted by {{columnName}} descending";
var dgTargetTile_PrimaryPlan$1 = "Primary Plan";
var dgTargetTile_SkillFormat$1 = "{{targetTagCount}} Skill";
var dgTargetTile_SkillsFormat$1 = "{{targetTagCount}} Skills";
var dgTargetTile_UnfollowConfirm$1 = "Are you sure you want to stop following this {{targetType}}?";
var dgTargetTile_UnfollowExplanation$1 = "Content from this {{targetType}} will no longer appear in your Feed.";
var dgTagsList_PlusCountMore$1 = "+{{count}} more";
var dgTagsList_RemoveWorkdaySkillInfo$1 = "If {{skillName}} exists in your Workday profile, removing it from here will also remove it from your Workday profile.";
var dgTagsList_RemoveWorkdaySkillTitle$1 = "Remove Workday Skill";
var dgTagsList_VisitWorkday$1 = "Visit Workday";
var dgTagsEdit_AddTagFormat$1 = "Add {{tag}}";
var dgTagsEdit_PlusAdd$1 = "+ Add";
var dgTagsEdit_RemoveTagFormat$1 = "Remove {{tag}}";
var dgTagsEdit_View_More_Button$1 = "View More";
var dgTagsEdit_WhatDidYouLearn$1 = "Skills";
var dgTagsEdit_WhoopsFormat$1 = "Whoops! {{errorMessage}}";
var dgTagRating_A11yAddFocusSkill$1 = "Add {{skillName}} to focus skills";
var dgTagRating_A11yAddSelfRating$1 = "Add self rating for {{skillName}}";
var dgTagRating_A11yAddSkillReview$1 = "Add skill review for {{skillName}}";
var dgTagRating_A11yAddSkillTarget$1 = "Add target skill level for {{skillName}}";
var dgTagRating_A11yChangeSelfRating$1 = "Self rating for {{skillName}}, level {{levelNumber}}. Change self rating";
var dgTagRating_A11yRemoveFocusSkill$1 = "Remove {{skillName}} from focus skills";
var dgTagRating_A11yRequestManagerRating$1 = "Request manager rating for {{skillName}}";
var dgTagRating_A11yRequestPeerRating$1 = "Request peer rating for {{skillName}}";
var dgTagRating_A11yRequestUpdateManagerRating$1 = "Manager rating for {{skillName}}, level {{levelNumber}}. Request manager rating";
var dgTagRating_A11yRequestUpdatePeerRating$1 = "Peer rating for {{skillName}}, level {{levelNumber}}. Request peer rating";
var dgTagRating_A11ySelfRatingCount$1 = "{{skillName}} is self-rated at level {{rating}}";
var dgTagRating_A11ySkillOptions$1 = "More options for {{skillName}}";
var dgTagRating_A11ySkillReviewComplete$1 = "Completed skill review for {{skillName}} level {{levelNumber}}";
var dgTagRating_A11ySkillReviewInProgress$1 = "Skill review for {{skillName}} in progress";
var dgTagRating_A11ySkillSignalCounts$1 = "{{totalSignalCount}} skill signals for {{skillName}}";
var dgTagRating_A11ySkillTarget$1 = "Target for {{skillName}}, level {{levelNumber}}. Change target level";
var dgTagRating_A11yTotalRatingCounts$1 = "{{skillName}} has {{totalRatingsCount}} total ratings";
var dgTagRating_AddA11y$1 = "Add the skill to your profile";
var dgTagRating_AddCredential$1 = "Add Skill Certification";
var dgTagRating_Added$1 = "Added";
var dgTagRating_AddedA11y$1 = "Remove the skill from your profile";
var dgTagRating_AddedIntegrationSkillsProfileDetails$1 = "We have found {{skillsLength}} {{providerName}} skill assessments and we have added the ratings to the skills on your profile.";
var dgTagRating_AddEvalRating$1 = "Add Skill Review";
var dgTagRating_AddEvaluation$1 = "Add Skill Review";
var dgTagRating_AddExternalRatingDetail$1 = "Measure your skill proficiency with {{ProviderName}}.";
var dgTagRating_AddFocusSkill$1 = "Add Focus Skill";
var dgTagRating_AddFocusSkillItem$1 = "Add {{title}} as focus still";
var dgTagRating_AddingRatingsToPersonalize$1 = "Adding ratings to skills on your profile to help personalize your experience.";
var dgTagRating_AddManagerTarget$1 = "Add Manager Rating";
var dgTagRating_AddRating$1 = "Add Rating";
var dgTagRating_AddRatingError$1 = "Sorry! There was a problem adding the rating.";
var dgTagRating_AddSelfAssessment$1 = "Add Self Rating";
var dgTagRating_AddSelfRating$1 = "Add self rating";
var dgTagRating_AddSelfRatingDetail$1 = "Rate yourself.";
var dgTagRating_AddSkillLevel$1 = "+ Add Expertise Level";
var dgTagRating_AddSkills$1 = "Add Skills";
var dgTagRating_AddSkillTarget$1 = "Add Skill Target";
var dgTagRating_AddToMySkills$1 = 'Add "{{tagName}}" to my skills';
var dgTagRating_AddToProfile$1 = "Add to Profile";
var dgTagRating_AddToProfileTooltip$1 = "Add to profile";
var dgTagRating_Advanced$1 = "Advanced";
var dgTagRating_AssessmentScore$1 = "Assessment Score";
var dgTagRating_Autonomy$1 = "Autonomy";
var dgTagRating_Autonomy_Desc_Scale6_1$1 = "You work best within a structured environment with supervision and predetermined processes to solve basic problems.";
var dgTagRating_Autonomy_Desc_Scale6_2$1 = "You can complete tasks on your own, but when a complex issue arises, you'll likely need some help. You know enough about your skills to know the difference between good work and great work.";
var dgTagRating_Autonomy_Desc_Scale6_3$1 = "You can work independently on new challenges. You've become good at setting your own goals to measure progress, and you're able to look at your work and accurately evaluate whether it was successful.";
var dgTagRating_Autonomy_Desc_Scale6_4$1 = "You can work independently on complex projects, and you can lead an initiative and see it through to the end with little to no supervision. You can plan the process you'll use, apply that plan, and evaluate its effectiveness - though you still value external feedback on your work.";
var dgTagRating_Autonomy_Desc_Scale6_5$1 = "You're likely trusted when it comes to your domain, and others may come to you with ideas, situations or problems to seek your insight. You're likely good at communicating problems and potential solutions.";
var dgTagRating_Autonomy_Desc_Scale6_6$1 = "You can work well independently on very complex projects, and you innovate to help the field advance. You’re likely to have successfully led teams that work on big initiatives pushing the boundaries of your field. You're completely autonomous, and you're recommended as a domain leader and scholar.";
var dgTagRating_Autonomy_Desc_Scale8_1$1 = "You work best within a structured environment with supervision, predetermined processes, and set criteria to judge output against.";
var dgTagRating_Autonomy_Desc_Scale8_2$1 = "You can solve basic problems and complete tasks on your own—but when a complex issue arises, you’ll likely need some help.";
var dgTagRating_Autonomy_Desc_Scale8_3$1 = "For the most part, you can work independently on new challenges. You know enough about your skills to be self-critical, and know the difference between good work and great work. You’ve also become good at setting your own goals to measure progress.";
var dgTagRating_Autonomy_Desc_Scale8_4$1 = "You can work independently on complex projects. When those projects are complete, you’re able to look at your work and accurately evaluate whether it was successful. While supervision isn’t necessary, you value external input and feedback on your work.";
var dgTagRating_Autonomy_Desc_Scale8_5$1 = "You can operate as a one-person show, which means you’re autonomous. You can lead an initiative and see it through to the end with little to no supervision. You can plan the process you’ll use, apply that plan, and evaluate the effectiveness of it while considering alternatives and the potential outcomes.\r\nYou’re likely trusted when it comes to your domain. Others may come to you with ideas, situations, or problems and ask for your insight or potential solutions.";
var dgTagRating_Autonomy_Desc_Scale8_6$1 = "You can work well independently on very complex projects. You’ve applied your unique viewpoint to solve complicated issues, and you innovate to help the field advance. You’re likely good at communicating problems and potential solutions, and can lead teams of practitioners.";
var dgTagRating_Autonomy_Desc_Scale8_7$1 = "You’ve likely successfully led teams as they work on big initiatives that push the boundaries of your field. And you can do it all—whether you’re still a practitioner or you spend the bulk of your time leading others, your judgment is well-respected from those within your domain.";
var dgTagRating_Autonomy_Desc_Scale8_8$1 = "You are completely autonomous, and you are regarded as a domain leader and scholar. You have your choice of projects, and you likely select those that will allow you to create significant impact in the field and offer new ideas or practices.";
var dgTagRating_AverageLevel$1 = "Average Level {{Level}}";
var dgTagRating_Beginner$1 = "Beginner";
var dgTagRating_CancelEval$1 = "Cancel Skill Review";
var dgTagRating_CancelMgrRatingRequest$1 = "Cancel Manager Rating Request";
var dgTagRating_CancelPeerRequests$1 = "Cancel Pending Peer Rating Requests";
var dgTagRating_CancelPeerRequestsDesc$1 = "If anyone in your list has a pending Peer Rating request from you for this skill, select this to cancel that request and send a new one.";
var dgTagRating_CancelRequest$1 = "Cancel Request";
var dgTagRating_Capable$1 = "Capable";
var dgTagRating_CertVisibility$1 = "Public or private";
var dgTagRating_ChangeManagerRating$1 = "Change manager rating";
var dgTagRating_ChangePeerRating$1 = "Change peer rating";
var dgTagRating_ChangeSkillTarget$1 = "Change skill target";
var dgTagRating_Checkpoint$1 = "Checkpoint";
var dgTagRating_Checkpoints$1 = "Checkpoints";
var dgTagRating_ClearCurrentRating$1 = "Clear current rating";
var dgTagRating_ClearCurrentTarget$1 = "Clear current target";
var dgTagRating_CommentPlaceholderFormat$1 = "Give {{name}} more information about this rating...";
var dgTagRating_Comments$1 = "Comments";
var dgTagRating_commentVisible$1 = "Your rating and comment might be visible to others. {{linkStart}}Learn more{{linkEnd}}";
var dgTagRating_CompleteCheckpoints$1 = "Complete a skill checkpoint in Degreed";
var dgTagRating_ContinueEvaluation$1 = "Continue Skill Review";
var dgTagRating_ContinueProcess$1 = "Continue Process";
var dgTagRating_Credential$1 = "Skill Certification";
var dgTagRating_Critical_RemoveFromProfileConfirmation$1 = "Your organization thinks {{skill}} is an important skill for your role, are your sure you want to remove this skill?";
var dgTagRating_CurrentManagerRating$1 = "Current manager rating";
var dgTagRating_CurrentPeerRating$1 = "Current peer rating";
var dgTagRating_CurrentSkillTarget$1 = "Current skill target";
var dgTagRating_DeactivatedUser$1 = "Deactivated User";
var dgTagRating_DegreedCertification$1 = "Degreed Certification";
var dgTagRating_DegreedCertified$1 = "Degreed Certified";
var dgTagRating_DescribeRatingSelected$1 = "Describe why you selected this rating level";
var dgTagRating_descriptionPlaceholderManagerRating$1 = "Briefly describe why you gave this manager rating";
var dgTagRating_descriptionPlaceholderPeerRating$1 = "Briefly describe why you gave this peer rating";
var dgTagRating_descriptionPlaceholderSkillTarget$1 = "Briefly describe why you gave this skill target";
var dgTagRating_Distinguished$1 = "Distinguished";
var dgTagRating_DoneRating$1 = "Done Rating";
var dgTagRating_EditExpertise$1 = "Edit Rating";
var dgTagRating_EditExpertiseLabel$1 = "{{skillTitle}} Edit Rating";
var dgTagRating_Effective$1 = "Effective";
var dgTagRating_EndorsedByFormat$1 = "Endorsed by {{name}}";
var dgTagRating_Evaluation$1 = "Skill Review";
var dgTagRating_EvalVisibility$1 = "Public or private";
var dgTagRating_Experienced$1 = "Experienced";
var dgTagRating_Expert$1 = "Expert";
var dgTagRating_FocusSkillAdded$1 = "{{skill}} was added as a focus skill to your profile";
var dgTagRating_FoundIntegrationSkillsProfileDetails$1 = "We found skills with {{providerName}} assessments that are not on your profile. Select the skills you want to add and we’ll add your assessment results to them.";
var dgTagRating_GetCertificate$1 = "Get an official certificate. A scientifically-backed process that’s reviewed by our expertise panel.";
var dgTagRating_Industry$1 = "Industry";
var dgTagRating_Industry_Desc_Scale6_1$1 = "You're new to the industry and gaining familiarity with history, best practices, and challenges.";
var dgTagRating_Industry_Desc_Scale6_2$1 = "Your knowledge of trends and technology is growing, and you're becoming familiar with the work of influencers and innovators who lead your industry. You may benefit from high-level guidance on theories and best practices.";
var dgTagRating_Industry_Desc_Scale6_3$1 = "You're aware of trends and how they affect your industry. You're also starting to evaluate what others in the industry are doing, and you're able to identify how effective their solutions are.";
var dgTagRating_Industry_Desc_Scale6_4$1 = "You're aware of the latest developments in the field, and you can clearly see where your industry is heading in the next few years. You can likely explain theories and solutions to others effectively.";
var dgTagRating_Industry_Desc_Scale6_5$1 = "You have a thorough understanding of the industry, and you've become experienced at making high-level judgments. You can see how your work interacts with and affects other fields.";
var dgTagRating_Industry_Desc_Scale6_6$1 = "You're taking the lead in your field, and many in the industry look to you for guidance. The work you do is often referred to as groundbreaking within the industry, and you have the ability to invent the tools to solve the biggest problems your field has to offer.";
var dgTagRating_Industry_Desc_Scale8_1$1 = "You’re new to the industry and just getting to know its history, best practices, and challenges.";
var dgTagRating_Industry_Desc_Scale8_2$1 = "Your familiarity with industry best practices and terminology is growing, as is your knowledge of trends and technology.";
var dgTagRating_Industry_Desc_Scale8_3$1 = "You may benefit by referring to some high-level guidance on theories and best practices when you apply your skill. You’re becoming familiar with the work of the influencers and innovators who lead your industry.";
var dgTagRating_Industry_Desc_Scale8_4$1 = "You’re aware of trends and can evaluate how they affect your industry. You’re also starting to evaluate what others within the industry are doing, and are able to identify how effective their solutions are.";
var dgTagRating_Industry_Desc_Scale8_5$1 = "You’re aware of the latest developments in your field and can likely effectively explain theories and solutions to others.";
var dgTagRating_Industry_Desc_Scale8_6$1 = "You know the industry like the back of your hand. You can clearly see where your industry is headed in the next few years, and how your work interacts with and affects other fields.";
var dgTagRating_Industry_Desc_Scale8_7$1 = "Within your industry, you’ve likely become experienced at making high-level judgments. Because you’re taking the lead in your field, it’s likely that many in the industry look to you for guidance on challenges, specialties, and latest developments, as well as insight into what the future will hold.";
var dgTagRating_Industry_Desc_Scale8_8$1 = "You have much to offer the industry in terms of leadership. The work you do is often referred to as groundbreaking by those familiar with the industry. Your work is likely highly influential to your field, and you have the ability to invent the tools to solve the biggest problems the field has to offer. This puts you in a position of being a leader, guide, and mentor.";
var dgTagRating_InProgress$1 = "In progress";
var dgTagRating_Intermediate$1 = "Intermediate";
var dgTagRating_InvalidRequest$1 = "Sorry, this request is no longer valid.";
var dgTagRating_Knowledge$1 = "Knowledge";
var dgTagRating_Knowledge_Desc_Scale6_1$1 = "You have fundamental knowledge about some aspects of the skill domain.";
var dgTagRating_Knowledge_Desc_Scale6_2$1 = "You've gained a working knowledge of both the fundamentals and theory of your skill domain.";
var dgTagRating_Knowledge_Desc_Scale6_3$1 = "Technical and theoretical knowledge have deepened, and you understand how theories and applications of those theories fit into situations.";
var dgTagRating_Knowledge_Desc_Scale6_4$1 = "You have robust, specialized knowledge about your skills. You have grasped the scope and limitations of your field, and you can apply your knowledge of theory, tools, methodology, and processes to a wide range of problems.";
var dgTagRating_Knowledge_Desc_Scale6_5$1 = "You've mastered the theory and application of your skill domain, and you can apply tools, methodology, and process successfully to complex problems in a range of scenarios. You develop solutions that others will often use or imitate.";
var dgTagRating_Knowledge_Desc_Scale6_6$1 = "You can apply advanced specialized knowledge, research methods, and approaches to all sorts of scenarios, including cutting-edge problems. You invent new solutions, develop new findings, and expand the existing body of knowledge, and you have a grasp on possible future directions for their field as well as their impacts.";
var dgTagRating_Knowledge_Desc_Scale8_1$1 = "You have general knowledge about some aspects of the skill.";
var dgTagRating_Knowledge_Desc_Scale8_2$1 = "You’ve gained a working, fundamental knowledge of your skill domain. While you know there’s still plenty left to learn, you’ve got the basics down.";
var dgTagRating_Knowledge_Desc_Scale8_3$1 = "You’ve extended your knowledge beyond the fundamentals into the theory of your skill domain.";
var dgTagRating_Knowledge_Desc_Scale8_4$1 = "Technical knowledge of your skill has deepened, as well as your theoretical knowledge and strategy.";
var dgTagRating_Knowledge_Desc_Scale8_5$1 = "You have robust, specialized knowledge about your skill. You understand how theories and applications of those theories fit into situations, and you have grasped the scope and limitations of the field.";
var dgTagRating_Knowledge_Desc_Scale8_6$1 = "You’ve mastered the knowledge, theory, tools, methodology, and processes of your skill domain. Not only can you apply them successfully to pretty much any problem—large or small, simple or complex—you can also clearly communicate these concepts to others.";
var dgTagRating_Knowledge_Desc_Scale8_7$1 = "You have in-depth knowledge of the current theories (including their limits), and you apply advanced specialized knowledge, research methods, and approaches in all sorts of scenarios. You think about problems in a highly complex way and develop solutions that others will often use or imitate. You also have knowledge of adjoining areas of expertise and how they relate to your field.";
var dgTagRating_Knowledge_Desc_Scale8_8$1 = "As a Level 8, your knowledge and unique vision of the field are highly sought-after. You have a grasp on what the future of your domain will hold and how it might affect people, tools, technology, processes, and the world as a whole. This requires a capacity for a wide range of strategic and scientific thinking, coupled with creative action. Chances are, you’re leading the field as a scholar, influencer, or published researcher.\r\nYou look at solving problems differently, invent new solutions, develop new findings, and expand the existing body of knowledge, including specialized knowledge involving other areas, skills, and disciplines.";
var dgTagRating_LastRated$1 = "Last Rated";
var dgTagRating_Level$1 = "Level {{Level}}";
var dgTagRating_LevelDescription$1 = "Level Description";
var dgTagRating_Levels$1 = "Skill Levels";
var dgTagRating_LevelUp$1 = "Level Up";
var dgTagRating_LevelUp_Desc_Scale6_1$1 = "<ul>\r\n<li>Absorb as much information as you can. It’s important for you to take advantage of your ability to learn and grow to move up to the next levels and master the domain.</li>\r\n<li>Pay attention. Learn from the influential voices in your space: blogs, webinars, e-newsletters, TED talks, and everything else.</li>\r\n<li>Learn from the various forms of content available: videos, books, courses, podcasts, etc.</li>\r\n<li>Seek other experts of all skill levels who are familiar with the field to help guide you in the right direction as you get started.</li>\r\n</ul>";
var dgTagRating_LevelUp_Desc_Scale6_2$1 = "<ul>\r\n<li>Continue learning and working to build your skills in different scenarios so you can apply your knowledge to more complex problems and situations.</li>\r\n<li>Seek interaction with those in your domain to see how they approach tasks, situations, and issues they encounter. Physical meet-ups, Facebook groups, Twitter chats, and online forums are all a great place to start.</li>\r\n<li>Seek out leaders in your space and observe how they solve problems. Follow the latest trends and technology and continue to apply these findings to your skill set.</li>\r\n</ul>";
var dgTagRating_LevelUp_Desc_Scale6_3$1 = "<ul>\r\n<li>Practice, practice, practice. Seek out different types of tasks and use them to gain varied experiences. This will give you opportunities to apply some of your foundational knowledge and push the limits of your abilities.</li>\r\n<li>Work on refining how you communicate and discuss high-level theories as they relate to projects.</li>\r\n<li>Pay attention to technologies and new practices. Try to envision how they may affect your domain.</li>\r\n</ul>";
var dgTagRating_LevelUp_Desc_Scale6_4$1 = "<ul>\r\n<li>Beginners may look to you to help them learn the basics. Be open to offering feedback and mentorship.</li>\r\n<li>Try to increase the diversity of your theoretical knowledge by applying different viewpoints to problems or challenges you come across in your work.</li>\r\n<li>Take it upon yourself to test new technologies, ideas, and solutions to see how effective they are in application.</li>\r\n</ul>";
var dgTagRating_LevelUp_Desc_Scale6_5$1 = "<ul>\r\n<li>Look for opportunities to lead a team or provide mentorship.</li>\r\n<li>Look for opportunities to share your knowledge and experience with a broader audience, whether that’s through conferences, webinars, online communities, or classrooms.</li>\r\n<li>Don’t continue to solve the same problems in the same ways. Continue to push the boundaries of your own knowledge and skills through innovative applications that allow you to flex in new ways.</li>\r\n</ul>";
var dgTagRating_LevelUp_Desc_Scale6_6$1 = "<ul>\r\n<li>Share your findings with others to push the industry forward and encourage innovation.</li>\r\n<li>Be a creator of the tools and trends that shape the industry.</li>\r\n<li>Apply knowledge, theory, and practices from other areas of expertise to create new solutions.</li>\r\n<li>Use your knowledge to push your industry, and those related, forward. It’s time to use your skill to invent the theories, processes, tech, and tools that will solve the greatest challenges in your domain.</li>\r\n</ul>";
var dgTagRating_LevelUp_Desc_Scale8_1$1 = "<ul>\r\n<li>Soak in as much information as you can. It’s important for you to take advantage of your ability to learn and grow to move up to the next levels and master the domain.</li>\r\n<li>Pay attention. Learn from the influential voices in your space: blogs, webinars, e-newsletters, TED talks, and everything else.</li>\r\n<li>Learn from the various forms of content available: videos, books, courses, podcasts, etc.</li>\r\n<li>Seek other experts of all skill levels who are familiar with the field to help guide you in the right direction as you get started.</li>\r\n</ul>";
var dgTagRating_LevelUp_Desc_Scale8_2$1 = "<ul>\r\n<li>Continue learning and working to build your skills in different scenarios so you can apply your knowledge to more complex problems and situations.</li>\r\n<li>Pay attention. Learn from the influential voices in your space: blogs, webinars, e-newsletters, TED talks, and everything else.</li>\r\n<li>Learn from the various forms of content available: videos, books, courses, podcasts, etc.</li>\r\n<li>Seek interaction with those in your domain to see how they approach tasks, situations, and issues they encounter. Physical meet-ups, Facebook groups, Twitter chats, and online forums are all a great place to start.</li>\r\n</ul>";
var dgTagRating_LevelUp_Desc_Scale8_3$1 = "<ul>\r\n<li>Practice, practice, practice. Seek out different types of tasks and use them to gain varied experiences. This will give you opportunities to apply some of your foundational knowledge and push the limits of your abilities.</li>\r\n<li>Seek out leaders in your space and observe how they solve problems. Follow the latest trends and technology and continue to apply these findings to your skill set.</li>\r\n</ul>";
var dgTagRating_LevelUp_Desc_Scale8_4$1 = "<ul>\r\n<li>Beginners are likely looking to you to help them learn the basics. Be open to offering feedback and mentorship.</li>\r\n<li>Work on refining how you communicate and discuss high-level theories as they relate to projects.</li>\r\n<li>Try to increase the diversity of your theoretical knowledge by applying different viewpoints to problems or challenges you come across in your work.</li>\r\n<li>Pay attention to technologies and new practices. Try to envision how they may affect your domain.</li>\r\n</ul>";
var dgTagRating_LevelUp_Desc_Scale8_5$1 = "<ul>\r\n<li>Take it upon yourself to test new technologies, ideas, and solutions to see how effective they are in application.</li>\r\n<li>Look for opportunities to lead a team or provide mentorship.</li>\r\n<li>Seek out and tackle higher complexity tasks beyond your comfort zone, and use guidance from those you trust as you run into road blocks.</li>\r\n</ul>";
var dgTagRating_LevelUp_Desc_Scale8_6$1 = "<ul>\r\n<li>Look for opportunities to share your knowledge and experience with a broader audience, whether that’s through conferences, webinars, online communities, or classrooms.</li>\r\n<li>Don’t continue to solve the same problems in the same ways. Continue to push the boundaries of your own knowledge and skills through innovative applications that allow you to flex in new ways.</li>\r\n</ul>";
var dgTagRating_LevelUp_Desc_Scale8_7$1 = "<ul>\r\n<li>Take on some of the industry’s biggest challenges. Think big.</li>\r\n<li>Share your findings with others to push the industry forward and encourage innovation.</li>\r\n<li>Be a creator of the tools and trends that shape the industry.</li>\r\n<li>Apply knowledge, theory, and practices from other areas of expertise to create new solutions.</li>\r\n<li>Seek out opportunities for research.</li>\r\n</ul>";
var dgTagRating_LevelUp_Desc_Scale8_8$1 = "<ul>\r\n<li>Even as a Level 8, there’s always more to learn. Continue to push yourself.</li>\r\n<li>As a Level 8, it’s crucial to use your knowledge to push your industry, and those related, forward. It’s time to use your skill to invent the theories, processes, tech, and tools that will solve the greatest challenges in your domain.</li>\r\n<li>Expose yourself to and communicate with other masters, and work together when possible for the development of the field as a whole.</li>\r\n<li>Consider the most effective ways for you to mentor, teach, and share your knowledge.</li>\r\n</ul>";
var dgTagRating_LinkedSkillsNumber$1 = "{{amount}} Linked Skills";
var dgTagRating_ManagerAssessment$1 = "Manager Rating";
var dgTagRating_ManagerRating$1 = "Manager rating";
var dgTagRating_ManagerRatinginProgress$1 = "Manager Rating in progress";
var dgTagRating_Master$1 = "Master";
var dgTagRating_MeasureYourSkill$1 = "Measure your skill with a scientifically-backed questionnaire.";
var dgTagRating_MngrRatingRequestCancelled$1 = "Manager Rating request canceled successfully.";
var dgTagRating_ModalButtonAddWithoutRating$1 = "Add without rating";
var dgTagRating_ModalButtonAddWithRating$1 = "Add with rating";
var dgTagRating_MyRatings$1 = "My Ratings";
var dgTagRating_NewManagerRating$1 = "New manager rating";
var dgTagRating_NewPeerRating$1 = "New peer rating";
var dgTagRating_NewSkillTarget$1 = "New skill target";
var dgTagRating_NoRatings$1 = "No evidence of skill at this time";
var dgTagRating_NoSkillTarget$1 = "No Skill Target";
var dgTagRating_NoTargetLevelAssigned$1 = "Set Target Level";
var dgTagRating_NumberOfRatings$1 = "{{ numberOfRatings }} Ratings";
var dgTagRating_OtherRatings$1 = "Other Ratings";
var dgTagRating_PeerRating$1 = "Peer Rating";
var dgTagRating_PeerRatingRequestCancelled$1 = "Peer Rating request canceled successfully.";
var dgTagRating_PeerRatings$1 = "Peer Ratings";
var dgTagRating_PeerRatingsTitle$1 = "Peer Ratings";
var dgTagRating_PeerRequestCountWarning$1 = "You are about to send a Peer Rating request to more than {{count}} people.";
var dgTagRating_PendingSelfRatingRequest$1 = "Pending Self Rating Request";
var dgTagRating_PrivacyPopoverDesc$1 = "Choose who can see your {{ratingType}} Level.";
var dgTagRating_PrivacyPopoverTitle$1 = "{{ratingType}} Level";
var dgTagRating_PrivateToYou$1 = "Private to you";
var dgTagRating_ProviderLogo$1 = "{{ProviderName}} logo";
var dgTagRating_ProviderSkillLabel$1 = "{{ProviderName}} skill rating";
var dgTagRating_RatedByFormat$1 = "Rated by {{manager}}";
var dgTagRating_RateNewSkills$1 = "Rate new skills";
var dgTagRating_RateSkills$1 = "Rate skills";
var dgTagRating_Rating$1 = "Rating";
var dgTagRating_RatingInProgress$1 = "You have a rating in progress";
var dgTagRating_RatingNotValid$1 = "This rating is no longer valid.";
var dgTagRating_RatingNotValidNewRating$1 = "This rating is invalid because you asked for a new rating.";
var dgTagRating_RatingOtherTitleFormat$1 = 'Give {{name}} a {{ratingType}} for "{{tagName}}"';
var dgTagRating_RatingPendingFormat$1 = "Request pending to {{manager}}";
var dgTagRating_RatingRequestCancelled$1 = "The rating request was cancelled successfully";
var dgTagRating_RatingRequested$1 = "The rating you requested is pending.";
var dgTagRating_RatingRequestedAge$1 = "Requested {{ RequestedAge }}";
var dgTagRating_RatingsRequested$1 = "The ratings you requested are pending.";
var dgTagRating_RatingTitleFormat$1 = 'Rate your expertise in "{{tagName}}"';
var dgTagRating_RatingType$1 = "Rating Type";
var dgTagRating_RecommendSkill$1 = "Recommend this Skill";
var dgTagRating_RemoveA11y$1 = "Remove the skill from your profile";
var dgTagRating_RemoveA11ySkill$1 = "Remove {{skillName}} from your profile";
var dgTagRating_RemoveFocusSkill$1 = "Remove Focus Skill";
var dgTagRating_RemoveFocusSkillItem$1 = "Remove {{title}} as focus skill";
var dgTagRating_RemoveFromPlan$1 = "Remove from Plan";
var dgTagRating_RemoveFromPlanA11y$1 = "Remove the skill from this plan";
var dgTagRating_RemoveFromProfile$1 = "Remove from Profile";
var dgTagRating_RemoveFromProfileConfirmation$1 = "Are you sure you want to remove the skill {{skill}} from your profile?";
var dgTagRating_RemoveFromProfileTooltip$1 = "Remove from profile";
var dgTagRating_RequestedRatings$1 = "The {{ RequestedCount }} ratings you requested are pending.";
var dgTagRating_RequestManagerAssessment$1 = "Request Manager Rating";
var dgTagRating_RequestManagerRating$1 = "Request manager rating";
var dgTagRating_RequestManagerRatingInstruction$1 = "Ask your manager to rate your skill.";
var dgTagRating_RequestNewRating$1 = "Request New Rating";
var dgTagRating_RequestNotValid$1 = "This rating request is no longer valid.";
var dgTagRating_RequestPeerRating$1 = "Request Peer Rating";
var dgTagRating_RequestPeerRatingInstruction$1 = "Ask anyone to rate you.";
var dgTagRating_RequestRating$1 = "Request Rating";
var dgTagRating_RequestSelfNotificationFormat$1 = "{{name}} requested you to rate yourself in the skill {{skill}}";
var dgTagRating_RequestSelfRatingForFormat$1 = "Request Self Rating for {{skill}}";
var dgTagRating_RequestsPending$1 = "Requests pending";
var dgTagRating_RestartEval$1 = "Start New Skill Review";
var dgTagRating_ReviewSkillsNewRatings$1 = "Review the skills on your profile to ensure the new ratings are accurate.";
var dgTagRating_saveNewRating$1 = "Save new rating";
var dgTagRating_saveNewTarget$1 = "Save new target";
var dgTagRating_SearchCollection$1 = "Search Collection";
var dgTagRating_SelectManager$1 = "Select your current manager";
var dgTagRating_SelectRating$1 = "Select skill rating";
var dgTagRating_SelfAssessment$1 = "Self Rating";
var dgTagRating_SelfAssessmentItem$1 = "Self rating for {{title}}";
var dgTagRating_SelfRatingRequestCancelled$1 = "Self Rating request canceled successfully.";
var dgTagRating_SelfRatingRequested$1 = "Your manager requests you rate yourself on this skill.";
var dgTagRating_SelfRatingUpdated$1 = "Self-rating for {{skill}} skill is updated";
var dgTagRating_ShareTag$1 = "Share Skill";
var dgTagRating_SignalCountPlural$1 = "+{{count}} more ratings";
var dgTagRating_SignalCountSingle$1 = "+{{count}} more rating";
var dgTagRating_SkillCertification$1 = "Skill Certification";
var dgTagRating_SkillCertInProgress$1 = "Skill Certification in progress";
var dgTagRating_SkillReviewInProgress$1 = "Skill Review in progress";
var dgTagRating_StartCredential$1 = "Get Degreed Certified";
var dgTagRating_StartEvaluation$1 = "Start Skill Review";
var dgTagRating_SubmitNext$1 = "Submit & Next";
var dgTagRating_SuccessfullyAddedSkills$1 = "You successfully added {{skillNumber}} new skills!";
var dgTagRating_SummaryLevel1$1 = "Can complete narrow and limited tasks requiring basic skills with direct supervision or guidance.";
var dgTagRating_SummaryLevel2$1 = "Can complete routine technical tasks requiring basic skills with general supervision or guidance.";
var dgTagRating_SummaryLevel3$1 = "Can process less structured but well-defined technical tasks, even if they are not routine, with occasional general supervision or guidance.";
var dgTagRating_SummaryLevel4$1 = "Can complete some specialized and complex tasks. Can use knowledge of theory and practical experience to choose principles and processes. May or may not have overall supervision. No direct guidance needed for these tasks.";
var dgTagRating_SummaryLevel5$1 = "Can complete many broad, complex tasks. Can use knowledge of theory and practical experience to choose principles and processes for technical tasks without supervision or guidance.";
var dgTagRating_SummaryLevel6$1 = "Master of completing broad, complex tasks in several subspecialties of the skill. Can use knowledge of theory and practical experience in all of those subspecialties.";
var dgTagRating_SummaryLevel7$1 = "Can complete new and complex tasks, including choosing the best processes for particular situations. Can use advanced specialized knowledge or processes.";
var dgTagRating_SummaryLevel8$1 = "Can develop innovative new solutions or research using a wide range of scientific and creative strategies.";
var dgTagRating_SummaryScale6_Level1$1 = "You have some knowledge about this skill and are starting to learn the tools and processes associated to it. With direct supervision or guidance, you can carry out basic tasks.";
var dgTagRating_SummaryScale6_Level2$1 = "You have a working knowledge of the core principles and practices of this skill, as well as some limited technical concepts. Under general supervision, you can complete a range of basic tasks using relevant methods.";
var dgTagRating_SummaryScale6_Level3$1 = "With your technical and theoretical knowledge of this skill, and under general supervision, you can work independently on challenges and provide solutions to predictable, well-defined problems.";
var dgTagRating_SummaryScale6_Level4$1 = "You have comprehensive theoretical, technical, and sometimes specialized knowledge that you use to solve difficult problems and complete complex tasks. You can lead an initiative and see it through to the end.";
var dgTagRating_SummaryScale6_Level5$1 = "You’ve mastered the knowledge, theories, tools, methodologies, and processes of your Skill domain. With your understanding and integration of these core theories and practices, you can process, complete, and communicate specialized and/or complex tasks and problems.";
var dgTagRating_SummaryScale6_Level6$1 = "As an innovator whose work is highlighted amongst your industry’s best, you demonstrate comprehensive, specialized knowledge as you analyze, solve, and complete new and complex tasks and problems. Your solutions and procedures in highly complex situations sets you apart as a leader in your field. You not only have an extended knowledge of adjoining skillsets, but you also have a grasp on what the future of your domain will hold and how it might affect people, tools, technology, processes, and the world as a whole.";
var dgTagRating_SummaryScale8_Level1$1 = "You have general knowledge about some aspects of the Skill. You are beginning to learn the tools associated with your Skill and how to use them to complete simple, routine tasks. Your best work is in a structured environment with supervision, predetermined processes, and established criteria to judge output against.";
var dgTagRating_SummaryScale8_Level2$1 = "You have gained a working, fundamental knowledge of your skill. While you know there’s still plenty of information left to learn, you understand the basics. You can solve basic problems and complete tasks on your own but when a complex issue arises you most likely need some help.";
var dgTagRating_SummaryScale8_Level3$1 = "You have extended your knowledge beyond the fundamentals and into the theory of your Skill domain. You are comfortable using the tools of the trade as you continue to develop your technical Skills. You can work independently on new challenges, know enough to be self-critical, and know the difference between good and great work. You are also good at setting goals and measuring progress.";
var dgTagRating_SummaryScale8_Level4$1 = "You are a skilled practitioner that uses a broad range of methods to solve problems: From planning to execution. You can tackle specialized tasks and apply your Skills to complex problems that might require a new process or approach. You can work independently on complex projects, and when those projects are complete, you are able to look at your work and accurately evaluate whether it was successful or unsuccessful.";
var dgTagRating_SummaryScale8_Level5$1 = "You have robust and specialized knowledge about your Skill. You have a proven track record of success and bring a wide range of cognitive and practical Skills to the table to solve new and complex problems. You can lead an initiative and see it through to the end.";
var dgTagRating_SummaryScale8_Level6$1 = "You have mastered the knowledge, theory, tools, methodology, and processes of your Skill domain. Not only can you apply them successfully to pretty much any problem—large or small, simple or complex—you can also clearly communicate these concepts to others.";
var dgTagRating_SummaryScale8_Level7$1 = "You are an innovator and your work is highlighted as your industry's best. You use tools in such a complex and experimental way that others look to you for best practices. You are the one setting the trends that others will follow. You also likely have one or two areas of expertise that are highly specialized or advanced.";
var dgTagRating_SummaryScale8_Level8$1 = "Your knowledge and unique vision of the field are highly sought after. You have a grasp on what the future of your domain will hold and how it might affect people, tools, technology, processes, and the world as a whole. You are recognized as a world-class leader in your field. You are also developing new standards, practices, and innovating beyond the majority of your peers.";
var dgTagRating_TakeCheckpoint$1 = "Take Checkpoint";
var dgTagRating_TargetCommentPlaceholderFormat$1 = "Give {{name}} more information about this target...";
var dgTagRating_TargetLevel$1 = "Target Level";
var dgTagRating_TargetRatingUpdated$1 = "Target for {{skill}} skill is updated";
var dgTagRating_TasksTools$1 = "Tasks and Tools";
var dgTagRating_TasksTools_Desc_Scale6_1$1 = "You're learning industry-standard tools and processes for your skill and how to use them to complete simple, routine tasks.";
var dgTagRating_TasksTools_Desc_Scale6_2$1 = "You're becoming comfortable with industry-standard tools and processes and are starting to apply them to less-structured tasks. You're also starting to understand how to evaluate the quality of your own work.";
var dgTagRating_TasksTools_Desc_Scale6_3$1 = "You're effective in working with less-structured tasks, and you use a broad range of methods to solve problems from planning to execution. You're comfortable using the tools of the trade - including some specialized ones - and continue to develop your technical skills.";
var dgTagRating_TasksTools_Desc_Scale6_4$1 = "You're a skilled practitioner with a proven track record of success; you bring a wide range of cognitive or practical skills to the table to solve complex problems. You can plan processes and easily identify the tools you'll use.";
var dgTagRating_TasksTools_Desc_Scale6_5$1 = "You use a comprehensive application of tools, methods, and processes to successfully complete new and complex tasks, and you innovate the application of new technologies by applying them and evaluating their effectiveness.";
var dgTagRating_TasksTools_Desc_Scale6_6$1 = "You're a master of your skill; you use tools in complex and experimental ways such that others look to you for best practices. You conduct research to develop and release new tools, processes, and technologies for use in your domain. Your work developing new standards and practices leads to recognition as a leader in your field.";
var dgTagRating_TasksTools_Desc_Scale8_1$1 = "You’re just beginning to learn the tools associated with your skill and how to use them to complete simple, routine tasks.";
var dgTagRating_TasksTools_Desc_Scale8_2$1 = "You’re becoming familiar with industry-standard tools and processes, and you understand how to apply them to routine tasks. You’re also starting to understand how to evaluate the quality of your own work outside of set criteria.";
var dgTagRating_TasksTools_Desc_Scale8_3$1 = "You’re effective in working with less-structured tasks, and can solve complex problems using theoretical knowledge. You’re comfortable using the tools of the trade and continue to develop your technical skills.";
var dgTagRating_TasksTools_Desc_Scale8_4$1 = "As a skilled practitioner, you use a broad range of methods to solve problems from planning to execution. You can tackle more specialized tasks and apply your skills to complex problems that might require a new process or approach.";
var dgTagRating_TasksTools_Desc_Scale8_5$1 = "You have a proven track record of success and bring a wide range of cognitive or practical skills to the table to solve new and complex problems. You can plan processes and easily identify the tools you’ll use, apply a plan, and evaluate its effectiveness while considering alternative solutions and potential outcomes.";
var dgTagRating_TasksTools_Desc_Scale8_6$1 = "You use a comprehensive application of tools, methods, and processes to successfully complete the most complex of tasks. You innovate the application of new technologies by applying them early on and evaluating their effectiveness.";
var dgTagRating_TasksTools_Desc_Scale8_7$1 = "You’re an innovator to the core, and your work is likely highlighted as industry best or best in class. You use tools in such a complex and experimental way that others look to you for best practices—you’re the one setting the trends that others will follow. You also likely have one or two areas of expertise that are highly specialized or advanced.";
var dgTagRating_TasksTools_Desc_Scale8_8$1 = "Level 8s are creating groundbreaking work in their fields. You’re a master of your skill and a creator of what others are using. You use your research to allow you to develop and release new tools, processes, and technologies for use in your domain. You’ve taken your experiences and applied them towards innovation, whether in the form of inventing more effective tools or authoring new theories on your domain.\r\nYou are recognized as a world-class leader in your field and are likely developing new standards and practices, innovating beyond the majority of your peers.";
var dgTagRating_TotalRatings$1 = "Total Ratings";
var dgTagRating_Unrated$1 = "Unrated";
var dgTagRating_UnratedDescription$1 = "Rate yourself in this skill to track progress, identify any skill gaps or proficiencies and improve recommendations throughout the application.";
var dgTagRating_UnratedPeerRatingDescription$1 = "Rate {{ name }} in this skill to track progress, identify any skill gaps or proficiencies and improve recommendations throughout the application.";
var dgTagRating_UnratedSkillTargetDescription$1 = "Set a skill target in this skill to track progress, identify any skill gaps or proficiencies and improve recommendations throughout the application.";
var dgTagRating_UpdatedManagerRating$1 = "Updated manager rating";
var dgTagRating_UpdatedNewRating$1 = "Updated new rating";
var dgTagRating_UpdatedPeerRating$1 = "Updated peer rating";
var dgTagRating_UpdatedSkillTarget$1 = "Updated skill target";
var dgTagRating_UpdateRating$1 = "Update Rating";
var dgTagRating_ViewCertificate$1 = "View Certificate";
var dgTagRating_ViewCheckpoints$1 = "View Checkpoints";
var dgTagRating_ViewExternalRating$1 = "View on {{ProviderName}}";
var dgTagRating_ViewLevelBreakdown$1 = "See Level Breakdown";
var dgTagRating_ViewLevelDescription$1 = "View Level Description";
var dgTagRating_ViewNewRatingScale$1 = "View new rating scale";
var dgTagRating_ViewRating$1 = "View Rating";
var dgTagRating_ViewRatingLabel$1 = "{{skillTitle}} View Rating";
var dgTagRating_ViewRatings$1 = "View {{RatingCount}} Ratings";
var dgTagRating_ViewRatingScale$1 = "View Rating Scale";
var dgTagRating_ViewScoreBreakdown$1 = "See Score Breakdown";
var dgTagRating_ViewSkill$1 = "View Skill";
var dgTagRating_VisibleToOrg$1 = "Visible to organization";
var dgTagRating_VisibleToPublic$1 = "Visible to everyone";
var dgTagRating_VisibleToYou$1 = "Visible only to you";
var dgTagRating_YourCurrentRating$1 = "Your current rating";
var dgSocialConnectSuccess_TitleFormat$1 = "You have successfully connected your {{providerDisplayName}} account.";
var dgSocialConnectionJoined_TitleFormat$1 = "Your friend {{connectionName}} joined Degreed.";
var dgSkipNav_SkipMainNavigation$1 = "Skip Main Navigation";
var dgSkipNav_SkipSidebar$1 = "Skip Sidebar Navigation";
var dgSkipNav_SkipSubNavigation$1 = "Skip Sub-navigation";
var dgSkipNav_SkipToMainContent$1 = "Skip to main content";
var dgSkipNav_SkipToSearchResults$1 = "Skip to search results";
var dgSkillSignalRatings_PrivacyInfo$1 = "Private ratings are not shown";
var dgSkillSignal_BarChartSubheading$1 = "Top Skill Signals by Type";
var dgSkillSignal_OtherTypes$1 = "Other Types";
var dgSkillsCheckup_DoneRating$1 = "Done Rating";
var dgSkillsCheckup_message$1 = "It's time for your Skill Checkup! Update your skill ratings to reflect your progress.";
var dgSkillsCheckup_UpdateRatings$1 = "Update Ratings";
var dgReorder_A11yItemMovedFormat$1 = "Item {{a}} moved to position {{b}}";
var dgReorder_MoveNext$1 = "Move to Next";
var dgReorder_MovePrev$1 = "Move to Previous";
var dgReorder_NoTitleText$1 = "(No Title)";
var dgReorder_SaveChanges$1 = "Save Changes";
var dgRelatedInputs_Related$1 = "Related";
var dgRecommendationsStatus_ByHeader$1 = "By";
var dgRecommendationsStatus_Empty$1 = "No items have been shared";
var dgRecommendationsStatus_HeaderAssignedTo$1 = "For";
var dgRecommendationsStatus_HeaderCreatedDate$1 = "Created Date";
var dgRecommendationsStatus_HeaderDueDate$1 = "Due Date";
var dgRecommendationsStatus_HeaderPercentComplete$1 = "Complete";
var dgRecommendationsStatus_HeaderTitle$1 = "Name";
var dgRecommendationsOverview_About$1 = "People you follow can share their favorite articles, videos, books and other great resources with you.";
var dgRecommendationsOverview_AboutConsumer$1 = "People you follow can share their favorite articles, videos, books and other great resources with you";
var dgRecommendationsOverview_AlreadyCompletedAssignedByFormat$1 = "{{personName}} assigned {{groupName}} to {{contentAction}} this {{contentType}} {{hasDateHtml}}by {{date}}{{hasDateEndHtml}}, but you've already completed it. Great job, overachiever.";
var dgRecommendationsOverview_AlreadyCompletedAssignedYouFormat$1 = "{{personName}} assigned you to {{contentAction}} this {{contentType}} {{hasDateHtml}}by {{date}}{{hasDateEndHtml}}, but you've already completed it. Great job, overachiever.";
var dgRecommendationsOverview_AlreadyCompletedRecommendedByFormat$1 = "{{nameHtml}} shared this with {{groupNameHtml}}, but you've already completed it. Great job, overachiever.";
var dgRecommendationsOverview_AlreadyCompletedRecommendedYouFormat$1 = "{{nameHtml}} shared this with you, but you've already completed it. Great job, overachiever.";
var dgRecommendationsOverview_AssignedByFormat$1 = "{{personName}} assigned {{groupName}} this {{contentType}} to {{contentAction}} {{hasDateHtml}}by {{date}}{{hasDateEndHtml}}";
var dgRecommendationsOverview_AssignedYouFormat$1 = "{{personName}} assigned you this {{contentType}} to {{contentAction}} {{hasDateHtml}}by {{date}}{{hasDateEndHtml}}";
var dgRecommendationsOverview_Description$1 = "Items shared with you and groups you are in are collected here to be reviewed and completed.";
var dgRecommendationsOverview_EmptyStateDescription$1 = "Items shared with you will show here.";
var dgRecommendationsOverview_EmptyStateTitle$1 = "No Shared Items";
var dgRecommendationsOverview_EmptyTitle$1 = "Wait for it… Wait for it…";
var dgRecommendationsOverview_Filter$1 = "Filter for Shared";
var dgRecommendationsOverview_Incomplete$1 = "Incomplete";
var dgRecommendationsOverview_RecommendedByFormat$1 = "{{nameHtml}} shared this with {{groupNameHtml}}";
var dgRecommendationsOverview_RecommendedByFormerLearnerFormat$1 = "A former learner shared this with {{groupNameHtml}}";
var dgRecommendationsOverview_RecommendedByNoCreatorFormat$1 = "This {{contentType}} was shared with {{groupName}}.";
var dgRecommendationsOverview_RecommendedYouFormat$1 = "{{nameHtml}} shared this with you";
var dgRecommendationsOverview_RecommendedYouFormerLearnerFormat$1 = "A former learner shared this with you";
var dgRecommendationsOverview_RecommendedYouNoCreatorFormat$1 = "This {{contentType}} was shared with you.";
var dgRatingButtonMeta_1Hour$1 = "1 hour";
var dgRatingButtonMeta_HoursFormat$1 = "{{numHrs}} hours";
var dgProviderLicense_CreateLicenseBtnFormat$1 = "Create {{providerName}} license";
var dgProviderLicense_GenerateLicenseFormat$1 = "Generate License for {{providerName}}";
var dgProfileShareActivity_DateShared$1 = "Date Shared";
var dgProfileShareActivity_GroupsSharedWith$1 = "Groups I have shared this with";
var dgProfileShareActivity_NumCommentsPlural$1 = "{{title}} has {{count}} comments";
var dgProfileShareActivity_NumCommentsSingular$1 = "{{title}} has 1 comment";
var dgProfileShareActivity_NumGroupsSharedWithPlural$1 = "You have shared {{title}} with {{count}} groups";
var dgProfileShareActivity_NumGroupsSharedWithSingular$1 = "You have shared {{title}} with 1 group";
var dgProfileShareActivity_NumPeopleSharedWithPlural$1 = "You have shared {{title}} with {{count}} people";
var dgProfileShareActivity_NumPeopleSharedWithSingular$1 = "You have shared {{title}} with 1 person";
var dgProfileShareActivity_PeopleSharedWith$1 = "People I have shared this with";
var dgProfileShareActivity_ShareActivity$1 = "Share Activity";
var dgProfileOverview_AchievementReported$1 = "Achievement Reported";
var dgProfileOverview_AddAchievements$1 = "Add Achievements";
var dgProfileOverview_AddDescription$1 = "Add Description";
var dgProfileOverview_AddDevelopmentPlan$1 = "Create Plan";
var dgProfileOverview_AddExperiences$1 = "Add Experiences";
var dgProfileOverview_AdditionalSkills$1 = "Additional Skills";
var dgProfileOverview_AddLearning$1 = "Add Learning";
var dgProfileOverview_AddSkill$1 = "{{skillName}} skill added";
var dgProfileOverview_AddSkillOrTopic$1 = "Add Skill";
var dgProfileOverview_AwardReceivedDate$1 = "Date Received";
var dgProfileOverview_BuildProfileAchievementsComplete_Plural$1 = "{{achievementsCount}} Achievements";
var dgProfileOverview_BuildProfileAchievementsComplete_Single$1 = "{{achievementsCount}} Achievement";
var dgProfileOverview_BuildProfileAchievementsIncomplete$1 = "Add {{achievementsLimit}} Achievement";
var dgProfileOverview_BuildProfileExperiencesComplete_Plural$1 = "{{experiencesCount}} Experiences";
var dgProfileOverview_BuildProfileExperiencesComplete_Single$1 = "{{experiencesCount}} Experience";
var dgProfileOverview_BuildProfileExperiencesIncomplete$1 = "Add {{experiencesLimit}} Experience";
var dgProfileOverview_BuildProfileFocusSkillsComplete$1 = "{{focusSkillsCount}} Focus Skills";
var dgProfileOverview_BuildProfileFocusSkillsComplete_Plural$1 = "{{focusSkillsCount}} Focus Skills";
var dgProfileOverview_BuildProfileFocusSkillsIncomplete$1 = "Set {{focusSkillsLimit}} Focus Skills";
var dgProfileOverview_BuildProfileLearningsComplete_Plural$1 = "{{learningsCount}} Learnings";
var dgProfileOverview_BuildProfileLearningsIncomplete$1 = "Complete {{learningsLimit}} Learning";
var dgProfileOverview_BuildProfileSectionCompleted$1 = "Completed";
var dgProfileOverview_BuildProfileSkillRatingsComplete_Plural$1 = "{{skillRatingsCount}} Skill Ratings";
var dgProfileOverview_BuildProfileSkillRatingsComplete_Single$1 = "{{skillRatingsCount}} Skill Rating";
var dgProfileOverview_BuildProfileSkillRatingsIncomplete$1 = "Rate {{skillRatingsLimit}} Skill";
var dgProfileOverview_BuildProfileSkillsComplete_Plural$1 = "{{skillsCount}} Skills";
var dgProfileOverview_BuildProfileSkillsIncomplete$1 = "Add {{skillsLimit}} Skills";
var dgProfileOverview_BuildProfileSubTitle$1 = "Completing your profile personalizes your Degreed experience, helps you track your learning, and communicates your expertise to others in your organization.";
var dgProfileOverview_BuildProfileTitle$1 = "Build Your Profile";
var dgProfileOverview_CertificateNumber$1 = "Certificate Number";
var dgProfileOverview_Columns$1 = "Columns";
var dgProfileOverview_ColumnsToDisplay$1 = "Select columns to display";
var dgProfileOverview_FilterForSkills$1 = "Filter for skills";
var dgProfileOverview_FindExperts$1 = "Find Experts";
var dgProfileOverview_FocusedSkills$1 = "Focus Skills";
var dgProfileOverview_FocusedSkillsDescription$1 = "Skills within this section will generate relevant content for your home feed.";
var dgProfileOverview_FocusEmptyState_Link$1 = "Set your Focus Skills";
var dgProfileOverview_FocusEmptyState_Owner$1 = "You have not set any Focus Skills";
var dgProfileOverview_FocusEmptyState_Viewer$1 = "No Focus Skills have been set";
var dgProfileOverview_FocusSkills$1 = "Focus Skills";
var dgProfileOverview_FocusSkills_EmptyState$1 = "Add Focus Skills you’re actively developing to receive personalized content recommendations.";
var dgProfileOverview_FocusSkillsDescription$1 = "Skills within this section will be highlighted on your learner home.";
var dgProfileOverview_FocusSkillsDescriptionOtherProfile$1 = "{{name}} is currently developing the skills within this section";
var dgProfileOverview_FocusSkillsHelp$1 = "Add or remove a focus skill by clicking on the";
var dgProfileOverview_FocusSkillsHelp_and_Core_Icon$1 = "Add or remove a focus skill by clicking on the {{starIcon}} icon";
var dgProfileOverview_HasParsedResume$1 = "Resume Parsed";
var dgProfileOverview_LearningTitle$1 = "Learning";
var dgProfileOverview_MaxColumnsToDisplay$1 = "Select up to {{maxSelectable}} columns to display";
var dgProfileOverview_MaxFocusedSkills$1 = "You can add up to {{maxFocusSkills}} skills.";
var dgProfileOverview_NoCompletedContent$1 = "You haven’t completed any content recently. You can find content in your feeds on the home page, or by browsing or searching for it.";
var dgProfileOverview_NonOwnerEmptyStateBody$1 = "{{ firstName }} has not added anything to their profile yet.";
var dgProfileOverview_NonOwnerEmptyStateTitle$1 = "There is nothing here";
var dgProfileOverview_NoParsedResume$1 = "No Resume Parsed";
var dgProfileOverview_NoSkills$1 = "{{userName}} hasn't added any skills or topics yet.";
var dgProfileOverview_NothingCompleted$1 = "{{userName}} hasn't completed anything yet.";
var dgProfileOverview_OtherSkills$1 = "Other Skills";
var dgProfileOverview_OverviewAchievementsTitle$1 = "Achievements";
var dgProfileOverview_OverviewCompleteWizardButton$1 = "Complete Wizard";
var dgProfileOverview_OverviewEmptyStateText$1 = "Before you can use your profile, you need to add some information.";
var dgProfileOverview_OverviewEmptyStateTitle$1 = "Start building your profile";
var dgProfileOverview_OverviewExperienceTitle$1 = "Experience";
var dgProfileOverview_OverviewLearningTitle$1 = "Learning";
var dgProfileOverview_OverviewNotProvidedTitle$1 = "Not Provided";
var dgProfileOverview_OverviewSkillsTitle$1 = "Skills";
var dgProfileOverview_RecentlyCompleted$1 = "Recently Completed";
var dgProfileOverview_RemoveSkill$1 = "{{skillName}} skill removed";
var dgProfileOverview_RequiredCriticalSkills$1 = "Critical Skills";
var dgProfileOverview_RequiredSkills$1 = "Required Skills";
var dgProfileOverview_RequiredSkillsDescription$1 = "Your organization has assigned these skills for your professional development.";
var dgProfileOverview_SeeSkillCollection$1 = "See skill collection";
var dgProfileOverview_SkillActionsAriaLabel$1 = "{{skillName}} Skill Actions";
var dgProfileOverview_SkillListView_Description$1 = "Description";
var dgProfileOverview_SkillListView_Endorsed$1 = "Endorsed";
var dgProfileOverview_SkillListView_OrgSkill$1 = "Org Skill";
var dgProfileOverview_SkillListView_SkillSignals$1 = "Skill signals";
var dgProfileOverview_SkillListView_Source$1 = "Source";
var dgProfileOverview_SkillListView_SourceValue_Experience$1 = "Experience";
var dgProfileOverview_SkillListView_SourceValue_Organization$1 = "Organization";
var dgProfileOverview_SkillListView_SourceValue_Self$1 = "Self";
var dgProfileOverview_SkillListView_TotalRatings$1 = "Total ratings";
var dgProfileOverview_SkillListView_Type$1 = "Type";
var dgProfileOverview_SkillSignalDataTableLabel$1 = "Skill Signal Data Details";
var dgProfileOverview_SkillSignalsLabel$1 = "{{skillName}}: {{numSignals}} Skill Signals. Ratings: {{ratingsCount}}. Experiences: {{experiencesCount}}. Achievements: {{achievementsCount}}.  Learnings: {{learningsCount}}.";
var dgProfileOverview_SkillSignalsTitle$1 = "Skill Signals";
var dgProfileOverview_SkillSuggestionsSubTitle$1 = "These are suggested for you based on your activity.";
var dgProfileOverview_SkillSuggestionsSubTitle_By_Org$1 = "These are suggested by your organization.";
var dgProfileOverview_SkillSuggestionsSubTitle_On_Role$1 = "⁪⁪⁪‍‍‍‍‍‍‍‍‍‍‍‍‍‍‍‍⁪These are suggested for you based on your role.";
var dgProfileOverview_SkillSuggestionsTitle$1 = "Skill Suggestions";
var dgProfileOverview_StackedSkillRatingsAriaLabel$1 = "{{skillName}} Skill Ratings";
var dgProfileOverview_TooltipSignalsPlural$1 = "Signals";
var dgProfileOverview_TooltipSignalsSingle$1 = "Signal";
var dgProfileOverview_TooltipSignalsZero$1 = "Signals";
var dgProfileOverview_ViewAllAchievements$1 = "Achievements Section: View All Achievements";
var dgProfileOverview_ViewAllExperiences$1 = "Experiences Section: View All Experiences";
var dgProfileOverview_ViewAllLearning$1 = "Learning Section: View All Learning";
var dgProfileOverview_ViewAllSkills$1 = "Skills Section: View All Skills";
var dgProfileOverview_ViewAward$1 = "View Award";
var dgProfileOverview_ViewBadge$1 = "View Badge";
var dgProfileOverview_ViewCertificate$1 = "View Certificate";
var dgProfileOverview_ViewDegree$1 = "View Degree";
var dgProfileCollectionItem_CertDetailsTitle$1 = "Certificate Details";
var dgProfileCollectionItem_CertImage$1 = "Image";
var dgProfileCollectionItem_CertIssuedBy$1 = "Issued by";
var dgProfileCollectionItem_CertIssuerUrl$1 = "URL of Issuer";
var dgProfileCollectionItem_CertNumber$1 = "Certificate #";
var dgProfileCollectionItem_CertTitle$1 = "Title of the Certificate";
var dgProfileCollectionItem_CertValidDate$1 = "Date Valid";
var dgProfileCollectionItem_MasteryPointsFormat$1 = "{{masteryPoints}} pts";
var dgProfileCollectionItem_Verified$1 = "VERIFIED";
var dgPostComment_Message$1 = "Message";
var dgPostComment_Placeholder$1 = "Share an article, video, or idea";
var dgPopularSearches_ListOption$1 = "List";
var dgPopularSearches_TermOption$1 = "Terms";
var dgPopularProviders_Empty$1 = "No popular providers";
var dgPopularProviders_InputPercentageFormat$1 = "<strong>{{itemCount}}%</strong> of total inputs";
var dgPopularProviders_ProviderPlaceholder$1 = "Choose Provider Catalog";
var dgPopularProviders_SeatsFormat$1 = "<strong>{{providerSeatsCurrent}}</strong> of <strong>{{providerSeatsTotal}}</strong> seats used";
var dgPopularCategories_ListOption$1 = "List";
var dgPopularCategories_NoCategories$1 = "No matching categories";
var dgPopularCategories_NoSearchTerms$1 = "No matching search terms";
var dgPopularCategories_TagsOption$1 = "Skills";
var dgPopularCategories_UncategorizedFormat$1 = "+{{masteryPoints}} uncategorized points earned this {{period}}";
var dgPathwayTile_Enroll$1 = "Enroll";
var dgPathwayTile_Enrolled$1 = "Enrolled";
var dgPathwayTile_EnrolledButtonLabel$1 = "Enrolled. Click to withdraw.";
var dgPathwayTile_Follow$1 = "Follow";
var dgPathwayTile_Following$1 = "Following";
var dgPathwayTile_FollowingButtonLabel$1 = "Following. Click to unfollow.";
var dgPathwayTile_PrivateShareMsg$1 = "<p>This pathway is private.<br>In order to share it, make it visible in pathway settings.</p>";
var dgPathwayTile_SavedForLaterMsgFormat$1 = "{{title}} has been saved!";
var dgPathwayTile_Unfollow$1 = "Unfollow";
var dgPathwayTile_UnfollowConfirm$1 = "Are you sure you want to unfollow this pathway?";
var dgPathwayTile_Withdraw$1 = "Withdraw";
var dgPathwayTile_WithdrawConfirm$1 = "Are you sure you want to withdraw from this pathway?";
var dgPathwayTile_WithdrawExplanation$1 = "Content from this pathway will no longer appear in your Feed.";
var dgPathwaysInsights_CompletionPercentage$1 = "% completion";
var dgPathwaysInsights_EnrolledCountFormat$1 = "{{count}} Enrollee";
var dgPathwaysInsights_EnrolledCountPluralFormat$1 = "{{count}} Enrollees";
var dgPathwaysInsights_FiftyToSeventyFive$1 = "50% to 75%";
var dgPathwaysInsights_FollowerCountFormat$1 = "{{count}} Follower";
var dgPathwaysInsights_FollowerCountPluralFormat$1 = "{{count}} Followers";
var dgPathwaysInsights_GreaterThanSeventyFive$1 = "more than 75%";
var dgPathwaysInsights_LessonLower$1 = "lesson";
var dgPathwaysInsights_LessThanTwentyFive$1 = "less than 25%";
var dgPathwaysInsights_PercentageOfEnrollees$1 = "{{percentage}} of enrollees have completed {{percentageText}} of this {{type}}";
var dgPathwaysInsights_PercentageOfFollowers$1 = "{{percentage}} of followers have completed {{percentageText}} of this {{type}}";
var dgPathwaysInsights_Section$1 = "Section";
var dgPathwaysInsights_SectionLower$1 = "section";
var dgPathwaysInsights_Sections$1 = "Sections";
var dgPathwaysInsights_TableTitle$1 = "Section completion info";
var dgPathwaysInsights_Title$1 = "Title";
var dgPathwaysInsights_TwentyFiveToFifty$1 = "25% to 50%";
var dgPathwaysInsights_WhenDataUpdates$1 = "Note: Data updates daily";
var dgPathwayPrivacy_CollaboratorProfilePrivate$1 = "Collaborator Profiles (private)";
var dgPathwayPrivacy_CollaboratorProfileVisible$1 = "Collaborator Profiles (public)";
var dgPathwayPrivacy_OrgVisibleFormat$1 = "Visible to Organization";
var dgPathwayPrivacy_Private$1 = "Private";
var dgPathwayPrivacy_ProfilePrivate$1 = "My Profile (private)";
var dgPathwayPrivacy_ProfileVisible$1 = "My Profile (visible)";
var dgPathwayPrivacy_Public$1 = "Public";
var dgPathwayPrivacy_SpecificGroupsVisible$1 = "Visible to Specific Groups";
var dgPathwayPrivacy_VisibilityBoostToGroupTooltip$1 = "This pathway will be boosted to these group members in their search results";
var dgOrgSecurity_AddGlobalAdmins$1 = "Add Global Admins";
var dgOrgSecurity_AddGlobalAdminsDescription$1 = "Ability to add Global Admins to the Global Tool";
var dgOrgSecurity_AssignLearning$1 = "Assign Content";
var dgOrgSecurity_AssignLearningDescription$1 = "Assign content to organization members";
var dgOrgSecurity_AssignRatings$1 = "Assign Skill Ratings";
var dgOrgSecurity_AssignRatingsDescription$1 = "Assign skill ratings to organization members";
var dgOrgSecurity_AuthorContent$1 = "Record Videos";
var dgOrgSecurity_AuthorContentDescription$1 = "Record videos for your organization’s internal catalog from the Home page";
var dgOrgSecurity_AuthorPathways$1 = "Create Organizational Pathways";
var dgOrgSecurity_AuthorPathwaysDescription$1 = "Make pathways visible to the organization";
var dgOrgSecurity_AuthorSkillPlans$1 = "Create Organizational Plans";
var dgOrgSecurity_AuthorSkillPlansDescription$1 = "Make plans visible to the organization";
var dgOrgSecurity_AuthorTargets$1 = "Author Plans";
var dgOrgSecurity_AuthorTargetsDescription$1 = "Create plans and author those plans";
var dgOrgSecurity_CobfigureBrowse$1 = "Configure Browse";
var dgOrgSecurity_ConfigureBrowse$1 = "Configure Featured";
var dgOrgSecurity_ConfigureBrowseDescription$1 = "Edit and configure the Featured page in Degreed.";
var dgOrgSecurity_CreateAdministrativeGroups$1 = "Create Administrative Groups";
var dgOrgSecurity_CreateAdministrativeGroupsDescription$1 = "Create groups that are only visible to you and people with the Manage Groups permission (not members)";
var dgOrgSecurity_CreateClosedGroups$1 = "Create Closed Groups";
var dgOrgSecurity_CreateClosedGroupsDescription$1 = "Create groups that all organization members can see and request to join";
var dgOrgSecurity_CreateDynamicTeamAssignmentOpportunities$1 = "Dynamic Team Assignment";
var dgOrgSecurity_CreateDynamicTeamAssignmentOpportunitiesDesc$1 = "Create Dynamic Team Assignment opportunities for the organization.";
var dgOrgSecurity_CreateDynamicTeamAssignmentOpportunitiesDescription$1 = "Create Dynamic Team Assignment opportunities for the organization.";
var dgOrgSecurity_CreateGroups$1 = "Create Groups";
var dgOrgSecurity_CreateGroupsDescription$1 = "Administrative privileges in all groups without needing to join";
var dgOrgSecurity_CreateLookingforMenteeOpportunities$1 = "Looking for Mentee";
var dgOrgSecurity_CreateLookingforMenteeOpportunitiesDescription$1 = "Create Looking for Mentee opportunities for the organization.";
var dgOrgSecurity_CreateLookingforMentorOpportunities$1 = "Looking for Mentor";
var dgOrgSecurity_CreateLookingforMentorOpportunitiesDescription$1 = "Create Looking for Mentor opportunities for the organization.";
var dgOrgSecurity_CreateMentorshipOpportunities$1 = "Mentorship";
var dgOrgSecurity_CreateMentorshipOpportunitiesDescription$1 = "Create Mentorship opportunities for the organization.";
var dgOrgSecurity_CreateOpenGroups$1 = "Create Open Groups";
var dgOrgSecurity_CreateOpenGroupsDescription$1 = "Create groups that all organization members can see and join";
var dgOrgSecurity_CreateOpportunities$1 = "Create Opportunities";
var dgOrgSecurity_CreateOpportunitiesDescription$1 = "Create opportunities for the organization.";
var dgOrgSecurity_CreateOtherOpportunities$1 = "Other";
var dgOrgSecurity_CreateOtherOpportunitiesDescription$1 = "Create Other opportunities for the organization.";
var dgOrgSecurity_CreatePeerMentoringOpportunities$1 = "Peer Mentoring";
var dgOrgSecurity_CreatePeerMentoringOpportunitiesDescription$1 = "Create Peer Mentoring opportunities for the organization.";
var dgOrgSecurity_CreatePrivateGroups$1 = "Create Private Groups";
var dgOrgSecurity_CreatePrivateGroupsDescription$1 = "Create invitation-only groups for your organization";
var dgOrgSecurity_CreateProBonoOpportunities$1 = "Pro Bono";
var dgOrgSecurity_CreateProBonoOpportunitiesDescription$1 = "Create Pro Bono opportunities for the organization.";
var dgOrgSecurity_CreateProjectOpportunities$1 = "Project";
var dgOrgSecurity_CreateProjectOpportunitiesDescription$1 = "Create Project opportunities for the organization.";
var dgOrgSecurity_CreateReverseMentoringOpportunities$1 = "Reverse Mentoring";
var dgOrgSecurity_CreateReverseMentoringOpportunitiesDescription$1 = "Create Reverse Mentoring opportunities for the organization.";
var dgOrgSecurity_CreateShadowingOpportunities$1 = "Shadowing";
var dgOrgSecurity_CreateShadowingOpportunitiesDescription$1 = "Create Shadowing opportunities for the organization.";
var dgOrgSecurity_CreateStretchAssignmentOpportunities$1 = "Stretch Assignment";
var dgOrgSecurity_CreateStretchAssignmentOpportunitiesDescription$1 = "Create Stretch Assignment opportunities for the organization.";
var dgOrgSecurity_CreateTenant$1 = "Create Organization";
var dgOrgSecurity_CreateTenantDescription$1 = "Create new organizations in the Global Admin Tool";
var dgOrgSecurity_CreateVolunteerOpportunities$1 = "Volunteer";
var dgOrgSecurity_CreateVolunteerOpportunitiesDescription$1 = "Create Volunteer opportunities for the organization.";
var dgOrgSecurity_CustomizeBrowse$1 = "Edit and configure the Browse page in Degreed";
var dgOrgSecurity_DefaultRoleText$1 = 'The default role for new members of your organization is "Member"';
var dgOrgSecurity_DeleteGroup$1 = "Delete Group";
var dgOrgSecurity_DeleteGroupDescription$1 = "Delete a group";
var dgOrgSecurity_DownloadPathwayDetailsReport$1 = "Download Pathway Details Report";
var dgOrgSecurity_DownloadPathwayDetailsReportDescription$1 = "Download reports for pathway completion details from the Pathway followers page.";
var dgOrgSecurity_DownloadReports$1 = "Download Reports";
var dgOrgSecurity_DownloadReportsDescription$1 = "Generate and download reports of organization or group insights";
var dgOrgSecurity_EditCommunications$1 = "Edit Communications";
var dgOrgSecurity_EditCommunicationsDescription$1 = "Edit any of the organization's communication settings, including emails and in-app messages.";
var dgOrgSecurity_EditCommunicationsGlobal$1 = "Edit Communications";
var dgOrgSecurity_EditCommunicationsGlobalDescription$1 = "Edit any of the Global Admin’s communication settings, including emails and in-app messages.";
var dgOrgSecurity_EditPermissions$1 = "Edit Permissions";
var dgOrgSecurity_EditPermissionsDescription$1 = "Edit the organization's permission settings for each user role";
var dgOrgSecurity_EditPermissionsGlobal$1 = "Edit Permissions";
var dgOrgSecurity_EditPermissionsGlobalDescription$1 = "Edit the Global Admin permissions settings for each user role.";
var dgOrgSecurity_EditSettings$1 = "Edit Settings";
var dgOrgSecurity_EditSettingsDescription$1 = "View and edit the organization’s settings, and edit the organization’s FAQs";
var dgOrgSecurity_EditTenantOrganizationPermissions$1 = "Edit Organization Permissions";
var dgOrgSecurity_EditTenantOrganizationPermissionsDescription$1 = "Edit the tenant organization's permission settings for each user role";
var dgOrgSecurity_EditTenantSettings$1 = "Edit Organization Settings";
var dgOrgSecurity_EditTenantSettingsDescription$1 = "Ability to select an org in the list, so the org settings can be modified. A user w/ this permission can select an org to change the org settings. A user without this permission can see the list of orgs, but when the user clicks on an org, the user is not taken to the org settings page.";
var dgOrgSecurity_EmailPasswordReset$1 = "Email Password Reset";
var dgOrgSecurity_EmailPasswordResetDescription$1 = "Reset password for member by sending email";
var dgOrgSecurity_EndorseContent$1 = "Endorse Content";
var dgOrgSecurity_EndorseContentDescription$1 = "Endorse plans or pathways with an indicator on the card";
var dgOrgSecurity_InviteMembers$1 = "Invite Members";
var dgOrgSecurity_InviteMembersDescription$1 = "Add new members to the organization from the member list";
var dgOrgSecurity_LearningProfessional$1 = "Learning Professional";
var dgOrgSecurity_LearnMore$1 = "Learn More";
var dgOrgSecurity_ManageAdvanced$1 = "Manage Advanced";
var dgOrgSecurity_ManageAdvancedDescription$1 = "View and manage advanced settings";
var dgOrgSecurity_ManageAttributes$1 = "Manage Custom Attributes";
var dgOrgSecurity_ManageAttributesDescription$1 = "Manage which custom user attributes display throughout Degreed, including in Segments and Business Rules drop-down lists";
var dgOrgSecurity_ManageBusinessRules$1 = "Manage Automations";
var dgOrgSecurity_ManageBusinessRulesDescription$1 = "View and manage automations.";
var dgOrgSecurity_ManageContent$1 = "Manage Catalog";
var dgOrgSecurity_ManageContentDescription$1 = "Create, remove, or edit internal content";
var dgOrgSecurity_ManageEngage$1 = "Manage Communications for Automations";
var dgOrgSecurity_ManageEngageDescription$1 = "Create, edit and delete communications for Automations";
var dgOrgSecurity_ManageGroups$1 = "Manage Groups";
var dgOrgSecurity_ManageGroupsDescription$1 = "Administrative privileges in all groups without needing to join";
var dgOrgSecurity_ManageIntegrations$1 = "Manage Integrations";
var dgOrgSecurity_ManageIntegrationsDescription$1 = "View and manage provider integrations.";
var dgOrgSecurity_ManageOpportunities$1 = "Manage Opportunities";
var dgOrgSecurity_ManageOpportunitiesDescription$1 = "Edit any of the organization’s opportunities.";
var dgOrgSecurity_ManageOrgApiKeys$1 = "Manage API Keys";
var dgOrgSecurity_ManageOrgApiKeysDescription$1 = "View and manage api keys.";
var dgOrgSecurity_ManagePathways$1 = "Manage Pathways";
var dgOrgSecurity_ManagePathwaysDescription$1 = "Edit any of the organization’s pathways, including pathway settings and content";
var dgOrgSecurity_ManageReporting$1 = "Manage Reporting";
var dgOrgSecurity_ManageReportingDescription$1 = "View and manage in-app reports and schedules";
var dgOrgSecurity_ManageReportingFTPScheduler$1 = "Manage Scheduled FTP Reports";
var dgOrgSecurity_ManageReportingFTPSchedulerDescription$1 = "View and manage scheduled FTP reports";
var dgOrgSecurity_ManageReportingInApp$1 = "Manage In App Reporting";
var dgOrgSecurity_ManageReportingInAppDescription$1 = "Manage reports and their schedules";
var dgOrgSecurity_ManageReportingTransmitterConfigurations$1 = "Manage Reporting Transmitter Configurations";
var dgOrgSecurity_ManageReportingTransmitterConfigurationsDescription$1 = "Create and manage transmitter configurations for FTP reports";
var dgOrgSecurity_ManageSegments$1 = "Manage Segments";
var dgOrgSecurity_ManageSegmentsDescription$1 = "View and manage user segments";
var dgOrgSecurity_ManageSkillPlans$1 = "Manage Plans and Directories";
var dgOrgSecurity_ManageSkillPlansDescription$1 = "View and edit any of the organization’s plans or directories, including settings and content";
var dgOrgSecurity_ManageSkills$1 = "Manage Skills";
var dgOrgSecurity_ManageSkillsDescription$1 = "View and manage the organization's skill taxonomy and associated roles";
var dgOrgSecurity_ManageSkillsPlatform$1 = "Manage Skills Platform";
var dgOrgSecurity_ManageSkillsPlatformDescription$1 = "This permission will allow users to manage skill labels and skill scales within the skills platform.";
var dgOrgSecurity_ManageSkillStandards$1 = "Manage Skill Standards";
var dgOrgSecurity_ManageSkillStandardsDescription$1 = "View and manage skill standards";
var dgOrgSecurity_ManageTargets$1 = "Manage Plans";
var dgOrgSecurity_ManageTargetsDescription$1 = "Create, view, and author plans without being an author";
var dgOrgSecurity_PublishOpportunities$1 = "Publish Opportunities";
var dgOrgSecurity_PublishOpportunitiesDescription$1 = "Make opportunities visible to the organization or groups.";
var dgOrgSecurity_PublishSkills$1 = "Publish Skills";
var dgOrgSecurity_PublishSkillsDescription$1 = "Make skill updates in Degreed Skills visible to the organization.";
var dgOrgSecurity_RecommendItems$1 = "Share Content";
var dgOrgSecurity_RecommendItemsDescription$1 = "Share content to members of the organization and followers";
var dgOrgSecurity_RecommendItemsWithDate$1 = "Assign Learning";
var dgOrgSecurity_RecommendItemsWithDateDescription$1 = "Create content assignments for organization members";
var dgOrgSecurity_RecommendOpportunities$1 = "Share Opportunities";
var dgOrgSecurity_RecommendOpportunitiesDescription$1 = "Share opportunities to members of the organization.";
var dgOrgSecurity_RecommendRatings$1 = "Share Skill Ratings";
var dgOrgSecurity_RecommendRatingsDescription$1 = "Share skill ratings with members of the organization";
var dgOrgSecurity_RemoveMembers$1 = "Remove Members";
var dgOrgSecurity_RemoveMembersDescription$1 = "Remove members from the organization’s member list";
var dgOrgSecurity_RequestManagerRating$1 = "Request manager rating";
var dgOrgSecurity_RequestManagerRatingDescription$1 = "Request your manager to rate your skill, private to you";
var dgOrgSecurity_RoleAdmin$1 = "Admin";
var dgOrgSecurity_RoleLearningProfessional$1 = "Learning Professional";
var dgOrgSecurity_RoleManager$1 = "Manager";
var dgOrgSecurity_RoleMember$1 = "Member";
var dgOrgSecurity_ScanCatalogLinks$1 = "Scan Catalog Links";
var dgOrgSecurity_ScanCatalogLinksDescription$1 = "Scan Manage Catalog content for broken links";
var dgOrgSecurity_SelectFeaturedPathways$1 = "Feature Pathways and Plans";
var dgOrgSecurity_SelectFeaturedPathwaysDescription$1 = "Edit the Featured Pathways/Plans section of the Browse page";
var dgOrgSecurity_ShareBundledContent$1 = "Share Bundled Content";
var dgOrgSecurity_ShareBundledContentDescription$1 = "Edit the organizations that can access bundled content";
var dgOrgSecurity_UploadClientUser$1 = "Upload Client User";
var dgOrgSecurity_UploadClientUserDescription$1 = "Add, update, or delete users";
var dgOrgSecurity_UploadCompletions$1 = "Upload Completions";
var dgOrgSecurity_UploadCompletionsDescription$1 = "Add, update, or delete learning completions";
var dgOrgSecurity_UploadContent$1 = "Upload Content";
var dgOrgSecurity_UploadContentDescription$1 = "Add, update, or delete content";
var dgOrgSecurity_UploadContentFiles$1 = "Upload Content Files";
var dgOrgSecurity_UploadContentFilesDescription$1 = "Upload content files to your organization’s internal catalog";
var dgOrgSecurity_UploadFiles$1 = "Upload Files";
var dgOrgSecurity_UploadFilesDescription$1 = "Upload files for your organization";
var dgOrgSecurity_UploadGroups$1 = "Upload Groups";
var dgOrgSecurity_UploadGroupsDescription$1 = "Add, update, or delete Groups";
var dgOrgSecurity_UploadOpportunities$1 = "Upload Opportunities";
var dgOrgSecurity_UploadOpportunitiesDescription$1 = "Add, update, or delete Opportunities";
var dgOrgSecurity_UploadPlans$1 = "Upload Plans";
var dgOrgSecurity_UploadPlansDescription$1 = "Add and update plans";
var dgOrgSecurity_UploadRequiredLearning$1 = "Upload Required Learning";
var dgOrgSecurity_UploadRequiredLearningDescription$1 = "Add, update, or delete required learning";
var dgOrgSecurity_UploadRoles$1 = "Upload Roles";
var dgOrgSecurity_UploadRolesDescription$1 = "Add and update roles";
var dgOrgSecurity_UploadSkills$1 = "Upload Skills";
var dgOrgSecurity_UploadSkillsDescription$1 = "Add and update skills";
var dgOrgSecurity_UploadUserUpdates$1 = "Upload User Updates";
var dgOrgSecurity_UploadUserUpdatesDescription$1 = "Add, update, or delete user attributes";
var dgOrgSecurity_ViewCareerPaths$1 = "View Plans and Directories";
var dgOrgSecurity_ViewCareerPathsDescription$1 = "View the organization’s plans and directories";
var dgOrgSecurity_ViewDynamicAdminGroupMembers$1 = "View Dynamic Admin Group Members";
var dgOrgSecurity_ViewDynamicAdminGroupMembersDescription$1 = "View a list of all organization members who meet conditions set by the dynamic admin group";
var dgOrgSecurity_ViewKnowledgeCenter$1 = "View Knowledge Center";
var dgOrgSecurity_ViewKnowledgeCenterDescription$1 = "View Degreed product documentation and administrative tools";
var dgOrgSecurity_ViewMembers$1 = "View Members";
var dgOrgSecurity_ViewMembersDescription$1 = "View a list of all organization members with their user roles";
var dgOrgSecurity_ViewOpportunities$1 = "View Opportunities";
var dgOrgSecurity_ViewOpportunitiesDescription$1 = "View organisation's opportunities.";
var dgOrgSecurity_ViewOrganizationOpportunityInsights$1 = "View Organization Opportunity Insights";
var dgOrgSecurity_ViewOrganizationOpportunityInsightsDescription$1 = "View opportunity insights for your organization";
var dgOrgSecurity_ViewOrganizationReports$1 = "View Organization Insights";
var dgOrgSecurity_ViewOrganizationReportsDescription$1 = "View insights for your organization, pathways, and plans";
var dgOrgSecurity_ViewPathwayEnrollees$1 = "View Pathway Followers";
var dgOrgSecurity_ViewPathwayEnrolleesDescription$1 = "View followers for pathways you've authored";
var dgOrgSecurity_ViewRatings$1 = "View Individual Skill Data";
var dgOrgSecurity_ViewRatingsDescription$1 = "View skill data for individuals throughout the product (in organization-level skill insights, or as a result of a share or assignment).";
var dgOrgSecurity_ViewRecommendedRatings$1 = "View Shared Skill Ratings";
var dgOrgSecurity_ViewRecommendedRatingsDescription$1 = "View skill data for individuals who have completed a skill rating you shared or assigned";
var dgOrgOverview_ChangeLogo$1 = "Change Logo";
var dgOrgOverview_ChangeLogoTextFormat$1 = "{{startStrong}}Square images work best.{{endStrong}} Image must be a PNG, JPG, or GIF file and no larger than 1MB. Image must be 200px wide or more.";
var dgOrgOverview_GroupCountFormat$1 = "{{count}} Groups";
var dgOrgOverview_HeaderColor$1 = "Header Color";
var dgOrgOverview_MemberCountFormat$1 = "{{count}} Members";
var dgOrgOverview_PreviewLabel$1 = "Preview of how the header will look with settings applied";
var dgOrgMembers_AddAMessage$1 = "Add a message";
var dgOrgMembers_AddMembersTitleFormat$1 = "Add people to {{org}}";
var dgOrgMembers_AddPeople$1 = "Add People";
var dgOrgMembers_CopyTheURL$1 = "Copy the URL";
var dgOrgMembers_EmailDomainChangeFormat$1 = "Contact your representative to update your organization's accepted email domains.";
var dgOrgMembers_EmailInstructions$1 = "Members of your team must have an email address that ends in:";
var dgOrgMembers_EmailPlaceholderText$1 = "Enter an email address";
var dgOrgMembers_InviteGroupInstructionsFormat$1 = "Quickly invite others to join you in the {{name}} group using this invite link.";
var dgOrgMembers_InviteLabel$1 = "Invite by email";
var dgOrgMembers_InviteMembersTitleFormat$1 = "Invite Users to {{org}}";
var dgOrgMembers_PersonalMessageDescription$1 = "This message will be displayed as part of the welcome email each team member will receive from support@degreed.com";
var dgOrgMembers_PersonalMessageDescriptionFormat$1 = "This message will be displayed as part of the welcome email each team member will receive from {{orgName}}@degreed.com";
var dgOrgMembers_PersonalMessageLabel$1 = "Personal message";
var dgOrgMembers_SelectAllPending$1 = "Select all pending invitations";
var dgOrgMembers_SendInvite$1 = "Send Invite";
var dgOrgManageProviderModal_DisconnectIntegrationWarning$1 = "You are about to remove this provider’s content from your catalog. Content will not be removed from Shared or Assigned queues, pathways, or plans.";
var dgOrgManageProviderModal_EnableIntegration$1 = "Enable Integration";
var dgOrgInvite_CommaSeparated$1 = "comma separated";
var dgOrgInvite_EmailAddresses$1 = "Email Addresses";
var dgOrgInvite_InviteEmailsOverview$1 = "Or, let us send an invite for you! List emails of coworkers in the field below.";
var dgOrgInvite_InviteLinkOverview$1 = "Quickly invite others to join you on Degreed using this invite link.";
var dgOrgInvite_InviteTitle$1 = "Invite People";
var dgOrgInvite_Send$1 = "Send";
var dgOrgInternalContentForm_AddFromUrl$1 = "or Add from a URL";
var dgOrgInternalContentForm_AddImage$1 = "Add Image";
var dgOrgInternalContentForm_AddInternalItemId$1 = "Add internal item ID";
var dgOrgInternalContentForm_ArticalFormatPlaceholder$1 = "Choose Article Format";
var dgOrgInternalContentForm_ArticleDescription$1 = "Description";
var dgOrgInternalContentForm_ArticleDescriptionPlaceholder$1 = "Describe what this article is about";
var dgOrgInternalContentForm_ArticleExistsCancel$1 = "No";
var dgOrgInternalContentForm_ArticleExistsDescription$1 = "The article you are trying to add was previously added. Any content added here will overwrite the existing article. Would you like to update it with this new information?";
var dgOrgInternalContentForm_ArticleExistsTitle$1 = "This article URL already exists";
var dgOrgInternalContentForm_ArticleFormat$1 = "Article Format";
var dgOrgInternalContentForm_ArticleFormatSelectPlaceholder$1 = "Select article format";
var dgOrgInternalContentForm_ArticleTitle$1 = "Title";
var dgOrgInternalContentForm_ArticleURL$1 = "Article URL";
var dgOrgInternalContentForm_AssessmentDescription$1 = "Description";
var dgOrgInternalContentForm_AssessmentExistsDescription$1 = "The assessment you are trying to add was previously added. Any content added here will overwrite the existing assessment. Would you like to update it with this new information?";
var dgOrgInternalContentForm_AssessmentExistsTitle$1 = "This assessment URL already exists";
var dgOrgInternalContentForm_AssessmentName$1 = "Assessment Name";
var dgOrgInternalContentForm_AssessmentProvider$1 = "Assessment Provider";
var dgOrgInternalContentForm_AssessmentURL$1 = "Assessment URL";
var dgOrgInternalContentForm_AudioURL$1 = "Podcast URL";
var dgOrgInternalContentForm_BookAuthor$1 = "Author";
var dgOrgInternalContentForm_BookCoverAltFormat$1 = "{{title}} book cover";
var dgOrgInternalContentForm_BookDatePublished$1 = "Date Published";
var dgOrgInternalContentForm_BookDateRead$1 = "Date Read";
var dgOrgInternalContentForm_BookLength$1 = "Length (Pages)";
var dgOrgInternalContentForm_BookLengthCustomFormat$1 = "Length ({{units}})";
var dgOrgInternalContentForm_BookSave$1 = "Save Book";
var dgOrgInternalContentForm_BookSubtitle$1 = "Subtitle";
var dgOrgInternalContentForm_BookSummary$1 = "Summary";
var dgOrgInternalContentForm_BookTitle$1 = "Title";
var dgOrgInternalContentForm_BookTitlePlaceholder$1 = "Book Title";
var dgOrgInternalContentForm_CategoriesToolTip$1 = "Add skills that will help users find content that is relevant to their needs.";
var dgOrgInternalContentForm_ChooseCourseFormat$1 = "Choose Course Format";
var dgOrgInternalContentForm_CommentTooltip$1 = "This comment will be shared publicly within your organization";
var dgOrgInternalContentForm_Complete$1 = "Complete!";
var dgOrgInternalContentForm_ContentOwner$1 = "Content Owner";
var dgOrgInternalContentForm_ContentOwnerPlaceholder$1 = "Search for a name or Degreed group";
var dgOrgInternalContentForm_ContentOwnerRequired$1 = "A content owner is required";
var dgOrgInternalContentForm_ContentOwnerTooltip$1 = "Search for a name or Degreed group who will be responsible for maintaining the content.";
var dgOrgInternalContentForm_CourseDescription$1 = "Description";
var dgOrgInternalContentForm_CourseDescriptionPlaceholder$1 = "Describe what this course is about";
var dgOrgInternalContentForm_CourseExistsDescription$1 = "The course you are trying to add was previously added. Any content added here will overwrite the existing course. Would you like to update it with this new information?";
var dgOrgInternalContentForm_CourseExistsTitle$1 = "This course title already exists";
var dgOrgInternalContentForm_CourseFormat$1 = "Course Format";
var dgOrgInternalContentForm_CourseTitle$1 = "Course Title";
var dgOrgInternalContentForm_CourseURL$1 = "Course Url";
var dgOrgInternalContentForm_CreateNewCredSparkAssessment$1 = "Create a new CredSpark Assessment";
var dgOrgInternalContentForm_CreationDate$1 = "Published Date";
var dgOrgInternalContentForm_CredSparkDashboard$1 = "CredSpark dashboard";
var dgOrgInternalContentForm_DragImage$1 = "Drag an image from your computer";
var dgOrgInternalContentForm_EditDetails$1 = "Edit details";
var dgOrgInternalContentForm_EventDescription$1 = "Description";
var dgOrgInternalContentForm_EventExistsDescription$1 = "The event you are trying to add was previously added. Any content added here will overwrite the existing event. Would you like to update it with this new information?";
var dgOrgInternalContentForm_EventExistsTitle$1 = "This event title already exists";
var dgOrgInternalContentForm_EventFormat$1 = "Event Format";
var dgOrgInternalContentForm_EventFormatPlaceholder$1 = "Choose Event Format";
var dgOrgInternalContentForm_EventTitle$1 = "Title";
var dgOrgInternalContentForm_EventTitlePlaceholder$1 = "Event Title";
var dgOrgInternalContentForm_EventURL$1 = "Event Web Site (URL)";
var dgOrgInternalContentForm_EventURLPlaceholder$1 = "Event URL";
var dgOrgInternalContentForm_File$1 = "File:";
var dgOrgInternalContentForm_FileTooLargeFormat$1 = "File too large {{fileSize}}MB: max {{fileMax}}";
var dgOrgInternalContentForm_GroupsTitle$1 = "Add Groups";
var dgOrgInternalContentForm_GroupsToolTip$1 = "Adding groups will help users find content that is associated to groups they belong to.";
var dgOrgInternalContentForm_ImageDisplayOption$1 = "Image Display Option";
var dgOrgInternalContentForm_ImageDisplayOption1$1 = "Small Image";
var dgOrgInternalContentForm_ImageDisplayOption2$1 = "Large Image";
var dgOrgInternalContentForm_ImagePreviewAltText$1 = "Content Image Preview";
var dgOrgInternalContentForm_ImageReuploadInstructions$1 = "Click thumbnail to reupload image.";
var dgOrgInternalContentForm_InternalItemId$1 = "Internal Item ID";
var dgOrgInternalContentForm_InvalidFileType$1 = "Invalid file type:";
var dgOrgInternalContentForm_ItemExistsCancel$1 = "No";
var dgOrgInternalContentForm_ItemExistsConfirm$1 = "Yes, continue";
var dgOrgInternalContentForm_IWroteBook$1 = "I wrote this book";
var dgOrgInternalContentForm_Languages$1 = "Languages";
var dgOrgInternalContentForm_ManageCredSparkAccount$1 = "Manage CredSpark";
var dgOrgInternalContentForm_ManageOnCredSpark$1 = "Manage on CredSpark";
var dgOrgInternalContentForm_NoLanguageFound$1 = "No Language Found";
var dgOrgInternalContentForm_NumberOfQuestions$1 = "Number of Questions";
var dgOrgInternalContentForm_NumberOfUnits$1 = "Number of";
var dgOrgInternalContentForm_Or$1 = "or";
var dgOrgInternalContentForm_ProcessingFile$1 = "processing file...";
var dgOrgInternalContentForm_Questions$1 = "Questions";
var dgOrgInternalContentForm_Record$1 = "Record";
var dgOrgInternalContentForm_RecordAVideo$1 = "Record a video";
var dgOrgInternalContentForm_RecordVideo$1 = "Record Video";
var dgOrgInternalContentForm_ReRecordVideo$1 = "Re-record Video";
var dgOrgInternalContentForm_ReSyncCredSpark$1 = "Re-sync";
var dgOrgInternalContentForm_ReUploadRecording$1 = "Re-upload Recording";
var dgOrgInternalContentForm_ScormFile$1 = "SCORM File";
var dgOrgInternalContentForm_ScormInstructions$1 = "Select SCORM zip file or drag/drop ";
var dgOrgInternalContentForm_ScormPackageCheckbox$1 = "SCORM Package";
var dgOrgInternalContentForm_ScormPackageUpdateCheckbox$1 = "Update SCORM Package";
var dgOrgInternalContentForm_SelectLanguage$1 = "Select Language";
var dgOrgInternalContentForm_UnableToUpload$1 = "Unable to upload";
var dgOrgInternalContentForm_UploadImage$1 = "Upload Image";
var dgOrgInternalContentForm_UploadRecording$1 = "Upload Recording";
var dgOrgInternalContentForm_VideoDescription$1 = "Description";
var dgOrgInternalContentForm_VideoDescriptionPlaceholder$1 = "Describe what this video is about";
var dgOrgInternalContentForm_VideoExistsDescription$1 = "The video you are trying to add was previously added. Any content added here will overwrite the existing video. Would you like to update it with this new information?";
var dgOrgInternalContentForm_VideoExistsTitle$1 = "This video URL already exists";
var dgOrgInternalContentForm_VideoFilesizeError$1 = "Sorry! Your file must be less than 1GB.";
var dgOrgInternalContentForm_VideoFiletypeError$1 = "Sorry! You can only upload videos with the .mp4 file extension.";
var dgOrgInternalContentForm_VideoFormat$1 = "Video Format";
var dgOrgInternalContentForm_VideoFormatSelectPlaceholder$1 = "Select video format";
var dgOrgInternalContentForm_VideoFormPlaceholder$1 = "Choose Video Format";
var dgOrgInternalContentForm_VideoLength$1 = "Video Length (minutes)";
var dgOrgInternalContentForm_VideoSourceSupported$1 = "This video source is supported by Degreed’s embedded video player.";
var dgOrgInternalContentForm_VideoTimeLimit$1 = "You can record up to {{timeLimit}} minutes of video.";
var dgOrgInternalContentForm_VideoTitle$1 = "Title";
var dgOrgInternalContentForm_VideoUploadLimit$1 = "Files can be videos ({{filePattern}}) up to {{filesizeLimit}} in size.";
var dgOrgInternalContentForm_VideoURL$1 = "Video URL";
var dgOrgInternalContent_1Pathway$1 = "1 Pathway";
var dgOrgInternalContent_1Plan$1 = "1 Plan";
var dgOrgInternalContent_1Share$1 = "1 Share";
var dgOrgInternalContent_AddContent$1 = "Add Content";
var dgOrgInternalContent_AddEditContent$1 = "Add or Edit Content";
var dgOrgInternalContent_AddNewContent$1 = "Add New Content";
var dgOrgInternalContent_AddNewContentFormat$1 = "Add New {{inputType}}";
var dgOrgInternalContent_All$1 = "All";
var dgOrgInternalContent_BrokenLinkError$1 = "This link appears to be broken and might need to be updated";
var dgOrgInternalContent_BrokenLinks$1 = "Broken Links";
var dgOrgInternalContent_BulkDeleteCredSpark$1 = "CredSpark assessments must be deleted or unpublished from your CredSpark dashboard to be removed completely.";
var dgOrgInternalContent_BulkEdit$1 = "Bulk Edit";
var dgOrgInternalContent_Catalog$1 = "Catalog";
var dgOrgInternalContent_CategoriesTitle$1 = "Add Skills to Selected Inputs";
var dgOrgInternalContent_CategoriesToolTip$1 = "Add skills to selected inputs that will help users find content that is relevant to their needs.";
var dgOrgInternalContent_CheckForBrokenLinks$1 = "Check for Broken Links";
var dgOrgInternalContent_CheckForBrokenToolTip$1 = "This button will be available again when the scan in progress has completed.";
var dgOrgInternalContent_ChooseContentType$1 = "Choose Content Type";
var dgOrgInternalContent_ContentInUse$1 = "This content is used in the following Plans and/or Pathways:";
var dgOrgInternalContent_ContentType$1 = "Content Type";
var dgOrgInternalContent_ContentUsedInPlansAndPathways$1 = "{{title}} is used in the following Pathways and Plans:";
var dgOrgInternalContent_ContinueToDeleteContent$1 = "Click {{ startBoldTag }} Continue {{ endBoldTag }} to delete the remaining items you selected from the catalog.";
var dgOrgInternalContent_DeleteContent$1 = "Delete Content";
var dgOrgInternalContent_DeleteContentMessage$1 = "You are about to remove the following item(s) from your organization catalog:";
var dgOrgInternalContent_DeleteContentPermissionWarning$1 = "You don’t have permissions to delete the following items:";
var dgOrgInternalContent_DeleteContentTooltip$1 = "Hosted files will be deleted from storage.";
var dgOrgInternalContent_DeleteFromAllReferences$1 = "Delete from the catalog and all other references";
var dgOrgInternalContent_DeleteFromAllReferencesTooltip$1 = "Content will be removed from Plans, Pathways, assignments, shares and hosted files will be deleted.";
var dgOrgInternalContent_DeleteFromCatalog$1 = "Delete from the catalog only";
var dgOrgInternalContent_DeleteItems$1 = "Delete {{ numberOfItems }} Items";
var dgOrgInternalContent_DeleteOneItem$1 = "Delete 1 Item";
var dgOrgInternalContent_DeleteSelectedInputs$1 = "Delete Selected Inputs";
var dgOrgInternalContent_EditContent$1 = "Edit Content";
var dgOrgInternalContent_EditContentFormat$1 = "Edit {{inputType}}";
var dgOrgInternalContent_GenerateCmsReport$1 = "Download Catalog";
var dgOrgInternalContent_GroupsTitle$1 = "Add Groups to Selected Inputs";
var dgOrgInternalContent_GroupsToolTip$1 = "Add groups to selected inputs that will help users find content that is associated to groups they belong to.";
var dgOrgInternalContent_InternalContentVisibility$1 = "Content in your internal catalog is only viewable and discoverable by members of your organization.";
var dgOrgInternalContent_ItemsSelectedFormat$1 = "{{count}} Content Items Selected";
var dgOrgInternalContent_LastScannedOn$1 = "Last Scanned on {{fullDate}}";
var dgOrgInternalContent_LinkIsNotBroken$1 = "Link Is Not Broken";
var dgOrgInternalContent_LinkUpdated$1 = "Link updated";
var dgOrgInternalContent_ManageBrokenLinks$1 = "Manage Broken Links";
var dgOrgInternalContent_MultiplePathways$1 = "{{count}} Pathways";
var dgOrgInternalContent_MultiplePlans$1 = "{{count}} Plans";
var dgOrgInternalContent_MultipleShares$1 = "{{ numberOfShares }} Shares";
var dgOrgInternalContent_NoBrokenLinksInfoText$1 = "There are currently no broken links. Click the button to start a new catalog scan.";
var dgOrgInternalContent_NoBrokenLinksScanHistory$1 = "Your organization hasn't run a check for broken links yet. Click the button below to start a catalog scan.";
var dgOrgInternalContent_ScanCompleteNotification$1 = "Your {{boldStart}}catalog links scan{{boldEnd}} is complete.";
var dgOrgInternalContent_ScanIsComplete$1 = "Catalog scan is complete!";
var dgOrgInternalContent_ScanningCatalog$1 = "Scanning your catalog for broken links...";
var dgOrgInternalContent_ShowMoreItems$1 = "+ {{ numberOfItems }} more";
var dgOrgInternalContent_SidebarDescriptionFormat$1 = "Changes made here will affect {{org}} Catalog in the Library, which is the default content catalog for members of your organization. The {{org}} Catalog is comprised of all proprietary content entered in Degreed, as well as any content selected below.";
var dgOrgInternalContent_SidebarTitle$1 = "Manage Internal Content";
var dgOrgInternalContent_SkillsHelperText$1 = "Search for a skill or select one from suggestions below";
var dgOrgInternalContent_SkillsMaxError$1 = "Up to 15 skills can be added";
var dgOrgInternalContent_SkillsPlaceholderText$1 = "Search for a skill or select one from suggestions below if available";
var dgOrgInternalContent_SkillsTooltipText$1 = "Search for a skill or select one from suggestions below if available. Adding relevant skills helps Degreed make better content recommendations to learners.";
var dgOrgInternalContent_ViewBrokenLinks$1 = "View Broken Links";
var dgOrgInternalContent_ViewScormReport$1 = "View SCORM Report";
var dgOrgFaqForm_AddFaq$1 = "Add FAQ";
var dgOrgFaqForm_EditFaq$1 = "Edit FAQ";
var dgOrgFaqForm_FaqAnswerPlaceholder$1 = "What is the answer?";
var dgOrgFaqForm_FaqContactInstructions$1 = "Questions submitted should be sent to this email address";
var dgOrgFaqForm_FaqContactLabel$1 = "FAQ Contact";
var dgOrgFaqForm_FaqContactPlaceholder$1 = "contact@company.com";
var dgOrgFaqForm_FaqInstructionsFormat$1 = "Changes made here will affect the {{orgName}} FAQ tab for your organization.";
var dgOrgFaqForm_FaqQuestionPlaceholder$1 = "What is the question?";
var dgOrgFaqForm_FaqValidationMessage$1 = "Whoops! Both question and answer are required.";
var dgOrgFaqForm_ManageOrgFaqFormat$1 = "Manage {{orgName}} FAQ";
var dgOrgEditMemberModal_RemoveUser$1 = "Remove User";
var dgNotificationPreference_IncludeInEmail$1 = "Include in this Email";
var dgNotificationPreference_SentTest$1 = "Send Test Email";
var dgNotificationMenu_NothingNew$1 = "No new notifications";
var dgNotificationMenu_Notifications$1 = "Notifications";
var dgNoSearchResults_CorrectSpelling$1 = "Make sure all words are spelled correctly.";
var dgNoSearchResults_DifferentKeywords$1 = "Try different keywords.";
var dgNoSearchResults_GeneralKeywords$1 = "Try more general keywords.";
var dgManagePathways_CloneFormat$1 = "Clone {{name}} Pathway";
var dgManagePathways_CreatePathway$1 = "Create a Pathway";
var dgManagePathways_Edit$1 = "Edit";
var dgManagePathways_MoreAuthorsFormat$1 = "+ {{count}} others";
var dgManagePathways_OneMoreAuthor$1 = "+ 1 other";
var dgManagePathways_SearchPlaceholder$1 = "Search by title or author";
var dgManagePathways_ViewFormat$1 = "View {{name}} Pathway";
var dgInviteAddPeople_Description$1 = "Connect with experts to discover what they are learning.";
var dgInviteAddPeople_Follow$1 = "Follow {{userName}}'s learning activities";
var dgInviteAddPeople_Learn$1 = "Learn with your colleagues";
var dgInviteAddPeople_StopFollowing$1 = "Stop following {{userName}}'s learning activities";
var dgInviteAddGroups_BecomeMember$1 = "Become a member of {{groupName}}";
var dgInviteAddGroups_Group$1 = "Group";
var dgInviteAddGroups_JoinGroup$1 = "Join Group";
var dgInviteAddGroups_JoinGroups$1 = "Join groups to share learning";
var dgInviteAddGroups_JoinGroupsDesc$1 = "Learning items that are shared in your groups will appear in your Feed, so you can see what your team members are working on and learn together";
var dgInviteAddGroups_LeaveGroup$1 = "Leave {{groupName}}";
var dgInviteAddCategories_FollowCategories$1 = "Follow Skills";
var dgInviteAddCategories_FollowCategoriesDesc$1 = "Following categories helps Degreed recommend content in the areas you want to grow. Choose from our suggestions or add your own.";
var dgInviteAddCategories_LearnPlaceholder$1 = "What would you like to learn?";
var dgIntegrationsCard_AlisonMessage$1 = "Import all courses from my Alison profile daily.";
var dgIntegrationsCard_CodecademyMessage$1 = "Import completed courses from Codecademy daily.";
var dgIntegrationsCard_CodeSchoolMessage$1 = "Import completed courses from Code School daily.";
var dgIntegrationsCard_Connect$1 = "Connect";
var dgIntegrationsCard_Connected$1 = "Connected";
var dgIntegrationsCard_Disconnect$1 = "Disconnect";
var dgIntegrationsCard_GoodreadsMessage$1 = "Import books from my Read shelf in Goodreads daily.";
var dgIntegrationsCard_GoogleplusMessage$1 = "Find your Google contacts on Degreed.";
var dgIntegrationsCard_ImportingMessage$1 = "Importing...";
var dgIntegrationsCard_KhanAcademyMessage$1 = "Import my completed videos and assessments from Khan Academy daily.";
var dgIntegrationsCard_LastSyncFailure$1 = "Failed to retrieve data. Check your settings.";
var dgIntegrationsCard_LastSyncFormat$1 = "Last imported {{date}}";
var dgIntegrationsCard_ManageSettings$1 = "Manage Settings";
var dgIntegrationsCard_PluralsightMessage$1 = "Import completed courses from Pluralsight daily.";
var dgIntegrationsCard_PocketMessage$1 = "Import articles from my Pocket Archive daily.";
var dgIntegrationsCard_SkillshareMessage$1 = "Import all courses from my Skillshare profile daily.";
var dgIntegrationsCard_SlackMessage$1 = "Get Today’s Learning and shared content delivered through slack.";
var dgIntegrationsCard_TreehouseMessage$1 = "Import completed courses from Treehouse daily.";
var dgIntegrationsCard_TwitterMessage$1 = "Share items from Degreed to your Twitter Followers";
var dgIntegrationsCard_UdemyMessage$1 = "Import all courses from my Udemy profile daily.";
var dgIntegrationsCard_ViewGoogleplusFriends$1 = "View Contacts";
var dgIntegrationsCard_ViewTwitterFriends$1 = "View Followers";
var dgInputTile_DueBy$1 = "Due by {{dueDate}}";
var dgInputTile_DueByFormat$1 = "Due by {{dueDate}}";
var dgInputStatistics_Commented$1 = "People who left takeaways";
var dgInputStatistics_CommentsCount$1 = "{{count}} Comments";
var dgInputStatistics_CompletedCount$1 = "{{count}} Completed";
var dgInputStatistics_LikesCount$1 = "{{count}} Likes";
var dgInputStatistics_PeopleWhoDisliked$1 = "People who disliked this";
var dgInputStatistics_PeopleWhoLiked$1 = "People who liked this";
var dgInputStatistics_PeopleWhoRated$1 = "People who rated this";
var dgInputStatistics_PeopleWhoViewed$1 = "People who viewed this";
var dgInputStatistics_SharesCount$1 = "{{count}} Shares";
var dgInputStatistics_SkillsCount$1 = "{{count}} Skills";
var dgInputStatistics_Tag$1 = "1 tag";
var dgInputStatistics_Tags$1 = "{{count}} skills";
var dgInputStatistics_TopCommenter$1 = "{{userName}} shared their takeaway";
var dgInputStatistics_TopCommenterAndOne$1 = "{{userName}} and {{countStartSpan}}1 other{{countEndSpan}} shared their takeaways";
var dgInputStatistics_TopCommenterCount$1 = "{{userName}} and {{countStartSpan}}{{userCount}} others{{countEndSpan}} shared their takeaways";
var dgInputStatistics_TopCompleter$1 = "{{userName}} completed this";
var dgInputStatistics_TopCompleterAndOne$1 = "{{userName}} and {{countStartSpan}}1 other{{countEndSpan}} completed this";
var dgInputStatistics_TopCompleterAndOneRead$1 = "{{userName}} and {{countStartSpan}}1 other{{countEndSpan}} read this";
var dgInputStatistics_TopCompleterAndOneWatched$1 = "{{userName}} and {{countStartSpan}}1 other{{countEndSpan}} watched this";
var dgInputStatistics_TopCompleterCount$1 = "{{userName}} and {{countStartSpan}}{{userCount}} others{{countEndSpan}} completed this";
var dgInputStatistics_TopCompleterCountRead$1 = "{{userName}} and {{countStartSpan}}{{userCount}} others{{countEndSpan}} read this";
var dgInputStatistics_TopCompleterCountWatched$1 = "{{userName}} and {{countStartSpan}}{{userCount}} others{{countEndSpan}} watched this";
var dgInputStatistics_TopCompleterRead$1 = "{{userName}} read this";
var dgInputStatistics_TopCompleterWatched$1 = "{{userName}} watched this";
var dgInputStatistics_TopFollower$1 = "{{userName}} followed this";
var dgInputStatistics_TopFollowerAndOne$1 = "{{userName}} and {{countStartSpan}}1 other{{countEndSpan}} followed this";
var dgInputStatistics_TopFollowerCount$1 = "{{userName}} and {{countStartSpan}}{{userCount}} others{{countEndSpan}} followed this";
var dgInputStatistics_TopRecommender$1 = "{{userName}} shared this";
var dgInputStatistics_TopRecommenderAndOne$1 = "{{userName}} and {{countStartSpan}}1 other{{countEndSpan}} shared this";
var dgInputStatistics_TopRecommenderCount$1 = "{{userName}} and {{countStartSpan}}{{userCount}} others{{countEndSpan}} shared this";
var dgInputStatistics_TopTakeawayAndOne$1 = "{{userName}} and {{countStartSpan}}1 other{{countEndSpan}} shared a takeaway";
var dgInputStatisticsHeader_TopCompleter$1 = "{{userName}} completed this {{inputType}}";
var dgInputStatisticsHeader_TopCompleterAndOne$1 = "{{userName}} and {{countStartSpan}}1 other{{countEndSpan}} completed this {{inputType}}";
var dgInputStatisticsHeader_TopCompleterCount$1 = "{{userName}} and {{countStartSpan}}{{userCount}} others{{countEndSpan}} completed this {{inputType}}";
var dgInputCountsByType_Points$1 = "points";
var dgImageUpload_BadgeFileTypeError$1 = "Invalid file type. We only accept PNG or SVG up to 5MB.";
var dgImageUpload_BrowseForImage$1 = "browse for an image";
var dgImageUpload_DragImageHere$1 = "Drag your image here";
var dgImageUpload_DropImage$1 = "Drag an image from your computer";
var dgImageUpload_FilesizeError$1 = "Image must be smaller than {{maxSize}}";
var dgImageUpload_FileTypes$1 = "Invalid image type. Image must be one of following: {{imageTypes}}";
var dgImageUpload_ImagePosition$1 = "Image Position";
var dgImageUpload_ImagePosition_HelperText$1 = "Select the position of the image to be above or below the text in the section.";
var dgImageUpload_ImagePreview$1 = "uploaded image preview";
var dgImageUpload_ImageTypesSize$1 = "JPG, PNG, or GIF";
var dgImageUpload_KB$1 = "{{fileSize}}KB";
var dgImageUpload_LimitedImageTypesSize$1 = "PNG or SVG";
var dgImageUpload_Or$1 = "or";
var dgImageUpload_PdfImageTypesSize$1 = "JPG, PNG, GIF, or PDF. 5 MB max.";
var dgImageUpload_RemoveImage$1 = "Remove Image";
var dgImageUpload_SectionDragAndDrop$1 = "Drag and drop or click to upload an image";
var dgImageUpload_SectionInvalidFileSize$1 = "File size is too big. Max size is {{fileSize}}MB.";
var dgImageUpload_SectionInvalidFileType$1 = "Invalid file type. We only accept JPEG, GIF, JPG, and PNG.";
var dgImageUpload_SectionInvalidFileTypeVar$1 = "Invalid file type. We only accept {{translatedFileTypes}}.";
var dgImageUpload_SectionRestrictions$1 = "JPEG, GIF, JPG, PNG up to 5MB";
var dgImageUpload_SectionRestrictionsVar$1 = "{{translatedFileTypes}} up to {{maxSize}}MB";
var dgImageUpload_UploadImage$1 = "Upload Image";
var dgImageEdit_Change$1 = "Change";
var dgImageEdit_ChangePhoto$1 = "change photo";
var dgImageEdit_ChooseFile$1 = "Choose File";
var dgImageEdit_ChooseFileToUpload$1 = "Choose a file to upload";
var dgImageEdit_ContentCard$1 = "Content Card";
var dgImageEdit_ContentDetails$1 = "Content Details";
var dgImageEdit_CropImage$1 = "Crop your image.";
var dgImageEdit_CropNote$1 = "Some images may be cropped additionally when displayed.";
var dgImageEdit_CropToFit$1 = "Crop your images to fit";
var dgImageEdit_DocumentationDesc$1 = "The preview above is how your image will display on the content card and more details view. Want to learn more? {{startAnchor}}View our image documentation{{endAnchor}}";
var dgImageEdit_DocumentationLabel$1 = "View our image documentation";
var dgImageEdit_DragPhoto$1 = "Drag a photo here";
var dgImageEdit_FilesizeError$1 = "Image must be smaller than {{maxSize}}";
var dgImageEdit_ImageDimensionsFormat$1 = "Images must be at least {{resolutionWidth}}px by {{resolutionHeight}}px to preserve quality";
var dgImageEdit_ImageTypes$1 = "Invalid image type. Image must be one of following: {{imageTypes}}";
var dgImageEdit_LookingGood$1 = "Looking Good!";
var dgImageEdit_NoImage$1 = "No image";
var dgImageEdit_SaveWithoutCropping$1 = "Save without cropping";
var dgImageEdit_SubmitImage$1 = "Submit Image";
var dgImageEdit_UploadImagePreview$1 = "uploaded image preview";
var dgGroupTile_JoinRequestPending$1 = "Request Pending";
var dgGroupTile_Leave$1 = "Leave";
var dgGroupTile_LeaveGroupModalBodyText$1 = "You will no longer receive group emails or items shared to the group.";
var dgGroupTile_LeaveGroupModalHeader$1 = "Are you sure you want to leave the group?";
var dgGroupTile_MemberCount$1 = "{{count}} members";
var dgGroupTile_RequestMembership$1 = "Request Membership";
var dgGroupsEdit_AddGroups$1 = "Add Groups";
var dgGroupsEdit_AddGroupsLabel$1 = "Enter the name of a group";
var dgGroupsEdit_AddGroupsToBoostTooltip$1 = "Adding groups helps you boost this in members of the group's global search results only.";
var dgGroupsEdit_AddGroupsTooltip$1 = "Adding groups helps you track and organize inputs.";
var dgGroupsEdit_RemoveGroupName$1 = "Remove {{groupName}}";
var dgGroupSecurity_AssignLearning$1 = "Assign Learning";
var dgGroupSecurity_AssignLearningDescription$1 = "Create content assignments for group members.";
var dgGroupSecurity_DefaultRoleDescription$1 = 'The default role for new members of this group is "Group {{roleName}}"';
var dgGroupSecurity_DeleteGroup$1 = "Delete Group";
var dgGroupSecurity_DeleteGroupDescription$1 = "Remove group from the organization.";
var dgGroupSecurity_EditPermissions$1 = "Edit Permissions";
var dgGroupSecurity_EditPermissionsDescription$1 = "Edit the group's default permissions.";
var dgGroupSecurity_EditSettings$1 = "Edit Settings";
var dgGroupSecurity_EditSettingsDescription$1 = "View and edit the group's settings.";
var dgGroupSecurity_GroupRoleHeader$1 = '"Group {{roleName}}" Role';
var dgGroupSecurity_InviteMembers$1 = "Invite Members";
var dgGroupSecurity_InviteMembersDescription$1 = "Invite new members to the group.";
var dgGroupSecurity_RecommendItems$1 = "Share";
var dgGroupSecurity_RecommendItemsDescription$1 = "Post to or share content with this group.";
var dgGroupSecurity_RecommendRatings$1 = "Share Skill Ratings";
var dgGroupSecurity_RecommendRatingsDescription$1 = "Share skill ratings with members of the group.";
var dgGroupSecurity_RemoveFeedItems$1 = "Remove Feed Items";
var dgGroupSecurity_RemoveFeedItemsDescription$1 = "Ability to remove any item from the group feed.";
var dgGroupSecurity_RemoveMembers$1 = "Remove Members";
var dgGroupSecurity_RemoveMembersDescription$1 = "Remove members from the group.";
var dgGroupSecurity_ViewGroupInsights$1 = "View Group Insights";
var dgGroupSecurity_ViewGroupInsightsDescription$1 = "View insights for this group.";
var dgGroupSecurity_ViewMembers$1 = "View Members";
var dgGroupSecurity_ViewMembersDescription$1 = "View a list of all group members.";
var dgGroupSecurity_ViewOrganizationReports$1 = "Download Reports";
var dgGroupSearch_PlaceHolder$1 = "Enter name of a group";
var dgGroupOverview_AdministrativeGroup$1 = "Administrative Group";
var dgGroupOverview_ClosedGroup$1 = "Closed Group";
var dgGroupOverview_DynamicAdminGroup$1 = "Dynamic Administrative Group";
var dgGroupOverview_GroupMembershipPending$1 = "Membership Pending";
var dgGroupOverview_JoinedGroup$1 = "Joined";
var dgGroupOverview_JoinThisGroup$1 = "Become a member of this group";
var dgGroupOverview_LeaveGroup$1 = "Leave Group";
var dgGroupOverview_MemberCountFormat$1 = "{{userCount}} members";
var dgGroupOverview_OpenGroup$1 = "Open Group";
var dgGroupOverview_PrivateGroup$1 = "Private Group";
var dgGroupOverview_RequestMembership$1 = "Request membership in this group";
var dgGroupOverview_Restricted$1 = "You have been assigned to this group by your organization. If you feel you shouldn't be in this group, contact your organization administrator.";
var dgGroupOverview_StaticAdminGroup$1 = "Static Administrative Group";
var dgGroupMembers_ActiveMembers$1 = "Active Members";
var dgGroupMembers_AddMember$1 = "Add Member";
var dgGroupMembers_AddPeople$1 = "Add people to group";
var dgGroupMembers_AddPeopleButton$1 = "Add people";
var dgGroupMembers_AddUsers$1 = "Add Users";
var dgGroupMembers_Admin$1 = "Admin";
var dgGroupMembers_CalculatingMembership$1 = "The membership list is being calculated.";
var dgGroupMembers_DateInvited$1 = "Date Invited";
var dgGroupMembers_DateJoined$1 = "Date Joined";
var dgGroupMembers_Invited$1 = "Invited";
var dgGroupMembers_InviteMembers$1 = "Invite Member";
var dgGroupMembers_LastActive$1 = "Last Active";
var dgGroupMembers_MemberSettings$1 = "Member settings";
var dgGroupMembers_NameHeader$1 = "Name";
var dgGroupMembers_NoActiveMemberMatch$1 = "No active members match your search";
var dgGroupMembers_NoDynamicMemberDescription$1 = "If this is a new group, the membership might be calculating.";
var dgGroupMembers_NoMatches$1 = "No members in this group match your search term";
var dgGroupMembers_NoMembers$1 = "There are currently no members";
var dgGroupMembers_NoPendingMembers$1 = "No pending members";
var dgGroupMembers_NoPendingRequests$1 = "No pending requests";
var dgGroupMembers_NoPermission$1 = "You do not have permission to view the member list.";
var dgGroupMembers_NoUsersMatch$1 = "There are no users that match the attributes for this group";
var dgGroupMembers_PendingApprovalHeader$1 = "Pending approval";
var dgGroupMembers_PendingInvitationFormat$1 = "{{memberCount}} pending invitations";
var dgGroupMembers_PendingInvitations$1 = "Pending Invitations";
var dgGroupMembers_PendingMemberSettings$1 = "Pending member settings";
var dgGroupMembers_PendingRequests$1 = "Pending Requests";
var dgGroupMembers_Points$1 = "Points";
var dgGroupMembers_PointsTooltip$1 = "Total points from completed content, not including experience";
var dgGroupMembers_Resend$1 = "Re-send";
var dgGroupMembers_ResendAll$1 = "Re-send All";
var dgGroupMembers_ResendInvites$1 = "Re-send invites";
var dgGroupMembers_SearchByName$1 = "Search by name";
var dgGroupMembers_SearchForMember$1 = "Search for a member";
var dgGroupMembers_SelectedCountFormat$1 = "({{checkedCount}}/{{pendingInviteCount}} selected)";
var dgGroupMembers_TotalMemberCountFormat$1 = "{{memberCount}} members";
var dgGroupInvite_groupInviteNotificationInviteFormat$1 = "{{personNameHtml}} invited you to the {{groupNameHtml}} group";
var dgGroupGoalsOverview_HowTo$1 = 'Create a goal by clicking "goals" and "create goal"';
var dgGroupGoals_CompleteAPathway$1 = "Complete a Pathway";
var dgGroupGoals_Completed$1 = "Completed";
var dgGroupGoals_CreateAGoal$1 = "Create a Goal";
var dgGroupGoals_CreateGoal$1 = "Create Goal";
var dgGroupGoals_CreateGoalSummary$1 = "Goals are a great way track your progress as you earn points in a category or work through a pathway.";
var dgGroupGoals_EarnMorePoints$1 = "Earn more Points in a Category";
var dgGroupGoals_HowTo$1 = "Create group goals by using the create goal button.";
var dgGroupGoals_NoGoals$1 = "You don't have any group goals created.";
var dgGroupGoalItem_ViewParticipants$1 = "View Participants";
var dgGroupDelete_DeleteGroupTitle$1 = "Delete Group";
var dgGroupDelete_DeleteLabelFormat$1 = 'Type "{{delete}}"';
var dgGroupDelete_DeleteLabelInfoFormat$1 = 'Type the word "{{delete}}"';
var dgGroupDelete_Instructions$1 = 'To delete this group, type "{{delete}}" into the field and press the "Delete Group" button.';
var dgGroupDelete_InstructionsFormat$1 = 'To delete this group, type "{{delete}}" into the field and press the "Delete Group" button.';
var dgGoalTitle_CompleteInputFormat$1 = "Complete {{htmlInputTitle}} {{inputType}}";
var dgGoalTitle_CompletePathwayFormat$1 = "Complete {{htmlPathwayTitle}} Pathway";
var dgGoalTitle_EarnPointsByTagFormat$1 = "Earn {{startStrong}}{{goalPoints}}{{endStrong}} more pts in {{anchorHtml}}";
var dgGoalItem_AssignedByFormat$1 = "Assigned {{startSpan}} by {{startAnchor}} {{goalCreatorName}}{{endAnchor}}{{endSpan}} to {{startAnchor2}}{{goalName}}{{endAnchor}}";
var dgGoalItem_GoalEndDateFormat$1 = "Due {{goalEndDate}}";
var dgGlobalSearch_A11ySearchDescription$1 = "Enter text and press enter or press down arrow key to select suggested items.";
var dgGlobalSearch_SearchExpandLabel$1 = "Expand Search";
var dgGlobalSearch_TopicsLabel$1 = "Your Skills";
var dgGlobalAddSuccess_CompletedToday$1 = "Completed Today";
var dgGlobalAddSuccess_Description$1 = "Every item you mark complete on Degreed is added to your profile collection, where you can find or share it later.";
var dgGlobalAddSuccess_ErrorWhenAdding$1 = "There was a problem. Please try adding to your profile again. If the problem persists please contact us so we can help.";
var dgGlobalAddSuccess_LearningItems$1 = "Learning Items";
var dgGlobalAddSuccess_Points$1 = "points";
var dgGlobalAddSuccess_RewardTrophy$1 = "Reward Trophy";
var dgGlobalAddSuccess_StartedYourCollection$1 = "You've started your collection!";
var dgGlobalAddSuccess_ViewYourCollection$1 = "View your collection";
var dgGlobalAdd_Achievement$1 = "Achievements";
var dgGlobalAdd_AchievementDescription$1 = "Demonstrate skill by documenting what you have achieved.";
var dgGlobalAdd_AddNewOutcomeTooltipFormat$1 = "Add a new {{newOutcome}} to your profile";
var dgGlobalAdd_Content$1 = "Add Content to Your Profile";
var dgGlobalAdd_CreateAPathway$1 = "Create a Pathway";
var dgGlobalAdd_Description$1 = "Add learning, experience, and coursework to your profile.";
var dgGlobalAdd_ExtensionsFormat$1 = "Browsing a lot across the web? Use the {{startAnchor}}Degreed button{{endAnchor}} to track your learning.";
var dgGlobalAdd_IntegrationsFormat$1 = "Connect to providers and import completed items to your profile with {{startAnchor}}integrations{{endAnchor}}.";
var dgGlobalAdd_OutcomeTypeFormat$1 = "You've added your maximum of {{outcomeLimit}} {{outcomeType}}s. You can edit or remove these from your collection.";
var dgGlobalAdd_Sections_Achievement$1 = "Achievement";
var dgGlobalAdd_Sections_Content$1 = "Content";
var dgGlobalAdd_Sections_Extensions$1 = "Browsing a lot across the web? Use the {{startAnchor}}Degreed button{{endAnchor}} to track your learning";
var dgGlobalAdd_TooltipFormat$1 = "Add a new {{inputType}} to your profile";
var dgFlexRow_AddLinkSection$1 = "Add Link Section";
var dgFlexRow_AddSection$1 = "Add Section";
var dgFlexRow_AddSectionSuccess$1 = "Section successfully added";
var dgFlexRow_AddTextAndImage$1 = "Add Text and Image Section";
var dgFlexRow_AddTextSection$1 = "Add Text Area";
var dgFlexRow_All$1 = "All";
var dgFlexRow_AllDescription$1 = "Showing all items with unlimited rows";
var dgFlexRow_Compact$1 = "Compact";
var dgFlexRow_CompactDescription$1 = "1 scrollable row with a link to view all";
var dgFlexRow_CustomErrors_RequiredMultiple$1 = "At least one field is required: Title, Text, or Image.";
var dgFlexRow_DeleteConfirmSubmit$1 = "Delete Section";
var dgFlexRow_DeleteSectionBody$1 = "Are you sure you want to delete {{sectionNameHtml}} section from this plan?";
var dgFlexRow_DeleteSectionPrompt$1 = "Are you sure you want to delete this {{type}} section?";
var dgFlexRow_DeleteSuccess$1 = "Section successfully deleted";
var dgFlexRow_EditDetails$1 = "Edit Details";
var dgFlexRow_EditLinkSection$1 = "Edit Link Section";
var dgFlexRow_EditSectionDescription$1 = "Description";
var dgFlexRow_EditSectionDescriptionPlaceholder$1 = "Add a Description";
var dgFlexRow_EditSectionDetails$1 = "Edit Section Details";
var dgFlexRow_EditSectionDisplayOptions$1 = "Display";
var dgFlexRow_EditSectionTitle$1 = "Title";
var dgFlexRow_EditSectionTitlePlaceholder$1 = "Add a Title";
var dgFlexRow_EditTextAndImage$1 = "Edit Text and Image Section";
var dgFlexRow_EditTextSection$1 = "Edit Text Area";
var dgFlexRow_Expanded$1 = "Expanded";
var dgFlexRow_ExpandedDescription$1 = "2 static rows with a link to view all";
var dgFlexRow_FieldRequired$1 = "This field is required";
var dgFlexRow_Link$1 = "Link";
var dgFlexRow_LinkDescription$1 = "Description";
var dgFlexRow_LinkSectionTitle$1 = "Title";
var dgFlexRow_LinkSectionTitleHelperText$1 = "This is the section title.";
var dgFlexRow_LinkTitle$1 = "Link Title";
var dgFlexRow_LinkTitleHelperText$1 = "This title will appear on the link button; we suggest keeping it short.";
var dgFlexRow_RemoveSection$1 = "Remove Section";
var dgFlexRow_ReorderItems$1 = "Reorder Items";
var dgFlexRow_ReorderSectionsTitle$1 = "Reorder Sections";
var dgFlexRow_ResourceAddedSuccess$1 = "Resources successfully added";
var dgFlexRow_ResourceRemovedSuccess$1 = "Resources successfully removed";
var dgFlexRow_SectionTypeLabelFormat$1 = "{{sectionType}} Section";
var dgFlexRow_ShowCompactDescription$1 = "Showing one row of items with a button to view all";
var dgFlexRow_TextTitle$1 = "Text";
var dgFlexRow_TextTitlePlaceholder$1 = "Add some extra information, context, etc.";
var dgFlexRow_UrlRequired$1 = "A valid URL is required (http://)";
var dgFlexRow_YesDeleteButton$1 = "Yes, delete";
var dgFlexMembers_FollowersFormat$1 = "{{followersCount}} Followers";
var dgFlexMembers_UpdatedDaily$1 = "Updated Daily";
var dgFileUploadButton_FileNameUnknown$1 = "file-name-unknown";
var dgFileUploadButton_FilesizeError$1 = "Sorry! Your file must be less than {{filesizeLimit}}";
var dgFileUploadButton_FiletypeError$1 = "Sorry! You can only upload {{filePattern}} type files";
var dgFileUploadButton_HelperInfo$1 = "Select a file ({{filePattern}}) up to {{filesizeLimit}} in size.";
var dgFileUploadButton_ImageUpload$1 = "Drag a file or click to choose";
var dgFileUploadButton_ProcessingFile$1 = "Processing file...";
var dgFileUploadButton_UploadComplete$1 = "Upload complete";
var dgFileUploadButton_UploadError$1 = "Upload error";
var dgFileUploadButton_UploadErrorMessage$1 = "Sorry! There was a problem with the upload process";
var dgFileUploadButton_UploadFile$1 = "Upload a file";
var dgFileUploadButton_Uploading$1 = "Uploading";
var dgFileUploadButton_ViewFileDocumentation$1 = "View our file documentation";
var dgFeed_AddSomething$1 = "Add something you learned...";
var dgFeed_AddTopCategories$1 = "Add top categories to your profile";
var dgFeed_CompletedCongrats$1 = "You completed Today's Learning. Your brain thanks you.";
var dgFeed_CompletedHeading$1 = "Completed Today";
var dgFeed_DismissTip$1 = "  Dismiss this tip";
var dgFeed_EmptyStateFormat$1 = "It's a bit quiet around here.{{break}}Follow {{pathwayLink}} and {{peopleLink}} to keep the recommendations coming.";
var dgFeed_EnrolledPathways$1 = "Enrolled Pathways";
var dgFeed_EnrollInPathway$1 = "Enroll in a pathway";
var dgFeed_FollowedPathways$1 = "Followed Pathways";
var dgFeed_FollowPathway$1 = "Follow a pathway";
var dgFeed_FollowUsers$1 = "Follow other Degreed users";
var dgFeed_KeepLearning$1 = "Keep Learning";
var dgFeed_Personalize$1 = "Personalize Today\xe2€™s Learning:";
var dgFeed_ShowAllAssignedFormat$1 = "Show all {{count}} assigned items";
var dgFeed_ViewAllYourPathways$1 = "View all your pathways";
var dgExtensions_AccessError$1 = "Something went wrong.";
var dgExtensions_AccessGranted$1 = "Access granted.";
var dgExtensions_AddBookmarkletManually$1 = "Add Bookmarklet Manually:";
var dgExtensions_AddCompletedCourses$1 = "Add completed courses to your Degreed profile.";
var dgExtensions_AddCompletedItems$1 = "Add completed items to your collection";
var dgExtensions_AddToChrome$1 = "Add to Chrome";
var dgExtensions_AddToCollection$1 = "Add completed items to your collection";
var dgExtensions_AdminFlexEd$1 = "Administer FlexEd Cards for your organization";
var dgExtensions_AppsUnavailable$1 = "The Degreed browser apps are currently unavailable for your organization.";
var dgExtensions_Bookmarklet$1 = "bookmarklet";
var dgExtensions_BookmarkletDragInstructions$1 = "Drag me to the bookmarks bar";
var dgExtensions_Bookmarks$1 = "bookmarks";
var dgExtensions_BrowserBookmarklet$1 = "Browser Bookmarklet";
var dgExtensions_BrowserWindowIllustrationAlt$1 = "illustration of a browser window with the degreed bookmarklet installed";
var dgExtensions_ButtonSuccess$1 = "You can start using the Degreed Button now.";
var dgExtensions_Chrome$1 = "Chrome";
var dgExtensions_ChromeExtension$1 = "Chrome Extension";
var dgExtensions_ChromeInstructionsFormat$1 = "clicking {{strongTagStart}}View > Always Show Bookmarks Bar{{strongTagEnd}}";
var dgExtensions_CopyBookmark$1 = "Copy Bookmark URL";
var dgExtensions_CreatePathways$1 = "Create pathways";
var dgExtensions_DegreedExtension$1 = "Degreed Extension";
var dgExtensions_DisplayFavoritesFormat$1 = "*Display your {{favType}} by {{instruction}}";
var dgExtensions_DragToInstallBookmarks$1 = "Drag this to your browser's Bookmarks Bar.*";
var dgExtensions_DragToInstallFavorites$1 = 'Drag this to your browser\'s Favorites Bar,*<br>or right-click the button and select "Add to favorites&hellip;"';
var dgExtensions_EmailAddressPlaceholder$1 = "youremail@company.com";
var dgExtensions_Extension$1 = "extension";
var dgExtensions_ExtensionInstalledAlt$1 = "illustration of a Chrome window with the degreed extension installed";
var dgExtensions_Favorites$1 = "favorites";
var dgExtensions_Firefox$1 = "Firefox";
var dgExtensions_FirefoxInstructionsFormat$1 = "clicking {{strongTagStart}}View > Toolbars > Bookmarks Toolbar{{strongTagEnd}}";
var dgExtensions_GetStarted$1 = "Hi there! Tell us your work email address so we can look you up in our system to get you started.";
var dgExtensions_GrantAccess$1 = "Grant access";
var dgExtensions_GrantAccessHeader$1 = "Grant access?";
var dgExtensions_IEInstructionsFormat$1 = "{{strongTagStart}}Right-clicking the empty space above the address bar > Favorites bar{{strongTagEnd}}";
var dgExtensions_InternetExplorer$1 = "Internet Explorer";
var dgExtensions_InvalidEmailError$1 = "Please enter a valid email address.";
var dgExtensions_iOS$1 = "iOS";
var dgExtensions_ItemsToPlans$1 = "Add items to your pathways and plans";
var dgExtensions_MakeChanges$1 = "Make changes to your account via the mobile application";
var dgExtensions_ManualBookmarkInstructions$1 = 'Bookmark link copied. Create a new bookmark in your browser manually using the name "+ Degreed" and paste the copied URL in the URL field of the browser\'s bookmark dialog and save your new bookmarklet.';
var dgExtensions_Mobile$1 = "Mobile";
var dgExtensions_Oauth_Authorize$1 = "The Degreed Extension";
var dgExtensions_Oauth_Request_Access$1 = "The Degreed Extension is requesting access to use your Degreed account to:";
var dgExtensions_PlusDegreedButton$1 = "+ Degreed";
var dgExtensions_RequestAccess$1 = "is requesting access to use your Degreed account to:";
var dgExtensions_Safari$1 = "Safari";
var dgExtensions_SafariInstructionsFormat$1 = "clicking {{strongTagStart}}View > Show Favorites Bar{{strongTagEnd}}";
var dgExtensions_SaveItemsForLater$1 = "Save items for later";
var dgExtensions_ShareItems$1 = "Share items with others";
var dgExtensions_SummaryEdge$1 = "Contact the Degreed administrator in your organization if you are interested in installing the Degreed Extension for Edge, or install it on another supported browser: Chrome, IE, Safari, or Firefox.";
var dgExtensions_SummaryFormat$1 = "This {{type}} allows you to easily track your learning from any website you visit. It's a convenient way to access features you would normally only find in Degreed.";
var dgExtensions_TitleEdge$1 = "The Degreed Button requires IT deployment for the Edge browser";
var dgExtensions_TitleFormat$1 = "All your favorite features of Degreed right from {{browser}}.";
var dgExtensions_TryOurBookmarklet$1 = "Try our Bookmarklet.";
var dgExtensions_UnableToDownload$1 = "Unable to download extensions?";
var dgExtensions_WishGrantAccess$1 = "Do you wish to grant access?";
var dgExtensions_YourBrowser$1 = "your browser";
var dgEnrolled_CompletedTooltipFormat$1 = "{{completedCount}} of {{totalCount}} items complete";
var dgEnrolled_DateAddedColumn$1 = "Date Added";
var dgEnrolled_EnrolledCountFormat$1 = "{{count}} Enrolled";
var dgEnrolled_EnrollmentDate$1 = "Enrollment Date";
var dgEnrolled_NameColumn$1 = "Name";
var dgDownloadableReports_ChooseGroup$1 = "Choose group";
var dgDownloadableReports_ChooseReportType$1 = "Choose report type";
var dgDownloadableReports_DataSet$1 = "Data Set";
var dgDownloadableReports_DateCreated$1 = "Date Created";
var dgDownloadableReports_datePickerText$1 = "The calendar filter does not interact with the Skill Reports.\nAny date selected will only apply to Content and Search reports.";
var dgDownloadableReports_DateRange$1 = "Date Range";
var dgDownloadableReports_Download$1 = "Download";
var dgDownloadableReports_DownloadableReports$1 = "Downloadable Reports";
var dgDownloadableReports_DownloadReport$1 = "Download Report";
var dgDownloadableReports_Generate$1 = "Generate";
var dgDownloadableReports_GenerateDataReport$1 = "Generate data report";
var dgDownloadableReports_GenerateReport$1 = "Generate Report";
var dgDownloadableReports_Generating$1 = "Generating";
var dgDownloadableReports_GroupOptionalTitle$1 = "Group (Optional)";
var dgDownloadableReports_GroupTitle$1 = "Group";
var dgDownloadableReports_MaxDaysReached$1 = "Please select no more than 93 days.";
var dgDownloadableReports_NoAvailableGroups$1 = "No Groups Available";
var dgDownloadableReports_NoMatchingReportTypes$1 = "No matching report types found";
var dgDownloadableReports_Parameters_InputIdentifier_Name$1 = "Content";
var dgDownloadableReports_Parameters_InputIdentifier_Placeholder$1 = "Choose a content item";
var dgDownloadableReports_Parameters_InputIdentifierList_Name$1 = "Content (Multiple)";
var dgDownloadableReports_Parameters_InputIdentifierList_Placeholder$1 = "Choose one or more content items";
var dgDownloadableReports_Report10$1 = "Content Trends - Completed";
var dgDownloadableReports_Report11$1 = "Content Trends - Viewed";
var dgDownloadableReports_Report12$1 = "Top Providers";
var dgDownloadableReports_Report13$1 = "Popular Topics";
var dgDownloadableReports_Report14$1 = "Top Searches";
var dgDownloadableReports_Report3$1 = "Content Completed";
var dgDownloadableReports_Report4$1 = "Content Viewed";
var dgDownloadableReports_Report5$1 = "Content Use By Provider";
var dgDownloadableReports_Report6$1 = "Completed Content By Topics";
var dgDownloadableReports_Report7$1 = "Search Terms";
var dgDownloadableReports_Report8$1 = "Top Providers";
var dgDownloadableReports_Report9$1 = "Popular Topics";
var dgDownloadableReports_ReportContentCompletionsDownload$1 = "Content Completions";
var dgDownloadableReports_ReportContentTrendsAdded$1 = "Completed Content";
var dgDownloadableReports_ReportContentTrendsViewed$1 = "Content Viewed";
var dgDownloadableReports_ReportDate$1 = "Reports contain data from {{startDate}} to {{endDate}}";
var dgDownloadableReports_ReportGenerated$1 = "Date Range";
var dgDownloadableReports_ReportPathwayDetailsDownload$1 = "Pathway Details";
var dgDownloadableReports_ReportPopularTopics$1 = "Content Added By Skill";
var dgDownloadableReports_ReportSkillAnalyticsTop1000SkillsRated$1 = "Skill Analytics Top 1000 Skills Rated";
var dgDownloadableReports_ReportSkillReport$1 = "Skill Report";
var dgDownloadableReports_ReportTop1000SkillsRated$1 = "Top 1000 Skills Rated";
var dgDownloadableReports_ReportTopProviders$1 = "Content Added By Provider";
var dgDownloadableReports_ReportTopSearches$1 = "Search Terms";
var dgDownloadableReports_ReportType$1 = "Report Type";
var dgDownloadableReports_ReportTypeRequired$1 = "Report type is required";
var dgDownloadableReports_ToastMessage$1 = "The report you requested is being generated. We’ll let you know when it’s ready to download.";
var dgDiscipline_ExpertsFormat$1 = "Lead Experts: {{experts}}";
var dgDiscipline_StartApplication$1 = "Start Application";
var dgCredPrePayLogin_DegreedAccount$1 = "Degreed account";
var dgCredPrePayLogin_LoginContinue$1 = "To continue, please log in to your existing Degreed account or choose a password to create a new Degreed account.";
var dgCredentialDisplay_StartDateFormat$1 = "Started {{date}}";
var dgCredentialDisplay_ViewApplicationFormat$1 = "View {{name}} Application";
var dgCopyLink_CopyInviteLink$1 = "Copy Invite Link";
var dgCopyLink_CopyLink$1 = "Copy Link";
var dgCopyLink_InviteURL$1 = "Invite URL";
var dgCookieBanner_accept$1 = "Got It!";
var dgCookieBanner_learnMore$1 = "Learn more.";
var dgCookieBanner_message$1 = 'We use cookies to improve your experience. Visit <a class="link underline" href="/api/about/cookienotice">Cookies</a> to learn more about our policy.';
var dgCookieBanner_message_V2$1 = 'Degreed uses essential cookies to improve your experience. Visit our Cookies to learn more about the cookies on Degreed <a class="link underline" href="/api/about/cookienotice">Learn More</a>';
var dgContentTile_AuthorshipAuthor$1 = "Author";
var dgContentTile_AuthorshipCreator$1 = "Creator";
var dgContentTile_AuthorshipPresenter$1 = "Presenter";
var dgContentTile_AuthorshipTeacher$1 = "Teacher";
var dgContentTile_Verified$1 = "VERIFIED";
var dgContentHosting_DragAndDrop$1 = "Drag and drop or click to upload a file";
var dgContentHosting_Hosted$1 = "Hosted";
var dgContentHosting_HostedFiles$1 = "Hosted Files";
var dgContentHosting_InvalidFileType$1 = "Invalid file type. See our {{startAnchor}}knowledge center{{endAnchor}} for list of supported types.";
var dgContentHosting_OrgStorageLimitAlmostReached$1 = "Your organization has {{ startBoldTag }} {{ orgStorageRemainingInMB }} MB {{ endBoldTag }} file storage left of its {{ orgStorageLimitInMB }} MB capacity.";
var dgContentHosting_OrgStorageLimitIsReached$1 = "Your organization has used all of its {{ orgStorageLimitInMB }} MB capacity.";
var dgContentCard_AssignedByFormat$1 = "{{nameHtml}} assigned you this {{inputType}} to complete by {{date}}";
var dgContentCard_CompleteByDateFormat$1 = "Complete this by {{dateHtml}}";
var dgContentCard_FromJobRoleFormat$1 = "Because you follow the {{jobRoleHtml}} plan";
var dgContentCard_FromPathwaysFormat$1 = "From the pathway {{pathwayHtml}}";
var dgContentCard_LibraryContent$1 = "You might like this.";
var dgContentCard_MoreLikeThisCompletedFormat$1 = "Because you completed {{inputHtml}}";
var dgContentCard_MoreLikeThisReadFormat$1 = "Because you read {{inputHtml}}";
var dgContentCard_MoreLikeThisWatchedFormat$1 = "Because you watched {{inputHtml}}";
var dgContentCard_Opportunity$1 = "New matched opportunity";
var dgContentCard_PopularCompletedFormat$1 = "Members of your groups completed this {{inputType}}";
var dgContentCard_PopularInFormat$1 = "Popular in {{groupHtml}} group";
var dgContentCard_PopularReadFormat$1 = "Members of your groups read this {{inputType}}";
var dgContentCard_PopularWatchedFormat$1 = "Members of your groups watched this {{inputType}}";
var dgContentCard_ReadByFormat$1 = "Recently read by {{nameHtml}}";
var dgContentCard_ReadMore$1 = "read more";
var dgContentCard_RecommendedByFormat$1 = "Shared by {{nameHtml}}";
var dgContentCard_RequiredLearning$1 = "Required Learning";
var dgContentCard_RequiredLearningDate$1 = "Required learning due {{dateHtml}}";
var dgContentCard_SavedForLater$1 = "Saved for Later";
var dgContentCard_WatchedByFormat$1 = "Recently watched by {{nameHtml}}";
var dgCompleteViewedTip_ThanksPluralFormat$1 = '<strong>Yay! Congratulations!</strong> You just earned {{pointsEarned}} points by completing these {{completedCount}} items. You can find them again later in <a href="/me?p=1#/overview" class="link">your collection</a>.';
var dgCompleteViewedTip_ThanksSingularFormat$1 = '<strong>Yay! Congratulations!</strong> You just earned {{pointsEarned}} points by completing an item. You can now find this item later in <a href="/me?p=1#/overview" class="link">your collection</a>.';
var dgComments_AddAReply$1 = "Add a reply";
var dgComments_ShareSomethingAbout$1 = "Share something about this";
var dgComments_WhatDidYouLearnFormat$1 = "What did you learn from this?";
var dgComment_CollapseCommentsFormat$1 = "Collapse {{count}} replies";
var dgComment_CollapseOneComment$1 = "Collapse 1 reply";
var dgComment_CommentHidden$1 = "This comment is hidden (inappropriate)";
var dgComment_DeleteConfirm$1 = "Yes, I'm Sure";
var dgComment_DeleteTakeaway$1 = "Are you sure you would like to delete this?";
var dgComment_DeleteTakeawayReplies$1 = "Are you sure you would like to delete this and its replies?";
var dgComment_Edited$1 = " (edited)";
var dgComment_HideComments$1 = "Hide comments";
var dgComment_JustNow$1 = "just now";
var dgComment_PlusReadMore$1 = "+ Read more";
var dgComment_ReplyHidden$1 = "This reply is hidden (inappropriate)";
var dgComment_ShowComments$1 = "Show comments ({{count}})";
var dgComment_ShowCommentsFormat$1 = "Show {{count}} replies";
var dgComment_ShowMoreCommentsFormat$1 = "Show {{count}} more";
var dgComment_ShowMultiplePreviousRepliesFormat$1 = "Show {{count}} previous replies";
var dgComment_ShowOneComment$1 = "Show 1 reply";
var dgComment_ShowPreviousReplies$1 = "Show previous replies";
var dgComment_ShowTakeawaysFormat$1 = "Show {{count}} takeaways";
var dgComment_ViewConversation$1 = "Takeaways";
var dgComment_ViewMoreFormat$1 = "View {{count}} more...";
var dgCombobox_SubmitSelection$1 = "Hit enter to submit your selection";
var dgColorpickerTextDarkness_DarkText$1 = "Dark text";
var dgColorpickerTextDarkness_LightText$1 = "Light text";
var dgCarousel_ShowNextItems$1 = "Show next items";
var dgCarousel_ShowPreviousItems$1 = "Show previous items";
var dgBrowseProviders_LaunchFormat$1 = "Visit {{icon}}";
var dgBrowseProviders_Search$1 = "Search";
var dgBrowseProviders_SearchResourcesFormat$1 = "Search for {{siteName}} content";
var dgBrowseProviders_VisitSiteFormat$1 = "Visit {{siteName}} Site";
var dgBrowsePathways_NoPathways$1 = "We could not find any pathways in the selected catalog.";
var dgBrowsePathways_NoRecommendations$1 = "We could not find any shared pathways.";
var dgBrowseFeaturedLearning_FromPathwayFormat$1 = "From the pathway {{pathwayName}}";
var dgBrowseFeaturedLearning_PopularGroupFormat$1 = "Popular in {{groupName}} group";
var dgBrowseFeaturedLearning_ReadByFormat$1 = "Recently read by {{user}}";
var dgBrowseFeaturedLearning_RecommendedByFormat$1 = "Shared by {{recommender}}";
var dgBrowseFeaturedLearning_SavedForLater$1 = "Saved for Later";
var dgBrowseFeaturedLearning_WatchedByFormat$1 = "Recently watched by {{user}}";
var dgAuthorVideo_CameraNotAuthorizedError$1 = "Camera not authorized. Please check your media permission settings.";
var dgAuthorVideo_CameraNotFoundError$1 = "Camera not found. Please check your device hardware and permissions.";
var dgAuthorVideo_CameraNotReadableError$1 = "Could not start video source.  Camera may already be in use.";
var dgAuthorVideo_ConfirmRedoRecording$1 = "Are you sure you want to redo your recording? Your current recording will get lost.";
var dgAuthorVideo_ModalTitle$1 = "Video Authoring";
var dgAuthorVideo_playerError$1 = "Your browser is unable to play this media clip.";
var dgAuthorVideo_ProcessingVideo$1 = "Processing video...";
var dgAuthorVideo_recorderError$1 = "This browser does not support video recording. You can upload a video with this browser, or record in Firefox or Google Chrome.";
var dgAuthorVideo_RecordVideoOnlyError$1 = "This browser does not support video recording. You can record in Firefox or Google Chrome.";
var dgAuthorVideo_Redirecting$1 = "Redirecting...";
var dgAuthorVideo_RedoRecording$1 = "Redo Recording";
var dgAuthorVideo_StartRecording$1 = "Start Recording";
var dgAuthorVideo_StopRecording$1 = "Stop Recording";
var dgAuthorVideo_TimeInMinutes$1 = "{{timeInMinutes}} minutes";
var dgAuthorVideo_TimeLimitReached$1 = "Time limit reached!";
var dgAuthorVideo_TimeWarningFormat$1 = "{{timeRemaining}} minutes left!";
var dgAuthorVideo_TryAgain$1 = "Try again";
var dgAuthorVideo_UploadError$1 = "Upload error";
var dgAuthorVideo_UploadErrorMessage$1 = "Sorry! There was a problem with the upload process";
var dgAuthorVideo_Uploading$1 = "Uploading";
var DgAssistant_ErrorText$1 = "There is an error connecting to the server. Please try again later.";
var DgAssistant_Executive_Description$1 = "Invest in yourself, improve leadership and management performance and inspire your team";
var DgAssistant_Executive_Title$1 = "Executive Coach";
var DgAssistant_LatestFrom$1 = "LATEST FROM";
var DgAssistant_Name$1 = "Degreed Assistant";
var DgAssistant_NoteText$1 = "Note";
var DgAssistant_NotificationText$1 = "This is an early access system. We are constantly working to improve the responsiveness and overall experience";
var DgAssistant_PlaceholderProcessing$1 = "Please wait...";
var DgAssistant_PlaceholderReady$1 = "Type a reply...";
var DgAssistant_PlaceholderStart$1 = "Message Degreed Assistant...";
var DgAssistant_SelectedJourneyText$1 = "You have selected '{{item}}'";
var DgAssistant_ShowLessText$1 = "See less";
var DgAssistant_ShowMoreText$1 = "See more";
var DgAssistant_StartNewText$1 = "Start a New Chat";
var DgAssistant_WelcomeText$1 = "What can I help you with today?";
var DgAssistant_YouText$1 = "You";
var dgAssignmentsOverview_AssignedGroupFormat$1 = "{{personName}} assigned {{groupName}} this {{contentType}} to {{contentAction}} {{hasDateHtml}}by {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_AssignedSingleFormat$1 = "{{personName}} assigned you this {{contentType}} to {{contentAction}} {{hasDateHtml}}by {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_AssignmentAbout$1 = "At this time, you don't have any learning assigned to you.";
var dgAssignmentsOverview_AssignmentEmptyTitle$1 = "No Results";
var dgAssignmentsOverview_AssignmentsDescription$1 = "Required assignments must be completed. They come from an external source and completions will be verified with their external source. Other assignments will show if they have been shared and assigned to you directly or to a group you are in.";
var dgAssignmentsOverview_AssignmentSearchPlaceholder$1 = "Filter for Assignments";
var dgAssignmentsOverview_AssignmentsTableDescription$1 = "Some assignments come from an external source and completions will be verified with their external source. Other assignments will show if they have been shared and assigned to you directly or to a group you are in.";
var dgAssignmentsOverview_CaughtUp$1 = "\uD83C\uDF89 You are all caught up!";
var dgAssignmentsOverview_Completed$1 = "Completed";
var dgAssignmentsOverview_CompletedAssignmentsEmpty$1 = "You have no completed assignments";
var dgAssignmentsOverview_CountDueSoon$1 = "{{count}} Due Soon";
var dgAssignmentsOverview_CountOverdue$1 = "{{count}} Overdue";
var dgAssignmentsOverview_Description$1 = "Assignments that are assigned to you or to a group you are in";
var dgAssignmentsOverview_DueDate$1 = "Due {{date}}";
var dgAssignmentsOverview_DueSoon$1 = "Due Soon";
var dgAssignmentsOverview_EmptyBody$1 = "Assignments and required learning will show up here to complete by a specified due date.";
var dgAssignmentsOverview_EmptyCompletedText$1 = "Completed assignments will show here";
var dgAssignmentsOverview_EmptyCompletedTitle$1 = "No completed assignments";
var dgAssignmentsOverview_EmptyHeader$1 = "You do not have any assignments.";
var dgAssignmentsOverview_EmptyToDoText$1 = "Your assignments will show here";
var dgAssignmentsOverview_Incomplete$1 = "Due Later";
var dgAssignmentsOverview_NextDueDate$1 = "Next due {{date}}";
var dgAssignmentsOverview_NoAssignments$1 = "You have no assignments";
var dgAssignmentsOverview_NoAssignmentsBody$1 = "Any required or assigned learning will show here.";
var dgAssignmentsOverview_NoAssignmentsHeader$1 = "No Assignments";
var dgAssignmentsOverview_NoAssignmentsHelpText$1 = "Assignments you receive will be shown here.";
var dgAssignmentsOverview_NoCompletedAssignments$1 = "No Completed Assignments";
var dgAssignmentsOverview_NoInProgressAssignments$1 = "No Assignments In Progress";
var dgAssignmentsOverview_OtherAssignmentsBody$1 = "Assignments will show here if they have been shared and assigned to you directly or to a group you are in.";
var dgAssignmentsOverview_OtherAssignmentsEmpty$1 = "You have no other assignments";
var dgAssignmentsOverview_OtherAssignmentsHeader$1 = "Other Assignments";
var dgAssignmentsOverview_Overdue$1 = "Overdue";
var dgAssignmentsOverview_OverdueAndDueSoon$1 = "Overdue & Due Soon";
var dgAssignmentsOverview_RequiredAssignmentsBody$1 = "These assignments must be completed. They come from an external source and completions will be verified with their external source.";
var dgAssignmentsOverview_RequiredAssignmentsEmpty$1 = "You have no required assignments";
var dgAssignmentsOverview_RequiredAssignmentsHeader$1 = "Required Assignments";
var dgAssignmentsOverview_RequiredGroupAttendedFormat$1 = "{{groupNameHtml}} is required to attend this{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_RequiredGroupCompletedFormat$1 = "{{groupNameHtml}} is required to complete this{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_RequiredGroupFollowedFormat$1 = "{{groupNameHtml}} is required to follow this{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_RequiredGroupFormat$1 = "{{groupName}} is required to {{contentAction}} this {{contentType}} {{hasDateHtml}}by {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_RequiredGroupReadFormat$1 = "{{groupNameHtml}} is required to read this{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_RequiredGroupWatchedFormat$1 = "{{groupNameHtml}} is required to watch this{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_RequiredSingleAlreadyCompletedFormat$1 = "You were required to complete this{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_RequiredSingleAttendedFormat$1 = "You are required to attend this{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_RequiredSingleAttendedOverdueFormat$1 = "You were required to attend this{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_RequiredSingleCompletedFormat$1 = "You are required to complete this{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_RequiredSingleCompletedOverdueFormat$1 = "You were required to complete this{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_RequiredSingleFollowedFormat$1 = "You are required to follow this{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_RequiredSingleFollowedOverdueFormat$1 = "You were required to follow this{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_RequiredSingleFormat$1 = "You are required to {{contentAction}} this {{contentType}} {{hasDateHtml}}by {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_RequiredSingleOverdueFormat$1 = "You were required to {{contentAction}} this {{contentType}} {{hasDateHtml}}by {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_RequiredSingleReadFormat$1 = "You are required to read this{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_RequiredSingleReadOverdueFormat$1 = "You were required to read this{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_RequiredSingleWatchedFormat$1 = "You are required to watch this{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_RequiredSingleWatchedOverdueFormat$1 = "You were required to watch this{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_ThirdPartyCompletedDate$1 = "Completed{{hasCompletedDateHtml}} {{completedDate}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_YourAssignments$1 = "Your Assignments";
var dgAddItems_AddItem$1 = "+Add";
var dgAddItems_EmailDomainError$1 = "Email doesn't match domains listed above";
var dgAddItems_EmailExistsError$1 = "Email address has already been added";
var dgAddItems_InvalidEmailError$1 = "Invalid email address";
var dgAddItems_MoreFormat$1 = "+ {{count}} more";
var dgActivityDetails_GoalActionFormat$1 = "{{user}} {{action}} the goal {{goalName}}";
var dgActivityDetails_GroupActivityAdd$1 = "{{user}} added the group {{settings}}";
var dgActivityDetails_GroupActivityRemove$1 = "{{user}} removed the group {{settings}}";
var dgActivityDetails_GroupActivityUpdate$1 = "{{user}} updated the group {{settings}}";
var dgActivityDetails_InputActionAdded$1 = "{{user}} added the following {{input}} {{date}}";
var dgActivityDetails_InputActionArticle$1 = "{{user}} read an article {{date}}";
var dgActivityDetails_InputActionBook$1 = "{{user}} read a book {{date}}";
var dgActivityDetails_InputActionCourse$1 = "{{user}} completed a course {{date}}";
var dgActivityDetails_InputActionEpisode$1 = "{{user}} completed an audio item {{date}}";
var dgActivityDetails_InputActionEvent$1 = "{{user}} attended an event {{date}}";
var dgActivityDetails_InputActionTask$1 = "{{user}} completed a task {{date}}";
var dgActivityDetails_InputActionVideo$1 = "{{user}} watched a video {{date}}";
var dgActivityDetails_PostedFormat$1 = "{{user}} posted <span class='color-shuttle_a zeta'>{{timeAgo}}</span>";
var dgActivityDetails_RemoveActivity$1 = "Are you sure you want to remove this from the group feed?";
var dgActivityDetails_RemoveConfirm$1 = "Yes, I'm Sure";
var dgActivityDetails_UserActionDateFormat$1 = "{{user}} {{action}} the {{input}} {{date}}";
var dgActivityDetails_UserActionFormat$1 = "{{user}} {{action}} the {{input}}";
var dgActivityDetails_UserActionItemTitleDateFormat$1 = "{{user}} {{action}} the following {{input}} {{title}} {{date}}";
var dgActivityDetails_UserActionItemTitleFormat$1 = "{{user}} {{action}} the following {{input}} {{title}}";
var dgActivityDetails_UserActionTheFollowingDateFormat$1 = "{{user}} shared this {{date}}";
var dgActivityDetails_UserActionTheFollowingDueDateFormat$1 = "{{user}} shared the following {{input}} {{date}} due {{dueDate}}";
var dgActivityDetails_UserActionTheFollowingFormat$1 = "{{user}} {{action}} the following {{input}}";
var dgActivityDetails_UserAddedNewUserFormat$1 = "{{user}} added {{newUser}} to the group.";
var dgActivityDetails_UserAssignedTheFollowingDateFormat$1 = "{{user}} assigned this {{assignedDate}} to be completed by {{dueDate}}";
var dgActivityDetails_UserAssignedTheFollowingFormat$1 = "{{user}} assigned this {{assignedDate}}";
var dgActivityDetails_UserJoinedGroupFormat$1 = "{{user}} joined the group.";
var dgActivityDetails_UserLeftGroupFormat$1 = "{{user}} left the group.";
var dgActivityDetails_UserPostedAgoFormat$1 = "{{user}} posted <span class='color-shuttle_a zeta'>{{timeAgo}}</span>";
var dgActivityDetails_UserPostedFormat$1 = "{{user}} posted";
var dgActivityDetails_UserRemovedUserFormat$1 = "{{user}} removed {{otherUser}} from the group.";
var dgActiveUserChartCtrl_A11yTooltipFormatDateRange$1 = "from {{startDate}} to {{endDate}}";
var dgActiveUserChartCtrl_ActiveUsers$1 = "Active Users";
var dgActiveUserChartCtrl_ActiveUsersToolTip$1 = "An active user is someone who has logged in at least once during the time periods on the x-axis.";
var dgActiveUserChartCtrl_DailyActiveUsers$1 = "Daily Active Users";
var dgActiveUserChartCtrl_Date$1 = "Date";
var dgActiveUserChartCtrl_MonthlyActiveUsers$1 = "Monthly Active Users";
var dgActiveUserChartCtrl_NewReturningUsers$1 = "New & Returning Users";
var dgActiveUserChartCtrl_NewUsers$1 = "New Users";
var dgActiveUserChartCtrl_NewUsersToolTip$1 = "New Users logged in for their first active session during this time period.";
var dgActiveUserChartCtrl_ReturningUsers$1 = "Returning Users";
var dgActiveUserChartCtrl_ReturningUsersToolTip$1 = "Returning Users logged in before this time period and had another active session during this time.";
var dgActiveUserChartCtrl_SelectUserType$1 = "Select User Type";
var dgActiveUserChartCtrl_WeeklyActiveUsers$1 = "Weekly Active Users";
var deleteModal_Cancel$1 = "Cancel";
var deleteModal_Delete$1 = "Delete";
var DegreeFormCtrl_CollegeName$1 = "A university or college name is required.";
var DegreeFormCtrl_CompletionDate$1 = "Please specify the completion date.";
var DegreeFormCtrl_DegreeLevel$1 = "A degree level is required.";
var DegreeFormCtrl_DegreeTitle$1 = "A degree title is required.";
var DegreeFormCtrl_FieldOfStudy$1 = "A field of study is required when adding courses.";
var DegreeFormCtrl_GradePointAvg$1 = "Please enter a valid grade point average.";
var DataPrivacyModalCtrl_AcceptContinue$1 = "Accept & Continue";
var DataPrivacyModalCtrl_Header$1 = "Data Privacy Policy";
var DataPrivacyModalCtrl_PolicyAcceptLabel$1 = "I confirm that I have read and understood this privacy notice";
var DataPrivacyModalCtrl_PolicyLegal$1 = "";
var DataPrivacyModalCtrl_PolicyReviewLabel$1 = "Please review and accept the following policy to use Degreed";
var DashboardNav_AddFocusSkills$1 = "Add Focus Skills";
var DashboardNav_AddSkill$1 = "Add Skill";
var DashboardNav_AddSkillRating$1 = "Add Skill Rating";
var DashboardNav_AllActivity$1 = "All activity";
var DashboardNav_AllInsights$1 = "All Insights";
var DashboardNav_Assignments$1 = "Assignments";
var DashboardNav_CertificationInProgress$1 = "Certification in progress";
var DashboardNav_CertifiedLevel$1 = "Certified: Level {{level}}";
var DashboardNav_Completions$1 = "Completions";
var DashboardNav_DismissRecommendation$1 = "Dismiss shared item";
var DashboardNav_EvalInProgress$1 = "Skill Review in progress";
var DashboardNav_EvalRatingLevel$1 = "Skill Review: Level {{level}}";
var DashboardNav_FindGroups$1 = "Find Groups";
var DashboardNav_FindPathway$1 = "Find a Pathway";
var DashboardNav_FollowingEverybody$1 = "Uh oh, looks like we don't have any more recommended people to follow.";
var DashboardNav_GetMonthlyActivityError$1 = "Sorry! There was a problem with getting your monthly activity results.";
var DashboardNav_ItemsViewed$1 = "Items Viewed";
var DashboardNav_LearnerHub$1 = "Learner Hub";
var DashboardNav_ManageFollowing$1 = "Manage Following";
var DashboardNav_ManagerRatingLevel$1 = "Manager Rating: Level {{level}}";
var DashboardNav_MaxFocusSkillDesc$1 = "You already have 4 Focus Skills. Remove or replace a Focus Skill under the <b>Skills tab in your Profile.</b>";
var DashboardNav_MonthlyActivity$1 = "Monthly Activity";
var DashboardNav_NegativeActivityChange$1 = "{{ label }} negative {{ count }} based on previous month";
var DashboardNav_NoActivityChange$1 = "{{ label }} {{ count }} based on previous month";
var DashboardNav_PathwayPercentComplete$1 = "{{percent}}% Complete";
var DashboardNav_PeopleToFollow$1 = "People To Follow";
var DashboardNav_PointsEarned$1 = "Points Earned";
var DashboardNav_PositiveActivityChange$1 = "{{ label }} positive {{ count }} based on previous month";
var DashboardNav_RefreshRecommended$1 = "Sorry those shares didn’t work out. Refresh the page to see a new set of people to follow.";
var DashboardNav_Resources$1 = "Resources";
var DashboardNav_SearchBySkill$1 = "Search by Skill";
var DashboardNav_SelfRatingLevel$1 = "Self Rating: Level {{level}}";
var DashboardNav_UpdateRatings$1 = "Update Ratings";
var DashboardNav_ViewMyProgress$1 = "View my progress";
var DashboardNav_YourGroups$1 = "Your Groups";
var DashboardNav_YourPathways$1 = "Your Pathways";
var DashboardNav_YourPlans$1 = "Your Plans";
var DashboardNav_YourSkills$1 = "Your Skills";
var CredVerificationCtrl_Instructions1$1 = "Welcome to Degreed Skill Certification for {{skill}}. To continue the process, we need to validate some personal details. Your first and last name will appear on your final certificate.";
var CredVerificationCtrl_Instructions2$1 = "To continue the process, we need to validate some personal details, including your name and photo ID. Your first and last name will appear on your final certificate.";
var CredStartCtrl_ApplicationReviewed$1 = "Application Reviewed";
var CredStartCtrl_AssertBehaviors$1 = "Assert Top 3 Skill Behaviors";
var CredStartCtrl_DegreedSkillsCertification$1 = "Degreed Skill Certification";
var CredStartCtrl_GetCertified$1 = "Get certified";
var CredStartCtrl_GetCertifiedPrice$1 = "Get Degreed Certified in {{skillname}} - <strong>{{price}}</strong>";
var CredStartCtrl_GetCertifiedSkillFormat$1 = "Get Degreed Certified in {{skillname}}";
var CredStartCtrl_GetCertifiedUnlimitedFormat$1 = "Get Degreed Certified in {{skillname}}";
var CredStartCtrl_GetEndorsed$1 = "Get Endorsed";
var CredStartCtrl_HowItWorks$1 = "How it works";
var CredStartCtrl_HowItWorksParagraph$1 = "Degreed Skill Certification is an in-depth assessment and proof of your individual skills, and will require a bit of effort. Think of it like a mini-college application process that includes a self evaluation, feedback from others, input from experts, and review of evidence you provide.";
var CredStartCtrl_ProvideEvidence$1 = "Provide Evidence";
var CredStartCtrl_ReceiveResults$1 = "Receive Results";
var CredStartCtrl_ReviewPeers$1 = "Review Peers";
var CredStartCtrl_ReviewSubmit$1 = "Review & Submit";
var CredStartCtrl_VerifyYourSkills$1 = "Verify your skills at any level, 1-8. Get formal, certified recognition for your skills, irrespective of how or where you developed your skills. You can add it to your resume or professional profile and use it throughout your career to show your certified expertise.";
var CredStartCtrl_VideoTitle$1 = "video: What Is Skill Certification?";
var CredSparkSvc_AssessmentError$1 = "We were unable to retreive your CredSpark assessment";
var CredSparkSvc_SyncError$1 = "We are unable to sync the latest CredSpark assessments at this time, please try again.";
var CredReviewCtrl_ConfirmButton$1 = "Confirm Application";
var CredReviewCtrl_Description$1 = "Review your application before you confirm. You will still be able to make changes up until the submission deadline.";
var CredReviewCtrl_Endorsers$1 = "Endorsers";
var CredResultsCtrl_CongratsParagraph$1 = "Explore the various ways to share your certificate and learn more about your level.";
var CredResultsCtrl_CongratsTitle$1 = "Congratulations on being Degreed Certified!";
var CredPrePayType_CertificationType$1 = "Choose Your Certification Plan";
var CredPrePayType_credit$1 = "Certification in one skill";
var CredPrePayType_creditAction$1 = "Get Certified in One Skill";
var CredPrePayType_creditDescription$1 = "<p>Get certified in one skill.</p>\n<p>Receive a digital certificate and verification link.</p>\n<p>Digital assets for LinkedIn, your resume, Facebook, Twitter, and anywhere you post your professional profile.</p>";
var CredPrePayType_lifetime$1 = "Unlimited Membership";
var CredPrePayType_lifetimeAction$1 = "Get an Unlimited Membership";
var CredPrePayType_lifetimeDescription$1 = "<p>For a limited time, we are offering the opportunity to purchase an unlimited membership of Degreed Skill Certification.</p> <p>Includes everything you get for a single skill, for as many skills as Degreed offers over the course of your life.</p>";
var CredPrePayType_LimitedOffer$1 = "Limited Time Offer!";
var CredPrePayType_OneSkillDescription$1 = "<p>Get certified in one skill.</p>\n<p>Receive a digital certificate and verification link.</p>\n<p>Digital assets for LinkedIn, your resume, Facebook, Twitter, and anywhere you post your professional profile.</p>";
var CredPrePayType_TypeHeading$1 = "Choose Your Certification Plan";
var CredPrePayCtrl_Payment$1 = "Payment";
var CredPrePayCtrl_SaveAndConfirm$1 = "Save & Confirm Payment";
var CredPrePayCtrl_SubmitPayment$1 = "Submit Payment";
var CredPrePayChooseSkillCtrl_ChooseASkill$1 = "Please choose a skill";
var CredPrePayChooseSkillCtrl_ChooseSkill$1 = "Choose Skill";
var CredPrePayChooseSkillCtrl_ContinueToApplication$1 = "Continue to Application";
var CredPrePayChooseSkillCtrl_ResultsForFormat$1 = "Related Skills for '{{term}}'";
var CredPrePayChooseSkillCtrl_SearchCatalog$1 = "Search our catalog of 1500+ skills:";
var CredPaymentSvc_PaymentInfoError$1 = "Sorry! There was a problem retrieving your details.";
var CredNav_AcceptHonorCode$1 = "Accept Honor Code";
var CredNav_Application$1 = "Application";
var CredNav_ApplicationDescription$1 = "Provide us with information about your skill level.";
var CredNav_Behavior1$1 = "First Skill Behavior";
var CredNav_Behavior2$1 = "Second Skill Behavior";
var CredNav_Behavior3$1 = "Third Skill Behavior";
var CredNav_Behaviors$1 = "Choose 3 Skill Behaviors";
var CredNav_Compare$1 = "Review Peers";
var CredNav_CompareDescription$1 = "Review others that have applied to become certified.";
var CredNav_Endorsers$1 = "List Endorsers";
var CredNav_EndorsersDescription$1 = "CredNav_EndorsersDescription";
var CredNav_FinalCheck$1 = "Final check";
var CredNav_heading$1 = "Skills Certification Navigation";
var CredNav_IdentityVerification$1 = "Identity Verification";
var CredNav_PeerComparison1$1 = "1st Peer Comparison";
var CredNav_PeerComparison2$1 = "2nd Peer Comparison";
var CredNav_PeerComparison3$1 = "3rd Peer Comparison";
var CredNav_PeerComparisonFormat$1 = "{{Number}}th Peer Comparison";
var CredNav_Results$1 = "Receive Results";
var CredNav_ResultsDescription$1 = "View, download, or share your certificate.";
var CredNav_ReviewApplication$1 = "Review Application";
var CredNav_SkillCertification$1 = "Skill Certification";
var CredNav_SkillReview$1 = "Skill Review";
var CredNav_Status$1 = "Check Status";
var CredNav_StatusDescription$1 = "Time to kick back and relax. We’re reviewing your application.";
var CredNav_Submit$1 = "Legal & Payment";
var CredNav_SubmitWithCredits$1 = "Legal & Submit";
var CredNav_WaitForCohort$1 = "Wait for cohort to open";
var CredManageTagsCtrl_ManageArticlesVideos$1 = "Manage Articles & Videos";
var CredManageTagsCtrl_ManageInformal$1 = "Manage Informal Learning";
var CredManageOutcomesCtrl_MaxErrorAccomplishmentFormat$1 = "We know you have a lot to show, but please limit your selection to a set of your {{count}} most relevant accomplishments.";
var CredManageOutcomesCtrl_MaxErrorSkillFormat$1 = "We know you have a lot to show, but please limit your selection to a set of your {{count}} most relevant skills.";
var CredManageOutcomesCtrl_MaxErrorTitle$1 = "Oops! That's 1 Too Many";
var CredManageOutcomesCtrl_TitleAccomplishment$1 = "Manage Accomplishments";
var CredManageOutcomesCtrl_TitleAward$1 = "Manage Awards";
var CredManageOutcomesCtrl_TitleCertificate$1 = "Manage Certificates";
var CredManageOutcomesCtrl_TitleDegree$1 = "Manage Degrees";
var CredManageOutcomesCtrl_TitleSkill$1 = "Manage Skills";
var CredEvidenceForm_AddUrl$1 = "Add URL";
var CredEvidenceForm_Complete$1 = "File upload complete";
var CredEvidenceForm_FileTypes$1 = "Files can be images (.jpg, .jpeg, .gif, .tiff, .png) or PDF files (.pdf) up to {{filesizeLimit}} in size.";
var CredEvidenceForm_InsertEvidence$1 = "Insert evidence";
var CredEvidenceForm_Processing$1 = "Processing file";
var CredEvidenceForm_ProvideEvidence$1 = "Provide Evidence";
var CredEvidenceForm_TitleOfEvidence$1 = "Title of Evidence";
var CredEvidenceForm_titleRequired$1 = "A title is required";
var CredEvidenceForm_UnableToUpload$1 = "Unable to upload file";
var CredEvidenceForm_UploadFile$1 = "Upload a file";
var CredEvidenceForm_urlFileRequired$1 = "A valid URL or a valid File upload is required. Remember to use http://";
var CredentialSvc_AddUserCredError$1 = "Sorry! There was a problem creating the application.";
var CredentialSvc_ApplyPaymentError$1 = "Your payment was successful but an error occurred while storing a record of it.";
var CredentialSvc_CohortError$1 = "Sorry! There was a problem retrieving available dates.";
var CredentialSvc_DeleteError$1 = "Sorry! There was a problem deleting the application.";
var CredentialSvc_DeleteSuccess$1 = "Application deleted successfully.";
var CredentialSvc_ErrorSavingChanges$1 = "An error occurred while saving your changes.";
var CredentialSvc_GetAllUserCredsError$1 = "Sorry! There was a problem retrieving applications.";
var CredentialSvc_GetBehaviorsError$1 = "Sorry! There was a problem retrieving behaviors.";
var CredentialSvc_GetComparisonError$1 = "Sorry! There was a problem retrieving comparison information.";
var CredentialSvc_GetCredError$1 = "Sorry! There was a problem retrieving this skill.";
var CredentialSvc_GetCredsError$1 = "Sorry! There was a problem retrieving available options.";
var CredentialSvc_GetEndorsersError$1 = "Sorry! There was a problem retrieving endorsement information.";
var CredentialSvc_GetLinksError$1 = "Sorry! There was a problem retrieving link information.";
var CredentialSvc_GetPaymentError$1 = "Sorry! There was a problem retrieving payment information.";
var CredentialSvc_GetProfileError$1 = "Sorry! There was a problem retrieving personal information.";
var CredentialSvc_GetReviewStatusError$1 = "An error occurred retrieving the review status.";
var CredentialSvc_GetScholarshipStatusError$1 = "An error occurred determining promo status.";
var CredentialSvc_GetSocialLinksError$1 = "Sorry! There was a problem retrieving the social links.";
var CredentialSvc_GetTagsError$1 = "Sorry! There was a problem retrieving skills.";
var CredentialSvc_GetUserCredError$1 = "Sorry! There was a problem retrieving the certification information.";
var CredentialSvc_SetBehaviorsError$1 = "Sorry! There was a problem saving behaviors.";
var CredentialSvc_SetComparisonError$1 = "Sorry! There was a problem saving comparison information.";
var CredentialSvc_SetEndorsersError$1 = "Sorry! There was a problem saving endorsement information.";
var CredentialSvc_SetLinksError$1 = "Sorry! There was a problem saving link information.";
var CredentialSvc_SetProfileError$1 = "Unable to upload file";
var CredentialSvc_SetScholarshipCodeError$1 = "An error occurred while setting the promo code.";
var CredentialSvc_SetTagsError$1 = "Sorry! There was a problem saving tags.";
var CredentialSvc_SubmitError$1 = "Sorry! Payment was successful, but there was a problem submitting the application.";
var CredApplyOverviewCtrl_ApplicationDeleted$1 = "Your application has been deleted. Wait while we redirect you.";
var CredApplyOverviewCtrl_DeletePrompt$1 = "Are you sure you want to delete your application?";
var CredApplyOverviewCtrl_MinReqsMet$1 = "Minimum requirements met";
var CredApplyOverviewCtrl_MinReqsNotMet$1 = "Minimum requirements not met";
var CredAcceptCtrl_AgreeLabel$1 = "I agree to the honor code.";
var CredAcceptCtrl_AgreeValidationMessage$1 = "You must agree to the honor code before advancing.";
var CredAcceptCtrl_Header$1 = "Agree to Honor Code";
var CredAcceptCtrl_HonorCodeDescription$1 = '<p class="par">All registered users of the Degreed service seeking skill certification must agree to and comply with the Degreed Honor code at all times, particularly upon submission of any evidence or other content submitted for review in consideration for certification. By requesting certification, you represent and warrant that you understand and have complied with the Degreed Honor Code.</p>\n\n<p class="par">Degreed will not tolerate any of the following activities:</p>\n\n<ul class="par bullets guts-m-b-3">\n    <li>Plagiarism (or any authorized use of another\'s work passed off as your own)</li>\n    <li>Lying or cheating</li>\n    <li>Fabrication and falsification of materials</li>\n    <li>Unauthorized aid</li>\n    <li>Misuse of materials</li>\n    <li>Complicity in dishonesty</li>\n    <li>Disclosure of confidential or proprietary information</li>\n</ul>\n\n<p class="par">Engaging in any prohibited activites may result in any of the following as solely determined by Degreed without any obligation, financial or otherwise, to you:</p>\n\n<ul class="par bullets guts-m-b-3">\n    <li>Denial of certification</li>\n    <li>Revocation of certification</li>\n    <li>Closure of Degreed account and any subsequent account opened without Degreed\'s written consent (which does not include anything generated during account registration)</li>\n</ul>\n\n<p class="par">Degreed, in its sole discretion, may update this Honor Code from time to time. Any submission made following a change to the Honor Code represents your acknowledgement and agreement with the change.</p>';
var CredAcceptCtrl_Instructions$1 = "Carefully read through the Degreed Honor Code below. If you agree, check the box at the bottom. You must agree to the Honor Code to be certified for a skill by Degreed.";
var CredAcceptCtrl_Submit$1 = "Save & Next";
var CredAcceptCtrl_Title$1 = "Degreed Honor Code";
var Cred_Application_Cancel$1 = "Cancel skill application";
var Cred_Application_Stay$1 = "Stay in application";
var Cred_ApplicationStep_AcceptHonorCode$1 = "Accept Honor Code";
var Cred_ApplicationStep_AcceptHonorCodeInstruction$1 = "Read and agree to the Degreed Honor Code.";
var Cred_ApplicationStep_ComparePeers$1 = "Complete peer comparisons";
var Cred_ApplicationStep_ComparePeersInstruction$1 = "Finish comparing your peers.";
var Cred_ApplicationStep_CompleteBehaviors$1 = "Complete behaviors";
var Cred_ApplicationStep_CompleteBehaviorsInstruction$1 = "Describe ways you use this skill.";
var Cred_ApplicationStep_CompleteEndorsers$1 = "Complete endorsers";
var Cred_ApplicationStep_CompleteEndorsersInstruction$1 = "Add references who know your skill.";
var Cred_ApplicationStep_ConfirmUser$1 = "Verify contact info";
var Cred_ApplicationStep_ConfirmUserInstruction$1 = "Make sure your contact information is correct.";
var Cred_ApplicationStep_Pay$1 = "Submit payment";
var Cred_ApplicationStep_PayInstruction$1 = "Enter your credit card or scholarship code.";
var Cred_ApplicationStep_Results$1 = "View results";
var Cred_ApplicationStep_ResultsInstruction$1 = "Check your skill level!";
var Cred_ApplicationStep_Review$1 = "Review application details";
var Cred_ApplicationStep_ReviewInstruction$1 = "Check your application one last time.";
var Cred_ApplicationStep_Submit$1 = "Submit application";
var Cred_ApplicationStep_SubmitInstruction$1 = "Commit to this month’s certification group.";
var Cred_ApplicationStep_Unknown$1 = "Unknown";
var Cred_ApplicationStep_WaitForCohort$1 = "Wait for submission deadline";
var Cred_ApplicationStep_WaitForCohortInstruction$1 = "Other applicants are finishing their applications.";
var Cred_ApplicationStep_WaitForReviews$1 = "Wait for reviews";
var Cred_ApplicationStep_WaitForReviewsInstruction$1 = "Other applicants are finishing their peer reviews.";
var Cred_BehaviorDisplay_DetailTitle$1 = "Skill Detail";
var Cred_BehaviorDisplay_TitleTitle$1 = "Skill Behavior";
var Cred_BehaviorReview_Accuracy$1 = "How accurate is {{endorsedName}}'s description of their skill behavior?";
var Cred_BehaviorReview_Accuracy_High$1 = "Accurate";
var Cred_BehaviorReview_Accuracy_Low$1 = "Inaccurate";
var Cred_BehaviorReview_AreYouQualified$1 = "Do you feel like you can answer the following question about {{endorsedName}}’s skill behavior?";
var Cred_Behaviors_DemoHeader$1 = "Examples of skill behaviors";
var Cred_Certificate_CertificateTitle$1 = "Certificate Title";
var Cred_Certificate_CertifiedOn$1 = "Certified on";
var Cred_Certificate_ChiefLearningOfficer$1 = "Chief Learning Officer";
var Cred_Certificate_Congratulations$1 = "Congratulations! You have achieved a Degreed Skill Certification.";
var Cred_Certificate_DateIssued$1 = "Date Issued";
var Cred_Certificate_DegreedCertifiesAria$1 = "Degreed certifies that {0} is a level {1} out of 8 in {2}.";
var Cred_Certificate_DegreedCertifiesThat$1 = "Degreed Certifies That";
var Cred_Certificate_Details$1 = "{{certificate}} Details";
var Cred_Certificate_Download$1 = "Download Certificate";
var Cred_Certificate_DownloadWillBegin$1 = "Your download will begin shortly";
var Cred_Certificate_EndorsedBy$1 = "Endorsed By";
var Cred_Certificate_Endorsers$1 = "Endorsed by: {0}";
var Cred_Certificate_ExecutiveChairman$1 = "Executive Chairman";
var Cred_Certificate_In$1 = "in";
var Cred_Certificate_Is$1 = "is";
var Cred_Certificate_Issuer$1 = "Issuer";
var Cred_Certificate_IssuerUrl$1 = "URL of Issuer";
var Cred_Certificate_Level$1 = "Level";
var Cred_Certificate_LevelOutOfLevel$1 = "{{min}} out of {{max}}";
var Cred_Certificate_LinkedInAuthority$1 = "In the Issuing Organization field, enter “Degreed”.";
var Cred_Certificate_LinkedInDate$1 = "This certification does not expire. Under Issue Date, enter “{{date}}”.";
var Cred_Certificate_LinkedInGo$1 = "Go to your LinkedIn profile and add a {{startAnchor}}Certification{{endAnchor}}.";
var Cred_Certificate_LinkedInLicense$1 = "In the Credential ID field, enter “{{code}}”.";
var Cred_Certificate_LinkedInName$1 = "In the certification Name field, enter “Degreed Level {{level}} in {{name}}”.";
var Cred_Certificate_LinkedInTitle$1 = "Go to your LinkedIn profile and add a Certification.";
var Cred_Certificate_LinkedInUrl$1 = 'In the Credential URL field, enter "{{url}}".';
var Cred_Certificate_Name$1 = "Degreed Level {{level}} at {{name}}";
var Cred_Certificate_NameLabel$1 = "Name";
var Cred_Certificate_RemovedRevoked$1 = "This certificate has been removed or revoked";
var Cred_Certificate_ResumeDate$1 = "Awarded: {{date}}";
var Cred_Certificate_ResumeName$1 = "Degreed Skill Certification, Level {{level}}, {{name}}";
var Cred_Certificate_ResumeTitle$1 = "Keep that r\xe9sum\xe9 fresh by adding your Degreed Skill Certification, usually in the <em>Skills</em> or <em>Experience</em> sections. Here’s how to word it:";
var Cred_Certificate_SealAlt$1 = "Degreed Certificate Seal";
var Cred_Certificate_SignaturesAlt$1 = "Signed by: David Blake President at Degreed, and Kelly Palmer C.L.O. at Degreed";
var Cred_Certificate_SkillCertificate$1 = "Skill Certificate";
var Cred_Certificate_SkillCertification$1 = "Skill Certification";
var Cred_Certificate_SocialEmailBodyFormat$1 = "Degreed has created a new way to certify skills no matter how you got them. I got certified in {0}. Check it out here: {1}";
var Cred_Certificate_SocialEmailSubjectFormat$1 = "Degreed Skill Certification";
var Cred_Certificate_SocialPostSummaryFormat$1 = "It’s time to make all skills matter. I got mine certified and I’m a Level {1} in {0}.";
var Cred_Certificate_SocialPostTitleFormat$1 = "Degreed Skill Certification";
var Cred_Certificate_TitleOf$1 = "Title of {{certificate}}";
var Cred_Certificate_Visibility$1 = "Visibility";
var Cred_Certificate_VisibilityLabel$1 = "Show certificate on your profile";
var Cred_Comparison_Next$1 = "Next Comparison";
var Cred_ComparisonNav_Comparison1$1 = "1st Comparison";
var Cred_ComparisonNav_Comparison2$1 = "2nd Comparison";
var Cred_ComparisonNav_Comparison3$1 = "3rd Comparison";
var Cred_ComparisonNav_ComparisonFormat$1 = "{{Number}}th Comparison";
var Cred_ComparisonPending_BeginNext$1 = "Begin next comparison";
var Cred_ComparisonPending_DueDateFormat$1 = "Due {{date}}";
var Cred_ComparisonPending_Heading$1 = "Pending comparisons";
var Cred_ComparisonPending_NoPendingReviews$1 = "No more applications to review";
var Cred_ComparisonPending_RemainingFormat$1 = "Approx. {{count}} comparisons remaining";
var Cred_ComparisonPending_ReviewsRemainingFormat$1 = "Approx. {{count}} reviews remaining";
var Cred_ConfirmSkipDialog_Body$1 = "If you continue with the current set of completed endorsements, we will not wait for the others to complete their endorsements before we award your certificate. This means that the other endorsers may not be listed on your certificate. Opting for one or two, rather than three endorsements will not affect your level.";
var Cred_ConfirmSkipDialog_Button$1 = "Yes, Continue";
var Cred_ConfirmSkipDialog_DeclinedBody$1 = "If you continue with the current endorsers, your certificate will list only those names. Your level is unaffected.";
var Cred_ConfirmSkipDialog_Heading$1 = "Continue with current endorsers?";
var Cred_CredVerifySvc_SubmitError$1 = "Sorry! There was a problem submitting the feedback.";
var Cred_EndorseExp_InstructionsFormat$1 = "The following questions will help us determine the maturity of {{applicantName}}’s skill in {{skillName}}. Please select all responses that are true. If none of the responses are true, or if you do not know, you can select none of the responses. Your responses will not be shared with {{applicantName}}.";
var Cred_EndorseExp_Q_Communication$1 = "Select the responses that are true of {{applicantName}}’s <strong>communication</strong> in {{skillName}}. {{applicantName}}:";
var Cred_EndorseExp_Q_Communication_15$1 = "Communicates effectively about {{skillName}}";
var Cred_EndorseExp_Q_Communication_35$1 = "Communicates well about controversial or complex subjects related to {{skillName}}";
var Cred_EndorseExp_Q_Communication_55$1 = "Communicates well about complex subjects related to {{skillName}} to cross-disciplinary audiences";
var Cred_EndorseExp_Q_Communication_75$1 = "Leads expert debates on new ideas in {{skillName}}";
var Cred_EndorseExp_Q_Knowledge$1 = "Select the responses that are true of {{applicantName}}’s <strong>knowledge</strong> in {{skillName}}. {{applicantName}}:";
var Cred_EndorseExp_Q_Knowledge_15$1 = "Demonstrates basic knowledge in {{skillName}}";
var Cred_EndorseExp_Q_Knowledge_35$1 = "Demonstrates broad theoretical or technical knowledge in {{skillName}}";
var Cred_EndorseExp_Q_Knowledge_55$1 = "Demonstrates deep understanding of innovative techniques and the most important theories or methods to solve complex problems in {{skillName}}";
var Cred_EndorseExp_Q_Knowledge_75$1 = "Contributes to innovation or expansion of knowledge in the field of {{skillName}}";
var Cred_EndorseExp_Q_Planning$1 = "Select the responses that are true of {{applicantName}}’s <strong>planning and evaluation</strong> in {{skillName}}. {{applicantName}}:";
var Cred_EndorseExp_Q_Planning_15$1 = "Evaluates their work in {{skillName}} based on specified criteria";
var Cred_EndorseExp_Q_Planning_35$1 = "Plans and designs appropriate approaches or processes in {{skillName}}, and evaluates their effectiveness";
var Cred_EndorseExp_Q_Planning_55$1 = "Develops and evaluates new solutions in {{skillName}} and comprehensively considers alternatives, including potential impacts";
var Cred_EndorseExp_Q_Planning_75$1 = "Explores and evaluates the limits of the current state of the {{skillName}} field";
var Cred_EndorseExp_Q_Practice$1 = "Select the responses that are true of {{applicantName}}’s <strong>applied practice</strong> of {{skillName}}. {{applicantName}}:";
var Cred_EndorseExp_Q_Practice_15$1 = "Carries out simple tasks in {{skillName}}";
var Cred_EndorseExp_Q_Practice_35$1 = "Solves problems to complete complex tasks in {{skillName}}";
var Cred_EndorseExp_Q_Practice_55$1 = "Applies a broad range of methods for completing complex tasks in {{skillName}}";
var Cred_EndorseExp_Q_Practice_75$1 = "Identifies strategic problems in the field of {{skillName}} and provides solutions";
var Cred_EndorseExp_Q_Responsibility$1 = "Select the responses that are true of {{applicantName}}’s <strong>responsibility and autonomy</strong> in {{skillName}}. {{applicantName}}:";
var Cred_EndorseExp_Q_Responsibility_15$1 = "Takes individual responsibilty under overall guidance in {{skillName}}";
var Cred_EndorseExp_Q_Responsibility_35$1 = "Demonstrates initiative, persistence, and flexibility in {{skillName}}";
var Cred_EndorseExp_Q_Responsibility_55$1 = "Exercises broad autonomy and responsibility for planning and developing {{skillName}} processes";
var Cred_EndorseExp_Q_Responsibility_75$1 = "Exercises broad autonomy and responsibility in projects significant to the field of {{skillName}}";
var Cred_EndorseExp_Q_Teamwork$1 = "Select the responses that are true of {{applicantName}}’s <strong>teamwork and leadership</strong> in {{skillName}}. {{applicantName}}:";
var Cred_EndorseExp_Q_Teamwork_15$1 = "Works under supervision when doing {{skillName}}";
var Cred_EndorseExp_Q_Teamwork_35$1 = "Works independently as part of a team in {{skillName}}";
var Cred_EndorseExp_Q_Teamwork_55$1 = "Leads a team in {{skillName}}";
var Cred_EndorseExp_Q_Teamwork_75$1 = "Leads an organization's {{skillName}} practitioners";
var Cred_EndorsementAccept_Accept$1 = "I agree to these terms of endorsement.";
var Cred_EndorsementAccept_HonorCode1$1 = "By submitting this endorsement, I certify that to the best of my knowledge and understanding, the individual listed has the skill(s) or experience identified in the questionnaire I received from Degreed.  I acknowledge and agree that by submitting this endorsement, my name will be publicly associated with this individual and his or her skill or experience that I am endorsing, and I hereby consent to the disclosure of my name as described.  I have first-hand knowledge of this individual’s skill or experience.  I represent and warrant that I have the expertise to evaluate the skill or experience and to determine whether such skill or experience meets industry expectations.";
var Cred_EndorsementAccept_HonorCode2$1 = "I further acknowledge and agree that by submitting this endorsement, I am voluntarily submitting my personal information, including my name.";
var Cred_EndorsementAccept_HonorCode3$1 = "I hereby authorize and consent to the disclosure of my name in connection with this endorsement, and I understand that any use of my name or other information I provide to Degreed may be used in accordance with the Degreed Privacy Policy.  I am solely responsible for any statements made in the endorsement or in connection with the endorsement, and I agree that I am subject to the Degreed Terms of Use to the extent I use the Degreed services, including, without limitation, the submission of this endorsement.";
var Cred_EndorsementAccept_HonorCodeTitle$1 = "Skill Reference Endorsement and Agreement";
var Cred_EndorsementAccept_Instructions$1 = "Should the applicant's certification be awarded, your name will be included on their certification as an endorser, publicly available. Before you endorse the applicant, you must commit to the Degreed Endorsement Agreement. If you do not agree to the Endorsement Agreement for any reason, you should decline to endorse the applicant.";
var Cred_EndorsementAccount_AlreadyLoggedIn$1 = "You're already logged in!";
var Cred_EndorsementAccount_Create$1 = "Create a new Degreed Account";
var Cred_EndorsementAccount_CreateAndNext$1 = "Create Account & Next Step";
var Cred_EndorsementAccount_EmailLabel$1 = "Email Address";
var Cred_EndorsementAccount_Header$1 = "Create a new Degreed Account";
var Cred_EndorsementAccount_Instructions$1 = "If you want to track your learning on Degreed or certify a skill of your own, you can create an account below to get started as soon as you finish this endorsement.";
var Cred_EndorsementAccount_PasswordLabel$1 = "Password";
var Cred_EndorsementAccount_Skip$1 = "Not right now";
var Cred_EndorsementAccount_SkipInstructions$1 = "You can create an account later if you change your mind.";
var Cred_EndorsementBehavior_Header$1 = "Review Skill Behavior {{behaviorNumber}}";
var Cred_EndorsementBehavior_Instructions$1 = "Carefully review the evidence {{endorsedFirstName}} provided, including their written responses and any attachments. Compare this evidence with your experience of working with {{endorsedFirstName}} in the past, then truthfully complete the evaluation at the bottom of the page.";
var Cred_EndorsementEndorser_EmailLabel$1 = "What is your email address?";
var Cred_EndorsementEndorser_EmailPlaceholder$1 = "e.g. Username@email.com";
var Cred_EndorsementEndorser_FirstNameLabel$1 = "What is your first name?";
var Cred_EndorsementEndorser_Instructions$1 = "{{endorsedName}} provided the following info. Please confirm it's accurate and update it if needed.";
var Cred_EndorsementEndorser_LastNameLabel$1 = "What is your last name?";
var Cred_EndorsementEndorser_PhoneLabel$1 = "What is your phone number?";
var Cred_EndorsementEndorser_PhonePlaceholder$1 = "e.g. 444-555-1111";
var Cred_EndorsementEndorser_PositionLabel$1 = "What is your job? Include your job role and who you work for.";
var Cred_EndorsementEndorser_PositionPlaceholder$1 = "e.g. Professor at Leiden University";
var Cred_EndorsementEndorser_RelationshipLabel$1 = "What is this person's relationship to you?";
var Cred_EndorsementEndorser_RelationshipPlaceholder$1 = "e.g. One of my students during his graduate studies.";
var Cred_EndorsementReasonForm_Header$1 = "Why not?";
var Cred_EndorsementReasonForm_ReasonLabel$1 = "If you want, let them know why you decided not to endorse their application.";
var Cred_EndorsementReasonForm_ReasonPlaceholder$1 = "I can’t endorse you right now because...";
var Cred_EndorsementStart_Accept$1 = "Review evidence";
var Cred_EndorsementStart_Decline$1 = "Decline to endorse";
var Cred_EndorsementStart_Declined$1 = "You have declined the endorsement.";
var Cred_EndorsementStart_DeclineReason$1 = "Please tell us why you declined (optional)";
var Cred_EndorsementStart_DegreedDescription$1 = "Degreed is the only platform that connects all the world’s best learning experiences – systems, content, people – so they can all work more effectively together. Degreed Skill Certification™ is the world's first skill-based, scientifically-backed, expert-driven credential.";
var Cred_EndorsementStart_Instructions$1 = "{{endorsedFirstName}} wants you to endorse their evidence for {{credentialName}} certification.";
var Cred_EndorsementStart_RequestFrom$1 = "Request from {{endorsedName}}";
var Cred_EndorsementStart_WhatIsDegreed$1 = "What is Degreed?";
var Cred_EndorsementSubmit_CompletedDetails$1 = "You helped {{endorsedName}} move one step closer to certifying their skill in {{credentialName}} on Degreed! Congratulations!";
var Cred_EndorsementSubmit_CompletedTitle$1 = "Thank you for endorsing {{endorsedName}}'s skill!";
var Cred_EndorsementSubmit_Exit$1 = "Learn on Degreed";
var Cred_EndorsementSubmit_Header$1 = "Finished";
var Cred_EndorsementSubmit_Instructions$1 = "Submit the endorsement";
var Cred_EndorsementSubmit_Instructions2$1 = "If you are finished with the endorsement, click <strong>Submit</strong>. You cannot change your responses after submitting the endorsement.";
var Cred_EndorseNav_AcceptDescription$1 = "Review the Endorsement Agreement.";
var Cred_EndorseNav_AccountDescription$1 = "You can create an account if you want one.";
var Cred_EndorseNav_ConfirmContactInfo$1 = "Confirm Contact Info";
var Cred_EndorseNav_CreateDegreedAcct$1 = "Create Account";
var Cred_EndorseNav_EndorserDescription$1 = "Confirm your contact information for us.";
var Cred_EndorseNav_Heading$1 = "Endorsement Navigation";
var Cred_EndorseNav_ReviewDescription$1 = "Review the applicant’s skill evidence.";
var Cred_EndorseNav_ReviewExperience$1 = "Review Experience";
var Cred_EndorseNav_ReviewExperienceDescription$1 = "Review the applicant’s experience";
var Cred_EndorseNav_ReviewHonorCode$1 = "Endorsement Agreement";
var Cred_EndorseNav_ReviewSkill1$1 = "Review Skill 1";
var Cred_EndorseNav_ReviewSkill2$1 = "Review Skill 2";
var Cred_EndorseNav_ReviewSkill3$1 = "Review Skill 3";
var Cred_EndorseNav_ReviewSkills$1 = "Review Skills";
var Cred_EndorseNav_Start$1 = "Start";
var Cred_EndorseNav_StartDescription$1 = "Let us know whether you’re willing to endorse {{fname}}.";
var Cred_EndorseNav_SubmitDescription$1 = "All done! Thanks for helping certify a skill!";
var Cred_EndorserDemo_ButtonLabel$1 = "What these endorsers will see";
var Cred_EndorserDemo_Heading$1 = "What endorsers see";
var Cred_EndorserDemo_ImageAlt$1 = "Screenshot example of {{title}}";
var Cred_EndorserDemo_Step1_Content$1 = "To double check the endorser's identity, they need to verify all correct contact info.";
var Cred_EndorserDemo_Step1_Title$1 = "Verify identity";
var Cred_EndorserDemo_Step2_Content$1 = "The endorser will then review your application by going over your skill behaviors.";
var Cred_EndorserDemo_Step2_Title$1 = "Review your application";
var Cred_EndorserDemo_Step3_Content$1 = "Finally the endorser will answer some questions about your application.";
var Cred_EndorserDemo_Step3_Title$1 = "Answer questions";
var Cred_EndorserDemo_ThanksGotIt$1 = "Thanks, got it";
var Cred_EndorserExpired_Explanation$1 = "This endorsement invitation may have expired. Please check with the certification applicant for an updated invitation.";
var Cred_EndorserExpired_Heading$1 = "This endorsement invitation is invalid";
var Cred_EndorserResend_Header$1 = "Resend Invite";
var Cred_Evidence_RemoveHeader$1 = "Are you sure you want to remove this evidence file?";
var Cred_Evidence_RemoveSummary$1 = "The file will no longer appear with your description.";
var Cred_EvidenceDisplay_ExampleHeading$1 = "Example";
var Cred_EvidenceDisplay_ProcessHeading$1 = "Process & Rationale";
var Cred_ExpertCandidate_AttrAutonomy$1 = "Responsibility and Autonomy";
var Cred_ExpertCandidate_Attributes$1 = "Attributes";
var Cred_ExpertCandidate_AttrKnowledge$1 = "Knowledge";
var Cred_ExpertCandidate_AttrPlanning$1 = "Planning and Evaluation";
var Cred_ExpertCandidate_AttrSkills$1 = "Application";
var Cred_ExpertCandidate_AttrTeaching$1 = "Communication and Teaching";
var Cred_ExpertCandidate_AttrTeamwork$1 = "Teamwork and Leadership";
var Cred_ExpertCandidate_CommentsLabel$1 = "Notes or Comments";
var Cred_ExpertCandidate_CommentsPlaceholder$1 = "Add your notes or comments...";
var Cred_ExpertCandidate_Heading$1 = "Which level should this candidate be awarded?";
var Cred_ExpertCandidate_LevelHigh$1 = "Expert";
var Cred_ExpertCandidate_LevelLabel$1 = "Which level should this candidate be awarded?";
var Cred_ExpertCandidate_LevelLow$1 = "Beginner";
var Cred_ExpertCandidate_NA$1 = "Cred_ExpertCandidate_NA";
var Cred_ExpertCandidate_SaveLevel$1 = "Submit review";
var Cred_ExpertPending_BeginNextReview$1 = "Begin next review";
var Cred_ExpertPending_Heading$1 = "Pending reviews";
var Cred_ExpertPending_NoPendingReviews$1 = "There are no pending reviews at the moment. Please check back later.";
var Cred_ExpertPending_ReviewsRemainingFormat$1 = "Approx. {{number}} reviews remaining";
var Cred_InstructionVideo$1 = "Instruction video";
var Cred_Intent_CareerChange$1 = "I’m looking for a career change.";
var Cred_Intent_ImproveSkills$1 = "I’m looking to develop and improve my skills in my current career.";
var Cred_Intent_legend$1 = "I’m applying for a Degreed Skill Certification because:";
var Cred_Intent_MeasureMe$1 = "I’m unsure of where my skill level stands and want to measure where I am.";
var Cred_Intent_Other$1 = "I’m applying for another reason.";
var Cred_Intent_ShowSkills$1 = "I want to be able to show my skills.";
var Cred_Intent_WorkDomain$1 = "I’m working in a domain that is different than my college degree.";
var Cred_LevelBreakdown_Autonomy_1$1 = "Demonstrates taking responsibility for the outcomes of structured activities in familiar and stable contexts.";
var Cred_LevelBreakdown_Autonomy_2$1 = "Takes individual responsibility for completing tasks and procedures within a limited range of contexts. Exercises some autonomy subject to overall direction and guidance.";
var Cred_LevelBreakdown_Autonomy_3$1 = "Performs tasks, employs procedures, and attains a quality of output with considerable responsibility and autonomy within contexts which are less familiar and stable, subject to overall direction or guidance. Sets one's own objectives and takes responsibility for them.";
var Cred_LevelBreakdown_Autonomy_4$1 = "Demonstrates initiative in planning and designing technical or management functions. Sets one's own objectives and takes responsibility for them. Demonstrates persistence and flexibility in attaining objectives.";
var Cred_LevelBreakdown_Autonomy_5$1 = "Takes responsibility for overall actions and results as well as exercises autonomy within broader parameters. Undertakes self-direct pursuit of objectives and takes responsibility for such objectives.";
var Cred_LevelBreakdown_Autonomy_6$1 = "Exercises broad autonomy and responsibility for planning and developing of processes. Evaluates the strengths and weaknesses of these processes.";
var Cred_LevelBreakdown_Autonomy_7$1 = "Exercises broad autonomy across a significant area of work. Defines objectives for new applications or research-oriented tasks.";
var Cred_LevelBreakdown_Autonomy_8$1 = "Exercises comprehensive autonomy as a leading scholar or practitioner and takes responsibility for planning and developing actions that have a significant impact on the field. Defines objectives for new, complex applications or research-oriented tasks. Selects appropriate means and develops new ideas and processes.";
var Cred_LevelBreakdown_Autonomy_Scale6_1$1 = "Takes individual responsibility for completing structured tasks and procedures in familiar and stable contexts.";
var Cred_LevelBreakdown_Autonomy_Scale6_2$1 = "Exercises some autonomy subject to overall direction and guidance within a limited range of contexts.";
var Cred_LevelBreakdown_Autonomy_Scale6_3$1 = "Performs tasks, employs procedures, and attains a quality of output with considerable responsibility and autonomy. Sets one's own objectives and takes responsibility for them.";
var Cred_LevelBreakdown_Autonomy_Scale6_4$1 = "Takes responsibility for overall actions and results as well as exercises autonomy within broader parameters. Demonstrates initiative in planning and designing technical and management functions and undertakes self-directed pursuit of objectives.";
var Cred_LevelBreakdown_Autonomy_Scale6_5$1 = "Exercises broad autonomy and responsibility for planning and developing processes and takes responsibility for objectives. Evaluates strengths and weaknesses of those processes.";
var Cred_LevelBreakdown_Autonomy_Scale6_6$1 = "Exercises comprehensive autonomy as a leading scholar or practitioner who defines objectives for new applications or research-oriented tasks. Develops new ideas and processes that have a significant impact on the field.";
var Cred_LevelBreakdown_Autonomy_Scale8_1$1 = "Demonstrates taking responsibility for the outcomes of structured activities in familiar and stable contexts.";
var Cred_LevelBreakdown_Autonomy_Scale8_2$1 = "Takes individual responsibility for completing tasks and procedures within a limited range of contexts. Exercises some autonomy subject to overall direction and guidance.";
var Cred_LevelBreakdown_Autonomy_Scale8_3$1 = "Performs tasks, employs procedures, and attains a quality of output with considerable responsibility and autonomy within contexts which are less familiar and stable, subject to overall direction or guidance. Sets one's own objectives and takes responsibility for them.";
var Cred_LevelBreakdown_Autonomy_Scale8_4$1 = "Demonstrates initiative in planning and designing technical or management functions. Sets one's own objectives and takes responsibility for them. Demonstrates persistence and flexibility in attaining objectives.";
var Cred_LevelBreakdown_Autonomy_Scale8_5$1 = "Takes responsibility for overall actions and results as well as exercises autonomy within broader parameters. Undertakes self-direct pursuit of objectives and takes responsibility for such objectives.";
var Cred_LevelBreakdown_Autonomy_Scale8_6$1 = "Exercises broad autonomy and responsibility for planning and developing of processes. Evaluates the strengths and weaknesses of these processes.";
var Cred_LevelBreakdown_Autonomy_Scale8_7$1 = "Exercises broad autonomy across a significant area of work. Defines objectives for new applications or research-oriented tasks.";
var Cred_LevelBreakdown_Autonomy_Scale8_8$1 = "Exercises comprehensive autonomy as a leading scholar or practitioner and takes responsibility for planning and developing actions that have a significant impact on the field. Defines objectives for new, complex applications or research-oriented tasks. Selects appropriate means and develops new ideas and processes.";
var Cred_LevelBreakdown_Description$1 = "These level ratings are based on the combined reviews of our expertise panel.";
var Cred_LevelBreakdown_Knowledge_1$1 = "Demonstrates general knowledge.";
var Cred_LevelBreakdown_Knowledge_2$1 = "Demonstrates and uses basic knowledge that includes relevant principles and practices.";
var Cred_LevelBreakdown_Knowledge_3$1 = "Demonstrates and applies extended knowledge. This includes the knowledge of a limited range of technical and theoretical concepts, procedures, and solutions to predictable problems.";
var Cred_LevelBreakdown_Knowledge_4$1 = "Demonstrates a comprehensive theoretical and technical knowledge to determine solutions to unfamiliar patterns.";
var Cred_LevelBreakdown_Knowledge_5$1 = "Demonstrates integrated and specialized knowledge. This includes deeper theoretical and professional knowledge, including the scope, the core theories and practices and the limitations of the field.";
var Cred_LevelBreakdown_Knowledge_6$1 = "Demonstrates broad integrated knowledge concerning scientific principles and practical application. This includes a critical understanding of the most important theories, a range of methods, as well as relevant and innovative development to address complex problems.";
var Cred_LevelBreakdown_Knowledge_7$1 = "Demonstrates comprehensive, detailed, specialized, and state-of-the-art knowledge. This includes demonstrating an extended knowledge in adjoining disciplines, major theories, methods, and schools of practice in the field.";
var Cred_LevelBreakdown_Knowledge_8$1 = "Demonstrates comprehensive, specialized, systematic state-of-the-art knowledge and contributes to innovation or the expansion of knowledge. This includes specialized knowledge at the interface of adjoining disciplines.";
var Cred_LevelBreakdown_Knowledge_Scale6_1$1 = "Demonstrates and uses basic knowledge.";
var Cred_LevelBreakdown_Knowledge_Scale6_2$1 = "Demonstrates and applies basic knowledge, including relevant principles and practices as well as a limited range of technical concepts.";
var Cred_LevelBreakdown_Knowledge_Scale6_3$1 = "Demonstrates and applies extended knowledge including solutions to predictable problems.";
var Cred_LevelBreakdown_Knowledge_Scale6_4$1 = "Demonstrates comprehensive theoretical technical knowledge, including specialized knowledge, to determine solutions to unfamiliar patterns.";
var Cred_LevelBreakdown_Knowledge_Scale6_5$1 = "Demonstrates broad integrated knowledge including the scope of the field and the core theories and practices. This critical understanding allows relevant innovation to address complex problems.";
var Cred_LevelBreakdown_Knowledge_Scale6_6$1 = "Demonstrates comprehensive, detailed, specialized state-of-the-art knowledge and contributes to innovation or expansion of knowledge. This includes an extended knowledge of adjoining disciplines, major theories, methods, and schools of practice.";
var Cred_LevelBreakdown_Knowledge_Scale8_1$1 = "Demonstrates general knowledge.";
var Cred_LevelBreakdown_Knowledge_Scale8_2$1 = "Demonstrates and uses basic knowledge that includes relevant principles and practices.";
var Cred_LevelBreakdown_Knowledge_Scale8_3$1 = "Demonstrates and applies extended knowledge. This includes the knowledge of a limited range of technical and theoretical concepts, procedures, and solutions to predictable problems.";
var Cred_LevelBreakdown_Knowledge_Scale8_4$1 = "Demonstrates a comprehensive theoretical and technical knowledge to determine solutions to unfamiliar patterns.";
var Cred_LevelBreakdown_Knowledge_Scale8_5$1 = "Demonstrates integrated and specialized knowledge. This includes deeper theoretical and professional knowledge, including the scope, the core theories and practices and the limitations of the field.";
var Cred_LevelBreakdown_Knowledge_Scale8_6$1 = "Demonstrates broad integrated knowledge concerning scientific principles and practical application. This includes a critical understanding of the most important theories, a range of methods, as well as relevant and innovative development to address complex problems.";
var Cred_LevelBreakdown_Knowledge_Scale8_7$1 = "Demonstrates comprehensive, detailed, specialized, and state-of-the-art knowledge. This includes demonstrating an extended knowledge in adjoining disciplines, major theories, methods, and schools of practice in the field.";
var Cred_LevelBreakdown_Knowledge_Scale8_8$1 = "Demonstrates comprehensive, specialized, systematic state-of-the-art knowledge and contributes to innovation or the expansion of knowledge. This includes specialized knowledge at the interface of adjoining disciplines.";
var Cred_LevelBreakdown_Planning_1$1 = "Demonstrates ability to recognize and to act on elementary relationships between assignments and tasks.";
var Cred_LevelBreakdown_Planning_2$1 = "Demonstrates ability to recognize and to act on elementary relationships between assignments and tasks. Evaluates the results of such tasks in accordance with pre-stipulated criteria.";
var Cred_LevelBreakdown_Planning_3$1 = "Evaluates results in accordance with criteria which are largely pre-stipulated. Provides simple reporting of methods and results.";
var Cred_LevelBreakdown_Planning_4$1 = "Plans and designs appropriate approaches and processes. Evaluates results. Demonstrates ability to select alternative actions or practices based on observations.";
var Cred_LevelBreakdown_Planning_5$1 = "Plans work processes. Evaluates such processes, comprehensively considering alternatives and their potential impacts. Identifies and frames complex problems and distinguishes among ideas, concepts, theories, or practical approaches to solve those problems.";
var Cred_LevelBreakdown_Planning_6$1 = "Develops and evaluates new solutions and considers the effect on various criteria. Differentiates and evaluates theories and approaches to selected complex problems.";
var Cred_LevelBreakdown_Planning_7$1 = "Demonstrates high-level, independent judgements in a range of technical or management functions and articulates significant challenges involved. This includes the initiation, planning, and evaluation of varied specialized technical or creative functions, the exploration of current limits of theory, knowledge, and practice, and the consideration of alternatives.";
var Cred_LevelBreakdown_Planning_8$1 = "Demonstrates ability to identify and solve novel problems in the areas of research, development, or innovation in the field. This includes the initiation, planning, and evaluation of broad specialized and technical and creative functions comprising cross-activity areas and the consideration of alternatives.";
var Cred_LevelBreakdown_Planning_Scale6_1$1 = "Demonstrates ability to recognize and to act on elementary relationships between assignments and tasks.";
var Cred_LevelBreakdown_Planning_Scale6_2$1 = "Evaluates results of tasks in accordance with pre-stipulated criteria. Provides simple reporting of methods and results.";
var Cred_LevelBreakdown_Planning_Scale6_3$1 = "Evaluates results in accordance with criteria that are largely pre-stipulated. Demonstrates ability to select alternative actions or practices based on observations.";
var Cred_LevelBreakdown_Planning_Scale6_4$1 = "Plans and designs appropriate approaches and work processes. Evaluates processes, considering alternatives and their potential impacts. Identifies and frames complex problems and distinguishes among ideas, concepts, theories, or practical approaches to solve those problems.";
var Cred_LevelBreakdown_Planning_Scale6_5$1 = "Develops new work processes and solutions, comprehensively considering alternatives and their potential impacts. Differentiates and evaluates theories and approaches to selected complex problems.";
var Cred_LevelBreakdown_Planning_Scale6_6$1 = "Demonstrates high-level, independent judgements in a range of technical or management functions and articulates significant challenges involved. Identifies and solves novel problems in research and development. This includes the initiation, planning, and evaluation of varied specialized technical or creative functions.";
var Cred_LevelBreakdown_Planning_Scale8_1$1 = "Demonstrates ability to recognize and to act on elementary relationships between assignments and tasks.";
var Cred_LevelBreakdown_Planning_Scale8_2$1 = "Demonstrates ability to recognize and to act on elementary relationships between assignments and tasks. Evaluates the results of such tasks in accordance with pre-stipulated criteria.";
var Cred_LevelBreakdown_Planning_Scale8_3$1 = "Evaluates results in accordance with criteria which are largely pre-stipulated. Provides simple reporting of methods and results.";
var Cred_LevelBreakdown_Planning_Scale8_4$1 = "Plans and designs appropriate approaches and processes. Evaluates results. Demonstrates ability to select alternative actions or practices based on observations.";
var Cred_LevelBreakdown_Planning_Scale8_5$1 = "Plans work processes. Evaluates such processes, comprehensively considering alternatives and their potential impacts. Identifies and frames complex problems and distinguishes among ideas, concepts, theories, or practical approaches to solve those problems.";
var Cred_LevelBreakdown_Planning_Scale8_6$1 = "Develops and evaluates new solutions and considers the effect on various criteria. Differentiates and evaluates theories and approaches to selected complex problems.";
var Cred_LevelBreakdown_Planning_Scale8_7$1 = "Demonstrates high-level, independent judgements in a range of technical or management functions and articulates significant challenges involved. This includes the initiation, planning, and evaluation of varied specialized technical or creative functions, the exploration of current limits of theory, knowledge, and practice, and the consideration of alternatives.";
var Cred_LevelBreakdown_Planning_Scale8_8$1 = "Demonstrates ability to identify and solve novel problems in the areas of research, development, or innovation in the field. This includes the initiation, planning, and evaluation of broad specialized and technical and creative functions comprising cross-activity areas and the consideration of alternatives.";
var Cred_LevelBreakdown_Skills_1$1 = "Demonstrates basic cognitive and practical skills to carry out tasks with stipulated rules.";
var Cred_LevelBreakdown_Skills_2$1 = "Demonstrates basic cognitive and practical skills required to carry out basic and technical tasks.";
var Cred_LevelBreakdown_Skills_3$1 = "Demonstrates a broad range of cognitive and practical skills. Can identify and use relevant methods and skills to complete tasks and use problem solving to address well-defined problems having a measure of complexity.";
var Cred_LevelBreakdown_Skills_4$1 = "Demonstrates the use of a broad range of cognitive and practical skills. Can solve difficult problems and complete complex tasks.";
var Cred_LevelBreakdown_Skills_5$1 = "Demonstrates an extended, broad range of specialized cognitive and practical skills. Can solve difficult problems and complete complex tasks.";
var Cred_LevelBreakdown_Skills_6$1 = "Demonstrates and applies a comprehensive range of methods for processing complex tasks and problems.";
var Cred_LevelBreakdown_Skills_7$1 = "Demonstrates specialized technical or conceptual skills to analyze, consolidate, and synthesize knowledge to identify and provide solutions to strategic problems in the skill.";
var Cred_LevelBreakdown_Skills_8$1 = "Demonstrates and applies skills in making high-level, independent judgements in a range of technical or management functions in varied specialized contexts.";
var Cred_LevelBreakdown_Skills_Scale6_1$1 = "Demonstrates basic cognitive and practical skills required to carry out basic and technical tasks with stipulated rules.";
var Cred_LevelBreakdown_Skills_Scale6_2$1 = "Demonstrates a range of cognitive and practical skills to carry out basic tasks using relevant methods and skills.";
var Cred_LevelBreakdown_Skills_Scale6_3$1 = "Demonstrates the use of a broad range of cognitive and practical skills. Can use problem solving to address well-defined problems and complex tasks.";
var Cred_LevelBreakdown_Skills_Scale6_4$1 = "Demonstrates an extended, broad range of specialized cognitive and practical skills. Can solve difficult problems and complete complex tasks.";
var Cred_LevelBreakdown_Skills_Scale6_5$1 = "Demonstrates and applies a comprehensive range of methods including specialized skills for processing complex tasks and problems.";
var Cred_LevelBreakdown_Skills_Scale6_6$1 = "Demonstrates specialized technical or conceptual skills to synthesize knowledge to make high-level, independent judgments and provide solutions to strategic problems in a range of specialized contexts.";
var Cred_LevelBreakdown_Skills_Scale8_1$1 = "Demonstrates basic cognitive and practical skills to carry out tasks with stipulated rules.";
var Cred_LevelBreakdown_Skills_Scale8_2$1 = "Demonstrates basic cognitive and practical skills required to carry out basic and technical tasks.";
var Cred_LevelBreakdown_Skills_Scale8_3$1 = "Demonstrates a broad range of cognitive and practical skills. Can identify and use relevant methods and skills to complete tasks and use problem solving to address well-defined problems having a measure of complexity.";
var Cred_LevelBreakdown_Skills_Scale8_4$1 = "Demonstrates the use of a broad range of cognitive and practical skills. Can solve difficult problems and complete complex tasks.";
var Cred_LevelBreakdown_Skills_Scale8_5$1 = "Demonstrates an extended, broad range of specialized cognitive and practical skills. Can solve difficult problems and complete complex tasks.";
var Cred_LevelBreakdown_Skills_Scale8_6$1 = "Demonstrates and applies a comprehensive range of methods for processing complex tasks and problems.";
var Cred_LevelBreakdown_Skills_Scale8_7$1 = "Demonstrates specialized technical or conceptual skills to analyze, consolidate, and synthesize knowledge to identify and provide solutions to strategic problems in the skill.";
var Cred_LevelBreakdown_Skills_Scale8_8$1 = "Demonstrates and applies skills in making high-level, independent judgements in a range of technical or management functions in varied specialized contexts.";
var Cred_LevelBreakdown_Teaching_1$1 = "Demonstrates basic interpersonal and communication abilities.";
var Cred_LevelBreakdown_Teaching_2$1 = "Actively takes a part in group learning by requesting guidance as needed. Uses effective listening and comprehension for receiving direction or information from others.";
var Cred_LevelBreakdown_Teaching_3$1 = "Uses communication abilities to transfer some knowledge and specialized skills to others. Uses effective listening and comprehension for receiving direction or information from others.";
var Cred_LevelBreakdown_Teaching_4$1 = "Demonstrates advanced interpersonal abilities, in particular the ability to communicate effectively about solutions to complex problems when the subject matter may be sensitive, controversial, or likely to be questioned or challenged. Assists in shaping the work in a group.";
var Cred_LevelBreakdown_Teaching_5$1 = "Demonstrates advanced interpersonal abilities, including the ability to present complex facts and circumstances and to communicate about solutions in a manner that is contextually appropriate to cross-disciplinary audiences. Acts in an anticipatory manner while considering the interests and requirements of others. Evaluates the potential consequences for work processes within teams, instructs others, and provides learning guidance.";
var Cred_LevelBreakdown_Teaching_6$1 = "Demonstrates advanced interpersonal abilities, including the ability to comprehensively and clearly communicate about methods, technologies, knowledge, and ideas. This includes the ability to present arguments and solutions to complex problems, even when subject matter is highly complex, unfamiliar, or technical. Instructs the professional development of others and acts in an anticipatory manner to address problems within teams.";
var Cred_LevelBreakdown_Teaching_7$1 = "Demonstrates appropriate communication abilities to lead expert debates on new ideas and problems. Promotes the professional development of others in a targeted manner. Demonstrates the ability to build consensus and apply negotiating practices in a group environment.";
var Cred_LevelBreakdown_Teaching_8$1 = "Demonstrates deep levels of interpersonal abilities. In particular, demonstrates communication abilities to transfer knowledge and specialized skills to others. Leads cross-specialty debates and introduces innovative contributions to specialized professional discussions.";
var Cred_LevelBreakdown_Teaching_Scale6_1$1 = "Demonstrates basic interpersonal and communication abilities. Uses effective listening and comprehension for receiving direction or information from others.";
var Cred_LevelBreakdown_Teaching_Scale6_2$1 = "Actively takes a part in group learning by requesting guidance as needed. Uses communication abilities to transfer some knowledge to others.";
var Cred_LevelBreakdown_Teaching_Scale6_3$1 = "Can communicate effectively about solutions to complex problems when the subject matter may be sensitive, controversial, or likely to be questioned or challenged.";
var Cred_LevelBreakdown_Teaching_Scale6_4$1 = "Assists in shaping the work in a group. Can present complex facts and circumstances and communicates about solutions in a manner that is contextually appropriate to cross-disciplinary audiences. Acts in an anticipatory manner while considering the interests and requirements of others.";
var Cred_LevelBreakdown_Teaching_Scale6_5$1 = "Demonstrates advanced interpersonal abilities, including the ability to comprehensively and clearly communicate about methods, technologies, knowledge, and ideas. This includes the ability to present arguments and solutions to complex problems, even when subject matter is highly complex, unfamiliar, or technical.";
var Cred_LevelBreakdown_Teaching_Scale6_6$1 = "Demonstrates appropriate communication abilities to lead expert debates on new ideas and problems. Demonstrates communication abilities to transfer  knowledge and specialized skills to others. Promotes the professional development of others in a targeted manner.";
var Cred_LevelBreakdown_Teaching_Scale8_1$1 = "Demonstrates basic interpersonal and communication abilities.";
var Cred_LevelBreakdown_Teaching_Scale8_2$1 = "Actively takes a part in group learning by requesting guidance as needed. Uses effective listening and comprehension for receiving direction or information from others.";
var Cred_LevelBreakdown_Teaching_Scale8_3$1 = "Uses communication abilities to transfer some knowledge and specialized skills to others. Uses effective listening and comprehension for receiving direction or information from others.";
var Cred_LevelBreakdown_Teaching_Scale8_4$1 = "Demonstrates advanced interpersonal abilities, in particular the ability to communicate effectively about solutions to complex problems when the subject matter may be sensitive, controversial, or likely to be questioned or challenged. Assists in shaping the work in a group.";
var Cred_LevelBreakdown_Teaching_Scale8_5$1 = "Demonstrates advanced interpersonal abilities, including the ability to present complex facts and circumstances and to communicate about solutions in a manner that is contextually appropriate to cross-disciplinary audiences. Acts in an anticipatory manner while considering the interests and requirements of others. Evaluates the potential consequences for work processes within teams, instructs others, and provides learning guidance.";
var Cred_LevelBreakdown_Teaching_Scale8_6$1 = "Demonstrates advanced interpersonal abilities, including the ability to comprehensively and clearly communicate about methods, technologies, knowledge, and ideas. This includes the ability to present arguments and solutions to complex problems, even when subject matter is highly complex, unfamiliar, or technical. Instructs the professional development of others and acts in an anticipatory manner to address problems within teams.";
var Cred_LevelBreakdown_Teaching_Scale8_7$1 = "Demonstrates appropriate communication abilities to lead expert debates on new ideas and problems. Promotes the professional development of others in a targeted manner. Demonstrates the ability to build consensus and apply negotiating practices in a group environment.";
var Cred_LevelBreakdown_Teaching_Scale8_8$1 = "Demonstrates deep levels of interpersonal abilities. In particular, demonstrates communication abilities to transfer knowledge and specialized skills to others. Leads cross-specialty debates and introduces innovative contributions to specialized professional discussions.";
var Cred_LevelBreakdown_Teamwork_1$1 = "Demonstrates ability to work within a group in familiar and stable contexts.";
var Cred_LevelBreakdown_Teamwork_2$1 = "Demonstrates intermediate interpersonal abilities.";
var Cred_LevelBreakdown_Teamwork_3$1 = "Works in complex and heterogeneous groups. Acknowledges different perspectives or approaches within the field.";
var Cred_LevelBreakdown_Teamwork_4$1 = "Works and collaborates in complex and heterogeneous groups. Acknowledges different perspectives or approaches within the field.";
var Cred_LevelBreakdown_Teamwork_5$1 = "Plans and structures work processes in a collaborative manner, including within heterogeneous groups. Reflects understanding of different perspectives or approaches within the field.";
var Cred_LevelBreakdown_Teamwork_6$1 = "Takes responsibility while working in expert teams and shows responsibility in leading groups or organizations.";
var Cred_LevelBreakdown_Teamwork_7$1 = "Takes responsibility for leading groups and organizations within the scope of complex tasks.";
var Cred_LevelBreakdown_Teamwork_8$1 = "Leads groups or organizations in complex or interdisciplinary tasks while maximizing areas of potential within such groups or organizations.";
var Cred_LevelBreakdown_Teamwork_Scale6_1$1 = "Demonstrates ability to work within a group in familiar and stable contexts.";
var Cred_LevelBreakdown_Teamwork_Scale6_2$1 = "Demonstrates intermediate interpersonal abilities in complex groups. Acknowledges different perspectives or approaches within the field.";
var Cred_LevelBreakdown_Teamwork_Scale6_3$1 = "Works and collaborates in complex and heterogeneous groups. Reflects understanding of different perspectives or approaches within the field.";
var Cred_LevelBreakdown_Teamwork_Scale6_4$1 = "Plans and structures work processes in a collaborative manner, including within heterogeneous groups.";
var Cred_LevelBreakdown_Teamwork_Scale6_5$1 = "Takes responsibility while working in expert teams and shows responsibility in leading groups or organizations.";
var Cred_LevelBreakdown_Teamwork_Scale6_6$1 = "Takes responsibility for leading groups or organizations in complex or interdisciplinary tasks while maximizing areas of potential.";
var Cred_LevelBreakdown_Teamwork_Scale8_1$1 = "Demonstrates ability to work within a group in familiar and stable contexts.";
var Cred_LevelBreakdown_Teamwork_Scale8_2$1 = "Demonstrates intermediate interpersonal abilities.";
var Cred_LevelBreakdown_Teamwork_Scale8_3$1 = "Works in complex and heterogeneous groups. Acknowledges different perspectives or approaches within the field.";
var Cred_LevelBreakdown_Teamwork_Scale8_4$1 = "Works and collaborates in complex and heterogeneous groups. Acknowledges different perspectives or approaches within the field.";
var Cred_LevelBreakdown_Teamwork_Scale8_5$1 = "Plans and structures work processes in a collaborative manner, including within heterogeneous groups. Reflects understanding of different perspectives or approaches within the field.";
var Cred_LevelBreakdown_Teamwork_Scale8_6$1 = "Takes responsibility while working in expert teams and shows responsibility in leading groups or organizations.";
var Cred_LevelBreakdown_Teamwork_Scale8_7$1 = "Takes responsibility for leading groups and organizations within the scope of complex tasks.";
var Cred_LevelBreakdown_Teamwork_Scale8_8$1 = "Leads groups or organizations in complex or interdisciplinary tasks while maximizing areas of potential within such groups or organizations.";
var Cred_levelDescription_ViewAll$1 = "View All Level Descriptions";
var Cred_levelName1$1 = "Beginner";
var Cred_levelName2$1 = "Capable";
var Cred_levelName3$1 = "Intermediate";
var Cred_levelName4$1 = "Effective";
var Cred_levelName5$1 = "Experienced";
var Cred_levelName6$1 = "Advanced";
var Cred_levelName7$1 = "Distinguished";
var Cred_levelName8$1 = "Master";
var Cred_levelShortTitle$1 = "Level {{level}}";
var Cred_levelSummary_Breakdown$1 = "Level Breakdown";
var Cred_levelSummary1$1 = "As a Level 1, you have general knowledge about some aspects of the skill. You’re just beginning to learn the tools associated with your skill and how to use them to complete simple, routine tasks. You work best within a structured environment with supervision, predetermined processes, and set criteria to judge output against.";
var Cred_levelSummary2$1 = "As a Level 2, you’ve gained a working, fundamental knowledge of your skill domain. While you know there’s still plenty left to learn, you’ve got the basics down. You can solve basic problems and complete tasks on your own—but when a complex issue arises, you’ll likely need some help.";
var Cred_levelSummary3$1 = "At Level 3, you’ve extended your knowledge beyond fundamentals into the theory of your skill domain. You’re comfortable using the tools of the trade as you continue to develop your technical skills. For the most part, you can work independently on new challenges. You know enough about your skills to be self-critical, and know the difference between good work and great work. You’ve also become good at setting your own goals to measure progress.";
var Cred_levelSummary4$1 = "As a Level 4, you’re a skilled practitioner that uses a broad range of methods to solve problems from planning to execution. You can tackle more specialized tasks and apply your skills to complex problems that might require a new process or approach.  You can work independently on complex projects, and when those projects are complete, you’re able to look at your work and accurately evaluate whether it was successful.";
var Cred_levelSummary5$1 = "As a Level 5, you have robust, and likely specialized knowledge about your skill. You have a proven track record of success, and bring a wide range of cognitive or practical skills to the table to solve new and complex problems. You can lead an initiative and see it through to the end.";
var Cred_levelSummary6$1 = "As a Level 6, you’ve mastered the knowledge, theory, tools, methodology, and processes of your skill domain. Not only can you apply them successfully to pretty much any problem—large or small, simple or complex—you can also clearly communicate these concepts to others.";
var Cred_levelSummary7$1 = "As a Level 7, you’re an innovator and your work is likely highlighted as industry best. You use tools in such a complex and experimental way that others look to you for best practices—you’re the one setting the trends that others will follow. You also likely have one or two areas of expertise that are highly specialized or advanced.";
var Cred_levelSummary8$1 = "As a Level 8, your knowledge and unique vision of the field are highly sought-after. You have a grasp on what the future of your domain will hold and how it might affect people, tools, technology, processes, and the world as a whole. You are recognized as a world-class leader in your field and are likely developing new standards and practices, innovating beyond the majority of your peers.";
var Cred_levelTitle$1 = "Level {{level}}: {{name}}";
var Cred_NextStep$1 = "Next step";
var Cred_NoComparison_Header$1 = "Review Peers";
var Cred_NoComparison_Instructions$1 = "You lucked out! Sometimes our super awesome algorithm says we don’t need additional peer reviews. You can move on to the next step!";
var Cred_NoComparison_NoReviewsNeeded$1 = "No peer reviews needed!";
var Cred_Overview_CompletePeerReviews$1 = "Complete Peer Reviews";
var Cred_Overview_EditApplication$1 = "Edit application";
var Cred_Overview_EditApplicationInstructions$1 = "You can change your application until {{date}} at {{time}}.";
var Cred_Overview_Instructions$1 = "Welcome to Degreed Skill Certification for {{skill}}. You will provide evidence of your skills that endorsers, peers, and our expertise panel will review to determine your skill level. You’ll help review your peers, too. Watch the video for more details about the process, or go ahead and get started!";
var Cred_Overview_NextActions$1 = "Next actions";
var Cred_Overview_NextDeadline$1 = "Next deadline";
var Cred_Overview_OptionalActions$1 = "Optional actions";
var Cred_Overview_SubmitApplication$1 = "Submit application";
var Cred_Overview_SubmitApplicationInstructions$1 = "Submit your application by the deadline. If you miss the deadline, there will be another application deadline the following month.";
var Cred_Overview_Title$1 = "Skill Certification Overview";
var Cred_PaymentNotSupported$1 = "Payment for skill certification is currently not supported in the EU. Please contact info@degreed.com to enable your application for skill certification.";
var Cred_SkillBehavior_Original$1 = "The original text for these skill behaviors in";
var Cred_SkillBehavior_Translated$1 = "NOTE: The text for these skill behaviors has been translated from";
var Cred_Status_AddNewEndorser$1 = "Add New Endorser";
var Cred_Status_ApplyCode$1 = "Apply your promo code above.";
var Cred_Status_CheckoutBtn$1 = "Proceed to checkout";
var Cred_Status_DateCompletedFormat$1 = "Endorsement completed on {{date}}";
var Cred_Status_DateDeclinedFormat$1 = "Declined request on {{date}}";
var Cred_Status_DegreedReviewed$1 = "Degreed Expert Review";
var Cred_Status_DegreedReviewedDescription$1 = "Our expertise panel has not reviewed your application yet.";
var Cred_Status_DegreedReviewedDescriptionCompleted$1 = "Our expertise panel has finished reviewing your application.";
var Cred_Status_EditInfo$1 = "Edit Info";
var Cred_Status_EndorserAdded$1 = "Endorser added and endorsement invitation sent!";
var Cred_Status_EndorserHasntResponded$1 = "Hasn't responded yet";
var Cred_Status_Endorsers_Desc$1 = "You must have at least one completed endorsement to receive your certificate.";
var Cred_Status_EndorsersHeading$1 = "Endorsers";
var Cred_Status_EndorserUpdated$1 = "Endorser updated!  An invitation was sent if a new email address was specified";
var Cred_Status_Header$1 = "Application Review Status";
var Cred_Status_Instructions1$1 = "Congratulations on getting this far! You can see the status of your application below. Once you have received at least one endorsement, you are finished! Take a well-earned break!";
var Cred_Status_Instructions2$1 = "If your endorsers have not responded or have declined to endorse you, you can resend the request or update your endorsers below.";
var Cred_Status_InvitationSent$1 = "Endorsement invitation sent!";
var Cred_Status_PaymentDescription$1 = "Degreed Skill Certification Process";
var Cred_Status_PaymentHeading$1 = "Payment";
var Cred_Status_PeerReviewed$1 = "Peer reviews of your application";
var Cred_Status_PeerReviewedDescription$1 = "Your peers are still reviewing you.";
var Cred_Status_PeerReviewedDescriptionCompleted$1 = "Your peers have finished reviewing you.";
var Cred_Status_Resend$1 = "Resend Invite";
var Cred_Status_ReviewsHeading$1 = "Reviews";
var Cred_Status_ScAwarded$1 = "Scholarship awarded!";
var Cred_Status_ScAwardedDescription$1 = "No payment needed.";
var Cred_Status_ScNotAwarded$1 = "Payment required";
var Cred_Status_ScNotAwardedDescription$1 = "The scholarship wasn't issued, but you did get a discount!";
var Cred_Status_ScPending$1 = "Scholarship pending";
var Cred_Status_ScPendingDescription$1 = "If your scholarship is approved, you won't have to pay for the application. Otherwise you'll get a discount.";
var Cred_Status_SkipEndorser$1 = "Certify with {{endorserCount}} endorser(s)";
var Cred_Status_WaitingOnEndorser$1 = "Waiting on endorser";
var Cred_Submit_AppliedCodeText$1 = "Applied";
var Cred_Submit_ApplyCodeText$1 = "Apply Code";
var Cred_Submit_Header$1 = "Legal & Payment";
var Cred_Submit_HeaderWithCredits$1 = "Legal & Submit";
var Cred_Submit_IAgreeGenuine$1 = "I agree to my application being reviewed by others.";
var Cred_Submit_PaymentBillingInfo$1 = "Billing Information";
var Cred_Submit_PaymentCard$1 = "Card Number";
var Cred_Submit_PaymentCardValidation$1 = "Card number is required";
var Cred_Submit_PaymentChoosePayment$1 = "Choose Payment Option";
var Cred_Submit_PaymentConfirm$1 = "Confirm payment";
var Cred_Submit_PaymentCurrency$1 = "$";
var Cred_Submit_PaymentCvv$1 = "CVV Number";
var Cred_Submit_PaymentError$1 = "Payment wasn't made";
var Cred_Submit_PaymentExp$1 = "Exp. Date";
var Cred_Submit_PaymentExpPlaceholder$1 = "MM/YY";
var Cred_Submit_PaymentExpValidation$1 = "Exp is required";
var Cred_Submit_PaymentFirstName$1 = "First Name";
var Cred_Submit_PaymentFirstNameValidation$1 = "First name is required";
var Cred_Submit_PaymentHeader$1 = "Payment";
var Cred_Submit_PaymentLastName$1 = "Last Name";
var Cred_Submit_PaymentLastNameValidation$1 = "Last name is required";
var Cred_Submit_PaymentNotRequired$1 = "No payment required!";
var Cred_Submit_PaymentProvidedBy$1 = "Promo code";
var Cred_Submit_PaymentReceived$1 = "Payment received. Thank you.";
var Cred_Submit_PlagiarismCheck$1 = "I agree all information provided is my own original work and adequate citations have been provided.";
var Cred_Submit_PlagiarismDescription$1 = "Degreed reserves the right to review your application for plagiarism. Provide only your own original work in your application and cite referenced materials as necessary.";
var Cred_Submit_PlagiarismHeader$1 = "Plagiarism Check";
var Cred_Submit_PromoCodeExpand$1 = "Have a promo code? Enter it here.";
var Cred_Submit_PromoNotFound$1 = "Promo code not found";
var Cred_Submit_PromoProductError$1 = "The promo code used is not valid for selected product. Make a new selection above or enter a new code.";
var Cred_Submit_ReviewedByDescription$1 = "Your skill behaviors and associated evidence will be reviewed and evaluated by other applicants, endorsers, and the expertise panel. By including evidence materials, you agree to allow other applicants, endorsers, and the expertise panel to view those materials as necessary to evaluate your skill level.";
var Cred_Submit_ReviewedByHeader$1 = "You Will Be Reviewed by Others";
var Cred_Submit_SaveApplication$1 = "Save application";
var Cred_Submit_ScholarshipCode$1 = "Promo code";
var Cred_Submit_ScholarshipDiscount$1 = "Promo discount";
var Cred_Submit_SecurePayment$1 = "Secure payment";
var Cred_Submit_SkillProcessName$1 = "Degreed Skill Certification Process";
var Cred_Submit_SubmitApplication$1 = "Submit application";
var Cred_Submit_SubTotal$1 = "Subtotal";
var Cred_Submit_TermsAgree$1 = "I have read and agree to the Evidence Submission Agreement.";
var Cred_Submit_TermsDescription$1 = "By submitting evidence of your skills for certification, you warrant: you have read, understood and hereby agree to the Degreed Honor Code; you are the sole owner of the content; or, if you are not the sole owner and others have contributed to the development of the content, you have all necessary rights, consents and permissions to submit this evidence and make these representations and warranties; none of the content contains any third party’s (including an employer’s) confidential or proprietary information; you are solely responsible for any information you provide or submit, and such content complies with applicable law, and is not illegal, abusive, defamatory, obscene, infringing, threatening, false, misleading or otherwise inappropriate as determined in Degreed’s sole discretion; and you are in compliance with all of Degreed’s terms and conditions for your use of this service.";
var Cred_Submit_TermsHeader$1 = "Evidence Submission Agreement";
var Cred_Success_Heading$1 = "Application Successfully Submitted";
var Cred_Success_Instructions$1 = "<p>You have successfully submitted your application. The next steps happen after the submission deadline for your skill. You can make any final edits to your application until the deadline. After that, your endorsers will be contacted and you’ll be moved into the next part of the process. You can check the submission deadline and view what’s next on the {{linkStartHtml}}Overview page{{linkEndHtml}}.</p>\r\n<p>Your endorsers will be emailed after the submission deadline on {{date}}.</p>\r\n<p>We’ll also email you when it’s time for the next step!</p>";
var Cred_Success_InviteOthers$1 = "You can speed up the process by Inviting other people to apply";
var Cred_Success_SubHeading$1 = "Great work…";
var Cred_Verify_CodeLabel$1 = "Degreed Certificate Code";
var Cred_Verify_FollowupLabel$1 = "Where did you find this certificate?";
var Cred_Verify_FollowupPlaceholder$1 = "Enter a link to the webpage or contact information for the person who provided this certificate";
var Cred_Verify_FollowupSuccess$1 = "Thank You.";
var Cred_Verify_Heading$1 = "Verify certificate";
var Cred_Verify_Instructions$1 = "Every Degreed certificate has a unique code you can use to check its validity. You can find the certificate code in the bottom-right corner of the certificate. This validator will let you know what certificate it corresponds to so you can verify the certificate.";
var Cred_Verify_InvalidInstructions$1 = "This code does not match a valid certificate. Let us know where you found it so we can follow up.";
var Cred_Verify_InvalidMessage$1 = "This is not a valid certificate";
var Cred_Verify_ValidMessage$1 = "This is a valid certificate";
var Cred_Verify_VerifyCodeButton$1 = "Verify Code";
var Cred_Wait_Heading$1 = "Application Successfully Submitted";
var Cred_Wait_Instructions$1 = "We have successfully received your application. You will be reviewed together with 10 peers. We’re waiting until we get a few more people to apply for the same skill to proceed. Go have a cop of coffee, you deserved it. We’ll send you a notification when you can continue with reviewing your peers.";
var Cred_Wait_InviteOthers$1 = "You can speed up the process by Inviting other people to apply";
var Cred_Wait_SubHeading$1 = "Now we wait...";
var CredentialAwardedEmail_Autonomy$1 = "Autonomy";
var CredentialAwardedEmail_Autonomy1Desc$1 = "You work best within a structured environment with supervision, predetermined processes, and a set criterion to judge output against.";
var CredentialAwardedEmail_Autonomy2Desc$1 = "You can solve basic problems and tasks on your own—but when a complex issue arises, you’ll likely need some help. ";
var CredentialAwardedEmail_Autonomy3Desc$1 = "You can solve basic problems and tasks on your own—but when a complex issue arises, you’ll likely need some help. ";
var CredentialAwardedEmail_Autonomy4Desc$1 = "You can solve basic problems and tasks on your own—but when a complex issue arises, you’ll likely need some help. ";
var CredentialAwardedEmail_Autonomy5Desc$1 = "You can solve basic problems and tasks on your own—but when a complex issue arises, you’ll likely need some help. ";
var CredentialAwardedEmail_Autonomy6Desc$1 = "You can work well independently on very complex projects. You’ve applied your unique viewpoint to solve complicated issues and innovate to help the field advance. You’re likely good at communicating problems and potential solutions, and can lead teams of others who are practitioners.";
var CredentialAwardedEmail_Autonomy7Desc$1 = "You’ve likely successfully led teams as they work on big initiatives that push the boundaries of your field. And you can do it all—whether you’re still a practitioner or you spend the bulk of your time leading others, your judgment is well-respected from those within your domain.";
var CredentialAwardedEmail_Autonomy8Desc$1 = "You are completely autonomous, and you are regarded as a domain leader and scholar. You have your choice of projects, and you likely select those that will allow you to create significant impact in the field and offer new ideas or practices.";
var CredentialAwardedEmail_Industry$1 = "Industry";
var CredentialAwardedEmail_Industry1Desc$1 = "You’re new to the industry and just getting to know its history, best practices, and challenges.";
var CredentialAwardedEmail_Industry2Desc$1 = "Your familiarity with the industry best-practices and terminology is growing, as is your knowledge of trends and technology.";
var CredentialAwardedEmail_Industry3Desc$1 = "Your familiarity with the industry best-practices and terminology is growing, as is your knowledge of trends and technology.";
var CredentialAwardedEmail_Industry4Desc$1 = "Your familiarity with the industry best-practices and terminology is growing, as is your knowledge of trends and technology.";
var CredentialAwardedEmail_Industry5Desc$1 = "Your familiarity with the industry best-practices and terminology is growing, as is your knowledge of trends and technology.";
var CredentialAwardedEmail_Industry6Desc$1 = "You know the industry like the back of your hand. You can clearly see where your industry is headed in the next few years, and how your work interacts and affects other fields.";
var CredentialAwardedEmail_Industry7Desc$1 = "Your field is defined by unpredictable changes. You’re good at flexing with those changes and making high-level judgments. Because you’re taking the lead in your field, it’s likely that many in the industry look to you for guidance on challenges, specialties, and latest developments, as well as insight into what the future will hold. ";
var CredentialAwardedEmail_Industry8Desc$1 = "You have much to offer the industry in terms of of leadership and innovations. The work you do is often referred to as groundbreaking by those familiar with the industry. You are one of the top influencers of your field ,and have the ability to invent the tools to solve the biggest problems the field has to offer. You have a grasp on what the next 10 years of your domain will hold.<br /><br />This puts you in a position of leadership, guidance, and mentorship.";
var CredentialAwardedEmail_Knowledge$1 = "Knowledge";
var CredentialAwardedEmail_Knowledge1Desc$1 = "You have general knowledge about some parts of the skill.";
var CredentialAwardedEmail_Knowledge2Desc$1 = "You’ve gained a working, fundamental knowledge of your skill domain. While you know there’s still plenty left to learn, you’ve got the basics down.";
var CredentialAwardedEmail_Knowledge3Desc$1 = "You’ve gained a working, fundamental knowledge of your skill domain. While you know there’s still plenty left to learn, you’ve got the basics down.";
var CredentialAwardedEmail_Knowledge4Desc$1 = "You’ve gained a working, fundamental knowledge of your skill domain. While you know there’s still plenty left to learn, you’ve got the basics down.";
var CredentialAwardedEmail_Knowledge5Desc$1 = "You’ve gained a working, fundamental knowledge of your skill domain. While you know there’s still plenty left to learn, you’ve got the basics down.";
var CredentialAwardedEmail_Knowledge6Desc$1 = "You’ve mastered the knowledge, theory, tools, methodology, and processes of your skill domain. Not only can you apply them successfully to pretty much any problem— large or small, simple or complex— you can also clearly communicate these concepts to others.";
var CredentialAwardedEmail_Knowledge7Desc$1 = "You have in depth knowledge of the current theories (including their limits), and you apply advanced specialized knowledge, research methods, and approaches in all sorts of scenarios. You think about problems in a highly complex way and develop solutions that others will often use or imitate. You also have knowledge of adjoining areas of expertise and how they relate to your field.";
var CredentialAwardedEmail_Knowledge8Desc$1 = "As a Level 8, your knowledge and unique vision of the field is highly sought-after. You have a grasp on what the future of your domain will hold and how it might affect people, tools, technology, processes, and the world as a whole.  This requires a capacity for a wide range of strategic and scientific thinking, coupled with creative action.<br /><br />Chances are, you’re leading the field as a scholar, influencer, or published researcher. You look at solving problems differently, invent new solutions, develop new findings, and expand the existing body of knowledge, including specialized knowledge involving other areas, skills, and disciplines.";
var CredentialAwardedEmail_LearnMore$1 = "Get the Most Out of Your Certification";
var CredentialAwardedEmail_LearnMoreDescFormat$1 = "Congratulations! Your certificate is ready and is available in Degreed. Now that you’ve been awarded your certificate, you can read more about your level and start sharing your expertise. Follow the link below to:<br/>  <br/>  <ul>  <li>View and download your certificate</li>  <li>Add it to your LinkedIn</li>  <li>Share it on your social profiles</li>  <li>List it on your resume</li>  <li>Learn about different levels</li>  </ul>";
var CredentialAwardedEmail_Level10Desc$1 = "<strong>Knowledge</strong>\r\n<br />You have a general knowledge about some parts of the skill.\r\n<br /><br />\r\n<b>Tasks and Tools</b>\r\n<br />You’re just beginning to learn the tools associated with your skill and how to use them to complete simple, routine tasks.\r\n<br /<br /><b>Autonomy</b>\r\n<br />You work best within a structured environment with supervision, pre-determined processes, and a set criterion to judge output against.\r\n<br /><br /><b>Industry</b>\r\n<br />You’re new to the industry and just getting to know its history, best practices, and challenges.\r\n<br /><br /><b>Level up</b>\r\n<br /><ul>\r\n<li>Soak up as much information as you can. It’s important for you to take advantage of your ability to learn and grow in order to move up to the next levels and master the domain. </li>\r\n<li>Pay attention. Learn from the influencers in your space: blogs, webinars, e-newsletters, TED talks, AMAs, and everything else.</li>\r\n<li>Learn from the various forms of content available: videos, books, courses, classes, etc.</li>\r\n<li>Seek others who are familiar with the field to help guide you in the right direction as you get started.</li>\r\n</ul>";
var CredentialAwardedEmail_Level1Desc$1 = "As a Level 1, you have general knowledge about some aspects of the skill. You’re just beginning to learn the tools associated with your skill and how to use them to complete simple, routine tasks. You work best within a structured environment with supervision, predetermined processes, and set criteria to judge output against.";
var CredentialAwardedEmail_Level1Intro$1 = "Congratulations! You’ve earned a Skill Certification in {0} from Degreed. You’ve been certified at Level 1, which means you’re <b>a Beginner</b> in using your skill.";
var CredentialAwardedEmail_Level1Title$1 = "Level 1: Beginner";
var CredentialAwardedEmail_Level2Desc$1 = "As a Level 2, you’ve gained a working, fundamental knowledge of your skill domain. While you know there’s still plenty left to learn, you’ve got the basics down. You can solve basic problems and complete tasks on your own—but when a complex issue arises, you’ll likely need some help.";
var CredentialAwardedEmail_Level2Intro$1 = "Congratulations! You’ve earned a Skill Certification in {0} from Degreed. You’ve been certified at Level 2, which means you’re <b>Capable</b> in using your skill.";
var CredentialAwardedEmail_Level2Title$1 = "Level 2: Capable";
var CredentialAwardedEmail_Level3Desc$1 = "At Level 3, you’ve extended your knowledge beyond fundamentals into the theory of your skill domain. You’re comfortable using the tools of the trade as you continue to develop your technical skills. For the most part, you can work independently on new challenges. You know enough about your skills to be self-critical, and know the difference between good work and great work. You’ve also become good at setting your own goals to measure progress.";
var CredentialAwardedEmail_Level3Intro$1 = "Congratulations! You’ve earned a Skill Certification in {0} from Degreed. You’ve been certified at Level 3, which means you’re Intermediate in using your skill.";
var CredentialAwardedEmail_Level3Title$1 = "Level 3: Intermediate";
var CredentialAwardedEmail_Level4Desc$1 = "As a Level 4, you’re a skilled practitioner that uses a broad range of methods to solve problems from planning to execution. You can tackle more specialized tasks and apply your skills to complex problems that might require a new process or approach.  You can work independently on complex projects, and when those projects are complete, you’re able to look at your work and accurately evaluate whether it was successful.";
var CredentialAwardedEmail_Level4Intro$1 = "Congratulations! You’ve earned a Skill Certification in {0} from Degreed. You’ve been certified at Level 4, which means you’re <b>Effective</b> in using your skill.";
var CredentialAwardedEmail_Level4Title$1 = "Level 4: Effective";
var CredentialAwardedEmail_Level5Desc$1 = "As a Level 5, you have robust, and likely specialized knowledge about your skill. You have a proven track record of success, and bring a wide range of cognitive or practical skills to the table to solve new and complex problems. You can lead an initiative and see it through to the end.";
var CredentialAwardedEmail_Level5Intro$1 = "Congratulations! You’ve earned a Skill Certification in {0} from Degreed. You’ve been certified at Level 5, which means you’re <b>Experienced</b> in using your skill.";
var CredentialAwardedEmail_Level5Title$1 = "Level 5: Experienced";
var CredentialAwardedEmail_Level6Desc$1 = "As a Level 6, you’ve mastered the knowledge, theory, tools, methodology, and processes of your skill domain. Not only can you apply them successfully to pretty much any problem—large or small, simple or complex—you can also clearly communicate these concepts to others. ";
var CredentialAwardedEmail_Level6Intro$1 = "Congratulations! You’ve earned a Skill Certification in {0} from Degreed. You’ve been certified at Level 6, which means you’re <b>Advanced</b> in using your skill.";
var CredentialAwardedEmail_Level6Title$1 = "Level 6: Advanced";
var CredentialAwardedEmail_Level7Desc$1 = "As a Level 7, you’re an innovator and your work is likely highlighted as industry best. You use tools in such a complex and experimental way that others look to you for best practices—you’re the one setting the trends that others will follow. You also likely have one or two areas of expertise that are highly specialized or advanced.";
var CredentialAwardedEmail_Level7Intro$1 = "Congratulations! You’ve earned a Skill Certification in {0} from Degreed. You’ve been certified at Level 7, which means you’re <b>Distinguished</b> in using your skill.";
var CredentialAwardedEmail_Level7Title$1 = "Level 7: Distinguished";
var CredentialAwardedEmail_Level8Desc$1 = "As a Level 8, your knowledge and unique vision of the field are highly sought-after. You have a grasp on what the future of your domain will hold and how it might affect people, tools, technology, processes, and the world as a whole. You are recognized as a world-class leader in your field and are likely developing new standards and practices, innovating beyond the majority of your peers.";
var CredentialAwardedEmail_Level8Intro$1 = "Congratulations! You’ve earned a Skill Certification in {0} from Degreed. You’ve been certified at Level 8, which means you’re a Master in using your skill.";
var CredentialAwardedEmail_Level8Title$1 = "Level 8: Master";
var CredentialAwardedEmail_Level9Desc$1 = "<strong>Knowledge</strong>\r\n<br />You have a general knowledge about some parts of the skill.\r\n<br /><br />\r\n<b>Tasks and Tools</b>\r\n<br />You’re just beginning to learn the tools associated with your skill and how to use them to complete simple, routine tasks.\r\n<br /<br /><b>Autonomy</b>\r\n<br />You work best within a structured environment with supervision, pre-determined processes, and a set criterion to judge output against.\r\n<br /><br /><b>Industry</b>\r\n<br />You’re new to the industry and just getting to know its history, best practices, and challenges.\r\n<br /><br /><b>Level up</b>\r\n<br /><ul>\r\n<li>Soak up as much information as you can. It’s important for you to take advantage of your ability to learn and grow in order to move up to the next levels and master the domain. </li>\r\n<li>Pay attention. Learn from the influencers in your space: blogs, webinars, e-newsletters, TED talks, AMAs, and everything else.</li>\r\n<li>Learn from the various forms of content available: videos, books, courses, classes, etc.</li>\r\n<li>Seek others who are familiar with the field to help guide you in the right direction as you get started.</li>\r\n</ul>";
var CredentialAwardedEmail_LevelUp$1 = "Level up";
var CredentialAwardedEmail_LevelUp1Desc$1 = "<ul><li>Soak up as much information as you can. It’s important for you to take advantage of your ability to learn and grow in order to move up to the next levels and master the domain. </li>\r\n<li>Pay attention. Learn from the influencers in your space: blogs, webinars, e-newsletters, TED talks, AMAs, and everything else.</li>\r\n<li>Learn from the various forms of content available: videos, books, courses, classes, etc.</li>\r\n<li>Seek others who are familiar with the field to help guide you in the right direction as you get started.</li></ul>";
var CredentialAwardedEmail_LevelUp2Desc$1 = "<ul><li>Continue learning and working to build your skills in different scenarios to apply your knowledge to more complex problems and situations.</li>\r\n<li>Seek interaction with those in your domain to see how they approach tasks, situations, and issues they encounter. As you do this, you can begin to develop your own unique approach to these things by applying what you know and continuing to learn.</li></ul>";
var CredentialAwardedEmail_LevelUp3Desc$1 = "<ul><li>Continue learning and working to build your skills in different scenarios to apply your knowledge to more complex problems and situations.</li>\r\n<li>Seek interaction with those in your domain to see how they approach tasks, situations, and issues they encounter. As you do this, you can begin to develop your own unique approach to these things by applying what you know and continuing to learn.</li></ul>";
var CredentialAwardedEmail_LevelUp4Desc$1 = "<ul><li>Continue learning and working to build your skills in different scenarios to apply your knowledge to more complex problems and situations.</li>\r\n<li>Seek interaction with those in your domain to see how they approach tasks, situations, and issues they encounter. As you do this, you can begin to develop your own unique approach to these things by applying what you know and continuing to learn.</li></ul>";
var CredentialAwardedEmail_LevelUp5Desc$1 = "<ul><li>Continue learning and working to build your skills in different scenarios to apply your knowledge to more complex problems and situations.</li>\r\n<li>Seek interaction with those in your domain to see how they approach tasks, situations, and issues they encounter. As you do this, you can begin to develop your own unique approach to these things by applying what you know and continuing to learn.</li></ul>";
var CredentialAwardedEmail_LevelUp6Desc$1 = "<ul><li>Look for opportunities to share your knowledge and experience with a broader audience, whether that’s through conferences, webinars, online communities, or classrooms.</li>\r\n<li>Continue to push the boundaries of your own knowledge and skills through innovative applications.</li></ul>";
var CredentialAwardedEmail_LevelUp7Desc$1 = "<ul><li>Take on some of the industry’s biggest challenges.</li>\r\n<li>Share your findings with others to push the industry forward and encourage innovation.</li>\r\n<li>Be a creator of the tools and trends that shape the industry.</li>\r\n<li>Apply knowledge, theory, and practices from other areas of expertise to create new solutions.</li>\r\n<li>Seek out opportunities for research.</li>\r\n</ul>";
var CredentialAwardedEmail_LevelUp8Desc$1 = "<ul><li>As a master, it’s crucial to use your knowledge to push your industry, and those related, forward. It’s time to use your skill to invent the theories, processes, tech and tools that will solve the greatest challenges in your domain.</li>\r\n<li>Expose yourself to and communicate with other masters, work together when possible for the development of the field as a whole.</li>\r\n<li>Consider the most effective ways for you to mentor, teach, and share your knowledge.</li></ul>";
var CredentialAwardedEmail_MessageParagraph1Format$1 = "You’ve been certified in {0} at Degreed level {1}!";
var CredentialAwardedEmail_MessageParagraph2$1 = "What your level says about you:";
var CredentialAwardedEmail_MessageParagraph3$1 = "You can now share your certificate on your Degreed profile,  your resume, or your social media profiles. Your certification never expires, but does include a date so everybody who sees it knows when you reached this level.";
var CredentialAwardedEmail_MessageParagraph6$1 = "Keep Leveling Up.";
var CredentialAwardedEmail_MessageParagraph7$1 = "Your skills won’t maintain themselves. Keep learning, and set some learning goals.";
var CredentialAwardedEmail_ShareYourExpertise$1 = "Share Your Expertise";
var CredentialAwardedEmail_ShareYourExpertiseDesc$1 = "You can now share your certificate on your Degreed profile, your resume, or your social media profiles. Your certification never expires, but does include a date so everybody who sees it knows when you reached this level.";
var CredentialAwardedEmail_Subject$1 = "Skill Certification: Your skill certificate is available";
var CredentialAwardedEmail_TaskTools$1 = "Tasks and Tools";
var CredentialAwardedEmail_TaskTools1Desc$1 = "You’re just beginning to learn the tools associated with your skill and how to use them to complete simple, routine tasks.";
var CredentialAwardedEmail_TaskTools2Desc$1 = "You’re becoming familiar with industry-standard tools and processes, and you understand how to apply them to routine tasks. You’re also starting to understand how to evaluate the quality of your own work outside of set criteria.";
var CredentialAwardedEmail_TaskTools3Desc$1 = "You’re becoming familiar with industry-standard tools and processes, and you understand how to apply them to routine tasks. You’re also starting to understand how to evaluate the quality of your own work outside of set criteria.";
var CredentialAwardedEmail_TaskTools4Desc$1 = "You’re becoming familiar with industry-standard tools and processes, and you understand how to apply them to routine tasks. You’re also starting to understand how to evaluate the quality of your own work outside of set criteria.";
var CredentialAwardedEmail_TaskTools5Desc$1 = "You’re becoming familiar with industry-standard tools and processes, and you understand how to apply them to routine tasks. You’re also starting to understand how to evaluate the quality of your own work outside of set criteria.";
var CredentialAwardedEmail_TaskTools6Desc$1 = "You use your robust application of tools, methods, and processes to successfully complete the most complex of tasks. You’re innovating the application of new technologies by applying them early on and evaluating their effectiveness.";
var CredentialAwardedEmail_TaskTools7Desc$1 = "You’re an innovator to the core, and your work is likely highlighted as industry best or best in class. You use tools in such a complex and experimental way that others look to you for best practices—you’re the one setting the trends that others will follow. You also likely have one or two sub-areas that are highly specialized or advanced.";
var CredentialAwardedEmail_TaskTools8Desc$1 = "You’re a master of your skill and a creator of what others are using. You use your research to allow you to develop and release new tools, processes, and technologies for use in your domain. You’ve taken your experiences and applied them towards innovations, whether it’s in the form of inventing more effective tools or authoring new theories on your domain.<br /><br />You are recognized as a world-class leader in your field, and are likely developing new standards, practices, and innovating beyond the majority of your peers.";
var CredentialAwardedEmail_Title$1 = "Skill Certification: Your skill certificate is available";
var CredentialCompleteBehaviorsEmail_MessageParagraph1Format$1 = "The most important step in getting your {0} skills certified is providing evidence of your skill level and expertise. You’ll provide three examples of ways you have applied this skill in the form of “I can…” statements. ";
var CredentialCompleteBehaviorsEmail_MessageParagraph2$1 = "For example:";
var CredentialCompleteBehaviorsEmail_MessageParagraph3$1 = "“I can take a corporate Facebook page from 20,000 to 1,000,000 likes organically.”";
var CredentialCompleteBehaviorsEmail_MessageParagraph4$1 = "You’ll also answer two questions about your skill evidence and provide links or attachments that help demonstrate it. Be careful to not upload any proprietary data. Keep in mind your 3 skill behaviors will be viewed by peers in blind 1-on-1 peer reviews, as well as reviewed by your endorsers and the Degreed Expertise panel.";
var CredentialCompleteBehaviorsEmail_MessageParagraph5$1 = "Gathering evidence and completing this section of the application might seem daunting, but think of it kinda like applying for grad school—it’s critical in helping us understand your skill level and how you rank amongst your peers. So dig in, gather your evidence, and show us your best.";
var CredentialCompleteBehaviorsEmail_MessageParagraph6Format$1 = "If you get stuck, we are always here to help: info@degreed.com.";
var CredentialCompleteBehaviorsEmail_Subject$1 = "Skill Certification: Submit your evidence";
var CredentialCompleteBehaviorsEmail_Title$1 = "Skill Certification: Submit your evidence";
var CredentialCompleteEndorsersEmail_MessageParagraph1$1 = "You did it—you entered your 3 skill behaviors! Give yourself a big pat on the back—or pour yourself a drink—you’ve earned it.";
var CredentialCompleteEndorsersEmail_MessageParagraph2$1 = "The next step in getting your Skill Certified is submitting 3 endorsers. Receiving at least one endorsement is the key to completing your application. Endorsers are emailed to confidentially review your skill behaviors and vouch for the accuracy of your evidence, as well as answer questions about how you compare to others they’ve worked with in the same skill.";
var CredentialCompleteEndorsersEmail_MessageParagraph3$1 = "This should take them about 30 minutes. Don’t worry—we won’t solicit them for anything else. You can also send them a personal message letting them know why you’re asking for their endorsement and what impact it can have.";
var CredentialCompleteEndorsersEmail_MessageParagraph4$1 = "Pro Tip:";
var CredentialCompleteEndorsersEmail_MessageParagraph5$1 = "These are no LinkedIn endorsements, so choose endorsers who know about your skill behaviors and have experience working with you. Don’t submit your next door neighbor because he’s known you the longest.";
var CredentialCompleteEndorsersEmail_Subject$1 = "Skill Certification: Submit your endorsers";
var CredentialCompleteEndorsersEmail_Title$1 = "Skill Certification: Submit your endorsers";
var CredentialEmail_AwardVideo$1 = '<br /><br /> <iframe width="560" height="315" src="https://www.youtube.com/embed/0UBz320iBEQ?rel=0" frameborder="0" allowfullscreen></iframe><br />';
var CredentialEmail_ContinueToApplication$1 = "Continue to Application";
var CredentialEmail_FooterReason$1 = "Degreed sent you this email because you're certifying a skill.";
var CredentialEmail_GetCertified$1 = "Get Certified";
var CredentialEmail_ReviewPeers$1 = "Review Peers";
var CredentialEmail_ViewCertificate$1 = "View Your Certificate";
var CredentialEmail_ViewEndorsements$1 = "View Endorsement Status";
var CredentialEmail_ViewStatus$1 = "View Status";
var CredentialEmail_WhatIsDegreed$1 = "What is Degreed?";
var CredentialEmail_WhatIsDegreedDesc$1 = "Degreed is a learning company dedicated to changing the way we all develop our skills, build our expertise, and grow our careers. Founded on the mission to jailbreak the degree, we believe that ALL learning matters, regardless of how or where it happens. We’re dedicated to building products—and a future—that enable every learner to recognize and fulfill their personal missions. Because the future doesn’t care how you became an expert, just that you did.";
var CredentialEndorserCompletedEmail_MessageParagraph1Format$1 = "Hi, {0}!";
var CredentialEndorserCompletedEmail_MessageParagraph2Format$1 = "{0} {1} just completed your endorsement for {2} on Degreed, bringing you one step closer to being able to show your expertise in your skill!";
var CredentialEndorserCompletedEmail_MessageParagraph3Format$1 = 'Find <a style="text-decoration: none;" href="{0}">more information about your next step</a> at Degreed. Good luck!';
var CredentialEndorserCompletedEmail_Subject$1 = "Skill Certification: Congratulations on your endorsement in {0}!";
var CredentialEndorserCompletedEmail_Title$1 = "Skill Certification: Congratulations on your endorsement in {0}!";
var CredentialEndorserDeclinedEmail_MessageParagraph1Format$1 = "{0} declined to endorse your application for {1} certification. But don’t worry, you can submit a new endorser to keep your application moving through the process.";
var CredentialEndorserDeclinedEmail_MessageParagraph2$1 = "Submit a new endorser here:";
var CredentialEndorserDeclinedEmail_Subject$1 = "Skill Certification: One of your endorsers declined";
var CredentialEndorserDeclinedEmail_Title$1 = "Skill Certification: One of your endorsers declined";
var CredentialEndorserFollowupEmail_MessageParagraph1Format$1 = "In order to get certified in {0}, {1} has requested your endorsement of their experience and skill level.  If you choose to endorse {1}, you will confidentially review the evidence they have provided, vouch for the integrity of said evidence, and rate how {1} compares against others you’ve worked with in the same capacity. This should take you about 20 minutes.";
var CredentialEndorserFollowupEmail_MessageParagraph2$1 = "Start your endorsement here: ";
var CredentialEndorserFollowupEmail_MessageParagraph3Format$1 = "If you can’t or don’t want to validate {0}’s evidence, you have the option to decline.";
var CredentialEndorserFollowupEmail_Subject$1 = "Reminder to endorse {0} for {1} certification";
var CredentialEndorserFollowupEmail_TitleFormat$1 = "Reminder to endorse {0} for {1} certification";
var CredentialEndorsersInitialEmail_MessageParagraph1Format$1 = "{0} {1} would like to become certified for their skill in {2} and has requested your endorsement of their experience and skill level.";
var CredentialEndorsersInitialEmail_MessageParagraph2Format$1 = "If you choose to endorse {0}, you will confidentially review the evidence they have provided and vouch for the accuracy of it:";
var CredentialEndorsersInitialEmail_MessageParagraph3Format$1 = "This should take you about 20 minutes and is necessary for {0} to receive their certificate in {1}. Visit and review the application here:";
var CredentialEndorsersInitialEmail_MessageParagraph4Format$1 = "If you can’t or don’t want to validate {0}’s evidence, you have the option to decline.";
var CredentialEndorsersInitialEmail_MessageParagraph5$1 = "You will then be asked a few questions about their skill level:";
var CredentialEndorsersInitialEmail_Subject$1 = "{0} has requested your endorsement for skill certification";
var CredentialEndorsersInitialEmail_Title$1 = "{0} has requested your endorsement for skill certification";
var CredentialEndorserThankEmail_MessageParagraph1Format$1 = "{0} has received their Degreed Certification in {1}";
var CredentialEndorserThankEmail_MessageParagraph2Format$1 = "Thanks for being {0}’s endorser. They have successfully completed the skill certification process and are now certified, so give them a shout out or note of congratulations! {0}’s skills and certifications are available to view on their Degreed profile (as long as they’ve chosen to make them public).";
var CredentialEndorserThankEmail_MessageParagraph3$1 = "You can get skill certified too!";
var CredentialEndorserThankEmail_MessageParagraph4Format$1 = "Join {0} in becoming certified. Skill Certifications can help you understand your skill level, and give you a way to represent your talent to others. Degreed currently certifies over 1500 skills, and as an endorser you’ll get a 25% discount on your first skill certification.";
var CredentialEndorserThankEmail_PromoCode$1 = "E7AKB8QC";
var CredentialEndorserThankEmail_Subject$1 = "Thanks for your endorsement!";
var CredentialEndorserThankEmail_Title$1 = "Thanks for your endorsement!";
var CredentialEndorserThankEmail_ViewProfile$1 = "View {0}’s profile";
var CredentialPaidInFullViaPromoEmail_Header$1 = "Payment Confirmation";
var CredentialPaidInFullViaPromoEmail_MessageParagraph1Format$1 = "Your promo code covered the fee for {0} Certification.";
var CredentialPaidInFullViaPromoEmail_MessageParagraph2$1 = "This means your application is complete and has been submitted for certification. You’ll receive instructions on the next steps in the process shortly. In the meantime, keep learning!";
var CredentialPaidInFullViaPromoEmail_PromotionalCodeDiscount$1 = "Promotional Code Discount";
var CredentialPaidInFullViaPromoEmail_Subject$1 = "Skill Certification: Receipt from Degreed";
var CredentialPaidInFullViaPromoEmail_Subtotal$1 = "Subtotal";
var CredentialPaidInFullViaPromoEmail_Title$1 = "Skill Certification: Receipt from Degreed";
var CredentialRateYourPeersEmail_MessageParagraph1$1 = "Next, to help us accurately assess applicants’ expertise, you will rate up to 10 sets in 1-to-1 comparisons. This takes about an hour.";
var CredentialRateYourPeersEmail_MessageParagraph2Format$1 = "Heads up! You’ll be compared to others as well, but its nothing to sweat about. This helps us determine relative rank order, is 95% accurate, and is the first of many factors in determining your skill level.</br> <strong>Your ratings of peers also help us measure your expertise, too, so work carefully! </strong>";
var CredentialRateYourPeersEmail_MessageParagraph3Format$1 = "Please complete your reviews by {0} to be awarded a final skill level and certificate.";
var CredentialRateYourPeersEmail_MessageParagraph4$1 = "Finish the reviews here:";
var CredentialRateYourPeersEmail_Subject$1 = "Skill Certification: Next steps—Rate your peers";
var CredentialRateYourPeersEmail_Title$1 = "Skill Certification: Next steps—Rate your peers";
var CredentialRateYourPeersFollowupEmail_MessageParagraph1$1 = "We still need your help to accurately assess other applicants’ expertise. You will rate up to 10 sets of your peers in 1-to-1 comparisons.";
var CredentialRateYourPeersFollowupEmail_MessageParagraph2Format$1 = "Heads up! You’ll be compared to others as well, but its nothing to sweat about. This helps us determine relative rank order, is 95% accurate, and is the first of many factors in determining your skill level.</br> <strong>Your ratings of peers also help us measure your expertise, too, so work carefully! </strong>";
var CredentialRateYourPeersFollowupEmail_MessageParagraph3Format$1 = "Please complete your reviews by {0} to be awarded a final skill level and certificate.";
var CredentialRateYourPeersFollowupEmail_MessageParagraph4$1 = "Finish the reviews here:";
var CredentialRateYourPeersFollowupEmail_MessageParagraph5Format$1 = 'Please email <a style="text-decoration: none;" href="mailto:info@degreed.com">info@degreed.com</a> if you have any questions or concerns.';
var CredentialRateYourPeersFollowupEmail_Subject$1 = "Skill Certification: Finish reviewing your peers";
var CredentialRateYourPeersFollowupEmail_Title$1 = "Skill Certification: Finish reviewing your peers";
var CredentialReviewSvc_ErrorSubmitting$1 = "Sorry! There was an error submitting the review.";
var CredentialReviewSvc_GetBehaviorsError$1 = "There was an error attempting to retrieve the skill certification behaviors for the specified application.";
var CredentialReviewSvc_GetError$1 = "Sorry! There was a problem retrieving details.";
var CredentialReviewSvc_GetReviewError$1 = "There was a problem retrieving review details.";
var CredentialSubmissionReminderEmail_FromAddress$1 = "info@degreed.com";
var CredentialSubmissionReminderEmail_MessageParagraph1$1 = "Hello,";
var CredentialSubmissionReminderEmail_MessageParagraph2Format$1 = "Joel here from Degreed. I wanted to let you know that our next Skill Certification application review period for {0} is coming up. If you would like to get certified as soon as possible, submit your application by {1}. If that’s not enough time, don’t sweat it. We restart the process for applicants in {0} on that date each month.";
var CredentialSubmissionReminderEmail_MessageParagraph3Format$1 = 'I’m here to help if you have any questions or if you need more time to complete your application, just reply to this email. You can also check out our <a href="https://www.youtube.com/watch?v=FGewInzqHKY">What is Skill Certification</a> video to help you along.';
var CredentialSubmissionReminderEmail_MessageParagraph4Format$1 = "You will need: <br/>\n<ul>\n<li>Three examples of ways you have applied this skill</li>\n<li>At least one endorser who can vouch for your skill level and experience</li>\n<li>About 4-6 hours (spread over a few sessions)</li></ul>";
var CredentialSubmissionReminderEmail_MessageParagraph5$1 = "Happy applying!";
var CredentialSubmissionReminderEmail_MessageParagraph6$1 = "Joel";
var CredentialSubmissionReminderEmail_Subject$1 = "A reminder from your Skill Certification personal assistant";
var CredentialSubmissionReminderEmail_Title$1 = "A reminder from your Skill Certification personal assistant";
var CredentialSubmittedEmail_MessageParagraph1Format$1 = "Congratulations on finishing your application for {0}! Next up: Review Your Peers";
var CredentialSubmittedEmail_MessageParagraph2$1 = "In the next step, you may be asked to participate in a round of peer reviews, which are anonymous 1-on-1 comparisons. Your application will also be compared to others, but it's nothing to sweat about. Peer reviews help us determine relative rank order with 95% accuracy and is the first of many factors in determining your skill level.";
var CredentialSubmittedEmail_MessageParagraph3Format$1 = "We’ll send you an email notification when you are placed into the next peer review group opening around {0}. There’s nothing you need to do, but sit back, relax, and keep on learning.";
var CredentialSubmittedEmail_MessageParagraph4Format$1 = "Please email info@degreed.com with any questions or comments. We’re here to help!";
var CredentialSubmittedEmail_Subject$1 = "Skill Certification: Great work!";
var CredentialSubmittedEmail_Title$1 = "Great Work!";
var CredentialWaitForReviewsEmail_MessageParagraph1$1 = "Congratulations on getting this far! Now it’s the easy part—just wait for your endorsements to be complete and for our expertise panel to work their magic.";
var CredentialWaitForReviewsEmail_MessageParagraph2$1 = "Next Steps: <br /><ul><li>Wait for at least one of your endorsers to give you their stamp of approval</li><li>Wait for the expertise panel to do a final review and ranking</li></ul>";
var CredentialWaitForReviewsEmail_MessageParagraph3$1 = "You can check the status of those endorsements here:";
var CredentialWaitForReviewsEmail_MessageParagraph4$1 = "While you wait, you can always learn something new on Degreed (shameless plug).";
var CredentialWaitForReviewsEmail_Subject$1 = "Skill Certification: Almost there!";
var CredentialWaitForReviewsEmail_Title$1 = "Almost There!";
var CredentialWaitingForEndorsementsEmail_MessageParagraph1$1 = "Sometimes, people just need a nudge, ya know? We’re still waiting for at least one of your endorsers to review your application and evidence.";
var CredentialWaitingForEndorsementsEmail_MessageParagraph2$1 = "You can check the status of those here: ";
var CredentialWaitingForEndorsementsEmail_MessageParagraph3$1 = "You can also send a reminder email to your endorsers or change your endorsers.";
var CredentialWaitingForEndorsementsEmail_MessageParagraph3Format$1 = 'Send them an automated reminder or add your own personal message:<br /><a style="text-decoration: none;" href="{0}"> {0}</a>';
var CredentialWaitingForEndorsementsEmail_MessageParagraph4Format$1 = 'Or replace an endorser:<br /><a href="{0}"> {0}</a>';
var CredentialWaitingForEndorsementsEmail_MessageParagraphInfo$1 = 'Please email <a style="text-decoration: none;" href="mailto:info@degreed.com">info@degreed.com</a> if you have any questions or concerns.';
var CredentialWaitingForEndorsementsEmail_Subject$1 = "Skill Certification: We're still waiting for your endorsers";
var CredentialWaitingForEndorsementsEmail_Title$1 = "Skill Certification: We're still waiting for your endorsers";
var CredentialWelcomeEmail_MessageDearFormat$1 = "Dear {0}";
var CredentialWelcomeEmail_MessageParagraph1$1 = "The world’s only skill-based professional credential designed to provide a real-time, expert-driven representation of what you know and can do.";
var CredentialWelcomeEmail_MessageParagraph10Format$1 = "Expected date: {0}";
var CredentialWelcomeEmail_MessageParagraph11$1 = 'If you have any questions, concerns, or feedback throughout the process please email <a href="mailto:info@degreed.com">info@degreed.com</a>. Best of luck!';
var CredentialWelcomeEmail_MessageParagraph12$1 = "You can return to your application anytime:";
var CredentialWelcomeEmail_MessageParagraph1Format$1 = 'Welcome to Degreed\'s Skill Certification! You can start your application right now or go back to it later from the menu in the top right of Degreed or with this link: <a href="{0}" target="_blank">{0}</a>';
var CredentialWelcomeEmail_MessageParagraph2$1 = "Here’s the hard truth: your degree has a shelf life, your resume is one-dimensional, and online networking only gets you so far. Degreed Skill Certification™ solves that by giving you an accurate, timely credential that shows the world your true expertise.";
var CredentialWelcomeEmail_MessageParagraph3$1 = "<strong>Step 1: Provide Evidence. </strong>You will provide three examples of ways you apply this skill, including links or attachments to help demonstrate your skill level. Expect to spend a few hours on this.";
var CredentialWelcomeEmail_MessageParagraph3Format$1 = "What you need to get Skill Certified in {0}:<br />\n<ul>\n<li>Three behaviors that represent your skill + evidence to support it</li>\n<li>At least one endorser who can vouch for your skill level and experience</li>                                                  \n<li>About 4 hours (spread over a few sessions)</li>\n<li>Submit your application by the next deadline on {1}. If that is too soon, there will be another deadline the following month.</li>                                             \n</ul>";
var CredentialWelcomeEmail_MessageParagraph4$1 = "<strong>Step 2: List Endorsers. </strong>You need to provide three endorsers, at least one of whom can confirm that your evidence matches their experience of working with you.";
var CredentialWelcomeEmail_MessageParagraph5$1 = "<strong>Step 3: Peer Reviews.</strong> After the submission deadline, we will ask you to review the anonymous applications of others who are applying for certification in the same skill. These reviews, combined with the reviews of our expertise panel, determine your level. This will probably take a few hours, but you can leave and come back.";
var CredentialWelcomeEmail_MessageParagraph6$1 = "<strong>Step 4: Expert Assessment.</strong> Our expertise panel will review your application to assign a level. You don’t need to do anything here.";
var CredentialWelcomeEmail_MessageParagraph7$1 = "<strong>Step 5: Certificate Awarded.</strong> Once that is completed and you have received at least one endorsement, we will award your certificate with your current skill level.";
var CredentialWelcomeEmail_MessageParagraph8$1 = "Start your application right away to reserve a spot. When you begin your application, you’ll receive another message with the deadlines for submitting your information.";
var CredentialWelcomeEmail_MessageParagraph9$1 = "You can share any questions, comments, or feedback with us at info@degreed.com. We’re excited to help you get recognized for your skills!";
var CredentialWelcomeEmail_MessageWelcomeFormat$1 = "Welcome to Degreed Skill Certification";
var CredentialWelcomeEmail_PreviewFormat$1 = "What you need to get Skill Certified in {0}.";
var CredentialWelcomeEmail_Subject$1 = "Welcome to Degreed Skill Certification";
var CredHonorCodeCtrl_AgreeLabel$1 = "I agree to the honor code";
var CredHonorCodeCtrl_DeclarationTitle$1 = "I declare that all information I will provide is genuine";
var CredHonorCodeCtrl_Header$1 = "1.2 Agreeing to Honor Code";
var CredHonorCodeCtrl_Instructions$1 = "I hereby declare that all information I will provide is genuine. Providing false information is seen as fraud and will get you in jail very bad.";
var CredHonorCodeCtrl_Submit$1 = "Save & Next";
var CredSpark_MissingEmployeeId$1 = "An EmployeeID is required to access this assessment.  Contact your Degreed Admin to set up your EmployeeID.";
var CoursesSvc_CoursesError$1 = "Sorry! There was a problem finding courses matching the name you entered.";
var CoursesSvc_ProviderError$1 = "Sorry! There was a problem finding providers matching the name you entered.";
var CourseFormCtrl_Accredited$1 = "From an accredited college or university";
var CourseFormCtrl_AddCourse$1 = "Add Course";
var CourseFormCtrl_AddToCatalogFormat$1 = "Add this course to {{orgName}}'s catalog";
var CourseFormCtrl_Category$1 = "Please add at least one category.";
var CourseFormCtrl_CommentPlaceholder$1 = "Describe what this course is about";
var CourseFormCtrl_Country$1 = "Country";
var CourseFormCtrl_CountryPlaceholder$1 = "Search for a country";
var CourseFormCtrl_CourseFromScormFile$1 = "From a SCORM File";
var CourseFormCtrl_CourseFromScormFile_MetadataMissingMessage$1 = "This SCORM file metadata isn't stored in our system. Don't worry, the course will display just fine! You can upload a new SCORM file to see the file name.";
var CourseFormCtrl_CourseGrade$1 = "Course Grade";
var CourseFormCtrl_CourseGradePlaceholder$1 = "Select course grade";
var CourseFormCtrl_CourseLevel$1 = "Course Level";
var CourseFormCtrl_CourseLevelPlaceholder$1 = "Select course level";
var CourseFormCtrl_CourseNumber$1 = "Course Number";
var CourseFormCtrl_CourseNumberPlaceholder$1 = "Enter a course number";
var CourseFormCtrl_CourseTitle$1 = "Course Title";
var CourseFormCtrl_CourseUrl$1 = "Course URL";
var CourseFormCtrl_CourseUrlAria$1 = "From a course URL";
var CourseFormCtrl_CreditHours$1 = "Credit Hours";
var CourseFormCtrl_CreditHoursPlaceholder$1 = "Enter credit hours";
var CourseFormCtrl_DateCompleted$1 = "Date Completed";
var CourseFormCtrl_DateCompletedPlaceholder$1 = "Select a date";
var CourseFormCtrl_DateTaught$1 = "Date Taught";
var CourseFormCtrl_EditCourse$1 = "Edit Course";
var CourseFormCtrl_FirstYearLevel$1 = "1st Year Level";
var CourseFormCtrl_FourthYearLevel$1 = "4th Year Level";
var CourseFormCtrl_GraduateLevel$1 = "Graduate Level";
var CourseFormCtrl_HowAdded$1 = "How would you like to add this course?";
var CourseFormCtrl_Informal$1 = "From an informal course provider";
var CourseFormCtrl_ITaughtCourse$1 = "I taught this course";
var CourseFormCtrl_Provider$1 = "From a course provider";
var CourseFormCtrl_Provider_Placeholder$1 = "Search for provider name";
var CourseFormCtrl_ProviderName$1 = "Provider Name";
var CourseFormCtrl_SaveCourse$1 = "Save Course";
var CourseFormCtrl_SchoolName$1 = "School Name";
var CourseFormCtrl_SchoolPlaceholder$1 = "Search for a school";
var CourseFormCtrl_SecondYearLevel$1 = "2nd Year Level";
var CourseFormCtrl_SelectCourse$1 = "Please type or select a course name.";
var CourseFormCtrl_SelectProvider$1 = "Please select a course provider.";
var CourseFormCtrl_Summary$1 = "Summary";
var CourseFormCtrl_ThirdYearLevel$1 = "3rd Year Level";
var CourseFormCtrl_TitlePlaceholder$1 = "Enter a course title";
var CourseFormCtrl_UnitType$1 = "Please select a unit type.";
var CourseFormCtrl_UrlError$1 = "The url is not publicly accessible, so cannot be added to our public library.";
var CourseFormCtrl_UrlOrScormRequired$1 = "A course URL or SCORM package is required.";
var CourseFormCtrl_UrlOrSelectionRequired$1 = "A course URL or selection is required.";
var CourseFormCtrl_US$1 = "United States";
var CourseFormCtrl_ValidNumber$1 = "Please specify a valid number.";
var CourseFormCtrl_ValidScormRequired$1 = "A valid SCORM package is required.";
var CourseFormCtrl_VerificationUrl$1 = "Verification URL";
var CourseFormCtrl_WhatDidYouLearnLong$1 = "What did you learn from this course?";
var CourseFormCtrl_WhatDidYouLearnShort$1 = "What did you learn?";
var CourseFormCtrl_WhereTaken$1 = "Where is this course taken?";
var Core_1DayAgo$1 = "1 day ago";
var Core_1DayAgoFormat$1 = "1 day ago";
var Core_1Hour$1 = "1 hour";
var Core_1Hour1Minute$1 = "1 hour, 1 minute";
var Core_1HourAgo$1 = "1 hour ago";
var Core_1HourAgo_Minimal$1 = "1h";
var Core_1HourMinutesFormat$1 = "1 hour, {{minutes}} minutes";
var Core_1Minute$1 = "1 minute";
var Core_1MinuteAgo$1 = "1 minute ago";
var Core_1MinuteAgo_Minimal$1 = "1min";
var Core_1MonthAgo$1 = "1 month ago";
var Core_1WeekAgo$1 = "1 week ago";
var Core_1WeekAgo_Minimal$1 = "1w";
var Core_1YearAgo$1 = "1 year ago";
var Core_A11yTypeaheadInstructions$1 = "Enter text and use arrow keys to select a search result.";
var Core_AboutMe$1 = "About Me";
var Core_Abstract$1 = "Abstract";
var Core_Academies$1 = "Academies";
var Core_AcademiesDescription$1 = "Learn new skills with academies created by your company.";
var Core_AcademiesExplore$1 = "Explore Academies";
var Core_AcademiesMarketplace$1 = "Academies and Content Marketplace";
var Core_Academy$1 = "Academy";
var Core_AcademyContributor$1 = "Academy Contributor";
var Core_AcademyView$1 = "View Academy";
var Core_Accept$1 = "Accept";
var Core_AccessDenied$1 = "Access Denied";
var Core_Accomplishment$1 = "Accomplishment";
var Core_AccomplishmentsDisplayName$1 = "Accomplishments";
var Core_AccountClaimed$1 = "Account Claimed";
var Core_AccountStatus$1 = "Account Status";
var Core_Accredited$1 = "Accredited";
var Core_Achievements$1 = "Achievements";
var Core_Acknowledge_Changes$1 = "I acknowledge and accept the changes";
var Core_ActionError$1 = "Sorry! There was a problem performing this action. It’s not your fault, we are working hard to fix the problem.";
var Core_Actions$1 = "Actions";
var Core_Active$1 = "Active";
var Core_ActiveLearner$1 = "Active Learner";
var Core_ActiveLearners$1 = "Active Learners";
var Core_Activity$1 = "Activity";
var Core_ActualRecommendation$1 = "Recommendation";
var Core_Add$1 = "Add";
var Core_Add_Skill_Source$1 = "Add Source";
var Core_Add_Source$1 = "Add Source";
var Core_AddAccomplishment$1 = "Add Accomplishment";
var Core_AddArticle$1 = "Add Article";
var Core_AddAudio$1 = "Add Podcast";
var Core_AddAudioToCatalogFormat$1 = "Add this podcast to {{orgName}}'s catalog";
var Core_AddBio$1 = "Add Bio";
var Core_AddBook$1 = "Add Book";
var Core_AddContent$1 = "Add Content";
var Core_Added$1 = "added";
var Core_AddedToQueueNotifierFormat$1 = "{{itemTitle}} has been saved!";
var Core_AddExperience$1 = "Add Experience";
var Core_AddGroups$1 = "Add Groups";
var Core_AddGroupsInfo$1 = "Adding groups will help users find content that is associated to groups they belong to.";
var Core_AddingGroupsInfo$1 = "Adding groups will help users find content that is associated to groups they belong to.";
var Core_AddItemTo$1 = "Add {{type}} {{name}} to...";
var Core_AddPage$1 = "Add Directory";
var Core_AddPathway$1 = "Add Pathway";
var Core_AddPlans$1 = "Add Plans";
var Core_AddPost$1 = "Enter a link to a post you’ve read";
var Core_AddTags$1 = "Add Skills";
var Core_AddTakeaway$1 = "Add Takeaway";
var Core_AddTo$1 = "Add to...";
var Core_AddToBundle$1 = "Add To Bundle";
var Core_AddToContent$1 = "Add To Content";
var Core_AddToJobRole$1 = "Add to Plan";
var Core_AddToPathway$1 = "Add To Pathway";
var Core_AddVideo$1 = "Add Video";
var Core_Advanced$1 = "Advanced";
var Core_AdvancedSettings$1 = "Advanced Settings";
var Core_AgreeContinue$1 = "Agree and Continue";
var Core_All$1 = "All";
var Core_All_Level$1 = "All Level";
var Core_AllFieldsRequired$1 = "All fields are required.";
var Core_AllTypesDisplayName$1 = "All Types";
var Core_AllUsers$1 = "All Users";
var Core_AltText$1 = "Image Alt Text";
var Core_AltTextHelperText$1 = "Add alternative text to describe the appearance or function of the image using plain language.";
var Core_Announcement$1 = "Announcement";
var Core_AnonymousCountPluralFormat$1 = "{{count}} anonymous learners";
var Core_AnonymousCountSingular$1 = "1 anonymous learner";
var Core_AnonymousLearner$1 = "Anonymous Learner";
var Core_AnonymousLearners$1 = "Anonymous Learners";
var Core_AnonymousLearnersNotShown$1 = "Anonymous learners not shown";
var Core_Apply$1 = "Apply";
var Core_ApplyChanges$1 = "Apply";
var Core_Approve$1 = "Approve";
var Core_ApproveAll$1 = "Approve All";
var Core_ApproximateMinLeft$1 = "approx. {{minutes}} minutes left";
var Core_Archived$1 = "Archived";
var Core_AreYouSure$1 = "Are you sure?";
var Core_Article$1 = "Article";
var Core_Articles$1 = "Articles";
var Core_ArticlesDisplayName$1 = "Articles";
var Core_ArticlesVideosDisplayName$1 = "Articles & Videos";
var Core_ArticleVideoDisplayName$1 = "Articles & Videos";
var Core_Assessment$1 = "Assessment";
var Core_AssessmentsDisplayName$1 = "Assessments";
var Core_Assign$1 = "Assign";
var Core_Assigned$1 = "Assigned";
var Core_AssignedBy$1 = "Assigned By";
var Core_AssignedDate$1 = "Assigned Date";
var Core_AssignedLearning$1 = "Assigned Learning";
var Core_AssignedLearningEmptyState$1 = "You don’t have any assigned learning to complete.";
var Core_AssignedTo$1 = "Assigned To";
var Core_Assignment$1 = "Assignment";
var Core_AssignmentType$1 = "Assignment Type";
var Core_Atoz$1 = "A to Z";
var Core_Attend$1 = "Attend";
var Core_Audio$1 = "Podcast";
var Core_Audiobook$1 = "Audio";
var Core_AudioLength$1 = "Podcast Length (minutes)";
var Core_AudioNamePlaceholder$1 = "Enter the name or link of a podcast you’ve heard or seen";
var Core_AudioTitlePlaceholder$1 = "Enter a title for this audio";
var Core_AudioUrl$1 = "Audio URL";
var Core_Authoring$1 = "Authoring";
var Core_Authors$1 = "Authors";
var Core_Award$1 = "Award";
var Core_AwardsDisplayName$1 = "Awards";
var Core_AWeek$1 = "A Week";
var Core_Back$1 = "Back";
var Core_BackToHomepage$1 = "Back to Homepage";
var Core_Badge$1 = "Badge";
var Core_BadgesDisplayName$1 = "Badges";
var Core_Basic$1 = "Basic";
var Core_Beginner$1 = "Beginner";
var Core_Book$1 = "Book";
var Core_Books$1 = "Books";
var Core_BooksDisplayName$1 = "Books";
var Core_Bootcamp$1 = "Bootcamp";
var Core_Browse$1 = "Browse";
var Core_BulkEdit$1 = "Bulk Edit";
var Core_BulkEditSelectedCount$1 = "{{count}} Selected";
var Core_By$1 = "Assigned By";
var Core_CalendarDayCount$1 = "Past {{dayCount}} days";
var Core_CalendarNextMonth$1 = "Show next month";
var Core_CalendarPastYear$1 = "Past year";
var Core_CalendarPrevMonth$1 = "Show previous month";
var Core_CalendarRangeEnd$1 = "Range end";
var Core_CalendarRangeStart$1 = "Range start";
var Core_CalendarSelectLast$1 = "Select the last:";
var Core_CalendarSelectRange$1 = "Select a date range:";
var Core_CalendarSpecificDates$1 = "Specific Dates";
var Core_CalendarView$1 = "View Calendar";
var Core_Cancel$1 = "Cancel";
var Core_Candidates$1 = "Candidates";
var Core_CannotBeUndone$1 = "This cannot be undone.";
var Core_CaseStudy$1 = "Case Study";
var Core_Categories$1 = "Categories";
var Core_Category$1 = "Skill";
var Core_CategoryName$1 = "Skill";
var Core_Certificate$1 = "Certificate";
var Core_CertificatesDisplayName$1 = "Certificates";
var Core_Certification$1 = "Certification";
var Core_CEU$1 = "CEU";
var Core_CEUEligible$1 = "CEU Eligible";
var Core_CEUUnits$1 = "{{units}} CEU";
var Core_Change$1 = "Change";
var Core_Change_Primary_Skill_Source$1 = "Change Primary Skill Source";
var Core_Changes$1 = "Changes";
var Core_ChangesSaved$1 = "Changes Saved";
var Core_CharLimitExceeded$1 = "Character limit exceeded";
var Core_CharsRemainingFormat$1 = "Characters remaining: {{count}}";
var Core_ChartNotAvailableForAppliedFilters$1 = "This chart isn’t available for applied filters.";
var Core_Chat$1 = "Chat";
var Core_CheckboxAll$1 = "Select all rows in the table";
var Core_ChooseFile$1 = "Choose file";
var Core_ChooseSetupOptions$1 = "Choose a setup option";
var Core_Clear$1 = "Clear";
var Core_ClearFilter$1 = "Clear Filter";
var Core_ClearFilters$1 = "Clear Filters";
var Core_ClearNumberFormat$1 = "Clear {{numberSelected}}";
var Core_ClearRating$1 = "Clear Rating";
var Core_ClearSelection$1 = "Clear all selected";
var Core_ClearSelectionPluralFormat$1 = "Clear the selection of {{count}} items";
var Core_ClearSelectionSingle$1 = "Clear selected item";
var Core_ClearSelfRating$1 = "Clear Self-Rating";
var Core_ClickHere$1 = "Click here";
var Core_Clone$1 = "Clone";
var Core_CloneOfFormat$1 = "[Clone of] {{title}}";
var Core_Close$1 = "Close";
var Core_Closed$1 = "Closed";
var Core_ClosedOnDate$1 = "Closed {{ date }}";
var Core_CloseSuccess$1 = "Close success message";
var Core_Coach$1 = "Coach";
var Core_Coaching$1 = "Coaching";
var Core_Collaborator$1 = "Collaborator";
var Core_CollaboratorOnly$1 = "Collaborator Only";
var Core_Collaborators$1 = "Collaborators";
var Core_Collapse$1 = "Collapse";
var Core_CollapseAria$1 = "Collapse Context: {{context}}";
var Core_ComingSoon$1 = "Coming Soon";
var Core_Comment$1 = "Comment";
var Core_CommentPrivacyWarning$1 = "(This comment will be viewable by others)";
var Core_Comments$1 = "Comments";
var Core_Complete$1 = "Complete";
var Core_Completed$1 = "Completed";
var Core_CompletedContent$1 = "Completed Content";
var Core_CompletedDate$1 = "Completed Date";
var Core_CompletedFormat$1 = "Completed the {{resourceType}}";
var Core_CompletedStatus$1 = "Completed Status";
var Core_Completion_Progress$1 = "Completion Progress";
var Core_Completions$1 = "Completions";
var Core_Confetti$1 = "Confetti";
var Core_Confirm$1 = "Confirm";
var Core_ConfirmModalDefaultInputString$1 = "DELETE";
var Core_ConfirmModalInputStringPlaceHolder$1 = "Type '{{input}}'";
var Core_ConfirmPassword$1 = "Confirm Password";
var Core_ConfirmPasswordPlaceholder$1 = "Type it one more time";
var Core_Connect$1 = "Connect";
var Core_Connected$1 = "Connected";
var Core_Connectors$1 = "Connectors";
var Core_ContactDegreedSupport$1 = "contact Degreed Support";
var Core_Content$1 = "Content";
var Core_ContentCompleted$1 = "{{content_title}} completed";
var Core_ContentFollowed$1 = "{{content_title}} followed";
var Core_ContentProcessing$1 = "Your content is being processed";
var Core_ContentRemoved$1 = "{{content_title}} removed from your profile collection";
var Core_ContentSaved$1 = "{{content_title}} saved";
var Core_ContentType$1 = "Content Type";
var Core_ContentUncompleted$1 = "{{content_title}} removed from completed items";
var Core_ContentUnfollowed$1 = "No longer following {{content_title}}";
var Core_ContentUnsaved$1 = "{{content_title}} removed from saved items";
var Core_Continue$1 = "Continue";
var Core_ContinueLearningEmptyState$1 = "You don’t have any learning content in progress.";
var Core_ContinuingEducationUnitsEligible$1 = "CEUs Available";
var Core_CopyToClipboard$1 = "Copy to clipboard";
var Core_Cost$1 = "Cost";
var Core_CountItems$1 = "{{count}} Items";
var Core_CountMinutes$1 = "{{count}} minutes";
var Core_CountPoints$1 = "{{count}} points";
var Core_Course$1 = "Course";
var Core_Courses$1 = "Courses";
var Core_CoursesDisplayName$1 = "Courses";
var Core_Create$1 = "Create";
var Core_CreatedBy$1 = "Created by: {{authorName}}";
var Core_CreatedDate$1 = "Created Date";
var Core_Critical$1 = "Critical";
var Core_Crop$1 = "Crop";
var Core_Cropping$1 = "Cropping";
var Core_CurrentPassword$1 = "Current Password";
var Core_CurrentPasswordPlaceholder$1 = "Enter your current password";
var Core_CurrentSelfRating$1 = "Current Self-Rating";
var Core_Date$1 = "Date";
var Core_Date_YYYYMMDDFormat$1 = "yyyy-mm-dd";
var Core_DateAddedToProfile$1 = "Date Added to Profile";
var Core_DateLastUpdated$1 = "Date Last Updated";
var Core_Day$1 = "Day";
var Core_DayOfWeekFriday$1 = "Friday";
var Core_DayOfWeekMonday$1 = "Monday";
var Core_DayOfWeekSaturday$1 = "Saturday";
var Core_DayOfWeekSunday$1 = "Sunday";
var Core_DayOfWeekThursday$1 = "Thursday";
var Core_DayOfWeekTuesday$1 = "Tuesday";
var Core_DayOfWeekWednesday$1 = "Wednesday";
var Core_Days$1 = "Days";
var Core_DaysAgoFormat$1 = "{{time}} days ago";
var Core_DaysAgoFormat_Minimal$1 = "{{time}}d";
var Core_DaysFormat$1 = "{{days}} Days";
var Core_Decline$1 = "Decline";
var Core_DeclineAll$1 = "Decline All";
var Core_Declined$1 = "Declined";
var Core_Degree$1 = "Degree";
var Core_DegreeBachelors$1 = "Degree - Bachelors";
var Core_DegreedSupport$1 = "Degreed Support";
var Core_DegreeMasters$1 = "Degree - Masters";
var Core_DegreesDisplayName$1 = "Degrees";
var Core_Delete$1 = "Delete";
var Core_Deleted$1 = "deleted";
var Core_Department$1 = "Department";
var Core_Description$1 = "Description";
var Core_Details$1 = "Details";
var Core_Developing$1 = "Developing";
var Core_Difficulty$1 = "Difficulty";
var Core_Directory$1 = "Directory";
var Core_Directorys$1 = "Directories";
var Core_DirectorysDisplayName$1 = "Directories";
var Core_Disable$1 = "Disable";
var Core_Disabled$1 = "Disabled";
var Core_DiscardChanges$1 = "Discard changes";
var Core_Discover$1 = "Discover";
var Core_DislikeAllyText$1 = "Dislike {{type}} {{name}}";
var Core_Dismiss$1 = "Dismiss";
var Core_DismissContent$1 = "Dismiss Content";
var Core_DismissDialogHeader$1 = "Are you sure you want to remove this?";
var Core_DismissItemError$1 = "Sorry! There was a problem dismissing the item.";
var Core_DismissItemSuccess$1 = "Item dismissed.";
var Core_Documentary$1 = "Documentary";
var Core_Done$1 = "Done";
var Core_DoneEditing$1 = "Done Editing";
var Core_DownloadDetails$1 = "Download Details";
var Core_DownloadFiles$1 = "Download Files";
var Core_DownloadMetadata$1 = "Download Metadata";
var Core_Draft$1 = "Draft";
var Core_DragFileHere$1 = "Drag a file here or";
var Core_Due$1 = "Due";
var Core_DueBy$1 = "Due By";
var Core_DueDate$1 = "Due Date";
var Core_DueDateFormat$1 = "Due {{date}}";
var Core_DueDateTimeFormat$1 = "Due {{date}} at {{time}}";
var Core_DueIn$1 = "Due In";
var Core_DueOn$1 = "Due On";
var Core_Duration$1 = "Duration";
var Core_DurationMinutes$1 = "Duration (minutes)";
var Core_DurationType$1 = "Duration Type";
var Core_Edit$1 = "Edit";
var Core_Edit_Skill_Source$1 = "Edit Skill Source";
var Core_EditArticle$1 = "Edit Article Details";
var Core_EditAudio$1 = "Edit Podcast Details";
var Core_EditBook$1 = "Edit Book Details";
var Core_EditDescription$1 = "Edit Description";
var Core_EditDetails$1 = "Edit Details";
var Core_EditItem$1 = "Edit Internal Item";
var Core_EditItemHelper$1 = "Changes to this item will be applied to your organization's content catalog";
var Core_EditPost$1 = "Edit Post Details";
var Core_EditSkillTarget$1 = "Edit Skill Target";
var Core_EditStep$1 = "Edit Step";
var Core_EditVideo$1 = "Edit Video Details";
var Core_Electronic$1 = "Electronic";
var Core_Email$1 = "Email";
var Core_EmailAddress$1 = "Email Address";
var Core_EmailAddresses$1 = "Email Address(es)";
var Core_EmailContent$1 = "Email Content";
var Core_EmailExistsError$1 = "An account with that e-mail has already been registered. Please login via e-mail.";
var Core_EmailPlaceholder$1 = "jane@acme.com";
var Core_EmailSubject$1 = "Email Subject";
var Core_EmailVerificationSuccessful$1 = "Your email has been verified";
var Core_Empty_Image_Alt$1 = "Empty";
var Core_EmptyFocusSkills$1 = "Get started with adding focus skills to your profile to get the best learning recommendations from Degreed.";
var Core_EmptyFocusSkillsWithSuggestion$1 = "You don’t have any focus skills in your Degreed profile. Based on your role, we recommend you add the following focus skills:";
var Core_Enable$1 = "Enable";
var Core_Enabled$1 = "Enabled";
var Core_EndDate$1 = "End Date";
var Core_Endorse$1 = "Endorse";
var Core_EndorseConfirmation$1 = "It may take several minutes for the endorsement to apply.";
var Core_EndorseContentChannelTypeError$1 = "Sorry! This endorsement cannot be updated.";
var Core_EndorseContentGenericError$1 = "Sorry! There was a problem updating the endorsement.";
var Core_EndorseContentOrgTypeError$1 = "Sorry! This endorsement cannot be updated.";
var Core_EndorseContentPermissionError$1 = "Sorry! You do not have permission to update the endorsement.";
var Core_Endorsed$1 = "Endorsed";
var Core_EndorsedByOrganization$1 = "{{orgName}} Endorsed";
var Core_EndorsedOnly$1 = "Endorsed Only";
var Core_EndorsedTooltip$1 = "Company Endorsed";
var Core_EndorseInformation$1 = "Endorsed resources are boosted in search results and display an icon to indicate the item is preferred by your organization.";
var Core_EndorsementRemoved$1 = "Endorsement Removed";
var Core_Engagement$1 = "Engagement";
var Core_Enroll$1 = "Enroll";
var Core_Enrolled$1 = "Enrolled";
var Core_Enrollees$1 = "Enrollees";
var Core_EnrollInPathway$1 = "Enroll In Pathway";
var Core_Enrollment$1 = "Enrollment";
var Core_Enrolls$1 = "Enrolls";
var Core_Episode$1 = "Podcast";
var Core_EpisodesDisplayName$1 = "Podcasts";
var Core_Error$1 = "Error";
var Core_Event$1 = "Event";
var Core_Events$1 = "Events";
var Core_EventsDisplayName$1 = "Events";
var Core_ExactMatches$1 = "Exact Matches";
var Core_Expand$1 = "Expand";
var Core_ExperienceDisplayName$1 = "Experience";
var Core_ExperiencesDisplayName$1 = "Experiences";
var Core_Expert$1 = "Expert";
var Core_External$1 = "External";
var Core_ExternalBook$1 = "Book";
var Core_ExternalBooksDisplayName$1 = "Books";
var Core_ExternalPodcast$1 = "Podcast";
var Core_ExternalPodcastsDisplayName$1 = "Podcasts";
var Core_ExternalResources$1 = "External Resources";
var Core_ExternalVideo$1 = "Video";
var Core_ExternalVideosDisplayName$1 = "Videos";
var Core_False$1 = "False";
var Core_Favicon$1 = "Favicon";
var Core_FeatureResource$1 = "Make Featured";
var Core_Feed$1 = "Feed";
var Core_FieldInvalidFormat$1 = "Invalid {{fieldName}}";
var Core_FieldRequired$1 = "This field is required";
var Core_FieldRequiredFormat$1 = "{{fieldName}} is required";
var Core_Files$1 = "Files";
var Core_FileTypes_FirstOrOnly$1 = "{{fileType}}";
var Core_FileTypes_Middle$1 = ", {{fileType}}";
var Core_FileTypes_OrLast$1 = " or {{fileType}}";
var Core_Filter$1 = "Filter";
var Core_FilterApplied$1 = "1 Filter Applied";
var Core_FiltersAppliedFormat$1 = "{{count}} Filters Applied";
var Core_FindContent$1 = "Find Content";
var Core_Finish$1 = "Finish";
var Core_FirstName$1 = "First name";
var Core_FlagAsInappropriate$1 = "Flag as Inappropriate";
var Core_Focus$1 = "Focus";
var Core_FocusSkill$1 = "Focus Skill";
var Core_FocusUnderLimitDescription$1 = "Below are focus skills you added to your Degreed profile. Add self-ratings and select target levels for each to get the best learning recommendations from Degreed.";
var Core_FocusUptoLimitDescription$1 = "Add self-ratings and select target levels to your focus skills to get the best learning recommendations from Degreed.";
var Core_Follow$1 = "Follow";
var Core_Follow_UserName$1 = "Follow {{userName}}";
var Core_Followers$1 = "Followers";
var Core_Following$1 = "Following";
var Core_FollowingButtonLabel$1 = "Following. Click to unfollow.";
var Core_FollowPathway$1 = "Follow Pathway";
var Core_Follows$1 = "Follows";
var Core_Format$1 = "Format";
var Core_Free$1 = "Free";
var Core_FreeformText$1 = "Text Area";
var Core_Future$1 = "Future";
var Core_GeneralErrorMessage$1 = "Sorry! There was a problem saving your changes.";
var Core_GeneralLoadingError$1 = "There was a problem loading the page.";
var Core_Goal$1 = "Goal";
var Core_GoalAddedFormat$1 = "{{title}} has been added to your goals!";
var Core_GoBack$1 = "Go Back";
var Core_Graduate$1 = "Graduate";
var Core_GreaterThan1Day$1 = "> 1 day";
var Core_Grid$1 = "Grid View";
var Core_Group$1 = "Group";
var Core_GroupDisplayName$1 = "Group Browse";
var Core_Groups$1 = "Groups";
var Core_GroupsDisplayName$1 = "Groups";
var Core_GrowthPlan$1 = "Growth Plan";
var Core_Help$1 = "Help";
var Core_Hide$1 = "Hide";
var Core_HideFilters$1 = "Hide Filters";
var Core_Home$1 = "Home";
var Core_Hooray$1 = "Hooray!";
var Core_Hour$1 = "Hour";
var Core_Hours$1 = "Hours";
var Core_HoursAgoFormat$1 = "{{time}} hours ago";
var Core_HoursAgoFormat_Minimal$1 = "{{time}}h";
var Core_HoursFormat$1 = "{{hours}} hours";
var Core_HoursMinutesFormat$1 = "{{hours}} hours, {{minutes}} minutes";
var Core_Hybrid$1 = "Hybrid";
var Core_Icon$1 = "Icon";
var Core_ICreatedAudio$1 = "I created this podcast";
var Core_Image$1 = "Image";
var Core_In1DayFormat$1 = "In 1 day";
var Core_Inactive$1 = "Inactive";
var Core_InAppNotification$1 = "In-App Notification";
var Core_InDaysFormat$1 = "In {{time}} days";
var Core_Inference$1 = "Inference";
var Core_Info$1 = "Info";
var Core_InPerson$1 = "In Person";
var Core_InProgress$1 = "In progress";
var Core_InputActionAdded$1 = "added the following {{input}}";
var Core_InputActionAttended$1 = "attended an event";
var Core_InputActionCompleted$1 = "completed a course";
var Core_InputActionCompletedCourse$1 = "completed a course";
var Core_InputActionCompletedPodcast$1 = "completed an audio item";
var Core_InputActionRead$1 = "read an article";
var Core_InputActionReadBook$1 = "read a book";
var Core_InputActionTaskCompleted$1 = "completed a task";
var Core_InputActionWatched$1 = "watched a video";
var Core_InputCommentPlaceholder$1 = "Share a comment about this {{inputType}} with others in your organization";
var Core_InputDetails$1 = "{{ name }} Details";
var Core_Inputs$1 = "Content";
var Core_Insights$1 = "Insights";
var Core_Instructions$1 = "Instructions";
var Core_InstructorLed$1 = "Instructor Led Classroom";
var Core_Integration$1 = "Integration";
var Core_Interested$1 = "Interested";
var Core_Intermediate$1 = "Intermediate";
var Core_Invalid$1 = "Invalid";
var Core_InvalidEmail$1 = "Please enter a valid email address";
var Core_InvalidEmailPattern$1 = "The e-mail address is invalid";
var Core_InvalidMaxValue$1 = "Please enter a value of {{max}} or less";
var Core_InvalidMinValue$1 = "Please enter a value of {{min}} or more";
var Core_Inventory$1 = "Inventory";
var Core_Invite$1 = "Invite";
var Core_Items$1 = "Items";
var Core_ItemsSelectedFormat$1 = "{{count}} selected";
var Core_JobRole$1 = "Plan";
var Core_JobroleDisplayName$1 = "Plan";
var Core_JobRoleLiteral$1 = "Job Role";
var Core_JobRoles$1 = "Plans";
var Core_JobRolesDisplayName$1 = "Plans";
var Core_JobTitle$1 = "Job Title";
var Core_Join$1 = "Join";
var Core_Joined$1 = "Joined";
var Core_JoinEvent$1 = "Join Event";
var Core_Journal$1 = "Journal";
var Core_Journey$1 = "Journey";
var Core_JustNow$1 = "just now";
var Core_Language$1 = "Language";
var Core_LanguageSettings$1 = "Language Settings";
var Core_LastActive$1 = "Last Active";
var Core_LastLogin$1 = "Your last login was";
var Core_LastMonth$1 = "Last Month";
var Core_LastName$1 = "Last name";
var Core_LastNameTC$1 = "Last Name";
var Core_LastUpdated$1 = "Last Updated";
var Core_LastWeek$1 = "Last Week";
var Core_Learn_More$1 = "Learn More";
var Core_Learning$1 = "Learning";
var Core_LearningMinutes$1 = "Learning Minutes";
var Core_LearningPath$1 = "Learning Path";
var Core_Learnings$1 = "Learnings";
var Core_LearnMore$1 = "Learn More";
var Core_LearnOnDegreed$1 = "Learn on Degreed";
var Core_LessThan10$1 = "< 10 mins";
var Core_LessThan1Day$1 = "< 1 day";
var Core_LessThan1Hour$1 = "< 1 hour";
var Core_LessThan30$1 = "< 30 mins";
var Core_LessThan30Days$1 = "< 30 days";
var Core_LessThan4Hours$1 = "< 4 hours";
var Core_LessThan5$1 = "< 5 min";
var Core_LessThan6Months$1 = "< 6 months";
var Core_LessThanADay$1 = "Less Than A Day";
var Core_LessThanOneYear$1 = "< 1 year";
var Core_Like$1 = "Like";
var Core_LikeAllyText$1 = "Like {{type}} {{name}}";
var Core_Liked$1 = "Liked";
var Core_LimitedVisibility$1 = "Limited Visibility";
var Core_Link$1 = "Link";
var Core_Linked_External_Skill_Source$1 = "Linked external skill source.";
var Core_Links$1 = "Links";
var Core_LinkText$1 = "Link";
var Core_List$1 = "List View";
var Core_ListItemsError$1 = "Sorry! There was a problem retrieving list items";
var Core_Live$1 = "Live";
var Core_LiveOnlineTraining$1 = "Live Online Training";
var Core_Loading$1 = "Loading";
var Core_LoadingResults$1 = "Loading results...";
var Core_LoadMore$1 = "Load More";
var Core_LoadMoreAria$1 = "Load More Context: {{context}}";
var Core_Location$1 = "Location";
var Core_MaliciousURL$1 = "Sorry! This content is from a risky website, so it can’t be added.";
var Core_ManageFocusSkills$1 = "Manage Focus Skills";
var Core_ManagerRating$1 = "Manager Rating";
var Core_ManageTranslations$1 = "Manage Translations";
var Core_Mandatory$1 = "Mandatory";
var Core_Mark_ContentName_Complete$1 = "Mark {{contentName}} Complete";
var Core_Mark_ContentTitle_Complete$1 = "Mark {{contentTitle}} Complete";
var Core_MarkAsComplete$1 = "Mark Complete";
var Core_Marketplace$1 = "Marketplace";
var Core_Matched_Skills$1 = "Matched Skills";
var Core_MatchedOf$1 = "{{matched}} of {{total}}";
var Core_MaxCost$1 = "Max. Price";
var Core_Media$1 = "Media";
var Core_Meeting$1 = "Meeting";
var Core_Members$1 = "Members";
var Core_Membership$1 = "Membership";
var Core_Mentee$1 = "Mentee";
var Core_Mentor$1 = "Mentor";
var Core_Mentors$1 = "Mentors";
var Core_Message$1 = "Message";
var Core_MinCost$1 = "Min. Price";
var Core_Minute$1 = "Minute";
var Core_Minutes$1 = "Minutes";
var Core_MinutesAgoFormat$1 = "{{time}} minutes ago";
var Core_MinutesAgoFormat_Minimal$1 = "{{time}}min";
var Core_MinutesFormat$1 = "{{minutes}} minutes";
var Core_MissingRatingNudgeText$1 = "Help Degreed improve your content recommendations by rating yourself for the following skills:";
var Core_Month$1 = "Month";
var Core_MonthAgoFormat$1 = "{{time}} month ago";
var Core_Months$1 = "Months";
var Core_MonthsAgoFormat$1 = "{{time}} months ago";
var Core_MonthsAgoFormat_Minimal$1 = "{{time}}m";
var Core_More$1 = "More";
var Core_MoreDetails$1 = "More Details";
var Core_MoreFilters$1 = "More filters";
var Core_MoreInfo$1 = "more info";
var Core_MoreOptions$1 = "more options";
var Core_MoreOptionsForItem$1 = "More options for {{name}}";
var Core_MoveDown$1 = "Move Down";
var Core_MoveToGlobal$1 = "Move to Global Catalog";
var Core_MoveUp$1 = "Move Up";
var Core_Multisession$1 = "Multiple Sessions";
var Core_Name$1 = "Name";
var Core_NearStart$1 = "Starting Soon";
var Core_New$1 = "New";
var Core_Newest$1 = "Newest";
var Core_NewItem$1 = "1 new item";
var Core_NewItems$1 = "{{count}} new items";
var Core_NewPassword$1 = "New Password";
var Core_NewPasswordPlaceholder$1 = "Keep it secret!";
var Core_NewRating$1 = "New rating";
var Core_NewSelfRating$1 = "New Self-Rating";
var Core_Next$1 = "Next";
var Core_Next30Days$1 = "Next 30 Days";
var Core_Next60Days$1 = "Next 60 Days";
var Core_Next7Days$1 = "Next 7 Days";
var Core_NextYear$1 = "Next Year";
var Core_NinePlusMonths$1 = "9+ Months";
var Core_No$1 = "No";
var Core_NoDescription$1 = "No Description";
var Core_NoDueDate$1 = "No due date";
var Core_NoFiles$1 = "No Files";
var Core_NoMembers$1 = "No members to show";
var Core_NoPreviousLogin$1 = "No previous login event";
var Core_NoResults$1 = "There are no results to show.";
var Core_NoResultsFor$1 = 'No results for "{{searchTerm}}"';
var Core_NoResultsFound$1 = "No Results Found.";
var Core_NoResultsMatch$1 = "No Results Match";
var Core_Normal$1 = "Normal";
var Core_NotAvailable$1 = "Not Available";
var Core_NotAvailableForGroup$1 = "This chart isn’t available for group data.";
var Core_NotDislikedAllyText$1 = "Not disliked {{type}} {{name}}";
var Core_NotFound_DescriptionText$1 = "You may not have permission to see this item or this item may not exist.";
var Core_NotFound_HeaderText$1 = "Nothing to see here";
var Core_NoThanks$1 = "No, Thanks.";
var Core_NotSelected$1 = "Not Selected";
var Core_NotSpecified$1 = "Not Specified";
var Core_Okay$1 = "Okay";
var Core_Older$1 = "Older";
var Core_Oldest$1 = "Oldest";
var Core_OnDate$1 = "On {{ date }}";
var Core_OneToThreeMonths$1 = "1-3 Months";
var Core_Online$1 = "Online";
var Core_Open$1 = "Open";
var Core_OpenContent$1 = "Open Content";
var Core_OpenDatePicker$1 = "Open date picker";
var Core_OpenedOnDate$1 = "Opened {{ date }}";
var Core_OpenItem$1 = "Open {{type}} {{name}}";
var Core_Operator_Contains$1 = "Contains";
var Core_Operator_Empty$1 = "Empty";
var Core_Operator_EndsWith$1 = "Ends With";
var Core_Operator_Exact$1 = "Exact";
var Core_Operator_NotContains$1 = "Not Contains";
var Core_Operator_StartsWith$1 = "Starts With";
var Core_Opportunities$1 = "Opportunities";
var Core_OpportunitiesDesc$1 = "Discover and apply to career opportunities that align with your skills and career goals.";
var Core_Opportunity$1 = "Opportunity";
var Core_Opportunity_Groups$1 = "Visible to a specific group";
var Core_Opportunity_JobRole$1 = "Job Role";
var Core_Opportunity_JobRole_Placeholder$1 = "Enter role related to opportunity";
var Core_OpportunityType$1 = "Type";
var Core_Optin$1 = "Opt In";
var Core_Optional$1 = "Optional";
var Core_OptionalMessage_Request$1 = "Add an optional message to your request";
var Core_Options$1 = "Options";
var Core_OptionsAvailableFormat$1 = "{{count}} options available";
var Core_Optout$1 = "Opt Out";
var Core_Or$1 = "or";
var Core_Org_Recommendation$1 = "Org Recommendation";
var Core_Organization$1 = "Organization";
var Core_Organizations$1 = "Organizations";
var Core_OrgManagedDocLinkLabel$1 = "Learn more about org-managed content";
var Core_OrgManagedNotification$1 = "Adding this item will make the selected {{resourceType}} org-managed.";
var Core_OrgManagedNotificationPlural$1 = "Adding org-managed items will make this {{resourceType}} org-managed.";
var Core_Other$1 = "Other";
var Core_OverrideChangesWarning$1 = "The following changes will override previous visibility settings.";
var Core_Overview$1 = "Overview";
var Core_OverYearAgo$1 = "Over a year ago";
var Core_Page$1 = "Page";
var Core_Pages$1 = "Pages";
var Core_Paid$1 = "Paid";
var Core_PasswordLocked$1 = "Password Locked";
var Core_PasswordMatchError$1 = "The new password and the confirmation password do not match";
var Core_PasswordPatternInfo$1 = "Passwords must be at least 8 characters long and include 1 number & 1 letter";
var Core_PasswordRequirementsNotMet$1 = "Password requirements have not been met";
var Core_PasswordReset$1 = "Password Reset";
var Core_Past$1 = "Past";
var Core_Pathway$1 = "Pathway";
var Core_Pathways$1 = "Pathways";
var Core_PathwaysDisplayName$1 = "Pathways";
var Core_PDF$1 = "PDF";
var Core_Pending$1 = "Pending";
var Core_People$1 = "People";
var Core_Permissions$1 = "Permissions";
var Core_PersonalizedLearningEmptySkills$1 = "Add skills to your profile to get Personalized Learning recommendations.";
var Core_PersonalizedLearningEmptySkillsWithSuggestion$1 = "Add skills to your profile to get Personalized Learning recommendations. We suggest you add the following skills:";
var Core_PersonalizedLearningEmptyState$1 = "There are no personalized learning recommendations available for this skill.";
var Core_Phone$1 = "Phone";
var Core_Plans$1 = "Plans";
var Core_PlansAndRoles$1 = "Plans";
var Core_Play$1 = "Play";
var Core_PleaseTryAgain$1 = "Please try again.";
var Core_PlusShowMore$1 = "+ Show More";
var Core_Podcast$1 = "Podcast";
var Core_PodcastDisplayName$1 = "Podcast";
var Core_PodcastEpisodeDisplayName$1 = "Podcast Episode";
var Core_PodcastHelp$1 = "You can paste a link to an audio file or web page, or search for the name of a Podcast Series.";
var Core_PodcastNameUrl$1 = "Podcast Name or URL";
var Core_Podcasts$1 = "Podcasts";
var Core_PodcastsDisplayName$1 = "Podcasts";
var Core_PodcastUrl$1 = "Podcast URL";
var Core_Points$1 = "Points";
var Core_Position$1 = "Experience";
var Core_PositionsDisplayName$1 = "Positions";
var Core_Post$1 = "Post";
var Core_PostsDisplayName$1 = "Posts";
var Core_PoweredBy$1 = "Powered by";
var Core_Preview$1 = "Preview";
var Core_Previous$1 = "Previous";
var Core_PreviousRating$1 = "Previous Rating";
var Core_PriceRange$1 = "Price Range";
var Core_Primary$1 = "Primary";
var Core_Primary_Source$1 = "Primary Source";
var Core_PrimaryPlan$1 = "Primary Plan";
var Core_Print$1 = "Print";
var Core_PrivacyLevel0$1 = "Private to collaborators";
var Core_PrivacyLevel1$1 = "Visible to organization";
var Core_PrivacyLevel2$1 = "Visible to a specific group";
var Core_PrivacyLevel2A$1 = "Visible to {{groupCount}} group";
var Core_PrivacyLevel2B$1 = "Visible to {{groupCount}} groups";
var Core_PrivacyLevel2C$1 = "Visible to {{groupName}}";
var Core_PrivacyLevel3$1 = "Visible on collaborators' profiles";
var Core_Private$1 = "Private";
var Core_Proficient$1 = "Proficient";
var Core_ProgramLanguage$1 = "Program Language";
var Core_ProgramType$1 = "Program Type";
var Core_ProgressBar_Tooltip$1 = "{{ percent }} of {{ total }}";
var Core_ProgressSaved$1 = "Progress Saved";
var Core_Provider$1 = "Provider";
var Core_Providers$1 = "Providers";
var Core_Pts$1 = "pts";
var Core_Publish$1 = "Publish";
var Core_PublishDate$1 = "Date Published";
var Core_Published$1 = "Published";
var Core_PublishedDaysAgoFormat$1 = "Published {{time}} days ago";
var Core_PublishedHoursAgoFormat$1 = "Published {{time}} hours ago";
var Core_PublishedJustNowFormat$1 = "Published just now";
var Core_PublishedMinutesAgoFormat$1 = "Published {{time}} minutes ago";
var Core_PublishedMonthsAgoFormat$1 = "Published {{time}} months ago";
var Core_PublishedOnDateFormat$1 = "on {{date}}";
var Core_PublishedOneHourAgoFormat$1 = "Published 1 hour ago";
var Core_PublishedOneMonthAgoFormat$1 = "Published 1 month ago";
var Core_PublishedOneWeekAgoFormat$1 = "Published 1 week ago";
var Core_PublishedWeeksAgoFormat$1 = "Published {{time}} weeks ago";
var Core_PublishedXTimeAgoFormat$1 = "Published {{ elapsedTime }}";
var Core_PublishedYesterdayFormat$1 = "Published yesterday";
var Core_Quarter$1 = "Quarter";
var Core_Question$1 = "Question";
var Core_Question_and_Answer$1 = "Question and Answer";
var Core_Questions$1 = "Questions";
var Core_Rate$1 = "Rate";
var Core_RateYourself$1 = "Rate Yourself";
var Core_RateYourselfInSkill$1 = "Rate Yourself in ‘{{skillTitle}}’";
var Core_Rating$1 = "Rating";
var Core_Ratings$1 = "Ratings";
var Core_RatingType$1 = "Rating Type";
var Core_Read$1 = "Read";
var Core_ReadMore$1 = "Read More";
var Core_RecentActivitySuggestion$1 = "Based on your recent activity in Degreed we suggest that you add the following skills to your profile:";
var Core_RecentStart$1 = "Recently Started";
var Core_Recommend$1 = "Share";
var Core_Recommendation$1 = "Share";
var Core_RecommendationDisplayName$1 = "Share";
var Core_RecommendationsDisplayName$1 = "Shares";
var Core_Recommended$1 = "Recommended";
var Core_RecommendedFocusSkills$1 = "Recommended Focus Skills";
var Core_RecommendedSkills$1 = "Recommended Skills";
var Core_RefreshPage$1 = "Refresh Page";
var Core_Register$1 = "Register";
var Core_Registered$1 = "Registered";
var Core_RelatedSkillTooltip$1 = "Related Skill: {{skillName}}";
var Core_Remove$1 = "Remove";
var Core_RemoveAssignment$1 = "Remove Assignment";
var Core_RemoveAssignmentDescription$1 = "Are you sure you want to remove this assignment? This will no longer be assigned to you.";
var Core_Removed$1 = "removed";
var Core_RemoveEndorsement$1 = "Remove Endorsement";
var Core_RemoveEndorsementConfirmation$1 = "Removing the endorsement removes the search boost and the icon. Are you sure you want to remove the endorsement?";
var Core_RemoveFacetFormat$1 = "Remove {{facetName}}";
var Core_RemoveFromAssignedModalText$1 = 'You are about to remove "{{title}}" from your Assigned Learning Section.';
var Core_RemoveFromContinueLearningModalText$1 = 'You are about to remove "{{title}}" from your Continue Learning Section.';
var Core_RemoveFromInProgressModalText$1 = 'You are about to remove "{{title}}" from your In Progress Section.';
var Core_RemoveFromPersonalizedLearningModalText$1 = 'You are about to remove "{{title}}" from your Personalized Learning Section.';
var Core_RemoveFromTrendingLearningModalText$1 = 'You are about to remove "{{title}}" from your Trending Section.';
var Core_RemoveImage$1 = "Remove image";
var Core_RemoveItem$1 = "Remove Item";
var Core_RemoveSkill$1 = "Remove skill";
var Core_RemoveSuccess$1 = "Successfully removed!";
var Core_Replace$1 = "Replace";
var Core_ReplaceFile$1 = "Replace File";
var Core_Reply$1 = "Reply";
var Core_ReportAProblem$1 = "Report a Problem";
var Core_Required$1 = "Required";
var Core_ReRateSkill$1 = "Update Rating";
var Core_Reset$1 = "Reset";
var Core_ResetDefault$1 = "Reset to Default";
var Core_ResetFilters$1 = "Reset Filters";
var Core_ResetFiltersWithCount$1 = "Reset Filters ({{count}})";
var Core_Results$1 = "Results";
var Core_ResultsFoundFormat$1 = "{{count}} results found";
var Core_Retry$1 = "Retry";
var Core_Revert$1 = "Revert";
var Core_Review$1 = "Review";
var Core_Role$1 = "Role";
var Core_RoleAdmin$1 = "Admin";
var Core_RoleAdminsCan$1 = "Admins can:";
var Core_RoleCareerProfessional$1 = "Career Professional";
var Core_RoleCareerProfessionalsCan$1 = "Career Professionals can:";
var Core_RoleLearningProfessional$1 = "Learning Professional";
var Core_RoleLearningProfessionalsCan$1 = "Learning Professionals can:";
var Core_RoleManager$1 = "Manager";
var Core_RoleManagersCan$1 = "Managers can:";
var Core_RoleMember$1 = "Member";
var Core_RoleMembersCan$1 = "Members can:";
var Core_RolePlan$1 = "Role Plan";
var Core_RoleTechnicalAdmin$1 = "Technical Admin";
var Core_RoleTechnicalAdminsCan$1 = "Technical Admins can:";
var Core_Save$1 = "Save";
var Core_SaveAudio$1 = "Save Podcast";
var Core_SaveChanges$1 = "Save Changes";
var Core_Saved$1 = "Saved";
var Core_SaveForLater$1 = "Save For Later";
var Core_SaveItemforLater$1 = "Save {{type}} - {{name}} for later";
var Core_SaveNext$1 = "Save & Next";
var Core_SaveRating$1 = "Save Rating";
var Core_SaveSkillTarget$1 = "Save Skill Target";
var Core_Saving$1 = "Saving";
var Core_ScrollLimit$1 = "Scroll limited to 250 results. Search in drop down for more.";
var Core_ScrollLimited$1 = "Scroll limited to 250 results. Check reports for more.";
var Core_Search$1 = "Search";
var Core_SearchCatalog$1 = "Search Catalog";
var Core_SearchCollection$1 = "Search Collection";
var Core_SearchFilterA11yLabel$1 = "On selecting an input, main content will update";
var Core_SearchForPathway$1 = "Search for a pathway";
var Core_SearchForPerson$1 = "Search for a person...";
var Core_SearchTerms$1 = "Search Terms";
var Core_Second$1 = "Second";
var Core_Secondary$1 = "Secondary";
var Core_Seconds$1 = "Seconds";
var Core_SecondsAgoFormat$1 = "{{time}} seconds ago";
var Core_SecondsAgoFormat_Minimal$1 = "{{time}}s";
var Core_SeeSkillCollection$1 = "See skill collection";
var Core_Segments$1 = "Segments";
var Core_Select$1 = "Select";
var Core_SelectAllInTable$1 = "Select all rows in the table";
var Core_SelectDate$1 = "Select Date";
var Core_SelectEndDate$1 = "Select End Date";
var Core_SelectItem$1 = "Select {{item}}";
var Core_SelectSelfRating$1 = "Select Self-Rating";
var Core_SelectSkillTarget$1 = "Select Skill Target";
var Core_SelectStartDate$1 = "Select Start Date";
var Core_SelfRating$1 = "Self Rating";
var Core_Send$1 = "Send";
var Core_SendEmail$1 = "Send Email";
var Core_Sending$1 = "Sending";
var Core_SendRequest$1 = "Send Request";
var Core_Series$1 = "Series";
var Core_SessionDateRange$1 = "Session Date Range";
var Core_SessionLocation$1 = "Session Location";
var Core_Sessions$1 = "Sessions";
var Core_SessionType$1 = "Session Type";
var Core_SetAsGoal$1 = "Set As Goal";
var Core_SetGoal$1 = "Set Goal";
var Core_SetSkillTarget$1 = "Set Skill Target";
var Core_Settings$1 = "Settings";
var Core_SettingsSaved$1 = "The settings were saved successfully";
var Core_Share$1 = "Share";
var Core_Shared$1 = "Shared";
var Core_SharedBy$1 = "Shared By";
var Core_SharedContent$1 = "Shared Content";
var Core_ShareItem$1 = "Share {{name}}";
var Core_ShareOn$1 = "Share on";
var Core_Show$1 = "Show";
var Core_ShowAll$1 = "Show All";
var Core_ShowAllAria$1 = "Show All Context: {{context}}";
var Core_ShowCompleted$1 = "Show Completed";
var Core_ShowFilters$1 = "Show Filters";
var Core_ShowLess$1 = "Show Less";
var Core_ShowLessAria$1 = "Show Less Context: {{context}}";
var Core_ShowMore$1 = "Show More";
var Core_ShowResults$1 = "Show Results";
var Core_SignalCount$1 = "1 Signal";
var Core_SignalsCount$1 = "{{count}} Signals";
var Core_Skill$1 = "Skill";
var Core_Skill_Source_Acknowledge_Changes_Content$1 = "The skills from {{Source_Name}} will be used as the default spelling, descriptions and labels for any existing skills in your skill inventory. Current primary skill source skills will be archived, and primary integration skills will no longer feed your inventory.";
var Core_SkillCoach$1 = "Skill Coach";
var Core_SkillCount$1 = "1 Skill";
var Core_SkillDisplayName$1 = "Skill Behavior";
var Core_SkillPlan$1 = "Plan";
var Core_SkillPlansDisplayName$1 = "Plans";
var Core_SkillRating$1 = "Skill Rating";
var Core_Skills$1 = "Skills";
var Core_SkillsAndTopics$1 = "Skills";
var Core_SkillScaleChanged$1 = "{{ orgName }}'s rating proficiency scale has changed";
var Core_SkillsCount$1 = "{{count}} Skills";
var Core_SkillsDisplayName$1 = "Skill Behaviors";
var Core_SkillTarget$1 = "Skill Target";
var Core_SkillTargetDescription$1 = "Set a skill target for this skill to track progress, identify any skill gaps or proficiencies and improve recommendations throughout Degreed.";
var Core_SkillTargetLevel$1 = "Skill Target Level";
var Core_Skip$1 = "Skip";
var Core_SlowWarn$1 = "Changes to data in this table may not appear immediately.";
var Core_SorryExclamation$1 = "Sorry!";
var Core_Sort$1 = "Sort";
var Core_SortBy$1 = "Sort by";
var Core_Source$1 = "Source";
var Core_Sources$1 = "Sources";
var Core_SpecificDates$1 = "Specific Dates";
var Core_SponsoredBy$1 = "Sponsored by {{sponsorName}}";
var Core_Stage$1 = "Stage";
var Core_Start$1 = "Start";
var Core_StartDate$1 = "Start Date";
var Core_Started$1 = "Started";
var Core_StartTracking$1 = "Start tracking";
var Core_Status$1 = "Status";
var Core_Submit$1 = "Submit";
var Core_SubmitContinue$1 = "Submit & Continue";
var Core_Submitting$1 = "Submitting";
var Core_Subscription$1 = "Subscription";
var Core_Subtitle$1 = "Subtitle";
var Core_Success$1 = "Success";
var Core_SuccessChangesPublished$1 = "Success! Your changes have been published.";
var Core_SuccessfullyVerified$1 = "Successfully verified";
var Core_Suggestions$1 = "Suggestions";
var Core_Summary$1 = "Summary";
var Core_Support$1 = "Support";
var Core_Tag$1 = "Skill";
var Core_TagCredential$1 = "Skill Certification";
var Core_TagEvaluation$1 = "Skill Review";
var Core_Tags$1 = "Skills";
var Core_TagsDisplayName$1 = "Skills";
var Core_TagSelf$1 = "Self Rating";
var Core_Target$1 = "Plan";
var Core_Targets$1 = "Plans";
var Core_TargetsDisplayName$1 = "Plans";
var Core_TargetTypeNotDefined$1 = "Not defined";
var Core_Task$1 = "Task";
var Core_Tasks$1 = "Tasks";
var Core_TasksDisplayName$1 = "Tasks";
var Core_Team$1 = "Skill Coach";
var Core_Text$1 = "Text";
var Core_ThisMonth$1 = "This Month";
var Core_ThisMonth_Minimal$1 = "1m";
var Core_ThisYear$1 = "This year";
var Core_ThisYear_Minimal$1 = "1y";
var Core_ThreeToNineMonths$1 = "3-9 Months";
var Core_TinyMCEAriaHelpText$1 = "Press ALT-0 for editor help descriptions.";
var Core_Title$1 = "Title";
var Core_TitleLength$1 = "Title must be 255 characters or less.";
var Core_TitleRequired$1 = "A title is required.";
var Core_To$1 = "To";
var Core_ToBeCompleted$1 = "To be completed";
var Core_Today$1 = "Today";
var Core_Today_Minimal$1 = "1d";
var Core_ToDo$1 = "To Do";
var Core_ToggleExactMatches$1 = "Toggle exact matches";
var Core_Top$1 = "Top";
var Core_Topics$1 = "Skills";
var Core_TotalMembers$1 = "{{count}} members";
var Core_Translations$1 = "Translations";
var Core_True$1 = "True";
var Core_TwoToFourWeeks$1 = "2-4 Weeks";
var Core_Type$1 = "Type";
var Core_UnableToEnrollFormat$1 = "Unable to enroll in {{type}}";
var Core_UncompletedFormat$1 = "Uncompleted the {{resourceType}}";
var Core_Undergraduate$1 = "Undergraduate";
var Core_UndislikeAllyText$1 = "Undislike {{type}} {{name}}";
var Core_UnfeatureResource$1 = "Remove From Featured";
var Core_UnFollow$1 = "Unfollow";
var Core_Units$1 = "Units";
var Core_Unknown$1 = "Unspecified";
var Core_Unlike$1 = "Unlike";
var Core_UnlikeAllyText$1 = "Unlike {{type}} {{name}}";
var Core_Unpublish$1 = "Unpublish";
var Core_UnpublishedChanges$1 = "Unpublished Changes";
var Core_Unsave$1 = "Unsave";
var Core_UnsaveItem$1 = "Unsave {{type}} {{name}}";
var Core_UnselectAll$1 = "Unselect All";
var Core_Update$1 = "Update";
var Core_Updated$1 = "updated";
var Core_Upload$1 = "Upload";
var Core_UploadCategories$1 = "Upload Categories";
var Core_Uploaded$1 = "Uploaded";
var Core_UploadedFilesForSource$1 = "Uploaded files for this source.";
var Core_UploadNew$1 = "Upload New";
var Core_UploadTranslations$1 = "Upload Translations";
var Core_Url$1 = "URL";
var Core_UrlRequired$1 = "A valid URL is required";
var Core_Usd$1 = "USD";
var Core_UsedIn$1 = "Used In";
var Core_User$1 = "Person";
var Core_UserActivityInformation$1 = "If this looks suspicious contact your information security administrator.";
var Core_Users$1 = "Users";
var Core_UsersDisplayName$1 = "People";
var Core_UTCDatesNote$1 = "All Dates are UTC";
var Core_Valid_No_WhiteSpace$1 = "This field cannot have leading or trailing spaces, or be just spaces.";
var Core_ValidUrl$1 = "Please use a valid and complete URL";
var Core_Verify$1 = "Verify";
var Core_Video$1 = "Video";
var Core_Videos$1 = "Videos";
var Core_VideosDisplayName$1 = "Videos";
var Core_View$1 = "View";
var Core_ViewAll$1 = "View All";
var Core_ViewConversation$1 = "View conversation";
var Core_ViewDescription$1 = "View Description";
var Core_ViewDetails$1 = "View Details";
var Core_Viewed$1 = "Viewed";
var Core_ViewInCollection$1 = "View In Collection";
var Core_ViewInGoals$1 = "View In Goals";
var Core_ViewInstructions$1 = "View Instructions";
var Core_ViewPathway$1 = "View";
var Core_ViewProfile$1 = "View Profile";
var Core_Views$1 = "Views";
var Core_ViewSavedItems$1 = "View Saved Items";
var Core_ViewSkills$1 = "View Skills";
var Core_VirtualClassroom$1 = "Virtual Classroom";
var Core_VisibilityCollaborators$1 = "Collaborators";
var Core_VisibilityDocLinkLabel$1 = "Learn more about Degreed visibility settings";
var Core_VisibilityGroup$1 = "Group";
var Core_VisibilityGroups$1 = "Groups";
var Core_VisibilityOrganization$1 = "Organization";
var Core_VisibilityProfile$1 = "Public Profile";
var Core_VisibilityPublic$1 = "Organization";
var Core_VisitProvider$1 = "Visit";
var Core_VisitUrl$1 = "Visit URL";
var Core_VisitWebsite$1 = "Visit {{name}} website";
var Core_Warning$1 = "Warning";
var Core_Watch$1 = "Watch";
var Core_Week$1 = "Week";
var Core_Weeks$1 = "Weeks";
var Core_WeeksAgoFormat$1 = "{{time}} weeks ago";
var Core_WhatDidYouLearnAudioLong$1 = "What did you learn from this podcast?";
var Core_Withdraw$1 = "Withdraw";
var Core_withPublished$1 = "Published";
var Core_Word$1 = "Word";
var Core_WordLimitExceeded$1 = "Word limit exceeded";
var Core_Words$1 = "Words";
var Core_WordsRemainingFormat$1 = "Words remaining: {{count}}";
var Core_Workshop$1 = "Workshop";
var Core_WouldYouLikeToProceed$1 = "Would you like to proceed?";
var Core_Year$1 = "Year";
var Core_YearAgoFormat$1 = "{{time}} year ago";
var Core_YearsAgoFormat$1 = "{{time}} years ago";
var Core_YearsAgoFormat_Minimal$1 = "{{time}}y";
var Core_Yes$1 = "Yes";
var Core_YesContinue$1 = "Yes, continue";
var Core_YesProceed$1 = "Yes, Proceed";
var Core_YesSure$1 = "Yes, I'm Sure";
var Core_Yesterday$1 = "Yesterday";
var Core_Yesterday_Minimal$1 = "2d";
var Core_YourFocusSkills$1 = "Your Focus Skills";
var Core_ZeroSignalsCount$1 = "0 Signals";
var Core_ZeroSkills$1 = "Skills";
var Core_ZeroSkillsCount$1 = "0 Skills";
var Core_ZoomIn$1 = "Zoom in";
var Core_ZoomOut$1 = "Zoom out";
var Core_Ztoa$1 = "Z to A";
var CopyLinkSvc_ActionMessage$1 = "Copied!";
var CopyLinkSvc_MacCopy$1 = "Press ⌘-C to copy";
var CopyLinkSvc_PcCopy$1 = "Press Ctrl-C to copy";
var CookieNotice_CookieDescription_AntiforgeryrequestV4Degreed$1 = "Used to prevent CSRF attacks.";
var CookieNotice_CookieDescription_AntiforgeryV4Degreed$1 = "Anti-forgery token used to prevent Cross-Site Request Forgery (CSRF).";
var CookieNotice_CookieDescription_DegreedBearerAccess$1 = "Stores an encrypted OAuth token by which the Degreed Button can authenticate to the Degreed application.";
var CookieNotice_CookieDescription_DegreedHost$1 = "Stores host that Degreed Button is communicating with (e.g., degreed.com, eu.degreed.com, etc.).";
var CookieNotice_CookieDescription_Helpdeskcookie$1 = "Stores encrypted host value used to seamlessly integrate the Degreed Knowledge Center with Degreed (e.g., degreed.com, eu.degreed.com, etc.).";
var CookieNotice_CookieDescription_IdentityV4Degreed$1 = "Stores encrypted identity-related information to maintain site authentication.";
var CookieNotice_CookieDescription_IsEU$1 = "Used to control display of policy banners.";
var CookieNotice_CookieDescription_IsNonEU$1 = "Used to control display of policy banners.";
var CookieNotice_CookieDescription_SessionTimeout$1 = "Stores a session expiration date/time based upon system session timeout settings.";
var CookieNotice_CookieDescription_SessionV4Degreed$1 = "Stores session-related information, including the unique session ID, in a hashed, randomly generated number.";
var CookieNotice_CookieDescription_SsoV4Degreed$1 = 'Stores one-way hash of the last IdP used for single sign-on ("SSO") to facilitate SP-initiated SSO when the user’s session expires.';
var CookieNotice_DurationType_Logout$1 = "Logout";
var CookieNotice_DurationType_Persistent1$1 = "Persistent (1 day)";
var CookieNotice_DurationType_Persistent60Custom$1 = "Persistent (token expires in 60 days), duration customizable by clients.";
var CookieNotice_DurationType_Persistent90$1 = "Persistent (90 days)";
var CookieNotice_DurationType_PersistentUpdated$1 = "Persistent, until updated by application";
var CookieNotice_DurationType_Session$1 = "Session";
var CookieNotice_EssentialCookies_Content$1 = '<p>\n    When you visit the Degreed platform, some cookies are required for technical\n    reasons that are necessary for the Degreed platform to operate. We refer to\n    these as "essential" cookies.\n  </p>\n  <p>\n    The essential cookies served to your device when you use the Degreed\n    platform are as follows:\n  </p>';
var CookieNotice_EssentialCookies_Title$1 = "Essential Cookies";
var CookieNotice_NonEssentialCookies_Content$1 = "<p>\n    If the Degreed platform is provided to you under an enterprise arrangement\n    with your employer, your employer may require that certain other\n    non-essential cookies are served to your device. These cookies may be served\n    by third parties analytics services (such as Google Analytics and Amplitude)\n    for purposes of gathering information.\n  </p>\n  <p>\n    It is your organization's responsibility to inform you of the details of any\n    such cookies that are served to your device. If you have any questions\n    concerning cookies served to your device that are mandated by your employer\n    then you should speak with your employer about such cookies.\n  </p>";
var CookieNotice_NonEssentialCookies_Title$1 = "Non-essential cookies on the Degreed platform";
var CookieNotice_OtherWebsiteCookies_Content$1 = "<p>\n    Users may be directed to other websites through links within Degreed.\n    Degreed has no control over the practices of other websites not owned or\n    controlled by Degreed. Your device may receive cookies or other similar\n    technologies from other websites and such websites are not subject to\n    Degreed's Privacy Policy or Cookie Notice. Third-party vendors, including\n    Google, may use cookies to serve ads based on a User's prior visits to\n    Degreed.com.\n  </p>";
var CookieNotice_OtherWebsiteCookies_Title$1 = "Cookies on other websites";
var CookieNotice_TableHeader_Duration$1 = "Duration";
var CookieNotice_TableHeader_Name$1 = "Name";
var CookieNotice_TableHeader_Provider$1 = "Provider";
var CookieNotice_TableHeader_Purpose$1 = "Purpose";
var CookieNotice_WhatAreCookies_Content$1 = '<p>\n    Cookies are small data files containing text that a website asks your device\n    to store. Cookies are used for a variety of reasons, including enabling\n    websites to provide functionality (like remembering that you are logged in)\n    or enabling them to work more efficiently. Other technologies, including\n    data we store on your web browser or device, identifiers associated with\n    your device, and other software, are used for similar purposes.\n  </p>\n  <p>\n    Cookies served by a website operator are called "first party cookies". Only\n    the website operator can access the first party cookies it sets. Cookies set\n    by parties other than the website owner are called "third party cookies".\n    Third party cookies enable third party features or functionality to be\n    provided on or through the website (e.g. like advertising, interactive\n    content and social sharing). The parties that set these third party cookies\n    may be able to recognise your device both when it visits the website in\n    question and also when it visits other websites that have partnered with the\n    third party.\n  </p>\n  <p>\n    Some cookies only persist on your device whilst you are visiting a website\n    or using a service. These are known as "session" cookies. Other types of\n    cookies can remain on your device after you have left a website or stopped\n    using a service. These are known as "persistent" cookies.\n  </p>\n  <p>\n    Cookies are not the only way to recognise or track visitors to a website. We\n    may use other, similar technologies from time to time, like web beacons\n    (sometimes called "tracking pixels\'\' or "clear gifs"). These are tiny\n    graphics files that contain a unique identifier that enable us to recognise\n    when someone has visited the Degreed site or opened an email that we have\n    sent.\n  </p>';
var CookieNotice_WhatAreCookies_Title$1 = "What are cookies?";
var ContentTabs_AddArticle$1 = "Enter a link to an article you’ve read";
var ContentTabs_AddPost$1 = "Enter a link to a post you’ve read";
var ContentTabs_AddTopicsOrSkills$1 = "Add Skills";
var ContentTabs_AddVideo$1 = "Enter a link to a video you’ve watched";
var ContentTabs_EnterBookTitle$1 = "Enter the name of a book you’ve read";
var ContentTabs_InvalidTitle$1 = "Please enter a title";
var ContentTabs_InvalidUrl$1 = "Please enter a valid url";
var ContentTabs_RelatedSkills$1 = "Related Skills";
var ContentTabs_YouAddedToProfile$1 = "You added this {{type}} to your profile";
var confirmModal_CancelApplicationBody$1 = "Are you sure you want to cancel the skill application for {{credName}}? This can't be undone.";
var confirmModal_DeleteAccomplishmentBody$1 = "This accomplishment will no longer appear in your profile.";
var confirmModal_DeleteAccomplishmentTitle$1 = "Are you sure you want to delete this accomplishment?";
var confirmModal_DeleteArticleBody$1 = "This article will no longer count toward your overall points and will no longer appear in your profile.";
var confirmModal_DeleteArticleTitle$1 = "Are you sure you want to delete this article?";
var confirmModal_DeleteAssessmentBody$1 = "This assessment will no longer count toward your overall points and will no longer appear in your profile.";
var confirmModal_DeleteAssessmentTitle$1 = "Are you sure you want to delete this assessment?";
var confirmModal_DeleteAwardBody$1 = "This award will no longer appear in your profile.";
var confirmModal_DeleteAwardTitle$1 = "Are you sure you want to delete this award?";
var confirmModal_DeleteBadgeBody$1 = "This badge will no longer appear in your profile.";
var confirmModal_DeleteBadgeTitle$1 = "Are you sure you want to delete this badge?";
var confirmModal_DeleteBookBody$1 = "This book will no longer count toward your overall points and will no longer appear in your profile.";
var confirmModal_DeleteBookTitle$1 = "Are you sure you want to delete this book?";
var confirmModal_DeleteCertificateBody$1 = "This certificate will no longer appear in your profile.";
var confirmModal_DeleteCertificateTitle$1 = "Are you sure you want to delete this certificate?";
var confirmModal_DeleteCourseBody$1 = "This course will no longer count toward your overall points and will no longer appear in your profile.";
var confirmModal_DeleteCourseTitle$1 = "Are you sure you want to delete this course?";
var confirmModal_DeleteDegreeBody$1 = "This degree will no longer appear in your profile.";
var confirmModal_DeleteDegreeTitle$1 = "Are you sure you want to delete this degree?";
var confirmModal_DeleteEpisodeBody$1 = "This episode will no longer count toward your overall points and will no longer appear in your profile.";
var confirmModal_DeleteEpisodeTitle$1 = "Are you sure you want to delete this episode?";
var confirmModal_DeleteEventBody$1 = "This event will no longer count toward your overall points and will no longer appear in your profile.";
var confirmModal_DeleteEventTitle$1 = "Are you sure you want to delete this event?";
var confirmModal_DeletePositionBody$1 = "This position will no longer count toward your overall points and will no longer appear in your profile.";
var confirmModal_DeletePositionTitle$1 = "Are you sure you want to delete this position?";
var confirmModal_DeletePostBody$1 = "These items will no longer count toward your overall points and will no longer appear in your profile.";
var confirmModal_DeletePostTitle$1 = "Are you sure you want to delete the selected item?";
var confirmModal_DeleteSkillBody$1 = "This skill will no longer appear in your profile.";
var confirmModal_DeleteSkillTitle$1 = "Are you sure you want to delete this skill?";
var confirmModal_DeleteTaskBody$1 = "This task will no longer count toward your overall points and will no longer appear in your profile.";
var confirmModal_DeleteTaskTitle$1 = "Are you sure you want to delete this task?";
var confirmModal_DeleteVideoBody$1 = "This video will no longer count toward your overall points and will no longer appear in your profile.";
var confirmModal_DeleteVideoTitle$1 = "Are you sure you want to delete this video?";
var confirmModal_EvalCancelApplicationBody$1 = "Are you sure you want to cancel the Skill Review for {{tagName}}? This can't be undone.";
var confirmModal_EvalRestartApplicationBody$1 = 'Click "Start" to begin a new Skill Review. Skill Reviews are a great way to measure your individual development.';
var CompletedSkillRating_Format$1 = "{{nameHtml}} completed the skill you shared with them";
var completedRecommendation_ArticleFormat$1 = "{{nameHtml}} completed the article you shared with them.";
var completedRecommendation_AssessmentFormat$1 = "{{nameHtml}} completed the assessment you shared with them.";
var completedRecommendation_BookFormat$1 = "{{nameHtml}} completed the book you shared with them.";
var completedRecommendation_CourseFormat$1 = "{{nameHtml}} completed the course you shared with them.";
var completedRecommendation_EpisodeFormat$1 = "{{nameHtml}} completed the podcast you shared with them.";
var completedRecommendation_EventFormat$1 = "{{nameHtml}} completed the event you shared with them.";
var completedRecommendation_Format$1 = "{{nameHtml}} completed the {{resourceType}} you shared with them.";
var completedRecommendation_PathwayFormat$1 = "{{nameHtml}} completed the pathway you shared with them.";
var completedRecommendation_PostFormat$1 = "{{nameHtml}} completed the post you shared with them.";
var completedRecommendation_SkillFormat$1 = "{{nameHtml}} completed the skill you shared with them.";
var completedRecommendation_TargetFormat$1 = "{{nameHtml}} completed the plan you shared with them.";
var completedRecommendation_TaskFormat$1 = "{{nameHtml}} completed the task you shared with them.";
var completedRecommendation_VideoFormat$1 = "{{nameHtml}} completed the video you shared with them.";
var completedRecommendationFollow_Format$1 = "{{nameHtml}} followed the {{resourceType}} you shared with them.";
var completedGoal_Single$1 = "You completed the goal {{goalHtml}}";
var completedAssignedLearning_Format$1 = "{{nameHtml}} has completed your assignment.";
var ComparisonSvc_RatingError$1 = "Sorry! There was a problem saving your rating.";
var ComparisonSvc_SelectionError$1 = "Sorry! There was a problem saving your selection.";
var ComparisonRatingSkillOptionsSvc_Capable$1 = "Capable";
var ComparisonRatingSkillOptionsSvc_CapableDesc$1 = "Demonstrated ability in skill, but would likely be deterred by significant challenges.";
var ComparisonRatingSkillOptionsSvc_Distinguished$1 = "Distinguished";
var ComparisonRatingSkillOptionsSvc_DistinguishedDesc$1 = "Mastery of skill that is difficult to obtain.";
var ComparisonRatingSkillOptionsSvc_Emerging$1 = "Emerging";
var ComparisonRatingSkillOptionsSvc_EmergingDesc$1 = "Superficial demonstration of basic skill.";
var ComparisonRatingSkillOptionsSvc_Experienced$1 = "Experienced";
var ComparisonRatingSkillOptionsSvc_ExperiencedDesc$1 = "Experience and ability in skill, and is unlikely to be deterred by challenges.";
var ComparisonRatingSkillOptionsSvc_Master$1 = "Master";
var ComparisonRatingSkillOptionsSvc_MasterDesc$1 = "Industry expert, skill shows an unmatched level of mastery.";
var ComparisonRatingSkillOptionsSvc_Novice$1 = "Novice";
var ComparisonRatingSkillOptionsSvc_NoviceDesc$1 = "Little to no understanding or demonstration of basic skill.";
var ComparisonRatingOptionsSvc_Capable$1 = "Capable";
var ComparisonRatingOptionsSvc_CapableDesc$1 = "Candidate has demonstrated ability in their skills, but would likely be deterred by significant challenges. May have one or more significant accomplishment.";
var ComparisonRatingOptionsSvc_Distinguished$1 = "Distinguished";
var ComparisonRatingOptionsSvc_DistinguishedDesc$1 = "Candidate has mastery of skills that are difficult to obtain. Accomplishments are rare and significant.";
var ComparisonRatingOptionsSvc_Emerging$1 = "Emerging";
var ComparisonRatingOptionsSvc_EmergingDesc$1 = "Candidate has superficial demonstration of basic skills. Accomplishments would be expected of those starting to work in this area.";
var ComparisonRatingOptionsSvc_Experienced$1 = "Experienced";
var ComparisonRatingOptionsSvc_ExperiencedDesc$1 = "Candidate has experience and ability in their skills, and is unlikely to be deterred by challenges. Accomplishments are significant, though not necessarily rare.";
var ComparisonRatingOptionsSvc_Master$1 = "Master";
var ComparisonRatingOptionsSvc_MasterDesc$1 = "Candidate is an industry expert, whose skills show an unmatched level of mastery. Accomplishments are unique and significant on an industry-wide level.";
var ComparisonRatingOptionsSvc_Novice$1 = "Novice";
var ComparisonRatingOptionsSvc_NoviceDesc$1 = "Candidate has little to no understanding or demonstration of basic skills. Accomplishments are not to be found or could be obtained with minimal effort.";
var ComparisonCriteriaSvc_Accomplishments$1 = "Rate this candidate based on the significance and difficulty of their accomplishments";
var ComparisonCriteriaSvc_ProvidedInformation$1 = "Rate this candidate based on all the information provided";
var ComparisonCriteriaSvc_SkillBreadth$1 = "Rate this candidate based on the breadth of their skills";
var ComparisonCriteriaSvc_SkillMastery$1 = "Rate this candidate based on the mastery of their skills";
var compareForm_CandidateHeader$1 = "Candidate {{candidateNumber}}";
var compareForm_CandidateLabel$1 = "Candidate";
var compareForm_DetailTitle$1 = "Skill Details";
var compareForm_Header$1 = "Which candidate is better at {{credentialName}}?";
var compareForm_Instructions$1 = "It’s time to review your peers! Rate carefully, because these ratings are one of the factors that will help determine your level.";
var compareForm_Prompt$1 = "Which candidate demonstrated more expertise in {{credentialName}}?";
var compareForm_SelectWinnerValidationMessage$1 = "Please select a candidate as the winner";
var compareForm_SummaryTitle$1 = "Skill Behaviors";
var CommonMeta_AuthorContentTitle$1 = "{0} Authoring";
var CommonMeta_CertificateDescription$1 = "With Degreed Skill Certification, you can certify the skills you have—any skill, any level, regardless of where you got them.";
var CommonMeta_CertificateTitle$1 = "My {0} Skill Certification | Degreed";
var CommonMeta_DegreedInfo$1 = "Degreed is a free service that tracks and scores all of your education--from books and online courses to formal college degrees. Get credit for everything you learn with Degreed.";
var CommonMeta_EmptyProfileTitle$1 = "User Profile";
var CommonMeta_ForMeDescription$1 = "Degreed is a lifelong learning platform that allows you to discover learning content, build your skills, and get your skills certified.";
var CommonMeta_ForMeTitle$1 = "Degreed | Learn with purpose";
var CommonMeta_LifelongDiploma$1 = "Degreed connects learning, talent development, and internal mobility opportunities in one place - so you can reinvent yourself one skill at a time.";
var CommonMeta_PersonalProfileTitle$1 = "{0}'s Profile";
var CommonMeta_PrivateProfileTitle$1 = "Private Profile";
var CommonMeta_ProfileOgTitle$1 = "{0}'s Degreed Profile";
var CommonMeta_TopicDescription$1 = "We've gathered popular articles, courses, videos, books, podcasts, and pathways for you to explore and learn more about {0}.";
var CommonMeta_TopicTitle$1 = "Learn about {0} | Degreed";
var CommentsSvc_AccessError$1 = "Sorry! There was a problem accessing comments.";
var CommentsSvc_AccessRepliesError$1 = "Sorry! There was a problem accessing comment replies.";
var CommentsSvc_AddCommentError$1 = "Sorry! There was a problem adding a comment.";
var CommentsSvc_AddReplyError$1 = "Sorry! There was a problem adding a reply.";
var CommentsSvc_FlagCommentError$1 = "Sorry! There was a problem flagging the comment.";
var CommentsSvc_GetUsersError$1 = "An error occurred getting a list of people.";
var CommentsSvc_LikeError$1 = "Sorry! There was a problem updating the comment status.";
var CommentsSvc_RemoveCommentError$1 = "Sorry! There was a problem removing the comment.";
var CommentsSvc_UpdateCommentError$1 = "Sorry! There was a problem updating the comment.";
var CommentsSvc_UsersTitle$1 = "People who liked this";
var CommentsCtrl_DeleteComment$1 = "Are you sure you would like to delete this comment?";
var CommentsCtrl_DeleteCommentReplies$1 = "Are you sure you would like to delete this comment and its replies?";
var CommentsCtrl_DeletePost$1 = "Delete Post";
var CommentsCtrl_EditPost$1 = "Edit Post";
var CommentsCtrl_Like$1 = "Like";
var CommentsCtrl_Liked$1 = "Liked";
var CommentsCtrl_PublicComment$1 = "This comment will be public";
var CommentsCtrl_PublicCommentDesc$1 = "This discussion is part of a public forum. Anything you post will be publicly viewable. Are you sure you would like to post a comment?";
var CommentsCtrl_Reply$1 = "Reply";
var CommentsCtrl_Unlike$1 = "Unlike";
var CommentsCtrl_ViewConversation$1 = "View conversation";
var CommentsCtrl_YesDelete$1 = "Yes, delete";
var Coach_AddCoverAltFormat$1 = "{{title}} avatar";
var Coach_AddInputLabelText$1 = "Coach name";
var Coach_AddInputPlaceholder$1 = "Type to search for a coach.";
var Coach_AdditionalFeedback$1 = "Additional Feedback";
var Coach_AddModalTitle$1 = "Add Coach";
var Coach_AddRequiredName$1 = "Coach name is required";
var Coach_AllConversations$1 = "All Conversations";
var Coach_Capabilities$1 = "Capabilities";
var Coach_ChooseSkill$1 = "Pick a skill to review";
var Coach_ChooseSkillNote$1 = "Before You Start, Please Note";
var Coach_ClearChat$1 = "Clear Chat";
var Coach_ClearChatHeader$1 = "Are you sure you want to clear chat?";
var Coach_ClearChatMessage$1 = "Once cleared, you won’t be able to retrieve it.";
var Coach_ClickToStart$1 = "Click to start conversation";
var Coach_ComingSoon$1 = "Coming Soon";
var Coach_ConversationLoadError$1 = "There is issue while loading your conversation";
var Coach_ConversationStartFailed$1 = "Unable to start the conversation. Please try again later.";
var Coach_Copied$1 = "Copied";
var Coach_CopySuccess$1 = "Message copied to clipboard. Use ⌘/Ctrl + V to paste";
var Coach_DefaultSkillReport$1 = "Currently, there's not enough information to create a detailed report. With a bit more interaction, we'll be able to generate a comprehensive overview!";
var Coach_DeleteConversation$1 = "Delete conversation?";
var Coach_DeleteConversationAction$1 = "Delete this conversation";
var Coach_DeleteConversationMessage$1 = 'This will delete <b> "{{ conversationSummary }}" </b>';
var Coach_EndConversation$1 = "End Conversation";
var Coach_ErrorText$1 = "Oops! Something went wrong. Please try again.";
var Coach_Evaluate$1 = "Review";
var Coach_EvaluateNewSkill$1 = "Try evaluating new skill";
var Coach_ExploreContent$1 = "Explore Content";
var Coach_ExploreMaestro$1 = "Explore Maestro";
var Coach_ExploreMentors$1 = "Explore Mentors";
var Coach_ExplorePathways$1 = "Explore Pathways";
var Coach_ExportError$1 = "Oops! Something went wrong while downloading. Please try again";
var Coach_ExportSummary$1 = "Export PDF Summary";
var Coach_FeedbackForMessage$1 = "Provide feedback to this message";
var Coach_FeedbackHeader$1 = "Provide Feedback";
var Coach_FeedbackOptionalText$1 = "Feel free to add more (Optional)";
var Coach_FeedbackUpdateError$1 = "Sorry, we couldn't update your feedback. Please try again later.";
var Coach_FeedbackUpdateSuccess$1 = "Thank you for your feedback! It helps us improve!";
var Coach_FormCtrlAreYouSure$1 = "Changes you have made will be lost. Are you sure you want to close?";
var Coach_GenerateSummaryCTA$1 = "Generate Summary";
var Coach_GenerateSummarySuccess$1 = "Summary and recommendations have been successfully generated.";
var Coach_GeneratingRecommendationError$1 = "There was some issue while generating summaries and recommendation. Try again";
var Coach_GeneratingSkillReport$1 = "Generating your skill review report, summary, and recommendations. Please wait";
var Coach_GeneratingSummary$1 = "Please wait while we generate summary and recommendations";
var Coach_GetStarted$1 = "Get started";
var Coach_HiText$1 = "Hi";
var Coach_InputPlaceholder$1 = "Start a conversation with {{Coach}}";
var Coach_InstructionAllow$1 = "Click “Allow” You don't need to click anything to take turns, just talk! Press play on the next card";
var Coach_InstructionInterrupt$1 = "If the assistant interrupts you, we're sorry! Feel free to finish your thought- they won't mind";
var Coach_InstructionMicEnable$1 = "You will be prompted to enable your microphone";
var Coach_InstructionVolumeUp$1 = "Make sure your volume is turned up";
var Coach_ModelAnalysis$1 = "Modal analysis";
var Coach_MuteMicrophone$1 = "Mute microphone";
var Coach_NewChat$1 = "New Chat";
var Coach_NoConversationText$1 = "No Conversations yet";
var Coach_NoDataFound$1 = "No data found";
var Coach_NoRecommendations$1 = "No Recommendations Found";
var Coach_NoSummary$1 = "No Summary Found";
var Coach_NotEnabledWarning$1 = "This feature is currently unavailable. Please check with your admin for access";
var Coach_NoTranscriptsFound$1 = "Start the conversation to view the transcript.";
var Coach_PinConversation$1 = "Pin this message";
var Coach_Pinned$1 = "Pinned";
var Coach_PlayPauseAllyText$1 = "Click here to play/pause coach introduction video";
var Coach_Prompts$1 = "Prompts";
var Coach_PromptsEmpty$1 = "No Prompts Found";
var Coach_RecentConversations$1 = "Recent Conversations";
var Coach_Recommendations$1 = "Recommendations";
var Coach_RecommendedContent$1 = "Recommended Content";
var Coach_RecommendedMentors$1 = "Recommended Mentors";
var Coach_RecommendedPathways$1 = "Recommended Pathways";
var Coach_SelectSkill$1 = "Select a skill for review";
var Coach_ShowAllCapabilities$1 = "View All Capabilities";
var Coach_SkillEvaluationDuration$1 = "This review will take 5 - 10 mins";
var Coach_SkillLevelDescription$1 = "Skill level description";
var Coach_SkillReport$1 = "Skill Report";
var Coach_SkillReportModalHeader$1 = "Your Skill Report is Ready";
var Coach_SkillReportModalSubHeader$1 = "Here's your Skill Report for {{skill_name}}";
var Coach_SkillReportSummaryHeader$1 = "Summary of your skill review";
var Coach_SkillReviewCompleted$1 = "Your skill review is completed";
var Coach_SpeakToInterrupt$1 = "Speak to Interrupt";
var Coach_StartConversation$1 = "Start a Conversation";
var Coach_StartNewSkillReview$1 = "to start new skill review";
var Coach_TextChatMode$1 = "Text Chat";
var Coach_TextMode$1 = "Text";
var Coach_TotalPinned$1 = "Pinned ({{totalPinned}})";
var Coach_TrackAllConversations$1 = "Track all your conversations here";
var Coach_Transcript$1 = "Transcript";
var Coach_UnmuteMicrophone$1 = "Unmute microphone";
var Coach_UpdateSkillRatings$1 = "Update your skill rating";
var Coach_UploadContent$1 = "Upload content here";
var Coach_VideoTagNoSupport$1 = "Your browser does not support the video tag.";
var Coach_ViewMoreOptions$1 = "Click here to view more options";
var Coach_ViewSummary$1 = "View Summary";
var Coach_VirtualCoachHeader$1 = "Virtual Coach";
var Coach_VoiceChatMode$1 = "Voice Chat";
var Coach_VoiceMode$1 = "Voice";
var Coach_WelcomeBackText$1 = "Welcome Back";
var checkDuplicateInputs_Decision$1 = "Choose an item to add to Pathway Bin.";
var checkDuplicateInputs_DuplicatesFoundPlural$1 = "We found {{count}} items that already use this URL.";
var checkDuplicateInputs_DuplicatesFoundSingle$1 = "We found {{count}} item that already uses this URL.";
var checkDuplicateInputs_ViewDuplicates$1 = "View Duplicates";
var ChartsModule_MinimumSkillUserCountEmptyStateText_Description$1 = "The {{ x }} chart will not display because the minimum user count of <b>{{ y }}</b> has not been reached.<br>Change the Learning Summary Type filter or contact your Degreed Admin for further assistance.";
var ChartsModule_MinimumSkillUserCountEmptyStateText_Header$1 = "Not enough users to display this data";
var CertificateFormCtrl_AddCertificate$1 = "Add Certificate";
var CertificateFormCtrl_CertificateNumber$1 = "Certificate Number";
var CertificateFormCtrl_EndAfterStart$1 = "The end date must be after the start date.";
var CertificateFormCtrl_ExpirationDate$1 = "Please specify the expiration date.";
var CertificateFormCtrl_ExpiryDate$1 = "Expiry Date";
var CertificateFormCtrl_IssueDate$1 = "Issue Date";
var CertificateFormCtrl_IssuerName$1 = "Issuer Name";
var CertificateFormCtrl_IssuerNameRequired$1 = "A certificate issuer name is required.";
var CertificateFormCtrl_IssuerURL$1 = "Issuer URL";
var CertificateFormCtrl_SaveCertificate$1 = "Save Certificate";
var CertificateFormCtrl_StartDate$1 = "Please specify the start date.";
var CertificateFormCtrl_TitleRequired$1 = "A certificate title is required.";
var BusinessRules_AcmAddUser$1 = "Enable Academy Admin Access";
var BusinessRules_AcmDeleteUser$1 = "Disable ACM Access";
var BusinessRules_ActionType$1 = "Action Type";
var BusinessRules_AddAction$1 = "Add Action";
var BusinessRules_AddAttribute$1 = "Add Attribute";
var BusinessRules_AddCondition$1 = "Add Condition";
var BusinessRules_AddProviderLicense$1 = "Add Provider Visibility";
var BusinessRules_AddRole$1 = "Update Permission Role";
var BusinessRules_AddRule$1 = "Add Rule";
var BusinessRules_AddSegments$1 = "Add Segments";
var BusinessRules_AddSkill$1 = "Add Skill";
var BusinessRules_AddSkillPlan$1 = "Add Plan";
var BusinessRules_AddToGroup$1 = "Add Group";
var BusinessRules_AddToPathway$1 = "Add Pathway";
var BusinessRules_And$1 = "And";
var BusinessRules_ApplyToAllUsers$1 = "User Record Received";
var BusinessRules_ApplyToNewUsers$1 = "User Is Created";
var BusinessRules_AreYouSure_DeleteSegments_Format$1 = "Are you sure you want to permanently delete the following {{count}} Segments?";
var BusinessRules_AssignResource$1 = "Assign";
var BusinessRules_AttributeInstructions$1 = "You are limited to 20 conditions.";
var BusinessRules_AttributeName$1 = "Attribute Name";
var BusinessRules_Attributes_Column$1 = "Attributes";
var BusinessRules_AttributeValue$1 = "Attribute Value";
var BusinessRules_BeyondDaysAgo$1 = "Over";
var BusinessRules_CloneSegment$1 = "Clone Segment";
var BusinessRules_CloneSegmentFormat$1 = "Are you sure you want to clone {{name}}?  The clone will open automatically for editing.";
var BusinessRules_Condition$1 = "Condition";
var BusinessRules_Conditions_Column$1 = "Conditions";
var BusinessRules_Contains$1 = "Contains";
var BusinessRules_CreateARule$1 = "Create a Rule";
var BusinessRules_CreateASegment$1 = "Create a Segment";
var BusinessRules_CreateSegment$1 = "Create Segment";
var BusinessRules_DateCreated_Column$1 = "Date Created";
var BusinessRules_DaysAgo$1 = "Days ago";
var BusinessRules_DeleteModalBody_Format$1 = "Are you sure you want to delete {{name}}?";
var BusinessRules_DeleteSegments$1 = "Delete Segments";
var BusinessRules_DeleteUser$1 = "Delete User";
var BusinessRules_DoesNotEqual$1 = "Does not equal";
var BusinessRules_EditRule$1 = "Edit Rule";
var BusinessRules_EditSegment$1 = "Edit Segment";
var BusinessRules_Equals$1 = "Equals";
var BusinessRules_Error_DuplicateRuleName$1 = "Duplicate name.  Please enter a unique name to continue";
var BusinessRules_GreaterOrEqual$1 = ">=";
var BusinessRules_GreaterThan$1 = ">";
var BusinessRules_If$1 = "If";
var BusinessRules_LesserOrEqual$1 = "<=";
var BusinessRules_LessThan$1 = "<";
var BusinessRules_ManageSegments$1 = "Manage Segments";
var BusinessRules_NA$1 = "NA";
var BusinessRules_NewItem_Format_AddNewSkill$1 = "Add new skill: {{name}}";
var BusinessRules_NotifyUser$1 = "Send Notification";
var BusinessRules_Operator$1 = "Operator";
var BusinessRules_PrivacyOutcomeWarning$1 = "Using Business Rules to set a user’s Profile Privacy overrides the user-selected setting each time the rule is run. Are you sure you want to set the Profile Privacy?";
var BusinessRules_Qualifier$1 = "Qualifier";
var BusinessRules_RemoveAction$1 = "Remove action";
var BusinessRules_RemoveCondition$1 = "Remove Condition";
var BusinessRules_RuleError_Description$1 = "This rule includes one or more errors that must be addressed. See the description below each field that includes an error.";
var BusinessRules_RuleError_Tooltip$1 = "Rule errors detected.  Click Edit for more information.";
var BusinessRules_RuleName$1 = "Rule Name";
var BusinessRules_SearchForProviderLicense$1 = "Search for Provider";
var BusinessRules_SearchForRole$1 = "Search For Role";
var BusinessRules_SearchForSkill$1 = "Search For Skill";
var BusinessRules_SearchForSkillPlan$1 = "Search For Skill Plan";
var BusinessRules_SegmentName$1 = "Segment Name";
var BusinessRules_SegmentNamePlaceholder$1 = "Segment Name";
var BusinessRules_SegmentsDeleted_Toast$1 = "Segments deleted successfully";
var BusinessRules_SegmentSearch_Placeholder$1 = "Search for Segment Name, Attribute Name, or Attribute Value";
var BusinessRules_SelectASegment$1 = "Select a segment";
var BusinessRules_SelectSegment$1 = "Select Segment";
var BusinessRules_SendEmail$1 = "Send Email";
var BusinessRules_SendNotification$1 = "Send Notification";
var BusinessRules_SetProfilePrivacy$1 = "Set Profile Privacy";
var BusinessRules_ShareResource$1 = "Share";
var BusinessRules_Then$1 = "Then";
var BusinessRules_ToggleActiveModalBody_ToDisable_Format$1 = "Are you sure you want to disable {{name}}?";
var BusinessRules_ToggleActiveModalBody_ToEnable_Format$1 = "Are you sure you want to enable {{name}}";
var BusinessRules_ToggleActiveModalConfirm_ToDisable$1 = "Yes, disable rule";
var BusinessRules_ToggleActiveModalConfirm_ToEnable$1 = "Yes, enable rule";
var BusinessRules_ToggleActiveModalHeader_ToDisable$1 = "Disable Automation";
var BusinessRules_ToggleActiveModalHeader_ToEnable$1 = "Enable Automation";
var BusinessRules_Trigger_Column$1 = "Trigger";
var BusinessRules_Value$1 = "Value";
var BusinessRules_WithinDaysAgo$1 = "Within the last";
var bulkUpdateModal_Cancel$1 = "Cancel";
var bulkUpdateModal_CancelProcessing$1 = "Cancel processing";
var bulkUpdateModal_CreateGroups$1 = "Create Groups";
var bulkUpdateModal_CreateGroupsSuccess$1 = "We will send you an email once the groups have been created and are visible.";
var bulkUpdateModal_CreateRoles$1 = "Create Plans";
var bulkUpdateModal_DownloadTemplate$1 = "Download Template";
var bulkUpdateModal_DuplicateRow$1 = "1 row has duplicate roles";
var bulkUpdateModal_DuplicateRowPluralFormat$1 = "{{count}} rows have duplicate roles";
var bulkUpdateModal_EmptyContentType$1 = "1 row needs the type of content specified";
var bulkUpdateModal_EmptyContentTypePluralFormat$1 = "{{count}} rows need the type of content specified";
var bulkUpdateModal_EmptyUpdateType$1 = "1 row needs the type of update specified";
var bulkUpdateModal_EmptyUpdateTypePluralFormat$1 = "{{count}} rows need the type of update specified";
var bulkUpdateModal_ExcelImported$1 = "Excel Sheet Imported";
var bulkUpdateModal_FileIsEmpty$1 = "File appears to be empty. Please resubmit.";
var bulkUpdateModal_FileName$1 = "File Name";
var bulkUpdateModal_FirstRow$1 = "First Row";
var bulkUpdateModal_HeadingGroups$1 = "Create Multiple Groups";
var bulkUpdateModal_HeadingRolePlans$1 = "Create Multiple Plans";
var bulkUpdateModal_MaximumRowWidthExceeded$1 = "1 row has exceeded the maximum width";
var bulkUpdateModal_MaximumRowWidthExceededPluralFormat$1 = "{{count}} rows have exceeded the maximum width";
var bulkUpdateModal_MissingRequiredColumn$1 = "1 row is missing required columns";
var bulkUpdateModal_MissingRequiredColumnPluralFormat$1 = "{{count}} rows are missing required columns";
var bulkUpdateModal_NotAppearRightAway$1 = "These plans might not appear right away.";
var bulkUpdateModal_RowsAccepted$1 = "Successful Rows";
var bulkUpdateModal_RowsFound$1 = "Rows Found";
var bulkUpdateModal_RowsWithErrors$1 = "Failed Rows";
var bulkUpdateModal_Save$1 = "Save";
var bulkUpdateModal_SelectAFile$1 = "Select a file (xls,xlsx) up to (2MB) in size";
var bulkUpdateModal_SuccessfulUpload$1 = "Your file has been uploaded successfully.";
var bulkUpdateModal_TotalRows$1 = "Total Rows";
var bulkUpdateModal_UnknownContentType$1 = "1 row has an unknown type of content";
var bulkUpdateModal_UnknownContentTypePluralFormat$1 = "{{count}} rows have an unknown type of content";
var bulkUpdateModal_UnknownDataType$1 = "1 row has an unknown type of update";
var bulkUpdateModal_UnknownDataTypePluralFormat$1 = "{{count}} rows have an unknown type of update";
var bulkUpdateModal_UnsupportedFileContentType$1 = "1 row has content files that are not supported";
var bulkUpdateModal_UnsupportedFileContentTypePluralFormat$1 = "{{count}} rows have content files that are not supported";
var bulkUpdateModal_UploadAFile$1 = "Upload A File";
var bulkUpdateModal_WillSendEmail$1 = "The file you uploaded is being processed. Changes based on this file may take up to 4 hours to appear in Degreed.";
var BreadcrumbSvc_DownloadableReports$1 = "Downloadable Reports";
var BreadcrumbSvc_Enrolled$1 = "Enrolled";
var BreadcrumbSvc_Insights$1 = "Insights";
var BreadcrumbSvc_LessonFormat$1 = "Lesson {{lesson}}";
var BreadcrumbSvc_SectionFormat$1 = "Section {{section}}";
var BooksSvc_ErrorMatchingBooks$1 = "Sorry! There was a problem retrieving matching books.";
var BookFormCtrl_AddBook$1 = "Add Book";
var BookFormCtrl_AddCategory$1 = "Please add at least one category.";
var BookFormCtrl_BookCoverAltFormat$1 = "{{title}} book cover";
var BookFormCtrl_BookLength$1 = "Book length must be a valid number.";
var BookFormCtrl_BookSearchError$1 = "This title can’t be retrieved at this time.";
var BookFormCtrl_BookTitle$1 = "Book Title";
var BookFormCtrl_DatePublished$1 = "Date Published";
var BookFormCtrl_DateRead$1 = "Date Read";
var BookFormCtrl_EditBook$1 = "Edit Book";
var BookFormCtrl_IWroteThis$1 = "I wrote this book";
var BookFormCtrl_Length$1 = "Length";
var BookFormCtrl_Pages$1 = "Pages";
var BookFormCtrl_SaveBook$1 = "Save Book";
var BookFormCtrl_SelectBook$1 = "Please select a book from the list.";
var BookFormCtrl_Title$1 = "Title";
var BookFormCtrl_WhatDidYouLearnLong$1 = "What did you learn from this book?";
var BookFormCtrl_WhatDidYouLearnShort$1 = "What did you learn?";
var behaviorModal_Heading1$1 = "How your application will be reviewed by others.";
var behaviorModal_Heading2$1 = "Adding links and uploading files.";
var behaviorModal_Heading3$1 = "Avoid personal and proprietary information.";
var behaviorModal_Instructions$1 = "Instructions";
var behaviorModal_Instructions1$1 = "Choose skill behaviors that show the depth and range of your skill level. Make your evidence detailed enough that a reviewer could understand your contribution level, your methodology, the challenges faced, and the outcomes achieved.";
var behaviorModal_Instructions2$1 = "When you are reviewed by peers, they will compare your application to another application in {{credName}} and determine which they believe “demonstrated more expertise.”";
var behaviorModal_Instructions3$1 = "When you are reviewed by the expertise panel, they will evaluate your application against a rubric that measures expertise based on characteristics such as autonomy, adaptability, and critical thinking.";
var behaviorModal_Instructions4$1 = "When you are reviewed by your endorsers, they will be asked to confirm that your skill behaviors and evidence are accurate and consistent with their experience working with you.";
var behaviorModal_Instructions5$1 = "Adding links or uploading files is a good way to demonstrate your skill but is not required. Make sure links are accessible and do not require a password to access.";
var behaviorModal_Instructions6$1 = "The certification process is designed to be anonymous. This helps prevent bias. Avoid information that would reveal identity, race, color, religion or creed, national origin or ancestry, sex, age, disability status, genetic information, veteran status, or citizenship.";
var behaviorModal_Instructions7$1 = "Information submitted must NOT infringe copyright and must NOT be confidential or proprietary. Generalize or remove details where necessary.";
var behaviorModal_Instructions8$1 = 'If you have any questions, please email <a href="mailto:info@degreed.com" class="par link">info@degreed.com</a>';
var behaviorModalVM_Instructions$1 = "Instructions";
var behaviorForm_AddEvidence$1 = "Support your example with a link or file.";
var behaviorForm_AppliedForFormat$1 = "Applied for {{credentialName}}";
var behaviorForm_B1Credential$1 = "Social Media Marketing";
var behaviorForm_B1Evidence$1 = "Embrace the Space Campaign Image";
var behaviorForm_B1Example$1 = "A running shoe brand had a very specific benefit to their product - we wanted to create and launch a campaign on social channels (Facebook, Twitter, and Instagram specifically) that clearly showed that benefit, attracted fans, and increased sales. I worked with the brand designers and copywriter to create the #EmbraceTheSpace campaign. The purpose was to draw attention to the shoe's foot-shaped toebox feature, and encourage people to ’embrace the space’ of their sport (trailrunning, outdoor hiking, road running, etc). I used organic reach, our ambassador team, and paid ads to spread this campaign. Because we understood our fan base, the messaging really connected with our community and the campaign grew quickly, with people submitting their own pictures using the hashtag #EmbraceTheSpace. The tagline became the calling card for people to join our community and try the shoes. I was responsible for all social content and promotion of the campaign online.<br><br>We quickly saw the success of the campaign and implemented it in our tradeshow events, print advertisements, and email campaigns. Sales from the ads using this messaging resulted in a positive ROI. Embrace the Space is still used today as a tagline - the hashtag has over 29,000 posts on Instagram alone - filled with pictures of runners who are embracing the space.";
var behaviorForm_B1Process$1 = "I feel that any good campaign has a combination of factors that create success when combined with a solid distribution plan. For us this campaign was; shareable, highly relatable to our fan base, easy to understand, and very easy to contribute to with your own content. It was something that was both very authentic to our brand and fans, and easy for people not yet familiar with us to be intrigued by. Because of this, I knew we’d be successful using the messaging with ads to increase shoe sales. General process included launching the campaign using our ambassador team to have a base level group of people who were sharing the image and messaging to kickstart the momentum. We followed that organic launch with highly targeted promotions of content and ads that increased direct sales. Once the campaign had momentum and content being contributed to the hashtag we kept the machine running by sharing the best of the community contributed images. Rinse and repeat, it’s still highly successful messaging for the brand.";
var behaviorForm_B1Title$1 = "I can create product launches and ad campaigns on multiple social channels that translate to direct sales and positive ROI";
var behaviorForm_B2Credential$1 = "Business Management";
var behaviorForm_B2Example$1 = "I managed an annual department budget of over $1 million (USD). The budget consisted of labor and overhead costs of 9 employees, travel and training expenses, internal IT costs, and contracts with external software vendors.<br><br>I was tasked with creating a budget at the beginning of the year, including projected growth. Over the course of several weeks, the budget was adjusted with guidance from the Finance department and executive leadership.<br><br>Each month, the Finance department provided updates on how actual costs were tracking to the budget. I had the duty to adjust spending or request updates to the budget for the remainder of the year.<br><br>As is true in all aspects of business, there were always unforeseen events during the year that required hard spending decisions. For example, due to new business needs I had to determine if we could hire a new team member to take on additional work. Through cutting some spending on travel and software as well as getting commitment from the executive team to add more money to the budget, I was able to open a new position mid-year.";
var behaviorForm_B2Process$1 = "Creating a budget is both an art and a science. It's hard to predict 12 months out. Managing a budget through the year is more of a science. It's easier to measure and adapt in the short term.<br><br>When creating a budget, I lean towards asking for slightly more than I think I'll need. For one, the first draft of a budget tends to get cut down by those higher in the org chart and those in charge of overall budgeting in the Finance department. It's quite rare for Finance to come back and tell you to spend more! I felt that as long as I justified what I was asking for, we could have a conversation and negotiate the final version.<br><br>During the year, I tried to underspend unless I was causing the department to miss out on measurable business value. It's easy to just say yes to each request for new software, a trip to a conference and so on. However, I found I got higher value and more thought out requests from the team when I pushed back. By being frugal, we had some slack in the budget for high value, and unforeseen, needs as the year went on.";
var behaviorForm_B2Title$1 = "I can create and manage a budget";
var behaviorForm_B3Credential$1 = "Python";
var behaviorForm_B3Evidence$1 = "DataFrame to matrix vectorizer class and tests";
var behaviorForm_B3Example$1 = "Frequently in my data science workflow, I need to go from a flattened data set in a dataframe (row name, column name, value) to a matrix structured according to row and column names and containing only values in order to use the sklearn library. To make this operation easier, I created a module to perform this pivot and transform, which is attached as evidence.<br><br>The general structure of the module follows the sklearn pattern of defining a transformer object and then using methods of this object to fit the required parameters and transform whatever data is passed to it. This pattern feels familiar to users and fits into sklearn data processing pipelines. It also is easy to store information like normalization factors during the fitting process that can later be used to transform new data without refitting.<br><br>One of the major motivations for this transformer was to make it easy to associate a row name or column name with the matrix indices. &nbsp;In order to facilitate this, instead of just returning the matrix, I defined a custom data structure that has row and column information as attributes and defined a method to extract the information that I needed.<br><br>I've included unit tests at the bottom of the module that will execute if I run the module in the command line. &nbsp;This helps my code stay robust as I make changes / edits and reminds me of what behavior I expected if I return to the function after not using it for a while. &nbsp;Incorporating the unit tests in the same file as the code makes it more modular, especially for single modules that I am not ready to structure into a package.";
var behaviorForm_B3Process$1 = "In general when creating modules, I think about:<br><br>\n1. The level of development needed for this specific instance - is this something I'm going to share widely or is it something that only I will use. This determines how much documentation / encoding of tests & examples I will do. Often this starts out very basic and evolves over time if a function is used frequently.<br><br>\n2. How best to break up complex operations into data structures, methods, and transformer/model objects.  This includes deciding if a process is better encoded as a function or an class method and  designing objects so that I can easily use external libraries.<br><br>\n3. Naming functions, classes and methods so that the process is easy to follow.<br><br>\n4. Making it easy to get information that I need for error checking. Examples of this include adding different levels of verbosity during runtime and defining methods specifically to extract information.<br><br>\n5. Following established patterns, and making it easy to leverage other packages, for example:<br><br>\n&nbsp;&nbsp;&nbsp;a. When I encode models or transformers, following the sklearn pattern of creating a transformer that can be fit using a specific data set because it is easy to swap out training and test data sets and because it works well in data processing pipelines.<br><br>\n&nbsp;&nbsp;&nbsp;b. For class methods that modify the object, I prefer to return the object itself so that operations can be chained together - this is a pattern seen in both pandas and in sklearn.<br><br>\n&nbsp;&nbsp;&nbsp;c. Making sure that the basic attributes of a class are stored in the right data structure to be easily passed to sklearn/pandas if it is part of the workflow.<br><br>\n6. Writing doc strings using a format that can be processed using tools like Sphinx to generate useful documentation.<br><br>";
var behaviorForm_B3Title$1 = "I can create custom python modules, incorporating the high level conceptualization of object structures and workflows, and ensuring basic error checking using unit tests";
var behaviorForm_behaviorInstruction$1 = "<p>For each skill behavior, please provide a detailed example of a time that you used the skill behavior. Explain what you did, who was involved, the challenges faced, and the results achieved.</p>\n<p>Additionally, please explain the way you approach this skill behavior, with emphasis on why you do it that way. This is your chance to highlight your knowledge of the skill by explaining relevant theories, principles, and methods.</p>";
var behaviorForm_behaviorsInstruction$1 = '<p>To represent your skill, please provide three examples of ways that you apply your skill. We call these skill behaviors. Skill behaviors should start with "I can&hellip;", for example, "I can manage a budget." You should select skill behaviors for which you can:</p>\n<ul class="bullets">\n    <li>Give a detailed example of a time you did this</li>\n    <li>Ask someone who worked with you to endorse you</li>\n    <li>Link or upload evidence, if possible</li>\n</ul>\n<p>Together your skill behaviors should describe the depth and breadth of your expertise in this skill.</p>\n<p>If you get stuck, consider how you would answer the question of someone who asked, "what do I need to know how to do to be good at this skill?"</p>';
var behaviorForm_BehaviorStatementsDemo$1 = '<div class="markdown">\n  <h2 class="h3 guts-p-b-1">Social Media Marketing</h2>\n  \n  <ol class="guts-p-b-1">\n    <li>I can build an online audience that passionately engages with a brand or company</li>\n    <li>I can drive and track revenue via social channels</li>\n    <li>I can run paid social media advertising campaigns</li>\n  </ol>\n  \n  <h2 class="h3 guts-p-b-1">Node.js</h2>\n  \n  <ol class="guts-p-b-1">\n    <li>I can write Node.js web applications and NPM packages</li>\n    <li>I can write Node.js articles and tutorials to teach others</li>\n    <li>I can speak about Node.js at meetups and conferences</li>\n  </ol>\n  \n  <h2 class="h3 guts-p-b-1">Public Speaking</h2>\n  \n  <ol class="guts-p-b-1">\n    <li>I can deliver highly engaging presentations</li>\n    <li>I can create visually compelling presentations to support my public speaking</li>\n    <li>I can read an audience and understand the power dynamics of a room</li>\n  </ol>\n  \n  <h2 class="h3 guts-p-b-1">CSS</h2>\n  \n  <ol class="guts-p-b-1">\n    <li>I can keep my CSS organized and well structured.</li>\n    <li>I can overcome specificity problems that are commonly associated with the difficolty of quality CSS</li>\n    <li>I can contribute to the open source community with CSS projects</li>\n  </ol>\n  \n  <h2 class="h3 guts-p-b-1">Drawing</h2>\n  \n  <ol class="guts-p-b-1">\n    <li>I can compose a still life and create an accurate and realistic depiction of it with graphite and/or charcoal</li>\n    <li>I can use and understand the roles of perspective in order to create more realistic drawings</li>\n    <li>I can draw from memory and imagination</li>\n  </ol>\n  \n  <h2 class="h3 guts-p-b-1">Customer Service</h2>\n  \n  <ol class="guts-p-b-1">\n    <li>I can show empathy to my clients concerns</li>\n    <li>I can answer my clients questions in a timely manner</li>\n    <li>I can provide creative solutions to address customer needs</li>\n  </ol>\n  \n  <h2 class="h3 guts-p-b-1">User Experience Design</h2>\n  \n  <ol class="guts-p-b-1">\n    <li>I can assess user needs through research</li>\n    <li>I can prototype conceptual designs to validate ideas</li>\n    <li>I can design solutions based on identified user needs </li>\n  </ol>\n\n</div>';
var behaviorForm_BehaviorStatementsDemoHeader$1 = "Example Skill Behavior Statements";
var behaviorForm_EditTitle$1 = "Edit title";
var behaviorForm_EvaluationCriteria$1 = '<p>You will be evaluated on your ability to demonstrate the following:</p>\n<ul class="bullets">\n    <li><strong>Knowledge:</strong> breadth and depth of technical and theoretical knowledge about this skill </li>\n    <li><strong>Application:</strong> breadth and depth of practical applications of this skill</li>\n    <li><strong>Planning and Evaluation:</strong> ability to identify problems, propose solutions, and evaluate success in this skill</li>\n    <li><strong>Responsibility and Autonomy:</strong> ability to work independently and take responsibility for results in this skill</li>\n    <li><strong>Teamwork:</strong> ability to work with or lead teams in this skill</li>\n    <li><strong>Teaching and Communication:</strong> ability to communicate with and teach others about this skill</li>\n</ul>';
var behaviorForm_EvaluationCriteriaHeader$1 = "Evaluation Criteria";
var behaviorForm_ExampleLabel$1 = "Describe a time you used this skill behavior.";
var behaviorForm_ExamplePlaceholder$1 = "Describe a time you did this in detail.";
var behaviorForm_Header1$1 = "Describe your first skill behavior";
var behaviorForm_Header2$1 = "Describe your second skill behavior";
var behaviorForm_Header3$1 = "Describe your third skill behavior";
var behaviorForm_ProcessLabel$1 = "Summarize your general process and why you do it that way.";
var behaviorForm_ProcessPlaceholder$1 = "Explain your approach when using this skill behavior.";
var behaviorForm_ProvideMoreInfo$1 = "Please provide more information";
var behaviorForm_ReadMore$1 = "Instructions";
var behaviorForm_ShowDemos$1 = "Show examples of skill behaviors";
var behaviorForm_ShowEvalCriteria$1 = "See the evaluation criteria";
var behaviorForm_TitleLabel$1 = "Briefly describe the skill behavior.";
var behaviorForm_TitleLabel1$1 = "What is your first skill behavior?";
var behaviorForm_TitleLabel2$1 = "What is your second skill behavior?";
var behaviorForm_TitleLabel3$1 = "What is your third skill behavior?";
var behaviorForm_TitlePlaceholder$1 = "I can...";
var behaviorForm_ValidationMessage$1 = "This field is required.";
var Banner_IE11Body$1 = "Degreed's support for Internet Explorer will soon expire. Prepare today by switching to a modern browser.";
var Banner_IE11Title$1 = "Time is Running Out!";
var Banner_LoggedOutCTA$1 = "Find, capture, and measure all your learning.";
var Banner_LoggedOutCTAButton$1 = "Learn More";
var BadgeFormCtrl_BadgeHelpText$1 = "Badges must be image files from a badge issuer.";
var BadgeFormCtrl_BadgeInfoText$1 = "Badge information is collected via the image. It cannot be edited.";
var BadgeFormCtrl_BadgeInvalidBadge$1 = "Invalid file source. Unrecognised badge issuer.";
var BadgeFormCtrl_BadgeUrl$1 = "Please enter a valid badge url.";
var AwardFormCtrl_AddAward$1 = "Add Award";
var AwardFormCtrl_AwardDate$1 = "A date is required.";
var AwardFormCtrl_AwardDateLabel$1 = "Award Date";
var AwardFormCtrl_AwardIssuer$1 = "An award issuer name is required.";
var AwardFormCtrl_AwardTitle$1 = "An award title is required.";
var AwardFormCtrl_AwardTitleLabel$1 = "Award Title";
var AwardFormCtrl_SaveAward$1 = "Save Award";
var Automation_AcademyConditions$1 = "Academy Conditions";
var Automation_AcademyConditions_Description$1 = "Define the audience by user association and status in an academy";
var Automation_AcademyName$1 = "Academy Name";
var Automation_AcademyStatus_Completed$1 = "Completed";
var Automation_AcademyStatus_Dropped$1 = "Dropped";
var Automation_AcademyStatus_InProgress$1 = "In Progress";
var Automation_AcademyStatus_NotStarted$1 = "Not Started";
var Automation_AcmAddUser_Format$1 = "Enable Academy Admin Access ({{count}})";
var Automation_AcmDeleteUser_Format$1 = "Disable ACM Access ({{count}})";
var Automation_AcmSelectRole$1 = "Select Role";
var Automation_Action$1 = "Action";
var Automation_Action_Delete$1 = "Action Removed";
var Automation_Action_Insert$1 = "Action Added";
var Automation_Action_Update$1 = "Action Updated";
var Automation_ActionDeleted$1 = "Action has been deleted.";
var Automation_ActionDesc$1 = "Actions are the outcomes of an automation.";
var Automation_ActionHasBeenAdded$1 = "An action has been added to this rule.";
var Automation_ActionHasNotBeenAdded$1 = "Please add at least one action to allow this rule to be enabled.";
var Automation_ActionLabel_Group$1 = "Group Name";
var Automation_ActionLabel_Pathway$1 = "Pathway Name";
var Automation_ActionLabel_PermissionRole$1 = "Role Name";
var Automation_ActionLabel_Privacy$1 = "Privacy Name";
var Automation_ActionLabel_Provider$1 = "Provider Name";
var Automation_ActionLabel_Skill$1 = "Skill Name";
var Automation_ActionLabel_Target$1 = "Plan Name";
var Automation_ActionNoConfigurationNeeded$1 = "This action needs no configuration.";
var Automation_Actions$1 = "Actions";
var Automation_AddAcademyCondition$1 = "Add Academy Condition";
var Automation_AddGroupCondition$1 = "Add Group Condition";
var Automation_AddProviderLicense_Format$1 = "Add Provider Visibility ({{count}})";
var Automation_AddRole_Format$1 = "Update Permission Role ({{count}})";
var Automation_AddSkill_Format$1 = "Add Skill ({{count}})";
var Automation_AddSkillCondition$1 = "Add Skill Condition";
var Automation_AddSkillPlan_Format$1 = "Add Plan ({{count}})";
var Automation_AddToGroup_Format$1 = "Add Group ({{count}})";
var Automation_AddToPathway_Format$1 = "Add Pathway ({{count}})";
var Automation_AreYouSure_DeleteAutomations_Format$1 = "Are you sure you want to permanently delete the following {{count}} Automations?";
var Automation_AssignedBy_Format$1 = "{{ content }} <strong>ASSIGNED BY</strong> {{ person }} <strong>DUE ON</strong> {{ date }}";
var Automation_AssignedByInDays_Format$1 = "{{ content }} <strong>ASSIGNED BY</strong> {{ person }} <strong>DUE IN</strong> {{ number }} days";
var Automation_AssignResource_Format$1 = "Assign ({{count}})";
var Automation_AttributeValue_HelperText$1 = "Type an attribute value and use the enter key to add any number of attribute values.";
var Automation_Automation$1 = "Automation";
var Automation_AutomationBuilder$1 = "Automation Builder";
var Automation_AutomationCreated$1 = "Automation Created";
var Automation_AutomationDetails$1 = "Automation Details";
var Automation_AutomationDisabled$1 = "Automation Disabled";
var Automation_AutomationEnabled$1 = "Automation Enabled";
var Automation_AutomationLastUpdated$1 = "Automation Last Updated";
var Automation_AutomationName$1 = "Automation Name";
var Automation_Automations$1 = "Automations";
var Automation_AutomationUpdated$1 = "Automation Updated";
var Automation_BulkEnable_SomeRulesInvalidWarning$1 = "One or more selected rules do not meet minimum requirements to enable and will remain disabled.";
var Automation_CadenceDailyTime_Format$1 = "Daily (Weekdays) <strong>AT</strong> {{ time }} (UTC)";
var Automation_CadenceDateTime_Format$1 = "{{ cadence }} <strong>ON</strong> {{ date }} <strong>AT</strong> {{ time }} (UTC)";
var Automation_CadenceDayOfTime_Format$1 = "{{ cadence }} <strong>ON</strong> the {{ date }} <strong>AT</strong> {{ time }} (UTC)";
var Automation_CadenceOnceTime_Format$1 = "Automation_CadenceOnceTime_Format";
var Automation_CannotEnableAtThisTime$1 = "A minimum of one trigger and one action is required to enable the Automation.";
var Automation_ChangeDetails$1 = "Change Details";
var Automation_ChangedTo$1 = "was changed to";
var Automation_Changes$1 = "Changes";
var Automation_Changes_Format$1 = "";
var Automation_CloneAutomation$1 = "Clone Automation";
var Automation_CloneAutomationFormat$1 = "Are you sure you want to clone {{name}}?  The clone will open in draft status for editing.";
var Automation_Communication$1 = "Communication";
var Automation_ConditionHelp$1 = "Conditions narrow the scope of an automation.  You are limited to 20 conditions.";
var Automation_ConditionsLimit$1 = "You are limited to 5 conditions.";
var Automation_CreateAnAutomation$1 = "Create an Automation";
var Automation_CreateYourFirst_Description$1 = "Any automations that are created in your organization will show here.";
var Automation_CreateYourFirst_Header$1 = "Create your first automation";
var Automation_CurrentlyEditingTitleAndDescription$1 = "Currently editing title and description";
var Automation_CurrentlyEditingTriggers$1 = "Currently editing triggers";
var Automation_DateUpdated$1 = "Date Updated";
var Automation_DeleteAction$1 = "Delete Action";
var Automation_DeleteActionConfirmation$1 = "Are you sure you want to delete this action?";
var Automation_DeleteAutomation$1 = "Delete Automation";
var Automation_DeleteAutomations$1 = "Delete Automations";
var Automation_DeleteConditions$1 = "Delete Conditions";
var Automation_DeleteConditions_Confirmation$1 = "Are you sure you want to permanently delete all conditions?";
var Automation_DeleteOnlyActionConfirmation$1 = "An automation requires at least one trigger and one action to be enabled. Deleting all actions will disable the automation. Are you sure you want to delete this action?";
var Automation_DeleteUser_Format$1 = "Delete User ({{count}})";
var Automation_Description$1 = "Description (Optional)";
var Automation_Description_Delete$1 = "Description Removed";
var Automation_Description_Insert$1 = "Description Added";
var Automation_Description_Update$1 = "Description Updated";
var Automation_DisableAutomations$1 = "Disable Automations";
var Automation_DisableAutomations_Format$1 = "Are you sure you want to disable the following {{count}} Automations?";
var Automation_DueDate_None$1 = "None";
var Automation_DueDate_Relative$1 = "Due In (Number of Days)";
var Automation_DueDate_Specific$1 = "Due On (Fixed Date)";
var Automation_EditableAttributeWarning$1 = "Users are able to change this attribute in the Degreed application.  Automations will run based on the last updated value.";
var Automation_EditableAttributeWarning_Format$1 = "{{attribute}} values can be changed by users and administrators from various sources. Automations use the most recent value.";
var Automation_EditAutomation$1 = "Edit Automation";
var Automation_EditTitleAndDescription$1 = "Edit title and description";
var Automation_EditTrigger$1 = "Edit trigger";
var Automation_EnableAutomation$1 = "Enable Automation";
var Automation_EnableAutomationDescription$1 = "When an automation is enabled, it will run whenever conditions are met. Disable the automation at any time to pause the rule.";
var Automation_EnableAutomations$1 = "Enable Automations";
var Automation_EnableAutomations_Format$1 = "Are you sure you want to enable the following {{count}} Automations?";
var Automation_EnabledOrDisabled$1 = "Enabled/Disabled";
var Automation_Event_ContentCompleted$1 = "User Completes Content";
var Automation_Event_GroupJoined$1 = "User Joins Group";
var Automation_Event_MentorshipCompleted$1 = "User Completes Mentorship";
var Automation_Event_OnboardingCompleted$1 = "User Completes Onboarding";
var Automation_Event_OpportunityMentorRequested$1 = "User Requests Mentor";
var Automation_Event_PathwayCompleted$1 = "User Completes Pathway";
var Automation_Event_PathwayEnrolled$1 = "User Follows Pathway";
var Automation_Event_PlanFollowed$1 = "User Follows Plan";
var Automation_Event_ProviderLicenseAssign$1 = "New Provider License Assigned";
var Automation_Event_UserAddsSkill$1 = "User Adds Skill";
var Automation_Event_UserUpdatestoFocusSkill$1 = "User Updates to Focus Skill";
var Automation_FormerUser$1 = "Former User";
var Automation_GroupConditions$1 = "Group Conditions";
var Automation_GroupNameHelper$1 = "Type to search for and select any number of groups.";
var Automation_HistoryAvailableNotification$1 = "Automation history is only available for the last 60 days.";
var Automation_HistoryLastUpdated$1 = "History Last Updated";
var Automation_IsNotOneOf$1 = "Is not one of";
var Automation_IsOneOf$1 = "Is one of";
var Automation_Log_Detail_Entry_Format$1 = "{{ entityActionHtml }} {{ typeOldHtml }} {{ oldValue }} {{ changedToHtml }} {{ typeNewHtml }} {{ newValue }}";
var Automation_LogTable_Summary$1 = "This table displays the automation history log for the past 60 days. Each row includes three columns that display the date, the number of changes made on that date, and the user who made the changes. Additionally, a drop down control allows you to expand the row to show specific details about each change made and the time it was made.";
var Automation_Name_Delete$1 = "Name Removed";
var Automation_Name_Insert$1 = "Name Added";
var Automation_Name_Update$1 = "Name Updated";
var Automation_NameAndDescription$1 = "Name and Description";
var Automation_NewAutomation$1 = "New Automation";
var Automation_NoDescription$1 = "No Description";
var Automation_NotificationSubject$1 = "Subject";
var Automation_NotifyUser_Format$1 = "Send Notification ({{count}})";
var Automation_NoWarning$1 = "No Warning";
var Automation_Or_List_Format$1 = "{{ commaList }} <strong>OR</strong> {{ lastItem }}";
var Automation_Outcome_Delete$1 = "Action Removed";
var Automation_Outcome_Insert$1 = "Action Added";
var Automation_Outcome_Update$1 = "Action Updated";
var Automation_Predicate_Delete$1 = "Condition Removed";
var Automation_Predicate_Insert$1 = "Condition Added";
var Automation_Predicate_Update$1 = "Condition Updated";
var Automation_PredicateLabel_ContentCompleted$1 = "Content Title";
var Automation_PredicateLabel_GroupJoined$1 = "Group Name";
var Automation_PredicateLabel_MentorshipCompleted$1 = "Mentorship Title";
var Automation_PredicateLabel_PathwayCompleted$1 = "Pathway Name";
var Automation_PredicateLabel_PathwayEnrolled$1 = "Pathway Name";
var Automation_PredicateLabel_PlanFollowed$1 = "Plan Title";
var Automation_PredicateLabel_ProviderLicenseAssign$1 = "Provider Name";
var Automation_PredicateLabel_UserAddsSkill$1 = "Skill Name";
var Automation_PredicateLabel_UserUpdatestoFocusSkill$1 = "Skill Name";
var Automation_PredicateType_Academy$1 = "Academy";
var Automation_PredicateType_Attribute$1 = "User";
var Automation_PredicateType_Description_Academy$1 = "Define the audience by user association and status in an academy";
var Automation_PredicateType_Description_Attribute$1 = "Define the audience with specific user attributes";
var Automation_PredicateType_Description_Group$1 = "Define the audience with Groups";
var Automation_PredicateType_Description_Skill$1 = "Define the audience with user skill attributes such as skills, focus skills, and skill ratings";
var Automation_PredicateType_Group$1 = "Group";
var Automation_PredicateType_Skill$1 = "Skill";
var Automation_RemoveCondition_Format$1 = "Remove condition with values {{value}}";
var Automation_RemoveEmptyCondition$1 = "Remove Empty Condition";
var Automation_SaveOrCancelFirst$1 = "Save or cancel this dialog to continue.";
var Automation_Schedule_Cadence$1 = "Cadence";
var Automation_Schedule_Daily$1 = "Daily (Week Days)";
var Automation_Schedule_Daily_Format$1 = "Run Daily (Week Days) at {{time}} (UTC)";
var Automation_Schedule_Date$1 = "Date";
var Automation_Schedule_Day$1 = "Day";
var Automation_Schedule_Last$1 = "Last";
var Automation_Schedule_LastDayOfMonth$1 = "Last Day of the Month";
var Automation_Schedule_Monthly$1 = "Monthly";
var Automation_Schedule_Monthly_Format$1 = "Run Monthly on the {{dayOfMonth}} day at {{time}} (UTC)";
var Automation_Schedule_Once$1 = "Once";
var Automation_Schedule_Once_Format$1 = "Run Once on {{specificDate}} at {{time}} (UTC)";
var Automation_Schedule_Ordinal_1$1 = "1st";
var Automation_Schedule_Ordinal_10$1 = "10th";
var Automation_Schedule_Ordinal_15$1 = "15th";
var Automation_Schedule_Ordinal_20$1 = "20th";
var Automation_Schedule_Ordinal_25$1 = "25th";
var Automation_Schedule_Ordinal_5$1 = "5th";
var Automation_Schedule_SelectCadence$1 = "Select a cadence";
var Automation_Schedule_SelectDate$1 = "Pick or enter a date";
var Automation_Schedule_SelectDay$1 = "Select a day";
var Automation_Schedule_SelectTime$1 = "Select a time";
var Automation_Schedule_TimeUTC$1 = "Time (UTC)";
var Automation_Schedule_Weekly$1 = "Weekly";
var Automation_Schedule_Weekly_Format$1 = "Run Weekly on {{dayOfWeek}} at {{time}} (UTC)";
var Automation_Search_Placeholder$1 = "Search for Rule Name, Attribute Name, Attribute Value, Description or Action Value";
var Automation_SearchAcademy$1 = "Search for Academy";
var Automation_SelectAction$1 = "Select an Action";
var Automation_SelectConditionType$1 = "Select a Condition Type";
var Automation_SelectConditionType_Description$1 = "Conditions narrow the scope of an automation. Choose a condition type below to define the automation audience.";
var Automation_SelectSkillCondition$1 = "Select skill condition";
var Automation_SelectStatuses$1 = "Select statuses";
var Automation_SelectTrigger$1 = "Select a Trigger";
var Automation_SendEmail_Format$1 = "Send Email ({{count}})";
var Automation_SetProfilePrivacy_Format$1 = "Set Profile Privacy ({{count}})";
var Automation_SharedBy_Format$1 = "{{ content }} <strong>SHARED BY</strong> {{ person }}";
var Automation_ShareResource_Format$1 = "Share ({{count}})";
var Automation_SkillCondition$1 = "Skill Condition";
var Automation_SkillCondition_AddOptionalSkills$1 = "Add Skill(s) (optional)";
var Automation_SkillConditions$1 = "Skill Conditions";
var Automation_SkillConditions_Description$1 = "Define the audience with user skill attributes such as ratings and added skills";
var Automation_SkillName$1 = "Skill Name";
var Automation_SkillNameHelper$1 = "Type to search for and select any number of specific skills";
var Automation_SkillOperator_hasnofocusskills$1 = "User has not added a focus skill";
var Automation_SkillOperator_hasnoskillrating$1 = "User has not added a skill rating";
var Automation_SkillOperator_hasnoskills$1 = "User has not added a skill";
var Automation_SkillOperator_hasnoskillsrating$1 = "User has not added a skill rating";
var Automation_SkillTimeFrame$1 = "Time Frame";
var Automation_SkillTimeFrame_AllTime$1 = "All Time";
var Automation_SkillTimeFrame_WithinDays$1 = "Within the Last (Number of Days)";
var Automation_Status_Update$1 = "Status Updated";
var Automation_Then$1 = "Then";
var Automation_TimeUpdated$1 = "Time Updated";
var Automation_Trigger$1 = "Trigger";
var Automation_Trigger_Delete$1 = "Trigger Removed";
var Automation_Trigger_Insert$1 = "Trigger Added";
var Automation_Trigger_Scheduled$1 = "Schedule";
var Automation_Trigger_Update$1 = "Trigger Updated";
var Automation_Trigger_UserCreated$1 = "User Is Created";
var Automation_Trigger_UserRecordReceived$1 = "User Record Received";
var Automation_TriggerHasBeenAdded$1 = "A trigger has been added to this rule.";
var Automation_TriggerHasNotBeenAdded$1 = "Please add a trigger to allow this rule to be enabled.";
var Automation_TriggerHelp$1 = "A trigger is the event that initiates an automation.";
var Automation_TriggerNoConfigurationNeeded$1 = "This trigger needs no configuration.";
var Automation_TriggersAndActionsRequired$1 = "One trigger and at least one action must be added in order to enable the rule.";
var Automation_UntitledAutomation$1 = "Untitled Automation";
var Automation_UpdatedBy$1 = "Updated By";
var Automation_UserAcademyStatus$1 = "User Academy Status";
var Automation_UserAcademyStatus_Helper$1 = "Select any number of academy statuses.";
var Automation_UserActivity$1 = "User Activity";
var Automation_UserAssignmentDescription$1 = 'If no selection is made, the assignment will come from "Admin."';
var Automation_UserAttribute$1 = "User Attribute";
var Automation_UserConditions$1 = "User Condition (Optional)";
var Automation_UserConditions_Header$1 = "User Conditions";
var Automation_UserEvents$1 = "User Events";
var Automation_UserManagement$1 = "User Management";
var Automation_UserMeetsConditions$1 = "User Meets Conditions";
var Automation_UserMeetsConditions_Academy$1 = "User Meets Academy Conditions";
var Automation_UserMeetsConditions_Attribute$1 = "User Meets User Conditions";
var Automation_UserMeetsConditions_Group$1 = "User Belongs to Group";
var Automation_UserMeetsConditions_Skill$1 = "User Meets Skill Conditions";
var Automation_UserNotificationDescription$1 = "Sends in-app notifications to learners in Degreed, and sends the notifications to Microsoft Teams, if enabled.";
var Automation_UserShareDescription$1 = 'If no selection is made, the share will come from "Admin."';
var Automation_ViewHistory$1 = "View History";
var Automation_Warning$1 = "Warning";
var Automation_Warning_RequiredBeforeSaving$1 = "Fill out all required fields before saving.";
var Automation_When$1 = "When";
var Attributes_AddHiddenAttributes$1 = "Add Hidden Attributes";
var Attributes_Attribute$1 = "Attribute";
var Attributes_AttributeDataType$1 = "Data Type";
var Attributes_AttributeFeatureName$1 = "Feature Visibility";
var Attributes_AttributeFilterLabel$1 = "Attribute Filter";
var Attributes_AttributeFilterModal_AddButton$1 = "Add Attribute";
var Attributes_AttributeFilterModal_AttributeFieldLabel$1 = "Attribute";
var Attributes_AttributeFilterModal_AttributeFieldPlaceHolder$1 = "Select a custom attribute";
var Attributes_AttributeFilterModal_OperatorFieldLabel$1 = "Operator";
var Attributes_AttributeFilterModal_OperatorFieldPlaceHolder$1 = "Select an operator";
var Attributes_AttributeFilterModal_Title$1 = "Attribute Filter";
var Attributes_AttributeFilterModal_ValuesFieldHint$1 = "Enter up to 10 values";
var Attributes_AttributeFilterModal_ValuesFieldLabel$1 = "Values";
var Attributes_AttributesDescription$1 = "Standard attributes are the basic user attributes available in Degreed. Custom attributes are any additional user attributes your organization sends to Degreed through the User file or the API. The Incoming Field column indicates which custom attributes are mapped to the standard attributes in the Attribute column. If the Incoming Field name differs from the Attribute name, the Attribute name is shown in Admin features.";
var Attributes_AttributesHeading$1 = "Standard and Custom Attributes";
var Attributes_AttributesLabel$1 = "Attributes";
var Attributes_AttributeSource$1 = "Standard/Custom";
var Attributes_Bool$1 = "Boolean";
var Attributes_BusinessRules$1 = "Automations";
var Attributes_Custom$1 = "Custom";
var Attributes_CustomAttributes$1 = "Custom Attributes";
var Attributes_CustomAttributesDescription$1 = "Custom attributes are additional fields that your org sends to Degreed (from files or API). Attributes that are Visible will be shown in Admin features. Attributes that are Hidden will be kept private and not shown in any features.";
var Attributes_CustomData$1 = "Custom Data";
var Attributes_DataType$1 = "Data Type";
var Attributes_DataTypes_Description$1 = "Select the data type for this attribute. This ensures any operations are performed as expected.";
var Attributes_DateTime$1 = "Datetime";
var Attributes_DateTimeOLD$1 = "Date";
var Attributes_DefaultVisibility$1 = "Default Visibility";
var Attributes_DefaultVisibilityDescription$1 = "Automatically turn on new custom attributes that are sent to Degreed for use in Business Rules, Segments, Reporting, and Engage.";
var Attributes_EditAttributeSettings$1 = "Edit Attribute Settings";
var Attributes_Feature_BusinessRules$1 = "Automations";
var Attributes_Feature_Segments$1 = "Segments";
var Attributes_FeatureVisibility$1 = "Feature Visibility";
var Attributes_FeatureVisibility_Description$1 = "Choose where you would like this attribute to be available for use.";
var Attributes_FieldType_Datetime$1 = "Datetime";
var Attributes_FieldType_Number$1 = "Number";
var Attributes_FieldType_String$1 = "String";
var Attributes_IncomingField$1 = "Incoming Field";
var Attributes_IncomingFields$1 = "Incoming Fields";
var Attributes_Instructions$1 = "This page is for viewing and managing user attributes in Degreed. These attributes are available to use in Admin features, such as Business Rules, Segments, Reporting, and Engage.";
var Attributes_NoMatches$1 = "No attributes match the current search term, please try again with a different search.";
var Attributes_NoResults$1 = "All attributes are currently visible.";
var Attributes_NoVisibleAttributes$1 = "There are no visible custom attributes";
var Attributes_NoVisibleAttributesInstructions$1 = "Click the Add Hidden Attributes dropdown to turn on attributes.";
var Attributes_Number$1 = "Number";
var Attributes_NumberOLD$1 = "Integer";
var Attributes_RemoveAttributeFormat$1 = "Remove Attribute: {{ attributeName }}";
var Attributes_Segments$1 = "Segments";
var Attributes_Standard$1 = "Standard";
var Attributes_StandardAttributes$1 = "Standard Attributes";
var Attributes_StandardAttributesInstructions$1 = "Standard attributes are the basic attributes available in Degreed. The table below shows how your organization maps its attribute data (from files or API) to the Degreed standard attributes. If the Incoming Field has a different name than the Standard Attribute that it’s mapped to, then the Standard attribute name will be the one that is shown in Admin features.";
var Attributes_StandardCustom$1 = "Standard/Custom";
var Attributes_String$1 = "String";
var Attributes_StringOLD$1 = "String";
var Attributes_UserAttributes$1 = "User Attributes";
var Attributes_UserAttributesDescription$1 = "View and manage user attributes for use in Admin features such as Automations and Segments";
var Attributes_VisibleAttributes$1 = "Visible Attributes";
var Attributes_VisibleAttributesDescription$1 = "These are attributes that are currently visible in Admin features.";
var Attributes_Warning_ConversionResultsInDataLoss_Format$1 = "There are {{count}} users with attribute values that don’t match the data type you’ve selected. This may affect how operations are performed. Please check your user file or API for any values that don’t match the selected data type for this attribute.";
var Attributes_Warning_InvalidConversionToBoolean$1 = "Changing a data type from Boolean to DateTime, or DateTime to Boolean is not recommended. If an existing value does not match the new data type, the value for that user will be blank in reports and a business rule or segment that uses the attribute will not apply to that user.";
var Attributes_Warning_InvalidConversionToDateTime$1 = "Changing a data type from DateTime to Number, or Number to DateTime is not recommended. If an existing value does not match the new data type, the value for that user will be blank in reports and a business rule or segment that uses the attribute will not apply to that user";
var Attributes_Warning_InvalidConversionToNumber$1 = "Changing a data type from DateTime to Number, or Number to DateTime is not recommended. If an existing value does not match the new data type, the value for that user will be blank in reports and a business rule or segment that uses the attribute will not apply to that user";
var Attributes_Warning_TypeMismatch_Format$1 = "There are {{count}} users with attribute values that don’t match the data type you’ve selected. This may affect how operations are performed. Please check your user file or API for any values that don’t match the selected data type for this attribute.";
var assignedLearning_AlreadyAttendAssignedByFormat$1 = "{{nameHtml}} assigned {{groupNameHtml}} to attend this {{hasDateHtml}}by {{date}}{{hasDateEndHtml}}, but you've already completed it. Great job, overachiever.";
var assignedLearning_AlreadyCompletedAssignedByFormat$1 = "{{nameHtml}} assigned {{groupNameHtml}} to complete this {{hasDateHtml}}by {{date}}{{hasDateEndHtml}}, but you've already completed it. Great job, overachiever.”";
var assignedLearning_AlreadyFollowAssignedByFormat$1 = "{{nameHtml}} assigned {{groupNameHtml}} to follow this {{hasDateHtml}}by {{date}}{{hasDateEndHtml}}, but you've already completed it. Great job, overachiever.";
var assignedLearning_AlreadyReadAssignedByFormat$1 = "{{nameHtml}} assigned {{groupNameHtml}} to read this {{hasDateHtml}}by {{date}}{{hasDateEndHtml}}, but you've already completed it. Great job, overachiever.";
var assignedLearning_AlreadyWatchedAssignedByFormat$1 = "{{nameHtml}} assigned {{groupNameHtml}} to watch this {{hasDateHtml}}by {{date}}{{hasDateEndHtml}}, but you've already completed it. Great job, overachiever.";
var assignedLearning_Completed$1 = "You completed this assignment on {{completedDate}}";
var assignedLearning_CompletedNoDate$1 = "You completed this assignment";
var assignedLearning_DueLater$1 = "{{nameHtml}} assigned this to you to complete by {{date}}";
var assignedLearning_DueLaterExternal$1 = "You have been assigned this to complete by {{date}}";
var assignedLearning_DueLaterGroup$1 = "{{nameHtml}} assigned this to your {{groupNameHtml}} to complete by {{date}}";
var assignedLearning_DueSoon$1 = "You have been assigned this to complete in {{days}} days";
var assignedLearning_GroupAlreadyAttendedFormat$1 = "{{nameHtml}} assigned {{groupNameHtml}} to attend this{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}, but you've already completed it. Great job, overachiever.";
var assignedLearning_GroupAlreadyAttendedFormerLearnerFormat$1 = "A former learner assigned {{groupNameHtml}} to attend this{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}, but you've already completed it. Great job, overachiever.";
var assignedLearning_GroupAlreadyCompletedDateFormat$1 = "{{nameHtml}} assigned {{groupNameHtml}} this {{type}} to {{action}} by {{date}}, but you’ve already completed it! Great job, overachiever.";
var assignedLearning_GroupAlreadyCompletedDateFormerLearnerFormat$1 = "A former learner assigned {{groupNameHtml}} this {{type}} to {{action}} by {{date}}, but you’ve already completed it! Great job, overachiever.";
var assignedLearning_GroupAlreadyCompletedFormat$1 = "{{nameHtml}} assigned {{groupNameHtml}} to complete this{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}, but you've already completed it. Great job, overachiever.";
var assignedLearning_GroupAlreadyCompletedFormerLearnerFormat$1 = "A former learner assigned {{groupNameHtml}} to complete this{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}, but you've already completed it. Great job, overachiever.";
var assignedLearning_GroupAlreadyCompletedNoDateFormat$1 = "{{nameHtml}} assigned {{groupNameHtml}} this {{type}} to {{action}}, but you’ve already completed it! Great job, overachiever.";
var assignedLearning_GroupAlreadyCompletedNoDateFormerLearnerFormat$1 = "A former learner assigned {{groupNameHtml}} this {{type}} to {{action}}, but you’ve already completed it! Great job, overachiever.";
var assignedLearning_GroupAlreadyFollowedFormat$1 = "{{nameHtml}} assigned {{groupNameHtml}} to follow this{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}, but you've already completed it. Great job, overachiever.";
var assignedLearning_GroupAlreadyFollowedFormerLearnerFormat$1 = "A former learner assigned {{groupNameHtml}} to follow this{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}, but you\\u0027ve already completed it. Great job, overachiever.";
var assignedLearning_GroupAlreadyReadFormat$1 = "{{nameHtml}} assigned {{groupNameHtml}} to read this{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}, but you've already completed it. Great job, overachiever.";
var assignedLearning_GroupAlreadyReadFormerLearnerFormat$1 = "A former learner assigned {{groupNameHtml}} to read this{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}, but you\\u0027ve already completed it. Great job, overachiever.";
var assignedLearning_GroupAlreadyWatchedFormat$1 = "{{nameHtml}} assigned {{groupNameHtml}} to watch this{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}, but you've already completed it. Great job, overachiever.";
var assignedLearning_GroupAlreadyWatchedFormerLearnerFormat$1 = "A former learner assigned {{groupNameHtml}} to watch this{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}, but you\\u0027ve already completed it. Great job, overachiever.";
var assignedLearning_GroupAttendedFormat$1 = "{{nameHtml}} assigned {{groupNameHtml}} this to attend{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}";
var assignedLearning_GroupAttendedFormerLearnerFormat$1 = "A former learner assigned {{groupNameHtml}} this to attend{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}";
var assignedLearning_GroupCompletedFormat$1 = "{{nameHtml}} assigned {{groupNameHtml}} this to complete{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}";
var assignedLearning_GroupCompletedFormerLearnerFormat$1 = "A former learner assigned {{groupNameHtml}} this to complete{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}";
var assignedLearning_GroupDateFormat$1 = "{{nameHtml}} assigned {{groupNameHtml}} this {{type}} to {{action}} by {{date}}";
var assignedLearning_GroupDateFormerLearnerFormat$1 = "A former learner assigned {{groupNameHtml}} this {{type}} to {{action}} by {{date}}";
var assignedLearning_GroupFollowedFormat$1 = "{{nameHtml}} assigned {{groupNameHtml}} this to follow{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}";
var assignedLearning_GroupFollowedFormerLearnerFormat$1 = "A former learner assigned {{groupNameHtml}} this to follow{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}";
var assignedLearning_GroupNoDateFormat$1 = "{{nameHtml}} assigned {{groupNameHtml}} this {{type}} to {{action}}";
var assignedLearning_GroupNoDateFormerLearnerFormat$1 = "A former learner assigned {{groupNameHtml}} this {{type}} to {{action}}";
var assignedLearning_GroupReadFormat$1 = "{{nameHtml}} assigned {{groupNameHtml}} this to read{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}";
var assignedLearning_GroupReadFormerLearnerFormat$1 = "A former learner assigned {{groupNameHtml}} this to read{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}";
var assignedLearning_GroupWatchedFormat$1 = "{{nameHtml}} assigned {{groupNameHtml}} this to watch{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}";
var assignedLearning_GroupWatchedFormerLearnerFormat$1 = "A former learner assigned {{groupNameHtml}} this to watch{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}";
var assignedLearning_NoDueDate$1 = "{{nameHtml}} assigned this to you to complete";
var assignedLearning_NoDueDateExternal$1 = "You have been assigned this to complete";
var assignedLearning_Overdue$1 = "You were assigned this to complete {{days}} days ago";
var assignedLearning_RequiredLearningTimeTip$1 = "If you think you’ve already completed this, check again tomorrow. If it’s still here, make sure you finished it on the provider’s website.";
var assignedLearning_YouAlreadyAttendedFormat$1 = "{{nameHtml}} assigned you this to attend{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}, but you’ve already completed it! Great job, overachiever.";
var assignedLearning_YouAlreadyAttendedFormerLearnerFormat$1 = "A former learner assigned you this to attend{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}, but you’ve already completed it! Great job, overachiever.";
var assignedLearning_YouAlreadyCompletedDateFormat$1 = "{{nameHtml}} assigned you this {{type}} to {{action}} by {{date}}, but you’ve already completed it! Great job, overachiever.";
var assignedLearning_YouAlreadyCompletedDateFormerLearnerFormat$1 = "A former learner assigned you this {{type}} to {{action}} by {{date}}, but you’ve already completed it! Great job, overachiever.";
var assignedLearning_YouAlreadyCompletedFormat$1 = "{{nameHtml}} assigned you this to complete{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}, but you’ve already completed it! Great job, overachiever.";
var assignedLearning_YouAlreadyCompletedFormerLearnerFormat$1 = "A former learner assigned you this to complete{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}, but you’ve already completed it! Great job, overachiever.";
var assignedLearning_YouAlreadyCompletedFormerLearnerNoDateFormat$1 = "A former learner assigned you this {{type}} to {{action}}, but you’ve already completed it! Great job, overachiever.";
var assignedLearning_YouAlreadyCompletedNoDateFormat$1 = "{{nameHtml}} assigned you this {{type}} to {{action}}, but you’ve already completed it! Great job, overachiever.";
var assignedLearning_YouAlreadyFollowedFormat$1 = "{{nameHtml}} assigned you this to follow{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}, but you're already following it! Great job, overachiever.";
var assignedLearning_YouAlreadyFollowedFormerLearnerFormat$1 = "A former learner assigned you this to follow{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}, but you're already following it! Great job, overachiever.";
var assignedLearning_YouAlreadyReadFormat$1 = "{{nameHtml}} assigned you this to read{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}, but you’ve already completed it! Great job, overachiever.";
var assignedLearning_YouAlreadyReadFormerLearnerFormat$1 = "A former learner assigned you this to read{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}, but you’ve already completed it! Great job, overachiever.";
var assignedLearning_YouAlreadyWatchedFormat$1 = "{{nameHtml}} assigned you this to watch{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}, but you’ve already completed it! Great job, overachiever.";
var assignedLearning_YouAlreadyWatchedFormerLearnerFormat$1 = "A former learner assigned you this to watch{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}, but you’ve already completed it! Great job, overachiever.";
var assignedLearning_YouAttendedFormat$1 = "{{nameHtml}} assigned you this to attend{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}";
var assignedLearning_YouAttendedFormerLearnerFormat$1 = "A former learner assigned you this to attend{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}";
var assignedLearning_YouCompletedFormat$1 = "{{nameHtml}} assigned you this to complete{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}";
var assignedLearning_YouCompletedFormerLearnerFormat$1 = "A former learner assigned you this to complete{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}";
var assignedLearning_YouDateFormat$1 = "{{nameHtml}} assigned you this {{type}} to {{action}} by {{date}}";
var assignedLearning_YouDateFormerLearnerFormat$1 = "A former learner assigned you this {{type}} to {{action}} by {{date}}";
var assignedLearning_YouFollowedFormat$1 = "{{nameHtml}} assigned you this to follow{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}";
var assignedLearning_YouFollowedFormerLearnerFormat$1 = "A former learner assigned you this to follow{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}";
var assignedLearning_YouNoDateFormat$1 = "{{nameHtml}} assigned you this {{type}} to {{action}}";
var assignedLearning_YouNoDateFormerLearnerFormat$1 = "A former learner assigned you this {{type}} to {{action}}";
var assignedLearning_YouReadFormat$1 = "{{nameHtml}} assigned you this to read{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}";
var assignedLearning_YouReadFormerLearnerFormat$1 = "A former learner assigned you this to read{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}";
var assignedLearning_YouWatchedFormat$1 = "{{nameHtml}} assigned you this to watch{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}";
var assignedLearning_YouWatchedFormerLearnerFormat$1 = "A former learner assigned you this to watch{{hasDateHtml}} by {{date}}{{hasDateEndHtml}}";
var AssessmentFormCtrl_AddAssessment$1 = "Add Assessment";
var AssessmentFormCtrl_AddToCatalogFormat$1 = "Add this assessment to {{orgName}}'s catalog";
var AssessmentFormCtrl_AssessmentName$1 = "Assessment Name";
var AssessmentFormCtrl_AssessmentProvider$1 = "Assessment Provider";
var AssessmentFormCtrl_AssessmentUrl$1 = "Assessment URL";
var AssessmentFormCtrl_Category$1 = "Please add at least one category.";
var AssessmentFormCtrl_CorrectQuestions$1 = "The number of correct questions cannot be greater than the number of questions.";
var AssessmentFormCtrl_CorrectQuestionsFormat$1 = "Questions correct {{startTag}} out of {{number}} {{endTag}}";
var AssessmentFormCtrl_DateCompleted$1 = "Date Completed";
var AssessmentFormCtrl_Description$1 = "Description";
var AssessmentFormCtrl_EditAssessment$1 = "Edit Assessment";
var AssessmentFormCtrl_NameRequired$1 = "An assessment name is required.";
var AssessmentFormCtrl_NumberOfQuestions$1 = "Please enter the number of questions.";
var AssessmentFormCtrl_NumberOfQuestionsError$1 = "Please enter the number of questions answered correctly.";
var AssessmentFormCtrl_Percentile$1 = "Percentile";
var AssessmentFormCtrl_SaveAssessment$1 = "Save Assessment";
var AssessmentFormCtrl_TotalQuestions$1 = "Total Questions";
var AssessmentFormCtrl_UrlRequired$1 = "An assessment URL is required.";
var AssessmentFormCtrl_WhatDidYouLearnLong$1 = "What did you learn from this assessment?";
var AssessmentFormCtrl_WhatDidYouLearnShort$1 = "What did you learn?";
var AppHeader_AcademiesTitle$1 = "Academies";
var AppHeader_BrowseTitle$1 = "Browse";
var AppHeader_DgAssistantTitle$1 = "Assistant";
var AppHeader_FeaturedTitle$1 = "Featured";
var AppHeader_HomeTitle$1 = "Home";
var AppHeader_Login$1 = "Log in";
var AppHeader_MaestroTitle$1 = "Maestro";
var AppHeader_OpportunitiesTitle$1 = "Opportunities";
var AppHeader_ProfileTitle$1 = "Profile";
var AppHeader_Signup$1 = "Sign up";
var AppHeader_SkillCoachTitle$1 = "Skill Coach";
var AppHeader_TeamTitle$1 = "Skill Coach";
var AnonymousUserHelper_EmailName$1 = "Anon. Learner";
var AnonymousUserHelper_Name$1 = "Anonymous Learner";
var alertModal_DontShowAgain$1 = "Don't show this again";
var addToTargetModal_AddedItemSuccessfully$1 = "{{resourceTitleHtml}} was successfully added to {{targetTitle}}.";
var addToTargetModal_AddedSuccessfully$1 = "Successfully added to the plan";
var addToTargetModal_AddingError$1 = "An error occurred while adding";
var addToTargetModal_AddItemDescription$1 = "The item will be added to the plan you select. You can go to edit mode to arrange the content as needed.";
var addToTargetModal_AddToTarget$1 = "Add to Plan";
var addToTargetModal_CreateJobRoleExplanation$1 = "It doesn’t look like you’ve created any plans yet. A plan is a curated collection of skills, pathways, groups, people, and content focused on a particular learning goal. You can create a plan to collect unordered materials for an annual goal, personal development, or a role transition.";
var addToTargetModal_CreateTarget$1 = "Create a plan";
var addToTargetModal_CreateYourTarget$1 = "Create your own plan!";
var addToTargetModal_EditTarget$1 = "Edit the plan";
var addToTargetModal_GoToTarget$1 = "Go to Plan";
var addToTargetModal_MostRecentTargets$1 = "Most Recent Plans";
var addToTargetModal_NoSectionsFound$1 = "The selected plan has no Mixed Resources sections. Adding this item will create a new section.";
var addToTargetModal_OrgManagedNotice$1 = "Adding this item will make the selected plan org-managed. Learn more about visibility settings in the {{anchorOpen}}Degreed Knowledge Center{{anchorClose}}.";
var addToTargetModal_SearchAuthoringTarget$1 = "Search for the plan you are authoring";
var addToTargetModal_SearchYourTargets$1 = "Search Your Plans";
var addToTargetModal_Section$1 = "Section";
var addToTargetModal_SelectPlanSection$1 = "Select a plan section";
var addToTargetModal_SelectSectionPlaceHolder$1 = "Select a Section";
var addToTargetModal_SelectTargetPlaceHolder$1 = "Select a Plan";
var addToTargetModal_VisitTargetEditPage$1 = "Go to edit mode to arrange the content.";
var addToTargetModal_WhichTarget$1 = "Which plan would you like to add this to?";
var addToTargetModal_YourTargets$1 = "Your Plans";
var addToPathwayModal_AddedSuccessfully$1 = "Successfully added to the pathway";
var addToPathwayModal_AddingError$1 = "An error occurred adding to the pathway";
var addToPathwayModal_AddItemDescription$1 = 'The item will be added to the pathway\'s "Hold for Later" area for the pathway you select. You can visit the pathway editor to arrange content into lessons.';
var addToPathwayModal_AddToCatalog$1 = "Add to catalog";
var addToPathwayModal_AddToPathway$1 = "Add to Pathway";
var addToPathwayModal_CreatePathway$1 = "Create a Pathway";
var addToPathwayModal_CreatePathwayExplanation$1 = "It doesn’t look like you have created any pathways yet. Use pathways to connect learning resources together around a common theme or skill.";
var addToPathwayModal_CreateYourPathway$1 = "Create your first pathway!";
var addToPathwayModal_EditPathway$1 = "Edit the Pathway";
var addToPathwayModal_GoToPathway$1 = "Go to Pathway";
var addToPathwayModal_HoldForLater$1 = "Hold for Later";
var addToPathwayModal_Lesson$1 = "Subsection";
var addToPathwayModal_LessonNumberFormat$1 = "Subsection {{number}}";
var addToPathwayModal_MostRecentPathways$1 = "Most Recent Pathways";
var addToPathwayModal_NoPathwayDescription$1 = "It doesn’t look like you have created any pathways yet. Use pathways to connect learning resources together around a common theme or skill.";
var addToPathwayModal_OrgManagedNotice$1 = "Adding this item will make the selected pathway org-managed. Learn more about visibility settings in the {{anchorOpen}}Degreed Knowledge Center{{anchorClose}}.";
var addToPathwayModal_Pathway$1 = "Pathway";
var addToPathwayModal_RecentlyUsed$1 = "Recently used Pathways";
var addToPathwayModal_SearchAuthoringPathway$1 = "Search for the pathway you are authoring";
var addToPathwayModal_SearchYourPathways$1 = "Search Your Pathways";
var addToPathwayModal_Section$1 = "Section";
var addToPathwayModal_SectionNumberFormat$1 = "Section {{number}}";
var addToPathwayModal_SelectLesson$1 = "Select a Subsection";
var addToPathwayModal_SelectPathway$1 = "Select a Pathway";
var addToPathwayModal_SelectPathwaySection$1 = "Select a pathway section";
var addToPathwayModal_SelectPathwaySubSection$1 = "Select a subsection";
var addToPathwayModal_SelectSection$1 = "Select a Section";
var addToPathwayModal_SuccessLabel$1 = "{{startBold}}{{assignmentName}}{{endBold}} was successfully added to {{pathwayName}}.";
var addToPathwayModal_VisitPathwayEditPage$1 = "Visit the pathway edit page to arrange the content into lessons.";
var addToPathwayModal_WhichPathway$1 = "Which pathway would you like to add this to?";
var addToPathwayModal_YourPathways$1 = "Your Pathways";
var addEditMetaDataModal_AddProperty$1 = "Add Property";
var addEditMetaDataModal_EditProperties$1 = "Edit Properties";
var addEditMetaDataModal_Property$1 = "Property";
var addEditMetaDataModal_Purpose_RolePlan$1 = "Role plan";
var addEditMetaDataModal_RemoveProperty$1 = "Remove Property";
var addEditMetaDataModal_Value$1 = "Value";
var ActiveLearner_Condition1$1 = "You have shared at least 1 item";
var ActiveLearner_Condition1WithName$1 = "{{name}} has shared at least 1 item";
var ActiveLearner_Condition2$1 = "You have completed at least 5 items";
var ActiveLearner_Condition2WithName$1 = "{{name}} has completed at least 5 items";
var ActiveLearner_Condition3$1 = "You have added at least 3 skills to your profile";
var ActiveLearner_Condition3WithName$1 = "{{name}} has added at least 3 skills to their profile";
var ActiveLearner_Condition4$1 = "You are active every month";
var ActiveLearner_Condition4WithName$1 = "{{name}} has been active every month";
var ActiveLearner_Congratulations$1 = "Congratulations!";
var ActiveLearner_CongratulationsText$1 = "Based on your activity, you have reached <a>Active</a> learner status! This means that you are among your organization's top learners. Keep up the good work!";
var ActiveLearner_FinePrint$1 = "If you don't use Degreed at least once every 30 days, you'll lose your Active Learner status. But don't worry, as soon as you are active again, you'll gain it back.";
var ActiveLearner_FinePrintWithName$1 = "If {{name}} doesn't use Degreed at least once every 30 days, they'll lose their Active Learner status.";
var ActiveLearner_HowToGetRecognized$1 = "How do you achieve this learner status?";
var ActiveLearner_ModalTitle$1 = "You are an Active Learner";
var ActiveLearner_ModalTitleWithName$1 = "{{name}} is an Active Learner";
var AccountSvc_ChangeLinkFail$1 = '<p>It looks like this link is not valid. Password reset links are only active a short while. To reset your password, please go to the <a href="/account/login" class="underline">log in page</a> and try again.</p>';
var AccountSvc_ChangeSuccess$1 = '<p>Password Changed. You can now <a href="/account/login" class="link">Log In</a></p>';
var AccountSvc_CreateAccountError$1 = "An error occurred creating a new account.";
var AccountSvc_DefaultPassword$1 = "<p>It looks like you have a default password. You must change your password before you can use Degreed.</p>";
var AccountSvc_DeleteAccount$1 = "Sorry! There was a problem deleting your account. Please contact us so we can help.";
var AccountSvc_EmailConfirmation$1 = "<p>Before you can verify your email address, we need to make sure you own the related Degreed account.</p><p>Please sign in or sign up for a Degreed account below.</p>";
var AccountSvc_ForgotPassword$1 = "<p>Please enter your primary email address to have a password reset email sent to you.</p><p>If you registered using Facebook, please log in with Facebook.</p>";
var AccountSvc_GroupInvite$1 = "<p>You have been invited to join a group on Degreed.</p><p>Participate in your organization&rsquo;s groups and learn with your coworkers.</p>";
var AccountSvc_LoginError$1 = "Sorry! There was a problem logging in. Please contact us so we can help.";
var AccountSvc_OrgInvite$1 = "<p>You have been invited to join<br>Degreed Learning Management.</p><p>Participate in your organization&rsquo;s groups and learn with your coworkers.</p>";
var AccountSvc_OrgPasswordError$1 = "Sorry! You belong to an organization that does not allow you to reset or recover your password. Please contact Degreed support for more information.";
var AccountSvc_PasswordResetError$1 = "Sorry! There was a problem resetting password. Please contact us so we can help.";
var AccountSvc_PasswordResetInstructionsMessage$1 = "Password reset instructions sent";
var AccountSvc_Restricted$1 = "<p>Unfortunately at this time the Learning Portal is not available to regulated employees.</p>";
var AccountSvc_SecondaryEmail$1 = "<p>Please log in with your organization email.</p>";
var AccountSvc_SessionExpired$1 = '<p>Your session has expired. Checking the "Remember Me" checkbox will keep you logged in for a longer time but only do so on a private computer.</p><p>Please sign in again.</p>';
var AccountSvc_SignUp$1 = "<p>Sign up for a Degreed account.</p>";
var AccountSvc_Unsubscribe$1 = "<p><strong>{{email}} has been successfully unsubscribed from the {{newsletter}}</strong></p><p>If you would like to subscribe again at some point, you can do so from your settings.</p>";
var AccountSvc_UserEndorsement$1 = "<p>You have been asked to provide a recommendation to help verify and support someone&rsquo;s expertise. Your recommendation is a critical part of this process. Please sign in or sign up for a Degreed account below to complete the recommendation.</p>";
var AccountCtrl_ContinueToAccount$1 = "Track and improve your skills.";
var AccountCtrl_LoginUsingProvider$1 = "Login to {{name}} using {{providerName}}.";
var AccountController_AccountLockedByOrgError$1 = "Your account has been locked.  Please contact your administrator.";
var AccountController_AccountLockedError$1 = "Your account is currently locked. Please try again in a few minutes.";
var AccountController_AgreeWithTermsOne$1 = "I agree with the Degreed";
var AccountController_AgreeWithTermTwo$1 = "terms of use";
var AccountController_And$1 = "and";
var AccountController_ChangePassword$1 = "Change Password";
var AccountController_ChangePasswordError$1 = "Unable to verify your old password, please try again.";
var AccountController_ChangePasswordTitle$1 = "Change your password.";
var AccountController_ConfirmPassword$1 = "Confirm Password";
var AccountController_Continue$1 = "Continue";
var AccountController_ContinueWithSSO$1 = "Continue with SSO";
var AccountController_EmailAddress$1 = "Email or Username";
var AccountController_EmailAddressPlaceholder$1 = "jane@acme.com";
var AccountController_EmailExistsError$1 = "An account with that e-mail has already been registered. Please login via e-mail.";
var AccountController_EmailLoginDisabledError$1 = "You belong to an organization that does not allow signing in via E-mail.";
var AccountController_EmailLoginError$1 = "The email or password provided is incorrect.";
var AccountController_FacebookLogin$1 = "Log in with Facebook";
var AccountController_FirstName$1 = "First Name";
var AccountController_Forgot$1 = "Set/Reset password";
var AccountController_LoggedOutHeader$1 = "You've been logged out.";
var AccountController_LoggedOutTitle$1 = "Logged Out";
var AccountController_Login$1 = "Log In";
var AccountController_LoginAgainButton$1 = "Login again?";
var AccountController_LoginUsingPassword$1 = "Log in using password";
var AccountController_LoginViewContent$1 = "Login to view content from {0}";
var AccountController_NewPassword$1 = "New Password";
var AccountController_OldPassword$1 = "Current Password";
var AccountController_OldPasswordPlaceholder$1 = "Enter your current password";
var AccountController_Password$1 = "Password";
var AccountController_PasswordMatchError$1 = "The new password and the confirmation password do not match.";
var AccountController_PasswordPatternInfo$1 = "Passwords must be at least 8 characters long and include 1 number & 1 letter";
var AccountController_PrivacyPolicy$1 = "privacy policy";
var AccountController_RecentPasswordError$1 = "You have used this password recently, please try again.";
var AccountController_Register$1 = "Register";
var AccountController_RegisterEmailExistsError$1 = "A user with the specified email address is already registered.";
var AccountController_RememberMe$1 = "Remember me";
var AccountController_ResetPassword$1 = "Reset your password.";
var AccountController_ResetYourPassword$1 = "Reset Your Password";
var AccountController_SignUp$1 = "Sign Up";
var AccountController_SignUpPageTitle$1 = "Sign Up";
var AccountController_SignUpTitle$1 = "Sign up.";
var AccountController_UsernameLoginError$1 = "The username or password you’ve entered is incorrect.";
var AccountController_ValidPassword$1 = "Valid password";
var AccountController_WelcomeDegreed$1 = "Welcome.";
var AccomplishmentFormCtrl_EndDate$1 = "The end date must be after the start date.";
var AccomplishmentFormCtrl_ExpirationDate$1 = "Please specify the expiration date.";
var AccomplishmentFormCtrl_StateDate$1 = "Please specify the start date.";
var AccomplishmentFormCtrl_Title$1 = "An accomplishment title is required.";
var AboutFooter_AltCareersIcon$1 = "Careers Icon";
var AboutFooter_AltContactIcon$1 = "Contact Icon";
var AboutFooter_AltMissionIcon$1 = "Mission Icon";
var AboutFooter_AltPressIcon$1 = "Press Icon";
var AboutFooter_CareersAtDegreed$1 = "Careers @ Degreed";
var AboutFooter_ContactDegreed$1 = "Contact Degreed";
var AboutFooter_DegreedMission$1 = "Degreed Mission";
var AboutFooter_DegreedPress$1 = "Degreed Press";
var AboutFooter_JailbreakTheDegree$1 = "Simple. Jailbreak the Degree.";
var AboutFooter_LearningAndWork$1 = "Equal parts learning and work.";
var AboutFooter_WeWantToHear$1 = "We'd love to hear from you.";
var AboutFooter_WhatOthersAreSaying$1 = "What others are saying about us.";
var A11y_ActionsToolbarType$1 = "Actions";
var A11y_AddComment$1 = "Add a comment";
var A11y_AssignmentsCount$1 = "{{n}} Assignments";
var A11y_AssignmentStatus$1 = "Assignment Status";
var A11y_BlurToSave$1 = "Move focus away from this element to automatically save changes.";
var A11y_BreadcrumbNavType$1 = "Breadcrumb";
var A11y_BrowseGroups$1 = "Browse groups button. Clicking this will redirect you to the browse groups page.";
var A11y_BrowseGroupsButton$1 = "Browse groups button. Clicking this will redirect you to the browse groups page.";
var A11y_BrowseOpportunitiesGridView$1 = "View all opportunities with a preview pane";
var A11y_BrowseOpportunitiesListView$1 = "View all opportunities in a simple table";
var A11y_BrowsePathwaysButton$1 = "Browse pathways button. Clicking this will redirect you to the browse pathways page.";
var A11y_BrowsePlansButton$1 = "Browse plans button. Clicking this will redirect you to the browse plans page.";
var A11y_BulkDelete_Format$1 = "Bulk delete {{count}} selected items";
var A11y_BulkDisable_Format$1 = "Bulk disable {{count}} selected items";
var A11y_BulkEnable_Format$1 = "Bulk enable {{count}} selected items";
var A11y_ButtonGroupWithNestedDropdown$1 = "Button group with nested dropdown";
var A11y_CharacterLimit$1 = "Character limit: {{ limit }}";
var A11y_CollapsePanelButton$1 = "“Hide details for {{name}}”";
var A11y_CollectionChangeAnnouncement$1 = "{{collectionName}} collection selected";
var A11y_CompletionProgressDetails$1 = "Completion Progress: {{numberCompleted}} of {{total}}";
var A11y_ConfirmModal_input$1 = "Input field for confirm dialog";
var A11y_ContentCompletedButton$1 = "Completion Button for {{title}}: Status Completed";
var A11y_ContentNotCompletedButton$1 = "Completion Button for {{title}}: Status Not Completed";
var A11y_ContentTypesNavType$1 = "Content Types";
var A11y_ContinuingEducationUnits$1 = "Continuing Education Units";
var A11y_CreateGroup$1 = "Create Group";
var A11y_Date_YYYYMMDDFormat$1 = "Date format: yyyy-mm-dd";
var A11y_Delete_Format$1 = "Delete {{item}}";
var A11y_DeleteLink$1 = "Delete the {{linkTitle}} link";
var A11y_Disable_Format$1 = "Disable {{item}}";
var A11y_Edit_Format$1 = "Edit {{item}}";
var A11y_Enable_Format$1 = "Enable {{item}}";
var A11y_EscapeToDismiss$1 = "Press escape key to dismiss";
var A11y_ExpandExperience$1 = "Expand for more details about this experience";
var A11y_ExpandForSummary$1 = "Expand for summary";
var A11y_ExpandForTitle$1 = "Expand for title";
var A11y_ExpandPanelButton$1 = "Show details for {{name}}";
var A11y_FollowingPathwayButton$1 = "Follow Pathway {{title}}: Status Following";
var A11y_FollowingPlanButton$1 = "Follow Plan {{title}}: Status Following";
var A11y_GlobalSearchInstructions$1 = "When suggestions are available use up and down arrows to review and enter to select. Touch device users, explore by touch or with swipe gestures.";
var A11y_GoToProfile$1 = "Go to profile of {{profileName}}";
var A11y_GroupJoinedButton$1 = "Join Group {{title}}: Status Joined";
var A11y_GroupNotJoinedButton$1 = "Join Group {{title}}: Status Not Joined";
var A11y_LearningCollectionsNavType$1 = "Learning Collections";
var A11y_LinkOpensNewWindow$1 = "Opens an external site in a new window";
var A11y_MainPagesNavType$1 = "Main Pages";
var A11y_NonOptionalStepsComplete$1 = "All non-optional steps are complete";
var A11y_NotFollowingPathwayButton$1 = "Follow Pathway {{title}}: Status Not Following";
var A11y_NotFollowingPlanButton$1 = "Follow Plan {{title}}: Status Not Following";
var A11y_NumberOfSkills$1 = "Number Of Skills";
var A11y_NumberSuggestionsAvailableFormat$1 = "{{n}} suggestions are available";
var A11y_OpensInANewTab$1 = "Opens in a new tab";
var A11y_OptionalStatus$1 = "Optional Status";
var A11y_PositiveNumbersOnly$1 = "Only positive numbers are allowed";
var A11y_RegistrationStatus$1 = "Registration Status";
var A11y_RemoveCardType$1 = "Remove {{cardType}} card";
var A11y_RemoveContent$1 = "Remove {{ contentType }} titled {{ contentTitle }}";
var A11y_RemoveSection$1 = "Remove section number {{ sectionNumber }} titled {{ sectionTitle }}";
var A11y_RemoveSubsection$1 = "Remove section number {{ sectionNumber }}, subsection number {{ subsectionNumber }}, titled {{ subsectionTitle }}";
var A11y_RemoveUser$1 = "Remove {{userType}}";
var A11y_RotatingLogos$1 = "Rotating list of client logos";
var A11y_SearchAssignments$1 = "Search Assignments";
var A11y_SecondaryPagesNavType$1 = "Secondary Pages";
var A11y_Select_Format$1 = "Select {{item}}";
var A11y_SessionStartDate$1 = "Session Start Date";
var A11y_SliderDescription$1 = "Horizontal Slider";
var A11y_SliderNavigation$1 = "For JAWS, use the ALT and arrow keys. For VoiceOver/NVDA, use the arrow keys.";
var A11y_TabChangeAnnouncement$1 = "{{newPageTitle}} tab selected";
var A11y_ToggleProductMenu$1 = "Toggle Product Menu";
var A11y_ToggleProfileMenu$1 = "Toggle Profile menu";
var A11y_ToggleSearch$1 = "Toggle search";
var A11y_TrackerCurrentStep$1 = "Currently on {{stepName}}";
var A11y_TrackerStep$1 = "Step {{stepName}}";
var A11y_TryOurBookmarklet$1 = "Try our bookmarklet - clicking on this button will update the content below";
var A11y_VerificationStatus$1 = "Verification Status";
var A11y_virtualDocument$1 = "Virtual {{documentType}}";
var A11y_WizardClickExpand$1 = "{{label}}: click to expand";
var A11y_WizardNavType$1 = "Progress Wizard";
var localTranslationsEn = {
    workdaySkillRemoved_Message: workdaySkillRemoved_Message$1,
    workdaySkillRemoved_Plural: workdaySkillRemoved_Plural$1,
    workdaySkillRemoved_Single: workdaySkillRemoved_Single$1,
    workdaySkillAdded_Plural: workdaySkillAdded_Plural$1,
    workdaySkillAdded_Single: workdaySkillAdded_Single$1,
    workdaySkillAdded_WorkdayIntegrationDisabled: workdaySkillAdded_WorkdayIntegrationDisabled$1,
    workdaySkillAdded_WorkdayIntegrationEnabled: workdaySkillAdded_WorkdayIntegrationEnabled$1,
    Webhooks_ActivityDownload: Webhooks_ActivityDownload$1,
    Webhooks_ActivityDownloadConfirmation: Webhooks_ActivityDownloadConfirmation$1,
    Webhooks_ActivityDownloadLogBtn: Webhooks_ActivityDownloadLogBtn$1,
    Webhooks_ActivityDownloadSuccessfully: Webhooks_ActivityDownloadSuccessfully$1,
    Webhooks_ActivityFilterCheckbox: Webhooks_ActivityFilterCheckbox$1,
    Webhooks_ActivityLog: Webhooks_ActivityLog$1,
    Webhooks_ActivityLogDescription: Webhooks_ActivityLogDescription$1,
    Webhooks_ActivityLogErrorOrgid: Webhooks_ActivityLogErrorOrgid$1,
    Webhooks_ActivityLogEventType: Webhooks_ActivityLogEventType$1,
    Webhooks_ActivityLogFailed: Webhooks_ActivityLogFailed$1,
    Webhooks_ActivityLogInvalid: Webhooks_ActivityLogInvalid$1,
    Webhooks_ActivityLogNoLogs: Webhooks_ActivityLogNoLogs$1,
    Webhooks_ActivityLogRefresh: Webhooks_ActivityLogRefresh$1,
    Webhooks_ActivityLogResponseCode: Webhooks_ActivityLogResponseCode$1,
    Webhooks_ActivityLogResponseTime: Webhooks_ActivityLogResponseTime$1,
    Webhooks_ActivityLogRetries: Webhooks_ActivityLogRetries$1,
    Webhooks_ActivityLogRetryCopyPaylod: Webhooks_ActivityLogRetryCopyPaylod$1,
    Webhooks_ActivityLogTimestamp: Webhooks_ActivityLogTimestamp$1,
    Webhooks_ActivityLogTry: Webhooks_ActivityLogTry$1,
    Webhooks_ActivityLogView: Webhooks_ActivityLogView$1,
    Webhooks_ActivityRetriesQueue: Webhooks_ActivityRetriesQueue$1,
    Webhooks_ActivityViewLog: Webhooks_ActivityViewLog$1,
    Webhooks_AddWebhook: Webhooks_AddWebhook$1,
    Webhooks_AuthorizationType: Webhooks_AuthorizationType$1,
    Webhooks_AvgLatency: Webhooks_AvgLatency$1,
    Webhooks_AvgTime: Webhooks_AvgTime$1,
    Webhooks_CreateWebhook: Webhooks_CreateWebhook$1,
    Webhooks_DeleteSuccessfully: Webhooks_DeleteSuccessfully$1,
    Webhooks_DeleteWebhook: Webhooks_DeleteWebhook$1,
    Webhooks_DeleteWebhookConfirmationMessage: Webhooks_DeleteWebhookConfirmationMessage$1,
    Webhooks_DeleteWebhookConfirmationPrimaryBtn: Webhooks_DeleteWebhookConfirmationPrimaryBtn$1,
    Webhooks_DeleteWebhookConfirmationSecondaryBtn: Webhooks_DeleteWebhookConfirmationSecondaryBtn$1,
    Webhooks_DescriptionAddWebhook: Webhooks_DescriptionAddWebhook$1,
    Webhooks_EndpointUrl: Webhooks_EndpointUrl$1,
    Webhooks_ErrorCreatingOrUpdatingWebhook: Webhooks_ErrorCreatingOrUpdatingWebhook$1,
    Webhooks_Events_LearningProgressEvent: Webhooks_Events_LearningProgressEvent$1,
    Webhooks_Events_LearningProgressEvent_Description: Webhooks_Events_LearningProgressEvent_Description$1,
    Webhooks_Events_PathwayCompletedEvent: Webhooks_Events_PathwayCompletedEvent$1,
    Webhooks_Events_PathwayCompletedEvent_Description: Webhooks_Events_PathwayCompletedEvent_Description$1,
    Webhooks_Events_PathwayCreatedEvent: Webhooks_Events_PathwayCreatedEvent$1,
    Webhooks_Events_PathwayCreatedEvent_Description: Webhooks_Events_PathwayCreatedEvent_Description$1,
    Webhooks_Events_PathwayEnrolledEvent: Webhooks_Events_PathwayEnrolledEvent$1,
    Webhooks_Events_PathwayEnrolledEvent_Description: Webhooks_Events_PathwayEnrolledEvent_Description$1,
    Webhooks_Events_PathwayUnenrolledEvent: Webhooks_Events_PathwayUnenrolledEvent$1,
    Webhooks_Events_PathwayUnenrolledEvent_Description: Webhooks_Events_PathwayUnenrolledEvent_Description$1,
    Webhooks_Events_PathwayUpdatedEvent: Webhooks_Events_PathwayUpdatedEvent$1,
    Webhooks_Events_PathwayUpdatedEvent_Description: Webhooks_Events_PathwayUpdatedEvent_Description$1,
    Webhooks_Events_PathwayViewedEvent: Webhooks_Events_PathwayViewedEvent$1,
    Webhooks_Events_PathwayViewedEvent_Description: Webhooks_Events_PathwayViewedEvent_Description$1,
    Webhooks_Events_QueueItemCreatedEvent: Webhooks_Events_QueueItemCreatedEvent$1,
    Webhooks_Events_QueueItemCreatedEvent_Description: Webhooks_Events_QueueItemCreatedEvent_Description$1,
    Webhooks_Events_QueueItemRemovedEvent: Webhooks_Events_QueueItemRemovedEvent$1,
    Webhooks_Events_QueueItemRemovedEvent_Description: Webhooks_Events_QueueItemRemovedEvent_Description$1,
    Webhooks_Events_RecommendationCreatedEvent: Webhooks_Events_RecommendationCreatedEvent$1,
    Webhooks_Events_RecommendationCreatedEvent_Description: Webhooks_Events_RecommendationCreatedEvent_Description$1,
    Webhooks_Events_TargetCreatedEvent: Webhooks_Events_TargetCreatedEvent$1,
    Webhooks_Events_TargetCreatedEvent_Description: Webhooks_Events_TargetCreatedEvent_Description$1,
    Webhooks_Events_TargetDeletedEvent: Webhooks_Events_TargetDeletedEvent$1,
    Webhooks_Events_TargetDeletedEvent_Description: Webhooks_Events_TargetDeletedEvent_Description$1,
    Webhooks_Events_TargetFollowedEvent: Webhooks_Events_TargetFollowedEvent$1,
    Webhooks_Events_TargetFollowedEvent_Description: Webhooks_Events_TargetFollowedEvent_Description$1,
    Webhooks_Events_TargetUnfollowedEvent: Webhooks_Events_TargetUnfollowedEvent$1,
    Webhooks_Events_TargetUnfollowedEvent_Description: Webhooks_Events_TargetUnfollowedEvent_Description$1,
    Webhooks_Events_UserCommentAddedEvent: Webhooks_Events_UserCommentAddedEvent$1,
    Webhooks_Events_UserCommentAddedEvent_Description: Webhooks_Events_UserCommentAddedEvent_Description$1,
    Webhooks_Events_UserCommentDeletedEvent: Webhooks_Events_UserCommentDeletedEvent$1,
    Webhooks_Events_UserCommentDeletedEvent_Description: Webhooks_Events_UserCommentDeletedEvent_Description$1,
    Webhooks_Events_UserCreatedGroupEvent: Webhooks_Events_UserCreatedGroupEvent$1,
    Webhooks_Events_UserCreatedGroupEvent_Description: Webhooks_Events_UserCreatedGroupEvent_Description$1,
    Webhooks_Events_UserDeletedGroupEvent: Webhooks_Events_UserDeletedGroupEvent$1,
    Webhooks_Events_UserDeletedGroupEvent_Description: Webhooks_Events_UserDeletedGroupEvent_Description$1,
    Webhooks_Events_UserFollowedEvent: Webhooks_Events_UserFollowedEvent$1,
    Webhooks_Events_UserFollowedEvent_Description: Webhooks_Events_UserFollowedEvent_Description$1,
    Webhooks_Events_UserInputCreatedEvent: Webhooks_Events_UserInputCreatedEvent$1,
    Webhooks_Events_UserInputCreatedEvent_Description: Webhooks_Events_UserInputCreatedEvent_Description$1,
    Webhooks_Events_UserInputViewedEvent: Webhooks_Events_UserInputViewedEvent$1,
    Webhooks_Events_UserInputViewedEvent_Description: Webhooks_Events_UserInputViewedEvent_Description$1,
    Webhooks_Events_UserInterestAddedEvent: Webhooks_Events_UserInterestAddedEvent$1,
    Webhooks_Events_UserInterestAddedEvent_Description: Webhooks_Events_UserInterestAddedEvent_Description$1,
    Webhooks_Events_UserInterestRemovedEvent: Webhooks_Events_UserInterestRemovedEvent$1,
    Webhooks_Events_UserInterestRemovedEvent_Description: Webhooks_Events_UserInterestRemovedEvent_Description$1,
    Webhooks_Events_UserInvitedToGroupEvent: Webhooks_Events_UserInvitedToGroupEvent$1,
    Webhooks_Events_UserInvitedToGroupEvent_Description: Webhooks_Events_UserInvitedToGroupEvent_Description$1,
    Webhooks_Events_UserJoinedGroupEvent: Webhooks_Events_UserJoinedGroupEvent$1,
    Webhooks_Events_UserJoinedGroupEvent_Description: Webhooks_Events_UserJoinedGroupEvent_Description$1,
    Webhooks_Events_UserLeftGroupEvent: Webhooks_Events_UserLeftGroupEvent$1,
    Webhooks_Events_UserLeftGroupEvent_Description: Webhooks_Events_UserLeftGroupEvent_Description$1,
    Webhooks_Events_UserLoginEvent: Webhooks_Events_UserLoginEvent$1,
    Webhooks_Events_UserLoginEvent_Description: Webhooks_Events_UserLoginEvent_Description$1,
    Webhooks_Events_UserResourceDeletedEvent: Webhooks_Events_UserResourceDeletedEvent$1,
    Webhooks_Events_UserResourceDeletedEvent_Description: Webhooks_Events_UserResourceDeletedEvent_Description$1,
    Webhooks_Events_UserResourceRatingEvent: Webhooks_Events_UserResourceRatingEvent$1,
    Webhooks_Events_UserResourceRatingEvent_Description: Webhooks_Events_UserResourceRatingEvent_Description$1,
    Webhooks_Events_UserTagRatingCompletedEvent: Webhooks_Events_UserTagRatingCompletedEvent$1,
    Webhooks_Events_UserTagRatingCompletedEvent_Description: Webhooks_Events_UserTagRatingCompletedEvent_Description$1,
    Webhooks_EventsSelected: Webhooks_EventsSelected$1,
    Webhooks_EventType: Webhooks_EventType$1,
    Webhooks_EventTypesColumn: Webhooks_EventTypesColumn$1,
    Webhooks_Get: Webhooks_Get$1,
    Webhooks_Heading: Webhooks_Heading$1,
    Webhooks_HeadingManage: Webhooks_HeadingManage$1,
    Webhooks_HeadingNew: Webhooks_HeadingNew$1,
    Webhooks_HMAC: Webhooks_HMAC$1,
    Webhooks_HMACSecret: Webhooks_HMACSecret$1,
    Webhooks_HMACSecretEncrypted: Webhooks_HMACSecretEncrypted$1,
    Webhooks_HMACSignatureHeader: Webhooks_HMACSignatureHeader$1,
    Webhooks_HMACSignatureHeaderEncrypted: Webhooks_HMACSignatureHeaderEncrypted$1,
    Webhooks_ID: Webhooks_ID$1,
    Webhooks_NoWebhook: Webhooks_NoWebhook$1,
    Webhooks_OAuth2: Webhooks_OAuth2$1,
    Webhooks_OAuthClientUrl: Webhooks_OAuthClientUrl$1,
    Webhooks_On: Webhooks_On$1,
    Webhooks_Paused: Webhooks_Paused$1,
    Webhooks_Payload: Webhooks_Payload$1,
    Webhooks_PayloadsSent: Webhooks_PayloadsSent$1,
    Webhooks_PayloadType: Webhooks_PayloadType$1,
    Webhooks_Security: Webhooks_Security$1,
    Webhooks_Status_Failure: Webhooks_Status_Failure$1,
    Webhooks_Status_Retry: Webhooks_Status_Retry$1,
    Webhooks_Status_Retry2: Webhooks_Status_Retry2$1,
    Webhooks_Status_Retry3: Webhooks_Status_Retry3$1,
    Webhooks_Status_Success: Webhooks_Status_Success$1,
    Webhooks_Status_WebhookCreated: Webhooks_Status_WebhookCreated$1,
    Webhooks_Stopped: Webhooks_Stopped$1,
    Webhooks_Test: Webhooks_Test$1,
    Webhooks_TestDescription: Webhooks_TestDescription$1,
    Webhooks_WebhookCreatedSuccessfully: Webhooks_WebhookCreatedSuccessfully$1,
    Webhooks_WebhookName: Webhooks_WebhookName$1,
    Webhooks_WebhookUpdatedSuccessfully: Webhooks_WebhookUpdatedSuccessfully$1,
    verificationModal_ImageAlt: verificationModal_ImageAlt$1,
    verificationModal_Instructions: verificationModal_Instructions$1,
    verificationModal_ProvidePhoto: verificationModal_ProvidePhoto$1,
    verificationModal_RequiredPhoto: verificationModal_RequiredPhoto$1,
    verificationModal_Submit: verificationModal_Submit$1,
    verificationForm_AuthInstructions: verificationForm_AuthInstructions$1,
    verificationForm_AuthLoginLink: verificationForm_AuthLoginLink$1,
    verificationForm_AuthPasswordLabel: verificationForm_AuthPasswordLabel$1,
    verificationForm_AuthTitle: verificationForm_AuthTitle$1,
    verificationForm_Change: verificationForm_Change$1,
    verificationForm_EmailLabel: verificationForm_EmailLabel$1,
    verificationForm_ErrorGettingForm: verificationForm_ErrorGettingForm$1,
    verificationForm_ErrorSavingForm: verificationForm_ErrorSavingForm$1,
    verificationForm_FirstNameLabel: verificationForm_FirstNameLabel$1,
    verificationForm_LastNameLabel: verificationForm_LastNameLabel$1,
    verificationForm_LinkedInLabel: verificationForm_LinkedInLabel$1,
    verificationForm_LinkedInPlaceholder: verificationForm_LinkedInPlaceholder$1,
    verificationForm_Optional: verificationForm_Optional$1,
    verificationForm_PhoneLabel: verificationForm_PhoneLabel$1,
    verificationForm_PhonePlaceholder: verificationForm_PhonePlaceholder$1,
    verificationForm_PhotoLabel: verificationForm_PhotoLabel$1,
    verificationForm_PhotoRequirements: verificationForm_PhotoRequirements$1,
    verificationForm_PhotoTileLabel: verificationForm_PhotoTileLabel$1,
    verificationForm_Submit: verificationForm_Submit$1,
    verificationForm_TwitterLabel: verificationForm_TwitterLabel$1,
    verificationForm_TwitterPlaceholder: verificationForm_TwitterPlaceholder$1,
    UserTaskSvc_Error: UserTaskSvc_Error$1,
    UserTagRatingRequested_Complete_NotificationTitleFormat: UserTagRatingRequested_Complete_NotificationTitleFormat$1,
    UserTagRatingRequested_NotificationTitleFormat: UserTagRatingRequested_NotificationTitleFormat$1,
    UserTagRatingRequested_Self_CompleteNotificationTitleFormat: UserTagRatingRequested_Self_CompleteNotificationTitleFormat$1,
    UserTagRatingRequested_Self_NotificationTitleFormat: UserTagRatingRequested_Self_NotificationTitleFormat$1,
    UserTagRatingCompleted_NotificationTitleFormat: UserTagRatingCompleted_NotificationTitleFormat$1,
    UserStaticSettingsSvc_AssociatedPersonalEmail: UserStaticSettingsSvc_AssociatedPersonalEmail$1,
    UserStaticSettingsSvc_DuplicateOrgEmail: UserStaticSettingsSvc_DuplicateOrgEmail$1,
    UserStaticSettingsSvc_DuplicateProfileName: UserStaticSettingsSvc_DuplicateProfileName$1,
    UserStaticSettingsSvc_Failure: UserStaticSettingsSvc_Failure$1,
    UserStaticSettingsSvc_InvalidPersonalEmail: UserStaticSettingsSvc_InvalidPersonalEmail$1,
    UserStaticSettingsSvc_InvalidProfileName: UserStaticSettingsSvc_InvalidProfileName$1,
    UserStaticSettingsSvc_Success: UserStaticSettingsSvc_Success$1,
    UsersSvc_FindUsersError: UsersSvc_FindUsersError$1,
    UsersSvc_GetOpportunityPreferencesError: UsersSvc_GetOpportunityPreferencesError$1,
    UsersSvc_GetRecommendedError: UsersSvc_GetRecommendedError$1,
    UsersSvc_GetUserError: UsersSvc_GetUserError$1,
    UsersSvc_UpdateOpportunityPreferencesError: UsersSvc_UpdateOpportunityPreferencesError$1,
    UserSettingsSvc_CommunicationSettingsSaved: UserSettingsSvc_CommunicationSettingsSaved$1,
    UserSettingsSvc_CommunicationSettingsSavedFailed: UserSettingsSvc_CommunicationSettingsSavedFailed$1,
    UserSettingsSvc_DescAssignedLearning: UserSettingsSvc_DescAssignedLearning$1,
    UserSettingsSvc_DescAssignmentReminder: UserSettingsSvc_DescAssignmentReminder$1,
    UserSettingsSvc_DescEndorsementRequest: UserSettingsSvc_DescEndorsementRequest$1,
    UserSettingsSvc_DescFollowers: UserSettingsSvc_DescFollowers$1,
    UserSettingsSvc_DescFollowingActivity: UserSettingsSvc_DescFollowingActivity$1,
    UserSettingsSvc_DescGoals: UserSettingsSvc_DescGoals$1,
    UserSettingsSvc_DescGroupPostAdded: UserSettingsSvc_DescGroupPostAdded$1,
    UserSettingsSvc_DescMention: UserSettingsSvc_DescMention$1,
    UserSettingsSvc_DescNewComment: UserSettingsSvc_DescNewComment$1,
    UserSettingsSvc_DescNewGoal: UserSettingsSvc_DescNewGoal$1,
    UserSettingsSvc_DescRecommendations: UserSettingsSvc_DescRecommendations$1,
    UserSettingsSvc_DescReplyComment: UserSettingsSvc_DescReplyComment$1,
    UserSettingsSvc_DescSocialNotify: UserSettingsSvc_DescSocialNotify$1,
    UserSettingsSvc_DescTodaysLearning: UserSettingsSvc_DescTodaysLearning$1,
    UserSettingsSvc_EmailAddressesError: UserSettingsSvc_EmailAddressesError$1,
    UserSettingsSvc_JobRoleSaveFailed: UserSettingsSvc_JobRoleSaveFailed$1,
    UserSettingsSvc_NotificationSettingsSaved: UserSettingsSvc_NotificationSettingsSaved$1,
    UserSettingsSvc_NotificationSettingsSavedFailed: UserSettingsSvc_NotificationSettingsSavedFailed$1,
    UserSettingsSvc_NotificationTestSendFailed: UserSettingsSvc_NotificationTestSendFailed$1,
    UserSettingsSvc_NotificationTestSent: UserSettingsSvc_NotificationTestSent$1,
    UserSettingsSvc_NotificationTypeDisplayText106: UserSettingsSvc_NotificationTypeDisplayText106$1,
    UserSettingsSvc_NotificationTypeDisplayText34: UserSettingsSvc_NotificationTypeDisplayText34$1,
    UserSettingsSvc_NotificationTypeDisplayText35: UserSettingsSvc_NotificationTypeDisplayText35$1,
    UserSettingsSvc_NotificationTypeDisplayText37: UserSettingsSvc_NotificationTypeDisplayText37$1,
    UserSettingsSvc_NotificationTypeDisplayText61: UserSettingsSvc_NotificationTypeDisplayText61$1,
    UserSettingsSvc_NotificationTypeDisplayText77: UserSettingsSvc_NotificationTypeDisplayText77$1,
    UserSettingsSvc_PrivacySettingsSaved: UserSettingsSvc_PrivacySettingsSaved$1,
    UserSettingsSvc_PrivacySettingsSaveFailed: UserSettingsSvc_PrivacySettingsSaveFailed$1,
    UserSettingsSvc_SettingsNotPublic: UserSettingsSvc_SettingsNotPublic$1,
    UserSettingsSvc_TryLoggingIn: UserSettingsSvc_TryLoggingIn$1,
    UserProfileSvc_ProblemAccessingCollection: UserProfileSvc_ProblemAccessingCollection$1,
    UserProfileSvc_ProblemAccessingSignalSummary: UserProfileSvc_ProblemAccessingSignalSummary$1,
    UserProfileSvc_ProblemDeletingCollectionItem: UserProfileSvc_ProblemDeletingCollectionItem$1,
    UserProfileSvc_ProblemUpdatingCollectionItem: UserProfileSvc_ProblemUpdatingCollectionItem$1,
    UserProfileSvc_ProblemUpdatingSkillCheckup: UserProfileSvc_ProblemUpdatingSkillCheckup$1,
    UserPrivacyCtrl_Continue: UserPrivacyCtrl_Continue$1,
    UserPrivacyCtrl_Organization: UserPrivacyCtrl_Organization$1,
    UserPrivacyCtrl_PrivacyWarningHeader: UserPrivacyCtrl_PrivacyWarningHeader$1,
    UserPrivacyCtrl_ToOrgProfileFormat: UserPrivacyCtrl_ToOrgProfileFormat$1,
    UserPrivacyCtrl_ToOrgProfileFromAnonymousFormat: UserPrivacyCtrl_ToOrgProfileFromAnonymousFormat$1,
    UserPrivacyCtrl_ToPrivateProfile: UserPrivacyCtrl_ToPrivateProfile$1,
    UserPrivacyCtrl_ToPrivateProfileInOrgFormat: UserPrivacyCtrl_ToPrivateProfileInOrgFormat$1,
    UserPrivacyCtrl_ToPrivateProfileInOrgFromAnonymousFormat: UserPrivacyCtrl_ToPrivateProfileInOrgFromAnonymousFormat$1,
    UserPrivacyCtrl_ToPublicProfile: UserPrivacyCtrl_ToPublicProfile$1,
    UserPrivacyCtrl_ToPublicProfileInOrgFormat: UserPrivacyCtrl_ToPublicProfileInOrgFormat$1,
    UserPrivacyCtrl_ToPublicProfileInOrgFromAnonymousFormat: UserPrivacyCtrl_ToPublicProfileInOrgFromAnonymousFormat$1,
    UserPrivacyCtrl_YourOrganization: UserPrivacyCtrl_YourOrganization$1,
    UserPositionSvc_ExperienceError: UserPositionSvc_ExperienceError$1,
    UserOutcomeSvc_AddingError: UserOutcomeSvc_AddingError$1,
    UserOutcomeSvc_RemovingError: UserOutcomeSvc_RemovingError$1,
    UserOutcomeSvc_RetreivingError: UserOutcomeSvc_RetreivingError$1,
    UserOutcomeSvc_UpdatingError: UserOutcomeSvc_UpdatingError$1,
    UserOutcomeSkillSvc_EightToTen: UserOutcomeSkillSvc_EightToTen$1,
    UserOutcomeSkillSvc_ElevenToFourteen: UserOutcomeSkillSvc_ElevenToFourteen$1,
    UserOutcomeSkillSvc_FifteenToTwenty: UserOutcomeSkillSvc_FifteenToTwenty$1,
    UserOutcomeSkillSvc_FiveToSeven: UserOutcomeSkillSvc_FiveToSeven$1,
    UserOutcomeSkillSvc_TwentyPlus: UserOutcomeSkillSvc_TwentyPlus$1,
    UserOutcomeSkillSvc_TwoToFour: UserOutcomeSkillSvc_TwoToFour$1,
    UserOutcomeSkillSvc_ZeroToOne: UserOutcomeSkillSvc_ZeroToOne$1,
    UserOutcomeDegreeSvc_AddingCoursesError: UserOutcomeDegreeSvc_AddingCoursesError$1,
    UserOutcomeDegreeSvc_Associates: UserOutcomeDegreeSvc_Associates$1,
    UserOutcomeDegreeSvc_Bachelors: UserOutcomeDegreeSvc_Bachelors$1,
    UserOutcomeDegreeSvc_Diploma: UserOutcomeDegreeSvc_Diploma$1,
    UserOutcomeDegreeSvc_Doctorate: UserOutcomeDegreeSvc_Doctorate$1,
    UserOutcomeDegreeSvc_Magister: UserOutcomeDegreeSvc_Magister$1,
    UserOutcomeDegreeSvc_Masters: UserOutcomeDegreeSvc_Masters$1,
    UserOutcomeDegreeSvc_PartialAssociates: UserOutcomeDegreeSvc_PartialAssociates$1,
    UserOutcomeDegreeSvc_PartialBachelors: UserOutcomeDegreeSvc_PartialBachelors$1,
    UserOutcomeDegreeSvc_PartialDoctorate: UserOutcomeDegreeSvc_PartialDoctorate$1,
    UserOutcomeDegreeSvc_PartialMasters: UserOutcomeDegreeSvc_PartialMasters$1,
    UserOutcomeDegreeSvc_PreDiploma: UserOutcomeDegreeSvc_PreDiploma$1,
    UserOrganizationSvc_NotificationError: UserOrganizationSvc_NotificationError$1,
    UserMediaSvc_MediaError: UserMediaSvc_MediaError$1,
    UserInsightsSvc_ErrorLearningCounts: UserInsightsSvc_ErrorLearningCounts$1,
    UserInsightsSvc_ErrorPersonalInfo: UserInsightsSvc_ErrorPersonalInfo$1,
    UserInputsSvc_AccessProfileError: UserInputsSvc_AccessProfileError$1,
    UserInputsSvc_AddToProfileError: UserInputsSvc_AddToProfileError$1,
    UserInputsSvc_DeleteFromProfileError: UserInputsSvc_DeleteFromProfileError$1,
    UserInputsSvc_SuccessfulAddNotifyFormat: UserInputsSvc_SuccessfulAddNotifyFormat$1,
    UserInputsSvc_UpdateProfileError: UserInputsSvc_UpdateProfileError$1,
    UserInputProvidersSvc_ProfileProvidersError: UserInputProvidersSvc_ProfileProvidersError$1,
    UserInputProvidersSvc_ProviderLicensesError: UserInputProvidersSvc_ProviderLicensesError$1,
    UserInfoPartial_BioModalTitle: UserInfoPartial_BioModalTitle$1,
    UserInfoPartial_ChangePrivacySettings: UserInfoPartial_ChangePrivacySettings$1,
    UserInfoPartial_EditProfile: UserInfoPartial_EditProfile$1,
    UserInfoPartial_FollowerCountFormat: UserInfoPartial_FollowerCountFormat$1,
    UserInfoPartial_FollowFormat: UserInfoPartial_FollowFormat$1,
    UserInfoPartial_FollowingCountFormat: UserInfoPartial_FollowingCountFormat$1,
    UserInfoPartial_FoundingScholar: UserInfoPartial_FoundingScholar$1,
    UserInfoPartial_StopFollowingFormat: UserInfoPartial_StopFollowingFormat$1,
    UserInfoPartial_VisibleToMe: UserInfoPartial_VisibleToMe$1,
    UserInfoPartial_VisibleToOrg: UserInfoPartial_VisibleToOrg$1,
    UserInfoPartial_VisibleToPublic: UserInfoPartial_VisibleToPublic$1,
    UserInfoPartial_VisibleToPublicAndOrg: UserInfoPartial_VisibleToPublicAndOrg$1,
    UserGroupsSvc_ProblemAccessingGroup: UserGroupsSvc_ProblemAccessingGroup$1,
    UserEventSvc_EventError: UserEventSvc_EventError$1,
    UserEpisodeSvc_EpisodeError: UserEpisodeSvc_EpisodeError$1,
    UserEmailAddressesSvc_ErrorValidatingEmail: UserEmailAddressesSvc_ErrorValidatingEmail$1,
    UserCourseSvc_CourseError: UserCourseSvc_CourseError$1,
    UserController_Achievements: UserController_Achievements$1,
    UserController_AddEmailAddress: UserController_AddEmailAddress$1,
    UserController_AddingSecondEmail: UserController_AddingSecondEmail$1,
    UserController_AddPersonalEmail: UserController_AddPersonalEmail$1,
    UserController_AddSkills: UserController_AddSkills$1,
    UserController_AddToCollectionDescription: UserController_AddToCollectionDescription$1,
    UserController_AddToCollectionOther: UserController_AddToCollectionOther$1,
    UserController_AddToCollectionSelf: UserController_AddToCollectionSelf$1,
    UserController_BulkEdit: UserController_BulkEdit$1,
    UserController_BulkEditSelectLabel: UserController_BulkEditSelectLabel$1,
    UserController_CaptureLearningFormat: UserController_CaptureLearningFormat$1,
    UserController_CategoryFilter: UserController_CategoryFilter$1,
    UserController_Collection: UserController_Collection$1,
    UserController_CollectionDescription: UserController_CollectionDescription$1,
    UserController_ConnectedEmail: UserController_ConnectedEmail$1,
    UserController_ConsumerPrimaryEmailDesc: UserController_ConsumerPrimaryEmailDesc$1,
    UserController_Content: UserController_Content$1,
    UserController_DashboardTitle: UserController_DashboardTitle$1,
    UserController_DegreedButton: UserController_DegreedButton$1,
    UserController_DegreedGroups: UserController_DegreedGroups$1,
    UserController_Delete: UserController_Delete$1,
    UserController_DeleteProfile: UserController_DeleteProfile$1,
    UserController_EditCategories: UserController_EditCategories$1,
    UserController_EmailAddress: UserController_EmailAddress$1,
    UserController_EmailAddressChangeInfo: UserController_EmailAddressChangeInfo$1,
    UserController_EmailPreferences: UserController_EmailPreferences$1,
    UserController_EmptyProfile: UserController_EmptyProfile$1,
    UserController_EnterEmail: UserController_EnterEmail$1,
    UserController_FilterCollection: UserController_FilterCollection$1,
    UserController_FindLearning: UserController_FindLearning$1,
    UserController_FollowersSubHeading: UserController_FollowersSubHeading$1,
    UserController_FollowersTitle: UserController_FollowersTitle$1,
    UserController_FollowFormat: UserController_FollowFormat$1,
    UserController_FollowingSubHeading: UserController_FollowingSubHeading$1,
    UserController_For: UserController_For$1,
    UserController_GoogleUsernamePlaceholder: UserController_GoogleUsernamePlaceholder$1,
    UserController_GreetingFormat: UserController_GreetingFormat$1,
    UserController_GroupsTitle: UserController_GroupsTitle$1,
    UserController_In: UserController_In$1,
    UserController_Insights: UserController_Insights$1,
    UserController_InviteAll: UserController_InviteAll$1,
    UserController_InviteFriends: UserController_InviteFriends$1,
    UserController_ItemsSelected: UserController_ItemsSelected$1,
    UserController_JoinGroups: UserController_JoinGroups$1,
    UserController_LastName: UserController_LastName$1,
    UserController_Loading: UserController_Loading$1,
    UserController_ManagedProfileMessageFormat: UserController_ManagedProfileMessageFormat$1,
    UserController_NameTaken: UserController_NameTaken$1,
    UserController_NameTakenError: UserController_NameTakenError$1,
    UserController_NoFriends: UserController_NoFriends$1,
    UserController_NoLearningTracked: UserController_NoLearningTracked$1,
    UserController_NoPersonalEmail: UserController_NoPersonalEmail$1,
    UserController_NoResults: UserController_NoResults$1,
    UserController_NoResultsFound: UserController_NoResultsFound$1,
    UserController_NoSkills: UserController_NoSkills$1,
    UserController_NothingCompleted: UserController_NothingCompleted$1,
    UserController_NotificationEmailInfoFormat: UserController_NotificationEmailInfoFormat$1,
    UserController_NotificationSettings: UserController_NotificationSettings$1,
    UserController_Opportunities: UserController_Opportunities$1,
    UserController_Overview: UserController_Overview$1,
    UserController_Pathways: UserController_Pathways$1,
    UserController_PersonalEmail: UserController_PersonalEmail$1,
    UserController_PersonalEmailEnableOptions: UserController_PersonalEmailEnableOptions$1,
    UserController_PersonalEmailError: UserController_PersonalEmailError$1,
    UserController_PersonalEmailOptions: UserController_PersonalEmailOptions$1,
    UserController_PostAComment: UserController_PostAComment$1,
    UserController_PrimaryEmailDesc: UserController_PrimaryEmailDesc$1,
    UserController_PrivateProfile: UserController_PrivateProfile$1,
    UserController_PrivateProfileExplanation: UserController_PrivateProfileExplanation$1,
    UserController_Profile: UserController_Profile$1,
    UserController_Progression: UserController_Progression$1,
    UserController_QueueTitle: UserController_QueueTitle$1,
    UserController_RecommendationsTitle: UserController_RecommendationsTitle$1,
    UserController_RequiredAssigned: UserController_RequiredAssigned$1,
    UserController_RequiredAssignedCount: UserController_RequiredAssignedCount$1,
    UserController_RequiredLearningTitle: UserController_RequiredLearningTitle$1,
    UserController_Saved: UserController_Saved$1,
    UserController_SaveSettingsErrorMessage: UserController_SaveSettingsErrorMessage$1,
    UserController_ScoreYourEducation: UserController_ScoreYourEducation$1,
    UserController_SecondaryEmailDesc: UserController_SecondaryEmailDesc$1,
    UserController_SelectAll: UserController_SelectAll$1,
    UserController_SelectLoginEmail: UserController_SelectLoginEmail$1,
    UserController_ShortQueueTitle: UserController_ShortQueueTitle$1,
    UserController_ShowHowFarFormat: UserController_ShowHowFarFormat$1,
    UserController_ShowLess: UserController_ShowLess$1,
    UserController_ShowMore: UserController_ShowMore$1,
    UserController_Skills: UserController_Skills$1,
    UserController_StepFour: UserController_StepFour$1,
    UserController_StepOne: UserController_StepOne$1,
    UserController_StepThree: UserController_StepThree$1,
    UserController_StepTwo: UserController_StepTwo$1,
    UserController_StopFollowingFormat: UserController_StopFollowingFormat$1,
    UserController_ThisUserPrivate: UserController_ThisUserPrivate$1,
    UserController_TodaysLearningFeedTitle: UserController_TodaysLearningFeedTitle$1,
    UserController_TodaysLearningTitle: UserController_TodaysLearningTitle$1,
    UserController_TrackLearningAltTag: UserController_TrackLearningAltTag$1,
    UserController_TryHere: UserController_TryHere$1,
    UserController_TurnOnIntegration: UserController_TurnOnIntegration$1,
    UserController_TwitterUsername: UserController_TwitterUsername$1,
    UserController_Type: UserController_Type$1,
    UserController_Unsubscribe: UserController_Unsubscribe$1,
    UserController_UnsubscribeWarning: UserController_UnsubscribeWarning$1,
    UserController_UnsubTitle: UserController_UnsubTitle$1,
    UserController_UpdateAccount: UserController_UpdateAccount$1,
    UserController_Verified: UserController_Verified$1,
    UserController_Verify: UserController_Verify$1,
    UserController_VerifyOwnership: UserController_VerifyOwnership$1,
    UserBookSvc_BookAccessError: UserBookSvc_BookAccessError$1,
    UserBookSvc_BookAddError: UserBookSvc_BookAddError$1,
    UserBookSvc_BookUpdateError: UserBookSvc_BookUpdateError$1,
    UserAssessmentSvc_AssessmentsError: UserAssessmentSvc_AssessmentsError$1,
    "User-AddedExternalSkillsChart_Column_Added": "Added",
    "User-AddedExternalSkillsChart_Column_SkillName": "Skill Name",
    "User-AddedExternalSkillsChart_Column_Source": "Source",
    "User-AddedExternalSkillsChart_Title": "User-Added External Skills",
    "User-AddedExternalSkillsChart_TooltipText": "Skills added to the users profile that are non-org managed skills.",
    User_Account: User_Account$1,
    User_AdditionalContentLanguages: User_AdditionalContentLanguages$1,
    User_BioLabel: User_BioLabel$1,
    User_CategoryExample: User_CategoryExample$1,
    User_CategoryExplanation: User_CategoryExplanation$1,
    User_CategoryQuestion: User_CategoryQuestion$1,
    User_ChangePassword: User_ChangePassword$1,
    User_CharactersRemaining: User_CharactersRemaining$1,
    User_Communications: User_Communications$1,
    User_ContentLanguage: User_ContentLanguage$1,
    User_DailyDigestA11yHelpText: User_DailyDigestA11yHelpText$1,
    User_DeleteProfile: User_DeleteProfile$1,
    User_DisplayLanguage: User_DisplayLanguage$1,
    User_Email: User_Email$1,
    User_EmailCommunicationsDesc: User_EmailCommunicationsDesc$1,
    User_EmailNotificationsDesc: User_EmailNotificationsDesc$1,
    User_EmailNotificationsLabel: User_EmailNotificationsLabel$1,
    User_EmailUpdatesDesc: User_EmailUpdatesDesc$1,
    User_EmailUpdatesLabel: User_EmailUpdatesLabel$1,
    User_Extensions: User_Extensions$1,
    User_Family: User_Family$1,
    User_FamilyAccountAdd: User_FamilyAccountAdd$1,
    User_FamilyAccountCreateError: User_FamilyAccountCreateError$1,
    User_FamilyAccountCreateSuccess: User_FamilyAccountCreateSuccess$1,
    User_FamilyAccountGetError: User_FamilyAccountGetError$1,
    User_FamilyAccountInstructions: User_FamilyAccountInstructions$1,
    User_FamilyAccountsHeader: User_FamilyAccountsHeader$1,
    User_FamilyCreateAccountFormat: User_FamilyCreateAccountFormat$1,
    User_FamilyEmptyStateHeader: User_FamilyEmptyStateHeader$1,
    User_FamilyLegendFormat: User_FamilyLegendFormat$1,
    User_FamilyPasswordLabel: User_FamilyPasswordLabel$1,
    User_FamilyProgramLabel: User_FamilyProgramLabel$1,
    User_FamilyUsernameLabelFormat: User_FamilyUsernameLabelFormat$1,
    User_FirstNameLabel: User_FirstNameLabel$1,
    User_Integrations: User_Integrations$1,
    User_LanguageExplanation: User_LanguageExplanation$1,
    User_LastNameLabel: User_LastNameLabel$1,
    User_LocationLabel: User_LocationLabel$1,
    User_ManagedProfileMessageFormat: User_ManagedProfileMessageFormat$1,
    User_Notifications: User_Notifications$1,
    User_NotificationsA11yHelpText: User_NotificationsA11yHelpText$1,
    User_PageTitle: User_PageTitle$1,
    User_Personal: User_Personal$1,
    User_PreferenceSurveysDescription: User_PreferenceSurveysDescription$1,
    User_PreferenceSurveysTitle: User_PreferenceSurveysTitle$1,
    User_PreferenceTipsDescription: User_PreferenceTipsDescription$1,
    User_PreferenceTipsTitle: User_PreferenceTipsTitle$1,
    User_PreferredContent: User_PreferredContent$1,
    User_Profile: User_Profile$1,
    User_ProfileName: User_ProfileName$1,
    User_ProfilePrivacyLabel: User_ProfilePrivacyLabel$1,
    User_ProfileUrlExplanation: User_ProfileUrlExplanation$1,
    User_ResetOnboarding: User_ResetOnboarding$1,
    User_SaveSettings: User_SaveSettings$1,
    User_SystemLanguage: User_SystemLanguage$1,
    User_SystemLanguageExplanation: User_SystemLanguageExplanation$1,
    User_UpdatesA11yHelpText: User_UpdatesA11yHelpText$1,
    UserEmailAddress_VerificationSuccessful: UserEmailAddress_VerificationSuccessful$1,
    UserEvaluationEndorsementCompleted_NotificationTitleFormat: UserEvaluationEndorsementCompleted_NotificationTitleFormat$1,
    UserEvaluationEndorsementRequested_NotificationTitleFormat: UserEvaluationEndorsementRequested_NotificationTitleFormat$1,
    UserGoalsSvc_GoalAccessError: UserGoalsSvc_GoalAccessError$1,
    UserGoalsSvc_GoalExistsError: UserGoalsSvc_GoalExistsError$1,
    UserInputsController_Praise1: UserInputsController_Praise1$1,
    UserInputsController_Praise2: UserInputsController_Praise2$1,
    UserInputsController_Praise3: UserInputsController_Praise3$1,
    UserInputsController_Praise4: UserInputsController_Praise4$1,
    UserInputsController_Praise5: UserInputsController_Praise5$1,
    UserInputsController_Praise6: UserInputsController_Praise6$1,
    UserInputsController_Praise7: UserInputsController_Praise7$1,
    UserInputsController_Reward1AccomplishmentPluralFormat: UserInputsController_Reward1AccomplishmentPluralFormat$1,
    UserInputsController_Reward1AccomplishmentSingular: UserInputsController_Reward1AccomplishmentSingular$1,
    UserInputsController_Reward1ArticlePluralFormat: UserInputsController_Reward1ArticlePluralFormat$1,
    UserInputsController_Reward1ArticleSingular: UserInputsController_Reward1ArticleSingular$1,
    UserInputsController_Reward1AssessmentPluralFormat: UserInputsController_Reward1AssessmentPluralFormat$1,
    UserInputsController_Reward1AssessmentSingular: UserInputsController_Reward1AssessmentSingular$1,
    UserInputsController_Reward1AwardPluralFormat: UserInputsController_Reward1AwardPluralFormat$1,
    UserInputsController_Reward1AwardSingular: UserInputsController_Reward1AwardSingular$1,
    UserInputsController_Reward1BadgePluralFormat: UserInputsController_Reward1BadgePluralFormat$1,
    UserInputsController_Reward1BadgeSingular: UserInputsController_Reward1BadgeSingular$1,
    UserInputsController_Reward1BookPluralFormat: UserInputsController_Reward1BookPluralFormat$1,
    UserInputsController_Reward1BookSingular: UserInputsController_Reward1BookSingular$1,
    UserInputsController_Reward1CertificatePluralFormat: UserInputsController_Reward1CertificatePluralFormat$1,
    UserInputsController_Reward1CertificateSingular: UserInputsController_Reward1CertificateSingular$1,
    UserInputsController_Reward1CoursePluralFormat: UserInputsController_Reward1CoursePluralFormat$1,
    UserInputsController_Reward1CourseSingular: UserInputsController_Reward1CourseSingular$1,
    UserInputsController_Reward1DegreePluralFormat: UserInputsController_Reward1DegreePluralFormat$1,
    UserInputsController_Reward1DegreeSingular: UserInputsController_Reward1DegreeSingular$1,
    UserInputsController_Reward1EpisodePluralFormat: UserInputsController_Reward1EpisodePluralFormat$1,
    UserInputsController_Reward1EpisodeSingular: UserInputsController_Reward1EpisodeSingular$1,
    UserInputsController_Reward1EventPluralFormat: UserInputsController_Reward1EventPluralFormat$1,
    UserInputsController_Reward1EventSingular: UserInputsController_Reward1EventSingular$1,
    UserInputsController_Reward1ItemPluralFormat: UserInputsController_Reward1ItemPluralFormat$1,
    UserInputsController_Reward1ItemSingular: UserInputsController_Reward1ItemSingular$1,
    UserInputsController_Reward1PositionPluralFormat: UserInputsController_Reward1PositionPluralFormat$1,
    UserInputsController_Reward1PositionSingular: UserInputsController_Reward1PositionSingular$1,
    UserInputsController_Reward1SkillPluralFormat: UserInputsController_Reward1SkillPluralFormat$1,
    UserInputsController_Reward1SkillSingular: UserInputsController_Reward1SkillSingular$1,
    UserInputsController_Reward1VideoPluralFormat: UserInputsController_Reward1VideoPluralFormat$1,
    UserInputsController_Reward1VideoSingular: UserInputsController_Reward1VideoSingular$1,
    UserInputsController_Reward2AccomplishmentPluralFormat: UserInputsController_Reward2AccomplishmentPluralFormat$1,
    UserInputsController_Reward2AccomplishmentSingular: UserInputsController_Reward2AccomplishmentSingular$1,
    UserInputsController_Reward2ArticlePluralFormat: UserInputsController_Reward2ArticlePluralFormat$1,
    UserInputsController_Reward2ArticleSingular: UserInputsController_Reward2ArticleSingular$1,
    UserInputsController_Reward2AssessmentPluralFormat: UserInputsController_Reward2AssessmentPluralFormat$1,
    UserInputsController_Reward2AssessmentSingular: UserInputsController_Reward2AssessmentSingular$1,
    UserInputsController_Reward2AwardPluralFormat: UserInputsController_Reward2AwardPluralFormat$1,
    UserInputsController_Reward2AwardSingular: UserInputsController_Reward2AwardSingular$1,
    UserInputsController_Reward2BadgePluralFormat: UserInputsController_Reward2BadgePluralFormat$1,
    UserInputsController_Reward2BadgeSingular: UserInputsController_Reward2BadgeSingular$1,
    UserInputsController_Reward2BookPluralFormat: UserInputsController_Reward2BookPluralFormat$1,
    UserInputsController_Reward2BookSingular: UserInputsController_Reward2BookSingular$1,
    UserInputsController_Reward2CertificatePluralFormat: UserInputsController_Reward2CertificatePluralFormat$1,
    UserInputsController_Reward2CertificateSingular: UserInputsController_Reward2CertificateSingular$1,
    UserInputsController_Reward2CoursePluralFormat: UserInputsController_Reward2CoursePluralFormat$1,
    UserInputsController_Reward2CourseSingular: UserInputsController_Reward2CourseSingular$1,
    UserInputsController_Reward2DegreePluralFormat: UserInputsController_Reward2DegreePluralFormat$1,
    UserInputsController_Reward2DegreeSingular: UserInputsController_Reward2DegreeSingular$1,
    UserInputsController_Reward2EpisodePluralFormat: UserInputsController_Reward2EpisodePluralFormat$1,
    UserInputsController_Reward2EpisodeSingular: UserInputsController_Reward2EpisodeSingular$1,
    UserInputsController_Reward2EventPluralFormat: UserInputsController_Reward2EventPluralFormat$1,
    UserInputsController_Reward2EventSingular: UserInputsController_Reward2EventSingular$1,
    UserInputsController_Reward2ItemPluralFormat: UserInputsController_Reward2ItemPluralFormat$1,
    UserInputsController_Reward2ItemSingular: UserInputsController_Reward2ItemSingular$1,
    UserInputsController_Reward2PositionPluralFormat: UserInputsController_Reward2PositionPluralFormat$1,
    UserInputsController_Reward2PositionSingular: UserInputsController_Reward2PositionSingular$1,
    UserInputsController_Reward2SkillPluralFormat: UserInputsController_Reward2SkillPluralFormat$1,
    UserInputsController_Reward2SkillSingular: UserInputsController_Reward2SkillSingular$1,
    UserInputsController_Reward2VideoPluralFormat: UserInputsController_Reward2VideoPluralFormat$1,
    UserInputsController_Reward2VideoSingular: UserInputsController_Reward2VideoSingular$1,
    Uploader_Canceled: Uploader_Canceled$1,
    Uploader_Completed: Uploader_Completed$1,
    Uploader_DefaultLimitNotice_Size: Uploader_DefaultLimitNotice_Size$1,
    Uploader_DefaultLimitNotice_Type: Uploader_DefaultLimitNotice_Type$1,
    Uploader_DefaultLimitNotice_TypeAndSize: Uploader_DefaultLimitNotice_TypeAndSize$1,
    Uploader_FileTypeError: Uploader_FileTypeError$1,
    Uploader_SizeLimitMet: Uploader_SizeLimitMet$1,
    Uploader_UnknownError: Uploader_UnknownError$1,
    unsubscribeTemplate_ChangeSettings: unsubscribeTemplate_ChangeSettings$1,
    TrackableLinkCtrl_AutoEnroll: TrackableLinkCtrl_AutoEnroll$1,
    TrackableLinkCtrl_CopiedLink: TrackableLinkCtrl_CopiedLink$1,
    TrackableLinkCtrl_CopyLink: TrackableLinkCtrl_CopyLink$1,
    TrackableLinkCtrl_CopyLinkAgain: TrackableLinkCtrl_CopyLinkAgain$1,
    TrackableLinkCtrl_DeleteLinkModalBodyText: TrackableLinkCtrl_DeleteLinkModalBodyText$1,
    TrackableLinkCtrl_DeleteLinkModalHeader: TrackableLinkCtrl_DeleteLinkModalHeader$1,
    TrackableLinkCtrl_EditModalTitle: TrackableLinkCtrl_EditModalTitle$1,
    TrackableLinkCtrl_FormTitle: TrackableLinkCtrl_FormTitle$1,
    TrackableLinkCtrl_FormTitlePlaceholder: TrackableLinkCtrl_FormTitlePlaceholder$1,
    TrackableLinkCtrl_LinkDescription: TrackableLinkCtrl_LinkDescription$1,
    TrackableLinkCtrl_ModalTitle: TrackableLinkCtrl_ModalTitle$1,
    TrackableLinkCtrl_NewLink: TrackableLinkCtrl_NewLink$1,
    TrackableLinkCtrl_StartTracking: TrackableLinkCtrl_StartTracking$1,
    TrackableLinkCtrl_TableHeaderClicks: TrackableLinkCtrl_TableHeaderClicks$1,
    TrackableLinkCtrl_TableHeaderCreator: TrackableLinkCtrl_TableHeaderCreator$1,
    TrackableLinkCtrl_TableHeaderDate: TrackableLinkCtrl_TableHeaderDate$1,
    TrackableLinkCtrl_TableHeaderEnrolls: TrackableLinkCtrl_TableHeaderEnrolls$1,
    TrackableLinkCtrl_TableHeaderLink: TrackableLinkCtrl_TableHeaderLink$1,
    TrackableLinkCtrl_Title: TrackableLinkCtrl_Title$1,
    TrackableLinkCtrl_TitleCreated: TrackableLinkCtrl_TitleCreated$1,
    TopCompletionsChart_CatalogTypeAllProviders: TopCompletionsChart_CatalogTypeAllProviders$1,
    TopCompletionsChart_CatalogTypeCatalog: TopCompletionsChart_CatalogTypeCatalog$1,
    TopCompletionsChart_CatalogTypeExternalCatalogProviders: TopCompletionsChart_CatalogTypeExternalCatalogProviders$1,
    TopCompletionsChart_CatalogTypeInternalCatalogProviders: TopCompletionsChart_CatalogTypeInternalCatalogProviders$1,
    TopCompletionsChart_CatalogTypeLearner: TopCompletionsChart_CatalogTypeLearner$1,
    TopCompletionsChart_CompletionsColumn: TopCompletionsChart_CompletionsColumn$1,
    TopCompletionsChart_NameColumn: TopCompletionsChart_NameColumn$1,
    TopCompletionsChart_NameFormat: TopCompletionsChart_NameFormat$1,
    TopCompletionsChart_NoResults: TopCompletionsChart_NoResults$1,
    TipSvc_OnboardError: TipSvc_OnboardError$1,
    TipSvc_OnboardResetSuccess: TipSvc_OnboardResetSuccess$1,
    TipSvc_SavedItemsModal: TipSvc_SavedItemsModal$1,
    TipSvc_SavedItemsModalHome: TipSvc_SavedItemsModalHome$1,
    TipSvc_ViewSavedItems: TipSvc_ViewSavedItems$1,
    TeamInsights_SpiderChart_BottomText: TeamInsights_SpiderChart_BottomText$1,
    TeamInsights_SpiderChart_LegendTitle: TeamInsights_SpiderChart_LegendTitle$1,
    TeamInsights_SpiderChart_RadarTitle: TeamInsights_SpiderChart_RadarTitle$1,
    Team_AllReports: Team_AllReports$1,
    Team_AllTeamMembers: Team_AllTeamMembers$1,
    Team_AssignmentEmailBodyDueSoon: Team_AssignmentEmailBodyDueSoon$1,
    Team_AssignmentEmailBodyOverdue: Team_AssignmentEmailBodyOverdue$1,
    Team_AssignmentLink: Team_AssignmentLink$1,
    Team_AssignmentName: Team_AssignmentName$1,
    Team_AssignmentNameDueSoon: Team_AssignmentNameDueSoon$1,
    Team_AssignmentNameOverdue: Team_AssignmentNameOverdue$1,
    Team_AssignmentReminder: Team_AssignmentReminder$1,
    Team_AssignmentReminders: Team_AssignmentReminders$1,
    Team_Assignments: Team_Assignments$1,
    Team_AssignmentsDueSoonDesc: Team_AssignmentsDueSoonDesc$1,
    Team_AssignmentsIncompleteDesc: Team_AssignmentsIncompleteDesc$1,
    Team_AssignmentsOverdueDesc: Team_AssignmentsOverdueDesc$1,
    Team_Chart_Disclaimer: Team_Chart_Disclaimer$1,
    Team_Chart_FullScreenText: Team_Chart_FullScreenText$1,
    Team_CompletionDetails: Team_CompletionDetails$1,
    Team_ContactAssignor: Team_ContactAssignor$1,
    Team_CountMandatory: Team_CountMandatory$1,
    Team_CountMandatorySingular: Team_CountMandatorySingular$1,
    Team_CountRequired: Team_CountRequired$1,
    Team_CountRequiredSingular: Team_CountRequiredSingular$1,
    Team_CustomEmailMessage: Team_CustomEmailMessage$1,
    Team_Customizable: Team_Customizable$1,
    Team_DirectReportsOnly: Team_DirectReportsOnly$1,
    Team_DismissAssignment: Team_DismissAssignment$1,
    Team_DismissAssignmentDesc: Team_DismissAssignmentDesc$1,
    Team_ErrorLoadingManagers: Team_ErrorLoadingManagers$1,
    Team_FilterbySkillsFilter_Title: Team_FilterbySkillsFilter_Title$1,
    Team_FocusFilterDisabledTooltip: Team_FocusFilterDisabledTooltip$1,
    Team_FocusFilterNoResultsTooltip: Team_FocusFilterNoResultsTooltip$1,
    Team_FocusLabel: Team_FocusLabel$1,
    Team_FocusSkills_Add: Team_FocusSkills_Add$1,
    Team_FocusSkills_AddFormat: Team_FocusSkills_AddFormat$1,
    Team_FocusSkills_Remove: Team_FocusSkills_Remove$1,
    Team_FocusSkills_RemoveFormat: Team_FocusSkills_RemoveFormat$1,
    Team_Group_Shared_And_Private_Message: Team_Group_Shared_And_Private_Message$1,
    Team_Insights_ActiveLearnerTitle: Team_Insights_ActiveLearnerTitle$1,
    Team_Insights_ActiveLearnerTooltip: Team_Insights_ActiveLearnerTooltip$1,
    Team_Insights_AssignedLearnings_Empty_Message: Team_Insights_AssignedLearnings_Empty_Message$1,
    Team_Insights_AssignedLearningsTitle: Team_Insights_AssignedLearningsTitle$1,
    Team_Insights_AverageCompletions_Label: Team_Insights_AverageCompletions_Label$1,
    Team_Insights_AveragePoints_Label: Team_Insights_AveragePoints_Label$1,
    Team_Insights_AveragePoints_Tooltip: Team_Insights_AveragePoints_Tooltip$1,
    Team_Insights_AveragePointsEarned_Label: Team_Insights_AveragePointsEarned_Label$1,
    Team_Insights_AvgCompletions_Label: Team_Insights_AvgCompletions_Label$1,
    Team_Insights_AvgCompletions_Tooltip: Team_Insights_AvgCompletions_Tooltip$1,
    Team_Insights_AvgPointsEarned_Label: Team_Insights_AvgPointsEarned_Label$1,
    Team_Insights_AvgPointsEarned_Tooltip: Team_Insights_AvgPointsEarned_Tooltip$1,
    Team_Insights_PopularSkillsTitle: Team_Insights_PopularSkillsTitle$1,
    Team_Insights_PopularSkillsTooltip: Team_Insights_PopularSkillsTooltip$1,
    Team_Insights_Range_Last30Days: Team_Insights_Range_Last30Days$1,
    Team_Insights_TotalCompletions_Label: Team_Insights_TotalCompletions_Label$1,
    Team_Insights_TotalCompletions_Tooltip: Team_Insights_TotalCompletions_Tooltip$1,
    Team_Insights_TotalPoints_Label: Team_Insights_TotalPoints_Label$1,
    Team_Insights_TotalPoints_Tooltip: Team_Insights_TotalPoints_Tooltip$1,
    Team_Insights_View_Assignment_Aria: Team_Insights_View_Assignment_Aria$1,
    Team_Insights_ViewAssignment: Team_Insights_ViewAssignment$1,
    Team_InsightSkills_NoSkillRating: Team_InsightSkills_NoSkillRating$1,
    Team_JobRelatedSkills: Team_JobRelatedSkills$1,
    Team_LearnerName: Team_LearnerName$1,
    Team_LearningInsights: Team_LearningInsights$1,
    Team_ManagerName: Team_ManagerName$1,
    Team_MSTeamsNotification: Team_MSTeamsNotification$1,
    Team_MyTeam: Team_MyTeam$1,
    Team_NewAssignment: Team_NewAssignment$1,
    Team_NoAssignments: Team_NoAssignments$1,
    Team_NoAssignmentsDesc: Team_NoAssignmentsDesc$1,
    Team_NoRating: Team_NoRating$1,
    Team_NotOnProfile: Team_NotOnProfile$1,
    Team_OptOutAutoDescription: Team_OptOutAutoDescription$1,
    Team_OptOutMessage: Team_OptOutMessage$1,
    Team_OptOutTitleModal: Team_OptOutTitleModal$1,
    Team_PleaseCompleteDueSoon: Team_PleaseCompleteDueSoon$1,
    Team_PleaseCompleteOverdue: Team_PleaseCompleteOverdue$1,
    Team_RatedJobSkills: Team_RatedJobSkills$1,
    Team_RatedSkillsHeader_Tooltip: Team_RatedSkillsHeader_Tooltip$1,
    Team_Rating_History_SetRating: Team_Rating_History_SetRating$1,
    Team_Recipients: Team_Recipients$1,
    Team_RecommendationSent: Team_RecommendationSent$1,
    Team_RecommendSkills_ButtonText: Team_RecommendSkills_ButtonText$1,
    Team_ReminderSent: Team_ReminderSent$1,
    Team_RemindersSent: Team_RemindersSent$1,
    Team_ReminderTypes: Team_ReminderTypes$1,
    Team_ScreenReader_Chart_Description_SkillSpiderChart: Team_ScreenReader_Chart_Description_SkillSpiderChart$1,
    Team_SelectRecipient: Team_SelectRecipient$1,
    Team_SelectReminder: Team_SelectReminder$1,
    Team_SelectReminderType: Team_SelectReminderType$1,
    Team_SendReminder: Team_SendReminder$1,
    Team_SendReminders: Team_SendReminders$1,
    Team_SkillInsights: Team_SkillInsights$1,
    Team_SkillProfile: Team_SkillProfile$1,
    Team_Skills: Team_Skills$1,
    Team_Skills_AverageRatingAction: Team_Skills_AverageRatingAction$1,
    Team_Skills_FocusSkill_MaxLimit: Team_Skills_FocusSkill_MaxLimit$1,
    Team_Skills_FocusSkillAction: Team_Skills_FocusSkillAction$1,
    Team_Skills_FocusSkillAction_Singular: Team_Skills_FocusSkillAction_Singular$1,
    Team_Skills_OnProfile: Team_Skills_OnProfile$1,
    Team_Skills_OnProfileAction: Team_Skills_OnProfileAction$1,
    Team_Skills_OnProfileAction_Singular: Team_Skills_OnProfileAction_Singular$1,
    Team_Skills_OpenRatingListModal: Team_Skills_OpenRatingListModal$1,
    Team_Skills_OptInToggle_MoM_Off: Team_Skills_OptInToggle_MoM_Off$1,
    Team_Skills_OptInToggle_MoM_On: Team_Skills_OptInToggle_MoM_On$1,
    Team_Skills_RatingCount: Team_Skills_RatingCount$1,
    Team_Skills_RatingCountAction: Team_Skills_RatingCountAction$1,
    Team_Skills_RemoveFocusSkill_Success: Team_Skills_RemoveFocusSkill_Success$1,
    Team_Skills_SetFocusSkill_Failure: Team_Skills_SetFocusSkill_Failure$1,
    Team_Skills_SetFocusSkill_Success: Team_Skills_SetFocusSkill_Success$1,
    Team_Skills_SkillChangePublished_NotificationContent: Team_Skills_SkillChangePublished_NotificationContent$1,
    Team_Skills_VisibilityTooltip: Team_Skills_VisibilityTooltip$1,
    Team_Skills_VisibilityTooltip_NoMoManager: Team_Skills_VisibilityTooltip_NoMoManager$1,
    Team_SpiderChart_BottomText: Team_SpiderChart_BottomText$1,
    Team_SpiderChart_LegendTitle: Team_SpiderChart_LegendTitle$1,
    Team_SpiderChart_PointLabel: Team_SpiderChart_PointLabel$1,
    Team_SpiderChart_RadarTitle: Team_SpiderChart_RadarTitle$1,
    Team_SubjectAssignmentNameDueSoon: Team_SubjectAssignmentNameDueSoon$1,
    Team_SubjectAssignmentNameOverdue: Team_SubjectAssignmentNameOverdue$1,
    Team_TeamFocusSkillTooltip: Team_TeamFocusSkillTooltip$1,
    Team_TeamFormat: Team_TeamFormat$1,
    Team_TeamMembers: Team_TeamMembers$1,
    Team_ThankYou: Team_ThankYou$1,
    Team_UpdateManagerRatingSuccessMessage: Team_UpdateManagerRatingSuccessMessage$1,
    Team_UpdatePeerRatingSuccessMessage: Team_UpdatePeerRatingSuccessMessage$1,
    Team_UpdateSkillTargetSuccessMessage: Team_UpdateSkillTargetSuccessMessage$1,
    Team_ViewReports: Team_ViewReports$1,
    Team_ViewSkillsProfile: Team_ViewSkillsProfile$1,
    Team_WelcomeBanner_Description: Team_WelcomeBanner_Description$1,
    Team_WelcomeBanner_Title: Team_WelcomeBanner_Title$1,
    TaskFormCtrl_Add: TaskFormCtrl_Add$1,
    TaskFormCtrl_AddImage: TaskFormCtrl_AddImage$1,
    TaskFormCtrl_AddToCatalogFormat: TaskFormCtrl_AddToCatalogFormat$1,
    TaskFormCtrl_Description: TaskFormCtrl_Description$1,
    TaskFormCtrl_Edit: TaskFormCtrl_Edit$1,
    TaskFormCtrl_ImagePreviewAltText: TaskFormCtrl_ImagePreviewAltText$1,
    TaskFormCtrl_Save: TaskFormCtrl_Save$1,
    TaskFormCtrl_Site: TaskFormCtrl_Site$1,
    TaskFormCtrl_Title: TaskFormCtrl_Title$1,
    TaskFormCtrl_TitleError: TaskFormCtrl_TitleError$1,
    TaskFormCtrl_Url: TaskFormCtrl_Url$1,
    TaskFormCtrl_ValidUrl: TaskFormCtrl_ValidUrl$1,
    TaskFormCtrl_WhatDidYouLearnLong: TaskFormCtrl_WhatDidYouLearnLong$1,
    TaskFormCtrl_WhatDidYouLearnShort: TaskFormCtrl_WhatDidYouLearnShort$1,
    TargetsSvc_AddAuthorError: TargetsSvc_AddAuthorError$1,
    TargetsSvc_AddError: TargetsSvc_AddError$1,
    TargetsSvc_AddResourceError: TargetsSvc_AddResourceError$1,
    TargetsSvc_AddSectionError: TargetsSvc_AddSectionError$1,
    TargetsSvc_AddSuccess: TargetsSvc_AddSuccess$1,
    TargetsSvc_CloneError: TargetsSvc_CloneError$1,
    TargetsSvc_CloneSuccess: TargetsSvc_CloneSuccess$1,
    TargetsSvc_DeleteAuthorError: TargetsSvc_DeleteAuthorError$1,
    TargetsSvc_DeleteError: TargetsSvc_DeleteError$1,
    TargetsSvc_DeleteResourceError: TargetsSvc_DeleteResourceError$1,
    TargetsSvc_DeleteSuccess: TargetsSvc_DeleteSuccess$1,
    TargetsSvc_DetailsError: TargetsSvc_DetailsError$1,
    TargetsSvc_Error: TargetsSvc_Error$1,
    TargetsSvc_FeaturedError: TargetsSvc_FeaturedError$1,
    TargetsSvc_FollowError: TargetsSvc_FollowError$1,
    TargetsSvc_GetUserError: TargetsSvc_GetUserError$1,
    TargetsSvc_MakeFeaturedNotification: TargetsSvc_MakeFeaturedNotification$1,
    TargetsSvc_RemoveFeaturedNotification: TargetsSvc_RemoveFeaturedNotification$1,
    TargetsSvc_ReorderResourceError: TargetsSvc_ReorderResourceError$1,
    TargetsSvc_RetrieveError: TargetsSvc_RetrieveError$1,
    TargetsSvc_SetNotVisibleSuccess: TargetsSvc_SetNotVisibleSuccess$1,
    TargetsSvc_SetTargetNameError: TargetsSvc_SetTargetNameError$1,
    TargetsSvc_SetVisibleSuccess: TargetsSvc_SetVisibleSuccess$1,
    TargetsSvc_SuggestionError: TargetsSvc_SuggestionError$1,
    TargetsSvc_TargetLevelError: TargetsSvc_TargetLevelError$1,
    TargetsSvc_TypeBrowse: TargetsSvc_TypeBrowse$1,
    TargetsSvc_TypeBrowse_Specific: TargetsSvc_TypeBrowse_Specific$1,
    TargetsSvc_TypeDirectory: TargetsSvc_TypeDirectory$1,
    TargetsSvc_TypeDirectory_Specific: TargetsSvc_TypeDirectory_Specific$1,
    TargetsSvc_TypeDirectorys: TargetsSvc_TypeDirectorys$1,
    TargetsSvc_TypeDirectorys_Specific: TargetsSvc_TypeDirectorys_Specific$1,
    TargetsSvc_TypeFeatured_Specific: TargetsSvc_TypeFeatured_Specific$1,
    TargetsSvc_TypeJobRole: TargetsSvc_TypeJobRole$1,
    TargetsSvc_TypeJobRole_Specific: TargetsSvc_TypeJobRole_Specific$1,
    TargetsSvc_TypeJobRoles: TargetsSvc_TypeJobRoles$1,
    TargetsSvc_TypeJobRoles_Specific: TargetsSvc_TypeJobRoles_Specific$1,
    TargetsSvc_TypeRole: TargetsSvc_TypeRole$1,
    TargetsSvc_TypeRole_Specific: TargetsSvc_TypeRole_Specific$1,
    TargetsSvc_TypeRoles: TargetsSvc_TypeRoles$1,
    TargetsSvc_TypeRoles_Specific: TargetsSvc_TypeRoles_Specific$1,
    TargetsSvc_TypeSkillPlan: TargetsSvc_TypeSkillPlan$1,
    TargetsSvc_TypeSkillPlan_Specific: TargetsSvc_TypeSkillPlan_Specific$1,
    TargetsSvc_TypeSkillPlans: TargetsSvc_TypeSkillPlans$1,
    TargetsSvc_TypeSkillPlans_Specific: TargetsSvc_TypeSkillPlans_Specific$1,
    TargetsSvc_TypeTarget: TargetsSvc_TypeTarget$1,
    TargetsSvc_TypeTarget_Specific: TargetsSvc_TypeTarget_Specific$1,
    TargetsSvc_TypeTargets: TargetsSvc_TypeTargets$1,
    TargetsSvc_TypeTargets_Specific: TargetsSvc_TypeTargets_Specific$1,
    TargetsSvc_UnfollowError: TargetsSvc_UnfollowError$1,
    TargetsSvc_UpdateAuthorsError: TargetsSvc_UpdateAuthorsError$1,
    TargetsSvc_UpdateError: TargetsSvc_UpdateError$1,
    TargetsSvc_UpdateSuccess: TargetsSvc_UpdateSuccess$1,
    TargetsSvc_UpdateVisibilityError: TargetsSvc_UpdateVisibilityError$1,
    TargetsSvc_UsersTitle: TargetsSvc_UsersTitle$1,
    TargetsCtrl_BulkChangeVisibility: TargetsCtrl_BulkChangeVisibility$1,
    TargetsCtrl_BulkChangeVisibilityPlural: TargetsCtrl_BulkChangeVisibilityPlural$1,
    TargetsCtrl_DeletePluralPrompt: TargetsCtrl_DeletePluralPrompt$1,
    TargetsCtrl_DeletePrompt: TargetsCtrl_DeletePrompt$1,
    Targets_MoveConfirmationMessage: Targets_MoveConfirmationMessage$1,
    Targets_MoveSuccessMessage: Targets_MoveSuccessMessage$1,
    TargetResourcesForm_Filters_Catalog: TargetResourcesForm_Filters_Catalog$1,
    TargetResourcesForm_Filters_PlansAndPathways: TargetResourcesForm_Filters_PlansAndPathways$1,
    TargetResourcesForm_Filters_Resources: TargetResourcesForm_Filters_Resources$1,
    TargetResourcesForm_InputHelp: TargetResourcesForm_InputHelp$1,
    TargetResourcesForm_NoResults: TargetResourcesForm_NoResults$1,
    TargetResourcesForm_NoResultsFound: TargetResourcesForm_NoResultsFound$1,
    TargetResourcesForm_ResourceAuthors: TargetResourcesForm_ResourceAuthors$1,
    TargetResourcesForm_SearchMixedPlaceholder: TargetResourcesForm_SearchMixedPlaceholder$1,
    TargetResourcesForm_SearchPlaceHolder: TargetResourcesForm_SearchPlaceHolder$1,
    TargetResourcesForm_Selected: TargetResourcesForm_Selected$1,
    TargetResourcesForm_Suggestions: TargetResourcesForm_Suggestions$1,
    TargetResourcesForm_Title: TargetResourcesForm_Title$1,
    TargetResources_AddResources: TargetResources_AddResources$1,
    TargetResources_CreateADirectory: TargetResources_CreateADirectory$1,
    TargetResources_CreateAResourceFormat: TargetResources_CreateAResourceFormat$1,
    TargetResources_CreateATarget: TargetResources_CreateATarget$1,
    TargetResources_DirectoryPlural: TargetResources_DirectoryPlural$1,
    TargetResources_Group: TargetResources_Group$1,
    TargetResources_GroupPlural: TargetResources_GroupPlural$1,
    TargetResources_InputPlural: TargetResources_InputPlural$1,
    TargetResources_NoDirectorysSelectedYet: TargetResources_NoDirectorysSelectedYet$1,
    TargetResources_NoGroupsSelectedYet: TargetResources_NoGroupsSelectedYet$1,
    TargetResources_NoTargetsSelectedYet: TargetResources_NoTargetsSelectedYet$1,
    TargetResources_PathwayPlural: TargetResources_PathwayPlural$1,
    TargetResources_ProviderPlural: TargetResources_ProviderPlural$1,
    TargetResources_TagPlural: TargetResources_TagPlural$1,
    TargetResources_Target: TargetResources_Target$1,
    TargetResources_TargetAndDirectoryPlural: TargetResources_TargetAndDirectoryPlural$1,
    TargetResources_TargetOrDirectory: TargetResources_TargetOrDirectory$1,
    TargetResources_TargetPlural: TargetResources_TargetPlural$1,
    TargetResources_UserPlural: TargetResources_UserPlural$1,
    TargetFormCtrl_TargetGroupsToolTip: TargetFormCtrl_TargetGroupsToolTip$1,
    TargetForm_AutopopulateInfo: TargetForm_AutopopulateInfo$1,
    TargetForm_AutopopulateTitle: TargetForm_AutopopulateTitle$1,
    TargetForm_CreateButton: TargetForm_CreateButton$1,
    TargetForm_CreateTitle: TargetForm_CreateTitle$1,
    TargetForm_Description: TargetForm_Description$1,
    TargetForm_DescriptionPlaceholder: TargetForm_DescriptionPlaceholder$1,
    TargetForm_EditTitle: TargetForm_EditTitle$1,
    TargetForm_FormDescription: TargetForm_FormDescription$1,
    TargetForm_IsEndorsedInfo: TargetForm_IsEndorsedInfo$1,
    TargetForm_IsEndorsedTitle: TargetForm_IsEndorsedTitle$1,
    TargetForm_Name: TargetForm_Name$1,
    TargetForm_NameError: TargetForm_NameError$1,
    TargetForm_NamePrompt: TargetForm_NamePrompt$1,
    TargetForm_RolePlanCreationNotice: TargetForm_RolePlanCreationNotice$1,
    TargetForm_SelectVisibility: TargetForm_SelectVisibility$1,
    TargetForm_SetPrimaryPlan: TargetForm_SetPrimaryPlan$1,
    TargetForm_Visibility: TargetForm_Visibility$1,
    TargetForm_VisibilityBoostToGroup: TargetForm_VisibilityBoostToGroup$1,
    TargetForm_VisibilityBoostToGroupTooltip: TargetForm_VisibilityBoostToGroupTooltip$1,
    TargetForm_VisibilityLimitToGroup: TargetForm_VisibilityLimitToGroup$1,
    TargetCtrl_AcceptAutosuggest: TargetCtrl_AcceptAutosuggest$1,
    TargetCtrl_AddDirectories: TargetCtrl_AddDirectories$1,
    TargetCtrl_AddDirectorys: TargetCtrl_AddDirectorys$1,
    TargetCtrl_AddGroups: TargetCtrl_AddGroups$1,
    TargetCtrl_AddInputs: TargetCtrl_AddInputs$1,
    TargetCtrl_AddOpportunities: TargetCtrl_AddOpportunities$1,
    TargetCtrl_AddPages: TargetCtrl_AddPages$1,
    TargetCtrl_AddPathways: TargetCtrl_AddPathways$1,
    TargetCtrl_AddProviders: TargetCtrl_AddProviders$1,
    TargetCtrl_AddTags: TargetCtrl_AddTags$1,
    TargetCtrl_AddTargetAndDirectoryPlural: TargetCtrl_AddTargetAndDirectoryPlural$1,
    TargetCtrl_AddTargetPlural: TargetCtrl_AddTargetPlural$1,
    TargetCtrl_AddTargets: TargetCtrl_AddTargets$1,
    TargetCtrl_AddUsers: TargetCtrl_AddUsers$1,
    TargetCtrl_AutoFill: TargetCtrl_AutoFill$1,
    TargetCtrl_AutosuggestNotice: TargetCtrl_AutosuggestNotice$1,
    TargetCtrl_ConfirmCloseButton: TargetCtrl_ConfirmCloseButton$1,
    TargetCtrl_ConfirmDeleteButton: TargetCtrl_ConfirmDeleteButton$1,
    TargetCtrl_DeleteInstructions: TargetCtrl_DeleteInstructions$1,
    TargetCtrl_DeletePluralPrompt: TargetCtrl_DeletePluralPrompt$1,
    TargetCtrl_DeletePrompt: TargetCtrl_DeletePrompt$1,
    TargetCtrl_DeletePromptDescription: TargetCtrl_DeletePromptDescription$1,
    TargetCtrl_Groups: TargetCtrl_Groups$1,
    TargetCtrl_Inputs: TargetCtrl_Inputs$1,
    TargetCtrl_NotVisibleNotice: TargetCtrl_NotVisibleNotice$1,
    TargetCtrl_Pathways: TargetCtrl_Pathways$1,
    TargetCtrl_PrimaryPlanDeselection: TargetCtrl_PrimaryPlanDeselection$1,
    TargetCtrl_PrimaryPlanSelection: TargetCtrl_PrimaryPlanSelection$1,
    TargetCtrl_SetTargetLevel: TargetCtrl_SetTargetLevel$1,
    TargetCtrl_SetVisible: TargetCtrl_SetVisible$1,
    TargetCtrl_SetVisibleNotAllowed: TargetCtrl_SetVisibleNotAllowed$1,
    TargetCtrl_SuggestionApplySuccess: TargetCtrl_SuggestionApplySuccess$1,
    TargetCtrl_Tags: TargetCtrl_Tags$1,
    TargetCtrl_TargetAndDirectoryPlural: TargetCtrl_TargetAndDirectoryPlural$1,
    TargetCtrl_TargetPlural: TargetCtrl_TargetPlural$1,
    TargetCtrl_Users: TargetCtrl_Users$1,
    TargetCtrl_WelcomeBack: TargetCtrl_WelcomeBack$1,
    TargetCtrl_YesAutopopulate: TargetCtrl_YesAutopopulate$1,
    TargetAuthorsForm_A11yAuthorDescription: TargetAuthorsForm_A11yAuthorDescription$1,
    TargetAuthorsForm_Authors: TargetAuthorsForm_Authors$1,
    TargetAuthorsForm_Save: TargetAuthorsForm_Save$1,
    TargetAuthorsForm_SearchPeopleGroupsPlaceHolder: TargetAuthorsForm_SearchPeopleGroupsPlaceHolder$1,
    TargetAuthorsForm_SearchPlaceHolder: TargetAuthorsForm_SearchPlaceHolder$1,
    TargetAuthorsForm_Title: TargetAuthorsForm_Title$1,
    TargetAuthorsForm_TitleAdd: TargetAuthorsForm_TitleAdd$1,
    Target_Delete: Target_Delete$1,
    Target_EditDetails: Target_EditDetails$1,
    Target_Empty: Target_Empty$1,
    Target_SetAuthoring: Target_SetAuthoring$1,
    Target_SetNotAuthoring: Target_SetNotAuthoring$1,
    Target_TargetLevelFormat: Target_TargetLevelFormat$1,
    TagsSvc_AddFocusSkillSuccess: TagsSvc_AddFocusSkillSuccess$1,
    TagsSvc_AddSkillError: TagsSvc_AddSkillError$1,
    TagsSvc_AddSkillsError: TagsSvc_AddSkillsError$1,
    TagsSvc_AddSkillsSuccess: TagsSvc_AddSkillsSuccess$1,
    TagsSvc_AddSkillSuccess: TagsSvc_AddSkillSuccess$1,
    TagsSvc_CategoryAvailable: TagsSvc_CategoryAvailable$1,
    TagsSvc_CategoryError: TagsSvc_CategoryError$1,
    TagsSvc_CategoryRetrieval: TagsSvc_CategoryRetrieval$1,
    TagsSvc_CategorySaves: TagsSvc_CategorySaves$1,
    TagsSvc_ConvertSkills: TagsSvc_ConvertSkills$1,
    TagsSvc_ConvertWorkdaySkillsDescription: TagsSvc_ConvertWorkdaySkillsDescription$1,
    TagsSvc_CreateError: TagsSvc_CreateError$1,
    TagsSvc_CredentialableTagsError: TagsSvc_CredentialableTagsError$1,
    TagsSvc_DeleteTagRatingError: TagsSvc_DeleteTagRatingError$1,
    TagsSvc_FocusSkillAlreadyAdded: TagsSvc_FocusSkillAlreadyAdded$1,
    TagsSvc_GetTagError: TagsSvc_GetTagError$1,
    TagsSvc_GetTagRatingDataError: TagsSvc_GetTagRatingDataError$1,
    TagsSvc_GetTagRatingError: TagsSvc_GetTagRatingError$1,
    TagsSvc_MatchingCategoryError: TagsSvc_MatchingCategoryError$1,
    TagsSvc_RateTagError: TagsSvc_RateTagError$1,
    TagsSvc_RecommendSkillError: TagsSvc_RecommendSkillError$1,
    TagsSvc_RemoveFocusSkillSuccess: TagsSvc_RemoveFocusSkillSuccess$1,
    TagsSvc_RemoveSkillError: TagsSvc_RemoveSkillError$1,
    TagsSvc_Replace: TagsSvc_Replace$1,
    TagsSvc_ReplaceFocusInterestModalDescription: TagsSvc_ReplaceFocusInterestModalDescription$1,
    TagsSvc_ReplaceFocusInterestModalTitle: TagsSvc_ReplaceFocusInterestModalTitle$1,
    TagsSvc_RequestTagRatingError: TagsSvc_RequestTagRatingError$1,
    TagsSvc_SkillsTagsError: TagsSvc_SkillsTagsError$1,
    TagsSvc_UpdateAssociateRatingSuccess: TagsSvc_UpdateAssociateRatingSuccess$1,
    TagsSvc_UpdateFocusSkillsError: TagsSvc_UpdateFocusSkillsError$1,
    TagsSvc_UpdatePrivacyError: TagsSvc_UpdatePrivacyError$1,
    TagsSvc_UseWorkdaySkillNames: TagsSvc_UseWorkdaySkillNames$1,
    TagsSvc_WorkdayCanonicalSkillConversionInstructions: TagsSvc_WorkdayCanonicalSkillConversionInstructions$1,
    TagsSearch_A11yTopTagsHint: TagsSearch_A11yTopTagsHint$1,
    TagsSearch_SkillProficiencyLevelDocumentationLabel: TagsSearch_SkillProficiencyLevelDocumentationLabel$1,
    TagsFormCtrl_AddSkillsOrTopics: TagsFormCtrl_AddSkillsOrTopics$1,
    TagsFormCtrl_SearchForSkill: TagsFormCtrl_SearchForSkill$1,
    TagsEdit_AddCategories: TagsEdit_AddCategories$1,
    TagsEdit_CategoriesMessage: TagsEdit_CategoriesMessage$1,
    TagsCtrl_Category: TagsCtrl_Category$1,
    TagsCtrl_CategoryHint: TagsCtrl_CategoryHint$1,
    TagsCtrl_SkillsPlaceholder: TagsCtrl_SkillsPlaceholder$1,
    TagsCtrl_SuggestedSkillsError: TagsCtrl_SuggestedSkillsError$1,
    TagsCtrl_SuggestedSkillsForSkill: TagsCtrl_SuggestedSkillsForSkill$1,
    TagsCtrl_SuggestedSkillsLoading: TagsCtrl_SuggestedSkillsLoading$1,
    TagsCtrl_SuggestedSkillsTitle: TagsCtrl_SuggestedSkillsTitle$1,
    TagRatingItem_TargetLevelFormat: TagRatingItem_TargetLevelFormat$1,
    TagRating_AskForNewRating: TagRating_AskForNewRating$1,
    TagRating_CancelRequest: TagRating_CancelRequest$1,
    TagRating_CancelRequestConfirmationFormat: TagRating_CancelRequestConfirmationFormat$1,
    TagRating_CancelRequestConfirmationFormatNoManager: TagRating_CancelRequestConfirmationFormatNoManager$1,
    TagRating_ChangeRating: TagRating_ChangeRating$1,
    TagRating_DeleteRatingFormat: TagRating_DeleteRatingFormat$1,
    TagRating_KeepRequest: TagRating_KeepRequest$1,
    TagRating_PendingManagerRequest: TagRating_PendingManagerRequest$1,
    TagRating_PendingPeerRequest: TagRating_PendingPeerRequest$1,
    TagRating_SkillTargetSetFormat: TagRating_SkillTargetSetFormat$1,
    TagRating_YouWereRatedFormat: TagRating_YouWereRatedFormat$1,
    SkillTrends_CustomAttributes_ErrorMessage: SkillTrends_CustomAttributes_ErrorMessage$1,
    SkillTrends_Declining: SkillTrends_Declining$1,
    SkillTrends_Emerging: SkillTrends_Emerging$1,
    SkillTrends_FilterByGroups: SkillTrends_FilterByGroups$1,
    SkillTrends_FilterBySegments: SkillTrends_FilterBySegments$1,
    SkillTrends_Groups_ErrorMessage: SkillTrends_Groups_ErrorMessage$1,
    SkillTrends_JobRoles_ErrorMessage: SkillTrends_JobRoles_ErrorMessage$1,
    SkillTrends_NoMatchingGroups: SkillTrends_NoMatchingGroups$1,
    SkillTrends_NoMatchingSegments: SkillTrends_NoMatchingSegments$1,
    SkillTrends_NoResultsInfo: SkillTrends_NoResultsInfo$1,
    SkillTrends_NoResultsLabel: SkillTrends_NoResultsLabel$1,
    SkillTrends_NotEnoughDataLabel: SkillTrends_NotEnoughDataLabel$1,
    SkillTrends_SkillGaps_Chart_NoResults: SkillTrends_SkillGaps_Chart_NoResults$1,
    SkillTrends_SkillGaps_Chart_NoResults_Info: SkillTrends_SkillGaps_Chart_NoResults_Info$1,
    SkillTrends_SkillGaps_Chart_SeriesName_SkillGap: SkillTrends_SkillGaps_Chart_SeriesName_SkillGap$1,
    SkillTrends_SkillGaps_Chart_SeriesName_SkillRating: SkillTrends_SkillGaps_Chart_SeriesName_SkillRating$1,
    SkillTrends_SkillGaps_Chart_SeriesName_SkillTarget: SkillTrends_SkillGaps_Chart_SeriesName_SkillTarget$1,
    SkillTrends_SkillGaps_Chart_Title: SkillTrends_SkillGaps_Chart_Title$1,
    SkillTrends_SkillGaps_Filters_JobRoles_Label: SkillTrends_SkillGaps_Filters_JobRoles_Label$1,
    SkillTrends_SkillGaps_Filters_RatingTypes_Label: SkillTrends_SkillGaps_Filters_RatingTypes_Label$1,
    SkillTrends_SkillGaps_Filters_RatingTypes_Option_All: SkillTrends_SkillGaps_Filters_RatingTypes_Option_All$1,
    SkillTrends_SkillGaps_Filters_RatingTypes_Option_Manager: SkillTrends_SkillGaps_Filters_RatingTypes_Option_Manager$1,
    SkillTrends_SkillGaps_Filters_RatingTypes_Option_Peer: SkillTrends_SkillGaps_Filters_RatingTypes_Option_Peer$1,
    SkillTrends_SkillGaps_Filters_RatingTypes_Option_Self: SkillTrends_SkillGaps_Filters_RatingTypes_Option_Self$1,
    SkillTrends_SkillGaps_Filters_RatingTypes_Option_SkillReview: SkillTrends_SkillGaps_Filters_RatingTypes_Option_SkillReview$1,
    SkillTrends_SkillGaps_NoJobRolesMessage: SkillTrends_SkillGaps_NoJobRolesMessage$1,
    SkillTrends_SkillGaps_Section_Title: SkillTrends_SkillGaps_Section_Title$1,
    SkillTrends_SkillGaps_Section_Tooltip: SkillTrends_SkillGaps_Section_Tooltip$1,
    SkillTrends_Tooltip_Declining: SkillTrends_Tooltip_Declining$1,
    SkillTrends_Tooltip_Emerging: SkillTrends_Tooltip_Emerging$1,
    SkillTrends_Tooltip_Trending: SkillTrends_Tooltip_Trending$1,
    SkillTrends_Top: SkillTrends_Top$1,
    SkillTrends_TopSearches_Title: SkillTrends_TopSearches_Title$1,
    SkillTrends_TopSearches_Tooltip: SkillTrends_TopSearches_Tooltip$1,
    SkillTrends_Trending: SkillTrends_Trending$1,
    SkillStd_AddDescription: SkillStd_AddDescription$1,
    SkillStd_AddSkillToProfile: SkillStd_AddSkillToProfile$1,
    SkillStd_AddTitle: SkillStd_AddTitle$1,
    SkillStd_CreateSkillStandards: SkillStd_CreateSkillStandards$1,
    SkillStd_DeleteSegmentMsg: SkillStd_DeleteSegmentMsg$1,
    SkillStd_DeleteSkillStandardsError: SkillStd_DeleteSkillStandardsError$1,
    SkillStd_DeleteSkillStandardsSegmentError: SkillStd_DeleteSkillStandardsSegmentError$1,
    SkillStd_DeleteSkillStandardsSegmentSuccess: SkillStd_DeleteSkillStandardsSegmentSuccess$1,
    SkillStd_DeleteSkillStandardsSuccess: SkillStd_DeleteSkillStandardsSuccess$1,
    SkillStd_DescriptionPlaceholder: SkillStd_DescriptionPlaceholder$1,
    SkillStd_DescriptionSuggestionPlaceholder: SkillStd_DescriptionSuggestionPlaceholder$1,
    SkillStd_EditDescription: SkillStd_EditDescription$1,
    SkillStd_EditSkillStandards: SkillStd_EditSkillStandards$1,
    SkillStd_emptyStateAddSomethingToShowHere: SkillStd_emptyStateAddSomethingToShowHere$1,
    SkillStd_MaximumAddedSegmentsDesc: SkillStd_MaximumAddedSegmentsDesc$1,
    SkillStd_MaximumAddedSegmentsReached: SkillStd_MaximumAddedSegmentsReached$1,
    SkillStd_MinimumVisibleSkillWarning: SkillStd_MinimumVisibleSkillWarning$1,
    SkillStd_NoVisibleSkills: SkillStd_NoVisibleSkills$1,
    SkillStd_NoVisibleSkillsUnpublishBody: SkillStd_NoVisibleSkillsUnpublishBody$1,
    SkillStd_NoVisibleSkillsUnpublishBodySecondary: SkillStd_NoVisibleSkillsUnpublishBodySecondary$1,
    SkillStd_PersonalSkillTarget: SkillStd_PersonalSkillTarget$1,
    SkillStd_PublishSegment: SkillStd_PublishSegment$1,
    SkillStd_RecommendedSkillsMessage: SkillStd_RecommendedSkillsMessage$1,
    SkillStd_RemoveSegment: SkillStd_RemoveSegment$1,
    SkillStd_RemoveSegmentBody: SkillStd_RemoveSegmentBody$1,
    SkillStd_RemoveSkill: SkillStd_RemoveSkill$1,
    SkillStd_RemoveSkillBody: SkillStd_RemoveSkillBody$1,
    SkillStd_RemoveSkillBodySecondary: SkillStd_RemoveSkillBodySecondary$1,
    SkillStd_RemoveSkillError: SkillStd_RemoveSkillError$1,
    SkillStd_RemoveSkillSuccess: SkillStd_RemoveSkillSuccess$1,
    SkillStd_RequirementStatus: SkillStd_RequirementStatus$1,
    SkillStd_SegmentAddedSuccessPlural: SkillStd_SegmentAddedSuccessPlural$1,
    SkillStd_SegmentAddedSuccessSingle: SkillStd_SegmentAddedSuccessSingle$1,
    SkillStd_SegmentPublishRequirementsNotMet: SkillStd_SegmentPublishRequirementsNotMet$1,
    SkillStd_Segments: SkillStd_Segments$1,
    SkillStd_SkillAddedSuccessPlural: SkillStd_SkillAddedSuccessPlural$1,
    SkillStd_SkillAddedSuccessSingle: SkillStd_SkillAddedSuccessSingle$1,
    SkillStd_SkillRemovedSegmentUnpublished_Multiple: SkillStd_SkillRemovedSegmentUnpublished_Multiple$1,
    SkillStd_SkillRemovedSegmentUnpublished_Single: SkillStd_SkillRemovedSegmentUnpublished_Single$1,
    SkillStd_SkillRequired: SkillStd_SkillRequired$1,
    SkillStd_SkillSet: SkillStd_SkillSet$1,
    SkillStd_SkillSetRelationships: SkillStd_SkillSetRelationships$1,
    SkillStd_SkillStandards: SkillStd_SkillStandards$1,
    SkillStd_SkillStandardsProfileSectionSubtitle: SkillStd_SkillStandardsProfileSectionSubtitle$1,
    SkillStd_SkillTargets: SkillStd_SkillTargets$1,
    SkillStd_SkillVisible: SkillStd_SkillVisible$1,
    SkillStd_Status_NoSegments: SkillStd_Status_NoSegments$1,
    SkillStd_Status_UnpublishedSegments: SkillStd_Status_UnpublishedSegments$1,
    SkillStd_SuccessfullyPublished: SkillStd_SuccessfullyPublished$1,
    SkillStd_SuccessfullyUnpublished: SkillStd_SuccessfullyUnpublished$1,
    SkillStd_TitleAlreadyExistsError: SkillStd_TitleAlreadyExistsError$1,
    SkillStd_TitleSuggestionPlaceholder: SkillStd_TitleSuggestionPlaceholder$1,
    SkillStd_Unpublished: SkillStd_Unpublished$1,
    SkillStd_UnpublishedSegmentsWarning: SkillStd_UnpublishedSegmentsWarning$1,
    SkillStd_UnpublishSegment: SkillStd_UnpublishSegment$1,
    SkillStd_UnpublishSegmentMsg: SkillStd_UnpublishSegmentMsg$1,
    SkillStd_UnpublishSegmentMsgConfirm: SkillStd_UnpublishSegmentMsgConfirm$1,
    SkillStd_UnpublishSegmentName: SkillStd_UnpublishSegmentName$1,
    SkillsSvc_AddPrimarySkillSource: SkillsSvc_AddPrimarySkillSource$1,
    SkillsSvc_AddRoleError: SkillsSvc_AddRoleError$1,
    SkillsSvc_AddRoleSuccess: SkillsSvc_AddRoleSuccess$1,
    SkillsSvc_AddSkill: SkillsSvc_AddSkill$1,
    SkillsSvc_AddSkillError: SkillsSvc_AddSkillError$1,
    SkillsSvc_AddSkillNameInputDescription: SkillsSvc_AddSkillNameInputDescription$1,
    SkillsSvc_AddSkillSource: SkillsSvc_AddSkillSource$1,
    SkillsSvc_AddSkillSuccess: SkillsSvc_AddSkillSuccess$1,
    SkillsSvc_AddTranslations: SkillsSvc_AddTranslations$1,
    SkillsSvc_AttemptPublishAgain: SkillsSvc_AttemptPublishAgain$1,
    SkillsSvc_Categories: SkillsSvc_Categories$1,
    SkillsSvc_Category: SkillsSvc_Category$1,
    SkillsSvc_CategoryCreateAgainError: SkillsSvc_CategoryCreateAgainError$1,
    SkillsSvc_CategorySuccessfullyCreated: SkillsSvc_CategorySuccessfullyCreated$1,
    SkillsSvc_CategorySuccessfullyUpdated: SkillsSvc_CategorySuccessfullyUpdated$1,
    SkillsSvc_CountSkillCategoriesPlural: SkillsSvc_CountSkillCategoriesPlural$1,
    SkillsSvc_CountSkillCategoriesSingular: SkillsSvc_CountSkillCategoriesSingular$1,
    SkillsSvc_CountSkillSynonymsPlural: SkillsSvc_CountSkillSynonymsPlural$1,
    SkillsSvc_CountSkillSynonymsSingular: SkillsSvc_CountSkillSynonymsSingular$1,
    SkillsSvc_CreateSkillTip: SkillsSvc_CreateSkillTip$1,
    SkillsSvc_CTASourcesDesc: SkillsSvc_CTASourcesDesc$1,
    SkillsSvc_CTASuggestionsDesc: SkillsSvc_CTASuggestionsDesc$1,
    SkillsSvc_CTAUnpublishedChangesDesc: SkillsSvc_CTAUnpublishedChangesDesc$1,
    SkillsSvc_CTAUnpublishedSkills: SkillsSvc_CTAUnpublishedSkills$1,
    SkillsSvc_CurrentDescription: SkillsSvc_CurrentDescription$1,
    SkillsSvc_CurrentSynonymousSkills: SkillsSvc_CurrentSynonymousSkills$1,
    SkillsSvc_CurrentTitle: SkillsSvc_CurrentTitle$1,
    SkillsSvc_DeleteLanguageTranslation: SkillsSvc_DeleteLanguageTranslation$1,
    SkillsSvc_DeleteRoleError: SkillsSvc_DeleteRoleError$1,
    SkillsSvc_DeleteRoleSuccess: SkillsSvc_DeleteRoleSuccess$1,
    SkillsSvc_DeleteSkillError: SkillsSvc_DeleteSkillError$1,
    SkillsSvc_DeleteSkillSource: SkillsSvc_DeleteSkillSource$1,
    SkillsSvc_DeleteSkillSourceDescription: SkillsSvc_DeleteSkillSourceDescription$1,
    SkillsSvc_DeleteSkillSuccess: SkillsSvc_DeleteSkillSuccess$1,
    SkillsSvc_DeleteTranslation: SkillsSvc_DeleteTranslation$1,
    SkillsSvc_EditRoleError: SkillsSvc_EditRoleError$1,
    SkillsSvc_EditRoleSuccess: SkillsSvc_EditRoleSuccess$1,
    SkillsSvc_EditSkill: SkillsSvc_EditSkill$1,
    SkillsSvc_EditSkillError: SkillsSvc_EditSkillError$1,
    SkillsSvc_EditSkillSuccess: SkillsSvc_EditSkillSuccess$1,
    SkillsSvc_EditsToSkills: SkillsSvc_EditsToSkills$1,
    SkillsSvc_EnableEndorseSkillOption: SkillsSvc_EnableEndorseSkillOption$1,
    SkillsSvc_EnableSkillReview: SkillsSvc_EnableSkillReview$1,
    SkillsSvc_EndorseSkill: SkillsSvc_EndorseSkill$1,
    SkillsSvc_FileUploadSuccessful: SkillsSvc_FileUploadSuccessful$1,
    SkillsSvc_FileUploadSuccessfulDescription: SkillsSvc_FileUploadSuccessfulDescription$1,
    SkillsSvc_GetStarted_Dashboard: SkillsSvc_GetStarted_Dashboard$1,
    SkillsSvc_GetStarted_Dashboard_Description: SkillsSvc_GetStarted_Dashboard_Description$1,
    SkillsSvc_ImportantPublishingInfo: SkillsSvc_ImportantPublishingInfo$1,
    SkillsSvc_IntegrationSourceEditTip: SkillsSvc_IntegrationSourceEditTip$1,
    SkillsSvc_ItemsAreNowAvailable: SkillsSvc_ItemsAreNowAvailable$1,
    SkillsSvc_JobRoles: SkillsSvc_JobRoles$1,
    SkillsSvc_JobRolesDescription: SkillsSvc_JobRolesDescription$1,
    SkillsSvc_LimitVisibilityToTheseGroups: SkillsSvc_LimitVisibilityToTheseGroups$1,
    SkillsSvc_ManageCategories: SkillsSvc_ManageCategories$1,
    SkillsSvc_ManageSources: SkillsSvc_ManageSources$1,
    SkillsSvc_MoreItems: SkillsSvc_MoreItems$1,
    SkillsSvc_NewSkillDescription: SkillsSvc_NewSkillDescription$1,
    SkillsSvc_NewSkillSpelling: SkillsSvc_NewSkillSpelling$1,
    SkillsSvc_NoPublishedHistory: SkillsSvc_NoPublishedHistory$1,
    SkillsSvc_OnboardingAddedNotification: SkillsSvc_OnboardingAddedNotification$1,
    SkillsSvc_OnboardingError: SkillsSvc_OnboardingError$1,
    SkillsSvc_OnboardingRemovedNotification: SkillsSvc_OnboardingRemovedNotification$1,
    SkillsSvc_OneMoreItem: SkillsSvc_OneMoreItem$1,
    SkillsSvc_OneTranslationSavedMsg: SkillsSvc_OneTranslationSavedMsg$1,
    SkillsSvc_OrgNameSkillsOnly: SkillsSvc_OrgNameSkillsOnly$1,
    SkillsSvc_PrimarySourceEditTip: SkillsSvc_PrimarySourceEditTip$1,
    SkillsSvc_Proficiency: SkillsSvc_Proficiency$1,
    SkillsSvc_Proficiency_Custom: SkillsSvc_Proficiency_Custom$1,
    SkillsSvc_Proficiency_Default: SkillsSvc_Proficiency_Default$1,
    SkillsSvc_Proficiency_Description_SubTitle: SkillsSvc_Proficiency_Description_SubTitle$1,
    SkillsSvc_Proficiency_Description_Title: SkillsSvc_Proficiency_Description_Title$1,
    SkillsSvc_Proficiency_InferDescription: SkillsSvc_Proficiency_InferDescription$1,
    SkillsSvc_Proficiency_Reset_Description: SkillsSvc_Proficiency_Reset_Description$1,
    SkillsSvc_Proficiency_Reset_Description_Content: SkillsSvc_Proficiency_Reset_Description_Content$1,
    SkillsSvc_PromoteSkillToOrg: SkillsSvc_PromoteSkillToOrg$1,
    SkillsSvc_Proprietary: SkillsSvc_Proprietary$1,
    SkillsSvc_ProprietarySkillOption: SkillsSvc_ProprietarySkillOption$1,
    SkillsSvc_ProprietaryToOrgLabel: SkillsSvc_ProprietaryToOrgLabel$1,
    SkillsSvc_PublishChangesToOrgName: SkillsSvc_PublishChangesToOrgName$1,
    SkillsSvc_PublishedSuccessfully: SkillsSvc_PublishedSuccessfully$1,
    SkillsSvc_PublishSkillCount: SkillsSvc_PublishSkillCount$1,
    SkillsSvc_PublishToLxp: SkillsSvc_PublishToLxp$1,
    SkillsSvc_PublishWarning: SkillsSvc_PublishWarning$1,
    SkillsSvc_RetrieveError: SkillsSvc_RetrieveError$1,
    SkillsSvc_ReviewSuggestions: SkillsSvc_ReviewSuggestions$1,
    SkillsSvc_RolesBulkUploadNotice: SkillsSvc_RolesBulkUploadNotice$1,
    SkillsSvc_RoleSuggestions: SkillsSvc_RoleSuggestions$1,
    SkillsSvc_Save_Upload: SkillsSvc_Save_Upload$1,
    SkillsSvc_SearchGroups: SkillsSvc_SearchGroups$1,
    SkillsSvc_SearchRoles: SkillsSvc_SearchRoles$1,
    SkillsSvc_SearchSkillCategories: SkillsSvc_SearchSkillCategories$1,
    SkillsSvc_SearchSkills: SkillsSvc_SearchSkills$1,
    SkillsSvc_SillAlreadyExistsInOrg: SkillsSvc_SillAlreadyExistsInOrg$1,
    SkillsSvc_SkillCategories: SkillsSvc_SkillCategories$1,
    SkillsSvc_SkillCategoriesDescription: SkillsSvc_SkillCategoriesDescription$1,
    SkillsSvc_SkillId: SkillsSvc_SkillId$1,
    SkillsSvc_SkillReviewEnableOption: SkillsSvc_SkillReviewEnableOption$1,
    SkillsSvc_SkillReviewVisibility: SkillsSvc_SkillReviewVisibility$1,
    SkillsSvc_SkillReviewVisibilityDescription: SkillsSvc_SkillReviewVisibilityDescription$1,
    SkillsSvc_SkillsBulkUploadNotice: SkillsSvc_SkillsBulkUploadNotice$1,
    SkillsSvc_SkillSourceCreated: SkillsSvc_SkillSourceCreated$1,
    SkillsSvc_SkillSourceCreatedDescription: SkillsSvc_SkillSourceCreatedDescription$1,
    SkillsSvc_SkillSourceDescription: SkillsSvc_SkillSourceDescription$1,
    SkillsSvc_SkillSourceName: SkillsSvc_SkillSourceName$1,
    SkillsSvc_SkillSources: SkillsSvc_SkillSources$1,
    SkillsSvc_SkillSuggestionDrawerTitle: SkillsSvc_SkillSuggestionDrawerTitle$1,
    SkillsSvc_SkillSynonymError: SkillsSvc_SkillSynonymError$1,
    SkillsSvc_SkillTitle: SkillsSvc_SkillTitle$1,
    SkillsSvc_SkillUpdatedSuccessfully: SkillsSvc_SkillUpdatedSuccessfully$1,
    SkillsSvc_SkipForNow: SkillsSvc_SkipForNow$1,
    SkillsSvc_SourceAlreadyExistsInOrg: SkillsSvc_SourceAlreadyExistsInOrg$1,
    SkillsSvc_SuggestedSkillDescription: SkillsSvc_SuggestedSkillDescription$1,
    SkillsSvc_SuggestedSkillTitle: SkillsSvc_SuggestedSkillTitle$1,
    SkillsSvc_SuggestedSynonymousSkills: SkillsSvc_SuggestedSynonymousSkills$1,
    SkillsSvc_suggestions_sub_header_text: SkillsSvc_suggestions_sub_header_text$1,
    SkillsSvc_SuggestionsApplied: SkillsSvc_SuggestionsApplied$1,
    SkillsSvc_SuggestionsDeclined: SkillsSvc_SuggestionsDeclined$1,
    SkillsSvc_SynonymAlreadyExistsMessaging: SkillsSvc_SynonymAlreadyExistsMessaging$1,
    SkillsSvc_SynonymousSkills: SkillsSvc_SynonymousSkills$1,
    SkillsSvc_SynonymousSkills_MergeModal_button: SkillsSvc_SynonymousSkills_MergeModal_button$1,
    SkillsSvc_SynonymousSkills_MergeModal_paragraph_1: SkillsSvc_SynonymousSkills_MergeModal_paragraph_1$1,
    SkillsSvc_SynonymousSkills_MergeModal_paragraph_2: SkillsSvc_SynonymousSkills_MergeModal_paragraph_2$1,
    SkillsSvc_SynonymousSkills_MergeModal_title: SkillsSvc_SynonymousSkills_MergeModal_title$1,
    SkillsSvc_SynonymousSkillsDescription: SkillsSvc_SynonymousSkillsDescription$1,
    SkillsSvc_TotalSuggestionsSelected: SkillsSvc_TotalSuggestionsSelected$1,
    SkillsSvc_Translations: SkillsSvc_Translations$1,
    SkillsSvc_TranslationsSaved: SkillsSvc_TranslationsSaved$1,
    SkillsSvc_TranslationsSavedMsg: SkillsSvc_TranslationsSavedMsg$1,
    SkillsSvc_TryAgainOrContactSupport: SkillsSvc_TryAgainOrContactSupport$1,
    SkillsSvc_UnpublishedChange: SkillsSvc_UnpublishedChange$1,
    SkillsSvc_UnpublishedChanges: SkillsSvc_UnpublishedChanges$1,
    SkillsSvc_UnpublishedChanges_None: SkillsSvc_UnpublishedChanges_None$1,
    SkillsSvc_UpdateError: SkillsSvc_UpdateError$1,
    SkillsSvc_UpdateRoleError: SkillsSvc_UpdateRoleError$1,
    SkillsSvc_UpdateRoleSuccess: SkillsSvc_UpdateRoleSuccess$1,
    SkillsSvc_UploadRoleError: SkillsSvc_UploadRoleError$1,
    SkillsSvc_UploadSkillError: SkillsSvc_UploadSkillError$1,
    SkillsSvc_UsersTitle: SkillsSvc_UsersTitle$1,
    SkillsSvc_ZeroTranslationSavedMsg: SkillsSvc_ZeroTranslationSavedMsg$1,
    SkillSectionsChart_AboveTarget: SkillSectionsChart_AboveTarget$1,
    SkillSectionsChart_AllSectionSkills: SkillSectionsChart_AllSectionSkills$1,
    SkillSectionsChart_AtTarget: SkillSectionsChart_AtTarget$1,
    SkillSectionsChart_AvgRatingFormat: SkillSectionsChart_AvgRatingFormat$1,
    SkillSectionsChart_BelowTarget: SkillSectionsChart_BelowTarget$1,
    SkillSectionsChart_Level: SkillSectionsChart_Level$1,
    SkillSectionsChart_NoData: SkillSectionsChart_NoData$1,
    SkillSectionsChart_NoRatings: SkillSectionsChart_NoRatings$1,
    SkillSectionsChart_NoTarget: SkillSectionsChart_NoTarget$1,
    SkillSectionsChart_PercentFormat: SkillSectionsChart_PercentFormat$1,
    SkillSectionsChart_PercentOfRatings: SkillSectionsChart_PercentOfRatings$1,
    SkillSectionsChart_PlanFollowersFormat: SkillSectionsChart_PlanFollowersFormat$1,
    SkillSectionsChart_PlanRatingsFormat: SkillSectionsChart_PlanRatingsFormat$1,
    SkillSectionsChart_PluralRatings: SkillSectionsChart_PluralRatings$1,
    SkillSectionsChart_ReviewCertificationNotAvailable: SkillSectionsChart_ReviewCertificationNotAvailable$1,
    SkillSectionsChart_SingularRating: SkillSectionsChart_SingularRating$1,
    SkillSectionsChart_SkillCertifications: SkillSectionsChart_SkillCertifications$1,
    SkillSectionsChart_SkillFollowersFormat: SkillSectionsChart_SkillFollowersFormat$1,
    SkillSectionsChart_SkillRatingsBreakdown: SkillSectionsChart_SkillRatingsBreakdown$1,
    SkillSectionsChart_SkillRatingsFormat: SkillSectionsChart_SkillRatingsFormat$1,
    SkillSectionsChart_Team_NoRatings: SkillSectionsChart_Team_NoRatings$1,
    SkillSectionsChart_TeamMembers_AvgFormat: SkillSectionsChart_TeamMembers_AvgFormat$1,
    SkillSectionsChart_TeamMembers_FollowFormat: SkillSectionsChart_TeamMembers_FollowFormat$1,
    SkillSectionsChart_TeamMembers_RatingsFormat: SkillSectionsChart_TeamMembers_RatingsFormat$1,
    SkillSearchCtrl_ComingSoon: SkillSearchCtrl_ComingSoon$1,
    SkillSearchCtrl_EmailAddress: SkillSearchCtrl_EmailAddress$1,
    SkillSearchCtrl_GetCertifiedToday: SkillSearchCtrl_GetCertifiedToday$1,
    SkillSearchCtrl_GetNotified: SkillSearchCtrl_GetNotified$1,
    SkillSearchCtrl_NoMatch: SkillSearchCtrl_NoMatch$1,
    SkillSearchCtrl_SearchForSkill: SkillSearchCtrl_SearchForSkill$1,
    SkillRegistrySearch_SkillRegistrySuggestions: SkillRegistrySearch_SkillRegistrySuggestions$1,
    SkillRatingTypeChart_Legend_Manager: SkillRatingTypeChart_Legend_Manager$1,
    SkillRatingTypeChart_Legend_Peer: SkillRatingTypeChart_Legend_Peer$1,
    SkillRatingTypeChart_Legend_Self: SkillRatingTypeChart_Legend_Self$1,
    SkillRatingTypeChart_Legend_SkillReview: SkillRatingTypeChart_Legend_SkillReview$1,
    SkillRatingTypeChart_LegendTitle: SkillRatingTypeChart_LegendTitle$1,
    SkillRatingTypeChart_Title: SkillRatingTypeChart_Title$1,
    SkillRatingTypeChart_TooltipText: SkillRatingTypeChart_TooltipText$1,
    SkillRatingTypeChart_XAxis_Label: SkillRatingTypeChart_XAxis_Label$1,
    SkillRatingTypeChart_YAxis_Label: SkillRatingTypeChart_YAxis_Label$1,
    SkillRatingsChart_AllTypes: SkillRatingsChart_AllTypes$1,
    SkillRatingsChart_AlphabeticalOrder: SkillRatingsChart_AlphabeticalOrder$1,
    SkillRatingsChart_Average: SkillRatingsChart_Average$1,
    SkillRatingsChart_AverageSkillRating: SkillRatingsChart_AverageSkillRating$1,
    SkillRatingsChart_avgSkillRatingFormat: SkillRatingsChart_avgSkillRatingFormat$1,
    SkillRatingsChart_certified: SkillRatingsChart_certified$1,
    SkillRatingsChart_DegreedCertified: SkillRatingsChart_DegreedCertified$1,
    SkillRatingsChart_Description: SkillRatingsChart_Description$1,
    SkillRatingsChart_EmptyStateText: SkillRatingsChart_EmptyStateText$1,
    SkillRatingsChart_Evaluations: SkillRatingsChart_Evaluations$1,
    SkillRatingsChart_High: SkillRatingsChart_High$1,
    SkillRatingsChart_learner: SkillRatingsChart_learner$1,
    SkillRatingsChart_learnerPluralFormat: SkillRatingsChart_learnerPluralFormat$1,
    SkillRatingsChart_Low: SkillRatingsChart_Low$1,
    SkillRatingsChart_manager: SkillRatingsChart_manager$1,
    SkillRatingsChart_ManagerRatings: SkillRatingsChart_ManagerRatings$1,
    SkillRatingsChart_Medium: SkillRatingsChart_Medium$1,
    SkillRatingsChart_MostRatings: SkillRatingsChart_MostRatings$1,
    SkillRatingsChart_NoData: SkillRatingsChart_NoData$1,
    SkillRatingsChart_NumberOfSkillsShownPluralFormat: SkillRatingsChart_NumberOfSkillsShownPluralFormat$1,
    SkillRatingsChart_NumberOfSkillsShownSingularFormat: SkillRatingsChart_NumberOfSkillsShownSingularFormat$1,
    SkillRatingsChart_NumberOfSkillsShownTopFormat: SkillRatingsChart_NumberOfSkillsShownTopFormat$1,
    SkillRatingsChart_Range: SkillRatingsChart_Range$1,
    SkillRatingsChart_Rating: SkillRatingsChart_Rating$1,
    SkillRatingsChart_Ratings: SkillRatingsChart_Ratings$1,
    SkillRatingsChart_RatingType: SkillRatingsChart_RatingType$1,
    SkillRatingsChart_Representativeness: SkillRatingsChart_Representativeness$1,
    SkillRatingsChart_review: SkillRatingsChart_review$1,
    SkillRatingsChart_Rigor: SkillRatingsChart_Rigor$1,
    SkillRatingsChart_self: SkillRatingsChart_self$1,
    SkillRatingsChart_SelfRatings: SkillRatingsChart_SelfRatings$1,
    SkillRatingsChart_SkillInventory: SkillRatingsChart_SkillInventory$1,
    SkillRatingsChart_StatsTitle: SkillRatingsChart_StatsTitle$1,
    SkillRatingsChart_TargetLevel: SkillRatingsChart_TargetLevel$1,
    SkillRatingsChart_Text: SkillRatingsChart_Text$1,
    SkillRatingsChart_TotalRatingsFormat: SkillRatingsChart_TotalRatingsFormat$1,
    SkillRatingsChart_TotalSkillRatings: SkillRatingsChart_TotalSkillRatings$1,
    SkillProgressionChart_AvgRating: SkillProgressionChart_AvgRating$1,
    SkillProgressionChart_AvgSkillRating: SkillProgressionChart_AvgSkillRating$1,
    SkillProgressionChart_NumberOfLearners: SkillProgressionChart_NumberOfLearners$1,
    SkillProgressionChart_NumberOfRatingsPlural: SkillProgressionChart_NumberOfRatingsPlural$1,
    SkillProgressionChart_NumberOfRatingsSingle: SkillProgressionChart_NumberOfRatingsSingle$1,
    SkillProgressionChart_Ratings: SkillProgressionChart_Ratings$1,
    SkillProgressionChart_SkillProgression: SkillProgressionChart_SkillProgression$1,
    SkillProgressionChart_SkillSupply: SkillProgressionChart_SkillSupply$1,
    SkillProgressionChart_SubtitlePluralFormat: SkillProgressionChart_SubtitlePluralFormat$1,
    SkillProgressionChart_SubtitleSingularFormat: SkillProgressionChart_SubtitleSingularFormat$1,
    SkillProgressionChart_SubtitleTopFormat: SkillProgressionChart_SubtitleTopFormat$1,
    SkillProgressionChart_Title: SkillProgressionChart_Title$1,
    SkillProgressionChart_XAxis: SkillProgressionChart_XAxis$1,
    SkillProgressionChart_YAxis: SkillProgressionChart_YAxis$1,
    SkillInsights_MinimumRatingNotice: SkillInsights_MinimumRatingNotice$1,
    SkillInsights_RatingNotice: SkillInsights_RatingNotice$1,
    SkillFormCtrl_AddLink: SkillFormCtrl_AddLink$1,
    SkillFormCtrl_Description: SkillFormCtrl_Description$1,
    SkillFormCtrl_SkillCategory: SkillFormCtrl_SkillCategory$1,
    SkillFormCtrl_SkillDescription: SkillFormCtrl_SkillDescription$1,
    SkillFormCtrl_Url: SkillFormCtrl_Url$1,
    SkillActivityChart_Title: SkillActivityChart_Title$1,
    SkillActivityChart_TooltipText: SkillActivityChart_TooltipText$1,
    singleRecommendation_groupAlreadyCompletedArticleDateFormat: singleRecommendation_groupAlreadyCompletedArticleDateFormat$1,
    singleRecommendation_groupAlreadyCompletedArticleFormat: singleRecommendation_groupAlreadyCompletedArticleFormat$1,
    singleRecommendation_groupAlreadyCompletedAssessmentDateFormat: singleRecommendation_groupAlreadyCompletedAssessmentDateFormat$1,
    singleRecommendation_groupAlreadyCompletedAssessmentFormat: singleRecommendation_groupAlreadyCompletedAssessmentFormat$1,
    singleRecommendation_groupAlreadyCompletedBookFormat: singleRecommendation_groupAlreadyCompletedBookFormat$1,
    singleRecommendation_groupAlreadyCompletedCourseFormat: singleRecommendation_groupAlreadyCompletedCourseFormat$1,
    singleRecommendation_groupAlreadyCompletedEpisodeDateFormat: singleRecommendation_groupAlreadyCompletedEpisodeDateFormat$1,
    singleRecommendation_groupAlreadyCompletedEpisodeFormat: singleRecommendation_groupAlreadyCompletedEpisodeFormat$1,
    singleRecommendation_groupAlreadyCompletedEventDateFormat: singleRecommendation_groupAlreadyCompletedEventDateFormat$1,
    singleRecommendation_groupAlreadyCompletedEventFormat: singleRecommendation_groupAlreadyCompletedEventFormat$1,
    singleRecommendation_GroupAlreadyCompletedFormat: singleRecommendation_GroupAlreadyCompletedFormat$1,
    singleRecommendation_groupAlreadyCompletedPathwayDateFormat: singleRecommendation_groupAlreadyCompletedPathwayDateFormat$1,
    singleRecommendation_groupAlreadyCompletedPathwayFormat: singleRecommendation_groupAlreadyCompletedPathwayFormat$1,
    singleRecommendation_groupAlreadyCompletedVideoDateFormat: singleRecommendation_groupAlreadyCompletedVideoDateFormat$1,
    singleRecommendation_groupAlreadyCompletedVideoFormat: singleRecommendation_groupAlreadyCompletedVideoFormat$1,
    singleRecommendation_groupArticleDateFormat: singleRecommendation_groupArticleDateFormat$1,
    singleRecommendation_groupArticleFormat: singleRecommendation_groupArticleFormat$1,
    singleRecommendation_groupAssessmentDateFormat: singleRecommendation_groupAssessmentDateFormat$1,
    singleRecommendation_groupAssessmentFormat: singleRecommendation_groupAssessmentFormat$1,
    singleRecommendation_groupBookDateFormat: singleRecommendation_groupBookDateFormat$1,
    singleRecommendation_groupBookFormat: singleRecommendation_groupBookFormat$1,
    singleRecommendation_groupCourseDateFormat: singleRecommendation_groupCourseDateFormat$1,
    singleRecommendation_groupCourseFormat: singleRecommendation_groupCourseFormat$1,
    singleRecommendation_groupEpisodeDateFormat: singleRecommendation_groupEpisodeDateFormat$1,
    singleRecommendation_groupEpisodeFormat: singleRecommendation_groupEpisodeFormat$1,
    singleRecommendation_groupEventDateFormat: singleRecommendation_groupEventDateFormat$1,
    singleRecommendation_groupEventFormat: singleRecommendation_groupEventFormat$1,
    singleRecommendation_GroupFollowFormat: singleRecommendation_GroupFollowFormat$1,
    singleRecommendation_GroupFormat: singleRecommendation_GroupFormat$1,
    singleRecommendation_groupPathwayDateFormat: singleRecommendation_groupPathwayDateFormat$1,
    singleRecommendation_groupPathwayFormat: singleRecommendation_groupPathwayFormat$1,
    singleRecommendation_groupTargetDateFormat: singleRecommendation_groupTargetDateFormat$1,
    singleRecommendation_groupTargetFormat: singleRecommendation_groupTargetFormat$1,
    singleRecommendation_groupVideoDateFormat: singleRecommendation_groupVideoDateFormat$1,
    singleRecommendation_groupVideoFormat: singleRecommendation_groupVideoFormat$1,
    singleRecommendation_GroupYouAlreadyFollowFormat: singleRecommendation_GroupYouAlreadyFollowFormat$1,
    singleRecommendation_youAlreadyCompletedArticleDateFormat: singleRecommendation_youAlreadyCompletedArticleDateFormat$1,
    singleRecommendation_youAlreadyCompletedArticleFormat: singleRecommendation_youAlreadyCompletedArticleFormat$1,
    singleRecommendation_youAlreadyCompletedAssessmentDateFormat: singleRecommendation_youAlreadyCompletedAssessmentDateFormat$1,
    singleRecommendation_youAlreadyCompletedAssessmentFormat: singleRecommendation_youAlreadyCompletedAssessmentFormat$1,
    singleRecommendation_youAlreadyCompletedBookFormat: singleRecommendation_youAlreadyCompletedBookFormat$1,
    singleRecommendation_youAlreadyCompletedCourseDateFormat: singleRecommendation_youAlreadyCompletedCourseDateFormat$1,
    singleRecommendation_youAlreadyCompletedCourseFormat: singleRecommendation_youAlreadyCompletedCourseFormat$1,
    singleRecommendation_youAlreadyCompletedEpisodeDateFormat: singleRecommendation_youAlreadyCompletedEpisodeDateFormat$1,
    singleRecommendation_youAlreadyCompletedEpisodeFormat: singleRecommendation_youAlreadyCompletedEpisodeFormat$1,
    singleRecommendation_youAlreadyCompletedEventDateFormat: singleRecommendation_youAlreadyCompletedEventDateFormat$1,
    singleRecommendation_youAlreadyCompletedEventFormat: singleRecommendation_youAlreadyCompletedEventFormat$1,
    singleRecommendation_YouAlreadyCompletedFormat: singleRecommendation_YouAlreadyCompletedFormat$1,
    singleRecommendation_youAlreadyCompletedPathwayFormat: singleRecommendation_youAlreadyCompletedPathwayFormat$1,
    singleRecommendation_youAlreadyCompletedTargetDateFormat: singleRecommendation_youAlreadyCompletedTargetDateFormat$1,
    singleRecommendation_youAlreadyCompletedTargetFormat: singleRecommendation_youAlreadyCompletedTargetFormat$1,
    singleRecommendation_youAlreadyCompletedVideoDateFormat: singleRecommendation_youAlreadyCompletedVideoDateFormat$1,
    singleRecommendation_youAlreadyCompletedVideoFormat: singleRecommendation_youAlreadyCompletedVideoFormat$1,
    singleRecommendation_YouAlreadyFollowFormat: singleRecommendation_YouAlreadyFollowFormat$1,
    singleRecommendation_youArticleFormat: singleRecommendation_youArticleFormat$1,
    singleRecommendation_youAssessmentDateFormat: singleRecommendation_youAssessmentDateFormat$1,
    singleRecommendation_youAssessmentFormat: singleRecommendation_youAssessmentFormat$1,
    singleRecommendation_youBookDateFormat: singleRecommendation_youBookDateFormat$1,
    singleRecommendation_youBookFormat: singleRecommendation_youBookFormat$1,
    singleRecommendation_youCourseDateFormat: singleRecommendation_youCourseDateFormat$1,
    singleRecommendation_youCourseFormat: singleRecommendation_youCourseFormat$1,
    singleRecommendation_youEpisodeDateFormat: singleRecommendation_youEpisodeDateFormat$1,
    singleRecommendation_youEpisodeFormat: singleRecommendation_youEpisodeFormat$1,
    singleRecommendation_youEventDateFormat: singleRecommendation_youEventDateFormat$1,
    singleRecommendation_youEventFormat: singleRecommendation_youEventFormat$1,
    singleRecommendation_YouFollowFormat: singleRecommendation_YouFollowFormat$1,
    singleRecommendation_YouFormat: singleRecommendation_YouFormat$1,
    singleRecommendation_youPathwayDateFormat: singleRecommendation_youPathwayDateFormat$1,
    singleRecommendation_youPathwayFormat: singleRecommendation_youPathwayFormat$1,
    singleRecommendation_youPositionDateFormat: singleRecommendation_youPositionDateFormat$1,
    singleRecommendation_youTargetDateFormat: singleRecommendation_youTargetDateFormat$1,
    singleRecommendation_youTargetFormat: singleRecommendation_youTargetFormat$1,
    singleRecommendation_youVideoDateFormat: singleRecommendation_youVideoDateFormat$1,
    singleRecommendation_youVideoFormat: singleRecommendation_youVideoFormat$1,
    signupForm_CreatePasswordLabel: signupForm_CreatePasswordLabel$1,
    signupForm_CreatePasswordPlaceholder: signupForm_CreatePasswordPlaceholder$1,
    signupForm_CreatePasswordTooltip: signupForm_CreatePasswordTooltip$1,
    signupForm_EmailExists: signupForm_EmailExists$1,
    signupForm_EmailPlaceholder: signupForm_EmailPlaceholder$1,
    signupForm_EmailStateTooltip: signupForm_EmailStateTooltip$1,
    signupForm_FirstNamePlaceholder: signupForm_FirstNamePlaceholder$1,
    signupForm_HasAccountCTA: signupForm_HasAccountCTA$1,
    signupForm_InvalidEmailSignup: signupForm_InvalidEmailSignup$1,
    signupForm_InvalidEula: signupForm_InvalidEula$1,
    signupForm_InvalidFirstName: signupForm_InvalidFirstName$1,
    signupForm_InvalidPassword: signupForm_InvalidPassword$1,
    signupForm_LastNamePlaceholder: signupForm_LastNamePlaceholder$1,
    signupForm_LogInNow: signupForm_LogInNow$1,
    signupForm_NoAccount: signupForm_NoAccount$1,
    signupForm_PasswordLabel: signupForm_PasswordLabel$1,
    signupForm_RegisterEmailLabel: signupForm_RegisterEmailLabel$1,
    signupForm_RegisterFirstNameLabel: signupForm_RegisterFirstNameLabel$1,
    signupForm_RegisterLastNameLabel: signupForm_RegisterLastNameLabel$1,
    signupForm_SignUpTitle: signupForm_SignUpTitle$1,
    SessionTimeoutModal_Body: SessionTimeoutModal_Body$1,
    SessionTimeoutModal_StillHere: SessionTimeoutModal_StillHere$1,
    searchTags_UserTagsAddButton: searchTags_UserTagsAddButton$1,
    searchTags_UserTagsHint: searchTags_UserTagsHint$1,
    SearchResultItem_AddToBin: SearchResultItem_AddToBin$1,
    scholarshipIntroModal_CreateAccount: scholarshipIntroModal_CreateAccount$1,
    scholarshipIntroModal_CreateAccountDescription: scholarshipIntroModal_CreateAccountDescription$1,
    scholarshipIntroModal_CreateAccountLabel: scholarshipIntroModal_CreateAccountLabel$1,
    resourceAssociationRemoved_ActionFormat: resourceAssociationRemoved_ActionFormat$1,
    resourceAssociationRemoved_ActionNoUserFormat: resourceAssociationRemoved_ActionNoUserFormat$1,
    resetPasswordForm_ConfirmPasswordError: resetPasswordForm_ConfirmPasswordError$1,
    resetPasswordForm_ConfirmPasswordLabel: resetPasswordForm_ConfirmPasswordLabel$1,
    resetPasswordForm_ConfirmPasswordPlaceholder: resetPasswordForm_ConfirmPasswordPlaceholder$1,
    resetPasswordForm_ExpiredPassword: resetPasswordForm_ExpiredPassword$1,
    resetPasswordForm_Info: resetPasswordForm_Info$1,
    resetPasswordForm_InvalidConfirmPassword: resetPasswordForm_InvalidConfirmPassword$1,
    resetPasswordForm_InvalidEmail: resetPasswordForm_InvalidEmail$1,
    resetPasswordForm_InvalidPassword: resetPasswordForm_InvalidPassword$1,
    resetPasswordForm_NewPasswordLabel: resetPasswordForm_NewPasswordLabel$1,
    resetPasswordForm_NewPasswordPlaceholder: resetPasswordForm_NewPasswordPlaceholder$1,
    requiredLearning_notificationDateFormat: requiredLearning_notificationDateFormat$1,
    RequestRating_Header: RequestRating_Header$1,
    RequestRating_Label: RequestRating_Label$1,
    RequestRating_Message1Format: RequestRating_Message1Format$1,
    RequestRating_RateNow: RequestRating_RateNow$1,
    RequestRating_Self_Message1Format: RequestRating_Self_Message1Format$1,
    RequestRating_Self_Subject: RequestRating_Self_Subject$1,
    RequestRating_SendRequest: RequestRating_SendRequest$1,
    RequestRating_Subject: RequestRating_Subject$1,
    RequestRating_SuccessMessage: RequestRating_SuccessMessage$1,
    requestGroupMembership_Accept: requestGroupMembership_Accept$1,
    requestGroupMembership_Approved: requestGroupMembership_Approved$1,
    requestGroupMembership_Decline: requestGroupMembership_Decline$1,
    requestGroupMembership_Denied: requestGroupMembership_Denied$1,
    requestGroupMembership_Plural: requestGroupMembership_Plural$1,
    requestGroupMembership_Single: requestGroupMembership_Single$1,
    ReportingContentSvc_All: ReportingContentSvc_All$1,
    ReportingContentSvc_ChartIDflexPathwaySections: ReportingContentSvc_ChartIDflexPathwaySections$1,
    ReportingContentSvc_ChartIDlearningChart: ReportingContentSvc_ChartIDlearningChart$1,
    ReportingContentSvc_ChartIDpopularCategories: ReportingContentSvc_ChartIDpopularCategories$1,
    ReportingContentSvc_ChartIDpopularProviders: ReportingContentSvc_ChartIDpopularProviders$1,
    ReportingContentSvc_ChartIDpopularSearches: ReportingContentSvc_ChartIDpopularSearches$1,
    ReportingContentSvc_ChartIDrecommendationsStatus: ReportingContentSvc_ChartIDrecommendationsStatus$1,
    ReportingContentSvc_ChartIDskillRatings: ReportingContentSvc_ChartIDskillRatings$1,
    ReportingContentSvc_ChartIDtopGroups: ReportingContentSvc_ChartIDtopGroups$1,
    ReportingContentSvc_ExternalContent: ReportingContentSvc_ExternalContent$1,
    ReportingContentSvc_ImageAltText: ReportingContentSvc_ImageAltText$1,
    ReportingContentSvc_InternalContent: ReportingContentSvc_InternalContent$1,
    ReportingContentSvc_Name: ReportingContentSvc_Name$1,
    ReportingContentSvc_NotEnoughActivity: ReportingContentSvc_NotEnoughActivity$1,
    ReportingContentSvc_Points: ReportingContentSvc_Points$1,
    ReportingContentSvc_ReportsNotAvailable: ReportingContentSvc_ReportsNotAvailable$1,
    ReportingContentSvc_TotalContentViewed: ReportingContentSvc_TotalContentViewed$1,
    ReportingContentSvc_TotalItemsAdded: ReportingContentSvc_TotalItemsAdded$1,
    ReportingContentSvc_TotalItemsCompleted: ReportingContentSvc_TotalItemsCompleted$1,
    ReportingContentSvc_TotalPointsEarned: ReportingContentSvc_TotalPointsEarned$1,
    Reporting_Transmitters_BOM: Reporting_Transmitters_BOM$1,
    Reporting_Transmitters_Configurations: Reporting_Transmitters_Configurations$1,
    Reporting_Transmitters_Configurations_Selection: Reporting_Transmitters_Configurations_Selection$1,
    Reporting_Transmitters_CreateEdit_AuthenticationType: Reporting_Transmitters_CreateEdit_AuthenticationType$1,
    Reporting_Transmitters_CreateEdit_BOMTooltip: Reporting_Transmitters_CreateEdit_BOMTooltip$1,
    Reporting_Transmitters_CreateEdit_ConnectionStatus: Reporting_Transmitters_CreateEdit_ConnectionStatus$1,
    Reporting_Transmitters_CreateEdit_ConnectionStatusCheck: Reporting_Transmitters_CreateEdit_ConnectionStatusCheck$1,
    Reporting_Transmitters_CreateEdit_ConnectionStatusFail: Reporting_Transmitters_CreateEdit_ConnectionStatusFail$1,
    Reporting_Transmitters_CreateEdit_ConnectionStatusNotConnected: Reporting_Transmitters_CreateEdit_ConnectionStatusNotConnected$1,
    Reporting_Transmitters_CreateEdit_ConnectionStatusSuccess: Reporting_Transmitters_CreateEdit_ConnectionStatusSuccess$1,
    Reporting_Transmitters_CreateEdit_CredentialsNote: Reporting_Transmitters_CreateEdit_CredentialsNote$1,
    Reporting_Transmitters_CreateEdit_HeaderCreate: Reporting_Transmitters_CreateEdit_HeaderCreate$1,
    Reporting_Transmitters_CreateEdit_HeaderUpdate: Reporting_Transmitters_CreateEdit_HeaderUpdate$1,
    Reporting_Transmitters_CreateEdit_HostPlaceholder: Reporting_Transmitters_CreateEdit_HostPlaceholder$1,
    Reporting_Transmitters_CreateEdit_Password: Reporting_Transmitters_CreateEdit_Password$1,
    Reporting_Transmitters_CreateEdit_PasswordPlaceholder: Reporting_Transmitters_CreateEdit_PasswordPlaceholder$1,
    Reporting_Transmitters_CreateEdit_PortNumberError: Reporting_Transmitters_CreateEdit_PortNumberError$1,
    Reporting_Transmitters_CreateEdit_PrivateKey: Reporting_Transmitters_CreateEdit_PrivateKey$1,
    Reporting_Transmitters_CreateEdit_PrivateKeyPlaceholder: Reporting_Transmitters_CreateEdit_PrivateKeyPlaceholder$1,
    Reporting_Transmitters_CreateEdit_Subfolder: Reporting_Transmitters_CreateEdit_Subfolder$1,
    Reporting_Transmitters_CreateEdit_SubfolderPlaceholder: Reporting_Transmitters_CreateEdit_SubfolderPlaceholder$1,
    Reporting_Transmitters_CreateEdit_TitlePlaceholder: Reporting_Transmitters_CreateEdit_TitlePlaceholder$1,
    Reporting_Transmitters_CreateEdit_TypePlaceholder: Reporting_Transmitters_CreateEdit_TypePlaceholder$1,
    Reporting_Transmitters_CreateEdit_TypeTootltip: Reporting_Transmitters_CreateEdit_TypeTootltip$1,
    Reporting_Transmitters_CreateEdit_Username: Reporting_Transmitters_CreateEdit_Username$1,
    Reporting_Transmitters_CreateEdit_UsernamePlaceholder: Reporting_Transmitters_CreateEdit_UsernamePlaceholder$1,
    Reporting_Transmitters_CreateNew: Reporting_Transmitters_CreateNew$1,
    Reporting_Transmitters_Default: Reporting_Transmitters_Default$1,
    Reporting_Transmitters_Error_Create: Reporting_Transmitters_Error_Create$1,
    Reporting_Transmitters_Error_Delete: Reporting_Transmitters_Error_Delete$1,
    Reporting_Transmitters_Error_Get: Reporting_Transmitters_Error_Get$1,
    Reporting_Transmitters_Error_GetAll: Reporting_Transmitters_Error_GetAll$1,
    Reporting_Transmitters_Error_GetPGPKey: Reporting_Transmitters_Error_GetPGPKey$1,
    Reporting_Transmitters_Error_SavePGPKey: Reporting_Transmitters_Error_SavePGPKey$1,
    Reporting_Transmitters_Error_Update: Reporting_Transmitters_Error_Update$1,
    Reporting_Transmitters_Host: Reporting_Transmitters_Host$1,
    Reporting_Transmitters_PGPEncrypted: Reporting_Transmitters_PGPEncrypted$1,
    Reporting_Transmitters_PGPExtension: Reporting_Transmitters_PGPExtension$1,
    Reporting_Transmitters_Port: Reporting_Transmitters_Port$1,
    Reporting_Transmitters_SetupPGPKey: Reporting_Transmitters_SetupPGPKey$1,
    Reporting_Transmitters_SetupPGPKeyLabel: Reporting_Transmitters_SetupPGPKeyLabel$1,
    Reporting_Transmitters_SetupPGPKeyPlaceholder: Reporting_Transmitters_SetupPGPKeyPlaceholder$1,
    Reporting_Transmitters_SetupPGPKeyPlaceholderFilled: Reporting_Transmitters_SetupPGPKeyPlaceholderFilled$1,
    Reporting_Transmitters_SetupPGPKeyTooltip: Reporting_Transmitters_SetupPGPKeyTooltip$1,
    Reporting_Transmitters_SFTP: Reporting_Transmitters_SFTP$1,
    Reporting_Transmitters_Success_Create: Reporting_Transmitters_Success_Create$1,
    Reporting_Transmitters_Success_Delete: Reporting_Transmitters_Success_Delete$1,
    Reporting_Transmitters_Success_SavePGPKey: Reporting_Transmitters_Success_SavePGPKey$1,
    Reporting_Transmitters_Success_Update: Reporting_Transmitters_Success_Update$1,
    Reporting_Transmitters_Title: Reporting_Transmitters_Title$1,
    Reporting_Transmitters_Type: Reporting_Transmitters_Type$1,
    Reporting_Transmitters_TypeOptionClientProvided: Reporting_Transmitters_TypeOptionClientProvided$1,
    Reporting_Transmitters_TypeOptionDegreed: Reporting_Transmitters_TypeOptionDegreed$1,
    ReportingInApp_Actions_ChooseReportType: ReportingInApp_Actions_ChooseReportType$1,
    ReportingInApp_Actions_CreateNewReport: ReportingInApp_Actions_CreateNewReport$1,
    ReportingInApp_Actions_EditSchedule: ReportingInApp_Actions_EditSchedule$1,
    ReportingInApp_Actions_GenerateReport: ReportingInApp_Actions_GenerateReport$1,
    ReportingInApp_Actions_OpenDownloads: ReportingInApp_Actions_OpenDownloads$1,
    ReportingInApp_Actions_PreviewReport: ReportingInApp_Actions_PreviewReport$1,
    ReportingInApp_Actions_ScheduleReport: ReportingInApp_Actions_ScheduleReport$1,
    ReportingInApp_Actions_ViewReport: ReportingInApp_Actions_ViewReport$1,
    ReportingInApp_Categories: ReportingInApp_Categories$1,
    ReportingInApp_Create: ReportingInApp_Create$1,
    ReportingInApp_CustomFields: ReportingInApp_CustomFields$1,
    ReportingInApp_DataTable_DeliveredDate: ReportingInApp_DataTable_DeliveredDate$1,
    ReportingInApp_DataTable_LastRun: ReportingInApp_DataTable_LastRun$1,
    ReportingInApp_DataTable_NextRun: ReportingInApp_DataTable_NextRun$1,
    ReportingInApp_DataTable_ReportTitle: ReportingInApp_DataTable_ReportTitle$1,
    ReportingInApp_DataTable_ReportType: ReportingInApp_DataTable_ReportType$1,
    ReportingInApp_DataTable_Status: ReportingInApp_DataTable_Status$1,
    ReportingInApp_DataTable_TimePeriod: ReportingInApp_DataTable_TimePeriod$1,
    ReportingInApp_Downloads: ReportingInApp_Downloads$1,
    ReportingInApp_Downloads_Description: ReportingInApp_Downloads_Description$1,
    ReportingInApp_Downloads_RemovalNotice: ReportingInApp_Downloads_RemovalNotice$1,
    ReportingInApp_FileFormat_CommaDelimited: ReportingInApp_FileFormat_CommaDelimited$1,
    ReportingInApp_FileFormat_Excel: ReportingInApp_FileFormat_Excel$1,
    ReportingInApp_Filters_Button_Filter: ReportingInApp_Filters_Button_Filter$1,
    ReportingInApp_Filters_Modal_Button_AddColumn: ReportingInApp_Filters_Modal_Button_AddColumn$1,
    ReportingInApp_Filters_Modal_Button_Remove: ReportingInApp_Filters_Modal_Button_Remove$1,
    ReportingInApp_Filters_Modal_Header_Title: ReportingInApp_Filters_Modal_Header_Title$1,
    ReportingInApp_Filters_Modal_Header_Tooltip: ReportingInApp_Filters_Modal_Header_Tooltip$1,
    ReportingInApp_Filters_Modal_Hint_Number: ReportingInApp_Filters_Modal_Hint_Number$1,
    ReportingInApp_Filters_Modal_Hint_String: ReportingInApp_Filters_Modal_Hint_String$1,
    ReportingInApp_Filters_Modal_Label_Column: ReportingInApp_Filters_Modal_Label_Column$1,
    ReportingInApp_Filters_Modal_Label_Date: ReportingInApp_Filters_Modal_Label_Date$1,
    ReportingInApp_Filters_Modal_Label_Operator: ReportingInApp_Filters_Modal_Label_Operator$1,
    ReportingInApp_Filters_Modal_Label_Value: ReportingInApp_Filters_Modal_Label_Value$1,
    ReportingInApp_Filters_Modal_Operator_Contains: ReportingInApp_Filters_Modal_Operator_Contains$1,
    ReportingInApp_Filters_Modal_Operator_DoesNotEqual: ReportingInApp_Filters_Modal_Operator_DoesNotEqual$1,
    ReportingInApp_Filters_Modal_Operator_Empty: ReportingInApp_Filters_Modal_Operator_Empty$1,
    ReportingInApp_Filters_Modal_Operator_EndsWith: ReportingInApp_Filters_Modal_Operator_EndsWith$1,
    ReportingInApp_Filters_Modal_Operator_Equals: ReportingInApp_Filters_Modal_Operator_Equals$1,
    ReportingInApp_Filters_Modal_Operator_EqualsOrGreaterThan: ReportingInApp_Filters_Modal_Operator_EqualsOrGreaterThan$1,
    ReportingInApp_Filters_Modal_Operator_EqualsOrLessThan: ReportingInApp_Filters_Modal_Operator_EqualsOrLessThan$1,
    ReportingInApp_Filters_Modal_Operator_Exact: ReportingInApp_Filters_Modal_Operator_Exact$1,
    ReportingInApp_Filters_Modal_Operator_StartsWith: ReportingInApp_Filters_Modal_Operator_StartsWith$1,
    ReportingInApp_Filters_Modal_Placeholder_Column: ReportingInApp_Filters_Modal_Placeholder_Column$1,
    ReportingInApp_Filters_Modal_Placeholder_Operator: ReportingInApp_Filters_Modal_Placeholder_Operator$1,
    ReportingInApp_Filters_Modal_Placeholder_Value: ReportingInApp_Filters_Modal_Placeholder_Value$1,
    ReportingInApp_Filters_Modal_UnselectedColumn_Notice: ReportingInApp_Filters_Modal_UnselectedColumn_Notice$1,
    ReportingInApp_GeneratedReports: ReportingInApp_GeneratedReports$1,
    ReportingInApp_ReportCategories: ReportingInApp_ReportCategories$1,
    ReportingInApp_ReportCategory_ACM_Description: ReportingInApp_ReportCategory_ACM_Description$1,
    ReportingInApp_ReportCategory_ACM_Title: ReportingInApp_ReportCategory_ACM_Title$1,
    ReportingInApp_ReportCategory_Assignments_Description: ReportingInApp_ReportCategory_Assignments_Description$1,
    ReportingInApp_ReportCategory_Assignments_Title: ReportingInApp_ReportCategory_Assignments_Title$1,
    ReportingInApp_ReportCategory_Content_Description: ReportingInApp_ReportCategory_Content_Description$1,
    ReportingInApp_ReportCategory_Content_Title: ReportingInApp_ReportCategory_Content_Title$1,
    ReportingInApp_ReportCategory_Opportunities_Description: ReportingInApp_ReportCategory_Opportunities_Description$1,
    ReportingInApp_ReportCategory_Opportunities_Title: ReportingInApp_ReportCategory_Opportunities_Title$1,
    ReportingInApp_ReportCategory_Skills_Description: ReportingInApp_ReportCategory_Skills_Description$1,
    ReportingInApp_ReportCategory_Skills_Title: ReportingInApp_ReportCategory_Skills_Title$1,
    ReportingInApp_ReportCategory_User_Description: ReportingInApp_ReportCategory_User_Description$1,
    ReportingInApp_ReportCategory_User_Title: ReportingInApp_ReportCategory_User_Title$1,
    ReportingInApp_ReportCategorySection_Details_Description: ReportingInApp_ReportCategorySection_Details_Description$1,
    ReportingInApp_ReportCategorySection_Details_Title: ReportingInApp_ReportCategorySection_Details_Title$1,
    ReportingInApp_ReportCategorySection_Summary_Description: ReportingInApp_ReportCategorySection_Summary_Description$1,
    ReportingInApp_ReportCategorySection_Summary_Title: ReportingInApp_ReportCategorySection_Summary_Title$1,
    ReportingInApp_ReportColumn_AbsoluteParticipantCount: ReportingInApp_ReportColumn_AbsoluteParticipantCount$1,
    ReportingInApp_ReportColumn_AcademyId: ReportingInApp_ReportColumn_AcademyId$1,
    ReportingInApp_ReportColumn_AcademyName: ReportingInApp_ReportColumn_AcademyName$1,
    ReportingInApp_ReportColumn_AcademyProgressPercent: ReportingInApp_ReportColumn_AcademyProgressPercent$1,
    ReportingInApp_ReportColumn_AcademyTitle: ReportingInApp_ReportColumn_AcademyTitle$1,
    ReportingInApp_ReportColumn_AcademyUrl: ReportingInApp_ReportColumn_AcademyUrl$1,
    ReportingInApp_ReportColumn_Active: ReportingInApp_ReportColumn_Active$1,
    ReportingInApp_ReportColumn_AdditionalLearning: ReportingInApp_ReportColumn_AdditionalLearning$1,
    ReportingInApp_ReportColumn_ApplicationStage: ReportingInApp_ReportColumn_ApplicationStage$1,
    ReportingInApp_ReportColumn_ApplicationUrl: ReportingInApp_ReportColumn_ApplicationUrl$1,
    ReportingInApp_ReportColumn_Approver: ReportingInApp_ReportColumn_Approver$1,
    ReportingInApp_ReportColumn_ApproverEmail: ReportingInApp_ReportColumn_ApproverEmail$1,
    ReportingInApp_ReportColumn_ApproverFirstName: ReportingInApp_ReportColumn_ApproverFirstName$1,
    ReportingInApp_ReportColumn_ApproverId: ReportingInApp_ReportColumn_ApproverId$1,
    ReportingInApp_ReportColumn_ApproverLastName: ReportingInApp_ReportColumn_ApproverLastName$1,
    ReportingInApp_ReportColumn_ApproverName: ReportingInApp_ReportColumn_ApproverName$1,
    ReportingInApp_ReportColumn_AssignedDate: ReportingInApp_ReportColumn_AssignedDate$1,
    ReportingInApp_ReportColumn_AssigneeEmail: ReportingInApp_ReportColumn_AssigneeEmail$1,
    ReportingInApp_ReportColumn_AssigneeEmployeeId: ReportingInApp_ReportColumn_AssigneeEmployeeId$1,
    ReportingInApp_ReportColumn_AssigneeFirstName: ReportingInApp_ReportColumn_AssigneeFirstName$1,
    ReportingInApp_ReportColumn_AssigneeLastName: ReportingInApp_ReportColumn_AssigneeLastName$1,
    ReportingInApp_ReportColumn_AssigneeUserName: ReportingInApp_ReportColumn_AssigneeUserName$1,
    ReportingInApp_ReportColumn_AssignerEmail: ReportingInApp_ReportColumn_AssignerEmail$1,
    ReportingInApp_ReportColumn_AssignerEmployeeId: ReportingInApp_ReportColumn_AssignerEmployeeId$1,
    ReportingInApp_ReportColumn_AssignerFirstName: ReportingInApp_ReportColumn_AssignerFirstName$1,
    ReportingInApp_ReportColumn_AssignerLastName: ReportingInApp_ReportColumn_AssignerLastName$1,
    ReportingInApp_ReportColumn_AssignerUserName: ReportingInApp_ReportColumn_AssignerUserName$1,
    ReportingInApp_ReportColumn_AssignmentIsCompleted: ReportingInApp_ReportColumn_AssignmentIsCompleted$1,
    ReportingInApp_ReportColumn_AssignmentsCompleted: ReportingInApp_ReportColumn_AssignmentsCompleted$1,
    ReportingInApp_ReportColumn_AssinmentStatus: ReportingInApp_ReportColumn_AssinmentStatus$1,
    ReportingInApp_ReportColumn_AverageCompletionPercent: ReportingInApp_ReportColumn_AverageCompletionPercent$1,
    ReportingInApp_ReportColumn_AverageManagerRatingsAdded: ReportingInApp_ReportColumn_AverageManagerRatingsAdded$1,
    ReportingInApp_ReportColumn_AverageMangerRating: ReportingInApp_ReportColumn_AverageMangerRating$1,
    ReportingInApp_ReportColumn_AverageOptOutCount: ReportingInApp_ReportColumn_AverageOptOutCount$1,
    ReportingInApp_ReportColumn_AveragePeerRatings: ReportingInApp_ReportColumn_AveragePeerRatings$1,
    ReportingInApp_ReportColumn_AverageSelfRating: ReportingInApp_ReportColumn_AverageSelfRating$1,
    ReportingInApp_ReportColumn_AverageSkillTargetRating: ReportingInApp_ReportColumn_AverageSkillTargetRating$1,
    ReportingInApp_ReportColumn_AverageSkillTargetsAdded: ReportingInApp_ReportColumn_AverageSkillTargetsAdded$1,
    ReportingInApp_ReportColumn_AverageTeamFocusSkills: ReportingInApp_ReportColumn_AverageTeamFocusSkills$1,
    ReportingInApp_ReportColumn_AverageTeamSize: ReportingInApp_ReportColumn_AverageTeamSize$1,
    ReportingInApp_ReportColumn_BeingFollowedEmployeeId: ReportingInApp_ReportColumn_BeingFollowedEmployeeId$1,
    ReportingInApp_ReportColumn_BeingFollowedUserEmail: ReportingInApp_ReportColumn_BeingFollowedUserEmail$1,
    ReportingInApp_ReportColumn_BeingFollowedUserFirstName: ReportingInApp_ReportColumn_BeingFollowedUserFirstName$1,
    ReportingInApp_ReportColumn_BeingFollowedUserLastName: ReportingInApp_ReportColumn_BeingFollowedUserLastName$1,
    ReportingInApp_ReportColumn_BeingFollowedUserName: ReportingInApp_ReportColumn_BeingFollowedUserName$1,
    ReportingInApp_ReportColumn_Category: ReportingInApp_ReportColumn_Category$1,
    "ReportingInApp_ReportColumn_Category 1": "ReportingInApp_ReportColumn_Category 1",
    "ReportingInApp_ReportColumn_Category 10": "ReportingInApp_ReportColumn_Category 10",
    "ReportingInApp_ReportColumn_Category 11": "ReportingInApp_ReportColumn_Category 11",
    "ReportingInApp_ReportColumn_Category 12": "ReportingInApp_ReportColumn_Category 12",
    "ReportingInApp_ReportColumn_Category 13": "ReportingInApp_ReportColumn_Category 13",
    "ReportingInApp_ReportColumn_Category 14": "ReportingInApp_ReportColumn_Category 14",
    "ReportingInApp_ReportColumn_Category 15": "ReportingInApp_ReportColumn_Category 15",
    "ReportingInApp_ReportColumn_Category 2": "ReportingInApp_ReportColumn_Category 2",
    "ReportingInApp_ReportColumn_Category 3": "ReportingInApp_ReportColumn_Category 3",
    "ReportingInApp_ReportColumn_Category 4": "ReportingInApp_ReportColumn_Category 4",
    "ReportingInApp_ReportColumn_Category 5": "ReportingInApp_ReportColumn_Category 5",
    "ReportingInApp_ReportColumn_Category 6": "ReportingInApp_ReportColumn_Category 6",
    "ReportingInApp_ReportColumn_Category 7": "ReportingInApp_ReportColumn_Category 7",
    "ReportingInApp_ReportColumn_Category 8": "ReportingInApp_ReportColumn_Category 8",
    "ReportingInApp_ReportColumn_Category 9": "ReportingInApp_ReportColumn_Category 9",
    ReportingInApp_ReportColumn_Collaborators: ReportingInApp_ReportColumn_Collaborators$1,
    ReportingInApp_ReportColumn_CollaboratorsEmployeeId: ReportingInApp_ReportColumn_CollaboratorsEmployeeId$1,
    ReportingInApp_ReportColumn_CollaboratorsUserName: ReportingInApp_ReportColumn_CollaboratorsUserName$1,
    ReportingInApp_ReportColumn_CompletedContent: ReportingInApp_ReportColumn_CompletedContent$1,
    ReportingInApp_ReportColumn_CompletedCount: ReportingInApp_ReportColumn_CompletedCount$1,
    ReportingInApp_ReportColumn_CompletedDate: ReportingInApp_ReportColumn_CompletedDate$1,
    ReportingInApp_ReportColumn_CompletedOn: ReportingInApp_ReportColumn_CompletedOn$1,
    ReportingInApp_ReportColumn_CompletedRequiredContent: ReportingInApp_ReportColumn_CompletedRequiredContent$1,
    ReportingInApp_ReportColumn_CompletionCompletedDate: ReportingInApp_ReportColumn_CompletionCompletedDate$1,
    ReportingInApp_ReportColumn_CompletionCreatedDate: ReportingInApp_ReportColumn_CompletionCreatedDate$1,
    ReportingInApp_ReportColumn_CompletionDate: ReportingInApp_ReportColumn_CompletionDate$1,
    ReportingInApp_ReportColumn_CompletionIsVerified: ReportingInApp_ReportColumn_CompletionIsVerified$1,
    ReportingInApp_ReportColumn_CompletionPercent: ReportingInApp_ReportColumn_CompletionPercent$1,
    ReportingInApp_ReportColumn_CompletionPercentage: ReportingInApp_ReportColumn_CompletionPercentage$1,
    ReportingInApp_ReportColumn_CompletionPoints: ReportingInApp_ReportColumn_CompletionPoints$1,
    ReportingInApp_ReportColumn_Completions: ReportingInApp_ReportColumn_Completions$1,
    ReportingInApp_ReportColumn_CompletionTags: ReportingInApp_ReportColumn_CompletionTags$1,
    ReportingInApp_ReportColumn_CompletionUserRating: ReportingInApp_ReportColumn_CompletionUserRating$1,
    ReportingInApp_ReportColumn_ContentCompleted: ReportingInApp_ReportColumn_ContentCompleted$1,
    ReportingInApp_ReportColumn_ContentCompletedCount: ReportingInApp_ReportColumn_ContentCompletedCount$1,
    ReportingInApp_ReportColumn_ContentCompletedDate: ReportingInApp_ReportColumn_ContentCompletedDate$1,
    ReportingInApp_ReportColumn_ContentDescription: ReportingInApp_ReportColumn_ContentDescription$1,
    ReportingInApp_ReportColumn_ContentDuration: ReportingInApp_ReportColumn_ContentDuration$1,
    ReportingInApp_ReportColumn_ContentDurationType: ReportingInApp_ReportColumn_ContentDurationType$1,
    ReportingInApp_ReportColumn_ContentId: ReportingInApp_ReportColumn_ContentId$1,
    ReportingInApp_ReportColumn_ContentOwnerName: ReportingInApp_ReportColumn_ContentOwnerName$1,
    ReportingInApp_ReportColumn_ContentProvider: ReportingInApp_ReportColumn_ContentProvider$1,
    ReportingInApp_ReportColumn_ContentTitle: ReportingInApp_ReportColumn_ContentTitle$1,
    ReportingInApp_ReportColumn_ContentType: ReportingInApp_ReportColumn_ContentType$1,
    ReportingInApp_ReportColumn_ContentUrl: ReportingInApp_ReportColumn_ContentUrl$1,
    ReportingInApp_ReportColumn_Contributors: ReportingInApp_ReportColumn_Contributors$1,
    ReportingInApp_ReportColumn_Cost: ReportingInApp_ReportColumn_Cost$1,
    ReportingInApp_ReportColumn_CostCenter: ReportingInApp_ReportColumn_CostCenter$1,
    ReportingInApp_ReportColumn_CreatedBy: ReportingInApp_ReportColumn_CreatedBy$1,
    ReportingInApp_ReportColumn_CreatedByEmail: ReportingInApp_ReportColumn_CreatedByEmail$1,
    ReportingInApp_ReportColumn_CreatedByEmployeeId: ReportingInApp_ReportColumn_CreatedByEmployeeId$1,
    ReportingInApp_ReportColumn_CreatedByFirstName: ReportingInApp_ReportColumn_CreatedByFirstName$1,
    ReportingInApp_ReportColumn_CreatedById: ReportingInApp_ReportColumn_CreatedById$1,
    ReportingInApp_ReportColumn_CreatedByLastName: ReportingInApp_ReportColumn_CreatedByLastName$1,
    ReportingInApp_ReportColumn_CreatedByName: ReportingInApp_ReportColumn_CreatedByName$1,
    ReportingInApp_ReportColumn_CreatedByUserName: ReportingInApp_ReportColumn_CreatedByUserName$1,
    ReportingInApp_ReportColumn_CreatedDate: ReportingInApp_ReportColumn_CreatedDate$1,
    ReportingInApp_ReportColumn_CreatedDateOfOpportunity: ReportingInApp_ReportColumn_CreatedDateOfOpportunity$1,
    ReportingInApp_ReportColumn_CreatedOn: ReportingInApp_ReportColumn_CreatedOn$1,
    ReportingInApp_ReportColumn_Currency: ReportingInApp_ReportColumn_Currency$1,
    "ReportingInApp_ReportColumn_CurrentTotalUsers100%": "Current Total Users 100%",
    ReportingInApp_ReportColumn_DailyDigestEmail: ReportingInApp_ReportColumn_DailyDigestEmail$1,
    ReportingInApp_ReportColumn_DateAdded: ReportingInApp_ReportColumn_DateAdded$1,
    ReportingInApp_ReportColumn_DateApprovedOrDeclined: ReportingInApp_ReportColumn_DateApprovedOrDeclined$1,
    ReportingInApp_ReportColumn_DateInvited: ReportingInApp_ReportColumn_DateInvited$1,
    ReportingInApp_ReportColumn_DateJoined: ReportingInApp_ReportColumn_DateJoined$1,
    ReportingInApp_ReportColumn_DateOfLastContentCompletion: ReportingInApp_ReportColumn_DateOfLastContentCompletion$1,
    ReportingInApp_ReportColumn_DateSearched: ReportingInApp_ReportColumn_DateSearched$1,
    ReportingInApp_ReportColumn_DateShared: ReportingInApp_ReportColumn_DateShared$1,
    ReportingInApp_ReportColumn_DateUserInterested: ReportingInApp_ReportColumn_DateUserInterested$1,
    ReportingInApp_ReportColumn_DateViewed: ReportingInApp_ReportColumn_DateViewed$1,
    ReportingInApp_ReportColumn_Department: ReportingInApp_ReportColumn_Department$1,
    ReportingInApp_ReportColumn_Description: ReportingInApp_ReportColumn_Description$1,
    ReportingInApp_ReportColumn_DirectReportEmail: ReportingInApp_ReportColumn_DirectReportEmail$1,
    ReportingInApp_ReportColumn_DirectReportFirstName: ReportingInApp_ReportColumn_DirectReportFirstName$1,
    ReportingInApp_ReportColumn_DirectReportId: ReportingInApp_ReportColumn_DirectReportId$1,
    ReportingInApp_ReportColumn_DirectReportLastName: ReportingInApp_ReportColumn_DirectReportLastName$1,
    ReportingInApp_ReportColumn_DirectReportName: ReportingInApp_ReportColumn_DirectReportName$1,
    ReportingInApp_ReportColumn_Discriminator: ReportingInApp_ReportColumn_Discriminator$1,
    ReportingInApp_ReportColumn_DueDate: ReportingInApp_ReportColumn_DueDate$1,
    ReportingInApp_ReportColumn_DueDateLocal: ReportingInApp_ReportColumn_DueDateLocal$1,
    ReportingInApp_ReportColumn_Duration: ReportingInApp_ReportColumn_Duration$1,
    ReportingInApp_ReportColumn_DurationInMinutes: ReportingInApp_ReportColumn_DurationInMinutes$1,
    ReportingInApp_ReportColumn_DurationUnitName: ReportingInApp_ReportColumn_DurationUnitName$1,
    ReportingInApp_ReportColumn_DurationUnits: ReportingInApp_ReportColumn_DurationUnits$1,
    ReportingInApp_ReportColumn_EmployeeId: ReportingInApp_ReportColumn_EmployeeId$1,
    ReportingInApp_ReportColumn_Endorsed: ReportingInApp_ReportColumn_Endorsed$1,
    ReportingInApp_ReportColumn_Enrolled: ReportingInApp_ReportColumn_Enrolled$1,
    ReportingInApp_ReportColumn_EnrolledUsers: ReportingInApp_ReportColumn_EnrolledUsers$1,
    ReportingInApp_ReportColumn_EstimatedLearningHours: ReportingInApp_ReportColumn_EstimatedLearningHours$1,
    ReportingInApp_ReportColumn_EstimatedLearningMinutes: ReportingInApp_ReportColumn_EstimatedLearningMinutes$1,
    ReportingInApp_ReportColumn_ExtractionDate: ReportingInApp_ReportColumn_ExtractionDate$1,
    ReportingInApp_ReportColumn_Feedback: ReportingInApp_ReportColumn_Feedback$1,
    ReportingInApp_ReportColumn_FirstLogin: ReportingInApp_ReportColumn_FirstLogin$1,
    ReportingInApp_ReportColumn_FollowerEmployeeId: ReportingInApp_ReportColumn_FollowerEmployeeId$1,
    ReportingInApp_ReportColumn_FollowerManagerId: ReportingInApp_ReportColumn_FollowerManagerId$1,
    ReportingInApp_ReportColumn_FollowerManagerName: ReportingInApp_ReportColumn_FollowerManagerName$1,
    ReportingInApp_ReportColumn_FollowerUserEmail: ReportingInApp_ReportColumn_FollowerUserEmail$1,
    ReportingInApp_ReportColumn_FollowerUserFirstName: ReportingInApp_ReportColumn_FollowerUserFirstName$1,
    ReportingInApp_ReportColumn_FollowerUserLastName: ReportingInApp_ReportColumn_FollowerUserLastName$1,
    ReportingInApp_ReportColumn_FollowerUserName: ReportingInApp_ReportColumn_FollowerUserName$1,
    ReportingInApp_ReportColumn_FollowerUserStatus: ReportingInApp_ReportColumn_FollowerUserStatus$1,
    ReportingInApp_ReportColumn_Group: ReportingInApp_ReportColumn_Group$1,
    "ReportingInApp_ReportColumn_Group 1": "ReportingInApp_ReportColumn_Group 1",
    "ReportingInApp_ReportColumn_Group 10": "ReportingInApp_ReportColumn_Group 10",
    "ReportingInApp_ReportColumn_Group 11": "ReportingInApp_ReportColumn_Group 11",
    "ReportingInApp_ReportColumn_Group 12": "ReportingInApp_ReportColumn_Group 12",
    "ReportingInApp_ReportColumn_Group 13": "ReportingInApp_ReportColumn_Group 13",
    "ReportingInApp_ReportColumn_Group 14": "ReportingInApp_ReportColumn_Group 14",
    "ReportingInApp_ReportColumn_Group 15": "ReportingInApp_ReportColumn_Group 15",
    "ReportingInApp_ReportColumn_Group 2": "ReportingInApp_ReportColumn_Group 2",
    "ReportingInApp_ReportColumn_Group 3": "ReportingInApp_ReportColumn_Group 3",
    "ReportingInApp_ReportColumn_Group 4": "ReportingInApp_ReportColumn_Group 4",
    "ReportingInApp_ReportColumn_Group 5": "ReportingInApp_ReportColumn_Group 5",
    "ReportingInApp_ReportColumn_Group 6": "ReportingInApp_ReportColumn_Group 6",
    "ReportingInApp_ReportColumn_Group 7": "ReportingInApp_ReportColumn_Group 7",
    "ReportingInApp_ReportColumn_Group 8": "ReportingInApp_ReportColumn_Group 8",
    "ReportingInApp_ReportColumn_Group 9": "ReportingInApp_ReportColumn_Group 9",
    ReportingInApp_ReportColumn_GroupName: ReportingInApp_ReportColumn_GroupName$1,
    ReportingInApp_ReportColumn_GroupRole: ReportingInApp_ReportColumn_GroupRole$1,
    ReportingInApp_ReportColumn_GroupsVisibility: ReportingInApp_ReportColumn_GroupsVisibility$1,
    ReportingInApp_ReportColumn_InterestedEmail: ReportingInApp_ReportColumn_InterestedEmail$1,
    ReportingInApp_ReportColumn_InterestedEmployeeId: ReportingInApp_ReportColumn_InterestedEmployeeId$1,
    ReportingInApp_ReportColumn_InterestedUserFirstName: ReportingInApp_ReportColumn_InterestedUserFirstName$1,
    ReportingInApp_ReportColumn_InterestedUserLastName: ReportingInApp_ReportColumn_InterestedUserLastName$1,
    ReportingInApp_ReportColumn_InterestedUserName: ReportingInApp_ReportColumn_InterestedUserName$1,
    ReportingInApp_ReportColumn_InterestedUserSkillMatch: ReportingInApp_ReportColumn_InterestedUserSkillMatch$1,
    ReportingInApp_ReportColumn_InterestedUserStage: ReportingInApp_ReportColumn_InterestedUserStage$1,
    ReportingInApp_ReportColumn_InternalExternalContent: ReportingInApp_ReportColumn_InternalExternalContent$1,
    ReportingInApp_ReportColumn_InternalId: ReportingInApp_ReportColumn_InternalId$1,
    ReportingInApp_ReportColumn_InternalManagerRatings: ReportingInApp_ReportColumn_InternalManagerRatings$1,
    ReportingInApp_ReportColumn_InternalSelfRatings: ReportingInApp_ReportColumn_InternalSelfRatings$1,
    ReportingInApp_ReportColumn_InternalSkillReviews: ReportingInApp_ReportColumn_InternalSkillReviews$1,
    ReportingInApp_ReportColumn_IsCompanySpecificProgram: ReportingInApp_ReportColumn_IsCompanySpecificProgram$1,
    ReportingInApp_ReportColumn_IsFollowing: ReportingInApp_ReportColumn_IsFollowing$1,
    ReportingInApp_ReportColumn_ItemId: ReportingInApp_ReportColumn_ItemId$1,
    ReportingInApp_ReportColumn_ItemName: ReportingInApp_ReportColumn_ItemName$1,
    ReportingInApp_ReportColumn_ItemType: ReportingInApp_ReportColumn_ItemType$1,
    ReportingInApp_ReportColumn_JobRole: ReportingInApp_ReportColumn_JobRole$1,
    ReportingInApp_ReportColumn_Language: ReportingInApp_ReportColumn_Language$1,
    ReportingInApp_ReportColumn_LastLogin: ReportingInApp_ReportColumn_LastLogin$1,
    ReportingInApp_ReportColumn_LastRatedDate: ReportingInApp_ReportColumn_LastRatedDate$1,
    ReportingInApp_ReportColumn_LastUpdated: ReportingInApp_ReportColumn_LastUpdated$1,
    ReportingInApp_ReportColumn_LastUpdateDate: ReportingInApp_ReportColumn_LastUpdateDate$1,
    ReportingInApp_ReportColumn_LastUpdatedOfOpportunity: ReportingInApp_ReportColumn_LastUpdatedOfOpportunity$1,
    ReportingInApp_ReportColumn_LatestCompletionDate: ReportingInApp_ReportColumn_LatestCompletionDate$1,
    ReportingInApp_ReportColumn_LearnerStatus: ReportingInApp_ReportColumn_LearnerStatus$1,
    ReportingInApp_ReportColumn_LessonDescription: ReportingInApp_ReportColumn_LessonDescription$1,
    ReportingInApp_ReportColumn_LessonNumber: ReportingInApp_ReportColumn_LessonNumber$1,
    ReportingInApp_ReportColumn_LessonTitle: ReportingInApp_ReportColumn_LessonTitle$1,
    ReportingInApp_ReportColumn_Location: ReportingInApp_ReportColumn_Location$1,
    ReportingInApp_ReportColumn_LoggedInDate: ReportingInApp_ReportColumn_LoggedInDate$1,
    ReportingInApp_ReportColumn_ManagerCount: ReportingInApp_ReportColumn_ManagerCount$1,
    ReportingInApp_ReportColumn_ManagerEmail: ReportingInApp_ReportColumn_ManagerEmail$1,
    ReportingInApp_ReportColumn_ManagerEmployeeId: ReportingInApp_ReportColumn_ManagerEmployeeId$1,
    ReportingInApp_ReportColumn_ManagerFirstName: ReportingInApp_ReportColumn_ManagerFirstName$1,
    ReportingInApp_ReportColumn_ManagerId: ReportingInApp_ReportColumn_ManagerId$1,
    ReportingInApp_ReportColumn_ManagerLastName: ReportingInApp_ReportColumn_ManagerLastName$1,
    ReportingInApp_ReportColumn_ManagerName: ReportingInApp_ReportColumn_ManagerName$1,
    ReportingInApp_ReportColumn_ManagerRating: ReportingInApp_ReportColumn_ManagerRating$1,
    ReportingInApp_ReportColumn_ManagerRatingAverage: ReportingInApp_ReportColumn_ManagerRatingAverage$1,
    ReportingInApp_ReportColumn_MarketplaceTitle: ReportingInApp_ReportColumn_MarketplaceTitle$1,
    ReportingInApp_ReportColumn_MenteeEmail: ReportingInApp_ReportColumn_MenteeEmail$1,
    ReportingInApp_ReportColumn_MenteeEmployeeId: ReportingInApp_ReportColumn_MenteeEmployeeId$1,
    ReportingInApp_ReportColumn_MenteeUserFirstName: ReportingInApp_ReportColumn_MenteeUserFirstName$1,
    ReportingInApp_ReportColumn_MenteeUserLastName: ReportingInApp_ReportColumn_MenteeUserLastName$1,
    ReportingInApp_ReportColumn_MenteeUserName: ReportingInApp_ReportColumn_MenteeUserName$1,
    ReportingInApp_ReportColumn_MentorEmployeeId: ReportingInApp_ReportColumn_MentorEmployeeId$1,
    ReportingInApp_ReportColumn_MentorUserEmail: ReportingInApp_ReportColumn_MentorUserEmail$1,
    ReportingInApp_ReportColumn_MentorUserFirstName: ReportingInApp_ReportColumn_MentorUserFirstName$1,
    ReportingInApp_ReportColumn_MentorUserLastName: ReportingInApp_ReportColumn_MentorUserLastName$1,
    ReportingInApp_ReportColumn_MentorUserName: ReportingInApp_ReportColumn_MentorUserName$1,
    ReportingInApp_ReportColumn_Nominated: ReportingInApp_ReportColumn_Nominated$1,
    ReportingInApp_ReportColumn_NoReply: ReportingInApp_ReportColumn_NoReply$1,
    ReportingInApp_ReportColumn_NumberOfInterestedCandidates: ReportingInApp_ReportColumn_NumberOfInterestedCandidates$1,
    ReportingInApp_ReportColumn_NumberOfMatchedCandidates: ReportingInApp_ReportColumn_NumberOfMatchedCandidates$1,
    ReportingInApp_ReportColumn_NumberOfRequiredSkills: ReportingInApp_ReportColumn_NumberOfRequiredSkills$1,
    ReportingInApp_ReportColumn_NumberOfSelectedCandidates: ReportingInApp_ReportColumn_NumberOfSelectedCandidates$1,
    ReportingInApp_ReportColumn_NumberOfShares: ReportingInApp_ReportColumn_NumberOfShares$1,
    ReportingInApp_ReportColumn_NumberOfShortlistedCandidates: ReportingInApp_ReportColumn_NumberOfShortlistedCandidates$1,
    ReportingInApp_ReportColumn_OpportunityDescription: ReportingInApp_ReportColumn_OpportunityDescription$1,
    ReportingInApp_ReportColumn_OpportunityId: ReportingInApp_ReportColumn_OpportunityId$1,
    ReportingInApp_ReportColumn_OpportunityIsObsolete: ReportingInApp_ReportColumn_OpportunityIsObsolete$1,
    ReportingInApp_ReportColumn_OpportunityOwnerEmployeeId: ReportingInApp_ReportColumn_OpportunityOwnerEmployeeId$1,
    ReportingInApp_ReportColumn_OpportunityOwnerUserName: ReportingInApp_ReportColumn_OpportunityOwnerUserName$1,
    ReportingInApp_ReportColumn_OpportunitySkills: ReportingInApp_ReportColumn_OpportunitySkills$1,
    ReportingInApp_ReportColumn_OpportunityStatus: ReportingInApp_ReportColumn_OpportunityStatus$1,
    ReportingInApp_ReportColumn_OpportunityTitle: ReportingInApp_ReportColumn_OpportunityTitle$1,
    ReportingInApp_ReportColumn_OpportunityType: ReportingInApp_ReportColumn_OpportunityType$1,
    ReportingInApp_ReportColumn_OpportunityUrl: ReportingInApp_ReportColumn_OpportunityUrl$1,
    ReportingInApp_ReportColumn_OpportunityVisibility: ReportingInApp_ReportColumn_OpportunityVisibility$1,
    ReportingInApp_ReportColumn_OptOut: ReportingInApp_ReportColumn_OptOut$1,
    ReportingInApp_ReportColumn_OptOutCount: ReportingInApp_ReportColumn_OptOutCount$1,
    ReportingInApp_ReportColumn_Order: ReportingInApp_ReportColumn_Order$1,
    ReportingInApp_ReportColumn_PathwayCompletedCount: ReportingInApp_ReportColumn_PathwayCompletedCount$1,
    ReportingInApp_ReportColumn_PathwayContentCount: ReportingInApp_ReportColumn_PathwayContentCount$1,
    ReportingInApp_ReportColumn_PathwayFollowDate: ReportingInApp_ReportColumn_PathwayFollowDate$1,
    ReportingInApp_ReportColumn_PathwayFollowedCount: ReportingInApp_ReportColumn_PathwayFollowedCount$1,
    ReportingInApp_ReportColumn_PathwayId: ReportingInApp_ReportColumn_PathwayId$1,
    ReportingInApp_ReportColumn_PathwayProgress: ReportingInApp_ReportColumn_PathwayProgress$1,
    ReportingInApp_ReportColumn_PathwayRequiredContentCount: ReportingInApp_ReportColumn_PathwayRequiredContentCount$1,
    ReportingInApp_ReportColumn_Pathways: ReportingInApp_ReportColumn_Pathways$1,
    ReportingInApp_ReportColumn_PathwayTitle: ReportingInApp_ReportColumn_PathwayTitle$1,
    ReportingInApp_ReportColumn_PathwayTopic: ReportingInApp_ReportColumn_PathwayTopic$1,
    ReportingInApp_ReportColumn_PathwayType: ReportingInApp_ReportColumn_PathwayType$1,
    ReportingInApp_ReportColumn_PathwayUrl: ReportingInApp_ReportColumn_PathwayUrl$1,
    ReportingInApp_ReportColumn_PathwayUserCount: ReportingInApp_ReportColumn_PathwayUserCount$1,
    ReportingInApp_ReportColumn_PeerRatings: ReportingInApp_ReportColumn_PeerRatings$1,
    ReportingInApp_ReportColumn_PercentOfSkillsMatched: ReportingInApp_ReportColumn_PercentOfSkillsMatched$1,
    ReportingInApp_ReportColumn_PermissionRole: ReportingInApp_ReportColumn_PermissionRole$1,
    ReportingInApp_ReportColumn_PlanFollowedCount: ReportingInApp_ReportColumn_PlanFollowedCount$1,
    ReportingInApp_ReportColumn_PlanId: ReportingInApp_ReportColumn_PlanId$1,
    ReportingInApp_ReportColumn_Plans: ReportingInApp_ReportColumn_Plans$1,
    ReportingInApp_ReportColumn_PlanTitle: ReportingInApp_ReportColumn_PlanTitle$1,
    ReportingInApp_ReportColumn_PlanType: ReportingInApp_ReportColumn_PlanType$1,
    ReportingInApp_ReportColumn_PlanUrl: ReportingInApp_ReportColumn_PlanUrl$1,
    ReportingInApp_ReportColumn_PreapprovalRequired: ReportingInApp_ReportColumn_PreapprovalRequired$1,
    ReportingInApp_ReportColumn_ProfilePrivacy: ReportingInApp_ReportColumn_ProfilePrivacy$1,
    ReportingInApp_ReportColumn_ProgramCostAmount: ReportingInApp_ReportColumn_ProgramCostAmount$1,
    ReportingInApp_ReportColumn_ProgramCostCurrency: ReportingInApp_ReportColumn_ProgramCostCurrency$1,
    ReportingInApp_ReportColumn_ProgramDuration: ReportingInApp_ReportColumn_ProgramDuration$1,
    ReportingInApp_ReportColumn_ProgramDurationUnit: ReportingInApp_ReportColumn_ProgramDurationUnit$1,
    ReportingInApp_ReportColumn_ProgramId: ReportingInApp_ReportColumn_ProgramId$1,
    ReportingInApp_ReportColumn_ProgramLength: ReportingInApp_ReportColumn_ProgramLength$1,
    ReportingInApp_ReportColumn_ProgramLengthUnit: ReportingInApp_ReportColumn_ProgramLengthUnit$1,
    ReportingInApp_ReportColumn_ProgramName: ReportingInApp_ReportColumn_ProgramName$1,
    ReportingInApp_ReportColumn_ProgramTitle: ReportingInApp_ReportColumn_ProgramTitle$1,
    ReportingInApp_ReportColumn_Provider: ReportingInApp_ReportColumn_Provider$1,
    ReportingInApp_ReportColumn_ProviderName: ReportingInApp_ReportColumn_ProviderName$1,
    ReportingInApp_ReportColumn_PublishedDate: ReportingInApp_ReportColumn_PublishedDate$1,
    ReportingInApp_ReportColumn_RealTimeEmailNotification: ReportingInApp_ReportColumn_RealTimeEmailNotification$1,
    ReportingInApp_ReportColumn_RecipientEmail: ReportingInApp_ReportColumn_RecipientEmail$1,
    ReportingInApp_ReportColumn_RecipientEmployeeId: ReportingInApp_ReportColumn_RecipientEmployeeId$1,
    ReportingInApp_ReportColumn_RecipientGroupName: ReportingInApp_ReportColumn_RecipientGroupName$1,
    ReportingInApp_ReportColumn_RecipientUserFirstName: ReportingInApp_ReportColumn_RecipientUserFirstName$1,
    ReportingInApp_ReportColumn_RecipientUserLastName: ReportingInApp_ReportColumn_RecipientUserLastName$1,
    ReportingInApp_ReportColumn_RecipientUserName: ReportingInApp_ReportColumn_RecipientUserName$1,
    ReportingInApp_ReportColumn_RecommendationType: ReportingInApp_ReportColumn_RecommendationType$1,
    ReportingInApp_ReportColumn_RepliedNo: ReportingInApp_ReportColumn_RepliedNo$1,
    ReportingInApp_ReportColumn_RepliedYes: ReportingInApp_ReportColumn_RepliedYes$1,
    ReportingInApp_ReportColumn_RequestedAmount: ReportingInApp_ReportColumn_RequestedAmount$1,
    ReportingInApp_ReportColumn_RequestedAmountCurrency: ReportingInApp_ReportColumn_RequestedAmountCurrency$1,
    ReportingInApp_ReportColumn_RequestedAmountUSD: ReportingInApp_ReportColumn_RequestedAmountUSD$1,
    ReportingInApp_ReportColumn_RequestedDate: ReportingInApp_ReportColumn_RequestedDate$1,
    ReportingInApp_ReportColumn_RequestId: ReportingInApp_ReportColumn_RequestId$1,
    ReportingInApp_ReportColumn_RequestType: ReportingInApp_ReportColumn_RequestType$1,
    ReportingInApp_ReportColumn_Required: ReportingInApp_ReportColumn_Required$1,
    ReportingInApp_ReportColumn_RequiredSkill: ReportingInApp_ReportColumn_RequiredSkill$1,
    ReportingInApp_ReportColumn_ResourceId: ReportingInApp_ReportColumn_ResourceId$1,
    ReportingInApp_ReportColumn_ResourceTitle: ReportingInApp_ReportColumn_ResourceTitle$1,
    ReportingInApp_ReportColumn_ResourceType: ReportingInApp_ReportColumn_ResourceType$1,
    ReportingInApp_ReportColumn_ResourceUrl: ReportingInApp_ReportColumn_ResourceUrl$1,
    ReportingInApp_ReportColumn_RestrictedAccess: ReportingInApp_ReportColumn_RestrictedAccess$1,
    ReportingInApp_ReportColumn_RsvpStatus: ReportingInApp_ReportColumn_RsvpStatus$1,
    ReportingInApp_ReportColumn_SearchCount: ReportingInApp_ReportColumn_SearchCount$1,
    ReportingInApp_ReportColumn_SearchTerm: ReportingInApp_ReportColumn_SearchTerm$1,
    ReportingInApp_ReportColumn_SectionContentCount: ReportingInApp_ReportColumn_SectionContentCount$1,
    ReportingInApp_ReportColumn_SectionDescription: ReportingInApp_ReportColumn_SectionDescription$1,
    ReportingInApp_ReportColumn_SectionNumber: ReportingInApp_ReportColumn_SectionNumber$1,
    ReportingInApp_ReportColumn_SectionOrder: ReportingInApp_ReportColumn_SectionOrder$1,
    ReportingInApp_ReportColumn_SectionTitle: ReportingInApp_ReportColumn_SectionTitle$1,
    ReportingInApp_ReportColumn_SegmentName: ReportingInApp_ReportColumn_SegmentName$1,
    ReportingInApp_ReportColumn_SelfRating: ReportingInApp_ReportColumn_SelfRating$1,
    ReportingInApp_ReportColumn_SelfRatingAverage: ReportingInApp_ReportColumn_SelfRatingAverage$1,
    ReportingInApp_ReportColumn_SharedByEmail: ReportingInApp_ReportColumn_SharedByEmail$1,
    ReportingInApp_ReportColumn_SharedByEmployeeId: ReportingInApp_ReportColumn_SharedByEmployeeId$1,
    ReportingInApp_ReportColumn_SharedByFirstName: ReportingInApp_ReportColumn_SharedByFirstName$1,
    ReportingInApp_ReportColumn_SharedByLastName: ReportingInApp_ReportColumn_SharedByLastName$1,
    ReportingInApp_ReportColumn_SharedByUserName: ReportingInApp_ReportColumn_SharedByUserName$1,
    ReportingInApp_ReportColumn_ShareStatus: ReportingInApp_ReportColumn_ShareStatus$1,
    ReportingInApp_ReportColumn_SkillAddedCount: ReportingInApp_ReportColumn_SkillAddedCount$1,
    ReportingInApp_ReportColumn_SkillCertificationRating: ReportingInApp_ReportColumn_SkillCertificationRating$1,
    ReportingInApp_ReportColumn_SkillFocusCount: ReportingInApp_ReportColumn_SkillFocusCount$1,
    ReportingInApp_ReportColumn_SkillFocusedDate: ReportingInApp_ReportColumn_SkillFocusedDate$1,
    ReportingInApp_ReportColumn_SkillFollowDate: ReportingInApp_ReportColumn_SkillFollowDate$1,
    ReportingInApp_ReportColumn_SkillFollowedDate: ReportingInApp_ReportColumn_SkillFollowedDate$1,
    ReportingInApp_ReportColumn_SkillIsFocused: ReportingInApp_ReportColumn_SkillIsFocused$1,
    ReportingInApp_ReportColumn_SkillLevelAverage: ReportingInApp_ReportColumn_SkillLevelAverage$1,
    ReportingInApp_ReportColumn_SkillName: ReportingInApp_ReportColumn_SkillName$1,
    ReportingInApp_ReportColumn_SkillRatedCount: ReportingInApp_ReportColumn_SkillRatedCount$1,
    ReportingInApp_ReportColumn_SkillRatedDate: ReportingInApp_ReportColumn_SkillRatedDate$1,
    ReportingInApp_ReportColumn_SkillRating: ReportingInApp_ReportColumn_SkillRating$1,
    ReportingInApp_ReportColumn_SkillRatingLabel: ReportingInApp_ReportColumn_SkillRatingLabel$1,
    ReportingInApp_ReportColumn_SkillRatingPrivacy: ReportingInApp_ReportColumn_SkillRatingPrivacy$1,
    ReportingInApp_ReportColumn_SkillRatingType: ReportingInApp_ReportColumn_SkillRatingType$1,
    ReportingInApp_ReportColumn_SkillReviewAverage: ReportingInApp_ReportColumn_SkillReviewAverage$1,
    ReportingInApp_ReportColumn_Skills: ReportingInApp_ReportColumn_Skills$1,
    ReportingInApp_ReportColumn_SkillStandardName: ReportingInApp_ReportColumn_SkillStandardName$1,
    ReportingInApp_ReportColumn_Source: ReportingInApp_ReportColumn_Source$1,
    ReportingInApp_ReportColumn_StartDate: ReportingInApp_ReportColumn_StartDate$1,
    ReportingInApp_ReportColumn_Status: ReportingInApp_ReportColumn_Status$1,
    ReportingInApp_ReportColumn_StatusChangeDate: ReportingInApp_ReportColumn_StatusChangeDate$1,
    ReportingInApp_ReportColumn_StepNumber: ReportingInApp_ReportColumn_StepNumber$1,
    ReportingInApp_ReportColumn_StepTitle: ReportingInApp_ReportColumn_StepTitle$1,
    ReportingInApp_ReportColumn_StepType: ReportingInApp_ReportColumn_StepType$1,
    ReportingInApp_ReportColumn_SubmissionType: ReportingInApp_ReportColumn_SubmissionType$1,
    ReportingInApp_ReportColumn_Summary: ReportingInApp_ReportColumn_Summary$1,
    ReportingInApp_ReportColumn_TargetFollowDate: ReportingInApp_ReportColumn_TargetFollowDate$1,
    ReportingInApp_ReportColumn_TargetLevel: ReportingInApp_ReportColumn_TargetLevel$1,
    ReportingInApp_ReportColumn_TargetRating: ReportingInApp_ReportColumn_TargetRating$1,
    ReportingInApp_ReportColumn_TeamFocusSkillList: ReportingInApp_ReportColumn_TeamFocusSkillList$1,
    ReportingInApp_ReportColumn_TeamFocusSkillsRatings: ReportingInApp_ReportColumn_TeamFocusSkillsRatings$1,
    ReportingInApp_ReportColumn_TeamSize: ReportingInApp_ReportColumn_TeamSize$1,
    ReportingInApp_ReportColumn_TextResponse: ReportingInApp_ReportColumn_TextResponse$1,
    ReportingInApp_ReportColumn_ThumbnailUrl: ReportingInApp_ReportColumn_ThumbnailUrl$1,
    ReportingInApp_ReportColumn_ThumbsDown: ReportingInApp_ReportColumn_ThumbsDown$1,
    ReportingInApp_ReportColumn_ThumbsUp: ReportingInApp_ReportColumn_ThumbsUp$1,
    ReportingInApp_ReportColumn_Title: ReportingInApp_ReportColumn_Title$1,
    ReportingInApp_ReportColumn_TotalAcademyContent: ReportingInApp_ReportColumn_TotalAcademyContent$1,
    ReportingInApp_ReportColumn_TotalAssignments: ReportingInApp_ReportColumn_TotalAssignments$1,
    ReportingInApp_ReportColumn_TotalDailyLogins: ReportingInApp_ReportColumn_TotalDailyLogins$1,
    ReportingInApp_ReportColumn_TotalLearningHours: ReportingInApp_ReportColumn_TotalLearningHours$1,
    ReportingInApp_ReportColumn_TotalLearningMinutes: ReportingInApp_ReportColumn_TotalLearningMinutes$1,
    ReportingInApp_ReportColumn_TotalManagerRatings: ReportingInApp_ReportColumn_TotalManagerRatings$1,
    ReportingInApp_ReportColumn_TotalManagerRatingsAdded: ReportingInApp_ReportColumn_TotalManagerRatingsAdded$1,
    ReportingInApp_ReportColumn_TotalPathwayContent: ReportingInApp_ReportColumn_TotalPathwayContent$1,
    ReportingInApp_ReportColumn_TotalPeerRatings: ReportingInApp_ReportColumn_TotalPeerRatings$1,
    ReportingInApp_ReportColumn_TotalPoints: ReportingInApp_ReportColumn_TotalPoints$1,
    ReportingInApp_ReportColumn_TotalRequiredPathwayContent: ReportingInApp_ReportColumn_TotalRequiredPathwayContent$1,
    ReportingInApp_ReportColumn_TotalSelfRatings: ReportingInApp_ReportColumn_TotalSelfRatings$1,
    ReportingInApp_ReportColumn_TotalSkillReviews: ReportingInApp_ReportColumn_TotalSkillReviews$1,
    ReportingInApp_ReportColumn_TotalSkillsFocused: ReportingInApp_ReportColumn_TotalSkillsFocused$1,
    ReportingInApp_ReportColumn_TotalSkillsFollowed: ReportingInApp_ReportColumn_TotalSkillsFollowed$1,
    ReportingInApp_ReportColumn_TotalSkillTargetsAdded: ReportingInApp_ReportColumn_TotalSkillTargetsAdded$1,
    ReportingInApp_ReportColumn_TotalTeamFocusSkills: ReportingInApp_ReportColumn_TotalTeamFocusSkills$1,
    ReportingInApp_ReportColumn_TotalUsersActive: ReportingInApp_ReportColumn_TotalUsersActive$1,
    ReportingInApp_ReportColumn_TotalUsersActiveInAcademy: ReportingInApp_ReportColumn_TotalUsersActiveInAcademy$1,
    ReportingInApp_ReportColumn_Type: ReportingInApp_ReportColumn_Type$1,
    ReportingInApp_ReportColumn_UnmatchedSkills: ReportingInApp_ReportColumn_UnmatchedSkills$1,
    ReportingInApp_ReportColumn_Url: ReportingInApp_ReportColumn_Url$1,
    ReportingInApp_ReportColumn_UserCompanyId: ReportingInApp_ReportColumn_UserCompanyId$1,
    ReportingInApp_ReportColumn_UserCompletionStatus: ReportingInApp_ReportColumn_UserCompletionStatus$1,
    ReportingInApp_ReportColumn_UserCreatedDate: ReportingInApp_ReportColumn_UserCreatedDate$1,
    ReportingInApp_ReportColumn_UserEmail: ReportingInApp_ReportColumn_UserEmail$1,
    ReportingInApp_ReportColumn_UserFirstName: ReportingInApp_ReportColumn_UserFirstName$1,
    ReportingInApp_ReportColumn_UserId: ReportingInApp_ReportColumn_UserId$1,
    ReportingInApp_ReportColumn_UserLastName: ReportingInApp_ReportColumn_UserLastName$1,
    ReportingInApp_ReportColumn_UserName: ReportingInApp_ReportColumn_UserName$1,
    ReportingInApp_ReportColumn_UserNote: ReportingInApp_ReportColumn_UserNote$1,
    ReportingInApp_ReportColumn_UserPlanStatus: ReportingInApp_ReportColumn_UserPlanStatus$1,
    ReportingInApp_ReportColumn_UsersAddingSkills: ReportingInApp_ReportColumn_UsersAddingSkills$1,
    ReportingInApp_ReportColumn_UsersCompletingContent: ReportingInApp_ReportColumn_UsersCompletingContent$1,
    ReportingInApp_ReportColumn_UsersCompletingPathways: ReportingInApp_ReportColumn_UsersCompletingPathways$1,
    ReportingInApp_ReportColumn_UsersFollowingPathways: ReportingInApp_ReportColumn_UsersFollowingPathways$1,
    ReportingInApp_ReportColumn_UsersFollowingPlans: ReportingInApp_ReportColumn_UsersFollowingPlans$1,
    ReportingInApp_ReportColumn_UsersRatingSkills: ReportingInApp_ReportColumn_UsersRatingSkills$1,
    ReportingInApp_ReportColumn_UserStatus: ReportingInApp_ReportColumn_UserStatus$1,
    ReportingInApp_ReportColumn_UserTopics: ReportingInApp_ReportColumn_UserTopics$1,
    ReportingInApp_ReportColumn_VerifiedLearningHours: ReportingInApp_ReportColumn_VerifiedLearningHours$1,
    ReportingInApp_ReportColumn_VerifiedLearningMinutes: ReportingInApp_ReportColumn_VerifiedLearningMinutes$1,
    ReportingInApp_ReportColumn_ViewCountAndroid: ReportingInApp_ReportColumn_ViewCountAndroid$1,
    ReportingInApp_ReportColumn_ViewCountAndroidApp: ReportingInApp_ReportColumn_ViewCountAndroidApp$1,
    ReportingInApp_ReportColumn_ViewCountAndroidBrowser: ReportingInApp_ReportColumn_ViewCountAndroidBrowser$1,
    ReportingInApp_ReportColumn_ViewCountDesktop: ReportingInApp_ReportColumn_ViewCountDesktop$1,
    ReportingInApp_ReportColumn_ViewCountIos: ReportingInApp_ReportColumn_ViewCountIos$1,
    ReportingInApp_ReportColumn_ViewCountIOSApp: ReportingInApp_ReportColumn_ViewCountIOSApp$1,
    ReportingInApp_ReportColumn_ViewCountIOSBrowser: ReportingInApp_ReportColumn_ViewCountIOSBrowser$1,
    ReportingInApp_ReportColumn_ViewCountWeb: ReportingInApp_ReportColumn_ViewCountWeb$1,
    ReportingInApp_ReportColumn_ViewedDate: ReportingInApp_ReportColumn_ViewedDate$1,
    ReportingInApp_ReportColumn_Visibility: ReportingInApp_ReportColumn_Visibility$1,
    ReportingInApp_ReportColumn_WeeklyDigestEmail: ReportingInApp_ReportColumn_WeeklyDigestEmail$1,
    ReportingInApp_ReportGenerate_FileFormat_Label: ReportingInApp_ReportGenerate_FileFormat_Label$1,
    ReportingInApp_ReportGenerate_FileFormatRowLimitWarning: ReportingInApp_ReportGenerate_FileFormatRowLimitWarning$1,
    ReportingInApp_ReportGenerate_Header: ReportingInApp_ReportGenerate_Header$1,
    ReportingInApp_ReportGenerate_SavePreset_Label: ReportingInApp_ReportGenerate_SavePreset_Label$1,
    ReportingInApp_ReportGenerate_SubmitButton: ReportingInApp_ReportGenerate_SubmitButton$1,
    ReportingInApp_ReportPreview: ReportingInApp_ReportPreview$1,
    ReportingInApp_ReportPreview_ChangeColumns: ReportingInApp_ReportPreview_ChangeColumns$1,
    ReportingInApp_ReportPreview_DownloadNotificationMessage: ReportingInApp_ReportPreview_DownloadNotificationMessage$1,
    ReportingInApp_ReportPreview_PreviewingRowsOfFormat: ReportingInApp_ReportPreview_PreviewingRowsOfFormat$1,
    ReportingInApp_ReportPreview_UseCustomDateRange: ReportingInApp_ReportPreview_UseCustomDateRange$1,
    ReportingInApp_ReportPreview_UTCDatesNote: ReportingInApp_ReportPreview_UTCDatesNote$1,
    ReportingInApp_Reports: ReportingInApp_Reports$1,
    ReportingInApp_ReportType_AcademiesContentCompletionOverview_Description: ReportingInApp_ReportType_AcademiesContentCompletionOverview_Description$1,
    ReportingInApp_ReportType_AcademiesContentCompletionOverview_Title: ReportingInApp_ReportType_AcademiesContentCompletionOverview_Title$1,
    ReportingInApp_ReportType_AcademiesDetailedByUser_Description: ReportingInApp_ReportType_AcademiesDetailedByUser_Description$1,
    ReportingInApp_ReportType_AcademiesDetailedByUser_Title: ReportingInApp_ReportType_AcademiesDetailedByUser_Title$1,
    ReportingInApp_ReportType_AcademiesLastLogin_Description: ReportingInApp_ReportType_AcademiesLastLogin_Description$1,
    ReportingInApp_ReportType_AcademiesLastLogin_Title: ReportingInApp_ReportType_AcademiesLastLogin_Title$1,
    ReportingInApp_ReportType_AcademiesMarketplaceProgramStatus_Description: ReportingInApp_ReportType_AcademiesMarketplaceProgramStatus_Description$1,
    ReportingInApp_ReportType_AcademiesMarketplaceProgramStatus_Title: ReportingInApp_ReportType_AcademiesMarketplaceProgramStatus_Title$1,
    ReportingInApp_ReportType_AcademiesProgressByUser_Description: ReportingInApp_ReportType_AcademiesProgressByUser_Description$1,
    ReportingInApp_ReportType_AcademiesProgressByUser_Title: ReportingInApp_ReportType_AcademiesProgressByUser_Title$1,
    ReportingInApp_ReportType_AcademiesSummaryByAcademy_Description: ReportingInApp_ReportType_AcademiesSummaryByAcademy_Description$1,
    ReportingInApp_ReportType_AcademiesSummaryByAcademy_Title: ReportingInApp_ReportType_AcademiesSummaryByAcademy_Title$1,
    ReportingInApp_ReportType_AcademiesSummaryByUser_Description: ReportingInApp_ReportType_AcademiesSummaryByUser_Description$1,
    ReportingInApp_ReportType_AcademiesSummaryByUser_Title: ReportingInApp_ReportType_AcademiesSummaryByUser_Title$1,
    ReportingInApp_ReportType_AcademyAndMarketplaceLoginsSummary_Description: ReportingInApp_ReportType_AcademyAndMarketplaceLoginsSummary_Description$1,
    ReportingInApp_ReportType_AcademyAndMarketplaceLoginsSummary_Title: ReportingInApp_ReportType_AcademyAndMarketplaceLoginsSummary_Title$1,
    ReportingInApp_ReportType_AcademyCompletionsByUser_Description: ReportingInApp_ReportType_AcademyCompletionsByUser_Description$1,
    ReportingInApp_ReportType_AcademyCompletionsByUser_Title: ReportingInApp_ReportType_AcademyCompletionsByUser_Title$1,
    ReportingInApp_ReportType_AcademyProjectsDetailedByUser_Description: ReportingInApp_ReportType_AcademyProjectsDetailedByUser_Description$1,
    ReportingInApp_ReportType_AcademyProjectsDetailedByUser_Title: ReportingInApp_ReportType_AcademyProjectsDetailedByUser_Title$1,
    ReportingInApp_ReportType_ActiveOpportunitiesDetailed_Description: ReportingInApp_ReportType_ActiveOpportunitiesDetailed_Description$1,
    ReportingInApp_ReportType_ActiveOpportunitiesDetailed_Title: ReportingInApp_ReportType_ActiveOpportunitiesDetailed_Title$1,
    ReportingInApp_ReportType_ApprovalsDetailedByUser_Description: ReportingInApp_ReportType_ApprovalsDetailedByUser_Description$1,
    ReportingInApp_ReportType_ApprovalsDetailedByUser_Title: ReportingInApp_ReportType_ApprovalsDetailedByUser_Title$1,
    ReportingInApp_ReportType_AssignmentActivityEmployee_Description: ReportingInApp_ReportType_AssignmentActivityEmployee_Description$1,
    ReportingInApp_ReportType_AssignmentActivityEmployee_Title: ReportingInApp_ReportType_AssignmentActivityEmployee_Title$1,
    ReportingInApp_ReportType_AssignmentsByUser_Description: ReportingInApp_ReportType_AssignmentsByUser_Description$1,
    ReportingInApp_ReportType_AssignmentsByUser_Title: ReportingInApp_ReportType_AssignmentsByUser_Title$1,
    ReportingInApp_ReportType_CompletionActivityUser_Description: ReportingInApp_ReportType_CompletionActivityUser_Description$1,
    ReportingInApp_ReportType_CompletionActivityUser_Title: ReportingInApp_ReportType_CompletionActivityUser_Title$1,
    ReportingInApp_ReportType_CompletionsByUser_Description: ReportingInApp_ReportType_CompletionsByUser_Description$1,
    ReportingInApp_ReportType_CompletionsByUser_Title: ReportingInApp_ReportType_CompletionsByUser_Title$1,
    ReportingInApp_ReportType_ContentCatalog_Description: ReportingInApp_ReportType_ContentCatalog_Description$1,
    ReportingInApp_ReportType_ContentCatalog_Title: ReportingInApp_ReportType_ContentCatalog_Title$1,
    ReportingInApp_ReportType_ContentView_Description: ReportingInApp_ReportType_ContentView_Description$1,
    ReportingInApp_ReportType_ContentView_Title: ReportingInApp_ReportType_ContentView_Title$1,
    ReportingInApp_ReportType_CustomProgramCompletionsByUser_Description: ReportingInApp_ReportType_CustomProgramCompletionsByUser_Description$1,
    ReportingInApp_ReportType_CustomProgramCompletionsByUser_Title: ReportingInApp_ReportType_CustomProgramCompletionsByUser_Title$1,
    ReportingInApp_ReportType_CustomProgramOverallProgress_Description: ReportingInApp_ReportType_CustomProgramOverallProgress_Description$1,
    ReportingInApp_ReportType_CustomProgramOverallProgress_Title: ReportingInApp_ReportType_CustomProgramOverallProgress_Title$1,
    ReportingInApp_ReportType_CustomProgramPercentProgressByUser_Description: ReportingInApp_ReportType_CustomProgramPercentProgressByUser_Description$1,
    ReportingInApp_ReportType_CustomProgramPercentProgressByUser_Title: ReportingInApp_ReportType_CustomProgramPercentProgressByUser_Title$1,
    ReportingInApp_ReportType_CustomProgramProjects_Description: ReportingInApp_ReportType_CustomProgramProjects_Description$1,
    ReportingInApp_ReportType_CustomProgramProjects_Title: ReportingInApp_ReportType_CustomProgramProjects_Title$1,
    ReportingInApp_ReportType_CustomProgramUsersLoggedIn_Description: ReportingInApp_ReportType_CustomProgramUsersLoggedIn_Description$1,
    ReportingInApp_ReportType_CustomProgramUsersLoggedIn_Title: ReportingInApp_ReportType_CustomProgramUsersLoggedIn_Title$1,
    ReportingInApp_ReportType_FollowersDetailed_Description: ReportingInApp_ReportType_FollowersDetailed_Description$1,
    ReportingInApp_ReportType_FollowersDetailed_Title: ReportingInApp_ReportType_FollowersDetailed_Title$1,
    ReportingInApp_ReportType_LearningHoursExecutiveSummary_Description: ReportingInApp_ReportType_LearningHoursExecutiveSummary_Description$1,
    ReportingInApp_ReportType_LearningHoursExecutiveSummary_Title: ReportingInApp_ReportType_LearningHoursExecutiveSummary_Title$1,
    ReportingInApp_ReportType_LearningHoursSummarybyUser_Description: ReportingInApp_ReportType_LearningHoursSummarybyUser_Description$1,
    ReportingInApp_ReportType_LearningHoursSummarybyUser_Title: ReportingInApp_ReportType_LearningHoursSummarybyUser_Title$1,
    ReportingInApp_ReportType_Logins_Description: ReportingInApp_ReportType_Logins_Description$1,
    ReportingInApp_ReportType_Logins_Title: ReportingInApp_ReportType_Logins_Title$1,
    ReportingInApp_ReportType_MentoringDetail_Description: ReportingInApp_ReportType_MentoringDetail_Description$1,
    ReportingInApp_ReportType_MentoringDetail_Title: ReportingInApp_ReportType_MentoringDetail_Title$1,
    ReportingInApp_ReportType_OpportunitiesInterestedActivityDetailed_Description: ReportingInApp_ReportType_OpportunitiesInterestedActivityDetailed_Description$1,
    ReportingInApp_ReportType_OpportunitiesInterestedActivityDetailed_Title: ReportingInApp_ReportType_OpportunitiesInterestedActivityDetailed_Title$1,
    ReportingInApp_ReportType_OpportunitiesViewDataSummary_Description: ReportingInApp_ReportType_OpportunitiesViewDataSummary_Description$1,
    ReportingInApp_ReportType_OpportunitiesViewDataSummary_Title: ReportingInApp_ReportType_OpportunitiesViewDataSummary_Title$1,
    ReportingInApp_ReportType_PathwayDetailByUser_Description: ReportingInApp_ReportType_PathwayDetailByUser_Description$1,
    ReportingInApp_ReportType_PathwayDetailByUser_Title: ReportingInApp_ReportType_PathwayDetailByUser_Title$1,
    ReportingInApp_ReportType_PathwaySummaryByPathway_Description: ReportingInApp_ReportType_PathwaySummaryByPathway_Description$1,
    ReportingInApp_ReportType_PathwaySummaryByPathway_Title: ReportingInApp_ReportType_PathwaySummaryByPathway_Title$1,
    ReportingInApp_ReportType_PathwaySummaryByUser_Description: ReportingInApp_ReportType_PathwaySummaryByUser_Description$1,
    ReportingInApp_ReportType_PathwaySummaryByUser_Title: ReportingInApp_ReportType_PathwaySummaryByUser_Title$1,
    ReportingInApp_ReportType_PlanDetailByUser_Description: ReportingInApp_ReportType_PlanDetailByUser_Description$1,
    ReportingInApp_ReportType_PlanDetailByUser_Title: ReportingInApp_ReportType_PlanDetailByUser_Title$1,
    ReportingInApp_ReportType_PlanSummaryByPlan_Description: ReportingInApp_ReportType_PlanSummaryByPlan_Description$1,
    ReportingInApp_ReportType_PlanSummaryByPlan_Title: ReportingInApp_ReportType_PlanSummaryByPlan_Title$1,
    ReportingInApp_ReportType_PlanSummaryByUser_Description: ReportingInApp_ReportType_PlanSummaryByUser_Description$1,
    ReportingInApp_ReportType_PlanSummaryByUser_Title: ReportingInApp_ReportType_PlanSummaryByUser_Title$1,
    ReportingInApp_ReportType_PublishedAcademiesDetailed_Description: ReportingInApp_ReportType_PublishedAcademiesDetailed_Description$1,
    ReportingInApp_ReportType_PublishedAcademiesDetailed_Title: ReportingInApp_ReportType_PublishedAcademiesDetailed_Title$1,
    ReportingInApp_ReportType_PublishedOpportunitiesSummary_Description: ReportingInApp_ReportType_PublishedOpportunitiesSummary_Description$1,
    ReportingInApp_ReportType_PublishedOpportunitiesSummary_Title: ReportingInApp_ReportType_PublishedOpportunitiesSummary_Title$1,
    ReportingInApp_ReportType_PublishedPathwaysDetailed_Description: ReportingInApp_ReportType_PublishedPathwaysDetailed_Description$1,
    ReportingInApp_ReportType_PublishedPathwaysDetailed_Title: ReportingInApp_ReportType_PublishedPathwaysDetailed_Title$1,
    ReportingInApp_ReportType_SearchSummary_Description: ReportingInApp_ReportType_SearchSummary_Description$1,
    ReportingInApp_ReportType_SearchSummary_Title: ReportingInApp_ReportType_SearchSummary_Title$1,
    ReportingInApp_ReportType_SharedDetailed_Description: ReportingInApp_ReportType_SharedDetailed_Description$1,
    ReportingInApp_ReportType_SharedDetailed_Title: ReportingInApp_ReportType_SharedDetailed_Title$1,
    ReportingInApp_ReportType_SharedOpportunitiesDetailed_Description: ReportingInApp_ReportType_SharedOpportunitiesDetailed_Description$1,
    ReportingInApp_ReportType_SharedOpportunitiesDetailed_Title: ReportingInApp_ReportType_SharedOpportunitiesDetailed_Title$1,
    ReportingInApp_ReportType_SkillActivityEmployee_Description: ReportingInApp_ReportType_SkillActivityEmployee_Description$1,
    ReportingInApp_ReportType_SkillActivityEmployee_Title: ReportingInApp_ReportType_SkillActivityEmployee_Title$1,
    ReportingInApp_ReportType_SkillCoachDetailedByManager_Description: ReportingInApp_ReportType_SkillCoachDetailedByManager_Description$1,
    ReportingInApp_ReportType_SkillCoachDetailedByManager_Title: ReportingInApp_ReportType_SkillCoachDetailedByManager_Title$1,
    ReportingInApp_ReportType_SkillCoachOverall_Description: ReportingInApp_ReportType_SkillCoachOverall_Description$1,
    ReportingInApp_ReportType_SkillCoachOverall_Title: ReportingInApp_ReportType_SkillCoachOverall_Title$1,
    ReportingInApp_ReportType_SkillCoachSummaryByManager_Description: ReportingInApp_ReportType_SkillCoachSummaryByManager_Description$1,
    ReportingInApp_ReportType_SkillCoachSummaryByManager_Title: ReportingInApp_ReportType_SkillCoachSummaryByManager_Title$1,
    ReportingInApp_ReportType_SkillFollowedDetailedByUser_Description: ReportingInApp_ReportType_SkillFollowedDetailedByUser_Description$1,
    ReportingInApp_ReportType_SkillFollowedDetailedByUser_Title: ReportingInApp_ReportType_SkillFollowedDetailedByUser_Title$1,
    ReportingInApp_ReportType_SkillsByUser_Description: ReportingInApp_ReportType_SkillsByUser_Description$1,
    ReportingInApp_ReportType_SkillsByUser_Title: ReportingInApp_ReportType_SkillsByUser_Title$1,
    ReportingInApp_ReportType_SkillStandardDetailedByUser_Description: ReportingInApp_ReportType_SkillStandardDetailedByUser_Description$1,
    ReportingInApp_ReportType_SkillStandardDetailedByUser_Title: ReportingInApp_ReportType_SkillStandardDetailedByUser_Title$1,
    ReportingInApp_ReportType_SummaryOfProgressAcademiesCustomPrograms_Description: ReportingInApp_ReportType_SummaryOfProgressAcademiesCustomPrograms_Description$1,
    ReportingInApp_ReportType_SummaryOfProgressAcademiesCustomPrograms_Title: ReportingInApp_ReportType_SummaryOfProgressAcademiesCustomPrograms_Title$1,
    ReportingInApp_ReportType_UserGroups_Description: ReportingInApp_ReportType_UserGroups_Description$1,
    ReportingInApp_ReportType_UserGroups_Title: ReportingInApp_ReportType_UserGroups_Title$1,
    ReportingInApp_ReportType_UserSummary_Description: ReportingInApp_ReportType_UserSummary_Description$1,
    ReportingInApp_ReportType_UserSummary_Title: ReportingInApp_ReportType_UserSummary_Title$1,
    ReportingInApp_ReportType_VWRptUserSummaryAnonymized_Description: ReportingInApp_ReportType_VWRptUserSummaryAnonymized_Description$1,
    ReportingInApp_ReportType_VWRptUserSummaryAnonymized_Title: ReportingInApp_ReportType_VWRptUserSummaryAnonymized_Title$1,
    ReportingInApp_SavedPresets: ReportingInApp_SavedPresets$1,
    ReportingInApp_SavedPresets_ConfirmDelete: ReportingInApp_SavedPresets_ConfirmDelete$1,
    ReportingInApp_SavedPresets_Description: ReportingInApp_SavedPresets_Description$1,
    ReportingInApp_SavedPresets_Error_DeletePreset: ReportingInApp_SavedPresets_Error_DeletePreset$1,
    ReportingInApp_SavedPresets_PresetDeleted: ReportingInApp_SavedPresets_PresetDeleted$1,
    ReportingInApp_Scheduled_MaxReportsNotice: ReportingInApp_Scheduled_MaxReportsNotice$1,
    ReportingInApp_ScheduledReports: ReportingInApp_ScheduledReports$1,
    ReportingInApp_Segments: ReportingInApp_Segments$1,
    ReportingInApp_Segments_DropdownFilter_TitleSelected: ReportingInApp_Segments_DropdownFilter_TitleSelected$1,
    ReportingInApp_Segments_Error_GetSegements: ReportingInApp_Segments_Error_GetSegements$1,
    ReportingInApp_Segments_Error_GetUserForSegments: ReportingInApp_Segments_Error_GetUserForSegments$1,
    ReportingInApp_Segments_Error_UpdateUserForSegments: ReportingInApp_Segments_Error_UpdateUserForSegments$1,
    ReportingInApp_Segments_Modal_Info: ReportingInApp_Segments_Modal_Info$1,
    ReportingInApp_Segments_Modal_Title: ReportingInApp_Segments_Modal_Title$1,
    ReportingInApp_Segments_Modal_UserListTitle: ReportingInApp_Segments_Modal_UserListTitle$1,
    ReportingInApp_Segments_Success_UpdateUserForSegments: ReportingInApp_Segments_Success_UpdateUserForSegments$1,
    ReportingInApp_Segments_View_Attributes: ReportingInApp_Segments_View_Attributes$1,
    ReportingInApp_Segments_View_EditReportPermissions: ReportingInApp_Segments_View_EditReportPermissions$1,
    ReportingInApp_Segments_View_ReportPermissions: ReportingInApp_Segments_View_ReportPermissions$1,
    ReportingInApp_Segments_View_SegmentName: ReportingInApp_Segments_View_SegmentName$1,
    ReportingInApp_Status_Download: ReportingInApp_Status_Download$1,
    ReportingInApp_Status_Error: ReportingInApp_Status_Error$1,
    ReportingInApp_Status_InProgress: ReportingInApp_Status_InProgress$1,
    ReportingInApp_Status_Unknown: ReportingInApp_Status_Unknown$1,
    replyToPost_GroupPluralFormat: replyToPost_GroupPluralFormat$1,
    replyToPost_GroupSingleFormat: replyToPost_GroupSingleFormat$1,
    replyToPost_PluralFormat: replyToPost_PluralFormat$1,
    replyToPost_SingleFormat: replyToPost_SingleFormat$1,
    replyToComment_CommentGroupPluralFormat: replyToComment_CommentGroupPluralFormat$1,
    replyToComment_CommentGroupSingleFormat: replyToComment_CommentGroupSingleFormat$1,
    replyToComment_CommentPluralFormat: replyToComment_CommentPluralFormat$1,
    replyToComment_CommentSingleFormat: replyToComment_CommentSingleFormat$1,
    replyToComment_TakeawayGroupPluralFormat: replyToComment_TakeawayGroupPluralFormat$1,
    replyToComment_TakeawayGroupSingleFormat: replyToComment_TakeawayGroupSingleFormat$1,
    replyToComment_TakeawayPluralFormat: replyToComment_TakeawayPluralFormat$1,
    replyToComment_TakeawaySingleFormat: replyToComment_TakeawaySingleFormat$1,
    RecommendationsSvc_DeleteConfirmationFormat: RecommendationsSvc_DeleteConfirmationFormat$1,
    RecommendationsSvc_GetUsersError: RecommendationsSvc_GetUsersError$1,
    RecommendationsSvc_InputAssignedFormat: RecommendationsSvc_InputAssignedFormat$1,
    RecommendationsSvc_InputAssignedFormatIneligibleAdmin: RecommendationsSvc_InputAssignedFormatIneligibleAdmin$1,
    RecommendationsSvc_InputAssignedFormatIneligibleLearner: RecommendationsSvc_InputAssignedFormatIneligibleLearner$1,
    RecommendationsSvc_InputAssignedFormatNoEligibleUsersAdmin: RecommendationsSvc_InputAssignedFormatNoEligibleUsersAdmin$1,
    RecommendationsSvc_InputAssignedFormatNoEligibleUsersLearner: RecommendationsSvc_InputAssignedFormatNoEligibleUsersLearner$1,
    RecommendationsSvc_InputRecommendedFormat: RecommendationsSvc_InputRecommendedFormat$1,
    RecommendationsSvc_InputRecommendedFormatIneligibleAdmin: RecommendationsSvc_InputRecommendedFormatIneligibleAdmin$1,
    RecommendationsSvc_InputRecommendedFormatIneligibleLearner: RecommendationsSvc_InputRecommendedFormatIneligibleLearner$1,
    RecommendationsSvc_InputRecommendedFormatNoEligibleUsersAdmin: RecommendationsSvc_InputRecommendedFormatNoEligibleUsersAdmin$1,
    RecommendationsSvc_InputRecommendedFormatNoEligibleUsersLearner: RecommendationsSvc_InputRecommendedFormatNoEligibleUsersLearner$1,
    RecommendationsSvc_ProblemAccessingRecommendations: RecommendationsSvc_ProblemAccessingRecommendations$1,
    RecommendationsSvc_ProblemAddingRecommendations: RecommendationsSvc_ProblemAddingRecommendations$1,
    RecommendationsSvc_ProblemDeleteRecommendationsFormat: RecommendationsSvc_ProblemDeleteRecommendationsFormat$1,
    RecommendationsSvc_ProblemSearchingGroups: RecommendationsSvc_ProblemSearchingGroups$1,
    RecommendationsSvc_ProblemSearchingMembers: RecommendationsSvc_ProblemSearchingMembers$1,
    RecommendationsSvc_ProblemUpdatingRecommendation: RecommendationsSvc_ProblemUpdatingRecommendation$1,
    RecommendationsSvc_SharedWith: RecommendationsSvc_SharedWith$1,
    RecommendationsSvc_SuccessDelete: RecommendationsSvc_SuccessDelete$1,
    RecommendationsSvc_SuccessDeleteAssignment: RecommendationsSvc_SuccessDeleteAssignment$1,
    RecommendationsSvc_UpdateAssignment: RecommendationsSvc_UpdateAssignment$1,
    RecommendationsSvc_UpdateRecommendation: RecommendationsSvc_UpdateRecommendation$1,
    RecommendationsSvc_UsersTitle: RecommendationsSvc_UsersTitle$1,
    RecommendationsOverviewCtrl_DismissDialogDescription: RecommendationsOverviewCtrl_DismissDialogDescription$1,
    RecommendationPolicyModal_Acknowledge: RecommendationPolicyModal_Acknowledge$1,
    RecommendationPolicyModal_Title: RecommendationPolicyModal_Title$1,
    recommendationForm_AddToProfileFormat: recommendationForm_AddToProfileFormat$1,
    recommendationForm_AssignItem: recommendationForm_AssignItem$1,
    recommendationForm_BackToAddingNames: recommendationForm_BackToAddingNames$1,
    recommendationForm_CharacterCount: recommendationForm_CharacterCount$1,
    recommendationForm_ConfirmDelete: recommendationForm_ConfirmDelete$1,
    recommendationForm_CopyUrl: recommendationForm_CopyUrl$1,
    recommendationForm_dateLabel: recommendationForm_dateLabel$1,
    recommendationForm_dateToggle: recommendationForm_dateToggle$1,
    recommendationForm_dateToggleInfo: recommendationForm_dateToggleInfo$1,
    recommendationForm_EmailRecommendation: recommendationForm_EmailRecommendation$1,
    recommendationForm_FindPeopleConsumerPlaceholder: recommendationForm_FindPeopleConsumerPlaceholder$1,
    recommendationForm_FindPeoplePlaceholder: recommendationForm_FindPeoplePlaceholder$1,
    recommendationForm_HasRecommendedSkills: recommendationForm_HasRecommendedSkills$1,
    recommendationForm_MemberCount: recommendationForm_MemberCount$1,
    recommendationForm_NoResults: recommendationForm_NoResults$1,
    recommendationForm_OnlyOrgMembers: recommendationForm_OnlyOrgMembers$1,
    recommendationForm_PickADate: recommendationForm_PickADate$1,
    recommendationForm_RecommendInput: recommendationForm_RecommendInput$1,
    recommendationForm_RecommendItem: recommendationForm_RecommendItem$1,
    recommendationForm_RecommendItem_Academy: recommendationForm_RecommendItem_Academy$1,
    recommendationForm_RecommendItem_Article: recommendationForm_RecommendItem_Article$1,
    recommendationForm_RecommendItem_Assessment: recommendationForm_RecommendItem_Assessment$1,
    recommendationForm_RecommendItem_Book: recommendationForm_RecommendItem_Book$1,
    recommendationForm_RecommendItem_Course: recommendationForm_RecommendItem_Course$1,
    recommendationForm_RecommendItem_Episode: recommendationForm_RecommendItem_Episode$1,
    recommendationForm_RecommendItem_Event: recommendationForm_RecommendItem_Event$1,
    recommendationForm_RecommendItem_Opportunity: recommendationForm_RecommendItem_Opportunity$1,
    recommendationForm_RecommendItem_Pathway: recommendationForm_RecommendItem_Pathway$1,
    recommendationForm_RecommendItem_Plan: recommendationForm_RecommendItem_Plan$1,
    recommendationForm_RecommendItem_Podcast: recommendationForm_RecommendItem_Podcast$1,
    recommendationForm_RecommendItem_Post: recommendationForm_RecommendItem_Post$1,
    recommendationForm_RecommendItem_Tag: recommendationForm_RecommendItem_Tag$1,
    recommendationForm_RecommendItem_Target: recommendationForm_RecommendItem_Target$1,
    recommendationForm_RecommendItem_Task: recommendationForm_RecommendItem_Task$1,
    recommendationForm_RecommendItem_Video: recommendationForm_RecommendItem_Video$1,
    recommendationForm_RecommendSkillInput: recommendationForm_RecommendSkillInput$1,
    recommendationForm_SearchByName: recommendationForm_SearchByName$1,
    recommendationForm_SearchLabel: recommendationForm_SearchLabel$1,
    recommendationForm_SearchLabelConsumer: recommendationForm_SearchLabelConsumer$1,
    recommendationForm_submitButtonPlural: recommendationForm_submitButtonPlural$1,
    recommendationForm_submitButtonPluralAssign: recommendationForm_submitButtonPluralAssign$1,
    recommendationForm_submitButtonSingular: recommendationForm_submitButtonSingular$1,
    recommendationForm_submitButtonSingularAssign: recommendationForm_submitButtonSingularAssign$1,
    recommendationForm_UpdateItem: recommendationForm_UpdateItem$1,
    recommendationForm_ViewSkillsOnProfile: recommendationForm_ViewSkillsOnProfile$1,
    recommendationForm_WhyAssignedUpdate: recommendationForm_WhyAssignedUpdate$1,
    recommendationForm_WhyRecommendedUpdate: recommendationForm_WhyRecommendedUpdate$1,
    recommendationForm_WhyRecommending: recommendationForm_WhyRecommending$1,
    recommendationForm_WhyRecommendingPlaceholder: recommendationForm_WhyRecommendingPlaceholder$1,
    recommendationDetail_DueDateFormat: recommendationDetail_DueDateFormat$1,
    recommendationDetail_LevelFormat: recommendationDetail_LevelFormat$1,
    recommendationDetail_StatusComplete: recommendationDetail_StatusComplete$1,
    recommendationDetail_StatusDismissed: recommendationDetail_StatusDismissed$1,
    recommendationDetail_StatusPending: recommendationDetail_StatusPending$1,
    recommendationDetail_StatusPrivate: recommendationDetail_StatusPrivate$1,
    recommendationDetail_StatusQueued: recommendationDetail_StatusQueued$1,
    RecommendationCtrl_SelectADate: RecommendationCtrl_SelectADate$1,
    QueueSvc_InternalError: QueueSvc_InternalError$1,
    QueueSvc_ItemAddedFormat: QueueSvc_ItemAddedFormat$1,
    QueueSvc_UsersTitle: QueueSvc_UsersTitle$1,
    QueueCtrl_CompletedMovedToCollection: QueueCtrl_CompletedMovedToCollection$1,
    QueueCtrl_EmptyStateDescription: QueueCtrl_EmptyStateDescription$1,
    QueueCtrl_EmptyStateTitle: QueueCtrl_EmptyStateTitle$1,
    QueueCtrl_InternalError: QueueCtrl_InternalError$1,
    QueueCtrl_NoItemsSaved: QueueCtrl_NoItemsSaved$1,
    QueueCtrl_RemoveSavedItems: QueueCtrl_RemoveSavedItems$1,
    QueueCtrl_SavedDescription: QueueCtrl_SavedDescription$1,
    QueueCtrl_SaveInstructionsFormat: QueueCtrl_SaveInstructionsFormat$1,
    QueueCtrl_SaveUrlForLater: QueueCtrl_SaveUrlForLater$1,
    PublicError_HomePageButton: PublicError_HomePageButton$1,
    ProviderSummary_agileunternehmen: ProviderSummary_agileunternehmen$1,
    ProviderSummary_aicpa: ProviderSummary_aicpa$1,
    ProviderSummary_alura: ProviderSummary_alura$1,
    ProviderSummary_anderspink: ProviderSummary_anderspink$1,
    ProviderSummary_arcitura: ProviderSummary_arcitura$1,
    ProviderSummary_ascm: ProviderSummary_ascm$1,
    ProviderSummary_awstraining: ProviderSummary_awstraining$1,
    ProviderSummary_babbel: ProviderSummary_babbel$1,
    ProviderSummary_bigdatainsider: ProviderSummary_bigdatainsider$1,
    ProviderSummary_blinkist: ProviderSummary_blinkist$1,
    ProviderSummary_business2community: ProviderSummary_business2community$1,
    ProviderSummary_businessinsider: ProviderSummary_businessinsider$1,
    ProviderSummary_busuupremium: ProviderSummary_busuupremium$1,
    ProviderSummary_cbtnuggets: ProviderSummary_cbtnuggets$1,
    ProviderSummary_centerforcreativeleadership: ProviderSummary_centerforcreativeleadership$1,
    ProviderSummary_cisconetworkingacademy: ProviderSummary_cisconetworkingacademy$1,
    ProviderSummary_crehana: ProviderSummary_crehana$1,
    ProviderSummary_cybrary: ProviderSummary_cybrary$1,
    ProviderSummary_datacamp: ProviderSummary_datacamp$1,
    ProviderSummary_degreedmeta: ProviderSummary_degreedmeta$1,
    ProviderSummary_deloitteinsights: ProviderSummary_deloitteinsights$1,
    ProviderSummary_duarte: ProviderSummary_duarte$1,
    ProviderSummary_edx: ProviderSummary_edx$1,
    ProviderSummary_emtrain: ProviderSummary_emtrain$1,
    ProviderSummary_entrepreneur: ProviderSummary_entrepreneur$1,
    ProviderSummary_exitcertified: ProviderSummary_exitcertified$1,
    ProviderSummary_financialedge: ProviderSummary_financialedge$1,
    ProviderSummary_fortinet: ProviderSummary_fortinet$1,
    ProviderSummary_fortytwocourses: ProviderSummary_fortytwocourses$1,
    ProviderSummary_futurelearn: ProviderSummary_futurelearn$1,
    ProviderSummary_getabstract: ProviderSummary_getabstract$1,
    ProviderSummary_ghsp: ProviderSummary_ghsp$1,
    ProviderSummary_goskills: ProviderSummary_goskills$1,
    ProviderSummary_greatlearning: ProviderSummary_greatlearning$1,
    ProviderSummary_growwithgoogle: ProviderSummary_growwithgoogle$1,
    ProviderSummary_handelsblatt: ProviderSummary_handelsblatt$1,
    ProviderSummary_hrcom: ProviderSummary_hrcom$1,
    ProviderSummary_hubspotacademy: ProviderSummary_hubspotacademy$1,
    ProviderSummary_ideou: ProviderSummary_ideou$1,
    ProviderSummary_industryofthings: ProviderSummary_industryofthings$1,
    ProviderSummary_invisionapp: ProviderSummary_invisionapp$1,
    ProviderSummary_itprotv: ProviderSummary_itprotv$1,
    ProviderSummary_joshbersin: ProviderSummary_joshbersin$1,
    ProviderSummary_kenblanchardcompanies: ProviderSummary_kenblanchardcompanies$1,
    ProviderSummary_kes: ProviderSummary_kes$1,
    ProviderSummary_khanacademy: ProviderSummary_khanacademy$1,
    ProviderSummary_loma: ProviderSummary_loma$1,
    ProviderSummary_mandel: ProviderSummary_mandel$1,
    ProviderSummary_masterclass: ProviderSummary_masterclass$1,
    ProviderSummary_mckinsey: ProviderSummary_mckinsey$1,
    ProviderSummary_methods: ProviderSummary_methods$1,
    ProviderSummary_microsoftlearn: ProviderSummary_microsoftlearn$1,
    ProviderSummary_mindtools: ProviderSummary_mindtools$1,
    ProviderSummary_mitsloanmgmtreview: ProviderSummary_mitsloanmgmtreview$1,
    ProviderSummary_platzi: ProviderSummary_platzi$1,
    ProviderSummary_pluralsight: ProviderSummary_pluralsight$1,
    ProviderSummary_racismreview: ProviderSummary_racismreview$1,
    ProviderSummary_redshelf: ProviderSummary_redshelf$1,
    ProviderSummary_safari: ProviderSummary_safari$1,
    ProviderSummary_scoopnewsgroup: ProviderSummary_scoopnewsgroup$1,
    ProviderSummary_simplilearn: ProviderSummary_simplilearn$1,
    ProviderSummary_skillshare: ProviderSummary_skillshare$1,
    ProviderSummary_softwareengineeringinstitute: ProviderSummary_softwareengineeringinstitute$1,
    ProviderSummary_soundview: ProviderSummary_soundview$1,
    ProviderSummary_springerprofessional: ProviderSummary_springerprofessional$1,
    ProviderSummary_tedatwork: ProviderSummary_tedatwork$1,
    ProviderSummary_udacity: ProviderSummary_udacity$1,
    ProviderSummary_whil: ProviderSummary_whil$1,
    ProviderSummary_workingvoices: ProviderSummary_workingvoices$1,
    ProfileSkillStd_CollaboratorOnly: ProfileSkillStd_CollaboratorOnly$1,
    ProfileSkillStd_EmptyStateDescription: ProfileSkillStd_EmptyStateDescription$1,
    ProfileSkillStd_EmptyStateTitle: ProfileSkillStd_EmptyStateTitle$1,
    ProfilePlans_EmptyDescription: ProfilePlans_EmptyDescription$1,
    ProfilePlans_EmptyStateDescription: ProfilePlans_EmptyStateDescription$1,
    ProfilePlans_EmptyStateTitle: ProfilePlans_EmptyStateTitle$1,
    ProfilePlans_FindPlans: ProfilePlans_FindPlans$1,
    ProfilePlans_NoPlans: ProfilePlans_NoPlans$1,
    ProfilePlans_NoPlansDescription: ProfilePlans_NoPlansDescription$1,
    ProfilePathways_Authoring: ProfilePathways_Authoring$1,
    ProfilePathways_Completed: ProfilePathways_Completed$1,
    ProfilePathways_CreateNewPathway: ProfilePathways_CreateNewPathway$1,
    ProfilePathways_CreatePathway: ProfilePathways_CreatePathway$1,
    ProfilePathways_EmptyDescription: ProfilePathways_EmptyDescription$1,
    ProfilePathways_EmptyStateDescription: ProfilePathways_EmptyStateDescription$1,
    ProfilePathways_EmptyStateTitle: ProfilePathways_EmptyStateTitle$1,
    ProfilePathways_EmptyTitle: ProfilePathways_EmptyTitle$1,
    ProfilePathways_Enrolled: ProfilePathways_Enrolled$1,
    ProfilePathways_FindPathways: ProfilePathways_FindPathways$1,
    ProfilePathways_FindPathwaysAria: ProfilePathways_FindPathwaysAria$1,
    ProfilePathways_Following: ProfilePathways_Following$1,
    ProfilePathways_LearnTypesAlt: ProfilePathways_LearnTypesAlt$1,
    ProfilePathways_NoPathways: ProfilePathways_NoPathways$1,
    ProfilePathways_UserNoPathwaysFormat: ProfilePathways_UserNoPathwaysFormat$1,
    ProfileCtrl_AddGroup: ProfileCtrl_AddGroup$1,
    ProfileCtrl_AllCategories: ProfileCtrl_AllCategories$1,
    ProfileCtrl_ArticlesRead: ProfileCtrl_ArticlesRead$1,
    ProfileCtrl_AssessmentsCompleted: ProfileCtrl_AssessmentsCompleted$1,
    ProfileCtrl_BooksRead: ProfileCtrl_BooksRead$1,
    ProfileCtrl_BulkDeleteFormat: ProfileCtrl_BulkDeleteFormat$1,
    ProfileCtrl_BulkDeleteSingle: ProfileCtrl_BulkDeleteSingle$1,
    ProfileCtrl_CoursesCompleted: ProfileCtrl_CoursesCompleted$1,
    ProfileCtrl_CreateGroup: ProfileCtrl_CreateGroup$1,
    ProfileCtrl_DeleteCollectionGenericItemBody: ProfileCtrl_DeleteCollectionGenericItemBody$1,
    ProfileCtrl_DeleteCollectionGenericItemBodySingle: ProfileCtrl_DeleteCollectionGenericItemBodySingle$1,
    ProfileCtrl_DeleteCollectionItemBodyFormat: ProfileCtrl_DeleteCollectionItemBodyFormat$1,
    ProfileCtrl_DeleteCollectionItemHeaderFormat: ProfileCtrl_DeleteCollectionItemHeaderFormat$1,
    ProfileCtrl_DeleteCollectionItemNotifierFormat: ProfileCtrl_DeleteCollectionItemNotifierFormat$1,
    ProfileCtrl_DeleteCollectionMultipleItemsNotifierFormat: ProfileCtrl_DeleteCollectionMultipleItemsNotifierFormat$1,
    ProfileCtrl_DeleteProviderItemNotifierFormat: ProfileCtrl_DeleteProviderItemNotifierFormat$1,
    ProfileCtrl_DeleteProviderItemPromptFormat: ProfileCtrl_DeleteProviderItemPromptFormat$1,
    ProfileCtrl_EditCollectionItemNotifierFormat: ProfileCtrl_EditCollectionItemNotifierFormat$1,
    ProfileCtrl_EditCollectionMultipleItemsNotifierFormat: ProfileCtrl_EditCollectionMultipleItemsNotifierFormat$1,
    ProfileCtrl_EventsAttended: ProfileCtrl_EventsAttended$1,
    ProfileCtrl_ExperienceDatePresent: ProfileCtrl_ExperienceDatePresent$1,
    ProfileCtrl_ExperienceDateYears: ProfileCtrl_ExperienceDateYears$1,
    ProfileCtrl_ExperienceReported: ProfileCtrl_ExperienceReported$1,
    ProfileCtrl_FindGroups: ProfileCtrl_FindGroups$1,
    ProfileCtrl_GroupsDescription: ProfileCtrl_GroupsDescription$1,
    ProfileCtrl_NoExactMatches: ProfileCtrl_NoExactMatches$1,
    ProfileCtrl_NoExactMatchesHelp: ProfileCtrl_NoExactMatchesHelp$1,
    ProfileCtrl_OwnerEmptyStateBody: ProfileCtrl_OwnerEmptyStateBody$1,
    ProfileCtrl_OwnerEmptyStateTitle: ProfileCtrl_OwnerEmptyStateTitle$1,
    ProfileCtrl_PathwaysDescription: ProfileCtrl_PathwaysDescription$1,
    ProfileCtrl_PlansDescription: ProfileCtrl_PlansDescription$1,
    ProfileCtrl_PodcastsCompleted: ProfileCtrl_PodcastsCompleted$1,
    ProfileCtrl_PointsEarnedTitle: ProfileCtrl_PointsEarnedTitle$1,
    ProfileCtrl_ShareProfile: ProfileCtrl_ShareProfile$1,
    ProfileCtrl_ShareProfilePrivate: ProfileCtrl_ShareProfilePrivate$1,
    ProfileCtrl_ShareProfileSuccess: ProfileCtrl_ShareProfileSuccess$1,
    ProfileCtrl_ShareSkillSuccess: ProfileCtrl_ShareSkillSuccess$1,
    ProfileCtrl_SkillStdDescription: ProfileCtrl_SkillStdDescription$1,
    ProfileCtrl_VideosWatched: ProfileCtrl_VideosWatched$1,
    ProfileCtrl_ViewSkillSignals: ProfileCtrl_ViewSkillSignals$1,
    problemModalContent_4xxOr5xxError: problemModalContent_4xxOr5xxError$1,
    problemModalContent_AccessDenied: problemModalContent_AccessDenied$1,
    problemModalContent_AdditionalDetails: problemModalContent_AdditionalDetails$1,
    problemModalContent_AdditionalDetailsPlaceholder: problemModalContent_AdditionalDetailsPlaceholder$1,
    problemModalContent_ApplicationQuestions: problemModalContent_ApplicationQuestions$1,
    problemModalContent_ApplicationTroubleCompleting: problemModalContent_ApplicationTroubleCompleting$1,
    problemModalContent_AttachScreenshot: problemModalContent_AttachScreenshot$1,
    problemModalContent_BrokenLink: problemModalContent_BrokenLink$1,
    problemModalContent_BrowserBlocked: problemModalContent_BrowserBlocked$1,
    problemModalContent_ChangeGroupVisibility: problemModalContent_ChangeGroupVisibility$1,
    problemModalContent_ChangingProfile: problemModalContent_ChangingProfile$1,
    problemModalContent_CompletedOverdueSeveralDays: problemModalContent_CompletedOverdueSeveralDays$1,
    problemModalContent_CompletedOverdueToday: problemModalContent_CompletedOverdueToday$1,
    problemModalContent_ContactPermission: problemModalContent_ContactPermission$1,
    problemModalContent_ContentDurationIncorrect: problemModalContent_ContentDurationIncorrect$1,
    problemModalContent_ContentInappropriate: problemModalContent_ContentInappropriate$1,
    problemModalContent_ContentMisassigned: problemModalContent_ContentMisassigned$1,
    problemModalContent_ContentNotAppropriateForWorkplace: problemModalContent_ContentNotAppropriateForWorkplace$1,
    problemModalContent_ContentNotRelevant: problemModalContent_ContentNotRelevant$1,
    problemModalContent_ContentNotSafeForWork: problemModalContent_ContentNotSafeForWork$1,
    problemModalContent_ContentSomethingIncorrect: problemModalContent_ContentSomethingIncorrect$1,
    problemModalContent_ContentTypeIncorrect: problemModalContent_ContentTypeIncorrect$1,
    problemModalContent_DefaultQuestions: problemModalContent_DefaultQuestions$1,
    problemModalContent_DefaultRelevance: problemModalContent_DefaultRelevance$1,
    problemModalContent_ErrorWithProvider: problemModalContent_ErrorWithProvider$1,
    problemModalContent_FileRestrictionDescription: problemModalContent_FileRestrictionDescription$1,
    problemModalContent_FileTypes: problemModalContent_FileTypes$1,
    problemModalContent_Flag: problemModalContent_Flag$1,
    problemModalContent_IncorrectPoints: problemModalContent_IncorrectPoints$1,
    problemModalContent_IssuesJoining: problemModalContent_IssuesJoining$1,
    problemModalContent_LinkAppearsBroken: problemModalContent_LinkAppearsBroken$1,
    problemModalContent_OpportunityIrrelevant: problemModalContent_OpportunityIrrelevant$1,
    problemModalContent_OpportunityQuestions: problemModalContent_OpportunityQuestions$1,
    problemModalContent_Other: problemModalContent_Other$1,
    problemModalContent_OtherInstructions: problemModalContent_OtherInstructions$1,
    problemModalContent_PaidContent: problemModalContent_PaidContent$1,
    problemModalContent_PermissionOrLicense: problemModalContent_PermissionOrLicense$1,
    problemModalContent_ProfileNotAppropriate: problemModalContent_ProfileNotAppropriate$1,
    problemModalContent_Reason: problemModalContent_Reason$1,
    problemModalContent_ReasonPlaceholder: problemModalContent_ReasonPlaceholder$1,
    problemModalContent_RequiredLearningWarning: problemModalContent_RequiredLearningWarning$1,
    problemModalContent_ShouldNotBeConnected: problemModalContent_ShouldNotBeConnected$1,
    problemModalContent_SubissuePlaceholder: problemModalContent_SubissuePlaceholder$1,
    problemModalContent_Subreason: problemModalContent_Subreason$1,
    problemModalContent_TeamIncorrectInsights: problemModalContent_TeamIncorrectInsights$1,
    problemModalContent_TeamIncorrectMembers: problemModalContent_TeamIncorrectMembers$1,
    problemModalContent_Title: problemModalContent_Title$1,
    problemModalContent_UnableToShare: problemModalContent_UnableToShare$1,
    problemModalContent_UploadScreenshotDetail: problemModalContent_UploadScreenshotDetail$1,
    problemModalContent_UploadScreenshotMessage: problemModalContent_UploadScreenshotMessage$1,
    primaryPlanSelectionModal_YesContinue: primaryPlanSelectionModal_YesContinue$1,
    PrePay_CertificateApplication: PrePay_CertificateApplication$1,
    PrePay_ChooseSkill: PrePay_ChooseSkill$1,
    PrePay_Payment: PrePay_Payment$1,
    PrePay_YourInformation: PrePay_YourInformation$1,
    PostFormCtrl_AnotherPathway: PostFormCtrl_AnotherPathway$1,
    PostFormCtrl_AreYouSure: PostFormCtrl_AreYouSure$1,
    PostFormCtrl_ClonedEditMessage: PostFormCtrl_ClonedEditMessage$1,
    PostFormCtrl_Content: PostFormCtrl_Content$1,
    PostFormCtrl_CreatePost: PostFormCtrl_CreatePost$1,
    PostFormCtrl_CreatePostSave: PostFormCtrl_CreatePostSave$1,
    PostFormCtrl_EditingDescription: PostFormCtrl_EditingDescription$1,
    PostFormCtrl_EditPost: PostFormCtrl_EditPost$1,
    PostFormCtrl_EditPostSave: PostFormCtrl_EditPostSave$1,
    PostFormCtrl_Title: PostFormCtrl_Title$1,
    PostFormCtrl_TitleLength: PostFormCtrl_TitleLength$1,
    PostFormCtrl_TitleRequired: PostFormCtrl_TitleRequired$1,
    PositionFormCtrl_AddCategory: PositionFormCtrl_AddCategory$1,
    PositionFormCtrl_AddExperience: PositionFormCtrl_AddExperience$1,
    PositionFormCtrl_AverageHours: PositionFormCtrl_AverageHours$1,
    PositionFormCtrl_CompanyOrg: PositionFormCtrl_CompanyOrg$1,
    PositionFormCtrl_CurrentPosition: PositionFormCtrl_CurrentPosition$1,
    PositionFormCtrl_DescribeExperience: PositionFormCtrl_DescribeExperience$1,
    PositionFormCtrl_Description: PositionFormCtrl_Description$1,
    PositionFormCtrl_EditExperience: PositionFormCtrl_EditExperience$1,
    PositionFormCtrl_EndAfterStart: PositionFormCtrl_EndAfterStart$1,
    PositionFormCtrl_EndDate: PositionFormCtrl_EndDate$1,
    PositionFormCtrl_EndDateError: PositionFormCtrl_EndDateError$1,
    PositionFormCtrl_ExpDescriptionLength: PositionFormCtrl_ExpDescriptionLength$1,
    PositionFormCtrl_ExperienceTitle: PositionFormCtrl_ExperienceTitle$1,
    PositionFormCtrl_HoursPerWeek: PositionFormCtrl_HoursPerWeek$1,
    PositionFormCtrl_IntermediatePosition: PositionFormCtrl_IntermediatePosition$1,
    PositionFormCtrl_JuniorPosition: PositionFormCtrl_JuniorPosition$1,
    PositionFormCtrl_MenteeName: PositionFormCtrl_MenteeName$1,
    PositionFormCtrl_MentorName: PositionFormCtrl_MentorName$1,
    PositionFormCtrl_Organization: PositionFormCtrl_Organization$1,
    PositionFormCtrl_PositionTitle: PositionFormCtrl_PositionTitle$1,
    PositionFormCtrl_RequiredOrg: PositionFormCtrl_RequiredOrg$1,
    PositionFormCtrl_RequiredTitle: PositionFormCtrl_RequiredTitle$1,
    PositionFormCtrl_SaveExperience: PositionFormCtrl_SaveExperience$1,
    PositionFormCtrl_SelectType: PositionFormCtrl_SelectType$1,
    PositionFormCtrl_Seniority: PositionFormCtrl_Seniority$1,
    PositionFormCtrl_SeniorPosition: PositionFormCtrl_SeniorPosition$1,
    PositionFormCtrl_StartDate: PositionFormCtrl_StartDate$1,
    PositionFormCtrl_StartDateError: PositionFormCtrl_StartDateError$1,
    PositionFormCtrl_Title: PositionFormCtrl_Title$1,
    PositionFormCtrl_WholeWeekHours: PositionFormCtrl_WholeWeekHours$1,
    PlanTagList_NoTags: PlanTagList_NoTags$1,
    PlanTagList_ShowAllTags: PlanTagList_ShowAllTags$1,
    PlanTagList_ViewPlan: PlanTagList_ViewPlan$1,
    PlanTagList_ViewSkillsInPlan: PlanTagList_ViewSkillsInPlan$1,
    PlanDropdown_ChoosePlan: PlanDropdown_ChoosePlan$1,
    PlanDropdown_FollowPlan: PlanDropdown_FollowPlan$1,
    PlanDropdown_NoPrimaryPlan: PlanDropdown_NoPrimaryPlan$1,
    PlanDropdown_PrimaryPlanTooltip: PlanDropdown_PrimaryPlanTooltip$1,
    PlanDropdown_Title: PlanDropdown_Title$1,
    PersonalSkillView_AddSkill: PersonalSkillView_AddSkill$1,
    PersonalSkillView_AddSkillInstructions: PersonalSkillView_AddSkillInstructions$1,
    PersonalSkillView_AddTarget: PersonalSkillView_AddTarget$1,
    PersonalSkillView_AllSkills: PersonalSkillView_AllSkills$1,
    PersonalSkillView_AverageRating: PersonalSkillView_AverageRating$1,
    PersonalSkillView_EvaluationRating: PersonalSkillView_EvaluationRating$1,
    PersonalSkillView_FindSkillContent: PersonalSkillView_FindSkillContent$1,
    PersonalSkillView_FocusSkill: PersonalSkillView_FocusSkill$1,
    PersonalSkillView_FocusSkills: PersonalSkillView_FocusSkills$1,
    PersonalSkillView_LastUpdated: PersonalSkillView_LastUpdated$1,
    PersonalSkillView_ManagerRating: PersonalSkillView_ManagerRating$1,
    PersonalSkillView_ManagerRatingFormat: PersonalSkillView_ManagerRatingFormat$1,
    PersonalSkillView_NoSkills: PersonalSkillView_NoSkills$1,
    PersonalSkillView_RequestSelfRating: PersonalSkillView_RequestSelfRating$1,
    PersonalSkillView_RequestSelfRating_Title: PersonalSkillView_RequestSelfRating_Title$1,
    PersonalSkillView_Search_Placeholder: PersonalSkillView_Search_Placeholder$1,
    PersonalSkillView_SelfRating: PersonalSkillView_SelfRating$1,
    PersonalSkillView_SelfRatingFormat: PersonalSkillView_SelfRatingFormat$1,
    PersonalSkillView_SkillDescription: PersonalSkillView_SkillDescription$1,
    PersonalSkillView_SkillProgression: PersonalSkillView_SkillProgression$1,
    PersonalSkillView_SkillProgressionChartSubtitle1: PersonalSkillView_SkillProgressionChartSubtitle1$1,
    PersonalSkillView_SkillProgressionChartSubtitle2: PersonalSkillView_SkillProgressionChartSubtitle2$1,
    PersonalSkillView_SkillProgressionChartSubtitle3: PersonalSkillView_SkillProgressionChartSubtitle3$1,
    PersonalSkillView_SkillReviewFormat: PersonalSkillView_SkillReviewFormat$1,
    PersonalSkillView_SkillTarget: PersonalSkillView_SkillTarget$1,
    PersonalSkillView_SkillTargetFormat: PersonalSkillView_SkillTargetFormat$1,
    PersonalSkillView_SkillTargetJobTargetFormat: PersonalSkillView_SkillTargetJobTargetFormat$1,
    PersonalSkillView_SkillTargetModalTitle: PersonalSkillView_SkillTargetModalTitle$1,
    PersonalSkillView_SkillTargetModalTitleFormat: PersonalSkillView_SkillTargetModalTitleFormat$1,
    PersonalSkillView_TeamFocusSkills: PersonalSkillView_TeamFocusSkills$1,
    PersonalSkillView_Top10SkillsAddSkill: PersonalSkillView_Top10SkillsAddSkill$1,
    PersonalSkillView_Top10SkillsAvgRating: PersonalSkillView_Top10SkillsAvgRating$1,
    PersonalSkillView_Top10SkillsSubtitle1: PersonalSkillView_Top10SkillsSubtitle1$1,
    PersonalSkillView_Top10SkillsSubtitle2: PersonalSkillView_Top10SkillsSubtitle2$1,
    PersonalSkillView_Top10SkillsSubtitle3: PersonalSkillView_Top10SkillsSubtitle3$1,
    PersonalSkillView_Top10SkillsSubtitle4: PersonalSkillView_Top10SkillsSubtitle4$1,
    PersonalSkillView_Top10SkillsTitle1: PersonalSkillView_Top10SkillsTitle1$1,
    PersonalSkillView_Top10SkillsTitle2: PersonalSkillView_Top10SkillsTitle2$1,
    PersonalSkillView_YourRating: PersonalSkillView_YourRating$1,
    PeopleCtrl_AllPeople: PeopleCtrl_AllPeople$1,
    PathwayTopContent_Empty: PathwayTopContent_Empty$1,
    PathwayTopContent_Title: PathwayTopContent_Title$1,
    PathwayTopContent_ViewAllContext: PathwayTopContent_ViewAllContext$1,
    PathwaySectionsChart_CompletedTooltipFormat: PathwaySectionsChart_CompletedTooltipFormat$1,
    PathwaySectionsChart_EnrolledTooltipFormat: PathwaySectionsChart_EnrolledTooltipFormat$1,
    PathwaySectionsChart_FollowingTooltipFormat: PathwaySectionsChart_FollowingTooltipFormat$1,
    PathwaySectionsChart_NoData: PathwaySectionsChart_NoData$1,
    PathwaySectionsChart_Started: PathwaySectionsChart_Started$1,
    PathwaySectionsChart_StartedTooltipFormat: PathwaySectionsChart_StartedTooltipFormat$1,
    PathwaySectionsChart_Title: PathwaySectionsChart_Title$1,
    Pathways_A11yItemsReordered: Pathways_A11yItemsReordered$1,
    Pathways_A11yLessonsReordered: Pathways_A11yLessonsReordered$1,
    Pathways_A11ySectionsReordered: Pathways_A11ySectionsReordered$1,
    Pathways_AddANote: Pathways_AddANote$1,
    Pathways_AddAuthorNote: Pathways_AddAuthorNote$1,
    Pathways_AddByType: Pathways_AddByType$1,
    Pathways_AddContent: Pathways_AddContent$1,
    Pathways_AddContentItemsSuccess: Pathways_AddContentItemsSuccess$1,
    Pathways_AddContentItemSuccess: Pathways_AddContentItemSuccess$1,
    Pathways_AddingInputTypeError: Pathways_AddingInputTypeError$1,
    Pathways_AddItemError: Pathways_AddItemError$1,
    Pathways_AddItemPermissionError: Pathways_AddItemPermissionError$1,
    Pathways_AdditionalContentSuccess: Pathways_AdditionalContentSuccess$1,
    Pathways_AddLesson: Pathways_AddLesson$1,
    Pathways_AddLessonError: Pathways_AddLessonError$1,
    Pathways_AddOneItem: Pathways_AddOneItem$1,
    Pathways_AddSection: Pathways_AddSection$1,
    Pathways_AddSectionError: Pathways_AddSectionError$1,
    Pathways_AddSubsection: Pathways_AddSubsection$1,
    Pathways_AddXItems: Pathways_AddXItems$1,
    Pathways_Article: Pathways_Article$1,
    Pathways_Assessment: Pathways_Assessment$1,
    Pathways_AuthorAccessError: Pathways_AuthorAccessError$1,
    Pathways_AuthoredPathwayError: Pathways_AuthoredPathwayError$1,
    Pathways_BackButton: Pathways_BackButton$1,
    Pathways_BackToBrowse: Pathways_BackToBrowse$1,
    Pathways_Bin: Pathways_Bin$1,
    Pathways_Book: Pathways_Book$1,
    Pathways_Collaborators: Pathways_Collaborators$1,
    Pathways_CollapseLesson: Pathways_CollapseLesson$1,
    Pathways_CollapseLessons: Pathways_CollapseLessons$1,
    Pathways_CompletedColumn: Pathways_CompletedColumn$1,
    Pathways_CompletedItemsFormat: Pathways_CompletedItemsFormat$1,
    Pathways_CompletionNotificationModalTitle: Pathways_CompletionNotificationModalTitle$1,
    Pathways_ConfirmCompletions: Pathways_ConfirmCompletions$1,
    Pathways_ConfirmDeleteLesson: Pathways_ConfirmDeleteLesson$1,
    Pathways_ConfirmDeleteSubsection: Pathways_ConfirmDeleteSubsection$1,
    Pathways_ConfirmRemoveItem: Pathways_ConfirmRemoveItem$1,
    Pathways_ConfirmRemoveSection: Pathways_ConfirmRemoveSection$1,
    Pathways_Course: Pathways_Course$1,
    Pathways_CreatedSection: Pathways_CreatedSection$1,
    Pathways_CreatedSubsection: Pathways_CreatedSubsection$1,
    Pathways_CreateSection: Pathways_CreateSection$1,
    Pathways_DeletedSection: Pathways_DeletedSection$1,
    Pathways_DeletedSubsection: Pathways_DeletedSubsection$1,
    Pathways_DeleteError: Pathways_DeleteError$1,
    Pathways_DeleteItem: Pathways_DeleteItem$1,
    Pathways_DeleteitemError: Pathways_DeleteitemError$1,
    Pathways_DeleteLesson: Pathways_DeleteLesson$1,
    Pathways_DeletelessonError: Pathways_DeletelessonError$1,
    Pathways_DeleteNote: Pathways_DeleteNote$1,
    Pathways_DeletePathwayBody: Pathways_DeletePathwayBody$1,
    Pathways_DeleteSection: Pathways_DeleteSection$1,
    Pathways_DeletesectionError: Pathways_DeletesectionError$1,
    Pathways_DeleteStepError: Pathways_DeleteStepError$1,
    Pathways_DeleteSubsection: Pathways_DeleteSubsection$1,
    Pathways_Description: Pathways_Description$1,
    Pathways_DescriptionPlaceholder: Pathways_DescriptionPlaceholder$1,
    Pathways_EditCatalogItemHelper: Pathways_EditCatalogItemHelper$1,
    Pathways_Edited: Pathways_Edited$1,
    Pathways_EditingDescription: Pathways_EditingDescription$1,
    Pathways_EditLocalContentHelper: Pathways_EditLocalContentHelper$1,
    Pathways_EditPathway: Pathways_EditPathway$1,
    Pathways_EditPermissionError: Pathways_EditPermissionError$1,
    Pathways_EmptyBinMessage: Pathways_EmptyBinMessage$1,
    Pathways_EnrollError: Pathways_EnrollError$1,
    Pathways_Episode: Pathways_Episode$1,
    Pathways_ErrorMessage: Pathways_ErrorMessage$1,
    Pathways_Event: Pathways_Event$1,
    Pathways_ExistingContentTypeError: Pathways_ExistingContentTypeError$1,
    Pathways_ExpandLesson: Pathways_ExpandLesson$1,
    Pathways_FeedbackAverage: Pathways_FeedbackAverage$1,
    Pathways_FeedbackCommentsPlaceholder: Pathways_FeedbackCommentsPlaceholder$1,
    Pathways_FeedbackCommentsTitle: Pathways_FeedbackCommentsTitle$1,
    Pathways_FeedbackDescription: Pathways_FeedbackDescription$1,
    Pathways_FeedbackExcellent: Pathways_FeedbackExcellent$1,
    Pathways_FeedbackGood: Pathways_FeedbackGood$1,
    Pathways_FeedbackOverallRating: Pathways_FeedbackOverallRating$1,
    Pathways_FeedbackPoor: Pathways_FeedbackPoor$1,
    Pathways_FeedbackSubmit: Pathways_FeedbackSubmit$1,
    Pathways_FeedbackSubmitted: Pathways_FeedbackSubmitted$1,
    Pathways_FeedbackSubmittedDescription: Pathways_FeedbackSubmittedDescription$1,
    Pathways_FeedbackTitle: Pathways_FeedbackTitle$1,
    Pathways_FeedbackVeryGood: Pathways_FeedbackVeryGood$1,
    Pathways_FollowedDate: Pathways_FollowedDate$1,
    Pathways_FollowError: Pathways_FollowError$1,
    Pathways_Followers: Pathways_Followers$1,
    Pathways_Following: Pathways_Following$1,
    Pathways_FollowingCountFormat: Pathways_FollowingCountFormat$1,
    Pathways_GetItemsError: Pathways_GetItemsError$1,
    Pathways_HoldForLater: Pathways_HoldForLater$1,
    Pathways_HoldForLaterError: Pathways_HoldForLaterError$1,
    Pathways_Insights: Pathways_Insights$1,
    Pathways_ItemCountFormat: Pathways_ItemCountFormat$1,
    Pathways_ItemCountSingular: Pathways_ItemCountSingular$1,
    Pathways_ItemSavedFormat: Pathways_ItemSavedFormat$1,
    Pathways_ItemsReordered: Pathways_ItemsReordered$1,
    Pathways_LessonCountFormat: Pathways_LessonCountFormat$1,
    Pathways_LessonCountSingular: Pathways_LessonCountSingular$1,
    Pathways_LessonDescriptionLabel: Pathways_LessonDescriptionLabel$1,
    Pathways_LessonDescriptionPlaceholder: Pathways_LessonDescriptionPlaceholder$1,
    Pathways_LessonItemsAllOptional: Pathways_LessonItemsAllOptional$1,
    Pathways_LessonLabelFormat: Pathways_LessonLabelFormat$1,
    Pathways_LessonNumberFormat: Pathways_LessonNumberFormat$1,
    Pathways_LessonTitleLabel: Pathways_LessonTitleLabel$1,
    Pathways_LessonTitlePlaceholder: Pathways_LessonTitlePlaceholder$1,
    Pathways_MakeFeatureNotification: Pathways_MakeFeatureNotification$1,
    Pathways_MakeOptional: Pathways_MakeOptional$1,
    Pathways_MakeRequired: Pathways_MakeRequired$1,
    Pathways_MarkAsOptional: Pathways_MarkAsOptional$1,
    Pathways_MarkAsRequired: Pathways_MarkAsRequired$1,
    Pathways_MoveConfirmationMessage: Pathways_MoveConfirmationMessage$1,
    Pathways_MovedItem: Pathways_MovedItem$1,
    Pathways_MovedLesson: Pathways_MovedLesson$1,
    Pathways_MovedSubsection: Pathways_MovedSubsection$1,
    Pathways_MovedToHoldForLater: Pathways_MovedToHoldForLater$1,
    Pathways_MoveItem: Pathways_MoveItem$1,
    Pathways_MoveItemError: Pathways_MoveItemError$1,
    Pathways_MoveItemTo: Pathways_MoveItemTo$1,
    Pathways_MoveLessonError: Pathways_MoveLessonError$1,
    Pathways_MoveLessonTo: Pathways_MoveLessonTo$1,
    Pathways_MoveSectionError: Pathways_MoveSectionError$1,
    Pathways_MoveSubsectionError: Pathways_MoveSubsectionError$1,
    Pathways_MoveSuccessMessage: Pathways_MoveSuccessMessage$1,
    Pathways_MoveWarningHostedContent: Pathways_MoveWarningHostedContent$1,
    Pathways_NewPathwayItemsNotification: Pathways_NewPathwayItemsNotification$1,
    Pathways_NoAccessDescriptionText: Pathways_NoAccessDescriptionText$1,
    Pathways_NoAccessHeaderText: Pathways_NoAccessHeaderText$1,
    Pathways_NoGroup: Pathways_NoGroup$1,
    Pathways_NoteFromAuthor: Pathways_NoteFromAuthor$1,
    Pathways_OptionalContent: Pathways_OptionalContent$1,
    Pathways_OptionalContentTooltip: Pathways_OptionalContentTooltip$1,
    Pathways_OptionalItemCountFormat: Pathways_OptionalItemCountFormat$1,
    Pathways_OptionalItemCountSingular: Pathways_OptionalItemCountSingular$1,
    Pathways_OrgManagedNotification: Pathways_OrgManagedNotification$1,
    Pathways_OutOfDate: Pathways_OutOfDate$1,
    Pathways_Pathway: Pathways_Pathway$1,
    Pathways_PathwayAccessError: Pathways_PathwayAccessError$1,
    Pathways_PathwayDetailAccessError: Pathways_PathwayDetailAccessError$1,
    Pathways_PathwayInfoAccessError: Pathways_PathwayInfoAccessError$1,
    Pathways_PathwayItemError: Pathways_PathwayItemError$1,
    Pathways_PathwayPrivateMessage: Pathways_PathwayPrivateMessage$1,
    Pathways_Post: Pathways_Post$1,
    Pathways_PrivacyCollaborators: Pathways_PrivacyCollaborators$1,
    Pathways_PrivacyGroupName: Pathways_PrivacyGroupName$1,
    Pathways_PrivacyGroups: Pathways_PrivacyGroups$1,
    Pathways_PrivacyOrg: Pathways_PrivacyOrg$1,
    Pathways_PrivacyOwner: Pathways_PrivacyOwner$1,
    Pathways_PrivacyProfile: Pathways_PrivacyProfile$1,
    Pathways_PrivatePathway: Pathways_PrivatePathway$1,
    Pathways_RefreshForLatestChange: Pathways_RefreshForLatestChange$1,
    Pathways_RemoveFeaturedNotification: Pathways_RemoveFeaturedNotification$1,
    Pathways_RemoveItemError: Pathways_RemoveItemError$1,
    Pathways_ReorderedSections: Pathways_ReorderedSections$1,
    Pathways_ReorderItemError: Pathways_ReorderItemError$1,
    Pathways_ReorderItems: Pathways_ReorderItems$1,
    Pathways_ReorderItemsTitleFormat: Pathways_ReorderItemsTitleFormat$1,
    Pathways_ReorderLessonError: Pathways_ReorderLessonError$1,
    Pathways_ReorderLessons: Pathways_ReorderLessons$1,
    Pathways_ReorderLessonsTitleFormat: Pathways_ReorderLessonsTitleFormat$1,
    Pathways_ReorderSections: Pathways_ReorderSections$1,
    Pathways_ReorderSubsectionItemsTitleFormat: Pathways_ReorderSubsectionItemsTitleFormat$1,
    Pathways_ReorderSubsections: Pathways_ReorderSubsections$1,
    Pathways_ReorderSubsectionsTitleFormat: Pathways_ReorderSubsectionsTitleFormat$1,
    Pathways_RequiredContentSuccess: Pathways_RequiredContentSuccess$1,
    Pathways_RestoreToOriginal: Pathways_RestoreToOriginal$1,
    Pathways_SaveError: Pathways_SaveError$1,
    Pathways_SearchCatalog: Pathways_SearchCatalog$1,
    Pathways_SearchError: Pathways_SearchError$1,
    Pathways_SectionCountFormat: Pathways_SectionCountFormat$1,
    Pathways_SectionDescLimit: Pathways_SectionDescLimit$1,
    Pathways_SectionDescriptionLabel: Pathways_SectionDescriptionLabel$1,
    Pathways_SectionDescriptionPlaceholder: Pathways_SectionDescriptionPlaceholder$1,
    Pathways_sectionLabelFormat: Pathways_sectionLabelFormat$1,
    Pathways_SectionNumberFormat: Pathways_SectionNumberFormat$1,
    Pathways_SectionNumberTitleFormat: Pathways_SectionNumberTitleFormat$1,
    Pathways_SectionTitleLabel: Pathways_SectionTitleLabel$1,
    Pathways_SectionTitlePlaceholder: Pathways_SectionTitlePlaceholder$1,
    Pathways_SelectACatalog: Pathways_SelectACatalog$1,
    Pathways_SetPathwayNameError: Pathways_SetPathwayNameError$1,
    Pathways_ShowMoreLessons: Pathways_ShowMoreLessons$1,
    Pathways_ShowOneMoreLesson: Pathways_ShowOneMoreLesson$1,
    Pathways_SubsectionCountFormat: Pathways_SubsectionCountFormat$1,
    Pathways_SubsectionCountSingular: Pathways_SubsectionCountSingular$1,
    Pathways_SubsectionDescriptionLabel: Pathways_SubsectionDescriptionLabel$1,
    Pathways_SubsectionDescriptionPlaceholder: Pathways_SubsectionDescriptionPlaceholder$1,
    Pathways_SubsectionNumberFormat: Pathways_SubsectionNumberFormat$1,
    Pathways_SubsectionsReordered: Pathways_SubsectionsReordered$1,
    Pathways_SubsectionTitleLabel: Pathways_SubsectionTitleLabel$1,
    Pathways_SubsectionTitlePlaceholder: Pathways_SubsectionTitlePlaceholder$1,
    Pathways_Task: Pathways_Task$1,
    Pathways_Title: Pathways_Title$1,
    Pathways_TitlePlaceholder: Pathways_TitlePlaceholder$1,
    Pathways_UnfollowError: Pathways_UnfollowError$1,
    Pathways_UntitledLesson: Pathways_UntitledLesson$1,
    Pathways_UntitledSection: Pathways_UntitledSection$1,
    Pathways_UpdateError: Pathways_UpdateError$1,
    Pathways_UpdateVisibilityError: Pathways_UpdateVisibilityError$1,
    Pathways_Video: Pathways_Video$1,
    Pathways_WithdrawFromPathway: Pathways_WithdrawFromPathway$1,
    Pathways_WithdrawFromPathwayBody: Pathways_WithdrawFromPathwayBody$1,
    PathwaysLayout_Enrollees: PathwaysLayout_Enrollees$1,
    PathwayPrivacyModal_BulkChangeVisibility: PathwayPrivacyModal_BulkChangeVisibility$1,
    PathwayPrivacyModal_BulkChangeVisibilityPlural: PathwayPrivacyModal_BulkChangeVisibilityPlural$1,
    PathwayPrivacyModal_ChangeVisibility: PathwayPrivacyModal_ChangeVisibility$1,
    PathwayPrivacyModal_ConfirmationModalBody: PathwayPrivacyModal_ConfirmationModalBody$1,
    PathwayPrivacyModal_ConfirmationModalConfirm: PathwayPrivacyModal_ConfirmationModalConfirm$1,
    PathwayPrivacyModal_ConfirmationModalHeader: PathwayPrivacyModal_ConfirmationModalHeader$1,
    PathwayPrivacyModal_EditSettings: PathwayPrivacyModal_EditSettings$1,
    PathwayPrivacyModal_FoundWhere: PathwayPrivacyModal_FoundWhere$1,
    PathwayPrivacyModal_OnlySetGroups: PathwayPrivacyModal_OnlySetGroups$1,
    PathwayPrivacyModal_OnlySetGroupsToolTip: PathwayPrivacyModal_OnlySetGroupsToolTip$1,
    PathwayPrivacyModal_SaveVisibility: PathwayPrivacyModal_SaveVisibility$1,
    PathwayPrivacyModal_SelectAGroupError: PathwayPrivacyModal_SelectAGroupError$1,
    PathwayPrivacyModal_TargetGroups: PathwayPrivacyModal_TargetGroups$1,
    PathwayPrivacyModal_TargetGroupsDirectoryToolTip: PathwayPrivacyModal_TargetGroupsDirectoryToolTip$1,
    PathwayPrivacyModal_TargetGroupsPlanToolTip: PathwayPrivacyModal_TargetGroupsPlanToolTip$1,
    PathwayPrivacyModal_TargetGroupsToolTip: PathwayPrivacyModal_TargetGroupsToolTip$1,
    PathwayEnrollmentSource_AmountSent: PathwayEnrollmentSource_AmountSent$1,
    PathwayEnrollmentSource_Assignments: PathwayEnrollmentSource_Assignments$1,
    PathwayEnrollmentSource_BusinessRules: PathwayEnrollmentSource_BusinessRules$1,
    PathwayEnrollmentSource_OtherTooltip: PathwayEnrollmentSource_OtherTooltip$1,
    PathwayEnrollmentSource_Title: PathwayEnrollmentSource_Title$1,
    PathwayEnrollmentSource_TrackableLinks: PathwayEnrollmentSource_TrackableLinks$1,
    pathwayAddEditModal_AddCollaborator: pathwayAddEditModal_AddCollaborator$1,
    pathwayAddEditModal_AddCollaborators: pathwayAddEditModal_AddCollaborators$1,
    pathwayAddEditModal_AddPathway_Success: pathwayAddEditModal_AddPathway_Success$1,
    pathwayAddEditModal_Authors: pathwayAddEditModal_Authors$1,
    pathwayAddEditModal_BadgeEligibilityLabel: pathwayAddEditModal_BadgeEligibilityLabel$1,
    pathwayAddEditModal_BadgeUuid: pathwayAddEditModal_BadgeUuid$1,
    pathwayAddEditModal_CloneOfPathwayFormat: pathwayAddEditModal_CloneOfPathwayFormat$1,
    pathwayAddEditModal_CollaboratorsDescription: pathwayAddEditModal_CollaboratorsDescription$1,
    pathwayAddEditModal_ConfirmDelete: pathwayAddEditModal_ConfirmDelete$1,
    pathwayAddEditModal_CreatePathway: pathwayAddEditModal_CreatePathway$1,
    pathwayAddEditModal_DeletedFormat: pathwayAddEditModal_DeletedFormat$1,
    pathwayAddEditModal_Description: pathwayAddEditModal_Description$1,
    pathwayAddEditModal_DescriptionDetail: pathwayAddEditModal_DescriptionDetail$1,
    pathwayAddEditModal_DescriptionLength: pathwayAddEditModal_DescriptionLength$1,
    pathwayAddEditModal_DescriptionMissing: pathwayAddEditModal_DescriptionMissing$1,
    pathwayAddEditModal_DoNotDisplayDuration: pathwayAddEditModal_DoNotDisplayDuration$1,
    pathwayAddEditModal_DoNotDisplayDurationNote: pathwayAddEditModal_DoNotDisplayDurationNote$1,
    pathwayAddEditModal_DoNotDisplayHeaderImage: pathwayAddEditModal_DoNotDisplayHeaderImage$1,
    pathwayAddEditModal_DoNotDisplayHeaderImageNote: pathwayAddEditModal_DoNotDisplayHeaderImageNote$1,
    pathwayAddEditModal_EditPathway: pathwayAddEditModal_EditPathway$1,
    pathwayAddEditModal_EndorsedByOrg: pathwayAddEditModal_EndorsedByOrg$1,
    pathwayAddEditModal_EndorsedByOrgNote: pathwayAddEditModal_EndorsedByOrgNote$1,
    pathwayAddEditModal_EndorsedContentByOrgNote: pathwayAddEditModal_EndorsedContentByOrgNote$1,
    pathwayAddEditModal_ImagePreview: pathwayAddEditModal_ImagePreview$1,
    pathwayAddEditModal_NameLength: pathwayAddEditModal_NameLength$1,
    pathwayAddEditModal_NameRequired: pathwayAddEditModal_NameRequired$1,
    pathwayAddEditModal_NeedCollaboratorPermission: pathwayAddEditModal_NeedCollaboratorPermission$1,
    pathwayAddEditModal_Or: pathwayAddEditModal_Or$1,
    pathwayAddEditModal_PathwayName: pathwayAddEditModal_PathwayName$1,
    pathwayAddEditModal_PathwayNameEg: pathwayAddEditModal_PathwayNameEg$1,
    pathwayAddEditModal_PathwayPrimaryContact: pathwayAddEditModal_PathwayPrimaryContact$1,
    pathwayAddEditModal_PathwaySettingsChannelDesc: pathwayAddEditModal_PathwaySettingsChannelDesc$1,
    pathwayAddEditModal_PathwaySettingsDesc: pathwayAddEditModal_PathwaySettingsDesc$1,
    pathwayAddEditModal_PrimaryContactRequired: pathwayAddEditModal_PrimaryContactRequired$1,
    pathwayAddEditModal_Remove: pathwayAddEditModal_Remove$1,
    pathwayAddEditModal_SavePathway: pathwayAddEditModal_SavePathway$1,
    pathwayAddEditModal_SavingPathway: pathwayAddEditModal_SavingPathway$1,
    pathwayAddEditModal_SearchCollaborators: pathwayAddEditModal_SearchCollaborators$1,
    pathwayAddEditModal_SearchPeopleGroupsPlaceHolder: pathwayAddEditModal_SearchPeopleGroupsPlaceHolder$1,
    pathwayAddEditModal_ShowPathwayContentRating: pathwayAddEditModal_ShowPathwayContentRating$1,
    pathwayAddEditModal_ShowPathwayContentRatingNote: pathwayAddEditModal_ShowPathwayContentRatingNote$1,
    pathwayAddEditModal_TitleofPathway: pathwayAddEditModal_TitleofPathway$1,
    pathwayAddEditModal_VisibleToOrg: pathwayAddEditModal_VisibleToOrg$1,
    pathwayAddEditModal_VisibleToOrgWarning: pathwayAddEditModal_VisibleToOrgWarning$1,
    PathwayActivity_OpportunityTitle: PathwayActivity_OpportunityTitle$1,
    PathwayActivity_PathwayTitle: PathwayActivity_PathwayTitle$1,
    PathwayActivity_PlanTitle: PathwayActivity_PlanTitle$1,
    PathwayActivity_SelectionAriaLabel: PathwayActivity_SelectionAriaLabel$1,
    PathwayActivity_TooltipClickedApply: PathwayActivity_TooltipClickedApply$1,
    PathwayActivity_TooltipCompletions: PathwayActivity_TooltipCompletions$1,
    PathwayActivity_TooltipEnroll: PathwayActivity_TooltipEnroll$1,
    PathwayActivity_TooltipFollow: PathwayActivity_TooltipFollow$1,
    PathwayActivity_TooltipInterested: PathwayActivity_TooltipInterested$1,
    PathwayActivity_TooltipTotalViews: PathwayActivity_TooltipTotalViews$1,
    PathwayActivity_TooltipViews: PathwayActivity_TooltipViews$1,
    PathwayActivity_TooltipViewsTotal: PathwayActivity_TooltipViewsTotal$1,
    PathwayActivity_TotalViews: PathwayActivity_TotalViews$1,
    PathwayActivity_Users: PathwayActivity_Users$1,
    PathwayActivity_UsersViewed: PathwayActivity_UsersViewed$1,
    Pagination_AriaLabelDefault: Pagination_AriaLabelDefault$1,
    Pagination_GoToPageFormat: Pagination_GoToPageFormat$1,
    Pagination_OfYFormat: Pagination_OfYFormat$1,
    Pagination_OfYResultsFormat: Pagination_OfYResultsFormat$1,
    Pagination_ResultsOverview: Pagination_ResultsOverview$1,
    OutcomeRatingOptionsSvc_ClaimsMostly: OutcomeRatingOptionsSvc_ClaimsMostly$1,
    OutcomeRatingOptionsSvc_ClaimsNotWell: OutcomeRatingOptionsSvc_ClaimsNotWell$1,
    OutcomeRatingOptionsSvc_ClaimsSlightly: OutcomeRatingOptionsSvc_ClaimsSlightly$1,
    OutcomeRatingOptionsSvc_ClaimsSomewhat: OutcomeRatingOptionsSvc_ClaimsSomewhat$1,
    OutcomeRatingOptionsSvc_ClaimsVeryWell: OutcomeRatingOptionsSvc_ClaimsVeryWell$1,
    OutcomeRatingOptionsSvc_DifficultyExtremely: OutcomeRatingOptionsSvc_DifficultyExtremely$1,
    OutcomeRatingOptionsSvc_DifficultyNot: OutcomeRatingOptionsSvc_DifficultyNot$1,
    OutcomeRatingOptionsSvc_DifficultySlightly: OutcomeRatingOptionsSvc_DifficultySlightly$1,
    OutcomeRatingOptionsSvc_DifficultySomewhat: OutcomeRatingOptionsSvc_DifficultySomewhat$1,
    OutcomeRatingOptionsSvc_DifficultyVery: OutcomeRatingOptionsSvc_DifficultyVery$1,
    OutcomeRatingOptionsSvc_MasteryCapable: OutcomeRatingOptionsSvc_MasteryCapable$1,
    OutcomeRatingOptionsSvc_MasteryDistinguished: OutcomeRatingOptionsSvc_MasteryDistinguished$1,
    OutcomeRatingOptionsSvc_MasteryEmerging: OutcomeRatingOptionsSvc_MasteryEmerging$1,
    OutcomeRatingOptionsSvc_MasteryExperienced: OutcomeRatingOptionsSvc_MasteryExperienced$1,
    OutcomeRatingOptionsSvc_MasteryMaster: OutcomeRatingOptionsSvc_MasteryMaster$1,
    OutcomeRatingOptionsSvc_MasteryNovice: OutcomeRatingOptionsSvc_MasteryNovice$1,
    OutcomeRatingOptionsSvc_RelevancyMostly: OutcomeRatingOptionsSvc_RelevancyMostly$1,
    OutcomeRatingOptionsSvc_RelevancyNot: OutcomeRatingOptionsSvc_RelevancyNot$1,
    OutcomeRatingOptionsSvc_RelevancySlightly: OutcomeRatingOptionsSvc_RelevancySlightly$1,
    OutcomeRatingOptionsSvc_RelevancySomewhat: OutcomeRatingOptionsSvc_RelevancySomewhat$1,
    OutcomeRatingOptionsSvc_RelevancyVery: OutcomeRatingOptionsSvc_RelevancyVery$1,
    OutcomeRatingOptionsSvc_SignificanceExtremely: OutcomeRatingOptionsSvc_SignificanceExtremely$1,
    OutcomeRatingOptionsSvc_SignificanceNot: OutcomeRatingOptionsSvc_SignificanceNot$1,
    OutcomeRatingOptionsSvc_SignificanceSlightly: OutcomeRatingOptionsSvc_SignificanceSlightly$1,
    OutcomeRatingOptionsSvc_SignificanceSomewhat: OutcomeRatingOptionsSvc_SignificanceSomewhat$1,
    OutcomeRatingOptionsSvc_SignificanceVery: OutcomeRatingOptionsSvc_SignificanceVery$1,
    OutcomeRatingOptionsSvc_SimilarityMostly: OutcomeRatingOptionsSvc_SimilarityMostly$1,
    OutcomeRatingOptionsSvc_SimilarityNot: OutcomeRatingOptionsSvc_SimilarityNot$1,
    OutcomeRatingOptionsSvc_SimilaritySlightly: OutcomeRatingOptionsSvc_SimilaritySlightly$1,
    OutcomeRatingOptionsSvc_SimilaritySomewhat: OutcomeRatingOptionsSvc_SimilaritySomewhat$1,
    OutcomeRatingOptionsSvc_SimilarityVery: OutcomeRatingOptionsSvc_SimilarityVery$1,
    OutcomeRatingOptionsSvc_SupportNeutral: OutcomeRatingOptionsSvc_SupportNeutral$1,
    OutcomeRatingOptionsSvc_SupportPoor: OutcomeRatingOptionsSvc_SupportPoor$1,
    OutcomeRatingOptionsSvc_SupportVeryPoor: OutcomeRatingOptionsSvc_SupportVeryPoor$1,
    OutcomeRatingOptionsSvc_SupportVeryWell: OutcomeRatingOptionsSvc_SupportVeryWell$1,
    OutcomeRatingOptionsSvc_SupportWell: OutcomeRatingOptionsSvc_SupportWell$1,
    OrgTargetsCtrl_CreateTarget: OrgTargetsCtrl_CreateTarget$1,
    OrgTargetsCtrl_DeletePrompt: OrgTargetsCtrl_DeletePrompt$1,
    OrgTargetsCtrl_Description: OrgTargetsCtrl_Description$1,
    OrgTargetsCtrl_FollowerCount: OrgTargetsCtrl_FollowerCount$1,
    OrgTargetsCtrl_NoJobRolesMessage: OrgTargetsCtrl_NoJobRolesMessage$1,
    OrgTargetsCtrl_SearchForJobRole: OrgTargetsCtrl_SearchForJobRole$1,
    OrgTargetsCtrl_Title: OrgTargetsCtrl_Title$1,
    OrgTargetsCtrl_Visibility: OrgTargetsCtrl_Visibility$1,
    OrgSvc_AddFAQContactSuccess: OrgSvc_AddFAQContactSuccess$1,
    OrgSvc_AddFAQError: OrgSvc_AddFAQError$1,
    OrgSvc_DeleteFAQError: OrgSvc_DeleteFAQError$1,
    OrgSvc_FAQEmailError: OrgSvc_FAQEmailError$1,
    OrgSvc_OrgError: OrgSvc_OrgError$1,
    OrgSvc_OrgJoinSuccess: OrgSvc_OrgJoinSuccess$1,
    OrgSvc_ResetPrivacyAcceptanceError: OrgSvc_ResetPrivacyAcceptanceError$1,
    OrgSvc_SendInviteError: OrgSvc_SendInviteError$1,
    OrgSvc_SendInviteSuccess: OrgSvc_SendInviteSuccess$1,
    OrgSvc_UpdateFAQError: OrgSvc_UpdateFAQError$1,
    OrgSvc_UpdateLinksError: OrgSvc_UpdateLinksError$1,
    OrgSvc_UpdateMessagesError: OrgSvc_UpdateMessagesError$1,
    OrgSvc_UpdateProviderError: OrgSvc_UpdateProviderError$1,
    OrgSvc_UpdateProviderSuccess: OrgSvc_UpdateProviderSuccess$1,
    OrgSkillsNav_Roles: OrgSkillsNav_Roles$1,
    OrgSkillsNav_Skills: OrgSkillsNav_Skills$1,
    OrgSkills_AC_OnboardingAdd: OrgSkills_AC_OnboardingAdd$1,
    OrgSkills_AC_OnboardingRemove: OrgSkills_AC_OnboardingRemove$1,
    OrgSkills_AC_PlanMark: OrgSkills_AC_PlanMark$1,
    OrgSkills_AC_PlanView: OrgSkills_AC_PlanView$1,
    OrgSkills_AddRole: OrgSkills_AddRole$1,
    OrgSkills_AddRoleHeading: OrgSkills_AddRoleHeading$1,
    OrgSkills_AddSkill: OrgSkills_AddSkill$1,
    OrgSkills_AddSkillButton: OrgSkills_AddSkillButton$1,
    OrgSkills_AddSkills: OrgSkills_AddSkills$1,
    OrgSkills_AddSkillTitle: OrgSkills_AddSkillTitle$1,
    OrgSkills_AlreadyAddedSkill: OrgSkills_AlreadyAddedSkill$1,
    OrgSkills_ApplySuggestions: OrgSkills_ApplySuggestions$1,
    OrgSkills_BackToRoles: OrgSkills_BackToRoles$1,
    OrgSkills_ContentCount: OrgSkills_ContentCount$1,
    OrgSkills_CountSelected: OrgSkills_CountSelected$1,
    OrgSkills_CreateSkills: OrgSkills_CreateSkills$1,
    OrgSkills_CurrentSkills: OrgSkills_CurrentSkills$1,
    OrgSkills_DeleteItem: OrgSkills_DeleteItem$1,
    OrgSkills_DescCharLimit: OrgSkills_DescCharLimit$1,
    OrgSkills_DescCharLimitExceeded: OrgSkills_DescCharLimitExceeded$1,
    OrgSkills_DescPlaceholder: OrgSkills_DescPlaceholder$1,
    OrgSkills_DownloadRoles: OrgSkills_DownloadRoles$1,
    OrgSkills_DownloadSkills: OrgSkills_DownloadSkills$1,
    OrgSkills_EditRoleHeading: OrgSkills_EditRoleHeading$1,
    OrgSkills_EditSkillTitle: OrgSkills_EditSkillTitle$1,
    OrgSkills_EnableSkillReview: OrgSkills_EnableSkillReview$1,
    OrgSkills_EnableSkillReviewHelpText: OrgSkills_EnableSkillReviewHelpText$1,
    OrgSkills_Endorsed: OrgSkills_Endorsed$1,
    OrgSkills_EndorsedSkillTooltip: OrgSkills_EndorsedSkillTooltip$1,
    OrgSkills_EndorseSkill: OrgSkills_EndorseSkill$1,
    OrgSkills_EndorseSkillHelpText: OrgSkills_EndorseSkillHelpText$1,
    OrgSkills_EquivalentSkillsHintSubtitle: OrgSkills_EquivalentSkillsHintSubtitle$1,
    OrgSkills_EquivalentSkillsHintTitle: OrgSkills_EquivalentSkillsHintTitle$1,
    OrgSkills_EquivalentSkillsTip: OrgSkills_EquivalentSkillsTip$1,
    OrgSkills_EquivalentSkillsTitle: OrgSkills_EquivalentSkillsTitle$1,
    OrgSkills_FollowerCount: OrgSkills_FollowerCount$1,
    OrgSkills_GeneratingSkills: OrgSkills_GeneratingSkills$1,
    OrgSkills_GeneratingSuggestions: OrgSkills_GeneratingSuggestions$1,
    OrgSkills_MarkedAsPlan: OrgSkills_MarkedAsPlan$1,
    OrgSkills_MatchedSkill: OrgSkills_MatchedSkill$1,
    OrgSkills_MatchedSkillButtonAlt: OrgSkills_MatchedSkillButtonAlt$1,
    OrgSkills_MatchSkill: OrgSkills_MatchSkill$1,
    OrgSkills_MatchSkillPlaceholder: OrgSkills_MatchSkillPlaceholder$1,
    OrgSkills_NoEquivalentSkillsFound: OrgSkills_NoEquivalentSkillsFound$1,
    OrgSkills_NoLevel: OrgSkills_NoLevel$1,
    OrgSkills_NoRolesAdded: OrgSkills_NoRolesAdded$1,
    OrgSkills_NoSkillsAdded: OrgSkills_NoSkillsAdded$1,
    OrgSkills_NoSkillsResultsFound: OrgSkills_NoSkillsResultsFound$1,
    OrgSkills_NumberSkillSuggestions: OrgSkills_NumberSkillSuggestions$1,
    OrgSkills_OnboardingFeatured: OrgSkills_OnboardingFeatured$1,
    OrgSkills_PathwayCount: OrgSkills_PathwayCount$1,
    OrgSkills_Plan: OrgSkills_Plan$1,
    OrgSkills_Plans: OrgSkills_Plans$1,
    OrgSkills_Recommend: OrgSkills_Recommend$1,
    OrgSkills_RecommendModalTitle: OrgSkills_RecommendModalTitle$1,
    OrgSkills_RecommendSkills: OrgSkills_RecommendSkills$1,
    OrgSkills_RecommendSkillsFormat: OrgSkills_RecommendSkillsFormat$1,
    OrgSkills_RecommendSkillsPluralFormat: OrgSkills_RecommendSkillsPluralFormat$1,
    OrgSkills_RecommendSkillsSingleFormat: OrgSkills_RecommendSkillsSingleFormat$1,
    OrgSkills_ReviewSkills: OrgSkills_ReviewSkills$1,
    OrgSkills_Role: OrgSkills_Role$1,
    OrgSkills_RoleAlreadyPlan: OrgSkills_RoleAlreadyPlan$1,
    OrgSkills_RoleDescription: OrgSkills_RoleDescription$1,
    OrgSkills_RoleDescriptionPlaceholder: OrgSkills_RoleDescriptionPlaceholder$1,
    OrgSkills_RoleIncludeInOnboarding: OrgSkills_RoleIncludeInOnboarding$1,
    OrgSkills_RoleIncludeInOnboardingInfo: OrgSkills_RoleIncludeInOnboardingInfo$1,
    OrgSkills_RoleMakePlan: OrgSkills_RoleMakePlan$1,
    OrgSkills_RoleMakePlanInfo: OrgSkills_RoleMakePlanInfo$1,
    OrgSkills_RolePlaceholder: OrgSkills_RolePlaceholder$1,
    OrgSkills_SearchForSkills: OrgSkills_SearchForSkills$1,
    OrgSkills_SearchPlaceholder: OrgSkills_SearchPlaceholder$1,
    OrgSkills_SeeSkillOverview: OrgSkills_SeeSkillOverview$1,
    OrgSkills_Selected: OrgSkills_Selected$1,
    OrgSkills_SelectSkillLevel: OrgSkills_SelectSkillLevel$1,
    OrgSkills_ShowAsPlan: OrgSkills_ShowAsPlan$1,
    OrgSkills_SimilarSkillsTitle: OrgSkills_SimilarSkillsTitle$1,
    OrgSkills_Skill: OrgSkills_Skill$1,
    OrgSkills_SkillDetailsTitle: OrgSkills_SkillDetailsTitle$1,
    OrgSkills_SkillLevel: OrgSkills_SkillLevel$1,
    OrgSkills_SkillNameExists: OrgSkills_SkillNameExists$1,
    OrgSkills_SkillPlaceholder: OrgSkills_SkillPlaceholder$1,
    OrgSkills_SkillProfile: OrgSkills_SkillProfile$1,
    OrgSkills_SkillReview: OrgSkills_SkillReview$1,
    OrgSkills_SkillReviewEnabled: OrgSkills_SkillReviewEnabled$1,
    OrgSkills_SkillReviewEnabledGroup: OrgSkills_SkillReviewEnabledGroup$1,
    OrgSkills_Skills: OrgSkills_Skills$1,
    OrgSkills_SkillsListInfo: OrgSkills_SkillsListInfo$1,
    OrgSkills_SkillsListPlaceholder: OrgSkills_SkillsListPlaceholder$1,
    OrgSkills_SkillToRoleSuggestions: OrgSkills_SkillToRoleSuggestions$1,
    OrgSkills_SlowChangesWarn: OrgSkills_SlowChangesWarn$1,
    OrgSkills_Source: OrgSkills_Source$1,
    OrgSkills_SuccessAddingSingleSkill: OrgSkills_SuccessAddingSingleSkill$1,
    OrgSkills_SuggestedSkills: OrgSkills_SuggestedSkills$1,
    OrgSkills_TranslatedTitle: OrgSkills_TranslatedTitle$1,
    OrgSkills_UpdateSkills: OrgSkills_UpdateSkills$1,
    OrgSkills_UploadFile: OrgSkills_UploadFile$1,
    OrgSkills_UploadOpportunitiesNotice: OrgSkills_UploadOpportunitiesNotice$1,
    OrgSkills_UploadRoles: OrgSkills_UploadRoles$1,
    OrgSkills_UploadRolesDescription: OrgSkills_UploadRolesDescription$1,
    OrgSkills_UploadSkills: OrgSkills_UploadSkills$1,
    OrgSkills_UploadSkills_ToSource: OrgSkills_UploadSkills_ToSource$1,
    OrgSkills_UploadSkillsDescription: OrgSkills_UploadSkillsDescription$1,
    OrgSkills_ViewRolePlan: OrgSkills_ViewRolePlan$1,
    OrgSkills_VisibilitySkillReview: OrgSkills_VisibilitySkillReview$1,
    OrgSkills_WorkdaySimilarSkillsInfo: OrgSkills_WorkdaySimilarSkillsInfo$1,
    OrgSettingsSupport_Description: OrgSettingsSupport_Description$1,
    OrgSettingsSupport_EmailLabel: OrgSettingsSupport_EmailLabel$1,
    OrgSettingsSupport_FaqUrlLabel: OrgSettingsSupport_FaqUrlLabel$1,
    OrgSettingsSupport_FaqUrlPlaceholder: OrgSettingsSupport_FaqUrlPlaceholder$1,
    OrgSettingsSupport_InvalidEmail: OrgSettingsSupport_InvalidEmail$1,
    OrgSettingsSupport_InvalidFaqUrl: OrgSettingsSupport_InvalidFaqUrl$1,
    OrgSettingsSupport_PhoneLabel: OrgSettingsSupport_PhoneLabel$1,
    OrgSettingsSupport_PhonePlaceholder: OrgSettingsSupport_PhonePlaceholder$1,
    OrgSettingsSupport_Title: OrgSettingsSupport_Title$1,
    OrgSettingsSupport_UpdateSuccessMessage: OrgSettingsSupport_UpdateSuccessMessage$1,
    OrgSettingsNav_Branding: OrgSettingsNav_Branding$1,
    OrgSettingsNav_BusinessRules: OrgSettingsNav_BusinessRules$1,
    OrgSettingsNav_Communication: OrgSettingsNav_Communication$1,
    OrgSettingsNav_HelpMenu: OrgSettingsNav_HelpMenu$1,
    OrgSettingsNav_Learning: OrgSettingsNav_Learning$1,
    OrgSettingsNav_Links: OrgSettingsNav_Links$1,
    OrgSettingsNav_ManageAttributes: OrgSettingsNav_ManageAttributes$1,
    OrgSettingsNav_Messages: OrgSettingsNav_Messages$1,
    OrgSettingsNav_Messaging: OrgSettingsNav_Messaging$1,
    OrgSettingsNav_Permissions: OrgSettingsNav_Permissions$1,
    OrgSettingsNav_Providers: OrgSettingsNav_Providers$1,
    OrgSettingsLinks_AddLink: OrgSettingsLinks_AddLink$1,
    OrgSettingsLinks_AddSection: OrgSettingsLinks_AddSection$1,
    OrgSettingsLinks_Description: OrgSettingsLinks_Description$1,
    OrgSettingsLinks_LinkMaximum: OrgSettingsLinks_LinkMaximum$1,
    OrgSettingsLinks_LinkTitle: OrgSettingsLinks_LinkTitle$1,
    OrgSettingsLinks_LinkTitlePlaceholder: OrgSettingsLinks_LinkTitlePlaceholder$1,
    OrgSettingsLinks_LinkUrl: OrgSettingsLinks_LinkUrl$1,
    OrgSettingsLinks_RemoveLink: OrgSettingsLinks_RemoveLink$1,
    OrgSettingsLinks_RemoveSection: OrgSettingsLinks_RemoveSection$1,
    OrgSettingsLinks_SectionTitle: OrgSettingsLinks_SectionTitle$1,
    OrgSettingsLinks_Title: OrgSettingsLinks_Title$1,
    OrgSettingsLinks_TitlePlaceholder: OrgSettingsLinks_TitlePlaceholder$1,
    OrgSettingsLinks_UpdateSuccessMessage: OrgSettingsLinks_UpdateSuccessMessage$1,
    OrgSettingsLinks_UrlPlaceholder: OrgSettingsLinks_UrlPlaceholder$1,
    OrgSettingsEndorsed_ImageSize: OrgSettingsEndorsed_ImageSize$1,
    OrgSettingsEndorsed_RemoveEndorseIcon: OrgSettingsEndorsed_RemoveEndorseIcon$1,
    OrgSettingsEndorsed_Subtitle: OrgSettingsEndorsed_Subtitle$1,
    OrgSettingsEndorsed_Title: OrgSettingsEndorsed_Title$1,
    OrgSettingsCtrl_AcademiesHeaderUploadSize: OrgSettingsCtrl_AcademiesHeaderUploadSize$1,
    OrgSettingsCtrl_AssignedLearningCustomizationDiscardConfirm: OrgSettingsCtrl_AssignedLearningCustomizationDiscardConfirm$1,
    OrgSettingsCtrl_ChangesCancelConfirm: OrgSettingsCtrl_ChangesCancelConfirm$1,
    OrgSettingsCtrl_ChangesCanceledSuccessMessage: OrgSettingsCtrl_ChangesCanceledSuccessMessage$1,
    OrgSettingsCtrl_ContrastWarning: OrgSettingsCtrl_ContrastWarning$1,
    OrgSettingsCtrl_EmailRequirements: OrgSettingsCtrl_EmailRequirements$1,
    OrgSettingsCtrl_EmailRequirementsHint: OrgSettingsCtrl_EmailRequirementsHint$1,
    OrgSettingsCtrl_ManageOrgName: OrgSettingsCtrl_ManageOrgName$1,
    OrgSettingsCtrl_MessagingTabLabel: OrgSettingsCtrl_MessagingTabLabel$1,
    OrgSettingsCtrl_MessagingTabPlaceholder: OrgSettingsCtrl_MessagingTabPlaceholder$1,
    OrgSettingsCtrl_OrgDescription: OrgSettingsCtrl_OrgDescription$1,
    OrgSettingsCtrl_OrgName: OrgSettingsCtrl_OrgName$1,
    OrgSettingsCtrl_OrgNameInOnboarding: OrgSettingsCtrl_OrgNameInOnboarding$1,
    OrgSettingsCtrl_OrgNameValidationMessage: OrgSettingsCtrl_OrgNameValidationMessage$1,
    OrgSettingsCtrl_Title: OrgSettingsCtrl_Title$1,
    OrgSettingsCtrl_UpdateLinksSuccessMessage: OrgSettingsCtrl_UpdateLinksSuccessMessage$1,
    OrgSettingsCtrl_UpdateSuccessMessage: OrgSettingsCtrl_UpdateSuccessMessage$1,
    OrgSettings_AcceptJobRoleFromClientUserFile_Desc: OrgSettings_AcceptJobRoleFromClientUserFile_Desc$1,
    OrgSettings_AddCard: OrgSettings_AddCard$1,
    OrgSettings_AdminNotifications: OrgSettings_AdminNotifications$1,
    OrgSettings_AllowEmailPasswordReset_Desc: OrgSettings_AllowEmailPasswordReset_Desc$1,
    OrgSettings_AllowEmailPasswordReset_Name: OrgSettings_AllowEmailPasswordReset_Name$1,
    OrgSettings_AllowInteractionAcrossOrganizations_Desc: OrgSettings_AllowInteractionAcrossOrganizations_Desc$1,
    OrgSettings_AllowInteractionAcrossOrganizations_Name: OrgSettings_AllowInteractionAcrossOrganizations_Name$1,
    OrgSettings_AllowOrgTransfer_Desc: OrgSettings_AllowOrgTransfer_Desc$1,
    OrgSettings_AllowOrgTransfer_Name: OrgSettings_AllowOrgTransfer_Name$1,
    OrgSettings_AllowSkillSuggestions_Desc: OrgSettings_AllowSkillSuggestions_Desc$1,
    OrgSettings_AllowSkillSuggestions_Name: OrgSettings_AllowSkillSuggestions_Name$1,
    OrgSettings_AllowSsoUserIdUpdate_Desc: OrgSettings_AllowSsoUserIdUpdate_Desc$1,
    OrgSettings_AllowSsoUserIdUpdate_Name: OrgSettings_AllowSsoUserIdUpdate_Name$1,
    OrgSettings_AnonymizeCredsparkUsers_Desc: OrgSettings_AnonymizeCredsparkUsers_Desc$1,
    OrgSettings_AnonymizeCredsparkUsers_Name: OrgSettings_AnonymizeCredsparkUsers_Name$1,
    OrgSettings_AnonymizePrivateUsers_Desc: OrgSettings_AnonymizePrivateUsers_Desc$1,
    OrgSettings_AnonymizePrivateUsers_Name: OrgSettings_AnonymizePrivateUsers_Name$1,
    OrgSettings_AnonymizeZendeskUsers_Desc: OrgSettings_AnonymizeZendeskUsers_Desc$1,
    OrgSettings_AnonymizeZendeskUsers_Name: OrgSettings_AnonymizeZendeskUsers_Name$1,
    OrgSettings_AppFeedback_GroupDesc: OrgSettings_AppFeedback_GroupDesc$1,
    OrgSettings_AppFeedback_GroupDisplayName: OrgSettings_AppFeedback_GroupDisplayName$1,
    OrgSettings_AppGuidance_GroupDesc: OrgSettings_AppGuidance_GroupDesc$1,
    OrgSettings_AppGuidance_GroupDisplayName: OrgSettings_AppGuidance_GroupDisplayName$1,
    OrgSettings_AssignedLearning_Desc: OrgSettings_AssignedLearning_Desc$1,
    OrgSettings_AssignedLearning_Name: OrgSettings_AssignedLearning_Name$1,
    OrgSettings_AssignedLearningDescription: OrgSettings_AssignedLearningDescription$1,
    OrgSettings_AssignedLearningSaveSuccess: OrgSettings_AssignedLearningSaveSuccess$1,
    OrgSettings_AuditUserGeneratedData_Desc: OrgSettings_AuditUserGeneratedData_Desc$1,
    OrgSettings_AuditUserGeneratedData_Name: OrgSettings_AuditUserGeneratedData_Name$1,
    OrgSettings_AuthenticationSettings: OrgSettings_AuthenticationSettings$1,
    OrgSettings_BuildSkillsEmail_Desc: OrgSettings_BuildSkillsEmail_Desc$1,
    OrgSettings_BuildSkillsEmail_Name: OrgSettings_BuildSkillsEmail_Name$1,
    OrgSettings_ButtonTitleRequired: OrgSettings_ButtonTitleRequired$1,
    OrgSettings_CardDescription: OrgSettings_CardDescription$1,
    OrgSettings_CardDescriptionPlaceholder: OrgSettings_CardDescriptionPlaceholder$1,
    OrgSettings_CardNumber: OrgSettings_CardNumber$1,
    OrgSettings_CardPositionAriaText: OrgSettings_CardPositionAriaText$1,
    OrgSettings_CardTitle: OrgSettings_CardTitle$1,
    OrgSettings_CardTitlePlaceholder: OrgSettings_CardTitlePlaceholder$1,
    OrgSettings_CardType: OrgSettings_CardType$1,
    OrgSettings_CareersFooterMessage_Desc: OrgSettings_CareersFooterMessage_Desc$1,
    OrgSettings_CareersFooterMessage_Name: OrgSettings_CareersFooterMessage_Name$1,
    OrgSettings_ClientAdobeAnalyticsId_Desc: OrgSettings_ClientAdobeAnalyticsId_Desc$1,
    OrgSettings_ClientAdobeAnalyticsId_Name: OrgSettings_ClientAdobeAnalyticsId_Name$1,
    OrgSettings_ClientGoogleAnalyticsId_Desc: OrgSettings_ClientGoogleAnalyticsId_Desc$1,
    OrgSettings_ClientGoogleAnalyticsId_Name: OrgSettings_ClientGoogleAnalyticsId_Name$1,
    OrgSettings_ClientTypeOverride_Desc: OrgSettings_ClientTypeOverride_Desc$1,
    OrgSettings_ClientTypeOverride_Name: OrgSettings_ClientTypeOverride_Name$1,
    OrgSettings_ClientTypeOverride_Selection_None: OrgSettings_ClientTypeOverride_Selection_None$1,
    OrgSettings_ClientTypeOverride_Selection_SkillAnalytics: OrgSettings_ClientTypeOverride_Selection_SkillAnalytics$1,
    OrgSettings_ClientTypeOverride_Selection_SkillInventory: OrgSettings_ClientTypeOverride_Selection_SkillInventory$1,
    OrgSettings_CmsCascadeDeleteFileImport_Desc: OrgSettings_CmsCascadeDeleteFileImport_Desc$1,
    OrgSettings_CmsCascadeDeleteFileImport_Name: OrgSettings_CmsCascadeDeleteFileImport_Name$1,
    OrgSettings_CmsCascadeDeleteNotifyUsers_Desc: OrgSettings_CmsCascadeDeleteNotifyUsers_Desc$1,
    OrgSettings_CmsCascadeDeleteNotifyUsers_Name: OrgSettings_CmsCascadeDeleteNotifyUsers_Name$1,
    OrgSettings_CompleteViewedItems_Desc: OrgSettings_CompleteViewedItems_Desc$1,
    OrgSettings_CompleteViewedItems_Name: OrgSettings_CompleteViewedItems_Name$1,
    OrgSettings_Confirmation: OrgSettings_Confirmation$1,
    OrgSettings_ContentModeratorOptions_Desc: OrgSettings_ContentModeratorOptions_Desc$1,
    OrgSettings_ContentModeratorOptions_Name: OrgSettings_ContentModeratorOptions_Name$1,
    OrgSettings_ContentSettings: OrgSettings_ContentSettings$1,
    OrgSettings_CreateManagerGroups_Desc: OrgSettings_CreateManagerGroups_Desc$1,
    OrgSettings_CredSparkEnabled_Desc: OrgSettings_CredSparkEnabled_Desc$1,
    OrgSettings_CredSparkEnabled_Name: OrgSettings_CredSparkEnabled_Name$1,
    OrgSettings_CustomizeCard: OrgSettings_CustomizeCard$1,
    OrgSettings_CustomizeCardDescription: OrgSettings_CustomizeCardDescription$1,
    OrgSettings_CustomizeHelpMenu: OrgSettings_CustomizeHelpMenu$1,
    OrgSettings_CustomMessageDesc: OrgSettings_CustomMessageDesc$1,
    OrgSettings_CustomOnboardingText_Default: OrgSettings_CustomOnboardingText_Default$1,
    OrgSettings_CustomOnboardingText_Desc: OrgSettings_CustomOnboardingText_Desc$1,
    OrgSettings_CustomOnboardingText_Name: OrgSettings_CustomOnboardingText_Name$1,
    OrgSettings_CustomRatingLevelNames_Desc: OrgSettings_CustomRatingLevelNames_Desc$1,
    OrgSettings_CustomRatingLevelNames_Name: OrgSettings_CustomRatingLevelNames_Name$1,
    OrgSettings_CustomRatingScale_Desc: OrgSettings_CustomRatingScale_Desc$1,
    OrgSettings_CustomRatingScale_Name: OrgSettings_CustomRatingScale_Name$1,
    OrgSettings_CustomRatingScale_Selection_Eight: OrgSettings_CustomRatingScale_Selection_Eight$1,
    OrgSettings_CustomRatingScale_Selection_Five: OrgSettings_CustomRatingScale_Selection_Five$1,
    OrgSettings_CustomRatingScale_Selection_Four: OrgSettings_CustomRatingScale_Selection_Four$1,
    OrgSettings_CustomRatingScale_Selection_Nine: OrgSettings_CustomRatingScale_Selection_Nine$1,
    OrgSettings_CustomRatingScale_Selection_Seven: OrgSettings_CustomRatingScale_Selection_Seven$1,
    OrgSettings_CustomRatingScale_Selection_Six: OrgSettings_CustomRatingScale_Selection_Six$1,
    OrgSettings_CustomRatingScale_Selection_Ten: OrgSettings_CustomRatingScale_Selection_Ten$1,
    OrgSettings_DailySummaryEmail_Desc: OrgSettings_DailySummaryEmail_Desc$1,
    OrgSettings_DailySummaryEmail_Name: OrgSettings_DailySummaryEmail_Name$1,
    OrgSettings_DateReceived: OrgSettings_DateReceived$1,
    OrgSettings_DefaultAssignmentsSort_Desc: OrgSettings_DefaultAssignmentsSort_Desc$1,
    OrgSettings_DefaultAssignmentsSort_Name: OrgSettings_DefaultAssignmentsSort_Name$1,
    OrgSettings_DefaultAssignmentsSort_Selection_AssignmentType: OrgSettings_DefaultAssignmentsSort_Selection_AssignmentType$1,
    OrgSettings_DefaultAssignmentsSort_Selection_DueDate: OrgSettings_DefaultAssignmentsSort_Selection_DueDate$1,
    OrgSettings_DefaultMessage: OrgSettings_DefaultMessage$1,
    OrgSettings_DefaultPrivacyLevel_Desc: OrgSettings_DefaultPrivacyLevel_Desc$1,
    OrgSettings_DefaultPrivacyLevel_Name: OrgSettings_DefaultPrivacyLevel_Name$1,
    OrgSettings_DefaultPWResetUI_Desc: OrgSettings_DefaultPWResetUI_Desc$1,
    OrgSettings_DefaultPWResetUI_Name: OrgSettings_DefaultPWResetUI_Name$1,
    OrgSettings_DefaultUserPassword_Desc: OrgSettings_DefaultUserPassword_Desc$1,
    OrgSettings_DefaultUserPassword_Name: OrgSettings_DefaultUserPassword_Name$1,
    OrgSettings_DegreedCareerMobility: OrgSettings_DegreedCareerMobility$1,
    OrgSettings_DegreedFeatures: OrgSettings_DegreedFeatures$1,
    OrgSettings_DegreedLearnUponUserSync: OrgSettings_DegreedLearnUponUserSync$1,
    OrgSettings_DegreedSurveys_Desc: OrgSettings_DegreedSurveys_Desc$1,
    OrgSettings_DegreedSurveys_Name: OrgSettings_DegreedSurveys_Name$1,
    OrgSettings_DegreedTalent_Desc: OrgSettings_DegreedTalent_Desc$1,
    OrgSettings_DegreedTalent_Name: OrgSettings_DegreedTalent_Name$1,
    OrgSettings_DeleteCardAriaText: OrgSettings_DeleteCardAriaText$1,
    OrgSettings_DeleteCardSuccess: OrgSettings_DeleteCardSuccess$1,
    OrgSettings_DeleteLink: OrgSettings_DeleteLink$1,
    OrgSettings_DeleteLinkModalMessage: OrgSettings_DeleteLinkModalMessage$1,
    OrgSettings_DeleteLinkSuccess: OrgSettings_DeleteLinkSuccess$1,
    OrgSettings_DeleteSavedLink: OrgSettings_DeleteSavedLink$1,
    OrgSettings_Delimiter_Desc: OrgSettings_Delimiter_Desc$1,
    OrgSettings_Delimiter_Name: OrgSettings_Delimiter_Name$1,
    OrgSettings_DenyComments_Desc: OrgSettings_DenyComments_Desc$1,
    OrgSettings_DenyComments_Name: OrgSettings_DenyComments_Name$1,
    OrgSettings_DGAssistant_GroupDesc: OrgSettings_DGAssistant_GroupDesc$1,
    OrgSettings_DGAssistant_GroupDisplayName: OrgSettings_DGAssistant_GroupDisplayName$1,
    OrgSettings_DGAssistantQuickResponse_Desc: OrgSettings_DGAssistantQuickResponse_Desc$1,
    OrgSettings_DGAssistantQuickResponse_Name: OrgSettings_DGAssistantQuickResponse_Name$1,
    OrgSettings_DisableAnalytics_Desc: OrgSettings_DisableAnalytics_Desc$1,
    OrgSettings_DisableAnalytics_Name: OrgSettings_DisableAnalytics_Name$1,
    OrgSettings_DisableAssignedLearning_Desc: OrgSettings_DisableAssignedLearning_Desc$1,
    OrgSettings_DisableAssignedLearning_Name: OrgSettings_DisableAssignedLearning_Name$1,
    OrgSettings_DisableAssignedLearningTab_Desc: OrgSettings_DisableAssignedLearningTab_Desc$1,
    OrgSettings_DisableAssignedLearningTab_Name: OrgSettings_DisableAssignedLearningTab_Name$1,
    OrgSettings_DisableBulkUpload_Desc: OrgSettings_DisableBulkUpload_Desc$1,
    OrgSettings_DisableBulkUpload_Name: OrgSettings_DisableBulkUpload_Name$1,
    OrgSettings_DisableCollaboratorsHeader_Desc: OrgSettings_DisableCollaboratorsHeader_Desc$1,
    OrgSettings_DisableCollaboratorsHeader_Name: OrgSettings_DisableCollaboratorsHeader_Name$1,
    OrgSettings_DisableContent2skills_Desc: OrgSettings_DisableContent2skills_Desc$1,
    OrgSettings_DisableContent2skills_Name: OrgSettings_DisableContent2skills_Name$1,
    OrgSettings_DisableDegreedMarketplace_Desc: OrgSettings_DisableDegreedMarketplace_Desc$1,
    OrgSettings_DisableDegreedMarketplace_Name: OrgSettings_DisableDegreedMarketplace_Name$1,
    OrgSettings_DisableEndorsedSearchResultsSection_Desc: OrgSettings_DisableEndorsedSearchResultsSection_Desc$1,
    OrgSettings_DisableEndorsedSearchResultsSection_Name: OrgSettings_DisableEndorsedSearchResultsSection_Name$1,
    OrgSettings_DisableEngagedLearner_Desc: OrgSettings_DisableEngagedLearner_Desc$1,
    OrgSettings_DisableEngagedLearner_Name: OrgSettings_DisableEngagedLearner_Name$1,
    OrgSettings_DisableHomeAdminSettings_Desc: OrgSettings_DisableHomeAdminSettings_Desc$1,
    OrgSettings_DisableHomeAdminSettings_Name: OrgSettings_DisableHomeAdminSettings_Name$1,
    OrgSettings_DisableIndividualSkillsData_Desc: OrgSettings_DisableIndividualSkillsData_Desc$1,
    OrgSettings_DisableIndividualSkillsData_Name: OrgSettings_DisableIndividualSkillsData_Name$1,
    OrgSettings_DisableInviteOrgMember_Desc: OrgSettings_DisableInviteOrgMember_Desc$1,
    OrgSettings_DisableInviteOrgMember_Name: OrgSettings_DisableInviteOrgMember_Name$1,
    OrgSettings_DisableKnowledgeCenter_Desc: OrgSettings_DisableKnowledgeCenter_Desc$1,
    OrgSettings_DisableKnowledgeCenter_Name: OrgSettings_DisableKnowledgeCenter_Name$1,
    OrgSettings_DisableLearnerSkillsRegistry_Desc: OrgSettings_DisableLearnerSkillsRegistry_Desc$1,
    OrgSettings_DisableLearnerSkillsRegistry_Name: OrgSettings_DisableLearnerSkillsRegistry_Name$1,
    OrgSettings_DisableLearningCampaigns_Desc: OrgSettings_DisableLearningCampaigns_Desc$1,
    OrgSettings_DisableLearningCampaigns_Name: OrgSettings_DisableLearningCampaigns_Name$1,
    OrgSettings_DisableManageContent_Desc: OrgSettings_DisableManageContent_Desc$1,
    OrgSettings_DisableManageContent_Name: OrgSettings_DisableManageContent_Name$1,
    OrgSettings_DisableMedalliaScript_Desc: OrgSettings_DisableMedalliaScript_Desc$1,
    OrgSettings_DisableMedalliaScript_Name: OrgSettings_DisableMedalliaScript_Name$1,
    OrgSettings_DisableMentorshipReview_Desc: OrgSettings_DisableMentorshipReview_Desc$1,
    OrgSettings_DisableMentorshipReview_Name: OrgSettings_DisableMentorshipReview_Name$1,
    OrgSettings_DisablePathwayHeaderImage_Desc: OrgSettings_DisablePathwayHeaderImage_Desc$1,
    OrgSettings_DisablePathwayHeaderImage_Name: OrgSettings_DisablePathwayHeaderImage_Name$1,
    OrgSettings_DisablePersonalizedLearningTab_Desc: OrgSettings_DisablePersonalizedLearningTab_Desc$1,
    OrgSettings_DisablePersonalizedLearningTab_Name: OrgSettings_DisablePersonalizedLearningTab_Name$1,
    OrgSettings_DisablePopupMessages_Desc: OrgSettings_DisablePopupMessages_Desc$1,
    OrgSettings_DisablePopupMessages_Name: OrgSettings_DisablePopupMessages_Name$1,
    OrgSettings_DisableProfileSkillSuggestions_Desc: OrgSettings_DisableProfileSkillSuggestions_Desc$1,
    OrgSettings_DisableProfileSkillSuggestions_Name: OrgSettings_DisableProfileSkillSuggestions_Name$1,
    OrgSettings_DisableRatingsInsights_Desc: OrgSettings_DisableRatingsInsights_Desc$1,
    OrgSettings_DisableRatingsInsights_Name: OrgSettings_DisableRatingsInsights_Name$1,
    OrgSettings_DisableResumeParsingInOnboarding_Desc: OrgSettings_DisableResumeParsingInOnboarding_Desc$1,
    OrgSettings_DisableSearchRelatedSkills_Desc: OrgSettings_DisableSearchRelatedSkills_Desc$1,
    OrgSettings_DisableSearchRelatedSkills_Name: OrgSettings_DisableSearchRelatedSkills_Name$1,
    OrgSettings_DisableSkillsVisualization_Desc: OrgSettings_DisableSkillsVisualization_Desc$1,
    OrgSettings_DisableSkillsVisualization_Name: OrgSettings_DisableSkillsVisualization_Name$1,
    OrgSettings_DisableThirdPartyExperienceManagement_Desc: OrgSettings_DisableThirdPartyExperienceManagement_Desc$1,
    OrgSettings_DisableThirdPartyExperienceManagement_Name: OrgSettings_DisableThirdPartyExperienceManagement_Name$1,
    OrgSettings_DisableTopLearnerInsights_Desc: OrgSettings_DisableTopLearnerInsights_Desc$1,
    OrgSettings_DisableTopLearnerInsights_Name: OrgSettings_DisableTopLearnerInsights_Name$1,
    OrgSettings_DisableUserGeneratedContent_Desc: OrgSettings_DisableUserGeneratedContent_Desc$1,
    OrgSettings_DisableUserGeneratedContent_Name: OrgSettings_DisableUserGeneratedContent_Name$1,
    OrgSettings_DiscardCardChanges: OrgSettings_DiscardCardChanges$1,
    OrgSettings_DownloadablePathwayReportEmployeeIdentifier_Desc: OrgSettings_DownloadablePathwayReportEmployeeIdentifier_Desc$1,
    OrgSettings_DownloadablePathwayReportEmployeeIdentifier_Name: OrgSettings_DownloadablePathwayReportEmployeeIdentifier_Name$1,
    OrgSettings_DownloadablePathwayReportEmployeeIdentifier_Selection_Both: OrgSettings_DownloadablePathwayReportEmployeeIdentifier_Selection_Both$1,
    OrgSettings_DownloadablePathwayReportEmployeeIdentifier_Selection_EmployeeIdOnly: OrgSettings_DownloadablePathwayReportEmployeeIdentifier_Selection_EmployeeIdOnly$1,
    OrgSettings_DownloadablePathwayReportEmployeeIdentifier_Selection_OrganizationEmailOnly: OrgSettings_DownloadablePathwayReportEmployeeIdentifier_Selection_OrganizationEmailOnly$1,
    OrgSettings_DownloadableReportPermissionReadOnly_Desc: OrgSettings_DownloadableReportPermissionReadOnly_Desc$1,
    OrgSettings_DownloadableReportPermissionReadOnly_Name: OrgSettings_DownloadableReportPermissionReadOnly_Name$1,
    OrgSettings_EmailSettings: OrgSettings_EmailSettings$1,
    OrgSettings_EmailSettings_Desc: OrgSettings_EmailSettings_Desc$1,
    OrgSettings_EmailSettings_GroupDesc: OrgSettings_EmailSettings_GroupDesc$1,
    OrgSettings_EmailSettings_GroupDisplayName: OrgSettings_EmailSettings_GroupDisplayName$1,
    OrgSettings_EmailSettings_Name: OrgSettings_EmailSettings_Name$1,
    OrgSettings_EmployeeProcessing: OrgSettings_EmployeeProcessing$1,
    OrgSettings_EnableActiveUserInsights_Desc: OrgSettings_EnableActiveUserInsights_Desc$1,
    OrgSettings_EnableActiveUserInsights_Name: OrgSettings_EnableActiveUserInsights_Name$1,
    OrgSettings_EnableAdvancedSkillAnalytics_Desc: OrgSettings_EnableAdvancedSkillAnalytics_Desc$1,
    OrgSettings_EnableAdvancedSkillAnalytics_Name: OrgSettings_EnableAdvancedSkillAnalytics_Name$1,
    OrgSettings_EnableAISkillInference_Desc: OrgSettings_EnableAISkillInference_Desc$1,
    OrgSettings_EnableAISkillInference_Name: OrgSettings_EnableAISkillInference_Name$1,
    OrgSettings_EnableCareerPathing_Desc: OrgSettings_EnableCareerPathing_Desc$1,
    OrgSettings_EnableCareerPathing_Name: OrgSettings_EnableCareerPathing_Name$1,
    OrgSettings_EnableCustomRatingLevelNames_Desc: OrgSettings_EnableCustomRatingLevelNames_Desc$1,
    OrgSettings_EnableCustomRatingLevelNames_Name: OrgSettings_EnableCustomRatingLevelNames_Name$1,
    OrgSettings_EnableCustomRatingScale_Desc: OrgSettings_EnableCustomRatingScale_Desc$1,
    OrgSettings_EnableCustomRatingScale_Name: OrgSettings_EnableCustomRatingScale_Name$1,
    OrgSettings_EnableCustomRecommendationTypes_Desc: OrgSettings_EnableCustomRecommendationTypes_Desc$1,
    OrgSettings_EnableCustomRecommendationTypes_Name: OrgSettings_EnableCustomRecommendationTypes_Name$1,
    OrgSettings_EnableDCMPilot_Desc: OrgSettings_EnableDCMPilot_Desc$1,
    OrgSettings_EnableDCMPilot_Name: OrgSettings_EnableDCMPilot_Name$1,
    OrgSettings_EnableDirectoriesOnBrowse_Desc: OrgSettings_EnableDirectoriesOnBrowse_Desc$1,
    OrgSettings_EnableDirectoriesOnBrowse_Name: OrgSettings_EnableDirectoriesOnBrowse_Name$1,
    OrgSettings_EnableEngage_Desc: OrgSettings_EnableEngage_Desc$1,
    OrgSettings_EnableEngage_Name: OrgSettings_EnableEngage_Name$1,
    OrgSettings_EnableEvaluationEndorsements_Desc: OrgSettings_EnableEvaluationEndorsements_Desc$1,
    OrgSettings_EnableEvaluationEndorsements_Name: OrgSettings_EnableEvaluationEndorsements_Name$1,
    OrgSettings_EnableManagerOfManager_Desc: OrgSettings_EnableManagerOfManager_Desc$1,
    OrgSettings_EnableManagerOfManager_Name: OrgSettings_EnableManagerOfManager_Name$1,
    OrgSettings_EnableManagerRatings_Desc: OrgSettings_EnableManagerRatings_Desc$1,
    OrgSettings_EnableManagerRatings_Name: OrgSettings_EnableManagerRatings_Name$1,
    OrgSettings_EnableMentorshipOpportunities_Desc: OrgSettings_EnableMentorshipOpportunities_Desc$1,
    OrgSettings_EnableMentorshipOpportunities_Name: OrgSettings_EnableMentorshipOpportunities_Name$1,
    OrgSettings_EnableMobileBiometricAuth_Desc: OrgSettings_EnableMobileBiometricAuth_Desc$1,
    OrgSettings_EnableMobileBiometricAuth_Name: OrgSettings_EnableMobileBiometricAuth_Name$1,
    OrgSettings_EnableNewReportingFTPConnection_Desc: OrgSettings_EnableNewReportingFTPConnection_Desc$1,
    OrgSettings_EnableOptionalEvaluationEndorsement_Desc: OrgSettings_EnableOptionalEvaluationEndorsement_Desc$1,
    OrgSettings_EnableOptionalEvaluationEndorsement_Name: OrgSettings_EnableOptionalEvaluationEndorsement_Name$1,
    OrgSettings_EnableOrgInsightsSkillsTab_Desc: OrgSettings_EnableOrgInsightsSkillsTab_Desc$1,
    OrgSettings_EnableOrgInsightsSkillsTab_Name: OrgSettings_EnableOrgInsightsSkillsTab_Name$1,
    OrgSettings_EnablePathwayBadgeTrigger_Desc: OrgSettings_EnablePathwayBadgeTrigger_Desc$1,
    OrgSettings_EnablePathwayBadgeTrigger_Name: OrgSettings_EnablePathwayBadgeTrigger_Name$1,
    OrgSettings_EnablePeerRatings_Desc: OrgSettings_EnablePeerRatings_Desc$1,
    OrgSettings_EnablePeerRatings_Name: OrgSettings_EnablePeerRatings_Name$1,
    OrgSettings_EnablePluralsightSkillsIntegration_Desc: OrgSettings_EnablePluralsightSkillsIntegration_Desc$1,
    OrgSettings_EnablePluralsightSkillsIntegration_Name: OrgSettings_EnablePluralsightSkillsIntegration_Name$1,
    OrgSettings_EnablePreferredContentLanguagesFilter_Desc: OrgSettings_EnablePreferredContentLanguagesFilter_Desc$1,
    OrgSettings_EnablePreferredContentLanguagesFilter_Name: OrgSettings_EnablePreferredContentLanguagesFilter_Name$1,
    OrgSettings_EnablePrimaryPlanOnDashboard_Desc: OrgSettings_EnablePrimaryPlanOnDashboard_Desc$1,
    OrgSettings_EnablePrimaryPlanOnDashboard_Name: OrgSettings_EnablePrimaryPlanOnDashboard_Name$1,
    OrgSettings_EnableProvidersInUI_Desc: OrgSettings_EnableProvidersInUI_Desc$1,
    OrgSettings_EnableProvidersInUI_Name: OrgSettings_EnableProvidersInUI_Name$1,
    OrgSettings_EnableSkillCoachOptInSettingForAll_Desc: OrgSettings_EnableSkillCoachOptInSettingForAll_Desc$1,
    OrgSettings_EnableSkillCoachOptInSettingForAll_Name: OrgSettings_EnableSkillCoachOptInSettingForAll_Name$1,
    OrgSettings_EnableSkillInsightsDashboard_Desc: OrgSettings_EnableSkillInsightsDashboard_Desc$1,
    OrgSettings_EnableSkillInsightsDashboard_Name: OrgSettings_EnableSkillInsightsDashboard_Name$1,
    OrgSettings_EnableSkillsCertification_Desc: OrgSettings_EnableSkillsCertification_Desc$1,
    OrgSettings_EnableSkillsCertification_Name: OrgSettings_EnableSkillsCertification_Name$1,
    OrgSettings_EnableSkillsEvaluation_Desc: OrgSettings_EnableSkillsEvaluation_Desc$1,
    OrgSettings_EnableSkillsEvaluation_Name: OrgSettings_EnableSkillsEvaluation_Name$1,
    OrgSettings_EnableSkillsPlatform_Desc: OrgSettings_EnableSkillsPlatform_Desc$1,
    OrgSettings_EnableSkillsPlatform_Name: OrgSettings_EnableSkillsPlatform_Name$1,
    OrgSettings_EnableSkillStandards_Desc: OrgSettings_EnableSkillStandards_Desc$1,
    OrgSettings_EnableSkillStandards_Name: OrgSettings_EnableSkillStandards_Name$1,
    OrgSettings_EnableTeamSpace_Desc: OrgSettings_EnableTeamSpace_Desc$1,
    OrgSettings_EnableTeamSpace_Name: OrgSettings_EnableTeamSpace_Name$1,
    OrgSettings_EnableUserSearchFilterByJobRole_Desc: OrgSettings_EnableUserSearchFilterByJobRole_Desc$1,
    OrgSettings_EnableUserSearchFilterByJobRole_Name: OrgSettings_EnableUserSearchFilterByJobRole_Name$1,
    OrgSettings_EnableUserSearchFilterByLocation_Desc: OrgSettings_EnableUserSearchFilterByLocation_Desc$1,
    OrgSettings_EnableUserSearchFilterByLocation_Name: OrgSettings_EnableUserSearchFilterByLocation_Name$1,
    OrgSettings_EnforceDataPrivacyAcceptance_Desc: OrgSettings_EnforceDataPrivacyAcceptance_Desc$1,
    OrgSettings_EnforceDataPrivacyAcceptance_Name: OrgSettings_EnforceDataPrivacyAcceptance_Name$1,
    OrgSettings_EnforceDataPrivacyAcceptanceBody_PlaceHolder: OrgSettings_EnforceDataPrivacyAcceptanceBody_PlaceHolder$1,
    OrgSettings_EnforceDataPrivacyAcceptanceBody_PopupLabel: OrgSettings_EnforceDataPrivacyAcceptanceBody_PopupLabel$1,
    OrgSettings_EnforceDataPrivacyAcceptanceConfirmation_Default: OrgSettings_EnforceDataPrivacyAcceptanceConfirmation_Default$1,
    OrgSettings_EnforceDataPrivacyAcceptanceConfirmation_PlaceHolder: OrgSettings_EnforceDataPrivacyAcceptanceConfirmation_PlaceHolder$1,
    OrgSettings_EnforceDataPrivacyAcceptanceConfirmation_PopupLabel: OrgSettings_EnforceDataPrivacyAcceptanceConfirmation_PopupLabel$1,
    OrgSettings_EnforceDataPrivacyAcceptanceHeader_Default: OrgSettings_EnforceDataPrivacyAcceptanceHeader_Default$1,
    OrgSettings_EnforceDataPrivacyAcceptanceHeader_PlaceHolder: OrgSettings_EnforceDataPrivacyAcceptanceHeader_PlaceHolder$1,
    OrgSettings_EnforceDataPrivacyAcceptanceHeader_PopupLabel: OrgSettings_EnforceDataPrivacyAcceptanceHeader_PopupLabel$1,
    OrgSettings_EnforceDataPrivacyAcceptanceTitle_Default: OrgSettings_EnforceDataPrivacyAcceptanceTitle_Default$1,
    OrgSettings_EnforceDataPrivacyAcceptanceTitle_PlaceHolder: OrgSettings_EnforceDataPrivacyAcceptanceTitle_PlaceHolder$1,
    OrgSettings_EnforceDataPrivacyAcceptanceTitle_PopupLabel: OrgSettings_EnforceDataPrivacyAcceptanceTitle_PopupLabel$1,
    OrgSettings_EnforceDegreedDataPrivacyAcceptance_Desc: OrgSettings_EnforceDegreedDataPrivacyAcceptance_Desc$1,
    OrgSettings_EnforceDegreedDataPrivacyAcceptance_Name: OrgSettings_EnforceDegreedDataPrivacyAcceptance_Name$1,
    OrgSettings_EngagementFeatures: OrgSettings_EngagementFeatures$1,
    OrgSettings_ErrorMessage: OrgSettings_ErrorMessage$1,
    OrgSettings_EstimatedDurationDefaults_Desc: OrgSettings_EstimatedDurationDefaults_Desc$1,
    OrgSettings_EstimatedDurationDefaults_Name: OrgSettings_EstimatedDurationDefaults_Name$1,
    OrgSettings_ExternalLink: OrgSettings_ExternalLink$1,
    OrgSettings_ExternalLinkPlaceholder: OrgSettings_ExternalLinkPlaceholder$1,
    OrgSettings_ExternalLinkRequired: OrgSettings_ExternalLinkRequired$1,
    OrgSettings_FileDetails: OrgSettings_FileDetails$1,
    OrgSettings_FileInformation: OrgSettings_FileInformation$1,
    OrgSettings_FileName_Desc: OrgSettings_FileName_Desc$1,
    OrgSettings_FileName_Name: OrgSettings_FileName_Name$1,
    OrgSettings_FtpNotificationEmail_Desc: OrgSettings_FtpNotificationEmail_Desc$1,
    OrgSettings_FtpNotificationEmail_Name: OrgSettings_FtpNotificationEmail_Name$1,
    OrgSettings_FtpStatusFileOptions_Desc: OrgSettings_FtpStatusFileOptions_Desc$1,
    OrgSettings_FtpStatusFileOptions_Name: OrgSettings_FtpStatusFileOptions_Name$1,
    OrgSettings_FtpStatusFileOptions_Selection_AllRows: OrgSettings_FtpStatusFileOptions_Selection_AllRows$1,
    OrgSettings_FtpStatusFileOptions_Selection_Disabled: OrgSettings_FtpStatusFileOptions_Selection_Disabled$1,
    OrgSettings_FtpStatusFileOptions_Selection_OnlyProblems: OrgSettings_FtpStatusFileOptions_Selection_OnlyProblems$1,
    OrgSettings_GoalProgressEmail_Desc: OrgSettings_GoalProgressEmail_Desc$1,
    OrgSettings_GoalProgressEmail_Name: OrgSettings_GoalProgressEmail_Name$1,
    OrgSettings_GroupPostAdded_Desc: OrgSettings_GroupPostAdded_Desc$1,
    OrgSettings_GroupPostAdded_Name: OrgSettings_GroupPostAdded_Name$1,
    OrgSettings_Groups_Desc: OrgSettings_Groups_Desc$1,
    OrgSettings_Groups_Name: OrgSettings_Groups_Name$1,
    OrgSettings_Hide_Overview_Achievement_Desc: OrgSettings_Hide_Overview_Achievement_Desc$1,
    OrgSettings_Hide_Overview_Experience_Desc: OrgSettings_Hide_Overview_Experience_Desc$1,
    OrgSettings_Hide_Overview_Tab_Desc: OrgSettings_Hide_Overview_Tab_Desc$1,
    OrgSettings_HideExternalCatalog_Desc: OrgSettings_HideExternalCatalog_Desc$1,
    OrgSettings_HideExternalCatalog_Name: OrgSettings_HideExternalCatalog_Name$1,
    OrgSettings_HideOverviewAchievement_Desc: OrgSettings_HideOverviewAchievement_Desc$1,
    OrgSettings_HideOverviewAchievement_Name: OrgSettings_HideOverviewAchievement_Name$1,
    OrgSettings_HideOverviewExperience_Desc: OrgSettings_HideOverviewExperience_Desc$1,
    OrgSettings_HideOverviewExperience_Name: OrgSettings_HideOverviewExperience_Name$1,
    OrgSettings_HideOverviewTab_Desc: OrgSettings_HideOverviewTab_Desc$1,
    OrgSettings_HideOverviewTab_Name: OrgSettings_HideOverviewTab_Name$1,
    OrgSettings_HidePersonalEmailInUserProfileSettings_Desc: OrgSettings_HidePersonalEmailInUserProfileSettings_Desc$1,
    OrgSettings_HidePersonalEmailInUserProfileSettings_Name: OrgSettings_HidePersonalEmailInUserProfileSettings_Name$1,
    OrgSettings_HidePersonalIntegrationsInUserProfileSettings_Desc: OrgSettings_HidePersonalIntegrationsInUserProfileSettings_Desc$1,
    OrgSettings_HidePersonalIntegrationsInUserProfileSettings_Name: OrgSettings_HidePersonalIntegrationsInUserProfileSettings_Name$1,
    OrgSettings_HideSocialLinks_Desc: OrgSettings_HideSocialLinks_Desc$1,
    OrgSettings_HideSocialLinks_Name: OrgSettings_HideSocialLinks_Name$1,
    OrgSettings_HideUserEmail_Desc: OrgSettings_HideUserEmail_Desc$1,
    OrgSettings_HideUserEmail_Name: OrgSettings_HideUserEmail_Name$1,
    OrgSettings_Home_PublishModal_AssignedLearning: OrgSettings_Home_PublishModal_AssignedLearning$1,
    OrgSettings_Home_PublishModal_Body: OrgSettings_Home_PublishModal_Body$1,
    OrgSettings_Home_PublishModal_Body_PublishNew: OrgSettings_Home_PublishModal_Body_PublishNew$1,
    OrgSettings_Home_PublishModal_Body_PublishOld: OrgSettings_Home_PublishModal_Body_PublishOld$1,
    OrgSettings_Home_PublishModal_Body_Unpublish: OrgSettings_Home_PublishModal_Body_Unpublish$1,
    OrgSettings_Home_PublishModal_Body_Unpublish_Sub: OrgSettings_Home_PublishModal_Body_Unpublish_Sub$1,
    OrgSettings_Home_PublishModal_Confirm: OrgSettings_Home_PublishModal_Confirm$1,
    OrgSettings_Home_PublishModal_Link_PluralLinks: OrgSettings_Home_PublishModal_Link_PluralLinks$1,
    OrgSettings_Home_PublishModal_Link_PluralLinksPluralSegments: OrgSettings_Home_PublishModal_Link_PluralLinksPluralSegments$1,
    OrgSettings_Home_PublishModal_Link_PluralLinksSingleSegment: OrgSettings_Home_PublishModal_Link_PluralLinksSingleSegment$1,
    OrgSettings_Home_PublishModal_Link_SingleLink: OrgSettings_Home_PublishModal_Link_SingleLink$1,
    OrgSettings_Home_PublishModal_Link_SingleLinkPluralSegments: OrgSettings_Home_PublishModal_Link_SingleLinkPluralSegments$1,
    OrgSettings_Home_PublishModal_Link_SingleLinkSingleSegment: OrgSettings_Home_PublishModal_Link_SingleLinkSingleSegment$1,
    OrgSettings_HomeDescription: OrgSettings_HomeDescription$1,
    OrgSettings_HomeInsightCards: OrgSettings_HomeInsightCards$1,
    OrgSettings_HomeLinksSection: OrgSettings_HomeLinksSection$1,
    OrgSettings_HomeOrgAnnouncement: OrgSettings_HomeOrgAnnouncement$1,
    OrgSettings_HomePageTile: OrgSettings_HomePageTile$1,
    OrgSettings_HomeSectionsReorderSuccess: OrgSettings_HomeSectionsReorderSuccess$1,
    OrgSettings_InApp_GroupDesc: OrgSettings_InApp_GroupDesc$1,
    OrgSettings_InApp_GroupDisplayName: OrgSettings_InApp_GroupDisplayName$1,
    OrgSettings_InAppTips_Desc: OrgSettings_InAppTips_Desc$1,
    OrgSettings_InAppTips_Name: OrgSettings_InAppTips_Name$1,
    OrgSettings_InsightCardsMaximum: OrgSettings_InsightCardsMaximum$1,
    OrgSettings_InsightCardsPublishUpdateSuccess: OrgSettings_InsightCardsPublishUpdateSuccess$1,
    OrgSettings_InsightCardsReorderSuccess: OrgSettings_InsightCardsReorderSuccess$1,
    OrgSettings_InsightCardsSaveSingleSuccess: OrgSettings_InsightCardsSaveSingleSuccess$1,
    OrgSettings_InsightCardsSaveSuccess: OrgSettings_InsightCardsSaveSuccess$1,
    OrgSettings_InsightCardsUnpublishSingleSuccess: OrgSettings_InsightCardsUnpublishSingleSuccess$1,
    OrgSettings_InsightCardsUnpublishSuccess: OrgSettings_InsightCardsUnpublishSuccess$1,
    OrgSettings_IntegrationEmailSettings_Desc: OrgSettings_IntegrationEmailSettings_Desc$1,
    OrgSettings_IntegrationEmailSettings_Name: OrgSettings_IntegrationEmailSettings_Name$1,
    OrgSettings_InternalLink: OrgSettings_InternalLink$1,
    OrgSettings_IsClientProvider_Desc: OrgSettings_IsClientProvider_Desc$1,
    OrgSettings_IsClientProvider_Name: OrgSettings_IsClientProvider_Name$1,
    OrgSettings_IsDefaultCatalog_Desc: OrgSettings_IsDefaultCatalog_Desc$1,
    OrgSettings_IsDefaultCatalog_Name: OrgSettings_IsDefaultCatalog_Name$1,
    OrgSettings_KeepManagerGroupsInSync_Desc: OrgSettings_KeepManagerGroupsInSync_Desc$1,
    OrgSettings_KeepManagerGroupsInSync_Name: OrgSettings_KeepManagerGroupsInSync_Name$1,
    OrgSettings_LearningFeeds: OrgSettings_LearningFeeds$1,
    OrgSettings_LimitGroupFeedActions_Desc: OrgSettings_LimitGroupFeedActions_Desc$1,
    OrgSettings_LimitGroupFeedActions_Name: OrgSettings_LimitGroupFeedActions_Name$1,
    OrgSettings_LinkButtonPlaceholder: OrgSettings_LinkButtonPlaceholder$1,
    OrgSettings_LinkButtonTitle: OrgSettings_LinkButtonTitle$1,
    OrgSettings_LinkDescription: OrgSettings_LinkDescription$1,
    OrgSettings_LinkDescriptionPlaceholder: OrgSettings_LinkDescriptionPlaceholder$1,
    OrgSettings_LinkDescriptionRequired: OrgSettings_LinkDescriptionRequired$1,
    OrgSettings_LinkInternalUrlPlaceholder: OrgSettings_LinkInternalUrlPlaceholder$1,
    OrgSettings_LinkInternalUrlRequired: OrgSettings_LinkInternalUrlRequired$1,
    OrgSettings_LinkPlaceholder: OrgSettings_LinkPlaceholder$1,
    OrgSettings_LinkSaveSuccess: OrgSettings_LinkSaveSuccess$1,
    OrgSettings_LinkSegmentRequired: OrgSettings_LinkSegmentRequired$1,
    OrgSettings_LinkSegments: OrgSettings_LinkSegments$1,
    OrgSettings_LinkSegmentsDescription: OrgSettings_LinkSegmentsDescription$1,
    OrgSettings_LinkSegmentsTooltip: OrgSettings_LinkSegmentsTooltip$1,
    OrgSettings_LinkSelectSource: OrgSettings_LinkSelectSource$1,
    OrgSettings_LinkTitle: OrgSettings_LinkTitle$1,
    OrgSettings_LinkTitleDuplicateError: OrgSettings_LinkTitleDuplicateError$1,
    OrgSettings_LinkTitleRequired: OrgSettings_LinkTitleRequired$1,
    OrgSettings_LinkUseSegments: OrgSettings_LinkUseSegments$1,
    OrgSettings_LockProfilePrivacy_Desc: OrgSettings_LockProfilePrivacy_Desc$1,
    OrgSettings_LockProfilePrivacy_Name: OrgSettings_LockProfilePrivacy_Name$1,
    OrgSettings_LockSkillManagerRatingVisibility_Desc: OrgSettings_LockSkillManagerRatingVisibility_Desc$1,
    OrgSettings_LockSkillManagerRatingVisibility_Name: OrgSettings_LockSkillManagerRatingVisibility_Name$1,
    OrgSettings_LockSkillPeerRatingVisibility_Desc: OrgSettings_LockSkillPeerRatingVisibility_Desc$1,
    OrgSettings_LockSkillPeerRatingVisibility_Name: OrgSettings_LockSkillPeerRatingVisibility_Name$1,
    OrgSettings_LockSkillSelfRatingVisibility_Desc: OrgSettings_LockSkillSelfRatingVisibility_Desc$1,
    OrgSettings_LockSkillSelfRatingVisibility_Name: OrgSettings_LockSkillSelfRatingVisibility_Name$1,
    OrgSettings_LU_AdminUserId_Desc: OrgSettings_LU_AdminUserId_Desc$1,
    OrgSettings_LU_AdminUserId_Name: OrgSettings_LU_AdminUserId_Name$1,
    OrgSettings_LU_ApiBaseUrl_DefaultText: OrgSettings_LU_ApiBaseUrl_DefaultText$1,
    OrgSettings_LU_ApiBaseUrl_Desc: OrgSettings_LU_ApiBaseUrl_Desc$1,
    OrgSettings_LU_ApiBaseUrl_Name: OrgSettings_LU_ApiBaseUrl_Name$1,
    OrgSettings_LU_ApiPassword_Desc: OrgSettings_LU_ApiPassword_Desc$1,
    OrgSettings_LU_ApiPassword_Name: OrgSettings_LU_ApiPassword_Name$1,
    OrgSettings_LU_ApiUsername_Desc: OrgSettings_LU_ApiUsername_Desc$1,
    OrgSettings_LU_ApiUsername_Name: OrgSettings_LU_ApiUsername_Name$1,
    OrgSettings_LU_BulkGroupSync_Desc: OrgSettings_LU_BulkGroupSync_Desc$1,
    OrgSettings_LU_BulkGroupSync_Name: OrgSettings_LU_BulkGroupSync_Name$1,
    OrgSettings_LU_BulkInviteUsers_Desc: OrgSettings_LU_BulkInviteUsers_Desc$1,
    OrgSettings_LU_BulkInviteUsers_Name: OrgSettings_LU_BulkInviteUsers_Name$1,
    OrgSettings_LU_BulkProcessUnenrollments_Desc: OrgSettings_LU_BulkProcessUnenrollments_Desc$1,
    OrgSettings_LU_BulkProcessUnenrollments_Name: OrgSettings_LU_BulkProcessUnenrollments_Name$1,
    OrgSettings_LU_BulkUpdateUsers_Desc: OrgSettings_LU_BulkUpdateUsers_Desc$1,
    OrgSettings_LU_BulkUpdateUsers_Name: OrgSettings_LU_BulkUpdateUsers_Name$1,
    OrgSettings_LU_CustomDataColumns_Desc: OrgSettings_LU_CustomDataColumns_Desc$1,
    OrgSettings_LU_CustomDataColumns_Name: OrgSettings_LU_CustomDataColumns_Name$1,
    OrgSettings_LU_DefaultEnabled_Desc: OrgSettings_LU_DefaultEnabled_Desc$1,
    OrgSettings_LU_DefaultEnabled_Name: OrgSettings_LU_DefaultEnabled_Name$1,
    OrgSettings_LU_DefaultExpires_Desc: OrgSettings_LU_DefaultExpires_Desc$1,
    OrgSettings_LU_DefaultExpires_Name: OrgSettings_LU_DefaultExpires_Name$1,
    OrgSettings_LU_DefaultGroupSync_Desc: OrgSettings_LU_DefaultGroupSync_Desc$1,
    OrgSettings_LU_DefaultGroupSync_Name: OrgSettings_LU_DefaultGroupSync_Name$1,
    OrgSettings_LU_DefaultMustChangePassword_Desc: OrgSettings_LU_DefaultMustChangePassword_Desc$1,
    OrgSettings_LU_DefaultMustChangePassword_Name: OrgSettings_LU_DefaultMustChangePassword_Name$1,
    OrgSettings_LU_DefaultPassword_Desc: OrgSettings_LU_DefaultPassword_Desc$1,
    OrgSettings_LU_DefaultPassword_Name: OrgSettings_LU_DefaultPassword_Name$1,
    OrgSettings_LU_GroupSync_Name: OrgSettings_LU_GroupSync_Name$1,
    OrgSettings_MarketplaceWarning_Default: OrgSettings_MarketplaceWarning_Default$1,
    OrgSettings_MarketplaceWarning_Desc: OrgSettings_MarketplaceWarning_Desc$1,
    OrgSettings_MarketplaceWarning_Name: OrgSettings_MarketplaceWarning_Name$1,
    OrgSettings_MaxDescription: OrgSettings_MaxDescription$1,
    OrgSettings_MaxInputDescription: OrgSettings_MaxInputDescription$1,
    OrgSettings_MaxTitleDescription: OrgSettings_MaxTitleDescription$1,
    OrgSettings_MentionInComment_Desc: OrgSettings_MentionInComment_Desc$1,
    OrgSettings_MentionInComment_Name: OrgSettings_MentionInComment_Name$1,
    OrgSettings_MinimumAggregatedLearningInsightsUserCount_Desc: OrgSettings_MinimumAggregatedLearningInsightsUserCount_Desc$1,
    OrgSettings_MinimumAggregatedLearningInsightsUserCount_Name: OrgSettings_MinimumAggregatedLearningInsightsUserCount_Name$1,
    OrgSettings_MinimumSkillUserCount_Desc: OrgSettings_MinimumSkillUserCount_Desc$1,
    OrgSettings_MinimumSkillUserCount_Name: OrgSettings_MinimumSkillUserCount_Name$1,
    OrgSettings_MobileBiometricAuth_Desc: OrgSettings_MobileBiometricAuth_Desc$1,
    OrgSettings_MobileBiometricAuth_Name: OrgSettings_MobileBiometricAuth_Name$1,
    OrgSettings_MobileClientSessionTimeout_Desc: OrgSettings_MobileClientSessionTimeout_Desc$1,
    OrgSettings_MobileClientSessionTimeout_Name: OrgSettings_MobileClientSessionTimeout_Name$1,
    OrgSettings_MonthlyActivity_Error: OrgSettings_MonthlyActivity_Error$1,
    OrgSettings_MonthlyActivityDescription: OrgSettings_MonthlyActivityDescription$1,
    OrgSettings_MonthlyActivityTypes_ItemsCompleted: OrgSettings_MonthlyActivityTypes_ItemsCompleted$1,
    OrgSettings_MonthlyActivityTypes_ItemsViewed: OrgSettings_MonthlyActivityTypes_ItemsViewed$1,
    OrgSettings_MonthlyActivityTypes_LearningDuration: OrgSettings_MonthlyActivityTypes_LearningDuration$1,
    OrgSettings_MonthlyActivityTypes_PointsEarned: OrgSettings_MonthlyActivityTypes_PointsEarned$1,
    OrgSettings_MonthlyActivityWithType: OrgSettings_MonthlyActivityWithType$1,
    OrgSettings_NewLink: OrgSettings_NewLink$1,
    OrgSettings_NotificationEmails_GroupDesc: OrgSettings_NotificationEmails_GroupDesc$1,
    OrgSettings_NotificationEmails_GroupDisplayName: OrgSettings_NotificationEmails_GroupDisplayName$1,
    OrgSettings_NotRecommended: OrgSettings_NotRecommended$1,
    OrgSettings_OAuthRefreshTokenTimeout_Desc: OrgSettings_OAuthRefreshTokenTimeout_Desc$1,
    OrgSettings_OAuthRefreshTokenTimeout_Name: OrgSettings_OAuthRefreshTokenTimeout_Name$1,
    OrgSettings_OAuthSessionTimeout_Desc: OrgSettings_OAuthSessionTimeout_Desc$1,
    OrgSettings_OAuthSessionTimeout_Name: OrgSettings_OAuthSessionTimeout_Name$1,
    OrgSettings_Onboarding_GroupDesc: OrgSettings_Onboarding_GroupDesc$1,
    OrgSettings_Onboarding_GroupDisplayName: OrgSettings_Onboarding_GroupDisplayName$1,
    OrgSettings_OnboardingExperience: OrgSettings_OnboardingExperience$1,
    OrgSettings_OnboardingExperience_GroupDesc: OrgSettings_OnboardingExperience_GroupDesc$1,
    OrgSettings_OnboardingExperience_GroupDisplayName: OrgSettings_OnboardingExperience_GroupDisplayName$1,
    OrgSettings_OnboardingMessage_Default: OrgSettings_OnboardingMessage_Default$1,
    OrgSettings_OnboardingMessage_Desc: OrgSettings_OnboardingMessage_Desc$1,
    OrgSettings_OnboardingMessage_Name: OrgSettings_OnboardingMessage_Name$1,
    OrgSettings_OnboardingRateSkillsIsMandatory_Desc: OrgSettings_OnboardingRateSkillsIsMandatory_Desc$1,
    OrgSettings_OnboardingRateSkillsIsMandatory_Name: OrgSettings_OnboardingRateSkillsIsMandatory_Name$1,
    OrgSettings_OnboardingTitle_Default: OrgSettings_OnboardingTitle_Default$1,
    OrgSettings_OnboardingTitle_Desc: OrgSettings_OnboardingTitle_Desc$1,
    OrgSettings_OnboardingTitle_Name: OrgSettings_OnboardingTitle_Name$1,
    OrgSettings_OnboardingWelcomeGreeting_Desc: OrgSettings_OnboardingWelcomeGreeting_Desc$1,
    OrgSettings_OnboardingWelcomeGreeting_Name: OrgSettings_OnboardingWelcomeGreeting_Name$1,
    OrgSettings_OpportunitiesActivityStartDate_Desc: OrgSettings_OpportunitiesActivityStartDate_Desc$1,
    OrgSettings_OpportunitiesActivityStartDate_Name: OrgSettings_OpportunitiesActivityStartDate_Name$1,
    OrgSettings_OrganizationEmailFromName_Desc: OrgSettings_OrganizationEmailFromName_Desc$1,
    OrgSettings_OrganizationEmailFromName_Name: OrgSettings_OrganizationEmailFromName_Name$1,
    OrgSettings_OrganizationEmailLogo_Desc: OrgSettings_OrganizationEmailLogo_Desc$1,
    OrgSettings_OrganizationEmailLogo_Name: OrgSettings_OrganizationEmailLogo_Name$1,
    OrgSettings_OrgIntroEmailMessage_Desc: OrgSettings_OrgIntroEmailMessage_Desc$1,
    OrgSettings_OrgIntroEmailMessage_Name: OrgSettings_OrgIntroEmailMessage_Name$1,
    OrgSettings_OrgSupportInfoCustomLink_Desc: OrgSettings_OrgSupportInfoCustomLink_Desc$1,
    OrgSettings_OrgSupportInfoCustomLink_Name: OrgSettings_OrgSupportInfoCustomLink_Name$1,
    OrgSettings_OrgSupportInfoCustomLink_Placeholder: OrgSettings_OrgSupportInfoCustomLink_Placeholder$1,
    OrgSettings_OrgSupportInfoCustomLinkURL_Placeholder: OrgSettings_OrgSupportInfoCustomLinkURL_Placeholder$1,
    OrgSettings_OrgSupportInfoEmail_Desc: OrgSettings_OrgSupportInfoEmail_Desc$1,
    OrgSettings_OrgSupportInfoEmail_Label: OrgSettings_OrgSupportInfoEmail_Label$1,
    OrgSettings_OrgSupportInfoEmail_Name: OrgSettings_OrgSupportInfoEmail_Name$1,
    OrgSettings_OrgSupportInfoEmail_Placeholder: OrgSettings_OrgSupportInfoEmail_Placeholder$1,
    OrgSettings_OrgSupportInfoFaq_Desc: OrgSettings_OrgSupportInfoFaq_Desc$1,
    OrgSettings_OrgSupportInfoFaq_Label: OrgSettings_OrgSupportInfoFaq_Label$1,
    OrgSettings_OrgSupportInfoFaq_Name: OrgSettings_OrgSupportInfoFaq_Name$1,
    OrgSettings_OrgSupportInfoFaq_Placeholder: OrgSettings_OrgSupportInfoFaq_Placeholder$1,
    OrgSettings_OrgSupportInfoLinkText_Label: OrgSettings_OrgSupportInfoLinkText_Label$1,
    OrgSettings_OrgSupportInfoLinkText_Placeholder: OrgSettings_OrgSupportInfoLinkText_Placeholder$1,
    OrgSettings_OrgSupportInfoLinkURL_Label: OrgSettings_OrgSupportInfoLinkURL_Label$1,
    OrgSettings_OrgSupportInfoLinkURL_Placeholder: OrgSettings_OrgSupportInfoLinkURL_Placeholder$1,
    OrgSettings_OrgSupportInfoPhone_Desc: OrgSettings_OrgSupportInfoPhone_Desc$1,
    OrgSettings_OrgSupportInfoPhone_Label: OrgSettings_OrgSupportInfoPhone_Label$1,
    OrgSettings_OrgSupportInfoPhone_Name: OrgSettings_OrgSupportInfoPhone_Name$1,
    OrgSettings_OrgSupportInfoPhone_Placeholder: OrgSettings_OrgSupportInfoPhone_Placeholder$1,
    OrgSettings_OtherEmails_GroupDesc: OrgSettings_OtherEmails_GroupDesc$1,
    OrgSettings_OtherEmails_GroupDisplayName: OrgSettings_OtherEmails_GroupDisplayName$1,
    OrgSettings_PasswordExpirationPeriod_DefaultText: OrgSettings_PasswordExpirationPeriod_DefaultText$1,
    OrgSettings_PasswordExpirationPeriod_Desc: OrgSettings_PasswordExpirationPeriod_Desc$1,
    OrgSettings_PasswordExpirationPeriod_Name: OrgSettings_PasswordExpirationPeriod_Name$1,
    OrgSettings_PathwayFeedbackSurvey_Desc: OrgSettings_PathwayFeedbackSurvey_Desc$1,
    OrgSettings_PathwayFeedbackSurvey_Name: OrgSettings_PathwayFeedbackSurvey_Name$1,
    OrgSettings_PermissionRoles_Desc: OrgSettings_PermissionRoles_Desc$1,
    OrgSettings_PermissionRoles_Name: OrgSettings_PermissionRoles_Name$1,
    OrgSettings_PersistSessionCookie_Desc: OrgSettings_PersistSessionCookie_Desc$1,
    OrgSettings_PersistSessionCookie_Name: OrgSettings_PersistSessionCookie_Name$1,
    OrgSettings_PointsDecommission_Desc: OrgSettings_PointsDecommission_Desc$1,
    OrgSettings_PointsDecommission_Name: OrgSettings_PointsDecommission_Name$1,
    OrgSettings_PreventPublicProfiles_Desc: OrgSettings_PreventPublicProfiles_Desc$1,
    OrgSettings_PreventPublicProfiles_Name: OrgSettings_PreventPublicProfiles_Name$1,
    OrgSettings_PrivacyChangeToOrganizationMessage_Default: OrgSettings_PrivacyChangeToOrganizationMessage_Default$1,
    OrgSettings_PrivacyChangeToOrganizationMessage_Desc: OrgSettings_PrivacyChangeToOrganizationMessage_Desc$1,
    OrgSettings_PrivacyChangeToOrganizationMessage_Name: OrgSettings_PrivacyChangeToOrganizationMessage_Name$1,
    OrgSettings_PrivacyChangeToPrivateMessage_Default: OrgSettings_PrivacyChangeToPrivateMessage_Default$1,
    OrgSettings_PrivacyChangeToPrivateMessage_Desc: OrgSettings_PrivacyChangeToPrivateMessage_Desc$1,
    OrgSettings_PrivacyChangeToPrivateMessage_Name: OrgSettings_PrivacyChangeToPrivateMessage_Name$1,
    OrgSettings_PrivacyChangeToPublicMessage_Default: OrgSettings_PrivacyChangeToPublicMessage_Default$1,
    OrgSettings_PrivacyChangeToPublicMessage_Desc: OrgSettings_PrivacyChangeToPublicMessage_Desc$1,
    OrgSettings_PrivacyChangeToPublicMessage_Name: OrgSettings_PrivacyChangeToPublicMessage_Name$1,
    OrgSettings_PrivacySettings: OrgSettings_PrivacySettings$1,
    OrgSettings_ProfileOverviewTabDefault_Desc: OrgSettings_ProfileOverviewTabDefault_Desc$1,
    OrgSettings_ProfileOverviewTabDefault_Name: OrgSettings_ProfileOverviewTabDefault_Name$1,
    OrgSettings_ProfileOverviewTabDefault_Selection_Focus: OrgSettings_ProfileOverviewTabDefault_Selection_Focus$1,
    OrgSettings_ProfileOverviewTabDefault_Selection_Top: OrgSettings_ProfileOverviewTabDefault_Selection_Top$1,
    OrgSettings_ProfilePrivacyUpdate_GroupDesc: OrgSettings_ProfilePrivacyUpdate_GroupDesc$1,
    OrgSettings_ProfilePrivacyUpdate_GroupDisplayName: OrgSettings_ProfilePrivacyUpdate_GroupDisplayName$1,
    OrgSettings_Providers_Desc: OrgSettings_Providers_Desc$1,
    OrgSettings_Providers_Name: OrgSettings_Providers_Name$1,
    OrgSettings_PublishCards: OrgSettings_PublishCards$1,
    OrgSettings_PublishCardsAriaText: OrgSettings_PublishCardsAriaText$1,
    OrgSettings_PublishCardsSingleSuccess: OrgSettings_PublishCardsSingleSuccess$1,
    OrgSettings_PublishCardsSuccess: OrgSettings_PublishCardsSuccess$1,
    OrgSettings_PublishChanges: OrgSettings_PublishChanges$1,
    OrgSettings_QuickLinks: OrgSettings_QuickLinks$1,
    OrgSettings_RapRedirectUrl_Desc: OrgSettings_RapRedirectUrl_Desc$1,
    OrgSettings_RapRedirectUrl_Label: OrgSettings_RapRedirectUrl_Label$1,
    OrgSettings_RapRedirectUrl_Name: OrgSettings_RapRedirectUrl_Name$1,
    OrgSettings_RapRedirectUrl_Placeholder: OrgSettings_RapRedirectUrl_Placeholder$1,
    OrgSettings_RateSkillsEmail_Desc: OrgSettings_RateSkillsEmail_Desc$1,
    OrgSettings_RateSkillsEmail_Name: OrgSettings_RateSkillsEmail_Name$1,
    OrgSettings_RatingsVisibilityPublic_Desc: OrgSettings_RatingsVisibilityPublic_Desc$1,
    OrgSettings_Recommendations_Desc: OrgSettings_Recommendations_Desc$1,
    OrgSettings_Recommendations_Name: OrgSettings_Recommendations_Name$1,
    OrgSettings_RemoveCard: OrgSettings_RemoveCard$1,
    OrgSettings_RemoveCardConfirmation: OrgSettings_RemoveCardConfirmation$1,
    OrgSettings_RemoveCardConfirmation_Body: OrgSettings_RemoveCardConfirmation_Body$1,
    OrgSettings_RemoveCardProceed_Confirm: OrgSettings_RemoveCardProceed_Confirm$1,
    OrgSettings_ReorderCards: OrgSettings_ReorderCards$1,
    OrgSettings_ReorderCardsAriaText: OrgSettings_ReorderCardsAriaText$1,
    OrgSettings_ReorderHomeSections: OrgSettings_ReorderHomeSections$1,
    OrgSettings_ReorderInsightCards: OrgSettings_ReorderInsightCards$1,
    OrgSettings_ReorderInvalidCardsAriaText: OrgSettings_ReorderInvalidCardsAriaText$1,
    OrgSettings_ReplyToComment_Desc: OrgSettings_ReplyToComment_Desc$1,
    OrgSettings_ReplyToComment_Name: OrgSettings_ReplyToComment_Name$1,
    OrgSettings_ReportAProblem_GroupDesc: OrgSettings_ReportAProblem_GroupDesc$1,
    OrgSettings_ReportAProblem_GroupDisplayName: OrgSettings_ReportAProblem_GroupDisplayName$1,
    OrgSettings_ReportEmailSettings_Desc: OrgSettings_ReportEmailSettings_Desc$1,
    OrgSettings_ReportEmailSettings_Name: OrgSettings_ReportEmailSettings_Name$1,
    OrgSettings_ReportingDateFormat_Desc: OrgSettings_ReportingDateFormat_Desc$1,
    OrgSettings_ReportingDateFormat_Name: OrgSettings_ReportingDateFormat_Name$1,
    OrgSettings_ReportingFTPConnection_Name: OrgSettings_ReportingFTPConnection_Name$1,
    OrgSettings_ReportingOrganizationNameAlias_Desc: OrgSettings_ReportingOrganizationNameAlias_Desc$1,
    OrgSettings_ReportingOrganizationNameAlias_Name: OrgSettings_ReportingOrganizationNameAlias_Name$1,
    OrgSettings_ReportingTimeZone_Desc: OrgSettings_ReportingTimeZone_Desc$1,
    OrgSettings_ReportingTimeZone_Name: OrgSettings_ReportingTimeZone_Name$1,
    OrgSettings_RequireInternalCredentialReviews_Desc: OrgSettings_RequireInternalCredentialReviews_Desc$1,
    OrgSettings_RequireInternalCredentialReviews_Name: OrgSettings_RequireInternalCredentialReviews_Name$1,
    OrgSettings_ResetAcceptance: OrgSettings_ResetAcceptance$1,
    OrgSettings_ResetDefaultMessage: OrgSettings_ResetDefaultMessage$1,
    OrgSettings_ResetPrivacyAcceptanceHeader: OrgSettings_ResetPrivacyAcceptanceHeader$1,
    OrgSettings_ResetPrivacyAcceptanceSuccess: OrgSettings_ResetPrivacyAcceptanceSuccess$1,
    OrgSettings_ResetPrivacyAcceptanceWarning: OrgSettings_ResetPrivacyAcceptanceWarning$1,
    OrgSettings_RestrictDuplicateEmailsOnUserFile_Desc: OrgSettings_RestrictDuplicateEmailsOnUserFile_Desc$1,
    OrgSettings_RestrictDuplicateEmailsOnUserFile_Name: OrgSettings_RestrictDuplicateEmailsOnUserFile_Name$1,
    OrgSettings_RestrictExtension_Desc: OrgSettings_RestrictExtension_Desc$1,
    OrgSettings_RestrictExtension_Name: OrgSettings_RestrictExtension_Name$1,
    OrgSettings_RestrictITunesExternalPodcastLinks_Desc: OrgSettings_RestrictITunesExternalPodcastLinks_Desc$1,
    OrgSettings_RestrictITunesExternalPodcastLinks_Name: OrgSettings_RestrictITunesExternalPodcastLinks_Name$1,
    OrgSettings_RestrictMobileApp_Desc: OrgSettings_RestrictMobileApp_Desc$1,
    OrgSettings_RestrictMobileApp_Name: OrgSettings_RestrictMobileApp_Name$1,
    OrgSettings_RestrictMobileAppInChina_Desc: OrgSettings_RestrictMobileAppInChina_Desc$1,
    OrgSettings_RestrictMobileAppInChina_Name: OrgSettings_RestrictMobileAppInChina_Name$1,
    OrgSettings_RunRulesSkippedRecords_Desc: OrgSettings_RunRulesSkippedRecords_Desc$1,
    OrgSettings_RunRulesSkippedRecords_Name: OrgSettings_RunRulesSkippedRecords_Name$1,
    OrgSettings_SavedLinks: OrgSettings_SavedLinks$1,
    OrgSettings_SavedLinksCount: OrgSettings_SavedLinksCount$1,
    OrgSettings_Security_ApiSectionDescription: OrgSettings_Security_ApiSectionDescription$1,
    OrgSettings_Security_ApiSectionTitle: OrgSettings_Security_ApiSectionTitle$1,
    OrgSettings_Security_ApiTimeoutDescription: OrgSettings_Security_ApiTimeoutDescription$1,
    OrgSettings_Security_ApiTimeOutError: OrgSettings_Security_ApiTimeOutError$1,
    OrgSettings_Security_ApiTimeOutResetAriaLabel: OrgSettings_Security_ApiTimeOutResetAriaLabel$1,
    OrgSettings_Security_ApiTimeoutTitle: OrgSettings_Security_ApiTimeoutTitle$1,
    OrgSettings_Security_ChromeSectionDescription: OrgSettings_Security_ChromeSectionDescription$1,
    OrgSettings_Security_ChromeSectionTitle: OrgSettings_Security_ChromeSectionTitle$1,
    OrgSettings_Security_ChromeTimeoutDescription: OrgSettings_Security_ChromeTimeoutDescription$1,
    OrgSettings_Security_ChromeTimeOutResetAriaLabel: OrgSettings_Security_ChromeTimeOutResetAriaLabel$1,
    OrgSettings_Security_ChromeTimeoutTitle: OrgSettings_Security_ChromeTimeoutTitle$1,
    OrgSettings_Security_ExtensionTimeOutError: OrgSettings_Security_ExtensionTimeOutError$1,
    OrgSettings_Security_InactivityTimeOutDescription: OrgSettings_Security_InactivityTimeOutDescription$1,
    OrgSettings_Security_InactivityTimeOutError: OrgSettings_Security_InactivityTimeOutError$1,
    OrgSettings_Security_InactivityTimeOutIntervalAriaLabel: OrgSettings_Security_InactivityTimeOutIntervalAriaLabel$1,
    OrgSettings_Security_InactivityTimeOutResetAriaLabel: OrgSettings_Security_InactivityTimeOutResetAriaLabel$1,
    OrgSettings_Security_InactivityTimeOutTitle: OrgSettings_Security_InactivityTimeOutTitle$1,
    OrgSettings_Security_LoginTimeOutDescription: OrgSettings_Security_LoginTimeOutDescription$1,
    OrgSettings_Security_LoginTimeOutError: OrgSettings_Security_LoginTimeOutError$1,
    OrgSettings_Security_LoginTimeOutIntervalAriaLabel: OrgSettings_Security_LoginTimeOutIntervalAriaLabel$1,
    OrgSettings_Security_LoginTimeOutResetAriaLabel: OrgSettings_Security_LoginTimeOutResetAriaLabel$1,
    OrgSettings_Security_LoginTimeOutTitle: OrgSettings_Security_LoginTimeOutTitle$1,
    OrgSettings_Security_LogOutAllUsers: OrgSettings_Security_LogOutAllUsers$1,
    OrgSettings_Security_LogOutWarningText: OrgSettings_Security_LogOutWarningText$1,
    OrgSettings_Security_MobileSectionDescription: OrgSettings_Security_MobileSectionDescription$1,
    OrgSettings_Security_MobileSectionTitle: OrgSettings_Security_MobileSectionTitle$1,
    OrgSettings_Security_MobileTimeoutDescription: OrgSettings_Security_MobileTimeoutDescription$1,
    OrgSettings_Security_MobileTimeOutError: OrgSettings_Security_MobileTimeOutError$1,
    OrgSettings_Security_MobileTimeOutResetAriaLabel: OrgSettings_Security_MobileTimeOutResetAriaLabel$1,
    OrgSettings_Security_MobileTimeoutTitle: OrgSettings_Security_MobileTimeoutTitle$1,
    OrgSettings_Security_NonPersistentSessionDescription: OrgSettings_Security_NonPersistentSessionDescription$1,
    OrgSettings_Security_NonPersistentSessionTitle: OrgSettings_Security_NonPersistentSessionTitle$1,
    OrgSettings_Security_PageTitle: OrgSettings_Security_PageTitle$1,
    OrgSettings_Security_PersistentSessionDescription: OrgSettings_Security_PersistentSessionDescription$1,
    OrgSettings_Security_PersistentSessionTitle: OrgSettings_Security_PersistentSessionTitle$1,
    OrgSettings_Security_SessionCookieModeTitle: OrgSettings_Security_SessionCookieModeTitle$1,
    OrgSettings_Security_WebSectionDescription: OrgSettings_Security_WebSectionDescription$1,
    OrgSettings_Security_WebSectionTitle: OrgSettings_Security_WebSectionTitle$1,
    OrgSettings_SegmentsDuplicateError: OrgSettings_SegmentsDuplicateError$1,
    OrgSettings_SegmentsMaxError: OrgSettings_SegmentsMaxError$1,
    OrgSettings_SelectLearningMetric: OrgSettings_SelectLearningMetric$1,
    OrgSettings_SelectLearningMetricPlaceholder: OrgSettings_SelectLearningMetricPlaceholder$1,
    OrgSettings_SendAllRapTicketsToClient_Desc: OrgSettings_SendAllRapTicketsToClient_Desc$1,
    OrgSettings_SendAllRapTicketsToClient_Name: OrgSettings_SendAllRapTicketsToClient_Name$1,
    OrgSettings_ServiceNowIntegrationConfiguration_Desc: OrgSettings_ServiceNowIntegrationConfiguration_Desc$1,
    OrgSettings_ServiceNowIntegrationConfiguration_Name: OrgSettings_ServiceNowIntegrationConfiguration_Name$1,
    OrgSettings_SessionTimeoutAbsoluteConfig_Desc: OrgSettings_SessionTimeoutAbsoluteConfig_Desc$1,
    OrgSettings_SessionTimeoutAbsoluteConfig_Name: OrgSettings_SessionTimeoutAbsoluteConfig_Name$1,
    OrgSettings_SessionTimeoutInactivityConfig_Desc: OrgSettings_SessionTimeoutInactivityConfig_Desc$1,
    OrgSettings_SessionTimeoutInactivityConfig_Name: OrgSettings_SessionTimeoutInactivityConfig_Name$1,
    OrgSettings_SetEvaluationsPrivateByDefault_Desc: OrgSettings_SetEvaluationsPrivateByDefault_Desc$1,
    OrgSettings_SetEvaluationsPrivateByDefault_Name: OrgSettings_SetEvaluationsPrivateByDefault_Name$1,
    OrgSettings_ShouldTransformTaxonomy_Desc: OrgSettings_ShouldTransformTaxonomy_Desc$1,
    OrgSettings_ShouldTransformTaxonomy_Name: OrgSettings_ShouldTransformTaxonomy_Name$1,
    OrgSettings_ShowAllProvidersInSearchFacet_Desc: OrgSettings_ShowAllProvidersInSearchFacet_Desc$1,
    OrgSettings_ShowAllProvidersInSearchFacet_Name: OrgSettings_ShowAllProvidersInSearchFacet_Name$1,
    OrgSettings_ShowCookiePolicyLink_Desc: OrgSettings_ShowCookiePolicyLink_Desc$1,
    OrgSettings_ShowCookiePolicyLink_Name: OrgSettings_ShowCookiePolicyLink_Name$1,
    OrgSettings_ShowExternalContentWarning_Default: OrgSettings_ShowExternalContentWarning_Default$1,
    OrgSettings_ShowExternalContentWarning_Desc: OrgSettings_ShowExternalContentWarning_Desc$1,
    OrgSettings_ShowExternalContentWarning_Name: OrgSettings_ShowExternalContentWarning_Name$1,
    OrgSettings_ShowGroupMembershipSource_Desc: OrgSettings_ShowGroupMembershipSource_Desc$1,
    OrgSettings_ShowGroupMembershipSource_Name: OrgSettings_ShowGroupMembershipSource_Name$1,
    OrgSettings_ShowSlackIntegration_Desc: OrgSettings_ShowSlackIntegration_Desc$1,
    OrgSettings_ShowSlackIntegration_Name: OrgSettings_ShowSlackIntegration_Name$1,
    OrgSettings_Size: OrgSettings_Size$1,
    OrgSettings_SizeKiloByte: OrgSettings_SizeKiloByte$1,
    OrgSettings_SkillCoachFullOrgAccess_Desc: OrgSettings_SkillCoachFullOrgAccess_Desc$1,
    OrgSettings_SkillCoachFullOrgAccess_Name: OrgSettings_SkillCoachFullOrgAccess_Name$1,
    OrgSettings_SkillInventoryClientOverride_Desc: OrgSettings_SkillInventoryClientOverride_Desc$1,
    OrgSettings_SkillInventoryClientOverride_Name: OrgSettings_SkillInventoryClientOverride_Name$1,
    OrgSettings_Skills_Desc: OrgSettings_Skills_Desc$1,
    OrgSettings_Skills_Name: OrgSettings_Skills_Name$1,
    OrgSettings_SkillsCheckupEmail_Desc: OrgSettings_SkillsCheckupEmail_Desc$1,
    OrgSettings_SkillsCheckupEmail_Name: OrgSettings_SkillsCheckupEmail_Name$1,
    OrgSettings_SkipEmailLookup_Desc: OrgSettings_SkipEmailLookup_Desc$1,
    OrgSettings_SkipEmailLookup_Name: OrgSettings_SkipEmailLookup_Name$1,
    OrgSettings_SocialNotify_Desc: OrgSettings_SocialNotify_Desc$1,
    OrgSettings_SocialNotify_Name: OrgSettings_SocialNotify_Name$1,
    OrgSettings_SocialSettings: OrgSettings_SocialSettings$1,
    OrgSettings_SsoAutoCreateProfile_Desc: OrgSettings_SsoAutoCreateProfile_Desc$1,
    OrgSettings_SsoAutoCreateProfile_Name: OrgSettings_SsoAutoCreateProfile_Name$1,
    OrgSettings_SuggestInternalContentOnly_Desc: OrgSettings_SuggestInternalContentOnly_Desc$1,
    OrgSettings_SuggestInternalContentOnly_Name: OrgSettings_SuggestInternalContentOnly_Name$1,
    OrgSettings_SuggestTags_Desc: OrgSettings_SuggestTags_Desc$1,
    OrgSettings_SuggestTags_Name: OrgSettings_SuggestTags_Name$1,
    OrgSettings_SuggestTargets_Desc: OrgSettings_SuggestTargets_Desc$1,
    OrgSettings_SuggestTargets_Name: OrgSettings_SuggestTargets_Name$1,
    OrgSettings_SupportTargets_Desc: OrgSettings_SupportTargets_Desc$1,
    OrgSettings_SupportTargets_Name: OrgSettings_SupportTargets_Name$1,
    OrgSettings_Tier1UserSupportTicketsEmailSettings_Desc: OrgSettings_Tier1UserSupportTicketsEmailSettings_Desc$1,
    OrgSettings_Tier1UserSupportTicketsEmailSettings_Name: OrgSettings_Tier1UserSupportTicketsEmailSettings_Name$1,
    OrgSettings_ToggleOff: OrgSettings_ToggleOff$1,
    OrgSettings_ToggleOn: OrgSettings_ToggleOn$1,
    OrgSettings_TotalInstance: OrgSettings_TotalInstance$1,
    OrgSettings_TotalInstanceCount_PluralFormat: OrgSettings_TotalInstanceCount_PluralFormat$1,
    OrgSettings_TotalInstanceCount_Single: OrgSettings_TotalInstanceCount_Single$1,
    OrgSettings_TotalInstances: OrgSettings_TotalInstances$1,
    OrgSettings_TotalRow: OrgSettings_TotalRow$1,
    OrgSettings_TotalRows: OrgSettings_TotalRows$1,
    OrgSettings_TotalRowsCount_PluralFormat: OrgSettings_TotalRowsCount_PluralFormat$1,
    OrgSettings_TotalRowsCount_Single: OrgSettings_TotalRowsCount_Single$1,
    OrgSettings_TrackLearning_Desc: OrgSettings_TrackLearning_Desc$1,
    OrgSettings_TrackLearning_Name: OrgSettings_TrackLearning_Name$1,
    OrgSettings_TrackLearningOnGo_Desc: OrgSettings_TrackLearningOnGo_Desc$1,
    OrgSettings_TrackLearningOnGo_Name: OrgSettings_TrackLearningOnGo_Name$1,
    OrgSettings_UnpublishCards: OrgSettings_UnpublishCards$1,
    OrgSettings_UntitledLinkTitle: OrgSettings_UntitledLinkTitle$1,
    OrgSettings_UpdateCard: OrgSettings_UpdateCard$1,
    OrgSettings_UpdateEmails_GroupDesc: OrgSettings_UpdateEmails_GroupDesc$1,
    OrgSettings_UpdateEmails_GroupDisplayName: OrgSettings_UpdateEmails_GroupDisplayName$1,
    OrgSettings_UpdatePublishing: OrgSettings_UpdatePublishing$1,
    OrgSettings_UpdateUserTagRatings_Desc: OrgSettings_UpdateUserTagRatings_Desc$1,
    OrgSettings_UpdateUserTagRatings_Name: OrgSettings_UpdateUserTagRatings_Name$1,
    OrgSettings_UpdateUserTagRatingsEmail_Desc: OrgSettings_UpdateUserTagRatingsEmail_Desc$1,
    OrgSettings_UpdateUserTagRatingsEmail_Name: OrgSettings_UpdateUserTagRatingsEmail_Name$1,
    OrgSettings_UpdateUserTags_Desc: OrgSettings_UpdateUserTags_Desc$1,
    OrgSettings_UpdateUserTags_Name: OrgSettings_UpdateUserTags_Name$1,
    OrgSettings_UrlScanExemptDomains_Desc: OrgSettings_UrlScanExemptDomains_Desc$1,
    OrgSettings_UrlScanExemptDomains_Name: OrgSettings_UrlScanExemptDomains_Name$1,
    OrgSettings_UseInternalJobSkills_Desc: OrgSettings_UseInternalJobSkills_Desc$1,
    OrgSettings_UseInternalJobSkills_Name: OrgSettings_UseInternalJobSkills_Name$1,
    OrgSettings_UserNotificationEmail_Desc: OrgSettings_UserNotificationEmail_Desc$1,
    OrgSettings_UserNotificationEmail_Name: OrgSettings_UserNotificationEmail_Name$1,
    OrgSettings_UseZendeskWebWidget_Desc: OrgSettings_UseZendeskWebWidget_Desc$1,
    OrgSettings_UseZendeskWebWidget_Name: OrgSettings_UseZendeskWebWidget_Name$1,
    OrgSettings_WeeklySummaryEmail_Desc: OrgSettings_WeeklySummaryEmail_Desc$1,
    OrgSettings_WeeklySummaryEmail_Name: OrgSettings_WeeklySummaryEmail_Name$1,
    OrgSettings_WelcomeEmail_Desc: OrgSettings_WelcomeEmail_Desc$1,
    OrgSettings_WelcomeEmail_Name: OrgSettings_WelcomeEmail_Name$1,
    OrgSettings_WelcomeIntro_Desc: OrgSettings_WelcomeIntro_Desc$1,
    OrgSettings_WelcomeIntro_Name: OrgSettings_WelcomeIntro_Name$1,
    OrgSettings_WeMissYouEmail_Desc: OrgSettings_WeMissYouEmail_Desc$1,
    OrgSettings_WeMissYouEmail_Name: OrgSettings_WeMissYouEmail_Name$1,
    OrgSettings_WhatSkillsEmail_Desc: OrgSettings_WhatSkillsEmail_Desc$1,
    OrgSettings_WhatSkillsEmail_Name: OrgSettings_WhatSkillsEmail_Name$1,
    OrgSettings_WhitelistedDomains_Desc: OrgSettings_WhitelistedDomains_Desc$1,
    OrgSettings_WhitelistedDomains_Name: OrgSettings_WhitelistedDomains_Name$1,
    OrgSettings_WhiteListFtpAccessIpAddresses_Desc: OrgSettings_WhiteListFtpAccessIpAddresses_Desc$1,
    OrgSettings_WhiteListFtpAccessIpAddresses_Name: OrgSettings_WhiteListFtpAccessIpAddresses_Name$1,
    OrgSettings_ZendeskWidgetKey_Desc: OrgSettings_ZendeskWidgetKey_Desc$1,
    OrgSettings_ZendeskWidgetKey_Name: OrgSettings_ZendeskWidgetKey_Name$1,
    OrgSecurityCtrl_CreateGroups: OrgSecurityCtrl_CreateGroups$1,
    OrgSecurityCtrl_DefaultRoleTextFormat: OrgSecurityCtrl_DefaultRoleTextFormat$1,
    OrgSecurityCtrl_RolesUpdatedSuccessMessage: OrgSecurityCtrl_RolesUpdatedSuccessMessage$1,
    OrgReportSchedule_Frequency_Daily: OrgReportSchedule_Frequency_Daily$1,
    OrgReportSchedule_Frequency_DailyMondayThruFriday: OrgReportSchedule_Frequency_DailyMondayThruFriday$1,
    OrgReportSchedule_Frequency_Monthly: OrgReportSchedule_Frequency_Monthly$1,
    OrgReportSchedule_Frequency_Quarterly: OrgReportSchedule_Frequency_Quarterly$1,
    OrgReportSchedule_Frequency_WeeklyOnMonday: OrgReportSchedule_Frequency_WeeklyOnMonday$1,
    OrgReportSchedule_Frequency_WeeklyOnSunday: OrgReportSchedule_Frequency_WeeklyOnSunday$1,
    OrgReportingCtrl_All: OrgReportingCtrl_All$1,
    OrgReportingCtrl_AllCompletedContent: OrgReportingCtrl_AllCompletedContent$1,
    OrgReportingCtrl_AllGroups: OrgReportingCtrl_AllGroups$1,
    OrgReportingCtrl_AllSkills: OrgReportingCtrl_AllSkills$1,
    OrgReportingCtrl_AllTopics: OrgReportingCtrl_AllTopics$1,
    OrgReportingCtrl_And: OrgReportingCtrl_And$1,
    OrgReportingCtrl_Count: OrgReportingCtrl_Count$1,
    OrgReportingCtrl_DateMaxValidation: OrgReportingCtrl_DateMaxValidation$1,
    OrgReportingCtrl_DateMaxValidationFormat: OrgReportingCtrl_DateMaxValidationFormat$1,
    OrgReportingCtrl_DownloadableReports: OrgReportingCtrl_DownloadableReports$1,
    OrgReportingCtrl_ErrorWithProvider: OrgReportingCtrl_ErrorWithProvider$1,
    OrgReportingCtrl_ExternalCatalog: OrgReportingCtrl_ExternalCatalog$1,
    OrgReportingCtrl_ExternalContent: OrgReportingCtrl_ExternalContent$1,
    OrgReportingCtrl_FilterByGroup: OrgReportingCtrl_FilterByGroup$1,
    OrgReportingCtrl_FilterByLocation: OrgReportingCtrl_FilterByLocation$1,
    OrgReportingCtrl_FilterByOrg: OrgReportingCtrl_FilterByOrg$1,
    OrgReportingCtrl_FilterBySkill: OrgReportingCtrl_FilterBySkill$1,
    OrgReportingCtrl_FullCatalog: OrgReportingCtrl_FullCatalog$1,
    OrgReportingCtrl_InputsAdded: OrgReportingCtrl_InputsAdded$1,
    OrgReportingCtrl_Insights: OrgReportingCtrl_Insights$1,
    OrgReportingCtrl_InternalCatalog: OrgReportingCtrl_InternalCatalog$1,
    OrgReportingCtrl_InternalContent: OrgReportingCtrl_InternalContent$1,
    OrgReportingCtrl_ItemsAdded: OrgReportingCtrl_ItemsAdded$1,
    OrgReportingCtrl_KpiItemsAddedName: OrgReportingCtrl_KpiItemsAddedName$1,
    OrgReportingCtrl_KpiItemsAddedTooltip: OrgReportingCtrl_KpiItemsAddedTooltip$1,
    OrgReportingCtrl_KpiLoginsName: OrgReportingCtrl_KpiLoginsName$1,
    OrgReportingCtrl_KpiLoginsTooltip: OrgReportingCtrl_KpiLoginsTooltip$1,
    OrgReportingCtrl_KpiOrgExpertsName: OrgReportingCtrl_KpiOrgExpertsName$1,
    OrgReportingCtrl_KpiOrgExpertsTooltip: OrgReportingCtrl_KpiOrgExpertsTooltip$1,
    OrgReportingCtrl_KpiRecommendationsName: OrgReportingCtrl_KpiRecommendationsName$1,
    OrgReportingCtrl_KpiRecommendationsTooltip: OrgReportingCtrl_KpiRecommendationsTooltip$1,
    OrgReportingCtrl_KPIS_Error: OrgReportingCtrl_KPIS_Error$1,
    OrgReportingCtrl_KpiSkillRatedUsersName: OrgReportingCtrl_KpiSkillRatedUsersName$1,
    OrgReportingCtrl_KpiSkillRatedUsersTooltip: OrgReportingCtrl_KpiSkillRatedUsersTooltip$1,
    OrgReportingCtrl_KpiViewsName: OrgReportingCtrl_KpiViewsName$1,
    OrgReportingCtrl_KpiViewsTooltip: OrgReportingCtrl_KpiViewsTooltip$1,
    OrgReportingCtrl_LearningSummary: OrgReportingCtrl_LearningSummary$1,
    OrgReportingCtrl_Members: OrgReportingCtrl_Members$1,
    OrgReportingCtrl_MinimumAggregatedLearningInsightsUserCount: OrgReportingCtrl_MinimumAggregatedLearningInsightsUserCount$1,
    OrgReportingCtrl_Name: OrgReportingCtrl_Name$1,
    OrgReportingCtrl_NoMatchingGroups: OrgReportingCtrl_NoMatchingGroups$1,
    OrgReportingCtrl_NoMatchingLocations: OrgReportingCtrl_NoMatchingLocations$1,
    OrgReportingCtrl_NoMatchingOrgs: OrgReportingCtrl_NoMatchingOrgs$1,
    OrgReportingCtrl_NoMatchingSkills: OrgReportingCtrl_NoMatchingSkills$1,
    OrgReportingCtrl_NoMatchingStatus: OrgReportingCtrl_NoMatchingStatus$1,
    OrgReportingCtrl_NoMatchingTypes: OrgReportingCtrl_NoMatchingTypes$1,
    OrgReportingCtrl_NoResults: OrgReportingCtrl_NoResults$1,
    OrgReportingCtrl_Points: OrgReportingCtrl_Points$1,
    OrgReportingCtrl_ResultsFormat: OrgReportingCtrl_ResultsFormat$1,
    OrgReportingCtrl_ShouldNotBeConnected: OrgReportingCtrl_ShouldNotBeConnected$1,
    OrgReportingCtrl_TimesAdded: OrgReportingCtrl_TimesAdded$1,
    OrgReportingCtrl_TopResultsFormat: OrgReportingCtrl_TopResultsFormat$1,
    OrgReportingCtrl_TotalContentViewed: OrgReportingCtrl_TotalContentViewed$1,
    OrgReportingCtrl_TotalItemsAdded: OrgReportingCtrl_TotalItemsAdded$1,
    OrgReportingCtrl_TotalPointsEarned: OrgReportingCtrl_TotalPointsEarned$1,
    OrgRatingScaleChange_NotificationContent: OrgRatingScaleChange_NotificationContent$1,
    OrgRatingScaleChange_NotificationDescription: OrgRatingScaleChange_NotificationDescription$1,
    OrgRatingScaleChange_NotificationTitle: OrgRatingScaleChange_NotificationTitle$1,
    orgProviderLicenseModal_ContinueButtonFormat: orgProviderLicenseModal_ContinueButtonFormat$1,
    orgProviderLicenseModal_CreatedLicenseFormat: orgProviderLicenseModal_CreatedLicenseFormat$1,
    orgProviderLicenseModal_InstructionsFormat: orgProviderLicenseModal_InstructionsFormat$1,
    orgProviderLicenseModal_LicenseErrorFormat: orgProviderLicenseModal_LicenseErrorFormat$1,
    orgProviderLicenseModal_MessageErrorFormat: orgProviderLicenseModal_MessageErrorFormat$1,
    OrgPlans_AddTargetOrDirectory: OrgPlans_AddTargetOrDirectory$1,
    OrgPlans_AllTypes: OrgPlans_AllTypes$1,
    OrgPlans_BundleInfo: OrgPlans_BundleInfo$1,
    OrgPlans_ChooseType: OrgPlans_ChooseType$1,
    OrgPlans_ChooseTypeHelpFormat: OrgPlans_ChooseTypeHelpFormat$1,
    OrgPlans_CloneBrowse: OrgPlans_CloneBrowse$1,
    OrgPlans_CloneDirectory: OrgPlans_CloneDirectory$1,
    OrgPlans_ClonePlan: OrgPlans_ClonePlan$1,
    OrgPlans_CloneRole: OrgPlans_CloneRole$1,
    OrgPlans_CloneTarget: OrgPlans_CloneTarget$1,
    OrgPlans_CreateBulkRoles: OrgPlans_CreateBulkRoles$1,
    OrgPlans_CreatedBy: OrgPlans_CreatedBy$1,
    OrgPlans_CreateDirectory: OrgPlans_CreateDirectory$1,
    OrgPlans_CreateRole: OrgPlans_CreateRole$1,
    OrgPlans_CreateTarget: OrgPlans_CreateTarget$1,
    OrgPlans_CreateTargetOrDirectory: OrgPlans_CreateTargetOrDirectory$1,
    OrgPlans_CustomTitlesAndDescriptionsNotLocalized: OrgPlans_CustomTitlesAndDescriptionsNotLocalized$1,
    OrgPlans_CustomTitlesAndTextNotLocalized: OrgPlans_CustomTitlesAndTextNotLocalized$1,
    OrgPlans_DeletePluralPrompt: OrgPlans_DeletePluralPrompt$1,
    OrgPlans_DeletePrompt: OrgPlans_DeletePrompt$1,
    OrgPlans_Description: OrgPlans_Description$1,
    OrgPlans_DescriptionPlaceholder: OrgPlans_DescriptionPlaceholder$1,
    OrgPlans_Directory: OrgPlans_Directory$1,
    OrgPlans_DirectoryDescription: OrgPlans_DirectoryDescription$1,
    OrgPlans_DirectoryDescriptionPlaceholder: OrgPlans_DirectoryDescriptionPlaceholder$1,
    OrgPlans_DirectoryImageAlt: OrgPlans_DirectoryImageAlt$1,
    OrgPlans_DirectoryTitlePlaceholder: OrgPlans_DirectoryTitlePlaceholder$1,
    OrgPlans_DisplayTypePlaceholder: OrgPlans_DisplayTypePlaceholder$1,
    OrgPlans_EditBrowse: OrgPlans_EditBrowse$1,
    OrgPlans_EditDirectory: OrgPlans_EditDirectory$1,
    OrgPlans_EditFeatured: OrgPlans_EditFeatured$1,
    OrgPlans_EditFeaturedPermissionError: OrgPlans_EditFeaturedPermissionError$1,
    OrgPlans_EditRole: OrgPlans_EditRole$1,
    OrgPlans_EditTarget: OrgPlans_EditTarget$1,
    OrgPlans_Featured: OrgPlans_Featured$1,
    OrgPlans_FollowerCount: OrgPlans_FollowerCount$1,
    OrgPlans_ImageUpload: OrgPlans_ImageUpload$1,
    OrgPlans_NoPlansAdded: OrgPlans_NoPlansAdded$1,
    OrgPlans_NoPlansFound: OrgPlans_NoPlansFound$1,
    OrgPlans_OnBrowseTooltip: OrgPlans_OnBrowseTooltip$1,
    OrgPlans_OnFeaturedTooltip: OrgPlans_OnFeaturedTooltip$1,
    OrgPlans_Pages: OrgPlans_Pages$1,
    OrgPlans_Parent: OrgPlans_Parent$1,
    OrgPlans_Plan: OrgPlans_Plan$1,
    OrgPlans_PlanDescription: OrgPlans_PlanDescription$1,
    OrgPlans_PlanImageAlt: OrgPlans_PlanImageAlt$1,
    OrgPlans_Plans: OrgPlans_Plans$1,
    OrgPlans_Purpose: OrgPlans_Purpose$1,
    OrgPlans_SetAsPrimaryPlan: OrgPlans_SetAsPrimaryPlan$1,
    OrgPlans_SkillPlanPlaceholder: OrgPlans_SkillPlanPlaceholder$1,
    OrgPlans_Subtitle: OrgPlans_Subtitle$1,
    OrgPlans_SubtitlePlaceholder: OrgPlans_SubtitlePlaceholder$1,
    OrgPlans_SubtitleTooltip: OrgPlans_SubtitleTooltip$1,
    OrgPlans_TargetDescriptionPlaceholder: OrgPlans_TargetDescriptionPlaceholder$1,
    OrgPlans_Template: OrgPlans_Template$1,
    OrgPlans_Title: OrgPlans_Title$1,
    OrgPlans_TitlePlaceholder: OrgPlans_TitlePlaceholder$1,
    OrgPlans_Type: OrgPlans_Type$1,
    OrgPlans_TypeBrowse: OrgPlans_TypeBrowse$1,
    OrgPlans_TypeDirectory: OrgPlans_TypeDirectory$1,
    OrgPlans_TypeFeatured: OrgPlans_TypeFeatured$1,
    OrgPlans_TypeRole: OrgPlans_TypeRole$1,
    OrgPlans_Types: OrgPlans_Types$1,
    OrgPlans_TypeTarget: OrgPlans_TypeTarget$1,
    OrgPlans_Visibility: OrgPlans_Visibility$1,
    OrgPathwayManagerCtrl_AddCollaborators: OrgPathwayManagerCtrl_AddCollaborators$1,
    OrgPathwayManagerCtrl_AuthorColumn: OrgPathwayManagerCtrl_AuthorColumn$1,
    OrgPathwayManagerCtrl_ConfirmDeleteButton: OrgPathwayManagerCtrl_ConfirmDeleteButton$1,
    OrgPathwayManagerCtrl_Delete: OrgPathwayManagerCtrl_Delete$1,
    OrgPathwayManagerCtrl_DeleteInstructions: OrgPathwayManagerCtrl_DeleteInstructions$1,
    OrgPathwayManagerCtrl_DeletePluralPrompt: OrgPathwayManagerCtrl_DeletePluralPrompt$1,
    OrgPathwayManagerCtrl_DeletePrompt: OrgPathwayManagerCtrl_DeletePrompt$1,
    OrgPathwayManagerCtrl_DeletePromptDescription: OrgPathwayManagerCtrl_DeletePromptDescription$1,
    OrgPathwayManagerCtrl_EndorsedPathwaysDescription: OrgPathwayManagerCtrl_EndorsedPathwaysDescription$1,
    OrgPathwayManagerCtrl_EnrolledColumn: OrgPathwayManagerCtrl_EnrolledColumn$1,
    OrgPathwayManagerCtrl_FeaturedColumn: OrgPathwayManagerCtrl_FeaturedColumn$1,
    OrgPathwayManagerCtrl_FollowingColumn: OrgPathwayManagerCtrl_FollowingColumn$1,
    OrgPathwayManagerCtrl_ItemsSelected: OrgPathwayManagerCtrl_ItemsSelected$1,
    OrgPathwayManagerCtrl_LastUpdatedColumn: OrgPathwayManagerCtrl_LastUpdatedColumn$1,
    OrgPathwayManagerCtrl_ManagePathwaysDescription: OrgPathwayManagerCtrl_ManagePathwaysDescription$1,
    OrgPathwayManagerCtrl_NameColumn: OrgPathwayManagerCtrl_NameColumn$1,
    OrgPathwayManagerCtrl_UpdateVisibility: OrgPathwayManagerCtrl_UpdateVisibility$1,
    OrgPathwayManagerCtrl_Visibility0: OrgPathwayManagerCtrl_Visibility0$1,
    OrgPathwayManagerCtrl_Visibility1: OrgPathwayManagerCtrl_Visibility1$1,
    OrgPathwayManagerCtrl_Visibility2: OrgPathwayManagerCtrl_Visibility2$1,
    OrgPathwayManagerCtrl_Visibility3: OrgPathwayManagerCtrl_Visibility3$1,
    OrgPathwayManagerCtrl_VisibilityColumn: OrgPathwayManagerCtrl_VisibilityColumn$1,
    OrgOpportunity_EngagementInsights_Tab: OrgOpportunity_EngagementInsights_Tab$1,
    OrgOpportunity_OpenInsights_Tab: OrgOpportunity_OpenInsights_Tab$1,
    OrgMembersCtrl_Admin: OrgMembersCtrl_Admin$1,
    OrgMembersCtrl_AnonUsersCountFormat: OrgMembersCtrl_AnonUsersCountFormat$1,
    OrgMembersCtrl_AnonUsersCountSingle: OrgMembersCtrl_AnonUsersCountSingle$1,
    OrgMembersCtrl_CountOfMembersFormat: OrgMembersCtrl_CountOfMembersFormat$1,
    OrgMembersCtrl_DateJoined: OrgMembersCtrl_DateJoined$1,
    OrgMembersCtrl_InviteMembers: OrgMembersCtrl_InviteMembers$1,
    OrgMembersCtrl_InviteUsers: OrgMembersCtrl_InviteUsers$1,
    OrgMembersCtrl_LastActive: OrgMembersCtrl_LastActive$1,
    OrgMembersCtrl_MemberInfoErrorMsg: OrgMembersCtrl_MemberInfoErrorMsg$1,
    OrgMembersCtrl_MemberSettingsText: OrgMembersCtrl_MemberSettingsText$1,
    OrgMembersCtrl_Name: OrgMembersCtrl_Name$1,
    OrgMembersCtrl_NoMembersMessage: OrgMembersCtrl_NoMembersMessage$1,
    OrgMembersCtrl_People: OrgMembersCtrl_People$1,
    OrgMembersCtrl_Points: OrgMembersCtrl_Points$1,
    OrgMembersCtrl_Private: OrgMembersCtrl_Private$1,
    OrgMembersCtrl_PrivateTooltip: OrgMembersCtrl_PrivateTooltip$1,
    OrgMembersCtrl_PrivateToOrg: OrgMembersCtrl_PrivateToOrg$1,
    OrgMembersCtrl_Public: OrgMembersCtrl_Public$1,
    OrgMembersCtrl_PublicTooltip: OrgMembersCtrl_PublicTooltip$1,
    OrgMembersCtrl_PublicToOrgTooltip: OrgMembersCtrl_PublicToOrgTooltip$1,
    OrgMembersCtrl_ResendInvites: OrgMembersCtrl_ResendInvites$1,
    OrgMembersCtrl_Role: OrgMembersCtrl_Role$1,
    OrgMembersCtrl_SearchForMember: OrgMembersCtrl_SearchForMember$1,
    OrgMembersCtrl_SearchForUser: OrgMembersCtrl_SearchForUser$1,
    OrgMembersCtrl_SeatsRemainingFormat: OrgMembersCtrl_SeatsRemainingFormat$1,
    OrgMembersCtrl_SeatsRemainingPluralFormat: OrgMembersCtrl_SeatsRemainingPluralFormat$1,
    OrgMembersCtrl_SeatsRemainingTooltip: OrgMembersCtrl_SeatsRemainingTooltip$1,
    OrgMembersCtrl_UsersCountFormat: OrgMembersCtrl_UsersCountFormat$1,
    OrgMembersCtrl_Visibility: OrgMembersCtrl_Visibility$1,
    OrgMemberFormCtrl_ConfirmRemoval: OrgMemberFormCtrl_ConfirmRemoval$1,
    OrgMemberFormCtrl_ConfirmRemovalMessage: OrgMemberFormCtrl_ConfirmRemovalMessage$1,
    OrgMemberFormCtrl_EmailPasswordReset: OrgMemberFormCtrl_EmailPasswordReset$1,
    OrgMemberFormCtrl_EmailResetPasswordSuccessMessageFormat: OrgMemberFormCtrl_EmailResetPasswordSuccessMessageFormat$1,
    OrgMemberFormCtrl_Groups: OrgMemberFormCtrl_Groups$1,
    OrgMemberFormCtrl_History: OrgMemberFormCtrl_History$1,
    OrgMemberFormCtrl_MemberSince: OrgMemberFormCtrl_MemberSince$1,
    OrgMemberFormCtrl_None: OrgMemberFormCtrl_None$1,
    OrgMemberFormCtrl_PasswordManagement: OrgMemberFormCtrl_PasswordManagement$1,
    OrgMemberFormCtrl_PendingMember: OrgMemberFormCtrl_PendingMember$1,
    OrgMemberFormCtrl_RemovedMemberSuccessMessage: OrgMemberFormCtrl_RemovedMemberSuccessMessage$1,
    OrgMemberFormCtrl_RemoveFromOrg: OrgMemberFormCtrl_RemoveFromOrg$1,
    OrgMemberFormCtrl_Removing: OrgMemberFormCtrl_Removing$1,
    OrgMemberFormCtrl_ResetPasswordDesc: OrgMemberFormCtrl_ResetPasswordDesc$1,
    OrgMemberFormCtrl_ResetPasswordOnLogin: OrgMemberFormCtrl_ResetPasswordOnLogin$1,
    OrgMemberFormCtrl_ResetPasswordToDefault: OrgMemberFormCtrl_ResetPasswordToDefault$1,
    OrgMemberFormCtrl_ResetPasswordToDefaultDesc: OrgMemberFormCtrl_ResetPasswordToDefaultDesc$1,
    OrgMemberFormCtrl_ResetPasswordToDefaultSuccess: OrgMemberFormCtrl_ResetPasswordToDefaultSuccess$1,
    OrgMemberFormCtrl_Role: OrgMemberFormCtrl_Role$1,
    OrgMemberFormCtrl_RolePermissions: OrgMemberFormCtrl_RolePermissions$1,
    OrgMemberFormCtrl_Title: OrgMemberFormCtrl_Title$1,
    OrgMemberFormCtrl_UpdatedMemberRoleSuccessMessage: OrgMemberFormCtrl_UpdatedMemberRoleSuccessMessage$1,
    OrgMemberFormCtrl_ViewUserSettings: OrgMemberFormCtrl_ViewUserSettings$1,
    OrgManage_AdvancedSSOCreated: OrgManage_AdvancedSSOCreated$1,
    OrgManage_Analytics_MenuItem_Label: OrgManage_Analytics_MenuItem_Label$1,
    OrgManage_Analytics_MenuItem_Text: OrgManage_Analytics_MenuItem_Text$1,
    OrgManage_CollectorDisabled: OrgManage_CollectorDisabled$1,
    OrgManage_ConnectorDisabled: OrgManage_ConnectorDisabled$1,
    OrgManage_ConnectorDisableFailed: OrgManage_ConnectorDisableFailed$1,
    OrgManage_Engage_MenuItem_Label: OrgManage_Engage_MenuItem_Label$1,
    OrgManage_Engage_MenuItem_Text: OrgManage_Engage_MenuItem_Text$1,
    OrgManage_EnterpriseProviderDisconnected: OrgManage_EnterpriseProviderDisconnected$1,
    OrgManage_Error_Get: OrgManage_Error_Get$1,
    OrgManage_ErrorCreatingProviderSSODetails: OrgManage_ErrorCreatingProviderSSODetails$1,
    OrgManage_ErrorMessageCollectors: OrgManage_ErrorMessageCollectors$1,
    OrgManage_ErrorMessageCollectorsOptions: OrgManage_ErrorMessageCollectorsOptions$1,
    OrgManage_ErrorMessageConnectors: OrgManage_ErrorMessageConnectors$1,
    OrgManage_ErrorMessageConnectorsOptions: OrgManage_ErrorMessageConnectorsOptions$1,
    OrgManage_ErrorMessageIntegrationProviders: OrgManage_ErrorMessageIntegrationProviders$1,
    OrgManage_ErrorMessageProvider: OrgManage_ErrorMessageProvider$1,
    OrgManage_ErrorMessageProviderDetails: OrgManage_ErrorMessageProviderDetails$1,
    OrgManage_ErrorMessageProvidersList: OrgManage_ErrorMessageProvidersList$1,
    OrgManage_ErrorSavingMessageCollectorsOptions: OrgManage_ErrorSavingMessageCollectorsOptions$1,
    OrgManage_ErrorSavingMessageConnectorsOptions: OrgManage_ErrorSavingMessageConnectorsOptions$1,
    OrgManage_ErrorUpdatingProviderSSODetails: OrgManage_ErrorUpdatingProviderSSODetails$1,
    OrgManage_ExtendedEnterprise: OrgManage_ExtendedEnterprise$1,
    OrgManage_FailedProviderSSODetails: OrgManage_FailedProviderSSODetails$1,
    OrgManage_FAQ_AddFAQ: OrgManage_FAQ_AddFAQ$1,
    OrgManage_FAQ_Answer: OrgManage_FAQ_Answer$1,
    OrgManage_FAQ_AnswerPlaceholder: OrgManage_FAQ_AnswerPlaceholder$1,
    OrgManage_FAQ_ConfirmDelete: OrgManage_FAQ_ConfirmDelete$1,
    OrgManage_FAQ_CreateFAQPage: OrgManage_FAQ_CreateFAQPage$1,
    OrgManage_FAQ_CreateFAQPageInstructions: OrgManage_FAQ_CreateFAQPageInstructions$1,
    OrgManage_FAQ_CustomizeFAQ: OrgManage_FAQ_CustomizeFAQ$1,
    OrgManage_FAQ_Delete: OrgManage_FAQ_Delete$1,
    OrgManage_FAQ_Edit: OrgManage_FAQ_Edit$1,
    OrgManage_FAQ_Error_CreateFAQ: OrgManage_FAQ_Error_CreateFAQ$1,
    OrgManage_FAQ_Error_DeleteFAQ: OrgManage_FAQ_Error_DeleteFAQ$1,
    OrgManage_FAQ_Error_GetFAQs: OrgManage_FAQ_Error_GetFAQs$1,
    OrgManage_FAQ_Error_UpdateFAQ: OrgManage_FAQ_Error_UpdateFAQ$1,
    OrgManage_FAQ_FaqCreated: OrgManage_FAQ_FaqCreated$1,
    OrgManage_FAQ_FaqDeleted: OrgManage_FAQ_FaqDeleted$1,
    OrgManage_FAQ_FaqUpdated: OrgManage_FAQ_FaqUpdated$1,
    OrgManage_FAQ_MaxFAQsMsg: OrgManage_FAQ_MaxFAQsMsg$1,
    OrgManage_FAQ_NoFAQs: OrgManage_FAQ_NoFAQs$1,
    OrgManage_FAQ_Question: OrgManage_FAQ_Question$1,
    OrgManage_FAQ_QuestionPlaceholder: OrgManage_FAQ_QuestionPlaceholder$1,
    OrgManage_FAQ_TryNarrowingSearch: OrgManage_FAQ_TryNarrowingSearch$1,
    OrgManage_LearningExperience: OrgManage_LearningExperience$1,
    OrgManage_Manage: OrgManage_Manage$1,
    OrgManage_MoreFormat: OrgManage_MoreFormat$1,
    OrgManage_OauthCredentials_apiKeyCreated: OrgManage_OauthCredentials_apiKeyCreated$1,
    OrgManage_OauthCredentials_ApiKeyCreatedHeaderModal: OrgManage_OauthCredentials_ApiKeyCreatedHeaderModal$1,
    OrgManage_OauthCredentials_apiKeysTab: OrgManage_OauthCredentials_apiKeysTab$1,
    OrgManage_OauthCredentials_clientKeyLabel: OrgManage_OauthCredentials_clientKeyLabel$1,
    OrgManage_OauthCredentials_clientPasswordLabel: OrgManage_OauthCredentials_clientPasswordLabel$1,
    OrgManage_OauthCredentials_ConfirmDelete: OrgManage_OauthCredentials_ConfirmDelete$1,
    OrgManage_OauthCredentials_copiedClipboardTooltip: OrgManage_OauthCredentials_copiedClipboardTooltip$1,
    OrgManage_OauthCredentials_copyAndSaveKey: OrgManage_OauthCredentials_copyAndSaveKey$1,
    OrgManage_OauthCredentials_copyClipboardTooltip: OrgManage_OauthCredentials_copyClipboardTooltip$1,
    OrgManage_OauthCredentials_Create: OrgManage_OauthCredentials_Create$1,
    OrgManage_OauthCredentials_Created: OrgManage_OauthCredentials_Created$1,
    OrgManage_OauthCredentials_CreatedByLabel: OrgManage_OauthCredentials_CreatedByLabel$1,
    OrgManage_OauthCredentials_CredentialsRevoked: OrgManage_OauthCredentials_CredentialsRevoked$1,
    OrgManage_OauthCredentials_defaultEmptyProviderCode: OrgManage_OauthCredentials_defaultEmptyProviderCode$1,
    OrgManage_OauthCredentials_Delete: OrgManage_OauthCredentials_Delete$1,
    OrgManage_OauthCredentials_descriptionPlaceholder: OrgManage_OauthCredentials_descriptionPlaceholder$1,
    OrgManage_OauthCredentials_EditCredentials: OrgManage_OauthCredentials_EditCredentials$1,
    OrgManage_OauthCredentials_editCredentialsTooltip: OrgManage_OauthCredentials_editCredentialsTooltip$1,
    OrgManage_OauthCredentials_ErrorSavingCredentials: OrgManage_OauthCredentials_ErrorSavingCredentials$1,
    OrgManage_OauthCredentials_NamePlaceholder: OrgManage_OauthCredentials_NamePlaceholder$1,
    OrgManage_OauthCredentials_NewCredentials: OrgManage_OauthCredentials_NewCredentials$1,
    OrgManage_OauthCredentials_organizationKeysLabel: OrgManage_OauthCredentials_organizationKeysLabel$1,
    OrgManage_OauthCredentials_providerKeysLabel: OrgManage_OauthCredentials_providerKeysLabel$1,
    OrgManage_OauthCredentials_providerLabel: OrgManage_OauthCredentials_providerLabel$1,
    OrgManage_OauthCredentials_providerPlaceholder: OrgManage_OauthCredentials_providerPlaceholder$1,
    OrgManage_OauthCredentials_revokeTooltip: OrgManage_OauthCredentials_revokeTooltip$1,
    OrgManage_OauthCredentials_Scope_completions: OrgManage_OauthCredentials_Scope_completions$1,
    OrgManage_OauthCredentials_Scope_completionsRead: OrgManage_OauthCredentials_Scope_completionsRead$1,
    OrgManage_OauthCredentials_Scope_completionsWrite: OrgManage_OauthCredentials_Scope_completionsWrite$1,
    OrgManage_OauthCredentials_Scope_content: OrgManage_OauthCredentials_Scope_content$1,
    OrgManage_OauthCredentials_Scope_contentRead: OrgManage_OauthCredentials_Scope_contentRead$1,
    OrgManage_OauthCredentials_Scope_contentWrite: OrgManage_OauthCredentials_Scope_contentWrite$1,
    OrgManage_OauthCredentials_Scope_customAttribute: OrgManage_OauthCredentials_Scope_customAttribute$1,
    OrgManage_OauthCredentials_Scope_Licenses: OrgManage_OauthCredentials_Scope_Licenses$1,
    OrgManage_OauthCredentials_Scope_ProviderUsers: OrgManage_OauthCredentials_Scope_ProviderUsers$1,
    OrgManage_OauthCredentials_Scope_r: OrgManage_OauthCredentials_Scope_r$1,
    OrgManage_OauthCredentials_Scope_read: OrgManage_OauthCredentials_Scope_read$1,
    OrgManage_OauthCredentials_Scope_readCompletions: OrgManage_OauthCredentials_Scope_readCompletions$1,
    OrgManage_OauthCredentials_Scope_readContent: OrgManage_OauthCredentials_Scope_readContent$1,
    OrgManage_OauthCredentials_Scope_readRequiredLearning: OrgManage_OauthCredentials_Scope_readRequiredLearning$1,
    OrgManage_OauthCredentials_Scope_readUsers: OrgManage_OauthCredentials_Scope_readUsers$1,
    OrgManage_OauthCredentials_Scope_requiredLearning: OrgManage_OauthCredentials_Scope_requiredLearning$1,
    OrgManage_OauthCredentials_Scope_requiredLearning_Bundles: OrgManage_OauthCredentials_Scope_requiredLearning_Bundles$1,
    OrgManage_OauthCredentials_Scope_requiredLearning_Logins: OrgManage_OauthCredentials_Scope_requiredLearning_Logins$1,
    OrgManage_OauthCredentials_Scope_requiredLearning_SharedItems: OrgManage_OauthCredentials_Scope_requiredLearning_SharedItems$1,
    OrgManage_OauthCredentials_Scope_requiredLearning_SkillPlans: OrgManage_OauthCredentials_Scope_requiredLearning_SkillPlans$1,
    OrgManage_OauthCredentials_Scope_requiredLearning_SkillRatings: OrgManage_OauthCredentials_Scope_requiredLearning_SkillRatings$1,
    OrgManage_OauthCredentials_Scope_requiredLearning_TodaysLearning: OrgManage_OauthCredentials_Scope_requiredLearning_TodaysLearning$1,
    OrgManage_OauthCredentials_Scope_requiredLearning_UserBadges: OrgManage_OauthCredentials_Scope_requiredLearning_UserBadges$1,
    OrgManage_OauthCredentials_Scope_requiredLearning_UserSkills: OrgManage_OauthCredentials_Scope_requiredLearning_UserSkills$1,
    OrgManage_OauthCredentials_Scope_requiredLearningRead: OrgManage_OauthCredentials_Scope_requiredLearningRead$1,
    OrgManage_OauthCredentials_Scope_requiredLearningWrite: OrgManage_OauthCredentials_Scope_requiredLearningWrite$1,
    OrgManage_OauthCredentials_Scope_rw: OrgManage_OauthCredentials_Scope_rw$1,
    OrgManage_OauthCredentials_Scope_SelfEnrolledLearning: OrgManage_OauthCredentials_Scope_SelfEnrolledLearning$1,
    OrgManage_OauthCredentials_Scope_UserBadges: OrgManage_OauthCredentials_Scope_UserBadges$1,
    OrgManage_OauthCredentials_Scope_users: OrgManage_OauthCredentials_Scope_users$1,
    OrgManage_OauthCredentials_Scope_usersRead: OrgManage_OauthCredentials_Scope_usersRead$1,
    OrgManage_OauthCredentials_Scope_usersWrite: OrgManage_OauthCredentials_Scope_usersWrite$1,
    OrgManage_OauthCredentials_Scope_write: OrgManage_OauthCredentials_Scope_write$1,
    OrgManage_OauthCredentials_Scope_writeCompletions: OrgManage_OauthCredentials_Scope_writeCompletions$1,
    OrgManage_OauthCredentials_Scope_writeContent: OrgManage_OauthCredentials_Scope_writeContent$1,
    OrgManage_OauthCredentials_Scope_writeRequiredLearning: OrgManage_OauthCredentials_Scope_writeRequiredLearning$1,
    OrgManage_OauthCredentials_Scope_writeUsers: OrgManage_OauthCredentials_Scope_writeUsers$1,
    OrgManage_OauthCredentials_Scope_Xapi: OrgManage_OauthCredentials_Scope_Xapi$1,
    OrgManage_OauthCredentials_ScopesLabel: OrgManage_OauthCredentials_ScopesLabel$1,
    OrgManage_OauthCredentials_Updated: OrgManage_OauthCredentials_Updated$1,
    OrgManage_OauthCredentials_warningManageCredentials: OrgManage_OauthCredentials_warningManageCredentials$1,
    OrgManage_OauthCredentials_wontShowKeyAgain: OrgManage_OauthCredentials_wontShowKeyAgain$1,
    OrgManage_OneMore: OrgManage_OneMore$1,
    OrgManage_Opportunities_Add: OrgManage_Opportunities_Add$1,
    OrgManage_Opportunities_AddCollaborators: OrgManage_Opportunities_AddCollaborators$1,
    OrgManage_Opportunities_AtLeastOneSkill: OrgManage_Opportunities_AtLeastOneSkill$1,
    OrgManage_Opportunities_BulkChangeVisibility: OrgManage_Opportunities_BulkChangeVisibility$1,
    OrgManage_Opportunities_BulkChangeVisibilityPlural: OrgManage_Opportunities_BulkChangeVisibilityPlural$1,
    OrgManage_Opportunities_BulkCloseAllHeader: OrgManage_Opportunities_BulkCloseAllHeader$1,
    OrgManage_Opportunities_BulkClosedSuccess: OrgManage_Opportunities_BulkClosedSuccess$1,
    OrgManage_Opportunities_BulkCloseError: OrgManage_Opportunities_BulkCloseError$1,
    OrgManage_Opportunities_BulkCloseExternalError: OrgManage_Opportunities_BulkCloseExternalError$1,
    OrgManage_Opportunities_BulkCloseHeader: OrgManage_Opportunities_BulkCloseHeader$1,
    OrgManage_Opportunities_BulkCloseNotify: OrgManage_Opportunities_BulkCloseNotify$1,
    OrgManage_Opportunities_BulkCloseWarning: OrgManage_Opportunities_BulkCloseWarning$1,
    OrgManage_Opportunities_BulkCloseWarningExternal: OrgManage_Opportunities_BulkCloseWarningExternal$1,
    OrgManage_Opportunities_BulkDeleteAllHeader: OrgManage_Opportunities_BulkDeleteAllHeader$1,
    OrgManage_Opportunities_BulkDeleteError: OrgManage_Opportunities_BulkDeleteError$1,
    OrgManage_Opportunities_BulkDeleteExternalError: OrgManage_Opportunities_BulkDeleteExternalError$1,
    OrgManage_Opportunities_BulkDeleteExternalFail: OrgManage_Opportunities_BulkDeleteExternalFail$1,
    OrgManage_Opportunities_BulkDeleteHeader: OrgManage_Opportunities_BulkDeleteHeader$1,
    OrgManage_Opportunities_BulkDeleteSuccess: OrgManage_Opportunities_BulkDeleteSuccess$1,
    OrgManage_Opportunities_BulkDeleteWarning: OrgManage_Opportunities_BulkDeleteWarning$1,
    OrgManage_Opportunities_BulkDeleteWarningExternal: OrgManage_Opportunities_BulkDeleteWarningExternal$1,
    OrgManage_Opportunities_ChooseDurationType: OrgManage_Opportunities_ChooseDurationType$1,
    OrgManage_Opportunities_Close: OrgManage_Opportunities_Close$1,
    OrgManage_Opportunities_ClosedOnlyOpportunities: OrgManage_Opportunities_ClosedOnlyOpportunities$1,
    OrgManage_Opportunities_ClosePrompt_Description: OrgManage_Opportunities_ClosePrompt_Description$1,
    OrgManage_Opportunities_ClosePrompt_Header: OrgManage_Opportunities_ClosePrompt_Header$1,
    OrgManage_Opportunities_ClosePrompt_NoSelect: OrgManage_Opportunities_ClosePrompt_NoSelect$1,
    OrgManage_Opportunities_ClosePrompt_SendNotification: OrgManage_Opportunities_ClosePrompt_SendNotification$1,
    OrgManage_Opportunities_ClosePrompt_Title: OrgManage_Opportunities_ClosePrompt_Title$1,
    OrgManage_Opportunities_Cols_Collaborators: OrgManage_Opportunities_Cols_Collaborators$1,
    OrgManage_Opportunities_Cols_Interested: OrgManage_Opportunities_Cols_Interested$1,
    OrgManage_Opportunities_Cols_LastUpdated: OrgManage_Opportunities_Cols_LastUpdated$1,
    OrgManage_Opportunities_Cols_Skills: OrgManage_Opportunities_Cols_Skills$1,
    OrgManage_Opportunities_Cols_Source: OrgManage_Opportunities_Cols_Source$1,
    OrgManage_Opportunities_Cols_Title: OrgManage_Opportunities_Cols_Title$1,
    OrgManage_Opportunities_Cols_Type: OrgManage_Opportunities_Cols_Type$1,
    OrgManage_Opportunities_Cols_Visibility: OrgManage_Opportunities_Cols_Visibility$1,
    OrgManage_Opportunities_Create: OrgManage_Opportunities_Create$1,
    OrgManage_Opportunities_DateCompare: OrgManage_Opportunities_DateCompare$1,
    OrgManage_Opportunities_DatePicker: OrgManage_Opportunities_DatePicker$1,
    OrgManage_Opportunities_Delete: OrgManage_Opportunities_Delete$1,
    OrgManage_Opportunities_Delete_Confirmation: OrgManage_Opportunities_Delete_Confirmation$1,
    OrgManage_Opportunities_Delete_Confirmation_Singular: OrgManage_Opportunities_Delete_Confirmation_Singular$1,
    OrgManage_Opportunities_Delete_Notice_Generic: OrgManage_Opportunities_Delete_Notice_Generic$1,
    OrgManage_Opportunities_Delete_Notice_Specific: OrgManage_Opportunities_Delete_Notice_Specific$1,
    OrgManage_Opportunities_Delete_Notice_Specific_Singular: OrgManage_Opportunities_Delete_Notice_Specific_Singular$1,
    OrgManage_Opportunities_Delete_Undeletable: OrgManage_Opportunities_Delete_Undeletable$1,
    OrgManage_Opportunities_Delete_Undeletable_Singular: OrgManage_Opportunities_Delete_Undeletable_Singular$1,
    OrgManage_Opportunities_DeleteOpportunities: OrgManage_Opportunities_DeleteOpportunities$1,
    OrgManage_Opportunities_DeleteOpportunity: OrgManage_Opportunities_DeleteOpportunity$1,
    OrgManage_Opportunities_DeletePrompt_Description: OrgManage_Opportunities_DeletePrompt_Description$1,
    OrgManage_Opportunities_DeletePrompt_Title: OrgManage_Opportunities_DeletePrompt_Title$1,
    OrgManage_Opportunities_DepartmentPlaceholder: OrgManage_Opportunities_DepartmentPlaceholder$1,
    OrgManage_Opportunities_DescMaxChars: OrgManage_Opportunities_DescMaxChars$1,
    OrgManage_Opportunities_DescPlaceholder: OrgManage_Opportunities_DescPlaceholder$1,
    OrgManage_Opportunities_Edit: OrgManage_Opportunities_Edit$1,
    OrgManage_Opportunities_EditSkills: OrgManage_Opportunities_EditSkills$1,
    OrgManage_Opportunities_EditTargetLevel: OrgManage_Opportunities_EditTargetLevel$1,
    OrgManage_Opportunities_EditVisibility: OrgManage_Opportunities_EditVisibility$1,
    OrgManage_Opportunities_Error_Add: OrgManage_Opportunities_Error_Add$1,
    OrgManage_Opportunities_Error_Close: OrgManage_Opportunities_Error_Close$1,
    OrgManage_Opportunities_Error_Delete: OrgManage_Opportunities_Error_Delete$1,
    OrgManage_Opportunities_Error_Edit: OrgManage_Opportunities_Error_Edit$1,
    OrgManage_Opportunities_Error_EditCollaborators: OrgManage_Opportunities_Error_EditCollaborators$1,
    OrgManage_Opportunities_Error_EditSkills: OrgManage_Opportunities_Error_EditSkills$1,
    OrgManage_Opportunities_Error_EditVisibility: OrgManage_Opportunities_Error_EditVisibility$1,
    OrgManage_Opportunities_Error_Share: OrgManage_Opportunities_Error_Share$1,
    OrgManage_Opportunities_Filters_Current_Collaborator: OrgManage_Opportunities_Filters_Current_Collaborator$1,
    OrgManage_Opportunities_Filters_Status_closed: OrgManage_Opportunities_Filters_Status_closed$1,
    OrgManage_Opportunities_Filters_Status_open: OrgManage_Opportunities_Filters_Status_open$1,
    OrgManage_Opportunities_Invalid_Field: OrgManage_Opportunities_Invalid_Field$1,
    OrgManage_Opportunities_JobRoles_SkillAdded: OrgManage_Opportunities_JobRoles_SkillAdded$1,
    OrgManage_Opportunities_MoreFormat: OrgManage_Opportunities_MoreFormat$1,
    OrgManage_Opportunities_NoItemsAdded: OrgManage_Opportunities_NoItemsAdded$1,
    OrgManage_Opportunities_OfDays: OrgManage_Opportunities_OfDays$1,
    OrgManage_Opportunities_OfHours: OrgManage_Opportunities_OfHours$1,
    OrgManage_Opportunities_OfMonths: OrgManage_Opportunities_OfMonths$1,
    OrgManage_Opportunities_OfWeeks: OrgManage_Opportunities_OfWeeks$1,
    OrgManage_Opportunities_OneMore: OrgManage_Opportunities_OneMore$1,
    OrgManage_Opportunities_OptIn: OrgManage_Opportunities_OptIn$1,
    OrgManage_Opportunities_OptIn_Description: OrgManage_Opportunities_OptIn_Description$1,
    OrgManage_Opportunities_OptIn_Header: OrgManage_Opportunities_OptIn_Header$1,
    OrgManage_Opportunities_Required_Field: OrgManage_Opportunities_Required_Field$1,
    OrgManage_Opportunities_SearchPlaceholder: OrgManage_Opportunities_SearchPlaceholder$1,
    OrgManage_Opportunities_ShowClosed: OrgManage_Opportunities_ShowClosed$1,
    OrgManage_Opportunities_StartDatePlaceholder: OrgManage_Opportunities_StartDatePlaceholder$1,
    OrgManage_Opportunities_Success_Add: OrgManage_Opportunities_Success_Add$1,
    OrgManage_Opportunities_Success_AddCollaboratorPluralToOpportunity: OrgManage_Opportunities_Success_AddCollaboratorPluralToOpportunity$1,
    OrgManage_Opportunities_Success_AddCollaboratorPluralToOpportunityPlural: OrgManage_Opportunities_Success_AddCollaboratorPluralToOpportunityPlural$1,
    OrgManage_Opportunities_Success_AddCollaboratorToOpportunity: OrgManage_Opportunities_Success_AddCollaboratorToOpportunity$1,
    OrgManage_Opportunities_Success_AddCollaboratorToOpportunityPlural: OrgManage_Opportunities_Success_AddCollaboratorToOpportunityPlural$1,
    OrgManage_Opportunities_Success_Close: OrgManage_Opportunities_Success_Close$1,
    OrgManage_Opportunities_Success_Delete: OrgManage_Opportunities_Success_Delete$1,
    OrgManage_Opportunities_Success_EditVisibility: OrgManage_Opportunities_Success_EditVisibility$1,
    OrgManage_Opportunities_Success_EditVisibilityPlural: OrgManage_Opportunities_Success_EditVisibilityPlural$1,
    OrgManage_Opportunities_Success_Update: OrgManage_Opportunities_Success_Update$1,
    OrgManage_Opportunities_Tab_Description: OrgManage_Opportunities_Tab_Description$1,
    OrgManage_Opportunities_Tab_Details: OrgManage_Opportunities_Tab_Details$1,
    OrgManage_Opportunities_Tab_Skills: OrgManage_Opportunities_Tab_Skills$1,
    OrgManage_Opportunities_ThreeToTenSkills: OrgManage_Opportunities_ThreeToTenSkills$1,
    OrgManage_Opportunities_TitlePlaceholder: OrgManage_Opportunities_TitlePlaceholder$1,
    OrgManage_Opportunities_TypePlaceholder: OrgManage_Opportunities_TypePlaceholder$1,
    OrgManage_Opportunities_Upload: OrgManage_Opportunities_Upload$1,
    OrgManage_Opportunities_UploadDescription: OrgManage_Opportunities_UploadDescription$1,
    OrgManage_Opportunities_UploadError: OrgManage_Opportunities_UploadError$1,
    OrgManage_Opportunities_UploadFile: OrgManage_Opportunities_UploadFile$1,
    OrgManage_Opportunities_UploadOpportunities: OrgManage_Opportunities_UploadOpportunities$1,
    OrgManage_Opportunities_UploadSuccess: OrgManage_Opportunities_UploadSuccess$1,
    OrgManage_Opportunities_Valid_Date: OrgManage_Opportunities_Valid_Date$1,
    OrgManage_Opportunities_Valid_Duration: OrgManage_Opportunities_Valid_Duration$1,
    OrgManage_Opportunities_Valid_Duration_Type: OrgManage_Opportunities_Valid_Duration_Type$1,
    OrgManage_Opportunities_Valid_Job_Role: OrgManage_Opportunities_Valid_Job_Role$1,
    OrgManage_Opportunities_Valid_MaxLength: OrgManage_Opportunities_Valid_MaxLength$1,
    OrgManage_Opportunities_Valid_MinLength: OrgManage_Opportunities_Valid_MinLength$1,
    OrgManage_Opportunities_VisibleCollaborators: OrgManage_Opportunities_VisibleCollaborators$1,
    OrgManage_Opportunities_VisibleGroups: OrgManage_Opportunities_VisibleGroups$1,
    OrgManage_Opportunities_VisibleOrganization: OrgManage_Opportunities_VisibleOrganization$1,
    OrgManage_OrgProviders_Created: OrgManage_OrgProviders_Created$1,
    OrgManage_OrgProviders_createProviderButton: OrgManage_OrgProviders_createProviderButton$1,
    OrgManage_OrgProviders_createProviderLabel: OrgManage_OrgProviders_createProviderLabel$1,
    OrgManage_OrgProviders_editOrgProviderTooltip: OrgManage_OrgProviders_editOrgProviderTooltip$1,
    OrgManage_OrgProviders_ErrorMessage: OrgManage_OrgProviders_ErrorMessage$1,
    OrgManage_OrgProviders_featuredColumnHeader: OrgManage_OrgProviders_featuredColumnHeader$1,
    OrgManage_OrgProviders_globalLicenseColumnHeader: OrgManage_OrgProviders_globalLicenseColumnHeader$1,
    OrgManage_OrgProviders_hiddenColumnHeader: OrgManage_OrgProviders_hiddenColumnHeader$1,
    OrgManage_OrgProviders_hiddenLabel: OrgManage_OrgProviders_hiddenLabel$1,
    OrgManage_OrgProviders_licensingColumnHeader: OrgManage_OrgProviders_licensingColumnHeader$1,
    OrgManage_OrgProviders_LicensingConfirmation_DefaultDescription: OrgManage_OrgProviders_LicensingConfirmation_DefaultDescription$1,
    OrgManage_OrgProviders_LicensingConfirmation_LicenseAlreadyRequested: OrgManage_OrgProviders_LicensingConfirmation_LicenseAlreadyRequested$1,
    OrgManage_OrgProviders_LicensingConfirmation_NoLicenseFound: OrgManage_OrgProviders_LicensingConfirmation_NoLicenseFound$1,
    OrgManage_OrgProviders_LicensingConfirmation_NoProviderFound: OrgManage_OrgProviders_LicensingConfirmation_NoProviderFound$1,
    OrgManage_OrgProviders_LicensingConfirmation_PageTitle: OrgManage_OrgProviders_LicensingConfirmation_PageTitle$1,
    OrgManage_OrgProviders_LicensingConfirmation_ProviderHeader: OrgManage_OrgProviders_LicensingConfirmation_ProviderHeader$1,
    OrgManage_OrgProviders_LicensingConfirmation_ProviderHomepage: OrgManage_OrgProviders_LicensingConfirmation_ProviderHomepage$1,
    OrgManage_OrgProviders_LicensingConfirmation_RequestLicense: OrgManage_OrgProviders_LicensingConfirmation_RequestLicense$1,
    OrgManage_OrgProviders_LicensingConfirmation_SearchForProviderContent: OrgManage_OrgProviders_LicensingConfirmation_SearchForProviderContent$1,
    OrgManage_OrgProviders_providerNameColumnHeader: OrgManage_OrgProviders_providerNameColumnHeader$1,
    OrgManage_OrgProviders_providersLabel: OrgManage_OrgProviders_providersLabel$1,
    OrgManage_OrgProviders_providersPlaceholder: OrgManage_OrgProviders_providersPlaceholder$1,
    OrgManage_OrgProviders_providersTab: OrgManage_OrgProviders_providersTab$1,
    OrgManage_OrgProviders_Updated: OrgManage_OrgProviders_Updated$1,
    OrgManage_ProviderDisconnected: OrgManage_ProviderDisconnected$1,
    OrgManage_ReportSchedule_AggregateRange: OrgManage_ReportSchedule_AggregateRange$1,
    OrgManage_ReportSchedule_Cols_Frequency: OrgManage_ReportSchedule_Cols_Frequency$1,
    OrgManage_ReportSchedule_Cols_FtpConfig: OrgManage_ReportSchedule_Cols_FtpConfig$1,
    OrgManage_ReportSchedule_Cols_LastExport: OrgManage_ReportSchedule_Cols_LastExport$1,
    OrgManage_ReportSchedule_Cols_ReportType: OrgManage_ReportSchedule_Cols_ReportType$1,
    OrgManage_ReportSchedule_Cols_TimePeriod: OrgManage_ReportSchedule_Cols_TimePeriod$1,
    OrgManage_ReportSchedule_Cols_Version: OrgManage_ReportSchedule_Cols_Version$1,
    OrgManage_ReportSchedule_ConfirmDelete: OrgManage_ReportSchedule_ConfirmDelete$1,
    OrgManage_ReportSchedule_DownloadFolder: OrgManage_ReportSchedule_DownloadFolder$1,
    OrgManage_ReportSchedule_DuplicateReportScheduleError: OrgManage_ReportSchedule_DuplicateReportScheduleError$1,
    OrgManage_ReportSchedule_EditReportSchedule: OrgManage_ReportSchedule_EditReportSchedule$1,
    OrgManage_ReportSchedule_Error_DeleteSchedule: OrgManage_ReportSchedule_Error_DeleteSchedule$1,
    OrgManage_ReportSchedule_Error_GetDateRanges: OrgManage_ReportSchedule_Error_GetDateRanges$1,
    OrgManage_ReportSchedule_Error_GetFrequencies: OrgManage_ReportSchedule_Error_GetFrequencies$1,
    OrgManage_ReportSchedule_Error_GetReportMethods: OrgManage_ReportSchedule_Error_GetReportMethods$1,
    OrgManage_ReportSchedule_Error_GetSchedules: OrgManage_ReportSchedule_Error_GetSchedules$1,
    OrgManage_ReportSchedule_Error_UpdateSchedule: OrgManage_ReportSchedule_Error_UpdateSchedule$1,
    OrgManage_ReportSchedule_Frequency_Daily: OrgManage_ReportSchedule_Frequency_Daily$1,
    OrgManage_ReportSchedule_Frequency_DailyMondayThruFriday: OrgManage_ReportSchedule_Frequency_DailyMondayThruFriday$1,
    OrgManage_ReportSchedule_Frequency_Monthly: OrgManage_ReportSchedule_Frequency_Monthly$1,
    OrgManage_ReportSchedule_Frequency_Quarterly: OrgManage_ReportSchedule_Frequency_Quarterly$1,
    OrgManage_ReportSchedule_Frequency_WeeklyOnMonday: OrgManage_ReportSchedule_Frequency_WeeklyOnMonday$1,
    OrgManage_ReportSchedule_Frequency_WeeklyOnSunday: OrgManage_ReportSchedule_Frequency_WeeklyOnSunday$1,
    OrgManage_ReportSchedule_FTP: OrgManage_ReportSchedule_FTP$1,
    OrgManage_ReportSchedule_FtpConfig: OrgManage_ReportSchedule_FtpConfig$1,
    OrgManage_ReportSchedule_NewReportSchedule: OrgManage_ReportSchedule_NewReportSchedule$1,
    OrgManage_ReportSchedule_Range_Last10Days: OrgManage_ReportSchedule_Range_Last10Days$1,
    OrgManage_ReportSchedule_Range_Last15Days: OrgManage_ReportSchedule_Range_Last15Days$1,
    OrgManage_ReportSchedule_Range_Last1Days: OrgManage_ReportSchedule_Range_Last1Days$1,
    OrgManage_ReportSchedule_Range_Last2Days: OrgManage_ReportSchedule_Range_Last2Days$1,
    OrgManage_ReportSchedule_Range_Last30Days: OrgManage_ReportSchedule_Range_Last30Days$1,
    OrgManage_ReportSchedule_Range_Last3Days: OrgManage_ReportSchedule_Range_Last3Days$1,
    OrgManage_ReportSchedule_Range_Last60Days: OrgManage_ReportSchedule_Range_Last60Days$1,
    OrgManage_ReportSchedule_Range_Last7Days: OrgManage_ReportSchedule_Range_Last7Days$1,
    OrgManage_ReportSchedule_Range_Last90Days: OrgManage_ReportSchedule_Range_Last90Days$1,
    OrgManage_ReportSchedule_Range_LastFullMonth: OrgManage_ReportSchedule_Range_LastFullMonth$1,
    OrgManage_ReportSchedule_Range_LastFullQuarter: OrgManage_ReportSchedule_Range_LastFullQuarter$1,
    OrgManage_ReportSchedule_Range_LastFullYear: OrgManage_ReportSchedule_Range_LastFullYear$1,
    OrgManage_ReportSchedule_Range_MonthToDate: OrgManage_ReportSchedule_Range_MonthToDate$1,
    OrgManage_ReportSchedule_Range_PreviousMonth: OrgManage_ReportSchedule_Range_PreviousMonth$1,
    OrgManage_ReportSchedule_Range_PreviousQuarter: OrgManage_ReportSchedule_Range_PreviousQuarter$1,
    OrgManage_ReportSchedule_Range_QuarterToDate: OrgManage_ReportSchedule_Range_QuarterToDate$1,
    OrgManage_ReportSchedule_Range_YearToDate: OrgManage_ReportSchedule_Range_YearToDate$1,
    OrgManage_ReportSchedule_ReportMaximum: OrgManage_ReportSchedule_ReportMaximum$1,
    OrgManage_ReportSchedule_ReportName: OrgManage_ReportSchedule_ReportName$1,
    OrgManage_ReportSchedule_ReportSchedule: OrgManage_ReportSchedule_ReportSchedule$1,
    OrgManage_ReportSchedule_ScheduleAdded: OrgManage_ReportSchedule_ScheduleAdded$1,
    OrgManage_ReportSchedule_ScheduleCreated: OrgManage_ReportSchedule_ScheduleCreated$1,
    OrgManage_ReportSchedule_ScheduleDeleted: OrgManage_ReportSchedule_ScheduleDeleted$1,
    OrgManage_ReportSchedule_ScheduleReport: OrgManage_ReportSchedule_ScheduleReport$1,
    OrgManage_ReportSchedule_ScheduleUpdated: OrgManage_ReportSchedule_ScheduleUpdated$1,
    OrgManage_ReportSchedule_SelectFrequency: OrgManage_ReportSchedule_SelectFrequency$1,
    OrgManage_ReportSchedule_SelectReportType: OrgManage_ReportSchedule_SelectReportType$1,
    OrgManage_ReportSchedule_SelectTimePeriod: OrgManage_ReportSchedule_SelectTimePeriod$1,
    OrgManage_ReportSchedule_SelectVersion: OrgManage_ReportSchedule_SelectVersion$1,
    OrgManage_ReportSchedule_UploadFile: OrgManage_ReportSchedule_UploadFile$1,
    OrgManage_SettingsError_OrgSupportInfoEmail_pattern: OrgManage_SettingsError_OrgSupportInfoEmail_pattern$1,
    OrgManage_SwitchTo: OrgManage_SwitchTo$1,
    OrgManage_UpdatedMessageCollectorsInformation: OrgManage_UpdatedMessageCollectorsInformation$1,
    OrgManage_UpdatedMessageConnectorsInformation: OrgManage_UpdatedMessageConnectorsInformation$1,
    OrgManage_UpdatedProviderRebranding: OrgManage_UpdatedProviderRebranding$1,
    OrgManage_UpdateUsers: OrgManage_UpdateUsers$1,
    OrgManage_UploadOpportunitiesError: OrgManage_UploadOpportunitiesError$1,
    OrgManage_UploadUsers: OrgManage_UploadUsers$1,
    orgInviteFlowModal_Compiling: orgInviteFlowModal_Compiling$1,
    orgInviteFlowModal_DiscoverContentInfo: orgInviteFlowModal_DiscoverContentInfo$1,
    orgInviteFlowModal_GotIt: orgInviteFlowModal_GotIt$1,
    orgInviteFlowModal_GroupConversation: orgInviteFlowModal_GroupConversation$1,
    orgInviteFlowModal_GroupConversations: orgInviteFlowModal_GroupConversations$1,
    orgInviteFlowModal_InviteMessageFormat: orgInviteFlowModal_InviteMessageFormat$1,
    orgInviteFlowModal_LearnAsTeam: orgInviteFlowModal_LearnAsTeam$1,
    orgInviteFlowModal_LetsGetStarted: orgInviteFlowModal_LetsGetStarted$1,
    orgInviteFlowModal_PersonalizedLearning: orgInviteFlowModal_PersonalizedLearning$1,
    orgInviteFlowModal_PersonalLearning: orgInviteFlowModal_PersonalLearning$1,
    orgInviteFlowModal_Recommendations: orgInviteFlowModal_Recommendations$1,
    orgInviteFlowModal_RecommendInfo: orgInviteFlowModal_RecommendInfo$1,
    orgInviteFlowModal_ResendVerification: orgInviteFlowModal_ResendVerification$1,
    orgInviteFlowModal_SeeMemberLearning: orgInviteFlowModal_SeeMemberLearning$1,
    orgInviteFlowModal_SocialGroupFeed: orgInviteFlowModal_SocialGroupFeed$1,
    orgInviteFlowModal_UnableToJoin: orgInviteFlowModal_UnableToJoin$1,
    orgInviteFlowModal_UnableToJoin_Desc: orgInviteFlowModal_UnableToJoin_Desc$1,
    orgInviteFlowModal_VerificationSentFormat: orgInviteFlowModal_VerificationSentFormat$1,
    orgInviteFlowModal_VerifyEmailFormat: orgInviteFlowModal_VerifyEmailFormat$1,
    orgInviteFlowModal_VerifyInstructions: orgInviteFlowModal_VerifyInstructions$1,
    orgInternalContentVisibilitySelector_GroupVisibilityPlaceholder: orgInternalContentVisibilitySelector_GroupVisibilityPlaceholder$1,
    orgInternalContentVisibilitySelector_OrgVisibilityPlaceholder: orgInternalContentVisibilitySelector_OrgVisibilityPlaceholder$1,
    orgInternalContentVisibilitySelector_TargetGroupsLabel: orgInternalContentVisibilitySelector_TargetGroupsLabel$1,
    orgInternalContentVisibilitySelector_Title: orgInternalContentVisibilitySelector_Title$1,
    orgInternalContentVisibilitySelector_VisibleToGroups: orgInternalContentVisibilitySelector_VisibleToGroups$1,
    orgInternalContentVisibilitySelector_VisibleToOrganization: orgInternalContentVisibilitySelector_VisibleToOrganization$1,
    OrgInternalContentSvc_DeletionConfirmationMessageFormat: OrgInternalContentSvc_DeletionConfirmationMessageFormat$1,
    OrgInternalContentSvc_InputType: OrgInternalContentSvc_InputType$1,
    OrgInternalContentSvc_InternalContentError: OrgInternalContentSvc_InternalContentError$1,
    OrgInternalContentSvc_ItemsDeletedSuccessMessage: OrgInternalContentSvc_ItemsDeletedSuccessMessage$1,
    OrgInternalContentSvc_ItemsDeletionError: OrgInternalContentSvc_ItemsDeletionError$1,
    OrgInternalContentSvc_ItemsRestoredSuccessMessage: OrgInternalContentSvc_ItemsRestoredSuccessMessage$1,
    OrgInternalContentSvc_ItemsRestoreError: OrgInternalContentSvc_ItemsRestoreError$1,
    OrgInternalContentSvc_ItemsUpdatedSuccessMessage: OrgInternalContentSvc_ItemsUpdatedSuccessMessage$1,
    OrgInternalContentSvc_ItemsUpdateError: OrgInternalContentSvc_ItemsUpdateError$1,
    OrgInternalContentSvc_ItemUpdateDuplicateError: OrgInternalContentSvc_ItemUpdateDuplicateError$1,
    OrgInternalContentSvc_ItemWTitleDeletedSuccessMessage: OrgInternalContentSvc_ItemWTitleDeletedSuccessMessage$1,
    OrgInternalContentSvc_ItemWTitleDeletionError: OrgInternalContentSvc_ItemWTitleDeletionError$1,
    OrgInternalContentSvc_ProviderName: OrgInternalContentSvc_ProviderName$1,
    OrgInternalContentSvc_SingleItemUpdatedSuccessMessage: OrgInternalContentSvc_SingleItemUpdatedSuccessMessage$1,
    OrgInternalContentSvc_Summary: OrgInternalContentSvc_Summary$1,
    OrgInternalContentSvc_Tags: OrgInternalContentSvc_Tags$1,
    OrgInternalContentSvc_Title: OrgInternalContentSvc_Title$1,
    OrgInternalContentModalCtrl_DuplicatesDescriptionLabel: OrgInternalContentModalCtrl_DuplicatesDescriptionLabel$1,
    OrgInternalContentModalCtrl_DuplicatesGroupsCount: OrgInternalContentModalCtrl_DuplicatesGroupsCount$1,
    OrgInternalContentModalCtrl_DuplicatesGroupsLabel: OrgInternalContentModalCtrl_DuplicatesGroupsLabel$1,
    OrgInternalContentModalCtrl_DuplicatesHeader: OrgInternalContentModalCtrl_DuplicatesHeader$1,
    OrgInternalContentModalCtrl_DuplicatesTopicsCount: OrgInternalContentModalCtrl_DuplicatesTopicsCount$1,
    OrgInternalContentModalCtrl_DuplicatesTopicsLabel: OrgInternalContentModalCtrl_DuplicatesTopicsLabel$1,
    OrgInternalContentCtrl_AddGroups: OrgInternalContentCtrl_AddGroups$1,
    OrgInternalContentCtrl_AddToPathway: OrgInternalContentCtrl_AddToPathway$1,
    OrgInternalContentCtrl_AddTopics: OrgInternalContentCtrl_AddTopics$1,
    OrgInternalContentCtrl_AssessmentUnavailableError: OrgInternalContentCtrl_AssessmentUnavailableError$1,
    OrgInternalContentCtrl_BulkEditItemsFormat: OrgInternalContentCtrl_BulkEditItemsFormat$1,
    OrgInternalContentCtrl_ClearCategories: OrgInternalContentCtrl_ClearCategories$1,
    OrgInternalContentCtrl_ContentOwner: OrgInternalContentCtrl_ContentOwner$1,
    OrgInternalContentCtrl_ContentTitle: OrgInternalContentCtrl_ContentTitle$1,
    OrgInternalContentCtrl_CourseProperties: OrgInternalContentCtrl_CourseProperties$1,
    OrgInternalContentCtrl_Delete: OrgInternalContentCtrl_Delete$1,
    OrgInternalContentCtrl_DialogConfirmBulkDeleteItems: OrgInternalContentCtrl_DialogConfirmBulkDeleteItems$1,
    OrgInternalContentCtrl_DialogConfirmClearCategories: OrgInternalContentCtrl_DialogConfirmClearCategories$1,
    OrgInternalContentCtrl_DialogConfirmDeleteItemFormat: OrgInternalContentCtrl_DialogConfirmDeleteItemFormat$1,
    OrgInternalContentCtrl_Edit: OrgInternalContentCtrl_Edit$1,
    OrgInternalContentCtrl_FlagAsInappropriate: OrgInternalContentCtrl_FlagAsInappropriate$1,
    OrgInternalContentCtrl_GenericError: OrgInternalContentCtrl_GenericError$1,
    OrgInternalContentCtrl_InputMetricCompletions: OrgInternalContentCtrl_InputMetricCompletions$1,
    OrgInternalContentCtrl_InputMetricDateAdded: OrgInternalContentCtrl_InputMetricDateAdded$1,
    OrgInternalContentCtrl_InputMetricDateUpdated: OrgInternalContentCtrl_InputMetricDateUpdated$1,
    OrgInternalContentCtrl_InputMetricNone: OrgInternalContentCtrl_InputMetricNone$1,
    OrgInternalContentCtrl_InputMetricRating: OrgInternalContentCtrl_InputMetricRating$1,
    OrgInternalContentCtrl_InputMetricRecommendations: OrgInternalContentCtrl_InputMetricRecommendations$1,
    OrgInternalContentCtrl_InputMetricTakeaways: OrgInternalContentCtrl_InputMetricTakeaways$1,
    OrgInternalContentCtrl_InputMetricViews: OrgInternalContentCtrl_InputMetricViews$1,
    OrgInternalContentCtrl_InternalProvider: OrgInternalContentCtrl_InternalProvider$1,
    OrgInternalContentCtrl_MakeASelection: OrgInternalContentCtrl_MakeASelection$1,
    OrgInternalContentCtrl_MoreDetails: OrgInternalContentCtrl_MoreDetails$1,
    OrgInternalContentCtrl_Recommend: OrgInternalContentCtrl_Recommend$1,
    OrgInternalContentCtrl_RemoveItems: OrgInternalContentCtrl_RemoveItems$1,
    OrgInternalContentCtrl_ReportAProblem: OrgInternalContentCtrl_ReportAProblem$1,
    OrgInternalContentCtrl_ReSyncDetails: OrgInternalContentCtrl_ReSyncDetails$1,
    OrgInternalContentCtrl_SearchCatalog: OrgInternalContentCtrl_SearchCatalog$1,
    OrgInternalContentCtrl_SearchErrorMessage: OrgInternalContentCtrl_SearchErrorMessage$1,
    OrgInternalContentCtrl_SetGoal: OrgInternalContentCtrl_SetGoal$1,
    OrgInternalContentCtrl_SuccessfulAddContent: OrgInternalContentCtrl_SuccessfulAddContent$1,
    OrgInternalContentCtrl_SuccessfulUpdateContent: OrgInternalContentCtrl_SuccessfulUpdateContent$1,
    OrgInternalContentCtrl_ValidateCategoryRequired: OrgInternalContentCtrl_ValidateCategoryRequired$1,
    OrgInternalContentCtrl_ValidateNeedEndDate: OrgInternalContentCtrl_ValidateNeedEndDate$1,
    OrgInternalContentCtrl_ValidateNumber: OrgInternalContentCtrl_ValidateNumber$1,
    OrgInternalContentCtrl_ValidateScormRequired: OrgInternalContentCtrl_ValidateScormRequired$1,
    OrgInternalContentCtrl_ValidateTitleRequired: OrgInternalContentCtrl_ValidateTitleRequired$1,
    OrgInternalContentCtrl_ValidateURLMayBeInvalid: OrgInternalContentCtrl_ValidateURLMayBeInvalid$1,
    OrgInternalContentCtrl_ViewDetails: OrgInternalContentCtrl_ViewDetails$1,
    OrgInternalContentCtrl_ViewInGoals: OrgInternalContentCtrl_ViewInGoals$1,
    OrgInternalContent_AddNewContentFormat: OrgInternalContent_AddNewContentFormat$1,
    OrgInternalContent_AddNewDisplayArticle: OrgInternalContent_AddNewDisplayArticle$1,
    OrgInternalContent_AddNewDisplayAssessment: OrgInternalContent_AddNewDisplayAssessment$1,
    OrgInternalContent_AddNewDisplayCourse: OrgInternalContent_AddNewDisplayCourse$1,
    OrgInternalContent_AddNewDisplayEpisode: OrgInternalContent_AddNewDisplayEpisode$1,
    OrgInternalContent_AddNewDisplayEvent: OrgInternalContent_AddNewDisplayEvent$1,
    OrgInternalContent_AddNewDisplayPost: OrgInternalContent_AddNewDisplayPost$1,
    OrgInternalContent_AddNewDisplayVideo: OrgInternalContent_AddNewDisplayVideo$1,
    OrgInternalContent_ContentType: OrgInternalContent_ContentType$1,
    OrgInternalContent_ContentUse: OrgInternalContent_ContentUse$1,
    OrgInternalContent_DeleteAllReferences: OrgInternalContent_DeleteAllReferences$1,
    OrgInternalContent_DeleteCatalogOnly: OrgInternalContent_DeleteCatalogOnly$1,
    OrgInternalContent_DeleteCatalogOnlyDesc: OrgInternalContent_DeleteCatalogOnlyDesc$1,
    OrgInternalContent_DeleteSingleContentFormat: OrgInternalContent_DeleteSingleContentFormat$1,
    OrgInternalContent_EditContentFormat: OrgInternalContent_EditContentFormat$1,
    OrgInternalContent_RestrictedContentNote: OrgInternalContent_RestrictedContentNote$1,
    OrgInternalContent_ValidateCategoryRequired: OrgInternalContent_ValidateCategoryRequired$1,
    OrgInternalContent_ValidateGroupSelectionRequired: OrgInternalContent_ValidateGroupSelectionRequired$1,
    OrgInternalContent_ValidateNeedEndDate: OrgInternalContent_ValidateNeedEndDate$1,
    OrgInternalContent_ValidateNumber: OrgInternalContent_ValidateNumber$1,
    OrgInternalContent_ValidateScormRequired: OrgInternalContent_ValidateScormRequired$1,
    OrgInternalContent_ValidateTitleRequired: OrgInternalContent_ValidateTitleRequired$1,
    OrgInternalContent_ValidateURLMayBeInvalid: OrgInternalContent_ValidateURLMayBeInvalid$1,
    OrgGroupsCtrl_AdministrativeDynamic: OrgGroupsCtrl_AdministrativeDynamic$1,
    OrgGroupsCtrl_AdministrativeGroup: OrgGroupsCtrl_AdministrativeGroup$1,
    OrgGroupsCtrl_AdministrativeStatic: OrgGroupsCtrl_AdministrativeStatic$1,
    OrgGroupsCtrl_AvailableGroupsHeading: OrgGroupsCtrl_AvailableGroupsHeading$1,
    OrgGroupsCtrl_BecomeMember: OrgGroupsCtrl_BecomeMember$1,
    OrgGroupsCtrl_Closed: OrgGroupsCtrl_Closed$1,
    OrgGroupsCtrl_ClosedGroup: OrgGroupsCtrl_ClosedGroup$1,
    OrgGroupsCtrl_CreateAGroup: OrgGroupsCtrl_CreateAGroup$1,
    OrgGroupsCtrl_DeletePluralPrompt: OrgGroupsCtrl_DeletePluralPrompt$1,
    OrgGroupsCtrl_DeletePrompt: OrgGroupsCtrl_DeletePrompt$1,
    OrgGroupsCtrl_Dynamic: OrgGroupsCtrl_Dynamic$1,
    OrgGroupsCtrl_GroupMembers: OrgGroupsCtrl_GroupMembers$1,
    OrgGroupsCtrl_GroupName: OrgGroupsCtrl_GroupName$1,
    OrgGroupsCtrl_GroupsTitle: OrgGroupsCtrl_GroupsTitle$1,
    OrgGroupsCtrl_GroupVisibility: OrgGroupsCtrl_GroupVisibility$1,
    OrgGroupsCtrl_JoinGroup: OrgGroupsCtrl_JoinGroup$1,
    OrgGroupsCtrl_Leave: OrgGroupsCtrl_Leave$1,
    OrgGroupsCtrl_LeaveGroup: OrgGroupsCtrl_LeaveGroup$1,
    OrgGroupsCtrl_LeaveGroupModalBodyText: OrgGroupsCtrl_LeaveGroupModalBodyText$1,
    OrgGroupsCtrl_LeaveGroupModalHeader: OrgGroupsCtrl_LeaveGroupModalHeader$1,
    OrgGroupsCtrl_MyGroupsHeading: OrgGroupsCtrl_MyGroupsHeading$1,
    OrgGroupsCtrl_NoGroupsCreatedMessage: OrgGroupsCtrl_NoGroupsCreatedMessage$1,
    OrgGroupsCtrl_NoGroupsMatchMessage: OrgGroupsCtrl_NoGroupsMatchMessage$1,
    OrgGroupsCtrl_NumberOfMembersFormat: OrgGroupsCtrl_NumberOfMembersFormat$1,
    OrgGroupsCtrl_Open: OrgGroupsCtrl_Open$1,
    OrgGroupsCtrl_OpenGroup: OrgGroupsCtrl_OpenGroup$1,
    OrgGroupsCtrl_Private: OrgGroupsCtrl_Private$1,
    OrgGroupsCtrl_PrivateGroup: OrgGroupsCtrl_PrivateGroup$1,
    OrgGroupsCtrl_RequestGroupMembership: OrgGroupsCtrl_RequestGroupMembership$1,
    OrgGroupsCtrl_RequestMembership: OrgGroupsCtrl_RequestMembership$1,
    OrgGroupsCtrl_RequestPending: OrgGroupsCtrl_RequestPending$1,
    OrgGroupsCtrl_SearchforGroup: OrgGroupsCtrl_SearchforGroup$1,
    OrgGroupsCtrl_Static: OrgGroupsCtrl_Static$1,
    OrgGroupsCtrl_ThreeOrLess: OrgGroupsCtrl_ThreeOrLess$1,
    OrgGroupsCtrl_ThreeOrLessMembers: OrgGroupsCtrl_ThreeOrLessMembers$1,
    OrgGroupsCtrl_UploadGroups: OrgGroupsCtrl_UploadGroups$1,
    OrgGroupsCtrl_UploadGroupsDescription: OrgGroupsCtrl_UploadGroupsDescription$1,
    OrgGroupsCtrl_UploadGroupsError: OrgGroupsCtrl_UploadGroupsError$1,
    OrgFtp_AllyText_CloseDetailsFormat: OrgFtp_AllyText_CloseDetailsFormat$1,
    OrgFtp_AllyText_SeeDetailsFormat: OrgFtp_AllyText_SeeDetailsFormat$1,
    OrgFtp_ChangedRowPluralFormat: OrgFtp_ChangedRowPluralFormat$1,
    OrgFtp_ChangedRowSingleFormat: OrgFtp_ChangedRowSingleFormat$1,
    OrgFtp_ClientUserFileWarning: OrgFtp_ClientUserFileWarning$1,
    OrgFtp_ContactSupport: OrgFtp_ContactSupport$1,
    OrgFtp_CorrectYourRows: OrgFtp_CorrectYourRows$1,
    OrgFtp_Discard: OrgFtp_Discard$1,
    OrgFtp_DiscardConfirmationMessage: OrgFtp_DiscardConfirmationMessage$1,
    OrgFtp_DiscardFile: OrgFtp_DiscardFile$1,
    OrgFtp_DragAndDrop: OrgFtp_DragAndDrop$1,
    OrgFtp_DragAndDropImage: OrgFtp_DragAndDropImage$1,
    OrgFtp_ErrorDiscardingFile: OrgFtp_ErrorDiscardingFile$1,
    OrgFtp_ErrorFileDetails: OrgFtp_ErrorFileDetails$1,
    OrgFtp_ErrorUnknownFormat: OrgFtp_ErrorUnknownFormat$1,
    OrgFtp_File_Error_DelimiterNotFound_Description: OrgFtp_File_Error_DelimiterNotFound_Description$1,
    OrgFtp_File_Error_DelimiterNotFound_Title: OrgFtp_File_Error_DelimiterNotFound_Title$1,
    OrgFtp_File_Error_DescriptionColumnMissing_Description: OrgFtp_File_Error_DescriptionColumnMissing_Description$1,
    OrgFtp_File_Error_DescriptionColumnMissing_Title: OrgFtp_File_Error_DescriptionColumnMissing_Title$1,
    OrgFtp_File_Error_DuplicateColumnFound_Description: OrgFtp_File_Error_DuplicateColumnFound_Description$1,
    OrgFtp_File_Error_DuplicateColumnFound_Title: OrgFtp_File_Error_DuplicateColumnFound_Title$1,
    OrgFtp_File_Error_ErrorParsingFile_Description: OrgFtp_File_Error_ErrorParsingFile_Description$1,
    OrgFtp_File_Error_ErrorParsingFile_Title: OrgFtp_File_Error_ErrorParsingFile_Title$1,
    OrgFtp_File_Error_ErrorParsingRows_Description: OrgFtp_File_Error_ErrorParsingRows_Description$1,
    OrgFtp_File_Error_ErrorParsingRows_Title: OrgFtp_File_Error_ErrorParsingRows_Title$1,
    OrgFtp_File_Error_ExternalIdColumnMissing_Description: OrgFtp_File_Error_ExternalIdColumnMissing_Description$1,
    OrgFtp_File_Error_ExternalIdColumnMissing_Title: OrgFtp_File_Error_ExternalIdColumnMissing_Title$1,
    OrgFtp_File_Error_FileIsEmpty_Description: OrgFtp_File_Error_FileIsEmpty_Description$1,
    OrgFtp_File_Error_FileIsEmpty_Title: OrgFtp_File_Error_FileIsEmpty_Title$1,
    OrgFtp_File_Error_FileNotFound_Description: OrgFtp_File_Error_FileNotFound_Description$1,
    OrgFtp_File_Error_FileNotFound_Title: OrgFtp_File_Error_FileNotFound_Title$1,
    OrgFtp_File_Error_InvalidFields_Description: OrgFtp_File_Error_InvalidFields_Description$1,
    OrgFtp_File_Error_InvalidFields_Title: OrgFtp_File_Error_InvalidFields_Title$1,
    OrgFtp_File_Error_NameColumnMissing_Description: OrgFtp_File_Error_NameColumnMissing_Description$1,
    OrgFtp_File_Error_NameColumnMissing_Title: OrgFtp_File_Error_NameColumnMissing_Title$1,
    OrgFtp_File_Error_NoColumnsFound_Description: OrgFtp_File_Error_NoColumnsFound_Description$1,
    OrgFtp_File_Error_NoColumnsFound_Title: OrgFtp_File_Error_NoColumnsFound_Title$1,
    OrgFtp_File_Error_NoDatabaseFileInfo_Description: OrgFtp_File_Error_NoDatabaseFileInfo_Description$1,
    OrgFtp_File_Error_NoDatabaseFileInfo_Title: OrgFtp_File_Error_NoDatabaseFileInfo_Title$1,
    OrgFtp_File_Error_NoFileInfoReturned_Description: OrgFtp_File_Error_NoFileInfoReturned_Description$1,
    OrgFtp_File_Error_NoFileInfoReturned_Title: OrgFtp_File_Error_NoFileInfoReturned_Title$1,
    OrgFtp_File_Error_NotifyParseFailure_Description: OrgFtp_File_Error_NotifyParseFailure_Description$1,
    OrgFtp_File_Error_NotifyParseFailure_Title: OrgFtp_File_Error_NotifyParseFailure_Title$1,
    OrgFtp_File_Error_ProcessingError_Description: OrgFtp_File_Error_ProcessingError_Description$1,
    OrgFtp_File_Error_TypeColumnMissing_Description: OrgFtp_File_Error_TypeColumnMissing_Description$1,
    OrgFtp_File_Error_TypeColumnMissing_Title: OrgFtp_File_Error_TypeColumnMissing_Title$1,
    OrgFtp_File_Error_UniqueIdColumnMissing_Description: OrgFtp_File_Error_UniqueIdColumnMissing_Description$1,
    OrgFtp_File_Error_UniqueIdColumnMissing_Title: OrgFtp_File_Error_UniqueIdColumnMissing_Title$1,
    OrgFtp_File_Error_Unknown_Description: OrgFtp_File_Error_Unknown_Description$1,
    OrgFtp_File_Error_Unknown_Title: OrgFtp_File_Error_Unknown_Title$1,
    OrgFtp_File_Error_UnrecognizedExtension_Description: OrgFtp_File_Error_UnrecognizedExtension_Description$1,
    OrgFtp_File_Error_UnrecognizedExtension_Title: OrgFtp_File_Error_UnrecognizedExtension_Title$1,
    OrgFtp_File_Error_UnsupportedExtension_Description: OrgFtp_File_Error_UnsupportedExtension_Description$1,
    OrgFtp_File_Error_UnsupportedExtension_Title: OrgFtp_File_Error_UnsupportedExtension_Title$1,
    OrgFtp_File_Error_ValueColumnMissing_Description: OrgFtp_File_Error_ValueColumnMissing_Description$1,
    OrgFtp_File_Error_ValueColumnMissing_Title: OrgFtp_File_Error_ValueColumnMissing_Title$1,
    OrgFtp_File_Rejected_Error_Format: OrgFtp_File_Rejected_Error_Format$1,
    OrgFtp_FileError: OrgFtp_FileError$1,
    OrgFtp_LandingPage_Description_BulkOpportunities: OrgFtp_LandingPage_Description_BulkOpportunities$1,
    OrgFtp_LandingPage_Description_BulkTaxonomyRoles: OrgFtp_LandingPage_Description_BulkTaxonomyRoles$1,
    OrgFtp_LandingPage_Description_BulkTaxonomySkills: OrgFtp_LandingPage_Description_BulkTaxonomySkills$1,
    OrgFtp_LandingPage_Description_ClientUser: OrgFtp_LandingPage_Description_ClientUser$1,
    OrgFtp_LandingPage_Description_Completion: OrgFtp_LandingPage_Description_Completion$1,
    OrgFtp_LandingPage_Description_Content: OrgFtp_LandingPage_Description_Content$1,
    OrgFtp_LandingPage_Description_Groups: OrgFtp_LandingPage_Description_Groups$1,
    OrgFtp_LandingPage_Description_RequiredLearning: OrgFtp_LandingPage_Description_RequiredLearning$1,
    OrgFtp_LandingPage_Description_UserUpdate: OrgFtp_LandingPage_Description_UserUpdate$1,
    OrgFtp_LandingPage_Type_Badge: OrgFtp_LandingPage_Type_Badge$1,
    OrgFtp_LandingPage_Type_BulkOpportunities: OrgFtp_LandingPage_Type_BulkOpportunities$1,
    OrgFtp_LandingPage_Type_BulkTaxonomyRoles: OrgFtp_LandingPage_Type_BulkTaxonomyRoles$1,
    OrgFtp_LandingPage_Type_BulkTaxonomySkills: OrgFtp_LandingPage_Type_BulkTaxonomySkills$1,
    OrgFtp_LandingPage_Type_ClientUser: OrgFtp_LandingPage_Type_ClientUser$1,
    OrgFtp_LandingPage_Type_Completion: OrgFtp_LandingPage_Type_Completion$1,
    OrgFtp_LandingPage_Type_Content: OrgFtp_LandingPage_Type_Content$1,
    OrgFtp_LandingPage_Type_Groups: OrgFtp_LandingPage_Type_Groups$1,
    OrgFtp_LandingPage_Type_JobRole: OrgFtp_LandingPage_Type_JobRole$1,
    OrgFtp_LandingPage_Type_Opportunity: OrgFtp_LandingPage_Type_Opportunity$1,
    OrgFtp_LandingPage_Type_RequiredLearning: OrgFtp_LandingPage_Type_RequiredLearning$1,
    OrgFtp_LandingPage_Type_Skill: OrgFtp_LandingPage_Type_Skill$1,
    OrgFtp_LandingPage_Type_SkillAssessment: OrgFtp_LandingPage_Type_SkillAssessment$1,
    OrgFtp_LandingPage_Type_UserUpdate: OrgFtp_LandingPage_Type_UserUpdate$1,
    OrgFtp_Note: OrgFtp_Note$1,
    OrgFtp_PendingChangedRowPluralFormat: OrgFtp_PendingChangedRowPluralFormat$1,
    OrgFtp_PendingChangedRowSingleFormat: OrgFtp_PendingChangedRowSingleFormat$1,
    OrgFtp_PendingFileWarning: OrgFtp_PendingFileWarning$1,
    OrgFtp_PendingRejectedRowPluralFormat: OrgFtp_PendingRejectedRowPluralFormat$1,
    OrgFtp_PendingRejectedRowSingleFormat: OrgFtp_PendingRejectedRowSingleFormat$1,
    OrgFtp_PendingWarningRowPluralFormat: OrgFtp_PendingWarningRowPluralFormat$1,
    OrgFtp_PendingWarningRowSingleFormat: OrgFtp_PendingWarningRowSingleFormat$1,
    OrgFtp_PreviewingXOfYRows_PluralFormat: OrgFtp_PreviewingXOfYRows_PluralFormat$1,
    OrgFtp_Processing: OrgFtp_Processing$1,
    OrgFtp_ProcessingError: OrgFtp_ProcessingError$1,
    OrgFtp_RejectedRowPluralFormat: OrgFtp_RejectedRowPluralFormat$1,
    OrgFtp_RejectedRowSingleFormat: OrgFtp_RejectedRowSingleFormat$1,
    OrgFtp_ReviewAndSubmit: OrgFtp_ReviewAndSubmit$1,
    OrgFtp_Row_Error_ConflictingRecord_Description: OrgFtp_Row_Error_ConflictingRecord_Description$1,
    OrgFtp_Row_Error_ConflictingRecord_Title: OrgFtp_Row_Error_ConflictingRecord_Title$1,
    OrgFtp_Row_Error_ContentNotFound_Description: OrgFtp_Row_Error_ContentNotFound_Description$1,
    OrgFtp_Row_Error_ContentNotFound_Title: OrgFtp_Row_Error_ContentNotFound_Title$1,
    OrgFtp_Row_Error_CustomAttributeTypeMissmatch_Description: OrgFtp_Row_Error_CustomAttributeTypeMissmatch_Description$1,
    OrgFtp_Row_Error_CustomAttributeTypeMissmatch_Title: OrgFtp_Row_Error_CustomAttributeTypeMissmatch_Title$1,
    OrgFtp_Row_Error_DuplicateCategoryName_Title: OrgFtp_Row_Error_DuplicateCategoryName_Title$1,
    OrgFtp_Row_Error_DuplicateEmail_Description: OrgFtp_Row_Error_DuplicateEmail_Description$1,
    OrgFtp_Row_Error_DuplicateEmail_Title: OrgFtp_Row_Error_DuplicateEmail_Title$1,
    OrgFtp_Row_Error_DuplicateExternalId_Title: OrgFtp_Row_Error_DuplicateExternalId_Title$1,
    OrgFtp_Row_Error_DuplicateLocalizeSkillName_Title: OrgFtp_Row_Error_DuplicateLocalizeSkillName_Title$1,
    OrgFtp_Row_Error_DuplicateRow_Description: OrgFtp_Row_Error_DuplicateRow_Description$1,
    OrgFtp_Row_Error_DuplicateRow_Title: OrgFtp_Row_Error_DuplicateRow_Title$1,
    OrgFtp_Row_Error_DuplicateSkillName_Title: OrgFtp_Row_Error_DuplicateSkillName_Title$1,
    OrgFtp_Row_Error_DuplicateSynonym_Title: OrgFtp_Row_Error_DuplicateSynonym_Title$1,
    OrgFtp_Row_Error_EmptyContentType_Description: OrgFtp_Row_Error_EmptyContentType_Description$1,
    OrgFtp_Row_Error_EmptyContentType_Title: OrgFtp_Row_Error_EmptyContentType_Title$1,
    OrgFtp_Row_Error_EmptyUpdateType_Description: OrgFtp_Row_Error_EmptyUpdateType_Description$1,
    OrgFtp_Row_Error_EmptyUpdateType_Title: OrgFtp_Row_Error_EmptyUpdateType_Title$1,
    OrgFtp_Row_Error_FieldExceedsMaxLength_Title: OrgFtp_Row_Error_FieldExceedsMaxLength_Title$1,
    OrgFtp_Row_Error_InvalidDuration_Description: OrgFtp_Row_Error_InvalidDuration_Description$1,
    OrgFtp_Row_Error_InvalidDuration_Title: OrgFtp_Row_Error_InvalidDuration_Title$1,
    OrgFtp_Row_Error_InvalidLanguageCode_Title: OrgFtp_Row_Error_InvalidLanguageCode_Title$1,
    OrgFtp_Row_Error_InvalidLearningMinutes_Description: OrgFtp_Row_Error_InvalidLearningMinutes_Description$1,
    OrgFtp_Row_Error_InvalidLearningMinutes_Title: OrgFtp_Row_Error_InvalidLearningMinutes_Title$1,
    OrgFtp_Row_Error_MaximumRowWidthExceeded_Description: OrgFtp_Row_Error_MaximumRowWidthExceeded_Description$1,
    OrgFtp_Row_Error_MaximumRowWidthExceeded_Title: OrgFtp_Row_Error_MaximumRowWidthExceeded_Title$1,
    OrgFtp_Row_Error_MissingRequiredColumn_Description: OrgFtp_Row_Error_MissingRequiredColumn_Description$1,
    OrgFtp_Row_Error_MissingRequiredColumn_Title: OrgFtp_Row_Error_MissingRequiredColumn_Title$1,
    OrgFtp_Row_Error_Unknown_Description: OrgFtp_Row_Error_Unknown_Description$1,
    OrgFtp_Row_Error_Unknown_Title: OrgFtp_Row_Error_Unknown_Title$1,
    OrgFtp_Row_Error_UnknownCategoryName_Title: OrgFtp_Row_Error_UnknownCategoryName_Title$1,
    OrgFtp_Row_Error_UnknownContentType_Description: OrgFtp_Row_Error_UnknownContentType_Description$1,
    OrgFtp_Row_Error_UnknownContentType_Title: OrgFtp_Row_Error_UnknownContentType_Title$1,
    OrgFtp_Row_Error_UnknownGroup_Description: OrgFtp_Row_Error_UnknownGroup_Description$1,
    OrgFtp_Row_Error_UnknownGroup_Title: OrgFtp_Row_Error_UnknownGroup_Title$1,
    OrgFtp_Row_Error_UnknownPathway_Description: OrgFtp_Row_Error_UnknownPathway_Description$1,
    OrgFtp_Row_Error_UnknownPathway_Title: OrgFtp_Row_Error_UnknownPathway_Title$1,
    OrgFtp_Row_Error_UnknownPlan_Description: OrgFtp_Row_Error_UnknownPlan_Description$1,
    OrgFtp_Row_Error_UnknownPlan_Title: OrgFtp_Row_Error_UnknownPlan_Title$1,
    OrgFtp_Row_Error_UnknownSkillName_Title: OrgFtp_Row_Error_UnknownSkillName_Title$1,
    OrgFtp_Row_Error_UnknownSkillPlan_Description: OrgFtp_Row_Error_UnknownSkillPlan_Description$1,
    OrgFtp_Row_Error_UnknownSkillPlan_Title: OrgFtp_Row_Error_UnknownSkillPlan_Title$1,
    OrgFtp_Row_Error_UnknownUpdateType_Description: OrgFtp_Row_Error_UnknownUpdateType_Description$1,
    OrgFtp_Row_Error_UnknownUpdateType_Title: OrgFtp_Row_Error_UnknownUpdateType_Title$1,
    OrgFtp_Row_Error_UnsupportedDisplayLanguage_Description: OrgFtp_Row_Error_UnsupportedDisplayLanguage_Description$1,
    OrgFtp_Row_Error_UnsupportedDisplayLanguage_Title: OrgFtp_Row_Error_UnsupportedDisplayLanguage_Title$1,
    OrgFtp_Row_Error_UnsupportedFileContentType_Description: OrgFtp_Row_Error_UnsupportedFileContentType_Description$1,
    OrgFtp_Row_Error_UnsupportedFileContentType_Title: OrgFtp_Row_Error_UnsupportedFileContentType_Title$1,
    OrgFtp_Row_Error_UserNotFound_Description: OrgFtp_Row_Error_UserNotFound_Description$1,
    OrgFtp_Row_Error_UserNotFound_Title: OrgFtp_Row_Error_UserNotFound_Title$1,
    OrgFtp_RowNumber: OrgFtp_RowNumber$1,
    OrgFtp_Select: OrgFtp_Select$1,
    OrgFtp_SelectFileTypeToUpload: OrgFtp_SelectFileTypeToUpload$1,
    OrgFtp_StatusBadge_Error: OrgFtp_StatusBadge_Error$1,
    OrgFtp_StatusBadge_Pending: OrgFtp_StatusBadge_Pending$1,
    OrgFtp_StatusBadge_Processing: OrgFtp_StatusBadge_Processing$1,
    OrgFtp_StatusBadge_ProcessingError: OrgFtp_StatusBadge_ProcessingError$1,
    OrgFtp_StatusBadge_Rejected: OrgFtp_StatusBadge_Rejected$1,
    OrgFtp_StatusBadge_Success: OrgFtp_StatusBadge_Success$1,
    OrgFtp_StatusBadge_Warning: OrgFtp_StatusBadge_Warning$1,
    OrgFtp_SubmitFile: OrgFtp_SubmitFile$1,
    OrgFtp_Success: OrgFtp_Success$1,
    OrgFtp_TemplateInstructions: OrgFtp_TemplateInstructions$1,
    OrgFtp_TemplateInstructions_LongFormInstructions_Header1: OrgFtp_TemplateInstructions_LongFormInstructions_Header1$1,
    OrgFtp_TemplateInstructions_LongFormInstructions_Header2: OrgFtp_TemplateInstructions_LongFormInstructions_Header2$1,
    OrgFtp_TemplateInstructions_LongFormInstructions_Header3: OrgFtp_TemplateInstructions_LongFormInstructions_Header3$1,
    OrgFtp_TemplateInstructions_LongFormInstructions_Link1: OrgFtp_TemplateInstructions_LongFormInstructions_Link1$1,
    OrgFtp_TemplateInstructions_LongFormInstructions_Para2: OrgFtp_TemplateInstructions_LongFormInstructions_Para2$1,
    OrgFtp_TemplateInstructions_LongFormInstructions_Para3: OrgFtp_TemplateInstructions_LongFormInstructions_Para3$1,
    OrgFtp_TemplateInstructions_LongFormInstructions_Para4: OrgFtp_TemplateInstructions_LongFormInstructions_Para4$1,
    OrgFtp_TemplateInstructions_LongFormInstructions_Para5: OrgFtp_TemplateInstructions_LongFormInstructions_Para5$1,
    OrgFtp_ThereMightBeSomeDelay: OrgFtp_ThereMightBeSomeDelay$1,
    OrgFtp_Types_RowsWithErrors: OrgFtp_Types_RowsWithErrors$1,
    OrgFtp_Types_RowsWithWarnings: OrgFtp_Types_RowsWithWarnings$1,
    OrgFtp_TypesTooltips_RowsWithErrors: OrgFtp_TypesTooltips_RowsWithErrors$1,
    OrgFtp_TypesTooltips_RowsWithWarnings: OrgFtp_TypesTooltips_RowsWithWarnings$1,
    OrgFtp_UploadFile: OrgFtp_UploadFile$1,
    OrgFtp_ViewFileDetails: OrgFtp_ViewFileDetails$1,
    OrgFtp_ViewFileLog: OrgFtp_ViewFileLog$1,
    OrgFtp_WarningRowPluralFormat: OrgFtp_WarningRowPluralFormat$1,
    OrgFtp_WarningRowSingleFormat: OrgFtp_WarningRowSingleFormat$1,
    OrgFtp_WillBeRejectedRowPluralFormat: OrgFtp_WillBeRejectedRowPluralFormat$1,
    OrgFtp_WillBeRejectedRowSingleFormat: OrgFtp_WillBeRejectedRowSingleFormat$1,
    OrgFtp_WillChangeRowPluralFormat: OrgFtp_WillChangeRowPluralFormat$1,
    OrgFtp_WillChangeRowSingleFormat: OrgFtp_WillChangeRowSingleFormat$1,
    OrgFtp_WillHaveWarningRowPluralFormat: OrgFtp_WillHaveWarningRowPluralFormat$1,
    OrgFtp_WillHaveWarningRowSingleFormat: OrgFtp_WillHaveWarningRowSingleFormat$1,
    OrgFtp_YourFileIsBeingProcessed: OrgFtp_YourFileIsBeingProcessed$1,
    OrgFaqCtrl_AnswerText: OrgFaqCtrl_AnswerText$1,
    OrgFaqCtrl_EnterSearchTerm: OrgFaqCtrl_EnterSearchTerm$1,
    OrgFaqCtrl_FaqHeading: OrgFaqCtrl_FaqHeading$1,
    OrgFaqCtrl_MaxResultsNarrowYourSearch: OrgFaqCtrl_MaxResultsNarrowYourSearch$1,
    OrgFaqCtrl_NewQuestion: OrgFaqCtrl_NewQuestion$1,
    OrgFaqCtrl_NoFaqsFoundFormat: OrgFaqCtrl_NoFaqsFoundFormat$1,
    OrgFaqCtrl_RemoveFaqButton: OrgFaqCtrl_RemoveFaqButton$1,
    OrgFaqCtrl_RemoveFaqConfirmContinue: OrgFaqCtrl_RemoveFaqConfirmContinue$1,
    OrgFaqCtrl_RemoveFaqDescriptionFormat: OrgFaqCtrl_RemoveFaqDescriptionFormat$1,
    OrgFaqCtrl_RemoveFaqHeadingFormat: OrgFaqCtrl_RemoveFaqHeadingFormat$1,
    OrgFaqCtrl_SearchForFaq: OrgFaqCtrl_SearchForFaq$1,
    OrgAnnouncement_ActivateDesc: OrgAnnouncement_ActivateDesc$1,
    OrgAnnouncement_ActivateLabel: OrgAnnouncement_ActivateLabel$1,
    OrgAnnouncement_AddALink: OrgAnnouncement_AddALink$1,
    OrgAnnouncement_BlankDescription: OrgAnnouncement_BlankDescription$1,
    OrgAnnouncement_Desc: OrgAnnouncement_Desc$1,
    OrgAnnouncement_DescriptionPlaceholder: OrgAnnouncement_DescriptionPlaceholder$1,
    OrgAnnouncement_ImageDesc: OrgAnnouncement_ImageDesc$1,
    OrgAnnouncement_ImageDescNew: OrgAnnouncement_ImageDescNew$1,
    OrgAnnouncement_Label: OrgAnnouncement_Label$1,
    OrgAnnouncement_LinkNamePlaceholder: OrgAnnouncement_LinkNamePlaceholder$1,
    OrgAnnouncement_LinkUrlHelperText: OrgAnnouncement_LinkUrlHelperText$1,
    OrgAnnouncement_RetrievingError: OrgAnnouncement_RetrievingError$1,
    OrgAnnouncement_TitlePlaceholder: OrgAnnouncement_TitlePlaceholder$1,
    OrganizationsController_AddFAQs: OrganizationsController_AddFAQs$1,
    OrganizationsController_BackToOrgFormat: OrganizationsController_BackToOrgFormat$1,
    OrganizationsController_Branding: OrganizationsController_Branding$1,
    OrganizationsController_Content: OrganizationsController_Content$1,
    OrganizationsController_EditImage: OrganizationsController_EditImage$1,
    OrganizationsController_EstimateInfo: OrganizationsController_EstimateInfo$1,
    OrganizationsController_FAQ: OrganizationsController_FAQ$1,
    OrganizationsController_FileLog: OrganizationsController_FileLog$1,
    OrganizationsController_FileUpload: OrganizationsController_FileUpload$1,
    OrganizationsController_Groups: OrganizationsController_Groups$1,
    OrganizationsController_HelpMenu: OrganizationsController_HelpMenu$1,
    OrganizationsController_Home: OrganizationsController_Home$1,
    OrganizationsController_Insights: OrganizationsController_Insights$1,
    OrganizationsController_InsightsAndUsage: OrganizationsController_InsightsAndUsage$1,
    OrganizationsController_InvitedMessageOne: OrganizationsController_InvitedMessageOne$1,
    OrganizationsController_InviteMessageTwo: OrganizationsController_InviteMessageTwo$1,
    OrganizationsController_JobRoles: OrganizationsController_JobRoles$1,
    OrganizationsController_Links: OrganizationsController_Links$1,
    OrganizationsController_ManageAdvanced: OrganizationsController_ManageAdvanced$1,
    OrganizationsController_ManageCatalog: OrganizationsController_ManageCatalog$1,
    OrganizationsController_ManageFAQ: OrganizationsController_ManageFAQ$1,
    OrganizationsController_ManageGroups: OrganizationsController_ManageGroups$1,
    OrganizationsController_ManageJobRoles: OrganizationsController_ManageJobRoles$1,
    OrganizationsController_ManageOpportunities: OrganizationsController_ManageOpportunities$1,
    OrganizationsController_ManagePathways: OrganizationsController_ManagePathways$1,
    OrganizationsController_ManagePeople: OrganizationsController_ManagePeople$1,
    OrganizationsController_ManagePlans: OrganizationsController_ManagePlans$1,
    OrganizationsController_ManagePublishedPathways: OrganizationsController_ManagePublishedPathways$1,
    OrganizationsController_ManageSkills: OrganizationsController_ManageSkills$1,
    OrganizationsController_Messaging: OrganizationsController_Messaging$1,
    OrganizationsController_NotEnoughActivity: OrganizationsController_NotEnoughActivity$1,
    OrganizationsController_Opportunities: OrganizationsController_Opportunities$1,
    OrganizationsController_OrganizationDetails: OrganizationsController_OrganizationDetails$1,
    OrganizationsController_Pages: OrganizationsController_Pages$1,
    OrganizationsController_Pathways: OrganizationsController_Pathways$1,
    OrganizationsController_People: OrganizationsController_People$1,
    OrganizationsController_Permissions: OrganizationsController_Permissions$1,
    OrganizationsController_Plans: OrganizationsController_Plans$1,
    OrganizationsController_Providers: OrganizationsController_Providers$1,
    OrganizationsController_Reporting: OrganizationsController_Reporting$1,
    OrganizationsController_ReportsNotAvailable: OrganizationsController_ReportsNotAvailable$1,
    OrganizationsController_ScanPreferences: OrganizationsController_ScanPreferences$1,
    OrganizationsController_Segments: OrganizationsController_Segments$1,
    OrganizationsController_SelectContentTypes: OrganizationsController_SelectContentTypes$1,
    OrganizationsController_Settings: OrganizationsController_Settings$1,
    OrganizationsController_Skills: OrganizationsController_Skills$1,
    OrganizationsController_SkillToRoleSuggestions: OrganizationsController_SkillToRoleSuggestions$1,
    OrganizationsController_StartScan: OrganizationsController_StartScan$1,
    OrganizationsController_SubmitQuestion: OrganizationsController_SubmitQuestion$1,
    OrganizationsController_WelcomeToDegreed: OrganizationsController_WelcomeToDegreed$1,
    opportunityNewAuthor_NotificationTitleFormat: opportunityNewAuthor_NotificationTitleFormat$1,
    OpportunityApplicantSelected_NotificationTitleFormat: OpportunityApplicantSelected_NotificationTitleFormat$1,
    Opportunities_AcceptMenteeModal_AcceptFormatted: Opportunities_AcceptMenteeModal_AcceptFormatted$1,
    Opportunities_AcceptMenteeModal_AvailabilityDescription: Opportunities_AcceptMenteeModal_AvailabilityDescription$1,
    Opportunities_AcceptMenteeModal_AvailabilityLabel: Opportunities_AcceptMenteeModal_AvailabilityLabel$1,
    Opportunities_AcceptMenteeModal_ConnectLabel: Opportunities_AcceptMenteeModal_ConnectLabel$1,
    Opportunities_AcceptMenteeModal_ConnectLabel_Error: Opportunities_AcceptMenteeModal_ConnectLabel_Error$1,
    Opportunities_AcceptMenteeModal_ConnectPlaceholder: Opportunities_AcceptMenteeModal_ConnectPlaceholder$1,
    Opportunities_AcceptMenteeModal_Description: Opportunities_AcceptMenteeModal_Description$1,
    Opportunities_AcceptMenteeModal_Error: Opportunities_AcceptMenteeModal_Error$1,
    Opportunities_AcceptMenteeModal_SubmitButtonText: Opportunities_AcceptMenteeModal_SubmitButtonText$1,
    Opportunities_AcceptMenteeModal_Success: Opportunities_AcceptMenteeModal_Success$1,
    Opportunities_AcceptMenteeModal_Success_Multi: Opportunities_AcceptMenteeModal_Success_Multi$1,
    Opportunities_Actions_Edit: Opportunities_Actions_Edit$1,
    Opportunities_ActiveFormat: Opportunities_ActiveFormat$1,
    Opportunities_Activity_AsCollaborator: Opportunities_Activity_AsCollaborator$1,
    Opportunities_Activity_NewCandidates: Opportunities_Activity_NewCandidates$1,
    Opportunities_Activity_NoInterestForDays: Opportunities_Activity_NoInterestForDays$1,
    Opportunities_Activity_NoInterestSevenDays: Opportunities_Activity_NoInterestSevenDays$1,
    Opportunities_Activity_OpenMoreThanDays: Opportunities_Activity_OpenMoreThanDays$1,
    Opportunities_AllGroups: Opportunities_AllGroups$1,
    Opportunities_AllLocations: Opportunities_AllLocations$1,
    Opportunities_AllSkills: Opportunities_AllSkills$1,
    Opportunities_AllStatuses: Opportunities_AllStatuses$1,
    Opportunities_AllTypes: Opportunities_AllTypes$1,
    Opportunities_Apply: Opportunities_Apply$1,
    Opportunities_ArchiveCandidatesModal_Header_Bulk: Opportunities_ArchiveCandidatesModal_Header_Bulk$1,
    Opportunities_ArchiveCandidatesModal_Header_Singular: Opportunities_ArchiveCandidatesModal_Header_Singular$1,
    Opportunities_ArchiveCandidatesModal_Labels_Notify_Bulk: Opportunities_ArchiveCandidatesModal_Labels_Notify_Bulk$1,
    Opportunities_ArchiveCandidatesModal_Labels_Notify_Singular: Opportunities_ArchiveCandidatesModal_Labels_Notify_Singular$1,
    Opportunities_ArchiveCandidatesModal_Labels_RejectionMessage: Opportunities_ArchiveCandidatesModal_Labels_RejectionMessage$1,
    Opportunities_ArchiveCandidatesModal_Labels_RejectionMessage_Placeholder: Opportunities_ArchiveCandidatesModal_Labels_RejectionMessage_Placeholder$1,
    Opportunities_ArchiveCandidatesModal_SubmitButtonText: Opportunities_ArchiveCandidatesModal_SubmitButtonText$1,
    Opportunities_Archived: Opportunities_Archived$1,
    Opportunities_BrowseOpportunities: Opportunities_BrowseOpportunities$1,
    Opportunities_Candidates_Cols_DateAdded: Opportunities_Candidates_Cols_DateAdded$1,
    Opportunities_Candidates_Cols_JobTitle: Opportunities_Candidates_Cols_JobTitle$1,
    Opportunities_Candidates_Cols_Location: Opportunities_Candidates_Cols_Location$1,
    Opportunities_Candidates_Cols_Name: Opportunities_Candidates_Cols_Name$1,
    Opportunities_Candidates_Cols_SkillMatch: Opportunities_Candidates_Cols_SkillMatch$1,
    Opportunities_Candidates_Cols_Stage: Opportunities_Candidates_Cols_Stage$1,
    Opportunities_Candidates_Cols_Status: Opportunities_Candidates_Cols_Status$1,
    Opportunities_Candidates_Cols_TargetMet: Opportunities_Candidates_Cols_TargetMet$1,
    Opportunities_Candidates_Email_RejectionMessage: Opportunities_Candidates_Email_RejectionMessage$1,
    Opportunities_Candidates_Error_Get: Opportunities_Candidates_Error_Get$1,
    Opportunities_Candidates_Modal_Award: Opportunities_Candidates_Modal_Award$1,
    Opportunities_Candidates_Modal_UpdateApplicant_Description: Opportunities_Candidates_Modal_UpdateApplicant_Description$1,
    Opportunities_Candidates_Modal_UpdateApplicant_Title: Opportunities_Candidates_Modal_UpdateApplicant_Title$1,
    Opportunities_Candidates_Modal_UpdateApplicantPrompt_CloseOpp: Opportunities_Candidates_Modal_UpdateApplicantPrompt_CloseOpp$1,
    Opportunities_Candidates_Modal_UpdateApplicantPrompt_Congratulations: Opportunities_Candidates_Modal_UpdateApplicantPrompt_Congratulations$1,
    Opportunities_Candidates_Modal_UpdateApplicantPrompt_Congratulations_Plural: Opportunities_Candidates_Modal_UpdateApplicantPrompt_Congratulations_Plural$1,
    Opportunities_Candidates_Modal_UpdateApplicantPrompt_Description: Opportunities_Candidates_Modal_UpdateApplicantPrompt_Description$1,
    Opportunities_Candidates_Modal_UpdateApplicantPrompt_Description_Plural: Opportunities_Candidates_Modal_UpdateApplicantPrompt_Description_Plural$1,
    Opportunities_Candidates_Modal_UpdateApplicantPrompt_NotifyUnselected: Opportunities_Candidates_Modal_UpdateApplicantPrompt_NotifyUnselected$1,
    Opportunities_Candidates_Modal_UpdateApplicantPrompt_SubmitButton: Opportunities_Candidates_Modal_UpdateApplicantPrompt_SubmitButton$1,
    Opportunities_Candidates_Modal_UpdateApplicantPrompt_SubmitButton_Plural: Opportunities_Candidates_Modal_UpdateApplicantPrompt_SubmitButton_Plural$1,
    Opportunities_Candidates_Modal_UpdateApplicantPrompt_Title: Opportunities_Candidates_Modal_UpdateApplicantPrompt_Title$1,
    Opportunities_Candidates_Modal_UpdateApplicantPrompt_Title_Plural: Opportunities_Candidates_Modal_UpdateApplicantPrompt_Title_Plural$1,
    Opportunities_Candidates_Notice_NoCandidates: Opportunities_Candidates_Notice_NoCandidates$1,
    Opportunities_Candidates_Search_Placeholder: Opportunities_Candidates_Search_Placeholder$1,
    Opportunities_Candidates_ShowArchived: Opportunities_Candidates_ShowArchived$1,
    Opportunities_Candidates_Stage_Archived: Opportunities_Candidates_Stage_Archived$1,
    Opportunities_Candidates_Stage_None: Opportunities_Candidates_Stage_None$1,
    Opportunities_Candidates_Stage_Select: Opportunities_Candidates_Stage_Select$1,
    Opportunities_Candidates_Stage_Selected: Opportunities_Candidates_Stage_Selected$1,
    Opportunities_Candidates_Stage_Shortlisted: Opportunities_Candidates_Stage_Shortlisted$1,
    Opportunities_Candidates_Status_Interested: Opportunities_Candidates_Status_Interested$1,
    Opportunities_Candidates_Status_InviteSent: Opportunities_Candidates_Status_InviteSent$1,
    Opportunities_Candidates_Status_NoResponse: Opportunities_Candidates_Status_NoResponse$1,
    Opportunities_Candidates_Status_NotInterested: Opportunities_Candidates_Status_NotInterested$1,
    Opportunities_Candidates_UserHasNotOptedIn: Opportunities_Candidates_UserHasNotOptedIn$1,
    Opportunities_CareerMobility: Opportunities_CareerMobility$1,
    Opportunities_ChartXAxisTitle: Opportunities_ChartXAxisTitle$1,
    Opportunities_ClosedOnDate: Opportunities_ClosedOnDate$1,
    Opportunities_ConnectWithButton_Status_Accepted: Opportunities_ConnectWithButton_Status_Accepted$1,
    Opportunities_ConnectWithButton_Status_None: Opportunities_ConnectWithButton_Status_None$1,
    Opportunities_ConnectWithButton_Status_Requested: Opportunities_ConnectWithButton_Status_Requested$1,
    Opportunities_ConnectWithModal_ConnectWithFormatted: Opportunities_ConnectWithModal_ConnectWithFormatted$1,
    Opportunities_ConnectWithModal_Description: Opportunities_ConnectWithModal_Description$1,
    Opportunities_ConnectWithModal_Error: Opportunities_ConnectWithModal_Error$1,
    Opportunities_ConnectWithModal_Labels_FocusSkills: Opportunities_ConnectWithModal_Labels_FocusSkills$1,
    Opportunities_ConnectWithModal_Labels_FocusSkills_Description: Opportunities_ConnectWithModal_Labels_FocusSkills_Description$1,
    Opportunities_ConnectWithModal_Labels_FocusSkills_Description_NoSkillsExplainer: Opportunities_ConnectWithModal_Labels_FocusSkills_Description_NoSkillsExplainer$1,
    Opportunities_ConnectWithModal_Labels_MatchingSkills: Opportunities_ConnectWithModal_Labels_MatchingSkills$1,
    Opportunities_ConnectWithModal_Labels_MatchingSkills_Description: Opportunities_ConnectWithModal_Labels_MatchingSkills_Description$1,
    Opportunities_ConnectWithModal_Labels_Reason: Opportunities_ConnectWithModal_Labels_Reason$1,
    Opportunities_ConnectWithModal_OpenModal: Opportunities_ConnectWithModal_OpenModal$1,
    Opportunities_ConnectWithModal_Placeholders_Reason: Opportunities_ConnectWithModal_Placeholders_Reason$1,
    Opportunities_ConnectWithModal_SubmitButton: Opportunities_ConnectWithModal_SubmitButton$1,
    Opportunities_ConnectWithModal_Success: Opportunities_ConnectWithModal_Success$1,
    Opportunities_ConnectWithModal_Success_Mentors_Removed: Opportunities_ConnectWithModal_Success_Mentors_Removed$1,
    Opportunities_ConnectWithModal_Success_Updated: Opportunities_ConnectWithModal_Success_Updated$1,
    Opportunities_DataUpdateTimelineExplanation: Opportunities_DataUpdateTimelineExplanation$1,
    Opportunities_DeclineMenteeModal_DeclineFormatted: Opportunities_DeclineMenteeModal_DeclineFormatted$1,
    Opportunities_DeclineMenteeModal_Description: Opportunities_DeclineMenteeModal_Description$1,
    Opportunities_DeclineMenteeModal_Error: Opportunities_DeclineMenteeModal_Error$1,
    Opportunities_DeclineMenteeModal_ExplanationLabel: Opportunities_DeclineMenteeModal_ExplanationLabel$1,
    Opportunities_DeclineMenteeModal_ExplanationPlaceholder: Opportunities_DeclineMenteeModal_ExplanationPlaceholder$1,
    Opportunities_DeclineMenteeModal_SubmitButtonText: Opportunities_DeclineMenteeModal_SubmitButtonText$1,
    Opportunities_DeclineMenteeModal_Success: Opportunities_DeclineMenteeModal_Success$1,
    Opportunities_DeclineMenteeModal_Success_Multi: Opportunities_DeclineMenteeModal_Success_Multi$1,
    Opportunities_Discard: Opportunities_Discard$1,
    Opportunities_DiscardChanges: Opportunities_DiscardChanges$1,
    Opportunities_Discover_Error_Get: Opportunities_Discover_Error_Get$1,
    Opportunities_Discover_NoItems_ActionDescription: Opportunities_Discover_NoItems_ActionDescription$1,
    Opportunities_Discover_NoItems_ActionDescription_Public: Opportunities_Discover_NoItems_ActionDescription_Public$1,
    Opportunities_Discover_NoItems_Headline: Opportunities_Discover_NoItems_Headline$1,
    Opportunities_Discover_NoItems_Headline_Public: Opportunities_Discover_NoItems_Headline_Public$1,
    Opportunities_Discover_ResultsDisclaimer: Opportunities_Discover_ResultsDisclaimer$1,
    Opportunities_EngagementAriaLabel: Opportunities_EngagementAriaLabel$1,
    Opportunities_Error_AddExperience: Opportunities_Error_AddExperience$1,
    Opportunities_Error_Get: Opportunities_Error_Get$1,
    Opportunities_Error_GetApplicantData: Opportunities_Error_GetApplicantData$1,
    Opportunities_Error_GetMentors: Opportunities_Error_GetMentors$1,
    Opportunities_Error_Loading: Opportunities_Error_Loading$1,
    Opportunities_Error_Skill_Delete: Opportunities_Error_Skill_Delete$1,
    Opportunities_Error_Target_Delete: Opportunities_Error_Target_Delete$1,
    Opportunities_Error_UpdateApplicantsStage: Opportunities_Error_UpdateApplicantsStage$1,
    Opportunities_Error_UpdateApplicantStage: Opportunities_Error_UpdateApplicantStage$1,
    Opportunities_Errors_OpportunityIsInvalid: Opportunities_Errors_OpportunityIsInvalid$1,
    Opportunities_Errors_OpportunityIsInvalid_Tab: Opportunities_Errors_OpportunityIsInvalid_Tab$1,
    Opportunities_ExcellentFitLabel: Opportunities_ExcellentFitLabel$1,
    Opportunities_GetError: Opportunities_GetError$1,
    Opportunities_GoodFitLabel: Opportunities_GoodFitLabel$1,
    Opportunities_InterestByMatchedCandidates: Opportunities_InterestByMatchedCandidates$1,
    Opportunities_InterestByUnmatchedCandidates: Opportunities_InterestByUnmatchedCandidates$1,
    Opportunities_InterestConfirmed: Opportunities_InterestConfirmed$1,
    Opportunities_Interested: Opportunities_Interested$1,
    Opportunities_Interested_NoItems_ActionDescription: Opportunities_Interested_NoItems_ActionDescription$1,
    Opportunities_Interested_NoItems_CustomNoItemsMessage: Opportunities_Interested_NoItems_CustomNoItemsMessage$1,
    Opportunities_Interested_NoItems_Headline: Opportunities_Interested_NoItems_Headline$1,
    Opportunities_Interested_NoResult: Opportunities_Interested_NoResult$1,
    Opportunities_InterestNotConfirmedError: Opportunities_InterestNotConfirmedError$1,
    Opportunities_InterestNotRemovedError: Opportunities_InterestNotRemovedError$1,
    Opportunities_InterestRemoved: Opportunities_InterestRemoved$1,
    Opportunities_JobRoleNotSpecified: Opportunities_JobRoleNotSpecified$1,
    Opportunities_Marketplace: Opportunities_Marketplace$1,
    Opportunities_Marketplace_BasedOn_Focus: Opportunities_Marketplace_BasedOn_Focus$1,
    Opportunities_Marketplace_BasedOn_Goals: Opportunities_Marketplace_BasedOn_Goals$1,
    Opportunities_Marketplace_BasedOn_Recent: Opportunities_Marketplace_BasedOn_Recent$1,
    Opportunities_Marketplace_BasedOn_Skills: Opportunities_Marketplace_BasedOn_Skills$1,
    Opportunities_Marketplace_LaneTypes_Mentors: Opportunities_Marketplace_LaneTypes_Mentors$1,
    Opportunities_Marketplace_LaneTypes_Permanent: Opportunities_Marketplace_LaneTypes_Permanent$1,
    Opportunities_Marketplace_LaneTypes_Projects: Opportunities_Marketplace_LaneTypes_Projects$1,
    Opportunities_Marketplace_LaneTypes_Temporary: Opportunities_Marketplace_LaneTypes_Temporary$1,
    Opportunities_MatchedCandidateExplanation: Opportunities_MatchedCandidateExplanation$1,
    Opportunities_MatchedSkills: Opportunities_MatchedSkills$1,
    Opportunities_MatchingSkills: Opportunities_MatchingSkills$1,
    Opportunities_Mentees: Opportunities_Mentees$1,
    Opportunities_MenteeSkills: Opportunities_MenteeSkills$1,
    Opportunities_Mentoring: Opportunities_Mentoring$1,
    Opportunities_Mentoring_Columns_Connect: Opportunities_Mentoring_Columns_Connect$1,
    Opportunities_Mentors: Opportunities_Mentors$1,
    Opportunities_MentorSkills: Opportunities_MentorSkills$1,
    Opportunities_Meta_Closed: Opportunities_Meta_Closed$1,
    Opportunities_Meta_Location: Opportunities_Meta_Location$1,
    Opportunities_Meta_PublishDate: Opportunities_Meta_PublishDate$1,
    Opportunities_Meta_PublishDateString: Opportunities_Meta_PublishDateString$1,
    Opportunities_Meta_Type: Opportunities_Meta_Type$1,
    Opportunities_Meta_Visibility: Opportunities_Meta_Visibility$1,
    Opportunities_MoreDetailsMentorshipModal_Info: Opportunities_MoreDetailsMentorshipModal_Info$1,
    Opportunities_MoreDetailsMentorshipModal_Warning: Opportunities_MoreDetailsMentorshipModal_Warning$1,
    Opportunities_MyOpportunities: Opportunities_MyOpportunities$1,
    Opportunities_MyOpportunitiesCollaboratingOn: Opportunities_MyOpportunitiesCollaboratingOn$1,
    Opportunities_MyOpportunitiesCompleted: Opportunities_MyOpportunitiesCompleted$1,
    Opportunities_MyOpportunitiesEmptyStateText: Opportunities_MyOpportunitiesEmptyStateText$1,
    Opportunities_MyOpportunitiesEmptyStateTitle: Opportunities_MyOpportunitiesEmptyStateTitle$1,
    Opportunities_MyOpportunitiesInterested: Opportunities_MyOpportunitiesInterested$1,
    Opportunities_MyOpportunitiesSavedForLater: Opportunities_MyOpportunitiesSavedForLater$1,
    Opportunities_MyOpportunitiesSelected: Opportunities_MyOpportunitiesSelected$1,
    Opportunities_MyOpportunitiesSharedWithMe: Opportunities_MyOpportunitiesSharedWithMe$1,
    Opportunities_NoMentorship: Opportunities_NoMentorship$1,
    Opportunities_NoResultsForBrowse: Opportunities_NoResultsForBrowse$1,
    Opportunities_NoResultsForSearch: Opportunities_NoResultsForSearch$1,
    Opportunities_NotFound_DescriptionText: Opportunities_NotFound_DescriptionText$1,
    Opportunities_OpenedOnDate: Opportunities_OpenedOnDate$1,
    Opportunities_OpenOpportunities: Opportunities_OpenOpportunities$1,
    Opportunities_OpenOpportunitiesByJobRoleFormat: Opportunities_OpenOpportunitiesByJobRoleFormat$1,
    Opportunities_OpenOpportunitiesByType: Opportunities_OpenOpportunitiesByType$1,
    Opportunities_OpenOpportunitiesByTypeFormat: Opportunities_OpenOpportunitiesByTypeFormat$1,
    Opportunities_OpportunityEngagement: Opportunities_OpportunityEngagement$1,
    Opportunities_OtherSkills: Opportunities_OtherSkills$1,
    Opportunities_PartialFitLabel: Opportunities_PartialFitLabel$1,
    Opportunities_RecentSearches: Opportunities_RecentSearches$1,
    Opportunities_Relation: Opportunities_Relation$1,
    "Opportunities_Relation_ Author": "Collaborator",
    Opportunities_Relation_Author: Opportunities_Relation_Author$1,
    Opportunities_Relation_InterestedApplicant: Opportunities_Relation_InterestedApplicant$1,
    Opportunities_Relation_SavedForLaterByUser: Opportunities_Relation_SavedForLaterByUser$1,
    Opportunities_Relation_SelectedApplicant: Opportunities_Relation_SelectedApplicant$1,
    Opportunities_RemoveArchive: Opportunities_RemoveArchive$1,
    Opportunities_RemoveArchived: Opportunities_RemoveArchived$1,
    Opportunities_RemoveInterest: Opportunities_RemoveInterest$1,
    Opportunities_RemoveSelected: Opportunities_RemoveSelected$1,
    Opportunities_RemoveShortlist: Opportunities_RemoveShortlist$1,
    Opportunities_RemoveShortlisted: Opportunities_RemoveShortlisted$1,
    Opportunities_ResultRange: Opportunities_ResultRange$1,
    Opportunities_SavedForLater: Opportunities_SavedForLater$1,
    Opportunities_Selected: Opportunities_Selected$1,
    Opportunities_SelectedCandidates: Opportunities_SelectedCandidates$1,
    Opportunities_SelectedCandidatesTooltip: Opportunities_SelectedCandidatesTooltip$1,
    Opportunities_SelectedMatchedCandidates: Opportunities_SelectedMatchedCandidates$1,
    Opportunities_SelectedUnmatchedCandidates: Opportunities_SelectedUnmatchedCandidates$1,
    Opportunities_SharedWithYou: Opportunities_SharedWithYou$1,
    Opportunities_Shortlisted: Opportunities_Shortlisted$1,
    Opportunities_ShowingCountOfTotalOpportunities: Opportunities_ShowingCountOfTotalOpportunities$1,
    Opportunities_ShowInterest: Opportunities_ShowInterest$1,
    Opportunities_SkillMatchFullLabel: Opportunities_SkillMatchFullLabel$1,
    Opportunities_SkillMatchLabel: Opportunities_SkillMatchLabel$1,
    Opportunities_Skills_AddSkillPlaceholder: Opportunities_Skills_AddSkillPlaceholder$1,
    Opportunities_Skills_AddSkillRating: Opportunities_Skills_AddSkillRating$1,
    Opportunities_Skills_AddSkillsAltText: Opportunities_Skills_AddSkillsAltText$1,
    Opportunities_Skills_AddTargetLevel: Opportunities_Skills_AddTargetLevel$1,
    Opportunities_Skills_EditSkillRating: Opportunities_Skills_EditSkillRating$1,
    Opportunities_Skills_EditTargetLevel: Opportunities_Skills_EditTargetLevel$1,
    Opportunities_Skills_Following_But_No_Rating: Opportunities_Skills_Following_But_No_Rating$1,
    Opportunities_Skills_Menu_AddTargetLevel: Opportunities_Skills_Menu_AddTargetLevel$1,
    Opportunities_Skills_Menu_EditTargetLevel: Opportunities_Skills_Menu_EditTargetLevel$1,
    Opportunities_Skills_Menu_RemoveTargetLevel: Opportunities_Skills_Menu_RemoveTargetLevel$1,
    Opportunities_Skills_Modal_AddTargetHeader: Opportunities_Skills_Modal_AddTargetHeader$1,
    Opportunities_Skills_Modal_EditTargetHeader: Opportunities_Skills_Modal_EditTargetHeader$1,
    Opportunities_Skills_RemoveSkillRating: Opportunities_Skills_RemoveSkillRating$1,
    Opportunities_SkillsMatchLabel: Opportunities_SkillsMatchLabel$1,
    Opportunities_SkillsMatchPercentage: Opportunities_SkillsMatchPercentage$1,
    Opportunities_Success_AddExperience: Opportunities_Success_AddExperience$1,
    Opportunities_Success_Clone: Opportunities_Success_Clone$1,
    Opportunities_Success_UpdateApplicantStage: Opportunities_Success_UpdateApplicantStage$1,
    Opportunities_SuggestedLearning: Opportunities_SuggestedLearning$1,
    Opportunities_SuggestedLearning_Description: Opportunities_SuggestedLearning_Description$1,
    Opportunities_TopLocations: Opportunities_TopLocations$1,
    Opportunities_TopOpportunitiesByJobRoleFormat: Opportunities_TopOpportunitiesByJobRoleFormat$1,
    Opportunities_TopOpportunitiesByJobRoleFormatNoCount: Opportunities_TopOpportunitiesByJobRoleFormatNoCount$1,
    Opportunities_TopOpportunitiesByTypeFormat: Opportunities_TopOpportunitiesByTypeFormat$1,
    Opportunities_TopSkillsInDemandFormat: Opportunities_TopSkillsInDemandFormat$1,
    Opportunities_TypeDynamicTeamAssignment: Opportunities_TypeDynamicTeamAssignment$1,
    Opportunities_TypeJobDescription: Opportunities_TypeJobDescription$1,
    Opportunities_TypeLookingForMentee: Opportunities_TypeLookingForMentee$1,
    Opportunities_TypeLookingForMentor: Opportunities_TypeLookingForMentor$1,
    Opportunities_TypeMenteeship: Opportunities_TypeMenteeship$1,
    Opportunities_TypeMenteeshipDescription: Opportunities_TypeMenteeshipDescription$1,
    Opportunities_TypeMentorship: Opportunities_TypeMentorship$1,
    Opportunities_TypeMentorshipDescription: Opportunities_TypeMentorshipDescription$1,
    Opportunities_TypeOther: Opportunities_TypeOther$1,
    Opportunities_TypeOtherDescription: Opportunities_TypeOtherDescription$1,
    Opportunities_TypePeerMentoring: Opportunities_TypePeerMentoring$1,
    Opportunities_TypePermanent: Opportunities_TypePermanent$1,
    Opportunities_TypeProBono: Opportunities_TypeProBono$1,
    Opportunities_TypeProject: Opportunities_TypeProject$1,
    Opportunities_TypeProjectDescription: Opportunities_TypeProjectDescription$1,
    Opportunities_TypeReverseMentoring: Opportunities_TypeReverseMentoring$1,
    Opportunities_TypeSecondment: Opportunities_TypeSecondment$1,
    Opportunities_TypeShadowing: Opportunities_TypeShadowing$1,
    Opportunities_TypeShadowingDescription: Opportunities_TypeShadowingDescription$1,
    Opportunities_TypeStretchAssignment: Opportunities_TypeStretchAssignment$1,
    Opportunities_TypeStretchAssignmentDescription: Opportunities_TypeStretchAssignmentDescription$1,
    Opportunities_TypeTemporary: Opportunities_TypeTemporary$1,
    Opportunities_TypeVolunteer: Opportunities_TypeVolunteer$1,
    Opportunities_UnmatchedCandidateExplanation: Opportunities_UnmatchedCandidateExplanation$1,
    Opportunities_UnmatchedSkills: Opportunities_UnmatchedSkills$1,
    Opportunities_UnsavedChanges: Opportunities_UnsavedChanges$1,
    Opportunities_UserRateSkillsModal_Header: Opportunities_UserRateSkillsModal_Header$1,
    Opportunities_View_Error_Get: Opportunities_View_Error_Get$1,
    Opportunities_ViewAll: Opportunities_ViewAll$1,
    Opportunities_ViewAllCollaborators: Opportunities_ViewAllCollaborators$1,
    Opportunities_ViewByMatchedCandidates: Opportunities_ViewByMatchedCandidates$1,
    Opportunities_ViewByUnmatchedCandidates: Opportunities_ViewByUnmatchedCandidates$1,
    Opportunities_Viewing: Opportunities_Viewing$1,
    Opportunities_ViewOpportunity: Opportunities_ViewOpportunity$1,
    Opportunities_ViewsAndInterest: Opportunities_ViewsAndInterest$1,
    Opportunities_ViewsAndInterestsTooltip: Opportunities_ViewsAndInterestsTooltip$1,
    Opportunities_YourOpportunities: Opportunities_YourOpportunities$1,
    OnboardingFooter_GetStarted: OnboardingFooter_GetStarted$1,
    OnboardingFooter_NextStep: OnboardingFooter_NextStep$1,
    OnboardingFooter_PreviousStep: OnboardingFooter_PreviousStep$1,
    OnboardingFooter_RatingDisabledStatus: OnboardingFooter_RatingDisabledStatus$1,
    OnboardingFooter_SeeMyProfile: OnboardingFooter_SeeMyProfile$1,
    OnboardingFooter_SkipStep: OnboardingFooter_SkipStep$1,
    OnboardingFooter_StartLearning: OnboardingFooter_StartLearning$1,
    OnboardingFooter_StepperLabel: OnboardingFooter_StepperLabel$1,
    OnboardingFooter_SubmitRating: OnboardingFooter_SubmitRating$1,
    "Onboarding_ AddedSkill": "Added Skill",
    Onboarding_A11yAssignedStepName: Onboarding_A11yAssignedStepName$1,
    Onboarding_A11yResumeReviewStepName: Onboarding_A11yResumeReviewStepName$1,
    Onboarding_A11yRoleSelectStepName: Onboarding_A11yRoleSelectStepName$1,
    Onboarding_A11ySkillAdded: Onboarding_A11ySkillAdded$1,
    Onboarding_A11ySkillAlreadyAdded: Onboarding_A11ySkillAlreadyAdded$1,
    Onboarding_A11ySkillsStepName: Onboarding_A11ySkillsStepName$1,
    Onboarding_A11yStartLearningStepName: Onboarding_A11yStartLearningStepName$1,
    Onboarding_AddedSkill: Onboarding_AddedSkill$1,
    Onboarding_AdditionalSkillsDescription: Onboarding_AdditionalSkillsDescription$1,
    Onboarding_AdditionalSkillsInterstedIn: Onboarding_AdditionalSkillsInterstedIn$1,
    Onboarding_AdditionalSkillsTitle: Onboarding_AdditionalSkillsTitle$1,
    Onboarding_AISkillsSuggestDesc: Onboarding_AISkillsSuggestDesc$1,
    Onboarding_AISkillsSuggestLabel: Onboarding_AISkillsSuggestLabel$1,
    Onboarding_AreYouSureDescription: Onboarding_AreYouSureDescription$1,
    Onboarding_AreYouSureHeading: Onboarding_AreYouSureHeading$1,
    Onboarding_AssignedSkillsDescription: Onboarding_AssignedSkillsDescription$1,
    Onboarding_AssignedSkillsError: Onboarding_AssignedSkillsError$1,
    Onboarding_AssignedSkillsHeader: Onboarding_AssignedSkillsHeader$1,
    Onboarding_AssignedSkillsInformationTooltip: Onboarding_AssignedSkillsInformationTooltip$1,
    Onboarding_AssignedSkillsWarning: Onboarding_AssignedSkillsWarning$1,
    Onboarding_BackupEmailAddressDesc: Onboarding_BackupEmailAddressDesc$1,
    Onboarding_ExperienceDatePresent: Onboarding_ExperienceDatePresent$1,
    Onboarding_ExperienceDateYears: Onboarding_ExperienceDateYears$1,
    Onboarding_ExportLinkedInResume: Onboarding_ExportLinkedInResume$1,
    Onboarding_ExportLinkedInResumeInstructions: Onboarding_ExportLinkedInResumeInstructions$1,
    Onboarding_FocusSkillTooltip: Onboarding_FocusSkillTooltip$1,
    Onboarding_FoundExperienceHeader: Onboarding_FoundExperienceHeader$1,
    Onboarding_LearnFromAnySource: Onboarding_LearnFromAnySource$1,
    Onboarding_LearnInstructions: Onboarding_LearnInstructions$1,
    Onboarding_LinkedInLink: Onboarding_LinkedInLink$1,
    Onboarding_LoadMore: Onboarding_LoadMore$1,
    Onboarding_ProfileSkill: Onboarding_ProfileSkill$1,
    Onboarding_ProgressInstructions: Onboarding_ProgressInstructions$1,
    Onboarding_ProgressInYourSkills: Onboarding_ProgressInYourSkills$1,
    Onboarding_RatingOverflowImgAlt: Onboarding_RatingOverflowImgAlt$1,
    Onboarding_RatingOverflowInstructions: Onboarding_RatingOverflowInstructions$1,
    Onboarding_RatingOverflowTitle: Onboarding_RatingOverflowTitle$1,
    Onboarding_ResetTipsBody: Onboarding_ResetTipsBody$1,
    Onboarding_ResetTipsHeader: Onboarding_ResetTipsHeader$1,
    Onboarding_ResumeAdditionalSkills: Onboarding_ResumeAdditionalSkills$1,
    Onboarding_ResumeLastModifiedDateMessage: Onboarding_ResumeLastModifiedDateMessage$1,
    Onboarding_ResumeReviewPageDescription: Onboarding_ResumeReviewPageDescription$1,
    Onboarding_ResumeReviewTitle: Onboarding_ResumeReviewTitle$1,
    Onboarding_ResumeSkill: Onboarding_ResumeSkill$1,
    Onboarding_ReviewExperienceDescription: Onboarding_ReviewExperienceDescription$1,
    Onboarding_ReviewOptionalSkillsDescription: Onboarding_ReviewOptionalSkillsDescription$1,
    Onboarding_ReviewOptionalSkillsHeader: Onboarding_ReviewOptionalSkillsHeader$1,
    Onboarding_ReviewSkills_Description: Onboarding_ReviewSkills_Description$1,
    Onboarding_ReviewSkills_Description_Empty: Onboarding_ReviewSkills_Description_Empty$1,
    Onboarding_ReviewSkillsDescription: Onboarding_ReviewSkillsDescription$1,
    Onboarding_ReviewSkillsHeader: Onboarding_ReviewSkillsHeader$1,
    Onboarding_RoleSkill: Onboarding_RoleSkill$1,
    Onboarding_RolesStepDescription: Onboarding_RolesStepDescription$1,
    Onboarding_RolesStepTitle: Onboarding_RolesStepTitle$1,
    Onboarding_SavingError: Onboarding_SavingError$1,
    Onboarding_SearchRoles_NoRoleAssigned: Onboarding_SearchRoles_NoRoleAssigned$1,
    Onboarding_SearchRoles_SearchForRole: Onboarding_SearchRoles_SearchForRole$1,
    Onboarding_SearchRoles_VisitIntegration: Onboarding_SearchRoles_VisitIntegration$1,
    Onboarding_SearchSkills_AddSkills: Onboarding_SearchSkills_AddSkills$1,
    Onboarding_SearchSkills_SearchForSkills: Onboarding_SearchSkills_SearchForSkills$1,
    Onboarding_SearchSkills_SuggestionsHeading: Onboarding_SearchSkills_SuggestionsHeading$1,
    Onboarding_SearchSkills_TopSkills: Onboarding_SearchSkills_TopSkills$1,
    Onboarding_SecondaryEmailDesc: Onboarding_SecondaryEmailDesc$1,
    Onboarding_SectionTitle: Onboarding_SectionTitle$1,
    "Onboarding_See MyProfile": "See My Profile",
    Onboarding_SeeSuggestedSkills: Onboarding_SeeSuggestedSkills$1,
    Onboarding_SkillSelectionRequiredTooltip: Onboarding_SkillSelectionRequiredTooltip$1,
    Onboarding_Step1CategoriesImgAlt: Onboarding_Step1CategoriesImgAlt$1,
    Onboarding_Step1IdeasImgAlt: Onboarding_Step1IdeasImgAlt$1,
    Onboarding_Step1Title: Onboarding_Step1Title$1,
    Onboarding_Step2Instructions: Onboarding_Step2Instructions$1,
    Onboarding_Step2InstructionsIntegration: Onboarding_Step2InstructionsIntegration$1,
    Onboarding_Step2InstructionsSkillInventory: Onboarding_Step2InstructionsSkillInventory$1,
    Onboarding_Step2Title: Onboarding_Step2Title$1,
    Onboarding_Step2TitleIntegration: Onboarding_Step2TitleIntegration$1,
    Onboarding_Step3Instructions: Onboarding_Step3Instructions$1,
    Onboarding_Step3InstructionsSkillInventory: Onboarding_Step3InstructionsSkillInventory$1,
    Onboarding_Step3Title: Onboarding_Step3Title$1,
    Onboarding_Step3TitleSkillInventory: Onboarding_Step3TitleSkillInventory$1,
    Onboarding_Step4Instructions: Onboarding_Step4Instructions$1,
    Onboarding_Step4InstructionsSkillInventory: Onboarding_Step4InstructionsSkillInventory$1,
    Onboarding_Step4Title: Onboarding_Step4Title$1,
    Onboarding_Step5Instructions: Onboarding_Step5Instructions$1,
    Onboarding_Step5Title: Onboarding_Step5Title$1,
    Onboarding_StepParse: Onboarding_StepParse$1,
    Onboarding_StepResults: Onboarding_StepResults$1,
    Onboarding_StepUpload: Onboarding_StepUpload$1,
    Onboarding_SuggestedSkill: Onboarding_SuggestedSkill$1,
    Onboarding_TrackYourSkills: Onboarding_TrackYourSkills$1,
    Onboarding_TrackYourSkillsInstructions: Onboarding_TrackYourSkillsInstructions$1,
    Onboarding_UploadResume: Onboarding_UploadResume$1,
    Onboarding_UploadResumeDescription: Onboarding_UploadResumeDescription$1,
    Onboarding_UploadResumeDescriptionTemp: Onboarding_UploadResumeDescriptionTemp$1,
    Onboarding_UploadResumeHeader: Onboarding_UploadResumeHeader$1,
    Onboarding_UploadResumeHeaderTemp: Onboarding_UploadResumeHeaderTemp$1,
    Onboarding_Welcome: Onboarding_Welcome$1,
    Onboarding_WelcomeDetails: Onboarding_WelcomeDetails$1,
    Onboarding_WelcomeHeading: Onboarding_WelcomeHeading$1,
    Onboarding_WelcomeInstructions: Onboarding_WelcomeInstructions$1,
    Onboarding_WelcomeMountainIllustration: Onboarding_WelcomeMountainIllustration$1,
    Onboarding_WelcomeTitle: Onboarding_WelcomeTitle$1,
    OnboardingController_PageTitle: OnboardingController_PageTitle$1,
    NotificationsCtrl_YouHaveRequiredLearningPluralFormat: NotificationsCtrl_YouHaveRequiredLearningPluralFormat$1,
    NotificationsCtrl_YouHaveRequiredLearningSingular: NotificationsCtrl_YouHaveRequiredLearningSingular$1,
    NotificationManager_SocialConnectionJoinedFormat: NotificationManager_SocialConnectionJoinedFormat$1,
    NotificationManager_UnsubscribeFormat: NotificationManager_UnsubscribeFormat$1,
    NotificationFeedCtrl_NotificationCountFormat: NotificationFeedCtrl_NotificationCountFormat$1,
    Notification_AutomationNotification: Notification_AutomationNotification$1,
    Notification_CompleteViewedItemsStepArticle: Notification_CompleteViewedItemsStepArticle$1,
    Notification_CompleteViewedItemsStepArticleItem1: Notification_CompleteViewedItemsStepArticleItem1$1,
    Notification_CompleteViewedItemsStepArticleItem2: Notification_CompleteViewedItemsStepArticleItem2$1,
    Notification_CompleteViewedItemsStepEpisode: Notification_CompleteViewedItemsStepEpisode$1,
    Notification_CompleteViewedItemsStepEpisodeItem1: Notification_CompleteViewedItemsStepEpisodeItem1$1,
    Notification_CompleteViewedItemsStepEpisodeItem2: Notification_CompleteViewedItemsStepEpisodeItem2$1,
    Notification_CompleteViewedItemsStepFirstFormat: Notification_CompleteViewedItemsStepFirstFormat$1,
    Notification_CompleteViewedItemsStepFirstFormatItem1: Notification_CompleteViewedItemsStepFirstFormatItem1$1,
    Notification_CompleteViewedItemsStepFirstFormatItem2: Notification_CompleteViewedItemsStepFirstFormatItem2$1,
    Notification_CompleteViewedItemsStepFirstSingular: Notification_CompleteViewedItemsStepFirstSingular$1,
    Notification_CompleteViewedItemsStepFirstSingularItem1: Notification_CompleteViewedItemsStepFirstSingularItem1$1,
    Notification_CompleteViewedItemsStepFirstSingularItem2: Notification_CompleteViewedItemsStepFirstSingularItem2$1,
    Notification_CompleteViewedItemsStepPost: Notification_CompleteViewedItemsStepPost$1,
    Notification_CompleteViewedItemsStepThanksFormat: Notification_CompleteViewedItemsStepThanksFormat$1,
    Notification_CompleteViewedItemsStepVideo: Notification_CompleteViewedItemsStepVideo$1,
    Notification_CompleteViewedItemsStepVideoItem1: Notification_CompleteViewedItemsStepVideoItem1$1,
    Notification_CompleteViewedItemsStepVideoItem2: Notification_CompleteViewedItemsStepVideoItem2$1,
    Notification_EnableDailyEmailStep1: Notification_EnableDailyEmailStep1$1,
    Notification_EnableDailyEmailStep1Item1: Notification_EnableDailyEmailStep1Item1$1,
    Notification_EnableDailyEmailStep1Item2: Notification_EnableDailyEmailStep1Item2$1,
    Notification_EnableDailyEmailStep2: Notification_EnableDailyEmailStep2$1,
    Notification_EnableDailyEmailStep2Item1: Notification_EnableDailyEmailStep2Item1$1,
    Notification_EnableDailyEmailStep2Item2: Notification_EnableDailyEmailStep2Item2$1,
    Notification_EnableDailyEmailStep3: Notification_EnableDailyEmailStep3$1,
    Notification_EnableDailyEmailStep3Item1: Notification_EnableDailyEmailStep3Item1$1,
    Notification_EnableDailyEmailStep3Item2: Notification_EnableDailyEmailStep3Item2$1,
    Notification_EnableDailyEmailStep4: Notification_EnableDailyEmailStep4$1,
    Notification_EnableDailyEmailStep5: Notification_EnableDailyEmailStep5$1,
    Notification_InstallNativeAppStep1: Notification_InstallNativeAppStep1$1,
    Notification_InstallNativeAppStep1Item1: Notification_InstallNativeAppStep1Item1$1,
    Notification_InstallNativeAppStep1Item2: Notification_InstallNativeAppStep1Item2$1,
    Notification_InstallNativeAppStep2: Notification_InstallNativeAppStep2$1,
    Notification_InstallNativeAppStep2Item1: Notification_InstallNativeAppStep2Item1$1,
    Notification_InstallNativeAppStep2Item2: Notification_InstallNativeAppStep2Item2$1,
    Notification_InstallNativeAppStep3: Notification_InstallNativeAppStep3$1,
    Notification_InstallNativeAppStep3Item1: Notification_InstallNativeAppStep3Item1$1,
    Notification_InstallNativeAppStep3Item2: Notification_InstallNativeAppStep3Item2$1,
    Notification_InstallNativeAppStep3Item3: Notification_InstallNativeAppStep3Item3$1,
    Notification_MultipleAssessmentsFoundAddSkills: Notification_MultipleAssessmentsFoundAddSkills$1,
    Notification_MultipleAssessmentsFoundReviewSkills: Notification_MultipleAssessmentsFoundReviewSkills$1,
    Notification_NewSkillsProviderAdded: Notification_NewSkillsProviderAdded$1,
    Notification_PathwayContentCompletionReminder: Notification_PathwayContentCompletionReminder$1,
    Notification_PrimaryTargetSetStepMainFormat: Notification_PrimaryTargetSetStepMainFormat$1,
    Notification_PrimaryTargetSetStepMainFormatItem1: Notification_PrimaryTargetSetStepMainFormatItem1$1,
    Notification_RecommendedBulkGeneric_NotificationTitleFormat: Notification_RecommendedBulkGeneric_NotificationTitleFormat$1,
    Notification_RecommendedSkills_NotificationTitleFormat: Notification_RecommendedSkills_NotificationTitleFormat$1,
    Notification_ReviewItems: Notification_ReviewItems$1,
    Notification_SingleAssessmentFoundAddSkill: Notification_SingleAssessmentFoundAddSkill$1,
    Notification_SingleAssessmentFoundReviewSkill: Notification_SingleAssessmentFoundReviewSkill$1,
    Notification_SkillMatched: Notification_SkillMatched$1,
    Notification_SkillsAddedToProfileFromJobRole_Plural: Notification_SkillsAddedToProfileFromJobRole_Plural$1,
    Notification_SkillsAddedToProfileFromJobRole_Single: Notification_SkillsAddedToProfileFromJobRole_Single$1,
    Notification_TitleFormat_OpportunityClosed: Notification_TitleFormat_OpportunityClosed$1,
    Notification_TitleFormat_OpportunityInterested: Notification_TitleFormat_OpportunityInterested$1,
    Notification_TrackYourLearningStep1: Notification_TrackYourLearningStep1$1,
    Notification_TrackYourLearningStep1Item1: Notification_TrackYourLearningStep1Item1$1,
    Notification_TrackYourLearningStep1Item2: Notification_TrackYourLearningStep1Item2$1,
    Notification_TrackYourLearningStep2: Notification_TrackYourLearningStep2$1,
    Notification_TrackYourLearningStep2Item1: Notification_TrackYourLearningStep2Item1$1,
    Notification_TrackYourLearningStep2Item2: Notification_TrackYourLearningStep2Item2$1,
    Notification_TrackYourLearningStep3: Notification_TrackYourLearningStep3$1,
    Notification_TrackYourLearningStep3Item1: Notification_TrackYourLearningStep3Item1$1,
    Notification_TrackYourLearningStep3Item2: Notification_TrackYourLearningStep3Item2$1,
    Notification_TrackYourLearningStep4: Notification_TrackYourLearningStep4$1,
    Notification_TrackYourLearningStep4Item1: Notification_TrackYourLearningStep4Item1$1,
    Notification_TrackYourLearningStep4Item2: Notification_TrackYourLearningStep4Item2$1,
    Notification_TrackYourLearningStep5: Notification_TrackYourLearningStep5$1,
    Notification_TrackYourLearningStep5Item1: Notification_TrackYourLearningStep5Item1$1,
    Notification_TrackYourLearningStep5Item2: Notification_TrackYourLearningStep5Item2$1,
    Notification_TrackYourLearningStep6: Notification_TrackYourLearningStep6$1,
    Notification_TrackYourLearningStep7: Notification_TrackYourLearningStep7$1,
    Notification_UpdateUserTagRatingsOnProfileStep1: Notification_UpdateUserTagRatingsOnProfileStep1$1,
    Notification_UpdateUserTagRatingsOnProfileStep1Item1: Notification_UpdateUserTagRatingsOnProfileStep1Item1$1,
    Notification_UpdateUserTagRatingsOnProfileStep1Item2: Notification_UpdateUserTagRatingsOnProfileStep1Item2$1,
    Notification_UpdateUserTagRatingsOnProfileStep2: Notification_UpdateUserTagRatingsOnProfileStep2$1,
    Notification_UpdateUserTagRatingsOnProfileStep2Item1: Notification_UpdateUserTagRatingsOnProfileStep2Item1$1,
    Notification_UpdateUserTagRatingsStep1: Notification_UpdateUserTagRatingsStep1$1,
    Notification_UpdateUserTagRatingsStep1Item1: Notification_UpdateUserTagRatingsStep1Item1$1,
    Notification_UpdateUserTagRatingsStep1Item2: Notification_UpdateUserTagRatingsStep1Item2$1,
    Notification_UpdateUserTagsStep1: Notification_UpdateUserTagsStep1$1,
    Notification_UpdateUserTagsStep1Item1: Notification_UpdateUserTagsStep1Item1$1,
    Notification_UpdateUserTagsStep1Item2: Notification_UpdateUserTagsStep1Item2$1,
    Notification_UpdateUserTagsStep2: Notification_UpdateUserTagsStep2$1,
    Notification_UpdateUserTagsStep2Item1: Notification_UpdateUserTagsStep2Item1$1,
    Notification_UpdateUserTagsStep3: Notification_UpdateUserTagsStep3$1,
    Notification_UserTagSetGoal_NotificationTitleFormat: Notification_UserTagSetGoal_NotificationTitleFormat$1,
    Notification_ViewOnProfile: Notification_ViewOnProfile$1,
    NotificationSvc_Notifications: NotificationSvc_Notifications$1,
    newUserFollower_PluralFormat: newUserFollower_PluralFormat$1,
    newUserFollower_SingleFormat: newUserFollower_SingleFormat$1,
    newTargetResource_Description: newTargetResource_Description$1,
    newTargetAuthor_DescriptionFormat: newTargetAuthor_DescriptionFormat$1,
    newPathwayAuthor_DescriptionFormat: newPathwayAuthor_DescriptionFormat$1,
    NavigationSvc_LearnTitle: NavigationSvc_LearnTitle$1,
    NavigationSvc_MainMenu: NavigationSvc_MainMenu$1,
    NavigationSvc_TodayTitle: NavigationSvc_TodayTitle$1,
    NativeInviteBanner_AppTagline: NativeInviteBanner_AppTagline$1,
    NativeInviteBanner_AppTitle: NativeInviteBanner_AppTitle$1,
    NativeInviteBanner_GetOnAppStore: NativeInviteBanner_GetOnAppStore$1,
    NativeInviteBanner_GetOnPlayStore: NativeInviteBanner_GetOnPlayStore$1,
    NativeInviteBanner_Open: NativeInviteBanner_Open$1,
    NativeInviteBanner_OpenInApp: NativeInviteBanner_OpenInApp$1,
    NativeInviteBanner_RedirectTitle: NativeInviteBanner_RedirectTitle$1,
    MsTeams_AboutAppTitle: MsTeams_AboutAppTitle$1,
    MsTeams_AccountNotAssociated: MsTeams_AccountNotAssociated$1,
    MsTeams_AddToCalendarButton: MsTeams_AddToCalendarButton$1,
    MsTeams_AddToCalendarSuccess: MsTeams_AddToCalendarSuccess$1,
    MsTeams_AddToCalendarTitle: MsTeams_AddToCalendarTitle$1,
    MsTeams_BotCapabilitiesTitle: MsTeams_BotCapabilitiesTitle$1,
    MsTeams_ChatErrorResponse: MsTeams_ChatErrorResponse$1,
    MsTeams_CommandsTitle: MsTeams_CommandsTitle$1,
    MsTeams_DegreedBotDescription: MsTeams_DegreedBotDescription$1,
    MsTeams_DegreedBotLongDescription: MsTeams_DegreedBotLongDescription$1,
    MsTeams_DegreedBotShortDescription: MsTeams_DegreedBotShortDescription$1,
    MsTeams_DegreedLongDescription: MsTeams_DegreedLongDescription$1,
    MsTeams_DegreedShortDescription: MsTeams_DegreedShortDescription$1,
    MsTeams_FeaturedPageDescription: MsTeams_FeaturedPageDescription$1,
    MsTeams_FeaturedPageLink: MsTeams_FeaturedPageLink$1,
    MsTeams_FeaturedPageTitle: MsTeams_FeaturedPageTitle$1,
    MsTeams_HelpDescription: MsTeams_HelpDescription$1,
    MsTeams_InstallationSuccess: MsTeams_InstallationSuccess$1,
    MsTeams_InstallationSuccessTitle: MsTeams_InstallationSuccessTitle$1,
    MsTeams_LeavingAppMessaging: MsTeams_LeavingAppMessaging$1,
    MsTeams_LoginWithDegreedBtn: MsTeams_LoginWithDegreedBtn$1,
    MsTeams_NoDegreedAccount: MsTeams_NoDegreedAccount$1,
    MsTeams_NoDegreedAccountSubtitle: MsTeams_NoDegreedAccountSubtitle$1,
    MsTeams_NoNotifications: MsTeams_NoNotifications$1,
    MsTeams_NotificationAssignedDescription: MsTeams_NotificationAssignedDescription$1,
    MsTeams_NotificationOpportunityDescription: MsTeams_NotificationOpportunityDescription$1,
    MsTeams_NotificationPersonFollowedDescription: MsTeams_NotificationPersonFollowedDescription$1,
    MsTeams_NotificationSharedDescription: MsTeams_NotificationSharedDescription$1,
    MsTeams_NoUnreadNotifications: MsTeams_NoUnreadNotifications$1,
    MsTeams_OnboardingAssignments: MsTeams_OnboardingAssignments$1,
    MsTeams_OnboardingPathways: MsTeams_OnboardingPathways$1,
    MsTeams_OnboardingPlans: MsTeams_OnboardingPlans$1,
    MsTeams_OnboardingSaved: MsTeams_OnboardingSaved$1,
    MsTeams_OnboardingShared: MsTeams_OnboardingShared$1,
    MsTeams_OnboardingStartTour: MsTeams_OnboardingStartTour$1,
    MsTeams_OnboardingTitle: MsTeams_OnboardingTitle$1,
    MsTeams_PleaseSignIn: MsTeams_PleaseSignIn$1,
    MsTeams_PopupBlockedAlertDescription: MsTeams_PopupBlockedAlertDescription$1,
    MsTeams_PopupBlockedAlertTitle: MsTeams_PopupBlockedAlertTitle$1,
    MsTeams_ShowAllNotifications: MsTeams_ShowAllNotifications$1,
    MsTeams_ShowUnread: MsTeams_ShowUnread$1,
    MsTeams_ShowUnreadNotifications: MsTeams_ShowUnreadNotifications$1,
    MsTeams_SignedInFailure: MsTeams_SignedInFailure$1,
    MsTeams_SignedInSuccess: MsTeams_SignedInSuccess$1,
    MsTeams_SignedOutSuccess: MsTeams_SignedOutSuccess$1,
    MsTeams_SignIn: MsTeams_SignIn$1,
    MsTeams_SignInRequired: MsTeams_SignInRequired$1,
    MsTeams_SignOut: MsTeams_SignOut$1,
    MsTeams_SignOutDescription: MsTeams_SignOutDescription$1,
    ModalSvc_AreYouSure: ModalSvc_AreYouSure$1,
    MentorshipNewRequest_NotificationTitleFormat: MentorshipNewRequest_NotificationTitleFormat$1,
    MentorshipFeedbackRequest_NotificationTitleFormat: MentorshipFeedbackRequest_NotificationTitleFormat$1,
    MentorshipFeedbackReceived_NotificationTitleFormat: MentorshipFeedbackReceived_NotificationTitleFormat$1,
    MentorshipDeclinedRequest_NotificationTitleFormat: MentorshipDeclinedRequest_NotificationTitleFormat$1,
    MentorshipCompleted_NotificationTitleFormat: MentorshipCompleted_NotificationTitleFormat$1,
    MentorshipAcceptedRequest_NotificationTitleFormat: MentorshipAcceptedRequest_NotificationTitleFormat$1,
    Mentoring_FeedbackGiven: Mentoring_FeedbackGiven$1,
    Mentoring_FeedbackReceived: Mentoring_FeedbackReceived$1,
    Mentoring_GiveFeedback: Mentoring_GiveFeedback$1,
    Mentoring_GiveFeedback_FeedbackShared: Mentoring_GiveFeedback_FeedbackShared$1,
    Mentoring_GiveFeedback_MenteeActionButton: Mentoring_GiveFeedback_MenteeActionButton$1,
    Mentoring_GiveFeedback_MenteeSubNote: Mentoring_GiveFeedback_MenteeSubNote$1,
    Mentoring_GiveFeedback_MentorSubNote: Mentoring_GiveFeedback_MentorSubNote$1,
    Mentoring_PeerRating: Mentoring_PeerRating$1,
    Mentoring_PeerRating_MenteeSubNote: Mentoring_PeerRating_MenteeSubNote$1,
    Mentoring_PeerRating_MentorSubNote: Mentoring_PeerRating_MentorSubNote$1,
    Mentoring_PeerRating_Requested: Mentoring_PeerRating_Requested$1,
    Mentoring_PeerRatingRequest: Mentoring_PeerRatingRequest$1,
    Mentoring_PeerRatingRequest_Placeholder: Mentoring_PeerRatingRequest_Placeholder$1,
    Mentoring_PlaceholderShareMessage: Mentoring_PlaceholderShareMessage$1,
    Mentoring_RequestFeedback: Mentoring_RequestFeedback$1,
    Mentoring_RequestFeedback_MenteeSubNote: Mentoring_RequestFeedback_MenteeSubNote$1,
    Mentoring_RequestFeedback_MentorSubNote: Mentoring_RequestFeedback_MentorSubNote$1,
    Mentoring_RequestFeedback_Requested: Mentoring_RequestFeedback_Requested$1,
    Mentoring_ReviewMenteeship: Mentoring_ReviewMenteeship$1,
    Mentoring_ReviewMentorship: Mentoring_ReviewMentorship$1,
    Mentoring_ShareFeedback: Mentoring_ShareFeedback$1,
    mentionInComment_GroupPluralFormat: mentionInComment_GroupPluralFormat$1,
    mentionInComment_GroupSingleFormat: mentionInComment_GroupSingleFormat$1,
    mentionInComment_PluralFormat: mentionInComment_PluralFormat$1,
    mentionInComment_SingleFormat: mentionInComment_SingleFormat$1,
    MediaFormCtrl_AddArticle: MediaFormCtrl_AddArticle$1,
    MediaFormCtrl_AddedArticleSuccessFormat: MediaFormCtrl_AddedArticleSuccessFormat$1,
    MediaFormCtrl_AddGroups: MediaFormCtrl_AddGroups$1,
    MediaFormCtrl_AddingGroupsInfo: MediaFormCtrl_AddingGroupsInfo$1,
    MediaFormCtrl_AddPost: MediaFormCtrl_AddPost$1,
    MediaFormCtrl_AddToCatalogFormat: MediaFormCtrl_AddToCatalogFormat$1,
    MediaFormCtrl_AddVideo: MediaFormCtrl_AddVideo$1,
    MediaFormCtrl_AddVideoToCatalogFormat: MediaFormCtrl_AddVideoToCatalogFormat$1,
    MediaFormCtrl_ArticleUrl: MediaFormCtrl_ArticleUrl$1,
    MediaFormCtrl_Category: MediaFormCtrl_Category$1,
    MediaFormCtrl_EditArticle: MediaFormCtrl_EditArticle$1,
    MediaFormCtrl_EditPost: MediaFormCtrl_EditPost$1,
    MediaFormCtrl_EditVideo: MediaFormCtrl_EditVideo$1,
    MediaFormCtrl_ErrorUnaccessibleArticle: MediaFormCtrl_ErrorUnaccessibleArticle$1,
    MediaFormCtrl_ErrorUnaccessiblePost: MediaFormCtrl_ErrorUnaccessiblePost$1,
    MediaFormCtrl_ErrorUnaccessibleVideo: MediaFormCtrl_ErrorUnaccessibleVideo$1,
    MediaFormCtrl_ICreatedVideo: MediaFormCtrl_ICreatedVideo$1,
    MediaFormCtrl_IWroteArticle: MediaFormCtrl_IWroteArticle$1,
    MediaFormCtrl_IWrotePost: MediaFormCtrl_IWrotePost$1,
    MediaFormCtrl_NarratorFormat: MediaFormCtrl_NarratorFormat$1,
    MediaFormCtrl_NewContentOwner: MediaFormCtrl_NewContentOwner$1,
    MediaFormCtrl_Provider: MediaFormCtrl_Provider$1,
    MediaFormCtrl_SaveArticle: MediaFormCtrl_SaveArticle$1,
    MediaFormCtrl_SavePost: MediaFormCtrl_SavePost$1,
    MediaFormCtrl_SaveVideo: MediaFormCtrl_SaveVideo$1,
    MediaFormCtrl_SelectionRequired: MediaFormCtrl_SelectionRequired$1,
    MediaFormCtrl_Skills_Placeholder: MediaFormCtrl_Skills_Placeholder$1,
    MediaFormCtrl_Summary: MediaFormCtrl_Summary$1,
    MediaFormCtrl_Title: MediaFormCtrl_Title$1,
    MediaFormCtrl_Title_Placeholder: MediaFormCtrl_Title_Placeholder$1,
    MediaFormCtrl_TitleRequired: MediaFormCtrl_TitleRequired$1,
    MediaFormCtrl_UrlError: MediaFormCtrl_UrlError$1,
    MediaFormCtrl_UrlOrRecordingRequired: MediaFormCtrl_UrlOrRecordingRequired$1,
    MediaFormCtrl_UrlOrUploadRequired: MediaFormCtrl_UrlOrUploadRequired$1,
    MediaFormCtrl_UrlOrVideoUploadOrRecordingRequired: MediaFormCtrl_UrlOrVideoUploadOrRecordingRequired$1,
    MediaFormCtrl_UrlOrVideoUploadRequired: MediaFormCtrl_UrlOrVideoUploadRequired$1,
    MediaFormCtrl_UrlRequired: MediaFormCtrl_UrlRequired$1,
    MediaFormCtrl_ValidContentOwnerRequired: MediaFormCtrl_ValidContentOwnerRequired$1,
    MediaFormCtrl_ValidNumberLength: MediaFormCtrl_ValidNumberLength$1,
    MediaFormCtrl_VideoLength: MediaFormCtrl_VideoLength$1,
    MediaFormCtrl_VideoSuccessFormat: MediaFormCtrl_VideoSuccessFormat$1,
    MediaFormCtrl_VideoUrl: MediaFormCtrl_VideoUrl$1,
    MediaFormCtrl_WhatDidYouLearnLong: MediaFormCtrl_WhatDidYouLearnLong$1,
    MediaFormCtrl_WhatDidYouLearnShort: MediaFormCtrl_WhatDidYouLearnShort$1,
    MediaFormCtrl_WhatDidYouLearnVideoLong: MediaFormCtrl_WhatDidYouLearnVideoLong$1,
    Markdown_ContentLength: Markdown_ContentLength$1,
    Markdown_EditorHelperFormat: Markdown_EditorHelperFormat$1,
    Markdown_MarkdownLearnMore: Markdown_MarkdownLearnMore$1,
    Markdown_MarkdownSupported: Markdown_MarkdownSupported$1,
    Markdown_toolbarA11y_addImage: Markdown_toolbarA11y_addImage$1,
    Markdown_toolbarA11y_bold: Markdown_toolbarA11y_bold$1,
    Markdown_toolbarA11y_italic: Markdown_toolbarA11y_italic$1,
    Markdown_toolbarA11y_link: Markdown_toolbarA11y_link$1,
    Markdown_toolbarA11y_ol: Markdown_toolbarA11y_ol$1,
    Markdown_toolbarA11y_quote: Markdown_toolbarA11y_quote$1,
    Markdown_toolbarA11y_ul: Markdown_toolbarA11y_ul$1,
    Markdown_UploadErrorMessage: Markdown_UploadErrorMessage$1,
    loginForm_EmailLabel: loginForm_EmailLabel$1,
    loginForm_EmailStateTooltip: loginForm_EmailStateTooltip$1,
    loginForm_InvalidEmail: loginForm_InvalidEmail$1,
    loginForm_LoggingInAs: loginForm_LoggingInAs$1,
    loginForm_NoAccount: loginForm_NoAccount$1,
    loginForm_NoAccountCTA: loginForm_NoAccountCTA$1,
    loginForm_PasswordHelper: loginForm_PasswordHelper$1,
    loginForm_PasswordLabel: loginForm_PasswordLabel$1,
    loginForm_PasswordPlaceholder: loginForm_PasswordPlaceholder$1,
    loginForm_PasswordPromptNoSSO: loginForm_PasswordPromptNoSSO$1,
    loginForm_SignUpNow: loginForm_SignUpNow$1,
    loginForm_SsoMessage: loginForm_SsoMessage$1,
    loginForm_WelcomeBackTitle: loginForm_WelcomeBackTitle$1,
    loginForm_WelcomeTitle: loginForm_WelcomeTitle$1,
    LiveEvents_Hybrid: LiveEvents_Hybrid$1,
    LiveEvents_JoinSession: LiveEvents_JoinSession$1,
    LiveEvents_RegisteredCheckboxLabel: LiveEvents_RegisteredCheckboxLabel$1,
    LiveEvents_RegisteredCheckboxTooltip: LiveEvents_RegisteredCheckboxTooltip$1,
    LiveEvents_RegisteredLabel: LiveEvents_RegisteredLabel$1,
    LiveEvents_RegisterOnWebsiteFormat: LiveEvents_RegisterOnWebsiteFormat$1,
    LiveEvents_RegistrationInstructions: LiveEvents_RegistrationInstructions$1,
    LiveEvents_SessionsCardLabel: LiveEvents_SessionsCardLabel$1,
    likeGroupActivity_GoalAddedPluralFormat: likeGroupActivity_GoalAddedPluralFormat$1,
    likeGroupActivity_GoalAddedSingleFormat: likeGroupActivity_GoalAddedSingleFormat$1,
    likeGroupActivity_GoalRemovedPluralFormat: likeGroupActivity_GoalRemovedPluralFormat$1,
    likeGroupActivity_GoalRemovedSingleFormat: likeGroupActivity_GoalRemovedSingleFormat$1,
    likeGroupActivity_GoalUpdatedPluralFormat: likeGroupActivity_GoalUpdatedPluralFormat$1,
    likeGroupActivity_GoalUpdatedSingleFormat: likeGroupActivity_GoalUpdatedSingleFormat$1,
    likeGroupActivity_GroupAddedPluralFormat: likeGroupActivity_GroupAddedPluralFormat$1,
    likeGroupActivity_GroupAddedSingleFormat: likeGroupActivity_GroupAddedSingleFormat$1,
    likeGroupActivity_GroupPostPluralFormat: likeGroupActivity_GroupPostPluralFormat$1,
    likeGroupActivity_GroupPostSingleFormat: likeGroupActivity_GroupPostSingleFormat$1,
    likeGroupActivity_GroupUpdatedPluralFormat: likeGroupActivity_GroupUpdatedPluralFormat$1,
    likeGroupActivity_GroupUpdatedSingleFormat: likeGroupActivity_GroupUpdatedSingleFormat$1,
    likeGroupActivity_InputRecommendedSingleFormat: likeGroupActivity_InputRecommendedSingleFormat$1,
    likeGroupActivity_UserAddedPluralFormat: likeGroupActivity_UserAddedPluralFormat$1,
    likeGroupActivity_UserAddedSingleFormat: likeGroupActivity_UserAddedSingleFormat$1,
    likeGroupActivity_UserInputPluralFormat: likeGroupActivity_UserInputPluralFormat$1,
    likeGroupActivity_UserInputSingleFormat: likeGroupActivity_UserInputSingleFormat$1,
    likeComment_PluralFormat: likeComment_PluralFormat$1,
    likeComment_PluralGroupFormat: likeComment_PluralGroupFormat$1,
    likeComment_SingleFormat: likeComment_SingleFormat$1,
    likeComment_SingleGroupFormat: likeComment_SingleGroupFormat$1,
    LearningSearch_ActiveSubscription: LearningSearch_ActiveSubscription$1,
    LearningSearch_BackToSearch: LearningSearch_BackToSearch$1,
    LearningSearch_Careers: LearningSearch_Careers$1,
    LearningSearch_Clear: LearningSearch_Clear$1,
    LearningSearch_ClearFilters: LearningSearch_ClearFilters$1,
    LearningSearch_ClosedGroup: LearningSearch_ClosedGroup$1,
    LearningSearch_CompletedAllFormat: LearningSearch_CompletedAllFormat$1,
    LearningSearch_Content: LearningSearch_Content$1,
    LearningSearch_DefaultSearchTerm: LearningSearch_DefaultSearchTerm$1,
    LearningSearch_DidYouMean: LearningSearch_DidYouMean$1,
    LearningSearch_Directories: LearningSearch_Directories$1,
    LearningSearch_ErrorContactSupport: LearningSearch_ErrorContactSupport$1,
    LearningSearch_ErrorDescription: LearningSearch_ErrorDescription$1,
    LearningSearch_ErrorTitle: LearningSearch_ErrorTitle$1,
    LearningSearch_ErrorTitleSideBar: LearningSearch_ErrorTitleSideBar$1,
    LearningSearch_FilterApplied: LearningSearch_FilterApplied$1,
    LearningSearch_FiltersApplied: LearningSearch_FiltersApplied$1,
    LearningSearch_GoToMarketplace: LearningSearch_GoToMarketplace$1,
    LearningSearch_GoToSearch: LearningSearch_GoToSearch$1,
    LearningSearch_Groups: LearningSearch_Groups$1,
    LearningSearch_GroupsLandingSearchInput: LearningSearch_GroupsLandingSearchInput$1,
    LearningSearch_Hmm: LearningSearch_Hmm$1,
    LearningSearch_JobRoles: LearningSearch_JobRoles$1,
    LearningSearch_Learning: LearningSearch_Learning$1,
    LearningSearch_LoadMoreEndorsed: LearningSearch_LoadMoreEndorsed$1,
    LearningSearch_LookingFor: LearningSearch_LookingFor$1,
    LearningSearch_More: LearningSearch_More$1,
    LearningSearch_MoreFilters: LearningSearch_MoreFilters$1,
    LearningSearch_MoreFormat: LearningSearch_MoreFormat$1,
    LearningSearch_MostPopular: LearningSearch_MostPopular$1,
    LearningSearch_MostRecent: LearningSearch_MostRecent$1,
    LearningSearch_MostRelevant: LearningSearch_MostRelevant$1,
    LearningSearch_NoResultsFound: LearningSearch_NoResultsFound$1,
    LearningSearch_NoResultsFoundAdvice: LearningSearch_NoResultsFoundAdvice$1,
    LearningSearch_NoResultsFoundMsg: LearningSearch_NoResultsFoundMsg$1,
    LearningSearch_NoResultsFoundTitle: LearningSearch_NoResultsFoundTitle$1,
    LearningSearch_NoSidebarFormat: LearningSearch_NoSidebarFormat$1,
    LearningSearch_OpenGroup: LearningSearch_OpenGroup$1,
    LearningSearch_OpportunitiesTitle: LearningSearch_OpportunitiesTitle$1,
    LearningSearch_OppsLandingSearchInput: LearningSearch_OppsLandingSearchInput$1,
    LearningSearch_OppsSidebarTooltip: LearningSearch_OppsSidebarTooltip$1,
    LearningSearch_Pathways: LearningSearch_Pathways$1,
    LearningSearch_PathwaysAndPlans: LearningSearch_PathwaysAndPlans$1,
    LearningSearch_People: LearningSearch_People$1,
    LearningSearch_PeopleAndGroups: LearningSearch_PeopleAndGroups$1,
    LearningSearch_PeopleLandingSearchInput: LearningSearch_PeopleLandingSearchInput$1,
    LearningSearch_Popular: LearningSearch_Popular$1,
    LearningSearch_ProviderNoResultsFoundAdvice: LearningSearch_ProviderNoResultsFoundAdvice$1,
    LearningSearch_ProviderNotPartOfCatalog: LearningSearch_ProviderNotPartOfCatalog$1,
    LearningSearch_QA: LearningSearch_QA$1,
    LearningSearch_RangeCount: LearningSearch_RangeCount$1,
    LearningSearch_RangeCountPlus: LearningSearch_RangeCountPlus$1,
    LearningSearch_Recent: LearningSearch_Recent$1,
    LearningSearch_Relevant: LearningSearch_Relevant$1,
    LearningSearch_RemoveFiltersAdvice: LearningSearch_RemoveFiltersAdvice$1,
    LearningSearch_ResetFiltersAdvice: LearningSearch_ResetFiltersAdvice$1,
    LearningSearch_ResetFiltersMsg: LearningSearch_ResetFiltersMsg$1,
    LearningSearch_ResultsCount: LearningSearch_ResultsCount$1,
    LearningSearch_ResultsCount_PluralFormat: LearningSearch_ResultsCount_PluralFormat$1,
    LearningSearch_ResultsCount_SingleFormat: LearningSearch_ResultsCount_SingleFormat$1,
    LearningSearch_ResultSetRangeCount: LearningSearch_ResultSetRangeCount$1,
    LearningSearch_ResultSetRangeCountPlus: LearningSearch_ResultSetRangeCountPlus$1,
    LearningSearch_ResultsFor: LearningSearch_ResultsFor$1,
    LearningSearch_Roles: LearningSearch_Roles$1,
    LearningSearch_SearchedInsteadFor: LearningSearch_SearchedInsteadFor$1,
    LearningSearch_SearchError: LearningSearch_SearchError$1,
    LearningSearch_SearchFilters: LearningSearch_SearchFilters$1,
    LearningSearch_SearchFiltersDescription: LearningSearch_SearchFiltersDescription$1,
    LearningSearch_ShowFilters: LearningSearch_ShowFilters$1,
    LearningSearch_ShowingResultsFor: LearningSearch_ShowingResultsFor$1,
    LearningSearch_Skills: LearningSearch_Skills$1,
    LearningSearch_SkillsLandingSearchInput: LearningSearch_SkillsLandingSearchInput$1,
    LearningSearch_SkillsResults: LearningSearch_SkillsResults$1,
    LearningSearch_Subscription: LearningSearch_Subscription$1,
    LearningSearch_SuggestedSearches: LearningSearch_SuggestedSearches$1,
    LearningSearch_Title: LearningSearch_Title$1,
    LearningSearch_Top: LearningSearch_Top$1,
    LearningSearch_Trending: LearningSearch_Trending$1,
    LearningSearch_ViewAll: LearningSearch_ViewAll$1,
    LearningSearch_ViewMore: LearningSearch_ViewMore$1,
    LearningCtrl_ActiveSubscription: LearningCtrl_ActiveSubscription$1,
    LearningCtrl_DefaultSearchTerm: LearningCtrl_DefaultSearchTerm$1,
    LearningCtrl_SearchError: LearningCtrl_SearchError$1,
    LearningCtrl_Subscription: LearningCtrl_Subscription$1,
    LearningController_ActiveSubscription: LearningController_ActiveSubscription$1,
    LearningController_All: LearningController_All$1,
    LearningController_Content: LearningController_Content$1,
    LearningController_FeaturedContent: LearningController_FeaturedContent$1,
    LearningController_FeaturedCourseProviders: LearningController_FeaturedCourseProviders$1,
    LearningController_FeaturedPathways: LearningController_FeaturedPathways$1,
    LearningController_FindSomething: LearningController_FindSomething$1,
    LearningController_More: LearningController_More$1,
    LearningController_NoCategories: LearningController_NoCategories$1,
    LearningController_Pathways: LearningController_Pathways$1,
    LearningController_People: LearningController_People$1,
    LearningController_QA: LearningController_QA$1,
    LearningController_RefineResults: LearningController_RefineResults$1,
    LearningController_SuggestedPeopleToFollow: LearningController_SuggestedPeopleToFollow$1,
    LearningController_Top: LearningController_Top$1,
    LearningController_TopCategories: LearningController_TopCategories$1,
    LearningController_Type: LearningController_Type$1,
    LearningController_ViewAll: LearningController_ViewAll$1,
    LearningController_VisitSite: LearningController_VisitSite$1,
    LearningController_YourTopCategories: LearningController_YourTopCategories$1,
    LearningBrowse_FeaturedContent: LearningBrowse_FeaturedContent$1,
    LearningBrowse_FeaturedCourseProviders: LearningBrowse_FeaturedCourseProviders$1,
    LearningBrowse_FeaturedPathways: LearningBrowse_FeaturedPathways$1,
    LearningBrowse_FeaturedTargets: LearningBrowse_FeaturedTargets$1,
    LearningBrowse_NewContent: LearningBrowse_NewContent$1,
    LearningBrowse_SuggestedGroups: LearningBrowse_SuggestedGroups$1,
    LearningBrowse_SuggestedJobRoles: LearningBrowse_SuggestedJobRoles$1,
    LearningBrowse_SuggestedOpportunities: LearningBrowse_SuggestedOpportunities$1,
    LearningBrowse_SuggestedPeopleToFollow: LearningBrowse_SuggestedPeopleToFollow$1,
    LearnerHome_ActivityFrom: LearnerHome_ActivityFrom$1,
    LearnerHome_ActivityIn: LearnerHome_ActivityIn$1,
    LearnerHome_BasedOnYourSkills: LearnerHome_BasedOnYourSkills$1,
    LearnerHome_ConnectDesc: LearnerHome_ConnectDesc$1,
    LearnerHome_ConnectLearners: LearnerHome_ConnectLearners$1,
    LearnerHome_ConnectLearnersDesc: LearnerHome_ConnectLearnersDesc$1,
    LearnerHome_ConnectMentors: LearnerHome_ConnectMentors$1,
    LearnerHome_ConnectMentorsDesc: LearnerHome_ConnectMentorsDesc$1,
    LearnerHome_ConnectWithPeopleTitle: LearnerHome_ConnectWithPeopleTitle$1,
    LearnerHome_ContinueLearning: LearnerHome_ContinueLearning$1,
    LearnerHome_FindMentors: LearnerHome_FindMentors$1,
    LearnerHome_GroupViewMoreLink: LearnerHome_GroupViewMoreLink$1,
    LearnerHome_GroupViewMoreTitle: LearnerHome_GroupViewMoreTitle$1,
    LearnerHome_ItemsCompleted: LearnerHome_ItemsCompleted$1,
    LearnerHome_ItemsCompletedDesc: LearnerHome_ItemsCompletedDesc$1,
    LearnerHome_ItemsDelta: LearnerHome_ItemsDelta$1,
    LearnerHome_ItemsViewed: LearnerHome_ItemsViewed$1,
    LearnerHome_ItemsViewedDesc: LearnerHome_ItemsViewedDesc$1,
    LearnerHome_LearningBudget: LearnerHome_LearningBudget$1,
    LearnerHome_LearningDelta: LearnerHome_LearningDelta$1,
    LearnerHome_LearningTime: LearnerHome_LearningTime$1,
    LearnerHome_LearningTimeDesc: LearnerHome_LearningTimeDesc$1,
    LearnerHome_MentorConnect: LearnerHome_MentorConnect$1,
    LearnerHome_MentorshipExpertise: LearnerHome_MentorshipExpertise$1,
    LearnerHome_NoChanges: LearnerHome_NoChanges$1,
    LearnerHome_OpportunitiesViewMoreLink: LearnerHome_OpportunitiesViewMoreLink$1,
    LearnerHome_OpportunityViewMoreLink: LearnerHome_OpportunityViewMoreLink$1,
    LearnerHome_OpportunityViewMoreTitle: LearnerHome_OpportunityViewMoreTitle$1,
    LearnerHome_PeopleToFollow: LearnerHome_PeopleToFollow$1,
    LearnerHome_PeopleYouFollow: LearnerHome_PeopleYouFollow$1,
    LearnerHome_PointsDelta: LearnerHome_PointsDelta$1,
    LearnerHome_PointsEarned: LearnerHome_PointsEarned$1,
    LearnerHome_PointsEarnedDesc: LearnerHome_PointsEarnedDesc$1,
    LearnerHome_RecentActivity: LearnerHome_RecentActivity$1,
    LearnerHome_RecentlyViewed: LearnerHome_RecentlyViewed$1,
    LearnerHome_RequestMentorship: LearnerHome_RequestMentorship$1,
    LearnerHome_SearchPeople: LearnerHome_SearchPeople$1,
    LearnerHome_SkillExplore: LearnerHome_SkillExplore$1,
    LearnerHome_SkillsToFollow: LearnerHome_SkillsToFollow$1,
    LearnerHome_TrendingAtOrgSubtitle: LearnerHome_TrendingAtOrgSubtitle$1,
    LearnerHome_TrendingAtOrgTitle: LearnerHome_TrendingAtOrgTitle$1,
    LearnerHome_TrendingWithin: LearnerHome_TrendingWithin$1,
    LearnerHome_UseYourBudget: LearnerHome_UseYourBudget$1,
    LearnerHome_ViewMoreLink: LearnerHome_ViewMoreLink$1,
    LearnerHome_ViewMoreMentorsLink: LearnerHome_ViewMoreMentorsLink$1,
    LearnerHome_ViewMoreTitle: LearnerHome_ViewMoreTitle$1,
    LearnerHome_ViewMoreUserLink: LearnerHome_ViewMoreUserLink$1,
    LearnerHome_ViewMoreUserTitle: LearnerHome_ViewMoreUserTitle$1,
    LearnerHome_ViewYourBalance: LearnerHome_ViewYourBalance$1,
    LearnerHome_WelcomeSectionSubTitle: LearnerHome_WelcomeSectionSubTitle$1,
    LearnerHome_WelcomeSectionSubTitleShort: LearnerHome_WelcomeSectionSubTitleShort$1,
    LearnerHome_WelcomeSectionTitle: LearnerHome_WelcomeSectionTitle$1,
    KPI_AddedSkillsByOthersAverage: KPI_AddedSkillsByOthersAverage$1,
    KPI_AddedSkillsByOthersAverageToolTip: KPI_AddedSkillsByOthersAverageToolTip$1,
    KPI_AverageRating: KPI_AverageRating$1,
    KPI_AvgFormat: KPI_AvgFormat$1,
    KPI_DaysSinceLastRating: KPI_DaysSinceLastRating$1,
    KPI_DaysSinceLastRatingToolTip: KPI_DaysSinceLastRatingToolTip$1,
    KPI_Decrease: KPI_Decrease$1,
    KPI_Increase: KPI_Increase$1,
    KPI_JobRoleSkillCount: KPI_JobRoleSkillCount$1,
    KPI_JobRoleSkillCountToolTip: KPI_JobRoleSkillCountToolTip$1,
    KPI_NoChange: KPI_NoChange$1,
    KPI_NoJobRoleToolTip: KPI_NoJobRoleToolTip$1,
    KPI_NotApplicableToolTip: KPI_NotApplicableToolTip$1,
    KPI_OpportunityApplyName: KPI_OpportunityApplyName$1,
    KPI_OpportunityApplyTooltip: KPI_OpportunityApplyTooltip$1,
    KPI_OpportunityDaysOpenName: KPI_OpportunityDaysOpenName$1,
    KPI_OpportunityDaysOpenTooltip: KPI_OpportunityDaysOpenTooltip$1,
    KPI_OpportunityInterestedName: KPI_OpportunityInterestedName$1,
    KPI_OpportunityInterestedTooltip: KPI_OpportunityInterestedTooltip$1,
    KPI_OpportunitySelectedName: KPI_OpportunitySelectedName$1,
    KPI_OpportunitySelectedTooltip: KPI_OpportunitySelectedTooltip$1,
    KPI_OpportunityUniqueViewsName: KPI_OpportunityUniqueViewsName$1,
    KPI_OpportunityUniqueViewsTooltip: KPI_OpportunityUniqueViewsTooltip$1,
    KPI_OpportunityUsersName: KPI_OpportunityUsersName$1,
    KPI_OpportunityUsersTooltip: KPI_OpportunityUsersTooltip$1,
    KPI_OpportunityViewsName: KPI_OpportunityViewsName$1,
    KPI_OpportunityViewsTooltip: KPI_OpportunityViewsTooltip$1,
    KPI_OrgOpportunityActiveOpportunitiesName: KPI_OrgOpportunityActiveOpportunitiesName$1,
    KPI_OrgOpportunityActiveOpportunitiesTooltip: KPI_OrgOpportunityActiveOpportunitiesTooltip$1,
    KPI_OrgOpportunityApplicantsInOpportunitiesName: KPI_OrgOpportunityApplicantsInOpportunitiesName$1,
    KPI_OrgOpportunityApplicantsInOpportunitiesTooltip: KPI_OrgOpportunityApplicantsInOpportunitiesTooltip$1,
    KPI_OrgOpportunityOpportunitiesWithInterestName: KPI_OrgOpportunityOpportunitiesWithInterestName$1,
    KPI_OrgOpportunityOpportunitiesWithInterestTooltip: KPI_OrgOpportunityOpportunitiesWithInterestTooltip$1,
    KPI_OrgOpportunityOpportunityUniqueUserViewName: KPI_OrgOpportunityOpportunityUniqueUserViewName$1,
    KPI_OrgOpportunityOpportunityUniqueUserViewTooltip: KPI_OrgOpportunityOpportunityUniqueUserViewTooltip$1,
    KPI_OrgOpportunitySelectedCandidatesName: KPI_OrgOpportunitySelectedCandidatesName$1,
    KPI_OrgOpportunitySelectedCandidatesTooltip: KPI_OrgOpportunitySelectedCandidatesTooltip$1,
    KPI_OverTheLastXDays: KPI_OverTheLastXDays$1,
    KPI_OverTheLastXYears: KPI_OverTheLastXYears$1,
    KPI_OverTheLastYear: KPI_OverTheLastYear$1,
    KPI_PathwayCompletedName: KPI_PathwayCompletedName$1,
    KPI_PathwayCompletedTooltip: KPI_PathwayCompletedTooltip$1,
    KPI_PathwayEnrollName: KPI_PathwayEnrollName$1,
    KPI_PathwayEnrollTooltip: KPI_PathwayEnrollTooltip$1,
    KPI_PathwayViewsName: KPI_PathwayViewsName$1,
    KPI_PathwayViewsTooltip: KPI_PathwayViewsTooltip$1,
    KPI_PersonalSkillProgression_Empty: KPI_PersonalSkillProgression_Empty$1,
    KPI_RatedSkillsByOthersAverage: KPI_RatedSkillsByOthersAverage$1,
    KPI_RatedSkillsByOthersAverageToolTip: KPI_RatedSkillsByOthersAverageToolTip$1,
    KPI_SkillsAdded: KPI_SkillsAdded$1,
    KPI_SkillsAddedPast12: KPI_SkillsAddedPast12$1,
    KPI_SkillsAddedPast12ToolTip: KPI_SkillsAddedPast12ToolTip$1,
    KPI_SkillsAddedToolTip: KPI_SkillsAddedToolTip$1,
    KPI_SkillsRated: KPI_SkillsRated$1,
    KPI_SkillsRatedPast12: KPI_SkillsRatedPast12$1,
    KPI_SkillsRatedPast12ToolTip: KPI_SkillsRatedPast12ToolTip$1,
    KPI_SkillsRatedToolTip: KPI_SkillsRatedToolTip$1,
    KPI_TargetFollowersName: KPI_TargetFollowersName$1,
    KPI_TargetFollowersTooltip: KPI_TargetFollowersTooltip$1,
    KPI_TargetViewsName: KPI_TargetViewsName$1,
    KPI_TargetViewsTooltip: KPI_TargetViewsTooltip$1,
    InviteAddPeopleCtrl_FollowPersonFormat: InviteAddPeopleCtrl_FollowPersonFormat$1,
    InviteAddPeopleCtrl_FollowPersonsFormat: InviteAddPeopleCtrl_FollowPersonsFormat$1,
    InviteAddCategoriesCtrl_FollowCategoriesFormat: InviteAddCategoriesCtrl_FollowCategoriesFormat$1,
    InviteAddCategoriesCtrl_FollowCategoryFormat: InviteAddCategoriesCtrl_FollowCategoryFormat$1,
    IntegrationsSvc_AlisonDescription: IntegrationsSvc_AlisonDescription$1,
    IntegrationsSvc_AlisonLabelText: IntegrationsSvc_AlisonLabelText$1,
    IntegrationsSvc_AlisonPlaceholderText: IntegrationsSvc_AlisonPlaceholderText$1,
    IntegrationsSvc_AlisonUrl: IntegrationsSvc_AlisonUrl$1,
    IntegrationsSvc_AutoNotifyLabelFormat: IntegrationsSvc_AutoNotifyLabelFormat$1,
    IntegrationsSvc_CodecademyDescription: IntegrationsSvc_CodecademyDescription$1,
    IntegrationsSvc_CodecademyLabelText: IntegrationsSvc_CodecademyLabelText$1,
    IntegrationsSvc_CodecademyPlaceholderText: IntegrationsSvc_CodecademyPlaceholderText$1,
    IntegrationsSvc_CodecademyUrl: IntegrationsSvc_CodecademyUrl$1,
    IntegrationsSvc_CodeSchoolDescription: IntegrationsSvc_CodeSchoolDescription$1,
    IntegrationsSvc_CodeSchoolLabelText: IntegrationsSvc_CodeSchoolLabelText$1,
    IntegrationsSvc_CodeSchoolPlaceholderText: IntegrationsSvc_CodeSchoolPlaceholderText$1,
    IntegrationsSvc_CodeSchoolUrl: IntegrationsSvc_CodeSchoolUrl$1,
    IntegrationsSvc_Contacts: IntegrationsSvc_Contacts$1,
    IntegrationsSvc_Followers: IntegrationsSvc_Followers$1,
    IntegrationsSvc_Friends: IntegrationsSvc_Friends$1,
    IntegrationsSvc_GoodreadsDescription: IntegrationsSvc_GoodreadsDescription$1,
    IntegrationsSvc_GoodreadsLabelText: IntegrationsSvc_GoodreadsLabelText$1,
    IntegrationsSvc_GoodreadsPlaceholderText: IntegrationsSvc_GoodreadsPlaceholderText$1,
    IntegrationsSvc_GoogleplusFriends: IntegrationsSvc_GoogleplusFriends$1,
    IntegrationsSvc_KhanAcademyDescription: IntegrationsSvc_KhanAcademyDescription$1,
    IntegrationsSvc_KhanAcademyLabelText: IntegrationsSvc_KhanAcademyLabelText$1,
    IntegrationsSvc_KhanAcademyPlaceholderText: IntegrationsSvc_KhanAcademyPlaceholderText$1,
    IntegrationsSvc_NoFriendsDescription: IntegrationsSvc_NoFriendsDescription$1,
    IntegrationsSvc_NoGoogleplusFriendsHeader: IntegrationsSvc_NoGoogleplusFriendsHeader$1,
    IntegrationsSvc_PluralsightDescription: IntegrationsSvc_PluralsightDescription$1,
    IntegrationsSvc_PluralsightLabelText: IntegrationsSvc_PluralsightLabelText$1,
    IntegrationsSvc_PluralsightPlaceholderText: IntegrationsSvc_PluralsightPlaceholderText$1,
    IntegrationsSvc_PluralsightUrl: IntegrationsSvc_PluralsightUrl$1,
    IntegrationsSvc_PocketDescription: IntegrationsSvc_PocketDescription$1,
    IntegrationsSvc_PocketLabelText: IntegrationsSvc_PocketLabelText$1,
    IntegrationsSvc_PocketPlaceholderText: IntegrationsSvc_PocketPlaceholderText$1,
    IntegrationsSvc_SkillshareDescription: IntegrationsSvc_SkillshareDescription$1,
    IntegrationsSvc_SkillshareLabelText: IntegrationsSvc_SkillshareLabelText$1,
    IntegrationsSvc_SkillsharePlaceholderText: IntegrationsSvc_SkillsharePlaceholderText$1,
    IntegrationsSvc_SkillshareUrl: IntegrationsSvc_SkillshareUrl$1,
    IntegrationsSvc_SkillshareUrlext: IntegrationsSvc_SkillshareUrlext$1,
    IntegrationsSvc_SlackDescription: IntegrationsSvc_SlackDescription$1,
    IntegrationsSvc_TreehouseDescription: IntegrationsSvc_TreehouseDescription$1,
    IntegrationsSvc_TreehouseLabelText: IntegrationsSvc_TreehouseLabelText$1,
    IntegrationsSvc_TreehousePlaceholderText: IntegrationsSvc_TreehousePlaceholderText$1,
    IntegrationsSvc_TreehouseUrl: IntegrationsSvc_TreehouseUrl$1,
    IntegrationsSvc_UdemyDescription: IntegrationsSvc_UdemyDescription$1,
    IntegrationsSvc_UdemyLabelText: IntegrationsSvc_UdemyLabelText$1,
    IntegrationsSvc_UdemyPlaceholderText: IntegrationsSvc_UdemyPlaceholderText$1,
    IntegrationsSvc_UdemyUrl: IntegrationsSvc_UdemyUrl$1,
    IntegrationsSvc_ViewContacts: IntegrationsSvc_ViewContacts$1,
    IntegrationsSvc_ViewFollowers: IntegrationsSvc_ViewFollowers$1,
    IntegrationsSvc_ViewFriends: IntegrationsSvc_ViewFriends$1,
    Integrations_Add_Type_Completion: Integrations_Add_Type_Completion$1,
    Integrations_Add_Type_Content: Integrations_Add_Type_Content$1,
    Integrations_Add_Type_Skill: Integrations_Add_Type_Skill$1,
    Integrations_Add_Type_SkillAssessment: Integrations_Add_Type_SkillAssessment$1,
    Integrations_AdvancedSSO: Integrations_AdvancedSSO$1,
    Integrations_AlisonImportError: Integrations_AlisonImportError$1,
    Integrations_AlisonPublicProfile: Integrations_AlisonPublicProfile$1,
    Integrations_AlisonUserId: Integrations_AlisonUserId$1,
    Integrations_AlisonUserIdUserName: Integrations_AlisonUserIdUserName$1,
    Integrations_APIKeys: Integrations_APIKeys$1,
    Integrations_BasicSSO: Integrations_BasicSSO$1,
    Integrations_ClientId: Integrations_ClientId$1,
    Integrations_ClientSecret: Integrations_ClientSecret$1,
    Integrations_CodecademyImportError: Integrations_CodecademyImportError$1,
    Integrations_CodecademyPublicProfile: Integrations_CodecademyPublicProfile$1,
    Integrations_CodecademyUsername: Integrations_CodecademyUsername$1,
    Integrations_CodeSchoolImportError: Integrations_CodeSchoolImportError$1,
    Integrations_CodeSchoolPublicProfile: Integrations_CodeSchoolPublicProfile$1,
    Integrations_CodeSchoolUsername: Integrations_CodeSchoolUsername$1,
    Integrations_ConfigureConnector_CreateAPI: Integrations_ConfigureConnector_CreateAPI$1,
    Integrations_Connect: Integrations_Connect$1,
    Integrations_Connected: Integrations_Connected$1,
    Integrations_ConnectIntegrations: Integrations_ConnectIntegrations$1,
    Integrations_ConnectorSync_Type_Badge: Integrations_ConnectorSync_Type_Badge$1,
    Integrations_ConnectorSync_Type_BulkOpportunities: Integrations_ConnectorSync_Type_BulkOpportunities$1,
    Integrations_ConnectorSync_Type_Completion: Integrations_ConnectorSync_Type_Completion$1,
    Integrations_ConnectorSync_Type_Content: Integrations_ConnectorSync_Type_Content$1,
    Integrations_ConnectorSync_Type_Opportunity: Integrations_ConnectorSync_Type_Opportunity$1,
    Integrations_ConnectorSync_Type_RequiredLearning: Integrations_ConnectorSync_Type_RequiredLearning$1,
    Integrations_ConnectorSync_Type_Skill: Integrations_ConnectorSync_Type_Skill$1,
    Integrations_ConnectorSync_Type_SkillAssessment: Integrations_ConnectorSync_Type_SkillAssessment$1,
    Integrations_ConnectorSyncMustVerify: Integrations_ConnectorSyncMustVerify$1,
    Integrations_ConnectorSyncNightly: Integrations_ConnectorSyncNightly$1,
    Integrations_ConsumerSetup: Integrations_ConsumerSetup$1,
    Integrations_ConsumerSetupMetadata: Integrations_ConsumerSetupMetadata$1,
    Integrations_ContactYourCEP: Integrations_ContactYourCEP$1,
    Integrations_ContentProviders: Integrations_ContentProviders$1,
    Integrations_ContentRemain: Integrations_ContentRemain$1,
    Integrations_ContentSyncPendingMeta: Integrations_ContentSyncPendingMeta$1,
    Integrations_ContentVisibility: Integrations_ContentVisibility$1,
    Integrations_CourseraImportError: Integrations_CourseraImportError$1,
    Integrations_CourseraPublicProfile: Integrations_CourseraPublicProfile$1,
    Integrations_CourseraUserId: Integrations_CourseraUserId$1,
    Integrations_CustomVisitLink: Integrations_CustomVisitLink$1,
    Integrations_DeleteAnyAssociated: Integrations_DeleteAnyAssociated$1,
    Integrations_DeleteAnyContent: Integrations_DeleteAnyContent$1,
    Integrations_DeleteAnyIncomplete: Integrations_DeleteAnyIncomplete$1,
    Integrations_DISABLE: Integrations_DISABLE$1,
    Integrations_DisableConnector: Integrations_DisableConnector$1,
    Integrations_DisableProvider: Integrations_DisableProvider$1,
    Integrations_DisablingConnectorWill: Integrations_DisablingConnectorWill$1,
    Integrations_DisablingProviderWill: Integrations_DisablingProviderWill$1,
    Integrations_Disconnect: Integrations_Disconnect$1,
    Integrations_Edit_Type_Completion: Integrations_Edit_Type_Completion$1,
    Integrations_Edit_Type_Content: Integrations_Edit_Type_Content$1,
    Integrations_Edit_Type_Skill: Integrations_Edit_Type_Skill$1,
    Integrations_Edit_Type_SkillAssessment: Integrations_Edit_Type_SkillAssessment$1,
    Integrations_EditGoodreadsProfile: Integrations_EditGoodreadsProfile$1,
    Integrations_EmailAssertionName: Integrations_EmailAssertionName$1,
    Integrations_Enable: Integrations_Enable$1,
    Integrations_EnableSSO: Integrations_EnableSSO$1,
    Integrations_EnterpriseAccountId: Integrations_EnterpriseAccountId$1,
    Integrations_EnterpriseSetMetadata: Integrations_EnterpriseSetMetadata$1,
    Integrations_EnterpriseSetup: Integrations_EnterpriseSetup$1,
    Integrations_EnterpriseSetupMetadata: Integrations_EnterpriseSetupMetadata$1,
    Integrations_EverybodyCanSee: Integrations_EverybodyCanSee$1,
    Integrations_FailedImport: Integrations_FailedImport$1,
    Integrations_FallbackContentImage: Integrations_FallbackContentImage$1,
    Integrations_FilterIntegrations: Integrations_FilterIntegrations$1,
    Integrations_FirstNameAssertionName: Integrations_FirstNameAssertionName$1,
    Integrations_FreeOneClickSetup: Integrations_FreeOneClickSetup$1,
    Integrations_GenerateAPIKey: Integrations_GenerateAPIKey$1,
    Integrations_GenerateAPIKeyProvider: Integrations_GenerateAPIKeyProvider$1,
    Integrations_GlobalVisibility: Integrations_GlobalVisibility$1,
    Integrations_GoodreadsImportError: Integrations_GoodreadsImportError$1,
    Integrations_GoodreadsUsername: Integrations_GoodreadsUsername$1,
    Integrations_GoodreadsUsernameEdit: Integrations_GoodreadsUsernameEdit$1,
    Integrations_ImageForProviderCard: Integrations_ImageForProviderCard$1,
    Integrations_ImageForProviderFavicon: Integrations_ImageForProviderFavicon$1,
    Integrations_ImageForProviderLogo: Integrations_ImageForProviderLogo$1,
    Integrations_ImportAlisonCourses: Integrations_ImportAlisonCourses$1,
    Integrations_ImportAlisonDaily: Integrations_ImportAlisonDaily$1,
    Integrations_ImportArchivedPocket: Integrations_ImportArchivedPocket$1,
    Integrations_ImportCodecademyDaily: Integrations_ImportCodecademyDaily$1,
    Integrations_ImportCodeSchoolDaily: Integrations_ImportCodeSchoolDaily$1,
    Integrations_ImportCompletedCodecademy: Integrations_ImportCompletedCodecademy$1,
    Integrations_ImportCompletedCodeSchool: Integrations_ImportCompletedCodeSchool$1,
    Integrations_ImportCompletedKhanAcademy: Integrations_ImportCompletedKhanAcademy$1,
    Integrations_ImportCompletedPluralsight: Integrations_ImportCompletedPluralsight$1,
    Integrations_ImportCompletedSkillshare: Integrations_ImportCompletedSkillshare$1,
    Integrations_ImportCompletedTreehouse: Integrations_ImportCompletedTreehouse$1,
    Integrations_ImportCompletedUdemy: Integrations_ImportCompletedUdemy$1,
    Integrations_ImportCourseraCourses: Integrations_ImportCourseraCourses$1,
    Integrations_ImportCourseraDaily: Integrations_ImportCourseraDaily$1,
    Integrations_ImportGoodreadsDaily: Integrations_ImportGoodreadsDaily$1,
    Integrations_ImportKhanAcademyDaily: Integrations_ImportKhanAcademyDaily$1,
    Integrations_ImportNow: Integrations_ImportNow$1,
    Integrations_ImportPluralsightDaily: Integrations_ImportPluralsightDaily$1,
    Integrations_ImportPocketDaily: Integrations_ImportPocketDaily$1,
    Integrations_ImportReadabilityDaily: Integrations_ImportReadabilityDaily$1,
    Integrations_ImportReadArticlesReadability: Integrations_ImportReadArticlesReadability$1,
    Integrations_ImportReadGoodreads: Integrations_ImportReadGoodreads$1,
    Integrations_ImportSkillshareDaily: Integrations_ImportSkillshareDaily$1,
    Integrations_ImportTreehouseDaily: Integrations_ImportTreehouseDaily$1,
    Integrations_ImportUdemyDaily: Integrations_ImportUdemyDaily$1,
    Integrations_IntegrationsDirectory: Integrations_IntegrationsDirectory$1,
    Integrations_KhanAcademyContentFree: Integrations_KhanAcademyContentFree$1,
    Integrations_KhanAcademyImportError: Integrations_KhanAcademyImportError$1,
    Integrations_KhanAcademyUsername: Integrations_KhanAcademyUsername$1,
    Integrations_LastImported: Integrations_LastImported$1,
    Integrations_LastNameAssertionName: Integrations_LastNameAssertionName$1,
    Integrations_LastSyncDate: Integrations_LastSyncDate$1,
    Integrations_LimitedVisibility: Integrations_LimitedVisibility$1,
    Integrations_Linkedin: Integrations_Linkedin$1,
    Integrations_Never: Integrations_Never$1,
    Integrations_Note: Integrations_Note$1,
    Integrations_NoteForPNG: Integrations_NoteForPNG$1,
    Integrations_NoteForSVG: Integrations_NoteForSVG$1,
    Integrations_OnlyShowIfLicense: Integrations_OnlyShowIfLicense$1,
    Integrations_Or: Integrations_Or$1,
    Integrations_OrgId: Integrations_OrgId$1,
    Integrations_PaidOneClick: Integrations_PaidOneClick$1,
    Integrations_PaidOneClickSetup: Integrations_PaidOneClickSetup$1,
    Integrations_PluralsightImportError: Integrations_PluralsightImportError$1,
    Integrations_PluralsightPublicProfile: Integrations_PluralsightPublicProfile$1,
    Integrations_PluralsightUsername: Integrations_PluralsightUsername$1,
    Integrations_PocketImportError: Integrations_PocketImportError$1,
    Integrations_PocketUsername: Integrations_PocketUsername$1,
    Integrations_PortalId: Integrations_PortalId$1,
    Integrations_PortalName: Integrations_PortalName$1,
    Integrations_PromptForLicense: Integrations_PromptForLicense$1,
    Integrations_ProviderAssertionConsumerService: Integrations_ProviderAssertionConsumerService$1,
    Integrations_ProviderEntityID: Integrations_ProviderEntityID$1,
    Integrations_ProviderLogo: Integrations_ProviderLogo$1,
    Integrations_ReadabilityImportError: Integrations_ReadabilityImportError$1,
    Integrations_ReadabilityUsername: Integrations_ReadabilityUsername$1,
    Integrations_RecommendGoogleplus: Integrations_RecommendGoogleplus$1,
    Integrations_RecommendLinkedin: Integrations_RecommendLinkedin$1,
    Integrations_RecommendTwitter: Integrations_RecommendTwitter$1,
    Integrations_SaveIntegrations: Integrations_SaveIntegrations$1,
    Integrations_ShouldDisableConnector: Integrations_ShouldDisableConnector$1,
    Integrations_ShouldDisableIntegration: Integrations_ShouldDisableIntegration$1,
    Integrations_ShowConnectedOnly: Integrations_ShowConnectedOnly$1,
    Integrations_SignSAMLAssertion: Integrations_SignSAMLAssertion$1,
    Integrations_SignSAMLResponse: Integrations_SignSAMLResponse$1,
    Integrations_SkillshareImportError: Integrations_SkillshareImportError$1,
    Integrations_SkillshareIserId: Integrations_SkillshareIserId$1,
    Integrations_SkillshareProfileRequired: Integrations_SkillshareProfileRequired$1,
    Integrations_SkillshareUserName: Integrations_SkillshareUserName$1,
    Integrations_SkillshareUserNameId: Integrations_SkillshareUserNameId$1,
    Integrations_SlackDescription: Integrations_SlackDescription$1,
    Integrations_SlackDescriptionConsumer: Integrations_SlackDescriptionConsumer$1,
    Integrations_SlackTodaysLearningTitle: Integrations_SlackTodaysLearningTitle$1,
    Integrations_SlackTodaysLearningTitleFormat: Integrations_SlackTodaysLearningTitleFormat$1,
    Integrations_SocialAccounts: Integrations_SocialAccounts$1,
    Integrations_SSO_EnabledContentURL: Integrations_SSO_EnabledContentURL$1,
    Integrations_SSO_IsEnabled: Integrations_SSO_IsEnabled$1,
    Integrations_SuccessfullImport: Integrations_SuccessfullImport$1,
    Integrations_TreehouseImportError: Integrations_TreehouseImportError$1,
    Integrations_TreehousePublicProfile: Integrations_TreehousePublicProfile$1,
    Integrations_TreehouseUsername: Integrations_TreehouseUsername$1,
    Integrations_Twitter: Integrations_Twitter$1,
    Integrations_TypeDisable: Integrations_TypeDisable$1,
    Integrations_TypeTerm: Integrations_TypeTerm$1,
    Integrations_UdemyImportError: Integrations_UdemyImportError$1,
    Integrations_UdemyUserId: Integrations_UdemyUserId$1,
    Integrations_UdemyVisibleCourses: Integrations_UdemyVisibleCourses$1,
    Integrations_UnableToVerify: Integrations_UnableToVerify$1,
    Integrations_UserGrantedLicense: Integrations_UserGrantedLicense$1,
    Integrations_UserIDAssertionName: Integrations_UserIDAssertionName$1,
    Integrations_UserIdentifierSamlSubject: Integrations_UserIdentifierSamlSubject$1,
    Integrations_VerifyCourseraPublicProfile: Integrations_VerifyCourseraPublicProfile$1,
    Integrations_VerifyPublicCodecademy: Integrations_VerifyPublicCodecademy$1,
    Integrations_VerifyPublicUdemyProfile: Integrations_VerifyPublicUdemyProfile$1,
    Integrations_VerifySkillsharePublic: Integrations_VerifySkillsharePublic$1,
    Integrations_VerifySkillshareUserId: Integrations_VerifySkillshareUserId$1,
    Integrations_VerifyUniqueCourseraUserId: Integrations_VerifyUniqueCourseraUserId$1,
    Integrations_VerifyUniqueUserId: Integrations_VerifyUniqueUserId$1,
    Integrations_ViewConnections: Integrations_ViewConnections$1,
    Integrations_ViewFollowers: Integrations_ViewFollowers$1,
    Integrations_ViewFriends: Integrations_ViewFriends$1,
    InsightsNav_SkillTrends: InsightsNav_SkillTrends$1,
    InputsSvc_AddItemError: InputsSvc_AddItemError$1,
    InputsSvc_CompletedError: InputsSvc_CompletedError$1,
    InputsSvc_CompletedSuccess: InputsSvc_CompletedSuccess$1,
    InputsSvc_DismissSuggestedError: InputsSvc_DismissSuggestedError$1,
    InputsSvc_DismissSuggestedSuccess: InputsSvc_DismissSuggestedSuccess$1,
    InputsSvc_EditContentDuplicateError: InputsSvc_EditContentDuplicateError$1,
    InputsSvc_GeneralError: InputsSvc_GeneralError$1,
    InputsSvc_GetAssessmentError: InputsSvc_GetAssessmentError$1,
    InputsSvc_GetBookError: InputsSvc_GetBookError$1,
    InputsSvc_GetCourseError: InputsSvc_GetCourseError$1,
    InputsSvc_GetCourseMetadataError: InputsSvc_GetCourseMetadataError$1,
    InputsSvc_GetEpisodeError: InputsSvc_GetEpisodeError$1,
    InputsSvc_GetEventError: InputsSvc_GetEventError$1,
    InputsSvc_GetMediaError: InputsSvc_GetMediaError$1,
    InputsSvc_GetMediaMetadataError: InputsSvc_GetMediaMetadataError$1,
    InputsSvc_GetSuggestedError: InputsSvc_GetSuggestedError$1,
    InputsSvc_GetUserError: InputsSvc_GetUserError$1,
    InputsSvc_PeopleCompleted: InputsSvc_PeopleCompleted$1,
    InputsSvc_PeopleLiked: InputsSvc_PeopleLiked$1,
    InputsSvc_PeopleShared: InputsSvc_PeopleShared$1,
    InputsSvc_PersonCompleted: InputsSvc_PersonCompleted$1,
    InputsSvc_PersonLiked: InputsSvc_PersonLiked$1,
    InputsSvc_PersonShared: InputsSvc_PersonShared$1,
    InputsSvc_ProfileDismissed: InputsSvc_ProfileDismissed$1,
    InputsSvc_QueueError: InputsSvc_QueueError$1,
    InputsSvc_QueueSuccess: InputsSvc_QueueSuccess$1,
    InputsSvc_UsersTitle: InputsSvc_UsersTitle$1,
    InputSessionForm_Address: InputSessionForm_Address$1,
    InputSessionForm_AddSessionDetails: InputSessionForm_AddSessionDetails$1,
    InputSessionForm_BasicInformation: InputSessionForm_BasicInformation$1,
    InputSessionForm_DateTime: InputSessionForm_DateTime$1,
    InputSessionForm_DateTimeNew: InputSessionForm_DateTimeNew$1,
    InputSessionForm_DeletionAlert: InputSessionForm_DeletionAlert$1,
    InputSessionForm_DifferentUrl: InputSessionForm_DifferentUrl$1,
    InputSessionForm_EndTime: InputSessionForm_EndTime$1,
    InputSessionForm_EventEnds: InputSessionForm_EventEnds$1,
    InputSessionForm_EventStarts: InputSessionForm_EventStarts$1,
    InputSessionForm_EventStreamLinkLabel: InputSessionForm_EventStreamLinkLabel$1,
    InputSessionForm_EventStreamLinkPlaceholder: InputSessionForm_EventStreamLinkPlaceholder$1,
    InputSessionForm_EventTimeZone: InputSessionForm_EventTimeZone$1,
    InputSessionForm_InPerson: InputSessionForm_InPerson$1,
    InputSessionForm_IntegratedDetailsNotEditable: InputSessionForm_IntegratedDetailsNotEditable$1,
    InputSessionForm_InvalidDate: InputSessionForm_InvalidDate$1,
    InputSessionForm_InvalidTime: InputSessionForm_InvalidTime$1,
    InputSessionForm_InvalidTimeNew: InputSessionForm_InvalidTimeNew$1,
    InputSessionForm_LocationType: InputSessionForm_LocationType$1,
    InputSessionForm_LocationUrl: InputSessionForm_LocationUrl$1,
    InputSessionForm_LocationUrl_Placeholder: InputSessionForm_LocationUrl_Placeholder$1,
    InputSessionForm_LocationUrlDescription: InputSessionForm_LocationUrlDescription$1,
    InputSessionForm_Online: InputSessionForm_Online$1,
    InputSessionForm_PhysicalLocation: InputSessionForm_PhysicalLocation$1,
    InputSessionForm_Registration: InputSessionForm_Registration$1,
    InputSessionForm_RegistrationAvailable: InputSessionForm_RegistrationAvailable$1,
    InputSessionForm_RegistrationAvailableNew: InputSessionForm_RegistrationAvailableNew$1,
    InputSessionForm_RegistrationUrl: InputSessionForm_RegistrationUrl$1,
    InputSessionForm_SameUrl: InputSessionForm_SameUrl$1,
    InputSessionForm_SameUrlNew: InputSessionForm_SameUrlNew$1,
    InputSessionForm_SearchAddress: InputSessionForm_SearchAddress$1,
    InputSessionForm_StartTime: InputSessionForm_StartTime$1,
    InputSessionForm_Timezone: InputSessionForm_Timezone$1,
    InputsController_AssessmentUnavailable: InputsController_AssessmentUnavailable$1,
    InputsController_Average: InputsController_Average$1,
    InputsController_FriendlyErrorMessage: InputsController_FriendlyErrorMessage$1,
    InputsController_From: InputsController_From$1,
    InputsController_Login: InputsController_Login$1,
    InputsController_NoRatings: InputsController_NoRatings$1,
    InputsController_S: InputsController_S$1,
    InputsController_Signup: InputsController_Signup$1,
    InputsController_User: InputsController_User$1,
    InputsController_YourRating: InputsController_YourRating$1,
    InputRatingsSvc_ErrorNotification: InputRatingsSvc_ErrorNotification$1,
    InputRatingsSvc_SavedCompleteSuccess: InputRatingsSvc_SavedCompleteSuccess$1,
    InputRatingsSvc_SaveRatingError: InputRatingsSvc_SaveRatingError$1,
    InputRatingsSvc_SaveRatingSuccess: InputRatingsSvc_SaveRatingSuccess$1,
    InputCard_PreviewInputFormat: InputCard_PreviewInputFormat$1,
    inappropriateModalContent_Instructions: inappropriateModalContent_Instructions$1,
    inappropriateModalContent_Reason: inappropriateModalContent_Reason$1,
    inappropriateModalContent_ReasonValidationError: inappropriateModalContent_ReasonValidationError$1,
    inappropriateModalContent_Title: inappropriateModalContent_Title$1,
    ImageEditSvc_ImagedUpdated: ImageEditSvc_ImagedUpdated$1,
    ImageEditSvc_ImageUploadError: ImageEditSvc_ImageUploadError$1,
    ImageEditSvc_ImageUploadTooBig: ImageEditSvc_ImageUploadTooBig$1,
    ImageEditSvc_OpenBadgeParseError: ImageEditSvc_OpenBadgeParseError$1,
    GroupSvc_BulkDeleteError: GroupSvc_BulkDeleteError$1,
    GroupSvc_BulkDeleteGroupsSuccess: GroupSvc_BulkDeleteGroupsSuccess$1,
    GroupSvc_ErrorNotification: GroupSvc_ErrorNotification$1,
    GroupSvc_GroupInvitesNotification: GroupSvc_GroupInvitesNotification$1,
    GroupSvc_GroupInvitesNotificationError: GroupSvc_GroupInvitesNotificationError$1,
    GroupSvc_GroupJoinNotification: GroupSvc_GroupJoinNotification$1,
    GroupSvc_GroupLeaveNotification: GroupSvc_GroupLeaveNotification$1,
    GroupSvc_GroupMembershipNotification: GroupSvc_GroupMembershipNotification$1,
    GroupSvc_GroupSettingsTitle: GroupSvc_GroupSettingsTitle$1,
    GroupSettingsCtrl_AdministrativeGroup: GroupSettingsCtrl_AdministrativeGroup$1,
    GroupSettingsCtrl_AdministrativeNewTip: GroupSettingsCtrl_AdministrativeNewTip$1,
    GroupSettingsCtrl_AdministrativeTip: GroupSettingsCtrl_AdministrativeTip$1,
    GroupSettingsCtrl_ClosedGroup: GroupSettingsCtrl_ClosedGroup$1,
    GroupSettingsCtrl_ClosedNewTip: GroupSettingsCtrl_ClosedNewTip$1,
    GroupSettingsCtrl_ClosedTip: GroupSettingsCtrl_ClosedTip$1,
    GroupSettingsCtrl_CreateBulkGroups: GroupSettingsCtrl_CreateBulkGroups$1,
    GroupSettingsCtrl_CustomTooltip: GroupSettingsCtrl_CustomTooltip$1,
    GroupSettingsCtrl_Description: GroupSettingsCtrl_Description$1,
    GroupSettingsCtrl_DuplicateName: GroupSettingsCtrl_DuplicateName$1,
    GroupSettingsCtrl_DynamicMembership: GroupSettingsCtrl_DynamicMembership$1,
    GroupSettingsCtrl_DynamicMembership_Info: GroupSettingsCtrl_DynamicMembership_Info$1,
    GroupSettingsCtrl_DynamicMembership_Instructions: GroupSettingsCtrl_DynamicMembership_Instructions$1,
    GroupSettingsCtrl_EnableOpportunities: GroupSettingsCtrl_EnableOpportunities$1,
    GroupSettingsCtrl_GroupAddedSuccess: GroupSettingsCtrl_GroupAddedSuccess$1,
    GroupSettingsCtrl_GroupName: GroupSettingsCtrl_GroupName$1,
    GroupSettingsCtrl_GroupNameFormat: GroupSettingsCtrl_GroupNameFormat$1,
    GroupSettingsCtrl_GroupUpdatePrivacySuccess: GroupSettingsCtrl_GroupUpdatePrivacySuccess$1,
    GroupSettingsCtrl_GroupUpdateSuccess: GroupSettingsCtrl_GroupUpdateSuccess$1,
    GroupSettingsCtrl_NameExists: GroupSettingsCtrl_NameExists$1,
    GroupSettingsCtrl_OpenGroup: GroupSettingsCtrl_OpenGroup$1,
    GroupSettingsCtrl_OpenNewTip: GroupSettingsCtrl_OpenNewTip$1,
    GroupSettingsCtrl_OpenTip: GroupSettingsCtrl_OpenTip$1,
    GroupSettingsCtrl_PrivacySettings: GroupSettingsCtrl_PrivacySettings$1,
    GroupSettingsCtrl_PrivateGroup: GroupSettingsCtrl_PrivateGroup$1,
    GroupSettingsCtrl_PrivateNewTip: GroupSettingsCtrl_PrivateNewTip$1,
    GroupSettingsCtrl_PrivateTip: GroupSettingsCtrl_PrivateTip$1,
    GroupSettingsCtrl_ProblemWithGroups: GroupSettingsCtrl_ProblemWithGroups$1,
    GroupSettingsCtrl_SaveGroup: GroupSettingsCtrl_SaveGroup$1,
    GroupSettingsCtrl_SpecifyCategory: GroupSettingsCtrl_SpecifyCategory$1,
    GroupSettingsCtrl_SpecifyDescription: GroupSettingsCtrl_SpecifyDescription$1,
    GroupSettingsCtrl_SpecifyName: GroupSettingsCtrl_SpecifyName$1,
    GroupSecurityCtrl_UpdateRolesSuccess: GroupSecurityCtrl_UpdateRolesSuccess$1,
    GroupsController_About: GroupsController_About$1,
    GroupsController_BecomeAMember: GroupsController_BecomeAMember$1,
    GroupsController_ClickRequestMembership: GroupsController_ClickRequestMembership$1,
    GroupsController_ClickToJoin: GroupsController_ClickToJoin$1,
    GroupsController_Feed: GroupsController_Feed$1,
    GroupsController_GroupMembershipPending: GroupsController_GroupMembershipPending$1,
    GroupsController_GroupPostVisibility: GroupsController_GroupPostVisibility$1,
    GroupsController_GroupSettingsTitle: GroupsController_GroupSettingsTitle$1,
    GroupsController_Insights: GroupsController_Insights$1,
    GroupsController_Joining: GroupsController_Joining$1,
    GroupsController_Members: GroupsController_Members$1,
    GroupsController_RequestedMembershipOne: GroupsController_RequestedMembershipOne$1,
    GroupsController_RequestedMembershipTwo: GroupsController_RequestedMembershipTwo$1,
    GroupsController_RequestMembership: GroupsController_RequestMembership$1,
    GroupsController_Settings: GroupsController_Settings$1,
    groupPostAdded_Format: groupPostAdded_Format$1,
    groupPostAdded_GroupFormat: groupPostAdded_GroupFormat$1,
    groupPostAdded_SingleFormat: groupPostAdded_SingleFormat$1,
    GroupMembersCtrl_AnyTime: GroupMembersCtrl_AnyTime$1,
    GroupMembersCtrl_ApproveInvite: GroupMembersCtrl_ApproveInvite$1,
    GroupMembersCtrl_DateJoined: GroupMembersCtrl_DateJoined$1,
    GroupMembersCtrl_DateRequestsOrInvited: GroupMembersCtrl_DateRequestsOrInvited$1,
    GroupMembersCtrl_DeclineInvite: GroupMembersCtrl_DeclineInvite$1,
    GroupMembersCtrl_EditUserSettings: GroupMembersCtrl_EditUserSettings$1,
    GroupMembersCtrl_ErrorNotification: GroupMembersCtrl_ErrorNotification$1,
    GroupMembersCtrl_FocusSkills: GroupMembersCtrl_FocusSkills$1,
    GroupMembersCtrl_JobTitle: GroupMembersCtrl_JobTitle$1,
    GroupMembersCtrl_LastActive: GroupMembersCtrl_LastActive$1,
    GroupMembersCtrl_LastXDaysFormat: GroupMembersCtrl_LastXDaysFormat$1,
    GroupMembersCtrl_MembershipSource: GroupMembersCtrl_MembershipSource$1,
    GroupMembersCtrl_MembershipSource_AnalyticsPipeline: GroupMembersCtrl_MembershipSource_AnalyticsPipeline$1,
    GroupMembersCtrl_MembershipSource_BusinessRulesAPI: GroupMembersCtrl_MembershipSource_BusinessRulesAPI$1,
    GroupMembersCtrl_MembershipSource_BusinessRulesFtp: GroupMembersCtrl_MembershipSource_BusinessRulesFtp$1,
    GroupMembersCtrl_MembershipSource_ClientUserFile: GroupMembersCtrl_MembershipSource_ClientUserFile$1,
    GroupMembersCtrl_MembershipSource_ScheduledAutomation: GroupMembersCtrl_MembershipSource_ScheduledAutomation$1,
    GroupMembersCtrl_MembershipSource_UserAttributeFile: GroupMembersCtrl_MembershipSource_UserAttributeFile$1,
    GroupMembersCtrl_MembershipSource_v2API: GroupMembersCtrl_MembershipSource_v2API$1,
    GroupMembersCtrl_MembershipSource_Web: GroupMembersCtrl_MembershipSource_Web$1,
    GroupMembersCtrl_Name: GroupMembersCtrl_Name$1,
    GroupMembersCtrl_Of: GroupMembersCtrl_Of$1,
    GroupMembersCtrl_Points: GroupMembersCtrl_Points$1,
    GroupMembersCtrl_RatedJobSkills: GroupMembersCtrl_RatedJobSkills$1,
    GroupMembersCtrl_Remove: GroupMembersCtrl_Remove$1,
    GroupMembersCtrl_ResendInvite: GroupMembersCtrl_ResendInvite$1,
    GroupMembersCtrl_Results: GroupMembersCtrl_Results$1,
    GroupMembersCtrl_ResultsPerPage: GroupMembersCtrl_ResultsPerPage$1,
    GroupMembersCtrl_SendEmail: GroupMembersCtrl_SendEmail$1,
    GroupMembersCtrl_SetToAdmin: GroupMembersCtrl_SetToAdmin$1,
    GroupMembersCtrl_SetToMember: GroupMembersCtrl_SetToMember$1,
    GroupMembersCtrl_ViewPendingMembers: GroupMembersCtrl_ViewPendingMembers$1,
    GroupMemberFormCtrl_UpdateMemberRoleFormat: GroupMemberFormCtrl_UpdateMemberRoleFormat$1,
    GroupInviteCtrl_AddPeopleToGroup: GroupInviteCtrl_AddPeopleToGroup$1,
    GroupInviteCtrl_InviteEmailInstructions: GroupInviteCtrl_InviteEmailInstructions$1,
    GroupInviteCtrl_InviteLinkInstructions: GroupInviteCtrl_InviteLinkInstructions$1,
    GroupInviteCtrl_InvitePeople: GroupInviteCtrl_InvitePeople$1,
    GroupInviteCtrl_SearchByName: GroupInviteCtrl_SearchByName$1,
    GroupInviteCtrl_SendInviteTo: GroupInviteCtrl_SendInviteTo$1,
    groupInviteAccepted_PluralFormat: groupInviteAccepted_PluralFormat$1,
    groupInviteAccepted_SingleFormat: groupInviteAccepted_SingleFormat$1,
    GroupInsightsCtrl_All: GroupInsightsCtrl_All$1,
    GroupInsightsCtrl_GroupCategories: GroupInsightsCtrl_GroupCategories$1,
    GroupInsightsCtrl_Month: GroupInsightsCtrl_Month$1,
    GroupInsightsCtrl_Week: GroupInsightsCtrl_Week$1,
    GroupInsightsCtrl_Year: GroupInsightsCtrl_Year$1,
    GroupFormSvc_ConfirmRemoval: GroupFormSvc_ConfirmRemoval$1,
    GroupFormSvc_ConfirmRemovalMessage: GroupFormSvc_ConfirmRemovalMessage$1,
    GroupFormSvc_EditUserSettings: GroupFormSvc_EditUserSettings$1,
    GroupFormSvc_History: GroupFormSvc_History$1,
    GroupFormSvc_MemberRequestDateFormat: GroupFormSvc_MemberRequestDateFormat$1,
    GroupFormSvc_MemberSinceFormat: GroupFormSvc_MemberSinceFormat$1,
    GroupFormSvc_PendingMember: GroupFormSvc_PendingMember$1,
    GroupFormSvc_RemoveFromGroup: GroupFormSvc_RemoveFromGroup$1,
    GroupFormSvc_Removing: GroupFormSvc_Removing$1,
    GroupFormSvc_Role: GroupFormSvc_Role$1,
    GroupFormSvc_RolePermissions: GroupFormSvc_RolePermissions$1,
    GroupFormSvc_TopCategories: GroupFormSvc_TopCategories$1,
    GroupDeleteCtrl_DeleteGroupConfirm: GroupDeleteCtrl_DeleteGroupConfirm$1,
    GroupDeleteCtrl_DeleteGroupError: GroupDeleteCtrl_DeleteGroupError$1,
    GroupDeleteCtrl_DeleteGroupInfoDescription: GroupDeleteCtrl_DeleteGroupInfoDescription$1,
    GroupDeleteCtrl_DeleteGroupSuccess: GroupDeleteCtrl_DeleteGroupSuccess$1,
    GroupCtrl_EmptyStateDescription: GroupCtrl_EmptyStateDescription$1,
    GroupCtrl_EmptyStateTitle: GroupCtrl_EmptyStateTitle$1,
    GroupCtrl_GroupRemovalWarning: GroupCtrl_GroupRemovalWarning$1,
    GroupCtrl_LeaveGroupHeader: GroupCtrl_LeaveGroupHeader$1,
    GroupCtrl_LeaveGroupSummary: GroupCtrl_LeaveGroupSummary$1,
    GroupCtrl_MemberRemovedSuccessfully: GroupCtrl_MemberRemovedSuccessfully$1,
    GroupCtrl_MyTeam: GroupCtrl_MyTeam$1,
    GroupCtrl_RemoveFromGroup: GroupCtrl_RemoveFromGroup$1,
    GroupCtrl_SetAsPrimary: GroupCtrl_SetAsPrimary$1,
    GroupCtrl_UnsetAsPrimary: GroupCtrl_UnsetAsPrimary$1,
    GroupContextSvc_ErrorNotification: GroupContextSvc_ErrorNotification$1,
    GoalFormSvc_ByThisDate: GoalFormSvc_ByThisDate$1,
    GoalFormSvc_CompleteThisFormat: GoalFormSvc_CompleteThisFormat$1,
    GoalFormSvc_CreateGoal: GoalFormSvc_CreateGoal$1,
    GoalFormSvc_CreateGroupGoal: GoalFormSvc_CreateGroupGoal$1,
    GoalFormSvc_DeleteGoal: GoalFormSvc_DeleteGoal$1,
    GoalFormSvc_EarnPoints: GoalFormSvc_EarnPoints$1,
    GoalFormSvc_EarnPointsMessage: GoalFormSvc_EarnPointsMessage$1,
    GoalFormSvc_EditGoal: GoalFormSvc_EditGoal$1,
    GoalFormSvc_GroupGoalProgress: GoalFormSvc_GroupGoalProgress$1,
    GoalFormSvc_GroupTooltip: GoalFormSvc_GroupTooltip$1,
    GoalFormSvc_InThisCategory: GoalFormSvc_InThisCategory$1,
    GoalFormSvc_ItemAddedFormat: GoalFormSvc_ItemAddedFormat$1,
    GoalFormSvc_JustMe: GoalFormSvc_JustMe$1,
    GoalFormSvc_NumberOfPoints: GoalFormSvc_NumberOfPoints$1,
    GoalFormSvc_WhichGroupsTitle: GoalFormSvc_WhichGroupsTitle$1,
    "global.navigation.admin.brand": "Degreed Logo",
    "global.navigation.admin.features.admin": "Admin",
    "global.navigation.admin.features.beta": "Beta",
    "global.navigation.admin.features.footer-branding": "Powered by",
    "global.navigation.admin.features.show-learner-view": "Show Learner View",
    "global.navigation.admin.features.sidebar-branding": "Powered by",
    "global.navigation.admin.sidebar.automations": "Automations",
    "global.navigation.admin.sidebar.catalog": "Catalog",
    "global.navigation.admin.sidebar.catalog.academies": "Academies",
    "global.navigation.admin.sidebar.catalog.content": "Content",
    "global.navigation.admin.sidebar.catalog.pathways": "Pathways",
    "global.navigation.admin.sidebar.catalog.plans": "Plans",
    "global.navigation.admin.sidebar.content-marketplace": "Content MarketPlace",
    "global.navigation.admin.sidebar.dashboard": "Insights",
    "global.navigation.admin.sidebar.dashboard.learning": "Learning",
    "global.navigation.admin.sidebar.dashboard.skills": "Skills",
    "global.navigation.admin.sidebar.extended-enterprise": "Extended Enterprise",
    "global.navigation.admin.sidebar.help": "Help",
    "global.navigation.admin.sidebar.help.cookie-notice": "Cookie Notice",
    "global.navigation.admin.sidebar.help.faq": "FAQ",
    "global.navigation.admin.sidebar.help.knowledge-center": "Knowledge Center",
    "global.navigation.admin.sidebar.help.privacy-policy": "Privacy Policy",
    "global.navigation.admin.sidebar.integrations": "Integrations",
    "global.navigation.admin.sidebar.integrations.api-keys": "API Keys",
    "global.navigation.admin.sidebar.integrations.connected": "Connected",
    "global.navigation.admin.sidebar.integrations.directory": "Directory",
    "global.navigation.admin.sidebar.integrations.file-log": "File Log",
    "global.navigation.admin.sidebar.integrations.file-upload": "File Upload",
    "global.navigation.admin.sidebar.people": "People",
    "global.navigation.admin.sidebar.people.groups": "Groups",
    "global.navigation.admin.sidebar.people.permissions": "Permissions",
    "global.navigation.admin.sidebar.people.segments": "Segments",
    "global.navigation.admin.sidebar.people.user-attributes": "User Attributes",
    "global.navigation.admin.sidebar.people.users": "Users",
    "global.navigation.admin.sidebar.reporting": "Reporting",
    "global.navigation.admin.sidebar.reporting.advanced-analytics": "Advanced Analytics",
    "global.navigation.admin.sidebar.reporting.categories": "Categories",
    "global.navigation.admin.sidebar.reporting.configurations": "Configurations",
    "global.navigation.admin.sidebar.reporting.ftp": "FTP",
    "global.navigation.admin.sidebar.reporting.presets": "Presets",
    "global.navigation.admin.sidebar.reporting.reports": "Reports",
    "global.navigation.admin.sidebar.reporting.segments": "Segments",
    "global.navigation.admin.sidebar.settings": "Settings",
    "global.navigation.admin.sidebar.settings.branding": "Branding",
    "global.navigation.admin.sidebar.settings.communication": "Communication",
    "global.navigation.admin.sidebar.settings.faq": "FAQ",
    "global.navigation.admin.sidebar.settings.help-menu": "Help Menu",
    "global.navigation.admin.sidebar.settings.home": "Home",
    "global.navigation.admin.sidebar.settings.messaging": "Messaging",
    "global.navigation.admin.sidebar.skills": "Skills",
    "global.navigation.admin.sidebar.skills.dashboard": "Dashboard",
    "global.navigation.admin.sidebar.skills.inventory": "Inventory",
    "global.navigation.admin.sidebar.skills.roles": "Roles",
    "global.navigation.admin.sidebar.skills.scales": "Scales",
    "global.navigation.admin.sidebar.skills.settings": "Settings",
    "global.navigation.admin.sidebar.skills.skill-standards": "Skill Standards",
    "global.navigation.learner.brand": "Degreed Logo",
    "global.navigation.learner.features.add-content": "Add Content",
    "global.navigation.learner.features.add-to-profile": "Add to Profile",
    "global.navigation.learner.features.beta": "Beta",
    "global.navigation.learner.features.footer-branding": "Powered by",
    "global.navigation.learner.features.search": "Search",
    "global.navigation.learner.features.show-admin-view": "Show Admin View",
    "global.navigation.learner.features.sidebar-branding": "Powered by",
    "global.navigation.learner.sidebar.assistant": "Assistant",
    "global.navigation.learner.sidebar.discover": "Discover",
    "global.navigation.learner.sidebar.featured": "Featured",
    "global.navigation.learner.sidebar.help": "Help",
    "global.navigation.learner.sidebar.help.cookie-notice": "Cookie Notice",
    "global.navigation.learner.sidebar.help.faq": "FAQ",
    "global.navigation.learner.sidebar.help.knowledge-center": "Knowledge Center",
    "global.navigation.learner.sidebar.help.privacy-policy": "Privacy Policy",
    "global.navigation.learner.sidebar.home": "Home",
    "global.navigation.learner.sidebar.home.assignments": "Assignments",
    "global.navigation.learner.sidebar.home.groups": "Groups",
    "global.navigation.learner.sidebar.home.my-learning": "My Learning",
    "global.navigation.learner.sidebar.home.pathways": "Pathways",
    "global.navigation.learner.sidebar.home.plans": "Plans",
    "global.navigation.learner.sidebar.home.saved": "Saved",
    "global.navigation.learner.sidebar.home.shared": "Shared",
    "global.navigation.learner.sidebar.notifications": "Notifications",
    "global.navigation.learner.sidebar.opportunities": "Opportunities",
    "global.navigation.learner.sidebar.opportunities.browse": "Browse",
    "global.navigation.learner.sidebar.opportunities.engagement-insights": "Engagement Insights",
    "global.navigation.learner.sidebar.opportunities.marketplace": "Marketplace",
    "global.navigation.learner.sidebar.opportunities.mentoring": "Mentoring",
    "global.navigation.learner.sidebar.opportunities.open-insights": "Open Insights",
    "global.navigation.learner.sidebar.profile": "Profile",
    "global.navigation.learner.sidebar.profile.activity": "Activity",
    "global.navigation.learner.sidebar.profile.collection": "Collection",
    "global.navigation.learner.sidebar.profile.flex-ed": "FlexED",
    "global.navigation.learner.sidebar.profile.logout": "Log Out",
    "global.navigation.learner.sidebar.profile.my-plan": "My Plan",
    "global.navigation.learner.sidebar.profile.overview": "Overview",
    "global.navigation.learner.sidebar.profile.settings": "Settings",
    "global.navigation.learner.sidebar.profile.skills": "Skills",
    "global.navigation.learner.sidebar.skill-coach": "Skill Coach",
    "global.navigation.learner.sidebar.skill-coach.members": "Members",
    "global.navigation.learner.sidebar.skill-coach.team-learning-insights": "Learning Insights",
    "global.navigation.learner.sidebar.skill-coach.team-skill-insights": "Skill Insights",
    "global.navigation.learner.sidebar.skill-coach.team-skills": "Team Skills",
    forgotPasswordForm_EmailLabel: forgotPasswordForm_EmailLabel$1,
    forgotPasswordForm_EmailPlaceholder: forgotPasswordForm_EmailPlaceholder$1,
    forgotPasswordForm_InvalidEmail: forgotPasswordForm_InvalidEmail$1,
    forgotPasswordForm_Message: forgotPasswordForm_Message$1,
    forgotPasswordForm_Success: forgotPasswordForm_Success$1,
    forgotPasswordForm_SuccessMessage: forgotPasswordForm_SuccessMessage$1,
    forgotPasswordForm_Title: forgotPasswordForm_Title$1,
    followTargetForm_GroupHeader: followTargetForm_GroupHeader$1,
    followTargetForm_GroupHeaderSingular: followTargetForm_GroupHeaderSingular$1,
    followTargetForm_Instructions: followTargetForm_Instructions$1,
    followTargetForm_NoResources: followTargetForm_NoResources$1,
    followTargetForm_PathwayHeader: followTargetForm_PathwayHeader$1,
    followTargetForm_PathwayHeaderSingular: followTargetForm_PathwayHeaderSingular$1,
    followTargetForm_selectTitleFormat: followTargetForm_selectTitleFormat$1,
    followTargetForm_Submit: followTargetForm_Submit$1,
    followTargetForm_TagHeader: followTargetForm_TagHeader$1,
    followTargetForm_TagHeaderSingular: followTargetForm_TagHeaderSingular$1,
    followTargetForm_TargetHeader: followTargetForm_TargetHeader$1,
    followTargetForm_TargetHeaderSingular: followTargetForm_TargetHeaderSingular$1,
    followTargetForm_Title: followTargetForm_Title$1,
    followTargetForm_UserHeader: followTargetForm_UserHeader$1,
    followTargetForm_UserHeaderSingular: followTargetForm_UserHeaderSingular$1,
    FollowingSvc_Continue: FollowingSvc_Continue$1,
    FollowingSvc_FollowerCountsError: FollowingSvc_FollowerCountsError$1,
    FollowingSvc_FollowerInfoError: FollowingSvc_FollowerInfoError$1,
    FollowingSvc_FollowError: FollowingSvc_FollowError$1,
    FollowingSvc_FollowNotification: FollowingSvc_FollowNotification$1,
    FollowingSvc_FollowNotificationFormat: FollowingSvc_FollowNotificationFormat$1,
    FollowingSvc_FollowUserNotification: FollowingSvc_FollowUserNotification$1,
    FollowingSvc_InteralFollowError: FollowingSvc_InteralFollowError$1,
    FollowingSvc_InternalRetrievalError: FollowingSvc_InternalRetrievalError$1,
    FollowingSvc_UnfollowError: FollowingSvc_UnfollowError$1,
    FollowingSvc_UnfollowNotificationFormat: FollowingSvc_UnfollowNotificationFormat$1,
    FlexSvc_AddItems: FlexSvc_AddItems$1,
    FlexSvc_AddLinkTextsDescription: FlexSvc_AddLinkTextsDescription$1,
    FlexSvc_AddResources: FlexSvc_AddResources$1,
    FlexSvc_CombinedResources: FlexSvc_CombinedResources$1,
    FlexSvc_FreeformTextDescription: FlexSvc_FreeformTextDescription$1,
    FlexSvc_MixedResources: FlexSvc_MixedResources$1,
    FlexSvc_MixedResourcesDescription: FlexSvc_MixedResourcesDescription$1,
    FlexSvc_OpportunitiesDescription: FlexSvc_OpportunitiesDescription$1,
    FlexSvc_TextAndImage: FlexSvc_TextAndImage$1,
    FlexEdSvc_FlexEdError: FlexEdSvc_FlexEdError$1,
    flexEdModal_AllFieldsRequiredError: flexEdModal_AllFieldsRequiredError$1,
    flexEdModal_Close: flexEdModal_Close$1,
    flexEdModal_ConnectCardButton: flexEdModal_ConnectCardButton$1,
    flexEdModal_ContactYourAdminMessage: flexEdModal_ContactYourAdminMessage$1,
    flexEdModal_FirstName: flexEdModal_FirstName$1,
    flexEdModal_InvalidNumberError: flexEdModal_InvalidNumberError$1,
    flexEdModal_LastFour: flexEdModal_LastFour$1,
    flexEdModal_LastName: flexEdModal_LastName$1,
    flexEdModal_LinkYourFlexEdCard: flexEdModal_LinkYourFlexEdCard$1,
    flexEdModal_MultipleCardsError: flexEdModal_MultipleCardsError$1,
    flexEdModal_NameDoesNotMatchCardError: flexEdModal_NameDoesNotMatchCardError$1,
    flexEdModal_NameOnCard: flexEdModal_NameOnCard$1,
    flexEdModal_SavedNewInformation: flexEdModal_SavedNewInformation$1,
    flexEdModal_SaveInfoButton: flexEdModal_SaveInfoButton$1,
    flexEdModal_SuccessfullyConnected: flexEdModal_SuccessfullyConnected$1,
    flexEdModal_ViewMyFlexEd: flexEdModal_ViewMyFlexEd$1,
    flexEdModal_ViewYourExpenditures: flexEdModal_ViewYourExpenditures$1,
    FlexEdCtrl_Amount: FlexEdCtrl_Amount$1,
    FlexEdCtrl_Balance: FlexEdCtrl_Balance$1,
    FlexEdCtrl_BalanceError: FlexEdCtrl_BalanceError$1,
    FlexEdCtrl_Date: FlexEdCtrl_Date$1,
    FlexEdCtrl_Description: FlexEdCtrl_Description$1,
    FlexEdCtrl_ErrorRetrieving: FlexEdCtrl_ErrorRetrieving$1,
    FlexEdCtrl_FlexEdTitle: FlexEdCtrl_FlexEdTitle$1,
    FlexEdCtrl_FlexEdTransactionsTitle: FlexEdCtrl_FlexEdTransactionsTitle$1,
    FlexEdCtrl_UpdateCardInfo: FlexEdCtrl_UpdateCardInfo$1,
    FlexCtrl_AddPrimaryContact: FlexCtrl_AddPrimaryContact$1,
    FlexCtrl_AddProperties: FlexCtrl_AddProperties$1,
    FlexCtrl_AddSection: FlexCtrl_AddSection$1,
    FlexCtrl_AutoSuggestError: FlexCtrl_AutoSuggestError$1,
    FlexCtrl_ChooseSectionType: FlexCtrl_ChooseSectionType$1,
    FlexCtrl_EditingStatusMessage: FlexCtrl_EditingStatusMessage$1,
    FlexCtrl_EditPageType: FlexCtrl_EditPageType$1,
    FlexCtrl_EditPlanType: FlexCtrl_EditPlanType$1,
    FlexCtrl_EditPrimaryContact: FlexCtrl_EditPrimaryContact$1,
    FlexCtrl_EditProperties: FlexCtrl_EditProperties$1,
    FlexCtrl_EditSettings: FlexCtrl_EditSettings$1,
    FlexCtrl_NothingHere: FlexCtrl_NothingHere$1,
    FlexCtrl_NothingHereDescription: FlexCtrl_NothingHereDescription$1,
    FlexCtrl_PrimaryContact: FlexCtrl_PrimaryContact$1,
    FlexCtrl_ReorderSections: FlexCtrl_ReorderSections$1,
    FlexCtrl_SavePrimaryContact: FlexCtrl_SavePrimaryContact$1,
    FlexCtrl_SettingsType: FlexCtrl_SettingsType$1,
    FlexCtrl_ViewDirectory: FlexCtrl_ViewDirectory$1,
    FlexCtrl_ViewPageType: FlexCtrl_ViewPageType$1,
    FlexCtrl_ViewPlanType: FlexCtrl_ViewPlanType$1,
    firstPathwayModal_Enrolled: firstPathwayModal_Enrolled$1,
    firstPathwayModal_Followed: firstPathwayModal_Followed$1,
    firstPathwayModal_ViewPathways: firstPathwayModal_ViewPathways$1,
    firstPathwayModal_WhyTheyHelp: firstPathwayModal_WhyTheyHelp$1,
    FeedSvc_Dismiss: FeedSvc_Dismiss$1,
    FeedbackSvc_ErrorMessage: FeedbackSvc_ErrorMessage$1,
    FeedbackSvc_ThankyouMessage: FeedbackSvc_ThankyouMessage$1,
    FeedbackPartial_CitiCollaborate: FeedbackPartial_CitiCollaborate$1,
    FeedbackPartial_FAQ: FeedbackPartial_FAQ$1,
    FeedbackPartial_HereToHelp: FeedbackPartial_HereToHelp$1,
    FeedbackPartial_KnowledgeCenter: FeedbackPartial_KnowledgeCenter$1,
    FeedbackPartial_OSSLicense: FeedbackPartial_OSSLicense$1,
    FeedbackPartial_PhoneNumber: FeedbackPartial_PhoneNumber$1,
    FeedbackPartial_PrivacyPolicy: FeedbackPartial_PrivacyPolicy$1,
    FeedbackPartial_SendAMessage: FeedbackPartial_SendAMessage$1,
    FacetFilter_ActiveSubscription: FacetFilter_ActiveSubscription$1,
    FacetFilter_More: FacetFilter_More$1,
    FacetFilter_None: FacetFilter_None$1,
    FacetFilter_SortAlpha: FacetFilter_SortAlpha$1,
    FacetFilter_SortAlphaReverse: FacetFilter_SortAlphaReverse$1,
    FacetFilter_SortNumeric: FacetFilter_SortNumeric$1,
    FacetFilter_VisitSite: FacetFilter_VisitSite$1,
    FacetFilter_YourTopCategories: FacetFilter_YourTopCategories$1,
    ExternalProvidersSvc_ErrorMatchingResults: ExternalProvidersSvc_ErrorMatchingResults$1,
    ExternalProvidersSvc_ErrorRetrievingDetailsFormat: ExternalProvidersSvc_ErrorRetrievingDetailsFormat$1,
    ExternalProvidersSvc_ErrorRetrivingListFormat: ExternalProvidersSvc_ErrorRetrivingListFormat$1,
    externalContentModal_HeaderFormat: externalContentModal_HeaderFormat$1,
    Ext_AddALesson: Ext_AddALesson$1,
    Ext_AddAPathway: Ext_AddAPathway$1,
    Ext_AddASection: Ext_AddASection$1,
    Ext_AddATitle: Ext_AddATitle$1,
    Ext_AddCommentError: Ext_AddCommentError$1,
    Ext_AddedToCatalogSuccess: Ext_AddedToCatalogSuccess$1,
    Ext_AddedToPlan: Ext_AddedToPlan$1,
    Ext_Adding: Ext_Adding$1,
    Ext_AddingInputFormat: Ext_AddingInputFormat$1,
    Ext_AddNotificationNote: Ext_AddNotificationNote$1,
    Ext_AddPathwayFor: Ext_AddPathwayFor$1,
    Ext_AddPathwayTitle: Ext_AddPathwayTitle$1,
    Ext_AddRecommendationNote: Ext_AddRecommendationNote$1,
    Ext_AddSuccess: Ext_AddSuccess$1,
    Ext_AddTakeaway: Ext_AddTakeaway$1,
    Ext_AddToCatalog: Ext_AddToCatalog$1,
    Ext_AddToCatalogFormat: Ext_AddToCatalogFormat$1,
    Ext_AddToPathway: Ext_AddToPathway$1,
    Ext_AddTopics: Ext_AddTopics$1,
    Ext_AddTopicsOrSkills: Ext_AddTopicsOrSkills$1,
    Ext_AddTopicsOrTakeAway: Ext_AddTopicsOrTakeAway$1,
    Ext_AddToPlan: Ext_AddToPlan$1,
    Ext_AuthBlurb: Ext_AuthBlurb$1,
    Ext_BookInfoUnavailable: Ext_BookInfoUnavailable$1,
    Ext_CharacterCount: Ext_CharacterCount$1,
    Ext_CharactersRemainingFormat: Ext_CharactersRemainingFormat$1,
    Ext_ClearSearch: Ext_ClearSearch$1,
    Ext_Close: Ext_Close$1,
    Ext_ConfirmDetails: Ext_ConfirmDetails$1,
    Ext_Continue: Ext_Continue$1,
    Ext_CreatePlan: Ext_CreatePlan$1,
    Ext_EnterTopics: Ext_EnterTopics$1,
    Ext_Error: Ext_Error$1,
    Ext_ErrorMessage: Ext_ErrorMessage$1,
    Ext_ErrorSharing: Ext_ErrorSharing$1,
    Ext_ExistsInCMS: Ext_ExistsInCMS$1,
    Ext_GroupMemberCount: Ext_GroupMemberCount$1,
    Ext_InputAddedFormat: Ext_InputAddedFormat$1,
    Ext_ItemAdded: Ext_ItemAdded$1,
    Ext_ItemSaved: Ext_ItemSaved$1,
    Ext_Lesson: Ext_Lesson$1,
    Ext_LessonAddError: Ext_LessonAddError$1,
    Ext_LessonFormat: Ext_LessonFormat$1,
    Ext_LessonPlaceholder: Ext_LessonPlaceholder$1,
    Ext_Loading: Ext_Loading$1,
    Ext_LogoAlt: Ext_LogoAlt$1,
    Ext_LogOut: Ext_LogOut$1,
    Ext_MarkCompleteError: Ext_MarkCompleteError$1,
    Ext_MarkCompleteFormat: Ext_MarkCompleteFormat$1,
    Ext_MemberCountFormat: Ext_MemberCountFormat$1,
    Ext_MenuMarkComplete: Ext_MenuMarkComplete$1,
    Ext_MenuRecommend: Ext_MenuRecommend$1,
    Ext_MenuSaveForLater: Ext_MenuSaveForLater$1,
    Ext_Message: Ext_Message$1,
    Ext_NewNotificationsFormat: Ext_NewNotificationsFormat$1,
    Ext_Next: Ext_Next$1,
    Ext_NoAccount: Ext_NoAccount$1,
    Ext_NoNotifications: Ext_NoNotifications$1,
    Ext_NoPlansYet: Ext_NoPlansYet$1,
    Ext_NotificationCountFormat: Ext_NotificationCountFormat$1,
    Ext_Pathway: Ext_Pathway$1,
    Ext_PathwayAddError: Ext_PathwayAddError$1,
    Ext_PathwayAddItemError: Ext_PathwayAddItemError$1,
    Ext_PathwayAddItemPermissionError: Ext_PathwayAddItemPermissionError$1,
    Ext_PathwayDetailAccessError: Ext_PathwayDetailAccessError$1,
    Ext_PathwayEnrollError: Ext_PathwayEnrollError$1,
    Ext_PathwayError: Ext_PathwayError$1,
    Ext_PathwayLessonsError: Ext_PathwayLessonsError$1,
    Ext_PathwayPlaceholder: Ext_PathwayPlaceholder$1,
    Ext_PathwayTitle: Ext_PathwayTitle$1,
    Ext_PathwayUnenrollError: Ext_PathwayUnenrollError$1,
    Ext_PdfErrorMessage: Ext_PdfErrorMessage$1,
    Ext_PlansCreate: Ext_PlansCreate$1,
    Ext_PlansModalTitle: Ext_PlansModalTitle$1,
    Ext_PlansPlaceholder: Ext_PlansPlaceholder$1,
    Ext_PointsShort: Ext_PointsShort$1,
    Ext_PrivacyOnlyMe: Ext_PrivacyOnlyMe$1,
    Ext_RecommandationSentPluralFormat: Ext_RecommandationSentPluralFormat$1,
    Ext_RecommandationSentSingle: Ext_RecommandationSentSingle$1,
    Ext_Recommend: Ext_Recommend$1,
    Ext_RecommendationSentPluralFormat: Ext_RecommendationSentPluralFormat$1,
    Ext_RecommendationSentSingle: Ext_RecommendationSentSingle$1,
    Ext_RecommendationViaEmail: Ext_RecommendationViaEmail$1,
    Ext_Recommending: Ext_Recommending$1,
    Ext_RecommendingToPluralFormat: Ext_RecommendingToPluralFormat$1,
    Ext_RecommendingToSingle: Ext_RecommendingToSingle$1,
    Ext_RecommendToPluralFormat: Ext_RecommendToPluralFormat$1,
    Ext_RecommendToSingle: Ext_RecommendToSingle$1,
    Ext_RelatedSkills: Ext_RelatedSkills$1,
    Ext_Retry: Ext_Retry$1,
    Ext_Save: Ext_Save$1,
    Ext_SaveButton: Ext_SaveButton$1,
    Ext_SaveForLaterError: Ext_SaveForLaterError$1,
    Ext_SaveRatingError: Ext_SaveRatingError$1,
    Ext_Saving: Ext_Saving$1,
    Ext_SavingError: Ext_SavingError$1,
    Ext_SavingItem: Ext_SavingItem$1,
    Ext_SearchError: Ext_SearchError$1,
    Ext_SearchGroups: Ext_SearchGroups$1,
    Ext_SearchResultArticlesHeadingFormat: Ext_SearchResultArticlesHeadingFormat$1,
    Ext_SearchResultBooksHeadingFormat: Ext_SearchResultBooksHeadingFormat$1,
    Ext_SearchResultNoneFound: Ext_SearchResultNoneFound$1,
    Ext_SearchResultPathwaysHeadingFormat: Ext_SearchResultPathwaysHeadingFormat$1,
    Ext_SearchResultPeopleHeadingFormat: Ext_SearchResultPeopleHeadingFormat$1,
    Ext_SearchResultTitleFormat: Ext_SearchResultTitleFormat$1,
    Ext_SearchResultVideosHeadingFormat: Ext_SearchResultVideosHeadingFormat$1,
    Ext_Section: Ext_Section$1,
    Ext_SectionAddError: Ext_SectionAddError$1,
    Ext_SectionFormat: Ext_SectionFormat$1,
    Ext_SectionPlaceholder: Ext_SectionPlaceholder$1,
    Ext_SelectAGroup: Ext_SelectAGroup$1,
    Ext_SelectALesson: Ext_SelectALesson$1,
    Ext_SelectAPathway: Ext_SelectAPathway$1,
    Ext_SelectASection: Ext_SelectASection$1,
    Ext_SelectLesson: Ext_SelectLesson$1,
    Ext_SelectPathway: Ext_SelectPathway$1,
    Ext_SelectPlan: Ext_SelectPlan$1,
    Ext_SelectRecommendees: Ext_SelectRecommendees$1,
    Ext_SelectRecommendeesPlaceholder: Ext_SelectRecommendeesPlaceholder$1,
    Ext_SelectSection: Ext_SelectSection$1,
    Ext_SelectSkillPlan: Ext_SelectSkillPlan$1,
    Ext_SharedContentSuccess: Ext_SharedContentSuccess$1,
    Ext_ShareSomethingAboutFormat: Ext_ShareSomethingAboutFormat$1,
    Ext_ShareTitle: Ext_ShareTitle$1,
    Ext_SignIn: Ext_SignIn$1,
    Ext_SignInTitle: Ext_SignInTitle$1,
    Ext_SignUpLink: Ext_SignUpLink$1,
    Ext_TagsModalTitle: Ext_TagsModalTitle$1,
    Ext_TagsSuggestionError: Ext_TagsSuggestionError$1,
    Ext_TakeawayAdded: Ext_TakeawayAdded$1,
    Ext_TakeawayPlaceholder: Ext_TakeawayPlaceholder$1,
    Ext_TargetAddError: Ext_TargetAddError$1,
    Ext_TargetGetError: Ext_TargetGetError$1,
    Ext_TargetGetSectionsError: Ext_TargetGetSectionsError$1,
    Ext_Title: Ext_Title$1,
    Ext_TopicAddedPlural: Ext_TopicAddedPlural$1,
    Ext_TopicAddedSingle: Ext_TopicAddedSingle$1,
    Ext_TopicAndTakeawayAddedPlural: Ext_TopicAndTakeawayAddedPlural$1,
    Ext_TopicAndTakeawayAddedSingle: Ext_TopicAndTakeawayAddedSingle$1,
    Ext_ViewAllOnDegreed: Ext_ViewAllOnDegreed$1,
    Ext_ViewDuplicate: Ext_ViewDuplicate$1,
    Ext_ViewPlan: Ext_ViewPlan$1,
    Ext_ViewSavedItems: Ext_ViewSavedItems$1,
    Ext_ViewYourPathway: Ext_ViewYourPathway$1,
    Ext_WhyRecommending: Ext_WhyRecommending$1,
    EventFormCtrl_AddEvent: EventFormCtrl_AddEvent$1,
    EventFormCtrl_AddToCatalogFormat: EventFormCtrl_AddToCatalogFormat$1,
    EventFormCtrl_Attendee: EventFormCtrl_Attendee$1,
    EventFormCtrl_Category: EventFormCtrl_Category$1,
    EventFormCtrl_DateAttended: EventFormCtrl_DateAttended$1,
    EventFormCtrl_Description: EventFormCtrl_Description$1,
    EventFormCtrl_EditEvent: EventFormCtrl_EditEvent$1,
    EventFormCtrl_EventLength: EventFormCtrl_EventLength$1,
    EventFormCtrl_EventLengthError: EventFormCtrl_EventLengthError$1,
    EventFormCtrl_EventSite: EventFormCtrl_EventSite$1,
    EventFormCtrl_EventTitle: EventFormCtrl_EventTitle$1,
    EventFormCtrl_EventTitleError: EventFormCtrl_EventTitleError$1,
    EventFormCtrl_EventUrl: EventFormCtrl_EventUrl$1,
    EventFormCtrl_HowInvolved: EventFormCtrl_HowInvolved$1,
    EventFormCtrl_Keynote: EventFormCtrl_Keynote$1,
    EventFormCtrl_OneDay: EventFormCtrl_OneDay$1,
    EventFormCtrl_OneHour: EventFormCtrl_OneHour$1,
    EventFormCtrl_Panelist: EventFormCtrl_Panelist$1,
    EventFormCtrl_Presenter: EventFormCtrl_Presenter$1,
    EventFormCtrl_SaveEvent: EventFormCtrl_SaveEvent$1,
    EventFormCtrl_ThreeToEightHours: EventFormCtrl_ThreeToEightHours$1,
    EventFormCtrl_ThreeToFiveDays: EventFormCtrl_ThreeToFiveDays$1,
    EventFormCtrl_Title: EventFormCtrl_Title$1,
    EventFormCtrl_TwoDays: EventFormCtrl_TwoDays$1,
    EventFormCtrl_TwoHours: EventFormCtrl_TwoHours$1,
    EventFormCtrl_ValidUrl: EventFormCtrl_ValidUrl$1,
    EventFormCtrl_WeekOrMore: EventFormCtrl_WeekOrMore$1,
    EventFormCtrl_WhatDidYouLearnLong: EventFormCtrl_WhatDidYouLearnLong$1,
    EventFormCtrl_WhatDidYouLearnShort: EventFormCtrl_WhatDidYouLearnShort$1,
    EvaluationSvc_DeleteError: EvaluationSvc_DeleteError$1,
    EvaluationSvc_DeleteSuccess: EvaluationSvc_DeleteSuccess$1,
    EvaluationSvc_RetrieveError: EvaluationSvc_RetrieveError$1,
    EvaluationSvc_SetResultsError: EvaluationSvc_SetResultsError$1,
    EvaluationSvc_SubmitError: EvaluationSvc_SubmitError$1,
    EvalNav_Heading: EvalNav_Heading$1,
    EvalNav_Introduction: EvalNav_Introduction$1,
    EvalNav_ResultsDescription: EvalNav_ResultsDescription$1,
    EvalNav_ResultsTitle: EvalNav_ResultsTitle$1,
    EvalNav_SelectEndorser: EvalNav_SelectEndorser$1,
    EvalApp_Cancel: EvalApp_Cancel$1,
    EvalApp_MainTitle: EvalApp_MainTitle$1,
    EvalApp_Results_Breakdown: EvalApp_Results_Breakdown$1,
    EvalApp_Results_Congratulations: EvalApp_Results_Congratulations$1,
    EvalApp_Results_ExtraMile: EvalApp_Results_ExtraMile$1,
    EvalApp_Results_GoToFeed: EvalApp_Results_GoToFeed$1,
    EvalApp_Results_GoToProfile: EvalApp_Results_GoToProfile$1,
    EvalApp_Results_LevelDeclarationFormat: EvalApp_Results_LevelDeclarationFormat$1,
    EvalApp_Stay: EvalApp_Stay$1,
    Eval_ApplicationAlreadyEndorsed: Eval_ApplicationAlreadyEndorsed$1,
    Eval_ApplicationAlreadyEndorsedDesc: Eval_ApplicationAlreadyEndorsedDesc$1,
    Eval_ApplicationEndorsed: Eval_ApplicationEndorsed$1,
    Eval_ApplicationEndorsedDesc: Eval_ApplicationEndorsedDesc$1,
    Eval_ApplicationNotEndorsedDesc: Eval_ApplicationNotEndorsedDesc$1,
    Eval_ApplicationOutOfDate: Eval_ApplicationOutOfDate$1,
    Eval_ApplicationOutOfDateDesc: Eval_ApplicationOutOfDateDesc$1,
    Eval_ApproveApplication: Eval_ApproveApplication$1,
    Eval_EndorseApplication: Eval_EndorseApplication$1,
    Eval_EndorsementDesc: Eval_EndorsementDesc$1,
    Eval_EndorsementHeader: Eval_EndorsementHeader$1,
    Eval_EndorsementNav: Eval_EndorsementNav$1,
    Eval_GoBackHome: Eval_GoBackHome$1,
    Eval_LeaveRemarks: Eval_LeaveRemarks$1,
    Eval_LevelInItem: Eval_LevelInItem$1,
    Eval_NextStep: Eval_NextStep$1,
    Eval_OptionalQuestionDesc_Endorser: Eval_OptionalQuestionDesc_Endorser$1,
    Eval_Question_AdvanceStateOfArt: Eval_Question_AdvanceStateOfArt$1,
    Eval_Question_AdvanceStateOfArtExample: Eval_Question_AdvanceStateOfArtExample$1,
    Eval_Question_AlternativeApproaches: Eval_Question_AlternativeApproaches$1,
    Eval_Question_AnticipateCommProblems: Eval_Question_AnticipateCommProblems$1,
    Eval_Question_AnticipateRequirements: Eval_Question_AnticipateRequirements$1,
    Eval_Question_ApplyFrequency: Eval_Question_ApplyFrequency$1,
    Eval_Question_ApplyJob: Eval_Question_ApplyJob$1,
    Eval_Question_ApplyNewTheories: Eval_Question_ApplyNewTheories$1,
    Eval_Question_ApproachTheory: Eval_Question_ApproachTheory$1,
    Eval_Question_ArticulateChallenge: Eval_Question_ArticulateChallenge$1,
    Eval_Question_ArticulateChallengeExample: Eval_Question_ArticulateChallengeExample$1,
    Eval_Question_BuildConsensus: Eval_Question_BuildConsensus$1,
    Eval_Question_BuildConsensusExample: Eval_Question_BuildConsensusExample$1,
    Eval_Question_Collaboration: Eval_Question_Collaboration$1,
    Eval_Question_CommunicateDifficultSubjects: Eval_Question_CommunicateDifficultSubjects$1,
    Eval_Question_CommunicationAbilities: Eval_Question_CommunicationAbilities$1,
    Eval_Question_ComplexTasks: Eval_Question_ComplexTasks$1,
    Eval_Question_ContributeProfessionalDevelopment: Eval_Question_ContributeProfessionalDevelopment$1,
    Eval_Question_ContributeProfessionalDevelopmentExample: Eval_Question_ContributeProfessionalDevelopmentExample$1,
    Eval_Question_ContributingToObjectives: Eval_Question_ContributingToObjectives$1,
    Eval_Question_CrossDiscipline: Eval_Question_CrossDiscipline$1,
    Eval_Question_DefineGroupProcess: Eval_Question_DefineGroupProcess$1,
    Eval_Question_DefineGroupRoles: Eval_Question_DefineGroupRoles$1,
    Eval_Question_DescribeKnowledge: Eval_Question_DescribeKnowledge$1,
    Eval_Question_DevelopGroupPotential: Eval_Question_DevelopGroupPotential$1,
    Eval_Question_DevelopGroupPotentialExample: Eval_Question_DevelopGroupPotentialExample$1,
    Eval_Question_DirectOthers: Eval_Question_DirectOthers$1,
    Eval_Question_DirectOthersExample: Eval_Question_DirectOthersExample$1,
    Eval_Question_EvaluateProcesses: Eval_Question_EvaluateProcesses$1,
    Eval_Question_EvaluateProcessesExample: Eval_Question_EvaluateProcessesExample$1,
    Eval_Question_EvaluateWork: Eval_Question_EvaluateWork$1,
    Eval_Question_FindSolutions: Eval_Question_FindSolutions$1,
    Eval_Question_FindSolutionsExample: Eval_Question_FindSolutionsExample$1,
    Eval_Question_FrequencyUnanticipatedProblems: Eval_Question_FrequencyUnanticipatedProblems$1,
    Eval_Question_HelpGroupEffective: Eval_Question_HelpGroupEffective$1,
    Eval_Question_ImpactOnField: Eval_Question_ImpactOnField$1,
    Eval_Question_ImpactOnFieldExample: Eval_Question_ImpactOnFieldExample$1,
    Eval_Question_ImpactOthers: Eval_Question_ImpactOthers$1,
    Eval_Question_ImproveSkill: Eval_Question_ImproveSkill$1,
    Eval_Question_InnovativeContributionExample: Eval_Question_InnovativeContributionExample$1,
    Eval_Question_JobTitle: Eval_Question_JobTitle$1,
    Eval_Question_LeadGroup: Eval_Question_LeadGroup$1,
    Eval_Question_LeadGroupExample: Eval_Question_LeadGroupExample$1,
    Eval_Question_LeadOrg: Eval_Question_LeadOrg$1,
    Eval_Question_LeadOrgExample: Eval_Question_LeadOrgExample$1,
    Eval_Question_Learn: Eval_Question_Learn$1,
    Eval_Question_LearnExample: Eval_Question_LearnExample$1,
    Eval_Question_LearnFromOthers: Eval_Question_LearnFromOthers$1,
    Eval_Question_LevelOfResponsibility: Eval_Question_LevelOfResponsibility$1,
    Eval_Question_LimitsExample: Eval_Question_LimitsExample$1,
    Eval_Question_LimitsOfField: Eval_Question_LimitsOfField$1,
    Eval_Question_MasterStateOfArt: Eval_Question_MasterStateOfArt$1,
    Eval_Question_NumberOfMethods: Eval_Question_NumberOfMethods$1,
    Eval_Question_OverallGuidance: Eval_Question_OverallGuidance$1,
    Eval_Question_PracticalAbilities: Eval_Question_PracticalAbilities$1,
    Eval_Question_PresentationAbilities: Eval_Question_PresentationAbilities$1,
    Eval_Question_PrestipulatedTasks: Eval_Question_PrestipulatedTasks$1,
    Eval_Question_ProblemsCanSolve: Eval_Question_ProblemsCanSolve$1,
    Eval_Question_ProjectResponsibility: Eval_Question_ProjectResponsibility$1,
    Eval_Question_RelatedSkills: Eval_Question_RelatedSkills$1,
    Eval_Question_RequirementsChange: Eval_Question_RequirementsChange$1,
    Eval_Question_SkillDuration: Eval_Question_SkillDuration$1,
    Eval_Question_SocietalImplications: Eval_Question_SocietalImplications$1,
    Eval_Question_StrategicJudgements: Eval_Question_StrategicJudgements$1,
    Eval_Question_StrategicProblemExample: Eval_Question_StrategicProblemExample$1,
    Eval_Question_Teamwork: Eval_Question_Teamwork$1,
    Eval_Question_TechnicalKnowledge: Eval_Question_TechnicalKnowledge$1,
    Eval_Question_TypesUnanticipatedProblems: Eval_Question_TypesUnanticipatedProblems$1,
    Eval_Question_UnclearTasks: Eval_Question_UnclearTasks$1,
    Eval_Question_UnderstandRelatedSkills: Eval_Question_UnderstandRelatedSkills$1,
    Eval_Question_WellKnown: Eval_Question_WellKnown$1,
    Eval_Question_WellKnownExample: Eval_Question_WellKnownExample$1,
    Eval_Question_WorkInGroup: Eval_Question_WorkInGroup$1,
    Eval_QuestionDesc_Endorser: Eval_QuestionDesc_Endorser$1,
    Eval_QuestionDesc_HonorCode: Eval_QuestionDesc_HonorCode$1,
    Eval_ReflectSkillDescription: Eval_ReflectSkillDescription$1,
    Eval_RequestChanges: Eval_RequestChanges$1,
    Eval_Response_1_2Years: Eval_Response_1_2Years$1,
    Eval_Response_11_Years: Eval_Response_11_Years$1,
    Eval_Response_3_5Years: Eval_Response_3_5Years$1,
    Eval_Response_6_10Years: Eval_Response_6_10Years$1,
    Eval_Response_AcceptHonorCode: Eval_Response_AcceptHonorCode$1,
    Eval_Response_AcknowledgeOthers: Eval_Response_AcknowledgeOthers$1,
    Eval_Response_AdvancedSkills: Eval_Response_AdvancedSkills$1,
    Eval_Response_BasicKnowledge: Eval_Response_BasicKnowledge$1,
    Eval_Response_BasicSkills: Eval_Response_BasicSkills$1,
    Eval_Response_BroadSkills: Eval_Response_BroadSkills$1,
    Eval_Response_CommunicateContextually: Eval_Response_CommunicateContextually$1,
    Eval_Response_CommunicateEffectively: Eval_Response_CommunicateEffectively$1,
    Eval_Response_ComplexCommunication: Eval_Response_ComplexCommunication$1,
    Eval_Response_ComplexProblems: Eval_Response_ComplexProblems$1,
    Eval_Response_ComprehensiveTechTheoryKnowledge: Eval_Response_ComprehensiveTechTheoryKnowledge$1,
    Eval_Response_ConvincingOthers: Eval_Response_ConvincingOthers$1,
    Eval_Response_CurrentLimits: Eval_Response_CurrentLimits$1,
    Eval_Response_Daily: Eval_Response_Daily$1,
    Eval_Response_DeepKnowledge: Eval_Response_DeepKnowledge$1,
    Eval_Response_DemonstrateBasics: Eval_Response_DemonstrateBasics$1,
    Eval_Response_DifferentApproaches: Eval_Response_DifferentApproaches$1,
    Eval_Response_DirectDevelopment: Eval_Response_DirectDevelopment$1,
    Eval_Response_ExtendedSkills: Eval_Response_ExtendedSkills$1,
    Eval_Response_ExtensiveKnowledge: Eval_Response_ExtensiveKnowledge$1,
    Eval_Response_ExtensiveTechTheoryKnowledge: Eval_Response_ExtensiveTechTheoryKnowledge$1,
    Eval_Response_FewProblems: Eval_Response_FewProblems$1,
    Eval_Response_FewTechniques: Eval_Response_FewTechniques$1,
    Eval_Response_FocusOnMyDevelopment: Eval_Response_FocusOnMyDevelopment$1,
    Eval_Response_FocusOnMyWork: Eval_Response_FocusOnMyWork$1,
    Eval_Response_FocusOnTask: Eval_Response_FocusOnTask$1,
    Eval_Response_IntroduceInnovativeContributions: Eval_Response_IntroduceInnovativeContributions$1,
    Eval_Response_LearningGuidance: Eval_Response_LearningGuidance$1,
    Eval_Response_LessThan1Year: Eval_Response_LessThan1Year$1,
    Eval_Response_LimitedTechTheoryKnowledge: Eval_Response_LimitedTechTheoryKnowledge$1,
    Eval_Response_MakePeopleMoreEffective: Eval_Response_MakePeopleMoreEffective$1,
    Eval_Response_Monthly: Eval_Response_Monthly$1,
    Eval_Response_MostAspects: Eval_Response_MostAspects$1,
    Eval_Response_No: Eval_Response_No$1,
    Eval_Response_NotComfortable: Eval_Response_NotComfortable$1,
    Eval_Response_NoTechTheoryKnowledge: Eval_Response_NoTechTheoryKnowledge$1,
    Eval_Response_NotSure: Eval_Response_NotSure$1,
    Eval_Response_NotVery: Eval_Response_NotVery$1,
    Eval_Response_NovelProblems: Eval_Response_NovelProblems$1,
    Eval_Response_Often: Eval_Response_Often$1,
    Eval_Response_OncePerYear: Eval_Response_OncePerYear$1,
    Eval_Response_OngoingSupport: Eval_Response_OngoingSupport$1,
    Eval_Response_Partially: Eval_Response_Partially$1,
    Eval_Response_PresentArguments: Eval_Response_PresentArguments$1,
    Eval_Response_PresentInformation: Eval_Response_PresentInformation$1,
    Eval_Response_PresentNone: Eval_Response_PresentNone$1,
    Eval_Response_Rarely: Eval_Response_Rarely$1,
    Eval_Response_ResponsibilityGiven: Eval_Response_ResponsibilityGiven$1,
    Eval_Response_ResponsibilityOverall: Eval_Response_ResponsibilityOverall$1,
    Eval_Response_ResponsibilityPlanning: Eval_Response_ResponsibilityPlanning$1,
    Eval_Response_SensitiveCommunication: Eval_Response_SensitiveCommunication$1,
    Eval_Response_SeveralMethods: Eval_Response_SeveralMethods$1,
    Eval_Response_SeveralPerYear: Eval_Response_SeveralPerYear$1,
    Eval_Response_SimpleProblems: Eval_Response_SimpleProblems$1,
    Eval_Response_SolveSimpleProblems: Eval_Response_SolveSimpleProblems$1,
    Eval_Response_SolveStrategicProblems: Eval_Response_SolveStrategicProblems$1,
    Eval_Response_SolveUnfamiliarProblems: Eval_Response_SolveUnfamiliarProblems$1,
    Eval_Response_SolveVarietyProblems: Eval_Response_SolveVarietyProblems$1,
    Eval_Response_SomeKnowledge: Eval_Response_SomeKnowledge$1,
    Eval_Response_Sometimes: Eval_Response_Sometimes$1,
    Eval_Response_Somewhat: Eval_Response_Somewhat$1,
    Eval_Response_SomewhatComfortable: Eval_Response_SomewhatComfortable$1,
    Eval_Response_Specific: Eval_Response_Specific$1,
    Eval_Response_StrategicProblems: Eval_Response_StrategicProblems$1,
    Eval_Response_SupportOthers: Eval_Response_SupportOthers$1,
    Eval_Response_Tangential: Eval_Response_Tangential$1,
    Eval_Response_UncomfortableCommunication: Eval_Response_UncomfortableCommunication$1,
    Eval_Response_UnderstandOthers: Eval_Response_UnderstandOthers$1,
    Eval_Response_Very: Eval_Response_Very$1,
    Eval_Response_VeryComfortable: Eval_Response_VeryComfortable$1,
    Eval_Response_Weekly: Eval_Response_Weekly$1,
    Eval_Response_Yes: Eval_Response_Yes$1,
    Eval_ResponseDesc_AcceptHonorCode: Eval_ResponseDesc_AcceptHonorCode$1,
    Eval_SaveEndorsementError: Eval_SaveEndorsementError$1,
    Eval_Step_Application: Eval_Step_Application$1,
    Eval_Step_AutonomyResponsibility: Eval_Step_AutonomyResponsibility$1,
    Eval_Step_Background: Eval_Step_Background$1,
    Eval_Step_CommunicationTeaching: Eval_Step_CommunicationTeaching$1,
    Eval_Step_DemonstrationOfCriteria: Eval_Step_DemonstrationOfCriteria$1,
    Eval_Step_EndorseDecline: Eval_Step_EndorseDecline$1,
    Eval_Step_Endorsement: Eval_Step_Endorsement$1,
    Eval_Step_General: Eval_Step_General$1,
    Eval_Step_Introduction: Eval_Step_Introduction$1,
    Eval_Step_Knowledge: Eval_Step_Knowledge$1,
    Eval_Step_PlanningEvaluation: Eval_Step_PlanningEvaluation$1,
    Eval_Step_Questionnaire: Eval_Step_Questionnaire$1,
    Eval_Step_ReceiveResults: Eval_Step_ReceiveResults$1,
    Eval_Step_ReviewApplication: Eval_Step_ReviewApplication$1,
    Eval_Step_TeamworkLeadership: Eval_Step_TeamworkLeadership$1,
    Eval_StepDesc_Application: Eval_StepDesc_Application$1,
    Eval_StepDesc_EndorseDecline: Eval_StepDesc_EndorseDecline$1,
    Eval_StepDesc_EndorseIntroduction: Eval_StepDesc_EndorseIntroduction$1,
    Eval_StepDesc_General: Eval_StepDesc_General$1,
    Eval_StepDesc_ReviewApplication: Eval_StepDesc_ReviewApplication$1,
    ErrorPages_ErrorTitle: ErrorPages_ErrorTitle$1,
    ErrorPages_ErrorTitle500: ErrorPages_ErrorTitle500$1,
    ErrorPages_FaultSolution: ErrorPages_FaultSolution$1,
    ErrorPages_HomepageButton: ErrorPages_HomepageButton$1,
    ErrorPages_ReportBugButton: ErrorPages_ReportBugButton$1,
    ErrorPages_VerifyEmailErrorText: ErrorPages_VerifyEmailErrorText$1,
    ErrorPages_VerifyEmailErrorTitle: ErrorPages_VerifyEmailErrorTitle$1,
    EpisodeFormCtrl_AddPodcast: EpisodeFormCtrl_AddPodcast$1,
    EpisodeFormCtrl_Category: EpisodeFormCtrl_Category$1,
    EpisodeFormCtrl_ChooseEpisode: EpisodeFormCtrl_ChooseEpisode$1,
    EpisodeFormCtrl_DateCompleted: EpisodeFormCtrl_DateCompleted$1,
    EpisodeFormCtrl_EditPodcast: EpisodeFormCtrl_EditPodcast$1,
    EpisodeFormCtrl_EnterPodcastName: EpisodeFormCtrl_EnterPodcastName$1,
    EpisodeFormCtrl_Episode: EpisodeFormCtrl_Episode$1,
    EpisodeFormCtrl_EpisodeError: EpisodeFormCtrl_EpisodeError$1,
    EpisodeFormCtrl_ICreatedEpisode: EpisodeFormCtrl_ICreatedEpisode$1,
    EpisodeFormCtrl_LengthInMinutes: EpisodeFormCtrl_LengthInMinutes$1,
    EpisodeFormCtrl_Loading: EpisodeFormCtrl_Loading$1,
    EpisodeFormCtrl_NoEpisodes: EpisodeFormCtrl_NoEpisodes$1,
    EpisodeFormCtrl_NoMatch: EpisodeFormCtrl_NoMatch$1,
    EpisodeFormCtrl_PodcastName: EpisodeFormCtrl_PodcastName$1,
    EpisodeFormCtrl_SaveEpisode: EpisodeFormCtrl_SaveEpisode$1,
    EpisodeFormCtrl_SelectEpisode: EpisodeFormCtrl_SelectEpisode$1,
    EpisodeFormCtrl_SelectTitle: EpisodeFormCtrl_SelectTitle$1,
    EpisodeFormCtrl_ValidNumber: EpisodeFormCtrl_ValidNumber$1,
    EpisodeFormCtrl_WhatDidYouLearnLong: EpisodeFormCtrl_WhatDidYouLearnLong$1,
    EpisodeFormCtrl_WhatDidYouLearnShort: EpisodeFormCtrl_WhatDidYouLearnShort$1,
    endorsersForm_applicantsEmailValidationMessage: endorsersForm_applicantsEmailValidationMessage$1,
    endorsersForm_Header: endorsersForm_Header$1,
    endorsersForm_Instructions: endorsersForm_Instructions$1,
    endorsersForm_InstructionsFour: endorsersForm_InstructionsFour$1,
    endorsersForm_InstructionsOne: endorsersForm_InstructionsOne$1,
    endorsersForm_InstructionsThree: endorsersForm_InstructionsThree$1,
    endorsersForm_InstructionsTwo: endorsersForm_InstructionsTwo$1,
    endorsersForm_InvalidEmailValidationMessage: endorsersForm_InvalidEmailValidationMessage$1,
    endorsersForm_sameEmailValidationMessage: endorsersForm_sameEmailValidationMessage$1,
    endorsersForm_SectionHeader1: endorsersForm_SectionHeader1$1,
    endorsersForm_SectionHeader2: endorsersForm_SectionHeader2$1,
    endorsersForm_SectionHeader3: endorsersForm_SectionHeader3$1,
    endorsersForm_Tip: endorsersForm_Tip$1,
    endorsersForm_ValidationMessage: endorsersForm_ValidationMessage$1,
    endorserForm_EditHeader: endorserForm_EditHeader$1,
    endorserForm_EmailLabel: endorserForm_EmailLabel$1,
    endorserForm_EmailPlaceholder: endorserForm_EmailPlaceholder$1,
    endorserForm_FirstNameLabel: endorserForm_FirstNameLabel$1,
    endorserForm_InvitationLabel: endorserForm_InvitationLabel$1,
    endorserForm_LastNameLabel: endorserForm_LastNameLabel$1,
    endorserForm_PositionLabel: endorserForm_PositionLabel$1,
    endorserForm_PositionPlaceholder: endorserForm_PositionPlaceholder$1,
    endorserForm_RelationshipLabel: endorserForm_RelationshipLabel$1,
    endorserForm_RelationshipPlaceholder: endorserForm_RelationshipPlaceholder$1,
    EndorsementSvc_ErrorGetting: EndorsementSvc_ErrorGetting$1,
    EndorsementSvc_ErrorSaving: EndorsementSvc_ErrorSaving$1,
    EndorsementOptionsSvc_ContributionLarge: EndorsementOptionsSvc_ContributionLarge$1,
    EndorsementOptionsSvc_ContributionModerate: EndorsementOptionsSvc_ContributionModerate$1,
    EndorsementOptionsSvc_ContributionNone: EndorsementOptionsSvc_ContributionNone$1,
    EndorsementOptionsSvc_ContributionSmall: EndorsementOptionsSvc_ContributionSmall$1,
    EndorsementOptionsSvc_ContributionVeryLarge: EndorsementOptionsSvc_ContributionVeryLarge$1,
    EndorsementOptionsSvc_DifficultyExtremely: EndorsementOptionsSvc_DifficultyExtremely$1,
    EndorsementOptionsSvc_DifficultyNot: EndorsementOptionsSvc_DifficultyNot$1,
    EndorsementOptionsSvc_DifficultySlightly: EndorsementOptionsSvc_DifficultySlightly$1,
    EndorsementOptionsSvc_DifficultySomewhat: EndorsementOptionsSvc_DifficultySomewhat$1,
    EndorsementOptionsSvc_DifficultyVery: EndorsementOptionsSvc_DifficultyVery$1,
    EndorsementOptionsSvc_ExpertLevel1: EndorsementOptionsSvc_ExpertLevel1$1,
    EndorsementOptionsSvc_ExpertLevel2: EndorsementOptionsSvc_ExpertLevel2$1,
    EndorsementOptionsSvc_ExpertLevel3: EndorsementOptionsSvc_ExpertLevel3$1,
    EndorsementOptionsSvc_ExpertLevel4: EndorsementOptionsSvc_ExpertLevel4$1,
    EndorsementOptionsSvc_ExpertLevel5: EndorsementOptionsSvc_ExpertLevel5$1,
    EndorsementOptionsSvc_MasteryCapable: EndorsementOptionsSvc_MasteryCapable$1,
    EndorsementOptionsSvc_MasteryDistinguished: EndorsementOptionsSvc_MasteryDistinguished$1,
    EndorsementOptionsSvc_MasteryEmerging: EndorsementOptionsSvc_MasteryEmerging$1,
    EndorsementOptionsSvc_MasteryExperienced: EndorsementOptionsSvc_MasteryExperienced$1,
    EndorsementOptionsSvc_MasteryMaster: EndorsementOptionsSvc_MasteryMaster$1,
    EndorsementOptionsSvc_MasteryNovice: EndorsementOptionsSvc_MasteryNovice$1,
    EndorsementOptionsSvc_People0To5: EndorsementOptionsSvc_People0To5$1,
    EndorsementOptionsSvc_People11To20: EndorsementOptionsSvc_People11To20$1,
    EndorsementOptionsSvc_People151Plus: EndorsementOptionsSvc_People151Plus$1,
    EndorsementOptionsSvc_People21To40: EndorsementOptionsSvc_People21To40$1,
    EndorsementOptionsSvc_People41To80: EndorsementOptionsSvc_People41To80$1,
    EndorsementOptionsSvc_People6To10: EndorsementOptionsSvc_People6To10$1,
    EndorsementOptionsSvc_People81To150: EndorsementOptionsSvc_People81To150$1,
    EndorsementOptionsSvc_Percentile30Minus: EndorsementOptionsSvc_Percentile30Minus$1,
    EndorsementOptionsSvc_Percentile30To49: EndorsementOptionsSvc_Percentile30To49$1,
    EndorsementOptionsSvc_Percentile50To69: EndorsementOptionsSvc_Percentile50To69$1,
    EndorsementOptionsSvc_Percentile70To89: EndorsementOptionsSvc_Percentile70To89$1,
    EndorsementOptionsSvc_Percentile90To99: EndorsementOptionsSvc_Percentile90To99$1,
    EndorsementOptionsSvc_RelationshipClientOfFormat: EndorsementOptionsSvc_RelationshipClientOfFormat$1,
    EndorsementOptionsSvc_RelationshipDifferentCompanyFormat: EndorsementOptionsSvc_RelationshipDifferentCompanyFormat$1,
    EndorsementOptionsSvc_RelationshipDifferentGroupFormat: EndorsementOptionsSvc_RelationshipDifferentGroupFormat$1,
    EndorsementOptionsSvc_RelationshipManagedFormat: EndorsementOptionsSvc_RelationshipManagedFormat$1,
    EndorsementOptionsSvc_RelationshipMentorFormat: EndorsementOptionsSvc_RelationshipMentorFormat$1,
    EndorsementOptionsSvc_RelationshipReportedToFormat: EndorsementOptionsSvc_RelationshipReportedToFormat$1,
    EndorsementOptionsSvc_RelationshipSameGroupFormat: EndorsementOptionsSvc_RelationshipSameGroupFormat$1,
    EndorsementOptionsSvc_RelationshipSeniorToFormat: EndorsementOptionsSvc_RelationshipSeniorToFormat$1,
    EndorsementOptionsSvc_RelationshipSeniorToYouFormat: EndorsementOptionsSvc_RelationshipSeniorToYouFormat$1,
    EndorsementOptionsSvc_RelationshipStudents: EndorsementOptionsSvc_RelationshipStudents$1,
    EndorsementOptionsSvc_RelationshipTeacherFormat: EndorsementOptionsSvc_RelationshipTeacherFormat$1,
    EndorsementOptionsSvc_RelationshipYourCientFormat: EndorsementOptionsSvc_RelationshipYourCientFormat$1,
    EndorsementOptionsSvc_SignificanceExtremely: EndorsementOptionsSvc_SignificanceExtremely$1,
    EndorsementOptionsSvc_SignificanceNot: EndorsementOptionsSvc_SignificanceNot$1,
    EndorsementOptionsSvc_SignificanceSlightly: EndorsementOptionsSvc_SignificanceSlightly$1,
    EndorsementOptionsSvc_SignificanceSomewhat: EndorsementOptionsSvc_SignificanceSomewhat$1,
    EndorsementOptionsSvc_SignificanceVery: EndorsementOptionsSvc_SignificanceVery$1,
    EndorsementOptionsSvc_VerifyNo: EndorsementOptionsSvc_VerifyNo$1,
    EndorsementOptionsSvc_VerifyPartial: EndorsementOptionsSvc_VerifyPartial$1,
    EndorsementOptionsSvc_VerifyUnknown: EndorsementOptionsSvc_VerifyUnknown$1,
    EndorsementOptionsSvc_VerifyYes: EndorsementOptionsSvc_VerifyYes$1,
    EndorsementOptionsSvc_Years0To1: EndorsementOptionsSvc_Years0To1$1,
    EndorsementOptionsSvc_Years11To14: EndorsementOptionsSvc_Years11To14$1,
    EndorsementOptionsSvc_Years15To20: EndorsementOptionsSvc_Years15To20$1,
    EndorsementOptionsSvc_Years21Plus: EndorsementOptionsSvc_Years21Plus$1,
    EndorsementOptionsSvc_Years2To4: EndorsementOptionsSvc_Years2To4$1,
    EndorsementOptionsSvc_Years5To7: EndorsementOptionsSvc_Years5To7$1,
    EndorsementOptionsSvc_Years8To10: EndorsementOptionsSvc_Years8To10$1,
    EmbeddedLearning_ComingSoon: EmbeddedLearning_ComingSoon$1,
    EmbeddedLearning_RelatedArticles: EmbeddedLearning_RelatedArticles$1,
    EmbeddedLearning_RelatedPathways: EmbeddedLearning_RelatedPathways$1,
    EmbeddedLearning_RelatedVideos: EmbeddedLearning_RelatedVideos$1,
    EmailAddressVerificationCtrl_VerificationEmailSentFormat: EmailAddressVerificationCtrl_VerificationEmailSentFormat$1,
    downloadReportOutcome_FailureFormat: downloadReportOutcome_FailureFormat$1,
    downloadReportOutcome_SuccessFormat: downloadReportOutcome_SuccessFormat$1,
    Download_DownloadFile: Download_DownloadFile$1,
    dgXpBar_NewPointsFormat: dgXpBar_NewPointsFormat$1,
    dgXpBar_NextGoalFormat: dgXpBar_NextGoalFormat$1,
    dgWordLimit_LimitToFormat: dgWordLimit_LimitToFormat$1,
    dgWordLimit_MinLimitFormat: dgWordLimit_MinLimitFormat$1,
    dgWordLimit_WordCount: dgWordLimit_WordCount$1,
    dgWordLimit_WordLimitReached: dgWordLimit_WordLimitReached$1,
    dgWordLimit_WordsRemaining: dgWordLimit_WordsRemaining$1,
    dgVideoPlayer_BrowserError: dgVideoPlayer_BrowserError$1,
    dgVideoPlayer_EncodingMessage: dgVideoPlayer_EncodingMessage$1,
    dgVBarChart_A11yTipFormat: dgVBarChart_A11yTipFormat$1,
    dgVBarChart_A11yTipFormatRange: dgVBarChart_A11yTipFormatRange$1,
    dgVBarChart_ChartFilterA11y: dgVBarChart_ChartFilterA11y$1,
    dgVBarChart_ContentItems: dgVBarChart_ContentItems$1,
    dgVBarChart_Date: dgVBarChart_Date$1,
    dgVBarChart_DisplayTypeLabel: dgVBarChart_DisplayTypeLabel$1,
    dgVBarChart_DisplayTypePlaceholder: dgVBarChart_DisplayTypePlaceholder$1,
    dgVBarChart_InputTypeLabel: dgVBarChart_InputTypeLabel$1,
    dgVBarChart_InputTypePlaceholder: dgVBarChart_InputTypePlaceholder$1,
    dgVBarChart_NoPointsTipFormat: dgVBarChart_NoPointsTipFormat$1,
    dgVBarChart_PeriodLabel: dgVBarChart_PeriodLabel$1,
    dgVBarChart_PeriodPlaceholder: dgVBarChart_PeriodPlaceholder$1,
    dgVBarChart_Points: dgVBarChart_Points$1,
    dgVBarChart_PointsTipFormat: dgVBarChart_PointsTipFormat$1,
    dgVBarChart_TopicLabel: dgVBarChart_TopicLabel$1,
    dgVBarChart_ViewLearningCompletions: dgVBarChart_ViewLearningCompletions$1,
    dgValidatedField_WhoopsMessageFormat: dgValidatedField_WhoopsMessageFormat$1,
    dgUtilityBar_AddToProfileInProgress: dgUtilityBar_AddToProfileInProgress$1,
    dgUtilityBar_AddToProfileTitle: dgUtilityBar_AddToProfileTitle$1,
    dgUtilityBar_FindSomethingToLearnPlaceholder: dgUtilityBar_FindSomethingToLearnPlaceholder$1,
    dgUtilityBar_FlexEdFormat: dgUtilityBar_FlexEdFormat$1,
    dgUtilityBar_InProgress: dgUtilityBar_InProgress$1,
    dgUtilityBar_ManageOrg: dgUtilityBar_ManageOrg$1,
    dgUtilityBar_MasteryPointsFormat: dgUtilityBar_MasteryPointsFormat$1,
    dgUtilityBar_PersonalInformationTitle: dgUtilityBar_PersonalInformationTitle$1,
    dgUtilityBar_SearchLabel: dgUtilityBar_SearchLabel$1,
    dgUtilityBar_SelectAnotherSkill: dgUtilityBar_SelectAnotherSkill$1,
    dgUtilityBar_SelectASkill: dgUtilityBar_SelectASkill$1,
    dgUserTile_Follow: dgUserTile_Follow$1,
    dgUserTile_Following: dgUserTile_Following$1,
    dgUserTile_Unfollow: dgUserTile_Unfollow$1,
    dgUsersSearch_Follow: dgUsersSearch_Follow$1,
    dgUsersSearch_FollowUserFormat: dgUsersSearch_FollowUserFormat$1,
    dgUsersSearch_NoResults: dgUsersSearch_NoResults$1,
    dgUsersSearch_SearchDescription: dgUsersSearch_SearchDescription$1,
    dgUsersSearch_SearchLabel: dgUsersSearch_SearchLabel$1,
    dgUsersSearch_SearchPlaceholder: dgUsersSearch_SearchPlaceholder$1,
    dgUsersSearch_SearchTitle: dgUsersSearch_SearchTitle$1,
    dgUsersSearch_UnFollow: dgUsersSearch_UnFollow$1,
    dgUsersSearch_UnfollowUserFormat: dgUsersSearch_UnfollowUserFormat$1,
    dgUserProfilePrivacy_ProfileSettingDescriptionFormat: dgUserProfilePrivacy_ProfileSettingDescriptionFormat$1,
    dgUserProfilePrivacy_VisibleToMeOnly: dgUserProfilePrivacy_VisibleToMeOnly$1,
    dgUserProfilePrivacy_VisibleToMeOnlyDesc: dgUserProfilePrivacy_VisibleToMeOnlyDesc$1,
    dgUserProfilePrivacy_VisibleToMeOnlyLabel: dgUserProfilePrivacy_VisibleToMeOnlyLabel$1,
    dgUserProfilePrivacy_VisibleToOrgDesc: dgUserProfilePrivacy_VisibleToOrgDesc$1,
    dgUserProfilePrivacy_VisibleToOrgLabel: dgUserProfilePrivacy_VisibleToOrgLabel$1,
    dgUserProfilePrivacy_VisibleToOrgOnly: dgUserProfilePrivacy_VisibleToOrgOnly$1,
    dgUserProfilePrivacy_VisibleToPublic: dgUserProfilePrivacy_VisibleToPublic$1,
    dgUserProfilePrivacy_VisibleToPublicDesc: dgUserProfilePrivacy_VisibleToPublicDesc$1,
    dgUserProfilePrivacy_VisibleToPublicInOrg: dgUserProfilePrivacy_VisibleToPublicInOrg$1,
    dgUserProfilePrivacy_VisibleToPublicLabel: dgUserProfilePrivacy_VisibleToPublicLabel$1,
    dgUserProfile_BecomeMentorSearchTitle: dgUserProfile_BecomeMentorSearchTitle$1,
    dgUserProfile_BecomeMentorSelectTitle: dgUserProfile_BecomeMentorSelectTitle$1,
    dgUserProfile_BecomeMentorTitle: dgUserProfile_BecomeMentorTitle$1,
    dgUserProfile_IntegrationAssigned: dgUserProfile_IntegrationAssigned$1,
    dgUserProfile_OppTypesInterestedTitle: dgUserProfile_OppTypesInterestedTitle$1,
    dgUserProfile_OppTypesSelectTitle: dgUserProfile_OppTypesSelectTitle$1,
    dgUserProfile_OppTypesTitle: dgUserProfile_OppTypesTitle$1,
    dgUserProfile_OptInLabel: dgUserProfile_OptInLabel$1,
    dgUserProfile_PersonalInformationLabel: dgUserProfile_PersonalInformationLabel$1,
    dgUserProfile_PictureLabel: dgUserProfile_PictureLabel$1,
    dgUserProfile_PrivacyLockedMessage: dgUserProfile_PrivacyLockedMessage$1,
    dgUserProfile_PrivacyVisibilityLabel: dgUserProfile_PrivacyVisibilityLabel$1,
    dgUserProfile_SkillCoachLabel: dgUserProfile_SkillCoachLabel$1,
    dgUserProfile_TeamProgramDesc: dgUserProfile_TeamProgramDesc$1,
    dgUserProfile_TeamProgramDescSkillInventory: dgUserProfile_TeamProgramDescSkillInventory$1,
    dgUserProfile_TeamProgramJoinDesc: dgUserProfile_TeamProgramJoinDesc$1,
    dgUserProfile_TeamProgramJoinHeader: dgUserProfile_TeamProgramJoinHeader$1,
    dgUserProfile_TeamProgramLabel: dgUserProfile_TeamProgramLabel$1,
    dgUserProfile_TeamProgramLeaveDesc: dgUserProfile_TeamProgramLeaveDesc$1,
    dgUserProfile_TeamProgramLeaveHeader: dgUserProfile_TeamProgramLeaveHeader$1,
    dgUserOverview_Channel: dgUserOverview_Channel$1,
    dgUserOverview_ConnectFlexedCard: dgUserOverview_ConnectFlexedCard$1,
    dgUserOverview_FlexEd: dgUserOverview_FlexEd$1,
    dgUserOverview_Logout: dgUserOverview_Logout$1,
    dgUserOverview_Points: dgUserOverview_Points$1,
    dgUserOverview_Profile: dgUserOverview_Profile$1,
    dgUserOverview_Settings: dgUserOverview_Settings$1,
    dgUserOverview_SkillCertification: dgUserOverview_SkillCertification$1,
    dgUserOverview_SkillReview: dgUserOverview_SkillReview$1,
    dgUserOverview_SwitchOrganization: dgUserOverview_SwitchOrganization$1,
    dgUserOutcomeItem_AdditionalInfo: dgUserOutcomeItem_AdditionalInfo$1,
    dgUserOutcomeItem_AwardIssuer: dgUserOutcomeItem_AwardIssuer$1,
    dgUserOutcomeItem_ContentTypeOverview: dgUserOutcomeItem_ContentTypeOverview$1,
    dgUserOutcomeItem_DidntSpecify: dgUserOutcomeItem_DidntSpecify$1,
    dgUserOutcomeItem_EarningCertificate: dgUserOutcomeItem_EarningCertificate$1,
    dgUserOutcomeItem_HowEarned: dgUserOutcomeItem_HowEarned$1,
    dgUserOutcomeItem_HowWasAchieved: dgUserOutcomeItem_HowWasAchieved$1,
    dgUserOutcomeItem_SelectivityAward: dgUserOutcomeItem_SelectivityAward$1,
    dgUserOutcomeItem_SelectivityCertificate: dgUserOutcomeItem_SelectivityCertificate$1,
    dgUserOutcomeItem_SkillCandidate: dgUserOutcomeItem_SkillCandidate$1,
    dgUserOutcomeItem_WhenWasApplied: dgUserOutcomeItem_WhenWasApplied$1,
    dgUserOutcomeItem_WhoElseContributed: dgUserOutcomeItem_WhoElseContributed$1,
    dgUserOutcomeItem_WhyUseCandidate: dgUserOutcomeItem_WhyUseCandidate$1,
    dgUserOutcomeEditForm_AccomplishmentDate: dgUserOutcomeEditForm_AccomplishmentDate$1,
    dgUserOutcomeEditForm_AchievedDate: dgUserOutcomeEditForm_AchievedDate$1,
    dgUserOutcomeEditForm_ActiveCert: dgUserOutcomeEditForm_ActiveCert$1,
    dgUserOutcomeEditForm_AddAccomplishment: dgUserOutcomeEditForm_AddAccomplishment$1,
    dgUserOutcomeEditForm_AddADegree: dgUserOutcomeEditForm_AddADegree$1,
    dgUserOutcomeEditForm_AddAward: dgUserOutcomeEditForm_AddAward$1,
    dgUserOutcomeEditForm_AddBadge: dgUserOutcomeEditForm_AddBadge$1,
    dgUserOutcomeEditForm_AddBadgeUrl: dgUserOutcomeEditForm_AddBadgeUrl$1,
    dgUserOutcomeEditForm_AddCertificate: dgUserOutcomeEditForm_AddCertificate$1,
    dgUserOutcomeEditForm_AddDegree: dgUserOutcomeEditForm_AddDegree$1,
    dgUserOutcomeEditForm_AdditionalSkillInfo: dgUserOutcomeEditForm_AdditionalSkillInfo$1,
    dgUserOutcomeEditForm_AddSkill: dgUserOutcomeEditForm_AddSkill$1,
    dgUserOutcomeEditForm_AwardedDate: dgUserOutcomeEditForm_AwardedDate$1,
    dgUserOutcomeEditForm_BadgeIssuer: dgUserOutcomeEditForm_BadgeIssuer$1,
    dgUserOutcomeEditForm_BadgeName: dgUserOutcomeEditForm_BadgeName$1,
    dgUserOutcomeEditForm_BadgeProvider: dgUserOutcomeEditForm_BadgeProvider$1,
    dgUserOutcomeEditForm_BadgeUrlJson: dgUserOutcomeEditForm_BadgeUrlJson$1,
    dgUserOutcomeEditForm_CategoryAwardsDescription: dgUserOutcomeEditForm_CategoryAwardsDescription$1,
    dgUserOutcomeEditForm_CategoryDescription: dgUserOutcomeEditForm_CategoryDescription$1,
    dgUserOutcomeEditForm_CertificateGrouping: dgUserOutcomeEditForm_CertificateGrouping$1,
    dgUserOutcomeEditForm_CertNumber: dgUserOutcomeEditForm_CertNumber$1,
    dgUserOutcomeEditForm_CollegeUniversity: dgUserOutcomeEditForm_CollegeUniversity$1,
    dgUserOutcomeEditForm_ConceptualizeSkillFormat: dgUserOutcomeEditForm_ConceptualizeSkillFormat$1,
    dgUserOutcomeEditForm_Country: dgUserOutcomeEditForm_Country$1,
    dgUserOutcomeEditForm_DateCompleted: dgUserOutcomeEditForm_DateCompleted$1,
    dgUserOutcomeEditForm_DateGraduated: dgUserOutcomeEditForm_DateGraduated$1,
    dgUserOutcomeEditForm_DegreeGrouping: dgUserOutcomeEditForm_DegreeGrouping$1,
    dgUserOutcomeEditForm_DegreeLevel: dgUserOutcomeEditForm_DegreeLevel$1,
    dgUserOutcomeEditForm_DegreeLevelExample: dgUserOutcomeEditForm_DegreeLevelExample$1,
    dgUserOutcomeEditForm_DegreeTitleExample: dgUserOutcomeEditForm_DegreeTitleExample$1,
    dgUserOutcomeEditForm_DescribeAccomplishment: dgUserOutcomeEditForm_DescribeAccomplishment$1,
    dgUserOutcomeEditForm_DescribeSkill: dgUserOutcomeEditForm_DescribeSkill$1,
    dgUserOutcomeEditForm_DescribeUseOfSkill: dgUserOutcomeEditForm_DescribeUseOfSkill$1,
    dgUserOutcomeEditForm_DescribeWhyUseOfSkill: dgUserOutcomeEditForm_DescribeWhyUseOfSkill$1,
    dgUserOutcomeEditForm_DoesCertExpire: dgUserOutcomeEditForm_DoesCertExpire$1,
    dgUserOutcomeEditForm_EditAccomplishment: dgUserOutcomeEditForm_EditAccomplishment$1,
    dgUserOutcomeEditForm_EditAward: dgUserOutcomeEditForm_EditAward$1,
    dgUserOutcomeEditForm_EditBadge: dgUserOutcomeEditForm_EditBadge$1,
    dgUserOutcomeEditForm_EditCertificate: dgUserOutcomeEditForm_EditCertificate$1,
    dgUserOutcomeEditForm_EditDegree: dgUserOutcomeEditForm_EditDegree$1,
    dgUserOutcomeEditForm_EndDate: dgUserOutcomeEditForm_EndDate$1,
    dgUserOutcomeEditForm_ExpandedClientBase: dgUserOutcomeEditForm_ExpandedClientBase$1,
    dgUserOutcomeEditForm_Expiration: dgUserOutcomeEditForm_Expiration$1,
    dgUserOutcomeEditForm_FieldOfStudy: dgUserOutcomeEditForm_FieldOfStudy$1,
    dgUserOutcomeEditForm_FormatDescription: dgUserOutcomeEditForm_FormatDescription$1,
    dgUserOutcomeEditForm_GPA: dgUserOutcomeEditForm_GPA$1,
    dgUserOutcomeEditForm_GPAExample: dgUserOutcomeEditForm_GPAExample$1,
    dgUserOutcomeEditForm_HeldSkill: dgUserOutcomeEditForm_HeldSkill$1,
    dgUserOutcomeEditForm_IncludeTypicalCourses: dgUserOutcomeEditForm_IncludeTypicalCourses$1,
    dgUserOutcomeEditForm_IssuedBy: dgUserOutcomeEditForm_IssuedBy$1,
    dgUserOutcomeEditForm_IssuerUrl: dgUserOutcomeEditForm_IssuerUrl$1,
    dgUserOutcomeEditForm_MozillaBadge: dgUserOutcomeEditForm_MozillaBadge$1,
    dgUserOutcomeEditForm_OpenBadgeLabelFormat: dgUserOutcomeEditForm_OpenBadgeLabelFormat$1,
    dgUserOutcomeEditForm_OrganizedCharity: dgUserOutcomeEditForm_OrganizedCharity$1,
    dgUserOutcomeEditForm_OutsideUS: dgUserOutcomeEditForm_OutsideUS$1,
    dgUserOutcomeEditForm_QuantitativeDescriptions: dgUserOutcomeEditForm_QuantitativeDescriptions$1,
    dgUserOutcomeEditForm_RateProficiency: dgUserOutcomeEditForm_RateProficiency$1,
    dgUserOutcomeEditForm_SaveBadge: dgUserOutcomeEditForm_SaveBadge$1,
    dgUserOutcomeEditForm_SaveDegree: dgUserOutcomeEditForm_SaveDegree$1,
    dgUserOutcomeEditForm_SaveToProfile: dgUserOutcomeEditForm_SaveToProfile$1,
    dgUserOutcomeEditForm_SelectCategories: dgUserOutcomeEditForm_SelectCategories$1,
    dgUserOutcomeEditForm_SelectField: dgUserOutcomeEditForm_SelectField$1,
    dgUserOutcomeEditForm_SkilGrouping: dgUserOutcomeEditForm_SkilGrouping$1,
    dgUserOutcomeEditForm_SkillCandidateAbbrFormat: dgUserOutcomeEditForm_SkillCandidateAbbrFormat$1,
    dgUserOutcomeEditForm_SkillEvidence: dgUserOutcomeEditForm_SkillEvidence$1,
    dgUserOutcomeEditForm_SkillEvidenceAbbrFormat: dgUserOutcomeEditForm_SkillEvidenceAbbrFormat$1,
    dgUserOutcomeEditForm_SkillGrouping: dgUserOutcomeEditForm_SkillGrouping$1,
    dgUserOutcomeEditForm_SkillHistory: dgUserOutcomeEditForm_SkillHistory$1,
    dgUserOutcomeEditForm_SkillInstance: dgUserOutcomeEditForm_SkillInstance$1,
    dgUserOutcomeEditForm_SkillUse: dgUserOutcomeEditForm_SkillUse$1,
    dgUserOutcomeEditForm_SkillUseDetail: dgUserOutcomeEditForm_SkillUseDetail$1,
    dgUserOutcomeEditForm_SkillUseDetails: dgUserOutcomeEditForm_SkillUseDetails$1,
    dgUserOutcomeEditForm_StartDate: dgUserOutcomeEditForm_StartDate$1,
    dgUserOutcomeEditForm_TitleOfAward: dgUserOutcomeEditForm_TitleOfAward$1,
    dgUserOutcomeEditForm_TitleOfCertificate: dgUserOutcomeEditForm_TitleOfCertificate$1,
    dgUserOutcomeEditForm_TitleOfDegree: dgUserOutcomeEditForm_TitleOfDegree$1,
    dgUserOutcomeEditForm_UniversityCountry: dgUserOutcomeEditForm_UniversityCountry$1,
    dgUserOutcomeEditForm_UniversityName: dgUserOutcomeEditForm_UniversityName$1,
    dgUserOutcomeEditForm_UploadAnImage: dgUserOutcomeEditForm_UploadAnImage$1,
    dgUserOutcomeEditForm_UploadBadge: dgUserOutcomeEditForm_UploadBadge$1,
    dgUserOutcomeEditForm_UploadDegreeImage: dgUserOutcomeEditForm_UploadDegreeImage$1,
    dgUserOutcomeEditForm_UploadImageOfCertificate: dgUserOutcomeEditForm_UploadImageOfCertificate$1,
    dgUserOutcomeEditForm_WhatDidYouDo: dgUserOutcomeEditForm_WhatDidYouDo$1,
    dgUserOutcomeEditForm_WhatTimeSpan: dgUserOutcomeEditForm_WhatTimeSpan$1,
    dgUserOutcomeEditForm_WhenDidYouReceiveAward: dgUserOutcomeEditForm_WhenDidYouReceiveAward$1,
    dgUserOrganizationPicker_Everyone: dgUserOrganizationPicker_Everyone$1,
    dgUserOrganizationPicker_Loading: dgUserOrganizationPicker_Loading$1,
    dgUserOrganizationPicker_OnlyMe: dgUserOrganizationPicker_OnlyMe$1,
    dgUserInfo_LinkCopied: dgUserInfo_LinkCopied$1,
    dgUserGoalItem_ViewGroup: dgUserGoalItem_ViewGroup$1,
    dgUserEvaluationEndorsement_approved: dgUserEvaluationEndorsement_approved$1,
    dgUserEvaluationEndorsement_complete_endorsementRequested: dgUserEvaluationEndorsement_complete_endorsementRequested$1,
    dgUserEvaluationEndorsement_endorsementCompleted: dgUserEvaluationEndorsement_endorsementCompleted$1,
    dgUserEvaluationEndorsement_endorsementRequested: dgUserEvaluationEndorsement_endorsementRequested$1,
    dgUserEvaluationEndorsement_endorsementRequestedChanges: dgUserEvaluationEndorsement_endorsementRequestedChanges$1,
    dgUserEvaluationEndorsement_endosed: dgUserEvaluationEndorsement_endosed$1,
    dgUserEvaluationEndorsement_goToApplication: dgUserEvaluationEndorsement_goToApplication$1,
    dgUserEvaluationEndorsement_requestedChanges: dgUserEvaluationEndorsement_requestedChanges$1,
    dgUserDeleteProfile_DeletedProfileConfirmed: dgUserDeleteProfile_DeletedProfileConfirmed$1,
    dgUserDeleteProfile_DeleteProfileConfirmation: dgUserDeleteProfile_DeleteProfileConfirmation$1,
    dgUserDeleteProfile_No: dgUserDeleteProfile_No$1,
    dgUserDeleteProfile_Yes: dgUserDeleteProfile_Yes$1,
    dgTrackableLink_Trackable: dgTrackableLink_Trackable$1,
    dgTopGroups_AdministrativeGroup: dgTopGroups_AdministrativeGroup$1,
    dgTopGroups_ClosedGroup: dgTopGroups_ClosedGroup$1,
    dgTopGroups_Empty: dgTopGroups_Empty$1,
    dgTopGroups_LinkToGroups: dgTopGroups_LinkToGroups$1,
    dgTopGroups_PrivateGroup: dgTopGroups_PrivateGroup$1,
    dgThumbs_Dislike: dgThumbs_Dislike$1,
    dgThumbs_Like: dgThumbs_Like$1,
    dgThumbs_NotDisliked: dgThumbs_NotDisliked$1,
    dgThumbs_RemoveDislike: dgThumbs_RemoveDislike$1,
    dgThumbs_RemoveLike: dgThumbs_RemoveLike$1,
    dgThumbs_Undislike: dgThumbs_Undislike$1,
    dgThSort_SortAscendingFormat: dgThSort_SortAscendingFormat$1,
    dgThSort_SortDescendingFormat: dgThSort_SortDescendingFormat$1,
    dgThSort_SortedAscendingFormat: dgThSort_SortedAscendingFormat$1,
    dgThSort_SortedDescendingFormat: dgThSort_SortedDescendingFormat$1,
    dgTargetTile_PrimaryPlan: dgTargetTile_PrimaryPlan$1,
    dgTargetTile_SkillFormat: dgTargetTile_SkillFormat$1,
    dgTargetTile_SkillsFormat: dgTargetTile_SkillsFormat$1,
    dgTargetTile_UnfollowConfirm: dgTargetTile_UnfollowConfirm$1,
    dgTargetTile_UnfollowExplanation: dgTargetTile_UnfollowExplanation$1,
    dgTagsList_PlusCountMore: dgTagsList_PlusCountMore$1,
    dgTagsList_RemoveWorkdaySkillInfo: dgTagsList_RemoveWorkdaySkillInfo$1,
    dgTagsList_RemoveWorkdaySkillTitle: dgTagsList_RemoveWorkdaySkillTitle$1,
    dgTagsList_VisitWorkday: dgTagsList_VisitWorkday$1,
    dgTagsEdit_AddTagFormat: dgTagsEdit_AddTagFormat$1,
    dgTagsEdit_PlusAdd: dgTagsEdit_PlusAdd$1,
    dgTagsEdit_RemoveTagFormat: dgTagsEdit_RemoveTagFormat$1,
    dgTagsEdit_View_More_Button: dgTagsEdit_View_More_Button$1,
    dgTagsEdit_WhatDidYouLearn: dgTagsEdit_WhatDidYouLearn$1,
    dgTagsEdit_WhoopsFormat: dgTagsEdit_WhoopsFormat$1,
    dgTagRating_A11yAddFocusSkill: dgTagRating_A11yAddFocusSkill$1,
    dgTagRating_A11yAddSelfRating: dgTagRating_A11yAddSelfRating$1,
    dgTagRating_A11yAddSkillReview: dgTagRating_A11yAddSkillReview$1,
    dgTagRating_A11yAddSkillTarget: dgTagRating_A11yAddSkillTarget$1,
    dgTagRating_A11yChangeSelfRating: dgTagRating_A11yChangeSelfRating$1,
    dgTagRating_A11yRemoveFocusSkill: dgTagRating_A11yRemoveFocusSkill$1,
    dgTagRating_A11yRequestManagerRating: dgTagRating_A11yRequestManagerRating$1,
    dgTagRating_A11yRequestPeerRating: dgTagRating_A11yRequestPeerRating$1,
    dgTagRating_A11yRequestUpdateManagerRating: dgTagRating_A11yRequestUpdateManagerRating$1,
    dgTagRating_A11yRequestUpdatePeerRating: dgTagRating_A11yRequestUpdatePeerRating$1,
    dgTagRating_A11ySelfRatingCount: dgTagRating_A11ySelfRatingCount$1,
    dgTagRating_A11ySkillOptions: dgTagRating_A11ySkillOptions$1,
    dgTagRating_A11ySkillReviewComplete: dgTagRating_A11ySkillReviewComplete$1,
    dgTagRating_A11ySkillReviewInProgress: dgTagRating_A11ySkillReviewInProgress$1,
    dgTagRating_A11ySkillSignalCounts: dgTagRating_A11ySkillSignalCounts$1,
    dgTagRating_A11ySkillTarget: dgTagRating_A11ySkillTarget$1,
    dgTagRating_A11yTotalRatingCounts: dgTagRating_A11yTotalRatingCounts$1,
    dgTagRating_AddA11y: dgTagRating_AddA11y$1,
    dgTagRating_AddCredential: dgTagRating_AddCredential$1,
    dgTagRating_Added: dgTagRating_Added$1,
    dgTagRating_AddedA11y: dgTagRating_AddedA11y$1,
    dgTagRating_AddedIntegrationSkillsProfileDetails: dgTagRating_AddedIntegrationSkillsProfileDetails$1,
    dgTagRating_AddEvalRating: dgTagRating_AddEvalRating$1,
    dgTagRating_AddEvaluation: dgTagRating_AddEvaluation$1,
    dgTagRating_AddExternalRatingDetail: dgTagRating_AddExternalRatingDetail$1,
    dgTagRating_AddFocusSkill: dgTagRating_AddFocusSkill$1,
    dgTagRating_AddFocusSkillItem: dgTagRating_AddFocusSkillItem$1,
    dgTagRating_AddingRatingsToPersonalize: dgTagRating_AddingRatingsToPersonalize$1,
    dgTagRating_AddManagerTarget: dgTagRating_AddManagerTarget$1,
    dgTagRating_AddRating: dgTagRating_AddRating$1,
    dgTagRating_AddRatingError: dgTagRating_AddRatingError$1,
    dgTagRating_AddSelfAssessment: dgTagRating_AddSelfAssessment$1,
    dgTagRating_AddSelfRating: dgTagRating_AddSelfRating$1,
    dgTagRating_AddSelfRatingDetail: dgTagRating_AddSelfRatingDetail$1,
    dgTagRating_AddSkillLevel: dgTagRating_AddSkillLevel$1,
    dgTagRating_AddSkills: dgTagRating_AddSkills$1,
    dgTagRating_AddSkillTarget: dgTagRating_AddSkillTarget$1,
    dgTagRating_AddToMySkills: dgTagRating_AddToMySkills$1,
    dgTagRating_AddToProfile: dgTagRating_AddToProfile$1,
    dgTagRating_AddToProfileTooltip: dgTagRating_AddToProfileTooltip$1,
    dgTagRating_Advanced: dgTagRating_Advanced$1,
    dgTagRating_AssessmentScore: dgTagRating_AssessmentScore$1,
    dgTagRating_Autonomy: dgTagRating_Autonomy$1,
    dgTagRating_Autonomy_Desc_Scale6_1: dgTagRating_Autonomy_Desc_Scale6_1$1,
    dgTagRating_Autonomy_Desc_Scale6_2: dgTagRating_Autonomy_Desc_Scale6_2$1,
    dgTagRating_Autonomy_Desc_Scale6_3: dgTagRating_Autonomy_Desc_Scale6_3$1,
    dgTagRating_Autonomy_Desc_Scale6_4: dgTagRating_Autonomy_Desc_Scale6_4$1,
    dgTagRating_Autonomy_Desc_Scale6_5: dgTagRating_Autonomy_Desc_Scale6_5$1,
    dgTagRating_Autonomy_Desc_Scale6_6: dgTagRating_Autonomy_Desc_Scale6_6$1,
    dgTagRating_Autonomy_Desc_Scale8_1: dgTagRating_Autonomy_Desc_Scale8_1$1,
    dgTagRating_Autonomy_Desc_Scale8_2: dgTagRating_Autonomy_Desc_Scale8_2$1,
    dgTagRating_Autonomy_Desc_Scale8_3: dgTagRating_Autonomy_Desc_Scale8_3$1,
    dgTagRating_Autonomy_Desc_Scale8_4: dgTagRating_Autonomy_Desc_Scale8_4$1,
    dgTagRating_Autonomy_Desc_Scale8_5: dgTagRating_Autonomy_Desc_Scale8_5$1,
    dgTagRating_Autonomy_Desc_Scale8_6: dgTagRating_Autonomy_Desc_Scale8_6$1,
    dgTagRating_Autonomy_Desc_Scale8_7: dgTagRating_Autonomy_Desc_Scale8_7$1,
    dgTagRating_Autonomy_Desc_Scale8_8: dgTagRating_Autonomy_Desc_Scale8_8$1,
    dgTagRating_AverageLevel: dgTagRating_AverageLevel$1,
    dgTagRating_Beginner: dgTagRating_Beginner$1,
    dgTagRating_CancelEval: dgTagRating_CancelEval$1,
    dgTagRating_CancelMgrRatingRequest: dgTagRating_CancelMgrRatingRequest$1,
    dgTagRating_CancelPeerRequests: dgTagRating_CancelPeerRequests$1,
    dgTagRating_CancelPeerRequestsDesc: dgTagRating_CancelPeerRequestsDesc$1,
    dgTagRating_CancelRequest: dgTagRating_CancelRequest$1,
    dgTagRating_Capable: dgTagRating_Capable$1,
    dgTagRating_CertVisibility: dgTagRating_CertVisibility$1,
    dgTagRating_ChangeManagerRating: dgTagRating_ChangeManagerRating$1,
    dgTagRating_ChangePeerRating: dgTagRating_ChangePeerRating$1,
    dgTagRating_ChangeSkillTarget: dgTagRating_ChangeSkillTarget$1,
    dgTagRating_Checkpoint: dgTagRating_Checkpoint$1,
    dgTagRating_Checkpoints: dgTagRating_Checkpoints$1,
    dgTagRating_ClearCurrentRating: dgTagRating_ClearCurrentRating$1,
    dgTagRating_ClearCurrentTarget: dgTagRating_ClearCurrentTarget$1,
    dgTagRating_CommentPlaceholderFormat: dgTagRating_CommentPlaceholderFormat$1,
    dgTagRating_Comments: dgTagRating_Comments$1,
    dgTagRating_commentVisible: dgTagRating_commentVisible$1,
    dgTagRating_CompleteCheckpoints: dgTagRating_CompleteCheckpoints$1,
    dgTagRating_ContinueEvaluation: dgTagRating_ContinueEvaluation$1,
    dgTagRating_ContinueProcess: dgTagRating_ContinueProcess$1,
    dgTagRating_Credential: dgTagRating_Credential$1,
    dgTagRating_Critical_RemoveFromProfileConfirmation: dgTagRating_Critical_RemoveFromProfileConfirmation$1,
    dgTagRating_CurrentManagerRating: dgTagRating_CurrentManagerRating$1,
    dgTagRating_CurrentPeerRating: dgTagRating_CurrentPeerRating$1,
    dgTagRating_CurrentSkillTarget: dgTagRating_CurrentSkillTarget$1,
    dgTagRating_DeactivatedUser: dgTagRating_DeactivatedUser$1,
    dgTagRating_DegreedCertification: dgTagRating_DegreedCertification$1,
    dgTagRating_DegreedCertified: dgTagRating_DegreedCertified$1,
    dgTagRating_DescribeRatingSelected: dgTagRating_DescribeRatingSelected$1,
    dgTagRating_descriptionPlaceholderManagerRating: dgTagRating_descriptionPlaceholderManagerRating$1,
    dgTagRating_descriptionPlaceholderPeerRating: dgTagRating_descriptionPlaceholderPeerRating$1,
    dgTagRating_descriptionPlaceholderSkillTarget: dgTagRating_descriptionPlaceholderSkillTarget$1,
    dgTagRating_Distinguished: dgTagRating_Distinguished$1,
    dgTagRating_DoneRating: dgTagRating_DoneRating$1,
    dgTagRating_EditExpertise: dgTagRating_EditExpertise$1,
    dgTagRating_EditExpertiseLabel: dgTagRating_EditExpertiseLabel$1,
    dgTagRating_Effective: dgTagRating_Effective$1,
    dgTagRating_EndorsedByFormat: dgTagRating_EndorsedByFormat$1,
    dgTagRating_Evaluation: dgTagRating_Evaluation$1,
    dgTagRating_EvalVisibility: dgTagRating_EvalVisibility$1,
    dgTagRating_Experienced: dgTagRating_Experienced$1,
    dgTagRating_Expert: dgTagRating_Expert$1,
    dgTagRating_FocusSkillAdded: dgTagRating_FocusSkillAdded$1,
    dgTagRating_FoundIntegrationSkillsProfileDetails: dgTagRating_FoundIntegrationSkillsProfileDetails$1,
    dgTagRating_GetCertificate: dgTagRating_GetCertificate$1,
    dgTagRating_Industry: dgTagRating_Industry$1,
    dgTagRating_Industry_Desc_Scale6_1: dgTagRating_Industry_Desc_Scale6_1$1,
    dgTagRating_Industry_Desc_Scale6_2: dgTagRating_Industry_Desc_Scale6_2$1,
    dgTagRating_Industry_Desc_Scale6_3: dgTagRating_Industry_Desc_Scale6_3$1,
    dgTagRating_Industry_Desc_Scale6_4: dgTagRating_Industry_Desc_Scale6_4$1,
    dgTagRating_Industry_Desc_Scale6_5: dgTagRating_Industry_Desc_Scale6_5$1,
    dgTagRating_Industry_Desc_Scale6_6: dgTagRating_Industry_Desc_Scale6_6$1,
    dgTagRating_Industry_Desc_Scale8_1: dgTagRating_Industry_Desc_Scale8_1$1,
    dgTagRating_Industry_Desc_Scale8_2: dgTagRating_Industry_Desc_Scale8_2$1,
    dgTagRating_Industry_Desc_Scale8_3: dgTagRating_Industry_Desc_Scale8_3$1,
    dgTagRating_Industry_Desc_Scale8_4: dgTagRating_Industry_Desc_Scale8_4$1,
    dgTagRating_Industry_Desc_Scale8_5: dgTagRating_Industry_Desc_Scale8_5$1,
    dgTagRating_Industry_Desc_Scale8_6: dgTagRating_Industry_Desc_Scale8_6$1,
    dgTagRating_Industry_Desc_Scale8_7: dgTagRating_Industry_Desc_Scale8_7$1,
    dgTagRating_Industry_Desc_Scale8_8: dgTagRating_Industry_Desc_Scale8_8$1,
    dgTagRating_InProgress: dgTagRating_InProgress$1,
    dgTagRating_Intermediate: dgTagRating_Intermediate$1,
    dgTagRating_InvalidRequest: dgTagRating_InvalidRequest$1,
    dgTagRating_Knowledge: dgTagRating_Knowledge$1,
    dgTagRating_Knowledge_Desc_Scale6_1: dgTagRating_Knowledge_Desc_Scale6_1$1,
    dgTagRating_Knowledge_Desc_Scale6_2: dgTagRating_Knowledge_Desc_Scale6_2$1,
    dgTagRating_Knowledge_Desc_Scale6_3: dgTagRating_Knowledge_Desc_Scale6_3$1,
    dgTagRating_Knowledge_Desc_Scale6_4: dgTagRating_Knowledge_Desc_Scale6_4$1,
    dgTagRating_Knowledge_Desc_Scale6_5: dgTagRating_Knowledge_Desc_Scale6_5$1,
    dgTagRating_Knowledge_Desc_Scale6_6: dgTagRating_Knowledge_Desc_Scale6_6$1,
    dgTagRating_Knowledge_Desc_Scale8_1: dgTagRating_Knowledge_Desc_Scale8_1$1,
    dgTagRating_Knowledge_Desc_Scale8_2: dgTagRating_Knowledge_Desc_Scale8_2$1,
    dgTagRating_Knowledge_Desc_Scale8_3: dgTagRating_Knowledge_Desc_Scale8_3$1,
    dgTagRating_Knowledge_Desc_Scale8_4: dgTagRating_Knowledge_Desc_Scale8_4$1,
    dgTagRating_Knowledge_Desc_Scale8_5: dgTagRating_Knowledge_Desc_Scale8_5$1,
    dgTagRating_Knowledge_Desc_Scale8_6: dgTagRating_Knowledge_Desc_Scale8_6$1,
    dgTagRating_Knowledge_Desc_Scale8_7: dgTagRating_Knowledge_Desc_Scale8_7$1,
    dgTagRating_Knowledge_Desc_Scale8_8: dgTagRating_Knowledge_Desc_Scale8_8$1,
    dgTagRating_LastRated: dgTagRating_LastRated$1,
    dgTagRating_Level: dgTagRating_Level$1,
    dgTagRating_LevelDescription: dgTagRating_LevelDescription$1,
    dgTagRating_Levels: dgTagRating_Levels$1,
    dgTagRating_LevelUp: dgTagRating_LevelUp$1,
    dgTagRating_LevelUp_Desc_Scale6_1: dgTagRating_LevelUp_Desc_Scale6_1$1,
    dgTagRating_LevelUp_Desc_Scale6_2: dgTagRating_LevelUp_Desc_Scale6_2$1,
    dgTagRating_LevelUp_Desc_Scale6_3: dgTagRating_LevelUp_Desc_Scale6_3$1,
    dgTagRating_LevelUp_Desc_Scale6_4: dgTagRating_LevelUp_Desc_Scale6_4$1,
    dgTagRating_LevelUp_Desc_Scale6_5: dgTagRating_LevelUp_Desc_Scale6_5$1,
    dgTagRating_LevelUp_Desc_Scale6_6: dgTagRating_LevelUp_Desc_Scale6_6$1,
    dgTagRating_LevelUp_Desc_Scale8_1: dgTagRating_LevelUp_Desc_Scale8_1$1,
    dgTagRating_LevelUp_Desc_Scale8_2: dgTagRating_LevelUp_Desc_Scale8_2$1,
    dgTagRating_LevelUp_Desc_Scale8_3: dgTagRating_LevelUp_Desc_Scale8_3$1,
    dgTagRating_LevelUp_Desc_Scale8_4: dgTagRating_LevelUp_Desc_Scale8_4$1,
    dgTagRating_LevelUp_Desc_Scale8_5: dgTagRating_LevelUp_Desc_Scale8_5$1,
    dgTagRating_LevelUp_Desc_Scale8_6: dgTagRating_LevelUp_Desc_Scale8_6$1,
    dgTagRating_LevelUp_Desc_Scale8_7: dgTagRating_LevelUp_Desc_Scale8_7$1,
    dgTagRating_LevelUp_Desc_Scale8_8: dgTagRating_LevelUp_Desc_Scale8_8$1,
    dgTagRating_LinkedSkillsNumber: dgTagRating_LinkedSkillsNumber$1,
    dgTagRating_ManagerAssessment: dgTagRating_ManagerAssessment$1,
    dgTagRating_ManagerRating: dgTagRating_ManagerRating$1,
    dgTagRating_ManagerRatinginProgress: dgTagRating_ManagerRatinginProgress$1,
    dgTagRating_Master: dgTagRating_Master$1,
    dgTagRating_MeasureYourSkill: dgTagRating_MeasureYourSkill$1,
    dgTagRating_MngrRatingRequestCancelled: dgTagRating_MngrRatingRequestCancelled$1,
    dgTagRating_ModalButtonAddWithoutRating: dgTagRating_ModalButtonAddWithoutRating$1,
    dgTagRating_ModalButtonAddWithRating: dgTagRating_ModalButtonAddWithRating$1,
    dgTagRating_MyRatings: dgTagRating_MyRatings$1,
    dgTagRating_NewManagerRating: dgTagRating_NewManagerRating$1,
    dgTagRating_NewPeerRating: dgTagRating_NewPeerRating$1,
    dgTagRating_NewSkillTarget: dgTagRating_NewSkillTarget$1,
    dgTagRating_NoRatings: dgTagRating_NoRatings$1,
    dgTagRating_NoSkillTarget: dgTagRating_NoSkillTarget$1,
    dgTagRating_NoTargetLevelAssigned: dgTagRating_NoTargetLevelAssigned$1,
    dgTagRating_NumberOfRatings: dgTagRating_NumberOfRatings$1,
    dgTagRating_OtherRatings: dgTagRating_OtherRatings$1,
    dgTagRating_PeerRating: dgTagRating_PeerRating$1,
    dgTagRating_PeerRatingRequestCancelled: dgTagRating_PeerRatingRequestCancelled$1,
    dgTagRating_PeerRatings: dgTagRating_PeerRatings$1,
    dgTagRating_PeerRatingsTitle: dgTagRating_PeerRatingsTitle$1,
    dgTagRating_PeerRequestCountWarning: dgTagRating_PeerRequestCountWarning$1,
    dgTagRating_PendingSelfRatingRequest: dgTagRating_PendingSelfRatingRequest$1,
    dgTagRating_PrivacyPopoverDesc: dgTagRating_PrivacyPopoverDesc$1,
    dgTagRating_PrivacyPopoverTitle: dgTagRating_PrivacyPopoverTitle$1,
    dgTagRating_PrivateToYou: dgTagRating_PrivateToYou$1,
    dgTagRating_ProviderLogo: dgTagRating_ProviderLogo$1,
    dgTagRating_ProviderSkillLabel: dgTagRating_ProviderSkillLabel$1,
    dgTagRating_RatedByFormat: dgTagRating_RatedByFormat$1,
    dgTagRating_RateNewSkills: dgTagRating_RateNewSkills$1,
    dgTagRating_RateSkills: dgTagRating_RateSkills$1,
    dgTagRating_Rating: dgTagRating_Rating$1,
    dgTagRating_RatingInProgress: dgTagRating_RatingInProgress$1,
    dgTagRating_RatingNotValid: dgTagRating_RatingNotValid$1,
    dgTagRating_RatingNotValidNewRating: dgTagRating_RatingNotValidNewRating$1,
    dgTagRating_RatingOtherTitleFormat: dgTagRating_RatingOtherTitleFormat$1,
    dgTagRating_RatingPendingFormat: dgTagRating_RatingPendingFormat$1,
    dgTagRating_RatingRequestCancelled: dgTagRating_RatingRequestCancelled$1,
    dgTagRating_RatingRequested: dgTagRating_RatingRequested$1,
    dgTagRating_RatingRequestedAge: dgTagRating_RatingRequestedAge$1,
    dgTagRating_RatingsRequested: dgTagRating_RatingsRequested$1,
    dgTagRating_RatingTitleFormat: dgTagRating_RatingTitleFormat$1,
    dgTagRating_RatingType: dgTagRating_RatingType$1,
    dgTagRating_RecommendSkill: dgTagRating_RecommendSkill$1,
    dgTagRating_RemoveA11y: dgTagRating_RemoveA11y$1,
    dgTagRating_RemoveA11ySkill: dgTagRating_RemoveA11ySkill$1,
    dgTagRating_RemoveFocusSkill: dgTagRating_RemoveFocusSkill$1,
    dgTagRating_RemoveFocusSkillItem: dgTagRating_RemoveFocusSkillItem$1,
    dgTagRating_RemoveFromPlan: dgTagRating_RemoveFromPlan$1,
    dgTagRating_RemoveFromPlanA11y: dgTagRating_RemoveFromPlanA11y$1,
    dgTagRating_RemoveFromProfile: dgTagRating_RemoveFromProfile$1,
    dgTagRating_RemoveFromProfileConfirmation: dgTagRating_RemoveFromProfileConfirmation$1,
    dgTagRating_RemoveFromProfileTooltip: dgTagRating_RemoveFromProfileTooltip$1,
    dgTagRating_RequestedRatings: dgTagRating_RequestedRatings$1,
    dgTagRating_RequestManagerAssessment: dgTagRating_RequestManagerAssessment$1,
    dgTagRating_RequestManagerRating: dgTagRating_RequestManagerRating$1,
    dgTagRating_RequestManagerRatingInstruction: dgTagRating_RequestManagerRatingInstruction$1,
    dgTagRating_RequestNewRating: dgTagRating_RequestNewRating$1,
    dgTagRating_RequestNotValid: dgTagRating_RequestNotValid$1,
    dgTagRating_RequestPeerRating: dgTagRating_RequestPeerRating$1,
    dgTagRating_RequestPeerRatingInstruction: dgTagRating_RequestPeerRatingInstruction$1,
    dgTagRating_RequestRating: dgTagRating_RequestRating$1,
    dgTagRating_RequestSelfNotificationFormat: dgTagRating_RequestSelfNotificationFormat$1,
    dgTagRating_RequestSelfRatingForFormat: dgTagRating_RequestSelfRatingForFormat$1,
    dgTagRating_RequestsPending: dgTagRating_RequestsPending$1,
    dgTagRating_RestartEval: dgTagRating_RestartEval$1,
    dgTagRating_ReviewSkillsNewRatings: dgTagRating_ReviewSkillsNewRatings$1,
    dgTagRating_saveNewRating: dgTagRating_saveNewRating$1,
    dgTagRating_saveNewTarget: dgTagRating_saveNewTarget$1,
    dgTagRating_SearchCollection: dgTagRating_SearchCollection$1,
    dgTagRating_SelectManager: dgTagRating_SelectManager$1,
    dgTagRating_SelectRating: dgTagRating_SelectRating$1,
    dgTagRating_SelfAssessment: dgTagRating_SelfAssessment$1,
    dgTagRating_SelfAssessmentItem: dgTagRating_SelfAssessmentItem$1,
    dgTagRating_SelfRatingRequestCancelled: dgTagRating_SelfRatingRequestCancelled$1,
    dgTagRating_SelfRatingRequested: dgTagRating_SelfRatingRequested$1,
    dgTagRating_SelfRatingUpdated: dgTagRating_SelfRatingUpdated$1,
    dgTagRating_ShareTag: dgTagRating_ShareTag$1,
    dgTagRating_SignalCountPlural: dgTagRating_SignalCountPlural$1,
    dgTagRating_SignalCountSingle: dgTagRating_SignalCountSingle$1,
    dgTagRating_SkillCertification: dgTagRating_SkillCertification$1,
    dgTagRating_SkillCertInProgress: dgTagRating_SkillCertInProgress$1,
    dgTagRating_SkillReviewInProgress: dgTagRating_SkillReviewInProgress$1,
    dgTagRating_StartCredential: dgTagRating_StartCredential$1,
    dgTagRating_StartEvaluation: dgTagRating_StartEvaluation$1,
    dgTagRating_SubmitNext: dgTagRating_SubmitNext$1,
    dgTagRating_SuccessfullyAddedSkills: dgTagRating_SuccessfullyAddedSkills$1,
    dgTagRating_SummaryLevel1: dgTagRating_SummaryLevel1$1,
    dgTagRating_SummaryLevel2: dgTagRating_SummaryLevel2$1,
    dgTagRating_SummaryLevel3: dgTagRating_SummaryLevel3$1,
    dgTagRating_SummaryLevel4: dgTagRating_SummaryLevel4$1,
    dgTagRating_SummaryLevel5: dgTagRating_SummaryLevel5$1,
    dgTagRating_SummaryLevel6: dgTagRating_SummaryLevel6$1,
    dgTagRating_SummaryLevel7: dgTagRating_SummaryLevel7$1,
    dgTagRating_SummaryLevel8: dgTagRating_SummaryLevel8$1,
    dgTagRating_SummaryScale6_Level1: dgTagRating_SummaryScale6_Level1$1,
    dgTagRating_SummaryScale6_Level2: dgTagRating_SummaryScale6_Level2$1,
    dgTagRating_SummaryScale6_Level3: dgTagRating_SummaryScale6_Level3$1,
    dgTagRating_SummaryScale6_Level4: dgTagRating_SummaryScale6_Level4$1,
    dgTagRating_SummaryScale6_Level5: dgTagRating_SummaryScale6_Level5$1,
    dgTagRating_SummaryScale6_Level6: dgTagRating_SummaryScale6_Level6$1,
    dgTagRating_SummaryScale8_Level1: dgTagRating_SummaryScale8_Level1$1,
    dgTagRating_SummaryScale8_Level2: dgTagRating_SummaryScale8_Level2$1,
    dgTagRating_SummaryScale8_Level3: dgTagRating_SummaryScale8_Level3$1,
    dgTagRating_SummaryScale8_Level4: dgTagRating_SummaryScale8_Level4$1,
    dgTagRating_SummaryScale8_Level5: dgTagRating_SummaryScale8_Level5$1,
    dgTagRating_SummaryScale8_Level6: dgTagRating_SummaryScale8_Level6$1,
    dgTagRating_SummaryScale8_Level7: dgTagRating_SummaryScale8_Level7$1,
    dgTagRating_SummaryScale8_Level8: dgTagRating_SummaryScale8_Level8$1,
    dgTagRating_TakeCheckpoint: dgTagRating_TakeCheckpoint$1,
    dgTagRating_TargetCommentPlaceholderFormat: dgTagRating_TargetCommentPlaceholderFormat$1,
    dgTagRating_TargetLevel: dgTagRating_TargetLevel$1,
    dgTagRating_TargetRatingUpdated: dgTagRating_TargetRatingUpdated$1,
    dgTagRating_TasksTools: dgTagRating_TasksTools$1,
    dgTagRating_TasksTools_Desc_Scale6_1: dgTagRating_TasksTools_Desc_Scale6_1$1,
    dgTagRating_TasksTools_Desc_Scale6_2: dgTagRating_TasksTools_Desc_Scale6_2$1,
    dgTagRating_TasksTools_Desc_Scale6_3: dgTagRating_TasksTools_Desc_Scale6_3$1,
    dgTagRating_TasksTools_Desc_Scale6_4: dgTagRating_TasksTools_Desc_Scale6_4$1,
    dgTagRating_TasksTools_Desc_Scale6_5: dgTagRating_TasksTools_Desc_Scale6_5$1,
    dgTagRating_TasksTools_Desc_Scale6_6: dgTagRating_TasksTools_Desc_Scale6_6$1,
    dgTagRating_TasksTools_Desc_Scale8_1: dgTagRating_TasksTools_Desc_Scale8_1$1,
    dgTagRating_TasksTools_Desc_Scale8_2: dgTagRating_TasksTools_Desc_Scale8_2$1,
    dgTagRating_TasksTools_Desc_Scale8_3: dgTagRating_TasksTools_Desc_Scale8_3$1,
    dgTagRating_TasksTools_Desc_Scale8_4: dgTagRating_TasksTools_Desc_Scale8_4$1,
    dgTagRating_TasksTools_Desc_Scale8_5: dgTagRating_TasksTools_Desc_Scale8_5$1,
    dgTagRating_TasksTools_Desc_Scale8_6: dgTagRating_TasksTools_Desc_Scale8_6$1,
    dgTagRating_TasksTools_Desc_Scale8_7: dgTagRating_TasksTools_Desc_Scale8_7$1,
    dgTagRating_TasksTools_Desc_Scale8_8: dgTagRating_TasksTools_Desc_Scale8_8$1,
    dgTagRating_TotalRatings: dgTagRating_TotalRatings$1,
    dgTagRating_Unrated: dgTagRating_Unrated$1,
    dgTagRating_UnratedDescription: dgTagRating_UnratedDescription$1,
    dgTagRating_UnratedPeerRatingDescription: dgTagRating_UnratedPeerRatingDescription$1,
    dgTagRating_UnratedSkillTargetDescription: dgTagRating_UnratedSkillTargetDescription$1,
    dgTagRating_UpdatedManagerRating: dgTagRating_UpdatedManagerRating$1,
    dgTagRating_UpdatedNewRating: dgTagRating_UpdatedNewRating$1,
    dgTagRating_UpdatedPeerRating: dgTagRating_UpdatedPeerRating$1,
    dgTagRating_UpdatedSkillTarget: dgTagRating_UpdatedSkillTarget$1,
    dgTagRating_UpdateRating: dgTagRating_UpdateRating$1,
    dgTagRating_ViewCertificate: dgTagRating_ViewCertificate$1,
    dgTagRating_ViewCheckpoints: dgTagRating_ViewCheckpoints$1,
    dgTagRating_ViewExternalRating: dgTagRating_ViewExternalRating$1,
    dgTagRating_ViewLevelBreakdown: dgTagRating_ViewLevelBreakdown$1,
    dgTagRating_ViewLevelDescription: dgTagRating_ViewLevelDescription$1,
    dgTagRating_ViewNewRatingScale: dgTagRating_ViewNewRatingScale$1,
    dgTagRating_ViewRating: dgTagRating_ViewRating$1,
    dgTagRating_ViewRatingLabel: dgTagRating_ViewRatingLabel$1,
    dgTagRating_ViewRatings: dgTagRating_ViewRatings$1,
    dgTagRating_ViewRatingScale: dgTagRating_ViewRatingScale$1,
    dgTagRating_ViewScoreBreakdown: dgTagRating_ViewScoreBreakdown$1,
    dgTagRating_ViewSkill: dgTagRating_ViewSkill$1,
    dgTagRating_VisibleToOrg: dgTagRating_VisibleToOrg$1,
    dgTagRating_VisibleToPublic: dgTagRating_VisibleToPublic$1,
    dgTagRating_VisibleToYou: dgTagRating_VisibleToYou$1,
    dgTagRating_YourCurrentRating: dgTagRating_YourCurrentRating$1,
    dgSocialConnectSuccess_TitleFormat: dgSocialConnectSuccess_TitleFormat$1,
    dgSocialConnectionJoined_TitleFormat: dgSocialConnectionJoined_TitleFormat$1,
    dgSkipNav_SkipMainNavigation: dgSkipNav_SkipMainNavigation$1,
    dgSkipNav_SkipSidebar: dgSkipNav_SkipSidebar$1,
    dgSkipNav_SkipSubNavigation: dgSkipNav_SkipSubNavigation$1,
    dgSkipNav_SkipToMainContent: dgSkipNav_SkipToMainContent$1,
    dgSkipNav_SkipToSearchResults: dgSkipNav_SkipToSearchResults$1,
    dgSkillSignalRatings_PrivacyInfo: dgSkillSignalRatings_PrivacyInfo$1,
    dgSkillSignal_BarChartSubheading: dgSkillSignal_BarChartSubheading$1,
    dgSkillSignal_OtherTypes: dgSkillSignal_OtherTypes$1,
    dgSkillsCheckup_DoneRating: dgSkillsCheckup_DoneRating$1,
    dgSkillsCheckup_message: dgSkillsCheckup_message$1,
    dgSkillsCheckup_UpdateRatings: dgSkillsCheckup_UpdateRatings$1,
    dgReorder_A11yItemMovedFormat: dgReorder_A11yItemMovedFormat$1,
    dgReorder_MoveNext: dgReorder_MoveNext$1,
    dgReorder_MovePrev: dgReorder_MovePrev$1,
    dgReorder_NoTitleText: dgReorder_NoTitleText$1,
    dgReorder_SaveChanges: dgReorder_SaveChanges$1,
    dgRelatedInputs_Related: dgRelatedInputs_Related$1,
    dgRecommendationsStatus_ByHeader: dgRecommendationsStatus_ByHeader$1,
    dgRecommendationsStatus_Empty: dgRecommendationsStatus_Empty$1,
    dgRecommendationsStatus_HeaderAssignedTo: dgRecommendationsStatus_HeaderAssignedTo$1,
    dgRecommendationsStatus_HeaderCreatedDate: dgRecommendationsStatus_HeaderCreatedDate$1,
    dgRecommendationsStatus_HeaderDueDate: dgRecommendationsStatus_HeaderDueDate$1,
    dgRecommendationsStatus_HeaderPercentComplete: dgRecommendationsStatus_HeaderPercentComplete$1,
    dgRecommendationsStatus_HeaderTitle: dgRecommendationsStatus_HeaderTitle$1,
    dgRecommendationsOverview_About: dgRecommendationsOverview_About$1,
    dgRecommendationsOverview_AboutConsumer: dgRecommendationsOverview_AboutConsumer$1,
    dgRecommendationsOverview_AlreadyCompletedAssignedByFormat: dgRecommendationsOverview_AlreadyCompletedAssignedByFormat$1,
    dgRecommendationsOverview_AlreadyCompletedAssignedYouFormat: dgRecommendationsOverview_AlreadyCompletedAssignedYouFormat$1,
    dgRecommendationsOverview_AlreadyCompletedRecommendedByFormat: dgRecommendationsOverview_AlreadyCompletedRecommendedByFormat$1,
    dgRecommendationsOverview_AlreadyCompletedRecommendedYouFormat: dgRecommendationsOverview_AlreadyCompletedRecommendedYouFormat$1,
    dgRecommendationsOverview_AssignedByFormat: dgRecommendationsOverview_AssignedByFormat$1,
    dgRecommendationsOverview_AssignedYouFormat: dgRecommendationsOverview_AssignedYouFormat$1,
    dgRecommendationsOverview_Description: dgRecommendationsOverview_Description$1,
    dgRecommendationsOverview_EmptyStateDescription: dgRecommendationsOverview_EmptyStateDescription$1,
    dgRecommendationsOverview_EmptyStateTitle: dgRecommendationsOverview_EmptyStateTitle$1,
    dgRecommendationsOverview_EmptyTitle: dgRecommendationsOverview_EmptyTitle$1,
    dgRecommendationsOverview_Filter: dgRecommendationsOverview_Filter$1,
    dgRecommendationsOverview_Incomplete: dgRecommendationsOverview_Incomplete$1,
    dgRecommendationsOverview_RecommendedByFormat: dgRecommendationsOverview_RecommendedByFormat$1,
    dgRecommendationsOverview_RecommendedByFormerLearnerFormat: dgRecommendationsOverview_RecommendedByFormerLearnerFormat$1,
    dgRecommendationsOverview_RecommendedByNoCreatorFormat: dgRecommendationsOverview_RecommendedByNoCreatorFormat$1,
    dgRecommendationsOverview_RecommendedYouFormat: dgRecommendationsOverview_RecommendedYouFormat$1,
    dgRecommendationsOverview_RecommendedYouFormerLearnerFormat: dgRecommendationsOverview_RecommendedYouFormerLearnerFormat$1,
    dgRecommendationsOverview_RecommendedYouNoCreatorFormat: dgRecommendationsOverview_RecommendedYouNoCreatorFormat$1,
    dgRatingButtonMeta_1Hour: dgRatingButtonMeta_1Hour$1,
    dgRatingButtonMeta_HoursFormat: dgRatingButtonMeta_HoursFormat$1,
    dgProviderLicense_CreateLicenseBtnFormat: dgProviderLicense_CreateLicenseBtnFormat$1,
    dgProviderLicense_GenerateLicenseFormat: dgProviderLicense_GenerateLicenseFormat$1,
    dgProfileShareActivity_DateShared: dgProfileShareActivity_DateShared$1,
    dgProfileShareActivity_GroupsSharedWith: dgProfileShareActivity_GroupsSharedWith$1,
    dgProfileShareActivity_NumCommentsPlural: dgProfileShareActivity_NumCommentsPlural$1,
    dgProfileShareActivity_NumCommentsSingular: dgProfileShareActivity_NumCommentsSingular$1,
    dgProfileShareActivity_NumGroupsSharedWithPlural: dgProfileShareActivity_NumGroupsSharedWithPlural$1,
    dgProfileShareActivity_NumGroupsSharedWithSingular: dgProfileShareActivity_NumGroupsSharedWithSingular$1,
    dgProfileShareActivity_NumPeopleSharedWithPlural: dgProfileShareActivity_NumPeopleSharedWithPlural$1,
    dgProfileShareActivity_NumPeopleSharedWithSingular: dgProfileShareActivity_NumPeopleSharedWithSingular$1,
    dgProfileShareActivity_PeopleSharedWith: dgProfileShareActivity_PeopleSharedWith$1,
    dgProfileShareActivity_ShareActivity: dgProfileShareActivity_ShareActivity$1,
    dgProfileOverview_AchievementReported: dgProfileOverview_AchievementReported$1,
    dgProfileOverview_AddAchievements: dgProfileOverview_AddAchievements$1,
    dgProfileOverview_AddDescription: dgProfileOverview_AddDescription$1,
    dgProfileOverview_AddDevelopmentPlan: dgProfileOverview_AddDevelopmentPlan$1,
    dgProfileOverview_AddExperiences: dgProfileOverview_AddExperiences$1,
    dgProfileOverview_AdditionalSkills: dgProfileOverview_AdditionalSkills$1,
    dgProfileOverview_AddLearning: dgProfileOverview_AddLearning$1,
    dgProfileOverview_AddSkill: dgProfileOverview_AddSkill$1,
    dgProfileOverview_AddSkillOrTopic: dgProfileOverview_AddSkillOrTopic$1,
    dgProfileOverview_AwardReceivedDate: dgProfileOverview_AwardReceivedDate$1,
    dgProfileOverview_BuildProfileAchievementsComplete_Plural: dgProfileOverview_BuildProfileAchievementsComplete_Plural$1,
    dgProfileOverview_BuildProfileAchievementsComplete_Single: dgProfileOverview_BuildProfileAchievementsComplete_Single$1,
    dgProfileOverview_BuildProfileAchievementsIncomplete: dgProfileOverview_BuildProfileAchievementsIncomplete$1,
    dgProfileOverview_BuildProfileExperiencesComplete_Plural: dgProfileOverview_BuildProfileExperiencesComplete_Plural$1,
    dgProfileOverview_BuildProfileExperiencesComplete_Single: dgProfileOverview_BuildProfileExperiencesComplete_Single$1,
    dgProfileOverview_BuildProfileExperiencesIncomplete: dgProfileOverview_BuildProfileExperiencesIncomplete$1,
    dgProfileOverview_BuildProfileFocusSkillsComplete: dgProfileOverview_BuildProfileFocusSkillsComplete$1,
    dgProfileOverview_BuildProfileFocusSkillsComplete_Plural: dgProfileOverview_BuildProfileFocusSkillsComplete_Plural$1,
    dgProfileOverview_BuildProfileFocusSkillsIncomplete: dgProfileOverview_BuildProfileFocusSkillsIncomplete$1,
    dgProfileOverview_BuildProfileLearningsComplete_Plural: dgProfileOverview_BuildProfileLearningsComplete_Plural$1,
    dgProfileOverview_BuildProfileLearningsIncomplete: dgProfileOverview_BuildProfileLearningsIncomplete$1,
    dgProfileOverview_BuildProfileSectionCompleted: dgProfileOverview_BuildProfileSectionCompleted$1,
    dgProfileOverview_BuildProfileSkillRatingsComplete_Plural: dgProfileOverview_BuildProfileSkillRatingsComplete_Plural$1,
    dgProfileOverview_BuildProfileSkillRatingsComplete_Single: dgProfileOverview_BuildProfileSkillRatingsComplete_Single$1,
    dgProfileOverview_BuildProfileSkillRatingsIncomplete: dgProfileOverview_BuildProfileSkillRatingsIncomplete$1,
    dgProfileOverview_BuildProfileSkillsComplete_Plural: dgProfileOverview_BuildProfileSkillsComplete_Plural$1,
    dgProfileOverview_BuildProfileSkillsIncomplete: dgProfileOverview_BuildProfileSkillsIncomplete$1,
    dgProfileOverview_BuildProfileSubTitle: dgProfileOverview_BuildProfileSubTitle$1,
    dgProfileOverview_BuildProfileTitle: dgProfileOverview_BuildProfileTitle$1,
    dgProfileOverview_CertificateNumber: dgProfileOverview_CertificateNumber$1,
    dgProfileOverview_Columns: dgProfileOverview_Columns$1,
    dgProfileOverview_ColumnsToDisplay: dgProfileOverview_ColumnsToDisplay$1,
    dgProfileOverview_FilterForSkills: dgProfileOverview_FilterForSkills$1,
    dgProfileOverview_FindExperts: dgProfileOverview_FindExperts$1,
    dgProfileOverview_FocusedSkills: dgProfileOverview_FocusedSkills$1,
    dgProfileOverview_FocusedSkillsDescription: dgProfileOverview_FocusedSkillsDescription$1,
    dgProfileOverview_FocusEmptyState_Link: dgProfileOverview_FocusEmptyState_Link$1,
    dgProfileOverview_FocusEmptyState_Owner: dgProfileOverview_FocusEmptyState_Owner$1,
    dgProfileOverview_FocusEmptyState_Viewer: dgProfileOverview_FocusEmptyState_Viewer$1,
    dgProfileOverview_FocusSkills: dgProfileOverview_FocusSkills$1,
    dgProfileOverview_FocusSkills_EmptyState: dgProfileOverview_FocusSkills_EmptyState$1,
    dgProfileOverview_FocusSkillsDescription: dgProfileOverview_FocusSkillsDescription$1,
    dgProfileOverview_FocusSkillsDescriptionOtherProfile: dgProfileOverview_FocusSkillsDescriptionOtherProfile$1,
    dgProfileOverview_FocusSkillsHelp: dgProfileOverview_FocusSkillsHelp$1,
    dgProfileOverview_FocusSkillsHelp_and_Core_Icon: dgProfileOverview_FocusSkillsHelp_and_Core_Icon$1,
    dgProfileOverview_HasParsedResume: dgProfileOverview_HasParsedResume$1,
    dgProfileOverview_LearningTitle: dgProfileOverview_LearningTitle$1,
    dgProfileOverview_MaxColumnsToDisplay: dgProfileOverview_MaxColumnsToDisplay$1,
    dgProfileOverview_MaxFocusedSkills: dgProfileOverview_MaxFocusedSkills$1,
    dgProfileOverview_NoCompletedContent: dgProfileOverview_NoCompletedContent$1,
    dgProfileOverview_NonOwnerEmptyStateBody: dgProfileOverview_NonOwnerEmptyStateBody$1,
    dgProfileOverview_NonOwnerEmptyStateTitle: dgProfileOverview_NonOwnerEmptyStateTitle$1,
    dgProfileOverview_NoParsedResume: dgProfileOverview_NoParsedResume$1,
    dgProfileOverview_NoSkills: dgProfileOverview_NoSkills$1,
    dgProfileOverview_NothingCompleted: dgProfileOverview_NothingCompleted$1,
    dgProfileOverview_OtherSkills: dgProfileOverview_OtherSkills$1,
    dgProfileOverview_OverviewAchievementsTitle: dgProfileOverview_OverviewAchievementsTitle$1,
    dgProfileOverview_OverviewCompleteWizardButton: dgProfileOverview_OverviewCompleteWizardButton$1,
    dgProfileOverview_OverviewEmptyStateText: dgProfileOverview_OverviewEmptyStateText$1,
    dgProfileOverview_OverviewEmptyStateTitle: dgProfileOverview_OverviewEmptyStateTitle$1,
    dgProfileOverview_OverviewExperienceTitle: dgProfileOverview_OverviewExperienceTitle$1,
    dgProfileOverview_OverviewLearningTitle: dgProfileOverview_OverviewLearningTitle$1,
    dgProfileOverview_OverviewNotProvidedTitle: dgProfileOverview_OverviewNotProvidedTitle$1,
    dgProfileOverview_OverviewSkillsTitle: dgProfileOverview_OverviewSkillsTitle$1,
    dgProfileOverview_RecentlyCompleted: dgProfileOverview_RecentlyCompleted$1,
    dgProfileOverview_RemoveSkill: dgProfileOverview_RemoveSkill$1,
    dgProfileOverview_RequiredCriticalSkills: dgProfileOverview_RequiredCriticalSkills$1,
    dgProfileOverview_RequiredSkills: dgProfileOverview_RequiredSkills$1,
    dgProfileOverview_RequiredSkillsDescription: dgProfileOverview_RequiredSkillsDescription$1,
    dgProfileOverview_SeeSkillCollection: dgProfileOverview_SeeSkillCollection$1,
    dgProfileOverview_SkillActionsAriaLabel: dgProfileOverview_SkillActionsAriaLabel$1,
    dgProfileOverview_SkillListView_Description: dgProfileOverview_SkillListView_Description$1,
    dgProfileOverview_SkillListView_Endorsed: dgProfileOverview_SkillListView_Endorsed$1,
    dgProfileOverview_SkillListView_OrgSkill: dgProfileOverview_SkillListView_OrgSkill$1,
    dgProfileOverview_SkillListView_SkillSignals: dgProfileOverview_SkillListView_SkillSignals$1,
    dgProfileOverview_SkillListView_Source: dgProfileOverview_SkillListView_Source$1,
    dgProfileOverview_SkillListView_SourceValue_Experience: dgProfileOverview_SkillListView_SourceValue_Experience$1,
    dgProfileOverview_SkillListView_SourceValue_Organization: dgProfileOverview_SkillListView_SourceValue_Organization$1,
    dgProfileOverview_SkillListView_SourceValue_Self: dgProfileOverview_SkillListView_SourceValue_Self$1,
    dgProfileOverview_SkillListView_TotalRatings: dgProfileOverview_SkillListView_TotalRatings$1,
    dgProfileOverview_SkillListView_Type: dgProfileOverview_SkillListView_Type$1,
    dgProfileOverview_SkillSignalDataTableLabel: dgProfileOverview_SkillSignalDataTableLabel$1,
    dgProfileOverview_SkillSignalsLabel: dgProfileOverview_SkillSignalsLabel$1,
    dgProfileOverview_SkillSignalsTitle: dgProfileOverview_SkillSignalsTitle$1,
    dgProfileOverview_SkillSuggestionsSubTitle: dgProfileOverview_SkillSuggestionsSubTitle$1,
    dgProfileOverview_SkillSuggestionsSubTitle_By_Org: dgProfileOverview_SkillSuggestionsSubTitle_By_Org$1,
    dgProfileOverview_SkillSuggestionsSubTitle_On_Role: dgProfileOverview_SkillSuggestionsSubTitle_On_Role$1,
    dgProfileOverview_SkillSuggestionsTitle: dgProfileOverview_SkillSuggestionsTitle$1,
    dgProfileOverview_StackedSkillRatingsAriaLabel: dgProfileOverview_StackedSkillRatingsAriaLabel$1,
    dgProfileOverview_TooltipSignalsPlural: dgProfileOverview_TooltipSignalsPlural$1,
    dgProfileOverview_TooltipSignalsSingle: dgProfileOverview_TooltipSignalsSingle$1,
    dgProfileOverview_TooltipSignalsZero: dgProfileOverview_TooltipSignalsZero$1,
    dgProfileOverview_ViewAllAchievements: dgProfileOverview_ViewAllAchievements$1,
    dgProfileOverview_ViewAllExperiences: dgProfileOverview_ViewAllExperiences$1,
    dgProfileOverview_ViewAllLearning: dgProfileOverview_ViewAllLearning$1,
    dgProfileOverview_ViewAllSkills: dgProfileOverview_ViewAllSkills$1,
    dgProfileOverview_ViewAward: dgProfileOverview_ViewAward$1,
    dgProfileOverview_ViewBadge: dgProfileOverview_ViewBadge$1,
    dgProfileOverview_ViewCertificate: dgProfileOverview_ViewCertificate$1,
    dgProfileOverview_ViewDegree: dgProfileOverview_ViewDegree$1,
    dgProfileCollectionItem_CertDetailsTitle: dgProfileCollectionItem_CertDetailsTitle$1,
    dgProfileCollectionItem_CertImage: dgProfileCollectionItem_CertImage$1,
    dgProfileCollectionItem_CertIssuedBy: dgProfileCollectionItem_CertIssuedBy$1,
    dgProfileCollectionItem_CertIssuerUrl: dgProfileCollectionItem_CertIssuerUrl$1,
    dgProfileCollectionItem_CertNumber: dgProfileCollectionItem_CertNumber$1,
    dgProfileCollectionItem_CertTitle: dgProfileCollectionItem_CertTitle$1,
    dgProfileCollectionItem_CertValidDate: dgProfileCollectionItem_CertValidDate$1,
    dgProfileCollectionItem_MasteryPointsFormat: dgProfileCollectionItem_MasteryPointsFormat$1,
    dgProfileCollectionItem_Verified: dgProfileCollectionItem_Verified$1,
    dgPostComment_Message: dgPostComment_Message$1,
    dgPostComment_Placeholder: dgPostComment_Placeholder$1,
    dgPopularSearches_ListOption: dgPopularSearches_ListOption$1,
    dgPopularSearches_TermOption: dgPopularSearches_TermOption$1,
    dgPopularProviders_Empty: dgPopularProviders_Empty$1,
    dgPopularProviders_InputPercentageFormat: dgPopularProviders_InputPercentageFormat$1,
    dgPopularProviders_ProviderPlaceholder: dgPopularProviders_ProviderPlaceholder$1,
    dgPopularProviders_SeatsFormat: dgPopularProviders_SeatsFormat$1,
    dgPopularCategories_ListOption: dgPopularCategories_ListOption$1,
    dgPopularCategories_NoCategories: dgPopularCategories_NoCategories$1,
    dgPopularCategories_NoSearchTerms: dgPopularCategories_NoSearchTerms$1,
    dgPopularCategories_TagsOption: dgPopularCategories_TagsOption$1,
    dgPopularCategories_UncategorizedFormat: dgPopularCategories_UncategorizedFormat$1,
    dgPathwayTile_Enroll: dgPathwayTile_Enroll$1,
    dgPathwayTile_Enrolled: dgPathwayTile_Enrolled$1,
    dgPathwayTile_EnrolledButtonLabel: dgPathwayTile_EnrolledButtonLabel$1,
    dgPathwayTile_Follow: dgPathwayTile_Follow$1,
    dgPathwayTile_Following: dgPathwayTile_Following$1,
    dgPathwayTile_FollowingButtonLabel: dgPathwayTile_FollowingButtonLabel$1,
    dgPathwayTile_PrivateShareMsg: dgPathwayTile_PrivateShareMsg$1,
    dgPathwayTile_SavedForLaterMsgFormat: dgPathwayTile_SavedForLaterMsgFormat$1,
    dgPathwayTile_Unfollow: dgPathwayTile_Unfollow$1,
    dgPathwayTile_UnfollowConfirm: dgPathwayTile_UnfollowConfirm$1,
    dgPathwayTile_Withdraw: dgPathwayTile_Withdraw$1,
    dgPathwayTile_WithdrawConfirm: dgPathwayTile_WithdrawConfirm$1,
    dgPathwayTile_WithdrawExplanation: dgPathwayTile_WithdrawExplanation$1,
    dgPathwaysInsights_CompletionPercentage: dgPathwaysInsights_CompletionPercentage$1,
    dgPathwaysInsights_EnrolledCountFormat: dgPathwaysInsights_EnrolledCountFormat$1,
    dgPathwaysInsights_EnrolledCountPluralFormat: dgPathwaysInsights_EnrolledCountPluralFormat$1,
    dgPathwaysInsights_FiftyToSeventyFive: dgPathwaysInsights_FiftyToSeventyFive$1,
    dgPathwaysInsights_FollowerCountFormat: dgPathwaysInsights_FollowerCountFormat$1,
    dgPathwaysInsights_FollowerCountPluralFormat: dgPathwaysInsights_FollowerCountPluralFormat$1,
    dgPathwaysInsights_GreaterThanSeventyFive: dgPathwaysInsights_GreaterThanSeventyFive$1,
    dgPathwaysInsights_LessonLower: dgPathwaysInsights_LessonLower$1,
    dgPathwaysInsights_LessThanTwentyFive: dgPathwaysInsights_LessThanTwentyFive$1,
    dgPathwaysInsights_PercentageOfEnrollees: dgPathwaysInsights_PercentageOfEnrollees$1,
    dgPathwaysInsights_PercentageOfFollowers: dgPathwaysInsights_PercentageOfFollowers$1,
    dgPathwaysInsights_Section: dgPathwaysInsights_Section$1,
    dgPathwaysInsights_SectionLower: dgPathwaysInsights_SectionLower$1,
    dgPathwaysInsights_Sections: dgPathwaysInsights_Sections$1,
    dgPathwaysInsights_TableTitle: dgPathwaysInsights_TableTitle$1,
    dgPathwaysInsights_Title: dgPathwaysInsights_Title$1,
    dgPathwaysInsights_TwentyFiveToFifty: dgPathwaysInsights_TwentyFiveToFifty$1,
    dgPathwaysInsights_WhenDataUpdates: dgPathwaysInsights_WhenDataUpdates$1,
    dgPathwayPrivacy_CollaboratorProfilePrivate: dgPathwayPrivacy_CollaboratorProfilePrivate$1,
    dgPathwayPrivacy_CollaboratorProfileVisible: dgPathwayPrivacy_CollaboratorProfileVisible$1,
    dgPathwayPrivacy_OrgVisibleFormat: dgPathwayPrivacy_OrgVisibleFormat$1,
    dgPathwayPrivacy_Private: dgPathwayPrivacy_Private$1,
    dgPathwayPrivacy_ProfilePrivate: dgPathwayPrivacy_ProfilePrivate$1,
    dgPathwayPrivacy_ProfileVisible: dgPathwayPrivacy_ProfileVisible$1,
    dgPathwayPrivacy_Public: dgPathwayPrivacy_Public$1,
    dgPathwayPrivacy_SpecificGroupsVisible: dgPathwayPrivacy_SpecificGroupsVisible$1,
    dgPathwayPrivacy_VisibilityBoostToGroupTooltip: dgPathwayPrivacy_VisibilityBoostToGroupTooltip$1,
    dgOrgSecurity_AddGlobalAdmins: dgOrgSecurity_AddGlobalAdmins$1,
    dgOrgSecurity_AddGlobalAdminsDescription: dgOrgSecurity_AddGlobalAdminsDescription$1,
    dgOrgSecurity_AssignLearning: dgOrgSecurity_AssignLearning$1,
    dgOrgSecurity_AssignLearningDescription: dgOrgSecurity_AssignLearningDescription$1,
    dgOrgSecurity_AssignRatings: dgOrgSecurity_AssignRatings$1,
    dgOrgSecurity_AssignRatingsDescription: dgOrgSecurity_AssignRatingsDescription$1,
    dgOrgSecurity_AuthorContent: dgOrgSecurity_AuthorContent$1,
    dgOrgSecurity_AuthorContentDescription: dgOrgSecurity_AuthorContentDescription$1,
    dgOrgSecurity_AuthorPathways: dgOrgSecurity_AuthorPathways$1,
    dgOrgSecurity_AuthorPathwaysDescription: dgOrgSecurity_AuthorPathwaysDescription$1,
    dgOrgSecurity_AuthorSkillPlans: dgOrgSecurity_AuthorSkillPlans$1,
    dgOrgSecurity_AuthorSkillPlansDescription: dgOrgSecurity_AuthorSkillPlansDescription$1,
    dgOrgSecurity_AuthorTargets: dgOrgSecurity_AuthorTargets$1,
    dgOrgSecurity_AuthorTargetsDescription: dgOrgSecurity_AuthorTargetsDescription$1,
    dgOrgSecurity_CobfigureBrowse: dgOrgSecurity_CobfigureBrowse$1,
    dgOrgSecurity_ConfigureBrowse: dgOrgSecurity_ConfigureBrowse$1,
    dgOrgSecurity_ConfigureBrowseDescription: dgOrgSecurity_ConfigureBrowseDescription$1,
    dgOrgSecurity_CreateAdministrativeGroups: dgOrgSecurity_CreateAdministrativeGroups$1,
    dgOrgSecurity_CreateAdministrativeGroupsDescription: dgOrgSecurity_CreateAdministrativeGroupsDescription$1,
    dgOrgSecurity_CreateClosedGroups: dgOrgSecurity_CreateClosedGroups$1,
    dgOrgSecurity_CreateClosedGroupsDescription: dgOrgSecurity_CreateClosedGroupsDescription$1,
    dgOrgSecurity_CreateDynamicTeamAssignmentOpportunities: dgOrgSecurity_CreateDynamicTeamAssignmentOpportunities$1,
    dgOrgSecurity_CreateDynamicTeamAssignmentOpportunitiesDesc: dgOrgSecurity_CreateDynamicTeamAssignmentOpportunitiesDesc$1,
    dgOrgSecurity_CreateDynamicTeamAssignmentOpportunitiesDescription: dgOrgSecurity_CreateDynamicTeamAssignmentOpportunitiesDescription$1,
    dgOrgSecurity_CreateGroups: dgOrgSecurity_CreateGroups$1,
    dgOrgSecurity_CreateGroupsDescription: dgOrgSecurity_CreateGroupsDescription$1,
    dgOrgSecurity_CreateLookingforMenteeOpportunities: dgOrgSecurity_CreateLookingforMenteeOpportunities$1,
    dgOrgSecurity_CreateLookingforMenteeOpportunitiesDescription: dgOrgSecurity_CreateLookingforMenteeOpportunitiesDescription$1,
    dgOrgSecurity_CreateLookingforMentorOpportunities: dgOrgSecurity_CreateLookingforMentorOpportunities$1,
    dgOrgSecurity_CreateLookingforMentorOpportunitiesDescription: dgOrgSecurity_CreateLookingforMentorOpportunitiesDescription$1,
    dgOrgSecurity_CreateMentorshipOpportunities: dgOrgSecurity_CreateMentorshipOpportunities$1,
    dgOrgSecurity_CreateMentorshipOpportunitiesDescription: dgOrgSecurity_CreateMentorshipOpportunitiesDescription$1,
    dgOrgSecurity_CreateOpenGroups: dgOrgSecurity_CreateOpenGroups$1,
    dgOrgSecurity_CreateOpenGroupsDescription: dgOrgSecurity_CreateOpenGroupsDescription$1,
    dgOrgSecurity_CreateOpportunities: dgOrgSecurity_CreateOpportunities$1,
    dgOrgSecurity_CreateOpportunitiesDescription: dgOrgSecurity_CreateOpportunitiesDescription$1,
    dgOrgSecurity_CreateOtherOpportunities: dgOrgSecurity_CreateOtherOpportunities$1,
    dgOrgSecurity_CreateOtherOpportunitiesDescription: dgOrgSecurity_CreateOtherOpportunitiesDescription$1,
    dgOrgSecurity_CreatePeerMentoringOpportunities: dgOrgSecurity_CreatePeerMentoringOpportunities$1,
    dgOrgSecurity_CreatePeerMentoringOpportunitiesDescription: dgOrgSecurity_CreatePeerMentoringOpportunitiesDescription$1,
    dgOrgSecurity_CreatePrivateGroups: dgOrgSecurity_CreatePrivateGroups$1,
    dgOrgSecurity_CreatePrivateGroupsDescription: dgOrgSecurity_CreatePrivateGroupsDescription$1,
    dgOrgSecurity_CreateProBonoOpportunities: dgOrgSecurity_CreateProBonoOpportunities$1,
    dgOrgSecurity_CreateProBonoOpportunitiesDescription: dgOrgSecurity_CreateProBonoOpportunitiesDescription$1,
    dgOrgSecurity_CreateProjectOpportunities: dgOrgSecurity_CreateProjectOpportunities$1,
    dgOrgSecurity_CreateProjectOpportunitiesDescription: dgOrgSecurity_CreateProjectOpportunitiesDescription$1,
    dgOrgSecurity_CreateReverseMentoringOpportunities: dgOrgSecurity_CreateReverseMentoringOpportunities$1,
    dgOrgSecurity_CreateReverseMentoringOpportunitiesDescription: dgOrgSecurity_CreateReverseMentoringOpportunitiesDescription$1,
    dgOrgSecurity_CreateShadowingOpportunities: dgOrgSecurity_CreateShadowingOpportunities$1,
    dgOrgSecurity_CreateShadowingOpportunitiesDescription: dgOrgSecurity_CreateShadowingOpportunitiesDescription$1,
    dgOrgSecurity_CreateStretchAssignmentOpportunities: dgOrgSecurity_CreateStretchAssignmentOpportunities$1,
    dgOrgSecurity_CreateStretchAssignmentOpportunitiesDescription: dgOrgSecurity_CreateStretchAssignmentOpportunitiesDescription$1,
    dgOrgSecurity_CreateTenant: dgOrgSecurity_CreateTenant$1,
    dgOrgSecurity_CreateTenantDescription: dgOrgSecurity_CreateTenantDescription$1,
    dgOrgSecurity_CreateVolunteerOpportunities: dgOrgSecurity_CreateVolunteerOpportunities$1,
    dgOrgSecurity_CreateVolunteerOpportunitiesDescription: dgOrgSecurity_CreateVolunteerOpportunitiesDescription$1,
    dgOrgSecurity_CustomizeBrowse: dgOrgSecurity_CustomizeBrowse$1,
    dgOrgSecurity_DefaultRoleText: dgOrgSecurity_DefaultRoleText$1,
    dgOrgSecurity_DeleteGroup: dgOrgSecurity_DeleteGroup$1,
    dgOrgSecurity_DeleteGroupDescription: dgOrgSecurity_DeleteGroupDescription$1,
    dgOrgSecurity_DownloadPathwayDetailsReport: dgOrgSecurity_DownloadPathwayDetailsReport$1,
    dgOrgSecurity_DownloadPathwayDetailsReportDescription: dgOrgSecurity_DownloadPathwayDetailsReportDescription$1,
    dgOrgSecurity_DownloadReports: dgOrgSecurity_DownloadReports$1,
    dgOrgSecurity_DownloadReportsDescription: dgOrgSecurity_DownloadReportsDescription$1,
    dgOrgSecurity_EditCommunications: dgOrgSecurity_EditCommunications$1,
    dgOrgSecurity_EditCommunicationsDescription: dgOrgSecurity_EditCommunicationsDescription$1,
    dgOrgSecurity_EditCommunicationsGlobal: dgOrgSecurity_EditCommunicationsGlobal$1,
    dgOrgSecurity_EditCommunicationsGlobalDescription: dgOrgSecurity_EditCommunicationsGlobalDescription$1,
    dgOrgSecurity_EditPermissions: dgOrgSecurity_EditPermissions$1,
    dgOrgSecurity_EditPermissionsDescription: dgOrgSecurity_EditPermissionsDescription$1,
    dgOrgSecurity_EditPermissionsGlobal: dgOrgSecurity_EditPermissionsGlobal$1,
    dgOrgSecurity_EditPermissionsGlobalDescription: dgOrgSecurity_EditPermissionsGlobalDescription$1,
    dgOrgSecurity_EditSettings: dgOrgSecurity_EditSettings$1,
    dgOrgSecurity_EditSettingsDescription: dgOrgSecurity_EditSettingsDescription$1,
    dgOrgSecurity_EditTenantOrganizationPermissions: dgOrgSecurity_EditTenantOrganizationPermissions$1,
    dgOrgSecurity_EditTenantOrganizationPermissionsDescription: dgOrgSecurity_EditTenantOrganizationPermissionsDescription$1,
    dgOrgSecurity_EditTenantSettings: dgOrgSecurity_EditTenantSettings$1,
    dgOrgSecurity_EditTenantSettingsDescription: dgOrgSecurity_EditTenantSettingsDescription$1,
    dgOrgSecurity_EmailPasswordReset: dgOrgSecurity_EmailPasswordReset$1,
    dgOrgSecurity_EmailPasswordResetDescription: dgOrgSecurity_EmailPasswordResetDescription$1,
    dgOrgSecurity_EndorseContent: dgOrgSecurity_EndorseContent$1,
    dgOrgSecurity_EndorseContentDescription: dgOrgSecurity_EndorseContentDescription$1,
    dgOrgSecurity_InviteMembers: dgOrgSecurity_InviteMembers$1,
    dgOrgSecurity_InviteMembersDescription: dgOrgSecurity_InviteMembersDescription$1,
    dgOrgSecurity_LearningProfessional: dgOrgSecurity_LearningProfessional$1,
    dgOrgSecurity_LearnMore: dgOrgSecurity_LearnMore$1,
    dgOrgSecurity_ManageAdvanced: dgOrgSecurity_ManageAdvanced$1,
    dgOrgSecurity_ManageAdvancedDescription: dgOrgSecurity_ManageAdvancedDescription$1,
    dgOrgSecurity_ManageAttributes: dgOrgSecurity_ManageAttributes$1,
    dgOrgSecurity_ManageAttributesDescription: dgOrgSecurity_ManageAttributesDescription$1,
    dgOrgSecurity_ManageBusinessRules: dgOrgSecurity_ManageBusinessRules$1,
    dgOrgSecurity_ManageBusinessRulesDescription: dgOrgSecurity_ManageBusinessRulesDescription$1,
    dgOrgSecurity_ManageContent: dgOrgSecurity_ManageContent$1,
    dgOrgSecurity_ManageContentDescription: dgOrgSecurity_ManageContentDescription$1,
    dgOrgSecurity_ManageEngage: dgOrgSecurity_ManageEngage$1,
    dgOrgSecurity_ManageEngageDescription: dgOrgSecurity_ManageEngageDescription$1,
    dgOrgSecurity_ManageGroups: dgOrgSecurity_ManageGroups$1,
    dgOrgSecurity_ManageGroupsDescription: dgOrgSecurity_ManageGroupsDescription$1,
    dgOrgSecurity_ManageIntegrations: dgOrgSecurity_ManageIntegrations$1,
    dgOrgSecurity_ManageIntegrationsDescription: dgOrgSecurity_ManageIntegrationsDescription$1,
    dgOrgSecurity_ManageOpportunities: dgOrgSecurity_ManageOpportunities$1,
    dgOrgSecurity_ManageOpportunitiesDescription: dgOrgSecurity_ManageOpportunitiesDescription$1,
    dgOrgSecurity_ManageOrgApiKeys: dgOrgSecurity_ManageOrgApiKeys$1,
    dgOrgSecurity_ManageOrgApiKeysDescription: dgOrgSecurity_ManageOrgApiKeysDescription$1,
    dgOrgSecurity_ManagePathways: dgOrgSecurity_ManagePathways$1,
    dgOrgSecurity_ManagePathwaysDescription: dgOrgSecurity_ManagePathwaysDescription$1,
    dgOrgSecurity_ManageReporting: dgOrgSecurity_ManageReporting$1,
    dgOrgSecurity_ManageReportingDescription: dgOrgSecurity_ManageReportingDescription$1,
    dgOrgSecurity_ManageReportingFTPScheduler: dgOrgSecurity_ManageReportingFTPScheduler$1,
    dgOrgSecurity_ManageReportingFTPSchedulerDescription: dgOrgSecurity_ManageReportingFTPSchedulerDescription$1,
    dgOrgSecurity_ManageReportingInApp: dgOrgSecurity_ManageReportingInApp$1,
    dgOrgSecurity_ManageReportingInAppDescription: dgOrgSecurity_ManageReportingInAppDescription$1,
    dgOrgSecurity_ManageReportingTransmitterConfigurations: dgOrgSecurity_ManageReportingTransmitterConfigurations$1,
    dgOrgSecurity_ManageReportingTransmitterConfigurationsDescription: dgOrgSecurity_ManageReportingTransmitterConfigurationsDescription$1,
    dgOrgSecurity_ManageSegments: dgOrgSecurity_ManageSegments$1,
    dgOrgSecurity_ManageSegmentsDescription: dgOrgSecurity_ManageSegmentsDescription$1,
    dgOrgSecurity_ManageSkillPlans: dgOrgSecurity_ManageSkillPlans$1,
    dgOrgSecurity_ManageSkillPlansDescription: dgOrgSecurity_ManageSkillPlansDescription$1,
    dgOrgSecurity_ManageSkills: dgOrgSecurity_ManageSkills$1,
    dgOrgSecurity_ManageSkillsDescription: dgOrgSecurity_ManageSkillsDescription$1,
    dgOrgSecurity_ManageSkillsPlatform: dgOrgSecurity_ManageSkillsPlatform$1,
    dgOrgSecurity_ManageSkillsPlatformDescription: dgOrgSecurity_ManageSkillsPlatformDescription$1,
    dgOrgSecurity_ManageSkillStandards: dgOrgSecurity_ManageSkillStandards$1,
    dgOrgSecurity_ManageSkillStandardsDescription: dgOrgSecurity_ManageSkillStandardsDescription$1,
    dgOrgSecurity_ManageTargets: dgOrgSecurity_ManageTargets$1,
    dgOrgSecurity_ManageTargetsDescription: dgOrgSecurity_ManageTargetsDescription$1,
    dgOrgSecurity_PublishOpportunities: dgOrgSecurity_PublishOpportunities$1,
    dgOrgSecurity_PublishOpportunitiesDescription: dgOrgSecurity_PublishOpportunitiesDescription$1,
    dgOrgSecurity_PublishSkills: dgOrgSecurity_PublishSkills$1,
    dgOrgSecurity_PublishSkillsDescription: dgOrgSecurity_PublishSkillsDescription$1,
    dgOrgSecurity_RecommendItems: dgOrgSecurity_RecommendItems$1,
    dgOrgSecurity_RecommendItemsDescription: dgOrgSecurity_RecommendItemsDescription$1,
    dgOrgSecurity_RecommendItemsWithDate: dgOrgSecurity_RecommendItemsWithDate$1,
    dgOrgSecurity_RecommendItemsWithDateDescription: dgOrgSecurity_RecommendItemsWithDateDescription$1,
    dgOrgSecurity_RecommendOpportunities: dgOrgSecurity_RecommendOpportunities$1,
    dgOrgSecurity_RecommendOpportunitiesDescription: dgOrgSecurity_RecommendOpportunitiesDescription$1,
    dgOrgSecurity_RecommendRatings: dgOrgSecurity_RecommendRatings$1,
    dgOrgSecurity_RecommendRatingsDescription: dgOrgSecurity_RecommendRatingsDescription$1,
    dgOrgSecurity_RemoveMembers: dgOrgSecurity_RemoveMembers$1,
    dgOrgSecurity_RemoveMembersDescription: dgOrgSecurity_RemoveMembersDescription$1,
    dgOrgSecurity_RequestManagerRating: dgOrgSecurity_RequestManagerRating$1,
    dgOrgSecurity_RequestManagerRatingDescription: dgOrgSecurity_RequestManagerRatingDescription$1,
    dgOrgSecurity_RoleAdmin: dgOrgSecurity_RoleAdmin$1,
    dgOrgSecurity_RoleLearningProfessional: dgOrgSecurity_RoleLearningProfessional$1,
    dgOrgSecurity_RoleManager: dgOrgSecurity_RoleManager$1,
    dgOrgSecurity_RoleMember: dgOrgSecurity_RoleMember$1,
    dgOrgSecurity_ScanCatalogLinks: dgOrgSecurity_ScanCatalogLinks$1,
    dgOrgSecurity_ScanCatalogLinksDescription: dgOrgSecurity_ScanCatalogLinksDescription$1,
    dgOrgSecurity_SelectFeaturedPathways: dgOrgSecurity_SelectFeaturedPathways$1,
    dgOrgSecurity_SelectFeaturedPathwaysDescription: dgOrgSecurity_SelectFeaturedPathwaysDescription$1,
    dgOrgSecurity_ShareBundledContent: dgOrgSecurity_ShareBundledContent$1,
    dgOrgSecurity_ShareBundledContentDescription: dgOrgSecurity_ShareBundledContentDescription$1,
    dgOrgSecurity_UploadClientUser: dgOrgSecurity_UploadClientUser$1,
    dgOrgSecurity_UploadClientUserDescription: dgOrgSecurity_UploadClientUserDescription$1,
    dgOrgSecurity_UploadCompletions: dgOrgSecurity_UploadCompletions$1,
    dgOrgSecurity_UploadCompletionsDescription: dgOrgSecurity_UploadCompletionsDescription$1,
    dgOrgSecurity_UploadContent: dgOrgSecurity_UploadContent$1,
    dgOrgSecurity_UploadContentDescription: dgOrgSecurity_UploadContentDescription$1,
    dgOrgSecurity_UploadContentFiles: dgOrgSecurity_UploadContentFiles$1,
    dgOrgSecurity_UploadContentFilesDescription: dgOrgSecurity_UploadContentFilesDescription$1,
    dgOrgSecurity_UploadFiles: dgOrgSecurity_UploadFiles$1,
    dgOrgSecurity_UploadFilesDescription: dgOrgSecurity_UploadFilesDescription$1,
    dgOrgSecurity_UploadGroups: dgOrgSecurity_UploadGroups$1,
    dgOrgSecurity_UploadGroupsDescription: dgOrgSecurity_UploadGroupsDescription$1,
    dgOrgSecurity_UploadOpportunities: dgOrgSecurity_UploadOpportunities$1,
    dgOrgSecurity_UploadOpportunitiesDescription: dgOrgSecurity_UploadOpportunitiesDescription$1,
    dgOrgSecurity_UploadPlans: dgOrgSecurity_UploadPlans$1,
    dgOrgSecurity_UploadPlansDescription: dgOrgSecurity_UploadPlansDescription$1,
    dgOrgSecurity_UploadRequiredLearning: dgOrgSecurity_UploadRequiredLearning$1,
    dgOrgSecurity_UploadRequiredLearningDescription: dgOrgSecurity_UploadRequiredLearningDescription$1,
    dgOrgSecurity_UploadRoles: dgOrgSecurity_UploadRoles$1,
    dgOrgSecurity_UploadRolesDescription: dgOrgSecurity_UploadRolesDescription$1,
    dgOrgSecurity_UploadSkills: dgOrgSecurity_UploadSkills$1,
    dgOrgSecurity_UploadSkillsDescription: dgOrgSecurity_UploadSkillsDescription$1,
    dgOrgSecurity_UploadUserUpdates: dgOrgSecurity_UploadUserUpdates$1,
    dgOrgSecurity_UploadUserUpdatesDescription: dgOrgSecurity_UploadUserUpdatesDescription$1,
    dgOrgSecurity_ViewCareerPaths: dgOrgSecurity_ViewCareerPaths$1,
    dgOrgSecurity_ViewCareerPathsDescription: dgOrgSecurity_ViewCareerPathsDescription$1,
    dgOrgSecurity_ViewDynamicAdminGroupMembers: dgOrgSecurity_ViewDynamicAdminGroupMembers$1,
    dgOrgSecurity_ViewDynamicAdminGroupMembersDescription: dgOrgSecurity_ViewDynamicAdminGroupMembersDescription$1,
    dgOrgSecurity_ViewKnowledgeCenter: dgOrgSecurity_ViewKnowledgeCenter$1,
    dgOrgSecurity_ViewKnowledgeCenterDescription: dgOrgSecurity_ViewKnowledgeCenterDescription$1,
    dgOrgSecurity_ViewMembers: dgOrgSecurity_ViewMembers$1,
    dgOrgSecurity_ViewMembersDescription: dgOrgSecurity_ViewMembersDescription$1,
    dgOrgSecurity_ViewOpportunities: dgOrgSecurity_ViewOpportunities$1,
    dgOrgSecurity_ViewOpportunitiesDescription: dgOrgSecurity_ViewOpportunitiesDescription$1,
    dgOrgSecurity_ViewOrganizationOpportunityInsights: dgOrgSecurity_ViewOrganizationOpportunityInsights$1,
    dgOrgSecurity_ViewOrganizationOpportunityInsightsDescription: dgOrgSecurity_ViewOrganizationOpportunityInsightsDescription$1,
    dgOrgSecurity_ViewOrganizationReports: dgOrgSecurity_ViewOrganizationReports$1,
    dgOrgSecurity_ViewOrganizationReportsDescription: dgOrgSecurity_ViewOrganizationReportsDescription$1,
    dgOrgSecurity_ViewPathwayEnrollees: dgOrgSecurity_ViewPathwayEnrollees$1,
    dgOrgSecurity_ViewPathwayEnrolleesDescription: dgOrgSecurity_ViewPathwayEnrolleesDescription$1,
    dgOrgSecurity_ViewRatings: dgOrgSecurity_ViewRatings$1,
    dgOrgSecurity_ViewRatingsDescription: dgOrgSecurity_ViewRatingsDescription$1,
    dgOrgSecurity_ViewRecommendedRatings: dgOrgSecurity_ViewRecommendedRatings$1,
    dgOrgSecurity_ViewRecommendedRatingsDescription: dgOrgSecurity_ViewRecommendedRatingsDescription$1,
    dgOrgOverview_ChangeLogo: dgOrgOverview_ChangeLogo$1,
    dgOrgOverview_ChangeLogoTextFormat: dgOrgOverview_ChangeLogoTextFormat$1,
    dgOrgOverview_GroupCountFormat: dgOrgOverview_GroupCountFormat$1,
    dgOrgOverview_HeaderColor: dgOrgOverview_HeaderColor$1,
    dgOrgOverview_MemberCountFormat: dgOrgOverview_MemberCountFormat$1,
    dgOrgOverview_PreviewLabel: dgOrgOverview_PreviewLabel$1,
    dgOrgMembers_AddAMessage: dgOrgMembers_AddAMessage$1,
    dgOrgMembers_AddMembersTitleFormat: dgOrgMembers_AddMembersTitleFormat$1,
    dgOrgMembers_AddPeople: dgOrgMembers_AddPeople$1,
    dgOrgMembers_CopyTheURL: dgOrgMembers_CopyTheURL$1,
    dgOrgMembers_EmailDomainChangeFormat: dgOrgMembers_EmailDomainChangeFormat$1,
    dgOrgMembers_EmailInstructions: dgOrgMembers_EmailInstructions$1,
    dgOrgMembers_EmailPlaceholderText: dgOrgMembers_EmailPlaceholderText$1,
    dgOrgMembers_InviteGroupInstructionsFormat: dgOrgMembers_InviteGroupInstructionsFormat$1,
    dgOrgMembers_InviteLabel: dgOrgMembers_InviteLabel$1,
    dgOrgMembers_InviteMembersTitleFormat: dgOrgMembers_InviteMembersTitleFormat$1,
    dgOrgMembers_PersonalMessageDescription: dgOrgMembers_PersonalMessageDescription$1,
    dgOrgMembers_PersonalMessageDescriptionFormat: dgOrgMembers_PersonalMessageDescriptionFormat$1,
    dgOrgMembers_PersonalMessageLabel: dgOrgMembers_PersonalMessageLabel$1,
    dgOrgMembers_SelectAllPending: dgOrgMembers_SelectAllPending$1,
    dgOrgMembers_SendInvite: dgOrgMembers_SendInvite$1,
    dgOrgManageProviderModal_DisconnectIntegrationWarning: dgOrgManageProviderModal_DisconnectIntegrationWarning$1,
    dgOrgManageProviderModal_EnableIntegration: dgOrgManageProviderModal_EnableIntegration$1,
    dgOrgInvite_CommaSeparated: dgOrgInvite_CommaSeparated$1,
    dgOrgInvite_EmailAddresses: dgOrgInvite_EmailAddresses$1,
    dgOrgInvite_InviteEmailsOverview: dgOrgInvite_InviteEmailsOverview$1,
    dgOrgInvite_InviteLinkOverview: dgOrgInvite_InviteLinkOverview$1,
    dgOrgInvite_InviteTitle: dgOrgInvite_InviteTitle$1,
    dgOrgInvite_Send: dgOrgInvite_Send$1,
    dgOrgInternalContentForm_AddFromUrl: dgOrgInternalContentForm_AddFromUrl$1,
    dgOrgInternalContentForm_AddImage: dgOrgInternalContentForm_AddImage$1,
    dgOrgInternalContentForm_AddInternalItemId: dgOrgInternalContentForm_AddInternalItemId$1,
    dgOrgInternalContentForm_ArticalFormatPlaceholder: dgOrgInternalContentForm_ArticalFormatPlaceholder$1,
    dgOrgInternalContentForm_ArticleDescription: dgOrgInternalContentForm_ArticleDescription$1,
    dgOrgInternalContentForm_ArticleDescriptionPlaceholder: dgOrgInternalContentForm_ArticleDescriptionPlaceholder$1,
    dgOrgInternalContentForm_ArticleExistsCancel: dgOrgInternalContentForm_ArticleExistsCancel$1,
    dgOrgInternalContentForm_ArticleExistsDescription: dgOrgInternalContentForm_ArticleExistsDescription$1,
    dgOrgInternalContentForm_ArticleExistsTitle: dgOrgInternalContentForm_ArticleExistsTitle$1,
    dgOrgInternalContentForm_ArticleFormat: dgOrgInternalContentForm_ArticleFormat$1,
    dgOrgInternalContentForm_ArticleFormatSelectPlaceholder: dgOrgInternalContentForm_ArticleFormatSelectPlaceholder$1,
    dgOrgInternalContentForm_ArticleTitle: dgOrgInternalContentForm_ArticleTitle$1,
    dgOrgInternalContentForm_ArticleURL: dgOrgInternalContentForm_ArticleURL$1,
    dgOrgInternalContentForm_AssessmentDescription: dgOrgInternalContentForm_AssessmentDescription$1,
    dgOrgInternalContentForm_AssessmentExistsDescription: dgOrgInternalContentForm_AssessmentExistsDescription$1,
    dgOrgInternalContentForm_AssessmentExistsTitle: dgOrgInternalContentForm_AssessmentExistsTitle$1,
    dgOrgInternalContentForm_AssessmentName: dgOrgInternalContentForm_AssessmentName$1,
    dgOrgInternalContentForm_AssessmentProvider: dgOrgInternalContentForm_AssessmentProvider$1,
    dgOrgInternalContentForm_AssessmentURL: dgOrgInternalContentForm_AssessmentURL$1,
    dgOrgInternalContentForm_AudioURL: dgOrgInternalContentForm_AudioURL$1,
    dgOrgInternalContentForm_BookAuthor: dgOrgInternalContentForm_BookAuthor$1,
    dgOrgInternalContentForm_BookCoverAltFormat: dgOrgInternalContentForm_BookCoverAltFormat$1,
    dgOrgInternalContentForm_BookDatePublished: dgOrgInternalContentForm_BookDatePublished$1,
    dgOrgInternalContentForm_BookDateRead: dgOrgInternalContentForm_BookDateRead$1,
    dgOrgInternalContentForm_BookLength: dgOrgInternalContentForm_BookLength$1,
    dgOrgInternalContentForm_BookLengthCustomFormat: dgOrgInternalContentForm_BookLengthCustomFormat$1,
    dgOrgInternalContentForm_BookSave: dgOrgInternalContentForm_BookSave$1,
    dgOrgInternalContentForm_BookSubtitle: dgOrgInternalContentForm_BookSubtitle$1,
    dgOrgInternalContentForm_BookSummary: dgOrgInternalContentForm_BookSummary$1,
    dgOrgInternalContentForm_BookTitle: dgOrgInternalContentForm_BookTitle$1,
    dgOrgInternalContentForm_BookTitlePlaceholder: dgOrgInternalContentForm_BookTitlePlaceholder$1,
    dgOrgInternalContentForm_CategoriesToolTip: dgOrgInternalContentForm_CategoriesToolTip$1,
    dgOrgInternalContentForm_ChooseCourseFormat: dgOrgInternalContentForm_ChooseCourseFormat$1,
    dgOrgInternalContentForm_CommentTooltip: dgOrgInternalContentForm_CommentTooltip$1,
    dgOrgInternalContentForm_Complete: dgOrgInternalContentForm_Complete$1,
    dgOrgInternalContentForm_ContentOwner: dgOrgInternalContentForm_ContentOwner$1,
    dgOrgInternalContentForm_ContentOwnerPlaceholder: dgOrgInternalContentForm_ContentOwnerPlaceholder$1,
    dgOrgInternalContentForm_ContentOwnerRequired: dgOrgInternalContentForm_ContentOwnerRequired$1,
    dgOrgInternalContentForm_ContentOwnerTooltip: dgOrgInternalContentForm_ContentOwnerTooltip$1,
    dgOrgInternalContentForm_CourseDescription: dgOrgInternalContentForm_CourseDescription$1,
    dgOrgInternalContentForm_CourseDescriptionPlaceholder: dgOrgInternalContentForm_CourseDescriptionPlaceholder$1,
    dgOrgInternalContentForm_CourseExistsDescription: dgOrgInternalContentForm_CourseExistsDescription$1,
    dgOrgInternalContentForm_CourseExistsTitle: dgOrgInternalContentForm_CourseExistsTitle$1,
    dgOrgInternalContentForm_CourseFormat: dgOrgInternalContentForm_CourseFormat$1,
    dgOrgInternalContentForm_CourseTitle: dgOrgInternalContentForm_CourseTitle$1,
    dgOrgInternalContentForm_CourseURL: dgOrgInternalContentForm_CourseURL$1,
    dgOrgInternalContentForm_CreateNewCredSparkAssessment: dgOrgInternalContentForm_CreateNewCredSparkAssessment$1,
    dgOrgInternalContentForm_CreationDate: dgOrgInternalContentForm_CreationDate$1,
    dgOrgInternalContentForm_CredSparkDashboard: dgOrgInternalContentForm_CredSparkDashboard$1,
    dgOrgInternalContentForm_DragImage: dgOrgInternalContentForm_DragImage$1,
    dgOrgInternalContentForm_EditDetails: dgOrgInternalContentForm_EditDetails$1,
    dgOrgInternalContentForm_EventDescription: dgOrgInternalContentForm_EventDescription$1,
    dgOrgInternalContentForm_EventExistsDescription: dgOrgInternalContentForm_EventExistsDescription$1,
    dgOrgInternalContentForm_EventExistsTitle: dgOrgInternalContentForm_EventExistsTitle$1,
    dgOrgInternalContentForm_EventFormat: dgOrgInternalContentForm_EventFormat$1,
    dgOrgInternalContentForm_EventFormatPlaceholder: dgOrgInternalContentForm_EventFormatPlaceholder$1,
    dgOrgInternalContentForm_EventTitle: dgOrgInternalContentForm_EventTitle$1,
    dgOrgInternalContentForm_EventTitlePlaceholder: dgOrgInternalContentForm_EventTitlePlaceholder$1,
    dgOrgInternalContentForm_EventURL: dgOrgInternalContentForm_EventURL$1,
    dgOrgInternalContentForm_EventURLPlaceholder: dgOrgInternalContentForm_EventURLPlaceholder$1,
    dgOrgInternalContentForm_File: dgOrgInternalContentForm_File$1,
    dgOrgInternalContentForm_FileTooLargeFormat: dgOrgInternalContentForm_FileTooLargeFormat$1,
    dgOrgInternalContentForm_GroupsTitle: dgOrgInternalContentForm_GroupsTitle$1,
    dgOrgInternalContentForm_GroupsToolTip: dgOrgInternalContentForm_GroupsToolTip$1,
    dgOrgInternalContentForm_ImageDisplayOption: dgOrgInternalContentForm_ImageDisplayOption$1,
    dgOrgInternalContentForm_ImageDisplayOption1: dgOrgInternalContentForm_ImageDisplayOption1$1,
    dgOrgInternalContentForm_ImageDisplayOption2: dgOrgInternalContentForm_ImageDisplayOption2$1,
    dgOrgInternalContentForm_ImagePreviewAltText: dgOrgInternalContentForm_ImagePreviewAltText$1,
    dgOrgInternalContentForm_ImageReuploadInstructions: dgOrgInternalContentForm_ImageReuploadInstructions$1,
    dgOrgInternalContentForm_InternalItemId: dgOrgInternalContentForm_InternalItemId$1,
    dgOrgInternalContentForm_InvalidFileType: dgOrgInternalContentForm_InvalidFileType$1,
    dgOrgInternalContentForm_ItemExistsCancel: dgOrgInternalContentForm_ItemExistsCancel$1,
    dgOrgInternalContentForm_ItemExistsConfirm: dgOrgInternalContentForm_ItemExistsConfirm$1,
    dgOrgInternalContentForm_IWroteBook: dgOrgInternalContentForm_IWroteBook$1,
    dgOrgInternalContentForm_Languages: dgOrgInternalContentForm_Languages$1,
    dgOrgInternalContentForm_ManageCredSparkAccount: dgOrgInternalContentForm_ManageCredSparkAccount$1,
    dgOrgInternalContentForm_ManageOnCredSpark: dgOrgInternalContentForm_ManageOnCredSpark$1,
    dgOrgInternalContentForm_NoLanguageFound: dgOrgInternalContentForm_NoLanguageFound$1,
    dgOrgInternalContentForm_NumberOfQuestions: dgOrgInternalContentForm_NumberOfQuestions$1,
    dgOrgInternalContentForm_NumberOfUnits: dgOrgInternalContentForm_NumberOfUnits$1,
    dgOrgInternalContentForm_Or: dgOrgInternalContentForm_Or$1,
    dgOrgInternalContentForm_ProcessingFile: dgOrgInternalContentForm_ProcessingFile$1,
    dgOrgInternalContentForm_Questions: dgOrgInternalContentForm_Questions$1,
    dgOrgInternalContentForm_Record: dgOrgInternalContentForm_Record$1,
    dgOrgInternalContentForm_RecordAVideo: dgOrgInternalContentForm_RecordAVideo$1,
    dgOrgInternalContentForm_RecordVideo: dgOrgInternalContentForm_RecordVideo$1,
    dgOrgInternalContentForm_ReRecordVideo: dgOrgInternalContentForm_ReRecordVideo$1,
    dgOrgInternalContentForm_ReSyncCredSpark: dgOrgInternalContentForm_ReSyncCredSpark$1,
    dgOrgInternalContentForm_ReUploadRecording: dgOrgInternalContentForm_ReUploadRecording$1,
    dgOrgInternalContentForm_ScormFile: dgOrgInternalContentForm_ScormFile$1,
    dgOrgInternalContentForm_ScormInstructions: dgOrgInternalContentForm_ScormInstructions$1,
    dgOrgInternalContentForm_ScormPackageCheckbox: dgOrgInternalContentForm_ScormPackageCheckbox$1,
    dgOrgInternalContentForm_ScormPackageUpdateCheckbox: dgOrgInternalContentForm_ScormPackageUpdateCheckbox$1,
    dgOrgInternalContentForm_SelectLanguage: dgOrgInternalContentForm_SelectLanguage$1,
    dgOrgInternalContentForm_UnableToUpload: dgOrgInternalContentForm_UnableToUpload$1,
    dgOrgInternalContentForm_UploadImage: dgOrgInternalContentForm_UploadImage$1,
    dgOrgInternalContentForm_UploadRecording: dgOrgInternalContentForm_UploadRecording$1,
    dgOrgInternalContentForm_VideoDescription: dgOrgInternalContentForm_VideoDescription$1,
    dgOrgInternalContentForm_VideoDescriptionPlaceholder: dgOrgInternalContentForm_VideoDescriptionPlaceholder$1,
    dgOrgInternalContentForm_VideoExistsDescription: dgOrgInternalContentForm_VideoExistsDescription$1,
    dgOrgInternalContentForm_VideoExistsTitle: dgOrgInternalContentForm_VideoExistsTitle$1,
    dgOrgInternalContentForm_VideoFilesizeError: dgOrgInternalContentForm_VideoFilesizeError$1,
    dgOrgInternalContentForm_VideoFiletypeError: dgOrgInternalContentForm_VideoFiletypeError$1,
    dgOrgInternalContentForm_VideoFormat: dgOrgInternalContentForm_VideoFormat$1,
    dgOrgInternalContentForm_VideoFormatSelectPlaceholder: dgOrgInternalContentForm_VideoFormatSelectPlaceholder$1,
    dgOrgInternalContentForm_VideoFormPlaceholder: dgOrgInternalContentForm_VideoFormPlaceholder$1,
    dgOrgInternalContentForm_VideoLength: dgOrgInternalContentForm_VideoLength$1,
    dgOrgInternalContentForm_VideoSourceSupported: dgOrgInternalContentForm_VideoSourceSupported$1,
    dgOrgInternalContentForm_VideoTimeLimit: dgOrgInternalContentForm_VideoTimeLimit$1,
    dgOrgInternalContentForm_VideoTitle: dgOrgInternalContentForm_VideoTitle$1,
    dgOrgInternalContentForm_VideoUploadLimit: dgOrgInternalContentForm_VideoUploadLimit$1,
    dgOrgInternalContentForm_VideoURL: dgOrgInternalContentForm_VideoURL$1,
    dgOrgInternalContent_1Pathway: dgOrgInternalContent_1Pathway$1,
    dgOrgInternalContent_1Plan: dgOrgInternalContent_1Plan$1,
    dgOrgInternalContent_1Share: dgOrgInternalContent_1Share$1,
    dgOrgInternalContent_AddContent: dgOrgInternalContent_AddContent$1,
    dgOrgInternalContent_AddEditContent: dgOrgInternalContent_AddEditContent$1,
    dgOrgInternalContent_AddNewContent: dgOrgInternalContent_AddNewContent$1,
    dgOrgInternalContent_AddNewContentFormat: dgOrgInternalContent_AddNewContentFormat$1,
    dgOrgInternalContent_All: dgOrgInternalContent_All$1,
    dgOrgInternalContent_BrokenLinkError: dgOrgInternalContent_BrokenLinkError$1,
    dgOrgInternalContent_BrokenLinks: dgOrgInternalContent_BrokenLinks$1,
    dgOrgInternalContent_BulkDeleteCredSpark: dgOrgInternalContent_BulkDeleteCredSpark$1,
    dgOrgInternalContent_BulkEdit: dgOrgInternalContent_BulkEdit$1,
    dgOrgInternalContent_Catalog: dgOrgInternalContent_Catalog$1,
    dgOrgInternalContent_CategoriesTitle: dgOrgInternalContent_CategoriesTitle$1,
    dgOrgInternalContent_CategoriesToolTip: dgOrgInternalContent_CategoriesToolTip$1,
    dgOrgInternalContent_CheckForBrokenLinks: dgOrgInternalContent_CheckForBrokenLinks$1,
    dgOrgInternalContent_CheckForBrokenToolTip: dgOrgInternalContent_CheckForBrokenToolTip$1,
    dgOrgInternalContent_ChooseContentType: dgOrgInternalContent_ChooseContentType$1,
    dgOrgInternalContent_ContentInUse: dgOrgInternalContent_ContentInUse$1,
    dgOrgInternalContent_ContentType: dgOrgInternalContent_ContentType$1,
    dgOrgInternalContent_ContentUsedInPlansAndPathways: dgOrgInternalContent_ContentUsedInPlansAndPathways$1,
    dgOrgInternalContent_ContinueToDeleteContent: dgOrgInternalContent_ContinueToDeleteContent$1,
    dgOrgInternalContent_DeleteContent: dgOrgInternalContent_DeleteContent$1,
    dgOrgInternalContent_DeleteContentMessage: dgOrgInternalContent_DeleteContentMessage$1,
    dgOrgInternalContent_DeleteContentPermissionWarning: dgOrgInternalContent_DeleteContentPermissionWarning$1,
    dgOrgInternalContent_DeleteContentTooltip: dgOrgInternalContent_DeleteContentTooltip$1,
    dgOrgInternalContent_DeleteFromAllReferences: dgOrgInternalContent_DeleteFromAllReferences$1,
    dgOrgInternalContent_DeleteFromAllReferencesTooltip: dgOrgInternalContent_DeleteFromAllReferencesTooltip$1,
    dgOrgInternalContent_DeleteFromCatalog: dgOrgInternalContent_DeleteFromCatalog$1,
    dgOrgInternalContent_DeleteItems: dgOrgInternalContent_DeleteItems$1,
    dgOrgInternalContent_DeleteOneItem: dgOrgInternalContent_DeleteOneItem$1,
    dgOrgInternalContent_DeleteSelectedInputs: dgOrgInternalContent_DeleteSelectedInputs$1,
    dgOrgInternalContent_EditContent: dgOrgInternalContent_EditContent$1,
    dgOrgInternalContent_EditContentFormat: dgOrgInternalContent_EditContentFormat$1,
    dgOrgInternalContent_GenerateCmsReport: dgOrgInternalContent_GenerateCmsReport$1,
    dgOrgInternalContent_GroupsTitle: dgOrgInternalContent_GroupsTitle$1,
    dgOrgInternalContent_GroupsToolTip: dgOrgInternalContent_GroupsToolTip$1,
    dgOrgInternalContent_InternalContentVisibility: dgOrgInternalContent_InternalContentVisibility$1,
    dgOrgInternalContent_ItemsSelectedFormat: dgOrgInternalContent_ItemsSelectedFormat$1,
    dgOrgInternalContent_LastScannedOn: dgOrgInternalContent_LastScannedOn$1,
    dgOrgInternalContent_LinkIsNotBroken: dgOrgInternalContent_LinkIsNotBroken$1,
    dgOrgInternalContent_LinkUpdated: dgOrgInternalContent_LinkUpdated$1,
    dgOrgInternalContent_ManageBrokenLinks: dgOrgInternalContent_ManageBrokenLinks$1,
    dgOrgInternalContent_MultiplePathways: dgOrgInternalContent_MultiplePathways$1,
    dgOrgInternalContent_MultiplePlans: dgOrgInternalContent_MultiplePlans$1,
    dgOrgInternalContent_MultipleShares: dgOrgInternalContent_MultipleShares$1,
    dgOrgInternalContent_NoBrokenLinksInfoText: dgOrgInternalContent_NoBrokenLinksInfoText$1,
    dgOrgInternalContent_NoBrokenLinksScanHistory: dgOrgInternalContent_NoBrokenLinksScanHistory$1,
    dgOrgInternalContent_ScanCompleteNotification: dgOrgInternalContent_ScanCompleteNotification$1,
    dgOrgInternalContent_ScanIsComplete: dgOrgInternalContent_ScanIsComplete$1,
    dgOrgInternalContent_ScanningCatalog: dgOrgInternalContent_ScanningCatalog$1,
    dgOrgInternalContent_ShowMoreItems: dgOrgInternalContent_ShowMoreItems$1,
    dgOrgInternalContent_SidebarDescriptionFormat: dgOrgInternalContent_SidebarDescriptionFormat$1,
    dgOrgInternalContent_SidebarTitle: dgOrgInternalContent_SidebarTitle$1,
    dgOrgInternalContent_SkillsHelperText: dgOrgInternalContent_SkillsHelperText$1,
    dgOrgInternalContent_SkillsMaxError: dgOrgInternalContent_SkillsMaxError$1,
    dgOrgInternalContent_SkillsPlaceholderText: dgOrgInternalContent_SkillsPlaceholderText$1,
    dgOrgInternalContent_SkillsTooltipText: dgOrgInternalContent_SkillsTooltipText$1,
    dgOrgInternalContent_ViewBrokenLinks: dgOrgInternalContent_ViewBrokenLinks$1,
    dgOrgInternalContent_ViewScormReport: dgOrgInternalContent_ViewScormReport$1,
    dgOrgFaqForm_AddFaq: dgOrgFaqForm_AddFaq$1,
    dgOrgFaqForm_EditFaq: dgOrgFaqForm_EditFaq$1,
    dgOrgFaqForm_FaqAnswerPlaceholder: dgOrgFaqForm_FaqAnswerPlaceholder$1,
    dgOrgFaqForm_FaqContactInstructions: dgOrgFaqForm_FaqContactInstructions$1,
    dgOrgFaqForm_FaqContactLabel: dgOrgFaqForm_FaqContactLabel$1,
    dgOrgFaqForm_FaqContactPlaceholder: dgOrgFaqForm_FaqContactPlaceholder$1,
    dgOrgFaqForm_FaqInstructionsFormat: dgOrgFaqForm_FaqInstructionsFormat$1,
    dgOrgFaqForm_FaqQuestionPlaceholder: dgOrgFaqForm_FaqQuestionPlaceholder$1,
    dgOrgFaqForm_FaqValidationMessage: dgOrgFaqForm_FaqValidationMessage$1,
    dgOrgFaqForm_ManageOrgFaqFormat: dgOrgFaqForm_ManageOrgFaqFormat$1,
    dgOrgEditMemberModal_RemoveUser: dgOrgEditMemberModal_RemoveUser$1,
    dgNotificationPreference_IncludeInEmail: dgNotificationPreference_IncludeInEmail$1,
    dgNotificationPreference_SentTest: dgNotificationPreference_SentTest$1,
    dgNotificationMenu_NothingNew: dgNotificationMenu_NothingNew$1,
    dgNotificationMenu_Notifications: dgNotificationMenu_Notifications$1,
    dgNoSearchResults_CorrectSpelling: dgNoSearchResults_CorrectSpelling$1,
    dgNoSearchResults_DifferentKeywords: dgNoSearchResults_DifferentKeywords$1,
    dgNoSearchResults_GeneralKeywords: dgNoSearchResults_GeneralKeywords$1,
    dgManagePathways_CloneFormat: dgManagePathways_CloneFormat$1,
    dgManagePathways_CreatePathway: dgManagePathways_CreatePathway$1,
    dgManagePathways_Edit: dgManagePathways_Edit$1,
    dgManagePathways_MoreAuthorsFormat: dgManagePathways_MoreAuthorsFormat$1,
    dgManagePathways_OneMoreAuthor: dgManagePathways_OneMoreAuthor$1,
    dgManagePathways_SearchPlaceholder: dgManagePathways_SearchPlaceholder$1,
    dgManagePathways_ViewFormat: dgManagePathways_ViewFormat$1,
    dgInviteAddPeople_Description: dgInviteAddPeople_Description$1,
    dgInviteAddPeople_Follow: dgInviteAddPeople_Follow$1,
    dgInviteAddPeople_Learn: dgInviteAddPeople_Learn$1,
    dgInviteAddPeople_StopFollowing: dgInviteAddPeople_StopFollowing$1,
    dgInviteAddGroups_BecomeMember: dgInviteAddGroups_BecomeMember$1,
    dgInviteAddGroups_Group: dgInviteAddGroups_Group$1,
    dgInviteAddGroups_JoinGroup: dgInviteAddGroups_JoinGroup$1,
    dgInviteAddGroups_JoinGroups: dgInviteAddGroups_JoinGroups$1,
    dgInviteAddGroups_JoinGroupsDesc: dgInviteAddGroups_JoinGroupsDesc$1,
    dgInviteAddGroups_LeaveGroup: dgInviteAddGroups_LeaveGroup$1,
    dgInviteAddCategories_FollowCategories: dgInviteAddCategories_FollowCategories$1,
    dgInviteAddCategories_FollowCategoriesDesc: dgInviteAddCategories_FollowCategoriesDesc$1,
    dgInviteAddCategories_LearnPlaceholder: dgInviteAddCategories_LearnPlaceholder$1,
    dgIntegrationsCard_AlisonMessage: dgIntegrationsCard_AlisonMessage$1,
    dgIntegrationsCard_CodecademyMessage: dgIntegrationsCard_CodecademyMessage$1,
    dgIntegrationsCard_CodeSchoolMessage: dgIntegrationsCard_CodeSchoolMessage$1,
    dgIntegrationsCard_Connect: dgIntegrationsCard_Connect$1,
    dgIntegrationsCard_Connected: dgIntegrationsCard_Connected$1,
    dgIntegrationsCard_Disconnect: dgIntegrationsCard_Disconnect$1,
    dgIntegrationsCard_GoodreadsMessage: dgIntegrationsCard_GoodreadsMessage$1,
    dgIntegrationsCard_GoogleplusMessage: dgIntegrationsCard_GoogleplusMessage$1,
    dgIntegrationsCard_ImportingMessage: dgIntegrationsCard_ImportingMessage$1,
    dgIntegrationsCard_KhanAcademyMessage: dgIntegrationsCard_KhanAcademyMessage$1,
    dgIntegrationsCard_LastSyncFailure: dgIntegrationsCard_LastSyncFailure$1,
    dgIntegrationsCard_LastSyncFormat: dgIntegrationsCard_LastSyncFormat$1,
    dgIntegrationsCard_ManageSettings: dgIntegrationsCard_ManageSettings$1,
    dgIntegrationsCard_PluralsightMessage: dgIntegrationsCard_PluralsightMessage$1,
    dgIntegrationsCard_PocketMessage: dgIntegrationsCard_PocketMessage$1,
    dgIntegrationsCard_SkillshareMessage: dgIntegrationsCard_SkillshareMessage$1,
    dgIntegrationsCard_SlackMessage: dgIntegrationsCard_SlackMessage$1,
    dgIntegrationsCard_TreehouseMessage: dgIntegrationsCard_TreehouseMessage$1,
    dgIntegrationsCard_TwitterMessage: dgIntegrationsCard_TwitterMessage$1,
    dgIntegrationsCard_UdemyMessage: dgIntegrationsCard_UdemyMessage$1,
    dgIntegrationsCard_ViewGoogleplusFriends: dgIntegrationsCard_ViewGoogleplusFriends$1,
    dgIntegrationsCard_ViewTwitterFriends: dgIntegrationsCard_ViewTwitterFriends$1,
    dgInputTile_DueBy: dgInputTile_DueBy$1,
    dgInputTile_DueByFormat: dgInputTile_DueByFormat$1,
    dgInputStatistics_Commented: dgInputStatistics_Commented$1,
    dgInputStatistics_CommentsCount: dgInputStatistics_CommentsCount$1,
    dgInputStatistics_CompletedCount: dgInputStatistics_CompletedCount$1,
    dgInputStatistics_LikesCount: dgInputStatistics_LikesCount$1,
    dgInputStatistics_PeopleWhoDisliked: dgInputStatistics_PeopleWhoDisliked$1,
    dgInputStatistics_PeopleWhoLiked: dgInputStatistics_PeopleWhoLiked$1,
    dgInputStatistics_PeopleWhoRated: dgInputStatistics_PeopleWhoRated$1,
    dgInputStatistics_PeopleWhoViewed: dgInputStatistics_PeopleWhoViewed$1,
    dgInputStatistics_SharesCount: dgInputStatistics_SharesCount$1,
    dgInputStatistics_SkillsCount: dgInputStatistics_SkillsCount$1,
    dgInputStatistics_Tag: dgInputStatistics_Tag$1,
    dgInputStatistics_Tags: dgInputStatistics_Tags$1,
    dgInputStatistics_TopCommenter: dgInputStatistics_TopCommenter$1,
    dgInputStatistics_TopCommenterAndOne: dgInputStatistics_TopCommenterAndOne$1,
    dgInputStatistics_TopCommenterCount: dgInputStatistics_TopCommenterCount$1,
    dgInputStatistics_TopCompleter: dgInputStatistics_TopCompleter$1,
    dgInputStatistics_TopCompleterAndOne: dgInputStatistics_TopCompleterAndOne$1,
    dgInputStatistics_TopCompleterAndOneRead: dgInputStatistics_TopCompleterAndOneRead$1,
    dgInputStatistics_TopCompleterAndOneWatched: dgInputStatistics_TopCompleterAndOneWatched$1,
    dgInputStatistics_TopCompleterCount: dgInputStatistics_TopCompleterCount$1,
    dgInputStatistics_TopCompleterCountRead: dgInputStatistics_TopCompleterCountRead$1,
    dgInputStatistics_TopCompleterCountWatched: dgInputStatistics_TopCompleterCountWatched$1,
    dgInputStatistics_TopCompleterRead: dgInputStatistics_TopCompleterRead$1,
    dgInputStatistics_TopCompleterWatched: dgInputStatistics_TopCompleterWatched$1,
    dgInputStatistics_TopFollower: dgInputStatistics_TopFollower$1,
    dgInputStatistics_TopFollowerAndOne: dgInputStatistics_TopFollowerAndOne$1,
    dgInputStatistics_TopFollowerCount: dgInputStatistics_TopFollowerCount$1,
    dgInputStatistics_TopRecommender: dgInputStatistics_TopRecommender$1,
    dgInputStatistics_TopRecommenderAndOne: dgInputStatistics_TopRecommenderAndOne$1,
    dgInputStatistics_TopRecommenderCount: dgInputStatistics_TopRecommenderCount$1,
    dgInputStatistics_TopTakeawayAndOne: dgInputStatistics_TopTakeawayAndOne$1,
    dgInputStatisticsHeader_TopCompleter: dgInputStatisticsHeader_TopCompleter$1,
    dgInputStatisticsHeader_TopCompleterAndOne: dgInputStatisticsHeader_TopCompleterAndOne$1,
    dgInputStatisticsHeader_TopCompleterCount: dgInputStatisticsHeader_TopCompleterCount$1,
    dgInputCountsByType_Points: dgInputCountsByType_Points$1,
    dgImageUpload_BadgeFileTypeError: dgImageUpload_BadgeFileTypeError$1,
    dgImageUpload_BrowseForImage: dgImageUpload_BrowseForImage$1,
    dgImageUpload_DragImageHere: dgImageUpload_DragImageHere$1,
    dgImageUpload_DropImage: dgImageUpload_DropImage$1,
    dgImageUpload_FilesizeError: dgImageUpload_FilesizeError$1,
    dgImageUpload_FileTypes: dgImageUpload_FileTypes$1,
    dgImageUpload_ImagePosition: dgImageUpload_ImagePosition$1,
    dgImageUpload_ImagePosition_HelperText: dgImageUpload_ImagePosition_HelperText$1,
    dgImageUpload_ImagePreview: dgImageUpload_ImagePreview$1,
    dgImageUpload_ImageTypesSize: dgImageUpload_ImageTypesSize$1,
    dgImageUpload_KB: dgImageUpload_KB$1,
    dgImageUpload_LimitedImageTypesSize: dgImageUpload_LimitedImageTypesSize$1,
    dgImageUpload_Or: dgImageUpload_Or$1,
    dgImageUpload_PdfImageTypesSize: dgImageUpload_PdfImageTypesSize$1,
    dgImageUpload_RemoveImage: dgImageUpload_RemoveImage$1,
    dgImageUpload_SectionDragAndDrop: dgImageUpload_SectionDragAndDrop$1,
    dgImageUpload_SectionInvalidFileSize: dgImageUpload_SectionInvalidFileSize$1,
    dgImageUpload_SectionInvalidFileType: dgImageUpload_SectionInvalidFileType$1,
    dgImageUpload_SectionInvalidFileTypeVar: dgImageUpload_SectionInvalidFileTypeVar$1,
    dgImageUpload_SectionRestrictions: dgImageUpload_SectionRestrictions$1,
    dgImageUpload_SectionRestrictionsVar: dgImageUpload_SectionRestrictionsVar$1,
    dgImageUpload_UploadImage: dgImageUpload_UploadImage$1,
    dgImageEdit_Change: dgImageEdit_Change$1,
    dgImageEdit_ChangePhoto: dgImageEdit_ChangePhoto$1,
    dgImageEdit_ChooseFile: dgImageEdit_ChooseFile$1,
    dgImageEdit_ChooseFileToUpload: dgImageEdit_ChooseFileToUpload$1,
    dgImageEdit_ContentCard: dgImageEdit_ContentCard$1,
    dgImageEdit_ContentDetails: dgImageEdit_ContentDetails$1,
    dgImageEdit_CropImage: dgImageEdit_CropImage$1,
    dgImageEdit_CropNote: dgImageEdit_CropNote$1,
    dgImageEdit_CropToFit: dgImageEdit_CropToFit$1,
    dgImageEdit_DocumentationDesc: dgImageEdit_DocumentationDesc$1,
    dgImageEdit_DocumentationLabel: dgImageEdit_DocumentationLabel$1,
    dgImageEdit_DragPhoto: dgImageEdit_DragPhoto$1,
    dgImageEdit_FilesizeError: dgImageEdit_FilesizeError$1,
    dgImageEdit_ImageDimensionsFormat: dgImageEdit_ImageDimensionsFormat$1,
    dgImageEdit_ImageTypes: dgImageEdit_ImageTypes$1,
    dgImageEdit_LookingGood: dgImageEdit_LookingGood$1,
    dgImageEdit_NoImage: dgImageEdit_NoImage$1,
    dgImageEdit_SaveWithoutCropping: dgImageEdit_SaveWithoutCropping$1,
    dgImageEdit_SubmitImage: dgImageEdit_SubmitImage$1,
    dgImageEdit_UploadImagePreview: dgImageEdit_UploadImagePreview$1,
    dgGroupTile_JoinRequestPending: dgGroupTile_JoinRequestPending$1,
    dgGroupTile_Leave: dgGroupTile_Leave$1,
    dgGroupTile_LeaveGroupModalBodyText: dgGroupTile_LeaveGroupModalBodyText$1,
    dgGroupTile_LeaveGroupModalHeader: dgGroupTile_LeaveGroupModalHeader$1,
    dgGroupTile_MemberCount: dgGroupTile_MemberCount$1,
    dgGroupTile_RequestMembership: dgGroupTile_RequestMembership$1,
    dgGroupsEdit_AddGroups: dgGroupsEdit_AddGroups$1,
    dgGroupsEdit_AddGroupsLabel: dgGroupsEdit_AddGroupsLabel$1,
    dgGroupsEdit_AddGroupsToBoostTooltip: dgGroupsEdit_AddGroupsToBoostTooltip$1,
    dgGroupsEdit_AddGroupsTooltip: dgGroupsEdit_AddGroupsTooltip$1,
    dgGroupsEdit_RemoveGroupName: dgGroupsEdit_RemoveGroupName$1,
    dgGroupSecurity_AssignLearning: dgGroupSecurity_AssignLearning$1,
    dgGroupSecurity_AssignLearningDescription: dgGroupSecurity_AssignLearningDescription$1,
    dgGroupSecurity_DefaultRoleDescription: dgGroupSecurity_DefaultRoleDescription$1,
    dgGroupSecurity_DeleteGroup: dgGroupSecurity_DeleteGroup$1,
    dgGroupSecurity_DeleteGroupDescription: dgGroupSecurity_DeleteGroupDescription$1,
    dgGroupSecurity_EditPermissions: dgGroupSecurity_EditPermissions$1,
    dgGroupSecurity_EditPermissionsDescription: dgGroupSecurity_EditPermissionsDescription$1,
    dgGroupSecurity_EditSettings: dgGroupSecurity_EditSettings$1,
    dgGroupSecurity_EditSettingsDescription: dgGroupSecurity_EditSettingsDescription$1,
    dgGroupSecurity_GroupRoleHeader: dgGroupSecurity_GroupRoleHeader$1,
    dgGroupSecurity_InviteMembers: dgGroupSecurity_InviteMembers$1,
    dgGroupSecurity_InviteMembersDescription: dgGroupSecurity_InviteMembersDescription$1,
    dgGroupSecurity_RecommendItems: dgGroupSecurity_RecommendItems$1,
    dgGroupSecurity_RecommendItemsDescription: dgGroupSecurity_RecommendItemsDescription$1,
    dgGroupSecurity_RecommendRatings: dgGroupSecurity_RecommendRatings$1,
    dgGroupSecurity_RecommendRatingsDescription: dgGroupSecurity_RecommendRatingsDescription$1,
    dgGroupSecurity_RemoveFeedItems: dgGroupSecurity_RemoveFeedItems$1,
    dgGroupSecurity_RemoveFeedItemsDescription: dgGroupSecurity_RemoveFeedItemsDescription$1,
    dgGroupSecurity_RemoveMembers: dgGroupSecurity_RemoveMembers$1,
    dgGroupSecurity_RemoveMembersDescription: dgGroupSecurity_RemoveMembersDescription$1,
    dgGroupSecurity_ViewGroupInsights: dgGroupSecurity_ViewGroupInsights$1,
    dgGroupSecurity_ViewGroupInsightsDescription: dgGroupSecurity_ViewGroupInsightsDescription$1,
    dgGroupSecurity_ViewMembers: dgGroupSecurity_ViewMembers$1,
    dgGroupSecurity_ViewMembersDescription: dgGroupSecurity_ViewMembersDescription$1,
    dgGroupSecurity_ViewOrganizationReports: dgGroupSecurity_ViewOrganizationReports$1,
    dgGroupSearch_PlaceHolder: dgGroupSearch_PlaceHolder$1,
    dgGroupOverview_AdministrativeGroup: dgGroupOverview_AdministrativeGroup$1,
    dgGroupOverview_ClosedGroup: dgGroupOverview_ClosedGroup$1,
    dgGroupOverview_DynamicAdminGroup: dgGroupOverview_DynamicAdminGroup$1,
    dgGroupOverview_GroupMembershipPending: dgGroupOverview_GroupMembershipPending$1,
    dgGroupOverview_JoinedGroup: dgGroupOverview_JoinedGroup$1,
    dgGroupOverview_JoinThisGroup: dgGroupOverview_JoinThisGroup$1,
    dgGroupOverview_LeaveGroup: dgGroupOverview_LeaveGroup$1,
    dgGroupOverview_MemberCountFormat: dgGroupOverview_MemberCountFormat$1,
    dgGroupOverview_OpenGroup: dgGroupOverview_OpenGroup$1,
    dgGroupOverview_PrivateGroup: dgGroupOverview_PrivateGroup$1,
    dgGroupOverview_RequestMembership: dgGroupOverview_RequestMembership$1,
    dgGroupOverview_Restricted: dgGroupOverview_Restricted$1,
    dgGroupOverview_StaticAdminGroup: dgGroupOverview_StaticAdminGroup$1,
    dgGroupMembers_ActiveMembers: dgGroupMembers_ActiveMembers$1,
    dgGroupMembers_AddMember: dgGroupMembers_AddMember$1,
    dgGroupMembers_AddPeople: dgGroupMembers_AddPeople$1,
    dgGroupMembers_AddPeopleButton: dgGroupMembers_AddPeopleButton$1,
    dgGroupMembers_AddUsers: dgGroupMembers_AddUsers$1,
    dgGroupMembers_Admin: dgGroupMembers_Admin$1,
    dgGroupMembers_CalculatingMembership: dgGroupMembers_CalculatingMembership$1,
    dgGroupMembers_DateInvited: dgGroupMembers_DateInvited$1,
    dgGroupMembers_DateJoined: dgGroupMembers_DateJoined$1,
    dgGroupMembers_Invited: dgGroupMembers_Invited$1,
    dgGroupMembers_InviteMembers: dgGroupMembers_InviteMembers$1,
    dgGroupMembers_LastActive: dgGroupMembers_LastActive$1,
    dgGroupMembers_MemberSettings: dgGroupMembers_MemberSettings$1,
    dgGroupMembers_NameHeader: dgGroupMembers_NameHeader$1,
    dgGroupMembers_NoActiveMemberMatch: dgGroupMembers_NoActiveMemberMatch$1,
    dgGroupMembers_NoDynamicMemberDescription: dgGroupMembers_NoDynamicMemberDescription$1,
    dgGroupMembers_NoMatches: dgGroupMembers_NoMatches$1,
    dgGroupMembers_NoMembers: dgGroupMembers_NoMembers$1,
    dgGroupMembers_NoPendingMembers: dgGroupMembers_NoPendingMembers$1,
    dgGroupMembers_NoPendingRequests: dgGroupMembers_NoPendingRequests$1,
    dgGroupMembers_NoPermission: dgGroupMembers_NoPermission$1,
    dgGroupMembers_NoUsersMatch: dgGroupMembers_NoUsersMatch$1,
    dgGroupMembers_PendingApprovalHeader: dgGroupMembers_PendingApprovalHeader$1,
    dgGroupMembers_PendingInvitationFormat: dgGroupMembers_PendingInvitationFormat$1,
    dgGroupMembers_PendingInvitations: dgGroupMembers_PendingInvitations$1,
    dgGroupMembers_PendingMemberSettings: dgGroupMembers_PendingMemberSettings$1,
    dgGroupMembers_PendingRequests: dgGroupMembers_PendingRequests$1,
    dgGroupMembers_Points: dgGroupMembers_Points$1,
    dgGroupMembers_PointsTooltip: dgGroupMembers_PointsTooltip$1,
    dgGroupMembers_Resend: dgGroupMembers_Resend$1,
    dgGroupMembers_ResendAll: dgGroupMembers_ResendAll$1,
    dgGroupMembers_ResendInvites: dgGroupMembers_ResendInvites$1,
    dgGroupMembers_SearchByName: dgGroupMembers_SearchByName$1,
    dgGroupMembers_SearchForMember: dgGroupMembers_SearchForMember$1,
    dgGroupMembers_SelectedCountFormat: dgGroupMembers_SelectedCountFormat$1,
    dgGroupMembers_TotalMemberCountFormat: dgGroupMembers_TotalMemberCountFormat$1,
    dgGroupInvite_groupInviteNotificationInviteFormat: dgGroupInvite_groupInviteNotificationInviteFormat$1,
    dgGroupGoalsOverview_HowTo: dgGroupGoalsOverview_HowTo$1,
    dgGroupGoals_CompleteAPathway: dgGroupGoals_CompleteAPathway$1,
    dgGroupGoals_Completed: dgGroupGoals_Completed$1,
    dgGroupGoals_CreateAGoal: dgGroupGoals_CreateAGoal$1,
    dgGroupGoals_CreateGoal: dgGroupGoals_CreateGoal$1,
    dgGroupGoals_CreateGoalSummary: dgGroupGoals_CreateGoalSummary$1,
    dgGroupGoals_EarnMorePoints: dgGroupGoals_EarnMorePoints$1,
    dgGroupGoals_HowTo: dgGroupGoals_HowTo$1,
    dgGroupGoals_NoGoals: dgGroupGoals_NoGoals$1,
    dgGroupGoalItem_ViewParticipants: dgGroupGoalItem_ViewParticipants$1,
    dgGroupDelete_DeleteGroupTitle: dgGroupDelete_DeleteGroupTitle$1,
    dgGroupDelete_DeleteLabelFormat: dgGroupDelete_DeleteLabelFormat$1,
    dgGroupDelete_DeleteLabelInfoFormat: dgGroupDelete_DeleteLabelInfoFormat$1,
    dgGroupDelete_Instructions: dgGroupDelete_Instructions$1,
    dgGroupDelete_InstructionsFormat: dgGroupDelete_InstructionsFormat$1,
    dgGoalTitle_CompleteInputFormat: dgGoalTitle_CompleteInputFormat$1,
    dgGoalTitle_CompletePathwayFormat: dgGoalTitle_CompletePathwayFormat$1,
    dgGoalTitle_EarnPointsByTagFormat: dgGoalTitle_EarnPointsByTagFormat$1,
    dgGoalItem_AssignedByFormat: dgGoalItem_AssignedByFormat$1,
    dgGoalItem_GoalEndDateFormat: dgGoalItem_GoalEndDateFormat$1,
    dgGlobalSearch_A11ySearchDescription: dgGlobalSearch_A11ySearchDescription$1,
    dgGlobalSearch_SearchExpandLabel: dgGlobalSearch_SearchExpandLabel$1,
    dgGlobalSearch_TopicsLabel: dgGlobalSearch_TopicsLabel$1,
    dgGlobalAddSuccess_CompletedToday: dgGlobalAddSuccess_CompletedToday$1,
    dgGlobalAddSuccess_Description: dgGlobalAddSuccess_Description$1,
    dgGlobalAddSuccess_ErrorWhenAdding: dgGlobalAddSuccess_ErrorWhenAdding$1,
    dgGlobalAddSuccess_LearningItems: dgGlobalAddSuccess_LearningItems$1,
    dgGlobalAddSuccess_Points: dgGlobalAddSuccess_Points$1,
    dgGlobalAddSuccess_RewardTrophy: dgGlobalAddSuccess_RewardTrophy$1,
    dgGlobalAddSuccess_StartedYourCollection: dgGlobalAddSuccess_StartedYourCollection$1,
    dgGlobalAddSuccess_ViewYourCollection: dgGlobalAddSuccess_ViewYourCollection$1,
    dgGlobalAdd_Achievement: dgGlobalAdd_Achievement$1,
    dgGlobalAdd_AchievementDescription: dgGlobalAdd_AchievementDescription$1,
    dgGlobalAdd_AddNewOutcomeTooltipFormat: dgGlobalAdd_AddNewOutcomeTooltipFormat$1,
    dgGlobalAdd_Content: dgGlobalAdd_Content$1,
    dgGlobalAdd_CreateAPathway: dgGlobalAdd_CreateAPathway$1,
    dgGlobalAdd_Description: dgGlobalAdd_Description$1,
    dgGlobalAdd_ExtensionsFormat: dgGlobalAdd_ExtensionsFormat$1,
    dgGlobalAdd_IntegrationsFormat: dgGlobalAdd_IntegrationsFormat$1,
    dgGlobalAdd_OutcomeTypeFormat: dgGlobalAdd_OutcomeTypeFormat$1,
    dgGlobalAdd_Sections_Achievement: dgGlobalAdd_Sections_Achievement$1,
    dgGlobalAdd_Sections_Content: dgGlobalAdd_Sections_Content$1,
    dgGlobalAdd_Sections_Extensions: dgGlobalAdd_Sections_Extensions$1,
    dgGlobalAdd_TooltipFormat: dgGlobalAdd_TooltipFormat$1,
    dgFlexRow_AddLinkSection: dgFlexRow_AddLinkSection$1,
    dgFlexRow_AddSection: dgFlexRow_AddSection$1,
    dgFlexRow_AddSectionSuccess: dgFlexRow_AddSectionSuccess$1,
    dgFlexRow_AddTextAndImage: dgFlexRow_AddTextAndImage$1,
    dgFlexRow_AddTextSection: dgFlexRow_AddTextSection$1,
    dgFlexRow_All: dgFlexRow_All$1,
    dgFlexRow_AllDescription: dgFlexRow_AllDescription$1,
    dgFlexRow_Compact: dgFlexRow_Compact$1,
    dgFlexRow_CompactDescription: dgFlexRow_CompactDescription$1,
    dgFlexRow_CustomErrors_RequiredMultiple: dgFlexRow_CustomErrors_RequiredMultiple$1,
    dgFlexRow_DeleteConfirmSubmit: dgFlexRow_DeleteConfirmSubmit$1,
    dgFlexRow_DeleteSectionBody: dgFlexRow_DeleteSectionBody$1,
    dgFlexRow_DeleteSectionPrompt: dgFlexRow_DeleteSectionPrompt$1,
    dgFlexRow_DeleteSuccess: dgFlexRow_DeleteSuccess$1,
    dgFlexRow_EditDetails: dgFlexRow_EditDetails$1,
    dgFlexRow_EditLinkSection: dgFlexRow_EditLinkSection$1,
    dgFlexRow_EditSectionDescription: dgFlexRow_EditSectionDescription$1,
    dgFlexRow_EditSectionDescriptionPlaceholder: dgFlexRow_EditSectionDescriptionPlaceholder$1,
    dgFlexRow_EditSectionDetails: dgFlexRow_EditSectionDetails$1,
    dgFlexRow_EditSectionDisplayOptions: dgFlexRow_EditSectionDisplayOptions$1,
    dgFlexRow_EditSectionTitle: dgFlexRow_EditSectionTitle$1,
    dgFlexRow_EditSectionTitlePlaceholder: dgFlexRow_EditSectionTitlePlaceholder$1,
    dgFlexRow_EditTextAndImage: dgFlexRow_EditTextAndImage$1,
    dgFlexRow_EditTextSection: dgFlexRow_EditTextSection$1,
    dgFlexRow_Expanded: dgFlexRow_Expanded$1,
    dgFlexRow_ExpandedDescription: dgFlexRow_ExpandedDescription$1,
    dgFlexRow_FieldRequired: dgFlexRow_FieldRequired$1,
    dgFlexRow_Link: dgFlexRow_Link$1,
    dgFlexRow_LinkDescription: dgFlexRow_LinkDescription$1,
    dgFlexRow_LinkSectionTitle: dgFlexRow_LinkSectionTitle$1,
    dgFlexRow_LinkSectionTitleHelperText: dgFlexRow_LinkSectionTitleHelperText$1,
    dgFlexRow_LinkTitle: dgFlexRow_LinkTitle$1,
    dgFlexRow_LinkTitleHelperText: dgFlexRow_LinkTitleHelperText$1,
    dgFlexRow_RemoveSection: dgFlexRow_RemoveSection$1,
    dgFlexRow_ReorderItems: dgFlexRow_ReorderItems$1,
    dgFlexRow_ReorderSectionsTitle: dgFlexRow_ReorderSectionsTitle$1,
    dgFlexRow_ResourceAddedSuccess: dgFlexRow_ResourceAddedSuccess$1,
    dgFlexRow_ResourceRemovedSuccess: dgFlexRow_ResourceRemovedSuccess$1,
    dgFlexRow_SectionTypeLabelFormat: dgFlexRow_SectionTypeLabelFormat$1,
    dgFlexRow_ShowCompactDescription: dgFlexRow_ShowCompactDescription$1,
    dgFlexRow_TextTitle: dgFlexRow_TextTitle$1,
    dgFlexRow_TextTitlePlaceholder: dgFlexRow_TextTitlePlaceholder$1,
    dgFlexRow_UrlRequired: dgFlexRow_UrlRequired$1,
    dgFlexRow_YesDeleteButton: dgFlexRow_YesDeleteButton$1,
    dgFlexMembers_FollowersFormat: dgFlexMembers_FollowersFormat$1,
    dgFlexMembers_UpdatedDaily: dgFlexMembers_UpdatedDaily$1,
    dgFileUploadButton_FileNameUnknown: dgFileUploadButton_FileNameUnknown$1,
    dgFileUploadButton_FilesizeError: dgFileUploadButton_FilesizeError$1,
    dgFileUploadButton_FiletypeError: dgFileUploadButton_FiletypeError$1,
    dgFileUploadButton_HelperInfo: dgFileUploadButton_HelperInfo$1,
    dgFileUploadButton_ImageUpload: dgFileUploadButton_ImageUpload$1,
    dgFileUploadButton_ProcessingFile: dgFileUploadButton_ProcessingFile$1,
    dgFileUploadButton_UploadComplete: dgFileUploadButton_UploadComplete$1,
    dgFileUploadButton_UploadError: dgFileUploadButton_UploadError$1,
    dgFileUploadButton_UploadErrorMessage: dgFileUploadButton_UploadErrorMessage$1,
    dgFileUploadButton_UploadFile: dgFileUploadButton_UploadFile$1,
    dgFileUploadButton_Uploading: dgFileUploadButton_Uploading$1,
    dgFileUploadButton_ViewFileDocumentation: dgFileUploadButton_ViewFileDocumentation$1,
    dgFeed_AddSomething: dgFeed_AddSomething$1,
    dgFeed_AddTopCategories: dgFeed_AddTopCategories$1,
    dgFeed_CompletedCongrats: dgFeed_CompletedCongrats$1,
    dgFeed_CompletedHeading: dgFeed_CompletedHeading$1,
    dgFeed_DismissTip: dgFeed_DismissTip$1,
    dgFeed_EmptyStateFormat: dgFeed_EmptyStateFormat$1,
    dgFeed_EnrolledPathways: dgFeed_EnrolledPathways$1,
    dgFeed_EnrollInPathway: dgFeed_EnrollInPathway$1,
    dgFeed_FollowedPathways: dgFeed_FollowedPathways$1,
    dgFeed_FollowPathway: dgFeed_FollowPathway$1,
    dgFeed_FollowUsers: dgFeed_FollowUsers$1,
    dgFeed_KeepLearning: dgFeed_KeepLearning$1,
    dgFeed_Personalize: dgFeed_Personalize$1,
    dgFeed_ShowAllAssignedFormat: dgFeed_ShowAllAssignedFormat$1,
    dgFeed_ViewAllYourPathways: dgFeed_ViewAllYourPathways$1,
    dgExtensions_AccessError: dgExtensions_AccessError$1,
    dgExtensions_AccessGranted: dgExtensions_AccessGranted$1,
    dgExtensions_AddBookmarkletManually: dgExtensions_AddBookmarkletManually$1,
    dgExtensions_AddCompletedCourses: dgExtensions_AddCompletedCourses$1,
    dgExtensions_AddCompletedItems: dgExtensions_AddCompletedItems$1,
    dgExtensions_AddToChrome: dgExtensions_AddToChrome$1,
    dgExtensions_AddToCollection: dgExtensions_AddToCollection$1,
    dgExtensions_AdminFlexEd: dgExtensions_AdminFlexEd$1,
    dgExtensions_AppsUnavailable: dgExtensions_AppsUnavailable$1,
    dgExtensions_Bookmarklet: dgExtensions_Bookmarklet$1,
    dgExtensions_BookmarkletDragInstructions: dgExtensions_BookmarkletDragInstructions$1,
    dgExtensions_Bookmarks: dgExtensions_Bookmarks$1,
    dgExtensions_BrowserBookmarklet: dgExtensions_BrowserBookmarklet$1,
    dgExtensions_BrowserWindowIllustrationAlt: dgExtensions_BrowserWindowIllustrationAlt$1,
    dgExtensions_ButtonSuccess: dgExtensions_ButtonSuccess$1,
    dgExtensions_Chrome: dgExtensions_Chrome$1,
    dgExtensions_ChromeExtension: dgExtensions_ChromeExtension$1,
    dgExtensions_ChromeInstructionsFormat: dgExtensions_ChromeInstructionsFormat$1,
    dgExtensions_CopyBookmark: dgExtensions_CopyBookmark$1,
    dgExtensions_CreatePathways: dgExtensions_CreatePathways$1,
    dgExtensions_DegreedExtension: dgExtensions_DegreedExtension$1,
    dgExtensions_DisplayFavoritesFormat: dgExtensions_DisplayFavoritesFormat$1,
    dgExtensions_DragToInstallBookmarks: dgExtensions_DragToInstallBookmarks$1,
    dgExtensions_DragToInstallFavorites: dgExtensions_DragToInstallFavorites$1,
    dgExtensions_EmailAddressPlaceholder: dgExtensions_EmailAddressPlaceholder$1,
    dgExtensions_Extension: dgExtensions_Extension$1,
    dgExtensions_ExtensionInstalledAlt: dgExtensions_ExtensionInstalledAlt$1,
    dgExtensions_Favorites: dgExtensions_Favorites$1,
    dgExtensions_Firefox: dgExtensions_Firefox$1,
    dgExtensions_FirefoxInstructionsFormat: dgExtensions_FirefoxInstructionsFormat$1,
    dgExtensions_GetStarted: dgExtensions_GetStarted$1,
    dgExtensions_GrantAccess: dgExtensions_GrantAccess$1,
    dgExtensions_GrantAccessHeader: dgExtensions_GrantAccessHeader$1,
    dgExtensions_IEInstructionsFormat: dgExtensions_IEInstructionsFormat$1,
    dgExtensions_InternetExplorer: dgExtensions_InternetExplorer$1,
    dgExtensions_InvalidEmailError: dgExtensions_InvalidEmailError$1,
    dgExtensions_iOS: dgExtensions_iOS$1,
    dgExtensions_ItemsToPlans: dgExtensions_ItemsToPlans$1,
    dgExtensions_MakeChanges: dgExtensions_MakeChanges$1,
    dgExtensions_ManualBookmarkInstructions: dgExtensions_ManualBookmarkInstructions$1,
    dgExtensions_Mobile: dgExtensions_Mobile$1,
    dgExtensions_Oauth_Authorize: dgExtensions_Oauth_Authorize$1,
    dgExtensions_Oauth_Request_Access: dgExtensions_Oauth_Request_Access$1,
    dgExtensions_PlusDegreedButton: dgExtensions_PlusDegreedButton$1,
    dgExtensions_RequestAccess: dgExtensions_RequestAccess$1,
    dgExtensions_Safari: dgExtensions_Safari$1,
    dgExtensions_SafariInstructionsFormat: dgExtensions_SafariInstructionsFormat$1,
    dgExtensions_SaveItemsForLater: dgExtensions_SaveItemsForLater$1,
    dgExtensions_ShareItems: dgExtensions_ShareItems$1,
    dgExtensions_SummaryEdge: dgExtensions_SummaryEdge$1,
    dgExtensions_SummaryFormat: dgExtensions_SummaryFormat$1,
    dgExtensions_TitleEdge: dgExtensions_TitleEdge$1,
    dgExtensions_TitleFormat: dgExtensions_TitleFormat$1,
    dgExtensions_TryOurBookmarklet: dgExtensions_TryOurBookmarklet$1,
    dgExtensions_UnableToDownload: dgExtensions_UnableToDownload$1,
    dgExtensions_WishGrantAccess: dgExtensions_WishGrantAccess$1,
    dgExtensions_YourBrowser: dgExtensions_YourBrowser$1,
    dgEnrolled_CompletedTooltipFormat: dgEnrolled_CompletedTooltipFormat$1,
    dgEnrolled_DateAddedColumn: dgEnrolled_DateAddedColumn$1,
    dgEnrolled_EnrolledCountFormat: dgEnrolled_EnrolledCountFormat$1,
    dgEnrolled_EnrollmentDate: dgEnrolled_EnrollmentDate$1,
    dgEnrolled_NameColumn: dgEnrolled_NameColumn$1,
    dgDownloadableReports_ChooseGroup: dgDownloadableReports_ChooseGroup$1,
    dgDownloadableReports_ChooseReportType: dgDownloadableReports_ChooseReportType$1,
    dgDownloadableReports_DataSet: dgDownloadableReports_DataSet$1,
    dgDownloadableReports_DateCreated: dgDownloadableReports_DateCreated$1,
    dgDownloadableReports_datePickerText: dgDownloadableReports_datePickerText$1,
    dgDownloadableReports_DateRange: dgDownloadableReports_DateRange$1,
    dgDownloadableReports_Download: dgDownloadableReports_Download$1,
    dgDownloadableReports_DownloadableReports: dgDownloadableReports_DownloadableReports$1,
    dgDownloadableReports_DownloadReport: dgDownloadableReports_DownloadReport$1,
    dgDownloadableReports_Generate: dgDownloadableReports_Generate$1,
    dgDownloadableReports_GenerateDataReport: dgDownloadableReports_GenerateDataReport$1,
    dgDownloadableReports_GenerateReport: dgDownloadableReports_GenerateReport$1,
    dgDownloadableReports_Generating: dgDownloadableReports_Generating$1,
    dgDownloadableReports_GroupOptionalTitle: dgDownloadableReports_GroupOptionalTitle$1,
    dgDownloadableReports_GroupTitle: dgDownloadableReports_GroupTitle$1,
    dgDownloadableReports_MaxDaysReached: dgDownloadableReports_MaxDaysReached$1,
    dgDownloadableReports_NoAvailableGroups: dgDownloadableReports_NoAvailableGroups$1,
    dgDownloadableReports_NoMatchingReportTypes: dgDownloadableReports_NoMatchingReportTypes$1,
    dgDownloadableReports_Parameters_InputIdentifier_Name: dgDownloadableReports_Parameters_InputIdentifier_Name$1,
    dgDownloadableReports_Parameters_InputIdentifier_Placeholder: dgDownloadableReports_Parameters_InputIdentifier_Placeholder$1,
    dgDownloadableReports_Parameters_InputIdentifierList_Name: dgDownloadableReports_Parameters_InputIdentifierList_Name$1,
    dgDownloadableReports_Parameters_InputIdentifierList_Placeholder: dgDownloadableReports_Parameters_InputIdentifierList_Placeholder$1,
    dgDownloadableReports_Report10: dgDownloadableReports_Report10$1,
    dgDownloadableReports_Report11: dgDownloadableReports_Report11$1,
    dgDownloadableReports_Report12: dgDownloadableReports_Report12$1,
    dgDownloadableReports_Report13: dgDownloadableReports_Report13$1,
    dgDownloadableReports_Report14: dgDownloadableReports_Report14$1,
    dgDownloadableReports_Report3: dgDownloadableReports_Report3$1,
    dgDownloadableReports_Report4: dgDownloadableReports_Report4$1,
    dgDownloadableReports_Report5: dgDownloadableReports_Report5$1,
    dgDownloadableReports_Report6: dgDownloadableReports_Report6$1,
    dgDownloadableReports_Report7: dgDownloadableReports_Report7$1,
    dgDownloadableReports_Report8: dgDownloadableReports_Report8$1,
    dgDownloadableReports_Report9: dgDownloadableReports_Report9$1,
    dgDownloadableReports_ReportContentCompletionsDownload: dgDownloadableReports_ReportContentCompletionsDownload$1,
    dgDownloadableReports_ReportContentTrendsAdded: dgDownloadableReports_ReportContentTrendsAdded$1,
    dgDownloadableReports_ReportContentTrendsViewed: dgDownloadableReports_ReportContentTrendsViewed$1,
    dgDownloadableReports_ReportDate: dgDownloadableReports_ReportDate$1,
    dgDownloadableReports_ReportGenerated: dgDownloadableReports_ReportGenerated$1,
    dgDownloadableReports_ReportPathwayDetailsDownload: dgDownloadableReports_ReportPathwayDetailsDownload$1,
    dgDownloadableReports_ReportPopularTopics: dgDownloadableReports_ReportPopularTopics$1,
    dgDownloadableReports_ReportSkillAnalyticsTop1000SkillsRated: dgDownloadableReports_ReportSkillAnalyticsTop1000SkillsRated$1,
    dgDownloadableReports_ReportSkillReport: dgDownloadableReports_ReportSkillReport$1,
    dgDownloadableReports_ReportTop1000SkillsRated: dgDownloadableReports_ReportTop1000SkillsRated$1,
    dgDownloadableReports_ReportTopProviders: dgDownloadableReports_ReportTopProviders$1,
    dgDownloadableReports_ReportTopSearches: dgDownloadableReports_ReportTopSearches$1,
    dgDownloadableReports_ReportType: dgDownloadableReports_ReportType$1,
    dgDownloadableReports_ReportTypeRequired: dgDownloadableReports_ReportTypeRequired$1,
    dgDownloadableReports_ToastMessage: dgDownloadableReports_ToastMessage$1,
    dgDiscipline_ExpertsFormat: dgDiscipline_ExpertsFormat$1,
    dgDiscipline_StartApplication: dgDiscipline_StartApplication$1,
    dgCredPrePayLogin_DegreedAccount: dgCredPrePayLogin_DegreedAccount$1,
    dgCredPrePayLogin_LoginContinue: dgCredPrePayLogin_LoginContinue$1,
    dgCredentialDisplay_StartDateFormat: dgCredentialDisplay_StartDateFormat$1,
    dgCredentialDisplay_ViewApplicationFormat: dgCredentialDisplay_ViewApplicationFormat$1,
    dgCopyLink_CopyInviteLink: dgCopyLink_CopyInviteLink$1,
    dgCopyLink_CopyLink: dgCopyLink_CopyLink$1,
    dgCopyLink_InviteURL: dgCopyLink_InviteURL$1,
    dgCookieBanner_accept: dgCookieBanner_accept$1,
    dgCookieBanner_learnMore: dgCookieBanner_learnMore$1,
    dgCookieBanner_message: dgCookieBanner_message$1,
    dgCookieBanner_message_V2: dgCookieBanner_message_V2$1,
    dgContentTile_AuthorshipAuthor: dgContentTile_AuthorshipAuthor$1,
    dgContentTile_AuthorshipCreator: dgContentTile_AuthorshipCreator$1,
    dgContentTile_AuthorshipPresenter: dgContentTile_AuthorshipPresenter$1,
    dgContentTile_AuthorshipTeacher: dgContentTile_AuthorshipTeacher$1,
    dgContentTile_Verified: dgContentTile_Verified$1,
    dgContentHosting_DragAndDrop: dgContentHosting_DragAndDrop$1,
    dgContentHosting_Hosted: dgContentHosting_Hosted$1,
    dgContentHosting_HostedFiles: dgContentHosting_HostedFiles$1,
    dgContentHosting_InvalidFileType: dgContentHosting_InvalidFileType$1,
    dgContentHosting_OrgStorageLimitAlmostReached: dgContentHosting_OrgStorageLimitAlmostReached$1,
    dgContentHosting_OrgStorageLimitIsReached: dgContentHosting_OrgStorageLimitIsReached$1,
    dgContentCard_AssignedByFormat: dgContentCard_AssignedByFormat$1,
    dgContentCard_CompleteByDateFormat: dgContentCard_CompleteByDateFormat$1,
    dgContentCard_FromJobRoleFormat: dgContentCard_FromJobRoleFormat$1,
    dgContentCard_FromPathwaysFormat: dgContentCard_FromPathwaysFormat$1,
    dgContentCard_LibraryContent: dgContentCard_LibraryContent$1,
    dgContentCard_MoreLikeThisCompletedFormat: dgContentCard_MoreLikeThisCompletedFormat$1,
    dgContentCard_MoreLikeThisReadFormat: dgContentCard_MoreLikeThisReadFormat$1,
    dgContentCard_MoreLikeThisWatchedFormat: dgContentCard_MoreLikeThisWatchedFormat$1,
    dgContentCard_Opportunity: dgContentCard_Opportunity$1,
    dgContentCard_PopularCompletedFormat: dgContentCard_PopularCompletedFormat$1,
    dgContentCard_PopularInFormat: dgContentCard_PopularInFormat$1,
    dgContentCard_PopularReadFormat: dgContentCard_PopularReadFormat$1,
    dgContentCard_PopularWatchedFormat: dgContentCard_PopularWatchedFormat$1,
    dgContentCard_ReadByFormat: dgContentCard_ReadByFormat$1,
    dgContentCard_ReadMore: dgContentCard_ReadMore$1,
    dgContentCard_RecommendedByFormat: dgContentCard_RecommendedByFormat$1,
    dgContentCard_RequiredLearning: dgContentCard_RequiredLearning$1,
    dgContentCard_RequiredLearningDate: dgContentCard_RequiredLearningDate$1,
    dgContentCard_SavedForLater: dgContentCard_SavedForLater$1,
    dgContentCard_WatchedByFormat: dgContentCard_WatchedByFormat$1,
    dgCompleteViewedTip_ThanksPluralFormat: dgCompleteViewedTip_ThanksPluralFormat$1,
    dgCompleteViewedTip_ThanksSingularFormat: dgCompleteViewedTip_ThanksSingularFormat$1,
    dgComments_AddAReply: dgComments_AddAReply$1,
    dgComments_ShareSomethingAbout: dgComments_ShareSomethingAbout$1,
    dgComments_WhatDidYouLearnFormat: dgComments_WhatDidYouLearnFormat$1,
    dgComment_CollapseCommentsFormat: dgComment_CollapseCommentsFormat$1,
    dgComment_CollapseOneComment: dgComment_CollapseOneComment$1,
    dgComment_CommentHidden: dgComment_CommentHidden$1,
    dgComment_DeleteConfirm: dgComment_DeleteConfirm$1,
    dgComment_DeleteTakeaway: dgComment_DeleteTakeaway$1,
    dgComment_DeleteTakeawayReplies: dgComment_DeleteTakeawayReplies$1,
    dgComment_Edited: dgComment_Edited$1,
    dgComment_HideComments: dgComment_HideComments$1,
    dgComment_JustNow: dgComment_JustNow$1,
    dgComment_PlusReadMore: dgComment_PlusReadMore$1,
    dgComment_ReplyHidden: dgComment_ReplyHidden$1,
    dgComment_ShowComments: dgComment_ShowComments$1,
    dgComment_ShowCommentsFormat: dgComment_ShowCommentsFormat$1,
    dgComment_ShowMoreCommentsFormat: dgComment_ShowMoreCommentsFormat$1,
    dgComment_ShowMultiplePreviousRepliesFormat: dgComment_ShowMultiplePreviousRepliesFormat$1,
    dgComment_ShowOneComment: dgComment_ShowOneComment$1,
    dgComment_ShowPreviousReplies: dgComment_ShowPreviousReplies$1,
    dgComment_ShowTakeawaysFormat: dgComment_ShowTakeawaysFormat$1,
    dgComment_ViewConversation: dgComment_ViewConversation$1,
    dgComment_ViewMoreFormat: dgComment_ViewMoreFormat$1,
    dgCombobox_SubmitSelection: dgCombobox_SubmitSelection$1,
    dgColorpickerTextDarkness_DarkText: dgColorpickerTextDarkness_DarkText$1,
    dgColorpickerTextDarkness_LightText: dgColorpickerTextDarkness_LightText$1,
    dgCarousel_ShowNextItems: dgCarousel_ShowNextItems$1,
    dgCarousel_ShowPreviousItems: dgCarousel_ShowPreviousItems$1,
    dgBrowseProviders_LaunchFormat: dgBrowseProviders_LaunchFormat$1,
    dgBrowseProviders_Search: dgBrowseProviders_Search$1,
    dgBrowseProviders_SearchResourcesFormat: dgBrowseProviders_SearchResourcesFormat$1,
    dgBrowseProviders_VisitSiteFormat: dgBrowseProviders_VisitSiteFormat$1,
    dgBrowsePathways_NoPathways: dgBrowsePathways_NoPathways$1,
    dgBrowsePathways_NoRecommendations: dgBrowsePathways_NoRecommendations$1,
    dgBrowseFeaturedLearning_FromPathwayFormat: dgBrowseFeaturedLearning_FromPathwayFormat$1,
    dgBrowseFeaturedLearning_PopularGroupFormat: dgBrowseFeaturedLearning_PopularGroupFormat$1,
    dgBrowseFeaturedLearning_ReadByFormat: dgBrowseFeaturedLearning_ReadByFormat$1,
    dgBrowseFeaturedLearning_RecommendedByFormat: dgBrowseFeaturedLearning_RecommendedByFormat$1,
    dgBrowseFeaturedLearning_SavedForLater: dgBrowseFeaturedLearning_SavedForLater$1,
    dgBrowseFeaturedLearning_WatchedByFormat: dgBrowseFeaturedLearning_WatchedByFormat$1,
    dgAuthorVideo_CameraNotAuthorizedError: dgAuthorVideo_CameraNotAuthorizedError$1,
    dgAuthorVideo_CameraNotFoundError: dgAuthorVideo_CameraNotFoundError$1,
    dgAuthorVideo_CameraNotReadableError: dgAuthorVideo_CameraNotReadableError$1,
    dgAuthorVideo_ConfirmRedoRecording: dgAuthorVideo_ConfirmRedoRecording$1,
    dgAuthorVideo_ModalTitle: dgAuthorVideo_ModalTitle$1,
    dgAuthorVideo_playerError: dgAuthorVideo_playerError$1,
    dgAuthorVideo_ProcessingVideo: dgAuthorVideo_ProcessingVideo$1,
    dgAuthorVideo_recorderError: dgAuthorVideo_recorderError$1,
    dgAuthorVideo_RecordVideoOnlyError: dgAuthorVideo_RecordVideoOnlyError$1,
    dgAuthorVideo_Redirecting: dgAuthorVideo_Redirecting$1,
    dgAuthorVideo_RedoRecording: dgAuthorVideo_RedoRecording$1,
    dgAuthorVideo_StartRecording: dgAuthorVideo_StartRecording$1,
    dgAuthorVideo_StopRecording: dgAuthorVideo_StopRecording$1,
    dgAuthorVideo_TimeInMinutes: dgAuthorVideo_TimeInMinutes$1,
    dgAuthorVideo_TimeLimitReached: dgAuthorVideo_TimeLimitReached$1,
    dgAuthorVideo_TimeWarningFormat: dgAuthorVideo_TimeWarningFormat$1,
    dgAuthorVideo_TryAgain: dgAuthorVideo_TryAgain$1,
    dgAuthorVideo_UploadError: dgAuthorVideo_UploadError$1,
    dgAuthorVideo_UploadErrorMessage: dgAuthorVideo_UploadErrorMessage$1,
    dgAuthorVideo_Uploading: dgAuthorVideo_Uploading$1,
    DgAssistant_ErrorText: DgAssistant_ErrorText$1,
    DgAssistant_Executive_Description: DgAssistant_Executive_Description$1,
    DgAssistant_Executive_Title: DgAssistant_Executive_Title$1,
    DgAssistant_LatestFrom: DgAssistant_LatestFrom$1,
    DgAssistant_Name: DgAssistant_Name$1,
    DgAssistant_NoteText: DgAssistant_NoteText$1,
    DgAssistant_NotificationText: DgAssistant_NotificationText$1,
    DgAssistant_PlaceholderProcessing: DgAssistant_PlaceholderProcessing$1,
    DgAssistant_PlaceholderReady: DgAssistant_PlaceholderReady$1,
    DgAssistant_PlaceholderStart: DgAssistant_PlaceholderStart$1,
    DgAssistant_SelectedJourneyText: DgAssistant_SelectedJourneyText$1,
    DgAssistant_ShowLessText: DgAssistant_ShowLessText$1,
    DgAssistant_ShowMoreText: DgAssistant_ShowMoreText$1,
    DgAssistant_StartNewText: DgAssistant_StartNewText$1,
    DgAssistant_WelcomeText: DgAssistant_WelcomeText$1,
    DgAssistant_YouText: DgAssistant_YouText$1,
    dgAssignmentsOverview_AssignedGroupFormat: dgAssignmentsOverview_AssignedGroupFormat$1,
    dgAssignmentsOverview_AssignedSingleFormat: dgAssignmentsOverview_AssignedSingleFormat$1,
    dgAssignmentsOverview_AssignmentAbout: dgAssignmentsOverview_AssignmentAbout$1,
    dgAssignmentsOverview_AssignmentEmptyTitle: dgAssignmentsOverview_AssignmentEmptyTitle$1,
    dgAssignmentsOverview_AssignmentsDescription: dgAssignmentsOverview_AssignmentsDescription$1,
    dgAssignmentsOverview_AssignmentSearchPlaceholder: dgAssignmentsOverview_AssignmentSearchPlaceholder$1,
    dgAssignmentsOverview_AssignmentsTableDescription: dgAssignmentsOverview_AssignmentsTableDescription$1,
    dgAssignmentsOverview_CaughtUp: dgAssignmentsOverview_CaughtUp$1,
    dgAssignmentsOverview_Completed: dgAssignmentsOverview_Completed$1,
    dgAssignmentsOverview_CompletedAssignmentsEmpty: dgAssignmentsOverview_CompletedAssignmentsEmpty$1,
    dgAssignmentsOverview_CountDueSoon: dgAssignmentsOverview_CountDueSoon$1,
    dgAssignmentsOverview_CountOverdue: dgAssignmentsOverview_CountOverdue$1,
    dgAssignmentsOverview_Description: dgAssignmentsOverview_Description$1,
    dgAssignmentsOverview_DueDate: dgAssignmentsOverview_DueDate$1,
    dgAssignmentsOverview_DueSoon: dgAssignmentsOverview_DueSoon$1,
    dgAssignmentsOverview_EmptyBody: dgAssignmentsOverview_EmptyBody$1,
    dgAssignmentsOverview_EmptyCompletedText: dgAssignmentsOverview_EmptyCompletedText$1,
    dgAssignmentsOverview_EmptyCompletedTitle: dgAssignmentsOverview_EmptyCompletedTitle$1,
    dgAssignmentsOverview_EmptyHeader: dgAssignmentsOverview_EmptyHeader$1,
    dgAssignmentsOverview_EmptyToDoText: dgAssignmentsOverview_EmptyToDoText$1,
    dgAssignmentsOverview_Incomplete: dgAssignmentsOverview_Incomplete$1,
    dgAssignmentsOverview_NextDueDate: dgAssignmentsOverview_NextDueDate$1,
    dgAssignmentsOverview_NoAssignments: dgAssignmentsOverview_NoAssignments$1,
    dgAssignmentsOverview_NoAssignmentsBody: dgAssignmentsOverview_NoAssignmentsBody$1,
    dgAssignmentsOverview_NoAssignmentsHeader: dgAssignmentsOverview_NoAssignmentsHeader$1,
    dgAssignmentsOverview_NoAssignmentsHelpText: dgAssignmentsOverview_NoAssignmentsHelpText$1,
    dgAssignmentsOverview_NoCompletedAssignments: dgAssignmentsOverview_NoCompletedAssignments$1,
    dgAssignmentsOverview_NoInProgressAssignments: dgAssignmentsOverview_NoInProgressAssignments$1,
    dgAssignmentsOverview_OtherAssignmentsBody: dgAssignmentsOverview_OtherAssignmentsBody$1,
    dgAssignmentsOverview_OtherAssignmentsEmpty: dgAssignmentsOverview_OtherAssignmentsEmpty$1,
    dgAssignmentsOverview_OtherAssignmentsHeader: dgAssignmentsOverview_OtherAssignmentsHeader$1,
    dgAssignmentsOverview_Overdue: dgAssignmentsOverview_Overdue$1,
    dgAssignmentsOverview_OverdueAndDueSoon: dgAssignmentsOverview_OverdueAndDueSoon$1,
    dgAssignmentsOverview_RequiredAssignmentsBody: dgAssignmentsOverview_RequiredAssignmentsBody$1,
    dgAssignmentsOverview_RequiredAssignmentsEmpty: dgAssignmentsOverview_RequiredAssignmentsEmpty$1,
    dgAssignmentsOverview_RequiredAssignmentsHeader: dgAssignmentsOverview_RequiredAssignmentsHeader$1,
    dgAssignmentsOverview_RequiredGroupAttendedFormat: dgAssignmentsOverview_RequiredGroupAttendedFormat$1,
    dgAssignmentsOverview_RequiredGroupCompletedFormat: dgAssignmentsOverview_RequiredGroupCompletedFormat$1,
    dgAssignmentsOverview_RequiredGroupFollowedFormat: dgAssignmentsOverview_RequiredGroupFollowedFormat$1,
    dgAssignmentsOverview_RequiredGroupFormat: dgAssignmentsOverview_RequiredGroupFormat$1,
    dgAssignmentsOverview_RequiredGroupReadFormat: dgAssignmentsOverview_RequiredGroupReadFormat$1,
    dgAssignmentsOverview_RequiredGroupWatchedFormat: dgAssignmentsOverview_RequiredGroupWatchedFormat$1,
    dgAssignmentsOverview_RequiredSingleAlreadyCompletedFormat: dgAssignmentsOverview_RequiredSingleAlreadyCompletedFormat$1,
    dgAssignmentsOverview_RequiredSingleAttendedFormat: dgAssignmentsOverview_RequiredSingleAttendedFormat$1,
    dgAssignmentsOverview_RequiredSingleAttendedOverdueFormat: dgAssignmentsOverview_RequiredSingleAttendedOverdueFormat$1,
    dgAssignmentsOverview_RequiredSingleCompletedFormat: dgAssignmentsOverview_RequiredSingleCompletedFormat$1,
    dgAssignmentsOverview_RequiredSingleCompletedOverdueFormat: dgAssignmentsOverview_RequiredSingleCompletedOverdueFormat$1,
    dgAssignmentsOverview_RequiredSingleFollowedFormat: dgAssignmentsOverview_RequiredSingleFollowedFormat$1,
    dgAssignmentsOverview_RequiredSingleFollowedOverdueFormat: dgAssignmentsOverview_RequiredSingleFollowedOverdueFormat$1,
    dgAssignmentsOverview_RequiredSingleFormat: dgAssignmentsOverview_RequiredSingleFormat$1,
    dgAssignmentsOverview_RequiredSingleOverdueFormat: dgAssignmentsOverview_RequiredSingleOverdueFormat$1,
    dgAssignmentsOverview_RequiredSingleReadFormat: dgAssignmentsOverview_RequiredSingleReadFormat$1,
    dgAssignmentsOverview_RequiredSingleReadOverdueFormat: dgAssignmentsOverview_RequiredSingleReadOverdueFormat$1,
    dgAssignmentsOverview_RequiredSingleWatchedFormat: dgAssignmentsOverview_RequiredSingleWatchedFormat$1,
    dgAssignmentsOverview_RequiredSingleWatchedOverdueFormat: dgAssignmentsOverview_RequiredSingleWatchedOverdueFormat$1,
    dgAssignmentsOverview_ThirdPartyCompletedDate: dgAssignmentsOverview_ThirdPartyCompletedDate$1,
    dgAssignmentsOverview_YourAssignments: dgAssignmentsOverview_YourAssignments$1,
    dgAddItems_AddItem: dgAddItems_AddItem$1,
    dgAddItems_EmailDomainError: dgAddItems_EmailDomainError$1,
    dgAddItems_EmailExistsError: dgAddItems_EmailExistsError$1,
    dgAddItems_InvalidEmailError: dgAddItems_InvalidEmailError$1,
    dgAddItems_MoreFormat: dgAddItems_MoreFormat$1,
    dgActivityDetails_GoalActionFormat: dgActivityDetails_GoalActionFormat$1,
    dgActivityDetails_GroupActivityAdd: dgActivityDetails_GroupActivityAdd$1,
    dgActivityDetails_GroupActivityRemove: dgActivityDetails_GroupActivityRemove$1,
    dgActivityDetails_GroupActivityUpdate: dgActivityDetails_GroupActivityUpdate$1,
    dgActivityDetails_InputActionAdded: dgActivityDetails_InputActionAdded$1,
    dgActivityDetails_InputActionArticle: dgActivityDetails_InputActionArticle$1,
    dgActivityDetails_InputActionBook: dgActivityDetails_InputActionBook$1,
    dgActivityDetails_InputActionCourse: dgActivityDetails_InputActionCourse$1,
    dgActivityDetails_InputActionEpisode: dgActivityDetails_InputActionEpisode$1,
    dgActivityDetails_InputActionEvent: dgActivityDetails_InputActionEvent$1,
    dgActivityDetails_InputActionTask: dgActivityDetails_InputActionTask$1,
    dgActivityDetails_InputActionVideo: dgActivityDetails_InputActionVideo$1,
    dgActivityDetails_PostedFormat: dgActivityDetails_PostedFormat$1,
    dgActivityDetails_RemoveActivity: dgActivityDetails_RemoveActivity$1,
    dgActivityDetails_RemoveConfirm: dgActivityDetails_RemoveConfirm$1,
    dgActivityDetails_UserActionDateFormat: dgActivityDetails_UserActionDateFormat$1,
    dgActivityDetails_UserActionFormat: dgActivityDetails_UserActionFormat$1,
    dgActivityDetails_UserActionItemTitleDateFormat: dgActivityDetails_UserActionItemTitleDateFormat$1,
    dgActivityDetails_UserActionItemTitleFormat: dgActivityDetails_UserActionItemTitleFormat$1,
    dgActivityDetails_UserActionTheFollowingDateFormat: dgActivityDetails_UserActionTheFollowingDateFormat$1,
    dgActivityDetails_UserActionTheFollowingDueDateFormat: dgActivityDetails_UserActionTheFollowingDueDateFormat$1,
    dgActivityDetails_UserActionTheFollowingFormat: dgActivityDetails_UserActionTheFollowingFormat$1,
    dgActivityDetails_UserAddedNewUserFormat: dgActivityDetails_UserAddedNewUserFormat$1,
    dgActivityDetails_UserAssignedTheFollowingDateFormat: dgActivityDetails_UserAssignedTheFollowingDateFormat$1,
    dgActivityDetails_UserAssignedTheFollowingFormat: dgActivityDetails_UserAssignedTheFollowingFormat$1,
    dgActivityDetails_UserJoinedGroupFormat: dgActivityDetails_UserJoinedGroupFormat$1,
    dgActivityDetails_UserLeftGroupFormat: dgActivityDetails_UserLeftGroupFormat$1,
    dgActivityDetails_UserPostedAgoFormat: dgActivityDetails_UserPostedAgoFormat$1,
    dgActivityDetails_UserPostedFormat: dgActivityDetails_UserPostedFormat$1,
    dgActivityDetails_UserRemovedUserFormat: dgActivityDetails_UserRemovedUserFormat$1,
    dgActiveUserChartCtrl_A11yTooltipFormatDateRange: dgActiveUserChartCtrl_A11yTooltipFormatDateRange$1,
    dgActiveUserChartCtrl_ActiveUsers: dgActiveUserChartCtrl_ActiveUsers$1,
    dgActiveUserChartCtrl_ActiveUsersToolTip: dgActiveUserChartCtrl_ActiveUsersToolTip$1,
    dgActiveUserChartCtrl_DailyActiveUsers: dgActiveUserChartCtrl_DailyActiveUsers$1,
    dgActiveUserChartCtrl_Date: dgActiveUserChartCtrl_Date$1,
    dgActiveUserChartCtrl_MonthlyActiveUsers: dgActiveUserChartCtrl_MonthlyActiveUsers$1,
    dgActiveUserChartCtrl_NewReturningUsers: dgActiveUserChartCtrl_NewReturningUsers$1,
    dgActiveUserChartCtrl_NewUsers: dgActiveUserChartCtrl_NewUsers$1,
    dgActiveUserChartCtrl_NewUsersToolTip: dgActiveUserChartCtrl_NewUsersToolTip$1,
    dgActiveUserChartCtrl_ReturningUsers: dgActiveUserChartCtrl_ReturningUsers$1,
    dgActiveUserChartCtrl_ReturningUsersToolTip: dgActiveUserChartCtrl_ReturningUsersToolTip$1,
    dgActiveUserChartCtrl_SelectUserType: dgActiveUserChartCtrl_SelectUserType$1,
    dgActiveUserChartCtrl_WeeklyActiveUsers: dgActiveUserChartCtrl_WeeklyActiveUsers$1,
    deleteModal_Cancel: deleteModal_Cancel$1,
    deleteModal_Delete: deleteModal_Delete$1,
    DegreeFormCtrl_CollegeName: DegreeFormCtrl_CollegeName$1,
    DegreeFormCtrl_CompletionDate: DegreeFormCtrl_CompletionDate$1,
    DegreeFormCtrl_DegreeLevel: DegreeFormCtrl_DegreeLevel$1,
    DegreeFormCtrl_DegreeTitle: DegreeFormCtrl_DegreeTitle$1,
    DegreeFormCtrl_FieldOfStudy: DegreeFormCtrl_FieldOfStudy$1,
    DegreeFormCtrl_GradePointAvg: DegreeFormCtrl_GradePointAvg$1,
    DataPrivacyModalCtrl_AcceptContinue: DataPrivacyModalCtrl_AcceptContinue$1,
    DataPrivacyModalCtrl_Header: DataPrivacyModalCtrl_Header$1,
    DataPrivacyModalCtrl_PolicyAcceptLabel: DataPrivacyModalCtrl_PolicyAcceptLabel$1,
    DataPrivacyModalCtrl_PolicyLegal: DataPrivacyModalCtrl_PolicyLegal$1,
    DataPrivacyModalCtrl_PolicyReviewLabel: DataPrivacyModalCtrl_PolicyReviewLabel$1,
    DashboardNav_AddFocusSkills: DashboardNav_AddFocusSkills$1,
    DashboardNav_AddSkill: DashboardNav_AddSkill$1,
    DashboardNav_AddSkillRating: DashboardNav_AddSkillRating$1,
    DashboardNav_AllActivity: DashboardNav_AllActivity$1,
    DashboardNav_AllInsights: DashboardNav_AllInsights$1,
    DashboardNav_Assignments: DashboardNav_Assignments$1,
    DashboardNav_CertificationInProgress: DashboardNav_CertificationInProgress$1,
    DashboardNav_CertifiedLevel: DashboardNav_CertifiedLevel$1,
    DashboardNav_Completions: DashboardNav_Completions$1,
    DashboardNav_DismissRecommendation: DashboardNav_DismissRecommendation$1,
    DashboardNav_EvalInProgress: DashboardNav_EvalInProgress$1,
    DashboardNav_EvalRatingLevel: DashboardNav_EvalRatingLevel$1,
    DashboardNav_FindGroups: DashboardNav_FindGroups$1,
    DashboardNav_FindPathway: DashboardNav_FindPathway$1,
    DashboardNav_FollowingEverybody: DashboardNav_FollowingEverybody$1,
    DashboardNav_GetMonthlyActivityError: DashboardNav_GetMonthlyActivityError$1,
    DashboardNav_ItemsViewed: DashboardNav_ItemsViewed$1,
    DashboardNav_LearnerHub: DashboardNav_LearnerHub$1,
    DashboardNav_ManageFollowing: DashboardNav_ManageFollowing$1,
    DashboardNav_ManagerRatingLevel: DashboardNav_ManagerRatingLevel$1,
    DashboardNav_MaxFocusSkillDesc: DashboardNav_MaxFocusSkillDesc$1,
    DashboardNav_MonthlyActivity: DashboardNav_MonthlyActivity$1,
    DashboardNav_NegativeActivityChange: DashboardNav_NegativeActivityChange$1,
    DashboardNav_NoActivityChange: DashboardNav_NoActivityChange$1,
    DashboardNav_PathwayPercentComplete: DashboardNav_PathwayPercentComplete$1,
    DashboardNav_PeopleToFollow: DashboardNav_PeopleToFollow$1,
    DashboardNav_PointsEarned: DashboardNav_PointsEarned$1,
    DashboardNav_PositiveActivityChange: DashboardNav_PositiveActivityChange$1,
    DashboardNav_RefreshRecommended: DashboardNav_RefreshRecommended$1,
    DashboardNav_Resources: DashboardNav_Resources$1,
    DashboardNav_SearchBySkill: DashboardNav_SearchBySkill$1,
    DashboardNav_SelfRatingLevel: DashboardNav_SelfRatingLevel$1,
    DashboardNav_UpdateRatings: DashboardNav_UpdateRatings$1,
    DashboardNav_ViewMyProgress: DashboardNav_ViewMyProgress$1,
    DashboardNav_YourGroups: DashboardNav_YourGroups$1,
    DashboardNav_YourPathways: DashboardNav_YourPathways$1,
    DashboardNav_YourPlans: DashboardNav_YourPlans$1,
    DashboardNav_YourSkills: DashboardNav_YourSkills$1,
    CredVerificationCtrl_Instructions1: CredVerificationCtrl_Instructions1$1,
    CredVerificationCtrl_Instructions2: CredVerificationCtrl_Instructions2$1,
    CredStartCtrl_ApplicationReviewed: CredStartCtrl_ApplicationReviewed$1,
    CredStartCtrl_AssertBehaviors: CredStartCtrl_AssertBehaviors$1,
    CredStartCtrl_DegreedSkillsCertification: CredStartCtrl_DegreedSkillsCertification$1,
    CredStartCtrl_GetCertified: CredStartCtrl_GetCertified$1,
    CredStartCtrl_GetCertifiedPrice: CredStartCtrl_GetCertifiedPrice$1,
    CredStartCtrl_GetCertifiedSkillFormat: CredStartCtrl_GetCertifiedSkillFormat$1,
    CredStartCtrl_GetCertifiedUnlimitedFormat: CredStartCtrl_GetCertifiedUnlimitedFormat$1,
    CredStartCtrl_GetEndorsed: CredStartCtrl_GetEndorsed$1,
    CredStartCtrl_HowItWorks: CredStartCtrl_HowItWorks$1,
    CredStartCtrl_HowItWorksParagraph: CredStartCtrl_HowItWorksParagraph$1,
    CredStartCtrl_ProvideEvidence: CredStartCtrl_ProvideEvidence$1,
    CredStartCtrl_ReceiveResults: CredStartCtrl_ReceiveResults$1,
    CredStartCtrl_ReviewPeers: CredStartCtrl_ReviewPeers$1,
    CredStartCtrl_ReviewSubmit: CredStartCtrl_ReviewSubmit$1,
    CredStartCtrl_VerifyYourSkills: CredStartCtrl_VerifyYourSkills$1,
    CredStartCtrl_VideoTitle: CredStartCtrl_VideoTitle$1,
    CredSparkSvc_AssessmentError: CredSparkSvc_AssessmentError$1,
    CredSparkSvc_SyncError: CredSparkSvc_SyncError$1,
    CredReviewCtrl_ConfirmButton: CredReviewCtrl_ConfirmButton$1,
    CredReviewCtrl_Description: CredReviewCtrl_Description$1,
    CredReviewCtrl_Endorsers: CredReviewCtrl_Endorsers$1,
    CredResultsCtrl_CongratsParagraph: CredResultsCtrl_CongratsParagraph$1,
    CredResultsCtrl_CongratsTitle: CredResultsCtrl_CongratsTitle$1,
    CredPrePayType_CertificationType: CredPrePayType_CertificationType$1,
    CredPrePayType_credit: CredPrePayType_credit$1,
    CredPrePayType_creditAction: CredPrePayType_creditAction$1,
    CredPrePayType_creditDescription: CredPrePayType_creditDescription$1,
    CredPrePayType_lifetime: CredPrePayType_lifetime$1,
    CredPrePayType_lifetimeAction: CredPrePayType_lifetimeAction$1,
    CredPrePayType_lifetimeDescription: CredPrePayType_lifetimeDescription$1,
    CredPrePayType_LimitedOffer: CredPrePayType_LimitedOffer$1,
    CredPrePayType_OneSkillDescription: CredPrePayType_OneSkillDescription$1,
    CredPrePayType_TypeHeading: CredPrePayType_TypeHeading$1,
    CredPrePayCtrl_Payment: CredPrePayCtrl_Payment$1,
    CredPrePayCtrl_SaveAndConfirm: CredPrePayCtrl_SaveAndConfirm$1,
    CredPrePayCtrl_SubmitPayment: CredPrePayCtrl_SubmitPayment$1,
    CredPrePayChooseSkillCtrl_ChooseASkill: CredPrePayChooseSkillCtrl_ChooseASkill$1,
    CredPrePayChooseSkillCtrl_ChooseSkill: CredPrePayChooseSkillCtrl_ChooseSkill$1,
    CredPrePayChooseSkillCtrl_ContinueToApplication: CredPrePayChooseSkillCtrl_ContinueToApplication$1,
    CredPrePayChooseSkillCtrl_ResultsForFormat: CredPrePayChooseSkillCtrl_ResultsForFormat$1,
    CredPrePayChooseSkillCtrl_SearchCatalog: CredPrePayChooseSkillCtrl_SearchCatalog$1,
    CredPaymentSvc_PaymentInfoError: CredPaymentSvc_PaymentInfoError$1,
    CredNav_AcceptHonorCode: CredNav_AcceptHonorCode$1,
    CredNav_Application: CredNav_Application$1,
    CredNav_ApplicationDescription: CredNav_ApplicationDescription$1,
    CredNav_Behavior1: CredNav_Behavior1$1,
    CredNav_Behavior2: CredNav_Behavior2$1,
    CredNav_Behavior3: CredNav_Behavior3$1,
    CredNav_Behaviors: CredNav_Behaviors$1,
    CredNav_Compare: CredNav_Compare$1,
    CredNav_CompareDescription: CredNav_CompareDescription$1,
    CredNav_Endorsers: CredNav_Endorsers$1,
    CredNav_EndorsersDescription: CredNav_EndorsersDescription$1,
    CredNav_FinalCheck: CredNav_FinalCheck$1,
    CredNav_heading: CredNav_heading$1,
    CredNav_IdentityVerification: CredNav_IdentityVerification$1,
    CredNav_PeerComparison1: CredNav_PeerComparison1$1,
    CredNav_PeerComparison2: CredNav_PeerComparison2$1,
    CredNav_PeerComparison3: CredNav_PeerComparison3$1,
    CredNav_PeerComparisonFormat: CredNav_PeerComparisonFormat$1,
    CredNav_Results: CredNav_Results$1,
    CredNav_ResultsDescription: CredNav_ResultsDescription$1,
    CredNav_ReviewApplication: CredNav_ReviewApplication$1,
    CredNav_SkillCertification: CredNav_SkillCertification$1,
    CredNav_SkillReview: CredNav_SkillReview$1,
    CredNav_Status: CredNav_Status$1,
    CredNav_StatusDescription: CredNav_StatusDescription$1,
    CredNav_Submit: CredNav_Submit$1,
    CredNav_SubmitWithCredits: CredNav_SubmitWithCredits$1,
    CredNav_WaitForCohort: CredNav_WaitForCohort$1,
    CredManageTagsCtrl_ManageArticlesVideos: CredManageTagsCtrl_ManageArticlesVideos$1,
    CredManageTagsCtrl_ManageInformal: CredManageTagsCtrl_ManageInformal$1,
    CredManageOutcomesCtrl_MaxErrorAccomplishmentFormat: CredManageOutcomesCtrl_MaxErrorAccomplishmentFormat$1,
    CredManageOutcomesCtrl_MaxErrorSkillFormat: CredManageOutcomesCtrl_MaxErrorSkillFormat$1,
    CredManageOutcomesCtrl_MaxErrorTitle: CredManageOutcomesCtrl_MaxErrorTitle$1,
    CredManageOutcomesCtrl_TitleAccomplishment: CredManageOutcomesCtrl_TitleAccomplishment$1,
    CredManageOutcomesCtrl_TitleAward: CredManageOutcomesCtrl_TitleAward$1,
    CredManageOutcomesCtrl_TitleCertificate: CredManageOutcomesCtrl_TitleCertificate$1,
    CredManageOutcomesCtrl_TitleDegree: CredManageOutcomesCtrl_TitleDegree$1,
    CredManageOutcomesCtrl_TitleSkill: CredManageOutcomesCtrl_TitleSkill$1,
    CredEvidenceForm_AddUrl: CredEvidenceForm_AddUrl$1,
    CredEvidenceForm_Complete: CredEvidenceForm_Complete$1,
    CredEvidenceForm_FileTypes: CredEvidenceForm_FileTypes$1,
    CredEvidenceForm_InsertEvidence: CredEvidenceForm_InsertEvidence$1,
    CredEvidenceForm_Processing: CredEvidenceForm_Processing$1,
    CredEvidenceForm_ProvideEvidence: CredEvidenceForm_ProvideEvidence$1,
    CredEvidenceForm_TitleOfEvidence: CredEvidenceForm_TitleOfEvidence$1,
    CredEvidenceForm_titleRequired: CredEvidenceForm_titleRequired$1,
    CredEvidenceForm_UnableToUpload: CredEvidenceForm_UnableToUpload$1,
    CredEvidenceForm_UploadFile: CredEvidenceForm_UploadFile$1,
    CredEvidenceForm_urlFileRequired: CredEvidenceForm_urlFileRequired$1,
    CredentialSvc_AddUserCredError: CredentialSvc_AddUserCredError$1,
    CredentialSvc_ApplyPaymentError: CredentialSvc_ApplyPaymentError$1,
    CredentialSvc_CohortError: CredentialSvc_CohortError$1,
    CredentialSvc_DeleteError: CredentialSvc_DeleteError$1,
    CredentialSvc_DeleteSuccess: CredentialSvc_DeleteSuccess$1,
    CredentialSvc_ErrorSavingChanges: CredentialSvc_ErrorSavingChanges$1,
    CredentialSvc_GetAllUserCredsError: CredentialSvc_GetAllUserCredsError$1,
    CredentialSvc_GetBehaviorsError: CredentialSvc_GetBehaviorsError$1,
    CredentialSvc_GetComparisonError: CredentialSvc_GetComparisonError$1,
    CredentialSvc_GetCredError: CredentialSvc_GetCredError$1,
    CredentialSvc_GetCredsError: CredentialSvc_GetCredsError$1,
    CredentialSvc_GetEndorsersError: CredentialSvc_GetEndorsersError$1,
    CredentialSvc_GetLinksError: CredentialSvc_GetLinksError$1,
    CredentialSvc_GetPaymentError: CredentialSvc_GetPaymentError$1,
    CredentialSvc_GetProfileError: CredentialSvc_GetProfileError$1,
    CredentialSvc_GetReviewStatusError: CredentialSvc_GetReviewStatusError$1,
    CredentialSvc_GetScholarshipStatusError: CredentialSvc_GetScholarshipStatusError$1,
    CredentialSvc_GetSocialLinksError: CredentialSvc_GetSocialLinksError$1,
    CredentialSvc_GetTagsError: CredentialSvc_GetTagsError$1,
    CredentialSvc_GetUserCredError: CredentialSvc_GetUserCredError$1,
    CredentialSvc_SetBehaviorsError: CredentialSvc_SetBehaviorsError$1,
    CredentialSvc_SetComparisonError: CredentialSvc_SetComparisonError$1,
    CredentialSvc_SetEndorsersError: CredentialSvc_SetEndorsersError$1,
    CredentialSvc_SetLinksError: CredentialSvc_SetLinksError$1,
    CredentialSvc_SetProfileError: CredentialSvc_SetProfileError$1,
    CredentialSvc_SetScholarshipCodeError: CredentialSvc_SetScholarshipCodeError$1,
    CredentialSvc_SetTagsError: CredentialSvc_SetTagsError$1,
    CredentialSvc_SubmitError: CredentialSvc_SubmitError$1,
    CredApplyOverviewCtrl_ApplicationDeleted: CredApplyOverviewCtrl_ApplicationDeleted$1,
    CredApplyOverviewCtrl_DeletePrompt: CredApplyOverviewCtrl_DeletePrompt$1,
    CredApplyOverviewCtrl_MinReqsMet: CredApplyOverviewCtrl_MinReqsMet$1,
    CredApplyOverviewCtrl_MinReqsNotMet: CredApplyOverviewCtrl_MinReqsNotMet$1,
    CredAcceptCtrl_AgreeLabel: CredAcceptCtrl_AgreeLabel$1,
    CredAcceptCtrl_AgreeValidationMessage: CredAcceptCtrl_AgreeValidationMessage$1,
    CredAcceptCtrl_Header: CredAcceptCtrl_Header$1,
    CredAcceptCtrl_HonorCodeDescription: CredAcceptCtrl_HonorCodeDescription$1,
    CredAcceptCtrl_Instructions: CredAcceptCtrl_Instructions$1,
    CredAcceptCtrl_Submit: CredAcceptCtrl_Submit$1,
    CredAcceptCtrl_Title: CredAcceptCtrl_Title$1,
    Cred_Application_Cancel: Cred_Application_Cancel$1,
    Cred_Application_Stay: Cred_Application_Stay$1,
    Cred_ApplicationStep_AcceptHonorCode: Cred_ApplicationStep_AcceptHonorCode$1,
    Cred_ApplicationStep_AcceptHonorCodeInstruction: Cred_ApplicationStep_AcceptHonorCodeInstruction$1,
    Cred_ApplicationStep_ComparePeers: Cred_ApplicationStep_ComparePeers$1,
    Cred_ApplicationStep_ComparePeersInstruction: Cred_ApplicationStep_ComparePeersInstruction$1,
    Cred_ApplicationStep_CompleteBehaviors: Cred_ApplicationStep_CompleteBehaviors$1,
    Cred_ApplicationStep_CompleteBehaviorsInstruction: Cred_ApplicationStep_CompleteBehaviorsInstruction$1,
    Cred_ApplicationStep_CompleteEndorsers: Cred_ApplicationStep_CompleteEndorsers$1,
    Cred_ApplicationStep_CompleteEndorsersInstruction: Cred_ApplicationStep_CompleteEndorsersInstruction$1,
    Cred_ApplicationStep_ConfirmUser: Cred_ApplicationStep_ConfirmUser$1,
    Cred_ApplicationStep_ConfirmUserInstruction: Cred_ApplicationStep_ConfirmUserInstruction$1,
    Cred_ApplicationStep_Pay: Cred_ApplicationStep_Pay$1,
    Cred_ApplicationStep_PayInstruction: Cred_ApplicationStep_PayInstruction$1,
    Cred_ApplicationStep_Results: Cred_ApplicationStep_Results$1,
    Cred_ApplicationStep_ResultsInstruction: Cred_ApplicationStep_ResultsInstruction$1,
    Cred_ApplicationStep_Review: Cred_ApplicationStep_Review$1,
    Cred_ApplicationStep_ReviewInstruction: Cred_ApplicationStep_ReviewInstruction$1,
    Cred_ApplicationStep_Submit: Cred_ApplicationStep_Submit$1,
    Cred_ApplicationStep_SubmitInstruction: Cred_ApplicationStep_SubmitInstruction$1,
    Cred_ApplicationStep_Unknown: Cred_ApplicationStep_Unknown$1,
    Cred_ApplicationStep_WaitForCohort: Cred_ApplicationStep_WaitForCohort$1,
    Cred_ApplicationStep_WaitForCohortInstruction: Cred_ApplicationStep_WaitForCohortInstruction$1,
    Cred_ApplicationStep_WaitForReviews: Cred_ApplicationStep_WaitForReviews$1,
    Cred_ApplicationStep_WaitForReviewsInstruction: Cred_ApplicationStep_WaitForReviewsInstruction$1,
    Cred_BehaviorDisplay_DetailTitle: Cred_BehaviorDisplay_DetailTitle$1,
    Cred_BehaviorDisplay_TitleTitle: Cred_BehaviorDisplay_TitleTitle$1,
    Cred_BehaviorReview_Accuracy: Cred_BehaviorReview_Accuracy$1,
    Cred_BehaviorReview_Accuracy_High: Cred_BehaviorReview_Accuracy_High$1,
    Cred_BehaviorReview_Accuracy_Low: Cred_BehaviorReview_Accuracy_Low$1,
    Cred_BehaviorReview_AreYouQualified: Cred_BehaviorReview_AreYouQualified$1,
    Cred_Behaviors_DemoHeader: Cred_Behaviors_DemoHeader$1,
    Cred_Certificate_CertificateTitle: Cred_Certificate_CertificateTitle$1,
    Cred_Certificate_CertifiedOn: Cred_Certificate_CertifiedOn$1,
    Cred_Certificate_ChiefLearningOfficer: Cred_Certificate_ChiefLearningOfficer$1,
    Cred_Certificate_Congratulations: Cred_Certificate_Congratulations$1,
    Cred_Certificate_DateIssued: Cred_Certificate_DateIssued$1,
    Cred_Certificate_DegreedCertifiesAria: Cred_Certificate_DegreedCertifiesAria$1,
    Cred_Certificate_DegreedCertifiesThat: Cred_Certificate_DegreedCertifiesThat$1,
    Cred_Certificate_Details: Cred_Certificate_Details$1,
    Cred_Certificate_Download: Cred_Certificate_Download$1,
    Cred_Certificate_DownloadWillBegin: Cred_Certificate_DownloadWillBegin$1,
    Cred_Certificate_EndorsedBy: Cred_Certificate_EndorsedBy$1,
    Cred_Certificate_Endorsers: Cred_Certificate_Endorsers$1,
    Cred_Certificate_ExecutiveChairman: Cred_Certificate_ExecutiveChairman$1,
    Cred_Certificate_In: Cred_Certificate_In$1,
    Cred_Certificate_Is: Cred_Certificate_Is$1,
    Cred_Certificate_Issuer: Cred_Certificate_Issuer$1,
    Cred_Certificate_IssuerUrl: Cred_Certificate_IssuerUrl$1,
    Cred_Certificate_Level: Cred_Certificate_Level$1,
    Cred_Certificate_LevelOutOfLevel: Cred_Certificate_LevelOutOfLevel$1,
    Cred_Certificate_LinkedInAuthority: Cred_Certificate_LinkedInAuthority$1,
    Cred_Certificate_LinkedInDate: Cred_Certificate_LinkedInDate$1,
    Cred_Certificate_LinkedInGo: Cred_Certificate_LinkedInGo$1,
    Cred_Certificate_LinkedInLicense: Cred_Certificate_LinkedInLicense$1,
    Cred_Certificate_LinkedInName: Cred_Certificate_LinkedInName$1,
    Cred_Certificate_LinkedInTitle: Cred_Certificate_LinkedInTitle$1,
    Cred_Certificate_LinkedInUrl: Cred_Certificate_LinkedInUrl$1,
    Cred_Certificate_Name: Cred_Certificate_Name$1,
    Cred_Certificate_NameLabel: Cred_Certificate_NameLabel$1,
    Cred_Certificate_RemovedRevoked: Cred_Certificate_RemovedRevoked$1,
    Cred_Certificate_ResumeDate: Cred_Certificate_ResumeDate$1,
    Cred_Certificate_ResumeName: Cred_Certificate_ResumeName$1,
    Cred_Certificate_ResumeTitle: Cred_Certificate_ResumeTitle$1,
    Cred_Certificate_SealAlt: Cred_Certificate_SealAlt$1,
    Cred_Certificate_SignaturesAlt: Cred_Certificate_SignaturesAlt$1,
    Cred_Certificate_SkillCertificate: Cred_Certificate_SkillCertificate$1,
    Cred_Certificate_SkillCertification: Cred_Certificate_SkillCertification$1,
    Cred_Certificate_SocialEmailBodyFormat: Cred_Certificate_SocialEmailBodyFormat$1,
    Cred_Certificate_SocialEmailSubjectFormat: Cred_Certificate_SocialEmailSubjectFormat$1,
    Cred_Certificate_SocialPostSummaryFormat: Cred_Certificate_SocialPostSummaryFormat$1,
    Cred_Certificate_SocialPostTitleFormat: Cred_Certificate_SocialPostTitleFormat$1,
    Cred_Certificate_TitleOf: Cred_Certificate_TitleOf$1,
    Cred_Certificate_Visibility: Cred_Certificate_Visibility$1,
    Cred_Certificate_VisibilityLabel: Cred_Certificate_VisibilityLabel$1,
    Cred_Comparison_Next: Cred_Comparison_Next$1,
    Cred_ComparisonNav_Comparison1: Cred_ComparisonNav_Comparison1$1,
    Cred_ComparisonNav_Comparison2: Cred_ComparisonNav_Comparison2$1,
    Cred_ComparisonNav_Comparison3: Cred_ComparisonNav_Comparison3$1,
    Cred_ComparisonNav_ComparisonFormat: Cred_ComparisonNav_ComparisonFormat$1,
    Cred_ComparisonPending_BeginNext: Cred_ComparisonPending_BeginNext$1,
    Cred_ComparisonPending_DueDateFormat: Cred_ComparisonPending_DueDateFormat$1,
    Cred_ComparisonPending_Heading: Cred_ComparisonPending_Heading$1,
    Cred_ComparisonPending_NoPendingReviews: Cred_ComparisonPending_NoPendingReviews$1,
    Cred_ComparisonPending_RemainingFormat: Cred_ComparisonPending_RemainingFormat$1,
    Cred_ComparisonPending_ReviewsRemainingFormat: Cred_ComparisonPending_ReviewsRemainingFormat$1,
    Cred_ConfirmSkipDialog_Body: Cred_ConfirmSkipDialog_Body$1,
    Cred_ConfirmSkipDialog_Button: Cred_ConfirmSkipDialog_Button$1,
    Cred_ConfirmSkipDialog_DeclinedBody: Cred_ConfirmSkipDialog_DeclinedBody$1,
    Cred_ConfirmSkipDialog_Heading: Cred_ConfirmSkipDialog_Heading$1,
    Cred_CredVerifySvc_SubmitError: Cred_CredVerifySvc_SubmitError$1,
    Cred_EndorseExp_InstructionsFormat: Cred_EndorseExp_InstructionsFormat$1,
    Cred_EndorseExp_Q_Communication: Cred_EndorseExp_Q_Communication$1,
    Cred_EndorseExp_Q_Communication_15: Cred_EndorseExp_Q_Communication_15$1,
    Cred_EndorseExp_Q_Communication_35: Cred_EndorseExp_Q_Communication_35$1,
    Cred_EndorseExp_Q_Communication_55: Cred_EndorseExp_Q_Communication_55$1,
    Cred_EndorseExp_Q_Communication_75: Cred_EndorseExp_Q_Communication_75$1,
    Cred_EndorseExp_Q_Knowledge: Cred_EndorseExp_Q_Knowledge$1,
    Cred_EndorseExp_Q_Knowledge_15: Cred_EndorseExp_Q_Knowledge_15$1,
    Cred_EndorseExp_Q_Knowledge_35: Cred_EndorseExp_Q_Knowledge_35$1,
    Cred_EndorseExp_Q_Knowledge_55: Cred_EndorseExp_Q_Knowledge_55$1,
    Cred_EndorseExp_Q_Knowledge_75: Cred_EndorseExp_Q_Knowledge_75$1,
    Cred_EndorseExp_Q_Planning: Cred_EndorseExp_Q_Planning$1,
    Cred_EndorseExp_Q_Planning_15: Cred_EndorseExp_Q_Planning_15$1,
    Cred_EndorseExp_Q_Planning_35: Cred_EndorseExp_Q_Planning_35$1,
    Cred_EndorseExp_Q_Planning_55: Cred_EndorseExp_Q_Planning_55$1,
    Cred_EndorseExp_Q_Planning_75: Cred_EndorseExp_Q_Planning_75$1,
    Cred_EndorseExp_Q_Practice: Cred_EndorseExp_Q_Practice$1,
    Cred_EndorseExp_Q_Practice_15: Cred_EndorseExp_Q_Practice_15$1,
    Cred_EndorseExp_Q_Practice_35: Cred_EndorseExp_Q_Practice_35$1,
    Cred_EndorseExp_Q_Practice_55: Cred_EndorseExp_Q_Practice_55$1,
    Cred_EndorseExp_Q_Practice_75: Cred_EndorseExp_Q_Practice_75$1,
    Cred_EndorseExp_Q_Responsibility: Cred_EndorseExp_Q_Responsibility$1,
    Cred_EndorseExp_Q_Responsibility_15: Cred_EndorseExp_Q_Responsibility_15$1,
    Cred_EndorseExp_Q_Responsibility_35: Cred_EndorseExp_Q_Responsibility_35$1,
    Cred_EndorseExp_Q_Responsibility_55: Cred_EndorseExp_Q_Responsibility_55$1,
    Cred_EndorseExp_Q_Responsibility_75: Cred_EndorseExp_Q_Responsibility_75$1,
    Cred_EndorseExp_Q_Teamwork: Cred_EndorseExp_Q_Teamwork$1,
    Cred_EndorseExp_Q_Teamwork_15: Cred_EndorseExp_Q_Teamwork_15$1,
    Cred_EndorseExp_Q_Teamwork_35: Cred_EndorseExp_Q_Teamwork_35$1,
    Cred_EndorseExp_Q_Teamwork_55: Cred_EndorseExp_Q_Teamwork_55$1,
    Cred_EndorseExp_Q_Teamwork_75: Cred_EndorseExp_Q_Teamwork_75$1,
    Cred_EndorsementAccept_Accept: Cred_EndorsementAccept_Accept$1,
    Cred_EndorsementAccept_HonorCode1: Cred_EndorsementAccept_HonorCode1$1,
    Cred_EndorsementAccept_HonorCode2: Cred_EndorsementAccept_HonorCode2$1,
    Cred_EndorsementAccept_HonorCode3: Cred_EndorsementAccept_HonorCode3$1,
    Cred_EndorsementAccept_HonorCodeTitle: Cred_EndorsementAccept_HonorCodeTitle$1,
    Cred_EndorsementAccept_Instructions: Cred_EndorsementAccept_Instructions$1,
    Cred_EndorsementAccount_AlreadyLoggedIn: Cred_EndorsementAccount_AlreadyLoggedIn$1,
    Cred_EndorsementAccount_Create: Cred_EndorsementAccount_Create$1,
    Cred_EndorsementAccount_CreateAndNext: Cred_EndorsementAccount_CreateAndNext$1,
    Cred_EndorsementAccount_EmailLabel: Cred_EndorsementAccount_EmailLabel$1,
    Cred_EndorsementAccount_Header: Cred_EndorsementAccount_Header$1,
    Cred_EndorsementAccount_Instructions: Cred_EndorsementAccount_Instructions$1,
    Cred_EndorsementAccount_PasswordLabel: Cred_EndorsementAccount_PasswordLabel$1,
    Cred_EndorsementAccount_Skip: Cred_EndorsementAccount_Skip$1,
    Cred_EndorsementAccount_SkipInstructions: Cred_EndorsementAccount_SkipInstructions$1,
    Cred_EndorsementBehavior_Header: Cred_EndorsementBehavior_Header$1,
    Cred_EndorsementBehavior_Instructions: Cred_EndorsementBehavior_Instructions$1,
    Cred_EndorsementEndorser_EmailLabel: Cred_EndorsementEndorser_EmailLabel$1,
    Cred_EndorsementEndorser_EmailPlaceholder: Cred_EndorsementEndorser_EmailPlaceholder$1,
    Cred_EndorsementEndorser_FirstNameLabel: Cred_EndorsementEndorser_FirstNameLabel$1,
    Cred_EndorsementEndorser_Instructions: Cred_EndorsementEndorser_Instructions$1,
    Cred_EndorsementEndorser_LastNameLabel: Cred_EndorsementEndorser_LastNameLabel$1,
    Cred_EndorsementEndorser_PhoneLabel: Cred_EndorsementEndorser_PhoneLabel$1,
    Cred_EndorsementEndorser_PhonePlaceholder: Cred_EndorsementEndorser_PhonePlaceholder$1,
    Cred_EndorsementEndorser_PositionLabel: Cred_EndorsementEndorser_PositionLabel$1,
    Cred_EndorsementEndorser_PositionPlaceholder: Cred_EndorsementEndorser_PositionPlaceholder$1,
    Cred_EndorsementEndorser_RelationshipLabel: Cred_EndorsementEndorser_RelationshipLabel$1,
    Cred_EndorsementEndorser_RelationshipPlaceholder: Cred_EndorsementEndorser_RelationshipPlaceholder$1,
    Cred_EndorsementReasonForm_Header: Cred_EndorsementReasonForm_Header$1,
    Cred_EndorsementReasonForm_ReasonLabel: Cred_EndorsementReasonForm_ReasonLabel$1,
    Cred_EndorsementReasonForm_ReasonPlaceholder: Cred_EndorsementReasonForm_ReasonPlaceholder$1,
    Cred_EndorsementStart_Accept: Cred_EndorsementStart_Accept$1,
    Cred_EndorsementStart_Decline: Cred_EndorsementStart_Decline$1,
    Cred_EndorsementStart_Declined: Cred_EndorsementStart_Declined$1,
    Cred_EndorsementStart_DeclineReason: Cred_EndorsementStart_DeclineReason$1,
    Cred_EndorsementStart_DegreedDescription: Cred_EndorsementStart_DegreedDescription$1,
    Cred_EndorsementStart_Instructions: Cred_EndorsementStart_Instructions$1,
    Cred_EndorsementStart_RequestFrom: Cred_EndorsementStart_RequestFrom$1,
    Cred_EndorsementStart_WhatIsDegreed: Cred_EndorsementStart_WhatIsDegreed$1,
    Cred_EndorsementSubmit_CompletedDetails: Cred_EndorsementSubmit_CompletedDetails$1,
    Cred_EndorsementSubmit_CompletedTitle: Cred_EndorsementSubmit_CompletedTitle$1,
    Cred_EndorsementSubmit_Exit: Cred_EndorsementSubmit_Exit$1,
    Cred_EndorsementSubmit_Header: Cred_EndorsementSubmit_Header$1,
    Cred_EndorsementSubmit_Instructions: Cred_EndorsementSubmit_Instructions$1,
    Cred_EndorsementSubmit_Instructions2: Cred_EndorsementSubmit_Instructions2$1,
    Cred_EndorseNav_AcceptDescription: Cred_EndorseNav_AcceptDescription$1,
    Cred_EndorseNav_AccountDescription: Cred_EndorseNav_AccountDescription$1,
    Cred_EndorseNav_ConfirmContactInfo: Cred_EndorseNav_ConfirmContactInfo$1,
    Cred_EndorseNav_CreateDegreedAcct: Cred_EndorseNav_CreateDegreedAcct$1,
    Cred_EndorseNav_EndorserDescription: Cred_EndorseNav_EndorserDescription$1,
    Cred_EndorseNav_Heading: Cred_EndorseNav_Heading$1,
    Cred_EndorseNav_ReviewDescription: Cred_EndorseNav_ReviewDescription$1,
    Cred_EndorseNav_ReviewExperience: Cred_EndorseNav_ReviewExperience$1,
    Cred_EndorseNav_ReviewExperienceDescription: Cred_EndorseNav_ReviewExperienceDescription$1,
    Cred_EndorseNav_ReviewHonorCode: Cred_EndorseNav_ReviewHonorCode$1,
    Cred_EndorseNav_ReviewSkill1: Cred_EndorseNav_ReviewSkill1$1,
    Cred_EndorseNav_ReviewSkill2: Cred_EndorseNav_ReviewSkill2$1,
    Cred_EndorseNav_ReviewSkill3: Cred_EndorseNav_ReviewSkill3$1,
    Cred_EndorseNav_ReviewSkills: Cred_EndorseNav_ReviewSkills$1,
    Cred_EndorseNav_Start: Cred_EndorseNav_Start$1,
    Cred_EndorseNav_StartDescription: Cred_EndorseNav_StartDescription$1,
    Cred_EndorseNav_SubmitDescription: Cred_EndorseNav_SubmitDescription$1,
    Cred_EndorserDemo_ButtonLabel: Cred_EndorserDemo_ButtonLabel$1,
    Cred_EndorserDemo_Heading: Cred_EndorserDemo_Heading$1,
    Cred_EndorserDemo_ImageAlt: Cred_EndorserDemo_ImageAlt$1,
    Cred_EndorserDemo_Step1_Content: Cred_EndorserDemo_Step1_Content$1,
    Cred_EndorserDemo_Step1_Title: Cred_EndorserDemo_Step1_Title$1,
    Cred_EndorserDemo_Step2_Content: Cred_EndorserDemo_Step2_Content$1,
    Cred_EndorserDemo_Step2_Title: Cred_EndorserDemo_Step2_Title$1,
    Cred_EndorserDemo_Step3_Content: Cred_EndorserDemo_Step3_Content$1,
    Cred_EndorserDemo_Step3_Title: Cred_EndorserDemo_Step3_Title$1,
    Cred_EndorserDemo_ThanksGotIt: Cred_EndorserDemo_ThanksGotIt$1,
    Cred_EndorserExpired_Explanation: Cred_EndorserExpired_Explanation$1,
    Cred_EndorserExpired_Heading: Cred_EndorserExpired_Heading$1,
    Cred_EndorserResend_Header: Cred_EndorserResend_Header$1,
    Cred_Evidence_RemoveHeader: Cred_Evidence_RemoveHeader$1,
    Cred_Evidence_RemoveSummary: Cred_Evidence_RemoveSummary$1,
    Cred_EvidenceDisplay_ExampleHeading: Cred_EvidenceDisplay_ExampleHeading$1,
    Cred_EvidenceDisplay_ProcessHeading: Cred_EvidenceDisplay_ProcessHeading$1,
    Cred_ExpertCandidate_AttrAutonomy: Cred_ExpertCandidate_AttrAutonomy$1,
    Cred_ExpertCandidate_Attributes: Cred_ExpertCandidate_Attributes$1,
    Cred_ExpertCandidate_AttrKnowledge: Cred_ExpertCandidate_AttrKnowledge$1,
    Cred_ExpertCandidate_AttrPlanning: Cred_ExpertCandidate_AttrPlanning$1,
    Cred_ExpertCandidate_AttrSkills: Cred_ExpertCandidate_AttrSkills$1,
    Cred_ExpertCandidate_AttrTeaching: Cred_ExpertCandidate_AttrTeaching$1,
    Cred_ExpertCandidate_AttrTeamwork: Cred_ExpertCandidate_AttrTeamwork$1,
    Cred_ExpertCandidate_CommentsLabel: Cred_ExpertCandidate_CommentsLabel$1,
    Cred_ExpertCandidate_CommentsPlaceholder: Cred_ExpertCandidate_CommentsPlaceholder$1,
    Cred_ExpertCandidate_Heading: Cred_ExpertCandidate_Heading$1,
    Cred_ExpertCandidate_LevelHigh: Cred_ExpertCandidate_LevelHigh$1,
    Cred_ExpertCandidate_LevelLabel: Cred_ExpertCandidate_LevelLabel$1,
    Cred_ExpertCandidate_LevelLow: Cred_ExpertCandidate_LevelLow$1,
    Cred_ExpertCandidate_NA: Cred_ExpertCandidate_NA$1,
    Cred_ExpertCandidate_SaveLevel: Cred_ExpertCandidate_SaveLevel$1,
    Cred_ExpertPending_BeginNextReview: Cred_ExpertPending_BeginNextReview$1,
    Cred_ExpertPending_Heading: Cred_ExpertPending_Heading$1,
    Cred_ExpertPending_NoPendingReviews: Cred_ExpertPending_NoPendingReviews$1,
    Cred_ExpertPending_ReviewsRemainingFormat: Cred_ExpertPending_ReviewsRemainingFormat$1,
    Cred_InstructionVideo: Cred_InstructionVideo$1,
    Cred_Intent_CareerChange: Cred_Intent_CareerChange$1,
    Cred_Intent_ImproveSkills: Cred_Intent_ImproveSkills$1,
    Cred_Intent_legend: Cred_Intent_legend$1,
    Cred_Intent_MeasureMe: Cred_Intent_MeasureMe$1,
    Cred_Intent_Other: Cred_Intent_Other$1,
    Cred_Intent_ShowSkills: Cred_Intent_ShowSkills$1,
    Cred_Intent_WorkDomain: Cred_Intent_WorkDomain$1,
    Cred_LevelBreakdown_Autonomy_1: Cred_LevelBreakdown_Autonomy_1$1,
    Cred_LevelBreakdown_Autonomy_2: Cred_LevelBreakdown_Autonomy_2$1,
    Cred_LevelBreakdown_Autonomy_3: Cred_LevelBreakdown_Autonomy_3$1,
    Cred_LevelBreakdown_Autonomy_4: Cred_LevelBreakdown_Autonomy_4$1,
    Cred_LevelBreakdown_Autonomy_5: Cred_LevelBreakdown_Autonomy_5$1,
    Cred_LevelBreakdown_Autonomy_6: Cred_LevelBreakdown_Autonomy_6$1,
    Cred_LevelBreakdown_Autonomy_7: Cred_LevelBreakdown_Autonomy_7$1,
    Cred_LevelBreakdown_Autonomy_8: Cred_LevelBreakdown_Autonomy_8$1,
    Cred_LevelBreakdown_Autonomy_Scale6_1: Cred_LevelBreakdown_Autonomy_Scale6_1$1,
    Cred_LevelBreakdown_Autonomy_Scale6_2: Cred_LevelBreakdown_Autonomy_Scale6_2$1,
    Cred_LevelBreakdown_Autonomy_Scale6_3: Cred_LevelBreakdown_Autonomy_Scale6_3$1,
    Cred_LevelBreakdown_Autonomy_Scale6_4: Cred_LevelBreakdown_Autonomy_Scale6_4$1,
    Cred_LevelBreakdown_Autonomy_Scale6_5: Cred_LevelBreakdown_Autonomy_Scale6_5$1,
    Cred_LevelBreakdown_Autonomy_Scale6_6: Cred_LevelBreakdown_Autonomy_Scale6_6$1,
    Cred_LevelBreakdown_Autonomy_Scale8_1: Cred_LevelBreakdown_Autonomy_Scale8_1$1,
    Cred_LevelBreakdown_Autonomy_Scale8_2: Cred_LevelBreakdown_Autonomy_Scale8_2$1,
    Cred_LevelBreakdown_Autonomy_Scale8_3: Cred_LevelBreakdown_Autonomy_Scale8_3$1,
    Cred_LevelBreakdown_Autonomy_Scale8_4: Cred_LevelBreakdown_Autonomy_Scale8_4$1,
    Cred_LevelBreakdown_Autonomy_Scale8_5: Cred_LevelBreakdown_Autonomy_Scale8_5$1,
    Cred_LevelBreakdown_Autonomy_Scale8_6: Cred_LevelBreakdown_Autonomy_Scale8_6$1,
    Cred_LevelBreakdown_Autonomy_Scale8_7: Cred_LevelBreakdown_Autonomy_Scale8_7$1,
    Cred_LevelBreakdown_Autonomy_Scale8_8: Cred_LevelBreakdown_Autonomy_Scale8_8$1,
    Cred_LevelBreakdown_Description: Cred_LevelBreakdown_Description$1,
    Cred_LevelBreakdown_Knowledge_1: Cred_LevelBreakdown_Knowledge_1$1,
    Cred_LevelBreakdown_Knowledge_2: Cred_LevelBreakdown_Knowledge_2$1,
    Cred_LevelBreakdown_Knowledge_3: Cred_LevelBreakdown_Knowledge_3$1,
    Cred_LevelBreakdown_Knowledge_4: Cred_LevelBreakdown_Knowledge_4$1,
    Cred_LevelBreakdown_Knowledge_5: Cred_LevelBreakdown_Knowledge_5$1,
    Cred_LevelBreakdown_Knowledge_6: Cred_LevelBreakdown_Knowledge_6$1,
    Cred_LevelBreakdown_Knowledge_7: Cred_LevelBreakdown_Knowledge_7$1,
    Cred_LevelBreakdown_Knowledge_8: Cred_LevelBreakdown_Knowledge_8$1,
    Cred_LevelBreakdown_Knowledge_Scale6_1: Cred_LevelBreakdown_Knowledge_Scale6_1$1,
    Cred_LevelBreakdown_Knowledge_Scale6_2: Cred_LevelBreakdown_Knowledge_Scale6_2$1,
    Cred_LevelBreakdown_Knowledge_Scale6_3: Cred_LevelBreakdown_Knowledge_Scale6_3$1,
    Cred_LevelBreakdown_Knowledge_Scale6_4: Cred_LevelBreakdown_Knowledge_Scale6_4$1,
    Cred_LevelBreakdown_Knowledge_Scale6_5: Cred_LevelBreakdown_Knowledge_Scale6_5$1,
    Cred_LevelBreakdown_Knowledge_Scale6_6: Cred_LevelBreakdown_Knowledge_Scale6_6$1,
    Cred_LevelBreakdown_Knowledge_Scale8_1: Cred_LevelBreakdown_Knowledge_Scale8_1$1,
    Cred_LevelBreakdown_Knowledge_Scale8_2: Cred_LevelBreakdown_Knowledge_Scale8_2$1,
    Cred_LevelBreakdown_Knowledge_Scale8_3: Cred_LevelBreakdown_Knowledge_Scale8_3$1,
    Cred_LevelBreakdown_Knowledge_Scale8_4: Cred_LevelBreakdown_Knowledge_Scale8_4$1,
    Cred_LevelBreakdown_Knowledge_Scale8_5: Cred_LevelBreakdown_Knowledge_Scale8_5$1,
    Cred_LevelBreakdown_Knowledge_Scale8_6: Cred_LevelBreakdown_Knowledge_Scale8_6$1,
    Cred_LevelBreakdown_Knowledge_Scale8_7: Cred_LevelBreakdown_Knowledge_Scale8_7$1,
    Cred_LevelBreakdown_Knowledge_Scale8_8: Cred_LevelBreakdown_Knowledge_Scale8_8$1,
    Cred_LevelBreakdown_Planning_1: Cred_LevelBreakdown_Planning_1$1,
    Cred_LevelBreakdown_Planning_2: Cred_LevelBreakdown_Planning_2$1,
    Cred_LevelBreakdown_Planning_3: Cred_LevelBreakdown_Planning_3$1,
    Cred_LevelBreakdown_Planning_4: Cred_LevelBreakdown_Planning_4$1,
    Cred_LevelBreakdown_Planning_5: Cred_LevelBreakdown_Planning_5$1,
    Cred_LevelBreakdown_Planning_6: Cred_LevelBreakdown_Planning_6$1,
    Cred_LevelBreakdown_Planning_7: Cred_LevelBreakdown_Planning_7$1,
    Cred_LevelBreakdown_Planning_8: Cred_LevelBreakdown_Planning_8$1,
    Cred_LevelBreakdown_Planning_Scale6_1: Cred_LevelBreakdown_Planning_Scale6_1$1,
    Cred_LevelBreakdown_Planning_Scale6_2: Cred_LevelBreakdown_Planning_Scale6_2$1,
    Cred_LevelBreakdown_Planning_Scale6_3: Cred_LevelBreakdown_Planning_Scale6_3$1,
    Cred_LevelBreakdown_Planning_Scale6_4: Cred_LevelBreakdown_Planning_Scale6_4$1,
    Cred_LevelBreakdown_Planning_Scale6_5: Cred_LevelBreakdown_Planning_Scale6_5$1,
    Cred_LevelBreakdown_Planning_Scale6_6: Cred_LevelBreakdown_Planning_Scale6_6$1,
    Cred_LevelBreakdown_Planning_Scale8_1: Cred_LevelBreakdown_Planning_Scale8_1$1,
    Cred_LevelBreakdown_Planning_Scale8_2: Cred_LevelBreakdown_Planning_Scale8_2$1,
    Cred_LevelBreakdown_Planning_Scale8_3: Cred_LevelBreakdown_Planning_Scale8_3$1,
    Cred_LevelBreakdown_Planning_Scale8_4: Cred_LevelBreakdown_Planning_Scale8_4$1,
    Cred_LevelBreakdown_Planning_Scale8_5: Cred_LevelBreakdown_Planning_Scale8_5$1,
    Cred_LevelBreakdown_Planning_Scale8_6: Cred_LevelBreakdown_Planning_Scale8_6$1,
    Cred_LevelBreakdown_Planning_Scale8_7: Cred_LevelBreakdown_Planning_Scale8_7$1,
    Cred_LevelBreakdown_Planning_Scale8_8: Cred_LevelBreakdown_Planning_Scale8_8$1,
    Cred_LevelBreakdown_Skills_1: Cred_LevelBreakdown_Skills_1$1,
    Cred_LevelBreakdown_Skills_2: Cred_LevelBreakdown_Skills_2$1,
    Cred_LevelBreakdown_Skills_3: Cred_LevelBreakdown_Skills_3$1,
    Cred_LevelBreakdown_Skills_4: Cred_LevelBreakdown_Skills_4$1,
    Cred_LevelBreakdown_Skills_5: Cred_LevelBreakdown_Skills_5$1,
    Cred_LevelBreakdown_Skills_6: Cred_LevelBreakdown_Skills_6$1,
    Cred_LevelBreakdown_Skills_7: Cred_LevelBreakdown_Skills_7$1,
    Cred_LevelBreakdown_Skills_8: Cred_LevelBreakdown_Skills_8$1,
    Cred_LevelBreakdown_Skills_Scale6_1: Cred_LevelBreakdown_Skills_Scale6_1$1,
    Cred_LevelBreakdown_Skills_Scale6_2: Cred_LevelBreakdown_Skills_Scale6_2$1,
    Cred_LevelBreakdown_Skills_Scale6_3: Cred_LevelBreakdown_Skills_Scale6_3$1,
    Cred_LevelBreakdown_Skills_Scale6_4: Cred_LevelBreakdown_Skills_Scale6_4$1,
    Cred_LevelBreakdown_Skills_Scale6_5: Cred_LevelBreakdown_Skills_Scale6_5$1,
    Cred_LevelBreakdown_Skills_Scale6_6: Cred_LevelBreakdown_Skills_Scale6_6$1,
    Cred_LevelBreakdown_Skills_Scale8_1: Cred_LevelBreakdown_Skills_Scale8_1$1,
    Cred_LevelBreakdown_Skills_Scale8_2: Cred_LevelBreakdown_Skills_Scale8_2$1,
    Cred_LevelBreakdown_Skills_Scale8_3: Cred_LevelBreakdown_Skills_Scale8_3$1,
    Cred_LevelBreakdown_Skills_Scale8_4: Cred_LevelBreakdown_Skills_Scale8_4$1,
    Cred_LevelBreakdown_Skills_Scale8_5: Cred_LevelBreakdown_Skills_Scale8_5$1,
    Cred_LevelBreakdown_Skills_Scale8_6: Cred_LevelBreakdown_Skills_Scale8_6$1,
    Cred_LevelBreakdown_Skills_Scale8_7: Cred_LevelBreakdown_Skills_Scale8_7$1,
    Cred_LevelBreakdown_Skills_Scale8_8: Cred_LevelBreakdown_Skills_Scale8_8$1,
    Cred_LevelBreakdown_Teaching_1: Cred_LevelBreakdown_Teaching_1$1,
    Cred_LevelBreakdown_Teaching_2: Cred_LevelBreakdown_Teaching_2$1,
    Cred_LevelBreakdown_Teaching_3: Cred_LevelBreakdown_Teaching_3$1,
    Cred_LevelBreakdown_Teaching_4: Cred_LevelBreakdown_Teaching_4$1,
    Cred_LevelBreakdown_Teaching_5: Cred_LevelBreakdown_Teaching_5$1,
    Cred_LevelBreakdown_Teaching_6: Cred_LevelBreakdown_Teaching_6$1,
    Cred_LevelBreakdown_Teaching_7: Cred_LevelBreakdown_Teaching_7$1,
    Cred_LevelBreakdown_Teaching_8: Cred_LevelBreakdown_Teaching_8$1,
    Cred_LevelBreakdown_Teaching_Scale6_1: Cred_LevelBreakdown_Teaching_Scale6_1$1,
    Cred_LevelBreakdown_Teaching_Scale6_2: Cred_LevelBreakdown_Teaching_Scale6_2$1,
    Cred_LevelBreakdown_Teaching_Scale6_3: Cred_LevelBreakdown_Teaching_Scale6_3$1,
    Cred_LevelBreakdown_Teaching_Scale6_4: Cred_LevelBreakdown_Teaching_Scale6_4$1,
    Cred_LevelBreakdown_Teaching_Scale6_5: Cred_LevelBreakdown_Teaching_Scale6_5$1,
    Cred_LevelBreakdown_Teaching_Scale6_6: Cred_LevelBreakdown_Teaching_Scale6_6$1,
    Cred_LevelBreakdown_Teaching_Scale8_1: Cred_LevelBreakdown_Teaching_Scale8_1$1,
    Cred_LevelBreakdown_Teaching_Scale8_2: Cred_LevelBreakdown_Teaching_Scale8_2$1,
    Cred_LevelBreakdown_Teaching_Scale8_3: Cred_LevelBreakdown_Teaching_Scale8_3$1,
    Cred_LevelBreakdown_Teaching_Scale8_4: Cred_LevelBreakdown_Teaching_Scale8_4$1,
    Cred_LevelBreakdown_Teaching_Scale8_5: Cred_LevelBreakdown_Teaching_Scale8_5$1,
    Cred_LevelBreakdown_Teaching_Scale8_6: Cred_LevelBreakdown_Teaching_Scale8_6$1,
    Cred_LevelBreakdown_Teaching_Scale8_7: Cred_LevelBreakdown_Teaching_Scale8_7$1,
    Cred_LevelBreakdown_Teaching_Scale8_8: Cred_LevelBreakdown_Teaching_Scale8_8$1,
    Cred_LevelBreakdown_Teamwork_1: Cred_LevelBreakdown_Teamwork_1$1,
    Cred_LevelBreakdown_Teamwork_2: Cred_LevelBreakdown_Teamwork_2$1,
    Cred_LevelBreakdown_Teamwork_3: Cred_LevelBreakdown_Teamwork_3$1,
    Cred_LevelBreakdown_Teamwork_4: Cred_LevelBreakdown_Teamwork_4$1,
    Cred_LevelBreakdown_Teamwork_5: Cred_LevelBreakdown_Teamwork_5$1,
    Cred_LevelBreakdown_Teamwork_6: Cred_LevelBreakdown_Teamwork_6$1,
    Cred_LevelBreakdown_Teamwork_7: Cred_LevelBreakdown_Teamwork_7$1,
    Cred_LevelBreakdown_Teamwork_8: Cred_LevelBreakdown_Teamwork_8$1,
    Cred_LevelBreakdown_Teamwork_Scale6_1: Cred_LevelBreakdown_Teamwork_Scale6_1$1,
    Cred_LevelBreakdown_Teamwork_Scale6_2: Cred_LevelBreakdown_Teamwork_Scale6_2$1,
    Cred_LevelBreakdown_Teamwork_Scale6_3: Cred_LevelBreakdown_Teamwork_Scale6_3$1,
    Cred_LevelBreakdown_Teamwork_Scale6_4: Cred_LevelBreakdown_Teamwork_Scale6_4$1,
    Cred_LevelBreakdown_Teamwork_Scale6_5: Cred_LevelBreakdown_Teamwork_Scale6_5$1,
    Cred_LevelBreakdown_Teamwork_Scale6_6: Cred_LevelBreakdown_Teamwork_Scale6_6$1,
    Cred_LevelBreakdown_Teamwork_Scale8_1: Cred_LevelBreakdown_Teamwork_Scale8_1$1,
    Cred_LevelBreakdown_Teamwork_Scale8_2: Cred_LevelBreakdown_Teamwork_Scale8_2$1,
    Cred_LevelBreakdown_Teamwork_Scale8_3: Cred_LevelBreakdown_Teamwork_Scale8_3$1,
    Cred_LevelBreakdown_Teamwork_Scale8_4: Cred_LevelBreakdown_Teamwork_Scale8_4$1,
    Cred_LevelBreakdown_Teamwork_Scale8_5: Cred_LevelBreakdown_Teamwork_Scale8_5$1,
    Cred_LevelBreakdown_Teamwork_Scale8_6: Cred_LevelBreakdown_Teamwork_Scale8_6$1,
    Cred_LevelBreakdown_Teamwork_Scale8_7: Cred_LevelBreakdown_Teamwork_Scale8_7$1,
    Cred_LevelBreakdown_Teamwork_Scale8_8: Cred_LevelBreakdown_Teamwork_Scale8_8$1,
    Cred_levelDescription_ViewAll: Cred_levelDescription_ViewAll$1,
    Cred_levelName1: Cred_levelName1$1,
    Cred_levelName2: Cred_levelName2$1,
    Cred_levelName3: Cred_levelName3$1,
    Cred_levelName4: Cred_levelName4$1,
    Cred_levelName5: Cred_levelName5$1,
    Cred_levelName6: Cred_levelName6$1,
    Cred_levelName7: Cred_levelName7$1,
    Cred_levelName8: Cred_levelName8$1,
    Cred_levelShortTitle: Cred_levelShortTitle$1,
    Cred_levelSummary_Breakdown: Cred_levelSummary_Breakdown$1,
    Cred_levelSummary1: Cred_levelSummary1$1,
    Cred_levelSummary2: Cred_levelSummary2$1,
    Cred_levelSummary3: Cred_levelSummary3$1,
    Cred_levelSummary4: Cred_levelSummary4$1,
    Cred_levelSummary5: Cred_levelSummary5$1,
    Cred_levelSummary6: Cred_levelSummary6$1,
    Cred_levelSummary7: Cred_levelSummary7$1,
    Cred_levelSummary8: Cred_levelSummary8$1,
    Cred_levelTitle: Cred_levelTitle$1,
    Cred_NextStep: Cred_NextStep$1,
    Cred_NoComparison_Header: Cred_NoComparison_Header$1,
    Cred_NoComparison_Instructions: Cred_NoComparison_Instructions$1,
    Cred_NoComparison_NoReviewsNeeded: Cred_NoComparison_NoReviewsNeeded$1,
    Cred_Overview_CompletePeerReviews: Cred_Overview_CompletePeerReviews$1,
    Cred_Overview_EditApplication: Cred_Overview_EditApplication$1,
    Cred_Overview_EditApplicationInstructions: Cred_Overview_EditApplicationInstructions$1,
    Cred_Overview_Instructions: Cred_Overview_Instructions$1,
    Cred_Overview_NextActions: Cred_Overview_NextActions$1,
    Cred_Overview_NextDeadline: Cred_Overview_NextDeadline$1,
    Cred_Overview_OptionalActions: Cred_Overview_OptionalActions$1,
    Cred_Overview_SubmitApplication: Cred_Overview_SubmitApplication$1,
    Cred_Overview_SubmitApplicationInstructions: Cred_Overview_SubmitApplicationInstructions$1,
    Cred_Overview_Title: Cred_Overview_Title$1,
    Cred_PaymentNotSupported: Cred_PaymentNotSupported$1,
    Cred_SkillBehavior_Original: Cred_SkillBehavior_Original$1,
    Cred_SkillBehavior_Translated: Cred_SkillBehavior_Translated$1,
    Cred_Status_AddNewEndorser: Cred_Status_AddNewEndorser$1,
    Cred_Status_ApplyCode: Cred_Status_ApplyCode$1,
    Cred_Status_CheckoutBtn: Cred_Status_CheckoutBtn$1,
    Cred_Status_DateCompletedFormat: Cred_Status_DateCompletedFormat$1,
    Cred_Status_DateDeclinedFormat: Cred_Status_DateDeclinedFormat$1,
    Cred_Status_DegreedReviewed: Cred_Status_DegreedReviewed$1,
    Cred_Status_DegreedReviewedDescription: Cred_Status_DegreedReviewedDescription$1,
    Cred_Status_DegreedReviewedDescriptionCompleted: Cred_Status_DegreedReviewedDescriptionCompleted$1,
    Cred_Status_EditInfo: Cred_Status_EditInfo$1,
    Cred_Status_EndorserAdded: Cred_Status_EndorserAdded$1,
    Cred_Status_EndorserHasntResponded: Cred_Status_EndorserHasntResponded$1,
    Cred_Status_Endorsers_Desc: Cred_Status_Endorsers_Desc$1,
    Cred_Status_EndorsersHeading: Cred_Status_EndorsersHeading$1,
    Cred_Status_EndorserUpdated: Cred_Status_EndorserUpdated$1,
    Cred_Status_Header: Cred_Status_Header$1,
    Cred_Status_Instructions1: Cred_Status_Instructions1$1,
    Cred_Status_Instructions2: Cred_Status_Instructions2$1,
    Cred_Status_InvitationSent: Cred_Status_InvitationSent$1,
    Cred_Status_PaymentDescription: Cred_Status_PaymentDescription$1,
    Cred_Status_PaymentHeading: Cred_Status_PaymentHeading$1,
    Cred_Status_PeerReviewed: Cred_Status_PeerReviewed$1,
    Cred_Status_PeerReviewedDescription: Cred_Status_PeerReviewedDescription$1,
    Cred_Status_PeerReviewedDescriptionCompleted: Cred_Status_PeerReviewedDescriptionCompleted$1,
    Cred_Status_Resend: Cred_Status_Resend$1,
    Cred_Status_ReviewsHeading: Cred_Status_ReviewsHeading$1,
    Cred_Status_ScAwarded: Cred_Status_ScAwarded$1,
    Cred_Status_ScAwardedDescription: Cred_Status_ScAwardedDescription$1,
    Cred_Status_ScNotAwarded: Cred_Status_ScNotAwarded$1,
    Cred_Status_ScNotAwardedDescription: Cred_Status_ScNotAwardedDescription$1,
    Cred_Status_ScPending: Cred_Status_ScPending$1,
    Cred_Status_ScPendingDescription: Cred_Status_ScPendingDescription$1,
    Cred_Status_SkipEndorser: Cred_Status_SkipEndorser$1,
    Cred_Status_WaitingOnEndorser: Cred_Status_WaitingOnEndorser$1,
    Cred_Submit_AppliedCodeText: Cred_Submit_AppliedCodeText$1,
    Cred_Submit_ApplyCodeText: Cred_Submit_ApplyCodeText$1,
    Cred_Submit_Header: Cred_Submit_Header$1,
    Cred_Submit_HeaderWithCredits: Cred_Submit_HeaderWithCredits$1,
    Cred_Submit_IAgreeGenuine: Cred_Submit_IAgreeGenuine$1,
    Cred_Submit_PaymentBillingInfo: Cred_Submit_PaymentBillingInfo$1,
    Cred_Submit_PaymentCard: Cred_Submit_PaymentCard$1,
    Cred_Submit_PaymentCardValidation: Cred_Submit_PaymentCardValidation$1,
    Cred_Submit_PaymentChoosePayment: Cred_Submit_PaymentChoosePayment$1,
    Cred_Submit_PaymentConfirm: Cred_Submit_PaymentConfirm$1,
    Cred_Submit_PaymentCurrency: Cred_Submit_PaymentCurrency$1,
    Cred_Submit_PaymentCvv: Cred_Submit_PaymentCvv$1,
    Cred_Submit_PaymentError: Cred_Submit_PaymentError$1,
    Cred_Submit_PaymentExp: Cred_Submit_PaymentExp$1,
    Cred_Submit_PaymentExpPlaceholder: Cred_Submit_PaymentExpPlaceholder$1,
    Cred_Submit_PaymentExpValidation: Cred_Submit_PaymentExpValidation$1,
    Cred_Submit_PaymentFirstName: Cred_Submit_PaymentFirstName$1,
    Cred_Submit_PaymentFirstNameValidation: Cred_Submit_PaymentFirstNameValidation$1,
    Cred_Submit_PaymentHeader: Cred_Submit_PaymentHeader$1,
    Cred_Submit_PaymentLastName: Cred_Submit_PaymentLastName$1,
    Cred_Submit_PaymentLastNameValidation: Cred_Submit_PaymentLastNameValidation$1,
    Cred_Submit_PaymentNotRequired: Cred_Submit_PaymentNotRequired$1,
    Cred_Submit_PaymentProvidedBy: Cred_Submit_PaymentProvidedBy$1,
    Cred_Submit_PaymentReceived: Cred_Submit_PaymentReceived$1,
    Cred_Submit_PlagiarismCheck: Cred_Submit_PlagiarismCheck$1,
    Cred_Submit_PlagiarismDescription: Cred_Submit_PlagiarismDescription$1,
    Cred_Submit_PlagiarismHeader: Cred_Submit_PlagiarismHeader$1,
    Cred_Submit_PromoCodeExpand: Cred_Submit_PromoCodeExpand$1,
    Cred_Submit_PromoNotFound: Cred_Submit_PromoNotFound$1,
    Cred_Submit_PromoProductError: Cred_Submit_PromoProductError$1,
    Cred_Submit_ReviewedByDescription: Cred_Submit_ReviewedByDescription$1,
    Cred_Submit_ReviewedByHeader: Cred_Submit_ReviewedByHeader$1,
    Cred_Submit_SaveApplication: Cred_Submit_SaveApplication$1,
    Cred_Submit_ScholarshipCode: Cred_Submit_ScholarshipCode$1,
    Cred_Submit_ScholarshipDiscount: Cred_Submit_ScholarshipDiscount$1,
    Cred_Submit_SecurePayment: Cred_Submit_SecurePayment$1,
    Cred_Submit_SkillProcessName: Cred_Submit_SkillProcessName$1,
    Cred_Submit_SubmitApplication: Cred_Submit_SubmitApplication$1,
    Cred_Submit_SubTotal: Cred_Submit_SubTotal$1,
    Cred_Submit_TermsAgree: Cred_Submit_TermsAgree$1,
    Cred_Submit_TermsDescription: Cred_Submit_TermsDescription$1,
    Cred_Submit_TermsHeader: Cred_Submit_TermsHeader$1,
    Cred_Success_Heading: Cred_Success_Heading$1,
    Cred_Success_Instructions: Cred_Success_Instructions$1,
    Cred_Success_InviteOthers: Cred_Success_InviteOthers$1,
    Cred_Success_SubHeading: Cred_Success_SubHeading$1,
    Cred_Verify_CodeLabel: Cred_Verify_CodeLabel$1,
    Cred_Verify_FollowupLabel: Cred_Verify_FollowupLabel$1,
    Cred_Verify_FollowupPlaceholder: Cred_Verify_FollowupPlaceholder$1,
    Cred_Verify_FollowupSuccess: Cred_Verify_FollowupSuccess$1,
    Cred_Verify_Heading: Cred_Verify_Heading$1,
    Cred_Verify_Instructions: Cred_Verify_Instructions$1,
    Cred_Verify_InvalidInstructions: Cred_Verify_InvalidInstructions$1,
    Cred_Verify_InvalidMessage: Cred_Verify_InvalidMessage$1,
    Cred_Verify_ValidMessage: Cred_Verify_ValidMessage$1,
    Cred_Verify_VerifyCodeButton: Cred_Verify_VerifyCodeButton$1,
    Cred_Wait_Heading: Cred_Wait_Heading$1,
    Cred_Wait_Instructions: Cred_Wait_Instructions$1,
    Cred_Wait_InviteOthers: Cred_Wait_InviteOthers$1,
    Cred_Wait_SubHeading: Cred_Wait_SubHeading$1,
    CredentialAwardedEmail_Autonomy: CredentialAwardedEmail_Autonomy$1,
    CredentialAwardedEmail_Autonomy1Desc: CredentialAwardedEmail_Autonomy1Desc$1,
    CredentialAwardedEmail_Autonomy2Desc: CredentialAwardedEmail_Autonomy2Desc$1,
    CredentialAwardedEmail_Autonomy3Desc: CredentialAwardedEmail_Autonomy3Desc$1,
    CredentialAwardedEmail_Autonomy4Desc: CredentialAwardedEmail_Autonomy4Desc$1,
    CredentialAwardedEmail_Autonomy5Desc: CredentialAwardedEmail_Autonomy5Desc$1,
    CredentialAwardedEmail_Autonomy6Desc: CredentialAwardedEmail_Autonomy6Desc$1,
    CredentialAwardedEmail_Autonomy7Desc: CredentialAwardedEmail_Autonomy7Desc$1,
    CredentialAwardedEmail_Autonomy8Desc: CredentialAwardedEmail_Autonomy8Desc$1,
    CredentialAwardedEmail_Industry: CredentialAwardedEmail_Industry$1,
    CredentialAwardedEmail_Industry1Desc: CredentialAwardedEmail_Industry1Desc$1,
    CredentialAwardedEmail_Industry2Desc: CredentialAwardedEmail_Industry2Desc$1,
    CredentialAwardedEmail_Industry3Desc: CredentialAwardedEmail_Industry3Desc$1,
    CredentialAwardedEmail_Industry4Desc: CredentialAwardedEmail_Industry4Desc$1,
    CredentialAwardedEmail_Industry5Desc: CredentialAwardedEmail_Industry5Desc$1,
    CredentialAwardedEmail_Industry6Desc: CredentialAwardedEmail_Industry6Desc$1,
    CredentialAwardedEmail_Industry7Desc: CredentialAwardedEmail_Industry7Desc$1,
    CredentialAwardedEmail_Industry8Desc: CredentialAwardedEmail_Industry8Desc$1,
    CredentialAwardedEmail_Knowledge: CredentialAwardedEmail_Knowledge$1,
    CredentialAwardedEmail_Knowledge1Desc: CredentialAwardedEmail_Knowledge1Desc$1,
    CredentialAwardedEmail_Knowledge2Desc: CredentialAwardedEmail_Knowledge2Desc$1,
    CredentialAwardedEmail_Knowledge3Desc: CredentialAwardedEmail_Knowledge3Desc$1,
    CredentialAwardedEmail_Knowledge4Desc: CredentialAwardedEmail_Knowledge4Desc$1,
    CredentialAwardedEmail_Knowledge5Desc: CredentialAwardedEmail_Knowledge5Desc$1,
    CredentialAwardedEmail_Knowledge6Desc: CredentialAwardedEmail_Knowledge6Desc$1,
    CredentialAwardedEmail_Knowledge7Desc: CredentialAwardedEmail_Knowledge7Desc$1,
    CredentialAwardedEmail_Knowledge8Desc: CredentialAwardedEmail_Knowledge8Desc$1,
    CredentialAwardedEmail_LearnMore: CredentialAwardedEmail_LearnMore$1,
    CredentialAwardedEmail_LearnMoreDescFormat: CredentialAwardedEmail_LearnMoreDescFormat$1,
    CredentialAwardedEmail_Level10Desc: CredentialAwardedEmail_Level10Desc$1,
    CredentialAwardedEmail_Level1Desc: CredentialAwardedEmail_Level1Desc$1,
    CredentialAwardedEmail_Level1Intro: CredentialAwardedEmail_Level1Intro$1,
    CredentialAwardedEmail_Level1Title: CredentialAwardedEmail_Level1Title$1,
    CredentialAwardedEmail_Level2Desc: CredentialAwardedEmail_Level2Desc$1,
    CredentialAwardedEmail_Level2Intro: CredentialAwardedEmail_Level2Intro$1,
    CredentialAwardedEmail_Level2Title: CredentialAwardedEmail_Level2Title$1,
    CredentialAwardedEmail_Level3Desc: CredentialAwardedEmail_Level3Desc$1,
    CredentialAwardedEmail_Level3Intro: CredentialAwardedEmail_Level3Intro$1,
    CredentialAwardedEmail_Level3Title: CredentialAwardedEmail_Level3Title$1,
    CredentialAwardedEmail_Level4Desc: CredentialAwardedEmail_Level4Desc$1,
    CredentialAwardedEmail_Level4Intro: CredentialAwardedEmail_Level4Intro$1,
    CredentialAwardedEmail_Level4Title: CredentialAwardedEmail_Level4Title$1,
    CredentialAwardedEmail_Level5Desc: CredentialAwardedEmail_Level5Desc$1,
    CredentialAwardedEmail_Level5Intro: CredentialAwardedEmail_Level5Intro$1,
    CredentialAwardedEmail_Level5Title: CredentialAwardedEmail_Level5Title$1,
    CredentialAwardedEmail_Level6Desc: CredentialAwardedEmail_Level6Desc$1,
    CredentialAwardedEmail_Level6Intro: CredentialAwardedEmail_Level6Intro$1,
    CredentialAwardedEmail_Level6Title: CredentialAwardedEmail_Level6Title$1,
    CredentialAwardedEmail_Level7Desc: CredentialAwardedEmail_Level7Desc$1,
    CredentialAwardedEmail_Level7Intro: CredentialAwardedEmail_Level7Intro$1,
    CredentialAwardedEmail_Level7Title: CredentialAwardedEmail_Level7Title$1,
    CredentialAwardedEmail_Level8Desc: CredentialAwardedEmail_Level8Desc$1,
    CredentialAwardedEmail_Level8Intro: CredentialAwardedEmail_Level8Intro$1,
    CredentialAwardedEmail_Level8Title: CredentialAwardedEmail_Level8Title$1,
    CredentialAwardedEmail_Level9Desc: CredentialAwardedEmail_Level9Desc$1,
    CredentialAwardedEmail_LevelUp: CredentialAwardedEmail_LevelUp$1,
    CredentialAwardedEmail_LevelUp1Desc: CredentialAwardedEmail_LevelUp1Desc$1,
    CredentialAwardedEmail_LevelUp2Desc: CredentialAwardedEmail_LevelUp2Desc$1,
    CredentialAwardedEmail_LevelUp3Desc: CredentialAwardedEmail_LevelUp3Desc$1,
    CredentialAwardedEmail_LevelUp4Desc: CredentialAwardedEmail_LevelUp4Desc$1,
    CredentialAwardedEmail_LevelUp5Desc: CredentialAwardedEmail_LevelUp5Desc$1,
    CredentialAwardedEmail_LevelUp6Desc: CredentialAwardedEmail_LevelUp6Desc$1,
    CredentialAwardedEmail_LevelUp7Desc: CredentialAwardedEmail_LevelUp7Desc$1,
    CredentialAwardedEmail_LevelUp8Desc: CredentialAwardedEmail_LevelUp8Desc$1,
    CredentialAwardedEmail_MessageParagraph1Format: CredentialAwardedEmail_MessageParagraph1Format$1,
    CredentialAwardedEmail_MessageParagraph2: CredentialAwardedEmail_MessageParagraph2$1,
    CredentialAwardedEmail_MessageParagraph3: CredentialAwardedEmail_MessageParagraph3$1,
    CredentialAwardedEmail_MessageParagraph6: CredentialAwardedEmail_MessageParagraph6$1,
    CredentialAwardedEmail_MessageParagraph7: CredentialAwardedEmail_MessageParagraph7$1,
    CredentialAwardedEmail_ShareYourExpertise: CredentialAwardedEmail_ShareYourExpertise$1,
    CredentialAwardedEmail_ShareYourExpertiseDesc: CredentialAwardedEmail_ShareYourExpertiseDesc$1,
    CredentialAwardedEmail_Subject: CredentialAwardedEmail_Subject$1,
    CredentialAwardedEmail_TaskTools: CredentialAwardedEmail_TaskTools$1,
    CredentialAwardedEmail_TaskTools1Desc: CredentialAwardedEmail_TaskTools1Desc$1,
    CredentialAwardedEmail_TaskTools2Desc: CredentialAwardedEmail_TaskTools2Desc$1,
    CredentialAwardedEmail_TaskTools3Desc: CredentialAwardedEmail_TaskTools3Desc$1,
    CredentialAwardedEmail_TaskTools4Desc: CredentialAwardedEmail_TaskTools4Desc$1,
    CredentialAwardedEmail_TaskTools5Desc: CredentialAwardedEmail_TaskTools5Desc$1,
    CredentialAwardedEmail_TaskTools6Desc: CredentialAwardedEmail_TaskTools6Desc$1,
    CredentialAwardedEmail_TaskTools7Desc: CredentialAwardedEmail_TaskTools7Desc$1,
    CredentialAwardedEmail_TaskTools8Desc: CredentialAwardedEmail_TaskTools8Desc$1,
    CredentialAwardedEmail_Title: CredentialAwardedEmail_Title$1,
    CredentialCompleteBehaviorsEmail_MessageParagraph1Format: CredentialCompleteBehaviorsEmail_MessageParagraph1Format$1,
    CredentialCompleteBehaviorsEmail_MessageParagraph2: CredentialCompleteBehaviorsEmail_MessageParagraph2$1,
    CredentialCompleteBehaviorsEmail_MessageParagraph3: CredentialCompleteBehaviorsEmail_MessageParagraph3$1,
    CredentialCompleteBehaviorsEmail_MessageParagraph4: CredentialCompleteBehaviorsEmail_MessageParagraph4$1,
    CredentialCompleteBehaviorsEmail_MessageParagraph5: CredentialCompleteBehaviorsEmail_MessageParagraph5$1,
    CredentialCompleteBehaviorsEmail_MessageParagraph6Format: CredentialCompleteBehaviorsEmail_MessageParagraph6Format$1,
    CredentialCompleteBehaviorsEmail_Subject: CredentialCompleteBehaviorsEmail_Subject$1,
    CredentialCompleteBehaviorsEmail_Title: CredentialCompleteBehaviorsEmail_Title$1,
    CredentialCompleteEndorsersEmail_MessageParagraph1: CredentialCompleteEndorsersEmail_MessageParagraph1$1,
    CredentialCompleteEndorsersEmail_MessageParagraph2: CredentialCompleteEndorsersEmail_MessageParagraph2$1,
    CredentialCompleteEndorsersEmail_MessageParagraph3: CredentialCompleteEndorsersEmail_MessageParagraph3$1,
    CredentialCompleteEndorsersEmail_MessageParagraph4: CredentialCompleteEndorsersEmail_MessageParagraph4$1,
    CredentialCompleteEndorsersEmail_MessageParagraph5: CredentialCompleteEndorsersEmail_MessageParagraph5$1,
    CredentialCompleteEndorsersEmail_Subject: CredentialCompleteEndorsersEmail_Subject$1,
    CredentialCompleteEndorsersEmail_Title: CredentialCompleteEndorsersEmail_Title$1,
    CredentialEmail_AwardVideo: CredentialEmail_AwardVideo$1,
    CredentialEmail_ContinueToApplication: CredentialEmail_ContinueToApplication$1,
    CredentialEmail_FooterReason: CredentialEmail_FooterReason$1,
    CredentialEmail_GetCertified: CredentialEmail_GetCertified$1,
    CredentialEmail_ReviewPeers: CredentialEmail_ReviewPeers$1,
    CredentialEmail_ViewCertificate: CredentialEmail_ViewCertificate$1,
    CredentialEmail_ViewEndorsements: CredentialEmail_ViewEndorsements$1,
    CredentialEmail_ViewStatus: CredentialEmail_ViewStatus$1,
    CredentialEmail_WhatIsDegreed: CredentialEmail_WhatIsDegreed$1,
    CredentialEmail_WhatIsDegreedDesc: CredentialEmail_WhatIsDegreedDesc$1,
    CredentialEndorserCompletedEmail_MessageParagraph1Format: CredentialEndorserCompletedEmail_MessageParagraph1Format$1,
    CredentialEndorserCompletedEmail_MessageParagraph2Format: CredentialEndorserCompletedEmail_MessageParagraph2Format$1,
    CredentialEndorserCompletedEmail_MessageParagraph3Format: CredentialEndorserCompletedEmail_MessageParagraph3Format$1,
    CredentialEndorserCompletedEmail_Subject: CredentialEndorserCompletedEmail_Subject$1,
    CredentialEndorserCompletedEmail_Title: CredentialEndorserCompletedEmail_Title$1,
    CredentialEndorserDeclinedEmail_MessageParagraph1Format: CredentialEndorserDeclinedEmail_MessageParagraph1Format$1,
    CredentialEndorserDeclinedEmail_MessageParagraph2: CredentialEndorserDeclinedEmail_MessageParagraph2$1,
    CredentialEndorserDeclinedEmail_Subject: CredentialEndorserDeclinedEmail_Subject$1,
    CredentialEndorserDeclinedEmail_Title: CredentialEndorserDeclinedEmail_Title$1,
    CredentialEndorserFollowupEmail_MessageParagraph1Format: CredentialEndorserFollowupEmail_MessageParagraph1Format$1,
    CredentialEndorserFollowupEmail_MessageParagraph2: CredentialEndorserFollowupEmail_MessageParagraph2$1,
    CredentialEndorserFollowupEmail_MessageParagraph3Format: CredentialEndorserFollowupEmail_MessageParagraph3Format$1,
    CredentialEndorserFollowupEmail_Subject: CredentialEndorserFollowupEmail_Subject$1,
    CredentialEndorserFollowupEmail_TitleFormat: CredentialEndorserFollowupEmail_TitleFormat$1,
    CredentialEndorsersInitialEmail_MessageParagraph1Format: CredentialEndorsersInitialEmail_MessageParagraph1Format$1,
    CredentialEndorsersInitialEmail_MessageParagraph2Format: CredentialEndorsersInitialEmail_MessageParagraph2Format$1,
    CredentialEndorsersInitialEmail_MessageParagraph3Format: CredentialEndorsersInitialEmail_MessageParagraph3Format$1,
    CredentialEndorsersInitialEmail_MessageParagraph4Format: CredentialEndorsersInitialEmail_MessageParagraph4Format$1,
    CredentialEndorsersInitialEmail_MessageParagraph5: CredentialEndorsersInitialEmail_MessageParagraph5$1,
    CredentialEndorsersInitialEmail_Subject: CredentialEndorsersInitialEmail_Subject$1,
    CredentialEndorsersInitialEmail_Title: CredentialEndorsersInitialEmail_Title$1,
    CredentialEndorserThankEmail_MessageParagraph1Format: CredentialEndorserThankEmail_MessageParagraph1Format$1,
    CredentialEndorserThankEmail_MessageParagraph2Format: CredentialEndorserThankEmail_MessageParagraph2Format$1,
    CredentialEndorserThankEmail_MessageParagraph3: CredentialEndorserThankEmail_MessageParagraph3$1,
    CredentialEndorserThankEmail_MessageParagraph4Format: CredentialEndorserThankEmail_MessageParagraph4Format$1,
    CredentialEndorserThankEmail_PromoCode: CredentialEndorserThankEmail_PromoCode$1,
    CredentialEndorserThankEmail_Subject: CredentialEndorserThankEmail_Subject$1,
    CredentialEndorserThankEmail_Title: CredentialEndorserThankEmail_Title$1,
    CredentialEndorserThankEmail_ViewProfile: CredentialEndorserThankEmail_ViewProfile$1,
    CredentialPaidInFullViaPromoEmail_Header: CredentialPaidInFullViaPromoEmail_Header$1,
    CredentialPaidInFullViaPromoEmail_MessageParagraph1Format: CredentialPaidInFullViaPromoEmail_MessageParagraph1Format$1,
    CredentialPaidInFullViaPromoEmail_MessageParagraph2: CredentialPaidInFullViaPromoEmail_MessageParagraph2$1,
    CredentialPaidInFullViaPromoEmail_PromotionalCodeDiscount: CredentialPaidInFullViaPromoEmail_PromotionalCodeDiscount$1,
    CredentialPaidInFullViaPromoEmail_Subject: CredentialPaidInFullViaPromoEmail_Subject$1,
    CredentialPaidInFullViaPromoEmail_Subtotal: CredentialPaidInFullViaPromoEmail_Subtotal$1,
    CredentialPaidInFullViaPromoEmail_Title: CredentialPaidInFullViaPromoEmail_Title$1,
    CredentialRateYourPeersEmail_MessageParagraph1: CredentialRateYourPeersEmail_MessageParagraph1$1,
    CredentialRateYourPeersEmail_MessageParagraph2Format: CredentialRateYourPeersEmail_MessageParagraph2Format$1,
    CredentialRateYourPeersEmail_MessageParagraph3Format: CredentialRateYourPeersEmail_MessageParagraph3Format$1,
    CredentialRateYourPeersEmail_MessageParagraph4: CredentialRateYourPeersEmail_MessageParagraph4$1,
    CredentialRateYourPeersEmail_Subject: CredentialRateYourPeersEmail_Subject$1,
    CredentialRateYourPeersEmail_Title: CredentialRateYourPeersEmail_Title$1,
    CredentialRateYourPeersFollowupEmail_MessageParagraph1: CredentialRateYourPeersFollowupEmail_MessageParagraph1$1,
    CredentialRateYourPeersFollowupEmail_MessageParagraph2Format: CredentialRateYourPeersFollowupEmail_MessageParagraph2Format$1,
    CredentialRateYourPeersFollowupEmail_MessageParagraph3Format: CredentialRateYourPeersFollowupEmail_MessageParagraph3Format$1,
    CredentialRateYourPeersFollowupEmail_MessageParagraph4: CredentialRateYourPeersFollowupEmail_MessageParagraph4$1,
    CredentialRateYourPeersFollowupEmail_MessageParagraph5Format: CredentialRateYourPeersFollowupEmail_MessageParagraph5Format$1,
    CredentialRateYourPeersFollowupEmail_Subject: CredentialRateYourPeersFollowupEmail_Subject$1,
    CredentialRateYourPeersFollowupEmail_Title: CredentialRateYourPeersFollowupEmail_Title$1,
    CredentialReviewSvc_ErrorSubmitting: CredentialReviewSvc_ErrorSubmitting$1,
    CredentialReviewSvc_GetBehaviorsError: CredentialReviewSvc_GetBehaviorsError$1,
    CredentialReviewSvc_GetError: CredentialReviewSvc_GetError$1,
    CredentialReviewSvc_GetReviewError: CredentialReviewSvc_GetReviewError$1,
    CredentialSubmissionReminderEmail_FromAddress: CredentialSubmissionReminderEmail_FromAddress$1,
    CredentialSubmissionReminderEmail_MessageParagraph1: CredentialSubmissionReminderEmail_MessageParagraph1$1,
    CredentialSubmissionReminderEmail_MessageParagraph2Format: CredentialSubmissionReminderEmail_MessageParagraph2Format$1,
    CredentialSubmissionReminderEmail_MessageParagraph3Format: CredentialSubmissionReminderEmail_MessageParagraph3Format$1,
    CredentialSubmissionReminderEmail_MessageParagraph4Format: CredentialSubmissionReminderEmail_MessageParagraph4Format$1,
    CredentialSubmissionReminderEmail_MessageParagraph5: CredentialSubmissionReminderEmail_MessageParagraph5$1,
    CredentialSubmissionReminderEmail_MessageParagraph6: CredentialSubmissionReminderEmail_MessageParagraph6$1,
    CredentialSubmissionReminderEmail_Subject: CredentialSubmissionReminderEmail_Subject$1,
    CredentialSubmissionReminderEmail_Title: CredentialSubmissionReminderEmail_Title$1,
    CredentialSubmittedEmail_MessageParagraph1Format: CredentialSubmittedEmail_MessageParagraph1Format$1,
    CredentialSubmittedEmail_MessageParagraph2: CredentialSubmittedEmail_MessageParagraph2$1,
    CredentialSubmittedEmail_MessageParagraph3Format: CredentialSubmittedEmail_MessageParagraph3Format$1,
    CredentialSubmittedEmail_MessageParagraph4Format: CredentialSubmittedEmail_MessageParagraph4Format$1,
    CredentialSubmittedEmail_Subject: CredentialSubmittedEmail_Subject$1,
    CredentialSubmittedEmail_Title: CredentialSubmittedEmail_Title$1,
    CredentialWaitForReviewsEmail_MessageParagraph1: CredentialWaitForReviewsEmail_MessageParagraph1$1,
    CredentialWaitForReviewsEmail_MessageParagraph2: CredentialWaitForReviewsEmail_MessageParagraph2$1,
    CredentialWaitForReviewsEmail_MessageParagraph3: CredentialWaitForReviewsEmail_MessageParagraph3$1,
    CredentialWaitForReviewsEmail_MessageParagraph4: CredentialWaitForReviewsEmail_MessageParagraph4$1,
    CredentialWaitForReviewsEmail_Subject: CredentialWaitForReviewsEmail_Subject$1,
    CredentialWaitForReviewsEmail_Title: CredentialWaitForReviewsEmail_Title$1,
    CredentialWaitingForEndorsementsEmail_MessageParagraph1: CredentialWaitingForEndorsementsEmail_MessageParagraph1$1,
    CredentialWaitingForEndorsementsEmail_MessageParagraph2: CredentialWaitingForEndorsementsEmail_MessageParagraph2$1,
    CredentialWaitingForEndorsementsEmail_MessageParagraph3: CredentialWaitingForEndorsementsEmail_MessageParagraph3$1,
    CredentialWaitingForEndorsementsEmail_MessageParagraph3Format: CredentialWaitingForEndorsementsEmail_MessageParagraph3Format$1,
    CredentialWaitingForEndorsementsEmail_MessageParagraph4Format: CredentialWaitingForEndorsementsEmail_MessageParagraph4Format$1,
    CredentialWaitingForEndorsementsEmail_MessageParagraphInfo: CredentialWaitingForEndorsementsEmail_MessageParagraphInfo$1,
    CredentialWaitingForEndorsementsEmail_Subject: CredentialWaitingForEndorsementsEmail_Subject$1,
    CredentialWaitingForEndorsementsEmail_Title: CredentialWaitingForEndorsementsEmail_Title$1,
    CredentialWelcomeEmail_MessageDearFormat: CredentialWelcomeEmail_MessageDearFormat$1,
    CredentialWelcomeEmail_MessageParagraph1: CredentialWelcomeEmail_MessageParagraph1$1,
    CredentialWelcomeEmail_MessageParagraph10Format: CredentialWelcomeEmail_MessageParagraph10Format$1,
    CredentialWelcomeEmail_MessageParagraph11: CredentialWelcomeEmail_MessageParagraph11$1,
    CredentialWelcomeEmail_MessageParagraph12: CredentialWelcomeEmail_MessageParagraph12$1,
    CredentialWelcomeEmail_MessageParagraph1Format: CredentialWelcomeEmail_MessageParagraph1Format$1,
    CredentialWelcomeEmail_MessageParagraph2: CredentialWelcomeEmail_MessageParagraph2$1,
    CredentialWelcomeEmail_MessageParagraph3: CredentialWelcomeEmail_MessageParagraph3$1,
    CredentialWelcomeEmail_MessageParagraph3Format: CredentialWelcomeEmail_MessageParagraph3Format$1,
    CredentialWelcomeEmail_MessageParagraph4: CredentialWelcomeEmail_MessageParagraph4$1,
    CredentialWelcomeEmail_MessageParagraph5: CredentialWelcomeEmail_MessageParagraph5$1,
    CredentialWelcomeEmail_MessageParagraph6: CredentialWelcomeEmail_MessageParagraph6$1,
    CredentialWelcomeEmail_MessageParagraph7: CredentialWelcomeEmail_MessageParagraph7$1,
    CredentialWelcomeEmail_MessageParagraph8: CredentialWelcomeEmail_MessageParagraph8$1,
    CredentialWelcomeEmail_MessageParagraph9: CredentialWelcomeEmail_MessageParagraph9$1,
    CredentialWelcomeEmail_MessageWelcomeFormat: CredentialWelcomeEmail_MessageWelcomeFormat$1,
    CredentialWelcomeEmail_PreviewFormat: CredentialWelcomeEmail_PreviewFormat$1,
    CredentialWelcomeEmail_Subject: CredentialWelcomeEmail_Subject$1,
    CredHonorCodeCtrl_AgreeLabel: CredHonorCodeCtrl_AgreeLabel$1,
    CredHonorCodeCtrl_DeclarationTitle: CredHonorCodeCtrl_DeclarationTitle$1,
    CredHonorCodeCtrl_Header: CredHonorCodeCtrl_Header$1,
    CredHonorCodeCtrl_Instructions: CredHonorCodeCtrl_Instructions$1,
    CredHonorCodeCtrl_Submit: CredHonorCodeCtrl_Submit$1,
    CredSpark_MissingEmployeeId: CredSpark_MissingEmployeeId$1,
    CoursesSvc_CoursesError: CoursesSvc_CoursesError$1,
    CoursesSvc_ProviderError: CoursesSvc_ProviderError$1,
    CourseFormCtrl_Accredited: CourseFormCtrl_Accredited$1,
    CourseFormCtrl_AddCourse: CourseFormCtrl_AddCourse$1,
    CourseFormCtrl_AddToCatalogFormat: CourseFormCtrl_AddToCatalogFormat$1,
    CourseFormCtrl_Category: CourseFormCtrl_Category$1,
    CourseFormCtrl_CommentPlaceholder: CourseFormCtrl_CommentPlaceholder$1,
    CourseFormCtrl_Country: CourseFormCtrl_Country$1,
    CourseFormCtrl_CountryPlaceholder: CourseFormCtrl_CountryPlaceholder$1,
    CourseFormCtrl_CourseFromScormFile: CourseFormCtrl_CourseFromScormFile$1,
    CourseFormCtrl_CourseFromScormFile_MetadataMissingMessage: CourseFormCtrl_CourseFromScormFile_MetadataMissingMessage$1,
    CourseFormCtrl_CourseGrade: CourseFormCtrl_CourseGrade$1,
    CourseFormCtrl_CourseGradePlaceholder: CourseFormCtrl_CourseGradePlaceholder$1,
    CourseFormCtrl_CourseLevel: CourseFormCtrl_CourseLevel$1,
    CourseFormCtrl_CourseLevelPlaceholder: CourseFormCtrl_CourseLevelPlaceholder$1,
    CourseFormCtrl_CourseNumber: CourseFormCtrl_CourseNumber$1,
    CourseFormCtrl_CourseNumberPlaceholder: CourseFormCtrl_CourseNumberPlaceholder$1,
    CourseFormCtrl_CourseTitle: CourseFormCtrl_CourseTitle$1,
    CourseFormCtrl_CourseUrl: CourseFormCtrl_CourseUrl$1,
    CourseFormCtrl_CourseUrlAria: CourseFormCtrl_CourseUrlAria$1,
    CourseFormCtrl_CreditHours: CourseFormCtrl_CreditHours$1,
    CourseFormCtrl_CreditHoursPlaceholder: CourseFormCtrl_CreditHoursPlaceholder$1,
    CourseFormCtrl_DateCompleted: CourseFormCtrl_DateCompleted$1,
    CourseFormCtrl_DateCompletedPlaceholder: CourseFormCtrl_DateCompletedPlaceholder$1,
    CourseFormCtrl_DateTaught: CourseFormCtrl_DateTaught$1,
    CourseFormCtrl_EditCourse: CourseFormCtrl_EditCourse$1,
    CourseFormCtrl_FirstYearLevel: CourseFormCtrl_FirstYearLevel$1,
    CourseFormCtrl_FourthYearLevel: CourseFormCtrl_FourthYearLevel$1,
    CourseFormCtrl_GraduateLevel: CourseFormCtrl_GraduateLevel$1,
    CourseFormCtrl_HowAdded: CourseFormCtrl_HowAdded$1,
    CourseFormCtrl_Informal: CourseFormCtrl_Informal$1,
    CourseFormCtrl_ITaughtCourse: CourseFormCtrl_ITaughtCourse$1,
    CourseFormCtrl_Provider: CourseFormCtrl_Provider$1,
    CourseFormCtrl_Provider_Placeholder: CourseFormCtrl_Provider_Placeholder$1,
    CourseFormCtrl_ProviderName: CourseFormCtrl_ProviderName$1,
    CourseFormCtrl_SaveCourse: CourseFormCtrl_SaveCourse$1,
    CourseFormCtrl_SchoolName: CourseFormCtrl_SchoolName$1,
    CourseFormCtrl_SchoolPlaceholder: CourseFormCtrl_SchoolPlaceholder$1,
    CourseFormCtrl_SecondYearLevel: CourseFormCtrl_SecondYearLevel$1,
    CourseFormCtrl_SelectCourse: CourseFormCtrl_SelectCourse$1,
    CourseFormCtrl_SelectProvider: CourseFormCtrl_SelectProvider$1,
    CourseFormCtrl_Summary: CourseFormCtrl_Summary$1,
    CourseFormCtrl_ThirdYearLevel: CourseFormCtrl_ThirdYearLevel$1,
    CourseFormCtrl_TitlePlaceholder: CourseFormCtrl_TitlePlaceholder$1,
    CourseFormCtrl_UnitType: CourseFormCtrl_UnitType$1,
    CourseFormCtrl_UrlError: CourseFormCtrl_UrlError$1,
    CourseFormCtrl_UrlOrScormRequired: CourseFormCtrl_UrlOrScormRequired$1,
    CourseFormCtrl_UrlOrSelectionRequired: CourseFormCtrl_UrlOrSelectionRequired$1,
    CourseFormCtrl_US: CourseFormCtrl_US$1,
    CourseFormCtrl_ValidNumber: CourseFormCtrl_ValidNumber$1,
    CourseFormCtrl_ValidScormRequired: CourseFormCtrl_ValidScormRequired$1,
    CourseFormCtrl_VerificationUrl: CourseFormCtrl_VerificationUrl$1,
    CourseFormCtrl_WhatDidYouLearnLong: CourseFormCtrl_WhatDidYouLearnLong$1,
    CourseFormCtrl_WhatDidYouLearnShort: CourseFormCtrl_WhatDidYouLearnShort$1,
    CourseFormCtrl_WhereTaken: CourseFormCtrl_WhereTaken$1,
    "Core_ AccountClaimed": "Account Claimed",
    "Core_ AddJobRole": "Add your job role",
    "Core_ AddLocation": "Add your location",
    "Core_ Assigned": "Assigned",
    "Core_ ExperienceType": "Experience Type",
    "Core_ PriceRange": "Price Range",
    "Core_ ProgramLanguage": "Program Language",
    "Core_ ProgramType": "Program Type",
    Core_1DayAgo: Core_1DayAgo$1,
    Core_1DayAgoFormat: Core_1DayAgoFormat$1,
    Core_1Hour: Core_1Hour$1,
    Core_1Hour1Minute: Core_1Hour1Minute$1,
    Core_1HourAgo: Core_1HourAgo$1,
    Core_1HourAgo_Minimal: Core_1HourAgo_Minimal$1,
    Core_1HourMinutesFormat: Core_1HourMinutesFormat$1,
    Core_1Minute: Core_1Minute$1,
    Core_1MinuteAgo: Core_1MinuteAgo$1,
    Core_1MinuteAgo_Minimal: Core_1MinuteAgo_Minimal$1,
    Core_1MonthAgo: Core_1MonthAgo$1,
    Core_1WeekAgo: Core_1WeekAgo$1,
    Core_1WeekAgo_Minimal: Core_1WeekAgo_Minimal$1,
    Core_1YearAgo: Core_1YearAgo$1,
    Core_A11yTypeaheadInstructions: Core_A11yTypeaheadInstructions$1,
    Core_AboutMe: Core_AboutMe$1,
    Core_Abstract: Core_Abstract$1,
    Core_Academies: Core_Academies$1,
    Core_AcademiesDescription: Core_AcademiesDescription$1,
    Core_AcademiesExplore: Core_AcademiesExplore$1,
    Core_AcademiesMarketplace: Core_AcademiesMarketplace$1,
    Core_Academy: Core_Academy$1,
    Core_AcademyContributor: Core_AcademyContributor$1,
    Core_AcademyView: Core_AcademyView$1,
    Core_Accept: Core_Accept$1,
    Core_AccessDenied: Core_AccessDenied$1,
    Core_Accomplishment: Core_Accomplishment$1,
    Core_AccomplishmentsDisplayName: Core_AccomplishmentsDisplayName$1,
    Core_AccountClaimed: Core_AccountClaimed$1,
    Core_AccountStatus: Core_AccountStatus$1,
    Core_Accredited: Core_Accredited$1,
    Core_Achievements: Core_Achievements$1,
    Core_Acknowledge_Changes: Core_Acknowledge_Changes$1,
    Core_ActionError: Core_ActionError$1,
    Core_Actions: Core_Actions$1,
    Core_Active: Core_Active$1,
    Core_ActiveLearner: Core_ActiveLearner$1,
    Core_ActiveLearners: Core_ActiveLearners$1,
    Core_Activity: Core_Activity$1,
    Core_ActualRecommendation: Core_ActualRecommendation$1,
    Core_Add: Core_Add$1,
    Core_Add_Skill_Source: Core_Add_Skill_Source$1,
    Core_Add_Source: Core_Add_Source$1,
    Core_AddAccomplishment: Core_AddAccomplishment$1,
    Core_AddArticle: Core_AddArticle$1,
    Core_AddAudio: Core_AddAudio$1,
    Core_AddAudioToCatalogFormat: Core_AddAudioToCatalogFormat$1,
    Core_AddBio: Core_AddBio$1,
    Core_AddBook: Core_AddBook$1,
    Core_AddContent: Core_AddContent$1,
    Core_Added: Core_Added$1,
    Core_AddedToQueueNotifierFormat: Core_AddedToQueueNotifierFormat$1,
    Core_AddExperience: Core_AddExperience$1,
    Core_AddGroups: Core_AddGroups$1,
    Core_AddGroupsInfo: Core_AddGroupsInfo$1,
    Core_AddingGroupsInfo: Core_AddingGroupsInfo$1,
    Core_AddItemTo: Core_AddItemTo$1,
    Core_AddPage: Core_AddPage$1,
    Core_AddPathway: Core_AddPathway$1,
    Core_AddPlans: Core_AddPlans$1,
    Core_AddPost: Core_AddPost$1,
    Core_AddTags: Core_AddTags$1,
    Core_AddTakeaway: Core_AddTakeaway$1,
    Core_AddTo: Core_AddTo$1,
    Core_AddToBundle: Core_AddToBundle$1,
    Core_AddToContent: Core_AddToContent$1,
    Core_AddToJobRole: Core_AddToJobRole$1,
    Core_AddToPathway: Core_AddToPathway$1,
    Core_AddVideo: Core_AddVideo$1,
    Core_Advanced: Core_Advanced$1,
    Core_AdvancedSettings: Core_AdvancedSettings$1,
    Core_AgreeContinue: Core_AgreeContinue$1,
    Core_All: Core_All$1,
    Core_All_Level: Core_All_Level$1,
    Core_AllFieldsRequired: Core_AllFieldsRequired$1,
    Core_AllTypesDisplayName: Core_AllTypesDisplayName$1,
    Core_AllUsers: Core_AllUsers$1,
    Core_AltText: Core_AltText$1,
    Core_AltTextHelperText: Core_AltTextHelperText$1,
    Core_Announcement: Core_Announcement$1,
    Core_AnonymousCountPluralFormat: Core_AnonymousCountPluralFormat$1,
    Core_AnonymousCountSingular: Core_AnonymousCountSingular$1,
    Core_AnonymousLearner: Core_AnonymousLearner$1,
    Core_AnonymousLearners: Core_AnonymousLearners$1,
    Core_AnonymousLearnersNotShown: Core_AnonymousLearnersNotShown$1,
    Core_Apply: Core_Apply$1,
    Core_ApplyChanges: Core_ApplyChanges$1,
    Core_Approve: Core_Approve$1,
    Core_ApproveAll: Core_ApproveAll$1,
    Core_ApproximateMinLeft: Core_ApproximateMinLeft$1,
    Core_Archived: Core_Archived$1,
    Core_AreYouSure: Core_AreYouSure$1,
    Core_Article: Core_Article$1,
    Core_Articles: Core_Articles$1,
    Core_ArticlesDisplayName: Core_ArticlesDisplayName$1,
    Core_ArticlesVideosDisplayName: Core_ArticlesVideosDisplayName$1,
    Core_ArticleVideoDisplayName: Core_ArticleVideoDisplayName$1,
    Core_Assessment: Core_Assessment$1,
    Core_AssessmentsDisplayName: Core_AssessmentsDisplayName$1,
    Core_Assign: Core_Assign$1,
    Core_Assigned: Core_Assigned$1,
    Core_AssignedBy: Core_AssignedBy$1,
    Core_AssignedDate: Core_AssignedDate$1,
    Core_AssignedLearning: Core_AssignedLearning$1,
    Core_AssignedLearningEmptyState: Core_AssignedLearningEmptyState$1,
    Core_AssignedTo: Core_AssignedTo$1,
    Core_Assignment: Core_Assignment$1,
    Core_AssignmentType: Core_AssignmentType$1,
    Core_Atoz: Core_Atoz$1,
    Core_Attend: Core_Attend$1,
    Core_Audio: Core_Audio$1,
    Core_Audiobook: Core_Audiobook$1,
    Core_AudioLength: Core_AudioLength$1,
    Core_AudioNamePlaceholder: Core_AudioNamePlaceholder$1,
    Core_AudioTitlePlaceholder: Core_AudioTitlePlaceholder$1,
    Core_AudioUrl: Core_AudioUrl$1,
    Core_Authoring: Core_Authoring$1,
    Core_Authors: Core_Authors$1,
    Core_Award: Core_Award$1,
    Core_AwardsDisplayName: Core_AwardsDisplayName$1,
    Core_AWeek: Core_AWeek$1,
    Core_Back: Core_Back$1,
    Core_BackToHomepage: Core_BackToHomepage$1,
    Core_Badge: Core_Badge$1,
    Core_BadgesDisplayName: Core_BadgesDisplayName$1,
    Core_Basic: Core_Basic$1,
    Core_Beginner: Core_Beginner$1,
    Core_Book: Core_Book$1,
    Core_Books: Core_Books$1,
    Core_BooksDisplayName: Core_BooksDisplayName$1,
    Core_Bootcamp: Core_Bootcamp$1,
    Core_Browse: Core_Browse$1,
    Core_BulkEdit: Core_BulkEdit$1,
    Core_BulkEditSelectedCount: Core_BulkEditSelectedCount$1,
    Core_By: Core_By$1,
    Core_CalendarDayCount: Core_CalendarDayCount$1,
    Core_CalendarNextMonth: Core_CalendarNextMonth$1,
    Core_CalendarPastYear: Core_CalendarPastYear$1,
    Core_CalendarPrevMonth: Core_CalendarPrevMonth$1,
    Core_CalendarRangeEnd: Core_CalendarRangeEnd$1,
    Core_CalendarRangeStart: Core_CalendarRangeStart$1,
    Core_CalendarSelectLast: Core_CalendarSelectLast$1,
    Core_CalendarSelectRange: Core_CalendarSelectRange$1,
    Core_CalendarSpecificDates: Core_CalendarSpecificDates$1,
    Core_CalendarView: Core_CalendarView$1,
    Core_Cancel: Core_Cancel$1,
    Core_Candidates: Core_Candidates$1,
    Core_CannotBeUndone: Core_CannotBeUndone$1,
    Core_CaseStudy: Core_CaseStudy$1,
    Core_Categories: Core_Categories$1,
    Core_Category: Core_Category$1,
    Core_CategoryName: Core_CategoryName$1,
    Core_Certificate: Core_Certificate$1,
    Core_CertificatesDisplayName: Core_CertificatesDisplayName$1,
    Core_Certification: Core_Certification$1,
    Core_CEU: Core_CEU$1,
    Core_CEUEligible: Core_CEUEligible$1,
    Core_CEUUnits: Core_CEUUnits$1,
    Core_Change: Core_Change$1,
    Core_Change_Primary_Skill_Source: Core_Change_Primary_Skill_Source$1,
    Core_Changes: Core_Changes$1,
    Core_ChangesSaved: Core_ChangesSaved$1,
    Core_CharLimitExceeded: Core_CharLimitExceeded$1,
    Core_CharsRemainingFormat: Core_CharsRemainingFormat$1,
    Core_ChartNotAvailableForAppliedFilters: Core_ChartNotAvailableForAppliedFilters$1,
    Core_Chat: Core_Chat$1,
    Core_CheckboxAll: Core_CheckboxAll$1,
    Core_ChooseFile: Core_ChooseFile$1,
    Core_ChooseSetupOptions: Core_ChooseSetupOptions$1,
    Core_Clear: Core_Clear$1,
    Core_ClearFilter: Core_ClearFilter$1,
    Core_ClearFilters: Core_ClearFilters$1,
    Core_ClearNumberFormat: Core_ClearNumberFormat$1,
    Core_ClearRating: Core_ClearRating$1,
    Core_ClearSelection: Core_ClearSelection$1,
    Core_ClearSelectionPluralFormat: Core_ClearSelectionPluralFormat$1,
    Core_ClearSelectionSingle: Core_ClearSelectionSingle$1,
    Core_ClearSelfRating: Core_ClearSelfRating$1,
    Core_ClickHere: Core_ClickHere$1,
    Core_Clone: Core_Clone$1,
    Core_CloneOfFormat: Core_CloneOfFormat$1,
    Core_Close: Core_Close$1,
    Core_Closed: Core_Closed$1,
    Core_ClosedOnDate: Core_ClosedOnDate$1,
    Core_CloseSuccess: Core_CloseSuccess$1,
    Core_Coach: Core_Coach$1,
    Core_Coaching: Core_Coaching$1,
    Core_Collaborator: Core_Collaborator$1,
    Core_CollaboratorOnly: Core_CollaboratorOnly$1,
    Core_Collaborators: Core_Collaborators$1,
    Core_Collapse: Core_Collapse$1,
    Core_CollapseAria: Core_CollapseAria$1,
    Core_ComingSoon: Core_ComingSoon$1,
    Core_Comment: Core_Comment$1,
    Core_CommentPrivacyWarning: Core_CommentPrivacyWarning$1,
    Core_Comments: Core_Comments$1,
    Core_Complete: Core_Complete$1,
    Core_Completed: Core_Completed$1,
    Core_CompletedContent: Core_CompletedContent$1,
    Core_CompletedDate: Core_CompletedDate$1,
    Core_CompletedFormat: Core_CompletedFormat$1,
    Core_CompletedStatus: Core_CompletedStatus$1,
    Core_Completion_Progress: Core_Completion_Progress$1,
    Core_Completions: Core_Completions$1,
    Core_Confetti: Core_Confetti$1,
    Core_Confirm: Core_Confirm$1,
    Core_ConfirmModalDefaultInputString: Core_ConfirmModalDefaultInputString$1,
    Core_ConfirmModalInputStringPlaceHolder: Core_ConfirmModalInputStringPlaceHolder$1,
    Core_ConfirmPassword: Core_ConfirmPassword$1,
    Core_ConfirmPasswordPlaceholder: Core_ConfirmPasswordPlaceholder$1,
    Core_Connect: Core_Connect$1,
    Core_Connected: Core_Connected$1,
    Core_Connectors: Core_Connectors$1,
    Core_ContactDegreedSupport: Core_ContactDegreedSupport$1,
    Core_Content: Core_Content$1,
    Core_ContentCompleted: Core_ContentCompleted$1,
    Core_ContentFollowed: Core_ContentFollowed$1,
    Core_ContentProcessing: Core_ContentProcessing$1,
    Core_ContentRemoved: Core_ContentRemoved$1,
    Core_ContentSaved: Core_ContentSaved$1,
    Core_ContentType: Core_ContentType$1,
    Core_ContentUncompleted: Core_ContentUncompleted$1,
    Core_ContentUnfollowed: Core_ContentUnfollowed$1,
    Core_ContentUnsaved: Core_ContentUnsaved$1,
    Core_Continue: Core_Continue$1,
    Core_ContinueLearningEmptyState: Core_ContinueLearningEmptyState$1,
    Core_ContinuingEducationUnitsEligible: Core_ContinuingEducationUnitsEligible$1,
    Core_CopyToClipboard: Core_CopyToClipboard$1,
    Core_Cost: Core_Cost$1,
    Core_CountItems: Core_CountItems$1,
    Core_CountMinutes: Core_CountMinutes$1,
    Core_CountPoints: Core_CountPoints$1,
    Core_Course: Core_Course$1,
    Core_Courses: Core_Courses$1,
    Core_CoursesDisplayName: Core_CoursesDisplayName$1,
    Core_Create: Core_Create$1,
    Core_CreatedBy: Core_CreatedBy$1,
    Core_CreatedDate: Core_CreatedDate$1,
    Core_Critical: Core_Critical$1,
    Core_Crop: Core_Crop$1,
    Core_Cropping: Core_Cropping$1,
    Core_CurrentPassword: Core_CurrentPassword$1,
    Core_CurrentPasswordPlaceholder: Core_CurrentPasswordPlaceholder$1,
    Core_CurrentSelfRating: Core_CurrentSelfRating$1,
    Core_Date: Core_Date$1,
    Core_Date_YYYYMMDDFormat: Core_Date_YYYYMMDDFormat$1,
    Core_DateAddedToProfile: Core_DateAddedToProfile$1,
    Core_DateLastUpdated: Core_DateLastUpdated$1,
    Core_Day: Core_Day$1,
    Core_DayOfWeekFriday: Core_DayOfWeekFriday$1,
    Core_DayOfWeekMonday: Core_DayOfWeekMonday$1,
    Core_DayOfWeekSaturday: Core_DayOfWeekSaturday$1,
    Core_DayOfWeekSunday: Core_DayOfWeekSunday$1,
    Core_DayOfWeekThursday: Core_DayOfWeekThursday$1,
    Core_DayOfWeekTuesday: Core_DayOfWeekTuesday$1,
    Core_DayOfWeekWednesday: Core_DayOfWeekWednesday$1,
    Core_Days: Core_Days$1,
    Core_DaysAgoFormat: Core_DaysAgoFormat$1,
    Core_DaysAgoFormat_Minimal: Core_DaysAgoFormat_Minimal$1,
    Core_DaysFormat: Core_DaysFormat$1,
    Core_Decline: Core_Decline$1,
    Core_DeclineAll: Core_DeclineAll$1,
    Core_Declined: Core_Declined$1,
    Core_Degree: Core_Degree$1,
    Core_DegreeBachelors: Core_DegreeBachelors$1,
    Core_DegreedSupport: Core_DegreedSupport$1,
    Core_DegreeMasters: Core_DegreeMasters$1,
    Core_DegreesDisplayName: Core_DegreesDisplayName$1,
    Core_Delete: Core_Delete$1,
    Core_Deleted: Core_Deleted$1,
    Core_Department: Core_Department$1,
    Core_Description: Core_Description$1,
    Core_Details: Core_Details$1,
    Core_Developing: Core_Developing$1,
    Core_Difficulty: Core_Difficulty$1,
    Core_Directory: Core_Directory$1,
    Core_Directorys: Core_Directorys$1,
    Core_DirectorysDisplayName: Core_DirectorysDisplayName$1,
    Core_Disable: Core_Disable$1,
    Core_Disabled: Core_Disabled$1,
    Core_DiscardChanges: Core_DiscardChanges$1,
    Core_Discover: Core_Discover$1,
    Core_DislikeAllyText: Core_DislikeAllyText$1,
    Core_Dismiss: Core_Dismiss$1,
    Core_DismissContent: Core_DismissContent$1,
    Core_DismissDialogHeader: Core_DismissDialogHeader$1,
    Core_DismissItemError: Core_DismissItemError$1,
    Core_DismissItemSuccess: Core_DismissItemSuccess$1,
    Core_Documentary: Core_Documentary$1,
    Core_Done: Core_Done$1,
    Core_DoneEditing: Core_DoneEditing$1,
    Core_DownloadDetails: Core_DownloadDetails$1,
    Core_DownloadFiles: Core_DownloadFiles$1,
    Core_DownloadMetadata: Core_DownloadMetadata$1,
    Core_Draft: Core_Draft$1,
    Core_DragFileHere: Core_DragFileHere$1,
    Core_Due: Core_Due$1,
    Core_DueBy: Core_DueBy$1,
    Core_DueDate: Core_DueDate$1,
    Core_DueDateFormat: Core_DueDateFormat$1,
    Core_DueDateTimeFormat: Core_DueDateTimeFormat$1,
    Core_DueIn: Core_DueIn$1,
    Core_DueOn: Core_DueOn$1,
    Core_Duration: Core_Duration$1,
    Core_DurationMinutes: Core_DurationMinutes$1,
    Core_DurationType: Core_DurationType$1,
    Core_Edit: Core_Edit$1,
    Core_Edit_Skill_Source: Core_Edit_Skill_Source$1,
    Core_EditArticle: Core_EditArticle$1,
    Core_EditAudio: Core_EditAudio$1,
    Core_EditBook: Core_EditBook$1,
    Core_EditDescription: Core_EditDescription$1,
    Core_EditDetails: Core_EditDetails$1,
    Core_EditItem: Core_EditItem$1,
    Core_EditItemHelper: Core_EditItemHelper$1,
    Core_EditPost: Core_EditPost$1,
    Core_EditSkillTarget: Core_EditSkillTarget$1,
    Core_EditStep: Core_EditStep$1,
    Core_EditVideo: Core_EditVideo$1,
    Core_Electronic: Core_Electronic$1,
    Core_Email: Core_Email$1,
    Core_EmailAddress: Core_EmailAddress$1,
    Core_EmailAddresses: Core_EmailAddresses$1,
    Core_EmailContent: Core_EmailContent$1,
    Core_EmailExistsError: Core_EmailExistsError$1,
    Core_EmailPlaceholder: Core_EmailPlaceholder$1,
    Core_EmailSubject: Core_EmailSubject$1,
    Core_EmailVerificationSuccessful: Core_EmailVerificationSuccessful$1,
    Core_Empty_Image_Alt: Core_Empty_Image_Alt$1,
    Core_EmptyFocusSkills: Core_EmptyFocusSkills$1,
    Core_EmptyFocusSkillsWithSuggestion: Core_EmptyFocusSkillsWithSuggestion$1,
    Core_Enable: Core_Enable$1,
    Core_Enabled: Core_Enabled$1,
    Core_EndDate: Core_EndDate$1,
    Core_Endorse: Core_Endorse$1,
    Core_EndorseConfirmation: Core_EndorseConfirmation$1,
    Core_EndorseContentChannelTypeError: Core_EndorseContentChannelTypeError$1,
    Core_EndorseContentGenericError: Core_EndorseContentGenericError$1,
    Core_EndorseContentOrgTypeError: Core_EndorseContentOrgTypeError$1,
    Core_EndorseContentPermissionError: Core_EndorseContentPermissionError$1,
    Core_Endorsed: Core_Endorsed$1,
    Core_EndorsedByOrganization: Core_EndorsedByOrganization$1,
    Core_EndorsedOnly: Core_EndorsedOnly$1,
    Core_EndorsedTooltip: Core_EndorsedTooltip$1,
    Core_EndorseInformation: Core_EndorseInformation$1,
    Core_EndorsementRemoved: Core_EndorsementRemoved$1,
    Core_Engagement: Core_Engagement$1,
    Core_Enroll: Core_Enroll$1,
    Core_Enrolled: Core_Enrolled$1,
    Core_Enrollees: Core_Enrollees$1,
    Core_EnrollInPathway: Core_EnrollInPathway$1,
    Core_Enrollment: Core_Enrollment$1,
    Core_Enrolls: Core_Enrolls$1,
    Core_Episode: Core_Episode$1,
    Core_EpisodesDisplayName: Core_EpisodesDisplayName$1,
    Core_Error: Core_Error$1,
    Core_Event: Core_Event$1,
    Core_Events: Core_Events$1,
    Core_EventsDisplayName: Core_EventsDisplayName$1,
    Core_ExactMatches: Core_ExactMatches$1,
    Core_Expand: Core_Expand$1,
    Core_ExperienceDisplayName: Core_ExperienceDisplayName$1,
    Core_ExperiencesDisplayName: Core_ExperiencesDisplayName$1,
    Core_Expert: Core_Expert$1,
    Core_External: Core_External$1,
    Core_ExternalBook: Core_ExternalBook$1,
    Core_ExternalBooksDisplayName: Core_ExternalBooksDisplayName$1,
    Core_ExternalPodcast: Core_ExternalPodcast$1,
    Core_ExternalPodcastsDisplayName: Core_ExternalPodcastsDisplayName$1,
    Core_ExternalResources: Core_ExternalResources$1,
    Core_ExternalVideo: Core_ExternalVideo$1,
    Core_ExternalVideosDisplayName: Core_ExternalVideosDisplayName$1,
    Core_False: Core_False$1,
    Core_Favicon: Core_Favicon$1,
    Core_FeatureResource: Core_FeatureResource$1,
    Core_Feed: Core_Feed$1,
    Core_FieldInvalidFormat: Core_FieldInvalidFormat$1,
    Core_FieldRequired: Core_FieldRequired$1,
    Core_FieldRequiredFormat: Core_FieldRequiredFormat$1,
    Core_Files: Core_Files$1,
    Core_FileTypes_FirstOrOnly: Core_FileTypes_FirstOrOnly$1,
    Core_FileTypes_Middle: Core_FileTypes_Middle$1,
    Core_FileTypes_OrLast: Core_FileTypes_OrLast$1,
    Core_Filter: Core_Filter$1,
    Core_FilterApplied: Core_FilterApplied$1,
    Core_FiltersAppliedFormat: Core_FiltersAppliedFormat$1,
    Core_FindContent: Core_FindContent$1,
    Core_Finish: Core_Finish$1,
    Core_FirstName: Core_FirstName$1,
    Core_FlagAsInappropriate: Core_FlagAsInappropriate$1,
    Core_Focus: Core_Focus$1,
    Core_FocusSkill: Core_FocusSkill$1,
    Core_FocusUnderLimitDescription: Core_FocusUnderLimitDescription$1,
    Core_FocusUptoLimitDescription: Core_FocusUptoLimitDescription$1,
    Core_Follow: Core_Follow$1,
    Core_Follow_UserName: Core_Follow_UserName$1,
    Core_Followers: Core_Followers$1,
    Core_Following: Core_Following$1,
    Core_FollowingButtonLabel: Core_FollowingButtonLabel$1,
    Core_FollowPathway: Core_FollowPathway$1,
    Core_Follows: Core_Follows$1,
    Core_Format: Core_Format$1,
    Core_Free: Core_Free$1,
    Core_FreeformText: Core_FreeformText$1,
    Core_Future: Core_Future$1,
    Core_GeneralErrorMessage: Core_GeneralErrorMessage$1,
    Core_GeneralLoadingError: Core_GeneralLoadingError$1,
    Core_Goal: Core_Goal$1,
    Core_GoalAddedFormat: Core_GoalAddedFormat$1,
    Core_GoBack: Core_GoBack$1,
    Core_Graduate: Core_Graduate$1,
    Core_GreaterThan1Day: Core_GreaterThan1Day$1,
    Core_Grid: Core_Grid$1,
    Core_Group: Core_Group$1,
    Core_GroupDisplayName: Core_GroupDisplayName$1,
    Core_Groups: Core_Groups$1,
    Core_GroupsDisplayName: Core_GroupsDisplayName$1,
    Core_GrowthPlan: Core_GrowthPlan$1,
    Core_Help: Core_Help$1,
    Core_Hide: Core_Hide$1,
    Core_HideFilters: Core_HideFilters$1,
    Core_Home: Core_Home$1,
    Core_Hooray: Core_Hooray$1,
    Core_Hour: Core_Hour$1,
    Core_Hours: Core_Hours$1,
    Core_HoursAgoFormat: Core_HoursAgoFormat$1,
    Core_HoursAgoFormat_Minimal: Core_HoursAgoFormat_Minimal$1,
    Core_HoursFormat: Core_HoursFormat$1,
    Core_HoursMinutesFormat: Core_HoursMinutesFormat$1,
    Core_Hybrid: Core_Hybrid$1,
    Core_Icon: Core_Icon$1,
    Core_ICreatedAudio: Core_ICreatedAudio$1,
    Core_Image: Core_Image$1,
    Core_In1DayFormat: Core_In1DayFormat$1,
    Core_Inactive: Core_Inactive$1,
    Core_InAppNotification: Core_InAppNotification$1,
    Core_InDaysFormat: Core_InDaysFormat$1,
    Core_Inference: Core_Inference$1,
    Core_Info: Core_Info$1,
    Core_InPerson: Core_InPerson$1,
    Core_InProgress: Core_InProgress$1,
    Core_InputActionAdded: Core_InputActionAdded$1,
    Core_InputActionAttended: Core_InputActionAttended$1,
    Core_InputActionCompleted: Core_InputActionCompleted$1,
    Core_InputActionCompletedCourse: Core_InputActionCompletedCourse$1,
    Core_InputActionCompletedPodcast: Core_InputActionCompletedPodcast$1,
    Core_InputActionRead: Core_InputActionRead$1,
    Core_InputActionReadBook: Core_InputActionReadBook$1,
    Core_InputActionTaskCompleted: Core_InputActionTaskCompleted$1,
    Core_InputActionWatched: Core_InputActionWatched$1,
    Core_InputCommentPlaceholder: Core_InputCommentPlaceholder$1,
    Core_InputDetails: Core_InputDetails$1,
    Core_Inputs: Core_Inputs$1,
    Core_Insights: Core_Insights$1,
    Core_Instructions: Core_Instructions$1,
    Core_InstructorLed: Core_InstructorLed$1,
    Core_Integration: Core_Integration$1,
    Core_Interested: Core_Interested$1,
    Core_Intermediate: Core_Intermediate$1,
    Core_Invalid: Core_Invalid$1,
    Core_InvalidEmail: Core_InvalidEmail$1,
    Core_InvalidEmailPattern: Core_InvalidEmailPattern$1,
    Core_InvalidMaxValue: Core_InvalidMaxValue$1,
    Core_InvalidMinValue: Core_InvalidMinValue$1,
    Core_Inventory: Core_Inventory$1,
    Core_Invite: Core_Invite$1,
    Core_Items: Core_Items$1,
    Core_ItemsSelectedFormat: Core_ItemsSelectedFormat$1,
    Core_JobRole: Core_JobRole$1,
    Core_JobroleDisplayName: Core_JobroleDisplayName$1,
    Core_JobRoleLiteral: Core_JobRoleLiteral$1,
    Core_JobRoles: Core_JobRoles$1,
    Core_JobRolesDisplayName: Core_JobRolesDisplayName$1,
    Core_JobTitle: Core_JobTitle$1,
    Core_Join: Core_Join$1,
    Core_Joined: Core_Joined$1,
    Core_JoinEvent: Core_JoinEvent$1,
    Core_Journal: Core_Journal$1,
    Core_Journey: Core_Journey$1,
    Core_JustNow: Core_JustNow$1,
    Core_Language: Core_Language$1,
    Core_LanguageSettings: Core_LanguageSettings$1,
    Core_LastActive: Core_LastActive$1,
    Core_LastLogin: Core_LastLogin$1,
    Core_LastMonth: Core_LastMonth$1,
    Core_LastName: Core_LastName$1,
    Core_LastNameTC: Core_LastNameTC$1,
    Core_LastUpdated: Core_LastUpdated$1,
    Core_LastWeek: Core_LastWeek$1,
    Core_Learn_More: Core_Learn_More$1,
    Core_Learning: Core_Learning$1,
    Core_LearningMinutes: Core_LearningMinutes$1,
    Core_LearningPath: Core_LearningPath$1,
    Core_Learnings: Core_Learnings$1,
    Core_LearnMore: Core_LearnMore$1,
    Core_LearnOnDegreed: Core_LearnOnDegreed$1,
    Core_LessThan10: Core_LessThan10$1,
    Core_LessThan1Day: Core_LessThan1Day$1,
    Core_LessThan1Hour: Core_LessThan1Hour$1,
    Core_LessThan30: Core_LessThan30$1,
    Core_LessThan30Days: Core_LessThan30Days$1,
    Core_LessThan4Hours: Core_LessThan4Hours$1,
    Core_LessThan5: Core_LessThan5$1,
    Core_LessThan6Months: Core_LessThan6Months$1,
    Core_LessThanADay: Core_LessThanADay$1,
    Core_LessThanOneYear: Core_LessThanOneYear$1,
    Core_Like: Core_Like$1,
    Core_LikeAllyText: Core_LikeAllyText$1,
    Core_Liked: Core_Liked$1,
    Core_LimitedVisibility: Core_LimitedVisibility$1,
    Core_Link: Core_Link$1,
    Core_Linked_External_Skill_Source: Core_Linked_External_Skill_Source$1,
    Core_Links: Core_Links$1,
    Core_LinkText: Core_LinkText$1,
    Core_List: Core_List$1,
    Core_ListItemsError: Core_ListItemsError$1,
    Core_Live: Core_Live$1,
    Core_LiveOnlineTraining: Core_LiveOnlineTraining$1,
    Core_Loading: Core_Loading$1,
    Core_LoadingResults: Core_LoadingResults$1,
    Core_LoadMore: Core_LoadMore$1,
    Core_LoadMoreAria: Core_LoadMoreAria$1,
    Core_Location: Core_Location$1,
    Core_MaliciousURL: Core_MaliciousURL$1,
    Core_ManageFocusSkills: Core_ManageFocusSkills$1,
    Core_ManagerRating: Core_ManagerRating$1,
    Core_ManageTranslations: Core_ManageTranslations$1,
    Core_Mandatory: Core_Mandatory$1,
    Core_Mark_ContentName_Complete: Core_Mark_ContentName_Complete$1,
    Core_Mark_ContentTitle_Complete: Core_Mark_ContentTitle_Complete$1,
    Core_MarkAsComplete: Core_MarkAsComplete$1,
    Core_Marketplace: Core_Marketplace$1,
    Core_Matched_Skills: Core_Matched_Skills$1,
    Core_MatchedOf: Core_MatchedOf$1,
    Core_MaxCost: Core_MaxCost$1,
    Core_Media: Core_Media$1,
    Core_Meeting: Core_Meeting$1,
    Core_Members: Core_Members$1,
    Core_Membership: Core_Membership$1,
    Core_Mentee: Core_Mentee$1,
    Core_Mentor: Core_Mentor$1,
    Core_Mentors: Core_Mentors$1,
    Core_Message: Core_Message$1,
    Core_MinCost: Core_MinCost$1,
    Core_Minute: Core_Minute$1,
    Core_Minutes: Core_Minutes$1,
    Core_MinutesAgoFormat: Core_MinutesAgoFormat$1,
    Core_MinutesAgoFormat_Minimal: Core_MinutesAgoFormat_Minimal$1,
    Core_MinutesFormat: Core_MinutesFormat$1,
    Core_MissingRatingNudgeText: Core_MissingRatingNudgeText$1,
    Core_Month: Core_Month$1,
    Core_MonthAgoFormat: Core_MonthAgoFormat$1,
    Core_Months: Core_Months$1,
    Core_MonthsAgoFormat: Core_MonthsAgoFormat$1,
    Core_MonthsAgoFormat_Minimal: Core_MonthsAgoFormat_Minimal$1,
    Core_More: Core_More$1,
    Core_MoreDetails: Core_MoreDetails$1,
    Core_MoreFilters: Core_MoreFilters$1,
    Core_MoreInfo: Core_MoreInfo$1,
    Core_MoreOptions: Core_MoreOptions$1,
    Core_MoreOptionsForItem: Core_MoreOptionsForItem$1,
    Core_MoveDown: Core_MoveDown$1,
    Core_MoveToGlobal: Core_MoveToGlobal$1,
    Core_MoveUp: Core_MoveUp$1,
    Core_Multisession: Core_Multisession$1,
    Core_Name: Core_Name$1,
    Core_NearStart: Core_NearStart$1,
    Core_New: Core_New$1,
    Core_Newest: Core_Newest$1,
    Core_NewItem: Core_NewItem$1,
    Core_NewItems: Core_NewItems$1,
    Core_NewPassword: Core_NewPassword$1,
    Core_NewPasswordPlaceholder: Core_NewPasswordPlaceholder$1,
    Core_NewRating: Core_NewRating$1,
    Core_NewSelfRating: Core_NewSelfRating$1,
    Core_Next: Core_Next$1,
    Core_Next30Days: Core_Next30Days$1,
    Core_Next60Days: Core_Next60Days$1,
    Core_Next7Days: Core_Next7Days$1,
    Core_NextYear: Core_NextYear$1,
    Core_NinePlusMonths: Core_NinePlusMonths$1,
    Core_No: Core_No$1,
    Core_NoDescription: Core_NoDescription$1,
    Core_NoDueDate: Core_NoDueDate$1,
    Core_NoFiles: Core_NoFiles$1,
    Core_NoMembers: Core_NoMembers$1,
    Core_NoPreviousLogin: Core_NoPreviousLogin$1,
    Core_NoResults: Core_NoResults$1,
    Core_NoResultsFor: Core_NoResultsFor$1,
    Core_NoResultsFound: Core_NoResultsFound$1,
    Core_NoResultsMatch: Core_NoResultsMatch$1,
    Core_Normal: Core_Normal$1,
    Core_NotAvailable: Core_NotAvailable$1,
    Core_NotAvailableForGroup: Core_NotAvailableForGroup$1,
    Core_NotDislikedAllyText: Core_NotDislikedAllyText$1,
    Core_NotFound_DescriptionText: Core_NotFound_DescriptionText$1,
    Core_NotFound_HeaderText: Core_NotFound_HeaderText$1,
    Core_NoThanks: Core_NoThanks$1,
    Core_NotSelected: Core_NotSelected$1,
    Core_NotSpecified: Core_NotSpecified$1,
    Core_Okay: Core_Okay$1,
    Core_Older: Core_Older$1,
    Core_Oldest: Core_Oldest$1,
    Core_OnDate: Core_OnDate$1,
    Core_OneToThreeMonths: Core_OneToThreeMonths$1,
    Core_Online: Core_Online$1,
    Core_Open: Core_Open$1,
    Core_OpenContent: Core_OpenContent$1,
    Core_OpenDatePicker: Core_OpenDatePicker$1,
    Core_OpenedOnDate: Core_OpenedOnDate$1,
    Core_OpenItem: Core_OpenItem$1,
    Core_Operator_Contains: Core_Operator_Contains$1,
    Core_Operator_Empty: Core_Operator_Empty$1,
    Core_Operator_EndsWith: Core_Operator_EndsWith$1,
    Core_Operator_Exact: Core_Operator_Exact$1,
    Core_Operator_NotContains: Core_Operator_NotContains$1,
    Core_Operator_StartsWith: Core_Operator_StartsWith$1,
    Core_Opportunities: Core_Opportunities$1,
    Core_OpportunitiesDesc: Core_OpportunitiesDesc$1,
    Core_Opportunity: Core_Opportunity$1,
    Core_Opportunity_Groups: Core_Opportunity_Groups$1,
    Core_Opportunity_JobRole: Core_Opportunity_JobRole$1,
    Core_Opportunity_JobRole_Placeholder: Core_Opportunity_JobRole_Placeholder$1,
    Core_OpportunityType: Core_OpportunityType$1,
    Core_Optin: Core_Optin$1,
    Core_Optional: Core_Optional$1,
    Core_OptionalMessage_Request: Core_OptionalMessage_Request$1,
    Core_Options: Core_Options$1,
    Core_OptionsAvailableFormat: Core_OptionsAvailableFormat$1,
    Core_Optout: Core_Optout$1,
    Core_Or: Core_Or$1,
    Core_Org_Recommendation: Core_Org_Recommendation$1,
    Core_Organization: Core_Organization$1,
    Core_Organizations: Core_Organizations$1,
    Core_OrgManagedDocLinkLabel: Core_OrgManagedDocLinkLabel$1,
    Core_OrgManagedNotification: Core_OrgManagedNotification$1,
    Core_OrgManagedNotificationPlural: Core_OrgManagedNotificationPlural$1,
    Core_Other: Core_Other$1,
    Core_OverrideChangesWarning: Core_OverrideChangesWarning$1,
    Core_Overview: Core_Overview$1,
    Core_OverYearAgo: Core_OverYearAgo$1,
    Core_Page: Core_Page$1,
    Core_Pages: Core_Pages$1,
    Core_Paid: Core_Paid$1,
    Core_PasswordLocked: Core_PasswordLocked$1,
    Core_PasswordMatchError: Core_PasswordMatchError$1,
    Core_PasswordPatternInfo: Core_PasswordPatternInfo$1,
    Core_PasswordRequirementsNotMet: Core_PasswordRequirementsNotMet$1,
    Core_PasswordReset: Core_PasswordReset$1,
    Core_Past: Core_Past$1,
    Core_Pathway: Core_Pathway$1,
    Core_Pathways: Core_Pathways$1,
    Core_PathwaysDisplayName: Core_PathwaysDisplayName$1,
    Core_PDF: Core_PDF$1,
    Core_Pending: Core_Pending$1,
    Core_People: Core_People$1,
    Core_Permissions: Core_Permissions$1,
    Core_PersonalizedLearningEmptySkills: Core_PersonalizedLearningEmptySkills$1,
    Core_PersonalizedLearningEmptySkillsWithSuggestion: Core_PersonalizedLearningEmptySkillsWithSuggestion$1,
    Core_PersonalizedLearningEmptyState: Core_PersonalizedLearningEmptyState$1,
    Core_Phone: Core_Phone$1,
    Core_Plans: Core_Plans$1,
    Core_PlansAndRoles: Core_PlansAndRoles$1,
    Core_Play: Core_Play$1,
    Core_PleaseTryAgain: Core_PleaseTryAgain$1,
    Core_PlusShowMore: Core_PlusShowMore$1,
    Core_Podcast: Core_Podcast$1,
    Core_PodcastDisplayName: Core_PodcastDisplayName$1,
    Core_PodcastEpisodeDisplayName: Core_PodcastEpisodeDisplayName$1,
    Core_PodcastHelp: Core_PodcastHelp$1,
    Core_PodcastNameUrl: Core_PodcastNameUrl$1,
    Core_Podcasts: Core_Podcasts$1,
    Core_PodcastsDisplayName: Core_PodcastsDisplayName$1,
    Core_PodcastUrl: Core_PodcastUrl$1,
    Core_Points: Core_Points$1,
    Core_Position: Core_Position$1,
    Core_PositionsDisplayName: Core_PositionsDisplayName$1,
    Core_Post: Core_Post$1,
    Core_PostsDisplayName: Core_PostsDisplayName$1,
    Core_PoweredBy: Core_PoweredBy$1,
    Core_Preview: Core_Preview$1,
    Core_Previous: Core_Previous$1,
    Core_PreviousRating: Core_PreviousRating$1,
    Core_PriceRange: Core_PriceRange$1,
    Core_Primary: Core_Primary$1,
    Core_Primary_Source: Core_Primary_Source$1,
    Core_PrimaryPlan: Core_PrimaryPlan$1,
    Core_Print: Core_Print$1,
    Core_PrivacyLevel0: Core_PrivacyLevel0$1,
    Core_PrivacyLevel1: Core_PrivacyLevel1$1,
    Core_PrivacyLevel2: Core_PrivacyLevel2$1,
    Core_PrivacyLevel2A: Core_PrivacyLevel2A$1,
    Core_PrivacyLevel2B: Core_PrivacyLevel2B$1,
    Core_PrivacyLevel2C: Core_PrivacyLevel2C$1,
    Core_PrivacyLevel3: Core_PrivacyLevel3$1,
    Core_Private: Core_Private$1,
    Core_Proficient: Core_Proficient$1,
    Core_ProgramLanguage: Core_ProgramLanguage$1,
    Core_ProgramType: Core_ProgramType$1,
    Core_ProgressBar_Tooltip: Core_ProgressBar_Tooltip$1,
    Core_ProgressSaved: Core_ProgressSaved$1,
    Core_Provider: Core_Provider$1,
    Core_Providers: Core_Providers$1,
    Core_Pts: Core_Pts$1,
    Core_Publish: Core_Publish$1,
    Core_PublishDate: Core_PublishDate$1,
    Core_Published: Core_Published$1,
    Core_PublishedDaysAgoFormat: Core_PublishedDaysAgoFormat$1,
    Core_PublishedHoursAgoFormat: Core_PublishedHoursAgoFormat$1,
    Core_PublishedJustNowFormat: Core_PublishedJustNowFormat$1,
    Core_PublishedMinutesAgoFormat: Core_PublishedMinutesAgoFormat$1,
    Core_PublishedMonthsAgoFormat: Core_PublishedMonthsAgoFormat$1,
    Core_PublishedOnDateFormat: Core_PublishedOnDateFormat$1,
    Core_PublishedOneHourAgoFormat: Core_PublishedOneHourAgoFormat$1,
    Core_PublishedOneMonthAgoFormat: Core_PublishedOneMonthAgoFormat$1,
    Core_PublishedOneWeekAgoFormat: Core_PublishedOneWeekAgoFormat$1,
    Core_PublishedWeeksAgoFormat: Core_PublishedWeeksAgoFormat$1,
    Core_PublishedXTimeAgoFormat: Core_PublishedXTimeAgoFormat$1,
    Core_PublishedYesterdayFormat: Core_PublishedYesterdayFormat$1,
    Core_Quarter: Core_Quarter$1,
    Core_Question: Core_Question$1,
    Core_Question_and_Answer: Core_Question_and_Answer$1,
    Core_Questions: Core_Questions$1,
    Core_Rate: Core_Rate$1,
    Core_RateYourself: Core_RateYourself$1,
    Core_RateYourselfInSkill: Core_RateYourselfInSkill$1,
    Core_Rating: Core_Rating$1,
    Core_Ratings: Core_Ratings$1,
    Core_RatingType: Core_RatingType$1,
    Core_Read: Core_Read$1,
    Core_ReadMore: Core_ReadMore$1,
    Core_RecentActivitySuggestion: Core_RecentActivitySuggestion$1,
    Core_RecentStart: Core_RecentStart$1,
    Core_Recommend: Core_Recommend$1,
    Core_Recommendation: Core_Recommendation$1,
    Core_RecommendationDisplayName: Core_RecommendationDisplayName$1,
    Core_RecommendationsDisplayName: Core_RecommendationsDisplayName$1,
    Core_Recommended: Core_Recommended$1,
    Core_RecommendedFocusSkills: Core_RecommendedFocusSkills$1,
    Core_RecommendedSkills: Core_RecommendedSkills$1,
    Core_RefreshPage: Core_RefreshPage$1,
    Core_Register: Core_Register$1,
    Core_Registered: Core_Registered$1,
    Core_RelatedSkillTooltip: Core_RelatedSkillTooltip$1,
    Core_Remove: Core_Remove$1,
    Core_RemoveAssignment: Core_RemoveAssignment$1,
    Core_RemoveAssignmentDescription: Core_RemoveAssignmentDescription$1,
    Core_Removed: Core_Removed$1,
    Core_RemoveEndorsement: Core_RemoveEndorsement$1,
    Core_RemoveEndorsementConfirmation: Core_RemoveEndorsementConfirmation$1,
    Core_RemoveFacetFormat: Core_RemoveFacetFormat$1,
    Core_RemoveFromAssignedModalText: Core_RemoveFromAssignedModalText$1,
    Core_RemoveFromContinueLearningModalText: Core_RemoveFromContinueLearningModalText$1,
    Core_RemoveFromInProgressModalText: Core_RemoveFromInProgressModalText$1,
    Core_RemoveFromPersonalizedLearningModalText: Core_RemoveFromPersonalizedLearningModalText$1,
    Core_RemoveFromTrendingLearningModalText: Core_RemoveFromTrendingLearningModalText$1,
    Core_RemoveImage: Core_RemoveImage$1,
    Core_RemoveItem: Core_RemoveItem$1,
    Core_RemoveSkill: Core_RemoveSkill$1,
    Core_RemoveSuccess: Core_RemoveSuccess$1,
    Core_Replace: Core_Replace$1,
    Core_ReplaceFile: Core_ReplaceFile$1,
    Core_Reply: Core_Reply$1,
    Core_ReportAProblem: Core_ReportAProblem$1,
    Core_Required: Core_Required$1,
    Core_ReRateSkill: Core_ReRateSkill$1,
    Core_Reset: Core_Reset$1,
    Core_ResetDefault: Core_ResetDefault$1,
    Core_ResetFilters: Core_ResetFilters$1,
    Core_ResetFiltersWithCount: Core_ResetFiltersWithCount$1,
    Core_Results: Core_Results$1,
    Core_ResultsFoundFormat: Core_ResultsFoundFormat$1,
    Core_Retry: Core_Retry$1,
    Core_Revert: Core_Revert$1,
    Core_Review: Core_Review$1,
    Core_Role: Core_Role$1,
    Core_RoleAdmin: Core_RoleAdmin$1,
    Core_RoleAdminsCan: Core_RoleAdminsCan$1,
    Core_RoleCareerProfessional: Core_RoleCareerProfessional$1,
    Core_RoleCareerProfessionalsCan: Core_RoleCareerProfessionalsCan$1,
    Core_RoleLearningProfessional: Core_RoleLearningProfessional$1,
    Core_RoleLearningProfessionalsCan: Core_RoleLearningProfessionalsCan$1,
    Core_RoleManager: Core_RoleManager$1,
    Core_RoleManagersCan: Core_RoleManagersCan$1,
    Core_RoleMember: Core_RoleMember$1,
    Core_RoleMembersCan: Core_RoleMembersCan$1,
    Core_RolePlan: Core_RolePlan$1,
    Core_RoleTechnicalAdmin: Core_RoleTechnicalAdmin$1,
    Core_RoleTechnicalAdminsCan: Core_RoleTechnicalAdminsCan$1,
    Core_Save: Core_Save$1,
    Core_SaveAudio: Core_SaveAudio$1,
    Core_SaveChanges: Core_SaveChanges$1,
    Core_Saved: Core_Saved$1,
    Core_SaveForLater: Core_SaveForLater$1,
    Core_SaveItemforLater: Core_SaveItemforLater$1,
    Core_SaveNext: Core_SaveNext$1,
    Core_SaveRating: Core_SaveRating$1,
    Core_SaveSkillTarget: Core_SaveSkillTarget$1,
    Core_Saving: Core_Saving$1,
    Core_ScrollLimit: Core_ScrollLimit$1,
    Core_ScrollLimited: Core_ScrollLimited$1,
    Core_Search: Core_Search$1,
    Core_SearchCatalog: Core_SearchCatalog$1,
    Core_SearchCollection: Core_SearchCollection$1,
    Core_SearchFilterA11yLabel: Core_SearchFilterA11yLabel$1,
    Core_SearchForPathway: Core_SearchForPathway$1,
    Core_SearchForPerson: Core_SearchForPerson$1,
    Core_SearchTerms: Core_SearchTerms$1,
    Core_Second: Core_Second$1,
    Core_Secondary: Core_Secondary$1,
    Core_Seconds: Core_Seconds$1,
    Core_SecondsAgoFormat: Core_SecondsAgoFormat$1,
    Core_SecondsAgoFormat_Minimal: Core_SecondsAgoFormat_Minimal$1,
    Core_SeeSkillCollection: Core_SeeSkillCollection$1,
    Core_Segments: Core_Segments$1,
    Core_Select: Core_Select$1,
    Core_SelectAllInTable: Core_SelectAllInTable$1,
    Core_SelectDate: Core_SelectDate$1,
    Core_SelectEndDate: Core_SelectEndDate$1,
    Core_SelectItem: Core_SelectItem$1,
    Core_SelectSelfRating: Core_SelectSelfRating$1,
    Core_SelectSkillTarget: Core_SelectSkillTarget$1,
    Core_SelectStartDate: Core_SelectStartDate$1,
    Core_SelfRating: Core_SelfRating$1,
    "Core_Self-Rating": "Self-Rating",
    "Core_Self-study": "Self-study",
    Core_Send: Core_Send$1,
    Core_SendEmail: Core_SendEmail$1,
    Core_Sending: Core_Sending$1,
    Core_SendRequest: Core_SendRequest$1,
    Core_Series: Core_Series$1,
    Core_SessionDateRange: Core_SessionDateRange$1,
    Core_SessionLocation: Core_SessionLocation$1,
    Core_Sessions: Core_Sessions$1,
    Core_SessionType: Core_SessionType$1,
    Core_SetAsGoal: Core_SetAsGoal$1,
    Core_SetGoal: Core_SetGoal$1,
    Core_SetSkillTarget: Core_SetSkillTarget$1,
    Core_Settings: Core_Settings$1,
    Core_SettingsSaved: Core_SettingsSaved$1,
    Core_Share: Core_Share$1,
    Core_Shared: Core_Shared$1,
    Core_SharedBy: Core_SharedBy$1,
    Core_SharedContent: Core_SharedContent$1,
    Core_ShareItem: Core_ShareItem$1,
    Core_ShareOn: Core_ShareOn$1,
    Core_Show: Core_Show$1,
    Core_ShowAll: Core_ShowAll$1,
    Core_ShowAllAria: Core_ShowAllAria$1,
    Core_ShowCompleted: Core_ShowCompleted$1,
    Core_ShowFilters: Core_ShowFilters$1,
    Core_ShowLess: Core_ShowLess$1,
    Core_ShowLessAria: Core_ShowLessAria$1,
    Core_ShowMore: Core_ShowMore$1,
    Core_ShowResults: Core_ShowResults$1,
    Core_SignalCount: Core_SignalCount$1,
    Core_SignalsCount: Core_SignalsCount$1,
    Core_Skill: Core_Skill$1,
    Core_Skill_Source_Acknowledge_Changes_Content: Core_Skill_Source_Acknowledge_Changes_Content$1,
    Core_SkillCoach: Core_SkillCoach$1,
    Core_SkillCount: Core_SkillCount$1,
    Core_SkillDisplayName: Core_SkillDisplayName$1,
    Core_SkillPlan: Core_SkillPlan$1,
    Core_SkillPlansDisplayName: Core_SkillPlansDisplayName$1,
    Core_SkillRating: Core_SkillRating$1,
    Core_Skills: Core_Skills$1,
    Core_SkillsAndTopics: Core_SkillsAndTopics$1,
    Core_SkillScaleChanged: Core_SkillScaleChanged$1,
    Core_SkillsCount: Core_SkillsCount$1,
    Core_SkillsDisplayName: Core_SkillsDisplayName$1,
    Core_SkillTarget: Core_SkillTarget$1,
    Core_SkillTargetDescription: Core_SkillTargetDescription$1,
    Core_SkillTargetLevel: Core_SkillTargetLevel$1,
    Core_Skip: Core_Skip$1,
    Core_SlowWarn: Core_SlowWarn$1,
    Core_SorryExclamation: Core_SorryExclamation$1,
    Core_Sort: Core_Sort$1,
    Core_SortBy: Core_SortBy$1,
    Core_Source: Core_Source$1,
    Core_Sources: Core_Sources$1,
    Core_SpecificDates: Core_SpecificDates$1,
    Core_SponsoredBy: Core_SponsoredBy$1,
    Core_Stage: Core_Stage$1,
    Core_Start: Core_Start$1,
    Core_StartDate: Core_StartDate$1,
    Core_Started: Core_Started$1,
    Core_StartTracking: Core_StartTracking$1,
    Core_Status: Core_Status$1,
    Core_Submit: Core_Submit$1,
    Core_SubmitContinue: Core_SubmitContinue$1,
    Core_Submitting: Core_Submitting$1,
    Core_Subscription: Core_Subscription$1,
    Core_Subtitle: Core_Subtitle$1,
    Core_Success: Core_Success$1,
    Core_SuccessChangesPublished: Core_SuccessChangesPublished$1,
    Core_SuccessfullyVerified: Core_SuccessfullyVerified$1,
    Core_Suggestions: Core_Suggestions$1,
    Core_Summary: Core_Summary$1,
    Core_Support: Core_Support$1,
    Core_Tag: Core_Tag$1,
    Core_TagCredential: Core_TagCredential$1,
    Core_TagEvaluation: Core_TagEvaluation$1,
    Core_Tags: Core_Tags$1,
    Core_TagsDisplayName: Core_TagsDisplayName$1,
    Core_TagSelf: Core_TagSelf$1,
    Core_Target: Core_Target$1,
    Core_Targets: Core_Targets$1,
    Core_TargetsDisplayName: Core_TargetsDisplayName$1,
    Core_TargetTypeNotDefined: Core_TargetTypeNotDefined$1,
    Core_Task: Core_Task$1,
    Core_Tasks: Core_Tasks$1,
    Core_TasksDisplayName: Core_TasksDisplayName$1,
    Core_Team: Core_Team$1,
    Core_Text: Core_Text$1,
    Core_ThisMonth: Core_ThisMonth$1,
    Core_ThisMonth_Minimal: Core_ThisMonth_Minimal$1,
    Core_ThisYear: Core_ThisYear$1,
    Core_ThisYear_Minimal: Core_ThisYear_Minimal$1,
    Core_ThreeToNineMonths: Core_ThreeToNineMonths$1,
    Core_TinyMCEAriaHelpText: Core_TinyMCEAriaHelpText$1,
    Core_Title: Core_Title$1,
    Core_TitleLength: Core_TitleLength$1,
    Core_TitleRequired: Core_TitleRequired$1,
    Core_To: Core_To$1,
    Core_ToBeCompleted: Core_ToBeCompleted$1,
    Core_Today: Core_Today$1,
    Core_Today_Minimal: Core_Today_Minimal$1,
    Core_ToDo: Core_ToDo$1,
    Core_ToggleExactMatches: Core_ToggleExactMatches$1,
    Core_Top: Core_Top$1,
    Core_Topics: Core_Topics$1,
    Core_TotalMembers: Core_TotalMembers$1,
    Core_Translations: Core_Translations$1,
    Core_True: Core_True$1,
    Core_TwoToFourWeeks: Core_TwoToFourWeeks$1,
    Core_Type: Core_Type$1,
    Core_UnableToEnrollFormat: Core_UnableToEnrollFormat$1,
    Core_UncompletedFormat: Core_UncompletedFormat$1,
    Core_Undergraduate: Core_Undergraduate$1,
    Core_UndislikeAllyText: Core_UndislikeAllyText$1,
    Core_UnfeatureResource: Core_UnfeatureResource$1,
    Core_UnFollow: Core_UnFollow$1,
    Core_Units: Core_Units$1,
    Core_Unknown: Core_Unknown$1,
    Core_Unlike: Core_Unlike$1,
    Core_UnlikeAllyText: Core_UnlikeAllyText$1,
    Core_Unpublish: Core_Unpublish$1,
    Core_UnpublishedChanges: Core_UnpublishedChanges$1,
    Core_Unsave: Core_Unsave$1,
    Core_UnsaveItem: Core_UnsaveItem$1,
    Core_UnselectAll: Core_UnselectAll$1,
    Core_Update: Core_Update$1,
    Core_Updated: Core_Updated$1,
    Core_Upload: Core_Upload$1,
    Core_UploadCategories: Core_UploadCategories$1,
    Core_Uploaded: Core_Uploaded$1,
    Core_UploadedFilesForSource: Core_UploadedFilesForSource$1,
    Core_UploadNew: Core_UploadNew$1,
    Core_UploadTranslations: Core_UploadTranslations$1,
    Core_Url: Core_Url$1,
    Core_UrlRequired: Core_UrlRequired$1,
    Core_Usd: Core_Usd$1,
    Core_UsedIn: Core_UsedIn$1,
    Core_User: Core_User$1,
    Core_UserActivityInformation: Core_UserActivityInformation$1,
    Core_Users: Core_Users$1,
    Core_UsersDisplayName: Core_UsersDisplayName$1,
    Core_UTCDatesNote: Core_UTCDatesNote$1,
    Core_Valid_No_WhiteSpace: Core_Valid_No_WhiteSpace$1,
    Core_ValidUrl: Core_ValidUrl$1,
    Core_Verify: Core_Verify$1,
    Core_Video: Core_Video$1,
    Core_Videos: Core_Videos$1,
    Core_VideosDisplayName: Core_VideosDisplayName$1,
    Core_View: Core_View$1,
    Core_ViewAll: Core_ViewAll$1,
    Core_ViewConversation: Core_ViewConversation$1,
    Core_ViewDescription: Core_ViewDescription$1,
    Core_ViewDetails: Core_ViewDetails$1,
    Core_Viewed: Core_Viewed$1,
    Core_ViewInCollection: Core_ViewInCollection$1,
    Core_ViewInGoals: Core_ViewInGoals$1,
    Core_ViewInstructions: Core_ViewInstructions$1,
    Core_ViewPathway: Core_ViewPathway$1,
    Core_ViewProfile: Core_ViewProfile$1,
    Core_Views: Core_Views$1,
    Core_ViewSavedItems: Core_ViewSavedItems$1,
    Core_ViewSkills: Core_ViewSkills$1,
    Core_VirtualClassroom: Core_VirtualClassroom$1,
    Core_VisibilityCollaborators: Core_VisibilityCollaborators$1,
    Core_VisibilityDocLinkLabel: Core_VisibilityDocLinkLabel$1,
    Core_VisibilityGroup: Core_VisibilityGroup$1,
    Core_VisibilityGroups: Core_VisibilityGroups$1,
    Core_VisibilityOrganization: Core_VisibilityOrganization$1,
    Core_VisibilityProfile: Core_VisibilityProfile$1,
    Core_VisibilityPublic: Core_VisibilityPublic$1,
    Core_VisitProvider: Core_VisitProvider$1,
    Core_VisitUrl: Core_VisitUrl$1,
    Core_VisitWebsite: Core_VisitWebsite$1,
    Core_Warning: Core_Warning$1,
    Core_Watch: Core_Watch$1,
    Core_Week: Core_Week$1,
    Core_Weeks: Core_Weeks$1,
    Core_WeeksAgoFormat: Core_WeeksAgoFormat$1,
    Core_WhatDidYouLearnAudioLong: Core_WhatDidYouLearnAudioLong$1,
    Core_Withdraw: Core_Withdraw$1,
    Core_withPublished: Core_withPublished$1,
    Core_Word: Core_Word$1,
    Core_WordLimitExceeded: Core_WordLimitExceeded$1,
    Core_Words: Core_Words$1,
    Core_WordsRemainingFormat: Core_WordsRemainingFormat$1,
    Core_Workshop: Core_Workshop$1,
    Core_WouldYouLikeToProceed: Core_WouldYouLikeToProceed$1,
    Core_Year: Core_Year$1,
    Core_YearAgoFormat: Core_YearAgoFormat$1,
    Core_YearsAgoFormat: Core_YearsAgoFormat$1,
    Core_YearsAgoFormat_Minimal: Core_YearsAgoFormat_Minimal$1,
    Core_Yes: Core_Yes$1,
    Core_YesContinue: Core_YesContinue$1,
    Core_YesProceed: Core_YesProceed$1,
    Core_YesSure: Core_YesSure$1,
    Core_Yesterday: Core_Yesterday$1,
    Core_Yesterday_Minimal: Core_Yesterday_Minimal$1,
    Core_YourFocusSkills: Core_YourFocusSkills$1,
    Core_ZeroSignalsCount: Core_ZeroSignalsCount$1,
    Core_ZeroSkills: Core_ZeroSkills$1,
    Core_ZeroSkillsCount: Core_ZeroSkillsCount$1,
    Core_ZoomIn: Core_ZoomIn$1,
    Core_ZoomOut: Core_ZoomOut$1,
    Core_Ztoa: Core_Ztoa$1,
    CopyLinkSvc_ActionMessage: CopyLinkSvc_ActionMessage$1,
    CopyLinkSvc_MacCopy: CopyLinkSvc_MacCopy$1,
    CopyLinkSvc_PcCopy: CopyLinkSvc_PcCopy$1,
    CookieNotice_CookieDescription_AntiforgeryrequestV4Degreed: CookieNotice_CookieDescription_AntiforgeryrequestV4Degreed$1,
    CookieNotice_CookieDescription_AntiforgeryV4Degreed: CookieNotice_CookieDescription_AntiforgeryV4Degreed$1,
    CookieNotice_CookieDescription_DegreedBearerAccess: CookieNotice_CookieDescription_DegreedBearerAccess$1,
    CookieNotice_CookieDescription_DegreedHost: CookieNotice_CookieDescription_DegreedHost$1,
    CookieNotice_CookieDescription_Helpdeskcookie: CookieNotice_CookieDescription_Helpdeskcookie$1,
    CookieNotice_CookieDescription_IdentityV4Degreed: CookieNotice_CookieDescription_IdentityV4Degreed$1,
    CookieNotice_CookieDescription_IsEU: CookieNotice_CookieDescription_IsEU$1,
    CookieNotice_CookieDescription_IsNonEU: CookieNotice_CookieDescription_IsNonEU$1,
    CookieNotice_CookieDescription_SessionTimeout: CookieNotice_CookieDescription_SessionTimeout$1,
    CookieNotice_CookieDescription_SessionV4Degreed: CookieNotice_CookieDescription_SessionV4Degreed$1,
    CookieNotice_CookieDescription_SsoV4Degreed: CookieNotice_CookieDescription_SsoV4Degreed$1,
    CookieNotice_DurationType_Logout: CookieNotice_DurationType_Logout$1,
    CookieNotice_DurationType_Persistent1: CookieNotice_DurationType_Persistent1$1,
    CookieNotice_DurationType_Persistent60Custom: CookieNotice_DurationType_Persistent60Custom$1,
    CookieNotice_DurationType_Persistent90: CookieNotice_DurationType_Persistent90$1,
    CookieNotice_DurationType_PersistentUpdated: CookieNotice_DurationType_PersistentUpdated$1,
    CookieNotice_DurationType_Session: CookieNotice_DurationType_Session$1,
    CookieNotice_EssentialCookies_Content: CookieNotice_EssentialCookies_Content$1,
    CookieNotice_EssentialCookies_Title: CookieNotice_EssentialCookies_Title$1,
    CookieNotice_NonEssentialCookies_Content: CookieNotice_NonEssentialCookies_Content$1,
    CookieNotice_NonEssentialCookies_Title: CookieNotice_NonEssentialCookies_Title$1,
    CookieNotice_OtherWebsiteCookies_Content: CookieNotice_OtherWebsiteCookies_Content$1,
    CookieNotice_OtherWebsiteCookies_Title: CookieNotice_OtherWebsiteCookies_Title$1,
    CookieNotice_TableHeader_Duration: CookieNotice_TableHeader_Duration$1,
    CookieNotice_TableHeader_Name: CookieNotice_TableHeader_Name$1,
    CookieNotice_TableHeader_Provider: CookieNotice_TableHeader_Provider$1,
    CookieNotice_TableHeader_Purpose: CookieNotice_TableHeader_Purpose$1,
    CookieNotice_WhatAreCookies_Content: CookieNotice_WhatAreCookies_Content$1,
    CookieNotice_WhatAreCookies_Title: CookieNotice_WhatAreCookies_Title$1,
    ContentTabs_AddArticle: ContentTabs_AddArticle$1,
    ContentTabs_AddPost: ContentTabs_AddPost$1,
    ContentTabs_AddTopicsOrSkills: ContentTabs_AddTopicsOrSkills$1,
    ContentTabs_AddVideo: ContentTabs_AddVideo$1,
    ContentTabs_EnterBookTitle: ContentTabs_EnterBookTitle$1,
    ContentTabs_InvalidTitle: ContentTabs_InvalidTitle$1,
    ContentTabs_InvalidUrl: ContentTabs_InvalidUrl$1,
    ContentTabs_RelatedSkills: ContentTabs_RelatedSkills$1,
    ContentTabs_YouAddedToProfile: ContentTabs_YouAddedToProfile$1,
    confirmModal_CancelApplicationBody: confirmModal_CancelApplicationBody$1,
    confirmModal_DeleteAccomplishmentBody: confirmModal_DeleteAccomplishmentBody$1,
    confirmModal_DeleteAccomplishmentTitle: confirmModal_DeleteAccomplishmentTitle$1,
    confirmModal_DeleteArticleBody: confirmModal_DeleteArticleBody$1,
    confirmModal_DeleteArticleTitle: confirmModal_DeleteArticleTitle$1,
    confirmModal_DeleteAssessmentBody: confirmModal_DeleteAssessmentBody$1,
    confirmModal_DeleteAssessmentTitle: confirmModal_DeleteAssessmentTitle$1,
    confirmModal_DeleteAwardBody: confirmModal_DeleteAwardBody$1,
    confirmModal_DeleteAwardTitle: confirmModal_DeleteAwardTitle$1,
    confirmModal_DeleteBadgeBody: confirmModal_DeleteBadgeBody$1,
    confirmModal_DeleteBadgeTitle: confirmModal_DeleteBadgeTitle$1,
    confirmModal_DeleteBookBody: confirmModal_DeleteBookBody$1,
    confirmModal_DeleteBookTitle: confirmModal_DeleteBookTitle$1,
    confirmModal_DeleteCertificateBody: confirmModal_DeleteCertificateBody$1,
    confirmModal_DeleteCertificateTitle: confirmModal_DeleteCertificateTitle$1,
    confirmModal_DeleteCourseBody: confirmModal_DeleteCourseBody$1,
    confirmModal_DeleteCourseTitle: confirmModal_DeleteCourseTitle$1,
    confirmModal_DeleteDegreeBody: confirmModal_DeleteDegreeBody$1,
    confirmModal_DeleteDegreeTitle: confirmModal_DeleteDegreeTitle$1,
    confirmModal_DeleteEpisodeBody: confirmModal_DeleteEpisodeBody$1,
    confirmModal_DeleteEpisodeTitle: confirmModal_DeleteEpisodeTitle$1,
    confirmModal_DeleteEventBody: confirmModal_DeleteEventBody$1,
    confirmModal_DeleteEventTitle: confirmModal_DeleteEventTitle$1,
    confirmModal_DeletePositionBody: confirmModal_DeletePositionBody$1,
    confirmModal_DeletePositionTitle: confirmModal_DeletePositionTitle$1,
    confirmModal_DeletePostBody: confirmModal_DeletePostBody$1,
    confirmModal_DeletePostTitle: confirmModal_DeletePostTitle$1,
    confirmModal_DeleteSkillBody: confirmModal_DeleteSkillBody$1,
    confirmModal_DeleteSkillTitle: confirmModal_DeleteSkillTitle$1,
    confirmModal_DeleteTaskBody: confirmModal_DeleteTaskBody$1,
    confirmModal_DeleteTaskTitle: confirmModal_DeleteTaskTitle$1,
    confirmModal_DeleteVideoBody: confirmModal_DeleteVideoBody$1,
    confirmModal_DeleteVideoTitle: confirmModal_DeleteVideoTitle$1,
    confirmModal_EvalCancelApplicationBody: confirmModal_EvalCancelApplicationBody$1,
    confirmModal_EvalRestartApplicationBody: confirmModal_EvalRestartApplicationBody$1,
    CompletedSkillRating_Format: CompletedSkillRating_Format$1,
    completedRecommendation_ArticleFormat: completedRecommendation_ArticleFormat$1,
    completedRecommendation_AssessmentFormat: completedRecommendation_AssessmentFormat$1,
    completedRecommendation_BookFormat: completedRecommendation_BookFormat$1,
    completedRecommendation_CourseFormat: completedRecommendation_CourseFormat$1,
    completedRecommendation_EpisodeFormat: completedRecommendation_EpisodeFormat$1,
    completedRecommendation_EventFormat: completedRecommendation_EventFormat$1,
    completedRecommendation_Format: completedRecommendation_Format$1,
    completedRecommendation_PathwayFormat: completedRecommendation_PathwayFormat$1,
    completedRecommendation_PostFormat: completedRecommendation_PostFormat$1,
    completedRecommendation_SkillFormat: completedRecommendation_SkillFormat$1,
    completedRecommendation_TargetFormat: completedRecommendation_TargetFormat$1,
    completedRecommendation_TaskFormat: completedRecommendation_TaskFormat$1,
    completedRecommendation_VideoFormat: completedRecommendation_VideoFormat$1,
    completedRecommendationFollow_Format: completedRecommendationFollow_Format$1,
    completedGoal_Single: completedGoal_Single$1,
    completedAssignedLearning_Format: completedAssignedLearning_Format$1,
    ComparisonSvc_RatingError: ComparisonSvc_RatingError$1,
    ComparisonSvc_SelectionError: ComparisonSvc_SelectionError$1,
    ComparisonRatingSkillOptionsSvc_Capable: ComparisonRatingSkillOptionsSvc_Capable$1,
    ComparisonRatingSkillOptionsSvc_CapableDesc: ComparisonRatingSkillOptionsSvc_CapableDesc$1,
    ComparisonRatingSkillOptionsSvc_Distinguished: ComparisonRatingSkillOptionsSvc_Distinguished$1,
    ComparisonRatingSkillOptionsSvc_DistinguishedDesc: ComparisonRatingSkillOptionsSvc_DistinguishedDesc$1,
    ComparisonRatingSkillOptionsSvc_Emerging: ComparisonRatingSkillOptionsSvc_Emerging$1,
    ComparisonRatingSkillOptionsSvc_EmergingDesc: ComparisonRatingSkillOptionsSvc_EmergingDesc$1,
    ComparisonRatingSkillOptionsSvc_Experienced: ComparisonRatingSkillOptionsSvc_Experienced$1,
    ComparisonRatingSkillOptionsSvc_ExperiencedDesc: ComparisonRatingSkillOptionsSvc_ExperiencedDesc$1,
    ComparisonRatingSkillOptionsSvc_Master: ComparisonRatingSkillOptionsSvc_Master$1,
    ComparisonRatingSkillOptionsSvc_MasterDesc: ComparisonRatingSkillOptionsSvc_MasterDesc$1,
    ComparisonRatingSkillOptionsSvc_Novice: ComparisonRatingSkillOptionsSvc_Novice$1,
    ComparisonRatingSkillOptionsSvc_NoviceDesc: ComparisonRatingSkillOptionsSvc_NoviceDesc$1,
    ComparisonRatingOptionsSvc_Capable: ComparisonRatingOptionsSvc_Capable$1,
    ComparisonRatingOptionsSvc_CapableDesc: ComparisonRatingOptionsSvc_CapableDesc$1,
    ComparisonRatingOptionsSvc_Distinguished: ComparisonRatingOptionsSvc_Distinguished$1,
    ComparisonRatingOptionsSvc_DistinguishedDesc: ComparisonRatingOptionsSvc_DistinguishedDesc$1,
    ComparisonRatingOptionsSvc_Emerging: ComparisonRatingOptionsSvc_Emerging$1,
    ComparisonRatingOptionsSvc_EmergingDesc: ComparisonRatingOptionsSvc_EmergingDesc$1,
    ComparisonRatingOptionsSvc_Experienced: ComparisonRatingOptionsSvc_Experienced$1,
    ComparisonRatingOptionsSvc_ExperiencedDesc: ComparisonRatingOptionsSvc_ExperiencedDesc$1,
    ComparisonRatingOptionsSvc_Master: ComparisonRatingOptionsSvc_Master$1,
    ComparisonRatingOptionsSvc_MasterDesc: ComparisonRatingOptionsSvc_MasterDesc$1,
    ComparisonRatingOptionsSvc_Novice: ComparisonRatingOptionsSvc_Novice$1,
    ComparisonRatingOptionsSvc_NoviceDesc: ComparisonRatingOptionsSvc_NoviceDesc$1,
    ComparisonCriteriaSvc_Accomplishments: ComparisonCriteriaSvc_Accomplishments$1,
    ComparisonCriteriaSvc_ProvidedInformation: ComparisonCriteriaSvc_ProvidedInformation$1,
    ComparisonCriteriaSvc_SkillBreadth: ComparisonCriteriaSvc_SkillBreadth$1,
    ComparisonCriteriaSvc_SkillMastery: ComparisonCriteriaSvc_SkillMastery$1,
    compareForm_CandidateHeader: compareForm_CandidateHeader$1,
    compareForm_CandidateLabel: compareForm_CandidateLabel$1,
    compareForm_DetailTitle: compareForm_DetailTitle$1,
    compareForm_Header: compareForm_Header$1,
    compareForm_Instructions: compareForm_Instructions$1,
    compareForm_Prompt: compareForm_Prompt$1,
    compareForm_SelectWinnerValidationMessage: compareForm_SelectWinnerValidationMessage$1,
    compareForm_SummaryTitle: compareForm_SummaryTitle$1,
    CommonMeta_AuthorContentTitle: CommonMeta_AuthorContentTitle$1,
    CommonMeta_CertificateDescription: CommonMeta_CertificateDescription$1,
    CommonMeta_CertificateTitle: CommonMeta_CertificateTitle$1,
    CommonMeta_DegreedInfo: CommonMeta_DegreedInfo$1,
    CommonMeta_EmptyProfileTitle: CommonMeta_EmptyProfileTitle$1,
    CommonMeta_ForMeDescription: CommonMeta_ForMeDescription$1,
    CommonMeta_ForMeTitle: CommonMeta_ForMeTitle$1,
    CommonMeta_LifelongDiploma: CommonMeta_LifelongDiploma$1,
    CommonMeta_PersonalProfileTitle: CommonMeta_PersonalProfileTitle$1,
    CommonMeta_PrivateProfileTitle: CommonMeta_PrivateProfileTitle$1,
    CommonMeta_ProfileOgTitle: CommonMeta_ProfileOgTitle$1,
    CommonMeta_TopicDescription: CommonMeta_TopicDescription$1,
    CommonMeta_TopicTitle: CommonMeta_TopicTitle$1,
    CommentsSvc_AccessError: CommentsSvc_AccessError$1,
    CommentsSvc_AccessRepliesError: CommentsSvc_AccessRepliesError$1,
    CommentsSvc_AddCommentError: CommentsSvc_AddCommentError$1,
    CommentsSvc_AddReplyError: CommentsSvc_AddReplyError$1,
    CommentsSvc_FlagCommentError: CommentsSvc_FlagCommentError$1,
    CommentsSvc_GetUsersError: CommentsSvc_GetUsersError$1,
    CommentsSvc_LikeError: CommentsSvc_LikeError$1,
    CommentsSvc_RemoveCommentError: CommentsSvc_RemoveCommentError$1,
    CommentsSvc_UpdateCommentError: CommentsSvc_UpdateCommentError$1,
    CommentsSvc_UsersTitle: CommentsSvc_UsersTitle$1,
    CommentsCtrl_DeleteComment: CommentsCtrl_DeleteComment$1,
    CommentsCtrl_DeleteCommentReplies: CommentsCtrl_DeleteCommentReplies$1,
    CommentsCtrl_DeletePost: CommentsCtrl_DeletePost$1,
    CommentsCtrl_EditPost: CommentsCtrl_EditPost$1,
    CommentsCtrl_Like: CommentsCtrl_Like$1,
    CommentsCtrl_Liked: CommentsCtrl_Liked$1,
    CommentsCtrl_PublicComment: CommentsCtrl_PublicComment$1,
    CommentsCtrl_PublicCommentDesc: CommentsCtrl_PublicCommentDesc$1,
    CommentsCtrl_Reply: CommentsCtrl_Reply$1,
    CommentsCtrl_Unlike: CommentsCtrl_Unlike$1,
    CommentsCtrl_ViewConversation: CommentsCtrl_ViewConversation$1,
    CommentsCtrl_YesDelete: CommentsCtrl_YesDelete$1,
    Coach_AddCoverAltFormat: Coach_AddCoverAltFormat$1,
    Coach_AddInputLabelText: Coach_AddInputLabelText$1,
    Coach_AddInputPlaceholder: Coach_AddInputPlaceholder$1,
    Coach_AdditionalFeedback: Coach_AdditionalFeedback$1,
    Coach_AddModalTitle: Coach_AddModalTitle$1,
    Coach_AddRequiredName: Coach_AddRequiredName$1,
    Coach_AllConversations: Coach_AllConversations$1,
    Coach_Capabilities: Coach_Capabilities$1,
    Coach_ChooseSkill: Coach_ChooseSkill$1,
    Coach_ChooseSkillNote: Coach_ChooseSkillNote$1,
    Coach_ClearChat: Coach_ClearChat$1,
    Coach_ClearChatHeader: Coach_ClearChatHeader$1,
    Coach_ClearChatMessage: Coach_ClearChatMessage$1,
    Coach_ClickToStart: Coach_ClickToStart$1,
    Coach_ComingSoon: Coach_ComingSoon$1,
    Coach_ConversationLoadError: Coach_ConversationLoadError$1,
    Coach_ConversationStartFailed: Coach_ConversationStartFailed$1,
    Coach_Copied: Coach_Copied$1,
    Coach_CopySuccess: Coach_CopySuccess$1,
    Coach_DefaultSkillReport: Coach_DefaultSkillReport$1,
    Coach_DeleteConversation: Coach_DeleteConversation$1,
    Coach_DeleteConversationAction: Coach_DeleteConversationAction$1,
    Coach_DeleteConversationMessage: Coach_DeleteConversationMessage$1,
    Coach_EndConversation: Coach_EndConversation$1,
    Coach_ErrorText: Coach_ErrorText$1,
    Coach_Evaluate: Coach_Evaluate$1,
    Coach_EvaluateNewSkill: Coach_EvaluateNewSkill$1,
    Coach_ExploreContent: Coach_ExploreContent$1,
    Coach_ExploreMaestro: Coach_ExploreMaestro$1,
    Coach_ExploreMentors: Coach_ExploreMentors$1,
    Coach_ExplorePathways: Coach_ExplorePathways$1,
    Coach_ExportError: Coach_ExportError$1,
    Coach_ExportSummary: Coach_ExportSummary$1,
    Coach_FeedbackForMessage: Coach_FeedbackForMessage$1,
    Coach_FeedbackHeader: Coach_FeedbackHeader$1,
    Coach_FeedbackOptionalText: Coach_FeedbackOptionalText$1,
    Coach_FeedbackUpdateError: Coach_FeedbackUpdateError$1,
    Coach_FeedbackUpdateSuccess: Coach_FeedbackUpdateSuccess$1,
    Coach_FormCtrlAreYouSure: Coach_FormCtrlAreYouSure$1,
    Coach_GenerateSummaryCTA: Coach_GenerateSummaryCTA$1,
    Coach_GenerateSummarySuccess: Coach_GenerateSummarySuccess$1,
    Coach_GeneratingRecommendationError: Coach_GeneratingRecommendationError$1,
    Coach_GeneratingSkillReport: Coach_GeneratingSkillReport$1,
    Coach_GeneratingSummary: Coach_GeneratingSummary$1,
    Coach_GetStarted: Coach_GetStarted$1,
    Coach_HiText: Coach_HiText$1,
    Coach_InputPlaceholder: Coach_InputPlaceholder$1,
    Coach_InstructionAllow: Coach_InstructionAllow$1,
    Coach_InstructionInterrupt: Coach_InstructionInterrupt$1,
    Coach_InstructionMicEnable: Coach_InstructionMicEnable$1,
    Coach_InstructionVolumeUp: Coach_InstructionVolumeUp$1,
    Coach_ModelAnalysis: Coach_ModelAnalysis$1,
    Coach_MuteMicrophone: Coach_MuteMicrophone$1,
    Coach_NewChat: Coach_NewChat$1,
    Coach_NoConversationText: Coach_NoConversationText$1,
    Coach_NoDataFound: Coach_NoDataFound$1,
    Coach_NoRecommendations: Coach_NoRecommendations$1,
    Coach_NoSummary: Coach_NoSummary$1,
    Coach_NotEnabledWarning: Coach_NotEnabledWarning$1,
    Coach_NoTranscriptsFound: Coach_NoTranscriptsFound$1,
    Coach_PinConversation: Coach_PinConversation$1,
    Coach_Pinned: Coach_Pinned$1,
    Coach_PlayPauseAllyText: Coach_PlayPauseAllyText$1,
    Coach_Prompts: Coach_Prompts$1,
    Coach_PromptsEmpty: Coach_PromptsEmpty$1,
    Coach_RecentConversations: Coach_RecentConversations$1,
    Coach_Recommendations: Coach_Recommendations$1,
    Coach_RecommendedContent: Coach_RecommendedContent$1,
    Coach_RecommendedMentors: Coach_RecommendedMentors$1,
    Coach_RecommendedPathways: Coach_RecommendedPathways$1,
    Coach_SelectSkill: Coach_SelectSkill$1,
    Coach_ShowAllCapabilities: Coach_ShowAllCapabilities$1,
    Coach_SkillEvaluationDuration: Coach_SkillEvaluationDuration$1,
    Coach_SkillLevelDescription: Coach_SkillLevelDescription$1,
    Coach_SkillReport: Coach_SkillReport$1,
    Coach_SkillReportModalHeader: Coach_SkillReportModalHeader$1,
    Coach_SkillReportModalSubHeader: Coach_SkillReportModalSubHeader$1,
    Coach_SkillReportSummaryHeader: Coach_SkillReportSummaryHeader$1,
    Coach_SkillReviewCompleted: Coach_SkillReviewCompleted$1,
    Coach_SpeakToInterrupt: Coach_SpeakToInterrupt$1,
    Coach_StartConversation: Coach_StartConversation$1,
    Coach_StartNewSkillReview: Coach_StartNewSkillReview$1,
    Coach_TextChatMode: Coach_TextChatMode$1,
    Coach_TextMode: Coach_TextMode$1,
    Coach_TotalPinned: Coach_TotalPinned$1,
    Coach_TrackAllConversations: Coach_TrackAllConversations$1,
    Coach_Transcript: Coach_Transcript$1,
    Coach_UnmuteMicrophone: Coach_UnmuteMicrophone$1,
    Coach_UpdateSkillRatings: Coach_UpdateSkillRatings$1,
    Coach_UploadContent: Coach_UploadContent$1,
    Coach_VideoTagNoSupport: Coach_VideoTagNoSupport$1,
    Coach_ViewMoreOptions: Coach_ViewMoreOptions$1,
    Coach_ViewSummary: Coach_ViewSummary$1,
    Coach_VirtualCoachHeader: Coach_VirtualCoachHeader$1,
    Coach_VoiceChatMode: Coach_VoiceChatMode$1,
    Coach_VoiceMode: Coach_VoiceMode$1,
    Coach_WelcomeBackText: Coach_WelcomeBackText$1,
    checkDuplicateInputs_Decision: checkDuplicateInputs_Decision$1,
    checkDuplicateInputs_DuplicatesFoundPlural: checkDuplicateInputs_DuplicatesFoundPlural$1,
    checkDuplicateInputs_DuplicatesFoundSingle: checkDuplicateInputs_DuplicatesFoundSingle$1,
    checkDuplicateInputs_ViewDuplicates: checkDuplicateInputs_ViewDuplicates$1,
    ChartsModule_MinimumSkillUserCountEmptyStateText_Description: ChartsModule_MinimumSkillUserCountEmptyStateText_Description$1,
    ChartsModule_MinimumSkillUserCountEmptyStateText_Header: ChartsModule_MinimumSkillUserCountEmptyStateText_Header$1,
    CertificateFormCtrl_AddCertificate: CertificateFormCtrl_AddCertificate$1,
    CertificateFormCtrl_CertificateNumber: CertificateFormCtrl_CertificateNumber$1,
    CertificateFormCtrl_EndAfterStart: CertificateFormCtrl_EndAfterStart$1,
    CertificateFormCtrl_ExpirationDate: CertificateFormCtrl_ExpirationDate$1,
    CertificateFormCtrl_ExpiryDate: CertificateFormCtrl_ExpiryDate$1,
    CertificateFormCtrl_IssueDate: CertificateFormCtrl_IssueDate$1,
    CertificateFormCtrl_IssuerName: CertificateFormCtrl_IssuerName$1,
    CertificateFormCtrl_IssuerNameRequired: CertificateFormCtrl_IssuerNameRequired$1,
    CertificateFormCtrl_IssuerURL: CertificateFormCtrl_IssuerURL$1,
    CertificateFormCtrl_SaveCertificate: CertificateFormCtrl_SaveCertificate$1,
    CertificateFormCtrl_StartDate: CertificateFormCtrl_StartDate$1,
    CertificateFormCtrl_TitleRequired: CertificateFormCtrl_TitleRequired$1,
    BusinessRules_AcmAddUser: BusinessRules_AcmAddUser$1,
    BusinessRules_AcmDeleteUser: BusinessRules_AcmDeleteUser$1,
    BusinessRules_ActionType: BusinessRules_ActionType$1,
    BusinessRules_AddAction: BusinessRules_AddAction$1,
    BusinessRules_AddAttribute: BusinessRules_AddAttribute$1,
    BusinessRules_AddCondition: BusinessRules_AddCondition$1,
    BusinessRules_AddProviderLicense: BusinessRules_AddProviderLicense$1,
    BusinessRules_AddRole: BusinessRules_AddRole$1,
    BusinessRules_AddRule: BusinessRules_AddRule$1,
    BusinessRules_AddSegments: BusinessRules_AddSegments$1,
    BusinessRules_AddSkill: BusinessRules_AddSkill$1,
    BusinessRules_AddSkillPlan: BusinessRules_AddSkillPlan$1,
    BusinessRules_AddToGroup: BusinessRules_AddToGroup$1,
    BusinessRules_AddToPathway: BusinessRules_AddToPathway$1,
    BusinessRules_And: BusinessRules_And$1,
    BusinessRules_ApplyToAllUsers: BusinessRules_ApplyToAllUsers$1,
    BusinessRules_ApplyToNewUsers: BusinessRules_ApplyToNewUsers$1,
    BusinessRules_AreYouSure_DeleteSegments_Format: BusinessRules_AreYouSure_DeleteSegments_Format$1,
    BusinessRules_AssignResource: BusinessRules_AssignResource$1,
    BusinessRules_AttributeInstructions: BusinessRules_AttributeInstructions$1,
    BusinessRules_AttributeName: BusinessRules_AttributeName$1,
    BusinessRules_Attributes_Column: BusinessRules_Attributes_Column$1,
    BusinessRules_AttributeValue: BusinessRules_AttributeValue$1,
    BusinessRules_BeyondDaysAgo: BusinessRules_BeyondDaysAgo$1,
    BusinessRules_CloneSegment: BusinessRules_CloneSegment$1,
    BusinessRules_CloneSegmentFormat: BusinessRules_CloneSegmentFormat$1,
    BusinessRules_Condition: BusinessRules_Condition$1,
    BusinessRules_Conditions_Column: BusinessRules_Conditions_Column$1,
    BusinessRules_Contains: BusinessRules_Contains$1,
    BusinessRules_CreateARule: BusinessRules_CreateARule$1,
    BusinessRules_CreateASegment: BusinessRules_CreateASegment$1,
    BusinessRules_CreateSegment: BusinessRules_CreateSegment$1,
    BusinessRules_DateCreated_Column: BusinessRules_DateCreated_Column$1,
    BusinessRules_DaysAgo: BusinessRules_DaysAgo$1,
    BusinessRules_DeleteModalBody_Format: BusinessRules_DeleteModalBody_Format$1,
    BusinessRules_DeleteSegments: BusinessRules_DeleteSegments$1,
    BusinessRules_DeleteUser: BusinessRules_DeleteUser$1,
    BusinessRules_DoesNotEqual: BusinessRules_DoesNotEqual$1,
    BusinessRules_EditRule: BusinessRules_EditRule$1,
    BusinessRules_EditSegment: BusinessRules_EditSegment$1,
    BusinessRules_Equals: BusinessRules_Equals$1,
    BusinessRules_Error_DuplicateRuleName: BusinessRules_Error_DuplicateRuleName$1,
    BusinessRules_GreaterOrEqual: BusinessRules_GreaterOrEqual$1,
    BusinessRules_GreaterThan: BusinessRules_GreaterThan$1,
    BusinessRules_If: BusinessRules_If$1,
    BusinessRules_LesserOrEqual: BusinessRules_LesserOrEqual$1,
    BusinessRules_LessThan: BusinessRules_LessThan$1,
    BusinessRules_ManageSegments: BusinessRules_ManageSegments$1,
    BusinessRules_NA: BusinessRules_NA$1,
    BusinessRules_NewItem_Format_AddNewSkill: BusinessRules_NewItem_Format_AddNewSkill$1,
    BusinessRules_NotifyUser: BusinessRules_NotifyUser$1,
    BusinessRules_Operator: BusinessRules_Operator$1,
    BusinessRules_PrivacyOutcomeWarning: BusinessRules_PrivacyOutcomeWarning$1,
    BusinessRules_Qualifier: BusinessRules_Qualifier$1,
    BusinessRules_RemoveAction: BusinessRules_RemoveAction$1,
    BusinessRules_RemoveCondition: BusinessRules_RemoveCondition$1,
    BusinessRules_RuleError_Description: BusinessRules_RuleError_Description$1,
    BusinessRules_RuleError_Tooltip: BusinessRules_RuleError_Tooltip$1,
    BusinessRules_RuleName: BusinessRules_RuleName$1,
    BusinessRules_SearchForProviderLicense: BusinessRules_SearchForProviderLicense$1,
    BusinessRules_SearchForRole: BusinessRules_SearchForRole$1,
    BusinessRules_SearchForSkill: BusinessRules_SearchForSkill$1,
    BusinessRules_SearchForSkillPlan: BusinessRules_SearchForSkillPlan$1,
    BusinessRules_SegmentName: BusinessRules_SegmentName$1,
    BusinessRules_SegmentNamePlaceholder: BusinessRules_SegmentNamePlaceholder$1,
    BusinessRules_SegmentsDeleted_Toast: BusinessRules_SegmentsDeleted_Toast$1,
    BusinessRules_SegmentSearch_Placeholder: BusinessRules_SegmentSearch_Placeholder$1,
    BusinessRules_SelectASegment: BusinessRules_SelectASegment$1,
    BusinessRules_SelectSegment: BusinessRules_SelectSegment$1,
    BusinessRules_SendEmail: BusinessRules_SendEmail$1,
    BusinessRules_SendNotification: BusinessRules_SendNotification$1,
    BusinessRules_SetProfilePrivacy: BusinessRules_SetProfilePrivacy$1,
    BusinessRules_ShareResource: BusinessRules_ShareResource$1,
    BusinessRules_Then: BusinessRules_Then$1,
    BusinessRules_ToggleActiveModalBody_ToDisable_Format: BusinessRules_ToggleActiveModalBody_ToDisable_Format$1,
    BusinessRules_ToggleActiveModalBody_ToEnable_Format: BusinessRules_ToggleActiveModalBody_ToEnable_Format$1,
    BusinessRules_ToggleActiveModalConfirm_ToDisable: BusinessRules_ToggleActiveModalConfirm_ToDisable$1,
    BusinessRules_ToggleActiveModalConfirm_ToEnable: BusinessRules_ToggleActiveModalConfirm_ToEnable$1,
    BusinessRules_ToggleActiveModalHeader_ToDisable: BusinessRules_ToggleActiveModalHeader_ToDisable$1,
    BusinessRules_ToggleActiveModalHeader_ToEnable: BusinessRules_ToggleActiveModalHeader_ToEnable$1,
    BusinessRules_Trigger_Column: BusinessRules_Trigger_Column$1,
    BusinessRules_Value: BusinessRules_Value$1,
    BusinessRules_WithinDaysAgo: BusinessRules_WithinDaysAgo$1,
    bulkUpdateModal_Cancel: bulkUpdateModal_Cancel$1,
    bulkUpdateModal_CancelProcessing: bulkUpdateModal_CancelProcessing$1,
    bulkUpdateModal_CreateGroups: bulkUpdateModal_CreateGroups$1,
    bulkUpdateModal_CreateGroupsSuccess: bulkUpdateModal_CreateGroupsSuccess$1,
    bulkUpdateModal_CreateRoles: bulkUpdateModal_CreateRoles$1,
    bulkUpdateModal_DownloadTemplate: bulkUpdateModal_DownloadTemplate$1,
    bulkUpdateModal_DuplicateRow: bulkUpdateModal_DuplicateRow$1,
    bulkUpdateModal_DuplicateRowPluralFormat: bulkUpdateModal_DuplicateRowPluralFormat$1,
    bulkUpdateModal_EmptyContentType: bulkUpdateModal_EmptyContentType$1,
    bulkUpdateModal_EmptyContentTypePluralFormat: bulkUpdateModal_EmptyContentTypePluralFormat$1,
    bulkUpdateModal_EmptyUpdateType: bulkUpdateModal_EmptyUpdateType$1,
    bulkUpdateModal_EmptyUpdateTypePluralFormat: bulkUpdateModal_EmptyUpdateTypePluralFormat$1,
    bulkUpdateModal_ExcelImported: bulkUpdateModal_ExcelImported$1,
    bulkUpdateModal_FileIsEmpty: bulkUpdateModal_FileIsEmpty$1,
    bulkUpdateModal_FileName: bulkUpdateModal_FileName$1,
    bulkUpdateModal_FirstRow: bulkUpdateModal_FirstRow$1,
    bulkUpdateModal_HeadingGroups: bulkUpdateModal_HeadingGroups$1,
    bulkUpdateModal_HeadingRolePlans: bulkUpdateModal_HeadingRolePlans$1,
    bulkUpdateModal_MaximumRowWidthExceeded: bulkUpdateModal_MaximumRowWidthExceeded$1,
    bulkUpdateModal_MaximumRowWidthExceededPluralFormat: bulkUpdateModal_MaximumRowWidthExceededPluralFormat$1,
    bulkUpdateModal_MissingRequiredColumn: bulkUpdateModal_MissingRequiredColumn$1,
    bulkUpdateModal_MissingRequiredColumnPluralFormat: bulkUpdateModal_MissingRequiredColumnPluralFormat$1,
    bulkUpdateModal_NotAppearRightAway: bulkUpdateModal_NotAppearRightAway$1,
    bulkUpdateModal_RowsAccepted: bulkUpdateModal_RowsAccepted$1,
    bulkUpdateModal_RowsFound: bulkUpdateModal_RowsFound$1,
    bulkUpdateModal_RowsWithErrors: bulkUpdateModal_RowsWithErrors$1,
    bulkUpdateModal_Save: bulkUpdateModal_Save$1,
    bulkUpdateModal_SelectAFile: bulkUpdateModal_SelectAFile$1,
    bulkUpdateModal_SuccessfulUpload: bulkUpdateModal_SuccessfulUpload$1,
    bulkUpdateModal_TotalRows: bulkUpdateModal_TotalRows$1,
    bulkUpdateModal_UnknownContentType: bulkUpdateModal_UnknownContentType$1,
    bulkUpdateModal_UnknownContentTypePluralFormat: bulkUpdateModal_UnknownContentTypePluralFormat$1,
    bulkUpdateModal_UnknownDataType: bulkUpdateModal_UnknownDataType$1,
    bulkUpdateModal_UnknownDataTypePluralFormat: bulkUpdateModal_UnknownDataTypePluralFormat$1,
    bulkUpdateModal_UnsupportedFileContentType: bulkUpdateModal_UnsupportedFileContentType$1,
    bulkUpdateModal_UnsupportedFileContentTypePluralFormat: bulkUpdateModal_UnsupportedFileContentTypePluralFormat$1,
    bulkUpdateModal_UploadAFile: bulkUpdateModal_UploadAFile$1,
    bulkUpdateModal_WillSendEmail: bulkUpdateModal_WillSendEmail$1,
    BreadcrumbSvc_DownloadableReports: BreadcrumbSvc_DownloadableReports$1,
    BreadcrumbSvc_Enrolled: BreadcrumbSvc_Enrolled$1,
    BreadcrumbSvc_Insights: BreadcrumbSvc_Insights$1,
    BreadcrumbSvc_LessonFormat: BreadcrumbSvc_LessonFormat$1,
    BreadcrumbSvc_SectionFormat: BreadcrumbSvc_SectionFormat$1,
    BooksSvc_ErrorMatchingBooks: BooksSvc_ErrorMatchingBooks$1,
    BookFormCtrl_AddBook: BookFormCtrl_AddBook$1,
    BookFormCtrl_AddCategory: BookFormCtrl_AddCategory$1,
    BookFormCtrl_BookCoverAltFormat: BookFormCtrl_BookCoverAltFormat$1,
    BookFormCtrl_BookLength: BookFormCtrl_BookLength$1,
    BookFormCtrl_BookSearchError: BookFormCtrl_BookSearchError$1,
    BookFormCtrl_BookTitle: BookFormCtrl_BookTitle$1,
    BookFormCtrl_DatePublished: BookFormCtrl_DatePublished$1,
    BookFormCtrl_DateRead: BookFormCtrl_DateRead$1,
    BookFormCtrl_EditBook: BookFormCtrl_EditBook$1,
    BookFormCtrl_IWroteThis: BookFormCtrl_IWroteThis$1,
    BookFormCtrl_Length: BookFormCtrl_Length$1,
    BookFormCtrl_Pages: BookFormCtrl_Pages$1,
    BookFormCtrl_SaveBook: BookFormCtrl_SaveBook$1,
    BookFormCtrl_SelectBook: BookFormCtrl_SelectBook$1,
    BookFormCtrl_Title: BookFormCtrl_Title$1,
    BookFormCtrl_WhatDidYouLearnLong: BookFormCtrl_WhatDidYouLearnLong$1,
    BookFormCtrl_WhatDidYouLearnShort: BookFormCtrl_WhatDidYouLearnShort$1,
    behaviorModal_Heading1: behaviorModal_Heading1$1,
    behaviorModal_Heading2: behaviorModal_Heading2$1,
    behaviorModal_Heading3: behaviorModal_Heading3$1,
    behaviorModal_Instructions: behaviorModal_Instructions$1,
    behaviorModal_Instructions1: behaviorModal_Instructions1$1,
    behaviorModal_Instructions2: behaviorModal_Instructions2$1,
    behaviorModal_Instructions3: behaviorModal_Instructions3$1,
    behaviorModal_Instructions4: behaviorModal_Instructions4$1,
    behaviorModal_Instructions5: behaviorModal_Instructions5$1,
    behaviorModal_Instructions6: behaviorModal_Instructions6$1,
    behaviorModal_Instructions7: behaviorModal_Instructions7$1,
    behaviorModal_Instructions8: behaviorModal_Instructions8$1,
    behaviorModalVM_Instructions: behaviorModalVM_Instructions$1,
    behaviorForm_AddEvidence: behaviorForm_AddEvidence$1,
    behaviorForm_AppliedForFormat: behaviorForm_AppliedForFormat$1,
    behaviorForm_B1Credential: behaviorForm_B1Credential$1,
    behaviorForm_B1Evidence: behaviorForm_B1Evidence$1,
    behaviorForm_B1Example: behaviorForm_B1Example$1,
    behaviorForm_B1Process: behaviorForm_B1Process$1,
    behaviorForm_B1Title: behaviorForm_B1Title$1,
    behaviorForm_B2Credential: behaviorForm_B2Credential$1,
    behaviorForm_B2Example: behaviorForm_B2Example$1,
    behaviorForm_B2Process: behaviorForm_B2Process$1,
    behaviorForm_B2Title: behaviorForm_B2Title$1,
    behaviorForm_B3Credential: behaviorForm_B3Credential$1,
    behaviorForm_B3Evidence: behaviorForm_B3Evidence$1,
    behaviorForm_B3Example: behaviorForm_B3Example$1,
    behaviorForm_B3Process: behaviorForm_B3Process$1,
    behaviorForm_B3Title: behaviorForm_B3Title$1,
    behaviorForm_behaviorInstruction: behaviorForm_behaviorInstruction$1,
    behaviorForm_behaviorsInstruction: behaviorForm_behaviorsInstruction$1,
    behaviorForm_BehaviorStatementsDemo: behaviorForm_BehaviorStatementsDemo$1,
    behaviorForm_BehaviorStatementsDemoHeader: behaviorForm_BehaviorStatementsDemoHeader$1,
    behaviorForm_EditTitle: behaviorForm_EditTitle$1,
    behaviorForm_EvaluationCriteria: behaviorForm_EvaluationCriteria$1,
    behaviorForm_EvaluationCriteriaHeader: behaviorForm_EvaluationCriteriaHeader$1,
    behaviorForm_ExampleLabel: behaviorForm_ExampleLabel$1,
    behaviorForm_ExamplePlaceholder: behaviorForm_ExamplePlaceholder$1,
    behaviorForm_Header1: behaviorForm_Header1$1,
    behaviorForm_Header2: behaviorForm_Header2$1,
    behaviorForm_Header3: behaviorForm_Header3$1,
    behaviorForm_ProcessLabel: behaviorForm_ProcessLabel$1,
    behaviorForm_ProcessPlaceholder: behaviorForm_ProcessPlaceholder$1,
    behaviorForm_ProvideMoreInfo: behaviorForm_ProvideMoreInfo$1,
    behaviorForm_ReadMore: behaviorForm_ReadMore$1,
    behaviorForm_ShowDemos: behaviorForm_ShowDemos$1,
    behaviorForm_ShowEvalCriteria: behaviorForm_ShowEvalCriteria$1,
    behaviorForm_TitleLabel: behaviorForm_TitleLabel$1,
    behaviorForm_TitleLabel1: behaviorForm_TitleLabel1$1,
    behaviorForm_TitleLabel2: behaviorForm_TitleLabel2$1,
    behaviorForm_TitleLabel3: behaviorForm_TitleLabel3$1,
    behaviorForm_TitlePlaceholder: behaviorForm_TitlePlaceholder$1,
    behaviorForm_ValidationMessage: behaviorForm_ValidationMessage$1,
    Banner_IE11Body: Banner_IE11Body$1,
    Banner_IE11Title: Banner_IE11Title$1,
    Banner_LoggedOutCTA: Banner_LoggedOutCTA$1,
    Banner_LoggedOutCTAButton: Banner_LoggedOutCTAButton$1,
    BadgeFormCtrl_BadgeHelpText: BadgeFormCtrl_BadgeHelpText$1,
    BadgeFormCtrl_BadgeInfoText: BadgeFormCtrl_BadgeInfoText$1,
    BadgeFormCtrl_BadgeInvalidBadge: BadgeFormCtrl_BadgeInvalidBadge$1,
    BadgeFormCtrl_BadgeUrl: BadgeFormCtrl_BadgeUrl$1,
    AwardFormCtrl_AddAward: AwardFormCtrl_AddAward$1,
    AwardFormCtrl_AwardDate: AwardFormCtrl_AwardDate$1,
    AwardFormCtrl_AwardDateLabel: AwardFormCtrl_AwardDateLabel$1,
    AwardFormCtrl_AwardIssuer: AwardFormCtrl_AwardIssuer$1,
    AwardFormCtrl_AwardTitle: AwardFormCtrl_AwardTitle$1,
    AwardFormCtrl_AwardTitleLabel: AwardFormCtrl_AwardTitleLabel$1,
    AwardFormCtrl_SaveAward: AwardFormCtrl_SaveAward$1,
    Automation_AcademyConditions: Automation_AcademyConditions$1,
    Automation_AcademyConditions_Description: Automation_AcademyConditions_Description$1,
    Automation_AcademyName: Automation_AcademyName$1,
    Automation_AcademyStatus_Completed: Automation_AcademyStatus_Completed$1,
    Automation_AcademyStatus_Dropped: Automation_AcademyStatus_Dropped$1,
    Automation_AcademyStatus_InProgress: Automation_AcademyStatus_InProgress$1,
    Automation_AcademyStatus_NotStarted: Automation_AcademyStatus_NotStarted$1,
    Automation_AcmAddUser_Format: Automation_AcmAddUser_Format$1,
    Automation_AcmDeleteUser_Format: Automation_AcmDeleteUser_Format$1,
    Automation_AcmSelectRole: Automation_AcmSelectRole$1,
    Automation_Action: Automation_Action$1,
    Automation_Action_Delete: Automation_Action_Delete$1,
    Automation_Action_Insert: Automation_Action_Insert$1,
    Automation_Action_Update: Automation_Action_Update$1,
    Automation_ActionDeleted: Automation_ActionDeleted$1,
    Automation_ActionDesc: Automation_ActionDesc$1,
    Automation_ActionHasBeenAdded: Automation_ActionHasBeenAdded$1,
    Automation_ActionHasNotBeenAdded: Automation_ActionHasNotBeenAdded$1,
    Automation_ActionLabel_Group: Automation_ActionLabel_Group$1,
    Automation_ActionLabel_Pathway: Automation_ActionLabel_Pathway$1,
    Automation_ActionLabel_PermissionRole: Automation_ActionLabel_PermissionRole$1,
    Automation_ActionLabel_Privacy: Automation_ActionLabel_Privacy$1,
    Automation_ActionLabel_Provider: Automation_ActionLabel_Provider$1,
    Automation_ActionLabel_Skill: Automation_ActionLabel_Skill$1,
    Automation_ActionLabel_Target: Automation_ActionLabel_Target$1,
    Automation_ActionNoConfigurationNeeded: Automation_ActionNoConfigurationNeeded$1,
    Automation_Actions: Automation_Actions$1,
    Automation_AddAcademyCondition: Automation_AddAcademyCondition$1,
    Automation_AddGroupCondition: Automation_AddGroupCondition$1,
    Automation_AddProviderLicense_Format: Automation_AddProviderLicense_Format$1,
    Automation_AddRole_Format: Automation_AddRole_Format$1,
    Automation_AddSkill_Format: Automation_AddSkill_Format$1,
    Automation_AddSkillCondition: Automation_AddSkillCondition$1,
    Automation_AddSkillPlan_Format: Automation_AddSkillPlan_Format$1,
    Automation_AddToGroup_Format: Automation_AddToGroup_Format$1,
    Automation_AddToPathway_Format: Automation_AddToPathway_Format$1,
    Automation_AreYouSure_DeleteAutomations_Format: Automation_AreYouSure_DeleteAutomations_Format$1,
    Automation_AssignedBy_Format: Automation_AssignedBy_Format$1,
    Automation_AssignedByInDays_Format: Automation_AssignedByInDays_Format$1,
    Automation_AssignResource_Format: Automation_AssignResource_Format$1,
    Automation_AttributeValue_HelperText: Automation_AttributeValue_HelperText$1,
    Automation_Automation: Automation_Automation$1,
    Automation_AutomationBuilder: Automation_AutomationBuilder$1,
    Automation_AutomationCreated: Automation_AutomationCreated$1,
    Automation_AutomationDetails: Automation_AutomationDetails$1,
    Automation_AutomationDisabled: Automation_AutomationDisabled$1,
    Automation_AutomationEnabled: Automation_AutomationEnabled$1,
    Automation_AutomationLastUpdated: Automation_AutomationLastUpdated$1,
    Automation_AutomationName: Automation_AutomationName$1,
    Automation_Automations: Automation_Automations$1,
    Automation_AutomationUpdated: Automation_AutomationUpdated$1,
    Automation_BulkEnable_SomeRulesInvalidWarning: Automation_BulkEnable_SomeRulesInvalidWarning$1,
    Automation_CadenceDailyTime_Format: Automation_CadenceDailyTime_Format$1,
    Automation_CadenceDateTime_Format: Automation_CadenceDateTime_Format$1,
    Automation_CadenceDayOfTime_Format: Automation_CadenceDayOfTime_Format$1,
    Automation_CadenceOnceTime_Format: Automation_CadenceOnceTime_Format$1,
    Automation_CannotEnableAtThisTime: Automation_CannotEnableAtThisTime$1,
    Automation_ChangeDetails: Automation_ChangeDetails$1,
    Automation_ChangedTo: Automation_ChangedTo$1,
    Automation_Changes: Automation_Changes$1,
    Automation_Changes_Format: Automation_Changes_Format$1,
    Automation_CloneAutomation: Automation_CloneAutomation$1,
    Automation_CloneAutomationFormat: Automation_CloneAutomationFormat$1,
    Automation_Communication: Automation_Communication$1,
    Automation_ConditionHelp: Automation_ConditionHelp$1,
    Automation_ConditionsLimit: Automation_ConditionsLimit$1,
    Automation_CreateAnAutomation: Automation_CreateAnAutomation$1,
    Automation_CreateYourFirst_Description: Automation_CreateYourFirst_Description$1,
    Automation_CreateYourFirst_Header: Automation_CreateYourFirst_Header$1,
    Automation_CurrentlyEditingTitleAndDescription: Automation_CurrentlyEditingTitleAndDescription$1,
    Automation_CurrentlyEditingTriggers: Automation_CurrentlyEditingTriggers$1,
    Automation_DateUpdated: Automation_DateUpdated$1,
    Automation_DeleteAction: Automation_DeleteAction$1,
    Automation_DeleteActionConfirmation: Automation_DeleteActionConfirmation$1,
    Automation_DeleteAutomation: Automation_DeleteAutomation$1,
    Automation_DeleteAutomations: Automation_DeleteAutomations$1,
    Automation_DeleteConditions: Automation_DeleteConditions$1,
    Automation_DeleteConditions_Confirmation: Automation_DeleteConditions_Confirmation$1,
    Automation_DeleteOnlyActionConfirmation: Automation_DeleteOnlyActionConfirmation$1,
    Automation_DeleteUser_Format: Automation_DeleteUser_Format$1,
    Automation_Description: Automation_Description$1,
    Automation_Description_Delete: Automation_Description_Delete$1,
    Automation_Description_Insert: Automation_Description_Insert$1,
    Automation_Description_Update: Automation_Description_Update$1,
    Automation_DisableAutomations: Automation_DisableAutomations$1,
    Automation_DisableAutomations_Format: Automation_DisableAutomations_Format$1,
    Automation_DueDate_None: Automation_DueDate_None$1,
    Automation_DueDate_Relative: Automation_DueDate_Relative$1,
    Automation_DueDate_Specific: Automation_DueDate_Specific$1,
    Automation_EditableAttributeWarning: Automation_EditableAttributeWarning$1,
    Automation_EditableAttributeWarning_Format: Automation_EditableAttributeWarning_Format$1,
    Automation_EditAutomation: Automation_EditAutomation$1,
    Automation_EditTitleAndDescription: Automation_EditTitleAndDescription$1,
    Automation_EditTrigger: Automation_EditTrigger$1,
    Automation_EnableAutomation: Automation_EnableAutomation$1,
    Automation_EnableAutomationDescription: Automation_EnableAutomationDescription$1,
    Automation_EnableAutomations: Automation_EnableAutomations$1,
    Automation_EnableAutomations_Format: Automation_EnableAutomations_Format$1,
    Automation_EnabledOrDisabled: Automation_EnabledOrDisabled$1,
    Automation_Event_ContentCompleted: Automation_Event_ContentCompleted$1,
    Automation_Event_GroupJoined: Automation_Event_GroupJoined$1,
    Automation_Event_MentorshipCompleted: Automation_Event_MentorshipCompleted$1,
    Automation_Event_OnboardingCompleted: Automation_Event_OnboardingCompleted$1,
    Automation_Event_OpportunityMentorRequested: Automation_Event_OpportunityMentorRequested$1,
    Automation_Event_PathwayCompleted: Automation_Event_PathwayCompleted$1,
    Automation_Event_PathwayEnrolled: Automation_Event_PathwayEnrolled$1,
    Automation_Event_PlanFollowed: Automation_Event_PlanFollowed$1,
    Automation_Event_ProviderLicenseAssign: Automation_Event_ProviderLicenseAssign$1,
    Automation_Event_UserAddsSkill: Automation_Event_UserAddsSkill$1,
    Automation_Event_UserUpdatestoFocusSkill: Automation_Event_UserUpdatestoFocusSkill$1,
    Automation_FormerUser: Automation_FormerUser$1,
    Automation_GroupConditions: Automation_GroupConditions$1,
    Automation_GroupNameHelper: Automation_GroupNameHelper$1,
    Automation_HistoryAvailableNotification: Automation_HistoryAvailableNotification$1,
    Automation_HistoryLastUpdated: Automation_HistoryLastUpdated$1,
    Automation_IsNotOneOf: Automation_IsNotOneOf$1,
    Automation_IsOneOf: Automation_IsOneOf$1,
    Automation_Log_Detail_Entry_Format: Automation_Log_Detail_Entry_Format$1,
    Automation_LogTable_Summary: Automation_LogTable_Summary$1,
    Automation_Name_Delete: Automation_Name_Delete$1,
    Automation_Name_Insert: Automation_Name_Insert$1,
    Automation_Name_Update: Automation_Name_Update$1,
    Automation_NameAndDescription: Automation_NameAndDescription$1,
    Automation_NewAutomation: Automation_NewAutomation$1,
    Automation_NoDescription: Automation_NoDescription$1,
    Automation_NotificationSubject: Automation_NotificationSubject$1,
    Automation_NotifyUser_Format: Automation_NotifyUser_Format$1,
    Automation_NoWarning: Automation_NoWarning$1,
    Automation_Or_List_Format: Automation_Or_List_Format$1,
    Automation_Outcome_Delete: Automation_Outcome_Delete$1,
    Automation_Outcome_Insert: Automation_Outcome_Insert$1,
    Automation_Outcome_Update: Automation_Outcome_Update$1,
    Automation_Predicate_Delete: Automation_Predicate_Delete$1,
    Automation_Predicate_Insert: Automation_Predicate_Insert$1,
    Automation_Predicate_Update: Automation_Predicate_Update$1,
    Automation_PredicateLabel_ContentCompleted: Automation_PredicateLabel_ContentCompleted$1,
    Automation_PredicateLabel_GroupJoined: Automation_PredicateLabel_GroupJoined$1,
    Automation_PredicateLabel_MentorshipCompleted: Automation_PredicateLabel_MentorshipCompleted$1,
    Automation_PredicateLabel_PathwayCompleted: Automation_PredicateLabel_PathwayCompleted$1,
    Automation_PredicateLabel_PathwayEnrolled: Automation_PredicateLabel_PathwayEnrolled$1,
    Automation_PredicateLabel_PlanFollowed: Automation_PredicateLabel_PlanFollowed$1,
    Automation_PredicateLabel_ProviderLicenseAssign: Automation_PredicateLabel_ProviderLicenseAssign$1,
    Automation_PredicateLabel_UserAddsSkill: Automation_PredicateLabel_UserAddsSkill$1,
    Automation_PredicateLabel_UserUpdatestoFocusSkill: Automation_PredicateLabel_UserUpdatestoFocusSkill$1,
    Automation_PredicateType_Academy: Automation_PredicateType_Academy$1,
    Automation_PredicateType_Attribute: Automation_PredicateType_Attribute$1,
    Automation_PredicateType_Description_Academy: Automation_PredicateType_Description_Academy$1,
    Automation_PredicateType_Description_Attribute: Automation_PredicateType_Description_Attribute$1,
    Automation_PredicateType_Description_Group: Automation_PredicateType_Description_Group$1,
    Automation_PredicateType_Description_Skill: Automation_PredicateType_Description_Skill$1,
    Automation_PredicateType_Group: Automation_PredicateType_Group$1,
    Automation_PredicateType_Skill: Automation_PredicateType_Skill$1,
    Automation_RemoveCondition_Format: Automation_RemoveCondition_Format$1,
    Automation_RemoveEmptyCondition: Automation_RemoveEmptyCondition$1,
    Automation_SaveOrCancelFirst: Automation_SaveOrCancelFirst$1,
    Automation_Schedule_Cadence: Automation_Schedule_Cadence$1,
    Automation_Schedule_Daily: Automation_Schedule_Daily$1,
    Automation_Schedule_Daily_Format: Automation_Schedule_Daily_Format$1,
    Automation_Schedule_Date: Automation_Schedule_Date$1,
    Automation_Schedule_Day: Automation_Schedule_Day$1,
    Automation_Schedule_Last: Automation_Schedule_Last$1,
    Automation_Schedule_LastDayOfMonth: Automation_Schedule_LastDayOfMonth$1,
    Automation_Schedule_Monthly: Automation_Schedule_Monthly$1,
    Automation_Schedule_Monthly_Format: Automation_Schedule_Monthly_Format$1,
    Automation_Schedule_Once: Automation_Schedule_Once$1,
    Automation_Schedule_Once_Format: Automation_Schedule_Once_Format$1,
    Automation_Schedule_Ordinal_1: Automation_Schedule_Ordinal_1$1,
    Automation_Schedule_Ordinal_10: Automation_Schedule_Ordinal_10$1,
    Automation_Schedule_Ordinal_15: Automation_Schedule_Ordinal_15$1,
    Automation_Schedule_Ordinal_20: Automation_Schedule_Ordinal_20$1,
    Automation_Schedule_Ordinal_25: Automation_Schedule_Ordinal_25$1,
    Automation_Schedule_Ordinal_5: Automation_Schedule_Ordinal_5$1,
    Automation_Schedule_SelectCadence: Automation_Schedule_SelectCadence$1,
    Automation_Schedule_SelectDate: Automation_Schedule_SelectDate$1,
    Automation_Schedule_SelectDay: Automation_Schedule_SelectDay$1,
    Automation_Schedule_SelectTime: Automation_Schedule_SelectTime$1,
    Automation_Schedule_TimeUTC: Automation_Schedule_TimeUTC$1,
    Automation_Schedule_Weekly: Automation_Schedule_Weekly$1,
    Automation_Schedule_Weekly_Format: Automation_Schedule_Weekly_Format$1,
    Automation_Search_Placeholder: Automation_Search_Placeholder$1,
    Automation_SearchAcademy: Automation_SearchAcademy$1,
    Automation_SelectAction: Automation_SelectAction$1,
    Automation_SelectConditionType: Automation_SelectConditionType$1,
    Automation_SelectConditionType_Description: Automation_SelectConditionType_Description$1,
    Automation_SelectSkillCondition: Automation_SelectSkillCondition$1,
    Automation_SelectStatuses: Automation_SelectStatuses$1,
    Automation_SelectTrigger: Automation_SelectTrigger$1,
    Automation_SendEmail_Format: Automation_SendEmail_Format$1,
    Automation_SetProfilePrivacy_Format: Automation_SetProfilePrivacy_Format$1,
    Automation_SharedBy_Format: Automation_SharedBy_Format$1,
    Automation_ShareResource_Format: Automation_ShareResource_Format$1,
    Automation_SkillCondition: Automation_SkillCondition$1,
    Automation_SkillCondition_AddOptionalSkills: Automation_SkillCondition_AddOptionalSkills$1,
    Automation_SkillConditions: Automation_SkillConditions$1,
    Automation_SkillConditions_Description: Automation_SkillConditions_Description$1,
    Automation_SkillName: Automation_SkillName$1,
    Automation_SkillNameHelper: Automation_SkillNameHelper$1,
    Automation_SkillOperator_hasnofocusskills: Automation_SkillOperator_hasnofocusskills$1,
    Automation_SkillOperator_hasnoskillrating: Automation_SkillOperator_hasnoskillrating$1,
    Automation_SkillOperator_hasnoskills: Automation_SkillOperator_hasnoskills$1,
    Automation_SkillOperator_hasnoskillsrating: Automation_SkillOperator_hasnoskillsrating$1,
    Automation_SkillTimeFrame: Automation_SkillTimeFrame$1,
    Automation_SkillTimeFrame_AllTime: Automation_SkillTimeFrame_AllTime$1,
    Automation_SkillTimeFrame_WithinDays: Automation_SkillTimeFrame_WithinDays$1,
    Automation_Status_Update: Automation_Status_Update$1,
    Automation_Then: Automation_Then$1,
    Automation_TimeUpdated: Automation_TimeUpdated$1,
    Automation_Trigger: Automation_Trigger$1,
    Automation_Trigger_Delete: Automation_Trigger_Delete$1,
    Automation_Trigger_Insert: Automation_Trigger_Insert$1,
    Automation_Trigger_Scheduled: Automation_Trigger_Scheduled$1,
    Automation_Trigger_Update: Automation_Trigger_Update$1,
    Automation_Trigger_UserCreated: Automation_Trigger_UserCreated$1,
    Automation_Trigger_UserRecordReceived: Automation_Trigger_UserRecordReceived$1,
    Automation_TriggerHasBeenAdded: Automation_TriggerHasBeenAdded$1,
    Automation_TriggerHasNotBeenAdded: Automation_TriggerHasNotBeenAdded$1,
    Automation_TriggerHelp: Automation_TriggerHelp$1,
    Automation_TriggerNoConfigurationNeeded: Automation_TriggerNoConfigurationNeeded$1,
    Automation_TriggersAndActionsRequired: Automation_TriggersAndActionsRequired$1,
    Automation_UntitledAutomation: Automation_UntitledAutomation$1,
    Automation_UpdatedBy: Automation_UpdatedBy$1,
    Automation_UserAcademyStatus: Automation_UserAcademyStatus$1,
    Automation_UserAcademyStatus_Helper: Automation_UserAcademyStatus_Helper$1,
    Automation_UserActivity: Automation_UserActivity$1,
    Automation_UserAssignmentDescription: Automation_UserAssignmentDescription$1,
    Automation_UserAttribute: Automation_UserAttribute$1,
    Automation_UserConditions: Automation_UserConditions$1,
    Automation_UserConditions_Header: Automation_UserConditions_Header$1,
    Automation_UserEvents: Automation_UserEvents$1,
    Automation_UserManagement: Automation_UserManagement$1,
    Automation_UserMeetsConditions: Automation_UserMeetsConditions$1,
    Automation_UserMeetsConditions_Academy: Automation_UserMeetsConditions_Academy$1,
    Automation_UserMeetsConditions_Attribute: Automation_UserMeetsConditions_Attribute$1,
    Automation_UserMeetsConditions_Group: Automation_UserMeetsConditions_Group$1,
    Automation_UserMeetsConditions_Skill: Automation_UserMeetsConditions_Skill$1,
    Automation_UserNotificationDescription: Automation_UserNotificationDescription$1,
    Automation_UserShareDescription: Automation_UserShareDescription$1,
    Automation_ViewHistory: Automation_ViewHistory$1,
    Automation_Warning: Automation_Warning$1,
    Automation_Warning_RequiredBeforeSaving: Automation_Warning_RequiredBeforeSaving$1,
    Automation_When: Automation_When$1,
    Attributes_AddHiddenAttributes: Attributes_AddHiddenAttributes$1,
    Attributes_Attribute: Attributes_Attribute$1,
    Attributes_AttributeDataType: Attributes_AttributeDataType$1,
    Attributes_AttributeFeatureName: Attributes_AttributeFeatureName$1,
    Attributes_AttributeFilterLabel: Attributes_AttributeFilterLabel$1,
    Attributes_AttributeFilterModal_AddButton: Attributes_AttributeFilterModal_AddButton$1,
    Attributes_AttributeFilterModal_AttributeFieldLabel: Attributes_AttributeFilterModal_AttributeFieldLabel$1,
    Attributes_AttributeFilterModal_AttributeFieldPlaceHolder: Attributes_AttributeFilterModal_AttributeFieldPlaceHolder$1,
    Attributes_AttributeFilterModal_OperatorFieldLabel: Attributes_AttributeFilterModal_OperatorFieldLabel$1,
    Attributes_AttributeFilterModal_OperatorFieldPlaceHolder: Attributes_AttributeFilterModal_OperatorFieldPlaceHolder$1,
    Attributes_AttributeFilterModal_Title: Attributes_AttributeFilterModal_Title$1,
    Attributes_AttributeFilterModal_ValuesFieldHint: Attributes_AttributeFilterModal_ValuesFieldHint$1,
    Attributes_AttributeFilterModal_ValuesFieldLabel: Attributes_AttributeFilterModal_ValuesFieldLabel$1,
    Attributes_AttributesDescription: Attributes_AttributesDescription$1,
    Attributes_AttributesHeading: Attributes_AttributesHeading$1,
    Attributes_AttributesLabel: Attributes_AttributesLabel$1,
    Attributes_AttributeSource: Attributes_AttributeSource$1,
    Attributes_Bool: Attributes_Bool$1,
    Attributes_BusinessRules: Attributes_BusinessRules$1,
    Attributes_Custom: Attributes_Custom$1,
    Attributes_CustomAttributes: Attributes_CustomAttributes$1,
    Attributes_CustomAttributesDescription: Attributes_CustomAttributesDescription$1,
    Attributes_CustomData: Attributes_CustomData$1,
    Attributes_DataType: Attributes_DataType$1,
    Attributes_DataTypes_Description: Attributes_DataTypes_Description$1,
    Attributes_DateTime: Attributes_DateTime$1,
    Attributes_DateTimeOLD: Attributes_DateTimeOLD$1,
    Attributes_DefaultVisibility: Attributes_DefaultVisibility$1,
    Attributes_DefaultVisibilityDescription: Attributes_DefaultVisibilityDescription$1,
    Attributes_EditAttributeSettings: Attributes_EditAttributeSettings$1,
    Attributes_Feature_BusinessRules: Attributes_Feature_BusinessRules$1,
    Attributes_Feature_Segments: Attributes_Feature_Segments$1,
    Attributes_FeatureVisibility: Attributes_FeatureVisibility$1,
    Attributes_FeatureVisibility_Description: Attributes_FeatureVisibility_Description$1,
    Attributes_FieldType_Datetime: Attributes_FieldType_Datetime$1,
    Attributes_FieldType_Number: Attributes_FieldType_Number$1,
    Attributes_FieldType_String: Attributes_FieldType_String$1,
    Attributes_IncomingField: Attributes_IncomingField$1,
    Attributes_IncomingFields: Attributes_IncomingFields$1,
    Attributes_Instructions: Attributes_Instructions$1,
    Attributes_NoMatches: Attributes_NoMatches$1,
    Attributes_NoResults: Attributes_NoResults$1,
    Attributes_NoVisibleAttributes: Attributes_NoVisibleAttributes$1,
    Attributes_NoVisibleAttributesInstructions: Attributes_NoVisibleAttributesInstructions$1,
    Attributes_Number: Attributes_Number$1,
    Attributes_NumberOLD: Attributes_NumberOLD$1,
    Attributes_RemoveAttributeFormat: Attributes_RemoveAttributeFormat$1,
    Attributes_Segments: Attributes_Segments$1,
    Attributes_Standard: Attributes_Standard$1,
    Attributes_StandardAttributes: Attributes_StandardAttributes$1,
    Attributes_StandardAttributesInstructions: Attributes_StandardAttributesInstructions$1,
    Attributes_StandardCustom: Attributes_StandardCustom$1,
    Attributes_String: Attributes_String$1,
    Attributes_StringOLD: Attributes_StringOLD$1,
    Attributes_UserAttributes: Attributes_UserAttributes$1,
    Attributes_UserAttributesDescription: Attributes_UserAttributesDescription$1,
    Attributes_VisibleAttributes: Attributes_VisibleAttributes$1,
    Attributes_VisibleAttributesDescription: Attributes_VisibleAttributesDescription$1,
    Attributes_Warning_ConversionResultsInDataLoss_Format: Attributes_Warning_ConversionResultsInDataLoss_Format$1,
    Attributes_Warning_InvalidConversionToBoolean: Attributes_Warning_InvalidConversionToBoolean$1,
    Attributes_Warning_InvalidConversionToDateTime: Attributes_Warning_InvalidConversionToDateTime$1,
    Attributes_Warning_InvalidConversionToNumber: Attributes_Warning_InvalidConversionToNumber$1,
    Attributes_Warning_TypeMismatch_Format: Attributes_Warning_TypeMismatch_Format$1,
    assignedLearning_AlreadyAttendAssignedByFormat: assignedLearning_AlreadyAttendAssignedByFormat$1,
    assignedLearning_AlreadyCompletedAssignedByFormat: assignedLearning_AlreadyCompletedAssignedByFormat$1,
    assignedLearning_AlreadyFollowAssignedByFormat: assignedLearning_AlreadyFollowAssignedByFormat$1,
    assignedLearning_AlreadyReadAssignedByFormat: assignedLearning_AlreadyReadAssignedByFormat$1,
    assignedLearning_AlreadyWatchedAssignedByFormat: assignedLearning_AlreadyWatchedAssignedByFormat$1,
    assignedLearning_Completed: assignedLearning_Completed$1,
    assignedLearning_CompletedNoDate: assignedLearning_CompletedNoDate$1,
    assignedLearning_DueLater: assignedLearning_DueLater$1,
    assignedLearning_DueLaterExternal: assignedLearning_DueLaterExternal$1,
    assignedLearning_DueLaterGroup: assignedLearning_DueLaterGroup$1,
    assignedLearning_DueSoon: assignedLearning_DueSoon$1,
    assignedLearning_GroupAlreadyAttendedFormat: assignedLearning_GroupAlreadyAttendedFormat$1,
    assignedLearning_GroupAlreadyAttendedFormerLearnerFormat: assignedLearning_GroupAlreadyAttendedFormerLearnerFormat$1,
    assignedLearning_GroupAlreadyCompletedDateFormat: assignedLearning_GroupAlreadyCompletedDateFormat$1,
    assignedLearning_GroupAlreadyCompletedDateFormerLearnerFormat: assignedLearning_GroupAlreadyCompletedDateFormerLearnerFormat$1,
    assignedLearning_GroupAlreadyCompletedFormat: assignedLearning_GroupAlreadyCompletedFormat$1,
    assignedLearning_GroupAlreadyCompletedFormerLearnerFormat: assignedLearning_GroupAlreadyCompletedFormerLearnerFormat$1,
    assignedLearning_GroupAlreadyCompletedNoDateFormat: assignedLearning_GroupAlreadyCompletedNoDateFormat$1,
    assignedLearning_GroupAlreadyCompletedNoDateFormerLearnerFormat: assignedLearning_GroupAlreadyCompletedNoDateFormerLearnerFormat$1,
    assignedLearning_GroupAlreadyFollowedFormat: assignedLearning_GroupAlreadyFollowedFormat$1,
    assignedLearning_GroupAlreadyFollowedFormerLearnerFormat: assignedLearning_GroupAlreadyFollowedFormerLearnerFormat$1,
    assignedLearning_GroupAlreadyReadFormat: assignedLearning_GroupAlreadyReadFormat$1,
    assignedLearning_GroupAlreadyReadFormerLearnerFormat: assignedLearning_GroupAlreadyReadFormerLearnerFormat$1,
    assignedLearning_GroupAlreadyWatchedFormat: assignedLearning_GroupAlreadyWatchedFormat$1,
    assignedLearning_GroupAlreadyWatchedFormerLearnerFormat: assignedLearning_GroupAlreadyWatchedFormerLearnerFormat$1,
    assignedLearning_GroupAttendedFormat: assignedLearning_GroupAttendedFormat$1,
    assignedLearning_GroupAttendedFormerLearnerFormat: assignedLearning_GroupAttendedFormerLearnerFormat$1,
    assignedLearning_GroupCompletedFormat: assignedLearning_GroupCompletedFormat$1,
    assignedLearning_GroupCompletedFormerLearnerFormat: assignedLearning_GroupCompletedFormerLearnerFormat$1,
    assignedLearning_GroupDateFormat: assignedLearning_GroupDateFormat$1,
    assignedLearning_GroupDateFormerLearnerFormat: assignedLearning_GroupDateFormerLearnerFormat$1,
    assignedLearning_GroupFollowedFormat: assignedLearning_GroupFollowedFormat$1,
    assignedLearning_GroupFollowedFormerLearnerFormat: assignedLearning_GroupFollowedFormerLearnerFormat$1,
    assignedLearning_GroupNoDateFormat: assignedLearning_GroupNoDateFormat$1,
    assignedLearning_GroupNoDateFormerLearnerFormat: assignedLearning_GroupNoDateFormerLearnerFormat$1,
    assignedLearning_GroupReadFormat: assignedLearning_GroupReadFormat$1,
    assignedLearning_GroupReadFormerLearnerFormat: assignedLearning_GroupReadFormerLearnerFormat$1,
    assignedLearning_GroupWatchedFormat: assignedLearning_GroupWatchedFormat$1,
    assignedLearning_GroupWatchedFormerLearnerFormat: assignedLearning_GroupWatchedFormerLearnerFormat$1,
    assignedLearning_NoDueDate: assignedLearning_NoDueDate$1,
    assignedLearning_NoDueDateExternal: assignedLearning_NoDueDateExternal$1,
    assignedLearning_Overdue: assignedLearning_Overdue$1,
    assignedLearning_RequiredLearningTimeTip: assignedLearning_RequiredLearningTimeTip$1,
    assignedLearning_YouAlreadyAttendedFormat: assignedLearning_YouAlreadyAttendedFormat$1,
    assignedLearning_YouAlreadyAttendedFormerLearnerFormat: assignedLearning_YouAlreadyAttendedFormerLearnerFormat$1,
    assignedLearning_YouAlreadyCompletedDateFormat: assignedLearning_YouAlreadyCompletedDateFormat$1,
    assignedLearning_YouAlreadyCompletedDateFormerLearnerFormat: assignedLearning_YouAlreadyCompletedDateFormerLearnerFormat$1,
    assignedLearning_YouAlreadyCompletedFormat: assignedLearning_YouAlreadyCompletedFormat$1,
    assignedLearning_YouAlreadyCompletedFormerLearnerFormat: assignedLearning_YouAlreadyCompletedFormerLearnerFormat$1,
    assignedLearning_YouAlreadyCompletedFormerLearnerNoDateFormat: assignedLearning_YouAlreadyCompletedFormerLearnerNoDateFormat$1,
    assignedLearning_YouAlreadyCompletedNoDateFormat: assignedLearning_YouAlreadyCompletedNoDateFormat$1,
    assignedLearning_YouAlreadyFollowedFormat: assignedLearning_YouAlreadyFollowedFormat$1,
    assignedLearning_YouAlreadyFollowedFormerLearnerFormat: assignedLearning_YouAlreadyFollowedFormerLearnerFormat$1,
    assignedLearning_YouAlreadyReadFormat: assignedLearning_YouAlreadyReadFormat$1,
    assignedLearning_YouAlreadyReadFormerLearnerFormat: assignedLearning_YouAlreadyReadFormerLearnerFormat$1,
    assignedLearning_YouAlreadyWatchedFormat: assignedLearning_YouAlreadyWatchedFormat$1,
    assignedLearning_YouAlreadyWatchedFormerLearnerFormat: assignedLearning_YouAlreadyWatchedFormerLearnerFormat$1,
    assignedLearning_YouAttendedFormat: assignedLearning_YouAttendedFormat$1,
    assignedLearning_YouAttendedFormerLearnerFormat: assignedLearning_YouAttendedFormerLearnerFormat$1,
    assignedLearning_YouCompletedFormat: assignedLearning_YouCompletedFormat$1,
    assignedLearning_YouCompletedFormerLearnerFormat: assignedLearning_YouCompletedFormerLearnerFormat$1,
    assignedLearning_YouDateFormat: assignedLearning_YouDateFormat$1,
    assignedLearning_YouDateFormerLearnerFormat: assignedLearning_YouDateFormerLearnerFormat$1,
    assignedLearning_YouFollowedFormat: assignedLearning_YouFollowedFormat$1,
    assignedLearning_YouFollowedFormerLearnerFormat: assignedLearning_YouFollowedFormerLearnerFormat$1,
    assignedLearning_YouNoDateFormat: assignedLearning_YouNoDateFormat$1,
    assignedLearning_YouNoDateFormerLearnerFormat: assignedLearning_YouNoDateFormerLearnerFormat$1,
    assignedLearning_YouReadFormat: assignedLearning_YouReadFormat$1,
    assignedLearning_YouReadFormerLearnerFormat: assignedLearning_YouReadFormerLearnerFormat$1,
    assignedLearning_YouWatchedFormat: assignedLearning_YouWatchedFormat$1,
    assignedLearning_YouWatchedFormerLearnerFormat: assignedLearning_YouWatchedFormerLearnerFormat$1,
    AssessmentFormCtrl_AddAssessment: AssessmentFormCtrl_AddAssessment$1,
    AssessmentFormCtrl_AddToCatalogFormat: AssessmentFormCtrl_AddToCatalogFormat$1,
    AssessmentFormCtrl_AssessmentName: AssessmentFormCtrl_AssessmentName$1,
    AssessmentFormCtrl_AssessmentProvider: AssessmentFormCtrl_AssessmentProvider$1,
    AssessmentFormCtrl_AssessmentUrl: AssessmentFormCtrl_AssessmentUrl$1,
    AssessmentFormCtrl_Category: AssessmentFormCtrl_Category$1,
    AssessmentFormCtrl_CorrectQuestions: AssessmentFormCtrl_CorrectQuestions$1,
    AssessmentFormCtrl_CorrectQuestionsFormat: AssessmentFormCtrl_CorrectQuestionsFormat$1,
    AssessmentFormCtrl_DateCompleted: AssessmentFormCtrl_DateCompleted$1,
    AssessmentFormCtrl_Description: AssessmentFormCtrl_Description$1,
    AssessmentFormCtrl_EditAssessment: AssessmentFormCtrl_EditAssessment$1,
    AssessmentFormCtrl_NameRequired: AssessmentFormCtrl_NameRequired$1,
    AssessmentFormCtrl_NumberOfQuestions: AssessmentFormCtrl_NumberOfQuestions$1,
    AssessmentFormCtrl_NumberOfQuestionsError: AssessmentFormCtrl_NumberOfQuestionsError$1,
    AssessmentFormCtrl_Percentile: AssessmentFormCtrl_Percentile$1,
    AssessmentFormCtrl_SaveAssessment: AssessmentFormCtrl_SaveAssessment$1,
    AssessmentFormCtrl_TotalQuestions: AssessmentFormCtrl_TotalQuestions$1,
    AssessmentFormCtrl_UrlRequired: AssessmentFormCtrl_UrlRequired$1,
    AssessmentFormCtrl_WhatDidYouLearnLong: AssessmentFormCtrl_WhatDidYouLearnLong$1,
    AssessmentFormCtrl_WhatDidYouLearnShort: AssessmentFormCtrl_WhatDidYouLearnShort$1,
    AppHeader_AcademiesTitle: AppHeader_AcademiesTitle$1,
    AppHeader_BrowseTitle: AppHeader_BrowseTitle$1,
    AppHeader_DgAssistantTitle: AppHeader_DgAssistantTitle$1,
    AppHeader_FeaturedTitle: AppHeader_FeaturedTitle$1,
    AppHeader_HomeTitle: AppHeader_HomeTitle$1,
    AppHeader_Login: AppHeader_Login$1,
    AppHeader_MaestroTitle: AppHeader_MaestroTitle$1,
    AppHeader_OpportunitiesTitle: AppHeader_OpportunitiesTitle$1,
    AppHeader_ProfileTitle: AppHeader_ProfileTitle$1,
    AppHeader_Signup: AppHeader_Signup$1,
    AppHeader_SkillCoachTitle: AppHeader_SkillCoachTitle$1,
    AppHeader_TeamTitle: AppHeader_TeamTitle$1,
    AnonymousUserHelper_EmailName: AnonymousUserHelper_EmailName$1,
    AnonymousUserHelper_Name: AnonymousUserHelper_Name$1,
    alertModal_DontShowAgain: alertModal_DontShowAgain$1,
    addToTargetModal_AddedItemSuccessfully: addToTargetModal_AddedItemSuccessfully$1,
    addToTargetModal_AddedSuccessfully: addToTargetModal_AddedSuccessfully$1,
    addToTargetModal_AddingError: addToTargetModal_AddingError$1,
    addToTargetModal_AddItemDescription: addToTargetModal_AddItemDescription$1,
    addToTargetModal_AddToTarget: addToTargetModal_AddToTarget$1,
    addToTargetModal_CreateJobRoleExplanation: addToTargetModal_CreateJobRoleExplanation$1,
    addToTargetModal_CreateTarget: addToTargetModal_CreateTarget$1,
    addToTargetModal_CreateYourTarget: addToTargetModal_CreateYourTarget$1,
    addToTargetModal_EditTarget: addToTargetModal_EditTarget$1,
    addToTargetModal_GoToTarget: addToTargetModal_GoToTarget$1,
    addToTargetModal_MostRecentTargets: addToTargetModal_MostRecentTargets$1,
    addToTargetModal_NoSectionsFound: addToTargetModal_NoSectionsFound$1,
    addToTargetModal_OrgManagedNotice: addToTargetModal_OrgManagedNotice$1,
    addToTargetModal_SearchAuthoringTarget: addToTargetModal_SearchAuthoringTarget$1,
    addToTargetModal_SearchYourTargets: addToTargetModal_SearchYourTargets$1,
    addToTargetModal_Section: addToTargetModal_Section$1,
    addToTargetModal_SelectPlanSection: addToTargetModal_SelectPlanSection$1,
    addToTargetModal_SelectSectionPlaceHolder: addToTargetModal_SelectSectionPlaceHolder$1,
    addToTargetModal_SelectTargetPlaceHolder: addToTargetModal_SelectTargetPlaceHolder$1,
    addToTargetModal_VisitTargetEditPage: addToTargetModal_VisitTargetEditPage$1,
    addToTargetModal_WhichTarget: addToTargetModal_WhichTarget$1,
    addToTargetModal_YourTargets: addToTargetModal_YourTargets$1,
    addToPathwayModal_AddedSuccessfully: addToPathwayModal_AddedSuccessfully$1,
    addToPathwayModal_AddingError: addToPathwayModal_AddingError$1,
    addToPathwayModal_AddItemDescription: addToPathwayModal_AddItemDescription$1,
    addToPathwayModal_AddToCatalog: addToPathwayModal_AddToCatalog$1,
    addToPathwayModal_AddToPathway: addToPathwayModal_AddToPathway$1,
    addToPathwayModal_CreatePathway: addToPathwayModal_CreatePathway$1,
    addToPathwayModal_CreatePathwayExplanation: addToPathwayModal_CreatePathwayExplanation$1,
    addToPathwayModal_CreateYourPathway: addToPathwayModal_CreateYourPathway$1,
    addToPathwayModal_EditPathway: addToPathwayModal_EditPathway$1,
    addToPathwayModal_GoToPathway: addToPathwayModal_GoToPathway$1,
    addToPathwayModal_HoldForLater: addToPathwayModal_HoldForLater$1,
    addToPathwayModal_Lesson: addToPathwayModal_Lesson$1,
    addToPathwayModal_LessonNumberFormat: addToPathwayModal_LessonNumberFormat$1,
    addToPathwayModal_MostRecentPathways: addToPathwayModal_MostRecentPathways$1,
    addToPathwayModal_NoPathwayDescription: addToPathwayModal_NoPathwayDescription$1,
    addToPathwayModal_OrgManagedNotice: addToPathwayModal_OrgManagedNotice$1,
    addToPathwayModal_Pathway: addToPathwayModal_Pathway$1,
    addToPathwayModal_RecentlyUsed: addToPathwayModal_RecentlyUsed$1,
    addToPathwayModal_SearchAuthoringPathway: addToPathwayModal_SearchAuthoringPathway$1,
    addToPathwayModal_SearchYourPathways: addToPathwayModal_SearchYourPathways$1,
    addToPathwayModal_Section: addToPathwayModal_Section$1,
    addToPathwayModal_SectionNumberFormat: addToPathwayModal_SectionNumberFormat$1,
    addToPathwayModal_SelectLesson: addToPathwayModal_SelectLesson$1,
    addToPathwayModal_SelectPathway: addToPathwayModal_SelectPathway$1,
    addToPathwayModal_SelectPathwaySection: addToPathwayModal_SelectPathwaySection$1,
    addToPathwayModal_SelectPathwaySubSection: addToPathwayModal_SelectPathwaySubSection$1,
    addToPathwayModal_SelectSection: addToPathwayModal_SelectSection$1,
    addToPathwayModal_SuccessLabel: addToPathwayModal_SuccessLabel$1,
    addToPathwayModal_VisitPathwayEditPage: addToPathwayModal_VisitPathwayEditPage$1,
    addToPathwayModal_WhichPathway: addToPathwayModal_WhichPathway$1,
    addToPathwayModal_YourPathways: addToPathwayModal_YourPathways$1,
    addEditMetaDataModal_AddProperty: addEditMetaDataModal_AddProperty$1,
    addEditMetaDataModal_EditProperties: addEditMetaDataModal_EditProperties$1,
    addEditMetaDataModal_Property: addEditMetaDataModal_Property$1,
    addEditMetaDataModal_Purpose_RolePlan: addEditMetaDataModal_Purpose_RolePlan$1,
    addEditMetaDataModal_RemoveProperty: addEditMetaDataModal_RemoveProperty$1,
    addEditMetaDataModal_Value: addEditMetaDataModal_Value$1,
    ActiveLearner_Condition1: ActiveLearner_Condition1$1,
    ActiveLearner_Condition1WithName: ActiveLearner_Condition1WithName$1,
    ActiveLearner_Condition2: ActiveLearner_Condition2$1,
    ActiveLearner_Condition2WithName: ActiveLearner_Condition2WithName$1,
    ActiveLearner_Condition3: ActiveLearner_Condition3$1,
    ActiveLearner_Condition3WithName: ActiveLearner_Condition3WithName$1,
    ActiveLearner_Condition4: ActiveLearner_Condition4$1,
    ActiveLearner_Condition4WithName: ActiveLearner_Condition4WithName$1,
    ActiveLearner_Congratulations: ActiveLearner_Congratulations$1,
    ActiveLearner_CongratulationsText: ActiveLearner_CongratulationsText$1,
    ActiveLearner_FinePrint: ActiveLearner_FinePrint$1,
    ActiveLearner_FinePrintWithName: ActiveLearner_FinePrintWithName$1,
    ActiveLearner_HowToGetRecognized: ActiveLearner_HowToGetRecognized$1,
    ActiveLearner_ModalTitle: ActiveLearner_ModalTitle$1,
    ActiveLearner_ModalTitleWithName: ActiveLearner_ModalTitleWithName$1,
    AccountSvc_ChangeLinkFail: AccountSvc_ChangeLinkFail$1,
    AccountSvc_ChangeSuccess: AccountSvc_ChangeSuccess$1,
    AccountSvc_CreateAccountError: AccountSvc_CreateAccountError$1,
    AccountSvc_DefaultPassword: AccountSvc_DefaultPassword$1,
    AccountSvc_DeleteAccount: AccountSvc_DeleteAccount$1,
    AccountSvc_EmailConfirmation: AccountSvc_EmailConfirmation$1,
    AccountSvc_ForgotPassword: AccountSvc_ForgotPassword$1,
    AccountSvc_GroupInvite: AccountSvc_GroupInvite$1,
    AccountSvc_LoginError: AccountSvc_LoginError$1,
    AccountSvc_OrgInvite: AccountSvc_OrgInvite$1,
    AccountSvc_OrgPasswordError: AccountSvc_OrgPasswordError$1,
    AccountSvc_PasswordResetError: AccountSvc_PasswordResetError$1,
    AccountSvc_PasswordResetInstructionsMessage: AccountSvc_PasswordResetInstructionsMessage$1,
    AccountSvc_Restricted: AccountSvc_Restricted$1,
    AccountSvc_SecondaryEmail: AccountSvc_SecondaryEmail$1,
    AccountSvc_SessionExpired: AccountSvc_SessionExpired$1,
    AccountSvc_SignUp: AccountSvc_SignUp$1,
    AccountSvc_Unsubscribe: AccountSvc_Unsubscribe$1,
    AccountSvc_UserEndorsement: AccountSvc_UserEndorsement$1,
    AccountCtrl_ContinueToAccount: AccountCtrl_ContinueToAccount$1,
    AccountCtrl_LoginUsingProvider: AccountCtrl_LoginUsingProvider$1,
    AccountController_AccountLockedByOrgError: AccountController_AccountLockedByOrgError$1,
    AccountController_AccountLockedError: AccountController_AccountLockedError$1,
    AccountController_AgreeWithTermsOne: AccountController_AgreeWithTermsOne$1,
    AccountController_AgreeWithTermTwo: AccountController_AgreeWithTermTwo$1,
    AccountController_And: AccountController_And$1,
    AccountController_ChangePassword: AccountController_ChangePassword$1,
    AccountController_ChangePasswordError: AccountController_ChangePasswordError$1,
    AccountController_ChangePasswordTitle: AccountController_ChangePasswordTitle$1,
    AccountController_ConfirmPassword: AccountController_ConfirmPassword$1,
    AccountController_Continue: AccountController_Continue$1,
    AccountController_ContinueWithSSO: AccountController_ContinueWithSSO$1,
    AccountController_EmailAddress: AccountController_EmailAddress$1,
    AccountController_EmailAddressPlaceholder: AccountController_EmailAddressPlaceholder$1,
    AccountController_EmailExistsError: AccountController_EmailExistsError$1,
    AccountController_EmailLoginDisabledError: AccountController_EmailLoginDisabledError$1,
    AccountController_EmailLoginError: AccountController_EmailLoginError$1,
    AccountController_FacebookLogin: AccountController_FacebookLogin$1,
    AccountController_FirstName: AccountController_FirstName$1,
    AccountController_Forgot: AccountController_Forgot$1,
    AccountController_LoggedOutHeader: AccountController_LoggedOutHeader$1,
    AccountController_LoggedOutTitle: AccountController_LoggedOutTitle$1,
    AccountController_Login: AccountController_Login$1,
    AccountController_LoginAgainButton: AccountController_LoginAgainButton$1,
    AccountController_LoginUsingPassword: AccountController_LoginUsingPassword$1,
    AccountController_LoginViewContent: AccountController_LoginViewContent$1,
    AccountController_NewPassword: AccountController_NewPassword$1,
    AccountController_OldPassword: AccountController_OldPassword$1,
    AccountController_OldPasswordPlaceholder: AccountController_OldPasswordPlaceholder$1,
    AccountController_Password: AccountController_Password$1,
    AccountController_PasswordMatchError: AccountController_PasswordMatchError$1,
    AccountController_PasswordPatternInfo: AccountController_PasswordPatternInfo$1,
    AccountController_PrivacyPolicy: AccountController_PrivacyPolicy$1,
    AccountController_RecentPasswordError: AccountController_RecentPasswordError$1,
    AccountController_Register: AccountController_Register$1,
    AccountController_RegisterEmailExistsError: AccountController_RegisterEmailExistsError$1,
    AccountController_RememberMe: AccountController_RememberMe$1,
    AccountController_ResetPassword: AccountController_ResetPassword$1,
    AccountController_ResetYourPassword: AccountController_ResetYourPassword$1,
    AccountController_SignUp: AccountController_SignUp$1,
    AccountController_SignUpPageTitle: AccountController_SignUpPageTitle$1,
    AccountController_SignUpTitle: AccountController_SignUpTitle$1,
    AccountController_UsernameLoginError: AccountController_UsernameLoginError$1,
    AccountController_ValidPassword: AccountController_ValidPassword$1,
    AccountController_WelcomeDegreed: AccountController_WelcomeDegreed$1,
    AccomplishmentFormCtrl_EndDate: AccomplishmentFormCtrl_EndDate$1,
    AccomplishmentFormCtrl_ExpirationDate: AccomplishmentFormCtrl_ExpirationDate$1,
    AccomplishmentFormCtrl_StateDate: AccomplishmentFormCtrl_StateDate$1,
    AccomplishmentFormCtrl_Title: AccomplishmentFormCtrl_Title$1,
    AboutFooter_AltCareersIcon: AboutFooter_AltCareersIcon$1,
    AboutFooter_AltContactIcon: AboutFooter_AltContactIcon$1,
    AboutFooter_AltMissionIcon: AboutFooter_AltMissionIcon$1,
    AboutFooter_AltPressIcon: AboutFooter_AltPressIcon$1,
    AboutFooter_CareersAtDegreed: AboutFooter_CareersAtDegreed$1,
    AboutFooter_ContactDegreed: AboutFooter_ContactDegreed$1,
    AboutFooter_DegreedMission: AboutFooter_DegreedMission$1,
    AboutFooter_DegreedPress: AboutFooter_DegreedPress$1,
    AboutFooter_JailbreakTheDegree: AboutFooter_JailbreakTheDegree$1,
    AboutFooter_LearningAndWork: AboutFooter_LearningAndWork$1,
    AboutFooter_WeWantToHear: AboutFooter_WeWantToHear$1,
    AboutFooter_WhatOthersAreSaying: AboutFooter_WhatOthersAreSaying$1,
    A11y_ActionsToolbarType: A11y_ActionsToolbarType$1,
    A11y_AddComment: A11y_AddComment$1,
    A11y_AssignmentsCount: A11y_AssignmentsCount$1,
    A11y_AssignmentStatus: A11y_AssignmentStatus$1,
    A11y_BlurToSave: A11y_BlurToSave$1,
    A11y_BreadcrumbNavType: A11y_BreadcrumbNavType$1,
    A11y_BrowseGroups: A11y_BrowseGroups$1,
    A11y_BrowseGroupsButton: A11y_BrowseGroupsButton$1,
    A11y_BrowseOpportunitiesGridView: A11y_BrowseOpportunitiesGridView$1,
    A11y_BrowseOpportunitiesListView: A11y_BrowseOpportunitiesListView$1,
    A11y_BrowsePathwaysButton: A11y_BrowsePathwaysButton$1,
    A11y_BrowsePlansButton: A11y_BrowsePlansButton$1,
    A11y_BulkDelete_Format: A11y_BulkDelete_Format$1,
    A11y_BulkDisable_Format: A11y_BulkDisable_Format$1,
    A11y_BulkEnable_Format: A11y_BulkEnable_Format$1,
    A11y_ButtonGroupWithNestedDropdown: A11y_ButtonGroupWithNestedDropdown$1,
    A11y_CharacterLimit: A11y_CharacterLimit$1,
    A11y_CollapsePanelButton: A11y_CollapsePanelButton$1,
    A11y_CollectionChangeAnnouncement: A11y_CollectionChangeAnnouncement$1,
    A11y_CompletionProgressDetails: A11y_CompletionProgressDetails$1,
    A11y_ConfirmModal_input: A11y_ConfirmModal_input$1,
    A11y_ContentCompletedButton: A11y_ContentCompletedButton$1,
    A11y_ContentNotCompletedButton: A11y_ContentNotCompletedButton$1,
    A11y_ContentTypesNavType: A11y_ContentTypesNavType$1,
    A11y_ContinuingEducationUnits: A11y_ContinuingEducationUnits$1,
    A11y_CreateGroup: A11y_CreateGroup$1,
    A11y_Date_YYYYMMDDFormat: A11y_Date_YYYYMMDDFormat$1,
    A11y_Delete_Format: A11y_Delete_Format$1,
    A11y_DeleteLink: A11y_DeleteLink$1,
    A11y_Disable_Format: A11y_Disable_Format$1,
    A11y_Edit_Format: A11y_Edit_Format$1,
    A11y_Enable_Format: A11y_Enable_Format$1,
    A11y_EscapeToDismiss: A11y_EscapeToDismiss$1,
    A11y_ExpandExperience: A11y_ExpandExperience$1,
    A11y_ExpandForSummary: A11y_ExpandForSummary$1,
    A11y_ExpandForTitle: A11y_ExpandForTitle$1,
    A11y_ExpandPanelButton: A11y_ExpandPanelButton$1,
    A11y_FollowingPathwayButton: A11y_FollowingPathwayButton$1,
    A11y_FollowingPlanButton: A11y_FollowingPlanButton$1,
    A11y_GlobalSearchInstructions: A11y_GlobalSearchInstructions$1,
    A11y_GoToProfile: A11y_GoToProfile$1,
    A11y_GroupJoinedButton: A11y_GroupJoinedButton$1,
    A11y_GroupNotJoinedButton: A11y_GroupNotJoinedButton$1,
    A11y_LearningCollectionsNavType: A11y_LearningCollectionsNavType$1,
    A11y_LinkOpensNewWindow: A11y_LinkOpensNewWindow$1,
    A11y_MainPagesNavType: A11y_MainPagesNavType$1,
    A11y_NonOptionalStepsComplete: A11y_NonOptionalStepsComplete$1,
    A11y_NotFollowingPathwayButton: A11y_NotFollowingPathwayButton$1,
    A11y_NotFollowingPlanButton: A11y_NotFollowingPlanButton$1,
    A11y_NumberOfSkills: A11y_NumberOfSkills$1,
    A11y_NumberSuggestionsAvailableFormat: A11y_NumberSuggestionsAvailableFormat$1,
    A11y_OpensInANewTab: A11y_OpensInANewTab$1,
    A11y_OptionalStatus: A11y_OptionalStatus$1,
    A11y_PositiveNumbersOnly: A11y_PositiveNumbersOnly$1,
    A11y_RegistrationStatus: A11y_RegistrationStatus$1,
    A11y_RemoveCardType: A11y_RemoveCardType$1,
    A11y_RemoveContent: A11y_RemoveContent$1,
    A11y_RemoveSection: A11y_RemoveSection$1,
    A11y_RemoveSubsection: A11y_RemoveSubsection$1,
    A11y_RemoveUser: A11y_RemoveUser$1,
    A11y_RotatingLogos: A11y_RotatingLogos$1,
    A11y_SearchAssignments: A11y_SearchAssignments$1,
    A11y_SecondaryPagesNavType: A11y_SecondaryPagesNavType$1,
    A11y_Select_Format: A11y_Select_Format$1,
    A11y_SessionStartDate: A11y_SessionStartDate$1,
    A11y_SliderDescription: A11y_SliderDescription$1,
    A11y_SliderNavigation: A11y_SliderNavigation$1,
    A11y_TabChangeAnnouncement: A11y_TabChangeAnnouncement$1,
    A11y_ToggleProductMenu: A11y_ToggleProductMenu$1,
    A11y_ToggleProfileMenu: A11y_ToggleProfileMenu$1,
    A11y_ToggleSearch: A11y_ToggleSearch$1,
    A11y_TrackerCurrentStep: A11y_TrackerCurrentStep$1,
    A11y_TrackerStep: A11y_TrackerStep$1,
    A11y_TryOurBookmarklet: A11y_TryOurBookmarklet$1,
    A11y_VerificationStatus: A11y_VerificationStatus$1,
    A11y_virtualDocument: A11y_virtualDocument$1,
    A11y_WizardClickExpand: A11y_WizardClickExpand$1,
    A11y_WizardNavType: A11y_WizardNavType$1
};

var A11y_ActionsToolbarType = "Actions";
var A11y_AddComment = "Ajouter un commentaire";
var A11y_AssignmentsCount = "{{n}} Assignments";
var A11y_AssignmentStatus = "Statut de la formation assign\xe9e";
var A11y_BlurToSave = "\xc9loignez le focus de cet \xe9l\xe9ment pour enregistrer les modifications automatiquement.";
var A11y_BreadcrumbNavType = "Breadcrumb";
var A11y_BrowseGroups = "Bouton Parcourir les groupes. Cliquez dessus pour acc\xe9der \xe0 la page des groupes.";
var A11y_BrowseGroupsButton = "Bouton Parcourir les groupes. Cliquez dessus pour acc\xe9der \xe0 la page des groupes.";
var A11y_BrowseOpportunitiesGridView = "Consulter toutes les opportunit\xe9s depuis un volet de pr\xe9visualisation";
var A11y_BrowseOpportunitiesListView = "Consulter toutes les opportunit\xe9s depuis un tableau simple";
var A11y_BrowsePathwaysButton = "Bouton Parcourir les parcours. Cliquez dessus pour acc\xe9der \xe0 la page des parcours.";
var A11y_BrowsePlansButton = "Bouton Parcourir les plans. Cliquez dessus pour acc\xe9der \xe0 la page des plans.";
var A11y_BulkDelete_Format = "Supprimer en bloc les {{count}}\xa0\xe9l\xe9ments s\xe9lectionn\xe9s";
var A11y_BulkDisable_Format = "Bulk disable {{count}} selected items";
var A11y_BulkEnable_Format = "Bulk enable {{count}} selected items";
var A11y_ButtonGroupWithNestedDropdown = "Bouton avec liste d\xe9roulante int\xe9gr\xe9e";
var A11y_CharacterLimit = "Limite de caract\xe8res\xa0: {{ limit }}";
var A11y_CollapsePanelButton = "\xab\xa0Masquer les d\xe9tails pour {{name}}\xa0\xbb";
var A11y_CollectionChangeAnnouncement = "Collection {{collectionName}} s\xe9lectionn\xe9e";
var A11y_CompletionProgressDetails = "Progression\xa0: {{numberCompleted}} sur {{total}}";
var A11y_ConfirmModal_input = "Input field for confirm dialog";
var A11y_ContentCompletedButton = "Bouton de validation pour {{title}}\xa0: Statut Termin\xe9";
var A11y_ContentNotCompletedButton = "Bouton de validation pour {{title}}\xa0: Statut Non termin\xe9";
var A11y_ContentTypesNavType = "Types de contenu";
var A11y_ContinuingEducationUnits = "Unit\xe9s de formation continue";
var A11y_CreateGroup = "Cr\xe9er un groupe";
var A11y_Date_YYYYMMDDFormat = "Format de date\xa0: aaaa-mm-dd";
var A11y_Delete_Format = "Supprimer {{item}}";
var A11y_DeleteLink = "Supprimer le lien {{linkTitle}}";
var A11y_Disable_Format = "D\xe9sactiver {{item}}";
var A11y_Edit_Format = "Modifier {{item}}";
var A11y_Enable_Format = "Activer {{item}}";
var A11y_EscapeToDismiss = "Appuyez sur la touche \xc9chap pour annuler";
var A11y_ExpandExperience = "Agrandir pour afficher plus de d\xe9tails sur cette exp\xe9rience";
var A11y_ExpandForSummary = "Agrandir pour afficher le r\xe9sum\xe9";
var A11y_ExpandForTitle = "Agrandir pour afficher le titre";
var A11y_ExpandPanelButton = "Afficher les d\xe9tails pour {{name}}";
var A11y_FollowingPathwayButton = "Suivre le parcours {{title}}\xa0: Statut Abonn\xe9";
var A11y_FollowingPlanButton = "Suivre le plan {{title}}\xa0: Statut Abonn\xe9";
var A11y_GlobalSearchInstructions = "Lorsque des suggestions sont disponibles, utilisez les fl\xe8ches du haut et du bas pour les passer en revue et appuyez sur la touche entr\xe9e pour les s\xe9lectionner. Pour les personnes utilisant des appareils tactiles, explorez ces suggestions en les touchant ou en balayant l’\xe9cran.";
var A11y_GoToProfile = "Acc\xe9der au profil de {{profileName}}";
var A11y_GroupJoinedButton = "Rejoindre le groupe {{title}}\xa0: Statut Membre";
var A11y_GroupNotJoinedButton = "Rejoindre le groupe {{title}}\xa0: Statut Non membre";
var A11y_LearningCollectionsNavType = "Collections d’apprentissage";
var A11y_LinkOpensNewWindow = "Ouvre un site externe dans une nouvelle fen\xeatre";
var A11y_MainPagesNavType = "Pages principales";
var A11y_NonOptionalStepsComplete = "Toutes les \xe9tapes obligatoires sont termin\xe9es";
var A11y_NotFollowingPathwayButton = "Suivre le parcours {{title}}\xa0: Statut Non abonn\xe9";
var A11y_NotFollowingPlanButton = "Suivre le plan {{title}}\xa0: Statut Non abonn\xe9";
var A11y_NumberOfSkills = "Nombre de comp\xe9tences";
var A11y_NumberSuggestionsAvailableFormat = "{{n}} suggestions sont disponibles";
var A11y_OpensInANewTab = "S’ouvre dans un nouvel onglet";
var A11y_OptionalStatus = "Statut facultatif";
var A11y_PositiveNumbersOnly = "Seuls les nombres positifs sont admis";
var A11y_RegistrationStatus = "Statut de l’inscription";
var A11y_RemoveCardType = "Supprimer la carte {{cardType}}";
var A11y_RemoveContent = "Supprimer l’\xe9l\xe9ment {{ contentType }} intitul\xe9 {{ contentTitle }}";
var A11y_RemoveSection = "Supprimer la section {{ sectionNumber }} intitul\xe9e {{ sectionTitle }}";
var A11y_RemoveSubsection = "Supprimer la section {{ sectionNumber }} ainsi que la sous-section {{ subsectionNumber }} intitul\xe9e {{ subsectionTitle }}";
var A11y_RemoveUser = "Supprimer {{userType}}";
var A11y_RotatingLogos = "Liste rotative des logos des clients";
var A11y_SearchAssignments = "Rechercher des formations assign\xe9es";
var A11y_SecondaryPagesNavType = "Pages secondaires";
var A11y_Select_Format = "S\xe9lectionner {{item}}";
var A11y_SessionStartDate = "Date de d\xe9but de la session";
var A11y_SliderDescription = "Curseur horizontal";
var A11y_SliderNavigation = "Pour JAWS, utilisez la touche Alt et les touches de direction. Pour VoiceOver/NVDA, utilisez les touches de direction.";
var A11y_TabChangeAnnouncement = "Onglet {{newPageTitle}} s\xe9lectionn\xe9";
var A11y_ToggleProductMenu = "Menu pour basculer entre les produits";
var A11y_ToggleProfileMenu = "Basculer entre les menus de profils";
var A11y_ToggleSearch = "Basculer vers la recherche";
var A11y_TrackerCurrentStep = "Actuellement dans {{stepName}}";
var A11y_TrackerStep = "\xc9tape {{stepName}}";
var A11y_TryOurBookmarklet = "Essayez notre bookmarklet. Cliquez sur ce bouton pour mettre \xe0 jour le contenu ci-dessous.";
var A11y_VerificationStatus = "Statut de la v\xe9rification";
var A11y_virtualDocument = "{{documentType}} virtuel";
var A11y_WizardClickExpand = "{{label}}\xa0: cliquer pour agrandir";
var A11y_WizardNavType = "Assistant de progression";
var AboutFooter_AltCareersIcon = "Ic\xf4ne Carri\xe8res";
var AboutFooter_AltContactIcon = "Ic\xf4ne Contact";
var AboutFooter_AltMissionIcon = "Ic\xf4ne Mission";
var AboutFooter_AltPressIcon = "Cliquez sur l’ic\xf4ne";
var AboutFooter_CareersAtDegreed = "Carri\xe8res chez Degreed";
var AboutFooter_ContactDegreed = "Contactez Degreed";
var AboutFooter_DegreedMission = "Mission Degreed";
var AboutFooter_DegreedPress = "Presse Degreed";
var AboutFooter_JailbreakTheDegree = "Simple. D\xe9bloquez votre dipl\xf4me.";
var AboutFooter_LearningAndWork = "Combinez travail et apprentissage.";
var AboutFooter_WeWantToHear = "Nous aimerions conna\xeetre votre opinion.";
var AboutFooter_WhatOthersAreSaying = "Ce que d’autres pensent de nous.";
var AccomplishmentFormCtrl_EndDate = "La date de fin doit avoir lieu apr\xe8s la date de d\xe9but.";
var AccomplishmentFormCtrl_ExpirationDate = "Veuillez indiquer la date d’expiration.";
var AccomplishmentFormCtrl_StateDate = "Veuillez indiquer la date de d\xe9but.";
var AccomplishmentFormCtrl_Title = "L’intitul\xe9 de l’accomplissement est requis.";
var AccountController_AccountLockedByOrgError = "Votre compte a \xe9t\xe9 verrouill\xe9. Veuillez contacter votre administrateur.";
var AccountController_AccountLockedError = "Votre compte est actuellement verrouill\xe9. Veuillez r\xe9essayer dans quelques minutes.";
var AccountController_AgreeWithTermsOne = "J’accepte les politiques Degreed suivantes\xa0:";
var AccountController_AgreeWithTermTwo = "Conditions d’utilisation";
var AccountController_And = "et";
var AccountController_ChangePassword = "Modifier le mot de passe";
var AccountController_ChangePasswordError = "Impossible de v\xe9rifier votre ancien mot de passe, veuillez r\xe9essayer.";
var AccountController_ChangePasswordTitle = "Modifier votre mot de passe";
var AccountController_ConfirmPassword = "Confirmer le mot de passe";
var AccountController_Continue = "Continuer";
var AccountController_ContinueWithSSO = "Continuer avec l’authentification unique (SSO)";
var AccountController_EmailAddress = "Adresse e-mail ou nom d’utilisateur";
var AccountController_EmailAddressPlaceholder = "jane@acme.com";
var AccountController_EmailExistsError = "Un compte utilisant cette adresse e-mail a d\xe9j\xe0 \xe9t\xe9 enregistr\xe9. Veuillez vous connecter en utilisant cette adresse e-mail.";
var AccountController_EmailLoginDisabledError = "Votre organisation ne vous a pas autoris\xe9 \xe0 vous connecter en utilisant un e-mail.";
var AccountController_EmailLoginError = "L’adresse e-mail ou le mot de passe fourni est incorrect(e).";
var AccountController_FacebookLogin = "Se connecter avec Facebook";
var AccountController_FirstName = "Pr\xe9nom";
var AccountController_Forgot = "D\xe9finir/r\xe9initialiser le mot de passe";
var AccountController_LoggedOutHeader = "Vous avez \xe9t\xe9 d\xe9connect\xe9(e).";
var AccountController_LoggedOutTitle = "D\xe9connect\xe9(e)";
var AccountController_Login = "Connexion";
var AccountController_LoginAgainButton = "Se reconnecter\xa0?";
var AccountController_LoginUsingPassword = "Connexion \xe0 l’aide du mot de passe";
var AccountController_LoginViewContent = "Connectez-vous pour afficher le contenu \xe0 partir de {0}";
var AccountController_NewPassword = "Nouveau mot de passe";
var AccountController_OldPassword = "Mot de passe actuel";
var AccountController_OldPasswordPlaceholder = "Saisissez votre mot de passe actuel";
var AccountController_Password = "Mot de passe";
var AccountController_PasswordMatchError = "Le nouveau mot de passe et sa confirmation sont diff\xe9rents.";
var AccountController_PasswordPatternInfo = "Les mots de passe doivent comprendre au minimum 8\xa0caract\xe8res, dont un chiffre et une lettre";
var AccountController_PrivacyPolicy = "Politique de confidentialit\xe9";
var AccountController_RecentPasswordError = "Vous avez utilis\xe9 ce mot de passe r\xe9cemment. Veuillez r\xe9essayer.";
var AccountController_Register = "Inscription";
var AccountController_RegisterEmailExistsError = "Un utilisateur s’est d\xe9j\xe0 inscrit avec l’adresse e-mail sp\xe9cifi\xe9e.";
var AccountController_RememberMe = "Se souvenir de moi";
var AccountController_ResetPassword = "R\xe9initialiser votre mot de passe.";
var AccountController_ResetYourPassword = "R\xe9initialiser le mot de passe";
var AccountController_SignUp = "Inscription";
var AccountController_SignUpPageTitle = "Inscription";
var AccountController_SignUpTitle = "S’inscrire.";
var AccountController_UsernameLoginError = "Le nom d’utilisateur ou le mot de passe que vous avez entr\xe9 est incorrect.";
var AccountController_ValidPassword = "Mot de passe valide";
var AccountController_WelcomeDegreed = "Bienvenue.";
var AccountCtrl_ContinueToAccount = "Suivez et am\xe9liorez vos comp\xe9tences.";
var AccountCtrl_LoginUsingProvider = "Connectez-vous {{name}} \xe0 l’aide de {{providerName}}.";
var AccountSvc_ChangeLinkFail = '<p>Il semble que ce lien n’est pas valide. Les liens de r\xe9initialisation de mot de passe sont actifs pendant une courte p\xe9riode. Pour r\xe9initialiser votre mot de passe, acc\xe9dez \xe0 la page de <a href="/account/login" class="underline">connexion</a> et r\xe9essayez.</p>';
var AccountSvc_ChangeSuccess = '<p>Mot de passe modifi\xe9. Vous pouvez d\xe9sormais <a href="/account/login" class="link">vous connecter</a></p>';
var AccountSvc_CreateAccountError = "Une erreur est survenue lors de la cr\xe9ation d’un nouveau compte.";
var AccountSvc_DefaultPassword = "<p>Il semble que vous avez un mot de passe par d\xe9faut. Vous devez modifier votre mot de passe avant de pouvoir utiliser Degreed.</p>";
var AccountSvc_DeleteAccount = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la suppression de votre compte. Contactez-nous pour obtenir de l’aide.";
var AccountSvc_EmailConfirmation = "<p>Avant de pouvoir v\xe9rifier votre adresse e-mail, nous devons nous assurer que vous poss\xe9dez le compte Degreed associ\xe9.</p><p>Veuillez vous connecter ou vous inscrire \xe0 un compte Degreed ci-dessous.</p>";
var AccountSvc_ForgotPassword = "<p>Entrez votre adresse e-mail principale pour vous envoyer un e-mail de r\xe9initialisation de mot de passe.</p><p>Si vous \xeates inscrit \xe0 l’aide de Facebook, connectez-vous avec Facebook.</p>";
var AccountSvc_GroupInvite = "<p>Vous avez re\xe7u une invitation \xe0 rejoindre un groupe sur Degreed.</p><p>Participez aux groupes de votre organisation et apprenez avec vos coll\xe8gues.</p>";
var AccountSvc_LoginError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la connexion. Contactez-nous pour obtenir de l’aide.";
var AccountSvc_OrgInvite = "<p>Vous avez re\xe7u une invitation \xe0 rejoindre<br>Degreed.</p><p>Participez aux groupes de votre organisation et apprenez avec vos coll\xe8gues.</p>";
var AccountSvc_OrgPasswordError = "D\xe9sol\xe9 ! Votre organisation ne vous a pas autoris\xe9 \xe0 r\xe9initialiser ou r\xe9cup\xe9rer votre mot de passe. Pour de plus amples informations, contactez Degreed.";
var AccountSvc_PasswordResetError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la r\xe9initialisation du mot de passe. Contactez-nous pour obtenir de l’aide.";
var AccountSvc_PasswordResetInstructionsMessage = "Instructions de r\xe9initialisation du mot de passe envoy\xe9es";
var AccountSvc_Restricted = "<p>Malheureusement, \xe0 ce moment-l\xe0, le Portail d’apprentissage n’est pas disponible pour les employ\xe9s r\xe9glement\xe9s.</p>";
var AccountSvc_SecondaryEmail = "<p>Connectez-vous avec votre courrier \xe9lectronique de votre organisation.</p>";
var AccountSvc_SessionExpired = "<p>Votre session a expir\xe9. Cocher la case \xab\xa0Se souvenir de moi\xa0\xbb vous permet de rester connect\xe9 plus longtemps, mais seulement sur un ordinateur priv\xe9.</p><p>Veuillez vous connecter \xe0 nouveau.</p>";
var AccountSvc_SignUp = "<p>Inscrivez-vous pour obtenir un compte Degreed.</p>";
var AccountSvc_Unsubscribe = "<p><strong>{{email}} a \xe9t\xe9 d\xe9sabonn\xe9 avec succ\xe8s \xe0 partir de {{newsletter}}</strong></p><p>Si vous souhaitez vous abonner de nouveau \xe0 un moment donn\xe9, vous pouvez le faire \xe0 partir de vos param\xe8tres.</p>";
var AccountSvc_UserEndorsement = "<p>Vous avez \xe9t\xe9 invit\xe9 \xe0 fournir une recommandation pour v\xe9rifier et corroborer l’expertise de quelqu’un. Votre recommandation constitue une part essentielle de cette op\xe9ration. Veuillez vous connecter ou vous inscrire \xe0 un compte Degreed ci-dessous pour compl\xe9ter la recommandation.</p>";
var ActiveLearner_Condition1 = "Vous avez partag\xe9 au moins 1\xa0\xe9l\xe9ment.";
var ActiveLearner_Condition1WithName = "{{name}} a partag\xe9 au moins 1\xa0\xe9l\xe9ment.";
var ActiveLearner_Condition2 = "Vous avez termin\xe9 au moins 5\xa0\xe9l\xe9ments.";
var ActiveLearner_Condition2WithName = "{{name}} a termin\xe9 au moins 5\xa0\xe9l\xe9ments.";
var ActiveLearner_Condition3 = "Vous avez ajout\xe9 au moins 3\xa0comp\xe9tences \xe0 votre profil.";
var ActiveLearner_Condition3WithName = "{{name}} a ajout\xe9 au moins 3\xa0comp\xe9tences \xe0 son profil.";
var ActiveLearner_Condition4 = "Vous effectuez une action tous les mois.";
var ActiveLearner_Condition4WithName = "{{name}} effectue une action tous les mois.";
var ActiveLearner_Congratulations = "F\xe9licitations\xa0!";
var ActiveLearner_CongratulationsText = "En fonction de votre activit\xe9, vous avez obtenu le statut d’apprenant(e) <a>actif(ve)</a>\xa0! Ceci signifie que vous \xeates parmi les meilleurs apprenants de votre organisation. Continuez comme \xe7a !";
var ActiveLearner_FinePrint = "Si vous n’utilisez pas Degreed au moins une fois tous les 30\xa0jours, vous perdrez votre statut d’apprenant actif. Mais ne vous inqui\xe9tez pas, vous le r\xe9cup\xe9rerez d\xe8s que vous reprendrez votre activit\xe9.";
var ActiveLearner_FinePrintWithName = "Si {{name}} n’utilise pas Degreed au moins une fois tous les 30\xa0jours, son statut d’apprenant actif sera perdu.";
var ActiveLearner_HowToGetRecognized = "Comment obtenir ce statut d’apprenant \xa0?";
var ActiveLearner_ModalTitle = "Vous disposez du statut d’apprenant actif";
var ActiveLearner_ModalTitleWithName = "{{name}} dispose du statut d’apprenant actif";
var addEditMetaDataModal_AddProperty = "Ajouter une propri\xe9t\xe9";
var addEditMetaDataModal_EditProperties = "Modifier les propri\xe9t\xe9s";
var addEditMetaDataModal_Property = "Propri\xe9t\xe9";
var addEditMetaDataModal_Purpose_RolePlan = "Plan d’\xe9volution de poste";
var addEditMetaDataModal_RemoveProperty = "Supprimer la propri\xe9t\xe9";
var addEditMetaDataModal_Value = "Valeur";
var addToPathwayModal_AddedSuccessfully = "Ajout au parcours effectu\xe9 avec succ\xe8s";
var addToPathwayModal_AddingError = "Une erreur est survenue lors de l’ajout au parcours";
var addToPathwayModal_AddItemDescription = "L’\xe9l\xe9ment sera ajout\xe9 dans la rubrique \xab\xa0Stock\xe9s temporairement\xa0\xbb du parcours que vous avez s\xe9lectionn\xe9. Vous pouvez utiliser l’\xe9diteur de parcours pour organiser le contenu en le\xe7ons.";
var addToPathwayModal_AddToCatalog = "Ajouter au catalogue";
var addToPathwayModal_AddToPathway = "Ajouter \xe0 un parcours";
var addToPathwayModal_CreatePathway = "Cr\xe9er un parcours";
var addToPathwayModal_CreatePathwayExplanation = "Vous ne semblez pas avoir cr\xe9\xe9 de parcours. Utilisez des parcours pour regrouper vos ressources de formation autour d’une comp\xe9tence ou d’un th\xe8me communs.";
var addToPathwayModal_CreateYourPathway = "Cr\xe9ez votre premier parcours\xa0!";
var addToPathwayModal_EditPathway = "Modifier le parcours";
var addToPathwayModal_GoToPathway = "Voir le parcours";
var addToPathwayModal_HoldForLater = "Stock\xe9s temporairement";
var addToPathwayModal_Lesson = "Sous-section";
var addToPathwayModal_LessonNumberFormat = "Sous-section\xa0{{number}}";
var addToPathwayModal_MostRecentPathways = "Parcours les plus r\xe9cents";
var addToPathwayModal_NoPathwayDescription = "Vous ne semblez pas avoir cr\xe9\xe9 de parcours. Utilisez des parcours pour regrouper vos ressources de formation autour d’une comp\xe9tence ou d’un th\xe8me communs.";
var addToPathwayModal_OrgManagedNotice = "Si vous ajoutez cet \xe9l\xe9ment, le parcours s\xe9lectionn\xe9 sera g\xe9r\xe9 par l’organisation. Pour en savoir plus sur les param\xe8tres de visibilit\xe9, consultez le {{anchorOpen}}Centre de connaissances Degreed{{anchorClose}}.";
var addToPathwayModal_Pathway = "Parcours";
var addToPathwayModal_RecentlyUsed = "Parcours utilis\xe9s r\xe9cemment";
var addToPathwayModal_SearchAuthoringPathway = "Rechercher les parcours dont vous \xeates l’auteur";
var addToPathwayModal_SearchYourPathways = "Rechercher vos parcours";
var addToPathwayModal_Section = "Section";
var addToPathwayModal_SectionNumberFormat = "Section {{number}}";
var addToPathwayModal_SelectLesson = "S\xe9lectionner une sous-section";
var addToPathwayModal_SelectPathway = "S\xe9lectionner un parcours";
var addToPathwayModal_SelectPathwaySection = "S\xe9lectionner une section de parcours";
var addToPathwayModal_SelectPathwaySubSection = "S\xe9lectionner une sous-section";
var addToPathwayModal_SelectSection = "S\xe9lectionner une section";
var addToPathwayModal_SuccessLabel = "{{startBold}}{{assignmentName}}{{endBold}} a bien \xe9t\xe9 ajout\xe9 \xe0 {{pathwayName}}.";
var addToPathwayModal_VisitPathwayEditPage = "Acc\xe9dez \xe0 la page d’\xe9dition du parcours pour organiser le contenu en le\xe7ons.";
var addToPathwayModal_WhichPathway = "\xc0 quel parcours souhaitez-vous ajouter ce th\xe8me?";
var addToPathwayModal_YourPathways = "Vos parcours";
var addToTargetModal_AddedItemSuccessfully = "{{resourceTitleHtml}} a bien \xe9t\xe9 ajout\xe9 \xe0 {{targetTitle}}.";
var addToTargetModal_AddedSuccessfully = "Ajout\xe9(s) au plan";
var addToTargetModal_AddingError = "Une erreur est survenue lors de l’ajout";
var addToTargetModal_AddItemDescription = "L’\xe9l\xe9ment sera ajout\xe9 au plan que vous s\xe9lectionnerez. Vous pouvez passer en mode \xe9dition pour organiser le contenu comme souhait\xe9.";
var addToTargetModal_AddToTarget = "Ajouter \xe0 un plan";
var addToTargetModal_CreateJobRoleExplanation = "Il semble que vous n’avez pas encore cr\xe9\xe9 de plan. Un plan est une collection de contenus s\xe9lectionn\xe9s portant sur des comp\xe9tences, des groupes, des personnes et des contenus sp\xe9cialement destin\xe9s \xe0 un objectif d’apprentissage particulier. Vous pouvez cr\xe9er un plan pour recueillir des ressources non tri\xe9es destin\xe9es \xe0 un objectif annuel, un d\xe9veloppement personnel ou une transition de poste.";
var addToTargetModal_CreateTarget = "Cr\xe9er un plan";
var addToTargetModal_CreateYourTarget = "Cr\xe9ez votre propre plan\xa0!";
var addToTargetModal_EditTarget = "Modifier le plan";
var addToTargetModal_GoToTarget = "Acc\xe9der au plan";
var addToTargetModal_MostRecentTargets = "Plans les plus r\xe9cents";
var addToTargetModal_NoSectionsFound = "Le plan s\xe9lectionn\xe9 ne comporte aucune section Ressources mixtes. L’ajout de cet \xe9l\xe9ment cr\xe9era une nouvelle section.";
var addToTargetModal_OrgManagedNotice = "Si vous ajoutez cet \xe9l\xe9ment, le plan s\xe9lectionn\xe9 sera g\xe9r\xe9 par l’organisation. Pour en savoir plus sur les param\xe8tres de visibilit\xe9, consultez le {{anchorOpen}}Centre de connaissances Degreed{{anchorClose}}.";
var addToTargetModal_SearchAuthoringTarget = "Rechercher les plans dont vous \xeates l’auteur";
var addToTargetModal_SearchYourTargets = "Rechercher vos plans";
var addToTargetModal_Section = "Section";
var addToTargetModal_SelectPlanSection = "S\xe9lectionner une section de plan";
var addToTargetModal_SelectSectionPlaceHolder = "S\xe9lectionner une section";
var addToTargetModal_SelectTargetPlaceHolder = "S\xe9lectionner un plan";
var addToTargetModal_VisitTargetEditPage = "Passez en mode \xe9dition pour organiser le contenu.";
var addToTargetModal_WhichTarget = "\xc0 quel plan souhaitez-vous ajouter cet \xe9l\xe9ment \xa0?";
var addToTargetModal_YourTargets = "Vos plans";
var alertModal_DontShowAgain = "Ne plus afficher ce message";
var AnonymousUserHelper_EmailName = "Anon. Apprenant";
var AnonymousUserHelper_Name = "Apprenant anonyme";
var AppHeader_AcademiesTitle = "Acad\xe9mies";
var AppHeader_BrowseTitle = "Parcourir";
var AppHeader_DgAssistantTitle = "Assistant";
var AppHeader_FeaturedTitle = "\xc0 la une";
var AppHeader_HomeTitle = "Accueil";
var AppHeader_Login = "Connexion";
var AppHeader_MaestroTitle = "Maestro";
var AppHeader_OpportunitiesTitle = "Opportunit\xe9s";
var AppHeader_ProfileTitle = "Profil";
var AppHeader_Signup = "Inscription";
var AppHeader_SkillCoachTitle = "Skill Coach";
var AppHeader_TeamTitle = "Skill Coach";
var AssessmentFormCtrl_AddAssessment = "Ajouter un test d’\xe9valuation";
var AssessmentFormCtrl_AddToCatalogFormat = "Ajoutez ce test d'\xe9valuation au catalogue {{orgName}}";
var AssessmentFormCtrl_AssessmentName = "Nom du test d’\xe9valuation";
var AssessmentFormCtrl_AssessmentProvider = "Fournisseur du test d’\xe9valuation";
var AssessmentFormCtrl_AssessmentUrl = "URL du test d’\xe9valuation";
var AssessmentFormCtrl_Category = "Veuillez ajouter au moins une cat\xe9gorie.";
var AssessmentFormCtrl_CorrectQuestions = "Le nombre de questions correctes ne doit pas \xeatre sup\xe9rieur au nombre de questions.";
var AssessmentFormCtrl_CorrectQuestionsFormat = "Questions correctes {{startTag}} (sur {{number}}) {{endTag}}";
var AssessmentFormCtrl_DateCompleted = "Date d’ex\xe9cution";
var AssessmentFormCtrl_Description = "Description";
var AssessmentFormCtrl_EditAssessment = "Modifier le test d’\xe9valuation";
var AssessmentFormCtrl_NameRequired = "Le nom du test d'\xe9valuation doit \xeatre renseign\xe9.";
var AssessmentFormCtrl_NumberOfQuestions = "Saisissez le nombre de questions.";
var AssessmentFormCtrl_NumberOfQuestionsError = "Saisissez le nombre de questions dont la r\xe9ponse est exacte.";
var AssessmentFormCtrl_Percentile = "Centile";
var AssessmentFormCtrl_SaveAssessment = "Enregistrer le test d’\xe9valuation";
var AssessmentFormCtrl_TotalQuestions = "Nombre total de questions";
var AssessmentFormCtrl_UrlRequired = "L’URL du test d’\xe9valuation doit \xeatre renseign\xe9e.";
var AssessmentFormCtrl_WhatDidYouLearnLong = "Qu’avez-vous appris gr\xe2ce \xe0 ce test d’\xe9valuation\xa0?";
var AssessmentFormCtrl_WhatDidYouLearnShort = "Qu’avez-vous appris\xa0?";
var assignedLearning_AlreadyAttendAssignedByFormat = "{{nameHtml}} a demand\xe9 \xe0 {{groupNameHtml}} de participer \xe0 ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}, mais vous l’avez d\xe9j\xe0 fait. Excellent travail, vous vous surpassez !";
var assignedLearning_AlreadyCompletedAssignedByFormat = "{{nameHtml}} a demand\xe9 \xe0 {{groupNameHtml}} de terminer ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}, mais vous l’avez d\xe9j\xe0 fait. Excellent travail, vous vous surpassez !";
var assignedLearning_AlreadyFollowAssignedByFormat = "{{nameHtml}} a demand\xe9 \xe0 {{groupNameHtml}} de suivre ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}, mais vous l’avez d\xe9j\xe0 fait. Excellent travail, vous vous surpassez !";
var assignedLearning_AlreadyReadAssignedByFormat = "{{nameHtml}} a demand\xe9 \xe0 {{groupNameHtml}} de lire ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}, mais vous l’avez d\xe9j\xe0 fait. Excellent travail, vous vous surpassez !";
var assignedLearning_AlreadyWatchedAssignedByFormat = "{{nameHtml}} a demand\xe9 \xe0 {{groupNameHtml}} de regarder ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}, mais vous l’avez d\xe9j\xe0 fait. Excellent travail, vous vous surpassez !";
var assignedLearning_Completed = "Vous avez termin\xe9 cette assignation le {{completedDate}}";
var assignedLearning_CompletedNoDate = "Vous avez termin\xe9 cette assignation";
var assignedLearning_DueLater = "{{nameHtml}} vous a demand\xe9 de terminer ceci avant le {{date}}";
var assignedLearning_DueLaterExternal = "Il vous a \xe9t\xe9 demand\xe9 de terminer ceci avant le {{date}}";
var assignedLearning_DueLaterGroup = "{{nameHtml}} a demand\xe9 \xe0 votre {{groupNameHtml}} de terminer ceci avant le {{date}}";
var assignedLearning_DueSoon = "Il vous a \xe9t\xe9 demand\xe9 de terminer ceci dans {{days}}\xa0jour(s)";
var assignedLearning_GroupAlreadyAttendedFormat = "{{nameHtml}} a demand\xe9 \xe0 {{groupNameHtml}} de participer \xe0 ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}, mais vous l’avez d\xe9j\xe0 fait. Excellent travail, vous vous surpassez !";
var assignedLearning_GroupAlreadyAttendedFormerLearnerFormat = "Un ancien apprenant a demand\xe9 \xe0 {{groupNameHtml}} de participer \xe0 ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}, mais vous l’avez d\xe9j\xe0 fait. Excellent travail, vous vous surpassez\xa0!";
var assignedLearning_GroupAlreadyCompletedDateFormat = "{{nameHtml}} a demand\xe9 \xe0 {{groupNameHtml}} de {{action}} ceci ({{type}}) d’ici le {{date}}, mais vous l’avez d\xe9j\xe0 fait. Excellent travail, vous vous surpassez !";
var assignedLearning_GroupAlreadyCompletedDateFormerLearnerFormat = "Un ancien apprenant a demand\xe9 \xe0 {{groupNameHtml}} de {{action}} ceci ({{type}}) avant le {{date}}, mais vous l’avez d\xe9j\xe0 fait. Excellent travail, vous vous surpassez\xa0!";
var assignedLearning_GroupAlreadyCompletedFormat = "{{nameHtml}} a demand\xe9 \xe0 {{groupNameHtml}} de terminer ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}, mais vous l’avez d\xe9j\xe0 fait. Excellent travail, vous vous surpassez !";
var assignedLearning_GroupAlreadyCompletedFormerLearnerFormat = "Un ancien apprenant a demand\xe9 \xe0 {{groupNameHtml}} de terminer ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}, mais vous l’avez d\xe9j\xe0 fait. Excellent travail, vous vous surpassez\xa0!";
var assignedLearning_GroupAlreadyCompletedNoDateFormat = "{{nameHtml}} a demand\xe9 \xe0 {{groupNameHtml}} de {{action}} ceci ({{type}}), mais vous l’avez d\xe9j\xe0 fait. Excellent travail, vous vous surpassez !";
var assignedLearning_GroupAlreadyCompletedNoDateFormerLearnerFormat = "Un ancien apprenant a demand\xe9 \xe0 {{groupNameHtml}} de {{action}} ceci ({{type}}), mais vous l’avez d\xe9j\xe0 fait. Excellent travail, vous vous surpassez\xa0!";
var assignedLearning_GroupAlreadyFollowedFormat = "{{nameHtml}} a demand\xe9 \xe0 {{groupNameHtml}} de suivre ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}, mais vous l’avez d\xe9j\xe0 fait. Excellent travail, vous vous surpassez !";
var assignedLearning_GroupAlreadyFollowedFormerLearnerFormat = "Un ancien apprenant a demand\xe9 \xe0 {{groupNameHtml}} de suivre ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}, mais vous l’avez d\xe9j\xe0 fait. Excellent travail, vous vous surpassez\xa0!";
var assignedLearning_GroupAlreadyReadFormat = "{{nameHtml}} a demand\xe9 \xe0 {{groupNameHtml}} de lire ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}, mais vous l’avez d\xe9j\xe0 fait. Excellent travail, vous vous surpassez !";
var assignedLearning_GroupAlreadyReadFormerLearnerFormat = "Un ancien apprenant a demand\xe9 \xe0 {{groupNameHtml}} de lire ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}, mais vous l’avez d\xe9j\xe0 fait. Excellent travail, vous vous surpassez\xa0!";
var assignedLearning_GroupAlreadyWatchedFormat = "{{nameHtml}} a demand\xe9 \xe0 {{groupNameHtml}} de regarder ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}, mais vous l’avez d\xe9j\xe0 fait. Excellent travail, vous vous surpassez !";
var assignedLearning_GroupAlreadyWatchedFormerLearnerFormat = "Un ancien apprenant a demand\xe9 \xe0 {{groupNameHtml}} de regarder ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}, mais vous l’avez d\xe9j\xe0 fait. Excellent travail, vous vous surpassez\xa0!";
var assignedLearning_GroupAttendedFormat = "{{nameHtml}} a demand\xe9 \xe0 {{groupNameHtml}} de participer \xe0 ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}";
var assignedLearning_GroupAttendedFormerLearnerFormat = "Un ancien apprenant a demand\xe9 \xe0 {{groupNameHtml}} de participer \xe0 ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}.";
var assignedLearning_GroupCompletedFormat = "{{nameHtml}} a demand\xe9 \xe0 {{groupNameHtml}} de terminer ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}.";
var assignedLearning_GroupCompletedFormerLearnerFormat = "Un ancien apprenant a demand\xe9 \xe0 {{groupNameHtml}} de terminer ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}.";
var assignedLearning_GroupDateFormat = "{{nameHtml}} a attribu\xe9 {{groupNameHtml}} ceci {{type}} \xe0 {{action}} par {{date}}";
var assignedLearning_GroupDateFormerLearnerFormat = "Un ancien apprenant a demand\xe9 \xe0 {{groupNameHtml}} de {{action}} ceci ({{type}}) avant le {{date}}.";
var assignedLearning_GroupFollowedFormat = "{{nameHtml}} a demand\xe9 \xe0 {{groupNameHtml}} de suivre ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}";
var assignedLearning_GroupFollowedFormerLearnerFormat = "Un ancien apprenant a demand\xe9 \xe0 {{groupNameHtml}} de suivre ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}.";
var assignedLearning_GroupNoDateFormat = "{{nameHtml}} a attribu\xe9 {{groupNameHtml}} ceci {{type}} \xe0 {{action}}";
var assignedLearning_GroupNoDateFormerLearnerFormat = "Un ancien apprenant a demand\xe9 \xe0 {{groupNameHtml}} de {{action}} ceci ({{type}}).";
var assignedLearning_GroupReadFormat = "{{nameHtml}} a demand\xe9 \xe0 {{groupNameHtml}} de lire ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}";
var assignedLearning_GroupReadFormerLearnerFormat = "Un ancien apprenant a demand\xe9 \xe0 {{groupNameHtml}} de lire ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}.";
var assignedLearning_GroupWatchedFormat = "{{nameHtml}} a demand\xe9 \xe0 {{groupNameHtml}} de regarder ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}";
var assignedLearning_GroupWatchedFormerLearnerFormat = "Un ancien apprenant a demand\xe9 \xe0 {{groupNameHtml}} de regarder ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}.";
var assignedLearning_NoDueDate = "{{nameHtml}} vous a demand\xe9 de terminer ceci";
var assignedLearning_NoDueDateExternal = "Il vous a \xe9t\xe9 demand\xe9 de terminer ceci";
var assignedLearning_Overdue = "Il vous a \xe9t\xe9 demand\xe9 de terminer ceci il y a {{days}}\xa0jour(s)";
var assignedLearning_RequiredLearningTimeTip = "Si vous pensez avoir d\xe9j\xe0 termin\xe9 ceci, v\xe9rifiez \xe0 nouveau demain. Si l’\xe9l\xe9ment est toujours ici, v\xe9rifiez que vous l’avez bien termin\xe9 sur le site Web du fournisseur.";
var assignedLearning_YouAlreadyAttendedFormat = "{{nameHtml}} vous a demand\xe9 de participer \xe0 ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}, mais vous l’avez d\xe9j\xe0 fait. Excellent travail, vous vous surpassez !";
var assignedLearning_YouAlreadyAttendedFormerLearnerFormat = "Un ancien apprenant vous a demand\xe9 de participer \xe0 ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}, mais vous l’avez d\xe9j\xe0 fait. Excellent travail, vous vous surpassez\xa0!";
var assignedLearning_YouAlreadyCompletedDateFormat = "{{nameHtml}} vous a demand\xe9 de {{action}} ceci ({{type}}) d’ici le {{date}}, mais vous l’avez d\xe9j\xe0 fait. Excellent travail, vous vous surpassez !";
var assignedLearning_YouAlreadyCompletedDateFormerLearnerFormat = "Un ancien apprenant vous a demand\xe9 de {{action}} ceci ({{type}}) avant le {{date}}, mais vous l’avez d\xe9j\xe0 fait. Excellent travail, vous vous surpassez\xa0!";
var assignedLearning_YouAlreadyCompletedFormat = "{{nameHtml}} vous a demand\xe9 de terminer ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}, mais vous l’avez d\xe9j\xe0 fait. Excellent travail, vous vous surpassez !";
var assignedLearning_YouAlreadyCompletedFormerLearnerFormat = "Un ancien apprenant vous a demand\xe9 de terminer ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}, mais vous l’avez d\xe9j\xe0 fait. Excellent travail, vous vous surpassez\xa0!";
var assignedLearning_YouAlreadyCompletedFormerLearnerNoDateFormat = "Un ancien apprenant vous a demand\xe9 de {{action}} ceci ({{type}}), mais vous l’avez d\xe9j\xe0 fait. Excellent travail, vous vous surpassez\xa0!";
var assignedLearning_YouAlreadyCompletedNoDateFormat = "{{nameHtml}} vous a demand\xe9 de {{action}} ceci ({{type}}), mais vous l’avez d\xe9j\xe0 fait. Excellent travail, vous vous surpassez !";
var assignedLearning_YouAlreadyFollowedFormat = "{{nameHtml}} vous a demand\xe9 de suivre ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}, mais vous l’avez d\xe9j\xe0 fait. Excellent travail, vous vous surpassez\xa0!";
var assignedLearning_YouAlreadyFollowedFormerLearnerFormat = "Un ancien apprenant vous a demand\xe9 de suivre ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}, mais vous l’avez d\xe9j\xe0 fait. Excellent travail, vous vous surpassez\xa0!";
var assignedLearning_YouAlreadyReadFormat = "{{nameHtml}} vous a demand\xe9 de lire ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}, mais vous l’avez d\xe9j\xe0 fait. Excellent travail, vous vous surpassez !";
var assignedLearning_YouAlreadyReadFormerLearnerFormat = "Un ancien apprenant vous a demand\xe9 de lire ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}, mais vous l’avez d\xe9j\xe0 fait. Excellent travail, vous vous surpassez\xa0!";
var assignedLearning_YouAlreadyWatchedFormat = "{{nameHtml}} vous a demand\xe9 de regarder ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}, mais vous l’avez d\xe9j\xe0 fait. Excellent travail, vous vous surpassez !";
var assignedLearning_YouAlreadyWatchedFormerLearnerFormat = "Un ancien apprenant vous a demand\xe9 de regarder ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}, mais vous l’avez d\xe9j\xe0 fait. Excellent travail, vous vous surpassez\xa0!";
var assignedLearning_YouAttendedFormat = "{{nameHtml}} vous a demand\xe9 de participer \xe0 ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}";
var assignedLearning_YouAttendedFormerLearnerFormat = "Un ancien apprenant vous a demand\xe9 de participer \xe0 ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}.";
var assignedLearning_YouCompletedFormat = "{{nameHtml}} vous a demand\xe9 de terminer ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}.";
var assignedLearning_YouCompletedFormerLearnerFormat = "Un ancien apprenant vous a demand\xe9 de terminer ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}.";
var assignedLearning_YouDateFormat = "{{nameHtml}} vous a attribu\xe9 ceci {{type}} \xe0 {{action}} par {{date}}";
var assignedLearning_YouDateFormerLearnerFormat = "Un ancien apprenant vous a demand\xe9 de {{action}} ceci ({{type}}) avant le {{date}}.";
var assignedLearning_YouFollowedFormat = "{{nameHtml}} vous a demand\xe9 de suivre ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}.";
var assignedLearning_YouFollowedFormerLearnerFormat = "Un ancien apprenant vous a demand\xe9 de suivre ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}.";
var assignedLearning_YouNoDateFormat = "{{nameHtml}} vous a attribu\xe9 ceci {{type}} \xe0 {{action}}";
var assignedLearning_YouNoDateFormerLearnerFormat = "Un ancien apprenant vous a demand\xe9 de {{action}} ceci ({{type}}).";
var assignedLearning_YouReadFormat = "{{nameHtml}} vous a demand\xe9 de lire ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}";
var assignedLearning_YouReadFormerLearnerFormat = "Un ancien apprenant vous a demand\xe9 de lire ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}.";
var assignedLearning_YouWatchedFormat = "{{nameHtml}} vous a demand\xe9 de regarder ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}";
var assignedLearning_YouWatchedFormerLearnerFormat = "Un ancien apprenant vous a demand\xe9 de regarder ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}.";
var Attributes_AddHiddenAttributes = "Ajouter des attributs masqu\xe9s";
var Attributes_Attribute = "Attribut";
var Attributes_AttributeDataType = "Type de donn\xe9es";
var Attributes_AttributeFeatureName = "Visibilit\xe9 de la fonctionnalit\xe9";
var Attributes_AttributeFilterLabel = "Filtre par attribut";
var Attributes_AttributeFilterModal_AddButton = "Ajouter un attribut";
var Attributes_AttributeFilterModal_AttributeFieldLabel = "Attribut";
var Attributes_AttributeFilterModal_AttributeFieldPlaceHolder = "S\xe9lectionner un attribut personnalis\xe9";
var Attributes_AttributeFilterModal_OperatorFieldLabel = "Op\xe9rateur";
var Attributes_AttributeFilterModal_OperatorFieldPlaceHolder = "S\xe9lectionner un op\xe9rateur";
var Attributes_AttributeFilterModal_Title = "Filtre par attribut";
var Attributes_AttributeFilterModal_ValuesFieldHint = "Saisissez jusqu’\xe0 10\xa0valeurs";
var Attributes_AttributeFilterModal_ValuesFieldLabel = "Valeurs";
var Attributes_AttributesDescription = "Les attributs standard sont les attributs utilisateurs de base disponibles dans Degreed. Les attributs personnalis\xe9s sont les attributs utilisateurs suppl\xe9mentaires que votre organisation transmet \xe0 Degreed par le biais du fichier utilisateur ou de l’API. La colonne Champ entrant indique les attributs utilisateurs qui sont associ\xe9s aux attributs standard dans la colonne Attribut. Si le nom du champ entrant n’est pas le m\xeame que celui de l’attribut, le nom de l’attribut est indiqu\xe9 dans les fonctions d’administration.";
var Attributes_AttributesHeading = "Attributs standard et personnalis\xe9s";
var Attributes_AttributesLabel = "Attributs";
var Attributes_AttributeSource = "Standard/personnalis\xe9";
var Attributes_Bool = "Bool\xe9en";
var Attributes_BusinessRules = "Automatisations";
var Attributes_Custom = "Personnalis\xe9";
var Attributes_CustomAttributes = "Attributs personnalis\xe9s";
var Attributes_CustomAttributesDescription = "Les attributs personnalis\xe9s sont des champs suppl\xe9mentaires que votre organisation envoie \xe0 Degreed (\xe0 partir de fichiers ou de l’API). Les attributs visibles apparaissent dans les fonctions d’administration. Les attributs masqu\xe9s restent priv\xe9s et n’apparaissent dans aucune fonction.";
var Attributes_CustomData = "Donn\xe9es personnalis\xe9es";
var Attributes_DataType = "Type de donn\xe9es";
var Attributes_DataTypes_Description = "S\xe9lectionnez le type de donn\xe9es pour cet attribut. Cela garantit que toutes les op\xe9rations sont effectu\xe9es comme pr\xe9vu.";
var Attributes_DateTime = "Date-heure";
var Attributes_DateTimeOLD = "Date";
var Attributes_DefaultVisibility = "Visibilit\xe9 par d\xe9faut";
var Attributes_DefaultVisibilityDescription = "Activez automatiquement les nouveaux attributs personnalis\xe9s envoy\xe9s \xe0 Degreed afin de les utiliser dans les r\xe8gles m\xe9tier, les segments, les rapports et Engage.";
var Attributes_EditAttributeSettings = "Modifier les param\xe8tres d’attribut";
var Attributes_Feature_BusinessRules = "Automatisations";
var Attributes_Feature_Segments = "Segments";
var Attributes_FeatureVisibility = "Visibilit\xe9 de la fonctionnalit\xe9";
var Attributes_FeatureVisibility_Description = "Choisissez l’endroit o\xf9 vous souhaitez que cet attribut soit disponible.";
var Attributes_FieldType_Datetime = "Date-heure";
var Attributes_FieldType_Number = "Nombre";
var Attributes_FieldType_String = "Cha\xeene";
var Attributes_IncomingField = "Champ entrant";
var Attributes_IncomingFields = "Champs entrants";
var Attributes_Instructions = "Cette page vous permet de visualiser et de g\xe9rer les attributs des utilisateurs dans Degreed. Ces attributs sont utilis\xe9s dans les fonctions d’administration, telles que les r\xe8gles m\xe9tier, les segments, les rapports et Engage.";
var Attributes_NoMatches = "Aucun attribut ne correspond au terme recherch\xe9, veuillez effectuer une nouvelle recherche.";
var Attributes_NoResults = "Tous les attributs sont actuellement visibles.";
var Attributes_NoVisibleAttributes = "Aucun attribut personnalis\xe9 n’est visible";
var Attributes_NoVisibleAttributesInstructions = "Cliquez sur le menu d\xe9roulant Ajouter des attributs masqu\xe9s pour activer des attributs.";
var Attributes_Number = "Nombre";
var Attributes_NumberOLD = "Nombre entier";
var Attributes_RemoveAttributeFormat = "Supprimer l’attribut\xa0: {{ attributeName }}";
var Attributes_Segments = "Segments";
var Attributes_Standard = "Standard";
var Attributes_StandardAttributes = "Attributs standard";
var Attributes_StandardAttributesInstructions = "Les attributs standards sont les attributs de base disponibles dans Degreed. Le tableau ci-dessous montre comment votre organisation met en relation ses donn\xe9es d’attributs (\xe0 partir de fichiers ou de l’API) avec les attributs standards de Degreed. Si le champ entrant a un nom diff\xe9rent de l’attribut standard auquel il est associ\xe9, c’est le nom de l’attribut standard qui appara\xeet dans les fonctions d’administration.";
var Attributes_StandardCustom = "Standard/personnalis\xe9";
var Attributes_String = "Cha\xeene";
var Attributes_StringOLD = "Cha\xeene";
var Attributes_UserAttributes = "Attributs utilisateurs";
var Attributes_UserAttributesDescription = "Affichez et g\xe9rez les attributs utilisateur employ\xe9s dans des fonctions d’administration telles que les automatisations et les segments.";
var Attributes_VisibleAttributes = "Attributs visibles";
var Attributes_VisibleAttributesDescription = "Ces attributs sont ceux qui sont actuellement visibles dans les fonctions d’administration.";
var Attributes_Warning_ConversionResultsInDataLoss_Format = "Les valeurs des attributs de {{count}}\xa0utilisateurs ne correspondent pas au type de donn\xe9es que vous avez s\xe9lectionn\xe9. Cela peut affecter l’ex\xe9cution des op\xe9rations. Veuillez v\xe9rifier dans votre fichier utilisateur ou l’API les valeurs qui ne correspondent pas au type de donn\xe9es s\xe9lectionn\xe9 pour cet attribut.";
var Attributes_Warning_InvalidConversionToBoolean = "Il n’est pas recommand\xe9 de modifier un type de donn\xe9es de Bol\xe9en \xe0 Date-heure ou de Date-heure \xe0 Bool\xe9en. Si une des valeurs pr\xe9sentes ne correspond pas au nouveau type de donn\xe9es, il n’y aura pas de valeur pour cet utilisateur dans les rapports et une r\xe8gle m\xe9tier ou un segment utilisant l’attribut ne lui sera pas appliqu\xe9.";
var Attributes_Warning_InvalidConversionToDateTime = "Il n’est pas recommand\xe9 de changer un type de donn\xe9es de Date-heure \xe0 Nombre ou de Nombre \xe0 Date-heure. Si une des valeurs pr\xe9sentes ne correspond pas au nouveau type de donn\xe9es, il n’y aura pas de valeur pour cet utilisateur dans les rapports et une r\xe8gle m\xe9tier ou un segment qui utilise l’attribut ne lui sera pas appliqu\xe9.";
var Attributes_Warning_InvalidConversionToNumber = "Il n’est pas recommand\xe9 de changer un type de donn\xe9es de Date-heure \xe0 Nombre ou de Nombre \xe0 Date-heure. Si une des valeurs pr\xe9sentes ne correspond pas au nouveau type de donn\xe9es, il n’y aura pas de valeur pour cet utilisateur dans les rapports et une r\xe8gle m\xe9tier ou un segment qui utilise l’attribut ne lui sera pas appliqu\xe9.";
var Attributes_Warning_TypeMismatch_Format = "Les valeurs des attributs de {{count}}\xa0utilisateurs ne correspondent pas au type de donn\xe9es que vous avez s\xe9lectionn\xe9. Cela peut affecter l’ex\xe9cution des op\xe9rations. Veuillez v\xe9rifier dans votre fichier utilisateur ou l’API les valeurs qui ne correspondent pas au type de donn\xe9es s\xe9lectionn\xe9 pour cet attribut.";
var Automation_AcademyConditions = "Conditions relatives aux acad\xe9mies";
var Automation_AcademyConditions_Description = "D\xe9finir le public cible par type d’utilisateur et par statut dans une acad\xe9mie";
var Automation_AcademyName = "Nom de l’acad\xe9mie";
var Automation_AcademyStatus_Completed = "Termin\xe9";
var Automation_AcademyStatus_Dropped = "Abandon";
var Automation_AcademyStatus_InProgress = "En cours";
var Automation_AcademyStatus_NotStarted = "Pas encore commenc\xe9";
var Automation_AcmAddUser_Format = "Enable Academy Admin Access ({{count}})";
var Automation_AcmDeleteUser_Format = "Disable ACM Access ({{count}})";
var Automation_AcmSelectRole = "Select Role";
var Automation_Action = "Action";
var Automation_Action_Delete = "Action supprim\xe9e";
var Automation_Action_Insert = "Action ajout\xe9e";
var Automation_Action_Update = "Action mise \xe0 jour";
var Automation_ActionDeleted = "L’action a \xe9t\xe9 supprim\xe9e.";
var Automation_ActionDesc = "Les actions sont les r\xe9sultats d’une automatisation.";
var Automation_ActionHasBeenAdded = "Une action a \xe9t\xe9 ajout\xe9e \xe0 cette r\xe8gle.";
var Automation_ActionHasNotBeenAdded = "Veuillez ajouter au moins une action pour activer cette r\xe8gle.";
var Automation_ActionLabel_Group = "Nom du groupe";
var Automation_ActionLabel_Pathway = "Nom du parcours";
var Automation_ActionLabel_PermissionRole = "Nom du poste";
var Automation_ActionLabel_Privacy = "Nom de la confidentialit\xe9";
var Automation_ActionLabel_Provider = "Nom du fournisseur";
var Automation_ActionLabel_Skill = "Nom de la comp\xe9tence";
var Automation_ActionLabel_Target = "Nom du plan";
var Automation_ActionNoConfigurationNeeded = "This action needs no configuration.";
var Automation_Actions = "Actions";
var Automation_AddAcademyCondition = "Ajouter une condition relative aux acad\xe9mies";
var Automation_AddGroupCondition = "Add Group Condition";
var Automation_AddProviderLicense_Format = "Ajouter la visibilit\xe9 du fournisseur ({{count}})";
var Automation_AddRole_Format = "Mettre \xe0 jour le r\xf4le d’autorisation ({{count}})";
var Automation_AddSkill_Format = "Ajouter une comp\xe9tence ({{count}})";
var Automation_AddSkillCondition = "Ajouter une condition relative aux comp\xe9tences";
var Automation_AddSkillPlan_Format = "Ajouter un plan ({{count}})";
var Automation_AddToGroup_Format = "Ajouter un groupe ({{count}})";
var Automation_AddToPathway_Format = "Ajouter un parcours ({{count}})";
var Automation_AreYouSure_DeleteAutomations_Format = "Voulez-vous vraiment supprimer d\xe9finitivement les {{count}}\xa0automatisations suivantes\xa0?";
var Automation_AssignedBy_Format = "{{ content }} <strong>ASSIGN\xc9(E) PAR</strong> {{ person }} <strong>\xc9CH\xc9ANCE</strong> {{ date }}";
var Automation_AssignedByInDays_Format = "{{ content }} <strong>ASSIGN\xc9(E) PAR</strong> {{ person }} <strong>\xc9CH\xc9ANCE</strong> {{ number }}\xa0jours";
var Automation_AssignResource_Format = "Assigner ({{count}})";
var Automation_AttributeValue_HelperText = "Type an attribute value and use the enter key to add any number of attribute values.";
var Automation_Automation = "Automatisation";
var Automation_AutomationBuilder = "G\xe9n\xe9rateur d’automatisations";
var Automation_AutomationCreated = "Automatisation cr\xe9\xe9e";
var Automation_AutomationDetails = "D\xe9tails de l’automatisation";
var Automation_AutomationDisabled = "Automatisation d\xe9sactiv\xe9e";
var Automation_AutomationEnabled = "Automatisation activ\xe9e";
var Automation_AutomationLastUpdated = "Derni\xe8re mise \xe0 jour de l’automatisation";
var Automation_AutomationName = "Nom de l’automatisation";
var Automation_Automations = "Automatisations";
var Automation_AutomationUpdated = "Automatisation mise \xe0 jour";
var Automation_BulkEnable_SomeRulesInvalidWarning = "One or more selected rules do not meet minimum requirements to enable and will remain disabled.";
var Automation_CadenceDailyTime_Format = "Quotidienne (jours de la semaine) <strong>\xc0</strong> {{ time }} (UTC)";
var Automation_CadenceDateTime_Format = "{{ cadence }} <strong>LE</strong> {{ date }} <strong>\xc0</strong> {{ time }} (UTC)";
var Automation_CadenceDayOfTime_Format = "{{ cadence }} <strong>LE</strong> {{ date }} <strong>\xc0</strong> {{ time }} (UTC)";
var Automation_CadenceOnceTime_Format = "Automation_CadenceOnceTime_Format";
var Automation_CannotEnableAtThisTime = "Au minimum un facteur de d\xe9clenchement et une action sont n\xe9cessaires pour activer l’automatisation.";
var Automation_ChangeDetails = "D\xe9tails du changement";
var Automation_ChangedTo = "was changed to";
var Automation_Changes = "Modifications";
var Automation_Changes_Format = "{{ count }}\xa0modification(s)";
var Automation_CloneAutomation = "Cloner l’automatisation";
var Automation_CloneAutomationFormat = "Voulez-vous vraiment cloner l’automatisation {{name}}\xa0? L’automatisation clon\xe9e s’ouvrira en mode brouillon pour que vous puissiez la modifier.";
var Automation_Communication = "Communication";
var Automation_ConditionHelp = "Les conditions limitent le champ d’application de l’automatisation. Vous ne pouvez pas d\xe9passer 20\xa0conditions.";
var Automation_ConditionsLimit = "Vous ne pouvez pas d\xe9passer cinq\xa0conditions.";
var Automation_CreateAnAutomation = "Cr\xe9er une automatisation";
var Automation_CreateYourFirst_Description = "Toutes les automatisations cr\xe9\xe9es dans votre organisation s’afficheront ici.";
var Automation_CreateYourFirst_Header = "Cr\xe9ez votre premi\xe8re automatisation";
var Automation_CurrentlyEditingTitleAndDescription = "Intitul\xe9 et description en cours de modification";
var Automation_CurrentlyEditingTriggers = "D\xe9clencheurs en cours de modification";
var Automation_DateUpdated = "Date de mise \xe0 jour";
var Automation_DeleteAction = "Supprimer l’action";
var Automation_DeleteActionConfirmation = "Voulez-vous vraiment supprimer cette action\xa0?";
var Automation_DeleteAutomation = "Supprimer l’automatisation";
var Automation_DeleteAutomations = "Supprimer les automatisations";
var Automation_DeleteConditions = "Supprimer les conditions";
var Automation_DeleteConditions_Confirmation = "Voulez-vous vraiment supprimer d\xe9finitivement toutes les conditions\xa0?";
var Automation_DeleteOnlyActionConfirmation = "Une automatisation n\xe9cessite au moins un d\xe9clencheur et une action pour \xeatre activ\xe9e. Supprimer toutes les actions d\xe9sactivera l’automatisation. Voulez-vous vraiment supprimer cette action\xa0?";
var Automation_DeleteUser_Format = "Supprimer l’utilisateur ({{count}})";
var Automation_Description = "Description (facultative)";
var Automation_Description_Delete = "Description supprim\xe9e";
var Automation_Description_Insert = "Description ajout\xe9e";
var Automation_Description_Update = "Description mise \xe0 jour";
var Automation_DisableAutomations = "Disable Automations";
var Automation_DisableAutomations_Format = "Are you sure you want to disable the following {{count}} Automations?";
var Automation_DueDate_None = "Aucune";
var Automation_DueDate_Relative = "\xc9ch\xe9ance (nombre de jours)";
var Automation_DueDate_Specific = "\xc9ch\xe9ance (date fixe)";
var Automation_EditableAttributeWarning = "Les utilisateurs peuvent modifier cet attribut dans l’application Degreed. Les automatisations s’ex\xe9cuteront en fonction de la derni\xe8re valeur mise \xe0 jour.";
var Automation_EditableAttributeWarning_Format = "Les valeurs de {{attribute}} peuvent \xeatre modifi\xe9es par les utilisateurs et les administrateurs \xe0 partir de diverses sources. Les automatisations se basent sur la valeur la plus r\xe9cente.";
var Automation_EditAutomation = "Modifier l’automatisation";
var Automation_EditTitleAndDescription = "Modifier l’intitul\xe9 et la description";
var Automation_EditTrigger = "Modifier le d\xe9clencheur";
var Automation_EnableAutomation = "Activer l’automatisation";
var Automation_EnableAutomationDescription = "Lorsqu’une automatisation est activ\xe9e, elle s’ex\xe9cute chaque fois que les conditions sont remplies. Vous pouvez d\xe9sactiver l’automatisation \xe0 tout moment pour suspendre la r\xe8gle.";
var Automation_EnableAutomations = "Enable Automations";
var Automation_EnableAutomations_Format = "Are you sure you want to enable the following {{count}} Automations?";
var Automation_EnabledOrDisabled = "Activ\xe9e/D\xe9sactiv\xe9e";
var Automation_Event_ContentCompleted = "L’utilisateur termine le contenu";
var Automation_Event_GroupJoined = "L’utilisateur rejoint le groupe";
var Automation_Event_MentorshipCompleted = "L’utilisateur termine son mentorat";
var Automation_Event_OnboardingCompleted = "L’utilisateur finalise l’int\xe9gration";
var Automation_Event_OpportunityMentorRequested = "L’utilisateur demande un mentorat";
var Automation_Event_PathwayCompleted = "L’utilisateur termine le parcours";
var Automation_Event_PathwayEnrolled = "L’utilisateur suit le parcours";
var Automation_Event_PlanFollowed = "L’utilisateur suit le plan";
var Automation_Event_ProviderLicenseAssign = "Nouvelle licence fournisseur attribu\xe9e";
var Automation_Event_UserAddsSkill = "L’utilisateur ajoute la comp\xe9tence";
var Automation_Event_UserUpdatestoFocusSkill = "L’utilisateur d\xe9finit la comp\xe9tence comme prioritaire";
var Automation_FormerUser = "Ancien utilisateur";
var Automation_GroupConditions = "Group Conditions";
var Automation_GroupNameHelper = "Type to search for and select any number of groups.";
var Automation_HistoryAvailableNotification = "L’historique d’automatisation n’est disponible que pour les 60\xa0derniers jours.";
var Automation_HistoryLastUpdated = "Derni\xe8re mise \xe0 jour de l’historique";
var Automation_IsNotOneOf = "Ne fait pas partie de";
var Automation_IsOneOf = "Fait partie de";
var Automation_Log_Detail_Entry_Format = "{{ entityActionHtml }} {{ typeOldHtml }} {{ oldValue }} {{ changedToHtml }} {{ typeNewHtml }} {{ newValue }}";
var Automation_LogTable_Summary = "Ce tableau affiche l’historique d’automatisation des 60\xa0derniers jours. Chaque ligne comprend trois colonnes qui affichent la date, le nombre de modifications effectu\xe9es \xe0 cette date et l’utilisateur ayant effectu\xe9 les modifications. De plus, une liste d\xe9roulante vous permet de d\xe9velopper la ligne pour afficher des d\xe9tails sp\xe9cifiques sur chaque modification effectu\xe9e et l’heure \xe0 laquelle elle a \xe9t\xe9 effectu\xe9e.";
var Automation_Name_Delete = "Nom supprim\xe9";
var Automation_Name_Insert = "Nom ajout\xe9";
var Automation_Name_Update = "Nom mis \xe0 jour";
var Automation_NameAndDescription = "Nom et description";
var Automation_NewAutomation = "Nouvelle automatisation";
var Automation_NoDescription = "Aucune description";
var Automation_NotificationSubject = "Objet";
var Automation_NotifyUser_Format = "Envoyer une notification ({{count}})";
var Automation_NoWarning = "Pas d’avertissement";
var Automation_Or_List_Format = "{{ commaList }} <strong>OU</strong> {{ lastItem }}";
var Automation_Outcome_Delete = "Action supprim\xe9e";
var Automation_Outcome_Insert = "Action ajout\xe9e";
var Automation_Outcome_Update = "Action mise \xe0 jour";
var Automation_Predicate_Delete = "Condition supprim\xe9e";
var Automation_Predicate_Insert = "Condition ajout\xe9e";
var Automation_Predicate_Update = "Condition mise \xe0 jour";
var Automation_PredicateLabel_ContentCompleted = "Titre du contenu";
var Automation_PredicateLabel_GroupJoined = "Nom du groupe";
var Automation_PredicateLabel_MentorshipCompleted = "Intitul\xe9 du mentorat";
var Automation_PredicateLabel_PathwayCompleted = "Nom du parcours";
var Automation_PredicateLabel_PathwayEnrolled = "Nom du parcours";
var Automation_PredicateLabel_PlanFollowed = "Titre du plan";
var Automation_PredicateLabel_ProviderLicenseAssign = "Nom du fournisseur";
var Automation_PredicateLabel_UserAddsSkill = "Nom de la comp\xe9tence";
var Automation_PredicateLabel_UserUpdatestoFocusSkill = "Nom de la comp\xe9tence";
var Automation_PredicateType_Academy = "Acad\xe9mie";
var Automation_PredicateType_Attribute = "Utilisateur";
var Automation_PredicateType_Description_Academy = "D\xe9finir le public cible en fonction de l’association d’utilisateurs et du statut dans une acad\xe9mie";
var Automation_PredicateType_Description_Attribute = "D\xe9finir le public cible en fonction d’attributs utilisateurs pr\xe9cis";
var Automation_PredicateType_Description_Group = "Define the audience with Groups";
var Automation_PredicateType_Description_Skill = "D\xe9finir le public cible en fonction d’attributs de comp\xe9tences propres aux utilisateurs, tels que les comp\xe9tences, les comp\xe9tences prioritaires et les \xe9valuations de comp\xe9tences";
var Automation_PredicateType_Group = "Group";
var Automation_PredicateType_Skill = "Comp\xe9tence";
var Automation_RemoveCondition_Format = "Supprimer la condition avec les valeurs {{value}}";
var Automation_RemoveEmptyCondition = "Supprimer la condition vide";
var Automation_SaveOrCancelFirst = "Enregistrer ou supprimer cette bo\xeete de dialogue pour continuer.";
var Automation_Schedule_Cadence = "Cadence";
var Automation_Schedule_Daily = "Quotidienne (en semaine)";
var Automation_Schedule_Daily_Format = "Ex\xe9cut\xe9e tous les jours (en semaine) \xe0 {{time}} (UTC)";
var Automation_Schedule_Date = "Date";
var Automation_Schedule_Day = "Jour";
var Automation_Schedule_Last = "Dernier";
var Automation_Schedule_LastDayOfMonth = "Dernier jour du mois";
var Automation_Schedule_Monthly = "Mensuelle";
var Automation_Schedule_Monthly_Format = "Ex\xe9cut\xe9e tous les {{dayOfMonth}}\xa0jours du mois \xe0 {{time}} (UTC)";
var Automation_Schedule_Once = "Une seule fois";
var Automation_Schedule_Once_Format = "Ex\xe9cut\xe9e une fois le {{specificDate}} \xe0 {{time}} (UTC)";
var Automation_Schedule_Ordinal_1 = "1er";
var Automation_Schedule_Ordinal_10 = "10e";
var Automation_Schedule_Ordinal_15 = "15e";
var Automation_Schedule_Ordinal_20 = "20e";
var Automation_Schedule_Ordinal_25 = "25e";
var Automation_Schedule_Ordinal_5 = "5e";
var Automation_Schedule_SelectCadence = "S\xe9lectionnez une cadence";
var Automation_Schedule_SelectDate = "S\xe9lectionnez ou saisissez une date";
var Automation_Schedule_SelectDay = "S\xe9lectionnez un jour";
var Automation_Schedule_SelectTime = "S\xe9lectionnez une heure";
var Automation_Schedule_TimeUTC = "Heure (UTC)";
var Automation_Schedule_Weekly = "Hebdomadaire";
var Automation_Schedule_Weekly_Format = "Ex\xe9cut\xe9e toutes les semaines le {{dayOfWeek}} \xe0 {{time}} (UTC)";
var Automation_Search_Placeholder = "Rechercher un nom de r\xe8gle, un nom d’attribut, une valeur d’attribut, une description ou une valeur d’action";
var Automation_SearchAcademy = "Rechercher une acad\xe9mie";
var Automation_SelectAction = "S\xe9lectionner une action";
var Automation_SelectConditionType = "S\xe9lectionner un type de condition";
var Automation_SelectConditionType_Description = "Les conditions limitent le champ d’application de l’automatisation. Choisissez un type de condition ci-dessous pour d\xe9finir le public cible de l’automatisation.";
var Automation_SelectSkillCondition = "S\xe9lectionner une condition relative aux comp\xe9tences";
var Automation_SelectStatuses = "S\xe9lectionner des statuts";
var Automation_SelectTrigger = "S\xe9lectionner un d\xe9clencheur";
var Automation_SendEmail_Format = "Envoyer un e-mail ({{count}})";
var Automation_SetProfilePrivacy_Format = "D\xe9finir la confidentialit\xe9 du profil ({{count}})";
var Automation_SharedBy_Format = "{{ content }} <strong>PARTAG\xc9(E) PAR</strong> {{ person }}";
var Automation_ShareResource_Format = "Partager ({{count}})";
var Automation_SkillCondition = "Condition relative aux comp\xe9tences";
var Automation_SkillCondition_AddOptionalSkills = "Ajouter une ou des comp\xe9tence(s) (facultatif)";
var Automation_SkillConditions = "Conditions relatives aux comp\xe9tences";
var Automation_SkillConditions_Description = "D\xe9finissez le public cible en fonction d’attributs de comp\xe9tences propres aux utilisateurs, tels que les \xe9valuations et les comp\xe9tences ajout\xe9es.";
var Automation_SkillName = "Intitul\xe9 de la comp\xe9tence";
var Automation_SkillNameHelper = "Saisissez du texte pour effectuer une recherche et s\xe9lectionner autant de comp\xe9tences sp\xe9cifiques que vous le souhaitez.";
var Automation_SkillOperator_hasnofocusskills = "L’utilisateur n’a pas ajout\xe9 de comp\xe9tence prioritaire";
var Automation_SkillOperator_hasnoskillrating = "L’utilisateur n’a pas ajout\xe9 d’\xe9valuation de comp\xe9tence";
var Automation_SkillOperator_hasnoskills = "L’utilisateur n’a pas ajout\xe9 de comp\xe9tence";
var Automation_SkillOperator_hasnoskillsrating = "L’utilisateur n’a pas ajout\xe9 d’\xe9valuation de comp\xe9tence";
var Automation_SkillTimeFrame = "P\xe9riode";
var Automation_SkillTimeFrame_AllTime = "\xc0 n’importe quelle date";
var Automation_SkillTimeFrame_WithinDays = "Au cours des derniers (nombre de jours)";
var Automation_Status_Update = "Statut mis \xe0 jour";
var Automation_Then = "Alors";
var Automation_TimeUpdated = "Heure de mise \xe0 jour";
var Automation_Trigger = "D\xe9clencheur";
var Automation_Trigger_Delete = "D\xe9clencheur supprim\xe9";
var Automation_Trigger_Insert = "D\xe9clencheur ajout\xe9";
var Automation_Trigger_Scheduled = "Planifier";
var Automation_Trigger_Update = "D\xe9clencheur mis \xe0 jour";
var Automation_Trigger_UserCreated = "Utilisateur cr\xe9\xe9";
var Automation_Trigger_UserRecordReceived = "Dossier utilisateur re\xe7u";
var Automation_TriggerHasBeenAdded = "Un d\xe9clencheur a \xe9t\xe9 ajout\xe9 \xe0 cette r\xe8gle.";
var Automation_TriggerHasNotBeenAdded = "Veuillez ajouter au moins un d\xe9clencheur pour activer cette r\xe8gle.";
var Automation_TriggerHelp = "Un d\xe9clencheur est l’\xe9v\xe9nement \xe0 l’origine d’une automatisation.";
var Automation_TriggerNoConfigurationNeeded = "Ce d\xe9clencheur n’a pas besoin d’\xeatre configur\xe9.";
var Automation_TriggersAndActionsRequired = "Un d\xe9clencheur et au moins une action doivent \xeatre ajout\xe9s pour activer cette r\xe8gle.";
var Automation_UntitledAutomation = "Automatisation sans intitul\xe9";
var Automation_UpdatedBy = "Mis(e) \xe0 jour par";
var Automation_UserAcademyStatus = "Statut de l’utilisateur de l’acad\xe9mie";
var Automation_UserAcademyStatus_Helper = "S\xe9lectionner un ou plusieurs statut(s) pour l’acad\xe9mie.";
var Automation_UserActivity = "Activit\xe9 de l’utilisateur";
var Automation_UserAssignmentDescription = "En l’absence de s\xe9lection, la formation sera assign\xe9e par un administrateur.";
var Automation_UserAttribute = "Attribut de l’utilisateur";
var Automation_UserConditions = "Conditions relatives aux utilisateurs (facultatif)";
var Automation_UserConditions_Header = "Conditions relatives aux utilisateurs";
var Automation_UserEvents = "\xc9v\xe9nements de l’utilisateur";
var Automation_UserManagement = "Gestion de l’utilisateur";
var Automation_UserMeetsConditions = "L’utilisateur r\xe9pond aux conditions";
var Automation_UserMeetsConditions_Academy = "L’utilisateur r\xe9pond aux conditions d’acad\xe9mies";
var Automation_UserMeetsConditions_Attribute = "L’utilisateur r\xe9pond aux conditions d’utilisateurs";
var Automation_UserMeetsConditions_Group = "User Belongs to Group";
var Automation_UserMeetsConditions_Skill = "L’utilisateur r\xe9pond aux conditions de comp\xe9tences";
var Automation_UserNotificationDescription = "Envoie aux apprenants dans Degreed des notifications int\xe9gr\xe9es \xe0 l’application, et envoie les notifications \xe0 Microsoft Teams, si l’option est activ\xe9e.";
var Automation_UserShareDescription = "En l’absence de s\xe9lection, le contenu sera partag\xe9 par un administrateur.";
var Automation_ViewHistory = "Consulter l’historique";
var Automation_Warning = "Avertissement";
var Automation_Warning_RequiredBeforeSaving = "Remplissez les champs obligatoires avant d’enregistrer.";
var Automation_When = "Lorsque";
var AwardFormCtrl_AddAward = "Ajouter une r\xe9compense";
var AwardFormCtrl_AwardDate = "La date doit \xeatre renseign\xe9e.";
var AwardFormCtrl_AwardDateLabel = "Date de la r\xe9compense";
var AwardFormCtrl_AwardIssuer = "Le nom de la personne octroyant la r\xe9compense doit \xeatre renseign\xe9.";
var AwardFormCtrl_AwardTitle = "L’intitul\xe9 de la r\xe9compense doit \xeatre renseign\xe9.";
var AwardFormCtrl_AwardTitleLabel = "Intitul\xe9 de la r\xe9compense";
var AwardFormCtrl_SaveAward = "Enregistrer la r\xe9compense";
var BadgeFormCtrl_BadgeHelpText = "Les badges doivent \xeatre des fichiers image provenant d’un \xe9metteur.";
var BadgeFormCtrl_BadgeInfoText = "Les informations de l’insigne sont extraites de l’image et ne peuvent pas \xeatre modifi\xe9es.";
var BadgeFormCtrl_BadgeInvalidBadge = "Source de fichier non valide. L’\xe9metteur du badge n’est pas identifiable.";
var BadgeFormCtrl_BadgeUrl = "Saisissez une URL de badge valide.";
var Banner_IE11Body = "La prise en charge par Degreed d’Internet Explorer va bient\xf4t arriver \xe0 expiration. Pour vous pr\xe9parer, passez d\xe8s aujourd’hui \xe0 un navigateur moderne.";
var Banner_IE11Title = "La date d’expiration approche\xa0!";
var Banner_LoggedOutCTA = "Recherchez, r\xe9pertoriez et \xe9valuez toutes vos exp\xe9riences d’apprentissage.";
var Banner_LoggedOutCTAButton = "En savoir plus";
var behaviorForm_AddEvidence = "\xc9tayez votre exemple \xe0 l’aide d’un lien ou d’un fichier.";
var behaviorForm_AppliedForFormat = "Demande soumise pour {{credentialName}}";
var behaviorForm_B1Credential = "Marketing sur les r\xe9seaux sociaux";
var behaviorForm_B1Evidence = "Image de la campagne \xab\xa0Embrace the Space\xa0\xbb";
var behaviorForm_B1Example = "Une marque de chaussures de course avait d\xe9velopp\xe9 un produit offrant un avantage tr\xe8s sp\xe9cifique que nous souhaitions mettre en avant \xe0 travers une campagne sur les r\xe9seaux sociaux (Facebook, Twitter et Instagram en particulier) pour attirer les fans et booster les ventes. J’ai collabor\xe9 avec les concepteurs de la marque et le r\xe9dacteur de contenu pour cr\xe9er la campagne #EmbraceTheSpace. L’objectif \xe9tait d’attirer l’attention des consommateurs sur le design de la chaussure qui \xe9pousait la forme du pied et de les encourager \xe0 profiter du gain d’espace qu’elle offrait au niveau des orteils pendant leur sport (trail, randonn\xe9e, course sur route, etc.). J’ai utilis\xe9 \xe0 la fois la port\xe9e organique, notre \xe9quipe d’ambassadeurs et des publicit\xe9s payantes pour diffuser cette campagne. Comprendre notre public nous a permis de cr\xe9er un message qui a fait forte impression aupr\xe8s de notre communaut\xe9 et de d\xe9velopper rapidement la campagne. Les gens soumettaient m\xeame leurs propres photos en utilisant le hashtag #EmbraceTheSpace. Le slogan est devenu un \xe9l\xe9ment essentiel de la campagne. Il a permis d’encourager les gens \xe0 rejoindre notre communaut\xe9 et \xe0 essayer les chaussures. J’\xe9tais responsable de l’ensemble du contenu publi\xe9 sur les r\xe9seaux sociaux et de la promotion de la campagne en ligne.<br><br>Nous avons rapidement constat\xe9 le succ\xe8s de la campagne et l’avons introduite dans nos salons professionnels, nos publicit\xe9s imprim\xe9es et nos campagnes d’e-mailing. Les ventes r\xe9alis\xe9es gr\xe2ce aux publicit\xe9s utilisant ce message se sont traduites par un retour sur investissement positif. Le slogan \xab\xa0Embrace the Space\xa0\xbb est toujours utilis\xe9 aujourd’hui et le hashtag est associ\xe9 a plus de 29\xa0000\xa0publications sur Instagram seulement, avec une multitude de photos de coureurs qui \xab\xa0profitent du gain d’espace\xa0\xbb offert par leurs chaussures.";
var behaviorForm_B1Process = "Selon moi, une bonne campagne d\xe9pend de plusieurs facteurs qui conduisent au succ\xe8s lorsqu’ils sont associ\xe9s \xe0 un plan de distribution solide. Pour nous, cette campagne \xe9tait simple \xe0 partager et \xe0 comprendre, et tr\xe8s pertinente pour notre base client. En outre, il \xe9tait tr\xe8s facile d’y contribuer avec son propre contenu. Elle \xe9tait \xe0 la fois tr\xe8s authentique pour notre marque et notre client\xe8le, mais elle permettait aussi d’attirer l’attention des personnes qui ne nous connaissaient pas encore. Je savais donc qu’utiliser le message avec des publicit\xe9s nous permettrait d’augmenter les ventes de chaussures. Dans le cadre du processus g\xe9n\xe9ral de lancement de la campagne, nous avons fait appel \xe0 notre \xe9quipe d’ambassadeurs, \xe0 savoir un groupe de personnes qui contribuerait \xe0 diffuser l’image et le message pour susciter l’int\xe9r\xeat et donner un premier \xe9lan \xe0 la campagne. Ce lancement organique a \xe9t\xe9 suivi de promotions tr\xe8s cibl\xe9es de contenus et de publicit\xe9s qui ont permis d’augmenter les ventes directes. Une fois que la campagne a pris de l’ampleur et que les gens ont commenc\xe9 \xe0 ajouter leur propre contenu au hashtag, nous avons continu\xe9 sur cette lanc\xe9e en partageant les meilleures images diffus\xe9es par la communaut\xe9. Nous avons r\xe9p\xe9t\xe9 ce processus, qui reste encore aujourd’hui une strat\xe9gie tr\xe8s efficace pour la marque.";
var behaviorForm_B1Title = "Je peux lancer des produits et cr\xe9er des campagnes publicitaires sur plusieurs r\xe9seaux sociaux, qui se traduisent par des ventes directes et un retour sur investissement positif.";
var behaviorForm_B2Credential = "Gestion d’entreprise";
var behaviorForm_B2Example = "Au sein de mon service, j’ai g\xe9r\xe9 un budget annuel de plus d’un million de dollars, comprenant les co\xfbts de main-d’œuvre et les frais g\xe9n\xe9raux de neuf collaborateurs, les frais de d\xe9placement et de formation, les d\xe9penses informatiques internes et les contrats avec des fournisseurs de logiciels externes.<br><br>Au d\xe9but de l’ann\xe9e, on m’a charg\xe9 d’\xe9tablir un budget accompagn\xe9 de pr\xe9visions de croissance. Pendant plusieurs semaines, le budget a \xe9t\xe9 ajust\xe9 avec l’aide du service financier et de la direction g\xe9n\xe9rale.<br><br>Chaque mois, le service financier nous faisait savoir si les d\xe9penses r\xe9elles \xe9taient en phase avec le budget pr\xe9vu. Il m’incombait ensuite d’ajuster les d\xe9penses ou de demander \xe0 ce que le budget soit revu pour le reste de l’ann\xe9e.<br><br>De m\xeame que dans tous les autres aspects de l’activit\xe9, des \xe9v\xe9nements inattendus se sont produits durant l’ann\xe9e, ce qui nous a amen\xe9s \xe0 prendre des d\xe9cisions difficiles en mati\xe8re de d\xe9penses. J’ai par exemple d\xfb d\xe9terminer si nous pouvions nous permettre d’embaucher un nouveau collaborateur pour r\xe9pondre \xe0 de nouveaux besoins ayant conduit \xe0 une hausse de la charge de travail. En r\xe9duisant certaines d\xe9penses li\xe9es aux d\xe9placements et aux logiciels, et en convainquant l’\xe9quipe de direction d’augmenter le budget, j’ai pu cr\xe9er un nouveau poste en milieu d’ann\xe9e.";
var behaviorForm_B2Process = "\xc9laborer un budget est \xe0 la fois un art et une science. Il est difficile de faire des pr\xe9visions sur douze mois. G\xe9rer un budget tout au long de l’ann\xe9e rel\xe8ve toutefois davantage de la science. Il est plus facile \xe0 mesurer et \xe0 adapter \xe0 court terme.<br><br>Lorsque j’\xe9tablis un budget, j’ai tendance \xe0 demander un peu plus que ce dont je pense avoir besoin, car la premi\xe8re version est g\xe9n\xe9ralement revue \xe0 la baisse par les personnes situ\xe9es plus haut dans l’organigramme et par celles qui sont charg\xe9es de la budg\xe9tisation globale au sein du service financier. Il est assez rare que le service financier vous dise de d\xe9penser plus\xa0! Je pensais que tant que je justifiais mes demandes, il \xe9tait possible de discuter et de n\xe9gocier la version finale.<br><br>Au cours de l’ann\xe9e, je me suis efforc\xe9 de d\xe9penser moins que ce qui \xe9tait pr\xe9vu dans le budget, sauf si cela risquait de priver le service d’avantages tangibles. Qu’il s’agisse d’un nouveau logiciel, d’un d\xe9placement pour assister \xe0 une conf\xe9rence, etc., il est tentant d’autoriser toutes les d\xe9penses. Cependant, j’ai constat\xe9 que j’obtenais des demandes de meilleure qualit\xe9 et plus r\xe9fl\xe9chies de la part de l’\xe9quipe lorsque j’opposais un peu plus de r\xe9sistance. Notre gestion prudente du budget nous a ainsi permis de disposer des fonds n\xe9cessaires pour couvrir des d\xe9penses importantes et des co\xfbts impr\xe9vus tout au long de l’ann\xe9e.";
var behaviorForm_B2Title = "Je peux cr\xe9er et g\xe9rer un budget";
var behaviorForm_B3Credential = "Python";
var behaviorForm_B3Evidence = "Classe et tests permettant de convertir un DataFrame en vecteur matriciel";
var behaviorForm_B3Example = "Dans mon workflow de science des donn\xe9es, je dois souvent passer d’un ensemble de donn\xe9es aplaties dans un DataFrame (nom de ligne, nom de colonne, valeur) \xe0 une matrice structur\xe9e selon les noms de ligne et de colonne et ne contenant que des valeurs afin d’utiliser la biblioth\xe8que sklearn. Pour faciliter cette op\xe9ration, j’ai cr\xe9\xe9 un module capable d’effectuer cette transformation (qui est joint comme preuve).<br><br>La structure g\xe9n\xe9rale du module suit le mod\xe8le de sklearn, qui consiste \xe0 d\xe9finir un objet de type transformer et \xe0 utiliser les m\xe9thodes de cet objet pour ajuster les param\xe8tres requis et transformer les donn\xe9es transmises. Ce mod\xe8le est connu des utilisateurs et s’int\xe8gre aux pipelines de traitement des donn\xe9es de sklearn. Il permet \xe9galement de stocker facilement des informations telles que des facteurs de normalisation pendant le processus d’ajustement. Ces informations peuvent \xeatre utilis\xe9es ult\xe9rieurement pour transformer de nouvelles donn\xe9es sans qu’il soit n\xe9cessaire de r\xe9ajuster le mod\xe8le.<br><br>L’une des principales motivations de ce transformer \xe9tait de faciliter l’association d’un nom de ligne ou de colonne avec les indices de la matrice. Pour y parvenir, j’ai cr\xe9\xe9 une structure de donn\xe9es personnalis\xe9e au lieu de renvoyer simplement la matrice. Cette structure comprend des informations sur les lignes et les colonnes en tant qu’attributs et dispose d’une m\xe9thode pour extraire les informations n\xe9cessaires.<br><br>J’ai inclus des tests unitaires \xe0 la fin du module, qui s’ex\xe9cuteront si je lance le module depuis la ligne de commande. Cela permet \xe0 mon code de rester fiable lorsque j’effectue des modifications et me rappelle le comportement attendu lorsque j’utilise \xe0 nouveau la fonction apr\xe8s un certain temps. Incorporer les tests unitaires dans le m\xeame fichier que le code am\xe9liore sa modularit\xe9, en particulier pour les modules uniques que je ne veux pas rassembler dans un paquet.";
var behaviorForm_B3Process = "De mani\xe8re g\xe9n\xe9rale, lorsque je cr\xe9e des modules, je tiens compte des points suivants\xa0:<br><br>\n1. Quel est le niveau de d\xe9veloppement n\xe9cessaire pour cette instance sp\xe9cifique\xa0? Est-ce que je vais la partager ou serai-je le seul \xe0 l’utiliser\xa0? Cela permet de d\xe9terminer la quantit\xe9 de documentation/d’encodage de tests et d’exemples n\xe9cessaires. Cela commence souvent de mani\xe8re tr\xe8s basique et \xe9volue au fil du temps si la fonction est utilis\xe9e fr\xe9quemment.<br><br>\n2. Comment d\xe9composer au mieux les op\xe9rations complexes en structures de donn\xe9es, m\xe9thodes et objets transformer/mod\xe8les\xa0? Il s’agit notamment de d\xe9cider si un processus est mieux cod\xe9 en tant que fonction ou en tant que m\xe9thode de classe et de concevoir des objets de mani\xe8re \xe0 pouvoir utiliser facilement des biblioth\xe8ques externes.<br><br>\n3. Nommer les fonctions, les classes et les m\xe9thodes de sorte que le processus soit facile \xe0 suivre.<br><br>\n4. Faciliter l’obtention des informations dont j’ai besoin pour la v\xe9rification des erreurs. Par exemple, ajouter diff\xe9rents niveaux de verbosit\xe9 pendant l’ex\xe9cution et la d\xe9finition de m\xe9thodes sp\xe9cifiques pour extraire des informations.<br><br>\n5. Suivre les mod\xe8les \xe9tablis et faciliter l’utilisation d’autres paquets, par exemple\xa0:<br><br>\n\xa0\xa0\xa0a. Lorsque j’encode des mod\xe8les ou des transformers, je suis le mod\xe8le sklearn qui consiste \xe0 cr\xe9er un transformer pouvant \xeatre adapt\xe9 \xe0 l’aide d’un ensemble de donn\xe9es sp\xe9cifique parce qu’il est facile d’intervertir les ensembles de donn\xe9es d’apprentissage et de test et parce que cela fonctionne bien dans les pipelines de traitement des donn\xe9es.<br><br>\n\xa0\xa0\xa0b. Pour les m\xe9thodes de classe qui modifient l’objet, je pr\xe9f\xe8re renvoyer l’objet lui-m\xeame afin que les op\xe9rations puissent \xeatre encha\xeen\xe9es\xa0; c’est un sch\xe9ma que l’on retrouve \xe0 la fois dans pandas et dans sklearn.<br><br>\n\xa0\xa0\xa0c. Je m’assure que les attributs de base d’une classe sont stock\xe9s dans la bonne structure de donn\xe9es pour \xeatre facilement transmis \xe0 sklearn/pandas si cela fait partie du workflow.<br><br>\n6. R\xe9diger des cha\xeenes de documentation dans un format qui peut \xeatre trait\xe9 \xe0 l’aide d’outils comme Sphinx pour g\xe9n\xe9rer une documentation utile.<br><br>";
var behaviorForm_B3Title = "Je peux cr\xe9er des modules Python sur mesure, qui incluent une conceptualisation approfondie des structures d’objets et des workflows, ainsi qu’une v\xe9rification basique des erreurs par le biais de tests unitaires.";
var behaviorForm_behaviorInstruction = "<p>Pour chaque comportement li\xe9 \xe0 la comp\xe9tence, veuillez d\xe9crire en d\xe9tail une situation concr\xe8te dans laquelle vous l’avez utilis\xe9. Pr\xe9cisez ce que vous avez fait, qui \xe9tait impliqu\xe9, les d\xe9fis rencontr\xe9s et les r\xe9sultats obtenus.</p>\n<p>En outre, veuillez expliquer la mani\xe8re dont vous abordez ce comportement, en mettant l’accent sur les raisons d’une telle approche. C’est l’occasion de mettre en avant votre connaissance de la comp\xe9tence en expliquant les th\xe9ories, les principes et les m\xe9thodes qui s’y rapportent.</p>";
var behaviorForm_behaviorsInstruction = '<p>Pour illustrer votre comp\xe9tence, veuillez fournir trois exemples de mise en pratique. C’est ce que nous appelons des comportements li\xe9s \xe0 la comp\xe9tence. Les d\xe9clarations associ\xe9es doivent commencer par \xab\xa0Je peux…\xa0\xbb (par exemple, \xab\xa0Je peux g\xe9rer un budget.\xa0\xbb). Veillez \xe0 s\xe9lectionner des comportements pour lesquels vous pouvez\xa0:</p>\n<ul class="bullets">\n    <li>donner un exemple d\xe9taill\xe9 d’une situation concr\xe8te\xa0;</li>\n    <li>demander l’approbation d’une personne qui a travaill\xe9 avec vous\xa0;</li>\n    <li>joindre des preuves ou des liens vers des preuves, si possible.</li>\n</ul>\n<p>Combin\xe9s, les comportements choisis doivent d\xe9montrer toute l’\xe9tendue de votre expertise dans ce domaine.</p>\n<p>Si vous \xe9prouvez des difficult\xe9s \xe0 r\xe9aliser cette \xe9tape, r\xe9fl\xe9chissez \xe0 la fa\xe7on dont vous r\xe9pondriez \xe0 la question suivante\xa0: \xab\xa0Que dois-je savoir faire pour \xeatre bon dans ce domaine\xa0?\xa0\xbb</p>';
var behaviorForm_BehaviorStatementsDemo = '<div class="markdown">\n  <h2 class="h3 guts-p-b-1">Marketing m\xe9dias sociaux</h2>\n  \n  <ol class="guts-p-b-1">\n    <li>Je peux d\xe9velopper une audience en ligne capable de s’engager durablement aupr\xe8s d’une marque ou d’une entreprise</li>\n    <li>Je peux g\xe9n\xe9rer et suivre les revenus via les canaux sociaux</li>\n    <li>Je peux mener des campagnes publicitaires payantes sur les r\xe9seaux sociaux</li>\n  </ol>\n  \n  <h2 class="h3 guts-p-b-1">Node.js</h2>\n  \n  <ol class="guts-p-b-1">\n    <li>Je peux cr\xe9er des applications web Node.js et des packs\xa0NPM</li>\n    <li>Je peux r\xe9diger des articles et des tutoriels Node.js pour former d’autres utilisateurs</li>\n    <li>Je peux parler de Node.js lors de r\xe9unions et de conf\xe9rences</li>\n  </ol>\n  \n  <h2 class="h3 guts-p-b-1">Prise de parole en public</h2>\n  \n  <ol class="guts-p-b-1">\n    <li>Je peux r\xe9aliser des pr\xe9sentations tr\xe8s attrayantes</li>\n    <li>Je peux cr\xe9er des pr\xe9sentations captivantes visuellement pour accompagner ma prise de parole en public</li>\n    <li>Je peux cerner une audience et comprendre la dynamique des interactions dans une salle</li>\n  </ol>\n  \n  <h2 class="h3 guts-p-b-1">CSS</h2>\n  \n  <ol class="guts-p-b-1">\n    <li>Je peux organiser et bien structurer mon CSS.</li>\n    <li>Je sais r\xe9soudre les probl\xe8mes de sp\xe9cificit\xe9 les plus courants associ\xe9s \xe0 la difficult\xe9 d’un CSS de qualit\xe9</li>\n    <li>Je peux participer \xe0 la communaut\xe9 open source avec des projets\xa0CSS</li>\n  </ol>\n  \n  <h2 class="h3 guts-p-b-1">Dessin</h2>\n  \n  <ol class="guts-p-b-1">\n    <li>Je peux composer une nature morte et cr\xe9er une description r\xe9aliste au crayon graphite et/ou charbon</li>\n    <li>Je peux utiliser des perspectives et comprendre leur r\xf4le afin de cr\xe9er des dessins plus r\xe9alistes</li>\n    <li>Je peux dessiner de m\xe9moire et \xe0 la force de mon imagination</li>\n  </ol>\n  \n  <h2 class="h3 guts-p-b-1">Service client</h2>\n  \n  <ol class="guts-p-b-1">\n    <li>Je fais preuve d’empathie \xe0 l’\xe9gard des inqui\xe9tudes exprim\xe9es par mes clients</li>\n    <li>Je peux r\xe9pondre aux questions de mes clients dans les meilleurs d\xe9lais</li>\n    <li>Je peux proposer des solutions cr\xe9atives afin de r\xe9pondre aux besoins des clients</li>\n  </ol>\n  \n  <h2 class="h3 guts-p-b-1">Design d’exp\xe9rience utilisateur</h2>\n  \n  <ol class="guts-p-b-1">\n    <li>Je peux \xe9valuer les besoins des utilisateurs par le biais de la recherche</li>\n    <li>Je peux cr\xe9er des prototypes de designs conceptuels pour valider des id\xe9es</li>\n    <li>Je peux cr\xe9er des solutions adapt\xe9es aux besoins des utilisateurs </li>\n  </ol>\n\n</div>';
var behaviorForm_BehaviorStatementsDemoHeader = "Exemples de d\xe9clarations de comportements li\xe9s \xe0 la comp\xe9tence";
var behaviorForm_EditTitle = "Modifier l’intitul\xe9";
var behaviorForm_EvaluationCriteria = '<p>Votre \xe9valuation portera sur les crit\xe8res suivants\xa0:</p>\n<ul class="bullets">\n    <li><strong>Connaissances\xa0:</strong> l’\xe9tendue des connaissances techniques et th\xe9oriques relatives \xe0 la comp\xe9tence </li>\n    <li><strong>Mise en pratique\xa0:</strong> l’\xe9tendue des applications pratiques de la comp\xe9tence</li>\n    <li><strong>Planification et \xe9valuation\xa0:</strong> la capacit\xe9 \xe0 identifier les probl\xe8mes, proposer des solutions et \xe9valuer les r\xe9sultats dans ce domaine de comp\xe9tence</li>\n    <li><strong>Responsabilit\xe9 et autonomie\xa0:</strong> la capacit\xe9 \xe0 travailler de mani\xe8re autonome et \xe0 assumer la responsabilit\xe9 des r\xe9sultats obtenus dans ce domaine de comp\xe9tence</li>\n    <li><strong>Esprit d’\xe9quipe\xa0:</strong> la capacit\xe9 \xe0 travailler en \xe9quipe ou \xe0 diriger des \xe9quipes dans ce domaine de comp\xe9tence</li>\n    <li><strong>Enseignement et communication\xa0:</strong> la capacit\xe9 \xe0 communiquer avec les autres et \xe0 leur enseigner la comp\xe9tence</li>\n</ul>';
var behaviorForm_EvaluationCriteriaHeader = "Crit\xe8res d’\xe9valuation";
var behaviorForm_ExampleLabel = "D\xe9crivez une situation dans laquelle vous avez adopt\xe9 ce comportement li\xe9 \xe0 la comp\xe9tence.";
var behaviorForm_ExamplePlaceholder = "D\xe9crivez en d\xe9tail une situation concr\xe8te.";
var behaviorForm_Header1 = "D\xe9crivez votre premier comportement li\xe9 \xe0 la comp\xe9tence";
var behaviorForm_Header2 = "D\xe9crivez votre deuxi\xe8me comportement li\xe9 \xe0 la comp\xe9tence";
var behaviorForm_Header3 = "D\xe9crivez votre troisi\xe8me comportement li\xe9 \xe0 la comp\xe9tence";
var behaviorForm_ProcessLabel = "R\xe9sumez votre approche g\xe9n\xe9rale et expliquez pourquoi vous proc\xe9dez de cette mani\xe8re.";
var behaviorForm_ProcessPlaceholder = "Expliquez votre approche lors de l’adoption de ce comportement li\xe9 \xe0 la comp\xe9tence.";
var behaviorForm_ProvideMoreInfo = "Veuillez fournir de plus amples d\xe9tails";
var behaviorForm_ReadMore = "Instructions";
var behaviorForm_ShowDemos = "Afficher des exemples de comportements li\xe9s \xe0 la comp\xe9tence";
var behaviorForm_ShowEvalCriteria = "Voir les crit\xe8res d’\xe9valuation";
var behaviorForm_TitleLabel = "D\xe9crivez bri\xe8vement le comportement li\xe9 \xe0 la comp\xe9tence.";
var behaviorForm_TitleLabel1 = "Quel est votre premier comportement li\xe9 \xe0 la comp\xe9tence\xa0?";
var behaviorForm_TitleLabel2 = "Quel est votre deuxi\xe8me comportement li\xe9 \xe0 la comp\xe9tence\xa0?";
var behaviorForm_TitleLabel3 = "Quel est votre troisi\xe8me comportement li\xe9 \xe0 la comp\xe9tence\xa0?";
var behaviorForm_TitlePlaceholder = "Je peux…";
var behaviorForm_ValidationMessage = "Ce champ doit \xeatre renseign\xe9.";
var behaviorModal_Heading1 = "Comment votre demande sera-t-elle \xe9valu\xe9e par les autres personnes.";
var behaviorModal_Heading2 = "Ajout de liens et t\xe9l\xe9chargement de fichiers.";
var behaviorModal_Heading3 = "\xc9vitez les informations personnelles et propri\xe9taires.";
var behaviorModal_Instructions = "Instructions";
var behaviorModal_Instructions1 = "Choisissez les comp\xe9tences comportementales illustrant le degr\xe9 et la vari\xe9t\xe9 de vos comp\xe9tences. D\xe9taillez vos justificatifs de mani\xe8re \xe0 ce que les \xe9valuateurs puissent appr\xe9hender votre degr\xe9 de contribution, votre m\xe9thodologie, les difficult\xe9s rencontr\xe9es et les r\xe9sultats obtenus.";
var behaviorModal_Instructions2 = "Lorsque vous \xeates examin\xe9s par des pairs, ils compareront votre application \xe0 une autre application dans {{credName}} et d\xe9termineront ce qu’ils croient \xab\xa0a d\xe9montr\xe9 plus d’expertise\xa0\xbb.";
var behaviorModal_Instructions3 = "Lors de votre examen par le panel d’experts, celui-ci \xe9valuera votre demande en fonction d’une rubrique mesurant l’expertise li\xe9e \xe0 des caract\xe9ristiques telles que l’autonomie, la facult\xe9 d’adaptation et l’esprit critique.";
var behaviorModal_Instructions4 = "Lors de votre \xe9valuation par les approbateurs, ces derniers seront invit\xe9s \xe0 confirmer que vos comp\xe9tences, comportements et justificatifs sont exacts et correspondent \xe0 leur exp\xe9rience professionnelle en votre compagnie.";
var behaviorModal_Instructions5 = "Bien que non obligatoire, l’ajout de liens et le t\xe9l\xe9chargement de fichiers permettent de d\xe9montrer votre comp\xe9tence. Veuillez vous assurer que les liens sont accessibles et ne n\xe9cessitent aucun mot de passe d’acc\xe8s.";
var behaviorModal_Instructions6 = "Le processus de certification a \xe9t\xe9 con\xe7u pour \xeatre anonyme. Tout biais est ainsi \xe9vit\xe9. Veuillez ne pas fournir d’indication susceptibles d’identifier votre race, couleur, religion ou croyance, origine nationale ou ascendance, sexe, \xe2ge, statut d’invalidit\xe9, information g\xe9n\xe9tique, statut d’ancien combattant et citoyennet\xe9.";
var behaviorModal_Instructions7 = "Les informations soumises ne doivent PAS enfreindre les droits d’auteur, NI \xeatre confidentielles ou propri\xe9taires. G\xe9n\xe9ralisez ou supprimez des d\xe9tails si n\xe9cessaire.";
var behaviorModal_Instructions8 = 'Si vous avez des questions, merci d’envoyer un e-mail \xe0 <a href="mailto:info@degreed.com" class="par link">info@degreed.com</a>';
var behaviorModalVM_Instructions = "Instructions";
var BookFormCtrl_AddBook = "Ajouter un livre";
var BookFormCtrl_AddCategory = "Veuillez ajouter au moins une cat\xe9gorie.";
var BookFormCtrl_BookCoverAltFormat = "couverture du livre {{title}}";
var BookFormCtrl_BookLength = "La longueur du livre doit \xeatre un nombre valide.";
var BookFormCtrl_BookSearchError = "This title can’t be retrieved at this time.";
var BookFormCtrl_BookTitle = "Intitul\xe9 du livre";
var BookFormCtrl_DatePublished = "Date de publication";
var BookFormCtrl_DateRead = "Date de lecture";
var BookFormCtrl_EditBook = "Modifier le livre";
var BookFormCtrl_IWroteThis = "Je suis l’auteur de ce livre";
var BookFormCtrl_Length = "Longueur";
var BookFormCtrl_Pages = "Pages";
var BookFormCtrl_SaveBook = "Enregistrer le livre";
var BookFormCtrl_SelectBook = "S\xe9lectionnez un livre dans la liste.";
var BookFormCtrl_Title = "Titre";
var BookFormCtrl_WhatDidYouLearnLong = "Qu’avez-vous appris gr\xe2ce \xe0 ce livre\xa0?";
var BookFormCtrl_WhatDidYouLearnShort = "Qu’avez-vous appris\xa0?";
var BooksSvc_ErrorMatchingBooks = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration des livres correspondants.";
var BreadcrumbSvc_DownloadableReports = "Rapports t\xe9l\xe9chargeables";
var BreadcrumbSvc_Enrolled = "Inscrit";
var BreadcrumbSvc_Insights = "Statistiques";
var BreadcrumbSvc_LessonFormat = "Le\xe7on {{lesson}}";
var BreadcrumbSvc_SectionFormat = "Section {{section}}";
var bulkUpdateModal_Cancel = "Annuler";
var bulkUpdateModal_CancelProcessing = "Annuler le traitement";
var bulkUpdateModal_CreateGroups = "Cr\xe9er des groupes";
var bulkUpdateModal_CreateGroupsSuccess = "Nous vous enverrons un e-mail une fois que les groupes auront \xe9t\xe9 cr\xe9\xe9s et seront visibles.";
var bulkUpdateModal_CreateRoles = "Cr\xe9er des plans";
var bulkUpdateModal_DownloadTemplate = "T\xe9l\xe9charger le mod\xe8le";
var bulkUpdateModal_DuplicateRow = "1\xa0ligne contient des postes en double";
var bulkUpdateModal_DuplicateRowPluralFormat = "{{count}} \xa0lignes contiennent des postes en double";
var bulkUpdateModal_EmptyContentType = "1\xa0ligne doit indiquer le type de contenu";
var bulkUpdateModal_EmptyContentTypePluralFormat = "{{count}}\xa0lignes doivent indiquer le type de contenu";
var bulkUpdateModal_EmptyUpdateType = "1\xa0ligne doit indiquer le type de mise \xe0 jour";
var bulkUpdateModal_EmptyUpdateTypePluralFormat = "{{count}}\xa0lignes doivent indiquer le type de mise \xe0 jour";
var bulkUpdateModal_ExcelImported = "Feuille Excel import\xe9e";
var bulkUpdateModal_FileIsEmpty = "Il semble que le fichier soit vide. Veuillez r\xe9essayer.";
var bulkUpdateModal_FileName = "Nom du fichier";
var bulkUpdateModal_FirstRow = "Premi\xe8re ligne";
var bulkUpdateModal_HeadingGroups = "Cr\xe9er plusieurs groupes";
var bulkUpdateModal_HeadingRolePlans = "Cr\xe9er plusieurs plans";
var bulkUpdateModal_MaximumRowWidthExceeded = "1\xa0ligne a d\xe9pass\xe9 la largeur maximum";
var bulkUpdateModal_MaximumRowWidthExceededPluralFormat = "{{count}}\xa0lignes ont d\xe9pass\xe9 la largeur maximum";
var bulkUpdateModal_MissingRequiredColumn = "1\xa0ligne ne contient pas les colonnes requises";
var bulkUpdateModal_MissingRequiredColumnPluralFormat = "{{count}}\xa0lignes ne contiennent pas les colonnes requises";
var bulkUpdateModal_NotAppearRightAway = "Ces plans peuvent ne pas appara\xeetre imm\xe9diatement.";
var bulkUpdateModal_RowsAccepted = "Lignes import\xe9es";
var bulkUpdateModal_RowsFound = "Lignes trouv\xe9es";
var bulkUpdateModal_RowsWithErrors = "Lignes non import\xe9es";
var bulkUpdateModal_Save = "Enregistrer";
var bulkUpdateModal_SelectAFile = "S\xe9lectionnez un fichier (xls, xlsx) dont la taille n’exc\xe8de pas (2\xa0Mo).";
var bulkUpdateModal_SuccessfulUpload = "Votre fichier a bien \xe9t\xe9 t\xe9l\xe9charg\xe9.";
var bulkUpdateModal_TotalRows = "Nombre total de lignes";
var bulkUpdateModal_UnknownContentType = "1\xa0ligne contient un type de contenu inconnu";
var bulkUpdateModal_UnknownContentTypePluralFormat = "{{count}}\xa0lignes contiennent un type de contenu inconnu";
var bulkUpdateModal_UnknownDataType = "1\xa0ligne contient un type de mise \xe0 jour inconnu";
var bulkUpdateModal_UnknownDataTypePluralFormat = "{{count}}\xa0lignes contiennent un type de mise \xe0 jour inconnu";
var bulkUpdateModal_UnsupportedFileContentType = "1\xa0ligne contient des fichiers non compatibles";
var bulkUpdateModal_UnsupportedFileContentTypePluralFormat = "{{count}}\xa0lignes contiennent des fichiers non compatibles";
var bulkUpdateModal_UploadAFile = "Charger un fichier";
var bulkUpdateModal_WillSendEmail = "Le fichier que vous avez t\xe9l\xe9charg\xe9 est en cours de traitement. Les modifications apport\xe9es en fonction de ce fichier peuvent prendre 4\xa0heures avant d’apparaitre dans Degreed.";
var BusinessRules_AcmAddUser = "Enable Academy Admin Access";
var BusinessRules_AcmDeleteUser = "Disable ACM Access";
var BusinessRules_ActionType = "Type d’action";
var BusinessRules_AddAction = "Ajouter une action";
var BusinessRules_AddAttribute = "Ajouter un attribut";
var BusinessRules_AddCondition = "Ajouter une condition";
var BusinessRules_AddProviderLicense = "Ajouter la visibilit\xe9 du fournisseur";
var BusinessRules_AddRole = "Mettre \xe0 jour le r\xf4le d’autorisation";
var BusinessRules_AddRule = "Ajouter une r\xe8gle";
var BusinessRules_AddSegments = "Ajouter des segments";
var BusinessRules_AddSkill = "Ajouter une comp\xe9tence";
var BusinessRules_AddSkillPlan = "Ajouter un plan";
var BusinessRules_AddToGroup = "Ajouter un groupe";
var BusinessRules_AddToPathway = "Ajouter le parcours";
var BusinessRules_And = "Et";
var BusinessRules_ApplyToAllUsers = "Dossier utilisateur re\xe7u";
var BusinessRules_ApplyToNewUsers = "Utilisateur cr\xe9\xe9";
var BusinessRules_AreYouSure_DeleteSegments_Format = "Are you sure you want to permanently delete the following {{count}} Segments?";
var BusinessRules_AssignResource = "Assigner";
var BusinessRules_AttributeInstructions = "Vous ne pouvez pas d\xe9passer 20\xa0conditions.";
var BusinessRules_AttributeName = "Nom de l’attribut";
var BusinessRules_Attributes_Column = "Attributs";
var BusinessRules_AttributeValue = "Valeur de l’attribut";
var BusinessRules_BeyondDaysAgo = "Il y a plus de";
var BusinessRules_CloneSegment = "Cloner le segment";
var BusinessRules_CloneSegmentFormat = "Voulez-vous vraiment cloner le segment {{name}}\xa0? Le segment clon\xe9 s’ouvrira automatiquement pour que vous puissiez le modifier.";
var BusinessRules_Condition = "Condition";
var BusinessRules_Conditions_Column = "Conditions";
var BusinessRules_Contains = "Contient";
var BusinessRules_CreateARule = "Cr\xe9er une r\xe8gle";
var BusinessRules_CreateASegment = "Cr\xe9er un segment";
var BusinessRules_CreateSegment = "Cr\xe9er un segment";
var BusinessRules_DateCreated_Column = "Date de cr\xe9ation";
var BusinessRules_DaysAgo = "Jours";
var BusinessRules_DeleteModalBody_Format = "Voulez-vous vraiment supprimer {{name}}\xa0?";
var BusinessRules_DeleteSegments = "Delete Segments";
var BusinessRules_DeleteUser = "Supprimer l’utilisateur";
var BusinessRules_DoesNotEqual = "N’est pas \xe9gal \xe0";
var BusinessRules_EditRule = "Modifier la r\xe8gle";
var BusinessRules_EditSegment = "Modifier le segment";
var BusinessRules_Equals = "Est \xe9gal \xe0";
var BusinessRules_Error_DuplicateRuleName = "Le nom existe d\xe9j\xe0. Veuillez entrer un nom unique pour continuer";
var BusinessRules_GreaterOrEqual = ">=";
var BusinessRules_GreaterThan = ">";
var BusinessRules_If = "Si";
var BusinessRules_LesserOrEqual = "<=";
var BusinessRules_LessThan = "<";
var BusinessRules_ManageSegments = "G\xe9rer les segments";
var BusinessRules_NA = "S.\xa0O.";
var BusinessRules_NewItem_Format_AddNewSkill = "Ajouter une nouvelle comp\xe9tence\xa0: {{name}}";
var BusinessRules_NotifyUser = "Envoyer une notification";
var BusinessRules_Operator = "Op\xe9rateur";
var BusinessRules_PrivacyOutcomeWarning = "L’utilisation des r\xe8gles m\xe9tier pour d\xe9finir la confidentialit\xe9 du profil d’un utilisateur remplace le param\xe8tre s\xe9lectionn\xe9 par l’utilisateur chaque fois que la r\xe8gle est ex\xe9cut\xe9e. Voulez-vous vraiment d\xe9finir la confidentialit\xe9 du profil\xa0?";
var BusinessRules_Qualifier = "Qualificatif";
var BusinessRules_RemoveAction = "Supprimer l’action";
var BusinessRules_RemoveCondition = "Supprimer la condition";
var BusinessRules_RuleError_Description = "Cette r\xe8gle comporte une ou plusieurs erreurs qui doivent \xeatre corrig\xe9es. Consultez la description sous chaque champ comportant une erreur.";
var BusinessRules_RuleError_Tooltip = "Erreurs d\xe9tect\xe9es dans la r\xe8gle. Cliquez sur Modifier pour en savoir plus.";
var BusinessRules_RuleName = "Intitul\xe9 de la r\xe8gle";
var BusinessRules_SearchForProviderLicense = "Rechercher un fournisseur";
var BusinessRules_SearchForRole = "Rechercher un poste";
var BusinessRules_SearchForSkill = "Rechercher une comp\xe9tence";
var BusinessRules_SearchForSkillPlan = "Rechercher un plan de comp\xe9tence";
var BusinessRules_SegmentName = "Nom du segment";
var BusinessRules_SegmentNamePlaceholder = "Nom du segment";
var BusinessRules_SegmentsDeleted_Toast = "Segments deleted successfully";
var BusinessRules_SegmentSearch_Placeholder = "Rechercher un nom de segment, un nom d’attribut ou une valeur d’attribut";
var BusinessRules_SelectASegment = "S\xe9lectionner un segment";
var BusinessRules_SelectSegment = "S\xe9lectionner un segment";
var BusinessRules_SendEmail = "Envoyer un e-mail";
var BusinessRules_SendNotification = "Envoyer une notification";
var BusinessRules_SetProfilePrivacy = "D\xe9finir la confidentialit\xe9 du profil";
var BusinessRules_ShareResource = "Partager";
var BusinessRules_Then = "Alors";
var BusinessRules_ToggleActiveModalBody_ToDisable_Format = "Voulez-vous vraiment d\xe9sactiver {{name}}\xa0?";
var BusinessRules_ToggleActiveModalBody_ToEnable_Format = "Voulez-vous vraiment activer {{name}}\xa0?";
var BusinessRules_ToggleActiveModalConfirm_ToDisable = "Oui, d\xe9sactiver la r\xe8gle";
var BusinessRules_ToggleActiveModalConfirm_ToEnable = "Oui, activer la r\xe8gle";
var BusinessRules_ToggleActiveModalHeader_ToDisable = "D\xe9sactiver l’automatisation";
var BusinessRules_ToggleActiveModalHeader_ToEnable = "Activer l’automatisation";
var BusinessRules_Trigger_Column = "D\xe9clencheur";
var BusinessRules_Value = "Valeur";
var BusinessRules_WithinDaysAgo = "Dans les derniers";
var CertificateFormCtrl_AddCertificate = "Ajouter un certificat";
var CertificateFormCtrl_CertificateNumber = "Num\xe9ro du certificat";
var CertificateFormCtrl_EndAfterStart = "La date de fin doit avoir lieu apr\xe8s la date de d\xe9but.";
var CertificateFormCtrl_ExpirationDate = "Veuillez indiquer la date d’expiration.";
var CertificateFormCtrl_ExpiryDate = "Date d’expiration";
var CertificateFormCtrl_IssueDate = "Date d’\xe9mission";
var CertificateFormCtrl_IssuerName = "Nom de l’\xe9metteur";
var CertificateFormCtrl_IssuerNameRequired = "Le nom de l’\xe9metteur du certificat doit \xeatre renseign\xe9.";
var CertificateFormCtrl_IssuerURL = "URL de l’\xe9metteur";
var CertificateFormCtrl_SaveCertificate = "Enregistrer le certificat";
var CertificateFormCtrl_StartDate = "Veuillez indiquer la date de d\xe9but.";
var CertificateFormCtrl_TitleRequired = "L’intitul\xe9 du certificat doit \xeatre renseign\xe9.";
var ChartsModule_MinimumSkillUserCountEmptyStateText_Description = "Le graphique {{ x }} ne s’affiche pas, car le nombre minimum de <b>{{ y }}</b>\xa0utilisateurs n’a pas \xe9t\xe9 atteint.<br>Modifiez le type de bilan des formations ou contactez l’administrateur Degreed pour obtenir de l’aide.";
var ChartsModule_MinimumSkillUserCountEmptyStateText_Header = "Nombre d’utilisateurs insuffisant pour afficher ces donn\xe9es";
var checkDuplicateInputs_Decision = "Choisissez un \xe9l\xe9ment pour l’ajouter au casier du parcours.";
var checkDuplicateInputs_DuplicatesFoundPlural = "Nous avons trouv\xe9 {{count}} \xe9l\xe9ments qui utilisent d\xe9j\xe0 cette URL.";
var checkDuplicateInputs_DuplicatesFoundSingle = "Nous avons trouv\xe9 {{count}} \xe9l\xe9ment qui utilise d\xe9j\xe0 cette URL.";
var checkDuplicateInputs_ViewDuplicates = "Afficher les doublons";
var Coach_AddCoverAltFormat = "Avatar de {{title}}";
var Coach_AddInputLabelText = "Nom du coach";
var Coach_AddInputPlaceholder = "Saisir du texte pour rechercher un coach";
var Coach_AdditionalFeedback = "Commentaire additionnel";
var Coach_AddModalTitle = "Ajouter un coach";
var Coach_AddRequiredName = "Le nom du coach doit \xeatre renseign\xe9.";
var Coach_AllConversations = "Toutes les conversations";
var Coach_Capabilities = "Fonctionnalit\xe9s";
var Coach_ChooseSkill = "S\xe9lectionner une comp\xe9tence pour la revue";
var Coach_ChooseSkillNote = "Avant de commencer, veuillez noter que\xa0:";
var Coach_ClearChat = "Effacer la conversation";
var Coach_ClearChatHeader = "Confirmez-vous vouloir effacer la conversation\xa0?";
var Coach_ClearChatMessage = "Une fois effac\xe9e, vous ne pourrez plus la restaurer.";
var Coach_ClickToStart = "Cliquez pour d\xe9marrer la conversation.";
var Coach_ComingSoon = "Prochainement";
var Coach_ConversationLoadError = "Un probl\xe8me est survenu lors du chargement de la conversation.";
var Coach_ConversationStartFailed = "Impossible de d\xe9marrer la conversation. Veuillez r\xe9essayer plus tard.";
var Coach_Copied = "Copi\xe9";
var Coach_CopySuccess = "Le message a \xe9t\xe9 copi\xe9 dans le presse-papier. Utilisez ⌘/Ctrl + V pour le coller.";
var Coach_DefaultSkillReport = "Nous n’avons pas encore assez d’informations pour g\xe9n\xe9rer un rapport d\xe9taill\xe9. Avec davantage d’interactions, nous pourrons cr\xe9er un aper\xe7u complet\xa0!";
var Coach_DeleteConversation = "Supprimer la conversation\xa0?";
var Coach_DeleteConversationAction = "Supprimer cette conversation";
var Coach_DeleteConversationMessage = "Cette action supprimera <b> \xab\xa0{{ conversationSummary }}\xa0\xbb </b>";
var Coach_EndConversation = "Terminer la conversation";
var Coach_ErrorText = "Oups\xa0! Une erreur s’est produite. Veuillez r\xe9essayer.";
var Coach_Evaluate = "Effectuer la revue";
var Coach_EvaluateNewSkill = "Essayer d’\xe9valuer une nouvelle comp\xe9tence";
var Coach_ExploreContent = "Explorer le contenu";
var Coach_ExploreMaestro = "Explorer Maestro";
var Coach_ExploreMentors = "Explorer les mentors";
var Coach_ExplorePathways = "Explorer les parcours";
var Coach_ExportError = "Oups\xa0! Une erreur s’est produite lors du t\xe9l\xe9chargement. Veuillez r\xe9essayer.";
var Coach_ExportSummary = "Exporter la synth\xe8se au format PDF";
var Coach_FeedbackForMessage = "Fournir un commentaire sur ce message";
var Coach_FeedbackHeader = "Faites-nous part de votre commentaire";
var Coach_FeedbackOptionalText = "N’h\xe9sitez pas \xe0 ajouter des d\xe9tails (facultatif)";
var Coach_FeedbackUpdateError = "Malheureusement, votre commentaire n’a pas \xe9t\xe9 mis \xe0 jour. Veuillez r\xe9essayer plus tard.";
var Coach_FeedbackUpdateSuccess = "Merci pour votre commentaire\xa0! Cela nous aide \xe0 nous am\xe9liorer\xa0!";
var Coach_FormCtrlAreYouSure = "Les modifications que vous avez apport\xe9es seront perdues. Voulez-vous vraiment fermer\xa0?";
var Coach_GenerateSummaryCTA = "G\xe9n\xe9rer la synth\xe8se";
var Coach_GenerateSummarySuccess = "La synth\xe8se et les recommandations ont \xe9t\xe9 g\xe9n\xe9r\xe9es avec succ\xe8s.";
var Coach_GeneratingRecommendationError = "Une erreur est survenue lors de la g\xe9n\xe9ration des synth\xe8ses et de la recommandation. Veuillez r\xe9essayer.";
var Coach_GeneratingSkillReport = "G\xe9n\xe9ration de votre rapport de revue de comp\xe9tence, de votre synth\xe8se et de vos recommandations. Veuillez patienter.";
var Coach_GeneratingSummary = "Veuillez patienter pendant que nous g\xe9n\xe9rons la synth\xe8se et les recommandations.";
var Coach_GetStarted = "D\xe9marrer";
var Coach_HiText = "Bonjour";
var Coach_InputPlaceholder = "Lancez une conversation avec {{Coach}}.";
var Coach_InstructionAllow = "Cliquez sur \xab\xa0Autoriser\xa0\xbb. Vous n’avez pas besoin de cliquer sur un bouton pour prendre la parole, il vous suffit de parler\xa0! Appuyez sur lecture sur la carte suivante.";
var Coach_InstructionInterrupt = "Nous nous excusons si l’assistant vous interrompt. Vous pouvez terminer votre phrase, cela ne le d\xe9rangera pas.";
var Coach_InstructionMicEnable = "Vous devrez accepter l’utilisation de votre microphone.";
var Coach_InstructionVolumeUp = "Assurez-vous que votre volume est correctement r\xe9gl\xe9.";
var Coach_ModelAnalysis = "Analyse modale";
var Coach_MuteMicrophone = "Mute microphone";
var Coach_NewChat = "Nouvelle conversation";
var Coach_NoConversationText = "Aucune conversation pour le moment";
var Coach_NoDataFound = "Aucune donn\xe9e trouv\xe9e";
var Coach_NoRecommendations = "Aucune recommandation trouv\xe9e";
var Coach_NoSummary = "Aucune synth\xe8se trouv\xe9e";
var Coach_NotEnabledWarning = "Cette fonctionnalit\xe9 est actuellement indisponible. Veuillez contacter votre administrateur pour y avoir acc\xe8s";
var Coach_NoTranscriptsFound = "Commencez la conversation pour voir la transcription.";
var Coach_PinConversation = "\xc9pingler ce message";
var Coach_Pinned = "\xc9pingl\xe9";
var Coach_PlayPauseAllyText = "Cliquez ici pour lire ou mettre en pause la vid\xe9o de pr\xe9sentation du coach.";
var Coach_Prompts = "Prompts";
var Coach_PromptsEmpty = "Aucun prompt trouv\xe9";
var Coach_RecentConversations = "Conversations r\xe9centes";
var Coach_Recommendations = "Recommandations";
var Coach_RecommendedContent = "Contenus recommand\xe9s";
var Coach_RecommendedMentors = "Mentors recommand\xe9s";
var Coach_RecommendedPathways = "Parcours recommand\xe9s";
var Coach_SelectSkill = "S\xe9lectionner une comp\xe9tence \xe0 \xe9valuer";
var Coach_ShowAllCapabilities = "Afficher toutes les fonctionnalit\xe9s";
var Coach_SkillEvaluationDuration = "Cette revue prendra 5 \xe0 10\xa0minutes.";
var Coach_SkillLevelDescription = "Description du niveau de comp\xe9tence";
var Coach_SkillReport = "Rapport de comp\xe9tence";
var Coach_SkillReportModalHeader = "Votre rapport de comp\xe9tence est pr\xeat";
var Coach_SkillReportModalSubHeader = "Voici votre rapport de comp\xe9tence pour {{skill_name}}";
var Coach_SkillReportSummaryHeader = "Synth\xe8se de votre revue de comp\xe9tence";
var Coach_SkillReviewCompleted = "Votre revue de comp\xe9tence est termin\xe9e";
var Coach_SpeakToInterrupt = "Parlez pour interrompre";
var Coach_StartConversation = "Lancer une conversation";
var Coach_StartNewSkillReview = "pour commencer une nouvelle revue de comp\xe9tence";
var Coach_TextChatMode = "Conversation \xe9crite";
var Coach_TextMode = "Texte";
var Coach_TotalPinned = "\xc9pingl\xe9 ({{totalPinned}})";
var Coach_TrackAllConversations = "Suivez toutes vos conversations ici";
var Coach_Transcript = "Transcription";
var Coach_UnmuteMicrophone = "Unmute microphone";
var Coach_UpdateSkillRatings = "Actualiser l'\xe9valuation de la comp\xe9tence";
var Coach_UploadContent = "Charger du contenu ici";
var Coach_VideoTagNoSupport = "Votre navigateur ne prend pas en charge l’\xe9l\xe9ment vid\xe9o.";
var Coach_ViewMoreOptions = "Cliquez ici pour afficher plus d’options.";
var Coach_ViewSummary = "Voir la synth\xe8se";
var Coach_VirtualCoachHeader = "Coach virtuel";
var Coach_VoiceChatMode = "Conversation vocale";
var Coach_VoiceMode = "Audio";
var Coach_WelcomeBackText = "heureux de vous revoir!";
var CommentsCtrl_DeleteComment = "Souhaitez-vous r\xe9ellement supprimer ce commentaire ?";
var CommentsCtrl_DeleteCommentReplies = "Souhaitez-vous r\xe9ellement supprimer ce commentaire et ses r\xe9ponses ?";
var CommentsCtrl_DeletePost = "Supprimer la publication";
var CommentsCtrl_EditPost = "Modifier la publication";
var CommentsCtrl_Like = "J’aime";
var CommentsCtrl_Liked = "Aim\xe9";
var CommentsCtrl_PublicComment = "Ce commentaire sera public.";
var CommentsCtrl_PublicCommentDesc = "Cette discussion a lieu dans un forum public. Toutes vos publications seront visibles publiquement. Souhaitez-vous r\xe9ellement publier un commentaire ?";
var CommentsCtrl_Reply = "R\xe9pondre";
var CommentsCtrl_Unlike = "Je n’aime plus";
var CommentsCtrl_ViewConversation = "Afficher la conversation";
var CommentsCtrl_YesDelete = "Oui, supprimer";
var CommentsSvc_AccessError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’acc\xe8s aux commentaires.";
var CommentsSvc_AccessRepliesError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’acc\xe8s aux r\xe9ponses du commentaire.";
var CommentsSvc_AddCommentError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’ajout d’un commentaire.";
var CommentsSvc_AddReplyError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’ajout d’une r\xe9ponse.";
var CommentsSvc_FlagCommentError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors du signalement du commentaire.";
var CommentsSvc_GetUsersError = "Une erreur est survenue lors de l’obtention de la liste des personnes.";
var CommentsSvc_LikeError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la mise \xe0 jour du statut du commentaire.";
var CommentsSvc_RemoveCommentError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la suppression du commentaire.";
var CommentsSvc_UpdateCommentError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la mise \xe0 jour du commentaire.";
var CommentsSvc_UsersTitle = "Personnes qui ont aim\xe9 cet \xe9l\xe9ment";
var CommonMeta_AuthorContentTitle = "{0} \xe9dition";
var CommonMeta_CertificateDescription = "Avec la certification de comp\xe9tence Degreed, vous pouvez certifier les comp\xe9tences dont vous disposez, toutes les comp\xe9tences, tous les niveaux, quel que soit l’endroit o\xf9 vous les avez obtenus.";
var CommonMeta_CertificateTitle = "Ma {0} certification de comp\xe9tence | Degreed";
var CommonMeta_DegreedInfo = "Degreed est un service gratuit vous permettant de suivre et d’\xe9valuer l’ensemble de votre \xe9ducation, qu’il s’agisse de livres, de formations ou de dipl\xf4mes universitaires. Faites valoir l’ensemble de votre formation gr\xe2ce \xe0 Degreed.";
var CommonMeta_EmptyProfileTitle = "Profil de l’utilisateur";
var CommonMeta_ForMeDescription = "Degreed est une plate-forme d’apprentissage continu qui vous permet de d\xe9couvrir du contenu d’apprentissage, de d\xe9velopper vos comp\xe9tences et de certifier vos comp\xe9tences.";
var CommonMeta_ForMeTitle = "Degreed | Donnez du sens \xe0 votre apprentissage";
var CommonMeta_LifelongDiploma = "Degreed regroupe en un seul et m\xeame endroit des opportunit\xe9s d’apprentissage, de d\xe9veloppement des talents et de mobilit\xe9 interne, pour vous aider \xe0 vous r\xe9inventer, une comp\xe9tence \xe0 la fois.";
var CommonMeta_PersonalProfileTitle = "Profil de {0}";
var CommonMeta_PrivateProfileTitle = "Profil priv\xe9";
var CommonMeta_ProfileOgTitle = "{0}’s profil Degreed";
var CommonMeta_TopicDescription = "Nous avons rassembl\xe9 des articles, des cours, des vid\xe9os, des livres, des podcasts et des parcours populaires que vous pouvez explorer et d\xe9couvrir {0}.";
var CommonMeta_TopicTitle = "En savoir plus sur {0} | Degreed";
var compareForm_CandidateHeader = "Candidat\xa0{{candidateNumber}}";
var compareForm_CandidateLabel = "Candidat";
var compareForm_DetailTitle = "D\xe9tails de la comp\xe9tence";
var compareForm_Header = "Quel est le candidat le plus dou\xe9 dans le domaine \xab\xa0{{credentialName}}\xa0\xbb\xa0?";
var compareForm_Instructions = "Il est temps d’\xe9valuer vos pairs\xa0! Ces \xe9valuations nous aideront \xe0 d\xe9terminer votre niveau, alors ne les n\xe9gligez pas.";
var compareForm_Prompt = "Quel est le candidat qui a d\xe9montr\xe9 un niveau d’expertise plus \xe9lev\xe9 dans le domaine \xab\xa0{{credentialName}}\xa0\xbb\xa0?";
var compareForm_SelectWinnerValidationMessage = "Veuillez s\xe9lectionner le candidat gagnant";
var compareForm_SummaryTitle = "Comportements li\xe9s \xe0 la comp\xe9tence";
var ComparisonCriteriaSvc_Accomplishments = "\xc9valuez ce candidat en fonction de l’importance et de la difficult\xe9 de ses accomplissements.";
var ComparisonCriteriaSvc_ProvidedInformation = "\xc9valuez ce candidat en fonction de toutes les informations fournies.";
var ComparisonCriteriaSvc_SkillBreadth = "\xc9valuez ce candidat en fonction de l’\xe9tendue de ses comp\xe9tences.";
var ComparisonCriteriaSvc_SkillMastery = "\xc9valuez ce candidat en fonction du niveau d’expertise de ses comp\xe9tences.";
var ComparisonRatingOptionsSvc_Capable = "Novice";
var ComparisonRatingOptionsSvc_CapableDesc = "Le candidat a d\xe9montr\xe9 un certain niveau de comp\xe9tences, mais est susceptible de ne pas surmonter les d\xe9fis complexes. Il peut avoir obtenu un ou plusieurs accomplissements importants.";
var ComparisonRatingOptionsSvc_Distinguished = "Distingu\xe9";
var ComparisonRatingOptionsSvc_DistinguishedDesc = "Le candidat ma\xeetrise des comp\xe9tences difficiles \xe0 obtenir. Ses accomplissements sont exceptionnels et importants.";
var ComparisonRatingOptionsSvc_Emerging = "En \xe9mergence";
var ComparisonRatingOptionsSvc_EmergingDesc = "Le candidat a d\xe9montr\xe9 des comp\xe9tences de base de mani\xe8re superficielle. Il est probable qu’il obtienne des accomplissements avec des efforts.";
var ComparisonRatingOptionsSvc_Experienced = "Exp\xe9riment\xe9";
var ComparisonRatingOptionsSvc_ExperiencedDesc = "Enclin \xe0 surmonter des d\xe9fis complexes, le candidat pr\xe9sente une exp\xe9rience et une ma\xeetrise de ses comp\xe9tences. Ses accomplissements sont importants, sans forc\xe9ment \xeatre exceptionnels.";
var ComparisonRatingOptionsSvc_Master = "Expert";
var ComparisonRatingOptionsSvc_MasterDesc = "Le candidat est un expert du domaine poss\xe9dant une ma\xeetrise in\xe9gal\xe9e des comp\xe9tences. Ses accomplissements dans ce domaine sont uniques et importants.";
var ComparisonRatingOptionsSvc_Novice = "Novice";
var ComparisonRatingOptionsSvc_NoviceDesc = "Le candidat a peu ou aucunement d\xe9montr\xe9 ou compris des comp\xe9tences de base. Il n’a pas obtenu d’accomplissement ou peut en obtenir sans d\xe9ployer d’efforts importants.";
var ComparisonRatingSkillOptionsSvc_Capable = "Novice";
var ComparisonRatingSkillOptionsSvc_CapableDesc = "Le candidat a d\xe9montr\xe9 un certain niveau de comp\xe9tence, mais est susceptible de ne pas surmonter les d\xe9fis complexes.";
var ComparisonRatingSkillOptionsSvc_Distinguished = "Distingu\xe9";
var ComparisonRatingSkillOptionsSvc_DistinguishedDesc = "Le candidat ma\xeetrise une comp\xe9tence difficile \xe0 obtenir.";
var ComparisonRatingSkillOptionsSvc_Emerging = "En \xe9mergence";
var ComparisonRatingSkillOptionsSvc_EmergingDesc = "Le candidat a d\xe9montr\xe9 une comp\xe9tence de base de mani\xe8re superficielle.";
var ComparisonRatingSkillOptionsSvc_Experienced = "Exp\xe9riment\xe9";
var ComparisonRatingSkillOptionsSvc_ExperiencedDesc = "Enclin \xe0 surmonter des d\xe9fis complexes, le candidat pr\xe9sente une exp\xe9rience et une ma\xeetrise de la comp\xe9tence.";
var ComparisonRatingSkillOptionsSvc_Master = "Expert";
var ComparisonRatingSkillOptionsSvc_MasterDesc = "Le candidat est un expert du domaine poss\xe9dant une ma\xeetrise in\xe9gal\xe9e de la comp\xe9tence.";
var ComparisonRatingSkillOptionsSvc_Novice = "Novice";
var ComparisonRatingSkillOptionsSvc_NoviceDesc = "Le candidat a peu ou aucunement d\xe9montr\xe9 ou compris la comp\xe9tence de base.";
var ComparisonSvc_RatingError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’enregistrement de votre \xe9valuation.";
var ComparisonSvc_SelectionError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’enregistrement de votre s\xe9lection.";
var completedAssignedLearning_Format = "{{nameHtml}} a termin\xe9 votre assignation.";
var completedGoal_Single = "Vous avez compl\xe9t\xe9 le but {{goalHtml}}";
var completedRecommendation_ArticleFormat = "{{nameHtml}} a termin\xe9 l’article que vous avez partag\xe9.";
var completedRecommendation_AssessmentFormat = "{{nameHtml}} a termin\xe9 le test d’\xe9valuation que vous avez partag\xe9.";
var completedRecommendation_BookFormat = "{{nameHtml}} a termin\xe9 le livre que vous avez partag\xe9.";
var completedRecommendation_CourseFormat = "{{nameHtml}} a termin\xe9 le cours que vous avez partag\xe9.";
var completedRecommendation_EpisodeFormat = "{{nameHtml}} a termin\xe9 le podcast que vous avez partag\xe9.";
var completedRecommendation_EventFormat = "{{nameHtml}} a termin\xe9 l’\xe9v\xe9nement que vous avez partag\xe9.";
var completedRecommendation_Format = "{{nameHtml}} a termin\xe9 la ressource ({{resourceType}}) que vous avez partag\xe9e.";
var completedRecommendation_PathwayFormat = "{{nameHtml}} a termin\xe9 le parcours que vous avez partag\xe9.";
var completedRecommendation_PostFormat = "{{nameHtml}} a termin\xe9 la publication que vous avez partag\xe9e.";
var completedRecommendation_SkillFormat = "{{nameHtml}} a termin\xe9 la comp\xe9tence que vous avez partag\xe9e.";
var completedRecommendation_TargetFormat = "{{nameHtml}} a termin\xe9 le plan que vous avez partag\xe9.";
var completedRecommendation_TaskFormat = "{{nameHtml}} a termin\xe9 la t\xe2che que vous avez partag\xe9e.";
var completedRecommendation_VideoFormat = "{{nameHtml}} a termin\xe9 la vid\xe9o que vous avez partag\xe9e.";
var completedRecommendationFollow_Format = "{{nameHtml}} a suivi la ressource ({{resourceType}}) que vous avez partag\xe9e.";
var CompletedSkillRating_Format = "{{nameHtml}} a valid\xe9 la comp\xe9tence que vous avez partag\xe9e.";
var confirmModal_CancelApplicationBody = "Voulez-vous vraiment annuler la demande li\xe9e \xe0 la comp\xe9tence pour {{credName}}\xa0? Cette action est irr\xe9versible.";
var confirmModal_DeleteAccomplishmentBody = "Cet accomplissement n’appara\xeetra plus dans votre profil.";
var confirmModal_DeleteAccomplishmentTitle = "Souhaitez-vous vraiment supprimer cet accomplissement \xa0?";
var confirmModal_DeleteArticleBody = "Cet article ne sera plus pris en compte dans le calcul du total des points et ne s’affichera plus dans votre profil.";
var confirmModal_DeleteArticleTitle = "Souhaitez-vous r\xe9ellement supprimer cet article \xa0?";
var confirmModal_DeleteAssessmentBody = "Ce test d'\xe9valuation ne comptera plus dans le calcul du total des points et cessera de s'afficher dans votre profil.";
var confirmModal_DeleteAssessmentTitle = "Souhaitez-vous r\xe9ellement supprimer ce test d'\xe9valuation ?";
var confirmModal_DeleteAwardBody = "Cette r\xe9compense n’appara\xeetra plus dans votre profil.";
var confirmModal_DeleteAwardTitle = "Souhaitez-vous vraiment supprimer cette r\xe9compense \xa0?";
var confirmModal_DeleteBadgeBody = "Ce badge cessera de s’afficher dans votre profil.";
var confirmModal_DeleteBadgeTitle = "Souhaitez-vous r\xe9ellement supprimer ce badge ?";
var confirmModal_DeleteBookBody = "Ce livre ne sera plus pris en compte dans le calcul du total des points et ne s’affichera plus dans votre profil.";
var confirmModal_DeleteBookTitle = "Souhaitez-vous r\xe9ellement supprimer ce livre \xa0?";
var confirmModal_DeleteCertificateBody = "Ce certificat n’appara\xeetra plus dans votre profil.";
var confirmModal_DeleteCertificateTitle = "Souhaitez-vous r\xe9ellement supprimer ce certificat \xa0?";
var confirmModal_DeleteCourseBody = "Ce cours ne sera plus pris en compte dans le calcul du total des points et ne s’affichera plus dans votre profil.";
var confirmModal_DeleteCourseTitle = "Souhaitez-vous vraiment supprimer ce cours \xa0?";
var confirmModal_DeleteDegreeBody = "Ce dipl\xf4me n’appara\xeetra plus dans votre profil.";
var confirmModal_DeleteDegreeTitle = "Voulez-vous vraiment supprimer ce dipl\xf4me\xa0?";
var confirmModal_DeleteEpisodeBody = "Cet \xe9pisode ne sera plus pris en compte dans le calcul du total des points et ne s’affichera plus dans votre profil.";
var confirmModal_DeleteEpisodeTitle = "Souhaitez-vous r\xe9ellement supprimer cet \xe9pisode \xa0?";
var confirmModal_DeleteEventBody = "Cet \xe9v\xe9nement ne sera plus pris en compte dans le calcul du total des points et ne s’affichera plus dans votre profil.";
var confirmModal_DeleteEventTitle = "Souhaitez-vous r\xe9ellement supprimer cet \xe9v\xe9nement \xa0?";
var confirmModal_DeletePositionBody = "Ce poste ne sera plus pris en compte dans le calcul du total des points et ne s’affichera plus dans votre profil.";
var confirmModal_DeletePositionTitle = "Souhaitez-vous r\xe9ellement supprimer ce poste \xa0?";
var confirmModal_DeletePostBody = "Ces \xe9l\xe9ments ne seront plus pris en compte dans le calcul du total des points et ne s’afficheront plus dans votre profil.";
var confirmModal_DeletePostTitle = "Voulez-vous vraiment supprimer l’\xe9l\xe9ment s\xe9lectionn\xe9\xa0?";
var confirmModal_DeleteSkillBody = "Cette comp\xe9tence cessera de s’afficher dans votre profil.";
var confirmModal_DeleteSkillTitle = "Souhaitez-vous r\xe9ellement supprimer cette comp\xe9tence ?";
var confirmModal_DeleteTaskBody = "Cette t\xe2che ne comptera plus dans le calcul du total des points et cessera de s’afficher dans votre profil.";
var confirmModal_DeleteTaskTitle = "Souhaitez-vous r\xe9ellement supprimer cette t\xe2che ?";
var confirmModal_DeleteVideoBody = "Cette vid\xe9o ne sera plus prise en compte dans le calcul du total des points et ne s’affichera plus dans votre profil.";
var confirmModal_DeleteVideoTitle = "Souhaitez-vous r\xe9ellement supprimer cette vid\xe9o \xa0?";
var confirmModal_EvalCancelApplicationBody = "\xcates-vous s\xfbr de vouloir supprimer la revue de comp\xe9tence pour {{tagName}} ? Cette action est irr\xe9versible.";
var confirmModal_EvalRestartApplicationBody = "Cliquez sur \xab\xa0D\xe9marrer\xa0\xbb pour commencer une nouvelle revue de comp\xe9tence. Les revues de comp\xe9tences sont un excellent moyen d’\xe9valuer votre d\xe9veloppement de comp\xe9tences personnel.";
var ContentTabs_AddArticle = "Saisissez le lien d’un article que vous avez lu";
var ContentTabs_AddPost = "Saisissez le lien d’une publication que vous avez lue";
var ContentTabs_AddTopicsOrSkills = "Ajouter des comp\xe9tences";
var ContentTabs_AddVideo = "Saisissez le lien d’une vid\xe9o que vous avez vue";
var ContentTabs_EnterBookTitle = "Saisissez le nom d’un livre que vous avez lu";
var ContentTabs_InvalidTitle = "Veuillez saisir un titre";
var ContentTabs_InvalidUrl = "Veuillez saisir une URL valide";
var ContentTabs_RelatedSkills = "Comp\xe9tences connexes";
var ContentTabs_YouAddedToProfile = "Vous avez ajout\xe9 ce {{type}} \xe0 votre profil";
var CookieNotice_CookieDescription_AntiforgeryrequestV4Degreed = "Sert \xe0 pr\xe9venir les attaques CSRF";
var CookieNotice_CookieDescription_AntiforgeryV4Degreed = "Jeton anti-contrefa\xe7on servant \xe0 emp\xeacher la falsification de requ\xeates intersites (CSRF)";
var CookieNotice_CookieDescription_DegreedBearerAccess = "Enregistre un jeton OAuth crypt\xe9 gr\xe2ce auquel le bouton\xa0Degreed peut s’authentifier dans l’application Degreed";
var CookieNotice_CookieDescription_DegreedHost = "Enregistre l’h\xf4te avec lequel communique le bouton\xa0Degreed (comme degreed.com, eu.degreed.com, etc.)";
var CookieNotice_CookieDescription_Helpdeskcookie = "Enregistre la valeur h\xf4te crypt\xe9e servant \xe0 assurer la bonne liaison entre le Centre de connaissances Degreed et Degreed (comme degreed.com, eu.degreed.com, etc.)";
var CookieNotice_CookieDescription_IdentityV4Degreed = "Enregistre des informations crypt\xe9es relatives \xe0 l’identit\xe9 des utilisateurs pour permettre de maintenir leur authentification sur le site";
var CookieNotice_CookieDescription_IsEU = "Sert \xe0 contr\xf4ler l’affichage des banni\xe8res relatives aux politiques";
var CookieNotice_CookieDescription_IsNonEU = "Sert \xe0 contr\xf4ler l’affichage des banni\xe8res relatives aux politiques";
var CookieNotice_CookieDescription_SessionTimeout = "Enregistre la date et l’heure d’expiration de la session selon les param\xe8tres du syst\xe8me";
var CookieNotice_CookieDescription_SessionV4Degreed = "Enregistre des informations sur la session, y compris son identifiant, dans une cl\xe9 de hachage g\xe9n\xe9r\xe9e de fa\xe7on al\xe9atoire";
var CookieNotice_CookieDescription_SsoV4Degreed = "Enregistre le hachage \xe0 sens unique du dernier fournisseur d’identit\xe9 utilis\xe9 pour l’authentification unique (\xab\xa0SSO\xa0\xbb) afin de faciliter le SSO initi\xe9 par le fournisseur de services lorsque la session de l’utilisateur expire";
var CookieNotice_DurationType_Logout = "D\xe9connexion";
var CookieNotice_DurationType_Persistent1 = "Persistant (1\xa0jour)";
var CookieNotice_DurationType_Persistent60Custom = "Persistant (le jeton expire apr\xe8s 60\xa0jours), dur\xe9e personnalisable par les clients";
var CookieNotice_DurationType_Persistent90 = "Persistant (90\xa0jours)";
var CookieNotice_DurationType_PersistentUpdated = "Persistant jusqu’\xe0 sa mise \xe0 jour par l’application";
var CookieNotice_DurationType_Session = "Session";
var CookieNotice_EssentialCookies_Content = "<p>\n    Lorsque vous acc\xe9dez \xe0 la plateforme Degreed, certains cookies sont obligatoires pour des raisons\n    techniques afin d’assurer son bon fonctionnement. Ces cookies\n    sont qualifi\xe9s d’\xab\xa0essentiels\xa0\xbb.\n  </p>\n  <p>\n    Les cookies essentiels sauvegard\xe9s sur votre appareil lors de votre utilisation de la plateforme\n    Degreed sont les suivants\xa0:\n  </p>";
var CookieNotice_EssentialCookies_Title = "Cookies essentiels";
var CookieNotice_NonEssentialCookies_Content = "<p>\n    Si l’acc\xe8s \xe0 la plateforme\xa0Degreed vous est fourni dans le cadre d’un accord d’entreprise\n    conclu avec votre employeur, ce dernier peut exiger qu’un certain nombre\n    de cookies non essentiels soient sauvegard\xe9s sur votre appareil. Ces cookies peuvent \xeatre d\xe9pos\xe9s\n    par des services d’analyse tiers (tels que Google \xa0Analytics et Amplitude)\n    dans le but de collecter des informations.\n  </p>\n  <p>\n    Les renseignements concernant la nature des\n    cookies plac\xe9s sur votre appareil rel\xe8vent de la responsabilit\xe9 de votre organisation. Pour toute question\n    concernant les cookies enregistr\xe9s \xe0 la demande de votre employeur,\n    nous vous invitons \xe0 vous adresser directement \xe0 celui-ci.\n  </p>";
var CookieNotice_NonEssentialCookies_Title = "Cookies non essentiels de la plateforme\xa0Degreed";
var CookieNotice_OtherWebsiteCookies_Content = "<p>\n    Les utilisateurs peuvent parfois \xeatre redirig\xe9s vers d’autres sites web via des liens pr\xe9sents sur Degreed.\n    Degreed n’exerce aucun contr\xf4le sur les pratiques des sites web tiers qui ne lui appartiennent pas et\n    qu’il n’administre pas. Des cookies ou d’autres technologies similaires sont susceptibles d’\xeatre\n    d\xe9pos\xe9s sur votre appareil par des sites web tiers. Ces sites web ne sont pas soumis \xe0\n    la Politique de confidentialit\xe9 ni \xe0 l’Avis sur les cookies de Degreed. Des fournisseurs tiers, tels que\n    Google, peuvent \xe9galement utiliser des cookies pour diffuser des publicit\xe9s bas\xe9es sur les pr\xe9c\xe9dentes visites de l’utilisateur sur\n    Degreed.com.\n  </p>";
var CookieNotice_OtherWebsiteCookies_Title = "Cookies de sites tiers";
var CookieNotice_TableHeader_Duration = "Dur\xe9e";
var CookieNotice_TableHeader_Name = "Nom";
var CookieNotice_TableHeader_Provider = "Fournisseur";
var CookieNotice_TableHeader_Purpose = "Objectif";
var CookieNotice_WhatAreCookies_Content = "<p>\n    Les cookies sont de petits fichiers texte que les sites web demandent \xe0 votre appareil\n    d’enregistrer. Les cookies remplissent divers objectifs, notamment en permettant\n    aux sites d’assurer certaines fonctionnalit\xe9s (telles que le maintien de votre connexion)\n    ou de fonctionner plus efficacement. Nous utilisons d’autres technologies \xe0 des fins similaires,\n    telles que le stockage de donn\xe9es dans votre navigateur web ou sur votre appareil,\n    l’utilisation d’identifiants associ\xe9s \xe0 votre appareil, ainsi que d’autres logiciels.\n  </p>\n  <p>\n    Les cookies d\xe9pos\xe9s par un gestionnaire de site web sont appel\xe9s \xab\xa0cookies internes\xa0\xbb. Seul\n    le gestionnaire du site peut y acc\xe9der. Les cookies d\xe9pos\xe9s\n    par des entit\xe9s autres que le propri\xe9taire du site sont appel\xe9s \xab\xa0cookies tiers\xa0\xbb.\n    Les cookies tiers permettent \xe0 des fonctionnalit\xe9s ou services fournis par des entit\xe9s externes\n    d’\xeatre int\xe9gr\xe9s sur ou via le site web (par exemple, la publicit\xe9, le contenu\n    interactif et le partage sur les r\xe9seaux sociaux). Les entit\xe9s qui d\xe9posent ces cookies tiers sont\n    susceptibles de reconna\xeetre votre appareil, tant lors de la visite du site web en question\n    que lors de la visite d’autres sites ayant \xe9tabli un partenariat avec cette\n    tierce partie.\n  </p>\n  <p>\n    Certains cookies ne sont enregistr\xe9s sur votre appareil que pendant votre visite sur un site web\n    ou lors de l’utilisation d’un service. Ceux-ci sont appel\xe9s \xab\xa0cookies de session\xa0\xbb. D’autres\n    cookies peuvent rester sur votre appareil apr\xe8s votre visite ou apr\xe8s l’utilisation\n    d’un service. Ceux-ci sont appel\xe9s \xab\xa0cookies persistants\xa0\xbb.\n  </p>\n  <p>\n    Les cookies ne sont pas l’unique moyen de reconna\xeetre des visiteurs ou de suivre leur activit\xe9 sur un site web. Nous\n    sommes susceptibles d’utiliser occasionnellement d’autres technologies similaires, telles que les balises web\n    (\xe9galement appel\xe9es \xab\xa0pixels de suivi\xa0 ou \xab\xa0pixels invisibles\xa0). Il s’agit de petits\n    fichiers image contenant un identifiant unique qui nous permet de savoir\n    lorsqu’une personne a visit\xe9 le site de Degreed ou ouvert un e-mail que nous lui avons\n    envoy\xe9.\n  </p>";
var CookieNotice_WhatAreCookies_Title = "Qu’est-ce qu’un cookie\xa0?";
var CopyLinkSvc_ActionMessage = "Copi\xe9\xa0!";
var CopyLinkSvc_MacCopy = "Appuyez sur ⌘-C pour copier";
var CopyLinkSvc_PcCopy = "Appuyez sur Ctrl-C pour copier";
var Core_1DayAgo = "il y a 1\xa0jour";
var Core_1DayAgoFormat = "il y a 1\xa0jour";
var Core_1Hour = "1\xa0heure";
var Core_1Hour1Minute = "1\xa0heure, 1\xa0minute";
var Core_1HourAgo = "il y a 1\xa0heure";
var Core_1HourAgo_Minimal = "1\xa0h";
var Core_1HourMinutesFormat = "1\xa0heure, {{minutes}}\xa0minutes";
var Core_1Minute = "1\xa0minute";
var Core_1MinuteAgo = "il y a 1\xa0minute";
var Core_1MinuteAgo_Minimal = "1\xa0min";
var Core_1MonthAgo = "il y a 1\xa0mois";
var Core_1WeekAgo = "il y a 1\xa0semaine";
var Core_1WeekAgo_Minimal = "1\xa0sem";
var Core_1YearAgo = "il y a 1\xa0an";
var Core_A11yTypeaheadInstructions = "Saisissez du texte et utilisez les touches fl\xe9ch\xe9es pour s\xe9lectionner un r\xe9sultat de recherche.";
var Core_AboutMe = "\xc0 propos de moi";
var Core_Abstract = "R\xe9sum\xe9";
var Core_Academies = "Acad\xe9mies";
var Core_AcademiesDescription = "D\xe9veloppez de nouvelles comp\xe9tences gr\xe2ce aux acad\xe9mies cr\xe9\xe9es par votre entreprise.";
var Core_AcademiesExplore = "Parcourir les acad\xe9mies";
var Core_AcademiesMarketplace = "Acad\xe9mies et Marketplace de contenus";
var Core_Academy = "Acad\xe9mie";
var Core_AcademyContributor = "Contributeur de l’acad\xe9mie";
var Core_AcademyView = "Afficher l’acad\xe9mie";
var Core_Accept = "Accepter";
var Core_AccessDenied = "Acc\xe8s refus\xe9";
var Core_Accomplishment = "Accomplissement";
var Core_AccomplishmentsDisplayName = "Accomplissements";
var Core_AccountClaimed = "Compte revendiqu\xe9";
var Core_AccountStatus = "Statut du compte";
var Core_Accredited = "Autoris\xe9";
var Core_Achievements = "R\xe9ussites";
var Core_Acknowledge_Changes = "Je confirme avoir pris connaissance des modifications et les accepte";
var Core_ActionError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de cette action. Ce n’est pas votre faute et nous mettons tout en œuvre pour r\xe9soudre le probl\xe8me.";
var Core_Actions = "Actions";
var Core_Active = "Actif";
var Core_ActiveLearner = "Apprenant actif";
var Core_ActiveLearners = "Apprenants actifs";
var Core_Activity = "Activit\xe9";
var Core_ActualRecommendation = "Recommandation";
var Core_Add = "Ajouter";
var Core_Add_Skill_Source = "Add Source";
var Core_Add_Source = "Ajouter une source";
var Core_AddAccomplishment = "Ajouter un accomplissement";
var Core_AddArticle = "Ajouter un article";
var Core_AddAudio = "Ajouter un podcast";
var Core_AddAudioToCatalogFormat = "Ajouter ce podcast au catalogue {{orgName}}";
var Core_AddBio = "Ajouter une biographie";
var Core_AddBook = "Ajouter un livre";
var Core_AddContent = "Ajouter du contenu";
var Core_Added = "ajout\xe9";
var Core_AddedToQueueNotifierFormat = "{{itemTitle}} a \xe9t\xe9 enregistr\xe9\xa0!";
var Core_AddExperience = "Ajouter une exp\xe9rience";
var Core_AddGroups = "Ajouter des groupes";
var Core_AddGroupsInfo = "Ajoutez des groupes pour aider les utilisateurs \xe0 trouver le contenu li\xe9 aux groupes auxquels ils appartiennent.";
var Core_AddingGroupsInfo = "Ajoutez des groupes pour aider les utilisateurs \xe0 trouver le contenu li\xe9 aux groupes auxquels ils appartiennent.";
var Core_AddItemTo = "Add {{type}} {{name}} to...";
var Core_AddPage = "Ajouter un r\xe9pertoire";
var Core_AddPathway = "Ajouter le parcours";
var Core_AddPlans = "Ajouter des plans";
var Core_AddPost = "Saisissez le lien d’une publication que vous avez lue";
var Core_AddTags = "Ajouter des comp\xe9tences";
var Core_AddTakeaway = "Ajouter un avis";
var Core_AddTo = "Ajouter \xe0...";
var Core_AddToBundle = "Ajouter au lot";
var Core_AddToContent = "Ajouter au contenu";
var Core_AddToJobRole = "Ajouter \xe0 un plan";
var Core_AddToPathway = "Ajouter \xe0 un parcours";
var Core_AddVideo = "Ajouter une vid\xe9o";
var Core_Advanced = "Avanc\xe9";
var Core_AdvancedSettings = "Param\xe8tres avanc\xe9s";
var Core_AgreeContinue = "Accepter et continuer";
var Core_All = "Tout";
var Core_All_Level = "Tous les niveaux";
var Core_AllFieldsRequired = "Tous les champs doivent \xeatre renseign\xe9s.";
var Core_AllTypesDisplayName = "Tous les types";
var Core_AllUsers = "Tous les utilisateurs";
var Core_AltText = "Texte alternatif de l’image";
var Core_AltTextHelperText = "Ajoutez un texte alternatif pour d\xe9crire l’aspect ou la fonction de l’image \xe0 l’aide de mots simples.";
var Core_Announcement = "Annonce";
var Core_AnonymousCountPluralFormat = "{{count}} apprenants anonymes";
var Core_AnonymousCountSingular = "1 apprenant anonyme";
var Core_AnonymousLearner = "Apprenant anonyme";
var Core_AnonymousLearners = "Apprenants anonymes";
var Core_AnonymousLearnersNotShown = "Apprenants anonymes non affich\xe9s";
var Core_Apply = "Appliquer";
var Core_ApplyChanges = "Appliquer";
var Core_Approve = "Approuver";
var Core_ApproveAll = "Tout accepter";
var Core_ApproximateMinLeft = "env. {{minutes}}\xa0minutes restantes";
var Core_Archived = "Candidature archiv\xe9e";
var Core_AreYouSure = "Confirmer";
var Core_Article = "Article";
var Core_Articles = "Articles";
var Core_ArticlesDisplayName = "Articles";
var Core_ArticlesVideosDisplayName = "Articles et vid\xe9os";
var Core_ArticleVideoDisplayName = "Articles et vid\xe9os";
var Core_Assessment = "Test d’\xe9valuation";
var Core_AssessmentsDisplayName = "Tests d’\xe9valuation";
var Core_Assign = "Assigner";
var Core_Assigned = "Assign\xe9";
var Core_AssignedBy = "Assign\xe9 par";
var Core_AssignedDate = "Date d’assignation";
var Core_AssignedLearning = "Formations assign\xe9es";
var Core_AssignedLearningEmptyState = "Vous n’avez aucune formation assign\xe9e \xe0 terminer.";
var Core_AssignedTo = "Assign\xe9 \xe0";
var Core_Assignment = "Formation assign\xe9e";
var Core_AssignmentType = "Type de formation assign\xe9e";
var Core_Atoz = "A \xe0 Z";
var Core_Attend = "Participer";
var Core_Audio = "Podcast";
var Core_Audiobook = "Audio";
var Core_AudioLength = "Dur\xe9e du podcast (en minutes)";
var Core_AudioNamePlaceholder = "Saisissez le nom ou le lien d’un podcast que vous avez vu ou \xe9cout\xe9";
var Core_AudioTitlePlaceholder = "Saisissez un titre pour cet audio";
var Core_AudioUrl = "URL de l’audio";
var Core_Authoring = "Cr\xe9ation de contenu";
var Core_Authors = "Auteurs";
var Core_Award = "R\xe9compense";
var Core_AwardsDisplayName = "R\xe9compenses";
var Core_AWeek = "Une semaine";
var Core_Back = "Retour";
var Core_BackToHomepage = "Retour \xe0 la page d’accueil";
var Core_Badge = "Insigne";
var Core_BadgesDisplayName = "Insignes";
var Core_Basic = "Basique";
var Core_Beginner = "D\xe9butant";
var Core_Book = "Livre";
var Core_Books = "Livres";
var Core_BooksDisplayName = "Livres";
var Core_Bootcamp = "Formation intensive";
var Core_Browse = "Parcourir";
var Core_BulkEdit = "Modifier en bloc";
var Core_BulkEditSelectedCount = "{{count}} s\xe9lectionn\xe9(s)";
var Core_By = "Attribu\xe9 par";
var Core_CalendarDayCount = "{{dayCount}}\xa0derniers jours";
var Core_CalendarNextMonth = "Afficher le mois suivant";
var Core_CalendarPastYear = "L’ann\xe9e pass\xe9e";
var Core_CalendarPrevMonth = "Afficher le mois pr\xe9c\xe9dent";
var Core_CalendarRangeEnd = "Fin de la plage";
var Core_CalendarRangeStart = "D\xe9but de la plage";
var Core_CalendarSelectLast = "S\xe9lectionner le dernier\xa0:";
var Core_CalendarSelectRange = "S\xe9lectionner une plage de dates\xa0:";
var Core_CalendarSpecificDates = "Dates pr\xe9cises";
var Core_CalendarView = "Afficher le calendrier";
var Core_Cancel = "Annuler";
var Core_Candidates = "Candidats";
var Core_CannotBeUndone = "Cette action est irr\xe9versible.";
var Core_CaseStudy = "\xc9tude de cas";
var Core_Categories = "Categories";
var Core_Category = "Comp\xe9tence";
var Core_CategoryName = "Comp\xe9tence";
var Core_Certificate = "Certificat";
var Core_CertificatesDisplayName = "Certificats";
var Core_Certification = "Certification";
var Core_CEU = "UFC";
var Core_CEUEligible = "\xc9ligible UFC";
var Core_CEUUnits = "{{units}} UFC";
var Core_Change = "Modifier";
var Core_Change_Primary_Skill_Source = "Changer la source de comp\xe9tences principale";
var Core_Changes = "Changes";
var Core_ChangesSaved = "Les modifications ont \xe9t\xe9 enregistr\xe9es";
var Core_CharLimitExceeded = "Nombre limite de caract\xe8res d\xe9pass\xe9";
var Core_CharsRemainingFormat = "Caract\xe8res restants\xa0: {{count}}";
var Core_ChartNotAvailableForAppliedFilters = "Ce graphique n’est pas disponible pour les filtres appliqu\xe9s.";
var Core_Chat = "Messagerie";
var Core_CheckboxAll = "S\xe9lectionner toutes les lignes du tableau";
var Core_ChooseFile = "Choisir un fichier";
var Core_ChooseSetupOptions = "Choisir une option d’installation";
var Core_Clear = "Supprimer";
var Core_ClearFilter = "Effacer le filtre";
var Core_ClearFilters = "Effacer les filtres";
var Core_ClearNumberFormat = "Effacer {{numberSelected}}\xa0filtre(s)";
var Core_ClearRating = "Effacer l’\xe9valuation";
var Core_ClearSelection = "Effacer toute la s\xe9lection";
var Core_ClearSelectionPluralFormat = "Effacer les {{count}} \xe9l\xe9ments s\xe9lectionn\xe9s";
var Core_ClearSelectionSingle = "Effacer l’\xe9l\xe9ment s\xe9lectionn\xe9";
var Core_ClearSelfRating = "Effacer l’auto-\xe9valuation";
var Core_ClickHere = "Cliquez ici";
var Core_Clone = "Cloner";
var Core_CloneOfFormat = "[Clone de] {{title}}";
var Core_Close = "Fermer";
var Core_Closed = "Ferm\xe9";
var Core_ClosedOnDate = "Ferm\xe9(e) le {{ date }}";
var Core_CloseSuccess = "Fermer le message de confirmation";
var Core_Coach = "Coach";
var Core_Coaching = "Coaching";
var Core_Collaborator = "Collaborateur";
var Core_CollaboratorOnly = "Collaborateur uniquement";
var Core_Collaborators = "Collaborateurs\xa0";
var Core_Collapse = "R\xe9duire";
var Core_CollapseAria = "Contexte pour le bouton R\xe9duire\xa0: {{context}}";
var Core_ComingSoon = "Prochainement";
var Core_Comment = "Commentaire";
var Core_CommentPrivacyWarning = "(Ce commentaire sera accessible par les autres personnes).";
var Core_Comments = "Commentaires";
var Core_Complete = "Terminer";
var Core_Completed = "Termin\xe9";
var Core_CompletedContent = "Contenu termin\xe9";
var Core_CompletedDate = "Date de compl\xe9tion";
var Core_CompletedFormat = "A marqu\xe9 {{resourceType}} comme effectu\xe9";
var Core_CompletedStatus = "Statut Termin\xe9";
var Core_Completion_Progress = "Progression";
var Core_Completions = "\xc9l\xe9ments termin\xe9s";
var Core_Confetti = "Confetti";
var Core_Confirm = "Confirmer";
var Core_ConfirmModalDefaultInputString = "DELETE";
var Core_ConfirmModalInputStringPlaceHolder = "Type '{{input}}'";
var Core_ConfirmPassword = "Confirmez le mot de passe";
var Core_ConfirmPasswordPlaceholder = "Tapez-le une fois de plus";
var Core_Connect = "Connexion";
var Core_Connected = "Connect\xe9";
var Core_Connectors = "Connecteurs";
var Core_ContactDegreedSupport = "veuillez contacter l’assistance de Degreed";
var Core_Content = "Contenu";
var Core_ContentCompleted = "Vous avez termin\xe9 {{content_title}}.";
var Core_ContentFollowed = "Vous vous \xeates abonn\xe9(e) \xe0 {{content_title}}.";
var Core_ContentProcessing = "Your content is being processed";
var Core_ContentRemoved = "Vous avez supprim\xe9 {{content_title}} de la collection sur votre profil.";
var Core_ContentSaved = "Vous avez enregistr\xe9 {{content_title}}.";
var Core_ContentType = "Type de contenu";
var Core_ContentUncompleted = "Vous avez supprim\xe9 {{content_title}} de vos \xe9l\xe9ments termin\xe9s.";
var Core_ContentUnfollowed = "Vous n’\xeates plus abonn\xe9(e) \xe0 {{content_title}}.";
var Core_ContentUnsaved = "Vous avez supprim\xe9 {{content_title}} de vos \xe9l\xe9ments enregistr\xe9s.";
var Core_Continue = "Continuer";
var Core_ContinueLearningEmptyState = "Vous n’avez aucun contenu de formation en cours.";
var Core_ContinuingEducationUnitsEligible = "UFC disponibles";
var Core_CopyToClipboard = "Copi\xe9 dans le presse-papier";
var Core_Cost = "Co\xfbt";
var Core_CountItems = "{{count}}\xa0\xe9l\xe9ments";
var Core_CountMinutes = "{{count}}\xa0minutes";
var Core_CountPoints = "{{count}}\xa0points";
var Core_Course = "Cours";
var Core_Courses = "Formations";
var Core_CoursesDisplayName = "Cours";
var Core_Create = "Cr\xe9er";
var Core_CreatedBy = "Cr\xe9\xe9(e) par\xa0: {{authorName}}";
var Core_CreatedDate = "Date de cr\xe9ation";
var Core_Critical = "Critique";
var Core_Crop = "Recadrer";
var Core_Cropping = "Recadrage";
var Core_CurrentPassword = "Mot de passe actuel";
var Core_CurrentPasswordPlaceholder = "Entrez votre mot de passe actuel";
var Core_CurrentSelfRating = "Auto-\xe9valuation actuelle";
var Core_Date = "Date";
var Core_Date_YYYYMMDDFormat = "aaaa-mm-jj";
var Core_DateAddedToProfile = "Date d’ajout au profil";
var Core_DateLastUpdated = "Date de la derni\xe8re mise \xe0 jour";
var Core_Day = "Jour";
var Core_DayOfWeekFriday = "Vendredi";
var Core_DayOfWeekMonday = "Lundi";
var Core_DayOfWeekSaturday = "Samedi";
var Core_DayOfWeekSunday = "Dimanche";
var Core_DayOfWeekThursday = "Jeudi";
var Core_DayOfWeekTuesday = "Mardi";
var Core_DayOfWeekWednesday = "Mercredi";
var Core_Days = "jours";
var Core_DaysAgoFormat = "il y a {{time}}\xa0jours";
var Core_DaysAgoFormat_Minimal = "{{time}}\xa0j";
var Core_DaysFormat = "{{days}}\xa0jours";
var Core_Decline = "Refuser";
var Core_DeclineAll = "Tout refuser";
var Core_Declined = "Refus\xe9";
var Core_Degree = "Dipl\xf4me";
var Core_DegreeBachelors = "Dipl\xf4me - Licence";
var Core_DegreedSupport = "Assistance Degreed";
var Core_DegreeMasters = "Dipl\xf4me - Master";
var Core_DegreesDisplayName = "Dipl\xf4mes";
var Core_Delete = "Supprimer";
var Core_Deleted = "supprim\xe9";
var Core_Department = "Service";
var Core_Description = "Description";
var Core_Details = "D\xe9tails";
var Core_Developing = "En d\xe9veloppement";
var Core_Difficulty = "Difficult\xe9";
var Core_Directory = "R\xe9pertoire";
var Core_Directorys = "R\xe9pertoires";
var Core_DirectorysDisplayName = "R\xe9pertoires";
var Core_Disable = "D\xe9sactiver";
var Core_Disabled = "D\xe9sactiv\xe9";
var Core_DiscardChanges = "Annuler les modifications";
var Core_Discover = "D\xe9couvrir";
var Core_DislikeAllyText = "Je n’aime pas {{type}} {{name}}";
var Core_Dismiss = "Ignorer";
var Core_DismissContent = "Ignorer le contenu";
var Core_DismissDialogHeader = "Souhaitez-vous r\xe9ellement supprimer cet \xe9l\xe9ment ?";
var Core_DismissItemError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors du masquage de l’\xe9l\xe9ment.";
var Core_DismissItemSuccess = "\xc9l\xe9ment ignor\xe9.";
var Core_Documentary = "Documentaire";
var Core_Done = "Terminer";
var Core_DoneEditing = "Modification termin\xe9e";
var Core_DownloadDetails = "T\xe9l\xe9charger les d\xe9tails";
var Core_DownloadFiles = "T\xe9l\xe9charger les fichiers";
var Core_DownloadMetadata = "T\xe9l\xe9charger les m\xe9tadonn\xe9es";
var Core_Draft = "Brouillon";
var Core_DragFileHere = "Faites glisser un fichier ici ou";
var Core_Due = "Date limite";
var Core_DueBy = "Date limite";
var Core_DueDate = "Date limite";
var Core_DueDateFormat = "Date limite {{date}}";
var Core_DueDateTimeFormat = "Date limite {{date}} \xe0 {{time}}";
var Core_DueIn = "\xc9ch\xe9ance";
var Core_DueOn = "\xc9ch\xe9ance";
var Core_Duration = "Dur\xe9e";
var Core_DurationMinutes = "Dur\xe9e (minutes)";
var Core_DurationType = "Type de dur\xe9e";
var Core_Edit = "Modifier";
var Core_Edit_Skill_Source = "Modifier la source de comp\xe9tences";
var Core_EditArticle = "Modifier les d\xe9tails de l’article";
var Core_EditAudio = "Modifier les d\xe9tails du podcast";
var Core_EditBook = "Modifier les d\xe9tails du livre";
var Core_EditDescription = "Modifier la description";
var Core_EditDetails = "Modifier les d\xe9tails";
var Core_EditItem = "Modifier l’\xe9l\xe9ment interne";
var Core_EditItemHelper = "Les modifications de cet \xe9l\xe9ment seront appliqu\xe9es au catalogue de contenus de votre organisation.";
var Core_EditPost = "Modifier les d\xe9tails de la publication";
var Core_EditSkillTarget = "Modifier la cible de la comp\xe9tence";
var Core_EditStep = "Modifier l’\xe9tape";
var Core_EditVideo = "Modifier les d\xe9tails de la vid\xe9o";
var Core_Electronic = "\xc9lectronique";
var Core_Email = "Adresse e-mail";
var Core_EmailAddress = "Adresse e-mail";
var Core_EmailAddresses = "Adresse(s) e-mail";
var Core_EmailContent = "Contenu de l’e-mail";
var Core_EmailExistsError = "Un compte utilisant cette adresse e-mail a d\xe9j\xe0 \xe9t\xe9 enregistr\xe9. Veuillez vous connecter en utilisant cette adresse.";
var Core_EmailPlaceholder = "jane@acme.com";
var Core_EmailSubject = "Objet de l’e-mail";
var Core_EmailVerificationSuccessful = "Votre adresse e-mail a \xe9t\xe9 v\xe9rifi\xe9e";
var Core_Empty_Image_Alt = "Vide";
var Core_EmptyFocusSkills = "Commencez \xe0 ajouter des comp\xe9tences prioritaires \xe0 votre profil afin de recevoir des recommandations de formation appropri\xe9es de la part de Degreed.";
var Core_EmptyFocusSkillsWithSuggestion = "Vous n’avez aucune comp\xe9tence prioritaire dans votre profil Degreed. Compte tenu de votre poste, nous vous recommandons d’ajouter les comp\xe9tences prioritaires suivantes\xa0:";
var Core_Enable = "Activer";
var Core_Enabled = "Activ\xe9";
var Core_EndDate = "Date de fin";
var Core_Endorse = "Recommander";
var Core_EndorseConfirmation = "La recommandation peut mettre plusieurs minutes \xe0 appara\xeetre.";
var Core_EndorseContentChannelTypeError = "Cette recommandation ne peut pas \xeatre mise \xe0 jour.";
var Core_EndorseContentGenericError = "Un probl\xe8me est survenu lors de la mise \xe0 jour de la recommandation.";
var Core_EndorseContentOrgTypeError = "Cette recommandation ne peut pas \xeatre mise \xe0 jour.";
var Core_EndorseContentPermissionError = "Vous n’avez pas l’autorisation de mettre \xe0 jour la recommandation.";
var Core_Endorsed = "Recommand\xe9";
var Core_EndorsedByOrganization = "Recommand\xe9 par {{orgName}}";
var Core_EndorsedOnly = "Recommand\xe9 seulement";
var Core_EndorsedTooltip = "Recommand\xe9 par l’entreprise";
var Core_EndorseInformation = "Les ressources recommand\xe9es sont mises en avant dans les r\xe9sultats de recherche et une ic\xf4ne s’affiche pour indiquer que l’\xe9l\xe9ment est recommand\xe9 par votre organisation.";
var Core_EndorsementRemoved = "Recommandation supprim\xe9e";
var Core_Engagement = "Engagement";
var Core_Enroll = "S’inscrire";
var Core_Enrolled = "Inscrit";
var Core_Enrollees = "Inscrits";
var Core_EnrollInPathway = "S’inscrire au parcours";
var Core_Enrollment = "Inscription";
var Core_Enrolls = "Inscriptions";
var Core_Episode = "Podcast";
var Core_EpisodesDisplayName = "Podcasts";
var Core_Error = "Erreur";
var Core_Event = "\xc9v\xe9nement";
var Core_Events = "\xc9v\xe8nements";
var Core_EventsDisplayName = "\xc9v\xe9nements";
var Core_ExactMatches = "Correspondances exactes";
var Core_Expand = "D\xe9velopper";
var Core_ExperienceDisplayName = "Exp\xe9rience";
var Core_ExperiencesDisplayName = "Exp\xe9riences";
var Core_Expert = "Expert";
var Core_External = "Externe";
var Core_ExternalBook = "Livre";
var Core_ExternalBooksDisplayName = "Livres";
var Core_ExternalPodcast = "Podcast";
var Core_ExternalPodcastsDisplayName = "Podcasts";
var Core_ExternalResources = "Ressources externes";
var Core_ExternalVideo = "Vid\xe9o";
var Core_ExternalVideosDisplayName = "Vid\xe9os";
var Core_False = "Faux";
var Core_Favicon = "Favicon";
var Core_FeatureResource = "Ajouter sur la page \xc0 la une";
var Core_Feed = "Flux";
var Core_FieldInvalidFormat = "{{fieldName}} invalide";
var Core_FieldRequired = "Ce champ doit \xeatre renseign\xe9.";
var Core_FieldRequiredFormat = "{{fieldName}} est obligatoire";
var Core_Files = "Fichiers";
var Core_FileTypes_FirstOrOnly = "{{fileType}}";
var Core_FileTypes_Middle = ", {{fileType}}";
var Core_FileTypes_OrLast = " ou {{fileType}}";
var Core_Filter = "Filtrer";
var Core_FilterApplied = "1 filtre appliqu\xe9";
var Core_FiltersAppliedFormat = "{{count}} filtres appliqu\xe9s";
var Core_FindContent = "Rechercher des contenus";
var Core_Finish = "Terminer";
var Core_FirstName = "Pr\xe9nom";
var Core_FlagAsInappropriate = "Signaler comme inappropri\xe9";
var Core_Focus = "Prioritaires";
var Core_FocusSkill = "Comp\xe9tence prioritaire";
var Core_FocusUnderLimitDescription = "Vous trouverez ci-dessous les comp\xe9tences prioritaires ajout\xe9es \xe0 votre profil Degreed. Ajoutez des auto-\xe9valuations et s\xe9lectionnez des niveaux cibles afin de recevoir des recommandations de formation appropri\xe9es de la part de Degreed.";
var Core_FocusUptoLimitDescription = "Ajoutez des auto-\xe9valuations et s\xe9lectionnez des niveaux cibles pour vos comp\xe9tences prioritaires afin de recevoir des recommandations de formation appropri\xe9es de la part de Degreed.";
var Core_Follow = "Suivre";
var Core_Follow_UserName = "Suivre {{userName}}";
var Core_Followers = "Abonn\xe9s";
var Core_Following = "Suivi";
var Core_FollowingButtonLabel = "Vous suivez cet \xe9l\xe9ment. Cliquez pour vous d\xe9sabonner.";
var Core_FollowPathway = "Suivre le parcours";
var Core_Follows = "Abonn\xe9s";
var Core_Format = "Format";
var Core_Free = "Gratuit";
var Core_FreeformText = "Zone de texte";
var Core_Future = "Futur";
var Core_GeneralErrorMessage = "D\xe9sol\xe9s ! Un probl\xe8me est survenu lors de l’enregistrement des modifications.";
var Core_GeneralLoadingError = "Un probl\xe8me est survenu lors du chargement de la page.";
var Core_Goal = "Objectif";
var Core_GoalAddedFormat = "{{title}} a \xe9t\xe9 ajout\xe9 \xe0 vos objectifs\xa0!";
var Core_GoBack = "Retour";
var Core_Graduate = "Deuxi\xe8me cycle";
var Core_GreaterThan1Day = "> 1\xa0jour";
var Core_Grid = "Affichage Grille";
var Core_Group = "Groupe";
var Core_GroupDisplayName = "Parcourir les groupes";
var Core_Groups = "Groupes";
var Core_GroupsDisplayName = "Groupes";
var Core_GrowthPlan = "Plan de croissance";
var Core_Help = "Aide";
var Core_Hide = "Masquer";
var Core_HideFilters = "Masquer les filtres";
var Core_Home = "Accueil";
var Core_Hooray = "Parfait\xa0!";
var Core_Hour = "heure";
var Core_Hours = "heures";
var Core_HoursAgoFormat = "il y a {{time}}\xa0heures";
var Core_HoursAgoFormat_Minimal = "{{time}}\xa0h";
var Core_HoursFormat = "{{hours}}\xa0heures";
var Core_HoursMinutesFormat = "{{hours}}\xa0heures, {{minutes}}\xa0minutes";
var Core_Hybrid = "Hybride";
var Core_Icon = "Ic\xf4ne";
var Core_ICreatedAudio = "J’ai cr\xe9\xe9 ce podcast";
var Core_Image = "Image";
var Core_In1DayFormat = "Dans 1\xa0jour";
var Core_Inactive = "Inactive";
var Core_InAppNotification = "In-App Notification";
var Core_InDaysFormat = "Dans {{time}} jours";
var Core_Inference = "Inference";
var Core_Info = "Infos";
var Core_InPerson = "En pr\xe9sentiel";
var Core_InProgress = "En cours";
var Core_InputActionAdded = "a ajout\xe9 le {{input}} suivant";
var Core_InputActionAttended = "a particip\xe9 \xe0 un \xe9v\xe9nement";
var Core_InputActionCompleted = "a termin\xe9 un cours";
var Core_InputActionCompletedCourse = "a termin\xe9 un cours";
var Core_InputActionCompletedPodcast = "a compl\xe9t\xe9 un \xe9l\xe9ment audio";
var Core_InputActionRead = "a lu un article";
var Core_InputActionReadBook = "a lu un livre";
var Core_InputActionTaskCompleted = "a r\xe9alis\xe9 une t\xe2che";
var Core_InputActionWatched = "a regard\xe9 une vid\xe9o";
var Core_InputCommentPlaceholder = "Partagez un commentaire concernant ce contenu ({{inputType}}) avec d’autres personnes de votre organisation.";
var Core_InputDetails = "{{ name }} - D\xe9tails";
var Core_Inputs = "Contenu";
var Core_Insights = "Statistiques";
var Core_Instructions = "Instructions";
var Core_InstructorLed = "Classe dirig\xe9e par un professeur";
var Core_Integration = "Int\xe9gration";
var Core_Interested = "Int\xe9ress\xe9s";
var Core_Intermediate = "Interm\xe9diaire";
var Core_Invalid = "Invalide";
var Core_InvalidEmail = "Veuillez saisir une adresse e-mail valide";
var Core_InvalidEmailPattern = "Cette adresse e-mail n’est pas valide";
var Core_InvalidMaxValue = "Veuillez saisir une valeur inf\xe9rieure ou \xe9gale \xe0 {{max}}";
var Core_InvalidMinValue = "Veuillez saisir une valeur sup\xe9rieure ou \xe9gale \xe0 {{min}}";
var Core_Inventory = "Inventaire";
var Core_Invite = "Inviter";
var Core_Items = "\xc9l\xe9ments";
var Core_ItemsSelectedFormat = "{{count}} s\xe9lectionn\xe9(s)";
var Core_JobRole = "Plan";
var Core_JobroleDisplayName = "Plan";
var Core_JobRoleLiteral = "Poste";
var Core_JobRoles = "Plans";
var Core_JobRolesDisplayName = "Plans";
var Core_JobTitle = "Intitul\xe9 de poste";
var Core_Join = "S’inscrire";
var Core_Joined = "Inscrit";
var Core_JoinEvent = "Rejoindre l’\xe9v\xe9nement";
var Core_Journal = "Journal";
var Core_Journey = "Parcours";
var Core_JustNow = "il y a quelques instants";
var Core_Language = "Langue";
var Core_LanguageSettings = "Param\xe8tres de langues";
var Core_LastActive = "Derni\xe8re activit\xe9";
var Core_LastLogin = "Date de votre derni\xe8re connexion\xa0:";
var Core_LastMonth = "Le mois dernier";
var Core_LastName = "Nom";
var Core_LastNameTC = "Nom";
var Core_LastUpdated = "Derni\xe8re mise \xe0 jour le";
var Core_LastWeek = "La semaine derni\xe8re";
var Core_Learn_More = "En savoir plus";
var Core_Learning = "Formation";
var Core_LearningMinutes = "Minutes de formation";
var Core_LearningPath = "Parcours d’apprentissage";
var Core_Learnings = "Formations";
var Core_LearnMore = "En savoir plus";
var Core_LearnOnDegreed = "Apprendre sur Degreed";
var Core_LessThan10 = "< 10\xa0min";
var Core_LessThan1Day = "< 1\xa0jour";
var Core_LessThan1Hour = "< 1\xa0heure";
var Core_LessThan30 = "< 30\xa0min";
var Core_LessThan30Days = "< 30\xa0jours";
var Core_LessThan4Hours = "< 4\xa0heures";
var Core_LessThan5 = "< 5\xa0min";
var Core_LessThan6Months = "< 6\xa0mois";
var Core_LessThanADay = "Moins d’un jour";
var Core_LessThanOneYear = "< 1\xa0an";
var Core_Like = "J’aime";
var Core_LikeAllyText = "J’aime {{type}} {{name}}";
var Core_Liked = "Aim\xe9";
var Core_LimitedVisibility = "Visibilit\xe9 limit\xe9e";
var Core_Link = "Lien";
var Core_Linked_External_Skill_Source = "Source de comp\xe9tences externe li\xe9e";
var Core_Links = "Liens";
var Core_LinkText = "Lien";
var Core_List = "Affichage Liste";
var Core_ListItemsError = "Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration des \xe9l\xe9ments de la liste.";
var Core_Live = "En direct";
var Core_LiveOnlineTraining = "Formation en ligne en direct";
var Core_Loading = "Chargement en cours";
var Core_LoadingResults = "Chargement des r\xe9sultats…";
var Core_LoadMore = "Afficher plus";
var Core_LoadMoreAria = "Contexte pour le bouton Afficher plus\xa0: {{context}}";
var Core_Location = "Localisation";
var Core_MaliciousURL = "D\xe9sol\xe9\xa0! Ce contenu provient d’un site Web risqu\xe9 et ne peut pas \xeatre ajout\xe9.";
var Core_ManageFocusSkills = "G\xe9rer les comp\xe9tences prioritaires";
var Core_ManagerRating = "\xc9valuations du manager";
var Core_ManageTranslations = "G\xe9rer les traductions";
var Core_Mandatory = "R\xe9glementaire";
var Core_Mark_ContentName_Complete = "Terminer \xab\xa0{{contentName}}\xa0\xbb";
var Core_Mark_ContentTitle_Complete = "Terminer \xab\xa0{{contentTitle}}\xa0\xbb";
var Core_MarkAsComplete = "Marquer comme termin\xe9";
var Core_Marketplace = "Marketplace";
var Core_Matched_Skills = "Comp\xe9tences correspondantes";
var Core_MatchedOf = "{{matched}}\xa0sur {{total}}";
var Core_MaxCost = "Prix maximal";
var Core_Media = "M\xe9dia";
var Core_Meeting = "R\xe9union";
var Core_Members = "Membres";
var Core_Membership = "Abonnement";
var Core_Mentee = "Mentor\xe9";
var Core_Mentor = "Mentor";
var Core_Mentors = "Mentors";
var Core_Message = "Message";
var Core_MinCost = "Prix minimal";
var Core_Minute = "minute";
var Core_Minutes = "minutes";
var Core_MinutesAgoFormat = "il y a {{time}}\xa0minutes";
var Core_MinutesAgoFormat_Minimal = "{{time}}\xa0min";
var Core_MinutesFormat = "{{minutes}}\xa0minutes";
var Core_MissingRatingNudgeText = "Aidez Degreed \xe0 am\xe9liorer vos recommandations de contenus en vous \xe9valuant dans les comp\xe9tences suivantes\xa0:";
var Core_Month = "mois";
var Core_MonthAgoFormat = "il y a {{time}}\xa0mois";
var Core_Months = "mois";
var Core_MonthsAgoFormat = "il y a {{time}}\xa0mois";
var Core_MonthsAgoFormat_Minimal = "{{time}}\xa0mois";
var Core_More = "Plus";
var Core_MoreDetails = "Plus de d\xe9tails";
var Core_MoreFilters = "Plus de filtres";
var Core_MoreInfo = "plus d’informations";
var Core_MoreOptions = "plus d’options";
var Core_MoreOptionsForItem = "Plus d’options pour {{name}}";
var Core_MoveDown = "D\xe9placer vers le bas";
var Core_MoveToGlobal = "D\xe9placer vers le catalogue global";
var Core_MoveUp = "D\xe9placer vers le haut";
var Core_Multisession = "Plusieurs sessions";
var Core_Name = "Nom";
var Core_NearStart = "Commence bient\xf4t";
var Core_New = "Nouveau";
var Core_Newest = "Plus r\xe9cent";
var Core_NewItem = "1\xa0nouvel \xe9l\xe9ment";
var Core_NewItems = "{{count}}\xa0nouveaux \xe9l\xe9ments";
var Core_NewPassword = "Nouveau mot de passe";
var Core_NewPasswordPlaceholder = "Gardez-le secret !";
var Core_NewRating = "Nouvelle \xe9valuation";
var Core_NewSelfRating = "Nouvelle auto-\xe9valuation";
var Core_Next = "Suivant";
var Core_Next30Days = "30\xa0prochains jours";
var Core_Next60Days = "60\xa0prochains jours";
var Core_Next7Days = "7\xa0prochains jours";
var Core_NextYear = "Ann\xe9e prochaine";
var Core_NinePlusMonths = "Plus de 9\xa0mois";
var Core_No = "Non";
var Core_NoDescription = "Aucune description";
var Core_NoDueDate = "Pas de date limite";
var Core_NoFiles = "Aucun fichier";
var Core_NoMembers = "Aucun membre \xe0 afficher";
var Core_NoPreviousLogin = "Aucune connexion pr\xe9c\xe9dente";
var Core_NoResults = "Aucun r\xe9sultat \xe0 afficher.";
var Core_NoResultsFor = "Aucun r\xe9sultat pour \xab\xa0{{searchTerm}}\xa0\xbb";
var Core_NoResultsFound = "Aucun r\xe9sultat trouv\xe9.";
var Core_NoResultsMatch = "Aucun r\xe9sultat";
var Core_Normal = "Normal";
var Core_NotAvailable = "Non disponible";
var Core_NotAvailableForGroup = "Ce graphique n’est pas disponible pour les donn\xe9es de groupe.";
var Core_NotDislikedAllyText = "Not disliked {{type}} {{name}}";
var Core_NotFound_DescriptionText = "Vous n’\xeates peut-\xeatre pas autoris\xe9 \xe0 voir cet \xe9l\xe9ment, ou celui-ci n’existe pas.";
var Core_NotFound_HeaderText = "Il n’y a rien \xe0 voir ici";
var Core_NoThanks = "Non, merci.";
var Core_NotSelected = "Non s\xe9lectionn\xe9e";
var Core_NotSpecified = "Non sp\xe9cifi\xe9";
var Core_Okay = "OK";
var Core_Older = "Plus ancien";
var Core_Oldest = "Plus ancien";
var Core_OnDate = "Le {{ date }}";
var Core_OneToThreeMonths = "1 \xe0 3\xa0mois";
var Core_Online = "En ligne";
var Core_Open = "Ouvrir";
var Core_OpenContent = "Ouvrir le contenu";
var Core_OpenDatePicker = "Ouvrir le s\xe9lecteur de date";
var Core_OpenedOnDate = "Ouvert(e) le {{ date }}";
var Core_OpenItem = "Open {{type}} {{name}}";
var Core_Operator_Contains = "Contient";
var Core_Operator_Empty = "Vide";
var Core_Operator_EndsWith = "Se termine par";
var Core_Operator_Exact = "Exact";
var Core_Operator_NotContains = "Ne contient pas";
var Core_Operator_StartsWith = "Commence par";
var Core_Opportunities = "Opportunit\xe9s";
var Core_OpportunitiesDesc = "D\xe9couvrez et postulez \xe0 des opportunit\xe9s de carri\xe8re qui correspondent \xe0 vos comp\xe9tences et \xe0 vos objectifs professionnels.";
var Core_Opportunity = "Opportunit\xe9";
var Core_Opportunity_Groups = "Visible par un groupe sp\xe9cifique";
var Core_Opportunity_JobRole = "Poste";
var Core_Opportunity_JobRole_Placeholder = "Saisissez un poste pour cette opportunit\xe9";
var Core_OpportunityType = "Type";
var Core_Optin = "S’abonner";
var Core_Optional = "Facultatif";
var Core_OptionalMessage_Request = "Ajouter un message facultatif \xe0 votre demande";
var Core_Options = "Options";
var Core_OptionsAvailableFormat = "{{count}} option(s) disponible(s)";
var Core_Optout = "Se d\xe9sabonner";
var Core_Or = "ou";
var Core_Org_Recommendation = "Recommandation de l’organisation";
var Core_Organization = "Organisation";
var Core_Organizations = "Organisations";
var Core_OrgManagedDocLinkLabel = "En savoir plus sur le contenu g\xe9r\xe9 par l’organisation.";
var Core_OrgManagedNotification = "Si vous ajoutez cet \xe9l\xe9ment, le {{resourceType}} s\xe9lectionn\xe9 deviendra g\xe9r\xe9 par l’organisation.";
var Core_OrgManagedNotificationPlural = "Si vous ajoutez ces \xe9l\xe9ments, le {{resourceType}} s\xe9lectionn\xe9 deviendra g\xe9r\xe9 par l’organisation.";
var Core_Other = "Autres";
var Core_OverrideChangesWarning = "Les modifications suivantes remplaceront les param\xe8tres de visibilit\xe9 pr\xe9c\xe9dents.";
var Core_Overview = "Vue d’ensemble";
var Core_OverYearAgo = "il y a plus d’un an";
var Core_Page = "Page";
var Core_Pages = "pages";
var Core_Paid = "Payant";
var Core_PasswordLocked = "Verrouill\xe9 par mot de passe";
var Core_PasswordMatchError = "Le nouveau mot de passe et sa confirmation sont diff\xe9rents";
var Core_PasswordPatternInfo = "Les mots de passe doivent comprendre au minimum 8\xa0caract\xe8res, dont un chiffre et une lettre";
var Core_PasswordRequirementsNotMet = "Les conditions du mot de passe n’ont pas \xe9t\xe9 remplies";
var Core_PasswordReset = "R\xe9initialisation du mot de passe";
var Core_Past = "Les derniers";
var Core_Pathway = "Parcours";
var Core_Pathways = "Parcours";
var Core_PathwaysDisplayName = "Parcours";
var Core_PDF = "PDF";
var Core_Pending = "En attente";
var Core_People = "Personnes";
var Core_Permissions = "Autorisations";
var Core_PersonalizedLearningEmptySkills = "Ajoutez des comp\xe9tences \xe0 votre profil pour recevoir des recommandations de formation personnalis\xe9es.";
var Core_PersonalizedLearningEmptySkillsWithSuggestion = "Ajoutez des comp\xe9tences \xe0 votre profil pour recevoir des recommandations de formation personnalis\xe9es. Nous vous sugg\xe9rons d’ajouter les comp\xe9tences suivantes\xa0:";
var Core_PersonalizedLearningEmptyState = "Aucune recommandation de formation personnalis\xe9e n’est disponible pour cette comp\xe9tence.";
var Core_Phone = "T\xe9l\xe9phone";
var Core_Plans = "Plans";
var Core_PlansAndRoles = "Plans";
var Core_Play = "Lire";
var Core_PleaseTryAgain = "Veuillez r\xe9essayer.";
var Core_PlusShowMore = "+ Afficher plus";
var Core_Podcast = "Podcast";
var Core_PodcastDisplayName = "Podcast";
var Core_PodcastEpisodeDisplayName = "\xc9pisode de podcast";
var Core_PodcastHelp = "Vous pouvez coller un lien vers un fichier audio ou une page Web, ou rechercher le nom d’une s\xe9rie de podcasts.";
var Core_PodcastNameUrl = "Nom ou URL du podcast";
var Core_Podcasts = "Podcasts";
var Core_PodcastsDisplayName = "Podcasts";
var Core_PodcastUrl = "URL du podcast";
var Core_Points = "Points";
var Core_Position = "Exp\xe9rience";
var Core_PositionsDisplayName = "Positions";
var Core_Post = "Publication";
var Core_PostsDisplayName = "Publications";
var Core_PoweredBy = "Par";
var Core_Preview = "Aper\xe7u";
var Core_Previous = "Pr\xe9c\xe9dent";
var Core_PreviousRating = "\xc9valuation pr\xe9c\xe9dente";
var Core_PriceRange = "Fourchette de prix";
var Core_Primary = "Principale";
var Core_Primary_Source = "Source principale";
var Core_PrimaryPlan = "Plan principal";
var Core_Print = "Imprimer";
var Core_PrivacyLevel0 = "Restreint aux collaborateurs";
var Core_PrivacyLevel1 = "Visible par l’organisation";
var Core_PrivacyLevel2 = "Visible par un groupe sp\xe9cifique";
var Core_PrivacyLevel2A = "Visible par {{groupCount}}\xa0groupe";
var Core_PrivacyLevel2B = "Visible par {{groupCount}}\xa0groupes";
var Core_PrivacyLevel2C = "Visible \xe0 {{groupName}}";
var Core_PrivacyLevel3 = "Visible sur les profils des collaborateurs";
var Core_Private = "Priv\xe9";
var Core_Proficient = "Comp\xe9tent";
var Core_ProgramLanguage = "Langage du programme";
var Core_ProgramType = "Type de programme";
var Core_ProgressBar_Tooltip = "{{ percent }} de {{ total }}";
var Core_ProgressSaved = "Avancement enregistr\xe9";
var Core_Provider = "Fournisseur";
var Core_Providers = "Fournisseurs";
var Core_Pts = "pt(s)";
var Core_Publish = "Publier";
var Core_PublishDate = "Date de publication";
var Core_Published = "Publi\xe9";
var Core_PublishedDaysAgoFormat = "Publi\xe9 il y a {{time}} jours";
var Core_PublishedHoursAgoFormat = "Publi\xe9 il y a {{time}} heures";
var Core_PublishedJustNowFormat = "Publi\xe9 maintenant";
var Core_PublishedMinutesAgoFormat = "Publi\xe9 il y a {{time}} minutes";
var Core_PublishedMonthsAgoFormat = "Publi\xe9 il y a {{time}} mois";
var Core_PublishedOnDateFormat = "le {{date}}";
var Core_PublishedOneHourAgoFormat = "Publi\xe9 il y a 1\xa0heure";
var Core_PublishedOneMonthAgoFormat = "Publi\xe9 il y a 1\xa0mois";
var Core_PublishedOneWeekAgoFormat = "Publi\xe9 il y a 1\xa0semaine";
var Core_PublishedWeeksAgoFormat = "Publi\xe9 il y a {{time}} semaines";
var Core_PublishedXTimeAgoFormat = "Publi\xe9(e) {{ elapsedTime }}";
var Core_PublishedYesterdayFormat = "Publi\xe9 hier";
var Core_Quarter = "trimestre";
var Core_Question = "Question";
var Core_Question_and_Answer = "Question et r\xe9ponse";
var Core_Questions = "Questions";
var Core_Rate = "\xc9valuer";
var Core_RateYourself = "\xc9valuez-vous";
var Core_RateYourselfInSkill = "\xc9valuez votre comp\xe9tence \xab\xa0{{skillTitle}}\xa0\xbb";
var Core_Rating = "\xc9valuations";
var Core_Ratings = "\xc9valuations";
var Core_RatingType = "Type d’\xe9valuation";
var Core_Read = "Lire";
var Core_ReadMore = "En savoir plus";
var Core_RecentActivitySuggestion = "Compte tenu de votre activit\xe9 r\xe9cente dans Degreed, nous vous sugg\xe9rons d’ajouter les comp\xe9tences suivantes \xe0 votre profil\xa0:";
var Core_RecentStart = "R\xe9cemment commenc\xe9";
var Core_Recommend = "Partager";
var Core_Recommendation = "Partager";
var Core_RecommendationDisplayName = "Partage";
var Core_RecommendationsDisplayName = "Partages";
var Core_Recommended = "Recommand\xe9";
var Core_RecommendedFocusSkills = "Comp\xe9tences prioritaires recommand\xe9es";
var Core_RecommendedSkills = "Comp\xe9tences recommand\xe9es";
var Core_RefreshPage = "Actualiser la page";
var Core_Register = "S’inscrire";
var Core_Registered = "Inscrit(e)";
var Core_RelatedSkillTooltip = "Comp\xe9tence associ\xe9e\xa0: {{skillName}}";
var Core_Remove = "Supprimer";
var Core_RemoveAssignment = "Supprimer la formation assign\xe9e";
var Core_RemoveAssignmentDescription = "Voulez-vous vraiment supprimer cette formation assign\xe9e\xa0? Elle ne vous sera plus assign\xe9e.";
var Core_Removed = "supprim\xe9";
var Core_RemoveEndorsement = "Supprimer la recommandation";
var Core_RemoveEndorsementConfirmation = "Si vous supprimez la recommandation, ce contenu ne sera plus mis en avant dans les r\xe9sultats de recherche et l’ic\xf4ne dispara\xeetra. Voulez-vous vraiment supprimer la recommandation\xa0?";
var Core_RemoveFacetFormat = "Supprimer {{facetName}}";
var Core_RemoveFromAssignedModalText = "Vous \xeates sur le point de supprimer \xab\xa0{{title}}\xa0\xbb de votre section Formations assign\xe9es.";
var Core_RemoveFromContinueLearningModalText = "Vous \xeates sur le point de supprimer \xab\xa0{{title}}\xa0\xbb de votre section Continuer de me former.";
var Core_RemoveFromInProgressModalText = "Vous \xeates sur le point de supprimer \xab\xa0{{title}}\xa0\xbb de votre section En cours.";
var Core_RemoveFromPersonalizedLearningModalText = "Vous \xeates sur le point de supprimer \xab\xa0{{title}}\xa0\xbb de votre section Formations personnalis\xe9es.";
var Core_RemoveFromTrendingLearningModalText = "Vous \xeates sur le point de supprimer \xab\xa0{{title}}\xa0\xbb de votre section Tendances.";
var Core_RemoveImage = "Supprimer l’image";
var Core_RemoveItem = "Supprimer l’\xe9l\xe9ment";
var Core_RemoveSkill = "Supprimer la comp\xe9tence";
var Core_RemoveSuccess = "Suppression effectu\xe9e!";
var Core_Replace = "Remplacer";
var Core_ReplaceFile = "Remplacer le fichier";
var Core_Reply = "R\xe9pondre";
var Core_ReportAProblem = "Signaler un probl\xe8me";
var Core_Required = "Obligatoire";
var Core_ReRateSkill = "Mettre \xe0 jour l’\xe9valuation";
var Core_Reset = "R\xe9initialiser";
var Core_ResetDefault = "R\xe9tablir les valeurs par d\xe9faut";
var Core_ResetFilters = "R\xe9initialiser les filtres";
var Core_ResetFiltersWithCount = "R\xe9initialiser les filtres ({{count}})";
var Core_Results = "R\xe9sultats";
var Core_ResultsFoundFormat = "{{count}} r\xe9sultats trouv\xe9s";
var Core_Retry = "R\xe9essayer";
var Core_Revert = "R\xe9tablir";
var Core_Review = "\xc9valuer";
var Core_Role = "Poste";
var Core_RoleAdmin = "Administrateur";
var Core_RoleAdminsCan = "Les administrateurs peuvent\xa0:";
var Core_RoleCareerProfessional = "Sp\xe9cialiste Carri\xe8res";
var Core_RoleCareerProfessionalsCan = "Les sp\xe9cialistes Carri\xe8res peuvent\xa0:";
var Core_RoleLearningProfessional = "Sp\xe9cialiste Learning";
var Core_RoleLearningProfessionalsCan = "Les sp\xe9cialistes Learning peuvent\xa0:";
var Core_RoleManager = "Manager";
var Core_RoleManagersCan = "Les managers peuvent\xa0:";
var Core_RoleMember = "Membre";
var Core_RoleMembersCan = "Les membres peuvent\xa0:";
var Core_RolePlan = "Plan d’\xe9volution de poste";
var Core_RoleTechnicalAdmin = "Administrateur technique";
var Core_RoleTechnicalAdminsCan = "Les administrateurs techniques peuvent\xa0:";
var Core_Save = "Enregistrer";
var Core_SaveAudio = "Enregistrer le podcast";
var Core_SaveChanges = "Enregistrer les modifications";
var Core_Saved = "Contenus enregistr\xe9s";
var Core_SaveForLater = "Enregistrer";
var Core_SaveItemforLater = "Save {{type}} - {{name}} for later";
var Core_SaveNext = "Enregistrer et continuer";
var Core_SaveRating = "Enregistrer l’\xe9valuation";
var Core_SaveSkillTarget = "Enregistrer la cible de comp\xe9tence";
var Core_Saving = "Enregistrement";
var Core_ScrollLimit = "D\xe9filement limit\xe9 \xe0 250\xa0r\xe9sultats. Faites une recherche dans le menu d\xe9roulant pour plus de r\xe9sultats.";
var Core_ScrollLimited = "D\xe9filement limit\xe9 \xe0 250\xa0r\xe9sultats. Consultez les rapports pour en voir plus.";
var Core_Search = "Rechercher";
var Core_SearchCatalog = "Rechercher Catalogue";
var Core_SearchCollection = "Rechercher dans la collection";
var Core_SearchFilterA11yLabel = "La s\xe9lection d’une entr\xe9e met \xe0 jour le contenu principal";
var Core_SearchForPathway = "Rechercher un parcours";
var Core_SearchForPerson = "Rechercher une personne...";
var Core_SearchTerms = "Termes de recherche";
var Core_Second = "seconde";
var Core_Secondary = "Secondaire";
var Core_Seconds = "secondes";
var Core_SecondsAgoFormat = "il y a {{time}}\xa0secondes";
var Core_SecondsAgoFormat_Minimal = "{{time}}\xa0s";
var Core_SeeSkillCollection = "Afficher le catalogue de comp\xe9tences";
var Core_Segments = "Segments";
var Core_Select = "S\xe9lectionner";
var Core_SelectAllInTable = "S\xe9lectionner toutes les lignes du tableau";
var Core_SelectDate = "S\xe9lectionner une date";
var Core_SelectEndDate = "S\xe9lectionner une date de fin";
var Core_SelectItem = "S\xe9lectionner {{item}}";
var Core_SelectSelfRating = "S\xe9lectionner une auto-\xe9valuation";
var Core_SelectSkillTarget = "S\xe9lectionner une cible de comp\xe9tence";
var Core_SelectStartDate = "S\xe9lectionner une date de d\xe9but";
var Core_SelfRating = "Auto-\xe9valuation";
var Core_Send = "Envoyer";
var Core_SendEmail = "Envoyer un e-mail";
var Core_Sending = "Envoi";
var Core_SendRequest = "Envoyer la demande";
var Core_Series = "S\xe9rie";
var Core_SessionDateRange = "Dates de la session";
var Core_SessionLocation = "Lieu de la session";
var Core_Sessions = "Sessions";
var Core_SessionType = "Type de session";
var Core_SetAsGoal = "D\xe9finir comme objectif";
var Core_SetGoal = "D\xe9finir un objectif";
var Core_SetSkillTarget = "D\xe9finir une cible de comp\xe9tence";
var Core_Settings = "Param\xe8tres";
var Core_SettingsSaved = "Les param\xe8tres ont bien \xe9t\xe9 enregistr\xe9s.";
var Core_Share = "Partager";
var Core_Shared = "Contenus partag\xe9s";
var Core_SharedBy = "Partag\xe9 par";
var Core_SharedContent = "Contenu partag\xe9";
var Core_ShareItem = "Partager {{name}}";
var Core_ShareOn = "Partager sur";
var Core_Show = "Afficher";
var Core_ShowAll = "Tout afficher";
var Core_ShowAllAria = "Contexte pour le bouton Afficher tout\xa0: {{context}}";
var Core_ShowCompleted = "Afficher les \xe9l\xe9ments termin\xe9s";
var Core_ShowFilters = "Afficher les filtres";
var Core_ShowLess = "Afficher moins";
var Core_ShowLessAria = "Contexte pour le bouton Afficher moins\xa0: {{context}}";
var Core_ShowMore = "Afficher plus";
var Core_ShowResults = "Afficher les r\xe9sultats";
var Core_SignalCount = "1\xa0signal";
var Core_SignalsCount = "{{count}}\xa0signaux";
var Core_Skill = "Comp\xe9tence";
var Core_Skill_Source_Acknowledge_Changes_Content = "Les comp\xe9tences issues de {{Source_Name}} seront utilis\xe9es par d\xe9faut pour l’orthographe, les descriptions et les \xe9tiquettes des comp\xe9tences existantes dans votre inventaire de comp\xe9tences. Les comp\xe9tences de la source de comp\xe9tences principale actuelle seront archiv\xe9es et les comp\xe9tences issues de l’int\xe9gration principale n’alimenteront plus votre inventaire.";
var Core_SkillCoach = "Skill Coach";
var Core_SkillCount = "1\xa0comp\xe9tence";
var Core_SkillDisplayName = "Comp\xe9tence comportementale";
var Core_SkillPlan = "Plan";
var Core_SkillPlansDisplayName = "Plans";
var Core_SkillRating = "\xc9valuation de la comp\xe9tence";
var Core_Skills = "Comp\xe9tences";
var Core_SkillsAndTopics = "Comp\xe9tences";
var Core_SkillScaleChanged = "L’\xe9chelle de ma\xeetrise des comp\xe9tences de {{ orgName }} a \xe9t\xe9 modifi\xe9e";
var Core_SkillsCount = "{{count}}\xa0comp\xe9tences";
var Core_SkillsDisplayName = "Comportements li\xe9s \xe0 la comp\xe9tence";
var Core_SkillTarget = "Cible de la comp\xe9tence";
var Core_SkillTargetDescription = "D\xe9finissez une cible pour cette comp\xe9tence afin d’en suivre la progression, d’identifier les d\xe9ficits de comp\xe9tences et les aptitudes, et d’am\xe9liorer les recommandations dans Degreed.";
var Core_SkillTargetLevel = "Niveau de la cible de comp\xe9tence";
var Core_Skip = "Ignorer";
var Core_SlowWarn = "Les modifications des donn\xe9es de ce tableau peuvent ne pas s’afficher imm\xe9diatement.";
var Core_SorryExclamation = "Oups\xa0!";
var Core_Sort = "Trier";
var Core_SortBy = "Trier par";
var Core_Source = "Source";
var Core_Sources = "Sources";
var Core_SpecificDates = "Dates pr\xe9cises";
var Core_SponsoredBy = "Sponsoris\xe9 par {{sponsorName}}";
var Core_Stage = "\xc9tape";
var Core_Start = "D\xe9marrer";
var Core_StartDate = "Date de d\xe9but";
var Core_Started = "D\xe9marr\xe9";
var Core_StartTracking = "Commencer \xe0 suivre";
var Core_Status = "Statut";
var Core_Submit = "Soumettre";
var Core_SubmitContinue = "Soumettre et continuer";
var Core_Submitting = "Soumission";
var Core_Subscription = "Abonnement";
var Core_Subtitle = "Sous-titre";
var Core_Success = "Envoi r\xe9ussi";
var Core_SuccessChangesPublished = "Vos modifications ont bien \xe9t\xe9 publi\xe9es.";
var Core_SuccessfullyVerified = "Validation effectu\xe9e";
var Core_Suggestions = "Suggestions";
var Core_Summary = "Synth\xe8se";
var Core_Support = "Assistance";
var Core_Tag = "Comp\xe9tence";
var Core_TagCredential = "Certification de comp\xe9tence";
var Core_TagEvaluation = "Revue de comp\xe9tence";
var Core_Tags = "Comp\xe9tences";
var Core_TagsDisplayName = "Comp\xe9tences";
var Core_TagSelf = "Auto-\xe9valuation";
var Core_Target = "Plan";
var Core_Targets = "Plans";
var Core_TargetsDisplayName = "Plans";
var Core_TargetTypeNotDefined = "Non d\xe9fini";
var Core_Task = "T\xe2che";
var Core_Tasks = "T\xe2ches";
var Core_TasksDisplayName = "T\xe2ches";
var Core_Team = "Skill Coach";
var Core_Text = "Texte";
var Core_ThisMonth = "ce mois";
var Core_ThisMonth_Minimal = "1\xa0mois";
var Core_ThisYear = "cette ann\xe9e";
var Core_ThisYear_Minimal = "1\xa0an";
var Core_ThreeToNineMonths = "3 \xe0 9\xa0mois";
var Core_TinyMCEAriaHelpText = "Appuyez sur ALT-0 pour acc\xe9der aux descriptions d’aide de l’\xe9diteur.";
var Core_Title = "Titre";
var Core_TitleLength = "Le titre ne doit pas d\xe9passer 255\xa0caract\xe8res.";
var Core_TitleRequired = "L’intitul\xe9 doit \xeatre renseign\xe9.";
var Core_To = "\xc0\xa0";
var Core_ToBeCompleted = "\xc0 terminer";
var Core_Today = "Aujourd’hui";
var Core_Today_Minimal = "1\xa0j";
var Core_ToDo = "\xc0 faire";
var Core_ToggleExactMatches = "Bouton pour activer les correspondances exactes";
var Core_Top = "Principales";
var Core_Topics = "Comp\xe9tences";
var Core_TotalMembers = "{{count}} membres";
var Core_Translations = "Traductions";
var Core_True = "Vrai";
var Core_TwoToFourWeeks = "2 \xe0 4\xa0semaines";
var Core_Type = "Type";
var Core_UnableToEnrollFormat = "Impossible de s’inscrire \xe0 {{type}}";
var Core_UncompletedFormat = "A marqu\xe9 {{resourceType}} comme non effectu\xe9";
var Core_Undergraduate = "Premier cycle";
var Core_UndislikeAllyText = "Retirer la mention Je n’aime pas de {{type}} {{name}}";
var Core_UnfeatureResource = "Supprimer de la page \xc0 la une";
var Core_UnFollow = "Ne plus suivre";
var Core_Units = "Units";
var Core_Unknown = "Non pr\xe9cis\xe9";
var Core_Unlike = "Je n’aime plus";
var Core_UnlikeAllyText = "Je n’aime plus {{type}} {{name}}";
var Core_Unpublish = "D\xe9publier";
var Core_UnpublishedChanges = "Unpublished Changes";
var Core_Unsave = "Annuler l’enregistrement";
var Core_UnsaveItem = "Unsave {{type}} {{name}}";
var Core_UnselectAll = "Tout d\xe9s\xe9lectionner";
var Core_Update = "Mettre \xe0 jour";
var Core_Updated = "a mis \xe0 jour";
var Core_Upload = "Charger";
var Core_UploadCategories = "Upload Categories";
var Core_Uploaded = "Charg\xe9";
var Core_UploadedFilesForSource = "Fichiers charg\xe9s pour cette source";
var Core_UploadNew = "T\xe9l\xe9charger Nouveau";
var Core_UploadTranslations = "Charger des traductions";
var Core_Url = "URL";
var Core_UrlRequired = "Une URL valide est requise";
var Core_Usd = "USD";
var Core_UsedIn = "Utilis\xe9 dans";
var Core_User = "Personne";
var Core_UserActivityInformation = "Si cela vous semble suspect, veuillez contacter le responsable de la s\xe9curit\xe9 des donn\xe9es.";
var Core_Users = "Utilisateurs";
var Core_UsersDisplayName = "Personnes";
var Core_UTCDatesNote = "Toutes les dates sont exprim\xe9es en UTC";
var Core_Valid_No_WhiteSpace = "Ce champ ne peut contenir d’espaces ni au d\xe9but ni \xe0 la fin, et il ne doit pas \xeatre compos\xe9 uniquement d’espaces.";
var Core_ValidUrl = "Veuillez utiliser une URL valide et compl\xe8te.";
var Core_Verify = "V\xe9rifier";
var Core_Video = "Vid\xe9o";
var Core_Videos = "Vid\xe9os";
var Core_VideosDisplayName = "Vid\xe9os";
var Core_View = "Afficher";
var Core_ViewAll = "Tout afficher";
var Core_ViewConversation = "Afficher la conversation";
var Core_ViewDescription = "Afficher la description";
var Core_ViewDetails = "Afficher les d\xe9tails";
var Core_Viewed = "Vu";
var Core_ViewInCollection = "Afficher dans la collection";
var Core_ViewInGoals = "Afficher dans les objectifs";
var Core_ViewInstructions = "Voir les instructions";
var Core_ViewPathway = "Afficher";
var Core_ViewProfile = "Afficher le profil";
var Core_Views = "Vues";
var Core_ViewSavedItems = "Afficher les \xe9l\xe9ments enregistr\xe9s";
var Core_ViewSkills = "Voir les comp\xe9tences";
var Core_VirtualClassroom = "Classe virtuelle";
var Core_VisibilityCollaborators = "Collaborateurs";
var Core_VisibilityDocLinkLabel = "En savoir plus sur les param\xe8tres de visibilit\xe9 dans Degreed";
var Core_VisibilityGroup = "Groupe";
var Core_VisibilityGroups = "Groupes";
var Core_VisibilityOrganization = "Organisation";
var Core_VisibilityProfile = "Profil public";
var Core_VisibilityPublic = "Organisation";
var Core_VisitProvider = "Voir";
var Core_VisitUrl = "Voir l’URL";
var Core_VisitWebsite = "Visiter le site {{name}}";
var Core_Warning = "Avertissement";
var Core_Watch = "Regarder";
var Core_Week = "semaine";
var Core_Weeks = "semaines";
var Core_WeeksAgoFormat = "il y a {{time}}\xa0semaines";
var Core_WhatDidYouLearnAudioLong = "Qu’avez-vous appris gr\xe2ce \xe0 ce podcast \xa0?";
var Core_Withdraw = "Quitter";
var Core_withPublished = "Publi\xe9";
var Core_Word = "Mot";
var Core_WordLimitExceeded = "Nombre limite de mots d\xe9pass\xe9.";
var Core_Words = "Mots";
var Core_WordsRemainingFormat = "Mots restants\xa0: {{count}}";
var Core_Workshop = "Atelier";
var Core_WouldYouLikeToProceed = "Souhaitez-vous continuer\xa0?";
var Core_Year = "ann\xe9e";
var Core_YearAgoFormat = "il y a {{time}}\xa0an";
var Core_YearsAgoFormat = "il y a {{time}}\xa0ans";
var Core_YearsAgoFormat_Minimal = "{{time}}\xa0an";
var Core_Yes = "Oui";
var Core_YesContinue = "Oui, continuer";
var Core_YesProceed = "Oui, continuer";
var Core_YesSure = "Oui";
var Core_Yesterday = "Hier";
var Core_Yesterday_Minimal = "2\xa0j";
var Core_YourFocusSkills = "Vos comp\xe9tences prioritaires";
var Core_ZeroSignalsCount = "0\xa0signal";
var Core_ZeroSkills = "Comp\xe9tences";
var Core_ZeroSkillsCount = "0\xa0comp\xe9tence";
var Core_ZoomIn = "Zoom avant";
var Core_ZoomOut = "Zoom arri\xe8re";
var Core_Ztoa = "Z \xe0 A";
var CourseFormCtrl_Accredited = "D’un organisme agr\xe9\xe9";
var CourseFormCtrl_AddCourse = "Ajouter un cours";
var CourseFormCtrl_AddToCatalogFormat = "Ajoutez ce cours au catalogue {{orgName}}";
var CourseFormCtrl_Category = "Veuillez ajouter au moins une cat\xe9gorie.";
var CourseFormCtrl_CommentPlaceholder = "D\xe9crire le contenu du cours";
var CourseFormCtrl_Country = "Pays";
var CourseFormCtrl_CountryPlaceholder = "Rechercher un pays";
var CourseFormCtrl_CourseFromScormFile = "\xc0 partir d’un fichier\xa0SCORM";
var CourseFormCtrl_CourseFromScormFile_MetadataMissingMessage = "Les m\xe9tadonn\xe9es de ce fichier SCORM ne sont pas stock\xe9es dans notre syst\xe8me. Rassurez-vous, le cours s’affichera correctement. Vous pouvez charger un nouveau fichier SCORM pour voir le nom du fichier.";
var CourseFormCtrl_CourseGrade = "Note du cours";
var CourseFormCtrl_CourseGradePlaceholder = "S\xe9lectionner la note obtenue";
var CourseFormCtrl_CourseLevel = "Niveau du cours";
var CourseFormCtrl_CourseLevelPlaceholder = "S\xe9lectionner le niveau du cours";
var CourseFormCtrl_CourseNumber = "Num\xe9ro du cours";
var CourseFormCtrl_CourseNumberPlaceholder = "Saisir le num\xe9ro du cours";
var CourseFormCtrl_CourseTitle = "Intitul\xe9 du cours";
var CourseFormCtrl_CourseUrl = "URL du cours";
var CourseFormCtrl_CourseUrlAria = "\xc0 partir de l’URL d’un cours";
var CourseFormCtrl_CreditHours = "Heures de cr\xe9dit";
var CourseFormCtrl_CreditHoursPlaceholder = "Saisir les heures de cr\xe9dit";
var CourseFormCtrl_DateCompleted = "Date d’ex\xe9cution";
var CourseFormCtrl_DateCompletedPlaceholder = "S\xe9lectionner une date";
var CourseFormCtrl_DateTaught = "Date d’enseignement";
var CourseFormCtrl_EditCourse = "Modifier le cours";
var CourseFormCtrl_FirstYearLevel = "Premi\xe8re ann\xe9e";
var CourseFormCtrl_FourthYearLevel = "Quatri\xe8me ann\xe9e";
var CourseFormCtrl_GraduateLevel = "Cycle sup\xe9rieur";
var CourseFormCtrl_HowAdded = "Comment voulez-vous ajouter ce cours\xa0?";
var CourseFormCtrl_Informal = "D’un prestataire de formation informel";
var CourseFormCtrl_ITaughtCourse = "J’ai dispens\xe9 ce cours";
var CourseFormCtrl_Provider = "\xc0 partir d’un fournisseur de cours";
var CourseFormCtrl_Provider_Placeholder = "Recherchez le nom du fournisseur";
var CourseFormCtrl_ProviderName = "Nom du prestataire";
var CourseFormCtrl_SaveCourse = "Enregistrer le cours";
var CourseFormCtrl_SchoolName = "Nom de l’\xe9tablissement scolaire";
var CourseFormCtrl_SchoolPlaceholder = "Rechercher un \xe9tablissement d’enseignement";
var CourseFormCtrl_SecondYearLevel = "Deuxi\xe8me ann\xe9e";
var CourseFormCtrl_SelectCourse = "Saisissez ou s\xe9lectionnez le nom d’un cours.";
var CourseFormCtrl_SelectProvider = "S\xe9lectionnez un prestataire de formation.";
var CourseFormCtrl_Summary = "R\xe9sum\xe9";
var CourseFormCtrl_ThirdYearLevel = "Troisi\xe8me ann\xe9e";
var CourseFormCtrl_TitlePlaceholder = "Saisir l’intitul\xe9 du cours";
var CourseFormCtrl_UnitType = "S\xe9lectionnez un type d’unit\xe9.";
var CourseFormCtrl_UrlError = "Cette URL n’est pas accessible publiquement et ne peut donc pas \xeatre ajout\xe9e \xe0 votre biblioth\xe8que publique.";
var CourseFormCtrl_UrlOrScormRequired = "Saisir l’URL du cours ou d’un package SCORM. ";
var CourseFormCtrl_UrlOrSelectionRequired = "Saisir l’URL du cours ou d’une s\xe9lection.";
var CourseFormCtrl_US = "\xc9tats-Unis";
var CourseFormCtrl_ValidNumber = "Veuillez indiquer un nombre valide.";
var CourseFormCtrl_ValidScormRequired = "Un package SCORM valide est requis.";
var CourseFormCtrl_VerificationUrl = "URL de v\xe9rification";
var CourseFormCtrl_WhatDidYouLearnLong = "Qu’avez-vous appris gr\xe2ce \xe0 ce cours \xa0?";
var CourseFormCtrl_WhatDidYouLearnShort = "Qu’avez-vous appris \xa0?";
var CourseFormCtrl_WhereTaken = "D’o\xf9 provient ce cours \xa0?";
var CoursesSvc_CoursesError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la recherche des formations correspondant \xe0 votre saisie.";
var CoursesSvc_ProviderError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la recherche des prestataires correspondant \xe0 votre saisie.";
var Cred_Application_Cancel = "Annuler la demande li\xe9e \xe0 la comp\xe9tence";
var Cred_Application_Stay = "Poursuivre la demande";
var Cred_ApplicationStep_AcceptHonorCode = "Accepter le code d’honneur";
var Cred_ApplicationStep_AcceptHonorCodeInstruction = "Lisez et acceptez le code d’honneur de Degreed.";
var Cred_ApplicationStep_ComparePeers = "Remplir la section des comparaisons de pairs";
var Cred_ApplicationStep_ComparePeersInstruction = "Finissez de comparer vos pairs.";
var Cred_ApplicationStep_CompleteBehaviors = "Remplir la section des comportements";
var Cred_ApplicationStep_CompleteBehaviorsInstruction = "D\xe9crivez les fa\xe7ons dont vous utilisez cette comp\xe9tence.";
var Cred_ApplicationStep_CompleteEndorsers = "Remplir la section des approbateurs";
var Cred_ApplicationStep_CompleteEndorsersInstruction = "Ajoutez des personnes qui connaissent votre comp\xe9tence.";
var Cred_ApplicationStep_ConfirmUser = "V\xe9rifier les coordonn\xe9es";
var Cred_ApplicationStep_ConfirmUserInstruction = "Assurez-vous que vos coordonn\xe9es sont exactes.";
var Cred_ApplicationStep_Pay = "Proc\xe9der au paiement";
var Cred_ApplicationStep_PayInstruction = "Saisissez votre num\xe9ro de carte bancaire ou votre code de bourse.";
var Cred_ApplicationStep_Results = "Afficher les r\xe9sultats";
var Cred_ApplicationStep_ResultsInstruction = "V\xe9rifiez votre niveau de comp\xe9tence\xa0!";
var Cred_ApplicationStep_Review = "Examiner les d\xe9tails de la demande";
var Cred_ApplicationStep_ReviewInstruction = "V\xe9rifiez une derni\xe8re fois votre demande.";
var Cred_ApplicationStep_Submit = "Soumettre la demande";
var Cred_ApplicationStep_SubmitInstruction = "Rejoignez le groupe de certification de ce mois-ci.";
var Cred_ApplicationStep_Unknown = "Inconnu";
var Cred_ApplicationStep_WaitForCohort = "Attendre la date limite de soumission";
var Cred_ApplicationStep_WaitForCohortInstruction = "D’autres candidats sont en train de finaliser leur demande.";
var Cred_ApplicationStep_WaitForReviews = "Attendre les \xe9valuations";
var Cred_ApplicationStep_WaitForReviewsInstruction = "D’autres candidats sont en train de finaliser l’\xe9valuation de leurs pairs.";
var Cred_BehaviorDisplay_DetailTitle = "D\xe9tails de la comp\xe9tence";
var Cred_BehaviorDisplay_TitleTitle = "Comp\xe9tence comportementale";
var Cred_BehaviorReview_Accuracy = "Dans quelle mesure la description fournie par {{endorsedName}} sur son comportement li\xe9 \xe0 la comp\xe9tence est-elle exacte\xa0?";
var Cred_BehaviorReview_Accuracy_High = "Exacte";
var Cred_BehaviorReview_Accuracy_Low = "Inexacte";
var Cred_BehaviorReview_AreYouQualified = "Pensez-vous pouvoir r\xe9pondre \xe0 la question suivante portant sur le comportement li\xe9 \xe0 la comp\xe9tence de {{endorsedName}}\xa0?";
var Cred_Behaviors_DemoHeader = "Exemples de comportements li\xe9s \xe0 la comp\xe9tence";
var Cred_Certificate_CertificateTitle = "Intitul\xe9 du certificat";
var Cred_Certificate_CertifiedOn = "Certifi\xe9 le";
var Cred_Certificate_ChiefLearningOfficer = "Directeur de l’apprentissage";
var Cred_Certificate_Congratulations = "F\xe9licitations\xa0! Vous avez obtenu une certification de comp\xe9tence Degreed.";
var Cred_Certificate_DateIssued = "Date d’obtention";
var Cred_Certificate_DegreedCertifiesAria = "Degreed certifie avoir attribu\xe9 \xe0 {0} le niveau\xa0{1} sur 8 dans le domaine \xab\xa0{2}\xa0\xbb.";
var Cred_Certificate_DegreedCertifiesThat = "Degreed certifie que";
var Cred_Certificate_Details = "D\xe9tails du {{certificate}}";
var Cred_Certificate_Download = "T\xe9l\xe9charger le certificat";
var Cred_Certificate_DownloadWillBegin = "Votre t\xe9l\xe9chargement va bient\xf4t commencer";
var Cred_Certificate_EndorsedBy = "Approuv\xe9 par";
var Cred_Certificate_Endorsers = "Approuv\xe9 par\xa0: {0}";
var Cred_Certificate_ExecutiveChairman = "Pr\xe9sident ex\xe9cutif";
var Cred_Certificate_In = "dans";
var Cred_Certificate_Is = "est";
var Cred_Certificate_Issuer = "\xc9metteur";
var Cred_Certificate_IssuerUrl = "URL de l’\xe9metteur";
var Cred_Certificate_Level = "NIVEAU";
var Cred_Certificate_LevelOutOfLevel = "{{min}} sur {{max}}";
var Cred_Certificate_LinkedInAuthority = "Dans le champ Organisation \xe9mettrice, saisissez \xab\xa0Degreed\xa0\xbb.";
var Cred_Certificate_LinkedInDate = "Ce certificat n’expire pas. Dans le champ Date d’\xe9mission, saisissez \xab\xa0{{date}}\xa0\xbb.";
var Cred_Certificate_LinkedInGo = "Rendez-vous dans votre profil LinkedIn et ajoutez une {{startAnchor}}certification{{endAnchor}}.";
var Cred_Certificate_LinkedInLicense = "Dans le champ ID de la qualification, saisissez \xab\xa0{{code}}\xa0\xbb.";
var Cred_Certificate_LinkedInName = "Dans le champ Nom de la certification, saisissez \xab\xa0Niveau Degreed\xa0{{level}} en {{name}}\xa0\xbb.";
var Cred_Certificate_LinkedInTitle = "Passer \xe0 votre profil LinkedIn et ajouter une certification.";
var Cred_Certificate_LinkedInUrl = "Dans le champ URL de la qualification, saisissez \xab\xa0{{url}}\xa0\xbb.";
var Cred_Certificate_Name = "Niveau Degreed {{level}} pour {{name}}";
var Cred_Certificate_NameLabel = "Nom";
var Cred_Certificate_RemovedRevoked = "Ce certificat a \xe9t\xe9 supprim\xe9 ou r\xe9voqu\xe9.";
var Cred_Certificate_ResumeDate = "Date d’obtention\xa0: {{date}}";
var Cred_Certificate_ResumeName = "Certification de comp\xe9tence Degreed, niveau\xa0{{level}}, {{name}}";
var Cred_Certificate_ResumeTitle = "Actualisez votre CV en ajoutant votre certification de comp\xe9tence Degreed, g\xe9n\xe9ralement dans la section <em>Comp\xe9tences</em> ou <em>Exp\xe9rience</em>. Utilisez la formulation suivante\xa0:";
var Cred_Certificate_SealAlt = "Cachet du certificat Degreed";
var Cred_Certificate_SignaturesAlt = "Sign\xe9 par\xa0: David Blake, pr\xe9sident de Degreed, et Kelly Palmer, CLO de Degreed";
var Cred_Certificate_SkillCertificate = "Certificat de comp\xe9tence";
var Cred_Certificate_SkillCertification = "Certification de comp\xe9tence";
var Cred_Certificate_SocialEmailBodyFormat = "Degreed propose une nouvelle fa\xe7on de certifier vos comp\xe9tences, quelle que soit la mani\xe8re dont vous les avez acquises. J’ai obtenu une certification dans le domaine \xab\xa0{0}\xa0\xbb. Pour en savoir, cliquez ici\xa0: {1}";
var Cred_Certificate_SocialEmailSubjectFormat = "Certification de comp\xe9tence Degreed";
var Cred_Certificate_SocialPostSummaryFormat = "Il est temps de faire en sorte que toutes les comp\xe9tences soient reconnues \xe0 leur juste valeur. J’ai moi-m\xeame obtenu une certification de niveau\xa0{1} dans le domaine \xab\xa0{0}\xa0\xbb.";
var Cred_Certificate_SocialPostTitleFormat = "Certification de comp\xe9tence Degreed";
var Cred_Certificate_TitleOf = "Intitul\xe9 du {{certificate}}";
var Cred_Certificate_Visibility = "Visibilit\xe9";
var Cred_Certificate_VisibilityLabel = "Afficher le certificat sur votre profil";
var Cred_Comparison_Next = "Comparaison suivante";
var Cred_ComparisonNav_Comparison1 = "1\xe8re comparaison";
var Cred_ComparisonNav_Comparison2 = "2e comparaison";
var Cred_ComparisonNav_Comparison3 = "3e comparaison";
var Cred_ComparisonNav_ComparisonFormat = "{{Number}} comparaison";
var Cred_ComparisonPending_BeginNext = "Commencer la comparaison suivante";
var Cred_ComparisonPending_DueDateFormat = "Date limite {{date}}";
var Cred_ComparisonPending_Heading = "Comparaisons en attente";
var Cred_ComparisonPending_NoPendingReviews = "Aucune autre demande \xe0 \xe9valuer";
var Cred_ComparisonPending_RemainingFormat = "Approx. {{count}} comparaisons restantes";
var Cred_ComparisonPending_ReviewsRemainingFormat = "Environ {{count}}\xa0\xe9valuations restantes";
var Cred_ConfirmSkipDialog_Body = "Si vous continuez avec le nombre actuel d’approbations re\xe7ues, nous n’attendrons pas que les autres approbations soient termin\xe9es pour vous d\xe9livrer votre certificat. Cela signifie que les autres approbateurs ne figureront peut-\xeatre pas sur votre certificat. Le fait d’avoir une ou deux approbations au lieu de trois n’aura pas d’incidence sur votre niveau.";
var Cred_ConfirmSkipDialog_Button = "Oui, continuer";
var Cred_ConfirmSkipDialog_DeclinedBody = "Si vous continuez avec les approbateurs actuels, votre certificat ne mentionnera que ces noms. Votre niveau ne sera toutefois pas affect\xe9.";
var Cred_ConfirmSkipDialog_Heading = "Voulez-vous continuer avec les approbateurs actuels\xa0?";
var Cred_CredVerifySvc_SubmitError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’envoi du retour.";
var Cred_EndorseExp_InstructionsFormat = "Les questions suivantes nous aideront \xe0 d\xe9terminer le niveau de ma\xeetrise de {{applicantName}} dans le domaine de comp\xe9tence \xab\xa0{{skillName}}\xa0\xbb. Veuillez s\xe9lectionner toutes les r\xe9ponses qui sont vraies. Si aucune des r\xe9ponses n’est vraie, ou si vous ne savez pas, vous avez la possibilit\xe9 de n’en s\xe9lectionner aucune. Vos r\xe9ponses ne seront pas communiqu\xe9es \xe0 {{applicantName}}.";
var Cred_EndorseExp_Q_Communication = "S\xe9lectionnez les r\xe9ponses vraies se rapportant \xe0 la <strong>capacit\xe9 de communication</strong> de {{applicantName}} dans le domaine \xab\xa0{{skillName}}\xa0\xbb. {{applicantName}}\xa0:";
var Cred_EndorseExp_Q_Communication_15 = "Communique efficacement au sujet de la comp\xe9tence \xab\xa0{{skillName}}\xa0\xbb";
var Cred_EndorseExp_Q_Communication_35 = "Communique correctement sur des sujets controvers\xe9s ou complexes en rapport avec la comp\xe9tence \xab\xa0{{skillName}}\xa0\xbb";
var Cred_EndorseExp_Q_Communication_55 = "Communique correctement sur des sujets complexes en rapport avec la comp\xe9tence \xab\xa0{{skillName}}\xa0\xbb aupr\xe8s de publics interdisciplinaires";
var Cred_EndorseExp_Q_Communication_75 = "Dirige des d\xe9bats d’experts portant sur de nouvelles id\xe9es dans le domaine de comp\xe9tence \xab\xa0{{skillName}}\xa0\xbb";
var Cred_EndorseExp_Q_Knowledge = "S\xe9lectionnez les r\xe9ponses vraies se rapportant aux <strong>connaissances</strong> de {{applicantName}} dans le domaine \xab\xa0{{skillName}}\xa0\xbb. {{applicantName}}\xa0:";
var Cred_EndorseExp_Q_Knowledge_15 = "D\xe9montre des connaissances de base dans le domaine de comp\xe9tence \xab\xa0{{skillName}}\xa0\xbb";
var Cred_EndorseExp_Q_Knowledge_35 = "D\xe9montre des connaissances th\xe9oriques ou techniques \xe9tendues dans le domaine de comp\xe9tence \xab\xa0{{skillName}}\xa0\xbb";
var Cred_EndorseExp_Q_Knowledge_55 = "D\xe9montre une compr\xe9hension approfondie des techniques innovantes et des th\xe9ories ou m\xe9thodes essentielles pour r\xe9soudre des probl\xe8mes complexes dans le domaine de comp\xe9tence \xab\xa0{{skillName}}\xa0\xbb";
var Cred_EndorseExp_Q_Knowledge_75 = "Contribue \xe0 l’innovation ou au d\xe9veloppement des connaissances dans le domaine de comp\xe9tence \xab\xa0{{skillName}}\xa0\xbb";
var Cred_EndorseExp_Q_Planning = "S\xe9lectionnez les r\xe9ponses vraies se rapportant \xe0 la <strong>capacit\xe9 de planification et d’\xe9valuation</strong> de {{applicantName}} dans le domaine \xab\xa0{{skillName}}\xa0\xbb. {{applicantName}}\xa0:";
var Cred_EndorseExp_Q_Planning_15 = "\xc9value le travail dans le domaine de comp\xe9tence \xab\xa0{{skillName}}\xa0\xbb en se basant sur des crit\xe8res pr\xe9cis";
var Cred_EndorseExp_Q_Planning_35 = "\xc9labore des strat\xe9gies ou des processus appropri\xe9s dans le domaine de comp\xe9tence \xab\xa0{{skillName}}\xa0\xbb, et mesure leur efficacit\xe9";
var Cred_EndorseExp_Q_Planning_55 = "D\xe9veloppe et \xe9value de nouvelles solutions dans le domaine de comp\xe9tence \xab\xa0{{skillName}}\xa0\xbb et examine en profondeur les alternatives, y compris les incidences potentielles";
var Cred_EndorseExp_Q_Planning_75 = "Explore et \xe9value les limites de l’\xe9tat actuel du domaine de comp\xe9tence \xab\xa0{{skillName}}\xa0\xbb";
var Cred_EndorseExp_Q_Practice = "S\xe9lectionnez les r\xe9ponses vraies se rapportant aux <strong>mises en pratique</strong> de {{applicantName}} dans le domaine \xab\xa0{{skillName}}\xa0\xbb. {{applicantName}}\xa0:";
var Cred_EndorseExp_Q_Practice_15 = "Effectue des t\xe2ches simples dans {{skillName}}";
var Cred_EndorseExp_Q_Practice_35 = "R\xe9sout les probl\xe8mes pour mener \xe0 bien des t\xe2ches complexes dans le domaine de comp\xe9tence \xab\xa0{{skillName}}\xa0\xbb";
var Cred_EndorseExp_Q_Practice_55 = "Applique un grand nombre de m\xe9thodes pour mener \xe0 bien des t\xe2ches complexes dans le domaine de comp\xe9tence \xab\xa0{{skillName}}\xa0\xbb";
var Cred_EndorseExp_Q_Practice_75 = "Identifie les probl\xe8mes strat\xe9giques dans le domaine de comp\xe9tence \xab\xa0{{skillName}}\xa0\xbb et fournit des solutions";
var Cred_EndorseExp_Q_Responsibility = "S\xe9lectionnez les r\xe9ponses vraies se rapportant au <strong>sens de la responsabilit\xe9 et de l’autonomie</strong> de {{applicantName}} dans le domaine \xab\xa0{{skillName}}\xa0\xbb. {{applicantName}}\xa0:";
var Cred_EndorseExp_Q_Responsibility_15 = "Assume la responsabilit\xe9 de ses propres actions tout en agissant sous supervision dans le domaine de comp\xe9tence \xab\xa0{{skillName}}\xa0\xbb";
var Cred_EndorseExp_Q_Responsibility_35 = "Fait preuve d’initiative, de pers\xe9v\xe9rance et de flexibilit\xe9 dans le domaine de comp\xe9tence \xab\xa0{{skillName}}\xa0\xbb";
var Cred_EndorseExp_Q_Responsibility_55 = "Fait preuve d’une grande autonomie et d’une grande responsabilit\xe9 en mati\xe8re de planification et d’\xe9laboration de m\xe9thodes de travail dans le domaine de comp\xe9tence \xab\xa0{{skillName}}\xa0\xbb";
var Cred_EndorseExp_Q_Responsibility_75 = "Fait preuve d’une grande autonomie et d’une grande responsabilit\xe9 dans des projets importants pour le domaine de comp\xe9tence \xab\xa0{{skillName}}\xa0\xbb";
var Cred_EndorseExp_Q_Teamwork = "S\xe9lectionnez les r\xe9ponses vraies se rapportant \xe0 <strong>l’esprit d’\xe9quipe et de leadership</strong> de {{applicantName}} dans le domaine \xab\xa0{{skillName}}\xa0\xbb. {{applicantName}}\xa0:";
var Cred_EndorseExp_Q_Teamwork_15 = "Travaille sous supervision dans le domaine de comp\xe9tence \xab\xa0{{skillName}}\xa0\xbb";
var Cred_EndorseExp_Q_Teamwork_35 = "Travaille de mani\xe8re autonome au sein d’une \xe9quipe dans le domaine de comp\xe9tence \xab\xa0{{skillName}}\xa0\xbb";
var Cred_EndorseExp_Q_Teamwork_55 = "Dirige une \xe9quipe dans le domaine de comp\xe9tence \xab\xa0{{skillName}}\xa0\xbb";
var Cred_EndorseExp_Q_Teamwork_75 = "Dirige des professionnels du domaine de comp\xe9tence \xab\xa0{{skillName}}\xa0\xbb au sein d’une organisation";
var Cred_EndorsementAccept_Accept = "J’accepte ces conditions d’approbation.";
var Cred_EndorsementAccept_HonorCode1 = "En soumettant cette approbation, je certifie qu’\xe0 ma connaissance, la personne mentionn\xe9e poss\xe8de les comp\xe9tences ou exp\xe9riences identifi\xe9es dans le questionnaire transmis par Degreed. Je comprends qu’en soumettant cette approbation, mon nom sera publiquement associ\xe9 \xe0 cette personne et aux comp\xe9tences ou exp\xe9riences qui font l’objet de cette approbation, et je consens par la pr\xe9sente \xe0 la divulgation de mon nom tel que d\xe9crit. J’ai pu constater personnellement que cette personne disposait des comp\xe9tences ou exp\xe9riences indiqu\xe9es. Je d\xe9clare et garantis avoir l’expertise n\xe9cessaire pour \xe9valuer ces comp\xe9tences ou exp\xe9riences et pour d\xe9terminer si elles r\xe9pondent ou non aux attentes du secteur.";
var Cred_EndorsementAccept_HonorCode2 = "Je reconnais et accepte par ailleurs qu’en transmettant cette approbation, je fournis volontairement mes renseignements personnels, notamment mon nom.";
var Cred_EndorsementAccept_HonorCode3 = "J’autorise et accepte la divulgation de mon nom dans le cadre de cette approbation, et je comprends que mon nom ainsi que les renseignements fournis \xe0 Degreed pourront \xeatre employ\xe9s conform\xe9ment \xe0 la Politique de confidentialit\xe9 de Degreed. Je suis seul responsable des d\xe9clarations effectu\xe9es dans le cadre de l’approbation ou en relation avec celle-ci, et j’accepte d’\xeatre r\xe9gi par les conditions d’utilisation de Degreed dans le cadre de mon utilisation des services de Degreed, y compris et sans s’y limiter, l’envoi de cette approbation.";
var Cred_EndorsementAccept_HonorCodeTitle = "Accord d’approbation des comp\xe9tences";
var Cred_EndorsementAccept_Instructions = "Si le candidat se voit octroyer la certification, votre nom figurera en tant qu’approbateur sur son certificat et sera accessible au public. Avant de soumettre votre approbation, vous devez vous engager \xe0 respecter l’accord d’approbation de Degreed. Si, pour quelque raison que ce soit, vous n’acceptez pas cet accord, vous devrez refuser de donner votre approbation.";
var Cred_EndorsementAccount_AlreadyLoggedIn = "Vous \xeates d\xe9j\xe0 connect\xe9 !";
var Cred_EndorsementAccount_Create = "Cr\xe9er un nouveau compte Degreed";
var Cred_EndorsementAccount_CreateAndNext = "Cr\xe9ation du compte et \xe9tape suivante";
var Cred_EndorsementAccount_EmailLabel = "Adresse e-mail";
var Cred_EndorsementAccount_Header = "Cr\xe9er un nouveau compte Degreed";
var Cred_EndorsementAccount_Instructions = "Si vous souhaitez effectuer le suivi de votre formation sur Degreed ou certifier une de vos comp\xe9tences, vous pouvez cr\xe9er un compte ci-dessous pour commencer une fois cette approbation termin\xe9e.";
var Cred_EndorsementAccount_PasswordLabel = "Mot de passe";
var Cred_EndorsementAccount_Skip = "Pas tout de suite";
var Cred_EndorsementAccount_SkipInstructions = "Vous pouvez cr\xe9er un compte ult\xe9rieurement si vous changez d’avis.";
var Cred_EndorsementBehavior_Header = "Examiner le comportement li\xe9 \xe0 la comp\xe9tence {{behaviorNumber}}";
var Cred_EndorsementBehavior_Instructions = "Examinez attentivement les preuves fournies par {{endorsedFirstName}}, y compris les r\xe9ponses \xe9crites et les pi\xe8ces jointes. Comparez ces preuves \xe0 vos collaborations ant\xe9rieures avec {{endorsedFirstName}}, puis remplissez honn\xeatement l’\xe9valuation au bas de la page.";
var Cred_EndorsementEndorser_EmailLabel = "Quelle est votre adresse e-mail \xa0?";
var Cred_EndorsementEndorser_EmailPlaceholder = "e.g. Username@email.com";
var Cred_EndorsementEndorser_FirstNameLabel = "Quel est votre pr\xe9nom\xa0?";
var Cred_EndorsementEndorser_Instructions = "{{endorsedName}} a fourni les informations suivantes. Veuillez confirmer qu’elles sont correctes ou les mettre \xe0 jour si besoin.";
var Cred_EndorsementEndorser_LastNameLabel = "Quel est votre nom ?";
var Cred_EndorsementEndorser_PhoneLabel = "Quel est votre num\xe9ro de t\xe9l\xe9phone\xa0?";
var Cred_EndorsementEndorser_PhonePlaceholder = "e.g. 444-555-1111";
var Cred_EndorsementEndorser_PositionLabel = "Quel emploi exercez-vous\xa0? Pr\xe9cisez votre poste et pour qui vous travaillez.";
var Cred_EndorsementEndorser_PositionPlaceholder = "P. ex.\xa0: professeur \xe0 l’universit\xe9 de Leyde";
var Cred_EndorsementEndorser_RelationshipLabel = "Quel est votre lien avec cette personne\xa0?";
var Cred_EndorsementEndorser_RelationshipPlaceholder = "P. ex.\xa0: il s’agit de l’un de mes \xe9tudiants en master";
var Cred_EndorsementReasonForm_Header = "Pourquoi pas\xa0?";
var Cred_EndorsementReasonForm_ReasonLabel = "Si vous le souhaitez, indiquez pourquoi vous avez d\xe9cid\xe9 de ne pas approuver sa demande.";
var Cred_EndorsementReasonForm_ReasonPlaceholder = "Je ne suis pas en mesure de donner mon approbation, car...";
var Cred_EndorsementStart_Accept = "Examiner les preuves";
var Cred_EndorsementStart_Decline = "Refuser de donner l’approbation";
var Cred_EndorsementStart_Declined = "Vous avez refus\xe9 de donner votre approbation.";
var Cred_EndorsementStart_DeclineReason = "Indiquez les raisons de votre refus (facultatif).";
var Cred_EndorsementStart_DegreedDescription = "Degreed est la seule plateforme qui relie toutes les meilleures exp\xe9riences de formation au monde – syst\xe8mes, contenus, personnes – pour qu’elles puissent toutes interagir plus efficacement. Degreed Skill Certification™ est la premi\xe8re solution de certification au monde qui soit \xe0 la fois ax\xe9e sur les comp\xe9tences, valid\xe9e scientifiquement et encadr\xe9e par des experts.";
var Cred_EndorsementStart_Instructions = "{{endorsedFirstName}} vous invite \xe0 approuver les preuves fournies aux fins de certification dans le domaine de comp\xe9tence \xab\xa0{{credentialName}}\xa0\xbb";
var Cred_EndorsementStart_RequestFrom = "Demande de {{endorsedName}}";
var Cred_EndorsementStart_WhatIsDegreed = "Qu’est-ce que Degreed\xa0?";
var Cred_EndorsementSubmit_CompletedDetails = "Vous avez aid\xe9 {{endorsedName}} \xe0 se rapprocher de son but et d’obtenir une certification Degreed dans le domaine de comp\xe9tence \xab\xa0{{credentialName}}\xa0\xbb. F\xe9licitations\xa0!";
var Cred_EndorsementSubmit_CompletedTitle = "Merci d’avoir approuv\xe9 la comp\xe9tence de\xa0{{endorsedName}}\xa0!";
var Cred_EndorsementSubmit_Exit = "Apprendre sur Degreed";
var Cred_EndorsementSubmit_Header = "Termin\xe9";
var Cred_EndorsementSubmit_Instructions = "Soumettre l’approbation";
var Cred_EndorsementSubmit_Instructions2 = "Si vous avez termin\xe9 l’approbation, cliquez sur <strong>Soumettre</strong>. Il n’est pas possible de modifier les r\xe9ponses apr\xe8s avoir soumis une approbation.";
var Cred_EndorseNav_AcceptDescription = "Examinez l’accord d’approbation.";
var Cred_EndorseNav_AccountDescription = "Vous pouvez cr\xe9er un compte si vous le souhaitez.";
var Cred_EndorseNav_ConfirmContactInfo = "Confirmer les coordonn\xe9es";
var Cred_EndorseNav_CreateDegreedAcct = "Cr\xe9er un compte";
var Cred_EndorseNav_EndorserDescription = "Confirmez vos coordonn\xe9es.";
var Cred_EndorseNav_Heading = "Navigation sur la page d’approbation";
var Cred_EndorseNav_ReviewDescription = "Examinez les preuves li\xe9es \xe0 la comp\xe9tence du candidat.";
var Cred_EndorseNav_ReviewExperience = "Examiner l’exp\xe9rience";
var Cred_EndorseNav_ReviewExperienceDescription = "\xc9valuer l’exp\xe9rience du candidat";
var Cred_EndorseNav_ReviewHonorCode = "Accord d’approbation";
var Cred_EndorseNav_ReviewSkill1 = "\xc9valuer la comp\xe9tence 1";
var Cred_EndorseNav_ReviewSkill2 = "\xc9valuer la comp\xe9tence 2";
var Cred_EndorseNav_ReviewSkill3 = "\xc9valuer la comp\xe9tence 3";
var Cred_EndorseNav_ReviewSkills = "\xc9valuer les comp\xe9tences";
var Cred_EndorseNav_Start = "D\xe9marrer";
var Cred_EndorseNav_StartDescription = "Indiquez si vous souhaitez ou non approuver {{fname}}.";
var Cred_EndorseNav_SubmitDescription = "C’est termin\xe9\xa0! Merci de nous avoir aid\xe9s \xe0 certifier une comp\xe9tence.";
var Cred_EndorserDemo_ButtonLabel = "Ce que ces approbateurs verront";
var Cred_EndorserDemo_Heading = "Ce que les approbateurs voient";
var Cred_EndorserDemo_ImageAlt = "Capture d’\xe9cran montrant un exemple de {{title}}";
var Cred_EndorserDemo_Step1_Content = "Pour confirmer son identit\xe9, l’approbateur doit v\xe9rifier que les coordonn\xe9es fournies sont exactes.";
var Cred_EndorserDemo_Step1_Title = "V\xe9rifier l’identit\xe9";
var Cred_EndorserDemo_Step2_Content = "L’approbateur examinera ensuite votre demande en passant en revue vos comportements li\xe9s \xe0 la comp\xe9tence.";
var Cred_EndorserDemo_Step2_Title = "Examiner la demande";
var Cred_EndorserDemo_Step3_Content = "Enfin, l’approbateur r\xe9pondra \xe0 quelques questions concernant votre demande.";
var Cred_EndorserDemo_Step3_Title = "R\xe9pondre aux questions";
var Cred_EndorserDemo_ThanksGotIt = "J’ai compris";
var Cred_EndorserExpired_Explanation = "Il se peut que cette invitation d’approbation ait expir\xe9. Adressez-vous au candidat \xe0 la certification pour obtenir une nouvelle invitation.";
var Cred_EndorserExpired_Heading = "Cette invitation d’approbation n’est pas valide";
var Cred_EndorserResend_Header = "Renvoyer l’invitation";
var Cred_Evidence_RemoveHeader = "Souhaitez-vous vraiment supprimer cette preuve\xa0?";
var Cred_Evidence_RemoveSummary = "La preuve ne s’affichera plus avec votre description.";
var Cred_EvidenceDisplay_ExampleHeading = "Exemple";
var Cred_EvidenceDisplay_ProcessHeading = "Processus et justification";
var Cred_ExpertCandidate_AttrAutonomy = "Responsabilit\xe9 et autonomie";
var Cred_ExpertCandidate_Attributes = "Attributs";
var Cred_ExpertCandidate_AttrKnowledge = "Connaissances";
var Cred_ExpertCandidate_AttrPlanning = "Planning et \xe9valuation";
var Cred_ExpertCandidate_AttrSkills = "Demande";
var Cred_ExpertCandidate_AttrTeaching = "Communication et enseignement";
var Cred_ExpertCandidate_AttrTeamwork = "Travail d’\xe9quipe et leadership";
var Cred_ExpertCandidate_CommentsLabel = "Remarques ou commentaires";
var Cred_ExpertCandidate_CommentsPlaceholder = "Ajoutez des remarques ou des commentaires…";
var Cred_ExpertCandidate_Heading = "Quel niveau doit-on attribuer \xe0 ce candidat\xa0?";
var Cred_ExpertCandidate_LevelHigh = "Expert";
var Cred_ExpertCandidate_LevelLabel = "Quel niveau doit-on attribuer \xe0 ce candidat\xa0?";
var Cred_ExpertCandidate_LevelLow = "D\xe9butant";
var Cred_ExpertCandidate_NA = "Cred_ExpertCandidate_NA";
var Cred_ExpertCandidate_SaveLevel = "Soumettre l’\xe9valuation";
var Cred_ExpertPending_BeginNextReview = "Proc\xe9der \xe0 l’examen suivant";
var Cred_ExpertPending_Heading = "\xc9valuations en attente";
var Cred_ExpertPending_NoPendingReviews = "Il n’y a aucune \xe9valuation en attente pour le moment. Veuillez v\xe9rifier ult\xe9rieurement.";
var Cred_ExpertPending_ReviewsRemainingFormat = "Environ {{number}}\xa0\xe9valuations restantes";
var Cred_InstructionVideo = "Vid\xe9o d’instruction";
var Cred_Intent_CareerChange = "Je souhaite changer de carri\xe8re.";
var Cred_Intent_ImproveSkills = "Je souhaite d\xe9velopper et am\xe9liorer mes comp\xe9tences dans mon poste actuel.";
var Cred_Intent_legend = "Je souhaite soumettre une demande de certification de comp\xe9tence Degreed car\xa0:";
var Cred_Intent_MeasureMe = "Je veux savoir exactement quel est mon niveau de comp\xe9tence.";
var Cred_Intent_Other = "Je souhaite soumettre une demande pour une autre raison.";
var Cred_Intent_ShowSkills = "Je veux pouvoir mettre en avant mes comp\xe9tences.";
var Cred_Intent_WorkDomain = "Je travaille dans un domaine qui diff\xe8re de mon cursus universitaire.";
var Cred_LevelBreakdown_Autonomy_1 = "Assume la responsabilit\xe9 pour les r\xe9sultats d’activit\xe9s structur\xe9s dans des contextes habituels et stables.";
var Cred_LevelBreakdown_Autonomy_2 = "Assume la responsabilit\xe9 individuelle de l’ex\xe9cution des t\xe2ches et des proc\xe9dures dans un \xe9ventail limit\xe9 de contextes. Exerce une certaine autonomie en suivant des directives et des conseils g\xe9n\xe9raux.";
var Cred_LevelBreakdown_Autonomy_3 = "Effectue les t\xe2ches, utilise les proc\xe9dures et obtient un bon r\xe9sultat avec un niveau important de responsabilit\xe9 et d’autonomie dans des contextes qui sont moins habituels et stables, en suivant des directives et des conseils g\xe9n\xe9raux. D\xe9finit ses propres objectifs et en assume la responsabilit\xe9.";
var Cred_LevelBreakdown_Autonomy_4 = "Fait preuve d’initiative en mati\xe8re de planification et d’\xe9laboration de fonctions techniques ou de management. D\xe9finit ses propres objectifs et en assume la responsabilit\xe9. Fait preuve de pers\xe9v\xe9rance et de flexibilit\xe9 pour atteindre les objectifs.";
var Cred_LevelBreakdown_Autonomy_5 = "Assume la responsabilit\xe9 pour les actions et r\xe9sultats g\xe9n\xe9raux, et exerce une autonomie dans des contextes aux param\xe8tres plus larges. Poursuit des objectifs en autonomie et assume la responsabilit\xe9 de ces objectifs.";
var Cred_LevelBreakdown_Autonomy_6 = "Fait preuve d’une grande autonomie et d’une grande responsabilit\xe9 en mati\xe8re de planification et d’\xe9laboration de m\xe9thodes de travail. \xc9value les forces et les faiblesses de ces m\xe9thodes.";
var Cred_LevelBreakdown_Autonomy_7 = "Exerce une grande autonomie dans un domaine d’activit\xe9 consid\xe9rable. D\xe9finit les objectifs pour de nouvelles applications ou des t\xe2ches de recherche.";
var Cred_LevelBreakdown_Autonomy_8 = "Exerce une autonomie compl\xe8te en tant que chercheur ou praticien et assument la responsabilit\xe9 de planification et de mise en œuvre de mesures ayant un impact consid\xe9rable sur le terrain. D\xe9finit les objectifs pour de nouvelles applications complexes ou des t\xe2ches de recherche. S\xe9lectionne les m\xe9thodes appropri\xe9es et met en œuvre de nouvelles id\xe9es et de nouveaux processus.";
var Cred_LevelBreakdown_Autonomy_Scale6_1 = "Assume la responsabilit\xe9 individuelle de l’ex\xe9cution de t\xe2ches et de proc\xe9dures structur\xe9es dans des contextes familiers et stables.";
var Cred_LevelBreakdown_Autonomy_Scale6_2 = "Fait preuve d’une certaine autonomie sous r\xe9serve de directives et conseils globaux dans un \xe9ventail limit\xe9 de contextes.";
var Cred_LevelBreakdown_Autonomy_Scale6_3 = "Effectue les t\xe2ches, utilise les proc\xe9dures et obtient un bon r\xe9sultat avec un niveau important de responsabilit\xe9 et d’autonomie. Fixe ses propres objectifs et en assume la responsabilit\xe9.";
var Cred_LevelBreakdown_Autonomy_Scale6_4 = "Assume la responsabilit\xe9 des actions et des r\xe9sultats globaux et exerce son autonomie dans des param\xe8tres plus larges. Fait preuve d’initiative dans la planification et la conception de fonctions techniques et de gestion et entreprend la poursuite autonome des objectifs.";
var Cred_LevelBreakdown_Autonomy_Scale6_5 = "Fait preuve d’une grande autonomie et d’une grande responsabilit\xe9 en mati\xe8re de planification et d’\xe9laboration des m\xe9thodes de travail et assume la responsabilit\xe9 des objectifs. \xc9value les forces et les faiblesses de ces m\xe9thodes.";
var Cred_LevelBreakdown_Autonomy_Scale6_6 = "Exerce une autonomie compl\xe8te en tant que sp\xe9cialiste ou praticien de premier plan qui d\xe9finit les objectifs de nouvelles applications ou de t\xe2ches ax\xe9es sur la recherche. D\xe9veloppe de nouvelles id\xe9es et m\xe9thodes qui ont un impact significatif sur le terrain.";
var Cred_LevelBreakdown_Autonomy_Scale8_1 = "Assume la responsabilit\xe9 des r\xe9sultats pour des activit\xe9s structur\xe9es dans des contextes familiers et stables.";
var Cred_LevelBreakdown_Autonomy_Scale8_2 = "Assume la responsabilit\xe9 individuelle de l’ex\xe9cution des t\xe2ches et des proc\xe9dures dans un \xe9ventail limit\xe9 de contextes. Exerce une certaine autonomie en suivant des directives et des conseils g\xe9n\xe9raux.";
var Cred_LevelBreakdown_Autonomy_Scale8_3 = "Effectue les t\xe2ches, utilise les proc\xe9dures et obtient un bon r\xe9sultat avec un niveau important de responsabilit\xe9 et d’autonomie dans des contextes qui sont moins habituels et stables, en suivant des directives et des conseils g\xe9n\xe9raux. D\xe9finit ses propres objectifs et en assume la responsabilit\xe9.";
var Cred_LevelBreakdown_Autonomy_Scale8_4 = "Fait preuve d’initiative en mati\xe8re de planification et d’\xe9laboration de fonctions techniques ou de management. D\xe9finit ses propres objectifs et en assume la responsabilit\xe9. Fait preuve de pers\xe9v\xe9rance et de flexibilit\xe9 pour atteindre les objectifs.";
var Cred_LevelBreakdown_Autonomy_Scale8_5 = "Assume la responsabilit\xe9 pour les actions et r\xe9sultats g\xe9n\xe9raux, et exerce une autonomie dans des contextes aux param\xe8tres plus larges. Poursuit des objectifs en autonomie et assume la responsabilit\xe9 de ces objectifs.";
var Cred_LevelBreakdown_Autonomy_Scale8_6 = "Fait preuve d’une grande autonomie et d’une grande responsabilit\xe9 en mati\xe8re de planification et d’\xe9laboration de m\xe9thodes de travail. \xc9value les forces et les faiblesses de ces m\xe9thodes.";
var Cred_LevelBreakdown_Autonomy_Scale8_7 = "Exerce une grande autonomie dans un domaine d’activit\xe9 consid\xe9rable. D\xe9finit les objectifs pour de nouvelles applications ou des t\xe2ches de recherche.";
var Cred_LevelBreakdown_Autonomy_Scale8_8 = "Exerce une autonomie compl\xe8te en tant que sp\xe9cialiste ou praticien et assume la responsabilit\xe9 de la planification et de la mise en œuvre d’actions ayant un impact important dans son domaine d’activit\xe9. D\xe9finit les objectifs pour de nouvelles applications complexes ou t\xe2ches de recherche. S\xe9lectionne les m\xe9thodes appropri\xe9es et \xe9labore de nouveaux concepts et processus.";
var Cred_LevelBreakdown_Description = "Ces \xe9valuations sont bas\xe9es sur les examens combin\xe9s de notre panel d’experts.";
var Cred_LevelBreakdown_Knowledge_1 = "Fait preuve de connaissances g\xe9n\xe9rales.";
var Cred_LevelBreakdown_Knowledge_2 = "Fait preuve des connaissances de base qui incluent des principes et des pratiques pertinents.";
var Cred_LevelBreakdown_Knowledge_3 = "Fait preuve et applique des connaissances \xe9tendues. Ceci inclut des connaissances d’une s\xe9lection limit\xe9e de concepts techniques et th\xe9oriques, de proc\xe9dures et de solutions \xe0 des probl\xe8mes pr\xe9visibles.";
var Cred_LevelBreakdown_Knowledge_4 = "Fait preuve de connaissances th\xe9oriques et techniques pour trouver des solutions \xe0 des sch\xe9mas inconnus.";
var Cred_LevelBreakdown_Knowledge_5 = "Fait preuve de connaissances int\xe9gr\xe9es et sp\xe9cialis\xe9es. Ceci inclut des connaissances th\xe9oriques et professionnelles approfondies, notamment la port\xe9e, les th\xe9ories et les pratiques principales, ainsi que les limitations du domaine.";
var Cred_LevelBreakdown_Knowledge_6 = "Fait preuve de grandes connaissances int\xe9gr\xe9es concernant les principes scientifiques et l’application pratique. Ceci inclut une compr\xe9hension critique des th\xe9ories les plus importantes, d’une vari\xe9t\xe9 de m\xe9thodes, ainsi qu’une mise en œuvre ad\xe9quate et innovante pour r\xe9soudre des probl\xe8mes complexes.";
var Cred_LevelBreakdown_Knowledge_7 = "Fait preuve de connaissances approfondies, d\xe9taill\xe9es, sp\xe9cialis\xe9es et modernes. Ceci inclut des connaissances approfondies sur des disciplines associ\xe9es, les th\xe9ories principales, les m\xe9thodes et les bonnes pratiques dans ce domaine.";
var Cred_LevelBreakdown_Knowledge_8 = "Fait preuve de connaissances approfondies, sp\xe9cialis\xe9es et de pointe. Contribue \xe0 l’innovation ou \xe0 l’expansion des connaissances. Ceci inclut des connaissances sp\xe9cialis\xe9es \xe0 l’interface de disciplines voisines.";
var Cred_LevelBreakdown_Knowledge_Scale6_1 = "D\xe9montre et utilise les connaissances de base.";
var Cred_LevelBreakdown_Knowledge_Scale6_2 = "D\xe9montre et applique des connaissances de base, y compris les principes et pratiques pertinents ainsi qu’un \xe9ventail limit\xe9 de concepts techniques.";
var Cred_LevelBreakdown_Knowledge_Scale6_3 = "D\xe9montre et applique des connaissances \xe9tendues, y compris des solutions \xe0 des probl\xe8mes pr\xe9visibles.";
var Cred_LevelBreakdown_Knowledge_Scale6_4 = "Fait preuve de connaissances th\xe9oriques et techniques compl\xe8tes, notamment des connaissances sp\xe9cialis\xe9es, pour trouver des solutions \xe0 des sch\xe9mas inconnus.";
var Cred_LevelBreakdown_Knowledge_Scale6_5 = "Fait preuve de grandes connaissances int\xe9gr\xe9es concernant les principes scientifiques et l’application pratique. Ces connaissances essentielles favorisent une innovation pertinente pour appr\xe9hender des probl\xe9matiques complexes.";
var Cred_LevelBreakdown_Knowledge_Scale6_6 = "Fait preuve de connaissances de pointe approfondies, d\xe9taill\xe9es et sp\xe9cialis\xe9es et contribue \xe0 l’innovation ou \xe0 l’expansion des connaissances. Ceci inclut des connaissances approfondies sur des disciplines associ\xe9es, les th\xe9ories principales, les m\xe9thodes et les bonnes pratiques dans ce domaine.";
var Cred_LevelBreakdown_Knowledge_Scale8_1 = "Poss\xe8de des connaissances g\xe9n\xe9rales.";
var Cred_LevelBreakdown_Knowledge_Scale8_2 = "Fait preuve des connaissances de base qui incluent des principes et des pratiques pertinents.";
var Cred_LevelBreakdown_Knowledge_Scale8_3 = "Fait preuve et applique des connaissances \xe9tendues. Ceci inclut des connaissances d’une s\xe9lection limit\xe9e de concepts techniques et th\xe9oriques, de proc\xe9dures et de solutions \xe0 des probl\xe8mes pr\xe9visibles.";
var Cred_LevelBreakdown_Knowledge_Scale8_4 = "Fait preuve de connaissances th\xe9oriques et techniques pour trouver des solutions \xe0 des sch\xe9mas inconnus.";
var Cred_LevelBreakdown_Knowledge_Scale8_5 = "Fait preuve de connaissances int\xe9gr\xe9es et sp\xe9cialis\xe9es. Ceci inclut des connaissances th\xe9oriques et professionnelles approfondies, notamment la port\xe9e, les th\xe9ories et les pratiques principales, ainsi que les limitations du domaine.";
var Cred_LevelBreakdown_Knowledge_Scale8_6 = "Fait preuve de grandes connaissances int\xe9gr\xe9es concernant les principes scientifiques et l’application pratique. Ceci inclut une compr\xe9hension critique des th\xe9ories les plus importantes, d’une vari\xe9t\xe9 de m\xe9thodes, ainsi qu’une mise en œuvre ad\xe9quate et innovante pour r\xe9soudre des probl\xe8mes complexes.";
var Cred_LevelBreakdown_Knowledge_Scale8_7 = "Fait preuve de connaissances approfondies, d\xe9taill\xe9es, sp\xe9cialis\xe9es et modernes. Ceci inclut des connaissances approfondies sur des disciplines associ\xe9es, les th\xe9ories principales, les m\xe9thodes et les bonnes pratiques dans ce domaine.";
var Cred_LevelBreakdown_Knowledge_Scale8_8 = "Fait preuve de connaissances approfondies, sp\xe9cialis\xe9es et de pointe. Contribue \xe0 l’innovation ou \xe0 l’expansion des connaissances. Ceci inclut des connaissances sp\xe9cialis\xe9es \xe0 l’interface de disciplines voisines.";
var Cred_LevelBreakdown_Planning_1 = "Sait reconna\xeetre les relations \xe9l\xe9mentaires entre les formations assign\xe9es et les t\xe2ches, et est capable d’agir en cons\xe9quence.";
var Cred_LevelBreakdown_Planning_2 = "Fait preuve de la capacit\xe9 de reconna\xeetre et d’agir sur les relations \xe9l\xe9mentaires entre missions et t\xe2ches. \xc9value les r\xe9sultats de ces t\xe2ches selon des crit\xe8res pr\xe9d\xe9termin\xe9s.";
var Cred_LevelBreakdown_Planning_3 = "\xc9value les r\xe9sultats selon des crit\xe8res largement pr\xe9d\xe9termin\xe9s. Fournit un reporting simple de m\xe9thodes et de r\xe9sultats.";
var Cred_LevelBreakdown_Planning_4 = "Planifie et con\xe7oit des approches et des proc\xe9dures appropri\xe9es. \xc9value les r\xe9sultats. Fait preuve d’une capacit\xe9 \xe0 s\xe9lectionner des actions ou des pratiques en fonction des observations.";
var Cred_LevelBreakdown_Planning_5 = "Planifie les processus de travail. \xc9value ces processus, en envisageant en d\xe9tail les alternatives et leurs impacts potentiels. Identifie et structure des probl\xe8mes complexes, et distingue les id\xe9es des concepts, th\xe9ories ou approches pratiques pour r\xe9soudre ces probl\xe8mes.";
var Cred_LevelBreakdown_Planning_6 = "\xc9labore et \xe9value de nouvelles solutions et consid\xe8re l’effet sur plusieurs crit\xe8res. Diff\xe9rencie et \xe9value les th\xe9ories et m\xe9thodes pour des probl\xe8mes complexes s\xe9lectionn\xe9s.";
var Cred_LevelBreakdown_Planning_7 = "Fait preuve de jugements ind\xe9pendants de haut niveau dans une vari\xe9t\xe9 de fonctions techniques et de management et exprime clairement les d\xe9fis pertinents impliqu\xe9s. Ceci inclut l’initiation, la planification et l’\xe9valuation de plusieurs fonctions cr\xe9atives ou techniques sp\xe9cialis\xe9es, l’exploration des limites actuelles de la th\xe9orie, des connaissances et de la pratique, ainsi que la consid\xe9ration d’alternatives.";
var Cred_LevelBreakdown_Planning_8 = "Fait preuve d’une capacit\xe9 d’identifier et de r\xe9soudre de nouveaux probl\xe8mes li\xe9s \xe0 la recherche, au d\xe9veloppement ou \xe0 l’innovation dans le domaine. Ceci inclut l’initiation, la planification et l’\xe9valuation de grandes fonctions sp\xe9cialis\xe9es, techniques et cr\xe9atives incluant des domaines interdisciplinaires et la consid\xe9ration d’alternatives.";
var Cred_LevelBreakdown_Planning_Scale6_1 = "Sait reconna\xeetre les relations \xe9l\xe9mentaires entre les formations assign\xe9es et les t\xe2ches, et est capable d’agir en cons\xe9quence.";
var Cred_LevelBreakdown_Planning_Scale6_2 = "\xc9value les r\xe9sultats des t\xe2ches conform\xe9ment aux crit\xe8res pr\xe9-stipul\xe9s.";
var Cred_LevelBreakdown_Planning_Scale6_3 = "\xc9value les r\xe9sultats selon des crit\xe8res largement pr\xe9-stipul\xe9s. D\xe9montre sa capacit\xe9 \xe0 s\xe9lectionner des actions ou des pratiques alternatives bas\xe9es sur des observations.";
var Cred_LevelBreakdown_Planning_Scale6_4 = "Planifie et con\xe7oit des approches et m\xe9thodes de travail adapt\xe9es. \xc9value ces m\xe9thodes, en envisageant en d\xe9tail les alternatives et leurs impacts potentiels. Identifie et structure des probl\xe8mes complexes, et distingue les id\xe9es des concepts, th\xe9ories ou approches pratiques pour r\xe9soudre ces probl\xe8mes.";
var Cred_LevelBreakdown_Planning_Scale6_5 = "\xc9labore de nouvelles m\xe9thodes de travail et solutions, en prenant en compte de mani\xe8re exhaustive les alternatives et leurs impacts potentiels. Diff\xe9rencie et \xe9value les th\xe9ories et les approches en rapport avec les probl\xe8mes complexes s\xe9lectionn\xe9s.";
var Cred_LevelBreakdown_Planning_Scale6_6 = "Fait preuve de jugements ind\xe9pendants de haut niveau dans une vari\xe9t\xe9 de fonctions techniques et de management et exprime clairement les d\xe9fis pertinents impliqu\xe9s. Identifie et r\xe9sout de nouveaux probl\xe8mes en recherche et d\xe9veloppement. Ceci inclut l’initiation, la planification et l’\xe9valuation de plusieurs fonctions cr\xe9atives ou techniques sp\xe9cialis\xe9es.";
var Cred_LevelBreakdown_Planning_Scale8_1 = "Sait reconna\xeetre les relations \xe9l\xe9mentaires entre les formations assign\xe9es et les t\xe2ches, et est capable d’agir en cons\xe9quence.";
var Cred_LevelBreakdown_Planning_Scale8_2 = "Sait reconna\xeetre les relations \xe9l\xe9mentaires entre les formations assign\xe9es et les t\xe2ches, et est capable d’agir en cons\xe9quence. \xc9value les r\xe9sultats de ces t\xe2ches selon des crit\xe8res pr\xe9d\xe9termin\xe9s.";
var Cred_LevelBreakdown_Planning_Scale8_3 = "\xc9value les r\xe9sultats selon des crit\xe8res largement pr\xe9d\xe9termin\xe9s. Fournit un reporting simple de m\xe9thodes et de r\xe9sultats.";
var Cred_LevelBreakdown_Planning_Scale8_4 = "Planifie et con\xe7oit des approches et des proc\xe9dures appropri\xe9es. \xc9value les r\xe9sultats. Fait preuve d’une capacit\xe9 \xe0 s\xe9lectionner des actions ou des pratiques en fonction des observations.";
var Cred_LevelBreakdown_Planning_Scale8_5 = "Planifie les processus de travail. \xc9value ces processus, en envisageant en d\xe9tail les alternatives et leurs impacts potentiels. Identifie et structure des probl\xe8mes complexes, et distingue les id\xe9es des concepts, th\xe9ories ou approches pratiques pour r\xe9soudre ces probl\xe8mes.";
var Cred_LevelBreakdown_Planning_Scale8_6 = "\xc9labore et \xe9value de nouvelles solutions et consid\xe8re l’effet sur plusieurs crit\xe8res. Diff\xe9rencie et \xe9value les th\xe9ories et m\xe9thodes pour des probl\xe8mes complexes s\xe9lectionn\xe9s.";
var Cred_LevelBreakdown_Planning_Scale8_7 = "Fait preuve de jugements ind\xe9pendants de haut niveau dans une vari\xe9t\xe9 de fonctions techniques et de management et exprime clairement les d\xe9fis pertinents impliqu\xe9s. Ceci inclut l’initiation, la planification et l’\xe9valuation de plusieurs fonctions cr\xe9atives ou techniques sp\xe9cialis\xe9es, l’exploration des limites actuelles de la th\xe9orie, des connaissances et de la pratique, ainsi que la consid\xe9ration d’alternatives.";
var Cred_LevelBreakdown_Planning_Scale8_8 = "Fait preuve d’une capacit\xe9 d’identifier et de r\xe9soudre de nouveaux probl\xe8mes li\xe9s \xe0 la recherche, au d\xe9veloppement ou \xe0 l’innovation dans le domaine. Ceci inclut l’initiation, la planification et l’\xe9valuation de grandes fonctions sp\xe9cialis\xe9es, techniques et cr\xe9atives incluant des domaines interdisciplinaires et la consid\xe9ration d’alternatives.";
var Cred_LevelBreakdown_Skills_1 = "Fait preuve d’aptitudes cognitives et de comp\xe9tences pratiques de base pour effectuer des t\xe2ches avec des r\xe8gles d\xe9termin\xe9es.";
var Cred_LevelBreakdown_Skills_2 = "Fait preuve des aptitudes cognitives et des comp\xe9tences pratiques requises pour effectuer des t\xe2ches techniques de base.";
var Cred_LevelBreakdown_Skills_3 = "Fait preuve d’une grande vari\xe9t\xe9 d’aptitudes cognitives et de comp\xe9tences pratiques. Peut identifier les m\xe9thodes et comp\xe9tences pertinentes pour effectuer des t\xe2ches et peut r\xe9soudre des probl\xe8mes bien d\xe9finis ayant une mesure de complexit\xe9.";
var Cred_LevelBreakdown_Skills_4 = "Fait preuve d’un usage d’une grande vari\xe9t\xe9 d’aptitudes cognitives et de comp\xe9tences pratiques. Peut r\xe9soudre des probl\xe8mes difficiles et effectuer des t\xe2ches complexes.";
var Cred_LevelBreakdown_Skills_5 = "Fait preuve d’une grande vari\xe9t\xe9 d’aptitudes cognitives et de comp\xe9tences pratiques sp\xe9cialis\xe9es. Peut r\xe9soudre des probl\xe8mes difficiles et effectuer des t\xe2ches complexes.";
var Cred_LevelBreakdown_Skills_6 = "Applique un registre complet de m\xe9thodes pour traiter des t\xe2ches et des probl\xe8mes complexes.";
var Cred_LevelBreakdown_Skills_7 = "Fait preuve de comp\xe9tences techniques et conceptuelles permettant d’analyser, de consolider et de synth\xe9tiser des connaissances pour identifier et fournir des solutions \xe0 des probl\xe8mes strat\xe9giques au sein de cette comp\xe9tence.";
var Cred_LevelBreakdown_Skills_8 = "Applique une capacit\xe9 de jugement ind\xe9pendant de haut niveau de nombreuses fonctions techniques et de management dans plusieurs contextes sp\xe9cialis\xe9s.";
var Cred_LevelBreakdown_Skills_Scale6_1 = "Fait preuve des aptitudes cognitives et des comp\xe9tences pratiques requises pour effectuer des t\xe2ches techniques de base \xe0 l’aide des r\xe8gles stipul\xe9es.";
var Cred_LevelBreakdown_Skills_Scale6_2 = "Fait preuve de comp\xe9tences cognitives et pratiques diverses pour effectuer des t\xe2ches de base en utilisant des m\xe9thodes et des comp\xe9tences pertinentes.";
var Cred_LevelBreakdown_Skills_Scale6_3 = "Fait preuve d’un usage d’une grande vari\xe9t\xe9 d’aptitudes cognitives et pratiques. Fait appel \xe0 une m\xe9thode de r\xe9solution des probl\xe8mes pour solutionner des probl\xe8mes bien d\xe9finis et des t\xe2ches complexes.";
var Cred_LevelBreakdown_Skills_Scale6_4 = "Fait preuve d’une grande vari\xe9t\xe9 d’aptitudes cognitives et de comp\xe9tences pratiques sp\xe9cialis\xe9es. Peut r\xe9soudre des probl\xe8mes difficiles et effectuer des t\xe2ches complexes.";
var Cred_LevelBreakdown_Skills_Scale6_5 = "D\xe9montre et applique toute une vari\xe9t\xe9 de m\xe9thodes, notamment des comp\xe9tences sp\xe9cialis\xe9es dans le but de traiter des t\xe2ches et des probl\xe8mes complexes.";
var Cred_LevelBreakdown_Skills_Scale6_6 = "Fait preuve de comp\xe9tences techniques ou conceptuelles sp\xe9cialis\xe9es pour synth\xe9tiser les connaissances afin de porter des jugements ind\xe9pendants de haut niveau et de fournir des solutions \xe0 des probl\xe8mes strat\xe9giques dans une vari\xe9t\xe9 de contextes sp\xe9cialis\xe9s.";
var Cred_LevelBreakdown_Skills_Scale8_1 = "Fait preuve d’aptitudes cognitives et de comp\xe9tences pratiques de base pour effectuer des t\xe2ches avec des r\xe8gles d\xe9termin\xe9es.";
var Cred_LevelBreakdown_Skills_Scale8_2 = "Fait preuve des aptitudes cognitives et des comp\xe9tences pratiques requises pour effectuer des t\xe2ches techniques de base.";
var Cred_LevelBreakdown_Skills_Scale8_3 = "Fait preuve d’une grande vari\xe9t\xe9 d’aptitudes cognitives et de comp\xe9tences pratiques. Peut identifier les m\xe9thodes et comp\xe9tences pertinentes pour effectuer des t\xe2ches et peut r\xe9soudre des probl\xe8mes bien d\xe9finis ayant une mesure de complexit\xe9.";
var Cred_LevelBreakdown_Skills_Scale8_4 = "Fait preuve d’un usage d’une grande vari\xe9t\xe9 d’aptitudes cognitives et de comp\xe9tences pratiques. Peut r\xe9soudre des probl\xe8mes difficiles et effectuer des t\xe2ches complexes.";
var Cred_LevelBreakdown_Skills_Scale8_5 = "Fait preuve d’une grande vari\xe9t\xe9 d’aptitudes cognitives et de comp\xe9tences pratiques sp\xe9cialis\xe9es. Peut r\xe9soudre des probl\xe8mes difficiles et effectuer des t\xe2ches complexes.";
var Cred_LevelBreakdown_Skills_Scale8_6 = "Applique un registre complet de m\xe9thodes pour traiter des t\xe2ches et des probl\xe8mes complexes.";
var Cred_LevelBreakdown_Skills_Scale8_7 = "Fait preuve de comp\xe9tences techniques et conceptuelles permettant d’analyser, de consolider et de synth\xe9tiser des connaissances pour identifier et fournir des solutions \xe0 des probl\xe8mes strat\xe9giques au sein de cette comp\xe9tence.";
var Cred_LevelBreakdown_Skills_Scale8_8 = "Applique une capacit\xe9 de jugement ind\xe9pendant de haut niveau de nombreuses fonctions techniques et de management dans plusieurs contextes sp\xe9cialis\xe9s.";
var Cred_LevelBreakdown_Teaching_1 = "Fait preuve de capacit\xe9s de communication et relationnelles de base.";
var Cred_LevelBreakdown_Teaching_2 = "Participe activement \xe0 l’apprentissage en groupe en demandant des conseils lorsque c’est n\xe9cessaire. Fait preuve d’attention et de compr\xe9hension pour recevoir des directives ou des informations de la part d’autres personnes.";
var Cred_LevelBreakdown_Teaching_3 = "Utilise une bonne communication pour transmettre des connaissances et des comp\xe9tences sp\xe9cialis\xe9es aux autres. Fait preuve d’attention et de compr\xe9hension pour recevoir des directives ou des informations de la part d’autres personnes.";
var Cred_LevelBreakdown_Teaching_4 = "Fait preuve de capacit\xe9s relationnelles sup\xe9rieures, en particulier d’une communication efficace des solutions \xe0 des probl\xe8mes complexes lorsque le sujet peut \xeatre sensible, controvers\xe9 ou susceptible d’\xeatre questionn\xe9 ou contest\xe9. Aide \xe0 \xe9laborer le travail en groupe.";
var Cred_LevelBreakdown_Teaching_5 = "Fait preuve de capacit\xe9s relationnelles avanc\xe9es, notamment la capacit\xe9 de pr\xe9senter des faits et des circonstances complexes et de communiquer des solutions de mani\xe8re appropri\xe9e au contexte \xe0 des audiences interdisciplinaires. Agit de mani\xe8re anticipative en consid\xe9rant les int\xe9r\xeats et exigences d’autrui. \xc9value les cons\xe9quences possibles de m\xe9thodes de travail au sein d’\xe9quipes, forment ses coll\xe8gues et fournit des conseils p\xe9dagogiques.";
var Cred_LevelBreakdown_Teaching_6 = "Fait preuve d’aptitudes relationnelles avanc\xe9es, notamment la capacit\xe9 de communiquer des m\xe9thodes, des technologies, des connaissances et des id\xe9es en d\xe9tail et avec clart\xe9. Ceci inclut la capacit\xe9 de pr\xe9sentation d’arguments et de solutions \xe0 des probl\xe8mes complexes, m\xeame lorsque le sujet est tr\xe8s difficile, inconnu ou technique. Dispense la formation pour le d\xe9veloppement professionnel de ses coll\xe8gues et agit de mani\xe8re anticipative pour r\xe9gler les probl\xe8mes au sein des \xe9quipes.";
var Cred_LevelBreakdown_Teaching_7 = "Fait preuve de capacit\xe9s de communication appropri\xe9es pour mener des d\xe9bats d’experts en mati\xe8re de nouvelles id\xe9es ou de nouveaux probl\xe8mes. Promeut le d\xe9veloppement professionnel des autres de mani\xe8re cibl\xe9e. Peut cr\xe9er un consensus et appliquer des pratiques de n\xe9gociations dans un environnement de groupe.";
var Cred_LevelBreakdown_Teaching_8 = "Fait preuve de niveaux profonds d’aptitudes relationnelles. En particulier, d’une bonne communication pour transmettre des connaissances et des comp\xe9tences sp\xe9cialis\xe9es aux autres. Anime des d\xe9bats interdisciplinaires et propose des contributions innovantes aux discussions professionnelles sp\xe9cialis\xe9es.";
var Cred_LevelBreakdown_Teaching_Scale6_1 = "D\xe9montre des capacit\xe9s interpersonnelles et de communication de base. Fait preuve d’attention et de compr\xe9hension pour recevoir des directives ou des informations de la part d’autres personnes.";
var Cred_LevelBreakdown_Teaching_Scale6_2 = "Participe activement \xe0 la formation en groupe en demandant des conseils lorsque cela est n\xe9cessaire. Utilise ses capacit\xe9s de communication pour partager certaines connaissances avec d’autres personnes.";
var Cred_LevelBreakdown_Teaching_Scale6_3 = "Peut communiquer efficacement sur des solutions \xe0 des probl\xe8mes complexes lorsque le sujet peut \xeatre sensible, controvers\xe9 ou susceptible d’\xeatre remis en question ou contest\xe9.";
var Cred_LevelBreakdown_Teaching_Scale6_4 = "Aide \xe0 fa\xe7onner le travail de groupe. Peut pr\xe9senter des faits et des circonstances complexes et communiquer sur les solutions de fa\xe7on adapt\xe9e au contexte \xe0 des publics interdisciplinaires. Agit avec anticipation tout en tenant compte des int\xe9r\xeats et des exigences des autres.";
var Cred_LevelBreakdown_Teaching_Scale6_5 = "Fait preuve d’aptitudes interpersonnelles avanc\xe9es, notamment la capacit\xe9 de communiquer des m\xe9thodes, des technologies, des connaissances et des id\xe9es en d\xe9tail et avec clart\xe9. Ceci inclut la capacit\xe9 de pr\xe9senter des arguments et des solutions \xe0 des probl\xe8mes complexes, m\xeame lorsque le sujet est tr\xe8s difficile, inconnu ou technique.";
var Cred_LevelBreakdown_Teaching_Scale6_6 = "Fait preuve de capacit\xe9s de communication appropri\xe9es pour mener des d\xe9bats d’experts sur de nouvelles id\xe9es et de nouveaux probl\xe8mes. D\xe9montre des capacit\xe9s de communication pour transf\xe9rer des connaissances et des comp\xe9tences sp\xe9cialis\xe9es aux autres. Favorise le d\xe9veloppement professionnel des autres de mani\xe8re cibl\xe9e.";
var Cred_LevelBreakdown_Teaching_Scale8_1 = "Fait preuve de capacit\xe9s de communication et relationnelles de base.";
var Cred_LevelBreakdown_Teaching_Scale8_2 = "Participe activement \xe0 la formation en groupe en demandant des conseils lorsque cela est n\xe9cessaire. Fait preuve d’attention et de compr\xe9hension pour recevoir des directives ou des informations de la part d’autres personnes.";
var Cred_LevelBreakdown_Teaching_Scale8_3 = "Utilise une bonne communication pour transmettre des connaissances et des comp\xe9tences sp\xe9cialis\xe9es aux autres. Fait preuve d’attention et de compr\xe9hension pour recevoir des directives ou des informations de la part d’autres personnes.";
var Cred_LevelBreakdown_Teaching_Scale8_4 = "Fait preuve de capacit\xe9s relationnelles sup\xe9rieures, en particulier d’une communication efficace des solutions \xe0 des probl\xe8mes complexes lorsque le sujet peut \xeatre sensible, controvers\xe9 ou susceptible d’\xeatre questionn\xe9 ou contest\xe9. Aide \xe0 \xe9laborer le travail en groupe.";
var Cred_LevelBreakdown_Teaching_Scale8_5 = "Fait preuve de capacit\xe9s relationnelles avanc\xe9es, notamment la capacit\xe9 de pr\xe9senter des faits et des circonstances complexes et de communiquer des solutions de mani\xe8re appropri\xe9e au contexte \xe0 des audiences interdisciplinaires. Agit de mani\xe8re anticipative en consid\xe9rant les int\xe9r\xeats et exigences d’autrui. \xc9value les cons\xe9quences possibles de m\xe9thodes de travail au sein d’\xe9quipes, forment ses coll\xe8gues et fournit des conseils p\xe9dagogiques.";
var Cred_LevelBreakdown_Teaching_Scale8_6 = "Fait preuve d’aptitudes relationnelles avanc\xe9es, notamment la capacit\xe9 de communiquer des m\xe9thodes, des technologies, des connaissances et des id\xe9es en d\xe9tail et avec clart\xe9. Ceci inclut la capacit\xe9 de pr\xe9sentation d’arguments et de solutions \xe0 des probl\xe8mes complexes, m\xeame lorsque le sujet est tr\xe8s difficile, inconnu ou technique. Dispense la formation pour le d\xe9veloppement professionnel de ses coll\xe8gues et agit de mani\xe8re anticipative pour r\xe9gler les probl\xe8mes au sein des \xe9quipes.";
var Cred_LevelBreakdown_Teaching_Scale8_7 = "Fait preuve de capacit\xe9s de communication appropri\xe9es pour mener des d\xe9bats d’experts en mati\xe8re de nouvelles id\xe9es ou de nouveaux probl\xe8mes. Promeut le d\xe9veloppement professionnel des autres de mani\xe8re cibl\xe9e. Peut cr\xe9er un consensus et appliquer des pratiques de n\xe9gociations dans un environnement de groupe.";
var Cred_LevelBreakdown_Teaching_Scale8_8 = "Fait preuve de niveaux profonds d’aptitudes relationnelles. En particulier, d’une bonne communication pour transmettre des connaissances et des comp\xe9tences sp\xe9cialis\xe9es aux autres. Anime des d\xe9bats interdisciplinaires et propose des contributions innovantes aux discussions professionnelles sp\xe9cialis\xe9es.";
var Cred_LevelBreakdown_Teamwork_1 = "Est capable de travailler en groupe dans des contextes habituels et stables.";
var Cred_LevelBreakdown_Teamwork_2 = "Fait preuve d’aptitudes relationnelles interm\xe9diaires.";
var Cred_LevelBreakdown_Teamwork_3 = "Travaille dans des groupes complexes et h\xe9t\xe9rog\xe8nes. Reconna\xeet les diff\xe9rentes perspectives ou approches au sein du domaine.";
var Cred_LevelBreakdown_Teamwork_4 = "Travaille et collabore dans des groupes complexes et h\xe9t\xe9rog\xe8nes. Reconna\xeet les diff\xe9rentes perspectives ou approches au sein du domaine.";
var Cred_LevelBreakdown_Teamwork_5 = "Planifie et structure les processus de travail de mani\xe8re collaborative, notamment dans des groupes h\xe9t\xe9rog\xe8nes. Renvoie une compr\xe9hension des diff\xe9rentes perspectives ou approches au sein du domaine.";
var Cred_LevelBreakdown_Teamwork_6 = "Assume la responsabilit\xe9 en travaillant dans des \xe9quipes d’experts et fait preuve de responsabilit\xe9 dans la gestion de groupes ou d’organisations.";
var Cred_LevelBreakdown_Teamwork_7 = "Prend la responsabilit\xe9 de diriger des groupes et des organisations dans le cadre de t\xe2ches complexes.";
var Cred_LevelBreakdown_Teamwork_8 = "Dirige des groupes et des organisations dans le cadre de t\xe2ches complexes ou interdisciplinaires en maximisant les domaines de potentiel de ces groupes ou organisations.";
var Cred_LevelBreakdown_Teamwork_Scale6_1 = "Est capable de travailler en groupe dans des contextes habituels et stables.";
var Cred_LevelBreakdown_Teamwork_Scale6_2 = "Fait preuve de capacit\xe9s interpersonnelles interm\xe9diaires dans des groupes complexes. Reconna\xeet diff\xe9rents points de vue ou approches dans le domaine.";
var Cred_LevelBreakdown_Teamwork_Scale6_3 = "Travaille et collabore dans des groupes complexes et h\xe9t\xe9rog\xe8nes. Refl\xe8te la compr\xe9hension des diff\xe9rents points de vue ou approches dans le domaine.";
var Cred_LevelBreakdown_Teamwork_Scale6_4 = "Planifie et structure les m\xe9thodes de travail de mani\xe8re collaborative, y compris au sein de groupes h\xe9t\xe9rog\xe8nes.";
var Cred_LevelBreakdown_Teamwork_Scale6_5 = "Assume des responsabilit\xe9s, tant au sein d’\xe9quipes d’experts que dans la gestion de groupes ou d’organisations.";
var Cred_LevelBreakdown_Teamwork_Scale6_6 = "Assume la responsabilit\xe9 de diriger des groupes ou des organisations dans le cadre de t\xe2ches complexes ou interdisciplinaires tout en maximisant les domaines de potentiel.";
var Cred_LevelBreakdown_Teamwork_Scale8_1 = "Est capable de travailler en groupe dans des contextes habituels et stables.";
var Cred_LevelBreakdown_Teamwork_Scale8_2 = "Fait preuve d’aptitudes relationnelles interm\xe9diaires.";
var Cred_LevelBreakdown_Teamwork_Scale8_3 = "Travaille dans des groupes complexes et h\xe9t\xe9rog\xe8nes. Reconna\xeet les diff\xe9rentes perspectives ou approches au sein du domaine.";
var Cred_LevelBreakdown_Teamwork_Scale8_4 = "Travaille et collabore dans des groupes complexes et h\xe9t\xe9rog\xe8nes. Reconna\xeet les diff\xe9rentes perspectives ou approches au sein du domaine.";
var Cred_LevelBreakdown_Teamwork_Scale8_5 = "Planifie et structure les processus de travail de mani\xe8re collaborative, notamment dans des groupes h\xe9t\xe9rog\xe8nes. Renvoie une compr\xe9hension des diff\xe9rentes perspectives ou approches au sein du domaine.";
var Cred_LevelBreakdown_Teamwork_Scale8_6 = "Assume des responsabilit\xe9s, tant au sein d’\xe9quipes d’experts que dans la gestion de groupes ou d’organisations.";
var Cred_LevelBreakdown_Teamwork_Scale8_7 = "Prend la responsabilit\xe9 de diriger des groupes et des organisations dans le cadre de t\xe2ches complexes.";
var Cred_LevelBreakdown_Teamwork_Scale8_8 = "Dirige des groupes et des organisations dans le cadre de t\xe2ches complexes ou interdisciplinaires en maximisant le potentiel de ces groupes ou organisations.";
var Cred_levelDescription_ViewAll = "Voir toutes les descriptions de niveaux";
var Cred_levelName1 = "D\xe9butant";
var Cred_levelName2 = "Novice";
var Cred_levelName3 = "Interm\xe9diaire";
var Cred_levelName4 = "Comp\xe9tent";
var Cred_levelName5 = "Exp\xe9riment\xe9";
var Cred_levelName6 = "Avanc\xe9";
var Cred_levelName7 = "\xc9m\xe9rite";
var Cred_levelName8 = "Expert";
var Cred_levelShortTitle = "Niveau {{level}}";
var Cred_levelSummary_Breakdown = "R\xe9partition des niveaux";
var Cred_levelSummary1 = "Au niveau\xa01, vous poss\xe9dez des connaissances g\xe9n\xe9rales sur certains aspects de la comp\xe9tence. Vous d\xe9couvrez les outils qui lui sont associ\xe9s et apprenez \xe0 les utiliser pour r\xe9aliser des t\xe2ches simples de routine. C’est dans un environnement structur\xe9 et sous supervision, avec des processus pr\xe9d\xe9finis et des crit\xe8res \xe9tablis pour \xe9valuer votre travail, que vous donnez vos meilleurs r\xe9sultats.";
var Cred_levelSummary2 = "Au niveau\xa02, vous avez acquis des connaissances fondamentales et pratiques dans votre domaine de comp\xe9tence. Vous savez qu’il vous reste encore beaucoup \xe0 apprendre, mais vous comprenez les bases. Vous \xeates capable de r\xe9soudre des probl\xe8mes simples et de r\xe9aliser des t\xe2ches de mani\xe8re autonome, mais vous aurez sans doute besoin d’aide si un probl\xe8me complexe se pr\xe9sente.";
var Cred_levelSummary3 = "Au niveau\xa03, vous avez \xe9largi vos connaissances au-del\xe0 des fondamentaux et vous approfondissez maintenant la th\xe9orie de votre domaine de comp\xe9tence. Vous utilisez les outils du m\xe9tier avec aisance tout en continuant d’enrichir vos comp\xe9tences techniques. Dans l’ensemble, vous \xeates capable de travailler en toute autonomie sur de nouveaux d\xe9fis. Vous ma\xeetrisez suffisamment vos comp\xe9tences pour faire preuve d’autocritique et faire la diff\xe9rence entre un bon et un excellent travail. Vous arrivez \xe9galement \xe0 fixer vos propres objectifs pour mesurer la progression accomplie.";
var Cred_levelSummary4 = "Au niveau\xa04, vous \xeates un professionnel comp\xe9tent et vous utilisez un large \xe9ventail de m\xe9thodes pour r\xe9soudre les probl\xe8mes, de la planification \xe0 l’ex\xe9cution. Vous \xeates capable d’accomplir des t\xe2ches plus sp\xe9cialis\xe9es et de mettre vos comp\xe9tences au service de probl\xe8mes complexes pouvant exiger un processus in\xe9dit ou une nouvelle approche. Vous savez travailler sur des projets complexes en toute autonomie, et une fois ces projets accomplis, vous \xeates en mesure d’\xe9valuer votre propre travail pour d\xe9terminer s’il a port\xe9 ses fruits.";
var Cred_levelSummary5 = "Au niveau\xa05, vous poss\xe9dez des connaissances solides et probablement sp\xe9cialis\xe9es dans votre domaine de comp\xe9tence. Vous avez maintenant plusieurs r\xe9ussites \xe0 votre actif et pouvez mettre un large \xe9ventail de comp\xe9tences cognitives ou pratiques au service de probl\xe8mes nouveaux et complexes. Vous \xeates capable de diriger une initiative jusqu’\xe0 sa conclusion.";
var Cred_levelSummary6 = "Au niveau\xa06, vous ma\xeetrisez le savoir, les connaissances th\xe9oriques, les outils, la m\xe9thodologie et les processus propres \xe0 votre domaine de comp\xe9tence. Vous \xeates non seulement capable d’utiliser ces connaissances pour r\xe9soudre n’importe quel probl\xe8me, mais \xe9galement de les communiquer clairement \xe0 autrui.";
var Cred_levelSummary7 = "Au niveau\xa07, vous aimez innover et votre travail n’a pas d’\xe9gal dans votre domaine, \xe0 tel point que c’est vous qui en dictez les tendances. Vous utilisez les outils \xe0 votre disposition de fa\xe7on si complexe et exp\xe9rimentale que tous sollicitent vos conseils. Vous disposez certainement aussi d’une expertise dans un ou plusieurs autres domaines de pointe ou hautement sp\xe9cialis\xe9s.";
var Cred_levelSummary8 = "Au niveau\xa08, votre connaissance et votre vision unique du domaine sont ardemment sollicit\xe9es. Vous anticipez les tendances majeures de l’avenir de votre secteur et leur impact sur les personnes, les outils, les technologies, les processus et le monde dans son ensemble. Reconnu comme un leader international dans votre domaine, vous \xe9laborez de nouvelles normes et pratiques, et votre capacit\xe9 d’innovation d\xe9passe celle de la majorit\xe9 de vos homologues.";
var Cred_levelTitle = "Niveau {{level}}\xa0: {{name}}";
var Cred_NextStep = "\xc9tape suivante";
var Cred_NoComparison_Header = "Evaluer des pairs";
var Cred_NoComparison_Instructions = "Vous avez de la chance\xa0! Notre formidable algorithme indique parfois que nous n’avons pas besoin d’\xe9valuations suppl\xe9mentaires de la part des pairs. Vous pouvez donc passer \xe0 l’\xe9tape suivante\xa0!";
var Cred_NoComparison_NoReviewsNeeded = "Pas d’\xe9valuations de pairs requises\xa0!";
var Cred_Overview_CompletePeerReviews = "\xc9valuer des pairs";
var Cred_Overview_EditApplication = "Modifier la demande";
var Cred_Overview_EditApplicationInstructions = "Vous pouvez modifier votre demande jusqu’au {{date}} \xe0 {{time}}.";
var Cred_Overview_Instructions = "Bienvenue dans Degreed Skill Certification pour la comp\xe9tence \xab\xa0{{skill}}\xa0\xbb. Vous devrez fournir des preuves de vos comp\xe9tences, qui seront ensuite examin\xe9es par des approbateurs, des pairs et notre panel d’experts pour d\xe9terminer votre niveau de comp\xe9tence. Vous participerez \xe9galement \xe0 l’\xe9valuation de vos pairs. Regardez la vid\xe9o pour en savoir plus sur le processus, ou commencez d\xe8s maintenant\xa0!";
var Cred_Overview_NextActions = "Prochaines actions";
var Cred_Overview_NextDeadline = "Prochaine \xe9ch\xe9ance";
var Cred_Overview_OptionalActions = "Actions facultatives";
var Cred_Overview_SubmitApplication = "Soumettre la demande";
var Cred_Overview_SubmitApplicationInstructions = "Soumettez votre demande avant la date limite. Si vous n’y parvenez pas, une autre date limite sera fix\xe9e le mois suivant.";
var Cred_Overview_Title = "Pr\xe9sentation de la certification de comp\xe9tence";
var Cred_PaymentNotSupported = "Le paiement de la certification des comp\xe9tences n’est actuellement pas pris en charge dans l’UE. Veuillez envoyer un e-mail \xe0 info@degreed.com pour activer votre demande de certification des comp\xe9tences.";
var Cred_SkillBehavior_Original = "Le texte original de ces comp\xe9tences comportementales dans";
var Cred_SkillBehavior_Translated = "REMARQUE\xa0: le texte pour ces comp\xe9tences comportementales a \xe9t\xe9 traduit de";
var Cred_Status_AddNewEndorser = "Ajouter un nouvel approbateur";
var Cred_Status_ApplyCode = "Appliquez le code promotionnel ci-dessus.";
var Cred_Status_CheckoutBtn = "Proc\xe9der au paiement";
var Cred_Status_DateCompletedFormat = "Approbation termin\xe9e le {{date}}";
var Cred_Status_DateDeclinedFormat = "Demande refus\xe9e le {{date}}";
var Cred_Status_DegreedReviewed = "Examen par des experts Degreed";
var Cred_Status_DegreedReviewedDescription = "Notre panel d’experts n’a pas encore examin\xe9 votre demande.";
var Cred_Status_DegreedReviewedDescriptionCompleted = "Notre panel d’experts a termin\xe9 d’examiner votre demande.";
var Cred_Status_EditInfo = "Modifier les informations";
var Cred_Status_EndorserAdded = "Approbateur ajout\xe9 et invitation d’approbation envoy\xe9e\xa0!";
var Cred_Status_EndorserHasntResponded = "N’a pas encore r\xe9pondu";
var Cred_Status_Endorsers_Desc = "Vous devez disposer d’au moins une approbation compl\xe8te pour recevoir votre certificat.";
var Cred_Status_EndorsersHeading = "Approbateurs";
var Cred_Status_EndorserUpdated = "Approbateur mis \xe0 jour\xa0! Une invitation a \xe9t\xe9 transmise si une nouvelle adresse e-mail a \xe9t\xe9 sp\xe9cifi\xe9e";
var Cred_Status_Header = "Statut de l’examen de la demande";
var Cred_Status_Instructions1 = "Nous vous f\xe9licitons d’\xeatre arriv\xe9(e) jusqu’ici ! Vous pouvez consulter le statut de votre demande ci-dessous. Une fois que vous aurez re\xe7u les approbations n\xe9cessaires, vous aurez termin\xe9\xa0! Prenez une pause bien m\xe9rit\xe9e !";
var Cred_Status_Instructions2 = "Si vos approbateurs n’ont pas r\xe9pondu ou ont refus\xe9 de donner leur approbation, vous pouvez renvoyer la demande ou mettre \xe0 jour les approbateurs ci-dessous.";
var Cred_Status_InvitationSent = "Invitation d’approbation envoy\xe9e !";
var Cred_Status_PaymentDescription = "Processus de certification de comp\xe9tence Degreed";
var Cred_Status_PaymentHeading = "Paiement";
var Cred_Status_PeerReviewed = "\xc9valuation de votre demande par des pairs";
var Cred_Status_PeerReviewedDescription = "L’\xe9valuation par vos pairs est toujours en cours.";
var Cred_Status_PeerReviewedDescriptionCompleted = "Vos pairs ont termin\xe9 de vous \xe9valuer.";
var Cred_Status_Resend = "Renvoyer l’invitation";
var Cred_Status_ReviewsHeading = "\xc9valuations";
var Cred_Status_ScAwarded = "Bourse accord\xe9e\xa0!";
var Cred_Status_ScAwardedDescription = "Aucun paiement n’est requis.";
var Cred_Status_ScNotAwarded = "Paiement requis";
var Cred_Status_ScNotAwardedDescription = "La bourse n’a pas \xe9t\xe9 d\xe9livr\xe9e, mais vous avez obtenu une r\xe9duction\xa0!";
var Cred_Status_ScPending = "Bourse en attente";
var Cred_Status_ScPendingDescription = "Si votre bourse est approuv\xe9e, vous n’aurez pas \xe0 payer pour soumettre la demande. Dans le cas contraire, vous obtiendrez une r\xe9duction.";
var Cred_Status_SkipEndorser = "Poursuivre la certification avec {{endorserCount}}\xa0approbateur(s)";
var Cred_Status_WaitingOnEndorser = "En attente de l’approbateur";
var Cred_Submit_AppliedCodeText = "Appliqu\xe9";
var Cred_Submit_ApplyCodeText = "Appliquer le code";
var Cred_Submit_Header = "Mentions l\xe9gales et paiement";
var Cred_Submit_HeaderWithCredits = "Mentions l\xe9gales et soumission";
var Cred_Submit_IAgreeGenuine = "J’accepte que ma demande soit \xe9valu\xe9e par d’autres personnes.";
var Cred_Submit_PaymentBillingInfo = "Informations de facturation";
var Cred_Submit_PaymentCard = "Num\xe9ro de carte";
var Cred_Submit_PaymentCardValidation = "Le num\xe9ro de carte doit \xeatre renseign\xe9";
var Cred_Submit_PaymentChoosePayment = "S\xe9lectionner le mode de paiement";
var Cred_Submit_PaymentConfirm = "Confirmer le paiement";
var Cred_Submit_PaymentCurrency = "$";
var Cred_Submit_PaymentCvv = "Cryptogramme visuel";
var Cred_Submit_PaymentError = "Paiement non soumis";
var Cred_Submit_PaymentExp = "Date d’expiration";
var Cred_Submit_PaymentExpPlaceholder = "MM/AA";
var Cred_Submit_PaymentExpValidation = "La date d’expiration doit \xeatre renseign\xe9e";
var Cred_Submit_PaymentFirstName = "Pr\xe9nom";
var Cred_Submit_PaymentFirstNameValidation = "Le pr\xe9nom doit \xeatre renseign\xe9";
var Cred_Submit_PaymentHeader = "Paiement";
var Cred_Submit_PaymentLastName = "Nom";
var Cred_Submit_PaymentLastNameValidation = "Le nom doit \xeatre renseign\xe9";
var Cred_Submit_PaymentNotRequired = "Aucun paiement requis\xa0!";
var Cred_Submit_PaymentProvidedBy = "Code promotionnel";
var Cred_Submit_PaymentReceived = "Le paiement a bien \xe9t\xe9 re\xe7u. Merci.";
var Cred_Submit_PlagiarismCheck = "Je d\xe9clare que les informations fournies proviennent uniquement de mes travaux et confirme avoir fourni les citations ad\xe9quates.";
var Cred_Submit_PlagiarismDescription = "Degreed se r\xe9serve le droit d’examiner votre demande pour v\xe9rifier l’absence de plagiat. Veillez \xe0 ne soumettre que du contenu original et \xe0 citer vos sources si n\xe9cessaire.";
var Cred_Submit_PlagiarismHeader = "Contr\xf4le de plagiat";
var Cred_Submit_PromoCodeExpand = "Vous avez un code promotionnel ? Saisissez-le ici.";
var Cred_Submit_PromoNotFound = "Code promotionnel introuvable";
var Cred_Submit_PromoProductError = "Le code promotionnel utilis\xe9 n’est pas valide pour le produit s\xe9lectionn\xe9. Faites une nouvelle s\xe9lection ci-dessus ou entrez un nouveau code.";
var Cred_Submit_ReviewedByDescription = "Vos comportements li\xe9s \xe0 la comp\xe9tence et les preuves associ\xe9es seront examin\xe9s par d’autres candidats, par les approbateurs que vous avez choisis et par notre panel d’experts. En joignant des \xe9l\xe9ments de preuve, vous autorisez les autres candidats, les approbateurs et le panel d’experts \xe0 consulter ces \xe9l\xe9ments autant de fois que n\xe9cessaire pour \xe9valuer votre niveau de comp\xe9tence.";
var Cred_Submit_ReviewedByHeader = "D’autres personnes vous \xe9valueront";
var Cred_Submit_SaveApplication = "Enregistrer la demande";
var Cred_Submit_ScholarshipCode = "Code promotionnel";
var Cred_Submit_ScholarshipDiscount = "R\xe9duction promotionnelle";
var Cred_Submit_SecurePayment = "Paiement s\xe9curis\xe9";
var Cred_Submit_SkillProcessName = "Processus de certification de comp\xe9tence Degreed";
var Cred_Submit_SubmitApplication = "Soumettre la demande";
var Cred_Submit_SubTotal = "Total";
var Cred_Submit_TermsAgree = "J’ai lu et j’accepte l’accord de soumission des preuves.";
var Cred_Submit_TermsDescription = "En soumettant des preuves de vos comp\xe9tences en vue d’une certification, vous garantissez\xa0: que vous avez lu et compris le code d’honneur de Degreed et que vous l’acceptez\xa0; que vous \xeates l’unique propri\xe9taire du contenu ou, si ce n’est pas le cas et que d’autres personnes ont contribu\xe9 \xe0 son \xe9laboration, que vous disposez de tous les droits, consentements et autorisations n\xe9cessaires pour soumettre ces preuves et fournir ces d\xe9clarations et garanties\xa0; qu’aucun contenu ne comporte d’informations confidentielles ou exclusives appartenant \xe0 un tiers (y compris un employeur)\xa0; que vous assumez l’enti\xe8re responsabilit\xe9 de tout contenu que vous fournissez ou soumettez, et que ce dernier est conforme aux lois applicables et n’est pas ill\xe9gal, abusif, diffamatoire, obsc\xe8ne, contrevenant, mena\xe7ant, faux, trompeur ou autrement inappropri\xe9, tel que d\xe9termin\xe9 \xe0 la seule discr\xe9tion de Degreed\xa0; et que vous vous conformez \xe0 toutes les conditions g\xe9n\xe9rales de Degreed relatives \xe0 l’utilisation de ce service.";
var Cred_Submit_TermsHeader = "Accord de soumission des preuves";
var Cred_Success_Heading = "Demande soumise avec succ\xe8s";
var Cred_Success_Instructions = "<p>Votre demande a bien \xe9t\xe9 soumise. Les \xe9tapes suivantes se d\xe9roulent apr\xe8s la date limite de soumission pour votre comp\xe9tence. Vous pouvez apporter les derni\xe8res modifications \xe0 votre demande jusqu’\xe0 la date limite, apr\xe8s quoi vos approbateurs seront contact\xe9s et vous passerez \xe0 la phase suivante du processus. Vous pouvez v\xe9rifier la date limite de soumission et consulter les \xe9tapes \xe0 venir sur la {{linkStartHtml}}page Vue d’ensemble{{linkEndHtml}}.</p>\n<p>Nous contacterons vos approbateurs par e-mail apr\xe8s la date limite de soumission fix\xe9e au {{date}}.</p>\n<p>Nous vous enverrons \xe9galement un e-mail lorsqu’il sera temps de passer \xe0 l’\xe9tape suivante\xa0!</p>";
var Cred_Success_InviteOthers = "Vous pouvez acc\xe9l\xe9rer le processus en invitant d’autres personnes \xe0 soumettre leur candidature.";
var Cred_Success_SubHeading = "Tr\xe8s bon travail\xa0!";
var Cred_Verify_CodeLabel = "Code de certificat Degreed";
var Cred_Verify_FollowupLabel = "O\xf9 avez-vous trouv\xe9 ce certificat\xa0?";
var Cred_Verify_FollowupPlaceholder = "Saisissez le lien menant vers la page Web ou les coordonn\xe9es de la personne qui a fourni ce certificat.";
var Cred_Verify_FollowupSuccess = "Merci.";
var Cred_Verify_Heading = "V\xe9rifier le certificat";
var Cred_Verify_Instructions = "Chaque certificat Degreed poss\xe8de un code unique que vous pouvez utiliser pour contr\xf4ler sa validit\xe9. Ce code se trouve dans le coin inf\xe9rieur droit du certificat. Il vous indiquera \xe0 quel certificat il correspond pour que vous puissiez v\xe9rifier ce dernier.";
var Cred_Verify_InvalidInstructions = "Ce code ne correspond \xe0 aucun certificat valide. Veuillez indiquer sa source pour que nous puissions mener une enqu\xeate plus approfondie.";
var Cred_Verify_InvalidMessage = "Ce certificat n’est pas valide.";
var Cred_Verify_ValidMessage = "Ce certificat est valide.";
var Cred_Verify_VerifyCodeButton = "V\xe9rifier le code";
var Cred_Wait_Heading = "Demande soumise avec succ\xe8s";
var Cred_Wait_Instructions = "Nous avons bien re\xe7u votre demande. Vous serez \xe9valu\xe9 par dix pairs. Nous attendons que d’autres personnes postulent \xe0 cette comp\xe9tence avant de continuer. Allez boire un caf\xe9 bien m\xe9rit\xe9. Nous vous enverrons une confirmation lorsque vous pourrez poursuivre l’\xe9valuation de vos pairs.";
var Cred_Wait_InviteOthers = "Vous pouvez acc\xe9l\xe9rer le processus en invitant d’autres personnes \xe0 soumettre leur candidature.";
var Cred_Wait_SubHeading = "Il ne reste plus qu’\xe0 patienter…";
var CredAcceptCtrl_AgreeLabel = "J’accepte le code d’honneur.";
var CredAcceptCtrl_AgreeValidationMessage = "Vous devez accepter le code d’honneur pour pouvoir continuer.";
var CredAcceptCtrl_Header = "Accepter le code d’honneur";
var CredAcceptCtrl_HonorCodeDescription = '<p class="par">Tous les utilisateurs inscrits au service Degreed et souhaitant obtenir une certification de comp\xe9tence doivent accepter et respecter en permanence le code d’honneur de Degreed, en particulier lors de la soumission de preuves ou de tout autre contenu \xe0 des fins d’\xe9valuation. En demandant une certification, vous d\xe9clarez et garantissez que vous comprenez et respectez le code d’honneur de Degreed.</p>\n\n<p class="par">Degreed ne tol\xe9rera aucune des activit\xe9s suivantes\xa0:</p>\n\n<ul class="par bullets guts-m-b-3">\n    <li>Plagiat (ou toute utilisation non autoris\xe9e du travail d’une autre personne pr\xe9sent\xe9 comme le v\xf4tre)</li>\n    <li>Mensonge ou tricherie</li>\n    <li>Fabrication et falsification de contenu</li>\n    <li>Aide non autoris\xe9e</li>\n    <li>Utilisation abusive de contenu</li>\n    <li>Participation \xe0 un comportement malhonn\xeate</li>\n    <li>Divulgation d’informations confidentielles ou exclusives</li>\n</ul>\n\n<p class="par">Participer \xe0 des activit\xe9s interdites peut entra\xeener l’une des cons\xe9quences suivantes, d\xe9termin\xe9es uniquement par Degreed sans aucune obligation, financi\xe8re ou autre, envers vous\xa0:</p>\n\n<ul class="par bullets guts-m-b-3">\n    <li>Refus d’attribuer la certification</li>\n    <li>R\xe9vocation de la certification</li>\n    <li>Fermeture du compte Degreed et de tout autre compte ouvert ult\xe9rieurement sans l’accord \xe9crit de Degreed (ne comprend pas ce qui a \xe9t\xe9 g\xe9n\xe9r\xe9 lors de la cr\xe9ation du compte)</li>\n</ul>\n\n<p class="par">Degreed peut, \xe0 sa seule discr\xe9tion, mettre ponctuellement \xe0 jour ce code d’honneur. En effectuant une soumission apr\xe8s une modification du code d’honneur, vous reconnaissez et acceptez les conditions mises \xe0 jour.</p>';
var CredAcceptCtrl_Instructions = "Lisez attentivement le code d’honneur ci-dessous. Si vous l’acceptez, cochez la case situ\xe9e plus bas. Vous devez accepter le code d’honneur pour pouvoir obtenir une certification de comp\xe9tence de la part de Degreed.";
var CredAcceptCtrl_Submit = "Enregistrer et continuer";
var CredAcceptCtrl_Title = "Code d’honneur de Degreed";
var CredApplyOverviewCtrl_ApplicationDeleted = "Votre demande a \xe9t\xe9 supprim\xe9e. Veuillez patienter pendant que nous vous redirigeons.";
var CredApplyOverviewCtrl_DeletePrompt = "Souhaitez-vous r\xe9ellement supprimer votre demande\xa0?";
var CredApplyOverviewCtrl_MinReqsMet = "Conditions minimales remplies";
var CredApplyOverviewCtrl_MinReqsNotMet = "Conditions minimales non remplies";
var CredentialAwardedEmail_Autonomy = "Autonomie";
var CredentialAwardedEmail_Autonomy1Desc = "Vous pr\xe9f\xe9rez travailler dans un cadre structur\xe9 et supervis\xe9, dot\xe9 de processus pr\xe9d\xe9termin\xe9s et de crit\xe8res de productivit\xe9 bien d\xe9finis.";
var CredentialAwardedEmail_Autonomy2Desc = "Vous \xeates capable de r\xe9soudre des probl\xe8mes simples et d’accomplir des t\xe2ches en toute autonomie. Cependant, vous \xeates susceptible d’avoir besoin d’aide si un probl\xe8me plus compliqu\xe9 surgit. ";
var CredentialAwardedEmail_Autonomy3Desc = "Vous \xeates capable de r\xe9soudre des probl\xe8mes simples et d’accomplir des t\xe2ches en toute autonomie. Cependant, vous \xeates susceptible d’avoir besoin d’aide si un probl\xe8me plus compliqu\xe9 surgit. ";
var CredentialAwardedEmail_Autonomy4Desc = "Vous \xeates capable de r\xe9soudre des probl\xe8mes simples et d’accomplir des t\xe2ches en toute autonomie. Cependant, vous \xeates susceptible d’avoir besoin d’aide si un probl\xe8me plus compliqu\xe9 surgit. ";
var CredentialAwardedEmail_Autonomy5Desc = "Vous \xeates capable de r\xe9soudre des probl\xe8mes simples et d’accomplir des t\xe2ches en toute autonomie. Cependant, vous \xeates susceptible d’avoir besoin d’aide si un probl\xe8me plus compliqu\xe9 surgit. ";
var CredentialAwardedEmail_Autonomy6Desc = "Vous savez travailler en autonomie sur des projets particuli\xe8rement complexes. Votre point de vue unique vous permet de r\xe9soudre des probl\xe8mes \xe9pineux et de proposer des innovations pour faire progresser votre domaine d’activit\xe9. Vous savez faire comprendre les probl\xe8mes, proposer des solutions et diriger une \xe9quipe de professionnels.";
var CredentialAwardedEmail_Autonomy7Desc = "Vous avez certainement \xe9t\xe9 \xe0 la t\xeate d’importants projets dont l’objectif \xe9tait de repousser les limites de votre domaine. Que vous soyez praticien ou que vous occupiez un r\xf4le de leader \xe0 temps plein, votre point de vue est respect\xe9 par tous les acteurs de votre domaine.";
var CredentialAwardedEmail_Autonomy8Desc = "Vous \xeates totalement autonome et vos pairs vous consid\xe8rent comme un chercheur et un leader du secteur. Vous choisissez les projets sur lesquels vous souhaitez travailler et vous optez pour ceux qui vous permettront d’avoir un maximum d’impact dans votre domaine afin de proposer de nouvelles id\xe9es ou pratiques.";
var CredentialAwardedEmail_Industry = "Secteur";
var CredentialAwardedEmail_Industry1Desc = "Vous d\xe9couvrez le secteur, son histoire, ses bonnes pratiques et ses d\xe9fis.";
var CredentialAwardedEmail_Industry2Desc = "Vous vous familiarisez de plus en plus avec les bonnes pratiques, le jargon, les tendances et la technologie du secteur.";
var CredentialAwardedEmail_Industry3Desc = "Vous vous familiarisez de plus en plus avec les bonnes pratiques, le jargon, les tendances et la technologie du secteur.";
var CredentialAwardedEmail_Industry4Desc = "Vous vous familiarisez de plus en plus avec les bonnes pratiques, le jargon, les tendances et la technologie du secteur.";
var CredentialAwardedEmail_Industry5Desc = "Vous vous familiarisez de plus en plus avec les bonnes pratiques, le jargon, les tendances et la technologie du secteur.";
var CredentialAwardedEmail_Industry6Desc = "Votre secteur n’a plus de secrets pour vous et vous savez pr\xe9cis\xe9ment de quoi sera fait son avenir. Vous savez \xe9galement en quoi votre travail affecte d’autres domaines.";
var CredentialAwardedEmail_Industry7Desc = "Votre domaine se caract\xe9rise par des changements impr\xe9visibles. Vous savez vous adapter \xe0 ces changements et prendre des d\xe9cisions strat\xe9giques. Puisque vous \xeates \xe0 la t\xeate de votre domaine, nombreux sont ceux qui sollicitent vos conseils en mati\xe8re de d\xe9fis et de sp\xe9cialisations ou qui souhaitent avoir votre avis au sujet des derni\xe8res \xe9volutions et de l’avenir de votre secteur. ";
var CredentialAwardedEmail_Industry8Desc = "Votre secteur tire pleinement parti de votre contribution en mati\xe8re de leadership et d’innovation. Votre travail est souvent qualifi\xe9 d’avant-gardiste par vos pairs et vous \xeates l’une des personnes les plus influentes dans votre domaine. Vous avez toutes les cartes en main pour cr\xe9er les outils de demain qui permettront de r\xe9soudre les principaux d\xe9fis auxquels votre secteur est confront\xe9. Vous avez une id\xe9e de ce que les dix prochaines ann\xe9es apporteront \xe0 votre domaine.<br /><br />\xc0 ce titre, vous \xeates donc consid\xe9r\xe9 comme un leader, un guide et un mentor.";
var CredentialAwardedEmail_Knowledge = "Connaissances";
var CredentialAwardedEmail_Knowledge1Desc = "Vous disposez de connaissances g\xe9n\xe9rales sur certains aspects de la comp\xe9tence.";
var CredentialAwardedEmail_Knowledge2Desc = "Vous avez acquis les connaissances de base de votre domaine de comp\xe9tences et savez les mettre en pratique, m\xeame si le chemin est encore long.";
var CredentialAwardedEmail_Knowledge3Desc = "Vous avez acquis les connaissances de base de votre domaine de comp\xe9tences et savez les mettre en pratique, m\xeame si le chemin est encore long.";
var CredentialAwardedEmail_Knowledge4Desc = "Vous avez acquis les connaissances de base de votre domaine de comp\xe9tences et savez les mettre en pratique, m\xeame si le chemin est encore long.";
var CredentialAwardedEmail_Knowledge5Desc = "Vous avez acquis les connaissances de base de votre domaine de comp\xe9tences et savez les mettre en pratique, m\xeame si le chemin est encore long.";
var CredentialAwardedEmail_Knowledge6Desc = "Vous ma\xeetrisez le savoir, les connaissances th\xe9oriques, les outils, la m\xe9thodologie et les processus propres \xe0 votre domaine de comp\xe9tence. Vous \xeates non seulement capable d’utiliser ces connaissances pour r\xe9soudre n’importe quel probl\xe8me, mais \xe9galement de les communiquer clairement \xe0 autrui.";
var CredentialAwardedEmail_Knowledge7Desc = "Vous disposez de connaissances approfondies sur les th\xe9ories actuelles (y compris leurs limites) et tirez pleinement parti des connaissances sp\xe9cialis\xe9es, m\xe9thodes de recherche et approches dont vous disposez pour faire face \xe0 diff\xe9rents cas de figure. Vous envisagez les obstacles qui se pr\xe9sentent sur votre chemin dans toute leur complexit\xe9 et trouvez des solutions que d’autres n’h\xe9siteront pas \xe0 utiliser ou imiter \xe0 leur tour. Vous disposez \xe9galement de connaissances qui vont au-del\xe0 de votre domaine d’expertise et \xeates capable de les mettre au service de votre secteur d’activit\xe9.";
var CredentialAwardedEmail_Knowledge8Desc = "Au niveau\xa08, votre connaissance et votre vision unique du domaine sont ardemment sollicit\xe9es. Vous anticipez les tendances majeures de l’avenir de votre secteur et leur impact sur les personnes, les outils, les technologies, les processus et le monde dans son ensemble. R\xe9flexion strat\xe9gique, pens\xe9e scientifique et esprit cr\xe9atif font donc partie de vos comp\xe9tences, et vous \xeates tr\xe8s certainement \xe0 la t\xeate de votre domaine.<br /><br />Vous avez une fa\xe7on bien \xe0 vous de r\xe9soudre les probl\xe8mes, d’apporter des solutions, d’atteindre des r\xe9sultats et de d\xe9velopper l’ensemble de connaissances existantes, y compris les connaissances sp\xe9cialis\xe9es qui ont trait \xe0 d’autres domaines, comp\xe9tences et disciplines.";
var CredentialAwardedEmail_LearnMore = "Tirez pleinement parti de votre certification";
var CredentialAwardedEmail_LearnMoreDescFormat = "F\xe9licitations\xa0! Votre certificat est d\xe9sormais disponible sur Degreed. Maintenant que vous l’avez re\xe7u, vous pouvez en apprendre davantage sur votre niveau et commencer \xe0 partager votre expertise. Suivez le lien ci-dessous pour\xa0:<br/> <br/>  <ul>  <li>afficher et t\xe9l\xe9charger votre certificat\xa0;</li>  <li>l’ajouter \xe0 votre profil LinkedIn\xa0;</li>  <li>le partager sur les r\xe9seaux sociaux\xa0;</li>  <li>l’indiquer sur votre CV\xa0;</li>  <li>d\xe9couvrir les diff\xe9rents niveaux.</li>  </ul>";
var CredentialAwardedEmail_Level10Desc = "<strong>Connaissances</strong>\n<br />Vous poss\xe9dez des connaissances g\xe9n\xe9rales sur certains aspects de la comp\xe9tence.\n<br /><br />\n<b>T\xe2ches et outils</b>\n<br />Vous d\xe9couvrez les outils associ\xe9s \xe0 la comp\xe9tence et apprenez \xe0 les utiliser pour r\xe9aliser des t\xe2ches simples de routine.\n<br /><br /><b>Autonomie</b>\n<br />C’est dans un environnement structur\xe9 et sous supervision, avec des processus pr\xe9d\xe9finis et des crit\xe8res \xe9tablis pour \xe9valuer votre travail, que vous donnez vos meilleurs r\xe9sultats.\n<br /><br /><b>Secteur</b>\n<br />Vous d\xe9couvrez le secteur et vous vous familiarisez avec son histoire, ses bonnes pratiques et ses d\xe9fis.\n<br /><br /><b>Pour passer au niveau sup\xe9rieur</b>\n<br /><ul>\n<li>Assimilez autant d’informations que possible. N’h\xe9sitez pas \xe0 tirer pleinement profit des opportunit\xe9s d’apprentissage qui s’offrent \xe0 vous pour gravir les \xe9chelons et devenir un expert dans votre domaine. </li>\n<li>Soyez attentif. Glanez des informations aupr\xe8s des experts de votre secteur via les blogs, webinaires, newsletters, conf\xe9rences\xa0TED, forums de questions-r\xe9ponses et autres ressources disponibles.</li>\n<li>Tirez profit des vid\xe9os, livres, cours et autres ressources \xe0 votre disposition.</li>\n<li>Avant de vous lancer, demandez conseil \xe0 des professionnels du secteur.</li>\n</ul>";
var CredentialAwardedEmail_Level1Desc = "Au niveau\xa01, vous poss\xe9dez des connaissances g\xe9n\xe9rales sur certains aspects de la comp\xe9tence. Vous d\xe9couvrez les outils qui lui sont associ\xe9s et apprenez \xe0 les utiliser pour r\xe9aliser des t\xe2ches simples de routine. C’est dans un environnement structur\xe9 et sous supervision, avec des processus pr\xe9d\xe9finis et des crit\xe8res \xe9tablis pour \xe9valuer votre travail, que vous donnez vos meilleurs r\xe9sultats.";
var CredentialAwardedEmail_Level1Intro = "F\xe9licitations\xa0! Vous avez obtenu une certification de comp\xe9tence Degreed en {0}. Le niveau\xa01 vous a \xe9t\xe9 attribu\xe9, soit <b>D\xe9butant</b>.";
var CredentialAwardedEmail_Level1Title = "Niveau\xa01\xa0: D\xe9butant";
var CredentialAwardedEmail_Level2Desc = "Vous avez acquis des connaissances fondamentales et pratiques dans votre comp\xe9tence. Vous savez qu’il vous reste encore beaucoup \xe0 apprendre, mais vous comprenez les bases. Vous \xeates capable de r\xe9soudre des probl\xe8mes simples et de r\xe9aliser des t\xe2ches de mani\xe8re autonome, mais vous aurez sans doute besoin d’aide si un probl\xe8me complexe se pr\xe9sente.";
var CredentialAwardedEmail_Level2Intro = "F\xe9licitations\xa0! Vous avez obtenu une certification de comp\xe9tence Degreed en {0}. Le niveau\xa02 vous a \xe9t\xe9 attribu\xe9, soit <b>Novice</b>.";
var CredentialAwardedEmail_Level2Title = "Niveau\xa02\xa0: Novice";
var CredentialAwardedEmail_Level3Desc = "Au niveau\xa03, vous avez \xe9largi vos connaissances au-del\xe0 des fondamentaux et vous approfondissez maintenant la th\xe9orie de votre domaine de comp\xe9tence. Vous utilisez les outils du m\xe9tier avec aisance tout en continuant d’enrichir vos comp\xe9tences techniques. Dans l’ensemble, vous \xeates capable de travailler en toute autonomie sur de nouveaux d\xe9fis. Vous ma\xeetrisez suffisamment vos comp\xe9tences pour faire preuve d’autocritique et faire la diff\xe9rence entre un bon et un excellent travail. Vous arrivez \xe9galement \xe0 fixer vos propres objectifs pour mesurer la progression accomplie.";
var CredentialAwardedEmail_Level3Intro = "F\xe9licitations\xa0! Vous avez obtenu une certification de comp\xe9tence Degreed en {0}. Le niveau\xa03 vous a \xe9t\xe9 attribu\xe9, soit Interm\xe9diaire.";
var CredentialAwardedEmail_Level3Title = "Niveau\xa03\xa0: interm\xe9diaire";
var CredentialAwardedEmail_Level4Desc = "Au niveau\xa04, vous \xeates un professionnel comp\xe9tent et vous utilisez un large \xe9ventail de m\xe9thodes pour r\xe9soudre les probl\xe8mes, de la planification \xe0 l’ex\xe9cution. Vous \xeates capable d’accomplir des t\xe2ches plus sp\xe9cialis\xe9es et de mettre vos comp\xe9tences au service de probl\xe8mes complexes pouvant exiger un processus in\xe9dit ou une nouvelle approche. Vous savez travailler sur des projets complexes en toute autonomie, et une fois ces projets accomplis, vous \xeates en mesure d’\xe9valuer votre propre travail pour d\xe9terminer s’il a port\xe9 ses fruits.";
var CredentialAwardedEmail_Level4Intro = "F\xe9licitations\xa0! Vous avez obtenu une certification de comp\xe9tence Degreed en {0}. Le niveau\xa04 vous a \xe9t\xe9 attribu\xe9, soit <b>Comp\xe9tent</b>.";
var CredentialAwardedEmail_Level4Title = "Niveau\xa04\xa0: Comp\xe9tent";
var CredentialAwardedEmail_Level5Desc = "Au niveau\xa05, vous poss\xe9dez des connaissances solides et probablement sp\xe9cialis\xe9es dans votre domaine de comp\xe9tence. Vous avez maintenant plusieurs r\xe9ussites \xe0 votre actif et pouvez mettre un large \xe9ventail de comp\xe9tences cognitives ou pratiques au service de probl\xe8mes nouveaux et complexes. Vous \xeates capable de diriger une initiative jusqu’\xe0 sa conclusion.";
var CredentialAwardedEmail_Level5Intro = "F\xe9licitations\xa0! Vous avez obtenu une certification de comp\xe9tence Degreed en {0}. Le niveau\xa05 vous a \xe9t\xe9 attribu\xe9, soit <b>Exp\xe9riment\xe9</b>.";
var CredentialAwardedEmail_Level5Title = "Niveau\xa05\xa0: exp\xe9riment\xe9";
var CredentialAwardedEmail_Level6Desc = "Au niveau\xa06, vous ma\xeetrisez le savoir, les connaissances th\xe9oriques, les outils, la m\xe9thodologie et les processus propres \xe0 votre domaine de comp\xe9tence. Vous \xeates non seulement capable d’utiliser ces connaissances pour r\xe9soudre n’importe quel probl\xe8me, mais \xe9galement de les communiquer clairement \xe0 autrui. ";
var CredentialAwardedEmail_Level6Intro = "F\xe9licitations\xa0! Vous avez obtenu une certification de comp\xe9tence Degreed en {0}. Le niveau\xa06 vous a \xe9t\xe9 attribu\xe9, soit <b>Avanc\xe9</b>.";
var CredentialAwardedEmail_Level6Title = "Niveau\xa06\xa0: avanc\xe9";
var CredentialAwardedEmail_Level7Desc = "Au niveau\xa07, vous aimez innover et votre travail n’a pas d’\xe9gal dans votre domaine, \xe0 tel point que c’est vous qui en dictez les tendances. Vous utilisez les outils \xe0 votre disposition de fa\xe7on si complexe et exp\xe9rimentale que tous sollicitent vos conseils. Vous disposez certainement aussi d’une expertise dans un ou plusieurs autres domaines de pointe ou hautement sp\xe9cialis\xe9s.";
var CredentialAwardedEmail_Level7Intro = "F\xe9licitations\xa0! Vous avez obtenu une certification de comp\xe9tence Degreed en {0}. Le niveau\xa07 vous a \xe9t\xe9 attribu\xe9, soit <b>\xc9m\xe9rite</b>.";
var CredentialAwardedEmail_Level7Title = "Niveau\xa07\xa0: \xe9m\xe9rite";
var CredentialAwardedEmail_Level8Desc = "Au niveau\xa08, votre connaissance et votre vision unique du domaine sont ardemment sollicit\xe9es. Vous anticipez les tendances majeures de l’avenir de votre secteur et leur impact sur les personnes, les outils, les technologies, les processus et le monde dans son ensemble. Reconnu comme un leader international dans votre domaine, vous \xe9laborez de nouvelles normes et pratiques, et votre capacit\xe9 d’innovation d\xe9passe celle de la majorit\xe9 de vos homologues.";
var CredentialAwardedEmail_Level8Intro = "F\xe9licitations\xa0! Vous avez obtenu une certification de comp\xe9tence Degreed en {0}. Le niveau\xa08 vous a \xe9t\xe9 attribu\xe9, soit Expert.";
var CredentialAwardedEmail_Level8Title = "Niveau\xa08\xa0: expert";
var CredentialAwardedEmail_Level9Desc = "<strong>Connaissances</strong>\n<br />Vous poss\xe9dez des connaissances g\xe9n\xe9rales sur certains aspects de la comp\xe9tence.\n<br /><br />\n<b>T\xe2ches et outils</b>\n<br />Vous d\xe9couvrez les outils associ\xe9s \xe0 la comp\xe9tence et apprenez \xe0 les utiliser pour r\xe9aliser des t\xe2ches simples de routine.\n<br /><br /><b>Autonomie</b>\n<br />C’est dans un environnement structur\xe9 et sous supervision, avec des processus pr\xe9d\xe9finis et des crit\xe8res \xe9tablis pour \xe9valuer votre travail, que vous donnez vos meilleurs r\xe9sultats.\n<br /><br /><b>Secteur</b>\n<br />Vous d\xe9couvrez le secteur et vous vous familiarisez avec son histoire, ses bonnes pratiques et ses d\xe9fis.\n<br /><br /><b>Pour passer au niveau sup\xe9rieur</b>\n<br /><ul>\n<li>Assimilez autant d’informations que possible. N’h\xe9sitez pas \xe0 tirer pleinement profit des opportunit\xe9s d’apprentissage qui s’offrent \xe0 vous pour gravir les \xe9chelons et devenir un expert dans votre domaine. </li>\n<li>Soyez attentif. Glanez des informations aupr\xe8s des experts de votre secteur via les blogs, webinaires, newsletters, conf\xe9rences\xa0TED, forums de questions-r\xe9ponses et autres ressources disponibles.</li>\n<li>Tirez profit des vid\xe9os, livres, cours et autres ressources \xe0 votre disposition.</li>\n<li>Avant de vous lancer, demandez conseil \xe0 des professionnels du secteur.</li>\n</ul>";
var CredentialAwardedEmail_LevelUp = "Pour passer au niveau sup\xe9rieur";
var CredentialAwardedEmail_LevelUp1Desc = "<ul><li>Assimilez autant d’informations que possible. N’h\xe9sitez pas \xe0 tirer pleinement profit des opportunit\xe9s d’apprentissage qui s’offrent \xe0 vous pour gravir les \xe9chelons et devenir un expert dans votre domaine. </li>\n<li>Soyez attentif. Glanez des informations aupr\xe8s des experts de votre secteur via les blogs, webinaires, newsletters, conf\xe9rences\xa0TED, forums de questions-r\xe9ponses et autres ressources disponibles.</li>\n<li>Tirez profit des vid\xe9os, livres, cours et autres ressources \xe0 votre disposition.</li>\n<li>Avant de vous lancer, demandez conseil \xe0 des professionnels du secteur.</li></ul>";
var CredentialAwardedEmail_LevelUp2Desc = "<ul><li>Continuez \xe0 vous former et \xe0 d\xe9velopper vos comp\xe9tences dans divers cas de figure. Ainsi, vous pourrez vous servir de vos connaissances pour r\xe9soudre des probl\xe8mes ou des situations complexes.</li>\n<li>Communiquez avec vos pairs pour d\xe9couvrir comment ils abordent les t\xe2ches, situations et probl\xe8mes auxquels ils sont confront\xe9s. En mettant en pratique les connaissances que vous avez acquises et en continuant \xe0 vous former, vous pourrez ainsi d\xe9velopper une approche qui vous est propre.</li></ul>";
var CredentialAwardedEmail_LevelUp3Desc = "<ul><li>Continuez \xe0 vous former et \xe0 d\xe9velopper vos comp\xe9tences dans divers cas de figure. Ainsi, vous pourrez vous servir de vos connaissances pour r\xe9soudre des probl\xe8mes ou des situations complexes.</li>\n<li>Communiquez avec vos pairs pour d\xe9couvrir comment ils abordent les t\xe2ches, situations et probl\xe8mes auxquels ils sont confront\xe9s. En mettant en pratique les connaissances que vous avez acquises et en continuant \xe0 vous former, vous pourrez ainsi d\xe9velopper une approche qui vous est propre.</li></ul>";
var CredentialAwardedEmail_LevelUp4Desc = "<ul><li>Continuez \xe0 vous former et \xe0 d\xe9velopper vos comp\xe9tences dans divers cas de figure. Ainsi, vous pourrez vous servir de vos connaissances pour r\xe9soudre des probl\xe8mes ou des situations complexes.</li>\n<li>Communiquez avec vos pairs pour d\xe9couvrir comment ils abordent les t\xe2ches, situations et probl\xe8mes auxquels ils sont confront\xe9s. En mettant en pratique les connaissances que vous avez acquises et en continuant \xe0 vous former, vous pourrez ainsi d\xe9velopper une approche qui vous est propre.</li></ul>";
var CredentialAwardedEmail_LevelUp5Desc = "<ul><li>Continuez \xe0 vous former et \xe0 d\xe9velopper vos comp\xe9tences dans divers cas de figure. Ainsi, vous pourrez vous servir de vos connaissances pour r\xe9soudre des probl\xe8mes ou des situations complexes.</li>\n<li>Communiquez avec vos pairs pour d\xe9couvrir comment ils abordent les t\xe2ches, situations et probl\xe8mes auxquels ils sont confront\xe9s. En mettant en pratique les connaissances que vous avez acquises et en continuant \xe0 vous former, vous pourrez ainsi d\xe9velopper une approche qui vous est propre.</li></ul>";
var CredentialAwardedEmail_LevelUp6Desc = "<ul><li>Conf\xe9rences, webinaires, communaut\xe9s en ligne ou formations\xa0: saisissez toutes les opportunit\xe9s qui s’offrent \xe0 vous pour partager votre savoir et votre exp\xe9rience avec un public plus large.</li>\n<li>Continuez \xe0 repousser vos propres limites en misant sur des outils innovants qui vous permettront de d\xe9velopper vos connaissances et vos comp\xe9tences.</li></ul>";
var CredentialAwardedEmail_LevelUp7Desc = "<ul><li>Confrontez-vous \xe0 certains des principaux d\xe9fis de votre secteur.</li>\n<li>Partagez vos r\xe9sultats avec vos pairs pour faire progresser votre secteur et stimuler l’innovation.</li>\n<li>Cr\xe9ez les outils et lancez les tendances qui fa\xe7onneront votre secteur.</li>\n<li>Puisez dans le savoir, les th\xe9ories et les pratiques d’autres domaines d’expertise pour d\xe9velopper de nouvelles solutions.</li>\n<li>Restez \xe0 l’aff\xfbt des opportunit\xe9s de recherche.</li>\n</ul>";
var CredentialAwardedEmail_LevelUp8Desc = "<ul><li>En tant qu’expert, vous vous devez de mettre vos connaissances \xe0 profit de votre secteur et des domaines qui y sont li\xe9s. Utilisez vos comp\xe9tences pour cr\xe9er les th\xe9ories, processus, technologies et outils qui permettront de relever les principaux d\xe9fis auxquels votre domaine est confront\xe9.</li>\n<li>Communiquez et collaborez autant que possible avec d’autres experts pour d\xe9velopper votre domaine dans son ensemble.</li>\n<li>Songez \xe0 la fa\xe7on la plus efficace d’enseigner et de partager vos connaissances.</li></ul>";
var CredentialAwardedEmail_MessageParagraph1Format = "Vous avez obtenu une certification Degreed de niveau\xa0{1} en {0}\xa0!";
var CredentialAwardedEmail_MessageParagraph2 = "Ce que votre niveau signifie\xa0:";
var CredentialAwardedEmail_MessageParagraph3 = "Vous pouvez d\xe9sormais partager votre certificat sur votre profil Degreed, votre CV ou les r\xe9seaux sociaux. Votre certification n’expire pas, mais elle est assortie d’une date pour indiquer quand vous avez atteint ce niveau.";
var CredentialAwardedEmail_MessageParagraph6 = "Continuez \xe0 progresser.";
var CredentialAwardedEmail_MessageParagraph7 = "Vous ne pourrez pas maintenir vos comp\xe9tences sans rien faire. Il est essentiel que vous continuiez \xe0 les d\xe9velopper et que vous vous fixiez des objectifs de formation.";
var CredentialAwardedEmail_ShareYourExpertise = "Partagez votre expertise";
var CredentialAwardedEmail_ShareYourExpertiseDesc = "Vous pouvez d\xe9sormais partager votre certificat sur votre profil Degreed, votre CV ou les r\xe9seaux sociaux. Votre certification n’expire pas, mais elle est assortie d’une date pour indiquer quand vous avez atteint ce niveau.";
var CredentialAwardedEmail_Subject = "Certification de comp\xe9tence\xa0: votre certificat de comp\xe9tence est disponible";
var CredentialAwardedEmail_TaskTools = "T\xe2ches et outils";
var CredentialAwardedEmail_TaskTools1Desc = "Vous apprenez \xe0 utiliser les outils li\xe9s \xe0 la comp\xe9tence pour accomplir des t\xe2ches simples et routini\xe8res.";
var CredentialAwardedEmail_TaskTools2Desc = "Vous \xeates de plus en plus \xe0 l’aise avec les outils et processus propres \xe0 votre secteur et vous savez les utiliser pour r\xe9aliser des t\xe2ches routini\xe8res. Vous commencez \xe9galement \xe0 savoir \xe9valuer la qualit\xe9 de votre travail sans faire r\xe9f\xe9rence aux crit\xe8res d\xe9finis.";
var CredentialAwardedEmail_TaskTools3Desc = "Vous \xeates de plus en plus \xe0 l’aise avec les outils et processus propres \xe0 votre secteur et vous savez les utiliser pour r\xe9aliser des t\xe2ches routini\xe8res. Vous commencez \xe9galement \xe0 savoir \xe9valuer la qualit\xe9 de votre travail sans faire r\xe9f\xe9rence aux crit\xe8res d\xe9finis.";
var CredentialAwardedEmail_TaskTools4Desc = "Vous \xeates de plus en plus \xe0 l’aise avec les outils et processus propres \xe0 votre secteur et vous savez les utiliser pour r\xe9aliser des t\xe2ches routini\xe8res. Vous commencez \xe9galement \xe0 savoir \xe9valuer la qualit\xe9 de votre travail sans faire r\xe9f\xe9rence aux crit\xe8res d\xe9finis.";
var CredentialAwardedEmail_TaskTools5Desc = "Vous \xeates de plus en plus \xe0 l’aise avec les outils et processus propres \xe0 votre secteur et vous savez les utiliser pour r\xe9aliser des t\xe2ches routini\xe8res. Vous commencez \xe9galement \xe0 savoir \xe9valuer la qualit\xe9 de votre travail sans faire r\xe9f\xe9rence aux crit\xe8res d\xe9finis.";
var CredentialAwardedEmail_TaskTools6Desc = "Vous utilisez un \xe9ventail fiable d’outils, de m\xe9thodes et de processus pour accomplir les t\xe2ches les plus complexes. Vous favorisez l’utilisation de nouvelles technologies et \xeates en mesure d’\xe9valuer leur efficacit\xe9.";
var CredentialAwardedEmail_TaskTools7Desc = "Innovateur dans l’\xe2me, votre travail n’a pas d’\xe9gal dans votre domaine, \xe0 tel point que c’est vous qui en dictez les tendances. Vous utilisez les outils \xe0 votre disposition de fa\xe7on si complexe et exp\xe9rimentale que tous sollicitent vos conseils. Vous disposez certainement aussi d’une expertise dans un ou plusieurs autres sous-domaines de pointe ou hautement sp\xe9cialis\xe9s.";
var CredentialAwardedEmail_TaskTools8Desc = "Vous ma\xeetrisez vos comp\xe9tences sur le bout des doigts et \xeates \xe0 l’origine des outils que vos pairs utilisent au quotidien. Vos recherches vous permettent de d\xe9velopper et proposer de nouveaux outils, processus et technologies aux professionnels de votre domaine. Vous avez mis votre exp\xe9rience au profit de l’innovation et avez ainsi con\xe7u des outils plus efficaces ou pr\xe9sent\xe9 de nouvelles th\xe9ories.<br /><br />Votre statut de leader du secteur est reconnu dans le monde entier et vous œuvrez certainement au d\xe9veloppement de nouvelles normes et pratiques. Votre capacit\xe9 \xe0 innover est sup\xe9rieure \xe0 celle de la plupart de vos pairs.";
var CredentialAwardedEmail_Title = "Certification de comp\xe9tence\xa0: votre certificat de comp\xe9tence est disponible";
var CredentialCompleteBehaviorsEmail_MessageParagraph1Format = "L’\xe9tape la plus importante pour obtenir votre certification dans le domaine \xab\xa0{0}\xa0\xbb consiste \xe0 apporter des preuves de votre niveau de comp\xe9tence et de votre expertise. Vous devrez pour cela fournir trois exemples de mise en pratique de cette comp\xe9tence sous la forme de d\xe9clarations \xab\xa0Je peux…\xa0\xbb. ";
var CredentialCompleteBehaviorsEmail_MessageParagraph2 = "Par exemple\xa0:";
var CredentialCompleteBehaviorsEmail_MessageParagraph3 = "\xab\xa0Je peux faire passer une page Facebook d’entreprise de 20\xa0000 \xe0 1\xa0000\xa0000 de likes de mani\xe8re organique.\xa0\xbb";
var CredentialCompleteBehaviorsEmail_MessageParagraph4 = "Vous devrez \xe9galement r\xe9pondre \xe0 deux questions concernant vos preuves de comp\xe9tence et fournir des liens ou des pi\xe8ces jointes qui permettent de les \xe9tayer. Veillez \xe0 ne pas importer de donn\xe9es exclusives. N’oubliez pas que vos trois comportements li\xe9s \xe0 la comp\xe9tence seront examin\xe9s par des pairs dans le cadre d’\xe9valuations individuelles anonymis\xe9es, ainsi que par vos approbateurs et par le panel d’experts de Degreed.";
var CredentialCompleteBehaviorsEmail_MessageParagraph5 = "Recueillir des preuves et renseigner cette section peut sembler d\xe9courageant, mais imaginez que vous remplissez une demande d’admission \xe0 l’universit\xe9\xa0: cette \xe9tape est essentielle pour nous aider \xe0 d\xe9terminer votre niveau de comp\xe9tence et votre classement parmi vos pairs. Alors, retroussez vos manches, rassemblez vos preuves et montrez-nous de quoi vous \xeates capable.";
var CredentialCompleteBehaviorsEmail_MessageParagraph6Format = "Si vous avez besoin d’aide, n’h\xe9sitez pas \xe0 nous contacter\xa0: info@degreed.com.";
var CredentialCompleteBehaviorsEmail_Subject = "Certification de comp\xe9tence\xa0: soumettez vos preuves";
var CredentialCompleteBehaviorsEmail_Title = "Certification de comp\xe9tence\xa0: soumettez vos preuves";
var CredentialCompleteEndorsersEmail_MessageParagraph1 = "Vous avez saisi vos trois comportements li\xe9s \xe0 la comp\xe9tence\xa0! F\xe9licitations, vous pouvez maintenant c\xe9l\xe9brer cet accomplissement\xa0: vous l’avez m\xe9rit\xe9.";
var CredentialCompleteEndorsersEmail_MessageParagraph2 = "La prochaine \xe9tape en vue d’obtenir votre certification consiste \xe0 choisir trois approbateurs. Il est essentiel d’en soumettre au moins un pour pouvoir finaliser votre demande. Nous contacterons les approbateurs par e-mail. Ces derniers seront ensuite invit\xe9s \xe0 \xe9valuer confidentiellement vos comportements, \xe0 confirmer la validit\xe9 de vos preuves et \xe0 r\xe9pondre \xe0 quelques questions pour pr\xe9ciser o\xf9 vous vous situez par rapport \xe0 d’autres coll\xe8gues dans le m\xeame domaine de comp\xe9tence.";
var CredentialCompleteEndorsersEmail_MessageParagraph3 = "Cela devrait prendre environ 30\xa0minutes. Rassurez-vous, nous ne les solliciterons pas \xe0 d’autres fins. Si vous le souhaitez, vous pouvez les contacter personnellement pour indiquer la raison de votre choix et l’impact d’une telle approbation.";
var CredentialCompleteEndorsersEmail_MessageParagraph4 = "Conseil de pro\xa0:";
var CredentialCompleteEndorsersEmail_MessageParagraph5 = "Il ne s’agit pas de recommandations LinkedIn. Choisissez donc des approbateurs qui connaissent vos comportements et votre fa\xe7on de travailler. Ne choisissez pas votre coll\xe8gue du bureau voisin parce qu’il vous conna\xeet depuis plus longtemps.";
var CredentialCompleteEndorsersEmail_Subject = "Certification de comp\xe9tence\xa0: soumettez vos approbateurs";
var CredentialCompleteEndorsersEmail_Title = "Certification de comp\xe9tence\xa0: soumettez vos approbateurs";
var CredentialEmail_AwardVideo = '<br /><br /> <iframe width="560" height="315" src="https://www.youtube.com/embed/0UBz320iBEQ?rel=0" frameborder="0" allowfullscreen></iframe><br />';
var CredentialEmail_ContinueToApplication = "Passer \xe0 la demande";
var CredentialEmail_FooterReason = "Degreed vous a envoy\xe9 cet e-mail parce que vous souhaitez certifier une comp\xe9tence.";
var CredentialEmail_GetCertified = "Obtenir une certification";
var CredentialEmail_ReviewPeers = "Evaluer des pairs";
var CredentialEmail_ViewCertificate = "Afficher votre certificat";
var CredentialEmail_ViewEndorsements = "Afficher le statut de l’approbation";
var CredentialEmail_ViewStatus = "Afficher le statut";
var CredentialEmail_WhatIsDegreed = "Qu’est-ce que Degreed\xa0?";
var CredentialEmail_WhatIsDegreedDesc = "Degreed est une entreprise de formation ayant pour vocation de changer la fa\xe7on dont les individus d\xe9veloppent leurs comp\xe9tences, leur expertise et leurs carri\xe8res. Nous nous sommes donn\xe9 pour mission de d\xe9cloisonner un syst\xe8me o\xf9 le dipl\xf4me est roi, car nous sommes convaincus que TOUS les apprentissages comptent, quelle que soit la forme qu’ils prennent. Nous nous engageons \xe0 cr\xe9er des produits qui permettent \xe0 chaque apprenant d’identifier et de poursuivre ses objectifs personnels. Peu importe comment vous \xeates devenu un expert, l’avenir retiendra simplement que vous y \xeates parvenu.";
var CredentialEndorserCompletedEmail_MessageParagraph1Format = "Bonjour, {0}\xa0!";
var CredentialEndorserCompletedEmail_MessageParagraph2Format = "{0} {1} a termin\xe9 son approbation pour la comp\xe9tence \xab\xa0{2}\xa0\xbb sur Degreed. Vous pourrez bient\xf4t mettre en avant votre expertise dans ce domaine de comp\xe9tence\xa0!";
var CredentialEndorserCompletedEmail_MessageParagraph3Format = 'D\xe9couvrez <a style="text-decoration: none;" href="{0}">votre prochaine \xe9tape</a> sur Degreed. Bonne chance\xa0!';
var CredentialEndorserCompletedEmail_Subject = "Certification de comp\xe9tence\xa0: f\xe9licitations, votre comp\xe9tence \xab\xa0{0}\xa0\xbb a \xe9t\xe9 approuv\xe9e\xa0!";
var CredentialEndorserCompletedEmail_Title = "Certification de comp\xe9tence\xa0: f\xe9licitations, votre comp\xe9tence \xab\xa0{0}\xa0\xbb a \xe9t\xe9 approuv\xe9e\xa0!";
var CredentialEndorserDeclinedEmail_MessageParagraph1Format = "{0} a refus\xe9 d’approuver votre demande de certification pour la comp\xe9tence \xab\xa0{1}\xa0\xbb. Pas d’inqui\xe9tude, vous pouvez soumettre un nouvel approbateur pour faire avancer votre demande.";
var CredentialEndorserDeclinedEmail_MessageParagraph2 = "Soumettez un nouvel approbateur ici\xa0:";
var CredentialEndorserDeclinedEmail_Subject = "Certification de comp\xe9tence\xa0: un approbateur a refus\xe9 votre demande";
var CredentialEndorserDeclinedEmail_Title = "Certification de comp\xe9tence\xa0: un approbateur a refus\xe9 votre demande";
var CredentialEndorserFollowupEmail_MessageParagraph1Format = "En vue d’obtenir une certification pour la comp\xe9tence \xab\xa0{0}\xa0\xbb, {1} vous demande d’approuver son niveau d’exp\xe9rience et de comp\xe9tence. Si vous acceptez, vous devrez \xe9valuer confidentiellement les preuves fournies par {1}, confirmer leur validit\xe9 et indiquer o\xf9 {1} se situe par rapport \xe0 d’autres coll\xe8gues dans le m\xeame domaine de comp\xe9tence. Cela devrait prendre environ 20\xa0minutes.";
var CredentialEndorserFollowupEmail_MessageParagraph2 = "Commencez le processus d’approbation ici\xa0: ";
var CredentialEndorserFollowupEmail_MessageParagraph3Format = "Si vous ne pouvez pas ou ne voulez pas valider les preuves fournies par {0}, vous avez la possibilit\xe9 de refuser.";
var CredentialEndorserFollowupEmail_Subject = "N’oubliez pas d’approuver la certification de {0} pour la comp\xe9tence \xab\xa0{1}\xa0\xbb";
var CredentialEndorserFollowupEmail_TitleFormat = "N’oubliez pas d’approuver la certification de {0} pour la comp\xe9tence \xab\xa0{1}\xa0\xbb";
var CredentialEndorsersInitialEmail_MessageParagraph1Format = "{0} {1} souhaite obtenir une certification dans le domaine \xab\xa0{2}\xa0\xbb et vous invite \xe0 approuver son niveau d’exp\xe9rience et de comp\xe9tence.";
var CredentialEndorsersInitialEmail_MessageParagraph2Format = "Si vous acceptez, vous devrez \xe9valuer confidentiellement les preuves fournies par {0} et confirmer leur validit\xe9\xa0:";
var CredentialEndorsersInitialEmail_MessageParagraph3Format = "Cette \xe9tape devrait prendre environ 20\xa0minutes et est n\xe9cessaire afin de permettre \xe0 {0} d’obtenir son certificat pour la comp\xe9tence \xab\xa0{1}\xa0\xbb. Acc\xe9dez \xe0 la demande ici\xa0:";
var CredentialEndorsersInitialEmail_MessageParagraph4Format = "Si vous ne pouvez pas ou ne voulez pas valider les preuves fournies par {0}, vous avez la possibilit\xe9 de refuser.";
var CredentialEndorsersInitialEmail_MessageParagraph5 = "Vous devrez ensuite r\xe9pondre \xe0 quelques questions sur son niveau de comp\xe9tence\xa0:";
var CredentialEndorsersInitialEmail_Subject = "{0} vous invite \xe0 approuver sa certification de comp\xe9tence";
var CredentialEndorsersInitialEmail_Title = "{0} vous invite \xe0 approuver sa certification de comp\xe9tence";
var CredentialEndorserThankEmail_MessageParagraph1Format = "{0} a obtenu sa certification Degreed pour la comp\xe9tence \xab\xa0{1}\xa0\xbb";
var CredentialEndorserThankEmail_MessageParagraph2Format = "Merci d’avoir accept\xe9 de donner votre approbation \xe0 {0}, qui a termin\xe9 avec succ\xe8s le processus de soumission et obtenu sa certification de comp\xe9tence. Des f\xe9licitations sont de rigueur\xa0! Les comp\xe9tences et les certifications de {0} sont disponibles sur son profil Degreed (si ce dernier est public).";
var CredentialEndorserThankEmail_MessageParagraph3 = "Vous pouvez vous aussi obtenir une certification de comp\xe9tence\xa0!";
var CredentialEndorserThankEmail_MessageParagraph4Format = "Suivez les pas de {0} en obtenant votre certification. Les certifications de comp\xe9tence peuvent vous permettre de d\xe9terminer votre niveau de comp\xe9tence et de montrer vos talents aux autres. Degreed certifie actuellement plus de 1\xa0500\xa0comp\xe9tences, et en tant qu’approbateur, vous b\xe9n\xe9ficierez d’une r\xe9duction de 25\xa0% sur votre premi\xe8re certification de comp\xe9tence.";
var CredentialEndorserThankEmail_PromoCode = "E7AKB8QC";
var CredentialEndorserThankEmail_Subject = "Merci de votre approbation\xa0!";
var CredentialEndorserThankEmail_Title = "Merci de votre approbation\xa0!";
var CredentialEndorserThankEmail_ViewProfile = "Afficher le profil de {0}";
var CredentialPaidInFullViaPromoEmail_Header = "Confirmation de paiement";
var CredentialPaidInFullViaPromoEmail_MessageParagraph1Format = "Votre code promotionnel a couvert les frais associ\xe9s \xe0 la certification \xab\xa0{0}\xa0\xbb.";
var CredentialPaidInFullViaPromoEmail_MessageParagraph2 = "Cela signifie que votre demande de certification a bien \xe9t\xe9 finalis\xe9e et soumise. Vous recevrez prochainement des instructions concernant les prochaines \xe9tapes du processus. En attendant, continuez \xe0 vous former\xa0!";
var CredentialPaidInFullViaPromoEmail_PromotionalCodeDiscount = "R\xe9duction du code promotionnel";
var CredentialPaidInFullViaPromoEmail_Subject = "Certification de comp\xe9tence\xa0: re\xe7u de Degreed";
var CredentialPaidInFullViaPromoEmail_Subtotal = "Total";
var CredentialPaidInFullViaPromoEmail_Title = "Certification de comp\xe9tence\xa0: re\xe7u de Degreed";
var CredentialRateYourPeersEmail_MessageParagraph1 = "Pour nous aider \xe0 d\xe9terminer avec exactitude l’expertise des candidats, vous devrez par la suite \xe9valuer jusqu’\xe0 10\xa0s\xe9ries de comparaisons individuelles. Cela prend environ une heure.";
var CredentialRateYourPeersEmail_MessageParagraph2Format = "Vous serez \xe9galement compar\xe9 \xe0 d’autres collaborateurs, mais inutile de vous inqui\xe9ter. En plus de nous permettre d’\xe9tablir un classement et d’\xeatre fiable \xe0 95\xa0%, il s’agit de l’un des nombreux facteurs qui nous aideront \xe0 d\xe9terminer votre niveau de comp\xe9tence.</br> <strong>Les \xe9valuations que vous soumettez pour vos pairs contribuent \xe9galement \xe0 \xe9valuer votre expertise, alors ne les n\xe9gligez pas\xa0! </strong>";
var CredentialRateYourPeersEmail_MessageParagraph3Format = "Veuillez terminer vos \xe9valuations au plus tard le {0} pour que nous puissions vous attribuer un niveau de comp\xe9tence final et un certificat.";
var CredentialRateYourPeersEmail_MessageParagraph4 = "Finalisez les \xe9valuations ici\xa0:";
var CredentialRateYourPeersEmail_Subject = "Certification de comp\xe9tence\xa0: prochaines \xe9tapes – \xe9valuez vos pairs";
var CredentialRateYourPeersEmail_Title = "Certification de comp\xe9tence\xa0: prochaines \xe9tapes – \xe9valuez vos pairs";
var CredentialRateYourPeersFollowupEmail_MessageParagraph1 = "Nous avons encore besoin de votre aide pour d\xe9terminer avec exactitude le niveau d’expertise de vos pairs. Vous devrez \xe9valuer jusqu’\xe0 10\xa0s\xe9ries de comparaisons individuelles.";
var CredentialRateYourPeersFollowupEmail_MessageParagraph2Format = "Vous serez \xe9galement compar\xe9 \xe0 d’autres collaborateurs, mais inutile de vous inqui\xe9ter. En plus de nous permettre d’\xe9tablir un classement et d’\xeatre fiable \xe0 95\xa0%, il s’agit de l’un des nombreux facteurs qui nous aideront \xe0 d\xe9terminer votre niveau de comp\xe9tence.</br> <strong>Les \xe9valuations que vous soumettez pour vos pairs contribuent \xe9galement \xe0 \xe9valuer votre expertise, alors ne les n\xe9gligez pas\xa0! </strong>";
var CredentialRateYourPeersFollowupEmail_MessageParagraph3Format = "Veuillez terminer vos \xe9valuations au plus tard le {0} pour que nous puissions vous attribuer un niveau de comp\xe9tence final et un certificat.";
var CredentialRateYourPeersFollowupEmail_MessageParagraph4 = "Finalisez les \xe9valuations ici\xa0:";
var CredentialRateYourPeersFollowupEmail_MessageParagraph5Format = 'Pour toute question, merci d’envoyer un e-mail \xe0 l’adresse <a style="text-decoration: none;" href="mailto:info@degreed.com">info@degreed.com</a>.';
var CredentialRateYourPeersFollowupEmail_Subject = "Certification de comp\xe9tence\xa0: terminez l’\xe9valuation de vos pairs";
var CredentialRateYourPeersFollowupEmail_Title = "Certification de comp\xe9tence\xa0: terminez l’\xe9valuation de vos pairs";
var CredentialReviewSvc_ErrorSubmitting = "D\xe9sol\xe9\xa0! Une erreur est survenue lors de la soumission de l’\xe9valuation.";
var CredentialReviewSvc_GetBehaviorsError = "Une erreur s’est produite lors de la r\xe9cup\xe9ration des comportements de certification des comp\xe9tences pour l’application indiqu\xe9e.";
var CredentialReviewSvc_GetError = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration des d\xe9tails.";
var CredentialReviewSvc_GetReviewError = "Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration des d\xe9tails de l’\xe9valuation.";
var CredentialSubmissionReminderEmail_FromAddress = "info@degreed.com";
var CredentialSubmissionReminderEmail_MessageParagraph1 = "Bonjour,";
var CredentialSubmissionReminderEmail_MessageParagraph2Format = "Ici Joel de chez Degreed. Je tenais \xe0 vous informer que notre prochaine p\xe9riode d’examen des demandes de certification pour la comp\xe9tence \xab\xa0{0}\xa0\xbb approche. Si vous souhaitez obtenir votre certification dans les meilleurs d\xe9lais, soumettez votre demande au plus tard le {1}. Si vous n’avez pas assez de temps pour le faire, ne vous inqui\xe9tez pas. Le processus recommence \xe0 la m\xeame date chaque mois pour les demandes associ\xe9es \xe0 la comp\xe9tence \xab\xa0{0}\xa0\xbb.";
var CredentialSubmissionReminderEmail_MessageParagraph3Format = 'Nous sommes l\xe0 pour vous aider. Si vous avez des questions ou si vous avez besoin de plus de temps pour remplir votre demande, il vous suffit de r\xe9pondre \xe0 cet e-mail. Vous pouvez \xe9galement regarder notre vid\xe9o <a href="https://www.youtube.com/watch?v=FGewInzqHKY">Qu’est-ce que la certification de comp\xe9tence\xa0?</a>.';
var CredentialSubmissionReminderEmail_MessageParagraph4Format = "Ce dont vous aurez besoin\xa0: <br/>\n<ul>\n<li>Trois exemples de mise en pratique de la comp\xe9tence</li>\n<li>Au moins un approbateur capable de confirmer votre niveau de comp\xe9tence et d’exp\xe9rience</li>\n<li>Environ 4\xa0\xe0 6\xa0heures (r\xe9parties sur plusieurs sessions)</li></ul>";
var CredentialSubmissionReminderEmail_MessageParagraph5 = "\xc0 vous de jouer\xa0!";
var CredentialSubmissionReminderEmail_MessageParagraph6 = "Joel";
var CredentialSubmissionReminderEmail_Subject = "Rappel de la part de votre assistant personnel concernant la certification de comp\xe9tence";
var CredentialSubmissionReminderEmail_Title = "Rappel de la part de votre assistant personnel concernant la certification de comp\xe9tence";
var CredentialSubmittedEmail_MessageParagraph1Format = "F\xe9licitations\xa0! Vous avez finalis\xe9 votre demande de certification pour la comp\xe9tence \xab\xa0{0}\xa0\xbb. Prochaine \xe9tape\xa0: \xe9valuer vos pairs";
var CredentialSubmittedEmail_MessageParagraph2 = "Au cours de l’\xe9tape suivante, vous serez peut-\xeatre invit\xe9 \xe0 \xe9valuer vos pairs dans le cadre d’une s\xe9rie de comparaisons individuelles anonymis\xe9es. Votre demande sera \xe9galement compar\xe9e \xe0 d’autres candidats, mais il n’y a pas de quoi s’inqui\xe9ter. Les \xe9valuations par les pairs nous permettent d’\xe9tablir un classement fiable \xe0 95\xa0% et constituent l’un des nombreux facteurs qui nous aideront \xe0 d\xe9terminer votre niveau de comp\xe9tence.";
var CredentialSubmittedEmail_MessageParagraph3Format = "Nous vous enverrons une notification par e-mail lorsque vous serez int\xe9gr\xe9 au prochain groupe d’\xe9valuation par les pairs, qui s’ouvrira aux alentours du {0}. \xc0 pr\xe9sent, il ne vous reste plus qu’\xe0 attendre patiemment et \xe0 continuer de vous former.";
var CredentialSubmittedEmail_MessageParagraph4Format = "Veuillez envoyer un e-mail \xe0 l’adresse info@degreed.com pour toute question. Nous sommes l\xe0 pour vous aider\xa0!";
var CredentialSubmittedEmail_Subject = "Certification de comp\xe9tence\xa0: tr\xe8s bon travail\xa0!";
var CredentialSubmittedEmail_Title = "Tr\xe8s bon travail\xa0!";
var CredentialSvc_AddUserCredError = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de la cr\xe9ation de la demande.";
var CredentialSvc_ApplyPaymentError = "Votre paiement a bien \xe9t\xe9 soumis, mais une erreur s’est produite lors de son enregistrement.";
var CredentialSvc_CohortError = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration des dates disponibles.";
var CredentialSvc_DeleteError = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de la suppression de la demande.";
var CredentialSvc_DeleteSuccess = "La demande a bien \xe9t\xe9 supprim\xe9e.";
var CredentialSvc_ErrorSavingChanges = "Une erreur est survenue lors de l’enregistrement de vos modifications.";
var CredentialSvc_GetAllUserCredsError = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration des demandes.";
var CredentialSvc_GetBehaviorsError = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration des comportements.";
var CredentialSvc_GetComparisonError = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration des informations de comparaison.";
var CredentialSvc_GetCredError = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration de cette comp\xe9tence.";
var CredentialSvc_GetCredsError = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration des options disponibles.";
var CredentialSvc_GetEndorsersError = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration des informations d’approbation.";
var CredentialSvc_GetLinksError = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration des informations de lien.";
var CredentialSvc_GetPaymentError = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration des informations de paiement.";
var CredentialSvc_GetProfileError = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration des informations personnelles.";
var CredentialSvc_GetReviewStatusError = "Une erreur s’est produite lors de la r\xe9cup\xe9ration du statut de l’\xe9valuation.";
var CredentialSvc_GetScholarshipStatusError = "Une erreur s’est produite au moment de d\xe9terminer le statut de la promotion.";
var CredentialSvc_GetSocialLinksError = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration des liens de r\xe9seaux sociaux.";
var CredentialSvc_GetTagsError = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration des comp\xe9tences.";
var CredentialSvc_GetUserCredError = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration des informations de certification.";
var CredentialSvc_SetBehaviorsError = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de l’enregistrement des comportements.";
var CredentialSvc_SetComparisonError = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de l’enregistrement des informations de comparaison.";
var CredentialSvc_SetEndorsersError = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de l’enregistrement des informations d’approbation.";
var CredentialSvc_SetLinksError = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de l’enregistrement des informations de lien.";
var CredentialSvc_SetProfileError = "\xc9chec de l’importation du fichier";
var CredentialSvc_SetScholarshipCodeError = "Une erreur s’est produite au moment de d\xe9finir le code promotionnel.";
var CredentialSvc_SetTagsError = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de l’enregistrement des mots-cl\xe9s.";
var CredentialSvc_SubmitError = "D\xe9sol\xe9\xa0! Le paiement a bien \xe9t\xe9 soumis, mais un probl\xe8me est survenu lors de la soumission de la demande.";
var CredentialWaitForReviewsEmail_MessageParagraph1 = "F\xe9licitations pour avoir atteint ce stade\xa0! Il ne vous reste plus qu’\xe0 attendre que vos approbations soient finalis\xe9es et que notre panel d’experts fasse son travail.";
var CredentialWaitForReviewsEmail_MessageParagraph2 = "Prochaines \xe9tapes\xa0: <br /><ul><li>Attendez qu’au moins un approbateur donne son approbation.</li><li>Attendez que le panel d’experts proc\xe8de \xe0 l’\xe9valuation finale et au classement.</li></ul>";
var CredentialWaitForReviewsEmail_MessageParagraph3 = "Vous pouvez v\xe9rifier le statut de ces approbations ici\xa0:";
var CredentialWaitForReviewsEmail_MessageParagraph4 = "En attendant, n’h\xe9sitez pas \xe0 apprendre quelque chose de nouveau sur Degreed (petit moment d’autopromotion).";
var CredentialWaitForReviewsEmail_Subject = "Certification de comp\xe9tence\xa0: vous y \xeates presque\xa0!";
var CredentialWaitForReviewsEmail_Title = "Vous y \xeates presque\xa0!";
var CredentialWaitingForEndorsementsEmail_MessageParagraph1 = "Les gens ont parfois juste besoin d’un petit rappel. Au moins un de vos approbateurs n’a pas encore examin\xe9 votre demande et vos preuves.";
var CredentialWaitingForEndorsementsEmail_MessageParagraph2 = "Vous pouvez v\xe9rifier leur statut ici\xa0: ";
var CredentialWaitingForEndorsementsEmail_MessageParagraph3 = "Vous pouvez \xe9galement envoyer un e-mail de rappel \xe0 vos approbateurs ou en choisir d’autres.";
var CredentialWaitingForEndorsementsEmail_MessageParagraph3Format = 'Envoyez-leur un rappel automatique ou ajoutez un message personnel\xa0:<br /><a style="text-decoration: none;" href="{0}">{0}</a>';
var CredentialWaitingForEndorsementsEmail_MessageParagraph4Format = 'Ou remplacez un approbateur\xa0:<br /><a href="{0}">{0}</a>';
var CredentialWaitingForEndorsementsEmail_MessageParagraphInfo = 'Pour toute question, merci d’envoyer un e-mail \xe0 l’adresse <a style="text-decoration: none;" href="mailto:info@degreed.com">info@degreed.com</a>.';
var CredentialWaitingForEndorsementsEmail_Subject = "Certification de comp\xe9tence\xa0: nous sommes toujours en attente de vos approbateurs";
var CredentialWaitingForEndorsementsEmail_Title = "Certification de comp\xe9tence\xa0: nous sommes toujours en attente de vos approbateurs";
var CredentialWelcomeEmail_MessageDearFormat = "Bonjour {0},";
var CredentialWelcomeEmail_MessageParagraph1 = "La seule solution de certification au monde qui soit \xe0 la fois ax\xe9e sur les comp\xe9tences, encadr\xe9e par des experts et con\xe7ue pour offrir une repr\xe9sentation en temps r\xe9el de vos connaissances et de vos aptitudes.";
var CredentialWelcomeEmail_MessageParagraph10Format = "Date pr\xe9vue\xa0: {0}";
var CredentialWelcomeEmail_MessageParagraph11 = 'Si vous avez des questions ou des commentaires tout au long du processus, veuillez nous contacter par e-mail \xe0 l’adresse <a href="mailto:info@degreed.com">info@degreed.com</a>. Bonne chance\xa0!';
var CredentialWelcomeEmail_MessageParagraph12 = "Vous pouvez revenir \xe0 votre demande \xe0 tout moment\xa0:";
var CredentialWelcomeEmail_MessageParagraph1Format = 'Bienvenue dans le processus de certification de comp\xe9tence Degreed\xa0! Vous pouvez d\xe8s \xe0 pr\xe9sent commencer votre soumission ou y revenir ult\xe9rieurement depuis le menu situ\xe9 en haut \xe0 droite de Degreed ou via ce lien\xa0: <a href="{0}" target="_blank">{0}</a>';
var CredentialWelcomeEmail_MessageParagraph2 = "Pour parler franchement\xa0: votre dipl\xf4me sera un jour obsol\xe8te, votre CV manque de profondeur et le r\xe9seautage en ligne a ses limites. Degreed Skill Certification™ r\xe9sout ces probl\xe8mes en vous d\xe9livrant une certification qui refl\xe8te de mani\xe8re pr\xe9cise et actualis\xe9e votre expertise.";
var CredentialWelcomeEmail_MessageParagraph3 = "<strong>\xc9tape\xa01\xa0: soumission des preuves. </strong>Vous devez fournir trois exemples de mise en pratique de la comp\xe9tence, accompagn\xe9s de liens ou de pi\xe8ces jointes, pour d\xe9montrer votre niveau de comp\xe9tence. Cette \xe9tape vous prendra probablement quelques heures.";
var CredentialWelcomeEmail_MessageParagraph3Format = "Ce dont vous avez besoin pour obtenir une certification dans le domaine de comp\xe9tence \xab\xa0{0}\xa0\xbb\xa0:<br />\n<ul>\n<li>Trois comportements illustrant votre comp\xe9tence et des preuves pour les \xe9tayer</li>\n<li>Au moins un approbateur capable de confirmer votre niveau de comp\xe9tence et d’exp\xe9rience</li>                                                  \n<li>Environ 4\xa0heures (r\xe9parties sur plusieurs sessions)</li>\n<li>Soumettez votre demande avant la prochaine date limite du {1}. Si ce d\xe9lai est trop court, une autre date limite sera fix\xe9e le mois suivant.</li>                                             \n</ul>";
var CredentialWelcomeEmail_MessageParagraph4 = "<strong>\xc9tape\xa02: s\xe9lection des approbateurs. </strong>Vous devez fournir trois approbateurs, dont au moins un capable de confirmer que vos preuves correspondent \xe0 votre fa\xe7on de travailler.";
var CredentialWelcomeEmail_MessageParagraph5 = "<strong>\xc9tape\xa03\xa0: \xe9valuation des pairs. </strong>Apr\xe8s la date limite de soumission, nous vous demanderons d’\xe9valuer les demandes anonymes d’autres candidats \xe0 la certification dans le m\xeame domaine de comp\xe9tence. Ces \xe9valuations, combin\xe9es \xe0 celles de notre panel d’experts, permettront de d\xe9terminer votre niveau. Cette \xe9tape vous prendra probablement quelques heures, mais vous n’\xeates pas oblig\xe9 de la r\xe9aliser d’une traite.";
var CredentialWelcomeEmail_MessageParagraph6 = "<strong>\xc9tape\xa04\xa0: test d'\xe9valuation par des experts. </strong>Notre panel d’experts examinera votre demande pour vous attribuer un niveau. Cette \xe9tape ne requiert aucune action de votre part.";
var CredentialWelcomeEmail_MessageParagraph7 = "<strong>\xc9tape\xa05\xa0: obtention du certificat. </strong>Lorsque vous aurez r\xe9alis\xe9 toutes ces \xe9tapes et re\xe7u au moins une approbation, nous vous d\xe9livrerons votre certificat avec votre niveau de comp\xe9tence actuel.";
var CredentialWelcomeEmail_MessageParagraph8 = "Commencez votre demande d\xe8s maintenant pour r\xe9server votre place. Au d\xe9but du processus, vous recevrez un autre message vous indiquant les dates limites de soumission des informations.";
var CredentialWelcomeEmail_MessageParagraph9 = "Pour toute question ou tout commentaire, contactez-nous par e-mail \xe0 l’adresse info@degreed.com. Nous avons h\xe2te de vous aider \xe0 mettre en avant vos comp\xe9tences\xa0!";
var CredentialWelcomeEmail_MessageWelcomeFormat = "Bienvenue dans Degreed Skill Certification";
var CredentialWelcomeEmail_PreviewFormat = "Ce dont vous avez besoin pour obtenir des comp\xe9tences certifi\xe9es en {0}.";
var CredentialWelcomeEmail_Subject = "Bienvenue dans Degreed Skill Certification";
var CredEvidenceForm_AddUrl = "Ajouter une URL";
var CredEvidenceForm_Complete = "Chargement du fichier termin\xe9";
var CredEvidenceForm_FileTypes = "Les fichiers peuvent \xeatre des images (.jpg, .jpeg, .gif, .tiff, .png) ou des fichiers PDF (.pdf) dont la taille n’exc\xe8de pas {{filesizeLimit}}.";
var CredEvidenceForm_InsertEvidence = "Ajouter une preuve";
var CredEvidenceForm_Processing = "Traitement du fichier";
var CredEvidenceForm_ProvideEvidence = "Fournir une preuve";
var CredEvidenceForm_TitleOfEvidence = "Intitul\xe9 de la preuve";
var CredEvidenceForm_titleRequired = "L’intitul\xe9 doit \xeatre renseign\xe9.";
var CredEvidenceForm_UnableToUpload = "\xc9chec du chargement du fichier";
var CredEvidenceForm_UploadFile = "T\xe9l\xe9charger un fichier";
var CredEvidenceForm_urlFileRequired = "Vous devez fournir une URL ou un fichier valide. N’oubliez pas d’utiliser http://";
var CredHonorCodeCtrl_AgreeLabel = "J’accepte le code d’honneur.";
var CredHonorCodeCtrl_DeclarationTitle = "Je d\xe9clare que toutes les informations que je fournirai sont v\xe9ridiques.";
var CredHonorCodeCtrl_Header = "1.2 Accepter le code d’honneur";
var CredHonorCodeCtrl_Instructions = "Je d\xe9clare par la pr\xe9sente que toutes les informations que je fournirai sont v\xe9ridiques. Soumettre de fausses informations est consid\xe9r\xe9 comme un acte frauduleux passible de prison.";
var CredHonorCodeCtrl_Submit = "Enregistrer et continuer";
var CredManageOutcomesCtrl_MaxErrorAccomplishmentFormat = "Nous savons que vous avez beaucoup \xe0 montrer, mais limitez votre s\xe9lection \xe0 un ensemble de vos {{count}} accomplissements les plus pertinents.";
var CredManageOutcomesCtrl_MaxErrorSkillFormat = "Nous savons que vous avez beaucoup \xe0 montrer, mais limitez votre s\xe9lection \xe0 un ensemble de vos {{count}} comp\xe9tences les plus pertinentes.";
var CredManageOutcomesCtrl_MaxErrorTitle = "Oups ! Il y en a un(e) de trop";
var CredManageOutcomesCtrl_TitleAccomplishment = "G\xe9rer les accomplissements";
var CredManageOutcomesCtrl_TitleAward = "G\xe9rer les r\xe9compenses";
var CredManageOutcomesCtrl_TitleCertificate = "G\xe9rer les certificats";
var CredManageOutcomesCtrl_TitleDegree = "G\xe9rer les dipl\xf4mes";
var CredManageOutcomesCtrl_TitleSkill = "G\xe9rer les comp\xe9tences";
var CredManageTagsCtrl_ManageArticlesVideos = "G\xe9rer les articles et les vid\xe9os";
var CredManageTagsCtrl_ManageInformal = "G\xe9rer l’apprentissage informel";
var CredNav_AcceptHonorCode = "Accepter le code d’honneur";
var CredNav_Application = "Demande";
var CredNav_ApplicationDescription = "Fournissez des informations sur votre niveau de comp\xe9tence.";
var CredNav_Behavior1 = "Premier comportement li\xe9 \xe0 la comp\xe9tence";
var CredNav_Behavior2 = "Deuxi\xe8me comportement li\xe9 \xe0 la comp\xe9tence";
var CredNav_Behavior3 = "Troisi\xe8me comportement li\xe9 \xe0 la comp\xe9tence";
var CredNav_Behaviors = "Choisir 3 comportements li\xe9s \xe0 comp\xe9tence";
var CredNav_Compare = "Evaluer des pairs";
var CredNav_CompareDescription = "Examinez d’autres demandes de certification.";
var CredNav_Endorsers = "S\xe9lectionner des approbateurs";
var CredNav_EndorsersDescription = "CredNav_EndorsersDescription";
var CredNav_FinalCheck = "V\xe9rification finale";
var CredNav_heading = "Navigation dans la certification de comp\xe9tence";
var CredNav_IdentityVerification = "V\xe9rification d’identit\xe9";
var CredNav_PeerComparison1 = "1re comparaison de pairs";
var CredNav_PeerComparison2 = "2e comparaison de pairs";
var CredNav_PeerComparison3 = "3e comparaison de pairs";
var CredNav_PeerComparisonFormat = "{{Number}}e comparaison de pairs";
var CredNav_Results = "Recevoir les r\xe9sultats";
var CredNav_ResultsDescription = "Affichez, t\xe9l\xe9chargez ou partagez votre certificat.";
var CredNav_ReviewApplication = "Examiner la demande";
var CredNav_SkillCertification = "Skill Certification (Certification de comp\xe9tence)";
var CredNav_SkillReview = "Revue de comp\xe9tence";
var CredNav_Status = "V\xe9rifier le statut";
var CredNav_StatusDescription = "Vous pouvez maintenant vous d\xe9tendre. Nous examinons votre demande.";
var CredNav_Submit = "Mentions l\xe9gales et paiement";
var CredNav_SubmitWithCredits = "Mentions l\xe9gales et soumission";
var CredNav_WaitForCohort = "Attendre l’ouverture de la cohorte";
var CredPaymentSvc_PaymentInfoError = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration de vos d\xe9tails.";
var CredPrePayChooseSkillCtrl_ChooseASkill = "Choisissez une comp\xe9tence";
var CredPrePayChooseSkillCtrl_ChooseSkill = "Choisir une comp\xe9tence";
var CredPrePayChooseSkillCtrl_ContinueToApplication = "Passer \xe0 la demande";
var CredPrePayChooseSkillCtrl_ResultsForFormat = "Comp\xe9tences associ\xe9es \xe0 \xab\xa0{{term}}\xa0\xbb";
var CredPrePayChooseSkillCtrl_SearchCatalog = "Parcourez notre catalogue de plus de 1\xa0500\xa0comp\xe9tences\xa0:";
var CredPrePayCtrl_Payment = "Paiement";
var CredPrePayCtrl_SaveAndConfirm = "Enregistrer et confirmer le paiement";
var CredPrePayCtrl_SubmitPayment = "Proc\xe9der au paiement";
var CredPrePayType_CertificationType = "Choisissez votre Plan de certification";
var CredPrePayType_credit = "Certification pour une comp\xe9tence";
var CredPrePayType_creditAction = "Certification pour Une comp\xe9tence";
var CredPrePayType_creditDescription = "<p>Faites certifier une comp\xe9tence.</p>\n<p>Recevez un certificat num\xe9rique et un lien de v\xe9rification.</p>\n<p>Des ressources num\xe9riques pour LinkedIn, votre CV, Facebook, Twitter et tout autre endroit o\xf9 vous publiez votre profil professionnel.</p>";
var CredPrePayType_lifetime = "Adh\xe9sion illimit\xe9e";
var CredPrePayType_lifetimeAction = "Obtenir une adh\xe9sion illimit\xe9e";
var CredPrePayType_lifetimeDescription = "<p>Pour une dur\xe9e limit\xe9e, nous vous offrons la possibilit\xe9 d’acheter une adh\xe9sion illimit\xe9e \xe0 la solution Degreed Skill Certification.</p> <p>L’offre n’est pas limit\xe9e \xe0 une seule comp\xe9tence, mais \xe0 autant de comp\xe9tences que vous le souhaitez et que Degreed propose tout au long de votre parcours.</p>";
var CredPrePayType_LimitedOffer = "Offre \xe0 dur\xe9e limit\xe9e\xa0!";
var CredPrePayType_OneSkillDescription = "<p>Faites certifier une comp\xe9tence.</p>\n<p>Recevez un certificat num\xe9rique et un lien de v\xe9rification.</p>\n<p>Des ressources num\xe9riques pour LinkedIn, votre CV, Facebook, Twitter et tout autre endroit o\xf9 vous publiez votre profil professionnel.</p>";
var CredPrePayType_TypeHeading = "Choisissez votre Plan de certification";
var CredResultsCtrl_CongratsParagraph = "Explorez les diff\xe9rentes fa\xe7ons de partager votre certificat et apprenez-en davantage sur votre niveau.";
var CredResultsCtrl_CongratsTitle = "F\xe9licitations, vous avez obtenu une certification Degreed\xa0!";
var CredReviewCtrl_ConfirmButton = "Confirmer la demande";
var CredReviewCtrl_Description = "V\xe9rifiez votre demande avant de la confirmer. Vous pourrez encore y apporter des modifications jusqu’\xe0 la date limite de soumission.";
var CredReviewCtrl_Endorsers = "Approbateurs";
var CredSpark_MissingEmployeeId = "Un ID d’employ\xe9 est n\xe9cessaire pour acc\xe9der \xe0 ce test d'\xe9valuation. Contactez votre administrateur Degreed pour configurer votre ID d’employ\xe9.";
var CredSparkSvc_AssessmentError = "Nous ne sommes pas parvenus \xe0 obtenir votre test d'\xe9valuation CredSpark.";
var CredSparkSvc_SyncError = "Nous ne sommes pas parvenus \xe0 synchroniser les derniers test d'\xe9valuation CredSpark, veuillez r\xe9essayer.";
var CredStartCtrl_ApplicationReviewed = "Demande examin\xe9e";
var CredStartCtrl_AssertBehaviors = "Identifier les trois principaux comportements li\xe9s \xe0 la comp\xe9tence";
var CredStartCtrl_DegreedSkillsCertification = "Certification de comp\xe9tence Degreed";
var CredStartCtrl_GetCertified = "Obtenir une certification";
var CredStartCtrl_GetCertifiedPrice = "Obtenir une certification Degreed dans le domaine \xab\xa0{{skillname}}\xa0\xbb - <strong>{{price}}</strong>";
var CredStartCtrl_GetCertifiedSkillFormat = "Obtenir une certification Degreed dans le domaine \xab\xa0{{skillname}}\xa0\xbb";
var CredStartCtrl_GetCertifiedUnlimitedFormat = "Obtenir une certification Degreed dans le domaine \xab\xa0{{skillname}}\xa0\xbb";
var CredStartCtrl_GetEndorsed = "Obtenir une approbation";
var CredStartCtrl_HowItWorks = "Comment \xe7a marche";
var CredStartCtrl_HowItWorksParagraph = "Le processus de certification de comp\xe9tence Degreed implique un test d'\xe9valuation et une validation approfondies de vos comp\xe9tences individuelles, et exigera quelques efforts de votre part. Voyez-le comme une demande simplifi\xe9e d’admission \xe0 l’universit\xe9, comprenant une auto-\xe9valuation, des commentaires d’autres personnes, l’avis d’experts et un examen des preuves fournies.";
var CredStartCtrl_ProvideEvidence = "Fournir une preuve";
var CredStartCtrl_ReceiveResults = "Recevoir les r\xe9sultats";
var CredStartCtrl_ReviewPeers = "Evaluer des pairs";
var CredStartCtrl_ReviewSubmit = "Examiner et soumettre";
var CredStartCtrl_VerifyYourSkills = "Validez vos comp\xe9tences \xe0 n’importe quel niveau (1 \xe0 8). Obtenez une reconnaissance officielle et certifi\xe9e de vos comp\xe9tences, peu importe comment et o\xf9 vous les avez acquises. Vous pouvez les ajouter \xe0 votre CV ou \xe0 votre profil professionnel et vous en servir tout au long de votre carri\xe8re pour mettre en avant votre expertise.";
var CredStartCtrl_VideoTitle = "vid\xe9o\xa0: Qu’est-ce que la certification de comp\xe9tence\xa0?";
var CredVerificationCtrl_Instructions1 = "Bienvenue dans Degreed Skill Certification pour la comp\xe9tence \xab\xa0{{skill}}\xa0\xbb. Pour poursuivre le processus, nous devons v\xe9rifier certaines informations personnelles. Vos nom et pr\xe9nom figureront sur votre certificat final.";
var CredVerificationCtrl_Instructions2 = "Pour poursuivre le processus, nous devons v\xe9rifier certaines informations personnelles, y compris votre nom complet et votre pi\xe8ce d’identit\xe9 avec photo. Vos nom et pr\xe9nom figureront sur votre certificat final.";
var DashboardNav_AddFocusSkills = "Ajouter des comp\xe9tences prioritaires";
var DashboardNav_AddSkill = "Ajouter une comp\xe9tence";
var DashboardNav_AddSkillRating = "Ajouter une \xe9valuation de comp\xe9tence";
var DashboardNav_AllActivity = "Toutes les activit\xe9s";
var DashboardNav_AllInsights = "Toutes les statistiques";
var DashboardNav_Assignments = "Formations assign\xe9es";
var DashboardNav_CertificationInProgress = "Certification en cours";
var DashboardNav_CertifiedLevel = "Certifi\xe9 : Niveau {{level}}";
var DashboardNav_Completions = "\xc9l\xe9ments termin\xe9s";
var DashboardNav_DismissRecommendation = "Ignorer l’\xe9l\xe9ment partag\xe9";
var DashboardNav_EvalInProgress = "Revue de comp\xe9tence en cours";
var DashboardNav_EvalRatingLevel = "Revue de comp\xe9tence\xa0: niveau {{level}}";
var DashboardNav_FindGroups = "Rechercher des groupes";
var DashboardNav_FindPathway = "Trouver un parcours";
var DashboardNav_FollowingEverybody = "Oups, il semble que nous n’avons plus de personnes \xe0 vous recommander.";
var DashboardNav_GetMonthlyActivityError = "D\xe9sol\xe9\xa0! Les r\xe9sultats de votre activit\xe9 mensuelle n’ont pas pu \xeatre r\xe9cup\xe9r\xe9s.";
var DashboardNav_ItemsViewed = "\xc9l\xe9ments consult\xe9s";
var DashboardNav_LearnerHub = "Espace apprenant";
var DashboardNav_ManageFollowing = "G\xe9rer les \xe9l\xe9ments suivis";
var DashboardNav_ManagerRatingLevel = "\xc9valuation du responsable : Niveau {{level}}";
var DashboardNav_MaxFocusSkillDesc = "Vous avez d\xe9j\xe0 4\xa0comp\xe9tences prioritaires. Supprimez ou remplacez-en une dans l’<b>onglet Comp\xe9tences de votre profil</b>.";
var DashboardNav_MonthlyActivity = "Activit\xe9 mensuelle";
var DashboardNav_NegativeActivityChange = "{{ label }} {{ count }} en moins par rapport au mois pr\xe9c\xe9dent";
var DashboardNav_NoActivityChange = "{{ label }} {{ count }} par rapport au mois pr\xe9c\xe9dent";
var DashboardNav_PathwayPercentComplete = "Termin\xe9 \xe0 {{percent}}\xa0%";
var DashboardNav_PeopleToFollow = "Personnes \xe0 suivre";
var DashboardNav_PointsEarned = "Points gagn\xe9s";
var DashboardNav_PositiveActivityChange = "{{ label }} {{ count }} en plus par rapport au mois pr\xe9c\xe9dent";
var DashboardNav_RefreshRecommended = "Nous sommes d\xe9sol\xe9s que ces partages ne vous aient pas plu. Actualisez la page pour afficher d’autres personnes \xe0 suivre.";
var DashboardNav_Resources = "Ressources";
var DashboardNav_SearchBySkill = "Rechercher par comp\xe9tence";
var DashboardNav_SelfRatingLevel = "Auto-\xe9valuation : Niveau {{level}}";
var DashboardNav_UpdateRatings = "Mettre \xe0 jour les \xe9valuations";
var DashboardNav_ViewMyProgress = "Voir mes progr\xe8s";
var DashboardNav_YourGroups = "Vos groupes";
var DashboardNav_YourPathways = "Vos parcours";
var DashboardNav_YourPlans = "Vos plans";
var DashboardNav_YourSkills = "Vos comp\xe9tences";
var DataPrivacyModalCtrl_AcceptContinue = "Accepter et continuer";
var DataPrivacyModalCtrl_Header = "Politique de confidentialit\xe9 des donn\xe9es";
var DataPrivacyModalCtrl_PolicyAcceptLabel = "Je confirme avoir lu et compris cette d\xe9claration de confidentialit\xe9";
var DataPrivacyModalCtrl_PolicyLegal = "";
var DataPrivacyModalCtrl_PolicyReviewLabel = "Veuillez lire et accepter la politique suivante pour utiliser Degreed";
var DegreeFormCtrl_CollegeName = "Le nom du coll\xe8ge ou de l’universit\xe9 doit \xeatre renseign\xe9.";
var DegreeFormCtrl_CompletionDate = "Veuillez indiquer la date de fin.";
var DegreeFormCtrl_DegreeLevel = "Le niveau du dipl\xf4me doit \xeatre renseign\xe9.";
var DegreeFormCtrl_DegreeTitle = "L’intitul\xe9 du dipl\xf4me doit \xeatre renseign\xe9.";
var DegreeFormCtrl_FieldOfStudy = "Le domaine d’\xe9tude doit \xeatre renseign\xe9 lors de l’ajout de formations.";
var DegreeFormCtrl_GradePointAvg = "Veuillez saisir une note moyenne valide sous forme de points.";
var deleteModal_Cancel = "Annuler";
var deleteModal_Delete = "Supprimer";
var dgActiveUserChartCtrl_A11yTooltipFormatDateRange = "du {{startDate}} au {{endDate}}";
var dgActiveUserChartCtrl_ActiveUsers = "Utilisateurs actifs";
var dgActiveUserChartCtrl_ActiveUsersToolTip = "Un utilisateur actif est une personne qui s’est connect\xe9e au moins une fois durant les p\xe9riodes figurant sur l’axe des x.";
var dgActiveUserChartCtrl_DailyActiveUsers = "Utilisateurs actifs par jour";
var dgActiveUserChartCtrl_Date = "Date";
var dgActiveUserChartCtrl_MonthlyActiveUsers = "Utilisateurs actifs par mois";
var dgActiveUserChartCtrl_NewReturningUsers = "Utilisateurs nouveaux et connus";
var dgActiveUserChartCtrl_NewUsers = "Nouveaux utilisateurs";
var dgActiveUserChartCtrl_NewUsersToolTip = "Les nouveaux utilisateurs ont eu leur premi\xe8re session active durant la p\xe9riode concern\xe9e.";
var dgActiveUserChartCtrl_ReturningUsers = "Utilisateurs connus";
var dgActiveUserChartCtrl_ReturningUsersToolTip = "Les utilisateurs connus se sont d\xe9j\xe0 connect\xe9s avant la p\xe9riode concern\xe9e et ont enregistr\xe9 une autre session active durant cette m\xeame p\xe9riode.";
var dgActiveUserChartCtrl_SelectUserType = "S\xe9lectionner le type d’utilisateur";
var dgActiveUserChartCtrl_WeeklyActiveUsers = "Utilisateurs actifs par semaine";
var dgActivityDetails_GoalActionFormat = "{{user}} {{action}} l’objectif {{goalName}}";
var dgActivityDetails_GroupActivityAdd = "{{user}} a ajout\xe9 le groupe {{settings}}";
var dgActivityDetails_GroupActivityRemove = "{{user}} a supprim\xe9 le groupe {{settings}}";
var dgActivityDetails_GroupActivityUpdate = "{{user}} a mis \xe0 jour le groupe {{settings}}";
var dgActivityDetails_InputActionAdded = "{{user}} a ajout\xe9 le contenu suivant ({{input}}) {{date}}";
var dgActivityDetails_InputActionArticle = "{{user}} a lu un article {{date}}";
var dgActivityDetails_InputActionBook = "{{user}} a lu un livre {{date}}";
var dgActivityDetails_InputActionCourse = "{{user}} a termin\xe9 un cours {{date}}";
var dgActivityDetails_InputActionEpisode = "{{user}} a termin\xe9 un \xe9l\xe9ment audio {{date}}";
var dgActivityDetails_InputActionEvent = "{{user}} a particip\xe9 \xe0 un \xe9v\xe9nement {{date}}";
var dgActivityDetails_InputActionTask = "{{user}} a termin\xe9 une t\xe2che {{date}}";
var dgActivityDetails_InputActionVideo = "{{user}} a regard\xe9 une vid\xe9o {{date}}";
var dgActivityDetails_PostedFormat = "{{user}} a publi\xe9 <span class='color-shuttle_a zeta'>{{timeAgo}}</span>";
var dgActivityDetails_RemoveActivity = "Souhaitez-vous vraiment supprimer cet \xe9l\xe9ment du flux du groupe \xa0?";
var dgActivityDetails_RemoveConfirm = "Oui";
var dgActivityDetails_UserActionDateFormat = "{{user}} {{action}} le {{input}} {{date}}";
var dgActivityDetails_UserActionFormat = "{{user}} {{action}} le {{input}}";
var dgActivityDetails_UserActionItemTitleDateFormat = "{{user}} {{action}} le suivant {{input}} {{title}} {{date}}";
var dgActivityDetails_UserActionItemTitleFormat = "{{user}} {{action}} le suivant {{input}} {{title}}";
var dgActivityDetails_UserActionTheFollowingDateFormat = "{{user}} a partag\xe9 ce contenu {{date}}";
var dgActivityDetails_UserActionTheFollowingDueDateFormat = "{{user}} a partag\xe9 le contenu suivant ({{input}}) {{date}} \xe0 terminer d’ici le {{dueDate}}";
var dgActivityDetails_UserActionTheFollowingFormat = "{{user}} {{action}} le suivant {{input}}";
var dgActivityDetails_UserAddedNewUserFormat = "{{user}} a ajout\xe9 {{newUser}} au groupe";
var dgActivityDetails_UserAssignedTheFollowingDateFormat = "{{user}} a assign\xe9 ce contenu ({{assignedDate}}) \xe0 terminer d’ici le {{dueDate}}";
var dgActivityDetails_UserAssignedTheFollowingFormat = "{{user}} a assign\xe9 ce contenu {{assignedDate}}";
var dgActivityDetails_UserJoinedGroupFormat = "{{user}} a rejoint le groupe.";
var dgActivityDetails_UserLeftGroupFormat = "{{user}} a quitt\xe9 le groupe.";
var dgActivityDetails_UserPostedAgoFormat = "{{user}} a publi\xe9 <span class='color-shuttle_a zeta'>{{timeAgo}}</span>";
var dgActivityDetails_UserPostedFormat = "{{user}} a publi\xe9 ceci";
var dgActivityDetails_UserRemovedUserFormat = "{{user}} a supprim\xe9 {{otherUser}} du groupe.";
var dgAddItems_AddItem = "+Ajouter";
var dgAddItems_EmailDomainError = "L’adresse e-mail ne correspond pas aux domaines mentionn\xe9s ci-dessus";
var dgAddItems_EmailExistsError = "L’adresse e-mail a d\xe9j\xe0 \xe9t\xe9 ajout\xe9e";
var dgAddItems_InvalidEmailError = "Adresse e-mail invalide";
var dgAddItems_MoreFormat = "+ plus {{count}}";
var dgAssignmentsOverview_AssignedGroupFormat = "{{personName}} a assign\xe9 {{groupName}} ceci {{contentType}} \xe0 {{contentAction}} {{hasDateHtml}}par {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_AssignedSingleFormat = "{{personName}} vous a assign\xe9 ce {{contentType}} \xe0 {{contentAction}} {{hasDateHtml}} par {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_AssignmentAbout = "Aucun apprentissage ne vous a \xe9t\xe9 assign\xe9 pour le moment.";
var dgAssignmentsOverview_AssignmentEmptyTitle = "Aucun r\xe9sultat";
var dgAssignmentsOverview_AssignmentsDescription = "Les formations assign\xe9es obligatoires doivent \xeatre termin\xe9es. Elles proviennent d’une source externe, et les \xe9l\xe9ments termin\xe9s feront l’objet d’une validation aupr\xe8s de cette derni\xe8re. Pour les autres formations, il vous sera indiqu\xe9 si ces derni\xe8res vous ont \xe9t\xe9 directement assign\xe9es, ou si elles ont \xe9t\xe9 partag\xe9es \xe0 un groupe auquel vous appartenez.";
var dgAssignmentsOverview_AssignmentSearchPlaceholder = "Filtrer par formation assign\xe9e";
var dgAssignmentsOverview_AssignmentsTableDescription = "Certaines formations assign\xe9es proviennent d’une source externe, et leur compl\xe9tion sera valid\xe9e par cette source. D’autres formations s’afficheront si elles ont \xe9t\xe9 partag\xe9es avec vous, vous ont \xe9t\xe9 assign\xe9es directement ou ont \xe9t\xe9 assign\xe9es \xe0 un groupe auquel vous appartenez.";
var dgAssignmentsOverview_CaughtUp = "\uD83C\uDF89 Vous \xeates \xe0 jour\xa0!";
var dgAssignmentsOverview_Completed = "Contenus termin\xe9s";
var dgAssignmentsOverview_CompletedAssignmentsEmpty = "Aucune formation assign\xe9e n’est termin\xe9e.";
var dgAssignmentsOverview_CountDueSoon = "{{count}} bient\xf4t \xe0 \xe9ch\xe9ance";
var dgAssignmentsOverview_CountOverdue = "{{count}} en retard";
var dgAssignmentsOverview_Description = "Les formations qui sont assign\xe9es \xe0 vous ou \xe0 un groupe dont vous faites partie";
var dgAssignmentsOverview_DueDate = "Date limite\xa0: {{date}}";
var dgAssignmentsOverview_DueSoon = "Date limite proche";
var dgAssignmentsOverview_EmptyBody = "Les formations assign\xe9es et obligatoires \xe0 terminer s’afficheront ici avec une date d’\xe9ch\xe9ance sp\xe9cifi\xe9e.";
var dgAssignmentsOverview_EmptyCompletedText = "Vos formations assign\xe9es termin\xe9es appara\xeetront ici";
var dgAssignmentsOverview_EmptyCompletedTitle = "Aucune formation assign\xe9e termin\xe9e";
var dgAssignmentsOverview_EmptyHeader = "Vous n’avez aucune formation assign\xe9e";
var dgAssignmentsOverview_EmptyToDoText = "Vos formations assign\xe9es appara\xeetront ici";
var dgAssignmentsOverview_Incomplete = "\xc0 compl\xe9ter plus tard";
var dgAssignmentsOverview_NextDueDate = "Prochaine date limite\xa0: {{date}}";
var dgAssignmentsOverview_NoAssignments = "Aucune formation assign\xe9e";
var dgAssignmentsOverview_NoAssignmentsBody = "Les formations obligatoires ou assign\xe9es appara\xeetront ici.";
var dgAssignmentsOverview_NoAssignmentsHeader = "Aucune formation assign\xe9e";
var dgAssignmentsOverview_NoAssignmentsHelpText = "Vos formations assign\xe9es appara\xeetront ici.";
var dgAssignmentsOverview_NoCompletedAssignments = "Aucune formation assign\xe9e termin\xe9e";
var dgAssignmentsOverview_NoInProgressAssignments = "Aucune formation assign\xe9e en cours";
var dgAssignmentsOverview_OtherAssignmentsBody = "Les formations qui ont \xe9t\xe9 partag\xe9es avec vous et vous ont \xe9t\xe9 assign\xe9es (directement ou dans le cadre d’un groupe auquel vous appartenez) appara\xeetront ici.";
var dgAssignmentsOverview_OtherAssignmentsEmpty = "Vous n’avez aucune autre formation assign\xe9e.";
var dgAssignmentsOverview_OtherAssignmentsHeader = "Autres formations assign\xe9es";
var dgAssignmentsOverview_Overdue = "Date limite pass\xe9e";
var dgAssignmentsOverview_OverdueAndDueSoon = "\xc9ch\xe9ances d\xe9pass\xe9es et \xe0 venir prochainement";
var dgAssignmentsOverview_RequiredAssignmentsBody = "Ces formations assign\xe9es doivent \xeatre termin\xe9es. Elles proviennent d’une source externe, et les \xe9l\xe9ments termin\xe9s feront l’objet d’une validation aupr\xe8s de cette derni\xe8re.";
var dgAssignmentsOverview_RequiredAssignmentsEmpty = "Vous n’avez aucune formation assign\xe9e obligatoire.";
var dgAssignmentsOverview_RequiredAssignmentsHeader = "Formations assign\xe9es obligatoires";
var dgAssignmentsOverview_RequiredGroupAttendedFormat = "{{groupNameHtml}} doit participer \xe0 ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_RequiredGroupCompletedFormat = "{{groupNameHtml}} doit compl\xe9ter ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_RequiredGroupFollowedFormat = "{{groupNameHtml}} doit suivre ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_RequiredGroupFormat = "{{groupName}} est requis pour {{contentAction}} ce {{contentType}} {{hasDateHtml}}par {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_RequiredGroupReadFormat = "{{groupNameHtml}} doit lire ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_RequiredGroupWatchedFormat = "{{groupNameHtml}} doit regarder ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_RequiredSingleAlreadyCompletedFormat = "Vous deviez terminer ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_RequiredSingleAttendedFormat = "Vous devez participer \xe0 ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_RequiredSingleAttendedOverdueFormat = "Vous deviez assister \xe0 ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_RequiredSingleCompletedFormat = "Vous devez compl\xe9ter ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_RequiredSingleCompletedOverdueFormat = "Vous deviez terminer ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_RequiredSingleFollowedFormat = "Vous devez suivre ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_RequiredSingleFollowedOverdueFormat = "Vous deviez suivre ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_RequiredSingleFormat = "Vous devez {{contentAction}} ce {{contentType}} {{hasDateHtml}}avant le {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_RequiredSingleOverdueFormat = "Vous deviez {{contentAction}} ceci ({{contentType}}){{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_RequiredSingleReadFormat = "Vous devez lire ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_RequiredSingleReadOverdueFormat = "Vous deviez lire ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_RequiredSingleWatchedFormat = "Vous devez regarder ceci{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_RequiredSingleWatchedOverdueFormat = "Vous deviez regarder cette vid\xe9o{{hasDateHtml}} avant le {{date}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_ThirdPartyCompletedDate = "Termin\xe9 {{hasCompletedDateHtml}}le {{completedDate}}{{hasDateEndHtml}}";
var dgAssignmentsOverview_YourAssignments = "Vos formations assign\xe9es";
var DgAssistant_ErrorText = "Une erreur s’est produite lors de la connexion au serveur. Veuillez r\xe9essayer plus tard.";
var DgAssistant_Executive_Description = "Invest in yourself, improve leadership and management performance and inspire your team";
var DgAssistant_Executive_Title = "Executive Coach";
var DgAssistant_LatestFrom = "LATEST FROM";
var DgAssistant_Name = "Assistant\xa0Degreed";
var DgAssistant_NoteText = "Remarque";
var DgAssistant_NotificationText = "Il s’agit d’un syst\xe8me en acc\xe8s anticip\xe9. Nous nous effor\xe7ons d’am\xe9liorer en continu sa r\xe9activit\xe9 et l’exp\xe9rience globale.";
var DgAssistant_PlaceholderProcessing = "Veuillez patienter…";
var DgAssistant_PlaceholderReady = "Saisissez une r\xe9ponse…";
var DgAssistant_PlaceholderStart = "Envoyez un message \xe0 l’Assistant Degreed…";
var DgAssistant_SelectedJourneyText = "Vous avez s\xe9lectionn\xe9 \xab\xa0{{item}}\xa0\xbb";
var DgAssistant_ShowLessText = "Afficher moins";
var DgAssistant_ShowMoreText = "Afficher plus";
var DgAssistant_StartNewText = "D\xe9marrer une nouvelle discussion";
var DgAssistant_WelcomeText = "En quoi puis-je vous aider aujourd’hui\xa0?";
var DgAssistant_YouText = "Vous";
var dgAuthorVideo_CameraNotAuthorizedError = "Cam\xe9ra non autoris\xe9e. Veuillez v\xe9rifier les param\xe8tres d’autorisation de votre m\xe9dia.";
var dgAuthorVideo_CameraNotFoundError = "Cam\xe9ra non trouv\xe9e. Veuillez v\xe9rifier le mat\xe9riel et les autorisations de votre appareil.";
var dgAuthorVideo_CameraNotReadableError = "Impossible de lancer la source vid\xe9o. Il se peut que la cam\xe9ra soit en cours d’utilisation.";
var dgAuthorVideo_ConfirmRedoRecording = "\xcates-vous s\xfbr de vouloir refaire votre enregistrement ? Votre enregistrement actuel sera perdu.";
var dgAuthorVideo_ModalTitle = "Cr\xe9ation de vid\xe9os";
var dgAuthorVideo_playerError = "Votre navigateur ne peut pas lire ce clip multim\xe9dia.";
var dgAuthorVideo_ProcessingVideo = "Traitement de la vid\xe9o...";
var dgAuthorVideo_recorderError = "Ce navigateur ne supporte pas l’enregistrement vid\xe9o. Vous pouvez charger une vid\xe9o avec ce navigateur, ou enregistrer dans Firefox ou Google Chrome.";
var dgAuthorVideo_RecordVideoOnlyError = "Ce navigateur ne prend pas en charge l’enregistrement vid\xe9o. Utilisez plut\xf4t Firefox ou Google Chrome.";
var dgAuthorVideo_Redirecting = "Redirection...";
var dgAuthorVideo_RedoRecording = "Refaire l’enregistrement";
var dgAuthorVideo_StartRecording = "D\xe9marrer l’enregistrement";
var dgAuthorVideo_StopRecording = "Arr\xeater l’enregistrement";
var dgAuthorVideo_TimeInMinutes = "{{timeInMinutes}} minutes";
var dgAuthorVideo_TimeLimitReached = "Limite de temps atteinte !";
var dgAuthorVideo_TimeWarningFormat = "{{timeRemaining}} minutes restantes !";
var dgAuthorVideo_TryAgain = "R\xe9essayer";
var dgAuthorVideo_UploadError = "Erreur de t\xe9l\xe9chargement";
var dgAuthorVideo_UploadErrorMessage = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors du t\xe9l\xe9chargement";
var dgAuthorVideo_Uploading = "Chargement";
var dgBrowseFeaturedLearning_FromPathwayFormat = "Du parcours {{pathwayName}}";
var dgBrowseFeaturedLearning_PopularGroupFormat = "Populaire dans le groupe {{groupName}}";
var dgBrowseFeaturedLearning_ReadByFormat = "R\xe9cemment lu par {{user}}";
var dgBrowseFeaturedLearning_RecommendedByFormat = "Partag\xe9 par {{recommender}}";
var dgBrowseFeaturedLearning_SavedForLater = "Enregistr\xe9 pour plus tard";
var dgBrowseFeaturedLearning_WatchedByFormat = "R\xe9cemment regard\xe9 par {{user}}";
var dgBrowsePathways_NoPathways = "Aucun parcours n’a \xe9t\xe9 trouv\xe9 dans le catalogue s\xe9lectionn\xe9.";
var dgBrowsePathways_NoRecommendations = "Impossible de trouver un parcours partag\xe9.";
var dgBrowseProviders_LaunchFormat = "Visiter {{icon}}";
var dgBrowseProviders_Search = "Rechercher";
var dgBrowseProviders_SearchResourcesFormat = "Rechercher du contenu {{siteName}}";
var dgBrowseProviders_VisitSiteFormat = "Visiter le site {{siteName}}";
var dgCarousel_ShowNextItems = "Afficher les \xe9l\xe9ments suivants";
var dgCarousel_ShowPreviousItems = "Afficher les \xe9l\xe9ments pr\xe9c\xe9dents";
var dgColorpickerTextDarkness_DarkText = "Texte fonc\xe9";
var dgColorpickerTextDarkness_LightText = "Texte clair";
var dgCombobox_SubmitSelection = "Appuyez sur Entr\xe9e pour transmettre votre s\xe9lection.";
var dgComment_CollapseCommentsFormat = "Replier {{count}} r\xe9ponses";
var dgComment_CollapseOneComment = "Replier 1 r\xe9ponse";
var dgComment_CommentHidden = "Ce commentaire est masqu\xe9 (inappropri\xe9)";
var dgComment_DeleteConfirm = "Oui";
var dgComment_DeleteTakeaway = "Souhaitez-vous r\xe9ellement supprimer cet \xe9l\xe9ment ?";
var dgComment_DeleteTakeawayReplies = "Souhaitez-vous r\xe9ellement supprimer cet \xe9l\xe9ment et ses r\xe9ponses \xa0?";
var dgComment_Edited = " (modifi\xe9)";
var dgComment_HideComments = "Masquer les commentaires";
var dgComment_JustNow = "il y a quelques instants";
var dgComment_PlusReadMore = "+ En savoir plus";
var dgComment_ReplyHidden = "Cette r\xe9ponse est masqu\xe9e (inappropri\xe9e)";
var dgComment_ShowComments = "Afficher les commentaires ({{count}})";
var dgComment_ShowCommentsFormat = "Afficher {{count}} r\xe9ponses";
var dgComment_ShowMoreCommentsFormat = "Afficher {{count}} plus";
var dgComment_ShowMultiplePreviousRepliesFormat = "Afficher {{count}} r\xe9ponses pr\xe9c\xe9dentes";
var dgComment_ShowOneComment = "Afficher 1 r\xe9ponse";
var dgComment_ShowPreviousReplies = "Afficher les r\xe9ponses pr\xe9c\xe9dentes";
var dgComment_ShowTakeawaysFormat = "Afficher {{count}} avis";
var dgComment_ViewConversation = "Avis";
var dgComment_ViewMoreFormat = "Afficher {{count}} plus...";
var dgComments_AddAReply = "Ajouter une r\xe9ponse";
var dgComments_ShareSomethingAbout = "Partagez des informations \xe0 ce sujet";
var dgComments_WhatDidYouLearnFormat = "Qu’avez-vous appris de ceci ?";
var dgCompleteViewedTip_ThanksPluralFormat = '<strong>F\xe9licitations\xa0!</strong> Vous venez de remporter {{pointsEarned}} points en compl\xe9tant ces {{completedCount}} \xe9l\xe9ments. Vous pourrez les retrouver dans <a href="/me?p=1#/overview" class="link">votre collection</a>.';
var dgCompleteViewedTip_ThanksSingularFormat = '<strong>F\xe9licitations\xa0!</strong> Vous venez de remporter {{pointsEarned}} points en compl\xe9tant cet \xe9l\xe9ment. Vous pourrez le retrouver dans <a href="/me?p=1#/overview" class="link">votre collection</a>.';
var dgContentCard_AssignedByFormat = "{{nameHtml}} vous a demand\xe9 de terminer ceci ({{inputType}}) avant le {{date}}.";
var dgContentCard_CompleteByDateFormat = "Terminez ceci avant le {{dateHtml}}";
var dgContentCard_FromJobRoleFormat = "Parce que vous suivez le plan {{jobRoleHtml}}";
var dgContentCard_FromPathwaysFormat = "Du parcours {{pathwayHtml}}";
var dgContentCard_LibraryContent = "Cela pourrait vous int\xe9resser.";
var dgContentCard_MoreLikeThisCompletedFormat = "Parce que vous avez compl\xe9t\xe9 {{inputHtml}}";
var dgContentCard_MoreLikeThisReadFormat = "Parce que vous avez lu {{inputHtml}}";
var dgContentCard_MoreLikeThisWatchedFormat = "Parce que vous avez regard\xe9 {{inputHtml}}";
var dgContentCard_Opportunity = "Nouvelle opportunit\xe9 \xe9quivalente";
var dgContentCard_PopularCompletedFormat = "Les membres de vos groupes ont termin\xe9 ce(tte) {{inputType}}";
var dgContentCard_PopularInFormat = "Populaire dans le groupe {{groupHtml}}";
var dgContentCard_PopularReadFormat = "Les membres de vos groupes ont lu ce(tte) {{inputType}}";
var dgContentCard_PopularWatchedFormat = "Les membres de vos groupes ont regard\xe9 ce(tte) {{inputType}}";
var dgContentCard_ReadByFormat = "R\xe9cemment lu par {{nameHtml}}";
var dgContentCard_ReadMore = "en savoir plus";
var dgContentCard_RecommendedByFormat = "Partag\xe9 par {{nameHtml}}";
var dgContentCard_RequiredLearning = "Formation obligatoire";
var dgContentCard_RequiredLearningDate = "Formation obligatoire \xe9chue le {{dateHtml}}";
var dgContentCard_SavedForLater = "Contenus enregistr\xe9s";
var dgContentCard_WatchedByFormat = "R\xe9cemment regard\xe9 par {{nameHtml}}";
var dgContentHosting_DragAndDrop = "Faites un glisser-d\xe9poser ou cliquez pour t\xe9l\xe9charger un fichier.";
var dgContentHosting_Hosted = "H\xe9berg\xe9";
var dgContentHosting_HostedFiles = "Fichiers h\xe9berg\xe9s";
var dgContentHosting_InvalidFileType = "Type de fichier non valide. Consultez notre {{startAnchor}}Centre de connaissances{{endAnchor}} pour obtenir la liste des types de fichier pris en charge.";
var dgContentHosting_OrgStorageLimitAlmostReached = "Votre organisation dispose de {{ startBoldTag }} {{ orgStorageRemainingInMB }}\xa0Mo {{ endBoldTag }}d’espace de stockage restant sur une capacit\xe9 totale de {{ orgStorageLimitInMB }}\xa0Mo.";
var dgContentHosting_OrgStorageLimitIsReached = "Votre organisation a utilis\xe9 la totalit\xe9 de sa capacit\xe9 de {{ orgStorageLimitInMB }}\xa0Mo.";
var dgContentTile_AuthorshipAuthor = "Auteur";
var dgContentTile_AuthorshipCreator = "Cr\xe9ateur";
var dgContentTile_AuthorshipPresenter = "Pr\xe9sentateur";
var dgContentTile_AuthorshipTeacher = "Professeur";
var dgContentTile_Verified = "VALID\xc9";
var dgCookieBanner_accept = "J’ai compris\xa0!";
var dgCookieBanner_learnMore = "En savoir plus.";
var dgCookieBanner_message = 'Nous utilisons des cookies pour am\xe9liorer votre exp\xe9rience. Consultez notre page d\xe9di\xe9e aux <a class="link underline" href="/api/about/cookienotice">cookies</a> pour en savoir plus sur notre politique.';
var dgCookieBanner_message_V2 = 'Degreed utilise des cookies essentiels pour am\xe9liorer votre exp\xe9rience. Consultez notre page d\xe9di\xe9e aux cookies pour en savoir plus sur leur utilisation dans le site Degreed <a class="link underline" href="/api/about/cookienotice">En savoir plus</a>';
var dgCopyLink_CopyInviteLink = "Copier le lien d’invitation";
var dgCopyLink_CopyLink = "Copier le lien";
var dgCopyLink_InviteURL = "URL d’invitation";
var dgCredentialDisplay_StartDateFormat = "Commenc\xe9 le {{date}}";
var dgCredentialDisplay_ViewApplicationFormat = "Voir l’application {{name}}";
var dgCredPrePayLogin_DegreedAccount = "Compte Degreed";
var dgCredPrePayLogin_LoginContinue = "Pour continuer, connectez-vous \xe0 votre compte Degreed existant ou choisissez un mot de passe pour cr\xe9er un nouveau compte Degreed.";
var dgDiscipline_ExpertsFormat = "Experts principaux : {{experts}}";
var dgDiscipline_StartApplication = "Lancer la candidature";
var dgDownloadableReports_ChooseGroup = "Choisir un groupe";
var dgDownloadableReports_ChooseReportType = "Choisir un type de rapport";
var dgDownloadableReports_DataSet = "D\xe9finir les donn\xe9es";
var dgDownloadableReports_DateCreated = "Date de cr\xe9ation";
var dgDownloadableReports_datePickerText = "Le filtre calendaire n’est pas li\xe9 aux rapports sur les comp\xe9tences. Les dates s\xe9lectionn\xe9es s’appliquent uniquement aux rapports portant sur le contenu et les recherches.";
var dgDownloadableReports_DateRange = "Plage de dates";
var dgDownloadableReports_Download = "T\xe9l\xe9charger";
var dgDownloadableReports_DownloadableReports = "Rapports t\xe9l\xe9chargeables";
var dgDownloadableReports_DownloadReport = "T\xe9l\xe9charger le rapport";
var dgDownloadableReports_Generate = "G\xe9n\xe9rer";
var dgDownloadableReports_GenerateDataReport = "G\xe9n\xe9rer un rapport de donn\xe9es";
var dgDownloadableReports_GenerateReport = "G\xe9n\xe9rer un rapport";
var dgDownloadableReports_Generating = "G\xe9n\xe9ration";
var dgDownloadableReports_GroupOptionalTitle = "Groupe (facultatif)";
var dgDownloadableReports_GroupTitle = "Groupe";
var dgDownloadableReports_MaxDaysReached = "Veuillez ne pas s\xe9lectionner plus de 93 jours.";
var dgDownloadableReports_NoAvailableGroups = "No Groups Available";
var dgDownloadableReports_NoMatchingReportTypes = "Aucun type de rapport correspondant";
var dgDownloadableReports_Parameters_InputIdentifier_Name = "Contenu";
var dgDownloadableReports_Parameters_InputIdentifier_Placeholder = "Choisir un \xe9l\xe9ment de contenu";
var dgDownloadableReports_Parameters_InputIdentifierList_Name = "Contenu (multiple)";
var dgDownloadableReports_Parameters_InputIdentifierList_Placeholder = "Choisir un ou plusieurs \xe9l\xe9ments de contenu";
var dgDownloadableReports_Report10 = "Tendances du contenu - Effectu\xe9";
var dgDownloadableReports_Report11 = "Tendances du contenu - Visualis\xe9";
var dgDownloadableReports_Report12 = "Principaux prestataires";
var dgDownloadableReports_Report13 = "Rubriques populaires";
var dgDownloadableReports_Report14 = "Recherches populaires";
var dgDownloadableReports_Report3 = "Contenu termin\xe9";
var dgDownloadableReports_Report4 = "Contenu visualis\xe9";
var dgDownloadableReports_Report5 = "Utilisation du contenu par le fournisseur";
var dgDownloadableReports_Report6 = "Contenu compl\xe9t\xe9 par sujets";
var dgDownloadableReports_Report7 = "Rechercher des termes";
var dgDownloadableReports_Report8 = "Principaux prestataires";
var dgDownloadableReports_Report9 = "Rubriques populaires";
var dgDownloadableReports_ReportContentCompletionsDownload = "Contenus valid\xe9s";
var dgDownloadableReports_ReportContentTrendsAdded = "Contenu termin\xe9";
var dgDownloadableReports_ReportContentTrendsViewed = "Contenu consult\xe9";
var dgDownloadableReports_ReportDate = "Les rapports contiennent des donn\xe9es du {{startDate}} au {{endDate}}";
var dgDownloadableReports_ReportGenerated = "Plage de dates";
var dgDownloadableReports_ReportPathwayDetailsDownload = "D\xe9tails du parcours";
var dgDownloadableReports_ReportPopularTopics = "Contenu ajout\xe9 par comp\xe9tence";
var dgDownloadableReports_ReportSkillAnalyticsTop1000SkillsRated = "Analyse des comp\xe9tences\xa0: 1\xa0000\xa0comp\xe9tences les mieux \xe9valu\xe9es";
var dgDownloadableReports_ReportSkillReport = "Rapport de comp\xe9tences";
var dgDownloadableReports_ReportTop1000SkillsRated = "Les 1\xa0000 principales comp\xe9tences \xe9valu\xe9es";
var dgDownloadableReports_ReportTopProviders = "Contenu ajout\xe9 par fournisseur";
var dgDownloadableReports_ReportTopSearches = "Termes de recherche";
var dgDownloadableReports_ReportType = "Type de rapport";
var dgDownloadableReports_ReportTypeRequired = "Type de rapport obligatoire";
var dgDownloadableReports_ToastMessage = "Le rapport que vous avez demand\xe9 est en cours de g\xe9n\xe9ration. Nous vous informerons quand il sera pr\xeat \xe0 \xeatre t\xe9l\xe9charg\xe9.";
var dgEnrolled_CompletedTooltipFormat = "{{completedCount}} \xe9l\xe9ment(s) termin\xe9(s) sur {{totalCount}}";
var dgEnrolled_DateAddedColumn = "Date d’ajout";
var dgEnrolled_EnrolledCountFormat = "{{count}} inscrit";
var dgEnrolled_EnrollmentDate = "Date de l’inscription";
var dgEnrolled_NameColumn = "Nom";
var dgExtensions_AccessError = "Une erreur s’est produite.";
var dgExtensions_AccessGranted = "Acc\xe8s autoris\xe9.";
var dgExtensions_AddBookmarkletManually = "Ajouter un bookmarklet manuellement\xa0:";
var dgExtensions_AddCompletedCourses = "Ajoutez les formations effectu\xe9es \xe0 votre profil Degreed.";
var dgExtensions_AddCompletedItems = "ajouter les \xe9l\xe9ments termin\xe9s \xe0 votre collection\xa0;";
var dgExtensions_AddToChrome = "Ajouter \xe0 Chrome";
var dgExtensions_AddToCollection = "ajouter les \xe9l\xe9ments termin\xe9s \xe0 votre collection\xa0;";
var dgExtensions_AdminFlexEd = "G\xe9rez les cartes FlexEd de votre organisation.";
var dgExtensions_AppsUnavailable = "Les applications de navigateur Degreed sont actuellement indisponibles pour votre organisation.";
var dgExtensions_Bookmarklet = "bookmarklet";
var dgExtensions_BookmarkletDragInstructions = "Faites-moi glisser dans la barre des favoris";
var dgExtensions_Bookmarks = "favoris";
var dgExtensions_BrowserBookmarklet = "Signapplet du navigateur";
var dgExtensions_BrowserWindowIllustrationAlt = "illustration d’une fen\xeatre de navigateur o\xf9 le bookmarklet Degreed a \xe9t\xe9 install\xe9";
var dgExtensions_ButtonSuccess = "Vous pouvez d\xe9sormais utiliser le bouton Degreed.";
var dgExtensions_Chrome = "Chrome";
var dgExtensions_ChromeExtension = "Extension Chrome";
var dgExtensions_ChromeInstructionsFormat = "cliquant sur {{strongTagStart}}Afficher\xa0> Toujours afficher la barre des favoris{{strongTagEnd}}.";
var dgExtensions_CopyBookmark = "Copier une URL de favori";
var dgExtensions_CreatePathways = "cr\xe9er des parcours\xa0;";
var dgExtensions_DegreedExtension = "Extension Degreed";
var dgExtensions_DisplayFavoritesFormat = "*\xa0Affichez vos {{favType}} en {{instruction}}";
var dgExtensions_DragToInstallBookmarks = "Faites glisser ceci dans la barre des favoris de votre navigateur*.";
var dgExtensions_DragToInstallFavorites = "Faites-le glisser dans la barre des favoris de votre navigateurs,*<br>ou effectuez un clic droit sur le bouton et s\xe9lectionnez \xab\xa0Ajouter aux favoris…\xa0\xbb";
var dgExtensions_EmailAddressPlaceholder = "votreemail@entreprise.com";
var dgExtensions_Extension = "extension";
var dgExtensions_ExtensionInstalledAlt = "illustration d’une fen\xeatre de Chrome o\xf9 l’extension Degreed a \xe9t\xe9 install\xe9e";
var dgExtensions_Favorites = "favoris";
var dgExtensions_Firefox = "Firefox";
var dgExtensions_FirefoxInstructionsFormat = "cliquer sur {{strongTagStart}}Afficher > Barres d’outils > Barre des signets{{strongTagEnd}}";
var dgExtensions_GetStarted = "Bonjour\xa0! Saisissez votre adresse e-mail professionnelle afin que nous puissions vous retrouver dans notre syst\xe8me pour vous aider \xe0 d\xe9marrer.";
var dgExtensions_GrantAccess = "Autoriser l’acc\xe8s";
var dgExtensions_GrantAccessHeader = "Autoriser l’acc\xe8s\xa0?";
var dgExtensions_IEInstructionsFormat = "{{strongTagStart}}Cliquer avec le bouton droit dans l’espace vide au-dessus de la barre d’adresse > Barre des favoris{{strongTagEnd}}";
var dgExtensions_InternetExplorer = "Internet Explorer";
var dgExtensions_InvalidEmailError = "Veuillez saisir une adresse e-mail valide.";
var dgExtensions_iOS = "iOS";
var dgExtensions_ItemsToPlans = "ajouter des \xe9l\xe9ments \xe0 vos parcours et plans.";
var dgExtensions_MakeChanges = "Apportez des modifications \xe0 votre compte \xe0 l’aide de l’application mobile.";
var dgExtensions_ManualBookmarkInstructions = "URL du favori copi\xe9e. Cr\xe9ez un nouveau favori manuellement sur votre navigateur en utilisant la commande \xab\xa0+ Degreed\xa0\xbb, collez l’URL copi\xe9e dans le champ correspondant de la fen\xeatre de dialogue puis enregistrez votre nouveau bookmarklet.";
var dgExtensions_Mobile = "Mobile";
var dgExtensions_Oauth_Authorize = "L’extension Degreed";
var dgExtensions_Oauth_Request_Access = "L’extension Degreed demande l’autorisation d’utiliser votre compte Degreed pour\xa0:";
var dgExtensions_PlusDegreedButton = "+ Degreed";
var dgExtensions_RequestAccess = "demande l’autorisation d’utiliser votre compte Degreed pour\xa0:";
var dgExtensions_Safari = "Safari";
var dgExtensions_SafariInstructionsFormat = "cliquer sur {{strongTagStart}}Afficher > Afficher la barre des favoris{{strongTagEnd}}";
var dgExtensions_SaveItemsForLater = "enregistrer des \xe9l\xe9ments afin que vous puissiez les retrouver facilement plus tard\xa0;";
var dgExtensions_ShareItems = "partager des \xe9l\xe9ments avec d’autres personnes\xa0;";
var dgExtensions_SummaryEdge = "Contactez l’administrateur Degreed de votre organisation si vous souhaitez installer l’extension Degreed pour Edge ou installez-le sur un autre navigateur pris en charge\xa0: Chrome, IE, Safari ou Firefox.";
var dgExtensions_SummaryFormat = "Ce bouton ({{type}}) vous permet de proc\xe9der facilement au suivi de vos contenus de formation, depuis n’importe quel site web. C’est un moyen tr\xe8s pratique d’acc\xe9der aux fonctionnalit\xe9s Degreed hors de la plateforme.";
var dgExtensions_TitleEdge = "Le bouton Degreed n\xe9cessite un d\xe9ploiement informatique pour le navigateur Edge";
var dgExtensions_TitleFormat = "Toutes vos fonctionnalit\xe9s Degreed pr\xe9f\xe9r\xe9es directement dans {{browser}}.";
var dgExtensions_TryOurBookmarklet = "Essayez notre bookmarklet.";
var dgExtensions_UnableToDownload = "Impossible de t\xe9l\xe9charger les extensions\xa0?";
var dgExtensions_WishGrantAccess = "Souhaitez-vous autoriser l’acc\xe8s\xa0?";
var dgExtensions_YourBrowser = "votre navigateur";
var dgFeed_AddSomething = "Ajoutez quelque chose que vous avez appris...";
var dgFeed_AddTopCategories = "Ajouter les cat\xe9gories principales \xe0 votre profil";
var dgFeed_CompletedCongrats = "Vous avez termin\xe9 le Programme d’aujourd’hui. Votre cerveau vous remercie.";
var dgFeed_CompletedHeading = "Termin\xe9 aujourd’hui";
var dgFeed_DismissTip = "  Ignorer ce conseil";
var dgFeed_EmptyStateFormat = "C’est un peu calme ici.{{break}}Suivez {{pathwayLink}} et {{peopleLink}} pour que les recommandations arrivent.";
var dgFeed_EnrolledPathways = "Parcours inscrits";
var dgFeed_EnrollInPathway = "S’inscrire \xe0 un parcours";
var dgFeed_FollowedPathways = "Parcours suivis";
var dgFeed_FollowPathway = "Suivre un parcours";
var dgFeed_FollowUsers = "Suivre d’autres utilisateurs de Degreed";
var dgFeed_KeepLearning = "Poursuivre votre apprentissage";
var dgFeed_Personalize = "Personnalisez le Programme d’aujourd’hui :";
var dgFeed_ShowAllAssignedFormat = "Afficher tous les {{count}} \xe9l\xe9ments attribu\xe9s";
var dgFeed_ViewAllYourPathways = "Voir tous vos parcours";
var dgFileUploadButton_FileNameUnknown = "nom-de-fichier-inconnu";
var dgFileUploadButton_FilesizeError = "D\xe9sol\xe9 ! Votre fichier doit \xeatre inf\xe9rieur \xe0 {{filesizeLimit}}";
var dgFileUploadButton_FiletypeError = "Vous pouvez uniquement charger des fichiers de type {{filePattern}}.";
var dgFileUploadButton_HelperInfo = "S\xe9lectionnez un fichier ({{filePattern}}) aillant une taille allant jusqu’\xe0 {{filesizeLimit}}.";
var dgFileUploadButton_ImageUpload = "Faites glisser un fichier ou cliquez pour choisir";
var dgFileUploadButton_ProcessingFile = "Traitement du fichier...";
var dgFileUploadButton_UploadComplete = "Chargement termin\xe9";
var dgFileUploadButton_UploadError = "Erreur de t\xe9l\xe9chargement";
var dgFileUploadButton_UploadErrorMessage = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors du t\xe9l\xe9chargement";
var dgFileUploadButton_UploadFile = "T\xe9l\xe9charger un fichier";
var dgFileUploadButton_Uploading = "Chargement";
var dgFileUploadButton_ViewFileDocumentation = "Consulter notre documentation sur les fichiers";
var dgFlexMembers_FollowersFormat = "{{followersCount}}\xa0abonn\xe9(s)";
var dgFlexMembers_UpdatedDaily = "Mise \xe0 jour quotidienne";
var dgFlexRow_AddLinkSection = "Ajouter une section de lien";
var dgFlexRow_AddSection = "Ajouter une section";
var dgFlexRow_AddSectionSuccess = "Section ajout\xe9e avec succ\xe8s";
var dgFlexRow_AddTextAndImage = "Section Ajouter un texte et une image";
var dgFlexRow_AddTextSection = "Ajouter une zone de texte";
var dgFlexRow_All = "Tout";
var dgFlexRow_AllDescription = "Afficher tous les \xe9l\xe9ments avec des lignes illimit\xe9es";
var dgFlexRow_Compact = "Compact";
var dgFlexRow_CompactDescription = "1 rang\xe9e d\xe9roulante avec un lien pour voir tout";
var dgFlexRow_CustomErrors_RequiredMultiple = "Vous devez remplir au moins un champ\xa0: Titre, Texte ou Image.";
var dgFlexRow_DeleteConfirmSubmit = "Supprimer la section";
var dgFlexRow_DeleteSectionBody = "Voulez-vous vraiment supprimer la section {{sectionNameHtml}} de ce plan \xa0?";
var dgFlexRow_DeleteSectionPrompt = "Voulez-vous vraiment supprimer la section {{type}} \xa0?";
var dgFlexRow_DeleteSuccess = "La section a bien \xe9t\xe9 supprim\xe9e";
var dgFlexRow_EditDetails = "Modifier les d\xe9tails";
var dgFlexRow_EditLinkSection = "Modifier la section de lien";
var dgFlexRow_EditSectionDescription = "Description";
var dgFlexRow_EditSectionDescriptionPlaceholder = "Ajouter une description";
var dgFlexRow_EditSectionDetails = "Modifier les informations de la section";
var dgFlexRow_EditSectionDisplayOptions = "Affichage";
var dgFlexRow_EditSectionTitle = "Titre";
var dgFlexRow_EditSectionTitlePlaceholder = "Ajouter un titre";
var dgFlexRow_EditTextAndImage = "Section Modifier le texte et l’image";
var dgFlexRow_EditTextSection = "Modifier la zone de texte";
var dgFlexRow_Expanded = "\xc9tendu";
var dgFlexRow_ExpandedDescription = "2 lignes statiques avec un lien pour voir tout";
var dgFlexRow_FieldRequired = "Ce champ doit \xeatre renseign\xe9.";
var dgFlexRow_Link = "Lien";
var dgFlexRow_LinkDescription = "Description";
var dgFlexRow_LinkSectionTitle = "Titre";
var dgFlexRow_LinkSectionTitleHelperText = "Correspond \xe0 l’intitul\xe9 de la section.";
var dgFlexRow_LinkTitle = "Titre du lien";
var dgFlexRow_LinkTitleHelperText = "Ce titre appara\xeetra sur le bouton de lien ; nous sugg\xe9rons de le garder court.";
var dgFlexRow_RemoveSection = "Supprimer la section";
var dgFlexRow_ReorderItems = "R\xe9organiser les \xe9l\xe9ments";
var dgFlexRow_ReorderSectionsTitle = "R\xe9organiser les sections";
var dgFlexRow_ResourceAddedSuccess = "Ressources ajout\xe9es avec succ\xe8s";
var dgFlexRow_ResourceRemovedSuccess = "Ressources supprim\xe9es avec succ\xe8s";
var dgFlexRow_SectionTypeLabelFormat = "Section {{sectionType}}";
var dgFlexRow_ShowCompactDescription = "Affiche une seule ligne d’\xe9l\xe9ments ainsi qu’un bouton pour pouvoir afficher tous les \xe9l\xe9ments";
var dgFlexRow_TextTitle = "Texte";
var dgFlexRow_TextTitlePlaceholder = "Ajoutez des informations suppl\xe9mentaires, le contexte, etc.";
var dgFlexRow_UrlRequired = "Une URL valide est requise (http://)";
var dgFlexRow_YesDeleteButton = "Oui, supprimer";
var dgGlobalAdd_Achievement = "R\xe9ussites";
var dgGlobalAdd_AchievementDescription = "D\xe9montrez vos comp\xe9tences en documentant vos accomplissements.";
var dgGlobalAdd_AddNewOutcomeTooltipFormat = "Ajouter un nouveau {{newOutcome}} \xe0 votre profil";
var dgGlobalAdd_Content = "Ajouter du contenu \xe0 votre profil";
var dgGlobalAdd_CreateAPathway = "Cr\xe9er un parcours";
var dgGlobalAdd_Description = "Ajoutez vos formations, exp\xe9riences et cours \xe0 votre profil.";
var dgGlobalAdd_ExtensionsFormat = "Vous naviguez beaucoup sur le Web\xa0? Utilisez le {{startAnchor}}bouton Degreed{{endAnchor}} pour suivre vos contenus de formation.";
var dgGlobalAdd_IntegrationsFormat = "Connectez-vous aux fournisseurs et importez les \xe9l\xe9ments termin\xe9s dans votre profil \xe0 l’aide d’{{startAnchor}}int\xe9grations{{endAnchor}}.";
var dgGlobalAdd_OutcomeTypeFormat = "Vous avez ajout\xe9 votre maximum de {{outcomeLimit}} {{outcomeType}}. Vous pouvez les modifier ou les supprimer de votre collection.";
var dgGlobalAdd_Sections_Achievement = "R\xe9ussite";
var dgGlobalAdd_Sections_Content = "Contenu";
var dgGlobalAdd_Sections_Extensions = "Vous naviguez beaucoup sur le Web\xa0? Utilisez le {{startAnchor}}bouton Degreed{{endAnchor}} pour suivre vos contenus de formation.";
var dgGlobalAdd_TooltipFormat = "Ajouter un nouveau {{inputType}} \xe0 votre profil";
var dgGlobalAddSuccess_CompletedToday = "Termin\xe9 aujourd’hui";
var dgGlobalAddSuccess_Description = "Tous les \xe9l\xe9ments que vous marquez comme termin\xe9s sur Degreed sont ajout\xe9s aux collections de votre profil. Vous pouvez ainsi les retrouver ou les partager ult\xe9rieurement.";
var dgGlobalAddSuccess_ErrorWhenAdding = "Un probl\xe8me est survenu. Veuillez r\xe9essayer d’ajouter l’\xe9l\xe9ment \xe0 votre profil. Si le probl\xe8me persiste, contactez-nous pour obtenir de l’aide.";
var dgGlobalAddSuccess_LearningItems = "\xc9l\xe9ments de formation";
var dgGlobalAddSuccess_Points = "points";
var dgGlobalAddSuccess_RewardTrophy = "Troph\xe9e de r\xe9compense";
var dgGlobalAddSuccess_StartedYourCollection = "Vous avez commenc\xe9 votre collection\xa0!";
var dgGlobalAddSuccess_ViewYourCollection = "Afficher votre collection";
var dgGlobalSearch_A11ySearchDescription = "Saisissez le texte et appuyez sur Entr\xe9e ou sur la fl\xe8che vers le bas pour s\xe9lectionner les \xe9l\xe9ments sugg\xe9r\xe9s.";
var dgGlobalSearch_SearchExpandLabel = "D\xe9velopper la recherche";
var dgGlobalSearch_TopicsLabel = "Vos comp\xe9tences";
var dgGoalItem_AssignedByFormat = "Assign\xe9 {{startSpan}} par {{startAnchor}} {{goalCreatorName}}{{endAnchor}}{{endSpan}} \xe0 {{startAnchor2}}{{goalName}}{{endAnchor}}";
var dgGoalItem_GoalEndDateFormat = "Date limite le {{goalEndDate}}";
var dgGoalTitle_CompleteInputFormat = "Terminer {{htmlInputTitle}} {{inputType}}";
var dgGoalTitle_CompletePathwayFormat = "Terminer le parcours {{htmlPathwayTitle}}";
var dgGoalTitle_EarnPointsByTagFormat = "Gagnez {{startStrong}}{{goalPoints}}{{endStrong}} plus de pts dans {{anchorHtml}}";
var dgGroupDelete_DeleteGroupTitle = "Supprimer le groupe";
var dgGroupDelete_DeleteLabelFormat = "Saisissez \xab\xa0{{delete}}\xa0\xbb";
var dgGroupDelete_DeleteLabelInfoFormat = "Saisissez le mot \xab\xa0{{delete}}\xa0\xbb";
var dgGroupDelete_Instructions = "Pour supprimer le groupe, saisissez \xab\xa0{{delete}}\xa0\xbb dans le champ puis cliquez sur le bouton \xab\xa0Supprimer le groupe\xa0\xbb.";
var dgGroupDelete_InstructionsFormat = "Pour supprimer ce groupe, saisissez \xab\xa0{{delete}}\xa0\xbb dans le champ, puis s\xe9lectionnez \xab\xa0Supprimer le groupe\xa0\xbb.";
var dgGroupGoalItem_ViewParticipants = "Afficher les participants";
var dgGroupGoals_CompleteAPathway = "Effectuer un parcours";
var dgGroupGoals_Completed = "Termin\xe9";
var dgGroupGoals_CreateAGoal = "Cr\xe9er un objectif";
var dgGroupGoals_CreateGoal = "Cr\xe9er un objectif";
var dgGroupGoals_CreateGoalSummary = "Les objectifs sont id\xe9aux pour suivre votre avancement lorsque vous gagnez des points dans une cat\xe9gorie ou que vous empruntez un parcours.";
var dgGroupGoals_EarnMorePoints = "Gagnez des points suppl\xe9mentaires dans une cat\xe9gorie";
var dgGroupGoals_HowTo = "Cr\xe9ez des objectifs de groupe en cliquant sur le bouton \xab\xa0Cr\xe9er un objectif\xa0\xbb.";
var dgGroupGoals_NoGoals = "Vous n’avez pas encore cr\xe9\xe9 d’objectifs de groupe.";
var dgGroupGoalsOverview_HowTo = "Cr\xe9ez un objectif en cliquant sur \xab\xa0Objectifs\xa0\xbb puis \xab\xa0Cr\xe9er un objectif\xa0\xbb.";
var dgGroupInvite_groupInviteNotificationInviteFormat = "{{personNameHtml}} vous a invit\xe9 au groupe {{groupNameHtml}}";
var dgGroupMembers_ActiveMembers = "Membres actifs";
var dgGroupMembers_AddMember = "Ajouter un membre";
var dgGroupMembers_AddPeople = "Ajouter des personnes au groupe";
var dgGroupMembers_AddPeopleButton = "Ajouter des personnes";
var dgGroupMembers_AddUsers = "Ajouter des utilisateurs";
var dgGroupMembers_Admin = "Administrateur";
var dgGroupMembers_CalculatingMembership = "La composition du groupe est en cours d’\xe9laboration.";
var dgGroupMembers_DateInvited = "Date d’invitation";
var dgGroupMembers_DateJoined = "Date d’inscription";
var dgGroupMembers_Invited = "Invit\xe9";
var dgGroupMembers_InviteMembers = "Inviter un membre";
var dgGroupMembers_LastActive = "Derni\xe8re activit\xe9";
var dgGroupMembers_MemberSettings = "Param\xe8tres des membres";
var dgGroupMembers_NameHeader = "Nom";
var dgGroupMembers_NoActiveMemberMatch = "Aucun membre actif ne correspond \xe0 la recherche";
var dgGroupMembers_NoDynamicMemberDescription = "S’il s’agit d’un nouveau groupe, sa composition est peut-\xeatre en cours.";
var dgGroupMembers_NoMatches = "Aucun membre de ce groupe ne correspond aux termes de la recherche.";
var dgGroupMembers_NoMembers = "Il n’y a actuellement aucun membre";
var dgGroupMembers_NoPendingMembers = "Aucun membre en attente";
var dgGroupMembers_NoPendingRequests = "Aucune demande en attente";
var dgGroupMembers_NoPermission = "Vous n’avez pas l’autorisation d’afficher la liste des membres.";
var dgGroupMembers_NoUsersMatch = "Aucun utilisateur ne correspond aux attributs de ce groupe.";
var dgGroupMembers_PendingApprovalHeader = "En attente d’approbation";
var dgGroupMembers_PendingInvitationFormat = "{{memberCount}} invitations en attente";
var dgGroupMembers_PendingInvitations = "Invitations en attente";
var dgGroupMembers_PendingMemberSettings = "Param\xe8tres des membres en attente";
var dgGroupMembers_PendingRequests = "Demandes en attente";
var dgGroupMembers_Points = "Points";
var dgGroupMembers_PointsTooltip = "Total des points obtenus li\xe9s au contenu effectu\xe9 (exp\xe9rience non comprise)";
var dgGroupMembers_Resend = "Renvoyer";
var dgGroupMembers_ResendAll = "Tout renvoyer";
var dgGroupMembers_ResendInvites = "Renvoyer les invitations";
var dgGroupMembers_SearchByName = "Rechercher par nom";
var dgGroupMembers_SearchForMember = "Rechercher un membre";
var dgGroupMembers_SelectedCountFormat = "({{checkedCount}}/{{pendingInviteCount}} s\xe9lectionn\xe9)";
var dgGroupMembers_TotalMemberCountFormat = "{{memberCount}} membres";
var dgGroupOverview_AdministrativeGroup = "Groupe administratif";
var dgGroupOverview_ClosedGroup = "Groupe ferm\xe9";
var dgGroupOverview_DynamicAdminGroup = "Groupe dynamique d’administrateurs";
var dgGroupOverview_GroupMembershipPending = "Inscription en attente";
var dgGroupOverview_JoinedGroup = "Inscrit";
var dgGroupOverview_JoinThisGroup = "Devenir membre de ce groupe";
var dgGroupOverview_LeaveGroup = "Quitter le groupe";
var dgGroupOverview_MemberCountFormat = "{{userCount}} membres";
var dgGroupOverview_OpenGroup = "Groupe ouvert";
var dgGroupOverview_PrivateGroup = "Groupe priv\xe9";
var dgGroupOverview_RequestMembership = "Demander \xe0 s’abonner au groupe";
var dgGroupOverview_Restricted = "Ce groupe vous a \xe9t\xe9 assign\xe9 par votre organisation. Si vous estimez ne pas avoir \xe0 y participer, contactez l’administrateur de votre organisation.";
var dgGroupOverview_StaticAdminGroup = "Groupe administratif statique";
var dgGroupSearch_PlaceHolder = "Saisissez le nom d’un groupe";
var dgGroupSecurity_AssignLearning = "Assigner l’apprentissage";
var dgGroupSecurity_AssignLearningDescription = "Cr\xe9ez des t\xe2ches de contenu destin\xe9es aux membres du groupe.";
var dgGroupSecurity_DefaultRoleDescription = "Le r\xf4le par d\xe9faut des nouveaux membres de ce groupe est \xab\xa0Groupe {{roleName}}\xa0\xbb.";
var dgGroupSecurity_DeleteGroup = "Supprimer le groupe";
var dgGroupSecurity_DeleteGroupDescription = "Supprimer le groupe de l’organisation";
var dgGroupSecurity_EditPermissions = "Modifier les autorisations";
var dgGroupSecurity_EditPermissionsDescription = "Modifier les autorisations par d\xe9faut du groupe";
var dgGroupSecurity_EditSettings = "Modifier les param\xe8tres";
var dgGroupSecurity_EditSettingsDescription = "Consulter et modifier les param\xe8tres du groupe";
var dgGroupSecurity_GroupRoleHeader = "\xab\xa0Groupe{{roleName}}\xa0\xbb R\xf4le";
var dgGroupSecurity_InviteMembers = "Inviter des membres";
var dgGroupSecurity_InviteMembersDescription = "Inviter de nouveaux membres \xe0 rejoindre le groupe";
var dgGroupSecurity_RecommendItems = "Partager";
var dgGroupSecurity_RecommendItemsDescription = "Publier ou partager du contenu avec le groupe";
var dgGroupSecurity_RecommendRatings = "Partager les \xe9valuations de comp\xe9tences";
var dgGroupSecurity_RecommendRatingsDescription = "Partager les \xe9valuations de comp\xe9tences avec les membres du groupe";
var dgGroupSecurity_RemoveFeedItems = "Supprimer des \xe9l\xe9ments du flux";
var dgGroupSecurity_RemoveFeedItemsDescription = "Supprimer n’importe quel \xe9l\xe9ment pr\xe9sent dans le flux du groupe";
var dgGroupSecurity_RemoveMembers = "Supprimer des membres";
var dgGroupSecurity_RemoveMembersDescription = "Supprimer des membres du groupe";
var dgGroupSecurity_ViewGroupInsights = "Afficher les statistiques du groupe";
var dgGroupSecurity_ViewGroupInsightsDescription = "Afficher les statistiques du groupe";
var dgGroupSecurity_ViewMembers = "Afficher les membres";
var dgGroupSecurity_ViewMembersDescription = "Afficher tous les membres du groupe";
var dgGroupSecurity_ViewOrganizationReports = "T\xe9l\xe9charger les rapports";
var dgGroupsEdit_AddGroups = "Ajouter des groupes";
var dgGroupsEdit_AddGroupsLabel = "Entrer le nom d’un groupe";
var dgGroupsEdit_AddGroupsToBoostTooltip = "L’ajout de groupes vous permet de booster ce contenu dans les r\xe9sultats de recherche globaux des membres du groupe uniquement.";
var dgGroupsEdit_AddGroupsTooltip = "Ajoutez des groupes pour suivre et organiser vos entr\xe9es.";
var dgGroupsEdit_RemoveGroupName = "Supprimer {{groupName}}";
var dgGroupTile_JoinRequestPending = "Demande en attente";
var dgGroupTile_Leave = "Quitter";
var dgGroupTile_LeaveGroupModalBodyText = "Vous ne recevrez plus d’e-mails de groupe ni d’\xe9l\xe9ments partag\xe9s avec le groupe.";
var dgGroupTile_LeaveGroupModalHeader = "Souhaitez-vous r\xe9ellement quitter le groupe \xa0?";
var dgGroupTile_MemberCount = "{{count}} membres";
var dgGroupTile_RequestMembership = "Demander \xe0 s’abonner";
var dgImageEdit_Change = "Modifier";
var dgImageEdit_ChangePhoto = "modifier la photo";
var dgImageEdit_ChooseFile = "Choisir un fichier";
var dgImageEdit_ChooseFileToUpload = "S\xe9lectionnez le fichier \xe0 t\xe9l\xe9charger";
var dgImageEdit_ContentCard = "Carte du contenu";
var dgImageEdit_ContentDetails = "D\xe9tails du contenu";
var dgImageEdit_CropImage = "Recadrez votre image";
var dgImageEdit_CropNote = "Certaines images sont susceptibles d’\xeatre encore recadr\xe9es lors de leur affichage.";
var dgImageEdit_CropToFit = "Recadrez votre image pour l’ajuster";
var dgImageEdit_DocumentationDesc = "L’aper\xe7u ci-dessus montre comment votre image s’affichera sur la carte de contenu et dans la vue plus d\xe9taill\xe9e. Vous voulez en savoir plus\xa0? {{startAnchor}}Consultez notre documentation sur les images{{endAnchor}}";
var dgImageEdit_DocumentationLabel = "Consulter notre documentation sur les images";
var dgImageEdit_DragPhoto = "Faire glisser une photo ici";
var dgImageEdit_FilesizeError = "La taille de l’image doit \xeatre inf\xe9rieure \xe0 {{maxSize}}";
var dgImageEdit_ImageDimensionsFormat = "Pour que leur qualit\xe9 soit pr\xe9serv\xe9e, les images {{resolutionWidth}}doivent \xeatre d’au moins \xa0px par {{resolutionHeight}}\xa0px.";
var dgImageEdit_ImageTypes = "Type d’image non valide. L’image doit \xeatre l’une des suivantes : {{imageTypes}}";
var dgImageEdit_LookingGood = "Parfait\xa0!";
var dgImageEdit_NoImage = "Aucune image";
var dgImageEdit_SaveWithoutCropping = "Enregistrer sans rogner";
var dgImageEdit_SubmitImage = "Envoyer l’image";
var dgImageEdit_UploadImagePreview = "aper\xe7u de l’image t\xe9l\xe9charg\xe9e";
var dgImageUpload_BadgeFileTypeError = "Type de fichier non valide. Nous acceptons seulement les fichiers PNG et SVG jusqu’\xe0 5\xa0Mo.";
var dgImageUpload_BrowseForImage = "recherchez une image";
var dgImageUpload_DragImageHere = "D\xe9posez une image ici";
var dgImageUpload_DropImage = "D\xe9posez une image depuis votre ordinateur";
var dgImageUpload_FilesizeError = "La taille de l’image doit \xeatre inf\xe9rieure \xe0 {{maxSize}}";
var dgImageUpload_FileTypes = "Type d’image non valide. L’image doit \xeatre l’une des suivantes : {{imageTypes}}";
var dgImageUpload_ImagePosition = "Emplacement de l’image";
var dgImageUpload_ImagePosition_HelperText = "S\xe9lectionnez l’emplacement de l’image dans la section (au-dessus ou en dessous du texte).";
var dgImageUpload_ImagePreview = "aper\xe7u de l’image charg\xe9e";
var dgImageUpload_ImageTypesSize = "JPG, PNG ou GIF";
var dgImageUpload_KB = "{{fileSize}}\xa0Ko";
var dgImageUpload_LimitedImageTypesSize = "PNG ou SVG";
var dgImageUpload_Or = "ou";
var dgImageUpload_PdfImageTypesSize = "JPG, PNG, GIF ou PDF. 5\xa0Mo max.";
var dgImageUpload_RemoveImage = "Supprimer l’image";
var dgImageUpload_SectionDragAndDrop = "Faites un glisser-d\xe9poser ou cliquez pour charger une image.";
var dgImageUpload_SectionInvalidFileSize = "La taille du fichier est trop importante. Elle doit \xeatre inf\xe9rieure \xe0 {{fileSize}}\xa0Mo.";
var dgImageUpload_SectionInvalidFileType = "Type de fichier non valide. Nous n’acceptons que les fichiers de type\xa0JPEG, GIF, JPG et PNG.";
var dgImageUpload_SectionInvalidFileTypeVar = "Type de fichier non valide. Nous n’acceptons que les fichiers de type {{translatedFileTypes}}.";
var dgImageUpload_SectionRestrictions = "JPEG, GIF, JPG, PNG (jusqu’\xe0 5\xa0Mo)";
var dgImageUpload_SectionRestrictionsVar = "{{translatedFileTypes}} jusqu’\xe0 {{maxSize}}\xa0Mo";
var dgImageUpload_UploadImage = "Chargez une image";
var dgInputCountsByType_Points = "points";
var dgInputStatistics_Commented = "Personnes qui ont laiss\xe9 un avis";
var dgInputStatistics_CommentsCount = "{{count}}\xa0commentaire(s)";
var dgInputStatistics_CompletedCount = "{{count}}\xa0\xe9l\xe9ment(s) termin\xe9(s)";
var dgInputStatistics_LikesCount = "{{count}}\xa0J’aime";
var dgInputStatistics_PeopleWhoDisliked = "Personnes qui n’ont pas aim\xe9 ce";
var dgInputStatistics_PeopleWhoLiked = "Personnes qui ont aim\xe9 ce contenu";
var dgInputStatistics_PeopleWhoRated = "Personnes qui ont \xe9valu\xe9 ce";
var dgInputStatistics_PeopleWhoViewed = "Personnes qui ont vu \xe7a";
var dgInputStatistics_SharesCount = "{{count}}\xa0partage(s)";
var dgInputStatistics_SkillsCount = "{{count}}\xa0comp\xe9tence(s)";
var dgInputStatistics_Tag = "1 mot-cl\xe9";
var dgInputStatistics_Tags = "{{count}}\xa0comp\xe9tences";
var dgInputStatistics_TopCommenter = "{{userName}} ont partag\xe9 leurs avis";
var dgInputStatistics_TopCommenterAndOne = "{{userName}} et {{countStartSpan}}1 autre{{countEndSpan}} ont partag\xe9 leurs avis";
var dgInputStatistics_TopCommenterCount = "{{userName}} et {{countStartSpan}}{{userCount}} autres{{countEndSpan}} ont partag\xe9 leurs avis";
var dgInputStatistics_TopCompleter = "{{userName}} a termin\xe9 ceci";
var dgInputStatistics_TopCompleterAndOne = "{{userName}} et {{countStartSpan}}1 autre{{countEndSpan}} ont valid\xe9 cet \xe9l\xe9ment";
var dgInputStatistics_TopCompleterAndOneRead = "{{userName}} et {{countStartSpan}}1\xa0autre personne{{countEndSpan}} ont lu ceci";
var dgInputStatistics_TopCompleterAndOneWatched = "{{userName}} et {{countStartSpan}}1\xa0autre personne{{countEndSpan}} ont regard\xe9 ceci";
var dgInputStatistics_TopCompleterCount = "{{userName}} et {{countStartSpan}}{{userCount}}\xa0autres personnes{{countEndSpan}} ont termin\xe9 ceci";
var dgInputStatistics_TopCompleterCountRead = "{{userName}} et {{countStartSpan}}{{userCount}}\xa0autres personnes{{countEndSpan}} ont lu ceci";
var dgInputStatistics_TopCompleterCountWatched = "{{userName}} et {{countStartSpan}}{{userCount}}\xa0autres personnes{{countEndSpan}} ont regard\xe9 ceci";
var dgInputStatistics_TopCompleterRead = "{{userName}} a lu ceci";
var dgInputStatistics_TopCompleterWatched = "{{userName}} a regard\xe9 ceci";
var dgInputStatistics_TopFollower = "{{userName}} a suivi ceci";
var dgInputStatistics_TopFollowerAndOne = "{{userName}} et {{countStartSpan}}1\xa0autre personne{{countEndSpan}} ont suivi ceci";
var dgInputStatistics_TopFollowerCount = "{{userName}} et {{countStartSpan}}{{userCount}}\xa0autres personnes {{countEndSpan}} ont suivi ceci";
var dgInputStatistics_TopRecommender = "{{userName}} a partag\xe9 cet \xe9l\xe9ment";
var dgInputStatistics_TopRecommenderAndOne = "{{userName}} et {{countStartSpan}}1 autre{{countEndSpan}} ont partag\xe9 cet \xe9l\xe9ment";
var dgInputStatistics_TopRecommenderCount = "{{userName}} et {{countStartSpan}}{{userCount}} autres{{countEndSpan}} ont partag\xe9 cet \xe9l\xe9ment";
var dgInputStatistics_TopTakeawayAndOne = "{{userName}} et {{countStartSpan}}1 autre{{countEndSpan}} ont partag\xe9 un avis";
var dgInputStatisticsHeader_TopCompleter = "{{userName}} a compl\xe9t\xe9 ce {{inputType}}";
var dgInputStatisticsHeader_TopCompleterAndOne = "{{userName}} et {{countStartSpan}}1 autre{{countEndSpan}} ont compl\xe9t\xe9 ce {{inputType}}";
var dgInputStatisticsHeader_TopCompleterCount = "{{userName}} et {{countStartSpan}}{{userCount}} autres{{countEndSpan}} ont compl\xe9t\xe9 ce {{inputType}}";
var dgInputTile_DueBy = "Date limite le {{dueDate}}";
var dgInputTile_DueByFormat = "Date limite le {{dueDate}}";
var dgIntegrationsCard_AlisonMessage = "Importez quotidiennement tous les cours de votre profil Alison.";
var dgIntegrationsCard_CodecademyMessage = "Importez quotidiennement les cours termin\xe9s sur Codecademy.";
var dgIntegrationsCard_CodeSchoolMessage = "Importer quotidiennement les formations r\xe9alis\xe9es sur Code School.";
var dgIntegrationsCard_Connect = "Connecter";
var dgIntegrationsCard_Connected = "Connect\xe9";
var dgIntegrationsCard_Disconnect = "D\xe9connecter";
var dgIntegrationsCard_GoodreadsMessage = "Importez quotidiennement des livres de votre biblioth\xe8que dans Goodreads.";
var dgIntegrationsCard_GoogleplusMessage = "Recherchez vos contacts Google sur Degreed.";
var dgIntegrationsCard_ImportingMessage = "Importation...";
var dgIntegrationsCard_KhanAcademyMessage = "Importer quotidiennement les vid\xe9os regard\xe9es et les tests d’\xe9valuation effectu\xe9s sur Khan Academy";
var dgIntegrationsCard_LastSyncFailure = "\xc9chec de r\xe9cup\xe9ration des donn\xe9es. V\xe9rifiez vos param\xe8tres.";
var dgIntegrationsCard_LastSyncFormat = "Derni\xe8re importation {{date}}";
var dgIntegrationsCard_ManageSettings = "G\xe9rer les param\xe8tres";
var dgIntegrationsCard_PluralsightMessage = "Importez quotidiennement les cours termin\xe9s sur Pluralsight.";
var dgIntegrationsCard_PocketMessage = "Importez quotidiennement des articles de votre archive Pocket.";
var dgIntegrationsCard_SkillshareMessage = "Importer quotidiennement les formations de mon profil Skillshare.";
var dgIntegrationsCard_SlackMessage = "Recevez le programme de la journ\xe9e et le contenu partag\xe9 via Slack.";
var dgIntegrationsCard_TreehouseMessage = "Importez quotidiennement les cours termin\xe9s sur Treehouse.";
var dgIntegrationsCard_TwitterMessage = "Partager des \xe9l\xe9ments de Degreed avec vos abonn\xe9s Twitter";
var dgIntegrationsCard_UdemyMessage = "Importer quotidiennement les formations de mon profil Udemy.";
var dgIntegrationsCard_ViewGoogleplusFriends = "Afficher les contacts";
var dgIntegrationsCard_ViewTwitterFriends = "Afficher les abonn\xe9s";
var dgInviteAddCategories_FollowCategories = "Suivre des comp\xe9tences";
var dgInviteAddCategories_FollowCategoriesDesc = "Suivez des cat\xe9gories afin que Degreed vous recommande les contenus li\xe9s aux domaines que vous souhaitez approfondir. Faites votre choix parmi les suggestions ou ajoutez les v\xf4tres.";
var dgInviteAddCategories_LearnPlaceholder = "Que souhaitez-vous apprendre ?";
var dgInviteAddGroups_BecomeMember = "Devenez membre de {{groupName}}";
var dgInviteAddGroups_Group = "Groupe";
var dgInviteAddGroups_JoinGroup = "Rejoindre le groupe";
var dgInviteAddGroups_JoinGroups = "Rejoignez des groupes pour partager votre apprentissage";
var dgInviteAddGroups_JoinGroupsDesc = "Les \xe9l\xe9ments d’apprentissage partag\xe9s dans vos groupes s’afficheront dans votre flux. Vous conna\xeetrez ainsi les th\xe8mes sur lesquels travaillent les membres du groupe afin de pouvoir \xe9tudier avec eux";
var dgInviteAddGroups_LeaveGroup = "Quitter {{groupName}}";
var dgInviteAddPeople_Description = "Communiquez avec les experts pour d\xe9couvrir ce qu’ils \xe9tudient.";
var dgInviteAddPeople_Follow = "Suivre les activit\xe9s d’apprentissage de {{userName}}";
var dgInviteAddPeople_Learn = "\xc9tudier avec vos coll\xe8gues";
var dgInviteAddPeople_StopFollowing = "Arr\xeater de suivre les activit\xe9s d’apprentissage de {{userName}}";
var dgManagePathways_CloneFormat = "Cloner le parcours {{name}}";
var dgManagePathways_CreatePathway = "Cr\xe9er un parcours";
var dgManagePathways_Edit = "Modifier";
var dgManagePathways_MoreAuthorsFormat = "+ {{count}}\xa0autres";
var dgManagePathways_OneMoreAuthor = "+ 1\xa0autre";
var dgManagePathways_SearchPlaceholder = "Rechercher par titre ou auteur";
var dgManagePathways_ViewFormat = "Voir le parcours {{name}}";
var dgNoSearchResults_CorrectSpelling = "Assurez-vous que les mots soient correctement \xe9crits.";
var dgNoSearchResults_DifferentKeywords = "Essayez diff\xe9rents mots-cl\xe9s.";
var dgNoSearchResults_GeneralKeywords = "Utilisez des mots-cl\xe9s plus g\xe9n\xe9raux.";
var dgNotificationMenu_NothingNew = "Pas de nouvelle notification";
var dgNotificationMenu_Notifications = "Notification";
var dgNotificationPreference_IncludeInEmail = "Inclure dans l’e-mail";
var dgNotificationPreference_SentTest = "Envoyer un e-mail de test";
var dgOrgEditMemberModal_RemoveUser = "Supprimer l’utilisateur";
var dgOrgFaqForm_AddFaq = "Ajouter FAQ";
var dgOrgFaqForm_EditFaq = "Modifier FAQ";
var dgOrgFaqForm_FaqAnswerPlaceholder = "Quelle est la r\xe9ponse ?";
var dgOrgFaqForm_FaqContactInstructions = "Les questions soumises doivent \xeatre envoy\xe9es \xe0 cette adresse e-mail";
var dgOrgFaqForm_FaqContactLabel = "Contact des FAQ";
var dgOrgFaqForm_FaqContactPlaceholder = "contact@company.com";
var dgOrgFaqForm_FaqInstructionsFormat = "Les modifications apport\xe9es ici affecteront l’onglet FAQ {{orgName}} pour votre organisation.";
var dgOrgFaqForm_FaqQuestionPlaceholder = "Quelle est la question ?";
var dgOrgFaqForm_FaqValidationMessage = "Oups! Veuillez indiquer une question et une r\xe9ponse.";
var dgOrgFaqForm_ManageOrgFaqFormat = "G\xe9rer les FAQ {{orgName}}";
var dgOrgInternalContent_1Pathway = "1\xa0parcours";
var dgOrgInternalContent_1Plan = "1\xa0plan";
var dgOrgInternalContent_1Share = "1 partage";
var dgOrgInternalContent_AddContent = "Ajouter du contenu";
var dgOrgInternalContent_AddEditContent = "Ajouter ou modifier du contenu";
var dgOrgInternalContent_AddNewContent = "Ajouter un nouveau contenu";
var dgOrgInternalContent_AddNewContentFormat = "Ajouter un nouveau {{inputType}}";
var dgOrgInternalContent_All = "Tout";
var dgOrgInternalContent_BrokenLinkError = "Ce lien ne fonctionne pas et doit \xeatre mis \xe0 jour.";
var dgOrgInternalContent_BrokenLinks = "Liens cass\xe9s";
var dgOrgInternalContent_BulkDeleteCredSpark = "Les tests d'\xe9valuation CredSpark doivent \xeatre supprim\xe9s ou d\xe9publi\xe9s de votre tableau de bord CredSpark pour \xeatre enti\xe8rement supprim\xe9s.";
var dgOrgInternalContent_BulkEdit = "Modifier en bloc";
var dgOrgInternalContent_Catalog = "Catalogue";
var dgOrgInternalContent_CategoriesTitle = "Ajouter des comp\xe9tences aux entr\xe9es s\xe9lectionn\xe9es";
var dgOrgInternalContent_CategoriesToolTip = "En ajoutant des comp\xe9tences \xe0 certaines entr\xe9es, les utilisateurs pourront trouver plus facilement du contenu r\xe9pondant \xe0 leurs besoins.";
var dgOrgInternalContent_CheckForBrokenLinks = "V\xe9rifier les liens cass\xe9s";
var dgOrgInternalContent_CheckForBrokenToolTip = "Ce bouton sera \xe0 nouveau disponible lorsque l’analyse en cours sera termin\xe9e.";
var dgOrgInternalContent_ChooseContentType = "S\xe9lectionner le type de contenu";
var dgOrgInternalContent_ContentInUse = "Ce contenu est utilis\xe9 dans les plans et/ou les parcours suivants\xa0:";
var dgOrgInternalContent_ContentType = "Type de contenu";
var dgOrgInternalContent_ContentUsedInPlansAndPathways = "{{title}} est d\xe9j\xe0 dans les parcours et plans suivants\xa0:";
var dgOrgInternalContent_ContinueToDeleteContent = "Cliquez sur {{ startBoldTag }} Continuer {{ endBoldTag }} pour supprimer les autres \xe9l\xe9ments que vous avez s\xe9lectionn\xe9s dans le catalogue.";
var dgOrgInternalContent_DeleteContent = "Supprimer le contenu";
var dgOrgInternalContent_DeleteContentMessage = "Vous \xeates sur le point de supprimer le(s) \xe9l\xe9ment(s) suivants du catalogue de votre organisation\xa0:";
var dgOrgInternalContent_DeleteContentPermissionWarning = "Vous ne disposez pas d’autorisation pour supprimer les \xe9l\xe9ments suivants\xa0:";
var dgOrgInternalContent_DeleteContentTooltip = "Les fichiers h\xe9berg\xe9s seront supprim\xe9s de l’espace de stockage.";
var dgOrgInternalContent_DeleteFromAllReferences = "Supprimer du catalogue et de toutes les autres r\xe9f\xe9rences";
var dgOrgInternalContent_DeleteFromAllReferencesTooltip = "Le contenu sera retir\xe9 des plans, des parcours, des formations assign\xe9es ainsi que des partages, et les fichiers h\xe9berg\xe9s seront supprim\xe9s. ";
var dgOrgInternalContent_DeleteFromCatalog = "Supprimer dans le catalogue uniquement";
var dgOrgInternalContent_DeleteItems = "\xc9l\xe9ments {{ numberOfItems }} supprim\xe9s";
var dgOrgInternalContent_DeleteOneItem = "Supprimer 1\xa0\xe9l\xe9ment";
var dgOrgInternalContent_DeleteSelectedInputs = "Supprimer les entr\xe9es s\xe9lectionn\xe9es";
var dgOrgInternalContent_EditContent = "Modifier le contenu";
var dgOrgInternalContent_EditContentFormat = "Modifier {{inputType}}";
var dgOrgInternalContent_GenerateCmsReport = "T\xe9l\xe9charger le catalogue";
var dgOrgInternalContent_GroupsTitle = "Ajouter des groupes aux entr\xe9es s\xe9lectionn\xe9es";
var dgOrgInternalContent_GroupsToolTip = "Ajoutez des groupes aux entr\xe9es s\xe9lectionn\xe9es pour aider les utilisateurs \xe0 trouver le contenu li\xe9 aux groupes auxquels ils appartiennent.";
var dgOrgInternalContent_InternalContentVisibility = "Le contenu de votre catalogue interne est uniquement accessible et d\xe9tectable par les membres de votre organisation.";
var dgOrgInternalContent_ItemsSelectedFormat = "{{count}} \xe9l\xe9ments de contenu s\xe9lectionn\xe9s";
var dgOrgInternalContent_LastScannedOn = "Derni\xe8re analyse le {{fullDate}}";
var dgOrgInternalContent_LinkIsNotBroken = "Le lien fonctionne";
var dgOrgInternalContent_LinkUpdated = "Lien mis \xe0 jour";
var dgOrgInternalContent_ManageBrokenLinks = "G\xe9rer les liens cass\xe9s";
var dgOrgInternalContent_MultiplePathways = "{{count}}\xa0parcours";
var dgOrgInternalContent_MultiplePlans = "{{count}}\xa0plans";
var dgOrgInternalContent_MultipleShares = "{{ numberOfShares }}\xa0partages";
var dgOrgInternalContent_NoBrokenLinksInfoText = "Il n’y a actuellement aucun lien cass\xe9. Cliquez sur le bouton pour analyser \xe0 nouveau le catalogue.";
var dgOrgInternalContent_NoBrokenLinksScanHistory = "Votre organisation n’a pas encore v\xe9rifi\xe9 les liens cass\xe9s. Cliquez sur le bouton ci-dessous pour analyser le catalogue.";
var dgOrgInternalContent_ScanCompleteNotification = "L’{{boldStart}}analyse des liens de votre catalogue{{boldEnd}} est termin\xe9e.";
var dgOrgInternalContent_ScanIsComplete = "L’analyse du catalogue est termin\xe9e\xa0!";
var dgOrgInternalContent_ScanningCatalog = "Recherche de liens cass\xe9s dans votre catalogue...";
var dgOrgInternalContent_ShowMoreItems = "{{ numberOfItems }} en plus";
var dgOrgInternalContent_SidebarDescriptionFormat = "Les modifications apport\xe9es ici affecteront le Catalogue {{org}} dans la biblioth\xe8que, qui est le catalogue de contenu par d\xe9faut pour les membres de votre organisation. Le catalogue {{org}} est compos\xe9 de tous les contenus exclusifs entr\xe9s dans Degreed, ainsi que de tout contenu s\xe9lectionn\xe9 ci-dessous.";
var dgOrgInternalContent_SidebarTitle = "G\xe9rer le contenu interne";
var dgOrgInternalContent_SkillsHelperText = "Recherchez une comp\xe9tence ou s\xe9lectionnez-en une parmi les suggestions ci-dessous.";
var dgOrgInternalContent_SkillsMaxError = "Jusqu’\xe0 15\xa0comp\xe9tences peuvent \xeatre ajout\xe9es.";
var dgOrgInternalContent_SkillsPlaceholderText = "Recherchez une comp\xe9tence ou s\xe9lectionnez-en une parmi les suggestions ci-dessous, si disponibles.";
var dgOrgInternalContent_SkillsTooltipText = "Recherchez une comp\xe9tence ou s\xe9lectionnez-en une parmi les suggestions ci-dessous, si disponibles. Le fait d’ajouter des comp\xe9tences pertinentes aide Degreed \xe0 proposer de meilleures recommandations de contenu aux apprenants.";
var dgOrgInternalContent_ViewBrokenLinks = "Afficher les liens cass\xe9s";
var dgOrgInternalContent_ViewScormReport = "Afficher le rapport SCORM";
var dgOrgInternalContentForm_AddFromUrl = "ou Ajouter \xe0 partir d’une URL";
var dgOrgInternalContentForm_AddImage = "Ajouter une image";
var dgOrgInternalContentForm_AddInternalItemId = "Ajouter l’identifiant interne de l’\xe9l\xe9ment";
var dgOrgInternalContentForm_ArticalFormatPlaceholder = "Choisissez le format de l’article";
var dgOrgInternalContentForm_ArticleDescription = "Description";
var dgOrgInternalContentForm_ArticleDescriptionPlaceholder = "D\xe9crivez l’objet de cet article.";
var dgOrgInternalContentForm_ArticleExistsCancel = "Non";
var dgOrgInternalContentForm_ArticleExistsDescription = "L’article que vous souhaitez ajouter l’a d\xe9j\xe0 \xe9t\xe9. Le contenu ajout\xe9 ici \xe9crasera l’article existant. Souhaitez-vous effectuer la mise \xe0 jour avec ces nouvelles informations ?";
var dgOrgInternalContentForm_ArticleExistsTitle = "L’URL de l’article existe d\xe9j\xe0";
var dgOrgInternalContentForm_ArticleFormat = "Format de l’article";
var dgOrgInternalContentForm_ArticleFormatSelectPlaceholder = "S\xe9lectionnez le format de l’article";
var dgOrgInternalContentForm_ArticleTitle = "Titre";
var dgOrgInternalContentForm_ArticleURL = "URL de l’article";
var dgOrgInternalContentForm_AssessmentDescription = "Description";
var dgOrgInternalContentForm_AssessmentExistsDescription = "Le test d’\xe9valuation que vous souhaitez ajouter figure d\xe9j\xe0 dans la liste. Le contenu ajout\xe9 ici \xe9crasera le test d’\xe9valuation existant. Souhaitez-vous effectuer la mise \xe0 jour avec ces nouvelles informations\xa0?";
var dgOrgInternalContentForm_AssessmentExistsTitle = "L'URL de ce test d'\xe9valuation existe d\xe9j\xe0";
var dgOrgInternalContentForm_AssessmentName = "Nom du test d’\xe9valuation";
var dgOrgInternalContentForm_AssessmentProvider = "Fournisseur du test d’\xe9valuation";
var dgOrgInternalContentForm_AssessmentURL = "URL du test d’\xe9valuation";
var dgOrgInternalContentForm_AudioURL = "URL du podcast";
var dgOrgInternalContentForm_BookAuthor = "Auteur";
var dgOrgInternalContentForm_BookCoverAltFormat = "Intitul\xe9 du livre {{title}}";
var dgOrgInternalContentForm_BookDatePublished = "Date de publication";
var dgOrgInternalContentForm_BookDateRead = "Date de lecture";
var dgOrgInternalContentForm_BookLength = "Longueur (nombre de pages)";
var dgOrgInternalContentForm_BookLengthCustomFormat = "Longueur ({{units}})";
var dgOrgInternalContentForm_BookSave = "Enregistrer le livre";
var dgOrgInternalContentForm_BookSubtitle = "Sous-titre";
var dgOrgInternalContentForm_BookSummary = "R\xe9sum\xe9";
var dgOrgInternalContentForm_BookTitle = "Titre";
var dgOrgInternalContentForm_BookTitlePlaceholder = "Intitul\xe9 du livre";
var dgOrgInternalContentForm_CategoriesToolTip = "En ajoutant des comp\xe9tences, les utilisateurs pourront trouver plus facilement du contenu r\xe9pondant \xe0 leurs besoins.";
var dgOrgInternalContentForm_ChooseCourseFormat = "Choisissez le format";
var dgOrgInternalContentForm_CommentTooltip = "Ce commentaire sera partag\xe9 publiquement avec votre organisation.";
var dgOrgInternalContentForm_Complete = "Termin\xe9 !";
var dgOrgInternalContentForm_ContentOwner = "Propri\xe9taire du contenu";
var dgOrgInternalContentForm_ContentOwnerPlaceholder = "Chercher un nom ou un groupe Degreed";
var dgOrgInternalContentForm_ContentOwnerRequired = "Le propri\xe9taire du contenu doit \xeatre renseign\xe9.";
var dgOrgInternalContentForm_ContentOwnerTooltip = "Recherchez le nom d’une personne ou un groupe Degreed qui aura la responsabilit\xe9 de maintenir le contenu \xe0 jour.";
var dgOrgInternalContentForm_CourseDescription = "Description";
var dgOrgInternalContentForm_CourseDescriptionPlaceholder = "D\xe9crivez le contenu de ce cours.";
var dgOrgInternalContentForm_CourseExistsDescription = "Le cours que vous souhaitez ajouter a d\xe9j\xe0 \xe9t\xe9 ajout\xe9. Le contenu ajout\xe9 ici \xe9crasera le cours existant. Souhaitez-vous effectuer la mise \xe0 jour avec ces nouvelles informations\xa0?";
var dgOrgInternalContentForm_CourseExistsTitle = "L’intitul\xe9 de ce cours existe d\xe9j\xe0";
var dgOrgInternalContentForm_CourseFormat = "Format du cours";
var dgOrgInternalContentForm_CourseTitle = "Intitul\xe9 du cours";
var dgOrgInternalContentForm_CourseURL = "URL du cours";
var dgOrgInternalContentForm_CreateNewCredSparkAssessment = "Cr\xe9er un nouveau test d’\xe9valuation CredSpark";
var dgOrgInternalContentForm_CreationDate = "Date de publication";
var dgOrgInternalContentForm_CredSparkDashboard = "Tableau de bord CredSpark";
var dgOrgInternalContentForm_DragImage = "D\xe9posez une image de votre ordinateur";
var dgOrgInternalContentForm_EditDetails = "Modifier les d\xe9tails";
var dgOrgInternalContentForm_EventDescription = "Description";
var dgOrgInternalContentForm_EventExistsDescription = "L’\xe9v\xe8nement que vous souhaitez ajouter l’a d\xe9j\xe0 \xe9t\xe9. Le contenu ajout\xe9 ici \xe9crasera l’\xe9v\xe8nement existant. Souhaitez-vous effectuer la mise \xe0 jour avec ces nouvelles informations ?";
var dgOrgInternalContentForm_EventExistsTitle = "Cet \xe9v\xe8nement existe d\xe9j\xe0";
var dgOrgInternalContentForm_EventFormat = "Format de l’\xe9v\xe9nement";
var dgOrgInternalContentForm_EventFormatPlaceholder = "Choisissez le format de l’\xe9v\xe9nement";
var dgOrgInternalContentForm_EventTitle = "Titre";
var dgOrgInternalContentForm_EventTitlePlaceholder = "Intitul\xe9 de l’\xe9v\xe9nement";
var dgOrgInternalContentForm_EventURL = "Site Web (URL) de l’\xe9v\xe9nement";
var dgOrgInternalContentForm_EventURLPlaceholder = "URL de l’\xe9v\xe9nement";
var dgOrgInternalContentForm_File = "Fichier :";
var dgOrgInternalContentForm_FileTooLargeFormat = "Fichier trop grand {{fileSize}}Mo : max {{fileMax}}";
var dgOrgInternalContentForm_GroupsTitle = "Ajouter des groupes";
var dgOrgInternalContentForm_GroupsToolTip = "Ajoutez des groupes pour aider les utilisateurs \xe0 trouver le contenu li\xe9 aux groupes auxquels ils appartiennent.";
var dgOrgInternalContentForm_ImageDisplayOption = "Option d’affichage d’image";
var dgOrgInternalContentForm_ImageDisplayOption1 = "Petite image";
var dgOrgInternalContentForm_ImageDisplayOption2 = "Grande image";
var dgOrgInternalContentForm_ImagePreviewAltText = "Aper\xe7u de l’image du contenu";
var dgOrgInternalContentForm_ImageReuploadInstructions = "Cliquez sur la miniature pour t\xe9l\xe9charger \xe0 nouveau l’image.";
var dgOrgInternalContentForm_InternalItemId = "Identifiant interne de l’\xe9l\xe9ment";
var dgOrgInternalContentForm_InvalidFileType = "Type d’image non valide :";
var dgOrgInternalContentForm_ItemExistsCancel = "Non";
var dgOrgInternalContentForm_ItemExistsConfirm = "Oui, continuer";
var dgOrgInternalContentForm_IWroteBook = "Je suis l’auteur de ce livre";
var dgOrgInternalContentForm_Languages = "Langues";
var dgOrgInternalContentForm_ManageCredSparkAccount = "G\xe9rer CredSpark";
var dgOrgInternalContentForm_ManageOnCredSpark = "G\xe9rer sur CredSpark";
var dgOrgInternalContentForm_NoLanguageFound = "Aucune langue trouv\xe9e";
var dgOrgInternalContentForm_NumberOfQuestions = "Nombre de questions";
var dgOrgInternalContentForm_NumberOfUnits = "Nombre de";
var dgOrgInternalContentForm_Or = "ou";
var dgOrgInternalContentForm_ProcessingFile = "traitement du fichier...";
var dgOrgInternalContentForm_Questions = "Questions";
var dgOrgInternalContentForm_Record = "Enregistrer";
var dgOrgInternalContentForm_RecordAVideo = "Enregistrer une vid\xe9o";
var dgOrgInternalContentForm_RecordVideo = "Enregistrer la vid\xe9o";
var dgOrgInternalContentForm_ReRecordVideo = "R\xe9enregistrer la vid\xe9o";
var dgOrgInternalContentForm_ReSyncCredSpark = "Resynchroniser";
var dgOrgInternalContentForm_ReUploadRecording = "Recharger l’enregistrement";
var dgOrgInternalContentForm_ScormFile = "Fichier SCORM";
var dgOrgInternalContentForm_ScormInstructions = "S\xe9lectionnez ou faites glisser le fichier SCORM zipp\xe9 ";
var dgOrgInternalContentForm_ScormPackageCheckbox = "Package SCORM";
var dgOrgInternalContentForm_ScormPackageUpdateCheckbox = "Mettre \xe0 jour le package SCORM";
var dgOrgInternalContentForm_SelectLanguage = "Choisir la langue";
var dgOrgInternalContentForm_UnableToUpload = "\xc9chec du t\xe9l\xe9chargement";
var dgOrgInternalContentForm_UploadImage = "T\xe9l\xe9charger l’image";
var dgOrgInternalContentForm_UploadRecording = "Charger l’enregistrement";
var dgOrgInternalContentForm_VideoDescription = "Description";
var dgOrgInternalContentForm_VideoDescriptionPlaceholder = "D\xe9crivez l’objet de cette vid\xe9o";
var dgOrgInternalContentForm_VideoExistsDescription = "La vid\xe9o que vous souhaitez ajouter l’a d\xe9j\xe0 \xe9t\xe9. Le contenu ajout\xe9 ici \xe9crasera la vid\xe9o existante. Souhaitez-vous effectuer la mise \xe0 jour avec ces nouvelles informations ?";
var dgOrgInternalContentForm_VideoExistsTitle = "L’URL de cette vid\xe9o existe d\xe9j\xe0";
var dgOrgInternalContentForm_VideoFilesizeError = "D\xe9sol\xe9 ! Votre fichier doit \xeatre inf\xe9rieur \xe0 1 Go.";
var dgOrgInternalContentForm_VideoFiletypeError = "D\xe9sol\xe9 ! Vous pouvez uniquement t\xe9l\xe9charger des vid\xe9os avec l’extension de fichier .mp4.";
var dgOrgInternalContentForm_VideoFormat = "Format de la vid\xe9o";
var dgOrgInternalContentForm_VideoFormatSelectPlaceholder = "S\xe9lectionnez le format de la vid\xe9o";
var dgOrgInternalContentForm_VideoFormPlaceholder = "Choisissez le format de la vid\xe9o";
var dgOrgInternalContentForm_VideoLength = "Dur\xe9e de la vid\xe9o (en minutes)";
var dgOrgInternalContentForm_VideoSourceSupported = "Cette source vid\xe9o est prise en charge par le lecteur vid\xe9o int\xe9gr\xe9 de Degreed.";
var dgOrgInternalContentForm_VideoTimeLimit = "Vous pouvez enregistrer jusqu’\xe0 {{timeLimit}}\xa0minutes de vid\xe9o.";
var dgOrgInternalContentForm_VideoTitle = "Titre";
var dgOrgInternalContentForm_VideoUploadLimit = "Les fichiers peuvent \xeatre des vid\xe9os ({{filePattern}}) aillant une taille allant jusqu’\xe0 {{filesizeLimit}}.";
var dgOrgInternalContentForm_VideoURL = "URL de la vid\xe9o";
var dgOrgInvite_CommaSeparated = "s\xe9par\xe9 par des virgules";
var dgOrgInvite_EmailAddresses = "Adresses e-mail";
var dgOrgInvite_InviteEmailsOverview = "Vous pouvez \xe9galement nous autoriser \xe0 envoyer une invitation en votre nom\xa0! Indiquez la liste des adresses e-mail de vos coll\xe8gues dans le champ suivant.";
var dgOrgInvite_InviteLinkOverview = "Utilisez ce lien d’invitation pour inviter rapidement d’autres personnes \xe0 vous rejoindre sur Degreed.";
var dgOrgInvite_InviteTitle = "Inviter d’autres personnes";
var dgOrgInvite_Send = "Envoyer";
var dgOrgManageProviderModal_DisconnectIntegrationWarning = "Vous allez supprimer le contenu de ce fournisseur de votre catalogue. Le contenu ne sera pas supprim\xe9 des contenus, parcours et plans partag\xe9s ou assign\xe9s.";
var dgOrgManageProviderModal_EnableIntegration = "Activer l’int\xe9gration";
var dgOrgMembers_AddAMessage = "Ajouter un message";
var dgOrgMembers_AddMembersTitleFormat = "Ajouter des personnes \xe0 {{org}}";
var dgOrgMembers_AddPeople = "Ajouter des personnes";
var dgOrgMembers_CopyTheURL = "Copier l’URL";
var dgOrgMembers_EmailDomainChangeFormat = "Contactez votre repr\xe9sentant pour mettre \xe0 jour les domaines de courrier \xe9lectronique accept\xe9s par votre organisation.";
var dgOrgMembers_EmailInstructions = "L’adresse e-mail des membres de votre \xe9quipe doit se terminer par :";
var dgOrgMembers_EmailPlaceholderText = "Saisissez une adresse e-mail";
var dgOrgMembers_InviteGroupInstructionsFormat = "Invitez rapidement d’autres personnes \xe0 vous joindre au groupe {{name}} \xe0 l’aide de ce lien d’invitation.";
var dgOrgMembers_InviteLabel = "Inviter par e-mail";
var dgOrgMembers_InviteMembersTitleFormat = "Inviter des utilisateurs \xe0 rejoindre {{org}}";
var dgOrgMembers_PersonalMessageDescription = "Ce message sera inclus dans l’e-mail de bienvenue envoy\xe9 \xe0 chaque membre de l’\xe9quipe par support@degreed.com";
var dgOrgMembers_PersonalMessageDescriptionFormat = "Ce message sera inclus dans l’e-mail de bienvenue envoy\xe9 \xe0 chaque membre de l’\xe9quipe par {{orgName}}@degreed.com";
var dgOrgMembers_PersonalMessageLabel = "Message personnel";
var dgOrgMembers_SelectAllPending = "S\xe9lectionner toutes les invitations en attente";
var dgOrgMembers_SendInvite = "Envoyer l’invitation";
var dgOrgOverview_ChangeLogo = "Modifier le logo";
var dgOrgOverview_ChangeLogoTextFormat = "{{startStrong}}Les images carr\xe9es fonctionnent le mieux.{{endStrong}}L’image doit \xeatre un fichier PNG, JPG ou GIF et pas plus de 1 Mo. La largeur minimale de l’image est de 200\xa0pixels.";
var dgOrgOverview_GroupCountFormat = "{{count}} groupes";
var dgOrgOverview_HeaderColor = "Couleur de l’en-t\xeate";
var dgOrgOverview_MemberCountFormat = "{{count}} membres";
var dgOrgOverview_PreviewLabel = "Aper\xe7u du titre avec les param\xe8tres appliqu\xe9s";
var dgOrgSecurity_AddGlobalAdmins = "Ajouter des administrateurs globaux";
var dgOrgSecurity_AddGlobalAdminsDescription = "Possibilit\xe9 d’ajouter des administrateurs globaux \xe0 l’outil global.";
var dgOrgSecurity_AssignLearning = "Assigner du contenu";
var dgOrgSecurity_AssignLearningDescription = "Assigner du contenu aux membres de l’organisation.";
var dgOrgSecurity_AssignRatings = "Assigner des \xe9valuations de comp\xe9tences";
var dgOrgSecurity_AssignRatingsDescription = "Assigner des \xe9valuations de comp\xe9tences aux membres de l’organisation";
var dgOrgSecurity_AuthorContent = "Enregistrer des vid\xe9os";
var dgOrgSecurity_AuthorContentDescription = "Enregistrer des vid\xe9os pour le catalogue interne de votre organisation \xe0 partir de la page d’accueil";
var dgOrgSecurity_AuthorPathways = "Cr\xe9er des parcours pour l’organisation";
var dgOrgSecurity_AuthorPathwaysDescription = "Rendre les parcours visibles au sein de l’organisation.";
var dgOrgSecurity_AuthorSkillPlans = "Cr\xe9er des plans pour l’organisation";
var dgOrgSecurity_AuthorSkillPlansDescription = "Rendre les plans visibles au sein de l’organisation.";
var dgOrgSecurity_AuthorTargets = "Cr\xe9er des plans";
var dgOrgSecurity_AuthorTargetsDescription = "Cr\xe9er des plans et les d\xe9velopper";
var dgOrgSecurity_CobfigureBrowse = "Configurer la page Parcourir";
var dgOrgSecurity_ConfigureBrowse = "Configurer la page \xc0 la une";
var dgOrgSecurity_ConfigureBrowseDescription = "Modifier et configurer la page \xc0 la une de Degreed";
var dgOrgSecurity_CreateAdministrativeGroups = "Cr\xe9er des groupes administratifs";
var dgOrgSecurity_CreateAdministrativeGroupsDescription = "Cr\xe9er des groupes visibles par vous ainsi que les personnes disposant de l’autorisation G\xe9rer les groupes (non visibles par les membres).";
var dgOrgSecurity_CreateClosedGroups = "Cr\xe9er des groupes ferm\xe9s";
var dgOrgSecurity_CreateClosedGroupsDescription = "Cr\xe9er des groupes que tous les membres de l’organisation peuvent voir et rejoindre sur demande";
var dgOrgSecurity_CreateDynamicTeamAssignmentOpportunities = "Affectation dynamique des \xe9quipes";
var dgOrgSecurity_CreateDynamicTeamAssignmentOpportunitiesDesc = "Cr\xe9ez des opportunit\xe9s d’affectation dynamique des \xe9quipes pour l’organisation.";
var dgOrgSecurity_CreateDynamicTeamAssignmentOpportunitiesDescription = "Cr\xe9er des opportunit\xe9s d’affectation dynamique des \xe9quipes pour l’organisation";
var dgOrgSecurity_CreateGroups = "Cr\xe9er des groupes";
var dgOrgSecurity_CreateGroupsDescription = "Privil\xe8ges d’administrateur dans tous les groupes, sans obligation de les rejoindre";
var dgOrgSecurity_CreateLookingforMenteeOpportunities = "Recherche de mentor\xe9";
var dgOrgSecurity_CreateLookingforMenteeOpportunitiesDescription = "Cr\xe9er des opportunit\xe9s de recherche de mentor\xe9s pour l’organisation";
var dgOrgSecurity_CreateLookingforMentorOpportunities = "Recherche de mentor";
var dgOrgSecurity_CreateLookingforMentorOpportunitiesDescription = "Cr\xe9er des opportunit\xe9s de recherche de mentors pour l’organisation";
var dgOrgSecurity_CreateMentorshipOpportunities = "Mentorat";
var dgOrgSecurity_CreateMentorshipOpportunitiesDescription = "Cr\xe9er des opportunit\xe9s de mentorat pour l’organisation";
var dgOrgSecurity_CreateOpenGroups = "Cr\xe9er des groupes ouverts";
var dgOrgSecurity_CreateOpenGroupsDescription = "Cr\xe9er des groupes que tous les membres de l’organisation peuvent voir et rejoindre";
var dgOrgSecurity_CreateOpportunities = "Cr\xe9er des opportunit\xe9s";
var dgOrgSecurity_CreateOpportunitiesDescription = "Cr\xe9er des opportunit\xe9s pour l’organisation";
var dgOrgSecurity_CreateOtherOpportunities = "Autres";
var dgOrgSecurity_CreateOtherOpportunitiesDescription = "Cr\xe9er d’autres opportunit\xe9s pour l’organisation";
var dgOrgSecurity_CreatePeerMentoringOpportunities = "Mentorat entre pairs";
var dgOrgSecurity_CreatePeerMentoringOpportunitiesDescription = "Cr\xe9er des opportunit\xe9s de mentorat entre pairs pour l’organisation";
var dgOrgSecurity_CreatePrivateGroups = "Cr\xe9er des groupes priv\xe9s";
var dgOrgSecurity_CreatePrivateGroupsDescription = "Cr\xe9er des groupes sur invitation pour votre organisation";
var dgOrgSecurity_CreateProBonoOpportunities = "Pro bono";
var dgOrgSecurity_CreateProBonoOpportunitiesDescription = "Cr\xe9er des opportunit\xe9s de services pro bono pour l’organisation";
var dgOrgSecurity_CreateProjectOpportunities = "Projet";
var dgOrgSecurity_CreateProjectOpportunitiesDescription = "Cr\xe9er des opportunit\xe9s de projets pour l’organisation";
var dgOrgSecurity_CreateReverseMentoringOpportunities = "Mentorat invers\xe9";
var dgOrgSecurity_CreateReverseMentoringOpportunitiesDescription = "Cr\xe9er des opportunit\xe9s de mentorat invers\xe9 pour l’organisation";
var dgOrgSecurity_CreateShadowingOpportunities = "Shadowing";
var dgOrgSecurity_CreateShadowingOpportunitiesDescription = "Cr\xe9er des opportunit\xe9s de shadowing pour l’organisation";
var dgOrgSecurity_CreateStretchAssignmentOpportunities = "Mission \xe9largie";
var dgOrgSecurity_CreateStretchAssignmentOpportunitiesDescription = "Cr\xe9er des opportunit\xe9s de missions \xe9largies pour l’organisation";
var dgOrgSecurity_CreateTenant = "Cr\xe9er une organisation";
var dgOrgSecurity_CreateTenantDescription = "Cr\xe9er de nouvelles organisations dans l’outil d’administration globale.";
var dgOrgSecurity_CreateVolunteerOpportunities = "B\xe9n\xe9vole";
var dgOrgSecurity_CreateVolunteerOpportunitiesDescription = "Cr\xe9er des opportunit\xe9s de b\xe9n\xe9volat pour l’organisation";
var dgOrgSecurity_CustomizeBrowse = "Modifier et configurer la page Parcourir de Degreed";
var dgOrgSecurity_DefaultRoleText = "Le r\xf4le par d\xe9faut des nouveaux membres de votre organisation est \xab\xa0Membre\xa0\xbb.";
var dgOrgSecurity_DeleteGroup = "Supprimer un groupe";
var dgOrgSecurity_DeleteGroupDescription = "Supprimer des groupes";
var dgOrgSecurity_DownloadPathwayDetailsReport = "T\xe9l\xe9charger des rapports sur les d\xe9tails des parcours";
var dgOrgSecurity_DownloadPathwayDetailsReportDescription = "Depuis la page Abonn\xe9s, t\xe9l\xe9charger des rapports afin d’en savoir plus sur les \xe9l\xe9ments termin\xe9s dans le cadre du parcours";
var dgOrgSecurity_DownloadReports = "T\xe9l\xe9charger des rapports";
var dgOrgSecurity_DownloadReportsDescription = "G\xe9n\xe9rer et t\xe9l\xe9charger des rapports de statistiques sur votre organisation ou un groupe.";
var dgOrgSecurity_EditCommunications = "Modifier les communications";
var dgOrgSecurity_EditCommunicationsDescription = "Modifier les param\xe8tres de communication de l’organisation, y compris les e-mails et les messages int\xe9gr\xe9s \xe0 l’application";
var dgOrgSecurity_EditCommunicationsGlobal = "Modifier les communications";
var dgOrgSecurity_EditCommunicationsGlobalDescription = "Modifiez les param\xe8tres de communication des administrateurs globaux, y compris les e-mails et les messages int\xe9gr\xe9s \xe0 l’application.";
var dgOrgSecurity_EditPermissions = "Modifier les autorisations";
var dgOrgSecurity_EditPermissionsDescription = "Modifier les param\xe8tres d’autorisation de l’organisation pour chaque r\xf4le d’utilisateur.";
var dgOrgSecurity_EditPermissionsGlobal = "Modifier les autorisations";
var dgOrgSecurity_EditPermissionsGlobalDescription = "Modifiez les param\xe8tres d’autorisation de l’administrateur global pour chaque r\xf4le utilisateur.";
var dgOrgSecurity_EditSettings = "Modifier les param\xe8tres";
var dgOrgSecurity_EditSettingsDescription = "Afficher et modifier les param\xe8tres de l’organisation, et modifier la rubrique FAQ de l’organisation.";
var dgOrgSecurity_EditTenantOrganizationPermissions = "Modifier les autorisations de l’organisation";
var dgOrgSecurity_EditTenantOrganizationPermissionsDescription = "Modifier les param\xe8tres d’autorisation de l’organisation titulaire pour chaque r\xf4le d’utilisateur";
var dgOrgSecurity_EditTenantSettings = "Modifier les param\xe8tres de l’organisation";
var dgOrgSecurity_EditTenantSettingsDescription = "Possibilit\xe9 de s\xe9lectionner une organisation dans la liste pour modifier ses param\xe8tres. Les utilisateurs b\xe9n\xe9ficiant de cette autorisation peuvent s\xe9lectionner une organisation pour modifier ses param\xe8tres. Les utilisateurs non autoris\xe9s peuvent consulter la liste des organisations, mais ils ne peuvent pas acc\xe9der \xe0 la page Param\xe8tres de l’organisation lorsqu’ils cliquent sur cette derni\xe8re.";
var dgOrgSecurity_EmailPasswordReset = "R\xe9initialisation du mot de passe par e-mail";
var dgOrgSecurity_EmailPasswordResetDescription = "R\xe9initialiser le mot de passe des membres en envoyant un e-mail";
var dgOrgSecurity_EndorseContent = "Recommander du contenu";
var dgOrgSecurity_EndorseContentDescription = "Recommander diff\xe9rents plans ou parcours \xe0 l’aide d’une ic\xf4ne sur la carte.";
var dgOrgSecurity_InviteMembers = "Inviter des membres";
var dgOrgSecurity_InviteMembersDescription = "Ajouter de nouveaux membres \xe0 l’organisation \xe0 partir de la liste des membres";
var dgOrgSecurity_LearningProfessional = "Professionnel de l’apprentissage";
var dgOrgSecurity_LearnMore = "En savoir plus";
var dgOrgSecurity_ManageAdvanced = "G\xe9rer les options avanc\xe9es";
var dgOrgSecurity_ManageAdvancedDescription = "Afficher et g\xe9rer les param\xe8tres avanc\xe9s";
var dgOrgSecurity_ManageAttributes = "G\xe9rer les attributs personnalis\xe9s";
var dgOrgSecurity_ManageAttributesDescription = "Choisir les attributs utilisateurs personnalis\xe9s qui doivent appara\xeetre sur toute la plateforme Degreed, y compris dans les listes d\xe9roulantes Segments et R\xe8gles m\xe9tier";
var dgOrgSecurity_ManageBusinessRules = "G\xe9rer les automatisations";
var dgOrgSecurity_ManageBusinessRulesDescription = "Afficher et g\xe9rer les automatisations";
var dgOrgSecurity_ManageContent = "G\xe9rer le catalogue";
var dgOrgSecurity_ManageContentDescription = "Cr\xe9er, supprimer ou modifier du contenu interne.";
var dgOrgSecurity_ManageEngage = "G\xe9rer les messages \xe0 automatiser";
var dgOrgSecurity_ManageEngageDescription = "Cr\xe9er, modifier et supprimer des messages \xe0 automatiser";
var dgOrgSecurity_ManageGroups = "G\xe9rer les groupes";
var dgOrgSecurity_ManageGroupsDescription = "Privil\xe8ges d’administrateur dans tous les groupes, sans obligation de les rejoindre.";
var dgOrgSecurity_ManageIntegrations = "G\xe9rer les int\xe9grations";
var dgOrgSecurity_ManageIntegrationsDescription = "Afficher et g\xe9rer les int\xe9grations de fournisseurs";
var dgOrgSecurity_ManageOpportunities = "G\xe9rer les opportunit\xe9s";
var dgOrgSecurity_ManageOpportunitiesDescription = "Modifier les opportunit\xe9s de l’organisation";
var dgOrgSecurity_ManageOrgApiKeys = "G\xe9rer les cl\xe9s\xa0API";
var dgOrgSecurity_ManageOrgApiKeysDescription = "Afficher et g\xe9rer les cl\xe9s\xa0API";
var dgOrgSecurity_ManagePathways = "G\xe9rer les parcours";
var dgOrgSecurity_ManagePathwaysDescription = "Modifier les parcours de l’organisation, y compris leur contenu et leurs param\xe8tres.";
var dgOrgSecurity_ManageReporting = "G\xe9rer les rapports";
var dgOrgSecurity_ManageReportingDescription = "Afficher et g\xe9rer les planifications et les rapports int\xe9gr\xe9s \xe0 l’application";
var dgOrgSecurity_ManageReportingFTPScheduler = "G\xe9rer les rapports FTP planifi\xe9s";
var dgOrgSecurity_ManageReportingFTPSchedulerDescription = "Afficher et g\xe9rer les rapports FTP planifi\xe9s";
var dgOrgSecurity_ManageReportingInApp = "G\xe9rer les rapports int\xe9gr\xe9s \xe0 l’application";
var dgOrgSecurity_ManageReportingInAppDescription = "Afficher et g\xe9rer les rapports dans l’application";
var dgOrgSecurity_ManageReportingTransmitterConfigurations = "G\xe9rer les configurations des \xe9metteurs de rapports";
var dgOrgSecurity_ManageReportingTransmitterConfigurationsDescription = "Cr\xe9er et g\xe9rer les configurations des \xe9metteurs pour les rapports FTP";
var dgOrgSecurity_ManageSegments = "G\xe9rer les segments";
var dgOrgSecurity_ManageSegmentsDescription = "Afficher et g\xe9rer les segments utilisateurs";
var dgOrgSecurity_ManageSkillPlans = "G\xe9rer les plans et les r\xe9pertoires";
var dgOrgSecurity_ManageSkillPlansDescription = "Afficher et modifier les plans ou les r\xe9pertoires de l’organisation, y compris leur contenu et leurs param\xe8tres.";
var dgOrgSecurity_ManageSkills = "G\xe9rer les comp\xe9tences";
var dgOrgSecurity_ManageSkillsDescription = "Afficher et g\xe9rer la taxonomie des comp\xe9tences et postes associ\xe9s de l’organisation";
var dgOrgSecurity_ManageSkillsPlatform = "G\xe9rer la plateforme de comp\xe9tences";
var dgOrgSecurity_ManageSkillsPlatformDescription = "Cette autorisation permettra aux utilisateurs de g\xe9rer les libell\xe9s et les \xe9chelles des comp\xe9tences sur la plateforme de comp\xe9tences";
var dgOrgSecurity_ManageSkillStandards = "G\xe9rer les normes de comp\xe9tences";
var dgOrgSecurity_ManageSkillStandardsDescription = "Afficher et g\xe9rer les normes de comp\xe9tences";
var dgOrgSecurity_ManageTargets = "G\xe9rer les plans";
var dgOrgSecurity_ManageTargetsDescription = "Cr\xe9er, afficher et d\xe9velopper des plans sans en \xeatre l’auteur";
var dgOrgSecurity_PublishOpportunities = "Publier des opportunit\xe9s";
var dgOrgSecurity_PublishOpportunitiesDescription = "Rendre les opportunit\xe9s visibles au sein de l’organisation ou de groupes";
var dgOrgSecurity_PublishSkills = "Publish Skills";
var dgOrgSecurity_PublishSkillsDescription = "Make skill updates in Degreed Skills visible to the organization.";
var dgOrgSecurity_RecommendItems = "Partager du contenu";
var dgOrgSecurity_RecommendItemsDescription = "Partager du contenu avec les membres de l’organisation et les abonn\xe9s.";
var dgOrgSecurity_RecommendItemsWithDate = "Assigner l’apprentissage";
var dgOrgSecurity_RecommendItemsWithDateDescription = "Cr\xe9er des t\xe2ches de contenu destin\xe9es aux membres de l’organisation";
var dgOrgSecurity_RecommendOpportunities = "Partager des opportunit\xe9s";
var dgOrgSecurity_RecommendOpportunitiesDescription = "Partager des opportunit\xe9s avec les membres de l’organisation";
var dgOrgSecurity_RecommendRatings = "Partager des \xe9valuations de comp\xe9tences";
var dgOrgSecurity_RecommendRatingsDescription = "Partager des \xe9valuations de comp\xe9tences avec les membres de l’organisation";
var dgOrgSecurity_RemoveMembers = "Supprimer des membres";
var dgOrgSecurity_RemoveMembersDescription = "Supprimer des membres de la liste des membres de l’organisation";
var dgOrgSecurity_RequestManagerRating = "Demander \xe0 \xeatre \xe9valu\xe9 par votre responsable";
var dgOrgSecurity_RequestManagerRatingDescription = "Demandez \xe0 votre responsable d’\xe9valuer votre comp\xe9tence en priv\xe9";
var dgOrgSecurity_RoleAdmin = "Administrateur";
var dgOrgSecurity_RoleLearningProfessional = "Professionnel de l’apprentissage";
var dgOrgSecurity_RoleManager = "Responsable";
var dgOrgSecurity_RoleMember = "Membre";
var dgOrgSecurity_ScanCatalogLinks = "Analyser les liens du catalogue";
var dgOrgSecurity_ScanCatalogLinksDescription = "Analyser le contenu de la page G\xe9rer le catalogue pour rechercher les liens cass\xe9s";
var dgOrgSecurity_SelectFeaturedPathways = "Ajouter des plans et des parcours \xe0 la une";
var dgOrgSecurity_SelectFeaturedPathwaysDescription = "Modifier la section Parcours/Plans \xe0 la une de la page Parcourir";
var dgOrgSecurity_ShareBundledContent = "Partager une s\xe9rie de contenus";
var dgOrgSecurity_ShareBundledContentDescription = "Modifier les organisations ayant acc\xe8s aux lots de contenus";
var dgOrgSecurity_UploadClientUser = "Charger un utilisateur client";
var dgOrgSecurity_UploadClientUserDescription = "Ajouter, mettre \xe0 jour ou supprimer des utilisateurs";
var dgOrgSecurity_UploadCompletions = "Charger des \xe9l\xe9ments termin\xe9s";
var dgOrgSecurity_UploadCompletionsDescription = "Ajouter, mettre \xe0 jour ou supprimer des \xe9l\xe9ments de formation termin\xe9s";
var dgOrgSecurity_UploadContent = "Charger du contenu";
var dgOrgSecurity_UploadContentDescription = "Ajouter, mettre \xe0 jour ou supprimer du contenu";
var dgOrgSecurity_UploadContentFiles = "Charger des fichiers de contenu";
var dgOrgSecurity_UploadContentFilesDescription = "Charger des fichiers de contenu dans le catalogue interne de votre organisation";
var dgOrgSecurity_UploadFiles = "Charger des fichiers";
var dgOrgSecurity_UploadFilesDescription = "Charger des fichiers pour votre organisation";
var dgOrgSecurity_UploadGroups = "Charger des groupes";
var dgOrgSecurity_UploadGroupsDescription = "Ajouter, mettre \xe0 jour ou supprimer des groupes";
var dgOrgSecurity_UploadOpportunities = "Charger des opportunit\xe9s";
var dgOrgSecurity_UploadOpportunitiesDescription = "Ajouter, mettre \xe0 jour ou supprimer des opportunit\xe9s";
var dgOrgSecurity_UploadPlans = "Charger des plans";
var dgOrgSecurity_UploadPlansDescription = "Ajouter et mettre \xe0 jour des plans";
var dgOrgSecurity_UploadRequiredLearning = "Charger des formations obligatoires";
var dgOrgSecurity_UploadRequiredLearningDescription = "Ajouter, mettre \xe0 jour ou supprimer des formations obligatoires";
var dgOrgSecurity_UploadRoles = "Charger des postes";
var dgOrgSecurity_UploadRolesDescription = "Ajouter et mettre \xe0 jour des postes";
var dgOrgSecurity_UploadSkills = "Charger des comp\xe9tences";
var dgOrgSecurity_UploadSkillsDescription = "Ajouter et mettre \xe0 jour des comp\xe9tences";
var dgOrgSecurity_UploadUserUpdates = "Charger des mises \xe0 jour d’utilisateurs";
var dgOrgSecurity_UploadUserUpdatesDescription = "Ajouter, mettre \xe0 jour ou supprimer des attributs utilisateurs";
var dgOrgSecurity_ViewCareerPaths = "Afficher les plans et les r\xe9pertoires";
var dgOrgSecurity_ViewCareerPathsDescription = "Afficher les plans et les r\xe9pertoires de l’organisation";
var dgOrgSecurity_ViewDynamicAdminGroupMembers = "Afficher les membres du groupe dynamique d’administrateurs";
var dgOrgSecurity_ViewDynamicAdminGroupMembersDescription = "Affiche une liste de tous les membres de l’organisation qui remplissent les conditions d\xe9finies par le groupe dynamique d’administrateurs";
var dgOrgSecurity_ViewKnowledgeCenter = "Afficher le Centre de connaissances";
var dgOrgSecurity_ViewKnowledgeCenterDescription = "Voir la documentation produit et les outils d’administration de Degreed";
var dgOrgSecurity_ViewMembers = "Afficher les membres";
var dgOrgSecurity_ViewMembersDescription = "Afficher la liste compl\xe8te des membres de l’organisation et leur r\xf4le d’utilisateur.";
var dgOrgSecurity_ViewOpportunities = "Voir les opportunit\xe9s";
var dgOrgSecurity_ViewOpportunitiesDescription = "Voir les opportunit\xe9s de l’entreprise.";
var dgOrgSecurity_ViewOrganizationOpportunityInsights = "Afficher les statistiques d’opportunit\xe9s de l’organisation";
var dgOrgSecurity_ViewOrganizationOpportunityInsightsDescription = "Afficher les statistiques d’opportunit\xe9s de votre organisation";
var dgOrgSecurity_ViewOrganizationReports = "Afficher les statistiques de l’organisation";
var dgOrgSecurity_ViewOrganizationReportsDescription = "Afficher les statistiques concernant votre organisation, vos parcours et vos plans.";
var dgOrgSecurity_ViewPathwayEnrollees = "Afficher les abonn\xe9s aux parcours";
var dgOrgSecurity_ViewPathwayEnrolleesDescription = "Afficher les abonn\xe9s aux parcours que vous avez cr\xe9\xe9s";
var dgOrgSecurity_ViewRatings = "Afficher les donn\xe9es de comp\xe9tences individuelles";
var dgOrgSecurity_ViewRatingsDescription = "Afficher les donn\xe9es de comp\xe9tences des individus dans la plateforme (dans les statistiques de comp\xe9tences de votre organisation, ou suite \xe0 un partage ou une assignation)";
var dgOrgSecurity_ViewRecommendedRatings = "Afficher les \xe9valuations de comp\xe9tences partag\xe9es";
var dgOrgSecurity_ViewRecommendedRatingsDescription = "Afficher les donn\xe9es de comp\xe9tences des individus ayant termin\xe9 une \xe9valuation de comp\xe9tence que vous avez partag\xe9e ou assign\xe9e";
var dgPathwayPrivacy_CollaboratorProfilePrivate = "Profils de collaborateurs (priv\xe9)";
var dgPathwayPrivacy_CollaboratorProfileVisible = "Profils de collaborateurs (public)";
var dgPathwayPrivacy_OrgVisibleFormat = "Visible par l’organisation";
var dgPathwayPrivacy_Private = "Priv\xe9";
var dgPathwayPrivacy_ProfilePrivate = "Mon profil (priv\xe9)";
var dgPathwayPrivacy_ProfileVisible = "Mon profil (visible)";
var dgPathwayPrivacy_Public = "Public";
var dgPathwayPrivacy_SpecificGroupsVisible = "Visible par des groupes sp\xe9cifiques";
var dgPathwayPrivacy_VisibilityBoostToGroupTooltip = "Ce parcours sera mis en avant dans les r\xe9sultats de recherche des membres de ce groupe.";
var dgPathwaysInsights_CompletionPercentage = "%\xa0d’ach\xe8vement";
var dgPathwaysInsights_EnrolledCountFormat = "{{count}} personne inscrite";
var dgPathwaysInsights_EnrolledCountPluralFormat = "{{count}} personnes inscrites";
var dgPathwaysInsights_FiftyToSeventyFive = "de 50\xa0% \xe0 75\xa0%";
var dgPathwaysInsights_FollowerCountFormat = "{{count}} abonn\xe9";
var dgPathwaysInsights_FollowerCountPluralFormat = "{{count}} abonn\xe9s";
var dgPathwaysInsights_GreaterThanSeventyFive = "plus de 75\xa0%";
var dgPathwaysInsights_LessonLower = "le\xe7on";
var dgPathwaysInsights_LessThanTwentyFive = "moins de 25\xa0%";
var dgPathwaysInsights_PercentageOfEnrollees = "{{percentage}} des inscrits ont compl\xe9t\xe9 {{percentageText}} de ce {{type}}";
var dgPathwaysInsights_PercentageOfFollowers = "{{percentage}} des abonn\xe9s ont valid\xe9 {{percentageText}} de ce {{type}}";
var dgPathwaysInsights_Section = "Section";
var dgPathwaysInsights_SectionLower = "section";
var dgPathwaysInsights_Sections = "Sections";
var dgPathwaysInsights_TableTitle = "Informations sur l’ach\xe8vement de la section";
var dgPathwaysInsights_Title = "Titre";
var dgPathwaysInsights_TwentyFiveToFifty = "de 25\xa0% \xe0 50\xa0%";
var dgPathwaysInsights_WhenDataUpdates = "Remarque : Mise \xe0 jour quotidienne des donn\xe9es";
var dgPathwayTile_Enroll = "S’inscrire";
var dgPathwayTile_Enrolled = "Inscrit";
var dgPathwayTile_EnrolledButtonLabel = "Inscrit Cliquez pour vous retirer.";
var dgPathwayTile_Follow = "Suivre";
var dgPathwayTile_Following = "Suivi";
var dgPathwayTile_FollowingButtonLabel = "Vous suivez cet \xe9l\xe9ment. Cliquez pour vous d\xe9sabonner.";
var dgPathwayTile_PrivateShareMsg = "<p>Ce parcours est priv\xe9.<br>Pour le partager, rendez-le visible dans les param\xe8tres de parcours.</p>";
var dgPathwayTile_SavedForLaterMsgFormat = "{{title}} a \xe9t\xe9 enregistr\xe9\xa0!";
var dgPathwayTile_Unfollow = "Se d\xe9sabonner";
var dgPathwayTile_UnfollowConfirm = "Voulez-vous vraiment cesser de suivre ce parcours\xa0?";
var dgPathwayTile_Withdraw = "Quitter";
var dgPathwayTile_WithdrawConfirm = "Souhaitez-vous r\xe9ellement quitter ce parcours ?";
var dgPathwayTile_WithdrawExplanation = "Le contenu de ce parcours n’appara\xeetra plus dans votre flux.";
var dgPopularCategories_ListOption = "Liste";
var dgPopularCategories_NoCategories = "Aucune cat\xe9gorie correspondante";
var dgPopularCategories_NoSearchTerms = "Aucun terme de recherche correspondant";
var dgPopularCategories_TagsOption = "Comp\xe9tences";
var dgPopularCategories_UncategorizedFormat = "+{{masteryPoints}} points non class\xe9s ont gagn\xe9 cette {{period}}";
var dgPopularProviders_Empty = "Aucun fournisseur populaire";
var dgPopularProviders_InputPercentageFormat = "<strong>{{itemCount}}%</strong> des entr\xe9es totales";
var dgPopularProviders_ProviderPlaceholder = "Choisissez un catalogue de fournisseur";
var dgPopularProviders_SeatsFormat = "<strong>{{providerSeatsCurrent}}</strong> des <strong>{{providerSeatsTotal}}</strong> si\xe8ges utilis\xe9s";
var dgPopularSearches_ListOption = "Liste";
var dgPopularSearches_TermOption = "Conditions";
var dgPostComment_Message = "Message";
var dgPostComment_Placeholder = "Partagez un article, une vid\xe9o ou une id\xe9e.";
var dgProfileCollectionItem_CertDetailsTitle = "D\xe9tails du certificat";
var dgProfileCollectionItem_CertImage = "Image";
var dgProfileCollectionItem_CertIssuedBy = "\xc9mis par";
var dgProfileCollectionItem_CertIssuerUrl = "URL de l’\xe9metteur";
var dgProfileCollectionItem_CertNumber = "Num\xe9ro du certificat";
var dgProfileCollectionItem_CertTitle = "Intitul\xe9 du certificat";
var dgProfileCollectionItem_CertValidDate = "Date de validit\xe9";
var dgProfileCollectionItem_MasteryPointsFormat = "{{masteryPoints}}\xa0point(s)";
var dgProfileCollectionItem_Verified = "VALID\xc9";
var dgProfileOverview_AchievementReported = "R\xe9ussite signal\xe9e";
var dgProfileOverview_AddAchievements = "Ajouter des r\xe9ussites";
var dgProfileOverview_AddDescription = "Ajouter une description";
var dgProfileOverview_AddDevelopmentPlan = "Cr\xe9er un plan";
var dgProfileOverview_AddExperiences = "Ajouter des exp\xe9riences";
var dgProfileOverview_AdditionalSkills = "Comp\xe9tences suppl\xe9mentaires";
var dgProfileOverview_AddLearning = "Ajouter des contenus de formation";
var dgProfileOverview_AddSkill = "La comp\xe9tence {{skillName}} a \xe9t\xe9 ajout\xe9e";
var dgProfileOverview_AddSkillOrTopic = "Ajouter une comp\xe9tence";
var dgProfileOverview_AwardReceivedDate = "Date de r\xe9ception";
var dgProfileOverview_BuildProfileAchievementsComplete_Plural = "{{achievementsCount}}\xa0r\xe9ussites";
var dgProfileOverview_BuildProfileAchievementsComplete_Single = "{{achievementsCount}}\xa0r\xe9ussite";
var dgProfileOverview_BuildProfileAchievementsIncomplete = "Ajouter {{achievementsLimit}}\xa0 r\xe9ussite";
var dgProfileOverview_BuildProfileExperiencesComplete_Plural = "{{experiencesCount}}\xa0exp\xe9riences";
var dgProfileOverview_BuildProfileExperiencesComplete_Single = "{{experiencesCount}}\xa0exp\xe9rience";
var dgProfileOverview_BuildProfileExperiencesIncomplete = "Ajouter {{experiencesLimit}}\xa0exp\xe9rience";
var dgProfileOverview_BuildProfileFocusSkillsComplete = "{{focusSkillsCount}}\xa0comp\xe9tences prioritaires";
var dgProfileOverview_BuildProfileFocusSkillsComplete_Plural = "{{focusSkillsCount}}\xa0comp\xe9tences prioritaires";
var dgProfileOverview_BuildProfileFocusSkillsIncomplete = "D\xe9finir {{focusSkillsLimit}}\xa0comp\xe9tences prioritaires";
var dgProfileOverview_BuildProfileLearningsComplete_Plural = "{{learningsCount}}\xa0formations";
var dgProfileOverview_BuildProfileLearningsIncomplete = "Terminer {{learningsLimit}}\xa0formation(s)";
var dgProfileOverview_BuildProfileSectionCompleted = "Termin\xe9";
var dgProfileOverview_BuildProfileSkillRatingsComplete_Plural = "{{skillRatingsCount}}\xa0\xe9valuations de comp\xe9tence";
var dgProfileOverview_BuildProfileSkillRatingsComplete_Single = "{{skillRatingsCount}}\xa0\xe9valuation de la comp\xe9tence";
var dgProfileOverview_BuildProfileSkillRatingsIncomplete = "\xc9valuer {{skillRatingsLimit}}\xa0comp\xe9tence";
var dgProfileOverview_BuildProfileSkillsComplete_Plural = "{{skillsCount}}\xa0comp\xe9tences";
var dgProfileOverview_BuildProfileSkillsIncomplete = "Ajouter {{skillsLimit}}\xa0comp\xe9tences";
var dgProfileOverview_BuildProfileSubTitle = "En finalisant votre profil, vous pourrez b\xe9n\xe9ficier d’une exp\xe9rience personnalis\xe9e, faire le suivi de votre formation et communiquer votre expertise aux autres collaborateurs de votre organisation.";
var dgProfileOverview_BuildProfileTitle = "Compl\xe9tez votre profil";
var dgProfileOverview_CertificateNumber = "Num\xe9ro du certificat";
var dgProfileOverview_Columns = "Colonnes";
var dgProfileOverview_ColumnsToDisplay = "S\xe9lectionnez les colonnes \xe0 afficher";
var dgProfileOverview_FilterForSkills = "Filtrer par comp\xe9tence";
var dgProfileOverview_FindExperts = "Rechercher des experts";
var dgProfileOverview_FocusedSkills = "Comp\xe9tences prioritaires";
var dgProfileOverview_FocusedSkillsDescription = "Les comp\xe9tences dans cette section g\xe9n\xe8reront du contenu pertinent pour le flux de votre page d’accueil.";
var dgProfileOverview_FocusEmptyState_Link = "D\xe9finir mes comp\xe9tences prioritaires";
var dgProfileOverview_FocusEmptyState_Owner = "Vous n’avez d\xe9fini aucune comp\xe9tence prioritaire";
var dgProfileOverview_FocusEmptyState_Viewer = "Vous n’avez d\xe9fini aucune comp\xe9tence prioritaire";
var dgProfileOverview_FocusSkills = "Comp\xe9tences prioritaires";
var dgProfileOverview_FocusSkills_EmptyState = "Ajoutez les comp\xe9tences prioritaires sur lesquelles vous travaillez pour recevoir des recommandations de contenu personnalis\xe9es.";
var dgProfileOverview_FocusSkillsDescription = "Les comp\xe9tences de cette section seront mises en \xe9vidence sur la page d’accueil.";
var dgProfileOverview_FocusSkillsDescriptionOtherProfile = "{{name}} travaille actuellement sur les comp\xe9tences de cette section.";
var dgProfileOverview_FocusSkillsHelp = "Ajoutez ou supprimez une comp\xe9tence prioritaire en cliquant sur";
var dgProfileOverview_FocusSkillsHelp_and_Core_Icon = "Ajoutez ou supprimez une comp\xe9tence prioritaire en cliquant sur l’ic\xf4ne {{starIcon}}";
var dgProfileOverview_HasParsedResume = "CV analys\xe9";
var dgProfileOverview_LearningTitle = "Formations";
var dgProfileOverview_MaxColumnsToDisplay = "S\xe9lectionnez jusqu’\xe0 {{maxSelectable}}\xa0colonnes \xe0 afficher";
var dgProfileOverview_MaxFocusedSkills = "Vous pouvez ajouter jusqu’\xe0 {{maxFocusSkills}} comp\xe9tences.";
var dgProfileOverview_NoCompletedContent = "Vous n’avez pas r\xe9cemment r\xe9alis\xe9 de contenu. Vous pouvez trouver du contenu dans les flux de votre page d’accueil ou en parcourant ou recherchant des contenus.";
var dgProfileOverview_NonOwnerEmptyStateBody = "{{ firstName }} n’a encore rien ajout\xe9 \xe0 son profil.";
var dgProfileOverview_NonOwnerEmptyStateTitle = "Il n’y a rien ici.";
var dgProfileOverview_NoParsedResume = "Aucun CV analys\xe9";
var dgProfileOverview_NoSkills = "{{userName}} n’a pas encore ajout\xe9 de comp\xe9tences ou de rubriques.";
var dgProfileOverview_NothingCompleted = "{{userName}} n’a encore rien r\xe9alis\xe9.";
var dgProfileOverview_OtherSkills = "Autres comp\xe9tences";
var dgProfileOverview_OverviewAchievementsTitle = "Accomplissements";
var dgProfileOverview_OverviewCompleteWizardButton = "Compl\xe9ter l’assistant";
var dgProfileOverview_OverviewEmptyStateText = "Vous devez fournir davantage d’informations avant de pouvoir utiliser votre profil.";
var dgProfileOverview_OverviewEmptyStateTitle = "Commencez \xe0 cr\xe9er votre profil";
var dgProfileOverview_OverviewExperienceTitle = "Exp\xe9rience";
var dgProfileOverview_OverviewLearningTitle = "Apprentissage";
var dgProfileOverview_OverviewNotProvidedTitle = "Non renseign\xe9";
var dgProfileOverview_OverviewSkillsTitle = "Comp\xe9tences";
var dgProfileOverview_RecentlyCompleted = "R\xe9cemment effectu\xe9";
var dgProfileOverview_RemoveSkill = "La comp\xe9tence {{skillName}} a \xe9t\xe9 supprim\xe9e";
var dgProfileOverview_RequiredCriticalSkills = "Comp\xe9tences critiques";
var dgProfileOverview_RequiredSkills = "Comp\xe9tences requises";
var dgProfileOverview_RequiredSkillsDescription = "Votre organisation a attribu\xe9 ces comp\xe9tences \xe0 votre d\xe9veloppement professionnel.";
var dgProfileOverview_SeeSkillCollection = "Afficher la collection li\xe9e \xe0 la comp\xe9tence";
var dgProfileOverview_SkillActionsAriaLabel = "Actions pour la comp\xe9tence {{skillName}}";
var dgProfileOverview_SkillListView_Description = "Description";
var dgProfileOverview_SkillListView_Endorsed = "Recommand\xe9";
var dgProfileOverview_SkillListView_OrgSkill = "Comp\xe9tence de l’organisation";
var dgProfileOverview_SkillListView_SkillSignals = "Signaux de comp\xe9tence";
var dgProfileOverview_SkillListView_Source = "Source";
var dgProfileOverview_SkillListView_SourceValue_Experience = "Exp\xe9rience";
var dgProfileOverview_SkillListView_SourceValue_Organization = "Organisation";
var dgProfileOverview_SkillListView_SourceValue_Self = "Ajout personnel";
var dgProfileOverview_SkillListView_TotalRatings = "Total des \xe9valuations";
var dgProfileOverview_SkillListView_Type = "Type";
var dgProfileOverview_SkillSignalDataTableLabel = "D\xe9tails des donn\xe9es du signal de comp\xe9tences";
var dgProfileOverview_SkillSignalsLabel = "{{skillName}} : {{numSignals}} signaux de comp\xe9tences. \xc9valuations : {{ratingsCount}}. Exp\xe9riences : {{experiencesCount}}. R\xe9ussites : {{achievementsCount}}. Formations : {{learningsCount}}.";
var dgProfileOverview_SkillSignalsTitle = "Signaux de comp\xe9tence";
var dgProfileOverview_SkillSuggestionsSubTitle = "Sugg\xe9r\xe9es en fonction des comp\xe9tences de votre profil.";
var dgProfileOverview_SkillSuggestionsSubTitle_By_Org = "Ces suggestions proviennent de votre organisation.";
var dgProfileOverview_SkillSuggestionsSubTitle_On_Role = "⁪⁪⁪‍‍‍‍‍‍‍‍‍‍‍‍‍‍‍‍⁪Ces suggestions sont bas\xe9es sur votre poste.";
var dgProfileOverview_SkillSuggestionsTitle = "Suggestions de comp\xe9tences";
var dgProfileOverview_StackedSkillRatingsAriaLabel = "\xc9valuations de la comp\xe9tence {{skillName}}";
var dgProfileOverview_TooltipSignalsPlural = "Signaux";
var dgProfileOverview_TooltipSignalsSingle = "Signal";
var dgProfileOverview_TooltipSignalsZero = "Signaux";
var dgProfileOverview_ViewAllAchievements = "Section R\xe9ussites\xa0: Afficher toutes les r\xe9ussites";
var dgProfileOverview_ViewAllExperiences = "Section Exp\xe9riences\xa0: Afficher toutes les exp\xe9riences";
var dgProfileOverview_ViewAllLearning = "Section Formations\xa0: Afficher toutes les formations";
var dgProfileOverview_ViewAllSkills = "Section Comp\xe9tences\xa0: Afficher toutes les comp\xe9tences";
var dgProfileOverview_ViewAward = "Afficher le badge";
var dgProfileOverview_ViewBadge = "Voir l’insigne";
var dgProfileOverview_ViewCertificate = "Afficher le certificat";
var dgProfileOverview_ViewDegree = "Voir le dipl\xf4me";
var dgProfileShareActivity_DateShared = "Date de partage";
var dgProfileShareActivity_GroupsSharedWith = "Groupes avec lesquels j’ai partag\xe9 ceci";
var dgProfileShareActivity_NumCommentsPlural = "{{title}} a {{count}}\xa0commentaires";
var dgProfileShareActivity_NumCommentsSingular = "{{title}} a 1\xa0commentaire";
var dgProfileShareActivity_NumGroupsSharedWithPlural = "Vous avez partag\xe9 {{title}} avec {{count}}\xa0groupes";
var dgProfileShareActivity_NumGroupsSharedWithSingular = "Vous avez partag\xe9 {{title}} avec 1\xa0groupe";
var dgProfileShareActivity_NumPeopleSharedWithPlural = "Vous avez partag\xe9 {{title}} avec {{count}}\xa0personnes";
var dgProfileShareActivity_NumPeopleSharedWithSingular = "Vous avez partag\xe9 {{title}} avec 1\xa0personne";
var dgProfileShareActivity_PeopleSharedWith = "Personnes avec lesquelles j’ai partag\xe9 ceci";
var dgProfileShareActivity_ShareActivity = "Activit\xe9 de partage";
var dgProviderLicense_CreateLicenseBtnFormat = "Cr\xe9er une licence {{providerName}}";
var dgProviderLicense_GenerateLicenseFormat = "G\xe9n\xe9rer une licence pour {{providerName}}";
var dgRatingButtonMeta_1Hour = "1\xa0heure";
var dgRatingButtonMeta_HoursFormat = "{{numHrs}}\xa0heures";
var dgRecommendationsOverview_About = "Les personnes que vous suivez peuvent partager avec vous leurs articles, vid\xe9os et livres pr\xe9f\xe9r\xe9s ainsi que d’autres formidables ressources.";
var dgRecommendationsOverview_AboutConsumer = "Les personnes que vous suivez peuvent partager avec vous leurs articles, vid\xe9os et livres pr\xe9f\xe9r\xe9s ainsi que d’autres formidables ressources";
var dgRecommendationsOverview_AlreadyCompletedAssignedByFormat = "{{personName}} a demand\xe9 \xe0 {{groupName}} de {{contentAction}} ceci {{contentType}} {{hasDateHtml}}avant le {{date}}{{hasDateEndHtml}}, mais vous l’avez d\xe9j\xe0 fait. Excellent travail, vous vous surpassez !";
var dgRecommendationsOverview_AlreadyCompletedAssignedYouFormat = "{{personName}} vous a demand\xe9 de {{contentAction}} ceci {{contentType}} {{hasDateHtml}}avant le {{date}}{{hasDateEndHtml}}, mais vous l’avez d\xe9j\xe0 fait. Excellent travail, vous vous surpassez !";
var dgRecommendationsOverview_AlreadyCompletedRecommendedByFormat = "{{nameHtml}} a partag\xe9 ceci avec {{groupNameHtml}}, mais vous l’avez d\xe9j\xe0 termin\xe9. Excellent travail, vous vous surpassez !";
var dgRecommendationsOverview_AlreadyCompletedRecommendedYouFormat = "{{nameHtml}} a partag\xe9 ceci avec vous, mais vous l’avez d\xe9j\xe0 termin\xe9. Excellent travail, vous vous surpassez !";
var dgRecommendationsOverview_AssignedByFormat = "{{personName}} a assign\xe9 {{groupName}} ceci {{contentType}} \xe0 {{contentAction}} {{hasDateHtml}}par {{date}}{{hasDateEndHtml}}";
var dgRecommendationsOverview_AssignedYouFormat = "{{personName}} vous a assign\xe9 ce {{contentType}} \xe0 {{contentAction}} {{hasDateHtml}} par {{date}}{{hasDateEndHtml}}";
var dgRecommendationsOverview_Description = "Les \xe9l\xe9ments partag\xe9s avec vous et avec les groupes auxquels vous appartenez sont rassembl\xe9s ici afin d’\xeatre \xe9valu\xe9s et termin\xe9s.";
var dgRecommendationsOverview_EmptyStateDescription = "Les \xe9l\xe9ments partag\xe9s avec vous appara\xeetront ici.";
var dgRecommendationsOverview_EmptyStateTitle = "Aucun \xe9l\xe9ment partag\xe9";
var dgRecommendationsOverview_EmptyTitle = "Un peu de patience…";
var dgRecommendationsOverview_Filter = "Filtrer les \xe9l\xe9ments partag\xe9s";
var dgRecommendationsOverview_Incomplete = "Contenus non termin\xe9s";
var dgRecommendationsOverview_RecommendedByFormat = "{{nameHtml}} a partag\xe9 ceci avec {{groupNameHtml}}";
var dgRecommendationsOverview_RecommendedByFormerLearnerFormat = "Un ancien apprenant a partag\xe9 ceci avec {{groupNameHtml}}";
var dgRecommendationsOverview_RecommendedByNoCreatorFormat = "Ce(tte) {{contentType}} a \xe9t\xe9 partag\xe9(e) avec {{groupName}}.";
var dgRecommendationsOverview_RecommendedYouFormat = "{{nameHtml}} a partag\xe9 ceci avec vous";
var dgRecommendationsOverview_RecommendedYouFormerLearnerFormat = "Un ancien apprenant a partag\xe9 ceci avec vous";
var dgRecommendationsOverview_RecommendedYouNoCreatorFormat = "Ce(tte) {{contentType}} a \xe9t\xe9 partag\xe9(e) avec vous.";
var dgRecommendationsStatus_ByHeader = "Par";
var dgRecommendationsStatus_Empty = "Aucun \xe9l\xe9ment n’a \xe9t\xe9 partag\xe9.";
var dgRecommendationsStatus_HeaderAssignedTo = "Pour";
var dgRecommendationsStatus_HeaderCreatedDate = "Date de cr\xe9ation";
var dgRecommendationsStatus_HeaderDueDate = "Date limite";
var dgRecommendationsStatus_HeaderPercentComplete = "de compl\xe9tion";
var dgRecommendationsStatus_HeaderTitle = "Nom";
var dgRelatedInputs_Related = "Li\xe9";
var dgReorder_A11yItemMovedFormat = "L’\xe9l\xe9ment {{a}} a \xe9t\xe9 d\xe9plac\xe9 vers la position {{b}}";
var dgReorder_MoveNext = "D\xe9placer vers Suivant";
var dgReorder_MovePrev = "D\xe9placer vers Pr\xe9c\xe9dent";
var dgReorder_NoTitleText = "(Pas de titre)";
var dgReorder_SaveChanges = "Enregistrer les modifications";
var dgSkillsCheckup_DoneRating = "\xc9valuation termin\xe9e";
var dgSkillsCheckup_message = "Il est temps de mettre \xe0 jour vos comp\xe9tences\xa0! Actualisez vos \xe9valuations de comp\xe9tences pour refl\xe9ter votre progression.";
var dgSkillsCheckup_UpdateRatings = "Mettre \xe0 jour les \xe9valuations";
var dgSkillSignal_BarChartSubheading = "Principaux signaux de comp\xe9tence par type";
var dgSkillSignal_OtherTypes = "Autres types";
var dgSkillSignalRatings_PrivacyInfo = "Les \xe9valuations priv\xe9es sont masqu\xe9es.";
var dgSkipNav_SkipMainNavigation = "Ignorer la navigation principale";
var dgSkipNav_SkipSidebar = "Ignorer la navigation lat\xe9rale";
var dgSkipNav_SkipSubNavigation = "Ignorer la sous-navigation";
var dgSkipNav_SkipToMainContent = "Afficher directement le contenu principal";
var dgSkipNav_SkipToSearchResults = "Afficher directement les r\xe9sultats de recherche";
var dgSocialConnectionJoined_TitleFormat = "Votre ami {{connectionName}} a rejoint Degreed";
var dgSocialConnectSuccess_TitleFormat = "Vous avez bien connect\xe9 votre compte {{providerDisplayName}}.";
var dgTagRating_A11yAddFocusSkill = "Ajouter {{skillName}} aux comp\xe9tences prioritaires";
var dgTagRating_A11yAddSelfRating = "Ajouter une auto-\xe9valuation pour {{skillName}}";
var dgTagRating_A11yAddSkillReview = "Ajouter une revue de comp\xe9tence pour {{skillName}}";
var dgTagRating_A11yAddSkillTarget = "Ajouter un niveau de comp\xe9tence cible pour {{skillName}}";
var dgTagRating_A11yChangeSelfRating = "Auto-\xe9valuation pour {{skillName}}, niveau {{levelNumber}}. Modifier l’auto-\xe9valuation";
var dgTagRating_A11yRemoveFocusSkill = "Supprimer {{skillName}} des comp\xe9tences prioritaires";
var dgTagRating_A11yRequestManagerRating = "Demander l’\xe9valuation de {{skillName}} par un manager";
var dgTagRating_A11yRequestPeerRating = "Demander l’\xe9valuation de {{skillName}} par un pair";
var dgTagRating_A11yRequestUpdateManagerRating = "\xc9valuation de {{skillName}} par un manager, niveau {{levelNumber}}. Demander une \xe9valuation par un manager";
var dgTagRating_A11yRequestUpdatePeerRating = "\xc9valuation de {{skillName}} par un pair, niveau {{levelNumber}}. Demander une \xe9valuation par un pair";
var dgTagRating_A11ySelfRatingCount = "{{skillName}} is self-rated at level {{rating}}";
var dgTagRating_A11ySkillOptions = "Plus d’options pour {{skillName}}";
var dgTagRating_A11ySkillReviewComplete = "Revue de comp\xe9tence termin\xe9e pour {{skillName}}, niveau {{levelNumber}}";
var dgTagRating_A11ySkillReviewInProgress = "Revue de comp\xe9tence en cours pour {{skillName}}";
var dgTagRating_A11ySkillSignalCounts = "{{totalSignalCount}}\xa0signaux de comp\xe9tence pour {{skillName}}";
var dgTagRating_A11ySkillTarget = "Cible pour {{skillName}}, niveau {{levelNumber}}. Modifier le niveau cible";
var dgTagRating_A11yTotalRatingCounts = "{{skillName}} a un total de {{totalRatingsCount}}\xa0\xe9valuations";
var dgTagRating_AddA11y = "Ajouter la comp\xe9tence \xe0 votre profil";
var dgTagRating_AddCredential = "Ajouter une certification de comp\xe9tence";
var dgTagRating_Added = "Ajout\xe9";
var dgTagRating_AddedA11y = "Supprimer la comp\xe9tence de votre profil";
var dgTagRating_AddedIntegrationSkillsProfileDetails = "Nous avons trouv\xe9 {{skillsLength}}\xa0tests d'\xe9valuation de comp\xe9tences {{providerName}} et nous avons ajout\xe9 les notes correspondant \xe0 chaque comp\xe9tence sur votre profil.";
var dgTagRating_AddEvalRating = "Ajouter une revue de comp\xe9tence";
var dgTagRating_AddEvaluation = "Ajouter une revue de comp\xe9tence";
var dgTagRating_AddExternalRatingDetail = "\xc9valuez votre degr\xe9 de ma\xeetrise des comp\xe9tences \xe0 l’aide de {{ProviderName}}.";
var dgTagRating_AddFocusSkill = "Ajouter une comp\xe9tence prioritaire";
var dgTagRating_AddFocusSkillItem = "Add {{title}} as focus still";
var dgTagRating_AddingRatingsToPersonalize = "L’ajout de notes attribu\xe9es aux comp\xe9tences de votre profil permet de personnaliser votre exp\xe9rience.";
var dgTagRating_AddManagerTarget = "Ajouter une \xe9valuation du manager";
var dgTagRating_AddRating = "Ajouter une \xe9valuation";
var dgTagRating_AddRatingError = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de l’ajout de la note.";
var dgTagRating_AddSelfAssessment = "Ajouter une auto-\xe9valuation";
var dgTagRating_AddSelfRating = "Ajouter une auto-\xe9valuation";
var dgTagRating_AddSelfRatingDetail = "\xc9valuez-vous.";
var dgTagRating_AddSkillLevel = "+ Ajouter un niveau d’expertise";
var dgTagRating_AddSkills = "Ajouter des comp\xe9tences";
var dgTagRating_AddSkillTarget = "Ajouter la cible de la comp\xe9tence";
var dgTagRating_AddToMySkills = "Ajouter \xab\xa0{{tagName}}\xa0\xbb \xe0 mes comp\xe9tences";
var dgTagRating_AddToProfile = "Ajouter au profil";
var dgTagRating_AddToProfileTooltip = "Ajouter au profil";
var dgTagRating_Advanced = "Avanc\xe9";
var dgTagRating_AssessmentScore = "R\xe9sultats du test d'\xe9valuation";
var dgTagRating_Autonomy = "Autonomie";
var dgTagRating_Autonomy_Desc_Scale6_1 = "Vous pr\xe9f\xe9rez travailler dans un cadre structur\xe9 et supervis\xe9 dot\xe9 de processus pr\xe9d\xe9termin\xe9s pour r\xe9soudre des probl\xe8mes de base.";
var dgTagRating_Autonomy_Desc_Scale6_2 = "Vous pouvez accomplir des t\xe2ches par vous-m\xeame, mais lorsqu’un probl\xe8me complexe survient, vous chercherez certainement de l’aide. Vous en savez assez sur vos comp\xe9tences pour faire la diff\xe9rence entre un travail correct et un excellent travail.";
var dgTagRating_Autonomy_Desc_Scale6_3 = "Vous pouvez travailler de mani\xe8re autonome sur de nouveaux d\xe9fis. Vous savez fixer vos propres objectifs afin de mesurer la progression, et vous \xeates capable de passer en revue votre travail et d’\xe9valuer avec pr\xe9cision sa r\xe9ussite.";
var dgTagRating_Autonomy_Desc_Scale6_4 = "Vous savez travailler de mani\xe8re autonome sur des projets complexes, et vous pouvez g\xe9rer un projet et le mener \xe0 terme avec peu ou pas de supervision. Vous savez pr\xe9voir la m\xe9thode que vous allez utiliser, mettre en application cette planification et \xe9valuer son efficacit\xe9, m\xeame si vous appr\xe9ciez toujours les commentaires externes sur votre travail.";
var dgTagRating_Autonomy_Desc_Scale6_5 = "Vous \xeates probablement digne de confiance en ce qui concerne votre domaine, et d’autres peuvent vous pr\xe9senter des id\xe9es, des situations ou des probl\xe8mes afin de vous demander votre avis. Vous \xeates probablement dou\xe9 pour communiquer les probl\xe8mes et les solutions potentielles.";
var dgTagRating_Autonomy_Desc_Scale6_6 = "Vous savez travailler de mani\xe8re autonome sur des projets tr\xe8s complexes, et vous innovez pour faire avancer le domaine. Vous avez probablement dirig\xe9 avec succ\xe8s des \xe9quipes qui travaillent sur de grands projets repoussant les limites de votre domaine. Vous \xeates compl\xe8tement autonome et vous \xeates recommand\xe9 en tant que coordinateur et sp\xe9cialiste d’un champ d’expertise.";
var dgTagRating_Autonomy_Desc_Scale8_1 = "Vous pr\xe9f\xe9rez travailler dans un cadre structur\xe9 et supervis\xe9 dot\xe9 de processus pr\xe9d\xe9termin\xe9s et de crit\xe8res de productivit\xe9 bien d\xe9finis.";
var dgTagRating_Autonomy_Desc_Scale8_2 = "Vous \xeates capable de r\xe9soudre des probl\xe8mes simples et d’accomplir des t\xe2ches en toute autonomie. Cependant, vous \xeates susceptible d’avoir besoin d’aide si un probl\xe8me plus compliqu\xe9 surgit.";
var dgTagRating_Autonomy_Desc_Scale8_3 = "Dans l’ensemble, vous \xeates en mesure de relever de nouveaux d\xe9fis sans avoir besoin d’aide. Vous ma\xeetrisez vos comp\xe9tences au point de savoir faire preuve d’autocritique et vous savez faire la diff\xe9rence entre bon et excellent travail. Vous vous fixez \xe9galement d\xe9sormais vos propres objectifs pour mesurer votre progression.";
var dgTagRating_Autonomy_Desc_Scale8_4 = "Vous savez travailler en autonomie sur des projets complexes. Une fois ces projets achev\xe9s, vous \xeates capable de prendre du recul et d’\xe9valuer la qualit\xe9 de votre travail. Bien qu’une supervision ne soit pas n\xe9cessaire, vous attachez de l’importance \xe0 l’avis de vos coll\xe8gues concernant votre travail.";
var dgTagRating_Autonomy_Desc_Scale8_5 = "Vous \xeates autonome et menez votre propre barque. Vous prenez des initiatives et menez \xe0 bien vos projets sans ou avec tr\xe8s peu de supervision. Vous savez planifier votre m\xe9thode de travail et la mettre \xe0 ex\xe9cution avant d’\xe9valuer son efficacit\xe9. Vous \xeates \xe9galement capable d’envisager des processus alternatifs et d’entrevoir leurs r\xe9sultats potentiels. Vous incarnez certainement une figure de confiance dans votre domaine, \xe0 tel point que vos pairs se tournent vers vous en cas de probl\xe8me ou pour partager leurs id\xe9es afin d’avoir votre avis ou de solliciter votre aide.";
var dgTagRating_Autonomy_Desc_Scale8_6 = "Vous savez travailler en autonomie sur des projets particuli\xe8rement complexes. Votre point de vue unique vous permet de r\xe9soudre des probl\xe8mes \xe9pineux et de proposer des innovations pour faire progresser votre domaine d’activit\xe9. Vous savez faire comprendre les probl\xe8mes, proposer des solutions et diriger une \xe9quipe de praticiens.";
var dgTagRating_Autonomy_Desc_Scale8_7 = "Vous avez certainement \xe9t\xe9 \xe0 la t\xeate d’importants projets dont l’objectif \xe9tait de repousser les limites de votre domaine. Que vous soyez praticien ou que vous occupiez un r\xf4le de leader \xe0 temps plein, votre point de vue est respect\xe9 par tous les acteurs de votre domaine.";
var dgTagRating_Autonomy_Desc_Scale8_8 = "Vous \xeates totalement autonome et vos pairs vous consid\xe8rent comme un chercheur et un leader du secteur. Vous choisissez les projets sur lesquels vous souhaitez travailler et vous optez pour ceux qui vous permettront d’avoir un maximum d’impact dans votre domaine afin de proposer de nouvelles id\xe9es ou pratiques.";
var dgTagRating_AverageLevel = "Niveau moyen {{Level}}";
var dgTagRating_Beginner = "D\xe9butant";
var dgTagRating_CancelEval = "Annuler la revue de comp\xe9tence";
var dgTagRating_CancelMgrRatingRequest = "Annuler la demande d’\xe9valuation du manager";
var dgTagRating_CancelPeerRequests = "Annuler les demandes d’\xe9valuation par un pair en attente";
var dgTagRating_CancelPeerRequestsDesc = "Si une personne de votre liste a une demande d’\xe9valuation en attente, \xe9mise par vous, pour cette comp\xe9tence, s\xe9lectionnez cette option pour annuler cette demande et en envoyer une nouvelle.";
var dgTagRating_CancelRequest = "Annuler la demande";
var dgTagRating_Capable = "Novice";
var dgTagRating_CertVisibility = "Public ou priv\xe9";
var dgTagRating_ChangeManagerRating = "Modifier l’\xe9valuation du manager";
var dgTagRating_ChangePeerRating = "Modifier l’\xe9valuation par un pair";
var dgTagRating_ChangeSkillTarget = "Modifier la cible de la comp\xe9tence";
var dgTagRating_Checkpoint = "Point de contr\xf4le";
var dgTagRating_Checkpoints = "Points de contr\xf4le";
var dgTagRating_ClearCurrentRating = "Effacer l’\xe9valuation actuelle";
var dgTagRating_ClearCurrentTarget = "Effacer la cible actuelle";
var dgTagRating_CommentPlaceholderFormat = "Donnez \xe0 {{name}} plus d’informations sur cette note...";
var dgTagRating_Comments = "Commentaires";
var dgTagRating_commentVisible = "Il est possible que votre \xe9valuation et votre commentaire soient visibles par d’autres personnes. {{linkStart}}En savoir plus{{linkEnd}}";
var dgTagRating_CompleteCheckpoints = "R\xe9alisez un point de contr\xf4le de comp\xe9tence dans Degreed.";
var dgTagRating_ContinueEvaluation = "Continuer la revue de comp\xe9tence";
var dgTagRating_ContinueProcess = "Poursuivre le processus";
var dgTagRating_Credential = "Certification de comp\xe9tence";
var dgTagRating_Critical_RemoveFromProfileConfirmation = "Votre organisation consid\xe8re que {{skill}} est une comp\xe9tence importante pour votre poste. Voulez-vous vraiment supprimer cette comp\xe9tence\xa0?";
var dgTagRating_CurrentManagerRating = "\xc9valuation actuelle par le manager";
var dgTagRating_CurrentPeerRating = "\xc9valuation actuelle par un pair";
var dgTagRating_CurrentSkillTarget = "Cible actuelle de la comp\xe9tence";
var dgTagRating_DeactivatedUser = "Utilisateur d\xe9sactiv\xe9";
var dgTagRating_DegreedCertification = "Certification Degreed";
var dgTagRating_DegreedCertified = "Certifi\xe9 Degreed";
var dgTagRating_DescribeRatingSelected = "Indiquez pourquoi vous avez s\xe9lectionn\xe9 ce niveau d’\xe9valuation";
var dgTagRating_descriptionPlaceholderManagerRating = "Indiquez bri\xe8vement pourquoi vous avez laiss\xe9 cette \xe9valuation en tant que manager.";
var dgTagRating_descriptionPlaceholderPeerRating = "Indiquez bri\xe8vement pourquoi vous avez laiss\xe9 cette \xe9valuation en tant que pair.";
var dgTagRating_descriptionPlaceholderSkillTarget = "Indiquez bri\xe8vement pourquoi vous avez d\xe9fini cette cible de comp\xe9tence.";
var dgTagRating_Distinguished = "\xc9m\xe9rite";
var dgTagRating_DoneRating = "\xc9valuation termin\xe9e";
var dgTagRating_EditExpertise = "Modifier l’\xe9valuation";
var dgTagRating_EditExpertiseLabel = "{{skillTitle}} Modifier l’\xe9valuation";
var dgTagRating_Effective = "Comp\xe9tent";
var dgTagRating_EndorsedByFormat = "Approuv\xe9 par {{name}}";
var dgTagRating_Evaluation = "Revue de comp\xe9tence";
var dgTagRating_EvalVisibility = "Public ou priv\xe9";
var dgTagRating_Experienced = "Exp\xe9riment\xe9";
var dgTagRating_Expert = "Expert";
var dgTagRating_FocusSkillAdded = "{{skill}} a \xe9t\xe9 ajout\xe9 en tant que comp\xe9tence prioritaire \xe0 votre profil.";
var dgTagRating_FoundIntegrationSkillsProfileDetails = "Nous avons trouv\xe9 des comp\xe9tences \xe9valu\xe9es par {{providerName}} qui ne se trouvent pas sur votre profil. S\xe9lectionnez les comp\xe9tences que vous souhaitez ajouter et nous y indiquerons leurs r\xe9sultats.";
var dgTagRating_GetCertificate = "Obtenir un certificat officiel. Un processus scientifique v\xe9rifi\xe9 par notre panel d’experts.";
var dgTagRating_Industry = "Secteur";
var dgTagRating_Industry_Desc_Scale6_1 = "Vous d\xe9couvrez le secteur et vous vous familiarisez avec son histoire, ses bonnes pratiques et ses d\xe9fis.";
var dgTagRating_Industry_Desc_Scale6_2 = "Votre connaissance des tendances et de la technologie s’am\xe9liore et vous vous familiarisez avec le travail des influenceurs et des innovateurs leaders de votre secteur. Vous pouvez b\xe9n\xe9ficier de conseils de haut niveau sur les th\xe9ories et les meilleures pratiques.";
var dgTagRating_Industry_Desc_Scale6_3 = "Vous suivez les tendances et \xeates capable de d\xe9terminer en quoi elles influeront sur votre secteur. Vous commencez \xe9galement \xe0 vous faire votre propre avis sur les solutions mises en œuvre par vos concurrents et \xeates en mesure d’\xe9valuer leur efficacit\xe9.";
var dgTagRating_Industry_Desc_Scale6_4 = "Vous suivez les derniers d\xe9veloppements dans le domaine et comprenez clairement l’orientation future de votre secteur dans les prochaines ann\xe9es. Vous \xeates en mesure d’expliquer efficacement les th\xe9ories et les solutions aux autres.";
var dgTagRating_Industry_Desc_Scale6_5 = "Vous avez une compr\xe9hension approfondie du secteur et avez acquis l’exp\xe9rience n\xe9cessaire pour porter des jugements de haut niveau. Vous voyez comment votre travail interagit et affecte d’autres domaines.";
var dgTagRating_Industry_Desc_Scale6_6 = "Vous \xeates leader dans votre domaine, et de nombreux acteurs du secteur se tournent vers vous pour obtenir des conseils. Le travail que vous r\xe9alisez est souvent qualifi\xe9 de r\xe9volutionnaire dans le secteur, et vous avez la capacit\xe9 d’inventer les outils aptes \xe0 r\xe9soudre les plus gros probl\xe8mes repr\xe9sentatifs de votre domaine.";
var dgTagRating_Industry_Desc_Scale8_1 = "Vous d\xe9couvrez le secteur, son histoire, ses bonnes pratiques et ses d\xe9fis.";
var dgTagRating_Industry_Desc_Scale8_2 = "Vous vous familiarisez de plus en plus avec les bonnes pratiques, le jargon, les tendances et la technologie du secteur.";
var dgTagRating_Industry_Desc_Scale8_3 = "Il peut vous \xeatre utile de vous rapporter \xe0 certains conseils th\xe9oriques et bonnes pratiques du secteur lorsque vous utilisez votre comp\xe9tence. Vous vous familiarisez avec le travail r\xe9alis\xe9 par les personnes influentes et les innovateurs \xe0 la t\xeate de votre secteur.";
var dgTagRating_Industry_Desc_Scale8_4 = "Vous suivez les tendances et \xeates capable de d\xe9terminer en quoi elles influeront sur votre secteur. Vous commencez \xe9galement \xe0 vous faire votre propre avis sur les solutions mises en œuvre par vos concurrents et \xeates en mesure d’\xe9valuer leur efficacit\xe9.";
var dgTagRating_Industry_Desc_Scale8_5 = "Vous \xeates au fait des derni\xe8res \xe9volutions dans votre domaine. Vous savez pr\xe9senter les principes de base et justifier les solutions utilis\xe9es \xe0 vos coll\xe8gues.";
var dgTagRating_Industry_Desc_Scale8_6 = "Votre secteur n’a plus de secrets pour vous et vous savez pr\xe9cis\xe9ment de quoi sera fait son avenir. Vous savez \xe9galement en quoi votre travail affecte d’autres domaines.";
var dgTagRating_Industry_Desc_Scale8_7 = "Vous \xeates certainement en charge de prendre des d\xe9cisions importantes au sein de votre secteur. En effet, puisque vous \xeates \xe0 la t\xeate de votre domaine, nombreux sont ceux qui sollicitent vos conseils en mati\xe8re de d\xe9fis et de sp\xe9cialisations ou qui souhaitent avoir votre avis au sujet des derni\xe8res \xe9volutions et de l’avenir de votre secteur.";
var dgTagRating_Industry_Desc_Scale8_8 = "Votre secteur tire pleinement parti de votre contribution en tant que leader. Votre travail est souvent qualifi\xe9 d’avant-gardiste par vos pairs et a tendance \xe0 jouer un r\xf4le pr\xe9pond\xe9rant dans votre domaine. Vous avez toutes les cartes en main pour cr\xe9er les outils de demain qui permettront de r\xe9soudre les principaux d\xe9fis auxquels votre secteur est confront\xe9. \xc0 ce titre, vous \xeates donc consid\xe9r\xe9 comme un leader, un guide et un mentor.";
var dgTagRating_InProgress = "En cours";
var dgTagRating_Intermediate = "Interm\xe9diaire";
var dgTagRating_InvalidRequest = "D\xe9sol\xe9, cette demande n’est plus valide.";
var dgTagRating_Knowledge = "Connaissances";
var dgTagRating_Knowledge_Desc_Scale6_1 = "Vous avez des connaissances fondamentales sur certains aspects du domaine de comp\xe9tence.";
var dgTagRating_Knowledge_Desc_Scale6_2 = "Vous avez acquis une connaissance pratique des principes de base et th\xe9oriques de votre domaine de comp\xe9tence.";
var dgTagRating_Knowledge_Desc_Scale6_3 = "Les connaissances techniques et th\xe9oriques se sont approfondies et vous comprenez comment les th\xe9ories et leurs mises en œuvre s’int\xe8grent aux diff\xe9rentes situations.";
var dgTagRating_Knowledge_Desc_Scale6_4 = "Vous avez des connaissances solides et sp\xe9cialis\xe9es sur vos comp\xe9tences. Vous avez compris la port\xe9e et les limites de votre domaine et vous pouvez vous servir de vos connaissances de la th\xe9orie, des outils, m\xe9thodologies et processus pour r\xe9soudre un large \xe9ventail de probl\xe8mes.";
var dgTagRating_Knowledge_Desc_Scale6_5 = "Vous ma\xeetrisez la th\xe9orie et la pratique appliqu\xe9es \xe0 votre domaine de comp\xe9tences, et vous \xeates capable de mettre en œuvre les outils, la m\xe9thodologie et les processus ad\xe9quats pour r\xe9soudre des probl\xe8mes complexes, dans des situations tr\xe8s vari\xe9es. Vous trouvez des solutions que d’autres n’h\xe9siteront pas \xe0 utiliser ou imiter \xe0 leur tour.";
var dgTagRating_Knowledge_Desc_Scale6_6 = "Vous tirez pleinement parti des connaissances sp\xe9cialis\xe9es, m\xe9thodes de recherche et approches dont vous disposez pour faire face \xe0 diff\xe9rents cas de figure, y compris des probl\xe8mes particuli\xe8rement nouveaux. Vous apportez des solutions, atteignez des r\xe9sultats et d\xe9veloppez l’ensemble de connaissances existantes, et comprenez les possibles orientations pour leur domaine ainsi que leur impact.";
var dgTagRating_Knowledge_Desc_Scale8_1 = "Vous disposez de connaissances g\xe9n\xe9rales sur certains aspects de la comp\xe9tence.";
var dgTagRating_Knowledge_Desc_Scale8_2 = "Vous avez acquis les connaissances de base de votre domaine de comp\xe9tences et savez les mettre en pratique, m\xeame si le chemin est encore long.";
var dgTagRating_Knowledge_Desc_Scale8_3 = "Vos connaissances ne se limitent plus aux principes de base et vous vous int\xe9ressez d\xe9sormais \xe0 la th\xe9orie de votre domaine de comp\xe9tences.";
var dgTagRating_Knowledge_Desc_Scale8_4 = "Vous avez approfondi votre savoir, vos connaissances th\xe9oriques et votre strat\xe9gie concernant votre comp\xe9tence.";
var dgTagRating_Knowledge_Desc_Scale8_5 = "Vous disposez de connaissances solides et sp\xe9cialis\xe9es au sujet de votre comp\xe9tence. Vous savez comment mettre la th\xe9orie en pratique pour faire face \xe0 toutes sortes de situations, et vous connaissez la port\xe9e et les limites de votre domaine.";
var dgTagRating_Knowledge_Desc_Scale8_6 = "Vous ma\xeetrisez le savoir, les connaissances th\xe9oriques, les outils, la m\xe9thodologie et les processus propres \xe0 votre domaine de comp\xe9tences. Vous \xeates non seulement capable d’utiliser ces connaissances pour r\xe9soudre n’importe quel probl\xe8me, mais \xe9galement de les communiquer clairement \xe0 autrui.";
var dgTagRating_Knowledge_Desc_Scale8_7 = "Vous disposez de connaissances approfondies sur les th\xe9ories actuelles (y compris leurs limites) et tirez pleinement parti des connaissances sp\xe9cialis\xe9es, m\xe9thodes de recherche et approches dont vous disposez pour faire face \xe0 diff\xe9rents cas de figure. Vous envisagez les obstacles qui se pr\xe9sentent sur votre chemin dans toute leur complexit\xe9 et trouvez des solutions que d’autres n’h\xe9siteront pas \xe0 utiliser ou imiter \xe0 leur tour. Vous disposez \xe9galement de connaissances qui vont au-del\xe0 de votre domaine d’expertise et \xeates capable de les mettre au service de votre secteur d’activit\xe9.";
var dgTagRating_Knowledge_Desc_Scale8_8 = "<p>Puisque vous avez atteint le niveau 8, vos connaissances et le point de vue unique dont vous disposez au sujet de votre secteur sont tr\xe8s recherch\xe9s. Vous savez globalement de quoi l’avenir sera fait et la fa\xe7on dont les \xe9volutions de votre domaine affecteront les acteurs, les outils, la technologie et les processus utilis\xe9s ainsi que le monde dans son ensemble. R\xe9flexion strat\xe9gique, pens\xe9e scientifique et esprit cr\xe9atif font donc partie de vos comp\xe9tences, et vous \xeates tr\xe8s certainement \xe0 la t\xeate de votre domaine. Vous avez une fa\xe7on bien \xe0 vous de r\xe9soudre les probl\xe8mes, d’apporter des solutions, d’atteindre des r\xe9sultats et de d\xe9velopper l’ensemble de connaissances existantes, y compris les connaissances sp\xe9cialis\xe9es qui ont trait \xe0 d’autres domaines, comp\xe9tences et disciplines.";
var dgTagRating_LastRated = "Derni\xe8re \xe9valuation le";
var dgTagRating_Level = "Niveau {{Level}}";
var dgTagRating_LevelDescription = "Description du niveau";
var dgTagRating_Levels = "Niveaux de comp\xe9tence";
var dgTagRating_LevelUp = "Pour passer au niveau sup\xe9rieur";
var dgTagRating_LevelUp_Desc_Scale6_1 = "<ul>\n<li>Absorbez autant d’informations que possible. N’h\xe9sitez pas \xe0 tirer pleinement profit des opportunit\xe9s d’apprentissage qui s’offrent \xe0 vous pour gravir les \xe9chelons et devenir un expert dans votre domaine.</li>\n<li>Soyez attentif. Glanez des informations aupr\xe8s des experts de votre secteur via les blogs, webinaires, newsletters, conf\xe9rences\xa0TED et autres ressources disponibles.</li>\n<li>Tirez profit des vid\xe9os, livres, cours et podcasts \xe0 votre disposition.</li>\n<li>Avant de vous lancer, demandez conseil \xe0 des professionnels du secteur de diff\xe9rents niveaux de comp\xe9tence.</li>\n</ul>";
var dgTagRating_LevelUp_Desc_Scale6_2 = "<ul>\n<li>Continuez \xe0 vous former et \xe0 d\xe9velopper vos comp\xe9tences dans diverses situations. Ainsi, vous pourrez vous servir de vos connaissances pour r\xe9soudre des probl\xe8mes ou des situations complexes.</li>\n<li>Communiquez avec vos pairs pour d\xe9couvrir comment ils abordent les t\xe2ches, situations et probl\xe8mes auxquels ils sont confront\xe9s. Les rencontres en personne, les groupes sur Facebook, les discussions sur Twitter et les forums en ligne constituent d’excellents points de d\xe9part.</li>\n<li>Communiquez avec les leaders du secteur et int\xe9ressez-vous \xe0 la fa\xe7on dont ils parviennent \xe0 surmonter les obstacles qui se dressent sur leur chemin. Suivez les derni\xe8res tendances et \xe9volutions technologiques, et continuez \xe0 les appliquer \xe0 vos comp\xe9tences.</li>\n</ul>";
var dgTagRating_LevelUp_Desc_Scale6_3 = "<ul>\n<li>Mettez la main \xe0 la p\xe2te. Portez-vous volontaire pour effectuer diff\xe9rentes t\xe2ches et acqu\xe9rir de l’exp\xe9rience. De cette mani\xe8re, vous pourrez tirer parti de vos connaissances de base et repousser les limites de vos capacit\xe9s.</li>\n<li>Peaufinez votre fa\xe7on de pr\xe9senter et de mettre en relation les th\xe9ories fondamentales avec les projets sur lesquels vous travaillez.</li>\n<li>Tenez-vous au courant des \xe9volutions technologiques et des nouvelles pratiques, et tentez de d\xe9terminer en quoi elles pourraient avoir une incidence sur votre domaine.</li>\n</ul>";
var dgTagRating_LevelUp_Desc_Scale6_4 = "<ul>\n<li>Les d\xe9butants comptent certainement sur vous pour leur enseigner les bases du m\xe9tier. Faites preuve d’ouverture, partagez vos commentaires et proposez-leur votre aide.</li>\n<li>Diversifiez vos connaissances th\xe9oriques en adoptant diff\xe9rents points de vue pour faire face aux probl\xe8mes ou d\xe9fis que vous rencontrez.</li>\n<li>Prenez l’initiative de tester les nouvelles technologies, d’adopter de nouvelles id\xe9es et de mettre en œuvre de nouvelles solutions pour d\xe9couvrir leur efficacit\xe9.</li>\n</ul>";
var dgTagRating_LevelUp_Desc_Scale6_5 = "<ul>\n<li>Restez \xe0 l’aff\xfbt des opportunit\xe9s de diriger une \xe9quipe et n’h\xe9sitez pas \xe0 prendre vos coll\xe8gues sous votre aile.</li>\n<li>Conf\xe9rences, webinaires, communaut\xe9s en ligne ou formations\xa0: saisissez toutes les opportunit\xe9s qui s’offrent \xe0 vous pour partager votre savoir et votre exp\xe9rience avec un public plus large.</li>\n<li>Optez pour de nouvelles fa\xe7ons de r\xe9soudre les probl\xe8mes et continuez \xe0 repousser vos propres limites en misant sur des outils innovants qui vous permettront de d\xe9velopper vos connaissances et vos comp\xe9tences.</li>\n</ul>";
var dgTagRating_LevelUp_Desc_Scale6_6 = "<ul>\n<li>Partagez vos r\xe9sultats avec vos pairs pour faire progresser votre secteur et stimuler l’innovation.</li>\n<li>Cr\xe9ez les outils et lancez les tendances qui fa\xe7onneront votre secteur.</li>\n<li>Puisez dans le savoir, les th\xe9ories et les pratiques d’autres domaines d’expertise pour d\xe9velopper de nouvelles solutions.</li>\n<li>Vous vous devez de mettre vos connaissances \xe0 profit de votre secteur et des domaines qui y sont li\xe9s. Utilisez vos comp\xe9tences pour cr\xe9er les th\xe9ories, processus, technologies et outils qui permettront de relever les principaux d\xe9fis auxquels votre domaine est confront\xe9.</li>\n</ul>";
var dgTagRating_LevelUp_Desc_Scale8_1 = "<ul>\n<li>Assimilez autant d’informations que possible. N’h\xe9sitez pas \xe0 tirer pleinement profit des opportunit\xe9s d’apprentissage qui s’offrent \xe0 vous pour gravir les \xe9chelons et devenir un expert dans votre domaine.</li>\n<li>Soyez attentif. Glanez des informations aupr\xe8s des experts de votre secteur via les blogs, webinaires, newsletters, conf\xe9rences\xa0TED et autres ressources disponibles.</li>\n<li>Tirez profit des vid\xe9os, livres, cours et podcasts \xe0 votre disposition.</li>\n<li>Avant de vous lancer, demandez conseil \xe0 des professionnels du secteur de diff\xe9rents niveaux de comp\xe9tence.</li>\n</ul>";
var dgTagRating_LevelUp_Desc_Scale8_2 = "<ul>\n<li>Continuez \xe0 vous former et \xe0 d\xe9velopper vos comp\xe9tences dans diverses situations. Ainsi, vous pourrez vous servir de vos connaissances pour r\xe9soudre des probl\xe8mes ou des situations complexes.</li>\n<li>Soyez attentif. Glanez des informations aupr\xe8s des experts de votre secteur via les blogs, webinaires, newsletters, conf\xe9rences\xa0TED et autres ressources disponibles.</li>\n<li>Tirez profit des vid\xe9os, livres, cours et podcasts \xe0 votre disposition.</li>\n<li>Communiquez avec vos pairs pour d\xe9couvrir comment ils abordent les t\xe2ches, situations et probl\xe8mes auxquels ils sont confront\xe9s. Les rencontres en personne, les groupes sur Facebook, les discussions sur Twitter et les forums en ligne constituent d’excellents points de d\xe9part.</li>\n</ul>";
var dgTagRating_LevelUp_Desc_Scale8_3 = "<ul>\n<li>Mettez la main \xe0 la p\xe2te. Portez-vous volontaire pour effectuer diff\xe9rentes t\xe2ches et acqu\xe9rir de l’exp\xe9rience. De cette mani\xe8re, vous pourrez tirer parti de vos connaissances de base et repousser les limites de vos capacit\xe9s.</li>\n<li>Communiquez avec les leaders du secteur et int\xe9ressez-vous \xe0 la fa\xe7on dont ils parviennent \xe0 surmonter les obstacles qui se dressent sur leur chemin. Suivez les derni\xe8res tendances et \xe9volutions technologiques, et continuez \xe0 les appliquer \xe0 vos comp\xe9tences.</li>\n</ul>";
var dgTagRating_LevelUp_Desc_Scale8_4 = "<ul>\n<li>Les d\xe9butants comptent certainement sur vous pour leur enseigner les bases du m\xe9tier. Faites preuve d’ouverture, partagez vos commentaires et proposez-leur votre aide.</li>\n<li>Peaufinez votre fa\xe7on de pr\xe9senter et de mettre en relation les th\xe9ories fondamentales avec les projets sur lesquels vous travaillez.</li>\n<li>Diversifiez vos connaissances th\xe9oriques en adoptant diff\xe9rents points de vue pour faire face aux probl\xe8mes ou d\xe9fis que vous rencontrez.</li>\n<li>Tenez-vous au courant des \xe9volutions technologiques et des nouvelles pratiques, et tentez de d\xe9terminer en quoi elles pourraient avoir une incidence sur votre domaine.</li>\n</ul>";
var dgTagRating_LevelUp_Desc_Scale8_5 = "<ul>\n<li>Prenez l’initiative de tester les nouvelles technologies, d’adopter de nouvelles id\xe9es et de mettre en œuvre de nouvelles solutions pour d\xe9couvrir leur efficacit\xe9.</li>\n<li>Recherchez les occasions de diriger une \xe9quipe et n’h\xe9sitez pas \xe0 prendre vos coll\xe8gues sous votre aile.</li>\n<li>Attaquez-vous \xe0 des t\xe2ches d’une complexit\xe9 \xe9lev\xe9e pour repousser les limites de votre zone de confort et suivez les conseils des personnes en qui vous avez confiance pour surmonter les obstacles qui se dressent sur votre chemin.</li>\n</ul>";
var dgTagRating_LevelUp_Desc_Scale8_6 = "<ul>\n<li>Conf\xe9rences, webinaires, communaut\xe9s en ligne ou formations\xa0: saisissez toutes les opportunit\xe9s qui s’offrent \xe0 vous pour partager votre savoir et votre exp\xe9rience avec un public plus large.</li>\n<li>Optez pour de nouvelles fa\xe7ons de r\xe9soudre les probl\xe8mes et continuez \xe0 repousser vos propres limites en misant sur des outils innovants qui vous permettront de d\xe9velopper vos connaissances et vos comp\xe9tences.</li>\n</ul>";
var dgTagRating_LevelUp_Desc_Scale8_7 = "<ul>\n<li>Confrontez-vous \xe0 certains des principaux d\xe9fis de votre secteur. Voyez grand.</li>\n<li>Partagez vos r\xe9sultats avec vos pairs pour faire progresser votre secteur et stimuler l’innovation.</li>\n<li>Cr\xe9ez les outils et lancez les tendances qui fa\xe7onneront votre secteur.</li>\n<li>Puisez dans le savoir, les th\xe9ories et les pratiques d’autres domaines d’expertise pour d\xe9velopper de nouvelles solutions.</li>\n<li>Restez \xe0 l’aff\xfbt des opportunit\xe9s de recherche.</li>\n</ul>";
var dgTagRating_LevelUp_Desc_Scale8_8 = "<ul>\n<li>Votre formation ne prend jamais fin, m\xeame une fois le niveau\xa08 atteint. Continuez \xe0 repousser vos limites.</li>\n<li>En tant qu’expert, vous vous devez de mettre vos connaissances \xe0 profit de votre secteur et des domaines qui y sont li\xe9s. Utilisez vos comp\xe9tences pour cr\xe9er les th\xe9ories, processus, technologies et outils qui permettront de relever les principaux d\xe9fis auxquels votre domaine est confront\xe9.</li>\n<li>Communiquez et collaborez autant que possible avec d’autres experts pour d\xe9velopper votre domaine dans son ensemble.</li>\n<li>Songez \xe0 la fa\xe7on la plus efficace d’enseigner et de partager vos connaissances.</li>\n</ul>";
var dgTagRating_LinkedSkillsNumber = "{{amount}}\xa0comp\xe9tences associ\xe9es";
var dgTagRating_ManagerAssessment = "\xc9valuation du manager";
var dgTagRating_ManagerRating = "\xc9valuation du manager";
var dgTagRating_ManagerRatinginProgress = "\xc9valuation du manager en cours";
var dgTagRating_Master = "Expert";
var dgTagRating_MeasureYourSkill = "Mesurez vos comp\xe9tences avec un questionnaire scientifique.";
var dgTagRating_MngrRatingRequestCancelled = "La demande d’\xe9valuation du manager a bien \xe9t\xe9 supprim\xe9e.";
var dgTagRating_ModalButtonAddWithoutRating = "Ajouter sans \xe9valuation";
var dgTagRating_ModalButtonAddWithRating = "Ajouter avec une \xe9valuation";
var dgTagRating_MyRatings = "Mes \xe9valuations";
var dgTagRating_NewManagerRating = "Nouvelle \xe9valuation du manager";
var dgTagRating_NewPeerRating = "Nouvelle \xe9valuation par un pair";
var dgTagRating_NewSkillTarget = "Nouvelle cible de la comp\xe9tence";
var dgTagRating_NoRatings = "Aucune preuve de comp\xe9tence pour le moment";
var dgTagRating_NoSkillTarget = "Aucune cible de la comp\xe9tence";
var dgTagRating_NoTargetLevelAssigned = "D\xe9finir un niveau cible";
var dgTagRating_NumberOfRatings = "{{ numberOfRatings }} \xe9valuations";
var dgTagRating_OtherRatings = "Autres \xe9valuations";
var dgTagRating_PeerRating = "\xc9valuation par un pair";
var dgTagRating_PeerRatingRequestCancelled = "La demande d’\xe9valuation par un pair a bien \xe9t\xe9 supprim\xe9e.";
var dgTagRating_PeerRatings = "\xc9valuation par un pair";
var dgTagRating_PeerRatingsTitle = "\xc9valuations par un pair";
var dgTagRating_PeerRequestCountWarning = "Vous \xeates sur le point d’envoyer une demande d’\xe9valuation par un pair \xe0 plus de {{count}} personnes.";
var dgTagRating_PendingSelfRatingRequest = "Demande d’auto-\xe9valuation en attente";
var dgTagRating_PrivacyPopoverDesc = "Choisissez qui peut voir votre niveau pour {{ratingType}}.";
var dgTagRating_PrivacyPopoverTitle = "Niveau pour {{ratingType}}";
var dgTagRating_PrivateToYou = "Visible uniquement par vous-m\xeame";
var dgTagRating_ProviderLogo = "Logo de {{ProviderName}}";
var dgTagRating_ProviderSkillLabel = "\xc9valuation de comp\xe9tence par {{ProviderName}}";
var dgTagRating_RatedByFormat = "\xc9valu\xe9 par {{manager}}";
var dgTagRating_RateNewSkills = "Noter les nouvelles comp\xe9tences";
var dgTagRating_RateSkills = "\xc9valuer les comp\xe9tences";
var dgTagRating_Rating = "\xc9valuations";
var dgTagRating_RatingInProgress = "Vous avez une \xe9valuation en cours";
var dgTagRating_RatingNotValid = "Cette \xe9valuation n’est plus valide.";
var dgTagRating_RatingNotValidNewRating = "Cette \xe9valuation est invalide car vous avez demand\xe9 une nouvelle \xe9valuation.";
var dgTagRating_RatingOtherTitleFormat = "Attribuer une {{ratingType}} \xe0 {{name}} pour \xab\xa0{{tagName}}\xa0\xbb";
var dgTagRating_RatingPendingFormat = "Demande en attente de {{manager}}";
var dgTagRating_RatingRequestCancelled = "La demande d’\xe9valuation a bien \xe9t\xe9 supprim\xe9e";
var dgTagRating_RatingRequested = "L’\xe9valuation que vous avez demand\xe9e est en attente.";
var dgTagRating_RatingRequestedAge = "{{ RequestedAge }} requis";
var dgTagRating_RatingsRequested = "Les \xe9valuations que vous avez demand\xe9es sont en attente.";
var dgTagRating_RatingTitleFormat = "\xc9valuez votre expertise concernant la comp\xe9tence \xab\xa0{{tagName}}\xa0\xbb";
var dgTagRating_RatingType = "Type d’\xe9valuation";
var dgTagRating_RecommendSkill = "Recommander cette comp\xe9tence";
var dgTagRating_RemoveA11y = "Supprimer la comp\xe9tence de votre profil";
var dgTagRating_RemoveA11ySkill = "Supprimer \xab\xa0{{skillName}}\xa0\xbb de votre profil";
var dgTagRating_RemoveFocusSkill = "Supprimer la comp\xe9tence prioritaire";
var dgTagRating_RemoveFocusSkillItem = "Remove {{title}} as focus skill";
var dgTagRating_RemoveFromPlan = "Supprimer du plan";
var dgTagRating_RemoveFromPlanA11y = "Supprimer la comp\xe9tence de ce plan";
var dgTagRating_RemoveFromProfile = "Supprimer du profil";
var dgTagRating_RemoveFromProfileConfirmation = "Souhaitez-vous vraiment supprimer la comp\xe9tence {{skill}} de votre profil\xa0?";
var dgTagRating_RemoveFromProfileTooltip = "Supprimer du profil";
var dgTagRating_RequestedRatings = "Les {{ RequestedCount }}\xa0\xe9valuations que vous avez demand\xe9es sont en attente.";
var dgTagRating_RequestManagerAssessment = "Demander une \xe9valuation au manager";
var dgTagRating_RequestManagerRating = "Demander \xe0 \xeatre \xe9valu\xe9 par votre responsable";
var dgTagRating_RequestManagerRatingInstruction = "Demandez \xe0 votre manager d’\xe9valuer votre comp\xe9tence.";
var dgTagRating_RequestNewRating = "Demander une nouvelle \xe9valuation";
var dgTagRating_RequestNotValid = "Cette demande d’\xe9valuation n’est plus valide.";
var dgTagRating_RequestPeerRating = "Demander une \xe9valuation par un pair";
var dgTagRating_RequestPeerRatingInstruction = "Demandez \xe0 quelqu’un de vous \xe9valuer.";
var dgTagRating_RequestRating = "Demander une \xe9valuation";
var dgTagRating_RequestSelfNotificationFormat = "{{name}} vous a demand\xe9 d’auto-\xe9valuer votre comp\xe9tence {{skill}}";
var dgTagRating_RequestSelfRatingForFormat = "Demander une auto-\xe9valuation pour {{skill}}";
var dgTagRating_RequestsPending = "Demandes en attente";
var dgTagRating_RestartEval = "Commencer une nouvelle revue de comp\xe9tence";
var dgTagRating_ReviewSkillsNewRatings = "Passez en revue les comp\xe9tences sur votre profil pour vous assurer que les nouvelles \xe9valuations sont exactes.";
var dgTagRating_saveNewRating = "Enregistrer la nouvelle \xe9valuation";
var dgTagRating_saveNewTarget = "Enregistrer la nouvelle cible";
var dgTagRating_SearchCollection = "Rechercher dans la collection";
var dgTagRating_SelectManager = "S\xe9lectionnez votre manager actuel";
var dgTagRating_SelectRating = "S\xe9lectionner une \xe9valuation pour la comp\xe9tence";
var dgTagRating_SelfAssessment = "Auto-\xe9valuation";
var dgTagRating_SelfAssessmentItem = "Self rating for {{title}}";
var dgTagRating_SelfRatingRequestCancelled = "La demande d’auto-\xe9valuation a bien \xe9t\xe9 supprim\xe9e.";
var dgTagRating_SelfRatingRequested = "Votre manager vous demande de vous auto-\xe9valuer pour cette comp\xe9tence.";
var dgTagRating_SelfRatingUpdated = "L’auto-\xe9valuation pour la comp\xe9tence {{skill}} a \xe9t\xe9 mise \xe0 jour.";
var dgTagRating_ShareTag = "Partager cette comp\xe9tence";
var dgTagRating_SignalCountPlural = "{{count}}\xa0\xe9valuations suppl\xe9mentaires";
var dgTagRating_SignalCountSingle = "{{count}}\xa0\xe9valuation suppl\xe9mentaire";
var dgTagRating_SkillCertification = "Certification de comp\xe9tence";
var dgTagRating_SkillCertInProgress = "Certification de comp\xe9tence en cours";
var dgTagRating_SkillReviewInProgress = "Revue de comp\xe9tence en cours";
var dgTagRating_StartCredential = "Obtenir la certification Degreed";
var dgTagRating_StartEvaluation = "Commencer une revue de comp\xe9tence";
var dgTagRating_SubmitNext = "Envoyer et suivant";
var dgTagRating_SuccessfullyAddedSkills = "Vous avez bien ajout\xe9 {{skillNumber}}\xa0nouvelles comp\xe9tences\xa0!";
var dgTagRating_SummaryLevel1 = "Peut effectuer, avec une supervision ou des conseils directs, des t\xe2ches restreintes et limit\xe9es exigeant des comp\xe9tences de base.";
var dgTagRating_SummaryLevel2 = "Peut effectuer, avec une supervision ou des conseils g\xe9n\xe9raux, des t\xe2ches techniques routini\xe8res exigeant des comp\xe9tences de base.";
var dgTagRating_SummaryLevel3 = "Peut traiter des t\xe2ches techniques moins structur\xe9es mais bien d\xe9finies, m\xeame si elles ne sont pas routini\xe8res, avec une supervision ou des conseils g\xe9n\xe9raux ponctuels.";
var dgTagRating_SummaryLevel4 = "Peut compl\xe9ter certaines t\xe2ches sp\xe9cialis\xe9es et complexes. Peut employer ses connaissances th\xe9oriques et son exp\xe9rience pratique pour choisir les principes et les processus. Poss\xe8de ou non une supervision g\xe9n\xe9rale. Aucun conseil direct n\xe9cessaire pour ces t\xe2ches.";
var dgTagRating_SummaryLevel5 = "Peut compl\xe9ter de nombreuses t\xe2ches vastes et complexes. Peut employer ses connaissances th\xe9oriques et son exp\xe9rience pratique pour choisir les principes et les processus des t\xe2ches techniques sans supervision ni conseils.";
var dgTagRating_SummaryLevel6 = "Expert capable de cr\xe9er des t\xe2ches vastes et complexes dans plusieurs sous-sp\xe9cialit\xe9s de la comp\xe9tence. Peut employer ses connaissances th\xe9oriques et son exp\xe9rience pratique dans toutes ces sous-sp\xe9cialit\xe9s.";
var dgTagRating_SummaryLevel7 = "Peut compl\xe9ter des t\xe2ches nouvelles et complexes, y compris en choisissant les meilleurs processus pour des situations particuli\xe8res. Peut utiliser des connaissances ou des processus sp\xe9cialis\xe9s avanc\xe9s.";
var dgTagRating_SummaryLevel8 = "Peut d\xe9velopper des solutions ou des recherches innovantes \xe0 l’aide de nombreuses strat\xe9gies scientifiques et cr\xe9atives.";
var dgTagRating_SummaryScale6_Level1 = "Vous poss\xe9dez certaines connaissances sur cette comp\xe9tence et commencez \xe0 apprendre les outils et les processus qui y sont associ\xe9s. Avec une supervision directe ou des directives, vous pouvez accomplir des t\xe2ches simples.";
var dgTagRating_SummaryScale6_Level2 = "Vous poss\xe9dez une connaissance concr\xe8te des principes et pratiques fondamentaux de cette comp\xe9tence, et vous ma\xeetrisez certains aspects techniques. Sous une supervision g\xe9n\xe9rale, vous pouvez accomplir une gamme de t\xe2ches simples en employant les m\xe9thodes correctes.";
var dgTagRating_SummaryScale6_Level3 = "Gr\xe2ce \xe0 vos connaissances techniques et th\xe9oriques de cette comp\xe9tence, et sous une supervision g\xe9n\xe9rale, vous pouvez travailler en toute autonomie sur des t\xe2ches d\xe9licates et apporter des solutions \xe0 des probl\xe8mes pr\xe9visibles et bien d\xe9finis.";
var dgTagRating_SummaryScale6_Level4 = "Vous poss\xe9dez des connaissances th\xe9oriques et techniques approfondies et certaines connaissances sp\xe9cialis\xe9es que vous mettez en œuvre pour r\xe9soudre des probl\xe8mes difficiles et r\xe9aliser des t\xe2ches complexes. Vous pouvez diriger une initiative jusqu’\xe0 sa conclusion.";
var dgTagRating_SummaryScale6_Level5 = "Vous ma\xeetrisez les connaissances, les th\xe9ories, les outils, les m\xe9thodologies et les processus de votre domaine de comp\xe9tence. Parce que vous avez pleinement int\xe9gr\xe9 ces th\xe9ories et ces pratiques, vous pouvez g\xe9rer des t\xe2ches et des probl\xe8mes sp\xe9cialis\xe9s ou complexes, les mener \xe0 bien et communiquer \xe0 leur sujet.";
var dgTagRating_SummaryScale6_Level6 = "Innovateur dans l’\xe2me, vous \xeates consid\xe9r\xe9 comme l’un des meilleurs au sein de votre secteur. L’ampleur et le degr\xe9 de sp\xe9cialisation de vos connaissances vous permettent d’analyser, de r\xe9soudre et de mener \xe0 bien des t\xe2ches et des probl\xe8mes in\xe9dits et complexes. Les solutions et les proc\xe9dures que vous proposez dans les situations d’une grande complexit\xe9 font de vous un leader de votre domaine. Vous n’avez pas seulement une vaste connaissance des comp\xe9tences connexes, vous anticipez \xe9galement les tendances majeures de l’avenir de votre secteur et leur impact sur les personnes, les outils, les technologies, les processus et le monde dans son ensemble.";
var dgTagRating_SummaryScale8_Level1 = "Vous poss\xe9dez des connaissances g\xe9n\xe9rales sur certains aspects de la comp\xe9tence. Vous d\xe9couvrez les outils qui lui sont associ\xe9s et apprenez \xe0 les utiliser pour r\xe9aliser des t\xe2ches simples de routine. C’est dans un environnement structur\xe9 et sous supervision, avec des processus pr\xe9d\xe9finis et des crit\xe8res \xe9tablis pour \xe9valuer votre travail, que vous donnez vos meilleurs r\xe9sultats.";
var dgTagRating_SummaryScale8_Level2 = "Vous avez acquis des connaissances fondamentales et pratiques dans votre comp\xe9tence. Vous savez qu’il vous reste encore de nombreuses informations \xe0 acqu\xe9rir, mais vous comprenez les bases. Vous \xeates capable de r\xe9soudre des probl\xe8mes simples et de r\xe9aliser des t\xe2ches de mani\xe8re autonome, mais vous aurez sans doute besoin d’aide si un probl\xe8me complexe se pr\xe9sente.";
var dgTagRating_SummaryScale8_Level3 = "Vous avez \xe9largi vos connaissances au-del\xe0 des fondamentaux et vous approfondissez maintenant la th\xe9orie de votre domaine de comp\xe9tence. Vous utilisez les outils du m\xe9tier avec aisance tout en continuant d’enrichir vos comp\xe9tences techniques. Capable de travailler en toute autonomie sur de nouveaux d\xe9fis, vous en savez assez pour faire preuve d’auto-critique et faire la diff\xe9rence entre un bon et un excellent travail. Vous savez \xe9galement fixer des objectifs et mesurer la progression accomplie.";
var dgTagRating_SummaryScale8_Level4 = "Vous \xeates un professionnel comp\xe9tent et vous utilisez un large \xe9ventail de m\xe9thodes pour r\xe9soudre les probl\xe8mes, de la planification \xe0 l’ex\xe9cution. Vous \xeates capable d’accomplir des t\xe2ches sp\xe9cialis\xe9es et de mettre vos comp\xe9tences au service de probl\xe8mes complexes pouvant exiger un processus in\xe9dit ou une nouvelle approche. Vous savez travailler sur des projets complexes en toute autonomie, et une fois ces projets accomplis, vous \xeates en mesure d’\xe9valuer votre propre travail pour d\xe9terminer s’il a ou non port\xe9 ses fruits.";
var dgTagRating_SummaryScale8_Level5 = "Vous poss\xe9dez des connaissances solides et sp\xe9cialis\xe9es dans votre domaine de comp\xe9tence. Vous avez maintenant plusieurs r\xe9ussites \xe0 votre actif et pouvez mettre un large \xe9ventail de comp\xe9tences cognitives et pratiques au service de probl\xe8mes nouveaux et complexes. Vous \xeates capable de diriger une initiative jusqu’\xe0 sa conclusion.";
var dgTagRating_SummaryScale8_Level6 = "Vous ma\xeetrisez le savoir, les connaissances th\xe9oriques, les outils, la m\xe9thodologie et les processus propres \xe0 votre domaine de comp\xe9tences. Vous \xeates non seulement capable d’utiliser ces connaissances pour r\xe9soudre n’importe quel probl\xe8me, quelles que soient son envergure et sa complexit\xe9, mais \xe9galement de communiquer clairement les concepts \xe0 autrui.";
var dgTagRating_SummaryScale8_Level7 = "Innovateur dans l’\xe2me, votre travail n’a pas d’\xe9gal dans votre domaine. Vous utilisez les outils \xe0 votre disposition de fa\xe7on si complexe et exp\xe9rimentale que tous sollicitent vos conseils et vos bonnes pratiques. Vous disposez certainement aussi d’une expertise dans un ou plusieurs autres domaines de pointe ou hautement sp\xe9cialis\xe9s.";
var dgTagRating_SummaryScale8_Level8 = "Votre connaissance et votre vision unique du domaine sont ardemment sollicit\xe9es. Vous anticipez les tendances majeures de l’avenir de votre secteur et leur impact sur les personnes, les outils, les technologies, les processus et le monde dans son ensemble. Reconnu comme un leader international dans votre domaine, vous \xe9laborez de nouvelles normes et pratiques, et votre capacit\xe9 d’innovation d\xe9passe celle de la majorit\xe9 de vos homologues.";
var dgTagRating_TakeCheckpoint = "R\xe9aliser un point de contr\xf4le";
var dgTagRating_TargetCommentPlaceholderFormat = "Donnez \xe0 {{name}} plus d’informations sur cette cible...";
var dgTagRating_TargetLevel = "Niveau cible";
var dgTagRating_TargetRatingUpdated = "La cible de la comp\xe9tence {{skill}} a \xe9t\xe9 mise \xe0 jour.";
var dgTagRating_TasksTools = "T\xe2ches et outils";
var dgTagRating_TasksTools_Desc_Scale6_1 = "Pour votre comp\xe9tence, vous apprenez \xe0 utiliser les outils et les m\xe9thodes propres \xe0 votre secteur pour remplir des t\xe2ches simples et routini\xe8res.";
var dgTagRating_TasksTools_Desc_Scale6_2 = "Vous \xeates de plus en plus \xe0 l’aise avec les outils et m\xe9thodes propres \xe0 votre secteur et vous savez les utiliser pour r\xe9aliser des t\xe2ches moins structur\xe9es. Vous commencez \xe9galement \xe0 savoir \xe9valuer la qualit\xe9 de votre travail.";
var dgTagRating_TasksTools_Desc_Scale6_3 = "Vous travaillez mieux avec des t\xe2ches moins structur\xe9es et vous utilisez toute une palette de m\xe9thodes pour r\xe9soudre les probl\xe8mes, de la planification \xe0 l’ex\xe9cution. Vous \xeates \xe0 l’aise avec les outils m\xe9tier, notamment les plus sp\xe9cialis\xe9s, et continuez \xe0 d\xe9velopper vos comp\xe9tences techniques.";
var dgTagRating_TasksTools_Desc_Scale6_4 = "Vous \xeates un praticien qualifi\xe9 avec une exp\xe9rience av\xe9r\xe9e de r\xe9ussite\xa0; vous tirez parti d’un large \xe9ventail de comp\xe9tences cognitives ou pratiques pour r\xe9soudre des probl\xe8mes complexes. Vous \xeates capable de planifier des processus et n’avez aucun mal \xe0 identifier les outils que vous utiliserez.";
var dgTagRating_TasksTools_Desc_Scale6_5 = "Vous utilisez un \xe9ventail complet d’outils, de m\xe9thodes et de processus pour accomplir des t\xe2ches nouvelles et complexes. Vous favorisez l’utilisation de nouvelles technologies et \xeates en mesure d’\xe9valuer leur efficacit\xe9.";
var dgTagRating_TasksTools_Desc_Scale6_6 = "Vous ma\xeetrisez vos comp\xe9tences\xa0; vous utilisez des outils de mani\xe8re complexe et exp\xe9rimentale, de sorte que les autres prennent vos bonnes pratiques pour exemple. Vous n’h\xe9sitez pas \xe0 effectuer des recherches pour d\xe9velopper et publier de nouveaux outils, processus et technologies \xe0 utiliser dans votre domaine. Les nouvelles normes et pratiques que vous d\xe9veloppez vous vaut la reconnaissance de vos pairs et un statut de leader du secteur.";
var dgTagRating_TasksTools_Desc_Scale8_1 = "Vous apprenez \xe0 utiliser les outils li\xe9s \xe0 la comp\xe9tence pour accomplir des t\xe2ches simples et routini\xe8res.";
var dgTagRating_TasksTools_Desc_Scale8_2 = "Vous \xeates de plus en plus \xe0 l’aise avec les outils et processus propres \xe0 votre secteur et vous savez les utiliser pour r\xe9aliser des t\xe2ches routini\xe8res. Vous commencez \xe9galement \xe0 savoir \xe9valuer la qualit\xe9 de votre travail sans faire r\xe9f\xe9rence aux crit\xe8res d\xe9finis.";
var dgTagRating_TasksTools_Desc_Scale8_3 = "Accomplir des t\xe2ches peu structur\xe9es ne vous fait plus peur et vous \xeates en mesure de r\xe9soudre des probl\xe8mes complexes en vous basant sur vos connaissances th\xe9oriques. Les outils \xe0 votre disposition n’ont pratiquement plus de secrets pour vous et vous continuez \xe0 d\xe9velopper vos comp\xe9tences techniques.";
var dgTagRating_TasksTools_Desc_Scale8_4 = "En tant que praticien chevronn\xe9, vous utilisez un large \xe9ventail de m\xe9thodes pour r\xe9soudre les probl\xe8mes auxquels vous vous heurtez \xe0 chaque \xe9tape de votre projet. Vous \xeates capable de mener \xe0 bien des t\xe2ches plus sp\xe9cialis\xe9es et de mettre vos comp\xe9tences \xe0 profit de probl\xe8mes complexes qui ne peuvent \xeatre r\xe9solus qu’\xe0 l’aide de nouveaux processus ou de nouvelles approches.";
var dgTagRating_TasksTools_Desc_Scale8_5 = "Votre efficacit\xe9 n’est plus \xe0 prouver et vous faites montre d’une grande vari\xe9t\xe9 d’aptitudes cognitives et de comp\xe9tences pratiques gr\xe2ce auxquelles vous \xeates en mesure de r\xe9soudre tous types de probl\xe8mes. Vous savez planifier vos m\xe9thodes de travail et identifier les outils dont vous aurez besoin avant d’\xe9valuer leur efficacit\xe9. Vous \xeates \xe9galement capable d’envisager des solutions alternatives et d’entrevoir leurs r\xe9sultats potentiels.";
var dgTagRating_TasksTools_Desc_Scale8_6 = "Vous utilisez un \xe9ventail complet d’outils, de m\xe9thodes et de processus pour accomplir les t\xe2ches les plus complexes. Vous favorisez l’utilisation de nouvelles technologies et \xeates en mesure d’\xe9valuer leur efficacit\xe9.";
var dgTagRating_TasksTools_Desc_Scale8_7 = "Innovateur dans l’\xe2me, votre travail n’a pas d’\xe9gal dans votre domaine, \xe0 tel point que c’est vous qui en dictez les tendances. Vous utilisez les outils \xe0 votre disposition de fa\xe7on si complexe et exp\xe9rimentale que tous sollicitent vos conseils. Vous disposez certainement aussi d’une expertise dans un ou plusieurs autres domaines de pointe ou hautement sp\xe9cialis\xe9s.";
var dgTagRating_TasksTools_Desc_Scale8_8 = "Les experts r\xe9volutionnent leur secteur. Vous ma\xeetrisez vos comp\xe9tences sur le bout des doigts et \xeates \xe0 l’origine des outils que vos pairs utilisent au quotidien. Vos recherches vous permettent de d\xe9velopper et proposer de nouveaux outils, processus et technologies aux professionnels de votre domaine. Vous avez mis votre exp\xe9rience au profit de l’innovation et avez ainsi con\xe7u des outils plus efficaces ou pr\xe9sent\xe9 de nouvelles th\xe9ories. Votre statut de leader du secteur est reconnu dans le monde entier et vous œuvrez certainement au d\xe9veloppement de nouvelles normes et pratiques. Votre capacit\xe9 \xe0 innover est sup\xe9rieure \xe0 celle de la plupart de vos pairs.";
var dgTagRating_TotalRatings = "\xc9valuations totales";
var dgTagRating_Unrated = "Non class\xe9";
var dgTagRating_UnratedDescription = "\xc9valuez vous-m\xeame cette comp\xe9tence pour suivre votre progression, identifier d’\xe9ventuels d\xe9ficits de comp\xe9tences ou des aptitudes, et am\xe9liorer les recommandations dans l’application.";
var dgTagRating_UnratedPeerRatingDescription = "\xc9valuez {{ name }} dans cette comp\xe9tence pour suivre sa progression, identifier d’\xe9ventuels d\xe9ficits de comp\xe9tences ou des aptitudes, et am\xe9liorer les recommandations dans l’application.";
var dgTagRating_UnratedSkillTargetDescription = "D\xe9finissez une cible pour cette comp\xe9tence afin d’en suivre la progression, d’identifier les d\xe9ficits de comp\xe9tences et les aptitudes, et d’am\xe9liorer les recommandations dans l’application.";
var dgTagRating_UpdatedManagerRating = "L’\xe9valuation par le manager a \xe9t\xe9 mise \xe0 jour";
var dgTagRating_UpdatedNewRating = "La nouvelle \xe9valuation a \xe9t\xe9 enregistr\xe9e";
var dgTagRating_UpdatedPeerRating = "L’\xe9valuation par un pair a \xe9t\xe9 mise \xe0 jour";
var dgTagRating_UpdatedSkillTarget = "La cible de la comp\xe9tence a \xe9t\xe9 mise \xe0 jour";
var dgTagRating_UpdateRating = "Mettre \xe0 jour l’\xe9valuation";
var dgTagRating_ViewCertificate = "Afficher le certificat";
var dgTagRating_ViewCheckpoints = "Afficher les points de contr\xf4le";
var dgTagRating_ViewExternalRating = "Afficher sur {{ProviderName}}";
var dgTagRating_ViewLevelBreakdown = "Afficher la r\xe9partition des niveaux";
var dgTagRating_ViewLevelDescription = "Afficher la description du niveau";
var dgTagRating_ViewNewRatingScale = "Afficher la nouvelle \xe9chelle d’\xe9valuation";
var dgTagRating_ViewRating = "Voir la note";
var dgTagRating_ViewRatingLabel = "{{skillTitle}} Afficher l’\xe9valuation";
var dgTagRating_ViewRatings = "Afficher {{RatingCount}} \xe9valuations";
var dgTagRating_ViewRatingScale = "Afficher l’\xe9chelle d’\xe9valuation";
var dgTagRating_ViewScoreBreakdown = "Afficher la r\xe9partition des scores";
var dgTagRating_ViewSkill = "Voir la comp\xe9tence";
var dgTagRating_VisibleToOrg = "Visible par l’organisation";
var dgTagRating_VisibleToPublic = "Visible par tout le monde";
var dgTagRating_VisibleToYou = "Visible uniquement par vous-m\xeame";
var dgTagRating_YourCurrentRating = "\xc9valuation actuelle";
var dgTagsEdit_AddTagFormat = "Ajouter {{tag}}";
var dgTagsEdit_PlusAdd = "+ Ajouter";
var dgTagsEdit_RemoveTagFormat = "Supprimer {{tag}}";
var dgTagsEdit_View_More_Button = "Afficher plus";
var dgTagsEdit_WhatDidYouLearn = "Comp\xe9tences";
var dgTagsEdit_WhoopsFormat = "Oups! {{errorMessage}}";
var dgTagsList_PlusCountMore = "+{{count}} plus";
var dgTagsList_RemoveWorkdaySkillInfo = "Si la comp\xe9tence \xab\xa0{{skillName}}\xa0\xbb figure dans votre profil Workday et que vous la supprimez ici, elle dispara\xeetra de votre profil Workday.";
var dgTagsList_RemoveWorkdaySkillTitle = "Supprimer la comp\xe9tence dans Workday";
var dgTagsList_VisitWorkday = "Ouvrir Workday";
var dgTargetTile_PrimaryPlan = "Plan principal";
var dgTargetTile_SkillFormat = "{{targetTagCount}} comp\xe9tence";
var dgTargetTile_SkillsFormat = "{{targetTagCount}} comp\xe9tences";
var dgTargetTile_UnfollowConfirm = "Voulez-vous vraiment arr\xeater de suivre ce {{targetType}} \xa0?";
var dgTargetTile_UnfollowExplanation = "Le contenu de ce {{targetType}} n’appara\xeetra plus dans votre flux.";
var dgThSort_SortAscendingFormat = "Trier {{columnName}} par ordre croissant";
var dgThSort_SortDescendingFormat = "Trier {{columnName}} par ordre d\xe9croissant";
var dgThSort_SortedAscendingFormat = "Tri\xe9 par {{columnName}} en ordre croissant";
var dgThSort_SortedDescendingFormat = "Tri\xe9 par {{columnName}} en ordre d\xe9croissant";
var dgThumbs_Dislike = "Je n’aime pas";
var dgThumbs_Like = "J’aime";
var dgThumbs_NotDisliked = "Not disliked";
var dgThumbs_RemoveDislike = "Supprimer la mention je n’aime pas";
var dgThumbs_RemoveLike = "Supprimer la mention j’aime";
var dgThumbs_Undislike = "Retirer la mention Je n’aime pas";
var dgTopGroups_AdministrativeGroup = "Groupe administratif";
var dgTopGroups_ClosedGroup = "Groupe ferm\xe9";
var dgTopGroups_Empty = "Aucun groupe le plus actif";
var dgTopGroups_LinkToGroups = "Tous les groupes";
var dgTopGroups_PrivateGroup = "Groupe priv\xe9";
var dgTrackableLink_Trackable = "Lien tra\xe7able";
var dgUserDeleteProfile_DeletedProfileConfirmed = "Votre compte est en cours de suppression. Nous sommes tristes de vous voir partir.<br>Vous serez redirig\xe9 sous peu.";
var dgUserDeleteProfile_DeleteProfileConfirmation = "Souhaitez-vous r\xe9ellement supprimer votre profil Degreed ?";
var dgUserDeleteProfile_No = "Non";
var dgUserDeleteProfile_Yes = "Oui";
var dgUserEvaluationEndorsement_approved = "A approuv\xe9 votre revue de comp\xe9tence {{tagName}}";
var dgUserEvaluationEndorsement_complete_endorsementRequested = "{{personNameHtml}} vous a demand\xe9 d’approuver sa revue de comp\xe9tence {{skillNameHtml}}, et vous l’avez d\xe9j\xe0 fait. Merci\xa0!";
var dgUserEvaluationEndorsement_endorsementCompleted = "{{personNameHtml}} a approuv\xe9 votre revue de la comp\xe9tence {{skillNameHtml}}";
var dgUserEvaluationEndorsement_endorsementRequested = "{{personNameHtml}} vous a demand\xe9 d’approuver sa revue de comp\xe9tence {{skillNameHtml}}";
var dgUserEvaluationEndorsement_endorsementRequestedChanges = "{{personNameHtml}} a demand\xe9 des modifications pour votre revue de comp\xe9tence {{skillNameHtml}}";
var dgUserEvaluationEndorsement_endosed = "A approuv\xe9 votre revue de la comp\xe9tence {{tagName}}";
var dgUserEvaluationEndorsement_goToApplication = "Acc\xe9der \xe0 la demande";
var dgUserEvaluationEndorsement_requestedChanges = "a demand\xe9 des modifications pour votre revue de comp\xe9tence {{tagName}}";
var dgUserGoalItem_ViewGroup = "Afficher le groupe";
var dgUserInfo_LinkCopied = "Le lien a \xe9t\xe9 copi\xe9.";
var dgUserOrganizationPicker_Everyone = "Tout le monde (public)";
var dgUserOrganizationPicker_Loading = "chargement...";
var dgUserOrganizationPicker_OnlyMe = "Moi uniquement (personnel)";
var dgUserOutcomeEditForm_AccomplishmentDate = "J’ai obtenu cet accomplissement \xe0 une date pr\xe9cise";
var dgUserOutcomeEditForm_AchievedDate = "Obtenu le";
var dgUserOutcomeEditForm_ActiveCert = "Quelle est la p\xe9riode de validit\xe9 du certificat \xa0?";
var dgUserOutcomeEditForm_AddAccomplishment = "Ajouter un accomplissement";
var dgUserOutcomeEditForm_AddADegree = "Ajouter un dipl\xf4me";
var dgUserOutcomeEditForm_AddAward = "Ajouter une r\xe9compense";
var dgUserOutcomeEditForm_AddBadge = "Ajouter un insigne";
var dgUserOutcomeEditForm_AddBadgeUrl = "Ajouter l’URL \xe0 partir d’un badge ouvert";
var dgUserOutcomeEditForm_AddCertificate = "Ajouter un certificat";
var dgUserOutcomeEditForm_AddDegree = "Ajouter un dipl\xf4me";
var dgUserOutcomeEditForm_AdditionalSkillInfo = "Ajoutez des informations suppl\xe9mentaires utiles lors de l’\xe9valuation de cette comp\xe9tence.";
var dgUserOutcomeEditForm_AddSkill = "Ajouter une comp\xe9tence";
var dgUserOutcomeEditForm_AwardedDate = "Obtenu le";
var dgUserOutcomeEditForm_BadgeIssuer = "\xc9metteur";
var dgUserOutcomeEditForm_BadgeName = "Nom du badge";
var dgUserOutcomeEditForm_BadgeProvider = "Prestataire du badge";
var dgUserOutcomeEditForm_BadgeUrlJson = "URL du badge (se terminant par .json)";
var dgUserOutcomeEditForm_CategoryAwardsDescription = "Conseil\xa0: saisissez le nom d’une comp\xe9tence, puis choisissez une option dans la liste ou utilisez la touche Entr\xe9e.";
var dgUserOutcomeEditForm_CategoryDescription = "Conseil\xa0: saisissez le nom d’une comp\xe9tence, puis choisissez une option dans la liste ou utilisez la touche Entr\xe9e.";
var dgUserOutcomeEditForm_CertificateGrouping = "Conseil\xa0: saisissez le nom d’une comp\xe9tence, puis choisissez une option dans la liste ou utilisez la touche Entr\xe9e.";
var dgUserOutcomeEditForm_CertNumber = "Saisissez le num\xe9ro du certificat, le cas \xe9ch\xe9ant.";
var dgUserOutcomeEditForm_CollegeUniversity = "Universit\xe9 ou facult\xe9";
var dgUserOutcomeEditForm_ConceptualizeSkillFormat = "Exemple\xa0: Je peux imaginer une gamme de produits et mettre en place un calendrier pour le d\xe9veloppement et le lancement des principales fonctionnalit\xe9s.";
var dgUserOutcomeEditForm_Country = "Pays";
var dgUserOutcomeEditForm_DateCompleted = "Date d’ex\xe9cution";
var dgUserOutcomeEditForm_DateGraduated = "Date d’obtention du dipl\xf4me";
var dgUserOutcomeEditForm_DegreeGrouping = "Conseil\xa0: saisissez le nom d’une comp\xe9tence, puis choisissez une option dans la liste ou utilisez la touche Entr\xe9e.";
var dgUserOutcomeEditForm_DegreeLevel = "Niveau du dipl\xf4me";
var dgUserOutcomeEditForm_DegreeLevelExample = "P. ex.\xa0: licence";
var dgUserOutcomeEditForm_DegreeTitleExample = "Par exemple\xa0: Licence en sciences";
var dgUserOutcomeEditForm_DescribeAccomplishment = "D\xe9crivez votre accomplissement";
var dgUserOutcomeEditForm_DescribeSkill = "D\xe9crivez votre comp\xe9tence";
var dgUserOutcomeEditForm_DescribeUseOfSkill = "D\xe9crivez la proc\xe9dure employ\xe9e pour utiliser cette comp\xe9tence";
var dgUserOutcomeEditForm_DescribeWhyUseOfSkill = "Pourquoi utilisez-vous la proc\xe9dure indiqu\xe9e ?";
var dgUserOutcomeEditForm_DoesCertExpire = "Ce certificat n’expire pas";
var dgUserOutcomeEditForm_EditAccomplishment = "Modifier l’accomplissement";
var dgUserOutcomeEditForm_EditAward = "Modifier la r\xe9compense";
var dgUserOutcomeEditForm_EditBadge = "Modifier le badge";
var dgUserOutcomeEditForm_EditCertificate = "Modifier le certificat";
var dgUserOutcomeEditForm_EditDegree = "Modifier le dipl\xf4me";
var dgUserOutcomeEditForm_EndDate = "Date de fin";
var dgUserOutcomeEditForm_ExpandedClientBase = "Exemple\xa0: \xab\xa0Client\xe8le en hausse de 78\xa0% sur trois ans.\xa0\xbb";
var dgUserOutcomeEditForm_Expiration = "Expiration";
var dgUserOutcomeEditForm_FieldOfStudy = "Domaine d’\xe9tude";
var dgUserOutcomeEditForm_FormatDescription = "Description du format du type : \xab\xa0Je peux...\xa0\xbb";
var dgUserOutcomeEditForm_GPA = "Note moyenne";
var dgUserOutcomeEditForm_GPAExample = "Par ex.\xa0: 4.0, 3.1";
var dgUserOutcomeEditForm_HeldSkill = "Depuis combien de temps poss\xe9dez-vous cette comp\xe9tence ?";
var dgUserOutcomeEditForm_IncludeTypicalCourses = "Ajouter aussi les cours g\xe9n\xe9ralement li\xe9s \xe0 ce dipl\xf4me dans mon profil";
var dgUserOutcomeEditForm_IssuedBy = "Remis(e) par";
var dgUserOutcomeEditForm_IssuerUrl = "URL de l’\xe9metteur";
var dgUserOutcomeEditForm_MozillaBadge = "Les badges ouverts Mozilla permettent aux organisations d’\xe9mettre, g\xe9rer et afficher des badges num\xe9riques. Leur but est d’aider les apprenants \xe0 faire valoir les comp\xe9tences et les accomplissements obtenus en ligne ou hors du syst\xe8me scolaire.";
var dgUserOutcomeEditForm_OpenBadgeLabelFormat = "En savoir plus sur le {{startAnchor}}projet Open Badges de Mozilla{{endAnchor}}.";
var dgUserOutcomeEditForm_OrganizedCharity = "Exemple\xa0: \xab\xa0Organisation d’un \xe9v\xe9nement caritatif avec 200\xa0b\xe9n\xe9voles ayant recueilli plus de 100\xa0000\xa0$.\xa0\xbb";
var dgUserOutcomeEditForm_OutsideUS = "Ce dipl\xf4me a \xe9t\xe9 obtenu hors des \xc9tats-Unis";
var dgUserOutcomeEditForm_QuantitativeDescriptions = "Les descriptions quantitatives sont les plus efficaces.";
var dgUserOutcomeEditForm_RateProficiency = "\xc9valuez votre niveau de comp\xe9tence";
var dgUserOutcomeEditForm_SaveBadge = "Enregistrer l’insigne";
var dgUserOutcomeEditForm_SaveDegree = "Enregistrer le dipl\xf4me";
var dgUserOutcomeEditForm_SaveToProfile = "Enregistrer dans le profil";
var dgUserOutcomeEditForm_SelectCategories = "Comp\xe9tences";
var dgUserOutcomeEditForm_SelectField = "S\xe9lectionnez un domaine correspondant pr\xe9cis\xe9ment au v\xf4tre";
var dgUserOutcomeEditForm_SkilGrouping = "Conseil\xa0: saisissez le nom d’une comp\xe9tence, puis choisissez une option dans la liste ou utilisez la touche Entr\xe9e.";
var dgUserOutcomeEditForm_SkillCandidateAbbrFormat = "{{startAbbr}}ex.{{endAbbr}} Je peux \xe9mettre des candidats et analyser avec pr\xe9cision leurs comp\xe9tences et \xeatre adapt\xe9 \xe0 un poste sp\xe9cifique.";
var dgUserOutcomeEditForm_SkillEvidence = "Ajoutez des liens vers des documents ou des sources prouvant votre expertise.";
var dgUserOutcomeEditForm_SkillEvidenceAbbrFormat = "{{startAbbr}}ex.{{endAbbr}} Articles publi\xe9s, interviews, podcasts, pr\xe9sentations, etc.";
var dgUserOutcomeEditForm_SkillGrouping = "Conseil\xa0: saisissez le nom d’une comp\xe9tence, puis choisissez une option dans la liste ou utilisez la touche Entr\xe9e.";
var dgUserOutcomeEditForm_SkillHistory = "Vous avez la possibilit\xe9 de pr\xe9ciser les ressources d’apprentissage, les personnes, les exp\xe9riences pass\xe9es ou les d\xe9fis ayant influenc\xe9 le processus.";
var dgUserOutcomeEditForm_SkillInstance = "D\xe9crivez un exemple de situation lors de laquelle vous avez employ\xe9 cette comp\xe9tence";
var dgUserOutcomeEditForm_SkillUse = "D\xe9crivez bri\xe8vement la fr\xe9quence \xe0 laquelle vous employez cette comp\xe9tence";
var dgUserOutcomeEditForm_SkillUseDetail = "Indiquez des d\xe9tails tels que les d\xe9marches entreprises, les difficult\xe9s rencontr\xe9es, le raisonnement employ\xe9 et les r\xe9sultats obtenus.";
var dgUserOutcomeEditForm_SkillUseDetails = "Indiquez des d\xe9tails tels que les d\xe9marches entreprises, les difficult\xe9s rencontr\xe9es, le raisonnement employ\xe9 et les r\xe9sultats obtenus.";
var dgUserOutcomeEditForm_StartDate = "Date de d\xe9but";
var dgUserOutcomeEditForm_TitleOfAward = "Intitul\xe9 de la r\xe9compense";
var dgUserOutcomeEditForm_TitleOfCertificate = "Intitul\xe9 du certificat";
var dgUserOutcomeEditForm_TitleOfDegree = "Intitul\xe9 du dipl\xf4me";
var dgUserOutcomeEditForm_UniversityCountry = "Pays de l’universit\xe9";
var dgUserOutcomeEditForm_UniversityName = "Nom de l’universit\xe9";
var dgUserOutcomeEditForm_UploadAnImage = "Charger une image";
var dgUserOutcomeEditForm_UploadBadge = "Charger un insigne";
var dgUserOutcomeEditForm_UploadDegreeImage = "Charger une image de votre dipl\xf4me";
var dgUserOutcomeEditForm_UploadImageOfCertificate = "Charger une image de votre certificat";
var dgUserOutcomeEditForm_WhatDidYouDo = "Que vous a-t-il \xe9t\xe9 demand\xe9 pour obtenir la r\xe9compense ?";
var dgUserOutcomeEditForm_WhatTimeSpan = "Sur quelle p\xe9riode cet accomplissement porte-t-il \xa0?";
var dgUserOutcomeEditForm_WhenDidYouReceiveAward = "Quand avez-vous obtenu cette r\xe9compense \xa0?";
var dgUserOutcomeItem_AdditionalInfo = "Informations suppl\xe9mentaires";
var dgUserOutcomeItem_AwardIssuer = "L’\xe9metteur de la r\xe9compense";
var dgUserOutcomeItem_ContentTypeOverview = "Vue d’ensemble {{contentType}}";
var dgUserOutcomeItem_DidntSpecify = "Le candidat n’a pas sp\xe9cifi\xe9 cette information.";
var dgUserOutcomeItem_EarningCertificate = "Activit\xe9 du candidat li\xe9e \xe0 l’obtention de ce certificat";
var dgUserOutcomeItem_HowEarned = "Mode d’octroi de la r\xe9compense";
var dgUserOutcomeItem_HowWasAchieved = "Mode d’obtention de l’accomplissement";
var dgUserOutcomeItem_SelectivityAward = "La s\xe9lectivit\xe9 de cette r\xe9compense";
var dgUserOutcomeItem_SelectivityCertificate = "La s\xe9lectivit\xe9 de ce certificat";
var dgUserOutcomeItem_SkillCandidate = "Le processus employ\xe9 par le candidat pour utiliser cette comp\xe9tence";
var dgUserOutcomeItem_WhenWasApplied = "Exemple de situation lors de laquelle la comp\xe9tence a \xe9t\xe9 employ\xe9e";
var dgUserOutcomeItem_WhoElseContributed = "Autres personnes ou organisations ayant contribu\xe9 \xe0 cet accomplissement";
var dgUserOutcomeItem_WhyUseCandidate = "Raison pour laquelle le candidat a employ\xe9 le processus pr\xe9c\xe9demment mentionn\xe9";
var dgUserOverview_Channel = "Outils des administrateurs";
var dgUserOverview_ConnectFlexedCard = "Associer votre carte FlexED";
var dgUserOverview_FlexEd = "FlexED";
var dgUserOverview_Logout = "Se d\xe9connecter";
var dgUserOverview_Points = "{{newPoints}} points";
var dgUserOverview_Profile = "Votre profil";
var dgUserOverview_Settings = "Param\xe8tres du profil";
var dgUserOverview_SkillCertification = "Certification de comp\xe9tence";
var dgUserOverview_SkillReview = "Revue de comp\xe9tence";
var dgUserOverview_SwitchOrganization = "Changer d’organisation";
var dgUserProfile_BecomeMentorSearchTitle = "Comp\xe9tences que vous souhaiteriez transmettre en tant que mentor";
var dgUserProfile_BecomeMentorSelectTitle = "Recevez des demandes de mentorat provenant de votre organisation.";
var dgUserProfile_BecomeMentorTitle = "Devenir mentor";
var dgUserProfile_IntegrationAssigned = "{{integrationName}} vous a attribu\xe9 ce poste.";
var dgUserProfile_OppTypesInterestedTitle = "Je souhaite voir les opportunit\xe9s sur la page d’accueil Degreed";
var dgUserProfile_OppTypesSelectTitle = "S\xe9lectionnez les types que vous souhaitez voir sur la page d’accueil Degreed.";
var dgUserProfile_OppTypesTitle = "Types d’opportunit\xe9s";
var dgUserProfile_OptInLabel = "Inscription";
var dgUserProfile_PersonalInformationLabel = "Informations personnelles";
var dgUserProfile_PictureLabel = "Photo";
var dgUserProfile_PrivacyLockedMessage = "Certains param\xe8tres de votre profil sont g\xe9r\xe9s par {{OrgName}}";
var dgUserProfile_PrivacyVisibilityLabel = "Visibilit\xe9";
var dgUserProfile_SkillCoachLabel = "Skill Coach";
var dgUserProfile_TeamProgramDesc = "Rejoignez Skill\xa0Coach pour permettre \xe0 votre manager de vous aider \xe0 d\xe9velopper vos comp\xe9tences.";
var dgUserProfile_TeamProgramDescSkillInventory = "Rejoignez Skill Coach pour permettre \xe0 votre manager de vous aider \xe0 d\xe9velopper vos comp\xe9tences.";
var dgUserProfile_TeamProgramJoinDesc = "Lorsque vous acceptez de rejoindre Skill\xa0Coach, votre manager peut consulter vos donn\xe9es de comp\xe9tences pour vous soutenir dans votre d\xe9veloppement.";
var dgUserProfile_TeamProgramJoinHeader = "S’abonner";
var dgUserProfile_TeamProgramLabel = "Skill Coach";
var dgUserProfile_TeamProgramLeaveDesc = "Avec Skill\xa0Coach, votre manager peut consulter vos donn\xe9es de comp\xe9tences pour vous soutenir dans votre d\xe9veloppement. Pour emp\xeacher votre manager de consulter ces donn\xe9es, s\xe9lectionnez Se d\xe9sinscrire.";
var dgUserProfile_TeamProgramLeaveHeader = "Se d\xe9sabonner";
var dgUserProfilePrivacy_ProfileSettingDescriptionFormat = "Ce param\xe8tre affecte la visibilit\xe9 de vos activit\xe9s d’apprentissage et si votre profil peut \xeatre d\xe9couvert ou non par d’autres apprenants {{orgName}}.";
var dgUserProfilePrivacy_VisibleToMeOnly = "Visible uniquement par moi";
var dgUserProfilePrivacy_VisibleToMeOnlyDesc = "Vous seul(e) pouvez consulter votre profil et vos activit\xe9s de formation.";
var dgUserProfilePrivacy_VisibleToMeOnlyLabel = "Priv\xe9";
var dgUserProfilePrivacy_VisibleToOrgDesc = "Seules les personnes de votre organisation disposant d’un compte Degreed peuvent consulter votre profil et vos activit\xe9s de formation.";
var dgUserProfilePrivacy_VisibleToOrgLabel = "Organisation";
var dgUserProfilePrivacy_VisibleToOrgOnly = "Visible uniquement par mon organisation";
var dgUserProfilePrivacy_VisibleToPublic = "Visible publiquement";
var dgUserProfilePrivacy_VisibleToPublicDesc = "Tout le monde peut consulter votre profil et vos activit\xe9s de formation.";
var dgUserProfilePrivacy_VisibleToPublicInOrg = "Visible publiquement et par mon organisation";
var dgUserProfilePrivacy_VisibleToPublicLabel = "Public";
var dgUsersSearch_Follow = "Suivre";
var dgUsersSearch_FollowUserFormat = "Suivre les activit\xe9s d’apprentissage de {{username}}";
var dgUsersSearch_NoResults = "Aucune personne ne correspond aux termes de la recherche.";
var dgUsersSearch_SearchDescription = "Degreed vous permet de conna\xeetre les derniers domaines \xe9tudi\xe9s ou d\xe9couverts par les autres personnes.";
var dgUsersSearch_SearchLabel = "Rechercher des personnes";
var dgUsersSearch_SearchPlaceholder = "Rechercher des personnes \xe0 suivre par cat\xe9gorie. Vous pouvez \xe9galement rechercher leur nom entre guillemets, par exemple \xab\xa0Jane Doe\xa0\xbb";
var dgUsersSearch_SearchTitle = "Communiquez avec d’autres personnes";
var dgUsersSearch_UnFollow = "Abonn\xe9";
var dgUsersSearch_UnfollowUserFormat = "Arr\xeater de suivre les activit\xe9s d’apprentissage de {{username}}";
var dgUserTile_Follow = "Suivre";
var dgUserTile_Following = "Abonn\xe9";
var dgUserTile_Unfollow = "Se d\xe9sabonner";
var dgUtilityBar_AddToProfileInProgress = "D\xe9sol\xe9\xa0! Vous ne pouvez pas ajouter de contenu ici pour l’instant. Acc\xe9dez \xe0 votre profil ou \xe0 la page d’accueil et r\xe9essayez.";
var dgUtilityBar_AddToProfileTitle = "Ajouter au profil";
var dgUtilityBar_FindSomethingToLearnPlaceholder = "Recherchez un th\xe8me d’apprentissage";
var dgUtilityBar_FlexEdFormat = "FlexED ({{available}})";
var dgUtilityBar_InProgress = "En cours";
var dgUtilityBar_ManageOrg = "G\xe9rer {{orgName}}";
var dgUtilityBar_MasteryPointsFormat = "{{masteryPoints}}\xa0point(s)";
var dgUtilityBar_PersonalInformationTitle = "Informations personnelles";
var dgUtilityBar_SearchLabel = "D\xe9velopper la recherche";
var dgUtilityBar_SelectAnotherSkill = "Choisissez une autre comp\xe9tence";
var dgUtilityBar_SelectASkill = "Choisissez une comp\xe9tence";
var dgValidatedField_WhoopsMessageFormat = "Oups! {{message}}";
var dgVBarChart_A11yTipFormat = "{{count}} {{inputType}}, {{totalPoints}} au total en {{monthName}}";
var dgVBarChart_A11yTipFormatRange = "{{count}} {{inputType}}, {{totalPoints}} au total de {{startDate}} \xe0 {{endDate}}";
var dgVBarChart_ChartFilterA11y = "La s\xe9lection d’une entr\xe9e met \xe0 jour le graphique";
var dgVBarChart_ContentItems = "\xc9l\xe9ments de contenu";
var dgVBarChart_Date = "Date";
var dgVBarChart_DisplayTypeLabel = "Afficher";
var dgVBarChart_DisplayTypePlaceholder = "S\xe9lectionnez le type de donn\xe9es";
var dgVBarChart_InputTypeLabel = "dans";
var dgVBarChart_InputTypePlaceholder = "S\xe9lectionnez le type de contenu";
var dgVBarChart_NoPointsTipFormat = "Total : {{totalPoints}}";
var dgVBarChart_PeriodLabel = "ce(tte)";
var dgVBarChart_PeriodPlaceholder = "P\xe9riode";
var dgVBarChart_Points = "Points";
var dgVBarChart_PointsTipFormat = "<b>{{date}}</b><br/>{{item}}\xa0: {{itemPoints}}<br/>Total\xa0: {{totalPoints}}";
var dgVBarChart_TopicLabel = "dans";
var dgVBarChart_ViewLearningCompletions = "Afficher les d\xe9tails des \xe9l\xe9ments termin\xe9s";
var dgVideoPlayer_BrowserError = "Votre navigateur ne peut pas lire cette vid\xe9o.";
var dgVideoPlayer_EncodingMessage = "Nous sommes encore en train de traiter cette nouvelle vid\xe9o pour votre navigateur.<br>R\xe9essayez plus tard.";
var dgWordLimit_LimitToFormat = "{{number}} mots maximum";
var dgWordLimit_MinLimitFormat = "{{number}} mots minimum.";
var dgWordLimit_WordCount = "Nombre de mots";
var dgWordLimit_WordLimitReached = "Nombre limite de mots d\xe9pass\xe9.";
var dgWordLimit_WordsRemaining = "Mots restants\xa0:";
var dgXpBar_NewPointsFormat = "{{newPoints}} pts";
var dgXpBar_NextGoalFormat = "{{nextGoal}} pts";
var Download_DownloadFile = "T\xe9l\xe9charger le fichier";
var downloadReportOutcome_FailureFormat = "Une erreur s’est produite en g\xe9n\xe9rant le rapport {{name}} que vous avez demand\xe9.";
var downloadReportOutcome_SuccessFormat = "Votre rapport {{name}} est pr\xeat \xe0 \xeatre t\xe9l\xe9charg\xe9.";
var EmailAddressVerificationCtrl_VerificationEmailSentFormat = "Courrier \xe9lectronique de v\xe9rification envoy\xe9 \xe0 {{email}}";
var EmbeddedLearning_ComingSoon = "Prochainement\xa0!";
var EmbeddedLearning_RelatedArticles = "Articles connexes";
var EmbeddedLearning_RelatedPathways = "Parcours connexes";
var EmbeddedLearning_RelatedVideos = "Vid\xe9os connexes";
var EndorsementOptionsSvc_ContributionLarge = "Contribution importante";
var EndorsementOptionsSvc_ContributionModerate = "Contribution mod\xe9r\xe9e";
var EndorsementOptionsSvc_ContributionNone = "Aucune contribution";
var EndorsementOptionsSvc_ContributionSmall = "Faible contribution";
var EndorsementOptionsSvc_ContributionVeryLarge = "Contribution tr\xe8s importante";
var EndorsementOptionsSvc_DifficultyExtremely = "Extr\xeamement difficile";
var EndorsementOptionsSvc_DifficultyNot = "Pas difficile";
var EndorsementOptionsSvc_DifficultySlightly = "Un peu difficile";
var EndorsementOptionsSvc_DifficultySomewhat = "Assez difficile";
var EndorsementOptionsSvc_DifficultyVery = "Tr\xe8s difficile";
var EndorsementOptionsSvc_ExpertLevel1 = "jusqu’au 30e centile";
var EndorsementOptionsSvc_ExpertLevel2 = "du 30e au 49e centile";
var EndorsementOptionsSvc_ExpertLevel3 = "du 50e au 69e centile";
var EndorsementOptionsSvc_ExpertLevel4 = "du 70e au 89e centile";
var EndorsementOptionsSvc_ExpertLevel5 = "du 90e au 99e centile";
var EndorsementOptionsSvc_MasteryCapable = "Novice";
var EndorsementOptionsSvc_MasteryDistinguished = "Distingu\xe9";
var EndorsementOptionsSvc_MasteryEmerging = "En \xe9mergence";
var EndorsementOptionsSvc_MasteryExperienced = "Exp\xe9riment\xe9";
var EndorsementOptionsSvc_MasteryMaster = "Expert";
var EndorsementOptionsSvc_MasteryNovice = "Novice";
var EndorsementOptionsSvc_People0To5 = "De 0\xa0\xe0 5\xa0personnes";
var EndorsementOptionsSvc_People11To20 = "De\xa011\xa0\xe0\xa020\xa0personnes";
var EndorsementOptionsSvc_People151Plus = "Plus de 151\xa0personnes";
var EndorsementOptionsSvc_People21To40 = "De\xa021\xa0\xe0\xa040\xa0personnes";
var EndorsementOptionsSvc_People41To80 = "De\xa041\xa0\xe0\xa080\xa0personnes";
var EndorsementOptionsSvc_People6To10 = "De\xa06\xa0\xe0\xa010\xa0personnes";
var EndorsementOptionsSvc_People81To150 = "De\xa081\xa0\xe0\xa0150\xa0personnes";
var EndorsementOptionsSvc_Percentile30Minus = "jusqu’au 30e centile";
var EndorsementOptionsSvc_Percentile30To49 = "du 30e au 49e centile";
var EndorsementOptionsSvc_Percentile50To69 = "du 50e au 69e centile";
var EndorsementOptionsSvc_Percentile70To89 = "du 70e au 89e centile";
var EndorsementOptionsSvc_Percentile90To99 = "du 90e au 99e centile";
var EndorsementOptionsSvc_RelationshipClientOfFormat = "Vous \xe9tiez un client de {{name}}";
var EndorsementOptionsSvc_RelationshipDifferentCompanyFormat = "Vous avez travaill\xe9 avec {{name}} mais chez diff\xe9rentes entreprises";
var EndorsementOptionsSvc_RelationshipDifferentGroupFormat = "Vous avez travaill\xe9 avec {{name}} dans diff\xe9rents groupes";
var EndorsementOptionsSvc_RelationshipManagedFormat = "Vous avez g\xe9r\xe9 {{name}} directement";
var EndorsementOptionsSvc_RelationshipMentorFormat = "Vous \xe9tiez un mentor pour {{name}}";
var EndorsementOptionsSvc_RelationshipReportedToFormat = "Vous avez signal\xe9 directement \xe0 {{name}}";
var EndorsementOptionsSvc_RelationshipSameGroupFormat = "Vous avez travaill\xe9 avec {{name}} dans le m\xeame groupe";
var EndorsementOptionsSvc_RelationshipSeniorToFormat = "Vous \xe9tiez senior pour {{name}}, mais n’avez pas \xe9t\xe9 son responsable direct";
var EndorsementOptionsSvc_RelationshipSeniorToYouFormat = "{{name}} \xe9tait sup\xe9rieur \xe0 vous, mais il n’a pas \xe9t\xe9 votre responsable direct";
var EndorsementOptionsSvc_RelationshipStudents = "Vous avez \xe9tudi\xe9 ensemble";
var EndorsementOptionsSvc_RelationshipTeacherFormat = "Vous \xe9tiez enseignant de {{name}}";
var EndorsementOptionsSvc_RelationshipYourCientFormat = "{{name}} \xe9tait un de vos client";
var EndorsementOptionsSvc_SignificanceExtremely = "Extr\xeamement important";
var EndorsementOptionsSvc_SignificanceNot = "Pas important";
var EndorsementOptionsSvc_SignificanceSlightly = "Un peu important";
var EndorsementOptionsSvc_SignificanceSomewhat = "Assez important";
var EndorsementOptionsSvc_SignificanceVery = "Tr\xe8s important";
var EndorsementOptionsSvc_VerifyNo = "Non, certains \xe9l\xe9ments sont incorrects";
var EndorsementOptionsSvc_VerifyPartial = "Partiellement, je connaissais d\xe9j\xe0 certaines informations";
var EndorsementOptionsSvc_VerifyUnknown = "Non, je ne connaissais aucune de ces informations";
var EndorsementOptionsSvc_VerifyYes = "Oui, tout semble correct";
var EndorsementOptionsSvc_Years0To1 = "de 0 \xe0 1\xa0an";
var EndorsementOptionsSvc_Years11To14 = "de 11 \xe0 14\xa0ans";
var EndorsementOptionsSvc_Years15To20 = "de 15 \xe0\xa020\xa0ans";
var EndorsementOptionsSvc_Years21Plus = "plus de 21 ans";
var EndorsementOptionsSvc_Years2To4 = "de 2 \xe0 4\xa0ans";
var EndorsementOptionsSvc_Years5To7 = "de 5 \xe0 7\xa0ans";
var EndorsementOptionsSvc_Years8To10 = "de 8 \xe0 10\xa0ans";
var EndorsementSvc_ErrorGetting = "D\xe9sol\xe9 ! Une erreur s’est produite lors de la r\xe9cup\xe9ration des d\xe9tails de l’approbation.";
var EndorsementSvc_ErrorSaving = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’enregistrement de votre s\xe9lection.";
var endorserForm_EditHeader = "Modifier l’approbateur";
var endorserForm_EmailLabel = "Quelle est l’adresse e-mail de l’approbateur\xa0?";
var endorserForm_EmailPlaceholder = "P. ex.\xa0: nomdutilisateur@email.com";
var endorserForm_FirstNameLabel = "Quel est son pr\xe9nom\xa0?";
var endorserForm_InvitationLabel = "Si besoin, vous pouvez ajouter un message personnel pour votre approbateur.";
var endorserForm_LastNameLabel = "Quel est son nom\xa0?";
var endorserForm_PositionLabel = "Quelle est la profession de l’approbateur\xa0? Pr\xe9cisez son poste et son affiliation.";
var endorserForm_PositionPlaceholder = "P. ex.\xa0: PDG de Degreed";
var endorserForm_RelationshipLabel = "Comment connaissez-vous cet approbateur\xa0?";
var endorserForm_RelationshipPlaceholder = "P. ex.\xa0: manager actuel";
var endorsersForm_applicantsEmailValidationMessage = "Veuillez fournir l’adresse e-mail de l’approbateur, et non la v\xf4tre.";
var endorsersForm_Header = "Qui peut approuver votre comp\xe9tence\xa0?";
var endorsersForm_Instructions = '<p class="par">Cette \xe9tape consiste \xe0 fournir les coordonn\xe9es de trois approbateurs capables de confirmer la validit\xe9 de vos d\xe9clarations concernant votre fa\xe7on de travailler et vos performances pass\xe9es dans le domaine \xab\xa0{{credentialName}}\xa0\xbb. Ils doivent tous vous avoir vu personnellement utiliser cette comp\xe9tence (p. ex.\xa0: en collaborant avec vous sur un projet).</p>\n\n<p class="par">Le processus d’approbation prend environ 15\xa0minutes. L’approbateur devra \xe9valuer l’exactitude et la ma\xeetrise de chaque comportement li\xe9 \xe0 la comp\xe9tence. Nous enverrons un e-mail \xe0 vos approbateurs lorsque vous aurez soumis votre demande.</p>\n\n<p class="par">Les noms de vos approbateurs figureront sur votre certificat final.</p>';
var endorsersForm_InstructionsFour = "Si vous soumettez votre demande dans les d\xe9lais, nous contacterons vos approbateurs par e-mail peu de temps apr\xe8s le {{date}}.";
var endorsersForm_InstructionsOne = "Cette \xe9tape consiste \xe0 fournir les coordonn\xe9es de trois approbateurs capables de confirmer la validit\xe9 de vos d\xe9clarations concernant votre fa\xe7on de travailler et vos performances pass\xe9es dans le domaine \xab\xa0{{credentialName}}\xa0\xbb. Ils doivent tous vous avoir vu personnellement utiliser cette comp\xe9tence (p. ex.\xa0: en collaborant avec vous sur un projet).";
var endorsersForm_InstructionsThree = "Les noms de vos approbateurs figureront sur votre certificat final.";
var endorsersForm_InstructionsTwo = "Le processus d’approbation prend environ 15\xa0minutes et n’implique aucun travail de r\xe9daction. L’approbateur devra \xe9valuer l’exactitude et la ma\xeetrise de chaque comportement li\xe9 \xe0 la comp\xe9tence.";
var endorsersForm_InvalidEmailValidationMessage = "Veuillez saisir une adresse e-mail valide.";
var endorsersForm_sameEmailValidationMessage = "Cette adresse e-mail est identique \xe0 celle d’un autre approbateur. Veuillez indiquer une adresse e-mail unique pour chaque approbateur.";
var endorsersForm_SectionHeader1 = "Qui est votre premier approbateur\xa0?";
var endorsersForm_SectionHeader2 = "Qui est votre deuxi\xe8me approbateur\xa0?";
var endorsersForm_SectionHeader3 = "Qui est votre troisi\xe8me approbateur\xa0?";
var endorsersForm_Tip = "Choisissez des personnes en qui vous avez confiance pour r\xe9pondre \xe0 une demande d’approbation. Vous pouvez les avertir que vous les avez choisies.";
var endorsersForm_ValidationMessage = "Ce champ doit \xeatre renseign\xe9.";
var EpisodeFormCtrl_AddPodcast = "Ajouter un \xe9pisode de podcast";
var EpisodeFormCtrl_Category = "Veuillez ajouter au moins une cat\xe9gorie.";
var EpisodeFormCtrl_ChooseEpisode = "Choisir un \xe9pisode";
var EpisodeFormCtrl_DateCompleted = "Date d’ex\xe9cution";
var EpisodeFormCtrl_EditPodcast = "Modifier l’\xe9pisode de podcast";
var EpisodeFormCtrl_EnterPodcastName = "Saisir le nom du podcast";
var EpisodeFormCtrl_Episode = "\xc9pisode";
var EpisodeFormCtrl_EpisodeError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’acc\xe8s \xe0 vos \xe9pisodes.";
var EpisodeFormCtrl_ICreatedEpisode = "J’ai cr\xe9\xe9 cet \xe9pisode";
var EpisodeFormCtrl_LengthInMinutes = "Longueur (en minutes)";
var EpisodeFormCtrl_Loading = "Chargement...";
var EpisodeFormCtrl_NoEpisodes = "Aucun \xe9pisode trouv\xe9";
var EpisodeFormCtrl_NoMatch = "(impossible de trouver un podcast ou un nom d’auteur r\xe9pondant \xe0 ces crit\xe8res. Veuillez noter que les podcasts explicites sont exclus de la recherche.)";
var EpisodeFormCtrl_PodcastName = "Nom du podcast";
var EpisodeFormCtrl_SaveEpisode = "Enregistrer l’\xe9pisode";
var EpisodeFormCtrl_SelectEpisode = "Veuillez s\xe9lectionner un \xe9pisode dans la liste.";
var EpisodeFormCtrl_SelectTitle = "Le titre est requis";
var EpisodeFormCtrl_ValidNumber = "La dur\xe9e doit \xeatre un nombre valide ou ne pas \xeatre indiqu\xe9";
var EpisodeFormCtrl_WhatDidYouLearnLong = "Qu’avez-vous appris gr\xe2ce \xe0 cet \xe9pisode de podcast \xa0?";
var EpisodeFormCtrl_WhatDidYouLearnShort = "Qu’avez-vous appris \xa0?";
var ErrorPages_ErrorTitle = "Oups\xa0! Impossible de trouver la page que vous cherchez.";
var ErrorPages_ErrorTitle500 = "Oups\xa0! Une erreur s’est produite.";
var ErrorPages_FaultSolution = "Notre site a subi de nombreuses modifications ces derniers temps, et beaucoup d’\xe9l\xe9ments ont \xe9t\xe9 d\xe9plac\xe9s. Essayez de saisir l’adresse \xe0 nouveau, signalez un probl\xe8me ou rendez-vous sur la page d’accueil.";
var ErrorPages_HomepageButton = "Page d’accueil de Degreed";
var ErrorPages_ReportBugButton = "Signaler un probl\xe8me";
var ErrorPages_VerifyEmailErrorText = "Oups\xa0! Ce lien n’est plus valide. Vous recevrez un e-mail avec un nouveau lien de v\xe9rification.";
var ErrorPages_VerifyEmailErrorTitle = "Lien expir\xe9";
var Eval_ApplicationAlreadyEndorsed = "Vous avez d\xe9j\xe0 examin\xe9 la demande de {{personName}}";
var Eval_ApplicationAlreadyEndorsedDesc = "Merci\xa0! Vous avez fini pour le moment.";
var Eval_ApplicationEndorsed = "Merci";
var Eval_ApplicationEndorsedDesc = "Vous avez bien approuv\xe9 la demande de {{personName}}.";
var Eval_ApplicationNotEndorsedDesc = "Vous avez refus\xe9 d’approuver la demande de {{personName}}.";
var Eval_ApplicationOutOfDate = "Vous avez termin\xe9\xa0! Aucune autre action n’est requise.";
var Eval_ApplicationOutOfDateDesc = "La demande d’approbation de la revue de comp\xe9tence a \xe9t\xe9 cl\xf4tur\xe9e, et votre validation n’est plus n\xe9cessaire.";
var Eval_ApproveApplication = "Approuver la demande";
var Eval_EndorseApplication = "Approuver la demande";
var Eval_EndorsementDesc = "{{personName}} vous a demand\xe9 d’approuver sa revue de comp\xe9tence. Une revue de comp\xe9tence est un questionnaire con\xe7u scientifiquement qui permet de mesurer le niveau de comp\xe9tence d’une personne. Vous devrez approuver la revue de comp\xe9tence ou demander des modifications en fonction des r\xe9ponses fournies et selon que le r\xe9sultat refl\xe8te ou non la comp\xe9tence de {{personName}}.";
var Eval_EndorsementHeader = "{{personName}} - Niveau {{level}} pour {{evaluationName}} - Revue de comp\xe9tence";
var Eval_EndorsementNav = "Navigation sur la page d’approbation de la revue de comp\xe9tence";
var Eval_GoBackHome = "Retourner \xe0 la page d’accueil";
var Eval_LeaveRemarks = "Laissez vos commentaires";
var Eval_LevelInItem = "Niveau\xa0{{level}} pour {{item}}";
var Eval_NextStep = "\xc9tape suivante";
var Eval_OptionalQuestionDesc_Endorser = "La s\xe9lection d’un approbateur est facultative. Cela fournit une preuve suppl\xe9mentaire de votre niveau de comp\xe9tence.";
var Eval_Question_AdvanceStateOfArt = "Contribuez-vous \xe0 faire avancer l’\xe9tat des connaissances dans cette comp\xe9tence\xa0?";
var Eval_Question_AdvanceStateOfArtExample = "Quelle est l’avanc\xe9e la plus r\xe9cente et la plus innovante que vous ayez apport\xe9e dans ce domaine\xa0?";
var Eval_Question_AlternativeApproaches = "Lorsque vous utilisez cette comp\xe9tence, envisagez-vous souvent d’autres approches pour r\xe9soudre un probl\xe8me\xa0?";
var Eval_Question_AnticipateCommProblems = "Lorsque vous utilisez cette comp\xe9tence, vous arrive-t-il souvent d’anticiper et de r\xe9soudre les probl\xe8mes de communication au sein des \xe9quipes\xa0?";
var Eval_Question_AnticipateRequirements = "Lorsque vous utilisez cette comp\xe9tence, vous arrive-t-il souvent d’anticiper les int\xe9r\xeats et les besoins des autres\xa0?";
var Eval_Question_ApplyFrequency = "Utilisez-vous fr\xe9quemment cette comp\xe9tence\xa0?";
var Eval_Question_ApplyJob = "Utilisez-vous cette comp\xe9tence dans votre emploi actuel\xa0?";
var Eval_Question_ApplyNewTheories = "Vous arrive-t-il souvent de mettre en pratique de nouvelles th\xe9ories, techniques ou m\xe9thodes relatives \xe0 cette comp\xe9tence dans votre travail\xa0?";
var Eval_Question_ApproachTheory = "Lequel des \xe9nonc\xe9s suivants d\xe9crit le mieux la fa\xe7on dont vous abordez la th\xe9orie de ce domaine de comp\xe9tences\xa0?";
var Eval_Question_ArticulateChallenge = "Lorsqu’un d\xe9fi important se pr\xe9sente sur un projet que vous dirigez dans ce domaine de comp\xe9tences, \xeates-vous souvent la premi\xe8re personne \xe0 l’identifier\xa0?";
var Eval_Question_ArticulateChallengeExample = "D\xe9crivez une situation o\xf9 vous avez identifi\xe9 un d\xe9fi majeur pour un projet que vous dirigiez.";
var Eval_Question_BuildConsensus = "Lorsque vous utilisez cette comp\xe9tence, vous arrive-t-il souvent de parvenir \xe0 un consensus dans un environnement de groupe\xa0?";
var Eval_Question_BuildConsensusExample = "D\xe9crivez comment vous \xeates parvenu(e) \xe0 un consensus sur une id\xe9e ou un projet au sein d’un groupe.";
var Eval_Question_Collaboration = "Lorsque vous planifiez votre travail dans cette comp\xe9tence, collaborez-vous avec d’autres personnes\xa0?";
var Eval_Question_CommunicateDifficultSubjects = "\xcates-vous \xe0 l’aise pour \xe9changer sur des sujets pointus concernant ce domaine\xa0?";
var Eval_Question_CommunicationAbilities = "Comment d\xe9cririez-vous votre aptitude \xe0 communiquer autour de cette comp\xe9tence\xa0?";
var Eval_Question_ComplexTasks = "Comment abordez-vous les t\xe2ches complexes en rapport avec ce domaine\xa0?";
var Eval_Question_ContributeProfessionalDevelopment = "Comment d\xe9cririez-vous votre contribution au d\xe9veloppement de cette comp\xe9tence chez d’autres personnes\xa0?";
var Eval_Question_ContributeProfessionalDevelopmentExample = "Comment avez-vous influenc\xe9 le d\xe9veloppement professionnel d’autres personnes poss\xe9dant cette comp\xe9tence\xa0?";
var Eval_Question_ContributingToObjectives = "Vous arrive-t-il souvent de vous demander si votre travail li\xe9 \xe0 cette comp\xe9tence contribue \xe0 la r\xe9alisation de vos objectifs\xa0?";
var Eval_Question_CrossDiscipline = "Lorsque vous utilisez cette comp\xe9tence, vous arrive-t-il souvent de travailler avec des personnes venant d’une autre discipline\xa0?";
var Eval_Question_DefineGroupProcess = "\xc9laborez-vous les m\xe9thodes de travail appliqu\xe9es par le groupe\xa0?";
var Eval_Question_DefineGroupRoles = "Aidez-vous \xe0 d\xe9finir le r\xf4le de chaque membre du groupe\xa0?";
var Eval_Question_DescribeKnowledge = "Comment d\xe9cririez-vous votre niveau connaissance par rapport \xe0 cette comp\xe9tence\xa0?";
var Eval_Question_DevelopGroupPotential = "Lorsque vous utilisez cette comp\xe9tence en groupe, cherchez-vous \xe0 identifier des opportunit\xe9s de la d\xe9velopper au sein du groupe, et parvenez-vous \xe0 le faire\xa0?";
var Eval_Question_DevelopGroupPotentialExample = "D\xe9crivez une situation o\xf9 vous avez d\xe9velopp\xe9 une comp\xe9tence au sein d’un groupe ou d’une organisation.";
var Eval_Question_DirectOthers = "Dirigez-vous le travail et assignez-vous des r\xf4les aux autres dans un domaine li\xe9 \xe0 cette comp\xe9tence\xa0?";
var Eval_Question_DirectOthersExample = "Comment dirigez-vous le travail et assignez-vous des r\xf4les \xe0 des pairs dans ce domaine\xa0?";
var Eval_Question_EvaluateProcesses = "\xc9valuez-vous souvent les forces et les faiblesses des m\xe9thodes de travail li\xe9es \xe0 cette comp\xe9tence\xa0?";
var Eval_Question_EvaluateProcessesExample = "D\xe9crivez une situation o\xf9 vous avez \xe9valu\xe9 les forces et les faiblesses d’une m\xe9thode de travail li\xe9e \xe0 cette comp\xe9tence.";
var Eval_Question_EvaluateWork = "Apr\xe8s avoir termin\xe9 une t\xe2che ou un projet li\xe9 \xe0 cette comp\xe9tence, \xe9valuez-vous l’efficacit\xe9 de votre travail\xa0?";
var Eval_Question_FindSolutions = "Lorsque vous utilisez cette comp\xe9tence, trouvez-vous souvent des solutions auxquelles d’autres personnes n’ont pas pens\xe9\xa0?";
var Eval_Question_FindSolutionsExample = "D\xe9crivez une situation o\xf9 vous avez d\xe9couvert une solution \xe0 un probl\xe8me auquel personne d’autre n’a pens\xe9 ou que personne n’a envisag\xe9.";
var Eval_Question_FrequencyUnanticipatedProblems = "Lorsque vous utilisez cette comp\xe9tence, rencontrez-vous souvent des probl\xe8mes que vous n’aviez pas anticip\xe9s\xa0?";
var Eval_Question_HelpGroupEffective = "Lorsque vous utilisez cette comp\xe9tence, aidez-vous les autres personnes de votre groupe \xe0 \xeatre plus efficaces\xa0?";
var Eval_Question_ImpactOnField = "Vos actions relatives \xe0 cette comp\xe9tence ont-elles un impact significatif au-del\xe0 de votre organisation\xa0?";
var Eval_Question_ImpactOnFieldExample = "D\xe9crivez bri\xe8vement dans quelle mesure vos actions ont un impact significatif au-del\xe0 de votre organisation.";
var Eval_Question_ImpactOthers = "Mesurez-vous souvent l’impact sur d’autres domaines fonctionnels des choix que vous faites en lien avec cette comp\xe9tence\xa0?";
var Eval_Question_ImproveSkill = "Est-ce une comp\xe9tence que vous voulez am\xe9liorer\xa0?";
var Eval_Question_InnovativeContributionExample = "D\xe9taillez une situation o\xf9 vous avez pr\xe9sent\xe9 \xe0 une communaut\xe9 plus large des concepts innovants li\xe9s \xe0 cette comp\xe9tence.";
var Eval_Question_JobTitle = "Quel est votre poste\xa0?";
var Eval_Question_LeadGroup = "Avez-vous dirig\xe9 un groupe dans ce domaine\xa0?";
var Eval_Question_LeadGroupExample = "Donnez un exemple de groupe que vous avez dirig\xe9 dans ce domaine.";
var Eval_Question_LeadOrg = "Avez-vous dirig\xe9 une organisation dans ce domaine\xa0?";
var Eval_Question_LeadOrgExample = "Donnez un exemple d’organisation que vous avez dirig\xe9e dans ce domaine.";
var Eval_Question_Learn = "\xc0 quelle fr\xe9quence vous formez-vous sur les nouveaux concepts et autres \xe9volutions en lien avec cette comp\xe9tence\xa0?";
var Eval_Question_LearnExample = "D\xe9crivez bri\xe8vement une chose que vous avez r\xe9cemment apprise en ce qui concerne cette comp\xe9tence.";
var Eval_Question_LearnFromOthers = "Dans quelle mesure \xeates-vous capable d’apprendre des autres en ce qui concerne cette comp\xe9tence\xa0?";
var Eval_Question_LevelOfResponsibility = "Comment d\xe9cririez-vous votre niveau de responsabilit\xe9 dans cette comp\xe9tence\xa0?";
var Eval_Question_LimitsExample = "D\xe9crivez une contrainte ou un d\xe9fi sp\xe9cifique dans ce domaine.";
var Eval_Question_LimitsOfField = "Pouvez-vous identifier les d\xe9fis et les contraintes propres \xe0 ce domaine\xa0?";
var Eval_Question_MasterStateOfArt = "Ma\xeetrisez-vous les derni\xe8res id\xe9es, technologies et fonctionnalit\xe9s li\xe9es \xe0 cette comp\xe9tence\xa0?";
var Eval_Question_NumberOfMethods = "Lorsque vous utilisez cette comp\xe9tence, lequel de ces \xe9nonc\xe9s vous d\xe9crit le mieux\xa0?";
var Eval_Question_OverallGuidance = "Travaillez-vous souvent sous la direction de quelqu’un d’autre en ce qui concerne cette comp\xe9tence\xa0?";
var Eval_Question_PracticalAbilities = "Comment qualifieriez-vous vos comp\xe9tences pratiques dans ce domaine\xa0?";
var Eval_Question_PresentationAbilities = "Comment d\xe9cririez-vous vos capacit\xe9s en mati\xe8re de pr\xe9sentation en ce qui concerne cette comp\xe9tence\xa0?";
var Eval_Question_PrestipulatedTasks = "\xcates-vous capable d’effectuer efficacement des t\xe2ches relatives \xe0 cette comp\xe9tence tout en vous conformant \xe0 des r\xe8gles pr\xe9\xe9tablies\xa0?";
var Eval_Question_ProblemsCanSolve = "Comment d\xe9cririez-vous les probl\xe8mes que vous pouvez r\xe9soudre gr\xe2ce \xe0 cette comp\xe9tence\xa0?";
var Eval_Question_ProjectResponsibility = "Vous chargez-vous souvent de nouveaux projets li\xe9s \xe0 cette comp\xe9tence\xa0?";
var Eval_Question_RelatedSkills = "Quelles sont les autres comp\xe9tences importantes li\xe9es \xe0 cette comp\xe9tence\xa0?";
var Eval_Question_RequirementsChange = "Les conditions requises pour vos projets li\xe9s \xe0 cette comp\xe9tence changent-elles souvent\xa0?";
var Eval_Question_SkillDuration = "Depuis combien de temps utilisez-vous cette comp\xe9tence\xa0?";
var Eval_Question_SocietalImplications = "Tenez-vous compte des implications soci\xe9tales, \xe9conomiques et culturelles de votre travail li\xe9 \xe0 cette comp\xe9tence\xa0?";
var Eval_Question_StrategicJudgements = "Dans quelle mesure \xeates-vous capable de formuler des jugements strat\xe9giques concernant des t\xe2ches techniques ou de gestion dans ce domaine\xa0?";
var Eval_Question_StrategicProblemExample = "Donnez un exemple de probl\xe8me strat\xe9gique que vous avez identifi\xe9 et r\xe9solu en rapport avec cette comp\xe9tence.";
var Eval_Question_Teamwork = "Lequel des \xe9nonc\xe9s suivants vous d\xe9crit le mieux lorsque vous travaillez en \xe9quipe\xa0?";
var Eval_Question_TechnicalKnowledge = "Comment d\xe9cririez-vous vos connaissances techniques et th\xe9oriques relatives \xe0 cette comp\xe9tence\xa0?";
var Eval_Question_TypesUnanticipatedProblems = "Quels sont les probl\xe8mes que vous n’avez pas pu anticiper\xa0?";
var Eval_Question_UnclearTasks = "Pouvez-vous g\xe9rer des t\xe2ches relatives \xe0 cette comp\xe9tence sans avoir besoin de r\xe8gles clairement d\xe9finies\xa0?";
var Eval_Question_UnderstandRelatedSkills = "Dans quelle mesure comprenez-vous ces comp\xe9tences connexes\xa0?";
var Eval_Question_WellKnown = "Est-ce que la plupart des personnes qui ont cette comp\xe9tence vous connaissent\xa0?";
var Eval_Question_WellKnownExample = "Selon votre estimation, combien de personnes ont \xe9t\xe9 influenc\xe9es par votre travail en lien avec cette comp\xe9tence\xa0?";
var Eval_Question_WorkInGroup = "Lorsque vous utilisez cette comp\xe9tence, travaillez-vous en groupe\xa0?";
var Eval_QuestionDesc_Endorser = "Choisissez quelqu’un dans votre organisation qui a suffisamment collabor\xe9 avec vous dans ce domaine pour pouvoir approuver vos r\xe9ponses. Cette personne pourra consulter toutes les r\xe9ponses que vous donnez dans le cadre de la revue de comp\xe9tence, ainsi que le niveau de comp\xe9tence obtenu.";
var Eval_QuestionDesc_HonorCode = "<p>La revue de comp\xe9tence est un questionnaire scientifiquement con\xe7u pour vous permettre d’\xe9valuer votre niveau de comp\xe9tence. Au cours du processus, vous devrez r\xe9pondre \xe0 de simples questions concernant votre exp\xe9rience qui seront ensuite utilis\xe9es pour calculer votre niveau.</p><p>Vous devez r\xe9pondre aux questions avec le plus de pr\xe9cision possible. Vous pourrez \xeatre occasionnellement invit\xe9(e) \xe0 fournir un exemple pour garantir votre objectivit\xe9.</p><p>Nous esp\xe9rons que ce processus vous aide \xe0 r\xe9fl\xe9chir et d\xe9terminer vos points forts et vos points faibles concernant cette comp\xe9tence. Une fois que vous aurez re\xe7u votre niveau de comp\xe9tence, vous pourrez mettre en valeur votre expertise aupr\xe8s de votre organisation ou planifier les prochaines \xe9tapes de votre d\xe9veloppement.</p>";
var Eval_ReflectSkillDescription = "Les informations fournies refl\xe8tent-elles le niveau de comp\xe9tence r\xe9el de {{personName}} ou des modifications sont-elles n\xe9cessaires\xa0?";
var Eval_RequestChanges = "Demander des modifications";
var Eval_Response_1_2Years = "De 1 \xe0 2\xa0ans";
var Eval_Response_11_Years = "11\xa0ans et plus";
var Eval_Response_3_5Years = "De 3 \xe0 5\xa0ans";
var Eval_Response_6_10Years = "De 6 \xe0 10\xa0ans";
var Eval_Response_AcceptHonorCode = "Je vais r\xe9pondre aux questions avec le plus de pr\xe9cision possible";
var Eval_Response_AcknowledgeOthers = "Je reconnais d’autres points de vue";
var Eval_Response_AdvancedSkills = "J’ai des comp\xe9tences techniques avanc\xe9es et sp\xe9cialis\xe9es";
var Eval_Response_BasicKnowledge = "Je connais les bases";
var Eval_Response_BasicSkills = "J’ai des comp\xe9tences pratiques de base";
var Eval_Response_BroadSkills = "J’ai un large \xe9ventail de comp\xe9tences pratiques";
var Eval_Response_CommunicateContextually = "Je peux proposer des solutions d’une mani\xe8re adapt\xe9e \xe0 un public interdisciplinaire";
var Eval_Response_CommunicateEffectively = "Je peux communiquer efficacement sur des solutions \xe0 des probl\xe8mes complexes";
var Eval_Response_ComplexCommunication = "Je peux aborder des sujets tr\xe8s complexes, peu familiers ou techniques";
var Eval_Response_ComplexProblems = "Probl\xe8mes complexes";
var Eval_Response_ComprehensiveTechTheoryKnowledge = "J’ai des connaissances approfondies et sp\xe9cialis\xe9es dans ces comp\xe9tences";
var Eval_Response_ConvincingOthers = "Je passe le plus clair de mon temps \xe0 convaincre les autres";
var Eval_Response_CurrentLimits = "J’explore les limites actuelles de la th\xe9orie, de la connaissance et de la pratique";
var Eval_Response_Daily = "Quotidien";
var Eval_Response_DeepKnowledge = "J’ai de profondes connaissances th\xe9oriques et professionnelles, y compris des th\xe9ories et des pratiques de base";
var Eval_Response_DemonstrateBasics = "Je peux d\xe9montrer et expliquer les bases aux autres";
var Eval_Response_DifferentApproaches = "J’\xe9value diff\xe9rentes th\xe9ories et approches pour r\xe9soudre des probl\xe8mes";
var Eval_Response_DirectDevelopment = "Je dirige le d\xe9veloppement professionnel des autres";
var Eval_Response_ExtendedSkills = "J’ai un large \xe9ventail de comp\xe9tences pratiques sp\xe9cialis\xe9es";
var Eval_Response_ExtensiveKnowledge = "J’ai une connaissance approfondie des principales th\xe9ories, m\xe9thodes et pratiques";
var Eval_Response_ExtensiveTechTheoryKnowledge = "J’ai une connaissance approfondie de ces comp\xe9tences";
var Eval_Response_FewProblems = "Pas ou peu de probl\xe8mes";
var Eval_Response_FewTechniques = "Je m’appuie sur quelques m\xe9thodes et techniques qui ont fait leurs preuves";
var Eval_Response_FocusOnMyDevelopment = "Je me concentre sur mon propre d\xe9veloppement";
var Eval_Response_FocusOnMyWork = "Je me concentre principalement sur mon propre travail";
var Eval_Response_FocusOnTask = "Je me concentre sur la t\xe2che \xe0 accomplir";
var Eval_Response_IntroduceInnovativeContributions = "Je propose des innovations \xe0 une large communaut\xe9";
var Eval_Response_LearningGuidance = "J’aide d’autres personnes \xe0 l’aide de conseils de formation bien fond\xe9s";
var Eval_Response_LessThan1Year = "Moins d’un an";
var Eval_Response_LimitedTechTheoryKnowledge = "J’ai une connaissance limit\xe9e de ces comp\xe9tences";
var Eval_Response_MakePeopleMoreEffective = "Je cherche activement le moyen de rendre les autres personnes plus efficaces";
var Eval_Response_Monthly = "Chaque mois";
var Eval_Response_MostAspects = "Mes connaissances couvrent la plupart des aspects de cette comp\xe9tence";
var Eval_Response_No = "Non";
var Eval_Response_NotComfortable = "Difficilement";
var Eval_Response_NoTechTheoryKnowledge = "Je ne comprends pas tr\xe8s bien ces comp\xe9tences";
var Eval_Response_NotSure = "Pas s\xfbr";
var Eval_Response_NotVery = "Pas tr\xe8s bien";
var Eval_Response_NovelProblems = "J’identifie et r\xe9sous de nouveaux probl\xe8mes li\xe9s \xe0 la recherche, au d\xe9veloppement ou \xe0 l’innovation autour de cette comp\xe9tence";
var Eval_Response_Often = "Souvent";
var Eval_Response_OncePerYear = "Une fois tous les deux ou trois ans";
var Eval_Response_OngoingSupport = "Je soutiens les autres de mani\xe8re continue";
var Eval_Response_Partially = "Partiellement";
var Eval_Response_PresentArguments = "Je peux pr\xe9senter des arguments et des solutions \xe0 des probl\xe8mes complexes";
var Eval_Response_PresentInformation = "Je pr\xe9sente des informations claires et pertinentes aux destinataires appropri\xe9s en temps voulu";
var Eval_Response_PresentNone = "Je ne pr\xe9sente pas d’informations aux autres";
var Eval_Response_Rarely = "Rarement";
var Eval_Response_ResponsibilityGiven = "J’assume la responsabilit\xe9 du travail qui m’a \xe9t\xe9 confi\xe9";
var Eval_Response_ResponsibilityOverall = "J’assume la responsabilit\xe9 des objectifs et des r\xe9sultats globaux";
var Eval_Response_ResponsibilityPlanning = "J’assume la responsabilit\xe9 de la planification et du d\xe9veloppement de projets et d’initiatives";
var Eval_Response_SensitiveCommunication = "Je peux aborder des sujets plus ou moins sensibles, controvers\xe9s ou susceptibles d’\xeatre contest\xe9s";
var Eval_Response_SeveralMethods = "J’\xe9value plusieurs m\xe9thodes et techniques en fonction de la situation";
var Eval_Response_SeveralPerYear = "Plusieurs fois par an";
var Eval_Response_SimpleProblems = "Probl\xe8mes simples";
var Eval_Response_SolveSimpleProblems = "Je peux r\xe9soudre des probl\xe8mes simples";
var Eval_Response_SolveStrategicProblems = "Je peux r\xe9soudre des probl\xe8mes strat\xe9giques g\xe9n\xe9raux";
var Eval_Response_SolveUnfamiliarProblems = "Je peux r\xe9soudre des probl\xe8mes qui me sont peu familiers";
var Eval_Response_SolveVarietyProblems = "Je peux r\xe9soudre une grande vari\xe9t\xe9 de probl\xe8mes complexes";
var Eval_Response_SomeKnowledge = "Je comprends quelques concepts techniques et th\xe9oriques";
var Eval_Response_Sometimes = "Parfois";
var Eval_Response_Somewhat = "Dans une certaine mesure";
var Eval_Response_SomewhatComfortable = "Plus ou moins facilement";
var Eval_Response_Specific = "La plupart de mes connaissances ne concernent qu’une partie sp\xe9cifique de cette comp\xe9tence";
var Eval_Response_StrategicProblems = "Probl\xe8mes strat\xe9giques";
var Eval_Response_SupportOthers = "Je soutiens les autres dans leurs r\xf4les";
var Eval_Response_Tangential = "Mes connaissances couvrent cette comp\xe9tence ainsi que d’autres domaines li\xe9s";
var Eval_Response_UncomfortableCommunication = "J’ai du mal \xe0 communiquer sur des sujets difficiles";
var Eval_Response_UnderstandOthers = "Je travaille activement pour comprendre le point de vue des autres et en tenir compte";
var Eval_Response_Very = "Tr\xe8s bien";
var Eval_Response_VeryComfortable = "Tr\xe8s facilement";
var Eval_Response_Weekly = "Hebdomadaire";
var Eval_Response_Yes = "Oui";
var Eval_ResponseDesc_AcceptHonorCode = "<p>La revue de comp\xe9tence est un questionnaire scientifiquement con\xe7u pour vous permettre d’\xe9valuer votre niveau de comp\xe9tence. Au cours du processus, vous devrez r\xe9pondre \xe0 de simples questions concernant votre exp\xe9rience qui seront ensuite utilis\xe9es pour calculer votre niveau.</p><p>Vous devez r\xe9pondre aux questions avec le plus de pr\xe9cision possible. Vous pourrez \xeatre occasionnellement invit\xe9(e) \xe0 fournir un exemple pour garantir votre objectivit\xe9.</p><p>Nous esp\xe9rons que ce processus vous aidera \xe0 r\xe9fl\xe9chir et d\xe9terminer vos points forts et vos points faibles concernant cette comp\xe9tence. Une fois que vous aurez re\xe7u votre niveau de comp\xe9tence, vous pourrez mettre en valeur votre expertise aupr\xe8s de votre organisation ou planifier les prochaines \xe9tapes de votre d\xe9veloppement.</p>";
var Eval_SaveEndorsementError = "Une erreur s’est produite lors de l’enregistrement.";
var Eval_Step_Application = "Application";
var Eval_Step_AutonomyResponsibility = "Autonomie et responsabilit\xe9";
var Eval_Step_Background = "Contexte d’acquisition de la comp\xe9tence";
var Eval_Step_CommunicationTeaching = "Communication et enseignement";
var Eval_Step_DemonstrationOfCriteria = "D\xe9tails de la comp\xe9tence";
var Eval_Step_EndorseDecline = "Approuver ou refuser";
var Eval_Step_Endorsement = "Invitez un approbateur";
var Eval_Step_General = "Contexte d’acquisition de la comp\xe9tence";
var Eval_Step_Introduction = "Introduction";
var Eval_Step_Knowledge = "Connaissances";
var Eval_Step_PlanningEvaluation = "Planning et \xe9valuation";
var Eval_Step_Questionnaire = "Questionnaire";
var Eval_Step_ReceiveResults = "Recevoir les r\xe9sultats";
var Eval_Step_ReviewApplication = "Examiner la demande";
var Eval_Step_TeamworkLeadership = "Travail d’\xe9quipe et leadership";
var Eval_StepDesc_Application = "R\xe9sultats de la demande de revue de comp\xe9tence de {{personName}}.";
var Eval_StepDesc_EndorseDecline = "\xc9valuez si la demande refl\xe8te le niveau de comp\xe9tence r\xe9el de {{personName}}.";
var Eval_StepDesc_EndorseIntroduction = "Explication de la revue de comp\xe9tence.";
var Eval_StepDesc_General = "Un aper\xe7u rapide";
var Eval_StepDesc_ReviewApplication = "R\xe9sultats de la demande de revue de comp\xe9tence de {{personName}}.";
var EvalApp_Cancel = "Annuler la revue de comp\xe9tence";
var EvalApp_MainTitle = "Revue de comp\xe9tence";
var EvalApp_Results_Breakdown = "R\xe9partition";
var EvalApp_Results_Congratulations = "F\xe9licitations\xa0!";
var EvalApp_Results_ExtraMile = "Si vous souhaitez recevoir un certificat correspondant \xe0 votre niveau de comp\xe9tence, vous pouvez fournir des preuves de vos capacit\xe9s et obtenir le statut {{aStart}}Certifi\xe9 Degreed{{aEnd}}";
var EvalApp_Results_GoToFeed = "Aller au flux";
var EvalApp_Results_GoToProfile = "Acc\xe9der au profil";
var EvalApp_Results_LevelDeclarationFormat = "D’apr\xe8s vos r\xe9ponses, vous avez le {{aStart}} niveau {{level}}{{aEnd}} en {{skillName}}.";
var EvalApp_Stay = "Continuer la revue";
var EvalNav_Heading = "Navigation sur la page de la revue de comp\xe9tence";
var EvalNav_Introduction = "Introduction";
var EvalNav_ResultsDescription = "Obtenez votre note";
var EvalNav_ResultsTitle = "Niveau de comp\xe9tence";
var EvalNav_SelectEndorser = "Choisissez un approbateur";
var EvaluationSvc_DeleteError = "Un probl\xe8me est survenu lors de la suppression de la revue de comp\xe9tence.";
var EvaluationSvc_DeleteSuccess = "La revue de comp\xe9tence a bien \xe9t\xe9 supprim\xe9e.";
var EvaluationSvc_RetrieveError = "Une erreur s’est produite lors de la r\xe9cup\xe9ration des \xe9valuations";
var EvaluationSvc_SetResultsError = "Une erreur s’est produite lors de l’enregistrement des r\xe9sultats de la question.";
var EvaluationSvc_SubmitError = "Une erreur s’est produite lors de la soumission.";
var EventFormCtrl_AddEvent = "Ajouter un \xe9v\xe9nement";
var EventFormCtrl_AddToCatalogFormat = "Ajoutez cet \xe9v\xe8nement au catalogue {{orgName}}";
var EventFormCtrl_Attendee = "Participant";
var EventFormCtrl_Category = "Veuillez ajouter au moins une cat\xe9gorie.";
var EventFormCtrl_DateAttended = "Date de participation";
var EventFormCtrl_Description = "Description";
var EventFormCtrl_EditEvent = "Modifier l’\xe9v\xe9nement";
var EventFormCtrl_EventLength = "Dur\xe9e de l’\xe9v\xe9nement";
var EventFormCtrl_EventLengthError = "La dur\xe9e de l’\xe9v\xe8nement doit \xeatre renseign\xe9e.";
var EventFormCtrl_EventSite = "Site web (URL) de l’\xe9v\xe9nement";
var EventFormCtrl_EventTitle = "Intitul\xe9 de l’\xe9v\xe9nement";
var EventFormCtrl_EventTitleError = "L’intitul\xe9 de l’\xe9v\xe9nement doit \xeatre renseign\xe9.";
var EventFormCtrl_EventUrl = "URL de l’\xe9v\xe9nement (indiquez http:// ou https://)";
var EventFormCtrl_HowInvolved = "Quelle a \xe9t\xe9 votre contribution\xa0?";
var EventFormCtrl_Keynote = "Discours";
var EventFormCtrl_OneDay = "1\xa0jour";
var EventFormCtrl_OneHour = "1\xa0heure";
var EventFormCtrl_Panelist = "Pan\xe9liste";
var EventFormCtrl_Presenter = "Pr\xe9sentateur";
var EventFormCtrl_SaveEvent = "Enregistrer l’\xe9v\xe9nement";
var EventFormCtrl_ThreeToEightHours = "de 3 \xe0 8\xa0heures";
var EventFormCtrl_ThreeToFiveDays = "de 3 \xe0 5\xa0jours";
var EventFormCtrl_Title = "Titre";
var EventFormCtrl_TwoDays = "2\xa0jours";
var EventFormCtrl_TwoHours = "2\xa0heures";
var EventFormCtrl_ValidUrl = "Veuillez utiliser une URL valide et compl\xe8te.";
var EventFormCtrl_WeekOrMore = "Une semaine ou plus";
var EventFormCtrl_WhatDidYouLearnLong = "Qu’avez-vous appris gr\xe2ce \xe0 cet \xe9v\xe9nement\xa0?";
var EventFormCtrl_WhatDidYouLearnShort = "Qu’avez-vous appris\xa0?";
var Ext_AddALesson = "Ajouter une nouvelle le\xe7on";
var Ext_AddAPathway = "Ajouter un nouveau parcours";
var Ext_AddASection = "Ajouter une nouvelle section";
var Ext_AddATitle = "Veuillez ajouter un titre";
var Ext_AddCommentError = "Un probl\xe8me est survenu lors de l’ajout de ce commentaire";
var Ext_AddedToCatalogSuccess = "Ajout\xe9 au catalogue";
var Ext_AddedToPlan = "Ajout\xe9 au plan";
var Ext_Adding = "Ajout...";
var Ext_AddingInputFormat = "Ajout {{inputType}}...";
var Ext_AddNotificationNote = "Ajouter une note indiquant les raisons de cette suggestion (facultatif)";
var Ext_AddPathwayFor = "Ce parcours est destin\xe9 \xe0...";
var Ext_AddPathwayTitle = "Nouveau titre de parcours";
var Ext_AddRecommendationNote = "Ajouter une note indiquant pourquoi vous partagez ceci (facultatif)";
var Ext_AddSuccess = "Ajout\xe9";
var Ext_AddTakeaway = "Ajouter un avis";
var Ext_AddToCatalog = "Ajouter au catalogue";
var Ext_AddToCatalogFormat = "Ajouter {{inputType}} au catalogue de {{orgName}}";
var Ext_AddToPathway = "Ajouter au parcours";
var Ext_AddTopics = "Ajouter des comp\xe9tences";
var Ext_AddTopicsOrSkills = "Ajouter des comp\xe9tences";
var Ext_AddTopicsOrTakeAway = "Ajouter des comp\xe9tences ou des avis";
var Ext_AddToPlan = "Ajouter \xe0 un plan";
var Ext_AuthBlurb = "Recherchez, capturez et mesurez l’ensemble de votre apprentissage \xe0 partir des meilleures ressources sur plusieurs milliers de plates-formes.";
var Ext_BookInfoUnavailable = "L’ajout des informations de ce livre n’est pas disponible";
var Ext_CharacterCount = "{{count}} caract\xe8res restants";
var Ext_CharactersRemainingFormat = "{{count}} caract\xe8res restants";
var Ext_ClearSearch = "Effacer votre recherche";
var Ext_Close = "Fermer";
var Ext_ConfirmDetails = "Confirmer les d\xe9tails";
var Ext_Continue = "Continuer";
var Ext_CreatePlan = "Cr\xe9er un plan";
var Ext_EnterTopics = "Saisissez des comp\xe9tences";
var Ext_Error = "Oups...";
var Ext_ErrorMessage = "D\xe9sol\xe9, un probl\xe8me est survenu.";
var Ext_ErrorSharing = "Un probl\xe8me est survenu lors du partage de ce contenu";
var Ext_ExistsInCMS = "Cet article existe d\xe9j\xe0 dans le catalogue.";
var Ext_GroupMemberCount = "{{count}} Membres | Groupe";
var Ext_InputAddedFormat = "{{inputType}} ajout\xe9";
var Ext_ItemAdded = "\xc9l\xe9ment ajout\xe9";
var Ext_ItemSaved = "\xc9l\xe9ment enregistr\xe9";
var Ext_Lesson = "Le\xe7on";
var Ext_LessonAddError = "Impossible d’ajouter cette le\xe7on";
var Ext_LessonFormat = "Le\xe7on {{lessonNumber}}";
var Ext_LessonPlaceholder = "S\xe9lectionner une le\xe7on";
var Ext_Loading = "Chargement...";
var Ext_LogoAlt = "Se rendre sur Degreed";
var Ext_LogOut = "Se d\xe9connecter";
var Ext_MarkCompleteError = "Un probl\xe8me est survenu au moment de la validation";
var Ext_MarkCompleteFormat = "Terminer\xa0: {{title}}";
var Ext_MemberCountFormat = "{{count}} membres";
var Ext_MenuMarkComplete = "Marquer comme termin\xe9";
var Ext_MenuRecommend = "Partage";
var Ext_MenuSaveForLater = "Mettre de c\xf4t\xe9";
var Ext_Message = "Message";
var Ext_NewNotificationsFormat = "{{count}}\xa0nouvelles notifications";
var Ext_Next = "Suivant";
var Ext_NoAccount = "Vous n’avez pas compte ?";
var Ext_NoNotifications = "Pas de nouvelle notification";
var Ext_NoPlansYet = "Aucun plan n’a \xe9t\xe9 cr\xe9\xe9 pour vos ajouts.";
var Ext_NotificationCountFormat = "{{count}} notifications";
var Ext_Pathway = "Parcours";
var Ext_PathwayAddError = "Nous n’avons pas pu enregistrer ce parcours";
var Ext_PathwayAddItemError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’ajout de l’\xe9l\xe9ment au parcours.";
var Ext_PathwayAddItemPermissionError = "D\xe9sol\xe9, Cet \xe9l\xe9ment n’a pas pu \xeatre ajout\xe9 au parcours s\xe9lectionn\xe9.";
var Ext_PathwayDetailAccessError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’acc\xe8s aux d\xe9tails du parcours.";
var Ext_PathwayEnrollError = "Un probl\xe8me est survenu lors de votre inscription \xe0 ce parcours";
var Ext_PathwayError = "Nous ne sommes pas parvenus \xe0 obtenir vos parcours";
var Ext_PathwayLessonsError = "Nous ne sommes pas parvenus \xe0 obtenir les le\xe7ons de ce parcours";
var Ext_PathwayPlaceholder = "S\xe9lectionner un parcours";
var Ext_PathwayTitle = "Ajouter au parcours";
var Ext_PathwayUnenrollError = "Un probl\xe8me est survenu lors de votre d\xe9sinscription de ce parcours";
var Ext_PdfErrorMessage = "Nous n’avons pas pu \xe9diter le PDF car il est h\xe9berg\xe9 dans un emplacement non s\xe9curis\xe9.";
var Ext_PlansCreate = "Cr\xe9er \xe0 partir du profil";
var Ext_PlansModalTitle = "Ajouter \xe0 un plan";
var Ext_PlansPlaceholder = "S\xe9lectionner un plan";
var Ext_PointsShort = "Points";
var Ext_PrivacyOnlyMe = "Moi uniquement (priv\xe9)";
var Ext_RecommandationSentPluralFormat = "Recommandation envoy\xe9e \xe0 {{count}} personnes avec succ\xe8s";
var Ext_RecommandationSentSingle = "Recommandation envoy\xe9e \xe0 1 personne avec succ\xe8s";
var Ext_Recommend = "Partage";
var Ext_RecommendationSentPluralFormat = "Partag\xe9 avec succ\xe8s avec {{count}}\xa0personnes";
var Ext_RecommendationSentSingle = "Partag\xe9 avec succ\xe8s avec 1\xa0personne";
var Ext_RecommendationViaEmail = "Partage par e-mail";
var Ext_Recommending = "Partage en cours...";
var Ext_RecommendingToPluralFormat = "Partage avec {{count}}\xa0personnes";
var Ext_RecommendingToSingle = "Partage avec 1\xa0personne";
var Ext_RecommendToPluralFormat = "Partager avec {{count}}\xa0personnes";
var Ext_RecommendToSingle = "Partager avec 1\xa0personne";
var Ext_RelatedSkills = "Comp\xe9tences connexes";
var Ext_Retry = "Oups, r\xe9essayez";
var Ext_Save = "Enregistrer";
var Ext_SaveButton = "Enregistrement";
var Ext_SaveForLaterError = "Un probl\xe8me est survenu au moment de mettre ceci de c\xf4t\xe9";
var Ext_SaveRatingError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’enregistrement de votre \xe9valuation. Ce n’est pas votre faute et nous mettons tout en œuvre pour r\xe9soudre le probl\xe8me.";
var Ext_Saving = "Enregistrement...";
var Ext_SavingError = "\xc9chec de l’enregistrement. Veuillez r\xe9essayer.";
var Ext_SavingItem = "Enregistrement de l’\xe9l\xe9ment...";
var Ext_SearchError = "Un probl\xe8me est survenu lors du chargement de cette recherche";
var Ext_SearchGroups = "Entrer le nom d’un groupe";
var Ext_SearchResultArticlesHeadingFormat = "Articles sur {{searchTerm}}";
var Ext_SearchResultBooksHeadingFormat = "Livres sur {{searchTerm}}";
var Ext_SearchResultNoneFound = "R\xe9sultat introuvable. Veuillez tenter une nouvelle recherche.";
var Ext_SearchResultPathwaysHeadingFormat = "Vos parcours sur {{searchTerm}}";
var Ext_SearchResultPeopleHeadingFormat = "Personnes \xe9galement int\xe9ress\xe9es par {{searchTerm}}";
var Ext_SearchResultTitleFormat = "R\xe9sultats pour \xab\xa0{{searchTerm}}\xa0\xbb";
var Ext_SearchResultVideosHeadingFormat = "Vid\xe9os sur {{searchTerm}}";
var Ext_Section = "Section";
var Ext_SectionAddError = "Ext_SectionAddError";
var Ext_SectionFormat = "Section {{sectionNumber}}";
var Ext_SectionPlaceholder = "S\xe9lectionner une section";
var Ext_SelectAGroup = "Veuillez s\xe9lectionner au moins un groupe.";
var Ext_SelectALesson = "S\xe9lectionner une le\xe7on";
var Ext_SelectAPathway = "S\xe9lectionner un parcours";
var Ext_SelectASection = "S\xe9lectionner une section";
var Ext_SelectLesson = "Choisissez une le\xe7on";
var Ext_SelectPathway = "Choisissez un parcours";
var Ext_SelectPlan = "S\xe9lectionner un plan";
var Ext_SelectRecommendees = "S\xe9lectionnez le groupe et les personnes avec lesquels partager ce contenu";
var Ext_SelectRecommendeesPlaceholder = "Entrez le nom d’un groupe ou d’une personne";
var Ext_SelectSection = "Choisissez une section";
var Ext_SelectSkillPlan = "Veuillez choisir un plan";
var Ext_SharedContentSuccess = "Votre {{contentType}} a \xe9t\xe9 partag\xe9";
var Ext_ShareSomethingAboutFormat = "Partagez des informations \xe0 ce sujet";
var Ext_ShareTitle = "Partager avec des groupes et des utilisateurs";
var Ext_SignIn = "Se connecter";
var Ext_SignInTitle = "Veuillez vous connecter";
var Ext_SignUpLink = "Inscription";
var Ext_TagsModalTitle = "Ajouter des comp\xe9tences";
var Ext_TagsSuggestionError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration des suggestions.";
var Ext_TakeawayAdded = "Avis ajout\xe9 avec succ\xe8s";
var Ext_TakeawayPlaceholder = "Qu’avez-vous appris de ceci ?";
var Ext_TargetAddError = "Un probl\xe8me est survenu lors de l’ajout de ce r\xe9pertoire \xe0 votre plan";
var Ext_TargetGetError = "Un probl\xe8me est survenu au moment de r\xe9cup\xe9rer vos plans";
var Ext_TargetGetSectionsError = "Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration des sections de votre plan.";
var Ext_Title = "Ajouter \xe0 Degreed";
var Ext_TopicAddedPlural = "Les comp\xe9tences ont bien \xe9t\xe9 ajout\xe9es";
var Ext_TopicAddedSingle = "La comp\xe9tence a bien \xe9t\xe9 ajout\xe9e";
var Ext_TopicAndTakeawayAddedPlural = "Les comp\xe9tences et l’avis ont bien \xe9t\xe9 ajout\xe9s";
var Ext_TopicAndTakeawayAddedSingle = "La comp\xe9tence et l’avis ont bien \xe9t\xe9 ajout\xe9s";
var Ext_ViewAllOnDegreed = "Tout afficher sur Degreed";
var Ext_ViewDuplicate = "Afficher le doublon";
var Ext_ViewPlan = "Afficher votre plan";
var Ext_ViewSavedItems = "Afficher les \xe9l\xe9ments enregistr\xe9s";
var Ext_ViewYourPathway = "Afficher votre parcours";
var Ext_WhyRecommending = "Ajoutez un message indiquant la raison de ce partage";
var externalContentModal_HeaderFormat = "Vous quittez le catalogue {{catalogName}}";
var ExternalProvidersSvc_ErrorMatchingResults = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’obtention des r\xe9sultats de recherche.";
var ExternalProvidersSvc_ErrorRetrievingDetailsFormat = "D\xe9sol\xe9 ! Il y a eu un probl\xe8me lors de la r\xe9cup\xe9ration des d\xe9tails {{type}}. R\xe9essayez plus tard.";
var ExternalProvidersSvc_ErrorRetrivingListFormat = "D\xe9sol\xe9 ! Il y a eu un probl\xe8me lors de la r\xe9cup\xe9ration de la liste {{type}}. R\xe9essayez plus tard.";
var FacetFilter_ActiveSubscription = "Abonnement actif";
var FacetFilter_More = "Plus";
var FacetFilter_None = "Aucun(e)";
var FacetFilter_SortAlpha = "a-z";
var FacetFilter_SortAlphaReverse = "z-a";
var FacetFilter_SortNumeric = "num\xe9ro";
var FacetFilter_VisitSite = "Visiter le site {{Name}}";
var FacetFilter_YourTopCategories = "Vos cat\xe9gories principales";
var FeedbackPartial_CitiCollaborate = "Citi Collaborate";
var FeedbackPartial_FAQ = "FAQ";
var FeedbackPartial_HereToHelp = "Nous sommes l\xe0 pour vous aider.";
var FeedbackPartial_KnowledgeCenter = "Centre de connaissances";
var FeedbackPartial_OSSLicense = "Informations sur la licence\xa0OSS";
var FeedbackPartial_PhoneNumber = "num\xe9ro de t\xe9l\xe9phone :";
var FeedbackPartial_PrivacyPolicy = "Politique de confidentialit\xe9";
var FeedbackPartial_SendAMessage = "Envoyez-nous un message";
var FeedbackSvc_ErrorMessage = "D\xe9sol\xe9 ! Nous ne sommes pas parvenus \xe0 recevoir votre demande.";
var FeedbackSvc_ThankyouMessage = "Merci, nous avons re\xe7u votre message.";
var FeedSvc_Dismiss = "Ignorer";
var firstPathwayModal_Enrolled = "Vous avez \xe9t\xe9 inscrit \xe0 un parcours";
var firstPathwayModal_Followed = "Vous suivez un parcours";
var firstPathwayModal_ViewPathways = "Afficher les parcours";
var firstPathwayModal_WhyTheyHelp = "Les parcours rassemblent des contenus de formation. Retrouvez les v\xf4tres sur la page de profil. ";
var FlexCtrl_AddPrimaryContact = "Ajouter un contact principal";
var FlexCtrl_AddProperties = "Ajouter des propri\xe9t\xe9s";
var FlexCtrl_AddSection = "Ajouter une section";
var FlexCtrl_AutoSuggestError = "D\xe9sol\xe9, aucune suggestion n’est disponible pour ce plan \xe0 l’heure actuelle. Vous pouvez cependant le personnaliser en y ajoutant du contenu, des personnes et des groupes.";
var FlexCtrl_ChooseSectionType = "Choisissez un type de section";
var FlexCtrl_EditingStatusMessage = "Vous \xeates en train de modifier cet \xe9l\xe9ment \xab\xa0{{pageType}}\xa0\xbb.";
var FlexCtrl_EditPageType = "Modifier {{pageType}}";
var FlexCtrl_EditPlanType = "Modifier le {{planType}}";
var FlexCtrl_EditPrimaryContact = "Modifier le contact principal";
var FlexCtrl_EditProperties = "Modifier les propri\xe9t\xe9s";
var FlexCtrl_EditSettings = "Modifier les param\xe8tres";
var FlexCtrl_NothingHere = "Il n’y a rien ici.";
var FlexCtrl_NothingHereDescription = "Lorsque vous ajouterez une section \xe0 votre plan, elle appara\xeetra ici.";
var FlexCtrl_PrimaryContact = "Contact principal";
var FlexCtrl_ReorderSections = "R\xe9organiser les sections";
var FlexCtrl_SavePrimaryContact = "Enregistrer le contact principal";
var FlexCtrl_SettingsType = "Param\xe8tres de {{pageType}}";
var FlexCtrl_ViewDirectory = "Afficher le r\xe9pertoire";
var FlexCtrl_ViewPageType = "Voir {{pageType}}";
var FlexCtrl_ViewPlanType = "FlexCtrl_ViewPlanType";
var FlexEdCtrl_Amount = "Montant";
var FlexEdCtrl_Balance = "(solde)";
var FlexEdCtrl_BalanceError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration de votre solde FlexED.";
var FlexEdCtrl_Date = "Date";
var FlexEdCtrl_Description = "Description";
var FlexEdCtrl_ErrorRetrieving = "Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration de vos informations FlexEd.";
var FlexEdCtrl_FlexEdTitle = "FlexED";
var FlexEdCtrl_FlexEdTransactionsTitle = "Transactions FlexED";
var FlexEdCtrl_UpdateCardInfo = "Mettre \xe0 jour les informations de la carte";
var flexEdModal_AllFieldsRequiredError = "Tous les champs doivent \xeatre renseign\xe9s.";
var flexEdModal_Close = "Fermer";
var flexEdModal_ConnectCardButton = "Associer la carte";
var flexEdModal_ContactYourAdminMessage = "Contactez votre administrateur si vous estimez avoir besoin d’une carte FlexED, mais que vous ne l’avez pas re\xe7ue.";
var flexEdModal_FirstName = "Pr\xe9nom";
var flexEdModal_InvalidNumberError = " Veuillez saisir un num\xe9ro valide.";
var flexEdModal_LastFour = "4 derniers chiffres de la carte FlexED";
var flexEdModal_LastName = "Nom";
var flexEdModal_LinkYourFlexEdCard = "Associer votre carte FlexED";
var flexEdModal_MultipleCardsError = " Diff\xe9rentes cartes correspondent aux informations fournies. Veuillez contacter votre administrateur.";
var flexEdModal_NameDoesNotMatchCardError = " Veuillez v\xe9rifier que les informations fournies sont correctes. Si le probl\xe8me persiste, veuillez contacter votre administrateur.";
var flexEdModal_NameOnCard = "Nom tel qu’indiqu\xe9 sur la carte";
var flexEdModal_SavedNewInformation = "Vos nouvelles informations FlexED ont \xe9t\xe9 enregistr\xe9es.";
var flexEdModal_SaveInfoButton = "Enregistrer les informations";
var flexEdModal_SuccessfullyConnected = "Vous venez d’ajouter avec succ\xe8s votre carte FlexED !";
var flexEdModal_ViewMyFlexEd = "Afficher mon FlexED";
var flexEdModal_ViewYourExpenditures = "Affichez vos d\xe9penses et g\xe9rez votre carte en cliquant sur le total FlexED du menu d’administration.";
var FlexEdSvc_FlexEdError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’acc\xe8s \xe0 vos informations FlexED.";
var FlexSvc_AddItems = "Ajouter des \xe9l\xe9ments";
var FlexSvc_AddLinkTextsDescription = "Contient uniquement un lien.";
var FlexSvc_AddResources = "Ajouter des ressources";
var FlexSvc_CombinedResources = "Ressources combin\xe9es";
var FlexSvc_FreeformTextDescription = "Contient uniquement une image et du texte.";
var FlexSvc_MixedResources = "M\xe9lange de ressources";
var FlexSvc_MixedResourcesDescription = "Peut contenir du contenu, des plans, des parcours, des comp\xe9tences, des personnes, des groupes et des fournisseurs.";
var FlexSvc_OpportunitiesDescription = "Contient uniquement des opportunit\xe9s.";
var FlexSvc_TextAndImage = "Texte et image";
var FollowingSvc_Continue = "Continuer";
var FollowingSvc_FollowerCountsError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration de votre nombre d’abonn\xe9s. Ce n’est pas votre faute et nous mettons tout en œuvre pour r\xe9soudre le probl\xe8me.";
var FollowingSvc_FollowerInfoError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration des informations des personnes que vous suivez.";
var FollowingSvc_FollowError = "D\xe9sol\xe9 ! Une erreur est survenue lors de l’abonnement \xe0 cette personne.";
var FollowingSvc_FollowNotification = "Vous suivez d\xe9sormais cette personne.";
var FollowingSvc_FollowNotificationFormat = "Vous suivez maintenant {{person}}";
var FollowingSvc_FollowUserNotification = "Si vous d\xe9cidez de suivre cet utilisateur, votre nom et votre photo s’afficheront sur la page Abonn\xe9s de celui-ci.";
var FollowingSvc_InteralFollowError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration des abonn\xe9s. Ce n’est pas votre faute et nous mettons tout en œuvre pour r\xe9soudre le probl\xe8me.";
var FollowingSvc_InternalRetrievalError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration des personnes suivies par cet utilisateur. Ce n’est pas votre faute et nous mettons tout en œuvre pour r\xe9soudre le probl\xe8me.";
var FollowingSvc_UnfollowError = "D\xe9sol\xe9 ! Une erreur est survenue lors du d\xe9sabonnement \xe0 cette personne.";
var FollowingSvc_UnfollowNotificationFormat = "Vous ne suivez plus {{person}}";
var followTargetForm_GroupHeader = "Rejoindre {{count}} groupes";
var followTargetForm_GroupHeaderSingular = "Rejoindre 1\xa0groupe";
var followTargetForm_Instructions = "Vous allez suivre le {{targetType}} \xab\xa0{{targetTitle}}\xa0\xbb. Si vous le suivez, le meilleur contenu de ce {{targetType}} et des ressources s\xe9lectionn\xe9es ci-dessous appara\xeetra dans votre flux de formation.";
var followTargetForm_NoResources = "Ce {{targetType}} ne dispose d’aucune autre ressource \xe0 s\xe9lectionner. En suivant ce {{targetType}}, vous recevrez une notification si d’autres ressources sont ajout\xe9es.";
var followTargetForm_PathwayHeader = "S’inscrire \xe0 {{count}}\xa0parcours";
var followTargetForm_PathwayHeaderSingular = "S’inscrire \xe0 1\xa0parcours";
var followTargetForm_selectTitleFormat = "S\xe9lectionner {{title}}";
var followTargetForm_Submit = "Suivre le {{targetType}}";
var followTargetForm_TagHeader = "Suivre {{count}}\xa0comp\xe9tences";
var followTargetForm_TagHeaderSingular = "Suivre 1\xa0comp\xe9tence";
var followTargetForm_TargetHeader = "Suivre {{count}}\xa0plans";
var followTargetForm_TargetHeaderSingular = "Suivre 1 plan";
var followTargetForm_Title = "Suivre un {{targetType}}";
var followTargetForm_UserHeader = "Suivre  {{count}}\xa0 personnes";
var followTargetForm_UserHeaderSingular = "Suivre 1\xa0personne";
var forgotPasswordForm_EmailLabel = "Quelle est votre adresse e-mail ?";
var forgotPasswordForm_EmailPlaceholder = "steve@acme.com";
var forgotPasswordForm_InvalidEmail = "Veuillez saisir une adresse e-mail valide";
var forgotPasswordForm_Message = "Veuillez indiquer votre adresse e-mail principale pour qu’un e-mail de r\xe9initialisation de mot de passe vous soit envoy\xe9.";
var forgotPasswordForm_Success = "Nous avons envoy\xe9 un e-mail \xe0 l’adresse que vous avez fournie avec des instructions pour r\xe9initialiser votre mot de passe.";
var forgotPasswordForm_SuccessMessage = "Votre mot de passe a \xe9t\xe9 r\xe9initialis\xe9 avec succ\xe8s. Vous pouvez maintenant vous connecter \xe0 votre compte en utilisant votre nouveau mot de passe.";
var forgotPasswordForm_Title = "R\xe9initialiser votre mot de passe";
var GoalFormSvc_ByThisDate = "d’ici cette date";
var GoalFormSvc_CompleteThisFormat = "Compl\xe9tez ce {{referenceType}}";
var GoalFormSvc_CreateGoal = "Cr\xe9er un objectif";
var GoalFormSvc_CreateGroupGoal = "Cr\xe9er un objectif pour un groupe sp\xe9cifique ?";
var GoalFormSvc_DeleteGoal = "Supprimer cet objectif";
var GoalFormSvc_EarnPoints = "Gagner des points";
var GoalFormSvc_EarnPointsMessage = "Gagner ce nombre de points suppl\xe9mentaires (nombre entier)";
var GoalFormSvc_EditGoal = "Modifier l’objectif";
var GoalFormSvc_GroupGoalProgress = "Avancement de l’objectif du groupe";
var GoalFormSvc_GroupTooltip = "S\xe9lectionnez un groupe pour cr\xe9er un objectif assign\xe9 \xe0 l’ensemble de ses membres.";
var GoalFormSvc_InThisCategory = "dans cette cat\xe9gorie";
var GoalFormSvc_ItemAddedFormat = "{{item}} a \xe9t\xe9 enregistr\xe9 pour plus tard!";
var GoalFormSvc_JustMe = "Non (moi uniquement)";
var GoalFormSvc_NumberOfPoints = "Nombre de points";
var GoalFormSvc_WhichGroupsTitle = "Pour quels groupes souhaitez-vous cr\xe9er un objectif ?";
var GroupContextSvc_ErrorNotification = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’acc\xe8s aux informations de l’organisation.";
var GroupCtrl_EmptyStateDescription = "Lorsque vous rejoindrez un groupe, il appara\xeetra ici.";
var GroupCtrl_EmptyStateTitle = "Aucun groupe";
var GroupCtrl_GroupRemovalWarning = "{{name}} ne pourra plus recevoir d’e-mails de groupe ni d’\xe9l\xe9ments partag\xe9s avec le groupe";
var GroupCtrl_LeaveGroupHeader = "Souhaitez-vous r\xe9ellement quitter le groupe ?";
var GroupCtrl_LeaveGroupSummary = "Vous ne recevrez plus d’e-mails de groupe ni d’\xe9l\xe9ments partag\xe9s avec le groupe.";
var GroupCtrl_MemberRemovedSuccessfully = "{{memberName}} a bien \xe9t\xe9 retir\xe9";
var GroupCtrl_MyTeam = "Voulez-vous vraiment supprimer ce groupe\xa0?";
var GroupCtrl_RemoveFromGroup = "Retirer {{name}} du groupe\xa0?";
var GroupCtrl_SetAsPrimary = "D\xe9finir en tant que \xab\xa0Votre \xe9quipe\xa0\xbb";
var GroupCtrl_UnsetAsPrimary = "Ne plus d\xe9finir en tant que \xab\xa0Votre \xe9quipe\xa0\xbb";
var GroupDeleteCtrl_DeleteGroupConfirm = "Voulez-vous vraiment supprimer ce groupe\xa0?";
var GroupDeleteCtrl_DeleteGroupError = "\xab\xa0D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la suppression du groupe.\xa0\xbb";
var GroupDeleteCtrl_DeleteGroupInfoDescription = "Ce groupe sera supprim\xe9 pour l’ensemble des membres du groupe. Tous les objectifs associ\xe9s \xe0 ce groupe seront \xe9galement supprim\xe9s.";
var GroupDeleteCtrl_DeleteGroupSuccess = "Groupe supprim\xe9 avec succ\xe8s.";
var GroupFormSvc_ConfirmRemoval = "Confirmer la suppression";
var GroupFormSvc_ConfirmRemovalMessage = "Voulez-vous vraiment supprimer cet utilisateur ?";
var GroupFormSvc_EditUserSettings = "Modifier les param\xe8tres de l’utilisateur";
var GroupFormSvc_History = "Historique";
var GroupFormSvc_MemberRequestDateFormat = "{{memberName}} a \xe9t\xe9 invit\xe9 sur {{dateRequestedHtml}}";
var GroupFormSvc_MemberSinceFormat = "{{memberName}} est membre de ce groupe depuis le {{dateJoined}}";
var GroupFormSvc_PendingMember = "Membre en attente";
var GroupFormSvc_RemoveFromGroup = "Supprimer du groupe";
var GroupFormSvc_Removing = "Suppression...";
var GroupFormSvc_Role = "R\xf4le";
var GroupFormSvc_RolePermissions = "{{name}} autorisations : {{permissions}}";
var GroupFormSvc_TopCategories = "Comp\xe9tences principales";
var GroupInsightsCtrl_All = "Tout";
var GroupInsightsCtrl_GroupCategories = "Cat\xe9gories de groupe";
var GroupInsightsCtrl_Month = "Mois";
var GroupInsightsCtrl_Week = "Semaine";
var GroupInsightsCtrl_Year = "Ann\xe9e";
var groupInviteAccepted_PluralFormat = "{{nameHtml}} et {{number}} autres ont accept\xe9 votre invitation au groupe {{groupNameHtml}}";
var groupInviteAccepted_SingleFormat = "{{nameHtml}} a accept\xe9 votre invitation au groupe {{groupNameHtml}}";
var GroupInviteCtrl_AddPeopleToGroup = "Ajouter des personnes au groupe";
var GroupInviteCtrl_InviteEmailInstructions = "Envoyez des invitations aux autres membres de l’organisation pour qu’ils rejoignent votre groupe.";
var GroupInviteCtrl_InviteLinkInstructions = "Invitez rapidement les membres de l’organisation \xe0 rejoindre votre groupe \xe0 l’aide de ce lien d’invitation.";
var GroupInviteCtrl_InvitePeople = "Inviter d’autres personnes";
var GroupInviteCtrl_SearchByName = "Rechercher par nom";
var GroupInviteCtrl_SendInviteTo = "L’invitation sera envoy\xe9e \xe0 :";
var GroupMemberFormCtrl_UpdateMemberRoleFormat = "R\xf4le mis \xe0 jour pour {{memberName}}";
var GroupMembersCtrl_AnyTime = "N’importe quelle dur\xe9e";
var GroupMembersCtrl_ApproveInvite = "Approuver";
var GroupMembersCtrl_DateJoined = "Date d’inscription";
var GroupMembersCtrl_DateRequestsOrInvited = "Date de requ\xeate/invitation";
var GroupMembersCtrl_DeclineInvite = "Refuser";
var GroupMembersCtrl_EditUserSettings = "Modifier les param\xe8tres de l’utilisateur";
var GroupMembersCtrl_ErrorNotification = "\xab\xa0D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’acc\xe8s aux informations des membres.\xa0\xbb";
var GroupMembersCtrl_FocusSkills = "Comp\xe9tences prioritaires";
var GroupMembersCtrl_JobTitle = "Profession";
var GroupMembersCtrl_LastActive = "Derni\xe8re activit\xe9";
var GroupMembersCtrl_LastXDaysFormat = "Derniers {{dayCount}} jours";
var GroupMembersCtrl_MembershipSource = "Source de l’abonnement";
var GroupMembersCtrl_MembershipSource_AnalyticsPipeline = "R\xe8gles m\xe9tier";
var GroupMembersCtrl_MembershipSource_BusinessRulesAPI = "Automatisations";
var GroupMembersCtrl_MembershipSource_BusinessRulesFtp = "R\xe8gles m\xe9tier";
var GroupMembersCtrl_MembershipSource_ClientUserFile = "Fichier utilisateur";
var GroupMembersCtrl_MembershipSource_ScheduledAutomation = "R\xe8gles m\xe9tier";
var GroupMembersCtrl_MembershipSource_UserAttributeFile = "Fichier de mise \xe0 jour d’utilisateurs";
var GroupMembersCtrl_MembershipSource_v2API = "API";
var GroupMembersCtrl_MembershipSource_Web = "Application Degreed";
var GroupMembersCtrl_Name = "Nom";
var GroupMembersCtrl_Of = "sur";
var GroupMembersCtrl_Points = "Points";
var GroupMembersCtrl_RatedJobSkills = "Comp\xe9tences professionnelles";
var GroupMembersCtrl_Remove = "Supprimer";
var GroupMembersCtrl_ResendInvite = "Renvoyer l’invitation";
var GroupMembersCtrl_Results = "R\xe9sultats";
var GroupMembersCtrl_ResultsPerPage = "R\xe9sultats par page\xa0:";
var GroupMembersCtrl_SendEmail = "Envoyer un e-mail";
var GroupMembersCtrl_SetToAdmin = "D\xe9finir en tant qu’administrateur";
var GroupMembersCtrl_SetToMember = "D\xe9finir comme membre";
var GroupMembersCtrl_ViewPendingMembers = "Afficher les {{memberCount}}\xa0 membres en attente";
var groupPostAdded_Format = "{{nameHtml}} a publi\xe9 dans {{groupNameHtml}}";
var groupPostAdded_GroupFormat = "{{nameHtml}} a publi\xe9 dans {{groupNameHtml}}";
var groupPostAdded_SingleFormat = "{{nameHtml}} a fait une publication dans {{groupNameHtml}}";
var GroupsController_About = "\xc0 propos du groupe";
var GroupsController_BecomeAMember = "Devenir membre de ce groupe";
var GroupsController_ClickRequestMembership = "Cliquez ici pour demander \xe0 s’abonner au groupe.";
var GroupsController_ClickToJoin = "Cliquez ici pour rejoindre ce groupe.";
var GroupsController_Feed = "Flux";
var GroupsController_GroupMembershipPending = "Inscription au groupe en attente";
var GroupsController_GroupPostVisibility = "Seul ce groupe peut voir les publications";
var GroupsController_GroupSettingsTitle = "Cr\xe9er un groupe";
var GroupsController_Insights = "Statistiques";
var GroupsController_Joining = "Inscription...";
var GroupsController_Members = "Membres";
var GroupsController_RequestedMembershipOne = "Vous avez demand\xe9 \xe0 devenir membre de ce";
var GroupsController_RequestedMembershipTwo = "groupe.";
var GroupsController_RequestMembership = "Demander \xe0 s’abonner au groupe";
var GroupsController_Settings = "Param\xe8tres";
var GroupSecurityCtrl_UpdateRolesSuccess = "Mise \xe0 jour des r\xf4les du groupe effectu\xe9e. Rechargement des permissions...";
var GroupSettingsCtrl_AdministrativeGroup = "Administratif";
var GroupSettingsCtrl_AdministrativeNewTip = "Seuls les administrateurs peuvent voir et interagir avec les groupes Administratif. Les autres personnes ne savent pas qu’elles appartiennent au groupe et ne voient pas le groupe dans la liste des groupes.";
var GroupSettingsCtrl_AdministrativeTip = "Seuls les administrateurs peuvent voir et interagir avec les groupes Administratif. Les autres personnes ne savent pas qu’elles appartiennent au groupe et ne voient pas le groupe dans la liste des groupes.";
var GroupSettingsCtrl_ClosedGroup = "Ferm\xe9";
var GroupSettingsCtrl_ClosedNewTip = "Tout membre de votre organisation peut trouver ce groupe, mais doit y \xeatre invit\xe9 pour y participer. Vous serez automatiquement ajout\xe9 au groupe.";
var GroupSettingsCtrl_ClosedTip = "Tout membre de votre organisation peut trouver ce groupe, mais doit y \xeatre invit\xe9 pour y participer.";
var GroupSettingsCtrl_CreateBulkGroups = "Ou cr\xe9ez plusieurs groupes \xe0 l’aide d’un(e)";
var GroupSettingsCtrl_CustomTooltip = "Lorsqu’un membre du groupe ajoute un contenu correspondant \xe0 ces comp\xe9tences, il s’affiche dans le flux du groupe.";
var GroupSettingsCtrl_Description = "Description";
var GroupSettingsCtrl_DuplicateName = "Ce groupe existe d\xe9j\xe0 dans l’organisation.";
var GroupSettingsCtrl_DynamicMembership = "Inscription dynamique";
var GroupSettingsCtrl_DynamicMembership_Info = "L’inscription au groupe se fait de mani\xe8re dynamique en fonction des attributs des utilisateurs.";
var GroupSettingsCtrl_DynamicMembership_Instructions = "S\xe9lectionnez jusqu’\xe0 20\xa0attributs pour d\xe9finir ce groupe dynamique";
var GroupSettingsCtrl_EnableOpportunities = "Activer les opportunit\xe9s pour le groupe";
var GroupSettingsCtrl_GroupAddedSuccess = "Groupe bien ajout\xe9.";
var GroupSettingsCtrl_GroupName = "Nom du groupe";
var GroupSettingsCtrl_GroupNameFormat = "Groupe {{groupName}}";
var GroupSettingsCtrl_GroupUpdatePrivacySuccess = "Mise \xe0 jour des param\xe8tres du groupe effectu\xe9e. Actualisation de la page...";
var GroupSettingsCtrl_GroupUpdateSuccess = "Mise \xe0 jour des param\xe8tres du groupe effectu\xe9e.";
var GroupSettingsCtrl_NameExists = "Il existe d\xe9j\xe0 un groupe avec ce nom dans {{org}}.";
var GroupSettingsCtrl_OpenGroup = "Ouvert \xe0 tous";
var GroupSettingsCtrl_OpenNewTip = "Tout membre de votre organisation peut trouver et rejoindre ce groupe. Le groupe pourra \xeatre ferm\xe9 ult\xe9rieurement.";
var GroupSettingsCtrl_OpenTip = "Tout membre de votre organisation peut trouver et rejoindre ce groupe.";
var GroupSettingsCtrl_PrivacySettings = "Param\xe8tres de confidentialit\xe9";
var GroupSettingsCtrl_PrivateGroup = "Priv\xe9";
var GroupSettingsCtrl_PrivateNewTip = "Seuls les utilisateurs que vous avez invit\xe9s \xe0 rejoindre le groupe peuvent le voir.";
var GroupSettingsCtrl_PrivateTip = "Seuls les utilisateurs que vous avez invit\xe9s \xe0 rejoindre le groupe peuvent le voir.";
var GroupSettingsCtrl_ProblemWithGroups = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’acc\xe8s aux groupes.";
var GroupSettingsCtrl_SaveGroup = "Enregistrer le groupe";
var GroupSettingsCtrl_SpecifyCategory = "Veuillez ajouter au moins une cat\xe9gorie.";
var GroupSettingsCtrl_SpecifyDescription = "Veuillez indiquer la description du groupe.";
var GroupSettingsCtrl_SpecifyName = "Veuillez indiquer le nom du groupe.";
var GroupSvc_BulkDeleteError = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de la suppression des groupes.";
var GroupSvc_BulkDeleteGroupsSuccess = "Groupe(s) supprim\xe9(s).";
var GroupSvc_ErrorNotification = "Un probl\xe8me est survenu lors de l’acc\xe8s aux groupes.";
var GroupSvc_GroupInvitesNotification = "Op\xe9ration effectu\xe9e\xa0! Vos invitations ont \xe9t\xe9 transmises.";
var GroupSvc_GroupInvitesNotificationError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’envoi des invitations.";
var GroupSvc_GroupJoinNotification = "Inscription au groupe effectu\xe9e.";
var GroupSvc_GroupLeaveNotification = "D\xe9sinscription du groupe effectu\xe9e.";
var GroupSvc_GroupMembershipNotification = "Demande d’inscription au groupe envoy\xe9e !";
var GroupSvc_GroupSettingsTitle = "Cr\xe9er un groupe";
var ImageEditSvc_ImagedUpdated = "Votre image a \xe9t\xe9 t\xe9l\xe9charg\xe9e.";
var ImageEditSvc_ImageUploadError = "Oups! Un probl\xe8me est survenu. Veuillez r\xe9essayer de t\xe9l\xe9charger l’image.";
var ImageEditSvc_ImageUploadTooBig = "Oups, c’est trop gros ! L’image doit \xeatre inf\xe9rieure \xe0 25\xa0Mo.";
var ImageEditSvc_OpenBadgeParseError = "Erreur\xa0: image de badge non valide. Une image de badge num\xe9rique valide doit inclure des donn\xe9es chiffr\xe9es relatives au badge num\xe9rique que vous avez obtenu. Elle est disponible aupr\xe8s du fournisseur de badge. Ajoutez une image de badge valide et r\xe9essayez.";
var inappropriateModalContent_Instructions = "Si vous signalez cet \xe9l\xe9ment, l’\xe9quipe d’assistance Degreed examinera le probl\xe8me. Si le contenu provient du catalogue externe, l’assistance Degreed supprimera le contenu inappropri\xe9. S’il s’agit de contenu interne, l’administrateur Degreed de votre organisation prendra une d\xe9cision d\xe9finitive, puis le supprimera s’il est inappropri\xe9.";
var inappropriateModalContent_Reason = "Indiquez-nous pourquoi ce contenu est inappropri\xe9";
var inappropriateModalContent_ReasonValidationError = "Veuillez indiquer un motif";
var inappropriateModalContent_Title = "Signaler un contenu inappropri\xe9";
var InputCard_PreviewInputFormat = "Aper\xe7u de {{inputType}}";
var InputRatingsSvc_ErrorNotification = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’enregistrement de votre \xe9valuation. Ce n’est pas votre faute et nous mettons tout en œuvre pour r\xe9soudre le probl\xe8me.";
var InputRatingsSvc_SavedCompleteSuccess = "Note enregistr\xe9e et {{type}} marqu\xe9 complet";
var InputRatingsSvc_SaveRatingError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’enregistrement de votre \xe9valuation. Ce n’est pas votre faute et nous mettons tout en œuvre pour r\xe9soudre le probl\xe8me.";
var InputRatingsSvc_SaveRatingSuccess = "Votre \xe9valuation a \xe9t\xe9 enregistr\xe9e.";
var InputsController_AssessmentUnavailable = "Ce test d'\xe9valuation n'est plus disponible.";
var InputsController_Average = "Moyenne";
var InputsController_FriendlyErrorMessage = "Vous devez d\xe9finir un pr\xe9nom et un nom sur la page Param\xe8tres avant de pouvoir afficher ce cours.";
var InputsController_From = "de";
var InputsController_Login = "Connexion";
var InputsController_NoRatings = "aucune \xe9valuation";
var InputsController_S = "s";
var InputsController_Signup = "Inscription";
var InputsController_User = "utilisateur";
var InputsController_YourRating = "Votre \xe9valuation :";
var InputSessionForm_Address = "Adresse";
var InputSessionForm_AddSessionDetails = "Ajouter des d\xe9tails sur la session";
var InputSessionForm_BasicInformation = "Informations de base";
var InputSessionForm_DateTime = "Date et heure";
var InputSessionForm_DateTimeNew = "Date et heure";
var InputSessionForm_DeletionAlert = "L’enregistrement de vos modifications alors que l’option D\xe9tails de la session est d\xe9sactiv\xe9e supprimera tous les d\xe9tails. Pour conserver vos modifications, r\xe9activez les D\xe9tails de la session avant de proc\xe9der \xe0 l’enregistrement.";
var InputSessionForm_DifferentUrl = "Utiliser une URL d’inscription diff\xe9rente";
var InputSessionForm_EndTime = "Heure de fin";
var InputSessionForm_EventEnds = "Fin de l’\xe9v\xe9nement";
var InputSessionForm_EventStarts = "D\xe9but de l’\xe9v\xe9nement";
var InputSessionForm_EventStreamLinkLabel = "Lien de diffusion de l’\xe9v\xe9nement en direct";
var InputSessionForm_EventStreamLinkPlaceholder = "Lien de diffusion de l’\xe9v\xe9nement (p.\xa0ex., Zoom, Google\xa0Meet)";
var InputSessionForm_EventTimeZone = "Fuseau horaire de l’\xe9v\xe9nement";
var InputSessionForm_InPerson = "Pr\xe9sentiel";
var InputSessionForm_IntegratedDetailsNotEditable = "Les d\xe9tails de la session provenant d’\xe9l\xe9ments int\xe9gr\xe9s ne sont pas modifiables dans Degreed";
var InputSessionForm_InvalidDate = "Veuillez s\xe9lectionner une date valide";
var InputSessionForm_InvalidTime = "Veuillez saisir une heure valide";
var InputSessionForm_InvalidTimeNew = "Veuillez s\xe9lectionner une heure valide";
var InputSessionForm_LocationType = "Type de lieu";
var InputSessionForm_LocationUrl = "URL du lieu";
var InputSessionForm_LocationUrl_Placeholder = "Ajoutez le lien de l’\xe9v\xe9nement diffus\xe9 en direct";
var InputSessionForm_LocationUrlDescription = "Lien vers le {{inputType}} en ligne";
var InputSessionForm_Online = "En ligne";
var InputSessionForm_PhysicalLocation = "Lieu physique de l’\xe9v\xe9nement";
var InputSessionForm_Registration = "Inscription";
var InputSessionForm_RegistrationAvailable = "L’inscription est ouverte";
var InputSessionForm_RegistrationAvailableNew = "Inscription disponible";
var InputSessionForm_RegistrationUrl = "URL d’inscription";
var InputSessionForm_SameUrl = "L’URL d’inscription est la m\xeame que celle du site web pour ce contenu ({{ inputType }})";
var InputSessionForm_SameUrlNew = "L’URL d’inscription est la m\xeame que celle du site Web du {{inputType}}";
var InputSessionForm_SearchAddress = "Rechercher l’adresse du lieu";
var InputSessionForm_StartTime = "Heure de d\xe9but";
var InputSessionForm_Timezone = "Fuseau horaire";
var InputsSvc_AddItemError = "Une erreur est survenue lors de l’ajout de l’\xe9l\xe9ment.";
var InputsSvc_CompletedError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la r\xe9alisation de l’\xe9l\xe9ment.";
var InputsSvc_CompletedSuccess = "\xc9l\xe9ment d’apprentissage effectu\xe9.";
var InputsSvc_DismissSuggestedError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors du masquage de l’\xe9l\xe9ment.";
var InputsSvc_DismissSuggestedSuccess = "\xc9l\xe9ment de formation ignor\xe9";
var InputsSvc_EditContentDuplicateError = "Le contenu en double existe d\xe9j\xe0.";
var InputsSvc_GeneralError = "Un probl\xe8me est survenu lors de l’acc\xe8s aux \xe9l\xe9ments de la biblioth\xe8que.";
var InputsSvc_GetAssessmentError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l'acc\xe8s aux tests d'\xe9valuation.";
var InputsSvc_GetBookError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’acc\xe8s aux livres.";
var InputsSvc_GetCourseError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’acc\xe8s aux formations.";
var InputsSvc_GetCourseMetadataError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la recherche d’informations \xe0 propos de l’URL.";
var InputsSvc_GetEpisodeError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’acc\xe8s aux \xe9pisodes.";
var InputsSvc_GetEventError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’acc\xe8s aux \xe9v\xe8nements.";
var InputsSvc_GetMediaError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’acc\xe8s aux m\xe9dias.";
var InputsSvc_GetMediaMetadataError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la recherche d’informations \xe0 propos de l’URL.";
var InputsSvc_GetSuggestedError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’obtention des \xe9l\xe9ments.";
var InputsSvc_GetUserError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration des principaux utilisateurs.";
var InputsSvc_PeopleCompleted = "{{count}}\xa0personnes ont termin\xe9 cet \xe9l\xe9ment";
var InputsSvc_PeopleLiked = "{{count}}\xa0personnes ont aim\xe9 cet \xe9l\xe9ment";
var InputsSvc_PeopleShared = "{{count}}\xa0personnes ont partag\xe9 cet \xe9l\xe9ment";
var InputsSvc_PersonCompleted = "1\xa0personne a termin\xe9 cet \xe9l\xe9ment";
var InputsSvc_PersonLiked = "1\xa0personne a aim\xe9 cet \xe9l\xe9ment";
var InputsSvc_PersonShared = "1\xa0personne a partag\xe9 cet \xe9l\xe9ment";
var InputsSvc_ProfileDismissed = "Profil ignor\xe9.";
var InputsSvc_QueueError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la mise de c\xf4t\xe9 de l’\xe9l\xe9ment.";
var InputsSvc_QueueSuccess = "\xc9l\xe9ment de formation mis de c\xf4t\xe9.";
var InputsSvc_UsersTitle = "Personnes ayant termin\xe9 ce contenu";
var InsightsNav_SkillTrends = "Tendances en mati\xe8re de comp\xe9tences";
var Integrations_Add_Type_Completion = "Ajouter un connecteur de compl\xe9tion";
var Integrations_Add_Type_Content = "Ajouter un connecteur de contenu";
var Integrations_Add_Type_Skill = "Ajouter un connecteur de comp\xe9tence";
var Integrations_Add_Type_SkillAssessment = "Ajouter un connecteur de test d’\xe9valuation de comp\xe9tences";
var Integrations_AdvancedSSO = "SSO avanc\xe9";
var Integrations_AlisonImportError = "Oups! Un probl\xe8me est survenu lors de l’importation de vos formations Alison. Veuillez v\xe9rifier votre identifiant utilisateur Alison unique.";
var Integrations_AlisonPublicProfile = "Vous devez poss\xe9der un profil Alison public.";
var Integrations_AlisonUserId = "Identifiant utilisateur Alison";
var Integrations_AlisonUserIdUserName = "Nom/identifiant d’utilisateur Alison";
var Integrations_APIKeys = "Cl\xe9s API";
var Integrations_BasicSSO = "SSO de base";
var Integrations_ClientId = "ID client";
var Integrations_ClientSecret = "Code secret client";
var Integrations_CodecademyImportError = "Oups\xa0! Un probl\xe8me est survenu lors de l’importation de vos formations Codecademy. Veuillez confirmer votre nom d’utilisateur.";
var Integrations_CodecademyPublicProfile = "Vous devez poss\xe9der un profil Codecademy public.";
var Integrations_CodecademyUsername = "Nom d’utilisateur Codecademy";
var Integrations_CodeSchoolImportError = "Oups ! Un probl\xe8me est survenu lors de l’importation de vos formations Code School. Veuillez v\xe9rifier votre nom d’utilisateur.";
var Integrations_CodeSchoolPublicProfile = "Vous devez poss\xe9der un profil Code School public.";
var Integrations_CodeSchoolUsername = "Nom d’utilisateur Code School";
var Integrations_ConfigureConnector_CreateAPI = "Vous devez configurer un connecteur ou cr\xe9er une cl\xe9 API pour activer votre int\xe9gration.";
var Integrations_Connect = "Connecter";
var Integrations_Connected = "Connect\xe9";
var Integrations_ConnectIntegrations = "Les int\xe9grations Degreed vous permettent facilement de vous mettre en valeur. Il vous suffit de vous connecter \xe0 ces services et d’importer les \xe9l\xe9ments r\xe9alis\xe9s dans votre profil Degreed.";
var Integrations_ConnectorSync_Type_Badge = "Synchroniser les insignes de {{providerName}} vers Degreed";
var Integrations_ConnectorSync_Type_BulkOpportunities = "Synchroniser des groupes d’opportunit\xe9s de {{providerName}} vers Degreed";
var Integrations_ConnectorSync_Type_Completion = "Synchroniser les \xe9l\xe9ments termin\xe9s de {{providerName}} vers Degreed";
var Integrations_ConnectorSync_Type_Content = "Synchroniser le contenu de {{providerName}} vers Degreed";
var Integrations_ConnectorSync_Type_Opportunity = "Synchroniser les opportunit\xe9s de {{providerName}} vers Degreed";
var Integrations_ConnectorSync_Type_RequiredLearning = "Synchroniser les formations obligatoires de {{providerName}} vers Degreed";
var Integrations_ConnectorSync_Type_Skill = "Synchroniser les comp\xe9tences de {{providerName}} vers Degreed";
var Integrations_ConnectorSync_Type_SkillAssessment = "Synchroniser les tests d’\xe9valuation de comp\xe9tences de {{providerName}} vers Degreed";
var Integrations_ConnectorSyncMustVerify = "Vous devez v\xe9rifier avant d’enregistrer.";
var Integrations_ConnectorSyncNightly = "La synchronisation des donn\xe9es se fera sous 24\xa0heures. Les donn\xe9es sont synchronis\xe9es pendant la nuit.";
var Integrations_ConsumerSetup = "Configuration client";
var Integrations_ConsumerSetupMetadata = "Les administrateurs Degreed peuvent activer l’indexation du contenu dans Degreed. Les apprenants qui cliqueront sur ce contenu seront redirig\xe9s vers une page d’acc\xe8s payant.";
var Integrations_ContactYourCEP = "Contactez votre Partenaire d’engagement client pour obtenir de l’aide";
var Integrations_ContentProviders = "Fournisseurs de contenu";
var Integrations_ContentRemain = "Le contenu qui fait d\xe9j\xe0 partie d’un parcours ou d’un plan sera conserv\xe9.";
var Integrations_ContentSyncPendingMeta = "La synchronisation de {{ providerName }} se fera sous 24\xa0heures. {{ providerName }} se synchronise pendant la nuit.";
var Integrations_ContentVisibility = "Visibilit\xe9 du contenu";
var Integrations_CourseraImportError = "Oups ! Un probl\xe8me est survenu lors de l’importation de vos formations Coursera.";
var Integrations_CourseraPublicProfile = "Vous devez poss\xe9der un profil Coursera public.";
var Integrations_CourseraUserId = "Identifiant utilisateur Coursera";
var Integrations_CustomVisitLink = "Lien de visite personnalis\xe9";
var Integrations_DeleteAnyAssociated = "Supprimer les licences utilisateur associ\xe9es \xe9ventuelles";
var Integrations_DeleteAnyContent = "Supprimer tout le contenu de {{ providerName }}";
var Integrations_DeleteAnyIncomplete = "Supprimer les formations obligatoires inachev\xe9es (les \xe9l\xe9ments termin\xe9s par les utilisateurs seront conserv\xe9s) si la formation obligatoire est configur\xe9e";
var Integrations_DISABLE = "D\xc9SACTIVER";
var Integrations_DisableConnector = "D\xe9sactiver le connecteur";
var Integrations_DisableProvider = "D\xe9sactiver le fournisseur";
var Integrations_DisablingConnectorWill = "La d\xe9sactivation de ce connecteur va supprimer tout le contenu de {{ providerName }} de votre instance Degreed.";
var Integrations_DisablingProviderWill = "La d\xe9sactivation de ce fournisseur aura les effets suivants\xa0:";
var Integrations_Disconnect = "D\xe9connecter";
var Integrations_Edit_Type_Completion = "Modifier le connecteur de compl\xe9tion";
var Integrations_Edit_Type_Content = "Modifier un connecteur de contenu";
var Integrations_Edit_Type_Skill = "Modifier un connecteur de comp\xe9tence";
var Integrations_Edit_Type_SkillAssessment = "Modifier un connecteur de test d’\xe9valuation de comp\xe9tences";
var Integrations_EditGoodreadsProfile = "Modifiez votre profil Goodreads en indiquant un nom d’utilisateur.";
var Integrations_EmailAssertionName = "Nom d’assertion de l’adresse e-mail";
var Integrations_Enable = "Activer";
var Integrations_EnableSSO = "Activer le SSO";
var Integrations_EnterpriseAccountId = "ID de compte entreprise";
var Integrations_EnterpriseSetMetadata = "Le contenu est accessible avec une licence entreprise";
var Integrations_EnterpriseSetup = "Entreprise";
var Integrations_EnterpriseSetupMetadata = "Le contenu est accessible avec une licence entreprise";
var Integrations_EverybodyCanSee = "Tout le monde peut le voir.";
var Integrations_FailedImport = "Une erreur est survenue lors de la configuration de votre int\xe9gration. R\xe9essayez plus tard.";
var Integrations_FallbackContentImage = "Image de contenu par d\xe9faut";
var Integrations_FilterIntegrations = "Filtrer les int\xe9grations";
var Integrations_FirstNameAssertionName = "Nom d’assertion du pr\xe9nom";
var Integrations_FreeOneClickSetup = "One-Click gratuit";
var Integrations_GenerateAPIKey = "G\xe9n\xe9rer une cl\xe9 API";
var Integrations_GenerateAPIKeyProvider = "G\xe9n\xe9rer une cl\xe9 API pour ce fournisseur";
var Integrations_GlobalVisibility = "Visibilit\xe9 globale";
var Integrations_GoodreadsImportError = "Oups ! Un probl\xe8me est survenu lors de l’importation de vos livres Goodreads. Veuillez r\xe9activer l’int\xe9gration Goodreads ci-dessus puis r\xe9essayez.";
var Integrations_GoodreadsUsername = "Nom d’utilisateur Goodreads";
var Integrations_GoodreadsUsernameEdit = "Nom d’utilisateur Goodreads (modifiez votre profil Goodreads en indiquant un nom d’utilisateur)";
var Integrations_ImageForProviderCard = "Il s’agit de l’image affich\xe9e comme carte du fournisseur.";
var Integrations_ImageForProviderFavicon = "Il s’agit de l’image affich\xe9e comme favicon du fournisseur.";
var Integrations_ImageForProviderLogo = "Il s’agit de l’image affich\xe9e comme logo du fournisseur.";
var Integrations_ImportAlisonCourses = "Importer les formations effectu\xe9es sur Alison";
var Integrations_ImportAlisonDaily = "Importer quotidiennement les formations de mon profil Alison.";
var Integrations_ImportArchivedPocket = "Importer les articles archiv\xe9s de Pocket";
var Integrations_ImportCodecademyDaily = "Importer quotidiennement les formations valid\xe9es sur Codecademy.";
var Integrations_ImportCodeSchoolDaily = "Importer quotidiennement les formations r\xe9alis\xe9es sur Code School.";
var Integrations_ImportCompletedCodecademy = "Importer mes formations suivies sur Codecademy";
var Integrations_ImportCompletedCodeSchool = "Importer les formations effectu\xe9es sur Code School";
var Integrations_ImportCompletedKhanAcademy = "Importer les vid\xe9os regard\xe9es sur Khan Academy";
var Integrations_ImportCompletedPluralsight = "Importer les formations effectu\xe9es sur Pluralsight";
var Integrations_ImportCompletedSkillshare = "Importer les formations effectu\xe9es sur Skillshare";
var Integrations_ImportCompletedTreehouse = "Importer les formations effectu\xe9es sur Treehouse";
var Integrations_ImportCompletedUdemy = "Importer les formations effectu\xe9es sur Udemy";
var Integrations_ImportCourseraCourses = "Importer les formations effectu\xe9es sur Coursera";
var Integrations_ImportCourseraDaily = "Importer quotidiennement les formations de mon profil Coursera";
var Integrations_ImportGoodreadsDaily = "Importer quotidiennement les livres marqu\xe9s comme lus sur Goodreads.";
var Integrations_ImportKhanAcademyDaily = "Importer quotidiennement les vid\xe9os regard\xe9es et les tests d’\xe9valuation effectu\xe9s sur Khan Academy";
var Integrations_ImportNow = "Importer maintenant";
var Integrations_ImportPluralsightDaily = "Importer quotidiennement les formations effectu\xe9es sur Pluralsight.";
var Integrations_ImportPocketDaily = "Importer quotidiennement les articles marqu\xe9s comme archiv\xe9s sur Pocket.";
var Integrations_ImportReadabilityDaily = "Importer quotidiennement les articles marqu\xe9s comme archiv\xe9s sur Readability.";
var Integrations_ImportReadArticlesReadability = "Importer les articles lus sur Readability";
var Integrations_ImportReadGoodreads = "Importer les livres lus sur Goodreads";
var Integrations_ImportSkillshareDaily = "Importer quotidiennement les formations de mon profil Skillshare.";
var Integrations_ImportTreehouseDaily = "Importer quotidiennement les formations effectu\xe9es sur Treehouse.";
var Integrations_ImportUdemyDaily = "Importer quotidiennement les formations de mon profil Udemy.";
var Integrations_IntegrationsDirectory = "R\xe9pertoire des int\xe9grations";
var Integrations_KhanAcademyContentFree = "Tout le contenu de Khan Academy est disponible gratuitement \xe0 l’adresse";
var Integrations_KhanAcademyImportError = "Oups ! Un probl\xe8me est survenu lors de l’importation de vos vid\xe9os Khan Academy. Veuillez r\xe9activer l’int\xe9gration Kahn Academy ci-dessus puis r\xe9essayez.";
var Integrations_KhanAcademyUsername = "Nom d’utilisateur Kahn Academy";
var Integrations_LastImported = "Derni\xe8re importation :";
var Integrations_LastNameAssertionName = "Nom d’assertion du nom de famille";
var Integrations_LastSyncDate = "Derni\xe8re synchronisation\xa0: {{ date }}";
var Integrations_LimitedVisibility = "Visibilit\xe9 limit\xe9e";
var Integrations_Linkedin = "LinkedIn";
var Integrations_Never = "Jamais";
var Integrations_Note = "Remarque :";
var Integrations_NoteForPNG = "L’image doit \xeatre un fichier PNG d’une taille de 200\xa0px de haut par 200\xa0px de large.";
var Integrations_NoteForSVG = "L’image doit \xeatre un fichier SVG vectoriel.";
var Integrations_OnlyShowIfLicense = "S’affiche uniquement si l’utilisateur dispose d’une licence.";
var Integrations_Or = "ou";
var Integrations_OrgId = "ID de l’organisation";
var Integrations_PaidOneClick = "One-Click payant";
var Integrations_PaidOneClickSetup = "Contenu public";
var Integrations_PluralsightImportError = "Oups ! Un probl\xe8me est survenu lors de l’importation de vos formations Pluralsight. Veuillez v\xe9rifier votre nom d’utilisateur.";
var Integrations_PluralsightPublicProfile = "Cette int\xe9gration exige un profil Pluralsight public avec la vignette \xab\xa0Formations valid\xe9es\xa0\xbb visible.";
var Integrations_PluralsightUsername = "Nom d’utilisateur Pluralsight";
var Integrations_PocketImportError = "Oups ! Un probl\xe8me est survenu lors de la synchronisation de Pocket. Veuillez r\xe9activer l’int\xe9gration Pocket ci-dessus puis r\xe9essayez.";
var Integrations_PocketUsername = "Nom d’utilisateur Pocket";
var Integrations_PortalId = "ID de portail";
var Integrations_PortalName = "Nom du portail";
var Integrations_PromptForLicense = "Demander une licence";
var Integrations_ProviderAssertionConsumerService = "URL du service client d’assertion (ACS) du fournisseur";
var Integrations_ProviderEntityID = "ID d’entit\xe9 du fournisseur";
var Integrations_ProviderLogo = "Logo du fournisseur";
var Integrations_ReadabilityImportError = "Oups ! Un probl\xe8me est survenu lors de l’importation de vos articles Readability. Veuillez r\xe9activer l’int\xe9gration Readability ci-dessus puis r\xe9essayez.";
var Integrations_ReadabilityUsername = "Nom d’utilisateur Readability";
var Integrations_RecommendGoogleplus = "Partager des \xe9l\xe9ments avec vos relations sur Google+.";
var Integrations_RecommendLinkedin = "Partager des \xe9l\xe9ments avec vos connexions sur LinkedIn.";
var Integrations_RecommendTwitter = "Partager des \xe9l\xe9ments avec vos abonn\xe9s sur Twitter.";
var Integrations_SaveIntegrations = "Enregistrer les int\xe9grations";
var Integrations_ShouldDisableConnector = "Voulez-vous vraiment d\xe9sactiver ce connecteur\xa0?";
var Integrations_ShouldDisableIntegration = "Voulez-vous vraiment d\xe9sactiver cette int\xe9gration\xa0?";
var Integrations_ShowConnectedOnly = "Afficher les int\xe9grations connect\xe9es uniquement";
var Integrations_SignSAMLAssertion = "Signer l’assertion SAML\xa0?";
var Integrations_SignSAMLResponse = "Signer la r\xe9ponse SAML\xa0?";
var Integrations_SkillshareImportError = "Oups ! Un probl\xe8me est survenu lors de l’importation de vos formations Skillshare.";
var Integrations_SkillshareIserId = "Identifiant utilisateur Skillshare";
var Integrations_SkillshareProfileRequired = "N\xe9cessite un profil Skillshare public.";
var Integrations_SkillshareUserName = "Nom d’utilisateur Skillshare";
var Integrations_SkillshareUserNameId = "Nom/identifiant d’utilisateur Skillshare";
var Integrations_SlackDescription = "Recevez le programme de la journ\xe9e et le contenu partag\xe9 via Slack.";
var Integrations_SlackDescriptionConsumer = "Obtenez le Programme d’aujourd’hui via Slack.";
var Integrations_SlackTodaysLearningTitle = "Avez-vous d\xe9j\xe0 vu cet \xe9l\xe9ment dans l’Apprentissage d’aujourd’hui sur Degreed\xa0?";
var Integrations_SlackTodaysLearningTitleFormat = "Apprentissage d’aujourd’hui pour {0}";
var Integrations_SocialAccounts = "Comptes de r\xe9seaux sociaux";
var Integrations_SSO_EnabledContentURL = "URL des contenus avec SSO activ\xe9";
var Integrations_SSO_IsEnabled = "Le SSO est activ\xe9 pour ce fournisseur.";
var Integrations_SuccessfullImport = "Vous avez correctement synchronis\xe9 votre compte avec Degreed.";
var Integrations_TreehouseImportError = "Oups ! Un probl\xe8me est survenu lors de l’importation de vos formations Treehouse. Veuillez v\xe9rifier votre nom d’utilisateur.";
var Integrations_TreehousePublicProfile = "Vous devez poss\xe9der un profil Treehouse public.";
var Integrations_TreehouseUsername = "Nom d’utilisateur Treehouse";
var Integrations_Twitter = "Twitter";
var Integrations_TypeDisable = "Saisissez \xab\xa0D\xc9SACTIVER\xa0\xbb";
var Integrations_TypeTerm = "Saisissez \xab\xa0{{ term }}\xa0\xbb";
var Integrations_UdemyImportError = "Oups ! Un probl\xe8me est survenu lors de l’importation de vos formations Udemy.";
var Integrations_UdemyUserId = "Identifiant utilisateur Udemy";
var Integrations_UdemyVisibleCourses = "Vous devez poss\xe9der un profil Udemy public et des formations visibles.";
var Integrations_UnableToVerify = "V\xe9rification impossible. V\xe9rifiez les informations et r\xe9essayez.";
var Integrations_UserGrantedLicense = "Les utilisateurs recevront une licence apr\xe8s avoir accept\xe9 l’invitation.";
var Integrations_UserIDAssertionName = "Nom d’assertion de l’ID d’utilisateur";
var Integrations_UserIdentifierSamlSubject = "Identifiant de l’utilisateur / Nom de sujet SAML";
var Integrations_VerifyCourseraPublicProfile = "Veuillez v\xe9rifier que votre profil Coursera est public.";
var Integrations_VerifyPublicCodecademy = "Veuillez v\xe9rifier que votre profil Codecademy est public.";
var Integrations_VerifyPublicUdemyProfile = "Veuillez v\xe9rifier que votre profil Udemy est public.";
var Integrations_VerifySkillsharePublic = "Veuillez v\xe9rifier que votre profil Skillshare est public.";
var Integrations_VerifySkillshareUserId = "Veuillez v\xe9rifier votre identifiant utilisateur Skillshare unique.";
var Integrations_VerifyUniqueCourseraUserId = "Veuillez v\xe9rifier votre identifiant utilisateur Coursera unique.";
var Integrations_VerifyUniqueUserId = "Veuillez v\xe9rifier votre identifiant utilisateur Udemy unique.";
var Integrations_ViewConnections = "Afficher les connexions";
var Integrations_ViewFollowers = "Afficher les abonn\xe9s";
var Integrations_ViewFriends = "Afficher les amis";
var IntegrationsSvc_AlisonDescription = "Importez quotidiennement tous les cours de votre profil Alison.<br><strong>Remarque\xa0:</strong> un profil Alison public est requis.";
var IntegrationsSvc_AlisonLabelText = "Nom/identifiant d’utilisateur Alison";
var IntegrationsSvc_AlisonPlaceholderText = "Nom/identifiant d’utilisateur";
var IntegrationsSvc_AlisonUrl = "http://alison.com/profile/";
var IntegrationsSvc_AutoNotifyLabelFormat = "Informez-moi automatiquement quand mon {{friendType}} rejoint Degreed.";
var IntegrationsSvc_CodecademyDescription = "Importez quotidiennement les cours termin\xe9s de Codecademy.<br><strong>Remarque\xa0:</strong> un profil Codecademy public est requis.";
var IntegrationsSvc_CodecademyLabelText = "Nom d’utilisateur Codeacademy";
var IntegrationsSvc_CodecademyPlaceholderText = "Nom d’utilisateur";
var IntegrationsSvc_CodecademyUrl = "http://www.codecademy.com/";
var IntegrationsSvc_CodeSchoolDescription = "Importer les cours complets de Code School quotidiennement.<br><strong>Remarque :</strong> N\xe9cessite un profil public de Code School.";
var IntegrationsSvc_CodeSchoolLabelText = "Nom d’utilisateur Code School";
var IntegrationsSvc_CodeSchoolPlaceholderText = "Nom d’utilisateur";
var IntegrationsSvc_CodeSchoolUrl = "https://www.codeschool.com/users/";
var IntegrationsSvc_Contacts = "Contacts";
var IntegrationsSvc_Followers = "Abonn\xe9s";
var IntegrationsSvc_Friends = "Amis";
var IntegrationsSvc_GoodreadsDescription = "Importer des livres que j’ai marqu\xe9 \xab\xa0lire\xa0\xbb dans Goodreads quotidiennement.<br><strong>Remarque :</strong> Modifiez votre profil Goodreads pour sp\xe9cifier un nom d’utilisateur.";
var IntegrationsSvc_GoodreadsLabelText = "Nom d’utilisateur Goodreads";
var IntegrationsSvc_GoodreadsPlaceholderText = "Nom d’utilisateur";
var IntegrationsSvc_GoogleplusFriends = "Contacts Google";
var IntegrationsSvc_KhanAcademyDescription = "Importez mes vid\xe9os et tests d'\xe9valuation complets de Khan Academy quotidiennement.<br><strong>Remarque :</strong> Tous les contenus Khan Academy sont disponibles gratuitement sur www.khanacademy.org";
var IntegrationsSvc_KhanAcademyLabelText = "Nom d’utilisateur Khan Academy";
var IntegrationsSvc_KhanAcademyPlaceholderText = "Nom d’utilisateur";
var IntegrationsSvc_NoFriendsDescription = "Aucun de vos {{friendType}} n’a encore adh\xe9r\xe9 \xe0 Degreed, mais nous vous informerons quand ils le feront!";
var IntegrationsSvc_NoGoogleplusFriendsHeader = "Aucun contact trouv\xe9.";
var IntegrationsSvc_PluralsightDescription = "Importez quotidiennement les cours termin\xe9s de Pluralsight.<br><strong>Remarque :</strong> cette int\xe9gration exige un profil Pluralsight public avec le titre \xab\xa0Cours termin\xe9s\xa0\xbb visible.";
var IntegrationsSvc_PluralsightLabelText = "Nom d’utilisateur Pluralsight";
var IntegrationsSvc_PluralsightPlaceholderText = "Nom d’utilisateur";
var IntegrationsSvc_PluralsightUrl = "http://app.pluralsight.com/profile/";
var IntegrationsSvc_PocketDescription = "Importer quotidiennement les articles marqu\xe9s comme archiv\xe9s sur Pocket.";
var IntegrationsSvc_PocketLabelText = "Nom d’utilisateur Pocket";
var IntegrationsSvc_PocketPlaceholderText = "Nom d’utilisateur";
var IntegrationsSvc_SkillshareDescription = "Importer quotidiennement tous les cours de mon profil Skillshare.<br><strong>Remarque</strong> : N\xe9cessite un profil Skillshare public.";
var IntegrationsSvc_SkillshareLabelText = "Nom/identifiant d’utilisateur Skillshare";
var IntegrationsSvc_SkillsharePlaceholderText = "Nom/identifiant d’utilisateur";
var IntegrationsSvc_SkillshareUrl = "https://www.skillshare.com/user/";
var IntegrationsSvc_SkillshareUrlext = "Nom/identifiant d’utilisateur Skillshare";
var IntegrationsSvc_SlackDescription = "Recevez le programme de la journ\xe9e et le contenu partag\xe9 via Slack.";
var IntegrationsSvc_TreehouseDescription = "Importez quotidiennement les cours termin\xe9s de Treehouse.<br><strong>Remarque :</strong> un profil Treehouse public est requis.";
var IntegrationsSvc_TreehouseLabelText = "Nom d’utilisateur Treehouse";
var IntegrationsSvc_TreehousePlaceholderText = "Nom d’utilisateur";
var IntegrationsSvc_TreehouseUrl = "http://www.teamtreehouse.com/";
var IntegrationsSvc_UdemyDescription = "Importez tous les cours de mon profil Udemy quotidiennement.<br><strong>Remarque :</strong> N\xe9cessite un profil public Udemy avec des cours visibles.";
var IntegrationsSvc_UdemyLabelText = "Identifiant utilisateur Udemy";
var IntegrationsSvc_UdemyPlaceholderText = "Identifiant utilisateur";
var IntegrationsSvc_UdemyUrl = "https://www.udemy.com/u/";
var IntegrationsSvc_ViewContacts = "Afficher les contacts";
var IntegrationsSvc_ViewFollowers = "Afficher les abonn\xe9s";
var IntegrationsSvc_ViewFriends = "Afficher les amis";
var InviteAddCategoriesCtrl_FollowCategoriesFormat = "Suivez {{count}} comp\xe9tences de plus";
var InviteAddCategoriesCtrl_FollowCategoryFormat = "Suivre {{count}} cat\xe9gorie suppl\xe9mentaire";
var InviteAddPeopleCtrl_FollowPersonFormat = "Suivre {{count}} personne suppl\xe9mentaire";
var InviteAddPeopleCtrl_FollowPersonsFormat = "Suivre {{count}} personnes suppl\xe9mentaires";
var KPI_AddedSkillsByOthersAverage = "Nombre moyen de comp\xe9tences ajout\xe9es pour mon poste";
var KPI_AddedSkillsByOthersAverageToolTip = "Le nombre moyen de comp\xe9tences ajout\xe9es par d’autres personnes pour votre poste.";
var KPI_AverageRating = "note moyenne";
var KPI_AvgFormat = "Moy. {{average}}";
var KPI_DaysSinceLastRating = "Nombre de jours depuis la derni\xe8re \xe9valuation";
var KPI_DaysSinceLastRatingToolTip = "Le nombre de jours qui se sont \xe9coul\xe9s depuis votre derni\xe8re \xe9valuation pour cette comp\xe9tence. Ne varie pas en fonction de la p\xe9riode s\xe9lectionn\xe9e.";
var KPI_Decrease = "Augmentation";
var KPI_Increase = "Diminution";
var KPI_JobRoleSkillCount = "Comp\xe9tences principales pour mon poste";
var KPI_JobRoleSkillCountToolTip = "Le nombre de comp\xe9tences dont vous disposez parmi les 10\xa0comp\xe9tences principales ajout\xe9es par les autres personnes qui occupent le m\xeame poste.";
var KPI_NoChange = "Aucune augmentation ou diminution";
var KPI_NoJobRoleToolTip = "Ajoutez votre poste dans les Param\xe8tres du profil pour afficher ces statistiques.";
var KPI_NotApplicableToolTip = "Il n’y a pas assez d’utilisateurs occupant votre poste pour recueillir ces statistiques.";
var KPI_OpportunityApplyName = "Clic(s) sur Postuler";
var KPI_OpportunityApplyTooltip = "{{count}}\xa0utilisateurs ont postul\xe9 pour cette opportunit\xe9 depuis le {{startDate}}.";
var KPI_OpportunityDaysOpenName = "Jours depuis la cr\xe9ation";
var KPI_OpportunityDaysOpenTooltip = "Le nombre de jours pass\xe9s depuis la cr\xe9ation de l’opportunit\xe9 (pour les opportunit\xe9s ouvertes). Le nombre de jours pendant lesquels l’opportunit\xe9 \xe9tait disponible (pour les opportunit\xe9s ferm\xe9es).";
var KPI_OpportunityInterestedName = "Int\xe9ress\xe9s";
var KPI_OpportunityInterestedTooltip = "{{count}} utilisateurs ont manifest\xe9 leur int\xe9r\xeat pour cette opportunit\xe9 depuis le {{startDate}}.";
var KPI_OpportunitySelectedName = "S\xe9lectionn\xe9s";
var KPI_OpportunitySelectedTooltip = "Le nombre total de candidats s\xe9lectionn\xe9s pour cette opportunit\xe9.";
var KPI_OpportunityUniqueViewsName = "Vues de l’opportunit\xe9";
var KPI_OpportunityUniqueViewsTooltip = "Le nombre total de vues uniques de l’opportunit\xe9.";
var KPI_OpportunityUsersName = "Utilisateurs ayant vu l’opportunit\xe9";
var KPI_OpportunityUsersTooltip = "{{count}} utilisateurs ont consult\xe9 cette opportunit\xe9 au moins une fois depuis le {{startDate}}.";
var KPI_OpportunityViewsName = "Vues";
var KPI_OpportunityViewsTooltip = "Cette opportunit\xe9 a \xe9t\xe9 consult\xe9e {{count}}\xa0fois depuis le {{ startDate }}, y compris par des utilisateurs connus.";
var KPI_OrgOpportunityActiveOpportunitiesName = "Opportunit\xe9s ouvertes";
var KPI_OrgOpportunityActiveOpportunitiesTooltip = "Le nombre total d’opportunit\xe9s ouvertes.";
var KPI_OrgOpportunityApplicantsInOpportunitiesName = "Int\xe9ress\xe9s (total)";
var KPI_OrgOpportunityApplicantsInOpportunitiesTooltip = "Le nombre total d’utilisateurs int\xe9ress\xe9s par les opportunit\xe9s disponibles.";
var KPI_OrgOpportunityOpportunitiesWithInterestName = "Nombre total d’opportunit\xe9s sauvegard\xe9es";
var KPI_OrgOpportunityOpportunitiesWithInterestTooltip = "Le nombre total d’opportunit\xe9s ouvertes sauvegard\xe9es par un ou plusieurs utilisateurs.";
var KPI_OrgOpportunityOpportunityUniqueUserViewName = "Vues d’opportunit\xe9s ouvertes";
var KPI_OrgOpportunityOpportunityUniqueUserViewTooltip = "Le nombre total de vues uniques des diff\xe9rentes opportunit\xe9s.";
var KPI_OrgOpportunitySelectedCandidatesName = "Candidats s\xe9lectionn\xe9s ces 30\xa0derniers jours";
var KPI_OrgOpportunitySelectedCandidatesTooltip = "Le nombre total de candidats s\xe9lectionn\xe9s pour des opportunit\xe9s au cours des 30\xa0derniers jours.";
var KPI_OverTheLastXDays = "au cours des {{number}}\xa0derniers jours";
var KPI_OverTheLastXYears = "au cours des {{number}}\xa0derni\xe8res ann\xe9es";
var KPI_OverTheLastYear = "au cours de l’ann\xe9e derni\xe8re";
var KPI_PathwayCompletedName = "\xc9l\xe9ments termin\xe9s par les abonn\xe9s";
var KPI_PathwayCompletedTooltip = "{{ count }}\xa0apprenants ont indiqu\xe9 avoir termin\xe9 tous les \xe9l\xe9ments depuis le {{ startDate }}.";
var KPI_PathwayEnrollName = "Abonn\xe9s";
var KPI_PathwayEnrollTooltip = "{{ count }}\xa0apprenants suivent actuellement ce parcours.";
var KPI_PathwayViewsName = "Vues des abonn\xe9s";
var KPI_PathwayViewsTooltip = "{{ count }}\xa0apprenants ont vu ce parcours au moins une fois depuis le {{ startDate }}.";
var KPI_PersonalSkillProgression_Empty = "Ajoutez des comp\xe9tences \xe0 votre profil de comp\xe9tences pour consulter cet indicateur";
var KPI_RatedSkillsByOthersAverage = "Nombre moyen de comp\xe9tences \xe9valu\xe9es pour mon poste";
var KPI_RatedSkillsByOthersAverageToolTip = "Le nombre moyen de comp\xe9tences \xe9valu\xe9es par d’autres personnes pour votre poste.";
var KPI_SkillsAdded = "Comp\xe9tences ajout\xe9es au cours des {{number}}\xa0derniers jours";
var KPI_SkillsAddedPast12 = "Comp\xe9tences ajout\xe9es cette ann\xe9e";
var KPI_SkillsAddedPast12ToolTip = "Le nombre total de comp\xe9tences ajout\xe9es au profil de l’apprenant au cours de la p\xe9riode s\xe9lectionn\xe9e.";
var KPI_SkillsAddedToolTip = "Le nombre total de comp\xe9tences ajout\xe9es au profil de l’apprenant au cours de la p\xe9riode s\xe9lectionn\xe9e.";
var KPI_SkillsRated = "Comp\xe9tences \xe9valu\xe9es au cours des {{number}}\xa0derniers jours";
var KPI_SkillsRatedPast12 = "Comp\xe9tences \xe9valu\xe9es cette ann\xe9e";
var KPI_SkillsRatedPast12ToolTip = "Le nombre total de comp\xe9tences uniques \xe9valu\xe9es au cours de la p\xe9riode s\xe9lectionn\xe9e.";
var KPI_SkillsRatedToolTip = "Le nombre total de comp\xe9tences uniques \xe9valu\xe9es au cours de la p\xe9riode s\xe9lectionn\xe9e.";
var KPI_TargetFollowersName = "Abonn\xe9s";
var KPI_TargetFollowersTooltip = "Nombre d’utilisateurs actuellement abonn\xe9s au plan";
var KPI_TargetViewsName = "Vues des abonn\xe9s";
var KPI_TargetViewsTooltip = "{{count}}\xa0apprenants ont vu ce plan au moins une fois depuis le {{ startDate }}.";
var LearnerHome_ActivityFrom = "Activit\xe9s des";
var LearnerHome_ActivityIn = "Activit\xe9s pour";
var LearnerHome_BasedOnYourSkills = "D’apr\xe8s vos comp\xe9tences";
var LearnerHome_ConnectDesc = "Communiquez avec des apprenants ayant les m\xeames objectifs et avec des mentors pr\xeats \xe0 vous accompagner tout au long de votre parcours de formation.";
var LearnerHome_ConnectLearners = "Communiquer avec des apprenants";
var LearnerHome_ConnectLearnersDesc = "Communiquez et r\xe9seautez avec des apprenants ayant les m\xeames objectifs de formation.";
var LearnerHome_ConnectMentors = "Communiquer avec des mentors";
var LearnerHome_ConnectMentorsDesc = "Communiquez avec des mentors pr\xeats \xe0 vous guider et \xe0 vous accompagner tout au long de votre parcours de formation.";
var LearnerHome_ConnectWithPeopleTitle = "R\xe9seau";
var LearnerHome_ContinueLearning = "Continuer de me former";
var LearnerHome_FindMentors = "Trouver des mentors";
var LearnerHome_GroupViewMoreLink = "Acc\xe9der au groupe";
var LearnerHome_GroupViewMoreTitle = "Vous souhaitez voir plus d’activit\xe9s\xa0?";
var LearnerHome_ItemsCompleted = "\xc9l\xe9ments termin\xe9s";
var LearnerHome_ItemsCompletedDesc = "Contenu de formation que vous avez termin\xe9 sur Degreed ce mois-ci.";
var LearnerHome_ItemsDelta = "+{{count}}\xa0\xe9l\xe9ment(s) ce mois-ci";
var LearnerHome_ItemsViewed = "\xc9l\xe9ments consult\xe9s";
var LearnerHome_ItemsViewedDesc = "Contenu de formation que vous avez consult\xe9 sur Degreed ce mois-ci.";
var LearnerHome_LearningBudget = "Budget de formation";
var LearnerHome_LearningDelta = "+{{count}}\xa0minute(s) ce mois-ci";
var LearnerHome_LearningTime = "Temps de formation";
var LearnerHome_LearningTimeDesc = "Temps que vous avez pass\xe9 sur Degreed ce mois-ci.";
var LearnerHome_MentorConnect = "Communiquer avec un mentor";
var LearnerHome_MentorshipExpertise = "Expertise du mentor";
var LearnerHome_NoChanges = "Pas de changements sur un mois";
var LearnerHome_OpportunitiesViewMoreLink = "Plus d’opportunit\xe9s";
var LearnerHome_OpportunityViewMoreLink = "Afficher toutes les opportunit\xe9s pertinentes";
var LearnerHome_OpportunityViewMoreTitle = "Vous recherchez des opportunit\xe9s suppl\xe9mentaires\xa0?";
var LearnerHome_PeopleToFollow = "Personnes \xe0 suivre";
var LearnerHome_PeopleYouFollow = "Personnes que vous suivez";
var LearnerHome_PointsDelta = "+{{count}}\xa0point(s) ce mois-ci";
var LearnerHome_PointsEarned = "Points gagn\xe9s";
var LearnerHome_PointsEarnedDesc = "Points que vous avez gagn\xe9s sur Degreed ce mois-ci.";
var LearnerHome_RecentActivity = "Activit\xe9s r\xe9centes";
var LearnerHome_RecentlyViewed = "Contenu r\xe9cemment consult\xe9";
var LearnerHome_RequestMentorship = "Envoyer une demande de mentorat";
var LearnerHome_SearchPeople = "Rechercher des personnes";
var LearnerHome_SkillExplore = "Comp\xe9tence \xe0 d\xe9couvrir";
var LearnerHome_SkillsToFollow = "Comp\xe9tences \xe0 suivre";
var LearnerHome_TrendingAtOrgSubtitle = "Learning content trending within your organization.";
var LearnerHome_TrendingAtOrgTitle = "Trending at {{orgName}}";
var LearnerHome_TrendingWithin = "Tendances chez";
var LearnerHome_UseYourBudget = "Utiliser votre budget";
var LearnerHome_ViewMoreLink = "Rechercher plus d’infos sur {{term}}";
var LearnerHome_ViewMoreMentorsLink = "D\xe9couvrir d’autres mentors";
var LearnerHome_ViewMoreTitle = "Vous n’avez pas trouv\xe9 ce que vous recherchez \xa0?";
var LearnerHome_ViewMoreUserLink = "Rechercher d’autres personnes \xe0 suivre";
var LearnerHome_ViewMoreUserTitle = "Vous ne trouvez pas la personne que vous recherchez \xa0?";
var LearnerHome_ViewYourBalance = "Afficher votre solde";
var LearnerHome_WelcomeSectionSubTitle = "Bienvenue dans votre espace apprenant personnalis\xe9 sur Degreed.";
var LearnerHome_WelcomeSectionSubTitleShort = "Bienvenue dans votre espace apprenant personnalis\xe9.";
var LearnerHome_WelcomeSectionTitle = "Bonjour, {{firstName}}";
var LearningBrowse_FeaturedContent = "Contenus \xe0 la une";
var LearningBrowse_FeaturedCourseProviders = "Fournisseurs \xe0 la une";
var LearningBrowse_FeaturedPathways = "Parcours \xe0 la une";
var LearningBrowse_FeaturedTargets = "\xc0 la une";
var LearningBrowse_NewContent = "Nouveaux contenus";
var LearningBrowse_SuggestedGroups = "Suggestion de groupes \xe0 rejoindre";
var LearningBrowse_SuggestedJobRoles = "Suggestions de plans \xe0 suivre";
var LearningBrowse_SuggestedOpportunities = "Opportunit\xe9s sugg\xe9r\xe9es";
var LearningBrowse_SuggestedPeopleToFollow = "Personnes \xe0 suivre recommand\xe9es";
var LearningController_ActiveSubscription = "Indique un abonnement actif";
var LearningController_All = "Tout";
var LearningController_Content = "Contenu";
var LearningController_FeaturedContent = "Contenu \xe0 la une";
var LearningController_FeaturedCourseProviders = "Fournisseurs de cours \xe0 la une";
var LearningController_FeaturedPathways = "Parcours \xe0 la une";
var LearningController_FindSomething = "Recherchez un th\xe8me d’apprentissage";
var LearningController_More = "Plus";
var LearningController_NoCategories = "Aucune cat\xe9gorie sp\xe9cifi\xe9e";
var LearningController_Pathways = "Parcours";
var LearningController_People = "Personnes";
var LearningController_QA = "Questions-r\xe9ponses";
var LearningController_RefineResults = "Affiner les r\xe9sultats";
var LearningController_SuggestedPeopleToFollow = "Personnes \xe0 suivre recommand\xe9es";
var LearningController_Top = "Populaires";
var LearningController_TopCategories = "Cat\xe9gories principales";
var LearningController_Type = "Type";
var LearningController_ViewAll = "Tout afficher";
var LearningController_VisitSite = "Visiter le site {{Name}}";
var LearningController_YourTopCategories = "Vos cat\xe9gories principales";
var LearningCtrl_ActiveSubscription = "Abonnement actif";
var LearningCtrl_DefaultSearchTerm = "\xc9ducation";
var LearningCtrl_SearchError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration des r\xe9sultats d’apprentissage.";
var LearningCtrl_Subscription = "Abonnement";
var LearningSearch_ActiveSubscription = "Abonnement actif";
var LearningSearch_BackToSearch = "Retour \xe0 la recherche";
var LearningSearch_Careers = "Carri\xe8res";
var LearningSearch_Clear = "Supprimer";
var LearningSearch_ClearFilters = "Effacer les filtres";
var LearningSearch_ClosedGroup = "Groupe ferm\xe9";
var LearningSearch_CompletedAllFormat = "F\xe9licitations\xa0! Vous avez termin\xe9 tous les {{inputType}} correspondants dans ce catalogue pour le moment. Essayez un autre type de contenu\xa0!";
var LearningSearch_Content = "Contenu";
var LearningSearch_DefaultSearchTerm = "\xc9ducation";
var LearningSearch_DidYouMean = "Voulez-vous dire {{suggestedTermHtml}}\xa0?";
var LearningSearch_Directories = "Pages";
var LearningSearch_ErrorContactSupport = "Si le probl\xe8me persiste, veuillez {{hrefStart}}contacter l’assistance{{hrefEnd}}.";
var LearningSearch_ErrorDescription = "Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration des r\xe9sultats. Veuillez recharger ou actualiser cette page pour r\xe9essayer.";
var LearningSearch_ErrorTitle = "Oups, une erreur s’est produite.";
var LearningSearch_ErrorTitleSideBar = "Oups, une erreur s’est produite. Veuillez recharger ou actualiser cette page pour r\xe9essayer.";
var LearningSearch_FilterApplied = "1 filtre appliqu\xe9";
var LearningSearch_FiltersApplied = "{{count}} filtres appliqu\xe9s";
var LearningSearch_GoToMarketplace = "Acc\xe9der \xe0 la marketplace";
var LearningSearch_GoToSearch = "Acc\xe9der \xe0 la page de recherche";
var LearningSearch_Groups = "Groupes";
var LearningSearch_GroupsLandingSearchInput = "Groupes pour\xa0:";
var LearningSearch_Hmm = "Hmm.";
var LearningSearch_JobRoles = "Plans";
var LearningSearch_Learning = "Formation";
var LearningSearch_LoadMoreEndorsed = "Afficher plus de contenu recommand\xe9";
var LearningSearch_LookingFor = "Je cherche...";
var LearningSearch_More = "plus";
var LearningSearch_MoreFilters = "Plus de filtres";
var LearningSearch_MoreFormat = "{{count}} {{itemname}}\xa0de plus";
var LearningSearch_MostPopular = "Popularit\xe9";
var LearningSearch_MostRecent = "Le plus r\xe9cent";
var LearningSearch_MostRelevant = "Pertinence";
var LearningSearch_NoResultsFound = "Nous n’avons trouv\xe9 aucun r\xe9sultat pour {{termHtml}}.";
var LearningSearch_NoResultsFoundAdvice = "V\xe9rifiez l’orthographe ou essayez de rechercher un autre terme.";
var LearningSearch_NoResultsFoundMsg = "Nous n’avons trouv\xe9 aucun r\xe9sultat pour \xab\xa0{{ searchTerm }}\xa0\xbb.";
var LearningSearch_NoResultsFoundTitle = "R\xe9sultat introuvable";
var LearningSearch_NoSidebarFormat = "Aucun r\xe9sultat relatif aux {{type}} trouv\xe9.";
var LearningSearch_OpenGroup = "Groupe ouvert";
var LearningSearch_OpportunitiesTitle = "Opportunit\xe9s";
var LearningSearch_OppsLandingSearchInput = "Opportunit\xe9s pour\xa0:";
var LearningSearch_OppsSidebarTooltip = "{{matches}}\xa0comp\xe9tences sur {{totalSkills}}";
var LearningSearch_Pathways = "Parcours";
var LearningSearch_PathwaysAndPlans = "Parcours et plans";
var LearningSearch_People = "Personnes";
var LearningSearch_PeopleAndGroups = "Personnes et groupes";
var LearningSearch_PeopleLandingSearchInput = "Personnes pour\xa0:";
var LearningSearch_Popular = "Popularit\xe9";
var LearningSearch_ProviderNoResultsFoundAdvice = "Demandez \xe0 l’administrateur du site Degreed de l’ajouter.";
var LearningSearch_ProviderNotPartOfCatalog = "\xab\xa0{{providerName}}\xa0\xbb ne fait pas partie de votre catalogue.";
var LearningSearch_QA = "Questions-r\xe9ponses";
var LearningSearch_RangeCount = "{{ rangeStart }}-{{ rangeEnd }} sur {{ totalNumResults }}";
var LearningSearch_RangeCountPlus = "{{ rangeStart }}-{{ rangeEnd }} sur >\xa0{{ totalNumResults }}";
var LearningSearch_Recent = "Le plus r\xe9cent";
var LearningSearch_Relevant = "Pertinence";
var LearningSearch_RemoveFiltersAdvice = "Essayez de supprimer certains de vos filtres.";
var LearningSearch_ResetFiltersAdvice = "Essayez de r\xe9initialiser vos filtres ou de mettre \xe0 jour votre langue pr\xe9f\xe9r\xe9e par d\xe9faut dans les param\xe8tres.";
var LearningSearch_ResetFiltersMsg = "Essayez de r\xe9initialiser vos filtres ou de mettre \xe0 jour votre langue pr\xe9f\xe9r\xe9e par d\xe9faut dans les param\xe8tres.";
var LearningSearch_ResultsCount = "{{count}} r\xe9sultats";
var LearningSearch_ResultsCount_PluralFormat = "{{count}} r\xe9sultats";
var LearningSearch_ResultsCount_SingleFormat = "{{count}} r\xe9sultat";
var LearningSearch_ResultSetRangeCount = "R\xe9sultats {{ rangeStart }}-{{ rangeEnd }} sur {{ totalNumResults }}";
var LearningSearch_ResultSetRangeCountPlus = "R\xe9sultats {{ rangeStart }}-{{ rangeEnd }} sur >\xa0{{ totalNumResults }}";
var LearningSearch_ResultsFor = "R\xe9sultats pour \xab\xa0{{searchTerm}}\xa0\xbb";
var LearningSearch_Roles = "R\xf4les";
var LearningSearch_SearchedInsteadFor = "Recherche effectu\xe9e pour le terme {{suggestedTermHtml}}";
var LearningSearch_SearchError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration des r\xe9sultats d’apprentissage.";
var LearningSearch_SearchFilters = "Filtres de recherche";
var LearningSearch_SearchFiltersDescription = "Cochez une ou plusieurs des cases ci-dessous pour mettre \xe0 jour le contenu.";
var LearningSearch_ShowFilters = "Afficher les filtres";
var LearningSearch_ShowingResultsFor = "Affichage des r\xe9sultats pour {{termHtml}}";
var LearningSearch_Skills = "Comp\xe9tences";
var LearningSearch_SkillsLandingSearchInput = "Comp\xe9tences en\xa0:";
var LearningSearch_SkillsResults = "R\xe9sultats des comp\xe9tences pour";
var LearningSearch_Subscription = "Abonnement";
var LearningSearch_SuggestedSearches = "Comp\xe9tences connexes";
var LearningSearch_Title = "Rechercher";
var LearningSearch_Top = "Populaires";
var LearningSearch_Trending = "Tendances";
var LearningSearch_ViewAll = "Tout afficher";
var LearningSearch_ViewMore = "Afficher plus";
var likeComment_PluralFormat = "{{nameHtml}} et {{number}} autres ont aim\xe9 votre commentaire";
var likeComment_PluralGroupFormat = "{{nameHtml}} et {{number}} autres ont aim\xe9 votre commentaire dans {{groupNameHtml}}";
var likeComment_SingleFormat = "{{nameHtml}} a aim\xe9 votre commentaire";
var likeComment_SingleGroupFormat = "{{nameHtml}} a aim\xe9 votre commentaire dans {{groupNameHtml}}";
var likeGroupActivity_GoalAddedPluralFormat = "{{nameHtml}} et {{number}} autres ont aim\xe9 votre nouvel objectif \xab\xa0{{goalHtml}}\xa0\xbb dans {{groupNameHtml}}";
var likeGroupActivity_GoalAddedSingleFormat = "{{nameHtml}} a aim\xe9 votre nouvel objectif \xab\xa0{{goalHtml}}\xa0\xbb dans {{groupNameHtml}}";
var likeGroupActivity_GoalRemovedPluralFormat = "{{nameHtml}} et {{number}} autres ont aim\xe9 votre objectif supprim\xe9 \xab\xa0{{goalHtml}}\xa0\xbb dans {{groupNameHtml}}";
var likeGroupActivity_GoalRemovedSingleFormat = "{{nameHtml}} a aim\xe9 votre objectif supprim\xe9 \xab\xa0{{goalHtml}}\xa0\xbb dans {{groupNameHtml}}";
var likeGroupActivity_GoalUpdatedPluralFormat = "{{nameHtml}} et {{number}} autres ont aim\xe9 votre objectif mis \xe0 jour \xab\xa0{{goalHtml}}\xa0\xbb dans {{groupNameHtml}}";
var likeGroupActivity_GoalUpdatedSingleFormat = "{{nameHtml}} a aim\xe9 votre objectif mis \xe0 jour \xab\xa0{{goalHtml}}\xa0\xbb dans {{groupNameHtml}}";
var likeGroupActivity_GroupAddedPluralFormat = "{{nameHtml}} et {{number}} autres ont aim\xe9 votre nouveau groupe \xab\xa0{{groupNameHtml}}\xa0\xbb";
var likeGroupActivity_GroupAddedSingleFormat = "{{nameHtml}} a aim\xe9 votre nouveau groupe \xab\xa0{{groupNameHtml}}\xa0\xbb";
var likeGroupActivity_GroupPostPluralFormat = "{{nameHtml}} et {{number}} autres ont aim\xe9 votre publication dans {{groupNameHtml}}";
var likeGroupActivity_GroupPostSingleFormat = "{{nameHtml}} a aim\xe9 votre publication dans {{groupNameHtml}}";
var likeGroupActivity_GroupUpdatedPluralFormat = "{{nameHtml}} et {{number}} autres ont aim\xe9 votre mise \xe0 jour de groupe dans {{groupNameHtml}}";
var likeGroupActivity_GroupUpdatedSingleFormat = "{{nameHtml}} a aim\xe9 votre mise \xe0 jour de groupe dans {{groupNameHtml}}";
var likeGroupActivity_InputRecommendedSingleFormat = "{{nameHtml}} a aim\xe9 votre partage de \xab\xa0{{inputTitleHtml}}\xa0\xbb dans {{groupNameHtml}}";
var likeGroupActivity_UserAddedPluralFormat = "{{nameHtml}} et {{number}} autres ont aim\xe9 votre ajout de {{user}} au {{groupNameHtml}}";
var likeGroupActivity_UserAddedSingleFormat = "{{nameHtml}} a aim\xe9 votre ajout de {{user}} au {{groupNameHtml}}";
var likeGroupActivity_UserInputPluralFormat = "{{nameHtml}} et {{number}} autres ont aim\xe9 votre {{inputType}} {{inputTitleHtml}} dans {{groupNameHtml}}";
var likeGroupActivity_UserInputSingleFormat = "{{nameHtml}} a aim\xe9 votre {{inputType}} {{inputTitleHtml}} in {{groupNameHtml}}";
var LiveEvents_Hybrid = "Hybride";
var LiveEvents_JoinSession = "Se joindre \xe0 la session";
var LiveEvents_RegisteredCheckboxLabel = "Je me suis inscrit \xe0 cet {{inputType}}";
var LiveEvents_RegisteredCheckboxTooltip = "S\xe9lectionnez cette option pour que {{inputType}} s’affiche sur votre page Enregistr\xe9.";
var LiveEvents_RegisteredLabel = "J’ai d\xe9j\xe0 soumis mon inscription \xe0 cette session";
var LiveEvents_RegisterOnWebsiteFormat = "Inscrivez-vous sur le site {{ name }}";
var LiveEvents_RegistrationInstructions = "Choisissez une session et inscrivez-vous sur le site {{name}}";
var LiveEvents_SessionsCardLabel = "Sessions en direct ({{count}})";
var loginForm_EmailLabel = "Quel est votre adresse e-mail ou nom d’utilisateur\xa0?";
var loginForm_EmailStateTooltip = "Sur la page suivante, vous pourrez entrer ou r\xe9initialiser votre mot de passe.";
var loginForm_InvalidEmail = "Veuillez saisir votre nom d’utilisateur ou adresse e-mail";
var loginForm_LoggingInAs = "Connexion en tant que {{startBold}}{{email}}{{endBold}}";
var loginForm_NoAccount = "Impossible de trouver ce compte. Si vous utilisez Degreed avec votre entreprise, contactez votre administrateur.";
var loginForm_NoAccountCTA = "Pas encore de compte ?";
var loginForm_PasswordHelper = "Mot de passe. Les mots de passe doivent comprendre au minimum 8\xa0caract\xe8res, dont un chiffre et une lettre.";
var loginForm_PasswordLabel = "Maintenant, entrez votre mot de passe";
var loginForm_PasswordPlaceholder = "Mot de passe";
var loginForm_PasswordPromptNoSSO = "Si l’authentification unique n’est pas accessible pour le moment, connectez-vous avec votre mot de passe.";
var loginForm_SignUpNow = "Inscrivez-vous maintenant";
var loginForm_SsoMessage = "Bonne nouvelle! {{orgName}} utilise l’authentification unique (SSO) pour se connecter \xe0 Degreed. Cliquez sur Continuer pour poursuivre.";
var loginForm_WelcomeBackTitle = "Heureux de vous revoir.";
var loginForm_WelcomeTitle = "Bienvenue.";
var Markdown_ContentLength = "Le contenu d\xe9passe la limite de caract\xe8res.";
var Markdown_EditorHelperFormat = "Images prises en charge\xa0: {{supportedFiletypes}} (jusqu’\xe0 {{filesizeLimit}}).";
var Markdown_MarkdownLearnMore = "En savoir plus";
var Markdown_MarkdownSupported = "Seules certaines fonctionnalit\xe9s Markdown sont prises en charge.";
var Markdown_toolbarA11y_addImage = "Joindre une image";
var Markdown_toolbarA11y_bold = "Ajouter du texte en gras";
var Markdown_toolbarA11y_italic = "Ajouter du texte en italique";
var Markdown_toolbarA11y_link = "Ajouter un lien";
var Markdown_toolbarA11y_ol = "Ajouter une liste num\xe9rot\xe9e";
var Markdown_toolbarA11y_quote = "Ins\xe9rer du texte entre guillemets";
var Markdown_toolbarA11y_ul = "Ajouter une liste \xe0 puces";
var Markdown_UploadErrorMessage = "D\xe9sol\xe9s ! Un probl\xe8me est survenu lors du t\xe9l\xe9chargement";
var MediaFormCtrl_AddArticle = "Ajouter un article";
var MediaFormCtrl_AddedArticleSuccessFormat = "Excellent travail en lisant {{title}} !";
var MediaFormCtrl_AddGroups = "Ajouter des groupes";
var MediaFormCtrl_AddingGroupsInfo = "Ajoutez des groupes pour aider les utilisateurs \xe0 trouver le contenu li\xe9 aux groupes auxquels ils appartiennent.";
var MediaFormCtrl_AddPost = "Ajouter une publication";
var MediaFormCtrl_AddToCatalogFormat = "Ajoutez cet article au catalogue {{orgName}}";
var MediaFormCtrl_AddVideo = "Ajouter une vid\xe9o";
var MediaFormCtrl_AddVideoToCatalogFormat = "Ajoutez cette vid\xe9o au catalogue {{orgName}}";
var MediaFormCtrl_ArticleUrl = "URL de l’article";
var MediaFormCtrl_Category = "Veuillez ajouter au moins une cat\xe9gorie.";
var MediaFormCtrl_EditArticle = "Modifier l’article";
var MediaFormCtrl_EditPost = "Modifier la publication";
var MediaFormCtrl_EditVideo = "Modifier la vid\xe9o";
var MediaFormCtrl_ErrorUnaccessibleArticle = "(impossible d’obtenir les d\xe9tails de cet article; il est possible qu’il ne soit pas accessible publiquement)";
var MediaFormCtrl_ErrorUnaccessiblePost = "(impossible d’obtenir les d\xe9tails de cette publication\xa0; il est possible qu’elle ne soit pas accessible publiquement)";
var MediaFormCtrl_ErrorUnaccessibleVideo = "(impossible d’obtenir les d\xe9tails de cette vid\xe9o; il est possible qu’elle ne soit pas accessible publiquement)";
var MediaFormCtrl_ICreatedVideo = "Je suis l’auteur du contenu de cette vid\xe9o";
var MediaFormCtrl_IWroteArticle = "Je suis l’auteur de cet article";
var MediaFormCtrl_IWrotePost = "J’ai r\xe9dig\xe9 cette publication";
var MediaFormCtrl_NarratorFormat = "Rapport\xe9 par {{name}}";
var MediaFormCtrl_NewContentOwner = "Veuillez renseigner un propri\xe9taire de contenu valide.";
var MediaFormCtrl_Provider = "Fournisseur";
var MediaFormCtrl_SaveArticle = "Enregistrer l’article";
var MediaFormCtrl_SavePost = "Enregistrer la publication";
var MediaFormCtrl_SaveVideo = "Enregistrer la vid\xe9o";
var MediaFormCtrl_SelectionRequired = "Une s\xe9lection est requise.";
var MediaFormCtrl_Skills_Placeholder = "Recherchez des comp\xe9tences ou s\xe9lectionnez-en parmi les suggestions ci-dessous.";
var MediaFormCtrl_Summary = "R\xe9sum\xe9";
var MediaFormCtrl_Title = "Titre";
var MediaFormCtrl_Title_Placeholder = "Ajoutez un titre";
var MediaFormCtrl_TitleRequired = "L’intitul\xe9 doit \xeatre renseign\xe9.";
var MediaFormCtrl_UrlError = "Cette URL n’est pas accessible publiquement et ne peut donc pas \xeatre ajout\xe9e \xe0 votre biblioth\xe8que publique.";
var MediaFormCtrl_UrlOrRecordingRequired = "Vous devez fournir une URL ou un enregistrement vid\xe9o valide.";
var MediaFormCtrl_UrlOrUploadRequired = "Une URL valide est requise ou un article doit \xeatre charg\xe9.";
var MediaFormCtrl_UrlOrVideoUploadOrRecordingRequired = "Vous devez fournir une URL, un enregistrement vid\xe9o ou une importation vid\xe9o valide.";
var MediaFormCtrl_UrlOrVideoUploadRequired = "Vous devez fournir une URL ou une importation vid\xe9o valide.";
var MediaFormCtrl_UrlRequired = "Une URL valide est requise.";
var MediaFormCtrl_ValidContentOwnerRequired = "Veuillez renseigner un propri\xe9taire de contenu valide.";
var MediaFormCtrl_ValidNumberLength = "La dur\xe9e doit \xeatre un nombre valide et raisonnable ou ne pas \xeatre indiqu\xe9e.";
var MediaFormCtrl_VideoLength = "Dur\xe9e de la vid\xe9o (en minutes)";
var MediaFormCtrl_VideoSuccessFormat = "Excellent travail en regardant {{title}} !";
var MediaFormCtrl_VideoUrl = "URL de la vid\xe9o";
var MediaFormCtrl_WhatDidYouLearnLong = "Qu’avez-vous appris gr\xe2ce \xe0 cet article\xa0?";
var MediaFormCtrl_WhatDidYouLearnShort = "Qu’avez-vous appris\xa0?";
var MediaFormCtrl_WhatDidYouLearnVideoLong = "Qu’avez-vous appris gr\xe2ce \xe0 cette vid\xe9o\xa0?";
var mentionInComment_GroupPluralFormat = "{{nameHtml}} et {{number}} autres vous ont mentionn\xe9 dans {{groupNameHtml}}";
var mentionInComment_GroupSingleFormat = "{{nameHtml}} vous a mentionn\xe9 dans {{groupNameHtml}}";
var mentionInComment_PluralFormat = "{{nameHtml}} et {{number}} autres vous ont mentionn\xe9";
var mentionInComment_SingleFormat = "{{nameHtml}} vous a mentionn\xe9";
var Mentoring_FeedbackGiven = "Commentaire fourni";
var Mentoring_FeedbackReceived = "Commentaire re\xe7u";
var Mentoring_GiveFeedback = "Fournir un commentaire";
var Mentoring_GiveFeedback_FeedbackShared = "Commentaire partag\xe9.";
var Mentoring_GiveFeedback_MenteeActionButton = "Ajouter un commentaire";
var Mentoring_GiveFeedback_MenteeSubNote = "Fournissez \xe0 votre mentor\xe9 un commentaire sur votre exp\xe9rience.";
var Mentoring_GiveFeedback_MentorSubNote = "Fournissez \xe0 votre mentor un commentaire sur le mentorat.";
var Mentoring_PeerRating = "\xc9valuation par un pair";
var Mentoring_PeerRating_MenteeSubNote = "Demandez \xe0 votre mentor\xe9 d’\xe9valuer certaines comp\xe9tences";
var Mentoring_PeerRating_MentorSubNote = "Demandez \xe0 votre mentor d’\xe9valuer certaines comp\xe9tences.";
var Mentoring_PeerRating_Requested = "\xc9valuation par un pair demand\xe9e.";
var Mentoring_PeerRatingRequest = "Demande d’\xe9valuation par un pair";
var Mentoring_PeerRatingRequest_Placeholder = "Ajoutez un message \xe0 votre demande...";
var Mentoring_PlaceholderShareMessage = "Envoyez un message avec vos commentaires...";
var Mentoring_RequestFeedback = "Demander un commentaire";
var Mentoring_RequestFeedback_MenteeSubNote = "Demandez un commentaire \xe0 votre mentor\xe9.";
var Mentoring_RequestFeedback_MentorSubNote = "Demandez un commentaire \xe0 votre mentor.";
var Mentoring_RequestFeedback_Requested = "Commentaire demand\xe9.";
var Mentoring_ReviewMenteeship = "\xc9valuer le mentorat en tant que mentor\xe9";
var Mentoring_ReviewMentorship = "\xc9valuer le mentorat en tant que mentor";
var Mentoring_ShareFeedback = "Partager les commentaires";
var MentorshipAcceptedRequest_NotificationTitleFormat = "{{mentorshipMentor}} a accept\xe9 votre demande de mentorat.";
var MentorshipCompleted_NotificationTitleFormat = "Votre mentorat avec {{mentorshipUser}} est termin\xe9.";
var MentorshipDeclinedRequest_NotificationTitleFormat = "{{mentorshipMentor}} a refus\xe9 votre demande de mentorat.";
var MentorshipFeedbackReceived_NotificationTitleFormat = "{{nameHtml}} a envoy\xe9 des commentaires concernant votre nouvelle connexion de mentorat.";
var MentorshipFeedbackRequest_NotificationTitleFormat = "{{mentorshipUser}} a demand\xe9 des commentaires concernant votre mentorat.";
var MentorshipNewRequest_NotificationTitleFormat = "{{mentorshipMentee}} vous a demand\xe9 d’\xeatre son mentor.";
var ModalSvc_AreYouSure = "Souhaitez-vous r\xe9ellement fermer cet \xe9l\xe9ment ?";
var MsTeams_AboutAppTitle = "L’apprentissage ne peut que servir les \xe9quipes.";
var MsTeams_AccountNotAssociated = "Cet utilisateur n’est associ\xe9 \xe0 aucun compte Degreed. Veuillez acc\xe9der \xe0 l’application Degreed depuis Microsoft Teams en utilisant un navigateur web, puis actualisez cette page.";
var MsTeams_AddToCalendarButton = "Ajouter au calendrier";
var MsTeams_AddToCalendarSuccess = "Ajout\xe9 \xe0 votre calendrier MS\xa0Teams";
var MsTeams_AddToCalendarTitle = "Ajouter ceci \xe0 votre calendrier MS\xa0Teams";
var MsTeams_BotCapabilitiesTitle = "Voici quelques-unes des fonctions que le bot Degreed peut accomplir";
var MsTeams_ChatErrorResponse = "Je n’ai pas compris votre demande. Tapez \xab\xa0Aide\xa0\xbb pour voir ce que je peux faire pour vous.";
var MsTeams_CommandsTitle = "Voici les commandes que vous pouvez utiliser avec cette application";
var MsTeams_DegreedBotDescription = "Ce rappel de Degreed vous invite \xe0 apprendre, partager et collaborer avec vos coll\xe8gues.";
var MsTeams_DegreedBotLongDescription = "Degreed est une plateforme de formation utilis\xe9e par des centaines de soci\xe9t\xe9s et leurs millions de collaborateurs partout dans le monde pour d\xe9velopper leurs comp\xe9tences actuelles et futures. En combinant la formation autodirig\xe9e, le d\xe9veloppement des comp\xe9tences, l’acc\xe8s \xe0 la formation et le recueil de donn\xe9es, Degreed aide votre organisation \xe0 s’adapter plus rapidement et \xe0 faire progresser davantage ses collaborateurs. L’application Degreed vous permet de d\xe9couvrir des contenus de formation, de d\xe9velopper des comp\xe9tences et de relever de nouveaux d\xe9fis professionnels.\n\nUn compte actif Degreed est n\xe9cessaire pour utiliser cette application. Si vous n’avez pas de compte, veuillez nous contacter \xe0 l’adresse https://degreed.zendesk.com/hc, et nous vous aiderons \xe0 en configurer un pour votre organisation.";
var MsTeams_DegreedBotShortDescription = "L’application Microsoft\xa0Teams de Degreed vous donne acc\xe8s aux contenus de formation, aux comp\xe9tences et aux opportunit\xe9s de carri\xe8re Degreed, afin de vous aider \xe0 relever vos prochains d\xe9fis professionnels, n’importe o\xf9, \xe0 n’importe quel moment.";
var MsTeams_DegreedLongDescription = "Degreed vous apporte tout ce dont vous avez besoin pour d\xe9velopper les comp\xe9tences qui vous permettront d’\xe9voluer. Gr\xe2ce \xe0 l’application Microsoft\xa0Teams de Degreed, vous pouvez rapidement r\xe9inventer vos comp\xe9tences existantes et en d\xe9velopper de nouvelles, sans que cela g\xeane votre travail. Ainsi, vous serez en mesure de r\xe9pondre aux nouvelles opportunit\xe9s professionnelles qui se pr\xe9sentent \xe0 vous.";
var MsTeams_DegreedShortDescription = "L’application Microsoft\xa0Teams de Degreed vous donne acc\xe8s aux contenus de formation, aux comp\xe9tences et aux opportunit\xe9s de carri\xe8re Degreed, afin de vous aider \xe0 relever vos prochains d\xe9fis professionnels, n’importe o\xf9, \xe0 n’importe quel moment.";
var MsTeams_FeaturedPageDescription = "Continuez \xe0 vous former avec du contenu s\xe9lectionn\xe9 par votre organisation\xa0!";
var MsTeams_FeaturedPageLink = "Page \xc0 la une";
var MsTeams_FeaturedPageTitle = "Page \xc0 la une";
var MsTeams_HelpDescription = "Affichez la liste des commandes disponibles";
var MsTeams_InstallationSuccess = "F\xe9licitations\xa0! Vous avez install\xe9 l’application Microsoft Teams de Degreed.";
var MsTeams_InstallationSuccessTitle = "Gr\xe2ce \xe0 Degreed, vous pouvez apprendre, partager et collaborer avec vos coll\xe8gues. Notez qu’un compte Degreed est requis pour acc\xe9der \xe0 l’application. Veuillez contacter notre \xe9quipe du service client\xe8le, \xe0 support@degreed.com, pour toute aide suppl\xe9mentaire.";
var MsTeams_LeavingAppMessaging = "Vous \xeates sur le point de quitter l’application Degreed pour Teams. Voulez-vous vraiment continuer\xa0?";
var MsTeams_LoginWithDegreedBtn = "Se connecter \xe0 Degreed";
var MsTeams_NoDegreedAccount = "Nous sommes d\xe9sol\xe9s, votre compte n’a pas \xe9t\xe9 configur\xe9 avec l’application Degreed. Veuillez contacter votre administrateur ou l’\xe9quipe d’assistance Degreed pour obtenir de l’aide.";
var MsTeams_NoDegreedAccountSubtitle = "Oups\xa0! Nous avons rencontr\xe9s un probl\xe8me.";
var MsTeams_NoNotifications = "Vous n’avez aucune notification pour l’instant. Revenez un peu plus tard.";
var MsTeams_NotificationAssignedDescription = "Envoyer des notifications lorsque des contenus vous sont assign\xe9s";
var MsTeams_NotificationOpportunityDescription = "Envoyez des notifications lorsque des opportunit\xe9s sont partag\xe9es";
var MsTeams_NotificationPersonFollowedDescription = "Envoyez des notifications lorsque des personnes vous suivent";
var MsTeams_NotificationSharedDescription = "Envoyez des notifications lorsque des \xe9l\xe9ments de contenu sont partag\xe9s avec vous";
var MsTeams_NoUnreadNotifications = "Vous \xeates \xe0 jour. Vous n’avez aucune notification non lue.";
var MsTeams_OnboardingAssignments = "Acc\xe9dez \xe0 toutes vos formations assign\xe9es pass\xe9es, futures et en retard.";
var MsTeams_OnboardingPathways = "Acc\xe9dez \xe0 tous les parcours que vous suivez et dont vous \xeates l’auteur. Les parcours sont des voies d’apprentissage guid\xe9es qui permettent de suivre votre progression.";
var MsTeams_OnboardingPlans = "Affichez tous les plans que vous suivez et dont vous \xeates l’auteur. Les plans sont une collection de comp\xe9tences, de parcours, de groupes, de personnes et de contenus de formation connexes.";
var MsTeams_OnboardingSaved = "Consultez de nouveau tous vos \xe9l\xe9ments enregistr\xe9s, y compris ceux que vous avez enregistr\xe9s dans votre application mobile Degreed et dans l’application Web Degreed.";
var MsTeams_OnboardingShared = "Affichez les \xe9l\xe9ments de contenu que d’autres personnes de votre organisation ont partag\xe9s avec vous, ainsi que les \xe9l\xe9ments que vous avez partag\xe9s avec elles.";
var MsTeams_OnboardingStartTour = "Lancer la visite";
var MsTeams_OnboardingTitle = "Consultez le contenu ci-dessous pour d\xe9couvrir ce que vous pouvez accomplir avec l’application Degreed dans Microsoft\xa0Teams.";
var MsTeams_PleaseSignIn = "Veuillez vous connecter.";
var MsTeams_PopupBlockedAlertDescription = "Les param\xe8tres de votre navigateur ont bloqu\xe9 l’ouverture de notre fen\xeatre contextuelle de connexion. Cliquez sur R\xe9essayer pour autoriser l’affichage de cette fen\xeatre.";
var MsTeams_PopupBlockedAlertTitle = "Fen\xeatre contextuelle bloqu\xe9e";
var MsTeams_ShowAllNotifications = "Afficher toutes les notifications";
var MsTeams_ShowUnread = "Afficher non lues";
var MsTeams_ShowUnreadNotifications = "Afficher les notifications non lues";
var MsTeams_SignedInFailure = "Hum... un probl\xe8me est survenu. R\xe9essayez.";
var MsTeams_SignedInSuccess = "Votre connexion est maintenant active. Tapez \xab\xa0Aide\xa0\xbb pour commencer.";
var MsTeams_SignedOutSuccess = "Vous vous \xeates d\xe9connect\xe9 de Degreed";
var MsTeams_SignIn = "Se connecter";
var MsTeams_SignInRequired = "Connectez-vous pour continuer.";
var MsTeams_SignOut = "Se d\xe9connecter";
var MsTeams_SignOutDescription = "D\xe9connectez-vous de l’application Degreed";
var NativeInviteBanner_AppTagline = "Prenez l’habitude d’apprendre tous les jours";
var NativeInviteBanner_AppTitle = "Degreed";
var NativeInviteBanner_GetOnAppStore = "T\xe9l\xe9charger sur l’App Store";
var NativeInviteBanner_GetOnPlayStore = "Obtenez le sur Google Play";
var NativeInviteBanner_Open = "Ouvrir";
var NativeInviteBanner_OpenInApp = "Ouvrir dans l’application";
var NativeInviteBanner_RedirectTitle = "App Degreed - Redirection...";
var NavigationSvc_LearnTitle = "Apprentissages";
var NavigationSvc_MainMenu = "Menu principal";
var NavigationSvc_TodayTitle = "Accueil";
var newPathwayAuthor_DescriptionFormat = "{{pathwayAuthor}} vous a ajout\xe9 comme collaborateur \xe0 un parcours {{pathwayName}}";
var newTargetAuthor_DescriptionFormat = "{{targetAuthor}} vous a ajout\xe9 comme collaborateur \xe0 un plan {{targetTitle}}";
var newTargetResource_Description = "{{targetAuthor}} a ajout\xe9 un \xe9l\xe9ment au plan {{targetTitle}}";
var newUserFollower_PluralFormat = "{{nameHtml}} et {{number}} autres personnes vous suivent";
var newUserFollower_SingleFormat = "{{nameHtml}} vous suit d\xe9sormais";
var Notification_AutomationNotification = "Votre administrateur a envoy\xe9 un message";
var Notification_CompleteViewedItemsStepArticle = "Voulez-vous marquer cet \xe9l\xe9ment complet ?";
var Notification_CompleteViewedItemsStepArticleItem1 = "Marquer comme termin\xe9";
var Notification_CompleteViewedItemsStepArticleItem2 = "Ignorer";
var Notification_CompleteViewedItemsStepEpisode = "Voulez-vous marquer ce podcast complet ?";
var Notification_CompleteViewedItemsStepEpisodeItem1 = "Marquer comme termin\xe9";
var Notification_CompleteViewedItemsStepEpisodeItem2 = "Ignorer";
var Notification_CompleteViewedItemsStepFirstFormat = "Il y a {0} \xe9l\xe9ments que vous avez consult\xe9s r\xe9cemment sur Degreed mais qui n’ont pas encore \xe9t\xe9 termin\xe9s. Voulez-vous les revoir ?";
var Notification_CompleteViewedItemsStepFirstFormatItem1 = "Examiner les \xe9l\xe9ments";
var Notification_CompleteViewedItemsStepFirstFormatItem2 = "Ignorer";
var Notification_CompleteViewedItemsStepFirstSingular = "Il y a 1 \xe9l\xe9ment que vous avez consult\xe9 r\xe9cemment sur Degreed mais qui n’a pas encore \xe9t\xe9 termin\xe9. Voulez-vous le revoir ?";
var Notification_CompleteViewedItemsStepFirstSingularItem1 = "V\xe9rifier l’\xe9l\xe9ment";
var Notification_CompleteViewedItemsStepFirstSingularItem2 = "Ignorer";
var Notification_CompleteViewedItemsStepPost = "Voulez-vous valider cette publication\xa0?";
var Notification_CompleteViewedItemsStepThanksFormat = '<strong>F\xe9licitations\xa0!</strong> Vous venez de remporter {{pointsEarned}} points en compl\xe9tant ces {{completedCount}} \xe9l\xe9ments. Vous pourrez les retrouver dans <a href="/me?p=1#/overview" class="link">votre collection</a>.';
var Notification_CompleteViewedItemsStepVideo = "Voulez-vous marquer cette vid\xe9o compl\xe8te ?";
var Notification_CompleteViewedItemsStepVideoItem1 = "Marquer comme termin\xe9";
var Notification_CompleteViewedItemsStepVideoItem2 = "Ignorer";
var Notification_EnableDailyEmailStep1 = "Comment se d\xe9brouille mon \xe9l\xe8ve pr\xe9f\xe9r\xe9 ?";
var Notification_EnableDailyEmailStep1Item1 = "Grand merci!";
var Notification_EnableDailyEmailStep1Item2 = "Je n’aime pas parler \xe0 des robots";
var Notification_EnableDailyEmailStep2 = "Seriez-vous int\xe9ress\xe9 par l’envoi de recommandations d’apprentissage quotidien dans votre bo\xeete de r\xe9ception ?";
var Notification_EnableDailyEmailStep2Item1 = "Oui s’il vous pla\xeet !";
var Notification_EnableDailyEmailStep2Item2 = "Pas tout de suite";
var Notification_EnableDailyEmailStep3 = "Pourrais-je vous int\xe9resser dans les recommandations d’apprentissage quotidien transmises \xe0 votre bo\xeete de r\xe9ception ?";
var Notification_EnableDailyEmailStep3Item1 = "S\xfbr !";
var Notification_EnableDailyEmailStep3Item2 = "Non merci !";
var Notification_EnableDailyEmailStep4 = "Fantastique\xa0! Recherchez votre premier e-mail demain matin\xa0!";
var Notification_EnableDailyEmailStep5 = "Pas de probl\xe8me. Bonne journ\xe9e d’apprentissage !";
var Notification_InstallNativeAppStep1 = "Heureux de voir que vous appr\xe9ciez Degreed. Connaissez-vous d\xe9j\xe0 notre application mobile pour apprendre sur la route ?";
var Notification_InstallNativeAppStep1Item1 = "Non, c’est quoi ?";
var Notification_InstallNativeAppStep1Item2 = "Oui !";
var Notification_InstallNativeAppStep2 = "Eh bien, nos applications vous permettent de trouver et de capturer l’apprentissage n’importe o\xf9. Cliquez simplement sur le lien que vous pr\xe9f\xe9rez installer, puis revenez \xe0 l’apprentissage !";
var Notification_InstallNativeAppStep2Item1 = "iOS";
var Notification_InstallNativeAppStep2Item2 = "Android";
var Notification_InstallNativeAppStep3 = "Cool, content que vous le sachiez d\xe9j\xe0. Nous n’avons pas encore vu d’activit\xe9 de l’application, alors nous voulions simplement nous en assurer ! Voici les liens au cas o\xf9 vous souhaitez l’installer.";
var Notification_InstallNativeAppStep3Item1 = "iOS";
var Notification_InstallNativeAppStep3Item2 = "Android";
var Notification_InstallNativeAppStep3Item3 = "Merci";
var Notification_MultipleAssessmentsFoundAddSkills = "Nous avons trouv\xe9 {{skillCount}} tests d'\xe9valuation sur {{providerName}} que vous voudrez peut-\xeatre ajouter \xe0 votre profil.";
var Notification_MultipleAssessmentsFoundReviewSkills = "Nous avons trouv\xe9 {{assessmentCount}}\xa0tests d'\xe9valuation de comp\xe9tences {{providerName}} et nous avons ajout\xe9 les notes correspondant \xe0 chaque comp\xe9tence sur votre profil.";
var Notification_NewSkillsProviderAdded = "L’int\xe9gration {{providerName}} a \xe9t\xe9 ajout\xe9e par {{organizationName}}. Vous pouvez d\xe9sormais ajouter un test d'\xe9valuation {{providerName}} \xe0 vos comp\xe9tences.";
var Notification_PathwayContentCompletionReminder = "Vous avez consult\xe9 les \xe9l\xe9ments du parcours {{pathwayname}}, mais vous ne les avez pas valid\xe9s.";
var Notification_PrimaryTargetSetStepMainFormat = "Pour vous aider \xe0 vous concentrer sur les comp\xe9tences qui vous int\xe9ressent le plus, nous faisons automatiquement de <strong>{0}</strong> votre plan principal. Si vous souhaitez changer de priorit\xe9, vous pouvez s\xe9lectionner un autre plan principal dans la liste de la page d’accueil.";
var Notification_PrimaryTargetSetStepMainFormatItem1 = "Parfait !";
var Notification_RecommendedBulkGeneric_NotificationTitleFormat = "{{nameHtml}} vous recommande d’ajouter des \xe9l\xe9ments \xe0 votre profil.";
var Notification_RecommendedSkills_NotificationTitleFormat = "{{nameHtml}} vous recommande d’ajouter certaines comp\xe9tences \xe0 votre profil.";
var Notification_ReviewItems = "Consulter les \xe9l\xe9ments";
var Notification_SingleAssessmentFoundAddSkill = "Nous avons trouv\xe9 un test d'\xe9valuation pour \xab\xa0{{skillName}}\xa0\xbb sur {{providerName}}. Pourquoi ne pas ajouter cette comp\xe9tence \xe0 votre profil\xa0?";
var Notification_SingleAssessmentFoundReviewSkill = "Nous avons trouv\xe9 votre test d'\xe9valuation de comp\xe9tence {{providerName}} pour \xab\xa0{{skillName}}\xa0\xbb et nous avons ajout\xe9 la note de \xab\xa0{{ratingLevel}}\xa0\xbb \xe0 la comp\xe9tence correspondante sur votre profil.";
var Notification_SkillMatched = "Votre administrateur a indiqu\xe9 que la comp\xe9tence \xab\xa0{{skillName}}\xa0\xbb correspond \xe0 une autre comp\xe9tence et qu’elle sera d\xe9sormais appel\xe9e \xab\xa0{{matchedToName}}\xa0\xbb.";
var Notification_SkillsAddedToProfileFromJobRole_Plural = "Votre organisation a ajout\xe9 {{ count }}\xa0comp\xe9tences pour le poste {{ role }} sur votre profil. V\xe9rifiez et \xe9valuez vos comp\xe9tences pour am\xe9liorer les recommandations.\n{{ viewSkillsHtml }}";
var Notification_SkillsAddedToProfileFromJobRole_Single = "Votre organisation a ajout\xe9 {{ count }}\xa0comp\xe9tence pour le poste {{ role }} sur votre profil. V\xe9rifiez et \xe9valuez vos comp\xe9tences pour am\xe9liorer les recommandations.\n{{ viewSkillsHtml }}";
var Notification_TitleFormat_OpportunityClosed = "{{opportunityAuthor}} a ferm\xe9 son opportunit\xe9";
var Notification_TitleFormat_OpportunityInterested = "{{nameHtml}} s’int\xe9resse \xe0 cette opportunit\xe9";
var Notification_TrackYourLearningStep1 = "Nous pouvons vous donner de meilleurs \xe9l\xe9ments dans votre flux si vous marquez les \xe9l\xe9ments complets. Comment d\xe9sirez-vous apprendre ?";
var Notification_TrackYourLearningStep1Item1 = "Oui, bien s\xfbr !";
var Notification_TrackYourLearningStep1Item2 = "Non merci, \xe7a va";
var Notification_TrackYourLearningStep2 = "Fantastique. Partout o\xf9 vous voyez du contenu sur Degreed, vous pouvez cliquer sur l’ic\xf4ne ✔︎. Cela le marque comme termin\xe9. Vous pouvez voir tout votre contenu compl\xe9t\xe9 sur votre profil.";
var Notification_TrackYourLearningStep2Item1 = "Merci !";
var Notification_TrackYourLearningStep2Item2 = "Montrez-moi une autre fa\xe7on de compl\xe9ter le contenu";
var Notification_TrackYourLearningStep3 = "Vous pouvez \xe9galement cliquer sur le bouton \xab\xa0+\xa0\xbb en haut pour ajouter des \xe9l\xe9ments. Vous pouvez ajouter des vid\xe9os, des articles et plus \xe0 partir de n’importe quel site Web. Vous pouvez \xe9galement ajouter de l’exp\xe9rience de travail et d’autres choses qui font partie de votre apprentissage.";
var Notification_TrackYourLearningStep3Item1 = "Nous vous remercions !";
var Notification_TrackYourLearningStep3Item2 = "Ne vous arr\xeatez pas maintenant pas, comment puis-je ajouter ?";
var Notification_TrackYourLearningStep4 = "Vous aimerez ce prochain. Nous avons une extension mobile. \xc0 partir de n’importe quelle page sur le Web, vous pouvez cliquer sur le bouton et nous suivrons votre ach\xe8vement dans Degreed.";
var Notification_TrackYourLearningStep4Item1 = "Merci !";
var Notification_TrackYourLearningStep4Item2 = "Donnez-m’en un autre !";
var Notification_TrackYourLearningStep5 = "Vous devriez activer nos int\xe9grations. De cette fa\xe7on, lorsque vous compl\xe9tez le contenu sur d’autres plates-formes, elles sont automatiquement suivies sur Degreed !";
var Notification_TrackYourLearningStep5Item1 = "Emmenez-moi aux int\xe9grations";
var Notification_TrackYourLearningStep5Item2 = "Merci ! Je v\xe9rifierai plus tard";
var Notification_TrackYourLearningStep6 = "Bonne journ\xe9e d’apprentissage !";
var Notification_TrackYourLearningStep7 = "Pas de probl\xe8me. Bonne journ\xe9e d’apprentissage !";
var Notification_UpdateUserTagRatingsOnProfileStep1 = "Il est temps de faire votre bilan de comp\xe9tences\xa0! Mettez \xe0 jour l’\xe9valuation de vos comp\xe9tences et celles que vous suivez afin de refl\xe9ter vos progr\xe8s.";
var Notification_UpdateUserTagRatingsOnProfileStep1Item1 = "Mettre \xe0 jour les \xe9valuations";
var Notification_UpdateUserTagRatingsOnProfileStep1Item2 = "\xc9valuation termin\xe9e";
var Notification_UpdateUserTagRatingsOnProfileStep2 = "\xc7a se pr\xe9sente bien\xa0! Merci d’avoir mis \xe0 jour l’\xe9valuation de vos comp\xe9tences. Nous vous rappellerons de les remettre \xe0 jour lorsque vous aurez un peu plus avanc\xe9.";
var Notification_UpdateUserTagRatingsOnProfileStep2Item1 = "Terminer le bilan";
var Notification_UpdateUserTagRatingsStep1 = "Il est temps de mettre \xe0 jour vos comp\xe9tences\xa0! Actualisez vos \xe9valuations de comp\xe9tences pour refl\xe9ter votre progression.";
var Notification_UpdateUserTagRatingsStep1Item1 = "Mettre \xe0 jour les \xe9valuations";
var Notification_UpdateUserTagRatingsStep1Item2 = "Ignorer";
var Notification_UpdateUserTagsStep1 = "H\xe9, vous utilisez Degreed depuis un moment maintenant. Une grande partie de ce que vous voyez est d\xe9termin\xe9e par les comp\xe9tences qui vous int\xe9ressent. Souhaitez-vous r\xe9viser et \xe9ventuellement modifier ceux-ci maintenant ?";
var Notification_UpdateUserTagsStep1Item1 = "S\xfbr !";
var Notification_UpdateUserTagsStep1Item2 = "Non merci, \xe7a va";
var Notification_UpdateUserTagsStep2 = "G\xe9nial. Vos comp\xe9tences sont g\xe9r\xe9es sur votre page Aper\xe7u du profil (au cas o\xf9 vous souhaitez les ajuster plus tard). Cliquez sur ce bouton pour les changer !";
var Notification_UpdateUserTagsStep2Item1 = "Modifier les comp\xe9tences";
var Notification_UpdateUserTagsStep3 = "Pas de probl\xe8me. Vous pouvez toujours g\xe9rer vos comp\xe9tences \xe0 partir de votre page Aper\xe7u du profil.";
var Notification_UserTagSetGoal_NotificationTitleFormat = "{{nameHtml}} a mis \xe0 jour votre niveau cible en mati\xe8re de {{tag}} sur {{level}}";
var Notification_ViewOnProfile = "View on Profile";
var NotificationFeedCtrl_NotificationCountFormat = "{{notificationItemCount}} nouvelles notifications";
var NotificationManager_SocialConnectionJoinedFormat = "Votre ami(e) {0} a rejoint Degreed.";
var NotificationManager_UnsubscribeFormat = "Votre d\xe9sinscription du contenu {{type}} a \xe9t\xe9 effectu\xe9e.";
var NotificationsCtrl_YouHaveRequiredLearningPluralFormat = "Vous avez {{count}}\xa0\xe9l\xe9ments de formation obligatoire";
var NotificationsCtrl_YouHaveRequiredLearningSingular = "Vous avez 1\xa0\xe9l\xe9ment de formation obligatoire";
var NotificationSvc_Notifications = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’acc\xe8s aux notifications.";
var Onboarding_A11yAssignedStepName = "Assign\xe9";
var Onboarding_A11yResumeReviewStepName = "Review Resume";
var Onboarding_A11yRoleSelectStepName = "S\xe9lection de poste";
var Onboarding_A11ySkillAdded = "Vous avez ajout\xe9 {{skillName}} \xe0 votre liste de comp\xe9tences.";
var Onboarding_A11ySkillAlreadyAdded = "{{skillName}} fait partie de la liste des \xab\xa0Comp\xe9tences qui pourraient vous int\xe9resser\xa0\xbb .";
var Onboarding_A11ySkillsStepName = "Comp\xe9tences";
var Onboarding_A11yStartLearningStepName = "Commencer \xe0 apprendre";
var Onboarding_AddedSkill = "Comp\xe9tence ajout\xe9e";
var Onboarding_AdditionalSkillsDescription = "Choisissez les comp\xe9tences que vous poss\xe9dez afin que nous puissions mieux organiser votre exp\xe9rience de formation.";
var Onboarding_AdditionalSkillsInterstedIn = "Comp\xe9tences qui pourraient vous int\xe9resser";
var Onboarding_AdditionalSkillsTitle = "S\xe9lectionnez les comp\xe9tences suppl\xe9mentaires que vous poss\xe9dez";
var Onboarding_AISkillsSuggestDesc = "Utiliser le mod\xe8le d’IA de Degreed pour sugg\xe9rer des comp\xe9tences";
var Onboarding_AISkillsSuggestLabel = "Autoriser l’IA de Degreed \xe0 sugg\xe9rer des comp\xe9tences";
var Onboarding_AreYouSureDescription = "<p>Avec un niveau d’\xe9valuation de la comp\xe9tence de <strong>1</strong>, vous poss\xe9dez certaines connaissances dans ce domaine de comp\xe9tence et vous commencez \xe0 apprendre les outils et les processus qui y sont associ\xe9s. </p>\n<p>Une fois que vous aurez soumis votre niveau d’\xe9valuation de la comp\xe9tence, il s’affichera sur la carte Comp\xe9tence de votre profil. <p>";
var Onboarding_AreYouSureHeading = "Soumettez votre niveau d’\xe9valuation de la comp\xe9tence";
var Onboarding_AssignedSkillsDescription = "Les comp\xe9tences suivantes sont recommand\xe9es pour tous les {{currentRole}} et seront ajout\xe9es \xe0 votre profil. Cependant, vous pouvez cliquer sur une comp\xe9tence pour la d\xe9s\xe9lectionner et elle ne sera pas ajout\xe9e \xe0 votre profil.";
var Onboarding_AssignedSkillsError = "S\xe9lectionnez au moins une comp\xe9tence pour passer \xe0 l’\xe9tape suivante.";
var Onboarding_AssignedSkillsHeader = "{{count}}\xa0comp\xe9tences sont assign\xe9es au poste {{roleName}}";
var Onboarding_AssignedSkillsInformationTooltip = "Votre poste peut \xeatre mis \xe0 jour \xe0 tout moment dans vos param\xe8tres de profil.";
var Onboarding_AssignedSkillsWarning = "Nous vous recommandons de ne pas d\xe9s\xe9lectionner les comp\xe9tences assign\xe9es. Les comp\xe9tences s\xe9lectionn\xe9es permettent de vous proposer des ressources et des formations bas\xe9es sur votre poste.";
var Onboarding_BackupEmailAddressDesc = "Adresse e-mail de s\xe9curit\xe9";
var Onboarding_ExperienceDatePresent = "Maintenant";
var Onboarding_ExperienceDateYears = "Ann\xe9es";
var Onboarding_ExportLinkedInResume = "Exporter votre CV depuis LinkedIn";
var Onboarding_ExportLinkedInResumeInstructions = "T\xe9l\xe9chargez votre CV LinkedIn en vous connectant \xe0 votre profil, en cliquant sur l’ic\xf4ne \xab\xa0Vous\xa0\xbb et sur \xab\xa0Voir le profil\xa0\xbb, puis en s\xe9lectionnant \xab\xa0Enregistrer au format PDF\xa0\xbb.";
var Onboarding_FocusSkillTooltip = "Pour choisir jusqu’\xe0 quatre comp\xe9tences prioritaires, s\xe9lectionnez les \xe9toiles correspondant \xe0 chacune des comp\xe9tences. Les comp\xe9tences prioritaires sont celles que vous souhaitez d\xe9velopper ou am\xe9liorer activement.";
var Onboarding_FoundExperienceHeader = "Nous avons trouv\xe9 {{count}}\xa0exp\xe9riences dans votre CV";
var Onboarding_LearnFromAnySource = "Apprenez de diff\xe9rentes sources";
var Onboarding_LearnInstructions = "Nous connecterons toutes les ressources n\xe9cessaires pour vous aider \xe0 apprendre et progresser. Des millions de cours, de vid\xe9os, de livres et plus encore\xa0!";
var Onboarding_LinkedInLink = "Acc\xe9der \xe0 LinkedIn";
var Onboarding_LoadMore = "Afficher plus";
var Onboarding_ProfileSkill = "Comp\xe9tence du profil";
var Onboarding_ProgressInstructions = "Nous sommes l\xe0 pour vous aider \xe0 d\xe9couvrir, acqu\xe9rir et d\xe9velopper les comp\xe9tences dont vous avez besoin pour l’avenir.";
var Onboarding_ProgressInYourSkills = "D\xe9veloppez vos comp\xe9tences";
var Onboarding_RatingOverflowImgAlt = "illustration abstraite repr\xe9sentant un profil d’utilisateur";
var Onboarding_RatingOverflowInstructions = "Vous avez termin\xe9 pour le moment. Vous pourrez toujours \xe9valuer d’autres comp\xe9tences sur votre profil plus tard.";
var Onboarding_RatingOverflowTitle = "Bon travail\xa0!";
var Onboarding_ResetTipsBody = "Cette op\xe9ration r\xe9initialisera le processus d’int\xe9gration, y compris la page de bienvenue.";
var Onboarding_ResetTipsHeader = "Souhaitez-vous r\xe9ellement r\xe9initialiser le processus d’int\xe9gration\xa0?";
var Onboarding_ResumeAdditionalSkills = "Nous avons trouv\xe9 {{count}}\xa0comp\xe9tences dans votre CV. Vous pourrez passer en revue, modifier et ajouter des comp\xe9tences \xe0 l’\xe9tape suivante.";
var Onboarding_ResumeLastModifiedDateMessage = "Le dernier CV que vous avez charg\xe9 date du {{date}}";
var Onboarding_ResumeReviewPageDescription = "Pour personnaliser votre exp\xe9rience Degreed, nous ajouterons {{experiencesNumber}}\xa0exp\xe9riences et {{skillsNumber}}\xa0comp\xe9tences de votre CV \xe0 votre profil. Vous pourrez examiner, modifier et ajouter des comp\xe9tences \xe0 l’\xe9tape suivante.";
var Onboarding_ResumeReviewTitle = "Examiner les exp\xe9riences issues du CV charg\xe9";
var Onboarding_ResumeSkill = "Comp\xe9tence du CV";
var Onboarding_ReviewExperienceDescription = "Passez en revue les postes qui figurent dans votre curriculum vitae. Ces exp\xe9riences seront ajout\xe9es \xe0 votre profil pour personnaliser votre exp\xe9rience Degreed.";
var Onboarding_ReviewOptionalSkillsDescription = "Les \xe9valuations de comp\xe9tences ne sont pas obligatoires, mais une fois ajout\xe9es \xe0 votre profil, elles constituent un bon point de d\xe9part pour suivre votre progression. Nous vous recommandons \xe9galement de s\xe9lectionner jusqu’\xe0 quatre comp\xe9tences prioritaires \xe0 l’aide des ic\xf4nes en forme d’\xe9toile pour personnaliser votre exp\xe9rience de formation. Il s’agit des comp\xe9tences que vous souhaitez d\xe9velopper activement.";
var Onboarding_ReviewOptionalSkillsHeader = "Compl\xe9tez votre profil de comp\xe9tences";
var Onboarding_ReviewSkills_Description = "Vous avez ajout\xe9 {{addedSkills}}\xa0comp\xe9tences correspondant \xe0 votre poste et \xe0 votre exp\xe9rience professionnelle pass\xe9e. Compl\xe9tez votre profil en ajoutant au moins trois auto-\xe9valuations et en s\xe9lectionnant jusqu’\xe0 quatre comp\xe9tences prioritaires pour am\xe9liorer les suggestions de comp\xe9tences, de contenus et d’opportunit\xe9s.\n<br><br>Si certaines de vos comp\xe9tences sont absentes, recherchez-les et ajoutez-les maintenant.";
var Onboarding_ReviewSkills_Description_Empty = "Aucune comp\xe9tence correspondant \xe0 votre poste ou \xe0 votre exp\xe9rience pass\xe9e n’a \xe9t\xe9 trouv\xe9e. Pour compl\xe9ter votre profil de comp\xe9tences, ajoutez au moins trois auto-\xe9valuations et s\xe9lectionnez jusqu’\xe0 quatre comp\xe9tences prioritaires.\n<br><br>Si certaines de vos comp\xe9tences sont absentes, recherchez-les et ajoutez-les maintenant.";
var Onboarding_ReviewSkillsDescription = "Pour obtenir la meilleure exp\xe9rience {{orgName}} personnalis\xe9e possible, nous allons remplir votre profil de comp\xe9tences. Ajoutez aux comp\xe9tences au moins trois auto-\xe9valuations et indiquez quelles comp\xe9tences vous souhaitez prioriser.<br><br>Si l’une des comp\xe9tences que vous poss\xe9dez ou que vous souhaitez d\xe9velopper n’appara\xeet pas, recherchez-la et ajoutez-la maintenant.";
var Onboarding_ReviewSkillsHeader = "Finalisez votre profil de comp\xe9tences";
var Onboarding_RoleSkill = "Comp\xe9tence li\xe9e \xe0 votre poste";
var Onboarding_RolesStepDescription = "Votre poste est le fondement de votre profil de comp\xe9tences ; il vous permet de profiter d’une exp\xe9rience {{orgName}}\xa0personnalis\xe9e.";
var Onboarding_RolesStepTitle = "S\xe9lectionnez votre poste";
var Onboarding_SavingError = "Un probl\xe8me est survenu lors de l’enregistrement de votre historique d’int\xe9gration.";
var Onboarding_SearchRoles_NoRoleAssigned = "Aucun poste attribu\xe9";
var Onboarding_SearchRoles_SearchForRole = "Rechercher un poste";
var Onboarding_SearchRoles_VisitIntegration = "Rendez-vous sur {{integrationName}} pour ajouter un poste.";
var Onboarding_SearchSkills_AddSkills = "Ajoutez les comp\xe9tences de votre choix";
var Onboarding_SearchSkills_SearchForSkills = "Rechercher des comp\xe9tences";
var Onboarding_SearchSkills_SuggestionsHeading = "{{numberOfSkills}} suggestions pour \xab\xa0{{roleName}}\xa0\xbb";
var Onboarding_SearchSkills_TopSkills = "Meilleures comp\xe9tences";
var Onboarding_SecondaryEmailDesc = "Cette adresse permet de prot\xe9ger votre compte et vos points";
var Onboarding_SectionTitle = "Int\xe9gration";
var Onboarding_SeeSuggestedSkills = "Afficher les comp\xe9tences sugg\xe9r\xe9es";
var Onboarding_SkillSelectionRequiredTooltip = "Vous devez s\xe9lectionner au moins une comp\xe9tence pour continuer.";
var Onboarding_Step1CategoriesImgAlt = "illustration abstraite repr\xe9sentant de nombreux types de contenu";
var Onboarding_Step1IdeasImgAlt = "illustration abstraite repr\xe9sentant des pens\xe9es et des id\xe9es";
var Onboarding_Step1Title = "Bienvenue sur Degreed";
var Onboarding_Step2Instructions = "Tout d’abord, dites-nous quel poste vous occupez, ou vous souhaiteriez occuper, afin que nous puissions vous aider \xe0 trouver des comp\xe9tences ou des sujets qui pourraient vous int\xe9resser.";
var Onboarding_Step2InstructionsIntegration = "Votre organisation vous a attribu\xe9 un poste \xe0 partir de {{integrationName}}. Vous pouvez ajouter ou modifier votre poste dans {{integrationName}}.";
var Onboarding_Step2InstructionsSkillInventory = "Veuillez nous indiquer votre profession et nous vous aiderons \xe0 ajouter vos comp\xe9tences actuelles.";
var Onboarding_Step2Title = "S\xe9lectionnez votre poste";
var Onboarding_Step2TitleIntegration = "Votre poste";
var Onboarding_Step3Instructions = "Choisissez maintenant quelques comp\xe9tences que vous aimeriez d\xe9velopper afin que nous puissions optimiser votre exp\xe9rience de formation.";
var Onboarding_Step3InstructionsSkillInventory = "Pour compl\xe9ter votre profil, veuillez pr\xe9ciser vos comp\xe9tences.";
var Onboarding_Step3Title = "S\xe9lectionnez les comp\xe9tences que vous souhaitez d\xe9velopper";
var Onboarding_Step3TitleSkillInventory = "Parlez-nous de vos talents";
var Onboarding_Step4Instructions = "\xc9valuez vos comp\xe9tences pour trouver des contenus de formation pertinents et suivre votre progression.";
var Onboarding_Step4InstructionsSkillInventory = "\xc9valuez vos comp\xe9tences pour commencer \xe0 suivre leur d\xe9veloppement et d\xe9terminer si elles correspondent \xe0 l’emploi souhait\xe9, ainsi qu’\xe0 votre emploi actuel.";
var Onboarding_Step4Title = "Il est temps de vous \xe9valuer sur vos comp\xe9tences\xa0!";
var Onboarding_Step5Instructions = "Nous avons trouv\xe9 des milliers d’articles, de vid\xe9os, de livres et de cours qui vous aideront \xe0 d\xe9velopper vos comp\xe9tences. Commencez par explorer votre flux de formation personnalis\xe9.";
var Onboarding_Step5Title = "Vous avez termin\xe9\xa0!";
var Onboarding_StepParse = "Analyser";
var Onboarding_StepResults = "R\xe9sultats";
var Onboarding_StepUpload = "Charger";
var Onboarding_SuggestedSkill = "Comp\xe9tence sugg\xe9r\xe9e";
var Onboarding_TrackYourSkills = "Revendiquez haut et fort votre talent";
var Onboarding_TrackYourSkillsInstructions = "Compl\xe9tez votre profil sans plus tarder pour montrer que vos comp\xe9tences sont indispensables \xe0 l’\xe9quipe.";
var Onboarding_UploadResume = "Charger un CV";
var Onboarding_UploadResumeDescription = "{{orgName}} compl\xe8tera votre exp\xe9rience de travail et extraira de votre CV les comp\xe9tences de chacun de vos pr\xe9c\xe9dents postes.";
var Onboarding_UploadResumeDescriptionTemp = "{{orgName}} extraira les comp\xe9tences de votre CV pour les ajouter \xe0 votre profil.";
var Onboarding_UploadResumeHeader = "Chargez votre CV pour ajouter des exp\xe9riences pass\xe9es";
var Onboarding_UploadResumeHeaderTemp = "Chargez votre CV pour ajouter des comp\xe9tences";
var Onboarding_Welcome = "Bienvenue {{username}}";
var Onboarding_WelcomeDetails = "Pour commencer, nous allons cr\xe9er votre profil {{orgName}}. Ce profil permet de trouver des ressources personnalis\xe9es pour votre poste, vos comp\xe9tences et vos objectifs.";
var Onboarding_WelcomeHeading = "Avez-vous les comp\xe9tences n\xe9cessaires pour affronter l’avenir \xa0?";
var Onboarding_WelcomeInstructions = "Commencez par charger votre CV pour que le syst\xe8me remplisse automatiquement vos comp\xe9tences et postes pr\xe9c\xe9dents, ou indiquez une adresse e-mail personnelle pour enregistrer votre profil afin de pouvoir y acc\xe9der depuis n’importe o\xf9.";
var Onboarding_WelcomeMountainIllustration = "Dessin d’une montagne illustrant la mani\xe8re dont Degreed vous accompagne dans votre parcours d’apprentissage";
var Onboarding_WelcomeTitle = "Personnalisez votre profil pour acc\xe9der \xe0 des ressources sur mesure adapt\xe9es \xe0 votre poste, \xe0 vos comp\xe9tences et \xe0 vos objectifs.";
var OnboardingController_PageTitle = "Bienvenue";
var OnboardingFooter_GetStarted = "D\xe9marrer";
var OnboardingFooter_NextStep = "\xc9tape suivante";
var OnboardingFooter_PreviousStep = "\xc9tape pr\xe9c\xe9dente";
var OnboardingFooter_RatingDisabledStatus = "{{ ratings }}\xa0de 3 \xe9valuations ajout\xe9es";
var OnboardingFooter_SeeMyProfile = "Voir mon profil";
var OnboardingFooter_SkipStep = "Passer l’\xe9tape";
var OnboardingFooter_StartLearning = "Commencer \xe0 apprendre";
var OnboardingFooter_StepperLabel = "\xc9tape {{stepNumber}} sur {{stepTotal}}";
var OnboardingFooter_SubmitRating = "Soumettre l’\xe9valuation";
var Opportunities_AcceptMenteeModal_AcceptFormatted = "Accepter {{ name }}";
var Opportunities_AcceptMenteeModal_AvailabilityDescription = "Si cette option est d\xe9sactiv\xe9e, vous ne recevrez pas de demandes de mentorat.";
var Opportunities_AcceptMenteeModal_AvailabilityLabel = "Disponibilit\xe9 pour du mentorat";
var Opportunities_AcceptMenteeModal_ConnectLabel = "Comment voudriez-vous communiquer\xa0?";
var Opportunities_AcceptMenteeModal_ConnectLabel_Error = "M\xe9thode de contact pr\xe9f\xe9r\xe9e";
var Opportunities_AcceptMenteeModal_ConnectPlaceholder = "S\xe9lectionnez une option";
var Opportunities_AcceptMenteeModal_Description = "F\xe9licitations pour votre nouveau contact de mentorat\xa0!";
var Opportunities_AcceptMenteeModal_Error = "Un probl\xe8me est survenu lors de l’approbation de ce mentorat.";
var Opportunities_AcceptMenteeModal_SubmitButtonText = "Accepter";
var Opportunities_AcceptMenteeModal_Success = "Le mentorat a bien \xe9t\xe9 accept\xe9.";
var Opportunities_AcceptMenteeModal_Success_Multi = "Le mentorat et la disponibilit\xe9 du mentor ont bien \xe9t\xe9 mis \xe0 jour.";
var Opportunities_Actions_Edit = "Modifier l’opportunit\xe9";
var Opportunities_ActiveFormat = "{{count}}\xa0active(s)";
var Opportunities_Activity_AsCollaborator = "Ajout\xe9(e) en tant que collaborateur/collaboratrice";
var Opportunities_Activity_NewCandidates = "{{candidates}}\xa0nouveau(x) candidat(s)";
var Opportunities_Activity_NoInterestForDays = "Aucun int\xe9r\xeat depuis {{days}}\xa0jours";
var Opportunities_Activity_NoInterestSevenDays = "Aucun int\xe9r\xeat depuis 7\xa0jours";
var Opportunities_Activity_OpenMoreThanDays = "Ouverte plus de {{days}}\xa0jours";
var Opportunities_AllGroups = "Tous les groupes";
var Opportunities_AllLocations = "Tous les lieux";
var Opportunities_AllSkills = "Toutes les comp\xe9tences";
var Opportunities_AllStatuses = "Tous les statuts";
var Opportunities_AllTypes = "Tous les types";
var Opportunities_Apply = "Postuler";
var Opportunities_ArchiveCandidatesModal_Header_Bulk = "Archiver {{ number }}\xa0candidatures";
var Opportunities_ArchiveCandidatesModal_Header_Singular = "Archiver la candidature";
var Opportunities_ArchiveCandidatesModal_Labels_Notify_Bulk = "Informer les personnes non s\xe9lectionn\xe9es que leur candidature a \xe9t\xe9 archiv\xe9e";
var Opportunities_ArchiveCandidatesModal_Labels_Notify_Singular = "Informer la personne non s\xe9lectionn\xe9e que sa candidature a \xe9t\xe9 archiv\xe9e";
var Opportunities_ArchiveCandidatesModal_Labels_RejectionMessage = "Message de refus";
var Opportunities_ArchiveCandidatesModal_Labels_RejectionMessage_Placeholder = "Saisissez un message personnalis\xe9 ici";
var Opportunities_ArchiveCandidatesModal_SubmitButtonText = "Archiver";
var Opportunities_Archived = "Candidature archiv\xe9e";
var Opportunities_BrowseOpportunities = "Parcourir les opportunit\xe9s";
var Opportunities_Candidates_Cols_DateAdded = "Date d’ajout";
var Opportunities_Candidates_Cols_JobTitle = "Poste";
var Opportunities_Candidates_Cols_Location = "Lieu";
var Opportunities_Candidates_Cols_Name = "Nom";
var Opportunities_Candidates_Cols_SkillMatch = "Ad\xe9quation des comp\xe9tences";
var Opportunities_Candidates_Cols_Stage = "\xc9tape";
var Opportunities_Candidates_Cols_Status = "\xc9tat";
var Opportunities_Candidates_Cols_TargetMet = "Cible atteinte";
var Opportunities_Candidates_Email_RejectionMessage = "Message de refus";
var Opportunities_Candidates_Error_Get = "D\xe9sol\xe9\xa0! Impossible de r\xe9cup\xe9rer les candidats.";
var Opportunities_Candidates_Modal_Award = "Oui, attribuer";
var Opportunities_Candidates_Modal_UpdateApplicant_Description = "Une notification sera envoy\xe9e au destinataire.";
var Opportunities_Candidates_Modal_UpdateApplicant_Title = "Voulez-vous vraiment attribuer cette opportunit\xe9\xa0?";
var Opportunities_Candidates_Modal_UpdateApplicantPrompt_CloseOpp = "Fermer cette opportunit\xe9 (action irr\xe9versible)";
var Opportunities_Candidates_Modal_UpdateApplicantPrompt_Congratulations = "F\xe9licitations pour ce choix de candidat\xa0! Comment voulez-vous finaliser cette opportunit\xe9\xa0?";
var Opportunities_Candidates_Modal_UpdateApplicantPrompt_Congratulations_Plural = "F\xe9licitations pour ces choix de candidats\xa0! De quelle mani\xe8re souhaitez-vous finaliser cette opportunit\xe9\xa0?";
var Opportunities_Candidates_Modal_UpdateApplicantPrompt_Description = "Le candidat que vous avez s\xe9lectionn\xe9 va recevoir une notification.";
var Opportunities_Candidates_Modal_UpdateApplicantPrompt_Description_Plural = "Les candidats que vous avez s\xe9lectionn\xe9s vont recevoir une notification.";
var Opportunities_Candidates_Modal_UpdateApplicantPrompt_NotifyUnselected = "Informer les candidats non s\xe9lectionn\xe9s que l’opportunit\xe9 a \xe9t\xe9 ferm\xe9e";
var Opportunities_Candidates_Modal_UpdateApplicantPrompt_SubmitButton = "S\xe9lectionner le candidat";
var Opportunities_Candidates_Modal_UpdateApplicantPrompt_SubmitButton_Plural = "S\xe9lectionner les candidats";
var Opportunities_Candidates_Modal_UpdateApplicantPrompt_Title = "Vous avez trouv\xe9 un candidat\xa0!";
var Opportunities_Candidates_Modal_UpdateApplicantPrompt_Title_Plural = "Vous avez trouv\xe9 des candidats\xa0!";
var Opportunities_Candidates_Notice_NoCandidates = "Aucun candidat ne correspond \xe0 cette opportunit\xe9.";
var Opportunities_Candidates_Search_Placeholder = "Rechercher un candidat";
var Opportunities_Candidates_ShowArchived = "Candidatures archiv\xe9es uniquement";
var Opportunities_Candidates_Stage_Archived = "Archiver";
var Opportunities_Candidates_Stage_None = "Non sp\xe9cifi\xe9";
var Opportunities_Candidates_Stage_Select = "S\xe9lectionn\xe9";
var Opportunities_Candidates_Stage_Selected = "S\xe9lectionner";
var Opportunities_Candidates_Stage_Shortlisted = "Pr\xe9s\xe9lectionner";
var Opportunities_Candidates_Status_Interested = "\xc7a m’int\xe9resse";
var Opportunities_Candidates_Status_InviteSent = "Partag\xe9s";
var Opportunities_Candidates_Status_NoResponse = "Pas de r\xe9ponse";
var Opportunities_Candidates_Status_NotInterested = "Pas int\xe9ress\xe9(e)";
var Opportunities_Candidates_UserHasNotOptedIn = "Cet utilisateur n’a pas encore accept\xe9 de partager ces informations.";
var Opportunities_CareerMobility = "La mobilit\xe9 interne";
var Opportunities_ChartXAxisTitle = "Date";
var Opportunities_ClosedOnDate = "Cl\xf4tur\xe9e le {{date}}";
var Opportunities_ConnectWithButton_Status_Accepted = "Votre mentor";
var Opportunities_ConnectWithButton_Status_None = "Demander comme mentor";
var Opportunities_ConnectWithButton_Status_Requested = "Mentorat demand\xe9";
var Opportunities_ConnectWithModal_ConnectWithFormatted = "Mise en relation avec {{ name }}";
var Opportunities_ConnectWithModal_Description = "Nous voulons tout mettre en œuvre pour que votre mentorat se passe dans les meilleures conditions possibles. Pour cela, nous aimerions savoir ce que vous en attendez.";
var Opportunities_ConnectWithModal_Error = "Une erreur s’est produite lors de la mise en relation avec ce mentor.";
var Opportunities_ConnectWithModal_Labels_FocusSkills = "Comp\xe9tences prioritaires";
var Opportunities_ConnectWithModal_Labels_FocusSkills_Description = "Votre mentor et vous n’avez aucune comp\xe9tence prioritaire en commun. Vos comp\xe9tences prioritaires (ci-dessous) seront envoy\xe9es \xe0 ce mentor pour l’aider \xe0 comprendre vos besoins de mentorat.";
var Opportunities_ConnectWithModal_Labels_FocusSkills_Description_NoSkillsExplainer = "Vous n’avez aucune comp\xe9tence prioritaire configur\xe9e dans {{startAnchor}}votre profil{{endAnchor}}. Nous vous recommandons de d\xe9finir au moins une comp\xe9tence prioritaire avant de contacter un mentor, car cela va l’aider \xe0 comprendre vos besoins de mentorat.";
var Opportunities_ConnectWithModal_Labels_MatchingSkills = "Comp\xe9tences correspondantes";
var Opportunities_ConnectWithModal_Labels_MatchingSkills_Description = "Ce mentor et vous avez en commun les comp\xe9tences prioritaires suivantes. Elles seront envoy\xe9es \xe0 ce mentor pour l’aider \xe0 comprendre vos besoins de mentorat.";
var Opportunities_ConnectWithModal_Labels_Reason = "Pourquoi souhaitez-vous b\xe9n\xe9ficier d’un mentor \xa0?";
var Opportunities_ConnectWithModal_OpenModal = "Demander un mentor";
var Opportunities_ConnectWithModal_Placeholders_Reason = "Quelle est votre motivation pour contacter ce mentor \xa0?";
var Opportunities_ConnectWithModal_SubmitButton = "Envoyer la demande";
var Opportunities_ConnectWithModal_Success = "Demande bien envoy\xe9e.";
var Opportunities_ConnectWithModal_Success_Mentors_Removed = "Vous avez bien mis fin \xe0 ce mentorat.";
var Opportunities_ConnectWithModal_Success_Updated = "Le mentorat a bien \xe9t\xe9 mis \xe0 jour.";
var Opportunities_DataUpdateTimelineExplanation = "Les donn\xe9es sur les vues et l’int\xe9r\xeat sont mises \xe0 jour tous les jours \xe0 minuit\xa0UTC. Celles sur les candidats qualifi\xe9s et non qualifi\xe9s sont actualis\xe9es entre minuit et 1\xa0h\xa0UTC.";
var Opportunities_DeclineMenteeModal_DeclineFormatted = "Refuser {{ name }}";
var Opportunities_DeclineMenteeModal_Description = "Aidez ce mentor\xe9 \xe0 comprendre pourquoi un mentorat avec vous n’est peut-\xeatre pas adapt\xe9.";
var Opportunities_DeclineMenteeModal_Error = "Un probl\xe8me est survenu lors du refus de ce mentorat.";
var Opportunities_DeclineMenteeModal_ExplanationLabel = "Remarque \xe0 l’intention du mentor\xe9";
var Opportunities_DeclineMenteeModal_ExplanationPlaceholder = "Ajouter une remarque";
var Opportunities_DeclineMenteeModal_SubmitButtonText = "Refuser";
var Opportunities_DeclineMenteeModal_Success = "Le mentorat a bien \xe9t\xe9 refus\xe9.";
var Opportunities_DeclineMenteeModal_Success_Multi = "Le mentorat et la disponibilit\xe9 du mentor ont \xe9t\xe9 mis \xe0 jour.";
var Opportunities_Discard = "Abandonner";
var Opportunities_DiscardChanges = "Voulez-vous vraiment abandonner ces modifications \xa0?";
var Opportunities_Discover_Error_Get = "D\xe9sol\xe9\xa0! Impossible de r\xe9cup\xe9rer les candidats.";
var Opportunities_Discover_NoItems_ActionDescription = "Rendez cette opportunit\xe9 visible et nous vous proposerons une s\xe9lection de candidats.";
var Opportunities_Discover_NoItems_ActionDescription_Public = "Veuillez ajouter un poste connexe ou des comp\xe9tences suppl\xe9mentaires pour d\xe9couvrir les candidats potentiels.";
var Opportunities_Discover_NoItems_Headline = "Cette opportunit\xe9 n’est pas encore visible";
var Opportunities_Discover_NoItems_Headline_Public = "Aucun profil ne correspond \xe0 cette opportunit\xe9";
var Opportunities_Discover_ResultsDisclaimer = "Les r\xe9sultats se fondent sur l’ad\xe9quation des comp\xe9tences dans l’ensemble de l’organisation. De nombreux facteurs les influencent, et il est possible qu’ils n’incluent pas tous les candidats possibles.";
var Opportunities_EngagementAriaLabel = "En savoir plus sur les statistiques d’engagement li\xe9es aux opportunit\xe9s";
var Opportunities_Error_AddExperience = "L’opportunit\xe9 n’a pas pu \xeatre ajout\xe9e comme exp\xe9rience.";
var Opportunities_Error_Get = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration des opportunit\xe9s.";
var Opportunities_Error_GetApplicantData = "D\xe9sol\xe9s\xa0! Un probl\xe8me est survenu lors de l’obtention des donn\xe9es du candidat.";
var Opportunities_Error_GetMentors = "Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration des mentors.";
var Opportunities_Error_Loading = "D\xe9sol\xe9s\xa0! Un probl\xe8me est survenu lors du chargement des opportunit\xe9s.";
var Opportunities_Error_Skill_Delete = "Un probl\xe8me est survenu lors de la suppression de la comp\xe9tence.";
var Opportunities_Error_Target_Delete = "Opportunities_Error_";
var Opportunities_Error_UpdateApplicantsStage = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de la mise \xe0 jour de l’\xe9tape de candidature.";
var Opportunities_Error_UpdateApplicantStage = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de la mise \xe0 jour de l’\xe9tape de candidature.";
var Opportunities_Errors_OpportunityIsInvalid = "Le probl\xe8me associ\xe9 \xe0 cette opportunit\xe9 doit \xeatre r\xe9solu.";
var Opportunities_Errors_OpportunityIsInvalid_Tab = "Cet onglet comporte des erreurs.";
var Opportunities_ExcellentFitLabel = "Excellent";
var Opportunities_GetError = "Un probl\xe8me est survenu lors de l’obtention des opportunit\xe9s.";
var Opportunities_GoodFitLabel = "Pertinent";
var Opportunities_InterestByMatchedCandidates = "Int\xe9r\xeat des candidats qualifi\xe9s";
var Opportunities_InterestByUnmatchedCandidates = "Int\xe9r\xeat des candidats non qualifi\xe9s";
var Opportunities_InterestConfirmed = "Votre int\xe9r\xeat pour cette opportunit\xe9 a \xe9t\xe9 pris en compte et une notification a \xe9t\xe9 envoy\xe9e.";
var Opportunities_Interested = "\xc7a m’int\xe9resse";
var Opportunities_Interested_NoItems_ActionDescription = "Veuillez cliquer sur \xab\xa0D\xe9couvrir\xa0\xbb pour trouver des candidats potentiels.";
var Opportunities_Interested_NoItems_CustomNoItemsMessage = "Certains candidats ont \xe9t\xe9 masqu\xe9s par les filtres s\xe9lectionn\xe9s.";
var Opportunities_Interested_NoItems_Headline = "Personne n’a encore manifest\xe9 son int\xe9r\xeat";
var Opportunities_Interested_NoResult = "Aucun r\xe9sultat pour";
var Opportunities_InterestNotConfirmedError = "Une erreur est survenue. Votre int\xe9r\xeat pour cette opportunit\xe9 n’est pas confirm\xe9.";
var Opportunities_InterestNotRemovedError = "Une erreur est survenue. Votre int\xe9r\xeat pour cette opportunit\xe9 n’a pas \xe9t\xe9 retir\xe9.";
var Opportunities_InterestRemoved = "Votre candidature a \xe9t\xe9 retir\xe9e de cette opportunit\xe9.";
var Opportunities_JobRoleNotSpecified = "Non sp\xe9cifi\xe9";
var Opportunities_Marketplace = "Opportunit\xe9s";
var Opportunities_Marketplace_BasedOn_Focus = "En fonction de vos comp\xe9tences prioritaires";
var Opportunities_Marketplace_BasedOn_Goals = "En fonction de vos objectifs de carri\xe8re";
var Opportunities_Marketplace_BasedOn_Recent = "Mise \xe0 jour la plus r\xe9cente";
var Opportunities_Marketplace_BasedOn_Skills = "En fonction de vos comp\xe9tences";
var Opportunities_Marketplace_LaneTypes_Mentors = "Communiquer avec un mentor";
var Opportunities_Marketplace_LaneTypes_Permanent = "Opportunit\xe9s \xe0 temps plein";
var Opportunities_Marketplace_LaneTypes_Projects = "Projets et t\xe2ches";
var Opportunities_Marketplace_LaneTypes_Temporary = "Missions \xe9largies";
var Opportunities_MatchedCandidateExplanation = "Candidat qualifi\xe9\xa0: l’opportunit\xe9 est pr\xe9sent\xe9e \xe0 l’utilisateur car les crit\xe8res du profil utilisateur sont satisfaits. {{startAnchor}}En savoir plus{{endAnchor}}";
var Opportunities_MatchedSkills = "Comp\xe9tences correspondantes";
var Opportunities_MatchingSkills = "COMP\xc9TENCES CORRESPONDANTES\xa0: {{matchingSkillsCount}} sur {{totalSkillsCount}}";
var Opportunities_Mentees = "Mentor\xe9s";
var Opportunities_MenteeSkills = "Comp\xe9tences du mentor\xe9";
var Opportunities_Mentoring = "Mentorat";
var Opportunities_Mentoring_Columns_Connect = "Communiquer par";
var Opportunities_Mentors = "Mentors";
var Opportunities_MentorSkills = "Comp\xe9tences du mentor";
var Opportunities_Meta_Closed = "Ferm\xe9e";
var Opportunities_Meta_Location = "Lieu";
var Opportunities_Meta_PublishDate = "Cr\xe9\xe9(e) le";
var Opportunities_Meta_PublishDateString = "Cr\xe9\xe9 le {{ date }}";
var Opportunities_Meta_Type = "Type";
var Opportunities_Meta_Visibility = "Visibilit\xe9";
var Opportunities_MoreDetailsMentorshipModal_Info = "La remarque n’a pas \xe9t\xe9 remplie.";
var Opportunities_MoreDetailsMentorshipModal_Warning = "La remarque n’a pas \xe9t\xe9 remplie et le mentor\xe9 n’a pas de comp\xe9tences disponibles.";
var Opportunities_MyOpportunities = "Mes opportunit\xe9s";
var Opportunities_MyOpportunitiesCollaboratingOn = "Collaborations";
var Opportunities_MyOpportunitiesCompleted = "Termin\xe9";
var Opportunities_MyOpportunitiesEmptyStateText = 'Votre <a href="{{ homePageUrl }}" class="link">page d’accueil</a> propose des opportunit\xe9s susceptibles de vous int\xe9resser. Ou vous pouvez <a href="/career/opportunities" target="_self" class="link">parcourir les opportunit\xe9s</a> disponibles.';
var Opportunities_MyOpportunitiesEmptyStateTitle = "Vous n’avez pas encore d’opportunit\xe9s.";
var Opportunities_MyOpportunitiesInterested = "\xc7a m’int\xe9resse";
var Opportunities_MyOpportunitiesSavedForLater = "Sauvegard\xe9s";
var Opportunities_MyOpportunitiesSelected = "S\xe9lectionn\xe9(e)";
var Opportunities_MyOpportunitiesSharedWithMe = "Partag\xe9es avec moi";
var Opportunities_NoMentorship = "Aucune nouvelle connexion de mentorat";
var Opportunities_NoResultsForBrowse = "Aucune opportunit\xe9 ne correspond \xe0 votre recherche. Veuillez modifier les filtres que vous avez s\xe9lectionn\xe9s.";
var Opportunities_NoResultsForSearch = "Aucune opportunit\xe9 ne correspond \xe0 \xab\xa0{{searchTerm}}\xa0\xbb. Veuillez modifier vos termes de recherche.";
var Opportunities_NotFound_DescriptionText = "Vous n’avez peut-\xeatre pas l’autorisation de voir cette opportunit\xe9, ou cette derni\xe8re n’existe pas.";
var Opportunities_OpenedOnDate = "Ouverte le {{date}}";
var Opportunities_OpenOpportunities = "Opportunit\xe9s ouvertes";
var Opportunities_OpenOpportunitiesByJobRoleFormat = "Opportunit\xe9s ouvertes par poste";
var Opportunities_OpenOpportunitiesByType = "Opportunit\xe9s par type";
var Opportunities_OpenOpportunitiesByTypeFormat = "Top des opportunit\xe9s ouvertes par type";
var Opportunities_OpportunityEngagement = "Engagement";
var Opportunities_OtherSkills = "Autres comp\xe9tences";
var Opportunities_PartialFitLabel = "Acceptable";
var Opportunities_RecentSearches = "Recherches r\xe9centes";
var Opportunities_Relation = "Relation";
var Opportunities_Relation_Author = "Collaborateur";
var Opportunities_Relation_InterestedApplicant = "\xc7a m’int\xe9resse";
var Opportunities_Relation_SavedForLaterByUser = "Enregistr\xe9es";
var Opportunities_Relation_SelectedApplicant = "S\xe9lectionn\xe9(e)";
var Opportunities_RemoveArchive = "Supprimer l’archivage";
var Opportunities_RemoveArchived = "Supprimer l’archivage";
var Opportunities_RemoveInterest = "Supprimer l’int\xe9r\xeat";
var Opportunities_RemoveSelected = "Supprimer la s\xe9lection";
var Opportunities_RemoveShortlist = "Supprimer la pr\xe9s\xe9lection";
var Opportunities_RemoveShortlisted = "Supprimer les pr\xe9s\xe9lectionn\xe9s";
var Opportunities_ResultRange = "R\xe9sultats {{ start }}-{{ end }} sur {{ total }}";
var Opportunities_SavedForLater = "Enregistr\xe9es";
var Opportunities_Selected = "S\xe9lectionn\xe9(e)";
var Opportunities_SelectedCandidates = "Candidats s\xe9lectionn\xe9s";
var Opportunities_SelectedCandidatesTooltip = "Nombre hebdomadaire de candidats s\xe9lectionn\xe9s";
var Opportunities_SelectedMatchedCandidates = "Candidats qualifi\xe9s s\xe9lectionn\xe9s";
var Opportunities_SelectedUnmatchedCandidates = "Candidats non qualifi\xe9s s\xe9lectionn\xe9s";
var Opportunities_SharedWithYou = "Partag\xe9es avec vous";
var Opportunities_Shortlisted = "Pr\xe9s\xe9lectionn\xe9";
var Opportunities_ShowingCountOfTotalOpportunities = "Affichage de {{ count }}\xa0opportunit\xe9(s) sur {{ total }}";
var Opportunities_ShowInterest = "Montrer mon int\xe9r\xeat";
var Opportunities_SkillMatchFullLabel = "{{matched}} comp\xe9tence(s) sur {{total}}";
var Opportunities_SkillMatchLabel = "{{matched}} sur {{total}}";
var Opportunities_Skills_AddSkillPlaceholder = "Rechercher des comp\xe9tences \xe0 ajouter...";
var Opportunities_Skills_AddSkillRating = "Ajouter une \xe9valuation \xe0 la comp\xe9tence";
var Opportunities_Skills_AddSkillsAltText = "Ajouter des comp\xe9tences";
var Opportunities_Skills_AddTargetLevel = "Ajouter un niveau cible";
var Opportunities_Skills_EditSkillRating = "Modifier l’\xe9valuation de la comp\xe9tence";
var Opportunities_Skills_EditTargetLevel = "Modifier le niveau cible";
var Opportunities_Skills_Following_But_No_Rating = "La comp\xe9tence a \xe9t\xe9 ajout\xe9e au profil sans \xe9valuation";
var Opportunities_Skills_Menu_AddTargetLevel = "Ajouter un niveau cible";
var Opportunities_Skills_Menu_EditTargetLevel = "Modifier le niveau cible";
var Opportunities_Skills_Menu_RemoveTargetLevel = "Supprimer la cible";
var Opportunities_Skills_Modal_AddTargetHeader = "\xc9valuez votre expertise concernant la comp\xe9tence \xab\xa0{{ skillName }}\xa0\xbb";
var Opportunities_Skills_Modal_EditTargetHeader = "\xc9valuez votre expertise dans \xab\xa0{{ skillName }}\xa0\xbb";
var Opportunities_Skills_RemoveSkillRating = "Supprimer l’\xe9valuation de la comp\xe9tence";
var Opportunities_SkillsMatchLabel = "correspondance";
var Opportunities_SkillsMatchPercentage = "{{percent}}\xa0%";
var Opportunities_Success_AddExperience = "Cette opportunit\xe9 a \xe9t\xe9 ajout\xe9e \xe0 votre exp\xe9rience.";
var Opportunities_Success_Clone = "L’opportunit\xe9 \xab\xa0{{title}}\xa0\xbb a bien \xe9t\xe9 ajout\xe9e\xa0!";
var Opportunities_Success_UpdateApplicantStage = "Termin\xe9\xa0! L’\xe9tape de candidature a \xe9t\xe9 mise \xe0 jour.";
var Opportunities_SuggestedLearning = "Contenus sugg\xe9r\xe9s";
var Opportunities_SuggestedLearning_Description = "Cette section sugg\xe8re des formations visant \xe0 renforcer vos comp\xe9tences pour cette opportunit\xe9.";
var Opportunities_TopLocations = "Principaux lieux";
var Opportunities_TopOpportunitiesByJobRoleFormat = "Top {{count}}\xa0des opportunit\xe9s par poste";
var Opportunities_TopOpportunitiesByJobRoleFormatNoCount = "Top des opportunit\xe9s par poste";
var Opportunities_TopOpportunitiesByTypeFormat = "Top {{count}}\xa0des opportunit\xe9s ouvertes par type";
var Opportunities_TopSkillsInDemandFormat = "Top {{count}}\xa0des comp\xe9tences demand\xe9es";
var Opportunities_TypeDynamicTeamAssignment = "Affectation dynamique des \xe9quipes";
var Opportunities_TypeJobDescription = "Un emploi standard r\xe9mun\xe9r\xe9";
var Opportunities_TypeLookingForMentee = "Recherche de mentor\xe9(e)";
var Opportunities_TypeLookingForMentor = "Recherche de mentor";
var Opportunities_TypeMenteeship = "Mentor\xe9(e)";
var Opportunities_TypeMenteeshipDescription = "Recevoir les conseils d’un mentor, en particulier d’une personne exp\xe9riment\xe9e";
var Opportunities_TypeMentorship = "Mentor";
var Opportunities_TypeMentorshipDescription = "Prodiguer des conseils \xe0 une personne";
var Opportunities_TypeOther = "Autres";
var Opportunities_TypeOtherDescription = "Tout autre type d’exp\xe9rience";
var Opportunities_TypePeerMentoring = "Mentorat entre pairs";
var Opportunities_TypePermanent = "Permanent";
var Opportunities_TypeProBono = "Pro bono";
var Opportunities_TypeProject = "Projet";
var Opportunities_TypeProjectDescription = "Une t\xe2che individuelle ou collective qui permet d’atteindre un objectif particulier";
var Opportunities_TypeReverseMentoring = "Mentorat invers\xe9";
var Opportunities_TypeSecondment = "D\xe9tachement";
var Opportunities_TypeShadowing = "Shadowing";
var Opportunities_TypeShadowingDescription = "Suivre ou observer attentivement un individu";
var Opportunities_TypeStretchAssignment = "Mission \xe9largie";
var Opportunities_TypeStretchAssignmentDescription = "Un projet ou une t\xe2che qui d\xe9passe actuellement votre niveau de connaissances ou de comp\xe9tences";
var Opportunities_TypeTemporary = "Temporaire";
var Opportunities_TypeVolunteer = "B\xe9n\xe9volat";
var Opportunities_UnmatchedCandidateExplanation = "Candidat non qualifi\xe9\xa0: l’opportunit\xe9 n’est pas pr\xe9sent\xe9e \xe0 l’utilisateur car les crit\xe8res du profil utilisateur ne sont pas satisfaits. {{startAnchor}}En savoir plus{{endAnchor}}";
var Opportunities_UnmatchedSkills = "Comp\xe9tences non correspondantes";
var Opportunities_UnsavedChanges = "Ces modifications n’ont pas \xe9t\xe9 enregistr\xe9es";
var Opportunities_UserRateSkillsModal_Header = "Distinguez-vous comme candidat en \xe9valuant vos comp\xe9tences";
var Opportunities_View_Error_Get = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration de l’opportunit\xe9.";
var Opportunities_ViewAll = "Afficher toutes les opportunit\xe9s";
var Opportunities_ViewAllCollaborators = "Voir tous les collaborateurs";
var Opportunities_ViewByMatchedCandidates = "Vues par candidats qualifi\xe9s";
var Opportunities_ViewByUnmatchedCandidates = "Vues par candidats non qualifi\xe9s";
var Opportunities_Viewing = "Visualisation";
var Opportunities_ViewOpportunity = "Voir l’opportunit\xe9";
var Opportunities_ViewsAndInterest = "Vues et int\xe9r\xeat";
var Opportunities_ViewsAndInterestsTooltip = "Vues hebdomadaires uniques et int\xe9r\xeat pour les opportunit\xe9s";
var Opportunities_YourOpportunities = "Vos opportunit\xe9s";
var OpportunityApplicantSelected_NotificationTitleFormat = "{{opportunityAuthor}} vous a s\xe9lectionn\xe9(e) pour son opportunit\xe9";
var opportunityNewAuthor_NotificationTitleFormat = "{{opportunityAuthor}} vous a ajout\xe9(e) comme collaborateur \xe0 une opportunit\xe9.";
var OrganizationsController_AddFAQs = "Ajouter des FAQ";
var OrganizationsController_BackToOrgFormat = "Retour \xe0 {{orgName}}";
var OrganizationsController_Branding = "Image de marque - Param\xe8tres";
var OrganizationsController_Content = "Catalogue";
var OrganizationsController_EditImage = "Modifier l’image";
var OrganizationsController_EstimateInfo = "L’analyse des liens s’ex\xe9cutera en arri\xe8re-plan pendant environ {{time}}. Vous recevrez une notification une fois que les r\xe9sultats de l’analyse pourront \xeatre consult\xe9s.";
var OrganizationsController_FAQ = "FAQ";
var OrganizationsController_FileLog = "Journal";
var OrganizationsController_FileUpload = "Chargement de fichier";
var OrganizationsController_Groups = "Groupes";
var OrganizationsController_HelpMenu = "Menu d’aide - Param\xe8tres";
var OrganizationsController_Home = "Page d’accueil – Param\xe8tres";
var OrganizationsController_Insights = "Statistiques";
var OrganizationsController_InsightsAndUsage = "Statistiques et utilisation";
var OrganizationsController_InvitedMessageOne = "vous ont invit\xe9 \xe0 les rejoindre sur Degreed. Vous \xeates d\xe9sormais membre de";
var OrganizationsController_InviteMessageTwo = "l’organisation sur Degreed. Vous pouvez maintenant participer aux groupes de cette organisation et \xe9tudier avec vos coll\xe8gues.";
var OrganizationsController_JobRoles = "Plans";
var OrganizationsController_Links = "Liens personnalis\xe9s - Param\xe8tres";
var OrganizationsController_ManageAdvanced = "G\xe9rer les options avanc\xe9es";
var OrganizationsController_ManageCatalog = "G\xe9rer le catalogue";
var OrganizationsController_ManageFAQ = "G\xe9rer les FAQ";
var OrganizationsController_ManageGroups = "G\xe9rer les groupes";
var OrganizationsController_ManageJobRoles = "G\xe9rer les plans";
var OrganizationsController_ManageOpportunities = "G\xe9rer les opportunit\xe9s";
var OrganizationsController_ManagePathways = "G\xe9rer les parcours";
var OrganizationsController_ManagePeople = "G\xe9rer les utilisateurs";
var OrganizationsController_ManagePlans = "G\xe9rer les plans";
var OrganizationsController_ManagePublishedPathways = "G\xe9rer les parcours publi\xe9s";
var OrganizationsController_ManageSkills = "G\xe9rer les comp\xe9tences";
var OrganizationsController_Messaging = "Messages";
var OrganizationsController_NotEnoughActivity = "Activit\xe9 insuffisante";
var OrganizationsController_Opportunities = "Opportunit\xe9s";
var OrganizationsController_OrganizationDetails = "D\xe9tails de l’organisation";
var OrganizationsController_Pages = "Pages";
var OrganizationsController_Pathways = "Parcours";
var OrganizationsController_People = "Personnes";
var OrganizationsController_Permissions = "Autorisations - Param\xe8tres";
var OrganizationsController_Plans = "Plans";
var OrganizationsController_Providers = "Fournisseurs - Param\xe8tres";
var OrganizationsController_Reporting = "Rapports";
var OrganizationsController_ReportsNotAvailable = "Les rapports deviennent disponibles une fois que les ressources d’apprentissage ont \xe9t\xe9 ajout\xe9es au cours de la p\xe9riode indiqu\xe9e.";
var OrganizationsController_ScanPreferences = "Pr\xe9f\xe9rences pour l’analyse";
var OrganizationsController_Segments = "Segments";
var OrganizationsController_SelectContentTypes = "S\xe9lectionner le(s) type(s) de contenu";
var OrganizationsController_Settings = "Param\xe8tres";
var OrganizationsController_Skills = "Skills I/O";
var OrganizationsController_SkillToRoleSuggestions = "Suggestions de comp\xe9tences pour les postes";
var OrganizationsController_StartScan = "D\xe9marrer l’analyse";
var OrganizationsController_SubmitQuestion = "Soumettre une question";
var OrganizationsController_WelcomeToDegreed = "Bienvenue sur la plateforme de gestion de l’apprentissage Degreed";
var OrgAnnouncement_ActivateDesc = "Activez l’annonce pour la partager avec tous les utilisateurs ou d\xe9sactivez-la pour la masquer.";
var OrgAnnouncement_ActivateLabel = "Activer l’annonce";
var OrgAnnouncement_AddALink = "Ajouter un lien";
var OrgAnnouncement_BlankDescription = "Ce message d’espace r\xe9serv\xe9 fournit un aper\xe7u du r\xe9sultat final. Vous pouvez modifier le texte en personnalisant le champ ci-dessus.";
var OrgAnnouncement_Desc = "Partagez une annonce avec votre organisation sur la page d’accueil.";
var OrgAnnouncement_DescriptionPlaceholder = "La description d’un parcours, d’un plan ou d’un \xe9l\xe9ment de contenu";
var OrgAnnouncement_ImageDesc = "La taille recommand\xe9e est de 114\xa0px en hauteur et max. 190\xa0px en largeur.";
var OrgAnnouncement_ImageDescNew = "La taille recommand\xe9e est de 348\xa0px en largeur et 192\xa0px en hauteur.";
var OrgAnnouncement_Label = "Annonce au niveau de l’organisation";
var OrgAnnouncement_LinkNamePlaceholder = "Voir le parcours";
var OrgAnnouncement_LinkUrlHelperText = "Ajouter un lien vers un \xe9l\xe9ment ou une page sur Degreed.";
var OrgAnnouncement_RetrievingError = "Une erreur est survenue lors de la r\xe9cup\xe9ration de l’annonce au niveau de l’organisation.";
var OrgAnnouncement_TitlePlaceholder = "Le titre de l’\xe9l\xe9ment que vous partagez";
var OrgFaqCtrl_AnswerText = "Le texte de la r\xe9ponse s’affichera ici.";
var OrgFaqCtrl_EnterSearchTerm = "Saisissez un terme de recherche ci-dessus.";
var OrgFaqCtrl_FaqHeading = "FAQ";
var OrgFaqCtrl_MaxResultsNarrowYourSearch = "Il est possible que certaines FAQ ne s’affichent pas. Essayez d’affiner la recherche.";
var OrgFaqCtrl_NewQuestion = "Nouvelle question";
var OrgFaqCtrl_NoFaqsFoundFormat = "Aucune FAQ pour {{orgName}} n’a \xe9t\xe9 trouv\xe9e.";
var OrgFaqCtrl_RemoveFaqButton = "Supprimer les FAQ";
var OrgFaqCtrl_RemoveFaqConfirmContinue = "Souhaitez-vous r\xe9ellement continuer ?";
var OrgFaqCtrl_RemoveFaqDescriptionFormat = "Cela supprimera d\xe9finitivement {{question}} des FAQ de votre organisation.";
var OrgFaqCtrl_RemoveFaqHeadingFormat = "Supprimer {{question}}";
var OrgFaqCtrl_SearchForFaq = "Rechercher des FAQ";
var OrgFtp_AllyText_CloseDetailsFormat = "Fermer les d\xe9tails pour\xa0: {{ error }}";
var OrgFtp_AllyText_SeeDetailsFormat = "Afficher les d\xe9tails pour\xa0: {{ error }}";
var OrgFtp_ChangedRowPluralFormat = "{{ count }}\xa0lignes ont \xe9t\xe9 trait\xe9es";
var OrgFtp_ChangedRowSingleFormat = "1\xa0ligne a \xe9t\xe9 trait\xe9e";
var OrgFtp_ClientUserFileWarning = "Le fichier utilisateur influe sur les automatisations, les rapports et d’autres op\xe9rations critiques. Si votre organisation utilise un fichier utilisateur automatis\xe9, il est possible que les modifications charg\xe9es soient \xe9cras\xe9es lors du prochain traitement de ce fichier.";
var OrgFtp_ContactSupport = "Contacter l’assistance";
var OrgFtp_CorrectYourRows = "Veuillez v\xe9rifier votre fichier et corriger ces lignes.";
var OrgFtp_Discard = "Abandonner";
var OrgFtp_DiscardConfirmationMessage = "Lorsque vous abandonnez un fichier, le syst\xe8me ne le traite pas. Voulez-vous vraiment abandonner ce fichier \xa0?";
var OrgFtp_DiscardFile = "Ignorer le fichier";
var OrgFtp_DragAndDrop = "D\xe9posez un fichier ou cliquez pour l’ajouter.";
var OrgFtp_DragAndDropImage = "Faites un glisser-d\xe9poser ou cliquez pour charger une image.";
var OrgFtp_ErrorDiscardingFile = "Erreur lors de l’abandon du fichier";
var OrgFtp_ErrorFileDetails = "Une erreur est survenue lors de l’extraction des d\xe9tails du fichier";
var OrgFtp_ErrorUnknownFormat = "Une erreur de type \xab\xa0{{ error }}\xa0\xbb est survenue";
var OrgFtp_File_Error_DelimiterNotFound_Description = "Veuillez v\xe9rifier que le fichier ne contient pas de caract\xe8res sp\xe9ciaux et le renvoyer.";
var OrgFtp_File_Error_DelimiterNotFound_Title = "Caract\xe8re sp\xe9cial d\xe9tect\xe9";
var OrgFtp_File_Error_DescriptionColumnMissing_Description = "La colonne Description est requise pour ce fichier. Ajoutez cette colonne avec une valeur pour chaque utilisateur, puis renvoyez le fichier.";
var OrgFtp_File_Error_DescriptionColumnMissing_Title = "Colonne Description manquante";
var OrgFtp_File_Error_DuplicateColumnFound_Description = "Les noms de colonne doivent \xeatre uniques.";
var OrgFtp_File_Error_DuplicateColumnFound_Title = "Colonne en double trouv\xe9e";
var OrgFtp_File_Error_ErrorParsingFile_Description = "Veuillez v\xe9rifier si le type et le nom de votre fichier r\xe9pondent \xe0 la configuration requise.";
var OrgFtp_File_Error_ErrorParsingFile_Title = "Impossible d’ouvrir le fichier";
var OrgFtp_File_Error_ErrorParsingRows_Description = "Veuillez v\xe9rifier si le type et le nom de votre fichier r\xe9pondent \xe0 la configuration requise.";
var OrgFtp_File_Error_ErrorParsingRows_Title = "Impossible d’analyser les lignes";
var OrgFtp_File_Error_ExternalIdColumnMissing_Description = "La colonne ID externe est requise pour ce fichier. Ajoutez cette colonne avec une valeur pour chaque utilisateur, puis renvoyez le fichier.";
var OrgFtp_File_Error_ExternalIdColumnMissing_Title = "Colonne d’identifiant externe manquante";
var OrgFtp_File_Error_FileIsEmpty_Description = "Il semble que le fichier soit vide. Veuillez r\xe9essayer.";
var OrgFtp_File_Error_FileIsEmpty_Title = "Le fichier est vide";
var OrgFtp_File_Error_FileNotFound_Description = "Nous n’avons pas pu localiser le fichier lors de la tentative de traitement. Veuillez r\xe9essayer.";
var OrgFtp_File_Error_FileNotFound_Title = "Fichier non trouv\xe9";
var OrgFtp_File_Error_InvalidFields_Description = "Ce fichier comporte des champs non valides (\xab\xa0Valeur\xa0\xbb et \xab\xa0Type\xa0\xbb) et ne peut donc pas \xeatre trait\xe9.";
var OrgFtp_File_Error_InvalidFields_Title = "Champs non valides";
var OrgFtp_File_Error_NameColumnMissing_Description = "La colonne Nom est requise pour ce fichier. Ajoutez cette colonne avec une valeur pour chaque utilisateur, puis renvoyez le fichier.";
var OrgFtp_File_Error_NameColumnMissing_Title = "Colonne Nom manquante";
var OrgFtp_File_Error_NoColumnsFound_Description = "Les fichiers doivent contenir les colonnes requises.";
var OrgFtp_File_Error_NoColumnsFound_Title = "Aucune colonne trouv\xe9e";
var OrgFtp_File_Error_NoDatabaseFileInfo_Description = "Veuillez v\xe9rifier si le type et le nom de votre fichier r\xe9pondent \xe0 la configuration requise";
var OrgFtp_File_Error_NoDatabaseFileInfo_Title = "Nom de fichier non reconnu";
var OrgFtp_File_Error_NoFileInfoReturned_Description = "Veuillez v\xe9rifier si le type et le nom de votre fichier correspondent \xe0 la configuration requise.";
var OrgFtp_File_Error_NoFileInfoReturned_Title = "Nom de fichier non reconnu";
var OrgFtp_File_Error_NotifyParseFailure_Description = "Ce fichier ne contient aucun enregistrement. Veuillez v\xe9rifier votre fichier et le renvoyer.";
var OrgFtp_File_Error_NotifyParseFailure_Title = "Ce fichier ne contient aucun enregistrement";
var OrgFtp_File_Error_ProcessingError_Description = 'Les utilisateurs ont \xe9t\xe9 import\xe9s, mais une erreur inconnue est survenue \xe0 la derni\xe8re \xe9tape du processus. Veuillez contacter <a href="mailto:support@degreed.com">support@degreed.com</a>';
var OrgFtp_File_Error_TypeColumnMissing_Description = "La colonne Type est requise pour ce fichier. Ajoutez cette colonne avec une valeur pour chaque utilisateur, puis renvoyez le fichier.";
var OrgFtp_File_Error_TypeColumnMissing_Title = "Colonne Type manquante";
var OrgFtp_File_Error_UniqueIdColumnMissing_Description = "La colonne ID unique est requise pour les fichiers utilisateur. Ajoutez cette colonne avec une valeur pour chaque utilisateur, puis renvoyez le fichier.";
var OrgFtp_File_Error_UniqueIdColumnMissing_Title = "Colonne d’identifiant unique manquante";
var OrgFtp_File_Error_Unknown_Description = 'Une erreur inconnue s’est produite. Merci d’envoyer une demande d’assistance sur <a href="https://degreed.zendesk.com/hc/requests/new">https://degreed.zendesk.com/hc/requests/new</a> en indiquant le nom du fichier concern\xe9 afin que nous puissions vous aider \xe0 r\xe9soudre votre probl\xe8me.';
var OrgFtp_File_Error_Unknown_Title = "Erreur inconnue";
var OrgFtp_File_Error_UnrecognizedExtension_Description = "Degreed prend en charge les formats .csv ou .txt pour les fichiers d\xe9limit\xe9s en texte brut, ou .xls ou .xlsx pour les fichiers Excel.";
var OrgFtp_File_Error_UnrecognizedExtension_Title = "Extension non reconnue";
var OrgFtp_File_Error_UnsupportedExtension_Description = "Degreed prend en charge les formats .csv ou .txt pour les fichiers d\xe9limit\xe9s en texte brut, ou .xls ou .xlsx pour les fichiers Excel.";
var OrgFtp_File_Error_UnsupportedExtension_Title = "Extension non reconnue";
var OrgFtp_File_Error_ValueColumnMissing_Description = "La colonne Valeur est requise pour ce fichier. Ajoutez cette colonne avec une valeur pour chaque utilisateur, puis renvoyez le fichier.";
var OrgFtp_File_Error_ValueColumnMissing_Title = "Colonne Valeur manquante";
var OrgFtp_File_Rejected_Error_Format = "L’erreur suivante s’est produite lors du traitement de ce fichier : <strong>{{error}}</strong>. Veuillez corriger cette erreur et r\xe9essayer.";
var OrgFtp_FileError = "Ce fichier ne peut \xeatre trait\xe9 en raison d’une erreur";
var OrgFtp_LandingPage_Description_BulkOpportunities = "Ajouter, mettre \xe0 jour ou supprimer des opportunit\xe9s";
var OrgFtp_LandingPage_Description_BulkTaxonomyRoles = "Ajouter et mettre \xe0 jour des postes";
var OrgFtp_LandingPage_Description_BulkTaxonomySkills = "Ajouter et mettre \xe0 jour des comp\xe9tences";
var OrgFtp_LandingPage_Description_ClientUser = "Ajouter, mettre \xe0 jour ou supprimer des utilisateurs";
var OrgFtp_LandingPage_Description_Completion = "Ajouter, mettre \xe0 jour ou supprimer des \xe9l\xe9ments de formation termin\xe9s";
var OrgFtp_LandingPage_Description_Content = "Ajouter, mettre \xe0 jour ou supprimer du contenu";
var OrgFtp_LandingPage_Description_Groups = "Ajouter, mettre \xe0 jour ou supprimer des groupes";
var OrgFtp_LandingPage_Description_RequiredLearning = "Ajouter, mettre \xe0 jour ou supprimer des formations obligatoires";
var OrgFtp_LandingPage_Description_UserUpdate = "Ajouter, mettre \xe0 jour ou supprimer des attributs utilisateurs";
var OrgFtp_LandingPage_Type_Badge = "Insigne";
var OrgFtp_LandingPage_Type_BulkOpportunities = "Opportunit\xe9s";
var OrgFtp_LandingPage_Type_BulkTaxonomyRoles = "Postes";
var OrgFtp_LandingPage_Type_BulkTaxonomySkills = "Comp\xe9tences";
var OrgFtp_LandingPage_Type_ClientUser = "Ajouter des utilisateurs";
var OrgFtp_LandingPage_Type_Completion = "Compl\xe9tion";
var OrgFtp_LandingPage_Type_Content = "Contenu";
var OrgFtp_LandingPage_Type_Groups = "Groupes";
var OrgFtp_LandingPage_Type_JobRole = "Poste";
var OrgFtp_LandingPage_Type_Opportunity = "Opportunit\xe9";
var OrgFtp_LandingPage_Type_RequiredLearning = "Formation obligatoire";
var OrgFtp_LandingPage_Type_Skill = "Comp\xe9tence";
var OrgFtp_LandingPage_Type_SkillAssessment = "Test d’\xe9valuation de comp\xe9tences";
var OrgFtp_LandingPage_Type_UserUpdate = "Mise \xe0 jour d’utilisateurs";
var OrgFtp_Note = "Remarque";
var OrgFtp_PendingChangedRowPluralFormat = "{{ count }}\xa0lignes seront trait\xe9es";
var OrgFtp_PendingChangedRowSingleFormat = "1\xa0ligne sera trait\xe9e";
var OrgFtp_PendingFileWarning = "Le traitement de ce fichier n’est pas termin\xe9. Si vous quittez cette page, votre fichier ne sera pas trait\xe9 et vos modifications seront perdues.";
var OrgFtp_PendingRejectedRowPluralFormat = "{{ count }}\xa0lignes seront rejet\xe9es";
var OrgFtp_PendingRejectedRowSingleFormat = "1\xa0ligne sera rejet\xe9e";
var OrgFtp_PendingWarningRowPluralFormat = "Ajouter  {{ count }}\xa0exp\xe9rience";
var OrgFtp_PendingWarningRowSingleFormat = "1\xa0ligne contiendra des avertissements";
var OrgFtp_PreviewingXOfYRows_PluralFormat = "Pr\xe9visualisation de 10\xa0lignes sur {{ total }}";
var OrgFtp_Processing = "Ce fichier est en cours de traitement.";
var OrgFtp_ProcessingError = "Le fichier a \xe9t\xe9 partiellement trait\xe9, mais une erreur est survenue \xe0 l’issue du traitement";
var OrgFtp_RejectedRowPluralFormat = "{{ count }}\xa0lignes ont \xe9t\xe9 rejet\xe9es";
var OrgFtp_RejectedRowSingleFormat = "1\xa0ligne a \xe9t\xe9 rejet\xe9e";
var OrgFtp_ReviewAndSubmit = "V\xe9rifier et envoyer";
var OrgFtp_Row_Error_ConflictingRecord_Description = "Ce fichier contient des enregistrements en conflit";
var OrgFtp_Row_Error_ConflictingRecord_Title = "Enregistrements en conflit";
var OrgFtp_Row_Error_ContentNotFound_Description = "Contenu introuvable dans votre organisation";
var OrgFtp_Row_Error_ContentNotFound_Title = "Contenu introuvable";
var OrgFtp_Row_Error_CustomAttributeTypeMissmatch_Description = "Il est impossible de convertir la valeur de l’attribut personnalis\xe9 pour qu’il corresponde au type de donn\xe9e sp\xe9cifi\xe9e.";
var OrgFtp_Row_Error_CustomAttributeTypeMissmatch_Title = "Type d’attribut incompatible";
var OrgFtp_Row_Error_DuplicateCategoryName_Title = "Duplicate Category Name";
var OrgFtp_Row_Error_DuplicateEmail_Description = "Les lignes suivantes contiennent des adresses e-mail en double. Elles ont donc \xe9t\xe9 rejet\xe9es.";
var OrgFtp_Row_Error_DuplicateEmail_Title = "E-mails en double d\xe9tect\xe9s";
var OrgFtp_Row_Error_DuplicateExternalId_Title = "Duplicate External Id";
var OrgFtp_Row_Error_DuplicateLocalizeSkillName_Title = "Nom de comp\xe9tence traduit en double";
var OrgFtp_Row_Error_DuplicateRow_Description = "Les lignes suivantes constituent des doublons. Elles ont donc \xe9t\xe9 rejet\xe9es.";
var OrgFtp_Row_Error_DuplicateRow_Title = "Ligne en double d\xe9tect\xe9e";
var OrgFtp_Row_Error_DuplicateSkillName_Title = "Nom de comp\xe9tence en double";
var OrgFtp_Row_Error_DuplicateSynonym_Title = "Synonyme en double";
var OrgFtp_Row_Error_EmptyContentType_Description = "Il manque un type de contenu dans les lignes suivantes.";
var OrgFtp_Row_Error_EmptyContentType_Title = "Type de contenu vide";
var OrgFtp_Row_Error_EmptyUpdateType_Description = "Il manque un type de mise \xe0 jour dans les lignes suivantes.";
var OrgFtp_Row_Error_EmptyUpdateType_Title = "Type de mise \xe0 jour vide";
var OrgFtp_Row_Error_FieldExceedsMaxLength_Title = "Le champ d\xe9passe le nombre maximal de caract\xe8res.";
var OrgFtp_Row_Error_InvalidDuration_Description = "\xab\xa0Dur\xe9e\xa0\xbb doit \xeatre une valeur num\xe9rique";
var OrgFtp_Row_Error_InvalidDuration_Title = "Dur\xe9e non valide";
var OrgFtp_Row_Error_InvalidLanguageCode_Title = "Code de langue non valide";
var OrgFtp_Row_Error_InvalidLearningMinutes_Description = "\xab\xa0Minutes de formation\xa0\xbb doit \xeatre une valeur num\xe9rique";
var OrgFtp_Row_Error_InvalidLearningMinutes_Title = "Minutes de formation non valides";
var OrgFtp_Row_Error_MaximumRowWidthExceeded_Description = "Les lignes suivantes ont d\xe9pass\xe9 la largeur maximale autoris\xe9e.";
var OrgFtp_Row_Error_MaximumRowWidthExceeded_Title = "Largeur de ligne maximale d\xe9pass\xe9e";
var OrgFtp_Row_Error_MissingRequiredColumn_Description = "Il manque une colonne requise dans les lignes suivantes.";
var OrgFtp_Row_Error_MissingRequiredColumn_Title = "Colonne requise manquante";
var OrgFtp_Row_Error_Unknown_Description = 'Une erreur inconnue s’est produite. Merci d’envoyer une demande d’assistance sur <a href="https://degreed.zendesk.com/hc/requests/new">https://degreed.zendesk.com/hc/requests/new</a> en indiquant le nom du fichier concern\xe9 afin que nous puissions vous aider \xe0 r\xe9soudre votre probl\xe8me.';
var OrgFtp_Row_Error_Unknown_Title = "Erreur inconnue";
var OrgFtp_Row_Error_UnknownCategoryName_Title = "Unknown Category Name";
var OrgFtp_Row_Error_UnknownContentType_Description = "Les lignes suivantes comportent un type de contenu inconnu.";
var OrgFtp_Row_Error_UnknownContentType_Title = "Type de contenu inconnu";
var OrgFtp_Row_Error_UnknownGroup_Description = "Cr\xe9ez le nom du groupe avant d’ajouter ou de supprimer des utilisateurs.";
var OrgFtp_Row_Error_UnknownGroup_Title = "Nom de groupe inconnu";
var OrgFtp_Row_Error_UnknownPathway_Description = "Cr\xe9ez le nom du parcours avant d’ajouter ou de supprimer des utilisateurs.";
var OrgFtp_Row_Error_UnknownPathway_Title = "Nom de parcours inconnu";
var OrgFtp_Row_Error_UnknownPlan_Description = "Cr\xe9ez le nom du plan avant d’ajouter ou de supprimer des utilisateurs.";
var OrgFtp_Row_Error_UnknownPlan_Title = "Nom de plan inconnu";
var OrgFtp_Row_Error_UnknownSkillName_Title = "Unknown Skill Name";
var OrgFtp_Row_Error_UnknownSkillPlan_Description = "Cr\xe9ez le nom du plan avant d’ajouter ou de supprimer des utilisateurs.";
var OrgFtp_Row_Error_UnknownSkillPlan_Title = "Nom de plan inconnu";
var OrgFtp_Row_Error_UnknownUpdateType_Description = "Les lignes suivantes comportent un type de mise \xe0 jour inconnu.";
var OrgFtp_Row_Error_UnknownUpdateType_Title = "Type de mise \xe0 jour inconnu";
var OrgFtp_Row_Error_UnsupportedDisplayLanguage_Description = "Les lignes suivantes comportent une langue d’affichage non prise en charge.";
var OrgFtp_Row_Error_UnsupportedDisplayLanguage_Title = "Langue d’affichage non prise en charge";
var OrgFtp_Row_Error_UnsupportedFileContentType_Description = "Les lignes suivantes comportent un type de contenu non pris en charge.";
var OrgFtp_Row_Error_UnsupportedFileContentType_Title = "Type de contenu de fichier non pris en charge";
var OrgFtp_Row_Error_UserNotFound_Description = "Utilisateur introuvable dans votre organisation";
var OrgFtp_Row_Error_UserNotFound_Title = "Utilisateur introuvable";
var OrgFtp_RowNumber = "Num\xe9ro de ligne";
var OrgFtp_Select = "S\xe9lectionner";
var OrgFtp_SelectFileTypeToUpload = "S\xe9lectionnez le type de fichier que vous souhaitez utiliser.";
var OrgFtp_StatusBadge_Error = "Trait\xe9 avec des erreurs";
var OrgFtp_StatusBadge_Pending = "En attente";
var OrgFtp_StatusBadge_Processing = "Traitement en cours";
var OrgFtp_StatusBadge_ProcessingError = "Erreur de fin de traitement";
var OrgFtp_StatusBadge_Rejected = "Rejet\xe9";
var OrgFtp_StatusBadge_Success = "Trait\xe9";
var OrgFtp_StatusBadge_Warning = "Trait\xe9 avec des avertissements";
var OrgFtp_SubmitFile = "Envoyer le fichier";
var OrgFtp_Success = "Termin\xe9\xa0!";
var OrgFtp_TemplateInstructions = "Instructions sur le mod\xe8le";
var OrgFtp_TemplateInstructions_LongFormInstructions_Header1 = "T\xe9l\xe9chargez le mod\xe8le pour commencer";
var OrgFtp_TemplateInstructions_LongFormInstructions_Header2 = "Saisissez vos donn\xe9es";
var OrgFtp_TemplateInstructions_LongFormInstructions_Header3 = "Renommez et enregistrez le fichier";
var OrgFtp_TemplateInstructions_LongFormInstructions_Link1 = "T\xe9l\xe9charger le mod\xe8le";
var OrgFtp_TemplateInstructions_LongFormInstructions_Para2 = "Compl\xe9tez le mod\xe8le en renseignant vos donn\xe9es et en suivant les instructions donn\xe9es dans les onglets \xab\xa0Explications du champ\xa0\xbb ou \xab\xa0Guide du fichier\xa0\xbb.";
var OrgFtp_TemplateInstructions_LongFormInstructions_Para3 = "Utilisez le format de nom de fichier recommand\xe9\xa0: {{nameFormat}}.";
var OrgFtp_TemplateInstructions_LongFormInstructions_Para4 = "Chaque fichier doit avoir un nom unique. Si plusieurs fichiers sont g\xe9n\xe9r\xe9s au cours d’une seule et m\xeame journ\xe9e, il est possible d’ajouter les minutes (MM) et les secondes (SS) \xe0 la date du fichier.";
var OrgFtp_TemplateInstructions_LongFormInstructions_Para5 = "Rendez-vous dans le {{knowledgeCenterLinkStart}}Centre de connaissances{{knowledgeCenterLinkEnd}} pour en savoir plus.";
var OrgFtp_ThereMightBeSomeDelay = "Les modifications apport\xe9es \xe0 votre fichier peuvent mettre du temps \xe0 appara\xeetre dans Degreed.";
var OrgFtp_Types_RowsWithErrors = "Lignes rejet\xe9es";
var OrgFtp_Types_RowsWithWarnings = "Lignes avec avertissements";
var OrgFtp_TypesTooltips_RowsWithErrors = "Lignes de donn\xe9es contenant des erreurs et non trait\xe9es par Degreed.";
var OrgFtp_TypesTooltips_RowsWithWarnings = "Lignes trait\xe9es par Degreed mais contenant des valeurs inconnues, qui ont \xe9t\xe9 ignor\xe9es.";
var OrgFtp_UploadFile = "Charger le fichier";
var OrgFtp_ViewFileDetails = "Afficher les d\xe9tails du fichier";
var OrgFtp_ViewFileLog = "Afficher le journal";
var OrgFtp_WarningRowPluralFormat = "{{ count }}\xa0lignes contiennent des avertissements";
var OrgFtp_WarningRowSingleFormat = "1\xa0ligne contient des avertissements";
var OrgFtp_WillBeRejectedRowPluralFormat = "{{ count }}\xa0lignes seront rejet\xe9es";
var OrgFtp_WillBeRejectedRowSingleFormat = "1\xa0ligne sera rejet\xe9e";
var OrgFtp_WillChangeRowPluralFormat = "{{ count }}\xa0lignes seront trait\xe9es";
var OrgFtp_WillChangeRowSingleFormat = "1\xa0ligne sera trait\xe9e";
var OrgFtp_WillHaveWarningRowPluralFormat = "{{ count }}\xa0lignes contiendront des avertissements";
var OrgFtp_WillHaveWarningRowSingleFormat = "1\xa0ligne contiendra des avertissements";
var OrgFtp_YourFileIsBeingProcessed = "Votre fichier {{ type }} est en cours de traitement";
var OrgGroupsCtrl_AdministrativeDynamic = "Administrative (Dynamic)";
var OrgGroupsCtrl_AdministrativeGroup = "Administratif";
var OrgGroupsCtrl_AdministrativeStatic = "Administrative (Static)";
var OrgGroupsCtrl_AvailableGroupsHeading = "Groupes disponibles";
var OrgGroupsCtrl_BecomeMember = "Devenir membre de ce groupe";
var OrgGroupsCtrl_Closed = "Closed";
var OrgGroupsCtrl_ClosedGroup = "Ferm\xe9";
var OrgGroupsCtrl_CreateAGroup = "Cr\xe9er un groupe";
var OrgGroupsCtrl_DeletePluralPrompt = "Voulez-vous vraiment supprimer {{ count }} groupes \xa0?";
var OrgGroupsCtrl_DeletePrompt = "Voulez-vous vraiment supprimer ce groupe \xa0?";
var OrgGroupsCtrl_Dynamic = "Dynamique";
var OrgGroupsCtrl_GroupMembers = "Membres";
var OrgGroupsCtrl_GroupName = "Nom";
var OrgGroupsCtrl_GroupsTitle = "Groupes";
var OrgGroupsCtrl_GroupVisibility = "Visibilit\xe9";
var OrgGroupsCtrl_JoinGroup = "Rejoindre le groupe \xab\xa0{{name}}\xa0\xbb";
var OrgGroupsCtrl_Leave = "Quitter";
var OrgGroupsCtrl_LeaveGroup = "Quitter le groupe \xab\xa0{{name}}\xa0\xbb";
var OrgGroupsCtrl_LeaveGroupModalBodyText = "Vous ne recevrez plus d’e-mails de groupe ni d’\xe9l\xe9ments partag\xe9s avec le groupe.";
var OrgGroupsCtrl_LeaveGroupModalHeader = "Souhaitez-vous r\xe9ellement quitter le groupe \xa0?";
var OrgGroupsCtrl_MyGroupsHeading = "Mes groupes";
var OrgGroupsCtrl_NoGroupsCreatedMessage = "Aucun groupe n’a \xe9t\xe9 cr\xe9\xe9 pour cette organisation.";
var OrgGroupsCtrl_NoGroupsMatchMessage = "Aucun groupe de cette organisation ne correspond aux termes de la recherche.";
var OrgGroupsCtrl_NumberOfMembersFormat = "{{count}} membres";
var OrgGroupsCtrl_Open = "Open";
var OrgGroupsCtrl_OpenGroup = "Ouvert";
var OrgGroupsCtrl_Private = "Private";
var OrgGroupsCtrl_PrivateGroup = "Priv\xe9";
var OrgGroupsCtrl_RequestGroupMembership = "Demander \xe0 rejoindre le groupe {{name}}";
var OrgGroupsCtrl_RequestMembership = "Demander \xe0 s’abonner au groupe";
var OrgGroupsCtrl_RequestPending = "Demande en attente";
var OrgGroupsCtrl_SearchforGroup = "Rechercher un groupe";
var OrgGroupsCtrl_Static = "Statique";
var OrgGroupsCtrl_ThreeOrLess = "3 ou moins";
var OrgGroupsCtrl_ThreeOrLessMembers = "3\xa0membres ou moins";
var OrgGroupsCtrl_UploadGroups = "Charger des groupes";
var OrgGroupsCtrl_UploadGroupsDescription = "Vous pouvez t\xe9l\xe9charger plusieurs groupes \xe0 la fois en les incluant dans un fichier avec le mod\xe8le suivant.";
var OrgGroupsCtrl_UploadGroupsError = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors du t\xe9l\xe9chargement des groupes.";
var OrgInternalContent_AddNewContentFormat = "Ajouter un nouveau {{inputType}}";
var OrgInternalContent_AddNewDisplayArticle = "Ajouter un nouvel article";
var OrgInternalContent_AddNewDisplayAssessment = "Ajouter un nouveau test d’\xe9valuation";
var OrgInternalContent_AddNewDisplayCourse = "Ajouter un nouveau cours";
var OrgInternalContent_AddNewDisplayEpisode = "Ajouter un nouveau podcast";
var OrgInternalContent_AddNewDisplayEvent = "Ajouter un nouvel \xe9v\xe9nement";
var OrgInternalContent_AddNewDisplayPost = "Ajouter une nouvelle publication";
var OrgInternalContent_AddNewDisplayVideo = "Ajouter une nouvelle vid\xe9o";
var OrgInternalContent_ContentType = "Type de contenu";
var OrgInternalContent_ContentUse = "Le contenu est utilis\xe9 dans :";
var OrgInternalContent_DeleteAllReferences = "Supprimer du catalogue et de toutes les autres r\xe9f\xe9rences";
var OrgInternalContent_DeleteCatalogOnly = "Supprimer uniquement du catalogue";
var OrgInternalContent_DeleteCatalogOnlyDesc = "Si ce contenu a \xe9t\xe9 ajout\xe9 \xe0 des lots, toutes les associations avec ces lots seront supprim\xe9es. Les utilisateurs ne verront plus cet \xe9l\xe9ment de contenu dans le lot qui a \xe9t\xe9 partag\xe9 avec eux.";
var OrgInternalContent_DeleteSingleContentFormat = "\xcates-vous s\xfbr que vous voulez supprimer {{title}} \xa0?";
var OrgInternalContent_EditContentFormat = "Modifier {{inputType}}";
var OrgInternalContent_RestrictedContentNote = "<strong>Remarque :</strong> Ce {{inputType}} est limit\xe9 \xe0 un certain public et peut ne pas \xeatre accessible \xe0 tous les membres de l’organisation.";
var OrgInternalContent_ValidateCategoryRequired = "Veuillez ajouter au moins une cat\xe9gorie.";
var OrgInternalContent_ValidateGroupSelectionRequired = "Saisissez les groupes pour lesquels ce contenu doit \xeatre visible";
var OrgInternalContent_ValidateNeedEndDate = "Si une date de d\xe9but est renseign\xe9e, la date de fin doit \xeatre indiqu\xe9e.";
var OrgInternalContent_ValidateNumber = "Cette valeur doit \xeatre un nombre valide et raisonnable.";
var OrgInternalContent_ValidateScormRequired = "Un package SCORM doit \xeatre fourni si cette option est coch\xe9e.";
var OrgInternalContent_ValidateTitleRequired = "L’intitul\xe9 doit \xeatre renseign\xe9.";
var OrgInternalContent_ValidateURLMayBeInvalid = "Cette URL peut \xeatre invalide.";
var OrgInternalContentCtrl_AddGroups = "Ajouter des groupes";
var OrgInternalContentCtrl_AddToPathway = "Ajouter au parcours";
var OrgInternalContentCtrl_AddTopics = "Ajouter des comp\xe9tences";
var OrgInternalContentCtrl_AssessmentUnavailableError = "D\xe9sol\xe9 ! Ce test d'\xe9valuation n'est pas disponible.";
var OrgInternalContentCtrl_BulkEditItemsFormat = "Modifier en bloc : {{count}} articles s\xe9lectionn\xe9s";
var OrgInternalContentCtrl_ClearCategories = "Effacer les cat\xe9gories";
var OrgInternalContentCtrl_ContentOwner = "Propri\xe9taire";
var OrgInternalContentCtrl_ContentTitle = "Catalogue";
var OrgInternalContentCtrl_CourseProperties = "Propri\xe9t\xe9s du cours";
var OrgInternalContentCtrl_Delete = "Supprimer";
var OrgInternalContentCtrl_DialogConfirmBulkDeleteItems = "Voulez-vous vraiment supprimer {{count}} \xe9l\xe9ment(s) de votre catalogue interne \xa0?";
var OrgInternalContentCtrl_DialogConfirmClearCategories = "Souhaitez-vous r\xe9ellement effacer les cat\xe9gories existantes des \xe9l\xe9ments s\xe9lectionn\xe9s ?";
var OrgInternalContentCtrl_DialogConfirmDeleteItemFormat = "Etes-vous s\xfbr que vous voulez supprimer {{title}} ?";
var OrgInternalContentCtrl_Edit = "Modifier";
var OrgInternalContentCtrl_FlagAsInappropriate = "Signaler comme inappropri\xe9";
var OrgInternalContentCtrl_GenericError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de cette action. Ce n’est pas votre faute et nous mettons tout en œuvre pour r\xe9soudre le probl\xe8me.";
var OrgInternalContentCtrl_InputMetricCompletions = "\xc9l\xe9ments termin\xe9s";
var OrgInternalContentCtrl_InputMetricDateAdded = "Date d’ajout";
var OrgInternalContentCtrl_InputMetricDateUpdated = "Date de mise \xe0 jour";
var OrgInternalContentCtrl_InputMetricNone = "Aucun(e)";
var OrgInternalContentCtrl_InputMetricRating = "\xc9valuations";
var OrgInternalContentCtrl_InputMetricRecommendations = "Partages";
var OrgInternalContentCtrl_InputMetricTakeaways = "Avis";
var OrgInternalContentCtrl_InputMetricViews = "Vues";
var OrgInternalContentCtrl_InternalProvider = "Interne";
var OrgInternalContentCtrl_MakeASelection = "Faites votre choix ci-dessous";
var OrgInternalContentCtrl_MoreDetails = "Plus de d\xe9tails";
var OrgInternalContentCtrl_Recommend = "Partage";
var OrgInternalContentCtrl_RemoveItems = "Supprimer {{count}} \xe9l\xe9ments";
var OrgInternalContentCtrl_ReportAProblem = "Signaler un probl\xe8me";
var OrgInternalContentCtrl_ReSyncDetails = "Re-synchroniser les d\xe9tails";
var OrgInternalContentCtrl_SearchCatalog = "Rechercher dans le catalogue";
var OrgInternalContentCtrl_SearchErrorMessage = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration des r\xe9sultats du contenu interne.";
var OrgInternalContentCtrl_SetGoal = "D\xe9finir un objectif";
var OrgInternalContentCtrl_SuccessfulAddContent = "Ajout\xe9 avec succ\xe8s {{title}}";
var OrgInternalContentCtrl_SuccessfulUpdateContent = "Mise \xe0 jour r\xe9ussie {{title}}";
var OrgInternalContentCtrl_ValidateCategoryRequired = "Veuillez ajouter au moins une cat\xe9gorie.";
var OrgInternalContentCtrl_ValidateNeedEndDate = "Si une date de d\xe9but est renseign\xe9e, la date de fin doit \xeatre indiqu\xe9e.";
var OrgInternalContentCtrl_ValidateNumber = "Cette valeur doit \xeatre un nombre valide et raisonnable.";
var OrgInternalContentCtrl_ValidateScormRequired = "Un package SCORM doit \xeatre fourni si cette option est coch\xe9e.";
var OrgInternalContentCtrl_ValidateTitleRequired = "L’intitul\xe9 doit \xeatre renseign\xe9.";
var OrgInternalContentCtrl_ValidateURLMayBeInvalid = "Cette URL peut \xeatre invalide.";
var OrgInternalContentCtrl_ViewDetails = "Afficher les d\xe9tails";
var OrgInternalContentCtrl_ViewInGoals = "Afficher dans les objectifs";
var OrgInternalContentModalCtrl_DuplicatesDescriptionLabel = "Description\xa0:";
var OrgInternalContentModalCtrl_DuplicatesGroupsCount = "{{count}} groupes";
var OrgInternalContentModalCtrl_DuplicatesGroupsLabel = "Groupes\xa0:";
var OrgInternalContentModalCtrl_DuplicatesHeader = "Doublons ({{count}})";
var OrgInternalContentModalCtrl_DuplicatesTopicsCount = "{{count}}\xa0comp\xe9tences";
var OrgInternalContentModalCtrl_DuplicatesTopicsLabel = "Comp\xe9tences\xa0:";
var OrgInternalContentSvc_DeletionConfirmationMessageFormat = "Etes-vous s\xfbr que vous voulez supprimer <br> {{title}} ?";
var OrgInternalContentSvc_InputType = "(Type de contenu)";
var OrgInternalContentSvc_InternalContentError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’acc\xe8s aux informations de l’organisation.";
var OrgInternalContentSvc_ItemsDeletedSuccessMessage = " \xe9l\xe9ments ont \xe9t\xe9 supprim\xe9s";
var OrgInternalContentSvc_ItemsDeletionError = "Nous n’avons pas pu supprimer {{inputsCount}} \xe9l\xe9ments, r\xe9essayez.";
var OrgInternalContentSvc_ItemsRestoredSuccessMessage = "{{inputsCount}} articles restaur\xe9s";
var OrgInternalContentSvc_ItemsRestoreError = "Nous n’avons pas pu restaurer {{inputsCount}} \xe9l\xe9ments, r\xe9essayez.";
var OrgInternalContentSvc_ItemsUpdatedSuccessMessage = "{{inputsCount}} articles mis \xe0 jour";
var OrgInternalContentSvc_ItemsUpdateError = "Nous n’avons pas pu mettre \xe0 jour {{inputsCount}} \xe9l\xe9ments, r\xe9essayez.";
var OrgInternalContentSvc_ItemUpdateDuplicateError = "Une entr\xe9e existe d\xe9j\xe0 avec l’URL\xa0: {{url}}";
var OrgInternalContentSvc_ItemWTitleDeletedSuccessMessage = " a \xe9t\xe9 supprim\xe9";
var OrgInternalContentSvc_ItemWTitleDeletionError = "Nous n’avons pas pu supprimer {{title}}, r\xe9essayez.";
var OrgInternalContentSvc_ProviderName = "(Nom du prestataire)";
var OrgInternalContentSvc_SingleItemUpdatedSuccessMessage = "1\xa0\xe9l\xe9ment mis \xe0 jour";
var OrgInternalContentSvc_Summary = "Aucune description";
var OrgInternalContentSvc_Tags = "Aucun mot-cl\xe9";
var OrgInternalContentSvc_Title = "(Titre)";
var orgInternalContentVisibilitySelector_GroupVisibilityPlaceholder = "Saisissez le nom d’un groupe administratif";
var orgInternalContentVisibilitySelector_OrgVisibilityPlaceholder = "Saisissez le nom d’un groupe ouvert, ferm\xe9 ou priv\xe9";
var orgInternalContentVisibilitySelector_TargetGroupsLabel = "Groupes cibles sp\xe9cifiques (facultatif)";
var orgInternalContentVisibilitySelector_Title = "Visibilit\xe9";
var orgInternalContentVisibilitySelector_VisibleToGroups = "Visible par des groupes sp\xe9cifiques";
var orgInternalContentVisibilitySelector_VisibleToOrganization = "Visible par l’organisation";
var orgInviteFlowModal_Compiling = "\xc9laboration du flux d’apprentissage";
var orgInviteFlowModal_DiscoverContentInfo = "D\xe9couvrez des contenus li\xe9s \xe0 votre r\xe9seau, vos groupes et vos centres d’int\xe9r\xeat pour suivre les domaines d’apprentissage de votre \xe9quipe ainsi que les tendances du secteur.";
var orgInviteFlowModal_GotIt = "J’ai compris !";
var orgInviteFlowModal_GroupConversation = "Conversation de groupe";
var orgInviteFlowModal_GroupConversations = "Conversations de groupe";
var orgInviteFlowModal_InviteMessageFormat = "Vous avez \xe9t\xe9 invit\xe9 \xe0 suivre votre apprentissage avec <strong>{{orgName}}</strong> sur Degreed !";
var orgInviteFlowModal_LearnAsTeam = "Commencez \xe0 \xe9tudier en \xe9quipe";
var orgInviteFlowModal_LetsGetStarted = "Commen\xe7ons !";
var orgInviteFlowModal_PersonalizedLearning = "Formations personnalis\xe9es";
var orgInviteFlowModal_PersonalLearning = "Apprentissage personnel";
var orgInviteFlowModal_Recommendations = "Partages";
var orgInviteFlowModal_RecommendInfo = "Si vous estimez qu’un membre d’une \xe9quipe ou un groupe peut b\xe9n\xe9ficier d’un certain \xe9l\xe9ment d’apprentissage, partagez-le directement avec lui afin qu’il s’affiche dans sa fen\xeatre d’apprentissage.";
var orgInviteFlowModal_ResendVerification = "Renvoyer la v\xe9rification";
var orgInviteFlowModal_SeeMemberLearning = "D\xe9couvrez ce que vos co\xe9quipiers \xe9tudient au sein de votre organisation et de vos groupes";
var orgInviteFlowModal_SocialGroupFeed = "Indiquez \xe0 un co\xe9quipier la raison pour laquelle vous avez partag\xe9 avec lui cet apprentissage ou une ressource potentiellement utile \xe0 partir du flux du groupe ou de votre organisation.";
var orgInviteFlowModal_UnableToJoin = "Impossible de rejoindre l’organisation";
var orgInviteFlowModal_UnableToJoin_Desc = "Vous n’avez pas pu rejoindre cette organisation car vous \xeates d\xe9j\xe0 membre d’une autre. Veuillez vous connecter avec un autre compte pour rejoindre cette organisation, ou contactez l’administrateur de votre organisation pour obtenir de l’aide.";
var orgInviteFlowModal_VerificationSentFormat = "E-mail de v\xe9rification envoy\xe9 \xe0 <br><strong>{{userEmail}}</strong><br><br>Cliquez sur le lien de v\xe9rification dans l’e-mail pour commencer \xe0 utiliser Degreed avec l’organisation {{orgName}}.";
var orgInviteFlowModal_VerifyEmailFormat = "votrenom@{{verifyEmail}}";
var orgInviteFlowModal_VerifyInstructions = "Veuillez v\xe9rifier votre adresse e-mail pour commencer.";
var OrgManage_AdvancedSSOCreated = "Avanc\xe9 — Int\xe9gration SSO cr\xe9\xe9e.";
var OrgManage_Analytics_MenuItem_Label = "D\xe9couvrir";
var OrgManage_Analytics_MenuItem_Text = "Degreed Analytics";
var OrgManage_CollectorDisabled = "Le collecteur a \xe9t\xe9 d\xe9sactiv\xe9.";
var OrgManage_ConnectorDisabled = "Le connecteur a \xe9t\xe9 d\xe9sactiv\xe9.";
var OrgManage_ConnectorDisableFailed = "La d\xe9sactivation du connecteur a \xe9chou\xe9.";
var OrgManage_Engage_MenuItem_Label = "Automatiser";
var OrgManage_Engage_MenuItem_Text = "Engage";
var OrgManage_EnterpriseProviderDisconnected = "Fournisseur entreprise d\xe9connect\xe9.";
var OrgManage_Error_Get = "D\xe9sol\xe9\xa0! Impossible de r\xe9cup\xe9rer le contenu.";
var OrgManage_ErrorCreatingProviderSSODetails = "La cr\xe9ation des informations SSO du fournisseur de l’organisation a \xe9chou\xe9.";
var OrgManage_ErrorMessageCollectors = "La r\xe9cup\xe9ration des collecteurs a \xe9chou\xe9.";
var OrgManage_ErrorMessageCollectorsOptions = "La r\xe9cup\xe9ration des options de collecteur a \xe9chou\xe9.";
var OrgManage_ErrorMessageConnectors = "La r\xe9cup\xe9ration des connecteurs a \xe9chou\xe9.";
var OrgManage_ErrorMessageConnectorsOptions = "La r\xe9cup\xe9ration des options de connecteur a \xe9chou\xe9.";
var OrgManage_ErrorMessageIntegrationProviders = "La r\xe9cup\xe9ration de la liste de tous les fournisseurs d’int\xe9gration a \xe9chou\xe9.";
var OrgManage_ErrorMessageProvider = "La r\xe9cup\xe9ration du fournisseur a \xe9chou\xe9.";
var OrgManage_ErrorMessageProviderDetails = "La r\xe9cup\xe9ration des informations du fournisseur a \xe9chou\xe9.";
var OrgManage_ErrorMessageProvidersList = "La r\xe9cup\xe9ration de la liste de tous les fournisseurs a \xe9chou\xe9.";
var OrgManage_ErrorSavingMessageCollectorsOptions = "L’enregistrement des options de collecteur a \xe9chou\xe9.";
var OrgManage_ErrorSavingMessageConnectorsOptions = "L’enregistrement des options de connecteur a \xe9chou\xe9.";
var OrgManage_ErrorUpdatingProviderSSODetails = "La mise \xe0 jour des informations SSO du fournisseur de l’organisation a \xe9chou\xe9.";
var OrgManage_ExtendedEnterprise = "Extended Enterprise";
var OrgManage_FailedProviderSSODetails = "La r\xe9cup\xe9ration des informations SSO du fournisseur a \xe9chou\xe9.";
var OrgManage_FAQ_AddFAQ = "Ajouter une FAQ";
var OrgManage_FAQ_Answer = "R\xe9ponse";
var OrgManage_FAQ_AnswerPlaceholder = "Saisissez votre r\xe9ponse ici";
var OrgManage_FAQ_ConfirmDelete = "Voulez-vous vraiment supprimer cette FAQ \xa0?";
var OrgManage_FAQ_CreateFAQPage = "Cr\xe9er une page FAQ";
var OrgManage_FAQ_CreateFAQPageInstructions = "Ajoutez quelques questions fr\xe9quemment pos\xe9es au sujet de votre organisation. Les apprenants pourront consulter la page FAQ \xe0 partir du menu d’aide.";
var OrgManage_FAQ_CustomizeFAQ = "Personnalisez la page FAQ de votre organisation.";
var OrgManage_FAQ_Delete = "Supprimer la FAQ";
var OrgManage_FAQ_Edit = "Modifier FAQ";
var OrgManage_FAQ_Error_CreateFAQ = "Une erreur est survenue lors de la cr\xe9ation de la FAQ";
var OrgManage_FAQ_Error_DeleteFAQ = "Une erreur est survenue lors de la suppression de la FAQ";
var OrgManage_FAQ_Error_GetFAQs = "Une erreur est survenue lors de la r\xe9cup\xe9ration de la FAQ.";
var OrgManage_FAQ_Error_UpdateFAQ = "Une erreur est survenue lors de la mise \xe0 jour de la FAQ";
var OrgManage_FAQ_FaqCreated = "La FAQ a bien \xe9t\xe9 cr\xe9\xe9e";
var OrgManage_FAQ_FaqDeleted = "La FAQ a \xe9t\xe9 supprim\xe9e";
var OrgManage_FAQ_FaqUpdated = "La FAQ a \xe9t\xe9 mise \xe0 jour";
var OrgManage_FAQ_MaxFAQsMsg = "Toutes les questions de la FAQ ne sont pas affich\xe9es";
var OrgManage_FAQ_NoFAQs = "La FAQ de votre organisation ne contient aucune question.";
var OrgManage_FAQ_Question = "Question";
var OrgManage_FAQ_QuestionPlaceholder = "Saisissez ici une question fr\xe9quemment pos\xe9e";
var OrgManage_FAQ_TryNarrowingSearch = "Veuillez affiner votre recherche.";
var OrgManage_LearningExperience = "Learning Experience";
var OrgManage_Manage = "G\xe9rer";
var OrgManage_MoreFormat = "+ {{remainder}} autres";
var OrgManage_OauthCredentials_apiKeyCreated = "Cl\xe9 API cr\xe9\xe9e";
var OrgManage_OauthCredentials_ApiKeyCreatedHeaderModal = "Enregistrez votre cl\xe9 API";
var OrgManage_OauthCredentials_apiKeysTab = "Cl\xe9s API";
var OrgManage_OauthCredentials_clientKeyLabel = "ID client";
var OrgManage_OauthCredentials_clientPasswordLabel = "Confidentialit\xe9 client\xa0:";
var OrgManage_OauthCredentials_ConfirmDelete = "Voulez-vous vraiment r\xe9voquer les identifiants \xa0?";
var OrgManage_OauthCredentials_copiedClipboardTooltip = "Copi\xe9 !";
var OrgManage_OauthCredentials_copyAndSaveKey = "Veuillez copier cette cl\xe9 secr\xe8te et l’enregistrer dans un emplacement s\xfbr";
var OrgManage_OauthCredentials_copyClipboardTooltip = "Copier";
var OrgManage_OauthCredentials_Create = "Cr\xe9er un nouvel identifiant";
var OrgManage_OauthCredentials_Created = "L’identifiant a \xe9t\xe9 cr\xe9\xe9.";
var OrgManage_OauthCredentials_CreatedByLabel = "Cr\xe9\xe9e par";
var OrgManage_OauthCredentials_CredentialsRevoked = "L’identifiant a \xe9t\xe9 r\xe9voqu\xe9.";
var OrgManage_OauthCredentials_defaultEmptyProviderCode = "[organization key]";
var OrgManage_OauthCredentials_Delete = "R\xe9voquer les identifiants de la cl\xe9 API";
var OrgManage_OauthCredentials_descriptionPlaceholder = "Description";
var OrgManage_OauthCredentials_EditCredentials = "Modifier la cl\xe9 API";
var OrgManage_OauthCredentials_editCredentialsTooltip = "Modifier les identifiants";
var OrgManage_OauthCredentials_ErrorSavingCredentials = "Une erreur s’est produite lors de l’enregistrement de l’identifiant";
var OrgManage_OauthCredentials_NamePlaceholder = "Nom";
var OrgManage_OauthCredentials_NewCredentials = "Cr\xe9er une nouvelle cl\xe9 API";
var OrgManage_OauthCredentials_organizationKeysLabel = "Cl\xe9s de l’organisation (2\xa0max.)";
var OrgManage_OauthCredentials_providerKeysLabel = "Cl\xe9s du fournisseur (aucune limite)";
var OrgManage_OauthCredentials_providerLabel = "Fournisseur";
var OrgManage_OauthCredentials_providerPlaceholder = "Rechercher des fournisseurs";
var OrgManage_OauthCredentials_revokeTooltip = "R\xe9voquer les identifiants";
var OrgManage_OauthCredentials_Scope_completions = "\xc9l\xe9ments termin\xe9s";
var OrgManage_OauthCredentials_Scope_completionsRead = "Consulter les ach\xe8vements";
var OrgManage_OauthCredentials_Scope_completionsWrite = "Modifier les ach\xe8vements";
var OrgManage_OauthCredentials_Scope_content = "Contenu";
var OrgManage_OauthCredentials_Scope_contentRead = "Consulter le contenu";
var OrgManage_OauthCredentials_Scope_contentWrite = "Modifier le contenu";
var OrgManage_OauthCredentials_Scope_customAttribute = "Attributs personnalis\xe9s";
var OrgManage_OauthCredentials_Scope_Licenses = "Licences";
var OrgManage_OauthCredentials_Scope_ProviderUsers = "Utilisateurs du fournisseur";
var OrgManage_OauthCredentials_Scope_r = "L";
var OrgManage_OauthCredentials_Scope_read = "Lecture";
var OrgManage_OauthCredentials_Scope_readCompletions = "Consulter les ach\xe8vements";
var OrgManage_OauthCredentials_Scope_readContent = "Consulter le contenu";
var OrgManage_OauthCredentials_Scope_readRequiredLearning = "Consulter la formation obligatoire";
var OrgManage_OauthCredentials_Scope_readUsers = "Consulter les utilisateurs";
var OrgManage_OauthCredentials_Scope_requiredLearning = "Formation obligatoire";
var OrgManage_OauthCredentials_Scope_requiredLearning_Bundles = "Lots";
var OrgManage_OauthCredentials_Scope_requiredLearning_Logins = "Identifiants";
var OrgManage_OauthCredentials_Scope_requiredLearning_SharedItems = "\xc9l\xe9ments partag\xe9s";
var OrgManage_OauthCredentials_Scope_requiredLearning_SkillPlans = "Plans de comp\xe9tence";
var OrgManage_OauthCredentials_Scope_requiredLearning_SkillRatings = "\xc9valuations des comp\xe9tences";
var OrgManage_OauthCredentials_Scope_requiredLearning_TodaysLearning = "Programme du jour";
var OrgManage_OauthCredentials_Scope_requiredLearning_UserBadges = "Insignes utilisateurs";
var OrgManage_OauthCredentials_Scope_requiredLearning_UserSkills = "Comp\xe9tences des utilisateurs";
var OrgManage_OauthCredentials_Scope_requiredLearningRead = "Lire les formations obligatoires";
var OrgManage_OauthCredentials_Scope_requiredLearningWrite = "Modifier la formation obligatoire";
var OrgManage_OauthCredentials_Scope_rw = "L/E";
var OrgManage_OauthCredentials_Scope_SelfEnrolledLearning = "Formation auto-assign\xe9e";
var OrgManage_OauthCredentials_Scope_UserBadges = "Insignes utilisateurs";
var OrgManage_OauthCredentials_Scope_users = "Utilisateurs";
var OrgManage_OauthCredentials_Scope_usersRead = "Consulter les utilisateurs";
var OrgManage_OauthCredentials_Scope_usersWrite = "Modifier les utilisateurs";
var OrgManage_OauthCredentials_Scope_write = "\xc9criture";
var OrgManage_OauthCredentials_Scope_writeCompletions = "Modifier les ach\xe8vements";
var OrgManage_OauthCredentials_Scope_writeContent = "Modifier le contenu";
var OrgManage_OauthCredentials_Scope_writeRequiredLearning = "\xc9crire les formations obligatoires";
var OrgManage_OauthCredentials_Scope_writeUsers = "Modifier les utilisateurs";
var OrgManage_OauthCredentials_Scope_Xapi = "xAPI";
var OrgManage_OauthCredentials_ScopesLabel = "Champs d’application";
var OrgManage_OauthCredentials_Updated = "L’identifiant a \xe9t\xe9 mis \xe0 jour.";
var OrgManage_OauthCredentials_warningManageCredentials = "Lorsque vous s\xe9lectionnez \xc9criture, les droits de lecture sont automatiquement accord\xe9s. De m\xeame, en d\xe9s\xe9lectionnant Lecture, les droits d’\xe9criture seront automatiquement d\xe9s\xe9lectionn\xe9s.";
var OrgManage_OauthCredentials_wontShowKeyAgain = "Pour des raisons de s\xe9curit\xe9, nous ne pouvons pas vous montrer la cl\xe9 \xe0 nouveau.";
var OrgManage_OneMore = "+ 1 autre";
var OrgManage_Opportunities_Add = "Ajouter une opportunit\xe9";
var OrgManage_Opportunities_AddCollaborators = "Ajouter des collaborateurs";
var OrgManage_Opportunities_AtLeastOneSkill = "Ajoutez au moins une comp\xe9tence";
var OrgManage_Opportunities_BulkChangeVisibility = "Modifier la visibilit\xe9 d’une opportunit\xe9";
var OrgManage_Opportunities_BulkChangeVisibilityPlural = "Modifier la visibilit\xe9 de {{count}}\xa0opportunit\xe9s";
var OrgManage_Opportunities_BulkCloseAllHeader = "Fermer {{totalCount}} opportunit\xe9s \xa0?";
var OrgManage_Opportunities_BulkClosedSuccess = "{{allowedCount}}\xa0opportunit\xe9s ferm\xe9es";
var OrgManage_Opportunities_BulkCloseError = "D\xe9sol\xe9\xa0! Les opportunit\xe9s n’ont pas pu \xeatre cl\xf4tur\xe9es.";
var OrgManage_Opportunities_BulkCloseExternalError = "{{notAllowedCount}}\xa0opportunit\xe9s externes n’ont pas \xe9t\xe9 cl\xf4tur\xe9es";
var OrgManage_Opportunities_BulkCloseHeader = "Cl\xf4turer {{allowedCount}}\xa0opportunit\xe9s sur {{totalCount}}\xa0?";
var OrgManage_Opportunities_BulkCloseNotify = "Informer les candidats non s\xe9lectionn\xe9s qu’ils n’ont pas \xe9t\xe9 retenus et que l’opportunit\xe9 a \xe9t\xe9 ferm\xe9e";
var OrgManage_Opportunities_BulkCloseWarning = "Si vous fermez ces opportunit\xe9s, vous ne pourrez plus les ouvrir. Cette action est irr\xe9versible.";
var OrgManage_Opportunities_BulkCloseWarningExternal = "*{{notAllowedCount}}\xa0opportunit\xe9s externes n’ont pas pu \xeatre cl\xf4tur\xe9es.";
var OrgManage_Opportunities_BulkDeleteAllHeader = "Supprimer {{totalCount}} opportunit\xe9s \xa0?";
var OrgManage_Opportunities_BulkDeleteError = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de la suppression des opportunit\xe9s.";
var OrgManage_Opportunities_BulkDeleteExternalError = "{{notAllowedCount}}\xa0opportunit\xe9s externes n’ont pas \xe9t\xe9 supprim\xe9es";
var OrgManage_Opportunities_BulkDeleteExternalFail = "{{notAllowedCount}}\xa0opportunit\xe9s externes n’ont pas \xe9t\xe9 supprim\xe9es";
var OrgManage_Opportunities_BulkDeleteHeader = "Supprimer {{allowedCount}}\xa0opportunit\xe9s sur {{totalCount}}\xa0?";
var OrgManage_Opportunities_BulkDeleteSuccess = "{{allowedCount}}\xa0opportunit\xe9s supprim\xe9es";
var OrgManage_Opportunities_BulkDeleteWarning = "La suppression de ces opportunit\xe9s est d\xe9finitive.<br>Cette action est irr\xe9versible.";
var OrgManage_Opportunities_BulkDeleteWarningExternal = "*{{notAllowedCount}}\xa0opportunit\xe9s externes n’ont pas pu \xeatre supprim\xe9es.";
var OrgManage_Opportunities_ChooseDurationType = "Choisissez le type de dur\xe9e";
var OrgManage_Opportunities_Close = "Fermer";
var OrgManage_Opportunities_ClosedOnlyOpportunities = "Afficher uniquement les opportunit\xe9s ferm\xe9es";
var OrgManage_Opportunities_ClosePrompt_Description = "Si vous fermez cette opportunit\xe9, vous ne pourrez plus la rouvrir. Cette action est irr\xe9versible.";
var OrgManage_Opportunities_ClosePrompt_Header = "Fermer {{ opportunityTitle }} \xa0?";
var OrgManage_Opportunities_ClosePrompt_NoSelect = "Avez-vous vraiment s\xe9lectionn\xe9 quelqu’un pour cette opportunit\xe9\xa0? S\xe9lectionner des candidats permet ensuite d’\xe9tablir des rapports historiques.";
var OrgManage_Opportunities_ClosePrompt_SendNotification = "Informer les candidats non s\xe9lectionn\xe9s que l’opportunit\xe9 a \xe9t\xe9 ferm\xe9e";
var OrgManage_Opportunities_ClosePrompt_Title = "Fermer {{ opportunityTitle }} \xa0?";
var OrgManage_Opportunities_Cols_Collaborators = "Collaborateurs";
var OrgManage_Opportunities_Cols_Interested = "Int\xe9ress\xe9s";
var OrgManage_Opportunities_Cols_LastUpdated = "Derni\xe8re mise \xe0 jour";
var OrgManage_Opportunities_Cols_Skills = "Comp\xe9tences";
var OrgManage_Opportunities_Cols_Source = "Source";
var OrgManage_Opportunities_Cols_Title = "Titre";
var OrgManage_Opportunities_Cols_Type = "Type";
var OrgManage_Opportunities_Cols_Visibility = "Visibilit\xe9";
var OrgManage_Opportunities_Create = "Cr\xe9er une opportunit\xe9";
var OrgManage_Opportunities_DateCompare = "S\xe9lectionnez une date valide";
var OrgManage_Opportunities_DatePicker = "S\xe9lectionner une date";
var OrgManage_Opportunities_Delete = "Supprimer";
var OrgManage_Opportunities_Delete_Confirmation = "En supprimant des opportunit\xe9s, vous les ferez \xe9galement dispara\xeetre des r\xe9sultats de recherche. Souhaitez-vous r\xe9ellement les supprimer\xa0?";
var OrgManage_Opportunities_Delete_Confirmation_Singular = "En supprimant cette opportunit\xe9, vous la ferez \xe9galement dispara\xeetre des r\xe9sultats de recherche. Souhaitez-vous r\xe9ellement la supprimer\xa0?";
var OrgManage_Opportunities_Delete_Notice_Generic = "Cette action est d\xe9finitive et irr\xe9versible\xa0:";
var OrgManage_Opportunities_Delete_Notice_Specific = "Vous \xeates sur le point de supprimer les opportunit\xe9s suivantes\xa0:";
var OrgManage_Opportunities_Delete_Notice_Specific_Singular = "Vous \xeates sur le point de supprimer l’opportunit\xe9 suivante\xa0:";
var OrgManage_Opportunities_Delete_Undeletable = "Ces opportunit\xe9s externes ne peuvent pas \xeatre supprim\xe9es\xa0:";
var OrgManage_Opportunities_Delete_Undeletable_Singular = "Cette opportunit\xe9 externe ne peut pas \xeatre supprim\xe9e\xa0:";
var OrgManage_Opportunities_DeleteOpportunities = "Supprimer";
var OrgManage_Opportunities_DeleteOpportunity = "Supprimer l’opportunit\xe9";
var OrgManage_Opportunities_DeletePrompt_Description = "Cette action entrainera sa suppression des r\xe9sultats de recherche.";
var OrgManage_Opportunities_DeletePrompt_Title = "Voulez-vous vraiment supprimer cette opportunit\xe9 \xa0?";
var OrgManage_Opportunities_DepartmentPlaceholder = "Saisissez un service en lien avec l’opportunit\xe9";
var OrgManage_Opportunities_DescMaxChars = "{{limit}}\xa0caract\xe8res restants";
var OrgManage_Opportunities_DescPlaceholder = "Br\xe8ve description de l’opportunit\xe9";
var OrgManage_Opportunities_Edit = "Modifier l’opportunit\xe9";
var OrgManage_Opportunities_EditSkills = "Modifier les comp\xe9tences";
var OrgManage_Opportunities_EditTargetLevel = "Modifier le niveau cible";
var OrgManage_Opportunities_EditVisibility = "Modifier la visibilit\xe9";
var OrgManage_Opportunities_Error_Add = "D\xe9sol\xe9\xa0! L’opportunit\xe9 n’a pas pu \xeatre ajout\xe9e.";
var OrgManage_Opportunities_Error_Close = "D\xe9sol\xe9\xa0! L’opportunit\xe9 n’a pas pu \xeatre cl\xf4tur\xe9e.";
var OrgManage_Opportunities_Error_Delete = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de la suppression de l’opportunit\xe9.";
var OrgManage_Opportunities_Error_Edit = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de la mise \xe0 jour de l’opportunit\xe9.";
var OrgManage_Opportunities_Error_EditCollaborators = "D\xe9sol\xe9s\xa0! Un probl\xe8me est survenu lors de l’ajout de collaborateurs.";
var OrgManage_Opportunities_Error_EditSkills = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de la mise \xe0 jour des comp\xe9tences de l’opportunit\xe9.";
var OrgManage_Opportunities_Error_EditVisibility = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de la mise \xe0 jour de la visibilit\xe9.";
var OrgManage_Opportunities_Error_Share = "D\xe9sol\xe9\xa0! L’opportunit\xe9 n’a pas pu \xeatre partag\xe9e.";
var OrgManage_Opportunities_Filters_Current_Collaborator = "{{fullName}} (vous)";
var OrgManage_Opportunities_Filters_Status_closed = "Ferm\xe9e";
var OrgManage_Opportunities_Filters_Status_open = "Ouverte";
var OrgManage_Opportunities_Invalid_Field = "Ce champ n’est pas valide.";
var OrgManage_Opportunities_JobRoles_SkillAdded = "{{numberOfSkills}} comp\xe9tences ajout\xe9es \xe0 votre poste \xab\xa0{{jobRoleName}}\xa0\xbb";
var OrgManage_Opportunities_MoreFormat = "et {{remainder}} autres";
var OrgManage_Opportunities_NoItemsAdded = "Aucune opportunit\xe9 n’a \xe9t\xe9 ajout\xe9e \xe0 cette organisation.";
var OrgManage_Opportunities_OfDays = "Nombre de jours";
var OrgManage_Opportunities_OfHours = "Nombre d’heures";
var OrgManage_Opportunities_OfMonths = "Nombre de mois";
var OrgManage_Opportunities_OfWeeks = "Nombre de semaines";
var OrgManage_Opportunities_OneMore = "et 1\xa0autre";
var OrgManage_Opportunities_OptIn = "S’abonner";
var OrgManage_Opportunities_OptIn_Description = "En manifestant votre int\xe9r\xeat pour cette opportunit\xe9, vous autorisez les utilisateurs Degreed de votre organisation en charge de la gestion des opportunit\xe9s \xe0 voir vos <strong>nom</strong>, <strong>adresse e-mail</strong>, <strong>lieu</strong>, <strong>poste</strong> et <strong>qualifications</strong>.";
var OrgManage_Opportunities_OptIn_Header = "S’abonner aux opportunit\xe9s \xa0?";
var OrgManage_Opportunities_Required_Field = "Ce champ est obligatoire";
var OrgManage_Opportunities_SearchPlaceholder = "{{count}}\xa0opportunit\xe9(s)";
var OrgManage_Opportunities_ShowClosed = "Ferm\xe9es uniquement";
var OrgManage_Opportunities_StartDatePlaceholder = "S\xe9lectionnez ou saisissez une date";
var OrgManage_Opportunities_Success_Add = "L’opportunit\xe9 \xab\xa0{{title}}\xa0\xbb a bien \xe9t\xe9 ajout\xe9e\xa0!";
var OrgManage_Opportunities_Success_AddCollaboratorPluralToOpportunity = "{{count}}\xa0collaborateurs ont \xe9t\xe9 ajout\xe9s \xe0 1\xa0opportunit\xe9.";
var OrgManage_Opportunities_Success_AddCollaboratorPluralToOpportunityPlural = "{{collaboratorCount}}\xa0collaborateurs ont bien \xe9t\xe9 ajout\xe9s \xe0 {{opportunityCount}}\xa0opportunit\xe9s.";
var OrgManage_Opportunities_Success_AddCollaboratorToOpportunity = "1\xa0collaborateur a \xe9t\xe9 ajout\xe9 \xe0 1\xa0opportunit\xe9.";
var OrgManage_Opportunities_Success_AddCollaboratorToOpportunityPlural = "1\xa0collaborateur a \xe9t\xe9 ajout\xe9 \xe0 {{count}}\xa0opportunit\xe9s.";
var OrgManage_Opportunities_Success_Close = "L’opportunit\xe9 \xab\xa0{{opportunityTitle}}\xa0\xbb a \xe9t\xe9 ferm\xe9e.";
var OrgManage_Opportunities_Success_Delete = "L’opportunit\xe9 \xab\xa0{{title}}\xa0\xbb a bien \xe9t\xe9 supprim\xe9e\xa0!";
var OrgManage_Opportunities_Success_EditVisibility = "Visibilit\xe9 modifi\xe9e pour une opportunit\xe9.";
var OrgManage_Opportunities_Success_EditVisibilityPlural = "Visibilit\xe9 modifi\xe9e pour {{count}}\xa0opportunit\xe9s.";
var OrgManage_Opportunities_Success_Update = "L’opportunit\xe9 \xab\xa0{{title}}\xa0\xbb a bien \xe9t\xe9 mise \xe0 jour\xa0!";
var OrgManage_Opportunities_Tab_Description = "Description";
var OrgManage_Opportunities_Tab_Details = "D\xe9tails";
var OrgManage_Opportunities_Tab_Skills = "Comp\xe9tences";
var OrgManage_Opportunities_ThreeToTenSkills = "Nous vous recommandons d’ajouter entre 3 et 10\xa0comp\xe9tences pour obtenir les meilleurs r\xe9sultats.";
var OrgManage_Opportunities_TitlePlaceholder = "Saisissez un titre pour cette opportunit\xe9";
var OrgManage_Opportunities_TypePlaceholder = "S\xe9lectionner un type";
var OrgManage_Opportunities_Upload = "Charger des opportunit\xe9s";
var OrgManage_Opportunities_UploadDescription = "Vous pouvez charger plusieurs opportunit\xe9s \xe0 la fois, en les regroupant dans un fichier avec le mod\xe8le suivant.";
var OrgManage_Opportunities_UploadError = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors du t\xe9l\xe9chargement des opportunit\xe9s.";
var OrgManage_Opportunities_UploadFile = "T\xe9l\xe9charger le fichier";
var OrgManage_Opportunities_UploadOpportunities = "T\xe9l\xe9charger les opportunit\xe9s";
var OrgManage_Opportunities_UploadSuccess = "Le fichier que vous avez t\xe9l\xe9charg\xe9 est en cours de traitement. Les modifications apport\xe9es en fonction de ce fichier peuvent prendre 4\xa0heures avant d’apparaitre dans Degreed.";
var OrgManage_Opportunities_Valid_Date = "S\xe9lectionnez une date valide";
var OrgManage_Opportunities_Valid_Duration = "Indiquez une dur\xe9e valide";
var OrgManage_Opportunities_Valid_Duration_Type = "S\xe9lectionnez le type de dur\xe9e";
var OrgManage_Opportunities_Valid_Job_Role = "Indiquez un poste valide";
var OrgManage_Opportunities_Valid_MaxLength = "Ce champ est trop long. R\xe9duisez-le de {{number}} caract\xe8res.";
var OrgManage_Opportunities_Valid_MinLength = "Ce champ est trop court. Ajoutez {{number}}\xa0caract\xe8res.";
var OrgManage_Opportunities_VisibleCollaborators = "Restreint aux collaborateurs";
var OrgManage_Opportunities_VisibleGroups = "Uniquement visible par des groupes sp\xe9cifiques";
var OrgManage_Opportunities_VisibleOrganization = "Visible par toute l’organisation";
var OrgManage_OrgProviders_Created = "Les informations du fournisseur ont \xe9t\xe9 cr\xe9\xe9es";
var OrgManage_OrgProviders_createProviderButton = "Ajouter un fournisseur";
var OrgManage_OrgProviders_createProviderLabel = "Ajouter un fournisseur";
var OrgManage_OrgProviders_editOrgProviderTooltip = "Modifier le fournisseur de l’organisation";
var OrgManage_OrgProviders_ErrorMessage = "Une erreur s’est produite lors de l’enregistrement du fournisseur";
var OrgManage_OrgProviders_featuredColumnHeader = "\xc0 la une";
var OrgManage_OrgProviders_globalLicenseColumnHeader = "Licence globale";
var OrgManage_OrgProviders_hiddenColumnHeader = "Masqu\xe9\xa0?";
var OrgManage_OrgProviders_hiddenLabel = "Masqu\xe9";
var OrgManage_OrgProviders_licensingColumnHeader = "Licence";
var OrgManage_OrgProviders_LicensingConfirmation_DefaultDescription = "Veuillez compter entre 24 et 36\xa0heures pour que les \xe9l\xe9ments termin\xe9s apparaissent dans votre profil Degreed. Si vous \xeates en train de d\xe9ployer Success Factors, vous ne pourrez pas acc\xe9der \xe0 ce contenu.";
var OrgManage_OrgProviders_LicensingConfirmation_LicenseAlreadyRequested = "Vous avez envoy\xe9 une demande de licence pour ce contenu.";
var OrgManage_OrgProviders_LicensingConfirmation_NoLicenseFound = "Nous n’avons pas \xe9t\xe9 en mesure d’acc\xe9der \xe0 votre accord de licence pour ce fournisseur.";
var OrgManage_OrgProviders_LicensingConfirmation_NoProviderFound = "Nous n’avons pas \xe9t\xe9 en mesure d’acc\xe9der \xe0 ce fournisseur.";
var OrgManage_OrgProviders_LicensingConfirmation_PageTitle = "Confirmation de licence pour {{ ProviderName }}";
var OrgManage_OrgProviders_LicensingConfirmation_ProviderHeader = "{{ ProviderName }} Licences";
var OrgManage_OrgProviders_LicensingConfirmation_ProviderHomepage = "Page d’accueil du fournisseur";
var OrgManage_OrgProviders_LicensingConfirmation_RequestLicense = "Demander une licence";
var OrgManage_OrgProviders_LicensingConfirmation_SearchForProviderContent = "Rechercher du contenu";
var OrgManage_OrgProviders_providerNameColumnHeader = "Nom du fournisseur";
var OrgManage_OrgProviders_providersLabel = "Fournisseurs";
var OrgManage_OrgProviders_providersPlaceholder = "Rechercher des fournisseurs";
var OrgManage_OrgProviders_providersTab = "Int\xe9grations";
var OrgManage_OrgProviders_Updated = "Les informations du fournisseur ont \xe9t\xe9 mises \xe0 jour";
var OrgManage_ProviderDisconnected = "Fournisseur d\xe9connect\xe9.";
var OrgManage_ReportSchedule_AggregateRange = "Tout le temps (les rapports de comp\xe9tence sont agr\xe9g\xe9s)";
var OrgManage_ReportSchedule_Cols_Frequency = "Fr\xe9quence";
var OrgManage_ReportSchedule_Cols_FtpConfig = "Configurations\xa0FTP";
var OrgManage_ReportSchedule_Cols_LastExport = "Derni\xe8re exportation";
var OrgManage_ReportSchedule_Cols_ReportType = "Type de rapport";
var OrgManage_ReportSchedule_Cols_TimePeriod = "P\xe9riode";
var OrgManage_ReportSchedule_Cols_Version = "Version";
var OrgManage_ReportSchedule_ConfirmDelete = "Voulez-vous vraiment supprimer ce rapport planifi\xe9\xa0?";
var OrgManage_ReportSchedule_DownloadFolder = "Les rapports planifi\xe9s sont t\xe9l\xe9charg\xe9s vers le dossier FTP de votre organisation.";
var OrgManage_ReportSchedule_DuplicateReportScheduleError = "Le rapport s\xe9lectionn\xe9 a d\xe9j\xe0 \xe9t\xe9 planifi\xe9 pour la p\xe9riode et la fr\xe9quence indiqu\xe9es.";
var OrgManage_ReportSchedule_EditReportSchedule = "Modifier le rapport planifi\xe9";
var OrgManage_ReportSchedule_Error_DeleteSchedule = "Une erreur s’est produite lors de la suppression du rapport planifi\xe9.";
var OrgManage_ReportSchedule_Error_GetDateRanges = "Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration des plages de dates disponibles.";
var OrgManage_ReportSchedule_Error_GetFrequencies = "Une erreur s’est produite lors de la r\xe9cup\xe9ration des fr\xe9quences de rapports disponibles.";
var OrgManage_ReportSchedule_Error_GetReportMethods = "Une erreur s’est produite lors de la r\xe9cup\xe9ration des rapports disponibles.";
var OrgManage_ReportSchedule_Error_GetSchedules = "Une erreur s’est produite lors de la r\xe9cup\xe9ration des rapports planifi\xe9s.";
var OrgManage_ReportSchedule_Error_UpdateSchedule = "Une erreur s’est produite lors de l’enregistrement du programme planifi\xe9.";
var OrgManage_ReportSchedule_Frequency_Daily = "Quotidienne (tous les jours)";
var OrgManage_ReportSchedule_Frequency_DailyMondayThruFriday = "Quotidienne (lun-ven)";
var OrgManage_ReportSchedule_Frequency_Monthly = "Mensuelle";
var OrgManage_ReportSchedule_Frequency_Quarterly = "Trimestrielle";
var OrgManage_ReportSchedule_Frequency_WeeklyOnMonday = "Hebdomadaire (envoy\xe9 le lundi)";
var OrgManage_ReportSchedule_Frequency_WeeklyOnSunday = "Hebdomadaire (envoi le dimanche)";
var OrgManage_ReportSchedule_FTP = "FTP";
var OrgManage_ReportSchedule_FtpConfig = "Choisir une configuration\xa0FTP";
var OrgManage_ReportSchedule_NewReportSchedule = "Planifier un nouveau rapport";
var OrgManage_ReportSchedule_Range_Last10Days = "10\xa0derniers jours";
var OrgManage_ReportSchedule_Range_Last15Days = "15\xa0derniers jours";
var OrgManage_ReportSchedule_Range_Last1Days = "Derni\xe8res 24\xa0heures";
var OrgManage_ReportSchedule_Range_Last2Days = "2\xa0derniers jours";
var OrgManage_ReportSchedule_Range_Last30Days = "30\xa0derniers jours";
var OrgManage_ReportSchedule_Range_Last3Days = "3 derniers jours";
var OrgManage_ReportSchedule_Range_Last60Days = "60\xa0derniers jours";
var OrgManage_ReportSchedule_Range_Last7Days = "7\xa0derniers jours";
var OrgManage_ReportSchedule_Range_Last90Days = "90\xa0derniers jours";
var OrgManage_ReportSchedule_Range_LastFullMonth = "Tout le mois dernier";
var OrgManage_ReportSchedule_Range_LastFullQuarter = "Tout le trimestre dernier";
var OrgManage_ReportSchedule_Range_LastFullYear = "Toute l’ann\xe9e derni\xe8re";
var OrgManage_ReportSchedule_Range_MonthToDate = "Mois en cours";
var OrgManage_ReportSchedule_Range_PreviousMonth = "Mois pr\xe9c\xe9dent";
var OrgManage_ReportSchedule_Range_PreviousQuarter = "Trimestre pr\xe9c\xe9dent";
var OrgManage_ReportSchedule_Range_QuarterToDate = "Trimestre en cours";
var OrgManage_ReportSchedule_Range_YearToDate = "Ann\xe9e en cours";
var OrgManage_ReportSchedule_ReportMaximum = "(10\xa0rapports maximum)";
var OrgManage_ReportSchedule_ReportName = "Nom du rapport";
var OrgManage_ReportSchedule_ReportSchedule = "Panification du rapport";
var OrgManage_ReportSchedule_ScheduleAdded = "Le rapport a bien \xe9t\xe9 planifi\xe9.";
var OrgManage_ReportSchedule_ScheduleCreated = "Le rapport a bien \xe9t\xe9 planifi\xe9.";
var OrgManage_ReportSchedule_ScheduleDeleted = "Rapport planifi\xe9 supprim\xe9";
var OrgManage_ReportSchedule_ScheduleReport = "Planifier un rapport";
var OrgManage_ReportSchedule_ScheduleUpdated = "Rapport planifi\xe9 mis \xe0 jour";
var OrgManage_ReportSchedule_SelectFrequency = "Choisissez la fr\xe9quence d’ex\xe9cution du rapport";
var OrgManage_ReportSchedule_SelectReportType = "S\xe9lectionnez le type de rapport";
var OrgManage_ReportSchedule_SelectTimePeriod = "Choisissez la p\xe9riode";
var OrgManage_ReportSchedule_SelectVersion = "S\xe9lectionnez la version";
var OrgManage_ReportSchedule_UploadFile = "Charger le fichier";
var OrgManage_SettingsError_OrgSupportInfoEmail_pattern = "Pour activer ce param\xe8tre, vous devez saisir une adresse e-mail personnalis\xe9e qui n’appartient pas au domaine @degreed.com.";
var OrgManage_SwitchTo = "Passer \xe0";
var OrgManage_UpdatedMessageCollectorsInformation = "Les informations du collecteur ont \xe9t\xe9 mises \xe0 jour.";
var OrgManage_UpdatedMessageConnectorsInformation = "Les informations du connecteur ont \xe9t\xe9 mises \xe0 jour.";
var OrgManage_UpdatedProviderRebranding = "La nouvelle marque du fournisseur a \xe9t\xe9 mise \xe0 jour.";
var OrgManage_UpdateUsers = "Mettre \xe0 jour des utilisateurs";
var OrgManage_UploadOpportunitiesError = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors du t\xe9l\xe9chargement des opportunit\xe9s.";
var OrgManage_UploadUsers = "Charger des utilisateurs";
var OrgMemberFormCtrl_ConfirmRemoval = "Confirmer la suppression";
var OrgMemberFormCtrl_ConfirmRemovalMessage = "Souhaitez-vous r\xe9ellement supprimer cet utilisateur ? Si vous le faites, les donn\xe9es de votre organisation seront d\xe9finitivement supprim\xe9es de leur profil.";
var OrgMemberFormCtrl_EmailPasswordReset = "Envoyer un lien de r\xe9initialisation du mot de passe par e-mail";
var OrgMemberFormCtrl_EmailResetPasswordSuccessMessageFormat = "E-mail de r\xe9initialisation du mot passe bien envoy\xe9 \xe0 {{name}}";
var OrgMemberFormCtrl_Groups = "Groupes";
var OrgMemberFormCtrl_History = "Historique";
var OrgMemberFormCtrl_MemberSince = "{{firstName}} a \xe9t\xe9 membre de cette organisation depuis le {{dateJoined}}.";
var OrgMemberFormCtrl_None = "(aucun)";
var OrgMemberFormCtrl_PasswordManagement = "Gestion du mot de passe";
var OrgMemberFormCtrl_PendingMember = "Membre en attente";
var OrgMemberFormCtrl_RemovedMemberSuccessMessage = "L’utilisateur a \xe9t\xe9 supprim\xe9 avec succ\xe8s.";
var OrgMemberFormCtrl_RemoveFromOrg = "Supprimer de l’organisation";
var OrgMemberFormCtrl_Removing = "Suppression...";
var OrgMemberFormCtrl_ResetPasswordDesc = "Envoyez un lien de r\xe9initialisation du mot de passe \xe0 l’adresse e-mail principale de l’utilisateur.";
var OrgMemberFormCtrl_ResetPasswordOnLogin = "Demander \xe0 l’utilisateur de changer le mot de passe apr\xe8s la premi\xe8re connexion";
var OrgMemberFormCtrl_ResetPasswordToDefault = "R\xe9tablir le mot de passe par d\xe9faut";
var OrgMemberFormCtrl_ResetPasswordToDefaultDesc = "R\xe9tablissez la valeur par d\xe9faut du mot de passe de l’utilisateur d\xe9finie par l’organisation. L’utilisateur sera invit\xe9 \xe0 modifier son mot de passe lors de sa prochaine connexion.";
var OrgMemberFormCtrl_ResetPasswordToDefaultSuccess = "Le mot de passe a bien \xe9t\xe9 r\xe9initialis\xe9 \xe0 la valeur par d\xe9faut d\xe9finie par l’organisation.";
var OrgMemberFormCtrl_Role = "R\xf4le";
var OrgMemberFormCtrl_RolePermissions = "{{name}} autorisations : {{permissions}}";
var OrgMemberFormCtrl_Title = "Modifier les param\xe8tres de l’utilisateur";
var OrgMemberFormCtrl_UpdatedMemberRoleSuccessMessage = "R\xf4le mis \xe0 jour pour {{name}}";
var OrgMemberFormCtrl_ViewUserSettings = "Afficher les param\xe8tres utilisateur";
var OrgMembersCtrl_Admin = "Administrateur";
var OrgMembersCtrl_AnonUsersCountFormat = "{{count}}\xa0utilisateurs anonymes";
var OrgMembersCtrl_AnonUsersCountSingle = "1 utilisateur anonyme";
var OrgMembersCtrl_CountOfMembersFormat = "{{count}} membres";
var OrgMembersCtrl_DateJoined = "Date d’inscription";
var OrgMembersCtrl_InviteMembers = "Inviter des membres";
var OrgMembersCtrl_InviteUsers = "Inviter des utilisateurs";
var OrgMembersCtrl_LastActive = "Derni\xe8re activit\xe9";
var OrgMembersCtrl_MemberInfoErrorMsg = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’acc\xe8s aux informations des membres.";
var OrgMembersCtrl_MemberSettingsText = "Param\xe8tres des membres";
var OrgMembersCtrl_Name = "Nom";
var OrgMembersCtrl_NoMembersMessage = "Aucun membre de cette organisation ne correspond aux termes de la recherche.";
var OrgMembersCtrl_People = "Personnes";
var OrgMembersCtrl_Points = "Points";
var OrgMembersCtrl_Private = "Priv\xe9";
var OrgMembersCtrl_PrivateTooltip = "Profil priv\xe9";
var OrgMembersCtrl_PrivateToOrg = "Restreint \xe0 l’organisation";
var OrgMembersCtrl_Public = "Public";
var OrgMembersCtrl_PublicTooltip = "Visible par le public et l’organisation";
var OrgMembersCtrl_PublicToOrgTooltip = "Visible par l’organisation";
var OrgMembersCtrl_ResendInvites = "Renvoyer les invitations";
var OrgMembersCtrl_Role = "R\xf4le";
var OrgMembersCtrl_SearchForMember = "Rechercher un membre";
var OrgMembersCtrl_SearchForUser = "Rechercher un utilisateur";
var OrgMembersCtrl_SeatsRemainingFormat = "{{count}}\xa0place restante";
var OrgMembersCtrl_SeatsRemainingPluralFormat = "{{count}}\xa0places restantes";
var OrgMembersCtrl_SeatsRemainingTooltip = "Cette valeur est calcul\xe9e en d\xe9duisant le nombre de places utilis\xe9es (utilisateurs actifs) du nombre total de places disponibles (comme d\xe9fini dans votre contrat). On entend par utilisateurs actifs les utilisateurs qui se sont connect\xe9s au moins une fois, n’ont pas \xe9t\xe9 supprim\xe9s et sont toujours associ\xe9s \xe0 votre organisation";
var OrgMembersCtrl_UsersCountFormat = "{{count}}\xa0utilisateurs";
var OrgMembersCtrl_Visibility = "Visibilit\xe9";
var OrgOpportunity_EngagementInsights_Tab = "Statistiques d’engagement";
var OrgOpportunity_OpenInsights_Tab = "Statistiques d’ouvertures";
var OrgPathwayManagerCtrl_AddCollaborators = "Ajouter des collaborateurs";
var OrgPathwayManagerCtrl_AuthorColumn = "Auteurs";
var OrgPathwayManagerCtrl_ConfirmDeleteButton = "Oui, supprimer les parcours";
var OrgPathwayManagerCtrl_Delete = "Supprimer";
var OrgPathwayManagerCtrl_DeleteInstructions = "Saisissez {{delete}} en lettres majuscules pour confirmer";
var OrgPathwayManagerCtrl_DeletePluralPrompt = "Souhaitez-vous r\xe9ellement supprimer {{ count }} parcours\xa0?";
var OrgPathwayManagerCtrl_DeletePrompt = "Souhaitez-vous r\xe9ellement supprimer 1 parcours \xa0?";
var OrgPathwayManagerCtrl_DeletePromptDescription = "Vous ne pouvez pas annuler cette action.";
var OrgPathwayManagerCtrl_EndorsedPathwaysDescription = "Les parcours recommand\xe9s et les \xe9l\xe9ments de contenu de ces parcours sont mis en avant dans les r\xe9sultats de recherche.";
var OrgPathwayManagerCtrl_EnrolledColumn = "Inscrit";
var OrgPathwayManagerCtrl_FeaturedColumn = "\xc0 la une";
var OrgPathwayManagerCtrl_FollowingColumn = "Abonn\xe9s";
var OrgPathwayManagerCtrl_ItemsSelected = "s\xe9lectionn\xe9";
var OrgPathwayManagerCtrl_LastUpdatedColumn = "Derni\xe8re mise \xe0 jour";
var OrgPathwayManagerCtrl_ManagePathwaysDescription = "Ajoutez, modifiez et supprimez des parcours, ajoutez des collaborateurs, modifiez leur visibilit\xe9 et ajoutez ou supprimez des recommandations.";
var OrgPathwayManagerCtrl_NameColumn = "Nom";
var OrgPathwayManagerCtrl_UpdateVisibility = "Modifier la visibilit\xe9";
var OrgPathwayManagerCtrl_Visibility0 = "Collaborateurs";
var OrgPathwayManagerCtrl_Visibility1 = "Organisation";
var OrgPathwayManagerCtrl_Visibility2 = "Groupes";
var OrgPathwayManagerCtrl_Visibility3 = "Profil public";
var OrgPathwayManagerCtrl_VisibilityColumn = "Visibilit\xe9";
var OrgPlans_AddTargetOrDirectory = "Ajouter un plan ou un r\xe9pertoire";
var OrgPlans_AllTypes = "Types";
var OrgPlans_BundleInfo = "Les r\xe9pertoires ne peuvent pas \xeatre assign\xe9s aux lots. Si vous souhaitez les ajouter en bloc aux lots, veuillez mettre \xe0 jour vos s\xe9lections.";
var OrgPlans_ChooseType = "Souhaitez-vous cr\xe9er un plan ou un r\xe9pertoire \xa0?";
var OrgPlans_ChooseTypeHelpFormat = "Si vous avez un doute, {{aStart}}apprenez-en plus \xe0 leur sujet{{aEnd}}.";
var OrgPlans_CloneBrowse = "Cloner la navigation";
var OrgPlans_CloneDirectory = "Cloner le r\xe9pertoire";
var OrgPlans_ClonePlan = "Dupliquer le plan";
var OrgPlans_CloneRole = "Dupliquer le poste";
var OrgPlans_CloneTarget = "Dupliquer le plan";
var OrgPlans_CreateBulkRoles = "Ou {{startButton}}cr\xe9ez plusieurs plans{{endButton}} \xe0 l’aide d’un mod\xe8le.";
var OrgPlans_CreatedBy = "Cr\xe9\xe9e par";
var OrgPlans_CreateDirectory = "Cr\xe9er un r\xe9pertoire";
var OrgPlans_CreateRole = "Cr\xe9er un poste";
var OrgPlans_CreateTarget = "Cr\xe9er un plan";
var OrgPlans_CreateTargetOrDirectory = "Cr\xe9er un plan ou un r\xe9pertoire";
var OrgPlans_CustomTitlesAndDescriptionsNotLocalized = "Les titres et descriptions personnalis\xe9s ne seront pas traduits.";
var OrgPlans_CustomTitlesAndTextNotLocalized = "Les titres et textes personnalis\xe9s ne seront pas traduits.";
var OrgPlans_DeletePluralPrompt = "Are you sure you want to delete {{ count }} plans?";
var OrgPlans_DeletePrompt = "Are you sure you want to delete 1 plan?";
var OrgPlans_Description = "Description";
var OrgPlans_DescriptionPlaceholder = "Courte description du plan";
var OrgPlans_Directory = "R\xe9pertoire";
var OrgPlans_DirectoryDescription = "Une page de navigation pour aider les utilisateurs \xe0 trouver des plans";
var OrgPlans_DirectoryDescriptionPlaceholder = "La mission du service financier est de...";
var OrgPlans_DirectoryImageAlt = "Image d’un r\xe9pertoire";
var OrgPlans_DirectoryTitlePlaceholder = "par ex. Finance";
var OrgPlans_DisplayTypePlaceholder = "Utilis\xe9 pour les plans de carri\xe8re";
var OrgPlans_EditBrowse = "Modifier la navigation";
var OrgPlans_EditDirectory = "Modifier le r\xe9pertoire";
var OrgPlans_EditFeatured = "Modifier la page \xc0 la une";
var OrgPlans_EditFeaturedPermissionError = "Vous ne disposez pas des autorisations requises pour modifier le plan \xe0 la une. Contactez votre administrateur Degreed pour obtenir l’autorisation voulue.";
var OrgPlans_EditRole = "Modifier le plan d’\xe9volution de poste";
var OrgPlans_EditTarget = "Modifier le plan";
var OrgPlans_Featured = "\xc0 la une";
var OrgPlans_FollowerCount = "Abonn\xe9s";
var OrgPlans_ImageUpload = "Image";
var OrgPlans_NoPlansAdded = "Aucun plan n’a \xe9t\xe9 cr\xe9\xe9 pour cette organisation.";
var OrgPlans_NoPlansFound = "Aucun plan ne correspond au terme de votre recherche.";
var OrgPlans_OnBrowseTooltip = "Cette page s’affichera en tant que section sur la page de navigation";
var OrgPlans_OnFeaturedTooltip = "Ce plan s’affiche sur la page \xc0 la une de votre organisation dans Degreed.";
var OrgPlans_Pages = "R\xe9pertoires";
var OrgPlans_Parent = "Parent";
var OrgPlans_Plan = "Plan";
var OrgPlans_PlanDescription = "Un ensemble d’\xe9l\xe9ments qui permettent aux abonn\xe9s de progresser dans une comp\xe9tence, un poste ou un plan de carri\xe8re";
var OrgPlans_PlanImageAlt = "Chiffre d’un plan";
var OrgPlans_Plans = "Plans";
var OrgPlans_Purpose = "Objet";
var OrgPlans_SetAsPrimaryPlan = "D\xe9finir un plan principal";
var OrgPlans_SkillPlanPlaceholder = "Utilis\xe9 pour le d\xe9veloppement personnel";
var OrgPlans_Subtitle = "Sous-titre";
var OrgPlans_SubtitlePlaceholder = "Indiquez un secteur d’activit\xe9 ou un domaine d’expertise";
var OrgPlans_SubtitleTooltip = "Visible sur les cartes dans les plans";
var OrgPlans_TargetDescriptionPlaceholder = "Courte description du plan";
var OrgPlans_Template = "Template";
var OrgPlans_Title = "Titre";
var OrgPlans_TitlePlaceholder = "Par exemple\xa0: Directeur commercial";
var OrgPlans_Type = "Type";
var OrgPlans_TypeBrowse = "Parcourir";
var OrgPlans_TypeDirectory = "R\xe9pertoire";
var OrgPlans_TypeFeatured = "\xc0 la une";
var OrgPlans_TypeRole = "Plan d’\xe9volution de poste";
var OrgPlans_Types = "Types";
var OrgPlans_TypeTarget = "Plan";
var OrgPlans_Visibility = "Visibilit\xe9";
var orgProviderLicenseModal_ContinueButtonFormat = "Continuer vers {{providerName}}";
var orgProviderLicenseModal_CreatedLicenseFormat = "Nous avons cr\xe9\xe9 votre licence {{providerName}}.";
var orgProviderLicenseModal_InstructionsFormat = "L’acc\xe8s est requis pour ce fournisseur.";
var orgProviderLicenseModal_LicenseErrorFormat = "Nous avons eu un probl\xe8me pour cr\xe9er une licence {{providerName}} pour vous. Veuillez r\xe9essayer ou {{anchorOpen}}allez directement au contenu gratuit{{anchorClose}}.";
var orgProviderLicenseModal_MessageErrorFormat = "Oups ! Nous n’avons pu acc\xe9der \xe0 votre accord de licence. Vous pouvez revenir \xe0 la recherche {{anchorOpen}} ici {{anchorClose}}.";
var OrgRatingScaleChange_NotificationContent = "L’\xe9chelle de ma\xeetrise des comp\xe9tences de {{ orgName }} a \xe9t\xe9 mise \xe0 jour. V\xe9rifiez vos niveaux de comp\xe9tence pour vous assurer qu’ils sont en phase avec la nouvelle \xe9chelle.\n{{ viewNewRatingScaleHtml }}";
var OrgRatingScaleChange_NotificationDescription = "Les niveaux d’\xe9valuations des comp\xe9tences de votre organisation sont pass\xe9s d’une \xe9chelle d’\xe9valuation \xe0 {{oldRatingScale}} points \xe0 une nouvelle \xe9chelle d’\xe9valuation \xe0 {{newRatingScale}} points. Ce changement vous aidera \xe0 optimiser le d\xe9veloppement des comp\xe9tences et \xe0 aligner vos donn\xe9es de comp\xe9tences sur les besoins de votre organisation.";
var OrgRatingScaleChange_NotificationTitle = "Nouveaux niveaux d’\xe9valuations des comp\xe9tences";
var OrgReportingCtrl_All = "Tout";
var OrgReportingCtrl_AllCompletedContent = "Tous les contenus effectu\xe9s";
var OrgReportingCtrl_AllGroups = "Tous les groupes";
var OrgReportingCtrl_AllSkills = "Toutes les comp\xe9tences";
var OrgReportingCtrl_AllTopics = "Toutes les comp\xe9tences";
var OrgReportingCtrl_And = "et";
var OrgReportingCtrl_Count = "Nombre";
var OrgReportingCtrl_DateMaxValidation = "Veuillez ne pas s\xe9lectionner plus de 365 jours.";
var OrgReportingCtrl_DateMaxValidationFormat = "Veuillez s\xe9lectionner un maximum de {{numDays}} jours.";
var OrgReportingCtrl_DownloadableReports = "Rapports t\xe9l\xe9chargeables";
var OrgReportingCtrl_ErrorWithProvider = "Nous avons rencontr\xe9 un probl\xe8me avec ce fournisseur";
var OrgReportingCtrl_ExternalCatalog = "Catalogue externe";
var OrgReportingCtrl_ExternalContent = "Contenu externe";
var OrgReportingCtrl_FilterByGroup = "Filtrer par groupe";
var OrgReportingCtrl_FilterByLocation = "Filtrer par lieu";
var OrgReportingCtrl_FilterByOrg = "Filtrer par organisation";
var OrgReportingCtrl_FilterBySkill = "Filtrer par comp\xe9tence";
var OrgReportingCtrl_FullCatalog = "Tout le catalogue";
var OrgReportingCtrl_InputsAdded = "Entr\xe9es ajout\xe9es";
var OrgReportingCtrl_Insights = "Statistiques";
var OrgReportingCtrl_InternalCatalog = "Catalogue interne";
var OrgReportingCtrl_InternalContent = "Contenu interne";
var OrgReportingCtrl_ItemsAdded = "\xc9l\xe9ments ajout\xe9s";
var OrgReportingCtrl_KpiItemsAddedName = "\xc9l\xe9ments termin\xe9s";
var OrgReportingCtrl_KpiItemsAddedTooltip = "Inclut tout contenu marqu\xe9 comme termin\xe9 durant la p\xe9riode d\xe9finie.";
var OrgReportingCtrl_KpiLoginsName = "Utilisateurs actifs";
var OrgReportingCtrl_KpiLoginsTooltip = "Un utilisateur actif est une personne qui s’est connect\xe9e au moins une fois durant la p\xe9riode d\xe9finie.";
var OrgReportingCtrl_KpiOrgExpertsName = "Experts dans {{metricSecondary}} comp\xe9tence(s)";
var OrgReportingCtrl_KpiOrgExpertsTooltip = "Il s’agit du nombre d’apprenants ayant obtenu une note de 6 \xe0 8 pour une comp\xe9tence, ainsi que le nombre de comp\xe9tences pour lesquelles ces apprenants ont une note de 6 \xe0 8.";
var OrgReportingCtrl_KpiRecommendationsName = "\xc9l\xe9ments partag\xe9s";
var OrgReportingCtrl_KpiRecommendationsTooltip = "Inclut le contenu partag\xe9 avec des individus ou groupes durant la p\xe9riode d\xe9finie.";
var OrgReportingCtrl_KPIS_Error = "Nous avons eu un probl\xe8me en essayant de charger vos KPI.";
var OrgReportingCtrl_KpiSkillRatedUsersName = "\xc9valu\xe9s pour au moins 1\xa0comp\xe9tence";
var OrgReportingCtrl_KpiSkillRatedUsersTooltip = "Il s’agit du pourcentage d’apprenants qui ont au moins une \xe9valuation de comp\xe9tence. Des pourcentages \xe9lev\xe9s signifient que les statistiques de comp\xe9tence incluent davantage d’apprenants.";
var OrgReportingCtrl_KpiViewsName = "\xc9l\xe9ments consult\xe9s";
var OrgReportingCtrl_KpiViewsTooltip = "Inclut le contenu et les \xe9l\xe9ments de r\xe9ussite consult\xe9s durant la p\xe9riode d\xe9finie.";
var OrgReportingCtrl_LearningSummary = "Bilan des formations";
var OrgReportingCtrl_Members = "Membres";
var OrgReportingCtrl_MinimumAggregatedLearningInsightsUserCount = "Les groupes comptant moins de {{number}} utilisateurs n’appara\xeetront pas dans cette liste.";
var OrgReportingCtrl_Name = "Nom";
var OrgReportingCtrl_NoMatchingGroups = "Aucun groupe correspondant";
var OrgReportingCtrl_NoMatchingLocations = "Aucun emplacement correspondant";
var OrgReportingCtrl_NoMatchingOrgs = "Aucune organisation correspondante";
var OrgReportingCtrl_NoMatchingSkills = "Aucune comp\xe9tence correspondante";
var OrgReportingCtrl_NoMatchingStatus = "Aucun \xe9tat correspondant";
var OrgReportingCtrl_NoMatchingTypes = "Aucun type correspondant";
var OrgReportingCtrl_NoResults = "Les filtres n’ont retourn\xe9 aucun r\xe9sultat.";
var OrgReportingCtrl_Points = "Points";
var OrgReportingCtrl_ResultsFormat = "{{count}} r\xe9sultats";
var OrgReportingCtrl_ShouldNotBeConnected = "Ce fournisseur ne devrait plus \xeatre connect\xe9";
var OrgReportingCtrl_TimesAdded = "Ajouts";
var OrgReportingCtrl_TopResultsFormat = "{{count}} meilleurs r\xe9sultats";
var OrgReportingCtrl_TotalContentViewed = "Nombre de contenus affich\xe9s";
var OrgReportingCtrl_TotalItemsAdded = "Nombre total d’\xe9l\xe9ments ajout\xe9s";
var OrgReportingCtrl_TotalPointsEarned = "Nombre total de points gagn\xe9s";
var OrgReportSchedule_Frequency_Daily = "Quotidien (tous les jours)";
var OrgReportSchedule_Frequency_DailyMondayThruFriday = "Quotidien (lun-ven)";
var OrgReportSchedule_Frequency_Monthly = "Mensuel (envoy\xe9 le 1er)";
var OrgReportSchedule_Frequency_Quarterly = "Trimestriel (envoy\xe9 le 1er)";
var OrgReportSchedule_Frequency_WeeklyOnMonday = "Hebdomadaire (envoy\xe9 le lundi)";
var OrgReportSchedule_Frequency_WeeklyOnSunday = "Hebdomadaire (envoy\xe9 le dimanche)";
var OrgSecurityCtrl_CreateGroups = "Cr\xe9er des groupes";
var OrgSecurityCtrl_DefaultRoleTextFormat = "Le r\xf4le par d\xe9faut pour les nouveaux membres de votre organisation est \xab\xa0{{name}}\xa0\xbb";
var OrgSecurityCtrl_RolesUpdatedSuccessMessage = "Mise \xe0 jour des r\xf4les de l'organisation effectu\xe9e.";
var OrgSettings_AcceptJobRoleFromClientUserFile_Desc = "Activez la d\xe9finition des postes pour un utilisateur \xe0 partir d’un fichier ClientUser.";
var OrgSettings_AddCard = "Ajouter une carte";
var OrgSettings_AdminNotifications = "Notifications administrateur";
var OrgSettings_AllowEmailPasswordReset_Desc = "Autoriser les apprenants \xe0 r\xe9initialiser le mot de passe de leur compte Degreed par e-mail.";
var OrgSettings_AllowEmailPasswordReset_Name = "R\xe9initialisation du mot de passe par e-mail.";
var OrgSettings_AllowInteractionAcrossOrganizations_Desc = "Cette fonctionnalit\xe9 permet aux entreprises \xe9tendues de partager des informations \xe0 l’ensemble des organisations ayant activ\xe9 cette option. Il s’agit notamment de la possibilit\xe9 de suivre les apprenants, de partager du contenu et de rendre visibles les \xe9valuations et les commentaires.";
var OrgSettings_AllowInteractionAcrossOrganizations_Name = "Permettre les interactions entre apprenants des diff\xe9rentes organisations";
var OrgSettings_AllowOrgTransfer_Desc = "Pour les organisations Extended Enterprise, cela permet d’activer le transfert automatique du profil d’un apprenant lorsque ce dernier est int\xe9gr\xe9 \xe0 une nouvelle organisation. Cette fonctionnalit\xe9 n\xe9cessite un identifiant unique et identique entre les organisations. Par exemple\xa0: un ID d’employ\xe9 collaborateur ou autre qui ne change pas lorsque l’apprenant est transf\xe9r\xe9 dans une nouvelle organisation.";
var OrgSettings_AllowOrgTransfer_Name = "Transfert automatique des apprenants entre les organisations";
var OrgSettings_AllowSkillSuggestions_Desc = "Utilisez l’inf\xe9rence d’IA de Degreed pour sugg\xe9rer des comp\xe9tences aux utilisateurs.";
var OrgSettings_AllowSkillSuggestions_Name = "Autoriser les suggestions de comp\xe9tences";
var OrgSettings_AllowSsoUserIdUpdate_Desc = "AllowSsoUserIdUpdate";
var OrgSettings_AllowSsoUserIdUpdate_Name = "AllowSsoUserIdUpdate";
var OrgSettings_AnonymizeCredsparkUsers_Desc = "Anonymiser le pr\xe9nom, le nom, l’adresse\xa0IP et l’adresse e-mail pour Credspark";
var OrgSettings_AnonymizeCredsparkUsers_Name = "Anonymiser les utilisateurs Credspark";
var OrgSettings_AnonymizePrivateUsers_Desc = "Les apprenants qui utilisent un profil priv\xe9 seront anonymis\xe9s sur l’ensemble de la plateforme et dans les statistiques.";
var OrgSettings_AnonymizePrivateUsers_Name = "Anonymiser les apprenants priv\xe9s";
var OrgSettings_AnonymizeZendeskUsers_Desc = "Les utilisateurs de cette organisation seront connect\xe9s \xe0 Zendesk par le biais de leur pseudonyme.";
var OrgSettings_AnonymizeZendeskUsers_Name = "Anonymiser les utilisateurs Zendesk";
var OrgSettings_AppFeedback_GroupDesc = "Activez les param\xe8tres pour que les apprenants puissent fournir un retour sur Degreed.";
var OrgSettings_AppFeedback_GroupDisplayName = "Feedback sur l’application";
var OrgSettings_AppGuidance_GroupDesc = "Activez les conseils dans l’application pour vous renseigner sur les fonctionnalit\xe9s principales.";
var OrgSettings_AppGuidance_GroupDisplayName = "Conseils de l’application";
var OrgSettings_AssignedLearning_Desc = "Avertit les apprenants lorsqu’ils ont un nouvel apprentissage assign\xe9.";
var OrgSettings_AssignedLearning_Name = "Formations assign\xe9es";
var OrgSettings_AssignedLearningDescription = "Les formations assign\xe9es comprennent les formations assign\xe9es ou obligatoires avec une date limite.";
var OrgSettings_AssignedLearningSaveSuccess = "La carte Formation assign\xe9e a bien \xe9t\xe9 enregistr\xe9e.";
var OrgSettings_AuditUserGeneratedData_Desc = "Cette option permet au syst\xe8me Degreed de commencer \xe0 recueillir des donn\xe9es textuelles issues des r\xe9seaux sociaux. Si les clients sont int\xe9ress\xe9s par cette fonctionnalit\xe9, ils doivent l’activer d\xe8s que possible, car les donn\xe9es ne peuvent pas \xeatre collect\xe9es r\xe9troactivement. Cette fonctionnalit\xe9 a \xe9t\xe9 ajout\xe9e conform\xe9ment aux r\xe9glementations am\xe9ricaines de la FINRA pour Ameriprise et RBC, mais peut ne pas convenir aux entreprises non financi\xe8res ayant des employ\xe9s dans d’autres pays.";
var OrgSettings_AuditUserGeneratedData_Name = "Audit des donn\xe9es textuelles issues des r\xe9seaux sociaux";
var OrgSettings_AuthenticationSettings = "Param\xe8tres d’authentification";
var OrgSettings_BuildSkillsEmail_Desc = "Invite les apprenants \xe0 d\xe9velopper leurs comp\xe9tences en consultant des contenus de formation et en marquant les \xe9l\xe9ments comme termin\xe9s.";
var OrgSettings_BuildSkillsEmail_Name = "E-mail d’int\xe9gration\xa0— Jour\xa05\xa0: D\xe9veloppez vos comp\xe9tences";
var OrgSettings_ButtonTitleRequired = "L’intitul\xe9 du bouton doit \xeatre renseign\xe9.";
var OrgSettings_CardDescription = "Description de la carte";
var OrgSettings_CardDescriptionPlaceholder = "Ajouter une courte description de cette carte";
var OrgSettings_CardNumber = "Carte {{number}}";
var OrgSettings_CardPositionAriaText = "Position\xa0: {{positionNumber}} sur {{totalNumber}}";
var OrgSettings_CardTitle = "Titre de la carte";
var OrgSettings_CardTitlePlaceholder = "Ajouter le titre de la carte";
var OrgSettings_CardType = "Type de carte";
var OrgSettings_CareersFooterMessage_Desc = "Fournit une clause de non-responsabilit\xe9 au bas de la page Postes. Cette fonctionnalit\xe9 ne doit PAS \xeatre activ\xe9e pour les clients, sauf s’ils le demandent express\xe9ment.";
var OrgSettings_CareersFooterMessage_Name = "Message de bas de page sur les carri\xe8res (clause de non-responsabilit\xe9)";
var OrgSettings_ClientAdobeAnalyticsId_Desc = "Identifiant Adobe Analytics (AA) de l’organisation. Lorsqu’il est fourni, le code\xa0AA s’ex\xe9cute et est associ\xe9 \xe0 l’identifiant sp\xe9cifi\xe9.";
var OrgSettings_ClientAdobeAnalyticsId_Name = "Identifiant Adobe Analytics du client";
var OrgSettings_ClientGoogleAnalyticsId_Desc = "Identifiant Google Analytics (GA) de l’organisation. Lorsqu’il est fourni, le code\xa0GA s’ex\xe9cute et est associ\xe9 \xe0 l’identifiant sp\xe9cifi\xe9. Ce code vient s’ajouter au code\xa0GA existant qui s’ex\xe9cute pour Degreed \xe0 des fins de suivi interne.";
var OrgSettings_ClientGoogleAnalyticsId_Name = "Identifiant Google Analytics du client";
var OrgSettings_ClientTypeOverride_Desc = "Des param\xe8tres alternatifs ne doivent \xeatre s\xe9lectionn\xe9s que pour les organisations qui disposent de l’outil d’inventaire des comp\xe9tences ou d’analyse des comp\xe9tences, mais qui ne b\xe9n\xe9ficient pas de la plateforme LXP. Pour les clients\xa0LXP, y compris les clients qui disposent de l’outil d’analyse des comp\xe9tences, d\xe9finissez les param\xe8tres standard dans l’outil d’administration globale.";
var OrgSettings_ClientTypeOverride_Name = "Remplacement des param\xe8tres selon le type de client";
var OrgSettings_ClientTypeOverride_Selection_None = "Aucun(e)";
var OrgSettings_ClientTypeOverride_Selection_SkillAnalytics = "Client disposant de l’outil d’analyse des comp\xe9tences";
var OrgSettings_ClientTypeOverride_Selection_SkillInventory = "Client disposant de l’outil d’inventaire des comp\xe9tences";
var OrgSettings_CmsCascadeDeleteFileImport_Desc = "Le contenu identifi\xe9 dans le CMS comme devant \xeatre supprim\xe9 via un fichier ou une API sera \xe9galement supprim\xe9 des parcours/casiers, des plans/r\xe9pertoires et des recommandations/formations assign\xe9es. La suppression en cascade ne fonctionne que pour le contenu du CMS ou le contenu fournisseur stock\xe9 dans le CMS. Elle ne s’applique pas aux autres contenus fournisseur.";
var OrgSettings_CmsCascadeDeleteFileImport_Name = "Suppression en cascade\xa0: activer pour les \xe9l\xe9ments de contenu de l’organisation";
var OrgSettings_CmsCascadeDeleteNotifyUsers_Desc = "Des notifications seront envoy\xe9es \xe0 la fois dans l’application et par e-mail aux auteurs ou aux destinataires en fonction des r\xe9sultats de la suppression en cascade. L’e-mail sera envoy\xe9 une fois par jour et comprendra un r\xe9capitulatif de tous les \xe9l\xe9ments de contenu d’un apprenant donn\xe9. Si la notification dans l’application est lue avant l’envoi de l’e-mail, ce dernier ne sera pas envoy\xe9. Les notifications sont envoy\xe9es aux auteurs des parcours et des plans/r\xe9pertoires ainsi qu’aux destinataires des recommandations/formations assign\xe9es.";
var OrgSettings_CmsCascadeDeleteNotifyUsers_Name = "Suppression en cascade\xa0: envoyer des notifications";
var OrgSettings_CompleteViewedItems_Desc = "Invite les apprenants \xe0 terminer les \xe9l\xe9ments consult\xe9s.";
var OrgSettings_CompleteViewedItems_Name = "Terminer les \xe9l\xe9ments consult\xe9s";
var OrgSettings_Confirmation = "R\xe9initialiser l’acceptation";
var OrgSettings_ContentModeratorOptions_Desc = "D\xe9finir une description du seuil de mod\xe9ration du contenu";
var OrgSettings_ContentModeratorOptions_Name = "D\xe9finir un seuil de mod\xe9ration de contenu";
var OrgSettings_ContentSettings = "Param\xe8tres de contenu";
var OrgSettings_CreateManagerGroups_Desc = "Activer la cr\xe9ation automatique des groupes/\xe9quipes de managers";
var OrgSettings_CredSparkEnabled_Desc = "Active l’int\xe9gration\xa0CredSpark. Un ticket Jira est n\xe9cessaire pour effectuer la configuration. Nous avons besoin des d\xe9tails CredSpark suivants\xa0: identifiant et jeton. Une fois l’int\xe9gration disponible pour une organisation, vous pouvez la d\xe9sactiver ou l’activer \xe0 l’aide de ce param\xe8tre. ";
var OrgSettings_CredSparkEnabled_Name = "Int\xe9gration du test d’\xe9valuation CredSpark";
var OrgSettings_CustomizeCard = "Personnaliser la carte";
var OrgSettings_CustomizeCardDescription = "Voulez-vous personnaliser le titre et/ou la description de cette carte\xa0?";
var OrgSettings_CustomizeHelpMenu = "Personnalisez le menu d’aide de votre organisation.";
var OrgSettings_CustomMessageDesc = "Les messages personnalis\xe9s ne seront pas traduits dans la langue de pr\xe9f\xe9rence des apprenants.";
var OrgSettings_CustomOnboardingText_Default = "Poss\xe9dez-vous les comp\xe9tences n\xe9cessaires pour affronter l’avenir \xa0? Pour commencer, nous allons cr\xe9er votre profil {{orgName}}. Celui-ci permettra de trouver des ressources adapt\xe9es \xe0 votre poste, vos comp\xe9tences et vos objectifs.";
var OrgSettings_CustomOnboardingText_Desc = "Modifie le texte de la premi\xe8re page de l’int\xe9gration.";
var OrgSettings_CustomOnboardingText_Name = "Texte d’int\xe9gration personnalis\xe9";
var OrgSettings_CustomRatingLevelNames_Desc = "Indiquer les \xe9tiquettes de comp\xe9tences personnalis\xe9es, une par ligne, en commen\xe7ant par le niveau\xa01";
var OrgSettings_CustomRatingLevelNames_Name = "\xc9tiquettes personnalis\xe9es de niveau de comp\xe9tence";
var OrgSettings_CustomRatingScale_Desc = "S\xe9lectionner une valeur maximale pour l’\xe9chelle d’\xe9valuation personnalis\xe9e";
var OrgSettings_CustomRatingScale_Name = "\xc9chelle d’\xe9valuation personnalis\xe9e";
var OrgSettings_CustomRatingScale_Selection_Eight = "8";
var OrgSettings_CustomRatingScale_Selection_Five = "5";
var OrgSettings_CustomRatingScale_Selection_Four = "4";
var OrgSettings_CustomRatingScale_Selection_Nine = "9";
var OrgSettings_CustomRatingScale_Selection_Seven = "7";
var OrgSettings_CustomRatingScale_Selection_Six = "6";
var OrgSettings_CustomRatingScale_Selection_Ten = "10";
var OrgSettings_DailySummaryEmail_Desc = "E-mail quotidien contenant une synth\xe8se des activit\xe9s dans Degreed et le programme du jour.";
var OrgSettings_DailySummaryEmail_Name = "Les tendances du jour";
var OrgSettings_DateReceived = "Date de r\xe9ception (UTC)";
var OrgSettings_DefaultAssignmentsSort_Desc = "Set the default column the Assignments page should be sorted on.";
var OrgSettings_DefaultAssignmentsSort_Name = "Default Assignments Sort Column";
var OrgSettings_DefaultAssignmentsSort_Selection_AssignmentType = "Assignment Type";
var OrgSettings_DefaultAssignmentsSort_Selection_DueDate = "Due Date (default)";
var OrgSettings_DefaultMessage = "Message par d\xe9faut";
var OrgSettings_DefaultPrivacyLevel_Desc = "Confidentialit\xe9 des profils par d\xe9faut pour une organisation. Tous les nouveaux comptes utilisateur cr\xe9\xe9s via le fichier des utilisateurs et l’authentification unique recevront ce niveau de confidentialit\xe9 par d\xe9faut. ";
var OrgSettings_DefaultPrivacyLevel_Name = "Niveau de confidentialit\xe9 par d\xe9faut";
var OrgSettings_DefaultPWResetUI_Desc = "Permet de r\xe9initialiser le mot de passe d’un utilisateur au sein de l’organisation en le rempla\xe7ant par le mot de passe par d\xe9faut de l’organisation.";
var OrgSettings_DefaultPWResetUI_Name = "Activer l’IU de r\xe9initialisation du mot de passe par d\xe9faut";
var OrgSettings_DefaultUserPassword_Desc = "D\xe9finit un mot de passe par d\xe9faut pour tous les nouveaux utilisateurs. Ils seront invit\xe9s \xe0 le modifier lors de leur premi\xe8re connexion.";
var OrgSettings_DefaultUserPassword_Name = "Mot de passe utilisateur par d\xe9faut";
var OrgSettings_DegreedCareerMobility = "Marketplace d’opportunit\xe9s Degreed";
var OrgSettings_DegreedFeatures = "Fonctionnalit\xe9s Degreed";
var OrgSettings_DegreedLearnUponUserSync = "Synchronisation des utilisateurs Degreed LearnUpon";
var OrgSettings_DegreedSurveys_Desc = "Les apprenants voient appara\xeetre des sondages et des invitations \xe0 participer aux \xe9tudes pour am\xe9liorer l’exp\xe9rience Degreed.";
var OrgSettings_DegreedSurveys_Name = "Participer aux \xe9tudes utilisateur de Degreed";
var OrgSettings_DegreedTalent_Desc = "Le produit Marketplace d’opportunit\xe9s disponible moyennant des frais suppl\xe9mentaires.";
var OrgSettings_DegreedTalent_Name = "Marketplace d’opportunit\xe9s Degreed";
var OrgSettings_DeleteCardAriaText = "Supprimer le num\xe9ro de carte {{cardNumber}}";
var OrgSettings_DeleteCardSuccess = "{{cardType}} a bien \xe9t\xe9 supprim\xe9e.";
var OrgSettings_DeleteLink = "Supprimer le lien";
var OrgSettings_DeleteLinkModalMessage = "Voulez-vous vraiment supprimer le lien \xab\xa0{{startEmphasisTag}}{{linkTitle}}{{endEmphasisTag}}\xa0\xbb de cette carte\xa0?";
var OrgSettings_DeleteLinkSuccess = "Le lien enregistr\xe9 a bien \xe9t\xe9 supprim\xe9.";
var OrgSettings_DeleteSavedLink = "Supprimer le lien enregistr\xe9";
var OrgSettings_Delimiter_Desc = "Valeur pour d\xe9limiter les fichiers CSV. Virgule (,) par d\xe9faut.";
var OrgSettings_Delimiter_Name = "S\xe9parateur de fichier";
var OrgSettings_DenyComments_Desc = "D\xe9sactive la fonctionnalit\xe9 permettant de soumettre un avis pour tous les apprenants de l’organisation. Seules BofA (29) et Ameriprise Financial (481) disposent de ce param\xe8tre. *Nous ne recommandons pas aux clients de d\xe9sactiver cette fonctionnalit\xe9.*";
var OrgSettings_DenyComments_Name = "D\xe9sactiver les avis";
var OrgSettings_DGAssistant_GroupDesc = "Param\xe8tres d’assistant";
var OrgSettings_DGAssistant_GroupDisplayName = "Param\xe8tres d’assistant";
var OrgSettings_DGAssistantQuickResponse_Desc = "Permet de raccourcir les d\xe9lais de r\xe9ponse.";
var OrgSettings_DGAssistantQuickResponse_Name = "R\xe9ponses rapides";
var OrgSettings_DisableAnalytics_Desc = "D\xe9sactive les analyses de tiers\xa0: Drift, FullStory, Engagio et Google\xa0Analytics. Cette option est rarement utilis\xe9e. *Nous ne recommandons pas aux clients de d\xe9sactiver cette fonctionnalit\xe9.*";
var OrgSettings_DisableAnalytics_Name = "D\xe9sactive le suivi analytique de tiers";
var OrgSettings_DisableAssignedLearning_Desc = "D\xe9sactive la fonctionnalit\xe9 \xab\xa0Formation assign\xe9e\xa0\xbb qui permet aux apprenants de recommander du contenu avec une date. Cette option est rarement utilis\xe9e. *Nous ne recommandons pas aux clients de d\xe9sactiver cette fonctionnalit\xe9.*";
var OrgSettings_DisableAssignedLearning_Name = "D\xe9sactiver la formation assign\xe9e";
var OrgSettings_DisableAssignedLearningTab_Desc = "Hides the assigned learning tab on the learner's homepage.";
var OrgSettings_DisableAssignedLearningTab_Name = "Disable Assigned Learning Tab (Learner Hub)";
var OrgSettings_DisableBulkUpload_Desc = "D\xe9sactive la possibilit\xe9 pour les apprenants de charger un mod\xe8le permettant d’ajouter des \xe9l\xe9ments en bloc.";
var OrgSettings_DisableBulkUpload_Name = "D\xe9sactiver le chargement en bloc";
var OrgSettings_DisableCollaboratorsHeader_Desc = "Cette fonctionnalit\xe9 permet de masquer la liste des collaborateurs en haut des parcours, des plans ou des r\xe9pertoires. Elle est activ\xe9e par d\xe9faut pour toutes les organisations.";
var OrgSettings_DisableCollaboratorsHeader_Name = "Masquer la liste des collaborateurs pour les parcours/plans/r\xe9pertoires";
var OrgSettings_DisableContent2skills_Desc = "When checked, it disables the use of DS Content to Skill inference service for the organization.";
var OrgSettings_DisableContent2skills_Name = "Disable content2skills inference";
var OrgSettings_DisableDegreedMarketplace_Desc = "Si cette option est d\xe9sactiv\xe9e, les apprenants ne verront pas la marketplace Degreed s’afficher pour leur organisation.";
var OrgSettings_DisableDegreedMarketplace_Name = "D\xe9sactiver la marketplace Degreed";
var OrgSettings_DisableEndorsedSearchResultsSection_Desc = "D\xe9sactive la section R\xe9sultats de recherche recommand\xe9s en haut des r\xe9sultats.";
var OrgSettings_DisableEndorsedSearchResultsSection_Name = "D\xe9sactiver la section R\xe9sultats de recherche recommand\xe9s ";
var OrgSettings_DisableEngagedLearner_Desc = "D\xe9sactive tous les insignes d’apprenant actif dans Degreed.";
var OrgSettings_DisableEngagedLearner_Name = "D\xe9sactiver le statut d’apprenant actif";
var OrgSettings_DisableHomeAdminSettings_Desc = "This setting will remove the ability for org admins to customize insight cards, organizational announcements and links and will hide the home tab in the settings area.";
var OrgSettings_DisableHomeAdminSettings_Name = "Disable Home Admin Settings";
var OrgSettings_DisableIndividualSkillsData_Desc = "D\xe9sactive l’autorisation bas\xe9e sur les r\xf4les, dans G\xe9rer [organisation]\xa0>\xa0Autorisations, permettant de contr\xf4ler l’analyse approfondie d’une liste d’apprenants dans les statistiques de comp\xe9tences de l’organisation.";
var OrgSettings_DisableIndividualSkillsData_Name = "D\xe9sactiver l’acc\xe8s aux donn\xe9es de comp\xe9tences individuelles dans les statistiques de comp\xe9tences de l’organisation";
var OrgSettings_DisableInviteOrgMember_Desc = "D\xe9sactive l’autorisation d’inviter des membres de l’organisation.";
var OrgSettings_DisableInviteOrgMember_Name = "D\xe9sactiver l’invitation des membres de l’organisation";
var OrgSettings_DisableKnowledgeCenter_Desc = "D\xe9sactive l’autorisation d’acc\xe8s au Centre de connaissances et le lien correspondant de la rubrique d’aide dans le coin inf\xe9rieur droit.";
var OrgSettings_DisableKnowledgeCenter_Name = "D\xe9sactiver le Centre de connaissances";
var OrgSettings_DisableLearnerSkillsRegistry_Desc = "Si cette option est d\xe9sactiv\xe9e, les apprenants ne verront pas les suggestions du r\xe9pertoire des comp\xe9tences lors de l’ajout d’une comp\xe9tence \xe0 un plan ou \xe0 un parcours, par exemple.";
var OrgSettings_DisableLearnerSkillsRegistry_Name = "D\xe9sactiver le r\xe9pertoire des comp\xe9tences pour les apprenants";
var OrgSettings_DisableLearningCampaigns_Desc = "Cette fonctionnalit\xe9 permet de d\xe9sactiver les liens tra\xe7ables dans les statistiques des parcours, disponibles depuis juillet\xa02018, et dans les statistiques des plans, disponibles depuis avril\xa02019. Elle est activ\xe9e par d\xe9faut pour toutes les organisations.";
var OrgSettings_DisableLearningCampaigns_Name = "D\xe9sactiver les liens tra\xe7ables dans les parcours et les plans";
var OrgSettings_DisableManageContent_Desc = "D\xe9sactive l’autorisation G\xe9rer le contenu et la gestion du contenu sur la page Contenu.";
var OrgSettings_DisableManageContent_Name = "D\xe9sactiver la gestion du contenu";
var OrgSettings_DisableMedalliaScript_Desc = "D\xe9sactive le suivi par Medallia.";
var OrgSettings_DisableMedalliaScript_Name = "R\xe9duire le suivi";
var OrgSettings_DisableMentorshipReview_Desc = "D\xe9sactive l’option permettant de soumettre et de demander des \xe9valuations de comp\xe9tences, de donner et de demander du feedback, et d’ajouter des exp\xe9riences de mentorat au profil lorsqu’elles sont termin\xe9es. La d\xe9sactivation de cette fonctionnalit\xe9 n’est pas recommand\xe9e.";
var OrgSettings_DisableMentorshipReview_Name = "D\xe9sactiver l’\xe9valuation de mentorat";
var OrgSettings_DisablePathwayHeaderImage_Desc = "Cette fonctionnalit\xe9 permet de supprimer/d\xe9sactiver l’image d’en-t\xeate servant d’arri\xe8re-plan \xe0 l’intitul\xe9 du parcours, en haut de la page du parcours. Elle d\xe9sactive l’image d’en-t\xeate pour tous les parcours de l’organisation. Les images d’en-t\xeate peuvent toutefois \xeatre activ\xe9es pour chaque parcours dans les param\xe8tres du parcours. Ceci ne s’applique qu’\xe0 la nouvelle version des parcours.";
var OrgSettings_DisablePathwayHeaderImage_Name = "D\xe9sactiver l’image d’en-t\xeate pour tous les parcours de l’organisation";
var OrgSettings_DisablePersonalizedLearningTab_Desc = "Hides the personalized learning tab on the learner's homepage.";
var OrgSettings_DisablePersonalizedLearningTab_Name = "Disable Personalized Learning Tab (Learner Hub)";
var OrgSettings_DisablePopupMessages_Desc = "Masque l’onglet Messages qui permet de configurer des messages contextuels.";
var OrgSettings_DisablePopupMessages_Name = "D\xe9sactiver les messages contextuels";
var OrgSettings_DisableProfileSkillSuggestions_Desc = "Disables the skill suggestions feature found in the profile overview and skills modal";
var OrgSettings_DisableProfileSkillSuggestions_Name = "Disable profile skill suggestions";
var OrgSettings_DisableRatingsInsights_Desc = "D\xe9sactive/masque le graphique des \xe9valuations de comp\xe9tences sur la page Statistiques de l’organisation et les graphiques des statistiques de comp\xe9tences sur la page Statistiques du plan. Seules BofA et SunCME (507) disposent de ce param\xe8tre. Nous ne recommandons pas aux clients de d\xe9sactiver cette fonctionnalit\xe9.";
var OrgSettings_DisableRatingsInsights_Name = "D\xe9sactiver les statistiques relatives aux \xe9valuations de comp\xe9tences";
var OrgSettings_DisableResumeParsingInOnboarding_Desc = "D\xe9sactive la fonctionnalit\xe9 d’analyse du CV pour les utilisateurs d’une organisation lors du processus d’int\xe9gration.";
var OrgSettings_DisableSearchRelatedSkills_Desc = "Lorsque cette section est d\xe9sactiv\xe9e, les comp\xe9tences connexes ne seront pas sugg\xe9r\xe9es sur la page des r\xe9sultats.";
var OrgSettings_DisableSearchRelatedSkills_Name = "D\xe9sactiver la recherche de comp\xe9tences associ\xe9es";
var OrgSettings_DisableSkillsVisualization_Desc = "Hides the skills visualization section on the learner's homepage.";
var OrgSettings_DisableSkillsVisualization_Name = "Disable Skills Visualization (Learner Hub)";
var OrgSettings_DisableThirdPartyExperienceManagement_Desc = "D\xe9sactive le suivi par des scripts tiers.";
var OrgSettings_DisableThirdPartyExperienceManagement_Name = "R\xe9duire le suivi";
var OrgSettings_DisableTopLearnerInsights_Desc = "D\xe9sactive tous les graphiques des statistiques relatives aux meilleurs apprenants sur la page Statistiques de l’organisation.";
var OrgSettings_DisableTopLearnerInsights_Name = "D\xe9sactiver les statistiques relatives aux meilleurs apprenants";
var OrgSettings_DisableUserGeneratedContent_Desc = "D\xe9sactive la fonctionnalit\xe9 Degreed de vid\xe9o g\xe9n\xe9r\xe9e par les utilisateurs.";
var OrgSettings_DisableUserGeneratedContent_Name = "D\xe9sactiver la vid\xe9o g\xe9n\xe9r\xe9e par les utilisateurs";
var OrgSettings_DiscardCardChanges = "Les modifications que vous avez apport\xe9es \xe0 la carte seront perdues.";
var OrgSettings_DownloadablePathwayReportEmployeeIdentifier_Desc = "S\xe9lectionne la ou les valeurs \xe0 utiliser pour identifier les collaborateurs dans le rapport Parcours t\xe9l\xe9chargeable.";
var OrgSettings_DownloadablePathwayReportEmployeeIdentifier_Name = "Identifier les collaborateurs dans le rapport Parcours t\xe9l\xe9chargeable";
var OrgSettings_DownloadablePathwayReportEmployeeIdentifier_Selection_Both = "ID d’employ\xe9 et adresse e-mail du collaborateur";
var OrgSettings_DownloadablePathwayReportEmployeeIdentifier_Selection_EmployeeIdOnly = "ID d’employ\xe9";
var OrgSettings_DownloadablePathwayReportEmployeeIdentifier_Selection_OrganizationEmailOnly = "Adresse e-mail du collaborateur";
var OrgSettings_DownloadableReportPermissionReadOnly_Desc = "D\xe9sactive l’autorisation T\xe9l\xe9charger les rapports et l’autorisation T\xe9l\xe9charger des rapports sur les d\xe9tails des parcours, de sorte que m\xeame les administrateurs ne puissent pas d\xe9finir les r\xf4les disposant de ces autorisations. Bank of America dispose de cette fonctionnalit\xe9, ce qui lui permet de d\xe9sactiver l’autorisation pour tous les r\xf4les, y compris le r\xf4le d’administrateur, puis de d\xe9sactiver l’autorisation de sorte que m\xeame les administrateurs ne puissent pas t\xe9l\xe9charger les rapports.";
var OrgSettings_DownloadableReportPermissionReadOnly_Name = "D\xe9sactiver l’autorisation de t\xe9l\xe9chargement des rapports";
var OrgSettings_EmailSettings = "Param\xe8tres des e-mails";
var OrgSettings_EmailSettings_Desc = "Invite l’apprenant \xe0 activer l’envoi des e-mails quotidiens.";
var OrgSettings_EmailSettings_GroupDesc = "Param\xe8tres d’e-mail informatif par d\xe9faut pour les nouveaux utilisateurs.";
var OrgSettings_EmailSettings_GroupDisplayName = "Param\xe8tres de messagerie";
var OrgSettings_EmailSettings_Name = "Param\xe8tres de messagerie";
var OrgSettings_EmployeeProcessing = "Traitement du personnel";
var OrgSettings_EnableActiveUserInsights_Desc = "Permet d’afficher le graphique des utilisateurs actifs (qui affiche \xe9galement des donn\xe9es sur les nouveaux utilisateurs et les utilisateurs r\xe9currents) sur la page Statistiques de l’organisation.";
var OrgSettings_EnableActiveUserInsights_Name = "Activer les statistiques sur les utilisateurs actifs";
var OrgSettings_EnableAdvancedSkillAnalytics_Desc = "Activez les visualisations avanc\xe9es de Skill Analytics.";
var OrgSettings_EnableAdvancedSkillAnalytics_Name = "Activer les fonctions avanc\xe9es de Skill Analytics";
var OrgSettings_EnableAISkillInference_Desc = "D\xe9duisez des comp\xe9tences \xe0 partir des postes de votre organisation.";
var OrgSettings_EnableAISkillInference_Name = "Activer l’inf\xe9rence des comp\xe9tences par l’IA Degreed";
var OrgSettings_EnableCareerPathing_Desc = "Un cadre souple pour construire une hi\xe9rarchie de contenu.";
var OrgSettings_EnableCareerPathing_Name = "Plans de carri\xe8re (les plans doivent \xe9galement \xeatre activ\xe9s)";
var OrgSettings_EnableCustomRatingLevelNames_Desc = "Permet \xe0 chaque niveau de comp\xe9tence d’avoir une \xe9tiquette diff\xe9rente.";
var OrgSettings_EnableCustomRatingLevelNames_Name = "\xc9tiquettes personnalis\xe9es de niveau de comp\xe9tence";
var OrgSettings_EnableCustomRatingScale_Desc = "Permet \xe0 l’organisation d’avoir une \xe9chelle d’\xe9valuation personnalis\xe9e.";
var OrgSettings_EnableCustomRatingScale_Name = "\xc9chelle d’\xe9valuation personnalis\xe9e";
var OrgSettings_EnableCustomRecommendationTypes_Desc = "Enables custom recommendation types (Mandatory, Recommended)";
var OrgSettings_EnableCustomRecommendationTypes_Name = "Enable Custom Recommendation Types";
var OrgSettings_EnableDCMPilot_Desc = "Utiliser les groupes pour contr\xf4ler la visibilit\xe9 de la marketplace d’opportunit\xe9s dans Degreed en fonction de l’appartenance au groupe. La marketplace d’opportunit\xe9s et les param\xe8tres de groupe seront visibles par les utilisateurs disposant du r\xf4le d’administrateur technique et d’administrateur.";
var OrgSettings_EnableDCMPilot_Name = "Activer DCM pour le POC/pilote";
var OrgSettings_EnableDirectoriesOnBrowse_Desc = "Si cette option est activ\xe9e, la page Parcourir affichera l’onglet R\xe9pertoires pour permettre aux utilisateurs de parcourir les r\xe9pertoires.";
var OrgSettings_EnableDirectoriesOnBrowse_Name = "Activer l’onglet R\xe9pertoires sur la page Parcourir";
var OrgSettings_EnableEngage_Desc = "Active l’application et les fonctionnalit\xe9s Engage pour l’organisation.";
var OrgSettings_EnableEngage_Name = "Activer Engage";
var OrgSettings_EnableEvaluationEndorsements_Desc = "Cette option permet d’ajouter une \xe9tape suppl\xe9mentaire n\xe9cessitant l’intervention d’un approbateur dans le cadre d’une revue de comp\xe9tence.";
var OrgSettings_EnableEvaluationEndorsements_Name = "Activer la validation par des pairs dans le cadre d’une revue de comp\xe9tence";
var OrgSettings_EnableManagerOfManager_Desc = "Permet d’activer les filtres des managers de managers dans Skill\xa0Coach.";
var OrgSettings_EnableManagerOfManager_Name = "Activer les filtres des managers de managers dans Skill\xa0Coach";
var OrgSettings_EnableManagerRatings_Desc = "Permet aux responsables d’\xe9valuer les comp\xe9tences de leurs employ\xe9s.";
var OrgSettings_EnableManagerRatings_Name = "\xc9valuations du responsable";
var OrgSettings_EnableMentorshipOpportunities_Desc = "Pour voir Mentorat dans l’application, l’organisation doit \xe9galement utiliser Mobilit\xe9 interne.";
var OrgSettings_EnableMentorshipOpportunities_Name = "Activer les opportunit\xe9s de mentorat";
var OrgSettings_EnableMobileBiometricAuth_Desc = "Active l’authentification biom\xe9trique dans l’application mobile. Personnalisez le d\xe9lai d’expiration de l’authentification biom\xe9trique en modifiant le param\xe8tre D\xe9lai d’expiration du jeton d’actualisation OAuth pour mobile.";
var OrgSettings_EnableMobileBiometricAuth_Name = "Authentification biom\xe9trique pour les appareils mobiles";
var OrgSettings_EnableNewReportingFTPConnection_Desc = "Activer une nouvelle m\xe9thode de transmission des rapports \xe0 un FTP client.";
var OrgSettings_EnableOptionalEvaluationEndorsement_Desc = "Lorsque cette option est coch\xe9e, l’\xe9tape d’approbation de la revue de comp\xe9tence devient facultative.";
var OrgSettings_EnableOptionalEvaluationEndorsement_Name = "Activer la validation par des pairs (facultative) dans le cadre d’une revue de comp\xe9tence";
var OrgSettings_EnableOrgInsightsSkillsTab_Desc = "FOR INTERNAL USE ONLY - Enable Skill Insights tab in Org Insights (Deprecated)";
var OrgSettings_EnableOrgInsightsSkillsTab_Name = "FOR INTERNAL USE ONLY - Enable Skill Insights tab in Org Insights";
var OrgSettings_EnablePathwayBadgeTrigger_Desc = "Active l’option de d\xe9clenchement d’insigne de parcours dans les param\xe8tres du parcours pour les utilisateurs disposant de l’autorisation G\xe9rer les parcours.";
var OrgSettings_EnablePathwayBadgeTrigger_Name = "Activer le d\xe9clenchement d’insigne de parcours";
var OrgSettings_EnablePeerRatings_Desc = "Permet aux utilisateurs de demander des \xe9valuations de comp\xe9tences par leurs pairs.";
var OrgSettings_EnablePeerRatings_Name = "\xc9valuations par les pairs";
var OrgSettings_EnablePluralsightSkillsIntegration_Desc = "Permet \xe0 l’utilisateur de voir les comp\xe9tences Pluralsight. Ces comp\xe9tences sont extraites via le collecteur de comp\xe9tences Pluralsight.";
var OrgSettings_EnablePluralsightSkillsIntegration_Name = "Activer l’int\xe9gration Pluralsight Skills";
var OrgSettings_EnablePreferredContentLanguagesFilter_Desc = "Restreindre les r\xe9sultats de recherche et les recommandations de la page d’accueil aux contenus dans les langues pr\xe9f\xe9r\xe9es de l’utilisateur pour le contenu.";
var OrgSettings_EnablePreferredContentLanguagesFilter_Name = "Activer le filtre relatif aux langues pr\xe9f\xe9r\xe9es pour le contenu";
var OrgSettings_EnablePrimaryPlanOnDashboard_Desc = "Si cette option est activ\xe9e, la barre lat\xe9rale affichant les comp\xe9tences et les plans sur la page d’accueil (\xab\xa0tableau de bord\xa0\xbb) sera remplac\xe9e par un composant de plan principal en haut, comprenant les comp\xe9tences associ\xe9es au plan principal de l’apprenant.";
var OrgSettings_EnablePrimaryPlanOnDashboard_Name = "Activer l’affichage du plan principal sur la page d’accueil";
var OrgSettings_EnableProvidersInUI_Desc = "Ajoute un onglet permettant aux organisations de mettre en avant des fournisseurs de catalogues publics.";
var OrgSettings_EnableProvidersInUI_Name = "Fournisseurs dans l’IU";
var OrgSettings_EnableSkillCoachOptInSettingForAll_Desc = "Si cette option est activ\xe9e, tous les utilisateurs de cette organisation verront l’option d’inscription \xe0 Skill Coach (ou de d\xe9sinscription) dans les param\xe8tres de leur profil.";
var OrgSettings_EnableSkillCoachOptInSettingForAll_Name = "Activer le param\xe8tre d’inscription \xe0 Skill Coach pour tous les utilisateurs";
var OrgSettings_EnableSkillInsightsDashboard_Desc = "La version + de l’onglet Statistiques de comp\xe9tences s’applique UNIQUEMENT aux clients disposant de l’option de revue de comp\xe9tence. Lorsque cette fonctionnalit\xe9 est activ\xe9e, l’onglet Statistiques de comp\xe9tences comprend des modules suppl\xe9mentaires qui ne sont pas disponibles pour les clients ne disposant pas de l’option de revue de comp\xe9tence.";
var OrgSettings_EnableSkillInsightsDashboard_Name = "Activer la version + des statistiques de comp\xe9tences (seulement pour les clients disposant de l’option de revue de comp\xe9tence)";
var OrgSettings_EnableSkillsCertification_Desc = "Activer la certification de comp\xe9tence pour toutes les comp\xe9tences prises en charge. Cette option n’est normalement pas activ\xe9e, car les organisations ach\xe8tent plut\xf4t des comp\xe9tences sp\xe9cifiques.";
var OrgSettings_EnableSkillsCertification_Name = "Certification de comp\xe9tence pour toutes les comp\xe9tences prises en charge";
var OrgSettings_EnableSkillsEvaluation_Desc = "La revue de comp\xe9tence est un processus simplifi\xe9 permettant de r\xe9aliser la premi\xe8re \xe9tape de la certification de comp\xe9tence et de fournir \xe0 l’utilisateur un niveau de comp\xe9tence initial. Lorsque cette option est activ\xe9e, les utilisateurs peuvent lancer une revue de comp\xe9tence \xe0 partir de la fen\xeatre modale d’\xe9valuation de comp\xe9tence (pour les comp\xe9tences prises en charge). ";
var OrgSettings_EnableSkillsEvaluation_Name = "Revue de comp\xe9tence";
var OrgSettings_EnableSkillsPlatform_Desc = "Mise en garde\xa0: cette option est en cours de d\xe9veloppement et ne devrait pas \xeatre ajout\xe9e \xe0 un environnement sans autorisation";
var OrgSettings_EnableSkillsPlatform_Name = "Activer la plateforme de comp\xe9tences";
var OrgSettings_EnableSkillStandards_Desc = "Enable Skill Standards for the organization. Default is false.";
var OrgSettings_EnableSkillStandards_Name = "Enable Skill Standards";
var OrgSettings_EnableTeamSpace_Desc = "Active la fonctionnalit\xe9 Skill\xa0Coach pour l’organisation.";
var OrgSettings_EnableTeamSpace_Name = "Activer Skill Coach";
var OrgSettings_EnableUserSearchFilterByJobRole_Desc = "Pour les recherches d’utilisateurs, affiche le filtre qui permet de regrouper les postes.";
var OrgSettings_EnableUserSearchFilterByJobRole_Name = "Activer le filtre de recherche d’utilisateurs par poste";
var OrgSettings_EnableUserSearchFilterByLocation_Desc = "Pour les recherches d’utilisateurs, affiche le filtre qui permet de regrouper les lieux.";
var OrgSettings_EnableUserSearchFilterByLocation_Name = "Activer le filtre de recherche d’utilisateurs par lieu";
var OrgSettings_EnforceDataPrivacyAcceptance_Desc = "Exigez que les utilisateurs acceptent ce message avant de pouvoir utiliser Degreed. Les apprenants qui n’acceptent pas le message ne seront pas autoris\xe9s \xe0 acc\xe9der \xe0 Degreed.";
var OrgSettings_EnforceDataPrivacyAcceptance_Name = "Imposer l’acceptation de la confidentialit\xe9 des donn\xe9es";
var OrgSettings_EnforceDataPrivacyAcceptanceBody_PlaceHolder = "Add an enforce data privacy acceptance message";
var OrgSettings_EnforceDataPrivacyAcceptanceBody_PopupLabel = "Enforce Data Privacy Acceptance Body";
var OrgSettings_EnforceDataPrivacyAcceptanceConfirmation_Default = "I confirm that I have read and understand the Terms and Conditions";
var OrgSettings_EnforceDataPrivacyAcceptanceConfirmation_PlaceHolder = "Add a custom confirmation text";
var OrgSettings_EnforceDataPrivacyAcceptanceConfirmation_PopupLabel = "Enforce Data Privacy Acceptance Confirmation";
var OrgSettings_EnforceDataPrivacyAcceptanceHeader_Default = "Degreed Terms and Conditions";
var OrgSettings_EnforceDataPrivacyAcceptanceHeader_PlaceHolder = "Add a custom header";
var OrgSettings_EnforceDataPrivacyAcceptanceHeader_PopupLabel = "Enforce Data Privacy Acceptance Header";
var OrgSettings_EnforceDataPrivacyAcceptanceTitle_Default = "Please review and accept the following Terms and Conditions to use Degreed";
var OrgSettings_EnforceDataPrivacyAcceptanceTitle_PlaceHolder = "Add a custom title";
var OrgSettings_EnforceDataPrivacyAcceptanceTitle_PopupLabel = "Enforce Data Privacy Acceptance Title";
var OrgSettings_EnforceDegreedDataPrivacyAcceptance_Desc = "Exiger que les utilisateurs acceptent la Politique de confidentialit\xe9 de Degreed avant de pouvoir utiliser le programme. Les utilisateurs qui n’acceptent pas ce message ne pourront pas acc\xe9der \xe0 Degreed.";
var OrgSettings_EnforceDegreedDataPrivacyAcceptance_Name = "Imposer l’acceptation de la politique de confidentialit\xe9 des donn\xe9es de Degreed";
var OrgSettings_EngagementFeatures = "Fonctionnalit\xe9s d’engagement";
var OrgSettings_ErrorMessage = "Message d’erreur";
var OrgSettings_EstimatedDurationDefaults_Desc = "Il s’agit des valeurs de dur\xe9e par d\xe9faut attribu\xe9es \xe0 chaque type d’entr\xe9e et utilis\xe9es dans les rapports lorsque la dur\xe9e d’une entr\xe9e n’est pas sp\xe9cifi\xe9e. Ces valeurs sont enregistr\xe9es au format ISO\xa08601 (par exemple\xa0: \xab\xa0PT2H5M\xa0\xbb).";
var OrgSettings_EstimatedDurationDefaults_Name = "Valeurs de dur\xe9e estim\xe9e par d\xe9faut";
var OrgSettings_ExternalLink = "Lien externe";
var OrgSettings_ExternalLinkPlaceholder = "Ajouter un lien externe";
var OrgSettings_ExternalLinkRequired = "Un lien externe doit \xeatre renseign\xe9.";
var OrgSettings_FileDetails = "D\xe9tails du fichier";
var OrgSettings_FileInformation = "Informations sur le fichier";
var OrgSettings_FileName_Desc = "Pr\xe9cisez un nom avec un param\xe8tre de d\xe9nomination. Par exemple\xa0: \xab\xa0nomfichier{0}.csv\xa0\xbb.";
var OrgSettings_FileName_Name = "Nom du fichier";
var OrgSettings_FtpNotificationEmail_Desc = "Active les notifications par e-mail pour les fichiers entrants FTP. Ajoutez un e-mail par ligne. Tous les e-mails sont envoy\xe9s \xe0 tous les destinataires.";
var OrgSettings_FtpNotificationEmail_Name = "E-mails entrants FTP";
var OrgSettings_FtpStatusFileOptions_Desc = "G\xe9n\xe9rer un rapport pour chaque fichier\xa0FTP entrant avec des informations d\xe9taill\xe9es sur chaque ligne.";
var OrgSettings_FtpStatusFileOptions_Name = "Rapport d\xe9taill\xe9 sur les lignes de fichier\xa0FTP entrant";
var OrgSettings_FtpStatusFileOptions_Selection_AllRows = "Toutes les lignes";
var OrgSettings_FtpStatusFileOptions_Selection_Disabled = "D\xe9sactiv\xe9";
var OrgSettings_FtpStatusFileOptions_Selection_OnlyProblems = "Probl\xe8mes seulement";
var OrgSettings_GoalProgressEmail_Desc = "Invite les utilisateurs \xe0 suivre les parcours.";
var OrgSettings_GoalProgressEmail_Name = "E-mail d’accueil - Jour 10\xa0: Quel est votre objectif\xa0?";
var OrgSettings_GroupPostAdded_Desc = "Avertit les apprenants lorsqu’il y a une nouvelle publication dans l’un de leurs groupes.";
var OrgSettings_GroupPostAdded_Name = "Nouvelle publication dans le groupe";
var OrgSettings_Groups_Desc = "Lorsqu’un fichier des utilisateurs est t\xe9l\xe9charg\xe9, l’option Ajouter l’annexera au fichier existant, tandis que l’option Remplacer l’\xe9crasera ou le remplacera.";
var OrgSettings_Groups_Name = "Groupes";
var OrgSettings_Hide_Overview_Achievement_Desc = "Masque la section R\xe9ussites de la vue d’ensemble du profil pour tous les utilisateurs de l’organisation. Cette section ne sera plus visible lorsque les utilisateurs consulteront leur propre profil ou celui d’autres personnes.";
var OrgSettings_Hide_Overview_Experience_Desc = "Masque la section Exp\xe9rience de la vue d’ensemble du profil dans tous les profils de l’organisation. La section Exp\xe9rience de la vue d’ensemble du profil ne sera plus visible lorsque les utilisateurs consultent leur propre profil ou le profil d’autres personnes.";
var OrgSettings_Hide_Overview_Tab_Desc = "Masque l’onglet de la vue d’ensemble du profil pour tous les utilisateurs de l’organisation. L’onglet de la vue d’ensemble du profil ne sera plus visible lorsque les utilisateurs consultent leur propre profil ou le profil d’autres personnes.";
var OrgSettings_HideExternalCatalog_Desc = "Masque l’option de s\xe9lection du catalogue externe pour tous les utilisateurs de l’organisation. Utilis\xe9 pour les clients partenaires comme HBP, mais non recommand\xe9 pour les autres clients.";
var OrgSettings_HideExternalCatalog_Name = "Masquer le catalogue externe";
var OrgSettings_HideOverviewAchievement_Desc = "Masque la section R\xe9ussites de la vue d’ensemble du profil pour tous les utilisateurs de l’organisation. Cette section ne sera plus visible lorsque les utilisateurs consulteront leur propre profil ou celui d’autres personnes. Cela ne s’applique pas aux profils publics consult\xe9s par des utilisateurs anonymes.";
var OrgSettings_HideOverviewAchievement_Name = "Masquer les r\xe9ussites de la vue d’ensemble";
var OrgSettings_HideOverviewExperience_Desc = "Masque la section Exp\xe9rience de la vue d’ensemble du profil pour tous les profils de l’organisation. Cette section ne sera plus visible lorsque les utilisateurs consulteront leur propre profil ou celui d’autres personnes. Cela ne s’applique pas aux profils publics consult\xe9s par des utilisateurs anonymes.";
var OrgSettings_HideOverviewExperience_Name = "Masquer l’exp\xe9rience de la vue d’ensemble";
var OrgSettings_HideOverviewTab_Desc = "Masque l’onglet Vue d’ensemble du profil pour tous les utilisateurs de l’organisation. Cet onglet ne sera plus visible lorsque les utilisateurs consulteront leur propre profil ou celui d’autres personnes. Cela ne s’applique pas aux profils publics consult\xe9s par des utilisateurs anonymes.";
var OrgSettings_HideOverviewTab_Name = "Masquer l’onglet de la vue d’ensemble";
var OrgSettings_HidePersonalEmailInUserProfileSettings_Desc = "Masque le champ d’adresse e-mail personnelle dans les param\xe8tres du profil de l’utilisateur pour que ce dernier ne puisse pas ajouter d’adresse e-mail personnelle.";
var OrgSettings_HidePersonalEmailInUserProfileSettings_Name = "Masquer l’adresse e-mail personnelle dans les param\xe8tres du profil";
var OrgSettings_HidePersonalIntegrationsInUserProfileSettings_Desc = "Masque l’onglet d’int\xe9grations personnelles dans les param\xe8tres du profil de l’utilisateur pour que ce dernier ne puisse pas configurer ses propres int\xe9grations.";
var OrgSettings_HidePersonalIntegrationsInUserProfileSettings_Name = "Masquer l’onglet d’int\xe9grations personnelles dans les param\xe8tres du profil";
var OrgSettings_HideSocialLinks_Desc = "D\xe9sactive les int\xe9grations Google et Slack.";
var OrgSettings_HideSocialLinks_Name = "D\xe9sactiver le partage social";
var OrgSettings_HideUserEmail_Desc = "Masque les adresses e-mail de l’utilisateur sur la carte d’utilisateur dans Degreed.";
var OrgSettings_HideUserEmail_Name = "D\xe9sactiver l’affichage des adresses e-mail de l’utilisateur";
var OrgSettings_Home_PublishModal_AssignedLearning = "Formations assign\xe9es";
var OrgSettings_Home_PublishModal_Body = "Vous \xeates sur le point de publier les cartes suivantes sur la page d’accueil de votre organisation\xa0:";
var OrgSettings_Home_PublishModal_Body_PublishNew = "Vous \xeates sur le point de {{startBold}}publier{{endBold}} les cartes suivantes sur la page d’accueil de votre organisation\xa0:";
var OrgSettings_Home_PublishModal_Body_PublishOld = "Les cartes suivantes resteront {{startBold}}publi\xe9es{{endBold}} sans modification\xa0:";
var OrgSettings_Home_PublishModal_Body_Unpublish = "Vous \xeates sur le point de {{startBold}}supprimer{{endBold}} les cartes suivantes de la page d’accueil de votre organisation\xa0:";
var OrgSettings_Home_PublishModal_Body_Unpublish_Sub = "Les cartes suivantes seront {{startBold}}supprim\xe9es{{endBold}} de la page d’accueil\xa0:";
var OrgSettings_Home_PublishModal_Confirm = "Voulez-vous continuer\xa0?";
var OrgSettings_Home_PublishModal_Link_PluralLinks = "Lien ({{ linkCount }}\xa0liens)";
var OrgSettings_Home_PublishModal_Link_PluralLinksPluralSegments = "Lien ({{ linkCount }}\xa0liens et {{ segmentCount }}\xa0segments)";
var OrgSettings_Home_PublishModal_Link_PluralLinksSingleSegment = "Lien ({{ linkCount }}\xa0liens et {{ segmentCount }}\xa0segment)";
var OrgSettings_Home_PublishModal_Link_SingleLink = "Lien ({{ linkCount }}\xa0lien)";
var OrgSettings_Home_PublishModal_Link_SingleLinkPluralSegments = "Lien ({{ linkCount }}\xa0lien et {{ segmentCount }}\xa0segments)";
var OrgSettings_Home_PublishModal_Link_SingleLinkSingleSegment = "Lien ({{ linkCount }}\xa0lien et {{ segmentCount }}\xa0segment)";
var OrgSettings_HomeDescription = "Configurez la page d’accueil des apprenants en fonction des besoins de votre organisation.";
var OrgSettings_HomeInsightCards = "Cartes de statistiques";
var OrgSettings_HomeLinksSection = "Section des liens";
var OrgSettings_HomeOrgAnnouncement = "Annonce de l’organisation";
var OrgSettings_HomePageTile = "Accueil";
var OrgSettings_HomeSectionsReorderSuccess = "Les sections de la page d’accueil ont bien \xe9t\xe9 r\xe9organis\xe9es.";
var OrgSettings_InApp_GroupDesc = "Des messages int\xe9gr\xe9s s’affichent en haut du flux de l’apprenant.";
var OrgSettings_InApp_GroupDisplayName = "Messages int\xe9gr\xe9s";
var OrgSettings_InAppTips_Desc = "Conseils et visites int\xe9gr\xe9s qui expliquent aux apprenants les fonctionnalit\xe9s principales.";
var OrgSettings_InAppTips_Name = "Conseils int\xe9gr\xe9s";
var OrgSettings_InsightCardsMaximum = "{{numberOfCards}}\xa0carte(s) maximum";
var OrgSettings_InsightCardsPublishUpdateSuccess = "La publication de la carte de statistiques a bien \xe9t\xe9 mise \xe0 jour.";
var OrgSettings_InsightCardsReorderSuccess = "Les cartes de statistiques ont \xe9t\xe9 r\xe9organis\xe9es.";
var OrgSettings_InsightCardsSaveSingleSuccess = "La carte de statistiques a bien \xe9t\xe9 enregistr\xe9e.";
var OrgSettings_InsightCardsSaveSuccess = "Les cartes de statistiques ont bien \xe9t\xe9 enregistr\xe9es.";
var OrgSettings_InsightCardsUnpublishSingleSuccess = "La publication de la carte de statistiques a bien \xe9t\xe9 annul\xe9e.";
var OrgSettings_InsightCardsUnpublishSuccess = "La publication des cartes de statistiques a bien \xe9t\xe9 annul\xe9e.";
var OrgSettings_IntegrationEmailSettings_Desc = "Active toutes les notifications par e-mail pour les \xe9checs d’int\xe9gration de fournisseur. Ajoutez un e-mail par ligne.";
var OrgSettings_IntegrationEmailSettings_Name = "E-mails d’\xe9chec d’int\xe9gration de fournisseur";
var OrgSettings_InternalLink = "Lien interne";
var OrgSettings_IsClientProvider_Desc = "Il s’agit d’un param\xe8tre sp\xe9cifique \xe0 HBP qui permet de masquer plusieurs fonctionnalit\xe9s, y compris les suivantes\xa0: l’ajout global, l’ajout rapide (tableau de bord), l’onglet FAQ de l’organisation, le clonage des parcours, les publications de groupe, l’onglet Int\xe9grations dans le profil, les liens vers le bouton Degreed sur la page Collection vide, les fournisseurs \xe0 la une dans Parcourir (en attente de mise en œuvre), le contenu \xe0 la une dans Parcourir (en attente de mise en œuvre) et l’affichage du nouveau contenu dans Parcourir (en attente de mise en œuvre).";
var OrgSettings_IsClientProvider_Name = "Client fournisseur";
var OrgSettings_IsDefaultCatalog_Desc = "D\xe9finir le fichier interne en tant que fichier par d\xe9faut pour les utilisateurs dans la recherche et la navigation.";
var OrgSettings_IsDefaultCatalog_Name = "D\xe9finir le fichier interne par d\xe9faut";
var OrgSettings_KeepManagerGroupsInSync_Desc = "Cette fonctionnalit\xe9 permet d’actualiser les relations avec les managers lorsqu’un fichier utilisateur est charg\xe9. Si l’option Groupes de managers est activ\xe9e, l’appartenance au groupe est \xe9galement mise \xe0 jour en cons\xe9quence.";
var OrgSettings_KeepManagerGroupsInSync_Name = "Synchroniser les relations avec les managers";
var OrgSettings_LearningFeeds = "Flux d’apprentissage";
var OrgSettings_LimitGroupFeedActions_Desc = "Les \xe9l\xe9ments du flux de groupe seront limit\xe9s aux publications de groupe, aux recommandations et aux formations assign\xe9es.";
var OrgSettings_LimitGroupFeedActions_Name = "Limiter les \xe9l\xe9ments du flux de groupe";
var OrgSettings_LinkButtonPlaceholder = "P. ex. \xab\xa0Acc\xe9der \xe0 la page\xa0\xbb\xa0; \xab\xa0Afficher plus\xa0\xbb…";
var OrgSettings_LinkButtonTitle = "Intitul\xe9 du bouton";
var OrgSettings_LinkDescription = "Description du lien";
var OrgSettings_LinkDescriptionPlaceholder = "Ajouter une courte description de votre lien";
var OrgSettings_LinkDescriptionRequired = "La description du lien doit \xeatre renseign\xe9e.";
var OrgSettings_LinkInternalUrlPlaceholder = "Recherchez un plan, un parcours ou un \xe9l\xe9ment de contenu";
var OrgSettings_LinkInternalUrlRequired = "Un lien interne doit \xeatre renseign\xe9.";
var OrgSettings_LinkPlaceholder = "Ajouter l’intitul\xe9 du lien";
var OrgSettings_LinkSaveSuccess = "Le lien a bien \xe9t\xe9 enregistr\xe9.";
var OrgSettings_LinkSegmentRequired = "Le segment doit \xeatre renseign\xe9.";
var OrgSettings_LinkSegments = "Segments";
var OrgSettings_LinkSegmentsDescription = "Les segments Degreed permettent \xe0 votre organisation de cibler le bon public pour ce lien.";
var OrgSettings_LinkSegmentsTooltip = "Rechercher les segments de {{orgName}}";
var OrgSettings_LinkSelectSource = "S\xe9lectionnez la source du lien.";
var OrgSettings_LinkTitle = "Intitul\xe9 du lien";
var OrgSettings_LinkTitleDuplicateError = "Cet intitul\xe9 de lien est d\xe9j\xe0 utilis\xe9 dans cette carte. Veuillez en saisir un autre.";
var OrgSettings_LinkTitleRequired = "L’intitul\xe9 du lien doit \xeatre renseign\xe9.";
var OrgSettings_LinkUseSegments = "Utiliser les segments";
var OrgSettings_LockProfilePrivacy_Desc = "Active la confidentialit\xe9 du profil.";
var OrgSettings_LockProfilePrivacy_Name = "Activer la confidentialit\xe9 du profil";
var OrgSettings_LockSkillManagerRatingVisibility_Desc = "Veille \xe0 ce que toutes les futures \xe9valuations des managers soient priv\xe9es (visibilit\xe9 limit\xe9e si cette option est activ\xe9e dans Skill\xa0Coach) et que les utilisateurs ne puissent pas modifier la visibilit\xe9.";
var OrgSettings_LockSkillManagerRatingVisibility_Name = "D\xe9finir les \xe9valuations de comp\xe9tences par les managers comme priv\xe9es";
var OrgSettings_LockSkillPeerRatingVisibility_Desc = "Veille \xe0 ce que toutes les futures \xe9valuations des pairs soient priv\xe9es (visibilit\xe9 limit\xe9e si cette option est activ\xe9e dans Skill\xa0Coach) et que les utilisateurs ne puissent pas modifier la visibilit\xe9.";
var OrgSettings_LockSkillPeerRatingVisibility_Name = "D\xe9finir les \xe9valuations de comp\xe9tences par les pairs comme priv\xe9es";
var OrgSettings_LockSkillSelfRatingVisibility_Desc = "Veille \xe0 ce que toutes les futures auto-\xe9valuations soient priv\xe9es (visibilit\xe9 limit\xe9e si cette option est activ\xe9e dans Skill\xa0Coach) et que les utilisateurs ne puissent pas modifier la visibilit\xe9.";
var OrgSettings_LockSkillSelfRatingVisibility_Name = "D\xe9finir les auto-\xe9valuations de comp\xe9tences comme priv\xe9es";
var OrgSettings_LU_AdminUserId_Desc = "L’identifiant num\xe9rique unique d’un administrateur LearnUpon, qui re\xe7oit l’e-mail r\xe9capitulatif.";
var OrgSettings_LU_AdminUserId_Name = "Identifiant d’administrateur LearnUpon";
var OrgSettings_LU_ApiBaseUrl_DefaultText = "https://yourdomain.learnupon.com/api/v1/";
var OrgSettings_LU_ApiBaseUrl_Desc = "L’URL de l’API LearnUpon de base utilis\xe9e pour charger des fichiers\xa0CSV via des requ\xeates\xa0POST.";
var OrgSettings_LU_ApiBaseUrl_Name = "URL de l’API";
var OrgSettings_LU_ApiPassword_Desc = "Mot de passe API pour LearnUpon";
var OrgSettings_LU_ApiPassword_Name = "Mot de passe API";
var OrgSettings_LU_ApiUsername_Desc = "Nom d’utilisateur API pour LearnUpon";
var OrgSettings_LU_ApiUsername_Name = "Nom d’utilisateur API";
var OrgSettings_LU_BulkGroupSync_Desc = "La valeur \xab\xa0true\xa0\xbb (vrai) indique que vous souhaitez une synchronisation compl\xe8te des groupes. La valeur par d\xe9faut est \xab\xa0false\xa0\xbb (faux).";
var OrgSettings_LU_BulkGroupSync_Name = "Synchronisation en bloc des groupes";
var OrgSettings_LU_BulkInviteUsers_Desc = "La valeur \xab\xa0true\xa0\xbb (vrai) indique que vous invitez des utilisateurs, et non que vous en cr\xe9ez. La valeur par d\xe9faut est \xab\xa0false\xa0\xbb (faux), pour cr\xe9er des utilisateurs.";
var OrgSettings_LU_BulkInviteUsers_Name = "Inviter des utilisateurs en bloc";
var OrgSettings_LU_BulkProcessUnenrollments_Desc = "Si la valeur est d\xe9finie sur \xab\xa0true\xa0\xbb (vrai), l’attribut d\xe9sinscrit les utilisateurs des cours et des parcours lorsque vous les supprimez des groupes. La valeur par d\xe9faut est \xab\xa0false\xa0\xbb (faux). La synchronisation des groupes doit \xeatre d\xe9finie sur \xab\xa0true\xa0\xbb.";
var OrgSettings_LU_BulkProcessUnenrollments_Name = "D\xe9sinscription en bloc";
var OrgSettings_LU_BulkUpdateUsers_Desc = "Indique si les utilisateurs existants devraient \xeatre mis \xe0 jour en plus de cr\xe9er/d’inviter de nouveaux utilisateurs.";
var OrgSettings_LU_BulkUpdateUsers_Name = "Actualiser les utilisateurs par lots";
var OrgSettings_LU_CustomDataColumns_Desc = "Liste des attributs de donn\xe9es utilisateur personnalis\xe9s configur\xe9s dans LearnUpon.";
var OrgSettings_LU_CustomDataColumns_Name = "Attributs utilisateur personnalis\xe9s";
var OrgSettings_LU_DefaultEnabled_Desc = "Indique si les utilisateurs devraient \xeatre activ\xe9s.";
var OrgSettings_LU_DefaultEnabled_Name = "Valeur par d\xe9faut d’activation d’utilisateur";
var OrgSettings_LU_DefaultExpires_Desc = "Indique la date d’expiration \xe0 utiliser par d\xe9faut. Le format doit \xeatre le suivant\xa0: mm/jj/aaaa";
var OrgSettings_LU_DefaultExpires_Name = "Valeur par d\xe9faut d’expiration d’utilisateur";
var OrgSettings_LU_DefaultGroupSync_Desc = "Indique la valeur \xe0 utiliser pour la colonne group_sync";
var OrgSettings_LU_DefaultGroupSync_Name = "Valeur par d\xe9faut pour le groupe d’utilisateurs";
var OrgSettings_LU_DefaultMustChangePassword_Desc = "Indique si les utilisateurs doivent changer le mot de passe apr\xe8s leur premi\xe8re connexion.";
var OrgSettings_LU_DefaultMustChangePassword_Name = "Valeur doitchangerlemotdepasse par d\xe9faut pour l’utilisateur";
var OrgSettings_LU_DefaultPassword_Desc = "Indique le mot de passe par d\xe9faut \xe0 attribuer \xe0 l’utilisateur";
var OrgSettings_LU_DefaultPassword_Name = "Valeur par d\xe9faut pour le mot de passe utilisateur";
var OrgSettings_LU_GroupSync_Name = "Synchronisation des groupes par d\xe9faut";
var OrgSettings_MarketplaceWarning_Default = "Vous allez maintenant acc\xe9der \xe0 la marketplace Degreed. Celle-ci contient du contenu payant propos\xe9 par des fournisseurs de contenus externes.";
var OrgSettings_MarketplaceWarning_Desc = "Ce message appara\xeet lorsque les apprenants choisissent d’afficher la Marketplace Degreed.";
var OrgSettings_MarketplaceWarning_Name = "Avertissement de la Marketplace";
var OrgSettings_MaxDescription = "Cette description doit \xeatre aussi courte que possible ({{max}}\xa0caract\xe8res max.).";
var OrgSettings_MaxInputDescription = "Make this {{input}} as short as possible ({{char}} characters max.)";
var OrgSettings_MaxTitleDescription = "Cet intitul\xe9 doit \xeatre aussi court que possible ({{max}}\xa0caract\xe8res max.).";
var OrgSettings_MentionInComment_Desc = "Avertit les apprenants lorsqu’ils ont \xe9t\xe9 mentionn\xe9s dans un avis.";
var OrgSettings_MentionInComment_Name = "@Mention";
var OrgSettings_MinimumAggregatedLearningInsightsUserCount_Desc = "Sp\xe9cifie le nombre minimum d’utilisateurs requis pour que les statistiques d’apprentissage agr\xe9g\xe9es s’affichent.";
var OrgSettings_MinimumAggregatedLearningInsightsUserCount_Name = "Nombre minimum d’utilisateurs pour les statistiques d’apprentissage agr\xe9g\xe9es";
var OrgSettings_MinimumSkillUserCount_Desc = "Sp\xe9cifie le nombre minimum d’utilisateurs requis pour que les donn\xe9es de comp\xe9tences agr\xe9g\xe9es s’affichent.";
var OrgSettings_MinimumSkillUserCount_Name = "Nombre minimum d’utilisateurs pour les comp\xe9tences";
var OrgSettings_MobileBiometricAuth_Desc = "Active l’authentification biom\xe9trique dans l’application mobile. Personnalisez le d\xe9lai d’expiration de l’authentification biom\xe9trique en modifiant le param\xe8tre D\xe9lai d’expiration du jeton d’actualisation OAuth pour mobile.";
var OrgSettings_MobileBiometricAuth_Name = "Authentification biom\xe9trique pour les appareils mobiles";
var OrgSettings_MobileClientSessionTimeout_Desc = "Permettre la connexion biom\xe9trique sur l’application mobile. Cela fonctionnera mieux avec un OAuthSessionTimeout plus long et raccourcira ce d\xe9lai d’expiration de session pour d\xe9clencher une connexion biom\xe9trique afin d’actualiser la session. R\xe9sultat\xa0: une session s\xe9curis\xe9e et plus longue pour l’utilisateur final.";
var OrgSettings_MobileClientSessionTimeout_Name = "D\xe9lai d’expiration de session biom\xe9trique pour application mobile";
var OrgSettings_MonthlyActivity_Error = "Un indicateur de formation est requis pour cette carte. S\xe9lectionnez-en un dans le menu d\xe9roulant.";
var OrgSettings_MonthlyActivityDescription = "L’activit\xe9 mensuelle aide les apprenants \xe0 suivre leurs efforts de formation mensuels dans Degreed.";
var OrgSettings_MonthlyActivityTypes_ItemsCompleted = "\xc9l\xe9ments termin\xe9s";
var OrgSettings_MonthlyActivityTypes_ItemsViewed = "\xc9l\xe9ments consult\xe9s";
var OrgSettings_MonthlyActivityTypes_LearningDuration = "Dur\xe9e de formation";
var OrgSettings_MonthlyActivityTypes_PointsEarned = "Points gagn\xe9s";
var OrgSettings_MonthlyActivityWithType = "Activit\xe9 mensuelle ({{ type }})";
var OrgSettings_NewLink = "Nouveau lien";
var OrgSettings_NotificationEmails_GroupDesc = "Envoie un e-mail aux apprenants pour chaque \xe9v\xe8nement suivant d\xe8s qu’il se produit.";
var OrgSettings_NotificationEmails_GroupDisplayName = "E-mails de notification";
var OrgSettings_NotRecommended = "Non recommand\xe9";
var OrgSettings_OAuthRefreshTokenTimeout_Desc = "Contr\xf4le le d\xe9lai d’expiration du jeton d’actualisation OAuth. La valeur par d\xe9faut est de 60\xa0jours. Vous pouvez la remplacer en saisissant un d\xe9lai personnalis\xe9 (en minutes). Ce d\xe9lai s’applique uniquement \xe0 l’API et \xe0 l’application mobile. La valeur doit \xeatre sup\xe9rieure au d\xe9lai d’expiration du jeton d’acc\xe8s OAuth pour l’API et l’application mobile afin d’offrir aux utilisateurs un d\xe9lai suppl\xe9mentaire pour pouvoir actualiser leur session sans devoir s’authentifier \xe0 nouveau apr\xe8s l’expiration du jeton d’acc\xe8s.";
var OrgSettings_OAuthRefreshTokenTimeout_Name = "D\xe9lai d’expiration du jeton d’actualisation OAuth pour l’API et l’application mobile";
var OrgSettings_OAuthSessionTimeout_Desc = "Contr\xf4le le d\xe9lai d’expiration du jeton d’acc\xe8s OAuth. La valeur par d\xe9faut est de 5\xa0minutes. Vous pouvez la remplacer en saisissant un d\xe9lai personnalis\xe9 (en minutes). Ce d\xe9lai s’applique uniquement \xe0 l’API et \xe0 l’application mobile. La valeur doit \xeatre bien inf\xe9rieure au d\xe9lai d’expiration du jeton d’actualisation OAuth pour l’API et l’application mobile afin d’obliger le client \xe0 se r\xe9authentifier r\xe9guli\xe8rement \xe0 l’aide du jeton d’actualisation. Il est essentiel que cette valeur soit inf\xe9rieure au d\xe9lai d’expiration du jeton d’actualisation pour permettre \xe0 ce dernier de fonctionner correctement (le d\xe9lai sugg\xe9r\xe9 est de 5 \xe0 10\xa0minutes).";
var OrgSettings_OAuthSessionTimeout_Name = "D\xe9lai d’expiration du jeton d’acc\xe8s OAuth pour l’API et l’application mobile";
var OrgSettings_Onboarding_GroupDesc = "E-mails envoy\xe9s aux nouveaux apprenants pour les aider \xe0 bien d\xe9buter avec Degreed.";
var OrgSettings_Onboarding_GroupDisplayName = "E-mails d’int\xe9gration";
var OrgSettings_OnboardingExperience = "Onboarding Experience";
var OrgSettings_OnboardingExperience_GroupDesc = "Personnaliser la premi\xe8re page de la visite d’int\xe9gration.";
var OrgSettings_OnboardingExperience_GroupDisplayName = "Messages d’int\xe9gration";
var OrgSettings_OnboardingMessage_Default = "Commencez par importer votre CV pour que le syst\xe8me remplisse automatiquement vos comp\xe9tences et vos postes pr\xe9c\xe9dents.";
var OrgSettings_OnboardingMessage_Desc = "Ce message s’affiche sous le titre de la visite d’int\xe9gration.";
var OrgSettings_OnboardingMessage_Name = "Message d’int\xe9gration";
var OrgSettings_OnboardingRateSkillsIsMandatory_Desc = "N\xe9cessite un nombre minimum de comp\xe9tences \xe0 \xe9valuer lors de l’int\xe9gration.";
var OrgSettings_OnboardingRateSkillsIsMandatory_Name = "L’\xe9valuation des comp\xe9tences est obligatoire lors de la phase d’int\xe9gration.";
var OrgSettings_OnboardingTitle_Default = "Personnalisez votre profil pour acc\xe9der \xe0 des ressources sur mesure adapt\xe9es \xe0 votre poste, \xe0 vos comp\xe9tences et \xe0 vos objectifs.";
var OrgSettings_OnboardingTitle_Desc = "Il s’agit du message principal pour la visite d’int\xe9gration de votre organisation.";
var OrgSettings_OnboardingTitle_Name = "Titre de la visite d’int\xe9gration";
var OrgSettings_OnboardingWelcomeGreeting_Desc = "Afficher \xab\xa0Bienvenue [Pr\xe9nom]\xa0\xbb au-dessus du titre de la visite d’int\xe9gration.";
var OrgSettings_OnboardingWelcomeGreeting_Name = "Message de bienvenue";
var OrgSettings_OpportunitiesActivityStartDate_Desc = "Date (et heure) \xe0 laquelle commencer le calcul et l’affichage des activit\xe9s pour les opportunit\xe9s. Elle doit \xeatre fournie sous la forme d’une cha\xeene au format UTC et a pour valeur par d\xe9faut \xab\xa02021-10-05T00:00:00Z\xa0\xbb (minuit le 5 octobre 2021).";
var OrgSettings_OpportunitiesActivityStartDate_Name = "Date de d\xe9but de l’activit\xe9 des opportunit\xe9s";
var OrgSettings_OrganizationEmailFromName_Desc = "Lorsqu’il est activ\xe9, l’aper\xe7u de l’exp\xe9diteur affiche \xab\xa0Degreed et {org name}\xa0\xbb au lieu de \xab\xa0{org name}\xa0\xbb uniquement.";
var OrgSettings_OrganizationEmailFromName_Name = "Aper\xe7u de l’exp\xe9diteur";
var OrgSettings_OrganizationEmailLogo_Desc = "Conserver une version diff\xe9rente du logo de l’organisation pour l’utiliser dans les e-mails.";
var OrgSettings_OrganizationEmailLogo_Name = "Logo de l’organisation pour les e-mails";
var OrgSettings_OrgIntroEmailMessage_Desc = "Chaque apprenant recevra deux e-mails apr\xe8s la cr\xe9ation de son compte. Le premier e-mail contiendra l’adresse e-mail de connexion et le second contiendra le mot de passe par d\xe9faut. Ces e-mails ne doivent \xeatre activ\xe9s que pour les organisations qui utilisent un nom d’utilisateur et un mot de passe pour se connecter \xe0 Degreed. Pour activer cette fonctionnalit\xe9, saisissez un message personnalis\xe9 pour l’e-mail.";
var OrgSettings_OrgIntroEmailMessage_Name = "Instructions relatives au nom d’utilisateur/mot de passe";
var OrgSettings_OrgSupportInfoCustomLink_Desc = "Ajoutez un lien vers les ressources d’aide de votre organisation.";
var OrgSettings_OrgSupportInfoCustomLink_Name = "Lien personnalis\xe9";
var OrgSettings_OrgSupportInfoCustomLink_Placeholder = "Nom abr\xe9g\xe9 de la ressource";
var OrgSettings_OrgSupportInfoCustomLinkURL_Placeholder = "http://resourceurl.com";
var OrgSettings_OrgSupportInfoEmail_Desc = "Ajoutez une adresse e-mail d’assistance sp\xe9cifique \xe0 votre organisation.";
var OrgSettings_OrgSupportInfoEmail_Label = "Adresse e-mail";
var OrgSettings_OrgSupportInfoEmail_Name = "Adresse e-mail";
var OrgSettings_OrgSupportInfoEmail_Placeholder = "support@your-organization.com";
var OrgSettings_OrgSupportInfoFaq_Desc = "Ajoutez un lien de FAQ personnalis\xe9. Si vous activez ce param\xe8tre sans ajouter de lien de FAQ personnalis\xe9, la FAQ de Degreed sera utilis\xe9e par d\xe9faut.";
var OrgSettings_OrgSupportInfoFaq_Label = "URL des questions fr\xe9quemment pos\xe9es";
var OrgSettings_OrgSupportInfoFaq_Name = "Questions fr\xe9quemment pos\xe9es";
var OrgSettings_OrgSupportInfoFaq_Placeholder = "http://resourceurl.com";
var OrgSettings_OrgSupportInfoLinkText_Label = "Nom du lien";
var OrgSettings_OrgSupportInfoLinkText_Placeholder = "Nom abr\xe9g\xe9 de la ressource";
var OrgSettings_OrgSupportInfoLinkURL_Label = "URL du lien";
var OrgSettings_OrgSupportInfoLinkURL_Placeholder = "http://resourceurl.com";
var OrgSettings_OrgSupportInfoPhone_Desc = "Ajoutez un num\xe9ro de t\xe9l\xe9phone personnalis\xe9. Si vous activez ce param\xe8tre sans ajouter de num\xe9ro de t\xe9l\xe9phone, le num\xe9ro de t\xe9l\xe9phone de l’assistance Degreed sera utilis\xe9 par d\xe9faut.";
var OrgSettings_OrgSupportInfoPhone_Label = "Num\xe9ro de t\xe9l\xe9phone";
var OrgSettings_OrgSupportInfoPhone_Name = "Num\xe9ro de t\xe9l\xe9phone";
var OrgSettings_OrgSupportInfoPhone_Placeholder = "+1\xa0800\xa0311\xa07061";
var OrgSettings_OtherEmails_GroupDesc = "E-mails envoy\xe9s pour stimuler l’engagement des utilisateurs dans Degreed.";
var OrgSettings_OtherEmails_GroupDisplayName = "Autres e-mails";
var OrgSettings_PasswordExpirationPeriod_DefaultText = "Saisir un d\xe9lai d’expiration personnalis\xe9 en jours";
var OrgSettings_PasswordExpirationPeriod_Desc = "Le nombre de jours avant l’expiration d’un mot de passe peut \xeatre personnalis\xe9 ici.";
var OrgSettings_PasswordExpirationPeriod_Name = "D\xe9lai d’expiration du mot de passe";
var OrgSettings_PathwayFeedbackSurvey_Desc = "Displays a checkbox in the pathway modal to users with the Manage Org Pathway permission to let learners rate pathway content.";
var OrgSettings_PathwayFeedbackSurvey_Name = "Pathway Feedback Survey";
var OrgSettings_PermissionRoles_Desc = "Ajouter lors de la cr\xe9ation\xa0: mise \xe0 jour du r\xf4le de l’utilisateur uniquement lors de la cr\xe9ation de son compte. Lorsque l’utilisateur est cr\xe9\xe9, vous pouvez soit utiliser le r\xf4le r\xe9f\xe9renc\xe9 dans le fichier s’il s’y trouve, soit attribuer \xe0 l’utilisateur le r\xf4le par d\xe9faut de membre dans le cas contraire. Mettre \xe0 jour \xe0 chaque fois\xa0: mise \xe0 jour du r\xf4le de l’utilisateur \xe0 chaque fois qu’un fichier est t\xe9l\xe9charg\xe9 s’il y est r\xe9f\xe9renc\xe9. Dans le cas contraire, il n’y aura pas de mise \xe0 jour.";
var OrgSettings_PermissionRoles_Name = "R\xf4les d’autorisation";
var OrgSettings_PersistSessionCookie_Desc = "When user is signing in, this denotes if the session should be persistent.";
var OrgSettings_PersistSessionCookie_Name = "Persist Session Cookie";
var OrgSettings_PointsDecommission_Desc = "Hides points from profile activity, profile learning summary, completion action buttons, and learning insight cards in skill coach.";
var OrgSettings_PointsDecommission_Name = "Points Decommission";
var OrgSettings_PreventPublicProfiles_Desc = "Masque l’option \xab\xa0Public\xa0\xbb du profil de l’utilisateur pour tous les membres de l’organisation (emp\xeache les utilisateurs de rendre leur profil public).";
var OrgSettings_PreventPublicProfiles_Name = "Emp\xeacher les profils publics";
var OrgSettings_PrivacyChangeToOrganizationMessage_Default = "Si vous d\xe9finissez votre profil comme \xe9tant visible dans votre organisation uniquement, les utilisateurs de {{OrgName}} auront acc\xe8s aux informations suivantes sur cette plateforme\xa0:<br/><br/><strong>Votre nom</strong>, <strong>votre collection en mati\xe8re de formations</strong> (membres de {{OrgNameSingular}}) et <strong>vos statistiques</strong> (y compris votre classement).<br/><br/>Les personnes qui ne sont pas membres de {{OrgNameSingular}} ne pourront pas vous suivre (c’est-\xe0-dire \xeatre inform\xe9es de vos activit\xe9s de formation).";
var OrgSettings_PrivacyChangeToOrganizationMessage_Desc = "Message indiquant le niveau confidentialit\xe9 du profil, qui s’affiche lorsque l’utilisateur rend son profil visible au sein de l’organisation.";
var OrgSettings_PrivacyChangeToOrganizationMessage_Name = "Message de profil visible par l’organisation";
var OrgSettings_PrivacyChangeToPrivateMessage_Default = "Si vous d\xe9finissez votre profil comme \xe9tant priv\xe9, les informations suivantes ne seront plus visibles pour le public ni pour les utilisateurs de {{OrgName}} sur cette plateforme\xa0: <br/><br/><strong>Votre nom</strong>, <strong>votre collection en mati\xe8re de formations</strong> (le contenu de {{OrgName}} ne sera plus visible pour les personnes qui ne sont pas membres de {{OrgNameSingular}}) et <strong>vos statistiques</strong> (y compris votre classement).<br/><br/>Les autres personnes ne pourront plus vous suivre (c’est-\xe0-dire \xeatre inform\xe9es de vos activit\xe9s de formation).";
var OrgSettings_PrivacyChangeToPrivateMessage_Desc = "Message indiquant le niveau confidentialit\xe9 du profil, qui s’affiche lorsque l’utilisateur rend son profil priv\xe9.";
var OrgSettings_PrivacyChangeToPrivateMessage_Name = "Message de profil priv\xe9";
var OrgSettings_PrivacyChangeToPublicMessage_Default = "Si vous d\xe9finissez votre profil comme \xe9tant public, les informations suivantes deviendront publiques (externes \xe0 tous les utilisateurs de {{OrgName}} sur cette plateforme)\xa0:<br/><br/><strong>Votre nom</strong>, <strong>votre collection en mati\xe8re de formations</strong> (le contenu de {{OrgName}} ne sera pas visible pour les personnes qui ne sont pas membres de {{OrgNameSingular}}) et <strong>vos statistiques</strong> (y compris votre classement).<br/><br/>D’autres utilisateurs publics pourront \xe9galement vous suivre (c’est-\xe0-dire \xeatre inform\xe9s de vos activit\xe9s de formation).";
var OrgSettings_PrivacyChangeToPublicMessage_Desc = "Message indiquant le niveau confidentialit\xe9 du profil, qui s’affiche lorsque l’utilisateur rend son profil public.";
var OrgSettings_PrivacyChangeToPublicMessage_Name = "Message de profil public";
var OrgSettings_PrivacySettings = "Param\xe8tres de confidentialit\xe9";
var OrgSettings_ProfileOverviewTabDefault_Desc = "D\xe9finir le r\xe9sum\xe9 des comp\xe9tences par d\xe9faut qui s’affiche dans la vue d’ensemble du profil. Cela ne s’applique pas aux profils publics consult\xe9s par des utilisateurs anonymes.";
var OrgSettings_ProfileOverviewTabDefault_Name = "R\xe9sum\xe9 des comp\xe9tences par d\xe9faut dans la vue d’ensemble du profil";
var OrgSettings_ProfileOverviewTabDefault_Selection_Focus = "Comp\xe9tences prioritaires";
var OrgSettings_ProfileOverviewTabDefault_Selection_Top = "Comp\xe9tences principales (par d\xe9faut)";
var OrgSettings_ProfilePrivacyUpdate_GroupDesc = "Ce message appara\xeet lorsqu’un apprenant modifie le param\xe8tre de confidentialit\xe9 de son profil.";
var OrgSettings_ProfilePrivacyUpdate_GroupDisplayName = "Avertissements de modification de la confidentialit\xe9 du profil";
var OrgSettings_Providers_Desc = "Lorsqu’un fichier des utilisateurs est t\xe9l\xe9charg\xe9, l’option Ajouter l’annexera au fichier existant, tandis que l’option Remplacer l’\xe9crasera ou le remplacera.";
var OrgSettings_Providers_Name = "Fournisseurs";
var OrgSettings_PublishCards = "Publier des cartes";
var OrgSettings_PublishCardsAriaText = "Veuillez mettre \xe0 jour au moins une carte pour pouvoir publier.";
var OrgSettings_PublishCardsSingleSuccess = "La carte de statistiques a bien \xe9t\xe9 publi\xe9e.";
var OrgSettings_PublishCardsSuccess = "Les cartes de statistiques ont bien \xe9t\xe9 publi\xe9es.";
var OrgSettings_PublishChanges = "Publier les modifications";
var OrgSettings_QuickLinks = "Liens rapides";
var OrgSettings_RapRedirectUrl_Desc = "Lorsque cette option est activ\xe9e, tous les tickets Signaler un probl\xe8me seront redirig\xe9s vers une URL personnalis\xe9e. Cela permettra \xe9galement d’\xe9viter les tickets d’assistance habituellement envoy\xe9s au service d’assistance Degreed.";
var OrgSettings_RapRedirectUrl_Label = "URL personnalis\xe9e";
var OrgSettings_RapRedirectUrl_Name = "Activer la redirection d’URL";
var OrgSettings_RapRedirectUrl_Placeholder = "Saisissez une URL";
var OrgSettings_RateSkillsEmail_Desc = "Invite les apprenants \xe0 noter leurs comp\xe9tences.";
var OrgSettings_RateSkillsEmail_Name = "E-mail d’int\xe9gration — Jour 7\xa0: Mesurez vos comp\xe9tences";
var OrgSettings_RatingsVisibilityPublic_Desc = "Activer cette option permet de rendre les \xe9valuations publiques dans l’ensemble de l’organisation.";
var OrgSettings_Recommendations_Desc = "Avertit les apprenants lorsqu’une autre personne a partag\xe9 du contenu avec eux.";
var OrgSettings_Recommendations_Name = "Nouveaux partages";
var OrgSettings_RemoveCard = "Supprimer la carte";
var OrgSettings_RemoveCardConfirmation = "Si vous supprimez cette carte, toutes les informations personnalis\xe9es que vous y avez ajout\xe9es seront perdues.";
var OrgSettings_RemoveCardConfirmation_Body = "Si vous supprimez cette carte, toutes les informations personnalis\xe9es que vous y avez ajout\xe9es seront perdues.";
var OrgSettings_RemoveCardProceed_Confirm = "Souhaitez-vous continuer\xa0?";
var OrgSettings_ReorderCards = "R\xe9organiser les cartes";
var OrgSettings_ReorderCardsAriaText = "Veuillez ajouter au moins deux cartes pour pouvoir les r\xe9organiser";
var OrgSettings_ReorderHomeSections = "R\xe9organiser les sections de la page d’accueil";
var OrgSettings_ReorderInsightCards = "R\xe9organiser les cartes de statistiques";
var OrgSettings_ReorderInvalidCardsAriaText = "Assurez-vous que tous les champs de la carte sont valides pour activer la r\xe9organisation.";
var OrgSettings_ReplyToComment_Desc = "Avertit les apprenants lorsqu’une autre personne a r\xe9pondu \xe0 leur avis.";
var OrgSettings_ReplyToComment_Name = "R\xe9pondre";
var OrgSettings_ReportAProblem_GroupDesc = "Redirige les utilisateurs vers une URL personnalis\xe9e pour tous les tickets Signaler un probl\xe8me.";
var OrgSettings_ReportAProblem_GroupDisplayName = "Redirection de l’URL de signalement de probl\xe8me";
var OrgSettings_ReportEmailSettings_Desc = "Active toutes les notifications par e-mail pour les \xe9checs de fichiers sortants\xa0FTP. Ajoutez un e-mail par ligne.";
var OrgSettings_ReportEmailSettings_Name = "E-mails d’\xe9chec de rapport sortant";
var OrgSettings_ReportingDateFormat_Desc = "Le format de date et d’heure pour les noms de rapports. Format par d\xe9faut\xa0: \xab\xa0aaaaMMjjHHmmss\xa0\xbb.";
var OrgSettings_ReportingDateFormat_Name = "Format de date et d’heure";
var OrgSettings_ReportingFTPConnection_Name = "Param\xe8tres de connexion\xa0FTP pour les rapports client";
var OrgSettings_ReportingOrganizationNameAlias_Desc = "Utilis\xe9 pour remplacer le nom de l’organisation figurant dans le nom d’un rapport.";
var OrgSettings_ReportingOrganizationNameAlias_Name = "Pseudonyme de l’organisation";
var OrgSettings_ReportingTimeZone_Desc = "Par d\xe9faut, les rapports sont ex\xe9cut\xe9s \xe0 l’heure UTC. Utilisez cette option pour passer \xe0 un fuseau horaire diff\xe9rent (p. ex.\xa0: heure normale des Rocheuses [MST] ou heure normale d’Asie de l’Ouest [WAST]).";
var OrgSettings_ReportingTimeZone_Name = "Fuseau horaire pour les rapports";
var OrgSettings_RequireInternalCredentialReviews_Desc = "Cette fonctionnalit\xe9 ne concerne que les organisations qui utilisent la certification de comp\xe9tence. Lorsqu’elle est activ\xe9e, seuls les coll\xe8gues peuvent proc\xe9der \xe0 des \xe9valuations de leurs pairs.";
var OrgSettings_RequireInternalCredentialReviews_Name = "Exiger des \xe9valuations internes de certification de comp\xe9tence";
var OrgSettings_ResetAcceptance = "R\xe9initialiser pour tous les utilisateurs";
var OrgSettings_ResetDefaultMessage = "R\xe9initialiser le message par d\xe9faut";
var OrgSettings_ResetPrivacyAcceptanceHeader = "R\xe9initialiser le message \xab\xa0Imposer l’acceptation de la confidentialit\xe9 des donn\xe9es\xa0\xbb";
var OrgSettings_ResetPrivacyAcceptanceSuccess = "Le message sur la confidentialit\xe9 des donn\xe9es a bien \xe9t\xe9 r\xe9initialis\xe9.";
var OrgSettings_ResetPrivacyAcceptanceWarning = "Vous \xeates sur le point de r\xe9initialiser ce message pour tous les utilisateurs. Souhaitez-vous continuer\xa0?";
var OrgSettings_RestrictDuplicateEmailsOnUserFile_Desc = "Cette fonctionnalit\xe9 permet de rejeter toutes les lignes qui contiennent une valeur d’adresse e-mail en double dans un fichier ClientUser (p. ex.\xa0: si deux lignes contiennent la m\xeame adresse e-mail, ces deux valeurs doivent \xeatre rejet\xe9es).";
var OrgSettings_RestrictDuplicateEmailsOnUserFile_Name = "Emp\xeacher les adresses e-mail en double";
var OrgSettings_RestrictExtension_Desc = "D\xe9sactive la page d’extension des param\xe8tres personnels et l’utilisation de l’extension et du bookmarklet.";
var OrgSettings_RestrictExtension_Name = "D\xe9sactiver l’extension/le bookmarklet";
var OrgSettings_RestrictITunesExternalPodcastLinks_Desc = "Cette fonctionnalit\xe9 permet de d\xe9sactiver la possibilit\xe9 pour les utilisateurs de lancer des podcasts iTunes \xe0 partir de liens dans le catalogue. L’utilisateur peut voir le lien du podcast, mais ne peut pas lancer le contenu. Nous ne recommandons pas aux clients de d\xe9sactiver cette fonctionnalit\xe9. (Seule BofA dispose de ce param\xe8tre.)";
var OrgSettings_RestrictITunesExternalPodcastLinks_Name = "D\xe9sactiver les liens vers des podcasts iTunes externes";
var OrgSettings_RestrictMobileApp_Desc = "Emp\xeache la connexion \xe0 l’application mobile Degreed.\nBloque les notifications et messages SINA qui renvoient \xe0 l’application mobile.";
var OrgSettings_RestrictMobileApp_Name = "Restreindre l’acc\xe8s \xe0 l’application mobile";
var OrgSettings_RestrictMobileAppInChina_Desc = "Blocks access to logging into the Degreed mobile app for users in China. Change this setting only after approval from the privacy team.";
var OrgSettings_RestrictMobileAppInChina_Name = "Restrict Mobile App in China (CLIENT SIGNATURE REQUIRED)";
var OrgSettings_RunRulesSkippedRecords_Desc = "S’applique au nouveau processeur de r\xe8gles m\xe9tier uniquement. Force l’ex\xe9cution des r\xe8gles m\xe9tier sur les dossiers entrants m\xeame si aucun changement n’est d\xe9tect\xe9.";
var OrgSettings_RunRulesSkippedRecords_Name = "Ex\xe9cuter des r\xe8gles m\xe9tier sur les dossiers ignor\xe9s";
var OrgSettings_SavedLinks = "Liens enregistr\xe9s";
var OrgSettings_SavedLinksCount = "Liens enregistr\xe9s\xa0: {{numberOfSavedLinks}}";
var OrgSettings_Security_ApiSectionDescription = "This setting will apply to any API tokens created";
var OrgSettings_Security_ApiSectionTitle = "API Access Token";
var OrgSettings_Security_ApiTimeoutDescription = "This will be the length of time an API token will be valid until a new one has to be generated. (max. 60 days, default = 60 days)";
var OrgSettings_Security_ApiTimeOutError = "Value must be longer than {{min}} minutes and shorter than {{max}} minutes.";
var OrgSettings_Security_ApiTimeOutResetAriaLabel = "Reset API access token timeout Duration";
var OrgSettings_Security_ApiTimeoutTitle = "Access Token";
var OrgSettings_Security_ChromeSectionDescription = "This setting will apply to all users using the Degreed Chrome Extension.";
var OrgSettings_Security_ChromeSectionTitle = "Chrome Extension";
var OrgSettings_Security_ChromeTimeoutDescription = "Regardless of activity, the user will be forced to log in after this period. (max. 365 days, default = 60 days)";
var OrgSettings_Security_ChromeTimeOutResetAriaLabel = "Reset Chrome Timeout Duration";
var OrgSettings_Security_ChromeTimeoutTitle = "Chrome Extension Timeout";
var OrgSettings_Security_ExtensionTimeOutError = "Value must be longer than {{min}} minutes and shorter than {{max}} minutes.";
var OrgSettings_Security_InactivityTimeOutDescription = "Dur\xe9e de validit\xe9 d’un cookie de session une fois qu’il est inactif (2\xa0minutes minimum, 100\xa0jours maximum, 14\xa0jours par d\xe9faut)";
var OrgSettings_Security_InactivityTimeOutError = "La valeur saisie doit \xeatre sup\xe9rieure \xe0 2\xa0minutes et inf\xe9rieure \xe0 100\xa0jours.";
var OrgSettings_Security_InactivityTimeOutIntervalAriaLabel = "Dur\xe9e du d\xe9lai d’inactivit\xe9";
var OrgSettings_Security_InactivityTimeOutResetAriaLabel = "R\xe9initialiser la dur\xe9e du d\xe9lai d’expiration en cas d’inactivit\xe9";
var OrgSettings_Security_InactivityTimeOutTitle = "Expiration en cas d’inactivit\xe9";
var OrgSettings_Security_LoginTimeOutDescription = "Peu importe la dur\xe9e d’activit\xe9 de l’utilisateur, ce dernier devra se connecter \xe0 nouveau au-del\xe0 de cette p\xe9riode (2\xa0minutes minimum, 365\xa0jours maximum, 30\xa0jours par d\xe9faut).";
var OrgSettings_Security_LoginTimeOutError = "La valeur saisie doit \xeatre sup\xe9rieure \xe0 2\xa0minutes et inf\xe9rieure \xe0 365\xa0jours.";
var OrgSettings_Security_LoginTimeOutIntervalAriaLabel = "Dur\xe9e du d\xe9lai d’expiration de la connexion";
var OrgSettings_Security_LoginTimeOutResetAriaLabel = "R\xe9initialiser la dur\xe9e du d\xe9lai d’expiration de la connexion";
var OrgSettings_Security_LoginTimeOutTitle = "Expiration de la connexion";
var OrgSettings_Security_LogOutAllUsers = "D\xe9connecter tous les utilisateurs";
var OrgSettings_Security_LogOutWarningText = "La publication de ces changements entra\xeenera la d\xe9connexion de tous vos utilisateurs. Ils devront \xe0 nouveau saisir leurs identifiants pour se reconnecter.";
var OrgSettings_Security_MobileSectionDescription = "This setting will apply to all users accessing the system through native mobile apps downloaded through the Android  or IOS app stores";
var OrgSettings_Security_MobileSectionTitle = "Mobile Apps";
var OrgSettings_Security_MobileTimeoutDescription = "Regardless of activity, users will be forced to login after the period. (max. 365 days, default = 60 days)";
var OrgSettings_Security_MobileTimeOutError = "Value must be longer than {{min}} minutes and shorter than {{max}} minutes.";
var OrgSettings_Security_MobileTimeOutResetAriaLabel = "Reset Mobile Timeout Duration";
var OrgSettings_Security_MobileTimeoutTitle = "Mobile Timeout";
var OrgSettings_Security_NonPersistentSessionDescription = "Si un utilisateur ferme son navigateur, sa session expirera. Ce comportement peut varier en fonction des param\xe8tres du navigateur de l’utilisateur.";
var OrgSettings_Security_NonPersistentSessionTitle = "Session non persistante";
var OrgSettings_Security_PageTitle = "S\xe9curit\xe9";
var OrgSettings_Security_PersistentSessionDescription = "Permet \xe0 l’utilisateur de conserver le cookie de session lorsqu’il rouvre le navigateur sur le m\xeame appareil.";
var OrgSettings_Security_PersistentSessionTitle = "Session persistante";
var OrgSettings_Security_SessionCookieModeTitle = "Mode de gestion des cookies de session";
var OrgSettings_Security_WebSectionDescription = "Ces param\xe8tres s’appliqueront \xe0 tous les utilisateurs acc\xe9dant au syst\xe8me via un navigateur web traditionnel ou mobile.";
var OrgSettings_Security_WebSectionTitle = "Application web";
var OrgSettings_SegmentsDuplicateError = "Le ou les segment(s) suivant(s) a/ont d\xe9j\xe0 \xe9t\xe9 utilis\xe9(s) pour un autre lien dans cette carte\xa0: {{segments}}. Veuillez en choisir d’autres.";
var OrgSettings_SegmentsMaxError = "Vous pouvez ajouter jusqu’\xe0 {{maxNumberOfSegments}}\xa0segments.";
var OrgSettings_SelectLearningMetric = "S\xe9lectionner un indicateur de formation";
var OrgSettings_SelectLearningMetricPlaceholder = "S\xe9lectionnez l’indicateur de formation que vous souhaitez montrer aux apprenants.";
var OrgSettings_SendAllRapTicketsToClient_Desc = "Lorsque cette option est activ\xe9e, tous les tickets d’assistance sont envoy\xe9s aux adresses e-mail de niveau\xa01 r\xe9pertori\xe9es par le client.";
var OrgSettings_SendAllRapTicketsToClient_Name = "Envoyer tous les tickets d’assistance au client";
var OrgSettings_ServiceNowIntegrationConfiguration_Desc = "Lorsque cette int\xe9gration est configur\xe9e, les tickets d’assistance de niveau\xa01 sont envoy\xe9s \xe0 l’instance\xa0ServiceNow du client.";
var OrgSettings_ServiceNowIntegrationConfiguration_Name = "Configuration de l’int\xe9gration\xa0ServiceNow";
var OrgSettings_SessionTimeoutAbsoluteConfig_Desc = 'Specifies the longest time in minutes a user can be authenticated despite activity or sliding expirations and the display unit (Minutes, Hours, or Days) to use on the administering page. The following is an example of the expected JSON format: {"SessionTimeoutAbsoluteDisplayUnit":"Days","SessionTimeoutAbsoluteMinutes":10080}';
var OrgSettings_SessionTimeoutAbsoluteConfig_Name = "Absolute Session Timeout Config";
var OrgSettings_SessionTimeoutInactivityConfig_Desc = 'Specifies the session timeout in minutes for user inactivity and the display unit (Minutes, Hours, or Days) to use on the administering page. The following is an example of the expected JSON format: {"SessionTimeoutInactivityDisplayUnit":"Hours","SessionTimeoutInactivityMinutes":10080}';
var OrgSettings_SessionTimeoutInactivityConfig_Name = "Inactive Session Timeout Config";
var OrgSettings_SetEvaluationsPrivateByDefault_Desc = "La visibilit\xe9 par d\xe9faut des revues de comp\xe9tences termin\xe9es est d\xe9finie sur \xab\xa0Public\xa0\xbb. Si cette option est coch\xe9e, la visibilit\xe9 par d\xe9faut des revues de comp\xe9tences nouvellement termin\xe9es est d\xe9finie sur \xab\xa0Priv\xe9\xa0\xbb.";
var OrgSettings_SetEvaluationsPrivateByDefault_Name = "D\xe9finir les revues de comp\xe9tences comme priv\xe9es par d\xe9faut";
var OrgSettings_ShouldTransformTaxonomy_Desc = "Ce param\xe8tre permet de d\xe9terminer si la mise en forme des titres et d’autres transformations seront appliqu\xe9es \xe0 la taxonomie des postes et des comp\xe9tences.";
var OrgSettings_ShouldTransformTaxonomy_Name = "Appliquer des transformations \xe0 la taxonomie";
var OrgSettings_ShowAllProvidersInSearchFacet_Desc = "Utilis\xe9e \xe0 des fins de navigation et de recherche, cette fonctionnalit\xe9 contr\xf4le les valeurs renvoy\xe9es dans le filtre fournisseur. Elle affiche tous les fournisseurs internes (pr\xe9f\xe9r\xe9s) ind\xe9pendamment du fait que des r\xe9sultats aient \xe9t\xe9 trouv\xe9s pour ces fournisseurs avec le terme de recherche sp\xe9cifi\xe9. Ainsi, un 0 s’affiche pour le fournisseur pr\xe9f\xe9r\xe9 m\xeame si aucun r\xe9sultat n’a \xe9t\xe9 trouv\xe9. ";
var OrgSettings_ShowAllProvidersInSearchFacet_Name = "Afficher les fournisseurs internes dans les r\xe9sultats de recherche m\xeame en l’absence de r\xe9sultat";
var OrgSettings_ShowCookiePolicyLink_Desc = "Ajoutez un lien vers l’avis sur les cookies de Degreed.";
var OrgSettings_ShowCookiePolicyLink_Name = "Avis sur les cookies";
var OrgSettings_ShowExternalContentWarning_Default = "Vous acc\xe9dez \xe0 un catalogue externe comprenant des sources publiques et des fournisseurs de contenu externes qui n’appartiennent pas et n’ont pas \xe9t\xe9 approuv\xe9s par votre organisation.";
var OrgSettings_ShowExternalContentWarning_Desc = "Ce message appara\xeet lorsque les apprenants choisissent de consulter des ressources externes au lieu du catalogue interne de l’organisation.";
var OrgSettings_ShowExternalContentWarning_Name = "Avertissement concernant le catalogue externe";
var OrgSettings_ShowGroupMembershipSource_Desc = "La m\xe9thode par laquelle un utilisateur a rejoint le groupe.";
var OrgSettings_ShowGroupMembershipSource_Name = "Afficher la source de l’abonnement au groupe";
var OrgSettings_ShowSlackIntegration_Desc = "Autoriser les utilisateurs \xe0 connecter l’int\xe9gration Slack \xe0 leur compte Degreed.";
var OrgSettings_ShowSlackIntegration_Name = "Int\xe9gration Slack";
var OrgSettings_Size = "Taille";
var OrgSettings_SizeKiloByte = "Taille (Ko)";
var OrgSettings_SkillCoachFullOrgAccess_Desc = "Ignore les groupes de pr\xe9lancement et active la fonctionnalit\xe9 pour tous les managers. (L’option \xab\xa0Activer Skill\xa0Coach\xa0\xbb doit \xe9galement \xeatre activ\xe9e).";
var OrgSettings_SkillCoachFullOrgAccess_Name = "Activer Skill\xa0Coach pour l’ensemble de l’organisation";
var OrgSettings_SkillInventoryClientOverride_Desc = "Ce param\xe8tre s’adresse uniquement aux nouvelles organisations utilisant l’inventaire des comp\xe9tences public gratuit. Il remplace les param\xe8tres par d\xe9faut de la LXP sans les modifier. L’acc\xe8s de l’organisation est limit\xe9 aux statistiques et outils de mesure des comp\xe9tences s\xe9lectionn\xe9s.";
var OrgSettings_SkillInventoryClientOverride_Name = "Remplacer l’inventaire des comp\xe9tences";
var OrgSettings_Skills_Desc = "Lorsque les opportunit\xe9s sont import\xe9es via un fichier ou une int\xe9gration, cette option permet soit d’ajouter des comp\xe9tences \xe0 l’opportunit\xe9, soit de remplacer les comp\xe9tences dans Degreed.";
var OrgSettings_Skills_Name = "Ajouter/Remplacer des comp\xe9tences";
var OrgSettings_SkillsCheckupEmail_Desc = "Une fois activ\xe9, cet e-mail est envoy\xe9 \xe0 tous les employ\xe9s de l’organisation tous les 3 mois pour les inviter \xe0 actualiser le niveau des comp\xe9tences ajout\xe9es \xe0 leur profil.";
var OrgSettings_SkillsCheckupEmail_Name = "E-mail de v\xe9rification des comp\xe9tences";
var OrgSettings_SkipEmailLookup_Desc = "Lors du traitement du fichier utilisateur, ne pas utiliser l’adresse e-mail comme identifiant pour trouver un compte existant.";
var OrgSettings_SkipEmailLookup_Name = "Exclure la recherche par adresse e-mail";
var OrgSettings_SocialNotify_Desc = "Avertit les apprenants lorsqu’une autre personne commence \xe0 les suivre.";
var OrgSettings_SocialNotify_Name = "Nouvel abonn\xe9";
var OrgSettings_SocialSettings = "Param\xe8tres sociaux";
var OrgSettings_SsoAutoCreateProfile_Desc = "Cr\xe9er un compte Degreed automatiquement lorsqu’un utilisateur s’inscrit gr\xe2ce au fournisseur d’authentification unique.";
var OrgSettings_SsoAutoCreateProfile_Name = "Cr\xe9er des comptes utilisateur automatiquement via l’authentification unique";
var OrgSettings_SuggestInternalContentOnly_Desc = "Le contenu s’affichant dans le flux Degreed peut provenir de\xa0: parcours du catalogue externe. \nLorsque ce param\xe8tre est activ\xe9, les parcours du catalogue externe n’apparaissent pas dans le flux des apprenants. \xc9tant donn\xe9 que les parcours externes sont les seuls contenus du catalogue externe qui peuvent \xeatre affich\xe9s dans le flux, cela signifie que les r\xe9sultats du flux n’afficheront plus aucun contenu du catalogue externe.";
var OrgSettings_SuggestInternalContentOnly_Name = "Sugg\xe9rer du contenu interne seulement";
var OrgSettings_SuggestTags_Desc = "Afficher des comp\xe9tences dans les r\xe9sultats de recherche.";
var OrgSettings_SuggestTags_Name = "Sugg\xe9rer des comp\xe9tences dans la recherche";
var OrgSettings_SuggestTargets_Desc = "Affichez des plans et des r\xe9pertoires dans les r\xe9sultats de recherche et de navigation.";
var OrgSettings_SuggestTargets_Name = "Sugg\xe9rer des plans et des r\xe9pertoires dans la recherche et la navigation";
var OrgSettings_SupportTargets_Desc = "Active les plans au sein d’une organisation. Si cette option est d\xe9sactiv\xe9e, les plans et les plans de carri\xe8re ne pourront pas \xeatre utilis\xe9s par l’organisation.";
var OrgSettings_SupportTargets_Name = "Plans (la d\xe9sactivation de cette option d\xe9sactive \xe9galement les plans de carri\xe8re)";
var OrgSettings_Tier1UserSupportTicketsEmailSettings_Desc = "Envoyez \xe0 la liste d’adresses e-mail suivante la description des probl\xe8mes signal\xe9s. Une adresse e-mail par ligne.";
var OrgSettings_Tier1UserSupportTicketsEmailSettings_Name = "E-mails de tickets de support utilisateur de niveau\xa01";
var OrgSettings_ToggleOff = "Param\xe8tre {{settingName}} d\xe9sactiv\xe9.";
var OrgSettings_ToggleOn = "Param\xe8tre {{settingName}} activ\xe9.";
var OrgSettings_TotalInstance = "Nombre total d’instances";
var OrgSettings_TotalInstanceCount_PluralFormat = "{{ count }}\xa0instances";
var OrgSettings_TotalInstanceCount_Single = "1\xa0instance";
var OrgSettings_TotalInstances = "Nombre total d’instances";
var OrgSettings_TotalRow = "Nombre de lignes";
var OrgSettings_TotalRows = "Nombre total de lignes";
var OrgSettings_TotalRowsCount_PluralFormat = "{{ count }}\xa0lignes";
var OrgSettings_TotalRowsCount_Single = "1\xa0ligne";
var OrgSettings_TrackLearning_Desc = "Indique aux apprenants qu’ils peuvent marquer les \xe9l\xe9ments comme termin\xe9s dans le flux.";
var OrgSettings_TrackLearning_Name = "Marquer la progression des formations";
var OrgSettings_TrackLearningOnGo_Desc = "Informe les apprenants qu’une application mobile est disponible pour apprendre \xe0 tout moment.";
var OrgSettings_TrackLearningOnGo_Name = "Disponibilit\xe9 des formations sur mobile";
var OrgSettings_UnpublishCards = "Supprimer les cartes";
var OrgSettings_UntitledLinkTitle = "Lien sans intitul\xe9";
var OrgSettings_UpdateCard = "Mettre \xe0 jour la carte";
var OrgSettings_UpdateEmails_GroupDesc = "Param\xe8tres par d\xe9faut concernant uniquement les nouveaux utilisateurs Degreed. Ces param\xe8tres n’affectent pas les param\xe8tres d’e-mail des utilisateurs actuels.";
var OrgSettings_UpdateEmails_GroupDisplayName = "Param\xe8tres par d\xe9faut des e-mails de mise \xe0 jour";
var OrgSettings_UpdatePublishing = "Mettre \xe0 jour la publication";
var OrgSettings_UpdateUserTagRatings_Desc = "Invite les utilisateurs \xe0 mettre \xe0 jour leurs \xe9valuations de comp\xe9tences.";
var OrgSettings_UpdateUserTagRatings_Name = "Invitation \xe0 mettre \xe0 jour les comp\xe9tences";
var OrgSettings_UpdateUserTagRatingsEmail_Desc = "Une fois activ\xe9, cet e-mail est envoy\xe9 \xe0 tous les employ\xe9s de l’organisation tous les 3\xa0mois pour les inviter \xe0 actualiser les \xe9valuations de comp\xe9tences ajout\xe9es \xe0 leur profil.";
var OrgSettings_UpdateUserTagRatingsEmail_Name = "E-mail de mise \xe0 jour des comp\xe9tences";
var OrgSettings_UpdateUserTags_Desc = "Invite les apprenants \xe0 v\xe9rifier et modifier leurs th\xe8mes de formation.";
var OrgSettings_UpdateUserTags_Name = "Renouveler les comp\xe9tences";
var OrgSettings_UrlScanExemptDomains_Desc = "Les administrateurs peuvent saisir dans ce champ les domaines et les sous-domaines \xe0 exclure des analyses d’URL permettant de rechercher les liens cass\xe9s. Lorsqu’un domaine ou un sous-domaine est exclu, l’onglet G\xe9rer les liens cass\xe9s ne signale aucune erreur li\xe9e \xe0 ces liens.";
var OrgSettings_UrlScanExemptDomains_Name = "Domaines \xe0 exclure des analyses d’URL";
var OrgSettings_UseInternalJobSkills_Desc = "Lorsque cette option est activ\xe9e, Degreed utilise la taxonomie des postes et des comp\xe9tences de l’organisation plut\xf4t que la sienne pour l’int\xe9gration et la cr\xe9ation de plans et de plans d’\xe9volution de poste. Cette fonctionnalit\xe9 est utile pour les organisations qui disposent d’une taxonomie compl\xe8te et fiable des postes avec les comp\xe9tences qui y sont associ\xe9es. Peu d’organisations souhaitent que cette fonctionnalit\xe9 soit activ\xe9e. ";
var OrgSettings_UseInternalJobSkills_Name = "Utiliser les postes et les comp\xe9tences de l’organisation";
var OrgSettings_UserNotificationEmail_Desc = "E-mails d\xe9clench\xe9s par des \xe9v\xe9nements se produisant dans Degreed.";
var OrgSettings_UserNotificationEmail_Name = "E-mails de notification";
var OrgSettings_UseZendeskWebWidget_Desc = "Activer le Web Widget de Zendesk pour cette organisation.";
var OrgSettings_UseZendeskWebWidget_Name = "Utiliser le Web Widget de Zendesk";
var OrgSettings_WeeklySummaryEmail_Desc = "E-mail hebdomadaire contenant une synth\xe8se des activit\xe9s dans Degreed et des suggestions de formations.";
var OrgSettings_WeeklySummaryEmail_Name = "Les tendances de la semaine";
var OrgSettings_WelcomeEmail_Desc = "E-mail envoy\xe9 \xe0 tous les nouveaux apprenants pour les aider \xe0 bien d\xe9marrer avec Degreed.";
var OrgSettings_WelcomeEmail_Name = "E-mail d’int\xe9gration — Jour 1\xa0: Bienvenue sur Degreed";
var OrgSettings_WelcomeIntro_Desc = "Visite d’int\xe9gration et de bienvenue dans Degreed pour aider l’apprenant \xe0 configurer son profil et \xe0 tirer le meilleur parti de la plateforme.";
var OrgSettings_WelcomeIntro_Name = "Visite de bienvenue pour tout nouvel apprenant";
var OrgSettings_WeMissYouEmail_Desc = "E-mail envoy\xe9 aux apprenants qui ont \xe9t\xe9 inactifs sur Degreed pendant 30\xa0jours.";
var OrgSettings_WeMissYouEmail_Name = "E-mail d’inactivit\xe9";
var OrgSettings_WhatSkillsEmail_Desc = "Cet e-mail invite les nouveaux apprenants \xe0 ajouter des comp\xe9tences \xe0 leur profil et les informe sur l’objectif de Degreed\xa0: le d\xe9veloppement des comp\xe9tences.";
var OrgSettings_WhatSkillsEmail_Name = "E-mail d’int\xe9gration — Jour 2\xa0: Quelles comp\xe9tences recherchez-vous\xa0?";
var OrgSettings_WhitelistedDomains_Desc = "Les administrateurs peuvent d\xe9finir des domaines sp\xe9cifiques pour h\xe9berger du contenu interne. Cela leur permet non seulement de d\xe9signer des domaines particuliers, mais aussi d’utiliser des caract\xe8res g\xe9n\xe9riques pour inclure des sous-domaines connexes.";
var OrgSettings_WhitelistedDomains_Name = "Domaines autoris\xe9s";
var OrgSettings_WhiteListFtpAccessIpAddresses_Desc = "Seul un utilisateur avec les adresses IP r\xe9pertori\xe9es peut acc\xe9der \xe0 ces fichiers FTP de l’organisation";
var OrgSettings_WhiteListFtpAccessIpAddresses_Name = "Mettre l’acc\xe8s FTP via les adresses IP sur liste blanche";
var OrgSettings_ZendeskWidgetKey_Desc = "D\xe9finit la cl\xe9 du widget Zendesk (g\xe9r\xe9e par les EE) qui d\xe9termine la version du bot utilis\xe9e par le widget.";
var OrgSettings_ZendeskWidgetKey_Name = "Cl\xe9 du Web Widget de Zendesk";
var OrgSettingsCtrl_AcademiesHeaderUploadSize = "La taille recommand\xe9e est au moins de 258\xa0px en hauteur et de 1152\xa0px en largeur.";
var OrgSettingsCtrl_AssignedLearningCustomizationDiscardConfirm = "Les modifications que vous avez apport\xe9es \xe0 la carte Formation assign\xe9e seront perdues. Voulez-vous vraiment continuer\xa0?";
var OrgSettingsCtrl_ChangesCancelConfirm = "Les modifications que vous avez apport\xe9es \xe0 {{ title }} seront perdues. Voulez-vous vraiment continuer\xa0?";
var OrgSettingsCtrl_ChangesCanceledSuccessMessage = "Les modifications que vous avez apport\xe9es \xe0 {{ title }} ont bien \xe9t\xe9 annul\xe9es.";
var OrgSettingsCtrl_ContrastWarning = "Le jeu de couleurs n’est PAS conforme aux exigences des WCAG relatives correspondant au rapport de contraste 4.5:1";
var OrgSettingsCtrl_EmailRequirements = "Pour s’inscrire, il est n\xe9cessaire de disposer d’une adresse e-mail";
var OrgSettingsCtrl_EmailRequirementsHint = "conseil : ajoutez plusieurs domaines en les s\xe9parant par une virgule.";
var OrgSettingsCtrl_ManageOrgName = "G\xe9rer {0}";
var OrgSettingsCtrl_MessagingTabLabel = "Vous pouvez personnaliser les messages qui apparaissent dans Degreed pour communiquer des informations importantes aux utilisateurs chaque fois que n\xe9cessaire.";
var OrgSettingsCtrl_MessagingTabPlaceholder = "Ajouter un message personnalis\xe9";
var OrgSettingsCtrl_OrgDescription = "Description";
var OrgSettingsCtrl_OrgName = "Nom de l’organisation";
var OrgSettingsCtrl_OrgNameInOnboarding = "Utiliser le nom de l’organisation dans l’int\xe9gration";
var OrgSettingsCtrl_OrgNameValidationMessage = "Veuillez renseigner le nom de l’organisation.";
var OrgSettingsCtrl_Title = "D\xe9tails de l’organisation";
var OrgSettingsCtrl_UpdateLinksSuccessMessage = "Les param\xe8tres ont bien \xe9t\xe9 mis \xe0 jour. Quelques minutes peuvent \xeatre n\xe9cessaires pour valider les modifications.";
var OrgSettingsCtrl_UpdateSuccessMessage = "Mise \xe0 jour des param\xe8tres de l’organisation effectu\xe9e.";
var OrgSettingsEndorsed_ImageSize = "La taille recommand\xe9e est de 48\xa0px en hauteur et max. 144\xa0px en largeur.";
var OrgSettingsEndorsed_RemoveEndorseIcon = "Supprimer l’ic\xf4ne de recommandation de l’\xe9l\xe9ment mis en ligne";
var OrgSettingsEndorsed_Subtitle = "Ajoutez un visuel aux \xe9l\xe9ments que vous souhaitez mettre en avant.";
var OrgSettingsEndorsed_Title = "Recommandations";
var OrgSettingsLinks_AddLink = "Ajouter un lien";
var OrgSettingsLinks_AddSection = "Ajouter une section";
var OrgSettingsLinks_Description = "Personnalisez la page d’accueil en ajoutant une section de liens importants.";
var OrgSettingsLinks_LinkMaximum = "(5\xa0liens maximum)";
var OrgSettingsLinks_LinkTitle = "Nom du lien";
var OrgSettingsLinks_LinkTitlePlaceholder = "Nom abr\xe9g\xe9 de la ressource";
var OrgSettingsLinks_LinkUrl = "URL du lien";
var OrgSettingsLinks_RemoveLink = "Supprimer le lien";
var OrgSettingsLinks_RemoveSection = "Supprimer la section";
var OrgSettingsLinks_SectionTitle = "Titre de la section";
var OrgSettingsLinks_Title = "Liens de l’organisation";
var OrgSettingsLinks_TitlePlaceholder = "Liens de {{orgName}}";
var OrgSettingsLinks_UpdateSuccessMessage = "Les liens de l’organisation ont bien \xe9t\xe9 mis \xe0 jour";
var OrgSettingsLinks_UrlPlaceholder = "http://resourceurl.com";
var OrgSettingsNav_Branding = "Image de marque";
var OrgSettingsNav_BusinessRules = "R\xe8gles m\xe9tier";
var OrgSettingsNav_Communication = "Communication";
var OrgSettingsNav_HelpMenu = "Menu d’aide";
var OrgSettingsNav_Learning = "Formation";
var OrgSettingsNav_Links = "Liens";
var OrgSettingsNav_ManageAttributes = "G\xe9rer les attributs";
var OrgSettingsNav_Messages = "Messages";
var OrgSettingsNav_Messaging = "Messages";
var OrgSettingsNav_Permissions = "Autorisations";
var OrgSettingsNav_Providers = "Fournisseurs";
var OrgSettingsSupport_Description = "Personnalisez le menu d’aide en indiquant vos coordonn\xe9es et les informations d’assistance";
var OrgSettingsSupport_EmailLabel = "Adresse e-mail";
var OrgSettingsSupport_FaqUrlLabel = "URL des FAQ";
var OrgSettingsSupport_FaqUrlPlaceholder = "https://degreed.com/faq";
var OrgSettingsSupport_InvalidEmail = "Veuillez saisir une adresse e-mail valide";
var OrgSettingsSupport_InvalidFaqUrl = "Veuillez saisir une URL valide";
var OrgSettingsSupport_PhoneLabel = "Num\xe9ro de t\xe9l\xe9phone";
var OrgSettingsSupport_PhonePlaceholder = "(123) 456-7890";
var OrgSettingsSupport_Title = "Gestion de l’assistance";
var OrgSettingsSupport_UpdateSuccessMessage = "Les param\xe8tres de gestion de l’assistance de l’organisation ont \xe9t\xe9 mis \xe0 jour avec succ\xe8s.";
var OrgSkills_AC_OnboardingAdd = "Sugg\xe9rer dans la visite de bienvenue";
var OrgSkills_AC_OnboardingRemove = "Ne pas sugg\xe9rer dans la visite";
var OrgSkills_AC_PlanMark = "Marquer comme plan";
var OrgSkills_AC_PlanView = "Modifier le plan";
var OrgSkills_AddRole = "Ajouter un poste";
var OrgSkills_AddRoleHeading = "Ajouter un poste";
var OrgSkills_AddSkill = "Ajouter une comp\xe9tence";
var OrgSkills_AddSkillButton = "Ajouter des comp\xe9tences";
var OrgSkills_AddSkills = "Ajouter des comp\xe9tences";
var OrgSkills_AddSkillTitle = "Ajouter une comp\xe9tence";
var OrgSkills_AlreadyAddedSkill = "Beau travail\xa0! Vous avez d\xe9j\xe0 ajout\xe9 cette comp\xe9tence \xe0 votre profil.";
var OrgSkills_ApplySuggestions = "Appliquer les suggestions";
var OrgSkills_BackToRoles = "Retour aux postes";
var OrgSkills_ContentCount = "Contenu";
var OrgSkills_CountSelected = "{{ count }} s\xe9lectionn\xe9(s)";
var OrgSkills_CreateSkills = "Cr\xe9er des comp\xe9tences";
var OrgSkills_CurrentSkills = "Comp\xe9tences actuelles";
var OrgSkills_DeleteItem = "Voulez-vous vraiment supprimer d\xe9finitivement {{ name }} \xa0?";
var OrgSkills_DescCharLimit = "Caract\xe8res restants\xa0: {{count}}";
var OrgSkills_DescCharLimitExceeded = "Nombre limite de caract\xe8res d\xe9pass\xe9.";
var OrgSkills_DescPlaceholder = "Br\xe8ve description de la comp\xe9tence";
var OrgSkills_DownloadRoles = "T\xe9l\xe9charger la liste";
var OrgSkills_DownloadSkills = "T\xe9l\xe9charger la liste";
var OrgSkills_EditRoleHeading = "Modifier le poste";
var OrgSkills_EditSkillTitle = "Modifier la comp\xe9tence";
var OrgSkills_EnableSkillReview = "Activer la revue de comp\xe9tence";
var OrgSkills_EnableSkillReviewHelpText = "Activez la revue de cette comp\xe9tence pour les apprenants de l’organisation.";
var OrgSkills_Endorsed = "Recommand\xe9e";
var OrgSkills_EndorsedSkillTooltip = "Cette comp\xe9tence est recommand\xe9e.";
var OrgSkills_EndorseSkill = "Recommander la comp\xe9tence";
var OrgSkills_EndorseSkillHelpText = "Si cette option est activ\xe9e, une ic\xf4ne de recommandation appara\xeet sur la carte.";
var OrgSkills_EquivalentSkillsHintSubtitle = "Ceci vous aidera \xe0 suivre et affiner les relations entre comp\xe9tences et postes.";
var OrgSkills_EquivalentSkillsHintTitle = "Identifiez les comp\xe9tences \xe9quivalentes que vous associez \xe0 cette comp\xe9tence personnalis\xe9e.";
var OrgSkills_EquivalentSkillsTip = "Conseil\xa0: saisissez le nom d’une comp\xe9tence, puis choisissez une option dans la liste ou utilisez la touche Entr\xe9e.";
var OrgSkills_EquivalentSkillsTitle = "Comp\xe9tences \xe9quivalentes";
var OrgSkills_FollowerCount = "Abonn\xe9s";
var OrgSkills_GeneratingSkills = "Generating skills...";
var OrgSkills_GeneratingSuggestions = "Generating suggestions...";
var OrgSkills_MarkedAsPlan = "Marqu\xe9 comme plan";
var OrgSkills_MatchedSkill = "Comp\xe9tence poss\xe9d\xe9e";
var OrgSkills_MatchedSkillButtonAlt = "La comp\xe9tence \xab\xa0{{matchedSkillName}}\xa0\xbb de {{providerName}} correspond \xe0 {{degreedSkillName}}. Cliquez pour la supprimer";
var OrgSkills_MatchSkill = "Trouver une correspondance";
var OrgSkills_MatchSkillPlaceholder = "Saisissez une comp\xe9tence";
var OrgSkills_NoEquivalentSkillsFound = "R\xe9sultat introuvable. Cette comp\xe9tence n’existe peut-\xeatre pas encore.";
var OrgSkills_NoLevel = "No Level";
var OrgSkills_NoRolesAdded = "Aucun poste n’a \xe9t\xe9 ajout\xe9 \xe0 cette organisation.";
var OrgSkills_NoSkillsAdded = "Aucune comp\xe9tence n’a \xe9t\xe9 ajout\xe9e \xe0 cette organisation.";
var OrgSkills_NoSkillsResultsFound = "Aucun r\xe9sultat. L’ajouter quand m\xeame \xa0?";
var OrgSkills_NumberSkillSuggestions = "{{ count }} suggestions de comp\xe9tences";
var OrgSkills_OnboardingFeatured = "\xc0 la une durant l’int\xe9gration";
var OrgSkills_PathwayCount = "Parcours";
var OrgSkills_Plan = "Plan";
var OrgSkills_Plans = "Plans";
var OrgSkills_Recommend = "Recommander";
var OrgSkills_RecommendModalTitle = "Recommander des comp\xe9tences";
var OrgSkills_RecommendSkills = "Recommander des comp\xe9tences";
var OrgSkills_RecommendSkillsFormat = "Recommander {{number}}\xa0comp\xe9tences";
var OrgSkills_RecommendSkillsPluralFormat = "Recommander {{number}}\xa0comp\xe9tences";
var OrgSkills_RecommendSkillsSingleFormat = "Recommander 1\xa0comp\xe9tence";
var OrgSkills_ReviewSkills = "\xc9valuer les comp\xe9tences";
var OrgSkills_Role = "Nom";
var OrgSkills_RoleAlreadyPlan = "This role was previously marked as a plan.";
var OrgSkills_RoleDescription = "Description du poste";
var OrgSkills_RoleDescriptionPlaceholder = "Saisir une description";
var OrgSkills_RoleIncludeInOnboarding = "Sugg\xe9rer un poste dans la visite de bienvenue";
var OrgSkills_RoleIncludeInOnboardingInfo = "Activez cette option pour sugg\xe9rer ce poste aux nouveaux utilisateurs avant leur recherche.";
var OrgSkills_RoleMakePlan = "Marquer comme plan";
var OrgSkills_RoleMakePlanInfo = "Cr\xe9ez un plan avec cet ensemble de comp\xe9tences. Vous pouvez ajouter du contenu plus tard.";
var OrgSkills_RolePlaceholder = "Concepteur de produits";
var OrgSkills_SearchForSkills = "Rechercher des comp\xe9tences…";
var OrgSkills_SearchPlaceholder = "Rechercher des comp\xe9tences…";
var OrgSkills_SeeSkillOverview = "Voir un aper\xe7u de la comp\xe9tence";
var OrgSkills_Selected = "S\xe9lectionn\xe9";
var OrgSkills_SelectSkillLevel = "Select Skill Level";
var OrgSkills_ShowAsPlan = "Marqu\xe9 comme plan";
var OrgSkills_SimilarSkillsTitle = "Comp\xe9tences similaires";
var OrgSkills_Skill = "Comp\xe9tence";
var OrgSkills_SkillDetailsTitle = "D\xe9tails de la comp\xe9tence";
var OrgSkills_SkillLevel = "Niveau de comp\xe9tence\xa0: {{skillLevel}}";
var OrgSkills_SkillNameExists = "Ce nom existe d\xe9j\xe0";
var OrgSkills_SkillPlaceholder = "Saisissez le nom de la comp\xe9tence";
var OrgSkills_SkillProfile = "Profil de comp\xe9tences";
var OrgSkills_SkillReview = "Revue de comp\xe9tence";
var OrgSkills_SkillReviewEnabled = "Organisation";
var OrgSkills_SkillReviewEnabledGroup = "Groupe";
var OrgSkills_Skills = "Comp\xe9tences";
var OrgSkills_SkillsListInfo = "Saisissez le nom d’une comp\xe9tence, puis choisissez une option dans la liste ou utilisez la touche Entr\xe9e";
var OrgSkills_SkillsListPlaceholder = "Saisissez une comp\xe9tence";
var OrgSkills_SkillToRoleSuggestions = "Suggestions de comp\xe9tences pour les postes";
var OrgSkills_SlowChangesWarn = "Les modifications des donn\xe9es de ce tableau peuvent ne pas s’afficher imm\xe9diatement.";
var OrgSkills_Source = "Source";
var OrgSkills_SuccessAddingSingleSkill = "Vous avez bien ajout\xe9 1\xa0nouvelle comp\xe9tence.";
var OrgSkills_SuggestedSkills = "Comp\xe9tences sugg\xe9r\xe9es";
var OrgSkills_TranslatedTitle = "Titre traduit\xa0:";
var OrgSkills_UpdateSkills = "Renouveler les comp\xe9tences";
var OrgSkills_UploadFile = "Charger le fichier";
var OrgSkills_UploadOpportunitiesNotice = "Le fichier que vous avez t\xe9l\xe9charg\xe9 est en cours de traitement. Les modifications apport\xe9es en fonction de ce fichier peuvent prendre 4\xa0heures avant d’apparaitre dans Degreed.";
var OrgSkills_UploadRoles = "Charger des postes";
var OrgSkills_UploadRolesDescription = "Vous pouvez charger plusieurs postes \xe0 la fois en les incluant dans un fichier avec le mod\xe8le suivant.";
var OrgSkills_UploadSkills = "Charger des comp\xe9tences";
var OrgSkills_UploadSkills_ToSource = "Upload Skills to {{SourceName}}";
var OrgSkills_UploadSkillsDescription = "Vous pouvez actualiser plusieurs comp\xe9tences \xe0 la fois en les incluant dans un fichier avec le mod\xe8le suivant. Il vous suffit d’inclure les comp\xe9tences que vous souhaitez actualiser.";
var OrgSkills_ViewRolePlan = "Voir le plan d’\xe9volution de poste";
var OrgSkills_VisibilitySkillReview = "Visibilit\xe9 de la revue de comp\xe9tence";
var OrgSkills_WorkdaySimilarSkillsInfo = "Les comp\xe9tences associ\xe9es sont automatiquement d\xe9finies par l’int\xe9gration Workday. Ces comp\xe9tences sont limit\xe9es \xe0 la taxonomie issue des catalogues de comp\xe9tences Workday et Degreed de votre organisation.";
var OrgSkillsNav_Roles = "Postes";
var OrgSkillsNav_Skills = "Comp\xe9tences";
var OrgSvc_AddFAQContactSuccess = "Op\xe9ration effectu\xe9e ! Contact des FAQ ajout\xe9.";
var OrgSvc_AddFAQError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’ajout aux FAQ.";
var OrgSvc_DeleteFAQError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la suppression des FAQ.";
var OrgSvc_FAQEmailError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’ajout de l’e-mail aux FAQ.";
var OrgSvc_OrgError = "Un probl\xe8me est survenu lors de l’acc\xe8s aux informations de l’organisation.";
var OrgSvc_OrgJoinSuccess = "Inscription de l’organisation effectu\xe9e.";
var OrgSvc_ResetPrivacyAcceptanceError = "Une erreur est survenue lors de la r\xe9initialisation du message \xab\xa0Imposer l’acceptation de la confidentialit\xe9 des donn\xe9es\xa0\xbb";
var OrgSvc_SendInviteError = "Un probl\xe8me est survenu lors de l’envoi des invitations.";
var OrgSvc_SendInviteSuccess = "Op\xe9ration effectu\xe9e\xa0! Vos invitations ont \xe9t\xe9 transmises.";
var OrgSvc_UpdateFAQError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la mise \xe0 jour des FAQ.";
var OrgSvc_UpdateLinksError = "Un probl\xe8me est survenu lors de la mise \xe0 jour des liens";
var OrgSvc_UpdateMessagesError = "Un probl\xe8me est survenu lors de la mise \xe0 jour des messages.";
var OrgSvc_UpdateProviderError = "Une erreur s’est produite lors de la mise \xe0 jour des param\xe8tres du fournisseur.";
var OrgSvc_UpdateProviderSuccess = "Mise \xe0 jour des param\xe8tres de fournisseur effectu\xe9e.";
var OrgTargetsCtrl_CreateTarget = "Cr\xe9er un {{targetType}}";
var OrgTargetsCtrl_DeletePrompt = "\xcates-vous s\xfbr de vouloir supprimer {{targetTitle}} ?";
var OrgTargetsCtrl_Description = "Description";
var OrgTargetsCtrl_FollowerCount = "Abonn\xe9s";
var OrgTargetsCtrl_NoJobRolesMessage = "Aucun plan \xe0 afficher";
var OrgTargetsCtrl_SearchForJobRole = "Rechercher un plan";
var OrgTargetsCtrl_Title = "Titre";
var OrgTargetsCtrl_Visibility = "Visibilit\xe9";
var OutcomeRatingOptionsSvc_ClaimsMostly = "Bien dans l’ensemble";
var OutcomeRatingOptionsSvc_ClaimsNotWell = "Pas bien";
var OutcomeRatingOptionsSvc_ClaimsSlightly = "L\xe9g\xe8rement bien";
var OutcomeRatingOptionsSvc_ClaimsSomewhat = "Plut\xf4t bien";
var OutcomeRatingOptionsSvc_ClaimsVeryWell = "Tr\xe8s bien";
var OutcomeRatingOptionsSvc_DifficultyExtremely = "Extr\xeamement difficile";
var OutcomeRatingOptionsSvc_DifficultyNot = "Pas difficile";
var OutcomeRatingOptionsSvc_DifficultySlightly = "Un peu difficile";
var OutcomeRatingOptionsSvc_DifficultySomewhat = "Assez difficile";
var OutcomeRatingOptionsSvc_DifficultyVery = "Tr\xe8s difficile";
var OutcomeRatingOptionsSvc_MasteryCapable = "Novice";
var OutcomeRatingOptionsSvc_MasteryDistinguished = "Distingu\xe9";
var OutcomeRatingOptionsSvc_MasteryEmerging = "En \xe9mergence";
var OutcomeRatingOptionsSvc_MasteryExperienced = "Exp\xe9riment\xe9";
var OutcomeRatingOptionsSvc_MasteryMaster = "Expert";
var OutcomeRatingOptionsSvc_MasteryNovice = "Novice";
var OutcomeRatingOptionsSvc_RelevancyMostly = "Pertinent dans l’ensemble";
var OutcomeRatingOptionsSvc_RelevancyNot = "Non pertinent";
var OutcomeRatingOptionsSvc_RelevancySlightly = "Peu pertinent";
var OutcomeRatingOptionsSvc_RelevancySomewhat = "Assez pertinent";
var OutcomeRatingOptionsSvc_RelevancyVery = "Tr\xe8s pertinent";
var OutcomeRatingOptionsSvc_SignificanceExtremely = "Extr\xeamement important";
var OutcomeRatingOptionsSvc_SignificanceNot = "Pas important";
var OutcomeRatingOptionsSvc_SignificanceSlightly = "Un peu important";
var OutcomeRatingOptionsSvc_SignificanceSomewhat = "Assez important";
var OutcomeRatingOptionsSvc_SignificanceVery = "Tr\xe8s important";
var OutcomeRatingOptionsSvc_SimilarityMostly = "Assez similaire";
var OutcomeRatingOptionsSvc_SimilarityNot = "Pas similaire";
var OutcomeRatingOptionsSvc_SimilaritySlightly = "Peu similaire";
var OutcomeRatingOptionsSvc_SimilaritySomewhat = "Plut\xf4t similaire";
var OutcomeRatingOptionsSvc_SimilarityVery = "Tr\xe8s similaire";
var OutcomeRatingOptionsSvc_SupportNeutral = "Moyen";
var OutcomeRatingOptionsSvc_SupportPoor = "Mauvais";
var OutcomeRatingOptionsSvc_SupportVeryPoor = "Tr\xe8s mauvais";
var OutcomeRatingOptionsSvc_SupportVeryWell = "Tr\xe8s bien";
var OutcomeRatingOptionsSvc_SupportWell = "Bien";
var Pagination_AriaLabelDefault = "Pagination";
var Pagination_GoToPageFormat = "Acc\xe9der \xe0 la page {{ number }}";
var Pagination_OfYFormat = "sur {{totalCount}}";
var Pagination_OfYResultsFormat = "r\xe9sultats sur {{totalCount}}";
var Pagination_ResultsOverview = "R\xe9sultats {{fromIndex}} \xe0 {{toIndex}} sur {{totalCount}}";
var PathwayActivity_OpportunityTitle = "Activit\xe9 de l’opportunit\xe9";
var PathwayActivity_PathwayTitle = "Activit\xe9 du parcours";
var PathwayActivity_PlanTitle = "Activit\xe9 du plan";
var PathwayActivity_SelectionAriaLabel = "S\xe9lection de filtres pour le graphique d’activit\xe9 du parcours";
var PathwayActivity_TooltipClickedApply = "{{ count }}\xa0utilisateurs ont cliqu\xe9 sur Postuler";
var PathwayActivity_TooltipCompletions = "{{ count }}\xa0utilisateurs ont termin\xe9 ce contenu.";
var PathwayActivity_TooltipEnroll = "{{ count }} utilisateurs inscrits.";
var PathwayActivity_TooltipFollow = "{{ count }}\xa0utilisateurs ont suivi ce contenu.";
var PathwayActivity_TooltipInterested = "{{ count }}\xa0utilisateurs int\xe9ress\xe9s.";
var PathwayActivity_TooltipTotalViews = "{{count}}\xa0vues au total.";
var PathwayActivity_TooltipViews = "{{ count }}\xa0utilisateurs ont vu ce contenu.";
var PathwayActivity_TooltipViewsTotal = "{{count}}\xa0vues au total.";
var PathwayActivity_TotalViews = "Vues totales";
var PathwayActivity_Users = "Utilisateurs";
var PathwayActivity_UsersViewed = "Utilisateurs ayant vu le contenu";
var pathwayAddEditModal_AddCollaborator = "Ajoutez des personnes qui collaboreront \xe0 ce parcours";
var pathwayAddEditModal_AddCollaborators = "+ Ajouter des collaborateurs";
var pathwayAddEditModal_AddPathway_Success = "Le parcours a bien \xe9t\xe9 ajout\xe9.";
var pathwayAddEditModal_Authors = "Collaborateurs du parcours";
var pathwayAddEditModal_BadgeEligibilityLabel = "Insigne d\xe9cern\xe9 en fin de parcours";
var pathwayAddEditModal_BadgeUuid = "UUID de l’insigne";
var pathwayAddEditModal_CloneOfPathwayFormat = "[Clone de] {{title}}";
var pathwayAddEditModal_CollaboratorsDescription = "Les collaborateurs pourront modifier ce parcours.";
var pathwayAddEditModal_ConfirmDelete = "Souhaitez-vous r\xe9ellement supprimer ce parcours ?";
var pathwayAddEditModal_CreatePathway = "Cr\xe9er un parcours";
var pathwayAddEditModal_DeletedFormat = "{{pathwayName}} a \xe9t\xe9 supprim\xe9.";
var pathwayAddEditModal_Description = "Description";
var pathwayAddEditModal_DescriptionDetail = "D\xe9crivez bri\xe8vement en quoi consiste le parcours.";
var pathwayAddEditModal_DescriptionLength = "La description du parcours ne doit pas d\xe9passer 2\xa0000\xa0caract\xe8res.";
var pathwayAddEditModal_DescriptionMissing = "Veuillez saisir une description valide.";
var pathwayAddEditModal_DoNotDisplayDuration = "Masquer la dur\xe9e estim\xe9e du parcours";
var pathwayAddEditModal_DoNotDisplayDurationNote = "Lorsque cette option est coch\xe9e, les parcours n’affichent pas la dur\xe9e estim\xe9e du parcours ou des sections.";
var pathwayAddEditModal_DoNotDisplayHeaderImage = "Ne pas afficher l’image d’en-t\xeate sur la page du parcours";
var pathwayAddEditModal_DoNotDisplayHeaderImageNote = "Lorsque cette option est coch\xe9e, l’image flout\xe9e du parcours n’appara\xeet pas dans l’en-t\xeate.";
var pathwayAddEditModal_EditPathway = "Modifier le parcours";
var pathwayAddEditModal_EndorsedByOrg = "Recommand\xe9";
var pathwayAddEditModal_EndorsedByOrgNote = "Si cette option est coch\xe9e, une ic\xf4ne de recommandation appara\xeetra sur la carte.";
var pathwayAddEditModal_EndorsedContentByOrgNote = "Les parcours recommand\xe9s et l’ensemble de leurs \xe9l\xe9ments de contenu sont mis en avant dans la liste des r\xe9sultats.";
var pathwayAddEditModal_ImagePreview = "Aper\xe7u de l’image du parcours";
var pathwayAddEditModal_NameLength = "Le nom du parcours ne doit pas d\xe9passer 255\xa0caract\xe8res.";
var pathwayAddEditModal_NameRequired = "Le nom du parcours doit \xeatre renseign\xe9.";
var pathwayAddEditModal_NeedCollaboratorPermission = "Au moins un collaborateur doit disposer de la permission \xc9diter les parcours.";
var pathwayAddEditModal_Or = "ou";
var pathwayAddEditModal_PathwayName = "Nom du parcours";
var pathwayAddEditModal_PathwayNameEg = "P. ex. Int\xe9gration des nouveaux collaborateurs";
var pathwayAddEditModal_PathwayPrimaryContact = "Contact principal pour le parcours";
var pathwayAddEditModal_PathwaySettingsChannelDesc = "Vous pouvez mettre \xe0 jour les permissions et les param\xe8tres ult\xe9rieurement.";
var pathwayAddEditModal_PathwaySettingsDesc = "Vous pourrez mettre \xe0 jour les autorisations et les param\xe8tres ult\xe9rieurement. Les collaborateurs ne pourront pas voir votre parcours, sauf si vous modifiez sa visibilit\xe9.";
var pathwayAddEditModal_PrimaryContactRequired = "Un contact principal est requis";
var pathwayAddEditModal_Remove = "supprimer";
var pathwayAddEditModal_SavePathway = "Enregistrer le parcours";
var pathwayAddEditModal_SavingPathway = "Enregistrement du parcours";
var pathwayAddEditModal_SearchCollaborators = "Rechercher des collaborateurs par nom";
var pathwayAddEditModal_SearchPeopleGroupsPlaceHolder = "Rechercher une personne ou un groupe";
var pathwayAddEditModal_ShowPathwayContentRating = "Afficher l’\xe9valuation du contenu du parcours";
var pathwayAddEditModal_ShowPathwayContentRatingNote = "Lorsque cette option est coch\xe9e, les apprenants ont la possibilit\xe9 d’\xe9valuer le contenu du parcours.";
var pathwayAddEditModal_TitleofPathway = "Intitul\xe9 du parcours dans la galerie";
var pathwayAddEditModal_VisibleToOrg = "Autoriser les collaborateurs \xe0 publier ce parcours dans l’organisation";
var pathwayAddEditModal_VisibleToOrgWarning = "Si cette option est coch\xe9e, les utilisateurs disposant de l’autorisation G\xe9rer les parcours peuvent afficher ou modifier celui-ci.";
var PathwayEnrollmentSource_AmountSent = "Total envoy\xe9";
var PathwayEnrollmentSource_Assignments = "Formations assign\xe9es";
var PathwayEnrollmentSource_BusinessRules = "R\xe8gles m\xe9tier";
var PathwayEnrollmentSource_OtherTooltip = "Utilisateurs qui suivent le parcours apr\xe8s avoir effectu\xe9 une recherche, parcouru le site ou cliqu\xe9 sur un lien non tra\xe7able.";
var PathwayEnrollmentSource_Title = "Source de suivi";
var PathwayEnrollmentSource_TrackableLinks = "Liens tra\xe7ables";
var PathwayPrivacyModal_BulkChangeVisibility = "Changer la visibilit\xe9 de 1 parcours";
var PathwayPrivacyModal_BulkChangeVisibilityPlural = "Changer la visibilit\xe9 de {{count}} parcours";
var PathwayPrivacyModal_ChangeVisibility = "Changer la visibilit\xe9 de {{title}}";
var PathwayPrivacyModal_ConfirmationModalBody = "Il ne vous sera plus possible de g\xe9rer ce parcours ou de le retrouver dans la liste des parcours de votre organisation. Cette action peut \xeatre annul\xe9e uniquement par les collaborateurs du parcours. Souhaitez-vous r\xe9ellement effectuer cette action ?";
var PathwayPrivacyModal_ConfirmationModalConfirm = "modifier la visibilit\xe9";
var PathwayPrivacyModal_ConfirmationModalHeader = "Modifier la visibilit\xe9 du parcours";
var PathwayPrivacyModal_EditSettings = "Modifier les param\xe8tres du parcours";
var PathwayPrivacyModal_FoundWhere = "Visibilit\xe9";
var PathwayPrivacyModal_OnlySetGroups = "Seuls ces groupes verront ce parcours dans la galerie de parcours";
var PathwayPrivacyModal_OnlySetGroupsToolTip = "Les autres groupes pourront encore \xeatre invit\xe9s \xe0 rejoindre ce groupe \xe0 titre de recommandation, etc.";
var PathwayPrivacyModal_SaveVisibility = "Enregistrer la visibilit\xe9";
var PathwayPrivacyModal_SelectAGroupError = "Veuillez rechercher et s\xe9lectionner un groupe.";
var PathwayPrivacyModal_TargetGroups = "Cibler ces groupes (facultatif)";
var PathwayPrivacyModal_TargetGroupsDirectoryToolTip = "Ces groupes pourront retrouver plus facilement ce r\xe9pertoire";
var PathwayPrivacyModal_TargetGroupsPlanToolTip = "Ces groupes pourront retrouver plus facilement ce plan";
var PathwayPrivacyModal_TargetGroupsToolTip = "Ces groupes pourront retrouver plus facilement ce parcours.";
var Pathways_A11yItemsReordered = "Les \xe9l\xe9ments ont \xe9t\xe9 r\xe9organis\xe9s au niveau de la le\xe7on.";
var Pathways_A11yLessonsReordered = "Les le\xe7ons ont \xe9t\xe9 r\xe9organis\xe9es au niveau du cours.";
var Pathways_A11ySectionsReordered = "Les sections ont \xe9t\xe9 r\xe9organis\xe9es sur la page.";
var Pathways_AddANote = "Ajouter une note pour les apprenants";
var Pathways_AddAuthorNote = "Ajouter une note de l’auteur";
var Pathways_AddByType = "Ajouter par type";
var Pathways_AddContent = "Ajouter du contenu";
var Pathways_AddContentItemsSuccess = "\xc9l\xe9ments de contenu ajout\xe9s";
var Pathways_AddContentItemSuccess = "\xc9l\xe9ment de contenu ajout\xe9";
var Pathways_AddingInputTypeError = "D\xe9sol\xe9 ! Il y a eu un probl\xe8me en ajoutant {{inputType}} au parcours.";
var Pathways_AddItemError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’ajout de l’\xe9l\xe9ment au parcours.";
var Pathways_AddItemPermissionError = "D\xe9sol\xe9s\xa0! Cet \xe9l\xe9ment n’a pas pu \xeatre ajout\xe9 au parcours s\xe9lectionn\xe9. Il est possible que cet \xe9l\xe9ment soit sp\xe9cifique \xe0 une organisation ou que vous ne disposiez pas des autorisations n\xe9cessaires.";
var Pathways_AdditionalContentSuccess = "Marqu\xe9 comme Contenu suppl\xe9mentaire";
var Pathways_AddLesson = "Ajouter une le\xe7on";
var Pathways_AddLessonError = "Un probl\xe8me est survenu lors de l’ajout de la le\xe7on du parcours.";
var Pathways_AddOneItem = "Ajouter 1\xa0\xe9l\xe9ment";
var Pathways_AddSection = "Ajouter une section";
var Pathways_AddSectionError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’ajout de la section du parcours.";
var Pathways_AddSubsection = "Cr\xe9er une sous-section";
var Pathways_AddXItems = "Ajouter {{count}}\xa0\xe9l\xe9ments";
var Pathways_Article = "Article";
var Pathways_Assessment = "Test d’\xe9valuation";
var Pathways_AuthorAccessError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’acc\xe8s aux informations de l’auteur du parcours.";
var Pathways_AuthoredPathwayError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’acc\xe8s aux parcours dont vous \xeates l’auteur.";
var Pathways_BackButton = "Revenir aux parcours";
var Pathways_BackToBrowse = "Retour \xe0 Parcourir";
var Pathways_Bin = "Stock\xe9s temporairement";
var Pathways_Book = "Livre";
var Pathways_Collaborators = "Collaborateurs\xa0";
var Pathways_CollapseLesson = "Masquer la le\xe7on";
var Pathways_CollapseLessons = "R\xe9duire la liste des le\xe7ons";
var Pathways_CompletedColumn = "Compl\xe9tion";
var Pathways_CompletedItemsFormat = "{{totalCompletedItems}} \xe9l\xe9ment(s) termin\xe9(s) sur {{totalItems}}";
var Pathways_CompletionNotificationModalTitle = "Avez-vous termin\xe9 des \xe9l\xe9ments du parcours {{pathwayName}}\xa0?";
var Pathways_ConfirmCompletions = "Confirmer les \xe9l\xe9ments termin\xe9s";
var Pathways_ConfirmDeleteLesson = "Voulez-vous vraiment supprimer cette le\xe7on\xa0? Son contenu sera d\xe9plac\xe9 vers l’onglet Stock\xe9s temporairement.";
var Pathways_ConfirmDeleteSubsection = "Voulez-vous vraiment supprimer cette sous-section\xa0? Son contenu sera d\xe9plac\xe9 vers l’onglet \xab\xa0Stock\xe9s temporairement\xa0\xbb.";
var Pathways_ConfirmRemoveItem = "Voulez-vous vraiment supprimer cet \xe9l\xe9ment \xa0? Il sera d\xe9plac\xe9 vers l’onglet Stock\xe9s temporairement.";
var Pathways_ConfirmRemoveSection = "La suppression d’une section entra\xeene la suppression de ses sous-sections et place les \xe9l\xe9ments de contenu dans l’onglet Stock\xe9s temporairement. Voulez-vous vraiment supprimer cette section \xa0?";
var Pathways_Course = "Cours";
var Pathways_CreatedSection = "La section a \xe9t\xe9 cr\xe9\xe9e.";
var Pathways_CreatedSubsection = "La sous-section a \xe9t\xe9 cr\xe9\xe9e.";
var Pathways_CreateSection = "Cr\xe9er une section";
var Pathways_DeletedSection = "La section a \xe9t\xe9 supprim\xe9e.";
var Pathways_DeletedSubsection = "La sous-section a bien \xe9t\xe9 supprim\xe9e";
var Pathways_DeleteError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la suppression du parcours.";
var Pathways_DeleteItem = "Supprimer";
var Pathways_DeleteitemError = "D\xe9sol\xe9s\xa0! Un probl\xe8me est survenu lors de la suppression de l’\xe9l\xe9ment du parcours.";
var Pathways_DeleteLesson = "Supprimer la le\xe7on";
var Pathways_DeletelessonError = "D\xe9sol\xe9s\xa0! Un probl\xe8me est survenu lors de la suppression de la sous-section du parcours.";
var Pathways_DeleteNote = "Supprimer la note";
var Pathways_DeletePathwayBody = "Voulez-vous vraiment supprimer ce parcours ? <br> Cette action est irr\xe9versible.";
var Pathways_DeleteSection = "Supprimer la section";
var Pathways_DeletesectionError = "D\xe9sol\xe9s\xa0! Un probl\xe8me est survenu lors de la suppression de la section du parcours.";
var Pathways_DeleteStepError = "D\xe9sol\xe9s\xa0! Un probl\xe8me est survenu lors de la suppression de l’\xe9l\xe9ment du parcours.";
var Pathways_DeleteSubsection = "Supprimer la sous-section";
var Pathways_Description = "Description du parcours";
var Pathways_DescriptionPlaceholder = "La description du parcours se place ici";
var Pathways_EditCatalogItemHelper = "Les modifications de cet \xe9l\xe9ment s’appliqueront au catalogue de contenus de votre organisation.";
var Pathways_Edited = "Modifi\xe9";
var Pathways_EditingDescription = "Les modifications apport\xe9es ici seront appliqu\xe9es uniquement \xe0 ce parcours.";
var Pathways_EditLocalContentHelper = "Les modifications apport\xe9es \xe0 ce contenu s’appliqueront seulement dans ce parcours.";
var Pathways_EditPathway = "Modifier le parcours";
var Pathways_EditPermissionError = "D\xe9sol\xe9 ! Pour cr\xe9er les parcours de l’organisation sp\xe9cifi\xe9e, vous devez d\xe9tenir l’autorisation Modifier les parcours. Si vous modifiez les collaborateurs, au moins l’un d’entre eux doit disposer de l’autorisation Modifier les parcours.";
var Pathways_EmptyBinMessage = "Ici, vous pouvez stocker des \xe9l\xe9ments pour une utilisation ult\xe9rieure. Ajoutez un \xe9l\xe9ment ici en cliquant sur l’option \xab\xa0d\xe9placer vers\xa0\xbb.";
var Pathways_EnrollError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de votre inscription au parcours.";
var Pathways_Episode = "\xc9pisode";
var Pathways_ErrorMessage = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de cette action. Ce n’est pas votre faute et nous mettons tout en œuvre pour r\xe9soudre le probl\xe8me.";
var Pathways_Event = "\xc9v\xe9nement";
var Pathways_ExistingContentTypeError = "Vous ne pouvez pas ajouter un \xe9l\xe9ment existant comme type de contenu diff\xe9rent.";
var Pathways_ExpandLesson = "Afficher la liste des le\xe7ons";
var Pathways_FeedbackAverage = "Average";
var Pathways_FeedbackCommentsPlaceholder = "Write your comments here";
var Pathways_FeedbackCommentsTitle = "What did you like or dislike about this content?";
var Pathways_FeedbackDescription = "Help us improve this pathway by reviewing the quality of the content you just completed.";
var Pathways_FeedbackExcellent = "Excellent";
var Pathways_FeedbackGood = "Good";
var Pathways_FeedbackOverallRating = "How would you rate the overall content quality in this pathway?";
var Pathways_FeedbackPoor = "Poor";
var Pathways_FeedbackSubmit = "Submit Feedback";
var Pathways_FeedbackSubmitted = "Feedback Submitted!";
var Pathways_FeedbackSubmittedDescription = "Thank you for your feedback! Our curation team will carefully review your input to help us improve this pathway. We appreciate your contribution and are dedicated to providing the best content possible. Stay tuned for updates!";
var Pathways_FeedbackTitle = "Rate Your Learning Experience";
var Pathways_FeedbackVeryGood = "Very Good";
var Pathways_FollowedDate = "Date de suivi";
var Pathways_FollowError = "Un probl\xe8me est survenu lors du suivi du parcours.";
var Pathways_Followers = "Abonn\xe9s";
var Pathways_Following = "Abonn\xe9";
var Pathways_FollowingCountFormat = "{{count}}\xa0abonnement(s)";
var Pathways_GetItemsError = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration de vos \xe9l\xe9ments de parcours.";
var Pathways_HoldForLater = "Stock\xe9s temporairement";
var Pathways_HoldForLaterError = "Un probl\xe8me est survenu lors du transfert des \xe9l\xe9ments vers l’onglet Stock\xe9s temporairement.";
var Pathways_Insights = "Statistiques";
var Pathways_ItemCountFormat = "{{count}}\xa0\xe9l\xe9ments";
var Pathways_ItemCountSingular = "1\xa0\xe9l\xe9ment";
var Pathways_ItemSavedFormat = "{{title}} a \xe9t\xe9 enregistr\xe9\xa0!";
var Pathways_ItemsReordered = "Les \xe9l\xe9ments ont \xe9t\xe9 r\xe9organis\xe9s au niveau de la sous-section.";
var Pathways_LessonCountFormat = "{{count}}\xa0le\xe7ons";
var Pathways_LessonCountSingular = "1\xa0le\xe7on";
var Pathways_LessonDescriptionLabel = "Description de la le\xe7on";
var Pathways_LessonDescriptionPlaceholder = "La description de la le\xe7on se place ici.";
var Pathways_LessonItemsAllOptional = "Cette section contient uniquement des \xe9l\xe9ments de formation suppl\xe9mentaires, non obligatoires pour votre parcours.";
var Pathways_LessonLabelFormat = "Le\xe7on {{number}}";
var Pathways_LessonNumberFormat = "Le\xe7on {{number}}";
var Pathways_LessonTitleLabel = "Intitul\xe9 de la le\xe7on";
var Pathways_LessonTitlePlaceholder = "L’intitul\xe9 de la le\xe7on se place ici.";
var Pathways_MakeFeatureNotification = "Le parcours a bien \xe9t\xe9 ajout\xe9 sur la page \xc0 la une.";
var Pathways_MakeOptional = "Marquer comme apprentissage suppl\xe9mentaire";
var Pathways_MakeRequired = "Supprimer en tant qu’apprentissage suppl\xe9mentaire";
var Pathways_MarkAsOptional = "Marquer comme facultatif";
var Pathways_MarkAsRequired = "Marquer comme obligatoire";
var Pathways_MoveConfirmationMessage = "Ceci aura pour effet de d\xe9placer d\xe9finitivement le parcours du catalogue de l’organisation au catalogue global.";
var Pathways_MovedItem = "L’\xe9l\xe9ment a bien \xe9t\xe9 d\xe9plac\xe9.";
var Pathways_MovedLesson = "La le\xe7on a \xe9t\xe9 d\xe9plac\xe9e.";
var Pathways_MovedSubsection = "La sous-section a bien \xe9t\xe9 d\xe9plac\xe9e";
var Pathways_MovedToHoldForLater = "\xc9l\xe9ments d\xe9plac\xe9s vers l’onglet Stock\xe9s temporairement.";
var Pathways_MoveItem = "D\xe9placer vers...";
var Pathways_MoveItemError = "D\xe9sol\xe9\xa0! Une erreur s’est produite lors du d\xe9placement des \xe9l\xe9ments du parcours.";
var Pathways_MoveItemTo = "D\xe9placer l’\xe9l\xe9ment vers";
var Pathways_MoveLessonError = "Une erreur s’est produite lors du d\xe9placement des le\xe7ons du parcours.";
var Pathways_MoveLessonTo = "D\xe9placer la le\xe7on vers";
var Pathways_MoveSectionError = "D\xe9sol\xe9\xa0! Une erreur s’est produite lors du d\xe9placement des sections du parcours.";
var Pathways_MoveSubsectionError = "D\xe9sol\xe9s\xa0! Un probl\xe8me est survenu lors du d\xe9placement des sous-sections du parcours.";
var Pathways_MoveSuccessMessage = "Le parcours a bien \xe9t\xe9 d\xe9plac\xe9\xa0!";
var Pathways_MoveWarningHostedContent = "This will remove hosted content from the pathway.";
var Pathways_NewPathwayItemsNotification = "{{newItems}} ont \xe9t\xe9 ajout\xe9s au parcours\xa0{{pathwayTitle}}.";
var Pathways_NoAccessDescriptionText = "Vous n’avez pas acc\xe8s \xe0 cette page.<br> Si vous pensez qu’il s’agit d’une erreur, veuillez contacter notre \xe9quipe d’assistance.";
var Pathways_NoAccessHeaderText = "Oups\xa0!";
var Pathways_NoGroup = "aucun groupe";
var Pathways_NoteFromAuthor = "Note de l’auteur";
var Pathways_OptionalContent = "Apprentissage suppl\xe9mentaire";
var Pathways_OptionalContentTooltip = "N’a pas d’impact n\xe9gatif sur l’\xe9volution du parcours";
var Pathways_OptionalItemCountFormat = "{{count}}\xa0\xe9l\xe9ments facultatifs";
var Pathways_OptionalItemCountSingular = "1\xa0\xe9l\xe9ment facultatif";
var Pathways_OrgManagedNotification = "L’ajout d’\xe9l\xe9ments g\xe9r\xe9s par l’organisation fera de ce parcours un parcours g\xe9r\xe9 par l’organisation.";
var Pathways_OutOfDate = "Le parcours est obsol\xe8te.";
var Pathways_Pathway = "Parcours";
var Pathways_PathwayAccessError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’acc\xe8s aux parcours.";
var Pathways_PathwayDetailAccessError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’acc\xe8s aux d\xe9tails du parcours.";
var Pathways_PathwayInfoAccessError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’acc\xe8s aux informations du parcours.";
var Pathways_PathwayItemError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’acc\xe8s aux \xe9l\xe9ments du parcours.";
var Pathways_PathwayPrivateMessage = "Ce parcours est priv\xe9.<br>Pour le partager, rendez-le visible dans les param\xe8tres de parcours.";
var Pathways_Post = "Publication";
var Pathways_PrivacyCollaborators = "Restreint aux collaborateurs";
var Pathways_PrivacyGroupName = "Visible par {{groupName}}";
var Pathways_PrivacyGroups = "Visible par {{groupLength}}\xa0groupes";
var Pathways_PrivacyOrg = "Visible par l’organisation";
var Pathways_PrivacyOwner = "Visible uniquement par vous-m\xeame";
var Pathways_PrivacyProfile = "Visible sur votre profil";
var Pathways_PrivatePathway = "<p>Ce parcours est priv\xe9.<br>Pour le partager, rendez-le visible dans les param\xe8tres de parcours.</p>";
var Pathways_RefreshForLatestChange = "Veuillez actualiser cette page pour mettre \xe0 jour ce parcours avec les derniers changements.";
var Pathways_RemoveFeaturedNotification = "Le parcours est supprim\xe9 de la page \xc0 la une.";
var Pathways_RemoveItemError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la suppression de l’\xe9l\xe9ment.";
var Pathways_ReorderedSections = "Les sections ont \xe9t\xe9 r\xe9organis\xe9es.";
var Pathways_ReorderItemError = "D\xe9sol\xe9s\xa0! Un probl\xe8me est survenu lors du d\xe9placement des \xe9l\xe9ments du parcours.";
var Pathways_ReorderItems = "R\xe9organiser les \xe9l\xe9ments";
var Pathways_ReorderItemsTitleFormat = "R\xe9organiser les \xe9l\xe9ments de la le\xe7on {{lessonNumber}}";
var Pathways_ReorderLessonError = "D\xe9sol\xe9s\xa0! Un probl\xe8me est survenu lors du d\xe9placement des sous-sections.";
var Pathways_ReorderLessons = "R\xe9organiser les le\xe7ons";
var Pathways_ReorderLessonsTitleFormat = "R\xe9organiser les le\xe7ons de la section {{sectionNumber}}";
var Pathways_ReorderSections = "R\xe9organiser les sections";
var Pathways_ReorderSubsectionItemsTitleFormat = "R\xe9organiser les \xe9l\xe9ments de la sous-section {{lessonNumber}}";
var Pathways_ReorderSubsections = "R\xe9organiser les sous-sections";
var Pathways_ReorderSubsectionsTitleFormat = "R\xe9organiser les sous-sections de la section {{sectionNumber}}";
var Pathways_RequiredContentSuccess = "Marqu\xe9 comme Contenu requis";
var Pathways_RestoreToOriginal = "R\xe9initialiser";
var Pathways_SaveError = "D\xe9sol\xe9s ! Un probl\xe8me est survenu lors de l’enregistrement des modifications.";
var Pathways_SearchCatalog = "Rechercher dans le catalogue";
var Pathways_SearchError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration des r\xe9sultats.";
var Pathways_SectionCountFormat = "{{count}}\xa0sections";
var Pathways_SectionDescLimit = "Saisissez jusqu’\xe0 2\xa0000\xa0caract\xe8res. Un lien <strong>En savoir plus</strong> est affich\xe9 apr\xe8s les 180\xa0premiers caract\xe8res.";
var Pathways_SectionDescriptionLabel = "Description de la section\xa0: section num\xe9ro {{ sectionNumber }}";
var Pathways_SectionDescriptionPlaceholder = "La description de la section se place ici.";
var Pathways_sectionLabelFormat = "Section {{n}}";
var Pathways_SectionNumberFormat = "Section {{number}}";
var Pathways_SectionNumberTitleFormat = "Section {{sectionNumber}} {{sectionTitle}}";
var Pathways_SectionTitleLabel = "Titre de la section\xa0: section num\xe9ro {{ sectionNumber }}";
var Pathways_SectionTitlePlaceholder = "Titre de la section";
var Pathways_SelectACatalog = "S\xe9lectionner un catalogue";
var Pathways_SetPathwayNameError = "D\xe9sol\xe9, un parcours portant ce nom existe d\xe9j\xe0. Veuillez choisir un autre nom.";
var Pathways_ShowMoreLessons = "Encore {{count}}\xa0le\xe7ons";
var Pathways_ShowOneMoreLesson = "Encore 1\xa0le\xe7on";
var Pathways_SubsectionCountFormat = "{{count}}\xa0sous-sections";
var Pathways_SubsectionCountSingular = "1\xa0sous-section";
var Pathways_SubsectionDescriptionLabel = "Description de la sous-section\xa0: section num\xe9ro {{ sectionNumber }}, sous-section num\xe9ro {{ subsectionNumber }}";
var Pathways_SubsectionDescriptionPlaceholder = "La description de la sous-section se place ici";
var Pathways_SubsectionNumberFormat = "Sous-section\xa0{{number}}";
var Pathways_SubsectionsReordered = "Les sous-sections ont \xe9t\xe9 r\xe9organis\xe9es au niveau du cours.";
var Pathways_SubsectionTitleLabel = "Titre de la sous-section\xa0: section num\xe9ro {{ sectionNumber }}, sous-section num\xe9ro {{ subsectionNumber }}";
var Pathways_SubsectionTitlePlaceholder = "Le titre de la sous-section se place ici";
var Pathways_Task = "T\xe2che";
var Pathways_Title = "Nom du parcours";
var Pathways_TitlePlaceholder = "Le nom du parcours se place ici";
var Pathways_UnfollowError = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de l’annulation du suivi du parcours.";
var Pathways_UntitledLesson = "Sous-section sans titre";
var Pathways_UntitledSection = "Section sans titre";
var Pathways_UpdateError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la mise \xe0 jour du parcours.";
var Pathways_UpdateVisibilityError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la mise \xe0 jour de la visibilit\xe9 du parcours.";
var Pathways_Video = "Vid\xe9o";
var Pathways_WithdrawFromPathway = "Voulez-vous vraiment cesser de suivre ce parcours \xa0?";
var Pathways_WithdrawFromPathwayBody = "Le contenu de ce parcours n’appara\xeetra plus dans votre flux.";
var PathwaySectionsChart_CompletedTooltipFormat = "Termin\xe9 \xe0 {{percentage}}\xa0%";
var PathwaySectionsChart_EnrolledTooltipFormat = "{{percentage}}\xa0% sont inscrits";
var PathwaySectionsChart_FollowingTooltipFormat = "{{percentage}}\xa0% sont abonn\xe9s";
var PathwaySectionsChart_NoData = "Ajoutez des parcours \xe0 cette section pour analyser leurs performances.";
var PathwaySectionsChart_Started = "D\xe9marr\xe9";
var PathwaySectionsChart_StartedTooltipFormat = "{{percentage}}\xa0% ont d\xe9marr\xe9";
var PathwaySectionsChart_Title = "Pourcentage d’abonn\xe9s au plan";
var PathwaysLayout_Enrollees = "Inscrits";
var PathwayTopContent_Empty = "Ajoutez du contenu \xe0 cette section pour analyser ses performances.";
var PathwayTopContent_Title = "Contenu le plus populaire";
var PathwayTopContent_ViewAllContext = "Afficher tout le contenu le plus populaire";
var PeopleCtrl_AllPeople = "Tout le monde";
var PersonalSkillView_AddSkill = "Ajouter une comp\xe9tence";
var PersonalSkillView_AddSkillInstructions = "Vous pouvez auto-\xe9valuer cette comp\xe9tence ou l’ajouter sans \xe9valuation. Votre \xe9valuation peut \xeatre modifi\xe9e \xe0 tout moment.";
var PersonalSkillView_AddTarget = "Ajouter une cible";
var PersonalSkillView_AllSkills = "Toutes les comp\xe9tences";
var PersonalSkillView_AverageRating = "\xc9valuation moyenne";
var PersonalSkillView_EvaluationRating = "Revue de comp\xe9tence";
var PersonalSkillView_FindSkillContent = "Rechercher du contenu sur la comp\xe9tence";
var PersonalSkillView_FocusSkill = "Comp\xe9tence prioritaire";
var PersonalSkillView_FocusSkills = "Comp\xe9tences prioritaires";
var PersonalSkillView_LastUpdated = "Derni\xe8re \xe9valuation le";
var PersonalSkillView_ManagerRating = "\xc9valuation du manager";
var PersonalSkillView_ManagerRatingFormat = "\xc9valuations du manager pour {{skill}}\xa0: {{rating}}";
var PersonalSkillView_NoSkills = "{{teamMemberName}} n’a pas encore ajout\xe9 de comp\xe9tences \xe0 son profil";
var PersonalSkillView_RequestSelfRating = "Demander une auto-\xe9valuation";
var PersonalSkillView_RequestSelfRating_Title = "Demander une auto-\xe9valuation pour \xab\xa0{{ skillTitle }}\xa0\xbb";
var PersonalSkillView_Search_Placeholder = "Rechercher une comp\xe9tence";
var PersonalSkillView_SelfRating = "Auto-\xe9valuation";
var PersonalSkillView_SelfRatingFormat = "Auto-\xe9valuation pour {{skill}}\xa0: {{rating}}";
var PersonalSkillView_SkillDescription = "Description de la comp\xe9tence";
var PersonalSkillView_SkillProgression = "Progression des comp\xe9tences";
var PersonalSkillView_SkillProgressionChartSubtitle1 = 'Ajoutez et \xe9valuez vos comp\xe9tences prioritaires dans <a href="{{ personalSkillProfile }}" class="link">votre profil de comp\xe9tences</a> pour consulter ces statistiques';
var PersonalSkillView_SkillProgressionChartSubtitle2 = "\xc9valuations de votre comp\xe9tence au fil du temps";
var PersonalSkillView_SkillProgressionChartSubtitle3 = 'Ajoutez et \xe9valuez vos comp\xe9tences dans <a href="{{ personalSkillProfile }}" class="link">votre profil de comp\xe9tences</a> pour consulter ces statistiques';
var PersonalSkillView_SkillReviewFormat = "Revue de comp\xe9tence pour {{skill}}\xa0: {{rating}}";
var PersonalSkillView_SkillTarget = "Cible de la comp\xe9tence";
var PersonalSkillView_SkillTargetFormat = "Cible de la comp\xe9tence {{skill}}\xa0: {{rating}}";
var PersonalSkillView_SkillTargetJobTargetFormat = "Niveau cible du poste\xa0: {{level}}";
var PersonalSkillView_SkillTargetModalTitle = "D\xe9finir une \xe9valuation cible";
var PersonalSkillView_SkillTargetModalTitleFormat = "D\xe9finir une cible de la comp\xe9tence pour \xab\xa0{{skill}}\xa0\xbb";
var PersonalSkillView_TeamFocusSkills = "Comp\xe9tences prioritaires pour l’\xe9quipe";
var PersonalSkillView_Top10SkillsAddSkill = "Avez-vous cette comp\xe9tence\xa0? Ajoutez-la\xa0!";
var PersonalSkillView_Top10SkillsAvgRating = "Ajoutez votre \xe9valuation pour d\xe9couvrir la moyenne";
var PersonalSkillView_Top10SkillsSubtitle1 = "Vous pourrez uniquement consulter la note moyenne des comp\xe9tences que vous avez ajout\xe9es et \xe9valu\xe9es.";
var PersonalSkillView_Top10SkillsSubtitle2 = "Il n’y a pas assez de donn\xe9es pour recueillir ces statistiques.";
var PersonalSkillView_Top10SkillsSubtitle3 = "Il n’y a pas assez d’utilisateurs occupant votre poste pour recueillir ces statistiques.";
var PersonalSkillView_Top10SkillsSubtitle4 = 'Ajoutez votre poste dans les <a href="{{ profileSettings }}" class="link">param\xe8tres du profil</a> pour afficher ces statistiques.';
var PersonalSkillView_Top10SkillsTitle1 = "{{ count }} comp\xe9tences principales pour mon poste";
var PersonalSkillView_Top10SkillsTitle2 = "Comp\xe9tences principales pour mon poste";
var PersonalSkillView_YourRating = "Votre \xe9valuation";
var PlanDropdown_ChoosePlan = "Choisissez votre plan";
var PlanDropdown_FollowPlan = "Trouvez un plan \xe0 suivre";
var PlanDropdown_NoPrimaryPlan = "Vous n’avez pas encore de plan principal. S\xe9lectionnez un plan d’apprentissage dans le menu Choisissez votre plan pour le d\xe9finir comme votre plan principal.";
var PlanDropdown_PrimaryPlanTooltip = "Votre plan principal";
var PlanDropdown_Title = "Vos plans";
var PlanTagList_NoTags = "Ce plan ne comporte aucune comp\xe9tence.";
var PlanTagList_ShowAllTags = "Afficher toutes les comp\xe9tences...";
var PlanTagList_ViewPlan = "Voir le plan";
var PlanTagList_ViewSkillsInPlan = "Afficher toutes les comp\xe9tences du plan";
var PositionFormCtrl_AddCategory = "Veuillez ajouter au moins une cat\xe9gorie.";
var PositionFormCtrl_AddExperience = "Ajouter une exp\xe9rience";
var PositionFormCtrl_AverageHours = "Veuillez indiquer votre nombre moyen d’heures travaill\xe9es chaque semaine.";
var PositionFormCtrl_CompanyOrg = "Entreprise ou organisation";
var PositionFormCtrl_CurrentPosition = "J’occupe actuellement ce poste";
var PositionFormCtrl_DescribeExperience = "D\xe9crivez votre exp\xe9rience";
var PositionFormCtrl_Description = "Description";
var PositionFormCtrl_EditExperience = "Modifier l’exp\xe9rience";
var PositionFormCtrl_EndAfterStart = "La date de fin doit avoir lieu apr\xe8s la date de d\xe9but.";
var PositionFormCtrl_EndDate = "Date de fin";
var PositionFormCtrl_EndDateError = "Veuillez indiquer la date de fin de cette exp\xe9rience.";
var PositionFormCtrl_ExpDescriptionLength = "Experience description must be 5000 characters or less.";
var PositionFormCtrl_ExperienceTitle = "Intitul\xe9 de l’exp\xe9rience";
var PositionFormCtrl_HoursPerWeek = "Heures par semaine";
var PositionFormCtrl_IntermediatePosition = "Interm\xe9diaire";
var PositionFormCtrl_JuniorPosition = "Junior";
var PositionFormCtrl_MenteeName = "Nom du mentor\xe9";
var PositionFormCtrl_MentorName = "Nom du mentor";
var PositionFormCtrl_Organization = "Organisation";
var PositionFormCtrl_PositionTitle = "Intitul\xe9 du poste";
var PositionFormCtrl_RequiredOrg = "Le nom de l’organisation doit \xeatre renseign\xe9.";
var PositionFormCtrl_RequiredTitle = "L’intitul\xe9 doit \xeatre renseign\xe9.";
var PositionFormCtrl_SaveExperience = "Enregistrer l’exp\xe9rience";
var PositionFormCtrl_SelectType = "S\xe9lectionner un type";
var PositionFormCtrl_Seniority = "Anciennet\xe9";
var PositionFormCtrl_SeniorPosition = "Senior";
var PositionFormCtrl_StartDate = "Date de d\xe9but";
var PositionFormCtrl_StartDateError = "Veuillez indiquer la date de d\xe9but de cette exp\xe9rience.";
var PositionFormCtrl_Title = "Titre";
var PositionFormCtrl_WholeWeekHours = "Nombres entiers uniquement";
var PostFormCtrl_AnotherPathway = "un autre parcours";
var PostFormCtrl_AreYouSure = "Les modifications que vous avez apport\xe9es seront perdues. Voulez-vous vraiment fermer ?";
var PostFormCtrl_ClonedEditMessage = "Cette publication a \xe9t\xe9 initialement cr\xe9\xe9e dans {{pathwayName}}. Le parcours que vous modifiez a \xe9t\xe9 clon\xe9 \xe0 partir du parcours original et ses publications peuvent uniquement \xeatre modifi\xe9es dans le contexte du parcours original.";
var PostFormCtrl_Content = "Contenu";
var PostFormCtrl_CreatePost = "Cr\xe9er une publication";
var PostFormCtrl_CreatePostSave = "Publication";
var PostFormCtrl_EditingDescription = "Les modifications apport\xe9es \xe0 cette publication affecteront les parcours clon\xe9s dans lesquelles elle appara\xeet.";
var PostFormCtrl_EditPost = "Modifier la publication";
var PostFormCtrl_EditPostSave = "Enregistrer";
var PostFormCtrl_Title = "Titre";
var PostFormCtrl_TitleLength = "Le titre ne doit pas d\xe9passer 255\xa0caract\xe8res.";
var PostFormCtrl_TitleRequired = "L’intitul\xe9 doit \xeatre renseign\xe9.";
var PrePay_CertificateApplication = "Demande de certificat";
var PrePay_ChooseSkill = "Choisir une comp\xe9tence";
var PrePay_Payment = "Paiement";
var PrePay_YourInformation = "Vos informations";
var primaryPlanSelectionModal_YesContinue = "Oui, continuer";
var problemModalContent_4xxOr5xxError = "Une erreur 4xx ou 5xx s’affiche";
var problemModalContent_AccessDenied = "Je n’ai pas l’autorisation d’acc\xe9der \xe0 cet \xe9l\xe9ment";
var problemModalContent_AdditionalDetails = "D\xe9tails suppl\xe9mentaires";
var problemModalContent_AdditionalDetailsPlaceholder = "Expliquez-nous votre probl\xe8me";
var problemModalContent_ApplicationQuestions = "J’ai des questions sur cette candidature";
var problemModalContent_ApplicationTroubleCompleting = "Je rencontre des difficult\xe9s pour finaliser cette candidature";
var problemModalContent_AttachScreenshot = "Joindre une capture d’\xe9cran";
var problemModalContent_BrokenLink = "Je ne peux pas acc\xe9der au lien ou le lien ne fonctionne pas";
var problemModalContent_BrowserBlocked = "Ce contenu ne charge pas (navigateur/site bloqu\xe9)";
var problemModalContent_ChangeGroupVisibility = "Je souhaite modifier la visibilit\xe9 de ce groupe";
var problemModalContent_ChangingProfile = "J’essaie de modifier quelque chose sur mon profil";
var problemModalContent_CompletedOverdueSeveralDays = "J’ai valid\xe9 ce contenu il y a plusieurs jours, mais l’\xe9ch\xe9ance appara\xeet toujours comme d\xe9pass\xe9e";
var problemModalContent_CompletedOverdueToday = "J’ai valid\xe9 ce contenu aujourd’hui, mais l’\xe9ch\xe9ance appara\xeet toujours comme d\xe9pass\xe9e";
var problemModalContent_ContactPermission = "Je vous autorise \xe0 me contacter pour toute question compl\xe9mentaire";
var problemModalContent_ContentDurationIncorrect = "La dur\xe9e de ce contenu n’est pas correcte";
var problemModalContent_ContentInappropriate = "Ce contenu est inappropri\xe9";
var problemModalContent_ContentMisassigned = "Ce contenu n’aurait pas d\xfb m’\xeatre attribu\xe9";
var problemModalContent_ContentNotAppropriateForWorkplace = "Ce contenu ne convient pas \xe0 un environnement professionnel";
var problemModalContent_ContentNotRelevant = "Ce contenu ne correspond pas \xe0 mes centres d’int\xe9r\xeat";
var problemModalContent_ContentNotSafeForWork = "Ce contenu n’est pas s\xfbr dans le cadre du travail";
var problemModalContent_ContentSomethingIncorrect = "Ce contenu n’est pas tout \xe0 fait correct";
var problemModalContent_ContentTypeIncorrect = "Le type de contenu n’est pas correct";
var problemModalContent_DefaultQuestions = "J’ai des questions sur cet \xe9l\xe9ment";
var problemModalContent_DefaultRelevance = "Cet \xe9l\xe9ment n’est pas pertinent";
var problemModalContent_ErrorWithProvider = "Il y a un probl\xe8me avec ce fournisseur";
var problemModalContent_FileRestrictionDescription = "Les fichiers peuvent \xeatre des images (.jpg, .jpeg, .gif, .png) dont la taille n’exc\xe8de pas 5\xa0Mo.";
var problemModalContent_FileTypes = "Les fichiers peuvent \xeatre des images (.jpg, .jpeg, .gif, png) dont la taille n’exc\xe8de pas {{filesizeLimit}}.";
var problemModalContent_Flag = "Cet \xe9l\xe9ment est inappropri\xe9";
var problemModalContent_IncorrectPoints = "Le nombre de points attribu\xe9s n’est pas correct";
var problemModalContent_IssuesJoining = "Les utilisateurs rencontrent des difficult\xe9s pour rejoindre ce groupe";
var problemModalContent_LinkAppearsBroken = "Je ne peux pas acc\xe9der au lien ou le lien ne fonctionne pas";
var problemModalContent_OpportunityIrrelevant = "Cette opportunit\xe9 n’est pas pertinente";
var problemModalContent_OpportunityQuestions = "J’ai des questions \xe0 propos de cette opportunit\xe9";
var problemModalContent_Other = "Autre";
var problemModalContent_OtherInstructions = "Pour toute autre question, veuillez consulter le {{knowledgeCenterLinkStart}}Centre de connaissances de Degreed{{knowledgeCenterLinkEnd}}";
var problemModalContent_PaidContent = "Je dois m’abonner ou payer pour acc\xe9der \xe0 ce contenu";
var problemModalContent_PermissionOrLicense = "Je ne peux pas acc\xe9der \xe0 ce contenu en raison d’un message d’erreur li\xe9 \xe0 l’autorisation ou \xe0 la licence";
var problemModalContent_ProfileNotAppropriate = "Le profil n’est pas appropri\xe9";
var problemModalContent_Reason = "Quel est le probl\xe8me\xa0?";
var problemModalContent_ReasonPlaceholder = "D\xe9crivez le probl\xe8me";
var problemModalContent_RequiredLearningWarning = "L’effacement de la formation obligatoire peut prendre jusqu’\xe0 48\xa0heures.";
var problemModalContent_ShouldNotBeConnected = "Ce fournisseur ne devrait plus \xeatre connect\xe9";
var problemModalContent_SubissuePlaceholder = "S\xe9lectionnez une r\xe9ponse";
var problemModalContent_Subreason = "En quoi pouvons-nous vous aider \xa0?";
var problemModalContent_TeamIncorrectInsights = "Les statistiques relatives \xe0 cette \xe9quipe ne sont pas correctes";
var problemModalContent_TeamIncorrectMembers = "Les membres associ\xe9s \xe0 cette \xe9quipe ne sont pas corrects";
var problemModalContent_Title = "Signaler un probl\xe8me";
var problemModalContent_UnableToShare = "Je ne parviens pas \xe0 partager du contenu avec ce groupe";
var problemModalContent_UploadScreenshotDetail = "Pour une r\xe9solution plus rapide du probl\xe8me, veuillez accompagner votre description d\xe9taill\xe9e d’une capture d’\xe9cran.";
var problemModalContent_UploadScreenshotMessage = "Faites un glisser-d\xe9poser ou cliquez pour t\xe9l\xe9charger une image.";
var ProfileCtrl_AddGroup = "Ajouter un groupe";
var ProfileCtrl_AllCategories = "Toutes les cat\xe9gories";
var ProfileCtrl_ArticlesRead = "Articles lus";
var ProfileCtrl_AssessmentsCompleted = "Tests d'\xe9valuation compl\xe9t\xe9s";
var ProfileCtrl_BooksRead = "Livres lus";
var ProfileCtrl_BulkDeleteFormat = "Supprimer les \xe9l\xe9ments de la collection";
var ProfileCtrl_BulkDeleteSingle = "Souhaitez-vous r\xe9ellement supprimer l’\xe9l\xe9ment s\xe9lectionn\xe9 \xa0?";
var ProfileCtrl_CoursesCompleted = "Formations r\xe9alis\xe9es";
var ProfileCtrl_CreateGroup = "Cr\xe9er un groupe";
var ProfileCtrl_DeleteCollectionGenericItemBody = "Ces \xe9l\xe9ments ne seront plus pris en compte dans le calcul du total des points et ne s’afficheront plus dans votre profil.";
var ProfileCtrl_DeleteCollectionGenericItemBodySingle = "Souhaitez-vous vraiment supprimer les \xe9l\xe9ments s\xe9lectionn\xe9s\xa0? Une fois supprim\xe9s, ils ne s’afficheront plus sur votre profil.";
var ProfileCtrl_DeleteCollectionItemBodyFormat = "Ce {{type}} ne compte plus pour vos points g\xe9n\xe9raux et n’appara\xeetra plus dans votre profil.";
var ProfileCtrl_DeleteCollectionItemHeaderFormat = "\xcates-vous s\xfbr de vouloir supprimer ce {{type}} ?";
var ProfileCtrl_DeleteCollectionItemNotifierFormat = "{{itemTitle}} a \xe9t\xe9 supprim\xe9.";
var ProfileCtrl_DeleteCollectionMultipleItemsNotifierFormat = "{{selectedLength}} \xe9l\xe9ments ont \xe9t\xe9 supprim\xe9s.";
var ProfileCtrl_DeleteProviderItemNotifierFormat = "Les \xe9l\xe9ments de \xab\xa0{{providerName}}\xa0\xbb ont \xe9t\xe9 supprim\xe9s.";
var ProfileCtrl_DeleteProviderItemPromptFormat = "\xcates-vous s\xfbr de vouloir supprimer les \xe9l\xe9ments de \xab\xa0{{providerName}}\xa0\xbb ?";
var ProfileCtrl_EditCollectionItemNotifierFormat = "{{itemTitle}} a \xe9t\xe9 mis \xe0 jour\xa0!";
var ProfileCtrl_EditCollectionMultipleItemsNotifierFormat = "{{selectedLength}}\xa0\xe9l\xe9ments ont \xe9t\xe9 mis \xe0 jour.";
var ProfileCtrl_EventsAttended = "\xc9v\xe8nements suivis";
var ProfileCtrl_ExperienceDatePresent = "Maintenant";
var ProfileCtrl_ExperienceDateYears = "ann\xe9es";
var ProfileCtrl_ExperienceReported = "Exp\xe9rience rapport\xe9e";
var ProfileCtrl_FindGroups = "Trouver un groupe \xe0 rejoindre";
var ProfileCtrl_GroupsDescription = "Les groupes sont un outil social visant \xe0 renforcer l’engagement des apprenants, \xe0 favoriser les discussions au sujet de la formation et \xe0 aider les apprenants \xe0 trouver le contenu le plus adapt\xe9 \xe0 leur poste ou leurs objectifs de formation.";
var ProfileCtrl_NoExactMatches = "Pas de correspondantes exactes";
var ProfileCtrl_NoExactMatchesHelp = "Essayez de modifier ou de supprimer certains de vos filtres, ou d’ajuster votre zone de recherche.";
var ProfileCtrl_OwnerEmptyStateBody = "Conservez ici l’historique de votre formation, de vos exp\xe9riences, de vos r\xe9ussites, de vos parcours et de vos plans.";
var ProfileCtrl_OwnerEmptyStateTitle = "Votre collection est vide";
var ProfileCtrl_PathwaysDescription = "Les parcours sont des voies d’apprentissage guid\xe9es qui permettent de suivre la progression des apprenants. Les parcours contiennent des \xe9l\xe9ments de contenu relatifs \xe0 un sujet ou un th\xe8me particulier et peuvent \xeatre organis\xe9s par sections ou sous-sections d’\xe9l\xe9ments connexes.";
var ProfileCtrl_PlansDescription = "Un plan est une collection de contenus portant sur des comp\xe9tences, des parcours, des groupes, des personnes et des contenus de formation visant \xe0 am\xe9liorer les comp\xe9tences des apprenants au sein de leur fonction actuelle ou de les pr\xe9parer \xe0 de nouveaux postes.";
var ProfileCtrl_PodcastsCompleted = "\xc9pisodes de podcast termin\xe9s";
var ProfileCtrl_PointsEarnedTitle = "Points gagn\xe9s";
var ProfileCtrl_ShareProfile = "Partager le profil";
var ProfileCtrl_ShareProfilePrivate = "Votre profil est priv\xe9";
var ProfileCtrl_ShareProfileSuccess = "Lien du profil copi\xe9\xa0!";
var ProfileCtrl_ShareSkillSuccess = "Lien de la comp\xe9tence copi\xe9\xa0!";
var ProfileCtrl_SkillStdDescription = "Les normes de comp\xe9tences sont les comp\xe9tences auxquelles votre organisation accorde le plus d’importance. Celles-ci vous aideront \xe0 orienter vos activit\xe9s de formation en vue d’atteindre vos cibles de comp\xe9tences.";
var ProfileCtrl_VideosWatched = "Vid\xe9os regard\xe9es";
var ProfileCtrl_ViewSkillSignals = "Afficher les signaux de comp\xe9tence";
var ProfilePathways_Authoring = "Cr\xe9ation de contenu";
var ProfilePathways_Completed = "\xc9l\xe9ments termin\xe9s";
var ProfilePathways_CreateNewPathway = "Cr\xe9er un parcours";
var ProfilePathways_CreatePathway = "Cr\xe9er un parcours";
var ProfilePathways_EmptyDescription = "Cr\xe9ez, partagez et suivez des parcours de formation.";
var ProfilePathways_EmptyStateDescription = "Les parcours que vous cr\xe9ez ou suivez appara\xeetront ici.";
var ProfilePathways_EmptyStateTitle = "Aucun parcours";
var ProfilePathways_EmptyTitle = "D\xe9marrez votre parcours";
var ProfilePathways_Enrolled = "Inscrit";
var ProfilePathways_FindPathways = "Recherchez un parcours \xe0 suivre";
var ProfilePathways_FindPathwaysAria = "Recherchez une formation";
var ProfilePathways_Following = "\xc9l\xe9ments suivis";
var ProfilePathways_LearnTypesAlt = "Recherchez, suivez et \xe9valuez TOUT ce que vous apprenez";
var ProfilePathways_NoPathways = "Aucun parcours disponible";
var ProfilePathways_UserNoPathwaysFormat = "{{profileName}} n’a ni cr\xe9\xe9 ni suivi aucun parcours.";
var ProfilePlans_EmptyDescription = "Cr\xe9ez, partagez et suivez des plans de formation.";
var ProfilePlans_EmptyStateDescription = "Les plans que vous cr\xe9ez ou suivez appara\xeetront ici.";
var ProfilePlans_EmptyStateTitle = "Aucun plan";
var ProfilePlans_FindPlans = "Trouver un plan \xe0 suivre";
var ProfilePlans_NoPlans = "Aucun plan \xe0 afficher";
var ProfilePlans_NoPlansDescription = "{{name}} n’a cr\xe9\xe9 ou suivi aucun plan.";
var ProfileSkillStd_CollaboratorOnly = "Collaborateur uniquement";
var ProfileSkillStd_EmptyStateDescription = "Les normes de comp\xe9tences que vous avez cr\xe9\xe9es ou assign\xe9es s’affichent ici.";
var ProfileSkillStd_EmptyStateTitle = "Aucune norme de comp\xe9tences";
var ProviderSummary_agileunternehmen = "Article de blog du Dr Dominic Linder sur la transformation num\xe9rique et l’agilit\xe9 des entreprises. Inclut des mises en pratique de contenus scientifiques et des recommandations de professionnels.";
var ProviderSummary_aicpa = "L’American Institute of Certified Public Accountants est la plus grande association de repr\xe9sentation de la profession comptable au monde.";
var ProviderSummary_alura = "Alura propose des formations technologiques immersives en portugais.";
var ProviderSummary_anderspink = "Anders Pink s\xe9lectionne automatiquement sur le Web des contenus personnalisables en fonction des sujets et des comp\xe9tences qui vous int\xe9ressent le plus. Les flux d’information sont actualis\xe9s quotidiennement, pour vous pr\xe9senter des contenus \xe0 jour provenant de sites r\xe9put\xe9s. Consultez un aper\xe7u de cette collection de flux populaires pour aider vos apprenants \xe0 optimiser leurs recherches et augmenter leur engagement avec des contenus r\xe9cents et pertinents.";
var ProviderSummary_arcitura = "Arcitura Education Inc. est un fournisseur mondial de programmes de formation et de certification informatiques progressifs et ind\xe9pendants.";
var ProviderSummary_ascm = "L’Association for Supply Chain Management (ASCM) est la plus grande association \xe0 but non lucratif dans le domaine de la cha\xeene d’approvisionnement. Partenaire objectif, elle d\xe9livre des certifications de cha\xeene d’approvisionnement mondialement reconnues ainsi qu’une formation compl\xe8te.";
var ProviderSummary_awstraining = "AWS Training and Certification constitue le seul ensemble de programmes et d’offres de formation \xe9labor\xe9s par les experts d’AWS.";
var ProviderSummary_babbel = "Leader dans le secteur de l’apprentissage des langues en ligne, Babbel compte des millions d’abonn\xe9s actifs dans le monde entier.";
var ProviderSummary_bigdatainsider = "Le portail BigData-Insider fournit des informations sur tous les sujets li\xe9s \xe0 la gestion et l’analyse de grandes quantit\xe9s de donn\xe9es.";
var ProviderSummary_blinkist = "Blinkist distille des informations cl\xe9s tir\xe9es de livres de non-fiction sous forme d’extraits captivants de 15\xa0minutes \xe0 lire ou \xe0 \xe9couter.";
var ProviderSummary_business2community = "Business 2 Community couvre l’actualit\xe9 et les principales tendances en mati\xe8re de m\xe9dias sociaux, marketing num\xe9rique, marketing de contenu, vente sociale, entrepreneuriat social et tant d’autres";
var ProviderSummary_businessinsider = "Business Insider pr\xe9sente l’actualit\xe9 des entreprises sp\xe9cialis\xe9es dans la tech, la finance, le commerce et tout autre secteur important aux yeux des leaders actuels et futurs.";
var ProviderSummary_busuupremium = "Busuu propose des cours dans 12\xa0langues sur le Web et sur mobile \xe0 plus de 100\xa0millions d’apprenants dans le monde.";
var ProviderSummary_cbtnuggets = "CBT\xa0Nuggets propose des formations en technologie \xe0 la demande, disponibles o\xf9 et quand et o\xf9 vous le souhaitez.";
var ProviderSummary_centerforcreativeleadership = "Le Center for Creative Leadership est un chef de file mondial dans le secteur du d\xe9veloppement du leadership.";
var ProviderSummary_cisconetworkingacademy = "Cisco Networking Academy est un programme de formation mondial dans le domaine de l’informatique et de la cybers\xe9curit\xe9. En partenariat avec des \xe9tablissements d’enseignement au niveau mondial, elle ouvre \xe0 tous des opportunit\xe9s professionnelles.";
var ProviderSummary_crehana = "EdTech – Start-up qui vise \xe0 cr\xe9er des environnements de formation virtuels, adaptatifs et centr\xe9s sur l’utilisateur.";
var ProviderSummary_cybrary = "Cybrary est un centre de formation qui s’appuie sur l’ensemble des connaissances d’experts et d’organisations de pointe du domaine de la cybers\xe9curit\xe9. Il est au service des \xe9quipes et des utilisateurs d\xe9sireux d’acqu\xe9rir, d’am\xe9liorer, d’\xe9valuer et de certifier leurs comp\xe9tences en cybers\xe9curit\xe9.";
var ProviderSummary_datacamp = "DataCamp est une plateforme de d\xe9veloppement des comp\xe9tences pour les professionnels et les organisations qui travaillent avec les donn\xe9es et dont l’objectif est de monter en comp\xe9tences dans les domaines de la science des donn\xe9es et du machine learning.";
var ProviderSummary_degreedmeta = "Du contenu original et des parcours cr\xe9\xe9s par Degreed.";
var ProviderSummary_deloitteinsights = "Dans Press Room, l’h\xf4te Tanya Ott interviewe les principaux leaders et d\xe9cideurs sur des sujets comme la strat\xe9gie concurrentielle, les technologies \xe9mergentes, la croissance, l’innovation et la performance, pour n’en citer que quelques-uns.";
var ProviderSummary_duarte = "Duarte aide les marques et les professionnels \xe0 cr\xe9er et produire des pr\xe9sentations et des communications qui inspirent leurs audiences \xe0 passer \xe0 l’action.";
var ProviderSummary_edx = "edX est un fournisseur de formation en ligne ouverte \xe0 tous\xa0(FLOT) qui h\xe9berge des cours en ligne de niveau universitaire, couvrant un large \xe9ventail de disciplines et s’adressant aux \xe9tudiants du monde entier.";
var ProviderSummary_emtrain = "Emtrain permet aux employ\xe9s de trouver des r\xe9ponses \xe0 leurs questions concernant l’inclusion, le respect et l’\xe9thique pour une culture d’entreprise plus saine.";
var ProviderSummary_entrepreneur = "Entrepreneur est un magazine am\xe9ricain sp\xe9cialis\xe9 dans l’entrepreneuriat, la gestion des petites entreprises et le monde des affaires.";
var ProviderSummary_exitcertified = "ExitCertified (Tech Data) aide les apprenants \xe0 acqu\xe9rir des comp\xe9tences essentielles en informatique et permet de passer au niveau sup\xe9rieur dans un domaine choisi.";
var ProviderSummary_financialedge = "Financial Edge Training permet aux professionnels de d\xe9velopper leurs comp\xe9tences techniques en mati\xe8re de banque d’investissement, de gestion d’actifs, de financement de projets et plus encore.";
var ProviderSummary_fortinet = "Cette formule propose des cours gratuits complets pour pr\xe9parer les utilisateurs \xe0 tous les niveaux de ma\xeetrise de la certification NSE.";
var ProviderSummary_fortytwocourses = "42courses est une plateforme d’apprentissage en ligne dont l’enseignement pratique, agr\xe9\xe9 et sur demande provient de marques et de leaders du secteur disposant d’une exp\xe9rience concr\xe8te.";
var ProviderSummary_futurelearn = "FutureLearn propose un large \xe9ventail de MOOC dispens\xe9s par les meilleures universit\xe9s et institutions culturelles \xe0 l’\xe9chelle mondiale.";
var ProviderSummary_getabstract = "GetAbstract propose des r\xe9sum\xe9s de livres et d’articles destin\xe9s aux clients commerciaux, livr\xe9s par pertinence.";
var ProviderSummary_ghsp = "Le GHSP est un journal en ligne gratuit, en libre acc\xe8s, \xe9valu\xe9 par des pairs, visant \xe0 am\xe9liorer les pratiques en mati\xe8re de sant\xe9.";
var ProviderSummary_goskills = "GoSkills est une plateforme d’apprentissage en ligne qui permet aux participants d’acqu\xe9rir des comp\xe9tences professionnelles afin d’atteindre leurs objectifs personnels et professionnels.";
var ProviderSummary_greatlearning = "Great\xa0Learning propose des certifications professionnelles offertes par des universit\xe9s de renomm\xe9e mondiale, dans les domaines les plus recherch\xe9s.";
var ProviderSummary_growwithgoogle = "Les Certificats Google Career proposent des formations en ligne flexibles pour des comp\xe9tences utilisables directement dans le contexte professionnel.";
var ProviderSummary_handelsblatt = "Handelsblatt est un quotidien allemand sp\xe9cialis\xe9 dans le journalisme \xe9conomique et financier, au niveau mondial.";
var ProviderSummary_hrcom = "HR.com est le plus grand r\xe9seau social destin\xe9 aux professionnels des RH, proposant articles, \xe9tudes de cas, bulletins d’information, sondages, forums de discussion, blogs et \xe9missions web.";
var ProviderSummary_hubspotacademy = "HubSpot Academy propose une formation en ligne gratuite pour les professionnels de l’inbound marketing, des ventes et du service client.";
var ProviderSummary_ideou = "D\xe9couvrez l’approche d’IDEO en mati\xe8re de r\xe9flexion conceptuelle (design thinking) et de r\xe9solution cr\xe9ative de probl\xe8mes gr\xe2ce \xe0 IDEO\xa0U, une \xe9cole en ligne proposant les outils et l’\xe9tat d’esprit n\xe9cessaires pour \xe9veiller la confiance cr\xe9ative des apprenants et les aider \xe0 relever des d\xe9fis complexes.";
var ProviderSummary_industryofthings = "Industry of Things est un portail web en allemand qui se sp\xe9cialise dans les applications pratiques de l’Internet des objets (IoT), du M2M et de l’Industrie 4.0.";
var ProviderSummary_invisionapp = "InVision regroupe conseils, actualit\xe9s et id\xe9es en mati\xe8re de design num\xe9rique.";
var ProviderSummary_itprotv = "ITProTV propose des vid\xe9os de formation informatique avec des laboratoires interactifs pratiques pour am\xe9liorer les connaissances informatiques et pr\xe9parer les examens de certification informatique.";
var ProviderSummary_joshbersin = "Le blog de Josh Bersin apporte de pr\xe9cieuses informations sur le travail, les comp\xe9tences, l’apprentissage, le leadership et la technologie\xa0RH.";
var ProviderSummary_kenblanchardcompanies = "The Ken Blanchard Companies proposent des solutions de d\xe9veloppement du leadership, des programmes de formation et un coaching bas\xe9s sur la recherche, qui inspirent et donnent des r\xe9sultats.";
var ProviderSummary_kes = "KES est une plateforme innovante ax\xe9e sur la technologie, le comportement et la cr\xe9ativit\xe9. Elle se donne pour mission d’aider les dirigeants et les entreprises \xe0 concevoir les affaires sous un nouveau jour.";
var ProviderSummary_khanacademy = "Khan Academy propose une collection gratuite en ligne de mini-cours via des tutoriels vid\xe9o dans pr\xe8s de 30\xa0langues, ayant dispens\xe9 plus de 600\xa0millions de cours dans le monde entier.";
var ProviderSummary_loma = "LOMA est une association professionnelle qui propose des programmes de formation et de d\xe9veloppement couvrant les domaines de la gestion, des op\xe9rations, de la recherche et des meilleures pratiques dans le secteur de l’assurance-vie.";
var ProviderSummary_mandel = "Mandel Communications dispense des formations, du coaching et des ateliers centr\xe9s sur le renforcement des comp\xe9tences de pr\xe9sentation, de conversation et d’animation.";
var ProviderSummary_masterclass = "MasterClass produit des cours en ligne dispens\xe9s par des personnes reconnues dans leurs domaines respectifs.";
var ProviderSummary_mckinsey = "McKinsey\xa0&\xa0Company offre les derni\xe8res perspectives commerciales gr\xe2ce aux milliers d’articles et de rapports qu’elle produit sur les meilleures opportunit\xe9s et les plus grands d\xe9fis qui se pr\xe9sentent \xe0 nous aujourd’hui.";
var ProviderSummary_methods = "D\xe9couvrez les m\xe9thodes de leadership employ\xe9es par certains des plus grands PDG, coachs professionnels, leaders d’opinion et th\xe9oriciens des affaires sur la sc\xe8ne mondiale.";
var ProviderSummary_microsoftlearn = "Microsoft\xa0Learn vise \xe0 am\xe9liorer les comp\xe9tences relatives aux produits et services Microsoft \xe0 l’aide de contenus de formation interactifs, bas\xe9s sur des t\xe2ches et traduits dans plusieurs langues.";
var ProviderSummary_mindtools = "Consultez les ressources MindTools.com pour acqu\xe9rir plus de 2\xa0800\xa0comp\xe9tences en gestion, leadership et efficacit\xe9 personnelle en vue d’atteindre satisfaction et r\xe9ussite professionnelles.";
var ProviderSummary_mitsloanmgmtreview = "LA MIT Sloan Management Review est \xe0 la fois une plateforme num\xe9rique et une revue de recherche pour les dirigeants d’entreprise, publi\xe9e \xe0 l’Institut de technologie du Massachusetts.";
var ProviderSummary_platzi = "Platzi est une plateforme en ligne permettant de former la prochaine g\xe9n\xe9ration de professionnels de la technologie.";
var ProviderSummary_pluralsight = "Pluralsight offre toute une gamme de formations vid\xe9o destin\xe9es aux d\xe9veloppeurs logiciels, aux administrateurs informatiques et aux sp\xe9cialistes des technologies cr\xe9atives.";
var ProviderSummary_racismreview = "Racism Review est un blog collaboratif qui met en avant les recherches sociologiques sur les populations et le racisme.";
var ProviderSummary_redshelf = "RedShelf est une soci\xe9t\xe9 EdTech qui met les ressources p\xe9dagogiques num\xe9riques au service de l’enseignement.";
var ProviderSummary_safari = "Safari Books Online est une biblioth\xe8que num\xe9rique \xe0 la demande proposant des contenus de sp\xe9cialit\xe9 au format livre et vid\xe9o, sign\xe9s par les meilleurs auteurs des domaines technologique et entrepreneurial.";
var ProviderSummary_scoopnewsgroup = "Scoop News Group est la principale entreprise de m\xe9dias et technologies du secteur public aux \xc9tats-Unis";
var ProviderSummary_simplilearn = "Simplilearn dispense des formations certifiantes en ligne et en interne.";
var ProviderSummary_skillshare = "Skillshare est une communaut\xe9 de formation en ligne proposant des vid\xe9os de formation non accr\xe9dit\xe9es, disponibles sur abonnement. Parmi les principales cat\xe9gories de cours, citons notamment les arts cr\xe9atifs, le design, l’entrepreneuriat, le lifestyle, la technologie, auxquelles s’ajoutent de nombreux autres sous-th\xe8mes.";
var ProviderSummary_softwareengineeringinstitute = "Le SEI de Carnegie Mellon m\xe8ne des activit\xe9s de recherche dans le domaine du g\xe9nie logiciel\xa0: acquisition, architecture et gammes de produits, am\xe9lioration des processus et mesure des performances, s\xe9curit\xe9, interop\xe9rabilit\xe9 et fiabilit\xe9 des syst\xe8mes.";
var ProviderSummary_soundview = "Soundview propose des r\xe9sum\xe9s qui vous font gagner du temps et des informations strat\xe9giques tir\xe9es de livres commerciaux \xe0 succ\xe8s.";
var ProviderSummary_springerprofessional = "Springer\xa0Professional est un fournisseur de m\xe9dias classiques et num\xe9riques sp\xe9cialis\xe9s dans les domaines \xe9conomiques, scientifiques, du g\xe9nie et des sciences sociales, au service du monde germanophone.";
var ProviderSummary_tedatwork = "TED@Work revisite les conf\xe9rences TED les plus marquantes pour r\xe9inventer l’apprentissage en entreprise en proposant un nouveau cadre et des outils pratiques. Cet aper\xe7u TED@Work propose dix\xa0\xe9chantillons de parcours issus du catalogue complet disponible sous licence.";
var ProviderSummary_udacity = "Udacity fait progresser votre carri\xe8re gr\xe2ce \xe0 des cours en ligne en programmation, science des donn\xe9es, intelligence artificielle, marketing num\xe9rique et plus encore.";
var ProviderSummary_whil = "Whil est une plateforme ax\xe9e sur la r\xe9duction du stress, le renforcement de la r\xe9silience et l’am\xe9lioration du bien-\xeatre mental.";
var ProviderSummary_workingvoices = "Working\xa0Voices propose de courts articles, des vid\xe9os, des cours, des conseils et des techniques pour am\xe9liorer les comp\xe9tences professionnelles sur le lieu de travail comme en dehors.";
var PublicError_HomePageButton = "Aller \xe0 la page d’accueil";
var QueueCtrl_CompletedMovedToCollection = "L’\xe9l\xe9ment termin\xe9 a \xe9t\xe9 d\xe9plac\xe9 vers la collection.";
var QueueCtrl_EmptyStateDescription = "Tout ce que vous enregistrez est affich\xe9 ici.";
var QueueCtrl_EmptyStateTitle = "Aucun \xe9l\xe9ment enregistr\xe9";
var QueueCtrl_InternalError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de cette action. Ce n’est pas votre faute et nous mettons tout en œuvre pour r\xe9soudre le probl\xe8me.";
var QueueCtrl_NoItemsSaved = "Vous n’avez pas encore enregistr\xe9 d’\xe9l\xe9ments.";
var QueueCtrl_RemoveSavedItems = "Souhaitez-vous vraiment supprimer ceci de vos \xe9l\xe9ments enregistr\xe9s \xa0?";
var QueueCtrl_SavedDescription = "Les \xe9l\xe9ments enregistr\xe9s peuvent \xeatre collect\xe9s et termin\xe9s ou partag\xe9s \xe0 une date ult\xe9rieure.";
var QueueCtrl_SaveInstructionsFormat = "Vous pouvez enregistrer des \xe9l\xe9ments en utilisant le {{startBookmarklet}}bouton Degreed{{endTag}}, ou en recherchant des contenus sur la {{startLearning}}page d’accueil Degreed{{endTag}}.";
var QueueCtrl_SaveUrlForLater = "Mettre une URL de c\xf4t\xe9";
var QueueSvc_InternalError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu. Ce n’est pas votre faute et nous mettons tout en œuvre pour r\xe9soudre le probl\xe8me.";
var QueueSvc_ItemAddedFormat = "{{item}} a \xe9t\xe9 enregistr\xe9\xa0!";
var QueueSvc_UsersTitle = "Les personnes qui ont enregistr\xe9";
var RecommendationCtrl_SelectADate = "Veuillez s\xe9lectionner une date";
var recommendationDetail_DueDateFormat = "Date limite {{dueDate}}";
var recommendationDetail_LevelFormat = "Niveau {{statusDetails}}";
var recommendationDetail_StatusComplete = "Termin\xe9";
var recommendationDetail_StatusDismissed = "Ignor\xe9";
var recommendationDetail_StatusPending = "En attente";
var recommendationDetail_StatusPrivate = "Priv\xe9";
var recommendationDetail_StatusQueued = "Enregistr\xe9 pour plus tard";
var recommendationForm_AddToProfileFormat = "Ajouter {{itemName}} au profil";
var recommendationForm_AssignItem = "Assigner ce {{itemType}}";
var recommendationForm_BackToAddingNames = "Retour \xe0 l’ajout des noms et des groupes";
var recommendationForm_CharacterCount = "{{characterCount}} caract\xe8res restants";
var recommendationForm_ConfirmDelete = "Souhaitez-vous r\xe9ellement supprimer ce partage\xa0?";
var recommendationForm_CopyUrl = "Copier l’URL";
var recommendationForm_dateLabel = "Date limite";
var recommendationForm_dateToggle = "Assigner";
var recommendationForm_dateToggleInfo = "Si ce contenu doit \xeatre consult\xe9 en priorit\xe9, vous pouvez saisir une date butoir.";
var recommendationForm_EmailRecommendation = "Partage par e-mail";
var recommendationForm_FindPeopleConsumerPlaceholder = "Rechercher par nom";
var recommendationForm_FindPeoplePlaceholder = "Rechercher par nom ou par groupe";
var recommendationForm_HasRecommendedSkills = "a recommand\xe9 les comp\xe9tences suivantes.<br> Cliquez sur + pour les ajouter \xe0 votre profil.";
var recommendationForm_MemberCount = "{{memberCount}} Membres | Groupe";
var recommendationForm_NoResults = "Aucun r\xe9sultat trouv\xe9";
var recommendationForm_OnlyOrgMembers = "* L’option d’apprentissage assign\xe9 n’est pas disponible pour les abonn\xe9s en dehors de votre organisation.";
var recommendationForm_PickADate = "S\xe9lectionner une date";
var recommendationForm_RecommendInput = "Partager cet {{inputType}}";
var recommendationForm_RecommendItem = "Partager ce contenu ({{itemType}})";
var recommendationForm_RecommendItem_Academy = "Partager cette acad\xe9mie";
var recommendationForm_RecommendItem_Article = "Partager cet article";
var recommendationForm_RecommendItem_Assessment = "Partager ce test d’\xe9valuation";
var recommendationForm_RecommendItem_Book = "Partager ce livre";
var recommendationForm_RecommendItem_Course = "Partager ce cours";
var recommendationForm_RecommendItem_Episode = "Partager ce podcast";
var recommendationForm_RecommendItem_Event = "Partager cet \xe9v\xe9nement";
var recommendationForm_RecommendItem_Opportunity = "Partager cette opportunit\xe9";
var recommendationForm_RecommendItem_Pathway = "Partager ce parcours";
var recommendationForm_RecommendItem_Plan = "Partager ce plan";
var recommendationForm_RecommendItem_Podcast = "Partager ce podcast";
var recommendationForm_RecommendItem_Post = "Partager cette publication";
var recommendationForm_RecommendItem_Tag = "Recommander l’\xe9valuation de la comp\xe9tence";
var recommendationForm_RecommendItem_Target = "Partager ce plan";
var recommendationForm_RecommendItem_Task = "Partager cette t\xe2che";
var recommendationForm_RecommendItem_Video = "Partager cette vid\xe9o";
var recommendationForm_RecommendSkillInput = "Recommander une \xe9valuation de comp\xe9tence";
var recommendationForm_SearchByName = "Rechercher par nom";
var recommendationForm_SearchLabel = "Rechercher par nom ou par groupe";
var recommendationForm_SearchLabelConsumer = "Recherchez vos abonn\xe9s publics par leur nom";
var recommendationForm_submitButtonPlural = "Partager avec {{recommendeeCount}}\xa0personne(s)";
var recommendationForm_submitButtonPluralAssign = "Assigner \xe0 {{recommendeeCount}} personne(s)";
var recommendationForm_submitButtonSingular = "Partager avec 1\xa0personne";
var recommendationForm_submitButtonSingularAssign = "Assigner \xe0 une personne";
var recommendationForm_UpdateItem = "Mettre \xe0 jour ce {{itemType}}";
var recommendationForm_ViewSkillsOnProfile = "Voir sur le profil";
var recommendationForm_WhyAssignedUpdate = "Mettez \xe0 jour la note indiquant les raisons de cette assignation";
var recommendationForm_WhyRecommendedUpdate = "Mettez \xe0 jour la note indiquant pourquoi vous partagez ceci";
var recommendationForm_WhyRecommending = "Message";
var recommendationForm_WhyRecommendingPlaceholder = "Ajouter un message indiquant la raison de ce partage";
var RecommendationPolicyModal_Acknowledge = "J’accepte";
var RecommendationPolicyModal_Title = "Politique de partage";
var RecommendationsOverviewCtrl_DismissDialogDescription = "Cet \xe9l\xe9ment cessera de vous \xeatre sugg\xe9r\xe9.";
var RecommendationsSvc_DeleteConfirmationFormat = "Etes-vous s\xfbr que vous voulez supprimer <br> {{title}} ?";
var RecommendationsSvc_GetUsersError = "Une erreur est survenue lors de l’obtention de la liste des partages.";
var RecommendationsSvc_InputAssignedFormat = "Ceci ({{title}}) a bien \xe9t\xe9 assign\xe9.";
var RecommendationsSvc_InputAssignedFormatIneligibleAdmin = "La comp\xe9tence {{title}} a \xe9t\xe9 assign\xe9e. Toutefois, certaines des personnes auxquelles vous l’avez recommand\xe9e ne sont pas \xe9ligibles pour effectuer sa revue. Modifiez la comp\xe9tence pour qu’elle puisse faire l’objet d’une revue.";
var RecommendationsSvc_InputAssignedFormatIneligibleLearner = "La comp\xe9tence {{title}} a \xe9t\xe9 assign\xe9e. Toutefois, certaines des personnes auxquelles vous l’avez recommand\xe9e ne sont pas \xe9ligibles pour effectuer sa revue. Contactez votre administrateur pour plus d’informations.";
var RecommendationsSvc_InputAssignedFormatNoEligibleUsersAdmin = "La comp\xe9tence {{title}} n’a pas pu \xeatre assign\xe9e, car aucune des personnes que vous avez s\xe9lectionn\xe9es n’est \xe9ligible pour effectuer sa revue. Modifiez la comp\xe9tence pour qu’elle puisse faire l’objet d’une revue.";
var RecommendationsSvc_InputAssignedFormatNoEligibleUsersLearner = "La comp\xe9tence {{title}} n’a pas pu \xeatre assign\xe9e, car aucune des personnes que vous avez s\xe9lectionn\xe9es n’est \xe9ligible pour effectuer sa revue. Contactez votre administrateur pour plus d’informations.";
var RecommendationsSvc_InputRecommendedFormat = "La comp\xe9tence {{title}} a bien \xe9t\xe9 recommand\xe9e.";
var RecommendationsSvc_InputRecommendedFormatIneligibleAdmin = "La comp\xe9tence {{title}} a \xe9t\xe9 recommand\xe9e. Toutefois, certaines des personnes auxquelles vous l’avez recommand\xe9e ne sont pas \xe9ligibles pour effectuer sa revue. Modifiez la comp\xe9tence pour qu’elle puisse faire l’objet d’une revue.";
var RecommendationsSvc_InputRecommendedFormatIneligibleLearner = "La comp\xe9tence {{title}} a \xe9t\xe9 recommand\xe9e. Toutefois, certaines des personnes auxquelles vous l’avez recommand\xe9e ne sont pas \xe9ligibles pour effectuer sa revue. Contactez votre administrateur pour plus d’informations.";
var RecommendationsSvc_InputRecommendedFormatNoEligibleUsersAdmin = "La comp\xe9tence {{title}} n’a pas pu \xeatre recommand\xe9e, car aucune des personnes que vous avez s\xe9lectionn\xe9es n’est \xe9ligible pour effectuer sa revue. Modifiez la comp\xe9tence pour qu’elle puisse faire l’objet d’une revue.";
var RecommendationsSvc_InputRecommendedFormatNoEligibleUsersLearner = "La comp\xe9tence {{title}} n’a pas pu \xeatre recommand\xe9e, car aucune des personnes que vous avez s\xe9lectionn\xe9es n’est \xe9ligible pour effectuer sa revue. Contactez votre administrateur pour plus d’informations.";
var RecommendationsSvc_ProblemAccessingRecommendations = "D\xe9sol\xe9s\xa0! Un probl\xe8me est survenu lors de l’acc\xe8s \xe0 vos partages.";
var RecommendationsSvc_ProblemAddingRecommendations = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’ajout de cette recommandation.";
var RecommendationsSvc_ProblemDeleteRecommendationsFormat = "D\xe9sol\xe9s\xa0! Un probl\xe8me est survenu lors de la suppression du partage";
var RecommendationsSvc_ProblemSearchingGroups = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la recherche des groupes.";
var RecommendationsSvc_ProblemSearchingMembers = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la recherche des membres.";
var RecommendationsSvc_ProblemUpdatingRecommendation = "D\xe9sol\xe9s\xa0! Un probl\xe8me est survenu lors de la mise \xe0 jour de ce partage.";
var RecommendationsSvc_SharedWith = "Partag\xe9 avec";
var RecommendationsSvc_SuccessDelete = "Le partage a \xe9t\xe9 supprim\xe9 avec succ\xe8s.";
var RecommendationsSvc_SuccessDeleteAssignment = "La t\xe2che a \xe9t\xe9 supprim\xe9e avec succ\xe8s.";
var RecommendationsSvc_UpdateAssignment = "La t\xe2che a \xe9t\xe9 mise \xe0 jour avec succ\xe8s.";
var RecommendationsSvc_UpdateRecommendation = "Le partage a \xe9t\xe9 mis \xe0 jour avec succ\xe8s.";
var RecommendationsSvc_UsersTitle = "Personnes qui ont partag\xe9 ceci";
var replyToComment_CommentGroupPluralFormat = "{{nameHtml}} et {{number}} autres ont r\xe9pondu \xe0 votre commentaire dans {{groupNameHtml}}";
var replyToComment_CommentGroupSingleFormat = "{{nameHtml}} a r\xe9pondu \xe0 votre commentaire dans {{groupNameHtml}}";
var replyToComment_CommentPluralFormat = "{{nameHtml}} et {{number}} autres ont r\xe9pondu \xe0 votre commentaire";
var replyToComment_CommentSingleFormat = "{{nameHtml}} a r\xe9pondu \xe0 votre commentaire";
var replyToComment_TakeawayGroupPluralFormat = "{{nameHtml}} et {{number}} autres ont r\xe9pondu \xe0 votre avis dans {{groupNameHtml}}";
var replyToComment_TakeawayGroupSingleFormat = "{{nameHtml}} a r\xe9pondu \xe0 votre avis dans {{groupNameHtml}}";
var replyToComment_TakeawayPluralFormat = "Il y a {{number}} r\xe9ponses \xe0 votre avis sur {{takeawayTitleHtml}}";
var replyToComment_TakeawaySingleFormat = "{{nameHtml}} a r\xe9pondu \xe0 votre avis sur {{takeawayTitleHtml}}";
var replyToPost_GroupPluralFormat = "{{nameHtml}} et {{number}} autres ont r\xe9pondu \xe0 votre publication dans {{groupNameHtml}}";
var replyToPost_GroupSingleFormat = "{{nameHtml}} a r\xe9pondu \xe0 votre publication dans {{groupNameHtml}}";
var replyToPost_PluralFormat = "{{nameHtml}} et {{number}} autres ont r\xe9pondu \xe0 votre publication";
var replyToPost_SingleFormat = "{{nameHtml}} a r\xe9pondu \xe0 votre publication ";
var Reporting_Transmitters_BOM = "Supprimer le BOM";
var Reporting_Transmitters_Configurations = "Configurations";
var Reporting_Transmitters_Configurations_Selection = "Configurations\xa0FTP";
var Reporting_Transmitters_CreateEdit_AuthenticationType = "Type d’authentification";
var Reporting_Transmitters_CreateEdit_BOMTooltip = "Supprime l’indicateur d’ordre des octets (BOM) dans le rapport. Laissez ce param\xe8tre sur NON, sauf s’il est n\xe9cessaire de retirer le BOM.";
var Reporting_Transmitters_CreateEdit_ConnectionStatus = "\xc9tat de la connexion\xa0:";
var Reporting_Transmitters_CreateEdit_ConnectionStatusCheck = "V\xe9rifier la connexion";
var Reporting_Transmitters_CreateEdit_ConnectionStatusFail = "\xc9chec de la connexion";
var Reporting_Transmitters_CreateEdit_ConnectionStatusNotConnected = "Connexion...";
var Reporting_Transmitters_CreateEdit_ConnectionStatusSuccess = "Connexion \xe9tablie";
var Reporting_Transmitters_CreateEdit_CredentialsNote = "Pour des raisons de s\xe9curit\xe9, les identifiants ne peuvent \xeatre affich\xe9s. Toute mise \xe0 jour du nom d’utilisateur, du mot de passe ou de la cl\xe9 priv\xe9e remplacera les valeurs existantes.";
var Reporting_Transmitters_CreateEdit_HeaderCreate = "Cr\xe9er la configuration";
var Reporting_Transmitters_CreateEdit_HeaderUpdate = "Modifier la configuration";
var Reporting_Transmitters_CreateEdit_HostPlaceholder = "votreserveurftp.com";
var Reporting_Transmitters_CreateEdit_Password = "Mot de passe";
var Reporting_Transmitters_CreateEdit_PasswordPlaceholder = "Saisir le mot de passe";
var Reporting_Transmitters_CreateEdit_PortNumberError = "Doit \xeatre un nombre";
var Reporting_Transmitters_CreateEdit_PrivateKey = "Cl\xe9 priv\xe9e";
var Reporting_Transmitters_CreateEdit_PrivateKeyPlaceholder = "Saisir la cl\xe9 priv\xe9e";
var Reporting_Transmitters_CreateEdit_Subfolder = "Chemin du sous-dossier";
var Reporting_Transmitters_CreateEdit_SubfolderPlaceholder = "Saisir le chemin du sous-dossier";
var Reporting_Transmitters_CreateEdit_TitlePlaceholder = "Saisir le titre de la configuration";
var Reporting_Transmitters_CreateEdit_TypePlaceholder = "S\xe9lectionner un type";
var Reporting_Transmitters_CreateEdit_TypeTootltip = "L’option \xab\xa0fourni par le client\xa0\xbb fait r\xe9f\xe9rence \xe0 un fichier interne qui se trouve en dehors de Degreed. L’option \xab\xa0FTP de Degreed\xa0\xbb fait r\xe9f\xe9rence \xe0 un fichier externe qui se trouve dans Degreed.";
var Reporting_Transmitters_CreateEdit_Username = "Nom d’utilisateur";
var Reporting_Transmitters_CreateEdit_UsernamePlaceholder = "Saisir le nom d’utilisateur";
var Reporting_Transmitters_CreateNew = "Cr\xe9er";
var Reporting_Transmitters_Default = "Par d\xe9faut";
var Reporting_Transmitters_Error_Create = "Erreur lors de la cr\xe9ation de la configuration de l’\xe9metteur";
var Reporting_Transmitters_Error_Delete = "Erreur lors de la suppression de la configuration de l’\xe9metteur";
var Reporting_Transmitters_Error_Get = "Erreur lors de la r\xe9cup\xe9ration de la configuration de l’\xe9metteur";
var Reporting_Transmitters_Error_GetAll = "Erreur lors de la r\xe9cup\xe9ration des configurations des \xe9metteurs";
var Reporting_Transmitters_Error_GetPGPKey = "Erreur lors de la r\xe9cup\xe9ration de la cl\xe9 de chiffrement\xa0PGP";
var Reporting_Transmitters_Error_SavePGPKey = "Erreur lors de l’enregistrement de la cl\xe9 de chiffrement\xa0PGP";
var Reporting_Transmitters_Error_Update = "Erreur lors de la mise \xe0 jour de la configuration de l’\xe9metteur";
var Reporting_Transmitters_Host = "H\xf4te";
var Reporting_Transmitters_PGPEncrypted = "Chiffrement\xa0PGP";
var Reporting_Transmitters_PGPExtension = "Extension\xa0PGP";
var Reporting_Transmitters_Port = "Port";
var Reporting_Transmitters_SetupPGPKey = "Configurer la cl\xe9\xa0PGP";
var Reporting_Transmitters_SetupPGPKeyLabel = "Saisir la cl\xe9 publique";
var Reporting_Transmitters_SetupPGPKeyPlaceholder = "Saisir la cl\xe9\xa0PGP ici";
var Reporting_Transmitters_SetupPGPKeyPlaceholderFilled = "Les {{count}}\xa0derniers caract\xe8res de votre cl\xe9 actuelle sont les suivants\xa0: {{chars}}";
var Reporting_Transmitters_SetupPGPKeyTooltip = "La cl\xe9\xa0PGP s’appliquera \xe0 toutes les configurations cr\xe9\xe9es.";
var Reporting_Transmitters_SFTP = "SFTP";
var Reporting_Transmitters_Success_Create = "La configuration de l’\xe9metteur a bien \xe9t\xe9 cr\xe9\xe9e.";
var Reporting_Transmitters_Success_Delete = "La configuration de l’\xe9metteur a bien \xe9t\xe9 supprim\xe9e.";
var Reporting_Transmitters_Success_SavePGPKey = "La cl\xe9 de chiffrement\xa0PGP a bien \xe9t\xe9 enregistr\xe9e.";
var Reporting_Transmitters_Success_Update = "La configuration de l’\xe9metteur a bien \xe9t\xe9 mise \xe0 jour.";
var Reporting_Transmitters_Title = "Titre";
var Reporting_Transmitters_Type = "Type";
var Reporting_Transmitters_TypeOptionClientProvided = "FTP fourni par le client";
var Reporting_Transmitters_TypeOptionDegreed = "FTP de Degreed";
var ReportingContentSvc_All = "Tous les types";
var ReportingContentSvc_ChartIDflexPathwaySections = "Parcours";
var ReportingContentSvc_ChartIDlearningChart = "Bilan des formations";
var ReportingContentSvc_ChartIDpopularCategories = "Comp\xe9tences populaires";
var ReportingContentSvc_ChartIDpopularProviders = "Fournisseurs populaires";
var ReportingContentSvc_ChartIDpopularSearches = "Recherches populaires";
var ReportingContentSvc_ChartIDrecommendationsStatus = "Contenus partag\xe9s ou assign\xe9s";
var ReportingContentSvc_ChartIDskillRatings = "Synth\xe8se des \xe9valuations de comp\xe9tences";
var ReportingContentSvc_ChartIDtopGroups = "Groupes les plus actifs";
var ReportingContentSvc_ExternalContent = "Contenu externe";
var ReportingContentSvc_ImageAltText = "capture d’\xe9cran d’un espace r\xe9serv\xe9 flout\xe9 utilis\xe9 pour illustrer ce type de rapport";
var ReportingContentSvc_InternalContent = "Contenu interne";
var ReportingContentSvc_Name = "Nom";
var ReportingContentSvc_NotEnoughActivity = "Activit\xe9 insuffisante";
var ReportingContentSvc_Points = "Points";
var ReportingContentSvc_ReportsNotAvailable = "Donn\xe9es insuffisantes pour les filtres s\xe9lectionn\xe9s.";
var ReportingContentSvc_TotalContentViewed = "Nombre de contenus affich\xe9s";
var ReportingContentSvc_TotalItemsAdded = "Nombre total d’\xe9l\xe9ments ajout\xe9s";
var ReportingContentSvc_TotalItemsCompleted = "Nombre total d’\xe9l\xe9ments termin\xe9s";
var ReportingContentSvc_TotalPointsEarned = "Nombre total de points gagn\xe9s";
var ReportingInApp_Actions_ChooseReportType = "Choisir un type de rapport";
var ReportingInApp_Actions_CreateNewReport = "Cr\xe9er un rapport";
var ReportingInApp_Actions_EditSchedule = "Modifier la planification";
var ReportingInApp_Actions_GenerateReport = "G\xe9n\xe9rer le rapport complet";
var ReportingInApp_Actions_OpenDownloads = "Ouvrir les rapports";
var ReportingInApp_Actions_PreviewReport = "Pr\xe9visualiser le rapport";
var ReportingInApp_Actions_ScheduleReport = "Planifier un rapport";
var ReportingInApp_Actions_ViewReport = "Afficher le rapport";
var ReportingInApp_Categories = "Cat\xe9gories";
var ReportingInApp_Create = "Cr\xe9er";
var ReportingInApp_CustomFields = "Champs personnalis\xe9s";
var ReportingInApp_DataTable_DeliveredDate = "Date de livraison (UTC)";
var ReportingInApp_DataTable_LastRun = "Derni\xe8re ex\xe9cution";
var ReportingInApp_DataTable_NextRun = "Prochaine ex\xe9cution (UTC)";
var ReportingInApp_DataTable_ReportTitle = "Titre du rapport";
var ReportingInApp_DataTable_ReportType = "Type de rapport";
var ReportingInApp_DataTable_Status = "Statut";
var ReportingInApp_DataTable_TimePeriod = "P\xe9riode";
var ReportingInApp_Downloads = "T\xe9l\xe9chargements";
var ReportingInApp_Downloads_Description = "Les rapports planifi\xe9s, en cours de traitement ou pr\xeats \xe0 \xeatre t\xe9l\xe9charg\xe9s figureront sur cette page.";
var ReportingInApp_Downloads_RemovalNotice = "Les rapports sont supprim\xe9s au bout de sept\xa0jours.";
var ReportingInApp_FileFormat_CommaDelimited = "Valeurs s\xe9par\xe9es par des virgules";
var ReportingInApp_FileFormat_Excel = "Excel";
var ReportingInApp_Filters_Button_Filter = "Filtre";
var ReportingInApp_Filters_Modal_Button_AddColumn = "Ajouter une colonne";
var ReportingInApp_Filters_Modal_Button_Remove = "Supprimer le filtre";
var ReportingInApp_Filters_Modal_Header_Title = "Filtre";
var ReportingInApp_Filters_Modal_Header_Tooltip = "Vous pouvez ajouter jusqu’\xe0 5\xa0noms de colonne.";
var ReportingInApp_Filters_Modal_Hint_Number = "Ne saisissez qu’une seule valeur num\xe9rique.";
var ReportingInApp_Filters_Modal_Hint_String = "Vous pouvez saisir jusqu’\xe0 {{count}}\xa0valeurs.";
var ReportingInApp_Filters_Modal_Label_Column = "Nom de la colonne";
var ReportingInApp_Filters_Modal_Label_Date = "Date";
var ReportingInApp_Filters_Modal_Label_Operator = "Op\xe9rateur";
var ReportingInApp_Filters_Modal_Label_Value = "Valeur(s)";
var ReportingInApp_Filters_Modal_Operator_Contains = "Contient";
var ReportingInApp_Filters_Modal_Operator_DoesNotEqual = "N’est pas \xe9gal \xe0";
var ReportingInApp_Filters_Modal_Operator_Empty = "Vide";
var ReportingInApp_Filters_Modal_Operator_EndsWith = "Se termine par";
var ReportingInApp_Filters_Modal_Operator_Equals = "Est \xe9gal \xe0";
var ReportingInApp_Filters_Modal_Operator_EqualsOrGreaterThan = "Est \xe9gal ou sup\xe9rieur \xe0";
var ReportingInApp_Filters_Modal_Operator_EqualsOrLessThan = "Est \xe9gal ou inf\xe9rieur \xe0";
var ReportingInApp_Filters_Modal_Operator_Exact = "Exact";
var ReportingInApp_Filters_Modal_Operator_StartsWith = "Commence par";
var ReportingInApp_Filters_Modal_Placeholder_Column = "S\xe9lectionner une colonne";
var ReportingInApp_Filters_Modal_Placeholder_Operator = "S\xe9lectionner un op\xe9rateur";
var ReportingInApp_Filters_Modal_Placeholder_Value = "Valeur";
var ReportingInApp_Filters_Modal_UnselectedColumn_Notice = "Cette colonne n’est pas s\xe9lectionn\xe9e dans la liste d\xe9roulante Modifier les colonnes. Vous pouvez filtrer le rapport en fonction de cette colonne, mais elle ne s’affichera pas dans les r\xe9sultats du rapport.";
var ReportingInApp_GeneratedReports = "Rapports g\xe9n\xe9r\xe9s";
var ReportingInApp_ReportCategories = "Cat\xe9gories de rapports";
var ReportingInApp_ReportCategory_ACM_Description = "Afficher les d\xe9tails sur vos acad\xe9mies et les programmes de la marketplace de contenus.";
var ReportingInApp_ReportCategory_ACM_Title = "Acad\xe9mies et Marketplace de contenus";
var ReportingInApp_ReportCategory_Assignments_Description = "Affichez le d\xe9tail des formations assign\xe9es au sein de votre organisation.";
var ReportingInApp_ReportCategory_Assignments_Title = "Formations assign\xe9es";
var ReportingInApp_ReportCategory_Content_Description = "Affichez les d\xe9tails sur l’engagement avec le contenu au sein de votre organisation.";
var ReportingInApp_ReportCategory_Content_Title = "Contenu";
var ReportingInApp_ReportCategory_Opportunities_Description = "Affichez le d\xe9tail des opportunit\xe9s au sein de votre organisation.";
var ReportingInApp_ReportCategory_Opportunities_Title = "Opportunit\xe9s";
var ReportingInApp_ReportCategory_Skills_Description = "Affichez le d\xe9tail des comp\xe9tences et leur utilisation dans votre organisation.";
var ReportingInApp_ReportCategory_Skills_Title = "Comp\xe9tences";
var ReportingInApp_ReportCategory_User_Description = "Affichez des informations d\xe9taill\xe9es sur les groupes d’utilisateurs.";
var ReportingInApp_ReportCategory_User_Title = "Utilisateur";
var ReportingInApp_ReportCategorySection_Details_Description = "Ces rapports fournissent des informations d\xe9taill\xe9es sur chaque occurrence d’une activit\xe9.";
var ReportingInApp_ReportCategorySection_Details_Title = "Rapports d\xe9taill\xe9s";
var ReportingInApp_ReportCategorySection_Summary_Description = "Ces rapports vous fournissent une synth\xe8se des donn\xe9es, dont le   nombre d’occurrences d’une activit\xe9";
var ReportingInApp_ReportCategorySection_Summary_Title = "Rapports de synth\xe8se";
var ReportingInApp_ReportColumn_AbsoluteParticipantCount = "Nombre total de participants";
var ReportingInApp_ReportColumn_AcademyId = "Identifiant de l’acad\xe9mie";
var ReportingInApp_ReportColumn_AcademyName = "Nom de l’acad\xe9mie";
var ReportingInApp_ReportColumn_AcademyProgressPercent = "Pourcentage de progression dans l’acad\xe9mie";
var ReportingInApp_ReportColumn_AcademyTitle = "Nom de l’acad\xe9mie";
var ReportingInApp_ReportColumn_AcademyUrl = "URL de l’acad\xe9mie";
var ReportingInApp_ReportColumn_Active = "Actif";
var ReportingInApp_ReportColumn_AdditionalLearning = "Formation suppl\xe9mentaire";
var ReportingInApp_ReportColumn_ApplicationStage = "\xc9tape de candidature";
var ReportingInApp_ReportColumn_ApplicationUrl = "URL de la demande";
var ReportingInApp_ReportColumn_Approver = "Approbateur";
var ReportingInApp_ReportColumn_ApproverEmail = "E-mail de l’approbateur";
var ReportingInApp_ReportColumn_ApproverFirstName = "Pr\xe9nom de l’approbateur";
var ReportingInApp_ReportColumn_ApproverId = "ID de l’approbateur";
var ReportingInApp_ReportColumn_ApproverLastName = "Nom de l’approbateur";
var ReportingInApp_ReportColumn_ApproverName = "Nom complet de l’approbateur";
var ReportingInApp_ReportColumn_AssignedDate = "Date d’assignation";
var ReportingInApp_ReportColumn_AssigneeEmail = "E-mail du destinataire";
var ReportingInApp_ReportColumn_AssigneeEmployeeId = "ID d’employ\xe9 du destinataire";
var ReportingInApp_ReportColumn_AssigneeFirstName = "Pr\xe9nom du destinataire";
var ReportingInApp_ReportColumn_AssigneeLastName = "Nom du destinataire";
var ReportingInApp_ReportColumn_AssigneeUserName = "Nom complet du destinataire";
var ReportingInApp_ReportColumn_AssignerEmail = "E-mail du responsable de l’assignation";
var ReportingInApp_ReportColumn_AssignerEmployeeId = "ID d’employ\xe9 du responsable de l’assignation";
var ReportingInApp_ReportColumn_AssignerFirstName = "Pr\xe9nom du responsable de l’assignation";
var ReportingInApp_ReportColumn_AssignerLastName = "Nom du responsable de l’assignation";
var ReportingInApp_ReportColumn_AssignerUserName = "Nom complet du responsable de l’assignation";
var ReportingInApp_ReportColumn_AssignmentIsCompleted = "Termin\xe9e";
var ReportingInApp_ReportColumn_AssignmentsCompleted = "Formations assign\xe9es termin\xe9es";
var ReportingInApp_ReportColumn_AssinmentStatus = "Statut de la formation assign\xe9e";
var ReportingInApp_ReportColumn_AverageCompletionPercent = "Pourcentage moyen de compl\xe9tion";
var ReportingInApp_ReportColumn_AverageManagerRatingsAdded = "\xc9valuations du manager ajout\xe9es (moyenne)";
var ReportingInApp_ReportColumn_AverageMangerRating = "\xc9valuation du manager (moyenne)";
var ReportingInApp_ReportColumn_AverageOptOutCount = "Nombre de d\xe9sinscriptions (moyenne)";
var ReportingInApp_ReportColumn_AveragePeerRatings = "\xc9valuation par les pairs (moyenne)";
var ReportingInApp_ReportColumn_AverageSelfRating = "Auto-\xe9valuation (moyenne)";
var ReportingInApp_ReportColumn_AverageSkillTargetRating = "\xc9valuation des cibles de comp\xe9tences (moyenne)";
var ReportingInApp_ReportColumn_AverageSkillTargetsAdded = "Cibles de comp\xe9tences ajout\xe9es (moyenne)";
var ReportingInApp_ReportColumn_AverageTeamFocusSkills = "Comp\xe9tences prioritaires pour l’\xe9quipe (moyenne)";
var ReportingInApp_ReportColumn_AverageTeamSize = "Taille de l’\xe9quipe (moyenne)";
var ReportingInApp_ReportColumn_BeingFollowedEmployeeId = "ID d’employ\xe9 de l’utilisateur suivi";
var ReportingInApp_ReportColumn_BeingFollowedUserEmail = "E-mail de l’utilisateur suivi";
var ReportingInApp_ReportColumn_BeingFollowedUserFirstName = "Pr\xe9nom de l’utilisateur suivi";
var ReportingInApp_ReportColumn_BeingFollowedUserLastName = "Nom de l’utilisateur suivi";
var ReportingInApp_ReportColumn_BeingFollowedUserName = "Nom complet de l’utilisateur suivi";
var ReportingInApp_ReportColumn_Category = "Cat\xe9gorie";
var ReportingInApp_ReportColumn_Collaborators = "Collaborateurs";
var ReportingInApp_ReportColumn_CollaboratorsEmployeeId = "ID d’employ\xe9 des collaborateurs";
var ReportingInApp_ReportColumn_CollaboratorsUserName = "Nom complet des collaborateurs";
var ReportingInApp_ReportColumn_CompletedContent = "Contenu termin\xe9";
var ReportingInApp_ReportColumn_CompletedCount = "Total d’utilisateurs ayant termin\xe9 \xe0 100\xa0%";
var ReportingInApp_ReportColumn_CompletedDate = "Date de fin";
var ReportingInApp_ReportColumn_CompletedOn = "Date de compl\xe9tion";
var ReportingInApp_ReportColumn_CompletedRequiredContent = "Nombre de contenus obligatoires termin\xe9s ";
var ReportingInApp_ReportColumn_CompletionCompletedDate = "Date de fin";
var ReportingInApp_ReportColumn_CompletionCreatedDate = "Date de cr\xe9ation";
var ReportingInApp_ReportColumn_CompletionDate = "Derni\xe8re date de compl\xe9tion de la ressource ou d’ajout de comp\xe9tence";
var ReportingInApp_ReportColumn_CompletionIsVerified = "Compl\xe9tion valid\xe9e";
var ReportingInApp_ReportColumn_CompletionPercent = "Pourcentage de compl\xe9tion";
var ReportingInApp_ReportColumn_CompletionPercentage = "Pourcentage de compl\xe9tion";
var ReportingInApp_ReportColumn_CompletionPoints = "Points de compl\xe9tion";
var ReportingInApp_ReportColumn_Completions = "\xc9l\xe9ments termin\xe9s";
var ReportingInApp_ReportColumn_CompletionTags = "Mots-cl\xe9s li\xe9s aux compl\xe9tions (th\xe8mes)";
var ReportingInApp_ReportColumn_CompletionUserRating = "\xc9valuation de l’\xe9l\xe9ment par l’utilisateur";
var ReportingInApp_ReportColumn_ContentCompleted = "Contenu termin\xe9";
var ReportingInApp_ReportColumn_ContentCompletedCount = "Contenu termin\xe9";
var ReportingInApp_ReportColumn_ContentCompletedDate = "Date de compl\xe9tion du contenu";
var ReportingInApp_ReportColumn_ContentDescription = "Description du contenu";
var ReportingInApp_ReportColumn_ContentDuration = "Dur\xe9e du contenu";
var ReportingInApp_ReportColumn_ContentDurationType = "Type de dur\xe9e du contenu";
var ReportingInApp_ReportColumn_ContentId = "Identifiant du contenu";
var ReportingInApp_ReportColumn_ContentOwnerName = "Nom du propri\xe9taire du contenu";
var ReportingInApp_ReportColumn_ContentProvider = "Fournisseur de contenu";
var ReportingInApp_ReportColumn_ContentTitle = "Titre du contenu";
var ReportingInApp_ReportColumn_ContentType = "Type de contenu";
var ReportingInApp_ReportColumn_ContentUrl = "URL du contenu";
var ReportingInApp_ReportColumn_Contributors = "Contributeurs";
var ReportingInApp_ReportColumn_Cost = "Co\xfbt";
var ReportingInApp_ReportColumn_CostCenter = "Centre de co\xfbts";
var ReportingInApp_ReportColumn_CreatedBy = "Cr\xe9\xe9 par";
var ReportingInApp_ReportColumn_CreatedByEmail = "Cr\xe9\xe9 par (Adresse e-mail)";
var ReportingInApp_ReportColumn_CreatedByEmployeeId = "Cr\xe9\xe9 par (ID d’employ\xe9)";
var ReportingInApp_ReportColumn_CreatedByFirstName = "Cr\xe9\xe9 par (Pr\xe9nom)";
var ReportingInApp_ReportColumn_CreatedById = "Cr\xe9\xe9 par (ID)";
var ReportingInApp_ReportColumn_CreatedByLastName = "Cr\xe9\xe9 par (Nom de famille)";
var ReportingInApp_ReportColumn_CreatedByName = "Cr\xe9\xe9 par (Nom)";
var ReportingInApp_ReportColumn_CreatedByUserName = "Cr\xe9\xe9 par (Nom complet)";
var ReportingInApp_ReportColumn_CreatedDate = "Date de cr\xe9ation";
var ReportingInApp_ReportColumn_CreatedDateOfOpportunity = "Cr\xe9\xe9 le (Date de l’opportunit\xe9)";
var ReportingInApp_ReportColumn_CreatedOn = "Cr\xe9\xe9(e) le";
var ReportingInApp_ReportColumn_Currency = "Devise";
var ReportingInApp_ReportColumn_DailyDigestEmail = "E-mail des tendances du jour";
var ReportingInApp_ReportColumn_DateAdded = "Date d’ajout";
var ReportingInApp_ReportColumn_DateApprovedOrDeclined = "Date d’approbation ou de refus";
var ReportingInApp_ReportColumn_DateInvited = "Date d’invitation";
var ReportingInApp_ReportColumn_DateJoined = "Date d’inscription";
var ReportingInApp_ReportColumn_DateOfLastContentCompletion = "Derni\xe8re date de compl\xe9tion";
var ReportingInApp_ReportColumn_DateSearched = "Date de recherche";
var ReportingInApp_ReportColumn_DateShared = "Date de partage";
var ReportingInApp_ReportColumn_DateUserInterested = "Date de manifestation d’int\xe9r\xeat par l’utilisateur";
var ReportingInApp_ReportColumn_DateViewed = "Date de visualisation";
var ReportingInApp_ReportColumn_Department = "Service";
var ReportingInApp_ReportColumn_Description = "Description";
var ReportingInApp_ReportColumn_DirectReportEmail = "Adresse e-mail du subordonn\xe9 direct";
var ReportingInApp_ReportColumn_DirectReportFirstName = "Pr\xe9nom du subordonn\xe9 direct";
var ReportingInApp_ReportColumn_DirectReportId = "ID du subordonn\xe9 direct";
var ReportingInApp_ReportColumn_DirectReportLastName = "Nom du subordonn\xe9 direct";
var ReportingInApp_ReportColumn_DirectReportName = "Nom complet du subordonn\xe9 direct";
var ReportingInApp_ReportColumn_Discriminator = "Type de programme";
var ReportingInApp_ReportColumn_DueDate = "\xc9ch\xe9ance";
var ReportingInApp_ReportColumn_DueDateLocal = "Date limite locale";
var ReportingInApp_ReportColumn_Duration = "Dur\xe9e";
var ReportingInApp_ReportColumn_DurationInMinutes = "Dur\xe9e en minutes";
var ReportingInApp_ReportColumn_DurationUnitName = "Nom de l’unit\xe9 de dur\xe9e";
var ReportingInApp_ReportColumn_DurationUnits = "Unit\xe9s de dur\xe9e";
var ReportingInApp_ReportColumn_EmployeeId = "ID d’employ\xe9";
var ReportingInApp_ReportColumn_Endorsed = "Recommand\xe9";
var ReportingInApp_ReportColumn_Enrolled = "Inscrit";
var ReportingInApp_ReportColumn_EnrolledUsers = "Utilisateurs inscrits";
var ReportingInApp_ReportColumn_EstimatedLearningHours = "Heures de formation estim\xe9es";
var ReportingInApp_ReportColumn_EstimatedLearningMinutes = "Minutes de formation estim\xe9es";
var ReportingInApp_ReportColumn_ExtractionDate = "ReportingInApp_ReportColumn_ExtractionDate";
var ReportingInApp_ReportColumn_Feedback = "Feedback";
var ReportingInApp_ReportColumn_FirstLogin = "Premi\xe8re connexion";
var ReportingInApp_ReportColumn_FollowerEmployeeId = "ID d’employ\xe9 de l’utilisateur abonn\xe9";
var ReportingInApp_ReportColumn_FollowerManagerId = "ID du manager de l’abonn\xe9";
var ReportingInApp_ReportColumn_FollowerManagerName = "Nom du manager de l’abonn\xe9";
var ReportingInApp_ReportColumn_FollowerUserEmail = "E-mail de l’utilisateur abonn\xe9";
var ReportingInApp_ReportColumn_FollowerUserFirstName = "Pr\xe9nom de l’utilisateur abonn\xe9";
var ReportingInApp_ReportColumn_FollowerUserLastName = "Nom de l’utilisateur abonn\xe9";
var ReportingInApp_ReportColumn_FollowerUserName = "Nom complet de l’utilisateur abonn\xe9";
var ReportingInApp_ReportColumn_FollowerUserStatus = "Statut de l’utilisateur abonn\xe9";
var ReportingInApp_ReportColumn_Group = "Groupe";
var ReportingInApp_ReportColumn_GroupName = "Nom du groupe";
var ReportingInApp_ReportColumn_GroupRole = "R\xf4le du groupe";
var ReportingInApp_ReportColumn_GroupsVisibility = "Visibilit\xe9 des groupes";
var ReportingInApp_ReportColumn_InterestedEmail = "E-mail de l’utilisateur int\xe9ress\xe9";
var ReportingInApp_ReportColumn_InterestedEmployeeId = "ID d’employ\xe9 de l’utilisateur int\xe9ress\xe9";
var ReportingInApp_ReportColumn_InterestedUserFirstName = "Pr\xe9nom de l’utilisateur int\xe9ress\xe9";
var ReportingInApp_ReportColumn_InterestedUserLastName = "Nom de famille de l’utilisateur int\xe9ress\xe9";
var ReportingInApp_ReportColumn_InterestedUserName = "Nom complet de l’utilisateur int\xe9ress\xe9";
var ReportingInApp_ReportColumn_InterestedUserSkillMatch = "Correspondance des comp\xe9tences de l’utilisateur int\xe9ress\xe9";
var ReportingInApp_ReportColumn_InterestedUserStage = "\xc9tape de l’utilisateur int\xe9ress\xe9";
var ReportingInApp_ReportColumn_InternalExternalContent = "Contenu interne/externe";
var ReportingInApp_ReportColumn_InternalId = "Identifiant interne";
var ReportingInApp_ReportColumn_InternalManagerRatings = "\xc9valuations du manager";
var ReportingInApp_ReportColumn_InternalSelfRatings = "Auto-\xe9valuations";
var ReportingInApp_ReportColumn_InternalSkillReviews = "Revues de comp\xe9tences";
var ReportingInApp_ReportColumn_IsCompanySpecificProgram = "Le programme est-il sp\xe9cifique \xe0 l’entreprise\xa0?";
var ReportingInApp_ReportColumn_IsFollowing = "Suivi";
var ReportingInApp_ReportColumn_ItemId = "ID de l’\xe9l\xe9ment";
var ReportingInApp_ReportColumn_ItemName = "Intitul\xe9 de l’\xe9l\xe9ment";
var ReportingInApp_ReportColumn_ItemType = "Type d’\xe9l\xe9ment";
var ReportingInApp_ReportColumn_JobRole = "Poste";
var ReportingInApp_ReportColumn_Language = "Langue";
var ReportingInApp_ReportColumn_LastLogin = "Derni\xe8re connexion";
var ReportingInApp_ReportColumn_LastRatedDate = "Date de la derni\xe8re \xe9valuation";
var ReportingInApp_ReportColumn_LastUpdated = "Derni\xe8re mise \xe0 jour";
var ReportingInApp_ReportColumn_LastUpdateDate = "Date de la derni\xe8re mise \xe0 jour";
var ReportingInApp_ReportColumn_LastUpdatedOfOpportunity = "Derni\xe8re mise \xe0 jour de l’opportunit\xe9";
var ReportingInApp_ReportColumn_LatestCompletionDate = "Derni\xe8re date de compl\xe9tion";
var ReportingInApp_ReportColumn_LearnerStatus = "Statut de l’apprenant";
var ReportingInApp_ReportColumn_LessonDescription = "Description de la le\xe7on";
var ReportingInApp_ReportColumn_LessonNumber = "Num\xe9ro de la le\xe7on";
var ReportingInApp_ReportColumn_LessonTitle = "Intitul\xe9 de la le\xe7on";
var ReportingInApp_ReportColumn_Location = "Lieu";
var ReportingInApp_ReportColumn_LoggedInDate = "Date de connexion";
var ReportingInApp_ReportColumn_ManagerCount = "Nombre de managers";
var ReportingInApp_ReportColumn_ManagerEmail = "Adresse e-mail du manager";
var ReportingInApp_ReportColumn_ManagerEmployeeId = "ID d’employ\xe9 du manager";
var ReportingInApp_ReportColumn_ManagerFirstName = "Pr\xe9nom du manager";
var ReportingInApp_ReportColumn_ManagerId = "Identifiant du manager";
var ReportingInApp_ReportColumn_ManagerLastName = "Nom du manager";
var ReportingInApp_ReportColumn_ManagerName = "Nom complet du manager";
var ReportingInApp_ReportColumn_ManagerRating = "\xc9valuations du manager";
var ReportingInApp_ReportColumn_ManagerRatingAverage = "\xc9valuation du manager (moyenne)";
var ReportingInApp_ReportColumn_MarketplaceTitle = "Titre sur la marketplace";
var ReportingInApp_ReportColumn_MenteeEmail = "E-mail du mentor\xe9";
var ReportingInApp_ReportColumn_MenteeEmployeeId = "ID d’employ\xe9 du mentor\xe9";
var ReportingInApp_ReportColumn_MenteeUserFirstName = "Pr\xe9nom du mentor\xe9";
var ReportingInApp_ReportColumn_MenteeUserLastName = "Nom de famille du mentor\xe9";
var ReportingInApp_ReportColumn_MenteeUserName = "Nom complet du mentor\xe9";
var ReportingInApp_ReportColumn_MentorEmployeeId = "ID d’employ\xe9 du mentor";
var ReportingInApp_ReportColumn_MentorUserEmail = "E-mail du mentor";
var ReportingInApp_ReportColumn_MentorUserFirstName = "Pr\xe9nom du mentor";
var ReportingInApp_ReportColumn_MentorUserLastName = "Nom de famille du mentor";
var ReportingInApp_ReportColumn_MentorUserName = "Nom complet du mentor";
var ReportingInApp_ReportColumn_Nominated = "Nomination";
var ReportingInApp_ReportColumn_NoReply = "Pas de r\xe9ponse";
var ReportingInApp_ReportColumn_NumberOfInterestedCandidates = "Nombre de candidats int\xe9ress\xe9s";
var ReportingInApp_ReportColumn_NumberOfMatchedCandidates = "Nombre de candidats qualifi\xe9s";
var ReportingInApp_ReportColumn_NumberOfRequiredSkills = "Nombre de comp\xe9tences requises";
var ReportingInApp_ReportColumn_NumberOfSelectedCandidates = "Nombre de candidats s\xe9lectionn\xe9s";
var ReportingInApp_ReportColumn_NumberOfShares = "Nombre de partages";
var ReportingInApp_ReportColumn_NumberOfShortlistedCandidates = "Nombre de candidats s\xe9lectionn\xe9s";
var ReportingInApp_ReportColumn_OpportunityDescription = "Description de l’opportunit\xe9";
var ReportingInApp_ReportColumn_OpportunityId = "ID de l’opportunit\xe9";
var ReportingInApp_ReportColumn_OpportunityIsObsolete = "L’opportunit\xe9 est obsol\xe8te";
var ReportingInApp_ReportColumn_OpportunityOwnerEmployeeId = "ID d’employ\xe9 du propri\xe9taire de l’opportunit\xe9";
var ReportingInApp_ReportColumn_OpportunityOwnerUserName = "Nom complet du propri\xe9taire de l’opportunit\xe9";
var ReportingInApp_ReportColumn_OpportunitySkills = "Comp\xe9tences requises pour cette opportunit\xe9";
var ReportingInApp_ReportColumn_OpportunityStatus = "Statut de l’opportunit\xe9";
var ReportingInApp_ReportColumn_OpportunityTitle = "Titre de l’opportunit\xe9";
var ReportingInApp_ReportColumn_OpportunityType = "Type d’opportunit\xe9";
var ReportingInApp_ReportColumn_OpportunityUrl = "URL de l’opportunit\xe9";
var ReportingInApp_ReportColumn_OpportunityVisibility = "Visibilit\xe9 de l’opportunit\xe9";
var ReportingInApp_ReportColumn_OptOut = "D\xe9sinscription";
var ReportingInApp_ReportColumn_OptOutCount = "Nombre de d\xe9sinscriptions";
var ReportingInApp_ReportColumn_Order = "Ordre";
var ReportingInApp_ReportColumn_PathwayCompletedCount = "Parcours termin\xe9s";
var ReportingInApp_ReportColumn_PathwayContentCount = "Contenus dans le parcours (total)";
var ReportingInApp_ReportColumn_PathwayFollowDate = "Date de suivi";
var ReportingInApp_ReportColumn_PathwayFollowedCount = "Parcours suivis/assign\xe9s";
var ReportingInApp_ReportColumn_PathwayId = "ID de parcours";
var ReportingInApp_ReportColumn_PathwayProgress = "Progression du parcours";
var ReportingInApp_ReportColumn_PathwayRequiredContentCount = "Contenu total du parcours requis";
var ReportingInApp_ReportColumn_Pathways = "Parcours";
var ReportingInApp_ReportColumn_PathwayTitle = "Intitul\xe9 du parcours";
var ReportingInApp_ReportColumn_PathwayTopic = "Th\xe8me du parcours";
var ReportingInApp_ReportColumn_PathwayType = "Type de parcours";
var ReportingInApp_ReportColumn_PathwayUrl = "URL du parcours";
var ReportingInApp_ReportColumn_PathwayUserCount = "Nombre total d’utilisateurs actifs dans le parcours";
var ReportingInApp_ReportColumn_PeerRatings = "\xc9valuations par un pair";
var ReportingInApp_ReportColumn_PercentOfSkillsMatched = "Pourcentage de comp\xe9tences correspondantes";
var ReportingInApp_ReportColumn_PermissionRole = "R\xf4le d’autorisation";
var ReportingInApp_ReportColumn_PlanFollowedCount = "Plans suivis";
var ReportingInApp_ReportColumn_PlanId = "Identifiant du plan";
var ReportingInApp_ReportColumn_Plans = "Plans";
var ReportingInApp_ReportColumn_PlanTitle = "Titre du plan";
var ReportingInApp_ReportColumn_PlanType = "Type de plan";
var ReportingInApp_ReportColumn_PlanUrl = "URL du plan";
var ReportingInApp_ReportColumn_PreapprovalRequired = "Approbation pr\xe9alable requise";
var ReportingInApp_ReportColumn_ProfilePrivacy = "Confidentialit\xe9 du profil";
var ReportingInApp_ReportColumn_ProgramCostAmount = "Co\xfbt du programme";
var ReportingInApp_ReportColumn_ProgramCostCurrency = "Devise de facturation du programme";
var ReportingInApp_ReportColumn_ProgramDuration = "Dur\xe9e du programme";
var ReportingInApp_ReportColumn_ProgramDurationUnit = "Unit\xe9 de dur\xe9e du programme";
var ReportingInApp_ReportColumn_ProgramId = "ID du programme";
var ReportingInApp_ReportColumn_ProgramLength = "Dur\xe9e du programme";
var ReportingInApp_ReportColumn_ProgramLengthUnit = "Unit\xe9 de la dur\xe9e du programme";
var ReportingInApp_ReportColumn_ProgramName = "Intitul\xe9 du programme";
var ReportingInApp_ReportColumn_ProgramTitle = "Titre du programme";
var ReportingInApp_ReportColumn_Provider = "Fournisseur";
var ReportingInApp_ReportColumn_ProviderName = "Nom du fournisseur";
var ReportingInApp_ReportColumn_PublishedDate = "Date de publication";
var ReportingInApp_ReportColumn_RealTimeEmailNotification = "Notification par e-mail en temps r\xe9el";
var ReportingInApp_ReportColumn_RecipientEmail = "E-mail du destinataire";
var ReportingInApp_ReportColumn_RecipientEmployeeId = "ID d’employ\xe9 du destinataire";
var ReportingInApp_ReportColumn_RecipientGroupName = "Nom de groupe du destinataire";
var ReportingInApp_ReportColumn_RecipientUserFirstName = "Pr\xe9nom du destinataire";
var ReportingInApp_ReportColumn_RecipientUserLastName = "Nom de famille du destinataire";
var ReportingInApp_ReportColumn_RecipientUserName = "Nom complet du destinataire";
var ReportingInApp_ReportColumn_RecommendationType = "Type de recommandation";
var ReportingInApp_ReportColumn_RepliedNo = "R\xe9ponses n\xe9gatives";
var ReportingInApp_ReportColumn_RepliedYes = "R\xe9ponses positives";
var ReportingInApp_ReportColumn_RequestedAmount = "Montant demand\xe9";
var ReportingInApp_ReportColumn_RequestedAmountCurrency = "Devise du montant demand\xe9";
var ReportingInApp_ReportColumn_RequestedAmountUSD = "Montant demand\xe9 en USD";
var ReportingInApp_ReportColumn_RequestedDate = "Date de la demande";
var ReportingInApp_ReportColumn_RequestId = "ID de la demande";
var ReportingInApp_ReportColumn_RequestType = "Type de demande";
var ReportingInApp_ReportColumn_Required = "Obligatoire";
var ReportingInApp_ReportColumn_RequiredSkill = "Requise";
var ReportingInApp_ReportColumn_ResourceId = "Identifiant de la ressource";
var ReportingInApp_ReportColumn_ResourceTitle = "Titre de la ressource";
var ReportingInApp_ReportColumn_ResourceType = "Type de ressource";
var ReportingInApp_ReportColumn_ResourceUrl = "URL de la ressource";
var ReportingInApp_ReportColumn_RestrictedAccess = "Restriction d’acc\xe8s";
var ReportingInApp_ReportColumn_RsvpStatus = "Confirmation de participation";
var ReportingInApp_ReportColumn_SearchCount = "Nombre de recherches";
var ReportingInApp_ReportColumn_SearchTerm = "Terme de recherche";
var ReportingInApp_ReportColumn_SectionContentCount = "Nombre de contenus dans la section";
var ReportingInApp_ReportColumn_SectionDescription = "Description de la section";
var ReportingInApp_ReportColumn_SectionNumber = "Num\xe9ro de la section";
var ReportingInApp_ReportColumn_SectionOrder = "Ordre de la section";
var ReportingInApp_ReportColumn_SectionTitle = "Titre de la section";
var ReportingInApp_ReportColumn_SegmentName = "Nom du segment";
var ReportingInApp_ReportColumn_SelfRating = "Auto-\xe9valuations";
var ReportingInApp_ReportColumn_SelfRatingAverage = "Auto-\xe9valuation (moyenne)";
var ReportingInApp_ReportColumn_SharedByEmail = "Partag\xe9 par (Adresse e-mail)";
var ReportingInApp_ReportColumn_SharedByEmployeeId = "Partag\xe9 par (ID d’employ\xe9)";
var ReportingInApp_ReportColumn_SharedByFirstName = "Partag\xe9 par (Pr\xe9nom)";
var ReportingInApp_ReportColumn_SharedByLastName = "Partag\xe9 par (Nom de famille)";
var ReportingInApp_ReportColumn_SharedByUserName = "Partag\xe9 par (Nom complet)";
var ReportingInApp_ReportColumn_ShareStatus = "Statut du partage";
var ReportingInApp_ReportColumn_SkillAddedCount = "Comp\xe9tences ajout\xe9es";
var ReportingInApp_ReportColumn_SkillCertificationRating = "\xc9valuation des certifications de comp\xe9tence";
var ReportingInApp_ReportColumn_SkillFocusCount = "Nombre de priorisations de la comp\xe9tence";
var ReportingInApp_ReportColumn_SkillFocusedDate = "Date de priorisation de la comp\xe9tence";
var ReportingInApp_ReportColumn_SkillFollowDate = "Date de suivi de la comp\xe9tence";
var ReportingInApp_ReportColumn_SkillFollowedDate = "Date de suivi de la comp\xe9tence";
var ReportingInApp_ReportColumn_SkillIsFocused = "Comp\xe9tence prioritaire";
var ReportingInApp_ReportColumn_SkillLevelAverage = "Niveau de comp\xe9tence moyen";
var ReportingInApp_ReportColumn_SkillName = "Nom de la comp\xe9tence";
var ReportingInApp_ReportColumn_SkillRatedCount = "Comp\xe9tences \xe9valu\xe9es";
var ReportingInApp_ReportColumn_SkillRatedDate = "Date d’\xe9valuation de la comp\xe9tence";
var ReportingInApp_ReportColumn_SkillRating = "\xc9valuation de la comp\xe9tence";
var ReportingInApp_ReportColumn_SkillRatingLabel = "Libell\xe9 de l’\xe9valuation de la comp\xe9tence";
var ReportingInApp_ReportColumn_SkillRatingPrivacy = "Confidentialit\xe9 de l’\xe9valuation de la comp\xe9tence";
var ReportingInApp_ReportColumn_SkillRatingType = "Type d’\xe9valuation de la comp\xe9tence";
var ReportingInApp_ReportColumn_SkillReviewAverage = "Revue de comp\xe9tence (moyenne)";
var ReportingInApp_ReportColumn_Skills = "Comp\xe9tences";
var ReportingInApp_ReportColumn_SkillStandardName = "Nom de la norme de comp\xe9tences";
var ReportingInApp_ReportColumn_Source = "Source";
var ReportingInApp_ReportColumn_StartDate = "Date de d\xe9but";
var ReportingInApp_ReportColumn_Status = "Statut";
var ReportingInApp_ReportColumn_StatusChangeDate = "Date du changement de statut";
var ReportingInApp_ReportColumn_StepNumber = "Num\xe9ro de l’\xe9tape";
var ReportingInApp_ReportColumn_StepTitle = "Intitul\xe9 de l’\xe9tape";
var ReportingInApp_ReportColumn_StepType = "Type d’\xe9tape";
var ReportingInApp_ReportColumn_SubmissionType = "Type de soumission";
var ReportingInApp_ReportColumn_Summary = "Synth\xe8se";
var ReportingInApp_ReportColumn_TargetFollowDate = "Date de suivi";
var ReportingInApp_ReportColumn_TargetLevel = "Niveau cible";
var ReportingInApp_ReportColumn_TargetRating = "Cibles de la comp\xe9tence";
var ReportingInApp_ReportColumn_TeamFocusSkillList = "Liste des comp\xe9tences prioritaires pour l’\xe9quipe";
var ReportingInApp_ReportColumn_TeamFocusSkillsRatings = "\xc9valuations des comp\xe9tences prioritaires de l’\xe9quipe";
var ReportingInApp_ReportColumn_TeamSize = "Taille de l’\xe9quipe";
var ReportingInApp_ReportColumn_TextResponse = "R\xe9ponse textuelle";
var ReportingInApp_ReportColumn_ThumbnailUrl = "URL de la vignette";
var ReportingInApp_ReportColumn_ThumbsDown = "Je n’aime pas";
var ReportingInApp_ReportColumn_ThumbsUp = "J’aime";
var ReportingInApp_ReportColumn_Title = "Titre";
var ReportingInApp_ReportColumn_TotalAcademyContent = "Contenus dans l’acad\xe9mie (total)";
var ReportingInApp_ReportColumn_TotalAssignments = "Nombre total de formations assign\xe9es";
var ReportingInApp_ReportColumn_TotalDailyLogins = "Total des connexions quotidiennes";
var ReportingInApp_ReportColumn_TotalLearningHours = "Nombre total d’heures de formation";
var ReportingInApp_ReportColumn_TotalLearningMinutes = "Nombre total de minutes de formation";
var ReportingInApp_ReportColumn_TotalManagerRatings = "Nombre total d’\xe9valuations du manager";
var ReportingInApp_ReportColumn_TotalManagerRatingsAdded = "\xc9valuations du manager ajout\xe9es (total)";
var ReportingInApp_ReportColumn_TotalPathwayContent = "Contenus dans le parcours (total)";
var ReportingInApp_ReportColumn_TotalPeerRatings = "\xc9valuations par les pairs (total)";
var ReportingInApp_ReportColumn_TotalPoints = "Total des points";
var ReportingInApp_ReportColumn_TotalRequiredPathwayContent = "Contenus requis dans le parcours (total)";
var ReportingInApp_ReportColumn_TotalSelfRatings = "Nombre total d’auto-\xe9valuations";
var ReportingInApp_ReportColumn_TotalSkillReviews = "Nombre total de revues de comp\xe9tence";
var ReportingInApp_ReportColumn_TotalSkillsFocused = "Nombre total de comp\xe9tences prioritaires";
var ReportingInApp_ReportColumn_TotalSkillsFollowed = "Nombre total de comp\xe9tences suivies";
var ReportingInApp_ReportColumn_TotalSkillTargetsAdded = "Cibles de comp\xe9tences ajout\xe9es (total)";
var ReportingInApp_ReportColumn_TotalTeamFocusSkills = "Comp\xe9tences prioritaires pour l’\xe9quipe (total)";
var ReportingInApp_ReportColumn_TotalUsersActive = "Nombre total d’utilisateurs actifs dans le plan";
var ReportingInApp_ReportColumn_TotalUsersActiveInAcademy = "Total d’utilisateurs actifs dans l’acad\xe9mie";
var ReportingInApp_ReportColumn_Type = "Type";
var ReportingInApp_ReportColumn_UnmatchedSkills = "Comp\xe9tences manquantes";
var ReportingInApp_ReportColumn_Url = "URL";
var ReportingInApp_ReportColumn_UserCompanyId = "Identifiant d’entreprise de l’utilisateur";
var ReportingInApp_ReportColumn_UserCompletionStatus = "\xc9tat d’avancement de l’utilisateur";
var ReportingInApp_ReportColumn_UserCreatedDate = "Date de cr\xe9ation de l’utilisateur";
var ReportingInApp_ReportColumn_UserEmail = "E-mail de l’utilisateur";
var ReportingInApp_ReportColumn_UserFirstName = "Pr\xe9nom de l’utilisateur";
var ReportingInApp_ReportColumn_UserId = "ID de l’utilisateur";
var ReportingInApp_ReportColumn_UserLastName = "Nom de l’utilisateur";
var ReportingInApp_ReportColumn_UserName = "Nom complet de l’utilisateur";
var ReportingInApp_ReportColumn_UserNote = "Note de l’utilisateur";
var ReportingInApp_ReportColumn_UserPlanStatus = "Statut du plan de l’utilisateur";
var ReportingInApp_ReportColumn_UsersAddingSkills = "Utilisateurs ayant ajout\xe9 des comp\xe9tences";
var ReportingInApp_ReportColumn_UsersCompletingContent = "Utilisateurs ayant termin\xe9 du contenu";
var ReportingInApp_ReportColumn_UsersCompletingPathways = "Utilisateurs ayant termin\xe9 des parcours";
var ReportingInApp_ReportColumn_UsersFollowingPathways = "Utilisateurs suivant des parcours";
var ReportingInApp_ReportColumn_UsersFollowingPlans = "Utilisateurs suivant des plans";
var ReportingInApp_ReportColumn_UsersRatingSkills = "Utilisateurs ayant \xe9valu\xe9 des comp\xe9tences";
var ReportingInApp_ReportColumn_UserStatus = "Statut de l’utilisateur";
var ReportingInApp_ReportColumn_UserTopics = "Th\xe8mes de l’utilisateur";
var ReportingInApp_ReportColumn_VerifiedLearningHours = "Heures de formation valid\xe9es";
var ReportingInApp_ReportColumn_VerifiedLearningMinutes = "Minutes de formation valid\xe9es";
var ReportingInApp_ReportColumn_ViewCountAndroid = "Nombre de vues sur Android";
var ReportingInApp_ReportColumn_ViewCountAndroidApp = "Nombre de vues sur l’application Android";
var ReportingInApp_ReportColumn_ViewCountAndroidBrowser = "Nombre de vues sur le navigateur Android";
var ReportingInApp_ReportColumn_ViewCountDesktop = "Nombre de vues sur le bureau";
var ReportingInApp_ReportColumn_ViewCountIos = "Nombre de vues sur iOS";
var ReportingInApp_ReportColumn_ViewCountIOSApp = "Nombre de vues sur l’application iOS";
var ReportingInApp_ReportColumn_ViewCountIOSBrowser = "Nombre de vues sur le navigateur iOS";
var ReportingInApp_ReportColumn_ViewCountWeb = "Nombre de vues sur le Web";
var ReportingInApp_ReportColumn_ViewedDate = "Date de consultation";
var ReportingInApp_ReportColumn_Visibility = "Visibilit\xe9";
var ReportingInApp_ReportColumn_WeeklyDigestEmail = "E-mail des tendances de la semaine";
var ReportingInApp_ReportGenerate_FileFormat_Label = "Type de fichier";
var ReportingInApp_ReportGenerate_FileFormatRowLimitWarning = "Les rapports pr\xe9sentant un million de lignes ou plus sont uniquement disponibles sous forme de fichier CSV.";
var ReportingInApp_ReportGenerate_Header = "Saisir un titre pour ce rapport";
var ReportingInApp_ReportGenerate_SavePreset_Label = "Enregistrer cette configuration de rapport en tant que pr\xe9r\xe9glage";
var ReportingInApp_ReportGenerate_SubmitButton = "G\xe9n\xe9rer";
var ReportingInApp_ReportPreview = "Aper\xe7u du rapport";
var ReportingInApp_ReportPreview_ChangeColumns = "Modifier les colonnes";
var ReportingInApp_ReportPreview_DownloadNotificationMessage = "La cr\xe9ation de votre rapport est en cours. Une fois termin\xe9, vous pourrez le t\xe9l\xe9charger depuis la page des rapports.";
var ReportingInApp_ReportPreview_PreviewingRowsOfFormat = "Pr\xe9visualisation de {{count}} lignes sur {{total}}";
var ReportingInApp_ReportPreview_UseCustomDateRange = "Utiliser une plage de dates personnalis\xe9e";
var ReportingInApp_ReportPreview_UTCDatesNote = "Toutes les dates sont exprim\xe9es en UTC";
var ReportingInApp_Reports = "Rapports";
var ReportingInApp_ReportType_AcademiesContentCompletionOverview_Description = "Utilisez le rapport d’aper\xe7u des compl\xe9tions de contenus dans l’acad\xe9mie pour conna\xeetre le pourcentage de compl\xe9tion global par \xe9tape et les confirmations de participation aux \xe9v\xe9nements.";
var ReportingInApp_ReportType_AcademiesContentCompletionOverview_Title = "Acad\xe9mies - Aper\xe7u des compl\xe9tions de contenus";
var ReportingInApp_ReportType_AcademiesDetailedByUser_Description = "Affiche les donn\xe9es d\xe9taill\xe9es sur les contenus termin\xe9s par les utilisateurs au sein des acad\xe9mies.";
var ReportingInApp_ReportType_AcademiesDetailedByUser_Title = "Acad\xe9mies (vue d\xe9taill\xe9e par utilisateur)";
var ReportingInApp_ReportType_AcademiesLastLogin_Description = "Liste de tous les utilisateurs assign\xe9s \xe0 l’acad\xe9mie, date \xe0 laquelle ils ont \xe9t\xe9 invit\xe9s \xe0 acc\xe9der \xe0 la plateforme et date de leur derni\xe8re connexion.";
var ReportingInApp_ReportType_AcademiesLastLogin_Title = "Acad\xe9mies - Derni\xe8re connexion";
var ReportingInApp_ReportType_AcademiesMarketplaceProgramStatus_Description = "Utilisez le rapport sur le statut des programmes de la marketplace dans l’acad\xe9mie pour consulter le statut des approbations de programmes au sein d’une acad\xe9mie.";
var ReportingInApp_ReportType_AcademiesMarketplaceProgramStatus_Title = "Acad\xe9mies - Statut des programmes de la marketplace";
var ReportingInApp_ReportType_AcademiesProgressByUser_Description = "Liste d\xe9taill\xe9e de l’\xe9tat d’avancement pour chaque utilisateur et \xe9l\xe9ment de l’acad\xe9mie.";
var ReportingInApp_ReportType_AcademiesProgressByUser_Title = "Acad\xe9mies - Progression par utilisateur";
var ReportingInApp_ReportType_AcademiesSummaryByAcademy_Description = "Affiche les donn\xe9es de chaque acad\xe9mie, y compris le nombre d’utilisateurs actifs et d’utilisateurs ayant termin\xe9 \xe0 100\xa0%";
var ReportingInApp_ReportType_AcademiesSummaryByAcademy_Title = "Acad\xe9mies (synth\xe8se par acad\xe9mie)";
var ReportingInApp_ReportType_AcademiesSummaryByUser_Description = "Affiche la synth\xe8se des donn\xe9es relatives aux interactions des utilisateurs avec les acad\xe9mies, y compris le nombre d’\xe9l\xe9ments termin\xe9s et le pourcentage de progression dans l’acad\xe9mie.";
var ReportingInApp_ReportType_AcademiesSummaryByUser_Title = "Acad\xe9mies (synth\xe8se par utilisateur)";
var ReportingInApp_ReportType_AcademyAndMarketplaceLoginsSummary_Description = "Affichez la synth\xe8se des donn\xe9es de connexion des utilisateurs.";
var ReportingInApp_ReportType_AcademyAndMarketplaceLoginsSummary_Title = "Connexions aux acad\xe9mies et \xe0 la marketplace (synth\xe8se)";
var ReportingInApp_ReportType_AcademyCompletionsByUser_Description = "Utilisez le rapport \xc9l\xe9ments termin\xe9s par utilisateur pour conna\xeetre le nom de tous les utilisateurs de l’acad\xe9mie et leur pourcentage d’avancement.";
var ReportingInApp_ReportType_AcademyCompletionsByUser_Title = "Acad\xe9mie - \xc9l\xe9ments termin\xe9s par utilisateur";
var ReportingInApp_ReportType_AcademyProjectsDetailedByUser_Description = "Affichez les d\xe9tails sur les projets d’acad\xe9mies, comme l’utilisateur et le statut.";
var ReportingInApp_ReportType_AcademyProjectsDetailedByUser_Title = "Projets d’acad\xe9mies (vue d\xe9taill\xe9e par utilisateur) ";
var ReportingInApp_ReportType_ActiveOpportunitiesDetailed_Description = "Afficher une liste d\xe9taill\xe9e des candidats aux opportunit\xe9s actives, par \xe9tape de candidature.";
var ReportingInApp_ReportType_ActiveOpportunitiesDetailed_Title = "Opportunit\xe9s actives (vue d\xe9taill\xe9e)";
var ReportingInApp_ReportType_ApprovalsDetailedByUser_Description = "Ce rapport r\xe9pertorie les demandes de programme et leur statut.";
var ReportingInApp_ReportType_ApprovalsDetailedByUser_Title = "Approbations (vue d\xe9taill\xe9e par utilisateur)";
var ReportingInApp_ReportType_AssignmentActivityEmployee_Description = "Affichez un r\xe9sum\xe9 de chaque formation assign\xe9e au sein de votre organisation, y compris le titre de la ressource, le nombre d’apprenants assign\xe9s, le nombre total d’\xe9l\xe9ments termin\xe9s, et plus encore.";
var ReportingInApp_ReportType_AssignmentActivityEmployee_Title = "Formation assign\xe9e (r\xe9sum\xe9 par formation assign\xe9e)";
var ReportingInApp_ReportType_AssignmentsByUser_Description = "Affichez le d\xe9tail des formations assign\xe9es \xe0 vos apprenants, y compris le titre des ressources, le nom et l’identifiant de l’apprenant, le nom et l’identifiant de l’auteur de l’assignation, la date de compl\xe9tion, et plus encore.";
var ReportingInApp_ReportType_AssignmentsByUser_Title = "Formation assign\xe9e (vue d\xe9taill\xe9e par utilisateur)";
var ReportingInApp_ReportType_CompletionActivityUser_Description = "Consultez des donn\xe9es de synth\xe8se sur les formations termin\xe9es par chaque apprenant, y compris la derni\xe8re date de compl\xe9tion, le nombre d’\xe9l\xe9ments termin\xe9s, etc.";
var ReportingInApp_ReportType_CompletionActivityUser_Title = "\xc9l\xe9ments termin\xe9s (r\xe9sum\xe9 par utilisateur)";
var ReportingInApp_ReportType_CompletionsByUser_Description = "Consultez des donn\xe9es de synth\xe8se sur les formations termin\xe9es par chaque apprenant, y compris la derni\xe8re date de compl\xe9tion.";
var ReportingInApp_ReportType_CompletionsByUser_Title = "\xc9l\xe9ments termin\xe9s (vue d\xe9taill\xe9e par utilisateur)";
var ReportingInApp_ReportType_ContentCatalog_Description = "Affichez une liste de contenus internes et externes avec des d\xe9tails comprenant des informations sur le fournisseur. ";
var ReportingInApp_ReportType_ContentCatalog_Title = "Catalogue de contenus (vue d\xe9taill\xe9e)";
var ReportingInApp_ReportType_ContentView_Description = "Donn\xe9es de synth\xe8se sur le contenu consult\xe9, y compris le type de contenu et le navigateur utilis\xe9.";
var ReportingInApp_ReportType_ContentView_Title = "Consultation des contenus (r\xe9sum\xe9)";
var ReportingInApp_ReportType_CustomProgramCompletionsByUser_Description = "Liste d\xe9taill\xe9e de l’\xe9tat d’avancement pour chaque utilisateur et \xe9l\xe9ment du programme personnalis\xe9.";
var ReportingInApp_ReportType_CustomProgramCompletionsByUser_Title = "Programme personnalis\xe9 - \xc9l\xe9ments termin\xe9s par l’utilisateur";
var ReportingInApp_ReportType_CustomProgramOverallProgress_Description = "Pourcentage de compl\xe9tion de chaque composant du programme personnalis\xe9 et nombre d’utilisateurs inscrits.";
var ReportingInApp_ReportType_CustomProgramOverallProgress_Title = "Programme personnalis\xe9 - Progression globale";
var ReportingInApp_ReportType_CustomProgramPercentProgressByUser_Description = "Nom de tous les utilisateurs inscrit au programme personnalis\xe9 et leur pourcentage de compl\xe9tion.";
var ReportingInApp_ReportType_CustomProgramPercentProgressByUser_Title = "Programme personnalis\xe9 - Pourcentage de progression par utilisateur";
var ReportingInApp_ReportType_CustomProgramProjects_Description = "Liste de toutes les soumissions de projets dans les programmes personnalis\xe9s, ainsi que le feedback des instructeurs et les dates de compl\xe9tion.";
var ReportingInApp_ReportType_CustomProgramProjects_Title = "Projets des programmes personnalis\xe9s";
var ReportingInApp_ReportType_CustomProgramUsersLoggedIn_Description = "Liste de tous les utilisateurs assign\xe9s au programme personnalis\xe9 et leur derni\xe8re connexion.";
var ReportingInApp_ReportType_CustomProgramUsersLoggedIn_Title = "Utilisateurs connect\xe9s au programme personnalis\xe9";
var ReportingInApp_ReportType_FollowersDetailed_Description = "Affichez des donn\xe9es sur les utilisateurs suivant d’autres utilisateurs.";
var ReportingInApp_ReportType_FollowersDetailed_Title = "Abonn\xe9s (vue d\xe9taill\xe9e)";
var ReportingInApp_ReportType_LearningHoursExecutiveSummary_Description = "Synth\xe8se globale des heures de formation par dur\xe9e valid\xe9e ou estim\xe9e";
var ReportingInApp_ReportType_LearningHoursExecutiveSummary_Title = "Heures de formation (bilan global)";
var ReportingInApp_ReportType_LearningHoursSummarybyUser_Description = "Affiche les heures de formation valid\xe9es et estim\xe9es par utilisateur";
var ReportingInApp_ReportType_LearningHoursSummarybyUser_Title = "Heures de formation (synth\xe8se par utilisateur)";
var ReportingInApp_ReportType_Logins_Description = "Affichez la synth\xe8se des donn\xe9es de connexions d’utilisateurs.";
var ReportingInApp_ReportType_Logins_Title = "Connexions (r\xe9sum\xe9)";
var ReportingInApp_ReportType_MentoringDetail_Description = "Afficher une liste d\xe9taill\xe9e des mentor\xe9s et des mentors, ainsi que le statut actuel du mentorat.";
var ReportingInApp_ReportType_MentoringDetail_Title = "Mentorat (vue d\xe9taill\xe9e)";
var ReportingInApp_ReportType_OpportunitiesInterestedActivityDetailed_Description = "Afficher une liste d\xe9taill\xe9e des utilisateurs int\xe9ress\xe9s par des opportunit\xe9s. Cela inclut des donn\xe9es relatives aux utilisateurs et aux opportunit\xe9s faisant l’objet de leur int\xe9r\xeat. ";
var ReportingInApp_ReportType_OpportunitiesInterestedActivityDetailed_Title = "Activit\xe9 des utilisateurs int\xe9ress\xe9s par des opportunit\xe9s (vue d\xe9taill\xe9e)";
var ReportingInApp_ReportType_OpportunitiesViewDataSummary_Description = "Afficher des donn\xe9es r\xe9capitulatives sur le nombre de vues pour chaque opportunit\xe9.";
var ReportingInApp_ReportType_OpportunitiesViewDataSummary_Title = "Donn\xe9es sur les consultations des opportunit\xe9s (r\xe9sum\xe9)";
var ReportingInApp_ReportType_PathwayDetailByUser_Description = "Consultez des donn\xe9es de synth\xe8se sur les \xe9l\xe9ments termin\xe9s par les utilisateurs dans le cadre d’un parcours suivi ou assign\xe9.";
var ReportingInApp_ReportType_PathwayDetailByUser_Title = "Parcours (vue d\xe9taill\xe9e par utilisateur)";
var ReportingInApp_ReportType_PathwaySummaryByPathway_Description = "Consultez des donn\xe9es de synth\xe8se sur chaque parcours, y compris le nombre d’utilisateurs actifs et le nombre d’utilisateurs ayant termin\xe9 un parcours \xe0 100\xa0%.";
var ReportingInApp_ReportType_PathwaySummaryByPathway_Title = "Parcours (r\xe9sum\xe9 par parcours)";
var ReportingInApp_ReportType_PathwaySummaryByUser_Description = "Consultez des donn\xe9es de synth\xe8se sur les utilisateurs d’un parcours suivi ou assign\xe9, y compris le nombre d’\xe9l\xe9ments termin\xe9s et le pourcentage de compl\xe9tion du parcours.";
var ReportingInApp_ReportType_PathwaySummaryByUser_Title = "Parcours (r\xe9sum\xe9 par utilisateur)";
var ReportingInApp_ReportType_PlanDetailByUser_Description = "Consultez des informations sur les \xe9l\xe9ments termin\xe9s par l’utilisateur dans le cadre d’un plan suivi ou assign\xe9.";
var ReportingInApp_ReportType_PlanDetailByUser_Title = "Plan (vue d\xe9taill\xe9e par utilisateur)";
var ReportingInApp_ReportType_PlanSummaryByPlan_Description = "Consultez des donn\xe9es de synth\xe8se sur chaque plan, y compris le nombre d’utilisateurs suivant le plan.";
var ReportingInApp_ReportType_PlanSummaryByPlan_Title = "Plan (r\xe9sum\xe9 par plan)";
var ReportingInApp_ReportType_PlanSummaryByUser_Description = "Consultez des donn\xe9es de synth\xe8se sur les utilisateurs d’un plan suivi ou assign\xe9, y compris le nombre d’\xe9l\xe9ments termin\xe9s.";
var ReportingInApp_ReportType_PlanSummaryByUser_Title = "Plan (r\xe9sum\xe9 par utilisateur)";
var ReportingInApp_ReportType_PublishedAcademiesDetailed_Description = "Affiche le contenu au sein des acad\xe9mies publi\xe9es";
var ReportingInApp_ReportType_PublishedAcademiesDetailed_Title = "Acad\xe9mies publi\xe9es (vue d\xe9taill\xe9e)";
var ReportingInApp_ReportType_PublishedOpportunitiesSummary_Description = "Afficher une liste r\xe9capitulative des opportunit\xe9s, comprenant une description, le nombre de personnes int\xe9ress\xe9es, ainsi que les candidats qualifi\xe9s et s\xe9lectionn\xe9s.";
var ReportingInApp_ReportType_PublishedOpportunitiesSummary_Title = "Opportunit\xe9s publi\xe9es (r\xe9sum\xe9)";
var ReportingInApp_ReportType_PublishedPathwaysDetailed_Description = "Affichez le contenu des parcours publi\xe9s, y compris des informations sur les sections et les le\xe7ons.";
var ReportingInApp_ReportType_PublishedPathwaysDetailed_Title = "Parcours publi\xe9s (vue d\xe9taill\xe9e)";
var ReportingInApp_ReportType_SearchSummary_Description = "Affichez les termes recherch\xe9s et le nombre de recherches associ\xe9es.";
var ReportingInApp_ReportType_SearchSummary_Title = "Recherche (r\xe9sum\xe9)";
var ReportingInApp_ReportType_SharedDetailed_Description = "Affichez des donn\xe9es relatives aux \xe9l\xe9ments partag\xe9s, y compris les noms de l’\xe9metteur et du destinataire.";
var ReportingInApp_ReportType_SharedDetailed_Title = "\xc9l\xe9ments partag\xe9s (vue d\xe9taill\xe9e)";
var ReportingInApp_ReportType_SharedOpportunitiesDetailed_Description = "Afficher une liste d\xe9taill\xe9e des opportunit\xe9s partag\xe9es, comprenant des donn\xe9es sur les utilisateurs qui ont partag\xe9, et sur les destinataires. ";
var ReportingInApp_ReportType_SharedOpportunitiesDetailed_Title = "Opportunit\xe9s partag\xe9es (vue d\xe9taill\xe9e)";
var ReportingInApp_ReportType_SkillActivityEmployee_Description = "Affichez une synth\xe8se sur chaque comp\xe9tence dans votre organisation, y compris le nombre total de profils auxquels elle a \xe9t\xe9 ajout\xe9e, le nombre de fois o\xf9 elle a \xe9t\xe9 d\xe9finie comme prioritaire ou prioritaire pour l’\xe9quipe (Skill\xa0Coach uniquement), la moyenne des \xe9valuations de la comp\xe9tence, et plus encore.";
var ReportingInApp_ReportType_SkillActivityEmployee_Title = "Comp\xe9tence (r\xe9sum\xe9 par comp\xe9tence)";
var ReportingInApp_ReportType_SkillCoachDetailedByManager_Description = "Affichez le d\xe9tail de l’activit\xe9 des managers dans le programme Skill\xa0Coach.";
var ReportingInApp_ReportType_SkillCoachDetailedByManager_Title = "Skill\xa0Coach (vue d\xe9taill\xe9e par manager)";
var ReportingInApp_ReportType_SkillCoachOverall_Description = "Consultez un r\xe9sum\xe9 du programme Skill\xa0Coach. Affiche le nombre de managers participants et un r\xe9sum\xe9 de leur activit\xe9 dans Skill\xa0Coach. ";
var ReportingInApp_ReportType_SkillCoachOverall_Title = "Skill\xa0Coach (r\xe9sum\xe9 global)";
var ReportingInApp_ReportType_SkillCoachSummaryByManager_Description = "Consultez un r\xe9sum\xe9 de l’activit\xe9 des managers dans le programme Skill\xa0Coach.";
var ReportingInApp_ReportType_SkillCoachSummaryByManager_Title = "Skill\xa0Coach (r\xe9sum\xe9 par manager)";
var ReportingInApp_ReportType_SkillFollowedDetailedByUser_Description = "Affichez des donn\xe9es sur les comp\xe9tences suivies par les utilisateurs.";
var ReportingInApp_ReportType_SkillFollowedDetailedByUser_Title = "Comp\xe9tences suivies (vue d\xe9taill\xe9e par utilisateur)";
var ReportingInApp_ReportType_SkillsByUser_Description = "Affichez le d\xe9tail des interactions de chacun des apprenants (par exemple, les \xe9valuations attribu\xe9es, les types d’\xe9valuation, les dates ajout\xe9es par utilisateur, et plus encore) pour chacune des comp\xe9tences dans votre taxonomie des comp\xe9tences.";
var ReportingInApp_ReportType_SkillsByUser_Title = "Comp\xe9tences (vue d\xe9taill\xe9e par utilisateur)";
var ReportingInApp_ReportType_SkillStandardDetailedByUser_Description = "Affichez une vue d\xe9taill\xe9e des \xe9valuations des utilisateurs dans les normes de comp\xe9tences.";
var ReportingInApp_ReportType_SkillStandardDetailedByUser_Title = "Norme de comp\xe9tences (vue d\xe9taill\xe9e par utilisateur)";
var ReportingInApp_ReportType_SummaryOfProgressAcademiesCustomPrograms_Description = "Synth\xe8se du pourcentage de progression et du nombre total de participants pour chaque acad\xe9mie ou programme personnalis\xe9.";
var ReportingInApp_ReportType_SummaryOfProgressAcademiesCustomPrograms_Title = "Synth\xe8se de la progression (acad\xe9mies et programmes personnalis\xe9s)";
var ReportingInApp_ReportType_UserGroups_Description = "Affichez des informations d\xe9taill\xe9es sur les groupes d’utilisateurs.";
var ReportingInApp_ReportType_UserGroups_Title = "Groupes d’utilisateurs (vue d\xe9taill\xe9e)";
var ReportingInApp_ReportType_UserSummary_Description = "Affichez des informations sur les utilisateurs, notamment leur derni\xe8re connexion et leur nombre de points.";
var ReportingInApp_ReportType_UserSummary_Title = "Utilisateur (r\xe9sum\xe9)";
var ReportingInApp_ReportType_VWRptUserSummaryAnonymized_Description = "";
var ReportingInApp_ReportType_VWRptUserSummaryAnonymized_Title = "UserSummary";
var ReportingInApp_SavedPresets = "Pr\xe9r\xe9glages";
var ReportingInApp_SavedPresets_ConfirmDelete = "Voulez-vous vraiment supprimer ce pr\xe9r\xe9glage enregistr\xe9 \xa0?";
var ReportingInApp_SavedPresets_Description = "Apr\xe8s avoir cr\xe9\xe9 un rapport, vous pouvez enregistrer les param\xe8tres et les filtres pour un usage ult\xe9rieur. Les pr\xe9r\xe9glages enregistr\xe9s seront indiqu\xe9s sur cette page.";
var ReportingInApp_SavedPresets_Error_DeletePreset = "\xc9chec de suppression des pr\xe9r\xe9glages enregistr\xe9s";
var ReportingInApp_SavedPresets_PresetDeleted = "Les pr\xe9r\xe9glages enregistr\xe9s ont bien \xe9t\xe9 supprim\xe9s.";
var ReportingInApp_Scheduled_MaxReportsNotice = "Planifier jusqu’\xe0 30\xa0rapports";
var ReportingInApp_ScheduledReports = "Rapports planifi\xe9s";
var ReportingInApp_Segments = "Segments";
var ReportingInApp_Segments_DropdownFilter_TitleSelected = "Segments s\xe9lectionn\xe9s";
var ReportingInApp_Segments_Error_GetSegements = "Erreur lors de la g\xe9n\xe9ration des segments du rapport";
var ReportingInApp_Segments_Error_GetUserForSegments = "Erreur lors de la r\xe9cup\xe9ration des utilisateurs";
var ReportingInApp_Segments_Error_UpdateUserForSegments = "Erreur lors de la mise \xe0 jour de l’utilisateur pour ces segments";
var ReportingInApp_Segments_Modal_Info = "Rechercher par nom pour ajouter des utilisateurs du rapport \xe0 ce segment.";
var ReportingInApp_Segments_Modal_Title = "Modifier l’autorisation relative aux rapports pour {{segmentName}}";
var ReportingInApp_Segments_Modal_UserListTitle = "Utilisateurs approuv\xe9s";
var ReportingInApp_Segments_Success_UpdateUserForSegments = "Les utilisateurs du rapport dans ce segment ont bien \xe9t\xe9 mis \xe0 jour.";
var ReportingInApp_Segments_View_Attributes = "Attributs";
var ReportingInApp_Segments_View_EditReportPermissions = "Modifier les autorisations relatives aux rapports";
var ReportingInApp_Segments_View_ReportPermissions = "Autorisations relatives aux rapports";
var ReportingInApp_Segments_View_SegmentName = "Nom du segment";
var ReportingInApp_Status_Download = "Pr\xeat au t\xe9l\xe9chargement";
var ReportingInApp_Status_Error = "Erreur";
var ReportingInApp_Status_InProgress = "Traitement en cours";
var ReportingInApp_Status_Unknown = "Inconnu";
var requestGroupMembership_Accept = "Accepter";
var requestGroupMembership_Approved = "Approuv\xe9";
var requestGroupMembership_Decline = "Refuser";
var requestGroupMembership_Denied = "Refus\xe9";
var requestGroupMembership_Plural = "{{nameHtml}} et {{number}} autres ont demand\xe9 l’appartenance au groupe {{groupNameHtml}}";
var requestGroupMembership_Single = "{{nameHtml}} a demand\xe9 l’appartenance au groupe {{groupNameHtml}}";
var RequestRating_Header = "Demander une \xe9valuation au manager";
var RequestRating_Label = "Recherchez votre manager";
var RequestRating_Message1Format = "{0} a demand\xe9 que vous \xe9valuiez son niveau pour la comp\xe9tence {1}";
var RequestRating_RateNow = "\xc9valuer maintenant";
var RequestRating_Self_Message1Format = "{0} vous a demand\xe9 d’auto-\xe9valuer votre comp\xe9tence {1}";
var RequestRating_Self_Subject = "{0} vous a demand\xe9 de vous auto-\xe9valuer.";
var RequestRating_SendRequest = "Envoyer la demande";
var RequestRating_Subject = "{0} vous a demand\xe9 d’\xe9valuer sa comp\xe9tence.";
var RequestRating_SuccessMessage = "Demande bien envoy\xe9e";
var requiredLearning_notificationDateFormat = "Vous avez un nouvel \xe9l\xe9ment de {{startHtml}}formation obligatoire{{endHtml}} avec \xe9ch\xe9ance au {{date}}";
var resetPasswordForm_ConfirmPasswordError = "Les mots de passe ne correspondent pas.";
var resetPasswordForm_ConfirmPasswordLabel = "Retapez votre nouveau mot de passe";
var resetPasswordForm_ConfirmPasswordPlaceholder = "Tapez-le une fois de plus";
var resetPasswordForm_ExpiredPassword = "Votre mot de passe a expir\xe9. Veuillez r\xe9initialiser votre mot de passe.";
var resetPasswordForm_Info = "Entrez un nouveau mot de passe pour votre compte.";
var resetPasswordForm_InvalidConfirmPassword = "Les mots de passe ne correspondent pas.";
var resetPasswordForm_InvalidEmail = "Veuillez entrer votre adresse e-mail.";
var resetPasswordForm_InvalidPassword = "Le mot de passe doit comprendre au minimum 8\xa0caract\xe8res, dont un chiffre et une lettre";
var resetPasswordForm_NewPasswordLabel = "Choisissez un nouveau mot de passe";
var resetPasswordForm_NewPasswordPlaceholder = "Gardez-le secret\xa0!";
var resourceAssociationRemoved_ActionFormat = "{{nameHtml}} a supprim\xe9 ce {{type}} de {{resourceTitle}} {{resourceType}}";
var resourceAssociationRemoved_ActionNoUserFormat = '<span class="font-semibold">La derni\xe8re importation du catalogue de votre organisation</span> a supprim\xe9 l’\xe9l\xe9ment \xab\xa0{{type}}\xa0\xbb dans \xab\xa0{{resourceTitle}} {{resourceType}}\xa0\xbb';
var scholarshipIntroModal_CreateAccount = "\xc9tape\xa02 : Cr\xe9ez un compte d\xe9veloppeur Salesforce";
var scholarshipIntroModal_CreateAccountDescription = "Pour vous inscrire, vous devez d’abord cr\xe9er un compte d\xe9veloppeur Salesforce GRATUIT et compl\xe9ter le parcours Salesforce.";
var scholarshipIntroModal_CreateAccountLabel = "Cr\xe9er un compte";
var SearchResultItem_AddToBin = "Ajouter au casier";
var searchTags_UserTagsAddButton = "+ Ajouter";
var searchTags_UserTagsHint = "conseil\xa0: ajoutez plusieurs comp\xe9tences en les s\xe9parant par une virgule.";
var SessionTimeoutModal_Body = "En raison d’une inactivit\xe9 prolong\xe9e, votre session expirera dans {{ secondsRemaining }}\xa0secondes.";
var SessionTimeoutModal_StillHere = "Je suis toujours l\xe0";
var signupForm_CreatePasswordLabel = "Choisissez un mot de passe";
var signupForm_CreatePasswordPlaceholder = "Gardez-le secret\xa0!";
var signupForm_CreatePasswordTooltip = "Le mot de passe doit comprendre au minimum 8\xa0caract\xe8res, dont un chiffre et une lettre.";
var signupForm_EmailExists = "Cette adresse e-mail est d\xe9j\xe0 utilis\xe9e. Souhaitez-vous {{startAnchor}}vous connecter \xa0?{{endAnchor}}";
var signupForm_EmailPlaceholder = "jane@acme.com";
var signupForm_EmailStateTooltip = "Sur la page suivante, vous pourrez vous connecter, entrer votre mot de passe ou r\xe9initialiser votre mot de passe.";
var signupForm_FirstNamePlaceholder = "Jane";
var signupForm_HasAccountCTA = "Vous avez d\xe9j\xe0 un compte \xa0?";
var signupForm_InvalidEmailSignup = "Hmm, cela ne semble pas \xeatre une adresse e-mail. R\xe9essayez.";
var signupForm_InvalidEula = "Vous devez accepter les conditions d’utilisation et la politique de confidentialit\xe9.";
var signupForm_InvalidFirstName = "Veuillez saisir votre pr\xe9nom.";
var signupForm_InvalidPassword = "Le mot de passe doit comprendre au minimum 8\xa0caract\xe8res, dont un chiffre et une lettre.";
var signupForm_LastNamePlaceholder = "Smith";
var signupForm_LogInNow = "Connectez-vous maintenant";
var signupForm_NoAccount = "Hmm, nous ne parvenons pas \xe0 trouver ce compte. Essayez \xe0 nouveau ou {{startAnchor}}cr\xe9ez un nouveau compte.{{endAnchor}}";
var signupForm_PasswordLabel = "Maintenant, entrez votre mot de passe";
var signupForm_RegisterEmailLabel = "Quelle est votre adresse e-mail \xa0?";
var signupForm_RegisterFirstNameLabel = "Pr\xe9nom";
var signupForm_RegisterLastNameLabel = "Nom";
var signupForm_SignUpTitle = "Inscription";
var singleRecommendation_groupAlreadyCompletedArticleDateFormat = "{{nameHtml}} a partag\xe9 l’article {{title}} avec {{groupNameHtml}}, mais vous l’avez d\xe9j\xe0 lu. Du travail de pro\xa0!";
var singleRecommendation_groupAlreadyCompletedArticleFormat = "{{nameHtml}} a partag\xe9 l’article {{title}} avec {{groupNameHtml}}, mais vous l’avez d\xe9j\xe0 lu\xa0! Excellent travail, quel(le) brillant(e) \xe9l\xe8ve\xa0!";
var singleRecommendation_groupAlreadyCompletedAssessmentDateFormat = "{{nameHtml}} a partag\xe9 le test d’\xe9valuation {{title}} avec {{groupNameHtml}}, mais vous l’avez d\xe9j\xe0 termin\xe9. Excellent travail, vous vous surpassez !";
var singleRecommendation_groupAlreadyCompletedAssessmentFormat = "{{nameHtml}} a partag\xe9 ce test d'\xe9valuation {{title}} avec {{groupNameHtml}}, mais vous l’avez d\xe9j\xe0 termin\xe9\xa0! Excellent travail, quel(le) brillant(e) \xe9l\xe8ve\xa0!";
var singleRecommendation_groupAlreadyCompletedBookFormat = "{{nameHtml}} a partag\xe9 le livre {{title}} avec {{groupNameHtml}}, mais vous l’avez d\xe9j\xe0 lu\xa0! Excellent travail, quel(le) brillant(e) \xe9l\xe8ve\xa0!";
var singleRecommendation_groupAlreadyCompletedCourseFormat = "{{nameHtml}} a partag\xe9 le cours {{title}} avec {{groupNameHtml}}, mais vous l’avez d\xe9j\xe0 termin\xe9. Excellent travail, vous vous surpassez\xa0!";
var singleRecommendation_groupAlreadyCompletedEpisodeDateFormat = "{{nameHtml}} a partag\xe9 un \xe9pisode de {{title}} avec {{groupNameHtml}}, mais vous l’avez d\xe9j\xe0 \xe9cout\xe9\xa0! Excellent travail, quel(le) brillant(e) \xe9l\xe8ve\xa0!";
var singleRecommendation_groupAlreadyCompletedEpisodeFormat = "{{nameHtml}} a partag\xe9 un \xe9pisode de {{title}} avec {{groupNameHtml}}, mais vous l’avez d\xe9j\xe0 \xe9cout\xe9\xa0! Excellent travail, quel(le) brillant(e) \xe9l\xe8ve\xa0!";
var singleRecommendation_groupAlreadyCompletedEventDateFormat = "{{nameHtml}} a partag\xe9 l’\xe9v\xe9nement {{title}} avec {{groupNameHtml}}, mais vous y avez d\xe9j\xe0 assist\xe9\xa0! Excellent travail, quel(le) brillant(e) \xe9l\xe8ve\xa0!";
var singleRecommendation_groupAlreadyCompletedEventFormat = "{{nameHtml}} a partag\xe9 l’\xe9v\xe9nement {{title}} avec {{groupNameHtml}}, mais vous y avez d\xe9j\xe0 assist\xe9\xa0! Excellent travail, quel(le) brillant(e) \xe9l\xe8ve\xa0!";
var singleRecommendation_GroupAlreadyCompletedFormat = "{{nameHtml}} a partag\xe9 l’\xe9l\xe9ment {{type}} avec {{groupNameHtml}}, mais vous l’avez d\xe9j\xe0 termin\xe9. Excellent travail\xa0!";
var singleRecommendation_groupAlreadyCompletedPathwayDateFormat = "{{nameHtml}} a partag\xe9 le parcours {{title}} avec {{groupNameHtml}}, mais vous l’avez d\xe9j\xe0 termin\xe9. Excellent travail, vous vous surpassez !";
var singleRecommendation_groupAlreadyCompletedPathwayFormat = "{{nameHtml}} a partag\xe9 le parcours {{title}} avec {{groupNameHtml}}, mais vous l’avez d\xe9j\xe0 termin\xe9. Excellent travail, vous vous surpassez !";
var singleRecommendation_groupAlreadyCompletedVideoDateFormat = "{{nameHtml}} a partag\xe9 la vid\xe9o {{title}} avec {{groupNameHtml}}, mais vous l’avez d\xe9j\xe0 regard\xe9e\xa0! Excellent travail, quel(le) brillant(e) \xe9l\xe8ve\xa0!";
var singleRecommendation_groupAlreadyCompletedVideoFormat = "{{nameHtml}} a partag\xe9 la vid\xe9o {{title}} avec {{groupNameHtml}}, mais vous l’avez d\xe9j\xe0 regard\xe9e\xa0! Excellent travail, quel(le) brillant(e) \xe9l\xe8ve\xa0!";
var singleRecommendation_groupArticleDateFormat = "{{nameHtml}} a partag\xe9 l’article {{title}} avec {{groupNameHtml}}";
var singleRecommendation_groupArticleFormat = "{{nameHtml}} a partag\xe9 cet article avec {{groupNameHtml}}";
var singleRecommendation_groupAssessmentDateFormat = "{{nameHtml}} a partag\xe9 le test d'\xe9valuation {{title}} avec {{groupNameHtml}}";
var singleRecommendation_groupAssessmentFormat = "{{nameHtml}} a partag\xe9 le test d’\xe9valuation {{title}} avec {{groupNameHtml}}";
var singleRecommendation_groupBookDateFormat = "{{nameHtml}} a partag\xe9 le livre {{title}} avec {{groupNameHtml}}";
var singleRecommendation_groupBookFormat = "{{nameHtml}} a partag\xe9 le livre {{title}} avec {{groupNameHtml}}";
var singleRecommendation_groupCourseDateFormat = "{{nameHtml}} a partag\xe9 le cours {{title}} avec {{groupNameHtml}}";
var singleRecommendation_groupCourseFormat = "{{nameHtml}} a partag\xe9 le cours {{title}} avec {{groupNameHtml}}";
var singleRecommendation_groupEpisodeDateFormat = "{{nameHtml}} a partag\xe9 un \xe9pisode de {{title}} avec {{groupNameHtml}}";
var singleRecommendation_groupEpisodeFormat = "{{nameHtml}} a partag\xe9 un \xe9pisode de {{title}} avec {{groupNameHtml}}";
var singleRecommendation_groupEventDateFormat = "{{nameHtml}} a partag\xe9 l’\xe9v\xe9nement {{title}} avec {{groupNameHtml}}";
var singleRecommendation_groupEventFormat = "{{nameHtml}} a partag\xe9 l’\xe9v\xe9nement {{title}} avec {{groupNameHtml}}";
var singleRecommendation_GroupFollowFormat = "{{nameHtml}} a partag\xe9 ceci avec {{groupNameHtml}}.";
var singleRecommendation_GroupFormat = "{{nameHtml}} a partag\xe9 ceci avec {{groupNameHtml}}";
var singleRecommendation_groupPathwayDateFormat = "{{nameHtml}} a partag\xe9 le parcours {{title}} avec {{groupNameHtml}}";
var singleRecommendation_groupPathwayFormat = "{{nameHtml}} a partag\xe9 le parcours {{title}} avec {{groupNameHtml}}";
var singleRecommendation_groupTargetDateFormat = "{{nameHtml}} a partag\xe9 le poste {{title}} avec {{groupNameHtml}}";
var singleRecommendation_groupTargetFormat = "{{nameHtml}} a partag\xe9 le plan {{title}} avec {{groupNameHtml}}";
var singleRecommendation_groupVideoDateFormat = "{{nameHtml}} a partag\xe9 la vid\xe9o {{title}} avec {{groupNameHtml}}";
var singleRecommendation_groupVideoFormat = "{{nameHtml}} a partag\xe9 la vid\xe9o {{title}} avec {{groupNameHtml}}";
var singleRecommendation_GroupYouAlreadyFollowFormat = "{{nameHtml}} a partag\xe9 ceci avec {{groupNameHtml}}, mais vous suivez d\xe9j\xe0 ce contenu.";
var singleRecommendation_youAlreadyCompletedArticleDateFormat = "{{nameHtml}} a partag\xe9 l’article {{title}} avec vous, mais vous l’avez d\xe9j\xe0 lu\xa0! Excellent travail, quel(le) brillant(e) \xe9l\xe8ve\xa0!";
var singleRecommendation_youAlreadyCompletedArticleFormat = "{{nameHtml}} a partag\xe9 l’article {{title}} avec vous, mais vous l’avez d\xe9j\xe0 lu\xa0! Excellent travail, quel(le) brillant(e) \xe9l\xe8ve\xa0!";
var singleRecommendation_youAlreadyCompletedAssessmentDateFormat = "{{nameHtml}} a partag\xe9 le test d’\xe9valuation {{title}} avec vous";
var singleRecommendation_youAlreadyCompletedAssessmentFormat = "{{nameHtml}} a partag\xe9 le test d'\xe9valuation {{title}} avec vous";
var singleRecommendation_youAlreadyCompletedBookFormat = "{{nameHtml}} a partag\xe9 le livre {{title}} avec vous, mais vous l’avez d\xe9j\xe0 lu\xa0! Excellent travail, quel(le) brillant(e) \xe9l\xe8ve\xa0!";
var singleRecommendation_youAlreadyCompletedCourseDateFormat = "{{nameHtml}} a partag\xe9 le cours {{title}} avec vous, mais vous l’avez d\xe9j\xe0 termin\xe9\xa0! Excellent travail, quel(le) brillant(e) \xe9l\xe8ve\xa0!";
var singleRecommendation_youAlreadyCompletedCourseFormat = "{{nameHtml}} a partag\xe9 le cours {{title}} avec vous, mais vous l’avez d\xe9j\xe0 termin\xe9. Excellent travail, vous vous surpassez !";
var singleRecommendation_youAlreadyCompletedEpisodeDateFormat = "{{nameHtml}} a partag\xe9 un \xe9pisode de {{title}} avec vous, mais vous l’avez d\xe9j\xe0 \xe9cout\xe9\xa0! Excellent travail, quel(le) brillant(e) \xe9l\xe8ve\xa0!";
var singleRecommendation_youAlreadyCompletedEpisodeFormat = "{{nameHtml}} a partag\xe9 un \xe9pisode de {{title}} avec vous, mais vous l’avez d\xe9j\xe0 \xe9cout\xe9\xa0! Excellent travail, quel(le) brillant(e) \xe9l\xe8ve\xa0!";
var singleRecommendation_youAlreadyCompletedEventDateFormat = "{{nameHtml}} a partag\xe9 l’\xe9v\xe9nement {{title}} avec vous, mais vous y avez d\xe9j\xe0 assist\xe9\xa0! Excellent travail, quel(le) brillant(e) \xe9l\xe8ve\xa0!";
var singleRecommendation_youAlreadyCompletedEventFormat = "{{nameHtml}} a partag\xe9 l’\xe9v\xe9nement {{title}} avec vous, mais vous y avez d\xe9j\xe0 assist\xe9\xa0! Excellent travail, quel(le) brillant(e) \xe9l\xe8ve\xa0!";
var singleRecommendation_YouAlreadyCompletedFormat = "{{nameHtml}} a partag\xe9 ceci avec vous, mais vous l’avez d\xe9j\xe0 termin\xe9. Excellent travail\xa0!";
var singleRecommendation_youAlreadyCompletedPathwayFormat = "{{nameHtml}} a partag\xe9 ceci avec vous, mais vous suivez d\xe9j\xe0 ce contenu. Excellent travail\xa0!";
var singleRecommendation_youAlreadyCompletedTargetDateFormat = "{{nameHtml}} a partag\xe9 le r\xf4le {{title}} avec vous, mais vous l’avez d\xe9j\xe0 suivi\xa0! Excellent travail, quel(le) brillant(e) \xe9l\xe8ve\xa0!";
var singleRecommendation_youAlreadyCompletedTargetFormat = "{{nameHtml}} a partag\xe9 le plan {{title}}, mais vous l’avez d\xe9j\xe0 suivi\xa0! Excellent travail, quel(le) brillant(e) \xe9l\xe8ve\xa0!";
var singleRecommendation_youAlreadyCompletedVideoDateFormat = "{{nameHtml}} a partag\xe9 la vid\xe9o {{title}} avec vous, mais vous l’avez d\xe9j\xe0 regard\xe9e\xa0! Excellent travail, quel(le) brillant(e) \xe9l\xe8ve\xa0!";
var singleRecommendation_youAlreadyCompletedVideoFormat = "{{nameHtml}} a partag\xe9 la vid\xe9o {{title}} avec vous, mais vous l’avez d\xe9j\xe0 regard\xe9e\xa0! Excellent travail, quel(le) brillant(e) \xe9l\xe8ve\xa0!";
var singleRecommendation_YouAlreadyFollowFormat = "{{nameHtml}} a partag\xe9 ceci avec vous, mais vous suivez d\xe9j\xe0 ce contenu.";
var singleRecommendation_youArticleFormat = "{{nameHtml}} a partag\xe9 l’article {{title}} avec vous";
var singleRecommendation_youAssessmentDateFormat = "{{nameHtml}} a partag\xe9 le test d’\xe9valuation {{title}} avec vous";
var singleRecommendation_youAssessmentFormat = "{{nameHtml}} a partag\xe9 le test d’\xe9valuation {{title}} avec vous";
var singleRecommendation_youBookDateFormat = "{{nameHtml}} a partag\xe9 le livre {{title}} avec vous";
var singleRecommendation_youBookFormat = "{{nameHtml}} a partag\xe9 le livre {{title}} avec vous";
var singleRecommendation_youCourseDateFormat = "{{nameHtml}} a partag\xe9 le cours {{title}} avec vous";
var singleRecommendation_youCourseFormat = "{{nameHtml}} a partag\xe9 le cours {{title}} avec vous";
var singleRecommendation_youEpisodeDateFormat = "{{nameHtml}} a partag\xe9 un \xe9pisode de {{title}} avec vous";
var singleRecommendation_youEpisodeFormat = "{{nameHtml}} a partag\xe9 un \xe9pisode de {{title}} avec vous";
var singleRecommendation_youEventDateFormat = "{{nameHtml}} a partag\xe9 l’\xe9v\xe9nement {{title}} avec vous";
var singleRecommendation_youEventFormat = "{{nameHtml}} a partag\xe9 l’\xe9v\xe9nement {{title}} avec vous";
var singleRecommendation_YouFollowFormat = "{{nameHtml}} a partag\xe9 ceci avec vous\xa0: {{type}} {{title}}.";
var singleRecommendation_YouFormat = "{{nameHtml}} a partag\xe9 ceci avec vous";
var singleRecommendation_youPathwayDateFormat = "{{nameHtml}} a partag\xe9 le parcours {{title}} avec vous";
var singleRecommendation_youPathwayFormat = "{{nameHtml}} a partag\xe9 le parcours {{title}} avec vous";
var singleRecommendation_youPositionDateFormat = "{{nameHtml}} a partag\xe9 la position {{title}} avec vous";
var singleRecommendation_youTargetDateFormat = "{{nameHtml}} a partag\xe9 le poste {{title}} avec vous";
var singleRecommendation_youTargetFormat = "{{nameHtml}} a partag\xe9 le plan {{title}} avec vous";
var singleRecommendation_youVideoDateFormat = "{{nameHtml}} a partag\xe9 la vid\xe9o {{title}} avec vous";
var singleRecommendation_youVideoFormat = "{{nameHtml}} a partag\xe9 la vid\xe9o {{title}} avec vous";
var SkillActivityChart_Title = "Activit\xe9";
var SkillActivityChart_TooltipText = "Affiche le niveau d’activit\xe9 par type pour chaque comp\xe9tence au cours de la p\xe9riode actuelle. Les comp\xe9tences ayant le plus d’activit\xe9 apparaissent en premier.";
var SkillFormCtrl_AddLink = "Ajouter un lien";
var SkillFormCtrl_Description = "Description";
var SkillFormCtrl_SkillCategory = "Veuillez ajouter au moins une cat\xe9gorie.";
var SkillFormCtrl_SkillDescription = "La description de la comp\xe9tence doit \xeatre renseign\xe9e.";
var SkillFormCtrl_Url = "URL";
var SkillInsights_MinimumRatingNotice = "Seules les comp\xe9tences associ\xe9es aux \xe9valuations de deux personnes ou plus apparaissent sur cette page.";
var SkillInsights_RatingNotice = "Seules les comp\xe9tences associ\xe9es aux \xe9valuations de {{ x }}\xa0personnes ou plus apparaissent sur cette page.";
var SkillProgressionChart_AvgRating = "\xc9valuation moyenne de la comp\xe9tence\xa0: {{number}}";
var SkillProgressionChart_AvgSkillRating = "\xc9valuation moyenne de la comp\xe9tence";
var SkillProgressionChart_NumberOfLearners = "Nombre d’apprenants";
var SkillProgressionChart_NumberOfRatingsPlural = "{{number}}\xa0\xe9valuations";
var SkillProgressionChart_NumberOfRatingsSingle = "{{number}}\xa0\xe9valuation";
var SkillProgressionChart_Ratings = "{{number}} apprenants";
var SkillProgressionChart_SkillProgression = "Progression des comp\xe9tences";
var SkillProgressionChart_SkillSupply = "Disponibilit\xe9 des comp\xe9tences";
var SkillProgressionChart_SubtitlePluralFormat = "{{ topCount }} comp\xe9tence(s) sur {{ totalCount }}";
var SkillProgressionChart_SubtitleSingularFormat = "{{ topCount }} \xe9valuation sur {{ totalCount }}";
var SkillProgressionChart_SubtitleTopFormat = "{{ topCount }}\xa0comp\xe9tence(s) principale(s) sur {{ totalCount }}";
var SkillProgressionChart_Title = "D\xe9veloppement des comp\xe9tences";
var SkillProgressionChart_XAxis = "Plage de dates";
var SkillProgressionChart_YAxis = "Nombre d’apprenants";
var SkillRatingsChart_AllTypes = "Tous les types";
var SkillRatingsChart_AlphabeticalOrder = "Ordre alphab\xe9tique";
var SkillRatingsChart_Average = "Moyenne";
var SkillRatingsChart_AverageSkillRating = "\xc9valuation moyenne de la comp\xe9tence";
var SkillRatingsChart_avgSkillRatingFormat = "\xc9valuation moyenne de la comp\xe9tence\xa0: {{avg}}";
var SkillRatingsChart_certified = "certifi\xe9";
var SkillRatingsChart_DegreedCertified = "Certifi\xe9 Degreed";
var SkillRatingsChart_Description = "Seules les comp\xe9tences associ\xe9es aux \xe9valuations de deux personnes ou plus apparaissent sur ce graphique.";
var SkillRatingsChart_EmptyStateText = "Aucune donn\xe9e d’\xe9valuation \xe0 afficher.<br>Seules les comp\xe9tences associ\xe9es aux \xe9valuations de {{ x }}\xa0personnes ou plus apparaissent sur ce graphique.";
var SkillRatingsChart_Evaluations = "Revues de comp\xe9tences";
var SkillRatingsChart_High = "Haut";
var SkillRatingsChart_learner = "1\xa0apprenant";
var SkillRatingsChart_learnerPluralFormat = "{{numOfLearners}}\xa0apprenants";
var SkillRatingsChart_Low = "Bas";
var SkillRatingsChart_manager = "responsable";
var SkillRatingsChart_ManagerRatings = "\xc9valuations du manager";
var SkillRatingsChart_Medium = "Moyen";
var SkillRatingsChart_MostRatings = "Les plus \xe9valu\xe9es";
var SkillRatingsChart_NoData = "Pas d’\xe9valuations \xe0 afficher.<br>Seules les comp\xe9tences associ\xe9es aux \xe9valuations de deux personnes ou plus apparaissent sur ce graphique.";
var SkillRatingsChart_NumberOfSkillsShownPluralFormat = "{{tagCount}}\xa0comp\xe9tence(s) sur {{totalTagCount}}";
var SkillRatingsChart_NumberOfSkillsShownSingularFormat = "{{tagCount}} sur {{totalTagCount}}\xa0comp\xe9tence";
var SkillRatingsChart_NumberOfSkillsShownTopFormat = "{{tagCount}}\xa0comp\xe9tence(s) principale(s) sur {{totalTagCount}}";
var SkillRatingsChart_Range = "Plage";
var SkillRatingsChart_Rating = "\xc9valuations";
var SkillRatingsChart_Ratings = "\xc9valuations :";
var SkillRatingsChart_RatingType = "Tous les types";
var SkillRatingsChart_Representativeness = "Repr\xe9sentation :";
var SkillRatingsChart_review = "\xc9valuer";
var SkillRatingsChart_Rigor = "Rigueur :";
var SkillRatingsChart_self = "Soi-m\xeame";
var SkillRatingsChart_SelfRatings = "Auto-\xe9valuations";
var SkillRatingsChart_SkillInventory = "Inventaire des comp\xe9tences";
var SkillRatingsChart_StatsTitle = "Consid\xe9rations des donn\xe9es";
var SkillRatingsChart_TargetLevel = "Niveau cible";
var SkillRatingsChart_Text = "Seules les comp\xe9tences associ\xe9es aux \xe9valuations de {{ x }}\xa0personnes ou plus apparaissent sur ce graphique.";
var SkillRatingsChart_TotalRatingsFormat = "{{total}} apprenants";
var SkillRatingsChart_TotalSkillRatings = "Nombre total d’\xe9valuations de la comp\xe9tence";
var SkillRatingTypeChart_Legend_Manager = "Manager";
var SkillRatingTypeChart_Legend_Peer = "Pair";
var SkillRatingTypeChart_Legend_Self = "Auto-\xe9valuation";
var SkillRatingTypeChart_Legend_SkillReview = "Revue de comp\xe9tence";
var SkillRatingTypeChart_LegendTitle = "Total";
var SkillRatingTypeChart_Title = "\xc9valuations";
var SkillRatingTypeChart_TooltipText = "Comprend le nombre total de toutes les \xe9valuations de comp\xe9tences par type et le nombre d’\xe9valuations pour chaque type au cours de la p\xe9riode actuelle.";
var SkillRatingTypeChart_XAxis_Label = "Plage de dates";
var SkillRatingTypeChart_YAxis_Label = "Nombre total d’\xe9valuations de comp\xe9tences";
var SkillRegistrySearch_SkillRegistrySuggestions = "Suggestions pour le r\xe9pertoire de comp\xe9tences";
var SkillSearchCtrl_ComingSoon = "Prochainement";
var SkillSearchCtrl_EmailAddress = "Adresse e-mail";
var SkillSearchCtrl_GetCertifiedToday = "Obtenez votre {{name}} comp\xe9tence certifi\xe9e aujourd’hui, \xe0 partir de ${{price}}";
var SkillSearchCtrl_GetNotified = "\xcatre inform\xe9";
var SkillSearchCtrl_NoMatch = "La certification de comp\xe9tence Degreed n’est pas disponible pour cette comp\xe9tence. Entrez votre adresse e-mail pour vous inscrire aux notifications lorsque de nouvelles comp\xe9tences sont ajout\xe9es.";
var SkillSearchCtrl_SearchForSkill = "Rechercher une comp\xe9tence";
var SkillSectionsChart_AboveTarget = "Au-dessus de la cible (niveau {{ratingNumber}})";
var SkillSectionsChart_AllSectionSkills = "Toutes les comp\xe9tences de la section";
var SkillSectionsChart_AtTarget = "Au niveau de la cible (niveau {{ratingNumber}})";
var SkillSectionsChart_AvgRatingFormat = "\xc9valuation moyenne – {{avg}}";
var SkillSectionsChart_BelowTarget = "En dessous de la cible (niveau {{ratingNumber}})";
var SkillSectionsChart_Level = "Niveau {{ratingNumber}}";
var SkillSectionsChart_NoData = "Ajoutez des comp\xe9tences \xe0 cette section pour analyser leurs performances.";
var SkillSectionsChart_NoRatings = "Il n’y a pas encore d’\xe9valuations.";
var SkillSectionsChart_NoTarget = "Cette comp\xe9tence n’a pas de cible.";
var SkillSectionsChart_PercentFormat = "{{numberPercent}}\xa0%";
var SkillSectionsChart_PercentOfRatings = "% des \xe9valuations";
var SkillSectionsChart_PlanFollowersFormat = "({{followerCount}}) des abonn\xe9s au plan ont une \xe9valuation pour cette comp\xe9tence.";
var SkillSectionsChart_PlanRatingsFormat = "({{ratingsAboveTargetCount}}) des \xe9valuations atteignent ou d\xe9passent le niveau cible.";
var SkillSectionsChart_PluralRatings = "\xe9valuations";
var SkillSectionsChart_ReviewCertificationNotAvailable = "La revue de comp\xe9tence/la certification Degreed ne sont pas encore disponibles pour cette comp\xe9tence.";
var SkillSectionsChart_SingularRating = "\xe9valuation";
var SkillSectionsChart_SkillCertifications = "Certifi\xe9 Degreed";
var SkillSectionsChart_SkillFollowersFormat = "({{followersCount}}) des apprenants de {{orgName}} suivent cette comp\xe9tence.";
var SkillSectionsChart_SkillRatingsBreakdown = "R\xe9partition des \xe9valuations de comp\xe9tences";
var SkillSectionsChart_SkillRatingsFormat = "({{ratingsCount}}) des apprenants de {{orgName}} ont \xe9valu\xe9 cette comp\xe9tence.";
var SkillSectionsChart_Team_NoRatings = "Aucune \xe9valuation \xe0 afficher.";
var SkillSectionsChart_TeamMembers_AvgFormat = '\xc9valuation moyenne – <span class="color-ocean">{{avg}}</span>';
var SkillSectionsChart_TeamMembers_FollowFormat = "({{followersCount}}) des membres de l’\xe9quipe suivent cette comp\xe9tence.";
var SkillSectionsChart_TeamMembers_RatingsFormat = "({{ratingsCount}}) des membres de l’\xe9quipe ont \xe9valu\xe9 cette comp\xe9tence.";
var SkillsSvc_AddPrimarySkillSource = "Add Primary Skill Source";
var SkillsSvc_AddRoleError = "Un probl\xe8me est survenu lors de l'ajout du poste.";
var SkillsSvc_AddRoleSuccess = "Le poste a bien \xe9t\xe9 ajout\xe9.";
var SkillsSvc_AddSkill = "Ajouter une comp\xe9tence";
var SkillsSvc_AddSkillError = "Un probl\xe8me est survenu lors de l’ajout de la comp\xe9tence.";
var SkillsSvc_AddSkillNameInputDescription = "Saisissez d’abord la comp\xe9tence en anglais. Une fois celle-ci enregistr\xe9e, vous pourrez g\xe9rer les traductions.";
var SkillsSvc_AddSkillSource = "Ajouter une source de comp\xe9tences";
var SkillsSvc_AddSkillSuccess = "La comp\xe9tence a bien \xe9t\xe9 ajout\xe9e.";
var SkillsSvc_AddTranslations = "Ajouter des traductions...";
var SkillsSvc_AttemptPublishAgain = "Try to publish again. If the problem persists, please contact Degreed Support.";
var SkillsSvc_Categories = "Categories";
var SkillsSvc_Category = "Category";
var SkillsSvc_CategoryCreateAgainError = "Something went wrong while creating the category. Try again.";
var SkillsSvc_CategorySuccessfullyCreated = "Category Successfully Created";
var SkillsSvc_CategorySuccessfullyUpdated = "Category successfully updated.";
var SkillsSvc_CountSkillCategoriesPlural = "+{{ count }} Categories";
var SkillsSvc_CountSkillCategoriesSingular = "+1 Category";
var SkillsSvc_CountSkillSynonymsPlural = "+{{ count }} Synonymous Skills";
var SkillsSvc_CountSkillSynonymsSingular = "+1 Synonymous Skill";
var SkillsSvc_CreateSkillTip = "<strong>CONSEIL DE PRO\xa0:</strong> saisissez d’abord le nom de la comp\xe9tence en anglais, puis enregistrez-la et laissez Degreed vous sugg\xe9rer des descriptions, des synonymes et bien plus \xe0 partir de la liste des comp\xe9tences canoniques.";
var SkillsSvc_CTASourcesDesc = "Collections of skills used to define the {{ orgName }} skill inventory";
var SkillsSvc_CTASuggestionsDesc = "Keep {{ orgName }} skills up to date by reviewing suggested updates";
var SkillsSvc_CTAUnpublishedChangesDesc = "Publish changes to update the {{ orgName }} LXP";
var SkillsSvc_CTAUnpublishedSkills = "Unpublished Skills";
var SkillsSvc_CurrentDescription = "<strong>Description actuelle\xa0:</strong> {{description}}";
var SkillsSvc_CurrentSynonymousSkills = "Synonymes actuels";
var SkillsSvc_CurrentTitle = "Intitul\xe9 actuel\xa0: {{title}}";
var SkillsSvc_DeleteLanguageTranslation = "Supprimer la traduction en {{language}} pour la comp\xe9tence {{skillName}}";
var SkillsSvc_DeleteRoleError = "Un probl\xe8me est survenu lors de la suppression du poste.";
var SkillsSvc_DeleteRoleSuccess = "Le poste \xab\xa0{{name}}\xa0\xbb a bien \xe9t\xe9 supprim\xe9.";
var SkillsSvc_DeleteSkillError = "Un probl\xe8me est survenu lors de la suppression de la comp\xe9tence.";
var SkillsSvc_DeleteSkillSource = "Delete Skill Source";
var SkillsSvc_DeleteSkillSourceDescription = "Delete the Skill Source {{Source_Name}} for the organization.";
var SkillsSvc_DeleteSkillSuccess = "La comp\xe9tence \xab\xa0{{name}}\xa0\xbb a bien \xe9t\xe9 supprim\xe9e.";
var SkillsSvc_DeleteTranslation = "Supprimer la traduction";
var SkillsSvc_EditRoleError = "Un probl\xe8me est survenu lors de l’enregistrement du poste.";
var SkillsSvc_EditRoleSuccess = "Le poste a bien \xe9t\xe9 enregistr\xe9.";
var SkillsSvc_EditSkill = "Modifier la comp\xe9tence";
var SkillsSvc_EditSkillError = "Un probl\xe8me est survenu lors de l’enregistrement de la comp\xe9tence.";
var SkillsSvc_EditSkillSuccess = "La comp\xe9tence a bien \xe9t\xe9 enregistr\xe9e.";
var SkillsSvc_EditsToSkills = '"Edits to {{unpublishedChangesCount}} skills"';
var SkillsSvc_EnableEndorseSkillOption = "Si cette option est activ\xe9e, une ic\xf4ne de recommandation appara\xeet sur la carte.";
var SkillsSvc_EnableSkillReview = "Activer la revue de comp\xe9tence";
var SkillsSvc_EndorseSkill = "Recommander la comp\xe9tence";
var SkillsSvc_FileUploadSuccessful = "Le fichier a \xe9t\xe9 charg\xe9 avec succ\xe8s.";
var SkillsSvc_FileUploadSuccessfulDescription = "{{fileName}} a bien \xe9t\xe9 charg\xe9 dans {{skillSourceName}}";
var SkillsSvc_GetStarted_Dashboard = "Get Started with Degreed Skills and superpower your learning.";
var SkillsSvc_GetStarted_Dashboard_Description = "First things first, add a skill source and its skills to your Inventory.";
var SkillsSvc_ImportantPublishingInfo = "Important Publishing Information";
var SkillsSvc_IntegrationSourceEditTip = "Les int\xe9grations sont d\xe9finies par une source externe. Elles offrent peu de possibilit\xe9s de modification et ne peuvent pas \xeatre supprim\xe9es. Pour d\xe9sactiver l’int\xe9gration des comp\xe9tences, {{contactSupportHtml}}.";
var SkillsSvc_ItemsAreNowAvailable = "Items are now available in the LXP.";
var SkillsSvc_JobRoles = "Postes";
var SkillsSvc_JobRolesDescription = "Des groupes de comp\xe9tences connexes bas\xe9es sur des caract\xe9ristiques, des fonctions ou des expertises communes.";
var SkillsSvc_LimitVisibilityToTheseGroups = "Restreindre l’acc\xe8s aux groupes suivants";
var SkillsSvc_ManageCategories = "Manage Categories";
var SkillsSvc_ManageSources = "Manage Sources";
var SkillsSvc_MoreItems = "+ {{count}}\xa0autres";
var SkillsSvc_NewSkillDescription = "New Skill Description";
var SkillsSvc_NewSkillSpelling = "New Skill Spelling";
var SkillsSvc_NoPublishedHistory = "Aucun historique publi\xe9";
var SkillsSvc_OnboardingAddedNotification = "L’\xe9l\xe9ment a bien \xe9t\xe9 ajout\xe9 aux suggestions.";
var SkillsSvc_OnboardingError = "D\xe9sol\xe9s ! Un probl\xe8me est survenu lors de l’enregistrement des modifications.";
var SkillsSvc_OnboardingRemovedNotification = "L’\xe9l\xe9ment a bien \xe9t\xe9 supprim\xe9.";
var SkillsSvc_OneMoreItem = "+ 1\xa0autre";
var SkillsSvc_OneTranslationSavedMsg = "{{count}}\xa0traduction a \xe9t\xe9 ajout\xe9e \xe0 {{skillName}}";
var SkillsSvc_OrgNameSkillsOnly = "{{ orgName }} Skills Only";
var SkillsSvc_PrimarySourceEditTip = "Il s’agit de la source de comp\xe9tences principale pour {{orgName}}. Elle ne peut pas \xeatre supprim\xe9e.";
var SkillsSvc_Proficiency = "Ma\xeetrise";
var SkillsSvc_Proficiency_Custom = "personnalis\xe9";
var SkillsSvc_Proficiency_Default = "par d\xe9faut";
var SkillsSvc_Proficiency_Description_SubTitle = "Personnalisez la description du niveau de ma\xeetrise pour cette comp\xe9tence.";
var SkillsSvc_Proficiency_Description_Title = "Description du niveau de ma\xeetrise de la comp\xe9tence";
var SkillsSvc_Proficiency_InferDescription = "Inf\xe9rer une description";
var SkillsSvc_Proficiency_Reset_Description = "R\xe9initialiser les descriptions";
var SkillsSvc_Proficiency_Reset_Description_Content = "La r\xe9initialisation des descriptions des niveaux de ma\xeetrise de la comp\xe9tence {{skillName}} restaurera toutes les descriptions aux valeurs par d\xe9faut d\xe9finies \xe0 l’\xe9chelle de l’organisation.";
var SkillsSvc_PromoteSkillToOrg = "+ Add to {{orgName}} Skills";
var SkillsSvc_Proprietary = "Exclusive";
var SkillsSvc_ProprietarySkillOption = "Les recommandations (descriptions, synonymes et comp\xe9tences connexes) ne s’appliquent pas aux comp\xe9tences exclusives.";
var SkillsSvc_ProprietaryToOrgLabel = "Exclusive \xe0 {{orgName}}";
var SkillsSvc_PublishChangesToOrgName = "Publier les modifications pour mettre \xe0 jour la plateforme LXP de {{ orgName }}.";
var SkillsSvc_PublishedSuccessfully = "Published Successfully";
var SkillsSvc_PublishSkillCount = "Publish {{publishSkillCount}} Skills";
var SkillsSvc_PublishToLxp = "Publier sur la LXP";
var SkillsSvc_PublishWarning = "You are about to publish the following to all learners in your organization's Degreed LXP instance.";
var SkillsSvc_RetrieveError = "D\xe9sol\xe9\xa0! Impossible de r\xe9cup\xe9rer le contenu.";
var SkillsSvc_ReviewSuggestions = "Review Suggestions";
var SkillsSvc_RolesBulkUploadNotice = "Le fichier que vous avez t\xe9l\xe9charg\xe9 est en cours de traitement. Les modifications apport\xe9es en fonction de ce fichier peuvent prendre 4\xa0heures avant d’apparaitre dans Degreed.";
var SkillsSvc_RoleSuggestions = "Suggestions de postes";
var SkillsSvc_Save_Upload = "Enregistrer et charger";
var SkillsSvc_SearchGroups = "Rechercher un groupe";
var SkillsSvc_SearchRoles = "Rechercher des postes";
var SkillsSvc_SearchSkillCategories = "Rechercher parmi les cat\xe9gories";
var SkillsSvc_SearchSkills = "Rechercher des comp\xe9tences";
var SkillsSvc_SillAlreadyExistsInOrg = "La comp\xe9tence figure d\xe9j\xe0 dans l’inventaire des comp\xe9tences de {{orgName}}.";
var SkillsSvc_SkillCategories = "Cat\xe9gories de comp\xe9tences";
var SkillsSvc_SkillCategoriesDescription = "Des groupes de comp\xe9tences connexes bas\xe9es sur des caract\xe9ristiques, des fonctions ou des expertises communes";
var SkillsSvc_SkillId = "ID de la comp\xe9tence";
var SkillsSvc_SkillReviewEnableOption = "Activer la revue de cette comp\xe9tence pour les apprenants de l’organisation.";
var SkillsSvc_SkillReviewVisibility = "Visibilit\xe9 de la revue de comp\xe9tence";
var SkillsSvc_SkillReviewVisibilityDescription = "D\xe9finir les personnes qui peuvent acc\xe9der aux \xe9valuations de revue de comp\xe9tence.";
var SkillsSvc_SkillsBulkUploadNotice = "Le fichier que vous avez t\xe9l\xe9charg\xe9 est en cours de traitement. Les modifications apport\xe9es en fonction de ce fichier peuvent prendre 4\xa0heures avant d’apparaitre dans Degreed.";
var SkillsSvc_SkillSourceCreated = "{{skillSourceName}} a \xe9t\xe9 cr\xe9\xe9 avec succ\xe8s\xa0!";
var SkillsSvc_SkillSourceCreatedDescription = "Chargez votre fichier de comp\xe9tences pour finaliser la cr\xe9ation de cette source de comp\xe9tences.";
var SkillsSvc_SkillSourceDescription = "Description de la source de comp\xe9tences";
var SkillsSvc_SkillSourceName = "Nom de la source de comp\xe9tences";
var SkillsSvc_SkillSources = "Sources de comp\xe9tences";
var SkillsSvc_SkillSuggestionDrawerTitle = "Suggestions de comp\xe9tences";
var SkillsSvc_SkillSynonymError = "{{skillName}} already added as {{synonymName}}";
var SkillsSvc_SkillTitle = "Titre de la comp\xe9tence";
var SkillsSvc_SkillUpdatedSuccessfully = "Les modifications apport\xe9es \xe0 {{skillName}} ont bien \xe9t\xe9 enregistr\xe9es.";
var SkillsSvc_SkipForNow = "Ignorer pour l’instant";
var SkillsSvc_SourceAlreadyExistsInOrg = "Le nom de la source de comp\xe9tences figure d\xe9j\xe0 dans l’inventaire de comp\xe9tences de {{orgName}}.";
var SkillsSvc_SuggestedSkillDescription = "Description de la comp\xe9tence sugg\xe9r\xe9e";
var SkillsSvc_SuggestedSkillTitle = "Intitul\xe9 de la comp\xe9tence sugg\xe9r\xe9e";
var SkillsSvc_SuggestedSynonymousSkills = "Synonymes sugg\xe9r\xe9s";
var SkillsSvc_suggestions_sub_header_text = "Suggestions inf\xe9r\xe9es \xe0 partir des comp\xe9tences normalis\xe9es Degreed";
var SkillsSvc_SuggestionsApplied = "{{number}} suggestion(s) appliqu\xe9e(s) pour {{skillName}}";
var SkillsSvc_SuggestionsDeclined = "{{number}} suggestion(s) refus\xe9e(s) pour {{skillName}}";
var SkillsSvc_SynonymAlreadyExistsMessaging = "A synonym label can only be linked to one skill. If you are unable to add it here, it's already linked to another skill.";
var SkillsSvc_SynonymousSkills = "Synonymes";
var SkillsSvc_SynonymousSkills_MergeModal_button = "Fusionner les comp\xe9tences";
var SkillsSvc_SynonymousSkills_MergeModal_paragraph_1 = "La comp\xe9tence {{synonymousSkillName}} est actuellement active dans l’inventaire des comp\xe9tences de {{orgName}}. Si vous la publiez en tant que synonyme de {{skillName}}, la comp\xe9tence {{synonymousSkillName}} sera masqu\xe9e et ses informations seront fusionn\xe9es avec {{skillName}} dans la LXP Degreed.";
var SkillsSvc_SynonymousSkills_MergeModal_paragraph_2 = "Si vous la supprimez en tant que synonyme alors qu’elle est encore \xe0 l’\xe9tat d’\xe9bauche, {{synonymousSkillName}} sera de nouveau disponible dans l’inventaire des comp\xe9tences de {{orgName}}.";
var SkillsSvc_SynonymousSkills_MergeModal_title = "Fusionner les comp\xe9tences";
var SkillsSvc_SynonymousSkillsDescription = "D’autres orthographes, mots ou groupes de mots utilis\xe9s de mani\xe8re interchangeable avec le nom de la comp\xe9tence.";
var SkillsSvc_TotalSuggestionsSelected = "Nombre total de suggestions s\xe9lectionn\xe9es";
var SkillsSvc_Translations = "Traductions pour la comp\xe9tence {{skillName}}";
var SkillsSvc_TranslationsSaved = "Traductions enregistr\xe9es";
var SkillsSvc_TranslationsSavedMsg = "{{count}}\xa0traductions ont \xe9t\xe9 ajout\xe9es \xe0 {{skillName}}";
var SkillsSvc_TryAgainOrContactSupport = "Veuillez r\xe9essayer. Si le probl\xe8me persiste, contactez l’assistance Degreed.";
var SkillsSvc_UnpublishedChange = "{{ number }} modification supprim\xe9e";
var SkillsSvc_UnpublishedChanges = "{{ number }} modifications supprim\xe9es";
var SkillsSvc_UnpublishedChanges_None = "{{ zero }} modification supprim\xe9e";
var SkillsSvc_UpdateError = "Un probl\xe8me est survenu lors de la mise \xe0 jour de la comp\xe9tence.";
var SkillsSvc_UpdateRoleError = "Un probl\xe8me est survenu lors de la mise \xe0 jour du poste.";
var SkillsSvc_UpdateRoleSuccess = "Le poste a bien \xe9t\xe9 mis \xe0 jour.";
var SkillsSvc_UploadRoleError = "Un probl\xe8me est survenu lors du chargement des postes.";
var SkillsSvc_UploadSkillError = "Un probl\xe8me est survenu lors du chargement des comp\xe9tences.";
var SkillsSvc_UsersTitle = "Personnes abonn\xe9es \xe0 cet \xe9l\xe9ment";
var SkillsSvc_ZeroTranslationSavedMsg = "{{count}}\xa0traduction a \xe9t\xe9 ajout\xe9e \xe0 {{skillName}}";
var SkillStd_AddDescription = "Ajouter une description";
var SkillStd_AddSkillToProfile = "Ajouter la comp\xe9tence au profil";
var SkillStd_AddTitle = "Ajouter un titre";
var SkillStd_CreateSkillStandards = "Cr\xe9er des normes de comp\xe9tences";
var SkillStd_DeleteSegmentMsg = "La suppression de \xab\xa0{{ segmentName }}\xa0\xbb  le supprimera \xe9galement de tous les segments dans \xab\xa0{{ skillStandardsName }}\xa0\xbb . Cette action est imm\xe9diate et irr\xe9versible. Voulez-vous vraiment supprimer \xab\xa0{{ segmentName }}\xa0\xbb\xa0?";
var SkillStd_DeleteSkillStandardsError = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de la suppression de la norme de comp\xe9tence.";
var SkillStd_DeleteSkillStandardsSegmentError = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de la suppression du segment de norme de comp\xe9tences.";
var SkillStd_DeleteSkillStandardsSegmentSuccess = "Le segment de normes de comp\xe9tences {{name}} a bien \xe9t\xe9 supprim\xe9\xa0!";
var SkillStd_DeleteSkillStandardsSuccess = "La norme de comp\xe9tences {{name}} a bien \xe9t\xe9 supprim\xe9e\xa0!";
var SkillStd_DescriptionPlaceholder = "Veuillez fournir une description pour vos utilisateurs";
var SkillStd_DescriptionSuggestionPlaceholder = "D\xe9crivez bri\xe8vement l’objet de cette norme de comp\xe9tence.";
var SkillStd_EditDescription = "Modifier la description";
var SkillStd_EditSkillStandards = "Modifier les normes de comp\xe9tences";
var SkillStd_emptyStateAddSomethingToShowHere = "Lorsque vous ajouterez un \xe9l\xe9ment, il appara\xeetra ici.";
var SkillStd_MaximumAddedSegmentsDesc = "Vous pouvez ajouter jusqu’\xe0 {{ value }}\xa0segments par norme de comp\xe9tence.";
var SkillStd_MaximumAddedSegmentsReached = "Vous avez atteint le nombre total de segments accept\xe9s pour cette norme de comp\xe9tence.";
var SkillStd_MinimumVisibleSkillWarning = "Au moins une comp\xe9tence doit \xeatre visible pour publier ce segment.";
var SkillStd_NoVisibleSkills = "Aucune comp\xe9tence visible";
var SkillStd_NoVisibleSkillsUnpublishBody = "Il n’y a pas de comp\xe9tence visible dans {{segmentName}}. Au moins une comp\xe9tence doit \xeatre visible pour publier ce segment.";
var SkillStd_NoVisibleSkillsUnpublishBodySecondary = "Voulez-vous vraiment supprimer {{segmentName}}\xa0?";
var SkillStd_PersonalSkillTarget = "Cible de la comp\xe9tence personnelle";
var SkillStd_PublishSegment = "Publier le segment";
var SkillStd_RecommendedSkillsMessage = "Votre organisation recommande ces comp\xe9tences dans le cadre de votre d\xe9veloppement professionnel.";
var SkillStd_RemoveSegment = "Supprimer le segment";
var SkillStd_RemoveSegmentBody = "La suppression de {{ segmentName }} affectera toutes les relations de comp\xe9tences pour ce segment. Cette action est imm\xe9diate et irr\xe9versible.";
var SkillStd_RemoveSkill = "Supprimer la comp\xe9tence";
var SkillStd_RemoveSkillBody = "La suppression de {{skillName}} l’\xf4tera \xe9galement de tous les segments dans {{ skillStandardsName}}. Cette action est imm\xe9diate et irr\xe9versible.";
var SkillStd_RemoveSkillBodySecondary = "Voulez-vous vraiment supprimer {{ skillName }}\xa0?";
var SkillStd_RemoveSkillError = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de la suppression de cette comp\xe9tence de la norme de comp\xe9tences.";
var SkillStd_RemoveSkillSuccess = "{{ skillName }} a bien \xe9t\xe9 supprim\xe9 de {{ skillStandard }}";
var SkillStd_RequirementStatus = "Statut de l’exigence";
var SkillStd_SegmentAddedSuccessPlural = "Vous avez bien ajout\xe9 des segments \xe0 {{ skillStandardsName }}";
var SkillStd_SegmentAddedSuccessSingle = "Vous avez bien ajout\xe9 un segment \xe0 {{ skillStandardsName }}";
var SkillStd_SegmentPublishRequirementsNotMet = "La publication de {{ name }} a \xe9chou\xe9. Veuillez v\xe9rifier que tous les crit\xe8res ont \xe9t\xe9 respect\xe9s avant de publier ce segment.";
var SkillStd_Segments = "Segments";
var SkillStd_SkillAddedSuccessPlural = "Vous avez bien ajout\xe9 des comp\xe9tences \xe0 {{ skillStandardsName }}";
var SkillStd_SkillAddedSuccessSingle = "Vous avez bien ajout\xe9 une comp\xe9tence \xe0 {{ skillStandardsName }}";
var SkillStd_SkillRemovedSegmentUnpublished_Multiple = "{{ skillName }} a \xe9t\xe9 supprim\xe9. {{ count }}\xa0segments ont \xe9t\xe9 d\xe9publi\xe9s.";
var SkillStd_SkillRemovedSegmentUnpublished_Single = "{{ skillName }} a \xe9t\xe9 supprim\xe9. {{ segmentName }} a \xe9t\xe9 d\xe9publi\xe9.";
var SkillStd_SkillRequired = "Critiques";
var SkillStd_SkillSet = "Ensemble de comp\xe9tences";
var SkillStd_SkillSetRelationships = "Relations de l’ensemble de comp\xe9tences";
var SkillStd_SkillStandards = "Normes de comp\xe9tences";
var SkillStd_SkillStandardsProfileSectionSubtitle = "Ces normes de comp\xe9tences ont \xe9t\xe9 s\xe9lectionn\xe9es pour vous par votre administrateur";
var SkillStd_SkillTargets = "Cibles de la comp\xe9tence";
var SkillStd_SkillVisible = "Visible";
var SkillStd_Status_NoSegments = "Aucun segment";
var SkillStd_Status_UnpublishedSegments = "Segments supprim\xe9s";
var SkillStd_SuccessfullyPublished = "{{ name }} a bien \xe9t\xe9 publi\xe9.";
var SkillStd_SuccessfullyUnpublished = "{{ name }} a bien \xe9t\xe9 d\xe9publi\xe9.";
var SkillStd_TitleAlreadyExistsError = "Ce titre existe d\xe9j\xe0. Veuillez saisir un nouveau titre.";
var SkillStd_TitleSuggestionPlaceholder = "P. ex. Int\xe9gration des nouveaux collaborateurs";
var SkillStd_Unpublished = "Supprim\xe9";
var SkillStd_UnpublishedSegmentsWarning = "Les segments supprim\xe9s ont \xe9t\xe9 ajout\xe9s \xe0 cette norme de comp\xe9tence. Ces segments resteront inactifs tant qu’il n’ont pas \xe9t\xe9 publi\xe9s au sein de l’organisation.";
var SkillStd_UnpublishSegment = "Supprimer le segment";
var SkillStd_UnpublishSegmentMsg = "La suppression de ce segment aura une incidence sur l’affichage de toutes les comp\xe9tences qui lui sont associ\xe9es pour les utilisateurs de ce segment.";
var SkillStd_UnpublishSegmentMsgConfirm = "Voulez-vous vraiment supprimer ce segment\xa0?";
var SkillStd_UnpublishSegmentName = "Supprimer {{segmentName}}";
var SkillTrends_CustomAttributes_ErrorMessage = "Impossible de charger les attributs";
var SkillTrends_Declining = "En baisse";
var SkillTrends_Emerging = "En hausse";
var SkillTrends_FilterByGroups = "Filtrer par groupe";
var SkillTrends_FilterBySegments = "Filtrer par segment";
var SkillTrends_Groups_ErrorMessage = "Impossible de charger les groupes";
var SkillTrends_JobRoles_ErrorMessage = "Impossible de charger les postes";
var SkillTrends_NoMatchingGroups = "Aucun groupe correspondant";
var SkillTrends_NoMatchingSegments = "Aucun segment correspondant";
var SkillTrends_NoResultsInfo = "Impossible d’afficher ces donn\xe9es en raison d’informations insuffisantes.";
var SkillTrends_NoResultsLabel = "Aucun r\xe9sultat";
var SkillTrends_NotEnoughDataLabel = "Aucune donn\xe9e n’est disponible pour ce graphique.";
var SkillTrends_SkillGaps_Chart_NoResults = "Aucun r\xe9sultat";
var SkillTrends_SkillGaps_Chart_NoResults_Info = "Impossible d’afficher ces donn\xe9es en raison d’informations insuffisantes.";
var SkillTrends_SkillGaps_Chart_SeriesName_SkillGap = "D\xe9ficit de comp\xe9tence";
var SkillTrends_SkillGaps_Chart_SeriesName_SkillRating = "\xc9valuation de la comp\xe9tence";
var SkillTrends_SkillGaps_Chart_SeriesName_SkillTarget = "Cible de la comp\xe9tence";
var SkillTrends_SkillGaps_Chart_Title = "D\xe9ficits";
var SkillTrends_SkillGaps_Filters_JobRoles_Label = "Postes";
var SkillTrends_SkillGaps_Filters_RatingTypes_Label = "Types d’\xe9valuation";
var SkillTrends_SkillGaps_Filters_RatingTypes_Option_All = "Tous";
var SkillTrends_SkillGaps_Filters_RatingTypes_Option_Manager = "Manager";
var SkillTrends_SkillGaps_Filters_RatingTypes_Option_Peer = "Pair";
var SkillTrends_SkillGaps_Filters_RatingTypes_Option_Self = "Auto-\xe9valuation";
var SkillTrends_SkillGaps_Filters_RatingTypes_Option_SkillReview = "Revue de comp\xe9tence";
var SkillTrends_SkillGaps_NoJobRolesMessage = "Pour afficher ce graphique, veuillez ajouter des plans d’\xe9volution de poste avec des comp\xe9tences poss\xe9dant des cibles.";
var SkillTrends_SkillGaps_Section_Title = "D\xe9ficits";
var SkillTrends_SkillGaps_Section_Tooltip = "Le poste avec le plus grand nombre d’utilisateurs est pr\xe9s\xe9lectionn\xe9. Vous pouvez modifier la s\xe9lection pour voir les d\xe9ficits de comp\xe9tences pour diff\xe9rents postes.";
var SkillTrends_Tooltip_Declining = "Comp\xe9tences ayant la plus forte baisse d’activit\xe9 pour la p\xe9riode actuelle, compar\xe9e \xe0 la p\xe9riode pr\xe9c\xe9dente de m\xeame dur\xe9e.";
var SkillTrends_Tooltip_Emerging = "Comp\xe9tences ayant la plus forte hausse d’activit\xe9 pour la p\xe9riode actuelle, compar\xe9e \xe0 la p\xe9riode pr\xe9c\xe9dente de m\xeame dur\xe9e.";
var SkillTrends_Tooltip_Trending = "Comp\xe9tences ayant globalement le plus d’activit\xe9 pour la p\xe9riode actuelle. Les hausses ou les baisses sont compar\xe9es entre la p\xe9riode actuelle et la p\xe9riode pr\xe9c\xe9dente de m\xeame dur\xe9e.";
var SkillTrends_Top = "Populaires";
var SkillTrends_TopSearches_Title = "Recherches populaires";
var SkillTrends_TopSearches_Tooltip = "Comp\xe9tences comptabilisant le plus de recherches au cours de la p\xe9riode actuelle. Les hausses ou les baisses sont compar\xe9es entre la p\xe9riode actuelle et la p\xe9riode pr\xe9c\xe9dente de m\xeame dur\xe9e.";
var SkillTrends_Trending = "Tendances";
var TagRating_AskForNewRating = "Demander une nouvelle \xe9valuation";
var TagRating_CancelRequest = "Annuler la demande";
var TagRating_CancelRequestConfirmationFormat = "Vous avez une demande d’\xe9valuation de la comp\xe9tence \xab\xa0{{tagName}}\xa0\xbb en attente pour {{raterName}}. Voulez-vous conserver ou annuler cette demande\xa0?";
var TagRating_CancelRequestConfirmationFormatNoManager = "Vous avez une demande d’\xe9valuation de la comp\xe9tence \xab\xa0{{tagName}}\xa0\xbb en attente pour un utilisateur d\xe9sactiv\xe9. Voulez-vous annuler cette demande\xa0?";
var TagRating_ChangeRating = "Modifier l’\xe9valuation";
var TagRating_DeleteRatingFormat = "\xcates-vous s\xfbr de vouloir supprimer la note pour {{tagName}} ?";
var TagRating_KeepRequest = "Conserver la demande";
var TagRating_PendingManagerRequest = "Demande d’\xe9valuation du manager en attente";
var TagRating_PendingPeerRequest = "Demande d’\xe9valuation par un pair en attente";
var TagRating_SkillTargetSetFormat = "{{nameHtml}} a mis \xe0 jour votre niveau cible sur {{level}}";
var TagRating_YouWereRatedFormat = "{{nameHtml}} vous a \xe9valu\xe9 un niveau {{level}}";
var TagRatingItem_TargetLevelFormat = "Niveau cible\xa0: {{level}}";
var TagsCtrl_Category = "Veuillez ajouter au moins une comp\xe9tence.";
var TagsCtrl_CategoryHint = "Conseil\xa0: saisissez le nom d’une comp\xe9tence, puis choisissez une option dans la liste ou utilisez la touche Entr\xe9e.";
var TagsCtrl_SkillsPlaceholder = "Saisissez une comp\xe9tence";
var TagsCtrl_SuggestedSkillsError = "Une erreur s’est produite lors du chargement de vos suggestions de comp\xe9tences.";
var TagsCtrl_SuggestedSkillsForSkill = "Suggestions de comp\xe9tences bas\xe9es sur \xab\xa0{{skillName}}\xa0\xbb";
var TagsCtrl_SuggestedSkillsLoading = "Chargement des suggestions de comp\xe9tences...";
var TagsCtrl_SuggestedSkillsTitle = "Suggestions de comp\xe9tences";
var TagsEdit_AddCategories = "Comp\xe9tences";
var TagsEdit_CategoriesMessage = "Ajouter des comp\xe9tences vous aide \xe0 suivre votre progression. Vous pouvez changer vos comp\xe9tences sur votre page Profil.";
var TagsFormCtrl_AddSkillsOrTopics = "Ajouter des comp\xe9tences";
var TagsFormCtrl_SearchForSkill = "Rechercher une comp\xe9tence";
var TagsSearch_A11yTopTagsHint = "Les boutons situ\xe9s sous le champ de texte vous permettent de s\xe9lectionner les comp\xe9tences recommand\xe9es.";
var TagsSearch_SkillProficiencyLevelDocumentationLabel = "Visit Degreed Skills for proficiency level descriptions";
var TagsSvc_AddFocusSkillSuccess = "La comp\xe9tence prioritaire a bien \xe9t\xe9 ajout\xe9e.";
var TagsSvc_AddSkillError = "Une erreur est survenue durant l’ajout de votre comp\xe9tence.";
var TagsSvc_AddSkillsError = "Une erreur est survenue durant l’ajout de vos comp\xe9tences.";
var TagsSvc_AddSkillsSuccess = "Les comp\xe9tences ont bien \xe9t\xe9 ajout\xe9es.";
var TagsSvc_AddSkillSuccess = "La comp\xe9tence a bien \xe9t\xe9 ajout\xe9e.";
var TagsSvc_CategoryAvailable = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration des cat\xe9gories disponibles.";
var TagsSvc_CategoryError = "Un probl\xe8me est survenu lors de l’acc\xe8s \xe0 vos cat\xe9gories principales.";
var TagsSvc_CategoryRetrieval = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration de vos cat\xe9gories.";
var TagsSvc_CategorySaves = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’enregistrement de vos cat\xe9gories.";
var TagsSvc_ConvertSkills = "Convertir les comp\xe9tences";
var TagsSvc_ConvertWorkdaySkillsDescription = "Les comp\xe9tences s\xe9lectionn\xe9es seront converties dans leurs \xe9quivalents dans Workday";
var TagsSvc_CreateError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’enregistrement de vos cat\xe9gories.";
var TagsSvc_CredentialableTagsError = "D\xe9sol\xe9, un probl\xe8me est survenu lors de la r\xe9cup\xe9ration des comp\xe9tences.";
var TagsSvc_DeleteTagRatingError = "Une erreur s’est produite lors de l’annulation de votre \xe9valuation. R\xe9essayer.";
var TagsSvc_FocusSkillAlreadyAdded = "Cette comp\xe9tence prioritaire existe d\xe9j\xe0.";
var TagsSvc_GetTagError = "Une erreur est survenue lors de la r\xe9cup\xe9ration des informations sur les mots-cl\xe9s.";
var TagsSvc_GetTagRatingDataError = "D\xe9sol\xe9, l’\xe9valuation de vos comp\xe9tences n’est pas disponible pour le moment.";
var TagsSvc_GetTagRatingError = "Une erreur est survenue lors de l’obtention des informations d’\xe9valuation.";
var TagsSvc_MatchingCategoryError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration des cat\xe9gories correspondantes.";
var TagsSvc_RateTagError = "Une erreur est survenue lors de l’enregistrement de l’\xe9valuation.";
var TagsSvc_RecommendSkillError = "Un probl\xe8me est survenu lors de l’envoi de la comp\xe9tence recommand\xe9e";
var TagsSvc_RemoveFocusSkillSuccess = "La comp\xe9tence prioritaire a bien \xe9t\xe9 supprim\xe9e.";
var TagsSvc_RemoveSkillError = "Une erreur est survenue lors de la suppression de votre comp\xe9tence.";
var TagsSvc_Replace = "Remplacer";
var TagsSvc_ReplaceFocusInterestModalDescription = "Vous avez d\xe9j\xe0 <b>4\xa0comp\xe9tences prioritaires</b> s\xe9lectionn\xe9es. Choisissez l’une des comp\xe9tences ci-dessous pour la remplacer.";
var TagsSvc_ReplaceFocusInterestModalTitle = "Remplacer une comp\xe9tence prioritaire";
var TagsSvc_RequestTagRatingError = "Une erreur est survenue lors de la demande d’\xe9valuation.";
var TagsSvc_SkillsTagsError = "D\xe9sol\xe9, un probl\xe8me est survenu lors de la r\xe9cup\xe9ration des comp\xe9tences.";
var TagsSvc_UpdateAssociateRatingSuccess = "Vous avez termin\xe9 l’{{ratingType}}. {{requester}} va recevoir une notification l’avisant de l’ach\xe8vement de l’\xe9valuation de la comp\xe9tence.";
var TagsSvc_UpdateFocusSkillsError = "D\xe9sol\xe9s\xa0! Un probl\xe8me est survenu lors de l’enregistrement de votre comp\xe9tence prioritaire.";
var TagsSvc_UpdatePrivacyError = "Une erreur s’est produite lors de la mise \xe0 jour de ce param\xe8tre de confidentialit\xe9.";
var TagsSvc_UseWorkdaySkillNames = "Utiliser les noms de comp\xe9tence de Workday\xa0?";
var TagsSvc_WorkdayCanonicalSkillConversionInstructions = "Les comp\xe9tences que vous \xeates en train d’ajouter ont des noms l\xe9g\xe8rement diff\xe9rents dans Workday. Utilisez les noms de comp\xe9tence correspondants de Workday, si disponibles, pour garantir la coh\xe9rence de votre profil sur les deux plateformes. Les comp\xe9tences ayant un \xe9quivalent dans Workday seront alors fusionn\xe9es dans une comp\xe9tence Workday synchronis\xe9e et unique. Si vous quittez simplement cette fen\xeatre modale, ces comp\xe9tences ne seront pas ajout\xe9es \xe0 votre profil.";
var Target_Delete = "Supprimer";
var Target_EditDetails = "Modifier les d\xe9tails";
var Target_Empty = "Rien n’a encore \xe9t\xe9 ajout\xe9.";
var Target_SetAuthoring = "Ajouter du contenu";
var Target_SetNotAuthoring = "Ajout termin\xe9";
var Target_TargetLevelFormat = "Niveau cible {{level}}";
var TargetAuthorsForm_A11yAuthorDescription = "{{authorname}}. Cliquez pour g\xe9rer tous les collaborateurs.";
var TargetAuthorsForm_Authors = "Collaborateurs";
var TargetAuthorsForm_Save = "Enregistrer les modifications";
var TargetAuthorsForm_SearchPeopleGroupsPlaceHolder = "Rechercher une personne ou un groupe";
var TargetAuthorsForm_SearchPlaceHolder = "Rechercher des personnes...";
var TargetAuthorsForm_Title = "G\xe9rer les collaborateurs";
var TargetAuthorsForm_TitleAdd = "Ajouter des collaborateurs";
var TargetCtrl_AcceptAutosuggest = "Appliquer les suggestions";
var TargetCtrl_AddDirectories = "Ajouter des r\xe9pertoires";
var TargetCtrl_AddDirectorys = "Ajouter des r\xe9pertoires";
var TargetCtrl_AddGroups = "Ajouter des groupes";
var TargetCtrl_AddInputs = "Ajouter du contenu";
var TargetCtrl_AddOpportunities = "Ajouter des opportunit\xe9s";
var TargetCtrl_AddPages = "Ajouter des plans";
var TargetCtrl_AddPathways = "Ajouter des parcours";
var TargetCtrl_AddProviders = "Ajouter des fournisseurs";
var TargetCtrl_AddTags = "Ajouter des comp\xe9tences";
var TargetCtrl_AddTargetAndDirectoryPlural = "Ajouter des plans ou des r\xe9pertoires";
var TargetCtrl_AddTargetPlural = "Ajouter des plans";
var TargetCtrl_AddTargets = "Ajouter un plan";
var TargetCtrl_AddUsers = "Ajouter des personnes";
var TargetCtrl_AutoFill = "Souhaitez-vous que nous remplissions automatiquement cette page avec des comp\xe9tences, des parcours, des groupes, des personnes et des contenus\xa0?";
var TargetCtrl_AutosuggestNotice = "Appliquer ces suggestions renseign\xe9es automatiquement";
var TargetCtrl_ConfirmCloseButton = "Oui, fermer";
var TargetCtrl_ConfirmDeleteButton = "Oui, supprimer";
var TargetCtrl_DeleteInstructions = "Saisissez {{delete}} en lettres majuscules pour confirmer";
var TargetCtrl_DeletePluralPrompt = "Are you sure you want to delete {{ count }} plans?";
var TargetCtrl_DeletePrompt = "Voulez-vous vraiment supprimer {{targetTitle}}\xa0?";
var TargetCtrl_DeletePromptDescription = "Vous ne pouvez pas annuler cette action.";
var TargetCtrl_Groups = "Groupes";
var TargetCtrl_Inputs = "Contenu";
var TargetCtrl_NotVisibleNotice = "Ce {{targetType}} n’est actuellement pas visible pour votre organisation.";
var TargetCtrl_Pathways = "Parcours";
var TargetCtrl_PrimaryPlanDeselection = "Souhaitez-vous r\xe9ellement cesser d’utiliser ce plan comme plan principal ?";
var TargetCtrl_PrimaryPlanSelection = "Souhaitez-vous r\xe9ellement d\xe9finir ce plan comme plan principal ? Votre plan principal existant ne sera plus indiqu\xe9 comme votre plan principal.";
var TargetCtrl_SetTargetLevel = "D\xe9finir un niveau cible";
var TargetCtrl_SetVisible = "Rendre visible";
var TargetCtrl_SetVisibleNotAllowed = "Ce {{targetType}} ne contient aucune ressource, il n’est donc pas visible pour votre organisation. Ajoutez des ressources puis r\xe9essayez.";
var TargetCtrl_SuggestionApplySuccess = "Les suggestions ont \xe9t\xe9 automatiquement appliqu\xe9es";
var TargetCtrl_Tags = "Comp\xe9tences";
var TargetCtrl_TargetAndDirectoryPlural = "Plans et r\xe9pertoires";
var TargetCtrl_TargetPlural = "Plans";
var TargetCtrl_Users = "Personnes";
var TargetCtrl_WelcomeBack = "Bienvenue dans votre plan";
var TargetCtrl_YesAutopopulate = "Oui, remplir automatiquement";
var TargetForm_AutopopulateInfo = "Remplissez automatiquement ce plan avec les \xe9l\xe9ments sugg\xe9r\xe9s.";
var TargetForm_AutopopulateTitle = "Remplir automatiquement";
var TargetForm_CreateButton = "Cr\xe9er {{targetType}}";
var TargetForm_CreateTitle = "Cr\xe9er {{targetType}}";
var TargetForm_Description = "Description";
var TargetForm_DescriptionPlaceholder = "Ce plan contribuera \xe0 votre d\xe9veloppement en tant que...";
var TargetForm_EditTitle = "Modifier {{targetType}}";
var TargetForm_FormDescription = "Les plans aident les individus, les groupes et l’organisation dans son ensemble \xe0 progresser de mani\xe8re guid\xe9e et planifi\xe9e.";
var TargetForm_IsEndorsedInfo = "Si cette option est coch\xe9e, une ic\xf4ne de recommandation appara\xeetra sur la carte.";
var TargetForm_IsEndorsedTitle = "Recommand\xe9";
var TargetForm_Name = "Titre";
var TargetForm_NameError = "Veuillez indiquer un titre.";
var TargetForm_NamePrompt = "Par exemple\xa0: Directeur commercial";
var TargetForm_RolePlanCreationNotice = "La cr\xe9ation d’un plan d’\xe9volution de poste cr\xe9era un poste pour votre organisation.";
var TargetForm_SelectVisibility = "S\xe9lectionner la visibilit\xe9";
var TargetForm_SetPrimaryPlan = "D\xe9finir un plan principal";
var TargetForm_Visibility = "Visibilit\xe9";
var TargetForm_VisibilityBoostToGroup = "Booster dans ces groupes";
var TargetForm_VisibilityBoostToGroupTooltip = "Permet de booster ce plan dans les r\xe9sultats de recherche globaux des membres du groupe.";
var TargetForm_VisibilityLimitToGroup = "Restreindre l’acc\xe8s aux groupes suivants";
var TargetFormCtrl_TargetGroupsToolTip = "Ces groupes pourront retrouver plus facilement ce plan";
var TargetResources_AddResources = "Ajouter des ressources";
var TargetResources_CreateADirectory = "Cr\xe9er un r\xe9pertoire";
var TargetResources_CreateAResourceFormat = "Cr\xe9er un \xe9l\xe9ment dans {{targetResourceType}}";
var TargetResources_CreateATarget = "Cr\xe9er un plan";
var TargetResources_DirectoryPlural = "R\xe9pertoires";
var TargetResources_Group = "Groupe";
var TargetResources_GroupPlural = "Groupes";
var TargetResources_InputPlural = "Contenu";
var TargetResources_NoDirectorysSelectedYet = "Aucun r\xe9pertoire n’a encore \xe9t\xe9 s\xe9lectionn\xe9.";
var TargetResources_NoGroupsSelectedYet = "Aucun groupe s\xe9lectionn\xe9 pour l’instant.";
var TargetResources_NoTargetsSelectedYet = "Aucun plan s\xe9lectionn\xe9 pour l’instant.";
var TargetResources_PathwayPlural = "Parcours";
var TargetResources_ProviderPlural = "Fournisseurs";
var TargetResources_TagPlural = "Comp\xe9tences";
var TargetResources_Target = "Plan";
var TargetResources_TargetAndDirectoryPlural = "Plans et r\xe9pertoires";
var TargetResources_TargetOrDirectory = "Plan ou r\xe9pertoire";
var TargetResources_TargetPlural = "Plans";
var TargetResources_UserPlural = "Personnes";
var TargetResourcesForm_Filters_Catalog = "Catalogue";
var TargetResourcesForm_Filters_PlansAndPathways = "Plans et parcours";
var TargetResourcesForm_Filters_Resources = "Ressources";
var TargetResourcesForm_InputHelp = "Rechercher des \xe9l\xe9ments de contenu sp\xe9cifiques";
var TargetResourcesForm_NoResults = "Comp\xe9tence introuvable. L’ajouter quand m\xeame\xa0?";
var TargetResourcesForm_NoResultsFound = "Aucun r\xe9sultat trouv\xe9.";
var TargetResourcesForm_ResourceAuthors = "Par {{authors}}";
var TargetResourcesForm_SearchMixedPlaceholder = "Rechercher dans le catalogue, les comp\xe9tences, les groupes, les personnes et les fournisseurs";
var TargetResourcesForm_SearchPlaceHolder = "Effectuez une recherche de {{targetResourceType}}";
var TargetResourcesForm_Selected = "S\xe9lection";
var TargetResourcesForm_Suggestions = "Suggestions";
var TargetResourcesForm_Title = "Ajouter sous {{targetResourceType}}";
var Targets_MoveConfirmationMessage = "Ceci aura pour effet de d\xe9placer d\xe9finitivement le plan du catalogue de l’organisation au catalogue global.";
var Targets_MoveSuccessMessage = "Le plan a bien \xe9t\xe9 d\xe9plac\xe9.";
var TargetsCtrl_BulkChangeVisibility = "Changer la visibilit\xe9 de 1 page";
var TargetsCtrl_BulkChangeVisibilityPlural = "Changer la visibilit\xe9 de {{count}}\xa0r\xe9pertoires";
var TargetsCtrl_DeletePluralPrompt = "Voulez-vous vraiment supprimer {{ count }} r\xe9pertoires\xa0?";
var TargetsCtrl_DeletePrompt = "Voulez-vous vraiment supprimer ce r\xe9pertoire\xa0?";
var TargetsSvc_AddAuthorError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’ajout d’un auteur.";
var TargetsSvc_AddError = "Un probl\xe8me est survenu lors de l’ajout du {{targetType}}.";
var TargetsSvc_AddResourceError = "D\xe9sol\xe9 ! Il y a eu un probl\xe8me pour ajouter {{targetType}}.";
var TargetsSvc_AddSectionError = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de l’ajout de la section.";
var TargetsSvc_AddSuccess = "Le {{targetType}} a bien \xe9t\xe9 ajout\xe9\xa0!";
var TargetsSvc_CloneError = "Un probl\xe8me est survenu lors du clonage du {{targetType}}.";
var TargetsSvc_CloneSuccess = "Le {{targetType}} a bien \xe9t\xe9 ajout\xe9\xa0!";
var TargetsSvc_DeleteAuthorError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la suppression d’un auteur.";
var TargetsSvc_DeleteError = "D\xe9sol\xe9\xa0! Impossible de supprimer l’\xe9l\xe9ment {{targetType}}.";
var TargetsSvc_DeleteResourceError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la suppression du {{targetType}}.";
var TargetsSvc_DeleteSuccess = "Le {{targetType}} \xab\xa0{{targetTitle}}\xa0\xbb a bien \xe9t\xe9 supprim\xe9\xa0!";
var TargetsSvc_DetailsError = "D\xe9sol\xe9\xa0! Impossible de charger le contenu. Rechargez la page pour r\xe9essayer.";
var TargetsSvc_Error = "D\xe9sol\xe9 ! Il y a eu un probl\xe8me pour r\xe9cup\xe9rer la correspondance {{targetTypePlural}}.";
var TargetsSvc_FeaturedError = "D\xe9sol\xe9s ! Un probl\xe8me est survenu lors de l’enregistrement des modifications.";
var TargetsSvc_FollowError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors du suivi du plan.";
var TargetsSvc_GetUserError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration des utilisateurs.";
var TargetsSvc_MakeFeaturedNotification = "L’\xe9l\xe9ment a bien \xe9t\xe9 ajout\xe9 sur la page \xc0 la une.";
var TargetsSvc_RemoveFeaturedNotification = "L’\xe9l\xe9ment est supprim\xe9 de la page \xc0 la une.";
var TargetsSvc_ReorderResourceError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors du d\xe9placement de l’\xe9l\xe9ment.";
var TargetsSvc_RetrieveError = "Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration du contenu.";
var TargetsSvc_SetNotVisibleSuccess = "Ce {{targetType}} n’est plus visible pour votre organisation.";
var TargetsSvc_SetTargetNameError = "D\xe9sol\xe9, un plan portant ce nom existe d\xe9j\xe0. Veuillez choisir un autre nom.";
var TargetsSvc_SetVisibleSuccess = "Ce {{targetType}} est maintenant visible pour votre organisation.";
var TargetsSvc_SuggestionError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration des suggestions.";
var TargetsSvc_TargetLevelError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la d\xe9finition du niveau cible.";
var TargetsSvc_TypeBrowse = "Parcourir";
var TargetsSvc_TypeBrowse_Specific = "Parcourir";
var TargetsSvc_TypeDirectory = "R\xe9pertoire";
var TargetsSvc_TypeDirectory_Specific = "R\xe9pertoire";
var TargetsSvc_TypeDirectorys = "R\xe9pertoires";
var TargetsSvc_TypeDirectorys_Specific = "R\xe9pertoires";
var TargetsSvc_TypeFeatured_Specific = "Plan \xe0 la une";
var TargetsSvc_TypeJobRole = "Plan";
var TargetsSvc_TypeJobRole_Specific = "Plan de comp\xe9tences";
var TargetsSvc_TypeJobRoles = "Plans";
var TargetsSvc_TypeJobRoles_Specific = "Plans de comp\xe9tences";
var TargetsSvc_TypeRole = "Poste";
var TargetsSvc_TypeRole_Specific = "Plan d’\xe9volution de poste";
var TargetsSvc_TypeRoles = "Plan de poste";
var TargetsSvc_TypeRoles_Specific = "Plan de poste";
var TargetsSvc_TypeSkillPlan = "Plan";
var TargetsSvc_TypeSkillPlan_Specific = "Plan de comp\xe9tences";
var TargetsSvc_TypeSkillPlans = "Plans";
var TargetsSvc_TypeSkillPlans_Specific = "Plans de comp\xe9tences";
var TargetsSvc_TypeTarget = "Plan";
var TargetsSvc_TypeTarget_Specific = "Plan de comp\xe9tence";
var TargetsSvc_TypeTargets = "Plans";
var TargetsSvc_TypeTargets_Specific = "Plans de comp\xe9tences";
var TargetsSvc_UnfollowError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’annulation du suivi du plan.";
var TargetsSvc_UpdateAuthorsError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la mise \xe0 jour des collaborateurs.";
var TargetsSvc_UpdateError = "D\xe9sol\xe9 ! Il y a eu un probl\xe8me lors de la mise \xe0 jour du {{targetType}}.";
var TargetsSvc_UpdateSuccess = "Le {{targetType}} a bien \xe9t\xe9 mis \xe0 jour\xa0!";
var TargetsSvc_UpdateVisibilityError = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de la mise \xe0 jour de la visibilit\xe9.";
var TargetsSvc_UsersTitle = "Personnes abonn\xe9es \xe0 cet \xe9l\xe9ment";
var TaskFormCtrl_Add = "Ajouter une t\xe2che";
var TaskFormCtrl_AddImage = "Ajouter une image";
var TaskFormCtrl_AddToCatalogFormat = "Ajoutez cette t\xe2che au catalogue {{orgName}}";
var TaskFormCtrl_Description = "Description";
var TaskFormCtrl_Edit = "Modifier la t\xe2che";
var TaskFormCtrl_ImagePreviewAltText = "Aper\xe7u de l’image du contenu";
var TaskFormCtrl_Save = "Enregistrer la t\xe2che";
var TaskFormCtrl_Site = "URL de la t\xe2che";
var TaskFormCtrl_Title = "Titre";
var TaskFormCtrl_TitleError = "Le titre de la t\xe2che doit \xeatre renseign\xe9.";
var TaskFormCtrl_Url = "URL de la t\xe2che (indiquez http:// ou https://)";
var TaskFormCtrl_ValidUrl = "Veuillez utiliser une URL valide et compl\xe8te.";
var TaskFormCtrl_WhatDidYouLearnLong = "Qu’avez-vous appris \xe0 l’issue de cette t\xe2che\xa0?";
var TaskFormCtrl_WhatDidYouLearnShort = "Qu’avez-vous appris ?";
var Team_AllReports = "Tous les subordonn\xe9s";
var Team_AllTeamMembers = "Tous les membres de l’\xe9quipe";
var Team_AssignmentEmailBodyDueSoon = "The assignment {{assignmentName}} is due on {{dueDate}}. Please log in to Degreed and complete {{assignmentName}} by the due date. {{assignmentLink}}";
var Team_AssignmentEmailBodyOverdue = "The assignment {{assignmentName}} was due on {{dueDate}} and is now overdue. Please log in to Degreed and complete {{assignmentName}} as soon as possible. {{assignmentLink}}";
var Team_AssignmentLink = "Assignment Link";
var Team_AssignmentName = "Assignment Name";
var Team_AssignmentNameDueSoon = "{{assignmentName}} is due soon";
var Team_AssignmentNameOverdue = "{{assignmentName}} is overdue";
var Team_AssignmentReminder = "Assignment Reminder";
var Team_AssignmentReminders = "Assignment Reminders";
var Team_Assignments = "Formations assign\xe9es";
var Team_AssignmentsDueSoonDesc = "Formations assign\xe9es d’\xe9quipe, non termin\xe9es, dont la date limite approche";
var Team_AssignmentsIncompleteDesc = "Ensemble des formations assign\xe9es non termin\xe9es";
var Team_AssignmentsOverdueDesc = "Formations assign\xe9es d’\xe9quipe, non termin\xe9es, dont la date limite est d\xe9pass\xe9e";
var Team_Chart_Disclaimer = "\xa9 Degreed.com. Tous droits r\xe9serv\xe9s. G\xe9n\xe9r\xe9 par Degreed.";
var Team_Chart_FullScreenText = "Activer le mode \xab\xa0Plein \xe9cran\xa0\xbb";
var Team_CompletionDetails = "D\xe9tails des \xe9l\xe9ments termin\xe9s";
var Team_ContactAssignor = "Contacter le responsable de l’assignation";
var Team_CountMandatory = "{{totalMandatory}} r\xe9glementaires";
var Team_CountMandatorySingular = "{{totalMandatory}} r\xe9glementaire";
var Team_CountRequired = "{{totalRequired}} obligatoires";
var Team_CountRequiredSingular = "{{totalRequired}} obligatoire";
var Team_CustomEmailMessage = "Custom Email Message";
var Team_Customizable = "Customizable";
var Team_DirectReportsOnly = "Subordonn\xe9s directs seulement";
var Team_DismissAssignment = "Ignorer la formation assign\xe9e";
var Team_DismissAssignmentDesc = "Ignorer {{assignmentName}} pour {{userName}} supprimera la formation assign\xe9e uniquement dans la vue manager. Elle restera visible pour les autres managers, dans les rapports et dans la liste des formations assign\xe9es \xe0 {{userName}}. Cette action est irr\xe9versible.";
var Team_ErrorLoadingManagers = "Un probl\xe8me est survenu lors du chargement de la liste de managers.";
var Team_FilterbySkillsFilter_Title = "Filtrer par comp\xe9tence";
var Team_FocusFilterDisabledTooltip = "Vous n’avez pas encore s\xe9lectionn\xe9 de comp\xe9tences prioritaires pour l’\xe9quipe. Vous pouvez s\xe9lectionner ces comp\xe9tences sous l’onglet Comp\xe9tences de l’\xe9quipe.";
var Team_FocusFilterNoResultsTooltip = "Vos r\xe9sultats de recherche n’indiquent aucune comp\xe9tence prioritaire pour l’\xe9quipe";
var Team_FocusLabel = "Uniquement les comp\xe9tences prioritaires pour l’\xe9quipe";
var Team_FocusSkills_Add = "Ajouter aux comp\xe9tences prioritaires pour l’\xe9quipe";
var Team_FocusSkills_AddFormat = "Ajouter {{ title }} aux comp\xe9tences prioritaires pour l’\xe9quipe";
var Team_FocusSkills_Remove = "Supprimer des comp\xe9tences prioritaires pour l’\xe9quipe";
var Team_FocusSkills_RemoveFormat = "Supprimer {{ title }} des comp\xe9tences prioritaires pour l’\xe9quipe";
var Team_Group_Shared_And_Private_Message = "Les \xe9l\xe9ments termin\xe9s par les apprenants priv\xe9s ou anonymes ne sont pas inclus dans le pourcentage de compl\xe9tion global.";
var Team_Insights_ActiveLearnerTitle = "Apprenants les plus actifs";
var Team_Insights_ActiveLearnerTooltip = "Les 10\xa0membres d’\xe9quipe qui ont termin\xe9 le plus de contenus au cours de cette p\xe9riode.";
var Team_Insights_AssignedLearnings_Empty_Message = "Aucun \xe9l\xe9ment n’a \xe9t\xe9 assign\xe9.";
var Team_Insights_AssignedLearningsTitle = "Formations assign\xe9es";
var Team_Insights_AverageCompletions_Label = "Moyenne des validations";
var Team_Insights_AveragePoints_Label = "Moyenne des points gagn\xe9s";
var Team_Insights_AveragePoints_Tooltip = "Moyenne des points gagn\xe9s par chaque membre de l’\xe9quipe au cours de cette p\xe9riode";
var Team_Insights_AveragePointsEarned_Label = "Moyenne des points gagn\xe9s";
var Team_Insights_AvgCompletions_Label = "Moyenne des \xe9l\xe9ments termin\xe9s";
var Team_Insights_AvgCompletions_Tooltip = "Moyenne des contenus termin\xe9s par chaque membre de l’\xe9quipe durant la p\xe9riode d\xe9finie.";
var Team_Insights_AvgPointsEarned_Label = "Moyenne des points gagn\xe9s";
var Team_Insights_AvgPointsEarned_Tooltip = "Moyenne des points gagn\xe9s par chaque membre de l’\xe9quipe durant la p\xe9riode d\xe9finie.";
var Team_Insights_PopularSkillsTitle = "Comp\xe9tences populaires";
var Team_Insights_PopularSkillsTooltip = "Les 10\xa0premi\xe8res comp\xe9tences, d’apr\xe8s le nombre total d’\xe9l\xe9ments de contenu termin\xe9s par votre \xe9quipe, et associ\xe9s \xe0 chaque comp\xe9tence.";
var Team_Insights_Range_Last30Days = "au cours des 30\xa0derniers jours";
var Team_Insights_TotalCompletions_Label = "Total des \xe9l\xe9ments termin\xe9s";
var Team_Insights_TotalCompletions_Tooltip = "Inclut tout contenu marqu\xe9 comme termin\xe9 durant la p\xe9riode d\xe9finie.";
var Team_Insights_TotalPoints_Label = "Total des points";
var Team_Insights_TotalPoints_Tooltip = "Inclut tout contenu marqu\xe9 comme termin\xe9 durant la p\xe9riode d\xe9finie.";
var Team_Insights_View_Assignment_Aria = "Afficher {{ assignmentName }}";
var Team_Insights_ViewAssignment = "Afficher {{ assignmentName }}";
var Team_InsightSkills_NoSkillRating = "Aucune \xe9valuation de la comp\xe9tence";
var Team_JobRelatedSkills = "Comp\xe9tences professionnelles";
var Team_LearnerName = "Learner Name";
var Team_LearningInsights = "Statistiques d’apprentissage";
var Team_ManagerName = "Manager Name";
var Team_MSTeamsNotification = "Also sends a Microsoft Teams notification, if enabled";
var Team_MyTeam = "Mon \xe9quipe";
var Team_NewAssignment = "New Assignment";
var Team_NoAssignments = "Votre \xe9quipe n’a aucune formation assign\xe9e";
var Team_NoAssignmentsDesc = "Une fois qu’une formation a \xe9t\xe9 assign\xe9e \xe0 votre \xe9quipe, elle appara\xeetra ici.";
var Team_NoRating = "Aucune \xe9valuation";
var Team_NotOnProfile = "Absente du profil";
var Team_OptOutAutoDescription = "Si vous passez en profil priv\xe9, vous ne pourrez plus vous abonner \xe0 Skill\xa0Coach ni vous en d\xe9sabonner. De plus, votre manager n’aura plus acc\xe8s \xe0 vos donn\xe9es de comp\xe9tences.";
var Team_OptOutMessage = "A quitt\xe9 Skill Coach";
var Team_OptOutTitleModal = "Notification Skill\xa0Coach";
var Team_PleaseCompleteDueSoon = "Please complete the assignment by {{dueDate}}.";
var Team_PleaseCompleteOverdue = "Please complete the assignment as soon as possible.";
var Team_RatedJobSkills = "Comp\xe9tences \xe9valu\xe9es";
var Team_RatedSkillsHeader_Tooltip = "Indique le nombre de comp\xe9tences \xe9valu\xe9es par l’utilisateur ou le manager par rapport au nombre total de comp\xe9tences de cet utilisateur.";
var Team_Rating_History_SetRating = "{{ name }} a d\xe9fini l’\xe9valuation sur {{ level }}";
var Team_Recipients = "Recipients";
var Team_RecommendationSent = "La recommandation a bien \xe9t\xe9 envoy\xe9e.";
var Team_RecommendSkills_ButtonText = "Recommander des comp\xe9tences";
var Team_ReminderSent = "Reminders sent successfully";
var Team_RemindersSent = "Reminders sent successfully";
var Team_ReminderTypes = "Reminder Types";
var Team_ScreenReader_Chart_Description_SkillSpiderChart = "Ce diagramme en toile d’araign\xe9e repr\xe9sente la relation entre les membres de l’\xe9quipe et leurs comp\xe9tences associ\xe9es.";
var Team_SelectRecipient = "Select at least one recipient";
var Team_SelectReminder = "Select at least one reminder type to see a preview.";
var Team_SelectReminderType = "Select at least one reminder type";
var Team_SendReminder = "Send Reminder";
var Team_SendReminders = "Envoyer un rappel";
var Team_SkillInsights = "Statistiques de comp\xe9tences";
var Team_SkillProfile = "Profil de comp\xe9tences";
var Team_Skills = "Comp\xe9tences de l’\xe9quipe";
var Team_Skills_AverageRatingAction = "L’\xe9valuation moyenne pour {{name}} est de {{count}}\xa0: {{action}}";
var Team_Skills_FocusSkill_MaxLimit = "Vous avez atteint la limite des comp\xe9tences prioritaires pour l’\xe9quipe";
var Team_Skills_FocusSkillAction = "{{name}} est une comp\xe9tence prioritaire sur {{count}}\xa0profils\xa0: {{action}}";
var Team_Skills_FocusSkillAction_Singular = "{{name}} est une comp\xe9tence prioritaire sur un profil\xa0: {{action}}";
var Team_Skills_OnProfile = "Mentions sur le profil";
var Team_Skills_OnProfileAction = "{{name}} appara\xeet sur {{count}}\xa0profils\xa0: {{action}}";
var Team_Skills_OnProfileAction_Singular = "{{name}} appara\xeet sur un profil\xa0: {{action}}";
var Team_Skills_OpenRatingListModal = "Ouvrir la fen\xeatre modale affichant la liste des \xe9valuations par les membres de l’\xe9quipe";
var Team_Skills_OptInToggle_MoM_Off = "Si vous acceptez de rejoindre Skill\xa0Coach, votre manager aura acc\xe8s \xe0 vos donn\xe9es pour vous aider \xe0 d\xe9velopper vos comp\xe9tences.";
var Team_Skills_OptInToggle_MoM_On = "Si vous acceptez de rejoindre Skill\xa0Coach, votre manager et ses sup\xe9rieurs auront acc\xe8s \xe0 vos donn\xe9es pour vous aider \xe0 d\xe9velopper vos comp\xe9tences.";
var Team_Skills_RatingCount = "Nombre d’\xe9valuations";
var Team_Skills_RatingCountAction = "Le nombre d’\xe9valuations pour {{name}} est de {{count}}\xa0: {{action}}";
var Team_Skills_RemoveFocusSkill_Success = "Cette comp\xe9tence a \xe9t\xe9 supprim\xe9e de votre s\xe9lection";
var Team_Skills_SetFocusSkill_Failure = "Cette comp\xe9tence n’a pas \xe9t\xe9 ajout\xe9e";
var Team_Skills_SetFocusSkill_Success = "Cette comp\xe9tence a \xe9t\xe9 ajout\xe9e \xe0 votre s\xe9lection";
var Team_Skills_SkillChangePublished_NotificationContent = "Votre organisation a mis \xe0 jour une ou plusieurs comp\xe9tences, ce qui pourrait affecter vos \xe9valuations.\n{{ skillChangePublishedHtml }}";
var Team_Skills_VisibilityTooltip = "Visible par vous, votre manager et ses managers car vous avez accept\xe9 de rejoindre Skill\xa0Coach.";
var Team_Skills_VisibilityTooltip_NoMoManager = "Visible par vous et votre manager car vous avez accept\xe9 de rejoindre Skill\xa0Coach.";
var Team_SpiderChart_BottomText = "Seuls {{ numTeamMembers }}\xa0membres d’\xe9quipe peuvent \xeatre affich\xe9s sur ce graphique.";
var Team_SpiderChart_LegendTitle = "Membres de l’\xe9quipe";
var Team_SpiderChart_PointLabel = "Le niveau de {{user}} est \xe9valu\xe9 \xe0 {{level}} pour la comp\xe9tence {{skill}}";
var Team_SpiderChart_RadarTitle = "Radar de comp\xe9tences";
var Team_SubjectAssignmentNameDueSoon = "Subject: Reminder: {{assignmentName}} is due soon";
var Team_SubjectAssignmentNameOverdue = "Subject: Reminder: {{assignmentName}} is overdue";
var Team_TeamFocusSkillTooltip = "Dans la liste des comp\xe9tences de votre \xe9quipe, choisissez celles qui rev\xeatent la plus grande importance pour vous. Vous pouvez s\xe9lectionner jusqu’\xe0 15\xa0comp\xe9tences.";
var Team_TeamFormat = "\xc9quipe de {{owner}}";
var Team_TeamMembers = "Membres de l’\xe9quipe";
var Team_ThankYou = "Thank you";
var Team_UpdateManagerRatingSuccessMessage = "L’\xe9valuation du manager a \xe9t\xe9 d\xe9finie. Votre coll\xe8gue en sera inform\xe9.";
var Team_UpdatePeerRatingSuccessMessage = "L’\xe9valuation par un pair a \xe9t\xe9 d\xe9finie. Votre coll\xe8gue sera inform\xe9 d’une nouvelle \xe9valuation de la comp\xe9tence.";
var Team_UpdateSkillTargetSuccessMessage = "Vous avez d\xe9fini la cible de la comp\xe9tence. {{requester}} va recevoir une notification pour l’en aviser.";
var Team_ViewReports = "View Reports";
var Team_ViewSkillsProfile = "Afficher le profil de comp\xe9tences";
var Team_WelcomeBanner_Description = "Skill\xa0Coach vous permet d’analyser les comp\xe9tences de chaque membre de votre \xe9quipe et d’encourager leur d\xe9veloppement. Nous vous conseillons de faire r\xe9guli\xe8rement le point avec eux sur leur mont\xe9e en comp\xe9tences et leur progression.";
var Team_WelcomeBanner_Title = "G\xe9rez et encouragez le d\xe9veloppement des comp\xe9tences de votre \xe9quipe";
var TeamInsights_SpiderChart_BottomText = "Seuls 5\xa0membres de l’\xe9quipe peuvent \xeatre affich\xe9s sur ce graphique";
var TeamInsights_SpiderChart_LegendTitle = "Membres de l’\xe9quipe";
var TeamInsights_SpiderChart_RadarTitle = "Radar de comp\xe9tences";
var TipSvc_OnboardError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’acc\xe8s \xe0 votre historique d’accueil.";
var TipSvc_OnboardResetSuccess = "Le processus d’int\xe9gration a bien \xe9t\xe9 r\xe9initialis\xe9";
var TipSvc_SavedItemsModal = "Les \xe9l\xe9ments que vous enregistrez s’affichent dans l’onglet Contenus enregistr\xe9s de votre profil. Vous pouvez \xe9galement y acc\xe9der \xe0 partir du lien Contenus enregistr\xe9s pr\xe9sent sur votre page d’accueil.";
var TipSvc_SavedItemsModalHome = "Les \xe9l\xe9ments enregistr\xe9s pour plus tard se trouvent dans la section \xab\xa0\xc9l\xe9ments enregistr\xe9s\xa0\xbb de la page d’accueil.";
var TipSvc_ViewSavedItems = "Afficher les \xe9l\xe9ments enregistr\xe9s";
var TopCompletionsChart_CatalogTypeAllProviders = "Tous les fournisseurs";
var TopCompletionsChart_CatalogTypeCatalog = "\xc9l\xe9ments de contenu";
var TopCompletionsChart_CatalogTypeExternalCatalogProviders = "Fournisseurs du catalogue externe";
var TopCompletionsChart_CatalogTypeInternalCatalogProviders = "Fournisseurs du catalogue interne";
var TopCompletionsChart_CatalogTypeLearner = "Apprenants";
var TopCompletionsChart_CompletionsColumn = "\xc9l\xe9ments termin\xe9s";
var TopCompletionsChart_NameColumn = "Nom";
var TopCompletionsChart_NameFormat = "Top {{count}}\xa0des \xe9l\xe9ments termin\xe9s";
var TopCompletionsChart_NoResults = "Aucun r\xe9sultat";
var TrackableLinkCtrl_AutoEnroll = "Lien tra\xe7able";
var TrackableLinkCtrl_CopiedLink = "Copi\xe9 dans le presse-papier";
var TrackableLinkCtrl_CopyLink = "Copier le lien";
var TrackableLinkCtrl_CopyLinkAgain = "Copier \xe0 nouveau";
var TrackableLinkCtrl_DeleteLinkModalBodyText = "Souhaitez-vous vraiment supprimer le lien tra\xe7able <strong>{{linkName}}</strong>\xa0?";
var TrackableLinkCtrl_DeleteLinkModalHeader = "Souhaitez-vous vraiment supprimer le lien tra\xe7able\xa0?";
var TrackableLinkCtrl_EditModalTitle = "Modifier le lien tra\xe7able";
var TrackableLinkCtrl_FormTitle = "O\xf9 sera utilis\xe9 ce lien\xa0?";
var TrackableLinkCtrl_FormTitlePlaceholder = "Exemple\xa0: E-mail de rappel, E-mail d’invitation du groupe de janvier";
var TrackableLinkCtrl_LinkDescription = "Utilisez ces liens pour promouvoir cet \xe9l\xe9ment au sein de votre organisation. D\xe9couvrez qui a cliqu\xe9 et s’est abonn\xe9 via ce lien dans la {{aTagStart}}section Liens tra\xe7ables{{aTagEnd}} des Statistiques.";
var TrackableLinkCtrl_ModalTitle = "Cr\xe9er un lien tra\xe7able";
var TrackableLinkCtrl_NewLink = "Nouveau lien tra\xe7able";
var TrackableLinkCtrl_StartTracking = "Commencer le suivi";
var TrackableLinkCtrl_TableHeaderClicks = "Clics";
var TrackableLinkCtrl_TableHeaderCreator = "Cr\xe9ateur";
var TrackableLinkCtrl_TableHeaderDate = "Date de cr\xe9ation";
var TrackableLinkCtrl_TableHeaderEnrolls = "Abonn\xe9s";
var TrackableLinkCtrl_TableHeaderLink = "Nom du lien";
var TrackableLinkCtrl_Title = "Liens tra\xe7ables";
var TrackableLinkCtrl_TitleCreated = "Liens tra\xe7ables cr\xe9\xe9s";
var unsubscribeTemplate_ChangeSettings = "Modifier les param\xe8tres de messagerie";
var Uploader_Canceled = "T\xe9l\xe9chargement annul\xe9";
var Uploader_Completed = "T\xe9l\xe9chargement termin\xe9";
var Uploader_DefaultLimitNotice_Size = "La taille des fichiers peut aller jusqu’\xe0 {{size}}\xa0Mo.";
var Uploader_DefaultLimitNotice_Type = "Les fichiers peuvent \xeatre au format {{types}}.";
var Uploader_DefaultLimitNotice_TypeAndSize = "Formats accept\xe9s\xa0: {{types}} ({{size}} Mo max.)";
var Uploader_FileTypeError = "Vous pouvez uniquement charger des fichiers de type {{filePattern}}.";
var Uploader_SizeLimitMet = "Le fichier est trop grand";
var Uploader_UnknownError = "Une erreur inconnue est survenue lors du t\xe9l\xe9chargement";
var User_Account = "Compte";
var User_AdditionalContentLanguages = "Autres langues pour le contenu";
var User_BioLabel = "Biographie";
var User_CategoryExample = "par exemple : leadership, comptabilit\xe9, d\xe9veloppement Web, politique, communication";
var User_CategoryExplanation = "Les rubriques vous permettent de d\xe9couvrir et de classifier les apprentissages.";
var User_CategoryQuestion = "Que souhaitez-vous apprendre ?";
var User_ChangePassword = "Modifier le mot de passe";
var User_CharactersRemaining = "Caract\xe8res restants";
var User_Communications = "Communications";
var User_ContentLanguage = "Langue du contenu";
var User_DailyDigestA11yHelpText = "Lorsque la case \xab\xa0Les tendances du jour\xa0\xbb est coch\xe9e, le contenu est mis \xe0 jour ci-dessous.";
var User_DeleteProfile = "Supprimer le profil";
var User_DisplayLanguage = "Langue d’affichage";
var User_Email = "E-mail";
var User_EmailCommunicationsDesc = "Envoyez-moi un e-mail pour chaque \xe9v\xe8nement suivant d\xe8s qu’il se produit.";
var User_EmailNotificationsDesc = "Envoyez-moi un e-mail pour chaque \xe9v\xe8nement suivant d\xe8s qu’il se produit.";
var User_EmailNotificationsLabel = "Notifications par e-mail";
var User_EmailUpdatesDesc = "Restez \xe0 jour avec ces e-mails informatifs.";
var User_EmailUpdatesLabel = "Mises \xe0 jour par e-mail";
var User_Extensions = "Bouton Degreed";
var User_Family = "Comptes familiaux";
var User_FamilyAccountAdd = "Cr\xe9er un compte familial";
var User_FamilyAccountCreateError = "D\xe9sol\xe9s\xa0! Un probl\xe8me est survenu lors de la cr\xe9ation du compte.";
var User_FamilyAccountCreateSuccess = "Termin\xe9\xa0! Votre nouveau compte familial a bien \xe9t\xe9 cr\xe9\xe9.";
var User_FamilyAccountGetError = "D\xe9sol\xe9s\xa0! Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration des informations du compte.";
var User_FamilyAccountInstructions = '<p>Ce service ne collecte aucune information personnelle concernant les enfants \xe2g\xe9s de moins de 13\xa0ans, conform\xe9ment au \xab\xa0Children’s Online Privacy Protection Act\xa0\xbb. Vous pouvez consulter l’activit\xe9 de connexion de votre enfant ou demander la suppression de son compte en envoyant votre demande par e-mail \xe0 l’adresse <a class="link" href="mailto:support@degreed.com">support@degreed.com</a>. Le service comprend des liens vers des sites exploit\xe9s par des tiers. La banque fournit uniquement ces liens \xe0 titre informatif et ne peut en aucun cas \xeatre tenue responsable du contenu de ces sites, de la confidentialit\xe9 ou des autres pratiques adopt\xe9es par les tiers qui les exploitent. La responsabilit\xe9 de v\xe9rifier que le contenu de tout site tiers est appropri\xe9 pour votre enfant vous incombe enti\xe8rement.</p><p>En utilisant ce service, vous acceptez ces <a class="link" href="/about/terms">conditions</a> en votre nom et au nom de vos enfants. Veuillez consulter notre <a class="link" href="/about/privacy">D\xe9claration de confidentialit\xe9</a>.</p>';
var User_FamilyAccountsHeader = "Comptes de votre famille";
var User_FamilyCreateAccountFormat = "Cr\xe9er un compte \xab\xa0{{programName}}\xa0\xbb";
var User_FamilyEmptyStateHeader = "Apprenez ensemble";
var User_FamilyLegendFormat = "Compte du membre {{ memberIndex }}";
var User_FamilyPasswordLabel = "Mot de passe";
var User_FamilyProgramLabel = "Programme";
var User_FamilyUsernameLabelFormat = "Nom d’utilisateur du membre {{ memberIndex }}";
var User_FirstNameLabel = "Pr\xe9nom";
var User_Integrations = "Int\xe9grations";
var User_LanguageExplanation = "Degreed vous sugg\xe9rera des contenus dans cette langue s’ils sont disponibles. Les modifications prendront effet sous 24\xa0heures.";
var User_LastNameLabel = "Nom";
var User_LocationLabel = "Lieu";
var User_ManagedProfileMessageFormat = "Les param\xe8tres de votre profil sont g\xe9r\xe9s par {0}";
var User_Notifications = "Notifications";
var User_NotificationsA11yHelpText = "Lorsque la case \xab\xa0Notifications par e-mail\xa0\xbb est coch\xe9e, le contenu est mis \xe0 jour ci-dessous.";
var User_PageTitle = "Param\xe8tres";
var User_Personal = "Personnel";
var User_PreferenceSurveysDescription = "Participez \xe0 des sondages et saisissez l’occasion d’am\xe9liorer votre exp\xe9rience.";
var User_PreferenceSurveysTitle = "Participer aux enqu\xeates Degreed";
var User_PreferenceTipsDescription = "Affichez des invites dans l’application vous expliquant comment bien utiliser Degreed.";
var User_PreferenceTipsTitle = "Afficher les conseils et astuces";
var User_PreferredContent = "Langue pr\xe9f\xe9r\xe9e pour le contenu";
var User_Profile = "Profil";
var User_ProfileName = "Nom du profil";
var User_ProfilePrivacyLabel = "Confidentialit\xe9 du profil";
var User_ProfileUrlExplanation = "Il s’agit de l’URL de votre profil (par exemple, {{domainName}}/profil/nomduprofil).";
var User_ResetOnboarding = "R\xe9initialiser le processus d’int\xe9gration";
var User_SaveSettings = "Enregistrer les param\xe8tres";
var User_SystemLanguage = "Langue d’affichage de Degreed";
var User_SystemLanguageExplanation = "Langues des boutons et messages dans Degreed. Ceci n’affecte pas la langue des \xe9l\xe9ments du contenu, y compris le contenu sugg\xe9r\xe9 par Degreed.";
var User_UpdatesA11yHelpText = "Lorsque la case \xab\xa0Mises \xe0 jour par e-mail\xa0\xbb est coch\xe9e, le contenu est mis \xe0 jour ci-dessous.";
var UserAssessmentSvc_AssessmentsError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l'acc\xe8s \xe0 vos tests d'\xe9valuation.";
var UserBookSvc_BookAccessError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’acc\xe8s \xe0 vos livres.";
var UserBookSvc_BookAddError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’ajout de ce livre.";
var UserBookSvc_BookUpdateError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la mise \xe0 jour de ce livre.";
var UserController_Achievements = "R\xe9ussites";
var UserController_AddEmailAddress = "Ajouter une adresse e-mail";
var UserController_AddingSecondEmail = "L’ajout d’une deuxi\xe8me adresse e-mail aide \xe0 prot\xe9ger votre compte et vos points.";
var UserController_AddPersonalEmail = "Ajouter une adresse e-mail personnelle";
var UserController_AddSkills = "Ajouter des comp\xe9tences";
var UserController_AddToCollectionDescription = "Cette collection permet de rassembler toutes vos formations, exp\xe9riences, r\xe9ussites, parcours et plans.";
var UserController_AddToCollectionOther = "Aucun(e) {{classifier}} dans cette collection";
var UserController_AddToCollectionSelf = "Ajouter des {{classifier}} \xe0 votre collection";
var UserController_BulkEdit = "Modifier en bloc";
var UserController_BulkEditSelectLabel = "S\xe9lectionner pour la modification en bloc";
var UserController_CaptureLearningFormat = "R\xe9pertoriez tout ce que vous apprenez (dans le cadre professionnel, de mani\xe8re informelle, sur le moment, etc.), et tirez parti de toutes vos formations.";
var UserController_CategoryFilter = "Filtre par cat\xe9gorie";
var UserController_Collection = "Collection";
var UserController_CollectionDescription = "Vous retrouverez ici l’historique de vos formations, exp\xe9riences, r\xe9ussites, parcours et plans.";
var UserController_ConnectedEmail = "Comptes e-mail associ\xe9s";
var UserController_ConsumerPrimaryEmailDesc = "C’est l’adresse e-mail qui sera utilis\xe9e pour les notifications par e-mail et la connexion.";
var UserController_Content = "Contenu";
var UserController_DashboardTitle = "Flux";
var UserController_DegreedButton = "Installez le bouton Degreed";
var UserController_DegreedGroups = "un environnement d’apprentissage collaboratif o\xf9 les employ\xe9s et les \xe9quipes s’inspirent, se d\xe9fient et s’aident mutuellement \xe0 avancer.";
var UserController_Delete = "Supprimer";
var UserController_DeleteProfile = "Souhaitez-vous r\xe9ellement supprimer votre profil Degreed ?";
var UserController_EditCategories = "Modifier les comp\xe9tences";
var UserController_EmailAddress = "Adresse e-mail";
var UserController_EmailAddressChangeInfo = "Pour confirmer les changements d’adresse e-mail, suivez les instructions envoy\xe9es \xe0 votre adresse e-mail principale.";
var UserController_EmailPreferences = "Pr\xe9f\xe9rences de messagerie";
var UserController_EmptyProfile = "Le profil est vide";
var UserController_EnterEmail = "Saisissez une adresse e-mail";
var UserController_FilterCollection = "Filtrer la collection";
var UserController_FindLearning = "Recherchez une formation";
var UserController_FollowersSubHeading = "Abonn\xe9s :";
var UserController_FollowersTitle = "Abonn\xe9s";
var UserController_FollowFormat = "Suivez les activit\xe9s d’apprentissage pour {{name}}";
var UserController_FollowingSubHeading = "Abonnements\xa0:";
var UserController_For = "pour";
var UserController_GoogleUsernamePlaceholder = "Identifiant Google+";
var UserController_GreetingFormat = "Bonjour, {0}";
var UserController_GroupsTitle = "Groupes";
var UserController_In = "dans";
var UserController_Insights = "Statistiques";
var UserController_InviteAll = "Inviter tout le monde";
var UserController_InviteFriends = "Inviter mes amis";
var UserController_ItemsSelected = "s\xe9lectionn\xe9";
var UserController_JoinGroups = "+ Rejoindre des groupes";
var UserController_LastName = "Nom";
var UserController_Loading = "Chargement...";
var UserController_ManagedProfileMessageFormat = "Les param\xe8tres de votre profil sont g\xe9r\xe9s par {0}";
var UserController_NameTaken = "D\xe9sol\xe9, ce nom existe d\xe9j\xe0.";
var UserController_NameTakenError = "D\xe9sol\xe9, ce nom existe d\xe9j\xe0.";
var UserController_NoFriends = "Vos amis ne s’affichent pas ?";
var UserController_NoLearningTracked = "ne suit aucun contenu de formation pour le moment.";
var UserController_NoPersonalEmail = "Oups, vous n’avez pas renseign\xe9 d’adresse e-mail personnelle";
var UserController_NoResults = "Aucun r\xe9sultat trouv\xe9";
var UserController_NoResultsFound = "Aucun r\xe9sultat trouv\xe9.";
var UserController_NoSkills = "n’a pas encore ajout\xe9 de comp\xe9tences ou de rubriques.";
var UserController_NothingCompleted = "n’a encore rien r\xe9alis\xe9.";
var UserController_NotificationEmailInfoFormat = "Les notifications par e-mail seront envoy\xe9es \xe0 votre adresse e-mail {{orgName}}";
var UserController_NotificationSettings = "Param\xe8tres de notification";
var UserController_Opportunities = "Opportunit\xe9s";
var UserController_Overview = "Vue d’ensemble";
var UserController_Pathways = "Parcours";
var UserController_PersonalEmail = "Adresse e-mail personnelle";
var UserController_PersonalEmailEnableOptions = "Les options suivantes seront activ\xe9es apr\xe8s avoir ajout\xe9 une adresse e-mail personnelle.";
var UserController_PersonalEmailError = "Votre adresse e-mail personnelle doit \xeatre diff\xe9rente de votre adresse e-mail professionnelle";
var UserController_PersonalEmailOptions = "Les options suivantes seront activ\xe9es apr\xe8s avoir ajout\xe9 une adresse e-mail personnelle.";
var UserController_PostAComment = "Publier un commentaire";
var UserController_PrimaryEmailDesc = "Il\xa0s’agit\xa0de\xa0votre\xa0adresse\xa0principale,\xa0qui\xa0sera\xa0utilis\xe9e\xa0pour\xa0vous\xa0envoyer\xa0des notifications\xa0par e-mail.";
var UserController_PrivateProfile = "Ce profil n’est pas public.";
var UserController_PrivateProfileExplanation = "Si vous pensez que vous devriez pouvoir le voir, essayez de vous connecter.";
var UserController_Profile = "Vue d’ensemble";
var UserController_Progression = "Progression";
var UserController_QueueTitle = "Mis de c\xf4t\xe9";
var UserController_RecommendationsTitle = "Contenus partag\xe9s";
var UserController_RequiredAssigned = "Requis et assign\xe9";
var UserController_RequiredAssignedCount = "Requis et assign\xe9 ({{count}})";
var UserController_RequiredLearningTitle = "Assign\xe9";
var UserController_Saved = "Contenus enregistr\xe9s";
var UserController_SaveSettingsErrorMessage = "Oups ! Il semble que l’adresse e-mail de ce profil est invalide. Veuillez r\xe9essayer.";
var UserController_ScoreYourEducation = "\xc9valuez votre \xe9ducation permanente gr\xe2ce \xe0 Degreed.";
var UserController_SecondaryEmailDesc = "C’est votre adresse de secours. Elle permet de prot\xe9ger votre compte et vos points.";
var UserController_SelectAll = "Tout s\xe9lectionner";
var UserController_SelectLoginEmail = "S\xe9lectionnez l’adresse e-mail avec laquelle vous connectez, que vous souhaitez utiliser pour recevoir les notifications par e-mail.";
var UserController_ShortQueueTitle = "Contenus enregistr\xe9s";
var UserController_ShowHowFarFormat = "Montrez-nous votre parcours";
var UserController_ShowLess = "Afficher moins";
var UserController_ShowMore = "Afficher plus";
var UserController_Skills = "Comp\xe9tences";
var UserController_StepFour = "\xc9tape 4\xa0:";
var UserController_StepOne = "\xc9tape 1\xa0:";
var UserController_StepThree = "\xc9tape 3\xa0:";
var UserController_StepTwo = "\xc9tape 2\xa0:";
var UserController_StopFollowingFormat = "Arr\xeater de suivre les activit\xe9s d’apprentissage de {{name}}";
var UserController_ThisUserPrivate = "Ce profil est priv\xe9";
var UserController_TodaysLearningFeedTitle = "Flux";
var UserController_TodaysLearningTitle = "Flux";
var UserController_TrackLearningAltTag = "Recherchez, suivez et \xe9valuez TOUT ce que vous apprenez";
var UserController_TryHere = "Essayez ici";
var UserController_TurnOnIntegration = "Activez votre premi\xe8re int\xe9gration";
var UserController_TwitterUsername = "Identifiant Twitter";
var UserController_Type = "Type";
var UserController_Unsubscribe = "Se d\xe9sinscrire";
var UserController_UnsubscribeWarning = "Si vous choisissez de vous d\xe9sabonner, <strong>tous</strong> les e-mails de Degreed ne vous seront pas disponibles (y compris ceux que votre entreprise peut demander \xe0 envoyer, les demandes de confirmation de compte et les instructions de r\xe9initialisation du mot de passe). Il est impossible d’annuler cette op\xe9ration sans contacter directement Degreed.";
var UserController_UnsubTitle = "D\xe9sinscription effectu\xe9e";
var UserController_UpdateAccount = "Mettez \xe0 jour votre compte";
var UserController_Verified = "Valid\xe9";
var UserController_Verify = "V\xe9rifier";
var UserController_VerifyOwnership = "Confirmez que vous \xeates le propri\xe9taire de cette adresse en r\xe9pondant \xe0 l’e-mail de v\xe9rification";
var UserCourseSvc_CourseError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’acc\xe8s \xe0 vos formations.";
var UserEmailAddress_VerificationSuccessful = "Your email has been verified!";
var UserEmailAddressesSvc_ErrorValidatingEmail = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la validation de l’adresse e-mail.";
var UserEpisodeSvc_EpisodeError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’acc\xe8s \xe0 vos \xe9pisodes.";
var UserEvaluationEndorsementCompleted_NotificationTitleFormat = "{{nameHtml}} a valid\xe9 l’approbation de votre revue de comp\xe9tence dans {{tag}}";
var UserEvaluationEndorsementRequested_NotificationTitleFormat = "{{nameHtml}} vous a demand\xe9 d’approuver sa revue de comp\xe9tence dans {{tag}}";
var UserEventSvc_EventError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’acc\xe8s \xe0 vos \xe9v\xe8nements.";
var UserGoalsSvc_GoalAccessError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’acc\xe8s \xe0 vos objectifs.";
var UserGoalsSvc_GoalExistsError = "Vous avez d\xe9j\xe0 d\xe9fini un objectif pour cet \xe9l\xe9ment.";
var UserGroupsSvc_ProblemAccessingGroup = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’acc\xe8s aux groupes.";
var UserInfoPartial_BioModalTitle = "Biographie de {{name}}";
var UserInfoPartial_ChangePrivacySettings = "cliquez ici pour modifier les param\xe8tres de confidentialit\xe9";
var UserInfoPartial_EditProfile = "Param\xe8tres";
var UserInfoPartial_FollowerCountFormat = "{{followerCount}}\xa0abonn\xe9(s)";
var UserInfoPartial_FollowFormat = "Suivre";
var UserInfoPartial_FollowingCountFormat = "{{followeesCount}}\xa0abonnement(s)";
var UserInfoPartial_FoundingScholar = "Chercheur fondateur";
var UserInfoPartial_StopFollowingFormat = "Cesser de suivre";
var UserInfoPartial_VisibleToMe = "Visible uniquement par moi";
var UserInfoPartial_VisibleToOrg = "Visible par l’organisation";
var UserInfoPartial_VisibleToPublic = "Visible publiquement";
var UserInfoPartial_VisibleToPublicAndOrg = "Visible par le public et l’organisation";
var UserInputProvidersSvc_ProfileProvidersError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’acc\xe8s \xe0 vos fournisseurs de profil.";
var UserInputProvidersSvc_ProviderLicensesError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’acc\xe8s \xe0 vos licences de prestataire.";
var UserInputsController_Praise1 = "Encore un effort !";
var UserInputsController_Praise2 = "Excellent !";
var UserInputsController_Praise3 = "Bon travail !";
var UserInputsController_Praise4 = "Tr\xe8s bon travail !";
var UserInputsController_Praise5 = "Impressionnant !";
var UserInputsController_Praise6 = "Nous sommes impressionn\xe9s !";
var UserInputsController_Praise7 = "Continuez comme \xe7a !";
var UserInputsController_Reward1AccomplishmentPluralFormat = "Vous avez ajout\xe9 {0} accomplissements \xe0 votre profil.";
var UserInputsController_Reward1AccomplishmentSingular = "Vous avez ajout\xe9 un accomplissement \xe0 votre profil.";
var UserInputsController_Reward1ArticlePluralFormat = "Vous avez ajout\xe9 {0} articles \xe0 votre profil.";
var UserInputsController_Reward1ArticleSingular = "Vous avez ajout\xe9 un article \xe0 votre profil.";
var UserInputsController_Reward1AssessmentPluralFormat = "Vous avez ajout\xe9 {0} tests d'\xe9valuation \xe0 votre profil.";
var UserInputsController_Reward1AssessmentSingular = "Vous avez ajout\xe9 un test d'\xe9valuation \xe0 votre profil.";
var UserInputsController_Reward1AwardPluralFormat = "Vous avez ajout\xe9 {0} r\xe9compenses \xe0 votre profil.";
var UserInputsController_Reward1AwardSingular = "Vous avez ajout\xe9 une r\xe9compense \xe0 votre profil.";
var UserInputsController_Reward1BadgePluralFormat = "Vous avez ajout\xe9 {0} badges \xe0 votre profil.";
var UserInputsController_Reward1BadgeSingular = "Vous avez ajout\xe9 un badge \xe0 votre profil.";
var UserInputsController_Reward1BookPluralFormat = "Vous avez ajout\xe9 {0} livres \xe0 votre profil.";
var UserInputsController_Reward1BookSingular = "Vous avez ajout\xe9 un livre \xe0 votre profil.";
var UserInputsController_Reward1CertificatePluralFormat = "Vous avez ajout\xe9 {0} certificats \xe0 votre profil.";
var UserInputsController_Reward1CertificateSingular = "Vous avez ajout\xe9 un certificat \xe0 votre profil.";
var UserInputsController_Reward1CoursePluralFormat = "Vous avez ajout\xe9 {0} formations \xe0 votre profil.";
var UserInputsController_Reward1CourseSingular = "Vous avez ajout\xe9 un cours \xe0 votre profil.";
var UserInputsController_Reward1DegreePluralFormat = "Vous avez ajout\xe9 {0} dipl\xf4mes \xe0 votre profil.";
var UserInputsController_Reward1DegreeSingular = "Vous avez ajout\xe9 un dipl\xf4me \xe0 votre profil.";
var UserInputsController_Reward1EpisodePluralFormat = "Vous avez ajout\xe9 {0} \xe9pisodes de podcast \xe0 votre profil.";
var UserInputsController_Reward1EpisodeSingular = "Vous avez ajout\xe9 un \xe9pisode de podcast \xe0 votre profil.";
var UserInputsController_Reward1EventPluralFormat = "Vous avez ajout\xe9 {0} \xe9v\xe8nements \xe0 votre profil.";
var UserInputsController_Reward1EventSingular = "Vous avez ajout\xe9 un \xe9v\xe8nement \xe0 votre profil.";
var UserInputsController_Reward1ItemPluralFormat = "Vous avez ajout\xe9 {0} \xe9l\xe9ments d’apprentissage \xe0 votre profil.";
var UserInputsController_Reward1ItemSingular = "Vous avez ajout\xe9 un \xe9l\xe9ment d’apprentissage \xe0 votre profil.";
var UserInputsController_Reward1PositionPluralFormat = "Vous avez ajout\xe9 {0} exp\xe9riences \xe0 votre profil.";
var UserInputsController_Reward1PositionSingular = "Vous avez ajout\xe9 une exp\xe9rience \xe0 votre profil.";
var UserInputsController_Reward1SkillPluralFormat = "Vous avez ajout\xe9 {0} comp\xe9tences \xe0 votre profil.";
var UserInputsController_Reward1SkillSingular = "Vous avez ajout\xe9 une comp\xe9tence \xe0 votre profil.";
var UserInputsController_Reward1VideoPluralFormat = "Vous avez ajout\xe9 {0} vid\xe9os \xe0 votre profil.";
var UserInputsController_Reward1VideoSingular = "Vous avez ajout\xe9 une vid\xe9o \xe0 votre profil.";
var UserInputsController_Reward2AccomplishmentPluralFormat = "Vous disposez donc de {0} accomplissements termin\xe9s.";
var UserInputsController_Reward2AccomplishmentSingular = "Vous disposez donc d’un accomplissement.";
var UserInputsController_Reward2ArticlePluralFormat = "Vous disposez donc de {0} articles termin\xe9s.";
var UserInputsController_Reward2ArticleSingular = "Vous disposez donc d’un article.";
var UserInputsController_Reward2AssessmentPluralFormat = "Vous disposez donc de {0} tests d'\xe9valuation termin\xe9s.";
var UserInputsController_Reward2AssessmentSingular = "Vous disposez donc d'un test d'\xe9valuation.";
var UserInputsController_Reward2AwardPluralFormat = "Vous disposez donc de {0} r\xe9compenses termin\xe9es.";
var UserInputsController_Reward2AwardSingular = "Vous disposez donc d’une r\xe9compense.";
var UserInputsController_Reward2BadgePluralFormat = "Vous disposez donc de {0} badges termin\xe9s.";
var UserInputsController_Reward2BadgeSingular = "Vous disposez donc d’un badge.";
var UserInputsController_Reward2BookPluralFormat = "Vous disposez donc de {0} livres termin\xe9s.";
var UserInputsController_Reward2BookSingular = "Vous disposez donc d’un livre.";
var UserInputsController_Reward2CertificatePluralFormat = "Vous disposez donc de {0} certificats termin\xe9s.";
var UserInputsController_Reward2CertificateSingular = "Vous disposez donc d’un certificat.";
var UserInputsController_Reward2CoursePluralFormat = "Vous disposez donc de {0} formations termin\xe9es.";
var UserInputsController_Reward2CourseSingular = "Vous avez termin\xe9 1\xa0cours.";
var UserInputsController_Reward2DegreePluralFormat = "Vous disposez donc de {0} dipl\xf4mes termin\xe9s.";
var UserInputsController_Reward2DegreeSingular = "Vous disposez donc d’un dipl\xf4me.";
var UserInputsController_Reward2EpisodePluralFormat = "Vous disposez donc de {0} \xe9pisodes de podcast termin\xe9s.";
var UserInputsController_Reward2EpisodeSingular = "Vous disposez donc d’un \xe9pisode de podcast.";
var UserInputsController_Reward2EventPluralFormat = "Vous disposez donc de {0} \xe9v\xe8nements termin\xe9s.";
var UserInputsController_Reward2EventSingular = "Vous disposez donc d’un \xe9v\xe8nement.";
var UserInputsController_Reward2ItemPluralFormat = "Vous disposez donc de {0} \xe9l\xe9ments d’apprentissage termin\xe9s.";
var UserInputsController_Reward2ItemSingular = "Vous disposez donc d’un \xe9l\xe9ment d’apprentissage.";
var UserInputsController_Reward2PositionPluralFormat = "Vous disposez donc de {0} exp\xe9riences termin\xe9es.";
var UserInputsController_Reward2PositionSingular = "Vous disposez donc d’une exp\xe9rience.";
var UserInputsController_Reward2SkillPluralFormat = "Vous disposez donc de {0} comp\xe9tences termin\xe9es.";
var UserInputsController_Reward2SkillSingular = "Vous disposez donc d’une comp\xe9tence.";
var UserInputsController_Reward2VideoPluralFormat = "Vous disposez donc de {0} vid\xe9os termin\xe9es.";
var UserInputsController_Reward2VideoSingular = "Vous disposez donc d’une vid\xe9o.";
var UserInputsSvc_AccessProfileError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’acc\xe8s aux \xe9l\xe9ments du profil.";
var UserInputsSvc_AddToProfileError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’ajout d’\xe9l\xe9ments \xe0 votre profil.";
var UserInputsSvc_DeleteFromProfileError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la suppression d’\xe9l\xe9ments de votre profil.";
var UserInputsSvc_SuccessfulAddNotifyFormat = "F\xe9licitations pour avoir compl\xe9t\xe9 ce {{input}}!";
var UserInputsSvc_UpdateProfileError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la mise \xe0 jour de votre profil.";
var UserInsightsSvc_ErrorLearningCounts = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la r\xe9cup\xe9ration des nombres d’apprentissages.";
var UserInsightsSvc_ErrorPersonalInfo = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’acc\xe8s aux informations du profil.";
var UserMediaSvc_MediaError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’acc\xe8s \xe0 vos m\xe9dias.";
var UserOrganizationSvc_NotificationError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’acc\xe8s aux informations de l’organisation.";
var UserOutcomeDegreeSvc_AddingCoursesError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’ajout des formations \xe0 votre profil.";
var UserOutcomeDegreeSvc_Associates = "Associ\xe9s";
var UserOutcomeDegreeSvc_Bachelors = "Licences";
var UserOutcomeDegreeSvc_Diploma = "Dipl\xf4mes";
var UserOutcomeDegreeSvc_Doctorate = "Doctorats";
var UserOutcomeDegreeSvc_Magister = "Ma\xeetrises";
var UserOutcomeDegreeSvc_Masters = "Masters";
var UserOutcomeDegreeSvc_PartialAssociates = "Associ\xe9s partiels";
var UserOutcomeDegreeSvc_PartialBachelors = "Licences partielles";
var UserOutcomeDegreeSvc_PartialDoctorate = "Doctorats partiels";
var UserOutcomeDegreeSvc_PartialMasters = "Masters partiels";
var UserOutcomeDegreeSvc_PreDiploma = "Pr\xe9-dipl\xf4mes";
var UserOutcomeSkillSvc_EightToTen = "de 8 \xe0 10\xa0ans";
var UserOutcomeSkillSvc_ElevenToFourteen = "de 11 \xe0 14\xa0ans";
var UserOutcomeSkillSvc_FifteenToTwenty = "de 15 \xe0\xa020\xa0ans";
var UserOutcomeSkillSvc_FiveToSeven = "de 5 \xe0 7\xa0ans";
var UserOutcomeSkillSvc_TwentyPlus = "Plus de 20\xa0ans";
var UserOutcomeSkillSvc_TwoToFour = "de 2 \xe0 4\xa0ans";
var UserOutcomeSkillSvc_ZeroToOne = "de 0 \xe0 1\xa0an";
var UserOutcomeSvc_AddingError = "D\xe9sol\xe9\xa0! Impossible d’enregistrer le formulaire.";
var UserOutcomeSvc_RemovingError = "D\xe9sol\xe9\xa0! Impossible de supprimer votre contenu.";
var UserOutcomeSvc_RetreivingError = "D\xe9sol\xe9\xa0! Impossible de r\xe9cup\xe9rer les d\xe9tails.";
var UserOutcomeSvc_UpdatingError = "D\xe9sol\xe9s ! Un probl\xe8me est survenu lors de l’enregistrement des modifications.";
var UserPositionSvc_ExperienceError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’acc\xe8s \xe0 votre exp\xe9rience.";
var UserPrivacyCtrl_Continue = "Continuer";
var UserPrivacyCtrl_Organization = "Organisation";
var UserPrivacyCtrl_PrivacyWarningHeader = "Avertissement de confidentialit\xe9";
var UserPrivacyCtrl_ToOrgProfileFormat = "Si vous d\xe9finissez votre profil comme \xe9tant visible dans votre organisation uniquement, les utilisateurs de {{OrgName}} auront acc\xe8s aux informations suivantes sur cette plateforme\xa0:<br/><br/><strong>Votre nom</strong>, <strong>votre collection en mati\xe8re de formations</strong> (membres de {{OrgNameSingular}}) et <strong>vos statistiques</strong> (y compris votre classement).<br/><br/>Les personnes qui ne sont pas membres de {{OrgNameSingular}} ne pourront pas vous suivre (c’est-\xe0-dire \xeatre inform\xe9es de vos activit\xe9s de formation).";
var UserPrivacyCtrl_ToOrgProfileFromAnonymousFormat = "Si vous d\xe9finissez votre profil comme \xe9tant visible dans votre organisation uniquement, les utilisateurs de {{OrgName}} auront acc\xe8s aux informations suivantes sur cette plateforme\xa0:<br/><br/><strong>Votre nom</strong>, <strong>votre collection en mati\xe8re de formations</strong> (membres de {{OrgName}}) et <strong>vos statistiques</strong> (y compris votre classement).<br/><br/>Les personnes qui ne sont pas membres de {{OrgName}} ne pourront pas vous suivre (c’est-\xe0-dire \xeatre inform\xe9es de vos activit\xe9s de formation), et vos informations seront visibles dans les rapports de l’organisation.";
var UserPrivacyCtrl_ToPrivateProfile = "Si vous d\xe9finissez votre profil comme \xe9tant priv\xe9, les informations suivantes ne seront plus visibles pour aucun des utilisateurs de cette plateforme\xa0: <br/><br/><strong>Votre nom</strong>, <strong>votre collection en mati\xe8re de formations</strong> et <strong>vos statistiques</strong> (y compris votre classement).<br/><br/>Les autres personnes ne pourront plus vous suivre (c’est-\xe0-dire \xeatre inform\xe9es de vos activit\xe9s de formation).";
var UserPrivacyCtrl_ToPrivateProfileInOrgFormat = "Si vous d\xe9finissez votre profil comme \xe9tant priv\xe9, les informations suivantes ne seront plus visibles pour le public ni pour les utilisateurs de {{OrgName}} sur cette plateforme\xa0:<br/><br/><strong>Votre nom</strong>, <strong>votre collection en mati\xe8re de formations</strong> (le contenu de {{OrgName}} ne sera plus visible pour les personnes qui ne sont pas membres de {{OrgNameSingular}}) et <strong>vos statistiques</strong> (y compris votre classement).<br/><br/>Les autres personnes ne pourront plus vous suivre (c’est-\xe0-dire \xeatre inform\xe9es de vos activit\xe9s de formation).";
var UserPrivacyCtrl_ToPrivateProfileInOrgFromAnonymousFormat = "Si vous d\xe9finissez votre profil comme \xe9tant priv\xe9, les informations suivantes ne seront plus visibles pour le public ni pour les utilisateurs de {{OrgName}} sur cette plateforme\xa0: <br/><br/><strong>Votre nom</strong>, <strong>votre collection en mati\xe8re de formations</strong> (le contenu de {{OrgName}} ne sera plus visible pour les personnes qui ne sont pas membres de {{OrgName}}) et <strong>vos statistiques</strong> (y compris votre classement).<br/><br/>Les autres personnes ne pourront plus vous suivre (c’est-\xe0-dire \xeatre inform\xe9es de vos activit\xe9s de formation), et vos informations ne seront plus visibles dans les rapports de l’organisation.";
var UserPrivacyCtrl_ToPublicProfile = "Si vous d\xe9finissez votre profil comme \xe9tant public, les informations suivantes deviendront publiques pour tous les utilisateurs de cette plateforme\xa0:<br><br><strong>Votre nom</strong>, <strong>votre collection en mati\xe8re de formations</strong>, <strong>vos statistiques</strong> (y compris votre classement).<br><br>D’autres utilisateurs pourront \xe9galement vous suivre (c’est-\xe0-dire \xeatre inform\xe9s de votre activit\xe9 de formation).";
var UserPrivacyCtrl_ToPublicProfileInOrgFormat = "Si vous d\xe9finissez votre profil comme \xe9tant public, les informations suivantes deviendront publiques (externes \xe0 tous les utilisateurs de {{OrgName}} sur cette plateforme)\xa0:<br/><br/><strong>Votre nom</strong>, <strong>votre collection en mati\xe8re de formations</strong> (le contenu de {{OrgName}} ne sera pas visible pour les personnes qui ne sont pas membres de {{OrgNameSingular}}) et <strong>vos statistiques</strong> (y compris votre classement).<br/><br/>D’autres utilisateurs publics pourront \xe9galement vous suivre (c’est-\xe0-dire \xeatre inform\xe9s de vos activit\xe9s de formation).";
var UserPrivacyCtrl_ToPublicProfileInOrgFromAnonymousFormat = "Si vous d\xe9finissez votre profil comme \xe9tant public, les informations suivantes deviendront publiques (externes \xe0 tous les utilisateurs de {{OrgName}} sur cette plateforme)\xa0:<br/><br/><strong>Votre nom</strong>, <strong>votre collection en mati\xe8re de formations</strong> (le contenu de {{OrgName}} ne sera pas visible pour les personnes qui ne sont pas membres de {{OrgName}}) et <strong>vos statistiques</strong> (y compris votre classement).<br/><br/>D’autres utilisateurs publics pourront \xe9galement vous suivre (c’est-\xe0-dire \xeatre inform\xe9s de vos activit\xe9s de formation), et vos informations seront visibles dans les rapports de l’organisation.";
var UserPrivacyCtrl_YourOrganization = "Votre organisation";
var UserProfileSvc_ProblemAccessingCollection = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’acc\xe8s \xe0 la collection de votre profil.";
var UserProfileSvc_ProblemAccessingSignalSummary = "D\xe9sol\xe9\xa0! Un probl\xe8me est survenu lors de l’acc\xe8s \xe0 vos signaux de comp\xe9tence";
var UserProfileSvc_ProblemDeletingCollectionItem = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la suppression de votre collection.";
var UserProfileSvc_ProblemUpdatingCollectionItem = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la mise \xe0 jour de votre collection";
var UserProfileSvc_ProblemUpdatingSkillCheckup = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors du rejet de votre bilan de comp\xe9tences";
var userRated_Format = "{{nameHtml}} vous a not\xe9 un niveau {{level}} dans {{tagName}}";
var UserSettingsSvc_CommunicationSettingsSaved = "Vos pr\xe9f\xe9rences de communication ont \xe9t\xe9 enregistr\xe9es.";
var UserSettingsSvc_CommunicationSettingsSavedFailed = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’enregistrement de vos pr\xe9f\xe9rences de notification.";
var UserSettingsSvc_DescAssignedLearning = "Formations assign\xe9es";
var UserSettingsSvc_DescAssignmentReminder = "Assignment Reminder";
var UserSettingsSvc_DescEndorsementRequest = "Demandes d’approbation d’une revue de comp\xe9tence";
var UserSettingsSvc_DescFollowers = "Nouveaux abonn\xe9s";
var UserSettingsSvc_DescFollowingActivity = "Nouvelles activit\xe9s des personnes que vous suivez";
var UserSettingsSvc_DescGoals = "Nouveaux objectifs et objectifs termin\xe9s";
var UserSettingsSvc_DescGroupPostAdded = "Nouvelle publication dans le groupe";
var UserSettingsSvc_DescMention = "Mention";
var UserSettingsSvc_DescNewComment = "Nouveaux commentaires";
var UserSettingsSvc_DescNewGoal = "Nouveaux objectifs";
var UserSettingsSvc_DescRecommendations = "Nouveaux partages";
var UserSettingsSvc_DescReplyComment = "R\xe9ponse";
var UserSettingsSvc_DescSocialNotify = "Nouvel abonn\xe9";
var UserSettingsSvc_DescTodaysLearning = "Liste des \xe9l\xe9ments de votre flux";
var UserSettingsSvc_EmailAddressesError = "Une erreur est survenue lors de la r\xe9cup\xe9ration de vos adresses e-mail.";
var UserSettingsSvc_JobRoleSaveFailed = "Une erreur s’est produite lors de l’enregistrement de votre poste.";
var UserSettingsSvc_NotificationSettingsSaved = "Vos pr\xe9f\xe9rences de notification ont \xe9t\xe9 enregistr\xe9es.";
var UserSettingsSvc_NotificationSettingsSavedFailed = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’enregistrement de vos pr\xe9f\xe9rences de notification.";
var UserSettingsSvc_NotificationTestSendFailed = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors du test de la notification.";
var UserSettingsSvc_NotificationTestSent = "Notification de test envoy\xe9e !";
var UserSettingsSvc_NotificationTypeDisplayText106 = "Tenez-vous au courant gr\xe2ce \xe0 ces e-mails informatifs.";
var UserSettingsSvc_NotificationTypeDisplayText34 = "Envoyez-moi un e-mail pour chacun des \xe9v\xe9nements suivants d\xe8s qu’il se produit.";
var UserSettingsSvc_NotificationTypeDisplayText35 = "Les tendances du jour";
var UserSettingsSvc_NotificationTypeDisplayText37 = "Les tendances de la semaine";
var UserSettingsSvc_NotificationTypeDisplayText61 = "Conseils ponctuels";
var UserSettingsSvc_NotificationTypeDisplayText77 = "V\xe9rification des comp\xe9tences";
var UserSettingsSvc_PrivacySettingsSaved = "Vos param\xe8tres de confidentialit\xe9 ont \xe9t\xe9 enregistr\xe9s.";
var UserSettingsSvc_PrivacySettingsSaveFailed = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’enregistrement de vos param\xe8tres.";
var UserSettingsSvc_SettingsNotPublic = "Les param\xe8tres du profil ne sont pas publics";
var UserSettingsSvc_TryLoggingIn = "Si vous voulez les consulter, essayez de vous connecter";
var UsersSvc_FindUsersError = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de la recherche des personnes correspondant \xe0 votre saisie.";
var UsersSvc_GetOpportunityPreferencesError = "Une erreur est survenue lors de r\xe9cup\xe9ration des pr\xe9f\xe9rences d’opportunit\xe9s";
var UsersSvc_GetRecommendedError = "Un probl\xe8me est survenu lors de l’obtention des partages.";
var UsersSvc_GetUserError = "Une erreur est survenue lors de l’obtention des d\xe9tails de l’utilisateur.";
var UsersSvc_UpdateOpportunityPreferencesError = "Une erreur est survenue lors de la mise \xe0 jour de vos pr\xe9f\xe9rences d’opportunit\xe9s";
var UserStaticSettingsSvc_AssociatedPersonalEmail = "D\xe9sol\xe9\xa0! Votre adresse e-mail personnelle ne peut pas \xeatre identique \xe0 l’adresse principale entr\xe9e dans le syst\xe8me.";
var UserStaticSettingsSvc_DuplicateOrgEmail = "D\xe9sol\xe9\xa0! Votre adresse secondaire doit \xeatre diff\xe9rente de votre adresse e-mail principale. Veuillez mettre \xe0 jour votre adresse e-mail secondaire avant d’enregistrer.";
var UserStaticSettingsSvc_DuplicateProfileName = "D\xe9sol\xe9 ! Ce nom de profil est d\xe9j\xe0 utilis\xe9.";
var UserStaticSettingsSvc_Failure = "D\xe9sol\xe9\xa0! Nous n’avons pas pu mettre \xe0 jour les param\xe8tres de votre profil.";
var UserStaticSettingsSvc_InvalidPersonalEmail = "D\xe9sol\xe9\xa0! Votre adresse e-mail secondaire n’est pas valide. Veuillez la mettre \xe0 jour avant d’enregistrer.";
var UserStaticSettingsSvc_InvalidProfileName = "D\xe9sol\xe9\xa0! Ce nom de profil n’est pas valide. Les noms de profil doivent \xeatre uniques et les caract\xe8res sp\xe9ciaux ne sont pas autoris\xe9s (seuls les chiffres et les lettres peuvent \xeatre utilis\xe9s.)";
var UserStaticSettingsSvc_Success = "Les param\xe8tres du profil ont bien \xe9t\xe9 mis \xe0 jour.";
var UserTagRatingCompleted_NotificationTitleFormat = "{{nameHtml}} vous a not\xe9 un niveau {{level}} dans {{tag}}";
var UserTagRatingRequested_Complete_NotificationTitleFormat = "Vous avez not\xe9 {{nameHtml}} dans {{tag}}";
var UserTagRatingRequested_NotificationTitleFormat = "{{nameHtml}} vous a demand\xe9 une {{ratingType}} pour la comp\xe9tence {{tag}}";
var UserTagRatingRequested_Self_CompleteNotificationTitleFormat = "Vous avez effectu\xe9 une auto-\xe9valuation pour {{tag}}";
var UserTagRatingRequested_Self_NotificationTitleFormat = "{{nameHtml}} vous a demand\xe9 d’auto-\xe9valuer votre comp\xe9tence {{tag}}";
var UserTaskSvc_Error = "D\xe9sol\xe9 ! Un probl\xe8me est survenu lors de l’acc\xe8s \xe0 vos t\xe2ches.";
var verificationForm_AuthInstructions = "Pour continuer, connectez-vous \xe0 votre compte Degreed existant ou choisissez un mot de passe pour cr\xe9er un nouveau compte Degreed.";
var verificationForm_AuthLoginLink = "Connectez-vous \xe0 votre compte Degreed";
var verificationForm_AuthPasswordLabel = "Choisissez un mot de passe pour cr\xe9er un nouveau compte";
var verificationForm_AuthTitle = "Compte Degreed";
var verificationForm_Change = "Modification";
var verificationForm_EmailLabel = "Adresse e-mail";
var verificationForm_ErrorGettingForm = "Un probl\xe8me est survenu lors du chargement de vos informations.";
var verificationForm_ErrorSavingForm = "Un probl\xe8me est survenu lors de l’enregistrement de vos informations.";
var verificationForm_FirstNameLabel = "Pr\xe9nom";
var verificationForm_LastNameLabel = "Nom";
var verificationForm_LinkedInLabel = "URL LinkedIn";
var verificationForm_LinkedInPlaceholder = "linkedin.com/in/nom_d’utilisateur";
var verificationForm_Optional = "(facultatif)";
var verificationForm_PhoneLabel = "Num\xe9ro de t\xe9l\xe9phone";
var verificationForm_PhonePlaceholder = "xxx-xxx-xxxx";
var verificationForm_PhotoLabel = "Pi\xe8ce d’identit\xe9 avec photo";
var verificationForm_PhotoRequirements = "Joignez une photo de vous tenant une carte d’identit\xe9. Cette derni\xe8re doit \xeatre bien visible.";
var verificationForm_PhotoTileLabel = "Votre pi\xe8ce d’identit\xe9 avec photo";
var verificationForm_Submit = "Enregistrer et continuer";
var verificationForm_TwitterLabel = "URL Twitter";
var verificationForm_TwitterPlaceholder = "twitter.com/nomdutilisateur";
var verificationModal_ImageAlt = "Exemple de photo d’une femme tenant sa pi\xe8ce d’identit\xe9";
var verificationModal_Instructions = "Joignez une photo de vous tenant une pi\xe8ce d’identit\xe9 avec photo \xe9mise par le gouvernement, comme un permis de conduire, une carte d’identit\xe9 ou encore un passeport. Veillez \xe0 ce que la pi\xe8ce d’identit\xe9 soit bien lisible sur la photo. Si vous n’avez pas de pi\xe8ce d’identit\xe9 comportant votre nom d’usage ou si vous avez des questions, contactez-nous par e-mail \xe0 l’adresse {{startAnchor}}support@degreed.com{{endAnchor}}.";
var verificationModal_ProvidePhoto = "T\xe9l\xe9charger un fichier";
var verificationModal_RequiredPhoto = "Une photo de vous tenant une carte d’identit\xe9 est obligatoire";
var verificationModal_Submit = "Ajouter une pi\xe8ce d’identit\xe9 avec photo";
var Webhooks_ActivityDownload = "Download Activity Log";
var Webhooks_ActivityDownloadConfirmation = "This Log will contain data from [Month/Day/Year] to [Month/Day/Year]. Please update your date filter if you want to receive data from a different date range.";
var Webhooks_ActivityDownloadLogBtn = "T\xe9l\xe9charger l’historique";
var Webhooks_ActivityDownloadSuccessfully = "Activity Log downloaded successfully!";
var Webhooks_ActivityFilterCheckbox = "Sent/Received,\nRetry 1,\nRetry 2,\nRetry 3,\nFailed,\nTest Message";
var Webhooks_ActivityLog = "Historique des activit\xe9s";
var Webhooks_ActivityLogDescription = "Short description goes here Lorem ipsum dolor sit amet consectetur.";
var Webhooks_ActivityLogErrorOrgid = "Error getting activity logs by org id";
var Webhooks_ActivityLogEventType = "Type d’\xe9v\xe9nement";
var Webhooks_ActivityLogFailed = "Failed to copy to clipboard.";
var Webhooks_ActivityLogInvalid = "Invalid JSON payload.";
var Webhooks_ActivityLogNoLogs = "Aucun historique d’activit\xe9 trouv\xe9";
var Webhooks_ActivityLogRefresh = "Actualiser l’historique";
var Webhooks_ActivityLogResponseCode = "Code de r\xe9ponse";
var Webhooks_ActivityLogResponseTime = "Temps de r\xe9ponse";
var Webhooks_ActivityLogRetries = "TENTATIVES";
var Webhooks_ActivityLogRetryCopyPaylod = "Copier la charge utile";
var Webhooks_ActivityLogTimestamp = "Horodatage";
var Webhooks_ActivityLogTry = "Essayez de modifier les filtres ou r\xe9essayez ult\xe9rieurement.";
var Webhooks_ActivityLogView = "Voir l’activit\xe9";
var Webhooks_ActivityRetriesQueue = "Retries Queue";
var Webhooks_ActivityViewLog = "Voir les historiques d’activit\xe9";
var Webhooks_AddWebhook = "Ajouter un webhook";
var Webhooks_AuthorizationType = "TYPE D’AUTORISATION";
var Webhooks_AvgLatency = "Average Latency";
var Webhooks_AvgTime = "Average Time to Response";
var Webhooks_CreateWebhook = "Cr\xe9er un webhook";
var Webhooks_DeleteSuccessfully = "Le webhook a \xe9t\xe9 supprim\xe9 avec succ\xe8s.";
var Webhooks_DeleteWebhook = "Supprimer un webhook";
var Webhooks_DeleteWebhookConfirmationMessage = "Voulez-vous vraiment supprimer cet abonnement au webhook\xa0? Cette action est d\xe9finitive et irr\xe9versible. \u2028\u2028Vous pouvez mettre cet abonnement \xab\xa0en pause\xa0\xbb si vous souhaitez le red\xe9marrer ult\xe9rieurement.";
var Webhooks_DeleteWebhookConfirmationPrimaryBtn = "Supprimer";
var Webhooks_DeleteWebhookConfirmationSecondaryBtn = "Annuler";
var Webhooks_DescriptionAddWebhook = "Il n’y a encore rien ici.";
var Webhooks_EndpointUrl = "URL du point de terminaison";
var Webhooks_ErrorCreatingOrUpdatingWebhook = "Veuillez remplir tous les champs obligatoires.";
var Webhooks_Events_LearningProgressEvent = "Mise \xe0 jour de progression";
var Webhooks_Events_LearningProgressEvent_Description = "Lorsqu’une ressource enregistre une progression. Les ressources d\xe9signent tous les types de contenus (vid\xe9os, livres, cours, \xe9v\xe9nements, etc.), les plans de comp\xe9tences, les parcours, les plans et les acad\xe9mies.";
var Webhooks_Events_PathwayCompletedEvent = "Parcours termin\xe9";
var Webhooks_Events_PathwayCompletedEvent_Description = "Cet \xe9v\xe9nement est enregistr\xe9 lorsqu’un parcours est termin\xe9.";
var Webhooks_Events_PathwayCreatedEvent = "Parcours cr\xe9\xe9";
var Webhooks_Events_PathwayCreatedEvent_Description = "Cet \xe9v\xe9nement est enregistr\xe9 lorsqu’un parcours est cr\xe9\xe9.";
var Webhooks_Events_PathwayEnrolledEvent = "Parcours suivi";
var Webhooks_Events_PathwayEnrolledEvent_Description = "Cet \xe9v\xe9nement est enregistr\xe9 lorsqu’un parcours compte un nouvel abonn\xe9.";
var Webhooks_Events_PathwayUnenrolledEvent = "Arr\xeat de suivi d’un parcours";
var Webhooks_Events_PathwayUnenrolledEvent_Description = "Cet \xe9v\xe9nement est enregistr\xe9 lorsqu’un parcours perd un abonn\xe9.";
var Webhooks_Events_PathwayUpdatedEvent = "Parcours mis \xe0 jour";
var Webhooks_Events_PathwayUpdatedEvent_Description = "Cet \xe9v\xe9nement est enregistr\xe9 lorsqu’un parcours est mis \xe0 jour.";
var Webhooks_Events_PathwayViewedEvent = "Parcours consult\xe9";
var Webhooks_Events_PathwayViewedEvent_Description = "Cet \xe9v\xe9nement est enregistr\xe9 lorsqu’un utilisateur consulte le parcours depuis l’interface utilisateur. En cas d’actualisation de la page par l’utilisateur, l’\xe9v\xe9nement Parcours consult\xe9 est \xe0 nouveau enregistr\xe9.";
var Webhooks_Events_QueueItemCreatedEvent = "\xc9l\xe9ment enregistr\xe9";
var Webhooks_Events_QueueItemCreatedEvent_Description = "Cet \xe9v\xe9nement est enregistr\xe9 lorsqu’une ressource est sauvegard\xe9e dans la file d’attente \xab\xa0saved-for-later\xa0\xbb. Les ressources d\xe9signent tous les types de contenus (vid\xe9os, livres, cours, \xe9v\xe9nements, etc.), les plans de comp\xe9tences, les parcours, les \xe9v\xe9nements, les insignes, les postes, les \xe9valuations de dipl\xf4me, les certificats de parcours, les r\xe9compenses, les accomplissements, les \xe9pisodes/podcasts sur les comp\xe9tences, les groupes, les utilisateurs, les mots-cl\xe9s, les cibles, les t\xe2ches, les donn\xe9es saisies, le texte libre, les liens, les publications, les opportunit\xe9s, les sections et les acad\xe9mies.";
var Webhooks_Events_QueueItemRemovedEvent = "Suppression d’un \xe9l\xe9ment enregistr\xe9";
var Webhooks_Events_QueueItemRemovedEvent_Description = "Cet \xe9v\xe9nement est enregistr\xe9 lorsqu’une ressource est supprim\xe9e de la file d’attente \xab\xa0saved-for-later\xa0\xbb. Les ressources d\xe9signent tous les types de contenus (vid\xe9os, livres, cours, \xe9v\xe9nements, etc.), les plans de comp\xe9tences, les parcours, les \xe9v\xe9nements, les insignes, les postes, les \xe9valuations de dipl\xf4me, les certificats de parcours, les r\xe9compenses, les accomplissements, les \xe9pisodes/podcasts sur les comp\xe9tences, les groupes, les utilisateurs, les mots-cl\xe9s, les cibles, les t\xe2ches, les donn\xe9es saisies, le texte libre, les liens, les publications, les opportunit\xe9s, les sections et les acad\xe9mies.";
var Webhooks_Events_RecommendationCreatedEvent = "\xc9l\xe9ment recommand\xe9";
var Webhooks_Events_RecommendationCreatedEvent_Description = "Cet \xe9v\xe9nement est enregistr\xe9 lorsqu’une ressource est recommand\xe9e. Les ressources d\xe9signent tous les types de contenus (vid\xe9os, livres, cours, \xe9v\xe9nements, etc.), les plans de comp\xe9tences, les parcours, les \xe9v\xe9nements, les insignes, les postes, les \xe9valuations de dipl\xf4me, les certificats de parcours, les r\xe9compenses, les accomplissements, les \xe9pisodes/podcasts sur les comp\xe9tences, les groupes, les utilisateurs, les mots-cl\xe9s, les cibles, les t\xe2ches, les donn\xe9es saisies, le texte libre, les liens, les publications, les opportunit\xe9s, les sections et les acad\xe9mies.";
var Webhooks_Events_TargetCreatedEvent = "Plan ou r\xe9pertoire cr\xe9\xe9";
var Webhooks_Events_TargetCreatedEvent_Description = "Cet \xe9v\xe9nement est enregistr\xe9 lorsqu’un plan ou un r\xe9pertoire est cr\xe9\xe9.";
var Webhooks_Events_TargetDeletedEvent = "Plan ou r\xe9pertoire supprim\xe9";
var Webhooks_Events_TargetDeletedEvent_Description = "Cet \xe9v\xe9nement est enregistr\xe9 lorsqu’un plan ou un r\xe9pertoire est supprim\xe9.";
var Webhooks_Events_TargetFollowedEvent = "Plan ou r\xe9pertoire suivi par un utilisateur";
var Webhooks_Events_TargetFollowedEvent_Description = "Cet \xe9v\xe9nement est enregistr\xe9 lorsqu’un plan ou un r\xe9pertoire compte un nouvel abonn\xe9.";
var Webhooks_Events_TargetUnfollowedEvent = "Arr\xeat de suivi d’un plan ou d’un r\xe9pertoire";
var Webhooks_Events_TargetUnfollowedEvent_Description = "Cet \xe9v\xe9nement est enregistr\xe9 lorsqu’un plan ou un r\xe9pertoire perd un nouvel abonn\xe9.";
var Webhooks_Events_UserCommentAddedEvent = "Commentaire ajout\xe9";
var Webhooks_Events_UserCommentAddedEvent_Description = "Cet \xe9v\xe9nement est enregistr\xe9 lorsqu’un commentaire est ajout\xe9.";
var Webhooks_Events_UserCommentDeletedEvent = "Commentaire supprim\xe9";
var Webhooks_Events_UserCommentDeletedEvent_Description = "Cet \xe9v\xe9nement est enregistr\xe9 lorsqu’un commentaire est supprim\xe9.";
var Webhooks_Events_UserCreatedGroupEvent = "Groupe cr\xe9\xe9";
var Webhooks_Events_UserCreatedGroupEvent_Description = "Cet \xe9v\xe9nement est enregistr\xe9 lorsqu’un groupe est cr\xe9\xe9.";
var Webhooks_Events_UserDeletedGroupEvent = "Utilisateur supprim\xe9 d’un groupe";
var Webhooks_Events_UserDeletedGroupEvent_Description = "Cet \xe9v\xe9nement est enregistr\xe9 lorsqu’un utilisateur est supprim\xe9 d’un groupe.";
var Webhooks_Events_UserFollowedEvent = "Utilisateur suivi";
var Webhooks_Events_UserFollowedEvent_Description = "Cet \xe9v\xe9nement est enregistr\xe9 lorsqu’un utilisateur compte un nouvel abonn\xe9.";
var Webhooks_Events_UserInputCreatedEvent = "Ajout d’un \xe9l\xe9ment termin\xe9";
var Webhooks_Events_UserInputCreatedEvent_Description = "Cet \xe9v\xe9nement est enregistr\xe9 lorsqu’un contenu est termin\xe9 (par exemple, un article, un cours, un livre, une vid\xe9o, un \xe9v\xe9nement, une t\xe2che, un \xe9pisode ou un podcast, etc.). La compl\xe9tion peut se faire \xe0 partir de l’interface utilisateur, de l’API V2 et des int\xe9grations.";
var Webhooks_Events_UserInputViewedEvent = "Contenu consult\xe9";
var Webhooks_Events_UserInputViewedEvent_Description = "Cet \xe9v\xe9nement est enregistr\xe9 lorsqu’un \xe9l\xe9ment de contenu est consult\xe9, notamment lorsque la carte du contenu est s\xe9lectionn\xe9e ou qu’un lien est utilis\xe9 pour acc\xe9der directement \xe0 la page du contenu dans l’interface utilisateur de Degreed (par exemple, un article, un cours, un livre, une vid\xe9o, un \xe9v\xe9nement, une t\xe2che, un \xe9pisode ou un podcast, etc.).";
var Webhooks_Events_UserInterestAddedEvent = "Comp\xe9tence ajout\xe9e \xe0 un utilisateur";
var Webhooks_Events_UserInterestAddedEvent_Description = "Cet \xe9v\xe9nement est enregistr\xe9 lorsqu’une comp\xe9tence est ajout\xe9e \xe0 un utilisateur.";
var Webhooks_Events_UserInterestRemovedEvent = "Comp\xe9tence retir\xe9e \xe0 un utilisateur";
var Webhooks_Events_UserInterestRemovedEvent_Description = "Cet \xe9v\xe9nement est enregistr\xe9 lorsqu’une comp\xe9tence est retir\xe9e \xe0 un utilisateur.";
var Webhooks_Events_UserInvitedToGroupEvent = "Utilisateur invit\xe9 \xe0 rejoindre un groupe";
var Webhooks_Events_UserInvitedToGroupEvent_Description = "Cet \xe9v\xe9nement est enregistr\xe9 lorsqu’un utilisateur est invit\xe9 \xe0 rejoindre un groupe.";
var Webhooks_Events_UserJoinedGroupEvent = "Utilisateur devenu membre d’un groupe";
var Webhooks_Events_UserJoinedGroupEvent_Description = "Cet \xe9v\xe9nement est enregistr\xe9 lorsqu’un utilisateur rejoint un groupe.";
var Webhooks_Events_UserLeftGroupEvent = "Utilisateur parti d'un groupe";
var Webhooks_Events_UserLeftGroupEvent_Description = "Cet \xe9v\xe9nement est enregistr\xe9 lorsqu’un utilisateur quitte un groupe.";
var Webhooks_Events_UserLoginEvent = "Utilisateur connect\xe9";
var Webhooks_Events_UserLoginEvent_Description = "Cet \xe9v\xe9nement est enregistr\xe9 lorsqu’un utilisateur se connecte.";
var Webhooks_Events_UserResourceDeletedEvent = "Suppression d’un \xe9l\xe9ment termin\xe9";
var Webhooks_Events_UserResourceDeletedEvent_Description = "Cet \xe9v\xe9nement est enregistr\xe9 lorsqu’une ressource est supprim\xe9e ou marqu\xe9e comme non termin\xe9e. Ces \xe9v\xe9nements peuvent se produire \xe0 partir de l’interface utilisateur, de l’API V2 et des int\xe9grations. Les ressources d\xe9signent tous les types de contenus (vid\xe9os, livres, cours, \xe9v\xe9nements, etc.), les plans de comp\xe9tences, les parcours, les \xe9v\xe9nements, les insignes, les postes, les \xe9valuations de dipl\xf4me, les certificats de parcours, les r\xe9compenses, les accomplissements, les \xe9pisodes/podcasts sur les comp\xe9tences, les groupes, les utilisateurs, les mots-cl\xe9s, les cibles, les t\xe2ches, les donn\xe9es saisies, le texte libre, les liens, les publications, les opportunit\xe9s, les sections et les acad\xe9mies.";
var Webhooks_Events_UserResourceRatingEvent = "Contenu aim\xe9";
var Webhooks_Events_UserResourceRatingEvent_Description = "Cet \xe9v\xe9nement est enregistr\xe9 lorsqu’une mention \xab\xa0J’aime\xa0\xbb est donn\xe9e \xe0 une ressource (pouce lev\xe9).";
var Webhooks_Events_UserTagRatingCompletedEvent = "Cr\xe9ation d’une \xe9valuation de comp\xe9tence";
var Webhooks_Events_UserTagRatingCompletedEvent_Description = "Lorsqu’un utilisateur \xe9value la comp\xe9tence d’un utilisateur, que ce soit pour lui-m\xeame ou en tant que manager.";
var Webhooks_EventsSelected = "Events Selected";
var Webhooks_EventType = "Event by Type";
var Webhooks_EventTypesColumn = "Description";
var Webhooks_Get = "Ajoutez un webhook pour commencer.";
var Webhooks_Heading = "Webhooks";
var Webhooks_HeadingManage = "G\xe9rer les webhooks";
var Webhooks_HeadingNew = "Nouveau webhook";
var Webhooks_HMAC = "HMAC";
var Webhooks_HMACSecret = "Cl\xe9 secr\xe8te HMAC";
var Webhooks_HMACSecretEncrypted = "This can also be known as the signing key and will be encrypted with SHA-256";
var Webhooks_HMACSignatureHeader = "En-t\xeate de signature HMAC";
var Webhooks_HMACSignatureHeaderEncrypted = "The Signature Header will be encrypted with SHA-256 in Base 64";
var Webhooks_ID = "Webhook Id";
var Webhooks_NoWebhook = "Get started by adding a webhook";
var Webhooks_OAuth2 = "OAuth 2";
var Webhooks_OAuthClientUrl = "Client URL";
var Webhooks_On = "Activ\xe9";
var Webhooks_Paused = "En pause";
var Webhooks_Payload = "Payloads";
var Webhooks_PayloadsSent = "Payloads Sent";
var Webhooks_PayloadType = "PAYLOAD TYPE";
var Webhooks_Security = "S\xe9curit\xe9";
var Webhooks_Status_Failure = "Failure";
var Webhooks_Status_Retry = "Retry 1";
var Webhooks_Status_Retry2 = "Retry 2";
var Webhooks_Status_Retry3 = "Retry 3";
var Webhooks_Status_Success = "Success";
var Webhooks_Status_WebhookCreated = "Webhook Created";
var Webhooks_Stopped = "Arr\xeat\xe9";
var Webhooks_Test = "Test du webhook en cours";
var Webhooks_TestDescription = "Nous envoyons actuellement un message de test au point de terminaison.";
var Webhooks_WebhookCreatedSuccessfully = "Le webhook a \xe9t\xe9 cr\xe9\xe9 avec succ\xe8s.";
var Webhooks_WebhookName = "Nom du webhook";
var Webhooks_WebhookUpdatedSuccessfully = "Le webhook a \xe9t\xe9 mis \xe0 jour avec succ\xe8s.";
var workdaySkillAdded_Plural = "Vos comp\xe9tences synchronis\xe9es dans Workday ont \xe9t\xe9 mises \xe0 jour. {{ number }}\xa0comp\xe9tences ont \xe9t\xe9 synchronis\xe9es avec votre profil.{{ viewSkillsHtml }}";
var workdaySkillAdded_Single = "Vos comp\xe9tences synchronis\xe9es avec Workday ont \xe9t\xe9 mises \xe0 jour. La comp\xe9tence {{ skillName }} a \xe9t\xe9 synchronis\xe9e avec votre profil.\n{{ viewSkillHtml }}";
var workdaySkillAdded_WorkdayIntegrationDisabled = "L’int\xe9gration de comp\xe9tences avec Workday a \xe9t\xe9 d\xe9sactiv\xe9e. Vos comp\xe9tences Workday ne seront plus synchronis\xe9es avec votre profil Degreed.\n{{ viewSkillsHtml }}";
var workdaySkillAdded_WorkdayIntegrationEnabled = "L’int\xe9gration de comp\xe9tences avec Workday a \xe9t\xe9 activ\xe9e. Les comp\xe9tences de votre profil Workday seront connect\xe9es et synchronis\xe9es avec votre profil Degreed.\n{{ viewSkillsHtml }}";
var workdaySkillRemoved_Message = "{{ skillName }} a \xe9t\xe9 supprim\xe9 de votre profil.";
var workdaySkillRemoved_Plural = "Les comp\xe9tences provenant de Workday ont \xe9t\xe9 mises \xe0 jour\xa0: \n{{ skillsRemovedHtml }}\n{{ viewSkillHtml }}";
var workdaySkillRemoved_Single = "Les comp\xe9tences provenant de Workday ont \xe9t\xe9 mises \xe0 jour\xa0: {{ skillName }} a \xe9t\xe9 supprim\xe9 de votre profil.\n{{ viewSkillHtml }}";
var localTranslationsFr = {
    A11y_ActionsToolbarType: A11y_ActionsToolbarType,
    A11y_AddComment: A11y_AddComment,
    A11y_AssignmentsCount: A11y_AssignmentsCount,
    A11y_AssignmentStatus: A11y_AssignmentStatus,
    A11y_BlurToSave: A11y_BlurToSave,
    A11y_BreadcrumbNavType: A11y_BreadcrumbNavType,
    A11y_BrowseGroups: A11y_BrowseGroups,
    A11y_BrowseGroupsButton: A11y_BrowseGroupsButton,
    A11y_BrowseOpportunitiesGridView: A11y_BrowseOpportunitiesGridView,
    A11y_BrowseOpportunitiesListView: A11y_BrowseOpportunitiesListView,
    A11y_BrowsePathwaysButton: A11y_BrowsePathwaysButton,
    A11y_BrowsePlansButton: A11y_BrowsePlansButton,
    A11y_BulkDelete_Format: A11y_BulkDelete_Format,
    A11y_BulkDisable_Format: A11y_BulkDisable_Format,
    A11y_BulkEnable_Format: A11y_BulkEnable_Format,
    A11y_ButtonGroupWithNestedDropdown: A11y_ButtonGroupWithNestedDropdown,
    A11y_CharacterLimit: A11y_CharacterLimit,
    A11y_CollapsePanelButton: A11y_CollapsePanelButton,
    A11y_CollectionChangeAnnouncement: A11y_CollectionChangeAnnouncement,
    A11y_CompletionProgressDetails: A11y_CompletionProgressDetails,
    A11y_ConfirmModal_input: A11y_ConfirmModal_input,
    A11y_ContentCompletedButton: A11y_ContentCompletedButton,
    A11y_ContentNotCompletedButton: A11y_ContentNotCompletedButton,
    A11y_ContentTypesNavType: A11y_ContentTypesNavType,
    A11y_ContinuingEducationUnits: A11y_ContinuingEducationUnits,
    A11y_CreateGroup: A11y_CreateGroup,
    A11y_Date_YYYYMMDDFormat: A11y_Date_YYYYMMDDFormat,
    A11y_Delete_Format: A11y_Delete_Format,
    A11y_DeleteLink: A11y_DeleteLink,
    A11y_Disable_Format: A11y_Disable_Format,
    A11y_Edit_Format: A11y_Edit_Format,
    A11y_Enable_Format: A11y_Enable_Format,
    A11y_EscapeToDismiss: A11y_EscapeToDismiss,
    A11y_ExpandExperience: A11y_ExpandExperience,
    A11y_ExpandForSummary: A11y_ExpandForSummary,
    A11y_ExpandForTitle: A11y_ExpandForTitle,
    A11y_ExpandPanelButton: A11y_ExpandPanelButton,
    A11y_FollowingPathwayButton: A11y_FollowingPathwayButton,
    A11y_FollowingPlanButton: A11y_FollowingPlanButton,
    A11y_GlobalSearchInstructions: A11y_GlobalSearchInstructions,
    A11y_GoToProfile: A11y_GoToProfile,
    A11y_GroupJoinedButton: A11y_GroupJoinedButton,
    A11y_GroupNotJoinedButton: A11y_GroupNotJoinedButton,
    A11y_LearningCollectionsNavType: A11y_LearningCollectionsNavType,
    A11y_LinkOpensNewWindow: A11y_LinkOpensNewWindow,
    A11y_MainPagesNavType: A11y_MainPagesNavType,
    A11y_NonOptionalStepsComplete: A11y_NonOptionalStepsComplete,
    A11y_NotFollowingPathwayButton: A11y_NotFollowingPathwayButton,
    A11y_NotFollowingPlanButton: A11y_NotFollowingPlanButton,
    A11y_NumberOfSkills: A11y_NumberOfSkills,
    A11y_NumberSuggestionsAvailableFormat: A11y_NumberSuggestionsAvailableFormat,
    A11y_OpensInANewTab: A11y_OpensInANewTab,
    A11y_OptionalStatus: A11y_OptionalStatus,
    A11y_PositiveNumbersOnly: A11y_PositiveNumbersOnly,
    A11y_RegistrationStatus: A11y_RegistrationStatus,
    A11y_RemoveCardType: A11y_RemoveCardType,
    A11y_RemoveContent: A11y_RemoveContent,
    A11y_RemoveSection: A11y_RemoveSection,
    A11y_RemoveSubsection: A11y_RemoveSubsection,
    A11y_RemoveUser: A11y_RemoveUser,
    A11y_RotatingLogos: A11y_RotatingLogos,
    A11y_SearchAssignments: A11y_SearchAssignments,
    A11y_SecondaryPagesNavType: A11y_SecondaryPagesNavType,
    A11y_Select_Format: A11y_Select_Format,
    A11y_SessionStartDate: A11y_SessionStartDate,
    A11y_SliderDescription: A11y_SliderDescription,
    A11y_SliderNavigation: A11y_SliderNavigation,
    A11y_TabChangeAnnouncement: A11y_TabChangeAnnouncement,
    A11y_ToggleProductMenu: A11y_ToggleProductMenu,
    A11y_ToggleProfileMenu: A11y_ToggleProfileMenu,
    A11y_ToggleSearch: A11y_ToggleSearch,
    A11y_TrackerCurrentStep: A11y_TrackerCurrentStep,
    A11y_TrackerStep: A11y_TrackerStep,
    A11y_TryOurBookmarklet: A11y_TryOurBookmarklet,
    A11y_VerificationStatus: A11y_VerificationStatus,
    A11y_virtualDocument: A11y_virtualDocument,
    A11y_WizardClickExpand: A11y_WizardClickExpand,
    A11y_WizardNavType: A11y_WizardNavType,
    AboutFooter_AltCareersIcon: AboutFooter_AltCareersIcon,
    AboutFooter_AltContactIcon: AboutFooter_AltContactIcon,
    AboutFooter_AltMissionIcon: AboutFooter_AltMissionIcon,
    AboutFooter_AltPressIcon: AboutFooter_AltPressIcon,
    AboutFooter_CareersAtDegreed: AboutFooter_CareersAtDegreed,
    AboutFooter_ContactDegreed: AboutFooter_ContactDegreed,
    AboutFooter_DegreedMission: AboutFooter_DegreedMission,
    AboutFooter_DegreedPress: AboutFooter_DegreedPress,
    AboutFooter_JailbreakTheDegree: AboutFooter_JailbreakTheDegree,
    AboutFooter_LearningAndWork: AboutFooter_LearningAndWork,
    AboutFooter_WeWantToHear: AboutFooter_WeWantToHear,
    AboutFooter_WhatOthersAreSaying: AboutFooter_WhatOthersAreSaying,
    AccomplishmentFormCtrl_EndDate: AccomplishmentFormCtrl_EndDate,
    AccomplishmentFormCtrl_ExpirationDate: AccomplishmentFormCtrl_ExpirationDate,
    AccomplishmentFormCtrl_StateDate: AccomplishmentFormCtrl_StateDate,
    AccomplishmentFormCtrl_Title: AccomplishmentFormCtrl_Title,
    AccountController_AccountLockedByOrgError: AccountController_AccountLockedByOrgError,
    AccountController_AccountLockedError: AccountController_AccountLockedError,
    AccountController_AgreeWithTermsOne: AccountController_AgreeWithTermsOne,
    AccountController_AgreeWithTermTwo: AccountController_AgreeWithTermTwo,
    AccountController_And: AccountController_And,
    AccountController_ChangePassword: AccountController_ChangePassword,
    AccountController_ChangePasswordError: AccountController_ChangePasswordError,
    AccountController_ChangePasswordTitle: AccountController_ChangePasswordTitle,
    AccountController_ConfirmPassword: AccountController_ConfirmPassword,
    AccountController_Continue: AccountController_Continue,
    AccountController_ContinueWithSSO: AccountController_ContinueWithSSO,
    AccountController_EmailAddress: AccountController_EmailAddress,
    AccountController_EmailAddressPlaceholder: AccountController_EmailAddressPlaceholder,
    AccountController_EmailExistsError: AccountController_EmailExistsError,
    AccountController_EmailLoginDisabledError: AccountController_EmailLoginDisabledError,
    AccountController_EmailLoginError: AccountController_EmailLoginError,
    AccountController_FacebookLogin: AccountController_FacebookLogin,
    AccountController_FirstName: AccountController_FirstName,
    AccountController_Forgot: AccountController_Forgot,
    AccountController_LoggedOutHeader: AccountController_LoggedOutHeader,
    AccountController_LoggedOutTitle: AccountController_LoggedOutTitle,
    AccountController_Login: AccountController_Login,
    AccountController_LoginAgainButton: AccountController_LoginAgainButton,
    AccountController_LoginUsingPassword: AccountController_LoginUsingPassword,
    AccountController_LoginViewContent: AccountController_LoginViewContent,
    AccountController_NewPassword: AccountController_NewPassword,
    AccountController_OldPassword: AccountController_OldPassword,
    AccountController_OldPasswordPlaceholder: AccountController_OldPasswordPlaceholder,
    AccountController_Password: AccountController_Password,
    AccountController_PasswordMatchError: AccountController_PasswordMatchError,
    AccountController_PasswordPatternInfo: AccountController_PasswordPatternInfo,
    AccountController_PrivacyPolicy: AccountController_PrivacyPolicy,
    AccountController_RecentPasswordError: AccountController_RecentPasswordError,
    AccountController_Register: AccountController_Register,
    AccountController_RegisterEmailExistsError: AccountController_RegisterEmailExistsError,
    AccountController_RememberMe: AccountController_RememberMe,
    AccountController_ResetPassword: AccountController_ResetPassword,
    AccountController_ResetYourPassword: AccountController_ResetYourPassword,
    AccountController_SignUp: AccountController_SignUp,
    AccountController_SignUpPageTitle: AccountController_SignUpPageTitle,
    AccountController_SignUpTitle: AccountController_SignUpTitle,
    AccountController_UsernameLoginError: AccountController_UsernameLoginError,
    AccountController_ValidPassword: AccountController_ValidPassword,
    AccountController_WelcomeDegreed: AccountController_WelcomeDegreed,
    AccountCtrl_ContinueToAccount: AccountCtrl_ContinueToAccount,
    AccountCtrl_LoginUsingProvider: AccountCtrl_LoginUsingProvider,
    AccountSvc_ChangeLinkFail: AccountSvc_ChangeLinkFail,
    AccountSvc_ChangeSuccess: AccountSvc_ChangeSuccess,
    AccountSvc_CreateAccountError: AccountSvc_CreateAccountError,
    AccountSvc_DefaultPassword: AccountSvc_DefaultPassword,
    AccountSvc_DeleteAccount: AccountSvc_DeleteAccount,
    AccountSvc_EmailConfirmation: AccountSvc_EmailConfirmation,
    AccountSvc_ForgotPassword: AccountSvc_ForgotPassword,
    AccountSvc_GroupInvite: AccountSvc_GroupInvite,
    AccountSvc_LoginError: AccountSvc_LoginError,
    AccountSvc_OrgInvite: AccountSvc_OrgInvite,
    AccountSvc_OrgPasswordError: AccountSvc_OrgPasswordError,
    AccountSvc_PasswordResetError: AccountSvc_PasswordResetError,
    AccountSvc_PasswordResetInstructionsMessage: AccountSvc_PasswordResetInstructionsMessage,
    AccountSvc_Restricted: AccountSvc_Restricted,
    AccountSvc_SecondaryEmail: AccountSvc_SecondaryEmail,
    AccountSvc_SessionExpired: AccountSvc_SessionExpired,
    AccountSvc_SignUp: AccountSvc_SignUp,
    AccountSvc_Unsubscribe: AccountSvc_Unsubscribe,
    AccountSvc_UserEndorsement: AccountSvc_UserEndorsement,
    ActiveLearner_Condition1: ActiveLearner_Condition1,
    ActiveLearner_Condition1WithName: ActiveLearner_Condition1WithName,
    ActiveLearner_Condition2: ActiveLearner_Condition2,
    ActiveLearner_Condition2WithName: ActiveLearner_Condition2WithName,
    ActiveLearner_Condition3: ActiveLearner_Condition3,
    ActiveLearner_Condition3WithName: ActiveLearner_Condition3WithName,
    ActiveLearner_Condition4: ActiveLearner_Condition4,
    ActiveLearner_Condition4WithName: ActiveLearner_Condition4WithName,
    ActiveLearner_Congratulations: ActiveLearner_Congratulations,
    ActiveLearner_CongratulationsText: ActiveLearner_CongratulationsText,
    ActiveLearner_FinePrint: ActiveLearner_FinePrint,
    ActiveLearner_FinePrintWithName: ActiveLearner_FinePrintWithName,
    ActiveLearner_HowToGetRecognized: ActiveLearner_HowToGetRecognized,
    ActiveLearner_ModalTitle: ActiveLearner_ModalTitle,
    ActiveLearner_ModalTitleWithName: ActiveLearner_ModalTitleWithName,
    addEditMetaDataModal_AddProperty: addEditMetaDataModal_AddProperty,
    addEditMetaDataModal_EditProperties: addEditMetaDataModal_EditProperties,
    addEditMetaDataModal_Property: addEditMetaDataModal_Property,
    addEditMetaDataModal_Purpose_RolePlan: addEditMetaDataModal_Purpose_RolePlan,
    addEditMetaDataModal_RemoveProperty: addEditMetaDataModal_RemoveProperty,
    addEditMetaDataModal_Value: addEditMetaDataModal_Value,
    addToPathwayModal_AddedSuccessfully: addToPathwayModal_AddedSuccessfully,
    addToPathwayModal_AddingError: addToPathwayModal_AddingError,
    addToPathwayModal_AddItemDescription: addToPathwayModal_AddItemDescription,
    addToPathwayModal_AddToCatalog: addToPathwayModal_AddToCatalog,
    addToPathwayModal_AddToPathway: addToPathwayModal_AddToPathway,
    addToPathwayModal_CreatePathway: addToPathwayModal_CreatePathway,
    addToPathwayModal_CreatePathwayExplanation: addToPathwayModal_CreatePathwayExplanation,
    addToPathwayModal_CreateYourPathway: addToPathwayModal_CreateYourPathway,
    addToPathwayModal_EditPathway: addToPathwayModal_EditPathway,
    addToPathwayModal_GoToPathway: addToPathwayModal_GoToPathway,
    addToPathwayModal_HoldForLater: addToPathwayModal_HoldForLater,
    addToPathwayModal_Lesson: addToPathwayModal_Lesson,
    addToPathwayModal_LessonNumberFormat: addToPathwayModal_LessonNumberFormat,
    addToPathwayModal_MostRecentPathways: addToPathwayModal_MostRecentPathways,
    addToPathwayModal_NoPathwayDescription: addToPathwayModal_NoPathwayDescription,
    addToPathwayModal_OrgManagedNotice: addToPathwayModal_OrgManagedNotice,
    addToPathwayModal_Pathway: addToPathwayModal_Pathway,
    addToPathwayModal_RecentlyUsed: addToPathwayModal_RecentlyUsed,
    addToPathwayModal_SearchAuthoringPathway: addToPathwayModal_SearchAuthoringPathway,
    addToPathwayModal_SearchYourPathways: addToPathwayModal_SearchYourPathways,
    addToPathwayModal_Section: addToPathwayModal_Section,
    addToPathwayModal_SectionNumberFormat: addToPathwayModal_SectionNumberFormat,
    addToPathwayModal_SelectLesson: addToPathwayModal_SelectLesson,
    addToPathwayModal_SelectPathway: addToPathwayModal_SelectPathway,
    addToPathwayModal_SelectPathwaySection: addToPathwayModal_SelectPathwaySection,
    addToPathwayModal_SelectPathwaySubSection: addToPathwayModal_SelectPathwaySubSection,
    addToPathwayModal_SelectSection: addToPathwayModal_SelectSection,
    addToPathwayModal_SuccessLabel: addToPathwayModal_SuccessLabel,
    addToPathwayModal_VisitPathwayEditPage: addToPathwayModal_VisitPathwayEditPage,
    addToPathwayModal_WhichPathway: addToPathwayModal_WhichPathway,
    addToPathwayModal_YourPathways: addToPathwayModal_YourPathways,
    addToTargetModal_AddedItemSuccessfully: addToTargetModal_AddedItemSuccessfully,
    addToTargetModal_AddedSuccessfully: addToTargetModal_AddedSuccessfully,
    addToTargetModal_AddingError: addToTargetModal_AddingError,
    addToTargetModal_AddItemDescription: addToTargetModal_AddItemDescription,
    addToTargetModal_AddToTarget: addToTargetModal_AddToTarget,
    addToTargetModal_CreateJobRoleExplanation: addToTargetModal_CreateJobRoleExplanation,
    addToTargetModal_CreateTarget: addToTargetModal_CreateTarget,
    addToTargetModal_CreateYourTarget: addToTargetModal_CreateYourTarget,
    addToTargetModal_EditTarget: addToTargetModal_EditTarget,
    addToTargetModal_GoToTarget: addToTargetModal_GoToTarget,
    addToTargetModal_MostRecentTargets: addToTargetModal_MostRecentTargets,
    addToTargetModal_NoSectionsFound: addToTargetModal_NoSectionsFound,
    addToTargetModal_OrgManagedNotice: addToTargetModal_OrgManagedNotice,
    addToTargetModal_SearchAuthoringTarget: addToTargetModal_SearchAuthoringTarget,
    addToTargetModal_SearchYourTargets: addToTargetModal_SearchYourTargets,
    addToTargetModal_Section: addToTargetModal_Section,
    addToTargetModal_SelectPlanSection: addToTargetModal_SelectPlanSection,
    addToTargetModal_SelectSectionPlaceHolder: addToTargetModal_SelectSectionPlaceHolder,
    addToTargetModal_SelectTargetPlaceHolder: addToTargetModal_SelectTargetPlaceHolder,
    addToTargetModal_VisitTargetEditPage: addToTargetModal_VisitTargetEditPage,
    addToTargetModal_WhichTarget: addToTargetModal_WhichTarget,
    addToTargetModal_YourTargets: addToTargetModal_YourTargets,
    alertModal_DontShowAgain: alertModal_DontShowAgain,
    AnonymousUserHelper_EmailName: AnonymousUserHelper_EmailName,
    AnonymousUserHelper_Name: AnonymousUserHelper_Name,
    AppHeader_AcademiesTitle: AppHeader_AcademiesTitle,
    AppHeader_BrowseTitle: AppHeader_BrowseTitle,
    AppHeader_DgAssistantTitle: AppHeader_DgAssistantTitle,
    AppHeader_FeaturedTitle: AppHeader_FeaturedTitle,
    AppHeader_HomeTitle: AppHeader_HomeTitle,
    AppHeader_Login: AppHeader_Login,
    AppHeader_MaestroTitle: AppHeader_MaestroTitle,
    AppHeader_OpportunitiesTitle: AppHeader_OpportunitiesTitle,
    AppHeader_ProfileTitle: AppHeader_ProfileTitle,
    AppHeader_Signup: AppHeader_Signup,
    AppHeader_SkillCoachTitle: AppHeader_SkillCoachTitle,
    AppHeader_TeamTitle: AppHeader_TeamTitle,
    AssessmentFormCtrl_AddAssessment: AssessmentFormCtrl_AddAssessment,
    AssessmentFormCtrl_AddToCatalogFormat: AssessmentFormCtrl_AddToCatalogFormat,
    AssessmentFormCtrl_AssessmentName: AssessmentFormCtrl_AssessmentName,
    AssessmentFormCtrl_AssessmentProvider: AssessmentFormCtrl_AssessmentProvider,
    AssessmentFormCtrl_AssessmentUrl: AssessmentFormCtrl_AssessmentUrl,
    AssessmentFormCtrl_Category: AssessmentFormCtrl_Category,
    AssessmentFormCtrl_CorrectQuestions: AssessmentFormCtrl_CorrectQuestions,
    AssessmentFormCtrl_CorrectQuestionsFormat: AssessmentFormCtrl_CorrectQuestionsFormat,
    AssessmentFormCtrl_DateCompleted: AssessmentFormCtrl_DateCompleted,
    AssessmentFormCtrl_Description: AssessmentFormCtrl_Description,
    AssessmentFormCtrl_EditAssessment: AssessmentFormCtrl_EditAssessment,
    AssessmentFormCtrl_NameRequired: AssessmentFormCtrl_NameRequired,
    AssessmentFormCtrl_NumberOfQuestions: AssessmentFormCtrl_NumberOfQuestions,
    AssessmentFormCtrl_NumberOfQuestionsError: AssessmentFormCtrl_NumberOfQuestionsError,
    AssessmentFormCtrl_Percentile: AssessmentFormCtrl_Percentile,
    AssessmentFormCtrl_SaveAssessment: AssessmentFormCtrl_SaveAssessment,
    AssessmentFormCtrl_TotalQuestions: AssessmentFormCtrl_TotalQuestions,
    AssessmentFormCtrl_UrlRequired: AssessmentFormCtrl_UrlRequired,
    AssessmentFormCtrl_WhatDidYouLearnLong: AssessmentFormCtrl_WhatDidYouLearnLong,
    AssessmentFormCtrl_WhatDidYouLearnShort: AssessmentFormCtrl_WhatDidYouLearnShort,
    assignedLearning_AlreadyAttendAssignedByFormat: assignedLearning_AlreadyAttendAssignedByFormat,
    assignedLearning_AlreadyCompletedAssignedByFormat: assignedLearning_AlreadyCompletedAssignedByFormat,
    assignedLearning_AlreadyFollowAssignedByFormat: assignedLearning_AlreadyFollowAssignedByFormat,
    assignedLearning_AlreadyReadAssignedByFormat: assignedLearning_AlreadyReadAssignedByFormat,
    assignedLearning_AlreadyWatchedAssignedByFormat: assignedLearning_AlreadyWatchedAssignedByFormat,
    assignedLearning_Completed: assignedLearning_Completed,
    assignedLearning_CompletedNoDate: assignedLearning_CompletedNoDate,
    assignedLearning_DueLater: assignedLearning_DueLater,
    assignedLearning_DueLaterExternal: assignedLearning_DueLaterExternal,
    assignedLearning_DueLaterGroup: assignedLearning_DueLaterGroup,
    assignedLearning_DueSoon: assignedLearning_DueSoon,
    assignedLearning_GroupAlreadyAttendedFormat: assignedLearning_GroupAlreadyAttendedFormat,
    assignedLearning_GroupAlreadyAttendedFormerLearnerFormat: assignedLearning_GroupAlreadyAttendedFormerLearnerFormat,
    assignedLearning_GroupAlreadyCompletedDateFormat: assignedLearning_GroupAlreadyCompletedDateFormat,
    assignedLearning_GroupAlreadyCompletedDateFormerLearnerFormat: assignedLearning_GroupAlreadyCompletedDateFormerLearnerFormat,
    assignedLearning_GroupAlreadyCompletedFormat: assignedLearning_GroupAlreadyCompletedFormat,
    assignedLearning_GroupAlreadyCompletedFormerLearnerFormat: assignedLearning_GroupAlreadyCompletedFormerLearnerFormat,
    assignedLearning_GroupAlreadyCompletedNoDateFormat: assignedLearning_GroupAlreadyCompletedNoDateFormat,
    assignedLearning_GroupAlreadyCompletedNoDateFormerLearnerFormat: assignedLearning_GroupAlreadyCompletedNoDateFormerLearnerFormat,
    assignedLearning_GroupAlreadyFollowedFormat: assignedLearning_GroupAlreadyFollowedFormat,
    assignedLearning_GroupAlreadyFollowedFormerLearnerFormat: assignedLearning_GroupAlreadyFollowedFormerLearnerFormat,
    assignedLearning_GroupAlreadyReadFormat: assignedLearning_GroupAlreadyReadFormat,
    assignedLearning_GroupAlreadyReadFormerLearnerFormat: assignedLearning_GroupAlreadyReadFormerLearnerFormat,
    assignedLearning_GroupAlreadyWatchedFormat: assignedLearning_GroupAlreadyWatchedFormat,
    assignedLearning_GroupAlreadyWatchedFormerLearnerFormat: assignedLearning_GroupAlreadyWatchedFormerLearnerFormat,
    assignedLearning_GroupAttendedFormat: assignedLearning_GroupAttendedFormat,
    assignedLearning_GroupAttendedFormerLearnerFormat: assignedLearning_GroupAttendedFormerLearnerFormat,
    assignedLearning_GroupCompletedFormat: assignedLearning_GroupCompletedFormat,
    assignedLearning_GroupCompletedFormerLearnerFormat: assignedLearning_GroupCompletedFormerLearnerFormat,
    assignedLearning_GroupDateFormat: assignedLearning_GroupDateFormat,
    assignedLearning_GroupDateFormerLearnerFormat: assignedLearning_GroupDateFormerLearnerFormat,
    assignedLearning_GroupFollowedFormat: assignedLearning_GroupFollowedFormat,
    assignedLearning_GroupFollowedFormerLearnerFormat: assignedLearning_GroupFollowedFormerLearnerFormat,
    assignedLearning_GroupNoDateFormat: assignedLearning_GroupNoDateFormat,
    assignedLearning_GroupNoDateFormerLearnerFormat: assignedLearning_GroupNoDateFormerLearnerFormat,
    assignedLearning_GroupReadFormat: assignedLearning_GroupReadFormat,
    assignedLearning_GroupReadFormerLearnerFormat: assignedLearning_GroupReadFormerLearnerFormat,
    assignedLearning_GroupWatchedFormat: assignedLearning_GroupWatchedFormat,
    assignedLearning_GroupWatchedFormerLearnerFormat: assignedLearning_GroupWatchedFormerLearnerFormat,
    assignedLearning_NoDueDate: assignedLearning_NoDueDate,
    assignedLearning_NoDueDateExternal: assignedLearning_NoDueDateExternal,
    assignedLearning_Overdue: assignedLearning_Overdue,
    assignedLearning_RequiredLearningTimeTip: assignedLearning_RequiredLearningTimeTip,
    assignedLearning_YouAlreadyAttendedFormat: assignedLearning_YouAlreadyAttendedFormat,
    assignedLearning_YouAlreadyAttendedFormerLearnerFormat: assignedLearning_YouAlreadyAttendedFormerLearnerFormat,
    assignedLearning_YouAlreadyCompletedDateFormat: assignedLearning_YouAlreadyCompletedDateFormat,
    assignedLearning_YouAlreadyCompletedDateFormerLearnerFormat: assignedLearning_YouAlreadyCompletedDateFormerLearnerFormat,
    assignedLearning_YouAlreadyCompletedFormat: assignedLearning_YouAlreadyCompletedFormat,
    assignedLearning_YouAlreadyCompletedFormerLearnerFormat: assignedLearning_YouAlreadyCompletedFormerLearnerFormat,
    assignedLearning_YouAlreadyCompletedFormerLearnerNoDateFormat: assignedLearning_YouAlreadyCompletedFormerLearnerNoDateFormat,
    assignedLearning_YouAlreadyCompletedNoDateFormat: assignedLearning_YouAlreadyCompletedNoDateFormat,
    assignedLearning_YouAlreadyFollowedFormat: assignedLearning_YouAlreadyFollowedFormat,
    assignedLearning_YouAlreadyFollowedFormerLearnerFormat: assignedLearning_YouAlreadyFollowedFormerLearnerFormat,
    assignedLearning_YouAlreadyReadFormat: assignedLearning_YouAlreadyReadFormat,
    assignedLearning_YouAlreadyReadFormerLearnerFormat: assignedLearning_YouAlreadyReadFormerLearnerFormat,
    assignedLearning_YouAlreadyWatchedFormat: assignedLearning_YouAlreadyWatchedFormat,
    assignedLearning_YouAlreadyWatchedFormerLearnerFormat: assignedLearning_YouAlreadyWatchedFormerLearnerFormat,
    assignedLearning_YouAttendedFormat: assignedLearning_YouAttendedFormat,
    assignedLearning_YouAttendedFormerLearnerFormat: assignedLearning_YouAttendedFormerLearnerFormat,
    assignedLearning_YouCompletedFormat: assignedLearning_YouCompletedFormat,
    assignedLearning_YouCompletedFormerLearnerFormat: assignedLearning_YouCompletedFormerLearnerFormat,
    assignedLearning_YouDateFormat: assignedLearning_YouDateFormat,
    assignedLearning_YouDateFormerLearnerFormat: assignedLearning_YouDateFormerLearnerFormat,
    assignedLearning_YouFollowedFormat: assignedLearning_YouFollowedFormat,
    assignedLearning_YouFollowedFormerLearnerFormat: assignedLearning_YouFollowedFormerLearnerFormat,
    assignedLearning_YouNoDateFormat: assignedLearning_YouNoDateFormat,
    assignedLearning_YouNoDateFormerLearnerFormat: assignedLearning_YouNoDateFormerLearnerFormat,
    assignedLearning_YouReadFormat: assignedLearning_YouReadFormat,
    assignedLearning_YouReadFormerLearnerFormat: assignedLearning_YouReadFormerLearnerFormat,
    assignedLearning_YouWatchedFormat: assignedLearning_YouWatchedFormat,
    assignedLearning_YouWatchedFormerLearnerFormat: assignedLearning_YouWatchedFormerLearnerFormat,
    Attributes_AddHiddenAttributes: Attributes_AddHiddenAttributes,
    Attributes_Attribute: Attributes_Attribute,
    Attributes_AttributeDataType: Attributes_AttributeDataType,
    Attributes_AttributeFeatureName: Attributes_AttributeFeatureName,
    Attributes_AttributeFilterLabel: Attributes_AttributeFilterLabel,
    Attributes_AttributeFilterModal_AddButton: Attributes_AttributeFilterModal_AddButton,
    Attributes_AttributeFilterModal_AttributeFieldLabel: Attributes_AttributeFilterModal_AttributeFieldLabel,
    Attributes_AttributeFilterModal_AttributeFieldPlaceHolder: Attributes_AttributeFilterModal_AttributeFieldPlaceHolder,
    Attributes_AttributeFilterModal_OperatorFieldLabel: Attributes_AttributeFilterModal_OperatorFieldLabel,
    Attributes_AttributeFilterModal_OperatorFieldPlaceHolder: Attributes_AttributeFilterModal_OperatorFieldPlaceHolder,
    Attributes_AttributeFilterModal_Title: Attributes_AttributeFilterModal_Title,
    Attributes_AttributeFilterModal_ValuesFieldHint: Attributes_AttributeFilterModal_ValuesFieldHint,
    Attributes_AttributeFilterModal_ValuesFieldLabel: Attributes_AttributeFilterModal_ValuesFieldLabel,
    Attributes_AttributesDescription: Attributes_AttributesDescription,
    Attributes_AttributesHeading: Attributes_AttributesHeading,
    Attributes_AttributesLabel: Attributes_AttributesLabel,
    Attributes_AttributeSource: Attributes_AttributeSource,
    Attributes_Bool: Attributes_Bool,
    Attributes_BusinessRules: Attributes_BusinessRules,
    Attributes_Custom: Attributes_Custom,
    Attributes_CustomAttributes: Attributes_CustomAttributes,
    Attributes_CustomAttributesDescription: Attributes_CustomAttributesDescription,
    Attributes_CustomData: Attributes_CustomData,
    Attributes_DataType: Attributes_DataType,
    Attributes_DataTypes_Description: Attributes_DataTypes_Description,
    Attributes_DateTime: Attributes_DateTime,
    Attributes_DateTimeOLD: Attributes_DateTimeOLD,
    Attributes_DefaultVisibility: Attributes_DefaultVisibility,
    Attributes_DefaultVisibilityDescription: Attributes_DefaultVisibilityDescription,
    Attributes_EditAttributeSettings: Attributes_EditAttributeSettings,
    Attributes_Feature_BusinessRules: Attributes_Feature_BusinessRules,
    Attributes_Feature_Segments: Attributes_Feature_Segments,
    Attributes_FeatureVisibility: Attributes_FeatureVisibility,
    Attributes_FeatureVisibility_Description: Attributes_FeatureVisibility_Description,
    Attributes_FieldType_Datetime: Attributes_FieldType_Datetime,
    Attributes_FieldType_Number: Attributes_FieldType_Number,
    Attributes_FieldType_String: Attributes_FieldType_String,
    Attributes_IncomingField: Attributes_IncomingField,
    Attributes_IncomingFields: Attributes_IncomingFields,
    Attributes_Instructions: Attributes_Instructions,
    Attributes_NoMatches: Attributes_NoMatches,
    Attributes_NoResults: Attributes_NoResults,
    Attributes_NoVisibleAttributes: Attributes_NoVisibleAttributes,
    Attributes_NoVisibleAttributesInstructions: Attributes_NoVisibleAttributesInstructions,
    Attributes_Number: Attributes_Number,
    Attributes_NumberOLD: Attributes_NumberOLD,
    Attributes_RemoveAttributeFormat: Attributes_RemoveAttributeFormat,
    Attributes_Segments: Attributes_Segments,
    Attributes_Standard: Attributes_Standard,
    Attributes_StandardAttributes: Attributes_StandardAttributes,
    Attributes_StandardAttributesInstructions: Attributes_StandardAttributesInstructions,
    Attributes_StandardCustom: Attributes_StandardCustom,
    Attributes_String: Attributes_String,
    Attributes_StringOLD: Attributes_StringOLD,
    Attributes_UserAttributes: Attributes_UserAttributes,
    Attributes_UserAttributesDescription: Attributes_UserAttributesDescription,
    Attributes_VisibleAttributes: Attributes_VisibleAttributes,
    Attributes_VisibleAttributesDescription: Attributes_VisibleAttributesDescription,
    Attributes_Warning_ConversionResultsInDataLoss_Format: Attributes_Warning_ConversionResultsInDataLoss_Format,
    Attributes_Warning_InvalidConversionToBoolean: Attributes_Warning_InvalidConversionToBoolean,
    Attributes_Warning_InvalidConversionToDateTime: Attributes_Warning_InvalidConversionToDateTime,
    Attributes_Warning_InvalidConversionToNumber: Attributes_Warning_InvalidConversionToNumber,
    Attributes_Warning_TypeMismatch_Format: Attributes_Warning_TypeMismatch_Format,
    Automation_AcademyConditions: Automation_AcademyConditions,
    Automation_AcademyConditions_Description: Automation_AcademyConditions_Description,
    Automation_AcademyName: Automation_AcademyName,
    Automation_AcademyStatus_Completed: Automation_AcademyStatus_Completed,
    Automation_AcademyStatus_Dropped: Automation_AcademyStatus_Dropped,
    Automation_AcademyStatus_InProgress: Automation_AcademyStatus_InProgress,
    Automation_AcademyStatus_NotStarted: Automation_AcademyStatus_NotStarted,
    Automation_AcmAddUser_Format: Automation_AcmAddUser_Format,
    Automation_AcmDeleteUser_Format: Automation_AcmDeleteUser_Format,
    Automation_AcmSelectRole: Automation_AcmSelectRole,
    Automation_Action: Automation_Action,
    Automation_Action_Delete: Automation_Action_Delete,
    Automation_Action_Insert: Automation_Action_Insert,
    Automation_Action_Update: Automation_Action_Update,
    Automation_ActionDeleted: Automation_ActionDeleted,
    Automation_ActionDesc: Automation_ActionDesc,
    Automation_ActionHasBeenAdded: Automation_ActionHasBeenAdded,
    Automation_ActionHasNotBeenAdded: Automation_ActionHasNotBeenAdded,
    Automation_ActionLabel_Group: Automation_ActionLabel_Group,
    Automation_ActionLabel_Pathway: Automation_ActionLabel_Pathway,
    Automation_ActionLabel_PermissionRole: Automation_ActionLabel_PermissionRole,
    Automation_ActionLabel_Privacy: Automation_ActionLabel_Privacy,
    Automation_ActionLabel_Provider: Automation_ActionLabel_Provider,
    Automation_ActionLabel_Skill: Automation_ActionLabel_Skill,
    Automation_ActionLabel_Target: Automation_ActionLabel_Target,
    Automation_ActionNoConfigurationNeeded: Automation_ActionNoConfigurationNeeded,
    Automation_Actions: Automation_Actions,
    Automation_AddAcademyCondition: Automation_AddAcademyCondition,
    Automation_AddGroupCondition: Automation_AddGroupCondition,
    Automation_AddProviderLicense_Format: Automation_AddProviderLicense_Format,
    Automation_AddRole_Format: Automation_AddRole_Format,
    Automation_AddSkill_Format: Automation_AddSkill_Format,
    Automation_AddSkillCondition: Automation_AddSkillCondition,
    Automation_AddSkillPlan_Format: Automation_AddSkillPlan_Format,
    Automation_AddToGroup_Format: Automation_AddToGroup_Format,
    Automation_AddToPathway_Format: Automation_AddToPathway_Format,
    Automation_AreYouSure_DeleteAutomations_Format: Automation_AreYouSure_DeleteAutomations_Format,
    Automation_AssignedBy_Format: Automation_AssignedBy_Format,
    Automation_AssignedByInDays_Format: Automation_AssignedByInDays_Format,
    Automation_AssignResource_Format: Automation_AssignResource_Format,
    Automation_AttributeValue_HelperText: Automation_AttributeValue_HelperText,
    Automation_Automation: Automation_Automation,
    Automation_AutomationBuilder: Automation_AutomationBuilder,
    Automation_AutomationCreated: Automation_AutomationCreated,
    Automation_AutomationDetails: Automation_AutomationDetails,
    Automation_AutomationDisabled: Automation_AutomationDisabled,
    Automation_AutomationEnabled: Automation_AutomationEnabled,
    Automation_AutomationLastUpdated: Automation_AutomationLastUpdated,
    Automation_AutomationName: Automation_AutomationName,
    Automation_Automations: Automation_Automations,
    Automation_AutomationUpdated: Automation_AutomationUpdated,
    Automation_BulkEnable_SomeRulesInvalidWarning: Automation_BulkEnable_SomeRulesInvalidWarning,
    Automation_CadenceDailyTime_Format: Automation_CadenceDailyTime_Format,
    Automation_CadenceDateTime_Format: Automation_CadenceDateTime_Format,
    Automation_CadenceDayOfTime_Format: Automation_CadenceDayOfTime_Format,
    Automation_CadenceOnceTime_Format: Automation_CadenceOnceTime_Format,
    Automation_CannotEnableAtThisTime: Automation_CannotEnableAtThisTime,
    Automation_ChangeDetails: Automation_ChangeDetails,
    Automation_ChangedTo: Automation_ChangedTo,
    Automation_Changes: Automation_Changes,
    Automation_Changes_Format: Automation_Changes_Format,
    Automation_CloneAutomation: Automation_CloneAutomation,
    Automation_CloneAutomationFormat: Automation_CloneAutomationFormat,
    Automation_Communication: Automation_Communication,
    Automation_ConditionHelp: Automation_ConditionHelp,
    Automation_ConditionsLimit: Automation_ConditionsLimit,
    Automation_CreateAnAutomation: Automation_CreateAnAutomation,
    Automation_CreateYourFirst_Description: Automation_CreateYourFirst_Description,
    Automation_CreateYourFirst_Header: Automation_CreateYourFirst_Header,
    Automation_CurrentlyEditingTitleAndDescription: Automation_CurrentlyEditingTitleAndDescription,
    Automation_CurrentlyEditingTriggers: Automation_CurrentlyEditingTriggers,
    Automation_DateUpdated: Automation_DateUpdated,
    Automation_DeleteAction: Automation_DeleteAction,
    Automation_DeleteActionConfirmation: Automation_DeleteActionConfirmation,
    Automation_DeleteAutomation: Automation_DeleteAutomation,
    Automation_DeleteAutomations: Automation_DeleteAutomations,
    Automation_DeleteConditions: Automation_DeleteConditions,
    Automation_DeleteConditions_Confirmation: Automation_DeleteConditions_Confirmation,
    Automation_DeleteOnlyActionConfirmation: Automation_DeleteOnlyActionConfirmation,
    Automation_DeleteUser_Format: Automation_DeleteUser_Format,
    Automation_Description: Automation_Description,
    Automation_Description_Delete: Automation_Description_Delete,
    Automation_Description_Insert: Automation_Description_Insert,
    Automation_Description_Update: Automation_Description_Update,
    Automation_DisableAutomations: Automation_DisableAutomations,
    Automation_DisableAutomations_Format: Automation_DisableAutomations_Format,
    Automation_DueDate_None: Automation_DueDate_None,
    Automation_DueDate_Relative: Automation_DueDate_Relative,
    Automation_DueDate_Specific: Automation_DueDate_Specific,
    Automation_EditableAttributeWarning: Automation_EditableAttributeWarning,
    Automation_EditableAttributeWarning_Format: Automation_EditableAttributeWarning_Format,
    Automation_EditAutomation: Automation_EditAutomation,
    Automation_EditTitleAndDescription: Automation_EditTitleAndDescription,
    Automation_EditTrigger: Automation_EditTrigger,
    Automation_EnableAutomation: Automation_EnableAutomation,
    Automation_EnableAutomationDescription: Automation_EnableAutomationDescription,
    Automation_EnableAutomations: Automation_EnableAutomations,
    Automation_EnableAutomations_Format: Automation_EnableAutomations_Format,
    Automation_EnabledOrDisabled: Automation_EnabledOrDisabled,
    Automation_Event_ContentCompleted: Automation_Event_ContentCompleted,
    Automation_Event_GroupJoined: Automation_Event_GroupJoined,
    Automation_Event_MentorshipCompleted: Automation_Event_MentorshipCompleted,
    Automation_Event_OnboardingCompleted: Automation_Event_OnboardingCompleted,
    Automation_Event_OpportunityMentorRequested: Automation_Event_OpportunityMentorRequested,
    Automation_Event_PathwayCompleted: Automation_Event_PathwayCompleted,
    Automation_Event_PathwayEnrolled: Automation_Event_PathwayEnrolled,
    Automation_Event_PlanFollowed: Automation_Event_PlanFollowed,
    Automation_Event_ProviderLicenseAssign: Automation_Event_ProviderLicenseAssign,
    Automation_Event_UserAddsSkill: Automation_Event_UserAddsSkill,
    Automation_Event_UserUpdatestoFocusSkill: Automation_Event_UserUpdatestoFocusSkill,
    Automation_FormerUser: Automation_FormerUser,
    Automation_GroupConditions: Automation_GroupConditions,
    Automation_GroupNameHelper: Automation_GroupNameHelper,
    Automation_HistoryAvailableNotification: Automation_HistoryAvailableNotification,
    Automation_HistoryLastUpdated: Automation_HistoryLastUpdated,
    Automation_IsNotOneOf: Automation_IsNotOneOf,
    Automation_IsOneOf: Automation_IsOneOf,
    Automation_Log_Detail_Entry_Format: Automation_Log_Detail_Entry_Format,
    Automation_LogTable_Summary: Automation_LogTable_Summary,
    Automation_Name_Delete: Automation_Name_Delete,
    Automation_Name_Insert: Automation_Name_Insert,
    Automation_Name_Update: Automation_Name_Update,
    Automation_NameAndDescription: Automation_NameAndDescription,
    Automation_NewAutomation: Automation_NewAutomation,
    Automation_NoDescription: Automation_NoDescription,
    Automation_NotificationSubject: Automation_NotificationSubject,
    Automation_NotifyUser_Format: Automation_NotifyUser_Format,
    Automation_NoWarning: Automation_NoWarning,
    Automation_Or_List_Format: Automation_Or_List_Format,
    Automation_Outcome_Delete: Automation_Outcome_Delete,
    Automation_Outcome_Insert: Automation_Outcome_Insert,
    Automation_Outcome_Update: Automation_Outcome_Update,
    Automation_Predicate_Delete: Automation_Predicate_Delete,
    Automation_Predicate_Insert: Automation_Predicate_Insert,
    Automation_Predicate_Update: Automation_Predicate_Update,
    Automation_PredicateLabel_ContentCompleted: Automation_PredicateLabel_ContentCompleted,
    Automation_PredicateLabel_GroupJoined: Automation_PredicateLabel_GroupJoined,
    Automation_PredicateLabel_MentorshipCompleted: Automation_PredicateLabel_MentorshipCompleted,
    Automation_PredicateLabel_PathwayCompleted: Automation_PredicateLabel_PathwayCompleted,
    Automation_PredicateLabel_PathwayEnrolled: Automation_PredicateLabel_PathwayEnrolled,
    Automation_PredicateLabel_PlanFollowed: Automation_PredicateLabel_PlanFollowed,
    Automation_PredicateLabel_ProviderLicenseAssign: Automation_PredicateLabel_ProviderLicenseAssign,
    Automation_PredicateLabel_UserAddsSkill: Automation_PredicateLabel_UserAddsSkill,
    Automation_PredicateLabel_UserUpdatestoFocusSkill: Automation_PredicateLabel_UserUpdatestoFocusSkill,
    Automation_PredicateType_Academy: Automation_PredicateType_Academy,
    Automation_PredicateType_Attribute: Automation_PredicateType_Attribute,
    Automation_PredicateType_Description_Academy: Automation_PredicateType_Description_Academy,
    Automation_PredicateType_Description_Attribute: Automation_PredicateType_Description_Attribute,
    Automation_PredicateType_Description_Group: Automation_PredicateType_Description_Group,
    Automation_PredicateType_Description_Skill: Automation_PredicateType_Description_Skill,
    Automation_PredicateType_Group: Automation_PredicateType_Group,
    Automation_PredicateType_Skill: Automation_PredicateType_Skill,
    Automation_RemoveCondition_Format: Automation_RemoveCondition_Format,
    Automation_RemoveEmptyCondition: Automation_RemoveEmptyCondition,
    Automation_SaveOrCancelFirst: Automation_SaveOrCancelFirst,
    Automation_Schedule_Cadence: Automation_Schedule_Cadence,
    Automation_Schedule_Daily: Automation_Schedule_Daily,
    Automation_Schedule_Daily_Format: Automation_Schedule_Daily_Format,
    Automation_Schedule_Date: Automation_Schedule_Date,
    Automation_Schedule_Day: Automation_Schedule_Day,
    Automation_Schedule_Last: Automation_Schedule_Last,
    Automation_Schedule_LastDayOfMonth: Automation_Schedule_LastDayOfMonth,
    Automation_Schedule_Monthly: Automation_Schedule_Monthly,
    Automation_Schedule_Monthly_Format: Automation_Schedule_Monthly_Format,
    Automation_Schedule_Once: Automation_Schedule_Once,
    Automation_Schedule_Once_Format: Automation_Schedule_Once_Format,
    Automation_Schedule_Ordinal_1: Automation_Schedule_Ordinal_1,
    Automation_Schedule_Ordinal_10: Automation_Schedule_Ordinal_10,
    Automation_Schedule_Ordinal_15: Automation_Schedule_Ordinal_15,
    Automation_Schedule_Ordinal_20: Automation_Schedule_Ordinal_20,
    Automation_Schedule_Ordinal_25: Automation_Schedule_Ordinal_25,
    Automation_Schedule_Ordinal_5: Automation_Schedule_Ordinal_5,
    Automation_Schedule_SelectCadence: Automation_Schedule_SelectCadence,
    Automation_Schedule_SelectDate: Automation_Schedule_SelectDate,
    Automation_Schedule_SelectDay: Automation_Schedule_SelectDay,
    Automation_Schedule_SelectTime: Automation_Schedule_SelectTime,
    Automation_Schedule_TimeUTC: Automation_Schedule_TimeUTC,
    Automation_Schedule_Weekly: Automation_Schedule_Weekly,
    Automation_Schedule_Weekly_Format: Automation_Schedule_Weekly_Format,
    Automation_Search_Placeholder: Automation_Search_Placeholder,
    Automation_SearchAcademy: Automation_SearchAcademy,
    Automation_SelectAction: Automation_SelectAction,
    Automation_SelectConditionType: Automation_SelectConditionType,
    Automation_SelectConditionType_Description: Automation_SelectConditionType_Description,
    Automation_SelectSkillCondition: Automation_SelectSkillCondition,
    Automation_SelectStatuses: Automation_SelectStatuses,
    Automation_SelectTrigger: Automation_SelectTrigger,
    Automation_SendEmail_Format: Automation_SendEmail_Format,
    Automation_SetProfilePrivacy_Format: Automation_SetProfilePrivacy_Format,
    Automation_SharedBy_Format: Automation_SharedBy_Format,
    Automation_ShareResource_Format: Automation_ShareResource_Format,
    Automation_SkillCondition: Automation_SkillCondition,
    Automation_SkillCondition_AddOptionalSkills: Automation_SkillCondition_AddOptionalSkills,
    Automation_SkillConditions: Automation_SkillConditions,
    Automation_SkillConditions_Description: Automation_SkillConditions_Description,
    Automation_SkillName: Automation_SkillName,
    Automation_SkillNameHelper: Automation_SkillNameHelper,
    Automation_SkillOperator_hasnofocusskills: Automation_SkillOperator_hasnofocusskills,
    Automation_SkillOperator_hasnoskillrating: Automation_SkillOperator_hasnoskillrating,
    Automation_SkillOperator_hasnoskills: Automation_SkillOperator_hasnoskills,
    Automation_SkillOperator_hasnoskillsrating: Automation_SkillOperator_hasnoskillsrating,
    Automation_SkillTimeFrame: Automation_SkillTimeFrame,
    Automation_SkillTimeFrame_AllTime: Automation_SkillTimeFrame_AllTime,
    Automation_SkillTimeFrame_WithinDays: Automation_SkillTimeFrame_WithinDays,
    Automation_Status_Update: Automation_Status_Update,
    Automation_Then: Automation_Then,
    Automation_TimeUpdated: Automation_TimeUpdated,
    Automation_Trigger: Automation_Trigger,
    Automation_Trigger_Delete: Automation_Trigger_Delete,
    Automation_Trigger_Insert: Automation_Trigger_Insert,
    Automation_Trigger_Scheduled: Automation_Trigger_Scheduled,
    Automation_Trigger_Update: Automation_Trigger_Update,
    Automation_Trigger_UserCreated: Automation_Trigger_UserCreated,
    Automation_Trigger_UserRecordReceived: Automation_Trigger_UserRecordReceived,
    Automation_TriggerHasBeenAdded: Automation_TriggerHasBeenAdded,
    Automation_TriggerHasNotBeenAdded: Automation_TriggerHasNotBeenAdded,
    Automation_TriggerHelp: Automation_TriggerHelp,
    Automation_TriggerNoConfigurationNeeded: Automation_TriggerNoConfigurationNeeded,
    Automation_TriggersAndActionsRequired: Automation_TriggersAndActionsRequired,
    Automation_UntitledAutomation: Automation_UntitledAutomation,
    Automation_UpdatedBy: Automation_UpdatedBy,
    Automation_UserAcademyStatus: Automation_UserAcademyStatus,
    Automation_UserAcademyStatus_Helper: Automation_UserAcademyStatus_Helper,
    Automation_UserActivity: Automation_UserActivity,
    Automation_UserAssignmentDescription: Automation_UserAssignmentDescription,
    Automation_UserAttribute: Automation_UserAttribute,
    Automation_UserConditions: Automation_UserConditions,
    Automation_UserConditions_Header: Automation_UserConditions_Header,
    Automation_UserEvents: Automation_UserEvents,
    Automation_UserManagement: Automation_UserManagement,
    Automation_UserMeetsConditions: Automation_UserMeetsConditions,
    Automation_UserMeetsConditions_Academy: Automation_UserMeetsConditions_Academy,
    Automation_UserMeetsConditions_Attribute: Automation_UserMeetsConditions_Attribute,
    Automation_UserMeetsConditions_Group: Automation_UserMeetsConditions_Group,
    Automation_UserMeetsConditions_Skill: Automation_UserMeetsConditions_Skill,
    Automation_UserNotificationDescription: Automation_UserNotificationDescription,
    Automation_UserShareDescription: Automation_UserShareDescription,
    Automation_ViewHistory: Automation_ViewHistory,
    Automation_Warning: Automation_Warning,
    Automation_Warning_RequiredBeforeSaving: Automation_Warning_RequiredBeforeSaving,
    Automation_When: Automation_When,
    AwardFormCtrl_AddAward: AwardFormCtrl_AddAward,
    AwardFormCtrl_AwardDate: AwardFormCtrl_AwardDate,
    AwardFormCtrl_AwardDateLabel: AwardFormCtrl_AwardDateLabel,
    AwardFormCtrl_AwardIssuer: AwardFormCtrl_AwardIssuer,
    AwardFormCtrl_AwardTitle: AwardFormCtrl_AwardTitle,
    AwardFormCtrl_AwardTitleLabel: AwardFormCtrl_AwardTitleLabel,
    AwardFormCtrl_SaveAward: AwardFormCtrl_SaveAward,
    BadgeFormCtrl_BadgeHelpText: BadgeFormCtrl_BadgeHelpText,
    BadgeFormCtrl_BadgeInfoText: BadgeFormCtrl_BadgeInfoText,
    BadgeFormCtrl_BadgeInvalidBadge: BadgeFormCtrl_BadgeInvalidBadge,
    BadgeFormCtrl_BadgeUrl: BadgeFormCtrl_BadgeUrl,
    Banner_IE11Body: Banner_IE11Body,
    Banner_IE11Title: Banner_IE11Title,
    Banner_LoggedOutCTA: Banner_LoggedOutCTA,
    Banner_LoggedOutCTAButton: Banner_LoggedOutCTAButton,
    behaviorForm_AddEvidence: behaviorForm_AddEvidence,
    behaviorForm_AppliedForFormat: behaviorForm_AppliedForFormat,
    behaviorForm_B1Credential: behaviorForm_B1Credential,
    behaviorForm_B1Evidence: behaviorForm_B1Evidence,
    behaviorForm_B1Example: behaviorForm_B1Example,
    behaviorForm_B1Process: behaviorForm_B1Process,
    behaviorForm_B1Title: behaviorForm_B1Title,
    behaviorForm_B2Credential: behaviorForm_B2Credential,
    behaviorForm_B2Example: behaviorForm_B2Example,
    behaviorForm_B2Process: behaviorForm_B2Process,
    behaviorForm_B2Title: behaviorForm_B2Title,
    behaviorForm_B3Credential: behaviorForm_B3Credential,
    behaviorForm_B3Evidence: behaviorForm_B3Evidence,
    behaviorForm_B3Example: behaviorForm_B3Example,
    behaviorForm_B3Process: behaviorForm_B3Process,
    behaviorForm_B3Title: behaviorForm_B3Title,
    behaviorForm_behaviorInstruction: behaviorForm_behaviorInstruction,
    behaviorForm_behaviorsInstruction: behaviorForm_behaviorsInstruction,
    behaviorForm_BehaviorStatementsDemo: behaviorForm_BehaviorStatementsDemo,
    behaviorForm_BehaviorStatementsDemoHeader: behaviorForm_BehaviorStatementsDemoHeader,
    behaviorForm_EditTitle: behaviorForm_EditTitle,
    behaviorForm_EvaluationCriteria: behaviorForm_EvaluationCriteria,
    behaviorForm_EvaluationCriteriaHeader: behaviorForm_EvaluationCriteriaHeader,
    behaviorForm_ExampleLabel: behaviorForm_ExampleLabel,
    behaviorForm_ExamplePlaceholder: behaviorForm_ExamplePlaceholder,
    behaviorForm_Header1: behaviorForm_Header1,
    behaviorForm_Header2: behaviorForm_Header2,
    behaviorForm_Header3: behaviorForm_Header3,
    behaviorForm_ProcessLabel: behaviorForm_ProcessLabel,
    behaviorForm_ProcessPlaceholder: behaviorForm_ProcessPlaceholder,
    behaviorForm_ProvideMoreInfo: behaviorForm_ProvideMoreInfo,
    behaviorForm_ReadMore: behaviorForm_ReadMore,
    behaviorForm_ShowDemos: behaviorForm_ShowDemos,
    behaviorForm_ShowEvalCriteria: behaviorForm_ShowEvalCriteria,
    behaviorForm_TitleLabel: behaviorForm_TitleLabel,
    behaviorForm_TitleLabel1: behaviorForm_TitleLabel1,
    behaviorForm_TitleLabel2: behaviorForm_TitleLabel2,
    behaviorForm_TitleLabel3: behaviorForm_TitleLabel3,
    behaviorForm_TitlePlaceholder: behaviorForm_TitlePlaceholder,
    behaviorForm_ValidationMessage: behaviorForm_ValidationMessage,
    behaviorModal_Heading1: behaviorModal_Heading1,
    behaviorModal_Heading2: behaviorModal_Heading2,
    behaviorModal_Heading3: behaviorModal_Heading3,
    behaviorModal_Instructions: behaviorModal_Instructions,
    behaviorModal_Instructions1: behaviorModal_Instructions1,
    behaviorModal_Instructions2: behaviorModal_Instructions2,
    behaviorModal_Instructions3: behaviorModal_Instructions3,
    behaviorModal_Instructions4: behaviorModal_Instructions4,
    behaviorModal_Instructions5: behaviorModal_Instructions5,
    behaviorModal_Instructions6: behaviorModal_Instructions6,
    behaviorModal_Instructions7: behaviorModal_Instructions7,
    behaviorModal_Instructions8: behaviorModal_Instructions8,
    behaviorModalVM_Instructions: behaviorModalVM_Instructions,
    BookFormCtrl_AddBook: BookFormCtrl_AddBook,
    BookFormCtrl_AddCategory: BookFormCtrl_AddCategory,
    BookFormCtrl_BookCoverAltFormat: BookFormCtrl_BookCoverAltFormat,
    BookFormCtrl_BookLength: BookFormCtrl_BookLength,
    BookFormCtrl_BookSearchError: BookFormCtrl_BookSearchError,
    BookFormCtrl_BookTitle: BookFormCtrl_BookTitle,
    BookFormCtrl_DatePublished: BookFormCtrl_DatePublished,
    BookFormCtrl_DateRead: BookFormCtrl_DateRead,
    BookFormCtrl_EditBook: BookFormCtrl_EditBook,
    BookFormCtrl_IWroteThis: BookFormCtrl_IWroteThis,
    BookFormCtrl_Length: BookFormCtrl_Length,
    BookFormCtrl_Pages: BookFormCtrl_Pages,
    BookFormCtrl_SaveBook: BookFormCtrl_SaveBook,
    BookFormCtrl_SelectBook: BookFormCtrl_SelectBook,
    BookFormCtrl_Title: BookFormCtrl_Title,
    BookFormCtrl_WhatDidYouLearnLong: BookFormCtrl_WhatDidYouLearnLong,
    BookFormCtrl_WhatDidYouLearnShort: BookFormCtrl_WhatDidYouLearnShort,
    BooksSvc_ErrorMatchingBooks: BooksSvc_ErrorMatchingBooks,
    BreadcrumbSvc_DownloadableReports: BreadcrumbSvc_DownloadableReports,
    BreadcrumbSvc_Enrolled: BreadcrumbSvc_Enrolled,
    BreadcrumbSvc_Insights: BreadcrumbSvc_Insights,
    BreadcrumbSvc_LessonFormat: BreadcrumbSvc_LessonFormat,
    BreadcrumbSvc_SectionFormat: BreadcrumbSvc_SectionFormat,
    bulkUpdateModal_Cancel: bulkUpdateModal_Cancel,
    bulkUpdateModal_CancelProcessing: bulkUpdateModal_CancelProcessing,
    bulkUpdateModal_CreateGroups: bulkUpdateModal_CreateGroups,
    bulkUpdateModal_CreateGroupsSuccess: bulkUpdateModal_CreateGroupsSuccess,
    bulkUpdateModal_CreateRoles: bulkUpdateModal_CreateRoles,
    bulkUpdateModal_DownloadTemplate: bulkUpdateModal_DownloadTemplate,
    bulkUpdateModal_DuplicateRow: bulkUpdateModal_DuplicateRow,
    bulkUpdateModal_DuplicateRowPluralFormat: bulkUpdateModal_DuplicateRowPluralFormat,
    bulkUpdateModal_EmptyContentType: bulkUpdateModal_EmptyContentType,
    bulkUpdateModal_EmptyContentTypePluralFormat: bulkUpdateModal_EmptyContentTypePluralFormat,
    bulkUpdateModal_EmptyUpdateType: bulkUpdateModal_EmptyUpdateType,
    bulkUpdateModal_EmptyUpdateTypePluralFormat: bulkUpdateModal_EmptyUpdateTypePluralFormat,
    bulkUpdateModal_ExcelImported: bulkUpdateModal_ExcelImported,
    bulkUpdateModal_FileIsEmpty: bulkUpdateModal_FileIsEmpty,
    bulkUpdateModal_FileName: bulkUpdateModal_FileName,
    bulkUpdateModal_FirstRow: bulkUpdateModal_FirstRow,
    bulkUpdateModal_HeadingGroups: bulkUpdateModal_HeadingGroups,
    bulkUpdateModal_HeadingRolePlans: bulkUpdateModal_HeadingRolePlans,
    bulkUpdateModal_MaximumRowWidthExceeded: bulkUpdateModal_MaximumRowWidthExceeded,
    bulkUpdateModal_MaximumRowWidthExceededPluralFormat: bulkUpdateModal_MaximumRowWidthExceededPluralFormat,
    bulkUpdateModal_MissingRequiredColumn: bulkUpdateModal_MissingRequiredColumn,
    bulkUpdateModal_MissingRequiredColumnPluralFormat: bulkUpdateModal_MissingRequiredColumnPluralFormat,
    bulkUpdateModal_NotAppearRightAway: bulkUpdateModal_NotAppearRightAway,
    bulkUpdateModal_RowsAccepted: bulkUpdateModal_RowsAccepted,
    bulkUpdateModal_RowsFound: bulkUpdateModal_RowsFound,
    bulkUpdateModal_RowsWithErrors: bulkUpdateModal_RowsWithErrors,
    bulkUpdateModal_Save: bulkUpdateModal_Save,
    bulkUpdateModal_SelectAFile: bulkUpdateModal_SelectAFile,
    bulkUpdateModal_SuccessfulUpload: bulkUpdateModal_SuccessfulUpload,
    bulkUpdateModal_TotalRows: bulkUpdateModal_TotalRows,
    bulkUpdateModal_UnknownContentType: bulkUpdateModal_UnknownContentType,
    bulkUpdateModal_UnknownContentTypePluralFormat: bulkUpdateModal_UnknownContentTypePluralFormat,
    bulkUpdateModal_UnknownDataType: bulkUpdateModal_UnknownDataType,
    bulkUpdateModal_UnknownDataTypePluralFormat: bulkUpdateModal_UnknownDataTypePluralFormat,
    bulkUpdateModal_UnsupportedFileContentType: bulkUpdateModal_UnsupportedFileContentType,
    bulkUpdateModal_UnsupportedFileContentTypePluralFormat: bulkUpdateModal_UnsupportedFileContentTypePluralFormat,
    bulkUpdateModal_UploadAFile: bulkUpdateModal_UploadAFile,
    bulkUpdateModal_WillSendEmail: bulkUpdateModal_WillSendEmail,
    BusinessRules_AcmAddUser: BusinessRules_AcmAddUser,
    BusinessRules_AcmDeleteUser: BusinessRules_AcmDeleteUser,
    BusinessRules_ActionType: BusinessRules_ActionType,
    BusinessRules_AddAction: BusinessRules_AddAction,
    BusinessRules_AddAttribute: BusinessRules_AddAttribute,
    BusinessRules_AddCondition: BusinessRules_AddCondition,
    BusinessRules_AddProviderLicense: BusinessRules_AddProviderLicense,
    BusinessRules_AddRole: BusinessRules_AddRole,
    BusinessRules_AddRule: BusinessRules_AddRule,
    BusinessRules_AddSegments: BusinessRules_AddSegments,
    BusinessRules_AddSkill: BusinessRules_AddSkill,
    BusinessRules_AddSkillPlan: BusinessRules_AddSkillPlan,
    BusinessRules_AddToGroup: BusinessRules_AddToGroup,
    BusinessRules_AddToPathway: BusinessRules_AddToPathway,
    BusinessRules_And: BusinessRules_And,
    BusinessRules_ApplyToAllUsers: BusinessRules_ApplyToAllUsers,
    BusinessRules_ApplyToNewUsers: BusinessRules_ApplyToNewUsers,
    BusinessRules_AreYouSure_DeleteSegments_Format: BusinessRules_AreYouSure_DeleteSegments_Format,
    BusinessRules_AssignResource: BusinessRules_AssignResource,
    BusinessRules_AttributeInstructions: BusinessRules_AttributeInstructions,
    BusinessRules_AttributeName: BusinessRules_AttributeName,
    BusinessRules_Attributes_Column: BusinessRules_Attributes_Column,
    BusinessRules_AttributeValue: BusinessRules_AttributeValue,
    BusinessRules_BeyondDaysAgo: BusinessRules_BeyondDaysAgo,
    BusinessRules_CloneSegment: BusinessRules_CloneSegment,
    BusinessRules_CloneSegmentFormat: BusinessRules_CloneSegmentFormat,
    BusinessRules_Condition: BusinessRules_Condition,
    BusinessRules_Conditions_Column: BusinessRules_Conditions_Column,
    BusinessRules_Contains: BusinessRules_Contains,
    BusinessRules_CreateARule: BusinessRules_CreateARule,
    BusinessRules_CreateASegment: BusinessRules_CreateASegment,
    BusinessRules_CreateSegment: BusinessRules_CreateSegment,
    BusinessRules_DateCreated_Column: BusinessRules_DateCreated_Column,
    BusinessRules_DaysAgo: BusinessRules_DaysAgo,
    BusinessRules_DeleteModalBody_Format: BusinessRules_DeleteModalBody_Format,
    BusinessRules_DeleteSegments: BusinessRules_DeleteSegments,
    BusinessRules_DeleteUser: BusinessRules_DeleteUser,
    BusinessRules_DoesNotEqual: BusinessRules_DoesNotEqual,
    BusinessRules_EditRule: BusinessRules_EditRule,
    BusinessRules_EditSegment: BusinessRules_EditSegment,
    BusinessRules_Equals: BusinessRules_Equals,
    BusinessRules_Error_DuplicateRuleName: BusinessRules_Error_DuplicateRuleName,
    BusinessRules_GreaterOrEqual: BusinessRules_GreaterOrEqual,
    BusinessRules_GreaterThan: BusinessRules_GreaterThan,
    BusinessRules_If: BusinessRules_If,
    BusinessRules_LesserOrEqual: BusinessRules_LesserOrEqual,
    BusinessRules_LessThan: BusinessRules_LessThan,
    BusinessRules_ManageSegments: BusinessRules_ManageSegments,
    BusinessRules_NA: BusinessRules_NA,
    BusinessRules_NewItem_Format_AddNewSkill: BusinessRules_NewItem_Format_AddNewSkill,
    BusinessRules_NotifyUser: BusinessRules_NotifyUser,
    BusinessRules_Operator: BusinessRules_Operator,
    BusinessRules_PrivacyOutcomeWarning: BusinessRules_PrivacyOutcomeWarning,
    BusinessRules_Qualifier: BusinessRules_Qualifier,
    BusinessRules_RemoveAction: BusinessRules_RemoveAction,
    BusinessRules_RemoveCondition: BusinessRules_RemoveCondition,
    BusinessRules_RuleError_Description: BusinessRules_RuleError_Description,
    BusinessRules_RuleError_Tooltip: BusinessRules_RuleError_Tooltip,
    BusinessRules_RuleName: BusinessRules_RuleName,
    BusinessRules_SearchForProviderLicense: BusinessRules_SearchForProviderLicense,
    BusinessRules_SearchForRole: BusinessRules_SearchForRole,
    BusinessRules_SearchForSkill: BusinessRules_SearchForSkill,
    BusinessRules_SearchForSkillPlan: BusinessRules_SearchForSkillPlan,
    BusinessRules_SegmentName: BusinessRules_SegmentName,
    BusinessRules_SegmentNamePlaceholder: BusinessRules_SegmentNamePlaceholder,
    BusinessRules_SegmentsDeleted_Toast: BusinessRules_SegmentsDeleted_Toast,
    BusinessRules_SegmentSearch_Placeholder: BusinessRules_SegmentSearch_Placeholder,
    BusinessRules_SelectASegment: BusinessRules_SelectASegment,
    BusinessRules_SelectSegment: BusinessRules_SelectSegment,
    BusinessRules_SendEmail: BusinessRules_SendEmail,
    BusinessRules_SendNotification: BusinessRules_SendNotification,
    BusinessRules_SetProfilePrivacy: BusinessRules_SetProfilePrivacy,
    BusinessRules_ShareResource: BusinessRules_ShareResource,
    BusinessRules_Then: BusinessRules_Then,
    BusinessRules_ToggleActiveModalBody_ToDisable_Format: BusinessRules_ToggleActiveModalBody_ToDisable_Format,
    BusinessRules_ToggleActiveModalBody_ToEnable_Format: BusinessRules_ToggleActiveModalBody_ToEnable_Format,
    BusinessRules_ToggleActiveModalConfirm_ToDisable: BusinessRules_ToggleActiveModalConfirm_ToDisable,
    BusinessRules_ToggleActiveModalConfirm_ToEnable: BusinessRules_ToggleActiveModalConfirm_ToEnable,
    BusinessRules_ToggleActiveModalHeader_ToDisable: BusinessRules_ToggleActiveModalHeader_ToDisable,
    BusinessRules_ToggleActiveModalHeader_ToEnable: BusinessRules_ToggleActiveModalHeader_ToEnable,
    BusinessRules_Trigger_Column: BusinessRules_Trigger_Column,
    BusinessRules_Value: BusinessRules_Value,
    BusinessRules_WithinDaysAgo: BusinessRules_WithinDaysAgo,
    CertificateFormCtrl_AddCertificate: CertificateFormCtrl_AddCertificate,
    CertificateFormCtrl_CertificateNumber: CertificateFormCtrl_CertificateNumber,
    CertificateFormCtrl_EndAfterStart: CertificateFormCtrl_EndAfterStart,
    CertificateFormCtrl_ExpirationDate: CertificateFormCtrl_ExpirationDate,
    CertificateFormCtrl_ExpiryDate: CertificateFormCtrl_ExpiryDate,
    CertificateFormCtrl_IssueDate: CertificateFormCtrl_IssueDate,
    CertificateFormCtrl_IssuerName: CertificateFormCtrl_IssuerName,
    CertificateFormCtrl_IssuerNameRequired: CertificateFormCtrl_IssuerNameRequired,
    CertificateFormCtrl_IssuerURL: CertificateFormCtrl_IssuerURL,
    CertificateFormCtrl_SaveCertificate: CertificateFormCtrl_SaveCertificate,
    CertificateFormCtrl_StartDate: CertificateFormCtrl_StartDate,
    CertificateFormCtrl_TitleRequired: CertificateFormCtrl_TitleRequired,
    ChartsModule_MinimumSkillUserCountEmptyStateText_Description: ChartsModule_MinimumSkillUserCountEmptyStateText_Description,
    ChartsModule_MinimumSkillUserCountEmptyStateText_Header: ChartsModule_MinimumSkillUserCountEmptyStateText_Header,
    checkDuplicateInputs_Decision: checkDuplicateInputs_Decision,
    checkDuplicateInputs_DuplicatesFoundPlural: checkDuplicateInputs_DuplicatesFoundPlural,
    checkDuplicateInputs_DuplicatesFoundSingle: checkDuplicateInputs_DuplicatesFoundSingle,
    checkDuplicateInputs_ViewDuplicates: checkDuplicateInputs_ViewDuplicates,
    Coach_AddCoverAltFormat: Coach_AddCoverAltFormat,
    Coach_AddInputLabelText: Coach_AddInputLabelText,
    Coach_AddInputPlaceholder: Coach_AddInputPlaceholder,
    Coach_AdditionalFeedback: Coach_AdditionalFeedback,
    Coach_AddModalTitle: Coach_AddModalTitle,
    Coach_AddRequiredName: Coach_AddRequiredName,
    Coach_AllConversations: Coach_AllConversations,
    Coach_Capabilities: Coach_Capabilities,
    Coach_ChooseSkill: Coach_ChooseSkill,
    Coach_ChooseSkillNote: Coach_ChooseSkillNote,
    Coach_ClearChat: Coach_ClearChat,
    Coach_ClearChatHeader: Coach_ClearChatHeader,
    Coach_ClearChatMessage: Coach_ClearChatMessage,
    Coach_ClickToStart: Coach_ClickToStart,
    Coach_ComingSoon: Coach_ComingSoon,
    Coach_ConversationLoadError: Coach_ConversationLoadError,
    Coach_ConversationStartFailed: Coach_ConversationStartFailed,
    Coach_Copied: Coach_Copied,
    Coach_CopySuccess: Coach_CopySuccess,
    Coach_DefaultSkillReport: Coach_DefaultSkillReport,
    Coach_DeleteConversation: Coach_DeleteConversation,
    Coach_DeleteConversationAction: Coach_DeleteConversationAction,
    Coach_DeleteConversationMessage: Coach_DeleteConversationMessage,
    Coach_EndConversation: Coach_EndConversation,
    Coach_ErrorText: Coach_ErrorText,
    Coach_Evaluate: Coach_Evaluate,
    Coach_EvaluateNewSkill: Coach_EvaluateNewSkill,
    Coach_ExploreContent: Coach_ExploreContent,
    Coach_ExploreMaestro: Coach_ExploreMaestro,
    Coach_ExploreMentors: Coach_ExploreMentors,
    Coach_ExplorePathways: Coach_ExplorePathways,
    Coach_ExportError: Coach_ExportError,
    Coach_ExportSummary: Coach_ExportSummary,
    Coach_FeedbackForMessage: Coach_FeedbackForMessage,
    Coach_FeedbackHeader: Coach_FeedbackHeader,
    Coach_FeedbackOptionalText: Coach_FeedbackOptionalText,
    Coach_FeedbackUpdateError: Coach_FeedbackUpdateError,
    Coach_FeedbackUpdateSuccess: Coach_FeedbackUpdateSuccess,
    Coach_FormCtrlAreYouSure: Coach_FormCtrlAreYouSure,
    Coach_GenerateSummaryCTA: Coach_GenerateSummaryCTA,
    Coach_GenerateSummarySuccess: Coach_GenerateSummarySuccess,
    Coach_GeneratingRecommendationError: Coach_GeneratingRecommendationError,
    Coach_GeneratingSkillReport: Coach_GeneratingSkillReport,
    Coach_GeneratingSummary: Coach_GeneratingSummary,
    Coach_GetStarted: Coach_GetStarted,
    Coach_HiText: Coach_HiText,
    Coach_InputPlaceholder: Coach_InputPlaceholder,
    Coach_InstructionAllow: Coach_InstructionAllow,
    Coach_InstructionInterrupt: Coach_InstructionInterrupt,
    Coach_InstructionMicEnable: Coach_InstructionMicEnable,
    Coach_InstructionVolumeUp: Coach_InstructionVolumeUp,
    Coach_ModelAnalysis: Coach_ModelAnalysis,
    Coach_MuteMicrophone: Coach_MuteMicrophone,
    Coach_NewChat: Coach_NewChat,
    Coach_NoConversationText: Coach_NoConversationText,
    Coach_NoDataFound: Coach_NoDataFound,
    Coach_NoRecommendations: Coach_NoRecommendations,
    Coach_NoSummary: Coach_NoSummary,
    Coach_NotEnabledWarning: Coach_NotEnabledWarning,
    Coach_NoTranscriptsFound: Coach_NoTranscriptsFound,
    Coach_PinConversation: Coach_PinConversation,
    Coach_Pinned: Coach_Pinned,
    Coach_PlayPauseAllyText: Coach_PlayPauseAllyText,
    Coach_Prompts: Coach_Prompts,
    Coach_PromptsEmpty: Coach_PromptsEmpty,
    Coach_RecentConversations: Coach_RecentConversations,
    Coach_Recommendations: Coach_Recommendations,
    Coach_RecommendedContent: Coach_RecommendedContent,
    Coach_RecommendedMentors: Coach_RecommendedMentors,
    Coach_RecommendedPathways: Coach_RecommendedPathways,
    Coach_SelectSkill: Coach_SelectSkill,
    Coach_ShowAllCapabilities: Coach_ShowAllCapabilities,
    Coach_SkillEvaluationDuration: Coach_SkillEvaluationDuration,
    Coach_SkillLevelDescription: Coach_SkillLevelDescription,
    Coach_SkillReport: Coach_SkillReport,
    Coach_SkillReportModalHeader: Coach_SkillReportModalHeader,
    Coach_SkillReportModalSubHeader: Coach_SkillReportModalSubHeader,
    Coach_SkillReportSummaryHeader: Coach_SkillReportSummaryHeader,
    Coach_SkillReviewCompleted: Coach_SkillReviewCompleted,
    Coach_SpeakToInterrupt: Coach_SpeakToInterrupt,
    Coach_StartConversation: Coach_StartConversation,
    Coach_StartNewSkillReview: Coach_StartNewSkillReview,
    Coach_TextChatMode: Coach_TextChatMode,
    Coach_TextMode: Coach_TextMode,
    Coach_TotalPinned: Coach_TotalPinned,
    Coach_TrackAllConversations: Coach_TrackAllConversations,
    Coach_Transcript: Coach_Transcript,
    Coach_UnmuteMicrophone: Coach_UnmuteMicrophone,
    Coach_UpdateSkillRatings: Coach_UpdateSkillRatings,
    Coach_UploadContent: Coach_UploadContent,
    Coach_VideoTagNoSupport: Coach_VideoTagNoSupport,
    Coach_ViewMoreOptions: Coach_ViewMoreOptions,
    Coach_ViewSummary: Coach_ViewSummary,
    Coach_VirtualCoachHeader: Coach_VirtualCoachHeader,
    Coach_VoiceChatMode: Coach_VoiceChatMode,
    Coach_VoiceMode: Coach_VoiceMode,
    Coach_WelcomeBackText: Coach_WelcomeBackText,
    CommentsCtrl_DeleteComment: CommentsCtrl_DeleteComment,
    CommentsCtrl_DeleteCommentReplies: CommentsCtrl_DeleteCommentReplies,
    CommentsCtrl_DeletePost: CommentsCtrl_DeletePost,
    CommentsCtrl_EditPost: CommentsCtrl_EditPost,
    CommentsCtrl_Like: CommentsCtrl_Like,
    CommentsCtrl_Liked: CommentsCtrl_Liked,
    CommentsCtrl_PublicComment: CommentsCtrl_PublicComment,
    CommentsCtrl_PublicCommentDesc: CommentsCtrl_PublicCommentDesc,
    CommentsCtrl_Reply: CommentsCtrl_Reply,
    CommentsCtrl_Unlike: CommentsCtrl_Unlike,
    CommentsCtrl_ViewConversation: CommentsCtrl_ViewConversation,
    CommentsCtrl_YesDelete: CommentsCtrl_YesDelete,
    CommentsSvc_AccessError: CommentsSvc_AccessError,
    CommentsSvc_AccessRepliesError: CommentsSvc_AccessRepliesError,
    CommentsSvc_AddCommentError: CommentsSvc_AddCommentError,
    CommentsSvc_AddReplyError: CommentsSvc_AddReplyError,
    CommentsSvc_FlagCommentError: CommentsSvc_FlagCommentError,
    CommentsSvc_GetUsersError: CommentsSvc_GetUsersError,
    CommentsSvc_LikeError: CommentsSvc_LikeError,
    CommentsSvc_RemoveCommentError: CommentsSvc_RemoveCommentError,
    CommentsSvc_UpdateCommentError: CommentsSvc_UpdateCommentError,
    CommentsSvc_UsersTitle: CommentsSvc_UsersTitle,
    CommonMeta_AuthorContentTitle: CommonMeta_AuthorContentTitle,
    CommonMeta_CertificateDescription: CommonMeta_CertificateDescription,
    CommonMeta_CertificateTitle: CommonMeta_CertificateTitle,
    CommonMeta_DegreedInfo: CommonMeta_DegreedInfo,
    CommonMeta_EmptyProfileTitle: CommonMeta_EmptyProfileTitle,
    CommonMeta_ForMeDescription: CommonMeta_ForMeDescription,
    CommonMeta_ForMeTitle: CommonMeta_ForMeTitle,
    CommonMeta_LifelongDiploma: CommonMeta_LifelongDiploma,
    CommonMeta_PersonalProfileTitle: CommonMeta_PersonalProfileTitle,
    CommonMeta_PrivateProfileTitle: CommonMeta_PrivateProfileTitle,
    CommonMeta_ProfileOgTitle: CommonMeta_ProfileOgTitle,
    CommonMeta_TopicDescription: CommonMeta_TopicDescription,
    CommonMeta_TopicTitle: CommonMeta_TopicTitle,
    compareForm_CandidateHeader: compareForm_CandidateHeader,
    compareForm_CandidateLabel: compareForm_CandidateLabel,
    compareForm_DetailTitle: compareForm_DetailTitle,
    compareForm_Header: compareForm_Header,
    compareForm_Instructions: compareForm_Instructions,
    compareForm_Prompt: compareForm_Prompt,
    compareForm_SelectWinnerValidationMessage: compareForm_SelectWinnerValidationMessage,
    compareForm_SummaryTitle: compareForm_SummaryTitle,
    ComparisonCriteriaSvc_Accomplishments: ComparisonCriteriaSvc_Accomplishments,
    ComparisonCriteriaSvc_ProvidedInformation: ComparisonCriteriaSvc_ProvidedInformation,
    ComparisonCriteriaSvc_SkillBreadth: ComparisonCriteriaSvc_SkillBreadth,
    ComparisonCriteriaSvc_SkillMastery: ComparisonCriteriaSvc_SkillMastery,
    ComparisonRatingOptionsSvc_Capable: ComparisonRatingOptionsSvc_Capable,
    ComparisonRatingOptionsSvc_CapableDesc: ComparisonRatingOptionsSvc_CapableDesc,
    ComparisonRatingOptionsSvc_Distinguished: ComparisonRatingOptionsSvc_Distinguished,
    ComparisonRatingOptionsSvc_DistinguishedDesc: ComparisonRatingOptionsSvc_DistinguishedDesc,
    ComparisonRatingOptionsSvc_Emerging: ComparisonRatingOptionsSvc_Emerging,
    ComparisonRatingOptionsSvc_EmergingDesc: ComparisonRatingOptionsSvc_EmergingDesc,
    ComparisonRatingOptionsSvc_Experienced: ComparisonRatingOptionsSvc_Experienced,
    ComparisonRatingOptionsSvc_ExperiencedDesc: ComparisonRatingOptionsSvc_ExperiencedDesc,
    ComparisonRatingOptionsSvc_Master: ComparisonRatingOptionsSvc_Master,
    ComparisonRatingOptionsSvc_MasterDesc: ComparisonRatingOptionsSvc_MasterDesc,
    ComparisonRatingOptionsSvc_Novice: ComparisonRatingOptionsSvc_Novice,
    ComparisonRatingOptionsSvc_NoviceDesc: ComparisonRatingOptionsSvc_NoviceDesc,
    ComparisonRatingSkillOptionsSvc_Capable: ComparisonRatingSkillOptionsSvc_Capable,
    ComparisonRatingSkillOptionsSvc_CapableDesc: ComparisonRatingSkillOptionsSvc_CapableDesc,
    ComparisonRatingSkillOptionsSvc_Distinguished: ComparisonRatingSkillOptionsSvc_Distinguished,
    ComparisonRatingSkillOptionsSvc_DistinguishedDesc: ComparisonRatingSkillOptionsSvc_DistinguishedDesc,
    ComparisonRatingSkillOptionsSvc_Emerging: ComparisonRatingSkillOptionsSvc_Emerging,
    ComparisonRatingSkillOptionsSvc_EmergingDesc: ComparisonRatingSkillOptionsSvc_EmergingDesc,
    ComparisonRatingSkillOptionsSvc_Experienced: ComparisonRatingSkillOptionsSvc_Experienced,
    ComparisonRatingSkillOptionsSvc_ExperiencedDesc: ComparisonRatingSkillOptionsSvc_ExperiencedDesc,
    ComparisonRatingSkillOptionsSvc_Master: ComparisonRatingSkillOptionsSvc_Master,
    ComparisonRatingSkillOptionsSvc_MasterDesc: ComparisonRatingSkillOptionsSvc_MasterDesc,
    ComparisonRatingSkillOptionsSvc_Novice: ComparisonRatingSkillOptionsSvc_Novice,
    ComparisonRatingSkillOptionsSvc_NoviceDesc: ComparisonRatingSkillOptionsSvc_NoviceDesc,
    ComparisonSvc_RatingError: ComparisonSvc_RatingError,
    ComparisonSvc_SelectionError: ComparisonSvc_SelectionError,
    completedAssignedLearning_Format: completedAssignedLearning_Format,
    completedGoal_Single: completedGoal_Single,
    completedRecommendation_ArticleFormat: completedRecommendation_ArticleFormat,
    completedRecommendation_AssessmentFormat: completedRecommendation_AssessmentFormat,
    completedRecommendation_BookFormat: completedRecommendation_BookFormat,
    completedRecommendation_CourseFormat: completedRecommendation_CourseFormat,
    completedRecommendation_EpisodeFormat: completedRecommendation_EpisodeFormat,
    completedRecommendation_EventFormat: completedRecommendation_EventFormat,
    completedRecommendation_Format: completedRecommendation_Format,
    completedRecommendation_PathwayFormat: completedRecommendation_PathwayFormat,
    completedRecommendation_PostFormat: completedRecommendation_PostFormat,
    completedRecommendation_SkillFormat: completedRecommendation_SkillFormat,
    completedRecommendation_TargetFormat: completedRecommendation_TargetFormat,
    completedRecommendation_TaskFormat: completedRecommendation_TaskFormat,
    completedRecommendation_VideoFormat: completedRecommendation_VideoFormat,
    completedRecommendationFollow_Format: completedRecommendationFollow_Format,
    CompletedSkillRating_Format: CompletedSkillRating_Format,
    confirmModal_CancelApplicationBody: confirmModal_CancelApplicationBody,
    confirmModal_DeleteAccomplishmentBody: confirmModal_DeleteAccomplishmentBody,
    confirmModal_DeleteAccomplishmentTitle: confirmModal_DeleteAccomplishmentTitle,
    confirmModal_DeleteArticleBody: confirmModal_DeleteArticleBody,
    confirmModal_DeleteArticleTitle: confirmModal_DeleteArticleTitle,
    confirmModal_DeleteAssessmentBody: confirmModal_DeleteAssessmentBody,
    confirmModal_DeleteAssessmentTitle: confirmModal_DeleteAssessmentTitle,
    confirmModal_DeleteAwardBody: confirmModal_DeleteAwardBody,
    confirmModal_DeleteAwardTitle: confirmModal_DeleteAwardTitle,
    confirmModal_DeleteBadgeBody: confirmModal_DeleteBadgeBody,
    confirmModal_DeleteBadgeTitle: confirmModal_DeleteBadgeTitle,
    confirmModal_DeleteBookBody: confirmModal_DeleteBookBody,
    confirmModal_DeleteBookTitle: confirmModal_DeleteBookTitle,
    confirmModal_DeleteCertificateBody: confirmModal_DeleteCertificateBody,
    confirmModal_DeleteCertificateTitle: confirmModal_DeleteCertificateTitle,
    confirmModal_DeleteCourseBody: confirmModal_DeleteCourseBody,
    confirmModal_DeleteCourseTitle: confirmModal_DeleteCourseTitle,
    confirmModal_DeleteDegreeBody: confirmModal_DeleteDegreeBody,
    confirmModal_DeleteDegreeTitle: confirmModal_DeleteDegreeTitle,
    confirmModal_DeleteEpisodeBody: confirmModal_DeleteEpisodeBody,
    confirmModal_DeleteEpisodeTitle: confirmModal_DeleteEpisodeTitle,
    confirmModal_DeleteEventBody: confirmModal_DeleteEventBody,
    confirmModal_DeleteEventTitle: confirmModal_DeleteEventTitle,
    confirmModal_DeletePositionBody: confirmModal_DeletePositionBody,
    confirmModal_DeletePositionTitle: confirmModal_DeletePositionTitle,
    confirmModal_DeletePostBody: confirmModal_DeletePostBody,
    confirmModal_DeletePostTitle: confirmModal_DeletePostTitle,
    confirmModal_DeleteSkillBody: confirmModal_DeleteSkillBody,
    confirmModal_DeleteSkillTitle: confirmModal_DeleteSkillTitle,
    confirmModal_DeleteTaskBody: confirmModal_DeleteTaskBody,
    confirmModal_DeleteTaskTitle: confirmModal_DeleteTaskTitle,
    confirmModal_DeleteVideoBody: confirmModal_DeleteVideoBody,
    confirmModal_DeleteVideoTitle: confirmModal_DeleteVideoTitle,
    confirmModal_EvalCancelApplicationBody: confirmModal_EvalCancelApplicationBody,
    confirmModal_EvalRestartApplicationBody: confirmModal_EvalRestartApplicationBody,
    ContentTabs_AddArticle: ContentTabs_AddArticle,
    ContentTabs_AddPost: ContentTabs_AddPost,
    ContentTabs_AddTopicsOrSkills: ContentTabs_AddTopicsOrSkills,
    ContentTabs_AddVideo: ContentTabs_AddVideo,
    ContentTabs_EnterBookTitle: ContentTabs_EnterBookTitle,
    ContentTabs_InvalidTitle: ContentTabs_InvalidTitle,
    ContentTabs_InvalidUrl: ContentTabs_InvalidUrl,
    ContentTabs_RelatedSkills: ContentTabs_RelatedSkills,
    ContentTabs_YouAddedToProfile: ContentTabs_YouAddedToProfile,
    CookieNotice_CookieDescription_AntiforgeryrequestV4Degreed: CookieNotice_CookieDescription_AntiforgeryrequestV4Degreed,
    CookieNotice_CookieDescription_AntiforgeryV4Degreed: CookieNotice_CookieDescription_AntiforgeryV4Degreed,
    CookieNotice_CookieDescription_DegreedBearerAccess: CookieNotice_CookieDescription_DegreedBearerAccess,
    CookieNotice_CookieDescription_DegreedHost: CookieNotice_CookieDescription_DegreedHost,
    CookieNotice_CookieDescription_Helpdeskcookie: CookieNotice_CookieDescription_Helpdeskcookie,
    CookieNotice_CookieDescription_IdentityV4Degreed: CookieNotice_CookieDescription_IdentityV4Degreed,
    CookieNotice_CookieDescription_IsEU: CookieNotice_CookieDescription_IsEU,
    CookieNotice_CookieDescription_IsNonEU: CookieNotice_CookieDescription_IsNonEU,
    CookieNotice_CookieDescription_SessionTimeout: CookieNotice_CookieDescription_SessionTimeout,
    CookieNotice_CookieDescription_SessionV4Degreed: CookieNotice_CookieDescription_SessionV4Degreed,
    CookieNotice_CookieDescription_SsoV4Degreed: CookieNotice_CookieDescription_SsoV4Degreed,
    CookieNotice_DurationType_Logout: CookieNotice_DurationType_Logout,
    CookieNotice_DurationType_Persistent1: CookieNotice_DurationType_Persistent1,
    CookieNotice_DurationType_Persistent60Custom: CookieNotice_DurationType_Persistent60Custom,
    CookieNotice_DurationType_Persistent90: CookieNotice_DurationType_Persistent90,
    CookieNotice_DurationType_PersistentUpdated: CookieNotice_DurationType_PersistentUpdated,
    CookieNotice_DurationType_Session: CookieNotice_DurationType_Session,
    CookieNotice_EssentialCookies_Content: CookieNotice_EssentialCookies_Content,
    CookieNotice_EssentialCookies_Title: CookieNotice_EssentialCookies_Title,
    CookieNotice_NonEssentialCookies_Content: CookieNotice_NonEssentialCookies_Content,
    CookieNotice_NonEssentialCookies_Title: CookieNotice_NonEssentialCookies_Title,
    CookieNotice_OtherWebsiteCookies_Content: CookieNotice_OtherWebsiteCookies_Content,
    CookieNotice_OtherWebsiteCookies_Title: CookieNotice_OtherWebsiteCookies_Title,
    CookieNotice_TableHeader_Duration: CookieNotice_TableHeader_Duration,
    CookieNotice_TableHeader_Name: CookieNotice_TableHeader_Name,
    CookieNotice_TableHeader_Provider: CookieNotice_TableHeader_Provider,
    CookieNotice_TableHeader_Purpose: CookieNotice_TableHeader_Purpose,
    CookieNotice_WhatAreCookies_Content: CookieNotice_WhatAreCookies_Content,
    CookieNotice_WhatAreCookies_Title: CookieNotice_WhatAreCookies_Title,
    CopyLinkSvc_ActionMessage: CopyLinkSvc_ActionMessage,
    CopyLinkSvc_MacCopy: CopyLinkSvc_MacCopy,
    CopyLinkSvc_PcCopy: CopyLinkSvc_PcCopy,
    "Core_ AccountClaimed": "Compte revendiqu\xe9",
    "Core_ AddJobRole": "Ajoutez votre poste",
    "Core_ AddLocation": "Ajoutez votre localisation",
    "Core_ Assigned": "Assign\xe9",
    "Core_ ExperienceType": "Type d’exp\xe9rience",
    "Core_ PriceRange": "Fourchette de prix",
    "Core_ ProgramLanguage": "Langage du programme",
    "Core_ ProgramType": "Type de programme",
    Core_1DayAgo: Core_1DayAgo,
    Core_1DayAgoFormat: Core_1DayAgoFormat,
    Core_1Hour: Core_1Hour,
    Core_1Hour1Minute: Core_1Hour1Minute,
    Core_1HourAgo: Core_1HourAgo,
    Core_1HourAgo_Minimal: Core_1HourAgo_Minimal,
    Core_1HourMinutesFormat: Core_1HourMinutesFormat,
    Core_1Minute: Core_1Minute,
    Core_1MinuteAgo: Core_1MinuteAgo,
    Core_1MinuteAgo_Minimal: Core_1MinuteAgo_Minimal,
    Core_1MonthAgo: Core_1MonthAgo,
    Core_1WeekAgo: Core_1WeekAgo,
    Core_1WeekAgo_Minimal: Core_1WeekAgo_Minimal,
    Core_1YearAgo: Core_1YearAgo,
    Core_A11yTypeaheadInstructions: Core_A11yTypeaheadInstructions,
    Core_AboutMe: Core_AboutMe,
    Core_Abstract: Core_Abstract,
    Core_Academies: Core_Academies,
    Core_AcademiesDescription: Core_AcademiesDescription,
    Core_AcademiesExplore: Core_AcademiesExplore,
    Core_AcademiesMarketplace: Core_AcademiesMarketplace,
    Core_Academy: Core_Academy,
    Core_AcademyContributor: Core_AcademyContributor,
    Core_AcademyView: Core_AcademyView,
    Core_Accept: Core_Accept,
    Core_AccessDenied: Core_AccessDenied,
    Core_Accomplishment: Core_Accomplishment,
    Core_AccomplishmentsDisplayName: Core_AccomplishmentsDisplayName,
    Core_AccountClaimed: Core_AccountClaimed,
    Core_AccountStatus: Core_AccountStatus,
    Core_Accredited: Core_Accredited,
    Core_Achievements: Core_Achievements,
    Core_Acknowledge_Changes: Core_Acknowledge_Changes,
    Core_ActionError: Core_ActionError,
    Core_Actions: Core_Actions,
    Core_Active: Core_Active,
    Core_ActiveLearner: Core_ActiveLearner,
    Core_ActiveLearners: Core_ActiveLearners,
    Core_Activity: Core_Activity,
    Core_ActualRecommendation: Core_ActualRecommendation,
    Core_Add: Core_Add,
    Core_Add_Skill_Source: Core_Add_Skill_Source,
    Core_Add_Source: Core_Add_Source,
    Core_AddAccomplishment: Core_AddAccomplishment,
    Core_AddArticle: Core_AddArticle,
    Core_AddAudio: Core_AddAudio,
    Core_AddAudioToCatalogFormat: Core_AddAudioToCatalogFormat,
    Core_AddBio: Core_AddBio,
    Core_AddBook: Core_AddBook,
    Core_AddContent: Core_AddContent,
    Core_Added: Core_Added,
    Core_AddedToQueueNotifierFormat: Core_AddedToQueueNotifierFormat,
    Core_AddExperience: Core_AddExperience,
    Core_AddGroups: Core_AddGroups,
    Core_AddGroupsInfo: Core_AddGroupsInfo,
    Core_AddingGroupsInfo: Core_AddingGroupsInfo,
    Core_AddItemTo: Core_AddItemTo,
    Core_AddPage: Core_AddPage,
    Core_AddPathway: Core_AddPathway,
    Core_AddPlans: Core_AddPlans,
    Core_AddPost: Core_AddPost,
    Core_AddTags: Core_AddTags,
    Core_AddTakeaway: Core_AddTakeaway,
    Core_AddTo: Core_AddTo,
    Core_AddToBundle: Core_AddToBundle,
    Core_AddToContent: Core_AddToContent,
    Core_AddToJobRole: Core_AddToJobRole,
    Core_AddToPathway: Core_AddToPathway,
    Core_AddVideo: Core_AddVideo,
    Core_Advanced: Core_Advanced,
    Core_AdvancedSettings: Core_AdvancedSettings,
    Core_AgreeContinue: Core_AgreeContinue,
    Core_All: Core_All,
    Core_All_Level: Core_All_Level,
    Core_AllFieldsRequired: Core_AllFieldsRequired,
    Core_AllTypesDisplayName: Core_AllTypesDisplayName,
    Core_AllUsers: Core_AllUsers,
    Core_AltText: Core_AltText,
    Core_AltTextHelperText: Core_AltTextHelperText,
    Core_Announcement: Core_Announcement,
    Core_AnonymousCountPluralFormat: Core_AnonymousCountPluralFormat,
    Core_AnonymousCountSingular: Core_AnonymousCountSingular,
    Core_AnonymousLearner: Core_AnonymousLearner,
    Core_AnonymousLearners: Core_AnonymousLearners,
    Core_AnonymousLearnersNotShown: Core_AnonymousLearnersNotShown,
    Core_Apply: Core_Apply,
    Core_ApplyChanges: Core_ApplyChanges,
    Core_Approve: Core_Approve,
    Core_ApproveAll: Core_ApproveAll,
    Core_ApproximateMinLeft: Core_ApproximateMinLeft,
    Core_Archived: Core_Archived,
    Core_AreYouSure: Core_AreYouSure,
    Core_Article: Core_Article,
    Core_Articles: Core_Articles,
    Core_ArticlesDisplayName: Core_ArticlesDisplayName,
    Core_ArticlesVideosDisplayName: Core_ArticlesVideosDisplayName,
    Core_ArticleVideoDisplayName: Core_ArticleVideoDisplayName,
    Core_Assessment: Core_Assessment,
    Core_AssessmentsDisplayName: Core_AssessmentsDisplayName,
    Core_Assign: Core_Assign,
    Core_Assigned: Core_Assigned,
    Core_AssignedBy: Core_AssignedBy,
    Core_AssignedDate: Core_AssignedDate,
    Core_AssignedLearning: Core_AssignedLearning,
    Core_AssignedLearningEmptyState: Core_AssignedLearningEmptyState,
    Core_AssignedTo: Core_AssignedTo,
    Core_Assignment: Core_Assignment,
    Core_AssignmentType: Core_AssignmentType,
    Core_Atoz: Core_Atoz,
    Core_Attend: Core_Attend,
    Core_Audio: Core_Audio,
    Core_Audiobook: Core_Audiobook,
    Core_AudioLength: Core_AudioLength,
    Core_AudioNamePlaceholder: Core_AudioNamePlaceholder,
    Core_AudioTitlePlaceholder: Core_AudioTitlePlaceholder,
    Core_AudioUrl: Core_AudioUrl,
    Core_Authoring: Core_Authoring,
    Core_Authors: Core_Authors,
    Core_Award: Core_Award,
    Core_AwardsDisplayName: Core_AwardsDisplayName,
    Core_AWeek: Core_AWeek,
    Core_Back: Core_Back,
    Core_BackToHomepage: Core_BackToHomepage,
    Core_Badge: Core_Badge,
    Core_BadgesDisplayName: Core_BadgesDisplayName,
    Core_Basic: Core_Basic,
    Core_Beginner: Core_Beginner,
    Core_Book: Core_Book,
    Core_Books: Core_Books,
    Core_BooksDisplayName: Core_BooksDisplayName,
    Core_Bootcamp: Core_Bootcamp,
    Core_Browse: Core_Browse,
    Core_BulkEdit: Core_BulkEdit,
    Core_BulkEditSelectedCount: Core_BulkEditSelectedCount,
    Core_By: Core_By,
    Core_CalendarDayCount: Core_CalendarDayCount,
    Core_CalendarNextMonth: Core_CalendarNextMonth,
    Core_CalendarPastYear: Core_CalendarPastYear,
    Core_CalendarPrevMonth: Core_CalendarPrevMonth,
    Core_CalendarRangeEnd: Core_CalendarRangeEnd,
    Core_CalendarRangeStart: Core_CalendarRangeStart,
    Core_CalendarSelectLast: Core_CalendarSelectLast,
    Core_CalendarSelectRange: Core_CalendarSelectRange,
    Core_CalendarSpecificDates: Core_CalendarSpecificDates,
    Core_CalendarView: Core_CalendarView,
    Core_Cancel: Core_Cancel,
    Core_Candidates: Core_Candidates,
    Core_CannotBeUndone: Core_CannotBeUndone,
    Core_CaseStudy: Core_CaseStudy,
    Core_Categories: Core_Categories,
    Core_Category: Core_Category,
    Core_CategoryName: Core_CategoryName,
    Core_Certificate: Core_Certificate,
    Core_CertificatesDisplayName: Core_CertificatesDisplayName,
    Core_Certification: Core_Certification,
    Core_CEU: Core_CEU,
    Core_CEUEligible: Core_CEUEligible,
    Core_CEUUnits: Core_CEUUnits,
    Core_Change: Core_Change,
    Core_Change_Primary_Skill_Source: Core_Change_Primary_Skill_Source,
    Core_Changes: Core_Changes,
    Core_ChangesSaved: Core_ChangesSaved,
    Core_CharLimitExceeded: Core_CharLimitExceeded,
    Core_CharsRemainingFormat: Core_CharsRemainingFormat,
    Core_ChartNotAvailableForAppliedFilters: Core_ChartNotAvailableForAppliedFilters,
    Core_Chat: Core_Chat,
    Core_CheckboxAll: Core_CheckboxAll,
    Core_ChooseFile: Core_ChooseFile,
    Core_ChooseSetupOptions: Core_ChooseSetupOptions,
    Core_Clear: Core_Clear,
    Core_ClearFilter: Core_ClearFilter,
    Core_ClearFilters: Core_ClearFilters,
    Core_ClearNumberFormat: Core_ClearNumberFormat,
    Core_ClearRating: Core_ClearRating,
    Core_ClearSelection: Core_ClearSelection,
    Core_ClearSelectionPluralFormat: Core_ClearSelectionPluralFormat,
    Core_ClearSelectionSingle: Core_ClearSelectionSingle,
    Core_ClearSelfRating: Core_ClearSelfRating,
    Core_ClickHere: Core_ClickHere,
    Core_Clone: Core_Clone,
    Core_CloneOfFormat: Core_CloneOfFormat,
    Core_Close: Core_Close,
    Core_Closed: Core_Closed,
    Core_ClosedOnDate: Core_ClosedOnDate,
    Core_CloseSuccess: Core_CloseSuccess,
    Core_Coach: Core_Coach,
    Core_Coaching: Core_Coaching,
    Core_Collaborator: Core_Collaborator,
    Core_CollaboratorOnly: Core_CollaboratorOnly,
    Core_Collaborators: Core_Collaborators,
    Core_Collapse: Core_Collapse,
    Core_CollapseAria: Core_CollapseAria,
    Core_ComingSoon: Core_ComingSoon,
    Core_Comment: Core_Comment,
    Core_CommentPrivacyWarning: Core_CommentPrivacyWarning,
    Core_Comments: Core_Comments,
    Core_Complete: Core_Complete,
    Core_Completed: Core_Completed,
    Core_CompletedContent: Core_CompletedContent,
    Core_CompletedDate: Core_CompletedDate,
    Core_CompletedFormat: Core_CompletedFormat,
    Core_CompletedStatus: Core_CompletedStatus,
    Core_Completion_Progress: Core_Completion_Progress,
    Core_Completions: Core_Completions,
    Core_Confetti: Core_Confetti,
    Core_Confirm: Core_Confirm,
    Core_ConfirmModalDefaultInputString: Core_ConfirmModalDefaultInputString,
    Core_ConfirmModalInputStringPlaceHolder: Core_ConfirmModalInputStringPlaceHolder,
    Core_ConfirmPassword: Core_ConfirmPassword,
    Core_ConfirmPasswordPlaceholder: Core_ConfirmPasswordPlaceholder,
    Core_Connect: Core_Connect,
    Core_Connected: Core_Connected,
    Core_Connectors: Core_Connectors,
    Core_ContactDegreedSupport: Core_ContactDegreedSupport,
    Core_Content: Core_Content,
    Core_ContentCompleted: Core_ContentCompleted,
    Core_ContentFollowed: Core_ContentFollowed,
    Core_ContentProcessing: Core_ContentProcessing,
    Core_ContentRemoved: Core_ContentRemoved,
    Core_ContentSaved: Core_ContentSaved,
    Core_ContentType: Core_ContentType,
    Core_ContentUncompleted: Core_ContentUncompleted,
    Core_ContentUnfollowed: Core_ContentUnfollowed,
    Core_ContentUnsaved: Core_ContentUnsaved,
    Core_Continue: Core_Continue,
    Core_ContinueLearningEmptyState: Core_ContinueLearningEmptyState,
    Core_ContinuingEducationUnitsEligible: Core_ContinuingEducationUnitsEligible,
    Core_CopyToClipboard: Core_CopyToClipboard,
    Core_Cost: Core_Cost,
    Core_CountItems: Core_CountItems,
    Core_CountMinutes: Core_CountMinutes,
    Core_CountPoints: Core_CountPoints,
    Core_Course: Core_Course,
    Core_Courses: Core_Courses,
    Core_CoursesDisplayName: Core_CoursesDisplayName,
    Core_Create: Core_Create,
    Core_CreatedBy: Core_CreatedBy,
    Core_CreatedDate: Core_CreatedDate,
    Core_Critical: Core_Critical,
    Core_Crop: Core_Crop,
    Core_Cropping: Core_Cropping,
    Core_CurrentPassword: Core_CurrentPassword,
    Core_CurrentPasswordPlaceholder: Core_CurrentPasswordPlaceholder,
    Core_CurrentSelfRating: Core_CurrentSelfRating,
    Core_Date: Core_Date,
    Core_Date_YYYYMMDDFormat: Core_Date_YYYYMMDDFormat,
    Core_DateAddedToProfile: Core_DateAddedToProfile,
    Core_DateLastUpdated: Core_DateLastUpdated,
    Core_Day: Core_Day,
    Core_DayOfWeekFriday: Core_DayOfWeekFriday,
    Core_DayOfWeekMonday: Core_DayOfWeekMonday,
    Core_DayOfWeekSaturday: Core_DayOfWeekSaturday,
    Core_DayOfWeekSunday: Core_DayOfWeekSunday,
    Core_DayOfWeekThursday: Core_DayOfWeekThursday,
    Core_DayOfWeekTuesday: Core_DayOfWeekTuesday,
    Core_DayOfWeekWednesday: Core_DayOfWeekWednesday,
    Core_Days: Core_Days,
    Core_DaysAgoFormat: Core_DaysAgoFormat,
    Core_DaysAgoFormat_Minimal: Core_DaysAgoFormat_Minimal,
    Core_DaysFormat: Core_DaysFormat,
    Core_Decline: Core_Decline,
    Core_DeclineAll: Core_DeclineAll,
    Core_Declined: Core_Declined,
    Core_Degree: Core_Degree,
    Core_DegreeBachelors: Core_DegreeBachelors,
    Core_DegreedSupport: Core_DegreedSupport,
    Core_DegreeMasters: Core_DegreeMasters,
    Core_DegreesDisplayName: Core_DegreesDisplayName,
    Core_Delete: Core_Delete,
    Core_Deleted: Core_Deleted,
    Core_Department: Core_Department,
    Core_Description: Core_Description,
    Core_Details: Core_Details,
    Core_Developing: Core_Developing,
    Core_Difficulty: Core_Difficulty,
    Core_Directory: Core_Directory,
    Core_Directorys: Core_Directorys,
    Core_DirectorysDisplayName: Core_DirectorysDisplayName,
    Core_Disable: Core_Disable,
    Core_Disabled: Core_Disabled,
    Core_DiscardChanges: Core_DiscardChanges,
    Core_Discover: Core_Discover,
    Core_DislikeAllyText: Core_DislikeAllyText,
    Core_Dismiss: Core_Dismiss,
    Core_DismissContent: Core_DismissContent,
    Core_DismissDialogHeader: Core_DismissDialogHeader,
    Core_DismissItemError: Core_DismissItemError,
    Core_DismissItemSuccess: Core_DismissItemSuccess,
    Core_Documentary: Core_Documentary,
    Core_Done: Core_Done,
    Core_DoneEditing: Core_DoneEditing,
    Core_DownloadDetails: Core_DownloadDetails,
    Core_DownloadFiles: Core_DownloadFiles,
    Core_DownloadMetadata: Core_DownloadMetadata,
    Core_Draft: Core_Draft,
    Core_DragFileHere: Core_DragFileHere,
    Core_Due: Core_Due,
    Core_DueBy: Core_DueBy,
    Core_DueDate: Core_DueDate,
    Core_DueDateFormat: Core_DueDateFormat,
    Core_DueDateTimeFormat: Core_DueDateTimeFormat,
    Core_DueIn: Core_DueIn,
    Core_DueOn: Core_DueOn,
    Core_Duration: Core_Duration,
    Core_DurationMinutes: Core_DurationMinutes,
    Core_DurationType: Core_DurationType,
    Core_Edit: Core_Edit,
    Core_Edit_Skill_Source: Core_Edit_Skill_Source,
    Core_EditArticle: Core_EditArticle,
    Core_EditAudio: Core_EditAudio,
    Core_EditBook: Core_EditBook,
    Core_EditDescription: Core_EditDescription,
    Core_EditDetails: Core_EditDetails,
    Core_EditItem: Core_EditItem,
    Core_EditItemHelper: Core_EditItemHelper,
    Core_EditPost: Core_EditPost,
    Core_EditSkillTarget: Core_EditSkillTarget,
    Core_EditStep: Core_EditStep,
    Core_EditVideo: Core_EditVideo,
    Core_Electronic: Core_Electronic,
    Core_Email: Core_Email,
    Core_EmailAddress: Core_EmailAddress,
    Core_EmailAddresses: Core_EmailAddresses,
    Core_EmailContent: Core_EmailContent,
    Core_EmailExistsError: Core_EmailExistsError,
    Core_EmailPlaceholder: Core_EmailPlaceholder,
    Core_EmailSubject: Core_EmailSubject,
    Core_EmailVerificationSuccessful: Core_EmailVerificationSuccessful,
    Core_Empty_Image_Alt: Core_Empty_Image_Alt,
    Core_EmptyFocusSkills: Core_EmptyFocusSkills,
    Core_EmptyFocusSkillsWithSuggestion: Core_EmptyFocusSkillsWithSuggestion,
    Core_Enable: Core_Enable,
    Core_Enabled: Core_Enabled,
    Core_EndDate: Core_EndDate,
    Core_Endorse: Core_Endorse,
    Core_EndorseConfirmation: Core_EndorseConfirmation,
    Core_EndorseContentChannelTypeError: Core_EndorseContentChannelTypeError,
    Core_EndorseContentGenericError: Core_EndorseContentGenericError,
    Core_EndorseContentOrgTypeError: Core_EndorseContentOrgTypeError,
    Core_EndorseContentPermissionError: Core_EndorseContentPermissionError,
    Core_Endorsed: Core_Endorsed,
    Core_EndorsedByOrganization: Core_EndorsedByOrganization,
    Core_EndorsedOnly: Core_EndorsedOnly,
    Core_EndorsedTooltip: Core_EndorsedTooltip,
    Core_EndorseInformation: Core_EndorseInformation,
    Core_EndorsementRemoved: Core_EndorsementRemoved,
    Core_Engagement: Core_Engagement,
    Core_Enroll: Core_Enroll,
    Core_Enrolled: Core_Enrolled,
    Core_Enrollees: Core_Enrollees,
    Core_EnrollInPathway: Core_EnrollInPathway,
    Core_Enrollment: Core_Enrollment,
    Core_Enrolls: Core_Enrolls,
    Core_Episode: Core_Episode,
    Core_EpisodesDisplayName: Core_EpisodesDisplayName,
    Core_Error: Core_Error,
    Core_Event: Core_Event,
    Core_Events: Core_Events,
    Core_EventsDisplayName: Core_EventsDisplayName,
    Core_ExactMatches: Core_ExactMatches,
    Core_Expand: Core_Expand,
    Core_ExperienceDisplayName: Core_ExperienceDisplayName,
    Core_ExperiencesDisplayName: Core_ExperiencesDisplayName,
    Core_Expert: Core_Expert,
    Core_External: Core_External,
    Core_ExternalBook: Core_ExternalBook,
    Core_ExternalBooksDisplayName: Core_ExternalBooksDisplayName,
    Core_ExternalPodcast: Core_ExternalPodcast,
    Core_ExternalPodcastsDisplayName: Core_ExternalPodcastsDisplayName,
    Core_ExternalResources: Core_ExternalResources,
    Core_ExternalVideo: Core_ExternalVideo,
    Core_ExternalVideosDisplayName: Core_ExternalVideosDisplayName,
    Core_False: Core_False,
    Core_Favicon: Core_Favicon,
    Core_FeatureResource: Core_FeatureResource,
    Core_Feed: Core_Feed,
    Core_FieldInvalidFormat: Core_FieldInvalidFormat,
    Core_FieldRequired: Core_FieldRequired,
    Core_FieldRequiredFormat: Core_FieldRequiredFormat,
    Core_Files: Core_Files,
    Core_FileTypes_FirstOrOnly: Core_FileTypes_FirstOrOnly,
    Core_FileTypes_Middle: Core_FileTypes_Middle,
    Core_FileTypes_OrLast: Core_FileTypes_OrLast,
    Core_Filter: Core_Filter,
    Core_FilterApplied: Core_FilterApplied,
    Core_FiltersAppliedFormat: Core_FiltersAppliedFormat,
    Core_FindContent: Core_FindContent,
    Core_Finish: Core_Finish,
    Core_FirstName: Core_FirstName,
    Core_FlagAsInappropriate: Core_FlagAsInappropriate,
    Core_Focus: Core_Focus,
    Core_FocusSkill: Core_FocusSkill,
    Core_FocusUnderLimitDescription: Core_FocusUnderLimitDescription,
    Core_FocusUptoLimitDescription: Core_FocusUptoLimitDescription,
    Core_Follow: Core_Follow,
    Core_Follow_UserName: Core_Follow_UserName,
    Core_Followers: Core_Followers,
    Core_Following: Core_Following,
    Core_FollowingButtonLabel: Core_FollowingButtonLabel,
    Core_FollowPathway: Core_FollowPathway,
    Core_Follows: Core_Follows,
    Core_Format: Core_Format,
    Core_Free: Core_Free,
    Core_FreeformText: Core_FreeformText,
    Core_Future: Core_Future,
    Core_GeneralErrorMessage: Core_GeneralErrorMessage,
    Core_GeneralLoadingError: Core_GeneralLoadingError,
    Core_Goal: Core_Goal,
    Core_GoalAddedFormat: Core_GoalAddedFormat,
    Core_GoBack: Core_GoBack,
    Core_Graduate: Core_Graduate,
    Core_GreaterThan1Day: Core_GreaterThan1Day,
    Core_Grid: Core_Grid,
    Core_Group: Core_Group,
    Core_GroupDisplayName: Core_GroupDisplayName,
    Core_Groups: Core_Groups,
    Core_GroupsDisplayName: Core_GroupsDisplayName,
    Core_GrowthPlan: Core_GrowthPlan,
    Core_Help: Core_Help,
    Core_Hide: Core_Hide,
    Core_HideFilters: Core_HideFilters,
    Core_Home: Core_Home,
    Core_Hooray: Core_Hooray,
    Core_Hour: Core_Hour,
    Core_Hours: Core_Hours,
    Core_HoursAgoFormat: Core_HoursAgoFormat,
    Core_HoursAgoFormat_Minimal: Core_HoursAgoFormat_Minimal,
    Core_HoursFormat: Core_HoursFormat,
    Core_HoursMinutesFormat: Core_HoursMinutesFormat,
    Core_Hybrid: Core_Hybrid,
    Core_Icon: Core_Icon,
    Core_ICreatedAudio: Core_ICreatedAudio,
    Core_Image: Core_Image,
    Core_In1DayFormat: Core_In1DayFormat,
    Core_Inactive: Core_Inactive,
    Core_InAppNotification: Core_InAppNotification,
    Core_InDaysFormat: Core_InDaysFormat,
    Core_Inference: Core_Inference,
    Core_Info: Core_Info,
    Core_InPerson: Core_InPerson,
    Core_InProgress: Core_InProgress,
    Core_InputActionAdded: Core_InputActionAdded,
    Core_InputActionAttended: Core_InputActionAttended,
    Core_InputActionCompleted: Core_InputActionCompleted,
    Core_InputActionCompletedCourse: Core_InputActionCompletedCourse,
    Core_InputActionCompletedPodcast: Core_InputActionCompletedPodcast,
    Core_InputActionRead: Core_InputActionRead,
    Core_InputActionReadBook: Core_InputActionReadBook,
    Core_InputActionTaskCompleted: Core_InputActionTaskCompleted,
    Core_InputActionWatched: Core_InputActionWatched,
    Core_InputCommentPlaceholder: Core_InputCommentPlaceholder,
    Core_InputDetails: Core_InputDetails,
    Core_Inputs: Core_Inputs,
    Core_Insights: Core_Insights,
    Core_Instructions: Core_Instructions,
    Core_InstructorLed: Core_InstructorLed,
    Core_Integration: Core_Integration,
    Core_Interested: Core_Interested,
    Core_Intermediate: Core_Intermediate,
    Core_Invalid: Core_Invalid,
    Core_InvalidEmail: Core_InvalidEmail,
    Core_InvalidEmailPattern: Core_InvalidEmailPattern,
    Core_InvalidMaxValue: Core_InvalidMaxValue,
    Core_InvalidMinValue: Core_InvalidMinValue,
    Core_Inventory: Core_Inventory,
    Core_Invite: Core_Invite,
    Core_Items: Core_Items,
    Core_ItemsSelectedFormat: Core_ItemsSelectedFormat,
    Core_JobRole: Core_JobRole,
    Core_JobroleDisplayName: Core_JobroleDisplayName,
    Core_JobRoleLiteral: Core_JobRoleLiteral,
    Core_JobRoles: Core_JobRoles,
    Core_JobRolesDisplayName: Core_JobRolesDisplayName,
    Core_JobTitle: Core_JobTitle,
    Core_Join: Core_Join,
    Core_Joined: Core_Joined,
    Core_JoinEvent: Core_JoinEvent,
    Core_Journal: Core_Journal,
    Core_Journey: Core_Journey,
    Core_JustNow: Core_JustNow,
    Core_Language: Core_Language,
    Core_LanguageSettings: Core_LanguageSettings,
    Core_LastActive: Core_LastActive,
    Core_LastLogin: Core_LastLogin,
    Core_LastMonth: Core_LastMonth,
    Core_LastName: Core_LastName,
    Core_LastNameTC: Core_LastNameTC,
    Core_LastUpdated: Core_LastUpdated,
    Core_LastWeek: Core_LastWeek,
    Core_Learn_More: Core_Learn_More,
    Core_Learning: Core_Learning,
    Core_LearningMinutes: Core_LearningMinutes,
    Core_LearningPath: Core_LearningPath,
    Core_Learnings: Core_Learnings,
    Core_LearnMore: Core_LearnMore,
    Core_LearnOnDegreed: Core_LearnOnDegreed,
    Core_LessThan10: Core_LessThan10,
    Core_LessThan1Day: Core_LessThan1Day,
    Core_LessThan1Hour: Core_LessThan1Hour,
    Core_LessThan30: Core_LessThan30,
    Core_LessThan30Days: Core_LessThan30Days,
    Core_LessThan4Hours: Core_LessThan4Hours,
    Core_LessThan5: Core_LessThan5,
    Core_LessThan6Months: Core_LessThan6Months,
    Core_LessThanADay: Core_LessThanADay,
    Core_LessThanOneYear: Core_LessThanOneYear,
    Core_Like: Core_Like,
    Core_LikeAllyText: Core_LikeAllyText,
    Core_Liked: Core_Liked,
    Core_LimitedVisibility: Core_LimitedVisibility,
    Core_Link: Core_Link,
    Core_Linked_External_Skill_Source: Core_Linked_External_Skill_Source,
    Core_Links: Core_Links,
    Core_LinkText: Core_LinkText,
    Core_List: Core_List,
    Core_ListItemsError: Core_ListItemsError,
    Core_Live: Core_Live,
    Core_LiveOnlineTraining: Core_LiveOnlineTraining,
    Core_Loading: Core_Loading,
    Core_LoadingResults: Core_LoadingResults,
    Core_LoadMore: Core_LoadMore,
    Core_LoadMoreAria: Core_LoadMoreAria,
    Core_Location: Core_Location,
    Core_MaliciousURL: Core_MaliciousURL,
    Core_ManageFocusSkills: Core_ManageFocusSkills,
    Core_ManagerRating: Core_ManagerRating,
    Core_ManageTranslations: Core_ManageTranslations,
    Core_Mandatory: Core_Mandatory,
    Core_Mark_ContentName_Complete: Core_Mark_ContentName_Complete,
    Core_Mark_ContentTitle_Complete: Core_Mark_ContentTitle_Complete,
    Core_MarkAsComplete: Core_MarkAsComplete,
    Core_Marketplace: Core_Marketplace,
    Core_Matched_Skills: Core_Matched_Skills,
    Core_MatchedOf: Core_MatchedOf,
    Core_MaxCost: Core_MaxCost,
    Core_Media: Core_Media,
    Core_Meeting: Core_Meeting,
    Core_Members: Core_Members,
    Core_Membership: Core_Membership,
    Core_Mentee: Core_Mentee,
    Core_Mentor: Core_Mentor,
    Core_Mentors: Core_Mentors,
    Core_Message: Core_Message,
    Core_MinCost: Core_MinCost,
    Core_Minute: Core_Minute,
    Core_Minutes: Core_Minutes,
    Core_MinutesAgoFormat: Core_MinutesAgoFormat,
    Core_MinutesAgoFormat_Minimal: Core_MinutesAgoFormat_Minimal,
    Core_MinutesFormat: Core_MinutesFormat,
    Core_MissingRatingNudgeText: Core_MissingRatingNudgeText,
    Core_Month: Core_Month,
    Core_MonthAgoFormat: Core_MonthAgoFormat,
    Core_Months: Core_Months,
    Core_MonthsAgoFormat: Core_MonthsAgoFormat,
    Core_MonthsAgoFormat_Minimal: Core_MonthsAgoFormat_Minimal,
    Core_More: Core_More,
    Core_MoreDetails: Core_MoreDetails,
    Core_MoreFilters: Core_MoreFilters,
    Core_MoreInfo: Core_MoreInfo,
    Core_MoreOptions: Core_MoreOptions,
    Core_MoreOptionsForItem: Core_MoreOptionsForItem,
    Core_MoveDown: Core_MoveDown,
    Core_MoveToGlobal: Core_MoveToGlobal,
    Core_MoveUp: Core_MoveUp,
    Core_Multisession: Core_Multisession,
    Core_Name: Core_Name,
    Core_NearStart: Core_NearStart,
    Core_New: Core_New,
    Core_Newest: Core_Newest,
    Core_NewItem: Core_NewItem,
    Core_NewItems: Core_NewItems,
    Core_NewPassword: Core_NewPassword,
    Core_NewPasswordPlaceholder: Core_NewPasswordPlaceholder,
    Core_NewRating: Core_NewRating,
    Core_NewSelfRating: Core_NewSelfRating,
    Core_Next: Core_Next,
    Core_Next30Days: Core_Next30Days,
    Core_Next60Days: Core_Next60Days,
    Core_Next7Days: Core_Next7Days,
    Core_NextYear: Core_NextYear,
    Core_NinePlusMonths: Core_NinePlusMonths,
    Core_No: Core_No,
    Core_NoDescription: Core_NoDescription,
    Core_NoDueDate: Core_NoDueDate,
    Core_NoFiles: Core_NoFiles,
    Core_NoMembers: Core_NoMembers,
    Core_NoPreviousLogin: Core_NoPreviousLogin,
    Core_NoResults: Core_NoResults,
    Core_NoResultsFor: Core_NoResultsFor,
    Core_NoResultsFound: Core_NoResultsFound,
    Core_NoResultsMatch: Core_NoResultsMatch,
    Core_Normal: Core_Normal,
    Core_NotAvailable: Core_NotAvailable,
    Core_NotAvailableForGroup: Core_NotAvailableForGroup,
    Core_NotDislikedAllyText: Core_NotDislikedAllyText,
    Core_NotFound_DescriptionText: Core_NotFound_DescriptionText,
    Core_NotFound_HeaderText: Core_NotFound_HeaderText,
    Core_NoThanks: Core_NoThanks,
    Core_NotSelected: Core_NotSelected,
    Core_NotSpecified: Core_NotSpecified,
    Core_Okay: Core_Okay,
    Core_Older: Core_Older,
    Core_Oldest: Core_Oldest,
    Core_OnDate: Core_OnDate,
    Core_OneToThreeMonths: Core_OneToThreeMonths,
    Core_Online: Core_Online,
    Core_Open: Core_Open,
    Core_OpenContent: Core_OpenContent,
    Core_OpenDatePicker: Core_OpenDatePicker,
    Core_OpenedOnDate: Core_OpenedOnDate,
    Core_OpenItem: Core_OpenItem,
    Core_Operator_Contains: Core_Operator_Contains,
    Core_Operator_Empty: Core_Operator_Empty,
    Core_Operator_EndsWith: Core_Operator_EndsWith,
    Core_Operator_Exact: Core_Operator_Exact,
    Core_Operator_NotContains: Core_Operator_NotContains,
    Core_Operator_StartsWith: Core_Operator_StartsWith,
    Core_Opportunities: Core_Opportunities,
    Core_OpportunitiesDesc: Core_OpportunitiesDesc,
    Core_Opportunity: Core_Opportunity,
    Core_Opportunity_Groups: Core_Opportunity_Groups,
    Core_Opportunity_JobRole: Core_Opportunity_JobRole,
    Core_Opportunity_JobRole_Placeholder: Core_Opportunity_JobRole_Placeholder,
    Core_OpportunityType: Core_OpportunityType,
    Core_Optin: Core_Optin,
    Core_Optional: Core_Optional,
    Core_OptionalMessage_Request: Core_OptionalMessage_Request,
    Core_Options: Core_Options,
    Core_OptionsAvailableFormat: Core_OptionsAvailableFormat,
    Core_Optout: Core_Optout,
    Core_Or: Core_Or,
    Core_Org_Recommendation: Core_Org_Recommendation,
    Core_Organization: Core_Organization,
    Core_Organizations: Core_Organizations,
    Core_OrgManagedDocLinkLabel: Core_OrgManagedDocLinkLabel,
    Core_OrgManagedNotification: Core_OrgManagedNotification,
    Core_OrgManagedNotificationPlural: Core_OrgManagedNotificationPlural,
    Core_Other: Core_Other,
    Core_OverrideChangesWarning: Core_OverrideChangesWarning,
    Core_Overview: Core_Overview,
    Core_OverYearAgo: Core_OverYearAgo,
    Core_Page: Core_Page,
    Core_Pages: Core_Pages,
    Core_Paid: Core_Paid,
    Core_PasswordLocked: Core_PasswordLocked,
    Core_PasswordMatchError: Core_PasswordMatchError,
    Core_PasswordPatternInfo: Core_PasswordPatternInfo,
    Core_PasswordRequirementsNotMet: Core_PasswordRequirementsNotMet,
    Core_PasswordReset: Core_PasswordReset,
    Core_Past: Core_Past,
    Core_Pathway: Core_Pathway,
    Core_Pathways: Core_Pathways,
    Core_PathwaysDisplayName: Core_PathwaysDisplayName,
    Core_PDF: Core_PDF,
    Core_Pending: Core_Pending,
    Core_People: Core_People,
    Core_Permissions: Core_Permissions,
    Core_PersonalizedLearningEmptySkills: Core_PersonalizedLearningEmptySkills,
    Core_PersonalizedLearningEmptySkillsWithSuggestion: Core_PersonalizedLearningEmptySkillsWithSuggestion,
    Core_PersonalizedLearningEmptyState: Core_PersonalizedLearningEmptyState,
    Core_Phone: Core_Phone,
    Core_Plans: Core_Plans,
    Core_PlansAndRoles: Core_PlansAndRoles,
    Core_Play: Core_Play,
    Core_PleaseTryAgain: Core_PleaseTryAgain,
    Core_PlusShowMore: Core_PlusShowMore,
    Core_Podcast: Core_Podcast,
    Core_PodcastDisplayName: Core_PodcastDisplayName,
    Core_PodcastEpisodeDisplayName: Core_PodcastEpisodeDisplayName,
    Core_PodcastHelp: Core_PodcastHelp,
    Core_PodcastNameUrl: Core_PodcastNameUrl,
    Core_Podcasts: Core_Podcasts,
    Core_PodcastsDisplayName: Core_PodcastsDisplayName,
    Core_PodcastUrl: Core_PodcastUrl,
    Core_Points: Core_Points,
    Core_Position: Core_Position,
    Core_PositionsDisplayName: Core_PositionsDisplayName,
    Core_Post: Core_Post,
    Core_PostsDisplayName: Core_PostsDisplayName,
    Core_PoweredBy: Core_PoweredBy,
    Core_Preview: Core_Preview,
    Core_Previous: Core_Previous,
    Core_PreviousRating: Core_PreviousRating,
    Core_PriceRange: Core_PriceRange,
    Core_Primary: Core_Primary,
    Core_Primary_Source: Core_Primary_Source,
    Core_PrimaryPlan: Core_PrimaryPlan,
    Core_Print: Core_Print,
    Core_PrivacyLevel0: Core_PrivacyLevel0,
    Core_PrivacyLevel1: Core_PrivacyLevel1,
    Core_PrivacyLevel2: Core_PrivacyLevel2,
    Core_PrivacyLevel2A: Core_PrivacyLevel2A,
    Core_PrivacyLevel2B: Core_PrivacyLevel2B,
    Core_PrivacyLevel2C: Core_PrivacyLevel2C,
    Core_PrivacyLevel3: Core_PrivacyLevel3,
    Core_Private: Core_Private,
    Core_Proficient: Core_Proficient,
    Core_ProgramLanguage: Core_ProgramLanguage,
    Core_ProgramType: Core_ProgramType,
    Core_ProgressBar_Tooltip: Core_ProgressBar_Tooltip,
    Core_ProgressSaved: Core_ProgressSaved,
    Core_Provider: Core_Provider,
    Core_Providers: Core_Providers,
    Core_Pts: Core_Pts,
    Core_Publish: Core_Publish,
    Core_PublishDate: Core_PublishDate,
    Core_Published: Core_Published,
    Core_PublishedDaysAgoFormat: Core_PublishedDaysAgoFormat,
    Core_PublishedHoursAgoFormat: Core_PublishedHoursAgoFormat,
    Core_PublishedJustNowFormat: Core_PublishedJustNowFormat,
    Core_PublishedMinutesAgoFormat: Core_PublishedMinutesAgoFormat,
    Core_PublishedMonthsAgoFormat: Core_PublishedMonthsAgoFormat,
    Core_PublishedOnDateFormat: Core_PublishedOnDateFormat,
    Core_PublishedOneHourAgoFormat: Core_PublishedOneHourAgoFormat,
    Core_PublishedOneMonthAgoFormat: Core_PublishedOneMonthAgoFormat,
    Core_PublishedOneWeekAgoFormat: Core_PublishedOneWeekAgoFormat,
    Core_PublishedWeeksAgoFormat: Core_PublishedWeeksAgoFormat,
    Core_PublishedXTimeAgoFormat: Core_PublishedXTimeAgoFormat,
    Core_PublishedYesterdayFormat: Core_PublishedYesterdayFormat,
    Core_Quarter: Core_Quarter,
    Core_Question: Core_Question,
    Core_Question_and_Answer: Core_Question_and_Answer,
    Core_Questions: Core_Questions,
    Core_Rate: Core_Rate,
    Core_RateYourself: Core_RateYourself,
    Core_RateYourselfInSkill: Core_RateYourselfInSkill,
    Core_Rating: Core_Rating,
    Core_Ratings: Core_Ratings,
    Core_RatingType: Core_RatingType,
    Core_Read: Core_Read,
    Core_ReadMore: Core_ReadMore,
    Core_RecentActivitySuggestion: Core_RecentActivitySuggestion,
    Core_RecentStart: Core_RecentStart,
    Core_Recommend: Core_Recommend,
    Core_Recommendation: Core_Recommendation,
    Core_RecommendationDisplayName: Core_RecommendationDisplayName,
    Core_RecommendationsDisplayName: Core_RecommendationsDisplayName,
    Core_Recommended: Core_Recommended,
    Core_RecommendedFocusSkills: Core_RecommendedFocusSkills,
    Core_RecommendedSkills: Core_RecommendedSkills,
    Core_RefreshPage: Core_RefreshPage,
    Core_Register: Core_Register,
    Core_Registered: Core_Registered,
    Core_RelatedSkillTooltip: Core_RelatedSkillTooltip,
    Core_Remove: Core_Remove,
    Core_RemoveAssignment: Core_RemoveAssignment,
    Core_RemoveAssignmentDescription: Core_RemoveAssignmentDescription,
    Core_Removed: Core_Removed,
    Core_RemoveEndorsement: Core_RemoveEndorsement,
    Core_RemoveEndorsementConfirmation: Core_RemoveEndorsementConfirmation,
    Core_RemoveFacetFormat: Core_RemoveFacetFormat,
    Core_RemoveFromAssignedModalText: Core_RemoveFromAssignedModalText,
    Core_RemoveFromContinueLearningModalText: Core_RemoveFromContinueLearningModalText,
    Core_RemoveFromInProgressModalText: Core_RemoveFromInProgressModalText,
    Core_RemoveFromPersonalizedLearningModalText: Core_RemoveFromPersonalizedLearningModalText,
    Core_RemoveFromTrendingLearningModalText: Core_RemoveFromTrendingLearningModalText,
    Core_RemoveImage: Core_RemoveImage,
    Core_RemoveItem: Core_RemoveItem,
    Core_RemoveSkill: Core_RemoveSkill,
    Core_RemoveSuccess: Core_RemoveSuccess,
    Core_Replace: Core_Replace,
    Core_ReplaceFile: Core_ReplaceFile,
    Core_Reply: Core_Reply,
    Core_ReportAProblem: Core_ReportAProblem,
    Core_Required: Core_Required,
    Core_ReRateSkill: Core_ReRateSkill,
    Core_Reset: Core_Reset,
    Core_ResetDefault: Core_ResetDefault,
    Core_ResetFilters: Core_ResetFilters,
    Core_ResetFiltersWithCount: Core_ResetFiltersWithCount,
    Core_Results: Core_Results,
    Core_ResultsFoundFormat: Core_ResultsFoundFormat,
    Core_Retry: Core_Retry,
    Core_Revert: Core_Revert,
    Core_Review: Core_Review,
    Core_Role: Core_Role,
    Core_RoleAdmin: Core_RoleAdmin,
    Core_RoleAdminsCan: Core_RoleAdminsCan,
    Core_RoleCareerProfessional: Core_RoleCareerProfessional,
    Core_RoleCareerProfessionalsCan: Core_RoleCareerProfessionalsCan,
    Core_RoleLearningProfessional: Core_RoleLearningProfessional,
    Core_RoleLearningProfessionalsCan: Core_RoleLearningProfessionalsCan,
    Core_RoleManager: Core_RoleManager,
    Core_RoleManagersCan: Core_RoleManagersCan,
    Core_RoleMember: Core_RoleMember,
    Core_RoleMembersCan: Core_RoleMembersCan,
    Core_RolePlan: Core_RolePlan,
    Core_RoleTechnicalAdmin: Core_RoleTechnicalAdmin,
    Core_RoleTechnicalAdminsCan: Core_RoleTechnicalAdminsCan,
    Core_Save: Core_Save,
    Core_SaveAudio: Core_SaveAudio,
    Core_SaveChanges: Core_SaveChanges,
    Core_Saved: Core_Saved,
    Core_SaveForLater: Core_SaveForLater,
    Core_SaveItemforLater: Core_SaveItemforLater,
    Core_SaveNext: Core_SaveNext,
    Core_SaveRating: Core_SaveRating,
    Core_SaveSkillTarget: Core_SaveSkillTarget,
    Core_Saving: Core_Saving,
    Core_ScrollLimit: Core_ScrollLimit,
    Core_ScrollLimited: Core_ScrollLimited,
    Core_Search: Core_Search,
    Core_SearchCatalog: Core_SearchCatalog,
    Core_SearchCollection: Core_SearchCollection,
    Core_SearchFilterA11yLabel: Core_SearchFilterA11yLabel,
    Core_SearchForPathway: Core_SearchForPathway,
    Core_SearchForPerson: Core_SearchForPerson,
    Core_SearchTerms: Core_SearchTerms,
    Core_Second: Core_Second,
    Core_Secondary: Core_Secondary,
    Core_Seconds: Core_Seconds,
    Core_SecondsAgoFormat: Core_SecondsAgoFormat,
    Core_SecondsAgoFormat_Minimal: Core_SecondsAgoFormat_Minimal,
    Core_SeeSkillCollection: Core_SeeSkillCollection,
    Core_Segments: Core_Segments,
    Core_Select: Core_Select,
    Core_SelectAllInTable: Core_SelectAllInTable,
    Core_SelectDate: Core_SelectDate,
    Core_SelectEndDate: Core_SelectEndDate,
    Core_SelectItem: Core_SelectItem,
    Core_SelectSelfRating: Core_SelectSelfRating,
    Core_SelectSkillTarget: Core_SelectSkillTarget,
    Core_SelectStartDate: Core_SelectStartDate,
    Core_SelfRating: Core_SelfRating,
    "Core_Self-Rating": "Auto-\xe9valuation",
    "Core_Self-study": "Auto-apprentissage",
    Core_Send: Core_Send,
    Core_SendEmail: Core_SendEmail,
    Core_Sending: Core_Sending,
    Core_SendRequest: Core_SendRequest,
    Core_Series: Core_Series,
    Core_SessionDateRange: Core_SessionDateRange,
    Core_SessionLocation: Core_SessionLocation,
    Core_Sessions: Core_Sessions,
    Core_SessionType: Core_SessionType,
    Core_SetAsGoal: Core_SetAsGoal,
    Core_SetGoal: Core_SetGoal,
    Core_SetSkillTarget: Core_SetSkillTarget,
    Core_Settings: Core_Settings,
    Core_SettingsSaved: Core_SettingsSaved,
    Core_Share: Core_Share,
    Core_Shared: Core_Shared,
    Core_SharedBy: Core_SharedBy,
    Core_SharedContent: Core_SharedContent,
    Core_ShareItem: Core_ShareItem,
    Core_ShareOn: Core_ShareOn,
    Core_Show: Core_Show,
    Core_ShowAll: Core_ShowAll,
    Core_ShowAllAria: Core_ShowAllAria,
    Core_ShowCompleted: Core_ShowCompleted,
    Core_ShowFilters: Core_ShowFilters,
    Core_ShowLess: Core_ShowLess,
    Core_ShowLessAria: Core_ShowLessAria,
    Core_ShowMore: Core_ShowMore,
    Core_ShowResults: Core_ShowResults,
    Core_SignalCount: Core_SignalCount,
    Core_SignalsCount: Core_SignalsCount,
    Core_Skill: Core_Skill,
    Core_Skill_Source_Acknowledge_Changes_Content: Core_Skill_Source_Acknowledge_Changes_Content,
    Core_SkillCoach: Core_SkillCoach,
    Core_SkillCount: Core_SkillCount,
    Core_SkillDisplayName: Core_SkillDisplayName,
    Core_SkillPlan: Core_SkillPlan,
    Core_SkillPlansDisplayName: Core_SkillPlansDisplayName,
    Core_SkillRating: Core_SkillRating,
    Core_Skills: Core_Skills,
    Core_SkillsAndTopics: Core_SkillsAndTopics,
    Core_SkillScaleChanged: Core_SkillScaleChanged,
    Core_SkillsCount: Core_SkillsCount,
    Core_SkillsDisplayName: Core_SkillsDisplayName,
    Core_SkillTarget: Core_SkillTarget,
    Core_SkillTargetDescription: Core_SkillTargetDescription,
    Core_SkillTargetLevel: Core_SkillTargetLevel,
    Core_Skip: Core_Skip,
    Core_SlowWarn: Core_SlowWarn,
    Core_SorryExclamation: Core_SorryExclamation,
    Core_Sort: Core_Sort,
    Core_SortBy: Core_SortBy,
    Core_Source: Core_Source,
    Core_Sources: Core_Sources,
    Core_SpecificDates: Core_SpecificDates,
    Core_SponsoredBy: Core_SponsoredBy,
    Core_Stage: Core_Stage,
    Core_Start: Core_Start,
    Core_StartDate: Core_StartDate,
    Core_Started: Core_Started,
    Core_StartTracking: Core_StartTracking,
    Core_Status: Core_Status,
    Core_Submit: Core_Submit,
    Core_SubmitContinue: Core_SubmitContinue,
    Core_Submitting: Core_Submitting,
    Core_Subscription: Core_Subscription,
    Core_Subtitle: Core_Subtitle,
    Core_Success: Core_Success,
    Core_SuccessChangesPublished: Core_SuccessChangesPublished,
    Core_SuccessfullyVerified: Core_SuccessfullyVerified,
    Core_Suggestions: Core_Suggestions,
    Core_Summary: Core_Summary,
    Core_Support: Core_Support,
    Core_Tag: Core_Tag,
    Core_TagCredential: Core_TagCredential,
    Core_TagEvaluation: Core_TagEvaluation,
    Core_Tags: Core_Tags,
    Core_TagsDisplayName: Core_TagsDisplayName,
    Core_TagSelf: Core_TagSelf,
    Core_Target: Core_Target,
    Core_Targets: Core_Targets,
    Core_TargetsDisplayName: Core_TargetsDisplayName,
    Core_TargetTypeNotDefined: Core_TargetTypeNotDefined,
    Core_Task: Core_Task,
    Core_Tasks: Core_Tasks,
    Core_TasksDisplayName: Core_TasksDisplayName,
    Core_Team: Core_Team,
    Core_Text: Core_Text,
    Core_ThisMonth: Core_ThisMonth,
    Core_ThisMonth_Minimal: Core_ThisMonth_Minimal,
    Core_ThisYear: Core_ThisYear,
    Core_ThisYear_Minimal: Core_ThisYear_Minimal,
    Core_ThreeToNineMonths: Core_ThreeToNineMonths,
    Core_TinyMCEAriaHelpText: Core_TinyMCEAriaHelpText,
    Core_Title: Core_Title,
    Core_TitleLength: Core_TitleLength,
    Core_TitleRequired: Core_TitleRequired,
    Core_To: Core_To,
    Core_ToBeCompleted: Core_ToBeCompleted,
    Core_Today: Core_Today,
    Core_Today_Minimal: Core_Today_Minimal,
    Core_ToDo: Core_ToDo,
    Core_ToggleExactMatches: Core_ToggleExactMatches,
    Core_Top: Core_Top,
    Core_Topics: Core_Topics,
    Core_TotalMembers: Core_TotalMembers,
    Core_Translations: Core_Translations,
    Core_True: Core_True,
    Core_TwoToFourWeeks: Core_TwoToFourWeeks,
    Core_Type: Core_Type,
    Core_UnableToEnrollFormat: Core_UnableToEnrollFormat,
    Core_UncompletedFormat: Core_UncompletedFormat,
    Core_Undergraduate: Core_Undergraduate,
    Core_UndislikeAllyText: Core_UndislikeAllyText,
    Core_UnfeatureResource: Core_UnfeatureResource,
    Core_UnFollow: Core_UnFollow,
    Core_Units: Core_Units,
    Core_Unknown: Core_Unknown,
    Core_Unlike: Core_Unlike,
    Core_UnlikeAllyText: Core_UnlikeAllyText,
    Core_Unpublish: Core_Unpublish,
    Core_UnpublishedChanges: Core_UnpublishedChanges,
    Core_Unsave: Core_Unsave,
    Core_UnsaveItem: Core_UnsaveItem,
    Core_UnselectAll: Core_UnselectAll,
    Core_Update: Core_Update,
    Core_Updated: Core_Updated,
    Core_Upload: Core_Upload,
    Core_UploadCategories: Core_UploadCategories,
    Core_Uploaded: Core_Uploaded,
    Core_UploadedFilesForSource: Core_UploadedFilesForSource,
    Core_UploadNew: Core_UploadNew,
    Core_UploadTranslations: Core_UploadTranslations,
    Core_Url: Core_Url,
    Core_UrlRequired: Core_UrlRequired,
    Core_Usd: Core_Usd,
    Core_UsedIn: Core_UsedIn,
    Core_User: Core_User,
    Core_UserActivityInformation: Core_UserActivityInformation,
    Core_Users: Core_Users,
    Core_UsersDisplayName: Core_UsersDisplayName,
    Core_UTCDatesNote: Core_UTCDatesNote,
    Core_Valid_No_WhiteSpace: Core_Valid_No_WhiteSpace,
    Core_ValidUrl: Core_ValidUrl,
    Core_Verify: Core_Verify,
    Core_Video: Core_Video,
    Core_Videos: Core_Videos,
    Core_VideosDisplayName: Core_VideosDisplayName,
    Core_View: Core_View,
    Core_ViewAll: Core_ViewAll,
    Core_ViewConversation: Core_ViewConversation,
    Core_ViewDescription: Core_ViewDescription,
    Core_ViewDetails: Core_ViewDetails,
    Core_Viewed: Core_Viewed,
    Core_ViewInCollection: Core_ViewInCollection,
    Core_ViewInGoals: Core_ViewInGoals,
    Core_ViewInstructions: Core_ViewInstructions,
    Core_ViewPathway: Core_ViewPathway,
    Core_ViewProfile: Core_ViewProfile,
    Core_Views: Core_Views,
    Core_ViewSavedItems: Core_ViewSavedItems,
    Core_ViewSkills: Core_ViewSkills,
    Core_VirtualClassroom: Core_VirtualClassroom,
    Core_VisibilityCollaborators: Core_VisibilityCollaborators,
    Core_VisibilityDocLinkLabel: Core_VisibilityDocLinkLabel,
    Core_VisibilityGroup: Core_VisibilityGroup,
    Core_VisibilityGroups: Core_VisibilityGroups,
    Core_VisibilityOrganization: Core_VisibilityOrganization,
    Core_VisibilityProfile: Core_VisibilityProfile,
    Core_VisibilityPublic: Core_VisibilityPublic,
    Core_VisitProvider: Core_VisitProvider,
    Core_VisitUrl: Core_VisitUrl,
    Core_VisitWebsite: Core_VisitWebsite,
    Core_Warning: Core_Warning,
    Core_Watch: Core_Watch,
    Core_Week: Core_Week,
    Core_Weeks: Core_Weeks,
    Core_WeeksAgoFormat: Core_WeeksAgoFormat,
    Core_WhatDidYouLearnAudioLong: Core_WhatDidYouLearnAudioLong,
    Core_Withdraw: Core_Withdraw,
    Core_withPublished: Core_withPublished,
    Core_Word: Core_Word,
    Core_WordLimitExceeded: Core_WordLimitExceeded,
    Core_Words: Core_Words,
    Core_WordsRemainingFormat: Core_WordsRemainingFormat,
    Core_Workshop: Core_Workshop,
    Core_WouldYouLikeToProceed: Core_WouldYouLikeToProceed,
    Core_Year: Core_Year,
    Core_YearAgoFormat: Core_YearAgoFormat,
    Core_YearsAgoFormat: Core_YearsAgoFormat,
    Core_YearsAgoFormat_Minimal: Core_YearsAgoFormat_Minimal,
    Core_Yes: Core_Yes,
    Core_YesContinue: Core_YesContinue,
    Core_YesProceed: Core_YesProceed,
    Core_YesSure: Core_YesSure,
    Core_Yesterday: Core_Yesterday,
    Core_Yesterday_Minimal: Core_Yesterday_Minimal,
    Core_YourFocusSkills: Core_YourFocusSkills,
    Core_ZeroSignalsCount: Core_ZeroSignalsCount,
    Core_ZeroSkills: Core_ZeroSkills,
    Core_ZeroSkillsCount: Core_ZeroSkillsCount,
    Core_ZoomIn: Core_ZoomIn,
    Core_ZoomOut: Core_ZoomOut,
    Core_Ztoa: Core_Ztoa,
    CourseFormCtrl_Accredited: CourseFormCtrl_Accredited,
    CourseFormCtrl_AddCourse: CourseFormCtrl_AddCourse,
    CourseFormCtrl_AddToCatalogFormat: CourseFormCtrl_AddToCatalogFormat,
    CourseFormCtrl_Category: CourseFormCtrl_Category,
    CourseFormCtrl_CommentPlaceholder: CourseFormCtrl_CommentPlaceholder,
    CourseFormCtrl_Country: CourseFormCtrl_Country,
    CourseFormCtrl_CountryPlaceholder: CourseFormCtrl_CountryPlaceholder,
    CourseFormCtrl_CourseFromScormFile: CourseFormCtrl_CourseFromScormFile,
    CourseFormCtrl_CourseFromScormFile_MetadataMissingMessage: CourseFormCtrl_CourseFromScormFile_MetadataMissingMessage,
    CourseFormCtrl_CourseGrade: CourseFormCtrl_CourseGrade,
    CourseFormCtrl_CourseGradePlaceholder: CourseFormCtrl_CourseGradePlaceholder,
    CourseFormCtrl_CourseLevel: CourseFormCtrl_CourseLevel,
    CourseFormCtrl_CourseLevelPlaceholder: CourseFormCtrl_CourseLevelPlaceholder,
    CourseFormCtrl_CourseNumber: CourseFormCtrl_CourseNumber,
    CourseFormCtrl_CourseNumberPlaceholder: CourseFormCtrl_CourseNumberPlaceholder,
    CourseFormCtrl_CourseTitle: CourseFormCtrl_CourseTitle,
    CourseFormCtrl_CourseUrl: CourseFormCtrl_CourseUrl,
    CourseFormCtrl_CourseUrlAria: CourseFormCtrl_CourseUrlAria,
    CourseFormCtrl_CreditHours: CourseFormCtrl_CreditHours,
    CourseFormCtrl_CreditHoursPlaceholder: CourseFormCtrl_CreditHoursPlaceholder,
    CourseFormCtrl_DateCompleted: CourseFormCtrl_DateCompleted,
    CourseFormCtrl_DateCompletedPlaceholder: CourseFormCtrl_DateCompletedPlaceholder,
    CourseFormCtrl_DateTaught: CourseFormCtrl_DateTaught,
    CourseFormCtrl_EditCourse: CourseFormCtrl_EditCourse,
    CourseFormCtrl_FirstYearLevel: CourseFormCtrl_FirstYearLevel,
    CourseFormCtrl_FourthYearLevel: CourseFormCtrl_FourthYearLevel,
    CourseFormCtrl_GraduateLevel: CourseFormCtrl_GraduateLevel,
    CourseFormCtrl_HowAdded: CourseFormCtrl_HowAdded,
    CourseFormCtrl_Informal: CourseFormCtrl_Informal,
    CourseFormCtrl_ITaughtCourse: CourseFormCtrl_ITaughtCourse,
    CourseFormCtrl_Provider: CourseFormCtrl_Provider,
    CourseFormCtrl_Provider_Placeholder: CourseFormCtrl_Provider_Placeholder,
    CourseFormCtrl_ProviderName: CourseFormCtrl_ProviderName,
    CourseFormCtrl_SaveCourse: CourseFormCtrl_SaveCourse,
    CourseFormCtrl_SchoolName: CourseFormCtrl_SchoolName,
    CourseFormCtrl_SchoolPlaceholder: CourseFormCtrl_SchoolPlaceholder,
    CourseFormCtrl_SecondYearLevel: CourseFormCtrl_SecondYearLevel,
    CourseFormCtrl_SelectCourse: CourseFormCtrl_SelectCourse,
    CourseFormCtrl_SelectProvider: CourseFormCtrl_SelectProvider,
    CourseFormCtrl_Summary: CourseFormCtrl_Summary,
    CourseFormCtrl_ThirdYearLevel: CourseFormCtrl_ThirdYearLevel,
    CourseFormCtrl_TitlePlaceholder: CourseFormCtrl_TitlePlaceholder,
    CourseFormCtrl_UnitType: CourseFormCtrl_UnitType,
    CourseFormCtrl_UrlError: CourseFormCtrl_UrlError,
    CourseFormCtrl_UrlOrScormRequired: CourseFormCtrl_UrlOrScormRequired,
    CourseFormCtrl_UrlOrSelectionRequired: CourseFormCtrl_UrlOrSelectionRequired,
    CourseFormCtrl_US: CourseFormCtrl_US,
    CourseFormCtrl_ValidNumber: CourseFormCtrl_ValidNumber,
    CourseFormCtrl_ValidScormRequired: CourseFormCtrl_ValidScormRequired,
    CourseFormCtrl_VerificationUrl: CourseFormCtrl_VerificationUrl,
    CourseFormCtrl_WhatDidYouLearnLong: CourseFormCtrl_WhatDidYouLearnLong,
    CourseFormCtrl_WhatDidYouLearnShort: CourseFormCtrl_WhatDidYouLearnShort,
    CourseFormCtrl_WhereTaken: CourseFormCtrl_WhereTaken,
    CoursesSvc_CoursesError: CoursesSvc_CoursesError,
    CoursesSvc_ProviderError: CoursesSvc_ProviderError,
    Cred_Application_Cancel: Cred_Application_Cancel,
    Cred_Application_Stay: Cred_Application_Stay,
    Cred_ApplicationStep_AcceptHonorCode: Cred_ApplicationStep_AcceptHonorCode,
    Cred_ApplicationStep_AcceptHonorCodeInstruction: Cred_ApplicationStep_AcceptHonorCodeInstruction,
    Cred_ApplicationStep_ComparePeers: Cred_ApplicationStep_ComparePeers,
    Cred_ApplicationStep_ComparePeersInstruction: Cred_ApplicationStep_ComparePeersInstruction,
    Cred_ApplicationStep_CompleteBehaviors: Cred_ApplicationStep_CompleteBehaviors,
    Cred_ApplicationStep_CompleteBehaviorsInstruction: Cred_ApplicationStep_CompleteBehaviorsInstruction,
    Cred_ApplicationStep_CompleteEndorsers: Cred_ApplicationStep_CompleteEndorsers,
    Cred_ApplicationStep_CompleteEndorsersInstruction: Cred_ApplicationStep_CompleteEndorsersInstruction,
    Cred_ApplicationStep_ConfirmUser: Cred_ApplicationStep_ConfirmUser,
    Cred_ApplicationStep_ConfirmUserInstruction: Cred_ApplicationStep_ConfirmUserInstruction,
    Cred_ApplicationStep_Pay: Cred_ApplicationStep_Pay,
    Cred_ApplicationStep_PayInstruction: Cred_ApplicationStep_PayInstruction,
    Cred_ApplicationStep_Results: Cred_ApplicationStep_Results,
    Cred_ApplicationStep_ResultsInstruction: Cred_ApplicationStep_ResultsInstruction,
    Cred_ApplicationStep_Review: Cred_ApplicationStep_Review,
    Cred_ApplicationStep_ReviewInstruction: Cred_ApplicationStep_ReviewInstruction,
    Cred_ApplicationStep_Submit: Cred_ApplicationStep_Submit,
    Cred_ApplicationStep_SubmitInstruction: Cred_ApplicationStep_SubmitInstruction,
    Cred_ApplicationStep_Unknown: Cred_ApplicationStep_Unknown,
    Cred_ApplicationStep_WaitForCohort: Cred_ApplicationStep_WaitForCohort,
    Cred_ApplicationStep_WaitForCohortInstruction: Cred_ApplicationStep_WaitForCohortInstruction,
    Cred_ApplicationStep_WaitForReviews: Cred_ApplicationStep_WaitForReviews,
    Cred_ApplicationStep_WaitForReviewsInstruction: Cred_ApplicationStep_WaitForReviewsInstruction,
    Cred_BehaviorDisplay_DetailTitle: Cred_BehaviorDisplay_DetailTitle,
    Cred_BehaviorDisplay_TitleTitle: Cred_BehaviorDisplay_TitleTitle,
    Cred_BehaviorReview_Accuracy: Cred_BehaviorReview_Accuracy,
    Cred_BehaviorReview_Accuracy_High: Cred_BehaviorReview_Accuracy_High,
    Cred_BehaviorReview_Accuracy_Low: Cred_BehaviorReview_Accuracy_Low,
    Cred_BehaviorReview_AreYouQualified: Cred_BehaviorReview_AreYouQualified,
    Cred_Behaviors_DemoHeader: Cred_Behaviors_DemoHeader,
    Cred_Certificate_CertificateTitle: Cred_Certificate_CertificateTitle,
    Cred_Certificate_CertifiedOn: Cred_Certificate_CertifiedOn,
    Cred_Certificate_ChiefLearningOfficer: Cred_Certificate_ChiefLearningOfficer,
    Cred_Certificate_Congratulations: Cred_Certificate_Congratulations,
    Cred_Certificate_DateIssued: Cred_Certificate_DateIssued,
    Cred_Certificate_DegreedCertifiesAria: Cred_Certificate_DegreedCertifiesAria,
    Cred_Certificate_DegreedCertifiesThat: Cred_Certificate_DegreedCertifiesThat,
    Cred_Certificate_Details: Cred_Certificate_Details,
    Cred_Certificate_Download: Cred_Certificate_Download,
    Cred_Certificate_DownloadWillBegin: Cred_Certificate_DownloadWillBegin,
    Cred_Certificate_EndorsedBy: Cred_Certificate_EndorsedBy,
    Cred_Certificate_Endorsers: Cred_Certificate_Endorsers,
    Cred_Certificate_ExecutiveChairman: Cred_Certificate_ExecutiveChairman,
    Cred_Certificate_In: Cred_Certificate_In,
    Cred_Certificate_Is: Cred_Certificate_Is,
    Cred_Certificate_Issuer: Cred_Certificate_Issuer,
    Cred_Certificate_IssuerUrl: Cred_Certificate_IssuerUrl,
    Cred_Certificate_Level: Cred_Certificate_Level,
    Cred_Certificate_LevelOutOfLevel: Cred_Certificate_LevelOutOfLevel,
    Cred_Certificate_LinkedInAuthority: Cred_Certificate_LinkedInAuthority,
    Cred_Certificate_LinkedInDate: Cred_Certificate_LinkedInDate,
    Cred_Certificate_LinkedInGo: Cred_Certificate_LinkedInGo,
    Cred_Certificate_LinkedInLicense: Cred_Certificate_LinkedInLicense,
    Cred_Certificate_LinkedInName: Cred_Certificate_LinkedInName,
    Cred_Certificate_LinkedInTitle: Cred_Certificate_LinkedInTitle,
    Cred_Certificate_LinkedInUrl: Cred_Certificate_LinkedInUrl,
    Cred_Certificate_Name: Cred_Certificate_Name,
    Cred_Certificate_NameLabel: Cred_Certificate_NameLabel,
    Cred_Certificate_RemovedRevoked: Cred_Certificate_RemovedRevoked,
    Cred_Certificate_ResumeDate: Cred_Certificate_ResumeDate,
    Cred_Certificate_ResumeName: Cred_Certificate_ResumeName,
    Cred_Certificate_ResumeTitle: Cred_Certificate_ResumeTitle,
    Cred_Certificate_SealAlt: Cred_Certificate_SealAlt,
    Cred_Certificate_SignaturesAlt: Cred_Certificate_SignaturesAlt,
    Cred_Certificate_SkillCertificate: Cred_Certificate_SkillCertificate,
    Cred_Certificate_SkillCertification: Cred_Certificate_SkillCertification,
    Cred_Certificate_SocialEmailBodyFormat: Cred_Certificate_SocialEmailBodyFormat,
    Cred_Certificate_SocialEmailSubjectFormat: Cred_Certificate_SocialEmailSubjectFormat,
    Cred_Certificate_SocialPostSummaryFormat: Cred_Certificate_SocialPostSummaryFormat,
    Cred_Certificate_SocialPostTitleFormat: Cred_Certificate_SocialPostTitleFormat,
    Cred_Certificate_TitleOf: Cred_Certificate_TitleOf,
    Cred_Certificate_Visibility: Cred_Certificate_Visibility,
    Cred_Certificate_VisibilityLabel: Cred_Certificate_VisibilityLabel,
    Cred_Comparison_Next: Cred_Comparison_Next,
    Cred_ComparisonNav_Comparison1: Cred_ComparisonNav_Comparison1,
    Cred_ComparisonNav_Comparison2: Cred_ComparisonNav_Comparison2,
    Cred_ComparisonNav_Comparison3: Cred_ComparisonNav_Comparison3,
    Cred_ComparisonNav_ComparisonFormat: Cred_ComparisonNav_ComparisonFormat,
    Cred_ComparisonPending_BeginNext: Cred_ComparisonPending_BeginNext,
    Cred_ComparisonPending_DueDateFormat: Cred_ComparisonPending_DueDateFormat,
    Cred_ComparisonPending_Heading: Cred_ComparisonPending_Heading,
    Cred_ComparisonPending_NoPendingReviews: Cred_ComparisonPending_NoPendingReviews,
    Cred_ComparisonPending_RemainingFormat: Cred_ComparisonPending_RemainingFormat,
    Cred_ComparisonPending_ReviewsRemainingFormat: Cred_ComparisonPending_ReviewsRemainingFormat,
    Cred_ConfirmSkipDialog_Body: Cred_ConfirmSkipDialog_Body,
    Cred_ConfirmSkipDialog_Button: Cred_ConfirmSkipDialog_Button,
    Cred_ConfirmSkipDialog_DeclinedBody: Cred_ConfirmSkipDialog_DeclinedBody,
    Cred_ConfirmSkipDialog_Heading: Cred_ConfirmSkipDialog_Heading,
    Cred_CredVerifySvc_SubmitError: Cred_CredVerifySvc_SubmitError,
    Cred_EndorseExp_InstructionsFormat: Cred_EndorseExp_InstructionsFormat,
    Cred_EndorseExp_Q_Communication: Cred_EndorseExp_Q_Communication,
    Cred_EndorseExp_Q_Communication_15: Cred_EndorseExp_Q_Communication_15,
    Cred_EndorseExp_Q_Communication_35: Cred_EndorseExp_Q_Communication_35,
    Cred_EndorseExp_Q_Communication_55: Cred_EndorseExp_Q_Communication_55,
    Cred_EndorseExp_Q_Communication_75: Cred_EndorseExp_Q_Communication_75,
    Cred_EndorseExp_Q_Knowledge: Cred_EndorseExp_Q_Knowledge,
    Cred_EndorseExp_Q_Knowledge_15: Cred_EndorseExp_Q_Knowledge_15,
    Cred_EndorseExp_Q_Knowledge_35: Cred_EndorseExp_Q_Knowledge_35,
    Cred_EndorseExp_Q_Knowledge_55: Cred_EndorseExp_Q_Knowledge_55,
    Cred_EndorseExp_Q_Knowledge_75: Cred_EndorseExp_Q_Knowledge_75,
    Cred_EndorseExp_Q_Planning: Cred_EndorseExp_Q_Planning,
    Cred_EndorseExp_Q_Planning_15: Cred_EndorseExp_Q_Planning_15,
    Cred_EndorseExp_Q_Planning_35: Cred_EndorseExp_Q_Planning_35,
    Cred_EndorseExp_Q_Planning_55: Cred_EndorseExp_Q_Planning_55,
    Cred_EndorseExp_Q_Planning_75: Cred_EndorseExp_Q_Planning_75,
    Cred_EndorseExp_Q_Practice: Cred_EndorseExp_Q_Practice,
    Cred_EndorseExp_Q_Practice_15: Cred_EndorseExp_Q_Practice_15,
    Cred_EndorseExp_Q_Practice_35: Cred_EndorseExp_Q_Practice_35,
    Cred_EndorseExp_Q_Practice_55: Cred_EndorseExp_Q_Practice_55,
    Cred_EndorseExp_Q_Practice_75: Cred_EndorseExp_Q_Practice_75,
    Cred_EndorseExp_Q_Responsibility: Cred_EndorseExp_Q_Responsibility,
    Cred_EndorseExp_Q_Responsibility_15: Cred_EndorseExp_Q_Responsibility_15,
    Cred_EndorseExp_Q_Responsibility_35: Cred_EndorseExp_Q_Responsibility_35,
    Cred_EndorseExp_Q_Responsibility_55: Cred_EndorseExp_Q_Responsibility_55,
    Cred_EndorseExp_Q_Responsibility_75: Cred_EndorseExp_Q_Responsibility_75,
    Cred_EndorseExp_Q_Teamwork: Cred_EndorseExp_Q_Teamwork,
    Cred_EndorseExp_Q_Teamwork_15: Cred_EndorseExp_Q_Teamwork_15,
    Cred_EndorseExp_Q_Teamwork_35: Cred_EndorseExp_Q_Teamwork_35,
    Cred_EndorseExp_Q_Teamwork_55: Cred_EndorseExp_Q_Teamwork_55,
    Cred_EndorseExp_Q_Teamwork_75: Cred_EndorseExp_Q_Teamwork_75,
    Cred_EndorsementAccept_Accept: Cred_EndorsementAccept_Accept,
    Cred_EndorsementAccept_HonorCode1: Cred_EndorsementAccept_HonorCode1,
    Cred_EndorsementAccept_HonorCode2: Cred_EndorsementAccept_HonorCode2,
    Cred_EndorsementAccept_HonorCode3: Cred_EndorsementAccept_HonorCode3,
    Cred_EndorsementAccept_HonorCodeTitle: Cred_EndorsementAccept_HonorCodeTitle,
    Cred_EndorsementAccept_Instructions: Cred_EndorsementAccept_Instructions,
    Cred_EndorsementAccount_AlreadyLoggedIn: Cred_EndorsementAccount_AlreadyLoggedIn,
    Cred_EndorsementAccount_Create: Cred_EndorsementAccount_Create,
    Cred_EndorsementAccount_CreateAndNext: Cred_EndorsementAccount_CreateAndNext,
    Cred_EndorsementAccount_EmailLabel: Cred_EndorsementAccount_EmailLabel,
    Cred_EndorsementAccount_Header: Cred_EndorsementAccount_Header,
    Cred_EndorsementAccount_Instructions: Cred_EndorsementAccount_Instructions,
    Cred_EndorsementAccount_PasswordLabel: Cred_EndorsementAccount_PasswordLabel,
    Cred_EndorsementAccount_Skip: Cred_EndorsementAccount_Skip,
    Cred_EndorsementAccount_SkipInstructions: Cred_EndorsementAccount_SkipInstructions,
    Cred_EndorsementBehavior_Header: Cred_EndorsementBehavior_Header,
    Cred_EndorsementBehavior_Instructions: Cred_EndorsementBehavior_Instructions,
    Cred_EndorsementEndorser_EmailLabel: Cred_EndorsementEndorser_EmailLabel,
    Cred_EndorsementEndorser_EmailPlaceholder: Cred_EndorsementEndorser_EmailPlaceholder,
    Cred_EndorsementEndorser_FirstNameLabel: Cred_EndorsementEndorser_FirstNameLabel,
    Cred_EndorsementEndorser_Instructions: Cred_EndorsementEndorser_Instructions,
    Cred_EndorsementEndorser_LastNameLabel: Cred_EndorsementEndorser_LastNameLabel,
    Cred_EndorsementEndorser_PhoneLabel: Cred_EndorsementEndorser_PhoneLabel,
    Cred_EndorsementEndorser_PhonePlaceholder: Cred_EndorsementEndorser_PhonePlaceholder,
    Cred_EndorsementEndorser_PositionLabel: Cred_EndorsementEndorser_PositionLabel,
    Cred_EndorsementEndorser_PositionPlaceholder: Cred_EndorsementEndorser_PositionPlaceholder,
    Cred_EndorsementEndorser_RelationshipLabel: Cred_EndorsementEndorser_RelationshipLabel,
    Cred_EndorsementEndorser_RelationshipPlaceholder: Cred_EndorsementEndorser_RelationshipPlaceholder,
    Cred_EndorsementReasonForm_Header: Cred_EndorsementReasonForm_Header,
    Cred_EndorsementReasonForm_ReasonLabel: Cred_EndorsementReasonForm_ReasonLabel,
    Cred_EndorsementReasonForm_ReasonPlaceholder: Cred_EndorsementReasonForm_ReasonPlaceholder,
    Cred_EndorsementStart_Accept: Cred_EndorsementStart_Accept,
    Cred_EndorsementStart_Decline: Cred_EndorsementStart_Decline,
    Cred_EndorsementStart_Declined: Cred_EndorsementStart_Declined,
    Cred_EndorsementStart_DeclineReason: Cred_EndorsementStart_DeclineReason,
    Cred_EndorsementStart_DegreedDescription: Cred_EndorsementStart_DegreedDescription,
    Cred_EndorsementStart_Instructions: Cred_EndorsementStart_Instructions,
    Cred_EndorsementStart_RequestFrom: Cred_EndorsementStart_RequestFrom,
    Cred_EndorsementStart_WhatIsDegreed: Cred_EndorsementStart_WhatIsDegreed,
    Cred_EndorsementSubmit_CompletedDetails: Cred_EndorsementSubmit_CompletedDetails,
    Cred_EndorsementSubmit_CompletedTitle: Cred_EndorsementSubmit_CompletedTitle,
    Cred_EndorsementSubmit_Exit: Cred_EndorsementSubmit_Exit,
    Cred_EndorsementSubmit_Header: Cred_EndorsementSubmit_Header,
    Cred_EndorsementSubmit_Instructions: Cred_EndorsementSubmit_Instructions,
    Cred_EndorsementSubmit_Instructions2: Cred_EndorsementSubmit_Instructions2,
    Cred_EndorseNav_AcceptDescription: Cred_EndorseNav_AcceptDescription,
    Cred_EndorseNav_AccountDescription: Cred_EndorseNav_AccountDescription,
    Cred_EndorseNav_ConfirmContactInfo: Cred_EndorseNav_ConfirmContactInfo,
    Cred_EndorseNav_CreateDegreedAcct: Cred_EndorseNav_CreateDegreedAcct,
    Cred_EndorseNav_EndorserDescription: Cred_EndorseNav_EndorserDescription,
    Cred_EndorseNav_Heading: Cred_EndorseNav_Heading,
    Cred_EndorseNav_ReviewDescription: Cred_EndorseNav_ReviewDescription,
    Cred_EndorseNav_ReviewExperience: Cred_EndorseNav_ReviewExperience,
    Cred_EndorseNav_ReviewExperienceDescription: Cred_EndorseNav_ReviewExperienceDescription,
    Cred_EndorseNav_ReviewHonorCode: Cred_EndorseNav_ReviewHonorCode,
    Cred_EndorseNav_ReviewSkill1: Cred_EndorseNav_ReviewSkill1,
    Cred_EndorseNav_ReviewSkill2: Cred_EndorseNav_ReviewSkill2,
    Cred_EndorseNav_ReviewSkill3: Cred_EndorseNav_ReviewSkill3,
    Cred_EndorseNav_ReviewSkills: Cred_EndorseNav_ReviewSkills,
    Cred_EndorseNav_Start: Cred_EndorseNav_Start,
    Cred_EndorseNav_StartDescription: Cred_EndorseNav_StartDescription,
    Cred_EndorseNav_SubmitDescription: Cred_EndorseNav_SubmitDescription,
    Cred_EndorserDemo_ButtonLabel: Cred_EndorserDemo_ButtonLabel,
    Cred_EndorserDemo_Heading: Cred_EndorserDemo_Heading,
    Cred_EndorserDemo_ImageAlt: Cred_EndorserDemo_ImageAlt,
    Cred_EndorserDemo_Step1_Content: Cred_EndorserDemo_Step1_Content,
    Cred_EndorserDemo_Step1_Title: Cred_EndorserDemo_Step1_Title,
    Cred_EndorserDemo_Step2_Content: Cred_EndorserDemo_Step2_Content,
    Cred_EndorserDemo_Step2_Title: Cred_EndorserDemo_Step2_Title,
    Cred_EndorserDemo_Step3_Content: Cred_EndorserDemo_Step3_Content,
    Cred_EndorserDemo_Step3_Title: Cred_EndorserDemo_Step3_Title,
    Cred_EndorserDemo_ThanksGotIt: Cred_EndorserDemo_ThanksGotIt,
    Cred_EndorserExpired_Explanation: Cred_EndorserExpired_Explanation,
    Cred_EndorserExpired_Heading: Cred_EndorserExpired_Heading,
    Cred_EndorserResend_Header: Cred_EndorserResend_Header,
    Cred_Evidence_RemoveHeader: Cred_Evidence_RemoveHeader,
    Cred_Evidence_RemoveSummary: Cred_Evidence_RemoveSummary,
    Cred_EvidenceDisplay_ExampleHeading: Cred_EvidenceDisplay_ExampleHeading,
    Cred_EvidenceDisplay_ProcessHeading: Cred_EvidenceDisplay_ProcessHeading,
    Cred_ExpertCandidate_AttrAutonomy: Cred_ExpertCandidate_AttrAutonomy,
    Cred_ExpertCandidate_Attributes: Cred_ExpertCandidate_Attributes,
    Cred_ExpertCandidate_AttrKnowledge: Cred_ExpertCandidate_AttrKnowledge,
    Cred_ExpertCandidate_AttrPlanning: Cred_ExpertCandidate_AttrPlanning,
    Cred_ExpertCandidate_AttrSkills: Cred_ExpertCandidate_AttrSkills,
    Cred_ExpertCandidate_AttrTeaching: Cred_ExpertCandidate_AttrTeaching,
    Cred_ExpertCandidate_AttrTeamwork: Cred_ExpertCandidate_AttrTeamwork,
    Cred_ExpertCandidate_CommentsLabel: Cred_ExpertCandidate_CommentsLabel,
    Cred_ExpertCandidate_CommentsPlaceholder: Cred_ExpertCandidate_CommentsPlaceholder,
    Cred_ExpertCandidate_Heading: Cred_ExpertCandidate_Heading,
    Cred_ExpertCandidate_LevelHigh: Cred_ExpertCandidate_LevelHigh,
    Cred_ExpertCandidate_LevelLabel: Cred_ExpertCandidate_LevelLabel,
    Cred_ExpertCandidate_LevelLow: Cred_ExpertCandidate_LevelLow,
    Cred_ExpertCandidate_NA: Cred_ExpertCandidate_NA,
    Cred_ExpertCandidate_SaveLevel: Cred_ExpertCandidate_SaveLevel,
    Cred_ExpertPending_BeginNextReview: Cred_ExpertPending_BeginNextReview,
    Cred_ExpertPending_Heading: Cred_ExpertPending_Heading,
    Cred_ExpertPending_NoPendingReviews: Cred_ExpertPending_NoPendingReviews,
    Cred_ExpertPending_ReviewsRemainingFormat: Cred_ExpertPending_ReviewsRemainingFormat,
    Cred_InstructionVideo: Cred_InstructionVideo,
    Cred_Intent_CareerChange: Cred_Intent_CareerChange,
    Cred_Intent_ImproveSkills: Cred_Intent_ImproveSkills,
    Cred_Intent_legend: Cred_Intent_legend,
    Cred_Intent_MeasureMe: Cred_Intent_MeasureMe,
    Cred_Intent_Other: Cred_Intent_Other,
    Cred_Intent_ShowSkills: Cred_Intent_ShowSkills,
    Cred_Intent_WorkDomain: Cred_Intent_WorkDomain,
    Cred_LevelBreakdown_Autonomy_1: Cred_LevelBreakdown_Autonomy_1,
    Cred_LevelBreakdown_Autonomy_2: Cred_LevelBreakdown_Autonomy_2,
    Cred_LevelBreakdown_Autonomy_3: Cred_LevelBreakdown_Autonomy_3,
    Cred_LevelBreakdown_Autonomy_4: Cred_LevelBreakdown_Autonomy_4,
    Cred_LevelBreakdown_Autonomy_5: Cred_LevelBreakdown_Autonomy_5,
    Cred_LevelBreakdown_Autonomy_6: Cred_LevelBreakdown_Autonomy_6,
    Cred_LevelBreakdown_Autonomy_7: Cred_LevelBreakdown_Autonomy_7,
    Cred_LevelBreakdown_Autonomy_8: Cred_LevelBreakdown_Autonomy_8,
    Cred_LevelBreakdown_Autonomy_Scale6_1: Cred_LevelBreakdown_Autonomy_Scale6_1,
    Cred_LevelBreakdown_Autonomy_Scale6_2: Cred_LevelBreakdown_Autonomy_Scale6_2,
    Cred_LevelBreakdown_Autonomy_Scale6_3: Cred_LevelBreakdown_Autonomy_Scale6_3,
    Cred_LevelBreakdown_Autonomy_Scale6_4: Cred_LevelBreakdown_Autonomy_Scale6_4,
    Cred_LevelBreakdown_Autonomy_Scale6_5: Cred_LevelBreakdown_Autonomy_Scale6_5,
    Cred_LevelBreakdown_Autonomy_Scale6_6: Cred_LevelBreakdown_Autonomy_Scale6_6,
    Cred_LevelBreakdown_Autonomy_Scale8_1: Cred_LevelBreakdown_Autonomy_Scale8_1,
    Cred_LevelBreakdown_Autonomy_Scale8_2: Cred_LevelBreakdown_Autonomy_Scale8_2,
    Cred_LevelBreakdown_Autonomy_Scale8_3: Cred_LevelBreakdown_Autonomy_Scale8_3,
    Cred_LevelBreakdown_Autonomy_Scale8_4: Cred_LevelBreakdown_Autonomy_Scale8_4,
    Cred_LevelBreakdown_Autonomy_Scale8_5: Cred_LevelBreakdown_Autonomy_Scale8_5,
    Cred_LevelBreakdown_Autonomy_Scale8_6: Cred_LevelBreakdown_Autonomy_Scale8_6,
    Cred_LevelBreakdown_Autonomy_Scale8_7: Cred_LevelBreakdown_Autonomy_Scale8_7,
    Cred_LevelBreakdown_Autonomy_Scale8_8: Cred_LevelBreakdown_Autonomy_Scale8_8,
    Cred_LevelBreakdown_Description: Cred_LevelBreakdown_Description,
    Cred_LevelBreakdown_Knowledge_1: Cred_LevelBreakdown_Knowledge_1,
    Cred_LevelBreakdown_Knowledge_2: Cred_LevelBreakdown_Knowledge_2,
    Cred_LevelBreakdown_Knowledge_3: Cred_LevelBreakdown_Knowledge_3,
    Cred_LevelBreakdown_Knowledge_4: Cred_LevelBreakdown_Knowledge_4,
    Cred_LevelBreakdown_Knowledge_5: Cred_LevelBreakdown_Knowledge_5,
    Cred_LevelBreakdown_Knowledge_6: Cred_LevelBreakdown_Knowledge_6,
    Cred_LevelBreakdown_Knowledge_7: Cred_LevelBreakdown_Knowledge_7,
    Cred_LevelBreakdown_Knowledge_8: Cred_LevelBreakdown_Knowledge_8,
    Cred_LevelBreakdown_Knowledge_Scale6_1: Cred_LevelBreakdown_Knowledge_Scale6_1,
    Cred_LevelBreakdown_Knowledge_Scale6_2: Cred_LevelBreakdown_Knowledge_Scale6_2,
    Cred_LevelBreakdown_Knowledge_Scale6_3: Cred_LevelBreakdown_Knowledge_Scale6_3,
    Cred_LevelBreakdown_Knowledge_Scale6_4: Cred_LevelBreakdown_Knowledge_Scale6_4,
    Cred_LevelBreakdown_Knowledge_Scale6_5: Cred_LevelBreakdown_Knowledge_Scale6_5,
    Cred_LevelBreakdown_Knowledge_Scale6_6: Cred_LevelBreakdown_Knowledge_Scale6_6,
    Cred_LevelBreakdown_Knowledge_Scale8_1: Cred_LevelBreakdown_Knowledge_Scale8_1,
    Cred_LevelBreakdown_Knowledge_Scale8_2: Cred_LevelBreakdown_Knowledge_Scale8_2,
    Cred_LevelBreakdown_Knowledge_Scale8_3: Cred_LevelBreakdown_Knowledge_Scale8_3,
    Cred_LevelBreakdown_Knowledge_Scale8_4: Cred_LevelBreakdown_Knowledge_Scale8_4,
    Cred_LevelBreakdown_Knowledge_Scale8_5: Cred_LevelBreakdown_Knowledge_Scale8_5,
    Cred_LevelBreakdown_Knowledge_Scale8_6: Cred_LevelBreakdown_Knowledge_Scale8_6,
    Cred_LevelBreakdown_Knowledge_Scale8_7: Cred_LevelBreakdown_Knowledge_Scale8_7,
    Cred_LevelBreakdown_Knowledge_Scale8_8: Cred_LevelBreakdown_Knowledge_Scale8_8,
    Cred_LevelBreakdown_Planning_1: Cred_LevelBreakdown_Planning_1,
    Cred_LevelBreakdown_Planning_2: Cred_LevelBreakdown_Planning_2,
    Cred_LevelBreakdown_Planning_3: Cred_LevelBreakdown_Planning_3,
    Cred_LevelBreakdown_Planning_4: Cred_LevelBreakdown_Planning_4,
    Cred_LevelBreakdown_Planning_5: Cred_LevelBreakdown_Planning_5,
    Cred_LevelBreakdown_Planning_6: Cred_LevelBreakdown_Planning_6,
    Cred_LevelBreakdown_Planning_7: Cred_LevelBreakdown_Planning_7,
    Cred_LevelBreakdown_Planning_8: Cred_LevelBreakdown_Planning_8,
    Cred_LevelBreakdown_Planning_Scale6_1: Cred_LevelBreakdown_Planning_Scale6_1,
    Cred_LevelBreakdown_Planning_Scale6_2: Cred_LevelBreakdown_Planning_Scale6_2,
    Cred_LevelBreakdown_Planning_Scale6_3: Cred_LevelBreakdown_Planning_Scale6_3,
    Cred_LevelBreakdown_Planning_Scale6_4: Cred_LevelBreakdown_Planning_Scale6_4,
    Cred_LevelBreakdown_Planning_Scale6_5: Cred_LevelBreakdown_Planning_Scale6_5,
    Cred_LevelBreakdown_Planning_Scale6_6: Cred_LevelBreakdown_Planning_Scale6_6,
    Cred_LevelBreakdown_Planning_Scale8_1: Cred_LevelBreakdown_Planning_Scale8_1,
    Cred_LevelBreakdown_Planning_Scale8_2: Cred_LevelBreakdown_Planning_Scale8_2,
    Cred_LevelBreakdown_Planning_Scale8_3: Cred_LevelBreakdown_Planning_Scale8_3,
    Cred_LevelBreakdown_Planning_Scale8_4: Cred_LevelBreakdown_Planning_Scale8_4,
    Cred_LevelBreakdown_Planning_Scale8_5: Cred_LevelBreakdown_Planning_Scale8_5,
    Cred_LevelBreakdown_Planning_Scale8_6: Cred_LevelBreakdown_Planning_Scale8_6,
    Cred_LevelBreakdown_Planning_Scale8_7: Cred_LevelBreakdown_Planning_Scale8_7,
    Cred_LevelBreakdown_Planning_Scale8_8: Cred_LevelBreakdown_Planning_Scale8_8,
    Cred_LevelBreakdown_Skills_1: Cred_LevelBreakdown_Skills_1,
    Cred_LevelBreakdown_Skills_2: Cred_LevelBreakdown_Skills_2,
    Cred_LevelBreakdown_Skills_3: Cred_LevelBreakdown_Skills_3,
    Cred_LevelBreakdown_Skills_4: Cred_LevelBreakdown_Skills_4,
    Cred_LevelBreakdown_Skills_5: Cred_LevelBreakdown_Skills_5,
    Cred_LevelBreakdown_Skills_6: Cred_LevelBreakdown_Skills_6,
    Cred_LevelBreakdown_Skills_7: Cred_LevelBreakdown_Skills_7,
    Cred_LevelBreakdown_Skills_8: Cred_LevelBreakdown_Skills_8,
    Cred_LevelBreakdown_Skills_Scale6_1: Cred_LevelBreakdown_Skills_Scale6_1,
    Cred_LevelBreakdown_Skills_Scale6_2: Cred_LevelBreakdown_Skills_Scale6_2,
    Cred_LevelBreakdown_Skills_Scale6_3: Cred_LevelBreakdown_Skills_Scale6_3,
    Cred_LevelBreakdown_Skills_Scale6_4: Cred_LevelBreakdown_Skills_Scale6_4,
    Cred_LevelBreakdown_Skills_Scale6_5: Cred_LevelBreakdown_Skills_Scale6_5,
    Cred_LevelBreakdown_Skills_Scale6_6: Cred_LevelBreakdown_Skills_Scale6_6,
    Cred_LevelBreakdown_Skills_Scale8_1: Cred_LevelBreakdown_Skills_Scale8_1,
    Cred_LevelBreakdown_Skills_Scale8_2: Cred_LevelBreakdown_Skills_Scale8_2,
    Cred_LevelBreakdown_Skills_Scale8_3: Cred_LevelBreakdown_Skills_Scale8_3,
    Cred_LevelBreakdown_Skills_Scale8_4: Cred_LevelBreakdown_Skills_Scale8_4,
    Cred_LevelBreakdown_Skills_Scale8_5: Cred_LevelBreakdown_Skills_Scale8_5,
    Cred_LevelBreakdown_Skills_Scale8_6: Cred_LevelBreakdown_Skills_Scale8_6,
    Cred_LevelBreakdown_Skills_Scale8_7: Cred_LevelBreakdown_Skills_Scale8_7,
    Cred_LevelBreakdown_Skills_Scale8_8: Cred_LevelBreakdown_Skills_Scale8_8,
    Cred_LevelBreakdown_Teaching_1: Cred_LevelBreakdown_Teaching_1,
    Cred_LevelBreakdown_Teaching_2: Cred_LevelBreakdown_Teaching_2,
    Cred_LevelBreakdown_Teaching_3: Cred_LevelBreakdown_Teaching_3,
    Cred_LevelBreakdown_Teaching_4: Cred_LevelBreakdown_Teaching_4,
    Cred_LevelBreakdown_Teaching_5: Cred_LevelBreakdown_Teaching_5,
    Cred_LevelBreakdown_Teaching_6: Cred_LevelBreakdown_Teaching_6,
    Cred_LevelBreakdown_Teaching_7: Cred_LevelBreakdown_Teaching_7,
    Cred_LevelBreakdown_Teaching_8: Cred_LevelBreakdown_Teaching_8,
    Cred_LevelBreakdown_Teaching_Scale6_1: Cred_LevelBreakdown_Teaching_Scale6_1,
    Cred_LevelBreakdown_Teaching_Scale6_2: Cred_LevelBreakdown_Teaching_Scale6_2,
    Cred_LevelBreakdown_Teaching_Scale6_3: Cred_LevelBreakdown_Teaching_Scale6_3,
    Cred_LevelBreakdown_Teaching_Scale6_4: Cred_LevelBreakdown_Teaching_Scale6_4,
    Cred_LevelBreakdown_Teaching_Scale6_5: Cred_LevelBreakdown_Teaching_Scale6_5,
    Cred_LevelBreakdown_Teaching_Scale6_6: Cred_LevelBreakdown_Teaching_Scale6_6,
    Cred_LevelBreakdown_Teaching_Scale8_1: Cred_LevelBreakdown_Teaching_Scale8_1,
    Cred_LevelBreakdown_Teaching_Scale8_2: Cred_LevelBreakdown_Teaching_Scale8_2,
    Cred_LevelBreakdown_Teaching_Scale8_3: Cred_LevelBreakdown_Teaching_Scale8_3,
    Cred_LevelBreakdown_Teaching_Scale8_4: Cred_LevelBreakdown_Teaching_Scale8_4,
    Cred_LevelBreakdown_Teaching_Scale8_5: Cred_LevelBreakdown_Teaching_Scale8_5,
    Cred_LevelBreakdown_Teaching_Scale8_6: Cred_LevelBreakdown_Teaching_Scale8_6,
    Cred_LevelBreakdown_Teaching_Scale8_7: Cred_LevelBreakdown_Teaching_Scale8_7,
    Cred_LevelBreakdown_Teaching_Scale8_8: Cred_LevelBreakdown_Teaching_Scale8_8,
    Cred_LevelBreakdown_Teamwork_1: Cred_LevelBreakdown_Teamwork_1,
    Cred_LevelBreakdown_Teamwork_2: Cred_LevelBreakdown_Teamwork_2,
    Cred_LevelBreakdown_Teamwork_3: Cred_LevelBreakdown_Teamwork_3,
    Cred_LevelBreakdown_Teamwork_4: Cred_LevelBreakdown_Teamwork_4,
    Cred_LevelBreakdown_Teamwork_5: Cred_LevelBreakdown_Teamwork_5,
    Cred_LevelBreakdown_Teamwork_6: Cred_LevelBreakdown_Teamwork_6,
    Cred_LevelBreakdown_Teamwork_7: Cred_LevelBreakdown_Teamwork_7,
    Cred_LevelBreakdown_Teamwork_8: Cred_LevelBreakdown_Teamwork_8,
    Cred_LevelBreakdown_Teamwork_Scale6_1: Cred_LevelBreakdown_Teamwork_Scale6_1,
    Cred_LevelBreakdown_Teamwork_Scale6_2: Cred_LevelBreakdown_Teamwork_Scale6_2,
    Cred_LevelBreakdown_Teamwork_Scale6_3: Cred_LevelBreakdown_Teamwork_Scale6_3,
    Cred_LevelBreakdown_Teamwork_Scale6_4: Cred_LevelBreakdown_Teamwork_Scale6_4,
    Cred_LevelBreakdown_Teamwork_Scale6_5: Cred_LevelBreakdown_Teamwork_Scale6_5,
    Cred_LevelBreakdown_Teamwork_Scale6_6: Cred_LevelBreakdown_Teamwork_Scale6_6,
    Cred_LevelBreakdown_Teamwork_Scale8_1: Cred_LevelBreakdown_Teamwork_Scale8_1,
    Cred_LevelBreakdown_Teamwork_Scale8_2: Cred_LevelBreakdown_Teamwork_Scale8_2,
    Cred_LevelBreakdown_Teamwork_Scale8_3: Cred_LevelBreakdown_Teamwork_Scale8_3,
    Cred_LevelBreakdown_Teamwork_Scale8_4: Cred_LevelBreakdown_Teamwork_Scale8_4,
    Cred_LevelBreakdown_Teamwork_Scale8_5: Cred_LevelBreakdown_Teamwork_Scale8_5,
    Cred_LevelBreakdown_Teamwork_Scale8_6: Cred_LevelBreakdown_Teamwork_Scale8_6,
    Cred_LevelBreakdown_Teamwork_Scale8_7: Cred_LevelBreakdown_Teamwork_Scale8_7,
    Cred_LevelBreakdown_Teamwork_Scale8_8: Cred_LevelBreakdown_Teamwork_Scale8_8,
    Cred_levelDescription_ViewAll: Cred_levelDescription_ViewAll,
    Cred_levelName1: Cred_levelName1,
    Cred_levelName2: Cred_levelName2,
    Cred_levelName3: Cred_levelName3,
    Cred_levelName4: Cred_levelName4,
    Cred_levelName5: Cred_levelName5,
    Cred_levelName6: Cred_levelName6,
    Cred_levelName7: Cred_levelName7,
    Cred_levelName8: Cred_levelName8,
    Cred_levelShortTitle: Cred_levelShortTitle,
    Cred_levelSummary_Breakdown: Cred_levelSummary_Breakdown,
    Cred_levelSummary1: Cred_levelSummary1,
    Cred_levelSummary2: Cred_levelSummary2,
    Cred_levelSummary3: Cred_levelSummary3,
    Cred_levelSummary4: Cred_levelSummary4,
    Cred_levelSummary5: Cred_levelSummary5,
    Cred_levelSummary6: Cred_levelSummary6,
    Cred_levelSummary7: Cred_levelSummary7,
    Cred_levelSummary8: Cred_levelSummary8,
    Cred_levelTitle: Cred_levelTitle,
    Cred_NextStep: Cred_NextStep,
    Cred_NoComparison_Header: Cred_NoComparison_Header,
    Cred_NoComparison_Instructions: Cred_NoComparison_Instructions,
    Cred_NoComparison_NoReviewsNeeded: Cred_NoComparison_NoReviewsNeeded,
    Cred_Overview_CompletePeerReviews: Cred_Overview_CompletePeerReviews,
    Cred_Overview_EditApplication: Cred_Overview_EditApplication,
    Cred_Overview_EditApplicationInstructions: Cred_Overview_EditApplicationInstructions,
    Cred_Overview_Instructions: Cred_Overview_Instructions,
    Cred_Overview_NextActions: Cred_Overview_NextActions,
    Cred_Overview_NextDeadline: Cred_Overview_NextDeadline,
    Cred_Overview_OptionalActions: Cred_Overview_OptionalActions,
    Cred_Overview_SubmitApplication: Cred_Overview_SubmitApplication,
    Cred_Overview_SubmitApplicationInstructions: Cred_Overview_SubmitApplicationInstructions,
    Cred_Overview_Title: Cred_Overview_Title,
    Cred_PaymentNotSupported: Cred_PaymentNotSupported,
    Cred_SkillBehavior_Original: Cred_SkillBehavior_Original,
    Cred_SkillBehavior_Translated: Cred_SkillBehavior_Translated,
    Cred_Status_AddNewEndorser: Cred_Status_AddNewEndorser,
    Cred_Status_ApplyCode: Cred_Status_ApplyCode,
    Cred_Status_CheckoutBtn: Cred_Status_CheckoutBtn,
    Cred_Status_DateCompletedFormat: Cred_Status_DateCompletedFormat,
    Cred_Status_DateDeclinedFormat: Cred_Status_DateDeclinedFormat,
    Cred_Status_DegreedReviewed: Cred_Status_DegreedReviewed,
    Cred_Status_DegreedReviewedDescription: Cred_Status_DegreedReviewedDescription,
    Cred_Status_DegreedReviewedDescriptionCompleted: Cred_Status_DegreedReviewedDescriptionCompleted,
    Cred_Status_EditInfo: Cred_Status_EditInfo,
    Cred_Status_EndorserAdded: Cred_Status_EndorserAdded,
    Cred_Status_EndorserHasntResponded: Cred_Status_EndorserHasntResponded,
    Cred_Status_Endorsers_Desc: Cred_Status_Endorsers_Desc,
    Cred_Status_EndorsersHeading: Cred_Status_EndorsersHeading,
    Cred_Status_EndorserUpdated: Cred_Status_EndorserUpdated,
    Cred_Status_Header: Cred_Status_Header,
    Cred_Status_Instructions1: Cred_Status_Instructions1,
    Cred_Status_Instructions2: Cred_Status_Instructions2,
    Cred_Status_InvitationSent: Cred_Status_InvitationSent,
    Cred_Status_PaymentDescription: Cred_Status_PaymentDescription,
    Cred_Status_PaymentHeading: Cred_Status_PaymentHeading,
    Cred_Status_PeerReviewed: Cred_Status_PeerReviewed,
    Cred_Status_PeerReviewedDescription: Cred_Status_PeerReviewedDescription,
    Cred_Status_PeerReviewedDescriptionCompleted: Cred_Status_PeerReviewedDescriptionCompleted,
    Cred_Status_Resend: Cred_Status_Resend,
    Cred_Status_ReviewsHeading: Cred_Status_ReviewsHeading,
    Cred_Status_ScAwarded: Cred_Status_ScAwarded,
    Cred_Status_ScAwardedDescription: Cred_Status_ScAwardedDescription,
    Cred_Status_ScNotAwarded: Cred_Status_ScNotAwarded,
    Cred_Status_ScNotAwardedDescription: Cred_Status_ScNotAwardedDescription,
    Cred_Status_ScPending: Cred_Status_ScPending,
    Cred_Status_ScPendingDescription: Cred_Status_ScPendingDescription,
    Cred_Status_SkipEndorser: Cred_Status_SkipEndorser,
    Cred_Status_WaitingOnEndorser: Cred_Status_WaitingOnEndorser,
    Cred_Submit_AppliedCodeText: Cred_Submit_AppliedCodeText,
    Cred_Submit_ApplyCodeText: Cred_Submit_ApplyCodeText,
    Cred_Submit_Header: Cred_Submit_Header,
    Cred_Submit_HeaderWithCredits: Cred_Submit_HeaderWithCredits,
    Cred_Submit_IAgreeGenuine: Cred_Submit_IAgreeGenuine,
    Cred_Submit_PaymentBillingInfo: Cred_Submit_PaymentBillingInfo,
    Cred_Submit_PaymentCard: Cred_Submit_PaymentCard,
    Cred_Submit_PaymentCardValidation: Cred_Submit_PaymentCardValidation,
    Cred_Submit_PaymentChoosePayment: Cred_Submit_PaymentChoosePayment,
    Cred_Submit_PaymentConfirm: Cred_Submit_PaymentConfirm,
    Cred_Submit_PaymentCurrency: Cred_Submit_PaymentCurrency,
    Cred_Submit_PaymentCvv: Cred_Submit_PaymentCvv,
    Cred_Submit_PaymentError: Cred_Submit_PaymentError,
    Cred_Submit_PaymentExp: Cred_Submit_PaymentExp,
    Cred_Submit_PaymentExpPlaceholder: Cred_Submit_PaymentExpPlaceholder,
    Cred_Submit_PaymentExpValidation: Cred_Submit_PaymentExpValidation,
    Cred_Submit_PaymentFirstName: Cred_Submit_PaymentFirstName,
    Cred_Submit_PaymentFirstNameValidation: Cred_Submit_PaymentFirstNameValidation,
    Cred_Submit_PaymentHeader: Cred_Submit_PaymentHeader,
    Cred_Submit_PaymentLastName: Cred_Submit_PaymentLastName,
    Cred_Submit_PaymentLastNameValidation: Cred_Submit_PaymentLastNameValidation,
    Cred_Submit_PaymentNotRequired: Cred_Submit_PaymentNotRequired,
    Cred_Submit_PaymentProvidedBy: Cred_Submit_PaymentProvidedBy,
    Cred_Submit_PaymentReceived: Cred_Submit_PaymentReceived,
    Cred_Submit_PlagiarismCheck: Cred_Submit_PlagiarismCheck,
    Cred_Submit_PlagiarismDescription: Cred_Submit_PlagiarismDescription,
    Cred_Submit_PlagiarismHeader: Cred_Submit_PlagiarismHeader,
    Cred_Submit_PromoCodeExpand: Cred_Submit_PromoCodeExpand,
    Cred_Submit_PromoNotFound: Cred_Submit_PromoNotFound,
    Cred_Submit_PromoProductError: Cred_Submit_PromoProductError,
    Cred_Submit_ReviewedByDescription: Cred_Submit_ReviewedByDescription,
    Cred_Submit_ReviewedByHeader: Cred_Submit_ReviewedByHeader,
    Cred_Submit_SaveApplication: Cred_Submit_SaveApplication,
    Cred_Submit_ScholarshipCode: Cred_Submit_ScholarshipCode,
    Cred_Submit_ScholarshipDiscount: Cred_Submit_ScholarshipDiscount,
    Cred_Submit_SecurePayment: Cred_Submit_SecurePayment,
    Cred_Submit_SkillProcessName: Cred_Submit_SkillProcessName,
    Cred_Submit_SubmitApplication: Cred_Submit_SubmitApplication,
    Cred_Submit_SubTotal: Cred_Submit_SubTotal,
    Cred_Submit_TermsAgree: Cred_Submit_TermsAgree,
    Cred_Submit_TermsDescription: Cred_Submit_TermsDescription,
    Cred_Submit_TermsHeader: Cred_Submit_TermsHeader,
    Cred_Success_Heading: Cred_Success_Heading,
    Cred_Success_Instructions: Cred_Success_Instructions,
    Cred_Success_InviteOthers: Cred_Success_InviteOthers,
    Cred_Success_SubHeading: Cred_Success_SubHeading,
    Cred_Verify_CodeLabel: Cred_Verify_CodeLabel,
    Cred_Verify_FollowupLabel: Cred_Verify_FollowupLabel,
    Cred_Verify_FollowupPlaceholder: Cred_Verify_FollowupPlaceholder,
    Cred_Verify_FollowupSuccess: Cred_Verify_FollowupSuccess,
    Cred_Verify_Heading: Cred_Verify_Heading,
    Cred_Verify_Instructions: Cred_Verify_Instructions,
    Cred_Verify_InvalidInstructions: Cred_Verify_InvalidInstructions,
    Cred_Verify_InvalidMessage: Cred_Verify_InvalidMessage,
    Cred_Verify_ValidMessage: Cred_Verify_ValidMessage,
    Cred_Verify_VerifyCodeButton: Cred_Verify_VerifyCodeButton,
    Cred_Wait_Heading: Cred_Wait_Heading,
    Cred_Wait_Instructions: Cred_Wait_Instructions,
    Cred_Wait_InviteOthers: Cred_Wait_InviteOthers,
    Cred_Wait_SubHeading: Cred_Wait_SubHeading,
    CredAcceptCtrl_AgreeLabel: CredAcceptCtrl_AgreeLabel,
    CredAcceptCtrl_AgreeValidationMessage: CredAcceptCtrl_AgreeValidationMessage,
    CredAcceptCtrl_Header: CredAcceptCtrl_Header,
    CredAcceptCtrl_HonorCodeDescription: CredAcceptCtrl_HonorCodeDescription,
    CredAcceptCtrl_Instructions: CredAcceptCtrl_Instructions,
    CredAcceptCtrl_Submit: CredAcceptCtrl_Submit,
    CredAcceptCtrl_Title: CredAcceptCtrl_Title,
    CredApplyOverviewCtrl_ApplicationDeleted: CredApplyOverviewCtrl_ApplicationDeleted,
    CredApplyOverviewCtrl_DeletePrompt: CredApplyOverviewCtrl_DeletePrompt,
    CredApplyOverviewCtrl_MinReqsMet: CredApplyOverviewCtrl_MinReqsMet,
    CredApplyOverviewCtrl_MinReqsNotMet: CredApplyOverviewCtrl_MinReqsNotMet,
    CredentialAwardedEmail_Autonomy: CredentialAwardedEmail_Autonomy,
    CredentialAwardedEmail_Autonomy1Desc: CredentialAwardedEmail_Autonomy1Desc,
    CredentialAwardedEmail_Autonomy2Desc: CredentialAwardedEmail_Autonomy2Desc,
    CredentialAwardedEmail_Autonomy3Desc: CredentialAwardedEmail_Autonomy3Desc,
    CredentialAwardedEmail_Autonomy4Desc: CredentialAwardedEmail_Autonomy4Desc,
    CredentialAwardedEmail_Autonomy5Desc: CredentialAwardedEmail_Autonomy5Desc,
    CredentialAwardedEmail_Autonomy6Desc: CredentialAwardedEmail_Autonomy6Desc,
    CredentialAwardedEmail_Autonomy7Desc: CredentialAwardedEmail_Autonomy7Desc,
    CredentialAwardedEmail_Autonomy8Desc: CredentialAwardedEmail_Autonomy8Desc,
    CredentialAwardedEmail_Industry: CredentialAwardedEmail_Industry,
    CredentialAwardedEmail_Industry1Desc: CredentialAwardedEmail_Industry1Desc,
    CredentialAwardedEmail_Industry2Desc: CredentialAwardedEmail_Industry2Desc,
    CredentialAwardedEmail_Industry3Desc: CredentialAwardedEmail_Industry3Desc,
    CredentialAwardedEmail_Industry4Desc: CredentialAwardedEmail_Industry4Desc,
    CredentialAwardedEmail_Industry5Desc: CredentialAwardedEmail_Industry5Desc,
    CredentialAwardedEmail_Industry6Desc: CredentialAwardedEmail_Industry6Desc,
    CredentialAwardedEmail_Industry7Desc: CredentialAwardedEmail_Industry7Desc,
    CredentialAwardedEmail_Industry8Desc: CredentialAwardedEmail_Industry8Desc,
    CredentialAwardedEmail_Knowledge: CredentialAwardedEmail_Knowledge,
    CredentialAwardedEmail_Knowledge1Desc: CredentialAwardedEmail_Knowledge1Desc,
    CredentialAwardedEmail_Knowledge2Desc: CredentialAwardedEmail_Knowledge2Desc,
    CredentialAwardedEmail_Knowledge3Desc: CredentialAwardedEmail_Knowledge3Desc,
    CredentialAwardedEmail_Knowledge4Desc: CredentialAwardedEmail_Knowledge4Desc,
    CredentialAwardedEmail_Knowledge5Desc: CredentialAwardedEmail_Knowledge5Desc,
    CredentialAwardedEmail_Knowledge6Desc: CredentialAwardedEmail_Knowledge6Desc,
    CredentialAwardedEmail_Knowledge7Desc: CredentialAwardedEmail_Knowledge7Desc,
    CredentialAwardedEmail_Knowledge8Desc: CredentialAwardedEmail_Knowledge8Desc,
    CredentialAwardedEmail_LearnMore: CredentialAwardedEmail_LearnMore,
    CredentialAwardedEmail_LearnMoreDescFormat: CredentialAwardedEmail_LearnMoreDescFormat,
    CredentialAwardedEmail_Level10Desc: CredentialAwardedEmail_Level10Desc,
    CredentialAwardedEmail_Level1Desc: CredentialAwardedEmail_Level1Desc,
    CredentialAwardedEmail_Level1Intro: CredentialAwardedEmail_Level1Intro,
    CredentialAwardedEmail_Level1Title: CredentialAwardedEmail_Level1Title,
    CredentialAwardedEmail_Level2Desc: CredentialAwardedEmail_Level2Desc,
    CredentialAwardedEmail_Level2Intro: CredentialAwardedEmail_Level2Intro,
    CredentialAwardedEmail_Level2Title: CredentialAwardedEmail_Level2Title,
    CredentialAwardedEmail_Level3Desc: CredentialAwardedEmail_Level3Desc,
    CredentialAwardedEmail_Level3Intro: CredentialAwardedEmail_Level3Intro,
    CredentialAwardedEmail_Level3Title: CredentialAwardedEmail_Level3Title,
    CredentialAwardedEmail_Level4Desc: CredentialAwardedEmail_Level4Desc,
    CredentialAwardedEmail_Level4Intro: CredentialAwardedEmail_Level4Intro,
    CredentialAwardedEmail_Level4Title: CredentialAwardedEmail_Level4Title,
    CredentialAwardedEmail_Level5Desc: CredentialAwardedEmail_Level5Desc,
    CredentialAwardedEmail_Level5Intro: CredentialAwardedEmail_Level5Intro,
    CredentialAwardedEmail_Level5Title: CredentialAwardedEmail_Level5Title,
    CredentialAwardedEmail_Level6Desc: CredentialAwardedEmail_Level6Desc,
    CredentialAwardedEmail_Level6Intro: CredentialAwardedEmail_Level6Intro,
    CredentialAwardedEmail_Level6Title: CredentialAwardedEmail_Level6Title,
    CredentialAwardedEmail_Level7Desc: CredentialAwardedEmail_Level7Desc,
    CredentialAwardedEmail_Level7Intro: CredentialAwardedEmail_Level7Intro,
    CredentialAwardedEmail_Level7Title: CredentialAwardedEmail_Level7Title,
    CredentialAwardedEmail_Level8Desc: CredentialAwardedEmail_Level8Desc,
    CredentialAwardedEmail_Level8Intro: CredentialAwardedEmail_Level8Intro,
    CredentialAwardedEmail_Level8Title: CredentialAwardedEmail_Level8Title,
    CredentialAwardedEmail_Level9Desc: CredentialAwardedEmail_Level9Desc,
    CredentialAwardedEmail_LevelUp: CredentialAwardedEmail_LevelUp,
    CredentialAwardedEmail_LevelUp1Desc: CredentialAwardedEmail_LevelUp1Desc,
    CredentialAwardedEmail_LevelUp2Desc: CredentialAwardedEmail_LevelUp2Desc,
    CredentialAwardedEmail_LevelUp3Desc: CredentialAwardedEmail_LevelUp3Desc,
    CredentialAwardedEmail_LevelUp4Desc: CredentialAwardedEmail_LevelUp4Desc,
    CredentialAwardedEmail_LevelUp5Desc: CredentialAwardedEmail_LevelUp5Desc,
    CredentialAwardedEmail_LevelUp6Desc: CredentialAwardedEmail_LevelUp6Desc,
    CredentialAwardedEmail_LevelUp7Desc: CredentialAwardedEmail_LevelUp7Desc,
    CredentialAwardedEmail_LevelUp8Desc: CredentialAwardedEmail_LevelUp8Desc,
    CredentialAwardedEmail_MessageParagraph1Format: CredentialAwardedEmail_MessageParagraph1Format,
    CredentialAwardedEmail_MessageParagraph2: CredentialAwardedEmail_MessageParagraph2,
    CredentialAwardedEmail_MessageParagraph3: CredentialAwardedEmail_MessageParagraph3,
    CredentialAwardedEmail_MessageParagraph6: CredentialAwardedEmail_MessageParagraph6,
    CredentialAwardedEmail_MessageParagraph7: CredentialAwardedEmail_MessageParagraph7,
    CredentialAwardedEmail_ShareYourExpertise: CredentialAwardedEmail_ShareYourExpertise,
    CredentialAwardedEmail_ShareYourExpertiseDesc: CredentialAwardedEmail_ShareYourExpertiseDesc,
    CredentialAwardedEmail_Subject: CredentialAwardedEmail_Subject,
    CredentialAwardedEmail_TaskTools: CredentialAwardedEmail_TaskTools,
    CredentialAwardedEmail_TaskTools1Desc: CredentialAwardedEmail_TaskTools1Desc,
    CredentialAwardedEmail_TaskTools2Desc: CredentialAwardedEmail_TaskTools2Desc,
    CredentialAwardedEmail_TaskTools3Desc: CredentialAwardedEmail_TaskTools3Desc,
    CredentialAwardedEmail_TaskTools4Desc: CredentialAwardedEmail_TaskTools4Desc,
    CredentialAwardedEmail_TaskTools5Desc: CredentialAwardedEmail_TaskTools5Desc,
    CredentialAwardedEmail_TaskTools6Desc: CredentialAwardedEmail_TaskTools6Desc,
    CredentialAwardedEmail_TaskTools7Desc: CredentialAwardedEmail_TaskTools7Desc,
    CredentialAwardedEmail_TaskTools8Desc: CredentialAwardedEmail_TaskTools8Desc,
    CredentialAwardedEmail_Title: CredentialAwardedEmail_Title,
    CredentialCompleteBehaviorsEmail_MessageParagraph1Format: CredentialCompleteBehaviorsEmail_MessageParagraph1Format,
    CredentialCompleteBehaviorsEmail_MessageParagraph2: CredentialCompleteBehaviorsEmail_MessageParagraph2,
    CredentialCompleteBehaviorsEmail_MessageParagraph3: CredentialCompleteBehaviorsEmail_MessageParagraph3,
    CredentialCompleteBehaviorsEmail_MessageParagraph4: CredentialCompleteBehaviorsEmail_MessageParagraph4,
    CredentialCompleteBehaviorsEmail_MessageParagraph5: CredentialCompleteBehaviorsEmail_MessageParagraph5,
    CredentialCompleteBehaviorsEmail_MessageParagraph6Format: CredentialCompleteBehaviorsEmail_MessageParagraph6Format,
    CredentialCompleteBehaviorsEmail_Subject: CredentialCompleteBehaviorsEmail_Subject,
    CredentialCompleteBehaviorsEmail_Title: CredentialCompleteBehaviorsEmail_Title,
    CredentialCompleteEndorsersEmail_MessageParagraph1: CredentialCompleteEndorsersEmail_MessageParagraph1,
    CredentialCompleteEndorsersEmail_MessageParagraph2: CredentialCompleteEndorsersEmail_MessageParagraph2,
    CredentialCompleteEndorsersEmail_MessageParagraph3: CredentialCompleteEndorsersEmail_MessageParagraph3,
    CredentialCompleteEndorsersEmail_MessageParagraph4: CredentialCompleteEndorsersEmail_MessageParagraph4,
    CredentialCompleteEndorsersEmail_MessageParagraph5: CredentialCompleteEndorsersEmail_MessageParagraph5,
    CredentialCompleteEndorsersEmail_Subject: CredentialCompleteEndorsersEmail_Subject,
    CredentialCompleteEndorsersEmail_Title: CredentialCompleteEndorsersEmail_Title,
    CredentialEmail_AwardVideo: CredentialEmail_AwardVideo,
    CredentialEmail_ContinueToApplication: CredentialEmail_ContinueToApplication,
    CredentialEmail_FooterReason: CredentialEmail_FooterReason,
    CredentialEmail_GetCertified: CredentialEmail_GetCertified,
    CredentialEmail_ReviewPeers: CredentialEmail_ReviewPeers,
    CredentialEmail_ViewCertificate: CredentialEmail_ViewCertificate,
    CredentialEmail_ViewEndorsements: CredentialEmail_ViewEndorsements,
    CredentialEmail_ViewStatus: CredentialEmail_ViewStatus,
    CredentialEmail_WhatIsDegreed: CredentialEmail_WhatIsDegreed,
    CredentialEmail_WhatIsDegreedDesc: CredentialEmail_WhatIsDegreedDesc,
    CredentialEndorserCompletedEmail_MessageParagraph1Format: CredentialEndorserCompletedEmail_MessageParagraph1Format,
    CredentialEndorserCompletedEmail_MessageParagraph2Format: CredentialEndorserCompletedEmail_MessageParagraph2Format,
    CredentialEndorserCompletedEmail_MessageParagraph3Format: CredentialEndorserCompletedEmail_MessageParagraph3Format,
    CredentialEndorserCompletedEmail_Subject: CredentialEndorserCompletedEmail_Subject,
    CredentialEndorserCompletedEmail_Title: CredentialEndorserCompletedEmail_Title,
    CredentialEndorserDeclinedEmail_MessageParagraph1Format: CredentialEndorserDeclinedEmail_MessageParagraph1Format,
    CredentialEndorserDeclinedEmail_MessageParagraph2: CredentialEndorserDeclinedEmail_MessageParagraph2,
    CredentialEndorserDeclinedEmail_Subject: CredentialEndorserDeclinedEmail_Subject,
    CredentialEndorserDeclinedEmail_Title: CredentialEndorserDeclinedEmail_Title,
    CredentialEndorserFollowupEmail_MessageParagraph1Format: CredentialEndorserFollowupEmail_MessageParagraph1Format,
    CredentialEndorserFollowupEmail_MessageParagraph2: CredentialEndorserFollowupEmail_MessageParagraph2,
    CredentialEndorserFollowupEmail_MessageParagraph3Format: CredentialEndorserFollowupEmail_MessageParagraph3Format,
    CredentialEndorserFollowupEmail_Subject: CredentialEndorserFollowupEmail_Subject,
    CredentialEndorserFollowupEmail_TitleFormat: CredentialEndorserFollowupEmail_TitleFormat,
    CredentialEndorsersInitialEmail_MessageParagraph1Format: CredentialEndorsersInitialEmail_MessageParagraph1Format,
    CredentialEndorsersInitialEmail_MessageParagraph2Format: CredentialEndorsersInitialEmail_MessageParagraph2Format,
    CredentialEndorsersInitialEmail_MessageParagraph3Format: CredentialEndorsersInitialEmail_MessageParagraph3Format,
    CredentialEndorsersInitialEmail_MessageParagraph4Format: CredentialEndorsersInitialEmail_MessageParagraph4Format,
    CredentialEndorsersInitialEmail_MessageParagraph5: CredentialEndorsersInitialEmail_MessageParagraph5,
    CredentialEndorsersInitialEmail_Subject: CredentialEndorsersInitialEmail_Subject,
    CredentialEndorsersInitialEmail_Title: CredentialEndorsersInitialEmail_Title,
    CredentialEndorserThankEmail_MessageParagraph1Format: CredentialEndorserThankEmail_MessageParagraph1Format,
    CredentialEndorserThankEmail_MessageParagraph2Format: CredentialEndorserThankEmail_MessageParagraph2Format,
    CredentialEndorserThankEmail_MessageParagraph3: CredentialEndorserThankEmail_MessageParagraph3,
    CredentialEndorserThankEmail_MessageParagraph4Format: CredentialEndorserThankEmail_MessageParagraph4Format,
    CredentialEndorserThankEmail_PromoCode: CredentialEndorserThankEmail_PromoCode,
    CredentialEndorserThankEmail_Subject: CredentialEndorserThankEmail_Subject,
    CredentialEndorserThankEmail_Title: CredentialEndorserThankEmail_Title,
    CredentialEndorserThankEmail_ViewProfile: CredentialEndorserThankEmail_ViewProfile,
    CredentialPaidInFullViaPromoEmail_Header: CredentialPaidInFullViaPromoEmail_Header,
    CredentialPaidInFullViaPromoEmail_MessageParagraph1Format: CredentialPaidInFullViaPromoEmail_MessageParagraph1Format,
    CredentialPaidInFullViaPromoEmail_MessageParagraph2: CredentialPaidInFullViaPromoEmail_MessageParagraph2,
    CredentialPaidInFullViaPromoEmail_PromotionalCodeDiscount: CredentialPaidInFullViaPromoEmail_PromotionalCodeDiscount,
    CredentialPaidInFullViaPromoEmail_Subject: CredentialPaidInFullViaPromoEmail_Subject,
    CredentialPaidInFullViaPromoEmail_Subtotal: CredentialPaidInFullViaPromoEmail_Subtotal,
    CredentialPaidInFullViaPromoEmail_Title: CredentialPaidInFullViaPromoEmail_Title,
    CredentialRateYourPeersEmail_MessageParagraph1: CredentialRateYourPeersEmail_MessageParagraph1,
    CredentialRateYourPeersEmail_MessageParagraph2Format: CredentialRateYourPeersEmail_MessageParagraph2Format,
    CredentialRateYourPeersEmail_MessageParagraph3Format: CredentialRateYourPeersEmail_MessageParagraph3Format,
    CredentialRateYourPeersEmail_MessageParagraph4: CredentialRateYourPeersEmail_MessageParagraph4,
    CredentialRateYourPeersEmail_Subject: CredentialRateYourPeersEmail_Subject,
    CredentialRateYourPeersEmail_Title: CredentialRateYourPeersEmail_Title,
    CredentialRateYourPeersFollowupEmail_MessageParagraph1: CredentialRateYourPeersFollowupEmail_MessageParagraph1,
    CredentialRateYourPeersFollowupEmail_MessageParagraph2Format: CredentialRateYourPeersFollowupEmail_MessageParagraph2Format,
    CredentialRateYourPeersFollowupEmail_MessageParagraph3Format: CredentialRateYourPeersFollowupEmail_MessageParagraph3Format,
    CredentialRateYourPeersFollowupEmail_MessageParagraph4: CredentialRateYourPeersFollowupEmail_MessageParagraph4,
    CredentialRateYourPeersFollowupEmail_MessageParagraph5Format: CredentialRateYourPeersFollowupEmail_MessageParagraph5Format,
    CredentialRateYourPeersFollowupEmail_Subject: CredentialRateYourPeersFollowupEmail_Subject,
    CredentialRateYourPeersFollowupEmail_Title: CredentialRateYourPeersFollowupEmail_Title,
    CredentialReviewSvc_ErrorSubmitting: CredentialReviewSvc_ErrorSubmitting,
    CredentialReviewSvc_GetBehaviorsError: CredentialReviewSvc_GetBehaviorsError,
    CredentialReviewSvc_GetError: CredentialReviewSvc_GetError,
    CredentialReviewSvc_GetReviewError: CredentialReviewSvc_GetReviewError,
    CredentialSubmissionReminderEmail_FromAddress: CredentialSubmissionReminderEmail_FromAddress,
    CredentialSubmissionReminderEmail_MessageParagraph1: CredentialSubmissionReminderEmail_MessageParagraph1,
    CredentialSubmissionReminderEmail_MessageParagraph2Format: CredentialSubmissionReminderEmail_MessageParagraph2Format,
    CredentialSubmissionReminderEmail_MessageParagraph3Format: CredentialSubmissionReminderEmail_MessageParagraph3Format,
    CredentialSubmissionReminderEmail_MessageParagraph4Format: CredentialSubmissionReminderEmail_MessageParagraph4Format,
    CredentialSubmissionReminderEmail_MessageParagraph5: CredentialSubmissionReminderEmail_MessageParagraph5,
    CredentialSubmissionReminderEmail_MessageParagraph6: CredentialSubmissionReminderEmail_MessageParagraph6,
    CredentialSubmissionReminderEmail_Subject: CredentialSubmissionReminderEmail_Subject,
    CredentialSubmissionReminderEmail_Title: CredentialSubmissionReminderEmail_Title,
    CredentialSubmittedEmail_MessageParagraph1Format: CredentialSubmittedEmail_MessageParagraph1Format,
    CredentialSubmittedEmail_MessageParagraph2: CredentialSubmittedEmail_MessageParagraph2,
    CredentialSubmittedEmail_MessageParagraph3Format: CredentialSubmittedEmail_MessageParagraph3Format,
    CredentialSubmittedEmail_MessageParagraph4Format: CredentialSubmittedEmail_MessageParagraph4Format,
    CredentialSubmittedEmail_Subject: CredentialSubmittedEmail_Subject,
    CredentialSubmittedEmail_Title: CredentialSubmittedEmail_Title,
    CredentialSvc_AddUserCredError: CredentialSvc_AddUserCredError,
    CredentialSvc_ApplyPaymentError: CredentialSvc_ApplyPaymentError,
    CredentialSvc_CohortError: CredentialSvc_CohortError,
    CredentialSvc_DeleteError: CredentialSvc_DeleteError,
    CredentialSvc_DeleteSuccess: CredentialSvc_DeleteSuccess,
    CredentialSvc_ErrorSavingChanges: CredentialSvc_ErrorSavingChanges,
    CredentialSvc_GetAllUserCredsError: CredentialSvc_GetAllUserCredsError,
    CredentialSvc_GetBehaviorsError: CredentialSvc_GetBehaviorsError,
    CredentialSvc_GetComparisonError: CredentialSvc_GetComparisonError,
    CredentialSvc_GetCredError: CredentialSvc_GetCredError,
    CredentialSvc_GetCredsError: CredentialSvc_GetCredsError,
    CredentialSvc_GetEndorsersError: CredentialSvc_GetEndorsersError,
    CredentialSvc_GetLinksError: CredentialSvc_GetLinksError,
    CredentialSvc_GetPaymentError: CredentialSvc_GetPaymentError,
    CredentialSvc_GetProfileError: CredentialSvc_GetProfileError,
    CredentialSvc_GetReviewStatusError: CredentialSvc_GetReviewStatusError,
    CredentialSvc_GetScholarshipStatusError: CredentialSvc_GetScholarshipStatusError,
    CredentialSvc_GetSocialLinksError: CredentialSvc_GetSocialLinksError,
    CredentialSvc_GetTagsError: CredentialSvc_GetTagsError,
    CredentialSvc_GetUserCredError: CredentialSvc_GetUserCredError,
    CredentialSvc_SetBehaviorsError: CredentialSvc_SetBehaviorsError,
    CredentialSvc_SetComparisonError: CredentialSvc_SetComparisonError,
    CredentialSvc_SetEndorsersError: CredentialSvc_SetEndorsersError,
    CredentialSvc_SetLinksError: CredentialSvc_SetLinksError,
    CredentialSvc_SetProfileError: CredentialSvc_SetProfileError,
    CredentialSvc_SetScholarshipCodeError: CredentialSvc_SetScholarshipCodeError,
    CredentialSvc_SetTagsError: CredentialSvc_SetTagsError,
    CredentialSvc_SubmitError: CredentialSvc_SubmitError,
    CredentialWaitForReviewsEmail_MessageParagraph1: CredentialWaitForReviewsEmail_MessageParagraph1,
    CredentialWaitForReviewsEmail_MessageParagraph2: CredentialWaitForReviewsEmail_MessageParagraph2,
    CredentialWaitForReviewsEmail_MessageParagraph3: CredentialWaitForReviewsEmail_MessageParagraph3,
    CredentialWaitForReviewsEmail_MessageParagraph4: CredentialWaitForReviewsEmail_MessageParagraph4,
    CredentialWaitForReviewsEmail_Subject: CredentialWaitForReviewsEmail_Subject,
    CredentialWaitForReviewsEmail_Title: CredentialWaitForReviewsEmail_Title,
    CredentialWaitingForEndorsementsEmail_MessageParagraph1: CredentialWaitingForEndorsementsEmail_MessageParagraph1,
    CredentialWaitingForEndorsementsEmail_MessageParagraph2: CredentialWaitingForEndorsementsEmail_MessageParagraph2,
    CredentialWaitingForEndorsementsEmail_MessageParagraph3: CredentialWaitingForEndorsementsEmail_MessageParagraph3,
    CredentialWaitingForEndorsementsEmail_MessageParagraph3Format: CredentialWaitingForEndorsementsEmail_MessageParagraph3Format,
    CredentialWaitingForEndorsementsEmail_MessageParagraph4Format: CredentialWaitingForEndorsementsEmail_MessageParagraph4Format,
    CredentialWaitingForEndorsementsEmail_MessageParagraphInfo: CredentialWaitingForEndorsementsEmail_MessageParagraphInfo,
    CredentialWaitingForEndorsementsEmail_Subject: CredentialWaitingForEndorsementsEmail_Subject,
    CredentialWaitingForEndorsementsEmail_Title: CredentialWaitingForEndorsementsEmail_Title,
    CredentialWelcomeEmail_MessageDearFormat: CredentialWelcomeEmail_MessageDearFormat,
    CredentialWelcomeEmail_MessageParagraph1: CredentialWelcomeEmail_MessageParagraph1,
    CredentialWelcomeEmail_MessageParagraph10Format: CredentialWelcomeEmail_MessageParagraph10Format,
    CredentialWelcomeEmail_MessageParagraph11: CredentialWelcomeEmail_MessageParagraph11,
    CredentialWelcomeEmail_MessageParagraph12: CredentialWelcomeEmail_MessageParagraph12,
    CredentialWelcomeEmail_MessageParagraph1Format: CredentialWelcomeEmail_MessageParagraph1Format,
    CredentialWelcomeEmail_MessageParagraph2: CredentialWelcomeEmail_MessageParagraph2,
    CredentialWelcomeEmail_MessageParagraph3: CredentialWelcomeEmail_MessageParagraph3,
    CredentialWelcomeEmail_MessageParagraph3Format: CredentialWelcomeEmail_MessageParagraph3Format,
    CredentialWelcomeEmail_MessageParagraph4: CredentialWelcomeEmail_MessageParagraph4,
    CredentialWelcomeEmail_MessageParagraph5: CredentialWelcomeEmail_MessageParagraph5,
    CredentialWelcomeEmail_MessageParagraph6: CredentialWelcomeEmail_MessageParagraph6,
    CredentialWelcomeEmail_MessageParagraph7: CredentialWelcomeEmail_MessageParagraph7,
    CredentialWelcomeEmail_MessageParagraph8: CredentialWelcomeEmail_MessageParagraph8,
    CredentialWelcomeEmail_MessageParagraph9: CredentialWelcomeEmail_MessageParagraph9,
    CredentialWelcomeEmail_MessageWelcomeFormat: CredentialWelcomeEmail_MessageWelcomeFormat,
    CredentialWelcomeEmail_PreviewFormat: CredentialWelcomeEmail_PreviewFormat,
    CredentialWelcomeEmail_Subject: CredentialWelcomeEmail_Subject,
    CredEvidenceForm_AddUrl: CredEvidenceForm_AddUrl,
    CredEvidenceForm_Complete: CredEvidenceForm_Complete,
    CredEvidenceForm_FileTypes: CredEvidenceForm_FileTypes,
    CredEvidenceForm_InsertEvidence: CredEvidenceForm_InsertEvidence,
    CredEvidenceForm_Processing: CredEvidenceForm_Processing,
    CredEvidenceForm_ProvideEvidence: CredEvidenceForm_ProvideEvidence,
    CredEvidenceForm_TitleOfEvidence: CredEvidenceForm_TitleOfEvidence,
    CredEvidenceForm_titleRequired: CredEvidenceForm_titleRequired,
    CredEvidenceForm_UnableToUpload: CredEvidenceForm_UnableToUpload,
    CredEvidenceForm_UploadFile: CredEvidenceForm_UploadFile,
    CredEvidenceForm_urlFileRequired: CredEvidenceForm_urlFileRequired,
    CredHonorCodeCtrl_AgreeLabel: CredHonorCodeCtrl_AgreeLabel,
    CredHonorCodeCtrl_DeclarationTitle: CredHonorCodeCtrl_DeclarationTitle,
    CredHonorCodeCtrl_Header: CredHonorCodeCtrl_Header,
    CredHonorCodeCtrl_Instructions: CredHonorCodeCtrl_Instructions,
    CredHonorCodeCtrl_Submit: CredHonorCodeCtrl_Submit,
    CredManageOutcomesCtrl_MaxErrorAccomplishmentFormat: CredManageOutcomesCtrl_MaxErrorAccomplishmentFormat,
    CredManageOutcomesCtrl_MaxErrorSkillFormat: CredManageOutcomesCtrl_MaxErrorSkillFormat,
    CredManageOutcomesCtrl_MaxErrorTitle: CredManageOutcomesCtrl_MaxErrorTitle,
    CredManageOutcomesCtrl_TitleAccomplishment: CredManageOutcomesCtrl_TitleAccomplishment,
    CredManageOutcomesCtrl_TitleAward: CredManageOutcomesCtrl_TitleAward,
    CredManageOutcomesCtrl_TitleCertificate: CredManageOutcomesCtrl_TitleCertificate,
    CredManageOutcomesCtrl_TitleDegree: CredManageOutcomesCtrl_TitleDegree,
    CredManageOutcomesCtrl_TitleSkill: CredManageOutcomesCtrl_TitleSkill,
    CredManageTagsCtrl_ManageArticlesVideos: CredManageTagsCtrl_ManageArticlesVideos,
    CredManageTagsCtrl_ManageInformal: CredManageTagsCtrl_ManageInformal,
    CredNav_AcceptHonorCode: CredNav_AcceptHonorCode,
    CredNav_Application: CredNav_Application,
    CredNav_ApplicationDescription: CredNav_ApplicationDescription,
    CredNav_Behavior1: CredNav_Behavior1,
    CredNav_Behavior2: CredNav_Behavior2,
    CredNav_Behavior3: CredNav_Behavior3,
    CredNav_Behaviors: CredNav_Behaviors,
    CredNav_Compare: CredNav_Compare,
    CredNav_CompareDescription: CredNav_CompareDescription,
    CredNav_Endorsers: CredNav_Endorsers,
    CredNav_EndorsersDescription: CredNav_EndorsersDescription,
    CredNav_FinalCheck: CredNav_FinalCheck,
    CredNav_heading: CredNav_heading,
    CredNav_IdentityVerification: CredNav_IdentityVerification,
    CredNav_PeerComparison1: CredNav_PeerComparison1,
    CredNav_PeerComparison2: CredNav_PeerComparison2,
    CredNav_PeerComparison3: CredNav_PeerComparison3,
    CredNav_PeerComparisonFormat: CredNav_PeerComparisonFormat,
    CredNav_Results: CredNav_Results,
    CredNav_ResultsDescription: CredNav_ResultsDescription,
    CredNav_ReviewApplication: CredNav_ReviewApplication,
    CredNav_SkillCertification: CredNav_SkillCertification,
    CredNav_SkillReview: CredNav_SkillReview,
    CredNav_Status: CredNav_Status,
    CredNav_StatusDescription: CredNav_StatusDescription,
    CredNav_Submit: CredNav_Submit,
    CredNav_SubmitWithCredits: CredNav_SubmitWithCredits,
    CredNav_WaitForCohort: CredNav_WaitForCohort,
    CredPaymentSvc_PaymentInfoError: CredPaymentSvc_PaymentInfoError,
    CredPrePayChooseSkillCtrl_ChooseASkill: CredPrePayChooseSkillCtrl_ChooseASkill,
    CredPrePayChooseSkillCtrl_ChooseSkill: CredPrePayChooseSkillCtrl_ChooseSkill,
    CredPrePayChooseSkillCtrl_ContinueToApplication: CredPrePayChooseSkillCtrl_ContinueToApplication,
    CredPrePayChooseSkillCtrl_ResultsForFormat: CredPrePayChooseSkillCtrl_ResultsForFormat,
    CredPrePayChooseSkillCtrl_SearchCatalog: CredPrePayChooseSkillCtrl_SearchCatalog,
    CredPrePayCtrl_Payment: CredPrePayCtrl_Payment,
    CredPrePayCtrl_SaveAndConfirm: CredPrePayCtrl_SaveAndConfirm,
    CredPrePayCtrl_SubmitPayment: CredPrePayCtrl_SubmitPayment,
    CredPrePayType_CertificationType: CredPrePayType_CertificationType,
    CredPrePayType_credit: CredPrePayType_credit,
    CredPrePayType_creditAction: CredPrePayType_creditAction,
    CredPrePayType_creditDescription: CredPrePayType_creditDescription,
    CredPrePayType_lifetime: CredPrePayType_lifetime,
    CredPrePayType_lifetimeAction: CredPrePayType_lifetimeAction,
    CredPrePayType_lifetimeDescription: CredPrePayType_lifetimeDescription,
    CredPrePayType_LimitedOffer: CredPrePayType_LimitedOffer,
    CredPrePayType_OneSkillDescription: CredPrePayType_OneSkillDescription,
    CredPrePayType_TypeHeading: CredPrePayType_TypeHeading,
    CredResultsCtrl_CongratsParagraph: CredResultsCtrl_CongratsParagraph,
    CredResultsCtrl_CongratsTitle: CredResultsCtrl_CongratsTitle,
    CredReviewCtrl_ConfirmButton: CredReviewCtrl_ConfirmButton,
    CredReviewCtrl_Description: CredReviewCtrl_Description,
    CredReviewCtrl_Endorsers: CredReviewCtrl_Endorsers,
    CredSpark_MissingEmployeeId: CredSpark_MissingEmployeeId,
    CredSparkSvc_AssessmentError: CredSparkSvc_AssessmentError,
    CredSparkSvc_SyncError: CredSparkSvc_SyncError,
    CredStartCtrl_ApplicationReviewed: CredStartCtrl_ApplicationReviewed,
    CredStartCtrl_AssertBehaviors: CredStartCtrl_AssertBehaviors,
    CredStartCtrl_DegreedSkillsCertification: CredStartCtrl_DegreedSkillsCertification,
    CredStartCtrl_GetCertified: CredStartCtrl_GetCertified,
    CredStartCtrl_GetCertifiedPrice: CredStartCtrl_GetCertifiedPrice,
    CredStartCtrl_GetCertifiedSkillFormat: CredStartCtrl_GetCertifiedSkillFormat,
    CredStartCtrl_GetCertifiedUnlimitedFormat: CredStartCtrl_GetCertifiedUnlimitedFormat,
    CredStartCtrl_GetEndorsed: CredStartCtrl_GetEndorsed,
    CredStartCtrl_HowItWorks: CredStartCtrl_HowItWorks,
    CredStartCtrl_HowItWorksParagraph: CredStartCtrl_HowItWorksParagraph,
    CredStartCtrl_ProvideEvidence: CredStartCtrl_ProvideEvidence,
    CredStartCtrl_ReceiveResults: CredStartCtrl_ReceiveResults,
    CredStartCtrl_ReviewPeers: CredStartCtrl_ReviewPeers,
    CredStartCtrl_ReviewSubmit: CredStartCtrl_ReviewSubmit,
    CredStartCtrl_VerifyYourSkills: CredStartCtrl_VerifyYourSkills,
    CredStartCtrl_VideoTitle: CredStartCtrl_VideoTitle,
    CredVerificationCtrl_Instructions1: CredVerificationCtrl_Instructions1,
    CredVerificationCtrl_Instructions2: CredVerificationCtrl_Instructions2,
    DashboardNav_AddFocusSkills: DashboardNav_AddFocusSkills,
    DashboardNav_AddSkill: DashboardNav_AddSkill,
    DashboardNav_AddSkillRating: DashboardNav_AddSkillRating,
    DashboardNav_AllActivity: DashboardNav_AllActivity,
    DashboardNav_AllInsights: DashboardNav_AllInsights,
    DashboardNav_Assignments: DashboardNav_Assignments,
    DashboardNav_CertificationInProgress: DashboardNav_CertificationInProgress,
    DashboardNav_CertifiedLevel: DashboardNav_CertifiedLevel,
    DashboardNav_Completions: DashboardNav_Completions,
    DashboardNav_DismissRecommendation: DashboardNav_DismissRecommendation,
    DashboardNav_EvalInProgress: DashboardNav_EvalInProgress,
    DashboardNav_EvalRatingLevel: DashboardNav_EvalRatingLevel,
    DashboardNav_FindGroups: DashboardNav_FindGroups,
    DashboardNav_FindPathway: DashboardNav_FindPathway,
    DashboardNav_FollowingEverybody: DashboardNav_FollowingEverybody,
    DashboardNav_GetMonthlyActivityError: DashboardNav_GetMonthlyActivityError,
    DashboardNav_ItemsViewed: DashboardNav_ItemsViewed,
    DashboardNav_LearnerHub: DashboardNav_LearnerHub,
    DashboardNav_ManageFollowing: DashboardNav_ManageFollowing,
    DashboardNav_ManagerRatingLevel: DashboardNav_ManagerRatingLevel,
    DashboardNav_MaxFocusSkillDesc: DashboardNav_MaxFocusSkillDesc,
    DashboardNav_MonthlyActivity: DashboardNav_MonthlyActivity,
    DashboardNav_NegativeActivityChange: DashboardNav_NegativeActivityChange,
    DashboardNav_NoActivityChange: DashboardNav_NoActivityChange,
    DashboardNav_PathwayPercentComplete: DashboardNav_PathwayPercentComplete,
    DashboardNav_PeopleToFollow: DashboardNav_PeopleToFollow,
    DashboardNav_PointsEarned: DashboardNav_PointsEarned,
    DashboardNav_PositiveActivityChange: DashboardNav_PositiveActivityChange,
    DashboardNav_RefreshRecommended: DashboardNav_RefreshRecommended,
    DashboardNav_Resources: DashboardNav_Resources,
    DashboardNav_SearchBySkill: DashboardNav_SearchBySkill,
    DashboardNav_SelfRatingLevel: DashboardNav_SelfRatingLevel,
    DashboardNav_UpdateRatings: DashboardNav_UpdateRatings,
    DashboardNav_ViewMyProgress: DashboardNav_ViewMyProgress,
    DashboardNav_YourGroups: DashboardNav_YourGroups,
    DashboardNav_YourPathways: DashboardNav_YourPathways,
    DashboardNav_YourPlans: DashboardNav_YourPlans,
    DashboardNav_YourSkills: DashboardNav_YourSkills,
    DataPrivacyModalCtrl_AcceptContinue: DataPrivacyModalCtrl_AcceptContinue,
    DataPrivacyModalCtrl_Header: DataPrivacyModalCtrl_Header,
    DataPrivacyModalCtrl_PolicyAcceptLabel: DataPrivacyModalCtrl_PolicyAcceptLabel,
    DataPrivacyModalCtrl_PolicyLegal: DataPrivacyModalCtrl_PolicyLegal,
    DataPrivacyModalCtrl_PolicyReviewLabel: DataPrivacyModalCtrl_PolicyReviewLabel,
    DegreeFormCtrl_CollegeName: DegreeFormCtrl_CollegeName,
    DegreeFormCtrl_CompletionDate: DegreeFormCtrl_CompletionDate,
    DegreeFormCtrl_DegreeLevel: DegreeFormCtrl_DegreeLevel,
    DegreeFormCtrl_DegreeTitle: DegreeFormCtrl_DegreeTitle,
    DegreeFormCtrl_FieldOfStudy: DegreeFormCtrl_FieldOfStudy,
    DegreeFormCtrl_GradePointAvg: DegreeFormCtrl_GradePointAvg,
    deleteModal_Cancel: deleteModal_Cancel,
    deleteModal_Delete: deleteModal_Delete,
    dgActiveUserChartCtrl_A11yTooltipFormatDateRange: dgActiveUserChartCtrl_A11yTooltipFormatDateRange,
    dgActiveUserChartCtrl_ActiveUsers: dgActiveUserChartCtrl_ActiveUsers,
    dgActiveUserChartCtrl_ActiveUsersToolTip: dgActiveUserChartCtrl_ActiveUsersToolTip,
    dgActiveUserChartCtrl_DailyActiveUsers: dgActiveUserChartCtrl_DailyActiveUsers,
    dgActiveUserChartCtrl_Date: dgActiveUserChartCtrl_Date,
    dgActiveUserChartCtrl_MonthlyActiveUsers: dgActiveUserChartCtrl_MonthlyActiveUsers,
    dgActiveUserChartCtrl_NewReturningUsers: dgActiveUserChartCtrl_NewReturningUsers,
    dgActiveUserChartCtrl_NewUsers: dgActiveUserChartCtrl_NewUsers,
    dgActiveUserChartCtrl_NewUsersToolTip: dgActiveUserChartCtrl_NewUsersToolTip,
    dgActiveUserChartCtrl_ReturningUsers: dgActiveUserChartCtrl_ReturningUsers,
    dgActiveUserChartCtrl_ReturningUsersToolTip: dgActiveUserChartCtrl_ReturningUsersToolTip,
    dgActiveUserChartCtrl_SelectUserType: dgActiveUserChartCtrl_SelectUserType,
    dgActiveUserChartCtrl_WeeklyActiveUsers: dgActiveUserChartCtrl_WeeklyActiveUsers,
    dgActivityDetails_GoalActionFormat: dgActivityDetails_GoalActionFormat,
    dgActivityDetails_GroupActivityAdd: dgActivityDetails_GroupActivityAdd,
    dgActivityDetails_GroupActivityRemove: dgActivityDetails_GroupActivityRemove,
    dgActivityDetails_GroupActivityUpdate: dgActivityDetails_GroupActivityUpdate,
    dgActivityDetails_InputActionAdded: dgActivityDetails_InputActionAdded,
    dgActivityDetails_InputActionArticle: dgActivityDetails_InputActionArticle,
    dgActivityDetails_InputActionBook: dgActivityDetails_InputActionBook,
    dgActivityDetails_InputActionCourse: dgActivityDetails_InputActionCourse,
    dgActivityDetails_InputActionEpisode: dgActivityDetails_InputActionEpisode,
    dgActivityDetails_InputActionEvent: dgActivityDetails_InputActionEvent,
    dgActivityDetails_InputActionTask: dgActivityDetails_InputActionTask,
    dgActivityDetails_InputActionVideo: dgActivityDetails_InputActionVideo,
    dgActivityDetails_PostedFormat: dgActivityDetails_PostedFormat,
    dgActivityDetails_RemoveActivity: dgActivityDetails_RemoveActivity,
    dgActivityDetails_RemoveConfirm: dgActivityDetails_RemoveConfirm,
    dgActivityDetails_UserActionDateFormat: dgActivityDetails_UserActionDateFormat,
    dgActivityDetails_UserActionFormat: dgActivityDetails_UserActionFormat,
    dgActivityDetails_UserActionItemTitleDateFormat: dgActivityDetails_UserActionItemTitleDateFormat,
    dgActivityDetails_UserActionItemTitleFormat: dgActivityDetails_UserActionItemTitleFormat,
    dgActivityDetails_UserActionTheFollowingDateFormat: dgActivityDetails_UserActionTheFollowingDateFormat,
    dgActivityDetails_UserActionTheFollowingDueDateFormat: dgActivityDetails_UserActionTheFollowingDueDateFormat,
    dgActivityDetails_UserActionTheFollowingFormat: dgActivityDetails_UserActionTheFollowingFormat,
    dgActivityDetails_UserAddedNewUserFormat: dgActivityDetails_UserAddedNewUserFormat,
    dgActivityDetails_UserAssignedTheFollowingDateFormat: dgActivityDetails_UserAssignedTheFollowingDateFormat,
    dgActivityDetails_UserAssignedTheFollowingFormat: dgActivityDetails_UserAssignedTheFollowingFormat,
    dgActivityDetails_UserJoinedGroupFormat: dgActivityDetails_UserJoinedGroupFormat,
    dgActivityDetails_UserLeftGroupFormat: dgActivityDetails_UserLeftGroupFormat,
    dgActivityDetails_UserPostedAgoFormat: dgActivityDetails_UserPostedAgoFormat,
    dgActivityDetails_UserPostedFormat: dgActivityDetails_UserPostedFormat,
    dgActivityDetails_UserRemovedUserFormat: dgActivityDetails_UserRemovedUserFormat,
    dgAddItems_AddItem: dgAddItems_AddItem,
    dgAddItems_EmailDomainError: dgAddItems_EmailDomainError,
    dgAddItems_EmailExistsError: dgAddItems_EmailExistsError,
    dgAddItems_InvalidEmailError: dgAddItems_InvalidEmailError,
    dgAddItems_MoreFormat: dgAddItems_MoreFormat,
    dgAssignmentsOverview_AssignedGroupFormat: dgAssignmentsOverview_AssignedGroupFormat,
    dgAssignmentsOverview_AssignedSingleFormat: dgAssignmentsOverview_AssignedSingleFormat,
    dgAssignmentsOverview_AssignmentAbout: dgAssignmentsOverview_AssignmentAbout,
    dgAssignmentsOverview_AssignmentEmptyTitle: dgAssignmentsOverview_AssignmentEmptyTitle,
    dgAssignmentsOverview_AssignmentsDescription: dgAssignmentsOverview_AssignmentsDescription,
    dgAssignmentsOverview_AssignmentSearchPlaceholder: dgAssignmentsOverview_AssignmentSearchPlaceholder,
    dgAssignmentsOverview_AssignmentsTableDescription: dgAssignmentsOverview_AssignmentsTableDescription,
    dgAssignmentsOverview_CaughtUp: dgAssignmentsOverview_CaughtUp,
    dgAssignmentsOverview_Completed: dgAssignmentsOverview_Completed,
    dgAssignmentsOverview_CompletedAssignmentsEmpty: dgAssignmentsOverview_CompletedAssignmentsEmpty,
    dgAssignmentsOverview_CountDueSoon: dgAssignmentsOverview_CountDueSoon,
    dgAssignmentsOverview_CountOverdue: dgAssignmentsOverview_CountOverdue,
    dgAssignmentsOverview_Description: dgAssignmentsOverview_Description,
    dgAssignmentsOverview_DueDate: dgAssignmentsOverview_DueDate,
    dgAssignmentsOverview_DueSoon: dgAssignmentsOverview_DueSoon,
    dgAssignmentsOverview_EmptyBody: dgAssignmentsOverview_EmptyBody,
    dgAssignmentsOverview_EmptyCompletedText: dgAssignmentsOverview_EmptyCompletedText,
    dgAssignmentsOverview_EmptyCompletedTitle: dgAssignmentsOverview_EmptyCompletedTitle,
    dgAssignmentsOverview_EmptyHeader: dgAssignmentsOverview_EmptyHeader,
    dgAssignmentsOverview_EmptyToDoText: dgAssignmentsOverview_EmptyToDoText,
    dgAssignmentsOverview_Incomplete: dgAssignmentsOverview_Incomplete,
    dgAssignmentsOverview_NextDueDate: dgAssignmentsOverview_NextDueDate,
    dgAssignmentsOverview_NoAssignments: dgAssignmentsOverview_NoAssignments,
    dgAssignmentsOverview_NoAssignmentsBody: dgAssignmentsOverview_NoAssignmentsBody,
    dgAssignmentsOverview_NoAssignmentsHeader: dgAssignmentsOverview_NoAssignmentsHeader,
    dgAssignmentsOverview_NoAssignmentsHelpText: dgAssignmentsOverview_NoAssignmentsHelpText,
    dgAssignmentsOverview_NoCompletedAssignments: dgAssignmentsOverview_NoCompletedAssignments,
    dgAssignmentsOverview_NoInProgressAssignments: dgAssignmentsOverview_NoInProgressAssignments,
    dgAssignmentsOverview_OtherAssignmentsBody: dgAssignmentsOverview_OtherAssignmentsBody,
    dgAssignmentsOverview_OtherAssignmentsEmpty: dgAssignmentsOverview_OtherAssignmentsEmpty,
    dgAssignmentsOverview_OtherAssignmentsHeader: dgAssignmentsOverview_OtherAssignmentsHeader,
    dgAssignmentsOverview_Overdue: dgAssignmentsOverview_Overdue,
    dgAssignmentsOverview_OverdueAndDueSoon: dgAssignmentsOverview_OverdueAndDueSoon,
    dgAssignmentsOverview_RequiredAssignmentsBody: dgAssignmentsOverview_RequiredAssignmentsBody,
    dgAssignmentsOverview_RequiredAssignmentsEmpty: dgAssignmentsOverview_RequiredAssignmentsEmpty,
    dgAssignmentsOverview_RequiredAssignmentsHeader: dgAssignmentsOverview_RequiredAssignmentsHeader,
    dgAssignmentsOverview_RequiredGroupAttendedFormat: dgAssignmentsOverview_RequiredGroupAttendedFormat,
    dgAssignmentsOverview_RequiredGroupCompletedFormat: dgAssignmentsOverview_RequiredGroupCompletedFormat,
    dgAssignmentsOverview_RequiredGroupFollowedFormat: dgAssignmentsOverview_RequiredGroupFollowedFormat,
    dgAssignmentsOverview_RequiredGroupFormat: dgAssignmentsOverview_RequiredGroupFormat,
    dgAssignmentsOverview_RequiredGroupReadFormat: dgAssignmentsOverview_RequiredGroupReadFormat,
    dgAssignmentsOverview_RequiredGroupWatchedFormat: dgAssignmentsOverview_RequiredGroupWatchedFormat,
    dgAssignmentsOverview_RequiredSingleAlreadyCompletedFormat: dgAssignmentsOverview_RequiredSingleAlreadyCompletedFormat,
    dgAssignmentsOverview_RequiredSingleAttendedFormat: dgAssignmentsOverview_RequiredSingleAttendedFormat,
    dgAssignmentsOverview_RequiredSingleAttendedOverdueFormat: dgAssignmentsOverview_RequiredSingleAttendedOverdueFormat,
    dgAssignmentsOverview_RequiredSingleCompletedFormat: dgAssignmentsOverview_RequiredSingleCompletedFormat,
    dgAssignmentsOverview_RequiredSingleCompletedOverdueFormat: dgAssignmentsOverview_RequiredSingleCompletedOverdueFormat,
    dgAssignmentsOverview_RequiredSingleFollowedFormat: dgAssignmentsOverview_RequiredSingleFollowedFormat,
    dgAssignmentsOverview_RequiredSingleFollowedOverdueFormat: dgAssignmentsOverview_RequiredSingleFollowedOverdueFormat,
    dgAssignmentsOverview_RequiredSingleFormat: dgAssignmentsOverview_RequiredSingleFormat,
    dgAssignmentsOverview_RequiredSingleOverdueFormat: dgAssignmentsOverview_RequiredSingleOverdueFormat,
    dgAssignmentsOverview_RequiredSingleReadFormat: dgAssignmentsOverview_RequiredSingleReadFormat,
    dgAssignmentsOverview_RequiredSingleReadOverdueFormat: dgAssignmentsOverview_RequiredSingleReadOverdueFormat,
    dgAssignmentsOverview_RequiredSingleWatchedFormat: dgAssignmentsOverview_RequiredSingleWatchedFormat,
    dgAssignmentsOverview_RequiredSingleWatchedOverdueFormat: dgAssignmentsOverview_RequiredSingleWatchedOverdueFormat,
    dgAssignmentsOverview_ThirdPartyCompletedDate: dgAssignmentsOverview_ThirdPartyCompletedDate,
    dgAssignmentsOverview_YourAssignments: dgAssignmentsOverview_YourAssignments,
    DgAssistant_ErrorText: DgAssistant_ErrorText,
    DgAssistant_Executive_Description: DgAssistant_Executive_Description,
    DgAssistant_Executive_Title: DgAssistant_Executive_Title,
    DgAssistant_LatestFrom: DgAssistant_LatestFrom,
    DgAssistant_Name: DgAssistant_Name,
    DgAssistant_NoteText: DgAssistant_NoteText,
    DgAssistant_NotificationText: DgAssistant_NotificationText,
    DgAssistant_PlaceholderProcessing: DgAssistant_PlaceholderProcessing,
    DgAssistant_PlaceholderReady: DgAssistant_PlaceholderReady,
    DgAssistant_PlaceholderStart: DgAssistant_PlaceholderStart,
    DgAssistant_SelectedJourneyText: DgAssistant_SelectedJourneyText,
    DgAssistant_ShowLessText: DgAssistant_ShowLessText,
    DgAssistant_ShowMoreText: DgAssistant_ShowMoreText,
    DgAssistant_StartNewText: DgAssistant_StartNewText,
    DgAssistant_WelcomeText: DgAssistant_WelcomeText,
    DgAssistant_YouText: DgAssistant_YouText,
    dgAuthorVideo_CameraNotAuthorizedError: dgAuthorVideo_CameraNotAuthorizedError,
    dgAuthorVideo_CameraNotFoundError: dgAuthorVideo_CameraNotFoundError,
    dgAuthorVideo_CameraNotReadableError: dgAuthorVideo_CameraNotReadableError,
    dgAuthorVideo_ConfirmRedoRecording: dgAuthorVideo_ConfirmRedoRecording,
    dgAuthorVideo_ModalTitle: dgAuthorVideo_ModalTitle,
    dgAuthorVideo_playerError: dgAuthorVideo_playerError,
    dgAuthorVideo_ProcessingVideo: dgAuthorVideo_ProcessingVideo,
    dgAuthorVideo_recorderError: dgAuthorVideo_recorderError,
    dgAuthorVideo_RecordVideoOnlyError: dgAuthorVideo_RecordVideoOnlyError,
    dgAuthorVideo_Redirecting: dgAuthorVideo_Redirecting,
    dgAuthorVideo_RedoRecording: dgAuthorVideo_RedoRecording,
    dgAuthorVideo_StartRecording: dgAuthorVideo_StartRecording,
    dgAuthorVideo_StopRecording: dgAuthorVideo_StopRecording,
    dgAuthorVideo_TimeInMinutes: dgAuthorVideo_TimeInMinutes,
    dgAuthorVideo_TimeLimitReached: dgAuthorVideo_TimeLimitReached,
    dgAuthorVideo_TimeWarningFormat: dgAuthorVideo_TimeWarningFormat,
    dgAuthorVideo_TryAgain: dgAuthorVideo_TryAgain,
    dgAuthorVideo_UploadError: dgAuthorVideo_UploadError,
    dgAuthorVideo_UploadErrorMessage: dgAuthorVideo_UploadErrorMessage,
    dgAuthorVideo_Uploading: dgAuthorVideo_Uploading,
    dgBrowseFeaturedLearning_FromPathwayFormat: dgBrowseFeaturedLearning_FromPathwayFormat,
    dgBrowseFeaturedLearning_PopularGroupFormat: dgBrowseFeaturedLearning_PopularGroupFormat,
    dgBrowseFeaturedLearning_ReadByFormat: dgBrowseFeaturedLearning_ReadByFormat,
    dgBrowseFeaturedLearning_RecommendedByFormat: dgBrowseFeaturedLearning_RecommendedByFormat,
    dgBrowseFeaturedLearning_SavedForLater: dgBrowseFeaturedLearning_SavedForLater,
    dgBrowseFeaturedLearning_WatchedByFormat: dgBrowseFeaturedLearning_WatchedByFormat,
    dgBrowsePathways_NoPathways: dgBrowsePathways_NoPathways,
    dgBrowsePathways_NoRecommendations: dgBrowsePathways_NoRecommendations,
    dgBrowseProviders_LaunchFormat: dgBrowseProviders_LaunchFormat,
    dgBrowseProviders_Search: dgBrowseProviders_Search,
    dgBrowseProviders_SearchResourcesFormat: dgBrowseProviders_SearchResourcesFormat,
    dgBrowseProviders_VisitSiteFormat: dgBrowseProviders_VisitSiteFormat,
    dgCarousel_ShowNextItems: dgCarousel_ShowNextItems,
    dgCarousel_ShowPreviousItems: dgCarousel_ShowPreviousItems,
    dgColorpickerTextDarkness_DarkText: dgColorpickerTextDarkness_DarkText,
    dgColorpickerTextDarkness_LightText: dgColorpickerTextDarkness_LightText,
    dgCombobox_SubmitSelection: dgCombobox_SubmitSelection,
    dgComment_CollapseCommentsFormat: dgComment_CollapseCommentsFormat,
    dgComment_CollapseOneComment: dgComment_CollapseOneComment,
    dgComment_CommentHidden: dgComment_CommentHidden,
    dgComment_DeleteConfirm: dgComment_DeleteConfirm,
    dgComment_DeleteTakeaway: dgComment_DeleteTakeaway,
    dgComment_DeleteTakeawayReplies: dgComment_DeleteTakeawayReplies,
    dgComment_Edited: dgComment_Edited,
    dgComment_HideComments: dgComment_HideComments,
    dgComment_JustNow: dgComment_JustNow,
    dgComment_PlusReadMore: dgComment_PlusReadMore,
    dgComment_ReplyHidden: dgComment_ReplyHidden,
    dgComment_ShowComments: dgComment_ShowComments,
    dgComment_ShowCommentsFormat: dgComment_ShowCommentsFormat,
    dgComment_ShowMoreCommentsFormat: dgComment_ShowMoreCommentsFormat,
    dgComment_ShowMultiplePreviousRepliesFormat: dgComment_ShowMultiplePreviousRepliesFormat,
    dgComment_ShowOneComment: dgComment_ShowOneComment,
    dgComment_ShowPreviousReplies: dgComment_ShowPreviousReplies,
    dgComment_ShowTakeawaysFormat: dgComment_ShowTakeawaysFormat,
    dgComment_ViewConversation: dgComment_ViewConversation,
    dgComment_ViewMoreFormat: dgComment_ViewMoreFormat,
    dgComments_AddAReply: dgComments_AddAReply,
    dgComments_ShareSomethingAbout: dgComments_ShareSomethingAbout,
    dgComments_WhatDidYouLearnFormat: dgComments_WhatDidYouLearnFormat,
    dgCompleteViewedTip_ThanksPluralFormat: dgCompleteViewedTip_ThanksPluralFormat,
    dgCompleteViewedTip_ThanksSingularFormat: dgCompleteViewedTip_ThanksSingularFormat,
    dgContentCard_AssignedByFormat: dgContentCard_AssignedByFormat,
    dgContentCard_CompleteByDateFormat: dgContentCard_CompleteByDateFormat,
    dgContentCard_FromJobRoleFormat: dgContentCard_FromJobRoleFormat,
    dgContentCard_FromPathwaysFormat: dgContentCard_FromPathwaysFormat,
    dgContentCard_LibraryContent: dgContentCard_LibraryContent,
    dgContentCard_MoreLikeThisCompletedFormat: dgContentCard_MoreLikeThisCompletedFormat,
    dgContentCard_MoreLikeThisReadFormat: dgContentCard_MoreLikeThisReadFormat,
    dgContentCard_MoreLikeThisWatchedFormat: dgContentCard_MoreLikeThisWatchedFormat,
    dgContentCard_Opportunity: dgContentCard_Opportunity,
    dgContentCard_PopularCompletedFormat: dgContentCard_PopularCompletedFormat,
    dgContentCard_PopularInFormat: dgContentCard_PopularInFormat,
    dgContentCard_PopularReadFormat: dgContentCard_PopularReadFormat,
    dgContentCard_PopularWatchedFormat: dgContentCard_PopularWatchedFormat,
    dgContentCard_ReadByFormat: dgContentCard_ReadByFormat,
    dgContentCard_ReadMore: dgContentCard_ReadMore,
    dgContentCard_RecommendedByFormat: dgContentCard_RecommendedByFormat,
    dgContentCard_RequiredLearning: dgContentCard_RequiredLearning,
    dgContentCard_RequiredLearningDate: dgContentCard_RequiredLearningDate,
    dgContentCard_SavedForLater: dgContentCard_SavedForLater,
    dgContentCard_WatchedByFormat: dgContentCard_WatchedByFormat,
    dgContentHosting_DragAndDrop: dgContentHosting_DragAndDrop,
    dgContentHosting_Hosted: dgContentHosting_Hosted,
    dgContentHosting_HostedFiles: dgContentHosting_HostedFiles,
    dgContentHosting_InvalidFileType: dgContentHosting_InvalidFileType,
    dgContentHosting_OrgStorageLimitAlmostReached: dgContentHosting_OrgStorageLimitAlmostReached,
    dgContentHosting_OrgStorageLimitIsReached: dgContentHosting_OrgStorageLimitIsReached,
    dgContentTile_AuthorshipAuthor: dgContentTile_AuthorshipAuthor,
    dgContentTile_AuthorshipCreator: dgContentTile_AuthorshipCreator,
    dgContentTile_AuthorshipPresenter: dgContentTile_AuthorshipPresenter,
    dgContentTile_AuthorshipTeacher: dgContentTile_AuthorshipTeacher,
    dgContentTile_Verified: dgContentTile_Verified,
    dgCookieBanner_accept: dgCookieBanner_accept,
    dgCookieBanner_learnMore: dgCookieBanner_learnMore,
    dgCookieBanner_message: dgCookieBanner_message,
    dgCookieBanner_message_V2: dgCookieBanner_message_V2,
    dgCopyLink_CopyInviteLink: dgCopyLink_CopyInviteLink,
    dgCopyLink_CopyLink: dgCopyLink_CopyLink,
    dgCopyLink_InviteURL: dgCopyLink_InviteURL,
    dgCredentialDisplay_StartDateFormat: dgCredentialDisplay_StartDateFormat,
    dgCredentialDisplay_ViewApplicationFormat: dgCredentialDisplay_ViewApplicationFormat,
    dgCredPrePayLogin_DegreedAccount: dgCredPrePayLogin_DegreedAccount,
    dgCredPrePayLogin_LoginContinue: dgCredPrePayLogin_LoginContinue,
    dgDiscipline_ExpertsFormat: dgDiscipline_ExpertsFormat,
    dgDiscipline_StartApplication: dgDiscipline_StartApplication,
    dgDownloadableReports_ChooseGroup: dgDownloadableReports_ChooseGroup,
    dgDownloadableReports_ChooseReportType: dgDownloadableReports_ChooseReportType,
    dgDownloadableReports_DataSet: dgDownloadableReports_DataSet,
    dgDownloadableReports_DateCreated: dgDownloadableReports_DateCreated,
    dgDownloadableReports_datePickerText: dgDownloadableReports_datePickerText,
    dgDownloadableReports_DateRange: dgDownloadableReports_DateRange,
    dgDownloadableReports_Download: dgDownloadableReports_Download,
    dgDownloadableReports_DownloadableReports: dgDownloadableReports_DownloadableReports,
    dgDownloadableReports_DownloadReport: dgDownloadableReports_DownloadReport,
    dgDownloadableReports_Generate: dgDownloadableReports_Generate,
    dgDownloadableReports_GenerateDataReport: dgDownloadableReports_GenerateDataReport,
    dgDownloadableReports_GenerateReport: dgDownloadableReports_GenerateReport,
    dgDownloadableReports_Generating: dgDownloadableReports_Generating,
    dgDownloadableReports_GroupOptionalTitle: dgDownloadableReports_GroupOptionalTitle,
    dgDownloadableReports_GroupTitle: dgDownloadableReports_GroupTitle,
    dgDownloadableReports_MaxDaysReached: dgDownloadableReports_MaxDaysReached,
    dgDownloadableReports_NoAvailableGroups: dgDownloadableReports_NoAvailableGroups,
    dgDownloadableReports_NoMatchingReportTypes: dgDownloadableReports_NoMatchingReportTypes,
    dgDownloadableReports_Parameters_InputIdentifier_Name: dgDownloadableReports_Parameters_InputIdentifier_Name,
    dgDownloadableReports_Parameters_InputIdentifier_Placeholder: dgDownloadableReports_Parameters_InputIdentifier_Placeholder,
    dgDownloadableReports_Parameters_InputIdentifierList_Name: dgDownloadableReports_Parameters_InputIdentifierList_Name,
    dgDownloadableReports_Parameters_InputIdentifierList_Placeholder: dgDownloadableReports_Parameters_InputIdentifierList_Placeholder,
    dgDownloadableReports_Report10: dgDownloadableReports_Report10,
    dgDownloadableReports_Report11: dgDownloadableReports_Report11,
    dgDownloadableReports_Report12: dgDownloadableReports_Report12,
    dgDownloadableReports_Report13: dgDownloadableReports_Report13,
    dgDownloadableReports_Report14: dgDownloadableReports_Report14,
    dgDownloadableReports_Report3: dgDownloadableReports_Report3,
    dgDownloadableReports_Report4: dgDownloadableReports_Report4,
    dgDownloadableReports_Report5: dgDownloadableReports_Report5,
    dgDownloadableReports_Report6: dgDownloadableReports_Report6,
    dgDownloadableReports_Report7: dgDownloadableReports_Report7,
    dgDownloadableReports_Report8: dgDownloadableReports_Report8,
    dgDownloadableReports_Report9: dgDownloadableReports_Report9,
    dgDownloadableReports_ReportContentCompletionsDownload: dgDownloadableReports_ReportContentCompletionsDownload,
    dgDownloadableReports_ReportContentTrendsAdded: dgDownloadableReports_ReportContentTrendsAdded,
    dgDownloadableReports_ReportContentTrendsViewed: dgDownloadableReports_ReportContentTrendsViewed,
    dgDownloadableReports_ReportDate: dgDownloadableReports_ReportDate,
    dgDownloadableReports_ReportGenerated: dgDownloadableReports_ReportGenerated,
    dgDownloadableReports_ReportPathwayDetailsDownload: dgDownloadableReports_ReportPathwayDetailsDownload,
    dgDownloadableReports_ReportPopularTopics: dgDownloadableReports_ReportPopularTopics,
    dgDownloadableReports_ReportSkillAnalyticsTop1000SkillsRated: dgDownloadableReports_ReportSkillAnalyticsTop1000SkillsRated,
    dgDownloadableReports_ReportSkillReport: dgDownloadableReports_ReportSkillReport,
    dgDownloadableReports_ReportTop1000SkillsRated: dgDownloadableReports_ReportTop1000SkillsRated,
    dgDownloadableReports_ReportTopProviders: dgDownloadableReports_ReportTopProviders,
    dgDownloadableReports_ReportTopSearches: dgDownloadableReports_ReportTopSearches,
    dgDownloadableReports_ReportType: dgDownloadableReports_ReportType,
    dgDownloadableReports_ReportTypeRequired: dgDownloadableReports_ReportTypeRequired,
    dgDownloadableReports_ToastMessage: dgDownloadableReports_ToastMessage,
    dgEnrolled_CompletedTooltipFormat: dgEnrolled_CompletedTooltipFormat,
    dgEnrolled_DateAddedColumn: dgEnrolled_DateAddedColumn,
    dgEnrolled_EnrolledCountFormat: dgEnrolled_EnrolledCountFormat,
    dgEnrolled_EnrollmentDate: dgEnrolled_EnrollmentDate,
    dgEnrolled_NameColumn: dgEnrolled_NameColumn,
    dgExtensions_AccessError: dgExtensions_AccessError,
    dgExtensions_AccessGranted: dgExtensions_AccessGranted,
    dgExtensions_AddBookmarkletManually: dgExtensions_AddBookmarkletManually,
    dgExtensions_AddCompletedCourses: dgExtensions_AddCompletedCourses,
    dgExtensions_AddCompletedItems: dgExtensions_AddCompletedItems,
    dgExtensions_AddToChrome: dgExtensions_AddToChrome,
    dgExtensions_AddToCollection: dgExtensions_AddToCollection,
    dgExtensions_AdminFlexEd: dgExtensions_AdminFlexEd,
    dgExtensions_AppsUnavailable: dgExtensions_AppsUnavailable,
    dgExtensions_Bookmarklet: dgExtensions_Bookmarklet,
    dgExtensions_BookmarkletDragInstructions: dgExtensions_BookmarkletDragInstructions,
    dgExtensions_Bookmarks: dgExtensions_Bookmarks,
    dgExtensions_BrowserBookmarklet: dgExtensions_BrowserBookmarklet,
    dgExtensions_BrowserWindowIllustrationAlt: dgExtensions_BrowserWindowIllustrationAlt,
    dgExtensions_ButtonSuccess: dgExtensions_ButtonSuccess,
    dgExtensions_Chrome: dgExtensions_Chrome,
    dgExtensions_ChromeExtension: dgExtensions_ChromeExtension,
    dgExtensions_ChromeInstructionsFormat: dgExtensions_ChromeInstructionsFormat,
    dgExtensions_CopyBookmark: dgExtensions_CopyBookmark,
    dgExtensions_CreatePathways: dgExtensions_CreatePathways,
    dgExtensions_DegreedExtension: dgExtensions_DegreedExtension,
    dgExtensions_DisplayFavoritesFormat: dgExtensions_DisplayFavoritesFormat,
    dgExtensions_DragToInstallBookmarks: dgExtensions_DragToInstallBookmarks,
    dgExtensions_DragToInstallFavorites: dgExtensions_DragToInstallFavorites,
    dgExtensions_EmailAddressPlaceholder: dgExtensions_EmailAddressPlaceholder,
    dgExtensions_Extension: dgExtensions_Extension,
    dgExtensions_ExtensionInstalledAlt: dgExtensions_ExtensionInstalledAlt,
    dgExtensions_Favorites: dgExtensions_Favorites,
    dgExtensions_Firefox: dgExtensions_Firefox,
    dgExtensions_FirefoxInstructionsFormat: dgExtensions_FirefoxInstructionsFormat,
    dgExtensions_GetStarted: dgExtensions_GetStarted,
    dgExtensions_GrantAccess: dgExtensions_GrantAccess,
    dgExtensions_GrantAccessHeader: dgExtensions_GrantAccessHeader,
    dgExtensions_IEInstructionsFormat: dgExtensions_IEInstructionsFormat,
    dgExtensions_InternetExplorer: dgExtensions_InternetExplorer,
    dgExtensions_InvalidEmailError: dgExtensions_InvalidEmailError,
    dgExtensions_iOS: dgExtensions_iOS,
    dgExtensions_ItemsToPlans: dgExtensions_ItemsToPlans,
    dgExtensions_MakeChanges: dgExtensions_MakeChanges,
    dgExtensions_ManualBookmarkInstructions: dgExtensions_ManualBookmarkInstructions,
    dgExtensions_Mobile: dgExtensions_Mobile,
    dgExtensions_Oauth_Authorize: dgExtensions_Oauth_Authorize,
    dgExtensions_Oauth_Request_Access: dgExtensions_Oauth_Request_Access,
    dgExtensions_PlusDegreedButton: dgExtensions_PlusDegreedButton,
    dgExtensions_RequestAccess: dgExtensions_RequestAccess,
    dgExtensions_Safari: dgExtensions_Safari,
    dgExtensions_SafariInstructionsFormat: dgExtensions_SafariInstructionsFormat,
    dgExtensions_SaveItemsForLater: dgExtensions_SaveItemsForLater,
    dgExtensions_ShareItems: dgExtensions_ShareItems,
    dgExtensions_SummaryEdge: dgExtensions_SummaryEdge,
    dgExtensions_SummaryFormat: dgExtensions_SummaryFormat,
    dgExtensions_TitleEdge: dgExtensions_TitleEdge,
    dgExtensions_TitleFormat: dgExtensions_TitleFormat,
    dgExtensions_TryOurBookmarklet: dgExtensions_TryOurBookmarklet,
    dgExtensions_UnableToDownload: dgExtensions_UnableToDownload,
    dgExtensions_WishGrantAccess: dgExtensions_WishGrantAccess,
    dgExtensions_YourBrowser: dgExtensions_YourBrowser,
    dgFeed_AddSomething: dgFeed_AddSomething,
    dgFeed_AddTopCategories: dgFeed_AddTopCategories,
    dgFeed_CompletedCongrats: dgFeed_CompletedCongrats,
    dgFeed_CompletedHeading: dgFeed_CompletedHeading,
    dgFeed_DismissTip: dgFeed_DismissTip,
    dgFeed_EmptyStateFormat: dgFeed_EmptyStateFormat,
    dgFeed_EnrolledPathways: dgFeed_EnrolledPathways,
    dgFeed_EnrollInPathway: dgFeed_EnrollInPathway,
    dgFeed_FollowedPathways: dgFeed_FollowedPathways,
    dgFeed_FollowPathway: dgFeed_FollowPathway,
    dgFeed_FollowUsers: dgFeed_FollowUsers,
    dgFeed_KeepLearning: dgFeed_KeepLearning,
    dgFeed_Personalize: dgFeed_Personalize,
    dgFeed_ShowAllAssignedFormat: dgFeed_ShowAllAssignedFormat,
    dgFeed_ViewAllYourPathways: dgFeed_ViewAllYourPathways,
    dgFileUploadButton_FileNameUnknown: dgFileUploadButton_FileNameUnknown,
    dgFileUploadButton_FilesizeError: dgFileUploadButton_FilesizeError,
    dgFileUploadButton_FiletypeError: dgFileUploadButton_FiletypeError,
    dgFileUploadButton_HelperInfo: dgFileUploadButton_HelperInfo,
    dgFileUploadButton_ImageUpload: dgFileUploadButton_ImageUpload,
    dgFileUploadButton_ProcessingFile: dgFileUploadButton_ProcessingFile,
    dgFileUploadButton_UploadComplete: dgFileUploadButton_UploadComplete,
    dgFileUploadButton_UploadError: dgFileUploadButton_UploadError,
    dgFileUploadButton_UploadErrorMessage: dgFileUploadButton_UploadErrorMessage,
    dgFileUploadButton_UploadFile: dgFileUploadButton_UploadFile,
    dgFileUploadButton_Uploading: dgFileUploadButton_Uploading,
    dgFileUploadButton_ViewFileDocumentation: dgFileUploadButton_ViewFileDocumentation,
    dgFlexMembers_FollowersFormat: dgFlexMembers_FollowersFormat,
    dgFlexMembers_UpdatedDaily: dgFlexMembers_UpdatedDaily,
    dgFlexRow_AddLinkSection: dgFlexRow_AddLinkSection,
    dgFlexRow_AddSection: dgFlexRow_AddSection,
    dgFlexRow_AddSectionSuccess: dgFlexRow_AddSectionSuccess,
    dgFlexRow_AddTextAndImage: dgFlexRow_AddTextAndImage,
    dgFlexRow_AddTextSection: dgFlexRow_AddTextSection,
    dgFlexRow_All: dgFlexRow_All,
    dgFlexRow_AllDescription: dgFlexRow_AllDescription,
    dgFlexRow_Compact: dgFlexRow_Compact,
    dgFlexRow_CompactDescription: dgFlexRow_CompactDescription,
    dgFlexRow_CustomErrors_RequiredMultiple: dgFlexRow_CustomErrors_RequiredMultiple,
    dgFlexRow_DeleteConfirmSubmit: dgFlexRow_DeleteConfirmSubmit,
    dgFlexRow_DeleteSectionBody: dgFlexRow_DeleteSectionBody,
    dgFlexRow_DeleteSectionPrompt: dgFlexRow_DeleteSectionPrompt,
    dgFlexRow_DeleteSuccess: dgFlexRow_DeleteSuccess,
    dgFlexRow_EditDetails: dgFlexRow_EditDetails,
    dgFlexRow_EditLinkSection: dgFlexRow_EditLinkSection,
    dgFlexRow_EditSectionDescription: dgFlexRow_EditSectionDescription,
    dgFlexRow_EditSectionDescriptionPlaceholder: dgFlexRow_EditSectionDescriptionPlaceholder,
    dgFlexRow_EditSectionDetails: dgFlexRow_EditSectionDetails,
    dgFlexRow_EditSectionDisplayOptions: dgFlexRow_EditSectionDisplayOptions,
    dgFlexRow_EditSectionTitle: dgFlexRow_EditSectionTitle,
    dgFlexRow_EditSectionTitlePlaceholder: dgFlexRow_EditSectionTitlePlaceholder,
    dgFlexRow_EditTextAndImage: dgFlexRow_EditTextAndImage,
    dgFlexRow_EditTextSection: dgFlexRow_EditTextSection,
    dgFlexRow_Expanded: dgFlexRow_Expanded,
    dgFlexRow_ExpandedDescription: dgFlexRow_ExpandedDescription,
    dgFlexRow_FieldRequired: dgFlexRow_FieldRequired,
    dgFlexRow_Link: dgFlexRow_Link,
    dgFlexRow_LinkDescription: dgFlexRow_LinkDescription,
    dgFlexRow_LinkSectionTitle: dgFlexRow_LinkSectionTitle,
    dgFlexRow_LinkSectionTitleHelperText: dgFlexRow_LinkSectionTitleHelperText,
    dgFlexRow_LinkTitle: dgFlexRow_LinkTitle,
    dgFlexRow_LinkTitleHelperText: dgFlexRow_LinkTitleHelperText,
    dgFlexRow_RemoveSection: dgFlexRow_RemoveSection,
    dgFlexRow_ReorderItems: dgFlexRow_ReorderItems,
    dgFlexRow_ReorderSectionsTitle: dgFlexRow_ReorderSectionsTitle,
    dgFlexRow_ResourceAddedSuccess: dgFlexRow_ResourceAddedSuccess,
    dgFlexRow_ResourceRemovedSuccess: dgFlexRow_ResourceRemovedSuccess,
    dgFlexRow_SectionTypeLabelFormat: dgFlexRow_SectionTypeLabelFormat,
    dgFlexRow_ShowCompactDescription: dgFlexRow_ShowCompactDescription,
    dgFlexRow_TextTitle: dgFlexRow_TextTitle,
    dgFlexRow_TextTitlePlaceholder: dgFlexRow_TextTitlePlaceholder,
    dgFlexRow_UrlRequired: dgFlexRow_UrlRequired,
    dgFlexRow_YesDeleteButton: dgFlexRow_YesDeleteButton,
    dgGlobalAdd_Achievement: dgGlobalAdd_Achievement,
    dgGlobalAdd_AchievementDescription: dgGlobalAdd_AchievementDescription,
    dgGlobalAdd_AddNewOutcomeTooltipFormat: dgGlobalAdd_AddNewOutcomeTooltipFormat,
    dgGlobalAdd_Content: dgGlobalAdd_Content,
    dgGlobalAdd_CreateAPathway: dgGlobalAdd_CreateAPathway,
    dgGlobalAdd_Description: dgGlobalAdd_Description,
    dgGlobalAdd_ExtensionsFormat: dgGlobalAdd_ExtensionsFormat,
    dgGlobalAdd_IntegrationsFormat: dgGlobalAdd_IntegrationsFormat,
    dgGlobalAdd_OutcomeTypeFormat: dgGlobalAdd_OutcomeTypeFormat,
    dgGlobalAdd_Sections_Achievement: dgGlobalAdd_Sections_Achievement,
    dgGlobalAdd_Sections_Content: dgGlobalAdd_Sections_Content,
    dgGlobalAdd_Sections_Extensions: dgGlobalAdd_Sections_Extensions,
    dgGlobalAdd_TooltipFormat: dgGlobalAdd_TooltipFormat,
    dgGlobalAddSuccess_CompletedToday: dgGlobalAddSuccess_CompletedToday,
    dgGlobalAddSuccess_Description: dgGlobalAddSuccess_Description,
    dgGlobalAddSuccess_ErrorWhenAdding: dgGlobalAddSuccess_ErrorWhenAdding,
    dgGlobalAddSuccess_LearningItems: dgGlobalAddSuccess_LearningItems,
    dgGlobalAddSuccess_Points: dgGlobalAddSuccess_Points,
    dgGlobalAddSuccess_RewardTrophy: dgGlobalAddSuccess_RewardTrophy,
    dgGlobalAddSuccess_StartedYourCollection: dgGlobalAddSuccess_StartedYourCollection,
    dgGlobalAddSuccess_ViewYourCollection: dgGlobalAddSuccess_ViewYourCollection,
    dgGlobalSearch_A11ySearchDescription: dgGlobalSearch_A11ySearchDescription,
    dgGlobalSearch_SearchExpandLabel: dgGlobalSearch_SearchExpandLabel,
    dgGlobalSearch_TopicsLabel: dgGlobalSearch_TopicsLabel,
    dgGoalItem_AssignedByFormat: dgGoalItem_AssignedByFormat,
    dgGoalItem_GoalEndDateFormat: dgGoalItem_GoalEndDateFormat,
    dgGoalTitle_CompleteInputFormat: dgGoalTitle_CompleteInputFormat,
    dgGoalTitle_CompletePathwayFormat: dgGoalTitle_CompletePathwayFormat,
    dgGoalTitle_EarnPointsByTagFormat: dgGoalTitle_EarnPointsByTagFormat,
    dgGroupDelete_DeleteGroupTitle: dgGroupDelete_DeleteGroupTitle,
    dgGroupDelete_DeleteLabelFormat: dgGroupDelete_DeleteLabelFormat,
    dgGroupDelete_DeleteLabelInfoFormat: dgGroupDelete_DeleteLabelInfoFormat,
    dgGroupDelete_Instructions: dgGroupDelete_Instructions,
    dgGroupDelete_InstructionsFormat: dgGroupDelete_InstructionsFormat,
    dgGroupGoalItem_ViewParticipants: dgGroupGoalItem_ViewParticipants,
    dgGroupGoals_CompleteAPathway: dgGroupGoals_CompleteAPathway,
    dgGroupGoals_Completed: dgGroupGoals_Completed,
    dgGroupGoals_CreateAGoal: dgGroupGoals_CreateAGoal,
    dgGroupGoals_CreateGoal: dgGroupGoals_CreateGoal,
    dgGroupGoals_CreateGoalSummary: dgGroupGoals_CreateGoalSummary,
    dgGroupGoals_EarnMorePoints: dgGroupGoals_EarnMorePoints,
    dgGroupGoals_HowTo: dgGroupGoals_HowTo,
    dgGroupGoals_NoGoals: dgGroupGoals_NoGoals,
    dgGroupGoalsOverview_HowTo: dgGroupGoalsOverview_HowTo,
    dgGroupInvite_groupInviteNotificationInviteFormat: dgGroupInvite_groupInviteNotificationInviteFormat,
    dgGroupMembers_ActiveMembers: dgGroupMembers_ActiveMembers,
    dgGroupMembers_AddMember: dgGroupMembers_AddMember,
    dgGroupMembers_AddPeople: dgGroupMembers_AddPeople,
    dgGroupMembers_AddPeopleButton: dgGroupMembers_AddPeopleButton,
    dgGroupMembers_AddUsers: dgGroupMembers_AddUsers,
    dgGroupMembers_Admin: dgGroupMembers_Admin,
    dgGroupMembers_CalculatingMembership: dgGroupMembers_CalculatingMembership,
    dgGroupMembers_DateInvited: dgGroupMembers_DateInvited,
    dgGroupMembers_DateJoined: dgGroupMembers_DateJoined,
    dgGroupMembers_Invited: dgGroupMembers_Invited,
    dgGroupMembers_InviteMembers: dgGroupMembers_InviteMembers,
    dgGroupMembers_LastActive: dgGroupMembers_LastActive,
    dgGroupMembers_MemberSettings: dgGroupMembers_MemberSettings,
    dgGroupMembers_NameHeader: dgGroupMembers_NameHeader,
    dgGroupMembers_NoActiveMemberMatch: dgGroupMembers_NoActiveMemberMatch,
    dgGroupMembers_NoDynamicMemberDescription: dgGroupMembers_NoDynamicMemberDescription,
    dgGroupMembers_NoMatches: dgGroupMembers_NoMatches,
    dgGroupMembers_NoMembers: dgGroupMembers_NoMembers,
    dgGroupMembers_NoPendingMembers: dgGroupMembers_NoPendingMembers,
    dgGroupMembers_NoPendingRequests: dgGroupMembers_NoPendingRequests,
    dgGroupMembers_NoPermission: dgGroupMembers_NoPermission,
    dgGroupMembers_NoUsersMatch: dgGroupMembers_NoUsersMatch,
    dgGroupMembers_PendingApprovalHeader: dgGroupMembers_PendingApprovalHeader,
    dgGroupMembers_PendingInvitationFormat: dgGroupMembers_PendingInvitationFormat,
    dgGroupMembers_PendingInvitations: dgGroupMembers_PendingInvitations,
    dgGroupMembers_PendingMemberSettings: dgGroupMembers_PendingMemberSettings,
    dgGroupMembers_PendingRequests: dgGroupMembers_PendingRequests,
    dgGroupMembers_Points: dgGroupMembers_Points,
    dgGroupMembers_PointsTooltip: dgGroupMembers_PointsTooltip,
    dgGroupMembers_Resend: dgGroupMembers_Resend,
    dgGroupMembers_ResendAll: dgGroupMembers_ResendAll,
    dgGroupMembers_ResendInvites: dgGroupMembers_ResendInvites,
    dgGroupMembers_SearchByName: dgGroupMembers_SearchByName,
    dgGroupMembers_SearchForMember: dgGroupMembers_SearchForMember,
    dgGroupMembers_SelectedCountFormat: dgGroupMembers_SelectedCountFormat,
    dgGroupMembers_TotalMemberCountFormat: dgGroupMembers_TotalMemberCountFormat,
    dgGroupOverview_AdministrativeGroup: dgGroupOverview_AdministrativeGroup,
    dgGroupOverview_ClosedGroup: dgGroupOverview_ClosedGroup,
    dgGroupOverview_DynamicAdminGroup: dgGroupOverview_DynamicAdminGroup,
    dgGroupOverview_GroupMembershipPending: dgGroupOverview_GroupMembershipPending,
    dgGroupOverview_JoinedGroup: dgGroupOverview_JoinedGroup,
    dgGroupOverview_JoinThisGroup: dgGroupOverview_JoinThisGroup,
    dgGroupOverview_LeaveGroup: dgGroupOverview_LeaveGroup,
    dgGroupOverview_MemberCountFormat: dgGroupOverview_MemberCountFormat,
    dgGroupOverview_OpenGroup: dgGroupOverview_OpenGroup,
    dgGroupOverview_PrivateGroup: dgGroupOverview_PrivateGroup,
    dgGroupOverview_RequestMembership: dgGroupOverview_RequestMembership,
    dgGroupOverview_Restricted: dgGroupOverview_Restricted,
    dgGroupOverview_StaticAdminGroup: dgGroupOverview_StaticAdminGroup,
    dgGroupSearch_PlaceHolder: dgGroupSearch_PlaceHolder,
    dgGroupSecurity_AssignLearning: dgGroupSecurity_AssignLearning,
    dgGroupSecurity_AssignLearningDescription: dgGroupSecurity_AssignLearningDescription,
    dgGroupSecurity_DefaultRoleDescription: dgGroupSecurity_DefaultRoleDescription,
    dgGroupSecurity_DeleteGroup: dgGroupSecurity_DeleteGroup,
    dgGroupSecurity_DeleteGroupDescription: dgGroupSecurity_DeleteGroupDescription,
    dgGroupSecurity_EditPermissions: dgGroupSecurity_EditPermissions,
    dgGroupSecurity_EditPermissionsDescription: dgGroupSecurity_EditPermissionsDescription,
    dgGroupSecurity_EditSettings: dgGroupSecurity_EditSettings,
    dgGroupSecurity_EditSettingsDescription: dgGroupSecurity_EditSettingsDescription,
    dgGroupSecurity_GroupRoleHeader: dgGroupSecurity_GroupRoleHeader,
    dgGroupSecurity_InviteMembers: dgGroupSecurity_InviteMembers,
    dgGroupSecurity_InviteMembersDescription: dgGroupSecurity_InviteMembersDescription,
    dgGroupSecurity_RecommendItems: dgGroupSecurity_RecommendItems,
    dgGroupSecurity_RecommendItemsDescription: dgGroupSecurity_RecommendItemsDescription,
    dgGroupSecurity_RecommendRatings: dgGroupSecurity_RecommendRatings,
    dgGroupSecurity_RecommendRatingsDescription: dgGroupSecurity_RecommendRatingsDescription,
    dgGroupSecurity_RemoveFeedItems: dgGroupSecurity_RemoveFeedItems,
    dgGroupSecurity_RemoveFeedItemsDescription: dgGroupSecurity_RemoveFeedItemsDescription,
    dgGroupSecurity_RemoveMembers: dgGroupSecurity_RemoveMembers,
    dgGroupSecurity_RemoveMembersDescription: dgGroupSecurity_RemoveMembersDescription,
    dgGroupSecurity_ViewGroupInsights: dgGroupSecurity_ViewGroupInsights,
    dgGroupSecurity_ViewGroupInsightsDescription: dgGroupSecurity_ViewGroupInsightsDescription,
    dgGroupSecurity_ViewMembers: dgGroupSecurity_ViewMembers,
    dgGroupSecurity_ViewMembersDescription: dgGroupSecurity_ViewMembersDescription,
    dgGroupSecurity_ViewOrganizationReports: dgGroupSecurity_ViewOrganizationReports,
    dgGroupsEdit_AddGroups: dgGroupsEdit_AddGroups,
    dgGroupsEdit_AddGroupsLabel: dgGroupsEdit_AddGroupsLabel,
    dgGroupsEdit_AddGroupsToBoostTooltip: dgGroupsEdit_AddGroupsToBoostTooltip,
    dgGroupsEdit_AddGroupsTooltip: dgGroupsEdit_AddGroupsTooltip,
    dgGroupsEdit_RemoveGroupName: dgGroupsEdit_RemoveGroupName,
    dgGroupTile_JoinRequestPending: dgGroupTile_JoinRequestPending,
    dgGroupTile_Leave: dgGroupTile_Leave,
    dgGroupTile_LeaveGroupModalBodyText: dgGroupTile_LeaveGroupModalBodyText,
    dgGroupTile_LeaveGroupModalHeader: dgGroupTile_LeaveGroupModalHeader,
    dgGroupTile_MemberCount: dgGroupTile_MemberCount,
    dgGroupTile_RequestMembership: dgGroupTile_RequestMembership,
    dgImageEdit_Change: dgImageEdit_Change,
    dgImageEdit_ChangePhoto: dgImageEdit_ChangePhoto,
    dgImageEdit_ChooseFile: dgImageEdit_ChooseFile,
    dgImageEdit_ChooseFileToUpload: dgImageEdit_ChooseFileToUpload,
    dgImageEdit_ContentCard: dgImageEdit_ContentCard,
    dgImageEdit_ContentDetails: dgImageEdit_ContentDetails,
    dgImageEdit_CropImage: dgImageEdit_CropImage,
    dgImageEdit_CropNote: dgImageEdit_CropNote,
    dgImageEdit_CropToFit: dgImageEdit_CropToFit,
    dgImageEdit_DocumentationDesc: dgImageEdit_DocumentationDesc,
    dgImageEdit_DocumentationLabel: dgImageEdit_DocumentationLabel,
    dgImageEdit_DragPhoto: dgImageEdit_DragPhoto,
    dgImageEdit_FilesizeError: dgImageEdit_FilesizeError,
    dgImageEdit_ImageDimensionsFormat: dgImageEdit_ImageDimensionsFormat,
    dgImageEdit_ImageTypes: dgImageEdit_ImageTypes,
    dgImageEdit_LookingGood: dgImageEdit_LookingGood,
    dgImageEdit_NoImage: dgImageEdit_NoImage,
    dgImageEdit_SaveWithoutCropping: dgImageEdit_SaveWithoutCropping,
    dgImageEdit_SubmitImage: dgImageEdit_SubmitImage,
    dgImageEdit_UploadImagePreview: dgImageEdit_UploadImagePreview,
    dgImageUpload_BadgeFileTypeError: dgImageUpload_BadgeFileTypeError,
    dgImageUpload_BrowseForImage: dgImageUpload_BrowseForImage,
    dgImageUpload_DragImageHere: dgImageUpload_DragImageHere,
    dgImageUpload_DropImage: dgImageUpload_DropImage,
    dgImageUpload_FilesizeError: dgImageUpload_FilesizeError,
    dgImageUpload_FileTypes: dgImageUpload_FileTypes,
    dgImageUpload_ImagePosition: dgImageUpload_ImagePosition,
    dgImageUpload_ImagePosition_HelperText: dgImageUpload_ImagePosition_HelperText,
    dgImageUpload_ImagePreview: dgImageUpload_ImagePreview,
    dgImageUpload_ImageTypesSize: dgImageUpload_ImageTypesSize,
    dgImageUpload_KB: dgImageUpload_KB,
    dgImageUpload_LimitedImageTypesSize: dgImageUpload_LimitedImageTypesSize,
    dgImageUpload_Or: dgImageUpload_Or,
    dgImageUpload_PdfImageTypesSize: dgImageUpload_PdfImageTypesSize,
    dgImageUpload_RemoveImage: dgImageUpload_RemoveImage,
    dgImageUpload_SectionDragAndDrop: dgImageUpload_SectionDragAndDrop,
    dgImageUpload_SectionInvalidFileSize: dgImageUpload_SectionInvalidFileSize,
    dgImageUpload_SectionInvalidFileType: dgImageUpload_SectionInvalidFileType,
    dgImageUpload_SectionInvalidFileTypeVar: dgImageUpload_SectionInvalidFileTypeVar,
    dgImageUpload_SectionRestrictions: dgImageUpload_SectionRestrictions,
    dgImageUpload_SectionRestrictionsVar: dgImageUpload_SectionRestrictionsVar,
    dgImageUpload_UploadImage: dgImageUpload_UploadImage,
    dgInputCountsByType_Points: dgInputCountsByType_Points,
    dgInputStatistics_Commented: dgInputStatistics_Commented,
    dgInputStatistics_CommentsCount: dgInputStatistics_CommentsCount,
    dgInputStatistics_CompletedCount: dgInputStatistics_CompletedCount,
    dgInputStatistics_LikesCount: dgInputStatistics_LikesCount,
    dgInputStatistics_PeopleWhoDisliked: dgInputStatistics_PeopleWhoDisliked,
    dgInputStatistics_PeopleWhoLiked: dgInputStatistics_PeopleWhoLiked,
    dgInputStatistics_PeopleWhoRated: dgInputStatistics_PeopleWhoRated,
    dgInputStatistics_PeopleWhoViewed: dgInputStatistics_PeopleWhoViewed,
    dgInputStatistics_SharesCount: dgInputStatistics_SharesCount,
    dgInputStatistics_SkillsCount: dgInputStatistics_SkillsCount,
    dgInputStatistics_Tag: dgInputStatistics_Tag,
    dgInputStatistics_Tags: dgInputStatistics_Tags,
    dgInputStatistics_TopCommenter: dgInputStatistics_TopCommenter,
    dgInputStatistics_TopCommenterAndOne: dgInputStatistics_TopCommenterAndOne,
    dgInputStatistics_TopCommenterCount: dgInputStatistics_TopCommenterCount,
    dgInputStatistics_TopCompleter: dgInputStatistics_TopCompleter,
    dgInputStatistics_TopCompleterAndOne: dgInputStatistics_TopCompleterAndOne,
    dgInputStatistics_TopCompleterAndOneRead: dgInputStatistics_TopCompleterAndOneRead,
    dgInputStatistics_TopCompleterAndOneWatched: dgInputStatistics_TopCompleterAndOneWatched,
    dgInputStatistics_TopCompleterCount: dgInputStatistics_TopCompleterCount,
    dgInputStatistics_TopCompleterCountRead: dgInputStatistics_TopCompleterCountRead,
    dgInputStatistics_TopCompleterCountWatched: dgInputStatistics_TopCompleterCountWatched,
    dgInputStatistics_TopCompleterRead: dgInputStatistics_TopCompleterRead,
    dgInputStatistics_TopCompleterWatched: dgInputStatistics_TopCompleterWatched,
    dgInputStatistics_TopFollower: dgInputStatistics_TopFollower,
    dgInputStatistics_TopFollowerAndOne: dgInputStatistics_TopFollowerAndOne,
    dgInputStatistics_TopFollowerCount: dgInputStatistics_TopFollowerCount,
    dgInputStatistics_TopRecommender: dgInputStatistics_TopRecommender,
    dgInputStatistics_TopRecommenderAndOne: dgInputStatistics_TopRecommenderAndOne,
    dgInputStatistics_TopRecommenderCount: dgInputStatistics_TopRecommenderCount,
    dgInputStatistics_TopTakeawayAndOne: dgInputStatistics_TopTakeawayAndOne,
    dgInputStatisticsHeader_TopCompleter: dgInputStatisticsHeader_TopCompleter,
    dgInputStatisticsHeader_TopCompleterAndOne: dgInputStatisticsHeader_TopCompleterAndOne,
    dgInputStatisticsHeader_TopCompleterCount: dgInputStatisticsHeader_TopCompleterCount,
    dgInputTile_DueBy: dgInputTile_DueBy,
    dgInputTile_DueByFormat: dgInputTile_DueByFormat,
    dgIntegrationsCard_AlisonMessage: dgIntegrationsCard_AlisonMessage,
    dgIntegrationsCard_CodecademyMessage: dgIntegrationsCard_CodecademyMessage,
    dgIntegrationsCard_CodeSchoolMessage: dgIntegrationsCard_CodeSchoolMessage,
    dgIntegrationsCard_Connect: dgIntegrationsCard_Connect,
    dgIntegrationsCard_Connected: dgIntegrationsCard_Connected,
    dgIntegrationsCard_Disconnect: dgIntegrationsCard_Disconnect,
    dgIntegrationsCard_GoodreadsMessage: dgIntegrationsCard_GoodreadsMessage,
    dgIntegrationsCard_GoogleplusMessage: dgIntegrationsCard_GoogleplusMessage,
    dgIntegrationsCard_ImportingMessage: dgIntegrationsCard_ImportingMessage,
    dgIntegrationsCard_KhanAcademyMessage: dgIntegrationsCard_KhanAcademyMessage,
    dgIntegrationsCard_LastSyncFailure: dgIntegrationsCard_LastSyncFailure,
    dgIntegrationsCard_LastSyncFormat: dgIntegrationsCard_LastSyncFormat,
    dgIntegrationsCard_ManageSettings: dgIntegrationsCard_ManageSettings,
    dgIntegrationsCard_PluralsightMessage: dgIntegrationsCard_PluralsightMessage,
    dgIntegrationsCard_PocketMessage: dgIntegrationsCard_PocketMessage,
    dgIntegrationsCard_SkillshareMessage: dgIntegrationsCard_SkillshareMessage,
    dgIntegrationsCard_SlackMessage: dgIntegrationsCard_SlackMessage,
    dgIntegrationsCard_TreehouseMessage: dgIntegrationsCard_TreehouseMessage,
    dgIntegrationsCard_TwitterMessage: dgIntegrationsCard_TwitterMessage,
    dgIntegrationsCard_UdemyMessage: dgIntegrationsCard_UdemyMessage,
    dgIntegrationsCard_ViewGoogleplusFriends: dgIntegrationsCard_ViewGoogleplusFriends,
    dgIntegrationsCard_ViewTwitterFriends: dgIntegrationsCard_ViewTwitterFriends,
    dgInviteAddCategories_FollowCategories: dgInviteAddCategories_FollowCategories,
    dgInviteAddCategories_FollowCategoriesDesc: dgInviteAddCategories_FollowCategoriesDesc,
    dgInviteAddCategories_LearnPlaceholder: dgInviteAddCategories_LearnPlaceholder,
    dgInviteAddGroups_BecomeMember: dgInviteAddGroups_BecomeMember,
    dgInviteAddGroups_Group: dgInviteAddGroups_Group,
    dgInviteAddGroups_JoinGroup: dgInviteAddGroups_JoinGroup,
    dgInviteAddGroups_JoinGroups: dgInviteAddGroups_JoinGroups,
    dgInviteAddGroups_JoinGroupsDesc: dgInviteAddGroups_JoinGroupsDesc,
    dgInviteAddGroups_LeaveGroup: dgInviteAddGroups_LeaveGroup,
    dgInviteAddPeople_Description: dgInviteAddPeople_Description,
    dgInviteAddPeople_Follow: dgInviteAddPeople_Follow,
    dgInviteAddPeople_Learn: dgInviteAddPeople_Learn,
    dgInviteAddPeople_StopFollowing: dgInviteAddPeople_StopFollowing,
    dgManagePathways_CloneFormat: dgManagePathways_CloneFormat,
    dgManagePathways_CreatePathway: dgManagePathways_CreatePathway,
    dgManagePathways_Edit: dgManagePathways_Edit,
    dgManagePathways_MoreAuthorsFormat: dgManagePathways_MoreAuthorsFormat,
    dgManagePathways_OneMoreAuthor: dgManagePathways_OneMoreAuthor,
    dgManagePathways_SearchPlaceholder: dgManagePathways_SearchPlaceholder,
    dgManagePathways_ViewFormat: dgManagePathways_ViewFormat,
    dgNoSearchResults_CorrectSpelling: dgNoSearchResults_CorrectSpelling,
    dgNoSearchResults_DifferentKeywords: dgNoSearchResults_DifferentKeywords,
    dgNoSearchResults_GeneralKeywords: dgNoSearchResults_GeneralKeywords,
    dgNotificationMenu_NothingNew: dgNotificationMenu_NothingNew,
    dgNotificationMenu_Notifications: dgNotificationMenu_Notifications,
    dgNotificationPreference_IncludeInEmail: dgNotificationPreference_IncludeInEmail,
    dgNotificationPreference_SentTest: dgNotificationPreference_SentTest,
    dgOrgEditMemberModal_RemoveUser: dgOrgEditMemberModal_RemoveUser,
    dgOrgFaqForm_AddFaq: dgOrgFaqForm_AddFaq,
    dgOrgFaqForm_EditFaq: dgOrgFaqForm_EditFaq,
    dgOrgFaqForm_FaqAnswerPlaceholder: dgOrgFaqForm_FaqAnswerPlaceholder,
    dgOrgFaqForm_FaqContactInstructions: dgOrgFaqForm_FaqContactInstructions,
    dgOrgFaqForm_FaqContactLabel: dgOrgFaqForm_FaqContactLabel,
    dgOrgFaqForm_FaqContactPlaceholder: dgOrgFaqForm_FaqContactPlaceholder,
    dgOrgFaqForm_FaqInstructionsFormat: dgOrgFaqForm_FaqInstructionsFormat,
    dgOrgFaqForm_FaqQuestionPlaceholder: dgOrgFaqForm_FaqQuestionPlaceholder,
    dgOrgFaqForm_FaqValidationMessage: dgOrgFaqForm_FaqValidationMessage,
    dgOrgFaqForm_ManageOrgFaqFormat: dgOrgFaqForm_ManageOrgFaqFormat,
    dgOrgInternalContent_1Pathway: dgOrgInternalContent_1Pathway,
    dgOrgInternalContent_1Plan: dgOrgInternalContent_1Plan,
    dgOrgInternalContent_1Share: dgOrgInternalContent_1Share,
    dgOrgInternalContent_AddContent: dgOrgInternalContent_AddContent,
    dgOrgInternalContent_AddEditContent: dgOrgInternalContent_AddEditContent,
    dgOrgInternalContent_AddNewContent: dgOrgInternalContent_AddNewContent,
    dgOrgInternalContent_AddNewContentFormat: dgOrgInternalContent_AddNewContentFormat,
    dgOrgInternalContent_All: dgOrgInternalContent_All,
    dgOrgInternalContent_BrokenLinkError: dgOrgInternalContent_BrokenLinkError,
    dgOrgInternalContent_BrokenLinks: dgOrgInternalContent_BrokenLinks,
    dgOrgInternalContent_BulkDeleteCredSpark: dgOrgInternalContent_BulkDeleteCredSpark,
    dgOrgInternalContent_BulkEdit: dgOrgInternalContent_BulkEdit,
    dgOrgInternalContent_Catalog: dgOrgInternalContent_Catalog,
    dgOrgInternalContent_CategoriesTitle: dgOrgInternalContent_CategoriesTitle,
    dgOrgInternalContent_CategoriesToolTip: dgOrgInternalContent_CategoriesToolTip,
    dgOrgInternalContent_CheckForBrokenLinks: dgOrgInternalContent_CheckForBrokenLinks,
    dgOrgInternalContent_CheckForBrokenToolTip: dgOrgInternalContent_CheckForBrokenToolTip,
    dgOrgInternalContent_ChooseContentType: dgOrgInternalContent_ChooseContentType,
    dgOrgInternalContent_ContentInUse: dgOrgInternalContent_ContentInUse,
    dgOrgInternalContent_ContentType: dgOrgInternalContent_ContentType,
    dgOrgInternalContent_ContentUsedInPlansAndPathways: dgOrgInternalContent_ContentUsedInPlansAndPathways,
    dgOrgInternalContent_ContinueToDeleteContent: dgOrgInternalContent_ContinueToDeleteContent,
    dgOrgInternalContent_DeleteContent: dgOrgInternalContent_DeleteContent,
    dgOrgInternalContent_DeleteContentMessage: dgOrgInternalContent_DeleteContentMessage,
    dgOrgInternalContent_DeleteContentPermissionWarning: dgOrgInternalContent_DeleteContentPermissionWarning,
    dgOrgInternalContent_DeleteContentTooltip: dgOrgInternalContent_DeleteContentTooltip,
    dgOrgInternalContent_DeleteFromAllReferences: dgOrgInternalContent_DeleteFromAllReferences,
    dgOrgInternalContent_DeleteFromAllReferencesTooltip: dgOrgInternalContent_DeleteFromAllReferencesTooltip,
    dgOrgInternalContent_DeleteFromCatalog: dgOrgInternalContent_DeleteFromCatalog,
    dgOrgInternalContent_DeleteItems: dgOrgInternalContent_DeleteItems,
    dgOrgInternalContent_DeleteOneItem: dgOrgInternalContent_DeleteOneItem,
    dgOrgInternalContent_DeleteSelectedInputs: dgOrgInternalContent_DeleteSelectedInputs,
    dgOrgInternalContent_EditContent: dgOrgInternalContent_EditContent,
    dgOrgInternalContent_EditContentFormat: dgOrgInternalContent_EditContentFormat,
    dgOrgInternalContent_GenerateCmsReport: dgOrgInternalContent_GenerateCmsReport,
    dgOrgInternalContent_GroupsTitle: dgOrgInternalContent_GroupsTitle,
    dgOrgInternalContent_GroupsToolTip: dgOrgInternalContent_GroupsToolTip,
    dgOrgInternalContent_InternalContentVisibility: dgOrgInternalContent_InternalContentVisibility,
    dgOrgInternalContent_ItemsSelectedFormat: dgOrgInternalContent_ItemsSelectedFormat,
    dgOrgInternalContent_LastScannedOn: dgOrgInternalContent_LastScannedOn,
    dgOrgInternalContent_LinkIsNotBroken: dgOrgInternalContent_LinkIsNotBroken,
    dgOrgInternalContent_LinkUpdated: dgOrgInternalContent_LinkUpdated,
    dgOrgInternalContent_ManageBrokenLinks: dgOrgInternalContent_ManageBrokenLinks,
    dgOrgInternalContent_MultiplePathways: dgOrgInternalContent_MultiplePathways,
    dgOrgInternalContent_MultiplePlans: dgOrgInternalContent_MultiplePlans,
    dgOrgInternalContent_MultipleShares: dgOrgInternalContent_MultipleShares,
    dgOrgInternalContent_NoBrokenLinksInfoText: dgOrgInternalContent_NoBrokenLinksInfoText,
    dgOrgInternalContent_NoBrokenLinksScanHistory: dgOrgInternalContent_NoBrokenLinksScanHistory,
    dgOrgInternalContent_ScanCompleteNotification: dgOrgInternalContent_ScanCompleteNotification,
    dgOrgInternalContent_ScanIsComplete: dgOrgInternalContent_ScanIsComplete,
    dgOrgInternalContent_ScanningCatalog: dgOrgInternalContent_ScanningCatalog,
    dgOrgInternalContent_ShowMoreItems: dgOrgInternalContent_ShowMoreItems,
    dgOrgInternalContent_SidebarDescriptionFormat: dgOrgInternalContent_SidebarDescriptionFormat,
    dgOrgInternalContent_SidebarTitle: dgOrgInternalContent_SidebarTitle,
    dgOrgInternalContent_SkillsHelperText: dgOrgInternalContent_SkillsHelperText,
    dgOrgInternalContent_SkillsMaxError: dgOrgInternalContent_SkillsMaxError,
    dgOrgInternalContent_SkillsPlaceholderText: dgOrgInternalContent_SkillsPlaceholderText,
    dgOrgInternalContent_SkillsTooltipText: dgOrgInternalContent_SkillsTooltipText,
    dgOrgInternalContent_ViewBrokenLinks: dgOrgInternalContent_ViewBrokenLinks,
    dgOrgInternalContent_ViewScormReport: dgOrgInternalContent_ViewScormReport,
    dgOrgInternalContentForm_AddFromUrl: dgOrgInternalContentForm_AddFromUrl,
    dgOrgInternalContentForm_AddImage: dgOrgInternalContentForm_AddImage,
    dgOrgInternalContentForm_AddInternalItemId: dgOrgInternalContentForm_AddInternalItemId,
    dgOrgInternalContentForm_ArticalFormatPlaceholder: dgOrgInternalContentForm_ArticalFormatPlaceholder,
    dgOrgInternalContentForm_ArticleDescription: dgOrgInternalContentForm_ArticleDescription,
    dgOrgInternalContentForm_ArticleDescriptionPlaceholder: dgOrgInternalContentForm_ArticleDescriptionPlaceholder,
    dgOrgInternalContentForm_ArticleExistsCancel: dgOrgInternalContentForm_ArticleExistsCancel,
    dgOrgInternalContentForm_ArticleExistsDescription: dgOrgInternalContentForm_ArticleExistsDescription,
    dgOrgInternalContentForm_ArticleExistsTitle: dgOrgInternalContentForm_ArticleExistsTitle,
    dgOrgInternalContentForm_ArticleFormat: dgOrgInternalContentForm_ArticleFormat,
    dgOrgInternalContentForm_ArticleFormatSelectPlaceholder: dgOrgInternalContentForm_ArticleFormatSelectPlaceholder,
    dgOrgInternalContentForm_ArticleTitle: dgOrgInternalContentForm_ArticleTitle,
    dgOrgInternalContentForm_ArticleURL: dgOrgInternalContentForm_ArticleURL,
    dgOrgInternalContentForm_AssessmentDescription: dgOrgInternalContentForm_AssessmentDescription,
    dgOrgInternalContentForm_AssessmentExistsDescription: dgOrgInternalContentForm_AssessmentExistsDescription,
    dgOrgInternalContentForm_AssessmentExistsTitle: dgOrgInternalContentForm_AssessmentExistsTitle,
    dgOrgInternalContentForm_AssessmentName: dgOrgInternalContentForm_AssessmentName,
    dgOrgInternalContentForm_AssessmentProvider: dgOrgInternalContentForm_AssessmentProvider,
    dgOrgInternalContentForm_AssessmentURL: dgOrgInternalContentForm_AssessmentURL,
    dgOrgInternalContentForm_AudioURL: dgOrgInternalContentForm_AudioURL,
    dgOrgInternalContentForm_BookAuthor: dgOrgInternalContentForm_BookAuthor,
    dgOrgInternalContentForm_BookCoverAltFormat: dgOrgInternalContentForm_BookCoverAltFormat,
    dgOrgInternalContentForm_BookDatePublished: dgOrgInternalContentForm_BookDatePublished,
    dgOrgInternalContentForm_BookDateRead: dgOrgInternalContentForm_BookDateRead,
    dgOrgInternalContentForm_BookLength: dgOrgInternalContentForm_BookLength,
    dgOrgInternalContentForm_BookLengthCustomFormat: dgOrgInternalContentForm_BookLengthCustomFormat,
    dgOrgInternalContentForm_BookSave: dgOrgInternalContentForm_BookSave,
    dgOrgInternalContentForm_BookSubtitle: dgOrgInternalContentForm_BookSubtitle,
    dgOrgInternalContentForm_BookSummary: dgOrgInternalContentForm_BookSummary,
    dgOrgInternalContentForm_BookTitle: dgOrgInternalContentForm_BookTitle,
    dgOrgInternalContentForm_BookTitlePlaceholder: dgOrgInternalContentForm_BookTitlePlaceholder,
    dgOrgInternalContentForm_CategoriesToolTip: dgOrgInternalContentForm_CategoriesToolTip,
    dgOrgInternalContentForm_ChooseCourseFormat: dgOrgInternalContentForm_ChooseCourseFormat,
    dgOrgInternalContentForm_CommentTooltip: dgOrgInternalContentForm_CommentTooltip,
    dgOrgInternalContentForm_Complete: dgOrgInternalContentForm_Complete,
    dgOrgInternalContentForm_ContentOwner: dgOrgInternalContentForm_ContentOwner,
    dgOrgInternalContentForm_ContentOwnerPlaceholder: dgOrgInternalContentForm_ContentOwnerPlaceholder,
    dgOrgInternalContentForm_ContentOwnerRequired: dgOrgInternalContentForm_ContentOwnerRequired,
    dgOrgInternalContentForm_ContentOwnerTooltip: dgOrgInternalContentForm_ContentOwnerTooltip,
    dgOrgInternalContentForm_CourseDescription: dgOrgInternalContentForm_CourseDescription,
    dgOrgInternalContentForm_CourseDescriptionPlaceholder: dgOrgInternalContentForm_CourseDescriptionPlaceholder,
    dgOrgInternalContentForm_CourseExistsDescription: dgOrgInternalContentForm_CourseExistsDescription,
    dgOrgInternalContentForm_CourseExistsTitle: dgOrgInternalContentForm_CourseExistsTitle,
    dgOrgInternalContentForm_CourseFormat: dgOrgInternalContentForm_CourseFormat,
    dgOrgInternalContentForm_CourseTitle: dgOrgInternalContentForm_CourseTitle,
    dgOrgInternalContentForm_CourseURL: dgOrgInternalContentForm_CourseURL,
    dgOrgInternalContentForm_CreateNewCredSparkAssessment: dgOrgInternalContentForm_CreateNewCredSparkAssessment,
    dgOrgInternalContentForm_CreationDate: dgOrgInternalContentForm_CreationDate,
    dgOrgInternalContentForm_CredSparkDashboard: dgOrgInternalContentForm_CredSparkDashboard,
    dgOrgInternalContentForm_DragImage: dgOrgInternalContentForm_DragImage,
    dgOrgInternalContentForm_EditDetails: dgOrgInternalContentForm_EditDetails,
    dgOrgInternalContentForm_EventDescription: dgOrgInternalContentForm_EventDescription,
    dgOrgInternalContentForm_EventExistsDescription: dgOrgInternalContentForm_EventExistsDescription,
    dgOrgInternalContentForm_EventExistsTitle: dgOrgInternalContentForm_EventExistsTitle,
    dgOrgInternalContentForm_EventFormat: dgOrgInternalContentForm_EventFormat,
    dgOrgInternalContentForm_EventFormatPlaceholder: dgOrgInternalContentForm_EventFormatPlaceholder,
    dgOrgInternalContentForm_EventTitle: dgOrgInternalContentForm_EventTitle,
    dgOrgInternalContentForm_EventTitlePlaceholder: dgOrgInternalContentForm_EventTitlePlaceholder,
    dgOrgInternalContentForm_EventURL: dgOrgInternalContentForm_EventURL,
    dgOrgInternalContentForm_EventURLPlaceholder: dgOrgInternalContentForm_EventURLPlaceholder,
    dgOrgInternalContentForm_File: dgOrgInternalContentForm_File,
    dgOrgInternalContentForm_FileTooLargeFormat: dgOrgInternalContentForm_FileTooLargeFormat,
    dgOrgInternalContentForm_GroupsTitle: dgOrgInternalContentForm_GroupsTitle,
    dgOrgInternalContentForm_GroupsToolTip: dgOrgInternalContentForm_GroupsToolTip,
    dgOrgInternalContentForm_ImageDisplayOption: dgOrgInternalContentForm_ImageDisplayOption,
    dgOrgInternalContentForm_ImageDisplayOption1: dgOrgInternalContentForm_ImageDisplayOption1,
    dgOrgInternalContentForm_ImageDisplayOption2: dgOrgInternalContentForm_ImageDisplayOption2,
    dgOrgInternalContentForm_ImagePreviewAltText: dgOrgInternalContentForm_ImagePreviewAltText,
    dgOrgInternalContentForm_ImageReuploadInstructions: dgOrgInternalContentForm_ImageReuploadInstructions,
    dgOrgInternalContentForm_InternalItemId: dgOrgInternalContentForm_InternalItemId,
    dgOrgInternalContentForm_InvalidFileType: dgOrgInternalContentForm_InvalidFileType,
    dgOrgInternalContentForm_ItemExistsCancel: dgOrgInternalContentForm_ItemExistsCancel,
    dgOrgInternalContentForm_ItemExistsConfirm: dgOrgInternalContentForm_ItemExistsConfirm,
    dgOrgInternalContentForm_IWroteBook: dgOrgInternalContentForm_IWroteBook,
    dgOrgInternalContentForm_Languages: dgOrgInternalContentForm_Languages,
    dgOrgInternalContentForm_ManageCredSparkAccount: dgOrgInternalContentForm_ManageCredSparkAccount,
    dgOrgInternalContentForm_ManageOnCredSpark: dgOrgInternalContentForm_ManageOnCredSpark,
    dgOrgInternalContentForm_NoLanguageFound: dgOrgInternalContentForm_NoLanguageFound,
    dgOrgInternalContentForm_NumberOfQuestions: dgOrgInternalContentForm_NumberOfQuestions,
    dgOrgInternalContentForm_NumberOfUnits: dgOrgInternalContentForm_NumberOfUnits,
    dgOrgInternalContentForm_Or: dgOrgInternalContentForm_Or,
    dgOrgInternalContentForm_ProcessingFile: dgOrgInternalContentForm_ProcessingFile,
    dgOrgInternalContentForm_Questions: dgOrgInternalContentForm_Questions,
    dgOrgInternalContentForm_Record: dgOrgInternalContentForm_Record,
    dgOrgInternalContentForm_RecordAVideo: dgOrgInternalContentForm_RecordAVideo,
    dgOrgInternalContentForm_RecordVideo: dgOrgInternalContentForm_RecordVideo,
    dgOrgInternalContentForm_ReRecordVideo: dgOrgInternalContentForm_ReRecordVideo,
    dgOrgInternalContentForm_ReSyncCredSpark: dgOrgInternalContentForm_ReSyncCredSpark,
    dgOrgInternalContentForm_ReUploadRecording: dgOrgInternalContentForm_ReUploadRecording,
    dgOrgInternalContentForm_ScormFile: dgOrgInternalContentForm_ScormFile,
    dgOrgInternalContentForm_ScormInstructions: dgOrgInternalContentForm_ScormInstructions,
    dgOrgInternalContentForm_ScormPackageCheckbox: dgOrgInternalContentForm_ScormPackageCheckbox,
    dgOrgInternalContentForm_ScormPackageUpdateCheckbox: dgOrgInternalContentForm_ScormPackageUpdateCheckbox,
    dgOrgInternalContentForm_SelectLanguage: dgOrgInternalContentForm_SelectLanguage,
    dgOrgInternalContentForm_UnableToUpload: dgOrgInternalContentForm_UnableToUpload,
    dgOrgInternalContentForm_UploadImage: dgOrgInternalContentForm_UploadImage,
    dgOrgInternalContentForm_UploadRecording: dgOrgInternalContentForm_UploadRecording,
    dgOrgInternalContentForm_VideoDescription: dgOrgInternalContentForm_VideoDescription,
    dgOrgInternalContentForm_VideoDescriptionPlaceholder: dgOrgInternalContentForm_VideoDescriptionPlaceholder,
    dgOrgInternalContentForm_VideoExistsDescription: dgOrgInternalContentForm_VideoExistsDescription,
    dgOrgInternalContentForm_VideoExistsTitle: dgOrgInternalContentForm_VideoExistsTitle,
    dgOrgInternalContentForm_VideoFilesizeError: dgOrgInternalContentForm_VideoFilesizeError,
    dgOrgInternalContentForm_VideoFiletypeError: dgOrgInternalContentForm_VideoFiletypeError,
    dgOrgInternalContentForm_VideoFormat: dgOrgInternalContentForm_VideoFormat,
    dgOrgInternalContentForm_VideoFormatSelectPlaceholder: dgOrgInternalContentForm_VideoFormatSelectPlaceholder,
    dgOrgInternalContentForm_VideoFormPlaceholder: dgOrgInternalContentForm_VideoFormPlaceholder,
    dgOrgInternalContentForm_VideoLength: dgOrgInternalContentForm_VideoLength,
    dgOrgInternalContentForm_VideoSourceSupported: dgOrgInternalContentForm_VideoSourceSupported,
    dgOrgInternalContentForm_VideoTimeLimit: dgOrgInternalContentForm_VideoTimeLimit,
    dgOrgInternalContentForm_VideoTitle: dgOrgInternalContentForm_VideoTitle,
    dgOrgInternalContentForm_VideoUploadLimit: dgOrgInternalContentForm_VideoUploadLimit,
    dgOrgInternalContentForm_VideoURL: dgOrgInternalContentForm_VideoURL,
    dgOrgInvite_CommaSeparated: dgOrgInvite_CommaSeparated,
    dgOrgInvite_EmailAddresses: dgOrgInvite_EmailAddresses,
    dgOrgInvite_InviteEmailsOverview: dgOrgInvite_InviteEmailsOverview,
    dgOrgInvite_InviteLinkOverview: dgOrgInvite_InviteLinkOverview,
    dgOrgInvite_InviteTitle: dgOrgInvite_InviteTitle,
    dgOrgInvite_Send: dgOrgInvite_Send,
    dgOrgManageProviderModal_DisconnectIntegrationWarning: dgOrgManageProviderModal_DisconnectIntegrationWarning,
    dgOrgManageProviderModal_EnableIntegration: dgOrgManageProviderModal_EnableIntegration,
    dgOrgMembers_AddAMessage: dgOrgMembers_AddAMessage,
    dgOrgMembers_AddMembersTitleFormat: dgOrgMembers_AddMembersTitleFormat,
    dgOrgMembers_AddPeople: dgOrgMembers_AddPeople,
    dgOrgMembers_CopyTheURL: dgOrgMembers_CopyTheURL,
    dgOrgMembers_EmailDomainChangeFormat: dgOrgMembers_EmailDomainChangeFormat,
    dgOrgMembers_EmailInstructions: dgOrgMembers_EmailInstructions,
    dgOrgMembers_EmailPlaceholderText: dgOrgMembers_EmailPlaceholderText,
    dgOrgMembers_InviteGroupInstructionsFormat: dgOrgMembers_InviteGroupInstructionsFormat,
    dgOrgMembers_InviteLabel: dgOrgMembers_InviteLabel,
    dgOrgMembers_InviteMembersTitleFormat: dgOrgMembers_InviteMembersTitleFormat,
    dgOrgMembers_PersonalMessageDescription: dgOrgMembers_PersonalMessageDescription,
    dgOrgMembers_PersonalMessageDescriptionFormat: dgOrgMembers_PersonalMessageDescriptionFormat,
    dgOrgMembers_PersonalMessageLabel: dgOrgMembers_PersonalMessageLabel,
    dgOrgMembers_SelectAllPending: dgOrgMembers_SelectAllPending,
    dgOrgMembers_SendInvite: dgOrgMembers_SendInvite,
    dgOrgOverview_ChangeLogo: dgOrgOverview_ChangeLogo,
    dgOrgOverview_ChangeLogoTextFormat: dgOrgOverview_ChangeLogoTextFormat,
    dgOrgOverview_GroupCountFormat: dgOrgOverview_GroupCountFormat,
    dgOrgOverview_HeaderColor: dgOrgOverview_HeaderColor,
    dgOrgOverview_MemberCountFormat: dgOrgOverview_MemberCountFormat,
    dgOrgOverview_PreviewLabel: dgOrgOverview_PreviewLabel,
    dgOrgSecurity_AddGlobalAdmins: dgOrgSecurity_AddGlobalAdmins,
    dgOrgSecurity_AddGlobalAdminsDescription: dgOrgSecurity_AddGlobalAdminsDescription,
    dgOrgSecurity_AssignLearning: dgOrgSecurity_AssignLearning,
    dgOrgSecurity_AssignLearningDescription: dgOrgSecurity_AssignLearningDescription,
    dgOrgSecurity_AssignRatings: dgOrgSecurity_AssignRatings,
    dgOrgSecurity_AssignRatingsDescription: dgOrgSecurity_AssignRatingsDescription,
    dgOrgSecurity_AuthorContent: dgOrgSecurity_AuthorContent,
    dgOrgSecurity_AuthorContentDescription: dgOrgSecurity_AuthorContentDescription,
    dgOrgSecurity_AuthorPathways: dgOrgSecurity_AuthorPathways,
    dgOrgSecurity_AuthorPathwaysDescription: dgOrgSecurity_AuthorPathwaysDescription,
    dgOrgSecurity_AuthorSkillPlans: dgOrgSecurity_AuthorSkillPlans,
    dgOrgSecurity_AuthorSkillPlansDescription: dgOrgSecurity_AuthorSkillPlansDescription,
    dgOrgSecurity_AuthorTargets: dgOrgSecurity_AuthorTargets,
    dgOrgSecurity_AuthorTargetsDescription: dgOrgSecurity_AuthorTargetsDescription,
    dgOrgSecurity_CobfigureBrowse: dgOrgSecurity_CobfigureBrowse,
    dgOrgSecurity_ConfigureBrowse: dgOrgSecurity_ConfigureBrowse,
    dgOrgSecurity_ConfigureBrowseDescription: dgOrgSecurity_ConfigureBrowseDescription,
    dgOrgSecurity_CreateAdministrativeGroups: dgOrgSecurity_CreateAdministrativeGroups,
    dgOrgSecurity_CreateAdministrativeGroupsDescription: dgOrgSecurity_CreateAdministrativeGroupsDescription,
    dgOrgSecurity_CreateClosedGroups: dgOrgSecurity_CreateClosedGroups,
    dgOrgSecurity_CreateClosedGroupsDescription: dgOrgSecurity_CreateClosedGroupsDescription,
    dgOrgSecurity_CreateDynamicTeamAssignmentOpportunities: dgOrgSecurity_CreateDynamicTeamAssignmentOpportunities,
    dgOrgSecurity_CreateDynamicTeamAssignmentOpportunitiesDesc: dgOrgSecurity_CreateDynamicTeamAssignmentOpportunitiesDesc,
    dgOrgSecurity_CreateDynamicTeamAssignmentOpportunitiesDescription: dgOrgSecurity_CreateDynamicTeamAssignmentOpportunitiesDescription,
    dgOrgSecurity_CreateGroups: dgOrgSecurity_CreateGroups,
    dgOrgSecurity_CreateGroupsDescription: dgOrgSecurity_CreateGroupsDescription,
    dgOrgSecurity_CreateLookingforMenteeOpportunities: dgOrgSecurity_CreateLookingforMenteeOpportunities,
    dgOrgSecurity_CreateLookingforMenteeOpportunitiesDescription: dgOrgSecurity_CreateLookingforMenteeOpportunitiesDescription,
    dgOrgSecurity_CreateLookingforMentorOpportunities: dgOrgSecurity_CreateLookingforMentorOpportunities,
    dgOrgSecurity_CreateLookingforMentorOpportunitiesDescription: dgOrgSecurity_CreateLookingforMentorOpportunitiesDescription,
    dgOrgSecurity_CreateMentorshipOpportunities: dgOrgSecurity_CreateMentorshipOpportunities,
    dgOrgSecurity_CreateMentorshipOpportunitiesDescription: dgOrgSecurity_CreateMentorshipOpportunitiesDescription,
    dgOrgSecurity_CreateOpenGroups: dgOrgSecurity_CreateOpenGroups,
    dgOrgSecurity_CreateOpenGroupsDescription: dgOrgSecurity_CreateOpenGroupsDescription,
    dgOrgSecurity_CreateOpportunities: dgOrgSecurity_CreateOpportunities,
    dgOrgSecurity_CreateOpportunitiesDescription: dgOrgSecurity_CreateOpportunitiesDescription,
    dgOrgSecurity_CreateOtherOpportunities: dgOrgSecurity_CreateOtherOpportunities,
    dgOrgSecurity_CreateOtherOpportunitiesDescription: dgOrgSecurity_CreateOtherOpportunitiesDescription,
    dgOrgSecurity_CreatePeerMentoringOpportunities: dgOrgSecurity_CreatePeerMentoringOpportunities,
    dgOrgSecurity_CreatePeerMentoringOpportunitiesDescription: dgOrgSecurity_CreatePeerMentoringOpportunitiesDescription,
    dgOrgSecurity_CreatePrivateGroups: dgOrgSecurity_CreatePrivateGroups,
    dgOrgSecurity_CreatePrivateGroupsDescription: dgOrgSecurity_CreatePrivateGroupsDescription,
    dgOrgSecurity_CreateProBonoOpportunities: dgOrgSecurity_CreateProBonoOpportunities,
    dgOrgSecurity_CreateProBonoOpportunitiesDescription: dgOrgSecurity_CreateProBonoOpportunitiesDescription,
    dgOrgSecurity_CreateProjectOpportunities: dgOrgSecurity_CreateProjectOpportunities,
    dgOrgSecurity_CreateProjectOpportunitiesDescription: dgOrgSecurity_CreateProjectOpportunitiesDescription,
    dgOrgSecurity_CreateReverseMentoringOpportunities: dgOrgSecurity_CreateReverseMentoringOpportunities,
    dgOrgSecurity_CreateReverseMentoringOpportunitiesDescription: dgOrgSecurity_CreateReverseMentoringOpportunitiesDescription,
    dgOrgSecurity_CreateShadowingOpportunities: dgOrgSecurity_CreateShadowingOpportunities,
    dgOrgSecurity_CreateShadowingOpportunitiesDescription: dgOrgSecurity_CreateShadowingOpportunitiesDescription,
    dgOrgSecurity_CreateStretchAssignmentOpportunities: dgOrgSecurity_CreateStretchAssignmentOpportunities,
    dgOrgSecurity_CreateStretchAssignmentOpportunitiesDescription: dgOrgSecurity_CreateStretchAssignmentOpportunitiesDescription,
    dgOrgSecurity_CreateTenant: dgOrgSecurity_CreateTenant,
    dgOrgSecurity_CreateTenantDescription: dgOrgSecurity_CreateTenantDescription,
    dgOrgSecurity_CreateVolunteerOpportunities: dgOrgSecurity_CreateVolunteerOpportunities,
    dgOrgSecurity_CreateVolunteerOpportunitiesDescription: dgOrgSecurity_CreateVolunteerOpportunitiesDescription,
    dgOrgSecurity_CustomizeBrowse: dgOrgSecurity_CustomizeBrowse,
    dgOrgSecurity_DefaultRoleText: dgOrgSecurity_DefaultRoleText,
    dgOrgSecurity_DeleteGroup: dgOrgSecurity_DeleteGroup,
    dgOrgSecurity_DeleteGroupDescription: dgOrgSecurity_DeleteGroupDescription,
    dgOrgSecurity_DownloadPathwayDetailsReport: dgOrgSecurity_DownloadPathwayDetailsReport,
    dgOrgSecurity_DownloadPathwayDetailsReportDescription: dgOrgSecurity_DownloadPathwayDetailsReportDescription,
    dgOrgSecurity_DownloadReports: dgOrgSecurity_DownloadReports,
    dgOrgSecurity_DownloadReportsDescription: dgOrgSecurity_DownloadReportsDescription,
    dgOrgSecurity_EditCommunications: dgOrgSecurity_EditCommunications,
    dgOrgSecurity_EditCommunicationsDescription: dgOrgSecurity_EditCommunicationsDescription,
    dgOrgSecurity_EditCommunicationsGlobal: dgOrgSecurity_EditCommunicationsGlobal,
    dgOrgSecurity_EditCommunicationsGlobalDescription: dgOrgSecurity_EditCommunicationsGlobalDescription,
    dgOrgSecurity_EditPermissions: dgOrgSecurity_EditPermissions,
    dgOrgSecurity_EditPermissionsDescription: dgOrgSecurity_EditPermissionsDescription,
    dgOrgSecurity_EditPermissionsGlobal: dgOrgSecurity_EditPermissionsGlobal,
    dgOrgSecurity_EditPermissionsGlobalDescription: dgOrgSecurity_EditPermissionsGlobalDescription,
    dgOrgSecurity_EditSettings: dgOrgSecurity_EditSettings,
    dgOrgSecurity_EditSettingsDescription: dgOrgSecurity_EditSettingsDescription,
    dgOrgSecurity_EditTenantOrganizationPermissions: dgOrgSecurity_EditTenantOrganizationPermissions,
    dgOrgSecurity_EditTenantOrganizationPermissionsDescription: dgOrgSecurity_EditTenantOrganizationPermissionsDescription,
    dgOrgSecurity_EditTenantSettings: dgOrgSecurity_EditTenantSettings,
    dgOrgSecurity_EditTenantSettingsDescription: dgOrgSecurity_EditTenantSettingsDescription,
    dgOrgSecurity_EmailPasswordReset: dgOrgSecurity_EmailPasswordReset,
    dgOrgSecurity_EmailPasswordResetDescription: dgOrgSecurity_EmailPasswordResetDescription,
    dgOrgSecurity_EndorseContent: dgOrgSecurity_EndorseContent,
    dgOrgSecurity_EndorseContentDescription: dgOrgSecurity_EndorseContentDescription,
    dgOrgSecurity_InviteMembers: dgOrgSecurity_InviteMembers,
    dgOrgSecurity_InviteMembersDescription: dgOrgSecurity_InviteMembersDescription,
    dgOrgSecurity_LearningProfessional: dgOrgSecurity_LearningProfessional,
    dgOrgSecurity_LearnMore: dgOrgSecurity_LearnMore,
    dgOrgSecurity_ManageAdvanced: dgOrgSecurity_ManageAdvanced,
    dgOrgSecurity_ManageAdvancedDescription: dgOrgSecurity_ManageAdvancedDescription,
    dgOrgSecurity_ManageAttributes: dgOrgSecurity_ManageAttributes,
    dgOrgSecurity_ManageAttributesDescription: dgOrgSecurity_ManageAttributesDescription,
    dgOrgSecurity_ManageBusinessRules: dgOrgSecurity_ManageBusinessRules,
    dgOrgSecurity_ManageBusinessRulesDescription: dgOrgSecurity_ManageBusinessRulesDescription,
    dgOrgSecurity_ManageContent: dgOrgSecurity_ManageContent,
    dgOrgSecurity_ManageContentDescription: dgOrgSecurity_ManageContentDescription,
    dgOrgSecurity_ManageEngage: dgOrgSecurity_ManageEngage,
    dgOrgSecurity_ManageEngageDescription: dgOrgSecurity_ManageEngageDescription,
    dgOrgSecurity_ManageGroups: dgOrgSecurity_ManageGroups,
    dgOrgSecurity_ManageGroupsDescription: dgOrgSecurity_ManageGroupsDescription,
    dgOrgSecurity_ManageIntegrations: dgOrgSecurity_ManageIntegrations,
    dgOrgSecurity_ManageIntegrationsDescription: dgOrgSecurity_ManageIntegrationsDescription,
    dgOrgSecurity_ManageOpportunities: dgOrgSecurity_ManageOpportunities,
    dgOrgSecurity_ManageOpportunitiesDescription: dgOrgSecurity_ManageOpportunitiesDescription,
    dgOrgSecurity_ManageOrgApiKeys: dgOrgSecurity_ManageOrgApiKeys,
    dgOrgSecurity_ManageOrgApiKeysDescription: dgOrgSecurity_ManageOrgApiKeysDescription,
    dgOrgSecurity_ManagePathways: dgOrgSecurity_ManagePathways,
    dgOrgSecurity_ManagePathwaysDescription: dgOrgSecurity_ManagePathwaysDescription,
    dgOrgSecurity_ManageReporting: dgOrgSecurity_ManageReporting,
    dgOrgSecurity_ManageReportingDescription: dgOrgSecurity_ManageReportingDescription,
    dgOrgSecurity_ManageReportingFTPScheduler: dgOrgSecurity_ManageReportingFTPScheduler,
    dgOrgSecurity_ManageReportingFTPSchedulerDescription: dgOrgSecurity_ManageReportingFTPSchedulerDescription,
    dgOrgSecurity_ManageReportingInApp: dgOrgSecurity_ManageReportingInApp,
    dgOrgSecurity_ManageReportingInAppDescription: dgOrgSecurity_ManageReportingInAppDescription,
    dgOrgSecurity_ManageReportingTransmitterConfigurations: dgOrgSecurity_ManageReportingTransmitterConfigurations,
    dgOrgSecurity_ManageReportingTransmitterConfigurationsDescription: dgOrgSecurity_ManageReportingTransmitterConfigurationsDescription,
    dgOrgSecurity_ManageSegments: dgOrgSecurity_ManageSegments,
    dgOrgSecurity_ManageSegmentsDescription: dgOrgSecurity_ManageSegmentsDescription,
    dgOrgSecurity_ManageSkillPlans: dgOrgSecurity_ManageSkillPlans,
    dgOrgSecurity_ManageSkillPlansDescription: dgOrgSecurity_ManageSkillPlansDescription,
    dgOrgSecurity_ManageSkills: dgOrgSecurity_ManageSkills,
    dgOrgSecurity_ManageSkillsDescription: dgOrgSecurity_ManageSkillsDescription,
    dgOrgSecurity_ManageSkillsPlatform: dgOrgSecurity_ManageSkillsPlatform,
    dgOrgSecurity_ManageSkillsPlatformDescription: dgOrgSecurity_ManageSkillsPlatformDescription,
    dgOrgSecurity_ManageSkillStandards: dgOrgSecurity_ManageSkillStandards,
    dgOrgSecurity_ManageSkillStandardsDescription: dgOrgSecurity_ManageSkillStandardsDescription,
    dgOrgSecurity_ManageTargets: dgOrgSecurity_ManageTargets,
    dgOrgSecurity_ManageTargetsDescription: dgOrgSecurity_ManageTargetsDescription,
    dgOrgSecurity_PublishOpportunities: dgOrgSecurity_PublishOpportunities,
    dgOrgSecurity_PublishOpportunitiesDescription: dgOrgSecurity_PublishOpportunitiesDescription,
    dgOrgSecurity_PublishSkills: dgOrgSecurity_PublishSkills,
    dgOrgSecurity_PublishSkillsDescription: dgOrgSecurity_PublishSkillsDescription,
    dgOrgSecurity_RecommendItems: dgOrgSecurity_RecommendItems,
    dgOrgSecurity_RecommendItemsDescription: dgOrgSecurity_RecommendItemsDescription,
    dgOrgSecurity_RecommendItemsWithDate: dgOrgSecurity_RecommendItemsWithDate,
    dgOrgSecurity_RecommendItemsWithDateDescription: dgOrgSecurity_RecommendItemsWithDateDescription,
    dgOrgSecurity_RecommendOpportunities: dgOrgSecurity_RecommendOpportunities,
    dgOrgSecurity_RecommendOpportunitiesDescription: dgOrgSecurity_RecommendOpportunitiesDescription,
    dgOrgSecurity_RecommendRatings: dgOrgSecurity_RecommendRatings,
    dgOrgSecurity_RecommendRatingsDescription: dgOrgSecurity_RecommendRatingsDescription,
    dgOrgSecurity_RemoveMembers: dgOrgSecurity_RemoveMembers,
    dgOrgSecurity_RemoveMembersDescription: dgOrgSecurity_RemoveMembersDescription,
    dgOrgSecurity_RequestManagerRating: dgOrgSecurity_RequestManagerRating,
    dgOrgSecurity_RequestManagerRatingDescription: dgOrgSecurity_RequestManagerRatingDescription,
    dgOrgSecurity_RoleAdmin: dgOrgSecurity_RoleAdmin,
    dgOrgSecurity_RoleLearningProfessional: dgOrgSecurity_RoleLearningProfessional,
    dgOrgSecurity_RoleManager: dgOrgSecurity_RoleManager,
    dgOrgSecurity_RoleMember: dgOrgSecurity_RoleMember,
    dgOrgSecurity_ScanCatalogLinks: dgOrgSecurity_ScanCatalogLinks,
    dgOrgSecurity_ScanCatalogLinksDescription: dgOrgSecurity_ScanCatalogLinksDescription,
    dgOrgSecurity_SelectFeaturedPathways: dgOrgSecurity_SelectFeaturedPathways,
    dgOrgSecurity_SelectFeaturedPathwaysDescription: dgOrgSecurity_SelectFeaturedPathwaysDescription,
    dgOrgSecurity_ShareBundledContent: dgOrgSecurity_ShareBundledContent,
    dgOrgSecurity_ShareBundledContentDescription: dgOrgSecurity_ShareBundledContentDescription,
    dgOrgSecurity_UploadClientUser: dgOrgSecurity_UploadClientUser,
    dgOrgSecurity_UploadClientUserDescription: dgOrgSecurity_UploadClientUserDescription,
    dgOrgSecurity_UploadCompletions: dgOrgSecurity_UploadCompletions,
    dgOrgSecurity_UploadCompletionsDescription: dgOrgSecurity_UploadCompletionsDescription,
    dgOrgSecurity_UploadContent: dgOrgSecurity_UploadContent,
    dgOrgSecurity_UploadContentDescription: dgOrgSecurity_UploadContentDescription,
    dgOrgSecurity_UploadContentFiles: dgOrgSecurity_UploadContentFiles,
    dgOrgSecurity_UploadContentFilesDescription: dgOrgSecurity_UploadContentFilesDescription,
    dgOrgSecurity_UploadFiles: dgOrgSecurity_UploadFiles,
    dgOrgSecurity_UploadFilesDescription: dgOrgSecurity_UploadFilesDescription,
    dgOrgSecurity_UploadGroups: dgOrgSecurity_UploadGroups,
    dgOrgSecurity_UploadGroupsDescription: dgOrgSecurity_UploadGroupsDescription,
    dgOrgSecurity_UploadOpportunities: dgOrgSecurity_UploadOpportunities,
    dgOrgSecurity_UploadOpportunitiesDescription: dgOrgSecurity_UploadOpportunitiesDescription,
    dgOrgSecurity_UploadPlans: dgOrgSecurity_UploadPlans,
    dgOrgSecurity_UploadPlansDescription: dgOrgSecurity_UploadPlansDescription,
    dgOrgSecurity_UploadRequiredLearning: dgOrgSecurity_UploadRequiredLearning,
    dgOrgSecurity_UploadRequiredLearningDescription: dgOrgSecurity_UploadRequiredLearningDescription,
    dgOrgSecurity_UploadRoles: dgOrgSecurity_UploadRoles,
    dgOrgSecurity_UploadRolesDescription: dgOrgSecurity_UploadRolesDescription,
    dgOrgSecurity_UploadSkills: dgOrgSecurity_UploadSkills,
    dgOrgSecurity_UploadSkillsDescription: dgOrgSecurity_UploadSkillsDescription,
    dgOrgSecurity_UploadUserUpdates: dgOrgSecurity_UploadUserUpdates,
    dgOrgSecurity_UploadUserUpdatesDescription: dgOrgSecurity_UploadUserUpdatesDescription,
    dgOrgSecurity_ViewCareerPaths: dgOrgSecurity_ViewCareerPaths,
    dgOrgSecurity_ViewCareerPathsDescription: dgOrgSecurity_ViewCareerPathsDescription,
    dgOrgSecurity_ViewDynamicAdminGroupMembers: dgOrgSecurity_ViewDynamicAdminGroupMembers,
    dgOrgSecurity_ViewDynamicAdminGroupMembersDescription: dgOrgSecurity_ViewDynamicAdminGroupMembersDescription,
    dgOrgSecurity_ViewKnowledgeCenter: dgOrgSecurity_ViewKnowledgeCenter,
    dgOrgSecurity_ViewKnowledgeCenterDescription: dgOrgSecurity_ViewKnowledgeCenterDescription,
    dgOrgSecurity_ViewMembers: dgOrgSecurity_ViewMembers,
    dgOrgSecurity_ViewMembersDescription: dgOrgSecurity_ViewMembersDescription,
    dgOrgSecurity_ViewOpportunities: dgOrgSecurity_ViewOpportunities,
    dgOrgSecurity_ViewOpportunitiesDescription: dgOrgSecurity_ViewOpportunitiesDescription,
    dgOrgSecurity_ViewOrganizationOpportunityInsights: dgOrgSecurity_ViewOrganizationOpportunityInsights,
    dgOrgSecurity_ViewOrganizationOpportunityInsightsDescription: dgOrgSecurity_ViewOrganizationOpportunityInsightsDescription,
    dgOrgSecurity_ViewOrganizationReports: dgOrgSecurity_ViewOrganizationReports,
    dgOrgSecurity_ViewOrganizationReportsDescription: dgOrgSecurity_ViewOrganizationReportsDescription,
    dgOrgSecurity_ViewPathwayEnrollees: dgOrgSecurity_ViewPathwayEnrollees,
    dgOrgSecurity_ViewPathwayEnrolleesDescription: dgOrgSecurity_ViewPathwayEnrolleesDescription,
    dgOrgSecurity_ViewRatings: dgOrgSecurity_ViewRatings,
    dgOrgSecurity_ViewRatingsDescription: dgOrgSecurity_ViewRatingsDescription,
    dgOrgSecurity_ViewRecommendedRatings: dgOrgSecurity_ViewRecommendedRatings,
    dgOrgSecurity_ViewRecommendedRatingsDescription: dgOrgSecurity_ViewRecommendedRatingsDescription,
    dgPathwayPrivacy_CollaboratorProfilePrivate: dgPathwayPrivacy_CollaboratorProfilePrivate,
    dgPathwayPrivacy_CollaboratorProfileVisible: dgPathwayPrivacy_CollaboratorProfileVisible,
    dgPathwayPrivacy_OrgVisibleFormat: dgPathwayPrivacy_OrgVisibleFormat,
    dgPathwayPrivacy_Private: dgPathwayPrivacy_Private,
    dgPathwayPrivacy_ProfilePrivate: dgPathwayPrivacy_ProfilePrivate,
    dgPathwayPrivacy_ProfileVisible: dgPathwayPrivacy_ProfileVisible,
    dgPathwayPrivacy_Public: dgPathwayPrivacy_Public,
    dgPathwayPrivacy_SpecificGroupsVisible: dgPathwayPrivacy_SpecificGroupsVisible,
    dgPathwayPrivacy_VisibilityBoostToGroupTooltip: dgPathwayPrivacy_VisibilityBoostToGroupTooltip,
    dgPathwaysInsights_CompletionPercentage: dgPathwaysInsights_CompletionPercentage,
    dgPathwaysInsights_EnrolledCountFormat: dgPathwaysInsights_EnrolledCountFormat,
    dgPathwaysInsights_EnrolledCountPluralFormat: dgPathwaysInsights_EnrolledCountPluralFormat,
    dgPathwaysInsights_FiftyToSeventyFive: dgPathwaysInsights_FiftyToSeventyFive,
    dgPathwaysInsights_FollowerCountFormat: dgPathwaysInsights_FollowerCountFormat,
    dgPathwaysInsights_FollowerCountPluralFormat: dgPathwaysInsights_FollowerCountPluralFormat,
    dgPathwaysInsights_GreaterThanSeventyFive: dgPathwaysInsights_GreaterThanSeventyFive,
    dgPathwaysInsights_LessonLower: dgPathwaysInsights_LessonLower,
    dgPathwaysInsights_LessThanTwentyFive: dgPathwaysInsights_LessThanTwentyFive,
    dgPathwaysInsights_PercentageOfEnrollees: dgPathwaysInsights_PercentageOfEnrollees,
    dgPathwaysInsights_PercentageOfFollowers: dgPathwaysInsights_PercentageOfFollowers,
    dgPathwaysInsights_Section: dgPathwaysInsights_Section,
    dgPathwaysInsights_SectionLower: dgPathwaysInsights_SectionLower,
    dgPathwaysInsights_Sections: dgPathwaysInsights_Sections,
    dgPathwaysInsights_TableTitle: dgPathwaysInsights_TableTitle,
    dgPathwaysInsights_Title: dgPathwaysInsights_Title,
    dgPathwaysInsights_TwentyFiveToFifty: dgPathwaysInsights_TwentyFiveToFifty,
    dgPathwaysInsights_WhenDataUpdates: dgPathwaysInsights_WhenDataUpdates,
    dgPathwayTile_Enroll: dgPathwayTile_Enroll,
    dgPathwayTile_Enrolled: dgPathwayTile_Enrolled,
    dgPathwayTile_EnrolledButtonLabel: dgPathwayTile_EnrolledButtonLabel,
    dgPathwayTile_Follow: dgPathwayTile_Follow,
    dgPathwayTile_Following: dgPathwayTile_Following,
    dgPathwayTile_FollowingButtonLabel: dgPathwayTile_FollowingButtonLabel,
    dgPathwayTile_PrivateShareMsg: dgPathwayTile_PrivateShareMsg,
    dgPathwayTile_SavedForLaterMsgFormat: dgPathwayTile_SavedForLaterMsgFormat,
    dgPathwayTile_Unfollow: dgPathwayTile_Unfollow,
    dgPathwayTile_UnfollowConfirm: dgPathwayTile_UnfollowConfirm,
    dgPathwayTile_Withdraw: dgPathwayTile_Withdraw,
    dgPathwayTile_WithdrawConfirm: dgPathwayTile_WithdrawConfirm,
    dgPathwayTile_WithdrawExplanation: dgPathwayTile_WithdrawExplanation,
    dgPopularCategories_ListOption: dgPopularCategories_ListOption,
    dgPopularCategories_NoCategories: dgPopularCategories_NoCategories,
    dgPopularCategories_NoSearchTerms: dgPopularCategories_NoSearchTerms,
    dgPopularCategories_TagsOption: dgPopularCategories_TagsOption,
    dgPopularCategories_UncategorizedFormat: dgPopularCategories_UncategorizedFormat,
    dgPopularProviders_Empty: dgPopularProviders_Empty,
    dgPopularProviders_InputPercentageFormat: dgPopularProviders_InputPercentageFormat,
    dgPopularProviders_ProviderPlaceholder: dgPopularProviders_ProviderPlaceholder,
    dgPopularProviders_SeatsFormat: dgPopularProviders_SeatsFormat,
    dgPopularSearches_ListOption: dgPopularSearches_ListOption,
    dgPopularSearches_TermOption: dgPopularSearches_TermOption,
    dgPostComment_Message: dgPostComment_Message,
    dgPostComment_Placeholder: dgPostComment_Placeholder,
    dgProfileCollectionItem_CertDetailsTitle: dgProfileCollectionItem_CertDetailsTitle,
    dgProfileCollectionItem_CertImage: dgProfileCollectionItem_CertImage,
    dgProfileCollectionItem_CertIssuedBy: dgProfileCollectionItem_CertIssuedBy,
    dgProfileCollectionItem_CertIssuerUrl: dgProfileCollectionItem_CertIssuerUrl,
    dgProfileCollectionItem_CertNumber: dgProfileCollectionItem_CertNumber,
    dgProfileCollectionItem_CertTitle: dgProfileCollectionItem_CertTitle,
    dgProfileCollectionItem_CertValidDate: dgProfileCollectionItem_CertValidDate,
    dgProfileCollectionItem_MasteryPointsFormat: dgProfileCollectionItem_MasteryPointsFormat,
    dgProfileCollectionItem_Verified: dgProfileCollectionItem_Verified,
    dgProfileOverview_AchievementReported: dgProfileOverview_AchievementReported,
    dgProfileOverview_AddAchievements: dgProfileOverview_AddAchievements,
    dgProfileOverview_AddDescription: dgProfileOverview_AddDescription,
    dgProfileOverview_AddDevelopmentPlan: dgProfileOverview_AddDevelopmentPlan,
    dgProfileOverview_AddExperiences: dgProfileOverview_AddExperiences,
    dgProfileOverview_AdditionalSkills: dgProfileOverview_AdditionalSkills,
    dgProfileOverview_AddLearning: dgProfileOverview_AddLearning,
    dgProfileOverview_AddSkill: dgProfileOverview_AddSkill,
    dgProfileOverview_AddSkillOrTopic: dgProfileOverview_AddSkillOrTopic,
    dgProfileOverview_AwardReceivedDate: dgProfileOverview_AwardReceivedDate,
    dgProfileOverview_BuildProfileAchievementsComplete_Plural: dgProfileOverview_BuildProfileAchievementsComplete_Plural,
    dgProfileOverview_BuildProfileAchievementsComplete_Single: dgProfileOverview_BuildProfileAchievementsComplete_Single,
    dgProfileOverview_BuildProfileAchievementsIncomplete: dgProfileOverview_BuildProfileAchievementsIncomplete,
    dgProfileOverview_BuildProfileExperiencesComplete_Plural: dgProfileOverview_BuildProfileExperiencesComplete_Plural,
    dgProfileOverview_BuildProfileExperiencesComplete_Single: dgProfileOverview_BuildProfileExperiencesComplete_Single,
    dgProfileOverview_BuildProfileExperiencesIncomplete: dgProfileOverview_BuildProfileExperiencesIncomplete,
    dgProfileOverview_BuildProfileFocusSkillsComplete: dgProfileOverview_BuildProfileFocusSkillsComplete,
    dgProfileOverview_BuildProfileFocusSkillsComplete_Plural: dgProfileOverview_BuildProfileFocusSkillsComplete_Plural,
    dgProfileOverview_BuildProfileFocusSkillsIncomplete: dgProfileOverview_BuildProfileFocusSkillsIncomplete,
    dgProfileOverview_BuildProfileLearningsComplete_Plural: dgProfileOverview_BuildProfileLearningsComplete_Plural,
    dgProfileOverview_BuildProfileLearningsIncomplete: dgProfileOverview_BuildProfileLearningsIncomplete,
    dgProfileOverview_BuildProfileSectionCompleted: dgProfileOverview_BuildProfileSectionCompleted,
    dgProfileOverview_BuildProfileSkillRatingsComplete_Plural: dgProfileOverview_BuildProfileSkillRatingsComplete_Plural,
    dgProfileOverview_BuildProfileSkillRatingsComplete_Single: dgProfileOverview_BuildProfileSkillRatingsComplete_Single,
    dgProfileOverview_BuildProfileSkillRatingsIncomplete: dgProfileOverview_BuildProfileSkillRatingsIncomplete,
    dgProfileOverview_BuildProfileSkillsComplete_Plural: dgProfileOverview_BuildProfileSkillsComplete_Plural,
    dgProfileOverview_BuildProfileSkillsIncomplete: dgProfileOverview_BuildProfileSkillsIncomplete,
    dgProfileOverview_BuildProfileSubTitle: dgProfileOverview_BuildProfileSubTitle,
    dgProfileOverview_BuildProfileTitle: dgProfileOverview_BuildProfileTitle,
    dgProfileOverview_CertificateNumber: dgProfileOverview_CertificateNumber,
    dgProfileOverview_Columns: dgProfileOverview_Columns,
    dgProfileOverview_ColumnsToDisplay: dgProfileOverview_ColumnsToDisplay,
    dgProfileOverview_FilterForSkills: dgProfileOverview_FilterForSkills,
    dgProfileOverview_FindExperts: dgProfileOverview_FindExperts,
    dgProfileOverview_FocusedSkills: dgProfileOverview_FocusedSkills,
    dgProfileOverview_FocusedSkillsDescription: dgProfileOverview_FocusedSkillsDescription,
    dgProfileOverview_FocusEmptyState_Link: dgProfileOverview_FocusEmptyState_Link,
    dgProfileOverview_FocusEmptyState_Owner: dgProfileOverview_FocusEmptyState_Owner,
    dgProfileOverview_FocusEmptyState_Viewer: dgProfileOverview_FocusEmptyState_Viewer,
    dgProfileOverview_FocusSkills: dgProfileOverview_FocusSkills,
    dgProfileOverview_FocusSkills_EmptyState: dgProfileOverview_FocusSkills_EmptyState,
    dgProfileOverview_FocusSkillsDescription: dgProfileOverview_FocusSkillsDescription,
    dgProfileOverview_FocusSkillsDescriptionOtherProfile: dgProfileOverview_FocusSkillsDescriptionOtherProfile,
    dgProfileOverview_FocusSkillsHelp: dgProfileOverview_FocusSkillsHelp,
    dgProfileOverview_FocusSkillsHelp_and_Core_Icon: dgProfileOverview_FocusSkillsHelp_and_Core_Icon,
    dgProfileOverview_HasParsedResume: dgProfileOverview_HasParsedResume,
    dgProfileOverview_LearningTitle: dgProfileOverview_LearningTitle,
    dgProfileOverview_MaxColumnsToDisplay: dgProfileOverview_MaxColumnsToDisplay,
    dgProfileOverview_MaxFocusedSkills: dgProfileOverview_MaxFocusedSkills,
    dgProfileOverview_NoCompletedContent: dgProfileOverview_NoCompletedContent,
    dgProfileOverview_NonOwnerEmptyStateBody: dgProfileOverview_NonOwnerEmptyStateBody,
    dgProfileOverview_NonOwnerEmptyStateTitle: dgProfileOverview_NonOwnerEmptyStateTitle,
    dgProfileOverview_NoParsedResume: dgProfileOverview_NoParsedResume,
    dgProfileOverview_NoSkills: dgProfileOverview_NoSkills,
    dgProfileOverview_NothingCompleted: dgProfileOverview_NothingCompleted,
    dgProfileOverview_OtherSkills: dgProfileOverview_OtherSkills,
    dgProfileOverview_OverviewAchievementsTitle: dgProfileOverview_OverviewAchievementsTitle,
    dgProfileOverview_OverviewCompleteWizardButton: dgProfileOverview_OverviewCompleteWizardButton,
    dgProfileOverview_OverviewEmptyStateText: dgProfileOverview_OverviewEmptyStateText,
    dgProfileOverview_OverviewEmptyStateTitle: dgProfileOverview_OverviewEmptyStateTitle,
    dgProfileOverview_OverviewExperienceTitle: dgProfileOverview_OverviewExperienceTitle,
    dgProfileOverview_OverviewLearningTitle: dgProfileOverview_OverviewLearningTitle,
    dgProfileOverview_OverviewNotProvidedTitle: dgProfileOverview_OverviewNotProvidedTitle,
    dgProfileOverview_OverviewSkillsTitle: dgProfileOverview_OverviewSkillsTitle,
    dgProfileOverview_RecentlyCompleted: dgProfileOverview_RecentlyCompleted,
    dgProfileOverview_RemoveSkill: dgProfileOverview_RemoveSkill,
    dgProfileOverview_RequiredCriticalSkills: dgProfileOverview_RequiredCriticalSkills,
    dgProfileOverview_RequiredSkills: dgProfileOverview_RequiredSkills,
    dgProfileOverview_RequiredSkillsDescription: dgProfileOverview_RequiredSkillsDescription,
    dgProfileOverview_SeeSkillCollection: dgProfileOverview_SeeSkillCollection,
    dgProfileOverview_SkillActionsAriaLabel: dgProfileOverview_SkillActionsAriaLabel,
    dgProfileOverview_SkillListView_Description: dgProfileOverview_SkillListView_Description,
    dgProfileOverview_SkillListView_Endorsed: dgProfileOverview_SkillListView_Endorsed,
    dgProfileOverview_SkillListView_OrgSkill: dgProfileOverview_SkillListView_OrgSkill,
    dgProfileOverview_SkillListView_SkillSignals: dgProfileOverview_SkillListView_SkillSignals,
    dgProfileOverview_SkillListView_Source: dgProfileOverview_SkillListView_Source,
    dgProfileOverview_SkillListView_SourceValue_Experience: dgProfileOverview_SkillListView_SourceValue_Experience,
    dgProfileOverview_SkillListView_SourceValue_Organization: dgProfileOverview_SkillListView_SourceValue_Organization,
    dgProfileOverview_SkillListView_SourceValue_Self: dgProfileOverview_SkillListView_SourceValue_Self,
    dgProfileOverview_SkillListView_TotalRatings: dgProfileOverview_SkillListView_TotalRatings,
    dgProfileOverview_SkillListView_Type: dgProfileOverview_SkillListView_Type,
    dgProfileOverview_SkillSignalDataTableLabel: dgProfileOverview_SkillSignalDataTableLabel,
    dgProfileOverview_SkillSignalsLabel: dgProfileOverview_SkillSignalsLabel,
    dgProfileOverview_SkillSignalsTitle: dgProfileOverview_SkillSignalsTitle,
    dgProfileOverview_SkillSuggestionsSubTitle: dgProfileOverview_SkillSuggestionsSubTitle,
    dgProfileOverview_SkillSuggestionsSubTitle_By_Org: dgProfileOverview_SkillSuggestionsSubTitle_By_Org,
    dgProfileOverview_SkillSuggestionsSubTitle_On_Role: dgProfileOverview_SkillSuggestionsSubTitle_On_Role,
    dgProfileOverview_SkillSuggestionsTitle: dgProfileOverview_SkillSuggestionsTitle,
    dgProfileOverview_StackedSkillRatingsAriaLabel: dgProfileOverview_StackedSkillRatingsAriaLabel,
    dgProfileOverview_TooltipSignalsPlural: dgProfileOverview_TooltipSignalsPlural,
    dgProfileOverview_TooltipSignalsSingle: dgProfileOverview_TooltipSignalsSingle,
    dgProfileOverview_TooltipSignalsZero: dgProfileOverview_TooltipSignalsZero,
    dgProfileOverview_ViewAllAchievements: dgProfileOverview_ViewAllAchievements,
    dgProfileOverview_ViewAllExperiences: dgProfileOverview_ViewAllExperiences,
    dgProfileOverview_ViewAllLearning: dgProfileOverview_ViewAllLearning,
    dgProfileOverview_ViewAllSkills: dgProfileOverview_ViewAllSkills,
    dgProfileOverview_ViewAward: dgProfileOverview_ViewAward,
    dgProfileOverview_ViewBadge: dgProfileOverview_ViewBadge,
    dgProfileOverview_ViewCertificate: dgProfileOverview_ViewCertificate,
    dgProfileOverview_ViewDegree: dgProfileOverview_ViewDegree,
    dgProfileShareActivity_DateShared: dgProfileShareActivity_DateShared,
    dgProfileShareActivity_GroupsSharedWith: dgProfileShareActivity_GroupsSharedWith,
    dgProfileShareActivity_NumCommentsPlural: dgProfileShareActivity_NumCommentsPlural,
    dgProfileShareActivity_NumCommentsSingular: dgProfileShareActivity_NumCommentsSingular,
    dgProfileShareActivity_NumGroupsSharedWithPlural: dgProfileShareActivity_NumGroupsSharedWithPlural,
    dgProfileShareActivity_NumGroupsSharedWithSingular: dgProfileShareActivity_NumGroupsSharedWithSingular,
    dgProfileShareActivity_NumPeopleSharedWithPlural: dgProfileShareActivity_NumPeopleSharedWithPlural,
    dgProfileShareActivity_NumPeopleSharedWithSingular: dgProfileShareActivity_NumPeopleSharedWithSingular,
    dgProfileShareActivity_PeopleSharedWith: dgProfileShareActivity_PeopleSharedWith,
    dgProfileShareActivity_ShareActivity: dgProfileShareActivity_ShareActivity,
    dgProviderLicense_CreateLicenseBtnFormat: dgProviderLicense_CreateLicenseBtnFormat,
    dgProviderLicense_GenerateLicenseFormat: dgProviderLicense_GenerateLicenseFormat,
    dgRatingButtonMeta_1Hour: dgRatingButtonMeta_1Hour,
    dgRatingButtonMeta_HoursFormat: dgRatingButtonMeta_HoursFormat,
    dgRecommendationsOverview_About: dgRecommendationsOverview_About,
    dgRecommendationsOverview_AboutConsumer: dgRecommendationsOverview_AboutConsumer,
    dgRecommendationsOverview_AlreadyCompletedAssignedByFormat: dgRecommendationsOverview_AlreadyCompletedAssignedByFormat,
    dgRecommendationsOverview_AlreadyCompletedAssignedYouFormat: dgRecommendationsOverview_AlreadyCompletedAssignedYouFormat,
    dgRecommendationsOverview_AlreadyCompletedRecommendedByFormat: dgRecommendationsOverview_AlreadyCompletedRecommendedByFormat,
    dgRecommendationsOverview_AlreadyCompletedRecommendedYouFormat: dgRecommendationsOverview_AlreadyCompletedRecommendedYouFormat,
    dgRecommendationsOverview_AssignedByFormat: dgRecommendationsOverview_AssignedByFormat,
    dgRecommendationsOverview_AssignedYouFormat: dgRecommendationsOverview_AssignedYouFormat,
    dgRecommendationsOverview_Description: dgRecommendationsOverview_Description,
    dgRecommendationsOverview_EmptyStateDescription: dgRecommendationsOverview_EmptyStateDescription,
    dgRecommendationsOverview_EmptyStateTitle: dgRecommendationsOverview_EmptyStateTitle,
    dgRecommendationsOverview_EmptyTitle: dgRecommendationsOverview_EmptyTitle,
    dgRecommendationsOverview_Filter: dgRecommendationsOverview_Filter,
    dgRecommendationsOverview_Incomplete: dgRecommendationsOverview_Incomplete,
    dgRecommendationsOverview_RecommendedByFormat: dgRecommendationsOverview_RecommendedByFormat,
    dgRecommendationsOverview_RecommendedByFormerLearnerFormat: dgRecommendationsOverview_RecommendedByFormerLearnerFormat,
    dgRecommendationsOverview_RecommendedByNoCreatorFormat: dgRecommendationsOverview_RecommendedByNoCreatorFormat,
    dgRecommendationsOverview_RecommendedYouFormat: dgRecommendationsOverview_RecommendedYouFormat,
    dgRecommendationsOverview_RecommendedYouFormerLearnerFormat: dgRecommendationsOverview_RecommendedYouFormerLearnerFormat,
    dgRecommendationsOverview_RecommendedYouNoCreatorFormat: dgRecommendationsOverview_RecommendedYouNoCreatorFormat,
    dgRecommendationsStatus_ByHeader: dgRecommendationsStatus_ByHeader,
    dgRecommendationsStatus_Empty: dgRecommendationsStatus_Empty,
    dgRecommendationsStatus_HeaderAssignedTo: dgRecommendationsStatus_HeaderAssignedTo,
    dgRecommendationsStatus_HeaderCreatedDate: dgRecommendationsStatus_HeaderCreatedDate,
    dgRecommendationsStatus_HeaderDueDate: dgRecommendationsStatus_HeaderDueDate,
    dgRecommendationsStatus_HeaderPercentComplete: dgRecommendationsStatus_HeaderPercentComplete,
    dgRecommendationsStatus_HeaderTitle: dgRecommendationsStatus_HeaderTitle,
    dgRelatedInputs_Related: dgRelatedInputs_Related,
    dgReorder_A11yItemMovedFormat: dgReorder_A11yItemMovedFormat,
    dgReorder_MoveNext: dgReorder_MoveNext,
    dgReorder_MovePrev: dgReorder_MovePrev,
    dgReorder_NoTitleText: dgReorder_NoTitleText,
    dgReorder_SaveChanges: dgReorder_SaveChanges,
    dgSkillsCheckup_DoneRating: dgSkillsCheckup_DoneRating,
    dgSkillsCheckup_message: dgSkillsCheckup_message,
    dgSkillsCheckup_UpdateRatings: dgSkillsCheckup_UpdateRatings,
    dgSkillSignal_BarChartSubheading: dgSkillSignal_BarChartSubheading,
    dgSkillSignal_OtherTypes: dgSkillSignal_OtherTypes,
    dgSkillSignalRatings_PrivacyInfo: dgSkillSignalRatings_PrivacyInfo,
    dgSkipNav_SkipMainNavigation: dgSkipNav_SkipMainNavigation,
    dgSkipNav_SkipSidebar: dgSkipNav_SkipSidebar,
    dgSkipNav_SkipSubNavigation: dgSkipNav_SkipSubNavigation,
    dgSkipNav_SkipToMainContent: dgSkipNav_SkipToMainContent,
    dgSkipNav_SkipToSearchResults: dgSkipNav_SkipToSearchResults,
    dgSocialConnectionJoined_TitleFormat: dgSocialConnectionJoined_TitleFormat,
    dgSocialConnectSuccess_TitleFormat: dgSocialConnectSuccess_TitleFormat,
    dgTagRating_A11yAddFocusSkill: dgTagRating_A11yAddFocusSkill,
    dgTagRating_A11yAddSelfRating: dgTagRating_A11yAddSelfRating,
    dgTagRating_A11yAddSkillReview: dgTagRating_A11yAddSkillReview,
    dgTagRating_A11yAddSkillTarget: dgTagRating_A11yAddSkillTarget,
    dgTagRating_A11yChangeSelfRating: dgTagRating_A11yChangeSelfRating,
    dgTagRating_A11yRemoveFocusSkill: dgTagRating_A11yRemoveFocusSkill,
    dgTagRating_A11yRequestManagerRating: dgTagRating_A11yRequestManagerRating,
    dgTagRating_A11yRequestPeerRating: dgTagRating_A11yRequestPeerRating,
    dgTagRating_A11yRequestUpdateManagerRating: dgTagRating_A11yRequestUpdateManagerRating,
    dgTagRating_A11yRequestUpdatePeerRating: dgTagRating_A11yRequestUpdatePeerRating,
    dgTagRating_A11ySelfRatingCount: dgTagRating_A11ySelfRatingCount,
    dgTagRating_A11ySkillOptions: dgTagRating_A11ySkillOptions,
    dgTagRating_A11ySkillReviewComplete: dgTagRating_A11ySkillReviewComplete,
    dgTagRating_A11ySkillReviewInProgress: dgTagRating_A11ySkillReviewInProgress,
    dgTagRating_A11ySkillSignalCounts: dgTagRating_A11ySkillSignalCounts,
    dgTagRating_A11ySkillTarget: dgTagRating_A11ySkillTarget,
    dgTagRating_A11yTotalRatingCounts: dgTagRating_A11yTotalRatingCounts,
    dgTagRating_AddA11y: dgTagRating_AddA11y,
    dgTagRating_AddCredential: dgTagRating_AddCredential,
    dgTagRating_Added: dgTagRating_Added,
    dgTagRating_AddedA11y: dgTagRating_AddedA11y,
    dgTagRating_AddedIntegrationSkillsProfileDetails: dgTagRating_AddedIntegrationSkillsProfileDetails,
    dgTagRating_AddEvalRating: dgTagRating_AddEvalRating,
    dgTagRating_AddEvaluation: dgTagRating_AddEvaluation,
    dgTagRating_AddExternalRatingDetail: dgTagRating_AddExternalRatingDetail,
    dgTagRating_AddFocusSkill: dgTagRating_AddFocusSkill,
    dgTagRating_AddFocusSkillItem: dgTagRating_AddFocusSkillItem,
    dgTagRating_AddingRatingsToPersonalize: dgTagRating_AddingRatingsToPersonalize,
    dgTagRating_AddManagerTarget: dgTagRating_AddManagerTarget,
    dgTagRating_AddRating: dgTagRating_AddRating,
    dgTagRating_AddRatingError: dgTagRating_AddRatingError,
    dgTagRating_AddSelfAssessment: dgTagRating_AddSelfAssessment,
    dgTagRating_AddSelfRating: dgTagRating_AddSelfRating,
    dgTagRating_AddSelfRatingDetail: dgTagRating_AddSelfRatingDetail,
    dgTagRating_AddSkillLevel: dgTagRating_AddSkillLevel,
    dgTagRating_AddSkills: dgTagRating_AddSkills,
    dgTagRating_AddSkillTarget: dgTagRating_AddSkillTarget,
    dgTagRating_AddToMySkills: dgTagRating_AddToMySkills,
    dgTagRating_AddToProfile: dgTagRating_AddToProfile,
    dgTagRating_AddToProfileTooltip: dgTagRating_AddToProfileTooltip,
    dgTagRating_Advanced: dgTagRating_Advanced,
    dgTagRating_AssessmentScore: dgTagRating_AssessmentScore,
    dgTagRating_Autonomy: dgTagRating_Autonomy,
    dgTagRating_Autonomy_Desc_Scale6_1: dgTagRating_Autonomy_Desc_Scale6_1,
    dgTagRating_Autonomy_Desc_Scale6_2: dgTagRating_Autonomy_Desc_Scale6_2,
    dgTagRating_Autonomy_Desc_Scale6_3: dgTagRating_Autonomy_Desc_Scale6_3,
    dgTagRating_Autonomy_Desc_Scale6_4: dgTagRating_Autonomy_Desc_Scale6_4,
    dgTagRating_Autonomy_Desc_Scale6_5: dgTagRating_Autonomy_Desc_Scale6_5,
    dgTagRating_Autonomy_Desc_Scale6_6: dgTagRating_Autonomy_Desc_Scale6_6,
    dgTagRating_Autonomy_Desc_Scale8_1: dgTagRating_Autonomy_Desc_Scale8_1,
    dgTagRating_Autonomy_Desc_Scale8_2: dgTagRating_Autonomy_Desc_Scale8_2,
    dgTagRating_Autonomy_Desc_Scale8_3: dgTagRating_Autonomy_Desc_Scale8_3,
    dgTagRating_Autonomy_Desc_Scale8_4: dgTagRating_Autonomy_Desc_Scale8_4,
    dgTagRating_Autonomy_Desc_Scale8_5: dgTagRating_Autonomy_Desc_Scale8_5,
    dgTagRating_Autonomy_Desc_Scale8_6: dgTagRating_Autonomy_Desc_Scale8_6,
    dgTagRating_Autonomy_Desc_Scale8_7: dgTagRating_Autonomy_Desc_Scale8_7,
    dgTagRating_Autonomy_Desc_Scale8_8: dgTagRating_Autonomy_Desc_Scale8_8,
    dgTagRating_AverageLevel: dgTagRating_AverageLevel,
    dgTagRating_Beginner: dgTagRating_Beginner,
    dgTagRating_CancelEval: dgTagRating_CancelEval,
    dgTagRating_CancelMgrRatingRequest: dgTagRating_CancelMgrRatingRequest,
    dgTagRating_CancelPeerRequests: dgTagRating_CancelPeerRequests,
    dgTagRating_CancelPeerRequestsDesc: dgTagRating_CancelPeerRequestsDesc,
    dgTagRating_CancelRequest: dgTagRating_CancelRequest,
    dgTagRating_Capable: dgTagRating_Capable,
    dgTagRating_CertVisibility: dgTagRating_CertVisibility,
    dgTagRating_ChangeManagerRating: dgTagRating_ChangeManagerRating,
    dgTagRating_ChangePeerRating: dgTagRating_ChangePeerRating,
    dgTagRating_ChangeSkillTarget: dgTagRating_ChangeSkillTarget,
    dgTagRating_Checkpoint: dgTagRating_Checkpoint,
    dgTagRating_Checkpoints: dgTagRating_Checkpoints,
    dgTagRating_ClearCurrentRating: dgTagRating_ClearCurrentRating,
    dgTagRating_ClearCurrentTarget: dgTagRating_ClearCurrentTarget,
    dgTagRating_CommentPlaceholderFormat: dgTagRating_CommentPlaceholderFormat,
    dgTagRating_Comments: dgTagRating_Comments,
    dgTagRating_commentVisible: dgTagRating_commentVisible,
    dgTagRating_CompleteCheckpoints: dgTagRating_CompleteCheckpoints,
    dgTagRating_ContinueEvaluation: dgTagRating_ContinueEvaluation,
    dgTagRating_ContinueProcess: dgTagRating_ContinueProcess,
    dgTagRating_Credential: dgTagRating_Credential,
    dgTagRating_Critical_RemoveFromProfileConfirmation: dgTagRating_Critical_RemoveFromProfileConfirmation,
    dgTagRating_CurrentManagerRating: dgTagRating_CurrentManagerRating,
    dgTagRating_CurrentPeerRating: dgTagRating_CurrentPeerRating,
    dgTagRating_CurrentSkillTarget: dgTagRating_CurrentSkillTarget,
    dgTagRating_DeactivatedUser: dgTagRating_DeactivatedUser,
    dgTagRating_DegreedCertification: dgTagRating_DegreedCertification,
    dgTagRating_DegreedCertified: dgTagRating_DegreedCertified,
    dgTagRating_DescribeRatingSelected: dgTagRating_DescribeRatingSelected,
    dgTagRating_descriptionPlaceholderManagerRating: dgTagRating_descriptionPlaceholderManagerRating,
    dgTagRating_descriptionPlaceholderPeerRating: dgTagRating_descriptionPlaceholderPeerRating,
    dgTagRating_descriptionPlaceholderSkillTarget: dgTagRating_descriptionPlaceholderSkillTarget,
    dgTagRating_Distinguished: dgTagRating_Distinguished,
    dgTagRating_DoneRating: dgTagRating_DoneRating,
    dgTagRating_EditExpertise: dgTagRating_EditExpertise,
    dgTagRating_EditExpertiseLabel: dgTagRating_EditExpertiseLabel,
    dgTagRating_Effective: dgTagRating_Effective,
    dgTagRating_EndorsedByFormat: dgTagRating_EndorsedByFormat,
    dgTagRating_Evaluation: dgTagRating_Evaluation,
    dgTagRating_EvalVisibility: dgTagRating_EvalVisibility,
    dgTagRating_Experienced: dgTagRating_Experienced,
    dgTagRating_Expert: dgTagRating_Expert,
    dgTagRating_FocusSkillAdded: dgTagRating_FocusSkillAdded,
    dgTagRating_FoundIntegrationSkillsProfileDetails: dgTagRating_FoundIntegrationSkillsProfileDetails,
    dgTagRating_GetCertificate: dgTagRating_GetCertificate,
    dgTagRating_Industry: dgTagRating_Industry,
    dgTagRating_Industry_Desc_Scale6_1: dgTagRating_Industry_Desc_Scale6_1,
    dgTagRating_Industry_Desc_Scale6_2: dgTagRating_Industry_Desc_Scale6_2,
    dgTagRating_Industry_Desc_Scale6_3: dgTagRating_Industry_Desc_Scale6_3,
    dgTagRating_Industry_Desc_Scale6_4: dgTagRating_Industry_Desc_Scale6_4,
    dgTagRating_Industry_Desc_Scale6_5: dgTagRating_Industry_Desc_Scale6_5,
    dgTagRating_Industry_Desc_Scale6_6: dgTagRating_Industry_Desc_Scale6_6,
    dgTagRating_Industry_Desc_Scale8_1: dgTagRating_Industry_Desc_Scale8_1,
    dgTagRating_Industry_Desc_Scale8_2: dgTagRating_Industry_Desc_Scale8_2,
    dgTagRating_Industry_Desc_Scale8_3: dgTagRating_Industry_Desc_Scale8_3,
    dgTagRating_Industry_Desc_Scale8_4: dgTagRating_Industry_Desc_Scale8_4,
    dgTagRating_Industry_Desc_Scale8_5: dgTagRating_Industry_Desc_Scale8_5,
    dgTagRating_Industry_Desc_Scale8_6: dgTagRating_Industry_Desc_Scale8_6,
    dgTagRating_Industry_Desc_Scale8_7: dgTagRating_Industry_Desc_Scale8_7,
    dgTagRating_Industry_Desc_Scale8_8: dgTagRating_Industry_Desc_Scale8_8,
    dgTagRating_InProgress: dgTagRating_InProgress,
    dgTagRating_Intermediate: dgTagRating_Intermediate,
    dgTagRating_InvalidRequest: dgTagRating_InvalidRequest,
    dgTagRating_Knowledge: dgTagRating_Knowledge,
    dgTagRating_Knowledge_Desc_Scale6_1: dgTagRating_Knowledge_Desc_Scale6_1,
    dgTagRating_Knowledge_Desc_Scale6_2: dgTagRating_Knowledge_Desc_Scale6_2,
    dgTagRating_Knowledge_Desc_Scale6_3: dgTagRating_Knowledge_Desc_Scale6_3,
    dgTagRating_Knowledge_Desc_Scale6_4: dgTagRating_Knowledge_Desc_Scale6_4,
    dgTagRating_Knowledge_Desc_Scale6_5: dgTagRating_Knowledge_Desc_Scale6_5,
    dgTagRating_Knowledge_Desc_Scale6_6: dgTagRating_Knowledge_Desc_Scale6_6,
    dgTagRating_Knowledge_Desc_Scale8_1: dgTagRating_Knowledge_Desc_Scale8_1,
    dgTagRating_Knowledge_Desc_Scale8_2: dgTagRating_Knowledge_Desc_Scale8_2,
    dgTagRating_Knowledge_Desc_Scale8_3: dgTagRating_Knowledge_Desc_Scale8_3,
    dgTagRating_Knowledge_Desc_Scale8_4: dgTagRating_Knowledge_Desc_Scale8_4,
    dgTagRating_Knowledge_Desc_Scale8_5: dgTagRating_Knowledge_Desc_Scale8_5,
    dgTagRating_Knowledge_Desc_Scale8_6: dgTagRating_Knowledge_Desc_Scale8_6,
    dgTagRating_Knowledge_Desc_Scale8_7: dgTagRating_Knowledge_Desc_Scale8_7,
    dgTagRating_Knowledge_Desc_Scale8_8: dgTagRating_Knowledge_Desc_Scale8_8,
    dgTagRating_LastRated: dgTagRating_LastRated,
    dgTagRating_Level: dgTagRating_Level,
    dgTagRating_LevelDescription: dgTagRating_LevelDescription,
    dgTagRating_Levels: dgTagRating_Levels,
    dgTagRating_LevelUp: dgTagRating_LevelUp,
    dgTagRating_LevelUp_Desc_Scale6_1: dgTagRating_LevelUp_Desc_Scale6_1,
    dgTagRating_LevelUp_Desc_Scale6_2: dgTagRating_LevelUp_Desc_Scale6_2,
    dgTagRating_LevelUp_Desc_Scale6_3: dgTagRating_LevelUp_Desc_Scale6_3,
    dgTagRating_LevelUp_Desc_Scale6_4: dgTagRating_LevelUp_Desc_Scale6_4,
    dgTagRating_LevelUp_Desc_Scale6_5: dgTagRating_LevelUp_Desc_Scale6_5,
    dgTagRating_LevelUp_Desc_Scale6_6: dgTagRating_LevelUp_Desc_Scale6_6,
    dgTagRating_LevelUp_Desc_Scale8_1: dgTagRating_LevelUp_Desc_Scale8_1,
    dgTagRating_LevelUp_Desc_Scale8_2: dgTagRating_LevelUp_Desc_Scale8_2,
    dgTagRating_LevelUp_Desc_Scale8_3: dgTagRating_LevelUp_Desc_Scale8_3,
    dgTagRating_LevelUp_Desc_Scale8_4: dgTagRating_LevelUp_Desc_Scale8_4,
    dgTagRating_LevelUp_Desc_Scale8_5: dgTagRating_LevelUp_Desc_Scale8_5,
    dgTagRating_LevelUp_Desc_Scale8_6: dgTagRating_LevelUp_Desc_Scale8_6,
    dgTagRating_LevelUp_Desc_Scale8_7: dgTagRating_LevelUp_Desc_Scale8_7,
    dgTagRating_LevelUp_Desc_Scale8_8: dgTagRating_LevelUp_Desc_Scale8_8,
    dgTagRating_LinkedSkillsNumber: dgTagRating_LinkedSkillsNumber,
    dgTagRating_ManagerAssessment: dgTagRating_ManagerAssessment,
    dgTagRating_ManagerRating: dgTagRating_ManagerRating,
    dgTagRating_ManagerRatinginProgress: dgTagRating_ManagerRatinginProgress,
    dgTagRating_Master: dgTagRating_Master,
    dgTagRating_MeasureYourSkill: dgTagRating_MeasureYourSkill,
    dgTagRating_MngrRatingRequestCancelled: dgTagRating_MngrRatingRequestCancelled,
    dgTagRating_ModalButtonAddWithoutRating: dgTagRating_ModalButtonAddWithoutRating,
    dgTagRating_ModalButtonAddWithRating: dgTagRating_ModalButtonAddWithRating,
    dgTagRating_MyRatings: dgTagRating_MyRatings,
    dgTagRating_NewManagerRating: dgTagRating_NewManagerRating,
    dgTagRating_NewPeerRating: dgTagRating_NewPeerRating,
    dgTagRating_NewSkillTarget: dgTagRating_NewSkillTarget,
    dgTagRating_NoRatings: dgTagRating_NoRatings,
    dgTagRating_NoSkillTarget: dgTagRating_NoSkillTarget,
    dgTagRating_NoTargetLevelAssigned: dgTagRating_NoTargetLevelAssigned,
    dgTagRating_NumberOfRatings: dgTagRating_NumberOfRatings,
    dgTagRating_OtherRatings: dgTagRating_OtherRatings,
    dgTagRating_PeerRating: dgTagRating_PeerRating,
    dgTagRating_PeerRatingRequestCancelled: dgTagRating_PeerRatingRequestCancelled,
    dgTagRating_PeerRatings: dgTagRating_PeerRatings,
    dgTagRating_PeerRatingsTitle: dgTagRating_PeerRatingsTitle,
    dgTagRating_PeerRequestCountWarning: dgTagRating_PeerRequestCountWarning,
    dgTagRating_PendingSelfRatingRequest: dgTagRating_PendingSelfRatingRequest,
    dgTagRating_PrivacyPopoverDesc: dgTagRating_PrivacyPopoverDesc,
    dgTagRating_PrivacyPopoverTitle: dgTagRating_PrivacyPopoverTitle,
    dgTagRating_PrivateToYou: dgTagRating_PrivateToYou,
    dgTagRating_ProviderLogo: dgTagRating_ProviderLogo,
    dgTagRating_ProviderSkillLabel: dgTagRating_ProviderSkillLabel,
    dgTagRating_RatedByFormat: dgTagRating_RatedByFormat,
    dgTagRating_RateNewSkills: dgTagRating_RateNewSkills,
    dgTagRating_RateSkills: dgTagRating_RateSkills,
    dgTagRating_Rating: dgTagRating_Rating,
    dgTagRating_RatingInProgress: dgTagRating_RatingInProgress,
    dgTagRating_RatingNotValid: dgTagRating_RatingNotValid,
    dgTagRating_RatingNotValidNewRating: dgTagRating_RatingNotValidNewRating,
    dgTagRating_RatingOtherTitleFormat: dgTagRating_RatingOtherTitleFormat,
    dgTagRating_RatingPendingFormat: dgTagRating_RatingPendingFormat,
    dgTagRating_RatingRequestCancelled: dgTagRating_RatingRequestCancelled,
    dgTagRating_RatingRequested: dgTagRating_RatingRequested,
    dgTagRating_RatingRequestedAge: dgTagRating_RatingRequestedAge,
    dgTagRating_RatingsRequested: dgTagRating_RatingsRequested,
    dgTagRating_RatingTitleFormat: dgTagRating_RatingTitleFormat,
    dgTagRating_RatingType: dgTagRating_RatingType,
    dgTagRating_RecommendSkill: dgTagRating_RecommendSkill,
    dgTagRating_RemoveA11y: dgTagRating_RemoveA11y,
    dgTagRating_RemoveA11ySkill: dgTagRating_RemoveA11ySkill,
    dgTagRating_RemoveFocusSkill: dgTagRating_RemoveFocusSkill,
    dgTagRating_RemoveFocusSkillItem: dgTagRating_RemoveFocusSkillItem,
    dgTagRating_RemoveFromPlan: dgTagRating_RemoveFromPlan,
    dgTagRating_RemoveFromPlanA11y: dgTagRating_RemoveFromPlanA11y,
    dgTagRating_RemoveFromProfile: dgTagRating_RemoveFromProfile,
    dgTagRating_RemoveFromProfileConfirmation: dgTagRating_RemoveFromProfileConfirmation,
    dgTagRating_RemoveFromProfileTooltip: dgTagRating_RemoveFromProfileTooltip,
    dgTagRating_RequestedRatings: dgTagRating_RequestedRatings,
    dgTagRating_RequestManagerAssessment: dgTagRating_RequestManagerAssessment,
    dgTagRating_RequestManagerRating: dgTagRating_RequestManagerRating,
    dgTagRating_RequestManagerRatingInstruction: dgTagRating_RequestManagerRatingInstruction,
    dgTagRating_RequestNewRating: dgTagRating_RequestNewRating,
    dgTagRating_RequestNotValid: dgTagRating_RequestNotValid,
    dgTagRating_RequestPeerRating: dgTagRating_RequestPeerRating,
    dgTagRating_RequestPeerRatingInstruction: dgTagRating_RequestPeerRatingInstruction,
    dgTagRating_RequestRating: dgTagRating_RequestRating,
    dgTagRating_RequestSelfNotificationFormat: dgTagRating_RequestSelfNotificationFormat,
    dgTagRating_RequestSelfRatingForFormat: dgTagRating_RequestSelfRatingForFormat,
    dgTagRating_RequestsPending: dgTagRating_RequestsPending,
    dgTagRating_RestartEval: dgTagRating_RestartEval,
    dgTagRating_ReviewSkillsNewRatings: dgTagRating_ReviewSkillsNewRatings,
    dgTagRating_saveNewRating: dgTagRating_saveNewRating,
    dgTagRating_saveNewTarget: dgTagRating_saveNewTarget,
    dgTagRating_SearchCollection: dgTagRating_SearchCollection,
    dgTagRating_SelectManager: dgTagRating_SelectManager,
    dgTagRating_SelectRating: dgTagRating_SelectRating,
    dgTagRating_SelfAssessment: dgTagRating_SelfAssessment,
    dgTagRating_SelfAssessmentItem: dgTagRating_SelfAssessmentItem,
    dgTagRating_SelfRatingRequestCancelled: dgTagRating_SelfRatingRequestCancelled,
    dgTagRating_SelfRatingRequested: dgTagRating_SelfRatingRequested,
    dgTagRating_SelfRatingUpdated: dgTagRating_SelfRatingUpdated,
    dgTagRating_ShareTag: dgTagRating_ShareTag,
    dgTagRating_SignalCountPlural: dgTagRating_SignalCountPlural,
    dgTagRating_SignalCountSingle: dgTagRating_SignalCountSingle,
    dgTagRating_SkillCertification: dgTagRating_SkillCertification,
    dgTagRating_SkillCertInProgress: dgTagRating_SkillCertInProgress,
    dgTagRating_SkillReviewInProgress: dgTagRating_SkillReviewInProgress,
    dgTagRating_StartCredential: dgTagRating_StartCredential,
    dgTagRating_StartEvaluation: dgTagRating_StartEvaluation,
    dgTagRating_SubmitNext: dgTagRating_SubmitNext,
    dgTagRating_SuccessfullyAddedSkills: dgTagRating_SuccessfullyAddedSkills,
    dgTagRating_SummaryLevel1: dgTagRating_SummaryLevel1,
    dgTagRating_SummaryLevel2: dgTagRating_SummaryLevel2,
    dgTagRating_SummaryLevel3: dgTagRating_SummaryLevel3,
    dgTagRating_SummaryLevel4: dgTagRating_SummaryLevel4,
    dgTagRating_SummaryLevel5: dgTagRating_SummaryLevel5,
    dgTagRating_SummaryLevel6: dgTagRating_SummaryLevel6,
    dgTagRating_SummaryLevel7: dgTagRating_SummaryLevel7,
    dgTagRating_SummaryLevel8: dgTagRating_SummaryLevel8,
    dgTagRating_SummaryScale6_Level1: dgTagRating_SummaryScale6_Level1,
    dgTagRating_SummaryScale6_Level2: dgTagRating_SummaryScale6_Level2,
    dgTagRating_SummaryScale6_Level3: dgTagRating_SummaryScale6_Level3,
    dgTagRating_SummaryScale6_Level4: dgTagRating_SummaryScale6_Level4,
    dgTagRating_SummaryScale6_Level5: dgTagRating_SummaryScale6_Level5,
    dgTagRating_SummaryScale6_Level6: dgTagRating_SummaryScale6_Level6,
    dgTagRating_SummaryScale8_Level1: dgTagRating_SummaryScale8_Level1,
    dgTagRating_SummaryScale8_Level2: dgTagRating_SummaryScale8_Level2,
    dgTagRating_SummaryScale8_Level3: dgTagRating_SummaryScale8_Level3,
    dgTagRating_SummaryScale8_Level4: dgTagRating_SummaryScale8_Level4,
    dgTagRating_SummaryScale8_Level5: dgTagRating_SummaryScale8_Level5,
    dgTagRating_SummaryScale8_Level6: dgTagRating_SummaryScale8_Level6,
    dgTagRating_SummaryScale8_Level7: dgTagRating_SummaryScale8_Level7,
    dgTagRating_SummaryScale8_Level8: dgTagRating_SummaryScale8_Level8,
    dgTagRating_TakeCheckpoint: dgTagRating_TakeCheckpoint,
    dgTagRating_TargetCommentPlaceholderFormat: dgTagRating_TargetCommentPlaceholderFormat,
    dgTagRating_TargetLevel: dgTagRating_TargetLevel,
    dgTagRating_TargetRatingUpdated: dgTagRating_TargetRatingUpdated,
    dgTagRating_TasksTools: dgTagRating_TasksTools,
    dgTagRating_TasksTools_Desc_Scale6_1: dgTagRating_TasksTools_Desc_Scale6_1,
    dgTagRating_TasksTools_Desc_Scale6_2: dgTagRating_TasksTools_Desc_Scale6_2,
    dgTagRating_TasksTools_Desc_Scale6_3: dgTagRating_TasksTools_Desc_Scale6_3,
    dgTagRating_TasksTools_Desc_Scale6_4: dgTagRating_TasksTools_Desc_Scale6_4,
    dgTagRating_TasksTools_Desc_Scale6_5: dgTagRating_TasksTools_Desc_Scale6_5,
    dgTagRating_TasksTools_Desc_Scale6_6: dgTagRating_TasksTools_Desc_Scale6_6,
    dgTagRating_TasksTools_Desc_Scale8_1: dgTagRating_TasksTools_Desc_Scale8_1,
    dgTagRating_TasksTools_Desc_Scale8_2: dgTagRating_TasksTools_Desc_Scale8_2,
    dgTagRating_TasksTools_Desc_Scale8_3: dgTagRating_TasksTools_Desc_Scale8_3,
    dgTagRating_TasksTools_Desc_Scale8_4: dgTagRating_TasksTools_Desc_Scale8_4,
    dgTagRating_TasksTools_Desc_Scale8_5: dgTagRating_TasksTools_Desc_Scale8_5,
    dgTagRating_TasksTools_Desc_Scale8_6: dgTagRating_TasksTools_Desc_Scale8_6,
    dgTagRating_TasksTools_Desc_Scale8_7: dgTagRating_TasksTools_Desc_Scale8_7,
    dgTagRating_TasksTools_Desc_Scale8_8: dgTagRating_TasksTools_Desc_Scale8_8,
    dgTagRating_TotalRatings: dgTagRating_TotalRatings,
    dgTagRating_Unrated: dgTagRating_Unrated,
    dgTagRating_UnratedDescription: dgTagRating_UnratedDescription,
    dgTagRating_UnratedPeerRatingDescription: dgTagRating_UnratedPeerRatingDescription,
    dgTagRating_UnratedSkillTargetDescription: dgTagRating_UnratedSkillTargetDescription,
    dgTagRating_UpdatedManagerRating: dgTagRating_UpdatedManagerRating,
    dgTagRating_UpdatedNewRating: dgTagRating_UpdatedNewRating,
    dgTagRating_UpdatedPeerRating: dgTagRating_UpdatedPeerRating,
    dgTagRating_UpdatedSkillTarget: dgTagRating_UpdatedSkillTarget,
    dgTagRating_UpdateRating: dgTagRating_UpdateRating,
    dgTagRating_ViewCertificate: dgTagRating_ViewCertificate,
    dgTagRating_ViewCheckpoints: dgTagRating_ViewCheckpoints,
    dgTagRating_ViewExternalRating: dgTagRating_ViewExternalRating,
    dgTagRating_ViewLevelBreakdown: dgTagRating_ViewLevelBreakdown,
    dgTagRating_ViewLevelDescription: dgTagRating_ViewLevelDescription,
    dgTagRating_ViewNewRatingScale: dgTagRating_ViewNewRatingScale,
    dgTagRating_ViewRating: dgTagRating_ViewRating,
    dgTagRating_ViewRatingLabel: dgTagRating_ViewRatingLabel,
    dgTagRating_ViewRatings: dgTagRating_ViewRatings,
    dgTagRating_ViewRatingScale: dgTagRating_ViewRatingScale,
    dgTagRating_ViewScoreBreakdown: dgTagRating_ViewScoreBreakdown,
    dgTagRating_ViewSkill: dgTagRating_ViewSkill,
    dgTagRating_VisibleToOrg: dgTagRating_VisibleToOrg,
    dgTagRating_VisibleToPublic: dgTagRating_VisibleToPublic,
    dgTagRating_VisibleToYou: dgTagRating_VisibleToYou,
    dgTagRating_YourCurrentRating: dgTagRating_YourCurrentRating,
    dgTagsEdit_AddTagFormat: dgTagsEdit_AddTagFormat,
    dgTagsEdit_PlusAdd: dgTagsEdit_PlusAdd,
    dgTagsEdit_RemoveTagFormat: dgTagsEdit_RemoveTagFormat,
    dgTagsEdit_View_More_Button: dgTagsEdit_View_More_Button,
    dgTagsEdit_WhatDidYouLearn: dgTagsEdit_WhatDidYouLearn,
    dgTagsEdit_WhoopsFormat: dgTagsEdit_WhoopsFormat,
    dgTagsList_PlusCountMore: dgTagsList_PlusCountMore,
    dgTagsList_RemoveWorkdaySkillInfo: dgTagsList_RemoveWorkdaySkillInfo,
    dgTagsList_RemoveWorkdaySkillTitle: dgTagsList_RemoveWorkdaySkillTitle,
    dgTagsList_VisitWorkday: dgTagsList_VisitWorkday,
    dgTargetTile_PrimaryPlan: dgTargetTile_PrimaryPlan,
    dgTargetTile_SkillFormat: dgTargetTile_SkillFormat,
    dgTargetTile_SkillsFormat: dgTargetTile_SkillsFormat,
    dgTargetTile_UnfollowConfirm: dgTargetTile_UnfollowConfirm,
    dgTargetTile_UnfollowExplanation: dgTargetTile_UnfollowExplanation,
    dgThSort_SortAscendingFormat: dgThSort_SortAscendingFormat,
    dgThSort_SortDescendingFormat: dgThSort_SortDescendingFormat,
    dgThSort_SortedAscendingFormat: dgThSort_SortedAscendingFormat,
    dgThSort_SortedDescendingFormat: dgThSort_SortedDescendingFormat,
    dgThumbs_Dislike: dgThumbs_Dislike,
    dgThumbs_Like: dgThumbs_Like,
    dgThumbs_NotDisliked: dgThumbs_NotDisliked,
    dgThumbs_RemoveDislike: dgThumbs_RemoveDislike,
    dgThumbs_RemoveLike: dgThumbs_RemoveLike,
    dgThumbs_Undislike: dgThumbs_Undislike,
    dgTopGroups_AdministrativeGroup: dgTopGroups_AdministrativeGroup,
    dgTopGroups_ClosedGroup: dgTopGroups_ClosedGroup,
    dgTopGroups_Empty: dgTopGroups_Empty,
    dgTopGroups_LinkToGroups: dgTopGroups_LinkToGroups,
    dgTopGroups_PrivateGroup: dgTopGroups_PrivateGroup,
    dgTrackableLink_Trackable: dgTrackableLink_Trackable,
    dgUserDeleteProfile_DeletedProfileConfirmed: dgUserDeleteProfile_DeletedProfileConfirmed,
    dgUserDeleteProfile_DeleteProfileConfirmation: dgUserDeleteProfile_DeleteProfileConfirmation,
    dgUserDeleteProfile_No: dgUserDeleteProfile_No,
    dgUserDeleteProfile_Yes: dgUserDeleteProfile_Yes,
    dgUserEvaluationEndorsement_approved: dgUserEvaluationEndorsement_approved,
    dgUserEvaluationEndorsement_complete_endorsementRequested: dgUserEvaluationEndorsement_complete_endorsementRequested,
    dgUserEvaluationEndorsement_endorsementCompleted: dgUserEvaluationEndorsement_endorsementCompleted,
    dgUserEvaluationEndorsement_endorsementRequested: dgUserEvaluationEndorsement_endorsementRequested,
    dgUserEvaluationEndorsement_endorsementRequestedChanges: dgUserEvaluationEndorsement_endorsementRequestedChanges,
    dgUserEvaluationEndorsement_endosed: dgUserEvaluationEndorsement_endosed,
    dgUserEvaluationEndorsement_goToApplication: dgUserEvaluationEndorsement_goToApplication,
    dgUserEvaluationEndorsement_requestedChanges: dgUserEvaluationEndorsement_requestedChanges,
    dgUserGoalItem_ViewGroup: dgUserGoalItem_ViewGroup,
    dgUserInfo_LinkCopied: dgUserInfo_LinkCopied,
    dgUserOrganizationPicker_Everyone: dgUserOrganizationPicker_Everyone,
    dgUserOrganizationPicker_Loading: dgUserOrganizationPicker_Loading,
    dgUserOrganizationPicker_OnlyMe: dgUserOrganizationPicker_OnlyMe,
    dgUserOutcomeEditForm_AccomplishmentDate: dgUserOutcomeEditForm_AccomplishmentDate,
    dgUserOutcomeEditForm_AchievedDate: dgUserOutcomeEditForm_AchievedDate,
    dgUserOutcomeEditForm_ActiveCert: dgUserOutcomeEditForm_ActiveCert,
    dgUserOutcomeEditForm_AddAccomplishment: dgUserOutcomeEditForm_AddAccomplishment,
    dgUserOutcomeEditForm_AddADegree: dgUserOutcomeEditForm_AddADegree,
    dgUserOutcomeEditForm_AddAward: dgUserOutcomeEditForm_AddAward,
    dgUserOutcomeEditForm_AddBadge: dgUserOutcomeEditForm_AddBadge,
    dgUserOutcomeEditForm_AddBadgeUrl: dgUserOutcomeEditForm_AddBadgeUrl,
    dgUserOutcomeEditForm_AddCertificate: dgUserOutcomeEditForm_AddCertificate,
    dgUserOutcomeEditForm_AddDegree: dgUserOutcomeEditForm_AddDegree,
    dgUserOutcomeEditForm_AdditionalSkillInfo: dgUserOutcomeEditForm_AdditionalSkillInfo,
    dgUserOutcomeEditForm_AddSkill: dgUserOutcomeEditForm_AddSkill,
    dgUserOutcomeEditForm_AwardedDate: dgUserOutcomeEditForm_AwardedDate,
    dgUserOutcomeEditForm_BadgeIssuer: dgUserOutcomeEditForm_BadgeIssuer,
    dgUserOutcomeEditForm_BadgeName: dgUserOutcomeEditForm_BadgeName,
    dgUserOutcomeEditForm_BadgeProvider: dgUserOutcomeEditForm_BadgeProvider,
    dgUserOutcomeEditForm_BadgeUrlJson: dgUserOutcomeEditForm_BadgeUrlJson,
    dgUserOutcomeEditForm_CategoryAwardsDescription: dgUserOutcomeEditForm_CategoryAwardsDescription,
    dgUserOutcomeEditForm_CategoryDescription: dgUserOutcomeEditForm_CategoryDescription,
    dgUserOutcomeEditForm_CertificateGrouping: dgUserOutcomeEditForm_CertificateGrouping,
    dgUserOutcomeEditForm_CertNumber: dgUserOutcomeEditForm_CertNumber,
    dgUserOutcomeEditForm_CollegeUniversity: dgUserOutcomeEditForm_CollegeUniversity,
    dgUserOutcomeEditForm_ConceptualizeSkillFormat: dgUserOutcomeEditForm_ConceptualizeSkillFormat,
    dgUserOutcomeEditForm_Country: dgUserOutcomeEditForm_Country,
    dgUserOutcomeEditForm_DateCompleted: dgUserOutcomeEditForm_DateCompleted,
    dgUserOutcomeEditForm_DateGraduated: dgUserOutcomeEditForm_DateGraduated,
    dgUserOutcomeEditForm_DegreeGrouping: dgUserOutcomeEditForm_DegreeGrouping,
    dgUserOutcomeEditForm_DegreeLevel: dgUserOutcomeEditForm_DegreeLevel,
    dgUserOutcomeEditForm_DegreeLevelExample: dgUserOutcomeEditForm_DegreeLevelExample,
    dgUserOutcomeEditForm_DegreeTitleExample: dgUserOutcomeEditForm_DegreeTitleExample,
    dgUserOutcomeEditForm_DescribeAccomplishment: dgUserOutcomeEditForm_DescribeAccomplishment,
    dgUserOutcomeEditForm_DescribeSkill: dgUserOutcomeEditForm_DescribeSkill,
    dgUserOutcomeEditForm_DescribeUseOfSkill: dgUserOutcomeEditForm_DescribeUseOfSkill,
    dgUserOutcomeEditForm_DescribeWhyUseOfSkill: dgUserOutcomeEditForm_DescribeWhyUseOfSkill,
    dgUserOutcomeEditForm_DoesCertExpire: dgUserOutcomeEditForm_DoesCertExpire,
    dgUserOutcomeEditForm_EditAccomplishment: dgUserOutcomeEditForm_EditAccomplishment,
    dgUserOutcomeEditForm_EditAward: dgUserOutcomeEditForm_EditAward,
    dgUserOutcomeEditForm_EditBadge: dgUserOutcomeEditForm_EditBadge,
    dgUserOutcomeEditForm_EditCertificate: dgUserOutcomeEditForm_EditCertificate,
    dgUserOutcomeEditForm_EditDegree: dgUserOutcomeEditForm_EditDegree,
    dgUserOutcomeEditForm_EndDate: dgUserOutcomeEditForm_EndDate,
    dgUserOutcomeEditForm_ExpandedClientBase: dgUserOutcomeEditForm_ExpandedClientBase,
    dgUserOutcomeEditForm_Expiration: dgUserOutcomeEditForm_Expiration,
    dgUserOutcomeEditForm_FieldOfStudy: dgUserOutcomeEditForm_FieldOfStudy,
    dgUserOutcomeEditForm_FormatDescription: dgUserOutcomeEditForm_FormatDescription,
    dgUserOutcomeEditForm_GPA: dgUserOutcomeEditForm_GPA,
    dgUserOutcomeEditForm_GPAExample: dgUserOutcomeEditForm_GPAExample,
    dgUserOutcomeEditForm_HeldSkill: dgUserOutcomeEditForm_HeldSkill,
    dgUserOutcomeEditForm_IncludeTypicalCourses: dgUserOutcomeEditForm_IncludeTypicalCourses,
    dgUserOutcomeEditForm_IssuedBy: dgUserOutcomeEditForm_IssuedBy,
    dgUserOutcomeEditForm_IssuerUrl: dgUserOutcomeEditForm_IssuerUrl,
    dgUserOutcomeEditForm_MozillaBadge: dgUserOutcomeEditForm_MozillaBadge,
    dgUserOutcomeEditForm_OpenBadgeLabelFormat: dgUserOutcomeEditForm_OpenBadgeLabelFormat,
    dgUserOutcomeEditForm_OrganizedCharity: dgUserOutcomeEditForm_OrganizedCharity,
    dgUserOutcomeEditForm_OutsideUS: dgUserOutcomeEditForm_OutsideUS,
    dgUserOutcomeEditForm_QuantitativeDescriptions: dgUserOutcomeEditForm_QuantitativeDescriptions,
    dgUserOutcomeEditForm_RateProficiency: dgUserOutcomeEditForm_RateProficiency,
    dgUserOutcomeEditForm_SaveBadge: dgUserOutcomeEditForm_SaveBadge,
    dgUserOutcomeEditForm_SaveDegree: dgUserOutcomeEditForm_SaveDegree,
    dgUserOutcomeEditForm_SaveToProfile: dgUserOutcomeEditForm_SaveToProfile,
    dgUserOutcomeEditForm_SelectCategories: dgUserOutcomeEditForm_SelectCategories,
    dgUserOutcomeEditForm_SelectField: dgUserOutcomeEditForm_SelectField,
    dgUserOutcomeEditForm_SkilGrouping: dgUserOutcomeEditForm_SkilGrouping,
    dgUserOutcomeEditForm_SkillCandidateAbbrFormat: dgUserOutcomeEditForm_SkillCandidateAbbrFormat,
    dgUserOutcomeEditForm_SkillEvidence: dgUserOutcomeEditForm_SkillEvidence,
    dgUserOutcomeEditForm_SkillEvidenceAbbrFormat: dgUserOutcomeEditForm_SkillEvidenceAbbrFormat,
    dgUserOutcomeEditForm_SkillGrouping: dgUserOutcomeEditForm_SkillGrouping,
    dgUserOutcomeEditForm_SkillHistory: dgUserOutcomeEditForm_SkillHistory,
    dgUserOutcomeEditForm_SkillInstance: dgUserOutcomeEditForm_SkillInstance,
    dgUserOutcomeEditForm_SkillUse: dgUserOutcomeEditForm_SkillUse,
    dgUserOutcomeEditForm_SkillUseDetail: dgUserOutcomeEditForm_SkillUseDetail,
    dgUserOutcomeEditForm_SkillUseDetails: dgUserOutcomeEditForm_SkillUseDetails,
    dgUserOutcomeEditForm_StartDate: dgUserOutcomeEditForm_StartDate,
    dgUserOutcomeEditForm_TitleOfAward: dgUserOutcomeEditForm_TitleOfAward,
    dgUserOutcomeEditForm_TitleOfCertificate: dgUserOutcomeEditForm_TitleOfCertificate,
    dgUserOutcomeEditForm_TitleOfDegree: dgUserOutcomeEditForm_TitleOfDegree,
    dgUserOutcomeEditForm_UniversityCountry: dgUserOutcomeEditForm_UniversityCountry,
    dgUserOutcomeEditForm_UniversityName: dgUserOutcomeEditForm_UniversityName,
    dgUserOutcomeEditForm_UploadAnImage: dgUserOutcomeEditForm_UploadAnImage,
    dgUserOutcomeEditForm_UploadBadge: dgUserOutcomeEditForm_UploadBadge,
    dgUserOutcomeEditForm_UploadDegreeImage: dgUserOutcomeEditForm_UploadDegreeImage,
    dgUserOutcomeEditForm_UploadImageOfCertificate: dgUserOutcomeEditForm_UploadImageOfCertificate,
    dgUserOutcomeEditForm_WhatDidYouDo: dgUserOutcomeEditForm_WhatDidYouDo,
    dgUserOutcomeEditForm_WhatTimeSpan: dgUserOutcomeEditForm_WhatTimeSpan,
    dgUserOutcomeEditForm_WhenDidYouReceiveAward: dgUserOutcomeEditForm_WhenDidYouReceiveAward,
    dgUserOutcomeItem_AdditionalInfo: dgUserOutcomeItem_AdditionalInfo,
    dgUserOutcomeItem_AwardIssuer: dgUserOutcomeItem_AwardIssuer,
    dgUserOutcomeItem_ContentTypeOverview: dgUserOutcomeItem_ContentTypeOverview,
    dgUserOutcomeItem_DidntSpecify: dgUserOutcomeItem_DidntSpecify,
    dgUserOutcomeItem_EarningCertificate: dgUserOutcomeItem_EarningCertificate,
    dgUserOutcomeItem_HowEarned: dgUserOutcomeItem_HowEarned,
    dgUserOutcomeItem_HowWasAchieved: dgUserOutcomeItem_HowWasAchieved,
    dgUserOutcomeItem_SelectivityAward: dgUserOutcomeItem_SelectivityAward,
    dgUserOutcomeItem_SelectivityCertificate: dgUserOutcomeItem_SelectivityCertificate,
    dgUserOutcomeItem_SkillCandidate: dgUserOutcomeItem_SkillCandidate,
    dgUserOutcomeItem_WhenWasApplied: dgUserOutcomeItem_WhenWasApplied,
    dgUserOutcomeItem_WhoElseContributed: dgUserOutcomeItem_WhoElseContributed,
    dgUserOutcomeItem_WhyUseCandidate: dgUserOutcomeItem_WhyUseCandidate,
    dgUserOverview_Channel: dgUserOverview_Channel,
    dgUserOverview_ConnectFlexedCard: dgUserOverview_ConnectFlexedCard,
    dgUserOverview_FlexEd: dgUserOverview_FlexEd,
    dgUserOverview_Logout: dgUserOverview_Logout,
    dgUserOverview_Points: dgUserOverview_Points,
    dgUserOverview_Profile: dgUserOverview_Profile,
    dgUserOverview_Settings: dgUserOverview_Settings,
    dgUserOverview_SkillCertification: dgUserOverview_SkillCertification,
    dgUserOverview_SkillReview: dgUserOverview_SkillReview,
    dgUserOverview_SwitchOrganization: dgUserOverview_SwitchOrganization,
    dgUserProfile_BecomeMentorSearchTitle: dgUserProfile_BecomeMentorSearchTitle,
    dgUserProfile_BecomeMentorSelectTitle: dgUserProfile_BecomeMentorSelectTitle,
    dgUserProfile_BecomeMentorTitle: dgUserProfile_BecomeMentorTitle,
    dgUserProfile_IntegrationAssigned: dgUserProfile_IntegrationAssigned,
    dgUserProfile_OppTypesInterestedTitle: dgUserProfile_OppTypesInterestedTitle,
    dgUserProfile_OppTypesSelectTitle: dgUserProfile_OppTypesSelectTitle,
    dgUserProfile_OppTypesTitle: dgUserProfile_OppTypesTitle,
    dgUserProfile_OptInLabel: dgUserProfile_OptInLabel,
    dgUserProfile_PersonalInformationLabel: dgUserProfile_PersonalInformationLabel,
    dgUserProfile_PictureLabel: dgUserProfile_PictureLabel,
    dgUserProfile_PrivacyLockedMessage: dgUserProfile_PrivacyLockedMessage,
    dgUserProfile_PrivacyVisibilityLabel: dgUserProfile_PrivacyVisibilityLabel,
    dgUserProfile_SkillCoachLabel: dgUserProfile_SkillCoachLabel,
    dgUserProfile_TeamProgramDesc: dgUserProfile_TeamProgramDesc,
    dgUserProfile_TeamProgramDescSkillInventory: dgUserProfile_TeamProgramDescSkillInventory,
    dgUserProfile_TeamProgramJoinDesc: dgUserProfile_TeamProgramJoinDesc,
    dgUserProfile_TeamProgramJoinHeader: dgUserProfile_TeamProgramJoinHeader,
    dgUserProfile_TeamProgramLabel: dgUserProfile_TeamProgramLabel,
    dgUserProfile_TeamProgramLeaveDesc: dgUserProfile_TeamProgramLeaveDesc,
    dgUserProfile_TeamProgramLeaveHeader: dgUserProfile_TeamProgramLeaveHeader,
    dgUserProfilePrivacy_ProfileSettingDescriptionFormat: dgUserProfilePrivacy_ProfileSettingDescriptionFormat,
    dgUserProfilePrivacy_VisibleToMeOnly: dgUserProfilePrivacy_VisibleToMeOnly,
    dgUserProfilePrivacy_VisibleToMeOnlyDesc: dgUserProfilePrivacy_VisibleToMeOnlyDesc,
    dgUserProfilePrivacy_VisibleToMeOnlyLabel: dgUserProfilePrivacy_VisibleToMeOnlyLabel,
    dgUserProfilePrivacy_VisibleToOrgDesc: dgUserProfilePrivacy_VisibleToOrgDesc,
    dgUserProfilePrivacy_VisibleToOrgLabel: dgUserProfilePrivacy_VisibleToOrgLabel,
    dgUserProfilePrivacy_VisibleToOrgOnly: dgUserProfilePrivacy_VisibleToOrgOnly,
    dgUserProfilePrivacy_VisibleToPublic: dgUserProfilePrivacy_VisibleToPublic,
    dgUserProfilePrivacy_VisibleToPublicDesc: dgUserProfilePrivacy_VisibleToPublicDesc,
    dgUserProfilePrivacy_VisibleToPublicInOrg: dgUserProfilePrivacy_VisibleToPublicInOrg,
    dgUserProfilePrivacy_VisibleToPublicLabel: dgUserProfilePrivacy_VisibleToPublicLabel,
    dgUsersSearch_Follow: dgUsersSearch_Follow,
    dgUsersSearch_FollowUserFormat: dgUsersSearch_FollowUserFormat,
    dgUsersSearch_NoResults: dgUsersSearch_NoResults,
    dgUsersSearch_SearchDescription: dgUsersSearch_SearchDescription,
    dgUsersSearch_SearchLabel: dgUsersSearch_SearchLabel,
    dgUsersSearch_SearchPlaceholder: dgUsersSearch_SearchPlaceholder,
    dgUsersSearch_SearchTitle: dgUsersSearch_SearchTitle,
    dgUsersSearch_UnFollow: dgUsersSearch_UnFollow,
    dgUsersSearch_UnfollowUserFormat: dgUsersSearch_UnfollowUserFormat,
    dgUserTile_Follow: dgUserTile_Follow,
    dgUserTile_Following: dgUserTile_Following,
    dgUserTile_Unfollow: dgUserTile_Unfollow,
    dgUtilityBar_AddToProfileInProgress: dgUtilityBar_AddToProfileInProgress,
    dgUtilityBar_AddToProfileTitle: dgUtilityBar_AddToProfileTitle,
    dgUtilityBar_FindSomethingToLearnPlaceholder: dgUtilityBar_FindSomethingToLearnPlaceholder,
    dgUtilityBar_FlexEdFormat: dgUtilityBar_FlexEdFormat,
    dgUtilityBar_InProgress: dgUtilityBar_InProgress,
    dgUtilityBar_ManageOrg: dgUtilityBar_ManageOrg,
    dgUtilityBar_MasteryPointsFormat: dgUtilityBar_MasteryPointsFormat,
    dgUtilityBar_PersonalInformationTitle: dgUtilityBar_PersonalInformationTitle,
    dgUtilityBar_SearchLabel: dgUtilityBar_SearchLabel,
    dgUtilityBar_SelectAnotherSkill: dgUtilityBar_SelectAnotherSkill,
    dgUtilityBar_SelectASkill: dgUtilityBar_SelectASkill,
    dgValidatedField_WhoopsMessageFormat: dgValidatedField_WhoopsMessageFormat,
    dgVBarChart_A11yTipFormat: dgVBarChart_A11yTipFormat,
    dgVBarChart_A11yTipFormatRange: dgVBarChart_A11yTipFormatRange,
    dgVBarChart_ChartFilterA11y: dgVBarChart_ChartFilterA11y,
    dgVBarChart_ContentItems: dgVBarChart_ContentItems,
    dgVBarChart_Date: dgVBarChart_Date,
    dgVBarChart_DisplayTypeLabel: dgVBarChart_DisplayTypeLabel,
    dgVBarChart_DisplayTypePlaceholder: dgVBarChart_DisplayTypePlaceholder,
    dgVBarChart_InputTypeLabel: dgVBarChart_InputTypeLabel,
    dgVBarChart_InputTypePlaceholder: dgVBarChart_InputTypePlaceholder,
    dgVBarChart_NoPointsTipFormat: dgVBarChart_NoPointsTipFormat,
    dgVBarChart_PeriodLabel: dgVBarChart_PeriodLabel,
    dgVBarChart_PeriodPlaceholder: dgVBarChart_PeriodPlaceholder,
    dgVBarChart_Points: dgVBarChart_Points,
    dgVBarChart_PointsTipFormat: dgVBarChart_PointsTipFormat,
    dgVBarChart_TopicLabel: dgVBarChart_TopicLabel,
    dgVBarChart_ViewLearningCompletions: dgVBarChart_ViewLearningCompletions,
    dgVideoPlayer_BrowserError: dgVideoPlayer_BrowserError,
    dgVideoPlayer_EncodingMessage: dgVideoPlayer_EncodingMessage,
    dgWordLimit_LimitToFormat: dgWordLimit_LimitToFormat,
    dgWordLimit_MinLimitFormat: dgWordLimit_MinLimitFormat,
    dgWordLimit_WordCount: dgWordLimit_WordCount,
    dgWordLimit_WordLimitReached: dgWordLimit_WordLimitReached,
    dgWordLimit_WordsRemaining: dgWordLimit_WordsRemaining,
    dgXpBar_NewPointsFormat: dgXpBar_NewPointsFormat,
    dgXpBar_NextGoalFormat: dgXpBar_NextGoalFormat,
    Download_DownloadFile: Download_DownloadFile,
    downloadReportOutcome_FailureFormat: downloadReportOutcome_FailureFormat,
    downloadReportOutcome_SuccessFormat: downloadReportOutcome_SuccessFormat,
    EmailAddressVerificationCtrl_VerificationEmailSentFormat: EmailAddressVerificationCtrl_VerificationEmailSentFormat,
    EmbeddedLearning_ComingSoon: EmbeddedLearning_ComingSoon,
    EmbeddedLearning_RelatedArticles: EmbeddedLearning_RelatedArticles,
    EmbeddedLearning_RelatedPathways: EmbeddedLearning_RelatedPathways,
    EmbeddedLearning_RelatedVideos: EmbeddedLearning_RelatedVideos,
    EndorsementOptionsSvc_ContributionLarge: EndorsementOptionsSvc_ContributionLarge,
    EndorsementOptionsSvc_ContributionModerate: EndorsementOptionsSvc_ContributionModerate,
    EndorsementOptionsSvc_ContributionNone: EndorsementOptionsSvc_ContributionNone,
    EndorsementOptionsSvc_ContributionSmall: EndorsementOptionsSvc_ContributionSmall,
    EndorsementOptionsSvc_ContributionVeryLarge: EndorsementOptionsSvc_ContributionVeryLarge,
    EndorsementOptionsSvc_DifficultyExtremely: EndorsementOptionsSvc_DifficultyExtremely,
    EndorsementOptionsSvc_DifficultyNot: EndorsementOptionsSvc_DifficultyNot,
    EndorsementOptionsSvc_DifficultySlightly: EndorsementOptionsSvc_DifficultySlightly,
    EndorsementOptionsSvc_DifficultySomewhat: EndorsementOptionsSvc_DifficultySomewhat,
    EndorsementOptionsSvc_DifficultyVery: EndorsementOptionsSvc_DifficultyVery,
    EndorsementOptionsSvc_ExpertLevel1: EndorsementOptionsSvc_ExpertLevel1,
    EndorsementOptionsSvc_ExpertLevel2: EndorsementOptionsSvc_ExpertLevel2,
    EndorsementOptionsSvc_ExpertLevel3: EndorsementOptionsSvc_ExpertLevel3,
    EndorsementOptionsSvc_ExpertLevel4: EndorsementOptionsSvc_ExpertLevel4,
    EndorsementOptionsSvc_ExpertLevel5: EndorsementOptionsSvc_ExpertLevel5,
    EndorsementOptionsSvc_MasteryCapable: EndorsementOptionsSvc_MasteryCapable,
    EndorsementOptionsSvc_MasteryDistinguished: EndorsementOptionsSvc_MasteryDistinguished,
    EndorsementOptionsSvc_MasteryEmerging: EndorsementOptionsSvc_MasteryEmerging,
    EndorsementOptionsSvc_MasteryExperienced: EndorsementOptionsSvc_MasteryExperienced,
    EndorsementOptionsSvc_MasteryMaster: EndorsementOptionsSvc_MasteryMaster,
    EndorsementOptionsSvc_MasteryNovice: EndorsementOptionsSvc_MasteryNovice,
    EndorsementOptionsSvc_People0To5: EndorsementOptionsSvc_People0To5,
    EndorsementOptionsSvc_People11To20: EndorsementOptionsSvc_People11To20,
    EndorsementOptionsSvc_People151Plus: EndorsementOptionsSvc_People151Plus,
    EndorsementOptionsSvc_People21To40: EndorsementOptionsSvc_People21To40,
    EndorsementOptionsSvc_People41To80: EndorsementOptionsSvc_People41To80,
    EndorsementOptionsSvc_People6To10: EndorsementOptionsSvc_People6To10,
    EndorsementOptionsSvc_People81To150: EndorsementOptionsSvc_People81To150,
    EndorsementOptionsSvc_Percentile30Minus: EndorsementOptionsSvc_Percentile30Minus,
    EndorsementOptionsSvc_Percentile30To49: EndorsementOptionsSvc_Percentile30To49,
    EndorsementOptionsSvc_Percentile50To69: EndorsementOptionsSvc_Percentile50To69,
    EndorsementOptionsSvc_Percentile70To89: EndorsementOptionsSvc_Percentile70To89,
    EndorsementOptionsSvc_Percentile90To99: EndorsementOptionsSvc_Percentile90To99,
    EndorsementOptionsSvc_RelationshipClientOfFormat: EndorsementOptionsSvc_RelationshipClientOfFormat,
    EndorsementOptionsSvc_RelationshipDifferentCompanyFormat: EndorsementOptionsSvc_RelationshipDifferentCompanyFormat,
    EndorsementOptionsSvc_RelationshipDifferentGroupFormat: EndorsementOptionsSvc_RelationshipDifferentGroupFormat,
    EndorsementOptionsSvc_RelationshipManagedFormat: EndorsementOptionsSvc_RelationshipManagedFormat,
    EndorsementOptionsSvc_RelationshipMentorFormat: EndorsementOptionsSvc_RelationshipMentorFormat,
    EndorsementOptionsSvc_RelationshipReportedToFormat: EndorsementOptionsSvc_RelationshipReportedToFormat,
    EndorsementOptionsSvc_RelationshipSameGroupFormat: EndorsementOptionsSvc_RelationshipSameGroupFormat,
    EndorsementOptionsSvc_RelationshipSeniorToFormat: EndorsementOptionsSvc_RelationshipSeniorToFormat,
    EndorsementOptionsSvc_RelationshipSeniorToYouFormat: EndorsementOptionsSvc_RelationshipSeniorToYouFormat,
    EndorsementOptionsSvc_RelationshipStudents: EndorsementOptionsSvc_RelationshipStudents,
    EndorsementOptionsSvc_RelationshipTeacherFormat: EndorsementOptionsSvc_RelationshipTeacherFormat,
    EndorsementOptionsSvc_RelationshipYourCientFormat: EndorsementOptionsSvc_RelationshipYourCientFormat,
    EndorsementOptionsSvc_SignificanceExtremely: EndorsementOptionsSvc_SignificanceExtremely,
    EndorsementOptionsSvc_SignificanceNot: EndorsementOptionsSvc_SignificanceNot,
    EndorsementOptionsSvc_SignificanceSlightly: EndorsementOptionsSvc_SignificanceSlightly,
    EndorsementOptionsSvc_SignificanceSomewhat: EndorsementOptionsSvc_SignificanceSomewhat,
    EndorsementOptionsSvc_SignificanceVery: EndorsementOptionsSvc_SignificanceVery,
    EndorsementOptionsSvc_VerifyNo: EndorsementOptionsSvc_VerifyNo,
    EndorsementOptionsSvc_VerifyPartial: EndorsementOptionsSvc_VerifyPartial,
    EndorsementOptionsSvc_VerifyUnknown: EndorsementOptionsSvc_VerifyUnknown,
    EndorsementOptionsSvc_VerifyYes: EndorsementOptionsSvc_VerifyYes,
    EndorsementOptionsSvc_Years0To1: EndorsementOptionsSvc_Years0To1,
    EndorsementOptionsSvc_Years11To14: EndorsementOptionsSvc_Years11To14,
    EndorsementOptionsSvc_Years15To20: EndorsementOptionsSvc_Years15To20,
    EndorsementOptionsSvc_Years21Plus: EndorsementOptionsSvc_Years21Plus,
    EndorsementOptionsSvc_Years2To4: EndorsementOptionsSvc_Years2To4,
    EndorsementOptionsSvc_Years5To7: EndorsementOptionsSvc_Years5To7,
    EndorsementOptionsSvc_Years8To10: EndorsementOptionsSvc_Years8To10,
    EndorsementSvc_ErrorGetting: EndorsementSvc_ErrorGetting,
    EndorsementSvc_ErrorSaving: EndorsementSvc_ErrorSaving,
    endorserForm_EditHeader: endorserForm_EditHeader,
    endorserForm_EmailLabel: endorserForm_EmailLabel,
    endorserForm_EmailPlaceholder: endorserForm_EmailPlaceholder,
    endorserForm_FirstNameLabel: endorserForm_FirstNameLabel,
    endorserForm_InvitationLabel: endorserForm_InvitationLabel,
    endorserForm_LastNameLabel: endorserForm_LastNameLabel,
    endorserForm_PositionLabel: endorserForm_PositionLabel,
    endorserForm_PositionPlaceholder: endorserForm_PositionPlaceholder,
    endorserForm_RelationshipLabel: endorserForm_RelationshipLabel,
    endorserForm_RelationshipPlaceholder: endorserForm_RelationshipPlaceholder,
    endorsersForm_applicantsEmailValidationMessage: endorsersForm_applicantsEmailValidationMessage,
    endorsersForm_Header: endorsersForm_Header,
    endorsersForm_Instructions: endorsersForm_Instructions,
    endorsersForm_InstructionsFour: endorsersForm_InstructionsFour,
    endorsersForm_InstructionsOne: endorsersForm_InstructionsOne,
    endorsersForm_InstructionsThree: endorsersForm_InstructionsThree,
    endorsersForm_InstructionsTwo: endorsersForm_InstructionsTwo,
    endorsersForm_InvalidEmailValidationMessage: endorsersForm_InvalidEmailValidationMessage,
    endorsersForm_sameEmailValidationMessage: endorsersForm_sameEmailValidationMessage,
    endorsersForm_SectionHeader1: endorsersForm_SectionHeader1,
    endorsersForm_SectionHeader2: endorsersForm_SectionHeader2,
    endorsersForm_SectionHeader3: endorsersForm_SectionHeader3,
    endorsersForm_Tip: endorsersForm_Tip,
    endorsersForm_ValidationMessage: endorsersForm_ValidationMessage,
    EpisodeFormCtrl_AddPodcast: EpisodeFormCtrl_AddPodcast,
    EpisodeFormCtrl_Category: EpisodeFormCtrl_Category,
    EpisodeFormCtrl_ChooseEpisode: EpisodeFormCtrl_ChooseEpisode,
    EpisodeFormCtrl_DateCompleted: EpisodeFormCtrl_DateCompleted,
    EpisodeFormCtrl_EditPodcast: EpisodeFormCtrl_EditPodcast,
    EpisodeFormCtrl_EnterPodcastName: EpisodeFormCtrl_EnterPodcastName,
    EpisodeFormCtrl_Episode: EpisodeFormCtrl_Episode,
    EpisodeFormCtrl_EpisodeError: EpisodeFormCtrl_EpisodeError,
    EpisodeFormCtrl_ICreatedEpisode: EpisodeFormCtrl_ICreatedEpisode,
    EpisodeFormCtrl_LengthInMinutes: EpisodeFormCtrl_LengthInMinutes,
    EpisodeFormCtrl_Loading: EpisodeFormCtrl_Loading,
    EpisodeFormCtrl_NoEpisodes: EpisodeFormCtrl_NoEpisodes,
    EpisodeFormCtrl_NoMatch: EpisodeFormCtrl_NoMatch,
    EpisodeFormCtrl_PodcastName: EpisodeFormCtrl_PodcastName,
    EpisodeFormCtrl_SaveEpisode: EpisodeFormCtrl_SaveEpisode,
    EpisodeFormCtrl_SelectEpisode: EpisodeFormCtrl_SelectEpisode,
    EpisodeFormCtrl_SelectTitle: EpisodeFormCtrl_SelectTitle,
    EpisodeFormCtrl_ValidNumber: EpisodeFormCtrl_ValidNumber,
    EpisodeFormCtrl_WhatDidYouLearnLong: EpisodeFormCtrl_WhatDidYouLearnLong,
    EpisodeFormCtrl_WhatDidYouLearnShort: EpisodeFormCtrl_WhatDidYouLearnShort,
    ErrorPages_ErrorTitle: ErrorPages_ErrorTitle,
    ErrorPages_ErrorTitle500: ErrorPages_ErrorTitle500,
    ErrorPages_FaultSolution: ErrorPages_FaultSolution,
    ErrorPages_HomepageButton: ErrorPages_HomepageButton,
    ErrorPages_ReportBugButton: ErrorPages_ReportBugButton,
    ErrorPages_VerifyEmailErrorText: ErrorPages_VerifyEmailErrorText,
    ErrorPages_VerifyEmailErrorTitle: ErrorPages_VerifyEmailErrorTitle,
    Eval_ApplicationAlreadyEndorsed: Eval_ApplicationAlreadyEndorsed,
    Eval_ApplicationAlreadyEndorsedDesc: Eval_ApplicationAlreadyEndorsedDesc,
    Eval_ApplicationEndorsed: Eval_ApplicationEndorsed,
    Eval_ApplicationEndorsedDesc: Eval_ApplicationEndorsedDesc,
    Eval_ApplicationNotEndorsedDesc: Eval_ApplicationNotEndorsedDesc,
    Eval_ApplicationOutOfDate: Eval_ApplicationOutOfDate,
    Eval_ApplicationOutOfDateDesc: Eval_ApplicationOutOfDateDesc,
    Eval_ApproveApplication: Eval_ApproveApplication,
    Eval_EndorseApplication: Eval_EndorseApplication,
    Eval_EndorsementDesc: Eval_EndorsementDesc,
    Eval_EndorsementHeader: Eval_EndorsementHeader,
    Eval_EndorsementNav: Eval_EndorsementNav,
    Eval_GoBackHome: Eval_GoBackHome,
    Eval_LeaveRemarks: Eval_LeaveRemarks,
    Eval_LevelInItem: Eval_LevelInItem,
    Eval_NextStep: Eval_NextStep,
    Eval_OptionalQuestionDesc_Endorser: Eval_OptionalQuestionDesc_Endorser,
    Eval_Question_AdvanceStateOfArt: Eval_Question_AdvanceStateOfArt,
    Eval_Question_AdvanceStateOfArtExample: Eval_Question_AdvanceStateOfArtExample,
    Eval_Question_AlternativeApproaches: Eval_Question_AlternativeApproaches,
    Eval_Question_AnticipateCommProblems: Eval_Question_AnticipateCommProblems,
    Eval_Question_AnticipateRequirements: Eval_Question_AnticipateRequirements,
    Eval_Question_ApplyFrequency: Eval_Question_ApplyFrequency,
    Eval_Question_ApplyJob: Eval_Question_ApplyJob,
    Eval_Question_ApplyNewTheories: Eval_Question_ApplyNewTheories,
    Eval_Question_ApproachTheory: Eval_Question_ApproachTheory,
    Eval_Question_ArticulateChallenge: Eval_Question_ArticulateChallenge,
    Eval_Question_ArticulateChallengeExample: Eval_Question_ArticulateChallengeExample,
    Eval_Question_BuildConsensus: Eval_Question_BuildConsensus,
    Eval_Question_BuildConsensusExample: Eval_Question_BuildConsensusExample,
    Eval_Question_Collaboration: Eval_Question_Collaboration,
    Eval_Question_CommunicateDifficultSubjects: Eval_Question_CommunicateDifficultSubjects,
    Eval_Question_CommunicationAbilities: Eval_Question_CommunicationAbilities,
    Eval_Question_ComplexTasks: Eval_Question_ComplexTasks,
    Eval_Question_ContributeProfessionalDevelopment: Eval_Question_ContributeProfessionalDevelopment,
    Eval_Question_ContributeProfessionalDevelopmentExample: Eval_Question_ContributeProfessionalDevelopmentExample,
    Eval_Question_ContributingToObjectives: Eval_Question_ContributingToObjectives,
    Eval_Question_CrossDiscipline: Eval_Question_CrossDiscipline,
    Eval_Question_DefineGroupProcess: Eval_Question_DefineGroupProcess,
    Eval_Question_DefineGroupRoles: Eval_Question_DefineGroupRoles,
    Eval_Question_DescribeKnowledge: Eval_Question_DescribeKnowledge,
    Eval_Question_DevelopGroupPotential: Eval_Question_DevelopGroupPotential,
    Eval_Question_DevelopGroupPotentialExample: Eval_Question_DevelopGroupPotentialExample,
    Eval_Question_DirectOthers: Eval_Question_DirectOthers,
    Eval_Question_DirectOthersExample: Eval_Question_DirectOthersExample,
    Eval_Question_EvaluateProcesses: Eval_Question_EvaluateProcesses,
    Eval_Question_EvaluateProcessesExample: Eval_Question_EvaluateProcessesExample,
    Eval_Question_EvaluateWork: Eval_Question_EvaluateWork,
    Eval_Question_FindSolutions: Eval_Question_FindSolutions,
    Eval_Question_FindSolutionsExample: Eval_Question_FindSolutionsExample,
    Eval_Question_FrequencyUnanticipatedProblems: Eval_Question_FrequencyUnanticipatedProblems,
    Eval_Question_HelpGroupEffective: Eval_Question_HelpGroupEffective,
    Eval_Question_ImpactOnField: Eval_Question_ImpactOnField,
    Eval_Question_ImpactOnFieldExample: Eval_Question_ImpactOnFieldExample,
    Eval_Question_ImpactOthers: Eval_Question_ImpactOthers,
    Eval_Question_ImproveSkill: Eval_Question_ImproveSkill,
    Eval_Question_InnovativeContributionExample: Eval_Question_InnovativeContributionExample,
    Eval_Question_JobTitle: Eval_Question_JobTitle,
    Eval_Question_LeadGroup: Eval_Question_LeadGroup,
    Eval_Question_LeadGroupExample: Eval_Question_LeadGroupExample,
    Eval_Question_LeadOrg: Eval_Question_LeadOrg,
    Eval_Question_LeadOrgExample: Eval_Question_LeadOrgExample,
    Eval_Question_Learn: Eval_Question_Learn,
    Eval_Question_LearnExample: Eval_Question_LearnExample,
    Eval_Question_LearnFromOthers: Eval_Question_LearnFromOthers,
    Eval_Question_LevelOfResponsibility: Eval_Question_LevelOfResponsibility,
    Eval_Question_LimitsExample: Eval_Question_LimitsExample,
    Eval_Question_LimitsOfField: Eval_Question_LimitsOfField,
    Eval_Question_MasterStateOfArt: Eval_Question_MasterStateOfArt,
    Eval_Question_NumberOfMethods: Eval_Question_NumberOfMethods,
    Eval_Question_OverallGuidance: Eval_Question_OverallGuidance,
    Eval_Question_PracticalAbilities: Eval_Question_PracticalAbilities,
    Eval_Question_PresentationAbilities: Eval_Question_PresentationAbilities,
    Eval_Question_PrestipulatedTasks: Eval_Question_PrestipulatedTasks,
    Eval_Question_ProblemsCanSolve: Eval_Question_ProblemsCanSolve,
    Eval_Question_ProjectResponsibility: Eval_Question_ProjectResponsibility,
    Eval_Question_RelatedSkills: Eval_Question_RelatedSkills,
    Eval_Question_RequirementsChange: Eval_Question_RequirementsChange,
    Eval_Question_SkillDuration: Eval_Question_SkillDuration,
    Eval_Question_SocietalImplications: Eval_Question_SocietalImplications,
    Eval_Question_StrategicJudgements: Eval_Question_StrategicJudgements,
    Eval_Question_StrategicProblemExample: Eval_Question_StrategicProblemExample,
    Eval_Question_Teamwork: Eval_Question_Teamwork,
    Eval_Question_TechnicalKnowledge: Eval_Question_TechnicalKnowledge,
    Eval_Question_TypesUnanticipatedProblems: Eval_Question_TypesUnanticipatedProblems,
    Eval_Question_UnclearTasks: Eval_Question_UnclearTasks,
    Eval_Question_UnderstandRelatedSkills: Eval_Question_UnderstandRelatedSkills,
    Eval_Question_WellKnown: Eval_Question_WellKnown,
    Eval_Question_WellKnownExample: Eval_Question_WellKnownExample,
    Eval_Question_WorkInGroup: Eval_Question_WorkInGroup,
    Eval_QuestionDesc_Endorser: Eval_QuestionDesc_Endorser,
    Eval_QuestionDesc_HonorCode: Eval_QuestionDesc_HonorCode,
    Eval_ReflectSkillDescription: Eval_ReflectSkillDescription,
    Eval_RequestChanges: Eval_RequestChanges,
    Eval_Response_1_2Years: Eval_Response_1_2Years,
    Eval_Response_11_Years: Eval_Response_11_Years,
    Eval_Response_3_5Years: Eval_Response_3_5Years,
    Eval_Response_6_10Years: Eval_Response_6_10Years,
    Eval_Response_AcceptHonorCode: Eval_Response_AcceptHonorCode,
    Eval_Response_AcknowledgeOthers: Eval_Response_AcknowledgeOthers,
    Eval_Response_AdvancedSkills: Eval_Response_AdvancedSkills,
    Eval_Response_BasicKnowledge: Eval_Response_BasicKnowledge,
    Eval_Response_BasicSkills: Eval_Response_BasicSkills,
    Eval_Response_BroadSkills: Eval_Response_BroadSkills,
    Eval_Response_CommunicateContextually: Eval_Response_CommunicateContextually,
    Eval_Response_CommunicateEffectively: Eval_Response_CommunicateEffectively,
    Eval_Response_ComplexCommunication: Eval_Response_ComplexCommunication,
    Eval_Response_ComplexProblems: Eval_Response_ComplexProblems,
    Eval_Response_ComprehensiveTechTheoryKnowledge: Eval_Response_ComprehensiveTechTheoryKnowledge,
    Eval_Response_ConvincingOthers: Eval_Response_ConvincingOthers,
    Eval_Response_CurrentLimits: Eval_Response_CurrentLimits,
    Eval_Response_Daily: Eval_Response_Daily,
    Eval_Response_DeepKnowledge: Eval_Response_DeepKnowledge,
    Eval_Response_DemonstrateBasics: Eval_Response_DemonstrateBasics,
    Eval_Response_DifferentApproaches: Eval_Response_DifferentApproaches,
    Eval_Response_DirectDevelopment: Eval_Response_DirectDevelopment,
    Eval_Response_ExtendedSkills: Eval_Response_ExtendedSkills,
    Eval_Response_ExtensiveKnowledge: Eval_Response_ExtensiveKnowledge,
    Eval_Response_ExtensiveTechTheoryKnowledge: Eval_Response_ExtensiveTechTheoryKnowledge,
    Eval_Response_FewProblems: Eval_Response_FewProblems,
    Eval_Response_FewTechniques: Eval_Response_FewTechniques,
    Eval_Response_FocusOnMyDevelopment: Eval_Response_FocusOnMyDevelopment,
    Eval_Response_FocusOnMyWork: Eval_Response_FocusOnMyWork,
    Eval_Response_FocusOnTask: Eval_Response_FocusOnTask,
    Eval_Response_IntroduceInnovativeContributions: Eval_Response_IntroduceInnovativeContributions,
    Eval_Response_LearningGuidance: Eval_Response_LearningGuidance,
    Eval_Response_LessThan1Year: Eval_Response_LessThan1Year,
    Eval_Response_LimitedTechTheoryKnowledge: Eval_Response_LimitedTechTheoryKnowledge,
    Eval_Response_MakePeopleMoreEffective: Eval_Response_MakePeopleMoreEffective,
    Eval_Response_Monthly: Eval_Response_Monthly,
    Eval_Response_MostAspects: Eval_Response_MostAspects,
    Eval_Response_No: Eval_Response_No,
    Eval_Response_NotComfortable: Eval_Response_NotComfortable,
    Eval_Response_NoTechTheoryKnowledge: Eval_Response_NoTechTheoryKnowledge,
    Eval_Response_NotSure: Eval_Response_NotSure,
    Eval_Response_NotVery: Eval_Response_NotVery,
    Eval_Response_NovelProblems: Eval_Response_NovelProblems,
    Eval_Response_Often: Eval_Response_Often,
    Eval_Response_OncePerYear: Eval_Response_OncePerYear,
    Eval_Response_OngoingSupport: Eval_Response_OngoingSupport,
    Eval_Response_Partially: Eval_Response_Partially,
    Eval_Response_PresentArguments: Eval_Response_PresentArguments,
    Eval_Response_PresentInformation: Eval_Response_PresentInformation,
    Eval_Response_PresentNone: Eval_Response_PresentNone,
    Eval_Response_Rarely: Eval_Response_Rarely,
    Eval_Response_ResponsibilityGiven: Eval_Response_ResponsibilityGiven,
    Eval_Response_ResponsibilityOverall: Eval_Response_ResponsibilityOverall,
    Eval_Response_ResponsibilityPlanning: Eval_Response_ResponsibilityPlanning,
    Eval_Response_SensitiveCommunication: Eval_Response_SensitiveCommunication,
    Eval_Response_SeveralMethods: Eval_Response_SeveralMethods,
    Eval_Response_SeveralPerYear: Eval_Response_SeveralPerYear,
    Eval_Response_SimpleProblems: Eval_Response_SimpleProblems,
    Eval_Response_SolveSimpleProblems: Eval_Response_SolveSimpleProblems,
    Eval_Response_SolveStrategicProblems: Eval_Response_SolveStrategicProblems,
    Eval_Response_SolveUnfamiliarProblems: Eval_Response_SolveUnfamiliarProblems,
    Eval_Response_SolveVarietyProblems: Eval_Response_SolveVarietyProblems,
    Eval_Response_SomeKnowledge: Eval_Response_SomeKnowledge,
    Eval_Response_Sometimes: Eval_Response_Sometimes,
    Eval_Response_Somewhat: Eval_Response_Somewhat,
    Eval_Response_SomewhatComfortable: Eval_Response_SomewhatComfortable,
    Eval_Response_Specific: Eval_Response_Specific,
    Eval_Response_StrategicProblems: Eval_Response_StrategicProblems,
    Eval_Response_SupportOthers: Eval_Response_SupportOthers,
    Eval_Response_Tangential: Eval_Response_Tangential,
    Eval_Response_UncomfortableCommunication: Eval_Response_UncomfortableCommunication,
    Eval_Response_UnderstandOthers: Eval_Response_UnderstandOthers,
    Eval_Response_Very: Eval_Response_Very,
    Eval_Response_VeryComfortable: Eval_Response_VeryComfortable,
    Eval_Response_Weekly: Eval_Response_Weekly,
    Eval_Response_Yes: Eval_Response_Yes,
    Eval_ResponseDesc_AcceptHonorCode: Eval_ResponseDesc_AcceptHonorCode,
    Eval_SaveEndorsementError: Eval_SaveEndorsementError,
    Eval_Step_Application: Eval_Step_Application,
    Eval_Step_AutonomyResponsibility: Eval_Step_AutonomyResponsibility,
    Eval_Step_Background: Eval_Step_Background,
    Eval_Step_CommunicationTeaching: Eval_Step_CommunicationTeaching,
    Eval_Step_DemonstrationOfCriteria: Eval_Step_DemonstrationOfCriteria,
    Eval_Step_EndorseDecline: Eval_Step_EndorseDecline,
    Eval_Step_Endorsement: Eval_Step_Endorsement,
    Eval_Step_General: Eval_Step_General,
    Eval_Step_Introduction: Eval_Step_Introduction,
    Eval_Step_Knowledge: Eval_Step_Knowledge,
    Eval_Step_PlanningEvaluation: Eval_Step_PlanningEvaluation,
    Eval_Step_Questionnaire: Eval_Step_Questionnaire,
    Eval_Step_ReceiveResults: Eval_Step_ReceiveResults,
    Eval_Step_ReviewApplication: Eval_Step_ReviewApplication,
    Eval_Step_TeamworkLeadership: Eval_Step_TeamworkLeadership,
    Eval_StepDesc_Application: Eval_StepDesc_Application,
    Eval_StepDesc_EndorseDecline: Eval_StepDesc_EndorseDecline,
    Eval_StepDesc_EndorseIntroduction: Eval_StepDesc_EndorseIntroduction,
    Eval_StepDesc_General: Eval_StepDesc_General,
    Eval_StepDesc_ReviewApplication: Eval_StepDesc_ReviewApplication,
    EvalApp_Cancel: EvalApp_Cancel,
    EvalApp_MainTitle: EvalApp_MainTitle,
    EvalApp_Results_Breakdown: EvalApp_Results_Breakdown,
    EvalApp_Results_Congratulations: EvalApp_Results_Congratulations,
    EvalApp_Results_ExtraMile: EvalApp_Results_ExtraMile,
    EvalApp_Results_GoToFeed: EvalApp_Results_GoToFeed,
    EvalApp_Results_GoToProfile: EvalApp_Results_GoToProfile,
    EvalApp_Results_LevelDeclarationFormat: EvalApp_Results_LevelDeclarationFormat,
    EvalApp_Stay: EvalApp_Stay,
    EvalNav_Heading: EvalNav_Heading,
    EvalNav_Introduction: EvalNav_Introduction,
    EvalNav_ResultsDescription: EvalNav_ResultsDescription,
    EvalNav_ResultsTitle: EvalNav_ResultsTitle,
    EvalNav_SelectEndorser: EvalNav_SelectEndorser,
    EvaluationSvc_DeleteError: EvaluationSvc_DeleteError,
    EvaluationSvc_DeleteSuccess: EvaluationSvc_DeleteSuccess,
    EvaluationSvc_RetrieveError: EvaluationSvc_RetrieveError,
    EvaluationSvc_SetResultsError: EvaluationSvc_SetResultsError,
    EvaluationSvc_SubmitError: EvaluationSvc_SubmitError,
    EventFormCtrl_AddEvent: EventFormCtrl_AddEvent,
    EventFormCtrl_AddToCatalogFormat: EventFormCtrl_AddToCatalogFormat,
    EventFormCtrl_Attendee: EventFormCtrl_Attendee,
    EventFormCtrl_Category: EventFormCtrl_Category,
    EventFormCtrl_DateAttended: EventFormCtrl_DateAttended,
    EventFormCtrl_Description: EventFormCtrl_Description,
    EventFormCtrl_EditEvent: EventFormCtrl_EditEvent,
    EventFormCtrl_EventLength: EventFormCtrl_EventLength,
    EventFormCtrl_EventLengthError: EventFormCtrl_EventLengthError,
    EventFormCtrl_EventSite: EventFormCtrl_EventSite,
    EventFormCtrl_EventTitle: EventFormCtrl_EventTitle,
    EventFormCtrl_EventTitleError: EventFormCtrl_EventTitleError,
    EventFormCtrl_EventUrl: EventFormCtrl_EventUrl,
    EventFormCtrl_HowInvolved: EventFormCtrl_HowInvolved,
    EventFormCtrl_Keynote: EventFormCtrl_Keynote,
    EventFormCtrl_OneDay: EventFormCtrl_OneDay,
    EventFormCtrl_OneHour: EventFormCtrl_OneHour,
    EventFormCtrl_Panelist: EventFormCtrl_Panelist,
    EventFormCtrl_Presenter: EventFormCtrl_Presenter,
    EventFormCtrl_SaveEvent: EventFormCtrl_SaveEvent,
    EventFormCtrl_ThreeToEightHours: EventFormCtrl_ThreeToEightHours,
    EventFormCtrl_ThreeToFiveDays: EventFormCtrl_ThreeToFiveDays,
    EventFormCtrl_Title: EventFormCtrl_Title,
    EventFormCtrl_TwoDays: EventFormCtrl_TwoDays,
    EventFormCtrl_TwoHours: EventFormCtrl_TwoHours,
    EventFormCtrl_ValidUrl: EventFormCtrl_ValidUrl,
    EventFormCtrl_WeekOrMore: EventFormCtrl_WeekOrMore,
    EventFormCtrl_WhatDidYouLearnLong: EventFormCtrl_WhatDidYouLearnLong,
    EventFormCtrl_WhatDidYouLearnShort: EventFormCtrl_WhatDidYouLearnShort,
    Ext_AddALesson: Ext_AddALesson,
    Ext_AddAPathway: Ext_AddAPathway,
    Ext_AddASection: Ext_AddASection,
    Ext_AddATitle: Ext_AddATitle,
    Ext_AddCommentError: Ext_AddCommentError,
    Ext_AddedToCatalogSuccess: Ext_AddedToCatalogSuccess,
    Ext_AddedToPlan: Ext_AddedToPlan,
    Ext_Adding: Ext_Adding,
    Ext_AddingInputFormat: Ext_AddingInputFormat,
    Ext_AddNotificationNote: Ext_AddNotificationNote,
    Ext_AddPathwayFor: Ext_AddPathwayFor,
    Ext_AddPathwayTitle: Ext_AddPathwayTitle,
    Ext_AddRecommendationNote: Ext_AddRecommendationNote,
    Ext_AddSuccess: Ext_AddSuccess,
    Ext_AddTakeaway: Ext_AddTakeaway,
    Ext_AddToCatalog: Ext_AddToCatalog,
    Ext_AddToCatalogFormat: Ext_AddToCatalogFormat,
    Ext_AddToPathway: Ext_AddToPathway,
    Ext_AddTopics: Ext_AddTopics,
    Ext_AddTopicsOrSkills: Ext_AddTopicsOrSkills,
    Ext_AddTopicsOrTakeAway: Ext_AddTopicsOrTakeAway,
    Ext_AddToPlan: Ext_AddToPlan,
    Ext_AuthBlurb: Ext_AuthBlurb,
    Ext_BookInfoUnavailable: Ext_BookInfoUnavailable,
    Ext_CharacterCount: Ext_CharacterCount,
    Ext_CharactersRemainingFormat: Ext_CharactersRemainingFormat,
    Ext_ClearSearch: Ext_ClearSearch,
    Ext_Close: Ext_Close,
    Ext_ConfirmDetails: Ext_ConfirmDetails,
    Ext_Continue: Ext_Continue,
    Ext_CreatePlan: Ext_CreatePlan,
    Ext_EnterTopics: Ext_EnterTopics,
    Ext_Error: Ext_Error,
    Ext_ErrorMessage: Ext_ErrorMessage,
    Ext_ErrorSharing: Ext_ErrorSharing,
    Ext_ExistsInCMS: Ext_ExistsInCMS,
    Ext_GroupMemberCount: Ext_GroupMemberCount,
    Ext_InputAddedFormat: Ext_InputAddedFormat,
    Ext_ItemAdded: Ext_ItemAdded,
    Ext_ItemSaved: Ext_ItemSaved,
    Ext_Lesson: Ext_Lesson,
    Ext_LessonAddError: Ext_LessonAddError,
    Ext_LessonFormat: Ext_LessonFormat,
    Ext_LessonPlaceholder: Ext_LessonPlaceholder,
    Ext_Loading: Ext_Loading,
    Ext_LogoAlt: Ext_LogoAlt,
    Ext_LogOut: Ext_LogOut,
    Ext_MarkCompleteError: Ext_MarkCompleteError,
    Ext_MarkCompleteFormat: Ext_MarkCompleteFormat,
    Ext_MemberCountFormat: Ext_MemberCountFormat,
    Ext_MenuMarkComplete: Ext_MenuMarkComplete,
    Ext_MenuRecommend: Ext_MenuRecommend,
    Ext_MenuSaveForLater: Ext_MenuSaveForLater,
    Ext_Message: Ext_Message,
    Ext_NewNotificationsFormat: Ext_NewNotificationsFormat,
    Ext_Next: Ext_Next,
    Ext_NoAccount: Ext_NoAccount,
    Ext_NoNotifications: Ext_NoNotifications,
    Ext_NoPlansYet: Ext_NoPlansYet,
    Ext_NotificationCountFormat: Ext_NotificationCountFormat,
    Ext_Pathway: Ext_Pathway,
    Ext_PathwayAddError: Ext_PathwayAddError,
    Ext_PathwayAddItemError: Ext_PathwayAddItemError,
    Ext_PathwayAddItemPermissionError: Ext_PathwayAddItemPermissionError,
    Ext_PathwayDetailAccessError: Ext_PathwayDetailAccessError,
    Ext_PathwayEnrollError: Ext_PathwayEnrollError,
    Ext_PathwayError: Ext_PathwayError,
    Ext_PathwayLessonsError: Ext_PathwayLessonsError,
    Ext_PathwayPlaceholder: Ext_PathwayPlaceholder,
    Ext_PathwayTitle: Ext_PathwayTitle,
    Ext_PathwayUnenrollError: Ext_PathwayUnenrollError,
    Ext_PdfErrorMessage: Ext_PdfErrorMessage,
    Ext_PlansCreate: Ext_PlansCreate,
    Ext_PlansModalTitle: Ext_PlansModalTitle,
    Ext_PlansPlaceholder: Ext_PlansPlaceholder,
    Ext_PointsShort: Ext_PointsShort,
    Ext_PrivacyOnlyMe: Ext_PrivacyOnlyMe,
    Ext_RecommandationSentPluralFormat: Ext_RecommandationSentPluralFormat,
    Ext_RecommandationSentSingle: Ext_RecommandationSentSingle,
    Ext_Recommend: Ext_Recommend,
    Ext_RecommendationSentPluralFormat: Ext_RecommendationSentPluralFormat,
    Ext_RecommendationSentSingle: Ext_RecommendationSentSingle,
    Ext_RecommendationViaEmail: Ext_RecommendationViaEmail,
    Ext_Recommending: Ext_Recommending,
    Ext_RecommendingToPluralFormat: Ext_RecommendingToPluralFormat,
    Ext_RecommendingToSingle: Ext_RecommendingToSingle,
    Ext_RecommendToPluralFormat: Ext_RecommendToPluralFormat,
    Ext_RecommendToSingle: Ext_RecommendToSingle,
    Ext_RelatedSkills: Ext_RelatedSkills,
    Ext_Retry: Ext_Retry,
    Ext_Save: Ext_Save,
    Ext_SaveButton: Ext_SaveButton,
    Ext_SaveForLaterError: Ext_SaveForLaterError,
    Ext_SaveRatingError: Ext_SaveRatingError,
    Ext_Saving: Ext_Saving,
    Ext_SavingError: Ext_SavingError,
    Ext_SavingItem: Ext_SavingItem,
    Ext_SearchError: Ext_SearchError,
    Ext_SearchGroups: Ext_SearchGroups,
    Ext_SearchResultArticlesHeadingFormat: Ext_SearchResultArticlesHeadingFormat,
    Ext_SearchResultBooksHeadingFormat: Ext_SearchResultBooksHeadingFormat,
    Ext_SearchResultNoneFound: Ext_SearchResultNoneFound,
    Ext_SearchResultPathwaysHeadingFormat: Ext_SearchResultPathwaysHeadingFormat,
    Ext_SearchResultPeopleHeadingFormat: Ext_SearchResultPeopleHeadingFormat,
    Ext_SearchResultTitleFormat: Ext_SearchResultTitleFormat,
    Ext_SearchResultVideosHeadingFormat: Ext_SearchResultVideosHeadingFormat,
    Ext_Section: Ext_Section,
    Ext_SectionAddError: Ext_SectionAddError,
    Ext_SectionFormat: Ext_SectionFormat,
    Ext_SectionPlaceholder: Ext_SectionPlaceholder,
    Ext_SelectAGroup: Ext_SelectAGroup,
    Ext_SelectALesson: Ext_SelectALesson,
    Ext_SelectAPathway: Ext_SelectAPathway,
    Ext_SelectASection: Ext_SelectASection,
    Ext_SelectLesson: Ext_SelectLesson,
    Ext_SelectPathway: Ext_SelectPathway,
    Ext_SelectPlan: Ext_SelectPlan,
    Ext_SelectRecommendees: Ext_SelectRecommendees,
    Ext_SelectRecommendeesPlaceholder: Ext_SelectRecommendeesPlaceholder,
    Ext_SelectSection: Ext_SelectSection,
    Ext_SelectSkillPlan: Ext_SelectSkillPlan,
    Ext_SharedContentSuccess: Ext_SharedContentSuccess,
    Ext_ShareSomethingAboutFormat: Ext_ShareSomethingAboutFormat,
    Ext_ShareTitle: Ext_ShareTitle,
    Ext_SignIn: Ext_SignIn,
    Ext_SignInTitle: Ext_SignInTitle,
    Ext_SignUpLink: Ext_SignUpLink,
    Ext_TagsModalTitle: Ext_TagsModalTitle,
    Ext_TagsSuggestionError: Ext_TagsSuggestionError,
    Ext_TakeawayAdded: Ext_TakeawayAdded,
    Ext_TakeawayPlaceholder: Ext_TakeawayPlaceholder,
    Ext_TargetAddError: Ext_TargetAddError,
    Ext_TargetGetError: Ext_TargetGetError,
    Ext_TargetGetSectionsError: Ext_TargetGetSectionsError,
    Ext_Title: Ext_Title,
    Ext_TopicAddedPlural: Ext_TopicAddedPlural,
    Ext_TopicAddedSingle: Ext_TopicAddedSingle,
    Ext_TopicAndTakeawayAddedPlural: Ext_TopicAndTakeawayAddedPlural,
    Ext_TopicAndTakeawayAddedSingle: Ext_TopicAndTakeawayAddedSingle,
    Ext_ViewAllOnDegreed: Ext_ViewAllOnDegreed,
    Ext_ViewDuplicate: Ext_ViewDuplicate,
    Ext_ViewPlan: Ext_ViewPlan,
    Ext_ViewSavedItems: Ext_ViewSavedItems,
    Ext_ViewYourPathway: Ext_ViewYourPathway,
    Ext_WhyRecommending: Ext_WhyRecommending,
    externalContentModal_HeaderFormat: externalContentModal_HeaderFormat,
    ExternalProvidersSvc_ErrorMatchingResults: ExternalProvidersSvc_ErrorMatchingResults,
    ExternalProvidersSvc_ErrorRetrievingDetailsFormat: ExternalProvidersSvc_ErrorRetrievingDetailsFormat,
    ExternalProvidersSvc_ErrorRetrivingListFormat: ExternalProvidersSvc_ErrorRetrivingListFormat,
    FacetFilter_ActiveSubscription: FacetFilter_ActiveSubscription,
    FacetFilter_More: FacetFilter_More,
    FacetFilter_None: FacetFilter_None,
    FacetFilter_SortAlpha: FacetFilter_SortAlpha,
    FacetFilter_SortAlphaReverse: FacetFilter_SortAlphaReverse,
    FacetFilter_SortNumeric: FacetFilter_SortNumeric,
    FacetFilter_VisitSite: FacetFilter_VisitSite,
    FacetFilter_YourTopCategories: FacetFilter_YourTopCategories,
    FeedbackPartial_CitiCollaborate: FeedbackPartial_CitiCollaborate,
    FeedbackPartial_FAQ: FeedbackPartial_FAQ,
    FeedbackPartial_HereToHelp: FeedbackPartial_HereToHelp,
    FeedbackPartial_KnowledgeCenter: FeedbackPartial_KnowledgeCenter,
    FeedbackPartial_OSSLicense: FeedbackPartial_OSSLicense,
    FeedbackPartial_PhoneNumber: FeedbackPartial_PhoneNumber,
    FeedbackPartial_PrivacyPolicy: FeedbackPartial_PrivacyPolicy,
    FeedbackPartial_SendAMessage: FeedbackPartial_SendAMessage,
    FeedbackSvc_ErrorMessage: FeedbackSvc_ErrorMessage,
    FeedbackSvc_ThankyouMessage: FeedbackSvc_ThankyouMessage,
    FeedSvc_Dismiss: FeedSvc_Dismiss,
    firstPathwayModal_Enrolled: firstPathwayModal_Enrolled,
    firstPathwayModal_Followed: firstPathwayModal_Followed,
    firstPathwayModal_ViewPathways: firstPathwayModal_ViewPathways,
    firstPathwayModal_WhyTheyHelp: firstPathwayModal_WhyTheyHelp,
    FlexCtrl_AddPrimaryContact: FlexCtrl_AddPrimaryContact,
    FlexCtrl_AddProperties: FlexCtrl_AddProperties,
    FlexCtrl_AddSection: FlexCtrl_AddSection,
    FlexCtrl_AutoSuggestError: FlexCtrl_AutoSuggestError,
    FlexCtrl_ChooseSectionType: FlexCtrl_ChooseSectionType,
    FlexCtrl_EditingStatusMessage: FlexCtrl_EditingStatusMessage,
    FlexCtrl_EditPageType: FlexCtrl_EditPageType,
    FlexCtrl_EditPlanType: FlexCtrl_EditPlanType,
    FlexCtrl_EditPrimaryContact: FlexCtrl_EditPrimaryContact,
    FlexCtrl_EditProperties: FlexCtrl_EditProperties,
    FlexCtrl_EditSettings: FlexCtrl_EditSettings,
    FlexCtrl_NothingHere: FlexCtrl_NothingHere,
    FlexCtrl_NothingHereDescription: FlexCtrl_NothingHereDescription,
    FlexCtrl_PrimaryContact: FlexCtrl_PrimaryContact,
    FlexCtrl_ReorderSections: FlexCtrl_ReorderSections,
    FlexCtrl_SavePrimaryContact: FlexCtrl_SavePrimaryContact,
    FlexCtrl_SettingsType: FlexCtrl_SettingsType,
    FlexCtrl_ViewDirectory: FlexCtrl_ViewDirectory,
    FlexCtrl_ViewPageType: FlexCtrl_ViewPageType,
    FlexCtrl_ViewPlanType: FlexCtrl_ViewPlanType,
    FlexEdCtrl_Amount: FlexEdCtrl_Amount,
    FlexEdCtrl_Balance: FlexEdCtrl_Balance,
    FlexEdCtrl_BalanceError: FlexEdCtrl_BalanceError,
    FlexEdCtrl_Date: FlexEdCtrl_Date,
    FlexEdCtrl_Description: FlexEdCtrl_Description,
    FlexEdCtrl_ErrorRetrieving: FlexEdCtrl_ErrorRetrieving,
    FlexEdCtrl_FlexEdTitle: FlexEdCtrl_FlexEdTitle,
    FlexEdCtrl_FlexEdTransactionsTitle: FlexEdCtrl_FlexEdTransactionsTitle,
    FlexEdCtrl_UpdateCardInfo: FlexEdCtrl_UpdateCardInfo,
    flexEdModal_AllFieldsRequiredError: flexEdModal_AllFieldsRequiredError,
    flexEdModal_Close: flexEdModal_Close,
    flexEdModal_ConnectCardButton: flexEdModal_ConnectCardButton,
    flexEdModal_ContactYourAdminMessage: flexEdModal_ContactYourAdminMessage,
    flexEdModal_FirstName: flexEdModal_FirstName,
    flexEdModal_InvalidNumberError: flexEdModal_InvalidNumberError,
    flexEdModal_LastFour: flexEdModal_LastFour,
    flexEdModal_LastName: flexEdModal_LastName,
    flexEdModal_LinkYourFlexEdCard: flexEdModal_LinkYourFlexEdCard,
    flexEdModal_MultipleCardsError: flexEdModal_MultipleCardsError,
    flexEdModal_NameDoesNotMatchCardError: flexEdModal_NameDoesNotMatchCardError,
    flexEdModal_NameOnCard: flexEdModal_NameOnCard,
    flexEdModal_SavedNewInformation: flexEdModal_SavedNewInformation,
    flexEdModal_SaveInfoButton: flexEdModal_SaveInfoButton,
    flexEdModal_SuccessfullyConnected: flexEdModal_SuccessfullyConnected,
    flexEdModal_ViewMyFlexEd: flexEdModal_ViewMyFlexEd,
    flexEdModal_ViewYourExpenditures: flexEdModal_ViewYourExpenditures,
    FlexEdSvc_FlexEdError: FlexEdSvc_FlexEdError,
    FlexSvc_AddItems: FlexSvc_AddItems,
    FlexSvc_AddLinkTextsDescription: FlexSvc_AddLinkTextsDescription,
    FlexSvc_AddResources: FlexSvc_AddResources,
    FlexSvc_CombinedResources: FlexSvc_CombinedResources,
    FlexSvc_FreeformTextDescription: FlexSvc_FreeformTextDescription,
    FlexSvc_MixedResources: FlexSvc_MixedResources,
    FlexSvc_MixedResourcesDescription: FlexSvc_MixedResourcesDescription,
    FlexSvc_OpportunitiesDescription: FlexSvc_OpportunitiesDescription,
    FlexSvc_TextAndImage: FlexSvc_TextAndImage,
    FollowingSvc_Continue: FollowingSvc_Continue,
    FollowingSvc_FollowerCountsError: FollowingSvc_FollowerCountsError,
    FollowingSvc_FollowerInfoError: FollowingSvc_FollowerInfoError,
    FollowingSvc_FollowError: FollowingSvc_FollowError,
    FollowingSvc_FollowNotification: FollowingSvc_FollowNotification,
    FollowingSvc_FollowNotificationFormat: FollowingSvc_FollowNotificationFormat,
    FollowingSvc_FollowUserNotification: FollowingSvc_FollowUserNotification,
    FollowingSvc_InteralFollowError: FollowingSvc_InteralFollowError,
    FollowingSvc_InternalRetrievalError: FollowingSvc_InternalRetrievalError,
    FollowingSvc_UnfollowError: FollowingSvc_UnfollowError,
    FollowingSvc_UnfollowNotificationFormat: FollowingSvc_UnfollowNotificationFormat,
    followTargetForm_GroupHeader: followTargetForm_GroupHeader,
    followTargetForm_GroupHeaderSingular: followTargetForm_GroupHeaderSingular,
    followTargetForm_Instructions: followTargetForm_Instructions,
    followTargetForm_NoResources: followTargetForm_NoResources,
    followTargetForm_PathwayHeader: followTargetForm_PathwayHeader,
    followTargetForm_PathwayHeaderSingular: followTargetForm_PathwayHeaderSingular,
    followTargetForm_selectTitleFormat: followTargetForm_selectTitleFormat,
    followTargetForm_Submit: followTargetForm_Submit,
    followTargetForm_TagHeader: followTargetForm_TagHeader,
    followTargetForm_TagHeaderSingular: followTargetForm_TagHeaderSingular,
    followTargetForm_TargetHeader: followTargetForm_TargetHeader,
    followTargetForm_TargetHeaderSingular: followTargetForm_TargetHeaderSingular,
    followTargetForm_Title: followTargetForm_Title,
    followTargetForm_UserHeader: followTargetForm_UserHeader,
    followTargetForm_UserHeaderSingular: followTargetForm_UserHeaderSingular,
    forgotPasswordForm_EmailLabel: forgotPasswordForm_EmailLabel,
    forgotPasswordForm_EmailPlaceholder: forgotPasswordForm_EmailPlaceholder,
    forgotPasswordForm_InvalidEmail: forgotPasswordForm_InvalidEmail,
    forgotPasswordForm_Message: forgotPasswordForm_Message,
    forgotPasswordForm_Success: forgotPasswordForm_Success,
    forgotPasswordForm_SuccessMessage: forgotPasswordForm_SuccessMessage,
    forgotPasswordForm_Title: forgotPasswordForm_Title,
    "global.navigation.admin.brand": "Logo Degreed",
    "global.navigation.admin.features.admin": "Admin",
    "global.navigation.admin.features.beta": "B\xeata",
    "global.navigation.admin.features.footer-branding": "Par",
    "global.navigation.admin.features.show-learner-view": "Afficher la vue apprenant",
    "global.navigation.admin.features.sidebar-branding": "Par",
    "global.navigation.admin.sidebar.automations": "Automatisations",
    "global.navigation.admin.sidebar.catalog": "Catalogue",
    "global.navigation.admin.sidebar.catalog.academies": "Acad\xe9mies",
    "global.navigation.admin.sidebar.catalog.content": "Contenus",
    "global.navigation.admin.sidebar.catalog.pathways": "Parcours",
    "global.navigation.admin.sidebar.catalog.plans": "Plans",
    "global.navigation.admin.sidebar.content-marketplace": "Marketplace de contenus",
    "global.navigation.admin.sidebar.dashboard": "Statistiques",
    "global.navigation.admin.sidebar.dashboard.learning": "Formations",
    "global.navigation.admin.sidebar.dashboard.skills": "Comp\xe9tences",
    "global.navigation.admin.sidebar.extended-enterprise": "Extended Enterprise",
    "global.navigation.admin.sidebar.help": "Aide",
    "global.navigation.admin.sidebar.help.cookie-notice": "Avis sur les cookies",
    "global.navigation.admin.sidebar.help.faq": "FAQ",
    "global.navigation.admin.sidebar.help.knowledge-center": "Centre de connaissances",
    "global.navigation.admin.sidebar.help.privacy-policy": "Politique de confidentialit\xe9",
    "global.navigation.admin.sidebar.integrations": "Int\xe9grations",
    "global.navigation.admin.sidebar.integrations.api-keys": "Cl\xe9s API",
    "global.navigation.admin.sidebar.integrations.connected": "Connect\xe9",
    "global.navigation.admin.sidebar.integrations.directory": "R\xe9pertoire",
    "global.navigation.admin.sidebar.integrations.file-log": "Journal",
    "global.navigation.admin.sidebar.integrations.file-upload": "Chargement de fichier",
    "global.navigation.admin.sidebar.people": "Personnes",
    "global.navigation.admin.sidebar.people.groups": "Groupes",
    "global.navigation.admin.sidebar.people.permissions": "Autorisations",
    "global.navigation.admin.sidebar.people.segments": "Segments",
    "global.navigation.admin.sidebar.people.user-attributes": "Attributs utilisateurs",
    "global.navigation.admin.sidebar.people.users": "Utilisateurs",
    "global.navigation.admin.sidebar.reporting": "Rapports",
    "global.navigation.admin.sidebar.reporting.advanced-analytics": "Advanced Analytics",
    "global.navigation.admin.sidebar.reporting.categories": "Cat\xe9gories",
    "global.navigation.admin.sidebar.reporting.configurations": "Configurations",
    "global.navigation.admin.sidebar.reporting.ftp": "Cat\xe9gories",
    "global.navigation.admin.sidebar.reporting.presets": "Pr\xe9r\xe9glages",
    "global.navigation.admin.sidebar.reporting.reports": "Rapports",
    "global.navigation.admin.sidebar.reporting.segments": "Segments",
    "global.navigation.admin.sidebar.settings": "Param\xe8tres",
    "global.navigation.admin.sidebar.settings.branding": "Image de marque",
    "global.navigation.admin.sidebar.settings.communication": "Communication",
    "global.navigation.admin.sidebar.settings.faq": "FAQ",
    "global.navigation.admin.sidebar.settings.help-menu": "Menu d’aide",
    "global.navigation.admin.sidebar.settings.home": "Accueil",
    "global.navigation.admin.sidebar.settings.messaging": "Messages",
    "global.navigation.admin.sidebar.skills": "Comp\xe9tences",
    "global.navigation.admin.sidebar.skills.dashboard": "Tableau de bord",
    "global.navigation.admin.sidebar.skills.inventory": "Inventaire",
    "global.navigation.admin.sidebar.skills.roles": "Postes",
    "global.navigation.admin.sidebar.skills.scales": "\xc9chelles",
    "global.navigation.admin.sidebar.skills.settings": "Param\xe8tres",
    "global.navigation.admin.sidebar.skills.skill-standards": "Normes de comp\xe9tences",
    "global.navigation.learner.brand": "Logo Degreed",
    "global.navigation.learner.features.add-content": "Ajouter du contenu",
    "global.navigation.learner.features.add-to-profile": "Ajouter au profil",
    "global.navigation.learner.features.beta": "B\xeata",
    "global.navigation.learner.features.footer-branding": "Par",
    "global.navigation.learner.features.search": "Recherche",
    "global.navigation.learner.features.show-admin-view": "Afficher la vue administrateur",
    "global.navigation.learner.features.sidebar-branding": "Par",
    "global.navigation.learner.sidebar.assistant": "Assistant",
    "global.navigation.learner.sidebar.discover": "D\xe9couvrir",
    "global.navigation.learner.sidebar.featured": "\xc0 la une",
    "global.navigation.learner.sidebar.help": "Aide",
    "global.navigation.learner.sidebar.help.cookie-notice": "Avis sur les cookies",
    "global.navigation.learner.sidebar.help.faq": "FAQ",
    "global.navigation.learner.sidebar.help.knowledge-center": "Centre de connaissances",
    "global.navigation.learner.sidebar.help.privacy-policy": "Politique de confidentialit\xe9",
    "global.navigation.learner.sidebar.home": "Accueil",
    "global.navigation.learner.sidebar.home.assignments": "Formations assign\xe9es",
    "global.navigation.learner.sidebar.home.groups": "Groupes",
    "global.navigation.learner.sidebar.home.my-learning": "Mes formations",
    "global.navigation.learner.sidebar.home.pathways": "Parcours",
    "global.navigation.learner.sidebar.home.plans": "Plans",
    "global.navigation.learner.sidebar.home.saved": "Contenus enregistr\xe9s",
    "global.navigation.learner.sidebar.home.shared": "Contenus partag\xe9s",
    "global.navigation.learner.sidebar.notifications": "Notifications",
    "global.navigation.learner.sidebar.opportunities": "Opportunit\xe9s",
    "global.navigation.learner.sidebar.opportunities.browse": "Parcourir",
    "global.navigation.learner.sidebar.opportunities.engagement-insights": "Statistiques d’engagement",
    "global.navigation.learner.sidebar.opportunities.marketplace": "Marketplace",
    "global.navigation.learner.sidebar.opportunities.mentoring": "Mentorat",
    "global.navigation.learner.sidebar.opportunities.open-insights": "Statistiques d’ouvertures",
    "global.navigation.learner.sidebar.profile": "Profil",
    "global.navigation.learner.sidebar.profile.activity": "Activit\xe9",
    "global.navigation.learner.sidebar.profile.collection": "Collection",
    "global.navigation.learner.sidebar.profile.flex-ed": "FlexED",
    "global.navigation.learner.sidebar.profile.logout": "Se d\xe9connecter",
    "global.navigation.learner.sidebar.profile.my-plan": "Mon plan",
    "global.navigation.learner.sidebar.profile.overview": "Vue d’ensemble",
    "global.navigation.learner.sidebar.profile.settings": "Param\xe8tres",
    "global.navigation.learner.sidebar.profile.skills": "Comp\xe9tences",
    "global.navigation.learner.sidebar.skill-coach": "Skill Coach",
    "global.navigation.learner.sidebar.skill-coach.members": "Membres",
    "global.navigation.learner.sidebar.skill-coach.team-learning-insights": "Statistiques d’apprentissage",
    "global.navigation.learner.sidebar.skill-coach.team-skill-insights": "Statistiques de comp\xe9tences",
    "global.navigation.learner.sidebar.skill-coach.team-skills": "Comp\xe9tences de l’\xe9quipe",
    GoalFormSvc_ByThisDate: GoalFormSvc_ByThisDate,
    GoalFormSvc_CompleteThisFormat: GoalFormSvc_CompleteThisFormat,
    GoalFormSvc_CreateGoal: GoalFormSvc_CreateGoal,
    GoalFormSvc_CreateGroupGoal: GoalFormSvc_CreateGroupGoal,
    GoalFormSvc_DeleteGoal: GoalFormSvc_DeleteGoal,
    GoalFormSvc_EarnPoints: GoalFormSvc_EarnPoints,
    GoalFormSvc_EarnPointsMessage: GoalFormSvc_EarnPointsMessage,
    GoalFormSvc_EditGoal: GoalFormSvc_EditGoal,
    GoalFormSvc_GroupGoalProgress: GoalFormSvc_GroupGoalProgress,
    GoalFormSvc_GroupTooltip: GoalFormSvc_GroupTooltip,
    GoalFormSvc_InThisCategory: GoalFormSvc_InThisCategory,
    GoalFormSvc_ItemAddedFormat: GoalFormSvc_ItemAddedFormat,
    GoalFormSvc_JustMe: GoalFormSvc_JustMe,
    GoalFormSvc_NumberOfPoints: GoalFormSvc_NumberOfPoints,
    GoalFormSvc_WhichGroupsTitle: GoalFormSvc_WhichGroupsTitle,
    GroupContextSvc_ErrorNotification: GroupContextSvc_ErrorNotification,
    GroupCtrl_EmptyStateDescription: GroupCtrl_EmptyStateDescription,
    GroupCtrl_EmptyStateTitle: GroupCtrl_EmptyStateTitle,
    GroupCtrl_GroupRemovalWarning: GroupCtrl_GroupRemovalWarning,
    GroupCtrl_LeaveGroupHeader: GroupCtrl_LeaveGroupHeader,
    GroupCtrl_LeaveGroupSummary: GroupCtrl_LeaveGroupSummary,
    GroupCtrl_MemberRemovedSuccessfully: GroupCtrl_MemberRemovedSuccessfully,
    GroupCtrl_MyTeam: GroupCtrl_MyTeam,
    GroupCtrl_RemoveFromGroup: GroupCtrl_RemoveFromGroup,
    GroupCtrl_SetAsPrimary: GroupCtrl_SetAsPrimary,
    GroupCtrl_UnsetAsPrimary: GroupCtrl_UnsetAsPrimary,
    GroupDeleteCtrl_DeleteGroupConfirm: GroupDeleteCtrl_DeleteGroupConfirm,
    GroupDeleteCtrl_DeleteGroupError: GroupDeleteCtrl_DeleteGroupError,
    GroupDeleteCtrl_DeleteGroupInfoDescription: GroupDeleteCtrl_DeleteGroupInfoDescription,
    GroupDeleteCtrl_DeleteGroupSuccess: GroupDeleteCtrl_DeleteGroupSuccess,
    GroupFormSvc_ConfirmRemoval: GroupFormSvc_ConfirmRemoval,
    GroupFormSvc_ConfirmRemovalMessage: GroupFormSvc_ConfirmRemovalMessage,
    GroupFormSvc_EditUserSettings: GroupFormSvc_EditUserSettings,
    GroupFormSvc_History: GroupFormSvc_History,
    GroupFormSvc_MemberRequestDateFormat: GroupFormSvc_MemberRequestDateFormat,
    GroupFormSvc_MemberSinceFormat: GroupFormSvc_MemberSinceFormat,
    GroupFormSvc_PendingMember: GroupFormSvc_PendingMember,
    GroupFormSvc_RemoveFromGroup: GroupFormSvc_RemoveFromGroup,
    GroupFormSvc_Removing: GroupFormSvc_Removing,
    GroupFormSvc_Role: GroupFormSvc_Role,
    GroupFormSvc_RolePermissions: GroupFormSvc_RolePermissions,
    GroupFormSvc_TopCategories: GroupFormSvc_TopCategories,
    GroupInsightsCtrl_All: GroupInsightsCtrl_All,
    GroupInsightsCtrl_GroupCategories: GroupInsightsCtrl_GroupCategories,
    GroupInsightsCtrl_Month: GroupInsightsCtrl_Month,
    GroupInsightsCtrl_Week: GroupInsightsCtrl_Week,
    GroupInsightsCtrl_Year: GroupInsightsCtrl_Year,
    groupInviteAccepted_PluralFormat: groupInviteAccepted_PluralFormat,
    groupInviteAccepted_SingleFormat: groupInviteAccepted_SingleFormat,
    GroupInviteCtrl_AddPeopleToGroup: GroupInviteCtrl_AddPeopleToGroup,
    GroupInviteCtrl_InviteEmailInstructions: GroupInviteCtrl_InviteEmailInstructions,
    GroupInviteCtrl_InviteLinkInstructions: GroupInviteCtrl_InviteLinkInstructions,
    GroupInviteCtrl_InvitePeople: GroupInviteCtrl_InvitePeople,
    GroupInviteCtrl_SearchByName: GroupInviteCtrl_SearchByName,
    GroupInviteCtrl_SendInviteTo: GroupInviteCtrl_SendInviteTo,
    GroupMemberFormCtrl_UpdateMemberRoleFormat: GroupMemberFormCtrl_UpdateMemberRoleFormat,
    GroupMembersCtrl_AnyTime: GroupMembersCtrl_AnyTime,
    GroupMembersCtrl_ApproveInvite: GroupMembersCtrl_ApproveInvite,
    GroupMembersCtrl_DateJoined: GroupMembersCtrl_DateJoined,
    GroupMembersCtrl_DateRequestsOrInvited: GroupMembersCtrl_DateRequestsOrInvited,
    GroupMembersCtrl_DeclineInvite: GroupMembersCtrl_DeclineInvite,
    GroupMembersCtrl_EditUserSettings: GroupMembersCtrl_EditUserSettings,
    GroupMembersCtrl_ErrorNotification: GroupMembersCtrl_ErrorNotification,
    GroupMembersCtrl_FocusSkills: GroupMembersCtrl_FocusSkills,
    GroupMembersCtrl_JobTitle: GroupMembersCtrl_JobTitle,
    GroupMembersCtrl_LastActive: GroupMembersCtrl_LastActive,
    GroupMembersCtrl_LastXDaysFormat: GroupMembersCtrl_LastXDaysFormat,
    GroupMembersCtrl_MembershipSource: GroupMembersCtrl_MembershipSource,
    GroupMembersCtrl_MembershipSource_AnalyticsPipeline: GroupMembersCtrl_MembershipSource_AnalyticsPipeline,
    GroupMembersCtrl_MembershipSource_BusinessRulesAPI: GroupMembersCtrl_MembershipSource_BusinessRulesAPI,
    GroupMembersCtrl_MembershipSource_BusinessRulesFtp: GroupMembersCtrl_MembershipSource_BusinessRulesFtp,
    GroupMembersCtrl_MembershipSource_ClientUserFile: GroupMembersCtrl_MembershipSource_ClientUserFile,
    GroupMembersCtrl_MembershipSource_ScheduledAutomation: GroupMembersCtrl_MembershipSource_ScheduledAutomation,
    GroupMembersCtrl_MembershipSource_UserAttributeFile: GroupMembersCtrl_MembershipSource_UserAttributeFile,
    GroupMembersCtrl_MembershipSource_v2API: GroupMembersCtrl_MembershipSource_v2API,
    GroupMembersCtrl_MembershipSource_Web: GroupMembersCtrl_MembershipSource_Web,
    GroupMembersCtrl_Name: GroupMembersCtrl_Name,
    GroupMembersCtrl_Of: GroupMembersCtrl_Of,
    GroupMembersCtrl_Points: GroupMembersCtrl_Points,
    GroupMembersCtrl_RatedJobSkills: GroupMembersCtrl_RatedJobSkills,
    GroupMembersCtrl_Remove: GroupMembersCtrl_Remove,
    GroupMembersCtrl_ResendInvite: GroupMembersCtrl_ResendInvite,
    GroupMembersCtrl_Results: GroupMembersCtrl_Results,
    GroupMembersCtrl_ResultsPerPage: GroupMembersCtrl_ResultsPerPage,
    GroupMembersCtrl_SendEmail: GroupMembersCtrl_SendEmail,
    GroupMembersCtrl_SetToAdmin: GroupMembersCtrl_SetToAdmin,
    GroupMembersCtrl_SetToMember: GroupMembersCtrl_SetToMember,
    GroupMembersCtrl_ViewPendingMembers: GroupMembersCtrl_ViewPendingMembers,
    groupPostAdded_Format: groupPostAdded_Format,
    groupPostAdded_GroupFormat: groupPostAdded_GroupFormat,
    groupPostAdded_SingleFormat: groupPostAdded_SingleFormat,
    GroupsController_About: GroupsController_About,
    GroupsController_BecomeAMember: GroupsController_BecomeAMember,
    GroupsController_ClickRequestMembership: GroupsController_ClickRequestMembership,
    GroupsController_ClickToJoin: GroupsController_ClickToJoin,
    GroupsController_Feed: GroupsController_Feed,
    GroupsController_GroupMembershipPending: GroupsController_GroupMembershipPending,
    GroupsController_GroupPostVisibility: GroupsController_GroupPostVisibility,
    GroupsController_GroupSettingsTitle: GroupsController_GroupSettingsTitle,
    GroupsController_Insights: GroupsController_Insights,
    GroupsController_Joining: GroupsController_Joining,
    GroupsController_Members: GroupsController_Members,
    GroupsController_RequestedMembershipOne: GroupsController_RequestedMembershipOne,
    GroupsController_RequestedMembershipTwo: GroupsController_RequestedMembershipTwo,
    GroupsController_RequestMembership: GroupsController_RequestMembership,
    GroupsController_Settings: GroupsController_Settings,
    GroupSecurityCtrl_UpdateRolesSuccess: GroupSecurityCtrl_UpdateRolesSuccess,
    GroupSettingsCtrl_AdministrativeGroup: GroupSettingsCtrl_AdministrativeGroup,
    GroupSettingsCtrl_AdministrativeNewTip: GroupSettingsCtrl_AdministrativeNewTip,
    GroupSettingsCtrl_AdministrativeTip: GroupSettingsCtrl_AdministrativeTip,
    GroupSettingsCtrl_ClosedGroup: GroupSettingsCtrl_ClosedGroup,
    GroupSettingsCtrl_ClosedNewTip: GroupSettingsCtrl_ClosedNewTip,
    GroupSettingsCtrl_ClosedTip: GroupSettingsCtrl_ClosedTip,
    GroupSettingsCtrl_CreateBulkGroups: GroupSettingsCtrl_CreateBulkGroups,
    GroupSettingsCtrl_CustomTooltip: GroupSettingsCtrl_CustomTooltip,
    GroupSettingsCtrl_Description: GroupSettingsCtrl_Description,
    GroupSettingsCtrl_DuplicateName: GroupSettingsCtrl_DuplicateName,
    GroupSettingsCtrl_DynamicMembership: GroupSettingsCtrl_DynamicMembership,
    GroupSettingsCtrl_DynamicMembership_Info: GroupSettingsCtrl_DynamicMembership_Info,
    GroupSettingsCtrl_DynamicMembership_Instructions: GroupSettingsCtrl_DynamicMembership_Instructions,
    GroupSettingsCtrl_EnableOpportunities: GroupSettingsCtrl_EnableOpportunities,
    GroupSettingsCtrl_GroupAddedSuccess: GroupSettingsCtrl_GroupAddedSuccess,
    GroupSettingsCtrl_GroupName: GroupSettingsCtrl_GroupName,
    GroupSettingsCtrl_GroupNameFormat: GroupSettingsCtrl_GroupNameFormat,
    GroupSettingsCtrl_GroupUpdatePrivacySuccess: GroupSettingsCtrl_GroupUpdatePrivacySuccess,
    GroupSettingsCtrl_GroupUpdateSuccess: GroupSettingsCtrl_GroupUpdateSuccess,
    GroupSettingsCtrl_NameExists: GroupSettingsCtrl_NameExists,
    GroupSettingsCtrl_OpenGroup: GroupSettingsCtrl_OpenGroup,
    GroupSettingsCtrl_OpenNewTip: GroupSettingsCtrl_OpenNewTip,
    GroupSettingsCtrl_OpenTip: GroupSettingsCtrl_OpenTip,
    GroupSettingsCtrl_PrivacySettings: GroupSettingsCtrl_PrivacySettings,
    GroupSettingsCtrl_PrivateGroup: GroupSettingsCtrl_PrivateGroup,
    GroupSettingsCtrl_PrivateNewTip: GroupSettingsCtrl_PrivateNewTip,
    GroupSettingsCtrl_PrivateTip: GroupSettingsCtrl_PrivateTip,
    GroupSettingsCtrl_ProblemWithGroups: GroupSettingsCtrl_ProblemWithGroups,
    GroupSettingsCtrl_SaveGroup: GroupSettingsCtrl_SaveGroup,
    GroupSettingsCtrl_SpecifyCategory: GroupSettingsCtrl_SpecifyCategory,
    GroupSettingsCtrl_SpecifyDescription: GroupSettingsCtrl_SpecifyDescription,
    GroupSettingsCtrl_SpecifyName: GroupSettingsCtrl_SpecifyName,
    GroupSvc_BulkDeleteError: GroupSvc_BulkDeleteError,
    GroupSvc_BulkDeleteGroupsSuccess: GroupSvc_BulkDeleteGroupsSuccess,
    GroupSvc_ErrorNotification: GroupSvc_ErrorNotification,
    GroupSvc_GroupInvitesNotification: GroupSvc_GroupInvitesNotification,
    GroupSvc_GroupInvitesNotificationError: GroupSvc_GroupInvitesNotificationError,
    GroupSvc_GroupJoinNotification: GroupSvc_GroupJoinNotification,
    GroupSvc_GroupLeaveNotification: GroupSvc_GroupLeaveNotification,
    GroupSvc_GroupMembershipNotification: GroupSvc_GroupMembershipNotification,
    GroupSvc_GroupSettingsTitle: GroupSvc_GroupSettingsTitle,
    ImageEditSvc_ImagedUpdated: ImageEditSvc_ImagedUpdated,
    ImageEditSvc_ImageUploadError: ImageEditSvc_ImageUploadError,
    ImageEditSvc_ImageUploadTooBig: ImageEditSvc_ImageUploadTooBig,
    ImageEditSvc_OpenBadgeParseError: ImageEditSvc_OpenBadgeParseError,
    inappropriateModalContent_Instructions: inappropriateModalContent_Instructions,
    inappropriateModalContent_Reason: inappropriateModalContent_Reason,
    inappropriateModalContent_ReasonValidationError: inappropriateModalContent_ReasonValidationError,
    inappropriateModalContent_Title: inappropriateModalContent_Title,
    InputCard_PreviewInputFormat: InputCard_PreviewInputFormat,
    InputRatingsSvc_ErrorNotification: InputRatingsSvc_ErrorNotification,
    InputRatingsSvc_SavedCompleteSuccess: InputRatingsSvc_SavedCompleteSuccess,
    InputRatingsSvc_SaveRatingError: InputRatingsSvc_SaveRatingError,
    InputRatingsSvc_SaveRatingSuccess: InputRatingsSvc_SaveRatingSuccess,
    InputsController_AssessmentUnavailable: InputsController_AssessmentUnavailable,
    InputsController_Average: InputsController_Average,
    InputsController_FriendlyErrorMessage: InputsController_FriendlyErrorMessage,
    InputsController_From: InputsController_From,
    InputsController_Login: InputsController_Login,
    InputsController_NoRatings: InputsController_NoRatings,
    InputsController_S: InputsController_S,
    InputsController_Signup: InputsController_Signup,
    InputsController_User: InputsController_User,
    InputsController_YourRating: InputsController_YourRating,
    InputSessionForm_Address: InputSessionForm_Address,
    InputSessionForm_AddSessionDetails: InputSessionForm_AddSessionDetails,
    InputSessionForm_BasicInformation: InputSessionForm_BasicInformation,
    InputSessionForm_DateTime: InputSessionForm_DateTime,
    InputSessionForm_DateTimeNew: InputSessionForm_DateTimeNew,
    InputSessionForm_DeletionAlert: InputSessionForm_DeletionAlert,
    InputSessionForm_DifferentUrl: InputSessionForm_DifferentUrl,
    InputSessionForm_EndTime: InputSessionForm_EndTime,
    InputSessionForm_EventEnds: InputSessionForm_EventEnds,
    InputSessionForm_EventStarts: InputSessionForm_EventStarts,
    InputSessionForm_EventStreamLinkLabel: InputSessionForm_EventStreamLinkLabel,
    InputSessionForm_EventStreamLinkPlaceholder: InputSessionForm_EventStreamLinkPlaceholder,
    InputSessionForm_EventTimeZone: InputSessionForm_EventTimeZone,
    InputSessionForm_InPerson: InputSessionForm_InPerson,
    InputSessionForm_IntegratedDetailsNotEditable: InputSessionForm_IntegratedDetailsNotEditable,
    InputSessionForm_InvalidDate: InputSessionForm_InvalidDate,
    InputSessionForm_InvalidTime: InputSessionForm_InvalidTime,
    InputSessionForm_InvalidTimeNew: InputSessionForm_InvalidTimeNew,
    InputSessionForm_LocationType: InputSessionForm_LocationType,
    InputSessionForm_LocationUrl: InputSessionForm_LocationUrl,
    InputSessionForm_LocationUrl_Placeholder: InputSessionForm_LocationUrl_Placeholder,
    InputSessionForm_LocationUrlDescription: InputSessionForm_LocationUrlDescription,
    InputSessionForm_Online: InputSessionForm_Online,
    InputSessionForm_PhysicalLocation: InputSessionForm_PhysicalLocation,
    InputSessionForm_Registration: InputSessionForm_Registration,
    InputSessionForm_RegistrationAvailable: InputSessionForm_RegistrationAvailable,
    InputSessionForm_RegistrationAvailableNew: InputSessionForm_RegistrationAvailableNew,
    InputSessionForm_RegistrationUrl: InputSessionForm_RegistrationUrl,
    InputSessionForm_SameUrl: InputSessionForm_SameUrl,
    InputSessionForm_SameUrlNew: InputSessionForm_SameUrlNew,
    InputSessionForm_SearchAddress: InputSessionForm_SearchAddress,
    InputSessionForm_StartTime: InputSessionForm_StartTime,
    InputSessionForm_Timezone: InputSessionForm_Timezone,
    InputsSvc_AddItemError: InputsSvc_AddItemError,
    InputsSvc_CompletedError: InputsSvc_CompletedError,
    InputsSvc_CompletedSuccess: InputsSvc_CompletedSuccess,
    InputsSvc_DismissSuggestedError: InputsSvc_DismissSuggestedError,
    InputsSvc_DismissSuggestedSuccess: InputsSvc_DismissSuggestedSuccess,
    InputsSvc_EditContentDuplicateError: InputsSvc_EditContentDuplicateError,
    InputsSvc_GeneralError: InputsSvc_GeneralError,
    InputsSvc_GetAssessmentError: InputsSvc_GetAssessmentError,
    InputsSvc_GetBookError: InputsSvc_GetBookError,
    InputsSvc_GetCourseError: InputsSvc_GetCourseError,
    InputsSvc_GetCourseMetadataError: InputsSvc_GetCourseMetadataError,
    InputsSvc_GetEpisodeError: InputsSvc_GetEpisodeError,
    InputsSvc_GetEventError: InputsSvc_GetEventError,
    InputsSvc_GetMediaError: InputsSvc_GetMediaError,
    InputsSvc_GetMediaMetadataError: InputsSvc_GetMediaMetadataError,
    InputsSvc_GetSuggestedError: InputsSvc_GetSuggestedError,
    InputsSvc_GetUserError: InputsSvc_GetUserError,
    InputsSvc_PeopleCompleted: InputsSvc_PeopleCompleted,
    InputsSvc_PeopleLiked: InputsSvc_PeopleLiked,
    InputsSvc_PeopleShared: InputsSvc_PeopleShared,
    InputsSvc_PersonCompleted: InputsSvc_PersonCompleted,
    InputsSvc_PersonLiked: InputsSvc_PersonLiked,
    InputsSvc_PersonShared: InputsSvc_PersonShared,
    InputsSvc_ProfileDismissed: InputsSvc_ProfileDismissed,
    InputsSvc_QueueError: InputsSvc_QueueError,
    InputsSvc_QueueSuccess: InputsSvc_QueueSuccess,
    InputsSvc_UsersTitle: InputsSvc_UsersTitle,
    InsightsNav_SkillTrends: InsightsNav_SkillTrends,
    Integrations_Add_Type_Completion: Integrations_Add_Type_Completion,
    Integrations_Add_Type_Content: Integrations_Add_Type_Content,
    Integrations_Add_Type_Skill: Integrations_Add_Type_Skill,
    Integrations_Add_Type_SkillAssessment: Integrations_Add_Type_SkillAssessment,
    Integrations_AdvancedSSO: Integrations_AdvancedSSO,
    Integrations_AlisonImportError: Integrations_AlisonImportError,
    Integrations_AlisonPublicProfile: Integrations_AlisonPublicProfile,
    Integrations_AlisonUserId: Integrations_AlisonUserId,
    Integrations_AlisonUserIdUserName: Integrations_AlisonUserIdUserName,
    Integrations_APIKeys: Integrations_APIKeys,
    Integrations_BasicSSO: Integrations_BasicSSO,
    Integrations_ClientId: Integrations_ClientId,
    Integrations_ClientSecret: Integrations_ClientSecret,
    Integrations_CodecademyImportError: Integrations_CodecademyImportError,
    Integrations_CodecademyPublicProfile: Integrations_CodecademyPublicProfile,
    Integrations_CodecademyUsername: Integrations_CodecademyUsername,
    Integrations_CodeSchoolImportError: Integrations_CodeSchoolImportError,
    Integrations_CodeSchoolPublicProfile: Integrations_CodeSchoolPublicProfile,
    Integrations_CodeSchoolUsername: Integrations_CodeSchoolUsername,
    Integrations_ConfigureConnector_CreateAPI: Integrations_ConfigureConnector_CreateAPI,
    Integrations_Connect: Integrations_Connect,
    Integrations_Connected: Integrations_Connected,
    Integrations_ConnectIntegrations: Integrations_ConnectIntegrations,
    Integrations_ConnectorSync_Type_Badge: Integrations_ConnectorSync_Type_Badge,
    Integrations_ConnectorSync_Type_BulkOpportunities: Integrations_ConnectorSync_Type_BulkOpportunities,
    Integrations_ConnectorSync_Type_Completion: Integrations_ConnectorSync_Type_Completion,
    Integrations_ConnectorSync_Type_Content: Integrations_ConnectorSync_Type_Content,
    Integrations_ConnectorSync_Type_Opportunity: Integrations_ConnectorSync_Type_Opportunity,
    Integrations_ConnectorSync_Type_RequiredLearning: Integrations_ConnectorSync_Type_RequiredLearning,
    Integrations_ConnectorSync_Type_Skill: Integrations_ConnectorSync_Type_Skill,
    Integrations_ConnectorSync_Type_SkillAssessment: Integrations_ConnectorSync_Type_SkillAssessment,
    Integrations_ConnectorSyncMustVerify: Integrations_ConnectorSyncMustVerify,
    Integrations_ConnectorSyncNightly: Integrations_ConnectorSyncNightly,
    Integrations_ConsumerSetup: Integrations_ConsumerSetup,
    Integrations_ConsumerSetupMetadata: Integrations_ConsumerSetupMetadata,
    Integrations_ContactYourCEP: Integrations_ContactYourCEP,
    Integrations_ContentProviders: Integrations_ContentProviders,
    Integrations_ContentRemain: Integrations_ContentRemain,
    Integrations_ContentSyncPendingMeta: Integrations_ContentSyncPendingMeta,
    Integrations_ContentVisibility: Integrations_ContentVisibility,
    Integrations_CourseraImportError: Integrations_CourseraImportError,
    Integrations_CourseraPublicProfile: Integrations_CourseraPublicProfile,
    Integrations_CourseraUserId: Integrations_CourseraUserId,
    Integrations_CustomVisitLink: Integrations_CustomVisitLink,
    Integrations_DeleteAnyAssociated: Integrations_DeleteAnyAssociated,
    Integrations_DeleteAnyContent: Integrations_DeleteAnyContent,
    Integrations_DeleteAnyIncomplete: Integrations_DeleteAnyIncomplete,
    Integrations_DISABLE: Integrations_DISABLE,
    Integrations_DisableConnector: Integrations_DisableConnector,
    Integrations_DisableProvider: Integrations_DisableProvider,
    Integrations_DisablingConnectorWill: Integrations_DisablingConnectorWill,
    Integrations_DisablingProviderWill: Integrations_DisablingProviderWill,
    Integrations_Disconnect: Integrations_Disconnect,
    Integrations_Edit_Type_Completion: Integrations_Edit_Type_Completion,
    Integrations_Edit_Type_Content: Integrations_Edit_Type_Content,
    Integrations_Edit_Type_Skill: Integrations_Edit_Type_Skill,
    Integrations_Edit_Type_SkillAssessment: Integrations_Edit_Type_SkillAssessment,
    Integrations_EditGoodreadsProfile: Integrations_EditGoodreadsProfile,
    Integrations_EmailAssertionName: Integrations_EmailAssertionName,
    Integrations_Enable: Integrations_Enable,
    Integrations_EnableSSO: Integrations_EnableSSO,
    Integrations_EnterpriseAccountId: Integrations_EnterpriseAccountId,
    Integrations_EnterpriseSetMetadata: Integrations_EnterpriseSetMetadata,
    Integrations_EnterpriseSetup: Integrations_EnterpriseSetup,
    Integrations_EnterpriseSetupMetadata: Integrations_EnterpriseSetupMetadata,
    Integrations_EverybodyCanSee: Integrations_EverybodyCanSee,
    Integrations_FailedImport: Integrations_FailedImport,
    Integrations_FallbackContentImage: Integrations_FallbackContentImage,
    Integrations_FilterIntegrations: Integrations_FilterIntegrations,
    Integrations_FirstNameAssertionName: Integrations_FirstNameAssertionName,
    Integrations_FreeOneClickSetup: Integrations_FreeOneClickSetup,
    Integrations_GenerateAPIKey: Integrations_GenerateAPIKey,
    Integrations_GenerateAPIKeyProvider: Integrations_GenerateAPIKeyProvider,
    Integrations_GlobalVisibility: Integrations_GlobalVisibility,
    Integrations_GoodreadsImportError: Integrations_GoodreadsImportError,
    Integrations_GoodreadsUsername: Integrations_GoodreadsUsername,
    Integrations_GoodreadsUsernameEdit: Integrations_GoodreadsUsernameEdit,
    Integrations_ImageForProviderCard: Integrations_ImageForProviderCard,
    Integrations_ImageForProviderFavicon: Integrations_ImageForProviderFavicon,
    Integrations_ImageForProviderLogo: Integrations_ImageForProviderLogo,
    Integrations_ImportAlisonCourses: Integrations_ImportAlisonCourses,
    Integrations_ImportAlisonDaily: Integrations_ImportAlisonDaily,
    Integrations_ImportArchivedPocket: Integrations_ImportArchivedPocket,
    Integrations_ImportCodecademyDaily: Integrations_ImportCodecademyDaily,
    Integrations_ImportCodeSchoolDaily: Integrations_ImportCodeSchoolDaily,
    Integrations_ImportCompletedCodecademy: Integrations_ImportCompletedCodecademy,
    Integrations_ImportCompletedCodeSchool: Integrations_ImportCompletedCodeSchool,
    Integrations_ImportCompletedKhanAcademy: Integrations_ImportCompletedKhanAcademy,
    Integrations_ImportCompletedPluralsight: Integrations_ImportCompletedPluralsight,
    Integrations_ImportCompletedSkillshare: Integrations_ImportCompletedSkillshare,
    Integrations_ImportCompletedTreehouse: Integrations_ImportCompletedTreehouse,
    Integrations_ImportCompletedUdemy: Integrations_ImportCompletedUdemy,
    Integrations_ImportCourseraCourses: Integrations_ImportCourseraCourses,
    Integrations_ImportCourseraDaily: Integrations_ImportCourseraDaily,
    Integrations_ImportGoodreadsDaily: Integrations_ImportGoodreadsDaily,
    Integrations_ImportKhanAcademyDaily: Integrations_ImportKhanAcademyDaily,
    Integrations_ImportNow: Integrations_ImportNow,
    Integrations_ImportPluralsightDaily: Integrations_ImportPluralsightDaily,
    Integrations_ImportPocketDaily: Integrations_ImportPocketDaily,
    Integrations_ImportReadabilityDaily: Integrations_ImportReadabilityDaily,
    Integrations_ImportReadArticlesReadability: Integrations_ImportReadArticlesReadability,
    Integrations_ImportReadGoodreads: Integrations_ImportReadGoodreads,
    Integrations_ImportSkillshareDaily: Integrations_ImportSkillshareDaily,
    Integrations_ImportTreehouseDaily: Integrations_ImportTreehouseDaily,
    Integrations_ImportUdemyDaily: Integrations_ImportUdemyDaily,
    Integrations_IntegrationsDirectory: Integrations_IntegrationsDirectory,
    Integrations_KhanAcademyContentFree: Integrations_KhanAcademyContentFree,
    Integrations_KhanAcademyImportError: Integrations_KhanAcademyImportError,
    Integrations_KhanAcademyUsername: Integrations_KhanAcademyUsername,
    Integrations_LastImported: Integrations_LastImported,
    Integrations_LastNameAssertionName: Integrations_LastNameAssertionName,
    Integrations_LastSyncDate: Integrations_LastSyncDate,
    Integrations_LimitedVisibility: Integrations_LimitedVisibility,
    Integrations_Linkedin: Integrations_Linkedin,
    Integrations_Never: Integrations_Never,
    Integrations_Note: Integrations_Note,
    Integrations_NoteForPNG: Integrations_NoteForPNG,
    Integrations_NoteForSVG: Integrations_NoteForSVG,
    Integrations_OnlyShowIfLicense: Integrations_OnlyShowIfLicense,
    Integrations_Or: Integrations_Or,
    Integrations_OrgId: Integrations_OrgId,
    Integrations_PaidOneClick: Integrations_PaidOneClick,
    Integrations_PaidOneClickSetup: Integrations_PaidOneClickSetup,
    Integrations_PluralsightImportError: Integrations_PluralsightImportError,
    Integrations_PluralsightPublicProfile: Integrations_PluralsightPublicProfile,
    Integrations_PluralsightUsername: Integrations_PluralsightUsername,
    Integrations_PocketImportError: Integrations_PocketImportError,
    Integrations_PocketUsername: Integrations_PocketUsername,
    Integrations_PortalId: Integrations_PortalId,
    Integrations_PortalName: Integrations_PortalName,
    Integrations_PromptForLicense: Integrations_PromptForLicense,
    Integrations_ProviderAssertionConsumerService: Integrations_ProviderAssertionConsumerService,
    Integrations_ProviderEntityID: Integrations_ProviderEntityID,
    Integrations_ProviderLogo: Integrations_ProviderLogo,
    Integrations_ReadabilityImportError: Integrations_ReadabilityImportError,
    Integrations_ReadabilityUsername: Integrations_ReadabilityUsername,
    Integrations_RecommendGoogleplus: Integrations_RecommendGoogleplus,
    Integrations_RecommendLinkedin: Integrations_RecommendLinkedin,
    Integrations_RecommendTwitter: Integrations_RecommendTwitter,
    Integrations_SaveIntegrations: Integrations_SaveIntegrations,
    Integrations_ShouldDisableConnector: Integrations_ShouldDisableConnector,
    Integrations_ShouldDisableIntegration: Integrations_ShouldDisableIntegration,
    Integrations_ShowConnectedOnly: Integrations_ShowConnectedOnly,
    Integrations_SignSAMLAssertion: Integrations_SignSAMLAssertion,
    Integrations_SignSAMLResponse: Integrations_SignSAMLResponse,
    Integrations_SkillshareImportError: Integrations_SkillshareImportError,
    Integrations_SkillshareIserId: Integrations_SkillshareIserId,
    Integrations_SkillshareProfileRequired: Integrations_SkillshareProfileRequired,
    Integrations_SkillshareUserName: Integrations_SkillshareUserName,
    Integrations_SkillshareUserNameId: Integrations_SkillshareUserNameId,
    Integrations_SlackDescription: Integrations_SlackDescription,
    Integrations_SlackDescriptionConsumer: Integrations_SlackDescriptionConsumer,
    Integrations_SlackTodaysLearningTitle: Integrations_SlackTodaysLearningTitle,
    Integrations_SlackTodaysLearningTitleFormat: Integrations_SlackTodaysLearningTitleFormat,
    Integrations_SocialAccounts: Integrations_SocialAccounts,
    Integrations_SSO_EnabledContentURL: Integrations_SSO_EnabledContentURL,
    Integrations_SSO_IsEnabled: Integrations_SSO_IsEnabled,
    Integrations_SuccessfullImport: Integrations_SuccessfullImport,
    Integrations_TreehouseImportError: Integrations_TreehouseImportError,
    Integrations_TreehousePublicProfile: Integrations_TreehousePublicProfile,
    Integrations_TreehouseUsername: Integrations_TreehouseUsername,
    Integrations_Twitter: Integrations_Twitter,
    Integrations_TypeDisable: Integrations_TypeDisable,
    Integrations_TypeTerm: Integrations_TypeTerm,
    Integrations_UdemyImportError: Integrations_UdemyImportError,
    Integrations_UdemyUserId: Integrations_UdemyUserId,
    Integrations_UdemyVisibleCourses: Integrations_UdemyVisibleCourses,
    Integrations_UnableToVerify: Integrations_UnableToVerify,
    Integrations_UserGrantedLicense: Integrations_UserGrantedLicense,
    Integrations_UserIDAssertionName: Integrations_UserIDAssertionName,
    Integrations_UserIdentifierSamlSubject: Integrations_UserIdentifierSamlSubject,
    Integrations_VerifyCourseraPublicProfile: Integrations_VerifyCourseraPublicProfile,
    Integrations_VerifyPublicCodecademy: Integrations_VerifyPublicCodecademy,
    Integrations_VerifyPublicUdemyProfile: Integrations_VerifyPublicUdemyProfile,
    Integrations_VerifySkillsharePublic: Integrations_VerifySkillsharePublic,
    Integrations_VerifySkillshareUserId: Integrations_VerifySkillshareUserId,
    Integrations_VerifyUniqueCourseraUserId: Integrations_VerifyUniqueCourseraUserId,
    Integrations_VerifyUniqueUserId: Integrations_VerifyUniqueUserId,
    Integrations_ViewConnections: Integrations_ViewConnections,
    Integrations_ViewFollowers: Integrations_ViewFollowers,
    Integrations_ViewFriends: Integrations_ViewFriends,
    IntegrationsSvc_AlisonDescription: IntegrationsSvc_AlisonDescription,
    IntegrationsSvc_AlisonLabelText: IntegrationsSvc_AlisonLabelText,
    IntegrationsSvc_AlisonPlaceholderText: IntegrationsSvc_AlisonPlaceholderText,
    IntegrationsSvc_AlisonUrl: IntegrationsSvc_AlisonUrl,
    IntegrationsSvc_AutoNotifyLabelFormat: IntegrationsSvc_AutoNotifyLabelFormat,
    IntegrationsSvc_CodecademyDescription: IntegrationsSvc_CodecademyDescription,
    IntegrationsSvc_CodecademyLabelText: IntegrationsSvc_CodecademyLabelText,
    IntegrationsSvc_CodecademyPlaceholderText: IntegrationsSvc_CodecademyPlaceholderText,
    IntegrationsSvc_CodecademyUrl: IntegrationsSvc_CodecademyUrl,
    IntegrationsSvc_CodeSchoolDescription: IntegrationsSvc_CodeSchoolDescription,
    IntegrationsSvc_CodeSchoolLabelText: IntegrationsSvc_CodeSchoolLabelText,
    IntegrationsSvc_CodeSchoolPlaceholderText: IntegrationsSvc_CodeSchoolPlaceholderText,
    IntegrationsSvc_CodeSchoolUrl: IntegrationsSvc_CodeSchoolUrl,
    IntegrationsSvc_Contacts: IntegrationsSvc_Contacts,
    IntegrationsSvc_Followers: IntegrationsSvc_Followers,
    IntegrationsSvc_Friends: IntegrationsSvc_Friends,
    IntegrationsSvc_GoodreadsDescription: IntegrationsSvc_GoodreadsDescription,
    IntegrationsSvc_GoodreadsLabelText: IntegrationsSvc_GoodreadsLabelText,
    IntegrationsSvc_GoodreadsPlaceholderText: IntegrationsSvc_GoodreadsPlaceholderText,
    IntegrationsSvc_GoogleplusFriends: IntegrationsSvc_GoogleplusFriends,
    IntegrationsSvc_KhanAcademyDescription: IntegrationsSvc_KhanAcademyDescription,
    IntegrationsSvc_KhanAcademyLabelText: IntegrationsSvc_KhanAcademyLabelText,
    IntegrationsSvc_KhanAcademyPlaceholderText: IntegrationsSvc_KhanAcademyPlaceholderText,
    IntegrationsSvc_NoFriendsDescription: IntegrationsSvc_NoFriendsDescription,
    IntegrationsSvc_NoGoogleplusFriendsHeader: IntegrationsSvc_NoGoogleplusFriendsHeader,
    IntegrationsSvc_PluralsightDescription: IntegrationsSvc_PluralsightDescription,
    IntegrationsSvc_PluralsightLabelText: IntegrationsSvc_PluralsightLabelText,
    IntegrationsSvc_PluralsightPlaceholderText: IntegrationsSvc_PluralsightPlaceholderText,
    IntegrationsSvc_PluralsightUrl: IntegrationsSvc_PluralsightUrl,
    IntegrationsSvc_PocketDescription: IntegrationsSvc_PocketDescription,
    IntegrationsSvc_PocketLabelText: IntegrationsSvc_PocketLabelText,
    IntegrationsSvc_PocketPlaceholderText: IntegrationsSvc_PocketPlaceholderText,
    IntegrationsSvc_SkillshareDescription: IntegrationsSvc_SkillshareDescription,
    IntegrationsSvc_SkillshareLabelText: IntegrationsSvc_SkillshareLabelText,
    IntegrationsSvc_SkillsharePlaceholderText: IntegrationsSvc_SkillsharePlaceholderText,
    IntegrationsSvc_SkillshareUrl: IntegrationsSvc_SkillshareUrl,
    IntegrationsSvc_SkillshareUrlext: IntegrationsSvc_SkillshareUrlext,
    IntegrationsSvc_SlackDescription: IntegrationsSvc_SlackDescription,
    IntegrationsSvc_TreehouseDescription: IntegrationsSvc_TreehouseDescription,
    IntegrationsSvc_TreehouseLabelText: IntegrationsSvc_TreehouseLabelText,
    IntegrationsSvc_TreehousePlaceholderText: IntegrationsSvc_TreehousePlaceholderText,
    IntegrationsSvc_TreehouseUrl: IntegrationsSvc_TreehouseUrl,
    IntegrationsSvc_UdemyDescription: IntegrationsSvc_UdemyDescription,
    IntegrationsSvc_UdemyLabelText: IntegrationsSvc_UdemyLabelText,
    IntegrationsSvc_UdemyPlaceholderText: IntegrationsSvc_UdemyPlaceholderText,
    IntegrationsSvc_UdemyUrl: IntegrationsSvc_UdemyUrl,
    IntegrationsSvc_ViewContacts: IntegrationsSvc_ViewContacts,
    IntegrationsSvc_ViewFollowers: IntegrationsSvc_ViewFollowers,
    IntegrationsSvc_ViewFriends: IntegrationsSvc_ViewFriends,
    InviteAddCategoriesCtrl_FollowCategoriesFormat: InviteAddCategoriesCtrl_FollowCategoriesFormat,
    InviteAddCategoriesCtrl_FollowCategoryFormat: InviteAddCategoriesCtrl_FollowCategoryFormat,
    InviteAddPeopleCtrl_FollowPersonFormat: InviteAddPeopleCtrl_FollowPersonFormat,
    InviteAddPeopleCtrl_FollowPersonsFormat: InviteAddPeopleCtrl_FollowPersonsFormat,
    KPI_AddedSkillsByOthersAverage: KPI_AddedSkillsByOthersAverage,
    KPI_AddedSkillsByOthersAverageToolTip: KPI_AddedSkillsByOthersAverageToolTip,
    KPI_AverageRating: KPI_AverageRating,
    KPI_AvgFormat: KPI_AvgFormat,
    KPI_DaysSinceLastRating: KPI_DaysSinceLastRating,
    KPI_DaysSinceLastRatingToolTip: KPI_DaysSinceLastRatingToolTip,
    KPI_Decrease: KPI_Decrease,
    KPI_Increase: KPI_Increase,
    KPI_JobRoleSkillCount: KPI_JobRoleSkillCount,
    KPI_JobRoleSkillCountToolTip: KPI_JobRoleSkillCountToolTip,
    KPI_NoChange: KPI_NoChange,
    KPI_NoJobRoleToolTip: KPI_NoJobRoleToolTip,
    KPI_NotApplicableToolTip: KPI_NotApplicableToolTip,
    KPI_OpportunityApplyName: KPI_OpportunityApplyName,
    KPI_OpportunityApplyTooltip: KPI_OpportunityApplyTooltip,
    KPI_OpportunityDaysOpenName: KPI_OpportunityDaysOpenName,
    KPI_OpportunityDaysOpenTooltip: KPI_OpportunityDaysOpenTooltip,
    KPI_OpportunityInterestedName: KPI_OpportunityInterestedName,
    KPI_OpportunityInterestedTooltip: KPI_OpportunityInterestedTooltip,
    KPI_OpportunitySelectedName: KPI_OpportunitySelectedName,
    KPI_OpportunitySelectedTooltip: KPI_OpportunitySelectedTooltip,
    KPI_OpportunityUniqueViewsName: KPI_OpportunityUniqueViewsName,
    KPI_OpportunityUniqueViewsTooltip: KPI_OpportunityUniqueViewsTooltip,
    KPI_OpportunityUsersName: KPI_OpportunityUsersName,
    KPI_OpportunityUsersTooltip: KPI_OpportunityUsersTooltip,
    KPI_OpportunityViewsName: KPI_OpportunityViewsName,
    KPI_OpportunityViewsTooltip: KPI_OpportunityViewsTooltip,
    KPI_OrgOpportunityActiveOpportunitiesName: KPI_OrgOpportunityActiveOpportunitiesName,
    KPI_OrgOpportunityActiveOpportunitiesTooltip: KPI_OrgOpportunityActiveOpportunitiesTooltip,
    KPI_OrgOpportunityApplicantsInOpportunitiesName: KPI_OrgOpportunityApplicantsInOpportunitiesName,
    KPI_OrgOpportunityApplicantsInOpportunitiesTooltip: KPI_OrgOpportunityApplicantsInOpportunitiesTooltip,
    KPI_OrgOpportunityOpportunitiesWithInterestName: KPI_OrgOpportunityOpportunitiesWithInterestName,
    KPI_OrgOpportunityOpportunitiesWithInterestTooltip: KPI_OrgOpportunityOpportunitiesWithInterestTooltip,
    KPI_OrgOpportunityOpportunityUniqueUserViewName: KPI_OrgOpportunityOpportunityUniqueUserViewName,
    KPI_OrgOpportunityOpportunityUniqueUserViewTooltip: KPI_OrgOpportunityOpportunityUniqueUserViewTooltip,
    KPI_OrgOpportunitySelectedCandidatesName: KPI_OrgOpportunitySelectedCandidatesName,
    KPI_OrgOpportunitySelectedCandidatesTooltip: KPI_OrgOpportunitySelectedCandidatesTooltip,
    KPI_OverTheLastXDays: KPI_OverTheLastXDays,
    KPI_OverTheLastXYears: KPI_OverTheLastXYears,
    KPI_OverTheLastYear: KPI_OverTheLastYear,
    KPI_PathwayCompletedName: KPI_PathwayCompletedName,
    KPI_PathwayCompletedTooltip: KPI_PathwayCompletedTooltip,
    KPI_PathwayEnrollName: KPI_PathwayEnrollName,
    KPI_PathwayEnrollTooltip: KPI_PathwayEnrollTooltip,
    KPI_PathwayViewsName: KPI_PathwayViewsName,
    KPI_PathwayViewsTooltip: KPI_PathwayViewsTooltip,
    KPI_PersonalSkillProgression_Empty: KPI_PersonalSkillProgression_Empty,
    KPI_RatedSkillsByOthersAverage: KPI_RatedSkillsByOthersAverage,
    KPI_RatedSkillsByOthersAverageToolTip: KPI_RatedSkillsByOthersAverageToolTip,
    KPI_SkillsAdded: KPI_SkillsAdded,
    KPI_SkillsAddedPast12: KPI_SkillsAddedPast12,
    KPI_SkillsAddedPast12ToolTip: KPI_SkillsAddedPast12ToolTip,
    KPI_SkillsAddedToolTip: KPI_SkillsAddedToolTip,
    KPI_SkillsRated: KPI_SkillsRated,
    KPI_SkillsRatedPast12: KPI_SkillsRatedPast12,
    KPI_SkillsRatedPast12ToolTip: KPI_SkillsRatedPast12ToolTip,
    KPI_SkillsRatedToolTip: KPI_SkillsRatedToolTip,
    KPI_TargetFollowersName: KPI_TargetFollowersName,
    KPI_TargetFollowersTooltip: KPI_TargetFollowersTooltip,
    KPI_TargetViewsName: KPI_TargetViewsName,
    KPI_TargetViewsTooltip: KPI_TargetViewsTooltip,
    LearnerHome_ActivityFrom: LearnerHome_ActivityFrom,
    LearnerHome_ActivityIn: LearnerHome_ActivityIn,
    LearnerHome_BasedOnYourSkills: LearnerHome_BasedOnYourSkills,
    LearnerHome_ConnectDesc: LearnerHome_ConnectDesc,
    LearnerHome_ConnectLearners: LearnerHome_ConnectLearners,
    LearnerHome_ConnectLearnersDesc: LearnerHome_ConnectLearnersDesc,
    LearnerHome_ConnectMentors: LearnerHome_ConnectMentors,
    LearnerHome_ConnectMentorsDesc: LearnerHome_ConnectMentorsDesc,
    LearnerHome_ConnectWithPeopleTitle: LearnerHome_ConnectWithPeopleTitle,
    LearnerHome_ContinueLearning: LearnerHome_ContinueLearning,
    LearnerHome_FindMentors: LearnerHome_FindMentors,
    LearnerHome_GroupViewMoreLink: LearnerHome_GroupViewMoreLink,
    LearnerHome_GroupViewMoreTitle: LearnerHome_GroupViewMoreTitle,
    LearnerHome_ItemsCompleted: LearnerHome_ItemsCompleted,
    LearnerHome_ItemsCompletedDesc: LearnerHome_ItemsCompletedDesc,
    LearnerHome_ItemsDelta: LearnerHome_ItemsDelta,
    LearnerHome_ItemsViewed: LearnerHome_ItemsViewed,
    LearnerHome_ItemsViewedDesc: LearnerHome_ItemsViewedDesc,
    LearnerHome_LearningBudget: LearnerHome_LearningBudget,
    LearnerHome_LearningDelta: LearnerHome_LearningDelta,
    LearnerHome_LearningTime: LearnerHome_LearningTime,
    LearnerHome_LearningTimeDesc: LearnerHome_LearningTimeDesc,
    LearnerHome_MentorConnect: LearnerHome_MentorConnect,
    LearnerHome_MentorshipExpertise: LearnerHome_MentorshipExpertise,
    LearnerHome_NoChanges: LearnerHome_NoChanges,
    LearnerHome_OpportunitiesViewMoreLink: LearnerHome_OpportunitiesViewMoreLink,
    LearnerHome_OpportunityViewMoreLink: LearnerHome_OpportunityViewMoreLink,
    LearnerHome_OpportunityViewMoreTitle: LearnerHome_OpportunityViewMoreTitle,
    LearnerHome_PeopleToFollow: LearnerHome_PeopleToFollow,
    LearnerHome_PeopleYouFollow: LearnerHome_PeopleYouFollow,
    LearnerHome_PointsDelta: LearnerHome_PointsDelta,
    LearnerHome_PointsEarned: LearnerHome_PointsEarned,
    LearnerHome_PointsEarnedDesc: LearnerHome_PointsEarnedDesc,
    LearnerHome_RecentActivity: LearnerHome_RecentActivity,
    LearnerHome_RecentlyViewed: LearnerHome_RecentlyViewed,
    LearnerHome_RequestMentorship: LearnerHome_RequestMentorship,
    LearnerHome_SearchPeople: LearnerHome_SearchPeople,
    LearnerHome_SkillExplore: LearnerHome_SkillExplore,
    LearnerHome_SkillsToFollow: LearnerHome_SkillsToFollow,
    LearnerHome_TrendingAtOrgSubtitle: LearnerHome_TrendingAtOrgSubtitle,
    LearnerHome_TrendingAtOrgTitle: LearnerHome_TrendingAtOrgTitle,
    LearnerHome_TrendingWithin: LearnerHome_TrendingWithin,
    LearnerHome_UseYourBudget: LearnerHome_UseYourBudget,
    LearnerHome_ViewMoreLink: LearnerHome_ViewMoreLink,
    LearnerHome_ViewMoreMentorsLink: LearnerHome_ViewMoreMentorsLink,
    LearnerHome_ViewMoreTitle: LearnerHome_ViewMoreTitle,
    LearnerHome_ViewMoreUserLink: LearnerHome_ViewMoreUserLink,
    LearnerHome_ViewMoreUserTitle: LearnerHome_ViewMoreUserTitle,
    LearnerHome_ViewYourBalance: LearnerHome_ViewYourBalance,
    LearnerHome_WelcomeSectionSubTitle: LearnerHome_WelcomeSectionSubTitle,
    LearnerHome_WelcomeSectionSubTitleShort: LearnerHome_WelcomeSectionSubTitleShort,
    LearnerHome_WelcomeSectionTitle: LearnerHome_WelcomeSectionTitle,
    LearningBrowse_FeaturedContent: LearningBrowse_FeaturedContent,
    LearningBrowse_FeaturedCourseProviders: LearningBrowse_FeaturedCourseProviders,
    LearningBrowse_FeaturedPathways: LearningBrowse_FeaturedPathways,
    LearningBrowse_FeaturedTargets: LearningBrowse_FeaturedTargets,
    LearningBrowse_NewContent: LearningBrowse_NewContent,
    LearningBrowse_SuggestedGroups: LearningBrowse_SuggestedGroups,
    LearningBrowse_SuggestedJobRoles: LearningBrowse_SuggestedJobRoles,
    LearningBrowse_SuggestedOpportunities: LearningBrowse_SuggestedOpportunities,
    LearningBrowse_SuggestedPeopleToFollow: LearningBrowse_SuggestedPeopleToFollow,
    LearningController_ActiveSubscription: LearningController_ActiveSubscription,
    LearningController_All: LearningController_All,
    LearningController_Content: LearningController_Content,
    LearningController_FeaturedContent: LearningController_FeaturedContent,
    LearningController_FeaturedCourseProviders: LearningController_FeaturedCourseProviders,
    LearningController_FeaturedPathways: LearningController_FeaturedPathways,
    LearningController_FindSomething: LearningController_FindSomething,
    LearningController_More: LearningController_More,
    LearningController_NoCategories: LearningController_NoCategories,
    LearningController_Pathways: LearningController_Pathways,
    LearningController_People: LearningController_People,
    LearningController_QA: LearningController_QA,
    LearningController_RefineResults: LearningController_RefineResults,
    LearningController_SuggestedPeopleToFollow: LearningController_SuggestedPeopleToFollow,
    LearningController_Top: LearningController_Top,
    LearningController_TopCategories: LearningController_TopCategories,
    LearningController_Type: LearningController_Type,
    LearningController_ViewAll: LearningController_ViewAll,
    LearningController_VisitSite: LearningController_VisitSite,
    LearningController_YourTopCategories: LearningController_YourTopCategories,
    LearningCtrl_ActiveSubscription: LearningCtrl_ActiveSubscription,
    LearningCtrl_DefaultSearchTerm: LearningCtrl_DefaultSearchTerm,
    LearningCtrl_SearchError: LearningCtrl_SearchError,
    LearningCtrl_Subscription: LearningCtrl_Subscription,
    LearningSearch_ActiveSubscription: LearningSearch_ActiveSubscription,
    LearningSearch_BackToSearch: LearningSearch_BackToSearch,
    LearningSearch_Careers: LearningSearch_Careers,
    LearningSearch_Clear: LearningSearch_Clear,
    LearningSearch_ClearFilters: LearningSearch_ClearFilters,
    LearningSearch_ClosedGroup: LearningSearch_ClosedGroup,
    LearningSearch_CompletedAllFormat: LearningSearch_CompletedAllFormat,
    LearningSearch_Content: LearningSearch_Content,
    LearningSearch_DefaultSearchTerm: LearningSearch_DefaultSearchTerm,
    LearningSearch_DidYouMean: LearningSearch_DidYouMean,
    LearningSearch_Directories: LearningSearch_Directories,
    LearningSearch_ErrorContactSupport: LearningSearch_ErrorContactSupport,
    LearningSearch_ErrorDescription: LearningSearch_ErrorDescription,
    LearningSearch_ErrorTitle: LearningSearch_ErrorTitle,
    LearningSearch_ErrorTitleSideBar: LearningSearch_ErrorTitleSideBar,
    LearningSearch_FilterApplied: LearningSearch_FilterApplied,
    LearningSearch_FiltersApplied: LearningSearch_FiltersApplied,
    LearningSearch_GoToMarketplace: LearningSearch_GoToMarketplace,
    LearningSearch_GoToSearch: LearningSearch_GoToSearch,
    LearningSearch_Groups: LearningSearch_Groups,
    LearningSearch_GroupsLandingSearchInput: LearningSearch_GroupsLandingSearchInput,
    LearningSearch_Hmm: LearningSearch_Hmm,
    LearningSearch_JobRoles: LearningSearch_JobRoles,
    LearningSearch_Learning: LearningSearch_Learning,
    LearningSearch_LoadMoreEndorsed: LearningSearch_LoadMoreEndorsed,
    LearningSearch_LookingFor: LearningSearch_LookingFor,
    LearningSearch_More: LearningSearch_More,
    LearningSearch_MoreFilters: LearningSearch_MoreFilters,
    LearningSearch_MoreFormat: LearningSearch_MoreFormat,
    LearningSearch_MostPopular: LearningSearch_MostPopular,
    LearningSearch_MostRecent: LearningSearch_MostRecent,
    LearningSearch_MostRelevant: LearningSearch_MostRelevant,
    LearningSearch_NoResultsFound: LearningSearch_NoResultsFound,
    LearningSearch_NoResultsFoundAdvice: LearningSearch_NoResultsFoundAdvice,
    LearningSearch_NoResultsFoundMsg: LearningSearch_NoResultsFoundMsg,
    LearningSearch_NoResultsFoundTitle: LearningSearch_NoResultsFoundTitle,
    LearningSearch_NoSidebarFormat: LearningSearch_NoSidebarFormat,
    LearningSearch_OpenGroup: LearningSearch_OpenGroup,
    LearningSearch_OpportunitiesTitle: LearningSearch_OpportunitiesTitle,
    LearningSearch_OppsLandingSearchInput: LearningSearch_OppsLandingSearchInput,
    LearningSearch_OppsSidebarTooltip: LearningSearch_OppsSidebarTooltip,
    LearningSearch_Pathways: LearningSearch_Pathways,
    LearningSearch_PathwaysAndPlans: LearningSearch_PathwaysAndPlans,
    LearningSearch_People: LearningSearch_People,
    LearningSearch_PeopleAndGroups: LearningSearch_PeopleAndGroups,
    LearningSearch_PeopleLandingSearchInput: LearningSearch_PeopleLandingSearchInput,
    LearningSearch_Popular: LearningSearch_Popular,
    LearningSearch_ProviderNoResultsFoundAdvice: LearningSearch_ProviderNoResultsFoundAdvice,
    LearningSearch_ProviderNotPartOfCatalog: LearningSearch_ProviderNotPartOfCatalog,
    LearningSearch_QA: LearningSearch_QA,
    LearningSearch_RangeCount: LearningSearch_RangeCount,
    LearningSearch_RangeCountPlus: LearningSearch_RangeCountPlus,
    LearningSearch_Recent: LearningSearch_Recent,
    LearningSearch_Relevant: LearningSearch_Relevant,
    LearningSearch_RemoveFiltersAdvice: LearningSearch_RemoveFiltersAdvice,
    LearningSearch_ResetFiltersAdvice: LearningSearch_ResetFiltersAdvice,
    LearningSearch_ResetFiltersMsg: LearningSearch_ResetFiltersMsg,
    LearningSearch_ResultsCount: LearningSearch_ResultsCount,
    LearningSearch_ResultsCount_PluralFormat: LearningSearch_ResultsCount_PluralFormat,
    LearningSearch_ResultsCount_SingleFormat: LearningSearch_ResultsCount_SingleFormat,
    LearningSearch_ResultSetRangeCount: LearningSearch_ResultSetRangeCount,
    LearningSearch_ResultSetRangeCountPlus: LearningSearch_ResultSetRangeCountPlus,
    LearningSearch_ResultsFor: LearningSearch_ResultsFor,
    LearningSearch_Roles: LearningSearch_Roles,
    LearningSearch_SearchedInsteadFor: LearningSearch_SearchedInsteadFor,
    LearningSearch_SearchError: LearningSearch_SearchError,
    LearningSearch_SearchFilters: LearningSearch_SearchFilters,
    LearningSearch_SearchFiltersDescription: LearningSearch_SearchFiltersDescription,
    LearningSearch_ShowFilters: LearningSearch_ShowFilters,
    LearningSearch_ShowingResultsFor: LearningSearch_ShowingResultsFor,
    LearningSearch_Skills: LearningSearch_Skills,
    LearningSearch_SkillsLandingSearchInput: LearningSearch_SkillsLandingSearchInput,
    LearningSearch_SkillsResults: LearningSearch_SkillsResults,
    LearningSearch_Subscription: LearningSearch_Subscription,
    LearningSearch_SuggestedSearches: LearningSearch_SuggestedSearches,
    LearningSearch_Title: LearningSearch_Title,
    LearningSearch_Top: LearningSearch_Top,
    LearningSearch_Trending: LearningSearch_Trending,
    LearningSearch_ViewAll: LearningSearch_ViewAll,
    LearningSearch_ViewMore: LearningSearch_ViewMore,
    likeComment_PluralFormat: likeComment_PluralFormat,
    likeComment_PluralGroupFormat: likeComment_PluralGroupFormat,
    likeComment_SingleFormat: likeComment_SingleFormat,
    likeComment_SingleGroupFormat: likeComment_SingleGroupFormat,
    likeGroupActivity_GoalAddedPluralFormat: likeGroupActivity_GoalAddedPluralFormat,
    likeGroupActivity_GoalAddedSingleFormat: likeGroupActivity_GoalAddedSingleFormat,
    likeGroupActivity_GoalRemovedPluralFormat: likeGroupActivity_GoalRemovedPluralFormat,
    likeGroupActivity_GoalRemovedSingleFormat: likeGroupActivity_GoalRemovedSingleFormat,
    likeGroupActivity_GoalUpdatedPluralFormat: likeGroupActivity_GoalUpdatedPluralFormat,
    likeGroupActivity_GoalUpdatedSingleFormat: likeGroupActivity_GoalUpdatedSingleFormat,
    likeGroupActivity_GroupAddedPluralFormat: likeGroupActivity_GroupAddedPluralFormat,
    likeGroupActivity_GroupAddedSingleFormat: likeGroupActivity_GroupAddedSingleFormat,
    likeGroupActivity_GroupPostPluralFormat: likeGroupActivity_GroupPostPluralFormat,
    likeGroupActivity_GroupPostSingleFormat: likeGroupActivity_GroupPostSingleFormat,
    likeGroupActivity_GroupUpdatedPluralFormat: likeGroupActivity_GroupUpdatedPluralFormat,
    likeGroupActivity_GroupUpdatedSingleFormat: likeGroupActivity_GroupUpdatedSingleFormat,
    likeGroupActivity_InputRecommendedSingleFormat: likeGroupActivity_InputRecommendedSingleFormat,
    likeGroupActivity_UserAddedPluralFormat: likeGroupActivity_UserAddedPluralFormat,
    likeGroupActivity_UserAddedSingleFormat: likeGroupActivity_UserAddedSingleFormat,
    likeGroupActivity_UserInputPluralFormat: likeGroupActivity_UserInputPluralFormat,
    likeGroupActivity_UserInputSingleFormat: likeGroupActivity_UserInputSingleFormat,
    LiveEvents_Hybrid: LiveEvents_Hybrid,
    LiveEvents_JoinSession: LiveEvents_JoinSession,
    LiveEvents_RegisteredCheckboxLabel: LiveEvents_RegisteredCheckboxLabel,
    LiveEvents_RegisteredCheckboxTooltip: LiveEvents_RegisteredCheckboxTooltip,
    LiveEvents_RegisteredLabel: LiveEvents_RegisteredLabel,
    LiveEvents_RegisterOnWebsiteFormat: LiveEvents_RegisterOnWebsiteFormat,
    LiveEvents_RegistrationInstructions: LiveEvents_RegistrationInstructions,
    LiveEvents_SessionsCardLabel: LiveEvents_SessionsCardLabel,
    loginForm_EmailLabel: loginForm_EmailLabel,
    loginForm_EmailStateTooltip: loginForm_EmailStateTooltip,
    loginForm_InvalidEmail: loginForm_InvalidEmail,
    loginForm_LoggingInAs: loginForm_LoggingInAs,
    loginForm_NoAccount: loginForm_NoAccount,
    loginForm_NoAccountCTA: loginForm_NoAccountCTA,
    loginForm_PasswordHelper: loginForm_PasswordHelper,
    loginForm_PasswordLabel: loginForm_PasswordLabel,
    loginForm_PasswordPlaceholder: loginForm_PasswordPlaceholder,
    loginForm_PasswordPromptNoSSO: loginForm_PasswordPromptNoSSO,
    loginForm_SignUpNow: loginForm_SignUpNow,
    loginForm_SsoMessage: loginForm_SsoMessage,
    loginForm_WelcomeBackTitle: loginForm_WelcomeBackTitle,
    loginForm_WelcomeTitle: loginForm_WelcomeTitle,
    Markdown_ContentLength: Markdown_ContentLength,
    Markdown_EditorHelperFormat: Markdown_EditorHelperFormat,
    Markdown_MarkdownLearnMore: Markdown_MarkdownLearnMore,
    Markdown_MarkdownSupported: Markdown_MarkdownSupported,
    Markdown_toolbarA11y_addImage: Markdown_toolbarA11y_addImage,
    Markdown_toolbarA11y_bold: Markdown_toolbarA11y_bold,
    Markdown_toolbarA11y_italic: Markdown_toolbarA11y_italic,
    Markdown_toolbarA11y_link: Markdown_toolbarA11y_link,
    Markdown_toolbarA11y_ol: Markdown_toolbarA11y_ol,
    Markdown_toolbarA11y_quote: Markdown_toolbarA11y_quote,
    Markdown_toolbarA11y_ul: Markdown_toolbarA11y_ul,
    Markdown_UploadErrorMessage: Markdown_UploadErrorMessage,
    MediaFormCtrl_AddArticle: MediaFormCtrl_AddArticle,
    MediaFormCtrl_AddedArticleSuccessFormat: MediaFormCtrl_AddedArticleSuccessFormat,
    MediaFormCtrl_AddGroups: MediaFormCtrl_AddGroups,
    MediaFormCtrl_AddingGroupsInfo: MediaFormCtrl_AddingGroupsInfo,
    MediaFormCtrl_AddPost: MediaFormCtrl_AddPost,
    MediaFormCtrl_AddToCatalogFormat: MediaFormCtrl_AddToCatalogFormat,
    MediaFormCtrl_AddVideo: MediaFormCtrl_AddVideo,
    MediaFormCtrl_AddVideoToCatalogFormat: MediaFormCtrl_AddVideoToCatalogFormat,
    MediaFormCtrl_ArticleUrl: MediaFormCtrl_ArticleUrl,
    MediaFormCtrl_Category: MediaFormCtrl_Category,
    MediaFormCtrl_EditArticle: MediaFormCtrl_EditArticle,
    MediaFormCtrl_EditPost: MediaFormCtrl_EditPost,
    MediaFormCtrl_EditVideo: MediaFormCtrl_EditVideo,
    MediaFormCtrl_ErrorUnaccessibleArticle: MediaFormCtrl_ErrorUnaccessibleArticle,
    MediaFormCtrl_ErrorUnaccessiblePost: MediaFormCtrl_ErrorUnaccessiblePost,
    MediaFormCtrl_ErrorUnaccessibleVideo: MediaFormCtrl_ErrorUnaccessibleVideo,
    MediaFormCtrl_ICreatedVideo: MediaFormCtrl_ICreatedVideo,
    MediaFormCtrl_IWroteArticle: MediaFormCtrl_IWroteArticle,
    MediaFormCtrl_IWrotePost: MediaFormCtrl_IWrotePost,
    MediaFormCtrl_NarratorFormat: MediaFormCtrl_NarratorFormat,
    MediaFormCtrl_NewContentOwner: MediaFormCtrl_NewContentOwner,
    MediaFormCtrl_Provider: MediaFormCtrl_Provider,
    MediaFormCtrl_SaveArticle: MediaFormCtrl_SaveArticle,
    MediaFormCtrl_SavePost: MediaFormCtrl_SavePost,
    MediaFormCtrl_SaveVideo: MediaFormCtrl_SaveVideo,
    MediaFormCtrl_SelectionRequired: MediaFormCtrl_SelectionRequired,
    MediaFormCtrl_Skills_Placeholder: MediaFormCtrl_Skills_Placeholder,
    MediaFormCtrl_Summary: MediaFormCtrl_Summary,
    MediaFormCtrl_Title: MediaFormCtrl_Title,
    MediaFormCtrl_Title_Placeholder: MediaFormCtrl_Title_Placeholder,
    MediaFormCtrl_TitleRequired: MediaFormCtrl_TitleRequired,
    MediaFormCtrl_UrlError: MediaFormCtrl_UrlError,
    MediaFormCtrl_UrlOrRecordingRequired: MediaFormCtrl_UrlOrRecordingRequired,
    MediaFormCtrl_UrlOrUploadRequired: MediaFormCtrl_UrlOrUploadRequired,
    MediaFormCtrl_UrlOrVideoUploadOrRecordingRequired: MediaFormCtrl_UrlOrVideoUploadOrRecordingRequired,
    MediaFormCtrl_UrlOrVideoUploadRequired: MediaFormCtrl_UrlOrVideoUploadRequired,
    MediaFormCtrl_UrlRequired: MediaFormCtrl_UrlRequired,
    MediaFormCtrl_ValidContentOwnerRequired: MediaFormCtrl_ValidContentOwnerRequired,
    MediaFormCtrl_ValidNumberLength: MediaFormCtrl_ValidNumberLength,
    MediaFormCtrl_VideoLength: MediaFormCtrl_VideoLength,
    MediaFormCtrl_VideoSuccessFormat: MediaFormCtrl_VideoSuccessFormat,
    MediaFormCtrl_VideoUrl: MediaFormCtrl_VideoUrl,
    MediaFormCtrl_WhatDidYouLearnLong: MediaFormCtrl_WhatDidYouLearnLong,
    MediaFormCtrl_WhatDidYouLearnShort: MediaFormCtrl_WhatDidYouLearnShort,
    MediaFormCtrl_WhatDidYouLearnVideoLong: MediaFormCtrl_WhatDidYouLearnVideoLong,
    mentionInComment_GroupPluralFormat: mentionInComment_GroupPluralFormat,
    mentionInComment_GroupSingleFormat: mentionInComment_GroupSingleFormat,
    mentionInComment_PluralFormat: mentionInComment_PluralFormat,
    mentionInComment_SingleFormat: mentionInComment_SingleFormat,
    Mentoring_FeedbackGiven: Mentoring_FeedbackGiven,
    Mentoring_FeedbackReceived: Mentoring_FeedbackReceived,
    Mentoring_GiveFeedback: Mentoring_GiveFeedback,
    Mentoring_GiveFeedback_FeedbackShared: Mentoring_GiveFeedback_FeedbackShared,
    Mentoring_GiveFeedback_MenteeActionButton: Mentoring_GiveFeedback_MenteeActionButton,
    Mentoring_GiveFeedback_MenteeSubNote: Mentoring_GiveFeedback_MenteeSubNote,
    Mentoring_GiveFeedback_MentorSubNote: Mentoring_GiveFeedback_MentorSubNote,
    Mentoring_PeerRating: Mentoring_PeerRating,
    Mentoring_PeerRating_MenteeSubNote: Mentoring_PeerRating_MenteeSubNote,
    Mentoring_PeerRating_MentorSubNote: Mentoring_PeerRating_MentorSubNote,
    Mentoring_PeerRating_Requested: Mentoring_PeerRating_Requested,
    Mentoring_PeerRatingRequest: Mentoring_PeerRatingRequest,
    Mentoring_PeerRatingRequest_Placeholder: Mentoring_PeerRatingRequest_Placeholder,
    Mentoring_PlaceholderShareMessage: Mentoring_PlaceholderShareMessage,
    Mentoring_RequestFeedback: Mentoring_RequestFeedback,
    Mentoring_RequestFeedback_MenteeSubNote: Mentoring_RequestFeedback_MenteeSubNote,
    Mentoring_RequestFeedback_MentorSubNote: Mentoring_RequestFeedback_MentorSubNote,
    Mentoring_RequestFeedback_Requested: Mentoring_RequestFeedback_Requested,
    Mentoring_ReviewMenteeship: Mentoring_ReviewMenteeship,
    Mentoring_ReviewMentorship: Mentoring_ReviewMentorship,
    Mentoring_ShareFeedback: Mentoring_ShareFeedback,
    MentorshipAcceptedRequest_NotificationTitleFormat: MentorshipAcceptedRequest_NotificationTitleFormat,
    MentorshipCompleted_NotificationTitleFormat: MentorshipCompleted_NotificationTitleFormat,
    MentorshipDeclinedRequest_NotificationTitleFormat: MentorshipDeclinedRequest_NotificationTitleFormat,
    MentorshipFeedbackReceived_NotificationTitleFormat: MentorshipFeedbackReceived_NotificationTitleFormat,
    MentorshipFeedbackRequest_NotificationTitleFormat: MentorshipFeedbackRequest_NotificationTitleFormat,
    MentorshipNewRequest_NotificationTitleFormat: MentorshipNewRequest_NotificationTitleFormat,
    ModalSvc_AreYouSure: ModalSvc_AreYouSure,
    MsTeams_AboutAppTitle: MsTeams_AboutAppTitle,
    MsTeams_AccountNotAssociated: MsTeams_AccountNotAssociated,
    MsTeams_AddToCalendarButton: MsTeams_AddToCalendarButton,
    MsTeams_AddToCalendarSuccess: MsTeams_AddToCalendarSuccess,
    MsTeams_AddToCalendarTitle: MsTeams_AddToCalendarTitle,
    MsTeams_BotCapabilitiesTitle: MsTeams_BotCapabilitiesTitle,
    MsTeams_ChatErrorResponse: MsTeams_ChatErrorResponse,
    MsTeams_CommandsTitle: MsTeams_CommandsTitle,
    MsTeams_DegreedBotDescription: MsTeams_DegreedBotDescription,
    MsTeams_DegreedBotLongDescription: MsTeams_DegreedBotLongDescription,
    MsTeams_DegreedBotShortDescription: MsTeams_DegreedBotShortDescription,
    MsTeams_DegreedLongDescription: MsTeams_DegreedLongDescription,
    MsTeams_DegreedShortDescription: MsTeams_DegreedShortDescription,
    MsTeams_FeaturedPageDescription: MsTeams_FeaturedPageDescription,
    MsTeams_FeaturedPageLink: MsTeams_FeaturedPageLink,
    MsTeams_FeaturedPageTitle: MsTeams_FeaturedPageTitle,
    MsTeams_HelpDescription: MsTeams_HelpDescription,
    MsTeams_InstallationSuccess: MsTeams_InstallationSuccess,
    MsTeams_InstallationSuccessTitle: MsTeams_InstallationSuccessTitle,
    MsTeams_LeavingAppMessaging: MsTeams_LeavingAppMessaging,
    MsTeams_LoginWithDegreedBtn: MsTeams_LoginWithDegreedBtn,
    MsTeams_NoDegreedAccount: MsTeams_NoDegreedAccount,
    MsTeams_NoDegreedAccountSubtitle: MsTeams_NoDegreedAccountSubtitle,
    MsTeams_NoNotifications: MsTeams_NoNotifications,
    MsTeams_NotificationAssignedDescription: MsTeams_NotificationAssignedDescription,
    MsTeams_NotificationOpportunityDescription: MsTeams_NotificationOpportunityDescription,
    MsTeams_NotificationPersonFollowedDescription: MsTeams_NotificationPersonFollowedDescription,
    MsTeams_NotificationSharedDescription: MsTeams_NotificationSharedDescription,
    MsTeams_NoUnreadNotifications: MsTeams_NoUnreadNotifications,
    MsTeams_OnboardingAssignments: MsTeams_OnboardingAssignments,
    MsTeams_OnboardingPathways: MsTeams_OnboardingPathways,
    MsTeams_OnboardingPlans: MsTeams_OnboardingPlans,
    MsTeams_OnboardingSaved: MsTeams_OnboardingSaved,
    MsTeams_OnboardingShared: MsTeams_OnboardingShared,
    MsTeams_OnboardingStartTour: MsTeams_OnboardingStartTour,
    MsTeams_OnboardingTitle: MsTeams_OnboardingTitle,
    MsTeams_PleaseSignIn: MsTeams_PleaseSignIn,
    MsTeams_PopupBlockedAlertDescription: MsTeams_PopupBlockedAlertDescription,
    MsTeams_PopupBlockedAlertTitle: MsTeams_PopupBlockedAlertTitle,
    MsTeams_ShowAllNotifications: MsTeams_ShowAllNotifications,
    MsTeams_ShowUnread: MsTeams_ShowUnread,
    MsTeams_ShowUnreadNotifications: MsTeams_ShowUnreadNotifications,
    MsTeams_SignedInFailure: MsTeams_SignedInFailure,
    MsTeams_SignedInSuccess: MsTeams_SignedInSuccess,
    MsTeams_SignedOutSuccess: MsTeams_SignedOutSuccess,
    MsTeams_SignIn: MsTeams_SignIn,
    MsTeams_SignInRequired: MsTeams_SignInRequired,
    MsTeams_SignOut: MsTeams_SignOut,
    MsTeams_SignOutDescription: MsTeams_SignOutDescription,
    NativeInviteBanner_AppTagline: NativeInviteBanner_AppTagline,
    NativeInviteBanner_AppTitle: NativeInviteBanner_AppTitle,
    NativeInviteBanner_GetOnAppStore: NativeInviteBanner_GetOnAppStore,
    NativeInviteBanner_GetOnPlayStore: NativeInviteBanner_GetOnPlayStore,
    NativeInviteBanner_Open: NativeInviteBanner_Open,
    NativeInviteBanner_OpenInApp: NativeInviteBanner_OpenInApp,
    NativeInviteBanner_RedirectTitle: NativeInviteBanner_RedirectTitle,
    NavigationSvc_LearnTitle: NavigationSvc_LearnTitle,
    NavigationSvc_MainMenu: NavigationSvc_MainMenu,
    NavigationSvc_TodayTitle: NavigationSvc_TodayTitle,
    newPathwayAuthor_DescriptionFormat: newPathwayAuthor_DescriptionFormat,
    newTargetAuthor_DescriptionFormat: newTargetAuthor_DescriptionFormat,
    newTargetResource_Description: newTargetResource_Description,
    newUserFollower_PluralFormat: newUserFollower_PluralFormat,
    newUserFollower_SingleFormat: newUserFollower_SingleFormat,
    Notification_AutomationNotification: Notification_AutomationNotification,
    Notification_CompleteViewedItemsStepArticle: Notification_CompleteViewedItemsStepArticle,
    Notification_CompleteViewedItemsStepArticleItem1: Notification_CompleteViewedItemsStepArticleItem1,
    Notification_CompleteViewedItemsStepArticleItem2: Notification_CompleteViewedItemsStepArticleItem2,
    Notification_CompleteViewedItemsStepEpisode: Notification_CompleteViewedItemsStepEpisode,
    Notification_CompleteViewedItemsStepEpisodeItem1: Notification_CompleteViewedItemsStepEpisodeItem1,
    Notification_CompleteViewedItemsStepEpisodeItem2: Notification_CompleteViewedItemsStepEpisodeItem2,
    Notification_CompleteViewedItemsStepFirstFormat: Notification_CompleteViewedItemsStepFirstFormat,
    Notification_CompleteViewedItemsStepFirstFormatItem1: Notification_CompleteViewedItemsStepFirstFormatItem1,
    Notification_CompleteViewedItemsStepFirstFormatItem2: Notification_CompleteViewedItemsStepFirstFormatItem2,
    Notification_CompleteViewedItemsStepFirstSingular: Notification_CompleteViewedItemsStepFirstSingular,
    Notification_CompleteViewedItemsStepFirstSingularItem1: Notification_CompleteViewedItemsStepFirstSingularItem1,
    Notification_CompleteViewedItemsStepFirstSingularItem2: Notification_CompleteViewedItemsStepFirstSingularItem2,
    Notification_CompleteViewedItemsStepPost: Notification_CompleteViewedItemsStepPost,
    Notification_CompleteViewedItemsStepThanksFormat: Notification_CompleteViewedItemsStepThanksFormat,
    Notification_CompleteViewedItemsStepVideo: Notification_CompleteViewedItemsStepVideo,
    Notification_CompleteViewedItemsStepVideoItem1: Notification_CompleteViewedItemsStepVideoItem1,
    Notification_CompleteViewedItemsStepVideoItem2: Notification_CompleteViewedItemsStepVideoItem2,
    Notification_EnableDailyEmailStep1: Notification_EnableDailyEmailStep1,
    Notification_EnableDailyEmailStep1Item1: Notification_EnableDailyEmailStep1Item1,
    Notification_EnableDailyEmailStep1Item2: Notification_EnableDailyEmailStep1Item2,
    Notification_EnableDailyEmailStep2: Notification_EnableDailyEmailStep2,
    Notification_EnableDailyEmailStep2Item1: Notification_EnableDailyEmailStep2Item1,
    Notification_EnableDailyEmailStep2Item2: Notification_EnableDailyEmailStep2Item2,
    Notification_EnableDailyEmailStep3: Notification_EnableDailyEmailStep3,
    Notification_EnableDailyEmailStep3Item1: Notification_EnableDailyEmailStep3Item1,
    Notification_EnableDailyEmailStep3Item2: Notification_EnableDailyEmailStep3Item2,
    Notification_EnableDailyEmailStep4: Notification_EnableDailyEmailStep4,
    Notification_EnableDailyEmailStep5: Notification_EnableDailyEmailStep5,
    Notification_InstallNativeAppStep1: Notification_InstallNativeAppStep1,
    Notification_InstallNativeAppStep1Item1: Notification_InstallNativeAppStep1Item1,
    Notification_InstallNativeAppStep1Item2: Notification_InstallNativeAppStep1Item2,
    Notification_InstallNativeAppStep2: Notification_InstallNativeAppStep2,
    Notification_InstallNativeAppStep2Item1: Notification_InstallNativeAppStep2Item1,
    Notification_InstallNativeAppStep2Item2: Notification_InstallNativeAppStep2Item2,
    Notification_InstallNativeAppStep3: Notification_InstallNativeAppStep3,
    Notification_InstallNativeAppStep3Item1: Notification_InstallNativeAppStep3Item1,
    Notification_InstallNativeAppStep3Item2: Notification_InstallNativeAppStep3Item2,
    Notification_InstallNativeAppStep3Item3: Notification_InstallNativeAppStep3Item3,
    Notification_MultipleAssessmentsFoundAddSkills: Notification_MultipleAssessmentsFoundAddSkills,
    Notification_MultipleAssessmentsFoundReviewSkills: Notification_MultipleAssessmentsFoundReviewSkills,
    Notification_NewSkillsProviderAdded: Notification_NewSkillsProviderAdded,
    Notification_PathwayContentCompletionReminder: Notification_PathwayContentCompletionReminder,
    Notification_PrimaryTargetSetStepMainFormat: Notification_PrimaryTargetSetStepMainFormat,
    Notification_PrimaryTargetSetStepMainFormatItem1: Notification_PrimaryTargetSetStepMainFormatItem1,
    Notification_RecommendedBulkGeneric_NotificationTitleFormat: Notification_RecommendedBulkGeneric_NotificationTitleFormat,
    Notification_RecommendedSkills_NotificationTitleFormat: Notification_RecommendedSkills_NotificationTitleFormat,
    Notification_ReviewItems: Notification_ReviewItems,
    Notification_SingleAssessmentFoundAddSkill: Notification_SingleAssessmentFoundAddSkill,
    Notification_SingleAssessmentFoundReviewSkill: Notification_SingleAssessmentFoundReviewSkill,
    Notification_SkillMatched: Notification_SkillMatched,
    Notification_SkillsAddedToProfileFromJobRole_Plural: Notification_SkillsAddedToProfileFromJobRole_Plural,
    Notification_SkillsAddedToProfileFromJobRole_Single: Notification_SkillsAddedToProfileFromJobRole_Single,
    Notification_TitleFormat_OpportunityClosed: Notification_TitleFormat_OpportunityClosed,
    Notification_TitleFormat_OpportunityInterested: Notification_TitleFormat_OpportunityInterested,
    Notification_TrackYourLearningStep1: Notification_TrackYourLearningStep1,
    Notification_TrackYourLearningStep1Item1: Notification_TrackYourLearningStep1Item1,
    Notification_TrackYourLearningStep1Item2: Notification_TrackYourLearningStep1Item2,
    Notification_TrackYourLearningStep2: Notification_TrackYourLearningStep2,
    Notification_TrackYourLearningStep2Item1: Notification_TrackYourLearningStep2Item1,
    Notification_TrackYourLearningStep2Item2: Notification_TrackYourLearningStep2Item2,
    Notification_TrackYourLearningStep3: Notification_TrackYourLearningStep3,
    Notification_TrackYourLearningStep3Item1: Notification_TrackYourLearningStep3Item1,
    Notification_TrackYourLearningStep3Item2: Notification_TrackYourLearningStep3Item2,
    Notification_TrackYourLearningStep4: Notification_TrackYourLearningStep4,
    Notification_TrackYourLearningStep4Item1: Notification_TrackYourLearningStep4Item1,
    Notification_TrackYourLearningStep4Item2: Notification_TrackYourLearningStep4Item2,
    Notification_TrackYourLearningStep5: Notification_TrackYourLearningStep5,
    Notification_TrackYourLearningStep5Item1: Notification_TrackYourLearningStep5Item1,
    Notification_TrackYourLearningStep5Item2: Notification_TrackYourLearningStep5Item2,
    Notification_TrackYourLearningStep6: Notification_TrackYourLearningStep6,
    Notification_TrackYourLearningStep7: Notification_TrackYourLearningStep7,
    Notification_UpdateUserTagRatingsOnProfileStep1: Notification_UpdateUserTagRatingsOnProfileStep1,
    Notification_UpdateUserTagRatingsOnProfileStep1Item1: Notification_UpdateUserTagRatingsOnProfileStep1Item1,
    Notification_UpdateUserTagRatingsOnProfileStep1Item2: Notification_UpdateUserTagRatingsOnProfileStep1Item2,
    Notification_UpdateUserTagRatingsOnProfileStep2: Notification_UpdateUserTagRatingsOnProfileStep2,
    Notification_UpdateUserTagRatingsOnProfileStep2Item1: Notification_UpdateUserTagRatingsOnProfileStep2Item1,
    Notification_UpdateUserTagRatingsStep1: Notification_UpdateUserTagRatingsStep1,
    Notification_UpdateUserTagRatingsStep1Item1: Notification_UpdateUserTagRatingsStep1Item1,
    Notification_UpdateUserTagRatingsStep1Item2: Notification_UpdateUserTagRatingsStep1Item2,
    Notification_UpdateUserTagsStep1: Notification_UpdateUserTagsStep1,
    Notification_UpdateUserTagsStep1Item1: Notification_UpdateUserTagsStep1Item1,
    Notification_UpdateUserTagsStep1Item2: Notification_UpdateUserTagsStep1Item2,
    Notification_UpdateUserTagsStep2: Notification_UpdateUserTagsStep2,
    Notification_UpdateUserTagsStep2Item1: Notification_UpdateUserTagsStep2Item1,
    Notification_UpdateUserTagsStep3: Notification_UpdateUserTagsStep3,
    Notification_UserTagSetGoal_NotificationTitleFormat: Notification_UserTagSetGoal_NotificationTitleFormat,
    Notification_ViewOnProfile: Notification_ViewOnProfile,
    NotificationFeedCtrl_NotificationCountFormat: NotificationFeedCtrl_NotificationCountFormat,
    NotificationManager_SocialConnectionJoinedFormat: NotificationManager_SocialConnectionJoinedFormat,
    NotificationManager_UnsubscribeFormat: NotificationManager_UnsubscribeFormat,
    NotificationsCtrl_YouHaveRequiredLearningPluralFormat: NotificationsCtrl_YouHaveRequiredLearningPluralFormat,
    NotificationsCtrl_YouHaveRequiredLearningSingular: NotificationsCtrl_YouHaveRequiredLearningSingular,
    NotificationSvc_Notifications: NotificationSvc_Notifications,
    "Onboarding_ AddedSkill": "Comp\xe9tence ajout\xe9e",
    Onboarding_A11yAssignedStepName: Onboarding_A11yAssignedStepName,
    Onboarding_A11yResumeReviewStepName: Onboarding_A11yResumeReviewStepName,
    Onboarding_A11yRoleSelectStepName: Onboarding_A11yRoleSelectStepName,
    Onboarding_A11ySkillAdded: Onboarding_A11ySkillAdded,
    Onboarding_A11ySkillAlreadyAdded: Onboarding_A11ySkillAlreadyAdded,
    Onboarding_A11ySkillsStepName: Onboarding_A11ySkillsStepName,
    Onboarding_A11yStartLearningStepName: Onboarding_A11yStartLearningStepName,
    Onboarding_AddedSkill: Onboarding_AddedSkill,
    Onboarding_AdditionalSkillsDescription: Onboarding_AdditionalSkillsDescription,
    Onboarding_AdditionalSkillsInterstedIn: Onboarding_AdditionalSkillsInterstedIn,
    Onboarding_AdditionalSkillsTitle: Onboarding_AdditionalSkillsTitle,
    Onboarding_AISkillsSuggestDesc: Onboarding_AISkillsSuggestDesc,
    Onboarding_AISkillsSuggestLabel: Onboarding_AISkillsSuggestLabel,
    Onboarding_AreYouSureDescription: Onboarding_AreYouSureDescription,
    Onboarding_AreYouSureHeading: Onboarding_AreYouSureHeading,
    Onboarding_AssignedSkillsDescription: Onboarding_AssignedSkillsDescription,
    Onboarding_AssignedSkillsError: Onboarding_AssignedSkillsError,
    Onboarding_AssignedSkillsHeader: Onboarding_AssignedSkillsHeader,
    Onboarding_AssignedSkillsInformationTooltip: Onboarding_AssignedSkillsInformationTooltip,
    Onboarding_AssignedSkillsWarning: Onboarding_AssignedSkillsWarning,
    Onboarding_BackupEmailAddressDesc: Onboarding_BackupEmailAddressDesc,
    Onboarding_ExperienceDatePresent: Onboarding_ExperienceDatePresent,
    Onboarding_ExperienceDateYears: Onboarding_ExperienceDateYears,
    Onboarding_ExportLinkedInResume: Onboarding_ExportLinkedInResume,
    Onboarding_ExportLinkedInResumeInstructions: Onboarding_ExportLinkedInResumeInstructions,
    Onboarding_FocusSkillTooltip: Onboarding_FocusSkillTooltip,
    Onboarding_FoundExperienceHeader: Onboarding_FoundExperienceHeader,
    Onboarding_LearnFromAnySource: Onboarding_LearnFromAnySource,
    Onboarding_LearnInstructions: Onboarding_LearnInstructions,
    Onboarding_LinkedInLink: Onboarding_LinkedInLink,
    Onboarding_LoadMore: Onboarding_LoadMore,
    Onboarding_ProfileSkill: Onboarding_ProfileSkill,
    Onboarding_ProgressInstructions: Onboarding_ProgressInstructions,
    Onboarding_ProgressInYourSkills: Onboarding_ProgressInYourSkills,
    Onboarding_RatingOverflowImgAlt: Onboarding_RatingOverflowImgAlt,
    Onboarding_RatingOverflowInstructions: Onboarding_RatingOverflowInstructions,
    Onboarding_RatingOverflowTitle: Onboarding_RatingOverflowTitle,
    Onboarding_ResetTipsBody: Onboarding_ResetTipsBody,
    Onboarding_ResetTipsHeader: Onboarding_ResetTipsHeader,
    Onboarding_ResumeAdditionalSkills: Onboarding_ResumeAdditionalSkills,
    Onboarding_ResumeLastModifiedDateMessage: Onboarding_ResumeLastModifiedDateMessage,
    Onboarding_ResumeReviewPageDescription: Onboarding_ResumeReviewPageDescription,
    Onboarding_ResumeReviewTitle: Onboarding_ResumeReviewTitle,
    Onboarding_ResumeSkill: Onboarding_ResumeSkill,
    Onboarding_ReviewExperienceDescription: Onboarding_ReviewExperienceDescription,
    Onboarding_ReviewOptionalSkillsDescription: Onboarding_ReviewOptionalSkillsDescription,
    Onboarding_ReviewOptionalSkillsHeader: Onboarding_ReviewOptionalSkillsHeader,
    Onboarding_ReviewSkills_Description: Onboarding_ReviewSkills_Description,
    Onboarding_ReviewSkills_Description_Empty: Onboarding_ReviewSkills_Description_Empty,
    Onboarding_ReviewSkillsDescription: Onboarding_ReviewSkillsDescription,
    Onboarding_ReviewSkillsHeader: Onboarding_ReviewSkillsHeader,
    Onboarding_RoleSkill: Onboarding_RoleSkill,
    Onboarding_RolesStepDescription: Onboarding_RolesStepDescription,
    Onboarding_RolesStepTitle: Onboarding_RolesStepTitle,
    Onboarding_SavingError: Onboarding_SavingError,
    Onboarding_SearchRoles_NoRoleAssigned: Onboarding_SearchRoles_NoRoleAssigned,
    Onboarding_SearchRoles_SearchForRole: Onboarding_SearchRoles_SearchForRole,
    Onboarding_SearchRoles_VisitIntegration: Onboarding_SearchRoles_VisitIntegration,
    Onboarding_SearchSkills_AddSkills: Onboarding_SearchSkills_AddSkills,
    Onboarding_SearchSkills_SearchForSkills: Onboarding_SearchSkills_SearchForSkills,
    Onboarding_SearchSkills_SuggestionsHeading: Onboarding_SearchSkills_SuggestionsHeading,
    Onboarding_SearchSkills_TopSkills: Onboarding_SearchSkills_TopSkills,
    Onboarding_SecondaryEmailDesc: Onboarding_SecondaryEmailDesc,
    Onboarding_SectionTitle: Onboarding_SectionTitle,
    "Onboarding_See MyProfile": "Voir mon profil",
    Onboarding_SeeSuggestedSkills: Onboarding_SeeSuggestedSkills,
    Onboarding_SkillSelectionRequiredTooltip: Onboarding_SkillSelectionRequiredTooltip,
    Onboarding_Step1CategoriesImgAlt: Onboarding_Step1CategoriesImgAlt,
    Onboarding_Step1IdeasImgAlt: Onboarding_Step1IdeasImgAlt,
    Onboarding_Step1Title: Onboarding_Step1Title,
    Onboarding_Step2Instructions: Onboarding_Step2Instructions,
    Onboarding_Step2InstructionsIntegration: Onboarding_Step2InstructionsIntegration,
    Onboarding_Step2InstructionsSkillInventory: Onboarding_Step2InstructionsSkillInventory,
    Onboarding_Step2Title: Onboarding_Step2Title,
    Onboarding_Step2TitleIntegration: Onboarding_Step2TitleIntegration,
    Onboarding_Step3Instructions: Onboarding_Step3Instructions,
    Onboarding_Step3InstructionsSkillInventory: Onboarding_Step3InstructionsSkillInventory,
    Onboarding_Step3Title: Onboarding_Step3Title,
    Onboarding_Step3TitleSkillInventory: Onboarding_Step3TitleSkillInventory,
    Onboarding_Step4Instructions: Onboarding_Step4Instructions,
    Onboarding_Step4InstructionsSkillInventory: Onboarding_Step4InstructionsSkillInventory,
    Onboarding_Step4Title: Onboarding_Step4Title,
    Onboarding_Step5Instructions: Onboarding_Step5Instructions,
    Onboarding_Step5Title: Onboarding_Step5Title,
    Onboarding_StepParse: Onboarding_StepParse,
    Onboarding_StepResults: Onboarding_StepResults,
    Onboarding_StepUpload: Onboarding_StepUpload,
    Onboarding_SuggestedSkill: Onboarding_SuggestedSkill,
    Onboarding_TrackYourSkills: Onboarding_TrackYourSkills,
    Onboarding_TrackYourSkillsInstructions: Onboarding_TrackYourSkillsInstructions,
    Onboarding_UploadResume: Onboarding_UploadResume,
    Onboarding_UploadResumeDescription: Onboarding_UploadResumeDescription,
    Onboarding_UploadResumeDescriptionTemp: Onboarding_UploadResumeDescriptionTemp,
    Onboarding_UploadResumeHeader: Onboarding_UploadResumeHeader,
    Onboarding_UploadResumeHeaderTemp: Onboarding_UploadResumeHeaderTemp,
    Onboarding_Welcome: Onboarding_Welcome,
    Onboarding_WelcomeDetails: Onboarding_WelcomeDetails,
    Onboarding_WelcomeHeading: Onboarding_WelcomeHeading,
    Onboarding_WelcomeInstructions: Onboarding_WelcomeInstructions,
    Onboarding_WelcomeMountainIllustration: Onboarding_WelcomeMountainIllustration,
    Onboarding_WelcomeTitle: Onboarding_WelcomeTitle,
    OnboardingController_PageTitle: OnboardingController_PageTitle,
    OnboardingFooter_GetStarted: OnboardingFooter_GetStarted,
    OnboardingFooter_NextStep: OnboardingFooter_NextStep,
    OnboardingFooter_PreviousStep: OnboardingFooter_PreviousStep,
    OnboardingFooter_RatingDisabledStatus: OnboardingFooter_RatingDisabledStatus,
    OnboardingFooter_SeeMyProfile: OnboardingFooter_SeeMyProfile,
    OnboardingFooter_SkipStep: OnboardingFooter_SkipStep,
    OnboardingFooter_StartLearning: OnboardingFooter_StartLearning,
    OnboardingFooter_StepperLabel: OnboardingFooter_StepperLabel,
    OnboardingFooter_SubmitRating: OnboardingFooter_SubmitRating,
    Opportunities_AcceptMenteeModal_AcceptFormatted: Opportunities_AcceptMenteeModal_AcceptFormatted,
    Opportunities_AcceptMenteeModal_AvailabilityDescription: Opportunities_AcceptMenteeModal_AvailabilityDescription,
    Opportunities_AcceptMenteeModal_AvailabilityLabel: Opportunities_AcceptMenteeModal_AvailabilityLabel,
    Opportunities_AcceptMenteeModal_ConnectLabel: Opportunities_AcceptMenteeModal_ConnectLabel,
    Opportunities_AcceptMenteeModal_ConnectLabel_Error: Opportunities_AcceptMenteeModal_ConnectLabel_Error,
    Opportunities_AcceptMenteeModal_ConnectPlaceholder: Opportunities_AcceptMenteeModal_ConnectPlaceholder,
    Opportunities_AcceptMenteeModal_Description: Opportunities_AcceptMenteeModal_Description,
    Opportunities_AcceptMenteeModal_Error: Opportunities_AcceptMenteeModal_Error,
    Opportunities_AcceptMenteeModal_SubmitButtonText: Opportunities_AcceptMenteeModal_SubmitButtonText,
    Opportunities_AcceptMenteeModal_Success: Opportunities_AcceptMenteeModal_Success,
    Opportunities_AcceptMenteeModal_Success_Multi: Opportunities_AcceptMenteeModal_Success_Multi,
    Opportunities_Actions_Edit: Opportunities_Actions_Edit,
    Opportunities_ActiveFormat: Opportunities_ActiveFormat,
    Opportunities_Activity_AsCollaborator: Opportunities_Activity_AsCollaborator,
    Opportunities_Activity_NewCandidates: Opportunities_Activity_NewCandidates,
    Opportunities_Activity_NoInterestForDays: Opportunities_Activity_NoInterestForDays,
    Opportunities_Activity_NoInterestSevenDays: Opportunities_Activity_NoInterestSevenDays,
    Opportunities_Activity_OpenMoreThanDays: Opportunities_Activity_OpenMoreThanDays,
    Opportunities_AllGroups: Opportunities_AllGroups,
    Opportunities_AllLocations: Opportunities_AllLocations,
    Opportunities_AllSkills: Opportunities_AllSkills,
    Opportunities_AllStatuses: Opportunities_AllStatuses,
    Opportunities_AllTypes: Opportunities_AllTypes,
    Opportunities_Apply: Opportunities_Apply,
    Opportunities_ArchiveCandidatesModal_Header_Bulk: Opportunities_ArchiveCandidatesModal_Header_Bulk,
    Opportunities_ArchiveCandidatesModal_Header_Singular: Opportunities_ArchiveCandidatesModal_Header_Singular,
    Opportunities_ArchiveCandidatesModal_Labels_Notify_Bulk: Opportunities_ArchiveCandidatesModal_Labels_Notify_Bulk,
    Opportunities_ArchiveCandidatesModal_Labels_Notify_Singular: Opportunities_ArchiveCandidatesModal_Labels_Notify_Singular,
    Opportunities_ArchiveCandidatesModal_Labels_RejectionMessage: Opportunities_ArchiveCandidatesModal_Labels_RejectionMessage,
    Opportunities_ArchiveCandidatesModal_Labels_RejectionMessage_Placeholder: Opportunities_ArchiveCandidatesModal_Labels_RejectionMessage_Placeholder,
    Opportunities_ArchiveCandidatesModal_SubmitButtonText: Opportunities_ArchiveCandidatesModal_SubmitButtonText,
    Opportunities_Archived: Opportunities_Archived,
    Opportunities_BrowseOpportunities: Opportunities_BrowseOpportunities,
    Opportunities_Candidates_Cols_DateAdded: Opportunities_Candidates_Cols_DateAdded,
    Opportunities_Candidates_Cols_JobTitle: Opportunities_Candidates_Cols_JobTitle,
    Opportunities_Candidates_Cols_Location: Opportunities_Candidates_Cols_Location,
    Opportunities_Candidates_Cols_Name: Opportunities_Candidates_Cols_Name,
    Opportunities_Candidates_Cols_SkillMatch: Opportunities_Candidates_Cols_SkillMatch,
    Opportunities_Candidates_Cols_Stage: Opportunities_Candidates_Cols_Stage,
    Opportunities_Candidates_Cols_Status: Opportunities_Candidates_Cols_Status,
    Opportunities_Candidates_Cols_TargetMet: Opportunities_Candidates_Cols_TargetMet,
    Opportunities_Candidates_Email_RejectionMessage: Opportunities_Candidates_Email_RejectionMessage,
    Opportunities_Candidates_Error_Get: Opportunities_Candidates_Error_Get,
    Opportunities_Candidates_Modal_Award: Opportunities_Candidates_Modal_Award,
    Opportunities_Candidates_Modal_UpdateApplicant_Description: Opportunities_Candidates_Modal_UpdateApplicant_Description,
    Opportunities_Candidates_Modal_UpdateApplicant_Title: Opportunities_Candidates_Modal_UpdateApplicant_Title,
    Opportunities_Candidates_Modal_UpdateApplicantPrompt_CloseOpp: Opportunities_Candidates_Modal_UpdateApplicantPrompt_CloseOpp,
    Opportunities_Candidates_Modal_UpdateApplicantPrompt_Congratulations: Opportunities_Candidates_Modal_UpdateApplicantPrompt_Congratulations,
    Opportunities_Candidates_Modal_UpdateApplicantPrompt_Congratulations_Plural: Opportunities_Candidates_Modal_UpdateApplicantPrompt_Congratulations_Plural,
    Opportunities_Candidates_Modal_UpdateApplicantPrompt_Description: Opportunities_Candidates_Modal_UpdateApplicantPrompt_Description,
    Opportunities_Candidates_Modal_UpdateApplicantPrompt_Description_Plural: Opportunities_Candidates_Modal_UpdateApplicantPrompt_Description_Plural,
    Opportunities_Candidates_Modal_UpdateApplicantPrompt_NotifyUnselected: Opportunities_Candidates_Modal_UpdateApplicantPrompt_NotifyUnselected,
    Opportunities_Candidates_Modal_UpdateApplicantPrompt_SubmitButton: Opportunities_Candidates_Modal_UpdateApplicantPrompt_SubmitButton,
    Opportunities_Candidates_Modal_UpdateApplicantPrompt_SubmitButton_Plural: Opportunities_Candidates_Modal_UpdateApplicantPrompt_SubmitButton_Plural,
    Opportunities_Candidates_Modal_UpdateApplicantPrompt_Title: Opportunities_Candidates_Modal_UpdateApplicantPrompt_Title,
    Opportunities_Candidates_Modal_UpdateApplicantPrompt_Title_Plural: Opportunities_Candidates_Modal_UpdateApplicantPrompt_Title_Plural,
    Opportunities_Candidates_Notice_NoCandidates: Opportunities_Candidates_Notice_NoCandidates,
    Opportunities_Candidates_Search_Placeholder: Opportunities_Candidates_Search_Placeholder,
    Opportunities_Candidates_ShowArchived: Opportunities_Candidates_ShowArchived,
    Opportunities_Candidates_Stage_Archived: Opportunities_Candidates_Stage_Archived,
    Opportunities_Candidates_Stage_None: Opportunities_Candidates_Stage_None,
    Opportunities_Candidates_Stage_Select: Opportunities_Candidates_Stage_Select,
    Opportunities_Candidates_Stage_Selected: Opportunities_Candidates_Stage_Selected,
    Opportunities_Candidates_Stage_Shortlisted: Opportunities_Candidates_Stage_Shortlisted,
    Opportunities_Candidates_Status_Interested: Opportunities_Candidates_Status_Interested,
    Opportunities_Candidates_Status_InviteSent: Opportunities_Candidates_Status_InviteSent,
    Opportunities_Candidates_Status_NoResponse: Opportunities_Candidates_Status_NoResponse,
    Opportunities_Candidates_Status_NotInterested: Opportunities_Candidates_Status_NotInterested,
    Opportunities_Candidates_UserHasNotOptedIn: Opportunities_Candidates_UserHasNotOptedIn,
    Opportunities_CareerMobility: Opportunities_CareerMobility,
    Opportunities_ChartXAxisTitle: Opportunities_ChartXAxisTitle,
    Opportunities_ClosedOnDate: Opportunities_ClosedOnDate,
    Opportunities_ConnectWithButton_Status_Accepted: Opportunities_ConnectWithButton_Status_Accepted,
    Opportunities_ConnectWithButton_Status_None: Opportunities_ConnectWithButton_Status_None,
    Opportunities_ConnectWithButton_Status_Requested: Opportunities_ConnectWithButton_Status_Requested,
    Opportunities_ConnectWithModal_ConnectWithFormatted: Opportunities_ConnectWithModal_ConnectWithFormatted,
    Opportunities_ConnectWithModal_Description: Opportunities_ConnectWithModal_Description,
    Opportunities_ConnectWithModal_Error: Opportunities_ConnectWithModal_Error,
    Opportunities_ConnectWithModal_Labels_FocusSkills: Opportunities_ConnectWithModal_Labels_FocusSkills,
    Opportunities_ConnectWithModal_Labels_FocusSkills_Description: Opportunities_ConnectWithModal_Labels_FocusSkills_Description,
    Opportunities_ConnectWithModal_Labels_FocusSkills_Description_NoSkillsExplainer: Opportunities_ConnectWithModal_Labels_FocusSkills_Description_NoSkillsExplainer,
    Opportunities_ConnectWithModal_Labels_MatchingSkills: Opportunities_ConnectWithModal_Labels_MatchingSkills,
    Opportunities_ConnectWithModal_Labels_MatchingSkills_Description: Opportunities_ConnectWithModal_Labels_MatchingSkills_Description,
    Opportunities_ConnectWithModal_Labels_Reason: Opportunities_ConnectWithModal_Labels_Reason,
    Opportunities_ConnectWithModal_OpenModal: Opportunities_ConnectWithModal_OpenModal,
    Opportunities_ConnectWithModal_Placeholders_Reason: Opportunities_ConnectWithModal_Placeholders_Reason,
    Opportunities_ConnectWithModal_SubmitButton: Opportunities_ConnectWithModal_SubmitButton,
    Opportunities_ConnectWithModal_Success: Opportunities_ConnectWithModal_Success,
    Opportunities_ConnectWithModal_Success_Mentors_Removed: Opportunities_ConnectWithModal_Success_Mentors_Removed,
    Opportunities_ConnectWithModal_Success_Updated: Opportunities_ConnectWithModal_Success_Updated,
    Opportunities_DataUpdateTimelineExplanation: Opportunities_DataUpdateTimelineExplanation,
    Opportunities_DeclineMenteeModal_DeclineFormatted: Opportunities_DeclineMenteeModal_DeclineFormatted,
    Opportunities_DeclineMenteeModal_Description: Opportunities_DeclineMenteeModal_Description,
    Opportunities_DeclineMenteeModal_Error: Opportunities_DeclineMenteeModal_Error,
    Opportunities_DeclineMenteeModal_ExplanationLabel: Opportunities_DeclineMenteeModal_ExplanationLabel,
    Opportunities_DeclineMenteeModal_ExplanationPlaceholder: Opportunities_DeclineMenteeModal_ExplanationPlaceholder,
    Opportunities_DeclineMenteeModal_SubmitButtonText: Opportunities_DeclineMenteeModal_SubmitButtonText,
    Opportunities_DeclineMenteeModal_Success: Opportunities_DeclineMenteeModal_Success,
    Opportunities_DeclineMenteeModal_Success_Multi: Opportunities_DeclineMenteeModal_Success_Multi,
    Opportunities_Discard: Opportunities_Discard,
    Opportunities_DiscardChanges: Opportunities_DiscardChanges,
    Opportunities_Discover_Error_Get: Opportunities_Discover_Error_Get,
    Opportunities_Discover_NoItems_ActionDescription: Opportunities_Discover_NoItems_ActionDescription,
    Opportunities_Discover_NoItems_ActionDescription_Public: Opportunities_Discover_NoItems_ActionDescription_Public,
    Opportunities_Discover_NoItems_Headline: Opportunities_Discover_NoItems_Headline,
    Opportunities_Discover_NoItems_Headline_Public: Opportunities_Discover_NoItems_Headline_Public,
    Opportunities_Discover_ResultsDisclaimer: Opportunities_Discover_ResultsDisclaimer,
    Opportunities_EngagementAriaLabel: Opportunities_EngagementAriaLabel,
    Opportunities_Error_AddExperience: Opportunities_Error_AddExperience,
    Opportunities_Error_Get: Opportunities_Error_Get,
    Opportunities_Error_GetApplicantData: Opportunities_Error_GetApplicantData,
    Opportunities_Error_GetMentors: Opportunities_Error_GetMentors,
    Opportunities_Error_Loading: Opportunities_Error_Loading,
    Opportunities_Error_Skill_Delete: Opportunities_Error_Skill_Delete,
    Opportunities_Error_Target_Delete: Opportunities_Error_Target_Delete,
    Opportunities_Error_UpdateApplicantsStage: Opportunities_Error_UpdateApplicantsStage,
    Opportunities_Error_UpdateApplicantStage: Opportunities_Error_UpdateApplicantStage,
    Opportunities_Errors_OpportunityIsInvalid: Opportunities_Errors_OpportunityIsInvalid,
    Opportunities_Errors_OpportunityIsInvalid_Tab: Opportunities_Errors_OpportunityIsInvalid_Tab,
    Opportunities_ExcellentFitLabel: Opportunities_ExcellentFitLabel,
    Opportunities_GetError: Opportunities_GetError,
    Opportunities_GoodFitLabel: Opportunities_GoodFitLabel,
    Opportunities_InterestByMatchedCandidates: Opportunities_InterestByMatchedCandidates,
    Opportunities_InterestByUnmatchedCandidates: Opportunities_InterestByUnmatchedCandidates,
    Opportunities_InterestConfirmed: Opportunities_InterestConfirmed,
    Opportunities_Interested: Opportunities_Interested,
    Opportunities_Interested_NoItems_ActionDescription: Opportunities_Interested_NoItems_ActionDescription,
    Opportunities_Interested_NoItems_CustomNoItemsMessage: Opportunities_Interested_NoItems_CustomNoItemsMessage,
    Opportunities_Interested_NoItems_Headline: Opportunities_Interested_NoItems_Headline,
    Opportunities_Interested_NoResult: Opportunities_Interested_NoResult,
    Opportunities_InterestNotConfirmedError: Opportunities_InterestNotConfirmedError,
    Opportunities_InterestNotRemovedError: Opportunities_InterestNotRemovedError,
    Opportunities_InterestRemoved: Opportunities_InterestRemoved,
    Opportunities_JobRoleNotSpecified: Opportunities_JobRoleNotSpecified,
    Opportunities_Marketplace: Opportunities_Marketplace,
    Opportunities_Marketplace_BasedOn_Focus: Opportunities_Marketplace_BasedOn_Focus,
    Opportunities_Marketplace_BasedOn_Goals: Opportunities_Marketplace_BasedOn_Goals,
    Opportunities_Marketplace_BasedOn_Recent: Opportunities_Marketplace_BasedOn_Recent,
    Opportunities_Marketplace_BasedOn_Skills: Opportunities_Marketplace_BasedOn_Skills,
    Opportunities_Marketplace_LaneTypes_Mentors: Opportunities_Marketplace_LaneTypes_Mentors,
    Opportunities_Marketplace_LaneTypes_Permanent: Opportunities_Marketplace_LaneTypes_Permanent,
    Opportunities_Marketplace_LaneTypes_Projects: Opportunities_Marketplace_LaneTypes_Projects,
    Opportunities_Marketplace_LaneTypes_Temporary: Opportunities_Marketplace_LaneTypes_Temporary,
    Opportunities_MatchedCandidateExplanation: Opportunities_MatchedCandidateExplanation,
    Opportunities_MatchedSkills: Opportunities_MatchedSkills,
    Opportunities_MatchingSkills: Opportunities_MatchingSkills,
    Opportunities_Mentees: Opportunities_Mentees,
    Opportunities_MenteeSkills: Opportunities_MenteeSkills,
    Opportunities_Mentoring: Opportunities_Mentoring,
    Opportunities_Mentoring_Columns_Connect: Opportunities_Mentoring_Columns_Connect,
    Opportunities_Mentors: Opportunities_Mentors,
    Opportunities_MentorSkills: Opportunities_MentorSkills,
    Opportunities_Meta_Closed: Opportunities_Meta_Closed,
    Opportunities_Meta_Location: Opportunities_Meta_Location,
    Opportunities_Meta_PublishDate: Opportunities_Meta_PublishDate,
    Opportunities_Meta_PublishDateString: Opportunities_Meta_PublishDateString,
    Opportunities_Meta_Type: Opportunities_Meta_Type,
    Opportunities_Meta_Visibility: Opportunities_Meta_Visibility,
    Opportunities_MoreDetailsMentorshipModal_Info: Opportunities_MoreDetailsMentorshipModal_Info,
    Opportunities_MoreDetailsMentorshipModal_Warning: Opportunities_MoreDetailsMentorshipModal_Warning,
    Opportunities_MyOpportunities: Opportunities_MyOpportunities,
    Opportunities_MyOpportunitiesCollaboratingOn: Opportunities_MyOpportunitiesCollaboratingOn,
    Opportunities_MyOpportunitiesCompleted: Opportunities_MyOpportunitiesCompleted,
    Opportunities_MyOpportunitiesEmptyStateText: Opportunities_MyOpportunitiesEmptyStateText,
    Opportunities_MyOpportunitiesEmptyStateTitle: Opportunities_MyOpportunitiesEmptyStateTitle,
    Opportunities_MyOpportunitiesInterested: Opportunities_MyOpportunitiesInterested,
    Opportunities_MyOpportunitiesSavedForLater: Opportunities_MyOpportunitiesSavedForLater,
    Opportunities_MyOpportunitiesSelected: Opportunities_MyOpportunitiesSelected,
    Opportunities_MyOpportunitiesSharedWithMe: Opportunities_MyOpportunitiesSharedWithMe,
    Opportunities_NoMentorship: Opportunities_NoMentorship,
    Opportunities_NoResultsForBrowse: Opportunities_NoResultsForBrowse,
    Opportunities_NoResultsForSearch: Opportunities_NoResultsForSearch,
    Opportunities_NotFound_DescriptionText: Opportunities_NotFound_DescriptionText,
    Opportunities_OpenedOnDate: Opportunities_OpenedOnDate,
    Opportunities_OpenOpportunities: Opportunities_OpenOpportunities,
    Opportunities_OpenOpportunitiesByJobRoleFormat: Opportunities_OpenOpportunitiesByJobRoleFormat,
    Opportunities_OpenOpportunitiesByType: Opportunities_OpenOpportunitiesByType,
    Opportunities_OpenOpportunitiesByTypeFormat: Opportunities_OpenOpportunitiesByTypeFormat,
    Opportunities_OpportunityEngagement: Opportunities_OpportunityEngagement,
    Opportunities_OtherSkills: Opportunities_OtherSkills,
    Opportunities_PartialFitLabel: Opportunities_PartialFitLabel,
    Opportunities_RecentSearches: Opportunities_RecentSearches,
    Opportunities_Relation: Opportunities_Relation,
    "Opportunities_Relation_ Author": "Collaborateur",
    Opportunities_Relation_Author: Opportunities_Relation_Author,
    Opportunities_Relation_InterestedApplicant: Opportunities_Relation_InterestedApplicant,
    Opportunities_Relation_SavedForLaterByUser: Opportunities_Relation_SavedForLaterByUser,
    Opportunities_Relation_SelectedApplicant: Opportunities_Relation_SelectedApplicant,
    Opportunities_RemoveArchive: Opportunities_RemoveArchive,
    Opportunities_RemoveArchived: Opportunities_RemoveArchived,
    Opportunities_RemoveInterest: Opportunities_RemoveInterest,
    Opportunities_RemoveSelected: Opportunities_RemoveSelected,
    Opportunities_RemoveShortlist: Opportunities_RemoveShortlist,
    Opportunities_RemoveShortlisted: Opportunities_RemoveShortlisted,
    Opportunities_ResultRange: Opportunities_ResultRange,
    Opportunities_SavedForLater: Opportunities_SavedForLater,
    Opportunities_Selected: Opportunities_Selected,
    Opportunities_SelectedCandidates: Opportunities_SelectedCandidates,
    Opportunities_SelectedCandidatesTooltip: Opportunities_SelectedCandidatesTooltip,
    Opportunities_SelectedMatchedCandidates: Opportunities_SelectedMatchedCandidates,
    Opportunities_SelectedUnmatchedCandidates: Opportunities_SelectedUnmatchedCandidates,
    Opportunities_SharedWithYou: Opportunities_SharedWithYou,
    Opportunities_Shortlisted: Opportunities_Shortlisted,
    Opportunities_ShowingCountOfTotalOpportunities: Opportunities_ShowingCountOfTotalOpportunities,
    Opportunities_ShowInterest: Opportunities_ShowInterest,
    Opportunities_SkillMatchFullLabel: Opportunities_SkillMatchFullLabel,
    Opportunities_SkillMatchLabel: Opportunities_SkillMatchLabel,
    Opportunities_Skills_AddSkillPlaceholder: Opportunities_Skills_AddSkillPlaceholder,
    Opportunities_Skills_AddSkillRating: Opportunities_Skills_AddSkillRating,
    Opportunities_Skills_AddSkillsAltText: Opportunities_Skills_AddSkillsAltText,
    Opportunities_Skills_AddTargetLevel: Opportunities_Skills_AddTargetLevel,
    Opportunities_Skills_EditSkillRating: Opportunities_Skills_EditSkillRating,
    Opportunities_Skills_EditTargetLevel: Opportunities_Skills_EditTargetLevel,
    Opportunities_Skills_Following_But_No_Rating: Opportunities_Skills_Following_But_No_Rating,
    Opportunities_Skills_Menu_AddTargetLevel: Opportunities_Skills_Menu_AddTargetLevel,
    Opportunities_Skills_Menu_EditTargetLevel: Opportunities_Skills_Menu_EditTargetLevel,
    Opportunities_Skills_Menu_RemoveTargetLevel: Opportunities_Skills_Menu_RemoveTargetLevel,
    Opportunities_Skills_Modal_AddTargetHeader: Opportunities_Skills_Modal_AddTargetHeader,
    Opportunities_Skills_Modal_EditTargetHeader: Opportunities_Skills_Modal_EditTargetHeader,
    Opportunities_Skills_RemoveSkillRating: Opportunities_Skills_RemoveSkillRating,
    Opportunities_SkillsMatchLabel: Opportunities_SkillsMatchLabel,
    Opportunities_SkillsMatchPercentage: Opportunities_SkillsMatchPercentage,
    Opportunities_Success_AddExperience: Opportunities_Success_AddExperience,
    Opportunities_Success_Clone: Opportunities_Success_Clone,
    Opportunities_Success_UpdateApplicantStage: Opportunities_Success_UpdateApplicantStage,
    Opportunities_SuggestedLearning: Opportunities_SuggestedLearning,
    Opportunities_SuggestedLearning_Description: Opportunities_SuggestedLearning_Description,
    Opportunities_TopLocations: Opportunities_TopLocations,
    Opportunities_TopOpportunitiesByJobRoleFormat: Opportunities_TopOpportunitiesByJobRoleFormat,
    Opportunities_TopOpportunitiesByJobRoleFormatNoCount: Opportunities_TopOpportunitiesByJobRoleFormatNoCount,
    Opportunities_TopOpportunitiesByTypeFormat: Opportunities_TopOpportunitiesByTypeFormat,
    Opportunities_TopSkillsInDemandFormat: Opportunities_TopSkillsInDemandFormat,
    Opportunities_TypeDynamicTeamAssignment: Opportunities_TypeDynamicTeamAssignment,
    Opportunities_TypeJobDescription: Opportunities_TypeJobDescription,
    Opportunities_TypeLookingForMentee: Opportunities_TypeLookingForMentee,
    Opportunities_TypeLookingForMentor: Opportunities_TypeLookingForMentor,
    Opportunities_TypeMenteeship: Opportunities_TypeMenteeship,
    Opportunities_TypeMenteeshipDescription: Opportunities_TypeMenteeshipDescription,
    Opportunities_TypeMentorship: Opportunities_TypeMentorship,
    Opportunities_TypeMentorshipDescription: Opportunities_TypeMentorshipDescription,
    Opportunities_TypeOther: Opportunities_TypeOther,
    Opportunities_TypeOtherDescription: Opportunities_TypeOtherDescription,
    Opportunities_TypePeerMentoring: Opportunities_TypePeerMentoring,
    Opportunities_TypePermanent: Opportunities_TypePermanent,
    Opportunities_TypeProBono: Opportunities_TypeProBono,
    Opportunities_TypeProject: Opportunities_TypeProject,
    Opportunities_TypeProjectDescription: Opportunities_TypeProjectDescription,
    Opportunities_TypeReverseMentoring: Opportunities_TypeReverseMentoring,
    Opportunities_TypeSecondment: Opportunities_TypeSecondment,
    Opportunities_TypeShadowing: Opportunities_TypeShadowing,
    Opportunities_TypeShadowingDescription: Opportunities_TypeShadowingDescription,
    Opportunities_TypeStretchAssignment: Opportunities_TypeStretchAssignment,
    Opportunities_TypeStretchAssignmentDescription: Opportunities_TypeStretchAssignmentDescription,
    Opportunities_TypeTemporary: Opportunities_TypeTemporary,
    Opportunities_TypeVolunteer: Opportunities_TypeVolunteer,
    Opportunities_UnmatchedCandidateExplanation: Opportunities_UnmatchedCandidateExplanation,
    Opportunities_UnmatchedSkills: Opportunities_UnmatchedSkills,
    Opportunities_UnsavedChanges: Opportunities_UnsavedChanges,
    Opportunities_UserRateSkillsModal_Header: Opportunities_UserRateSkillsModal_Header,
    Opportunities_View_Error_Get: Opportunities_View_Error_Get,
    Opportunities_ViewAll: Opportunities_ViewAll,
    Opportunities_ViewAllCollaborators: Opportunities_ViewAllCollaborators,
    Opportunities_ViewByMatchedCandidates: Opportunities_ViewByMatchedCandidates,
    Opportunities_ViewByUnmatchedCandidates: Opportunities_ViewByUnmatchedCandidates,
    Opportunities_Viewing: Opportunities_Viewing,
    Opportunities_ViewOpportunity: Opportunities_ViewOpportunity,
    Opportunities_ViewsAndInterest: Opportunities_ViewsAndInterest,
    Opportunities_ViewsAndInterestsTooltip: Opportunities_ViewsAndInterestsTooltip,
    Opportunities_YourOpportunities: Opportunities_YourOpportunities,
    OpportunityApplicantSelected_NotificationTitleFormat: OpportunityApplicantSelected_NotificationTitleFormat,
    opportunityNewAuthor_NotificationTitleFormat: opportunityNewAuthor_NotificationTitleFormat,
    OrganizationsController_AddFAQs: OrganizationsController_AddFAQs,
    OrganizationsController_BackToOrgFormat: OrganizationsController_BackToOrgFormat,
    OrganizationsController_Branding: OrganizationsController_Branding,
    OrganizationsController_Content: OrganizationsController_Content,
    OrganizationsController_EditImage: OrganizationsController_EditImage,
    OrganizationsController_EstimateInfo: OrganizationsController_EstimateInfo,
    OrganizationsController_FAQ: OrganizationsController_FAQ,
    OrganizationsController_FileLog: OrganizationsController_FileLog,
    OrganizationsController_FileUpload: OrganizationsController_FileUpload,
    OrganizationsController_Groups: OrganizationsController_Groups,
    OrganizationsController_HelpMenu: OrganizationsController_HelpMenu,
    OrganizationsController_Home: OrganizationsController_Home,
    OrganizationsController_Insights: OrganizationsController_Insights,
    OrganizationsController_InsightsAndUsage: OrganizationsController_InsightsAndUsage,
    OrganizationsController_InvitedMessageOne: OrganizationsController_InvitedMessageOne,
    OrganizationsController_InviteMessageTwo: OrganizationsController_InviteMessageTwo,
    OrganizationsController_JobRoles: OrganizationsController_JobRoles,
    OrganizationsController_Links: OrganizationsController_Links,
    OrganizationsController_ManageAdvanced: OrganizationsController_ManageAdvanced,
    OrganizationsController_ManageCatalog: OrganizationsController_ManageCatalog,
    OrganizationsController_ManageFAQ: OrganizationsController_ManageFAQ,
    OrganizationsController_ManageGroups: OrganizationsController_ManageGroups,
    OrganizationsController_ManageJobRoles: OrganizationsController_ManageJobRoles,
    OrganizationsController_ManageOpportunities: OrganizationsController_ManageOpportunities,
    OrganizationsController_ManagePathways: OrganizationsController_ManagePathways,
    OrganizationsController_ManagePeople: OrganizationsController_ManagePeople,
    OrganizationsController_ManagePlans: OrganizationsController_ManagePlans,
    OrganizationsController_ManagePublishedPathways: OrganizationsController_ManagePublishedPathways,
    OrganizationsController_ManageSkills: OrganizationsController_ManageSkills,
    OrganizationsController_Messaging: OrganizationsController_Messaging,
    OrganizationsController_NotEnoughActivity: OrganizationsController_NotEnoughActivity,
    OrganizationsController_Opportunities: OrganizationsController_Opportunities,
    OrganizationsController_OrganizationDetails: OrganizationsController_OrganizationDetails,
    OrganizationsController_Pages: OrganizationsController_Pages,
    OrganizationsController_Pathways: OrganizationsController_Pathways,
    OrganizationsController_People: OrganizationsController_People,
    OrganizationsController_Permissions: OrganizationsController_Permissions,
    OrganizationsController_Plans: OrganizationsController_Plans,
    OrganizationsController_Providers: OrganizationsController_Providers,
    OrganizationsController_Reporting: OrganizationsController_Reporting,
    OrganizationsController_ReportsNotAvailable: OrganizationsController_ReportsNotAvailable,
    OrganizationsController_ScanPreferences: OrganizationsController_ScanPreferences,
    OrganizationsController_Segments: OrganizationsController_Segments,
    OrganizationsController_SelectContentTypes: OrganizationsController_SelectContentTypes,
    OrganizationsController_Settings: OrganizationsController_Settings,
    OrganizationsController_Skills: OrganizationsController_Skills,
    OrganizationsController_SkillToRoleSuggestions: OrganizationsController_SkillToRoleSuggestions,
    OrganizationsController_StartScan: OrganizationsController_StartScan,
    OrganizationsController_SubmitQuestion: OrganizationsController_SubmitQuestion,
    OrganizationsController_WelcomeToDegreed: OrganizationsController_WelcomeToDegreed,
    OrgAnnouncement_ActivateDesc: OrgAnnouncement_ActivateDesc,
    OrgAnnouncement_ActivateLabel: OrgAnnouncement_ActivateLabel,
    OrgAnnouncement_AddALink: OrgAnnouncement_AddALink,
    OrgAnnouncement_BlankDescription: OrgAnnouncement_BlankDescription,
    OrgAnnouncement_Desc: OrgAnnouncement_Desc,
    OrgAnnouncement_DescriptionPlaceholder: OrgAnnouncement_DescriptionPlaceholder,
    OrgAnnouncement_ImageDesc: OrgAnnouncement_ImageDesc,
    OrgAnnouncement_ImageDescNew: OrgAnnouncement_ImageDescNew,
    OrgAnnouncement_Label: OrgAnnouncement_Label,
    OrgAnnouncement_LinkNamePlaceholder: OrgAnnouncement_LinkNamePlaceholder,
    OrgAnnouncement_LinkUrlHelperText: OrgAnnouncement_LinkUrlHelperText,
    OrgAnnouncement_RetrievingError: OrgAnnouncement_RetrievingError,
    OrgAnnouncement_TitlePlaceholder: OrgAnnouncement_TitlePlaceholder,
    OrgFaqCtrl_AnswerText: OrgFaqCtrl_AnswerText,
    OrgFaqCtrl_EnterSearchTerm: OrgFaqCtrl_EnterSearchTerm,
    OrgFaqCtrl_FaqHeading: OrgFaqCtrl_FaqHeading,
    OrgFaqCtrl_MaxResultsNarrowYourSearch: OrgFaqCtrl_MaxResultsNarrowYourSearch,
    OrgFaqCtrl_NewQuestion: OrgFaqCtrl_NewQuestion,
    OrgFaqCtrl_NoFaqsFoundFormat: OrgFaqCtrl_NoFaqsFoundFormat,
    OrgFaqCtrl_RemoveFaqButton: OrgFaqCtrl_RemoveFaqButton,
    OrgFaqCtrl_RemoveFaqConfirmContinue: OrgFaqCtrl_RemoveFaqConfirmContinue,
    OrgFaqCtrl_RemoveFaqDescriptionFormat: OrgFaqCtrl_RemoveFaqDescriptionFormat,
    OrgFaqCtrl_RemoveFaqHeadingFormat: OrgFaqCtrl_RemoveFaqHeadingFormat,
    OrgFaqCtrl_SearchForFaq: OrgFaqCtrl_SearchForFaq,
    OrgFtp_AllyText_CloseDetailsFormat: OrgFtp_AllyText_CloseDetailsFormat,
    OrgFtp_AllyText_SeeDetailsFormat: OrgFtp_AllyText_SeeDetailsFormat,
    OrgFtp_ChangedRowPluralFormat: OrgFtp_ChangedRowPluralFormat,
    OrgFtp_ChangedRowSingleFormat: OrgFtp_ChangedRowSingleFormat,
    OrgFtp_ClientUserFileWarning: OrgFtp_ClientUserFileWarning,
    OrgFtp_ContactSupport: OrgFtp_ContactSupport,
    OrgFtp_CorrectYourRows: OrgFtp_CorrectYourRows,
    OrgFtp_Discard: OrgFtp_Discard,
    OrgFtp_DiscardConfirmationMessage: OrgFtp_DiscardConfirmationMessage,
    OrgFtp_DiscardFile: OrgFtp_DiscardFile,
    OrgFtp_DragAndDrop: OrgFtp_DragAndDrop,
    OrgFtp_DragAndDropImage: OrgFtp_DragAndDropImage,
    OrgFtp_ErrorDiscardingFile: OrgFtp_ErrorDiscardingFile,
    OrgFtp_ErrorFileDetails: OrgFtp_ErrorFileDetails,
    OrgFtp_ErrorUnknownFormat: OrgFtp_ErrorUnknownFormat,
    OrgFtp_File_Error_DelimiterNotFound_Description: OrgFtp_File_Error_DelimiterNotFound_Description,
    OrgFtp_File_Error_DelimiterNotFound_Title: OrgFtp_File_Error_DelimiterNotFound_Title,
    OrgFtp_File_Error_DescriptionColumnMissing_Description: OrgFtp_File_Error_DescriptionColumnMissing_Description,
    OrgFtp_File_Error_DescriptionColumnMissing_Title: OrgFtp_File_Error_DescriptionColumnMissing_Title,
    OrgFtp_File_Error_DuplicateColumnFound_Description: OrgFtp_File_Error_DuplicateColumnFound_Description,
    OrgFtp_File_Error_DuplicateColumnFound_Title: OrgFtp_File_Error_DuplicateColumnFound_Title,
    OrgFtp_File_Error_ErrorParsingFile_Description: OrgFtp_File_Error_ErrorParsingFile_Description,
    OrgFtp_File_Error_ErrorParsingFile_Title: OrgFtp_File_Error_ErrorParsingFile_Title,
    OrgFtp_File_Error_ErrorParsingRows_Description: OrgFtp_File_Error_ErrorParsingRows_Description,
    OrgFtp_File_Error_ErrorParsingRows_Title: OrgFtp_File_Error_ErrorParsingRows_Title,
    OrgFtp_File_Error_ExternalIdColumnMissing_Description: OrgFtp_File_Error_ExternalIdColumnMissing_Description,
    OrgFtp_File_Error_ExternalIdColumnMissing_Title: OrgFtp_File_Error_ExternalIdColumnMissing_Title,
    OrgFtp_File_Error_FileIsEmpty_Description: OrgFtp_File_Error_FileIsEmpty_Description,
    OrgFtp_File_Error_FileIsEmpty_Title: OrgFtp_File_Error_FileIsEmpty_Title,
    OrgFtp_File_Error_FileNotFound_Description: OrgFtp_File_Error_FileNotFound_Description,
    OrgFtp_File_Error_FileNotFound_Title: OrgFtp_File_Error_FileNotFound_Title,
    OrgFtp_File_Error_InvalidFields_Description: OrgFtp_File_Error_InvalidFields_Description,
    OrgFtp_File_Error_InvalidFields_Title: OrgFtp_File_Error_InvalidFields_Title,
    OrgFtp_File_Error_NameColumnMissing_Description: OrgFtp_File_Error_NameColumnMissing_Description,
    OrgFtp_File_Error_NameColumnMissing_Title: OrgFtp_File_Error_NameColumnMissing_Title,
    OrgFtp_File_Error_NoColumnsFound_Description: OrgFtp_File_Error_NoColumnsFound_Description,
    OrgFtp_File_Error_NoColumnsFound_Title: OrgFtp_File_Error_NoColumnsFound_Title,
    OrgFtp_File_Error_NoDatabaseFileInfo_Description: OrgFtp_File_Error_NoDatabaseFileInfo_Description,
    OrgFtp_File_Error_NoDatabaseFileInfo_Title: OrgFtp_File_Error_NoDatabaseFileInfo_Title,
    OrgFtp_File_Error_NoFileInfoReturned_Description: OrgFtp_File_Error_NoFileInfoReturned_Description,
    OrgFtp_File_Error_NoFileInfoReturned_Title: OrgFtp_File_Error_NoFileInfoReturned_Title,
    OrgFtp_File_Error_NotifyParseFailure_Description: OrgFtp_File_Error_NotifyParseFailure_Description,
    OrgFtp_File_Error_NotifyParseFailure_Title: OrgFtp_File_Error_NotifyParseFailure_Title,
    OrgFtp_File_Error_ProcessingError_Description: OrgFtp_File_Error_ProcessingError_Description,
    OrgFtp_File_Error_TypeColumnMissing_Description: OrgFtp_File_Error_TypeColumnMissing_Description,
    OrgFtp_File_Error_TypeColumnMissing_Title: OrgFtp_File_Error_TypeColumnMissing_Title,
    OrgFtp_File_Error_UniqueIdColumnMissing_Description: OrgFtp_File_Error_UniqueIdColumnMissing_Description,
    OrgFtp_File_Error_UniqueIdColumnMissing_Title: OrgFtp_File_Error_UniqueIdColumnMissing_Title,
    OrgFtp_File_Error_Unknown_Description: OrgFtp_File_Error_Unknown_Description,
    OrgFtp_File_Error_Unknown_Title: OrgFtp_File_Error_Unknown_Title,
    OrgFtp_File_Error_UnrecognizedExtension_Description: OrgFtp_File_Error_UnrecognizedExtension_Description,
    OrgFtp_File_Error_UnrecognizedExtension_Title: OrgFtp_File_Error_UnrecognizedExtension_Title,
    OrgFtp_File_Error_UnsupportedExtension_Description: OrgFtp_File_Error_UnsupportedExtension_Description,
    OrgFtp_File_Error_UnsupportedExtension_Title: OrgFtp_File_Error_UnsupportedExtension_Title,
    OrgFtp_File_Error_ValueColumnMissing_Description: OrgFtp_File_Error_ValueColumnMissing_Description,
    OrgFtp_File_Error_ValueColumnMissing_Title: OrgFtp_File_Error_ValueColumnMissing_Title,
    OrgFtp_File_Rejected_Error_Format: OrgFtp_File_Rejected_Error_Format,
    OrgFtp_FileError: OrgFtp_FileError,
    OrgFtp_LandingPage_Description_BulkOpportunities: OrgFtp_LandingPage_Description_BulkOpportunities,
    OrgFtp_LandingPage_Description_BulkTaxonomyRoles: OrgFtp_LandingPage_Description_BulkTaxonomyRoles,
    OrgFtp_LandingPage_Description_BulkTaxonomySkills: OrgFtp_LandingPage_Description_BulkTaxonomySkills,
    OrgFtp_LandingPage_Description_ClientUser: OrgFtp_LandingPage_Description_ClientUser,
    OrgFtp_LandingPage_Description_Completion: OrgFtp_LandingPage_Description_Completion,
    OrgFtp_LandingPage_Description_Content: OrgFtp_LandingPage_Description_Content,
    OrgFtp_LandingPage_Description_Groups: OrgFtp_LandingPage_Description_Groups,
    OrgFtp_LandingPage_Description_RequiredLearning: OrgFtp_LandingPage_Description_RequiredLearning,
    OrgFtp_LandingPage_Description_UserUpdate: OrgFtp_LandingPage_Description_UserUpdate,
    OrgFtp_LandingPage_Type_Badge: OrgFtp_LandingPage_Type_Badge,
    OrgFtp_LandingPage_Type_BulkOpportunities: OrgFtp_LandingPage_Type_BulkOpportunities,
    OrgFtp_LandingPage_Type_BulkTaxonomyRoles: OrgFtp_LandingPage_Type_BulkTaxonomyRoles,
    OrgFtp_LandingPage_Type_BulkTaxonomySkills: OrgFtp_LandingPage_Type_BulkTaxonomySkills,
    OrgFtp_LandingPage_Type_ClientUser: OrgFtp_LandingPage_Type_ClientUser,
    OrgFtp_LandingPage_Type_Completion: OrgFtp_LandingPage_Type_Completion,
    OrgFtp_LandingPage_Type_Content: OrgFtp_LandingPage_Type_Content,
    OrgFtp_LandingPage_Type_Groups: OrgFtp_LandingPage_Type_Groups,
    OrgFtp_LandingPage_Type_JobRole: OrgFtp_LandingPage_Type_JobRole,
    OrgFtp_LandingPage_Type_Opportunity: OrgFtp_LandingPage_Type_Opportunity,
    OrgFtp_LandingPage_Type_RequiredLearning: OrgFtp_LandingPage_Type_RequiredLearning,
    OrgFtp_LandingPage_Type_Skill: OrgFtp_LandingPage_Type_Skill,
    OrgFtp_LandingPage_Type_SkillAssessment: OrgFtp_LandingPage_Type_SkillAssessment,
    OrgFtp_LandingPage_Type_UserUpdate: OrgFtp_LandingPage_Type_UserUpdate,
    OrgFtp_Note: OrgFtp_Note,
    OrgFtp_PendingChangedRowPluralFormat: OrgFtp_PendingChangedRowPluralFormat,
    OrgFtp_PendingChangedRowSingleFormat: OrgFtp_PendingChangedRowSingleFormat,
    OrgFtp_PendingFileWarning: OrgFtp_PendingFileWarning,
    OrgFtp_PendingRejectedRowPluralFormat: OrgFtp_PendingRejectedRowPluralFormat,
    OrgFtp_PendingRejectedRowSingleFormat: OrgFtp_PendingRejectedRowSingleFormat,
    OrgFtp_PendingWarningRowPluralFormat: OrgFtp_PendingWarningRowPluralFormat,
    OrgFtp_PendingWarningRowSingleFormat: OrgFtp_PendingWarningRowSingleFormat,
    OrgFtp_PreviewingXOfYRows_PluralFormat: OrgFtp_PreviewingXOfYRows_PluralFormat,
    OrgFtp_Processing: OrgFtp_Processing,
    OrgFtp_ProcessingError: OrgFtp_ProcessingError,
    OrgFtp_RejectedRowPluralFormat: OrgFtp_RejectedRowPluralFormat,
    OrgFtp_RejectedRowSingleFormat: OrgFtp_RejectedRowSingleFormat,
    OrgFtp_ReviewAndSubmit: OrgFtp_ReviewAndSubmit,
    OrgFtp_Row_Error_ConflictingRecord_Description: OrgFtp_Row_Error_ConflictingRecord_Description,
    OrgFtp_Row_Error_ConflictingRecord_Title: OrgFtp_Row_Error_ConflictingRecord_Title,
    OrgFtp_Row_Error_ContentNotFound_Description: OrgFtp_Row_Error_ContentNotFound_Description,
    OrgFtp_Row_Error_ContentNotFound_Title: OrgFtp_Row_Error_ContentNotFound_Title,
    OrgFtp_Row_Error_CustomAttributeTypeMissmatch_Description: OrgFtp_Row_Error_CustomAttributeTypeMissmatch_Description,
    OrgFtp_Row_Error_CustomAttributeTypeMissmatch_Title: OrgFtp_Row_Error_CustomAttributeTypeMissmatch_Title,
    OrgFtp_Row_Error_DuplicateCategoryName_Title: OrgFtp_Row_Error_DuplicateCategoryName_Title,
    OrgFtp_Row_Error_DuplicateEmail_Description: OrgFtp_Row_Error_DuplicateEmail_Description,
    OrgFtp_Row_Error_DuplicateEmail_Title: OrgFtp_Row_Error_DuplicateEmail_Title,
    OrgFtp_Row_Error_DuplicateExternalId_Title: OrgFtp_Row_Error_DuplicateExternalId_Title,
    OrgFtp_Row_Error_DuplicateLocalizeSkillName_Title: OrgFtp_Row_Error_DuplicateLocalizeSkillName_Title,
    OrgFtp_Row_Error_DuplicateRow_Description: OrgFtp_Row_Error_DuplicateRow_Description,
    OrgFtp_Row_Error_DuplicateRow_Title: OrgFtp_Row_Error_DuplicateRow_Title,
    OrgFtp_Row_Error_DuplicateSkillName_Title: OrgFtp_Row_Error_DuplicateSkillName_Title,
    OrgFtp_Row_Error_DuplicateSynonym_Title: OrgFtp_Row_Error_DuplicateSynonym_Title,
    OrgFtp_Row_Error_EmptyContentType_Description: OrgFtp_Row_Error_EmptyContentType_Description,
    OrgFtp_Row_Error_EmptyContentType_Title: OrgFtp_Row_Error_EmptyContentType_Title,
    OrgFtp_Row_Error_EmptyUpdateType_Description: OrgFtp_Row_Error_EmptyUpdateType_Description,
    OrgFtp_Row_Error_EmptyUpdateType_Title: OrgFtp_Row_Error_EmptyUpdateType_Title,
    OrgFtp_Row_Error_FieldExceedsMaxLength_Title: OrgFtp_Row_Error_FieldExceedsMaxLength_Title,
    OrgFtp_Row_Error_InvalidDuration_Description: OrgFtp_Row_Error_InvalidDuration_Description,
    OrgFtp_Row_Error_InvalidDuration_Title: OrgFtp_Row_Error_InvalidDuration_Title,
    OrgFtp_Row_Error_InvalidLanguageCode_Title: OrgFtp_Row_Error_InvalidLanguageCode_Title,
    OrgFtp_Row_Error_InvalidLearningMinutes_Description: OrgFtp_Row_Error_InvalidLearningMinutes_Description,
    OrgFtp_Row_Error_InvalidLearningMinutes_Title: OrgFtp_Row_Error_InvalidLearningMinutes_Title,
    OrgFtp_Row_Error_MaximumRowWidthExceeded_Description: OrgFtp_Row_Error_MaximumRowWidthExceeded_Description,
    OrgFtp_Row_Error_MaximumRowWidthExceeded_Title: OrgFtp_Row_Error_MaximumRowWidthExceeded_Title,
    OrgFtp_Row_Error_MissingRequiredColumn_Description: OrgFtp_Row_Error_MissingRequiredColumn_Description,
    OrgFtp_Row_Error_MissingRequiredColumn_Title: OrgFtp_Row_Error_MissingRequiredColumn_Title,
    OrgFtp_Row_Error_Unknown_Description: OrgFtp_Row_Error_Unknown_Description,
    OrgFtp_Row_Error_Unknown_Title: OrgFtp_Row_Error_Unknown_Title,
    OrgFtp_Row_Error_UnknownCategoryName_Title: OrgFtp_Row_Error_UnknownCategoryName_Title,
    OrgFtp_Row_Error_UnknownContentType_Description: OrgFtp_Row_Error_UnknownContentType_Description,
    OrgFtp_Row_Error_UnknownContentType_Title: OrgFtp_Row_Error_UnknownContentType_Title,
    OrgFtp_Row_Error_UnknownGroup_Description: OrgFtp_Row_Error_UnknownGroup_Description,
    OrgFtp_Row_Error_UnknownGroup_Title: OrgFtp_Row_Error_UnknownGroup_Title,
    OrgFtp_Row_Error_UnknownPathway_Description: OrgFtp_Row_Error_UnknownPathway_Description,
    OrgFtp_Row_Error_UnknownPathway_Title: OrgFtp_Row_Error_UnknownPathway_Title,
    OrgFtp_Row_Error_UnknownPlan_Description: OrgFtp_Row_Error_UnknownPlan_Description,
    OrgFtp_Row_Error_UnknownPlan_Title: OrgFtp_Row_Error_UnknownPlan_Title,
    OrgFtp_Row_Error_UnknownSkillName_Title: OrgFtp_Row_Error_UnknownSkillName_Title,
    OrgFtp_Row_Error_UnknownSkillPlan_Description: OrgFtp_Row_Error_UnknownSkillPlan_Description,
    OrgFtp_Row_Error_UnknownSkillPlan_Title: OrgFtp_Row_Error_UnknownSkillPlan_Title,
    OrgFtp_Row_Error_UnknownUpdateType_Description: OrgFtp_Row_Error_UnknownUpdateType_Description,
    OrgFtp_Row_Error_UnknownUpdateType_Title: OrgFtp_Row_Error_UnknownUpdateType_Title,
    OrgFtp_Row_Error_UnsupportedDisplayLanguage_Description: OrgFtp_Row_Error_UnsupportedDisplayLanguage_Description,
    OrgFtp_Row_Error_UnsupportedDisplayLanguage_Title: OrgFtp_Row_Error_UnsupportedDisplayLanguage_Title,
    OrgFtp_Row_Error_UnsupportedFileContentType_Description: OrgFtp_Row_Error_UnsupportedFileContentType_Description,
    OrgFtp_Row_Error_UnsupportedFileContentType_Title: OrgFtp_Row_Error_UnsupportedFileContentType_Title,
    OrgFtp_Row_Error_UserNotFound_Description: OrgFtp_Row_Error_UserNotFound_Description,
    OrgFtp_Row_Error_UserNotFound_Title: OrgFtp_Row_Error_UserNotFound_Title,
    OrgFtp_RowNumber: OrgFtp_RowNumber,
    OrgFtp_Select: OrgFtp_Select,
    OrgFtp_SelectFileTypeToUpload: OrgFtp_SelectFileTypeToUpload,
    OrgFtp_StatusBadge_Error: OrgFtp_StatusBadge_Error,
    OrgFtp_StatusBadge_Pending: OrgFtp_StatusBadge_Pending,
    OrgFtp_StatusBadge_Processing: OrgFtp_StatusBadge_Processing,
    OrgFtp_StatusBadge_ProcessingError: OrgFtp_StatusBadge_ProcessingError,
    OrgFtp_StatusBadge_Rejected: OrgFtp_StatusBadge_Rejected,
    OrgFtp_StatusBadge_Success: OrgFtp_StatusBadge_Success,
    OrgFtp_StatusBadge_Warning: OrgFtp_StatusBadge_Warning,
    OrgFtp_SubmitFile: OrgFtp_SubmitFile,
    OrgFtp_Success: OrgFtp_Success,
    OrgFtp_TemplateInstructions: OrgFtp_TemplateInstructions,
    OrgFtp_TemplateInstructions_LongFormInstructions_Header1: OrgFtp_TemplateInstructions_LongFormInstructions_Header1,
    OrgFtp_TemplateInstructions_LongFormInstructions_Header2: OrgFtp_TemplateInstructions_LongFormInstructions_Header2,
    OrgFtp_TemplateInstructions_LongFormInstructions_Header3: OrgFtp_TemplateInstructions_LongFormInstructions_Header3,
    OrgFtp_TemplateInstructions_LongFormInstructions_Link1: OrgFtp_TemplateInstructions_LongFormInstructions_Link1,
    OrgFtp_TemplateInstructions_LongFormInstructions_Para2: OrgFtp_TemplateInstructions_LongFormInstructions_Para2,
    OrgFtp_TemplateInstructions_LongFormInstructions_Para3: OrgFtp_TemplateInstructions_LongFormInstructions_Para3,
    OrgFtp_TemplateInstructions_LongFormInstructions_Para4: OrgFtp_TemplateInstructions_LongFormInstructions_Para4,
    OrgFtp_TemplateInstructions_LongFormInstructions_Para5: OrgFtp_TemplateInstructions_LongFormInstructions_Para5,
    OrgFtp_ThereMightBeSomeDelay: OrgFtp_ThereMightBeSomeDelay,
    OrgFtp_Types_RowsWithErrors: OrgFtp_Types_RowsWithErrors,
    OrgFtp_Types_RowsWithWarnings: OrgFtp_Types_RowsWithWarnings,
    OrgFtp_TypesTooltips_RowsWithErrors: OrgFtp_TypesTooltips_RowsWithErrors,
    OrgFtp_TypesTooltips_RowsWithWarnings: OrgFtp_TypesTooltips_RowsWithWarnings,
    OrgFtp_UploadFile: OrgFtp_UploadFile,
    OrgFtp_ViewFileDetails: OrgFtp_ViewFileDetails,
    OrgFtp_ViewFileLog: OrgFtp_ViewFileLog,
    OrgFtp_WarningRowPluralFormat: OrgFtp_WarningRowPluralFormat,
    OrgFtp_WarningRowSingleFormat: OrgFtp_WarningRowSingleFormat,
    OrgFtp_WillBeRejectedRowPluralFormat: OrgFtp_WillBeRejectedRowPluralFormat,
    OrgFtp_WillBeRejectedRowSingleFormat: OrgFtp_WillBeRejectedRowSingleFormat,
    OrgFtp_WillChangeRowPluralFormat: OrgFtp_WillChangeRowPluralFormat,
    OrgFtp_WillChangeRowSingleFormat: OrgFtp_WillChangeRowSingleFormat,
    OrgFtp_WillHaveWarningRowPluralFormat: OrgFtp_WillHaveWarningRowPluralFormat,
    OrgFtp_WillHaveWarningRowSingleFormat: OrgFtp_WillHaveWarningRowSingleFormat,
    OrgFtp_YourFileIsBeingProcessed: OrgFtp_YourFileIsBeingProcessed,
    OrgGroupsCtrl_AdministrativeDynamic: OrgGroupsCtrl_AdministrativeDynamic,
    OrgGroupsCtrl_AdministrativeGroup: OrgGroupsCtrl_AdministrativeGroup,
    OrgGroupsCtrl_AdministrativeStatic: OrgGroupsCtrl_AdministrativeStatic,
    OrgGroupsCtrl_AvailableGroupsHeading: OrgGroupsCtrl_AvailableGroupsHeading,
    OrgGroupsCtrl_BecomeMember: OrgGroupsCtrl_BecomeMember,
    OrgGroupsCtrl_Closed: OrgGroupsCtrl_Closed,
    OrgGroupsCtrl_ClosedGroup: OrgGroupsCtrl_ClosedGroup,
    OrgGroupsCtrl_CreateAGroup: OrgGroupsCtrl_CreateAGroup,
    OrgGroupsCtrl_DeletePluralPrompt: OrgGroupsCtrl_DeletePluralPrompt,
    OrgGroupsCtrl_DeletePrompt: OrgGroupsCtrl_DeletePrompt,
    OrgGroupsCtrl_Dynamic: OrgGroupsCtrl_Dynamic,
    OrgGroupsCtrl_GroupMembers: OrgGroupsCtrl_GroupMembers,
    OrgGroupsCtrl_GroupName: OrgGroupsCtrl_GroupName,
    OrgGroupsCtrl_GroupsTitle: OrgGroupsCtrl_GroupsTitle,
    OrgGroupsCtrl_GroupVisibility: OrgGroupsCtrl_GroupVisibility,
    OrgGroupsCtrl_JoinGroup: OrgGroupsCtrl_JoinGroup,
    OrgGroupsCtrl_Leave: OrgGroupsCtrl_Leave,
    OrgGroupsCtrl_LeaveGroup: OrgGroupsCtrl_LeaveGroup,
    OrgGroupsCtrl_LeaveGroupModalBodyText: OrgGroupsCtrl_LeaveGroupModalBodyText,
    OrgGroupsCtrl_LeaveGroupModalHeader: OrgGroupsCtrl_LeaveGroupModalHeader,
    OrgGroupsCtrl_MyGroupsHeading: OrgGroupsCtrl_MyGroupsHeading,
    OrgGroupsCtrl_NoGroupsCreatedMessage: OrgGroupsCtrl_NoGroupsCreatedMessage,
    OrgGroupsCtrl_NoGroupsMatchMessage: OrgGroupsCtrl_NoGroupsMatchMessage,
    OrgGroupsCtrl_NumberOfMembersFormat: OrgGroupsCtrl_NumberOfMembersFormat,
    OrgGroupsCtrl_Open: OrgGroupsCtrl_Open,
    OrgGroupsCtrl_OpenGroup: OrgGroupsCtrl_OpenGroup,
    OrgGroupsCtrl_Private: OrgGroupsCtrl_Private,
    OrgGroupsCtrl_PrivateGroup: OrgGroupsCtrl_PrivateGroup,
    OrgGroupsCtrl_RequestGroupMembership: OrgGroupsCtrl_RequestGroupMembership,
    OrgGroupsCtrl_RequestMembership: OrgGroupsCtrl_RequestMembership,
    OrgGroupsCtrl_RequestPending: OrgGroupsCtrl_RequestPending,
    OrgGroupsCtrl_SearchforGroup: OrgGroupsCtrl_SearchforGroup,
    OrgGroupsCtrl_Static: OrgGroupsCtrl_Static,
    OrgGroupsCtrl_ThreeOrLess: OrgGroupsCtrl_ThreeOrLess,
    OrgGroupsCtrl_ThreeOrLessMembers: OrgGroupsCtrl_ThreeOrLessMembers,
    OrgGroupsCtrl_UploadGroups: OrgGroupsCtrl_UploadGroups,
    OrgGroupsCtrl_UploadGroupsDescription: OrgGroupsCtrl_UploadGroupsDescription,
    OrgGroupsCtrl_UploadGroupsError: OrgGroupsCtrl_UploadGroupsError,
    OrgInternalContent_AddNewContentFormat: OrgInternalContent_AddNewContentFormat,
    OrgInternalContent_AddNewDisplayArticle: OrgInternalContent_AddNewDisplayArticle,
    OrgInternalContent_AddNewDisplayAssessment: OrgInternalContent_AddNewDisplayAssessment,
    OrgInternalContent_AddNewDisplayCourse: OrgInternalContent_AddNewDisplayCourse,
    OrgInternalContent_AddNewDisplayEpisode: OrgInternalContent_AddNewDisplayEpisode,
    OrgInternalContent_AddNewDisplayEvent: OrgInternalContent_AddNewDisplayEvent,
    OrgInternalContent_AddNewDisplayPost: OrgInternalContent_AddNewDisplayPost,
    OrgInternalContent_AddNewDisplayVideo: OrgInternalContent_AddNewDisplayVideo,
    OrgInternalContent_ContentType: OrgInternalContent_ContentType,
    OrgInternalContent_ContentUse: OrgInternalContent_ContentUse,
    OrgInternalContent_DeleteAllReferences: OrgInternalContent_DeleteAllReferences,
    OrgInternalContent_DeleteCatalogOnly: OrgInternalContent_DeleteCatalogOnly,
    OrgInternalContent_DeleteCatalogOnlyDesc: OrgInternalContent_DeleteCatalogOnlyDesc,
    OrgInternalContent_DeleteSingleContentFormat: OrgInternalContent_DeleteSingleContentFormat,
    OrgInternalContent_EditContentFormat: OrgInternalContent_EditContentFormat,
    OrgInternalContent_RestrictedContentNote: OrgInternalContent_RestrictedContentNote,
    OrgInternalContent_ValidateCategoryRequired: OrgInternalContent_ValidateCategoryRequired,
    OrgInternalContent_ValidateGroupSelectionRequired: OrgInternalContent_ValidateGroupSelectionRequired,
    OrgInternalContent_ValidateNeedEndDate: OrgInternalContent_ValidateNeedEndDate,
    OrgInternalContent_ValidateNumber: OrgInternalContent_ValidateNumber,
    OrgInternalContent_ValidateScormRequired: OrgInternalContent_ValidateScormRequired,
    OrgInternalContent_ValidateTitleRequired: OrgInternalContent_ValidateTitleRequired,
    OrgInternalContent_ValidateURLMayBeInvalid: OrgInternalContent_ValidateURLMayBeInvalid,
    OrgInternalContentCtrl_AddGroups: OrgInternalContentCtrl_AddGroups,
    OrgInternalContentCtrl_AddToPathway: OrgInternalContentCtrl_AddToPathway,
    OrgInternalContentCtrl_AddTopics: OrgInternalContentCtrl_AddTopics,
    OrgInternalContentCtrl_AssessmentUnavailableError: OrgInternalContentCtrl_AssessmentUnavailableError,
    OrgInternalContentCtrl_BulkEditItemsFormat: OrgInternalContentCtrl_BulkEditItemsFormat,
    OrgInternalContentCtrl_ClearCategories: OrgInternalContentCtrl_ClearCategories,
    OrgInternalContentCtrl_ContentOwner: OrgInternalContentCtrl_ContentOwner,
    OrgInternalContentCtrl_ContentTitle: OrgInternalContentCtrl_ContentTitle,
    OrgInternalContentCtrl_CourseProperties: OrgInternalContentCtrl_CourseProperties,
    OrgInternalContentCtrl_Delete: OrgInternalContentCtrl_Delete,
    OrgInternalContentCtrl_DialogConfirmBulkDeleteItems: OrgInternalContentCtrl_DialogConfirmBulkDeleteItems,
    OrgInternalContentCtrl_DialogConfirmClearCategories: OrgInternalContentCtrl_DialogConfirmClearCategories,
    OrgInternalContentCtrl_DialogConfirmDeleteItemFormat: OrgInternalContentCtrl_DialogConfirmDeleteItemFormat,
    OrgInternalContentCtrl_Edit: OrgInternalContentCtrl_Edit,
    OrgInternalContentCtrl_FlagAsInappropriate: OrgInternalContentCtrl_FlagAsInappropriate,
    OrgInternalContentCtrl_GenericError: OrgInternalContentCtrl_GenericError,
    OrgInternalContentCtrl_InputMetricCompletions: OrgInternalContentCtrl_InputMetricCompletions,
    OrgInternalContentCtrl_InputMetricDateAdded: OrgInternalContentCtrl_InputMetricDateAdded,
    OrgInternalContentCtrl_InputMetricDateUpdated: OrgInternalContentCtrl_InputMetricDateUpdated,
    OrgInternalContentCtrl_InputMetricNone: OrgInternalContentCtrl_InputMetricNone,
    OrgInternalContentCtrl_InputMetricRating: OrgInternalContentCtrl_InputMetricRating,
    OrgInternalContentCtrl_InputMetricRecommendations: OrgInternalContentCtrl_InputMetricRecommendations,
    OrgInternalContentCtrl_InputMetricTakeaways: OrgInternalContentCtrl_InputMetricTakeaways,
    OrgInternalContentCtrl_InputMetricViews: OrgInternalContentCtrl_InputMetricViews,
    OrgInternalContentCtrl_InternalProvider: OrgInternalContentCtrl_InternalProvider,
    OrgInternalContentCtrl_MakeASelection: OrgInternalContentCtrl_MakeASelection,
    OrgInternalContentCtrl_MoreDetails: OrgInternalContentCtrl_MoreDetails,
    OrgInternalContentCtrl_Recommend: OrgInternalContentCtrl_Recommend,
    OrgInternalContentCtrl_RemoveItems: OrgInternalContentCtrl_RemoveItems,
    OrgInternalContentCtrl_ReportAProblem: OrgInternalContentCtrl_ReportAProblem,
    OrgInternalContentCtrl_ReSyncDetails: OrgInternalContentCtrl_ReSyncDetails,
    OrgInternalContentCtrl_SearchCatalog: OrgInternalContentCtrl_SearchCatalog,
    OrgInternalContentCtrl_SearchErrorMessage: OrgInternalContentCtrl_SearchErrorMessage,
    OrgInternalContentCtrl_SetGoal: OrgInternalContentCtrl_SetGoal,
    OrgInternalContentCtrl_SuccessfulAddContent: OrgInternalContentCtrl_SuccessfulAddContent,
    OrgInternalContentCtrl_SuccessfulUpdateContent: OrgInternalContentCtrl_SuccessfulUpdateContent,
    OrgInternalContentCtrl_ValidateCategoryRequired: OrgInternalContentCtrl_ValidateCategoryRequired,
    OrgInternalContentCtrl_ValidateNeedEndDate: OrgInternalContentCtrl_ValidateNeedEndDate,
    OrgInternalContentCtrl_ValidateNumber: OrgInternalContentCtrl_ValidateNumber,
    OrgInternalContentCtrl_ValidateScormRequired: OrgInternalContentCtrl_ValidateScormRequired,
    OrgInternalContentCtrl_ValidateTitleRequired: OrgInternalContentCtrl_ValidateTitleRequired,
    OrgInternalContentCtrl_ValidateURLMayBeInvalid: OrgInternalContentCtrl_ValidateURLMayBeInvalid,
    OrgInternalContentCtrl_ViewDetails: OrgInternalContentCtrl_ViewDetails,
    OrgInternalContentCtrl_ViewInGoals: OrgInternalContentCtrl_ViewInGoals,
    OrgInternalContentModalCtrl_DuplicatesDescriptionLabel: OrgInternalContentModalCtrl_DuplicatesDescriptionLabel,
    OrgInternalContentModalCtrl_DuplicatesGroupsCount: OrgInternalContentModalCtrl_DuplicatesGroupsCount,
    OrgInternalContentModalCtrl_DuplicatesGroupsLabel: OrgInternalContentModalCtrl_DuplicatesGroupsLabel,
    OrgInternalContentModalCtrl_DuplicatesHeader: OrgInternalContentModalCtrl_DuplicatesHeader,
    OrgInternalContentModalCtrl_DuplicatesTopicsCount: OrgInternalContentModalCtrl_DuplicatesTopicsCount,
    OrgInternalContentModalCtrl_DuplicatesTopicsLabel: OrgInternalContentModalCtrl_DuplicatesTopicsLabel,
    OrgInternalContentSvc_DeletionConfirmationMessageFormat: OrgInternalContentSvc_DeletionConfirmationMessageFormat,
    OrgInternalContentSvc_InputType: OrgInternalContentSvc_InputType,
    OrgInternalContentSvc_InternalContentError: OrgInternalContentSvc_InternalContentError,
    OrgInternalContentSvc_ItemsDeletedSuccessMessage: OrgInternalContentSvc_ItemsDeletedSuccessMessage,
    OrgInternalContentSvc_ItemsDeletionError: OrgInternalContentSvc_ItemsDeletionError,
    OrgInternalContentSvc_ItemsRestoredSuccessMessage: OrgInternalContentSvc_ItemsRestoredSuccessMessage,
    OrgInternalContentSvc_ItemsRestoreError: OrgInternalContentSvc_ItemsRestoreError,
    OrgInternalContentSvc_ItemsUpdatedSuccessMessage: OrgInternalContentSvc_ItemsUpdatedSuccessMessage,
    OrgInternalContentSvc_ItemsUpdateError: OrgInternalContentSvc_ItemsUpdateError,
    OrgInternalContentSvc_ItemUpdateDuplicateError: OrgInternalContentSvc_ItemUpdateDuplicateError,
    OrgInternalContentSvc_ItemWTitleDeletedSuccessMessage: OrgInternalContentSvc_ItemWTitleDeletedSuccessMessage,
    OrgInternalContentSvc_ItemWTitleDeletionError: OrgInternalContentSvc_ItemWTitleDeletionError,
    OrgInternalContentSvc_ProviderName: OrgInternalContentSvc_ProviderName,
    OrgInternalContentSvc_SingleItemUpdatedSuccessMessage: OrgInternalContentSvc_SingleItemUpdatedSuccessMessage,
    OrgInternalContentSvc_Summary: OrgInternalContentSvc_Summary,
    OrgInternalContentSvc_Tags: OrgInternalContentSvc_Tags,
    OrgInternalContentSvc_Title: OrgInternalContentSvc_Title,
    orgInternalContentVisibilitySelector_GroupVisibilityPlaceholder: orgInternalContentVisibilitySelector_GroupVisibilityPlaceholder,
    orgInternalContentVisibilitySelector_OrgVisibilityPlaceholder: orgInternalContentVisibilitySelector_OrgVisibilityPlaceholder,
    orgInternalContentVisibilitySelector_TargetGroupsLabel: orgInternalContentVisibilitySelector_TargetGroupsLabel,
    orgInternalContentVisibilitySelector_Title: orgInternalContentVisibilitySelector_Title,
    orgInternalContentVisibilitySelector_VisibleToGroups: orgInternalContentVisibilitySelector_VisibleToGroups,
    orgInternalContentVisibilitySelector_VisibleToOrganization: orgInternalContentVisibilitySelector_VisibleToOrganization,
    orgInviteFlowModal_Compiling: orgInviteFlowModal_Compiling,
    orgInviteFlowModal_DiscoverContentInfo: orgInviteFlowModal_DiscoverContentInfo,
    orgInviteFlowModal_GotIt: orgInviteFlowModal_GotIt,
    orgInviteFlowModal_GroupConversation: orgInviteFlowModal_GroupConversation,
    orgInviteFlowModal_GroupConversations: orgInviteFlowModal_GroupConversations,
    orgInviteFlowModal_InviteMessageFormat: orgInviteFlowModal_InviteMessageFormat,
    orgInviteFlowModal_LearnAsTeam: orgInviteFlowModal_LearnAsTeam,
    orgInviteFlowModal_LetsGetStarted: orgInviteFlowModal_LetsGetStarted,
    orgInviteFlowModal_PersonalizedLearning: orgInviteFlowModal_PersonalizedLearning,
    orgInviteFlowModal_PersonalLearning: orgInviteFlowModal_PersonalLearning,
    orgInviteFlowModal_Recommendations: orgInviteFlowModal_Recommendations,
    orgInviteFlowModal_RecommendInfo: orgInviteFlowModal_RecommendInfo,
    orgInviteFlowModal_ResendVerification: orgInviteFlowModal_ResendVerification,
    orgInviteFlowModal_SeeMemberLearning: orgInviteFlowModal_SeeMemberLearning,
    orgInviteFlowModal_SocialGroupFeed: orgInviteFlowModal_SocialGroupFeed,
    orgInviteFlowModal_UnableToJoin: orgInviteFlowModal_UnableToJoin,
    orgInviteFlowModal_UnableToJoin_Desc: orgInviteFlowModal_UnableToJoin_Desc,
    orgInviteFlowModal_VerificationSentFormat: orgInviteFlowModal_VerificationSentFormat,
    orgInviteFlowModal_VerifyEmailFormat: orgInviteFlowModal_VerifyEmailFormat,
    orgInviteFlowModal_VerifyInstructions: orgInviteFlowModal_VerifyInstructions,
    OrgManage_AdvancedSSOCreated: OrgManage_AdvancedSSOCreated,
    OrgManage_Analytics_MenuItem_Label: OrgManage_Analytics_MenuItem_Label,
    OrgManage_Analytics_MenuItem_Text: OrgManage_Analytics_MenuItem_Text,
    OrgManage_CollectorDisabled: OrgManage_CollectorDisabled,
    OrgManage_ConnectorDisabled: OrgManage_ConnectorDisabled,
    OrgManage_ConnectorDisableFailed: OrgManage_ConnectorDisableFailed,
    OrgManage_Engage_MenuItem_Label: OrgManage_Engage_MenuItem_Label,
    OrgManage_Engage_MenuItem_Text: OrgManage_Engage_MenuItem_Text,
    OrgManage_EnterpriseProviderDisconnected: OrgManage_EnterpriseProviderDisconnected,
    OrgManage_Error_Get: OrgManage_Error_Get,
    OrgManage_ErrorCreatingProviderSSODetails: OrgManage_ErrorCreatingProviderSSODetails,
    OrgManage_ErrorMessageCollectors: OrgManage_ErrorMessageCollectors,
    OrgManage_ErrorMessageCollectorsOptions: OrgManage_ErrorMessageCollectorsOptions,
    OrgManage_ErrorMessageConnectors: OrgManage_ErrorMessageConnectors,
    OrgManage_ErrorMessageConnectorsOptions: OrgManage_ErrorMessageConnectorsOptions,
    OrgManage_ErrorMessageIntegrationProviders: OrgManage_ErrorMessageIntegrationProviders,
    OrgManage_ErrorMessageProvider: OrgManage_ErrorMessageProvider,
    OrgManage_ErrorMessageProviderDetails: OrgManage_ErrorMessageProviderDetails,
    OrgManage_ErrorMessageProvidersList: OrgManage_ErrorMessageProvidersList,
    OrgManage_ErrorSavingMessageCollectorsOptions: OrgManage_ErrorSavingMessageCollectorsOptions,
    OrgManage_ErrorSavingMessageConnectorsOptions: OrgManage_ErrorSavingMessageConnectorsOptions,
    OrgManage_ErrorUpdatingProviderSSODetails: OrgManage_ErrorUpdatingProviderSSODetails,
    OrgManage_ExtendedEnterprise: OrgManage_ExtendedEnterprise,
    OrgManage_FailedProviderSSODetails: OrgManage_FailedProviderSSODetails,
    OrgManage_FAQ_AddFAQ: OrgManage_FAQ_AddFAQ,
    OrgManage_FAQ_Answer: OrgManage_FAQ_Answer,
    OrgManage_FAQ_AnswerPlaceholder: OrgManage_FAQ_AnswerPlaceholder,
    OrgManage_FAQ_ConfirmDelete: OrgManage_FAQ_ConfirmDelete,
    OrgManage_FAQ_CreateFAQPage: OrgManage_FAQ_CreateFAQPage,
    OrgManage_FAQ_CreateFAQPageInstructions: OrgManage_FAQ_CreateFAQPageInstructions,
    OrgManage_FAQ_CustomizeFAQ: OrgManage_FAQ_CustomizeFAQ,
    OrgManage_FAQ_Delete: OrgManage_FAQ_Delete,
    OrgManage_FAQ_Edit: OrgManage_FAQ_Edit,
    OrgManage_FAQ_Error_CreateFAQ: OrgManage_FAQ_Error_CreateFAQ,
    OrgManage_FAQ_Error_DeleteFAQ: OrgManage_FAQ_Error_DeleteFAQ,
    OrgManage_FAQ_Error_GetFAQs: OrgManage_FAQ_Error_GetFAQs,
    OrgManage_FAQ_Error_UpdateFAQ: OrgManage_FAQ_Error_UpdateFAQ,
    OrgManage_FAQ_FaqCreated: OrgManage_FAQ_FaqCreated,
    OrgManage_FAQ_FaqDeleted: OrgManage_FAQ_FaqDeleted,
    OrgManage_FAQ_FaqUpdated: OrgManage_FAQ_FaqUpdated,
    OrgManage_FAQ_MaxFAQsMsg: OrgManage_FAQ_MaxFAQsMsg,
    OrgManage_FAQ_NoFAQs: OrgManage_FAQ_NoFAQs,
    OrgManage_FAQ_Question: OrgManage_FAQ_Question,
    OrgManage_FAQ_QuestionPlaceholder: OrgManage_FAQ_QuestionPlaceholder,
    OrgManage_FAQ_TryNarrowingSearch: OrgManage_FAQ_TryNarrowingSearch,
    OrgManage_LearningExperience: OrgManage_LearningExperience,
    OrgManage_Manage: OrgManage_Manage,
    OrgManage_MoreFormat: OrgManage_MoreFormat,
    OrgManage_OauthCredentials_apiKeyCreated: OrgManage_OauthCredentials_apiKeyCreated,
    OrgManage_OauthCredentials_ApiKeyCreatedHeaderModal: OrgManage_OauthCredentials_ApiKeyCreatedHeaderModal,
    OrgManage_OauthCredentials_apiKeysTab: OrgManage_OauthCredentials_apiKeysTab,
    OrgManage_OauthCredentials_clientKeyLabel: OrgManage_OauthCredentials_clientKeyLabel,
    OrgManage_OauthCredentials_clientPasswordLabel: OrgManage_OauthCredentials_clientPasswordLabel,
    OrgManage_OauthCredentials_ConfirmDelete: OrgManage_OauthCredentials_ConfirmDelete,
    OrgManage_OauthCredentials_copiedClipboardTooltip: OrgManage_OauthCredentials_copiedClipboardTooltip,
    OrgManage_OauthCredentials_copyAndSaveKey: OrgManage_OauthCredentials_copyAndSaveKey,
    OrgManage_OauthCredentials_copyClipboardTooltip: OrgManage_OauthCredentials_copyClipboardTooltip,
    OrgManage_OauthCredentials_Create: OrgManage_OauthCredentials_Create,
    OrgManage_OauthCredentials_Created: OrgManage_OauthCredentials_Created,
    OrgManage_OauthCredentials_CreatedByLabel: OrgManage_OauthCredentials_CreatedByLabel,
    OrgManage_OauthCredentials_CredentialsRevoked: OrgManage_OauthCredentials_CredentialsRevoked,
    OrgManage_OauthCredentials_defaultEmptyProviderCode: OrgManage_OauthCredentials_defaultEmptyProviderCode,
    OrgManage_OauthCredentials_Delete: OrgManage_OauthCredentials_Delete,
    OrgManage_OauthCredentials_descriptionPlaceholder: OrgManage_OauthCredentials_descriptionPlaceholder,
    OrgManage_OauthCredentials_EditCredentials: OrgManage_OauthCredentials_EditCredentials,
    OrgManage_OauthCredentials_editCredentialsTooltip: OrgManage_OauthCredentials_editCredentialsTooltip,
    OrgManage_OauthCredentials_ErrorSavingCredentials: OrgManage_OauthCredentials_ErrorSavingCredentials,
    OrgManage_OauthCredentials_NamePlaceholder: OrgManage_OauthCredentials_NamePlaceholder,
    OrgManage_OauthCredentials_NewCredentials: OrgManage_OauthCredentials_NewCredentials,
    OrgManage_OauthCredentials_organizationKeysLabel: OrgManage_OauthCredentials_organizationKeysLabel,
    OrgManage_OauthCredentials_providerKeysLabel: OrgManage_OauthCredentials_providerKeysLabel,
    OrgManage_OauthCredentials_providerLabel: OrgManage_OauthCredentials_providerLabel,
    OrgManage_OauthCredentials_providerPlaceholder: OrgManage_OauthCredentials_providerPlaceholder,
    OrgManage_OauthCredentials_revokeTooltip: OrgManage_OauthCredentials_revokeTooltip,
    OrgManage_OauthCredentials_Scope_completions: OrgManage_OauthCredentials_Scope_completions,
    OrgManage_OauthCredentials_Scope_completionsRead: OrgManage_OauthCredentials_Scope_completionsRead,
    OrgManage_OauthCredentials_Scope_completionsWrite: OrgManage_OauthCredentials_Scope_completionsWrite,
    OrgManage_OauthCredentials_Scope_content: OrgManage_OauthCredentials_Scope_content,
    OrgManage_OauthCredentials_Scope_contentRead: OrgManage_OauthCredentials_Scope_contentRead,
    OrgManage_OauthCredentials_Scope_contentWrite: OrgManage_OauthCredentials_Scope_contentWrite,
    OrgManage_OauthCredentials_Scope_customAttribute: OrgManage_OauthCredentials_Scope_customAttribute,
    OrgManage_OauthCredentials_Scope_Licenses: OrgManage_OauthCredentials_Scope_Licenses,
    OrgManage_OauthCredentials_Scope_ProviderUsers: OrgManage_OauthCredentials_Scope_ProviderUsers,
    OrgManage_OauthCredentials_Scope_r: OrgManage_OauthCredentials_Scope_r,
    OrgManage_OauthCredentials_Scope_read: OrgManage_OauthCredentials_Scope_read,
    OrgManage_OauthCredentials_Scope_readCompletions: OrgManage_OauthCredentials_Scope_readCompletions,
    OrgManage_OauthCredentials_Scope_readContent: OrgManage_OauthCredentials_Scope_readContent,
    OrgManage_OauthCredentials_Scope_readRequiredLearning: OrgManage_OauthCredentials_Scope_readRequiredLearning,
    OrgManage_OauthCredentials_Scope_readUsers: OrgManage_OauthCredentials_Scope_readUsers,
    OrgManage_OauthCredentials_Scope_requiredLearning: OrgManage_OauthCredentials_Scope_requiredLearning,
    OrgManage_OauthCredentials_Scope_requiredLearning_Bundles: OrgManage_OauthCredentials_Scope_requiredLearning_Bundles,
    OrgManage_OauthCredentials_Scope_requiredLearning_Logins: OrgManage_OauthCredentials_Scope_requiredLearning_Logins,
    OrgManage_OauthCredentials_Scope_requiredLearning_SharedItems: OrgManage_OauthCredentials_Scope_requiredLearning_SharedItems,
    OrgManage_OauthCredentials_Scope_requiredLearning_SkillPlans: OrgManage_OauthCredentials_Scope_requiredLearning_SkillPlans,
    OrgManage_OauthCredentials_Scope_requiredLearning_SkillRatings: OrgManage_OauthCredentials_Scope_requiredLearning_SkillRatings,
    OrgManage_OauthCredentials_Scope_requiredLearning_TodaysLearning: OrgManage_OauthCredentials_Scope_requiredLearning_TodaysLearning,
    OrgManage_OauthCredentials_Scope_requiredLearning_UserBadges: OrgManage_OauthCredentials_Scope_requiredLearning_UserBadges,
    OrgManage_OauthCredentials_Scope_requiredLearning_UserSkills: OrgManage_OauthCredentials_Scope_requiredLearning_UserSkills,
    OrgManage_OauthCredentials_Scope_requiredLearningRead: OrgManage_OauthCredentials_Scope_requiredLearningRead,
    OrgManage_OauthCredentials_Scope_requiredLearningWrite: OrgManage_OauthCredentials_Scope_requiredLearningWrite,
    OrgManage_OauthCredentials_Scope_rw: OrgManage_OauthCredentials_Scope_rw,
    OrgManage_OauthCredentials_Scope_SelfEnrolledLearning: OrgManage_OauthCredentials_Scope_SelfEnrolledLearning,
    OrgManage_OauthCredentials_Scope_UserBadges: OrgManage_OauthCredentials_Scope_UserBadges,
    OrgManage_OauthCredentials_Scope_users: OrgManage_OauthCredentials_Scope_users,
    OrgManage_OauthCredentials_Scope_usersRead: OrgManage_OauthCredentials_Scope_usersRead,
    OrgManage_OauthCredentials_Scope_usersWrite: OrgManage_OauthCredentials_Scope_usersWrite,
    OrgManage_OauthCredentials_Scope_write: OrgManage_OauthCredentials_Scope_write,
    OrgManage_OauthCredentials_Scope_writeCompletions: OrgManage_OauthCredentials_Scope_writeCompletions,
    OrgManage_OauthCredentials_Scope_writeContent: OrgManage_OauthCredentials_Scope_writeContent,
    OrgManage_OauthCredentials_Scope_writeRequiredLearning: OrgManage_OauthCredentials_Scope_writeRequiredLearning,
    OrgManage_OauthCredentials_Scope_writeUsers: OrgManage_OauthCredentials_Scope_writeUsers,
    OrgManage_OauthCredentials_Scope_Xapi: OrgManage_OauthCredentials_Scope_Xapi,
    OrgManage_OauthCredentials_ScopesLabel: OrgManage_OauthCredentials_ScopesLabel,
    OrgManage_OauthCredentials_Updated: OrgManage_OauthCredentials_Updated,
    OrgManage_OauthCredentials_warningManageCredentials: OrgManage_OauthCredentials_warningManageCredentials,
    OrgManage_OauthCredentials_wontShowKeyAgain: OrgManage_OauthCredentials_wontShowKeyAgain,
    OrgManage_OneMore: OrgManage_OneMore,
    OrgManage_Opportunities_Add: OrgManage_Opportunities_Add,
    OrgManage_Opportunities_AddCollaborators: OrgManage_Opportunities_AddCollaborators,
    OrgManage_Opportunities_AtLeastOneSkill: OrgManage_Opportunities_AtLeastOneSkill,
    OrgManage_Opportunities_BulkChangeVisibility: OrgManage_Opportunities_BulkChangeVisibility,
    OrgManage_Opportunities_BulkChangeVisibilityPlural: OrgManage_Opportunities_BulkChangeVisibilityPlural,
    OrgManage_Opportunities_BulkCloseAllHeader: OrgManage_Opportunities_BulkCloseAllHeader,
    OrgManage_Opportunities_BulkClosedSuccess: OrgManage_Opportunities_BulkClosedSuccess,
    OrgManage_Opportunities_BulkCloseError: OrgManage_Opportunities_BulkCloseError,
    OrgManage_Opportunities_BulkCloseExternalError: OrgManage_Opportunities_BulkCloseExternalError,
    OrgManage_Opportunities_BulkCloseHeader: OrgManage_Opportunities_BulkCloseHeader,
    OrgManage_Opportunities_BulkCloseNotify: OrgManage_Opportunities_BulkCloseNotify,
    OrgManage_Opportunities_BulkCloseWarning: OrgManage_Opportunities_BulkCloseWarning,
    OrgManage_Opportunities_BulkCloseWarningExternal: OrgManage_Opportunities_BulkCloseWarningExternal,
    OrgManage_Opportunities_BulkDeleteAllHeader: OrgManage_Opportunities_BulkDeleteAllHeader,
    OrgManage_Opportunities_BulkDeleteError: OrgManage_Opportunities_BulkDeleteError,
    OrgManage_Opportunities_BulkDeleteExternalError: OrgManage_Opportunities_BulkDeleteExternalError,
    OrgManage_Opportunities_BulkDeleteExternalFail: OrgManage_Opportunities_BulkDeleteExternalFail,
    OrgManage_Opportunities_BulkDeleteHeader: OrgManage_Opportunities_BulkDeleteHeader,
    OrgManage_Opportunities_BulkDeleteSuccess: OrgManage_Opportunities_BulkDeleteSuccess,
    OrgManage_Opportunities_BulkDeleteWarning: OrgManage_Opportunities_BulkDeleteWarning,
    OrgManage_Opportunities_BulkDeleteWarningExternal: OrgManage_Opportunities_BulkDeleteWarningExternal,
    OrgManage_Opportunities_ChooseDurationType: OrgManage_Opportunities_ChooseDurationType,
    OrgManage_Opportunities_Close: OrgManage_Opportunities_Close,
    OrgManage_Opportunities_ClosedOnlyOpportunities: OrgManage_Opportunities_ClosedOnlyOpportunities,
    OrgManage_Opportunities_ClosePrompt_Description: OrgManage_Opportunities_ClosePrompt_Description,
    OrgManage_Opportunities_ClosePrompt_Header: OrgManage_Opportunities_ClosePrompt_Header,
    OrgManage_Opportunities_ClosePrompt_NoSelect: OrgManage_Opportunities_ClosePrompt_NoSelect,
    OrgManage_Opportunities_ClosePrompt_SendNotification: OrgManage_Opportunities_ClosePrompt_SendNotification,
    OrgManage_Opportunities_ClosePrompt_Title: OrgManage_Opportunities_ClosePrompt_Title,
    OrgManage_Opportunities_Cols_Collaborators: OrgManage_Opportunities_Cols_Collaborators,
    OrgManage_Opportunities_Cols_Interested: OrgManage_Opportunities_Cols_Interested,
    OrgManage_Opportunities_Cols_LastUpdated: OrgManage_Opportunities_Cols_LastUpdated,
    OrgManage_Opportunities_Cols_Skills: OrgManage_Opportunities_Cols_Skills,
    OrgManage_Opportunities_Cols_Source: OrgManage_Opportunities_Cols_Source,
    OrgManage_Opportunities_Cols_Title: OrgManage_Opportunities_Cols_Title,
    OrgManage_Opportunities_Cols_Type: OrgManage_Opportunities_Cols_Type,
    OrgManage_Opportunities_Cols_Visibility: OrgManage_Opportunities_Cols_Visibility,
    OrgManage_Opportunities_Create: OrgManage_Opportunities_Create,
    OrgManage_Opportunities_DateCompare: OrgManage_Opportunities_DateCompare,
    OrgManage_Opportunities_DatePicker: OrgManage_Opportunities_DatePicker,
    OrgManage_Opportunities_Delete: OrgManage_Opportunities_Delete,
    OrgManage_Opportunities_Delete_Confirmation: OrgManage_Opportunities_Delete_Confirmation,
    OrgManage_Opportunities_Delete_Confirmation_Singular: OrgManage_Opportunities_Delete_Confirmation_Singular,
    OrgManage_Opportunities_Delete_Notice_Generic: OrgManage_Opportunities_Delete_Notice_Generic,
    OrgManage_Opportunities_Delete_Notice_Specific: OrgManage_Opportunities_Delete_Notice_Specific,
    OrgManage_Opportunities_Delete_Notice_Specific_Singular: OrgManage_Opportunities_Delete_Notice_Specific_Singular,
    OrgManage_Opportunities_Delete_Undeletable: OrgManage_Opportunities_Delete_Undeletable,
    OrgManage_Opportunities_Delete_Undeletable_Singular: OrgManage_Opportunities_Delete_Undeletable_Singular,
    OrgManage_Opportunities_DeleteOpportunities: OrgManage_Opportunities_DeleteOpportunities,
    OrgManage_Opportunities_DeleteOpportunity: OrgManage_Opportunities_DeleteOpportunity,
    OrgManage_Opportunities_DeletePrompt_Description: OrgManage_Opportunities_DeletePrompt_Description,
    OrgManage_Opportunities_DeletePrompt_Title: OrgManage_Opportunities_DeletePrompt_Title,
    OrgManage_Opportunities_DepartmentPlaceholder: OrgManage_Opportunities_DepartmentPlaceholder,
    OrgManage_Opportunities_DescMaxChars: OrgManage_Opportunities_DescMaxChars,
    OrgManage_Opportunities_DescPlaceholder: OrgManage_Opportunities_DescPlaceholder,
    OrgManage_Opportunities_Edit: OrgManage_Opportunities_Edit,
    OrgManage_Opportunities_EditSkills: OrgManage_Opportunities_EditSkills,
    OrgManage_Opportunities_EditTargetLevel: OrgManage_Opportunities_EditTargetLevel,
    OrgManage_Opportunities_EditVisibility: OrgManage_Opportunities_EditVisibility,
    OrgManage_Opportunities_Error_Add: OrgManage_Opportunities_Error_Add,
    OrgManage_Opportunities_Error_Close: OrgManage_Opportunities_Error_Close,
    OrgManage_Opportunities_Error_Delete: OrgManage_Opportunities_Error_Delete,
    OrgManage_Opportunities_Error_Edit: OrgManage_Opportunities_Error_Edit,
    OrgManage_Opportunities_Error_EditCollaborators: OrgManage_Opportunities_Error_EditCollaborators,
    OrgManage_Opportunities_Error_EditSkills: OrgManage_Opportunities_Error_EditSkills,
    OrgManage_Opportunities_Error_EditVisibility: OrgManage_Opportunities_Error_EditVisibility,
    OrgManage_Opportunities_Error_Share: OrgManage_Opportunities_Error_Share,
    OrgManage_Opportunities_Filters_Current_Collaborator: OrgManage_Opportunities_Filters_Current_Collaborator,
    OrgManage_Opportunities_Filters_Status_closed: OrgManage_Opportunities_Filters_Status_closed,
    OrgManage_Opportunities_Filters_Status_open: OrgManage_Opportunities_Filters_Status_open,
    OrgManage_Opportunities_Invalid_Field: OrgManage_Opportunities_Invalid_Field,
    OrgManage_Opportunities_JobRoles_SkillAdded: OrgManage_Opportunities_JobRoles_SkillAdded,
    OrgManage_Opportunities_MoreFormat: OrgManage_Opportunities_MoreFormat,
    OrgManage_Opportunities_NoItemsAdded: OrgManage_Opportunities_NoItemsAdded,
    OrgManage_Opportunities_OfDays: OrgManage_Opportunities_OfDays,
    OrgManage_Opportunities_OfHours: OrgManage_Opportunities_OfHours,
    OrgManage_Opportunities_OfMonths: OrgManage_Opportunities_OfMonths,
    OrgManage_Opportunities_OfWeeks: OrgManage_Opportunities_OfWeeks,
    OrgManage_Opportunities_OneMore: OrgManage_Opportunities_OneMore,
    OrgManage_Opportunities_OptIn: OrgManage_Opportunities_OptIn,
    OrgManage_Opportunities_OptIn_Description: OrgManage_Opportunities_OptIn_Description,
    OrgManage_Opportunities_OptIn_Header: OrgManage_Opportunities_OptIn_Header,
    OrgManage_Opportunities_Required_Field: OrgManage_Opportunities_Required_Field,
    OrgManage_Opportunities_SearchPlaceholder: OrgManage_Opportunities_SearchPlaceholder,
    OrgManage_Opportunities_ShowClosed: OrgManage_Opportunities_ShowClosed,
    OrgManage_Opportunities_StartDatePlaceholder: OrgManage_Opportunities_StartDatePlaceholder,
    OrgManage_Opportunities_Success_Add: OrgManage_Opportunities_Success_Add,
    OrgManage_Opportunities_Success_AddCollaboratorPluralToOpportunity: OrgManage_Opportunities_Success_AddCollaboratorPluralToOpportunity,
    OrgManage_Opportunities_Success_AddCollaboratorPluralToOpportunityPlural: OrgManage_Opportunities_Success_AddCollaboratorPluralToOpportunityPlural,
    OrgManage_Opportunities_Success_AddCollaboratorToOpportunity: OrgManage_Opportunities_Success_AddCollaboratorToOpportunity,
    OrgManage_Opportunities_Success_AddCollaboratorToOpportunityPlural: OrgManage_Opportunities_Success_AddCollaboratorToOpportunityPlural,
    OrgManage_Opportunities_Success_Close: OrgManage_Opportunities_Success_Close,
    OrgManage_Opportunities_Success_Delete: OrgManage_Opportunities_Success_Delete,
    OrgManage_Opportunities_Success_EditVisibility: OrgManage_Opportunities_Success_EditVisibility,
    OrgManage_Opportunities_Success_EditVisibilityPlural: OrgManage_Opportunities_Success_EditVisibilityPlural,
    OrgManage_Opportunities_Success_Update: OrgManage_Opportunities_Success_Update,
    OrgManage_Opportunities_Tab_Description: OrgManage_Opportunities_Tab_Description,
    OrgManage_Opportunities_Tab_Details: OrgManage_Opportunities_Tab_Details,
    OrgManage_Opportunities_Tab_Skills: OrgManage_Opportunities_Tab_Skills,
    OrgManage_Opportunities_ThreeToTenSkills: OrgManage_Opportunities_ThreeToTenSkills,
    OrgManage_Opportunities_TitlePlaceholder: OrgManage_Opportunities_TitlePlaceholder,
    OrgManage_Opportunities_TypePlaceholder: OrgManage_Opportunities_TypePlaceholder,
    OrgManage_Opportunities_Upload: OrgManage_Opportunities_Upload,
    OrgManage_Opportunities_UploadDescription: OrgManage_Opportunities_UploadDescription,
    OrgManage_Opportunities_UploadError: OrgManage_Opportunities_UploadError,
    OrgManage_Opportunities_UploadFile: OrgManage_Opportunities_UploadFile,
    OrgManage_Opportunities_UploadOpportunities: OrgManage_Opportunities_UploadOpportunities,
    OrgManage_Opportunities_UploadSuccess: OrgManage_Opportunities_UploadSuccess,
    OrgManage_Opportunities_Valid_Date: OrgManage_Opportunities_Valid_Date,
    OrgManage_Opportunities_Valid_Duration: OrgManage_Opportunities_Valid_Duration,
    OrgManage_Opportunities_Valid_Duration_Type: OrgManage_Opportunities_Valid_Duration_Type,
    OrgManage_Opportunities_Valid_Job_Role: OrgManage_Opportunities_Valid_Job_Role,
    OrgManage_Opportunities_Valid_MaxLength: OrgManage_Opportunities_Valid_MaxLength,
    OrgManage_Opportunities_Valid_MinLength: OrgManage_Opportunities_Valid_MinLength,
    OrgManage_Opportunities_VisibleCollaborators: OrgManage_Opportunities_VisibleCollaborators,
    OrgManage_Opportunities_VisibleGroups: OrgManage_Opportunities_VisibleGroups,
    OrgManage_Opportunities_VisibleOrganization: OrgManage_Opportunities_VisibleOrganization,
    OrgManage_OrgProviders_Created: OrgManage_OrgProviders_Created,
    OrgManage_OrgProviders_createProviderButton: OrgManage_OrgProviders_createProviderButton,
    OrgManage_OrgProviders_createProviderLabel: OrgManage_OrgProviders_createProviderLabel,
    OrgManage_OrgProviders_editOrgProviderTooltip: OrgManage_OrgProviders_editOrgProviderTooltip,
    OrgManage_OrgProviders_ErrorMessage: OrgManage_OrgProviders_ErrorMessage,
    OrgManage_OrgProviders_featuredColumnHeader: OrgManage_OrgProviders_featuredColumnHeader,
    OrgManage_OrgProviders_globalLicenseColumnHeader: OrgManage_OrgProviders_globalLicenseColumnHeader,
    OrgManage_OrgProviders_hiddenColumnHeader: OrgManage_OrgProviders_hiddenColumnHeader,
    OrgManage_OrgProviders_hiddenLabel: OrgManage_OrgProviders_hiddenLabel,
    OrgManage_OrgProviders_licensingColumnHeader: OrgManage_OrgProviders_licensingColumnHeader,
    OrgManage_OrgProviders_LicensingConfirmation_DefaultDescription: OrgManage_OrgProviders_LicensingConfirmation_DefaultDescription,
    OrgManage_OrgProviders_LicensingConfirmation_LicenseAlreadyRequested: OrgManage_OrgProviders_LicensingConfirmation_LicenseAlreadyRequested,
    OrgManage_OrgProviders_LicensingConfirmation_NoLicenseFound: OrgManage_OrgProviders_LicensingConfirmation_NoLicenseFound,
    OrgManage_OrgProviders_LicensingConfirmation_NoProviderFound: OrgManage_OrgProviders_LicensingConfirmation_NoProviderFound,
    OrgManage_OrgProviders_LicensingConfirmation_PageTitle: OrgManage_OrgProviders_LicensingConfirmation_PageTitle,
    OrgManage_OrgProviders_LicensingConfirmation_ProviderHeader: OrgManage_OrgProviders_LicensingConfirmation_ProviderHeader,
    OrgManage_OrgProviders_LicensingConfirmation_ProviderHomepage: OrgManage_OrgProviders_LicensingConfirmation_ProviderHomepage,
    OrgManage_OrgProviders_LicensingConfirmation_RequestLicense: OrgManage_OrgProviders_LicensingConfirmation_RequestLicense,
    OrgManage_OrgProviders_LicensingConfirmation_SearchForProviderContent: OrgManage_OrgProviders_LicensingConfirmation_SearchForProviderContent,
    OrgManage_OrgProviders_providerNameColumnHeader: OrgManage_OrgProviders_providerNameColumnHeader,
    OrgManage_OrgProviders_providersLabel: OrgManage_OrgProviders_providersLabel,
    OrgManage_OrgProviders_providersPlaceholder: OrgManage_OrgProviders_providersPlaceholder,
    OrgManage_OrgProviders_providersTab: OrgManage_OrgProviders_providersTab,
    OrgManage_OrgProviders_Updated: OrgManage_OrgProviders_Updated,
    OrgManage_ProviderDisconnected: OrgManage_ProviderDisconnected,
    OrgManage_ReportSchedule_AggregateRange: OrgManage_ReportSchedule_AggregateRange,
    OrgManage_ReportSchedule_Cols_Frequency: OrgManage_ReportSchedule_Cols_Frequency,
    OrgManage_ReportSchedule_Cols_FtpConfig: OrgManage_ReportSchedule_Cols_FtpConfig,
    OrgManage_ReportSchedule_Cols_LastExport: OrgManage_ReportSchedule_Cols_LastExport,
    OrgManage_ReportSchedule_Cols_ReportType: OrgManage_ReportSchedule_Cols_ReportType,
    OrgManage_ReportSchedule_Cols_TimePeriod: OrgManage_ReportSchedule_Cols_TimePeriod,
    OrgManage_ReportSchedule_Cols_Version: OrgManage_ReportSchedule_Cols_Version,
    OrgManage_ReportSchedule_ConfirmDelete: OrgManage_ReportSchedule_ConfirmDelete,
    OrgManage_ReportSchedule_DownloadFolder: OrgManage_ReportSchedule_DownloadFolder,
    OrgManage_ReportSchedule_DuplicateReportScheduleError: OrgManage_ReportSchedule_DuplicateReportScheduleError,
    OrgManage_ReportSchedule_EditReportSchedule: OrgManage_ReportSchedule_EditReportSchedule,
    OrgManage_ReportSchedule_Error_DeleteSchedule: OrgManage_ReportSchedule_Error_DeleteSchedule,
    OrgManage_ReportSchedule_Error_GetDateRanges: OrgManage_ReportSchedule_Error_GetDateRanges,
    OrgManage_ReportSchedule_Error_GetFrequencies: OrgManage_ReportSchedule_Error_GetFrequencies,
    OrgManage_ReportSchedule_Error_GetReportMethods: OrgManage_ReportSchedule_Error_GetReportMethods,
    OrgManage_ReportSchedule_Error_GetSchedules: OrgManage_ReportSchedule_Error_GetSchedules,
    OrgManage_ReportSchedule_Error_UpdateSchedule: OrgManage_ReportSchedule_Error_UpdateSchedule,
    OrgManage_ReportSchedule_Frequency_Daily: OrgManage_ReportSchedule_Frequency_Daily,
    OrgManage_ReportSchedule_Frequency_DailyMondayThruFriday: OrgManage_ReportSchedule_Frequency_DailyMondayThruFriday,
    OrgManage_ReportSchedule_Frequency_Monthly: OrgManage_ReportSchedule_Frequency_Monthly,
    OrgManage_ReportSchedule_Frequency_Quarterly: OrgManage_ReportSchedule_Frequency_Quarterly,
    OrgManage_ReportSchedule_Frequency_WeeklyOnMonday: OrgManage_ReportSchedule_Frequency_WeeklyOnMonday,
    OrgManage_ReportSchedule_Frequency_WeeklyOnSunday: OrgManage_ReportSchedule_Frequency_WeeklyOnSunday,
    OrgManage_ReportSchedule_FTP: OrgManage_ReportSchedule_FTP,
    OrgManage_ReportSchedule_FtpConfig: OrgManage_ReportSchedule_FtpConfig,
    OrgManage_ReportSchedule_NewReportSchedule: OrgManage_ReportSchedule_NewReportSchedule,
    OrgManage_ReportSchedule_Range_Last10Days: OrgManage_ReportSchedule_Range_Last10Days,
    OrgManage_ReportSchedule_Range_Last15Days: OrgManage_ReportSchedule_Range_Last15Days,
    OrgManage_ReportSchedule_Range_Last1Days: OrgManage_ReportSchedule_Range_Last1Days,
    OrgManage_ReportSchedule_Range_Last2Days: OrgManage_ReportSchedule_Range_Last2Days,
    OrgManage_ReportSchedule_Range_Last30Days: OrgManage_ReportSchedule_Range_Last30Days,
    OrgManage_ReportSchedule_Range_Last3Days: OrgManage_ReportSchedule_Range_Last3Days,
    OrgManage_ReportSchedule_Range_Last60Days: OrgManage_ReportSchedule_Range_Last60Days,
    OrgManage_ReportSchedule_Range_Last7Days: OrgManage_ReportSchedule_Range_Last7Days,
    OrgManage_ReportSchedule_Range_Last90Days: OrgManage_ReportSchedule_Range_Last90Days,
    OrgManage_ReportSchedule_Range_LastFullMonth: OrgManage_ReportSchedule_Range_LastFullMonth,
    OrgManage_ReportSchedule_Range_LastFullQuarter: OrgManage_ReportSchedule_Range_LastFullQuarter,
    OrgManage_ReportSchedule_Range_LastFullYear: OrgManage_ReportSchedule_Range_LastFullYear,
    OrgManage_ReportSchedule_Range_MonthToDate: OrgManage_ReportSchedule_Range_MonthToDate,
    OrgManage_ReportSchedule_Range_PreviousMonth: OrgManage_ReportSchedule_Range_PreviousMonth,
    OrgManage_ReportSchedule_Range_PreviousQuarter: OrgManage_ReportSchedule_Range_PreviousQuarter,
    OrgManage_ReportSchedule_Range_QuarterToDate: OrgManage_ReportSchedule_Range_QuarterToDate,
    OrgManage_ReportSchedule_Range_YearToDate: OrgManage_ReportSchedule_Range_YearToDate,
    OrgManage_ReportSchedule_ReportMaximum: OrgManage_ReportSchedule_ReportMaximum,
    OrgManage_ReportSchedule_ReportName: OrgManage_ReportSchedule_ReportName,
    OrgManage_ReportSchedule_ReportSchedule: OrgManage_ReportSchedule_ReportSchedule,
    OrgManage_ReportSchedule_ScheduleAdded: OrgManage_ReportSchedule_ScheduleAdded,
    OrgManage_ReportSchedule_ScheduleCreated: OrgManage_ReportSchedule_ScheduleCreated,
    OrgManage_ReportSchedule_ScheduleDeleted: OrgManage_ReportSchedule_ScheduleDeleted,
    OrgManage_ReportSchedule_ScheduleReport: OrgManage_ReportSchedule_ScheduleReport,
    OrgManage_ReportSchedule_ScheduleUpdated: OrgManage_ReportSchedule_ScheduleUpdated,
    OrgManage_ReportSchedule_SelectFrequency: OrgManage_ReportSchedule_SelectFrequency,
    OrgManage_ReportSchedule_SelectReportType: OrgManage_ReportSchedule_SelectReportType,
    OrgManage_ReportSchedule_SelectTimePeriod: OrgManage_ReportSchedule_SelectTimePeriod,
    OrgManage_ReportSchedule_SelectVersion: OrgManage_ReportSchedule_SelectVersion,
    OrgManage_ReportSchedule_UploadFile: OrgManage_ReportSchedule_UploadFile,
    OrgManage_SettingsError_OrgSupportInfoEmail_pattern: OrgManage_SettingsError_OrgSupportInfoEmail_pattern,
    OrgManage_SwitchTo: OrgManage_SwitchTo,
    OrgManage_UpdatedMessageCollectorsInformation: OrgManage_UpdatedMessageCollectorsInformation,
    OrgManage_UpdatedMessageConnectorsInformation: OrgManage_UpdatedMessageConnectorsInformation,
    OrgManage_UpdatedProviderRebranding: OrgManage_UpdatedProviderRebranding,
    OrgManage_UpdateUsers: OrgManage_UpdateUsers,
    OrgManage_UploadOpportunitiesError: OrgManage_UploadOpportunitiesError,
    OrgManage_UploadUsers: OrgManage_UploadUsers,
    OrgMemberFormCtrl_ConfirmRemoval: OrgMemberFormCtrl_ConfirmRemoval,
    OrgMemberFormCtrl_ConfirmRemovalMessage: OrgMemberFormCtrl_ConfirmRemovalMessage,
    OrgMemberFormCtrl_EmailPasswordReset: OrgMemberFormCtrl_EmailPasswordReset,
    OrgMemberFormCtrl_EmailResetPasswordSuccessMessageFormat: OrgMemberFormCtrl_EmailResetPasswordSuccessMessageFormat,
    OrgMemberFormCtrl_Groups: OrgMemberFormCtrl_Groups,
    OrgMemberFormCtrl_History: OrgMemberFormCtrl_History,
    OrgMemberFormCtrl_MemberSince: OrgMemberFormCtrl_MemberSince,
    OrgMemberFormCtrl_None: OrgMemberFormCtrl_None,
    OrgMemberFormCtrl_PasswordManagement: OrgMemberFormCtrl_PasswordManagement,
    OrgMemberFormCtrl_PendingMember: OrgMemberFormCtrl_PendingMember,
    OrgMemberFormCtrl_RemovedMemberSuccessMessage: OrgMemberFormCtrl_RemovedMemberSuccessMessage,
    OrgMemberFormCtrl_RemoveFromOrg: OrgMemberFormCtrl_RemoveFromOrg,
    OrgMemberFormCtrl_Removing: OrgMemberFormCtrl_Removing,
    OrgMemberFormCtrl_ResetPasswordDesc: OrgMemberFormCtrl_ResetPasswordDesc,
    OrgMemberFormCtrl_ResetPasswordOnLogin: OrgMemberFormCtrl_ResetPasswordOnLogin,
    OrgMemberFormCtrl_ResetPasswordToDefault: OrgMemberFormCtrl_ResetPasswordToDefault,
    OrgMemberFormCtrl_ResetPasswordToDefaultDesc: OrgMemberFormCtrl_ResetPasswordToDefaultDesc,
    OrgMemberFormCtrl_ResetPasswordToDefaultSuccess: OrgMemberFormCtrl_ResetPasswordToDefaultSuccess,
    OrgMemberFormCtrl_Role: OrgMemberFormCtrl_Role,
    OrgMemberFormCtrl_RolePermissions: OrgMemberFormCtrl_RolePermissions,
    OrgMemberFormCtrl_Title: OrgMemberFormCtrl_Title,
    OrgMemberFormCtrl_UpdatedMemberRoleSuccessMessage: OrgMemberFormCtrl_UpdatedMemberRoleSuccessMessage,
    OrgMemberFormCtrl_ViewUserSettings: OrgMemberFormCtrl_ViewUserSettings,
    OrgMembersCtrl_Admin: OrgMembersCtrl_Admin,
    OrgMembersCtrl_AnonUsersCountFormat: OrgMembersCtrl_AnonUsersCountFormat,
    OrgMembersCtrl_AnonUsersCountSingle: OrgMembersCtrl_AnonUsersCountSingle,
    OrgMembersCtrl_CountOfMembersFormat: OrgMembersCtrl_CountOfMembersFormat,
    OrgMembersCtrl_DateJoined: OrgMembersCtrl_DateJoined,
    OrgMembersCtrl_InviteMembers: OrgMembersCtrl_InviteMembers,
    OrgMembersCtrl_InviteUsers: OrgMembersCtrl_InviteUsers,
    OrgMembersCtrl_LastActive: OrgMembersCtrl_LastActive,
    OrgMembersCtrl_MemberInfoErrorMsg: OrgMembersCtrl_MemberInfoErrorMsg,
    OrgMembersCtrl_MemberSettingsText: OrgMembersCtrl_MemberSettingsText,
    OrgMembersCtrl_Name: OrgMembersCtrl_Name,
    OrgMembersCtrl_NoMembersMessage: OrgMembersCtrl_NoMembersMessage,
    OrgMembersCtrl_People: OrgMembersCtrl_People,
    OrgMembersCtrl_Points: OrgMembersCtrl_Points,
    OrgMembersCtrl_Private: OrgMembersCtrl_Private,
    OrgMembersCtrl_PrivateTooltip: OrgMembersCtrl_PrivateTooltip,
    OrgMembersCtrl_PrivateToOrg: OrgMembersCtrl_PrivateToOrg,
    OrgMembersCtrl_Public: OrgMembersCtrl_Public,
    OrgMembersCtrl_PublicTooltip: OrgMembersCtrl_PublicTooltip,
    OrgMembersCtrl_PublicToOrgTooltip: OrgMembersCtrl_PublicToOrgTooltip,
    OrgMembersCtrl_ResendInvites: OrgMembersCtrl_ResendInvites,
    OrgMembersCtrl_Role: OrgMembersCtrl_Role,
    OrgMembersCtrl_SearchForMember: OrgMembersCtrl_SearchForMember,
    OrgMembersCtrl_SearchForUser: OrgMembersCtrl_SearchForUser,
    OrgMembersCtrl_SeatsRemainingFormat: OrgMembersCtrl_SeatsRemainingFormat,
    OrgMembersCtrl_SeatsRemainingPluralFormat: OrgMembersCtrl_SeatsRemainingPluralFormat,
    OrgMembersCtrl_SeatsRemainingTooltip: OrgMembersCtrl_SeatsRemainingTooltip,
    OrgMembersCtrl_UsersCountFormat: OrgMembersCtrl_UsersCountFormat,
    OrgMembersCtrl_Visibility: OrgMembersCtrl_Visibility,
    OrgOpportunity_EngagementInsights_Tab: OrgOpportunity_EngagementInsights_Tab,
    OrgOpportunity_OpenInsights_Tab: OrgOpportunity_OpenInsights_Tab,
    OrgPathwayManagerCtrl_AddCollaborators: OrgPathwayManagerCtrl_AddCollaborators,
    OrgPathwayManagerCtrl_AuthorColumn: OrgPathwayManagerCtrl_AuthorColumn,
    OrgPathwayManagerCtrl_ConfirmDeleteButton: OrgPathwayManagerCtrl_ConfirmDeleteButton,
    OrgPathwayManagerCtrl_Delete: OrgPathwayManagerCtrl_Delete,
    OrgPathwayManagerCtrl_DeleteInstructions: OrgPathwayManagerCtrl_DeleteInstructions,
    OrgPathwayManagerCtrl_DeletePluralPrompt: OrgPathwayManagerCtrl_DeletePluralPrompt,
    OrgPathwayManagerCtrl_DeletePrompt: OrgPathwayManagerCtrl_DeletePrompt,
    OrgPathwayManagerCtrl_DeletePromptDescription: OrgPathwayManagerCtrl_DeletePromptDescription,
    OrgPathwayManagerCtrl_EndorsedPathwaysDescription: OrgPathwayManagerCtrl_EndorsedPathwaysDescription,
    OrgPathwayManagerCtrl_EnrolledColumn: OrgPathwayManagerCtrl_EnrolledColumn,
    OrgPathwayManagerCtrl_FeaturedColumn: OrgPathwayManagerCtrl_FeaturedColumn,
    OrgPathwayManagerCtrl_FollowingColumn: OrgPathwayManagerCtrl_FollowingColumn,
    OrgPathwayManagerCtrl_ItemsSelected: OrgPathwayManagerCtrl_ItemsSelected,
    OrgPathwayManagerCtrl_LastUpdatedColumn: OrgPathwayManagerCtrl_LastUpdatedColumn,
    OrgPathwayManagerCtrl_ManagePathwaysDescription: OrgPathwayManagerCtrl_ManagePathwaysDescription,
    OrgPathwayManagerCtrl_NameColumn: OrgPathwayManagerCtrl_NameColumn,
    OrgPathwayManagerCtrl_UpdateVisibility: OrgPathwayManagerCtrl_UpdateVisibility,
    OrgPathwayManagerCtrl_Visibility0: OrgPathwayManagerCtrl_Visibility0,
    OrgPathwayManagerCtrl_Visibility1: OrgPathwayManagerCtrl_Visibility1,
    OrgPathwayManagerCtrl_Visibility2: OrgPathwayManagerCtrl_Visibility2,
    OrgPathwayManagerCtrl_Visibility3: OrgPathwayManagerCtrl_Visibility3,
    OrgPathwayManagerCtrl_VisibilityColumn: OrgPathwayManagerCtrl_VisibilityColumn,
    OrgPlans_AddTargetOrDirectory: OrgPlans_AddTargetOrDirectory,
    OrgPlans_AllTypes: OrgPlans_AllTypes,
    OrgPlans_BundleInfo: OrgPlans_BundleInfo,
    OrgPlans_ChooseType: OrgPlans_ChooseType,
    OrgPlans_ChooseTypeHelpFormat: OrgPlans_ChooseTypeHelpFormat,
    OrgPlans_CloneBrowse: OrgPlans_CloneBrowse,
    OrgPlans_CloneDirectory: OrgPlans_CloneDirectory,
    OrgPlans_ClonePlan: OrgPlans_ClonePlan,
    OrgPlans_CloneRole: OrgPlans_CloneRole,
    OrgPlans_CloneTarget: OrgPlans_CloneTarget,
    OrgPlans_CreateBulkRoles: OrgPlans_CreateBulkRoles,
    OrgPlans_CreatedBy: OrgPlans_CreatedBy,
    OrgPlans_CreateDirectory: OrgPlans_CreateDirectory,
    OrgPlans_CreateRole: OrgPlans_CreateRole,
    OrgPlans_CreateTarget: OrgPlans_CreateTarget,
    OrgPlans_CreateTargetOrDirectory: OrgPlans_CreateTargetOrDirectory,
    OrgPlans_CustomTitlesAndDescriptionsNotLocalized: OrgPlans_CustomTitlesAndDescriptionsNotLocalized,
    OrgPlans_CustomTitlesAndTextNotLocalized: OrgPlans_CustomTitlesAndTextNotLocalized,
    OrgPlans_DeletePluralPrompt: OrgPlans_DeletePluralPrompt,
    OrgPlans_DeletePrompt: OrgPlans_DeletePrompt,
    OrgPlans_Description: OrgPlans_Description,
    OrgPlans_DescriptionPlaceholder: OrgPlans_DescriptionPlaceholder,
    OrgPlans_Directory: OrgPlans_Directory,
    OrgPlans_DirectoryDescription: OrgPlans_DirectoryDescription,
    OrgPlans_DirectoryDescriptionPlaceholder: OrgPlans_DirectoryDescriptionPlaceholder,
    OrgPlans_DirectoryImageAlt: OrgPlans_DirectoryImageAlt,
    OrgPlans_DirectoryTitlePlaceholder: OrgPlans_DirectoryTitlePlaceholder,
    OrgPlans_DisplayTypePlaceholder: OrgPlans_DisplayTypePlaceholder,
    OrgPlans_EditBrowse: OrgPlans_EditBrowse,
    OrgPlans_EditDirectory: OrgPlans_EditDirectory,
    OrgPlans_EditFeatured: OrgPlans_EditFeatured,
    OrgPlans_EditFeaturedPermissionError: OrgPlans_EditFeaturedPermissionError,
    OrgPlans_EditRole: OrgPlans_EditRole,
    OrgPlans_EditTarget: OrgPlans_EditTarget,
    OrgPlans_Featured: OrgPlans_Featured,
    OrgPlans_FollowerCount: OrgPlans_FollowerCount,
    OrgPlans_ImageUpload: OrgPlans_ImageUpload,
    OrgPlans_NoPlansAdded: OrgPlans_NoPlansAdded,
    OrgPlans_NoPlansFound: OrgPlans_NoPlansFound,
    OrgPlans_OnBrowseTooltip: OrgPlans_OnBrowseTooltip,
    OrgPlans_OnFeaturedTooltip: OrgPlans_OnFeaturedTooltip,
    OrgPlans_Pages: OrgPlans_Pages,
    OrgPlans_Parent: OrgPlans_Parent,
    OrgPlans_Plan: OrgPlans_Plan,
    OrgPlans_PlanDescription: OrgPlans_PlanDescription,
    OrgPlans_PlanImageAlt: OrgPlans_PlanImageAlt,
    OrgPlans_Plans: OrgPlans_Plans,
    OrgPlans_Purpose: OrgPlans_Purpose,
    OrgPlans_SetAsPrimaryPlan: OrgPlans_SetAsPrimaryPlan,
    OrgPlans_SkillPlanPlaceholder: OrgPlans_SkillPlanPlaceholder,
    OrgPlans_Subtitle: OrgPlans_Subtitle,
    OrgPlans_SubtitlePlaceholder: OrgPlans_SubtitlePlaceholder,
    OrgPlans_SubtitleTooltip: OrgPlans_SubtitleTooltip,
    OrgPlans_TargetDescriptionPlaceholder: OrgPlans_TargetDescriptionPlaceholder,
    OrgPlans_Template: OrgPlans_Template,
    OrgPlans_Title: OrgPlans_Title,
    OrgPlans_TitlePlaceholder: OrgPlans_TitlePlaceholder,
    OrgPlans_Type: OrgPlans_Type,
    OrgPlans_TypeBrowse: OrgPlans_TypeBrowse,
    OrgPlans_TypeDirectory: OrgPlans_TypeDirectory,
    OrgPlans_TypeFeatured: OrgPlans_TypeFeatured,
    OrgPlans_TypeRole: OrgPlans_TypeRole,
    OrgPlans_Types: OrgPlans_Types,
    OrgPlans_TypeTarget: OrgPlans_TypeTarget,
    OrgPlans_Visibility: OrgPlans_Visibility,
    orgProviderLicenseModal_ContinueButtonFormat: orgProviderLicenseModal_ContinueButtonFormat,
    orgProviderLicenseModal_CreatedLicenseFormat: orgProviderLicenseModal_CreatedLicenseFormat,
    orgProviderLicenseModal_InstructionsFormat: orgProviderLicenseModal_InstructionsFormat,
    orgProviderLicenseModal_LicenseErrorFormat: orgProviderLicenseModal_LicenseErrorFormat,
    orgProviderLicenseModal_MessageErrorFormat: orgProviderLicenseModal_MessageErrorFormat,
    OrgRatingScaleChange_NotificationContent: OrgRatingScaleChange_NotificationContent,
    OrgRatingScaleChange_NotificationDescription: OrgRatingScaleChange_NotificationDescription,
    OrgRatingScaleChange_NotificationTitle: OrgRatingScaleChange_NotificationTitle,
    OrgReportingCtrl_All: OrgReportingCtrl_All,
    OrgReportingCtrl_AllCompletedContent: OrgReportingCtrl_AllCompletedContent,
    OrgReportingCtrl_AllGroups: OrgReportingCtrl_AllGroups,
    OrgReportingCtrl_AllSkills: OrgReportingCtrl_AllSkills,
    OrgReportingCtrl_AllTopics: OrgReportingCtrl_AllTopics,
    OrgReportingCtrl_And: OrgReportingCtrl_And,
    OrgReportingCtrl_Count: OrgReportingCtrl_Count,
    OrgReportingCtrl_DateMaxValidation: OrgReportingCtrl_DateMaxValidation,
    OrgReportingCtrl_DateMaxValidationFormat: OrgReportingCtrl_DateMaxValidationFormat,
    OrgReportingCtrl_DownloadableReports: OrgReportingCtrl_DownloadableReports,
    OrgReportingCtrl_ErrorWithProvider: OrgReportingCtrl_ErrorWithProvider,
    OrgReportingCtrl_ExternalCatalog: OrgReportingCtrl_ExternalCatalog,
    OrgReportingCtrl_ExternalContent: OrgReportingCtrl_ExternalContent,
    OrgReportingCtrl_FilterByGroup: OrgReportingCtrl_FilterByGroup,
    OrgReportingCtrl_FilterByLocation: OrgReportingCtrl_FilterByLocation,
    OrgReportingCtrl_FilterByOrg: OrgReportingCtrl_FilterByOrg,
    OrgReportingCtrl_FilterBySkill: OrgReportingCtrl_FilterBySkill,
    OrgReportingCtrl_FullCatalog: OrgReportingCtrl_FullCatalog,
    OrgReportingCtrl_InputsAdded: OrgReportingCtrl_InputsAdded,
    OrgReportingCtrl_Insights: OrgReportingCtrl_Insights,
    OrgReportingCtrl_InternalCatalog: OrgReportingCtrl_InternalCatalog,
    OrgReportingCtrl_InternalContent: OrgReportingCtrl_InternalContent,
    OrgReportingCtrl_ItemsAdded: OrgReportingCtrl_ItemsAdded,
    OrgReportingCtrl_KpiItemsAddedName: OrgReportingCtrl_KpiItemsAddedName,
    OrgReportingCtrl_KpiItemsAddedTooltip: OrgReportingCtrl_KpiItemsAddedTooltip,
    OrgReportingCtrl_KpiLoginsName: OrgReportingCtrl_KpiLoginsName,
    OrgReportingCtrl_KpiLoginsTooltip: OrgReportingCtrl_KpiLoginsTooltip,
    OrgReportingCtrl_KpiOrgExpertsName: OrgReportingCtrl_KpiOrgExpertsName,
    OrgReportingCtrl_KpiOrgExpertsTooltip: OrgReportingCtrl_KpiOrgExpertsTooltip,
    OrgReportingCtrl_KpiRecommendationsName: OrgReportingCtrl_KpiRecommendationsName,
    OrgReportingCtrl_KpiRecommendationsTooltip: OrgReportingCtrl_KpiRecommendationsTooltip,
    OrgReportingCtrl_KPIS_Error: OrgReportingCtrl_KPIS_Error,
    OrgReportingCtrl_KpiSkillRatedUsersName: OrgReportingCtrl_KpiSkillRatedUsersName,
    OrgReportingCtrl_KpiSkillRatedUsersTooltip: OrgReportingCtrl_KpiSkillRatedUsersTooltip,
    OrgReportingCtrl_KpiViewsName: OrgReportingCtrl_KpiViewsName,
    OrgReportingCtrl_KpiViewsTooltip: OrgReportingCtrl_KpiViewsTooltip,
    OrgReportingCtrl_LearningSummary: OrgReportingCtrl_LearningSummary,
    OrgReportingCtrl_Members: OrgReportingCtrl_Members,
    OrgReportingCtrl_MinimumAggregatedLearningInsightsUserCount: OrgReportingCtrl_MinimumAggregatedLearningInsightsUserCount,
    OrgReportingCtrl_Name: OrgReportingCtrl_Name,
    OrgReportingCtrl_NoMatchingGroups: OrgReportingCtrl_NoMatchingGroups,
    OrgReportingCtrl_NoMatchingLocations: OrgReportingCtrl_NoMatchingLocations,
    OrgReportingCtrl_NoMatchingOrgs: OrgReportingCtrl_NoMatchingOrgs,
    OrgReportingCtrl_NoMatchingSkills: OrgReportingCtrl_NoMatchingSkills,
    OrgReportingCtrl_NoMatchingStatus: OrgReportingCtrl_NoMatchingStatus,
    OrgReportingCtrl_NoMatchingTypes: OrgReportingCtrl_NoMatchingTypes,
    OrgReportingCtrl_NoResults: OrgReportingCtrl_NoResults,
    OrgReportingCtrl_Points: OrgReportingCtrl_Points,
    OrgReportingCtrl_ResultsFormat: OrgReportingCtrl_ResultsFormat,
    OrgReportingCtrl_ShouldNotBeConnected: OrgReportingCtrl_ShouldNotBeConnected,
    OrgReportingCtrl_TimesAdded: OrgReportingCtrl_TimesAdded,
    OrgReportingCtrl_TopResultsFormat: OrgReportingCtrl_TopResultsFormat,
    OrgReportingCtrl_TotalContentViewed: OrgReportingCtrl_TotalContentViewed,
    OrgReportingCtrl_TotalItemsAdded: OrgReportingCtrl_TotalItemsAdded,
    OrgReportingCtrl_TotalPointsEarned: OrgReportingCtrl_TotalPointsEarned,
    OrgReportSchedule_Frequency_Daily: OrgReportSchedule_Frequency_Daily,
    OrgReportSchedule_Frequency_DailyMondayThruFriday: OrgReportSchedule_Frequency_DailyMondayThruFriday,
    OrgReportSchedule_Frequency_Monthly: OrgReportSchedule_Frequency_Monthly,
    OrgReportSchedule_Frequency_Quarterly: OrgReportSchedule_Frequency_Quarterly,
    OrgReportSchedule_Frequency_WeeklyOnMonday: OrgReportSchedule_Frequency_WeeklyOnMonday,
    OrgReportSchedule_Frequency_WeeklyOnSunday: OrgReportSchedule_Frequency_WeeklyOnSunday,
    OrgSecurityCtrl_CreateGroups: OrgSecurityCtrl_CreateGroups,
    OrgSecurityCtrl_DefaultRoleTextFormat: OrgSecurityCtrl_DefaultRoleTextFormat,
    OrgSecurityCtrl_RolesUpdatedSuccessMessage: OrgSecurityCtrl_RolesUpdatedSuccessMessage,
    OrgSettings_AcceptJobRoleFromClientUserFile_Desc: OrgSettings_AcceptJobRoleFromClientUserFile_Desc,
    OrgSettings_AddCard: OrgSettings_AddCard,
    OrgSettings_AdminNotifications: OrgSettings_AdminNotifications,
    OrgSettings_AllowEmailPasswordReset_Desc: OrgSettings_AllowEmailPasswordReset_Desc,
    OrgSettings_AllowEmailPasswordReset_Name: OrgSettings_AllowEmailPasswordReset_Name,
    OrgSettings_AllowInteractionAcrossOrganizations_Desc: OrgSettings_AllowInteractionAcrossOrganizations_Desc,
    OrgSettings_AllowInteractionAcrossOrganizations_Name: OrgSettings_AllowInteractionAcrossOrganizations_Name,
    OrgSettings_AllowOrgTransfer_Desc: OrgSettings_AllowOrgTransfer_Desc,
    OrgSettings_AllowOrgTransfer_Name: OrgSettings_AllowOrgTransfer_Name,
    OrgSettings_AllowSkillSuggestions_Desc: OrgSettings_AllowSkillSuggestions_Desc,
    OrgSettings_AllowSkillSuggestions_Name: OrgSettings_AllowSkillSuggestions_Name,
    OrgSettings_AllowSsoUserIdUpdate_Desc: OrgSettings_AllowSsoUserIdUpdate_Desc,
    OrgSettings_AllowSsoUserIdUpdate_Name: OrgSettings_AllowSsoUserIdUpdate_Name,
    OrgSettings_AnonymizeCredsparkUsers_Desc: OrgSettings_AnonymizeCredsparkUsers_Desc,
    OrgSettings_AnonymizeCredsparkUsers_Name: OrgSettings_AnonymizeCredsparkUsers_Name,
    OrgSettings_AnonymizePrivateUsers_Desc: OrgSettings_AnonymizePrivateUsers_Desc,
    OrgSettings_AnonymizePrivateUsers_Name: OrgSettings_AnonymizePrivateUsers_Name,
    OrgSettings_AnonymizeZendeskUsers_Desc: OrgSettings_AnonymizeZendeskUsers_Desc,
    OrgSettings_AnonymizeZendeskUsers_Name: OrgSettings_AnonymizeZendeskUsers_Name,
    OrgSettings_AppFeedback_GroupDesc: OrgSettings_AppFeedback_GroupDesc,
    OrgSettings_AppFeedback_GroupDisplayName: OrgSettings_AppFeedback_GroupDisplayName,
    OrgSettings_AppGuidance_GroupDesc: OrgSettings_AppGuidance_GroupDesc,
    OrgSettings_AppGuidance_GroupDisplayName: OrgSettings_AppGuidance_GroupDisplayName,
    OrgSettings_AssignedLearning_Desc: OrgSettings_AssignedLearning_Desc,
    OrgSettings_AssignedLearning_Name: OrgSettings_AssignedLearning_Name,
    OrgSettings_AssignedLearningDescription: OrgSettings_AssignedLearningDescription,
    OrgSettings_AssignedLearningSaveSuccess: OrgSettings_AssignedLearningSaveSuccess,
    OrgSettings_AuditUserGeneratedData_Desc: OrgSettings_AuditUserGeneratedData_Desc,
    OrgSettings_AuditUserGeneratedData_Name: OrgSettings_AuditUserGeneratedData_Name,
    OrgSettings_AuthenticationSettings: OrgSettings_AuthenticationSettings,
    OrgSettings_BuildSkillsEmail_Desc: OrgSettings_BuildSkillsEmail_Desc,
    OrgSettings_BuildSkillsEmail_Name: OrgSettings_BuildSkillsEmail_Name,
    OrgSettings_ButtonTitleRequired: OrgSettings_ButtonTitleRequired,
    OrgSettings_CardDescription: OrgSettings_CardDescription,
    OrgSettings_CardDescriptionPlaceholder: OrgSettings_CardDescriptionPlaceholder,
    OrgSettings_CardNumber: OrgSettings_CardNumber,
    OrgSettings_CardPositionAriaText: OrgSettings_CardPositionAriaText,
    OrgSettings_CardTitle: OrgSettings_CardTitle,
    OrgSettings_CardTitlePlaceholder: OrgSettings_CardTitlePlaceholder,
    OrgSettings_CardType: OrgSettings_CardType,
    OrgSettings_CareersFooterMessage_Desc: OrgSettings_CareersFooterMessage_Desc,
    OrgSettings_CareersFooterMessage_Name: OrgSettings_CareersFooterMessage_Name,
    OrgSettings_ClientAdobeAnalyticsId_Desc: OrgSettings_ClientAdobeAnalyticsId_Desc,
    OrgSettings_ClientAdobeAnalyticsId_Name: OrgSettings_ClientAdobeAnalyticsId_Name,
    OrgSettings_ClientGoogleAnalyticsId_Desc: OrgSettings_ClientGoogleAnalyticsId_Desc,
    OrgSettings_ClientGoogleAnalyticsId_Name: OrgSettings_ClientGoogleAnalyticsId_Name,
    OrgSettings_ClientTypeOverride_Desc: OrgSettings_ClientTypeOverride_Desc,
    OrgSettings_ClientTypeOverride_Name: OrgSettings_ClientTypeOverride_Name,
    OrgSettings_ClientTypeOverride_Selection_None: OrgSettings_ClientTypeOverride_Selection_None,
    OrgSettings_ClientTypeOverride_Selection_SkillAnalytics: OrgSettings_ClientTypeOverride_Selection_SkillAnalytics,
    OrgSettings_ClientTypeOverride_Selection_SkillInventory: OrgSettings_ClientTypeOverride_Selection_SkillInventory,
    OrgSettings_CmsCascadeDeleteFileImport_Desc: OrgSettings_CmsCascadeDeleteFileImport_Desc,
    OrgSettings_CmsCascadeDeleteFileImport_Name: OrgSettings_CmsCascadeDeleteFileImport_Name,
    OrgSettings_CmsCascadeDeleteNotifyUsers_Desc: OrgSettings_CmsCascadeDeleteNotifyUsers_Desc,
    OrgSettings_CmsCascadeDeleteNotifyUsers_Name: OrgSettings_CmsCascadeDeleteNotifyUsers_Name,
    OrgSettings_CompleteViewedItems_Desc: OrgSettings_CompleteViewedItems_Desc,
    OrgSettings_CompleteViewedItems_Name: OrgSettings_CompleteViewedItems_Name,
    OrgSettings_Confirmation: OrgSettings_Confirmation,
    OrgSettings_ContentModeratorOptions_Desc: OrgSettings_ContentModeratorOptions_Desc,
    OrgSettings_ContentModeratorOptions_Name: OrgSettings_ContentModeratorOptions_Name,
    OrgSettings_ContentSettings: OrgSettings_ContentSettings,
    OrgSettings_CreateManagerGroups_Desc: OrgSettings_CreateManagerGroups_Desc,
    OrgSettings_CredSparkEnabled_Desc: OrgSettings_CredSparkEnabled_Desc,
    OrgSettings_CredSparkEnabled_Name: OrgSettings_CredSparkEnabled_Name,
    OrgSettings_CustomizeCard: OrgSettings_CustomizeCard,
    OrgSettings_CustomizeCardDescription: OrgSettings_CustomizeCardDescription,
    OrgSettings_CustomizeHelpMenu: OrgSettings_CustomizeHelpMenu,
    OrgSettings_CustomMessageDesc: OrgSettings_CustomMessageDesc,
    OrgSettings_CustomOnboardingText_Default: OrgSettings_CustomOnboardingText_Default,
    OrgSettings_CustomOnboardingText_Desc: OrgSettings_CustomOnboardingText_Desc,
    OrgSettings_CustomOnboardingText_Name: OrgSettings_CustomOnboardingText_Name,
    OrgSettings_CustomRatingLevelNames_Desc: OrgSettings_CustomRatingLevelNames_Desc,
    OrgSettings_CustomRatingLevelNames_Name: OrgSettings_CustomRatingLevelNames_Name,
    OrgSettings_CustomRatingScale_Desc: OrgSettings_CustomRatingScale_Desc,
    OrgSettings_CustomRatingScale_Name: OrgSettings_CustomRatingScale_Name,
    OrgSettings_CustomRatingScale_Selection_Eight: OrgSettings_CustomRatingScale_Selection_Eight,
    OrgSettings_CustomRatingScale_Selection_Five: OrgSettings_CustomRatingScale_Selection_Five,
    OrgSettings_CustomRatingScale_Selection_Four: OrgSettings_CustomRatingScale_Selection_Four,
    OrgSettings_CustomRatingScale_Selection_Nine: OrgSettings_CustomRatingScale_Selection_Nine,
    OrgSettings_CustomRatingScale_Selection_Seven: OrgSettings_CustomRatingScale_Selection_Seven,
    OrgSettings_CustomRatingScale_Selection_Six: OrgSettings_CustomRatingScale_Selection_Six,
    OrgSettings_CustomRatingScale_Selection_Ten: OrgSettings_CustomRatingScale_Selection_Ten,
    OrgSettings_DailySummaryEmail_Desc: OrgSettings_DailySummaryEmail_Desc,
    OrgSettings_DailySummaryEmail_Name: OrgSettings_DailySummaryEmail_Name,
    OrgSettings_DateReceived: OrgSettings_DateReceived,
    OrgSettings_DefaultAssignmentsSort_Desc: OrgSettings_DefaultAssignmentsSort_Desc,
    OrgSettings_DefaultAssignmentsSort_Name: OrgSettings_DefaultAssignmentsSort_Name,
    OrgSettings_DefaultAssignmentsSort_Selection_AssignmentType: OrgSettings_DefaultAssignmentsSort_Selection_AssignmentType,
    OrgSettings_DefaultAssignmentsSort_Selection_DueDate: OrgSettings_DefaultAssignmentsSort_Selection_DueDate,
    OrgSettings_DefaultMessage: OrgSettings_DefaultMessage,
    OrgSettings_DefaultPrivacyLevel_Desc: OrgSettings_DefaultPrivacyLevel_Desc,
    OrgSettings_DefaultPrivacyLevel_Name: OrgSettings_DefaultPrivacyLevel_Name,
    OrgSettings_DefaultPWResetUI_Desc: OrgSettings_DefaultPWResetUI_Desc,
    OrgSettings_DefaultPWResetUI_Name: OrgSettings_DefaultPWResetUI_Name,
    OrgSettings_DefaultUserPassword_Desc: OrgSettings_DefaultUserPassword_Desc,
    OrgSettings_DefaultUserPassword_Name: OrgSettings_DefaultUserPassword_Name,
    OrgSettings_DegreedCareerMobility: OrgSettings_DegreedCareerMobility,
    OrgSettings_DegreedFeatures: OrgSettings_DegreedFeatures,
    OrgSettings_DegreedLearnUponUserSync: OrgSettings_DegreedLearnUponUserSync,
    OrgSettings_DegreedSurveys_Desc: OrgSettings_DegreedSurveys_Desc,
    OrgSettings_DegreedSurveys_Name: OrgSettings_DegreedSurveys_Name,
    OrgSettings_DegreedTalent_Desc: OrgSettings_DegreedTalent_Desc,
    OrgSettings_DegreedTalent_Name: OrgSettings_DegreedTalent_Name,
    OrgSettings_DeleteCardAriaText: OrgSettings_DeleteCardAriaText,
    OrgSettings_DeleteCardSuccess: OrgSettings_DeleteCardSuccess,
    OrgSettings_DeleteLink: OrgSettings_DeleteLink,
    OrgSettings_DeleteLinkModalMessage: OrgSettings_DeleteLinkModalMessage,
    OrgSettings_DeleteLinkSuccess: OrgSettings_DeleteLinkSuccess,
    OrgSettings_DeleteSavedLink: OrgSettings_DeleteSavedLink,
    OrgSettings_Delimiter_Desc: OrgSettings_Delimiter_Desc,
    OrgSettings_Delimiter_Name: OrgSettings_Delimiter_Name,
    OrgSettings_DenyComments_Desc: OrgSettings_DenyComments_Desc,
    OrgSettings_DenyComments_Name: OrgSettings_DenyComments_Name,
    OrgSettings_DGAssistant_GroupDesc: OrgSettings_DGAssistant_GroupDesc,
    OrgSettings_DGAssistant_GroupDisplayName: OrgSettings_DGAssistant_GroupDisplayName,
    OrgSettings_DGAssistantQuickResponse_Desc: OrgSettings_DGAssistantQuickResponse_Desc,
    OrgSettings_DGAssistantQuickResponse_Name: OrgSettings_DGAssistantQuickResponse_Name,
    OrgSettings_DisableAnalytics_Desc: OrgSettings_DisableAnalytics_Desc,
    OrgSettings_DisableAnalytics_Name: OrgSettings_DisableAnalytics_Name,
    OrgSettings_DisableAssignedLearning_Desc: OrgSettings_DisableAssignedLearning_Desc,
    OrgSettings_DisableAssignedLearning_Name: OrgSettings_DisableAssignedLearning_Name,
    OrgSettings_DisableAssignedLearningTab_Desc: OrgSettings_DisableAssignedLearningTab_Desc,
    OrgSettings_DisableAssignedLearningTab_Name: OrgSettings_DisableAssignedLearningTab_Name,
    OrgSettings_DisableBulkUpload_Desc: OrgSettings_DisableBulkUpload_Desc,
    OrgSettings_DisableBulkUpload_Name: OrgSettings_DisableBulkUpload_Name,
    OrgSettings_DisableCollaboratorsHeader_Desc: OrgSettings_DisableCollaboratorsHeader_Desc,
    OrgSettings_DisableCollaboratorsHeader_Name: OrgSettings_DisableCollaboratorsHeader_Name,
    OrgSettings_DisableContent2skills_Desc: OrgSettings_DisableContent2skills_Desc,
    OrgSettings_DisableContent2skills_Name: OrgSettings_DisableContent2skills_Name,
    OrgSettings_DisableDegreedMarketplace_Desc: OrgSettings_DisableDegreedMarketplace_Desc,
    OrgSettings_DisableDegreedMarketplace_Name: OrgSettings_DisableDegreedMarketplace_Name,
    OrgSettings_DisableEndorsedSearchResultsSection_Desc: OrgSettings_DisableEndorsedSearchResultsSection_Desc,
    OrgSettings_DisableEndorsedSearchResultsSection_Name: OrgSettings_DisableEndorsedSearchResultsSection_Name,
    OrgSettings_DisableEngagedLearner_Desc: OrgSettings_DisableEngagedLearner_Desc,
    OrgSettings_DisableEngagedLearner_Name: OrgSettings_DisableEngagedLearner_Name,
    OrgSettings_DisableHomeAdminSettings_Desc: OrgSettings_DisableHomeAdminSettings_Desc,
    OrgSettings_DisableHomeAdminSettings_Name: OrgSettings_DisableHomeAdminSettings_Name,
    OrgSettings_DisableIndividualSkillsData_Desc: OrgSettings_DisableIndividualSkillsData_Desc,
    OrgSettings_DisableIndividualSkillsData_Name: OrgSettings_DisableIndividualSkillsData_Name,
    OrgSettings_DisableInviteOrgMember_Desc: OrgSettings_DisableInviteOrgMember_Desc,
    OrgSettings_DisableInviteOrgMember_Name: OrgSettings_DisableInviteOrgMember_Name,
    OrgSettings_DisableKnowledgeCenter_Desc: OrgSettings_DisableKnowledgeCenter_Desc,
    OrgSettings_DisableKnowledgeCenter_Name: OrgSettings_DisableKnowledgeCenter_Name,
    OrgSettings_DisableLearnerSkillsRegistry_Desc: OrgSettings_DisableLearnerSkillsRegistry_Desc,
    OrgSettings_DisableLearnerSkillsRegistry_Name: OrgSettings_DisableLearnerSkillsRegistry_Name,
    OrgSettings_DisableLearningCampaigns_Desc: OrgSettings_DisableLearningCampaigns_Desc,
    OrgSettings_DisableLearningCampaigns_Name: OrgSettings_DisableLearningCampaigns_Name,
    OrgSettings_DisableManageContent_Desc: OrgSettings_DisableManageContent_Desc,
    OrgSettings_DisableManageContent_Name: OrgSettings_DisableManageContent_Name,
    OrgSettings_DisableMedalliaScript_Desc: OrgSettings_DisableMedalliaScript_Desc,
    OrgSettings_DisableMedalliaScript_Name: OrgSettings_DisableMedalliaScript_Name,
    OrgSettings_DisableMentorshipReview_Desc: OrgSettings_DisableMentorshipReview_Desc,
    OrgSettings_DisableMentorshipReview_Name: OrgSettings_DisableMentorshipReview_Name,
    OrgSettings_DisablePathwayHeaderImage_Desc: OrgSettings_DisablePathwayHeaderImage_Desc,
    OrgSettings_DisablePathwayHeaderImage_Name: OrgSettings_DisablePathwayHeaderImage_Name,
    OrgSettings_DisablePersonalizedLearningTab_Desc: OrgSettings_DisablePersonalizedLearningTab_Desc,
    OrgSettings_DisablePersonalizedLearningTab_Name: OrgSettings_DisablePersonalizedLearningTab_Name,
    OrgSettings_DisablePopupMessages_Desc: OrgSettings_DisablePopupMessages_Desc,
    OrgSettings_DisablePopupMessages_Name: OrgSettings_DisablePopupMessages_Name,
    OrgSettings_DisableProfileSkillSuggestions_Desc: OrgSettings_DisableProfileSkillSuggestions_Desc,
    OrgSettings_DisableProfileSkillSuggestions_Name: OrgSettings_DisableProfileSkillSuggestions_Name,
    OrgSettings_DisableRatingsInsights_Desc: OrgSettings_DisableRatingsInsights_Desc,
    OrgSettings_DisableRatingsInsights_Name: OrgSettings_DisableRatingsInsights_Name,
    OrgSettings_DisableResumeParsingInOnboarding_Desc: OrgSettings_DisableResumeParsingInOnboarding_Desc,
    OrgSettings_DisableSearchRelatedSkills_Desc: OrgSettings_DisableSearchRelatedSkills_Desc,
    OrgSettings_DisableSearchRelatedSkills_Name: OrgSettings_DisableSearchRelatedSkills_Name,
    OrgSettings_DisableSkillsVisualization_Desc: OrgSettings_DisableSkillsVisualization_Desc,
    OrgSettings_DisableSkillsVisualization_Name: OrgSettings_DisableSkillsVisualization_Name,
    OrgSettings_DisableThirdPartyExperienceManagement_Desc: OrgSettings_DisableThirdPartyExperienceManagement_Desc,
    OrgSettings_DisableThirdPartyExperienceManagement_Name: OrgSettings_DisableThirdPartyExperienceManagement_Name,
    OrgSettings_DisableTopLearnerInsights_Desc: OrgSettings_DisableTopLearnerInsights_Desc,
    OrgSettings_DisableTopLearnerInsights_Name: OrgSettings_DisableTopLearnerInsights_Name,
    OrgSettings_DisableUserGeneratedContent_Desc: OrgSettings_DisableUserGeneratedContent_Desc,
    OrgSettings_DisableUserGeneratedContent_Name: OrgSettings_DisableUserGeneratedContent_Name,
    OrgSettings_DiscardCardChanges: OrgSettings_DiscardCardChanges,
    OrgSettings_DownloadablePathwayReportEmployeeIdentifier_Desc: OrgSettings_DownloadablePathwayReportEmployeeIdentifier_Desc,
    OrgSettings_DownloadablePathwayReportEmployeeIdentifier_Name: OrgSettings_DownloadablePathwayReportEmployeeIdentifier_Name,
    OrgSettings_DownloadablePathwayReportEmployeeIdentifier_Selection_Both: OrgSettings_DownloadablePathwayReportEmployeeIdentifier_Selection_Both,
    OrgSettings_DownloadablePathwayReportEmployeeIdentifier_Selection_EmployeeIdOnly: OrgSettings_DownloadablePathwayReportEmployeeIdentifier_Selection_EmployeeIdOnly,
    OrgSettings_DownloadablePathwayReportEmployeeIdentifier_Selection_OrganizationEmailOnly: OrgSettings_DownloadablePathwayReportEmployeeIdentifier_Selection_OrganizationEmailOnly,
    OrgSettings_DownloadableReportPermissionReadOnly_Desc: OrgSettings_DownloadableReportPermissionReadOnly_Desc,
    OrgSettings_DownloadableReportPermissionReadOnly_Name: OrgSettings_DownloadableReportPermissionReadOnly_Name,
    OrgSettings_EmailSettings: OrgSettings_EmailSettings,
    OrgSettings_EmailSettings_Desc: OrgSettings_EmailSettings_Desc,
    OrgSettings_EmailSettings_GroupDesc: OrgSettings_EmailSettings_GroupDesc,
    OrgSettings_EmailSettings_GroupDisplayName: OrgSettings_EmailSettings_GroupDisplayName,
    OrgSettings_EmailSettings_Name: OrgSettings_EmailSettings_Name,
    OrgSettings_EmployeeProcessing: OrgSettings_EmployeeProcessing,
    OrgSettings_EnableActiveUserInsights_Desc: OrgSettings_EnableActiveUserInsights_Desc,
    OrgSettings_EnableActiveUserInsights_Name: OrgSettings_EnableActiveUserInsights_Name,
    OrgSettings_EnableAdvancedSkillAnalytics_Desc: OrgSettings_EnableAdvancedSkillAnalytics_Desc,
    OrgSettings_EnableAdvancedSkillAnalytics_Name: OrgSettings_EnableAdvancedSkillAnalytics_Name,
    OrgSettings_EnableAISkillInference_Desc: OrgSettings_EnableAISkillInference_Desc,
    OrgSettings_EnableAISkillInference_Name: OrgSettings_EnableAISkillInference_Name,
    OrgSettings_EnableCareerPathing_Desc: OrgSettings_EnableCareerPathing_Desc,
    OrgSettings_EnableCareerPathing_Name: OrgSettings_EnableCareerPathing_Name,
    OrgSettings_EnableCustomRatingLevelNames_Desc: OrgSettings_EnableCustomRatingLevelNames_Desc,
    OrgSettings_EnableCustomRatingLevelNames_Name: OrgSettings_EnableCustomRatingLevelNames_Name,
    OrgSettings_EnableCustomRatingScale_Desc: OrgSettings_EnableCustomRatingScale_Desc,
    OrgSettings_EnableCustomRatingScale_Name: OrgSettings_EnableCustomRatingScale_Name,
    OrgSettings_EnableCustomRecommendationTypes_Desc: OrgSettings_EnableCustomRecommendationTypes_Desc,
    OrgSettings_EnableCustomRecommendationTypes_Name: OrgSettings_EnableCustomRecommendationTypes_Name,
    OrgSettings_EnableDCMPilot_Desc: OrgSettings_EnableDCMPilot_Desc,
    OrgSettings_EnableDCMPilot_Name: OrgSettings_EnableDCMPilot_Name,
    OrgSettings_EnableDirectoriesOnBrowse_Desc: OrgSettings_EnableDirectoriesOnBrowse_Desc,
    OrgSettings_EnableDirectoriesOnBrowse_Name: OrgSettings_EnableDirectoriesOnBrowse_Name,
    OrgSettings_EnableEngage_Desc: OrgSettings_EnableEngage_Desc,
    OrgSettings_EnableEngage_Name: OrgSettings_EnableEngage_Name,
    OrgSettings_EnableEvaluationEndorsements_Desc: OrgSettings_EnableEvaluationEndorsements_Desc,
    OrgSettings_EnableEvaluationEndorsements_Name: OrgSettings_EnableEvaluationEndorsements_Name,
    OrgSettings_EnableManagerOfManager_Desc: OrgSettings_EnableManagerOfManager_Desc,
    OrgSettings_EnableManagerOfManager_Name: OrgSettings_EnableManagerOfManager_Name,
    OrgSettings_EnableManagerRatings_Desc: OrgSettings_EnableManagerRatings_Desc,
    OrgSettings_EnableManagerRatings_Name: OrgSettings_EnableManagerRatings_Name,
    OrgSettings_EnableMentorshipOpportunities_Desc: OrgSettings_EnableMentorshipOpportunities_Desc,
    OrgSettings_EnableMentorshipOpportunities_Name: OrgSettings_EnableMentorshipOpportunities_Name,
    OrgSettings_EnableMobileBiometricAuth_Desc: OrgSettings_EnableMobileBiometricAuth_Desc,
    OrgSettings_EnableMobileBiometricAuth_Name: OrgSettings_EnableMobileBiometricAuth_Name,
    OrgSettings_EnableNewReportingFTPConnection_Desc: OrgSettings_EnableNewReportingFTPConnection_Desc,
    OrgSettings_EnableOptionalEvaluationEndorsement_Desc: OrgSettings_EnableOptionalEvaluationEndorsement_Desc,
    OrgSettings_EnableOptionalEvaluationEndorsement_Name: OrgSettings_EnableOptionalEvaluationEndorsement_Name,
    OrgSettings_EnableOrgInsightsSkillsTab_Desc: OrgSettings_EnableOrgInsightsSkillsTab_Desc,
    OrgSettings_EnableOrgInsightsSkillsTab_Name: OrgSettings_EnableOrgInsightsSkillsTab_Name,
    OrgSettings_EnablePathwayBadgeTrigger_Desc: OrgSettings_EnablePathwayBadgeTrigger_Desc,
    OrgSettings_EnablePathwayBadgeTrigger_Name: OrgSettings_EnablePathwayBadgeTrigger_Name,
    OrgSettings_EnablePeerRatings_Desc: OrgSettings_EnablePeerRatings_Desc,
    OrgSettings_EnablePeerRatings_Name: OrgSettings_EnablePeerRatings_Name,
    OrgSettings_EnablePluralsightSkillsIntegration_Desc: OrgSettings_EnablePluralsightSkillsIntegration_Desc,
    OrgSettings_EnablePluralsightSkillsIntegration_Name: OrgSettings_EnablePluralsightSkillsIntegration_Name,
    OrgSettings_EnablePreferredContentLanguagesFilter_Desc: OrgSettings_EnablePreferredContentLanguagesFilter_Desc,
    OrgSettings_EnablePreferredContentLanguagesFilter_Name: OrgSettings_EnablePreferredContentLanguagesFilter_Name,
    OrgSettings_EnablePrimaryPlanOnDashboard_Desc: OrgSettings_EnablePrimaryPlanOnDashboard_Desc,
    OrgSettings_EnablePrimaryPlanOnDashboard_Name: OrgSettings_EnablePrimaryPlanOnDashboard_Name,
    OrgSettings_EnableProvidersInUI_Desc: OrgSettings_EnableProvidersInUI_Desc,
    OrgSettings_EnableProvidersInUI_Name: OrgSettings_EnableProvidersInUI_Name,
    OrgSettings_EnableSkillCoachOptInSettingForAll_Desc: OrgSettings_EnableSkillCoachOptInSettingForAll_Desc,
    OrgSettings_EnableSkillCoachOptInSettingForAll_Name: OrgSettings_EnableSkillCoachOptInSettingForAll_Name,
    OrgSettings_EnableSkillInsightsDashboard_Desc: OrgSettings_EnableSkillInsightsDashboard_Desc,
    OrgSettings_EnableSkillInsightsDashboard_Name: OrgSettings_EnableSkillInsightsDashboard_Name,
    OrgSettings_EnableSkillsCertification_Desc: OrgSettings_EnableSkillsCertification_Desc,
    OrgSettings_EnableSkillsCertification_Name: OrgSettings_EnableSkillsCertification_Name,
    OrgSettings_EnableSkillsEvaluation_Desc: OrgSettings_EnableSkillsEvaluation_Desc,
    OrgSettings_EnableSkillsEvaluation_Name: OrgSettings_EnableSkillsEvaluation_Name,
    OrgSettings_EnableSkillsPlatform_Desc: OrgSettings_EnableSkillsPlatform_Desc,
    OrgSettings_EnableSkillsPlatform_Name: OrgSettings_EnableSkillsPlatform_Name,
    OrgSettings_EnableSkillStandards_Desc: OrgSettings_EnableSkillStandards_Desc,
    OrgSettings_EnableSkillStandards_Name: OrgSettings_EnableSkillStandards_Name,
    OrgSettings_EnableTeamSpace_Desc: OrgSettings_EnableTeamSpace_Desc,
    OrgSettings_EnableTeamSpace_Name: OrgSettings_EnableTeamSpace_Name,
    OrgSettings_EnableUserSearchFilterByJobRole_Desc: OrgSettings_EnableUserSearchFilterByJobRole_Desc,
    OrgSettings_EnableUserSearchFilterByJobRole_Name: OrgSettings_EnableUserSearchFilterByJobRole_Name,
    OrgSettings_EnableUserSearchFilterByLocation_Desc: OrgSettings_EnableUserSearchFilterByLocation_Desc,
    OrgSettings_EnableUserSearchFilterByLocation_Name: OrgSettings_EnableUserSearchFilterByLocation_Name,
    OrgSettings_EnforceDataPrivacyAcceptance_Desc: OrgSettings_EnforceDataPrivacyAcceptance_Desc,
    OrgSettings_EnforceDataPrivacyAcceptance_Name: OrgSettings_EnforceDataPrivacyAcceptance_Name,
    OrgSettings_EnforceDataPrivacyAcceptanceBody_PlaceHolder: OrgSettings_EnforceDataPrivacyAcceptanceBody_PlaceHolder,
    OrgSettings_EnforceDataPrivacyAcceptanceBody_PopupLabel: OrgSettings_EnforceDataPrivacyAcceptanceBody_PopupLabel,
    OrgSettings_EnforceDataPrivacyAcceptanceConfirmation_Default: OrgSettings_EnforceDataPrivacyAcceptanceConfirmation_Default,
    OrgSettings_EnforceDataPrivacyAcceptanceConfirmation_PlaceHolder: OrgSettings_EnforceDataPrivacyAcceptanceConfirmation_PlaceHolder,
    OrgSettings_EnforceDataPrivacyAcceptanceConfirmation_PopupLabel: OrgSettings_EnforceDataPrivacyAcceptanceConfirmation_PopupLabel,
    OrgSettings_EnforceDataPrivacyAcceptanceHeader_Default: OrgSettings_EnforceDataPrivacyAcceptanceHeader_Default,
    OrgSettings_EnforceDataPrivacyAcceptanceHeader_PlaceHolder: OrgSettings_EnforceDataPrivacyAcceptanceHeader_PlaceHolder,
    OrgSettings_EnforceDataPrivacyAcceptanceHeader_PopupLabel: OrgSettings_EnforceDataPrivacyAcceptanceHeader_PopupLabel,
    OrgSettings_EnforceDataPrivacyAcceptanceTitle_Default: OrgSettings_EnforceDataPrivacyAcceptanceTitle_Default,
    OrgSettings_EnforceDataPrivacyAcceptanceTitle_PlaceHolder: OrgSettings_EnforceDataPrivacyAcceptanceTitle_PlaceHolder,
    OrgSettings_EnforceDataPrivacyAcceptanceTitle_PopupLabel: OrgSettings_EnforceDataPrivacyAcceptanceTitle_PopupLabel,
    OrgSettings_EnforceDegreedDataPrivacyAcceptance_Desc: OrgSettings_EnforceDegreedDataPrivacyAcceptance_Desc,
    OrgSettings_EnforceDegreedDataPrivacyAcceptance_Name: OrgSettings_EnforceDegreedDataPrivacyAcceptance_Name,
    OrgSettings_EngagementFeatures: OrgSettings_EngagementFeatures,
    OrgSettings_ErrorMessage: OrgSettings_ErrorMessage,
    OrgSettings_EstimatedDurationDefaults_Desc: OrgSettings_EstimatedDurationDefaults_Desc,
    OrgSettings_EstimatedDurationDefaults_Name: OrgSettings_EstimatedDurationDefaults_Name,
    OrgSettings_ExternalLink: OrgSettings_ExternalLink,
    OrgSettings_ExternalLinkPlaceholder: OrgSettings_ExternalLinkPlaceholder,
    OrgSettings_ExternalLinkRequired: OrgSettings_ExternalLinkRequired,
    OrgSettings_FileDetails: OrgSettings_FileDetails,
    OrgSettings_FileInformation: OrgSettings_FileInformation,
    OrgSettings_FileName_Desc: OrgSettings_FileName_Desc,
    OrgSettings_FileName_Name: OrgSettings_FileName_Name,
    OrgSettings_FtpNotificationEmail_Desc: OrgSettings_FtpNotificationEmail_Desc,
    OrgSettings_FtpNotificationEmail_Name: OrgSettings_FtpNotificationEmail_Name,
    OrgSettings_FtpStatusFileOptions_Desc: OrgSettings_FtpStatusFileOptions_Desc,
    OrgSettings_FtpStatusFileOptions_Name: OrgSettings_FtpStatusFileOptions_Name,
    OrgSettings_FtpStatusFileOptions_Selection_AllRows: OrgSettings_FtpStatusFileOptions_Selection_AllRows,
    OrgSettings_FtpStatusFileOptions_Selection_Disabled: OrgSettings_FtpStatusFileOptions_Selection_Disabled,
    OrgSettings_FtpStatusFileOptions_Selection_OnlyProblems: OrgSettings_FtpStatusFileOptions_Selection_OnlyProblems,
    OrgSettings_GoalProgressEmail_Desc: OrgSettings_GoalProgressEmail_Desc,
    OrgSettings_GoalProgressEmail_Name: OrgSettings_GoalProgressEmail_Name,
    OrgSettings_GroupPostAdded_Desc: OrgSettings_GroupPostAdded_Desc,
    OrgSettings_GroupPostAdded_Name: OrgSettings_GroupPostAdded_Name,
    OrgSettings_Groups_Desc: OrgSettings_Groups_Desc,
    OrgSettings_Groups_Name: OrgSettings_Groups_Name,
    OrgSettings_Hide_Overview_Achievement_Desc: OrgSettings_Hide_Overview_Achievement_Desc,
    OrgSettings_Hide_Overview_Experience_Desc: OrgSettings_Hide_Overview_Experience_Desc,
    OrgSettings_Hide_Overview_Tab_Desc: OrgSettings_Hide_Overview_Tab_Desc,
    OrgSettings_HideExternalCatalog_Desc: OrgSettings_HideExternalCatalog_Desc,
    OrgSettings_HideExternalCatalog_Name: OrgSettings_HideExternalCatalog_Name,
    OrgSettings_HideOverviewAchievement_Desc: OrgSettings_HideOverviewAchievement_Desc,
    OrgSettings_HideOverviewAchievement_Name: OrgSettings_HideOverviewAchievement_Name,
    OrgSettings_HideOverviewExperience_Desc: OrgSettings_HideOverviewExperience_Desc,
    OrgSettings_HideOverviewExperience_Name: OrgSettings_HideOverviewExperience_Name,
    OrgSettings_HideOverviewTab_Desc: OrgSettings_HideOverviewTab_Desc,
    OrgSettings_HideOverviewTab_Name: OrgSettings_HideOverviewTab_Name,
    OrgSettings_HidePersonalEmailInUserProfileSettings_Desc: OrgSettings_HidePersonalEmailInUserProfileSettings_Desc,
    OrgSettings_HidePersonalEmailInUserProfileSettings_Name: OrgSettings_HidePersonalEmailInUserProfileSettings_Name,
    OrgSettings_HidePersonalIntegrationsInUserProfileSettings_Desc: OrgSettings_HidePersonalIntegrationsInUserProfileSettings_Desc,
    OrgSettings_HidePersonalIntegrationsInUserProfileSettings_Name: OrgSettings_HidePersonalIntegrationsInUserProfileSettings_Name,
    OrgSettings_HideSocialLinks_Desc: OrgSettings_HideSocialLinks_Desc,
    OrgSettings_HideSocialLinks_Name: OrgSettings_HideSocialLinks_Name,
    OrgSettings_HideUserEmail_Desc: OrgSettings_HideUserEmail_Desc,
    OrgSettings_HideUserEmail_Name: OrgSettings_HideUserEmail_Name,
    OrgSettings_Home_PublishModal_AssignedLearning: OrgSettings_Home_PublishModal_AssignedLearning,
    OrgSettings_Home_PublishModal_Body: OrgSettings_Home_PublishModal_Body,
    OrgSettings_Home_PublishModal_Body_PublishNew: OrgSettings_Home_PublishModal_Body_PublishNew,
    OrgSettings_Home_PublishModal_Body_PublishOld: OrgSettings_Home_PublishModal_Body_PublishOld,
    OrgSettings_Home_PublishModal_Body_Unpublish: OrgSettings_Home_PublishModal_Body_Unpublish,
    OrgSettings_Home_PublishModal_Body_Unpublish_Sub: OrgSettings_Home_PublishModal_Body_Unpublish_Sub,
    OrgSettings_Home_PublishModal_Confirm: OrgSettings_Home_PublishModal_Confirm,
    OrgSettings_Home_PublishModal_Link_PluralLinks: OrgSettings_Home_PublishModal_Link_PluralLinks,
    OrgSettings_Home_PublishModal_Link_PluralLinksPluralSegments: OrgSettings_Home_PublishModal_Link_PluralLinksPluralSegments,
    OrgSettings_Home_PublishModal_Link_PluralLinksSingleSegment: OrgSettings_Home_PublishModal_Link_PluralLinksSingleSegment,
    OrgSettings_Home_PublishModal_Link_SingleLink: OrgSettings_Home_PublishModal_Link_SingleLink,
    OrgSettings_Home_PublishModal_Link_SingleLinkPluralSegments: OrgSettings_Home_PublishModal_Link_SingleLinkPluralSegments,
    OrgSettings_Home_PublishModal_Link_SingleLinkSingleSegment: OrgSettings_Home_PublishModal_Link_SingleLinkSingleSegment,
    OrgSettings_HomeDescription: OrgSettings_HomeDescription,
    OrgSettings_HomeInsightCards: OrgSettings_HomeInsightCards,
    OrgSettings_HomeLinksSection: OrgSettings_HomeLinksSection,
    OrgSettings_HomeOrgAnnouncement: OrgSettings_HomeOrgAnnouncement,
    OrgSettings_HomePageTile: OrgSettings_HomePageTile,
    OrgSettings_HomeSectionsReorderSuccess: OrgSettings_HomeSectionsReorderSuccess,
    OrgSettings_InApp_GroupDesc: OrgSettings_InApp_GroupDesc,
    OrgSettings_InApp_GroupDisplayName: OrgSettings_InApp_GroupDisplayName,
    OrgSettings_InAppTips_Desc: OrgSettings_InAppTips_Desc,
    OrgSettings_InAppTips_Name: OrgSettings_InAppTips_Name,
    OrgSettings_InsightCardsMaximum: OrgSettings_InsightCardsMaximum,
    OrgSettings_InsightCardsPublishUpdateSuccess: OrgSettings_InsightCardsPublishUpdateSuccess,
    OrgSettings_InsightCardsReorderSuccess: OrgSettings_InsightCardsReorderSuccess,
    OrgSettings_InsightCardsSaveSingleSuccess: OrgSettings_InsightCardsSaveSingleSuccess,
    OrgSettings_InsightCardsSaveSuccess: OrgSettings_InsightCardsSaveSuccess,
    OrgSettings_InsightCardsUnpublishSingleSuccess: OrgSettings_InsightCardsUnpublishSingleSuccess,
    OrgSettings_InsightCardsUnpublishSuccess: OrgSettings_InsightCardsUnpublishSuccess,
    OrgSettings_IntegrationEmailSettings_Desc: OrgSettings_IntegrationEmailSettings_Desc,
    OrgSettings_IntegrationEmailSettings_Name: OrgSettings_IntegrationEmailSettings_Name,
    OrgSettings_InternalLink: OrgSettings_InternalLink,
    OrgSettings_IsClientProvider_Desc: OrgSettings_IsClientProvider_Desc,
    OrgSettings_IsClientProvider_Name: OrgSettings_IsClientProvider_Name,
    OrgSettings_IsDefaultCatalog_Desc: OrgSettings_IsDefaultCatalog_Desc,
    OrgSettings_IsDefaultCatalog_Name: OrgSettings_IsDefaultCatalog_Name,
    OrgSettings_KeepManagerGroupsInSync_Desc: OrgSettings_KeepManagerGroupsInSync_Desc,
    OrgSettings_KeepManagerGroupsInSync_Name: OrgSettings_KeepManagerGroupsInSync_Name,
    OrgSettings_LearningFeeds: OrgSettings_LearningFeeds,
    OrgSettings_LimitGroupFeedActions_Desc: OrgSettings_LimitGroupFeedActions_Desc,
    OrgSettings_LimitGroupFeedActions_Name: OrgSettings_LimitGroupFeedActions_Name,
    OrgSettings_LinkButtonPlaceholder: OrgSettings_LinkButtonPlaceholder,
    OrgSettings_LinkButtonTitle: OrgSettings_LinkButtonTitle,
    OrgSettings_LinkDescription: OrgSettings_LinkDescription,
    OrgSettings_LinkDescriptionPlaceholder: OrgSettings_LinkDescriptionPlaceholder,
    OrgSettings_LinkDescriptionRequired: OrgSettings_LinkDescriptionRequired,
    OrgSettings_LinkInternalUrlPlaceholder: OrgSettings_LinkInternalUrlPlaceholder,
    OrgSettings_LinkInternalUrlRequired: OrgSettings_LinkInternalUrlRequired,
    OrgSettings_LinkPlaceholder: OrgSettings_LinkPlaceholder,
    OrgSettings_LinkSaveSuccess: OrgSettings_LinkSaveSuccess,
    OrgSettings_LinkSegmentRequired: OrgSettings_LinkSegmentRequired,
    OrgSettings_LinkSegments: OrgSettings_LinkSegments,
    OrgSettings_LinkSegmentsDescription: OrgSettings_LinkSegmentsDescription,
    OrgSettings_LinkSegmentsTooltip: OrgSettings_LinkSegmentsTooltip,
    OrgSettings_LinkSelectSource: OrgSettings_LinkSelectSource,
    OrgSettings_LinkTitle: OrgSettings_LinkTitle,
    OrgSettings_LinkTitleDuplicateError: OrgSettings_LinkTitleDuplicateError,
    OrgSettings_LinkTitleRequired: OrgSettings_LinkTitleRequired,
    OrgSettings_LinkUseSegments: OrgSettings_LinkUseSegments,
    OrgSettings_LockProfilePrivacy_Desc: OrgSettings_LockProfilePrivacy_Desc,
    OrgSettings_LockProfilePrivacy_Name: OrgSettings_LockProfilePrivacy_Name,
    OrgSettings_LockSkillManagerRatingVisibility_Desc: OrgSettings_LockSkillManagerRatingVisibility_Desc,
    OrgSettings_LockSkillManagerRatingVisibility_Name: OrgSettings_LockSkillManagerRatingVisibility_Name,
    OrgSettings_LockSkillPeerRatingVisibility_Desc: OrgSettings_LockSkillPeerRatingVisibility_Desc,
    OrgSettings_LockSkillPeerRatingVisibility_Name: OrgSettings_LockSkillPeerRatingVisibility_Name,
    OrgSettings_LockSkillSelfRatingVisibility_Desc: OrgSettings_LockSkillSelfRatingVisibility_Desc,
    OrgSettings_LockSkillSelfRatingVisibility_Name: OrgSettings_LockSkillSelfRatingVisibility_Name,
    OrgSettings_LU_AdminUserId_Desc: OrgSettings_LU_AdminUserId_Desc,
    OrgSettings_LU_AdminUserId_Name: OrgSettings_LU_AdminUserId_Name,
    OrgSettings_LU_ApiBaseUrl_DefaultText: OrgSettings_LU_ApiBaseUrl_DefaultText,
    OrgSettings_LU_ApiBaseUrl_Desc: OrgSettings_LU_ApiBaseUrl_Desc,
    OrgSettings_LU_ApiBaseUrl_Name: OrgSettings_LU_ApiBaseUrl_Name,
    OrgSettings_LU_ApiPassword_Desc: OrgSettings_LU_ApiPassword_Desc,
    OrgSettings_LU_ApiPassword_Name: OrgSettings_LU_ApiPassword_Name,
    OrgSettings_LU_ApiUsername_Desc: OrgSettings_LU_ApiUsername_Desc,
    OrgSettings_LU_ApiUsername_Name: OrgSettings_LU_ApiUsername_Name,
    OrgSettings_LU_BulkGroupSync_Desc: OrgSettings_LU_BulkGroupSync_Desc,
    OrgSettings_LU_BulkGroupSync_Name: OrgSettings_LU_BulkGroupSync_Name,
    OrgSettings_LU_BulkInviteUsers_Desc: OrgSettings_LU_BulkInviteUsers_Desc,
    OrgSettings_LU_BulkInviteUsers_Name: OrgSettings_LU_BulkInviteUsers_Name,
    OrgSettings_LU_BulkProcessUnenrollments_Desc: OrgSettings_LU_BulkProcessUnenrollments_Desc,
    OrgSettings_LU_BulkProcessUnenrollments_Name: OrgSettings_LU_BulkProcessUnenrollments_Name,
    OrgSettings_LU_BulkUpdateUsers_Desc: OrgSettings_LU_BulkUpdateUsers_Desc,
    OrgSettings_LU_BulkUpdateUsers_Name: OrgSettings_LU_BulkUpdateUsers_Name,
    OrgSettings_LU_CustomDataColumns_Desc: OrgSettings_LU_CustomDataColumns_Desc,
    OrgSettings_LU_CustomDataColumns_Name: OrgSettings_LU_CustomDataColumns_Name,
    OrgSettings_LU_DefaultEnabled_Desc: OrgSettings_LU_DefaultEnabled_Desc,
    OrgSettings_LU_DefaultEnabled_Name: OrgSettings_LU_DefaultEnabled_Name,
    OrgSettings_LU_DefaultExpires_Desc: OrgSettings_LU_DefaultExpires_Desc,
    OrgSettings_LU_DefaultExpires_Name: OrgSettings_LU_DefaultExpires_Name,
    OrgSettings_LU_DefaultGroupSync_Desc: OrgSettings_LU_DefaultGroupSync_Desc,
    OrgSettings_LU_DefaultGroupSync_Name: OrgSettings_LU_DefaultGroupSync_Name,
    OrgSettings_LU_DefaultMustChangePassword_Desc: OrgSettings_LU_DefaultMustChangePassword_Desc,
    OrgSettings_LU_DefaultMustChangePassword_Name: OrgSettings_LU_DefaultMustChangePassword_Name,
    OrgSettings_LU_DefaultPassword_Desc: OrgSettings_LU_DefaultPassword_Desc,
    OrgSettings_LU_DefaultPassword_Name: OrgSettings_LU_DefaultPassword_Name,
    OrgSettings_LU_GroupSync_Name: OrgSettings_LU_GroupSync_Name,
    OrgSettings_MarketplaceWarning_Default: OrgSettings_MarketplaceWarning_Default,
    OrgSettings_MarketplaceWarning_Desc: OrgSettings_MarketplaceWarning_Desc,
    OrgSettings_MarketplaceWarning_Name: OrgSettings_MarketplaceWarning_Name,
    OrgSettings_MaxDescription: OrgSettings_MaxDescription,
    OrgSettings_MaxInputDescription: OrgSettings_MaxInputDescription,
    OrgSettings_MaxTitleDescription: OrgSettings_MaxTitleDescription,
    OrgSettings_MentionInComment_Desc: OrgSettings_MentionInComment_Desc,
    OrgSettings_MentionInComment_Name: OrgSettings_MentionInComment_Name,
    OrgSettings_MinimumAggregatedLearningInsightsUserCount_Desc: OrgSettings_MinimumAggregatedLearningInsightsUserCount_Desc,
    OrgSettings_MinimumAggregatedLearningInsightsUserCount_Name: OrgSettings_MinimumAggregatedLearningInsightsUserCount_Name,
    OrgSettings_MinimumSkillUserCount_Desc: OrgSettings_MinimumSkillUserCount_Desc,
    OrgSettings_MinimumSkillUserCount_Name: OrgSettings_MinimumSkillUserCount_Name,
    OrgSettings_MobileBiometricAuth_Desc: OrgSettings_MobileBiometricAuth_Desc,
    OrgSettings_MobileBiometricAuth_Name: OrgSettings_MobileBiometricAuth_Name,
    OrgSettings_MobileClientSessionTimeout_Desc: OrgSettings_MobileClientSessionTimeout_Desc,
    OrgSettings_MobileClientSessionTimeout_Name: OrgSettings_MobileClientSessionTimeout_Name,
    OrgSettings_MonthlyActivity_Error: OrgSettings_MonthlyActivity_Error,
    OrgSettings_MonthlyActivityDescription: OrgSettings_MonthlyActivityDescription,
    OrgSettings_MonthlyActivityTypes_ItemsCompleted: OrgSettings_MonthlyActivityTypes_ItemsCompleted,
    OrgSettings_MonthlyActivityTypes_ItemsViewed: OrgSettings_MonthlyActivityTypes_ItemsViewed,
    OrgSettings_MonthlyActivityTypes_LearningDuration: OrgSettings_MonthlyActivityTypes_LearningDuration,
    OrgSettings_MonthlyActivityTypes_PointsEarned: OrgSettings_MonthlyActivityTypes_PointsEarned,
    OrgSettings_MonthlyActivityWithType: OrgSettings_MonthlyActivityWithType,
    OrgSettings_NewLink: OrgSettings_NewLink,
    OrgSettings_NotificationEmails_GroupDesc: OrgSettings_NotificationEmails_GroupDesc,
    OrgSettings_NotificationEmails_GroupDisplayName: OrgSettings_NotificationEmails_GroupDisplayName,
    OrgSettings_NotRecommended: OrgSettings_NotRecommended,
    OrgSettings_OAuthRefreshTokenTimeout_Desc: OrgSettings_OAuthRefreshTokenTimeout_Desc,
    OrgSettings_OAuthRefreshTokenTimeout_Name: OrgSettings_OAuthRefreshTokenTimeout_Name,
    OrgSettings_OAuthSessionTimeout_Desc: OrgSettings_OAuthSessionTimeout_Desc,
    OrgSettings_OAuthSessionTimeout_Name: OrgSettings_OAuthSessionTimeout_Name,
    OrgSettings_Onboarding_GroupDesc: OrgSettings_Onboarding_GroupDesc,
    OrgSettings_Onboarding_GroupDisplayName: OrgSettings_Onboarding_GroupDisplayName,
    OrgSettings_OnboardingExperience: OrgSettings_OnboardingExperience,
    OrgSettings_OnboardingExperience_GroupDesc: OrgSettings_OnboardingExperience_GroupDesc,
    OrgSettings_OnboardingExperience_GroupDisplayName: OrgSettings_OnboardingExperience_GroupDisplayName,
    OrgSettings_OnboardingMessage_Default: OrgSettings_OnboardingMessage_Default,
    OrgSettings_OnboardingMessage_Desc: OrgSettings_OnboardingMessage_Desc,
    OrgSettings_OnboardingMessage_Name: OrgSettings_OnboardingMessage_Name,
    OrgSettings_OnboardingRateSkillsIsMandatory_Desc: OrgSettings_OnboardingRateSkillsIsMandatory_Desc,
    OrgSettings_OnboardingRateSkillsIsMandatory_Name: OrgSettings_OnboardingRateSkillsIsMandatory_Name,
    OrgSettings_OnboardingTitle_Default: OrgSettings_OnboardingTitle_Default,
    OrgSettings_OnboardingTitle_Desc: OrgSettings_OnboardingTitle_Desc,
    OrgSettings_OnboardingTitle_Name: OrgSettings_OnboardingTitle_Name,
    OrgSettings_OnboardingWelcomeGreeting_Desc: OrgSettings_OnboardingWelcomeGreeting_Desc,
    OrgSettings_OnboardingWelcomeGreeting_Name: OrgSettings_OnboardingWelcomeGreeting_Name,
    OrgSettings_OpportunitiesActivityStartDate_Desc: OrgSettings_OpportunitiesActivityStartDate_Desc,
    OrgSettings_OpportunitiesActivityStartDate_Name: OrgSettings_OpportunitiesActivityStartDate_Name,
    OrgSettings_OrganizationEmailFromName_Desc: OrgSettings_OrganizationEmailFromName_Desc,
    OrgSettings_OrganizationEmailFromName_Name: OrgSettings_OrganizationEmailFromName_Name,
    OrgSettings_OrganizationEmailLogo_Desc: OrgSettings_OrganizationEmailLogo_Desc,
    OrgSettings_OrganizationEmailLogo_Name: OrgSettings_OrganizationEmailLogo_Name,
    OrgSettings_OrgIntroEmailMessage_Desc: OrgSettings_OrgIntroEmailMessage_Desc,
    OrgSettings_OrgIntroEmailMessage_Name: OrgSettings_OrgIntroEmailMessage_Name,
    OrgSettings_OrgSupportInfoCustomLink_Desc: OrgSettings_OrgSupportInfoCustomLink_Desc,
    OrgSettings_OrgSupportInfoCustomLink_Name: OrgSettings_OrgSupportInfoCustomLink_Name,
    OrgSettings_OrgSupportInfoCustomLink_Placeholder: OrgSettings_OrgSupportInfoCustomLink_Placeholder,
    OrgSettings_OrgSupportInfoCustomLinkURL_Placeholder: OrgSettings_OrgSupportInfoCustomLinkURL_Placeholder,
    OrgSettings_OrgSupportInfoEmail_Desc: OrgSettings_OrgSupportInfoEmail_Desc,
    OrgSettings_OrgSupportInfoEmail_Label: OrgSettings_OrgSupportInfoEmail_Label,
    OrgSettings_OrgSupportInfoEmail_Name: OrgSettings_OrgSupportInfoEmail_Name,
    OrgSettings_OrgSupportInfoEmail_Placeholder: OrgSettings_OrgSupportInfoEmail_Placeholder,
    OrgSettings_OrgSupportInfoFaq_Desc: OrgSettings_OrgSupportInfoFaq_Desc,
    OrgSettings_OrgSupportInfoFaq_Label: OrgSettings_OrgSupportInfoFaq_Label,
    OrgSettings_OrgSupportInfoFaq_Name: OrgSettings_OrgSupportInfoFaq_Name,
    OrgSettings_OrgSupportInfoFaq_Placeholder: OrgSettings_OrgSupportInfoFaq_Placeholder,
    OrgSettings_OrgSupportInfoLinkText_Label: OrgSettings_OrgSupportInfoLinkText_Label,
    OrgSettings_OrgSupportInfoLinkText_Placeholder: OrgSettings_OrgSupportInfoLinkText_Placeholder,
    OrgSettings_OrgSupportInfoLinkURL_Label: OrgSettings_OrgSupportInfoLinkURL_Label,
    OrgSettings_OrgSupportInfoLinkURL_Placeholder: OrgSettings_OrgSupportInfoLinkURL_Placeholder,
    OrgSettings_OrgSupportInfoPhone_Desc: OrgSettings_OrgSupportInfoPhone_Desc,
    OrgSettings_OrgSupportInfoPhone_Label: OrgSettings_OrgSupportInfoPhone_Label,
    OrgSettings_OrgSupportInfoPhone_Name: OrgSettings_OrgSupportInfoPhone_Name,
    OrgSettings_OrgSupportInfoPhone_Placeholder: OrgSettings_OrgSupportInfoPhone_Placeholder,
    OrgSettings_OtherEmails_GroupDesc: OrgSettings_OtherEmails_GroupDesc,
    OrgSettings_OtherEmails_GroupDisplayName: OrgSettings_OtherEmails_GroupDisplayName,
    OrgSettings_PasswordExpirationPeriod_DefaultText: OrgSettings_PasswordExpirationPeriod_DefaultText,
    OrgSettings_PasswordExpirationPeriod_Desc: OrgSettings_PasswordExpirationPeriod_Desc,
    OrgSettings_PasswordExpirationPeriod_Name: OrgSettings_PasswordExpirationPeriod_Name,
    OrgSettings_PathwayFeedbackSurvey_Desc: OrgSettings_PathwayFeedbackSurvey_Desc,
    OrgSettings_PathwayFeedbackSurvey_Name: OrgSettings_PathwayFeedbackSurvey_Name,
    OrgSettings_PermissionRoles_Desc: OrgSettings_PermissionRoles_Desc,
    OrgSettings_PermissionRoles_Name: OrgSettings_PermissionRoles_Name,
    OrgSettings_PersistSessionCookie_Desc: OrgSettings_PersistSessionCookie_Desc,
    OrgSettings_PersistSessionCookie_Name: OrgSettings_PersistSessionCookie_Name,
    OrgSettings_PointsDecommission_Desc: OrgSettings_PointsDecommission_Desc,
    OrgSettings_PointsDecommission_Name: OrgSettings_PointsDecommission_Name,
    OrgSettings_PreventPublicProfiles_Desc: OrgSettings_PreventPublicProfiles_Desc,
    OrgSettings_PreventPublicProfiles_Name: OrgSettings_PreventPublicProfiles_Name,
    OrgSettings_PrivacyChangeToOrganizationMessage_Default: OrgSettings_PrivacyChangeToOrganizationMessage_Default,
    OrgSettings_PrivacyChangeToOrganizationMessage_Desc: OrgSettings_PrivacyChangeToOrganizationMessage_Desc,
    OrgSettings_PrivacyChangeToOrganizationMessage_Name: OrgSettings_PrivacyChangeToOrganizationMessage_Name,
    OrgSettings_PrivacyChangeToPrivateMessage_Default: OrgSettings_PrivacyChangeToPrivateMessage_Default,
    OrgSettings_PrivacyChangeToPrivateMessage_Desc: OrgSettings_PrivacyChangeToPrivateMessage_Desc,
    OrgSettings_PrivacyChangeToPrivateMessage_Name: OrgSettings_PrivacyChangeToPrivateMessage_Name,
    OrgSettings_PrivacyChangeToPublicMessage_Default: OrgSettings_PrivacyChangeToPublicMessage_Default,
    OrgSettings_PrivacyChangeToPublicMessage_Desc: OrgSettings_PrivacyChangeToPublicMessage_Desc,
    OrgSettings_PrivacyChangeToPublicMessage_Name: OrgSettings_PrivacyChangeToPublicMessage_Name,
    OrgSettings_PrivacySettings: OrgSettings_PrivacySettings,
    OrgSettings_ProfileOverviewTabDefault_Desc: OrgSettings_ProfileOverviewTabDefault_Desc,
    OrgSettings_ProfileOverviewTabDefault_Name: OrgSettings_ProfileOverviewTabDefault_Name,
    OrgSettings_ProfileOverviewTabDefault_Selection_Focus: OrgSettings_ProfileOverviewTabDefault_Selection_Focus,
    OrgSettings_ProfileOverviewTabDefault_Selection_Top: OrgSettings_ProfileOverviewTabDefault_Selection_Top,
    OrgSettings_ProfilePrivacyUpdate_GroupDesc: OrgSettings_ProfilePrivacyUpdate_GroupDesc,
    OrgSettings_ProfilePrivacyUpdate_GroupDisplayName: OrgSettings_ProfilePrivacyUpdate_GroupDisplayName,
    OrgSettings_Providers_Desc: OrgSettings_Providers_Desc,
    OrgSettings_Providers_Name: OrgSettings_Providers_Name,
    OrgSettings_PublishCards: OrgSettings_PublishCards,
    OrgSettings_PublishCardsAriaText: OrgSettings_PublishCardsAriaText,
    OrgSettings_PublishCardsSingleSuccess: OrgSettings_PublishCardsSingleSuccess,
    OrgSettings_PublishCardsSuccess: OrgSettings_PublishCardsSuccess,
    OrgSettings_PublishChanges: OrgSettings_PublishChanges,
    OrgSettings_QuickLinks: OrgSettings_QuickLinks,
    OrgSettings_RapRedirectUrl_Desc: OrgSettings_RapRedirectUrl_Desc,
    OrgSettings_RapRedirectUrl_Label: OrgSettings_RapRedirectUrl_Label,
    OrgSettings_RapRedirectUrl_Name: OrgSettings_RapRedirectUrl_Name,
    OrgSettings_RapRedirectUrl_Placeholder: OrgSettings_RapRedirectUrl_Placeholder,
    OrgSettings_RateSkillsEmail_Desc: OrgSettings_RateSkillsEmail_Desc,
    OrgSettings_RateSkillsEmail_Name: OrgSettings_RateSkillsEmail_Name,
    OrgSettings_RatingsVisibilityPublic_Desc: OrgSettings_RatingsVisibilityPublic_Desc,
    OrgSettings_Recommendations_Desc: OrgSettings_Recommendations_Desc,
    OrgSettings_Recommendations_Name: OrgSettings_Recommendations_Name,
    OrgSettings_RemoveCard: OrgSettings_RemoveCard,
    OrgSettings_RemoveCardConfirmation: OrgSettings_RemoveCardConfirmation,
    OrgSettings_RemoveCardConfirmation_Body: OrgSettings_RemoveCardConfirmation_Body,
    OrgSettings_RemoveCardProceed_Confirm: OrgSettings_RemoveCardProceed_Confirm,
    OrgSettings_ReorderCards: OrgSettings_ReorderCards,
    OrgSettings_ReorderCardsAriaText: OrgSettings_ReorderCardsAriaText,
    OrgSettings_ReorderHomeSections: OrgSettings_ReorderHomeSections,
    OrgSettings_ReorderInsightCards: OrgSettings_ReorderInsightCards,
    OrgSettings_ReorderInvalidCardsAriaText: OrgSettings_ReorderInvalidCardsAriaText,
    OrgSettings_ReplyToComment_Desc: OrgSettings_ReplyToComment_Desc,
    OrgSettings_ReplyToComment_Name: OrgSettings_ReplyToComment_Name,
    OrgSettings_ReportAProblem_GroupDesc: OrgSettings_ReportAProblem_GroupDesc,
    OrgSettings_ReportAProblem_GroupDisplayName: OrgSettings_ReportAProblem_GroupDisplayName,
    OrgSettings_ReportEmailSettings_Desc: OrgSettings_ReportEmailSettings_Desc,
    OrgSettings_ReportEmailSettings_Name: OrgSettings_ReportEmailSettings_Name,
    OrgSettings_ReportingDateFormat_Desc: OrgSettings_ReportingDateFormat_Desc,
    OrgSettings_ReportingDateFormat_Name: OrgSettings_ReportingDateFormat_Name,
    OrgSettings_ReportingFTPConnection_Name: OrgSettings_ReportingFTPConnection_Name,
    OrgSettings_ReportingOrganizationNameAlias_Desc: OrgSettings_ReportingOrganizationNameAlias_Desc,
    OrgSettings_ReportingOrganizationNameAlias_Name: OrgSettings_ReportingOrganizationNameAlias_Name,
    OrgSettings_ReportingTimeZone_Desc: OrgSettings_ReportingTimeZone_Desc,
    OrgSettings_ReportingTimeZone_Name: OrgSettings_ReportingTimeZone_Name,
    OrgSettings_RequireInternalCredentialReviews_Desc: OrgSettings_RequireInternalCredentialReviews_Desc,
    OrgSettings_RequireInternalCredentialReviews_Name: OrgSettings_RequireInternalCredentialReviews_Name,
    OrgSettings_ResetAcceptance: OrgSettings_ResetAcceptance,
    OrgSettings_ResetDefaultMessage: OrgSettings_ResetDefaultMessage,
    OrgSettings_ResetPrivacyAcceptanceHeader: OrgSettings_ResetPrivacyAcceptanceHeader,
    OrgSettings_ResetPrivacyAcceptanceSuccess: OrgSettings_ResetPrivacyAcceptanceSuccess,
    OrgSettings_ResetPrivacyAcceptanceWarning: OrgSettings_ResetPrivacyAcceptanceWarning,
    OrgSettings_RestrictDuplicateEmailsOnUserFile_Desc: OrgSettings_RestrictDuplicateEmailsOnUserFile_Desc,
    OrgSettings_RestrictDuplicateEmailsOnUserFile_Name: OrgSettings_RestrictDuplicateEmailsOnUserFile_Name,
    OrgSettings_RestrictExtension_Desc: OrgSettings_RestrictExtension_Desc,
    OrgSettings_RestrictExtension_Name: OrgSettings_RestrictExtension_Name,
    OrgSettings_RestrictITunesExternalPodcastLinks_Desc: OrgSettings_RestrictITunesExternalPodcastLinks_Desc,
    OrgSettings_RestrictITunesExternalPodcastLinks_Name: OrgSettings_RestrictITunesExternalPodcastLinks_Name,
    OrgSettings_RestrictMobileApp_Desc: OrgSettings_RestrictMobileApp_Desc,
    OrgSettings_RestrictMobileApp_Name: OrgSettings_RestrictMobileApp_Name,
    OrgSettings_RestrictMobileAppInChina_Desc: OrgSettings_RestrictMobileAppInChina_Desc,
    OrgSettings_RestrictMobileAppInChina_Name: OrgSettings_RestrictMobileAppInChina_Name,
    OrgSettings_RunRulesSkippedRecords_Desc: OrgSettings_RunRulesSkippedRecords_Desc,
    OrgSettings_RunRulesSkippedRecords_Name: OrgSettings_RunRulesSkippedRecords_Name,
    OrgSettings_SavedLinks: OrgSettings_SavedLinks,
    OrgSettings_SavedLinksCount: OrgSettings_SavedLinksCount,
    OrgSettings_Security_ApiSectionDescription: OrgSettings_Security_ApiSectionDescription,
    OrgSettings_Security_ApiSectionTitle: OrgSettings_Security_ApiSectionTitle,
    OrgSettings_Security_ApiTimeoutDescription: OrgSettings_Security_ApiTimeoutDescription,
    OrgSettings_Security_ApiTimeOutError: OrgSettings_Security_ApiTimeOutError,
    OrgSettings_Security_ApiTimeOutResetAriaLabel: OrgSettings_Security_ApiTimeOutResetAriaLabel,
    OrgSettings_Security_ApiTimeoutTitle: OrgSettings_Security_ApiTimeoutTitle,
    OrgSettings_Security_ChromeSectionDescription: OrgSettings_Security_ChromeSectionDescription,
    OrgSettings_Security_ChromeSectionTitle: OrgSettings_Security_ChromeSectionTitle,
    OrgSettings_Security_ChromeTimeoutDescription: OrgSettings_Security_ChromeTimeoutDescription,
    OrgSettings_Security_ChromeTimeOutResetAriaLabel: OrgSettings_Security_ChromeTimeOutResetAriaLabel,
    OrgSettings_Security_ChromeTimeoutTitle: OrgSettings_Security_ChromeTimeoutTitle,
    OrgSettings_Security_ExtensionTimeOutError: OrgSettings_Security_ExtensionTimeOutError,
    OrgSettings_Security_InactivityTimeOutDescription: OrgSettings_Security_InactivityTimeOutDescription,
    OrgSettings_Security_InactivityTimeOutError: OrgSettings_Security_InactivityTimeOutError,
    OrgSettings_Security_InactivityTimeOutIntervalAriaLabel: OrgSettings_Security_InactivityTimeOutIntervalAriaLabel,
    OrgSettings_Security_InactivityTimeOutResetAriaLabel: OrgSettings_Security_InactivityTimeOutResetAriaLabel,
    OrgSettings_Security_InactivityTimeOutTitle: OrgSettings_Security_InactivityTimeOutTitle,
    OrgSettings_Security_LoginTimeOutDescription: OrgSettings_Security_LoginTimeOutDescription,
    OrgSettings_Security_LoginTimeOutError: OrgSettings_Security_LoginTimeOutError,
    OrgSettings_Security_LoginTimeOutIntervalAriaLabel: OrgSettings_Security_LoginTimeOutIntervalAriaLabel,
    OrgSettings_Security_LoginTimeOutResetAriaLabel: OrgSettings_Security_LoginTimeOutResetAriaLabel,
    OrgSettings_Security_LoginTimeOutTitle: OrgSettings_Security_LoginTimeOutTitle,
    OrgSettings_Security_LogOutAllUsers: OrgSettings_Security_LogOutAllUsers,
    OrgSettings_Security_LogOutWarningText: OrgSettings_Security_LogOutWarningText,
    OrgSettings_Security_MobileSectionDescription: OrgSettings_Security_MobileSectionDescription,
    OrgSettings_Security_MobileSectionTitle: OrgSettings_Security_MobileSectionTitle,
    OrgSettings_Security_MobileTimeoutDescription: OrgSettings_Security_MobileTimeoutDescription,
    OrgSettings_Security_MobileTimeOutError: OrgSettings_Security_MobileTimeOutError,
    OrgSettings_Security_MobileTimeOutResetAriaLabel: OrgSettings_Security_MobileTimeOutResetAriaLabel,
    OrgSettings_Security_MobileTimeoutTitle: OrgSettings_Security_MobileTimeoutTitle,
    OrgSettings_Security_NonPersistentSessionDescription: OrgSettings_Security_NonPersistentSessionDescription,
    OrgSettings_Security_NonPersistentSessionTitle: OrgSettings_Security_NonPersistentSessionTitle,
    OrgSettings_Security_PageTitle: OrgSettings_Security_PageTitle,
    OrgSettings_Security_PersistentSessionDescription: OrgSettings_Security_PersistentSessionDescription,
    OrgSettings_Security_PersistentSessionTitle: OrgSettings_Security_PersistentSessionTitle,
    OrgSettings_Security_SessionCookieModeTitle: OrgSettings_Security_SessionCookieModeTitle,
    OrgSettings_Security_WebSectionDescription: OrgSettings_Security_WebSectionDescription,
    OrgSettings_Security_WebSectionTitle: OrgSettings_Security_WebSectionTitle,
    OrgSettings_SegmentsDuplicateError: OrgSettings_SegmentsDuplicateError,
    OrgSettings_SegmentsMaxError: OrgSettings_SegmentsMaxError,
    OrgSettings_SelectLearningMetric: OrgSettings_SelectLearningMetric,
    OrgSettings_SelectLearningMetricPlaceholder: OrgSettings_SelectLearningMetricPlaceholder,
    OrgSettings_SendAllRapTicketsToClient_Desc: OrgSettings_SendAllRapTicketsToClient_Desc,
    OrgSettings_SendAllRapTicketsToClient_Name: OrgSettings_SendAllRapTicketsToClient_Name,
    OrgSettings_ServiceNowIntegrationConfiguration_Desc: OrgSettings_ServiceNowIntegrationConfiguration_Desc,
    OrgSettings_ServiceNowIntegrationConfiguration_Name: OrgSettings_ServiceNowIntegrationConfiguration_Name,
    OrgSettings_SessionTimeoutAbsoluteConfig_Desc: OrgSettings_SessionTimeoutAbsoluteConfig_Desc,
    OrgSettings_SessionTimeoutAbsoluteConfig_Name: OrgSettings_SessionTimeoutAbsoluteConfig_Name,
    OrgSettings_SessionTimeoutInactivityConfig_Desc: OrgSettings_SessionTimeoutInactivityConfig_Desc,
    OrgSettings_SessionTimeoutInactivityConfig_Name: OrgSettings_SessionTimeoutInactivityConfig_Name,
    OrgSettings_SetEvaluationsPrivateByDefault_Desc: OrgSettings_SetEvaluationsPrivateByDefault_Desc,
    OrgSettings_SetEvaluationsPrivateByDefault_Name: OrgSettings_SetEvaluationsPrivateByDefault_Name,
    OrgSettings_ShouldTransformTaxonomy_Desc: OrgSettings_ShouldTransformTaxonomy_Desc,
    OrgSettings_ShouldTransformTaxonomy_Name: OrgSettings_ShouldTransformTaxonomy_Name,
    OrgSettings_ShowAllProvidersInSearchFacet_Desc: OrgSettings_ShowAllProvidersInSearchFacet_Desc,
    OrgSettings_ShowAllProvidersInSearchFacet_Name: OrgSettings_ShowAllProvidersInSearchFacet_Name,
    OrgSettings_ShowCookiePolicyLink_Desc: OrgSettings_ShowCookiePolicyLink_Desc,
    OrgSettings_ShowCookiePolicyLink_Name: OrgSettings_ShowCookiePolicyLink_Name,
    OrgSettings_ShowExternalContentWarning_Default: OrgSettings_ShowExternalContentWarning_Default,
    OrgSettings_ShowExternalContentWarning_Desc: OrgSettings_ShowExternalContentWarning_Desc,
    OrgSettings_ShowExternalContentWarning_Name: OrgSettings_ShowExternalContentWarning_Name,
    OrgSettings_ShowGroupMembershipSource_Desc: OrgSettings_ShowGroupMembershipSource_Desc,
    OrgSettings_ShowGroupMembershipSource_Name: OrgSettings_ShowGroupMembershipSource_Name,
    OrgSettings_ShowSlackIntegration_Desc: OrgSettings_ShowSlackIntegration_Desc,
    OrgSettings_ShowSlackIntegration_Name: OrgSettings_ShowSlackIntegration_Name,
    OrgSettings_Size: OrgSettings_Size,
    OrgSettings_SizeKiloByte: OrgSettings_SizeKiloByte,
    OrgSettings_SkillCoachFullOrgAccess_Desc: OrgSettings_SkillCoachFullOrgAccess_Desc,
    OrgSettings_SkillCoachFullOrgAccess_Name: OrgSettings_SkillCoachFullOrgAccess_Name,
    OrgSettings_SkillInventoryClientOverride_Desc: OrgSettings_SkillInventoryClientOverride_Desc,
    OrgSettings_SkillInventoryClientOverride_Name: OrgSettings_SkillInventoryClientOverride_Name,
    OrgSettings_Skills_Desc: OrgSettings_Skills_Desc,
    OrgSettings_Skills_Name: OrgSettings_Skills_Name,
    OrgSettings_SkillsCheckupEmail_Desc: OrgSettings_SkillsCheckupEmail_Desc,
    OrgSettings_SkillsCheckupEmail_Name: OrgSettings_SkillsCheckupEmail_Name,
    OrgSettings_SkipEmailLookup_Desc: OrgSettings_SkipEmailLookup_Desc,
    OrgSettings_SkipEmailLookup_Name: OrgSettings_SkipEmailLookup_Name,
    OrgSettings_SocialNotify_Desc: OrgSettings_SocialNotify_Desc,
    OrgSettings_SocialNotify_Name: OrgSettings_SocialNotify_Name,
    OrgSettings_SocialSettings: OrgSettings_SocialSettings,
    OrgSettings_SsoAutoCreateProfile_Desc: OrgSettings_SsoAutoCreateProfile_Desc,
    OrgSettings_SsoAutoCreateProfile_Name: OrgSettings_SsoAutoCreateProfile_Name,
    OrgSettings_SuggestInternalContentOnly_Desc: OrgSettings_SuggestInternalContentOnly_Desc,
    OrgSettings_SuggestInternalContentOnly_Name: OrgSettings_SuggestInternalContentOnly_Name,
    OrgSettings_SuggestTags_Desc: OrgSettings_SuggestTags_Desc,
    OrgSettings_SuggestTags_Name: OrgSettings_SuggestTags_Name,
    OrgSettings_SuggestTargets_Desc: OrgSettings_SuggestTargets_Desc,
    OrgSettings_SuggestTargets_Name: OrgSettings_SuggestTargets_Name,
    OrgSettings_SupportTargets_Desc: OrgSettings_SupportTargets_Desc,
    OrgSettings_SupportTargets_Name: OrgSettings_SupportTargets_Name,
    OrgSettings_Tier1UserSupportTicketsEmailSettings_Desc: OrgSettings_Tier1UserSupportTicketsEmailSettings_Desc,
    OrgSettings_Tier1UserSupportTicketsEmailSettings_Name: OrgSettings_Tier1UserSupportTicketsEmailSettings_Name,
    OrgSettings_ToggleOff: OrgSettings_ToggleOff,
    OrgSettings_ToggleOn: OrgSettings_ToggleOn,
    OrgSettings_TotalInstance: OrgSettings_TotalInstance,
    OrgSettings_TotalInstanceCount_PluralFormat: OrgSettings_TotalInstanceCount_PluralFormat,
    OrgSettings_TotalInstanceCount_Single: OrgSettings_TotalInstanceCount_Single,
    OrgSettings_TotalInstances: OrgSettings_TotalInstances,
    OrgSettings_TotalRow: OrgSettings_TotalRow,
    OrgSettings_TotalRows: OrgSettings_TotalRows,
    OrgSettings_TotalRowsCount_PluralFormat: OrgSettings_TotalRowsCount_PluralFormat,
    OrgSettings_TotalRowsCount_Single: OrgSettings_TotalRowsCount_Single,
    OrgSettings_TrackLearning_Desc: OrgSettings_TrackLearning_Desc,
    OrgSettings_TrackLearning_Name: OrgSettings_TrackLearning_Name,
    OrgSettings_TrackLearningOnGo_Desc: OrgSettings_TrackLearningOnGo_Desc,
    OrgSettings_TrackLearningOnGo_Name: OrgSettings_TrackLearningOnGo_Name,
    OrgSettings_UnpublishCards: OrgSettings_UnpublishCards,
    OrgSettings_UntitledLinkTitle: OrgSettings_UntitledLinkTitle,
    OrgSettings_UpdateCard: OrgSettings_UpdateCard,
    OrgSettings_UpdateEmails_GroupDesc: OrgSettings_UpdateEmails_GroupDesc,
    OrgSettings_UpdateEmails_GroupDisplayName: OrgSettings_UpdateEmails_GroupDisplayName,
    OrgSettings_UpdatePublishing: OrgSettings_UpdatePublishing,
    OrgSettings_UpdateUserTagRatings_Desc: OrgSettings_UpdateUserTagRatings_Desc,
    OrgSettings_UpdateUserTagRatings_Name: OrgSettings_UpdateUserTagRatings_Name,
    OrgSettings_UpdateUserTagRatingsEmail_Desc: OrgSettings_UpdateUserTagRatingsEmail_Desc,
    OrgSettings_UpdateUserTagRatingsEmail_Name: OrgSettings_UpdateUserTagRatingsEmail_Name,
    OrgSettings_UpdateUserTags_Desc: OrgSettings_UpdateUserTags_Desc,
    OrgSettings_UpdateUserTags_Name: OrgSettings_UpdateUserTags_Name,
    OrgSettings_UrlScanExemptDomains_Desc: OrgSettings_UrlScanExemptDomains_Desc,
    OrgSettings_UrlScanExemptDomains_Name: OrgSettings_UrlScanExemptDomains_Name,
    OrgSettings_UseInternalJobSkills_Desc: OrgSettings_UseInternalJobSkills_Desc,
    OrgSettings_UseInternalJobSkills_Name: OrgSettings_UseInternalJobSkills_Name,
    OrgSettings_UserNotificationEmail_Desc: OrgSettings_UserNotificationEmail_Desc,
    OrgSettings_UserNotificationEmail_Name: OrgSettings_UserNotificationEmail_Name,
    OrgSettings_UseZendeskWebWidget_Desc: OrgSettings_UseZendeskWebWidget_Desc,
    OrgSettings_UseZendeskWebWidget_Name: OrgSettings_UseZendeskWebWidget_Name,
    OrgSettings_WeeklySummaryEmail_Desc: OrgSettings_WeeklySummaryEmail_Desc,
    OrgSettings_WeeklySummaryEmail_Name: OrgSettings_WeeklySummaryEmail_Name,
    OrgSettings_WelcomeEmail_Desc: OrgSettings_WelcomeEmail_Desc,
    OrgSettings_WelcomeEmail_Name: OrgSettings_WelcomeEmail_Name,
    OrgSettings_WelcomeIntro_Desc: OrgSettings_WelcomeIntro_Desc,
    OrgSettings_WelcomeIntro_Name: OrgSettings_WelcomeIntro_Name,
    OrgSettings_WeMissYouEmail_Desc: OrgSettings_WeMissYouEmail_Desc,
    OrgSettings_WeMissYouEmail_Name: OrgSettings_WeMissYouEmail_Name,
    OrgSettings_WhatSkillsEmail_Desc: OrgSettings_WhatSkillsEmail_Desc,
    OrgSettings_WhatSkillsEmail_Name: OrgSettings_WhatSkillsEmail_Name,
    OrgSettings_WhitelistedDomains_Desc: OrgSettings_WhitelistedDomains_Desc,
    OrgSettings_WhitelistedDomains_Name: OrgSettings_WhitelistedDomains_Name,
    OrgSettings_WhiteListFtpAccessIpAddresses_Desc: OrgSettings_WhiteListFtpAccessIpAddresses_Desc,
    OrgSettings_WhiteListFtpAccessIpAddresses_Name: OrgSettings_WhiteListFtpAccessIpAddresses_Name,
    OrgSettings_ZendeskWidgetKey_Desc: OrgSettings_ZendeskWidgetKey_Desc,
    OrgSettings_ZendeskWidgetKey_Name: OrgSettings_ZendeskWidgetKey_Name,
    OrgSettingsCtrl_AcademiesHeaderUploadSize: OrgSettingsCtrl_AcademiesHeaderUploadSize,
    OrgSettingsCtrl_AssignedLearningCustomizationDiscardConfirm: OrgSettingsCtrl_AssignedLearningCustomizationDiscardConfirm,
    OrgSettingsCtrl_ChangesCancelConfirm: OrgSettingsCtrl_ChangesCancelConfirm,
    OrgSettingsCtrl_ChangesCanceledSuccessMessage: OrgSettingsCtrl_ChangesCanceledSuccessMessage,
    OrgSettingsCtrl_ContrastWarning: OrgSettingsCtrl_ContrastWarning,
    OrgSettingsCtrl_EmailRequirements: OrgSettingsCtrl_EmailRequirements,
    OrgSettingsCtrl_EmailRequirementsHint: OrgSettingsCtrl_EmailRequirementsHint,
    OrgSettingsCtrl_ManageOrgName: OrgSettingsCtrl_ManageOrgName,
    OrgSettingsCtrl_MessagingTabLabel: OrgSettingsCtrl_MessagingTabLabel,
    OrgSettingsCtrl_MessagingTabPlaceholder: OrgSettingsCtrl_MessagingTabPlaceholder,
    OrgSettingsCtrl_OrgDescription: OrgSettingsCtrl_OrgDescription,
    OrgSettingsCtrl_OrgName: OrgSettingsCtrl_OrgName,
    OrgSettingsCtrl_OrgNameInOnboarding: OrgSettingsCtrl_OrgNameInOnboarding,
    OrgSettingsCtrl_OrgNameValidationMessage: OrgSettingsCtrl_OrgNameValidationMessage,
    OrgSettingsCtrl_Title: OrgSettingsCtrl_Title,
    OrgSettingsCtrl_UpdateLinksSuccessMessage: OrgSettingsCtrl_UpdateLinksSuccessMessage,
    OrgSettingsCtrl_UpdateSuccessMessage: OrgSettingsCtrl_UpdateSuccessMessage,
    OrgSettingsEndorsed_ImageSize: OrgSettingsEndorsed_ImageSize,
    OrgSettingsEndorsed_RemoveEndorseIcon: OrgSettingsEndorsed_RemoveEndorseIcon,
    OrgSettingsEndorsed_Subtitle: OrgSettingsEndorsed_Subtitle,
    OrgSettingsEndorsed_Title: OrgSettingsEndorsed_Title,
    OrgSettingsLinks_AddLink: OrgSettingsLinks_AddLink,
    OrgSettingsLinks_AddSection: OrgSettingsLinks_AddSection,
    OrgSettingsLinks_Description: OrgSettingsLinks_Description,
    OrgSettingsLinks_LinkMaximum: OrgSettingsLinks_LinkMaximum,
    OrgSettingsLinks_LinkTitle: OrgSettingsLinks_LinkTitle,
    OrgSettingsLinks_LinkTitlePlaceholder: OrgSettingsLinks_LinkTitlePlaceholder,
    OrgSettingsLinks_LinkUrl: OrgSettingsLinks_LinkUrl,
    OrgSettingsLinks_RemoveLink: OrgSettingsLinks_RemoveLink,
    OrgSettingsLinks_RemoveSection: OrgSettingsLinks_RemoveSection,
    OrgSettingsLinks_SectionTitle: OrgSettingsLinks_SectionTitle,
    OrgSettingsLinks_Title: OrgSettingsLinks_Title,
    OrgSettingsLinks_TitlePlaceholder: OrgSettingsLinks_TitlePlaceholder,
    OrgSettingsLinks_UpdateSuccessMessage: OrgSettingsLinks_UpdateSuccessMessage,
    OrgSettingsLinks_UrlPlaceholder: OrgSettingsLinks_UrlPlaceholder,
    OrgSettingsNav_Branding: OrgSettingsNav_Branding,
    OrgSettingsNav_BusinessRules: OrgSettingsNav_BusinessRules,
    OrgSettingsNav_Communication: OrgSettingsNav_Communication,
    OrgSettingsNav_HelpMenu: OrgSettingsNav_HelpMenu,
    OrgSettingsNav_Learning: OrgSettingsNav_Learning,
    OrgSettingsNav_Links: OrgSettingsNav_Links,
    OrgSettingsNav_ManageAttributes: OrgSettingsNav_ManageAttributes,
    OrgSettingsNav_Messages: OrgSettingsNav_Messages,
    OrgSettingsNav_Messaging: OrgSettingsNav_Messaging,
    OrgSettingsNav_Permissions: OrgSettingsNav_Permissions,
    OrgSettingsNav_Providers: OrgSettingsNav_Providers,
    OrgSettingsSupport_Description: OrgSettingsSupport_Description,
    OrgSettingsSupport_EmailLabel: OrgSettingsSupport_EmailLabel,
    OrgSettingsSupport_FaqUrlLabel: OrgSettingsSupport_FaqUrlLabel,
    OrgSettingsSupport_FaqUrlPlaceholder: OrgSettingsSupport_FaqUrlPlaceholder,
    OrgSettingsSupport_InvalidEmail: OrgSettingsSupport_InvalidEmail,
    OrgSettingsSupport_InvalidFaqUrl: OrgSettingsSupport_InvalidFaqUrl,
    OrgSettingsSupport_PhoneLabel: OrgSettingsSupport_PhoneLabel,
    OrgSettingsSupport_PhonePlaceholder: OrgSettingsSupport_PhonePlaceholder,
    OrgSettingsSupport_Title: OrgSettingsSupport_Title,
    OrgSettingsSupport_UpdateSuccessMessage: OrgSettingsSupport_UpdateSuccessMessage,
    OrgSkills_AC_OnboardingAdd: OrgSkills_AC_OnboardingAdd,
    OrgSkills_AC_OnboardingRemove: OrgSkills_AC_OnboardingRemove,
    OrgSkills_AC_PlanMark: OrgSkills_AC_PlanMark,
    OrgSkills_AC_PlanView: OrgSkills_AC_PlanView,
    OrgSkills_AddRole: OrgSkills_AddRole,
    OrgSkills_AddRoleHeading: OrgSkills_AddRoleHeading,
    OrgSkills_AddSkill: OrgSkills_AddSkill,
    OrgSkills_AddSkillButton: OrgSkills_AddSkillButton,
    OrgSkills_AddSkills: OrgSkills_AddSkills,
    OrgSkills_AddSkillTitle: OrgSkills_AddSkillTitle,
    OrgSkills_AlreadyAddedSkill: OrgSkills_AlreadyAddedSkill,
    OrgSkills_ApplySuggestions: OrgSkills_ApplySuggestions,
    OrgSkills_BackToRoles: OrgSkills_BackToRoles,
    OrgSkills_ContentCount: OrgSkills_ContentCount,
    OrgSkills_CountSelected: OrgSkills_CountSelected,
    OrgSkills_CreateSkills: OrgSkills_CreateSkills,
    OrgSkills_CurrentSkills: OrgSkills_CurrentSkills,
    OrgSkills_DeleteItem: OrgSkills_DeleteItem,
    OrgSkills_DescCharLimit: OrgSkills_DescCharLimit,
    OrgSkills_DescCharLimitExceeded: OrgSkills_DescCharLimitExceeded,
    OrgSkills_DescPlaceholder: OrgSkills_DescPlaceholder,
    OrgSkills_DownloadRoles: OrgSkills_DownloadRoles,
    OrgSkills_DownloadSkills: OrgSkills_DownloadSkills,
    OrgSkills_EditRoleHeading: OrgSkills_EditRoleHeading,
    OrgSkills_EditSkillTitle: OrgSkills_EditSkillTitle,
    OrgSkills_EnableSkillReview: OrgSkills_EnableSkillReview,
    OrgSkills_EnableSkillReviewHelpText: OrgSkills_EnableSkillReviewHelpText,
    OrgSkills_Endorsed: OrgSkills_Endorsed,
    OrgSkills_EndorsedSkillTooltip: OrgSkills_EndorsedSkillTooltip,
    OrgSkills_EndorseSkill: OrgSkills_EndorseSkill,
    OrgSkills_EndorseSkillHelpText: OrgSkills_EndorseSkillHelpText,
    OrgSkills_EquivalentSkillsHintSubtitle: OrgSkills_EquivalentSkillsHintSubtitle,
    OrgSkills_EquivalentSkillsHintTitle: OrgSkills_EquivalentSkillsHintTitle,
    OrgSkills_EquivalentSkillsTip: OrgSkills_EquivalentSkillsTip,
    OrgSkills_EquivalentSkillsTitle: OrgSkills_EquivalentSkillsTitle,
    OrgSkills_FollowerCount: OrgSkills_FollowerCount,
    OrgSkills_GeneratingSkills: OrgSkills_GeneratingSkills,
    OrgSkills_GeneratingSuggestions: OrgSkills_GeneratingSuggestions,
    OrgSkills_MarkedAsPlan: OrgSkills_MarkedAsPlan,
    OrgSkills_MatchedSkill: OrgSkills_MatchedSkill,
    OrgSkills_MatchedSkillButtonAlt: OrgSkills_MatchedSkillButtonAlt,
    OrgSkills_MatchSkill: OrgSkills_MatchSkill,
    OrgSkills_MatchSkillPlaceholder: OrgSkills_MatchSkillPlaceholder,
    OrgSkills_NoEquivalentSkillsFound: OrgSkills_NoEquivalentSkillsFound,
    OrgSkills_NoLevel: OrgSkills_NoLevel,
    OrgSkills_NoRolesAdded: OrgSkills_NoRolesAdded,
    OrgSkills_NoSkillsAdded: OrgSkills_NoSkillsAdded,
    OrgSkills_NoSkillsResultsFound: OrgSkills_NoSkillsResultsFound,
    OrgSkills_NumberSkillSuggestions: OrgSkills_NumberSkillSuggestions,
    OrgSkills_OnboardingFeatured: OrgSkills_OnboardingFeatured,
    OrgSkills_PathwayCount: OrgSkills_PathwayCount,
    OrgSkills_Plan: OrgSkills_Plan,
    OrgSkills_Plans: OrgSkills_Plans,
    OrgSkills_Recommend: OrgSkills_Recommend,
    OrgSkills_RecommendModalTitle: OrgSkills_RecommendModalTitle,
    OrgSkills_RecommendSkills: OrgSkills_RecommendSkills,
    OrgSkills_RecommendSkillsFormat: OrgSkills_RecommendSkillsFormat,
    OrgSkills_RecommendSkillsPluralFormat: OrgSkills_RecommendSkillsPluralFormat,
    OrgSkills_RecommendSkillsSingleFormat: OrgSkills_RecommendSkillsSingleFormat,
    OrgSkills_ReviewSkills: OrgSkills_ReviewSkills,
    OrgSkills_Role: OrgSkills_Role,
    OrgSkills_RoleAlreadyPlan: OrgSkills_RoleAlreadyPlan,
    OrgSkills_RoleDescription: OrgSkills_RoleDescription,
    OrgSkills_RoleDescriptionPlaceholder: OrgSkills_RoleDescriptionPlaceholder,
    OrgSkills_RoleIncludeInOnboarding: OrgSkills_RoleIncludeInOnboarding,
    OrgSkills_RoleIncludeInOnboardingInfo: OrgSkills_RoleIncludeInOnboardingInfo,
    OrgSkills_RoleMakePlan: OrgSkills_RoleMakePlan,
    OrgSkills_RoleMakePlanInfo: OrgSkills_RoleMakePlanInfo,
    OrgSkills_RolePlaceholder: OrgSkills_RolePlaceholder,
    OrgSkills_SearchForSkills: OrgSkills_SearchForSkills,
    OrgSkills_SearchPlaceholder: OrgSkills_SearchPlaceholder,
    OrgSkills_SeeSkillOverview: OrgSkills_SeeSkillOverview,
    OrgSkills_Selected: OrgSkills_Selected,
    OrgSkills_SelectSkillLevel: OrgSkills_SelectSkillLevel,
    OrgSkills_ShowAsPlan: OrgSkills_ShowAsPlan,
    OrgSkills_SimilarSkillsTitle: OrgSkills_SimilarSkillsTitle,
    OrgSkills_Skill: OrgSkills_Skill,
    OrgSkills_SkillDetailsTitle: OrgSkills_SkillDetailsTitle,
    OrgSkills_SkillLevel: OrgSkills_SkillLevel,
    OrgSkills_SkillNameExists: OrgSkills_SkillNameExists,
    OrgSkills_SkillPlaceholder: OrgSkills_SkillPlaceholder,
    OrgSkills_SkillProfile: OrgSkills_SkillProfile,
    OrgSkills_SkillReview: OrgSkills_SkillReview,
    OrgSkills_SkillReviewEnabled: OrgSkills_SkillReviewEnabled,
    OrgSkills_SkillReviewEnabledGroup: OrgSkills_SkillReviewEnabledGroup,
    OrgSkills_Skills: OrgSkills_Skills,
    OrgSkills_SkillsListInfo: OrgSkills_SkillsListInfo,
    OrgSkills_SkillsListPlaceholder: OrgSkills_SkillsListPlaceholder,
    OrgSkills_SkillToRoleSuggestions: OrgSkills_SkillToRoleSuggestions,
    OrgSkills_SlowChangesWarn: OrgSkills_SlowChangesWarn,
    OrgSkills_Source: OrgSkills_Source,
    OrgSkills_SuccessAddingSingleSkill: OrgSkills_SuccessAddingSingleSkill,
    OrgSkills_SuggestedSkills: OrgSkills_SuggestedSkills,
    OrgSkills_TranslatedTitle: OrgSkills_TranslatedTitle,
    OrgSkills_UpdateSkills: OrgSkills_UpdateSkills,
    OrgSkills_UploadFile: OrgSkills_UploadFile,
    OrgSkills_UploadOpportunitiesNotice: OrgSkills_UploadOpportunitiesNotice,
    OrgSkills_UploadRoles: OrgSkills_UploadRoles,
    OrgSkills_UploadRolesDescription: OrgSkills_UploadRolesDescription,
    OrgSkills_UploadSkills: OrgSkills_UploadSkills,
    OrgSkills_UploadSkills_ToSource: OrgSkills_UploadSkills_ToSource,
    OrgSkills_UploadSkillsDescription: OrgSkills_UploadSkillsDescription,
    OrgSkills_ViewRolePlan: OrgSkills_ViewRolePlan,
    OrgSkills_VisibilitySkillReview: OrgSkills_VisibilitySkillReview,
    OrgSkills_WorkdaySimilarSkillsInfo: OrgSkills_WorkdaySimilarSkillsInfo,
    OrgSkillsNav_Roles: OrgSkillsNav_Roles,
    OrgSkillsNav_Skills: OrgSkillsNav_Skills,
    OrgSvc_AddFAQContactSuccess: OrgSvc_AddFAQContactSuccess,
    OrgSvc_AddFAQError: OrgSvc_AddFAQError,
    OrgSvc_DeleteFAQError: OrgSvc_DeleteFAQError,
    OrgSvc_FAQEmailError: OrgSvc_FAQEmailError,
    OrgSvc_OrgError: OrgSvc_OrgError,
    OrgSvc_OrgJoinSuccess: OrgSvc_OrgJoinSuccess,
    OrgSvc_ResetPrivacyAcceptanceError: OrgSvc_ResetPrivacyAcceptanceError,
    OrgSvc_SendInviteError: OrgSvc_SendInviteError,
    OrgSvc_SendInviteSuccess: OrgSvc_SendInviteSuccess,
    OrgSvc_UpdateFAQError: OrgSvc_UpdateFAQError,
    OrgSvc_UpdateLinksError: OrgSvc_UpdateLinksError,
    OrgSvc_UpdateMessagesError: OrgSvc_UpdateMessagesError,
    OrgSvc_UpdateProviderError: OrgSvc_UpdateProviderError,
    OrgSvc_UpdateProviderSuccess: OrgSvc_UpdateProviderSuccess,
    OrgTargetsCtrl_CreateTarget: OrgTargetsCtrl_CreateTarget,
    OrgTargetsCtrl_DeletePrompt: OrgTargetsCtrl_DeletePrompt,
    OrgTargetsCtrl_Description: OrgTargetsCtrl_Description,
    OrgTargetsCtrl_FollowerCount: OrgTargetsCtrl_FollowerCount,
    OrgTargetsCtrl_NoJobRolesMessage: OrgTargetsCtrl_NoJobRolesMessage,
    OrgTargetsCtrl_SearchForJobRole: OrgTargetsCtrl_SearchForJobRole,
    OrgTargetsCtrl_Title: OrgTargetsCtrl_Title,
    OrgTargetsCtrl_Visibility: OrgTargetsCtrl_Visibility,
    OutcomeRatingOptionsSvc_ClaimsMostly: OutcomeRatingOptionsSvc_ClaimsMostly,
    OutcomeRatingOptionsSvc_ClaimsNotWell: OutcomeRatingOptionsSvc_ClaimsNotWell,
    OutcomeRatingOptionsSvc_ClaimsSlightly: OutcomeRatingOptionsSvc_ClaimsSlightly,
    OutcomeRatingOptionsSvc_ClaimsSomewhat: OutcomeRatingOptionsSvc_ClaimsSomewhat,
    OutcomeRatingOptionsSvc_ClaimsVeryWell: OutcomeRatingOptionsSvc_ClaimsVeryWell,
    OutcomeRatingOptionsSvc_DifficultyExtremely: OutcomeRatingOptionsSvc_DifficultyExtremely,
    OutcomeRatingOptionsSvc_DifficultyNot: OutcomeRatingOptionsSvc_DifficultyNot,
    OutcomeRatingOptionsSvc_DifficultySlightly: OutcomeRatingOptionsSvc_DifficultySlightly,
    OutcomeRatingOptionsSvc_DifficultySomewhat: OutcomeRatingOptionsSvc_DifficultySomewhat,
    OutcomeRatingOptionsSvc_DifficultyVery: OutcomeRatingOptionsSvc_DifficultyVery,
    OutcomeRatingOptionsSvc_MasteryCapable: OutcomeRatingOptionsSvc_MasteryCapable,
    OutcomeRatingOptionsSvc_MasteryDistinguished: OutcomeRatingOptionsSvc_MasteryDistinguished,
    OutcomeRatingOptionsSvc_MasteryEmerging: OutcomeRatingOptionsSvc_MasteryEmerging,
    OutcomeRatingOptionsSvc_MasteryExperienced: OutcomeRatingOptionsSvc_MasteryExperienced,
    OutcomeRatingOptionsSvc_MasteryMaster: OutcomeRatingOptionsSvc_MasteryMaster,
    OutcomeRatingOptionsSvc_MasteryNovice: OutcomeRatingOptionsSvc_MasteryNovice,
    OutcomeRatingOptionsSvc_RelevancyMostly: OutcomeRatingOptionsSvc_RelevancyMostly,
    OutcomeRatingOptionsSvc_RelevancyNot: OutcomeRatingOptionsSvc_RelevancyNot,
    OutcomeRatingOptionsSvc_RelevancySlightly: OutcomeRatingOptionsSvc_RelevancySlightly,
    OutcomeRatingOptionsSvc_RelevancySomewhat: OutcomeRatingOptionsSvc_RelevancySomewhat,
    OutcomeRatingOptionsSvc_RelevancyVery: OutcomeRatingOptionsSvc_RelevancyVery,
    OutcomeRatingOptionsSvc_SignificanceExtremely: OutcomeRatingOptionsSvc_SignificanceExtremely,
    OutcomeRatingOptionsSvc_SignificanceNot: OutcomeRatingOptionsSvc_SignificanceNot,
    OutcomeRatingOptionsSvc_SignificanceSlightly: OutcomeRatingOptionsSvc_SignificanceSlightly,
    OutcomeRatingOptionsSvc_SignificanceSomewhat: OutcomeRatingOptionsSvc_SignificanceSomewhat,
    OutcomeRatingOptionsSvc_SignificanceVery: OutcomeRatingOptionsSvc_SignificanceVery,
    OutcomeRatingOptionsSvc_SimilarityMostly: OutcomeRatingOptionsSvc_SimilarityMostly,
    OutcomeRatingOptionsSvc_SimilarityNot: OutcomeRatingOptionsSvc_SimilarityNot,
    OutcomeRatingOptionsSvc_SimilaritySlightly: OutcomeRatingOptionsSvc_SimilaritySlightly,
    OutcomeRatingOptionsSvc_SimilaritySomewhat: OutcomeRatingOptionsSvc_SimilaritySomewhat,
    OutcomeRatingOptionsSvc_SimilarityVery: OutcomeRatingOptionsSvc_SimilarityVery,
    OutcomeRatingOptionsSvc_SupportNeutral: OutcomeRatingOptionsSvc_SupportNeutral,
    OutcomeRatingOptionsSvc_SupportPoor: OutcomeRatingOptionsSvc_SupportPoor,
    OutcomeRatingOptionsSvc_SupportVeryPoor: OutcomeRatingOptionsSvc_SupportVeryPoor,
    OutcomeRatingOptionsSvc_SupportVeryWell: OutcomeRatingOptionsSvc_SupportVeryWell,
    OutcomeRatingOptionsSvc_SupportWell: OutcomeRatingOptionsSvc_SupportWell,
    Pagination_AriaLabelDefault: Pagination_AriaLabelDefault,
    Pagination_GoToPageFormat: Pagination_GoToPageFormat,
    Pagination_OfYFormat: Pagination_OfYFormat,
    Pagination_OfYResultsFormat: Pagination_OfYResultsFormat,
    Pagination_ResultsOverview: Pagination_ResultsOverview,
    PathwayActivity_OpportunityTitle: PathwayActivity_OpportunityTitle,
    PathwayActivity_PathwayTitle: PathwayActivity_PathwayTitle,
    PathwayActivity_PlanTitle: PathwayActivity_PlanTitle,
    PathwayActivity_SelectionAriaLabel: PathwayActivity_SelectionAriaLabel,
    PathwayActivity_TooltipClickedApply: PathwayActivity_TooltipClickedApply,
    PathwayActivity_TooltipCompletions: PathwayActivity_TooltipCompletions,
    PathwayActivity_TooltipEnroll: PathwayActivity_TooltipEnroll,
    PathwayActivity_TooltipFollow: PathwayActivity_TooltipFollow,
    PathwayActivity_TooltipInterested: PathwayActivity_TooltipInterested,
    PathwayActivity_TooltipTotalViews: PathwayActivity_TooltipTotalViews,
    PathwayActivity_TooltipViews: PathwayActivity_TooltipViews,
    PathwayActivity_TooltipViewsTotal: PathwayActivity_TooltipViewsTotal,
    PathwayActivity_TotalViews: PathwayActivity_TotalViews,
    PathwayActivity_Users: PathwayActivity_Users,
    PathwayActivity_UsersViewed: PathwayActivity_UsersViewed,
    pathwayAddEditModal_AddCollaborator: pathwayAddEditModal_AddCollaborator,
    pathwayAddEditModal_AddCollaborators: pathwayAddEditModal_AddCollaborators,
    pathwayAddEditModal_AddPathway_Success: pathwayAddEditModal_AddPathway_Success,
    pathwayAddEditModal_Authors: pathwayAddEditModal_Authors,
    pathwayAddEditModal_BadgeEligibilityLabel: pathwayAddEditModal_BadgeEligibilityLabel,
    pathwayAddEditModal_BadgeUuid: pathwayAddEditModal_BadgeUuid,
    pathwayAddEditModal_CloneOfPathwayFormat: pathwayAddEditModal_CloneOfPathwayFormat,
    pathwayAddEditModal_CollaboratorsDescription: pathwayAddEditModal_CollaboratorsDescription,
    pathwayAddEditModal_ConfirmDelete: pathwayAddEditModal_ConfirmDelete,
    pathwayAddEditModal_CreatePathway: pathwayAddEditModal_CreatePathway,
    pathwayAddEditModal_DeletedFormat: pathwayAddEditModal_DeletedFormat,
    pathwayAddEditModal_Description: pathwayAddEditModal_Description,
    pathwayAddEditModal_DescriptionDetail: pathwayAddEditModal_DescriptionDetail,
    pathwayAddEditModal_DescriptionLength: pathwayAddEditModal_DescriptionLength,
    pathwayAddEditModal_DescriptionMissing: pathwayAddEditModal_DescriptionMissing,
    pathwayAddEditModal_DoNotDisplayDuration: pathwayAddEditModal_DoNotDisplayDuration,
    pathwayAddEditModal_DoNotDisplayDurationNote: pathwayAddEditModal_DoNotDisplayDurationNote,
    pathwayAddEditModal_DoNotDisplayHeaderImage: pathwayAddEditModal_DoNotDisplayHeaderImage,
    pathwayAddEditModal_DoNotDisplayHeaderImageNote: pathwayAddEditModal_DoNotDisplayHeaderImageNote,
    pathwayAddEditModal_EditPathway: pathwayAddEditModal_EditPathway,
    pathwayAddEditModal_EndorsedByOrg: pathwayAddEditModal_EndorsedByOrg,
    pathwayAddEditModal_EndorsedByOrgNote: pathwayAddEditModal_EndorsedByOrgNote,
    pathwayAddEditModal_EndorsedContentByOrgNote: pathwayAddEditModal_EndorsedContentByOrgNote,
    pathwayAddEditModal_ImagePreview: pathwayAddEditModal_ImagePreview,
    pathwayAddEditModal_NameLength: pathwayAddEditModal_NameLength,
    pathwayAddEditModal_NameRequired: pathwayAddEditModal_NameRequired,
    pathwayAddEditModal_NeedCollaboratorPermission: pathwayAddEditModal_NeedCollaboratorPermission,
    pathwayAddEditModal_Or: pathwayAddEditModal_Or,
    pathwayAddEditModal_PathwayName: pathwayAddEditModal_PathwayName,
    pathwayAddEditModal_PathwayNameEg: pathwayAddEditModal_PathwayNameEg,
    pathwayAddEditModal_PathwayPrimaryContact: pathwayAddEditModal_PathwayPrimaryContact,
    pathwayAddEditModal_PathwaySettingsChannelDesc: pathwayAddEditModal_PathwaySettingsChannelDesc,
    pathwayAddEditModal_PathwaySettingsDesc: pathwayAddEditModal_PathwaySettingsDesc,
    pathwayAddEditModal_PrimaryContactRequired: pathwayAddEditModal_PrimaryContactRequired,
    pathwayAddEditModal_Remove: pathwayAddEditModal_Remove,
    pathwayAddEditModal_SavePathway: pathwayAddEditModal_SavePathway,
    pathwayAddEditModal_SavingPathway: pathwayAddEditModal_SavingPathway,
    pathwayAddEditModal_SearchCollaborators: pathwayAddEditModal_SearchCollaborators,
    pathwayAddEditModal_SearchPeopleGroupsPlaceHolder: pathwayAddEditModal_SearchPeopleGroupsPlaceHolder,
    pathwayAddEditModal_ShowPathwayContentRating: pathwayAddEditModal_ShowPathwayContentRating,
    pathwayAddEditModal_ShowPathwayContentRatingNote: pathwayAddEditModal_ShowPathwayContentRatingNote,
    pathwayAddEditModal_TitleofPathway: pathwayAddEditModal_TitleofPathway,
    pathwayAddEditModal_VisibleToOrg: pathwayAddEditModal_VisibleToOrg,
    pathwayAddEditModal_VisibleToOrgWarning: pathwayAddEditModal_VisibleToOrgWarning,
    PathwayEnrollmentSource_AmountSent: PathwayEnrollmentSource_AmountSent,
    PathwayEnrollmentSource_Assignments: PathwayEnrollmentSource_Assignments,
    PathwayEnrollmentSource_BusinessRules: PathwayEnrollmentSource_BusinessRules,
    PathwayEnrollmentSource_OtherTooltip: PathwayEnrollmentSource_OtherTooltip,
    PathwayEnrollmentSource_Title: PathwayEnrollmentSource_Title,
    PathwayEnrollmentSource_TrackableLinks: PathwayEnrollmentSource_TrackableLinks,
    PathwayPrivacyModal_BulkChangeVisibility: PathwayPrivacyModal_BulkChangeVisibility,
    PathwayPrivacyModal_BulkChangeVisibilityPlural: PathwayPrivacyModal_BulkChangeVisibilityPlural,
    PathwayPrivacyModal_ChangeVisibility: PathwayPrivacyModal_ChangeVisibility,
    PathwayPrivacyModal_ConfirmationModalBody: PathwayPrivacyModal_ConfirmationModalBody,
    PathwayPrivacyModal_ConfirmationModalConfirm: PathwayPrivacyModal_ConfirmationModalConfirm,
    PathwayPrivacyModal_ConfirmationModalHeader: PathwayPrivacyModal_ConfirmationModalHeader,
    PathwayPrivacyModal_EditSettings: PathwayPrivacyModal_EditSettings,
    PathwayPrivacyModal_FoundWhere: PathwayPrivacyModal_FoundWhere,
    PathwayPrivacyModal_OnlySetGroups: PathwayPrivacyModal_OnlySetGroups,
    PathwayPrivacyModal_OnlySetGroupsToolTip: PathwayPrivacyModal_OnlySetGroupsToolTip,
    PathwayPrivacyModal_SaveVisibility: PathwayPrivacyModal_SaveVisibility,
    PathwayPrivacyModal_SelectAGroupError: PathwayPrivacyModal_SelectAGroupError,
    PathwayPrivacyModal_TargetGroups: PathwayPrivacyModal_TargetGroups,
    PathwayPrivacyModal_TargetGroupsDirectoryToolTip: PathwayPrivacyModal_TargetGroupsDirectoryToolTip,
    PathwayPrivacyModal_TargetGroupsPlanToolTip: PathwayPrivacyModal_TargetGroupsPlanToolTip,
    PathwayPrivacyModal_TargetGroupsToolTip: PathwayPrivacyModal_TargetGroupsToolTip,
    Pathways_A11yItemsReordered: Pathways_A11yItemsReordered,
    Pathways_A11yLessonsReordered: Pathways_A11yLessonsReordered,
    Pathways_A11ySectionsReordered: Pathways_A11ySectionsReordered,
    Pathways_AddANote: Pathways_AddANote,
    Pathways_AddAuthorNote: Pathways_AddAuthorNote,
    Pathways_AddByType: Pathways_AddByType,
    Pathways_AddContent: Pathways_AddContent,
    Pathways_AddContentItemsSuccess: Pathways_AddContentItemsSuccess,
    Pathways_AddContentItemSuccess: Pathways_AddContentItemSuccess,
    Pathways_AddingInputTypeError: Pathways_AddingInputTypeError,
    Pathways_AddItemError: Pathways_AddItemError,
    Pathways_AddItemPermissionError: Pathways_AddItemPermissionError,
    Pathways_AdditionalContentSuccess: Pathways_AdditionalContentSuccess,
    Pathways_AddLesson: Pathways_AddLesson,
    Pathways_AddLessonError: Pathways_AddLessonError,
    Pathways_AddOneItem: Pathways_AddOneItem,
    Pathways_AddSection: Pathways_AddSection,
    Pathways_AddSectionError: Pathways_AddSectionError,
    Pathways_AddSubsection: Pathways_AddSubsection,
    Pathways_AddXItems: Pathways_AddXItems,
    Pathways_Article: Pathways_Article,
    Pathways_Assessment: Pathways_Assessment,
    Pathways_AuthorAccessError: Pathways_AuthorAccessError,
    Pathways_AuthoredPathwayError: Pathways_AuthoredPathwayError,
    Pathways_BackButton: Pathways_BackButton,
    Pathways_BackToBrowse: Pathways_BackToBrowse,
    Pathways_Bin: Pathways_Bin,
    Pathways_Book: Pathways_Book,
    Pathways_Collaborators: Pathways_Collaborators,
    Pathways_CollapseLesson: Pathways_CollapseLesson,
    Pathways_CollapseLessons: Pathways_CollapseLessons,
    Pathways_CompletedColumn: Pathways_CompletedColumn,
    Pathways_CompletedItemsFormat: Pathways_CompletedItemsFormat,
    Pathways_CompletionNotificationModalTitle: Pathways_CompletionNotificationModalTitle,
    Pathways_ConfirmCompletions: Pathways_ConfirmCompletions,
    Pathways_ConfirmDeleteLesson: Pathways_ConfirmDeleteLesson,
    Pathways_ConfirmDeleteSubsection: Pathways_ConfirmDeleteSubsection,
    Pathways_ConfirmRemoveItem: Pathways_ConfirmRemoveItem,
    Pathways_ConfirmRemoveSection: Pathways_ConfirmRemoveSection,
    Pathways_Course: Pathways_Course,
    Pathways_CreatedSection: Pathways_CreatedSection,
    Pathways_CreatedSubsection: Pathways_CreatedSubsection,
    Pathways_CreateSection: Pathways_CreateSection,
    Pathways_DeletedSection: Pathways_DeletedSection,
    Pathways_DeletedSubsection: Pathways_DeletedSubsection,
    Pathways_DeleteError: Pathways_DeleteError,
    Pathways_DeleteItem: Pathways_DeleteItem,
    Pathways_DeleteitemError: Pathways_DeleteitemError,
    Pathways_DeleteLesson: Pathways_DeleteLesson,
    Pathways_DeletelessonError: Pathways_DeletelessonError,
    Pathways_DeleteNote: Pathways_DeleteNote,
    Pathways_DeletePathwayBody: Pathways_DeletePathwayBody,
    Pathways_DeleteSection: Pathways_DeleteSection,
    Pathways_DeletesectionError: Pathways_DeletesectionError,
    Pathways_DeleteStepError: Pathways_DeleteStepError,
    Pathways_DeleteSubsection: Pathways_DeleteSubsection,
    Pathways_Description: Pathways_Description,
    Pathways_DescriptionPlaceholder: Pathways_DescriptionPlaceholder,
    Pathways_EditCatalogItemHelper: Pathways_EditCatalogItemHelper,
    Pathways_Edited: Pathways_Edited,
    Pathways_EditingDescription: Pathways_EditingDescription,
    Pathways_EditLocalContentHelper: Pathways_EditLocalContentHelper,
    Pathways_EditPathway: Pathways_EditPathway,
    Pathways_EditPermissionError: Pathways_EditPermissionError,
    Pathways_EmptyBinMessage: Pathways_EmptyBinMessage,
    Pathways_EnrollError: Pathways_EnrollError,
    Pathways_Episode: Pathways_Episode,
    Pathways_ErrorMessage: Pathways_ErrorMessage,
    Pathways_Event: Pathways_Event,
    Pathways_ExistingContentTypeError: Pathways_ExistingContentTypeError,
    Pathways_ExpandLesson: Pathways_ExpandLesson,
    Pathways_FeedbackAverage: Pathways_FeedbackAverage,
    Pathways_FeedbackCommentsPlaceholder: Pathways_FeedbackCommentsPlaceholder,
    Pathways_FeedbackCommentsTitle: Pathways_FeedbackCommentsTitle,
    Pathways_FeedbackDescription: Pathways_FeedbackDescription,
    Pathways_FeedbackExcellent: Pathways_FeedbackExcellent,
    Pathways_FeedbackGood: Pathways_FeedbackGood,
    Pathways_FeedbackOverallRating: Pathways_FeedbackOverallRating,
    Pathways_FeedbackPoor: Pathways_FeedbackPoor,
    Pathways_FeedbackSubmit: Pathways_FeedbackSubmit,
    Pathways_FeedbackSubmitted: Pathways_FeedbackSubmitted,
    Pathways_FeedbackSubmittedDescription: Pathways_FeedbackSubmittedDescription,
    Pathways_FeedbackTitle: Pathways_FeedbackTitle,
    Pathways_FeedbackVeryGood: Pathways_FeedbackVeryGood,
    Pathways_FollowedDate: Pathways_FollowedDate,
    Pathways_FollowError: Pathways_FollowError,
    Pathways_Followers: Pathways_Followers,
    Pathways_Following: Pathways_Following,
    Pathways_FollowingCountFormat: Pathways_FollowingCountFormat,
    Pathways_GetItemsError: Pathways_GetItemsError,
    Pathways_HoldForLater: Pathways_HoldForLater,
    Pathways_HoldForLaterError: Pathways_HoldForLaterError,
    Pathways_Insights: Pathways_Insights,
    Pathways_ItemCountFormat: Pathways_ItemCountFormat,
    Pathways_ItemCountSingular: Pathways_ItemCountSingular,
    Pathways_ItemSavedFormat: Pathways_ItemSavedFormat,
    Pathways_ItemsReordered: Pathways_ItemsReordered,
    Pathways_LessonCountFormat: Pathways_LessonCountFormat,
    Pathways_LessonCountSingular: Pathways_LessonCountSingular,
    Pathways_LessonDescriptionLabel: Pathways_LessonDescriptionLabel,
    Pathways_LessonDescriptionPlaceholder: Pathways_LessonDescriptionPlaceholder,
    Pathways_LessonItemsAllOptional: Pathways_LessonItemsAllOptional,
    Pathways_LessonLabelFormat: Pathways_LessonLabelFormat,
    Pathways_LessonNumberFormat: Pathways_LessonNumberFormat,
    Pathways_LessonTitleLabel: Pathways_LessonTitleLabel,
    Pathways_LessonTitlePlaceholder: Pathways_LessonTitlePlaceholder,
    Pathways_MakeFeatureNotification: Pathways_MakeFeatureNotification,
    Pathways_MakeOptional: Pathways_MakeOptional,
    Pathways_MakeRequired: Pathways_MakeRequired,
    Pathways_MarkAsOptional: Pathways_MarkAsOptional,
    Pathways_MarkAsRequired: Pathways_MarkAsRequired,
    Pathways_MoveConfirmationMessage: Pathways_MoveConfirmationMessage,
    Pathways_MovedItem: Pathways_MovedItem,
    Pathways_MovedLesson: Pathways_MovedLesson,
    Pathways_MovedSubsection: Pathways_MovedSubsection,
    Pathways_MovedToHoldForLater: Pathways_MovedToHoldForLater,
    Pathways_MoveItem: Pathways_MoveItem,
    Pathways_MoveItemError: Pathways_MoveItemError,
    Pathways_MoveItemTo: Pathways_MoveItemTo,
    Pathways_MoveLessonError: Pathways_MoveLessonError,
    Pathways_MoveLessonTo: Pathways_MoveLessonTo,
    Pathways_MoveSectionError: Pathways_MoveSectionError,
    Pathways_MoveSubsectionError: Pathways_MoveSubsectionError,
    Pathways_MoveSuccessMessage: Pathways_MoveSuccessMessage,
    Pathways_MoveWarningHostedContent: Pathways_MoveWarningHostedContent,
    Pathways_NewPathwayItemsNotification: Pathways_NewPathwayItemsNotification,
    Pathways_NoAccessDescriptionText: Pathways_NoAccessDescriptionText,
    Pathways_NoAccessHeaderText: Pathways_NoAccessHeaderText,
    Pathways_NoGroup: Pathways_NoGroup,
    Pathways_NoteFromAuthor: Pathways_NoteFromAuthor,
    Pathways_OptionalContent: Pathways_OptionalContent,
    Pathways_OptionalContentTooltip: Pathways_OptionalContentTooltip,
    Pathways_OptionalItemCountFormat: Pathways_OptionalItemCountFormat,
    Pathways_OptionalItemCountSingular: Pathways_OptionalItemCountSingular,
    Pathways_OrgManagedNotification: Pathways_OrgManagedNotification,
    Pathways_OutOfDate: Pathways_OutOfDate,
    Pathways_Pathway: Pathways_Pathway,
    Pathways_PathwayAccessError: Pathways_PathwayAccessError,
    Pathways_PathwayDetailAccessError: Pathways_PathwayDetailAccessError,
    Pathways_PathwayInfoAccessError: Pathways_PathwayInfoAccessError,
    Pathways_PathwayItemError: Pathways_PathwayItemError,
    Pathways_PathwayPrivateMessage: Pathways_PathwayPrivateMessage,
    Pathways_Post: Pathways_Post,
    Pathways_PrivacyCollaborators: Pathways_PrivacyCollaborators,
    Pathways_PrivacyGroupName: Pathways_PrivacyGroupName,
    Pathways_PrivacyGroups: Pathways_PrivacyGroups,
    Pathways_PrivacyOrg: Pathways_PrivacyOrg,
    Pathways_PrivacyOwner: Pathways_PrivacyOwner,
    Pathways_PrivacyProfile: Pathways_PrivacyProfile,
    Pathways_PrivatePathway: Pathways_PrivatePathway,
    Pathways_RefreshForLatestChange: Pathways_RefreshForLatestChange,
    Pathways_RemoveFeaturedNotification: Pathways_RemoveFeaturedNotification,
    Pathways_RemoveItemError: Pathways_RemoveItemError,
    Pathways_ReorderedSections: Pathways_ReorderedSections,
    Pathways_ReorderItemError: Pathways_ReorderItemError,
    Pathways_ReorderItems: Pathways_ReorderItems,
    Pathways_ReorderItemsTitleFormat: Pathways_ReorderItemsTitleFormat,
    Pathways_ReorderLessonError: Pathways_ReorderLessonError,
    Pathways_ReorderLessons: Pathways_ReorderLessons,
    Pathways_ReorderLessonsTitleFormat: Pathways_ReorderLessonsTitleFormat,
    Pathways_ReorderSections: Pathways_ReorderSections,
    Pathways_ReorderSubsectionItemsTitleFormat: Pathways_ReorderSubsectionItemsTitleFormat,
    Pathways_ReorderSubsections: Pathways_ReorderSubsections,
    Pathways_ReorderSubsectionsTitleFormat: Pathways_ReorderSubsectionsTitleFormat,
    Pathways_RequiredContentSuccess: Pathways_RequiredContentSuccess,
    Pathways_RestoreToOriginal: Pathways_RestoreToOriginal,
    Pathways_SaveError: Pathways_SaveError,
    Pathways_SearchCatalog: Pathways_SearchCatalog,
    Pathways_SearchError: Pathways_SearchError,
    Pathways_SectionCountFormat: Pathways_SectionCountFormat,
    Pathways_SectionDescLimit: Pathways_SectionDescLimit,
    Pathways_SectionDescriptionLabel: Pathways_SectionDescriptionLabel,
    Pathways_SectionDescriptionPlaceholder: Pathways_SectionDescriptionPlaceholder,
    Pathways_sectionLabelFormat: Pathways_sectionLabelFormat,
    Pathways_SectionNumberFormat: Pathways_SectionNumberFormat,
    Pathways_SectionNumberTitleFormat: Pathways_SectionNumberTitleFormat,
    Pathways_SectionTitleLabel: Pathways_SectionTitleLabel,
    Pathways_SectionTitlePlaceholder: Pathways_SectionTitlePlaceholder,
    Pathways_SelectACatalog: Pathways_SelectACatalog,
    Pathways_SetPathwayNameError: Pathways_SetPathwayNameError,
    Pathways_ShowMoreLessons: Pathways_ShowMoreLessons,
    Pathways_ShowOneMoreLesson: Pathways_ShowOneMoreLesson,
    Pathways_SubsectionCountFormat: Pathways_SubsectionCountFormat,
    Pathways_SubsectionCountSingular: Pathways_SubsectionCountSingular,
    Pathways_SubsectionDescriptionLabel: Pathways_SubsectionDescriptionLabel,
    Pathways_SubsectionDescriptionPlaceholder: Pathways_SubsectionDescriptionPlaceholder,
    Pathways_SubsectionNumberFormat: Pathways_SubsectionNumberFormat,
    Pathways_SubsectionsReordered: Pathways_SubsectionsReordered,
    Pathways_SubsectionTitleLabel: Pathways_SubsectionTitleLabel,
    Pathways_SubsectionTitlePlaceholder: Pathways_SubsectionTitlePlaceholder,
    Pathways_Task: Pathways_Task,
    Pathways_Title: Pathways_Title,
    Pathways_TitlePlaceholder: Pathways_TitlePlaceholder,
    Pathways_UnfollowError: Pathways_UnfollowError,
    Pathways_UntitledLesson: Pathways_UntitledLesson,
    Pathways_UntitledSection: Pathways_UntitledSection,
    Pathways_UpdateError: Pathways_UpdateError,
    Pathways_UpdateVisibilityError: Pathways_UpdateVisibilityError,
    Pathways_Video: Pathways_Video,
    Pathways_WithdrawFromPathway: Pathways_WithdrawFromPathway,
    Pathways_WithdrawFromPathwayBody: Pathways_WithdrawFromPathwayBody,
    PathwaySectionsChart_CompletedTooltipFormat: PathwaySectionsChart_CompletedTooltipFormat,
    PathwaySectionsChart_EnrolledTooltipFormat: PathwaySectionsChart_EnrolledTooltipFormat,
    PathwaySectionsChart_FollowingTooltipFormat: PathwaySectionsChart_FollowingTooltipFormat,
    PathwaySectionsChart_NoData: PathwaySectionsChart_NoData,
    PathwaySectionsChart_Started: PathwaySectionsChart_Started,
    PathwaySectionsChart_StartedTooltipFormat: PathwaySectionsChart_StartedTooltipFormat,
    PathwaySectionsChart_Title: PathwaySectionsChart_Title,
    PathwaysLayout_Enrollees: PathwaysLayout_Enrollees,
    PathwayTopContent_Empty: PathwayTopContent_Empty,
    PathwayTopContent_Title: PathwayTopContent_Title,
    PathwayTopContent_ViewAllContext: PathwayTopContent_ViewAllContext,
    PeopleCtrl_AllPeople: PeopleCtrl_AllPeople,
    PersonalSkillView_AddSkill: PersonalSkillView_AddSkill,
    PersonalSkillView_AddSkillInstructions: PersonalSkillView_AddSkillInstructions,
    PersonalSkillView_AddTarget: PersonalSkillView_AddTarget,
    PersonalSkillView_AllSkills: PersonalSkillView_AllSkills,
    PersonalSkillView_AverageRating: PersonalSkillView_AverageRating,
    PersonalSkillView_EvaluationRating: PersonalSkillView_EvaluationRating,
    PersonalSkillView_FindSkillContent: PersonalSkillView_FindSkillContent,
    PersonalSkillView_FocusSkill: PersonalSkillView_FocusSkill,
    PersonalSkillView_FocusSkills: PersonalSkillView_FocusSkills,
    PersonalSkillView_LastUpdated: PersonalSkillView_LastUpdated,
    PersonalSkillView_ManagerRating: PersonalSkillView_ManagerRating,
    PersonalSkillView_ManagerRatingFormat: PersonalSkillView_ManagerRatingFormat,
    PersonalSkillView_NoSkills: PersonalSkillView_NoSkills,
    PersonalSkillView_RequestSelfRating: PersonalSkillView_RequestSelfRating,
    PersonalSkillView_RequestSelfRating_Title: PersonalSkillView_RequestSelfRating_Title,
    PersonalSkillView_Search_Placeholder: PersonalSkillView_Search_Placeholder,
    PersonalSkillView_SelfRating: PersonalSkillView_SelfRating,
    PersonalSkillView_SelfRatingFormat: PersonalSkillView_SelfRatingFormat,
    PersonalSkillView_SkillDescription: PersonalSkillView_SkillDescription,
    PersonalSkillView_SkillProgression: PersonalSkillView_SkillProgression,
    PersonalSkillView_SkillProgressionChartSubtitle1: PersonalSkillView_SkillProgressionChartSubtitle1,
    PersonalSkillView_SkillProgressionChartSubtitle2: PersonalSkillView_SkillProgressionChartSubtitle2,
    PersonalSkillView_SkillProgressionChartSubtitle3: PersonalSkillView_SkillProgressionChartSubtitle3,
    PersonalSkillView_SkillReviewFormat: PersonalSkillView_SkillReviewFormat,
    PersonalSkillView_SkillTarget: PersonalSkillView_SkillTarget,
    PersonalSkillView_SkillTargetFormat: PersonalSkillView_SkillTargetFormat,
    PersonalSkillView_SkillTargetJobTargetFormat: PersonalSkillView_SkillTargetJobTargetFormat,
    PersonalSkillView_SkillTargetModalTitle: PersonalSkillView_SkillTargetModalTitle,
    PersonalSkillView_SkillTargetModalTitleFormat: PersonalSkillView_SkillTargetModalTitleFormat,
    PersonalSkillView_TeamFocusSkills: PersonalSkillView_TeamFocusSkills,
    PersonalSkillView_Top10SkillsAddSkill: PersonalSkillView_Top10SkillsAddSkill,
    PersonalSkillView_Top10SkillsAvgRating: PersonalSkillView_Top10SkillsAvgRating,
    PersonalSkillView_Top10SkillsSubtitle1: PersonalSkillView_Top10SkillsSubtitle1,
    PersonalSkillView_Top10SkillsSubtitle2: PersonalSkillView_Top10SkillsSubtitle2,
    PersonalSkillView_Top10SkillsSubtitle3: PersonalSkillView_Top10SkillsSubtitle3,
    PersonalSkillView_Top10SkillsSubtitle4: PersonalSkillView_Top10SkillsSubtitle4,
    PersonalSkillView_Top10SkillsTitle1: PersonalSkillView_Top10SkillsTitle1,
    PersonalSkillView_Top10SkillsTitle2: PersonalSkillView_Top10SkillsTitle2,
    PersonalSkillView_YourRating: PersonalSkillView_YourRating,
    PlanDropdown_ChoosePlan: PlanDropdown_ChoosePlan,
    PlanDropdown_FollowPlan: PlanDropdown_FollowPlan,
    PlanDropdown_NoPrimaryPlan: PlanDropdown_NoPrimaryPlan,
    PlanDropdown_PrimaryPlanTooltip: PlanDropdown_PrimaryPlanTooltip,
    PlanDropdown_Title: PlanDropdown_Title,
    PlanTagList_NoTags: PlanTagList_NoTags,
    PlanTagList_ShowAllTags: PlanTagList_ShowAllTags,
    PlanTagList_ViewPlan: PlanTagList_ViewPlan,
    PlanTagList_ViewSkillsInPlan: PlanTagList_ViewSkillsInPlan,
    PositionFormCtrl_AddCategory: PositionFormCtrl_AddCategory,
    PositionFormCtrl_AddExperience: PositionFormCtrl_AddExperience,
    PositionFormCtrl_AverageHours: PositionFormCtrl_AverageHours,
    PositionFormCtrl_CompanyOrg: PositionFormCtrl_CompanyOrg,
    PositionFormCtrl_CurrentPosition: PositionFormCtrl_CurrentPosition,
    PositionFormCtrl_DescribeExperience: PositionFormCtrl_DescribeExperience,
    PositionFormCtrl_Description: PositionFormCtrl_Description,
    PositionFormCtrl_EditExperience: PositionFormCtrl_EditExperience,
    PositionFormCtrl_EndAfterStart: PositionFormCtrl_EndAfterStart,
    PositionFormCtrl_EndDate: PositionFormCtrl_EndDate,
    PositionFormCtrl_EndDateError: PositionFormCtrl_EndDateError,
    PositionFormCtrl_ExpDescriptionLength: PositionFormCtrl_ExpDescriptionLength,
    PositionFormCtrl_ExperienceTitle: PositionFormCtrl_ExperienceTitle,
    PositionFormCtrl_HoursPerWeek: PositionFormCtrl_HoursPerWeek,
    PositionFormCtrl_IntermediatePosition: PositionFormCtrl_IntermediatePosition,
    PositionFormCtrl_JuniorPosition: PositionFormCtrl_JuniorPosition,
    PositionFormCtrl_MenteeName: PositionFormCtrl_MenteeName,
    PositionFormCtrl_MentorName: PositionFormCtrl_MentorName,
    PositionFormCtrl_Organization: PositionFormCtrl_Organization,
    PositionFormCtrl_PositionTitle: PositionFormCtrl_PositionTitle,
    PositionFormCtrl_RequiredOrg: PositionFormCtrl_RequiredOrg,
    PositionFormCtrl_RequiredTitle: PositionFormCtrl_RequiredTitle,
    PositionFormCtrl_SaveExperience: PositionFormCtrl_SaveExperience,
    PositionFormCtrl_SelectType: PositionFormCtrl_SelectType,
    PositionFormCtrl_Seniority: PositionFormCtrl_Seniority,
    PositionFormCtrl_SeniorPosition: PositionFormCtrl_SeniorPosition,
    PositionFormCtrl_StartDate: PositionFormCtrl_StartDate,
    PositionFormCtrl_StartDateError: PositionFormCtrl_StartDateError,
    PositionFormCtrl_Title: PositionFormCtrl_Title,
    PositionFormCtrl_WholeWeekHours: PositionFormCtrl_WholeWeekHours,
    PostFormCtrl_AnotherPathway: PostFormCtrl_AnotherPathway,
    PostFormCtrl_AreYouSure: PostFormCtrl_AreYouSure,
    PostFormCtrl_ClonedEditMessage: PostFormCtrl_ClonedEditMessage,
    PostFormCtrl_Content: PostFormCtrl_Content,
    PostFormCtrl_CreatePost: PostFormCtrl_CreatePost,
    PostFormCtrl_CreatePostSave: PostFormCtrl_CreatePostSave,
    PostFormCtrl_EditingDescription: PostFormCtrl_EditingDescription,
    PostFormCtrl_EditPost: PostFormCtrl_EditPost,
    PostFormCtrl_EditPostSave: PostFormCtrl_EditPostSave,
    PostFormCtrl_Title: PostFormCtrl_Title,
    PostFormCtrl_TitleLength: PostFormCtrl_TitleLength,
    PostFormCtrl_TitleRequired: PostFormCtrl_TitleRequired,
    PrePay_CertificateApplication: PrePay_CertificateApplication,
    PrePay_ChooseSkill: PrePay_ChooseSkill,
    PrePay_Payment: PrePay_Payment,
    PrePay_YourInformation: PrePay_YourInformation,
    primaryPlanSelectionModal_YesContinue: primaryPlanSelectionModal_YesContinue,
    problemModalContent_4xxOr5xxError: problemModalContent_4xxOr5xxError,
    problemModalContent_AccessDenied: problemModalContent_AccessDenied,
    problemModalContent_AdditionalDetails: problemModalContent_AdditionalDetails,
    problemModalContent_AdditionalDetailsPlaceholder: problemModalContent_AdditionalDetailsPlaceholder,
    problemModalContent_ApplicationQuestions: problemModalContent_ApplicationQuestions,
    problemModalContent_ApplicationTroubleCompleting: problemModalContent_ApplicationTroubleCompleting,
    problemModalContent_AttachScreenshot: problemModalContent_AttachScreenshot,
    problemModalContent_BrokenLink: problemModalContent_BrokenLink,
    problemModalContent_BrowserBlocked: problemModalContent_BrowserBlocked,
    problemModalContent_ChangeGroupVisibility: problemModalContent_ChangeGroupVisibility,
    problemModalContent_ChangingProfile: problemModalContent_ChangingProfile,
    problemModalContent_CompletedOverdueSeveralDays: problemModalContent_CompletedOverdueSeveralDays,
    problemModalContent_CompletedOverdueToday: problemModalContent_CompletedOverdueToday,
    problemModalContent_ContactPermission: problemModalContent_ContactPermission,
    problemModalContent_ContentDurationIncorrect: problemModalContent_ContentDurationIncorrect,
    problemModalContent_ContentInappropriate: problemModalContent_ContentInappropriate,
    problemModalContent_ContentMisassigned: problemModalContent_ContentMisassigned,
    problemModalContent_ContentNotAppropriateForWorkplace: problemModalContent_ContentNotAppropriateForWorkplace,
    problemModalContent_ContentNotRelevant: problemModalContent_ContentNotRelevant,
    problemModalContent_ContentNotSafeForWork: problemModalContent_ContentNotSafeForWork,
    problemModalContent_ContentSomethingIncorrect: problemModalContent_ContentSomethingIncorrect,
    problemModalContent_ContentTypeIncorrect: problemModalContent_ContentTypeIncorrect,
    problemModalContent_DefaultQuestions: problemModalContent_DefaultQuestions,
    problemModalContent_DefaultRelevance: problemModalContent_DefaultRelevance,
    problemModalContent_ErrorWithProvider: problemModalContent_ErrorWithProvider,
    problemModalContent_FileRestrictionDescription: problemModalContent_FileRestrictionDescription,
    problemModalContent_FileTypes: problemModalContent_FileTypes,
    problemModalContent_Flag: problemModalContent_Flag,
    problemModalContent_IncorrectPoints: problemModalContent_IncorrectPoints,
    problemModalContent_IssuesJoining: problemModalContent_IssuesJoining,
    problemModalContent_LinkAppearsBroken: problemModalContent_LinkAppearsBroken,
    problemModalContent_OpportunityIrrelevant: problemModalContent_OpportunityIrrelevant,
    problemModalContent_OpportunityQuestions: problemModalContent_OpportunityQuestions,
    problemModalContent_Other: problemModalContent_Other,
    problemModalContent_OtherInstructions: problemModalContent_OtherInstructions,
    problemModalContent_PaidContent: problemModalContent_PaidContent,
    problemModalContent_PermissionOrLicense: problemModalContent_PermissionOrLicense,
    problemModalContent_ProfileNotAppropriate: problemModalContent_ProfileNotAppropriate,
    problemModalContent_Reason: problemModalContent_Reason,
    problemModalContent_ReasonPlaceholder: problemModalContent_ReasonPlaceholder,
    problemModalContent_RequiredLearningWarning: problemModalContent_RequiredLearningWarning,
    problemModalContent_ShouldNotBeConnected: problemModalContent_ShouldNotBeConnected,
    problemModalContent_SubissuePlaceholder: problemModalContent_SubissuePlaceholder,
    problemModalContent_Subreason: problemModalContent_Subreason,
    problemModalContent_TeamIncorrectInsights: problemModalContent_TeamIncorrectInsights,
    problemModalContent_TeamIncorrectMembers: problemModalContent_TeamIncorrectMembers,
    problemModalContent_Title: problemModalContent_Title,
    problemModalContent_UnableToShare: problemModalContent_UnableToShare,
    problemModalContent_UploadScreenshotDetail: problemModalContent_UploadScreenshotDetail,
    problemModalContent_UploadScreenshotMessage: problemModalContent_UploadScreenshotMessage,
    ProfileCtrl_AddGroup: ProfileCtrl_AddGroup,
    ProfileCtrl_AllCategories: ProfileCtrl_AllCategories,
    ProfileCtrl_ArticlesRead: ProfileCtrl_ArticlesRead,
    ProfileCtrl_AssessmentsCompleted: ProfileCtrl_AssessmentsCompleted,
    ProfileCtrl_BooksRead: ProfileCtrl_BooksRead,
    ProfileCtrl_BulkDeleteFormat: ProfileCtrl_BulkDeleteFormat,
    ProfileCtrl_BulkDeleteSingle: ProfileCtrl_BulkDeleteSingle,
    ProfileCtrl_CoursesCompleted: ProfileCtrl_CoursesCompleted,
    ProfileCtrl_CreateGroup: ProfileCtrl_CreateGroup,
    ProfileCtrl_DeleteCollectionGenericItemBody: ProfileCtrl_DeleteCollectionGenericItemBody,
    ProfileCtrl_DeleteCollectionGenericItemBodySingle: ProfileCtrl_DeleteCollectionGenericItemBodySingle,
    ProfileCtrl_DeleteCollectionItemBodyFormat: ProfileCtrl_DeleteCollectionItemBodyFormat,
    ProfileCtrl_DeleteCollectionItemHeaderFormat: ProfileCtrl_DeleteCollectionItemHeaderFormat,
    ProfileCtrl_DeleteCollectionItemNotifierFormat: ProfileCtrl_DeleteCollectionItemNotifierFormat,
    ProfileCtrl_DeleteCollectionMultipleItemsNotifierFormat: ProfileCtrl_DeleteCollectionMultipleItemsNotifierFormat,
    ProfileCtrl_DeleteProviderItemNotifierFormat: ProfileCtrl_DeleteProviderItemNotifierFormat,
    ProfileCtrl_DeleteProviderItemPromptFormat: ProfileCtrl_DeleteProviderItemPromptFormat,
    ProfileCtrl_EditCollectionItemNotifierFormat: ProfileCtrl_EditCollectionItemNotifierFormat,
    ProfileCtrl_EditCollectionMultipleItemsNotifierFormat: ProfileCtrl_EditCollectionMultipleItemsNotifierFormat,
    ProfileCtrl_EventsAttended: ProfileCtrl_EventsAttended,
    ProfileCtrl_ExperienceDatePresent: ProfileCtrl_ExperienceDatePresent,
    ProfileCtrl_ExperienceDateYears: ProfileCtrl_ExperienceDateYears,
    ProfileCtrl_ExperienceReported: ProfileCtrl_ExperienceReported,
    ProfileCtrl_FindGroups: ProfileCtrl_FindGroups,
    ProfileCtrl_GroupsDescription: ProfileCtrl_GroupsDescription,
    ProfileCtrl_NoExactMatches: ProfileCtrl_NoExactMatches,
    ProfileCtrl_NoExactMatchesHelp: ProfileCtrl_NoExactMatchesHelp,
    ProfileCtrl_OwnerEmptyStateBody: ProfileCtrl_OwnerEmptyStateBody,
    ProfileCtrl_OwnerEmptyStateTitle: ProfileCtrl_OwnerEmptyStateTitle,
    ProfileCtrl_PathwaysDescription: ProfileCtrl_PathwaysDescription,
    ProfileCtrl_PlansDescription: ProfileCtrl_PlansDescription,
    ProfileCtrl_PodcastsCompleted: ProfileCtrl_PodcastsCompleted,
    ProfileCtrl_PointsEarnedTitle: ProfileCtrl_PointsEarnedTitle,
    ProfileCtrl_ShareProfile: ProfileCtrl_ShareProfile,
    ProfileCtrl_ShareProfilePrivate: ProfileCtrl_ShareProfilePrivate,
    ProfileCtrl_ShareProfileSuccess: ProfileCtrl_ShareProfileSuccess,
    ProfileCtrl_ShareSkillSuccess: ProfileCtrl_ShareSkillSuccess,
    ProfileCtrl_SkillStdDescription: ProfileCtrl_SkillStdDescription,
    ProfileCtrl_VideosWatched: ProfileCtrl_VideosWatched,
    ProfileCtrl_ViewSkillSignals: ProfileCtrl_ViewSkillSignals,
    ProfilePathways_Authoring: ProfilePathways_Authoring,
    ProfilePathways_Completed: ProfilePathways_Completed,
    ProfilePathways_CreateNewPathway: ProfilePathways_CreateNewPathway,
    ProfilePathways_CreatePathway: ProfilePathways_CreatePathway,
    ProfilePathways_EmptyDescription: ProfilePathways_EmptyDescription,
    ProfilePathways_EmptyStateDescription: ProfilePathways_EmptyStateDescription,
    ProfilePathways_EmptyStateTitle: ProfilePathways_EmptyStateTitle,
    ProfilePathways_EmptyTitle: ProfilePathways_EmptyTitle,
    ProfilePathways_Enrolled: ProfilePathways_Enrolled,
    ProfilePathways_FindPathways: ProfilePathways_FindPathways,
    ProfilePathways_FindPathwaysAria: ProfilePathways_FindPathwaysAria,
    ProfilePathways_Following: ProfilePathways_Following,
    ProfilePathways_LearnTypesAlt: ProfilePathways_LearnTypesAlt,
    ProfilePathways_NoPathways: ProfilePathways_NoPathways,
    ProfilePathways_UserNoPathwaysFormat: ProfilePathways_UserNoPathwaysFormat,
    ProfilePlans_EmptyDescription: ProfilePlans_EmptyDescription,
    ProfilePlans_EmptyStateDescription: ProfilePlans_EmptyStateDescription,
    ProfilePlans_EmptyStateTitle: ProfilePlans_EmptyStateTitle,
    ProfilePlans_FindPlans: ProfilePlans_FindPlans,
    ProfilePlans_NoPlans: ProfilePlans_NoPlans,
    ProfilePlans_NoPlansDescription: ProfilePlans_NoPlansDescription,
    ProfileSkillStd_CollaboratorOnly: ProfileSkillStd_CollaboratorOnly,
    ProfileSkillStd_EmptyStateDescription: ProfileSkillStd_EmptyStateDescription,
    ProfileSkillStd_EmptyStateTitle: ProfileSkillStd_EmptyStateTitle,
    ProviderSummary_agileunternehmen: ProviderSummary_agileunternehmen,
    ProviderSummary_aicpa: ProviderSummary_aicpa,
    ProviderSummary_alura: ProviderSummary_alura,
    ProviderSummary_anderspink: ProviderSummary_anderspink,
    ProviderSummary_arcitura: ProviderSummary_arcitura,
    ProviderSummary_ascm: ProviderSummary_ascm,
    ProviderSummary_awstraining: ProviderSummary_awstraining,
    ProviderSummary_babbel: ProviderSummary_babbel,
    ProviderSummary_bigdatainsider: ProviderSummary_bigdatainsider,
    ProviderSummary_blinkist: ProviderSummary_blinkist,
    ProviderSummary_business2community: ProviderSummary_business2community,
    ProviderSummary_businessinsider: ProviderSummary_businessinsider,
    ProviderSummary_busuupremium: ProviderSummary_busuupremium,
    ProviderSummary_cbtnuggets: ProviderSummary_cbtnuggets,
    ProviderSummary_centerforcreativeleadership: ProviderSummary_centerforcreativeleadership,
    ProviderSummary_cisconetworkingacademy: ProviderSummary_cisconetworkingacademy,
    ProviderSummary_crehana: ProviderSummary_crehana,
    ProviderSummary_cybrary: ProviderSummary_cybrary,
    ProviderSummary_datacamp: ProviderSummary_datacamp,
    ProviderSummary_degreedmeta: ProviderSummary_degreedmeta,
    ProviderSummary_deloitteinsights: ProviderSummary_deloitteinsights,
    ProviderSummary_duarte: ProviderSummary_duarte,
    ProviderSummary_edx: ProviderSummary_edx,
    ProviderSummary_emtrain: ProviderSummary_emtrain,
    ProviderSummary_entrepreneur: ProviderSummary_entrepreneur,
    ProviderSummary_exitcertified: ProviderSummary_exitcertified,
    ProviderSummary_financialedge: ProviderSummary_financialedge,
    ProviderSummary_fortinet: ProviderSummary_fortinet,
    ProviderSummary_fortytwocourses: ProviderSummary_fortytwocourses,
    ProviderSummary_futurelearn: ProviderSummary_futurelearn,
    ProviderSummary_getabstract: ProviderSummary_getabstract,
    ProviderSummary_ghsp: ProviderSummary_ghsp,
    ProviderSummary_goskills: ProviderSummary_goskills,
    ProviderSummary_greatlearning: ProviderSummary_greatlearning,
    ProviderSummary_growwithgoogle: ProviderSummary_growwithgoogle,
    ProviderSummary_handelsblatt: ProviderSummary_handelsblatt,
    ProviderSummary_hrcom: ProviderSummary_hrcom,
    ProviderSummary_hubspotacademy: ProviderSummary_hubspotacademy,
    ProviderSummary_ideou: ProviderSummary_ideou,
    ProviderSummary_industryofthings: ProviderSummary_industryofthings,
    ProviderSummary_invisionapp: ProviderSummary_invisionapp,
    ProviderSummary_itprotv: ProviderSummary_itprotv,
    ProviderSummary_joshbersin: ProviderSummary_joshbersin,
    ProviderSummary_kenblanchardcompanies: ProviderSummary_kenblanchardcompanies,
    ProviderSummary_kes: ProviderSummary_kes,
    ProviderSummary_khanacademy: ProviderSummary_khanacademy,
    ProviderSummary_loma: ProviderSummary_loma,
    ProviderSummary_mandel: ProviderSummary_mandel,
    ProviderSummary_masterclass: ProviderSummary_masterclass,
    ProviderSummary_mckinsey: ProviderSummary_mckinsey,
    ProviderSummary_methods: ProviderSummary_methods,
    ProviderSummary_microsoftlearn: ProviderSummary_microsoftlearn,
    ProviderSummary_mindtools: ProviderSummary_mindtools,
    ProviderSummary_mitsloanmgmtreview: ProviderSummary_mitsloanmgmtreview,
    ProviderSummary_platzi: ProviderSummary_platzi,
    ProviderSummary_pluralsight: ProviderSummary_pluralsight,
    ProviderSummary_racismreview: ProviderSummary_racismreview,
    ProviderSummary_redshelf: ProviderSummary_redshelf,
    ProviderSummary_safari: ProviderSummary_safari,
    ProviderSummary_scoopnewsgroup: ProviderSummary_scoopnewsgroup,
    ProviderSummary_simplilearn: ProviderSummary_simplilearn,
    ProviderSummary_skillshare: ProviderSummary_skillshare,
    ProviderSummary_softwareengineeringinstitute: ProviderSummary_softwareengineeringinstitute,
    ProviderSummary_soundview: ProviderSummary_soundview,
    ProviderSummary_springerprofessional: ProviderSummary_springerprofessional,
    ProviderSummary_tedatwork: ProviderSummary_tedatwork,
    ProviderSummary_udacity: ProviderSummary_udacity,
    ProviderSummary_whil: ProviderSummary_whil,
    ProviderSummary_workingvoices: ProviderSummary_workingvoices,
    PublicError_HomePageButton: PublicError_HomePageButton,
    QueueCtrl_CompletedMovedToCollection: QueueCtrl_CompletedMovedToCollection,
    QueueCtrl_EmptyStateDescription: QueueCtrl_EmptyStateDescription,
    QueueCtrl_EmptyStateTitle: QueueCtrl_EmptyStateTitle,
    QueueCtrl_InternalError: QueueCtrl_InternalError,
    QueueCtrl_NoItemsSaved: QueueCtrl_NoItemsSaved,
    QueueCtrl_RemoveSavedItems: QueueCtrl_RemoveSavedItems,
    QueueCtrl_SavedDescription: QueueCtrl_SavedDescription,
    QueueCtrl_SaveInstructionsFormat: QueueCtrl_SaveInstructionsFormat,
    QueueCtrl_SaveUrlForLater: QueueCtrl_SaveUrlForLater,
    QueueSvc_InternalError: QueueSvc_InternalError,
    QueueSvc_ItemAddedFormat: QueueSvc_ItemAddedFormat,
    QueueSvc_UsersTitle: QueueSvc_UsersTitle,
    RecommendationCtrl_SelectADate: RecommendationCtrl_SelectADate,
    recommendationDetail_DueDateFormat: recommendationDetail_DueDateFormat,
    recommendationDetail_LevelFormat: recommendationDetail_LevelFormat,
    recommendationDetail_StatusComplete: recommendationDetail_StatusComplete,
    recommendationDetail_StatusDismissed: recommendationDetail_StatusDismissed,
    recommendationDetail_StatusPending: recommendationDetail_StatusPending,
    recommendationDetail_StatusPrivate: recommendationDetail_StatusPrivate,
    recommendationDetail_StatusQueued: recommendationDetail_StatusQueued,
    recommendationForm_AddToProfileFormat: recommendationForm_AddToProfileFormat,
    recommendationForm_AssignItem: recommendationForm_AssignItem,
    recommendationForm_BackToAddingNames: recommendationForm_BackToAddingNames,
    recommendationForm_CharacterCount: recommendationForm_CharacterCount,
    recommendationForm_ConfirmDelete: recommendationForm_ConfirmDelete,
    recommendationForm_CopyUrl: recommendationForm_CopyUrl,
    recommendationForm_dateLabel: recommendationForm_dateLabel,
    recommendationForm_dateToggle: recommendationForm_dateToggle,
    recommendationForm_dateToggleInfo: recommendationForm_dateToggleInfo,
    recommendationForm_EmailRecommendation: recommendationForm_EmailRecommendation,
    recommendationForm_FindPeopleConsumerPlaceholder: recommendationForm_FindPeopleConsumerPlaceholder,
    recommendationForm_FindPeoplePlaceholder: recommendationForm_FindPeoplePlaceholder,
    recommendationForm_HasRecommendedSkills: recommendationForm_HasRecommendedSkills,
    recommendationForm_MemberCount: recommendationForm_MemberCount,
    recommendationForm_NoResults: recommendationForm_NoResults,
    recommendationForm_OnlyOrgMembers: recommendationForm_OnlyOrgMembers,
    recommendationForm_PickADate: recommendationForm_PickADate,
    recommendationForm_RecommendInput: recommendationForm_RecommendInput,
    recommendationForm_RecommendItem: recommendationForm_RecommendItem,
    recommendationForm_RecommendItem_Academy: recommendationForm_RecommendItem_Academy,
    recommendationForm_RecommendItem_Article: recommendationForm_RecommendItem_Article,
    recommendationForm_RecommendItem_Assessment: recommendationForm_RecommendItem_Assessment,
    recommendationForm_RecommendItem_Book: recommendationForm_RecommendItem_Book,
    recommendationForm_RecommendItem_Course: recommendationForm_RecommendItem_Course,
    recommendationForm_RecommendItem_Episode: recommendationForm_RecommendItem_Episode,
    recommendationForm_RecommendItem_Event: recommendationForm_RecommendItem_Event,
    recommendationForm_RecommendItem_Opportunity: recommendationForm_RecommendItem_Opportunity,
    recommendationForm_RecommendItem_Pathway: recommendationForm_RecommendItem_Pathway,
    recommendationForm_RecommendItem_Plan: recommendationForm_RecommendItem_Plan,
    recommendationForm_RecommendItem_Podcast: recommendationForm_RecommendItem_Podcast,
    recommendationForm_RecommendItem_Post: recommendationForm_RecommendItem_Post,
    recommendationForm_RecommendItem_Tag: recommendationForm_RecommendItem_Tag,
    recommendationForm_RecommendItem_Target: recommendationForm_RecommendItem_Target,
    recommendationForm_RecommendItem_Task: recommendationForm_RecommendItem_Task,
    recommendationForm_RecommendItem_Video: recommendationForm_RecommendItem_Video,
    recommendationForm_RecommendSkillInput: recommendationForm_RecommendSkillInput,
    recommendationForm_SearchByName: recommendationForm_SearchByName,
    recommendationForm_SearchLabel: recommendationForm_SearchLabel,
    recommendationForm_SearchLabelConsumer: recommendationForm_SearchLabelConsumer,
    recommendationForm_submitButtonPlural: recommendationForm_submitButtonPlural,
    recommendationForm_submitButtonPluralAssign: recommendationForm_submitButtonPluralAssign,
    recommendationForm_submitButtonSingular: recommendationForm_submitButtonSingular,
    recommendationForm_submitButtonSingularAssign: recommendationForm_submitButtonSingularAssign,
    recommendationForm_UpdateItem: recommendationForm_UpdateItem,
    recommendationForm_ViewSkillsOnProfile: recommendationForm_ViewSkillsOnProfile,
    recommendationForm_WhyAssignedUpdate: recommendationForm_WhyAssignedUpdate,
    recommendationForm_WhyRecommendedUpdate: recommendationForm_WhyRecommendedUpdate,
    recommendationForm_WhyRecommending: recommendationForm_WhyRecommending,
    recommendationForm_WhyRecommendingPlaceholder: recommendationForm_WhyRecommendingPlaceholder,
    RecommendationPolicyModal_Acknowledge: RecommendationPolicyModal_Acknowledge,
    RecommendationPolicyModal_Title: RecommendationPolicyModal_Title,
    RecommendationsOverviewCtrl_DismissDialogDescription: RecommendationsOverviewCtrl_DismissDialogDescription,
    RecommendationsSvc_DeleteConfirmationFormat: RecommendationsSvc_DeleteConfirmationFormat,
    RecommendationsSvc_GetUsersError: RecommendationsSvc_GetUsersError,
    RecommendationsSvc_InputAssignedFormat: RecommendationsSvc_InputAssignedFormat,
    RecommendationsSvc_InputAssignedFormatIneligibleAdmin: RecommendationsSvc_InputAssignedFormatIneligibleAdmin,
    RecommendationsSvc_InputAssignedFormatIneligibleLearner: RecommendationsSvc_InputAssignedFormatIneligibleLearner,
    RecommendationsSvc_InputAssignedFormatNoEligibleUsersAdmin: RecommendationsSvc_InputAssignedFormatNoEligibleUsersAdmin,
    RecommendationsSvc_InputAssignedFormatNoEligibleUsersLearner: RecommendationsSvc_InputAssignedFormatNoEligibleUsersLearner,
    RecommendationsSvc_InputRecommendedFormat: RecommendationsSvc_InputRecommendedFormat,
    RecommendationsSvc_InputRecommendedFormatIneligibleAdmin: RecommendationsSvc_InputRecommendedFormatIneligibleAdmin,
    RecommendationsSvc_InputRecommendedFormatIneligibleLearner: RecommendationsSvc_InputRecommendedFormatIneligibleLearner,
    RecommendationsSvc_InputRecommendedFormatNoEligibleUsersAdmin: RecommendationsSvc_InputRecommendedFormatNoEligibleUsersAdmin,
    RecommendationsSvc_InputRecommendedFormatNoEligibleUsersLearner: RecommendationsSvc_InputRecommendedFormatNoEligibleUsersLearner,
    RecommendationsSvc_ProblemAccessingRecommendations: RecommendationsSvc_ProblemAccessingRecommendations,
    RecommendationsSvc_ProblemAddingRecommendations: RecommendationsSvc_ProblemAddingRecommendations,
    RecommendationsSvc_ProblemDeleteRecommendationsFormat: RecommendationsSvc_ProblemDeleteRecommendationsFormat,
    RecommendationsSvc_ProblemSearchingGroups: RecommendationsSvc_ProblemSearchingGroups,
    RecommendationsSvc_ProblemSearchingMembers: RecommendationsSvc_ProblemSearchingMembers,
    RecommendationsSvc_ProblemUpdatingRecommendation: RecommendationsSvc_ProblemUpdatingRecommendation,
    RecommendationsSvc_SharedWith: RecommendationsSvc_SharedWith,
    RecommendationsSvc_SuccessDelete: RecommendationsSvc_SuccessDelete,
    RecommendationsSvc_SuccessDeleteAssignment: RecommendationsSvc_SuccessDeleteAssignment,
    RecommendationsSvc_UpdateAssignment: RecommendationsSvc_UpdateAssignment,
    RecommendationsSvc_UpdateRecommendation: RecommendationsSvc_UpdateRecommendation,
    RecommendationsSvc_UsersTitle: RecommendationsSvc_UsersTitle,
    replyToComment_CommentGroupPluralFormat: replyToComment_CommentGroupPluralFormat,
    replyToComment_CommentGroupSingleFormat: replyToComment_CommentGroupSingleFormat,
    replyToComment_CommentPluralFormat: replyToComment_CommentPluralFormat,
    replyToComment_CommentSingleFormat: replyToComment_CommentSingleFormat,
    replyToComment_TakeawayGroupPluralFormat: replyToComment_TakeawayGroupPluralFormat,
    replyToComment_TakeawayGroupSingleFormat: replyToComment_TakeawayGroupSingleFormat,
    replyToComment_TakeawayPluralFormat: replyToComment_TakeawayPluralFormat,
    replyToComment_TakeawaySingleFormat: replyToComment_TakeawaySingleFormat,
    replyToPost_GroupPluralFormat: replyToPost_GroupPluralFormat,
    replyToPost_GroupSingleFormat: replyToPost_GroupSingleFormat,
    replyToPost_PluralFormat: replyToPost_PluralFormat,
    replyToPost_SingleFormat: replyToPost_SingleFormat,
    Reporting_Transmitters_BOM: Reporting_Transmitters_BOM,
    Reporting_Transmitters_Configurations: Reporting_Transmitters_Configurations,
    Reporting_Transmitters_Configurations_Selection: Reporting_Transmitters_Configurations_Selection,
    Reporting_Transmitters_CreateEdit_AuthenticationType: Reporting_Transmitters_CreateEdit_AuthenticationType,
    Reporting_Transmitters_CreateEdit_BOMTooltip: Reporting_Transmitters_CreateEdit_BOMTooltip,
    Reporting_Transmitters_CreateEdit_ConnectionStatus: Reporting_Transmitters_CreateEdit_ConnectionStatus,
    Reporting_Transmitters_CreateEdit_ConnectionStatusCheck: Reporting_Transmitters_CreateEdit_ConnectionStatusCheck,
    Reporting_Transmitters_CreateEdit_ConnectionStatusFail: Reporting_Transmitters_CreateEdit_ConnectionStatusFail,
    Reporting_Transmitters_CreateEdit_ConnectionStatusNotConnected: Reporting_Transmitters_CreateEdit_ConnectionStatusNotConnected,
    Reporting_Transmitters_CreateEdit_ConnectionStatusSuccess: Reporting_Transmitters_CreateEdit_ConnectionStatusSuccess,
    Reporting_Transmitters_CreateEdit_CredentialsNote: Reporting_Transmitters_CreateEdit_CredentialsNote,
    Reporting_Transmitters_CreateEdit_HeaderCreate: Reporting_Transmitters_CreateEdit_HeaderCreate,
    Reporting_Transmitters_CreateEdit_HeaderUpdate: Reporting_Transmitters_CreateEdit_HeaderUpdate,
    Reporting_Transmitters_CreateEdit_HostPlaceholder: Reporting_Transmitters_CreateEdit_HostPlaceholder,
    Reporting_Transmitters_CreateEdit_Password: Reporting_Transmitters_CreateEdit_Password,
    Reporting_Transmitters_CreateEdit_PasswordPlaceholder: Reporting_Transmitters_CreateEdit_PasswordPlaceholder,
    Reporting_Transmitters_CreateEdit_PortNumberError: Reporting_Transmitters_CreateEdit_PortNumberError,
    Reporting_Transmitters_CreateEdit_PrivateKey: Reporting_Transmitters_CreateEdit_PrivateKey,
    Reporting_Transmitters_CreateEdit_PrivateKeyPlaceholder: Reporting_Transmitters_CreateEdit_PrivateKeyPlaceholder,
    Reporting_Transmitters_CreateEdit_Subfolder: Reporting_Transmitters_CreateEdit_Subfolder,
    Reporting_Transmitters_CreateEdit_SubfolderPlaceholder: Reporting_Transmitters_CreateEdit_SubfolderPlaceholder,
    Reporting_Transmitters_CreateEdit_TitlePlaceholder: Reporting_Transmitters_CreateEdit_TitlePlaceholder,
    Reporting_Transmitters_CreateEdit_TypePlaceholder: Reporting_Transmitters_CreateEdit_TypePlaceholder,
    Reporting_Transmitters_CreateEdit_TypeTootltip: Reporting_Transmitters_CreateEdit_TypeTootltip,
    Reporting_Transmitters_CreateEdit_Username: Reporting_Transmitters_CreateEdit_Username,
    Reporting_Transmitters_CreateEdit_UsernamePlaceholder: Reporting_Transmitters_CreateEdit_UsernamePlaceholder,
    Reporting_Transmitters_CreateNew: Reporting_Transmitters_CreateNew,
    Reporting_Transmitters_Default: Reporting_Transmitters_Default,
    Reporting_Transmitters_Error_Create: Reporting_Transmitters_Error_Create,
    Reporting_Transmitters_Error_Delete: Reporting_Transmitters_Error_Delete,
    Reporting_Transmitters_Error_Get: Reporting_Transmitters_Error_Get,
    Reporting_Transmitters_Error_GetAll: Reporting_Transmitters_Error_GetAll,
    Reporting_Transmitters_Error_GetPGPKey: Reporting_Transmitters_Error_GetPGPKey,
    Reporting_Transmitters_Error_SavePGPKey: Reporting_Transmitters_Error_SavePGPKey,
    Reporting_Transmitters_Error_Update: Reporting_Transmitters_Error_Update,
    Reporting_Transmitters_Host: Reporting_Transmitters_Host,
    Reporting_Transmitters_PGPEncrypted: Reporting_Transmitters_PGPEncrypted,
    Reporting_Transmitters_PGPExtension: Reporting_Transmitters_PGPExtension,
    Reporting_Transmitters_Port: Reporting_Transmitters_Port,
    Reporting_Transmitters_SetupPGPKey: Reporting_Transmitters_SetupPGPKey,
    Reporting_Transmitters_SetupPGPKeyLabel: Reporting_Transmitters_SetupPGPKeyLabel,
    Reporting_Transmitters_SetupPGPKeyPlaceholder: Reporting_Transmitters_SetupPGPKeyPlaceholder,
    Reporting_Transmitters_SetupPGPKeyPlaceholderFilled: Reporting_Transmitters_SetupPGPKeyPlaceholderFilled,
    Reporting_Transmitters_SetupPGPKeyTooltip: Reporting_Transmitters_SetupPGPKeyTooltip,
    Reporting_Transmitters_SFTP: Reporting_Transmitters_SFTP,
    Reporting_Transmitters_Success_Create: Reporting_Transmitters_Success_Create,
    Reporting_Transmitters_Success_Delete: Reporting_Transmitters_Success_Delete,
    Reporting_Transmitters_Success_SavePGPKey: Reporting_Transmitters_Success_SavePGPKey,
    Reporting_Transmitters_Success_Update: Reporting_Transmitters_Success_Update,
    Reporting_Transmitters_Title: Reporting_Transmitters_Title,
    Reporting_Transmitters_Type: Reporting_Transmitters_Type,
    Reporting_Transmitters_TypeOptionClientProvided: Reporting_Transmitters_TypeOptionClientProvided,
    Reporting_Transmitters_TypeOptionDegreed: Reporting_Transmitters_TypeOptionDegreed,
    ReportingContentSvc_All: ReportingContentSvc_All,
    ReportingContentSvc_ChartIDflexPathwaySections: ReportingContentSvc_ChartIDflexPathwaySections,
    ReportingContentSvc_ChartIDlearningChart: ReportingContentSvc_ChartIDlearningChart,
    ReportingContentSvc_ChartIDpopularCategories: ReportingContentSvc_ChartIDpopularCategories,
    ReportingContentSvc_ChartIDpopularProviders: ReportingContentSvc_ChartIDpopularProviders,
    ReportingContentSvc_ChartIDpopularSearches: ReportingContentSvc_ChartIDpopularSearches,
    ReportingContentSvc_ChartIDrecommendationsStatus: ReportingContentSvc_ChartIDrecommendationsStatus,
    ReportingContentSvc_ChartIDskillRatings: ReportingContentSvc_ChartIDskillRatings,
    ReportingContentSvc_ChartIDtopGroups: ReportingContentSvc_ChartIDtopGroups,
    ReportingContentSvc_ExternalContent: ReportingContentSvc_ExternalContent,
    ReportingContentSvc_ImageAltText: ReportingContentSvc_ImageAltText,
    ReportingContentSvc_InternalContent: ReportingContentSvc_InternalContent,
    ReportingContentSvc_Name: ReportingContentSvc_Name,
    ReportingContentSvc_NotEnoughActivity: ReportingContentSvc_NotEnoughActivity,
    ReportingContentSvc_Points: ReportingContentSvc_Points,
    ReportingContentSvc_ReportsNotAvailable: ReportingContentSvc_ReportsNotAvailable,
    ReportingContentSvc_TotalContentViewed: ReportingContentSvc_TotalContentViewed,
    ReportingContentSvc_TotalItemsAdded: ReportingContentSvc_TotalItemsAdded,
    ReportingContentSvc_TotalItemsCompleted: ReportingContentSvc_TotalItemsCompleted,
    ReportingContentSvc_TotalPointsEarned: ReportingContentSvc_TotalPointsEarned,
    ReportingInApp_Actions_ChooseReportType: ReportingInApp_Actions_ChooseReportType,
    ReportingInApp_Actions_CreateNewReport: ReportingInApp_Actions_CreateNewReport,
    ReportingInApp_Actions_EditSchedule: ReportingInApp_Actions_EditSchedule,
    ReportingInApp_Actions_GenerateReport: ReportingInApp_Actions_GenerateReport,
    ReportingInApp_Actions_OpenDownloads: ReportingInApp_Actions_OpenDownloads,
    ReportingInApp_Actions_PreviewReport: ReportingInApp_Actions_PreviewReport,
    ReportingInApp_Actions_ScheduleReport: ReportingInApp_Actions_ScheduleReport,
    ReportingInApp_Actions_ViewReport: ReportingInApp_Actions_ViewReport,
    ReportingInApp_Categories: ReportingInApp_Categories,
    ReportingInApp_Create: ReportingInApp_Create,
    ReportingInApp_CustomFields: ReportingInApp_CustomFields,
    ReportingInApp_DataTable_DeliveredDate: ReportingInApp_DataTable_DeliveredDate,
    ReportingInApp_DataTable_LastRun: ReportingInApp_DataTable_LastRun,
    ReportingInApp_DataTable_NextRun: ReportingInApp_DataTable_NextRun,
    ReportingInApp_DataTable_ReportTitle: ReportingInApp_DataTable_ReportTitle,
    ReportingInApp_DataTable_ReportType: ReportingInApp_DataTable_ReportType,
    ReportingInApp_DataTable_Status: ReportingInApp_DataTable_Status,
    ReportingInApp_DataTable_TimePeriod: ReportingInApp_DataTable_TimePeriod,
    ReportingInApp_Downloads: ReportingInApp_Downloads,
    ReportingInApp_Downloads_Description: ReportingInApp_Downloads_Description,
    ReportingInApp_Downloads_RemovalNotice: ReportingInApp_Downloads_RemovalNotice,
    ReportingInApp_FileFormat_CommaDelimited: ReportingInApp_FileFormat_CommaDelimited,
    ReportingInApp_FileFormat_Excel: ReportingInApp_FileFormat_Excel,
    ReportingInApp_Filters_Button_Filter: ReportingInApp_Filters_Button_Filter,
    ReportingInApp_Filters_Modal_Button_AddColumn: ReportingInApp_Filters_Modal_Button_AddColumn,
    ReportingInApp_Filters_Modal_Button_Remove: ReportingInApp_Filters_Modal_Button_Remove,
    ReportingInApp_Filters_Modal_Header_Title: ReportingInApp_Filters_Modal_Header_Title,
    ReportingInApp_Filters_Modal_Header_Tooltip: ReportingInApp_Filters_Modal_Header_Tooltip,
    ReportingInApp_Filters_Modal_Hint_Number: ReportingInApp_Filters_Modal_Hint_Number,
    ReportingInApp_Filters_Modal_Hint_String: ReportingInApp_Filters_Modal_Hint_String,
    ReportingInApp_Filters_Modal_Label_Column: ReportingInApp_Filters_Modal_Label_Column,
    ReportingInApp_Filters_Modal_Label_Date: ReportingInApp_Filters_Modal_Label_Date,
    ReportingInApp_Filters_Modal_Label_Operator: ReportingInApp_Filters_Modal_Label_Operator,
    ReportingInApp_Filters_Modal_Label_Value: ReportingInApp_Filters_Modal_Label_Value,
    ReportingInApp_Filters_Modal_Operator_Contains: ReportingInApp_Filters_Modal_Operator_Contains,
    ReportingInApp_Filters_Modal_Operator_DoesNotEqual: ReportingInApp_Filters_Modal_Operator_DoesNotEqual,
    ReportingInApp_Filters_Modal_Operator_Empty: ReportingInApp_Filters_Modal_Operator_Empty,
    ReportingInApp_Filters_Modal_Operator_EndsWith: ReportingInApp_Filters_Modal_Operator_EndsWith,
    ReportingInApp_Filters_Modal_Operator_Equals: ReportingInApp_Filters_Modal_Operator_Equals,
    ReportingInApp_Filters_Modal_Operator_EqualsOrGreaterThan: ReportingInApp_Filters_Modal_Operator_EqualsOrGreaterThan,
    ReportingInApp_Filters_Modal_Operator_EqualsOrLessThan: ReportingInApp_Filters_Modal_Operator_EqualsOrLessThan,
    ReportingInApp_Filters_Modal_Operator_Exact: ReportingInApp_Filters_Modal_Operator_Exact,
    ReportingInApp_Filters_Modal_Operator_StartsWith: ReportingInApp_Filters_Modal_Operator_StartsWith,
    ReportingInApp_Filters_Modal_Placeholder_Column: ReportingInApp_Filters_Modal_Placeholder_Column,
    ReportingInApp_Filters_Modal_Placeholder_Operator: ReportingInApp_Filters_Modal_Placeholder_Operator,
    ReportingInApp_Filters_Modal_Placeholder_Value: ReportingInApp_Filters_Modal_Placeholder_Value,
    ReportingInApp_Filters_Modal_UnselectedColumn_Notice: ReportingInApp_Filters_Modal_UnselectedColumn_Notice,
    ReportingInApp_GeneratedReports: ReportingInApp_GeneratedReports,
    ReportingInApp_ReportCategories: ReportingInApp_ReportCategories,
    ReportingInApp_ReportCategory_ACM_Description: ReportingInApp_ReportCategory_ACM_Description,
    ReportingInApp_ReportCategory_ACM_Title: ReportingInApp_ReportCategory_ACM_Title,
    ReportingInApp_ReportCategory_Assignments_Description: ReportingInApp_ReportCategory_Assignments_Description,
    ReportingInApp_ReportCategory_Assignments_Title: ReportingInApp_ReportCategory_Assignments_Title,
    ReportingInApp_ReportCategory_Content_Description: ReportingInApp_ReportCategory_Content_Description,
    ReportingInApp_ReportCategory_Content_Title: ReportingInApp_ReportCategory_Content_Title,
    ReportingInApp_ReportCategory_Opportunities_Description: ReportingInApp_ReportCategory_Opportunities_Description,
    ReportingInApp_ReportCategory_Opportunities_Title: ReportingInApp_ReportCategory_Opportunities_Title,
    ReportingInApp_ReportCategory_Skills_Description: ReportingInApp_ReportCategory_Skills_Description,
    ReportingInApp_ReportCategory_Skills_Title: ReportingInApp_ReportCategory_Skills_Title,
    ReportingInApp_ReportCategory_User_Description: ReportingInApp_ReportCategory_User_Description,
    ReportingInApp_ReportCategory_User_Title: ReportingInApp_ReportCategory_User_Title,
    ReportingInApp_ReportCategorySection_Details_Description: ReportingInApp_ReportCategorySection_Details_Description,
    ReportingInApp_ReportCategorySection_Details_Title: ReportingInApp_ReportCategorySection_Details_Title,
    ReportingInApp_ReportCategorySection_Summary_Description: ReportingInApp_ReportCategorySection_Summary_Description,
    ReportingInApp_ReportCategorySection_Summary_Title: ReportingInApp_ReportCategorySection_Summary_Title,
    ReportingInApp_ReportColumn_AbsoluteParticipantCount: ReportingInApp_ReportColumn_AbsoluteParticipantCount,
    ReportingInApp_ReportColumn_AcademyId: ReportingInApp_ReportColumn_AcademyId,
    ReportingInApp_ReportColumn_AcademyName: ReportingInApp_ReportColumn_AcademyName,
    ReportingInApp_ReportColumn_AcademyProgressPercent: ReportingInApp_ReportColumn_AcademyProgressPercent,
    ReportingInApp_ReportColumn_AcademyTitle: ReportingInApp_ReportColumn_AcademyTitle,
    ReportingInApp_ReportColumn_AcademyUrl: ReportingInApp_ReportColumn_AcademyUrl,
    ReportingInApp_ReportColumn_Active: ReportingInApp_ReportColumn_Active,
    ReportingInApp_ReportColumn_AdditionalLearning: ReportingInApp_ReportColumn_AdditionalLearning,
    ReportingInApp_ReportColumn_ApplicationStage: ReportingInApp_ReportColumn_ApplicationStage,
    ReportingInApp_ReportColumn_ApplicationUrl: ReportingInApp_ReportColumn_ApplicationUrl,
    ReportingInApp_ReportColumn_Approver: ReportingInApp_ReportColumn_Approver,
    ReportingInApp_ReportColumn_ApproverEmail: ReportingInApp_ReportColumn_ApproverEmail,
    ReportingInApp_ReportColumn_ApproverFirstName: ReportingInApp_ReportColumn_ApproverFirstName,
    ReportingInApp_ReportColumn_ApproverId: ReportingInApp_ReportColumn_ApproverId,
    ReportingInApp_ReportColumn_ApproverLastName: ReportingInApp_ReportColumn_ApproverLastName,
    ReportingInApp_ReportColumn_ApproverName: ReportingInApp_ReportColumn_ApproverName,
    ReportingInApp_ReportColumn_AssignedDate: ReportingInApp_ReportColumn_AssignedDate,
    ReportingInApp_ReportColumn_AssigneeEmail: ReportingInApp_ReportColumn_AssigneeEmail,
    ReportingInApp_ReportColumn_AssigneeEmployeeId: ReportingInApp_ReportColumn_AssigneeEmployeeId,
    ReportingInApp_ReportColumn_AssigneeFirstName: ReportingInApp_ReportColumn_AssigneeFirstName,
    ReportingInApp_ReportColumn_AssigneeLastName: ReportingInApp_ReportColumn_AssigneeLastName,
    ReportingInApp_ReportColumn_AssigneeUserName: ReportingInApp_ReportColumn_AssigneeUserName,
    ReportingInApp_ReportColumn_AssignerEmail: ReportingInApp_ReportColumn_AssignerEmail,
    ReportingInApp_ReportColumn_AssignerEmployeeId: ReportingInApp_ReportColumn_AssignerEmployeeId,
    ReportingInApp_ReportColumn_AssignerFirstName: ReportingInApp_ReportColumn_AssignerFirstName,
    ReportingInApp_ReportColumn_AssignerLastName: ReportingInApp_ReportColumn_AssignerLastName,
    ReportingInApp_ReportColumn_AssignerUserName: ReportingInApp_ReportColumn_AssignerUserName,
    ReportingInApp_ReportColumn_AssignmentIsCompleted: ReportingInApp_ReportColumn_AssignmentIsCompleted,
    ReportingInApp_ReportColumn_AssignmentsCompleted: ReportingInApp_ReportColumn_AssignmentsCompleted,
    ReportingInApp_ReportColumn_AssinmentStatus: ReportingInApp_ReportColumn_AssinmentStatus,
    ReportingInApp_ReportColumn_AverageCompletionPercent: ReportingInApp_ReportColumn_AverageCompletionPercent,
    ReportingInApp_ReportColumn_AverageManagerRatingsAdded: ReportingInApp_ReportColumn_AverageManagerRatingsAdded,
    ReportingInApp_ReportColumn_AverageMangerRating: ReportingInApp_ReportColumn_AverageMangerRating,
    ReportingInApp_ReportColumn_AverageOptOutCount: ReportingInApp_ReportColumn_AverageOptOutCount,
    ReportingInApp_ReportColumn_AveragePeerRatings: ReportingInApp_ReportColumn_AveragePeerRatings,
    ReportingInApp_ReportColumn_AverageSelfRating: ReportingInApp_ReportColumn_AverageSelfRating,
    ReportingInApp_ReportColumn_AverageSkillTargetRating: ReportingInApp_ReportColumn_AverageSkillTargetRating,
    ReportingInApp_ReportColumn_AverageSkillTargetsAdded: ReportingInApp_ReportColumn_AverageSkillTargetsAdded,
    ReportingInApp_ReportColumn_AverageTeamFocusSkills: ReportingInApp_ReportColumn_AverageTeamFocusSkills,
    ReportingInApp_ReportColumn_AverageTeamSize: ReportingInApp_ReportColumn_AverageTeamSize,
    ReportingInApp_ReportColumn_BeingFollowedEmployeeId: ReportingInApp_ReportColumn_BeingFollowedEmployeeId,
    ReportingInApp_ReportColumn_BeingFollowedUserEmail: ReportingInApp_ReportColumn_BeingFollowedUserEmail,
    ReportingInApp_ReportColumn_BeingFollowedUserFirstName: ReportingInApp_ReportColumn_BeingFollowedUserFirstName,
    ReportingInApp_ReportColumn_BeingFollowedUserLastName: ReportingInApp_ReportColumn_BeingFollowedUserLastName,
    ReportingInApp_ReportColumn_BeingFollowedUserName: ReportingInApp_ReportColumn_BeingFollowedUserName,
    ReportingInApp_ReportColumn_Category: ReportingInApp_ReportColumn_Category,
    "ReportingInApp_ReportColumn_Category 1": "ReportingInApp_ReportColumn_Category 1",
    "ReportingInApp_ReportColumn_Category 10": "ReportingInApp_ReportColumn_Category 10",
    "ReportingInApp_ReportColumn_Category 11": "ReportingInApp_ReportColumn_Category 11",
    "ReportingInApp_ReportColumn_Category 12": "ReportingInApp_ReportColumn_Category 12",
    "ReportingInApp_ReportColumn_Category 13": "ReportingInApp_ReportColumn_Category 13",
    "ReportingInApp_ReportColumn_Category 14": "ReportingInApp_ReportColumn_Category 14",
    "ReportingInApp_ReportColumn_Category 15": "ReportingInApp_ReportColumn_Category 15",
    "ReportingInApp_ReportColumn_Category 2": "ReportingInApp_ReportColumn_Category 2",
    "ReportingInApp_ReportColumn_Category 3": "ReportingInApp_ReportColumn_Category 3",
    "ReportingInApp_ReportColumn_Category 4": "ReportingInApp_ReportColumn_Category 4",
    "ReportingInApp_ReportColumn_Category 5": "ReportingInApp_ReportColumn_Category 5",
    "ReportingInApp_ReportColumn_Category 6": "ReportingInApp_ReportColumn_Category 6",
    "ReportingInApp_ReportColumn_Category 7": "ReportingInApp_ReportColumn_Category 7",
    "ReportingInApp_ReportColumn_Category 8": "ReportingInApp_ReportColumn_Category 8",
    "ReportingInApp_ReportColumn_Category 9": "ReportingInApp_ReportColumn_Category 9",
    ReportingInApp_ReportColumn_Collaborators: ReportingInApp_ReportColumn_Collaborators,
    ReportingInApp_ReportColumn_CollaboratorsEmployeeId: ReportingInApp_ReportColumn_CollaboratorsEmployeeId,
    ReportingInApp_ReportColumn_CollaboratorsUserName: ReportingInApp_ReportColumn_CollaboratorsUserName,
    ReportingInApp_ReportColumn_CompletedContent: ReportingInApp_ReportColumn_CompletedContent,
    ReportingInApp_ReportColumn_CompletedCount: ReportingInApp_ReportColumn_CompletedCount,
    ReportingInApp_ReportColumn_CompletedDate: ReportingInApp_ReportColumn_CompletedDate,
    ReportingInApp_ReportColumn_CompletedOn: ReportingInApp_ReportColumn_CompletedOn,
    ReportingInApp_ReportColumn_CompletedRequiredContent: ReportingInApp_ReportColumn_CompletedRequiredContent,
    ReportingInApp_ReportColumn_CompletionCompletedDate: ReportingInApp_ReportColumn_CompletionCompletedDate,
    ReportingInApp_ReportColumn_CompletionCreatedDate: ReportingInApp_ReportColumn_CompletionCreatedDate,
    ReportingInApp_ReportColumn_CompletionDate: ReportingInApp_ReportColumn_CompletionDate,
    ReportingInApp_ReportColumn_CompletionIsVerified: ReportingInApp_ReportColumn_CompletionIsVerified,
    ReportingInApp_ReportColumn_CompletionPercent: ReportingInApp_ReportColumn_CompletionPercent,
    ReportingInApp_ReportColumn_CompletionPercentage: ReportingInApp_ReportColumn_CompletionPercentage,
    ReportingInApp_ReportColumn_CompletionPoints: ReportingInApp_ReportColumn_CompletionPoints,
    ReportingInApp_ReportColumn_Completions: ReportingInApp_ReportColumn_Completions,
    ReportingInApp_ReportColumn_CompletionTags: ReportingInApp_ReportColumn_CompletionTags,
    ReportingInApp_ReportColumn_CompletionUserRating: ReportingInApp_ReportColumn_CompletionUserRating,
    ReportingInApp_ReportColumn_ContentCompleted: ReportingInApp_ReportColumn_ContentCompleted,
    ReportingInApp_ReportColumn_ContentCompletedCount: ReportingInApp_ReportColumn_ContentCompletedCount,
    ReportingInApp_ReportColumn_ContentCompletedDate: ReportingInApp_ReportColumn_ContentCompletedDate,
    ReportingInApp_ReportColumn_ContentDescription: ReportingInApp_ReportColumn_ContentDescription,
    ReportingInApp_ReportColumn_ContentDuration: ReportingInApp_ReportColumn_ContentDuration,
    ReportingInApp_ReportColumn_ContentDurationType: ReportingInApp_ReportColumn_ContentDurationType,
    ReportingInApp_ReportColumn_ContentId: ReportingInApp_ReportColumn_ContentId,
    ReportingInApp_ReportColumn_ContentOwnerName: ReportingInApp_ReportColumn_ContentOwnerName,
    ReportingInApp_ReportColumn_ContentProvider: ReportingInApp_ReportColumn_ContentProvider,
    ReportingInApp_ReportColumn_ContentTitle: ReportingInApp_ReportColumn_ContentTitle,
    ReportingInApp_ReportColumn_ContentType: ReportingInApp_ReportColumn_ContentType,
    ReportingInApp_ReportColumn_ContentUrl: ReportingInApp_ReportColumn_ContentUrl,
    ReportingInApp_ReportColumn_Contributors: ReportingInApp_ReportColumn_Contributors,
    ReportingInApp_ReportColumn_Cost: ReportingInApp_ReportColumn_Cost,
    ReportingInApp_ReportColumn_CostCenter: ReportingInApp_ReportColumn_CostCenter,
    ReportingInApp_ReportColumn_CreatedBy: ReportingInApp_ReportColumn_CreatedBy,
    ReportingInApp_ReportColumn_CreatedByEmail: ReportingInApp_ReportColumn_CreatedByEmail,
    ReportingInApp_ReportColumn_CreatedByEmployeeId: ReportingInApp_ReportColumn_CreatedByEmployeeId,
    ReportingInApp_ReportColumn_CreatedByFirstName: ReportingInApp_ReportColumn_CreatedByFirstName,
    ReportingInApp_ReportColumn_CreatedById: ReportingInApp_ReportColumn_CreatedById,
    ReportingInApp_ReportColumn_CreatedByLastName: ReportingInApp_ReportColumn_CreatedByLastName,
    ReportingInApp_ReportColumn_CreatedByName: ReportingInApp_ReportColumn_CreatedByName,
    ReportingInApp_ReportColumn_CreatedByUserName: ReportingInApp_ReportColumn_CreatedByUserName,
    ReportingInApp_ReportColumn_CreatedDate: ReportingInApp_ReportColumn_CreatedDate,
    ReportingInApp_ReportColumn_CreatedDateOfOpportunity: ReportingInApp_ReportColumn_CreatedDateOfOpportunity,
    ReportingInApp_ReportColumn_CreatedOn: ReportingInApp_ReportColumn_CreatedOn,
    ReportingInApp_ReportColumn_Currency: ReportingInApp_ReportColumn_Currency,
    "ReportingInApp_ReportColumn_CurrentTotalUsers100%": "Total actuel d’utilisateurs \xe0 100\xa0%",
    ReportingInApp_ReportColumn_DailyDigestEmail: ReportingInApp_ReportColumn_DailyDigestEmail,
    ReportingInApp_ReportColumn_DateAdded: ReportingInApp_ReportColumn_DateAdded,
    ReportingInApp_ReportColumn_DateApprovedOrDeclined: ReportingInApp_ReportColumn_DateApprovedOrDeclined,
    ReportingInApp_ReportColumn_DateInvited: ReportingInApp_ReportColumn_DateInvited,
    ReportingInApp_ReportColumn_DateJoined: ReportingInApp_ReportColumn_DateJoined,
    ReportingInApp_ReportColumn_DateOfLastContentCompletion: ReportingInApp_ReportColumn_DateOfLastContentCompletion,
    ReportingInApp_ReportColumn_DateSearched: ReportingInApp_ReportColumn_DateSearched,
    ReportingInApp_ReportColumn_DateShared: ReportingInApp_ReportColumn_DateShared,
    ReportingInApp_ReportColumn_DateUserInterested: ReportingInApp_ReportColumn_DateUserInterested,
    ReportingInApp_ReportColumn_DateViewed: ReportingInApp_ReportColumn_DateViewed,
    ReportingInApp_ReportColumn_Department: ReportingInApp_ReportColumn_Department,
    ReportingInApp_ReportColumn_Description: ReportingInApp_ReportColumn_Description,
    ReportingInApp_ReportColumn_DirectReportEmail: ReportingInApp_ReportColumn_DirectReportEmail,
    ReportingInApp_ReportColumn_DirectReportFirstName: ReportingInApp_ReportColumn_DirectReportFirstName,
    ReportingInApp_ReportColumn_DirectReportId: ReportingInApp_ReportColumn_DirectReportId,
    ReportingInApp_ReportColumn_DirectReportLastName: ReportingInApp_ReportColumn_DirectReportLastName,
    ReportingInApp_ReportColumn_DirectReportName: ReportingInApp_ReportColumn_DirectReportName,
    ReportingInApp_ReportColumn_Discriminator: ReportingInApp_ReportColumn_Discriminator,
    ReportingInApp_ReportColumn_DueDate: ReportingInApp_ReportColumn_DueDate,
    ReportingInApp_ReportColumn_DueDateLocal: ReportingInApp_ReportColumn_DueDateLocal,
    ReportingInApp_ReportColumn_Duration: ReportingInApp_ReportColumn_Duration,
    ReportingInApp_ReportColumn_DurationInMinutes: ReportingInApp_ReportColumn_DurationInMinutes,
    ReportingInApp_ReportColumn_DurationUnitName: ReportingInApp_ReportColumn_DurationUnitName,
    ReportingInApp_ReportColumn_DurationUnits: ReportingInApp_ReportColumn_DurationUnits,
    ReportingInApp_ReportColumn_EmployeeId: ReportingInApp_ReportColumn_EmployeeId,
    ReportingInApp_ReportColumn_Endorsed: ReportingInApp_ReportColumn_Endorsed,
    ReportingInApp_ReportColumn_Enrolled: ReportingInApp_ReportColumn_Enrolled,
    ReportingInApp_ReportColumn_EnrolledUsers: ReportingInApp_ReportColumn_EnrolledUsers,
    ReportingInApp_ReportColumn_EstimatedLearningHours: ReportingInApp_ReportColumn_EstimatedLearningHours,
    ReportingInApp_ReportColumn_EstimatedLearningMinutes: ReportingInApp_ReportColumn_EstimatedLearningMinutes,
    ReportingInApp_ReportColumn_ExtractionDate: ReportingInApp_ReportColumn_ExtractionDate,
    ReportingInApp_ReportColumn_Feedback: ReportingInApp_ReportColumn_Feedback,
    ReportingInApp_ReportColumn_FirstLogin: ReportingInApp_ReportColumn_FirstLogin,
    ReportingInApp_ReportColumn_FollowerEmployeeId: ReportingInApp_ReportColumn_FollowerEmployeeId,
    ReportingInApp_ReportColumn_FollowerManagerId: ReportingInApp_ReportColumn_FollowerManagerId,
    ReportingInApp_ReportColumn_FollowerManagerName: ReportingInApp_ReportColumn_FollowerManagerName,
    ReportingInApp_ReportColumn_FollowerUserEmail: ReportingInApp_ReportColumn_FollowerUserEmail,
    ReportingInApp_ReportColumn_FollowerUserFirstName: ReportingInApp_ReportColumn_FollowerUserFirstName,
    ReportingInApp_ReportColumn_FollowerUserLastName: ReportingInApp_ReportColumn_FollowerUserLastName,
    ReportingInApp_ReportColumn_FollowerUserName: ReportingInApp_ReportColumn_FollowerUserName,
    ReportingInApp_ReportColumn_FollowerUserStatus: ReportingInApp_ReportColumn_FollowerUserStatus,
    ReportingInApp_ReportColumn_Group: ReportingInApp_ReportColumn_Group,
    "ReportingInApp_ReportColumn_Group 1": "ReportingInApp_ReportColumn_Group 1",
    "ReportingInApp_ReportColumn_Group 10": "ReportingInApp_ReportColumn_Group 10",
    "ReportingInApp_ReportColumn_Group 11": "ReportingInApp_ReportColumn_Group 11",
    "ReportingInApp_ReportColumn_Group 12": "ReportingInApp_ReportColumn_Group 12",
    "ReportingInApp_ReportColumn_Group 13": "ReportingInApp_ReportColumn_Group 13",
    "ReportingInApp_ReportColumn_Group 14": "ReportingInApp_ReportColumn_Group 14",
    "ReportingInApp_ReportColumn_Group 15": "ReportingInApp_ReportColumn_Group 15",
    "ReportingInApp_ReportColumn_Group 2": "ReportingInApp_ReportColumn_Group 2",
    "ReportingInApp_ReportColumn_Group 3": "ReportingInApp_ReportColumn_Group 3",
    "ReportingInApp_ReportColumn_Group 4": "ReportingInApp_ReportColumn_Group 4",
    "ReportingInApp_ReportColumn_Group 5": "ReportingInApp_ReportColumn_Group 5",
    "ReportingInApp_ReportColumn_Group 6": "ReportingInApp_ReportColumn_Group 6",
    "ReportingInApp_ReportColumn_Group 7": "ReportingInApp_ReportColumn_Group 7",
    "ReportingInApp_ReportColumn_Group 8": "ReportingInApp_ReportColumn_Group 8",
    "ReportingInApp_ReportColumn_Group 9": "ReportingInApp_ReportColumn_Group 9",
    ReportingInApp_ReportColumn_GroupName: ReportingInApp_ReportColumn_GroupName,
    ReportingInApp_ReportColumn_GroupRole: ReportingInApp_ReportColumn_GroupRole,
    ReportingInApp_ReportColumn_GroupsVisibility: ReportingInApp_ReportColumn_GroupsVisibility,
    ReportingInApp_ReportColumn_InterestedEmail: ReportingInApp_ReportColumn_InterestedEmail,
    ReportingInApp_ReportColumn_InterestedEmployeeId: ReportingInApp_ReportColumn_InterestedEmployeeId,
    ReportingInApp_ReportColumn_InterestedUserFirstName: ReportingInApp_ReportColumn_InterestedUserFirstName,
    ReportingInApp_ReportColumn_InterestedUserLastName: ReportingInApp_ReportColumn_InterestedUserLastName,
    ReportingInApp_ReportColumn_InterestedUserName: ReportingInApp_ReportColumn_InterestedUserName,
    ReportingInApp_ReportColumn_InterestedUserSkillMatch: ReportingInApp_ReportColumn_InterestedUserSkillMatch,
    ReportingInApp_ReportColumn_InterestedUserStage: ReportingInApp_ReportColumn_InterestedUserStage,
    ReportingInApp_ReportColumn_InternalExternalContent: ReportingInApp_ReportColumn_InternalExternalContent,
    ReportingInApp_ReportColumn_InternalId: ReportingInApp_ReportColumn_InternalId,
    ReportingInApp_ReportColumn_InternalManagerRatings: ReportingInApp_ReportColumn_InternalManagerRatings,
    ReportingInApp_ReportColumn_InternalSelfRatings: ReportingInApp_ReportColumn_InternalSelfRatings,
    ReportingInApp_ReportColumn_InternalSkillReviews: ReportingInApp_ReportColumn_InternalSkillReviews,
    ReportingInApp_ReportColumn_IsCompanySpecificProgram: ReportingInApp_ReportColumn_IsCompanySpecificProgram,
    ReportingInApp_ReportColumn_IsFollowing: ReportingInApp_ReportColumn_IsFollowing,
    ReportingInApp_ReportColumn_ItemId: ReportingInApp_ReportColumn_ItemId,
    ReportingInApp_ReportColumn_ItemName: ReportingInApp_ReportColumn_ItemName,
    ReportingInApp_ReportColumn_ItemType: ReportingInApp_ReportColumn_ItemType,
    ReportingInApp_ReportColumn_JobRole: ReportingInApp_ReportColumn_JobRole,
    ReportingInApp_ReportColumn_Language: ReportingInApp_ReportColumn_Language,
    ReportingInApp_ReportColumn_LastLogin: ReportingInApp_ReportColumn_LastLogin,
    ReportingInApp_ReportColumn_LastRatedDate: ReportingInApp_ReportColumn_LastRatedDate,
    ReportingInApp_ReportColumn_LastUpdated: ReportingInApp_ReportColumn_LastUpdated,
    ReportingInApp_ReportColumn_LastUpdateDate: ReportingInApp_ReportColumn_LastUpdateDate,
    ReportingInApp_ReportColumn_LastUpdatedOfOpportunity: ReportingInApp_ReportColumn_LastUpdatedOfOpportunity,
    ReportingInApp_ReportColumn_LatestCompletionDate: ReportingInApp_ReportColumn_LatestCompletionDate,
    ReportingInApp_ReportColumn_LearnerStatus: ReportingInApp_ReportColumn_LearnerStatus,
    ReportingInApp_ReportColumn_LessonDescription: ReportingInApp_ReportColumn_LessonDescription,
    ReportingInApp_ReportColumn_LessonNumber: ReportingInApp_ReportColumn_LessonNumber,
    ReportingInApp_ReportColumn_LessonTitle: ReportingInApp_ReportColumn_LessonTitle,
    ReportingInApp_ReportColumn_Location: ReportingInApp_ReportColumn_Location,
    ReportingInApp_ReportColumn_LoggedInDate: ReportingInApp_ReportColumn_LoggedInDate,
    ReportingInApp_ReportColumn_ManagerCount: ReportingInApp_ReportColumn_ManagerCount,
    ReportingInApp_ReportColumn_ManagerEmail: ReportingInApp_ReportColumn_ManagerEmail,
    ReportingInApp_ReportColumn_ManagerEmployeeId: ReportingInApp_ReportColumn_ManagerEmployeeId,
    ReportingInApp_ReportColumn_ManagerFirstName: ReportingInApp_ReportColumn_ManagerFirstName,
    ReportingInApp_ReportColumn_ManagerId: ReportingInApp_ReportColumn_ManagerId,
    ReportingInApp_ReportColumn_ManagerLastName: ReportingInApp_ReportColumn_ManagerLastName,
    ReportingInApp_ReportColumn_ManagerName: ReportingInApp_ReportColumn_ManagerName,
    ReportingInApp_ReportColumn_ManagerRating: ReportingInApp_ReportColumn_ManagerRating,
    ReportingInApp_ReportColumn_ManagerRatingAverage: ReportingInApp_ReportColumn_ManagerRatingAverage,
    ReportingInApp_ReportColumn_MarketplaceTitle: ReportingInApp_ReportColumn_MarketplaceTitle,
    ReportingInApp_ReportColumn_MenteeEmail: ReportingInApp_ReportColumn_MenteeEmail,
    ReportingInApp_ReportColumn_MenteeEmployeeId: ReportingInApp_ReportColumn_MenteeEmployeeId,
    ReportingInApp_ReportColumn_MenteeUserFirstName: ReportingInApp_ReportColumn_MenteeUserFirstName,
    ReportingInApp_ReportColumn_MenteeUserLastName: ReportingInApp_ReportColumn_MenteeUserLastName,
    ReportingInApp_ReportColumn_MenteeUserName: ReportingInApp_ReportColumn_MenteeUserName,
    ReportingInApp_ReportColumn_MentorEmployeeId: ReportingInApp_ReportColumn_MentorEmployeeId,
    ReportingInApp_ReportColumn_MentorUserEmail: ReportingInApp_ReportColumn_MentorUserEmail,
    ReportingInApp_ReportColumn_MentorUserFirstName: ReportingInApp_ReportColumn_MentorUserFirstName,
    ReportingInApp_ReportColumn_MentorUserLastName: ReportingInApp_ReportColumn_MentorUserLastName,
    ReportingInApp_ReportColumn_MentorUserName: ReportingInApp_ReportColumn_MentorUserName,
    ReportingInApp_ReportColumn_Nominated: ReportingInApp_ReportColumn_Nominated,
    ReportingInApp_ReportColumn_NoReply: ReportingInApp_ReportColumn_NoReply,
    ReportingInApp_ReportColumn_NumberOfInterestedCandidates: ReportingInApp_ReportColumn_NumberOfInterestedCandidates,
    ReportingInApp_ReportColumn_NumberOfMatchedCandidates: ReportingInApp_ReportColumn_NumberOfMatchedCandidates,
    ReportingInApp_ReportColumn_NumberOfRequiredSkills: ReportingInApp_ReportColumn_NumberOfRequiredSkills,
    ReportingInApp_ReportColumn_NumberOfSelectedCandidates: ReportingInApp_ReportColumn_NumberOfSelectedCandidates,
    ReportingInApp_ReportColumn_NumberOfShares: ReportingInApp_ReportColumn_NumberOfShares,
    ReportingInApp_ReportColumn_NumberOfShortlistedCandidates: ReportingInApp_ReportColumn_NumberOfShortlistedCandidates,
    ReportingInApp_ReportColumn_OpportunityDescription: ReportingInApp_ReportColumn_OpportunityDescription,
    ReportingInApp_ReportColumn_OpportunityId: ReportingInApp_ReportColumn_OpportunityId,
    ReportingInApp_ReportColumn_OpportunityIsObsolete: ReportingInApp_ReportColumn_OpportunityIsObsolete,
    ReportingInApp_ReportColumn_OpportunityOwnerEmployeeId: ReportingInApp_ReportColumn_OpportunityOwnerEmployeeId,
    ReportingInApp_ReportColumn_OpportunityOwnerUserName: ReportingInApp_ReportColumn_OpportunityOwnerUserName,
    ReportingInApp_ReportColumn_OpportunitySkills: ReportingInApp_ReportColumn_OpportunitySkills,
    ReportingInApp_ReportColumn_OpportunityStatus: ReportingInApp_ReportColumn_OpportunityStatus,
    ReportingInApp_ReportColumn_OpportunityTitle: ReportingInApp_ReportColumn_OpportunityTitle,
    ReportingInApp_ReportColumn_OpportunityType: ReportingInApp_ReportColumn_OpportunityType,
    ReportingInApp_ReportColumn_OpportunityUrl: ReportingInApp_ReportColumn_OpportunityUrl,
    ReportingInApp_ReportColumn_OpportunityVisibility: ReportingInApp_ReportColumn_OpportunityVisibility,
    ReportingInApp_ReportColumn_OptOut: ReportingInApp_ReportColumn_OptOut,
    ReportingInApp_ReportColumn_OptOutCount: ReportingInApp_ReportColumn_OptOutCount,
    ReportingInApp_ReportColumn_Order: ReportingInApp_ReportColumn_Order,
    ReportingInApp_ReportColumn_PathwayCompletedCount: ReportingInApp_ReportColumn_PathwayCompletedCount,
    ReportingInApp_ReportColumn_PathwayContentCount: ReportingInApp_ReportColumn_PathwayContentCount,
    ReportingInApp_ReportColumn_PathwayFollowDate: ReportingInApp_ReportColumn_PathwayFollowDate,
    ReportingInApp_ReportColumn_PathwayFollowedCount: ReportingInApp_ReportColumn_PathwayFollowedCount,
    ReportingInApp_ReportColumn_PathwayId: ReportingInApp_ReportColumn_PathwayId,
    ReportingInApp_ReportColumn_PathwayProgress: ReportingInApp_ReportColumn_PathwayProgress,
    ReportingInApp_ReportColumn_PathwayRequiredContentCount: ReportingInApp_ReportColumn_PathwayRequiredContentCount,
    ReportingInApp_ReportColumn_Pathways: ReportingInApp_ReportColumn_Pathways,
    ReportingInApp_ReportColumn_PathwayTitle: ReportingInApp_ReportColumn_PathwayTitle,
    ReportingInApp_ReportColumn_PathwayTopic: ReportingInApp_ReportColumn_PathwayTopic,
    ReportingInApp_ReportColumn_PathwayType: ReportingInApp_ReportColumn_PathwayType,
    ReportingInApp_ReportColumn_PathwayUrl: ReportingInApp_ReportColumn_PathwayUrl,
    ReportingInApp_ReportColumn_PathwayUserCount: ReportingInApp_ReportColumn_PathwayUserCount,
    ReportingInApp_ReportColumn_PeerRatings: ReportingInApp_ReportColumn_PeerRatings,
    ReportingInApp_ReportColumn_PercentOfSkillsMatched: ReportingInApp_ReportColumn_PercentOfSkillsMatched,
    ReportingInApp_ReportColumn_PermissionRole: ReportingInApp_ReportColumn_PermissionRole,
    ReportingInApp_ReportColumn_PlanFollowedCount: ReportingInApp_ReportColumn_PlanFollowedCount,
    ReportingInApp_ReportColumn_PlanId: ReportingInApp_ReportColumn_PlanId,
    ReportingInApp_ReportColumn_Plans: ReportingInApp_ReportColumn_Plans,
    ReportingInApp_ReportColumn_PlanTitle: ReportingInApp_ReportColumn_PlanTitle,
    ReportingInApp_ReportColumn_PlanType: ReportingInApp_ReportColumn_PlanType,
    ReportingInApp_ReportColumn_PlanUrl: ReportingInApp_ReportColumn_PlanUrl,
    ReportingInApp_ReportColumn_PreapprovalRequired: ReportingInApp_ReportColumn_PreapprovalRequired,
    ReportingInApp_ReportColumn_ProfilePrivacy: ReportingInApp_ReportColumn_ProfilePrivacy,
    ReportingInApp_ReportColumn_ProgramCostAmount: ReportingInApp_ReportColumn_ProgramCostAmount,
    ReportingInApp_ReportColumn_ProgramCostCurrency: ReportingInApp_ReportColumn_ProgramCostCurrency,
    ReportingInApp_ReportColumn_ProgramDuration: ReportingInApp_ReportColumn_ProgramDuration,
    ReportingInApp_ReportColumn_ProgramDurationUnit: ReportingInApp_ReportColumn_ProgramDurationUnit,
    ReportingInApp_ReportColumn_ProgramId: ReportingInApp_ReportColumn_ProgramId,
    ReportingInApp_ReportColumn_ProgramLength: ReportingInApp_ReportColumn_ProgramLength,
    ReportingInApp_ReportColumn_ProgramLengthUnit: ReportingInApp_ReportColumn_ProgramLengthUnit,
    ReportingInApp_ReportColumn_ProgramName: ReportingInApp_ReportColumn_ProgramName,
    ReportingInApp_ReportColumn_ProgramTitle: ReportingInApp_ReportColumn_ProgramTitle,
    ReportingInApp_ReportColumn_Provider: ReportingInApp_ReportColumn_Provider,
    ReportingInApp_ReportColumn_ProviderName: ReportingInApp_ReportColumn_ProviderName,
    ReportingInApp_ReportColumn_PublishedDate: ReportingInApp_ReportColumn_PublishedDate,
    ReportingInApp_ReportColumn_RealTimeEmailNotification: ReportingInApp_ReportColumn_RealTimeEmailNotification,
    ReportingInApp_ReportColumn_RecipientEmail: ReportingInApp_ReportColumn_RecipientEmail,
    ReportingInApp_ReportColumn_RecipientEmployeeId: ReportingInApp_ReportColumn_RecipientEmployeeId,
    ReportingInApp_ReportColumn_RecipientGroupName: ReportingInApp_ReportColumn_RecipientGroupName,
    ReportingInApp_ReportColumn_RecipientUserFirstName: ReportingInApp_ReportColumn_RecipientUserFirstName,
    ReportingInApp_ReportColumn_RecipientUserLastName: ReportingInApp_ReportColumn_RecipientUserLastName,
    ReportingInApp_ReportColumn_RecipientUserName: ReportingInApp_ReportColumn_RecipientUserName,
    ReportingInApp_ReportColumn_RecommendationType: ReportingInApp_ReportColumn_RecommendationType,
    ReportingInApp_ReportColumn_RepliedNo: ReportingInApp_ReportColumn_RepliedNo,
    ReportingInApp_ReportColumn_RepliedYes: ReportingInApp_ReportColumn_RepliedYes,
    ReportingInApp_ReportColumn_RequestedAmount: ReportingInApp_ReportColumn_RequestedAmount,
    ReportingInApp_ReportColumn_RequestedAmountCurrency: ReportingInApp_ReportColumn_RequestedAmountCurrency,
    ReportingInApp_ReportColumn_RequestedAmountUSD: ReportingInApp_ReportColumn_RequestedAmountUSD,
    ReportingInApp_ReportColumn_RequestedDate: ReportingInApp_ReportColumn_RequestedDate,
    ReportingInApp_ReportColumn_RequestId: ReportingInApp_ReportColumn_RequestId,
    ReportingInApp_ReportColumn_RequestType: ReportingInApp_ReportColumn_RequestType,
    ReportingInApp_ReportColumn_Required: ReportingInApp_ReportColumn_Required,
    ReportingInApp_ReportColumn_RequiredSkill: ReportingInApp_ReportColumn_RequiredSkill,
    ReportingInApp_ReportColumn_ResourceId: ReportingInApp_ReportColumn_ResourceId,
    ReportingInApp_ReportColumn_ResourceTitle: ReportingInApp_ReportColumn_ResourceTitle,
    ReportingInApp_ReportColumn_ResourceType: ReportingInApp_ReportColumn_ResourceType,
    ReportingInApp_ReportColumn_ResourceUrl: ReportingInApp_ReportColumn_ResourceUrl,
    ReportingInApp_ReportColumn_RestrictedAccess: ReportingInApp_ReportColumn_RestrictedAccess,
    ReportingInApp_ReportColumn_RsvpStatus: ReportingInApp_ReportColumn_RsvpStatus,
    ReportingInApp_ReportColumn_SearchCount: ReportingInApp_ReportColumn_SearchCount,
    ReportingInApp_ReportColumn_SearchTerm: ReportingInApp_ReportColumn_SearchTerm,
    ReportingInApp_ReportColumn_SectionContentCount: ReportingInApp_ReportColumn_SectionContentCount,
    ReportingInApp_ReportColumn_SectionDescription: ReportingInApp_ReportColumn_SectionDescription,
    ReportingInApp_ReportColumn_SectionNumber: ReportingInApp_ReportColumn_SectionNumber,
    ReportingInApp_ReportColumn_SectionOrder: ReportingInApp_ReportColumn_SectionOrder,
    ReportingInApp_ReportColumn_SectionTitle: ReportingInApp_ReportColumn_SectionTitle,
    ReportingInApp_ReportColumn_SegmentName: ReportingInApp_ReportColumn_SegmentName,
    ReportingInApp_ReportColumn_SelfRating: ReportingInApp_ReportColumn_SelfRating,
    ReportingInApp_ReportColumn_SelfRatingAverage: ReportingInApp_ReportColumn_SelfRatingAverage,
    ReportingInApp_ReportColumn_SharedByEmail: ReportingInApp_ReportColumn_SharedByEmail,
    ReportingInApp_ReportColumn_SharedByEmployeeId: ReportingInApp_ReportColumn_SharedByEmployeeId,
    ReportingInApp_ReportColumn_SharedByFirstName: ReportingInApp_ReportColumn_SharedByFirstName,
    ReportingInApp_ReportColumn_SharedByLastName: ReportingInApp_ReportColumn_SharedByLastName,
    ReportingInApp_ReportColumn_SharedByUserName: ReportingInApp_ReportColumn_SharedByUserName,
    ReportingInApp_ReportColumn_ShareStatus: ReportingInApp_ReportColumn_ShareStatus,
    ReportingInApp_ReportColumn_SkillAddedCount: ReportingInApp_ReportColumn_SkillAddedCount,
    ReportingInApp_ReportColumn_SkillCertificationRating: ReportingInApp_ReportColumn_SkillCertificationRating,
    ReportingInApp_ReportColumn_SkillFocusCount: ReportingInApp_ReportColumn_SkillFocusCount,
    ReportingInApp_ReportColumn_SkillFocusedDate: ReportingInApp_ReportColumn_SkillFocusedDate,
    ReportingInApp_ReportColumn_SkillFollowDate: ReportingInApp_ReportColumn_SkillFollowDate,
    ReportingInApp_ReportColumn_SkillFollowedDate: ReportingInApp_ReportColumn_SkillFollowedDate,
    ReportingInApp_ReportColumn_SkillIsFocused: ReportingInApp_ReportColumn_SkillIsFocused,
    ReportingInApp_ReportColumn_SkillLevelAverage: ReportingInApp_ReportColumn_SkillLevelAverage,
    ReportingInApp_ReportColumn_SkillName: ReportingInApp_ReportColumn_SkillName,
    ReportingInApp_ReportColumn_SkillRatedCount: ReportingInApp_ReportColumn_SkillRatedCount,
    ReportingInApp_ReportColumn_SkillRatedDate: ReportingInApp_ReportColumn_SkillRatedDate,
    ReportingInApp_ReportColumn_SkillRating: ReportingInApp_ReportColumn_SkillRating,
    ReportingInApp_ReportColumn_SkillRatingLabel: ReportingInApp_ReportColumn_SkillRatingLabel,
    ReportingInApp_ReportColumn_SkillRatingPrivacy: ReportingInApp_ReportColumn_SkillRatingPrivacy,
    ReportingInApp_ReportColumn_SkillRatingType: ReportingInApp_ReportColumn_SkillRatingType,
    ReportingInApp_ReportColumn_SkillReviewAverage: ReportingInApp_ReportColumn_SkillReviewAverage,
    ReportingInApp_ReportColumn_Skills: ReportingInApp_ReportColumn_Skills,
    ReportingInApp_ReportColumn_SkillStandardName: ReportingInApp_ReportColumn_SkillStandardName,
    ReportingInApp_ReportColumn_Source: ReportingInApp_ReportColumn_Source,
    ReportingInApp_ReportColumn_StartDate: ReportingInApp_ReportColumn_StartDate,
    ReportingInApp_ReportColumn_Status: ReportingInApp_ReportColumn_Status,
    ReportingInApp_ReportColumn_StatusChangeDate: ReportingInApp_ReportColumn_StatusChangeDate,
    ReportingInApp_ReportColumn_StepNumber: ReportingInApp_ReportColumn_StepNumber,
    ReportingInApp_ReportColumn_StepTitle: ReportingInApp_ReportColumn_StepTitle,
    ReportingInApp_ReportColumn_StepType: ReportingInApp_ReportColumn_StepType,
    ReportingInApp_ReportColumn_SubmissionType: ReportingInApp_ReportColumn_SubmissionType,
    ReportingInApp_ReportColumn_Summary: ReportingInApp_ReportColumn_Summary,
    ReportingInApp_ReportColumn_TargetFollowDate: ReportingInApp_ReportColumn_TargetFollowDate,
    ReportingInApp_ReportColumn_TargetLevel: ReportingInApp_ReportColumn_TargetLevel,
    ReportingInApp_ReportColumn_TargetRating: ReportingInApp_ReportColumn_TargetRating,
    ReportingInApp_ReportColumn_TeamFocusSkillList: ReportingInApp_ReportColumn_TeamFocusSkillList,
    ReportingInApp_ReportColumn_TeamFocusSkillsRatings: ReportingInApp_ReportColumn_TeamFocusSkillsRatings,
    ReportingInApp_ReportColumn_TeamSize: ReportingInApp_ReportColumn_TeamSize,
    ReportingInApp_ReportColumn_TextResponse: ReportingInApp_ReportColumn_TextResponse,
    ReportingInApp_ReportColumn_ThumbnailUrl: ReportingInApp_ReportColumn_ThumbnailUrl,
    ReportingInApp_ReportColumn_ThumbsDown: ReportingInApp_ReportColumn_ThumbsDown,
    ReportingInApp_ReportColumn_ThumbsUp: ReportingInApp_ReportColumn_ThumbsUp,
    ReportingInApp_ReportColumn_Title: ReportingInApp_ReportColumn_Title,
    ReportingInApp_ReportColumn_TotalAcademyContent: ReportingInApp_ReportColumn_TotalAcademyContent,
    ReportingInApp_ReportColumn_TotalAssignments: ReportingInApp_ReportColumn_TotalAssignments,
    ReportingInApp_ReportColumn_TotalDailyLogins: ReportingInApp_ReportColumn_TotalDailyLogins,
    ReportingInApp_ReportColumn_TotalLearningHours: ReportingInApp_ReportColumn_TotalLearningHours,
    ReportingInApp_ReportColumn_TotalLearningMinutes: ReportingInApp_ReportColumn_TotalLearningMinutes,
    ReportingInApp_ReportColumn_TotalManagerRatings: ReportingInApp_ReportColumn_TotalManagerRatings,
    ReportingInApp_ReportColumn_TotalManagerRatingsAdded: ReportingInApp_ReportColumn_TotalManagerRatingsAdded,
    ReportingInApp_ReportColumn_TotalPathwayContent: ReportingInApp_ReportColumn_TotalPathwayContent,
    ReportingInApp_ReportColumn_TotalPeerRatings: ReportingInApp_ReportColumn_TotalPeerRatings,
    ReportingInApp_ReportColumn_TotalPoints: ReportingInApp_ReportColumn_TotalPoints,
    ReportingInApp_ReportColumn_TotalRequiredPathwayContent: ReportingInApp_ReportColumn_TotalRequiredPathwayContent,
    ReportingInApp_ReportColumn_TotalSelfRatings: ReportingInApp_ReportColumn_TotalSelfRatings,
    ReportingInApp_ReportColumn_TotalSkillReviews: ReportingInApp_ReportColumn_TotalSkillReviews,
    ReportingInApp_ReportColumn_TotalSkillsFocused: ReportingInApp_ReportColumn_TotalSkillsFocused,
    ReportingInApp_ReportColumn_TotalSkillsFollowed: ReportingInApp_ReportColumn_TotalSkillsFollowed,
    ReportingInApp_ReportColumn_TotalSkillTargetsAdded: ReportingInApp_ReportColumn_TotalSkillTargetsAdded,
    ReportingInApp_ReportColumn_TotalTeamFocusSkills: ReportingInApp_ReportColumn_TotalTeamFocusSkills,
    ReportingInApp_ReportColumn_TotalUsersActive: ReportingInApp_ReportColumn_TotalUsersActive,
    ReportingInApp_ReportColumn_TotalUsersActiveInAcademy: ReportingInApp_ReportColumn_TotalUsersActiveInAcademy,
    ReportingInApp_ReportColumn_Type: ReportingInApp_ReportColumn_Type,
    ReportingInApp_ReportColumn_UnmatchedSkills: ReportingInApp_ReportColumn_UnmatchedSkills,
    ReportingInApp_ReportColumn_Url: ReportingInApp_ReportColumn_Url,
    ReportingInApp_ReportColumn_UserCompanyId: ReportingInApp_ReportColumn_UserCompanyId,
    ReportingInApp_ReportColumn_UserCompletionStatus: ReportingInApp_ReportColumn_UserCompletionStatus,
    ReportingInApp_ReportColumn_UserCreatedDate: ReportingInApp_ReportColumn_UserCreatedDate,
    ReportingInApp_ReportColumn_UserEmail: ReportingInApp_ReportColumn_UserEmail,
    ReportingInApp_ReportColumn_UserFirstName: ReportingInApp_ReportColumn_UserFirstName,
    ReportingInApp_ReportColumn_UserId: ReportingInApp_ReportColumn_UserId,
    ReportingInApp_ReportColumn_UserLastName: ReportingInApp_ReportColumn_UserLastName,
    ReportingInApp_ReportColumn_UserName: ReportingInApp_ReportColumn_UserName,
    ReportingInApp_ReportColumn_UserNote: ReportingInApp_ReportColumn_UserNote,
    ReportingInApp_ReportColumn_UserPlanStatus: ReportingInApp_ReportColumn_UserPlanStatus,
    ReportingInApp_ReportColumn_UsersAddingSkills: ReportingInApp_ReportColumn_UsersAddingSkills,
    ReportingInApp_ReportColumn_UsersCompletingContent: ReportingInApp_ReportColumn_UsersCompletingContent,
    ReportingInApp_ReportColumn_UsersCompletingPathways: ReportingInApp_ReportColumn_UsersCompletingPathways,
    ReportingInApp_ReportColumn_UsersFollowingPathways: ReportingInApp_ReportColumn_UsersFollowingPathways,
    ReportingInApp_ReportColumn_UsersFollowingPlans: ReportingInApp_ReportColumn_UsersFollowingPlans,
    ReportingInApp_ReportColumn_UsersRatingSkills: ReportingInApp_ReportColumn_UsersRatingSkills,
    ReportingInApp_ReportColumn_UserStatus: ReportingInApp_ReportColumn_UserStatus,
    ReportingInApp_ReportColumn_UserTopics: ReportingInApp_ReportColumn_UserTopics,
    ReportingInApp_ReportColumn_VerifiedLearningHours: ReportingInApp_ReportColumn_VerifiedLearningHours,
    ReportingInApp_ReportColumn_VerifiedLearningMinutes: ReportingInApp_ReportColumn_VerifiedLearningMinutes,
    ReportingInApp_ReportColumn_ViewCountAndroid: ReportingInApp_ReportColumn_ViewCountAndroid,
    ReportingInApp_ReportColumn_ViewCountAndroidApp: ReportingInApp_ReportColumn_ViewCountAndroidApp,
    ReportingInApp_ReportColumn_ViewCountAndroidBrowser: ReportingInApp_ReportColumn_ViewCountAndroidBrowser,
    ReportingInApp_ReportColumn_ViewCountDesktop: ReportingInApp_ReportColumn_ViewCountDesktop,
    ReportingInApp_ReportColumn_ViewCountIos: ReportingInApp_ReportColumn_ViewCountIos,
    ReportingInApp_ReportColumn_ViewCountIOSApp: ReportingInApp_ReportColumn_ViewCountIOSApp,
    ReportingInApp_ReportColumn_ViewCountIOSBrowser: ReportingInApp_ReportColumn_ViewCountIOSBrowser,
    ReportingInApp_ReportColumn_ViewCountWeb: ReportingInApp_ReportColumn_ViewCountWeb,
    ReportingInApp_ReportColumn_ViewedDate: ReportingInApp_ReportColumn_ViewedDate,
    ReportingInApp_ReportColumn_Visibility: ReportingInApp_ReportColumn_Visibility,
    ReportingInApp_ReportColumn_WeeklyDigestEmail: ReportingInApp_ReportColumn_WeeklyDigestEmail,
    ReportingInApp_ReportGenerate_FileFormat_Label: ReportingInApp_ReportGenerate_FileFormat_Label,
    ReportingInApp_ReportGenerate_FileFormatRowLimitWarning: ReportingInApp_ReportGenerate_FileFormatRowLimitWarning,
    ReportingInApp_ReportGenerate_Header: ReportingInApp_ReportGenerate_Header,
    ReportingInApp_ReportGenerate_SavePreset_Label: ReportingInApp_ReportGenerate_SavePreset_Label,
    ReportingInApp_ReportGenerate_SubmitButton: ReportingInApp_ReportGenerate_SubmitButton,
    ReportingInApp_ReportPreview: ReportingInApp_ReportPreview,
    ReportingInApp_ReportPreview_ChangeColumns: ReportingInApp_ReportPreview_ChangeColumns,
    ReportingInApp_ReportPreview_DownloadNotificationMessage: ReportingInApp_ReportPreview_DownloadNotificationMessage,
    ReportingInApp_ReportPreview_PreviewingRowsOfFormat: ReportingInApp_ReportPreview_PreviewingRowsOfFormat,
    ReportingInApp_ReportPreview_UseCustomDateRange: ReportingInApp_ReportPreview_UseCustomDateRange,
    ReportingInApp_ReportPreview_UTCDatesNote: ReportingInApp_ReportPreview_UTCDatesNote,
    ReportingInApp_Reports: ReportingInApp_Reports,
    ReportingInApp_ReportType_AcademiesContentCompletionOverview_Description: ReportingInApp_ReportType_AcademiesContentCompletionOverview_Description,
    ReportingInApp_ReportType_AcademiesContentCompletionOverview_Title: ReportingInApp_ReportType_AcademiesContentCompletionOverview_Title,
    ReportingInApp_ReportType_AcademiesDetailedByUser_Description: ReportingInApp_ReportType_AcademiesDetailedByUser_Description,
    ReportingInApp_ReportType_AcademiesDetailedByUser_Title: ReportingInApp_ReportType_AcademiesDetailedByUser_Title,
    ReportingInApp_ReportType_AcademiesLastLogin_Description: ReportingInApp_ReportType_AcademiesLastLogin_Description,
    ReportingInApp_ReportType_AcademiesLastLogin_Title: ReportingInApp_ReportType_AcademiesLastLogin_Title,
    ReportingInApp_ReportType_AcademiesMarketplaceProgramStatus_Description: ReportingInApp_ReportType_AcademiesMarketplaceProgramStatus_Description,
    ReportingInApp_ReportType_AcademiesMarketplaceProgramStatus_Title: ReportingInApp_ReportType_AcademiesMarketplaceProgramStatus_Title,
    ReportingInApp_ReportType_AcademiesProgressByUser_Description: ReportingInApp_ReportType_AcademiesProgressByUser_Description,
    ReportingInApp_ReportType_AcademiesProgressByUser_Title: ReportingInApp_ReportType_AcademiesProgressByUser_Title,
    ReportingInApp_ReportType_AcademiesSummaryByAcademy_Description: ReportingInApp_ReportType_AcademiesSummaryByAcademy_Description,
    ReportingInApp_ReportType_AcademiesSummaryByAcademy_Title: ReportingInApp_ReportType_AcademiesSummaryByAcademy_Title,
    ReportingInApp_ReportType_AcademiesSummaryByUser_Description: ReportingInApp_ReportType_AcademiesSummaryByUser_Description,
    ReportingInApp_ReportType_AcademiesSummaryByUser_Title: ReportingInApp_ReportType_AcademiesSummaryByUser_Title,
    ReportingInApp_ReportType_AcademyAndMarketplaceLoginsSummary_Description: ReportingInApp_ReportType_AcademyAndMarketplaceLoginsSummary_Description,
    ReportingInApp_ReportType_AcademyAndMarketplaceLoginsSummary_Title: ReportingInApp_ReportType_AcademyAndMarketplaceLoginsSummary_Title,
    ReportingInApp_ReportType_AcademyCompletionsByUser_Description: ReportingInApp_ReportType_AcademyCompletionsByUser_Description,
    ReportingInApp_ReportType_AcademyCompletionsByUser_Title: ReportingInApp_ReportType_AcademyCompletionsByUser_Title,
    ReportingInApp_ReportType_AcademyProjectsDetailedByUser_Description: ReportingInApp_ReportType_AcademyProjectsDetailedByUser_Description,
    ReportingInApp_ReportType_AcademyProjectsDetailedByUser_Title: ReportingInApp_ReportType_AcademyProjectsDetailedByUser_Title,
    ReportingInApp_ReportType_ActiveOpportunitiesDetailed_Description: ReportingInApp_ReportType_ActiveOpportunitiesDetailed_Description,
    ReportingInApp_ReportType_ActiveOpportunitiesDetailed_Title: ReportingInApp_ReportType_ActiveOpportunitiesDetailed_Title,
    ReportingInApp_ReportType_ApprovalsDetailedByUser_Description: ReportingInApp_ReportType_ApprovalsDetailedByUser_Description,
    ReportingInApp_ReportType_ApprovalsDetailedByUser_Title: ReportingInApp_ReportType_ApprovalsDetailedByUser_Title,
    ReportingInApp_ReportType_AssignmentActivityEmployee_Description: ReportingInApp_ReportType_AssignmentActivityEmployee_Description,
    ReportingInApp_ReportType_AssignmentActivityEmployee_Title: ReportingInApp_ReportType_AssignmentActivityEmployee_Title,
    ReportingInApp_ReportType_AssignmentsByUser_Description: ReportingInApp_ReportType_AssignmentsByUser_Description,
    ReportingInApp_ReportType_AssignmentsByUser_Title: ReportingInApp_ReportType_AssignmentsByUser_Title,
    ReportingInApp_ReportType_CompletionActivityUser_Description: ReportingInApp_ReportType_CompletionActivityUser_Description,
    ReportingInApp_ReportType_CompletionActivityUser_Title: ReportingInApp_ReportType_CompletionActivityUser_Title,
    ReportingInApp_ReportType_CompletionsByUser_Description: ReportingInApp_ReportType_CompletionsByUser_Description,
    ReportingInApp_ReportType_CompletionsByUser_Title: ReportingInApp_ReportType_CompletionsByUser_Title,
    ReportingInApp_ReportType_ContentCatalog_Description: ReportingInApp_ReportType_ContentCatalog_Description,
    ReportingInApp_ReportType_ContentCatalog_Title: ReportingInApp_ReportType_ContentCatalog_Title,
    ReportingInApp_ReportType_ContentView_Description: ReportingInApp_ReportType_ContentView_Description,
    ReportingInApp_ReportType_ContentView_Title: ReportingInApp_ReportType_ContentView_Title,
    ReportingInApp_ReportType_CustomProgramCompletionsByUser_Description: ReportingInApp_ReportType_CustomProgramCompletionsByUser_Description,
    ReportingInApp_ReportType_CustomProgramCompletionsByUser_Title: ReportingInApp_ReportType_CustomProgramCompletionsByUser_Title,
    ReportingInApp_ReportType_CustomProgramOverallProgress_Description: ReportingInApp_ReportType_CustomProgramOverallProgress_Description,
    ReportingInApp_ReportType_CustomProgramOverallProgress_Title: ReportingInApp_ReportType_CustomProgramOverallProgress_Title,
    ReportingInApp_ReportType_CustomProgramPercentProgressByUser_Description: ReportingInApp_ReportType_CustomProgramPercentProgressByUser_Description,
    ReportingInApp_ReportType_CustomProgramPercentProgressByUser_Title: ReportingInApp_ReportType_CustomProgramPercentProgressByUser_Title,
    ReportingInApp_ReportType_CustomProgramProjects_Description: ReportingInApp_ReportType_CustomProgramProjects_Description,
    ReportingInApp_ReportType_CustomProgramProjects_Title: ReportingInApp_ReportType_CustomProgramProjects_Title,
    ReportingInApp_ReportType_CustomProgramUsersLoggedIn_Description: ReportingInApp_ReportType_CustomProgramUsersLoggedIn_Description,
    ReportingInApp_ReportType_CustomProgramUsersLoggedIn_Title: ReportingInApp_ReportType_CustomProgramUsersLoggedIn_Title,
    ReportingInApp_ReportType_FollowersDetailed_Description: ReportingInApp_ReportType_FollowersDetailed_Description,
    ReportingInApp_ReportType_FollowersDetailed_Title: ReportingInApp_ReportType_FollowersDetailed_Title,
    ReportingInApp_ReportType_LearningHoursExecutiveSummary_Description: ReportingInApp_ReportType_LearningHoursExecutiveSummary_Description,
    ReportingInApp_ReportType_LearningHoursExecutiveSummary_Title: ReportingInApp_ReportType_LearningHoursExecutiveSummary_Title,
    ReportingInApp_ReportType_LearningHoursSummarybyUser_Description: ReportingInApp_ReportType_LearningHoursSummarybyUser_Description,
    ReportingInApp_ReportType_LearningHoursSummarybyUser_Title: ReportingInApp_ReportType_LearningHoursSummarybyUser_Title,
    ReportingInApp_ReportType_Logins_Description: ReportingInApp_ReportType_Logins_Description,
    ReportingInApp_ReportType_Logins_Title: ReportingInApp_ReportType_Logins_Title,
    ReportingInApp_ReportType_MentoringDetail_Description: ReportingInApp_ReportType_MentoringDetail_Description,
    ReportingInApp_ReportType_MentoringDetail_Title: ReportingInApp_ReportType_MentoringDetail_Title,
    ReportingInApp_ReportType_OpportunitiesInterestedActivityDetailed_Description: ReportingInApp_ReportType_OpportunitiesInterestedActivityDetailed_Description,
    ReportingInApp_ReportType_OpportunitiesInterestedActivityDetailed_Title: ReportingInApp_ReportType_OpportunitiesInterestedActivityDetailed_Title,
    ReportingInApp_ReportType_OpportunitiesViewDataSummary_Description: ReportingInApp_ReportType_OpportunitiesViewDataSummary_Description,
    ReportingInApp_ReportType_OpportunitiesViewDataSummary_Title: ReportingInApp_ReportType_OpportunitiesViewDataSummary_Title,
    ReportingInApp_ReportType_PathwayDetailByUser_Description: ReportingInApp_ReportType_PathwayDetailByUser_Description,
    ReportingInApp_ReportType_PathwayDetailByUser_Title: ReportingInApp_ReportType_PathwayDetailByUser_Title,
    ReportingInApp_ReportType_PathwaySummaryByPathway_Description: ReportingInApp_ReportType_PathwaySummaryByPathway_Description,
    ReportingInApp_ReportType_PathwaySummaryByPathway_Title: ReportingInApp_ReportType_PathwaySummaryByPathway_Title,
    ReportingInApp_ReportType_PathwaySummaryByUser_Description: ReportingInApp_ReportType_PathwaySummaryByUser_Description,
    ReportingInApp_ReportType_PathwaySummaryByUser_Title: ReportingInApp_ReportType_PathwaySummaryByUser_Title,
    ReportingInApp_ReportType_PlanDetailByUser_Description: ReportingInApp_ReportType_PlanDetailByUser_Description,
    ReportingInApp_ReportType_PlanDetailByUser_Title: ReportingInApp_ReportType_PlanDetailByUser_Title,
    ReportingInApp_ReportType_PlanSummaryByPlan_Description: ReportingInApp_ReportType_PlanSummaryByPlan_Description,
    ReportingInApp_ReportType_PlanSummaryByPlan_Title: ReportingInApp_ReportType_PlanSummaryByPlan_Title,
    ReportingInApp_ReportType_PlanSummaryByUser_Description: ReportingInApp_ReportType_PlanSummaryByUser_Description,
    ReportingInApp_ReportType_PlanSummaryByUser_Title: ReportingInApp_ReportType_PlanSummaryByUser_Title,
    ReportingInApp_ReportType_PublishedAcademiesDetailed_Description: ReportingInApp_ReportType_PublishedAcademiesDetailed_Description,
    ReportingInApp_ReportType_PublishedAcademiesDetailed_Title: ReportingInApp_ReportType_PublishedAcademiesDetailed_Title,
    ReportingInApp_ReportType_PublishedOpportunitiesSummary_Description: ReportingInApp_ReportType_PublishedOpportunitiesSummary_Description,
    ReportingInApp_ReportType_PublishedOpportunitiesSummary_Title: ReportingInApp_ReportType_PublishedOpportunitiesSummary_Title,
    ReportingInApp_ReportType_PublishedPathwaysDetailed_Description: ReportingInApp_ReportType_PublishedPathwaysDetailed_Description,
    ReportingInApp_ReportType_PublishedPathwaysDetailed_Title: ReportingInApp_ReportType_PublishedPathwaysDetailed_Title,
    ReportingInApp_ReportType_SearchSummary_Description: ReportingInApp_ReportType_SearchSummary_Description,
    ReportingInApp_ReportType_SearchSummary_Title: ReportingInApp_ReportType_SearchSummary_Title,
    ReportingInApp_ReportType_SharedDetailed_Description: ReportingInApp_ReportType_SharedDetailed_Description,
    ReportingInApp_ReportType_SharedDetailed_Title: ReportingInApp_ReportType_SharedDetailed_Title,
    ReportingInApp_ReportType_SharedOpportunitiesDetailed_Description: ReportingInApp_ReportType_SharedOpportunitiesDetailed_Description,
    ReportingInApp_ReportType_SharedOpportunitiesDetailed_Title: ReportingInApp_ReportType_SharedOpportunitiesDetailed_Title,
    ReportingInApp_ReportType_SkillActivityEmployee_Description: ReportingInApp_ReportType_SkillActivityEmployee_Description,
    ReportingInApp_ReportType_SkillActivityEmployee_Title: ReportingInApp_ReportType_SkillActivityEmployee_Title,
    ReportingInApp_ReportType_SkillCoachDetailedByManager_Description: ReportingInApp_ReportType_SkillCoachDetailedByManager_Description,
    ReportingInApp_ReportType_SkillCoachDetailedByManager_Title: ReportingInApp_ReportType_SkillCoachDetailedByManager_Title,
    ReportingInApp_ReportType_SkillCoachOverall_Description: ReportingInApp_ReportType_SkillCoachOverall_Description,
    ReportingInApp_ReportType_SkillCoachOverall_Title: ReportingInApp_ReportType_SkillCoachOverall_Title,
    ReportingInApp_ReportType_SkillCoachSummaryByManager_Description: ReportingInApp_ReportType_SkillCoachSummaryByManager_Description,
    ReportingInApp_ReportType_SkillCoachSummaryByManager_Title: ReportingInApp_ReportType_SkillCoachSummaryByManager_Title,
    ReportingInApp_ReportType_SkillFollowedDetailedByUser_Description: ReportingInApp_ReportType_SkillFollowedDetailedByUser_Description,
    ReportingInApp_ReportType_SkillFollowedDetailedByUser_Title: ReportingInApp_ReportType_SkillFollowedDetailedByUser_Title,
    ReportingInApp_ReportType_SkillsByUser_Description: ReportingInApp_ReportType_SkillsByUser_Description,
    ReportingInApp_ReportType_SkillsByUser_Title: ReportingInApp_ReportType_SkillsByUser_Title,
    ReportingInApp_ReportType_SkillStandardDetailedByUser_Description: ReportingInApp_ReportType_SkillStandardDetailedByUser_Description,
    ReportingInApp_ReportType_SkillStandardDetailedByUser_Title: ReportingInApp_ReportType_SkillStandardDetailedByUser_Title,
    ReportingInApp_ReportType_SummaryOfProgressAcademiesCustomPrograms_Description: ReportingInApp_ReportType_SummaryOfProgressAcademiesCustomPrograms_Description,
    ReportingInApp_ReportType_SummaryOfProgressAcademiesCustomPrograms_Title: ReportingInApp_ReportType_SummaryOfProgressAcademiesCustomPrograms_Title,
    ReportingInApp_ReportType_UserGroups_Description: ReportingInApp_ReportType_UserGroups_Description,
    ReportingInApp_ReportType_UserGroups_Title: ReportingInApp_ReportType_UserGroups_Title,
    ReportingInApp_ReportType_UserSummary_Description: ReportingInApp_ReportType_UserSummary_Description,
    ReportingInApp_ReportType_UserSummary_Title: ReportingInApp_ReportType_UserSummary_Title,
    ReportingInApp_ReportType_VWRptUserSummaryAnonymized_Description: ReportingInApp_ReportType_VWRptUserSummaryAnonymized_Description,
    ReportingInApp_ReportType_VWRptUserSummaryAnonymized_Title: ReportingInApp_ReportType_VWRptUserSummaryAnonymized_Title,
    ReportingInApp_SavedPresets: ReportingInApp_SavedPresets,
    ReportingInApp_SavedPresets_ConfirmDelete: ReportingInApp_SavedPresets_ConfirmDelete,
    ReportingInApp_SavedPresets_Description: ReportingInApp_SavedPresets_Description,
    ReportingInApp_SavedPresets_Error_DeletePreset: ReportingInApp_SavedPresets_Error_DeletePreset,
    ReportingInApp_SavedPresets_PresetDeleted: ReportingInApp_SavedPresets_PresetDeleted,
    ReportingInApp_Scheduled_MaxReportsNotice: ReportingInApp_Scheduled_MaxReportsNotice,
    ReportingInApp_ScheduledReports: ReportingInApp_ScheduledReports,
    ReportingInApp_Segments: ReportingInApp_Segments,
    ReportingInApp_Segments_DropdownFilter_TitleSelected: ReportingInApp_Segments_DropdownFilter_TitleSelected,
    ReportingInApp_Segments_Error_GetSegements: ReportingInApp_Segments_Error_GetSegements,
    ReportingInApp_Segments_Error_GetUserForSegments: ReportingInApp_Segments_Error_GetUserForSegments,
    ReportingInApp_Segments_Error_UpdateUserForSegments: ReportingInApp_Segments_Error_UpdateUserForSegments,
    ReportingInApp_Segments_Modal_Info: ReportingInApp_Segments_Modal_Info,
    ReportingInApp_Segments_Modal_Title: ReportingInApp_Segments_Modal_Title,
    ReportingInApp_Segments_Modal_UserListTitle: ReportingInApp_Segments_Modal_UserListTitle,
    ReportingInApp_Segments_Success_UpdateUserForSegments: ReportingInApp_Segments_Success_UpdateUserForSegments,
    ReportingInApp_Segments_View_Attributes: ReportingInApp_Segments_View_Attributes,
    ReportingInApp_Segments_View_EditReportPermissions: ReportingInApp_Segments_View_EditReportPermissions,
    ReportingInApp_Segments_View_ReportPermissions: ReportingInApp_Segments_View_ReportPermissions,
    ReportingInApp_Segments_View_SegmentName: ReportingInApp_Segments_View_SegmentName,
    ReportingInApp_Status_Download: ReportingInApp_Status_Download,
    ReportingInApp_Status_Error: ReportingInApp_Status_Error,
    ReportingInApp_Status_InProgress: ReportingInApp_Status_InProgress,
    ReportingInApp_Status_Unknown: ReportingInApp_Status_Unknown,
    requestGroupMembership_Accept: requestGroupMembership_Accept,
    requestGroupMembership_Approved: requestGroupMembership_Approved,
    requestGroupMembership_Decline: requestGroupMembership_Decline,
    requestGroupMembership_Denied: requestGroupMembership_Denied,
    requestGroupMembership_Plural: requestGroupMembership_Plural,
    requestGroupMembership_Single: requestGroupMembership_Single,
    RequestRating_Header: RequestRating_Header,
    RequestRating_Label: RequestRating_Label,
    RequestRating_Message1Format: RequestRating_Message1Format,
    RequestRating_RateNow: RequestRating_RateNow,
    RequestRating_Self_Message1Format: RequestRating_Self_Message1Format,
    RequestRating_Self_Subject: RequestRating_Self_Subject,
    RequestRating_SendRequest: RequestRating_SendRequest,
    RequestRating_Subject: RequestRating_Subject,
    RequestRating_SuccessMessage: RequestRating_SuccessMessage,
    requiredLearning_notificationDateFormat: requiredLearning_notificationDateFormat,
    resetPasswordForm_ConfirmPasswordError: resetPasswordForm_ConfirmPasswordError,
    resetPasswordForm_ConfirmPasswordLabel: resetPasswordForm_ConfirmPasswordLabel,
    resetPasswordForm_ConfirmPasswordPlaceholder: resetPasswordForm_ConfirmPasswordPlaceholder,
    resetPasswordForm_ExpiredPassword: resetPasswordForm_ExpiredPassword,
    resetPasswordForm_Info: resetPasswordForm_Info,
    resetPasswordForm_InvalidConfirmPassword: resetPasswordForm_InvalidConfirmPassword,
    resetPasswordForm_InvalidEmail: resetPasswordForm_InvalidEmail,
    resetPasswordForm_InvalidPassword: resetPasswordForm_InvalidPassword,
    resetPasswordForm_NewPasswordLabel: resetPasswordForm_NewPasswordLabel,
    resetPasswordForm_NewPasswordPlaceholder: resetPasswordForm_NewPasswordPlaceholder,
    resourceAssociationRemoved_ActionFormat: resourceAssociationRemoved_ActionFormat,
    resourceAssociationRemoved_ActionNoUserFormat: resourceAssociationRemoved_ActionNoUserFormat,
    scholarshipIntroModal_CreateAccount: scholarshipIntroModal_CreateAccount,
    scholarshipIntroModal_CreateAccountDescription: scholarshipIntroModal_CreateAccountDescription,
    scholarshipIntroModal_CreateAccountLabel: scholarshipIntroModal_CreateAccountLabel,
    SearchResultItem_AddToBin: SearchResultItem_AddToBin,
    searchTags_UserTagsAddButton: searchTags_UserTagsAddButton,
    searchTags_UserTagsHint: searchTags_UserTagsHint,
    SessionTimeoutModal_Body: SessionTimeoutModal_Body,
    SessionTimeoutModal_StillHere: SessionTimeoutModal_StillHere,
    signupForm_CreatePasswordLabel: signupForm_CreatePasswordLabel,
    signupForm_CreatePasswordPlaceholder: signupForm_CreatePasswordPlaceholder,
    signupForm_CreatePasswordTooltip: signupForm_CreatePasswordTooltip,
    signupForm_EmailExists: signupForm_EmailExists,
    signupForm_EmailPlaceholder: signupForm_EmailPlaceholder,
    signupForm_EmailStateTooltip: signupForm_EmailStateTooltip,
    signupForm_FirstNamePlaceholder: signupForm_FirstNamePlaceholder,
    signupForm_HasAccountCTA: signupForm_HasAccountCTA,
    signupForm_InvalidEmailSignup: signupForm_InvalidEmailSignup,
    signupForm_InvalidEula: signupForm_InvalidEula,
    signupForm_InvalidFirstName: signupForm_InvalidFirstName,
    signupForm_InvalidPassword: signupForm_InvalidPassword,
    signupForm_LastNamePlaceholder: signupForm_LastNamePlaceholder,
    signupForm_LogInNow: signupForm_LogInNow,
    signupForm_NoAccount: signupForm_NoAccount,
    signupForm_PasswordLabel: signupForm_PasswordLabel,
    signupForm_RegisterEmailLabel: signupForm_RegisterEmailLabel,
    signupForm_RegisterFirstNameLabel: signupForm_RegisterFirstNameLabel,
    signupForm_RegisterLastNameLabel: signupForm_RegisterLastNameLabel,
    signupForm_SignUpTitle: signupForm_SignUpTitle,
    singleRecommendation_groupAlreadyCompletedArticleDateFormat: singleRecommendation_groupAlreadyCompletedArticleDateFormat,
    singleRecommendation_groupAlreadyCompletedArticleFormat: singleRecommendation_groupAlreadyCompletedArticleFormat,
    singleRecommendation_groupAlreadyCompletedAssessmentDateFormat: singleRecommendation_groupAlreadyCompletedAssessmentDateFormat,
    singleRecommendation_groupAlreadyCompletedAssessmentFormat: singleRecommendation_groupAlreadyCompletedAssessmentFormat,
    singleRecommendation_groupAlreadyCompletedBookFormat: singleRecommendation_groupAlreadyCompletedBookFormat,
    singleRecommendation_groupAlreadyCompletedCourseFormat: singleRecommendation_groupAlreadyCompletedCourseFormat,
    singleRecommendation_groupAlreadyCompletedEpisodeDateFormat: singleRecommendation_groupAlreadyCompletedEpisodeDateFormat,
    singleRecommendation_groupAlreadyCompletedEpisodeFormat: singleRecommendation_groupAlreadyCompletedEpisodeFormat,
    singleRecommendation_groupAlreadyCompletedEventDateFormat: singleRecommendation_groupAlreadyCompletedEventDateFormat,
    singleRecommendation_groupAlreadyCompletedEventFormat: singleRecommendation_groupAlreadyCompletedEventFormat,
    singleRecommendation_GroupAlreadyCompletedFormat: singleRecommendation_GroupAlreadyCompletedFormat,
    singleRecommendation_groupAlreadyCompletedPathwayDateFormat: singleRecommendation_groupAlreadyCompletedPathwayDateFormat,
    singleRecommendation_groupAlreadyCompletedPathwayFormat: singleRecommendation_groupAlreadyCompletedPathwayFormat,
    singleRecommendation_groupAlreadyCompletedVideoDateFormat: singleRecommendation_groupAlreadyCompletedVideoDateFormat,
    singleRecommendation_groupAlreadyCompletedVideoFormat: singleRecommendation_groupAlreadyCompletedVideoFormat,
    singleRecommendation_groupArticleDateFormat: singleRecommendation_groupArticleDateFormat,
    singleRecommendation_groupArticleFormat: singleRecommendation_groupArticleFormat,
    singleRecommendation_groupAssessmentDateFormat: singleRecommendation_groupAssessmentDateFormat,
    singleRecommendation_groupAssessmentFormat: singleRecommendation_groupAssessmentFormat,
    singleRecommendation_groupBookDateFormat: singleRecommendation_groupBookDateFormat,
    singleRecommendation_groupBookFormat: singleRecommendation_groupBookFormat,
    singleRecommendation_groupCourseDateFormat: singleRecommendation_groupCourseDateFormat,
    singleRecommendation_groupCourseFormat: singleRecommendation_groupCourseFormat,
    singleRecommendation_groupEpisodeDateFormat: singleRecommendation_groupEpisodeDateFormat,
    singleRecommendation_groupEpisodeFormat: singleRecommendation_groupEpisodeFormat,
    singleRecommendation_groupEventDateFormat: singleRecommendation_groupEventDateFormat,
    singleRecommendation_groupEventFormat: singleRecommendation_groupEventFormat,
    singleRecommendation_GroupFollowFormat: singleRecommendation_GroupFollowFormat,
    singleRecommendation_GroupFormat: singleRecommendation_GroupFormat,
    singleRecommendation_groupPathwayDateFormat: singleRecommendation_groupPathwayDateFormat,
    singleRecommendation_groupPathwayFormat: singleRecommendation_groupPathwayFormat,
    singleRecommendation_groupTargetDateFormat: singleRecommendation_groupTargetDateFormat,
    singleRecommendation_groupTargetFormat: singleRecommendation_groupTargetFormat,
    singleRecommendation_groupVideoDateFormat: singleRecommendation_groupVideoDateFormat,
    singleRecommendation_groupVideoFormat: singleRecommendation_groupVideoFormat,
    singleRecommendation_GroupYouAlreadyFollowFormat: singleRecommendation_GroupYouAlreadyFollowFormat,
    singleRecommendation_youAlreadyCompletedArticleDateFormat: singleRecommendation_youAlreadyCompletedArticleDateFormat,
    singleRecommendation_youAlreadyCompletedArticleFormat: singleRecommendation_youAlreadyCompletedArticleFormat,
    singleRecommendation_youAlreadyCompletedAssessmentDateFormat: singleRecommendation_youAlreadyCompletedAssessmentDateFormat,
    singleRecommendation_youAlreadyCompletedAssessmentFormat: singleRecommendation_youAlreadyCompletedAssessmentFormat,
    singleRecommendation_youAlreadyCompletedBookFormat: singleRecommendation_youAlreadyCompletedBookFormat,
    singleRecommendation_youAlreadyCompletedCourseDateFormat: singleRecommendation_youAlreadyCompletedCourseDateFormat,
    singleRecommendation_youAlreadyCompletedCourseFormat: singleRecommendation_youAlreadyCompletedCourseFormat,
    singleRecommendation_youAlreadyCompletedEpisodeDateFormat: singleRecommendation_youAlreadyCompletedEpisodeDateFormat,
    singleRecommendation_youAlreadyCompletedEpisodeFormat: singleRecommendation_youAlreadyCompletedEpisodeFormat,
    singleRecommendation_youAlreadyCompletedEventDateFormat: singleRecommendation_youAlreadyCompletedEventDateFormat,
    singleRecommendation_youAlreadyCompletedEventFormat: singleRecommendation_youAlreadyCompletedEventFormat,
    singleRecommendation_YouAlreadyCompletedFormat: singleRecommendation_YouAlreadyCompletedFormat,
    singleRecommendation_youAlreadyCompletedPathwayFormat: singleRecommendation_youAlreadyCompletedPathwayFormat,
    singleRecommendation_youAlreadyCompletedTargetDateFormat: singleRecommendation_youAlreadyCompletedTargetDateFormat,
    singleRecommendation_youAlreadyCompletedTargetFormat: singleRecommendation_youAlreadyCompletedTargetFormat,
    singleRecommendation_youAlreadyCompletedVideoDateFormat: singleRecommendation_youAlreadyCompletedVideoDateFormat,
    singleRecommendation_youAlreadyCompletedVideoFormat: singleRecommendation_youAlreadyCompletedVideoFormat,
    singleRecommendation_YouAlreadyFollowFormat: singleRecommendation_YouAlreadyFollowFormat,
    singleRecommendation_youArticleFormat: singleRecommendation_youArticleFormat,
    singleRecommendation_youAssessmentDateFormat: singleRecommendation_youAssessmentDateFormat,
    singleRecommendation_youAssessmentFormat: singleRecommendation_youAssessmentFormat,
    singleRecommendation_youBookDateFormat: singleRecommendation_youBookDateFormat,
    singleRecommendation_youBookFormat: singleRecommendation_youBookFormat,
    singleRecommendation_youCourseDateFormat: singleRecommendation_youCourseDateFormat,
    singleRecommendation_youCourseFormat: singleRecommendation_youCourseFormat,
    singleRecommendation_youEpisodeDateFormat: singleRecommendation_youEpisodeDateFormat,
    singleRecommendation_youEpisodeFormat: singleRecommendation_youEpisodeFormat,
    singleRecommendation_youEventDateFormat: singleRecommendation_youEventDateFormat,
    singleRecommendation_youEventFormat: singleRecommendation_youEventFormat,
    singleRecommendation_YouFollowFormat: singleRecommendation_YouFollowFormat,
    singleRecommendation_YouFormat: singleRecommendation_YouFormat,
    singleRecommendation_youPathwayDateFormat: singleRecommendation_youPathwayDateFormat,
    singleRecommendation_youPathwayFormat: singleRecommendation_youPathwayFormat,
    singleRecommendation_youPositionDateFormat: singleRecommendation_youPositionDateFormat,
    singleRecommendation_youTargetDateFormat: singleRecommendation_youTargetDateFormat,
    singleRecommendation_youTargetFormat: singleRecommendation_youTargetFormat,
    singleRecommendation_youVideoDateFormat: singleRecommendation_youVideoDateFormat,
    singleRecommendation_youVideoFormat: singleRecommendation_youVideoFormat,
    SkillActivityChart_Title: SkillActivityChart_Title,
    SkillActivityChart_TooltipText: SkillActivityChart_TooltipText,
    SkillFormCtrl_AddLink: SkillFormCtrl_AddLink,
    SkillFormCtrl_Description: SkillFormCtrl_Description,
    SkillFormCtrl_SkillCategory: SkillFormCtrl_SkillCategory,
    SkillFormCtrl_SkillDescription: SkillFormCtrl_SkillDescription,
    SkillFormCtrl_Url: SkillFormCtrl_Url,
    SkillInsights_MinimumRatingNotice: SkillInsights_MinimumRatingNotice,
    SkillInsights_RatingNotice: SkillInsights_RatingNotice,
    SkillProgressionChart_AvgRating: SkillProgressionChart_AvgRating,
    SkillProgressionChart_AvgSkillRating: SkillProgressionChart_AvgSkillRating,
    SkillProgressionChart_NumberOfLearners: SkillProgressionChart_NumberOfLearners,
    SkillProgressionChart_NumberOfRatingsPlural: SkillProgressionChart_NumberOfRatingsPlural,
    SkillProgressionChart_NumberOfRatingsSingle: SkillProgressionChart_NumberOfRatingsSingle,
    SkillProgressionChart_Ratings: SkillProgressionChart_Ratings,
    SkillProgressionChart_SkillProgression: SkillProgressionChart_SkillProgression,
    SkillProgressionChart_SkillSupply: SkillProgressionChart_SkillSupply,
    SkillProgressionChart_SubtitlePluralFormat: SkillProgressionChart_SubtitlePluralFormat,
    SkillProgressionChart_SubtitleSingularFormat: SkillProgressionChart_SubtitleSingularFormat,
    SkillProgressionChart_SubtitleTopFormat: SkillProgressionChart_SubtitleTopFormat,
    SkillProgressionChart_Title: SkillProgressionChart_Title,
    SkillProgressionChart_XAxis: SkillProgressionChart_XAxis,
    SkillProgressionChart_YAxis: SkillProgressionChart_YAxis,
    SkillRatingsChart_AllTypes: SkillRatingsChart_AllTypes,
    SkillRatingsChart_AlphabeticalOrder: SkillRatingsChart_AlphabeticalOrder,
    SkillRatingsChart_Average: SkillRatingsChart_Average,
    SkillRatingsChart_AverageSkillRating: SkillRatingsChart_AverageSkillRating,
    SkillRatingsChart_avgSkillRatingFormat: SkillRatingsChart_avgSkillRatingFormat,
    SkillRatingsChart_certified: SkillRatingsChart_certified,
    SkillRatingsChart_DegreedCertified: SkillRatingsChart_DegreedCertified,
    SkillRatingsChart_Description: SkillRatingsChart_Description,
    SkillRatingsChart_EmptyStateText: SkillRatingsChart_EmptyStateText,
    SkillRatingsChart_Evaluations: SkillRatingsChart_Evaluations,
    SkillRatingsChart_High: SkillRatingsChart_High,
    SkillRatingsChart_learner: SkillRatingsChart_learner,
    SkillRatingsChart_learnerPluralFormat: SkillRatingsChart_learnerPluralFormat,
    SkillRatingsChart_Low: SkillRatingsChart_Low,
    SkillRatingsChart_manager: SkillRatingsChart_manager,
    SkillRatingsChart_ManagerRatings: SkillRatingsChart_ManagerRatings,
    SkillRatingsChart_Medium: SkillRatingsChart_Medium,
    SkillRatingsChart_MostRatings: SkillRatingsChart_MostRatings,
    SkillRatingsChart_NoData: SkillRatingsChart_NoData,
    SkillRatingsChart_NumberOfSkillsShownPluralFormat: SkillRatingsChart_NumberOfSkillsShownPluralFormat,
    SkillRatingsChart_NumberOfSkillsShownSingularFormat: SkillRatingsChart_NumberOfSkillsShownSingularFormat,
    SkillRatingsChart_NumberOfSkillsShownTopFormat: SkillRatingsChart_NumberOfSkillsShownTopFormat,
    SkillRatingsChart_Range: SkillRatingsChart_Range,
    SkillRatingsChart_Rating: SkillRatingsChart_Rating,
    SkillRatingsChart_Ratings: SkillRatingsChart_Ratings,
    SkillRatingsChart_RatingType: SkillRatingsChart_RatingType,
    SkillRatingsChart_Representativeness: SkillRatingsChart_Representativeness,
    SkillRatingsChart_review: SkillRatingsChart_review,
    SkillRatingsChart_Rigor: SkillRatingsChart_Rigor,
    SkillRatingsChart_self: SkillRatingsChart_self,
    SkillRatingsChart_SelfRatings: SkillRatingsChart_SelfRatings,
    SkillRatingsChart_SkillInventory: SkillRatingsChart_SkillInventory,
    SkillRatingsChart_StatsTitle: SkillRatingsChart_StatsTitle,
    SkillRatingsChart_TargetLevel: SkillRatingsChart_TargetLevel,
    SkillRatingsChart_Text: SkillRatingsChart_Text,
    SkillRatingsChart_TotalRatingsFormat: SkillRatingsChart_TotalRatingsFormat,
    SkillRatingsChart_TotalSkillRatings: SkillRatingsChart_TotalSkillRatings,
    SkillRatingTypeChart_Legend_Manager: SkillRatingTypeChart_Legend_Manager,
    SkillRatingTypeChart_Legend_Peer: SkillRatingTypeChart_Legend_Peer,
    SkillRatingTypeChart_Legend_Self: SkillRatingTypeChart_Legend_Self,
    SkillRatingTypeChart_Legend_SkillReview: SkillRatingTypeChart_Legend_SkillReview,
    SkillRatingTypeChart_LegendTitle: SkillRatingTypeChart_LegendTitle,
    SkillRatingTypeChart_Title: SkillRatingTypeChart_Title,
    SkillRatingTypeChart_TooltipText: SkillRatingTypeChart_TooltipText,
    SkillRatingTypeChart_XAxis_Label: SkillRatingTypeChart_XAxis_Label,
    SkillRatingTypeChart_YAxis_Label: SkillRatingTypeChart_YAxis_Label,
    SkillRegistrySearch_SkillRegistrySuggestions: SkillRegistrySearch_SkillRegistrySuggestions,
    SkillSearchCtrl_ComingSoon: SkillSearchCtrl_ComingSoon,
    SkillSearchCtrl_EmailAddress: SkillSearchCtrl_EmailAddress,
    SkillSearchCtrl_GetCertifiedToday: SkillSearchCtrl_GetCertifiedToday,
    SkillSearchCtrl_GetNotified: SkillSearchCtrl_GetNotified,
    SkillSearchCtrl_NoMatch: SkillSearchCtrl_NoMatch,
    SkillSearchCtrl_SearchForSkill: SkillSearchCtrl_SearchForSkill,
    SkillSectionsChart_AboveTarget: SkillSectionsChart_AboveTarget,
    SkillSectionsChart_AllSectionSkills: SkillSectionsChart_AllSectionSkills,
    SkillSectionsChart_AtTarget: SkillSectionsChart_AtTarget,
    SkillSectionsChart_AvgRatingFormat: SkillSectionsChart_AvgRatingFormat,
    SkillSectionsChart_BelowTarget: SkillSectionsChart_BelowTarget,
    SkillSectionsChart_Level: SkillSectionsChart_Level,
    SkillSectionsChart_NoData: SkillSectionsChart_NoData,
    SkillSectionsChart_NoRatings: SkillSectionsChart_NoRatings,
    SkillSectionsChart_NoTarget: SkillSectionsChart_NoTarget,
    SkillSectionsChart_PercentFormat: SkillSectionsChart_PercentFormat,
    SkillSectionsChart_PercentOfRatings: SkillSectionsChart_PercentOfRatings,
    SkillSectionsChart_PlanFollowersFormat: SkillSectionsChart_PlanFollowersFormat,
    SkillSectionsChart_PlanRatingsFormat: SkillSectionsChart_PlanRatingsFormat,
    SkillSectionsChart_PluralRatings: SkillSectionsChart_PluralRatings,
    SkillSectionsChart_ReviewCertificationNotAvailable: SkillSectionsChart_ReviewCertificationNotAvailable,
    SkillSectionsChart_SingularRating: SkillSectionsChart_SingularRating,
    SkillSectionsChart_SkillCertifications: SkillSectionsChart_SkillCertifications,
    SkillSectionsChart_SkillFollowersFormat: SkillSectionsChart_SkillFollowersFormat,
    SkillSectionsChart_SkillRatingsBreakdown: SkillSectionsChart_SkillRatingsBreakdown,
    SkillSectionsChart_SkillRatingsFormat: SkillSectionsChart_SkillRatingsFormat,
    SkillSectionsChart_Team_NoRatings: SkillSectionsChart_Team_NoRatings,
    SkillSectionsChart_TeamMembers_AvgFormat: SkillSectionsChart_TeamMembers_AvgFormat,
    SkillSectionsChart_TeamMembers_FollowFormat: SkillSectionsChart_TeamMembers_FollowFormat,
    SkillSectionsChart_TeamMembers_RatingsFormat: SkillSectionsChart_TeamMembers_RatingsFormat,
    SkillsSvc_AddPrimarySkillSource: SkillsSvc_AddPrimarySkillSource,
    SkillsSvc_AddRoleError: SkillsSvc_AddRoleError,
    SkillsSvc_AddRoleSuccess: SkillsSvc_AddRoleSuccess,
    SkillsSvc_AddSkill: SkillsSvc_AddSkill,
    SkillsSvc_AddSkillError: SkillsSvc_AddSkillError,
    SkillsSvc_AddSkillNameInputDescription: SkillsSvc_AddSkillNameInputDescription,
    SkillsSvc_AddSkillSource: SkillsSvc_AddSkillSource,
    SkillsSvc_AddSkillSuccess: SkillsSvc_AddSkillSuccess,
    SkillsSvc_AddTranslations: SkillsSvc_AddTranslations,
    SkillsSvc_AttemptPublishAgain: SkillsSvc_AttemptPublishAgain,
    SkillsSvc_Categories: SkillsSvc_Categories,
    SkillsSvc_Category: SkillsSvc_Category,
    SkillsSvc_CategoryCreateAgainError: SkillsSvc_CategoryCreateAgainError,
    SkillsSvc_CategorySuccessfullyCreated: SkillsSvc_CategorySuccessfullyCreated,
    SkillsSvc_CategorySuccessfullyUpdated: SkillsSvc_CategorySuccessfullyUpdated,
    SkillsSvc_CountSkillCategoriesPlural: SkillsSvc_CountSkillCategoriesPlural,
    SkillsSvc_CountSkillCategoriesSingular: SkillsSvc_CountSkillCategoriesSingular,
    SkillsSvc_CountSkillSynonymsPlural: SkillsSvc_CountSkillSynonymsPlural,
    SkillsSvc_CountSkillSynonymsSingular: SkillsSvc_CountSkillSynonymsSingular,
    SkillsSvc_CreateSkillTip: SkillsSvc_CreateSkillTip,
    SkillsSvc_CTASourcesDesc: SkillsSvc_CTASourcesDesc,
    SkillsSvc_CTASuggestionsDesc: SkillsSvc_CTASuggestionsDesc,
    SkillsSvc_CTAUnpublishedChangesDesc: SkillsSvc_CTAUnpublishedChangesDesc,
    SkillsSvc_CTAUnpublishedSkills: SkillsSvc_CTAUnpublishedSkills,
    SkillsSvc_CurrentDescription: SkillsSvc_CurrentDescription,
    SkillsSvc_CurrentSynonymousSkills: SkillsSvc_CurrentSynonymousSkills,
    SkillsSvc_CurrentTitle: SkillsSvc_CurrentTitle,
    SkillsSvc_DeleteLanguageTranslation: SkillsSvc_DeleteLanguageTranslation,
    SkillsSvc_DeleteRoleError: SkillsSvc_DeleteRoleError,
    SkillsSvc_DeleteRoleSuccess: SkillsSvc_DeleteRoleSuccess,
    SkillsSvc_DeleteSkillError: SkillsSvc_DeleteSkillError,
    SkillsSvc_DeleteSkillSource: SkillsSvc_DeleteSkillSource,
    SkillsSvc_DeleteSkillSourceDescription: SkillsSvc_DeleteSkillSourceDescription,
    SkillsSvc_DeleteSkillSuccess: SkillsSvc_DeleteSkillSuccess,
    SkillsSvc_DeleteTranslation: SkillsSvc_DeleteTranslation,
    SkillsSvc_EditRoleError: SkillsSvc_EditRoleError,
    SkillsSvc_EditRoleSuccess: SkillsSvc_EditRoleSuccess,
    SkillsSvc_EditSkill: SkillsSvc_EditSkill,
    SkillsSvc_EditSkillError: SkillsSvc_EditSkillError,
    SkillsSvc_EditSkillSuccess: SkillsSvc_EditSkillSuccess,
    SkillsSvc_EditsToSkills: SkillsSvc_EditsToSkills,
    SkillsSvc_EnableEndorseSkillOption: SkillsSvc_EnableEndorseSkillOption,
    SkillsSvc_EnableSkillReview: SkillsSvc_EnableSkillReview,
    SkillsSvc_EndorseSkill: SkillsSvc_EndorseSkill,
    SkillsSvc_FileUploadSuccessful: SkillsSvc_FileUploadSuccessful,
    SkillsSvc_FileUploadSuccessfulDescription: SkillsSvc_FileUploadSuccessfulDescription,
    SkillsSvc_GetStarted_Dashboard: SkillsSvc_GetStarted_Dashboard,
    SkillsSvc_GetStarted_Dashboard_Description: SkillsSvc_GetStarted_Dashboard_Description,
    SkillsSvc_ImportantPublishingInfo: SkillsSvc_ImportantPublishingInfo,
    SkillsSvc_IntegrationSourceEditTip: SkillsSvc_IntegrationSourceEditTip,
    SkillsSvc_ItemsAreNowAvailable: SkillsSvc_ItemsAreNowAvailable,
    SkillsSvc_JobRoles: SkillsSvc_JobRoles,
    SkillsSvc_JobRolesDescription: SkillsSvc_JobRolesDescription,
    SkillsSvc_LimitVisibilityToTheseGroups: SkillsSvc_LimitVisibilityToTheseGroups,
    SkillsSvc_ManageCategories: SkillsSvc_ManageCategories,
    SkillsSvc_ManageSources: SkillsSvc_ManageSources,
    SkillsSvc_MoreItems: SkillsSvc_MoreItems,
    SkillsSvc_NewSkillDescription: SkillsSvc_NewSkillDescription,
    SkillsSvc_NewSkillSpelling: SkillsSvc_NewSkillSpelling,
    SkillsSvc_NoPublishedHistory: SkillsSvc_NoPublishedHistory,
    SkillsSvc_OnboardingAddedNotification: SkillsSvc_OnboardingAddedNotification,
    SkillsSvc_OnboardingError: SkillsSvc_OnboardingError,
    SkillsSvc_OnboardingRemovedNotification: SkillsSvc_OnboardingRemovedNotification,
    SkillsSvc_OneMoreItem: SkillsSvc_OneMoreItem,
    SkillsSvc_OneTranslationSavedMsg: SkillsSvc_OneTranslationSavedMsg,
    SkillsSvc_OrgNameSkillsOnly: SkillsSvc_OrgNameSkillsOnly,
    SkillsSvc_PrimarySourceEditTip: SkillsSvc_PrimarySourceEditTip,
    SkillsSvc_Proficiency: SkillsSvc_Proficiency,
    SkillsSvc_Proficiency_Custom: SkillsSvc_Proficiency_Custom,
    SkillsSvc_Proficiency_Default: SkillsSvc_Proficiency_Default,
    SkillsSvc_Proficiency_Description_SubTitle: SkillsSvc_Proficiency_Description_SubTitle,
    SkillsSvc_Proficiency_Description_Title: SkillsSvc_Proficiency_Description_Title,
    SkillsSvc_Proficiency_InferDescription: SkillsSvc_Proficiency_InferDescription,
    SkillsSvc_Proficiency_Reset_Description: SkillsSvc_Proficiency_Reset_Description,
    SkillsSvc_Proficiency_Reset_Description_Content: SkillsSvc_Proficiency_Reset_Description_Content,
    SkillsSvc_PromoteSkillToOrg: SkillsSvc_PromoteSkillToOrg,
    SkillsSvc_Proprietary: SkillsSvc_Proprietary,
    SkillsSvc_ProprietarySkillOption: SkillsSvc_ProprietarySkillOption,
    SkillsSvc_ProprietaryToOrgLabel: SkillsSvc_ProprietaryToOrgLabel,
    SkillsSvc_PublishChangesToOrgName: SkillsSvc_PublishChangesToOrgName,
    SkillsSvc_PublishedSuccessfully: SkillsSvc_PublishedSuccessfully,
    SkillsSvc_PublishSkillCount: SkillsSvc_PublishSkillCount,
    SkillsSvc_PublishToLxp: SkillsSvc_PublishToLxp,
    SkillsSvc_PublishWarning: SkillsSvc_PublishWarning,
    SkillsSvc_RetrieveError: SkillsSvc_RetrieveError,
    SkillsSvc_ReviewSuggestions: SkillsSvc_ReviewSuggestions,
    SkillsSvc_RolesBulkUploadNotice: SkillsSvc_RolesBulkUploadNotice,
    SkillsSvc_RoleSuggestions: SkillsSvc_RoleSuggestions,
    SkillsSvc_Save_Upload: SkillsSvc_Save_Upload,
    SkillsSvc_SearchGroups: SkillsSvc_SearchGroups,
    SkillsSvc_SearchRoles: SkillsSvc_SearchRoles,
    SkillsSvc_SearchSkillCategories: SkillsSvc_SearchSkillCategories,
    SkillsSvc_SearchSkills: SkillsSvc_SearchSkills,
    SkillsSvc_SillAlreadyExistsInOrg: SkillsSvc_SillAlreadyExistsInOrg,
    SkillsSvc_SkillCategories: SkillsSvc_SkillCategories,
    SkillsSvc_SkillCategoriesDescription: SkillsSvc_SkillCategoriesDescription,
    SkillsSvc_SkillId: SkillsSvc_SkillId,
    SkillsSvc_SkillReviewEnableOption: SkillsSvc_SkillReviewEnableOption,
    SkillsSvc_SkillReviewVisibility: SkillsSvc_SkillReviewVisibility,
    SkillsSvc_SkillReviewVisibilityDescription: SkillsSvc_SkillReviewVisibilityDescription,
    SkillsSvc_SkillsBulkUploadNotice: SkillsSvc_SkillsBulkUploadNotice,
    SkillsSvc_SkillSourceCreated: SkillsSvc_SkillSourceCreated,
    SkillsSvc_SkillSourceCreatedDescription: SkillsSvc_SkillSourceCreatedDescription,
    SkillsSvc_SkillSourceDescription: SkillsSvc_SkillSourceDescription,
    SkillsSvc_SkillSourceName: SkillsSvc_SkillSourceName,
    SkillsSvc_SkillSources: SkillsSvc_SkillSources,
    SkillsSvc_SkillSuggestionDrawerTitle: SkillsSvc_SkillSuggestionDrawerTitle,
    SkillsSvc_SkillSynonymError: SkillsSvc_SkillSynonymError,
    SkillsSvc_SkillTitle: SkillsSvc_SkillTitle,
    SkillsSvc_SkillUpdatedSuccessfully: SkillsSvc_SkillUpdatedSuccessfully,
    SkillsSvc_SkipForNow: SkillsSvc_SkipForNow,
    SkillsSvc_SourceAlreadyExistsInOrg: SkillsSvc_SourceAlreadyExistsInOrg,
    SkillsSvc_SuggestedSkillDescription: SkillsSvc_SuggestedSkillDescription,
    SkillsSvc_SuggestedSkillTitle: SkillsSvc_SuggestedSkillTitle,
    SkillsSvc_SuggestedSynonymousSkills: SkillsSvc_SuggestedSynonymousSkills,
    SkillsSvc_suggestions_sub_header_text: SkillsSvc_suggestions_sub_header_text,
    SkillsSvc_SuggestionsApplied: SkillsSvc_SuggestionsApplied,
    SkillsSvc_SuggestionsDeclined: SkillsSvc_SuggestionsDeclined,
    SkillsSvc_SynonymAlreadyExistsMessaging: SkillsSvc_SynonymAlreadyExistsMessaging,
    SkillsSvc_SynonymousSkills: SkillsSvc_SynonymousSkills,
    SkillsSvc_SynonymousSkills_MergeModal_button: SkillsSvc_SynonymousSkills_MergeModal_button,
    SkillsSvc_SynonymousSkills_MergeModal_paragraph_1: SkillsSvc_SynonymousSkills_MergeModal_paragraph_1,
    SkillsSvc_SynonymousSkills_MergeModal_paragraph_2: SkillsSvc_SynonymousSkills_MergeModal_paragraph_2,
    SkillsSvc_SynonymousSkills_MergeModal_title: SkillsSvc_SynonymousSkills_MergeModal_title,
    SkillsSvc_SynonymousSkillsDescription: SkillsSvc_SynonymousSkillsDescription,
    SkillsSvc_TotalSuggestionsSelected: SkillsSvc_TotalSuggestionsSelected,
    SkillsSvc_Translations: SkillsSvc_Translations,
    SkillsSvc_TranslationsSaved: SkillsSvc_TranslationsSaved,
    SkillsSvc_TranslationsSavedMsg: SkillsSvc_TranslationsSavedMsg,
    SkillsSvc_TryAgainOrContactSupport: SkillsSvc_TryAgainOrContactSupport,
    SkillsSvc_UnpublishedChange: SkillsSvc_UnpublishedChange,
    SkillsSvc_UnpublishedChanges: SkillsSvc_UnpublishedChanges,
    SkillsSvc_UnpublishedChanges_None: SkillsSvc_UnpublishedChanges_None,
    SkillsSvc_UpdateError: SkillsSvc_UpdateError,
    SkillsSvc_UpdateRoleError: SkillsSvc_UpdateRoleError,
    SkillsSvc_UpdateRoleSuccess: SkillsSvc_UpdateRoleSuccess,
    SkillsSvc_UploadRoleError: SkillsSvc_UploadRoleError,
    SkillsSvc_UploadSkillError: SkillsSvc_UploadSkillError,
    SkillsSvc_UsersTitle: SkillsSvc_UsersTitle,
    SkillsSvc_ZeroTranslationSavedMsg: SkillsSvc_ZeroTranslationSavedMsg,
    SkillStd_AddDescription: SkillStd_AddDescription,
    SkillStd_AddSkillToProfile: SkillStd_AddSkillToProfile,
    SkillStd_AddTitle: SkillStd_AddTitle,
    SkillStd_CreateSkillStandards: SkillStd_CreateSkillStandards,
    SkillStd_DeleteSegmentMsg: SkillStd_DeleteSegmentMsg,
    SkillStd_DeleteSkillStandardsError: SkillStd_DeleteSkillStandardsError,
    SkillStd_DeleteSkillStandardsSegmentError: SkillStd_DeleteSkillStandardsSegmentError,
    SkillStd_DeleteSkillStandardsSegmentSuccess: SkillStd_DeleteSkillStandardsSegmentSuccess,
    SkillStd_DeleteSkillStandardsSuccess: SkillStd_DeleteSkillStandardsSuccess,
    SkillStd_DescriptionPlaceholder: SkillStd_DescriptionPlaceholder,
    SkillStd_DescriptionSuggestionPlaceholder: SkillStd_DescriptionSuggestionPlaceholder,
    SkillStd_EditDescription: SkillStd_EditDescription,
    SkillStd_EditSkillStandards: SkillStd_EditSkillStandards,
    SkillStd_emptyStateAddSomethingToShowHere: SkillStd_emptyStateAddSomethingToShowHere,
    SkillStd_MaximumAddedSegmentsDesc: SkillStd_MaximumAddedSegmentsDesc,
    SkillStd_MaximumAddedSegmentsReached: SkillStd_MaximumAddedSegmentsReached,
    SkillStd_MinimumVisibleSkillWarning: SkillStd_MinimumVisibleSkillWarning,
    SkillStd_NoVisibleSkills: SkillStd_NoVisibleSkills,
    SkillStd_NoVisibleSkillsUnpublishBody: SkillStd_NoVisibleSkillsUnpublishBody,
    SkillStd_NoVisibleSkillsUnpublishBodySecondary: SkillStd_NoVisibleSkillsUnpublishBodySecondary,
    SkillStd_PersonalSkillTarget: SkillStd_PersonalSkillTarget,
    SkillStd_PublishSegment: SkillStd_PublishSegment,
    SkillStd_RecommendedSkillsMessage: SkillStd_RecommendedSkillsMessage,
    SkillStd_RemoveSegment: SkillStd_RemoveSegment,
    SkillStd_RemoveSegmentBody: SkillStd_RemoveSegmentBody,
    SkillStd_RemoveSkill: SkillStd_RemoveSkill,
    SkillStd_RemoveSkillBody: SkillStd_RemoveSkillBody,
    SkillStd_RemoveSkillBodySecondary: SkillStd_RemoveSkillBodySecondary,
    SkillStd_RemoveSkillError: SkillStd_RemoveSkillError,
    SkillStd_RemoveSkillSuccess: SkillStd_RemoveSkillSuccess,
    SkillStd_RequirementStatus: SkillStd_RequirementStatus,
    SkillStd_SegmentAddedSuccessPlural: SkillStd_SegmentAddedSuccessPlural,
    SkillStd_SegmentAddedSuccessSingle: SkillStd_SegmentAddedSuccessSingle,
    SkillStd_SegmentPublishRequirementsNotMet: SkillStd_SegmentPublishRequirementsNotMet,
    SkillStd_Segments: SkillStd_Segments,
    SkillStd_SkillAddedSuccessPlural: SkillStd_SkillAddedSuccessPlural,
    SkillStd_SkillAddedSuccessSingle: SkillStd_SkillAddedSuccessSingle,
    SkillStd_SkillRemovedSegmentUnpublished_Multiple: SkillStd_SkillRemovedSegmentUnpublished_Multiple,
    SkillStd_SkillRemovedSegmentUnpublished_Single: SkillStd_SkillRemovedSegmentUnpublished_Single,
    SkillStd_SkillRequired: SkillStd_SkillRequired,
    SkillStd_SkillSet: SkillStd_SkillSet,
    SkillStd_SkillSetRelationships: SkillStd_SkillSetRelationships,
    SkillStd_SkillStandards: SkillStd_SkillStandards,
    SkillStd_SkillStandardsProfileSectionSubtitle: SkillStd_SkillStandardsProfileSectionSubtitle,
    SkillStd_SkillTargets: SkillStd_SkillTargets,
    SkillStd_SkillVisible: SkillStd_SkillVisible,
    SkillStd_Status_NoSegments: SkillStd_Status_NoSegments,
    SkillStd_Status_UnpublishedSegments: SkillStd_Status_UnpublishedSegments,
    SkillStd_SuccessfullyPublished: SkillStd_SuccessfullyPublished,
    SkillStd_SuccessfullyUnpublished: SkillStd_SuccessfullyUnpublished,
    SkillStd_TitleAlreadyExistsError: SkillStd_TitleAlreadyExistsError,
    SkillStd_TitleSuggestionPlaceholder: SkillStd_TitleSuggestionPlaceholder,
    SkillStd_Unpublished: SkillStd_Unpublished,
    SkillStd_UnpublishedSegmentsWarning: SkillStd_UnpublishedSegmentsWarning,
    SkillStd_UnpublishSegment: SkillStd_UnpublishSegment,
    SkillStd_UnpublishSegmentMsg: SkillStd_UnpublishSegmentMsg,
    SkillStd_UnpublishSegmentMsgConfirm: SkillStd_UnpublishSegmentMsgConfirm,
    SkillStd_UnpublishSegmentName: SkillStd_UnpublishSegmentName,
    SkillTrends_CustomAttributes_ErrorMessage: SkillTrends_CustomAttributes_ErrorMessage,
    SkillTrends_Declining: SkillTrends_Declining,
    SkillTrends_Emerging: SkillTrends_Emerging,
    SkillTrends_FilterByGroups: SkillTrends_FilterByGroups,
    SkillTrends_FilterBySegments: SkillTrends_FilterBySegments,
    SkillTrends_Groups_ErrorMessage: SkillTrends_Groups_ErrorMessage,
    SkillTrends_JobRoles_ErrorMessage: SkillTrends_JobRoles_ErrorMessage,
    SkillTrends_NoMatchingGroups: SkillTrends_NoMatchingGroups,
    SkillTrends_NoMatchingSegments: SkillTrends_NoMatchingSegments,
    SkillTrends_NoResultsInfo: SkillTrends_NoResultsInfo,
    SkillTrends_NoResultsLabel: SkillTrends_NoResultsLabel,
    SkillTrends_NotEnoughDataLabel: SkillTrends_NotEnoughDataLabel,
    SkillTrends_SkillGaps_Chart_NoResults: SkillTrends_SkillGaps_Chart_NoResults,
    SkillTrends_SkillGaps_Chart_NoResults_Info: SkillTrends_SkillGaps_Chart_NoResults_Info,
    SkillTrends_SkillGaps_Chart_SeriesName_SkillGap: SkillTrends_SkillGaps_Chart_SeriesName_SkillGap,
    SkillTrends_SkillGaps_Chart_SeriesName_SkillRating: SkillTrends_SkillGaps_Chart_SeriesName_SkillRating,
    SkillTrends_SkillGaps_Chart_SeriesName_SkillTarget: SkillTrends_SkillGaps_Chart_SeriesName_SkillTarget,
    SkillTrends_SkillGaps_Chart_Title: SkillTrends_SkillGaps_Chart_Title,
    SkillTrends_SkillGaps_Filters_JobRoles_Label: SkillTrends_SkillGaps_Filters_JobRoles_Label,
    SkillTrends_SkillGaps_Filters_RatingTypes_Label: SkillTrends_SkillGaps_Filters_RatingTypes_Label,
    SkillTrends_SkillGaps_Filters_RatingTypes_Option_All: SkillTrends_SkillGaps_Filters_RatingTypes_Option_All,
    SkillTrends_SkillGaps_Filters_RatingTypes_Option_Manager: SkillTrends_SkillGaps_Filters_RatingTypes_Option_Manager,
    SkillTrends_SkillGaps_Filters_RatingTypes_Option_Peer: SkillTrends_SkillGaps_Filters_RatingTypes_Option_Peer,
    SkillTrends_SkillGaps_Filters_RatingTypes_Option_Self: SkillTrends_SkillGaps_Filters_RatingTypes_Option_Self,
    SkillTrends_SkillGaps_Filters_RatingTypes_Option_SkillReview: SkillTrends_SkillGaps_Filters_RatingTypes_Option_SkillReview,
    SkillTrends_SkillGaps_NoJobRolesMessage: SkillTrends_SkillGaps_NoJobRolesMessage,
    SkillTrends_SkillGaps_Section_Title: SkillTrends_SkillGaps_Section_Title,
    SkillTrends_SkillGaps_Section_Tooltip: SkillTrends_SkillGaps_Section_Tooltip,
    SkillTrends_Tooltip_Declining: SkillTrends_Tooltip_Declining,
    SkillTrends_Tooltip_Emerging: SkillTrends_Tooltip_Emerging,
    SkillTrends_Tooltip_Trending: SkillTrends_Tooltip_Trending,
    SkillTrends_Top: SkillTrends_Top,
    SkillTrends_TopSearches_Title: SkillTrends_TopSearches_Title,
    SkillTrends_TopSearches_Tooltip: SkillTrends_TopSearches_Tooltip,
    SkillTrends_Trending: SkillTrends_Trending,
    TagRating_AskForNewRating: TagRating_AskForNewRating,
    TagRating_CancelRequest: TagRating_CancelRequest,
    TagRating_CancelRequestConfirmationFormat: TagRating_CancelRequestConfirmationFormat,
    TagRating_CancelRequestConfirmationFormatNoManager: TagRating_CancelRequestConfirmationFormatNoManager,
    TagRating_ChangeRating: TagRating_ChangeRating,
    TagRating_DeleteRatingFormat: TagRating_DeleteRatingFormat,
    TagRating_KeepRequest: TagRating_KeepRequest,
    TagRating_PendingManagerRequest: TagRating_PendingManagerRequest,
    TagRating_PendingPeerRequest: TagRating_PendingPeerRequest,
    TagRating_SkillTargetSetFormat: TagRating_SkillTargetSetFormat,
    TagRating_YouWereRatedFormat: TagRating_YouWereRatedFormat,
    TagRatingItem_TargetLevelFormat: TagRatingItem_TargetLevelFormat,
    TagsCtrl_Category: TagsCtrl_Category,
    TagsCtrl_CategoryHint: TagsCtrl_CategoryHint,
    TagsCtrl_SkillsPlaceholder: TagsCtrl_SkillsPlaceholder,
    TagsCtrl_SuggestedSkillsError: TagsCtrl_SuggestedSkillsError,
    TagsCtrl_SuggestedSkillsForSkill: TagsCtrl_SuggestedSkillsForSkill,
    TagsCtrl_SuggestedSkillsLoading: TagsCtrl_SuggestedSkillsLoading,
    TagsCtrl_SuggestedSkillsTitle: TagsCtrl_SuggestedSkillsTitle,
    TagsEdit_AddCategories: TagsEdit_AddCategories,
    TagsEdit_CategoriesMessage: TagsEdit_CategoriesMessage,
    TagsFormCtrl_AddSkillsOrTopics: TagsFormCtrl_AddSkillsOrTopics,
    TagsFormCtrl_SearchForSkill: TagsFormCtrl_SearchForSkill,
    TagsSearch_A11yTopTagsHint: TagsSearch_A11yTopTagsHint,
    TagsSearch_SkillProficiencyLevelDocumentationLabel: TagsSearch_SkillProficiencyLevelDocumentationLabel,
    TagsSvc_AddFocusSkillSuccess: TagsSvc_AddFocusSkillSuccess,
    TagsSvc_AddSkillError: TagsSvc_AddSkillError,
    TagsSvc_AddSkillsError: TagsSvc_AddSkillsError,
    TagsSvc_AddSkillsSuccess: TagsSvc_AddSkillsSuccess,
    TagsSvc_AddSkillSuccess: TagsSvc_AddSkillSuccess,
    TagsSvc_CategoryAvailable: TagsSvc_CategoryAvailable,
    TagsSvc_CategoryError: TagsSvc_CategoryError,
    TagsSvc_CategoryRetrieval: TagsSvc_CategoryRetrieval,
    TagsSvc_CategorySaves: TagsSvc_CategorySaves,
    TagsSvc_ConvertSkills: TagsSvc_ConvertSkills,
    TagsSvc_ConvertWorkdaySkillsDescription: TagsSvc_ConvertWorkdaySkillsDescription,
    TagsSvc_CreateError: TagsSvc_CreateError,
    TagsSvc_CredentialableTagsError: TagsSvc_CredentialableTagsError,
    TagsSvc_DeleteTagRatingError: TagsSvc_DeleteTagRatingError,
    TagsSvc_FocusSkillAlreadyAdded: TagsSvc_FocusSkillAlreadyAdded,
    TagsSvc_GetTagError: TagsSvc_GetTagError,
    TagsSvc_GetTagRatingDataError: TagsSvc_GetTagRatingDataError,
    TagsSvc_GetTagRatingError: TagsSvc_GetTagRatingError,
    TagsSvc_MatchingCategoryError: TagsSvc_MatchingCategoryError,
    TagsSvc_RateTagError: TagsSvc_RateTagError,
    TagsSvc_RecommendSkillError: TagsSvc_RecommendSkillError,
    TagsSvc_RemoveFocusSkillSuccess: TagsSvc_RemoveFocusSkillSuccess,
    TagsSvc_RemoveSkillError: TagsSvc_RemoveSkillError,
    TagsSvc_Replace: TagsSvc_Replace,
    TagsSvc_ReplaceFocusInterestModalDescription: TagsSvc_ReplaceFocusInterestModalDescription,
    TagsSvc_ReplaceFocusInterestModalTitle: TagsSvc_ReplaceFocusInterestModalTitle,
    TagsSvc_RequestTagRatingError: TagsSvc_RequestTagRatingError,
    TagsSvc_SkillsTagsError: TagsSvc_SkillsTagsError,
    TagsSvc_UpdateAssociateRatingSuccess: TagsSvc_UpdateAssociateRatingSuccess,
    TagsSvc_UpdateFocusSkillsError: TagsSvc_UpdateFocusSkillsError,
    TagsSvc_UpdatePrivacyError: TagsSvc_UpdatePrivacyError,
    TagsSvc_UseWorkdaySkillNames: TagsSvc_UseWorkdaySkillNames,
    TagsSvc_WorkdayCanonicalSkillConversionInstructions: TagsSvc_WorkdayCanonicalSkillConversionInstructions,
    Target_Delete: Target_Delete,
    Target_EditDetails: Target_EditDetails,
    Target_Empty: Target_Empty,
    Target_SetAuthoring: Target_SetAuthoring,
    Target_SetNotAuthoring: Target_SetNotAuthoring,
    Target_TargetLevelFormat: Target_TargetLevelFormat,
    TargetAuthorsForm_A11yAuthorDescription: TargetAuthorsForm_A11yAuthorDescription,
    TargetAuthorsForm_Authors: TargetAuthorsForm_Authors,
    TargetAuthorsForm_Save: TargetAuthorsForm_Save,
    TargetAuthorsForm_SearchPeopleGroupsPlaceHolder: TargetAuthorsForm_SearchPeopleGroupsPlaceHolder,
    TargetAuthorsForm_SearchPlaceHolder: TargetAuthorsForm_SearchPlaceHolder,
    TargetAuthorsForm_Title: TargetAuthorsForm_Title,
    TargetAuthorsForm_TitleAdd: TargetAuthorsForm_TitleAdd,
    TargetCtrl_AcceptAutosuggest: TargetCtrl_AcceptAutosuggest,
    TargetCtrl_AddDirectories: TargetCtrl_AddDirectories,
    TargetCtrl_AddDirectorys: TargetCtrl_AddDirectorys,
    TargetCtrl_AddGroups: TargetCtrl_AddGroups,
    TargetCtrl_AddInputs: TargetCtrl_AddInputs,
    TargetCtrl_AddOpportunities: TargetCtrl_AddOpportunities,
    TargetCtrl_AddPages: TargetCtrl_AddPages,
    TargetCtrl_AddPathways: TargetCtrl_AddPathways,
    TargetCtrl_AddProviders: TargetCtrl_AddProviders,
    TargetCtrl_AddTags: TargetCtrl_AddTags,
    TargetCtrl_AddTargetAndDirectoryPlural: TargetCtrl_AddTargetAndDirectoryPlural,
    TargetCtrl_AddTargetPlural: TargetCtrl_AddTargetPlural,
    TargetCtrl_AddTargets: TargetCtrl_AddTargets,
    TargetCtrl_AddUsers: TargetCtrl_AddUsers,
    TargetCtrl_AutoFill: TargetCtrl_AutoFill,
    TargetCtrl_AutosuggestNotice: TargetCtrl_AutosuggestNotice,
    TargetCtrl_ConfirmCloseButton: TargetCtrl_ConfirmCloseButton,
    TargetCtrl_ConfirmDeleteButton: TargetCtrl_ConfirmDeleteButton,
    TargetCtrl_DeleteInstructions: TargetCtrl_DeleteInstructions,
    TargetCtrl_DeletePluralPrompt: TargetCtrl_DeletePluralPrompt,
    TargetCtrl_DeletePrompt: TargetCtrl_DeletePrompt,
    TargetCtrl_DeletePromptDescription: TargetCtrl_DeletePromptDescription,
    TargetCtrl_Groups: TargetCtrl_Groups,
    TargetCtrl_Inputs: TargetCtrl_Inputs,
    TargetCtrl_NotVisibleNotice: TargetCtrl_NotVisibleNotice,
    TargetCtrl_Pathways: TargetCtrl_Pathways,
    TargetCtrl_PrimaryPlanDeselection: TargetCtrl_PrimaryPlanDeselection,
    TargetCtrl_PrimaryPlanSelection: TargetCtrl_PrimaryPlanSelection,
    TargetCtrl_SetTargetLevel: TargetCtrl_SetTargetLevel,
    TargetCtrl_SetVisible: TargetCtrl_SetVisible,
    TargetCtrl_SetVisibleNotAllowed: TargetCtrl_SetVisibleNotAllowed,
    TargetCtrl_SuggestionApplySuccess: TargetCtrl_SuggestionApplySuccess,
    TargetCtrl_Tags: TargetCtrl_Tags,
    TargetCtrl_TargetAndDirectoryPlural: TargetCtrl_TargetAndDirectoryPlural,
    TargetCtrl_TargetPlural: TargetCtrl_TargetPlural,
    TargetCtrl_Users: TargetCtrl_Users,
    TargetCtrl_WelcomeBack: TargetCtrl_WelcomeBack,
    TargetCtrl_YesAutopopulate: TargetCtrl_YesAutopopulate,
    TargetForm_AutopopulateInfo: TargetForm_AutopopulateInfo,
    TargetForm_AutopopulateTitle: TargetForm_AutopopulateTitle,
    TargetForm_CreateButton: TargetForm_CreateButton,
    TargetForm_CreateTitle: TargetForm_CreateTitle,
    TargetForm_Description: TargetForm_Description,
    TargetForm_DescriptionPlaceholder: TargetForm_DescriptionPlaceholder,
    TargetForm_EditTitle: TargetForm_EditTitle,
    TargetForm_FormDescription: TargetForm_FormDescription,
    TargetForm_IsEndorsedInfo: TargetForm_IsEndorsedInfo,
    TargetForm_IsEndorsedTitle: TargetForm_IsEndorsedTitle,
    TargetForm_Name: TargetForm_Name,
    TargetForm_NameError: TargetForm_NameError,
    TargetForm_NamePrompt: TargetForm_NamePrompt,
    TargetForm_RolePlanCreationNotice: TargetForm_RolePlanCreationNotice,
    TargetForm_SelectVisibility: TargetForm_SelectVisibility,
    TargetForm_SetPrimaryPlan: TargetForm_SetPrimaryPlan,
    TargetForm_Visibility: TargetForm_Visibility,
    TargetForm_VisibilityBoostToGroup: TargetForm_VisibilityBoostToGroup,
    TargetForm_VisibilityBoostToGroupTooltip: TargetForm_VisibilityBoostToGroupTooltip,
    TargetForm_VisibilityLimitToGroup: TargetForm_VisibilityLimitToGroup,
    TargetFormCtrl_TargetGroupsToolTip: TargetFormCtrl_TargetGroupsToolTip,
    TargetResources_AddResources: TargetResources_AddResources,
    TargetResources_CreateADirectory: TargetResources_CreateADirectory,
    TargetResources_CreateAResourceFormat: TargetResources_CreateAResourceFormat,
    TargetResources_CreateATarget: TargetResources_CreateATarget,
    TargetResources_DirectoryPlural: TargetResources_DirectoryPlural,
    TargetResources_Group: TargetResources_Group,
    TargetResources_GroupPlural: TargetResources_GroupPlural,
    TargetResources_InputPlural: TargetResources_InputPlural,
    TargetResources_NoDirectorysSelectedYet: TargetResources_NoDirectorysSelectedYet,
    TargetResources_NoGroupsSelectedYet: TargetResources_NoGroupsSelectedYet,
    TargetResources_NoTargetsSelectedYet: TargetResources_NoTargetsSelectedYet,
    TargetResources_PathwayPlural: TargetResources_PathwayPlural,
    TargetResources_ProviderPlural: TargetResources_ProviderPlural,
    TargetResources_TagPlural: TargetResources_TagPlural,
    TargetResources_Target: TargetResources_Target,
    TargetResources_TargetAndDirectoryPlural: TargetResources_TargetAndDirectoryPlural,
    TargetResources_TargetOrDirectory: TargetResources_TargetOrDirectory,
    TargetResources_TargetPlural: TargetResources_TargetPlural,
    TargetResources_UserPlural: TargetResources_UserPlural,
    TargetResourcesForm_Filters_Catalog: TargetResourcesForm_Filters_Catalog,
    TargetResourcesForm_Filters_PlansAndPathways: TargetResourcesForm_Filters_PlansAndPathways,
    TargetResourcesForm_Filters_Resources: TargetResourcesForm_Filters_Resources,
    TargetResourcesForm_InputHelp: TargetResourcesForm_InputHelp,
    TargetResourcesForm_NoResults: TargetResourcesForm_NoResults,
    TargetResourcesForm_NoResultsFound: TargetResourcesForm_NoResultsFound,
    TargetResourcesForm_ResourceAuthors: TargetResourcesForm_ResourceAuthors,
    TargetResourcesForm_SearchMixedPlaceholder: TargetResourcesForm_SearchMixedPlaceholder,
    TargetResourcesForm_SearchPlaceHolder: TargetResourcesForm_SearchPlaceHolder,
    TargetResourcesForm_Selected: TargetResourcesForm_Selected,
    TargetResourcesForm_Suggestions: TargetResourcesForm_Suggestions,
    TargetResourcesForm_Title: TargetResourcesForm_Title,
    Targets_MoveConfirmationMessage: Targets_MoveConfirmationMessage,
    Targets_MoveSuccessMessage: Targets_MoveSuccessMessage,
    TargetsCtrl_BulkChangeVisibility: TargetsCtrl_BulkChangeVisibility,
    TargetsCtrl_BulkChangeVisibilityPlural: TargetsCtrl_BulkChangeVisibilityPlural,
    TargetsCtrl_DeletePluralPrompt: TargetsCtrl_DeletePluralPrompt,
    TargetsCtrl_DeletePrompt: TargetsCtrl_DeletePrompt,
    TargetsSvc_AddAuthorError: TargetsSvc_AddAuthorError,
    TargetsSvc_AddError: TargetsSvc_AddError,
    TargetsSvc_AddResourceError: TargetsSvc_AddResourceError,
    TargetsSvc_AddSectionError: TargetsSvc_AddSectionError,
    TargetsSvc_AddSuccess: TargetsSvc_AddSuccess,
    TargetsSvc_CloneError: TargetsSvc_CloneError,
    TargetsSvc_CloneSuccess: TargetsSvc_CloneSuccess,
    TargetsSvc_DeleteAuthorError: TargetsSvc_DeleteAuthorError,
    TargetsSvc_DeleteError: TargetsSvc_DeleteError,
    TargetsSvc_DeleteResourceError: TargetsSvc_DeleteResourceError,
    TargetsSvc_DeleteSuccess: TargetsSvc_DeleteSuccess,
    TargetsSvc_DetailsError: TargetsSvc_DetailsError,
    TargetsSvc_Error: TargetsSvc_Error,
    TargetsSvc_FeaturedError: TargetsSvc_FeaturedError,
    TargetsSvc_FollowError: TargetsSvc_FollowError,
    TargetsSvc_GetUserError: TargetsSvc_GetUserError,
    TargetsSvc_MakeFeaturedNotification: TargetsSvc_MakeFeaturedNotification,
    TargetsSvc_RemoveFeaturedNotification: TargetsSvc_RemoveFeaturedNotification,
    TargetsSvc_ReorderResourceError: TargetsSvc_ReorderResourceError,
    TargetsSvc_RetrieveError: TargetsSvc_RetrieveError,
    TargetsSvc_SetNotVisibleSuccess: TargetsSvc_SetNotVisibleSuccess,
    TargetsSvc_SetTargetNameError: TargetsSvc_SetTargetNameError,
    TargetsSvc_SetVisibleSuccess: TargetsSvc_SetVisibleSuccess,
    TargetsSvc_SuggestionError: TargetsSvc_SuggestionError,
    TargetsSvc_TargetLevelError: TargetsSvc_TargetLevelError,
    TargetsSvc_TypeBrowse: TargetsSvc_TypeBrowse,
    TargetsSvc_TypeBrowse_Specific: TargetsSvc_TypeBrowse_Specific,
    TargetsSvc_TypeDirectory: TargetsSvc_TypeDirectory,
    TargetsSvc_TypeDirectory_Specific: TargetsSvc_TypeDirectory_Specific,
    TargetsSvc_TypeDirectorys: TargetsSvc_TypeDirectorys,
    TargetsSvc_TypeDirectorys_Specific: TargetsSvc_TypeDirectorys_Specific,
    TargetsSvc_TypeFeatured_Specific: TargetsSvc_TypeFeatured_Specific,
    TargetsSvc_TypeJobRole: TargetsSvc_TypeJobRole,
    TargetsSvc_TypeJobRole_Specific: TargetsSvc_TypeJobRole_Specific,
    TargetsSvc_TypeJobRoles: TargetsSvc_TypeJobRoles,
    TargetsSvc_TypeJobRoles_Specific: TargetsSvc_TypeJobRoles_Specific,
    TargetsSvc_TypeRole: TargetsSvc_TypeRole,
    TargetsSvc_TypeRole_Specific: TargetsSvc_TypeRole_Specific,
    TargetsSvc_TypeRoles: TargetsSvc_TypeRoles,
    TargetsSvc_TypeRoles_Specific: TargetsSvc_TypeRoles_Specific,
    TargetsSvc_TypeSkillPlan: TargetsSvc_TypeSkillPlan,
    TargetsSvc_TypeSkillPlan_Specific: TargetsSvc_TypeSkillPlan_Specific,
    TargetsSvc_TypeSkillPlans: TargetsSvc_TypeSkillPlans,
    TargetsSvc_TypeSkillPlans_Specific: TargetsSvc_TypeSkillPlans_Specific,
    TargetsSvc_TypeTarget: TargetsSvc_TypeTarget,
    TargetsSvc_TypeTarget_Specific: TargetsSvc_TypeTarget_Specific,
    TargetsSvc_TypeTargets: TargetsSvc_TypeTargets,
    TargetsSvc_TypeTargets_Specific: TargetsSvc_TypeTargets_Specific,
    TargetsSvc_UnfollowError: TargetsSvc_UnfollowError,
    TargetsSvc_UpdateAuthorsError: TargetsSvc_UpdateAuthorsError,
    TargetsSvc_UpdateError: TargetsSvc_UpdateError,
    TargetsSvc_UpdateSuccess: TargetsSvc_UpdateSuccess,
    TargetsSvc_UpdateVisibilityError: TargetsSvc_UpdateVisibilityError,
    TargetsSvc_UsersTitle: TargetsSvc_UsersTitle,
    TaskFormCtrl_Add: TaskFormCtrl_Add,
    TaskFormCtrl_AddImage: TaskFormCtrl_AddImage,
    TaskFormCtrl_AddToCatalogFormat: TaskFormCtrl_AddToCatalogFormat,
    TaskFormCtrl_Description: TaskFormCtrl_Description,
    TaskFormCtrl_Edit: TaskFormCtrl_Edit,
    TaskFormCtrl_ImagePreviewAltText: TaskFormCtrl_ImagePreviewAltText,
    TaskFormCtrl_Save: TaskFormCtrl_Save,
    TaskFormCtrl_Site: TaskFormCtrl_Site,
    TaskFormCtrl_Title: TaskFormCtrl_Title,
    TaskFormCtrl_TitleError: TaskFormCtrl_TitleError,
    TaskFormCtrl_Url: TaskFormCtrl_Url,
    TaskFormCtrl_ValidUrl: TaskFormCtrl_ValidUrl,
    TaskFormCtrl_WhatDidYouLearnLong: TaskFormCtrl_WhatDidYouLearnLong,
    TaskFormCtrl_WhatDidYouLearnShort: TaskFormCtrl_WhatDidYouLearnShort,
    Team_AllReports: Team_AllReports,
    Team_AllTeamMembers: Team_AllTeamMembers,
    Team_AssignmentEmailBodyDueSoon: Team_AssignmentEmailBodyDueSoon,
    Team_AssignmentEmailBodyOverdue: Team_AssignmentEmailBodyOverdue,
    Team_AssignmentLink: Team_AssignmentLink,
    Team_AssignmentName: Team_AssignmentName,
    Team_AssignmentNameDueSoon: Team_AssignmentNameDueSoon,
    Team_AssignmentNameOverdue: Team_AssignmentNameOverdue,
    Team_AssignmentReminder: Team_AssignmentReminder,
    Team_AssignmentReminders: Team_AssignmentReminders,
    Team_Assignments: Team_Assignments,
    Team_AssignmentsDueSoonDesc: Team_AssignmentsDueSoonDesc,
    Team_AssignmentsIncompleteDesc: Team_AssignmentsIncompleteDesc,
    Team_AssignmentsOverdueDesc: Team_AssignmentsOverdueDesc,
    Team_Chart_Disclaimer: Team_Chart_Disclaimer,
    Team_Chart_FullScreenText: Team_Chart_FullScreenText,
    Team_CompletionDetails: Team_CompletionDetails,
    Team_ContactAssignor: Team_ContactAssignor,
    Team_CountMandatory: Team_CountMandatory,
    Team_CountMandatorySingular: Team_CountMandatorySingular,
    Team_CountRequired: Team_CountRequired,
    Team_CountRequiredSingular: Team_CountRequiredSingular,
    Team_CustomEmailMessage: Team_CustomEmailMessage,
    Team_Customizable: Team_Customizable,
    Team_DirectReportsOnly: Team_DirectReportsOnly,
    Team_DismissAssignment: Team_DismissAssignment,
    Team_DismissAssignmentDesc: Team_DismissAssignmentDesc,
    Team_ErrorLoadingManagers: Team_ErrorLoadingManagers,
    Team_FilterbySkillsFilter_Title: Team_FilterbySkillsFilter_Title,
    Team_FocusFilterDisabledTooltip: Team_FocusFilterDisabledTooltip,
    Team_FocusFilterNoResultsTooltip: Team_FocusFilterNoResultsTooltip,
    Team_FocusLabel: Team_FocusLabel,
    Team_FocusSkills_Add: Team_FocusSkills_Add,
    Team_FocusSkills_AddFormat: Team_FocusSkills_AddFormat,
    Team_FocusSkills_Remove: Team_FocusSkills_Remove,
    Team_FocusSkills_RemoveFormat: Team_FocusSkills_RemoveFormat,
    Team_Group_Shared_And_Private_Message: Team_Group_Shared_And_Private_Message,
    Team_Insights_ActiveLearnerTitle: Team_Insights_ActiveLearnerTitle,
    Team_Insights_ActiveLearnerTooltip: Team_Insights_ActiveLearnerTooltip,
    Team_Insights_AssignedLearnings_Empty_Message: Team_Insights_AssignedLearnings_Empty_Message,
    Team_Insights_AssignedLearningsTitle: Team_Insights_AssignedLearningsTitle,
    Team_Insights_AverageCompletions_Label: Team_Insights_AverageCompletions_Label,
    Team_Insights_AveragePoints_Label: Team_Insights_AveragePoints_Label,
    Team_Insights_AveragePoints_Tooltip: Team_Insights_AveragePoints_Tooltip,
    Team_Insights_AveragePointsEarned_Label: Team_Insights_AveragePointsEarned_Label,
    Team_Insights_AvgCompletions_Label: Team_Insights_AvgCompletions_Label,
    Team_Insights_AvgCompletions_Tooltip: Team_Insights_AvgCompletions_Tooltip,
    Team_Insights_AvgPointsEarned_Label: Team_Insights_AvgPointsEarned_Label,
    Team_Insights_AvgPointsEarned_Tooltip: Team_Insights_AvgPointsEarned_Tooltip,
    Team_Insights_PopularSkillsTitle: Team_Insights_PopularSkillsTitle,
    Team_Insights_PopularSkillsTooltip: Team_Insights_PopularSkillsTooltip,
    Team_Insights_Range_Last30Days: Team_Insights_Range_Last30Days,
    Team_Insights_TotalCompletions_Label: Team_Insights_TotalCompletions_Label,
    Team_Insights_TotalCompletions_Tooltip: Team_Insights_TotalCompletions_Tooltip,
    Team_Insights_TotalPoints_Label: Team_Insights_TotalPoints_Label,
    Team_Insights_TotalPoints_Tooltip: Team_Insights_TotalPoints_Tooltip,
    Team_Insights_View_Assignment_Aria: Team_Insights_View_Assignment_Aria,
    Team_Insights_ViewAssignment: Team_Insights_ViewAssignment,
    Team_InsightSkills_NoSkillRating: Team_InsightSkills_NoSkillRating,
    Team_JobRelatedSkills: Team_JobRelatedSkills,
    Team_LearnerName: Team_LearnerName,
    Team_LearningInsights: Team_LearningInsights,
    Team_ManagerName: Team_ManagerName,
    Team_MSTeamsNotification: Team_MSTeamsNotification,
    Team_MyTeam: Team_MyTeam,
    Team_NewAssignment: Team_NewAssignment,
    Team_NoAssignments: Team_NoAssignments,
    Team_NoAssignmentsDesc: Team_NoAssignmentsDesc,
    Team_NoRating: Team_NoRating,
    Team_NotOnProfile: Team_NotOnProfile,
    Team_OptOutAutoDescription: Team_OptOutAutoDescription,
    Team_OptOutMessage: Team_OptOutMessage,
    Team_OptOutTitleModal: Team_OptOutTitleModal,
    Team_PleaseCompleteDueSoon: Team_PleaseCompleteDueSoon,
    Team_PleaseCompleteOverdue: Team_PleaseCompleteOverdue,
    Team_RatedJobSkills: Team_RatedJobSkills,
    Team_RatedSkillsHeader_Tooltip: Team_RatedSkillsHeader_Tooltip,
    Team_Rating_History_SetRating: Team_Rating_History_SetRating,
    Team_Recipients: Team_Recipients,
    Team_RecommendationSent: Team_RecommendationSent,
    Team_RecommendSkills_ButtonText: Team_RecommendSkills_ButtonText,
    Team_ReminderSent: Team_ReminderSent,
    Team_RemindersSent: Team_RemindersSent,
    Team_ReminderTypes: Team_ReminderTypes,
    Team_ScreenReader_Chart_Description_SkillSpiderChart: Team_ScreenReader_Chart_Description_SkillSpiderChart,
    Team_SelectRecipient: Team_SelectRecipient,
    Team_SelectReminder: Team_SelectReminder,
    Team_SelectReminderType: Team_SelectReminderType,
    Team_SendReminder: Team_SendReminder,
    Team_SendReminders: Team_SendReminders,
    Team_SkillInsights: Team_SkillInsights,
    Team_SkillProfile: Team_SkillProfile,
    Team_Skills: Team_Skills,
    Team_Skills_AverageRatingAction: Team_Skills_AverageRatingAction,
    Team_Skills_FocusSkill_MaxLimit: Team_Skills_FocusSkill_MaxLimit,
    Team_Skills_FocusSkillAction: Team_Skills_FocusSkillAction,
    Team_Skills_FocusSkillAction_Singular: Team_Skills_FocusSkillAction_Singular,
    Team_Skills_OnProfile: Team_Skills_OnProfile,
    Team_Skills_OnProfileAction: Team_Skills_OnProfileAction,
    Team_Skills_OnProfileAction_Singular: Team_Skills_OnProfileAction_Singular,
    Team_Skills_OpenRatingListModal: Team_Skills_OpenRatingListModal,
    Team_Skills_OptInToggle_MoM_Off: Team_Skills_OptInToggle_MoM_Off,
    Team_Skills_OptInToggle_MoM_On: Team_Skills_OptInToggle_MoM_On,
    Team_Skills_RatingCount: Team_Skills_RatingCount,
    Team_Skills_RatingCountAction: Team_Skills_RatingCountAction,
    Team_Skills_RemoveFocusSkill_Success: Team_Skills_RemoveFocusSkill_Success,
    Team_Skills_SetFocusSkill_Failure: Team_Skills_SetFocusSkill_Failure,
    Team_Skills_SetFocusSkill_Success: Team_Skills_SetFocusSkill_Success,
    Team_Skills_SkillChangePublished_NotificationContent: Team_Skills_SkillChangePublished_NotificationContent,
    Team_Skills_VisibilityTooltip: Team_Skills_VisibilityTooltip,
    Team_Skills_VisibilityTooltip_NoMoManager: Team_Skills_VisibilityTooltip_NoMoManager,
    Team_SpiderChart_BottomText: Team_SpiderChart_BottomText,
    Team_SpiderChart_LegendTitle: Team_SpiderChart_LegendTitle,
    Team_SpiderChart_PointLabel: Team_SpiderChart_PointLabel,
    Team_SpiderChart_RadarTitle: Team_SpiderChart_RadarTitle,
    Team_SubjectAssignmentNameDueSoon: Team_SubjectAssignmentNameDueSoon,
    Team_SubjectAssignmentNameOverdue: Team_SubjectAssignmentNameOverdue,
    Team_TeamFocusSkillTooltip: Team_TeamFocusSkillTooltip,
    Team_TeamFormat: Team_TeamFormat,
    Team_TeamMembers: Team_TeamMembers,
    Team_ThankYou: Team_ThankYou,
    Team_UpdateManagerRatingSuccessMessage: Team_UpdateManagerRatingSuccessMessage,
    Team_UpdatePeerRatingSuccessMessage: Team_UpdatePeerRatingSuccessMessage,
    Team_UpdateSkillTargetSuccessMessage: Team_UpdateSkillTargetSuccessMessage,
    Team_ViewReports: Team_ViewReports,
    Team_ViewSkillsProfile: Team_ViewSkillsProfile,
    Team_WelcomeBanner_Description: Team_WelcomeBanner_Description,
    Team_WelcomeBanner_Title: Team_WelcomeBanner_Title,
    TeamInsights_SpiderChart_BottomText: TeamInsights_SpiderChart_BottomText,
    TeamInsights_SpiderChart_LegendTitle: TeamInsights_SpiderChart_LegendTitle,
    TeamInsights_SpiderChart_RadarTitle: TeamInsights_SpiderChart_RadarTitle,
    TipSvc_OnboardError: TipSvc_OnboardError,
    TipSvc_OnboardResetSuccess: TipSvc_OnboardResetSuccess,
    TipSvc_SavedItemsModal: TipSvc_SavedItemsModal,
    TipSvc_SavedItemsModalHome: TipSvc_SavedItemsModalHome,
    TipSvc_ViewSavedItems: TipSvc_ViewSavedItems,
    TopCompletionsChart_CatalogTypeAllProviders: TopCompletionsChart_CatalogTypeAllProviders,
    TopCompletionsChart_CatalogTypeCatalog: TopCompletionsChart_CatalogTypeCatalog,
    TopCompletionsChart_CatalogTypeExternalCatalogProviders: TopCompletionsChart_CatalogTypeExternalCatalogProviders,
    TopCompletionsChart_CatalogTypeInternalCatalogProviders: TopCompletionsChart_CatalogTypeInternalCatalogProviders,
    TopCompletionsChart_CatalogTypeLearner: TopCompletionsChart_CatalogTypeLearner,
    TopCompletionsChart_CompletionsColumn: TopCompletionsChart_CompletionsColumn,
    TopCompletionsChart_NameColumn: TopCompletionsChart_NameColumn,
    TopCompletionsChart_NameFormat: TopCompletionsChart_NameFormat,
    TopCompletionsChart_NoResults: TopCompletionsChart_NoResults,
    TrackableLinkCtrl_AutoEnroll: TrackableLinkCtrl_AutoEnroll,
    TrackableLinkCtrl_CopiedLink: TrackableLinkCtrl_CopiedLink,
    TrackableLinkCtrl_CopyLink: TrackableLinkCtrl_CopyLink,
    TrackableLinkCtrl_CopyLinkAgain: TrackableLinkCtrl_CopyLinkAgain,
    TrackableLinkCtrl_DeleteLinkModalBodyText: TrackableLinkCtrl_DeleteLinkModalBodyText,
    TrackableLinkCtrl_DeleteLinkModalHeader: TrackableLinkCtrl_DeleteLinkModalHeader,
    TrackableLinkCtrl_EditModalTitle: TrackableLinkCtrl_EditModalTitle,
    TrackableLinkCtrl_FormTitle: TrackableLinkCtrl_FormTitle,
    TrackableLinkCtrl_FormTitlePlaceholder: TrackableLinkCtrl_FormTitlePlaceholder,
    TrackableLinkCtrl_LinkDescription: TrackableLinkCtrl_LinkDescription,
    TrackableLinkCtrl_ModalTitle: TrackableLinkCtrl_ModalTitle,
    TrackableLinkCtrl_NewLink: TrackableLinkCtrl_NewLink,
    TrackableLinkCtrl_StartTracking: TrackableLinkCtrl_StartTracking,
    TrackableLinkCtrl_TableHeaderClicks: TrackableLinkCtrl_TableHeaderClicks,
    TrackableLinkCtrl_TableHeaderCreator: TrackableLinkCtrl_TableHeaderCreator,
    TrackableLinkCtrl_TableHeaderDate: TrackableLinkCtrl_TableHeaderDate,
    TrackableLinkCtrl_TableHeaderEnrolls: TrackableLinkCtrl_TableHeaderEnrolls,
    TrackableLinkCtrl_TableHeaderLink: TrackableLinkCtrl_TableHeaderLink,
    TrackableLinkCtrl_Title: TrackableLinkCtrl_Title,
    TrackableLinkCtrl_TitleCreated: TrackableLinkCtrl_TitleCreated,
    unsubscribeTemplate_ChangeSettings: unsubscribeTemplate_ChangeSettings,
    Uploader_Canceled: Uploader_Canceled,
    Uploader_Completed: Uploader_Completed,
    Uploader_DefaultLimitNotice_Size: Uploader_DefaultLimitNotice_Size,
    Uploader_DefaultLimitNotice_Type: Uploader_DefaultLimitNotice_Type,
    Uploader_DefaultLimitNotice_TypeAndSize: Uploader_DefaultLimitNotice_TypeAndSize,
    Uploader_FileTypeError: Uploader_FileTypeError,
    Uploader_SizeLimitMet: Uploader_SizeLimitMet,
    Uploader_UnknownError: Uploader_UnknownError,
    User_Account: User_Account,
    User_AdditionalContentLanguages: User_AdditionalContentLanguages,
    User_BioLabel: User_BioLabel,
    User_CategoryExample: User_CategoryExample,
    User_CategoryExplanation: User_CategoryExplanation,
    User_CategoryQuestion: User_CategoryQuestion,
    User_ChangePassword: User_ChangePassword,
    User_CharactersRemaining: User_CharactersRemaining,
    User_Communications: User_Communications,
    User_ContentLanguage: User_ContentLanguage,
    User_DailyDigestA11yHelpText: User_DailyDigestA11yHelpText,
    User_DeleteProfile: User_DeleteProfile,
    User_DisplayLanguage: User_DisplayLanguage,
    User_Email: User_Email,
    User_EmailCommunicationsDesc: User_EmailCommunicationsDesc,
    User_EmailNotificationsDesc: User_EmailNotificationsDesc,
    User_EmailNotificationsLabel: User_EmailNotificationsLabel,
    User_EmailUpdatesDesc: User_EmailUpdatesDesc,
    User_EmailUpdatesLabel: User_EmailUpdatesLabel,
    User_Extensions: User_Extensions,
    User_Family: User_Family,
    User_FamilyAccountAdd: User_FamilyAccountAdd,
    User_FamilyAccountCreateError: User_FamilyAccountCreateError,
    User_FamilyAccountCreateSuccess: User_FamilyAccountCreateSuccess,
    User_FamilyAccountGetError: User_FamilyAccountGetError,
    User_FamilyAccountInstructions: User_FamilyAccountInstructions,
    User_FamilyAccountsHeader: User_FamilyAccountsHeader,
    User_FamilyCreateAccountFormat: User_FamilyCreateAccountFormat,
    User_FamilyEmptyStateHeader: User_FamilyEmptyStateHeader,
    User_FamilyLegendFormat: User_FamilyLegendFormat,
    User_FamilyPasswordLabel: User_FamilyPasswordLabel,
    User_FamilyProgramLabel: User_FamilyProgramLabel,
    User_FamilyUsernameLabelFormat: User_FamilyUsernameLabelFormat,
    User_FirstNameLabel: User_FirstNameLabel,
    User_Integrations: User_Integrations,
    User_LanguageExplanation: User_LanguageExplanation,
    User_LastNameLabel: User_LastNameLabel,
    User_LocationLabel: User_LocationLabel,
    User_ManagedProfileMessageFormat: User_ManagedProfileMessageFormat,
    User_Notifications: User_Notifications,
    User_NotificationsA11yHelpText: User_NotificationsA11yHelpText,
    User_PageTitle: User_PageTitle,
    User_Personal: User_Personal,
    User_PreferenceSurveysDescription: User_PreferenceSurveysDescription,
    User_PreferenceSurveysTitle: User_PreferenceSurveysTitle,
    User_PreferenceTipsDescription: User_PreferenceTipsDescription,
    User_PreferenceTipsTitle: User_PreferenceTipsTitle,
    User_PreferredContent: User_PreferredContent,
    User_Profile: User_Profile,
    User_ProfileName: User_ProfileName,
    User_ProfilePrivacyLabel: User_ProfilePrivacyLabel,
    User_ProfileUrlExplanation: User_ProfileUrlExplanation,
    User_ResetOnboarding: User_ResetOnboarding,
    User_SaveSettings: User_SaveSettings,
    User_SystemLanguage: User_SystemLanguage,
    User_SystemLanguageExplanation: User_SystemLanguageExplanation,
    User_UpdatesA11yHelpText: User_UpdatesA11yHelpText,
    "User-AddedExternalSkillsChart_Column_Added": "Ajouts",
    "User-AddedExternalSkillsChart_Column_SkillName": "Intitul\xe9 de la comp\xe9tence",
    "User-AddedExternalSkillsChart_Column_Source": "Source",
    "User-AddedExternalSkillsChart_Title": "Comp\xe9tences externes ajout\xe9es par les utilisateurs",
    "User-AddedExternalSkillsChart_TooltipText": "Comp\xe9tences ajout\xe9es aux profils des utilisateurs et non g\xe9r\xe9es par l’organisation",
    UserAssessmentSvc_AssessmentsError: UserAssessmentSvc_AssessmentsError,
    UserBookSvc_BookAccessError: UserBookSvc_BookAccessError,
    UserBookSvc_BookAddError: UserBookSvc_BookAddError,
    UserBookSvc_BookUpdateError: UserBookSvc_BookUpdateError,
    UserController_Achievements: UserController_Achievements,
    UserController_AddEmailAddress: UserController_AddEmailAddress,
    UserController_AddingSecondEmail: UserController_AddingSecondEmail,
    UserController_AddPersonalEmail: UserController_AddPersonalEmail,
    UserController_AddSkills: UserController_AddSkills,
    UserController_AddToCollectionDescription: UserController_AddToCollectionDescription,
    UserController_AddToCollectionOther: UserController_AddToCollectionOther,
    UserController_AddToCollectionSelf: UserController_AddToCollectionSelf,
    UserController_BulkEdit: UserController_BulkEdit,
    UserController_BulkEditSelectLabel: UserController_BulkEditSelectLabel,
    UserController_CaptureLearningFormat: UserController_CaptureLearningFormat,
    UserController_CategoryFilter: UserController_CategoryFilter,
    UserController_Collection: UserController_Collection,
    UserController_CollectionDescription: UserController_CollectionDescription,
    UserController_ConnectedEmail: UserController_ConnectedEmail,
    UserController_ConsumerPrimaryEmailDesc: UserController_ConsumerPrimaryEmailDesc,
    UserController_Content: UserController_Content,
    UserController_DashboardTitle: UserController_DashboardTitle,
    UserController_DegreedButton: UserController_DegreedButton,
    UserController_DegreedGroups: UserController_DegreedGroups,
    UserController_Delete: UserController_Delete,
    UserController_DeleteProfile: UserController_DeleteProfile,
    UserController_EditCategories: UserController_EditCategories,
    UserController_EmailAddress: UserController_EmailAddress,
    UserController_EmailAddressChangeInfo: UserController_EmailAddressChangeInfo,
    UserController_EmailPreferences: UserController_EmailPreferences,
    UserController_EmptyProfile: UserController_EmptyProfile,
    UserController_EnterEmail: UserController_EnterEmail,
    UserController_FilterCollection: UserController_FilterCollection,
    UserController_FindLearning: UserController_FindLearning,
    UserController_FollowersSubHeading: UserController_FollowersSubHeading,
    UserController_FollowersTitle: UserController_FollowersTitle,
    UserController_FollowFormat: UserController_FollowFormat,
    UserController_FollowingSubHeading: UserController_FollowingSubHeading,
    UserController_For: UserController_For,
    UserController_GoogleUsernamePlaceholder: UserController_GoogleUsernamePlaceholder,
    UserController_GreetingFormat: UserController_GreetingFormat,
    UserController_GroupsTitle: UserController_GroupsTitle,
    UserController_In: UserController_In,
    UserController_Insights: UserController_Insights,
    UserController_InviteAll: UserController_InviteAll,
    UserController_InviteFriends: UserController_InviteFriends,
    UserController_ItemsSelected: UserController_ItemsSelected,
    UserController_JoinGroups: UserController_JoinGroups,
    UserController_LastName: UserController_LastName,
    UserController_Loading: UserController_Loading,
    UserController_ManagedProfileMessageFormat: UserController_ManagedProfileMessageFormat,
    UserController_NameTaken: UserController_NameTaken,
    UserController_NameTakenError: UserController_NameTakenError,
    UserController_NoFriends: UserController_NoFriends,
    UserController_NoLearningTracked: UserController_NoLearningTracked,
    UserController_NoPersonalEmail: UserController_NoPersonalEmail,
    UserController_NoResults: UserController_NoResults,
    UserController_NoResultsFound: UserController_NoResultsFound,
    UserController_NoSkills: UserController_NoSkills,
    UserController_NothingCompleted: UserController_NothingCompleted,
    UserController_NotificationEmailInfoFormat: UserController_NotificationEmailInfoFormat,
    UserController_NotificationSettings: UserController_NotificationSettings,
    UserController_Opportunities: UserController_Opportunities,
    UserController_Overview: UserController_Overview,
    UserController_Pathways: UserController_Pathways,
    UserController_PersonalEmail: UserController_PersonalEmail,
    UserController_PersonalEmailEnableOptions: UserController_PersonalEmailEnableOptions,
    UserController_PersonalEmailError: UserController_PersonalEmailError,
    UserController_PersonalEmailOptions: UserController_PersonalEmailOptions,
    UserController_PostAComment: UserController_PostAComment,
    UserController_PrimaryEmailDesc: UserController_PrimaryEmailDesc,
    UserController_PrivateProfile: UserController_PrivateProfile,
    UserController_PrivateProfileExplanation: UserController_PrivateProfileExplanation,
    UserController_Profile: UserController_Profile,
    UserController_Progression: UserController_Progression,
    UserController_QueueTitle: UserController_QueueTitle,
    UserController_RecommendationsTitle: UserController_RecommendationsTitle,
    UserController_RequiredAssigned: UserController_RequiredAssigned,
    UserController_RequiredAssignedCount: UserController_RequiredAssignedCount,
    UserController_RequiredLearningTitle: UserController_RequiredLearningTitle,
    UserController_Saved: UserController_Saved,
    UserController_SaveSettingsErrorMessage: UserController_SaveSettingsErrorMessage,
    UserController_ScoreYourEducation: UserController_ScoreYourEducation,
    UserController_SecondaryEmailDesc: UserController_SecondaryEmailDesc,
    UserController_SelectAll: UserController_SelectAll,
    UserController_SelectLoginEmail: UserController_SelectLoginEmail,
    UserController_ShortQueueTitle: UserController_ShortQueueTitle,
    UserController_ShowHowFarFormat: UserController_ShowHowFarFormat,
    UserController_ShowLess: UserController_ShowLess,
    UserController_ShowMore: UserController_ShowMore,
    UserController_Skills: UserController_Skills,
    UserController_StepFour: UserController_StepFour,
    UserController_StepOne: UserController_StepOne,
    UserController_StepThree: UserController_StepThree,
    UserController_StepTwo: UserController_StepTwo,
    UserController_StopFollowingFormat: UserController_StopFollowingFormat,
    UserController_ThisUserPrivate: UserController_ThisUserPrivate,
    UserController_TodaysLearningFeedTitle: UserController_TodaysLearningFeedTitle,
    UserController_TodaysLearningTitle: UserController_TodaysLearningTitle,
    UserController_TrackLearningAltTag: UserController_TrackLearningAltTag,
    UserController_TryHere: UserController_TryHere,
    UserController_TurnOnIntegration: UserController_TurnOnIntegration,
    UserController_TwitterUsername: UserController_TwitterUsername,
    UserController_Type: UserController_Type,
    UserController_Unsubscribe: UserController_Unsubscribe,
    UserController_UnsubscribeWarning: UserController_UnsubscribeWarning,
    UserController_UnsubTitle: UserController_UnsubTitle,
    UserController_UpdateAccount: UserController_UpdateAccount,
    UserController_Verified: UserController_Verified,
    UserController_Verify: UserController_Verify,
    UserController_VerifyOwnership: UserController_VerifyOwnership,
    UserCourseSvc_CourseError: UserCourseSvc_CourseError,
    UserEmailAddress_VerificationSuccessful: UserEmailAddress_VerificationSuccessful,
    UserEmailAddressesSvc_ErrorValidatingEmail: UserEmailAddressesSvc_ErrorValidatingEmail,
    UserEpisodeSvc_EpisodeError: UserEpisodeSvc_EpisodeError,
    UserEvaluationEndorsementCompleted_NotificationTitleFormat: UserEvaluationEndorsementCompleted_NotificationTitleFormat,
    UserEvaluationEndorsementRequested_NotificationTitleFormat: UserEvaluationEndorsementRequested_NotificationTitleFormat,
    UserEventSvc_EventError: UserEventSvc_EventError,
    UserGoalsSvc_GoalAccessError: UserGoalsSvc_GoalAccessError,
    UserGoalsSvc_GoalExistsError: UserGoalsSvc_GoalExistsError,
    UserGroupsSvc_ProblemAccessingGroup: UserGroupsSvc_ProblemAccessingGroup,
    UserInfoPartial_BioModalTitle: UserInfoPartial_BioModalTitle,
    UserInfoPartial_ChangePrivacySettings: UserInfoPartial_ChangePrivacySettings,
    UserInfoPartial_EditProfile: UserInfoPartial_EditProfile,
    UserInfoPartial_FollowerCountFormat: UserInfoPartial_FollowerCountFormat,
    UserInfoPartial_FollowFormat: UserInfoPartial_FollowFormat,
    UserInfoPartial_FollowingCountFormat: UserInfoPartial_FollowingCountFormat,
    UserInfoPartial_FoundingScholar: UserInfoPartial_FoundingScholar,
    UserInfoPartial_StopFollowingFormat: UserInfoPartial_StopFollowingFormat,
    UserInfoPartial_VisibleToMe: UserInfoPartial_VisibleToMe,
    UserInfoPartial_VisibleToOrg: UserInfoPartial_VisibleToOrg,
    UserInfoPartial_VisibleToPublic: UserInfoPartial_VisibleToPublic,
    UserInfoPartial_VisibleToPublicAndOrg: UserInfoPartial_VisibleToPublicAndOrg,
    UserInputProvidersSvc_ProfileProvidersError: UserInputProvidersSvc_ProfileProvidersError,
    UserInputProvidersSvc_ProviderLicensesError: UserInputProvidersSvc_ProviderLicensesError,
    UserInputsController_Praise1: UserInputsController_Praise1,
    UserInputsController_Praise2: UserInputsController_Praise2,
    UserInputsController_Praise3: UserInputsController_Praise3,
    UserInputsController_Praise4: UserInputsController_Praise4,
    UserInputsController_Praise5: UserInputsController_Praise5,
    UserInputsController_Praise6: UserInputsController_Praise6,
    UserInputsController_Praise7: UserInputsController_Praise7,
    UserInputsController_Reward1AccomplishmentPluralFormat: UserInputsController_Reward1AccomplishmentPluralFormat,
    UserInputsController_Reward1AccomplishmentSingular: UserInputsController_Reward1AccomplishmentSingular,
    UserInputsController_Reward1ArticlePluralFormat: UserInputsController_Reward1ArticlePluralFormat,
    UserInputsController_Reward1ArticleSingular: UserInputsController_Reward1ArticleSingular,
    UserInputsController_Reward1AssessmentPluralFormat: UserInputsController_Reward1AssessmentPluralFormat,
    UserInputsController_Reward1AssessmentSingular: UserInputsController_Reward1AssessmentSingular,
    UserInputsController_Reward1AwardPluralFormat: UserInputsController_Reward1AwardPluralFormat,
    UserInputsController_Reward1AwardSingular: UserInputsController_Reward1AwardSingular,
    UserInputsController_Reward1BadgePluralFormat: UserInputsController_Reward1BadgePluralFormat,
    UserInputsController_Reward1BadgeSingular: UserInputsController_Reward1BadgeSingular,
    UserInputsController_Reward1BookPluralFormat: UserInputsController_Reward1BookPluralFormat,
    UserInputsController_Reward1BookSingular: UserInputsController_Reward1BookSingular,
    UserInputsController_Reward1CertificatePluralFormat: UserInputsController_Reward1CertificatePluralFormat,
    UserInputsController_Reward1CertificateSingular: UserInputsController_Reward1CertificateSingular,
    UserInputsController_Reward1CoursePluralFormat: UserInputsController_Reward1CoursePluralFormat,
    UserInputsController_Reward1CourseSingular: UserInputsController_Reward1CourseSingular,
    UserInputsController_Reward1DegreePluralFormat: UserInputsController_Reward1DegreePluralFormat,
    UserInputsController_Reward1DegreeSingular: UserInputsController_Reward1DegreeSingular,
    UserInputsController_Reward1EpisodePluralFormat: UserInputsController_Reward1EpisodePluralFormat,
    UserInputsController_Reward1EpisodeSingular: UserInputsController_Reward1EpisodeSingular,
    UserInputsController_Reward1EventPluralFormat: UserInputsController_Reward1EventPluralFormat,
    UserInputsController_Reward1EventSingular: UserInputsController_Reward1EventSingular,
    UserInputsController_Reward1ItemPluralFormat: UserInputsController_Reward1ItemPluralFormat,
    UserInputsController_Reward1ItemSingular: UserInputsController_Reward1ItemSingular,
    UserInputsController_Reward1PositionPluralFormat: UserInputsController_Reward1PositionPluralFormat,
    UserInputsController_Reward1PositionSingular: UserInputsController_Reward1PositionSingular,
    UserInputsController_Reward1SkillPluralFormat: UserInputsController_Reward1SkillPluralFormat,
    UserInputsController_Reward1SkillSingular: UserInputsController_Reward1SkillSingular,
    UserInputsController_Reward1VideoPluralFormat: UserInputsController_Reward1VideoPluralFormat,
    UserInputsController_Reward1VideoSingular: UserInputsController_Reward1VideoSingular,
    UserInputsController_Reward2AccomplishmentPluralFormat: UserInputsController_Reward2AccomplishmentPluralFormat,
    UserInputsController_Reward2AccomplishmentSingular: UserInputsController_Reward2AccomplishmentSingular,
    UserInputsController_Reward2ArticlePluralFormat: UserInputsController_Reward2ArticlePluralFormat,
    UserInputsController_Reward2ArticleSingular: UserInputsController_Reward2ArticleSingular,
    UserInputsController_Reward2AssessmentPluralFormat: UserInputsController_Reward2AssessmentPluralFormat,
    UserInputsController_Reward2AssessmentSingular: UserInputsController_Reward2AssessmentSingular,
    UserInputsController_Reward2AwardPluralFormat: UserInputsController_Reward2AwardPluralFormat,
    UserInputsController_Reward2AwardSingular: UserInputsController_Reward2AwardSingular,
    UserInputsController_Reward2BadgePluralFormat: UserInputsController_Reward2BadgePluralFormat,
    UserInputsController_Reward2BadgeSingular: UserInputsController_Reward2BadgeSingular,
    UserInputsController_Reward2BookPluralFormat: UserInputsController_Reward2BookPluralFormat,
    UserInputsController_Reward2BookSingular: UserInputsController_Reward2BookSingular,
    UserInputsController_Reward2CertificatePluralFormat: UserInputsController_Reward2CertificatePluralFormat,
    UserInputsController_Reward2CertificateSingular: UserInputsController_Reward2CertificateSingular,
    UserInputsController_Reward2CoursePluralFormat: UserInputsController_Reward2CoursePluralFormat,
    UserInputsController_Reward2CourseSingular: UserInputsController_Reward2CourseSingular,
    UserInputsController_Reward2DegreePluralFormat: UserInputsController_Reward2DegreePluralFormat,
    UserInputsController_Reward2DegreeSingular: UserInputsController_Reward2DegreeSingular,
    UserInputsController_Reward2EpisodePluralFormat: UserInputsController_Reward2EpisodePluralFormat,
    UserInputsController_Reward2EpisodeSingular: UserInputsController_Reward2EpisodeSingular,
    UserInputsController_Reward2EventPluralFormat: UserInputsController_Reward2EventPluralFormat,
    UserInputsController_Reward2EventSingular: UserInputsController_Reward2EventSingular,
    UserInputsController_Reward2ItemPluralFormat: UserInputsController_Reward2ItemPluralFormat,
    UserInputsController_Reward2ItemSingular: UserInputsController_Reward2ItemSingular,
    UserInputsController_Reward2PositionPluralFormat: UserInputsController_Reward2PositionPluralFormat,
    UserInputsController_Reward2PositionSingular: UserInputsController_Reward2PositionSingular,
    UserInputsController_Reward2SkillPluralFormat: UserInputsController_Reward2SkillPluralFormat,
    UserInputsController_Reward2SkillSingular: UserInputsController_Reward2SkillSingular,
    UserInputsController_Reward2VideoPluralFormat: UserInputsController_Reward2VideoPluralFormat,
    UserInputsController_Reward2VideoSingular: UserInputsController_Reward2VideoSingular,
    UserInputsSvc_AccessProfileError: UserInputsSvc_AccessProfileError,
    UserInputsSvc_AddToProfileError: UserInputsSvc_AddToProfileError,
    UserInputsSvc_DeleteFromProfileError: UserInputsSvc_DeleteFromProfileError,
    UserInputsSvc_SuccessfulAddNotifyFormat: UserInputsSvc_SuccessfulAddNotifyFormat,
    UserInputsSvc_UpdateProfileError: UserInputsSvc_UpdateProfileError,
    UserInsightsSvc_ErrorLearningCounts: UserInsightsSvc_ErrorLearningCounts,
    UserInsightsSvc_ErrorPersonalInfo: UserInsightsSvc_ErrorPersonalInfo,
    UserMediaSvc_MediaError: UserMediaSvc_MediaError,
    UserOrganizationSvc_NotificationError: UserOrganizationSvc_NotificationError,
    UserOutcomeDegreeSvc_AddingCoursesError: UserOutcomeDegreeSvc_AddingCoursesError,
    UserOutcomeDegreeSvc_Associates: UserOutcomeDegreeSvc_Associates,
    UserOutcomeDegreeSvc_Bachelors: UserOutcomeDegreeSvc_Bachelors,
    UserOutcomeDegreeSvc_Diploma: UserOutcomeDegreeSvc_Diploma,
    UserOutcomeDegreeSvc_Doctorate: UserOutcomeDegreeSvc_Doctorate,
    UserOutcomeDegreeSvc_Magister: UserOutcomeDegreeSvc_Magister,
    UserOutcomeDegreeSvc_Masters: UserOutcomeDegreeSvc_Masters,
    UserOutcomeDegreeSvc_PartialAssociates: UserOutcomeDegreeSvc_PartialAssociates,
    UserOutcomeDegreeSvc_PartialBachelors: UserOutcomeDegreeSvc_PartialBachelors,
    UserOutcomeDegreeSvc_PartialDoctorate: UserOutcomeDegreeSvc_PartialDoctorate,
    UserOutcomeDegreeSvc_PartialMasters: UserOutcomeDegreeSvc_PartialMasters,
    UserOutcomeDegreeSvc_PreDiploma: UserOutcomeDegreeSvc_PreDiploma,
    UserOutcomeSkillSvc_EightToTen: UserOutcomeSkillSvc_EightToTen,
    UserOutcomeSkillSvc_ElevenToFourteen: UserOutcomeSkillSvc_ElevenToFourteen,
    UserOutcomeSkillSvc_FifteenToTwenty: UserOutcomeSkillSvc_FifteenToTwenty,
    UserOutcomeSkillSvc_FiveToSeven: UserOutcomeSkillSvc_FiveToSeven,
    UserOutcomeSkillSvc_TwentyPlus: UserOutcomeSkillSvc_TwentyPlus,
    UserOutcomeSkillSvc_TwoToFour: UserOutcomeSkillSvc_TwoToFour,
    UserOutcomeSkillSvc_ZeroToOne: UserOutcomeSkillSvc_ZeroToOne,
    UserOutcomeSvc_AddingError: UserOutcomeSvc_AddingError,
    UserOutcomeSvc_RemovingError: UserOutcomeSvc_RemovingError,
    UserOutcomeSvc_RetreivingError: UserOutcomeSvc_RetreivingError,
    UserOutcomeSvc_UpdatingError: UserOutcomeSvc_UpdatingError,
    UserPositionSvc_ExperienceError: UserPositionSvc_ExperienceError,
    UserPrivacyCtrl_Continue: UserPrivacyCtrl_Continue,
    UserPrivacyCtrl_Organization: UserPrivacyCtrl_Organization,
    UserPrivacyCtrl_PrivacyWarningHeader: UserPrivacyCtrl_PrivacyWarningHeader,
    UserPrivacyCtrl_ToOrgProfileFormat: UserPrivacyCtrl_ToOrgProfileFormat,
    UserPrivacyCtrl_ToOrgProfileFromAnonymousFormat: UserPrivacyCtrl_ToOrgProfileFromAnonymousFormat,
    UserPrivacyCtrl_ToPrivateProfile: UserPrivacyCtrl_ToPrivateProfile,
    UserPrivacyCtrl_ToPrivateProfileInOrgFormat: UserPrivacyCtrl_ToPrivateProfileInOrgFormat,
    UserPrivacyCtrl_ToPrivateProfileInOrgFromAnonymousFormat: UserPrivacyCtrl_ToPrivateProfileInOrgFromAnonymousFormat,
    UserPrivacyCtrl_ToPublicProfile: UserPrivacyCtrl_ToPublicProfile,
    UserPrivacyCtrl_ToPublicProfileInOrgFormat: UserPrivacyCtrl_ToPublicProfileInOrgFormat,
    UserPrivacyCtrl_ToPublicProfileInOrgFromAnonymousFormat: UserPrivacyCtrl_ToPublicProfileInOrgFromAnonymousFormat,
    UserPrivacyCtrl_YourOrganization: UserPrivacyCtrl_YourOrganization,
    UserProfileSvc_ProblemAccessingCollection: UserProfileSvc_ProblemAccessingCollection,
    UserProfileSvc_ProblemAccessingSignalSummary: UserProfileSvc_ProblemAccessingSignalSummary,
    UserProfileSvc_ProblemDeletingCollectionItem: UserProfileSvc_ProblemDeletingCollectionItem,
    UserProfileSvc_ProblemUpdatingCollectionItem: UserProfileSvc_ProblemUpdatingCollectionItem,
    UserProfileSvc_ProblemUpdatingSkillCheckup: UserProfileSvc_ProblemUpdatingSkillCheckup,
    userRated_Format: userRated_Format,
    UserSettingsSvc_CommunicationSettingsSaved: UserSettingsSvc_CommunicationSettingsSaved,
    UserSettingsSvc_CommunicationSettingsSavedFailed: UserSettingsSvc_CommunicationSettingsSavedFailed,
    UserSettingsSvc_DescAssignedLearning: UserSettingsSvc_DescAssignedLearning,
    UserSettingsSvc_DescAssignmentReminder: UserSettingsSvc_DescAssignmentReminder,
    UserSettingsSvc_DescEndorsementRequest: UserSettingsSvc_DescEndorsementRequest,
    UserSettingsSvc_DescFollowers: UserSettingsSvc_DescFollowers,
    UserSettingsSvc_DescFollowingActivity: UserSettingsSvc_DescFollowingActivity,
    UserSettingsSvc_DescGoals: UserSettingsSvc_DescGoals,
    UserSettingsSvc_DescGroupPostAdded: UserSettingsSvc_DescGroupPostAdded,
    UserSettingsSvc_DescMention: UserSettingsSvc_DescMention,
    UserSettingsSvc_DescNewComment: UserSettingsSvc_DescNewComment,
    UserSettingsSvc_DescNewGoal: UserSettingsSvc_DescNewGoal,
    UserSettingsSvc_DescRecommendations: UserSettingsSvc_DescRecommendations,
    UserSettingsSvc_DescReplyComment: UserSettingsSvc_DescReplyComment,
    UserSettingsSvc_DescSocialNotify: UserSettingsSvc_DescSocialNotify,
    UserSettingsSvc_DescTodaysLearning: UserSettingsSvc_DescTodaysLearning,
    UserSettingsSvc_EmailAddressesError: UserSettingsSvc_EmailAddressesError,
    UserSettingsSvc_JobRoleSaveFailed: UserSettingsSvc_JobRoleSaveFailed,
    UserSettingsSvc_NotificationSettingsSaved: UserSettingsSvc_NotificationSettingsSaved,
    UserSettingsSvc_NotificationSettingsSavedFailed: UserSettingsSvc_NotificationSettingsSavedFailed,
    UserSettingsSvc_NotificationTestSendFailed: UserSettingsSvc_NotificationTestSendFailed,
    UserSettingsSvc_NotificationTestSent: UserSettingsSvc_NotificationTestSent,
    UserSettingsSvc_NotificationTypeDisplayText106: UserSettingsSvc_NotificationTypeDisplayText106,
    UserSettingsSvc_NotificationTypeDisplayText34: UserSettingsSvc_NotificationTypeDisplayText34,
    UserSettingsSvc_NotificationTypeDisplayText35: UserSettingsSvc_NotificationTypeDisplayText35,
    UserSettingsSvc_NotificationTypeDisplayText37: UserSettingsSvc_NotificationTypeDisplayText37,
    UserSettingsSvc_NotificationTypeDisplayText61: UserSettingsSvc_NotificationTypeDisplayText61,
    UserSettingsSvc_NotificationTypeDisplayText77: UserSettingsSvc_NotificationTypeDisplayText77,
    UserSettingsSvc_PrivacySettingsSaved: UserSettingsSvc_PrivacySettingsSaved,
    UserSettingsSvc_PrivacySettingsSaveFailed: UserSettingsSvc_PrivacySettingsSaveFailed,
    UserSettingsSvc_SettingsNotPublic: UserSettingsSvc_SettingsNotPublic,
    UserSettingsSvc_TryLoggingIn: UserSettingsSvc_TryLoggingIn,
    UsersSvc_FindUsersError: UsersSvc_FindUsersError,
    UsersSvc_GetOpportunityPreferencesError: UsersSvc_GetOpportunityPreferencesError,
    UsersSvc_GetRecommendedError: UsersSvc_GetRecommendedError,
    UsersSvc_GetUserError: UsersSvc_GetUserError,
    UsersSvc_UpdateOpportunityPreferencesError: UsersSvc_UpdateOpportunityPreferencesError,
    UserStaticSettingsSvc_AssociatedPersonalEmail: UserStaticSettingsSvc_AssociatedPersonalEmail,
    UserStaticSettingsSvc_DuplicateOrgEmail: UserStaticSettingsSvc_DuplicateOrgEmail,
    UserStaticSettingsSvc_DuplicateProfileName: UserStaticSettingsSvc_DuplicateProfileName,
    UserStaticSettingsSvc_Failure: UserStaticSettingsSvc_Failure,
    UserStaticSettingsSvc_InvalidPersonalEmail: UserStaticSettingsSvc_InvalidPersonalEmail,
    UserStaticSettingsSvc_InvalidProfileName: UserStaticSettingsSvc_InvalidProfileName,
    UserStaticSettingsSvc_Success: UserStaticSettingsSvc_Success,
    UserTagRatingCompleted_NotificationTitleFormat: UserTagRatingCompleted_NotificationTitleFormat,
    UserTagRatingRequested_Complete_NotificationTitleFormat: UserTagRatingRequested_Complete_NotificationTitleFormat,
    UserTagRatingRequested_NotificationTitleFormat: UserTagRatingRequested_NotificationTitleFormat,
    UserTagRatingRequested_Self_CompleteNotificationTitleFormat: UserTagRatingRequested_Self_CompleteNotificationTitleFormat,
    UserTagRatingRequested_Self_NotificationTitleFormat: UserTagRatingRequested_Self_NotificationTitleFormat,
    UserTaskSvc_Error: UserTaskSvc_Error,
    verificationForm_AuthInstructions: verificationForm_AuthInstructions,
    verificationForm_AuthLoginLink: verificationForm_AuthLoginLink,
    verificationForm_AuthPasswordLabel: verificationForm_AuthPasswordLabel,
    verificationForm_AuthTitle: verificationForm_AuthTitle,
    verificationForm_Change: verificationForm_Change,
    verificationForm_EmailLabel: verificationForm_EmailLabel,
    verificationForm_ErrorGettingForm: verificationForm_ErrorGettingForm,
    verificationForm_ErrorSavingForm: verificationForm_ErrorSavingForm,
    verificationForm_FirstNameLabel: verificationForm_FirstNameLabel,
    verificationForm_LastNameLabel: verificationForm_LastNameLabel,
    verificationForm_LinkedInLabel: verificationForm_LinkedInLabel,
    verificationForm_LinkedInPlaceholder: verificationForm_LinkedInPlaceholder,
    verificationForm_Optional: verificationForm_Optional,
    verificationForm_PhoneLabel: verificationForm_PhoneLabel,
    verificationForm_PhonePlaceholder: verificationForm_PhonePlaceholder,
    verificationForm_PhotoLabel: verificationForm_PhotoLabel,
    verificationForm_PhotoRequirements: verificationForm_PhotoRequirements,
    verificationForm_PhotoTileLabel: verificationForm_PhotoTileLabel,
    verificationForm_Submit: verificationForm_Submit,
    verificationForm_TwitterLabel: verificationForm_TwitterLabel,
    verificationForm_TwitterPlaceholder: verificationForm_TwitterPlaceholder,
    verificationModal_ImageAlt: verificationModal_ImageAlt,
    verificationModal_Instructions: verificationModal_Instructions,
    verificationModal_ProvidePhoto: verificationModal_ProvidePhoto,
    verificationModal_RequiredPhoto: verificationModal_RequiredPhoto,
    verificationModal_Submit: verificationModal_Submit,
    Webhooks_ActivityDownload: Webhooks_ActivityDownload,
    Webhooks_ActivityDownloadConfirmation: Webhooks_ActivityDownloadConfirmation,
    Webhooks_ActivityDownloadLogBtn: Webhooks_ActivityDownloadLogBtn,
    Webhooks_ActivityDownloadSuccessfully: Webhooks_ActivityDownloadSuccessfully,
    Webhooks_ActivityFilterCheckbox: Webhooks_ActivityFilterCheckbox,
    Webhooks_ActivityLog: Webhooks_ActivityLog,
    Webhooks_ActivityLogDescription: Webhooks_ActivityLogDescription,
    Webhooks_ActivityLogErrorOrgid: Webhooks_ActivityLogErrorOrgid,
    Webhooks_ActivityLogEventType: Webhooks_ActivityLogEventType,
    Webhooks_ActivityLogFailed: Webhooks_ActivityLogFailed,
    Webhooks_ActivityLogInvalid: Webhooks_ActivityLogInvalid,
    Webhooks_ActivityLogNoLogs: Webhooks_ActivityLogNoLogs,
    Webhooks_ActivityLogRefresh: Webhooks_ActivityLogRefresh,
    Webhooks_ActivityLogResponseCode: Webhooks_ActivityLogResponseCode,
    Webhooks_ActivityLogResponseTime: Webhooks_ActivityLogResponseTime,
    Webhooks_ActivityLogRetries: Webhooks_ActivityLogRetries,
    Webhooks_ActivityLogRetryCopyPaylod: Webhooks_ActivityLogRetryCopyPaylod,
    Webhooks_ActivityLogTimestamp: Webhooks_ActivityLogTimestamp,
    Webhooks_ActivityLogTry: Webhooks_ActivityLogTry,
    Webhooks_ActivityLogView: Webhooks_ActivityLogView,
    Webhooks_ActivityRetriesQueue: Webhooks_ActivityRetriesQueue,
    Webhooks_ActivityViewLog: Webhooks_ActivityViewLog,
    Webhooks_AddWebhook: Webhooks_AddWebhook,
    Webhooks_AuthorizationType: Webhooks_AuthorizationType,
    Webhooks_AvgLatency: Webhooks_AvgLatency,
    Webhooks_AvgTime: Webhooks_AvgTime,
    Webhooks_CreateWebhook: Webhooks_CreateWebhook,
    Webhooks_DeleteSuccessfully: Webhooks_DeleteSuccessfully,
    Webhooks_DeleteWebhook: Webhooks_DeleteWebhook,
    Webhooks_DeleteWebhookConfirmationMessage: Webhooks_DeleteWebhookConfirmationMessage,
    Webhooks_DeleteWebhookConfirmationPrimaryBtn: Webhooks_DeleteWebhookConfirmationPrimaryBtn,
    Webhooks_DeleteWebhookConfirmationSecondaryBtn: Webhooks_DeleteWebhookConfirmationSecondaryBtn,
    Webhooks_DescriptionAddWebhook: Webhooks_DescriptionAddWebhook,
    Webhooks_EndpointUrl: Webhooks_EndpointUrl,
    Webhooks_ErrorCreatingOrUpdatingWebhook: Webhooks_ErrorCreatingOrUpdatingWebhook,
    Webhooks_Events_LearningProgressEvent: Webhooks_Events_LearningProgressEvent,
    Webhooks_Events_LearningProgressEvent_Description: Webhooks_Events_LearningProgressEvent_Description,
    Webhooks_Events_PathwayCompletedEvent: Webhooks_Events_PathwayCompletedEvent,
    Webhooks_Events_PathwayCompletedEvent_Description: Webhooks_Events_PathwayCompletedEvent_Description,
    Webhooks_Events_PathwayCreatedEvent: Webhooks_Events_PathwayCreatedEvent,
    Webhooks_Events_PathwayCreatedEvent_Description: Webhooks_Events_PathwayCreatedEvent_Description,
    Webhooks_Events_PathwayEnrolledEvent: Webhooks_Events_PathwayEnrolledEvent,
    Webhooks_Events_PathwayEnrolledEvent_Description: Webhooks_Events_PathwayEnrolledEvent_Description,
    Webhooks_Events_PathwayUnenrolledEvent: Webhooks_Events_PathwayUnenrolledEvent,
    Webhooks_Events_PathwayUnenrolledEvent_Description: Webhooks_Events_PathwayUnenrolledEvent_Description,
    Webhooks_Events_PathwayUpdatedEvent: Webhooks_Events_PathwayUpdatedEvent,
    Webhooks_Events_PathwayUpdatedEvent_Description: Webhooks_Events_PathwayUpdatedEvent_Description,
    Webhooks_Events_PathwayViewedEvent: Webhooks_Events_PathwayViewedEvent,
    Webhooks_Events_PathwayViewedEvent_Description: Webhooks_Events_PathwayViewedEvent_Description,
    Webhooks_Events_QueueItemCreatedEvent: Webhooks_Events_QueueItemCreatedEvent,
    Webhooks_Events_QueueItemCreatedEvent_Description: Webhooks_Events_QueueItemCreatedEvent_Description,
    Webhooks_Events_QueueItemRemovedEvent: Webhooks_Events_QueueItemRemovedEvent,
    Webhooks_Events_QueueItemRemovedEvent_Description: Webhooks_Events_QueueItemRemovedEvent_Description,
    Webhooks_Events_RecommendationCreatedEvent: Webhooks_Events_RecommendationCreatedEvent,
    Webhooks_Events_RecommendationCreatedEvent_Description: Webhooks_Events_RecommendationCreatedEvent_Description,
    Webhooks_Events_TargetCreatedEvent: Webhooks_Events_TargetCreatedEvent,
    Webhooks_Events_TargetCreatedEvent_Description: Webhooks_Events_TargetCreatedEvent_Description,
    Webhooks_Events_TargetDeletedEvent: Webhooks_Events_TargetDeletedEvent,
    Webhooks_Events_TargetDeletedEvent_Description: Webhooks_Events_TargetDeletedEvent_Description,
    Webhooks_Events_TargetFollowedEvent: Webhooks_Events_TargetFollowedEvent,
    Webhooks_Events_TargetFollowedEvent_Description: Webhooks_Events_TargetFollowedEvent_Description,
    Webhooks_Events_TargetUnfollowedEvent: Webhooks_Events_TargetUnfollowedEvent,
    Webhooks_Events_TargetUnfollowedEvent_Description: Webhooks_Events_TargetUnfollowedEvent_Description,
    Webhooks_Events_UserCommentAddedEvent: Webhooks_Events_UserCommentAddedEvent,
    Webhooks_Events_UserCommentAddedEvent_Description: Webhooks_Events_UserCommentAddedEvent_Description,
    Webhooks_Events_UserCommentDeletedEvent: Webhooks_Events_UserCommentDeletedEvent,
    Webhooks_Events_UserCommentDeletedEvent_Description: Webhooks_Events_UserCommentDeletedEvent_Description,
    Webhooks_Events_UserCreatedGroupEvent: Webhooks_Events_UserCreatedGroupEvent,
    Webhooks_Events_UserCreatedGroupEvent_Description: Webhooks_Events_UserCreatedGroupEvent_Description,
    Webhooks_Events_UserDeletedGroupEvent: Webhooks_Events_UserDeletedGroupEvent,
    Webhooks_Events_UserDeletedGroupEvent_Description: Webhooks_Events_UserDeletedGroupEvent_Description,
    Webhooks_Events_UserFollowedEvent: Webhooks_Events_UserFollowedEvent,
    Webhooks_Events_UserFollowedEvent_Description: Webhooks_Events_UserFollowedEvent_Description,
    Webhooks_Events_UserInputCreatedEvent: Webhooks_Events_UserInputCreatedEvent,
    Webhooks_Events_UserInputCreatedEvent_Description: Webhooks_Events_UserInputCreatedEvent_Description,
    Webhooks_Events_UserInputViewedEvent: Webhooks_Events_UserInputViewedEvent,
    Webhooks_Events_UserInputViewedEvent_Description: Webhooks_Events_UserInputViewedEvent_Description,
    Webhooks_Events_UserInterestAddedEvent: Webhooks_Events_UserInterestAddedEvent,
    Webhooks_Events_UserInterestAddedEvent_Description: Webhooks_Events_UserInterestAddedEvent_Description,
    Webhooks_Events_UserInterestRemovedEvent: Webhooks_Events_UserInterestRemovedEvent,
    Webhooks_Events_UserInterestRemovedEvent_Description: Webhooks_Events_UserInterestRemovedEvent_Description,
    Webhooks_Events_UserInvitedToGroupEvent: Webhooks_Events_UserInvitedToGroupEvent,
    Webhooks_Events_UserInvitedToGroupEvent_Description: Webhooks_Events_UserInvitedToGroupEvent_Description,
    Webhooks_Events_UserJoinedGroupEvent: Webhooks_Events_UserJoinedGroupEvent,
    Webhooks_Events_UserJoinedGroupEvent_Description: Webhooks_Events_UserJoinedGroupEvent_Description,
    Webhooks_Events_UserLeftGroupEvent: Webhooks_Events_UserLeftGroupEvent,
    Webhooks_Events_UserLeftGroupEvent_Description: Webhooks_Events_UserLeftGroupEvent_Description,
    Webhooks_Events_UserLoginEvent: Webhooks_Events_UserLoginEvent,
    Webhooks_Events_UserLoginEvent_Description: Webhooks_Events_UserLoginEvent_Description,
    Webhooks_Events_UserResourceDeletedEvent: Webhooks_Events_UserResourceDeletedEvent,
    Webhooks_Events_UserResourceDeletedEvent_Description: Webhooks_Events_UserResourceDeletedEvent_Description,
    Webhooks_Events_UserResourceRatingEvent: Webhooks_Events_UserResourceRatingEvent,
    Webhooks_Events_UserResourceRatingEvent_Description: Webhooks_Events_UserResourceRatingEvent_Description,
    Webhooks_Events_UserTagRatingCompletedEvent: Webhooks_Events_UserTagRatingCompletedEvent,
    Webhooks_Events_UserTagRatingCompletedEvent_Description: Webhooks_Events_UserTagRatingCompletedEvent_Description,
    Webhooks_EventsSelected: Webhooks_EventsSelected,
    Webhooks_EventType: Webhooks_EventType,
    Webhooks_EventTypesColumn: Webhooks_EventTypesColumn,
    Webhooks_Get: Webhooks_Get,
    Webhooks_Heading: Webhooks_Heading,
    Webhooks_HeadingManage: Webhooks_HeadingManage,
    Webhooks_HeadingNew: Webhooks_HeadingNew,
    Webhooks_HMAC: Webhooks_HMAC,
    Webhooks_HMACSecret: Webhooks_HMACSecret,
    Webhooks_HMACSecretEncrypted: Webhooks_HMACSecretEncrypted,
    Webhooks_HMACSignatureHeader: Webhooks_HMACSignatureHeader,
    Webhooks_HMACSignatureHeaderEncrypted: Webhooks_HMACSignatureHeaderEncrypted,
    Webhooks_ID: Webhooks_ID,
    Webhooks_NoWebhook: Webhooks_NoWebhook,
    Webhooks_OAuth2: Webhooks_OAuth2,
    Webhooks_OAuthClientUrl: Webhooks_OAuthClientUrl,
    Webhooks_On: Webhooks_On,
    Webhooks_Paused: Webhooks_Paused,
    Webhooks_Payload: Webhooks_Payload,
    Webhooks_PayloadsSent: Webhooks_PayloadsSent,
    Webhooks_PayloadType: Webhooks_PayloadType,
    Webhooks_Security: Webhooks_Security,
    Webhooks_Status_Failure: Webhooks_Status_Failure,
    Webhooks_Status_Retry: Webhooks_Status_Retry,
    Webhooks_Status_Retry2: Webhooks_Status_Retry2,
    Webhooks_Status_Retry3: Webhooks_Status_Retry3,
    Webhooks_Status_Success: Webhooks_Status_Success,
    Webhooks_Status_WebhookCreated: Webhooks_Status_WebhookCreated,
    Webhooks_Stopped: Webhooks_Stopped,
    Webhooks_Test: Webhooks_Test,
    Webhooks_TestDescription: Webhooks_TestDescription,
    Webhooks_WebhookCreatedSuccessfully: Webhooks_WebhookCreatedSuccessfully,
    Webhooks_WebhookName: Webhooks_WebhookName,
    Webhooks_WebhookUpdatedSuccessfully: Webhooks_WebhookUpdatedSuccessfully,
    workdaySkillAdded_Plural: workdaySkillAdded_Plural,
    workdaySkillAdded_Single: workdaySkillAdded_Single,
    workdaySkillAdded_WorkdayIntegrationDisabled: workdaySkillAdded_WorkdayIntegrationDisabled,
    workdaySkillAdded_WorkdayIntegrationEnabled: workdaySkillAdded_WorkdayIntegrationEnabled,
    workdaySkillRemoved_Message: workdaySkillRemoved_Message,
    workdaySkillRemoved_Plural: workdaySkillRemoved_Plural,
    workdaySkillRemoved_Single: workdaySkillRemoved_Single
};

function asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator$2(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator$2(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
// type AllSettledResponse = { status: 'fulfilled'; value: unknown } | { status: 'rejected'; reason: unknown };
/**
 * Load desired lang translations first, then load all other translations in background
 * @param lang
 * @param addResources
 */ var loadAllTranslations = function() {
    var _ref = _async_to_generator$2(function(lang, addResources) {
        var translations;
        return _ts_generator$2(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        loadTranslations(lang)
                    ];
                case 1:
                    translations = _state.sent();
                    addResources(lang, "translation", translations);
                    // Why is this batch loading needed; when an on-demand load works fine?
                    // const otherLocales = LOCALES.filter((locale) => locale !== lang);
                    // batchLoadTranslations(otherLocales, addResources);
                    return [
                        2,
                        translations
                    ];
            }
        });
    });
    return function loadAllTranslations(lang, addResources) {
        return _ref.apply(this, arguments);
    };
}();
// ****************************************************
// Private Utils
// ****************************************************
var sameOriginRequestInit$1 = {
    credentials: "same-origin",
    method: "GET",
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
    }
};
var paramsFor = function(culture) {
    return new URLSearchParams({
        format: "Json",
        culture: culture,
        "dg-casing": "camel"
    });
};
// const LOCALES = [
//   'ar',
//   'cs',
//   'da',
//   'en',
//   'en_gb',
//   'es',
//   'es_419',
//   'fr',
//   'de',
//   'el',
//   'he',
//   'hu',
//   'id',
//   'it',
//   'ja',
//   'ko',
//   'nl',
//   'pl',
//   'pt',
//   'ro',
//   'ru',
//   'sv',
//   'th',
//   'tr',
//   'vi',
//   'zh',
// ] as const;
/**
 * Internal flag to track if the API is available
 */ var apiAvailable = true;
/**
 * Load all translations in background (silently)
 */ // const batchLoadTranslations = async (locales: string[], addResources: i18nAddResourcesFn) => {
//   const loadByLocale = async (locale: string) => {
//     const translations = await loadTranslations(locale);
//     addResources(locale, 'translation', translations);
//   };
//   if (apiAvailable) {
//     const registerResources = (list: AllSettledResponse[]) => {
//       list.forEach((result, i) => {
//         if (result.status !== 'rejected') {
//           addResources(locales[i], 'translation', result.value);
//         }
//       });
//     };
//     // If the API is not available, we will not try to fetch translations again
//     Promise.allSettled(locales.map(loadByLocale)).then(registerResources);
//   }
// };
/**
 * For local development, the API may not be available. Fail gracefully.
 */ var loadTranslations = function() {
    var _ref = _async_to_generator$2(function() {
        var culture, translations, url, response;
        var _arguments = arguments;
        return _ts_generator$2(this, function(_state) {
            switch(_state.label){
                case 0:
                    culture = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "en";
                    translations = culture === "fr" ? localTranslationsFr : culture === "en" ? localTranslationsEn : {};
                    if (!apiAvailable) return [
                        3,
                        4
                    ];
                    url = "/api/translations/translate";
                    return [
                        4,
                        fetch("".concat(url, "?").concat(paramsFor(culture)), sameOriginRequestInit$1)
                    ];
                case 1:
                    response = _state.sent();
                    if (!(response.status === 200)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    translations = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    apiAvailable = false;
                    _state.label = 4;
                case 4:
                    return [
                        2,
                        translations
                    ];
            }
        });
    });
    return function loadTranslations() {
        return _ref.apply(this, arguments);
    };
}();

function _array_like_to_array$2(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$2(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit$2(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$2() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array$2(arr, i) {
    return _array_with_holes$2(arr) || _iterable_to_array_limit$2(arr, i) || _unsupported_iterable_to_array$2(arr, i) || _non_iterable_rest$2();
}
function _unsupported_iterable_to_array$2(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$2(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$2(o, minLen);
}
var initialized = false;
/**
 * 1x Initialization of i18next for React
 */ var initForReact = function(lang) {
    if (initialized) return;
    instance.use(initReactI18next) // passes i18n down to react-i18next
    .init({
        lng: lang,
        fallbackLng: "en",
        interpolation: {
            escapeValue: false
        }
    });
    initialized = true;
};
/**
 * Apollo expects a translate function with a default value as the first parameter.
 *
 * If the application provides a translate function (and initializes its own translation services), this function expects the key as the first parameter.
 * We want to wrap the translate function to support a default value as the first parameter.
 *
 * If the translate function is not provided, we will auto-initialize i18next for Apollo translations.
 */ var useTranslations = function() {
    var lang = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "en", translate = arguments.length > 1 ? arguments[1] : void 0, enableFallback = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var _useState = _sliced_to_array$2(useState(function() {
        return translate ? {} : null; // Simulate truthy when translate function is provided
    }), 2), translations = _useState[0], setTranslations = _useState[1];
    var t = useCallback(function(defaultValue, key, params) {
        var translation = translate ? translate(key, params) : instance.t(key, params);
        return translation !== key ? translation : enableFallback ? defaultValue : key;
    }, [
        translate,
        enableFallback
    ]);
    useEffect(function() {
        if (!translate) {
            initForReact(lang); // Only re-initialize if we are building our own translate function
            instance.changeLanguage(lang || "en");
            loadAllTranslations(lang || "en", instance.addResources).then(function(t) {
                setTranslations(t);
            });
        }
    }, [
        lang,
        translate
    ]);
    return {
        t: t,
        lang: lang,
        translations: translations
    };
};

var CalendarProvider;
(function(CalendarProvider) {
    CalendarProvider[CalendarProvider["Google"] = 0] = "Google";
    CalendarProvider[CalendarProvider["Outlook"] = 1] = "Outlook";
})(CalendarProvider || (CalendarProvider = {}));
var CurrencyCode;
(function(CurrencyCode) {
    CurrencyCode[CurrencyCode["USD"] = 0] = "USD";
    CurrencyCode[CurrencyCode["CAD"] = 1] = "CAD";
    CurrencyCode[CurrencyCode["AUD"] = 2] = "AUD";
    CurrencyCode[CurrencyCode["BRL"] = 3] = "BRL";
    CurrencyCode[CurrencyCode["CHF"] = 4] = "CHF";
    CurrencyCode[CurrencyCode["DKK"] = 5] = "DKK";
    CurrencyCode[CurrencyCode["EUR"] = 6] = "EUR";
    CurrencyCode[CurrencyCode["GBP"] = 7] = "GBP";
    CurrencyCode[CurrencyCode["INR"] = 8] = "INR";
    CurrencyCode[CurrencyCode["RSD"] = 9] = "RSD";
    CurrencyCode[CurrencyCode["SEK"] = 10] = "SEK";
    CurrencyCode[CurrencyCode["ZAR"] = 11] = "ZAR";
    CurrencyCode[CurrencyCode["CLP"] = 12] = "CLP";
})(CurrencyCode || (CurrencyCode = {}));
var LanguagePreference;
(function(LanguagePreference) {
    LanguagePreference[LanguagePreference["EN_US"] = 0] = "EN_US";
    LanguagePreference[LanguagePreference["FR_CA"] = 1] = "FR_CA";
    LanguagePreference[LanguagePreference["ES_419"] = 2] = "ES_419";
    LanguagePreference[LanguagePreference["PT_BR"] = 3] = "PT_BR";
    LanguagePreference[LanguagePreference["DE_DE"] = 4] = "DE_DE";
    LanguagePreference[LanguagePreference["EN_GB"] = 5] = "EN_GB";
    LanguagePreference[LanguagePreference["FR_FR"] = 6] = "FR_FR";
    LanguagePreference[LanguagePreference["JA_JP"] = 7] = "JA_JP";
    LanguagePreference[LanguagePreference["ZH_CN"] = 8] = "ZH_CN";
    LanguagePreference[LanguagePreference["DA_DK"] = 9] = "DA_DK";
    LanguagePreference[LanguagePreference["ES_ES"] = 10] = "ES_ES";
    LanguagePreference[LanguagePreference["IT_IT"] = 11] = "IT_IT";
    LanguagePreference[LanguagePreference["KO_KR"] = 12] = "KO_KR";
    LanguagePreference[LanguagePreference["NL_NL"] = 13] = "NL_NL";
    LanguagePreference[LanguagePreference["PL_PL"] = 14] = "PL_PL";
    LanguagePreference[LanguagePreference["RU_RU"] = 15] = "RU_RU";
    LanguagePreference[LanguagePreference["SV_SE"] = 16] = "SV_SE";
    LanguagePreference[LanguagePreference["CS_CZ"] = 17] = "CS_CZ";
    LanguagePreference[LanguagePreference["HU_HU"] = 18] = "HU_HU";
    LanguagePreference[LanguagePreference["ID_ID"] = 19] = "ID_ID";
    LanguagePreference[LanguagePreference["PT_PT"] = 20] = "PT_PT";
    LanguagePreference[LanguagePreference["RO_RO"] = 21] = "RO_RO";
    LanguagePreference[LanguagePreference["TH_TH"] = 22] = "TH_TH";
    LanguagePreference[LanguagePreference["TR_TR"] = 23] = "TR_TR";
    LanguagePreference[LanguagePreference["VI_VN"] = 24] = "VI_VN";
    LanguagePreference[LanguagePreference["ZH_TW"] = 25] = "ZH_TW";
    LanguagePreference[LanguagePreference["EL_GR"] = 26] = "EL_GR";
})(LanguagePreference || (LanguagePreference = {}));
var FinanceType;
(function(FinanceType) {
    FinanceType[FinanceType["Loan"] = 0] = "Loan";
    FinanceType[FinanceType["ISA"] = 1] = "ISA";
    FinanceType[FinanceType["Scholarship"] = 2] = "Scholarship";
    FinanceType[FinanceType["Discount"] = 3] = "Discount";
    FinanceType[FinanceType["Prepayment"] = 4] = "Prepayment";
    FinanceType[FinanceType["TuitionReimbursement"] = 5] = "TuitionReimbursement";
    FinanceType[FinanceType["CompletionBonus"] = 6] = "CompletionBonus";
    FinanceType[FinanceType["Other"] = 7] = "Other";
    FinanceType[FinanceType["ExternalReimbursement"] = 8] = "ExternalReimbursement";
    FinanceType[FinanceType["DirectBilling"] = 9] = "DirectBilling";
})(FinanceType || (FinanceType = {}));
var FeatureFlagExperiments;
(function(FeatureFlagExperiments) {
    FeatureFlagExperiments["PeerVisibility"] = "feature__peer_visibility";
    FeatureFlagExperiments["PeerVisibilityForCustomPrograms"] = "feature__peer_visibility_for_custom_programs";
    FeatureFlagExperiments["TeamInsights"] = "feature__team_insights";
    FeatureFlagExperiments["PrepaymentTab"] = "feature__prepayment-tab";
    FeatureFlagExperiments["PrepaymentLinkNewBankAccount"] = "feature__link-new-bank-account-to-stripe";
    FeatureFlagExperiments["DisableProgressUpdates"] = "feature__disable-progress-updates";
    FeatureFlagExperiments["CustomPrograms"] = "feature__custom-programs";
    FeatureFlagExperiments["OnlyCustomProgramsUser"] = "feature__only-show-custom-programs-to-user";
    FeatureFlagExperiments["TimeIncentives"] = "feature__time-incentives";
    FeatureFlagExperiments["Academies"] = "feature__academies";
    FeatureFlagExperiments["ConnectCalendar"] = "feature__connect-calendar";
    FeatureFlagExperiments["GoogleCalendar"] = "feature__google-calendar";
    FeatureFlagExperiments["Licenses"] = "feature__licenses";
    FeatureFlagExperiments["ExternalReimbursements"] = "feature__external-reimbursements";
    FeatureFlagExperiments["PseudoLocale"] = "feature__locale-testing";
    FeatureFlagExperiments["CostCenter"] = "feature__cost-center";
    FeatureFlagExperiments["DisableVirtualCards"] = "feature__disable-virtual-cards";
    FeatureFlagExperiments["Incentives"] = "feature__incentives";
    FeatureFlagExperiments["SlackControls"] = "temp__slack-controls";
    FeatureFlagExperiments["AcademyPeople"] = "feature__academy-people";
    FeatureFlagExperiments["LearnInReimbursements"] = "feature__learn-in-reimbursements";
    FeatureFlagExperiments["CredsparkDemo"] = "temp__credspark_demo";
    FeatureFlagExperiments["ReportStatusTag"] = "feature__report_status_tag";
    FeatureFlagExperiments["UnspentFunds"] = "feature__unspent_funds";
    FeatureFlagExperiments["Subscriptions"] = "temp__subscriptions";
    FeatureFlagExperiments["TranslatePlbFields"] = "temp__translate_plb_fields";
    FeatureFlagExperiments["HideMarketplace"] = "feature__custom_program_hide_marketplace";
    FeatureFlagExperiments["ProjectFeedback"] = "temp__show_project_feedback";
    FeatureFlagExperiments["ProductSwitcher"] = "temp_product_switcher";
    FeatureFlagExperiments["RenameApprovalFields"] = "temp_rename_approval_fields";
    FeatureFlagExperiments["RequestWithCurrency"] = "temp__request_with_currency";
    FeatureFlagExperiments["Swedish"] = "feature__language_swedish";
    FeatureFlagExperiments["Russian"] = "feature__language_russian";
    FeatureFlagExperiments["Polish"] = "feature__language_polish";
    FeatureFlagExperiments["Dutch"] = "feature__language_dutch";
    FeatureFlagExperiments["Korean"] = "feature__language_korean";
    FeatureFlagExperiments["Italian"] = "feature__language_italian";
    FeatureFlagExperiments["SpainSpanish"] = "feature__language_spain_spanish";
    FeatureFlagExperiments["Danish"] = "feature__language_danish";
    FeatureFlagExperiments["HideHeaderOnResubmit"] = "temp__hide_header_resubmit";
    FeatureFlagExperiments["HideSubtextForResubmissions"] = "temp__hide_subtext_for_resubmissions";
    FeatureFlagExperiments["NewTags"] = "temp__status-tags-ui";
    FeatureFlagExperiments["CustomProgramDiscussionSteps"] = "temp__cp_discussion_steps";
    FeatureFlagExperiments["WhatsNext"] = "feature__whats_next";
    FeatureFlagExperiments["InstructionText"] = "feature__instruction_text";
    FeatureFlagExperiments["Prorating"] = "temp__prorate_budgets";
    FeatureFlagExperiments["HelperText"] = "feature__help_text";
    FeatureFlagExperiments["SetLanguageFromBrowser"] = "temp__set_language_from_browser";
    FeatureFlagExperiments["SkipAcademyStep"] = "feature__skip_academy_step";
    FeatureFlagExperiments["AcademyLoadingRefresh"] = "feature__academy_loading_refresh";
    FeatureFlagExperiments["ReimbursementAttachmentsMigration"] = "temp__reimbursements_attachments_migration";
    FeatureFlagExperiments["DirectBilling"] = "temp__direct_billing";
    FeatureFlagExperiments["YourPlanNameChange"] = "temp_rename_your_plan_to_home";
    FeatureFlagExperiments["VoucherCodes"] = "temp__voucher_codes";
    FeatureFlagExperiments["NudgeEmails"] = "temp__nudge_emails";
    FeatureFlagExperiments["ViewMembersInCustomProgram"] = "temp__view_members_in_custom_program";
    FeatureFlagExperiments["ProgramDetailsRedesign"] = "temp__program_detail_redesign_p1";
    FeatureFlagExperiments["RemoveOtherIncentives"] = "temp__remove_other_incentives";
    FeatureFlagExperiments["AcademyProgramApprovers"] = "temp__academy_program_approver";
    FeatureFlagExperiments["WelcomeBackHeader"] = "temp__your_plan_welcome_back_header";
    FeatureFlagExperiments["LxpToCmFlow"] = "temp__cm_lxp_flow";
    FeatureFlagExperiments["IntegratedUser"] = "temp__integrated_user";
    FeatureFlagExperiments["UpdatedLxpToCmFlow"] = "temp__updated_cm_lxp_flow";
    FeatureFlagExperiments["SettingsRedesign"] = "temp__settings_redesign";
    FeatureFlagExperiments["Nominations"] = "feature__nomination";
    FeatureFlagExperiments["HideMarketplaceFromLXP"] = "feature__hide_marketplace";
    FeatureFlagExperiments["HidePrimaryNav"] = "temp__hide_primary_nav";
    FeatureFlagExperiments["ShowEmployeeEmail"] = "temp__show_employee_email";
    FeatureFlagExperiments["LicenseModalUpdate"] = "temp__access_program_voucher";
    FeatureFlagExperiments["ShowCustomProgramClickToJoin"] = "temp__allow_custom_program_join";
    FeatureFlagExperiments["ShowAcademyClickToJoin"] = "temp__allow_academy_join";
    FeatureFlagExperiments["ShowProductSwitcherLxpOption"] = "temp__show_product_switcher_lxp_option";
    FeatureFlagExperiments["UnlockStepOnProgramApproval"] = "feature__unlock-step-on-program-approval";
    FeatureFlagExperiments["ProgramDetailsRedesignPt2"] = "temp_program_details_redesign_pt2";
    FeatureFlagExperiments["BulkNudgeAllParticipants"] = "temp__bulk_nudge_all_participants";
    FeatureFlagExperiments["HideAdminSettings"] = "temp__hide_admin_settings";
    FeatureFlagExperiments["AcademyAndCpLxpFlow"] = "temp__acad-and-cp-lxp_flow";
    FeatureFlagExperiments["IdleTimeLogout"] = "idle_time_logout";
    FeatureFlagExperiments["SunsetMonthlyRenewal"] = "temp__sunset_monthly_renewal";
    FeatureFlagExperiments["TeamInsightsHideColumns"] = "temp__team_insights_hide_columns";
    FeatureFlagExperiments["HideChatWidget"] = "feature__hide_help_widget";
    FeatureFlagExperiments["EditProjectSubmissions"] = "feature__edit_project_submissions";
    FeatureFlagExperiments["SunsetInitiatives"] = "temp__sunsetinitiatives";
    FeatureFlagExperiments["SunsetReviews"] = "temp__sunsetreviews";
    FeatureFlagExperiments["HideEveryYearDirectBilling"] = "temp__hide_every-year-direct-billing";
    FeatureFlagExperiments["HideEveryYearReimbursement"] = "temp__hide_every-year-reimbursement";
    FeatureFlagExperiments["HideRenewalDate"] = "temp__hide_renewaldate";
    FeatureFlagExperiments["HideRollOver"] = "feature__hide_rollover";
    FeatureFlagExperiments["CatalogContentAcademies"] = "feature__catalog_content_academies";
    FeatureFlagExperiments["AcademiesCleanUp"] = "temp__academies_clean_up";
    FeatureFlagExperiments["IsLxpAdmin"] = "feature__is_lxp_admin";
    FeatureFlagExperiments["HideProductSwitcher"] = "temp__hide_product_switcher";
    FeatureFlagExperiments["Czech_Czech_Republic"] = "feature__language_czech";
    FeatureFlagExperiments["Hungarian"] = "feature__language_hungarian";
    FeatureFlagExperiments["Indonesian"] = "feature__language_indonesian";
    FeatureFlagExperiments["Portuguese_Portugal"] = "feature__language_portuguese_portugal";
    FeatureFlagExperiments["Romanian_Romania"] = "feature__language_romanian_romania";
    FeatureFlagExperiments["Thai"] = "feature__language_thai";
    FeatureFlagExperiments["Turkish"] = "feature__language_turkish";
    FeatureFlagExperiments["Vietnamese"] = "feature__language_vietnamese";
    FeatureFlagExperiments["Chinese_Taiwan"] = "feature__language_chinese_taiwan";
    FeatureFlagExperiments["Greek_Greece"] = "feature__language_greek_greece";
    FeatureFlagExperiments["ACMLayout"] = "temp__acm_layout";
    FeatureFlagExperiments["LXPAdminLayout"] = "temp__lxp_admin_layout";
})(FeatureFlagExperiments || (FeatureFlagExperiments = {}));

var contextService = {
    isChannel: function() {
        return false;
    }
};

var initOrgInfo = function() {
    return {
        name: "",
        image: "",
        organizationId: 0,
        isEngaged: false,
        permissions: {},
        settings: {},
        orgRole: "",
        hasPex: false
    };
};

var LAYOUT_FEATURE_FLAG_KEYS = {
    degreedSkillsOctober2024: "skills-degreedskills-october2024",
    lxpDegreedAssistant: "lxp-degreed-assistant",
    personalizedLearning: "personalized-learning-sections-cards",
    sessionManagement: "session_management_config_ui",
    useLearnerHub: "new-home-learner-hub",
    orgManagement: {
        segmensUI: "segments-ui",
        showWebhooksAdmin: "api-enable-outbound-webhooks"
    },
    insights: {
        insightsSkillAnalytics: "insights-skill-analytics"
    },
    teams: {
        teamSpaceEnabled: "team-space-manager-enabled-v1-061220"
    },
    skillCoach: {
        managerAssignments: "mpr-manager-assignments-2025-feb"
    },
    apollo: {
        APOLLO_LAYOUT: "apollo_refresh",
        APOLLO_LAYOUT_REFRESH: "lxp-layout-refresh",
        APOLLO_LAYOUT_LEARNER_V2: "apollo_refresh_v2_learner",
        APOLLO_LAYOUT_LEARNER_V3: "apollo_refresh_v3_learner",
        APOLLO_LAYOUT_ADMIN_V2: "apollo_refresh_v2_admin",
        APOLLO_LAYOUT_ADMIN_V3: "apollo_refresh_v3_admin"
    }
};
var initFeatureFlags = function() {
    return {
        degreedSkillsOctober2024: true,
        lxpDegreedAssistant: false,
        personalizedLearning: true,
        sessionManagement: true,
        useLearnerHub: true,
        orgManagement: {
            segmentsUI: true,
            showWebhooksAdmin: true
        },
        insights: {
            insightsSkillAnalytics: true
        },
        teams: {
            teamSpaceEnabled: false
        },
        skillCoach: {
            managerAssignments: false
        },
        apollo: {
            APOLLO_LAYOUT: true,
            APOLLO_LAYOUT_REFRESH: true,
            APOLLO_LAYOUT_LEARNER_V2: true,
            APOLLO_LAYOUT_LEARNER_V3: true,
            APOLLO_LAYOUT_ADMIN_V2: true,
            APOLLO_LAYOUT_ADMIN_V3: true
        }
    };
};
/**
 * Recursively loop through LAYOUT_FEATURE_FLAG_KEYS and return an object of CompositeFeatureFlags
 */ var buildFeatureFlagsFrom = function(keys, getFlagValue) {
    return Object.keys(keys).reduce(function(acc, key) {
        var value = keys[key];
        acc[key] = typeof value === "object" ? buildFeatureFlagsFrom(value, getFlagValue) : getFlagValue(value);
        return acc;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }, {});
};

/**
 * Degreed's Apollo Design is undercontinuous development and adoption.
 * Some features were released in July 2024, and others in October 2024.
 *
 * We use feature flags to control the rollout of these features.
 */ /**
 * Register callback to easily check 1..n Apollo feature flags
 * Easy way to lookup and cache all Apollo flags...
 */ function configureApolloWithFeatureFlags(lookup) {
    var enableApolloLayout = false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys(FEATURE_FLAGS)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            var isEnabled = lookup(FEATURE_FLAGS[key]);
            markAsEnabled(key, isEnabled);
            enableApolloLayout || (enableApolloLayout = isEnabled);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Special flag to check if ANY version of Apollo is enabled...
    // NOTE: This assumes that ADMIN and LEARNER are always enabled together...
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useApolloLayout(enableApolloLayout);
}
// ******************************************
// Quick accessors to the Apollo flags...
// ******************************************
// NOTE: This is also a conditional mutator
var useApolloLayout = function(isEnabled) {
    return setEnabled("APOLLO_LAYOUT", isEnabled);
};
// @deprecated
var useApolloLayout_Refresh = function() {
    return isFlagEnabled("APOLLO_LAYOUT_REFRESH");
};
/**
 * Should we use v2 or v3 Apollo refresh?
 */ var useApolloLayout_Learner_V2 = function() {
    return isFlagEnabled("APOLLO_LAYOUT_LEARNER_V2") || isFlagEnabled("APOLLO_LAYOUT_REFRESH");
};
var useApolloLayout_Admin_V2 = function() {
    return isFlagEnabled("APOLLO_LAYOUT_ADMIN_V2") || isFlagEnabled("APOLLO_LAYOUT_REFRESH");
};
var useApolloLayout_Learner_V3 = function() {
    return isFlagEnabled("APOLLO_LAYOUT_LEARNER_V3");
};
var useApolloLayout_Admin_V3 = function() {
    return isFlagEnabled("APOLLO_LAYOUT_ADMIN_V3");
};
// ******************************************
// Private helpers
// ******************************************
/**
 * Features flags are configured on LaunchDarkly and are associated with 'groups'.
 *
 * Note: Users join the 'groups' and then have access to the features associated with
 * the 'flags' associated with each 'groups'.
 *
 * This document details the flags, groups, and provides snapshots of the UX for Apollo Navigation
 * @see https://degreedjira.atlassian.net/wiki/spaces/CCO/pages/6051463185/Learner+Hub+Navigation+LD+flags
 *
 */ var FEATURE_FLAGS = {
    APOLLO_LAYOUT: "apollo_refresh",
    // July, 2024 flag
    APOLLO_LAYOUT_REFRESH: "lxp-layout-refresh",
    // Oct, 2024 unified flags
    APOLLO_LAYOUT_LEARNER_V2: "apollo_refresh_v2_learner",
    APOLLO_LAYOUT_LEARNER_V3: "apollo_refresh_v3_learner",
    APOLLO_LAYOUT_ADMIN_V2: "apollo_refresh_v2_admin",
    APOLLO_LAYOUT_ADMIN_V3: "apollo_refresh_v3_admin"
};
/**
 * Internal registry of Apollo feature flags
 */ var features = {};
function isFlagEnabled(flag) {
    return features[FEATURE_FLAGS[flag]];
}
/**
 * Save the flag value to the Window object...
 * needed for lazy loaded modules and routing
 */ function markAsEnabled(flag) {
    var enabled = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    features[FEATURE_FLAGS[flag]] = enabled;
    return enabled;
}
/**
 * Smart mutator to mark ONLY if defined
 */ function setEnabled(flag, enabled) {
    if (enabled !== undefined) markAsEnabled(flag, enabled);
    return isFlagEnabled(flag);
}

function _array_like_to_array$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$1(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array$1(arr);
}
function _define_property$2(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit$1(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$1() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$2(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$2(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array$1(arr, i) {
    return _array_with_holes$1(arr) || _iterable_to_array_limit$1(arr, i) || _unsupported_iterable_to_array$1(arr, i) || _non_iterable_rest$1();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array$1(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$1(o, minLen);
}
function e(e) {
    function t(e, t) {
        Error.captureStackTrace && Error.captureStackTrace(this, this.constructor), this.message = e, this.code = t;
    }
    return t.prototype = new Error, t.prototype.name = e, t.prototype.constructor = t, t;
}
var t = e("LaunchDarklyUnexpectedResponseError"), n = e("LaunchDarklyInvalidEnvironmentIdError"), r = e("LaunchDarklyInvalidUserError"), o = e("LaunchDarklyInvalidEventKeyError"), i = e("LaunchDarklyInvalidArgumentError"), a = e("LaunchDarklyFlagFetchError");
for(var s = {
    LDUnexpectedResponseError: t,
    LDInvalidEnvironmentIdError: n,
    LDInvalidUserError: r,
    LDInvalidEventKeyError: o,
    LDInvalidArgumentError: i,
    LDInvalidDataError: e("LaunchDarklyInvalidDataError"),
    LDFlagFetchError: a,
    LDTimeoutError: e("LaunchDarklyTimeoutError"),
    isHttpErrorRecoverable: function isHttpErrorRecoverable(e) {
        return !(e >= 400 && e < 500) || 400 === e || 408 === e || 429 === e;
    }
}, c = function c(e) {
    var t = m(e), n = t[0], r = t[1];
    return 3 * (n + r) / 4 - r;
}, u = function u(e) {
    var t, n, r = m(e), o = r[0], i = r[1], a = new g(function(e, t, n) {
        return 3 * (t + n) / 4 - n;
    }(0, o, i)), s = 0, c = i > 0 ? o - 4 : o;
    for(n = 0; n < c; n += 4)t = f[e.charCodeAt(n)] << 18 | f[e.charCodeAt(n + 1)] << 12 | f[e.charCodeAt(n + 2)] << 6 | f[e.charCodeAt(n + 3)], a[s++] = t >> 16 & 255, a[s++] = t >> 8 & 255, a[s++] = 255 & t;
    2 === i && (t = f[e.charCodeAt(n)] << 2 | f[e.charCodeAt(n + 1)] >> 4, a[s++] = 255 & t);
    1 === i && (t = f[e.charCodeAt(n)] << 10 | f[e.charCodeAt(n + 1)] << 4 | f[e.charCodeAt(n + 2)] >> 2, a[s++] = t >> 8 & 255, a[s++] = 255 & t);
    return a;
}, l = function l(e) {
    for(var t, n = e.length, r = n % 3, o = [], i = 16383, a = 0, s = n - r; a < s; a += i)o.push(h(e, a, a + i > s ? s : a + i));
    1 === r ? (t = e[n - 1], o.push(d[t >> 2] + d[t << 4 & 63] + "==")) : 2 === r && (t = (e[n - 2] << 8) + e[n - 1], o.push(d[t >> 10] + d[t >> 4 & 63] + d[t << 2 & 63] + "="));
    return o.join("");
}, d = [], f = [], g = "undefined" != typeof Uint8Array ? Uint8Array : Array, v = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", p = 0; p < 64; ++p)d[p] = v[p], f[v.charCodeAt(p)] = p;
function m(e) {
    var t = e.length;
    if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    var n = e.indexOf("=");
    return -1 === n && (n = t), [
        n,
        n === t ? 0 : 4 - n % 4
    ];
}
function h(e, t, n) {
    for(var r, o, i = [], a = t; a < n; a += 3)r = (e[a] << 16 & 16711680) + (e[a + 1] << 8 & 65280) + (255 & e[a + 2]), i.push(d[(o = r) >> 18 & 63] + d[o >> 12 & 63] + d[o >> 6 & 63] + d[63 & o]);
    return i.join("");
}
f["-".charCodeAt(0)] = 62, f["_".charCodeAt(0)] = 63;
var y = {
    byteLength: c,
    toByteArray: u,
    fromByteArray: l
}, w = Array.isArray, b = Object.keys, k = Object.prototype.hasOwnProperty, E = function e(t, n) {
    if (t === n) return !0;
    if (t && n && "object" == typeof t && "object" == typeof n) {
        var r, o, i, a = w(t), s = w(n);
        if (a && s) {
            if ((o = t.length) != n.length) return !1;
            for(r = o; 0 != r--;)if (!e(t[r], n[r])) return !1;
            return !0;
        }
        if (a != s) return !1;
        var c = _instanceof(t, Date), u = _instanceof(n, Date);
        if (c != u) return !1;
        if (c && u) return t.getTime() == n.getTime();
        var l = _instanceof(t, RegExp), d = _instanceof(n, RegExp);
        if (l != d) return !1;
        if (l && d) return t.toString() == n.toString();
        var f = b(t);
        if ((o = f.length) !== b(n).length) return !1;
        for(r = o; 0 != r--;)if (!k.call(n, f[r])) return !1;
        for(r = o; 0 != r--;)if (!e(t[i = f[r]], n[i])) return !1;
        return !0;
    }
    return t != t && n != n;
};
var D = [
    "key",
    "ip",
    "country",
    "email",
    "firstName",
    "lastName",
    "avatar",
    "name"
];
function x(e) {
    var t = unescape(encodeURIComponent(e));
    return y.fromByteArray(function(e) {
        var t = [];
        for(var n = 0; n < e.length; n++)t.push(e.charCodeAt(n));
        return t;
    }(t));
}
function C(e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
}
var P, S = {
    appendUrlPath: function appendUrlPath(e, t) {
        return (e.endsWith("/") ? e.substring(0, e.length - 1) : e) + (t.startsWith("/") ? "" : "/") + t;
    },
    base64URLEncode: function base64URLEncode(e) {
        return x(e).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
    },
    btoa: x,
    clone: function clone(e) {
        return JSON.parse(JSON.stringify(e));
    },
    deepEquals: function deepEquals(e, t) {
        return E(e, t);
    },
    extend: function extend() {
        for(var _len = arguments.length, _$e = new Array(_len), _key = 0; _key < _len; _key++){
            _$e[_key] = arguments[_key];
        }
        return _$e.reduce(function(e, t) {
            return _object_spread$2({}, e, t);
        }, {});
    },
    getLDUserAgentString: function getLDUserAgentString(e) {
        var t = e.version || "?";
        return e.userAgent + "/" + t;
    },
    objectHasOwnProperty: C,
    onNextTick: function onNextTick(e) {
        setTimeout(e, 0);
    },
    sanitizeContext: function sanitizeContext(e) {
        if (!e) return e;
        var t;
        return null !== e.kind && void 0 !== e.kind || D.forEach(function(n) {
            var r = e[n];
            void 0 !== r && "string" != typeof r && (t = t || _object_spread$2({}, e), t[n] = String(r));
        }), t || e;
    },
    transformValuesToVersionedValues: function transformValuesToVersionedValues(e) {
        var t = {};
        for(var n in e)C(e, n) && (t[n] = {
            value: e[n],
            version: 0
        });
        return t;
    },
    transformVersionedValuesToValues: function transformVersionedValuesToValues(e) {
        var t = {};
        for(var n in e)C(e, n) && (t[n] = e[n].value);
        return t;
    },
    wrapPromiseCallback: function wrapPromiseCallback(e, t) {
        var n = e.then(function(e) {
            return t && setTimeout(function() {
                t(null, e);
            }, 0), e;
        }, function(e) {
            if (!t) return Promise.reject(e);
            setTimeout(function() {
                t(e, null);
            }, 0);
        });
        return t ? void 0 : n;
    }
}, I = new Uint8Array(16);
function O() {
    if (!P && !(P = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto))) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    return P(I);
}
var T = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function L(e) {
    return "string" == typeof e && T.test(e);
}
for(var U, R, A = [], j = 0; j < 256; ++j)A.push((j + 256).toString(16).substr(1));
function F(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = (A[e[t + 0]] + A[e[t + 1]] + A[e[t + 2]] + A[e[t + 3]] + "-" + A[e[t + 4]] + A[e[t + 5]] + "-" + A[e[t + 6]] + A[e[t + 7]] + "-" + A[e[t + 8]] + A[e[t + 9]] + "-" + A[e[t + 10]] + A[e[t + 11]] + A[e[t + 12]] + A[e[t + 13]] + A[e[t + 14]] + A[e[t + 15]]).toLowerCase();
    if (!L(n)) throw TypeError("Stringified UUID is invalid");
    return n;
}
var N = 0, $ = 0;
function V(e) {
    if (!L(e)) throw TypeError("Invalid UUID");
    var t, n = new Uint8Array(16);
    return n[0] = (t = parseInt(e.slice(0, 8), 16)) >>> 24, n[1] = t >>> 16 & 255, n[2] = t >>> 8 & 255, n[3] = 255 & t, n[4] = (t = parseInt(e.slice(9, 13), 16)) >>> 8, n[5] = 255 & t, n[6] = (t = parseInt(e.slice(14, 18), 16)) >>> 8, n[7] = 255 & t, n[8] = (t = parseInt(e.slice(19, 23), 16)) >>> 8, n[9] = 255 & t, n[10] = (t = parseInt(e.slice(24, 36), 16)) / 1099511627776 & 255, n[11] = t / 4294967296 & 255, n[12] = t >>> 24 & 255, n[13] = t >>> 16 & 255, n[14] = t >>> 8 & 255, n[15] = 255 & t, n;
}
function M(e, t, n) {
    function r(e, r, o, i) {
        if ("string" == typeof e && (e = function(e) {
            e = unescape(encodeURIComponent(e));
            for(var _$t = [], _$n = 0; _$n < e.length; ++_$n)_$t.push(e.charCodeAt(_$n));
            return _$t;
        }(e)), "string" == typeof r && (r = V(r)), 16 !== r.length) throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
        var a = new Uint8Array(16 + e.length);
        if (a.set(r), a.set(e, r.length), (a = n(a))[6] = 15 & a[6] | t, a[8] = 63 & a[8] | 128, o) {
            i = i || 0;
            for(var s = 0; s < 16; ++s)o[i + s] = a[s];
            return o;
        }
        return F(a);
    }
    try {
        r.name = e;
    } catch (e) {}
    return r.DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", r.URL = "6ba7b811-9dad-11d1-80b4-00c04fd430c8", r;
}
function q(e) {
    return 14 + (e + 64 >>> 9 << 4) + 1;
}
function H(e, t) {
    var n = (65535 & e) + (65535 & t);
    return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
}
function z(e, t, n, r, o, i) {
    return H((a = H(H(t, e), H(r, i))) << (s = o) | a >>> 32 - s, n);
    var a, s;
}
function K(e, t, n, r, o, i, a) {
    return z(t & n | ~t & r, e, t, o, i, a);
}
function _(e, t, n, r, o, i, a) {
    return z(t & r | n & ~r, e, t, o, i, a);
}
function J(e, t, n, r, o, i, a) {
    return z(t ^ n ^ r, e, t, o, i, a);
}
function B(e, t, n, r, o, i, a) {
    return z(n ^ (t | ~r), e, t, o, i, a);
}
var G = M("v3", 48, function(e) {
    if ("string" == typeof e) {
        var t = unescape(encodeURIComponent(e));
        e = new Uint8Array(t.length);
        for(var n = 0; n < t.length; ++n)e[n] = t.charCodeAt(n);
    }
    return function(e) {
        for(var t = [], n = 32 * e.length, r = "0123456789abcdef", o = 0; o < n; o += 8){
            var i = e[o >> 5] >>> o % 32 & 255, a = parseInt(r.charAt(i >>> 4 & 15) + r.charAt(15 & i), 16);
            t.push(a);
        }
        return t;
    }(function(e, t) {
        e[t >> 5] |= 128 << t % 32, e[q(t) - 1] = t;
        for(var n = 1732584193, r = -271733879, o = -1732584194, i = 271733878, a = 0; a < e.length; a += 16){
            var s = n, c = r, u = o, l = i;
            n = K(n, r, o, i, e[a], 7, -680876936), i = K(i, n, r, o, e[a + 1], 12, -389564586), o = K(o, i, n, r, e[a + 2], 17, 606105819), r = K(r, o, i, n, e[a + 3], 22, -1044525330), n = K(n, r, o, i, e[a + 4], 7, -176418897), i = K(i, n, r, o, e[a + 5], 12, 1200080426), o = K(o, i, n, r, e[a + 6], 17, -1473231341), r = K(r, o, i, n, e[a + 7], 22, -45705983), n = K(n, r, o, i, e[a + 8], 7, 1770035416), i = K(i, n, r, o, e[a + 9], 12, -1958414417), o = K(o, i, n, r, e[a + 10], 17, -42063), r = K(r, o, i, n, e[a + 11], 22, -1990404162), n = K(n, r, o, i, e[a + 12], 7, 1804603682), i = K(i, n, r, o, e[a + 13], 12, -40341101), o = K(o, i, n, r, e[a + 14], 17, -1502002290), n = _(n, r = K(r, o, i, n, e[a + 15], 22, 1236535329), o, i, e[a + 1], 5, -165796510), i = _(i, n, r, o, e[a + 6], 9, -1069501632), o = _(o, i, n, r, e[a + 11], 14, 643717713), r = _(r, o, i, n, e[a], 20, -373897302), n = _(n, r, o, i, e[a + 5], 5, -701558691), i = _(i, n, r, o, e[a + 10], 9, 38016083), o = _(o, i, n, r, e[a + 15], 14, -660478335), r = _(r, o, i, n, e[a + 4], 20, -405537848), n = _(n, r, o, i, e[a + 9], 5, 568446438), i = _(i, n, r, o, e[a + 14], 9, -1019803690), o = _(o, i, n, r, e[a + 3], 14, -187363961), r = _(r, o, i, n, e[a + 8], 20, 1163531501), n = _(n, r, o, i, e[a + 13], 5, -1444681467), i = _(i, n, r, o, e[a + 2], 9, -51403784), o = _(o, i, n, r, e[a + 7], 14, 1735328473), n = J(n, r = _(r, o, i, n, e[a + 12], 20, -1926607734), o, i, e[a + 5], 4, -378558), i = J(i, n, r, o, e[a + 8], 11, -2022574463), o = J(o, i, n, r, e[a + 11], 16, 1839030562), r = J(r, o, i, n, e[a + 14], 23, -35309556), n = J(n, r, o, i, e[a + 1], 4, -1530992060), i = J(i, n, r, o, e[a + 4], 11, 1272893353), o = J(o, i, n, r, e[a + 7], 16, -155497632), r = J(r, o, i, n, e[a + 10], 23, -1094730640), n = J(n, r, o, i, e[a + 13], 4, 681279174), i = J(i, n, r, o, e[a], 11, -358537222), o = J(o, i, n, r, e[a + 3], 16, -722521979), r = J(r, o, i, n, e[a + 6], 23, 76029189), n = J(n, r, o, i, e[a + 9], 4, -640364487), i = J(i, n, r, o, e[a + 12], 11, -421815835), o = J(o, i, n, r, e[a + 15], 16, 530742520), n = B(n, r = J(r, o, i, n, e[a + 2], 23, -995338651), o, i, e[a], 6, -198630844), i = B(i, n, r, o, e[a + 7], 10, 1126891415), o = B(o, i, n, r, e[a + 14], 15, -1416354905), r = B(r, o, i, n, e[a + 5], 21, -57434055), n = B(n, r, o, i, e[a + 12], 6, 1700485571), i = B(i, n, r, o, e[a + 3], 10, -1894986606), o = B(o, i, n, r, e[a + 10], 15, -1051523), r = B(r, o, i, n, e[a + 1], 21, -2054922799), n = B(n, r, o, i, e[a + 8], 6, 1873313359), i = B(i, n, r, o, e[a + 15], 10, -30611744), o = B(o, i, n, r, e[a + 6], 15, -1560198380), r = B(r, o, i, n, e[a + 13], 21, 1309151649), n = B(n, r, o, i, e[a + 4], 6, -145523070), i = B(i, n, r, o, e[a + 11], 10, -1120210379), o = B(o, i, n, r, e[a + 2], 15, 718787259), r = B(r, o, i, n, e[a + 9], 21, -343485551), n = H(n, s), r = H(r, c), o = H(o, u), i = H(i, l);
        }
        return [
            n,
            r,
            o,
            i
        ];
    }(function(e) {
        if (0 === e.length) return [];
        for(var t = 8 * e.length, n = new Uint32Array(q(t)), r = 0; r < t; r += 8)n[r >> 5] |= (255 & e[r / 8]) << r % 32;
        return n;
    }(e), 8 * e.length));
}), W = G;
function X(e, t, n, r) {
    switch(e){
        case 0:
            return t & n ^ ~t & r;
        case 1:
        case 3:
            return t ^ n ^ r;
        case 2:
            return t & n ^ t & r ^ n & r;
    }
}
function Q(e, t) {
    return e << t | e >>> 32 - t;
}
var Y = M("v5", 80, function(e) {
    var t = [
        1518500249,
        1859775393,
        2400959708,
        3395469782
    ], n = [
        1732584193,
        4023233417,
        2562383102,
        271733878,
        3285377520
    ];
    if ("string" == typeof e) {
        var r = unescape(encodeURIComponent(e));
        e = [];
        for(var o = 0; o < r.length; ++o)e.push(r.charCodeAt(o));
    } else Array.isArray(e) || (e = Array.prototype.slice.call(e));
    e.push(128);
    for(var i = e.length / 4 + 2, a = Math.ceil(i / 16), s = new Array(a), c = 0; c < a; ++c){
        for(var u = new Uint32Array(16), l = 0; l < 16; ++l)u[l] = e[64 * c + 4 * l] << 24 | e[64 * c + 4 * l + 1] << 16 | e[64 * c + 4 * l + 2] << 8 | e[64 * c + 4 * l + 3];
        s[c] = u;
    }
    s[a - 1][14] = 8 * (e.length - 1) / Math.pow(2, 32), s[a - 1][14] = Math.floor(s[a - 1][14]), s[a - 1][15] = 8 * (e.length - 1) & 4294967295;
    for(var d = 0; d < a; ++d){
        for(var f = new Uint32Array(80), g = 0; g < 16; ++g)f[g] = s[d][g];
        for(var v = 16; v < 80; ++v)f[v] = Q(f[v - 3] ^ f[v - 8] ^ f[v - 14] ^ f[v - 16], 1);
        for(var p = n[0], m = n[1], h = n[2], y = n[3], w = n[4], b = 0; b < 80; ++b){
            var k = Math.floor(b / 20), E = Q(p, 5) + X(k, m, h, y) + w + t[k] + f[b] >>> 0;
            w = y, y = h, h = Q(m, 30) >>> 0, m = p, p = E;
        }
        n[0] = n[0] + p >>> 0, n[1] = n[1] + m >>> 0, n[2] = n[2] + h >>> 0, n[3] = n[3] + y >>> 0, n[4] = n[4] + w >>> 0;
    }
    return [
        n[0] >> 24 & 255,
        n[0] >> 16 & 255,
        n[0] >> 8 & 255,
        255 & n[0],
        n[1] >> 24 & 255,
        n[1] >> 16 & 255,
        n[1] >> 8 & 255,
        255 & n[1],
        n[2] >> 24 & 255,
        n[2] >> 16 & 255,
        n[2] >> 8 & 255,
        255 & n[2],
        n[3] >> 24 & 255,
        n[3] >> 16 & 255,
        n[3] >> 8 & 255,
        255 & n[3],
        n[4] >> 24 & 255,
        n[4] >> 16 & 255,
        n[4] >> 8 & 255,
        255 & n[4]
    ];
}), Z = Y;
var ee = Object.freeze({
    __proto__: null,
    v1: function v1(e, t, n) {
        var r = t && n || 0, o = t || new Array(16), i = (e = e || {}).node || U, a = void 0 !== e.clockseq ? e.clockseq : R;
        if (null == i || null == a) {
            var s = e.random || (e.rng || O)();
            null == i && (i = U = [
                1 | s[0],
                s[1],
                s[2],
                s[3],
                s[4],
                s[5]
            ]), null == a && (a = R = 16383 & (s[6] << 8 | s[7]));
        }
        var c = void 0 !== e.msecs ? e.msecs : Date.now(), u = void 0 !== e.nsecs ? e.nsecs : $ + 1, l = c - N + (u - $) / 1e4;
        if (l < 0 && void 0 === e.clockseq && (a = a + 1 & 16383), (l < 0 || c > N) && void 0 === e.nsecs && (u = 0), u >= 1e4) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
        N = c, $ = u, R = a;
        var d = (1e4 * (268435455 & (c += 122192928e5)) + u) % 4294967296;
        o[r++] = d >>> 24 & 255, o[r++] = d >>> 16 & 255, o[r++] = d >>> 8 & 255, o[r++] = 255 & d;
        var f = c / 4294967296 * 1e4 & 268435455;
        o[r++] = f >>> 8 & 255, o[r++] = 255 & f, o[r++] = f >>> 24 & 15 | 16, o[r++] = f >>> 16 & 255, o[r++] = a >>> 8 | 128, o[r++] = 255 & a;
        for(var g = 0; g < 6; ++g)o[r + g] = i[g];
        return t || F(o);
    },
    v3: W,
    v4: function v4(e, t, n) {
        var r = (e = e || {}).random || (e.rng || O)();
        if (r[6] = 15 & r[6] | 64, r[8] = 63 & r[8] | 128, t) {
            n = n || 0;
            for(var o = 0; o < 16; ++o)t[n + o] = r[o];
            return t;
        }
        return F(r);
    },
    v5: Z,
    NIL: "00000000-0000-0000-0000-000000000000",
    version: function version(e) {
        if (!L(e)) throw TypeError("Invalid UUID");
        return parseInt(e.substr(14, 1), 16);
    },
    validate: L,
    stringify: F,
    parse: V
});
var te = [
    "debug",
    "info",
    "warn",
    "error",
    "none"
];
var ne = {
    commonBasicLogger: function commonBasicLogger(e, t) {
        var _loop = function(_$e) {
            var t = te[_$e];
            if ("none" !== t) if (_$e < a) c[t] = function() {};
            else {
                var _$n = _$e;
                c[t] = function() {
                    s(_$n, t, arguments);
                };
            }
        };
        if (e && e.destination && "function" != typeof e.destination) throw new Error("destination for basicLogger was set to a non-function");
        function n(e) {
            return function(t) {
                console && console[e] && console[e].call(console, t);
            };
        }
        var r = e && e.destination ? [
            e.destination,
            e.destination,
            e.destination,
            e.destination
        ] : [
            n("log"),
            n("info"),
            n("warn"),
            n("error")
        ], o = !(!e || !e.destination), i = e && void 0 !== e.prefix && null !== e.prefix ? e.prefix : "[LaunchDarkly] ";
        var a = 1;
        if (e && e.level) for(var t1 = 0; t1 < te.length; t1++)te[t1] === e.level && (a = t1);
        function s(e, n, a) {
            if (a.length < 1) return;
            var s;
            var c = o ? n + ": " + i : i;
            if (1 !== a.length && t) {
                var _$e = _to_consumable_array(a);
                _$e[0] = c + _$e[0], s = t.apply(void 0, _to_consumable_array(_$e));
            } else s = c + a[0];
            try {
                r[e](s);
            } catch (e) {
                console && console.log && console.log("[LaunchDarkly] Configured logger's " + n + " method threw an exception: " + e);
            }
        }
        var c = {};
        for(var _$e = 0; _$e < te.length; _$e++)_loop(_$e);
        return c;
    },
    validateLogger: function validateLogger(e) {
        te.forEach(function(t) {
            if ("none" !== t && (!e[t] || "function" != typeof e[t])) throw new Error("Provided logger instance must support logger." + t + "(...) method");
        });
    }
};
function re(e) {
    return e && e.message ? e.message : "string" == typeof e || _instanceof(e, String) ? e : JSON.stringify(e);
}
var oe = " Please see https://docs.launchdarkly.com/sdk/client-side/javascript#initialize-the-client for instructions on SDK initialization.";
var ie = {
    bootstrapInvalid: function bootstrapInvalid() {
        return "LaunchDarkly bootstrap data is not available because the back end could not read the flags.";
    },
    bootstrapOldFormat: function bootstrapOldFormat() {
        return "LaunchDarkly client was initialized with bootstrap data that did not include flag metadata. Events may not be sent correctly." + oe;
    },
    clientInitialized: function clientInitialized() {
        return "LaunchDarkly client initialized";
    },
    clientNotReady: function clientNotReady() {
        return "LaunchDarkly client is not ready";
    },
    debugEnqueueingEvent: function debugEnqueueingEvent(e) {
        return 'enqueueing "' + e + '" event';
    },
    debugPostingDiagnosticEvent: function debugPostingDiagnosticEvent(e) {
        return "sending diagnostic event (" + e.kind + ")";
    },
    debugPostingEvents: function debugPostingEvents(e) {
        return "sending " + e + " events";
    },
    debugStreamDelete: function debugStreamDelete(e) {
        return 'received streaming deletion for flag "' + e + '"';
    },
    debugStreamDeleteIgnored: function debugStreamDeleteIgnored(e) {
        return 'received streaming deletion for flag "' + e + '" but ignored due to version check';
    },
    debugStreamPatch: function debugStreamPatch(e) {
        return 'received streaming update for flag "' + e + '"';
    },
    debugStreamPatchIgnored: function debugStreamPatchIgnored(e) {
        return 'received streaming update for flag "' + e + '" but ignored due to version check';
    },
    debugStreamPing: function debugStreamPing() {
        return "received ping message from stream";
    },
    debugPolling: function debugPolling(e) {
        return "polling for feature flags at " + e;
    },
    debugStreamPut: function debugStreamPut() {
        return "received streaming update for all flags";
    },
    deprecated: function deprecated(e, t) {
        return t ? '"' + e + '" is deprecated, please use "' + t + '"' : '"' + e + '" is deprecated';
    },
    environmentNotFound: function environmentNotFound() {
        return "Environment not found. Double check that you specified a valid environment/client-side ID." + oe;
    },
    environmentNotSpecified: function environmentNotSpecified() {
        return "No environment/client-side ID was specified." + oe;
    },
    errorFetchingFlags: function errorFetchingFlags(e) {
        return "Error fetching flag settings: " + re(e);
    },
    eventCapacityExceeded: function eventCapacityExceeded() {
        return "Exceeded event queue capacity. Increase capacity to avoid dropping events.";
    },
    eventWithoutContext: function eventWithoutContext() {
        return "Be sure to call `identify` in the LaunchDarkly client: https://docs.launchdarkly.com/sdk/features/identify#javascript";
    },
    httpErrorMessage: function httpErrorMessage(e, t, n) {
        return "Received error " + e + (401 === e ? " (invalid SDK key)" : "") + " for " + t + " - " + (s.isHttpErrorRecoverable(e) ? n : "giving up permanently");
    },
    httpUnavailable: function httpUnavailable() {
        return "Cannot make HTTP requests in this environment." + oe;
    },
    identifyDisabled: function identifyDisabled() {
        return "identify() has no effect here; it must be called on the main client instance";
    },
    inspectorMethodError: function(e, t) {
        return 'an inspector: "'.concat(t, '" of type: "').concat(e, '" generated an exception');
    },
    invalidContentType: function invalidContentType(e) {
        return 'Expected application/json content type but got "' + e + '"';
    },
    invalidData: function invalidData() {
        return "Invalid data received from LaunchDarkly; connection may have been interrupted";
    },
    invalidInspector: function(e, t) {
        return 'an inspector: "'.concat(t, '" of an invalid type (').concat(e, ") was configured");
    },
    invalidKey: function invalidKey() {
        return "Event key must be a string";
    },
    invalidMetricValue: function(e) {
        return 'The track function was called with a non-numeric "metricValue" ('.concat(e, "), only numeric metric values are supported.");
    },
    invalidContext: function invalidContext() {
        return "Invalid context specified." + oe;
    },
    invalidTagValue: function(e) {
        return 'Config option "'.concat(e, '" must only contain letters, numbers, ., _ or -.');
    },
    localStorageUnavailable: function localStorageUnavailable(e) {
        return "local storage is unavailable: " + re(e);
    },
    networkError: function(e) {
        return "network error" + (e ? " (" + e + ")" : "");
    },
    optionBelowMinimum: function(e, t, n) {
        return 'Config option "' + e + '" was set to ' + t + ", changing to minimum value of " + n;
    },
    streamClosing: function streamClosing() {
        return "Closing stream connection";
    },
    streamConnecting: function streamConnecting(e) {
        return "Opening stream connection to " + e;
    },
    streamError: function streamError(e, t) {
        return "Error on stream connection: " + re(e) + ", will continue retrying after " + t + " milliseconds.";
    },
    tagValueTooLong: function(e) {
        return 'Value of "'.concat(e, '" was longer than 64 characters and was discarded.');
    },
    unknownCustomEventKey: function unknownCustomEventKey(e) {
        return 'Custom event "' + e + '" does not exist';
    },
    unknownOption: function(e) {
        return 'Ignoring unknown config option "' + e + '"';
    },
    contextNotSpecified: function contextNotSpecified() {
        return "No context specified." + oe;
    },
    unrecoverableStreamError: function(e) {
        return "Error on stream connection ".concat(re(e), ", giving up permanently");
    },
    wrongOptionType: function(e, t, n) {
        return 'Config option "' + e + '" should be of type ' + t + ", got " + n + ", using default value";
    },
    wrongOptionTypeBoolean: function(e, t) {
        return 'Config option "' + e + '" should be a boolean, got ' + t + ", converting to boolean";
    }
};
var ae = ne.validateLogger, se = {
    baseUrl: {
        default: "https://app.launchdarkly.com"
    },
    streamUrl: {
        default: "https://clientstream.launchdarkly.com"
    },
    eventsUrl: {
        default: "https://events.launchdarkly.com"
    },
    sendEvents: {
        default: !0
    },
    streaming: {
        type: "boolean"
    },
    sendLDHeaders: {
        default: !0
    },
    requestHeaderTransform: {
        type: "function"
    },
    sendEventsOnlyForVariation: {
        default: !1
    },
    useReport: {
        default: !1
    },
    evaluationReasons: {
        default: !1
    },
    eventCapacity: {
        default: 100,
        minimum: 1
    },
    flushInterval: {
        default: 2e3,
        minimum: 2e3
    },
    samplingInterval: {
        default: 0,
        minimum: 0
    },
    streamReconnectDelay: {
        default: 1e3,
        minimum: 0
    },
    allAttributesPrivate: {
        default: !1
    },
    privateAttributes: {
        default: []
    },
    bootstrap: {
        type: "string|object"
    },
    diagnosticRecordingInterval: {
        default: 9e5,
        minimum: 2e3
    },
    diagnosticOptOut: {
        default: !1
    },
    wrapperName: {
        type: "string"
    },
    wrapperVersion: {
        type: "string"
    },
    stateProvider: {
        type: "object"
    },
    application: {
        validator: function validator(e, t, n) {
            var r = {};
            t.id && (r.id = le("".concat(e, ".id"), t.id, n));
            t.version && (r.version = le("".concat(e, ".version"), t.version, n));
            return r;
        }
    },
    inspectors: {
        default: []
    }
}, ce = /^(\w|\.|-)+$/;
function ue(e) {
    return e && e.replace(/\/+$/, "");
}
function le(e, t, n) {
    if ("string" == typeof t && t.match(ce)) {
        if (!(t.length > 64)) return t;
        n.warn(ie.tagValueTooLong(e));
    } else n.warn(ie.invalidTagValue(e));
}
var de = {
    baseOptionDefs: se,
    validate: function validate(e, t, n, r) {
        var o = S.extend({
            logger: {
                default: r
            }
        }, se, n), i = {};
        function a(e) {
            S.onNextTick(function() {
                t && t.maybeReportError(new s.LDInvalidArgumentError(e));
            });
        }
        var c = S.extend({}, e || {});
        return function(e) {
            var t = e;
            Object.keys(i).forEach(function(e) {
                if (void 0 !== t[e]) {
                    var _$n = i[e];
                    r && r.warn(ie.deprecated(e, _$n)), _$n && (void 0 === t[_$n] && (t[_$n] = t[e]), delete t[e]);
                }
            });
        }(c), c = function(e) {
            var t = S.extend({}, e);
            return Object.keys(o).forEach(function(e) {
                void 0 !== t[e] && null !== t[e] || (t[e] = o[e] && o[e].default);
            }), t;
        }(c), c = function(e) {
            var t = S.extend({}, e), _$n = function(e) {
                if (null === e) return "any";
                if (void 0 === e) return;
                if (Array.isArray(e)) return "array";
                var t = typeof e === "undefined" ? "undefined" : _type_of(e);
                return "boolean" === t || "string" === t || "number" === t || "function" === t ? t : "object";
            };
            return Object.keys(e).forEach(function(i) {
                var s = e[i];
                if (null != s) {
                    var c = o[i];
                    if (void 0 === c) a(ie.unknownOption(i));
                    else {
                        var o1 = c.type || _$n(c.default), u = c.validator;
                        if (u) {
                            var _$n1 = u(i, e[i], r);
                            void 0 !== _$n1 ? t[i] = _$n1 : delete t[i];
                        } else if ("any" !== o1) {
                            var _$e = o1.split("|"), _$r = _$n(s);
                            _$e.indexOf(_$r) < 0 ? "boolean" === o1 ? (t[i] = !!s, a(ie.wrongOptionTypeBoolean(i, _$r))) : (a(ie.wrongOptionType(i, o1, _$r)), t[i] = c.default) : "number" === _$r && void 0 !== c.minimum && s < c.minimum && (a(ie.optionBelowMinimum(i, s, c.minimum)), t[i] = c.minimum);
                        }
                    }
                }
            }), t.baseUrl = ue(t.baseUrl), t.streamUrl = ue(t.streamUrl), t.eventsUrl = ue(t.eventsUrl), t;
        }(c), ae(c.logger), c;
    },
    getTags: function getTags(e) {
        var t = {};
        return e && (e.application && void 0 !== e.application.id && null !== e.application.id && (t["application-id"] = [
            e.application.id
        ]), e.application && void 0 !== e.application.version && null !== e.application.id && (t["application-version"] = [
            e.application.version
        ])), t;
    }
};
var fe = S.getLDUserAgentString;
var ge = {
    getLDHeaders: function getLDHeaders(e, t) {
        if (t && !t.sendLDHeaders) return {};
        var n = {};
        n[e.userAgentHeaderName || "User-Agent"] = fe(e), t && t.wrapperName && (n["X-LaunchDarkly-Wrapper"] = t.wrapperVersion ? t.wrapperName + "/" + t.wrapperVersion : t.wrapperName);
        var r = de.getTags(t), o = Object.keys(r);
        return o.length && (n["x-launchdarkly-tags"] = o.sort().map(function(e) {
            return Array.isArray(r[e]) ? r[e].sort().map(function(t) {
                return "".concat(e, "/").concat(t);
            }) : [
                "".concat(e, "/").concat(r[e])
            ];
        }).reduce(function(e, t) {
            return e.concat(t);
        }, []).join(" ")), n;
    },
    transformHeaders: function transformHeaders(e, t) {
        return t && t.requestHeaderTransform ? t.requestHeaderTransform(_object_spread$2({}, e)) : e;
    }
};
var ve = ee.v1, pe = ge.getLDHeaders, me = ge.transformHeaders;
var he = function he(e, t, n) {
    var r = S.extend({
        "Content-Type": "application/json"
    }, pe(e, n)), o = {};
    return o.sendEvents = function(t, o, i) {
        if (!e.httpRequest) return Promise.resolve();
        var a = JSON.stringify(t), c = i ? null : ve();
        return (function t(u) {
            var l = i ? r : S.extend({}, r, {
                "X-LaunchDarkly-Event-Schema": "4",
                "X-LaunchDarkly-Payload-ID": c
            });
            return e.httpRequest("POST", o, me(l, n), a).promise.then(function(e) {
                if (e) return e.status >= 400 && s.isHttpErrorRecoverable(e.status) && u ? t(!1) : function(e) {
                    var _$t = {
                        status: e.status
                    }, _$n = e.header("date");
                    if (_$n) {
                        var _$e = Date.parse(_$n);
                        _$e && (_$t.serverTime = _$e);
                    }
                    return _$t;
                }(e);
            }).catch(function() {
                return u ? t(!1) : Promise.reject();
            });
        })(!0).catch(function() {});
    }, o;
};
var ye = ne.commonBasicLogger;
function we(e) {
    return "string" == typeof e && "kind" !== e && e.match(/^(\w|\.|-)+$/);
}
function be(e) {
    return e.includes("%") || e.includes(":") ? e.replace(/%/g, "%25").replace(/:/g, "%3A") : e;
}
var ke = {
    checkContext: function checkContext(e, t) {
        if (e) {
            if (t && (void 0 === e.kind || null === e.kind)) return void 0 !== e.key && null !== e.key;
            var n = e.key, r = void 0 === e.kind ? "user" : e.kind, o = we(r), i = "multi" === r || null != n && "" !== n;
            if ("multi" === r) {
                var _$t = Object.keys(e).filter(function(e) {
                    return "kind" !== e;
                });
                return i && _$t.every(function(e) {
                    return we(e);
                }) && _$t.every(function(t) {
                    var n = e[t].key;
                    return null != n && "" !== n;
                });
            }
            return i && o;
        }
        return !1;
    },
    getContextKeys: function getContextKeys(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ye();
        if (!e) return;
        var n = {}, r = e.kind, o = e.key;
        switch(r){
            case void 0:
                n.user = "".concat(o);
                break;
            case "multi":
                Object.entries(e).filter(function(param) {
                    var _param = _sliced_to_array$1(param, 1), _$e = _param[0];
                    return "kind" !== _$e;
                }).forEach(function(param) {
                    var _param = _sliced_to_array$1(param, 2), _$e = _param[0], t = _param[1];
                    t && t.key && (n[_$e] = t.key);
                });
                break;
            case null:
                t.warn("null is not a valid context kind: ".concat(e));
                break;
            case "":
                t.warn("'' is not a valid context kind: ".concat(e));
                break;
            default:
                n[r] = "".concat(o);
        }
        return n;
    },
    getContextKinds: function getContextKinds(e) {
        return e ? null === e.kind || void 0 === e.kind ? [
            "user"
        ] : "multi" !== e.kind ? [
            e.kind
        ] : Object.keys(e).filter(function(e) {
            return "kind" !== e;
        }) : [];
    },
    getCanonicalKey: function getCanonicalKey(e) {
        if (e) {
            if ((void 0 === e.kind || null === e.kind || "user" === e.kind) && e.key) return e.key;
            if ("multi" !== e.kind && e.key) return "".concat(e.kind, ":").concat(be(e.key));
            if ("multi" === e.kind) return Object.keys(e).sort().filter(function(e) {
                return "kind" !== e;
            }).map(function(t) {
                return "".concat(t, ":").concat(be(e[t].key));
            }).join(":");
        }
    }
};
var Ee = ke.getContextKinds;
var De = function De() {
    var _$e = {};
    var t = 0, n = 0, r = {}, o = {};
    return _$e.summarizeEvent = function(e) {
        if ("feature" === e.kind) {
            var i = e.key + ":" + (null !== e.variation && void 0 !== e.variation ? e.variation : "") + ":" + (null !== e.version && void 0 !== e.version ? e.version : ""), a = r[i];
            var s = o[e.key];
            s || (s = new Set, o[e.key] = s), (function(e) {
                return e.context ? Ee(e.context) : e.contextKeys ? Object.keys(e.contextKeys) : [];
            })(e).forEach(function(e) {
                return s.add(e);
            }), a ? a.count = a.count + 1 : r[i] = {
                count: 1,
                key: e.key,
                version: e.version,
                variation: e.variation,
                value: e.value,
                default: e.default
            }, (0 === t || e.creationDate < t) && (t = e.creationDate), e.creationDate > n && (n = e.creationDate);
        }
    }, _$e.getSummary = function() {
        var _$e = {};
        var i = !0;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.values(r)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var t1 = _step.value;
                var n1 = _$e[t1.key];
                n1 || (n1 = {
                    default: t1.default,
                    counters: [],
                    contextKinds: _to_consumable_array(o[t1.key])
                }, _$e[t1.key] = n1);
                var r1 = {
                    value: t1.value,
                    count: t1.count
                };
                void 0 !== t1.variation && null !== t1.variation && (r1.variation = t1.variation), void 0 !== t1.version && null !== t1.version ? r1.version = t1.version : r1.unknown = !0, n1.counters.push(r1), i = !1;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return i ? null : {
            startDate: t,
            endDate: n,
            features: _$e
        };
    }, _$e.clearSummary = function() {
        t = 0, n = 0, r = {}, o = {};
    }, _$e;
};
function xe(e) {
    return e.replace(/~/g, "~0").replace(/\//g, "~1");
}
function Ce(e) {
    return (e.startsWith("/") ? e.substring(1) : e).split("/").map(function(e) {
        return e.indexOf("~") >= 0 ? e.replace(/~1/g, "/").replace(/~0/g, "~") : e;
    });
}
function Pe(e) {
    return !e.startsWith("/");
}
function Se(e, t) {
    var n = Pe(e), r = Pe(t);
    if (n && r) return e === t;
    if (n) {
        var n1 = Ce(t);
        return 1 === n1.length && e === n1[0];
    }
    if (r) {
        var n2 = Ce(e);
        return 1 === n2.length && t === n2[0];
    }
    return e === t;
}
function Ie(e) {
    return "/".concat(xe(e));
}
var Oe = {
    cloneExcluding: function cloneExcluding(e, t) {
        var _loop = function() {
            var _$e = n.pop();
            if (t.some(function(t) {
                return Se(t, _$e.ptr);
            })) o.push(_$e.ptr);
            else {
                var _$t = _$e.source[_$e.key];
                if (null === _$t) _$e.parent[_$e.key] = _$t;
                else if (Array.isArray(_$t)) _$e.parent[_$e.key] = _to_consumable_array(_$t);
                else if ("object" == typeof _$t) {
                    var _n;
                    if (_$e.visited.includes(_$t)) return "continue";
                    _$e.parent[_$e.key] = {}, (_n = n).push.apply(_n, _to_consumable_array(Object.keys(_$t).map(function(n) {
                        return {
                            key: n,
                            ptr: (r = _$e.ptr, o = xe(n), "".concat(r, "/").concat(o)),
                            source: _$t,
                            parent: _$e.parent[_$e.key],
                            visited: _to_consumable_array(_$e.visited).concat([
                                _$t
                            ])
                        };
                        var r, o;
                    })));
                } else _$e.parent[_$e.key] = _$t;
            }
        };
        var _n;
        var n = [], r = {}, o = [];
        for((_n = n).push.apply(_n, _to_consumable_array(Object.keys(e).map(function(t) {
            return {
                key: t,
                ptr: Ie(t),
                source: e,
                parent: r,
                visited: [
                    e
                ]
            };
        }))); n.length;)_loop();
        return {
            cloned: r,
            excluded: o.sort()
        };
    },
    compare: Se,
    literalToReference: Ie
};
var Te = function Te(e) {
    var t = {}, n = e.allAttributesPrivate, r = e.privateAttributes || [], o = [
        "key",
        "kind",
        "_meta",
        "anonymous"
    ], i = [
        "name",
        "ip",
        "firstName",
        "lastName",
        "email",
        "avatar",
        "country"
    ], a = function(e, t) {
        if ("object" != typeof e || null === e || Array.isArray(e)) return;
        var _Oe_cloneExcluding = Oe.cloneExcluding(e, function(e, t) {
            return (n || t && e.anonymous ? Object.keys(e) : _to_consumable_array(r).concat(_to_consumable_array(e._meta && e._meta.privateAttributes || []))).filter(function(e) {
                return !o.some(function(t) {
                    return Oe.compare(e, t);
                });
            });
        }(e, t)), i = _Oe_cloneExcluding.cloned, a = _Oe_cloneExcluding.excluded;
        return i.key = String(i.key), a.length && (i._meta || (i._meta = {}), i._meta.redactedAttributes = a), i._meta && (delete i._meta.privateAttributes, 0 === Object.keys(i._meta).length && delete i._meta), void 0 !== i.anonymous && (i.anonymous = !!i.anonymous), i;
    };
    return t.filter = function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
        return void 0 === e.kind || null === e.kind ? a(function(e) {
            var t = _object_spread_props$2(_object_spread$2({}, e.custom || {}), {
                kind: "user",
                key: e.key
            });
            void 0 !== e.anonymous && (t.anonymous = !!e.anonymous);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = i[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var n = _step.value;
                    delete t[n], void 0 !== e[n] && null !== e[n] && (t[n] = String(e[n]));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return void 0 !== e.privateAttributeNames && null !== e.privateAttributeNames && (t._meta = t._meta || {}, t._meta.privateAttributes = e.privateAttributeNames.map(function(e) {
                return e.startsWith("/") ? Oe.literalToReference(e) : e;
            })), t;
        }(e), t) : "multi" === e.kind ? function(e, t) {
            var n = {
                kind: e.kind
            }, r = Object.keys(e);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = r[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var o = _step.value;
                    if ("kind" !== o) {
                        var r1 = a(e[o], t);
                        r1 && (n[o] = r1);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return n;
        }(e, t) : a(e, t);
    }, t;
};
var Le = ke.getContextKeys;
var Ue = function Ue(e, t, n) {
    var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, i = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null;
    var a = {}, c = i || he(e, n, t), u = S.appendUrlPath(t.eventsUrl, "/events/bulk/" + n), l = De(), d = Te(t), f = t.samplingInterval, g = t.eventCapacity, v = t.flushInterval, p = t.logger;
    var m, h = [], y = 0, w = !1, b = !1;
    function k() {
        return 0 === f || 0 === Math.floor(Math.random() * f);
    }
    function E(e) {
        var _$t = S.extend({}, e);
        return "identify" === e.kind ? _$t.context = d.filter(e.context) : "feature" === e.kind ? _$t.context = d.filter(e.context, !0) : (_$t.contextKeys = Le(e.context, p), delete _$t.context), "feature" === e.kind && (delete _$t.trackEvents, delete _$t.debugEventsUntilDate), _$t;
    }
    function D(e) {
        h.length < g ? (h.push(e), b = !1) : (b || (b = !0, p.warn(ie.eventCapacityExceeded())), r && r.incrementDroppedEvents());
    }
    return a.enqueue = function(e) {
        if (w) return;
        var _$t = !1, _$n = !1;
        var r;
        if (l.summarizeEvent(e), "feature" === e.kind ? k() && (_$t = !!e.trackEvents, _$n = !!(r = e).debugEventsUntilDate && r.debugEventsUntilDate > y && r.debugEventsUntilDate > (new Date).getTime()) : _$t = k(), _$t && D(E(e)), _$n) {
            var _$t1 = S.extend({}, e, {
                kind: "debug"
            });
            _$t1.context = d.filter(_$t1.context), delete _$t1.trackEvents, delete _$t1.debugEventsUntilDate, D(_$t1);
        }
    }, a.flush = function() {
        if (w) return Promise.resolve();
        var _$e = h, _$t = l.getSummary();
        return l.clearSummary(), _$t && (_$t.kind = "summary", _$e.push(_$t)), r && r.setEventsInLastBatch(_$e.length), 0 === _$e.length ? Promise.resolve() : (h = [], p.debug(ie.debugPostingEvents(_$e.length)), c.sendEvents(_$e, u).then(function(e) {
            e && (e.serverTime && (y = e.serverTime), s.isHttpErrorRecoverable(e.status) || (w = !0), e.status >= 400 && S.onNextTick(function() {
                o.maybeReportError(new s.LDUnexpectedResponseError(ie.httpErrorMessage(e.status, "event posting", "some events were dropped")));
            }));
        }));
    }, a.start = function() {
        var _$e = function() {
            a.flush(), m = setTimeout(_$e, v);
        };
        m = setTimeout(_$e, v);
    }, a.stop = function() {
        clearTimeout(m);
    }, a;
};
var Re = function Re(e) {
    var t = {}, n = {};
    return t.on = function(e, t, r) {
        n[e] = n[e] || [], n[e] = n[e].concat({
            handler: t,
            context: r
        });
    }, t.off = function(e, t, r) {
        if (n[e]) for(var o = 0; o < n[e].length; o++)n[e][o].handler === t && n[e][o].context === r && (n[e] = n[e].slice(0, o).concat(n[e].slice(o + 1)));
    }, t.emit = function(e) {
        if (!n[e]) return;
        var t = n[e].slice(0);
        for(var _$e = 0; _$e < t.length; _$e++)t[_$e].handler.apply(t[_$e].context, Array.prototype.slice.call(arguments, 1));
    }, t.getEvents = function() {
        return Object.keys(n);
    }, t.getEventListenerCount = function(e) {
        return n[e] ? n[e].length : 0;
    }, t.maybeReportError = function(t) {
        t && (n["error"] ? this.emit("error", t) : (e || console).error(t.message));
    }, t;
};
var Ae = "ready", je = "initialized", Fe = "failed";
var Ne = function Ne(e) {
    var t = !1, n = !1, r = null, o = null;
    var i = new Promise(function(t) {
        var n = function() {
            e.off(Ae, n), t();
        };
        e.on(Ae, n);
    }).catch(function() {});
    return {
        getInitializationPromise: function() {
            return o || (t ? Promise.resolve() : n ? Promise.reject(r) : (o = new Promise(function(t, n) {
                var r = function() {
                    e.off(je, r), t();
                }, o = function(t) {
                    e.off(Fe, o), n(t);
                };
                e.on(je, r), e.on(Fe, o);
            }), o));
        },
        getReadyPromise: function() {
            return i;
        },
        signalSuccess: function() {
            t || n || (t = !0, e.emit(je), e.emit(Ae));
        },
        signalFailure: function(o) {
            t || n || (n = !0, r = o, e.emit(Fe, o), e.emit(Ae)), e.maybeReportError(o);
        }
    };
};
var $e = function $e(e, t, n, r) {
    var o = {};
    function i() {
        var _$e = "";
        var o = r.getContext();
        return o && (_$e = n || S.btoa(JSON.stringify(o))), "ld:" + t + ":" + _$e;
    }
    return o.loadFlags = function() {
        return e.get(i()).then(function(e) {
            if (null == e) return null;
            try {
                var t = JSON.parse(e);
                if (t) {
                    var _$e = t.$schema;
                    void 0 === _$e || _$e < 1 ? t = S.transformValuesToVersionedValues(t) : delete t.$schema;
                }
                return t;
            } catch (e) {
                return o.clearFlags().then(function() {
                    return null;
                });
            }
        });
    }, o.saveFlags = function(t) {
        var n = S.extend({}, t, {
            $schema: 1
        });
        return e.set(i(), JSON.stringify(n));
    }, o.clearFlags = function() {
        return e.clear(i());
    }, o;
};
var Ve = function Ve(e, t) {
    var n = {};
    var r = !1;
    var o = function(e) {
        r || (r = !0, t.warn(ie.localStorageUnavailable(e)));
    };
    return n.isEnabled = function() {
        return !!e;
    }, n.get = function(t) {
        return new Promise(function(n) {
            e ? e.get(t).then(n).catch(function(e) {
                o(e), n(void 0);
            }) : n(void 0);
        });
    }, n.set = function(t, n) {
        return new Promise(function(r) {
            e ? e.set(t, n).then(function() {
                return r(!0);
            }).catch(function(e) {
                o(e), r(!1);
            }) : r(!1);
        });
    }, n.clear = function(t) {
        return new Promise(function(n) {
            e ? e.clear(t).then(function() {
                return n(!0);
            }).catch(function(e) {
                o(e), n(!1);
            }) : n(!1);
        });
    }, n;
};
var Me = S.appendUrlPath, qe = S.base64URLEncode, He = S.objectHasOwnProperty, ze = ge.getLDHeaders, Ke = ge.transformHeaders, _e = s.isHttpErrorRecoverable;
var Je = function Je(e, t, n, r) {
    var o = t.streamUrl, i = t.logger, a = {}, s = Me(o, "/eval/" + n), c = t.useReport, u = t.evaluationReasons, l = t.streamReconnectDelay, d = ze(e, t);
    var f, g = !1, v = null, p = null, m = null, h = null, y = null, w = 0;
    function b() {
        var _$e = (_$t = function() {
            var _$e = l * Math.pow(2, w);
            return _$e > 3e4 ? 3e4 : _$e;
        }(), _$t - Math.trunc(.5 * Math.random() * _$t));
        var _$t;
        return w += 1, _$e;
    }
    function k(e) {
        if (e.status && "number" == typeof e.status && !_e(e.status)) return x(), i.error(ie.unrecoverableStreamError(e)), void (p && (clearTimeout(p), p = null));
        var _$t = b();
        g || (i.warn(ie.streamError(e, _$t)), g = !0), C(!1), x(), E(_$t);
    }
    function E(e) {
        p || (e ? p = setTimeout(D, e) : D());
    }
    function D() {
        var r;
        p = null;
        var a = "";
        var l = {
            headers: d,
            readTimeoutMillis: 3e5
        };
        if (e.eventSourceFactory) {
            null != h && (a = "h=" + h), c ? e.eventSourceAllowsReport ? (r = s, l.method = "REPORT", l.headers["Content-Type"] = "application/json", l.body = JSON.stringify(m)) : (r = Me(o, "/ping/" + n), a = "") : r = s + "/" + qe(JSON.stringify(m)), l.headers = Ke(l.headers, t), u && (a = a + (a ? "&" : "") + "withReasons=true"), r = r + (a ? "?" : "") + a, x(), i.info(ie.streamConnecting(r)), f = (new Date).getTime(), v = e.eventSourceFactory(r, l);
            for(var _$e in y)He(y, _$e) && v.addEventListener(_$e, y[_$e]);
            v.onerror = k, v.onopen = function() {
                w = 0;
            };
        }
    }
    function x() {
        v && (i.info(ie.streamClosing()), v.close(), v = null);
    }
    function C(e) {
        f && r && r.recordStreamInit(f, !e, (new Date).getTime() - f), f = null;
    }
    return a.connect = function(e, t, n) {
        var _loop = function(_$e) {
            y[_$e] = function(t) {
                g = !1, C(!0), n[_$e] && n[_$e](t);
            };
        };
        m = e, h = t, y = {};
        for(var _$e in n || {})_loop(_$e);
        E();
    }, a.disconnect = function() {
        clearTimeout(p), p = null, x();
    }, a.isConnected = function() {
        return !!(v && e.eventSourceIsActive && e.eventSourceIsActive(v));
    }, a;
};
var Be = function Be(e) {
    var t, n, r, o;
    var i = {
        addPromise: function(i, a) {
            t = i, n && n(), n = a, i.then(function(n) {
                t === i && (r(n), e && e());
            }, function(n) {
                t === i && (o(n), e && e());
            });
        }
    };
    return i.resultPromise = new Promise(function(e, t) {
        r = e, o = t;
    }), i;
};
var Ge = ge.transformHeaders, We = ge.getLDHeaders, Xe = "application/json";
var Qe = function Qe(e, t, n) {
    var r = t.baseUrl, o = t.useReport, i = t.evaluationReasons, a = t.logger, c = {}, u = {};
    function l(n, r) {
        if (!e.httpRequest) return new Promise(function(e, t) {
            t(new s.LDFlagFetchError(ie.httpUnavailable()));
        });
        var o = r ? "REPORT" : "GET", i = We(e, t);
        r && (i["Content-Type"] = Xe);
        var a = u[n];
        a || (a = Be(function() {
            delete u[n];
        }), u[n] = a);
        var c = e.httpRequest(o, n, Ge(i, t), r), l = c.promise.then(function(e) {
            if (200 === e.status) {
                if (e.header("content-type") && e.header("content-type").substring(0, 16) === Xe) return JSON.parse(e.body);
                {
                    var _$t = ie.invalidContentType(e.header("content-type") || "");
                    return Promise.reject(new s.LDFlagFetchError(_$t));
                }
            }
            return Promise.reject(function(e) {
                return 404 === e.status ? new s.LDInvalidEnvironmentIdError(ie.environmentNotFound()) : new s.LDFlagFetchError(ie.errorFetchingFlags(e.statusText || String(e.status)));
            }(e));
        }, function(e) {
            return Promise.reject(new s.LDFlagFetchError(ie.networkError(e)));
        });
        return a.addPromise(l, function() {
            c.cancel && c.cancel();
        }), a.resultPromise;
    }
    return c.fetchJSON = function(e) {
        return l(S.appendUrlPath(r, e), null);
    }, c.fetchFlagSettings = function(e, t) {
        var s, c, u, d = "";
        return o ? (c = [
            r,
            "/sdk/evalx/",
            n,
            "/context"
        ].join(""), u = JSON.stringify(e)) : (s = S.base64URLEncode(JSON.stringify(e)), c = [
            r,
            "/sdk/evalx/",
            n,
            "/contexts/",
            s
        ].join("")), t && (d = "h=" + t), i && (d = d + (d ? "&" : "") + "withReasons=true"), c = c + (d ? "?" : "") + d, a.debug(ie.debugPolling(c)), l(c, u);
    }, c;
};
var Ye = function Ye(e, t) {
    var n = {};
    var r;
    return n.setContext = function(e) {
        r = S.sanitizeContext(e), r && t && t(S.clone(r));
    }, n.getContext = function() {
        return r ? S.clone(r) : null;
    }, e && n.setContext(e), n;
};
var Ze = ee.v1, et = ke.getContextKinds;
var tt = function tt(e) {
    function t(e) {
        return null == e || "user" === e ? "ld:$anonUserId" : "ld:$contextKey:".concat(e);
    }
    function n(n, r) {
        return null !== r.key && void 0 !== r.key ? (r.key = r.key.toString(), Promise.resolve(r)) : r.anonymous ? (function(n) {
            return e.get(t(n));
        })(n).then(function(o) {
            if (o) return r.key = o, r;
            {
                var _$o = Ze();
                return r.key = _$o, (function(n, r) {
                    return e.set(t(r), n);
                })(_$o, n).then(function() {
                    return r;
                });
            }
        }) : Promise.reject(new s.LDInvalidUserError(ie.invalidContext()));
    }
    this.processContext = function(e) {
        if (!e) return Promise.reject(new s.LDInvalidUserError(ie.contextNotSpecified()));
        var t = S.clone(e);
        if ("multi" === e.kind) {
            var _$e = et(t);
            return Promise.all(_$e.map(function(e) {
                return n(e, t[e]);
            })).then(function() {
                return t;
            });
        }
        return n(e.kind, t);
    };
};
var nt = ee.v1, rt = de.baseOptionDefs, ot = S.appendUrlPath;
var it = {
    DiagnosticId: function DiagnosticId(e) {
        var t = {
            diagnosticId: nt()
        };
        return e && (t.sdkKeySuffix = e.length > 6 ? e.substring(e.length - 6) : e), t;
    },
    DiagnosticsAccumulator: function DiagnosticsAccumulator(e) {
        var t, n, r, o;
        function i(e) {
            t = e, n = 0, r = 0, o = [];
        }
        return i(e), {
            getProps: function() {
                return {
                    dataSinceDate: t,
                    droppedEvents: n,
                    eventsInLastBatch: r,
                    streamInits: o
                };
            },
            setProps: function(e) {
                t = e.dataSinceDate, n = e.droppedEvents || 0, r = e.eventsInLastBatch || 0, o = e.streamInits || [];
            },
            incrementDroppedEvents: function() {
                n++;
            },
            setEventsInLastBatch: function(e) {
                r = e;
            },
            recordStreamInit: function(e, t, n) {
                var r = {
                    timestamp: e,
                    failed: t,
                    durationMillis: n
                };
                o.push(r);
            },
            reset: i
        };
    },
    DiagnosticsManager: function DiagnosticsManager(e, t, n, r, o, i, a) {
        var s = !!e.diagnosticUseCombinedEvent, c = "ld:" + o + ":$diagnostics", u = ot(i.eventsUrl, "/events/diagnostic/" + o), l = i.diagnosticRecordingInterval, d = n;
        var f, g, v = !!i.streaming;
        var p = {};
        function m() {
            return {
                sdk: w(),
                configuration: b(),
                platform: e.diagnosticPlatformData
            };
        }
        function h(e) {
            i.logger && i.logger.debug(ie.debugPostingDiagnosticEvent(e)), r.sendEvents(e, u, !0).then(function() {}).catch(function() {});
        }
        function y() {
            h(function() {
                var _$e = (new Date).getTime();
                var t = _object_spread$2({
                    kind: s ? "diagnostic-combined" : "diagnostic",
                    id: a,
                    creationDate: _$e
                }, d.getProps());
                return s && (t = _object_spread$2({}, t, m())), d.reset(_$e), t;
            }()), g = setTimeout(y, l), f = (new Date).getTime(), s && function() {
                if (t.isEnabled()) {
                    var _$e = _object_spread$2({}, d.getProps());
                    t.set(c, JSON.stringify(_$e));
                }
            }();
        }
        function w() {
            var t = _object_spread$2({}, e.diagnosticSdkData);
            return i.wrapperName && (t.wrapperName = i.wrapperName), i.wrapperVersion && (t.wrapperVersion = i.wrapperVersion), t;
        }
        function b() {
            return {
                customBaseURI: i.baseUrl !== rt.baseUrl.default,
                customStreamURI: i.streamUrl !== rt.streamUrl.default,
                customEventsURI: i.eventsUrl !== rt.eventsUrl.default,
                eventsCapacity: i.eventCapacity,
                eventsFlushIntervalMillis: i.flushInterval,
                reconnectTimeMillis: i.streamReconnectDelay,
                streamingDisabled: !v,
                allAttributesPrivate: !!i.allAttributesPrivate,
                diagnosticRecordingIntervalMillis: i.diagnosticRecordingInterval,
                usingSecureMode: !!i.hash,
                bootstrapMode: !!i.bootstrap,
                fetchGoalsDisabled: !i.fetchGoals,
                sendEventsOnlyForVariation: !!i.sendEventsOnlyForVariation
            };
        }
        return p.start = function() {
            s ? function(e) {
                if (!t.isEnabled()) return e(!1);
                t.get(c).then(function(t) {
                    if (t) try {
                        var _$e = JSON.parse(t);
                        d.setProps(_$e), f = _$e.dataSinceDate;
                    } catch (e) {}
                    e(!0);
                }).catch(function() {
                    e(!1);
                });
            }(function(e) {
                if (e) {
                    var _$e = (f || 0) + l, t = (new Date).getTime();
                    t >= _$e ? y() : g = setTimeout(y, _$e - t);
                } else 0 === Math.floor(4 * Math.random()) ? y() : g = setTimeout(y, l);
            }) : (h(_object_spread$2({
                kind: "diagnostic-init",
                id: a,
                creationDate: d.getProps().dataSinceDate
            }, m())), g = setTimeout(y, l));
        }, p.stop = function() {
            g && clearTimeout(g);
        }, p.setStreaming = function(e) {
            v = e;
        }, p;
    }
};
var at = function at(e, t) {
    var n = !1;
    var r = {
        type: e.type,
        name: e.name,
        synchronous: e.synchronous,
        method: function() {
            for(var _len = arguments.length, o = new Array(_len), _key = 0; _key < _len; _key++){
                o[_key] = arguments[_key];
            }
            try {
                var _e;
                (_e = e).method.apply(_e, _to_consumable_array(o));
            } catch (e) {
                n || (n = !0, t.warn(ie.inspectorMethodError(r.type, r.name)));
            }
        }
    };
    return r;
};
var st = S.onNextTick, ct = {
    flagUsed: "flag-used",
    flagDetailsChanged: "flag-details-changed",
    flagDetailChanged: "flag-detail-changed",
    clientIdentityChanged: "client-identity-changed"
};
Object.freeze(ct);
var ut = {
    InspectorTypes: ct,
    InspectorManager: function InspectorManager(e, t) {
        var _obj, _obj1;
        var n = {}, r = (_obj = {}, _define_property$2(_obj, ct.flagUsed, []), _define_property$2(_obj, ct.flagDetailsChanged, []), _define_property$2(_obj, ct.flagDetailChanged, []), _define_property$2(_obj, ct.clientIdentityChanged, []), _obj), o = (_obj1 = {}, _define_property$2(_obj1, ct.flagUsed, []), _define_property$2(_obj1, ct.flagDetailsChanged, []), _define_property$2(_obj1, ct.flagDetailChanged, []), _define_property$2(_obj1, ct.clientIdentityChanged, []), _obj1), i = e && e.map(function(e) {
            return at(e, t);
        });
        return i && i.forEach(function(e) {
            Object.prototype.hasOwnProperty.call(r, e.type) && !e.synchronous ? r[e.type].push(e) : Object.prototype.hasOwnProperty.call(o, e.type) && e.synchronous ? o[e.type].push(e) : t.warn(ie.invalidInspector(e.type, e.name));
        }), n.hasListeners = function(e) {
            return r[e] && r[e].length || o[e] && o[e].length;
        }, n.onFlagUsed = function(e, t, n) {
            var i = ct.flagUsed;
            o[i].length && o[i].forEach(function(r) {
                return r.method(e, t, n);
            }), r[i].length && st(function() {
                r[i].forEach(function(r) {
                    return r.method(e, t, n);
                });
            });
        }, n.onFlags = function(e) {
            var t = ct.flagDetailsChanged;
            o[t].length && o[t].forEach(function(t) {
                return t.method(e);
            }), r[t].length && st(function() {
                r[t].forEach(function(t) {
                    return t.method(e);
                });
            });
        }, n.onFlagChanged = function(e, t) {
            var n = ct.flagDetailChanged;
            o[n].length && o[n].forEach(function(n) {
                return n.method(e, t);
            }), r[n].length && st(function() {
                r[n].forEach(function(n) {
                    return n.method(e, t);
                });
            });
        }, n.onIdentityChanged = function(e) {
            var t = ct.clientIdentityChanged;
            o[t].length && o[t].forEach(function(t) {
                return t.method(e);
            }), r[t].length && st(function() {
                r[t].forEach(function(t) {
                    return t.method(e);
                });
            });
        }, n;
    }
};
var lt = s.LDTimeoutError;
var dt = function dt(e, t) {
    return new Promise(function(n, r) {
        setTimeout(function() {
            r(new lt("".concat(t, " timed out after ").concat(e, " seconds.")));
        }, 1e3 * e);
    });
};
var ft = ne.commonBasicLogger, gt = ke.checkContext, vt = ke.getContextKeys, pt = ut.InspectorTypes, mt = ut.InspectorManager, ht = "change", yt = "internal-change";
var wt = {
    initialize: function initialize(e, t, n, r, o) {
        var i = function() {
            if (n && n.logger) return n.logger;
            return o && o.logger && o.logger.default || ft("warn");
        }(), a = Re(i), c = Ne(a), u = de.validate(n, a, o, i), l = mt(u.inspectors, i), d = u.sendEvents;
        var f = e, g = u.hash;
        var v = Ve(r.localStorage, i), p = he(r, f, u), m = u.sendEvents && !u.diagnosticOptOut, h = m ? it.DiagnosticId(f) : null, y = m ? it.DiagnosticsAccumulator((new Date).getTime()) : null, w = m ? it.DiagnosticsManager(r, v, y, p, f, u, h) : null, b = Je(r, u, f, y), k = u.eventProcessor || Ue(r, u, f, y, a, p), E = Qe(r, u, f);
        var D, _$x, _$C, P = {}, I = u.streaming, O = !1, T = !1, _$L = !0;
        var U = u.stateProvider, R = Ye(null, function(e) {
            ((function(e) {
                if (U) return;
                e && F({
                    kind: "identify",
                    context: e,
                    creationDate: (new Date).getTime()
                });
            }))(e), l.hasListeners(pt.clientIdentityChanged) && l.onIdentityChanged(R.getContext());
        }), A = new tt(v), j = v.isEnabled() ? $e(v, f, g, R) : null;
        function F(e) {
            f && (U && U.enqueueEvent && U.enqueueEvent(e) || (e.context ? (_$L = !1, !d || T || r.isDoNotTrack() || (i.debug(ie.debugEnqueueingEvent(e.kind)), k.enqueue(e))) : _$L && (i.warn(ie.eventWithoutContext()), _$L = !1)));
        }
        function N(e, t) {
            l.hasListeners(pt.flagDetailChanged) && l.onFlagChanged(e.key, H(t));
        }
        function $() {
            l.hasListeners(pt.flagDetailsChanged) && l.onFlags(Object.entries(P).map(function(param) {
                var _param = _sliced_to_array$1(param, 2), _$e = _param[0], t = _param[1];
                return {
                    key: _$e,
                    detail: H(t)
                };
            }).reduce(function(e, t) {
                return e[t.key] = t.detail, e;
            }, {}));
        }
        function V(e, t, n, r) {
            var _$o = R.getContext(), i = new Date, a = {
                kind: "feature",
                key: e,
                context: _$o,
                value: t ? t.value : null,
                variation: t ? t.variationIndex : null,
                default: n,
                creationDate: i.getTime()
            }, s = P[e];
            s && (a.version = s.flagVersion ? s.flagVersion : s.version, a.trackEvents = s.trackEvents, a.debugEventsUntilDate = s.debugEventsUntilDate), (r || s && s.trackReason) && t && (a.reason = t.reason), F(a);
        }
        function M(e) {
            return gt(e, !1) ? Promise.resolve(e) : Promise.reject(new s.LDInvalidUserError(ie.invalidContext()));
        }
        function q(e, t, n, r, o, i) {
            var _s_prerequisites;
            var a, s;
            return P && S.objectHasOwnProperty(P, e) && P[e] && !P[e].deleted ? (s = P[e], a = H(s), null !== s.value && void 0 !== s.value || (a.value = t)) : a = {
                value: t,
                variationIndex: null,
                reason: {
                    kind: "ERROR",
                    errorKind: "FLAG_NOT_FOUND"
                }
            }, n && (o || (s === null || s === void 0 ? void 0 : (_s_prerequisites = s.prerequisites) === null || _s_prerequisites === void 0 ? void 0 : _s_prerequisites.forEach(function(e) {
                q(e, void 0, n, !1, !1, !1);
            })), V(e, a, t, r)), !o && i && function(e, t) {
                l.hasListeners(pt.flagUsed) && l.onFlagUsed(e, t, R.getContext());
            }(e, a), a;
        }
        function H(e) {
            return {
                value: e.value,
                variationIndex: void 0 === e.variation ? null : e.variation,
                reason: e.reason || null
            };
        }
        function z() {
            if (_$x = !0, !R.getContext()) return;
            var _$e = function(e) {
                try {
                    return JSON.parse(e);
                } catch (e) {
                    return void a.maybeReportError(new s.LDInvalidDataError(ie.invalidData()));
                }
            };
            b.connect(R.getContext(), g, {
                ping: function ping() {
                    i.debug(ie.debugStreamPing());
                    var _$e = R.getContext();
                    E.fetchFlagSettings(_$e, g).then(function(t) {
                        S.deepEquals(_$e, R.getContext()) && _(t || {});
                    }).catch(function(e) {
                        a.maybeReportError(new s.LDFlagFetchError(ie.errorFetchingFlags(e)));
                    });
                },
                put: function put(t) {
                    var _$n = _$e(t.data);
                    _$n && (i.debug(ie.debugStreamPut()), _(_$n));
                },
                patch: function patch(t) {
                    var _$n = _$e(t.data);
                    if (!_$n) return;
                    var _$r = P[_$n.key];
                    if (!_$r || !_$r.version || !_$n.version || _$r.version < _$n.version) {
                        i.debug(ie.debugStreamPatch(_$n.key));
                        var _$e1 = {}, _$t = S.extend({}, _$n);
                        delete _$t.key, P[_$n.key] = _$t;
                        var _$o = H(_$t);
                        _$e1[_$n.key] = _$r ? {
                            previous: _$r.value,
                            current: _$o
                        } : {
                            current: _$o
                        }, N(_$n, _$t), J(_$e1);
                    } else i.debug(ie.debugStreamPatchIgnored(_$n.key));
                },
                delete: function _delete(t) {
                    var _$n = _$e(t.data);
                    if (_$n) if (!P[_$n.key] || P[_$n.key].version < _$n.version) {
                        i.debug(ie.debugStreamDelete(_$n.key));
                        var _$e1 = {};
                        P[_$n.key] && !P[_$n.key].deleted && (_$e1[_$n.key] = {
                            previous: P[_$n.key].value
                        }), P[_$n.key] = {
                            version: _$n.version,
                            deleted: !0
                        }, N(_$n, P[_$n.key]), J(_$e1);
                    } else i.debug(ie.debugStreamDeleteIgnored(_$n.key));
                }
            });
        }
        function K() {
            _$x && (b.disconnect(), _$x = !1);
        }
        function _(e) {
            var t = {};
            if (!e) return Promise.resolve();
            for(var _$n in P)S.objectHasOwnProperty(P, _$n) && P[_$n] && (e[_$n] && !S.deepEquals(e[_$n].value, P[_$n].value) ? t[_$n] = {
                previous: P[_$n].value,
                current: H(e[_$n])
            } : e[_$n] && !e[_$n].deleted || (t[_$n] = {
                previous: P[_$n].value
            }));
            for(var _$n1 in e)S.objectHasOwnProperty(e, _$n1) && e[_$n1] && (!P[_$n1] || P[_$n1].deleted) && (t[_$n1] = {
                current: H(e[_$n1])
            });
            return P = _object_spread$2({}, e), $(), J(t).catch(function() {});
        }
        function J(e) {
            var t = Object.keys(e);
            if (t.length > 0) {
                var _$n = {};
                t.forEach(function(t) {
                    var _$r = e[t].current, _$o = _$r ? _$r.value : void 0, i = e[t].previous;
                    a.emit(ht + ":" + t, _$o, i), _$n[t] = _$r ? {
                        current: _$o,
                        previous: i
                    } : {
                        previous: i
                    };
                }), a.emit(ht, _$n), a.emit(yt, P), u.sendEventsOnlyForVariation || U || t.forEach(function(t) {
                    V(t, e[t].current);
                });
            }
            return D && j ? j.saveFlags(P) : Promise.resolve();
        }
        function B() {
            var _$e = I || _$C && void 0 === I;
            _$e && !_$x ? z() : !_$e && _$x && K(), w && w.setStreaming(_$e);
        }
        function G(e) {
            return e === ht || e.substr(0, 7) === ht + ":";
        }
        if ("string" == typeof u.bootstrap && "LOCALSTORAGE" === u.bootstrap.toUpperCase() && (j ? D = !0 : i.warn(ie.localStorageUnavailable())), "object" == typeof u.bootstrap && (P = function(e) {
            var t = Object.keys(e), _$n = "$flagsState", _$r = "$valid", _$o = e[_$n];
            !_$o && t.length && i.warn(ie.bootstrapOldFormat()), !1 === e[_$r] && i.warn(ie.bootstrapInvalid());
            var a = {};
            return t.forEach(function(t) {
                if (t !== _$n && t !== _$r) {
                    var _$n1 = {
                        value: e[t]
                    };
                    _$o && _$o[t] ? _$n1 = S.extend(_$n1, _$o[t]) : _$n1.version = 0, a[t] = _$n1;
                }
            }), a;
        }(u.bootstrap)), U) {
            var _$e = U.getInitialState();
            _$e ? W(_$e) : U.on("init", W), U.on("update", function(e) {
                e.context && R.setContext(e.context);
                e.flags && _(e.flags);
            });
        } else (function() {
            if (!e) return Promise.reject(new s.LDInvalidEnvironmentIdError(ie.environmentNotSpecified()));
            return A.processContext(t).then(M).then(function(e) {
                return R.setContext(e), "object" == typeof u.bootstrap ? X() : D ? j.loadFlags().then(function(e) {
                    return null == e ? (P = {}, E.fetchFlagSettings(R.getContext(), g).then(function(e) {
                        return _(e || {});
                    }).then(X).catch(function(e) {
                        Q(new s.LDFlagFetchError(ie.errorFetchingFlags(e)));
                    })) : (P = e, S.onNextTick(X), E.fetchFlagSettings(R.getContext(), g).then(function(e) {
                        return _(e);
                    }).catch(function(e) {
                        return a.maybeReportError(e);
                    }));
                }) : E.fetchFlagSettings(R.getContext(), g).then(function(e) {
                    P = e || {}, $(), X();
                }).catch(function(e) {
                    P = {}, Q(e);
                });
            });
        })().catch(Q);
        function W(e) {
            f = e.environment, R.setContext(e.context), P = _object_spread$2({}, e.flags), S.onNextTick(X);
        }
        function X() {
            i.info(ie.clientInitialized()), O = !0, B(), c.signalSuccess();
        }
        function Q(e) {
            c.signalFailure(e);
        }
        var Y = {
            waitForInitialization: function waitForInitialization() {
                var _$e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : void 0;
                if (null != _$e) {
                    if ("number" == typeof _$e) return function(e) {
                        e > 5 && i.warn("The waitForInitialization function was called with a timeout greater than 5 seconds. We recommend a timeout of 5 seconds or less.");
                        var t = c.getInitializationPromise(), _$n = dt(e, "waitForInitialization");
                        return Promise.race([
                            _$n,
                            t
                        ]).catch(function(e) {
                            throw _instanceof(e, s.LDTimeoutError) && i.error("waitForInitialization error: ".concat(e)), e;
                        });
                    }(_$e);
                    i.warn("The waitForInitialization method was provided with a non-numeric timeout.");
                }
                return i.warn("The waitForInitialization function was called without a timeout specified. In a future version a default timeout will be applied."), c.getInitializationPromise();
            },
            waitUntilReady: function() {
                return c.getReadyPromise();
            },
            identify: function identify(e, t, n) {
                if (T) return S.wrapPromiseCallback(Promise.resolve({}), n);
                if (U) return i.warn(ie.identifyDisabled()), S.wrapPromiseCallback(Promise.resolve(S.transformVersionedValuesToValues(P)), n);
                var _$r = D && j ? j.clearFlags() : Promise.resolve();
                return S.wrapPromiseCallback(_$r.then(function() {
                    return A.processContext(e);
                }).then(M).then(function(e) {
                    return E.fetchFlagSettings(e, t).then(function(n) {
                        var _$r = S.transformVersionedValuesToValues(n);
                        return R.setContext(e), g = t, n ? _(n).then(function() {
                            return _$r;
                        }) : _$r;
                    });
                }).then(function(e) {
                    return _$x && z(), e;
                }).catch(function(e) {
                    return a.maybeReportError(e), Promise.reject(e);
                }), n);
            },
            getContext: function getContext() {
                return R.getContext();
            },
            variation: function variation(e, t) {
                return q(e, t, !0, !1, !1, !0).value;
            },
            variationDetail: function variationDetail(e, t) {
                return q(e, t, !0, !0, !1, !0);
            },
            track: function track(e, t, n) {
                if ("string" != typeof e) return void a.maybeReportError(new s.LDInvalidEventKeyError(ie.unknownCustomEventKey(e)));
                void 0 !== n && "number" != typeof n && i.warn(ie.invalidMetricValue(typeof n === "undefined" ? "undefined" : _type_of(n))), r.customEventFilter && !r.customEventFilter(e) && i.warn(ie.unknownCustomEventKey(e));
                var _$o = R.getContext(), c = {
                    kind: "custom",
                    key: e,
                    context: _$o,
                    url: r.getCurrentUrl(),
                    creationDate: (new Date).getTime()
                };
                _$o && _$o.anonymous && (c.contextKind = _$o.anonymous ? "anonymousUser" : "user"), null != t && (c.data = t), null != n && (c.metricValue = n), F(c);
            },
            on: function on(e, t, n) {
                var _a;
                G(e) ? (_$C = !0, O && B(), a.on(e, t, n)) : (_a = a).on.apply(_a, arguments);
            },
            off: function off(e) {
                var _a;
                if ((_a = a).off.apply(_a, arguments), G(e)) {
                    var _$e = !1;
                    a.getEvents().forEach(function(t) {
                        G(t) && a.getEventListenerCount(t) > 0 && (_$e = !0);
                    }), _$e || (_$C = !1, _$x && void 0 === I && K());
                }
            },
            setStreaming: function setStreaming(e) {
                var t = null === e ? void 0 : e;
                t !== I && (I = t, B());
            },
            flush: function flush(e) {
                return S.wrapPromiseCallback(d ? k.flush() : Promise.resolve(), e);
            },
            allFlags: function allFlags() {
                var _$e = {};
                if (!P) return _$e;
                for(var t in P)S.objectHasOwnProperty(P, t) && !P[t].deleted && (_$e[t] = q(t, null, !u.sendEventsOnlyForVariation, !1, !0, !1).value);
                return _$e;
            },
            close: function close(e) {
                if (T) return S.wrapPromiseCallback(Promise.resolve(), e);
                var t = function() {
                    T = !0, P = {};
                }, _$n = Promise.resolve().then(function() {
                    if (K(), w && w.stop(), d) return k.stop(), k.flush();
                }).then(t).catch(t);
                return S.wrapPromiseCallback(_$n, e);
            }
        };
        return {
            client: Y,
            options: u,
            emitter: a,
            ident: R,
            logger: i,
            requestor: E,
            start: function start() {
                d && (w && w.start(), k.start());
            },
            enqueueEvent: F,
            getFlagsInternal: function getFlagsInternal() {
                return P;
            },
            getEnvironmentId: function() {
                return f;
            },
            internalChangeEventName: yt
        };
    },
    commonBasicLogger: ft,
    errors: s,
    messages: ie,
    utils: S,
    getContextKeys: vt
}, bt = wt.initialize, kt = wt.errors;
function Dt(e, t, n) {
    return (t = function(e) {
        var _$t = function(e, t) {
            if ("object" != typeof e || !e) return e;
            var _$n = e[Symbol.toPrimitive];
            if (void 0 !== _$n) {
                var r = _$n.call(e, t || "default");
                if ("object" != typeof r) return r;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
        }(e, "string");
        return "symbol" == (typeof _$t === "undefined" ? "undefined" : _type_of(_$t)) ? _$t : _$t + "";
    }(t)) in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = n, e;
}
function xt(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function(t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
    }
    return n;
}
function Ct(e) {
    for(var t = 1; t < arguments.length; t++){
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? xt(Object(n), !0).forEach(function(t) {
            Dt(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : xt(Object(n)).forEach(function(t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
    }
    return e;
}
var It = {
    promise: Promise.resolve({
        status: 200,
        header: function header() {
            return null;
        },
        body: null
    })
};
function Ot(e, t, n, r, o) {
    if (o && !function() {
        var _$e = window.navigator && window.navigator.userAgent;
        if (_$e) {
            var _$t = _$e.match(/Chrom(e|ium)\/([0-9]+)\./);
            if (_$t) return parseInt(_$t[2], 10) < 73;
        }
        return !0;
    }()) return It;
    var i = new window.XMLHttpRequest;
    for(var a in i.open(e, t, !o), n || {})Object.prototype.hasOwnProperty.call(n, a) && i.setRequestHeader(a, n[a]);
    if (o) {
        try {
            i.send(r);
        } catch (e) {}
        return It;
    }
    var s, c = new Promise(function(e, t) {
        i.addEventListener("load", function() {
            s || e({
                status: i.status,
                header: function header(e) {
                    return i.getResponseHeader(e);
                },
                body: i.responseText
            });
        }), i.addEventListener("error", function() {
            s || t(new Error);
        }), i.send(r);
    });
    return {
        promise: c,
        cancel: function cancel() {
            s = !0, i.abort();
        }
    };
}
var Tt = function(e) {
    if ("string" != typeof e) throw new TypeError("Expected a string");
    return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
};
function Lt(e, t, n, r) {
    var o, i, a = (("substring" === e.kind || "regex" === e.kind) && r.includes("/") ? t : t.replace(r, "")).replace(n, "");
    switch(e.kind){
        case "exact":
            i = t, o = new RegExp("^" + Tt(e.url) + "/?$");
            break;
        case "canonical":
            i = a, o = new RegExp("^" + Tt(e.url) + "/?$");
            break;
        case "substring":
            i = a, o = new RegExp(".*" + Tt(e.substring) + ".*$");
            break;
        case "regex":
            i = a, o = new RegExp(e.pattern);
            break;
        default:
            return !1;
    }
    return o.test(i);
}
function Ut(e, t) {
    for(var n = {}, r = null, o = [], i = 0; i < e.length; i++)for(var a = e[i], s = a.urls || [], c = 0; c < s.length; c++)if (Lt(s[c], window.location.href, window.location.search, window.location.hash)) {
        "pageview" === a.kind ? t("pageview", a) : (o.push(a), t("click_pageview", a));
        break;
    }
    return o.length > 0 && (r = function r(e) {
        for(var n = function(e, t) {
            for(var n = [], r = 0; r < t.length; r++)for(var o = e.target, i = t[r], a = i.selector, s = document.querySelectorAll(a); o && s.length > 0;){
                for(var c = 0; c < s.length; c++)o === s[c] && n.push(i);
                o = o.parentNode;
            }
            return n;
        }(e, o), r = 0; r < n.length; r++)t("click", n[r]);
    }, document.addEventListener("click", r)), n.dispose = function() {
        document.removeEventListener("click", r);
    }, n;
}
function Rt(e, t) {
    var n, r;
    function o() {
        r && r.dispose(), n && n.length && (r = Ut(n, i));
    }
    function i(t, n) {
        var r = e.ident.getContext(), o = {
            kind: t,
            key: n.key,
            data: null,
            url: window.location.href,
            creationDate: (new Date).getTime(),
            context: r
        };
        return "click" === t && (o.selector = n.selector), e.enqueueEvent(o);
    }
    return e.requestor.fetchJSON("/sdk/goals/" + e.getEnvironmentId()).then(function(e) {
        e && e.length > 0 && (r = Ut(n = e, i), function(e, t) {
            var n, r = window.location.href;
            function o() {
                (n = window.location.href) !== r && (r = n, t());
            }
            !function e(t, n) {
                t(), setTimeout(function() {
                    e(t, n);
                }, n);
            }(o, e), window.history && window.history.pushState ? window.addEventListener("popstate", o) : window.addEventListener("hashchange", o);
        }(300, o)), t();
    }).catch(function(n) {
        e.emitter.maybeReportError(new kt.LDUnexpectedResponseError((n && n.message, n.message))), t();
    }), {};
}
var At = "goalsReady", jt = {
    fetchGoals: {
        default: !0
    },
    hash: {
        type: "string"
    },
    eventProcessor: {
        type: "object"
    },
    eventUrlTransformer: {
        type: "function"
    },
    disableSyncEventPost: {
        default: !1
    }
};
function Ft(e, t) {
    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, r = function(e) {
        var _$t, n = {
            userAgentHeaderName: "X-LaunchDarkly-User-Agent",
            synchronousFlush: !1
        };
        if (window.XMLHttpRequest) {
            var r = e && e.disableSyncEventPost;
            n.httpRequest = function(e, t, o, i) {
                var a = n.synchronousFlush & !r;
                return n.synchronousFlush = !1, Ot(e, t, o, i, a);
            };
        }
        n.httpAllowsPost = function() {
            return void 0 === _$t && (_$t = !!window.XMLHttpRequest && "withCredentials" in new window.XMLHttpRequest), _$t;
        }, n.httpFallbackPing = function(e) {
            (new window.Image).src = e;
        };
        var o, i = e && e.eventUrlTransformer;
        n.getCurrentUrl = function() {
            return i ? i(window.location.href) : window.location.href;
        }, n.isDoNotTrack = function() {
            var _$e;
            return 1 === (_$e = window.navigator && void 0 !== window.navigator.doNotTrack ? window.navigator.doNotTrack : window.navigator && void 0 !== window.navigator.msDoNotTrack ? window.navigator.msDoNotTrack : window.doNotTrack) || !0 === _$e || "1" === _$e || "yes" === _$e;
        };
        try {
            window.localStorage && (n.localStorage = {
                get: function get(e) {
                    return new Promise(function(t) {
                        t(window.localStorage.getItem(e));
                    });
                },
                set: function set(e, t) {
                    return new Promise(function(n) {
                        window.localStorage.setItem(e, t), n();
                    });
                },
                clear: function clear(e) {
                    return new Promise(function(t) {
                        window.localStorage.removeItem(e), t();
                    });
                }
            });
        } catch (e) {
            n.localStorage = null;
        }
        if (e && e.useReport && "function" == typeof window.EventSourcePolyfill && window.EventSourcePolyfill.supportedOptions && window.EventSourcePolyfill.supportedOptions.method ? (n.eventSourceAllowsReport = !0, o = window.EventSourcePolyfill) : (n.eventSourceAllowsReport = !1, o = window.EventSource), window.EventSource) {
            var a = 3e5;
            n.eventSourceFactory = function(e, t) {
                var n = Ct(Ct({}, {
                    heartbeatTimeout: a,
                    silentTimeout: a,
                    skipDefaultHeaders: !0
                }), t);
                return new o(e, n);
            }, n.eventSourceIsActive = function(e) {
                return e.readyState === window.EventSource.OPEN || e.readyState === window.EventSource.CONNECTING;
            };
        }
        return n.userAgent = "JSClient", n.version = "3.5.0", n.diagnosticSdkData = {
            name: "js-client-sdk",
            version: "3.5.0"
        }, n.diagnosticPlatformData = {
            name: "JS"
        }, n.diagnosticUseCombinedEvent = !0, n;
    }(n), o = bt(e, t, n, r, jt), i = o.client, a = o.options, s = o.emitter, c = new Promise(function(e) {
        var _$t = s.on(At, function() {
            s.off(At, _$t), e();
        });
    });
    i.waitUntilGoalsReady = function() {
        return c;
    }, a.fetchGoals ? Rt(o, function() {
        return s.emit(At);
    }) : s.emit(At), "complete" !== document.readyState ? window.addEventListener("load", o.start) : o.start();
    var u = function u() {
        r.synchronousFlush = !0, i.flush().catch(function() {}), r.synchronousFlush = !1;
    };
    return document.addEventListener("visibilitychange", function() {
        "hidden" === document.visibilityState && u();
    }), window.addEventListener("pagehide", u), i;
}

var viewerProfile = {
    userProfileId: "60fa2f59-8aa1-4ee4-bb6f-d2a5bc2549ea",
    profileUrl: "sampleuser",
    bio: "",
    name: "Sample User",
    picture: "https://lxp.staging.degreedcdn.com/content/img/default/profile/26.svg?v=1087402891481720",
    location: "",
    firstName: "Sample",
    lastName: "User",
    onboardDate: "2023-06-09T14:46:03.587Z",
    dateCreated: "2023-06-09T14:46:03.587Z",
    introCompleted: true,
    introNumber: "0",
    lastLogin: "2024-10-08T19:41:51.537Z",
    numLogins: 72,
    timeZoneOffset: -360,
    userProfileKey: 1946741,
    utM_Source: "1",
    utM_Medium: "SSO",
    aliasUid: "5aaab97245",
    aliasEmail: "emailapp+5aaab97245@degreedemail.com",
    aliasFirstName: "User",
    aliasLastName: "184271",
    privacyId: "OrgVisible",
    ssoOrganizationId: 1,
    localeId: "en-US",
    jobRole: "",
    contentLanguage: "en",
    vanityUrl: "sampleuser",
    internalUrl: "/sampleuser",
    additionalContentLanguages: [],
    userProfileContentLanguages: []
};
var defaultOrgId = 1;
var orgInfo = [
    {
        organizationId: 1,
        name: "Degreed",
        image: "data:image/png;base64,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",
        endorsedImage: "https://lxp.staging.degreedcdn.com/content/img/org/1-0cc68542-fdcd-42be-b892-f9083bd0069e.png?v=832981720",
        type: "Standard",
        organizationCode: "degreed",
        groups: [
            {
                groupId: 244,
                name: "New Group!!!!",
                type: "Closed"
            },
            {
                groupId: 100935,
                name: "Pre-Release: Degreed Assistant",
                type: "Open"
            },
            {
                groupId: 20733,
                name: "Pre-release: Learner Home",
                type: "Open"
            },
            {
                groupId: 22468,
                name: "Pre-release: Learner Home 2",
                type: "Open"
            },
            {
                groupId: 101731,
                name: "Pre-Release: New Home Learning Hub",
                type: "Open"
            },
            {
                groupId: 659033,
                name: "Pre-release: October 2024 LXP MPR",
                type: "Open"
            },
            {
                groupId: 659580,
                name: "Pre-release: Skill Coach Manager Assignments",
                type: "Open"
            },
            {
                groupId: 153,
                name: "Test Group",
                type: "Closed"
            },
            {
                groupId: 27986,
                name: "TestingBulkGroupUpload3",
                type: "Private"
            }
        ],
        hasScorm: true,
        hasCredSpark: false,
        hasContentHosting: true,
        settings: {
            academiesBannerImage: "~/content/img/org/1-11f95fab-2574-471f-87ed-8c2a6318a048.png",
            allowRestrictedImages: "true",
            allowSkillSuggestions: "true",
            careersFooterMessage: "Testing!!!! (Career Footer Message #CareersFooterMessageValue)",
            clientAdobeAnalyticsId: "Test1234NewValue",
            clientGoogleAnalyticsId: "G-3X5NQC7G76",
            clientTypeOverride: "0",
            cmsCascadeDeleteFileImport: "true",
            defaultAssignmentsSort: "0",
            degreedSurveys: "false",
            degreedTalent: "true",
            denyComments: "false",
            disableAnalytics: "false",
            disableAssignedLearning: "false",
            disableBulkUpload: "false",
            disableCollaboratorsHeader: "false",
            disableDegreedMarketplace: "false",
            disableEndorsedSearchResultsSection: "false",
            disableEngagedLearner: "false",
            disableHomeAdminSettings: "false",
            disableIndividualSkillsData: "false",
            disableLearnerSkillsRegistry: "true",
            disableMentorshipReview: "true",
            disablePathwayHeaderImage: "false",
            disablePlanImage: "",
            disableRatingsInsights: "false",
            disableResumeParsingInOnboarding: "false",
            disableSearchRelatedSkills: "false",
            disableThirdPartyExperienceManagement: "true",
            disableUserGeneratedContent: "false",
            doNotDisplayRatingScaleChanges: "false",
            downloadableReportPermissionReadOnly: "false",
            dynamicAdminGroupMembers: "true",
            enableAcademies: "true",
            enableActiveUserInsights: "true",
            enableAdvancedSkillAnalytics: "true",
            enableAISkillInference: "true",
            enableCareerPathing: "true",
            enableContentHosting: "true",
            enableContentMarketplace: "true",
            enableCustomRecommendationTypes: "false",
            enableDCMPilot: "false",
            enableDegreedCheckpoints: "true",
            enableManagerOfManager: "false",
            enableManagerRatings: "true",
            enableMentorshipOpportunities: "true",
            enablePathwayBadgeTrigger: "true",
            enablePeerRatings: "true",
            enablePluralsightSkillsIntegration: "false",
            enablePrimaryPlanOnDashboard: "false",
            enableProvidersInUI: "true",
            enableReportingInApp: "true",
            enableSkillInsightsDashboard: "true",
            enableSkillsCertification: "true",
            enableSkillsEvaluation: "true",
            enableSkillsPlatform: "true",
            enableSkillStandards: "true",
            enableTeamSpace: "true",
            enableUserSearchFilterByJobRole: "true",
            enableUserSearchFilterByLocation: "true",
            enableWorkdaySkillsIntegration: "false",
            enforceDataPrivacyAcceptance: "true",
            featureFlagsRestrictPII: "false",
            hideExternalCatalog: "false",
            hideExternalPeople: "false",
            hideMasterOrgSettings: "False",
            hideOverviewAchievement: "false",
            hideOverviewExperience: "false",
            hideOverviewTab: "false",
            hidePersonalIntegrationsInUserProfileSettings: "false",
            inAppTips: "true",
            isClientProvider: "false",
            learnInSsoUrl: "https://staging.degreed.dev/develop?ssoprovider=learnin",
            lockProfilePrivacy: "false",
            lockSkillManagerRatingVisibility: "false",
            lockSkillPeerRatingVisibility: "false",
            lockSkillSelfRatingVisibility: "false",
            minimumAggregatedLearningInsightsUserCount: "2",
            minimumSkillUserCount: "2",
            onboardingMessage: "true",
            onboardingRateSkillsMandatory: "true",
            onboardingTitle: "true",
            onboardingWelcomeGreeting: "true",
            opportunitiesActivityStartDate: "8/1/2021 12:00:00 AM",
            organizationBrandColor: "#ffffff",
            organizationEndorsedPicture: "~/content/img/org/1-0cc68542-fdcd-42be-b892-f9083bd0069e.png",
            organizationNameInOnboarding: "true",
            organizationUsesLightText: "True",
            profileOverviewTabDefault: "0",
            restrictExtension: "false",
            sendAllRapTicketsToClient: "false",
            showGroupMembershipSource: "false",
            skillAnalyticsClient: "false",
            skillCoachFullOrgAccess: "false",
            skillInventoryClient: "false",
            skillsPlusRolloutTempDec2024: "true",
            supportTargets: "true",
            useInternalJobSkills: "true",
            useOriginalProfileAvatar: "false",
            useZendeskWebWidget: "true"
        },
        permissions: [
            "EditPermissions",
            "EditSettings",
            "InviteMembers",
            "RemoveMembers",
            "AuthorPathways",
            "ManageContent",
            "RecommendItems",
            "ManageGroups",
            "CreateOpenGroups",
            "CreateClosedGroups",
            "CreatePrivateGroups",
            "ViewReports",
            "ManagePathways",
            "ViewMembers",
            "ManageTargets",
            "AuthorTargets",
            "AssignLearning",
            "CreateAdministrativeGroups",
            "DownloadReports",
            "ViewKnowledgeCenter",
            "AuthorContent",
            "ViewPathwayEnrollees",
            "DownloadPathwayDetailsReport",
            "EndorseContent",
            "RecommendRatings",
            "AssignRatings",
            "ViewRatings",
            "ManageSkills",
            "ViewRecommendedRatings",
            "ManageOpportunities",
            "EditCommunications",
            "ViewOrganizationOpportunityInsights",
            "RecommendOpportunities",
            "CreateDynamicTeamAssignmentOpportunities",
            "CreateMentorshipOpportunities",
            "CreateOtherOpportunities",
            "CreateShadowingOpportunities",
            "CreateStretchAssignmentOpportunities",
            "PublishOpportunities",
            "CreateLookingforMentorOpportunities",
            "CreateLookingforMenteeOpportunities",
            "CreateReverseMentoringOpportunities",
            "CreatePeerMentoringOpportunities",
            "CreateVolunteerOpportunities",
            "CreateProBonoOpportunities",
            "ConfigureBrowse",
            "ManageIntegrations",
            "ManageOrgApiKeys",
            "UploadOpportunities",
            "UploadGroups",
            "UploadUserUpdates",
            "UploadCompletions",
            "UploadRequiredLearning",
            "UploadContent",
            "UploadClientUser",
            "UploadRoles",
            "UploadSkills",
            "ManageReportingInApp",
            "ManageBusinessRules",
            "ManageReportingFTPScheduler",
            "ManageSegments",
            "ManageEngage",
            "ManageAttributes",
            "ManageSkillStandards",
            "UploadContentFiles",
            "ManageSkillsPlatform",
            "ManageReportingTransmitterConfigurations",
            "ScanCatalogLinks",
            "ViewDynamicAdminGroupMembers"
        ],
        orgRole: "Admin",
        hasPex: true,
        organizationBranding: {
            brandColor: "#ffffff",
            useLightText: false,
            organizationNameInOnboarding: true
        }
    }
];
var viewerGroups = [
    {
        userGroupId: 777238,
        userProfileKey: 1608741,
        joinDate: "2024-04-05T14:12:04.6849477Z",
        groupId: 153,
        lastVisitDate: "2024-06-25T20:53:21.7785776Z",
        roleId: 2,
        sourceType: "BusinessRulesAPI",
        sourceTypeId: "SSO:15823",
        lastModifiedDate: "2024-04-05T14:12:04.6849477Z",
        group: {
            groupId: 153,
            name: "Test Group",
            description: "testers",
            createdDate: "2015-07-31T23:08:03.4379847Z",
            privacyLevel: "Closed",
            organizationId: 1,
            isRestricted: false,
            isManaged: false,
            type: 0,
            organization: {
                organizationId: 1,
                industry: "E-Learning",
                dateCreated: "2013-10-29T15:52:23.845563Z",
                image: "~/content/img/org/1-aad9de8b-a442-4e47-aeaf-8294d1edaa7e.png",
                ssoEnabled: true,
                encrypt: false,
                cacheEncryptedData: false,
                allowRestrictedUsers: false,
                performLogoutSLO: false,
                autoSPInitiatedSSO: true,
                code: "degreed",
                scormAppId: "6CLEEQCX1L",
                scormSecurityKey: "RCaU5Y49YZG95C7ZL8VM3rQ4EXUx7g6Ph59uGSQT",
                requireTlsEmail: true,
                organizationType: "Standard",
                ftpFolderName: "1-degreed",
                degreedDomain: "degreedstg.staging.degreed.dev",
                name: "Degreed",
                url: "http://wiki.degreed.com",
                requiredEmailSuffix: "shell.com,degreed.com,degreed",
                hasScorm: true
            },
            membershipType: "Static",
            interestNames: ""
        }
    },
    {
        userGroupId: 777239,
        userProfileKey: 1608741,
        joinDate: "2024-04-05T14:12:04.6849477Z",
        groupId: 244,
        roleId: 2,
        sourceType: "BusinessRulesAPI",
        sourceTypeId: "SSO:15823",
        lastModifiedDate: "2024-04-05T14:12:04.6849477Z",
        group: {
            groupId: 244,
            name: "New Group!!!!",
            description: "the best new group",
            createdBy: 26077,
            createdDate: "2016-03-08T21:48:19.3191521Z",
            privacyLevel: "Closed",
            organizationId: 1,
            isRestricted: false,
            isManaged: false,
            type: 0,
            organization: {
                organizationId: 1,
                industry: "E-Learning",
                dateCreated: "2013-10-29T15:52:23.845563Z",
                image: "~/content/img/org/1-aad9de8b-a442-4e47-aeaf-8294d1edaa7e.png",
                ssoEnabled: true,
                encrypt: false,
                cacheEncryptedData: false,
                allowRestrictedUsers: false,
                performLogoutSLO: false,
                autoSPInitiatedSSO: true,
                code: "degreed",
                scormAppId: "6CLEEQCX1L",
                scormSecurityKey: "RCaU5Y49YZG95C7ZL8VM3rQ4EXUx7g6Ph59uGSQT",
                requireTlsEmail: true,
                organizationType: "Standard",
                ftpFolderName: "1-degreed",
                degreedDomain: "degreedstg.staging.degreed.dev",
                name: "Degreed",
                url: "http://wiki.degreed.com",
                requiredEmailSuffix: "shell.com,degreed.com,degreed",
                hasScorm: true
            },
            membershipType: "Static",
            interestNames: ""
        }
    },
    {
        userGroupId: 6671279,
        userProfileKey: 1608741,
        joinDate: "2024-08-01T15:54:51.264088Z",
        groupId: 20733,
        roleId: 1,
        sourceType: "Web",
        sourceTypeId: "1608741",
        lastModifiedDate: "2024-08-01T15:54:51.264088Z",
        group: {
            groupId: 20733,
            name: "Pre-release: Learner Home",
            description: "For brave souls that want to preview the new work in progress learner home!",
            createdBy: 1354350,
            createdDate: "2020-05-20T17:23:17.8161855Z",
            privacyLevel: "Open",
            organizationId: 1,
            isRestricted: false,
            isManaged: false,
            type: 0,
            organization: {
                organizationId: 1,
                industry: "E-Learning",
                dateCreated: "2013-10-29T15:52:23.845563Z",
                image: "~/content/img/org/1-aad9de8b-a442-4e47-aeaf-8294d1edaa7e.png",
                ssoEnabled: true,
                encrypt: false,
                cacheEncryptedData: false,
                allowRestrictedUsers: false,
                performLogoutSLO: false,
                autoSPInitiatedSSO: true,
                code: "degreed",
                scormAppId: "6CLEEQCX1L",
                scormSecurityKey: "RCaU5Y49YZG95C7ZL8VM3rQ4EXUx7g6Ph59uGSQT",
                requireTlsEmail: true,
                organizationType: "Standard",
                ftpFolderName: "1-degreed",
                degreedDomain: "degreedstg.staging.degreed.dev",
                name: "Degreed",
                url: "http://wiki.degreed.com",
                requiredEmailSuffix: "shell.com,degreed.com,degreed",
                hasScorm: true
            },
            membershipType: "Static",
            interestNames: ""
        }
    },
    {
        userGroupId: 6671280,
        userProfileKey: 1608741,
        joinDate: "2024-08-01T15:54:58.3111424Z",
        groupId: 22468,
        roleId: 1,
        sourceType: "Web",
        sourceTypeId: "1608741",
        lastModifiedDate: "2024-08-01T15:54:58.3111424Z",
        group: {
            groupId: 22468,
            name: "Pre-release: Learner Home 2",
            description: "2nd learner home group",
            createdBy: 1365319,
            createdDate: "2020-09-23T19:42:27.1454217Z",
            privacyLevel: "Open",
            organizationId: 1,
            isRestricted: false,
            isManaged: false,
            type: 0,
            organization: {
                organizationId: 1,
                industry: "E-Learning",
                dateCreated: "2013-10-29T15:52:23.845563Z",
                image: "~/content/img/org/1-aad9de8b-a442-4e47-aeaf-8294d1edaa7e.png",
                ssoEnabled: true,
                encrypt: false,
                cacheEncryptedData: false,
                allowRestrictedUsers: false,
                performLogoutSLO: false,
                autoSPInitiatedSSO: true,
                code: "degreed",
                scormAppId: "6CLEEQCX1L",
                scormSecurityKey: "RCaU5Y49YZG95C7ZL8VM3rQ4EXUx7g6Ph59uGSQT",
                requireTlsEmail: true,
                organizationType: "Standard",
                ftpFolderName: "1-degreed",
                degreedDomain: "degreedstg.staging.degreed.dev",
                name: "Degreed",
                url: "http://wiki.degreed.com",
                requiredEmailSuffix: "shell.com,degreed.com,degreed",
                hasScorm: true
            },
            membershipType: "Static",
            interestNames: ""
        }
    },
    {
        userGroupId: 777240,
        userProfileKey: 1608741,
        joinDate: "2024-04-05T14:12:04.6849477Z",
        groupId: 27986,
        roleId: 2,
        sourceType: "BusinessRulesAPI",
        sourceTypeId: "SSO:15823",
        lastModifiedDate: "2024-04-05T14:12:04.6849477Z",
        group: {
            groupId: 27986,
            name: "TestingBulkGroupUpload3",
            description: "Testing",
            createdDate: "2021-02-05T21:43:57.5406716Z",
            privacyLevel: "Private",
            organizationId: 1,
            isRestricted: false,
            isManaged: false,
            type: 0,
            externalId: "1234Test1237",
            organization: {
                organizationId: 1,
                industry: "E-Learning",
                dateCreated: "2013-10-29T15:52:23.845563Z",
                image: "~/content/img/org/1-aad9de8b-a442-4e47-aeaf-8294d1edaa7e.png",
                ssoEnabled: true,
                encrypt: false,
                cacheEncryptedData: false,
                allowRestrictedUsers: false,
                performLogoutSLO: false,
                autoSPInitiatedSSO: true,
                code: "degreed",
                scormAppId: "6CLEEQCX1L",
                scormSecurityKey: "RCaU5Y49YZG95C7ZL8VM3rQ4EXUx7g6Ph59uGSQT",
                requireTlsEmail: true,
                organizationType: "Standard",
                ftpFolderName: "1-degreed",
                degreedDomain: "degreedstg.staging.degreed.dev",
                name: "Degreed",
                url: "http://wiki.degreed.com",
                requiredEmailSuffix: "shell.com,degreed.com,degreed",
                hasScorm: true
            },
            membershipType: "Static",
            interestNames: ""
        }
    },
    {
        userGroupId: 6672820,
        userProfileKey: 1608741,
        joinDate: "2024-09-13T14:47:56.5499759Z",
        groupId: 100935,
        roleId: 1,
        sourceType: "Web",
        sourceTypeId: "1608741",
        lastModifiedDate: "2024-09-13T14:47:56.5499759Z",
        group: {
            groupId: 100935,
            name: "Pre-Release: Degreed Assistant",
            description: "Enables degreed assistant",
            createdBy: 1946760,
            createdDate: "2024-02-06T02:13:45.2738485Z",
            privacyLevel: "Open",
            organizationId: 1,
            isRestricted: false,
            isManaged: false,
            type: 0,
            organization: {
                organizationId: 1,
                industry: "E-Learning",
                dateCreated: "2013-10-29T15:52:23.845563Z",
                image: "~/content/img/org/1-aad9de8b-a442-4e47-aeaf-8294d1edaa7e.png",
                ssoEnabled: true,
                encrypt: false,
                cacheEncryptedData: false,
                allowRestrictedUsers: false,
                performLogoutSLO: false,
                autoSPInitiatedSSO: true,
                code: "degreed",
                scormAppId: "6CLEEQCX1L",
                scormSecurityKey: "RCaU5Y49YZG95C7ZL8VM3rQ4EXUx7g6Ph59uGSQT",
                requireTlsEmail: true,
                organizationType: "Standard",
                ftpFolderName: "1-degreed",
                degreedDomain: "degreedstg.staging.degreed.dev",
                name: "Degreed",
                url: "http://wiki.degreed.com",
                requiredEmailSuffix: "shell.com,degreed.com,degreed",
                hasScorm: true
            },
            membershipType: "Static",
            interestNames: ""
        }
    },
    {
        userGroupId: 6670318,
        userProfileKey: 1608741,
        joinDate: "2024-06-28T16:45:38.541978Z",
        groupId: 101731,
        lastVisitDate: "2024-07-09T21:57:13.1591455Z",
        roleId: 1,
        sourceType: "Web",
        sourceTypeId: "1608741",
        lastModifiedDate: "2024-06-28T16:45:38.541978Z",
        group: {
            groupId: 101731,
            name: "Pre-Release: New Home Learning Hub",
            description: "For testing the new learner hub work",
            createdBy: 1624756,
            createdDate: "2024-05-07T04:05:41.6937243Z",
            privacyLevel: "Open",
            organizationId: 1,
            isRestricted: false,
            isManaged: false,
            type: 0,
            organization: {
                organizationId: 1,
                industry: "E-Learning",
                dateCreated: "2013-10-29T15:52:23.845563Z",
                image: "~/content/img/org/1-aad9de8b-a442-4e47-aeaf-8294d1edaa7e.png",
                ssoEnabled: true,
                encrypt: false,
                cacheEncryptedData: false,
                allowRestrictedUsers: false,
                performLogoutSLO: false,
                autoSPInitiatedSSO: true,
                code: "degreed",
                scormAppId: "6CLEEQCX1L",
                scormSecurityKey: "RCaU5Y49YZG95C7ZL8VM3rQ4EXUx7g6Ph59uGSQT",
                requireTlsEmail: true,
                organizationType: "Standard",
                ftpFolderName: "1-degreed",
                degreedDomain: "degreedstg.staging.degreed.dev",
                name: "Degreed",
                url: "http://wiki.degreed.com",
                requiredEmailSuffix: "shell.com,degreed.com,degreed",
                hasScorm: true
            },
            membershipType: "Static",
            interestNames: ""
        }
    },
    {
        userGroupId: 6673881,
        userProfileKey: 1608741,
        joinDate: "2024-10-03T21:06:20.1633332Z",
        groupId: 659033,
        roleId: 1,
        sourceType: "Web",
        sourceTypeId: "1608741",
        lastModifiedDate: "2024-10-03T21:06:20.1633332Z",
        group: {
            groupId: 659033,
            name: "Pre-release: October 2024 LXP MPR",
            description: "Group to represent all of our Learner Hub LD flags",
            createdBy: 1720037,
            createdDate: "2024-07-19T20:55:11.437651Z",
            privacyLevel: "Open",
            organizationId: 1,
            isRestricted: false,
            isManaged: false,
            type: 0,
            organization: {
                organizationId: 1,
                industry: "E-Learning",
                dateCreated: "2013-10-29T15:52:23.845563Z",
                image: "~/content/img/org/1-aad9de8b-a442-4e47-aeaf-8294d1edaa7e.png",
                ssoEnabled: true,
                encrypt: false,
                cacheEncryptedData: false,
                allowRestrictedUsers: false,
                performLogoutSLO: false,
                autoSPInitiatedSSO: true,
                code: "degreed",
                scormAppId: "6CLEEQCX1L",
                scormSecurityKey: "RCaU5Y49YZG95C7ZL8VM3rQ4EXUx7g6Ph59uGSQT",
                requireTlsEmail: true,
                organizationType: "Standard",
                ftpFolderName: "1-degreed",
                degreedDomain: "degreedstg.staging.degreed.dev",
                name: "Degreed",
                url: "http://wiki.degreed.com",
                requiredEmailSuffix: "shell.com,degreed.com,degreed",
                hasScorm: true
            },
            membershipType: "Static",
            interestNames: ""
        }
    },
    {
        userGroupId: 6673631,
        userProfileKey: 1608741,
        joinDate: "2024-09-27T15:29:11.3772689Z",
        groupId: 659580,
        roleId: 1,
        sourceType: "Web",
        sourceTypeId: "1608741",
        lastModifiedDate: "2024-09-27T15:29:11.3772689Z",
        group: {
            groupId: 659580,
            name: "Pre-release: Skill Coach Manager Assignments",
            description: "Enable the new Skill Coach Manager Assignments tab (Apollo)",
            createdBy: 1486124,
            createdDate: "2024-09-13T16:24:41.3261873Z",
            privacyLevel: "Open",
            organizationId: 1,
            isRestricted: false,
            isManaged: false,
            type: 0,
            organization: {
                organizationId: 1,
                industry: "E-Learning",
                dateCreated: "2013-10-29T15:52:23.845563Z",
                image: "~/content/img/org/1-aad9de8b-a442-4e47-aeaf-8294d1edaa7e.png",
                ssoEnabled: true,
                encrypt: false,
                cacheEncryptedData: false,
                allowRestrictedUsers: false,
                performLogoutSLO: false,
                autoSPInitiatedSSO: true,
                code: "degreed",
                scormAppId: "6CLEEQCX1L",
                scormSecurityKey: "RCaU5Y49YZG95C7ZL8VM3rQ4EXUx7g6Ph59uGSQT",
                requireTlsEmail: true,
                organizationType: "Standard",
                ftpFolderName: "1-degreed",
                degreedDomain: "degreedstg.staging.degreed.dev",
                name: "Degreed",
                url: "http://wiki.degreed.com",
                requiredEmailSuffix: "shell.com,degreed.com,degreed",
                hasScorm: true
            },
            membershipType: "Static",
            interestNames: ""
        }
    }
];
var viewerInterests = [
    {
        userInterestId: 6366223,
        position: 0,
        tagId: 2424,
        name: "Hadoop",
        isFocused: false,
        title: "Hadoop",
        dateModified: "2024-09-18T15:11:33.6094392Z",
        isMentoring: false,
        internalUrl: "/resource/tag?id=2424",
        resourceId: 2424,
        resourceType: "Tag"
    },
    {
        userInterestId: 4997230,
        position: 0,
        tagId: 6518,
        name: "ASP.NET",
        isFocused: false,
        title: "ASP.NET",
        dateModified: "2024-09-18T15:11:33.6094392Z",
        internalUrl: "/resource/tag?id=6518",
        resourceId: 6518,
        resourceType: "Tag"
    },
    {
        userInterestId: 3729640,
        position: 0,
        tagId: 17274,
        name: "Software Development",
        isFocused: false,
        title: "Software Development",
        dateModified: "2024-09-18T15:11:33.6094392Z",
        internalUrl: "/resource/tag?id=17274",
        resourceId: 17274,
        resourceType: "Tag"
    },
    {
        userInterestId: 4976307,
        position: 0,
        tagId: 24349,
        name: "HTML",
        isFocused: false,
        title: "HTML",
        dateModified: "2024-09-18T15:11:33.6094392Z",
        internalUrl: "/resource/tag?id=24349",
        resourceId: 24349,
        resourceType: "Tag"
    },
    {
        userInterestId: 3729638,
        position: 0,
        tagId: 24987,
        name: "iOS Development",
        isFocused: false,
        title: "iOS Development",
        dateModified: "2024-09-18T15:11:33.6094392Z",
        internalUrl: "/resource/tag?id=24987",
        resourceId: 24987,
        resourceType: "Tag"
    },
    {
        userInterestId: 4230778,
        position: 0,
        tagId: 20175,
        name: "Digital Design",
        isFocused: false,
        title: "Digital Design",
        dateModified: "2024-09-18T15:11:33.6094392Z",
        internalUrl: "/resource/tag?id=20175",
        resourceId: 20175,
        resourceType: "Tag"
    },
    {
        userInterestId: 3789390,
        position: 0,
        tagId: 56226,
        name: "Design",
        isFocused: false,
        title: "Design",
        dateModified: "2024-09-18T15:11:33.6094392Z",
        internalUrl: "/resource/tag?id=56226",
        resourceId: 56226,
        resourceType: "Tag"
    },
    {
        userInterestId: 3729639,
        position: 0,
        tagId: 62345,
        name: "Software Engineering",
        isFocused: false,
        title: "Software Engineering",
        dateModified: "2024-09-18T15:11:33.6094392Z",
        internalUrl: "/resource/tag?id=62345",
        resourceId: 62345,
        resourceType: "Tag"
    },
    {
        userInterestId: 3729641,
        position: 0,
        tagId: 131477,
        name: "Angular",
        isFocused: false,
        title: "Angular",
        dateModified: "2024-09-18T15:11:33.6094392Z",
        internalUrl: "/resource/tag?id=131477",
        resourceId: 131477,
        resourceType: "Tag"
    },
    {
        userInterestId: 4997231,
        position: 1,
        tagId: 47202,
        name: "Programming",
        isFocused: false,
        title: "Programming",
        dateModified: "2024-09-18T15:11:33.6094392Z",
        internalUrl: "/resource/tag?id=47202",
        resourceId: 47202,
        resourceType: "Tag"
    },
    {
        userInterestId: 6366224,
        position: 1,
        tagId: 17816,
        name: "Python",
        isFocused: false,
        title: "Python",
        dateModified: "2024-09-18T15:11:33.6094392Z",
        isMentoring: false,
        internalUrl: "/resource/tag?id=17816",
        resourceId: 17816,
        resourceType: "Tag"
    },
    {
        userInterestId: 6366225,
        position: 2,
        tagId: 24247,
        name: "Ruby",
        isFocused: false,
        title: "Ruby",
        dateModified: "2024-09-18T15:11:33.6094392Z",
        isMentoring: false,
        internalUrl: "/resource/tag?id=24247",
        resourceId: 24247,
        resourceType: "Tag"
    },
    {
        userInterestId: 4997232,
        position: 2,
        tagId: 53036,
        name: "Mobile Application Development",
        isFocused: false,
        title: "Mobile Application Development",
        dateModified: "2024-09-18T15:11:33.6094392Z",
        internalUrl: "/resource/tag?id=53036",
        resourceId: 53036,
        resourceType: "Tag"
    },
    {
        userInterestId: 4997233,
        position: 3,
        tagId: 58327,
        name: "REST API",
        isFocused: false,
        title: "REST API",
        dateModified: "2024-09-18T15:11:33.6094392Z",
        internalUrl: "/resource/tag?id=58327",
        resourceId: 58327,
        resourceType: "Tag"
    },
    {
        userInterestId: 6366226,
        position: 3,
        tagId: 28820,
        name: "Natural Language Processing",
        isFocused: false,
        title: "Natural Language Processing",
        dateModified: "2024-09-18T15:11:33.6094392Z",
        isMentoring: false,
        internalUrl: "/resource/tag?id=28820",
        resourceId: 28820,
        resourceType: "Tag"
    },
    {
        userInterestId: 6366227,
        position: 4,
        tagId: 39530,
        name: "Data Visualization",
        isFocused: false,
        title: "Data Visualization",
        dateModified: "2024-09-18T15:11:33.6094392Z",
        isMentoring: false,
        internalUrl: "/resource/tag?id=39530",
        resourceId: 39530,
        resourceType: "Tag"
    },
    {
        userInterestId: 4997234,
        position: 4,
        tagId: 74244,
        name: "Salesforce.com",
        isFocused: false,
        title: "Salesforce.com",
        dateModified: "2024-09-18T15:11:33.6094392Z",
        internalUrl: "/resource/tag?id=74244",
        resourceId: 74244,
        resourceType: "Tag"
    },
    {
        userInterestId: 6366228,
        position: 5,
        tagId: 50366,
        name: "Business Intelligence",
        isFocused: false,
        title: "Business Intelligence",
        dateModified: "2024-09-18T15:11:33.6094392Z",
        isMentoring: false,
        internalUrl: "/resource/tag?id=50366",
        resourceId: 50366,
        resourceType: "Tag"
    },
    {
        userInterestId: 4997235,
        position: 5,
        tagId: 76373,
        name: "Video Game Development",
        isFocused: false,
        title: "Video Game Development",
        dateModified: "2024-09-18T15:11:33.6094392Z",
        internalUrl: "/resource/tag?id=76373",
        resourceId: 76373,
        resourceType: "Tag"
    },
    {
        userInterestId: 4997236,
        position: 6,
        tagId: 76955,
        name: "Software Testing",
        isFocused: false,
        title: "Software Testing",
        dateModified: "2024-09-18T15:11:33.6094392Z",
        internalUrl: "/resource/tag?id=76955",
        resourceId: 76955,
        resourceType: "Tag"
    },
    {
        userInterestId: 6366229,
        position: 6,
        tagId: 74301,
        name: "R",
        isFocused: false,
        title: "R",
        dateModified: "2024-09-18T15:11:33.6094392Z",
        isMentoring: false,
        internalUrl: "/resource/tag?id=74301",
        resourceId: 74301,
        resourceType: "Tag"
    },
    {
        userInterestId: 4997237,
        position: 7,
        tagId: 79675,
        name: "Entrepreneurship",
        isFocused: false,
        title: "Entrepreneurship",
        dateModified: "2024-09-18T15:11:33.6094392Z",
        internalUrl: "/resource/tag?id=79675",
        resourceId: 79675,
        resourceType: "Tag"
    },
    {
        userInterestId: 6366230,
        position: 7,
        tagId: 122120,
        name: "Customer Experience",
        isFocused: false,
        title: "Customer Experience",
        dateModified: "2024-09-18T15:11:33.6094392Z",
        isMentoring: false,
        internalUrl: "/resource/tag?id=122120",
        resourceId: 122120,
        resourceType: "Tag"
    },
    {
        userInterestId: 6366231,
        position: 8,
        tagId: 128699,
        name: "Data Munging",
        isFocused: false,
        title: "Data Munging",
        dateModified: "2024-09-18T15:11:33.6094392Z",
        isMentoring: false,
        internalUrl: "/resource/tag?id=128699",
        resourceId: 128699,
        resourceType: "Tag"
    },
    {
        userInterestId: 4997238,
        position: 8,
        tagId: 85104,
        name: ".NET Programming",
        isFocused: false,
        title: ".NET Programming",
        dateModified: "2024-09-18T15:11:33.6094392Z",
        internalUrl: "/resource/tag?id=85104",
        resourceId: 85104,
        resourceType: "Tag"
    },
    {
        userInterestId: 4997239,
        position: 9,
        tagId: 86079,
        name: "Application Development",
        isFocused: false,
        title: "Application Development",
        dateModified: "2024-09-18T15:11:33.6094392Z",
        internalUrl: "/resource/tag?id=86079",
        resourceId: 86079,
        resourceType: "Tag"
    },
    {
        userInterestId: 6366232,
        position: 9,
        tagId: 138426,
        name: "Data Mining",
        isFocused: false,
        title: "Data Mining",
        dateModified: "2024-09-18T15:11:33.6094392Z",
        isMentoring: false,
        internalUrl: "/resource/tag?id=138426",
        resourceId: 138426,
        resourceType: "Tag"
    },
    {
        userInterestId: 6366233,
        position: 10,
        tagId: 154978,
        name: "Data Verification",
        isFocused: false,
        title: "Data Verification",
        dateModified: "2024-09-18T15:11:33.6094392Z",
        isMentoring: false,
        internalUrl: "/resource/tag?id=154978",
        resourceId: 154978,
        resourceType: "Tag"
    },
    {
        userInterestId: 4997240,
        position: 10,
        tagId: 98356,
        name: "Machine Learning",
        isFocused: false,
        title: "Machine Learning",
        dateModified: "2024-09-18T15:11:33.6094392Z",
        internalUrl: "/resource/tag?id=98356",
        resourceId: 98356,
        resourceType: "Tag"
    },
    {
        userInterestId: 4997241,
        position: 11,
        tagId: 106781,
        name: "Node.js",
        isFocused: false,
        title: "Node.js",
        dateModified: "2024-09-18T15:11:33.6094392Z",
        internalUrl: "/resource/tag?id=106781",
        resourceId: 106781,
        resourceType: "Tag"
    },
    {
        userInterestId: 6366234,
        position: 11,
        tagId: 209243,
        name: "SAS Analytics",
        isFocused: false,
        title: "SAS Analytics",
        dateModified: "2024-09-18T15:11:33.6094392Z",
        isMentoring: false,
        internalUrl: "/resource/tag?id=209243",
        resourceId: 209243,
        resourceType: "Tag"
    },
    {
        userInterestId: 6366235,
        position: 12,
        tagId: 297078,
        name: "big data analysis",
        isFocused: false,
        title: "big data analysis",
        dateModified: "2024-09-18T15:11:33.6094392Z",
        isMentoring: false,
        internalUrl: "/resource/tag?id=297078",
        resourceId: 297078,
        resourceType: "Tag"
    },
    {
        userInterestId: 4997242,
        position: 12,
        tagId: 108124,
        name: "ReactJS",
        isFocused: false,
        title: "ReactJS",
        dateModified: "2024-09-18T15:11:33.6094392Z",
        internalUrl: "/resource/tag?id=108124",
        resourceId: 108124,
        resourceType: "Tag"
    },
    {
        userInterestId: 4997243,
        position: 13,
        tagId: 109581,
        name: "Database Management",
        isFocused: false,
        title: "Database Management",
        dateModified: "2024-09-18T15:11:33.6094392Z",
        internalUrl: "/resource/tag?id=109581",
        resourceId: 109581,
        resourceType: "Tag"
    },
    {
        userInterestId: 6366236,
        position: 13,
        tagId: 305809,
        name: "Algorithm Creation",
        isFocused: false,
        title: "Algorithm Creation",
        dateModified: "2024-09-18T15:11:33.6094392Z",
        isMentoring: false,
        internalUrl: "/resource/tag?id=305809",
        resourceId: 305809,
        resourceType: "Tag"
    },
    {
        userInterestId: 4997244,
        position: 14,
        tagId: 125032,
        name: "Microsoft Visual Studio",
        isFocused: false,
        title: "Microsoft Visual Studio",
        dateModified: "2024-09-18T15:11:33.6094392Z",
        internalUrl: "/resource/tag?id=125032",
        resourceId: 125032,
        resourceType: "Tag"
    },
    {
        userInterestId: 4997245,
        position: 15,
        tagId: 155341,
        name: "Java Message Service (JMS)",
        isFocused: false,
        title: "Java Message Service (JMS)",
        dateModified: "2024-09-18T15:11:33.6094392Z",
        internalUrl: "/resource/tag?id=155341",
        resourceId: 155341,
        resourceType: "Tag"
    },
    {
        userInterestId: 4997246,
        position: 16,
        tagId: 155342,
        name: "Java Server Pages (JSP)",
        isFocused: false,
        title: "Java Server Pages (JSP)",
        dateModified: "2024-09-18T15:11:33.6094392Z",
        internalUrl: "/resource/tag?id=155342",
        resourceId: 155342,
        resourceType: "Tag"
    },
    {
        userInterestId: 4997247,
        position: 17,
        tagId: 172108,
        name: "account servicing",
        isFocused: false,
        title: "account servicing",
        dateModified: "2024-09-18T15:11:33.6094392Z",
        internalUrl: "/resource/tag?id=172108",
        resourceId: 172108,
        resourceType: "Tag"
    }
];
var viewerPicture = "https://lxp.staging.degreedcdn.com/content/profile-pictures/large-1608741-5774df9a-1273-4e2c-b65a-6ae999a573af.jpeg?v=832981720";
var analyticsEnabled = false;
var isPrivateProfile = false;
var isManagedProfile = false;
var isRestrictedViewerProfile = false;
var contextId = "1608741";
var canRecommendItems = true;
var canRecommendRatings = true;
var canAssignRatings = true;
var canEvaluateSkills = true;
var canRequestManagerRating = true;
var canRequestPeerRating = true;
var canCertifySkills = false;
var canShareSocial = true;
var canAssignLearning = true;
var canComment = true;
var canRestrictContent = true;
var canEndorseContent = true;
var canViewKnowledgeCenter = true;
var canAuthorTargets = true;
var canConfigureBrowse = true;
var canManageOrganization = true;
var canBulkUpload = true;
var canUploadContentFiles = true;
var canUploadVideo = true;
var canRecordVideo = true;
var canShareOpportunity = true;
var canManageOpportunities = true;
var canManageTargets = true;
var canFeaturePathways = false;
var canCreateOpportunities = true;
var canPublishOpportunities = true;
var canViewReporting = true;
var canManageReporting = true;
var canScanCatalogLinks = true;
var hasChannelManagePathwayPermission = false;
var hasChannelManageTargetPermission = false;
var hasCareerPathing = true;
var hasChannel = false;
var isTargetAuthor = true;
var isEngaged = true;
var isManager = false;
var participateInUserSurveys = true;
var showInAppTips = true;
var participateInTeamProgram = false;
var hasInternalJobSkills = true;
var hasManageIntegrations = true;
var canCascadeDeleteInputResources = true;
var showScaleChanged = false;
var enableSkillStandards = true;
var enableCustomRecommendationTypes = false;
var viewRatingScaleChanges = false;
var enablePluralsightSkillsIntegration = false;
var optInAISkillInference = false;
var hasCareerMobility = true;
var careerMobilityIsGroupControlled = false;
var defaultOrgPermissionRole = "Admin";
var showUserSearchFilterByLocation = true;
var showUserSearchFilterByJobRole = true;
var enableMentorshipOpportunities = true;
var disableMentorshipReview = true;
var opportunitiesActivityStartDate = "2021-08-01T00:00:00Z";
var showDegreedDataPrivacyAcceptance = false;
var showDataPrivacyAcceptance = false;
var allowOpportunityManagerViewProfileInfo = false;
var disableResumeParsingInOnboarding = false;
var disableLearnerSkillsRegistry = true;
var hasAcceptedPrivacyPolicy = true;
var isSkillInventoryClient = true;
var isSkillAnalyticsClient = true;
var uploadedImageType = "faces";
var enableOsanoCookieBannerAuthed = true;
var hideOverviewTab = false;
var hideOverviewExperience = false;
var hideOverviewAchievement = false;
var minimumSkillUserCount = 2;
var minimumAggregatedLearningInsightsUserCount = 2;
var orgRatingScale = {
    organizationRatingScaleKey: 1,
    name: "Degreed",
    anchorLow: 1,
    anchorHigh: 8,
    labels: [
        "Foundational",
        "Foundational",
        "Proficient",
        "Proficient",
        "Advanced",
        "Advanced",
        "Expert",
        "Expert"
    ],
    levels: [
        {
            ratingScaleLevelKey: 1,
            value: 1,
            name: "Foundational",
            description: "You work best within a structured environment with supervision, predetermined processes, and set criteria to judge output against."
        },
        {
            ratingScaleLevelKey: 2,
            value: 2,
            name: "Foundational",
            description: "You can solve basic problems and complete tasks on your own—but when a complex issue arises, you'll likely need some help."
        },
        {
            ratingScaleLevelKey: 3,
            value: 3,
            name: "Proficient",
            description: "For the most part, you can work independently on new challenges. You know enough about your skills to be self-critical, and know the difference between good work and great work. You've also become good at setting your own goals to measure progress."
        },
        {
            ratingScaleLevelKey: 4,
            value: 4,
            name: "Proficient",
            description: "You can work independently on complex projects. When those projects are complete, you're able to look at your work and accurately evaluate whether it was successful. While supervision isn't necessary, you value external input and feedback on your work."
        },
        {
            ratingScaleLevelKey: 5,
            value: 5,
            name: "Advanced",
            description: "You can operate as a one-person show, which means you're autonomous. You can lead an initiative and see it through to the end with little to no supervision. You can plan the process you'll use, apply that plan, and evaluate the effectiveness of it while considering alternatives and the potential outcomes.\nYou're likely trusted when it comes to your domain. Others may come to you with ideas, situations, or problems and ask for your insight or potential solutions."
        },
        {
            ratingScaleLevelKey: 6,
            value: 6,
            name: "Advanced",
            description: "You can work well independently on very complex projects. You've applied your unique viewpoint to solve complicated issues, and you innovate to help the field advance. You're likely good at communicating problems and potential solutions, and can lead teams of practitioners."
        },
        {
            ratingScaleLevelKey: 7,
            value: 7,
            name: "Expert",
            description: "You've likely successfully led teams as they work on big initiatives that push the boundaries of your field. And you can do it all—whether you're still a practitioner or you spend the bulk of your time leading others, your judgment is well-respected from those within your domain."
        },
        {
            ratingScaleLevelKey: 8,
            value: 8,
            name: "Expert",
            description: "You are completely autonomous, and you are regarded as a domain leader and scholar. You have your choice of projects, and you likely select those that will allow you to create significant impact in the field and offer new ideas or practices."
        }
    ]
};
var orgRatingLabels = [
    "Foundational",
    "Foundational",
    "Proficient",
    "Proficient",
    "Advanced",
    "Advanced",
    "Expert",
    "Expert"
];
var setOverviewTabDefault = "Top";
var showPrimaryPlanOption = false;
var onboardingRateSkillsMandatory = true;
var disableRatingsInsights = false;
var disableSearchRelatedSkills = false;
var additionalContentLanguages = [];
var disableDegreedMarketplace = false;
var academiesBannerImage = "https://lxp.staging.degreedcdn.com/content/img/org/1-11f95fab-2574-471f-87ed-8c2a6318a048.png?v=811981720";
var acmCanViewAcademies = true;
var acmCanViewBudgets = false;
var acmUserCurrency = "";
var defaultAssignmentsSortColumn = "DueDate";
var publishSkills = true;
var skillsPlusRolloutTempDec2024 = false;
var localAuthenticatedUser = {
    viewerProfile: viewerProfile,
    defaultOrgId: defaultOrgId,
    orgInfo: orgInfo,
    viewerGroups: viewerGroups,
    viewerInterests: viewerInterests,
    viewerPicture: viewerPicture,
    analyticsEnabled: analyticsEnabled,
    isPrivateProfile: isPrivateProfile,
    isManagedProfile: isManagedProfile,
    isRestrictedViewerProfile: isRestrictedViewerProfile,
    contextId: contextId,
    canRecommendItems: canRecommendItems,
    canRecommendRatings: canRecommendRatings,
    canAssignRatings: canAssignRatings,
    canEvaluateSkills: canEvaluateSkills,
    canRequestManagerRating: canRequestManagerRating,
    canRequestPeerRating: canRequestPeerRating,
    canCertifySkills: canCertifySkills,
    canShareSocial: canShareSocial,
    canAssignLearning: canAssignLearning,
    canComment: canComment,
    canRestrictContent: canRestrictContent,
    canEndorseContent: canEndorseContent,
    canViewKnowledgeCenter: canViewKnowledgeCenter,
    canAuthorTargets: canAuthorTargets,
    canConfigureBrowse: canConfigureBrowse,
    canManageOrganization: canManageOrganization,
    canBulkUpload: canBulkUpload,
    canUploadContentFiles: canUploadContentFiles,
    canUploadVideo: canUploadVideo,
    canRecordVideo: canRecordVideo,
    canShareOpportunity: canShareOpportunity,
    canManageOpportunities: canManageOpportunities,
    canManageTargets: canManageTargets,
    canFeaturePathways: canFeaturePathways,
    canCreateOpportunities: canCreateOpportunities,
    canPublishOpportunities: canPublishOpportunities,
    canViewReporting: canViewReporting,
    canManageReporting: canManageReporting,
    canScanCatalogLinks: canScanCatalogLinks,
    hasChannelManagePathwayPermission: hasChannelManagePathwayPermission,
    hasChannelManageTargetPermission: hasChannelManageTargetPermission,
    hasCareerPathing: hasCareerPathing,
    hasChannel: hasChannel,
    isTargetAuthor: isTargetAuthor,
    isEngaged: isEngaged,
    isManager: isManager,
    participateInUserSurveys: participateInUserSurveys,
    showInAppTips: showInAppTips,
    participateInTeamProgram: participateInTeamProgram,
    hasInternalJobSkills: hasInternalJobSkills,
    hasManageIntegrations: hasManageIntegrations,
    canCascadeDeleteInputResources: canCascadeDeleteInputResources,
    showScaleChanged: showScaleChanged,
    enableSkillStandards: enableSkillStandards,
    enableCustomRecommendationTypes: enableCustomRecommendationTypes,
    viewRatingScaleChanges: viewRatingScaleChanges,
    enablePluralsightSkillsIntegration: enablePluralsightSkillsIntegration,
    optInAISkillInference: optInAISkillInference,
    hasCareerMobility: hasCareerMobility,
    careerMobilityIsGroupControlled: careerMobilityIsGroupControlled,
    defaultOrgPermissionRole: defaultOrgPermissionRole,
    showUserSearchFilterByLocation: showUserSearchFilterByLocation,
    showUserSearchFilterByJobRole: showUserSearchFilterByJobRole,
    enableMentorshipOpportunities: enableMentorshipOpportunities,
    disableMentorshipReview: disableMentorshipReview,
    opportunitiesActivityStartDate: opportunitiesActivityStartDate,
    showDegreedDataPrivacyAcceptance: showDegreedDataPrivacyAcceptance,
    showDataPrivacyAcceptance: showDataPrivacyAcceptance,
    allowOpportunityManagerViewProfileInfo: allowOpportunityManagerViewProfileInfo,
    disableResumeParsingInOnboarding: disableResumeParsingInOnboarding,
    disableLearnerSkillsRegistry: disableLearnerSkillsRegistry,
    hasAcceptedPrivacyPolicy: hasAcceptedPrivacyPolicy,
    isSkillInventoryClient: isSkillInventoryClient,
    isSkillAnalyticsClient: isSkillAnalyticsClient,
    uploadedImageType: uploadedImageType,
    enableOsanoCookieBannerAuthed: enableOsanoCookieBannerAuthed,
    hideOverviewTab: hideOverviewTab,
    hideOverviewExperience: hideOverviewExperience,
    hideOverviewAchievement: hideOverviewAchievement,
    minimumSkillUserCount: minimumSkillUserCount,
    minimumAggregatedLearningInsightsUserCount: minimumAggregatedLearningInsightsUserCount,
    orgRatingScale: orgRatingScale,
    orgRatingLabels: orgRatingLabels,
    setOverviewTabDefault: setOverviewTabDefault,
    showPrimaryPlanOption: showPrimaryPlanOption,
    onboardingRateSkillsMandatory: onboardingRateSkillsMandatory,
    disableRatingsInsights: disableRatingsInsights,
    disableSearchRelatedSkills: disableSearchRelatedSkills,
    additionalContentLanguages: additionalContentLanguages,
    disableDegreedMarketplace: disableDegreedMarketplace,
    academiesBannerImage: academiesBannerImage,
    acmCanViewAcademies: acmCanViewAcademies,
    acmCanViewBudgets: acmCanViewBudgets,
    acmUserCurrency: acmUserCurrency,
    defaultAssignmentsSortColumn: defaultAssignmentsSortColumn,
    publishSkills: publishSkills,
    skillsPlusRolloutTempDec2024: skillsPlusRolloutTempDec2024
};

var degreedSkillsOctober2024 = true;
var lxpDegreedAssistant = false;
var personalizedLearning = true;
var sessionManagement = true;
var useLearnerHub = true;
var orgManagement = {
    segmentsUI: true,
    showWebhooksAdmin: true
};
var insights = {
    insightsSkillAnalytics: true
};
var teams = {
    teamSpaceEnabled: false
};
var skillCoach = {
    managerAssignments: false
};
var apollo = {
    APOLLO_LAYOUT: true,
    APOLLO_LAYOUT_REFRESH: true,
    APOLLO_LAYOUT_LEARNER_V2: true,
    APOLLO_LAYOUT_LEARNER_V3: true,
    APOLLO_LAYOUT_ADMIN_V2: true,
    APOLLO_LAYOUT_ADMIN_V3: true
};
var localFeatureFlags = {
    degreedSkillsOctober2024: degreedSkillsOctober2024,
    lxpDegreedAssistant: lxpDegreedAssistant,
    personalizedLearning: personalizedLearning,
    sessionManagement: sessionManagement,
    useLearnerHub: useLearnerHub,
    orgManagement: orgManagement,
    insights: insights,
    teams: teams,
    skillCoach: skillCoach,
    apollo: apollo
};

var faq = "/faq/1";
var email = "support@your-organization.com";
var phone = "800.311.7061";
var customText = "Test degreed Update";
var customLink = "http://degreed.com";
var helpLink = "/HelpdeskSAML/ZenDeskSSOInitiator?url=https%3A%2F%2Fdegreed.zendesk.com%2Fhc%2F";
var showCookieLink = true;
var localSupportInfo = {
    faq: faq,
    email: email,
    phone: phone,
    customText: customText,
    customLink: customLink,
    helpLink: helpLink,
    showCookieLink: showCookieLink
};

/** Handles values that might be either a true boolean or a (case-insensitive) string. */ function booleanFromString(value) {
    // if boolean, return as-is
    if (typeof value === "boolean") {
        return value;
    }
    return (value === null || value === void 0 ? void 0 : value.toLowerCase()) === "true";
}

/* eslint-disable @typescript-eslint/no-explicit-any */ function _define_property$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$1(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$1(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * Convert RawAuth data to LxPAthUser instance
 *
 * Transform raw org settings from string values to their natural types
 * This should eventually be done on the back end via db-provided type info
 */ function fixupAuthUser(rawAuthUser) {
    var _rawAuthUser_orgInfo;
    var orgInfo = (_rawAuthUser_orgInfo = rawAuthUser.orgInfo) === null || _rawAuthUser_orgInfo === void 0 ? void 0 : _rawAuthUser_orgInfo.map(function(o) {
        return _object_spread_props$1(_object_spread$1({}, o), {
            settings: o.settings ? mapTypedOrgSettings(o.settings) : {},
            permissions: o.permissions ? mapOrgPermissions(o) : {}
        });
    });
    var defaultOrgInfo = orgInfo === null || orgInfo === void 0 ? void 0 : orgInfo.find(function(o) {
        return o.organizationId === rawAuthUser.defaultOrgId;
    });
    return _object_spread_props$1(_object_spread$1({}, rawAuthUser), {
        viewerProfile: _object_spread_props$1(_object_spread$1({}, rawAuthUser.viewerProfile), {
            // duplicate isEngaged under viewerProfile object so we don't break the old angular component
            isEngaged: rawAuthUser.isEngaged
        }),
        orgInfo: orgInfo,
        // Provide default org info as dedicated property
        defaultOrgInfo: defaultOrgInfo
    });
}
/**
 * Convert org setting values, which arrive as strings over the wire, into their appropriate data types.
 * @param settings
 * @returns LxpOrgSettings
 */ function mapTypedOrgSettings(settings) {
    var target = settings;
    var remapped = Object.keys(target).reduce(function(acc, key) {
        var bValue = booleanFromString(target[key]);
        return _object_spread_props$1(_object_spread$1({}, acc), _define_property$1({}, key, bValue));
    }, {});
    return _object_spread_props$1(_object_spread$1({}, remapped), {
        // These are NOT booleans
        learnInBalanceUrl: target.learnInBalanceUrl,
        opportunitiesActivityStartDate: new Date(target.opportunitiesActivityStartDate),
        academiesBannerImage: target.academiesBannerImage,
        careersFooterMessage: target.careersFooterMessage,
        clientAdobeAnalyticsId: target.clientAdobeAnalyticsId,
        clientGoogleAnalyticsId: target.clientGoogleAnalyticsId,
        clientTypeOverride: target.clientTypeOverride,
        defaultAssignmentsSort: target.defaultAssignmentsSort,
        learnInSsoUrl: target.learnInSsoUrl,
        organizationBrandColor: target.organizationBrandColor,
        organizationEndorsedPicture: target.organizationEndorsedPicture,
        minimumAggregatedLearningInsightsUserCount: target.minimumAggregatedLearningInsightsUserCount,
        profileOverviewTabDefault: target.profileOverviewTabDefault
    });
}
/**
 * LxP publishes permissions as upperCamelCase string[]
 * @returns camelCase Record<string, boolean>
 */ function mapOrgPermissions(orgInfo) {
    var lookup = orgInfo.permissions.reduce(function(acc, permission) {
        return _object_spread_props$1(_object_spread$1({}, acc), _define_property$1({}, toCamelCase(permission), true));
    }, {});
    return lookup;
}
/**
 * Convert a string to camelCase
 * Permissions are an array of strings in upperCamelCase
 */ function toCamelCase(str) {
    if (!str) return str;
    return str.charAt(0).toLowerCase() + str.slice(1);
}

function asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator$1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator$1(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var sameOriginRequestInit = {
    credentials: "same-origin",
    method: "GET",
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
    }
};
/**
 * Load user, orgInfo, supportInfo, and featureFlags from LXP endpoints
 */ var loadLxpPermissions = function() {
    var _ref = _async_to_generator$1(function() {
        var apiEnabled, authUser, orgId, orgInfo, supportInfo;
        var _arguments = arguments;
        return _ts_generator$1(this, function(_state) {
            switch(_state.label){
                case 0:
                    apiEnabled = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : true;
                    return [
                        4,
                        getAuthUser(apiEnabled)
                    ];
                case 1:
                    authUser = _state.sent();
                    orgId = authUser.defaultOrgId;
                    orgInfo = authUser.orgInfo.find(function(x) {
                        return x.organizationId === orgId;
                    }) || initOrgInfo();
                    return [
                        4,
                        getSupportInfo(orgInfo, orgId, apiEnabled)
                    ];
                case 2:
                    supportInfo = _state.sent();
                    return [
                        2,
                        {
                            authUser: authUser,
                            orgInfo: orgInfo,
                            supportInfo: supportInfo
                        }
                    ];
            }
        });
    });
    return function loadLxpPermissions() {
        return _ref.apply(this, arguments);
    };
}();
var getAuthUser = function() {
    var _ref = _async_to_generator$1(function() {
        var apiEnabled, rawUser, response, user;
        var _arguments = arguments;
        return _ts_generator$1(this, function(_state) {
            switch(_state.label){
                case 0:
                    apiEnabled = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : true;
                    rawUser = localAuthenticatedUser;
                    if (!apiEnabled) return [
                        3,
                        6
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        5,
                        ,
                        6
                    ]);
                    return [
                        4,
                        fetch("/api/account/getauthenticateduser?dg-casing=camel", sameOriginRequestInit)
                    ];
                case 2:
                    response = _state.sent();
                    if (!(response.status === 200)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        response.json()
                    ];
                case 3:
                    rawUser = _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        3,
                        6
                    ];
                case 5:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 6:
                    // Use a sample JSON file for local development since we can't easily hit the needed service with valid auth cookies
                    user = fixupAuthUser(rawUser);
                    return [
                        2,
                        Promise.resolve(user)
                    ];
            }
        });
    });
    return function getAuthUser() {
        return _ref.apply(this, arguments);
    };
}();
var getSupportInfo = function() {
    var _ref = _async_to_generator$1(function(orgInfo, orgId) {
        var apiEnabled, rawSupportInfo, _orgInfo_permissions_viewKnowledgeCenter, canViewKnowledgeCenter, params, response;
        var _arguments = arguments;
        return _ts_generator$1(this, function(_state) {
            switch(_state.label){
                case 0:
                    apiEnabled = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : true;
                    rawSupportInfo = localSupportInfo;
                    if (!apiEnabled) return [
                        3,
                        7
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        5,
                        ,
                        6
                    ]);
                    canViewKnowledgeCenter = (_orgInfo_permissions_viewKnowledgeCenter = orgInfo === null || orgInfo === void 0 ? void 0 : orgInfo.permissions.viewKnowledgeCenter) !== null && _orgInfo_permissions_viewKnowledgeCenter !== void 0 ? _orgInfo_permissions_viewKnowledgeCenter : false;
                    params = new URLSearchParams({
                        orgId: orgId.toString(),
                        // localeId,
                        includeKC: canViewKnowledgeCenter.toString(),
                        "dg-casing": "camel"
                    });
                    return [
                        4,
                        fetch("/api/organizations/getsupportinfo?".concat(params), sameOriginRequestInit)
                    ];
                case 2:
                    response = _state.sent();
                    if (!(response.status === 200)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        response.json()
                    ];
                case 3:
                    rawSupportInfo = _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        3,
                        6
                    ];
                case 5:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 6:
                    return [
                        2,
                        rawSupportInfo
                    ];
                case 7:
                    // Use a sample JSON file for local development since we can't easily hit the needed service with valid auth cookies
                    return [
                        2,
                        localSupportInfo
                    ];
            }
        });
    });
    return function getSupportInfo(orgInfo, orgId) {
        return _ref.apply(this, arguments);
    };
}();
var getGroupNames = function(user) {
    // null or empty, return []
    if (!(user === null || user === void 0 ? void 0 : user.viewerGroups) || (user === null || user === void 0 ? void 0 : user.viewerGroups.length) === 0) {
        return [];
    }
    return user.viewerGroups.filter(function(viewerGroup) {
        return viewerGroup.group.name.toLowerCase().includes("pre-release");
    }).map(function(viewerGroup) {
        return viewerGroup.group.name;
    });
};
/**
 * Get Launch Darkly feature flags for LXP using the Launch Darkly client SDK
 */ var loadFeatureFlags = function() {
    var _ref = _async_to_generator$1(function(authUser, orgInfo, launchDarklyConfig) {
        var apiEnabled, context;
        var _arguments = arguments;
        return _ts_generator$1(this, function(_state) {
            apiEnabled = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : true;
            if (apiEnabled) {
                context = {
                    kind: "user",
                    key: launchDarklyConfig.contextKey,
                    // Custom attributes
                    Org: orgInfo.organizationId || -1,
                    Role: orgInfo.orgRole,
                    PreReleaseGroups: getGroupNames(authUser)
                };
                return [
                    2,
                    new Promise(function(resolve) {
                        var client = Ft(launchDarklyConfig.licenseKey, context);
                        client.waitForInitialization(2).then(function() {
                            var getFlagValue = function(flag) {
                                return client.variation(flag, false);
                            };
                            resolve(buildFeatureFlagsFrom(launchDarklyConfig.requestedFlags, getFlagValue));
                        }).catch(function(err) {
                            console.error(JSON.stringify(err));
                            resolve({});
                        });
                    })
                ];
            }
            return [
                2,
                Promise.resolve(localFeatureFlags)
            ];
        });
    });
    return function loadFeatureFlags(authUser, orgInfo, launchDarklyConfig) {
        return _ref.apply(this, arguments);
    };
}();

var admin$2 = {
    brand: {
        href: "/orgs/<orgId>",
        mark: {
            url: "data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' fill='%230062E3' xmlns='http://www.w3.org/2000/svg' %3E%3Cpath class='logo' fill-rule='evenodd' clip-rule='evenodd' d='M28.2624 15.1156L20.2595 10.6838L19.9913 10.5263C19.7677 10.4363 19.5219 10.3913 19.276 10.3913C19.0301 10.3913 18.7842 10.4363 18.5606 10.5263L18.2477 10.7063L16.9958 11.4037C16.9735 11.4262 16.9735 11.4486 16.9958 11.4711L17.51 11.7411L20.5278 13.4059L22.3161 14.3957C22.3161 14.3957 19.6783 14.5082 17.2417 15.9255C16.7946 16.1954 16.2805 16.3304 15.7663 16.3304H15.6545C15.1404 16.3304 14.6262 16.1954 14.1792 15.9255C11.7425 14.5082 9.10472 14.3957 9.10472 14.3957L15.6993 10.7288L18.0465 9.40145C18.2924 9.26647 19.1418 8.72656 20.1031 9.01901C20.5278 9.13149 21.2431 9.53643 21.8244 9.87388C22.2938 10.1438 22.875 10.0539 23.2327 9.62642C23.4115 9.40145 23.5009 9.15399 23.5009 8.88403C23.5009 8.50159 23.3221 8.14164 22.9644 7.91668C22.2044 7.44425 21.1537 6.88183 20.3043 6.74685C18.1135 6.36441 16.7276 7.44425 15.6769 8.00666C14.8721 7.35426 13.2403 6.38691 11.0719 6.74685C10.2001 6.90433 9.17179 7.44425 8.41174 7.91668C7.83052 8.27662 7.6964 9.0865 8.14348 9.60392C8.36703 9.85139 8.67999 9.98637 8.99295 9.98637C9.19414 9.98637 9.37297 9.94137 9.55181 9.82889C10.133 9.49144 10.8484 9.0865 11.2731 8.97402C12.4132 8.65907 13.3968 9.40145 13.3968 9.40145L3.0914 15.1156C2.82315 15.2506 2.66667 15.543 2.66667 15.8355V17.2528C2.66667 17.5452 2.82315 17.8152 3.0914 17.9727C3.35965 18.1076 3.42672 18.1976 3.42672 18.7151C3.42672 19.6149 2.82315 24.5417 9.21649 24.5417C14.9616 24.5417 14.2462 18.895 15.6769 18.9175C17.1299 18.895 16.4146 24.5417 22.1373 24.5417C28.5307 24.5417 27.9271 19.6149 27.9271 18.7151C27.9271 18.1976 27.9718 18.1301 28.24 17.9727C28.5083 17.8377 28.6648 17.5452 28.6648 17.2528V15.8355C28.6871 15.5205 28.5083 15.2506 28.2624 15.1156ZM12.1896 21.0997C11.5637 22.427 10.4683 22.6295 8.88118 22.562C7.6964 22.517 6.60103 22.1345 6.04218 21.4821C5.23742 20.5598 5.32684 17.7927 5.6398 17.1853C6.24336 16.0155 11.7872 16.3754 12.5249 17.8602C12.6144 18.0177 13.1062 19.1875 12.1896 21.0997ZM25.3116 21.4821C24.7528 22.1121 23.6574 22.4945 22.4726 22.562C20.9078 22.6295 19.8125 22.427 19.1642 21.0997C18.2477 19.1875 18.7394 18.0177 18.8065 17.8602C19.5442 16.3754 25.1104 16.0155 25.6917 17.1853C26.027 17.8152 26.1164 20.5823 25.3116 21.4821Z' /%3E%3C/svg%3E",
            altText: "Degreed logo"
        },
        logo: {
            url: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='268' height='54' viewBox='0 0 134 27' fill='none'%3E%3Cpath d='M27.344 18.1522C26.3963 18.9499 25.2299 19.4576 23.9176 19.4576C22.0222 19.5301 20.7099 19.3125 19.9809 17.717C18.8874 15.4688 19.4706 14.0909 19.5435 13.8733C20.4183 12.1327 27.1253 11.6976 27.7814 13.0756C28.2188 13.8008 28.3647 17.1369 27.344 18.1522ZM11.6701 17.717C10.9411 19.3125 9.62883 19.5301 7.73337 19.4576C6.49404 19.4576 5.2547 19.0225 4.30698 18.1522C3.35925 17.0643 3.43215 13.8008 3.79666 13.0756C4.52568 11.6976 11.1598 12.1327 12.0346 13.8733C12.1804 14.0909 12.7636 15.4688 11.6701 17.717ZM30.9162 10.6098L21.2932 5.38809L21.0015 5.17052C20.4183 4.95295 19.8351 4.95295 19.3248 5.17052L18.9603 5.38809L17.4293 6.25837V6.33089L18.0126 6.62099L21.6577 8.57911L23.7718 9.73949C21.6577 9.88453 19.5435 10.5372 17.721 11.5526C17.2106 11.8427 16.5545 12.0602 15.9713 12.0602H15.8255C15.1694 12.0602 14.5862 11.9152 14.0759 11.5526C12.1804 10.5372 10.1391 9.88453 8.02498 9.73949L15.8984 5.38809L18.7416 3.79258C19.4706 3.28492 20.3454 3.13987 21.2203 3.35744C21.9493 3.64754 22.6054 3.93763 23.2615 4.37277C23.5531 4.51782 23.8447 4.59034 24.1363 4.51781C24.4279 4.44529 24.6466 4.30025 24.8654 4.08268C25.0841 3.86511 25.157 3.50249 25.157 3.2124C25.157 2.77726 24.9383 2.34212 24.5008 2.05203C23.5531 1.39932 22.4596 0.964178 21.2932 0.674086C18.6687 0.238946 16.9919 1.47184 15.7526 2.19707C14.2217 0.96418 12.1804 0.383993 10.212 0.674086C9.04561 0.964178 8.02498 1.39932 7.00435 2.05203C6.42114 2.48717 6.20243 3.28492 6.63984 3.86511C6.63984 3.93763 6.71274 3.93763 6.71274 4.01015C7.00435 4.30025 7.36886 4.44529 7.73337 4.44529C7.95208 4.44529 8.17079 4.37277 8.38949 4.22772C9.04561 3.86511 9.70173 3.50249 10.4307 3.2124C11.3056 2.99483 12.2533 3.2124 12.9823 3.72006L0.807678 10.6098C0.51607 10.7548 0.297363 11.1174 0.297363 11.48V13.1481C0.297363 13.5107 0.51607 13.8733 0.807678 14.0183C1.09929 14.1634 1.17219 14.3084 1.17219 14.8886C1.17219 15.9765 0.443168 21.7783 8.09788 21.7783C14.9507 21.7783 14.1488 15.1062 15.8255 15.1062C17.5022 15.1062 16.7003 21.7783 23.5531 21.7783C31.2078 21.7783 30.4788 15.9765 30.4788 14.8886C30.4788 14.3084 30.5517 14.1634 30.8433 14.0183C31.2078 13.8733 31.4265 13.5107 31.4265 13.1481V11.48C31.4994 11.1174 31.2807 10.7548 30.9162 10.6098Z' fill='%230062E3'/%3E%3Cpath d='M70.1374 14.8887C70.2103 14.236 70.5019 13.6558 71.0122 13.2206C71.7413 12.6405 72.6161 12.3504 73.5638 12.4229C74.4386 12.3504 75.3135 12.6405 75.9696 13.2206C76.4799 13.6558 76.7715 14.3085 76.8444 14.9612V15.759C76.8444 16.4117 76.6257 17.0644 76.1883 17.572C76.1154 17.6446 76.0425 17.7896 75.8967 17.8621C75.6051 18.1522 75.1677 18.3698 74.8031 18.5148C74.3657 18.6599 73.8554 18.7324 73.3451 18.7324C72.4703 18.8049 71.5954 18.5148 70.9393 17.8621C70.8664 17.7896 70.7206 17.7171 70.6477 17.572C70.2103 16.9919 69.9916 16.2666 70.0645 15.5414C70.0645 15.3238 70.0645 15.1063 70.1374 14.8887ZM79.6876 10.2472H77.2818C77.2089 10.2472 77.136 10.3197 77.0631 10.3922C76.9902 10.4648 76.9902 10.5373 76.9902 10.6098V11.7702C76.5528 11.19 75.8967 10.6823 75.2406 10.3922C74.4386 10.1021 73.6367 9.9571 72.7619 9.9571C71.6684 9.9571 70.6477 10.1747 69.7 10.6823C68.8252 11.1175 68.1691 11.8427 67.6587 12.713C67.1484 13.5833 66.9297 14.5986 66.9297 15.6139C66.9297 16.5567 67.1484 17.4995 67.5129 18.3698L67.6587 18.5148C68.0962 19.3126 68.8252 19.9653 69.6271 20.473C69.9916 20.6905 70.429 20.8356 70.8664 20.9806C71.3768 21.1257 71.8871 21.1982 72.4703 21.1257C73.0535 21.1257 73.6367 21.0532 74.2199 20.9806C74.5115 20.9081 74.8031 20.7631 75.0947 20.6905C75.8238 20.4004 76.4799 19.8928 76.9902 19.3126V21.0532C76.9902 21.5608 76.8444 22.0685 76.5528 22.5036C76.2612 22.9388 75.8238 23.3014 75.3135 23.5189C74.9489 23.664 74.5844 23.809 74.2199 23.809C73.9283 23.809 73.7096 23.8816 73.418 23.8816C71.8142 23.8816 70.7935 23.4464 70.2832 22.5036C70.2832 22.4311 70.2103 22.3586 70.1374 22.3586H67.5858C67.44 22.3586 67.2942 22.5036 67.2942 22.6487V22.7212C67.5858 23.809 68.242 24.6793 69.1897 25.332C70.5019 26.0573 71.96 26.3473 73.4909 26.2748C74.6573 26.3473 75.8238 26.0572 76.9173 25.6221C76.9902 25.6221 76.9902 25.5496 77.0631 25.5496C77.5734 25.332 78.0108 25.0419 78.3753 24.6793C79.396 23.7365 79.9792 22.4311 80.0521 21.0532C80.125 20.618 80.125 20.1829 80.125 19.8203V10.6098C80.0521 10.3922 79.9063 10.2472 79.6876 10.2472ZM130.427 16.1216C130.427 16.9193 130.136 17.7171 129.553 18.2247C129.261 18.5148 128.824 18.8049 128.386 18.95C127.949 19.095 127.438 19.2401 127.001 19.2401C126.126 19.3126 125.178 18.95 124.595 18.3698C123.939 17.7171 123.648 16.7743 123.72 15.8315C123.648 14.8887 123.939 13.9459 124.595 13.2206C125.324 12.5679 126.199 12.2778 127.147 12.3504C128.022 12.2778 128.969 12.6405 129.553 13.2206C129.844 13.5107 130.063 13.8734 130.209 14.236C130.354 14.6711 130.427 15.0337 130.427 15.4689V16.1216ZM133.198 6.25842H130.719C130.646 6.25842 130.573 6.25842 130.5 6.33094C130.427 6.40347 130.427 6.47599 130.427 6.54852V11.6251C129.407 10.3922 127.876 9.73954 126.272 9.81206C125.178 9.81206 124.158 10.0296 123.21 10.6098C122.335 11.1175 121.606 11.8427 121.169 12.713C120.659 13.6558 120.44 14.7436 120.513 15.8315C120.513 16.9193 120.731 17.9347 121.169 18.8775C121.606 19.7477 122.262 20.4004 123.137 20.9081C124.012 21.4158 124.96 21.6333 125.98 21.6333C126.928 21.6333 127.803 21.4883 128.605 21.1257C129.407 20.8356 130.063 20.2554 130.5 19.6027V20.9806C130.5 21.1982 130.646 21.3432 130.865 21.3432H133.271C133.489 21.3432 133.635 21.1982 133.635 20.9806V6.62104C133.635 6.54852 133.635 6.40347 133.562 6.40347C133.416 6.33095 133.343 6.25842 133.198 6.25842ZM108.921 14.5986C108.994 13.8734 109.359 13.2206 109.942 12.858C110.598 12.3504 111.4 12.1328 112.202 12.1328C113.077 12.0603 113.879 12.2778 114.608 12.7855C115.191 13.2206 115.555 13.8734 115.482 14.5986H108.921ZM116.941 11.4076C115.628 10.3922 113.952 9.81206 112.275 9.9571C111.108 9.9571 109.942 10.1747 108.848 10.7549C107.901 11.2625 107.099 11.9878 106.588 12.9306C106.078 13.8734 105.787 14.9612 105.787 16.0491C105.714 17.6446 106.297 19.1676 107.463 20.2554C108.775 21.3432 110.452 21.8509 112.202 21.7784C113.66 21.8509 115.118 21.5608 116.43 20.8356C117.378 20.2554 118.034 19.3851 118.326 18.2973C118.399 18.1522 118.326 18.0072 118.18 18.0072H115.628C115.555 18.0072 115.41 18.0797 115.41 18.1522C114.972 19.0225 113.952 19.5302 112.421 19.5302C111.837 19.5302 111.181 19.3851 110.598 19.1676C110.088 18.95 109.723 18.5874 109.359 18.1522C109.067 17.7171 108.921 17.2094 108.921 16.7018H118.18C118.326 16.7018 118.399 16.6292 118.471 16.5567C118.544 16.4842 118.617 16.3391 118.617 16.2666V15.6864C118.69 14.0909 118.034 12.5679 116.941 11.4076ZM94.4138 14.5986C94.4867 13.8734 94.8512 13.2206 95.4344 12.858C96.0905 12.3504 96.8925 12.1328 97.6944 12.1328C98.5692 12.0603 99.3711 12.2778 100.1 12.7855C100.683 13.2206 101.048 13.8734 100.975 14.5986H94.4138ZM102.36 11.4076C101.048 10.3922 99.3711 9.81206 97.6944 9.9571C96.5279 9.9571 95.3615 10.1747 94.268 10.7549C93.3203 11.2625 92.5183 11.9878 92.008 12.9306C91.4977 13.8734 91.2061 14.9612 91.2061 16.0491C91.1332 17.6446 91.7164 19.1676 92.8829 20.2554C94.1951 21.3432 95.8718 21.8509 97.6215 21.7784C99.0795 21.8509 100.538 21.5608 101.85 20.8356C102.798 20.2554 103.454 19.3851 103.745 18.2973C103.818 18.1522 103.745 18.0072 103.599 18.0072H101.048C100.975 18.0072 100.829 18.0797 100.829 18.1522C100.392 19.0225 99.3711 19.5302 97.8402 19.5302C97.257 19.5302 96.6009 19.3851 96.0176 19.1676C95.5073 18.95 95.1428 18.5874 94.7783 18.1522C94.4867 17.7171 94.3409 17.2094 94.3409 16.7018H103.599C103.745 16.7018 103.818 16.6292 103.891 16.5567C103.964 16.4842 104.037 16.3391 104.037 16.2666V15.6864C104.11 14.0909 103.527 12.5679 102.36 11.4076ZM89.8939 10.1022C88.29 10.1022 86.832 10.8274 85.8114 12.0603V10.6098C85.8114 10.5373 85.8114 10.4648 85.7384 10.3922C85.6655 10.3197 85.5926 10.3197 85.5197 10.2472H83.114C82.8953 10.2472 82.7495 10.3922 82.7495 10.6098V21.0532C82.7495 21.2707 82.8953 21.4158 83.114 21.4158H85.5926C85.8114 21.4158 85.9572 21.2707 85.9572 21.0532V15.5414C85.9572 14.8162 86.3217 14.0909 86.9049 13.5833C87.6339 13.0031 88.5816 12.6405 89.5294 12.713H89.9668C90.1855 12.713 90.4042 12.5679 90.4042 12.3504V10.4648C90.4042 10.3922 90.3313 10.2472 90.2584 10.1747C90.1855 10.1022 90.1126 10.0296 89.9668 10.0296H89.8939V10.1022ZM55.4112 14.6711C55.4841 13.9459 55.8486 13.2932 56.4318 12.9306C57.0879 12.4229 57.8899 12.2053 58.6918 12.2053C59.5666 12.1328 60.3685 12.3504 61.0976 12.858C61.6808 13.2932 61.9724 13.9459 61.9724 14.6711H55.4112ZM63.4304 11.4076C62.1182 10.3197 60.5143 9.81206 58.8376 9.88458C57.6712 9.88458 56.5047 10.1022 55.4112 10.6823C54.4635 11.19 53.6616 11.9152 53.1512 12.858C52.6409 13.8008 52.3493 14.8887 52.3493 15.9765C52.2764 17.572 52.8596 19.095 54.0261 20.1829C55.3383 21.2707 57.015 21.7784 58.7647 21.7059C60.2227 21.7784 61.6808 21.4883 62.993 20.7631C63.9407 20.1829 64.5969 19.3126 64.8885 18.2247C64.9614 18.0797 64.8156 17.9347 64.7427 17.9347H62.1911C62.1182 17.9347 61.9724 18.0072 61.9724 18.0797C61.535 18.95 60.5143 19.4576 58.9105 19.4576C58.3273 19.4576 57.6712 19.3126 57.0879 19.095C56.5776 18.8775 56.2131 18.5148 55.8486 18.0797C55.557 17.6446 55.4112 17.1369 55.4112 16.6292H64.5969C64.7427 16.6292 64.8156 16.5567 64.8885 16.4842C64.9614 16.4117 65.0343 16.2666 65.0343 16.1941V15.6864C65.1072 14.0909 64.524 12.5679 63.4304 11.4076ZM47.1733 16.1216C47.1733 16.4842 47.1004 16.9193 46.9546 17.2819C46.8088 17.6446 46.5901 18.0072 46.2984 18.2973C46.0068 18.5874 45.5694 18.8775 45.132 19.0225C44.6946 19.1675 44.1843 19.3126 43.674 19.3126C42.7991 19.3851 41.8514 19.0225 41.2682 18.4423C40.6121 17.7896 40.3205 16.8468 40.3934 15.9765C40.3205 15.0337 40.6121 14.0909 41.2682 13.3657C41.9972 12.713 42.872 12.4229 43.8198 12.4954C44.6946 12.4229 45.6423 12.7855 46.2255 13.3657C46.5172 13.6558 46.7359 14.0184 46.8817 14.381C47.0275 14.7436 47.1004 15.1788 47.1004 15.6139L47.1733 16.1216ZM49.9435 6.33094H47.4649C47.2462 6.33094 47.1004 6.47599 47.1004 6.69356V11.7702C46.0797 10.5373 44.4759 9.88458 42.872 9.9571C41.7785 9.9571 40.7579 10.1747 39.8102 10.7549C38.9353 11.2625 38.2063 11.9878 37.7689 12.858C36.8212 14.8162 36.8212 17.0644 37.7689 19.0225C38.2063 19.8928 38.8624 20.5455 39.7373 21.0532C40.6121 21.5608 41.5598 21.7784 42.5804 21.7784C43.5282 21.7784 44.403 21.6333 45.2049 21.2707C46.0068 20.9806 46.663 20.4004 47.1004 19.7477V21.1257C47.1004 21.3432 47.2462 21.4883 47.4649 21.4883H49.8706C50.0894 21.4883 50.2352 21.3432 50.2352 21.1257V6.69356C50.2352 6.62104 50.1622 6.54852 50.1622 6.47599C50.1622 6.33095 50.0164 6.33094 49.9435 6.33094Z' fill='%23353C42'/%3E%3C/svg%3E",
            altText: "Degreed logo"
        },
        colors: {
            background: "#ffffff",
            text: "var(--apollo-color-neutral-800)",
            highlight: "var(--apollo-color-blue-800)",
            separator: "var(--apollo-color-neutral-200)"
        },
        text: "Degreed Logo",
        analytics: "global.navigation.admin.brand",
        i18n: "global.navigation.admin.brand, A11Y__DEGREED_LOGO",
        dgat: "global.navigation.admin.brand"
    },
    features: {
        beta: {
            enabled: false,
            visible: false,
            text: "Beta",
            i18n: "global.navigation.admin.features.beta, GENERIC__BETA",
            dgat: "global.navigation.admin.features.beta"
        },
        admin: {
            enabled: true,
            visible: true,
            text: "Admin",
            i18n: "global.navigation.admin.features.admin, ADMIN",
            dgat: "global.navigation.admin.features.admin"
        },
        footerBranding: {
            enabled: true,
            visible: true,
            text: "Powered by",
            i18n: "global.navigation.admin.features.footer-branding, BRAND__POWERED_BY",
            dgat: "global.navigation.admin.features.footer-branding"
        },
        sidebarBranding: {
            enabled: true,
            visible: true,
            text: "Powered by",
            i18n: "global.navigation.admin.features.sidebar-branding, BRAND__POWERED_BY",
            dgat: "global.navigation.admin.features.sidebar-branding"
        },
        switcher: {
            enabled: true,
            visible: true,
            text: "Show Learner View",
            i18n: "global.navigation.admin.features.show-learner-view, LEARNER__SHOW_VIEW",
            dgat: "global.navigation.admin.features.show-learner-view",
            analytics: "global.navigation.admin.features.show-learner-view",
            href: "/<user>/dashboard"
        },
        search: {
            enabled: false,
            visible: false
        },
        addContent: {
            enabled: false,
            visible: false
        }
    },
    navigation: {
        top: [
            {
                headerTitle: "Insights",
                headerTitleI18n: "global.navigation.admin.sidebar.dashboard, INSIGHT__PLURAL",
                text: "Insights",
                i18n: "global.navigation.admin.sidebar.dashboard, INSIGHT__PLURAL",
                dgat: "global.navigation.admin.sidebar.dashboard",
                analytics: "global.navigation.admin.sidebar.dashboard",
                icon: "presentation-chart-line",
                children: [
                    {
                        text: "Learning",
                        i18n: "global.navigation.admin.sidebar.dashboard.learning, GENERIC__LEARNING",
                        dgat: "global.navigation.admin.sidebar.dashboard.learning",
                        analytics: "global.navigation.admin.sidebar.dashboard.learning",
                        href: "/orgs/<orgId>/insights/learning"
                    },
                    {
                        text: "Skills",
                        i18n: "global.navigation.admin.sidebar.dashboard.skills, GENERIC__SKILL__PLURAL",
                        dgat: "global.navigation.admin.sidebar.dashboard.skills",
                        analytics: "global.navigation.admin.sidebar.dashboard.skills",
                        href: "/orgs/<orgId>/insights/skills"
                    },
                    {
                        text: "Skill Trends",
                        i18n: "global.navigation.admin.sidebar.dashboard.skill-trends, NAV__SKILL_TRENDS",
                        dgat: "global.navigation.admin.sidebar.dashboard.skill-trends",
                        analytics: "global.navigation.admin.sidebar.dashboard.skill-trends",
                        href: "/orgs/<orgId>/insights/skill-trends"
                    }
                ]
            },
            {
                headerTitle: "People",
                headerTitleI18n: "global.navigation.admin.sidebar.people, GENERIC__PEOPLE",
                text: "People",
                i18n: "global.navigation.admin.sidebar.people, GENERIC__PEOPLE",
                dgat: "global.navigation.admin.sidebar.people",
                analytics: "global.navigation.admin.sidebar.people",
                icon: "users",
                children: [
                    {
                        text: "Users",
                        i18n: "global.navigation.admin.sidebar.people.users, USER__PLURAL",
                        dgat: "global.navigation.admin.sidebar.people.users",
                        analytics: "global.navigation.admin.sidebar.people.users",
                        href: "/orgs/<orgId>/members/users"
                    },
                    {
                        text: "Groups",
                        i18n: "global.navigation.admin.sidebar.people.groups, NAV__GROUPS",
                        dgat: "global.navigation.admin.sidebar.people.groups",
                        analytics: "global.navigation.admin.sidebar.people.groups",
                        href: "/orgs/<orgId>/groups"
                    },
                    {
                        text: "Segments",
                        i18n: "global.navigation.admin.sidebar.people.segments, NAV__SEGMENTS",
                        dgat: "global.navigation.admin.sidebar.people.segments",
                        analytics: "global.navigation.admin.sidebar.people.segments",
                        href: "/orgs/<orgId>/members/segments"
                    },
                    {
                        text: "User Attributes",
                        i18n: "global.navigation.admin.sidebar.people.user-attributes, NAV__USER_ATTRIBUTES",
                        dgat: "global.navigation.admin.sidebar.people.user-attributes",
                        analytics: "global.navigation.admin.sidebar.people.user-attributes",
                        href: "/orgs/<orgId>/members/attributes"
                    },
                    {
                        text: "Permissions",
                        i18n: "global.navigation.admin.sidebar.people.permissions, PERMISSION__PLURAL",
                        dgat: "global.navigation.admin.sidebar.people.permissions",
                        analytics: "global.navigation.admin.sidebar.people.permissions",
                        href: "/orgs/<orgId>/settings/permissions"
                    }
                ]
            },
            {
                headerTitle: "Catalog",
                headerTitleI18n: "global.navigation.admin.sidebar.catalog, NAV__CATALOG",
                text: "Catalog",
                i18n: "global.navigation.admin.sidebar.catalog",
                dgat: "global.navigation.admin.catalog",
                analytics: "global.navigation.admin.catalog",
                icon: "book-open",
                children: [
                    {
                        text: "Content",
                        i18n: "global.navigation.admin.sidebar.catalog.content, CONTENT",
                        dgat: "global.navigation.admin.sidebar.catalog.content",
                        analytics: "global.navigation.admin.sidebar.catalog.content",
                        href: "/orgs/<orgId>/content"
                    },
                    {
                        text: "Academies",
                        i18n: "global.navigation.admin.sidebar.catalog.academies, ACADEMY__PLURAL",
                        dgat: "global.navigation.admin.sidebar.catalog.academies",
                        analytics: "global.navigation.admin.sidebar.catalog.academies",
                        routerLink: "/admin/academies?lxpAdmin=true"
                    },
                    {
                        text: "Pathways",
                        i18n: "global.navigation.admin.sidebar.catalog.pathways, NAV__PATHWAYS",
                        dgat: "global.navigation.admin.sidebar.catalog.pathways",
                        analytics: "global.navigation.admin.sidebar.catalog.pathways",
                        href: "/orgs/<orgId>/pathways"
                    },
                    {
                        text: "Plans",
                        i18n: "global.navigation.admin.sidebar.catalog.plans, NAV__PLANS",
                        dgat: "global.navigation.admin.sidebar.catalog.plans",
                        analytics: "global.navigation.admin.sidebar.catalog.plans",
                        href: "/orgs/<orgId>/plans"
                    },
                    {
                        text: "Skill-Dev",
                        i18n: "global.navigation.admin.sidebar.catalog.skill-dev, OrganizationsController_JobRoles",
                        dgat: "global.navigation.admin.sidebar.catalog.skill-dev",
                        analytics: "global.navigation.admin.sidebar.catalog.skill-dev",
                        href: "/orgs/<orgId>/skill-dev"
                    }
                ]
            },
            {
                headerTitle: "Skills",
                headerTitleI18n: "global.navigation.admin.sidebar.skills, GENERIC__SKILL__PLURAL",
                text: "Skills",
                i18n: "global.navigation.admin.sidebar.skills, GENERIC__SKILL__PLURAL",
                dgat: "global.navigation.admin.sidebar.skills",
                analytics: "global.navigation.admin.sidebar.skills",
                icon: "tag",
                children: [
                    {
                        text: "Dashboard",
                        i18n: "global.navigation.admin.sidebar.skills.dashboard, NAV__DASHBOARD",
                        dgat: "global.navigation.admin.sidebar.skills.dashboard",
                        analytics: "global.navigation.admin.sidebar.skills.dashboard",
                        href: "/orgs/<orgId>/skills-platform/dashboard"
                    },
                    {
                        text: "Inventory",
                        i18n: "global.navigation.admin.sidebar.skills.inventory, NAV__INVENTORY",
                        dgat: "global.navigation.admin.sidebar.skills.inventory",
                        analytics: "global.navigation.admin.sidebar.skills.inventory",
                        href: "/orgs/<orgId>/skills-platform/skill-inventory"
                    },
                    {
                        text: "Scales",
                        i18n: "global.navigation.admin.sidebar.skills.scales, NAV__SCALES",
                        dgat: "global.navigation.admin.sidebar.skills.scales",
                        analytics: "global.navigation.admin.sidebar.skills.scales",
                        href: "/skillsplatform/scales"
                    },
                    {
                        text: "Org Skills",
                        i18n: "global.navigation.admin.sidebar.skills.skill-list, NAV__ORG_SKILLS",
                        dgat: "global.navigation.admin.sidebar.skills.skill-list",
                        analytics: "global.navigation.admin.sidebar.skills.skill-list",
                        href: "/orgs/<orgId>/skills/list"
                    },
                    {
                        text: "Roles",
                        i18n: "global.navigation.admin.sidebar.skills.roles, NAV__ROLES",
                        dgat: "global.navigation.admin.sidebar.skills.roles",
                        analytics: "global.navigation.admin.sidebar.skills.roles",
                        href: "/orgs/<orgId>/skills/roles"
                    },
                    {
                        text: "Skill Standards",
                        i18n: "global.navigation.admin.sidebar.skills.skill-standards, NAV__SKILL_STANDARDS",
                        dgat: "global.navigation.admin.sidebar.skills.skill-standards",
                        analytics: "global.navigation.admin.sidebar.skills.skill-standards",
                        href: "/orgs/<orgId>/skills/skillstandards"
                    },
                    {
                        text: "Publish",
                        i18n: "global.navigation.admin.sidebar.skills.publish",
                        dgat: "global.navigation.admin.sidebar.skills.publish",
                        analytics: "global.navigation.admin.sidebar.skills.publish",
                        href: "/orgs/<orgId>/skills-platform/publish-skills"
                    },
                    {
                        text: "Settings",
                        i18n: "global.navigation.admin.sidebar.skills.settings, SETTING__PLURAL",
                        dgat: "global.navigation.admin.sidebar.skills.settings",
                        analytics: "global.navigation.admin.sidebar.skills.settings",
                        href: "/orgs/<orgId>/skills/settings"
                    }
                ]
            },
            {
                headerTitle: "Content Marketplace",
                headerTitleI18n: "global.navigation.admin.sidebar.content-marketplace, CONTENT_MARKETPLACE",
                text: "Content Marketplace",
                i18n: "global.navigation.admin.sidebar.content-marketplace, CONTENT_MARKETPLACE",
                dgat: "global.navigation.admin.sidebar.content-marketplace",
                analytics: "global.navigation.admin.sidebar.content-marketplace",
                icon: "building-storefront",
                routerLink: "/admin/programs"
            },
            {
                headerTitle: "Automations",
                headerTitleI18n: "global.navigation.admin.sidebar.automations, NAV__AUTOMATIONS",
                text: "Automations",
                i18n: "global.navigation.admin.sidebar.automations, NAV__AUTOMATIONS",
                dgat: "global.navigation.admin.sidebar.automations",
                analytics: "global.navigation.admin.sidebar.automations",
                icon: "bolt",
                href: "/orgs/<orgId>/automations"
            },
            {
                headerTitle: "Reporting",
                headerTitleI18n: "global.navigation.admin.sidebar.reporting, NAV__REPORTING",
                text: "Reporting",
                i18n: "global.navigation.admin.sidebar.reporting, NAV__REPORTING",
                dgat: "global.navigation.admin.sidebar.reporting",
                analytics: "global.navigation.admin.sidebar.reporting",
                icon: "document-chart-bar",
                children: [
                    {
                        text: "Reports",
                        i18n: "global.navigation.admin.sidebar.reporting.reports, REPORT__PLURAL",
                        dgat: "global.navigation.admin.sidebar.reporting.reports",
                        analytics: "global.navigation.admin.sidebar.reporting.reports",
                        href: "/orgs/<orgId>/reporting"
                    },
                    {
                        text: "Presets",
                        i18n: "global.navigation.admin.sidebar.reporting.presets, NAV__PRESETS",
                        dgat: "global.navigation.admin.sidebar.reporting.presets",
                        analytics: "global.navigation.admin.sidebar.reporting.presets",
                        href: "/orgs/<orgId>/reporting/presets"
                    },
                    {
                        text: "Categories",
                        i18n: "global.navigation.admin.sidebar.reporting.categories, NAV__CATEGORIES",
                        dgat: "global.navigation.admin.sidebar.reporting.categories",
                        analytics: "global.navigation.admin.sidebar.reporting.categories",
                        href: "/orgs/<orgId>/reporting/create"
                    },
                    {
                        text: "FTP",
                        i18n: "global.navigation.admin.sidebar.reporting.ftp, NAV__FTP",
                        dgat: "global.navigation.admin.sidebar.reporting.ftp",
                        analytics: "global.navigation.admin.sidebar.reporting.ftp",
                        href: "/orgs/<orgId>/reporting/reportSchedule"
                    },
                    {
                        text: "Configurations",
                        i18n: "global.navigation.admin.sidebar.reporting.configurations, NAV__CONFIGURATIONS",
                        dgat: "global.navigation.admin.sidebar.reporting.configurations",
                        analytics: "global.navigation.admin.sidebar.reporting.configurations",
                        href: "/orgs/<orgId>/reporting/configurations"
                    },
                    {
                        text: "Segments",
                        i18n: "global.navigation.admin.sidebar.reporting.segments, NAV__SEGMENTS",
                        dgat: "global.navigation.admin.sidebar.reporting.segments",
                        analytics: "global.navigation.admin.sidebar.reporting.segments",
                        href: "/orgs/<orgId>/reporting/segments"
                    },
                    {
                        text: "Advanced Analytics",
                        i18n: "global.navigation.admin.sidebar.reporting.advanced-analytics, NAV__ADVANCED_ANALYTICS",
                        dgat: "global.navigation.admin.sidebar.reporting.advanced-analytics",
                        analytics: "global.navigation.admin.sidebar.reporting.advanced-analytics",
                        href: "/analytics?tag=1",
                        target: "_blank"
                    }
                ]
            },
            {
                headerTitle: "Integrations",
                headerTitleI18n: "global.navigation.admin.sidebar.integrations, INTEGRATION__PLURAL",
                text: "Integrations",
                i18n: "global.navigation.admin.sidebar.integrations, INTEGRATION__PLURAL",
                dgat: "global.navigation.admin.sidebar.integrations",
                analytics: "global.navigation.admin.sidebar.integrations",
                icon: "puzzle-piece",
                children: [
                    {
                        text: "Connected",
                        i18n: "global.navigation.admin.sidebar.integrations.connected, NAV__CONNECTED",
                        dgat: "global.navigation.admin.sidebar.integrations.connected",
                        analytics: "global.navigation.admin.sidebar.integrations.connected",
                        href: "/orgs/<orgId>/settings/integrationProviders"
                    },
                    {
                        text: "Directory",
                        i18n: "global.navigation.admin.sidebar.integrations.directory, NAV__DIRECTORY",
                        dgat: "global.navigation.admin.sidebar.integrations.directory",
                        analytics: "global.navigation.admin.sidebar.integrations.directory",
                        href: "https://integrations.degreed.com/?host=degreedstg.staging.degreed.dev",
                        target: "_blank"
                    },
                    {
                        text: "API Keys",
                        i18n: "global.navigation.admin.sidebar.integrations.api-keys, NAV__API_KEYS",
                        dgat: "global.navigation.admin.sidebar.integrations.api-keys",
                        analytics: "global.navigation.admin.sidebar.integrations.api-keys",
                        href: "/orgs/<orgId>/settings/manageCredentials"
                    },
                    {
                        text: "File Upload",
                        i18n: "global.navigation.admin.sidebar.integrations.file-upload, NAV__FILE_UPLOAD",
                        dgat: "global.navigation.admin.sidebar.integrations.file-upload",
                        analytics: "global.navigation.admin.sidebar.integrations.file-upload",
                        href: "/orgs/<orgId>/fileupload/uploadFile"
                    },
                    {
                        text: "File Log",
                        i18n: "global.navigation.admin.sidebar.integrations.file-log, NAV__FILE_LOG",
                        dgat: "global.navigation.admin.sidebar.integrations.file-log",
                        analytics: "global.navigation.admin.sidebar.integrations.file-log",
                        href: "/orgs/<orgId>/fileupload/fileLog"
                    },
                    {
                        text: "Webooks",
                        i18n: "global.navigation.admin.sidebar.integrations.webhooks, Webhooks_Heading",
                        dgat: "global.navigation.admin.sidebar.integrations.webhooks",
                        analytics: "global.navigation.admin.sidebar.integrations.webhooks",
                        href: "/orgs/<orgId>/webhooks"
                    }
                ]
            },
            {
                headerTitle: "Settings",
                headerTitleI18n: "global.navigation.admin.sidebar.settings, SETTING__PLURAL",
                text: "Settings",
                i18n: "global.navigation.admin.sidebar.settings, SETTING__PLURAL",
                dgat: "global.navigation.admin.sidebar.settings",
                analytics: "global.navigation.admin.sidebar.settings",
                icon: "cog-6-tooth",
                children: [
                    {
                        text: "Branding",
                        i18n: "global.navigation.admin.sidebar.settings.branding, BRAND__BRANDING",
                        dgat: "global.navigation.admin.sidebar.settings.branding",
                        analytics: "global.navigation.admin.sidebar.settings.branding",
                        href: "/orgs/<orgId>/settings/branding"
                    },
                    {
                        text: "Home",
                        i18n: "global.navigation.admin.sidebar.settings.home, GENERIC__HOME",
                        dgat: "global.navigation.admin.sidebar.settings.home",
                        analytics: "global.navigation.admin.sidebar.settings.home",
                        href: "/orgs/<orgId>/settings/home/insights"
                    },
                    {
                        text: "Help Menu",
                        i18n: "global.navigation.admin.sidebar.settings.help-menu, NAV__HELP_MENU",
                        dgat: "global.navigation.admin.sidebar.settings.help-menu",
                        analytics: "global.navigation.admin.sidebar.settings.help-menu",
                        href: "/orgs/<orgId>/settings/helpMenu"
                    },
                    {
                        text: "Communication",
                        i18n: "global.navigation.admin.sidebar.settings.communication, SKILL__COMMUNICATION",
                        dgat: "global.navigation.admin.sidebar.settings.communication",
                        analytics: "global.navigation.admin.sidebar.settings.communication",
                        href: "/orgs/<orgId>/settings/communications"
                    },
                    {
                        text: "FAQ",
                        i18n: "global.navigation.admin.sidebar.settings.faq, NAV__FREQUENTLY_ASKED_QUESTIONS",
                        dgat: "global.navigation.admin.sidebar.settings.faq",
                        analytics: "global.navigation.admin.sidebar.settings.faq",
                        href: "/orgs/<orgId>/settings/faq"
                    },
                    {
                        text: "Messaging",
                        i18n: "global.navigation.admin.sidebar.settings.messaging, NAV__MESSAGING",
                        dgat: "global.navigation.admin.sidebar.settings.messaging",
                        analytics: "global.navigation.admin.sidebar.settings.messaging",
                        href: "/orgs/<orgId>/settings/messaging"
                    },
                    {
                        text: "Security",
                        i18n: "global.navigation.admin.sidebar.settings.security, NAV__SECURITY",
                        dgat: "global.navigation.admin.sidebar.settings.security",
                        analytics: "global.navigation.admin.sidebar.settings.security",
                        href: "/orgs/<orgId>/settings/security"
                    }
                ]
            },
            {
                headerTitle: "Extended Enterprise",
                headerTitleI18n: "global.navigation.admin.sidebar.extended-enterprise, NAV__EXTENDED_ENTERPRISE",
                text: "Extended Enterprise",
                i18n: "global.navigation.admin.sidebar.extended-enterprise, NAV__EXTENDED_ENTERPRISE",
                dgat: "global.navigation.admin.sidebar.extended-enterprise",
                analytics: "global.navigation.admin.sidebar.extended-enterprise",
                icon: "building-office-2",
                href: "/channel"
            },
            {
                headerTitle: "Help",
                headerTitleI18n: "global.navigation.admin.sidebar.help, SUPPORT__HELP",
                text: "Help",
                i18n: "global.navigation.admin.sidebar.help, SUPPORT__HELP",
                dgat: "global.navigation.admin.sidebar.help",
                analytics: "global.navigation.admin.sidebar.help",
                icon: "lifebuoy",
                children: [
                    {
                        text: "Knowledge Center",
                        i18n: "global.navigation.admin.sidebar.help.knowledge-center, GENERIC__KNOWLEDGE_CENTER",
                        dgat: "global.navigation.admin.sidebar.help.knowledge-center",
                        analytics: "global.navigation.admin.sidebar.help.knowledge-center",
                        href: "/orgs/<orgId>/settings/helpMenu",
                        target: "_blank"
                    },
                    {
                        text: "Privacy Policy",
                        i18n: "global.navigation.admin.sidebar.help.privacy-policy, NAV__PRIVACY_POLICY",
                        dgat: "global.navigation.admin.sidebar.help.privacy-policy",
                        analytics: "global.navigation.admin.sidebar.help.privacy-policy",
                        href: "/about/privacy",
                        target: "_blank"
                    },
                    {
                        text: "Cookie Notice",
                        i18n: "global.navigation.admin.sidebar.help.cookie-notice, NAV__COOKIE_NOTICE",
                        dgat: "global.navigation.admin.sidebar.help.cookie-notice",
                        analytics: "global.navigation.admin.sidebar.help.cookie-notice",
                        href: "/api/about/cookienotice",
                        target: "_blank"
                    },
                    {
                        text: "Frequently Asked Questions",
                        i18n: "global.navigation.admin.sidebar.help.faq, NAV__FAQ",
                        dgat: "global.navigation.admin.sidebar.help.faq",
                        analytics: "global.navigation.admin.sidebar.help.faq",
                        href: "/orgs/<orgId>/settings/faq",
                        target: "_blank",
                        includeSeparator: true
                    },
                    {
                        text: "",
                        dgat: "global.navigation.admin.sidebar.help.custom-link",
                        analytics: "global.navigation.admin.sidebar.help.custom-link",
                        href: "#"
                    },
                    {
                        text: "",
                        dgat: "global.navigation.admin.sidebar.help.support-phone",
                        analytics: "global.navigation.admin.sidebar.help.support-phone",
                        icon: "phone",
                        href: "#",
                        includeSeparator: true
                    },
                    {
                        text: "",
                        dgat: "global.navigation.admin.sidebar.help.support-email",
                        analytics: "global.navigation.admin.sidebar.help.support-email",
                        icon: "envelope",
                        href: "#"
                    }
                ]
            }
        ],
        bottom: []
    }
};
var LxpToAcmConfig = {
    admin: admin$2
};

var learner = {
    brand: {
        routerLink: "/user",
        mark: {
            url: "data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' fill='%230062E3' xmlns='http://www.w3.org/2000/svg' %3E%3Cpath class='logo' fill-rule='evenodd' clip-rule='evenodd' d='M28.2624 15.1156L20.2595 10.6838L19.9913 10.5263C19.7677 10.4363 19.5219 10.3913 19.276 10.3913C19.0301 10.3913 18.7842 10.4363 18.5606 10.5263L18.2477 10.7063L16.9958 11.4037C16.9735 11.4262 16.9735 11.4486 16.9958 11.4711L17.51 11.7411L20.5278 13.4059L22.3161 14.3957C22.3161 14.3957 19.6783 14.5082 17.2417 15.9255C16.7946 16.1954 16.2805 16.3304 15.7663 16.3304H15.6545C15.1404 16.3304 14.6262 16.1954 14.1792 15.9255C11.7425 14.5082 9.10472 14.3957 9.10472 14.3957L15.6993 10.7288L18.0465 9.40145C18.2924 9.26647 19.1418 8.72656 20.1031 9.01901C20.5278 9.13149 21.2431 9.53643 21.8244 9.87388C22.2938 10.1438 22.875 10.0539 23.2327 9.62642C23.4115 9.40145 23.5009 9.15399 23.5009 8.88403C23.5009 8.50159 23.3221 8.14164 22.9644 7.91668C22.2044 7.44425 21.1537 6.88183 20.3043 6.74685C18.1135 6.36441 16.7276 7.44425 15.6769 8.00666C14.8721 7.35426 13.2403 6.38691 11.0719 6.74685C10.2001 6.90433 9.17179 7.44425 8.41174 7.91668C7.83052 8.27662 7.6964 9.0865 8.14348 9.60392C8.36703 9.85139 8.67999 9.98637 8.99295 9.98637C9.19414 9.98637 9.37297 9.94137 9.55181 9.82889C10.133 9.49144 10.8484 9.0865 11.2731 8.97402C12.4132 8.65907 13.3968 9.40145 13.3968 9.40145L3.0914 15.1156C2.82315 15.2506 2.66667 15.543 2.66667 15.8355V17.2528C2.66667 17.5452 2.82315 17.8152 3.0914 17.9727C3.35965 18.1076 3.42672 18.1976 3.42672 18.7151C3.42672 19.6149 2.82315 24.5417 9.21649 24.5417C14.9616 24.5417 14.2462 18.895 15.6769 18.9175C17.1299 18.895 16.4146 24.5417 22.1373 24.5417C28.5307 24.5417 27.9271 19.6149 27.9271 18.7151C27.9271 18.1976 27.9718 18.1301 28.24 17.9727C28.5083 17.8377 28.6648 17.5452 28.6648 17.2528V15.8355C28.6871 15.5205 28.5083 15.2506 28.2624 15.1156ZM12.1896 21.0997C11.5637 22.427 10.4683 22.6295 8.88118 22.562C7.6964 22.517 6.60103 22.1345 6.04218 21.4821C5.23742 20.5598 5.32684 17.7927 5.6398 17.1853C6.24336 16.0155 11.7872 16.3754 12.5249 17.8602C12.6144 18.0177 13.1062 19.1875 12.1896 21.0997ZM25.3116 21.4821C24.7528 22.1121 23.6574 22.4945 22.4726 22.562C20.9078 22.6295 19.8125 22.427 19.1642 21.0997C18.2477 19.1875 18.7394 18.0177 18.8065 17.8602C19.5442 16.3754 25.1104 16.0155 25.6917 17.1853C26.027 17.8152 26.1164 20.5823 25.3116 21.4821Z' /%3E%3C/svg%3E",
            altText: "Degreed logo"
        },
        logo: {
            url: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='268' height='54' viewBox='0 0 134 27' fill='none'%3E%3Cpath d='M27.344 18.1522C26.3963 18.9499 25.2299 19.4576 23.9176 19.4576C22.0222 19.5301 20.7099 19.3125 19.9809 17.717C18.8874 15.4688 19.4706 14.0909 19.5435 13.8733C20.4183 12.1327 27.1253 11.6976 27.7814 13.0756C28.2188 13.8008 28.3647 17.1369 27.344 18.1522ZM11.6701 17.717C10.9411 19.3125 9.62883 19.5301 7.73337 19.4576C6.49404 19.4576 5.2547 19.0225 4.30698 18.1522C3.35925 17.0643 3.43215 13.8008 3.79666 13.0756C4.52568 11.6976 11.1598 12.1327 12.0346 13.8733C12.1804 14.0909 12.7636 15.4688 11.6701 17.717ZM30.9162 10.6098L21.2932 5.38809L21.0015 5.17052C20.4183 4.95295 19.8351 4.95295 19.3248 5.17052L18.9603 5.38809L17.4293 6.25837V6.33089L18.0126 6.62099L21.6577 8.57911L23.7718 9.73949C21.6577 9.88453 19.5435 10.5372 17.721 11.5526C17.2106 11.8427 16.5545 12.0602 15.9713 12.0602H15.8255C15.1694 12.0602 14.5862 11.9152 14.0759 11.5526C12.1804 10.5372 10.1391 9.88453 8.02498 9.73949L15.8984 5.38809L18.7416 3.79258C19.4706 3.28492 20.3454 3.13987 21.2203 3.35744C21.9493 3.64754 22.6054 3.93763 23.2615 4.37277C23.5531 4.51782 23.8447 4.59034 24.1363 4.51781C24.4279 4.44529 24.6466 4.30025 24.8654 4.08268C25.0841 3.86511 25.157 3.50249 25.157 3.2124C25.157 2.77726 24.9383 2.34212 24.5008 2.05203C23.5531 1.39932 22.4596 0.964178 21.2932 0.674086C18.6687 0.238946 16.9919 1.47184 15.7526 2.19707C14.2217 0.96418 12.1804 0.383993 10.212 0.674086C9.04561 0.964178 8.02498 1.39932 7.00435 2.05203C6.42114 2.48717 6.20243 3.28492 6.63984 3.86511C6.63984 3.93763 6.71274 3.93763 6.71274 4.01015C7.00435 4.30025 7.36886 4.44529 7.73337 4.44529C7.95208 4.44529 8.17079 4.37277 8.38949 4.22772C9.04561 3.86511 9.70173 3.50249 10.4307 3.2124C11.3056 2.99483 12.2533 3.2124 12.9823 3.72006L0.807678 10.6098C0.51607 10.7548 0.297363 11.1174 0.297363 11.48V13.1481C0.297363 13.5107 0.51607 13.8733 0.807678 14.0183C1.09929 14.1634 1.17219 14.3084 1.17219 14.8886C1.17219 15.9765 0.443168 21.7783 8.09788 21.7783C14.9507 21.7783 14.1488 15.1062 15.8255 15.1062C17.5022 15.1062 16.7003 21.7783 23.5531 21.7783C31.2078 21.7783 30.4788 15.9765 30.4788 14.8886C30.4788 14.3084 30.5517 14.1634 30.8433 14.0183C31.2078 13.8733 31.4265 13.5107 31.4265 13.1481V11.48C31.4994 11.1174 31.2807 10.7548 30.9162 10.6098Z' fill='%230062E3'/%3E%3Cpath d='M70.1374 14.8887C70.2103 14.236 70.5019 13.6558 71.0122 13.2206C71.7413 12.6405 72.6161 12.3504 73.5638 12.4229C74.4386 12.3504 75.3135 12.6405 75.9696 13.2206C76.4799 13.6558 76.7715 14.3085 76.8444 14.9612V15.759C76.8444 16.4117 76.6257 17.0644 76.1883 17.572C76.1154 17.6446 76.0425 17.7896 75.8967 17.8621C75.6051 18.1522 75.1677 18.3698 74.8031 18.5148C74.3657 18.6599 73.8554 18.7324 73.3451 18.7324C72.4703 18.8049 71.5954 18.5148 70.9393 17.8621C70.8664 17.7896 70.7206 17.7171 70.6477 17.572C70.2103 16.9919 69.9916 16.2666 70.0645 15.5414C70.0645 15.3238 70.0645 15.1063 70.1374 14.8887ZM79.6876 10.2472H77.2818C77.2089 10.2472 77.136 10.3197 77.0631 10.3922C76.9902 10.4648 76.9902 10.5373 76.9902 10.6098V11.7702C76.5528 11.19 75.8967 10.6823 75.2406 10.3922C74.4386 10.1021 73.6367 9.9571 72.7619 9.9571C71.6684 9.9571 70.6477 10.1747 69.7 10.6823C68.8252 11.1175 68.1691 11.8427 67.6587 12.713C67.1484 13.5833 66.9297 14.5986 66.9297 15.6139C66.9297 16.5567 67.1484 17.4995 67.5129 18.3698L67.6587 18.5148C68.0962 19.3126 68.8252 19.9653 69.6271 20.473C69.9916 20.6905 70.429 20.8356 70.8664 20.9806C71.3768 21.1257 71.8871 21.1982 72.4703 21.1257C73.0535 21.1257 73.6367 21.0532 74.2199 20.9806C74.5115 20.9081 74.8031 20.7631 75.0947 20.6905C75.8238 20.4004 76.4799 19.8928 76.9902 19.3126V21.0532C76.9902 21.5608 76.8444 22.0685 76.5528 22.5036C76.2612 22.9388 75.8238 23.3014 75.3135 23.5189C74.9489 23.664 74.5844 23.809 74.2199 23.809C73.9283 23.809 73.7096 23.8816 73.418 23.8816C71.8142 23.8816 70.7935 23.4464 70.2832 22.5036C70.2832 22.4311 70.2103 22.3586 70.1374 22.3586H67.5858C67.44 22.3586 67.2942 22.5036 67.2942 22.6487V22.7212C67.5858 23.809 68.242 24.6793 69.1897 25.332C70.5019 26.0573 71.96 26.3473 73.4909 26.2748C74.6573 26.3473 75.8238 26.0572 76.9173 25.6221C76.9902 25.6221 76.9902 25.5496 77.0631 25.5496C77.5734 25.332 78.0108 25.0419 78.3753 24.6793C79.396 23.7365 79.9792 22.4311 80.0521 21.0532C80.125 20.618 80.125 20.1829 80.125 19.8203V10.6098C80.0521 10.3922 79.9063 10.2472 79.6876 10.2472ZM130.427 16.1216C130.427 16.9193 130.136 17.7171 129.553 18.2247C129.261 18.5148 128.824 18.8049 128.386 18.95C127.949 19.095 127.438 19.2401 127.001 19.2401C126.126 19.3126 125.178 18.95 124.595 18.3698C123.939 17.7171 123.648 16.7743 123.72 15.8315C123.648 14.8887 123.939 13.9459 124.595 13.2206C125.324 12.5679 126.199 12.2778 127.147 12.3504C128.022 12.2778 128.969 12.6405 129.553 13.2206C129.844 13.5107 130.063 13.8734 130.209 14.236C130.354 14.6711 130.427 15.0337 130.427 15.4689V16.1216ZM133.198 6.25842H130.719C130.646 6.25842 130.573 6.25842 130.5 6.33094C130.427 6.40347 130.427 6.47599 130.427 6.54852V11.6251C129.407 10.3922 127.876 9.73954 126.272 9.81206C125.178 9.81206 124.158 10.0296 123.21 10.6098C122.335 11.1175 121.606 11.8427 121.169 12.713C120.659 13.6558 120.44 14.7436 120.513 15.8315C120.513 16.9193 120.731 17.9347 121.169 18.8775C121.606 19.7477 122.262 20.4004 123.137 20.9081C124.012 21.4158 124.96 21.6333 125.98 21.6333C126.928 21.6333 127.803 21.4883 128.605 21.1257C129.407 20.8356 130.063 20.2554 130.5 19.6027V20.9806C130.5 21.1982 130.646 21.3432 130.865 21.3432H133.271C133.489 21.3432 133.635 21.1982 133.635 20.9806V6.62104C133.635 6.54852 133.635 6.40347 133.562 6.40347C133.416 6.33095 133.343 6.25842 133.198 6.25842ZM108.921 14.5986C108.994 13.8734 109.359 13.2206 109.942 12.858C110.598 12.3504 111.4 12.1328 112.202 12.1328C113.077 12.0603 113.879 12.2778 114.608 12.7855C115.191 13.2206 115.555 13.8734 115.482 14.5986H108.921ZM116.941 11.4076C115.628 10.3922 113.952 9.81206 112.275 9.9571C111.108 9.9571 109.942 10.1747 108.848 10.7549C107.901 11.2625 107.099 11.9878 106.588 12.9306C106.078 13.8734 105.787 14.9612 105.787 16.0491C105.714 17.6446 106.297 19.1676 107.463 20.2554C108.775 21.3432 110.452 21.8509 112.202 21.7784C113.66 21.8509 115.118 21.5608 116.43 20.8356C117.378 20.2554 118.034 19.3851 118.326 18.2973C118.399 18.1522 118.326 18.0072 118.18 18.0072H115.628C115.555 18.0072 115.41 18.0797 115.41 18.1522C114.972 19.0225 113.952 19.5302 112.421 19.5302C111.837 19.5302 111.181 19.3851 110.598 19.1676C110.088 18.95 109.723 18.5874 109.359 18.1522C109.067 17.7171 108.921 17.2094 108.921 16.7018H118.18C118.326 16.7018 118.399 16.6292 118.471 16.5567C118.544 16.4842 118.617 16.3391 118.617 16.2666V15.6864C118.69 14.0909 118.034 12.5679 116.941 11.4076ZM94.4138 14.5986C94.4867 13.8734 94.8512 13.2206 95.4344 12.858C96.0905 12.3504 96.8925 12.1328 97.6944 12.1328C98.5692 12.0603 99.3711 12.2778 100.1 12.7855C100.683 13.2206 101.048 13.8734 100.975 14.5986H94.4138ZM102.36 11.4076C101.048 10.3922 99.3711 9.81206 97.6944 9.9571C96.5279 9.9571 95.3615 10.1747 94.268 10.7549C93.3203 11.2625 92.5183 11.9878 92.008 12.9306C91.4977 13.8734 91.2061 14.9612 91.2061 16.0491C91.1332 17.6446 91.7164 19.1676 92.8829 20.2554C94.1951 21.3432 95.8718 21.8509 97.6215 21.7784C99.0795 21.8509 100.538 21.5608 101.85 20.8356C102.798 20.2554 103.454 19.3851 103.745 18.2973C103.818 18.1522 103.745 18.0072 103.599 18.0072H101.048C100.975 18.0072 100.829 18.0797 100.829 18.1522C100.392 19.0225 99.3711 19.5302 97.8402 19.5302C97.257 19.5302 96.6009 19.3851 96.0176 19.1676C95.5073 18.95 95.1428 18.5874 94.7783 18.1522C94.4867 17.7171 94.3409 17.2094 94.3409 16.7018H103.599C103.745 16.7018 103.818 16.6292 103.891 16.5567C103.964 16.4842 104.037 16.3391 104.037 16.2666V15.6864C104.11 14.0909 103.527 12.5679 102.36 11.4076ZM89.8939 10.1022C88.29 10.1022 86.832 10.8274 85.8114 12.0603V10.6098C85.8114 10.5373 85.8114 10.4648 85.7384 10.3922C85.6655 10.3197 85.5926 10.3197 85.5197 10.2472H83.114C82.8953 10.2472 82.7495 10.3922 82.7495 10.6098V21.0532C82.7495 21.2707 82.8953 21.4158 83.114 21.4158H85.5926C85.8114 21.4158 85.9572 21.2707 85.9572 21.0532V15.5414C85.9572 14.8162 86.3217 14.0909 86.9049 13.5833C87.6339 13.0031 88.5816 12.6405 89.5294 12.713H89.9668C90.1855 12.713 90.4042 12.5679 90.4042 12.3504V10.4648C90.4042 10.3922 90.3313 10.2472 90.2584 10.1747C90.1855 10.1022 90.1126 10.0296 89.9668 10.0296H89.8939V10.1022ZM55.4112 14.6711C55.4841 13.9459 55.8486 13.2932 56.4318 12.9306C57.0879 12.4229 57.8899 12.2053 58.6918 12.2053C59.5666 12.1328 60.3685 12.3504 61.0976 12.858C61.6808 13.2932 61.9724 13.9459 61.9724 14.6711H55.4112ZM63.4304 11.4076C62.1182 10.3197 60.5143 9.81206 58.8376 9.88458C57.6712 9.88458 56.5047 10.1022 55.4112 10.6823C54.4635 11.19 53.6616 11.9152 53.1512 12.858C52.6409 13.8008 52.3493 14.8887 52.3493 15.9765C52.2764 17.572 52.8596 19.095 54.0261 20.1829C55.3383 21.2707 57.015 21.7784 58.7647 21.7059C60.2227 21.7784 61.6808 21.4883 62.993 20.7631C63.9407 20.1829 64.5969 19.3126 64.8885 18.2247C64.9614 18.0797 64.8156 17.9347 64.7427 17.9347H62.1911C62.1182 17.9347 61.9724 18.0072 61.9724 18.0797C61.535 18.95 60.5143 19.4576 58.9105 19.4576C58.3273 19.4576 57.6712 19.3126 57.0879 19.095C56.5776 18.8775 56.2131 18.5148 55.8486 18.0797C55.557 17.6446 55.4112 17.1369 55.4112 16.6292H64.5969C64.7427 16.6292 64.8156 16.5567 64.8885 16.4842C64.9614 16.4117 65.0343 16.2666 65.0343 16.1941V15.6864C65.1072 14.0909 64.524 12.5679 63.4304 11.4076ZM47.1733 16.1216C47.1733 16.4842 47.1004 16.9193 46.9546 17.2819C46.8088 17.6446 46.5901 18.0072 46.2984 18.2973C46.0068 18.5874 45.5694 18.8775 45.132 19.0225C44.6946 19.1675 44.1843 19.3126 43.674 19.3126C42.7991 19.3851 41.8514 19.0225 41.2682 18.4423C40.6121 17.7896 40.3205 16.8468 40.3934 15.9765C40.3205 15.0337 40.6121 14.0909 41.2682 13.3657C41.9972 12.713 42.872 12.4229 43.8198 12.4954C44.6946 12.4229 45.6423 12.7855 46.2255 13.3657C46.5172 13.6558 46.7359 14.0184 46.8817 14.381C47.0275 14.7436 47.1004 15.1788 47.1004 15.6139L47.1733 16.1216ZM49.9435 6.33094H47.4649C47.2462 6.33094 47.1004 6.47599 47.1004 6.69356V11.7702C46.0797 10.5373 44.4759 9.88458 42.872 9.9571C41.7785 9.9571 40.7579 10.1747 39.8102 10.7549C38.9353 11.2625 38.2063 11.9878 37.7689 12.858C36.8212 14.8162 36.8212 17.0644 37.7689 19.0225C38.2063 19.8928 38.8624 20.5455 39.7373 21.0532C40.6121 21.5608 41.5598 21.7784 42.5804 21.7784C43.5282 21.7784 44.403 21.6333 45.2049 21.2707C46.0068 20.9806 46.663 20.4004 47.1004 19.7477V21.1257C47.1004 21.3432 47.2462 21.4883 47.4649 21.4883H49.8706C50.0894 21.4883 50.2352 21.3432 50.2352 21.1257V6.69356C50.2352 6.62104 50.1622 6.54852 50.1622 6.47599C50.1622 6.33095 50.0164 6.33094 49.9435 6.33094Z' fill='%23353C42'/%3E%3C/svg%3E",
            altText: "Degreed logo"
        },
        colors: {
            background: "#ffffff",
            text: "var(--apollo-color-neutral-800)",
            highlight: "var(--apollo-color-blue-800)",
            separator: "var(--apollo-color-neutral-200)"
        },
        text: "Degreed Logo",
        analytics: "global.navigation.learner.brand",
        i18n: "global.navigation.learner.brand, A11Y__DEGREED_LOGO",
        dgat: "global.navigation.learner.brand"
    },
    features: {
        addContent: {
            enabled: true,
            visible: true,
            text: "New Request",
            i18n: "global.navigation.learner.features.new-request, FUND__REQUEST__NEW",
            titleText: "New Request",
            titleI18n: "global.navigation.learner.features.new-request, FUND__REQUEST__NEW",
            dgat: "global.navigation.learner.features.new-request",
            analytics: "global.navigation.learner.features.new-request"
        },
        beta: {
            enabled: true,
            visible: true,
            text: "Beta",
            i18n: "global.navigation.learner.features.beta, GENERIC__BETA",
            dgat: "global.navigation.learner.features.beta"
        },
        footerBranding: {
            enabled: true,
            visible: true,
            text: "Powered by",
            i18n: "global.navigation.learner.features.footer-branding, BRAND__POWERED_BY",
            dgat: "global.navigation.learner.features.footer-branding"
        },
        sidebarBranding: {
            enabled: true,
            visible: true,
            text: "Powered by",
            i18n: "global.navigation.learner.features.sidebar-branding, BRAND__POWERED_BY",
            dgat: "global.navigation.learner.features.sidebar-branding"
        },
        switcher: {
            enabled: true,
            visible: true,
            text: "Show Admin View",
            i18n: "global.navigation.learner.features.show-admin-view, ADMIN__VIEW__SHOW",
            dgat: "global.navigation.learner.features.show-admin-view",
            analytics: "global.navigation.learner.features.show-admin-view",
            routerLink: "/admin"
        }
    },
    navigation: {
        top: [
            {
                headerTitle: "Home",
                headerTitleI18n: "global.navigation.learner.sidebar.home, GENERIC__HOME",
                text: "Home",
                i18n: "global.navigation.learner.sidebar.home, GENERIC__HOME",
                dgat: "global.navigation.learner.sidebar.home",
                analytics: "global.navigation.learner.sidebar.home",
                icon: "home",
                routerLink: "/user/manage"
            },
            {
                headerTitle: "Content Marketplace",
                headerTitleI18n: "global.navigation.learner.sidebar.marketplace, CONTENT_MARKETPLACE",
                text: "Marketplace",
                i18n: "global.navigation.learner.sidebar.marketplace, PROGRAM__MARKETPLACE__SIMPLE",
                dgat: "global.navigation.learner.sidebar.marketplace",
                analytics: "global.navigation.learner.sidebar.marketplace",
                icon: "building-storefront",
                routerLink: "/user/programs"
            },
            {
                headerTitle: "Academies",
                headerTitleI18n: "global.navigation.learner.sidebar.academies, ACADEMY__PLURAL",
                text: "Academies",
                i18n: "global.navigation.learner.sidebar.academies, ACADEMY__PLURAL",
                dgat: "global.navigation.learner.sidebar.academies",
                analytics: "global.navigation.learner.sidebar.academies",
                icon: "building-library",
                routerLink: "/user/academies"
            },
            {
                headerTitle: "Team Insights",
                headerTitleI18n: "global.navigation.learner.sidebar.team-insights, TEAM__INSIGHTS",
                text: "Team Insights",
                i18n: "global.navigation.learner.sidebar.team-insights, TEAM__INSIGHTS",
                dgat: "global.navigation.learner.sidebar.team-insights",
                analytics: "global.navigation.learner.sidebar.team-insights",
                icon: "user-group",
                routerLink: "/manager/team-insights"
            },
            {
                headerTitle: "Approvals",
                headerTitleI18n: "global.navigation.learner.sidebar.approvals, APPROVAL__PLURAL",
                text: "Approvals",
                i18n: "global.navigation.learner.sidebar.approvals, APPROVAL__PLURAL",
                dgat: "global.navigation.learner.sidebar.approvals",
                analytics: "global.navigation.learner.sidebar.approvals",
                icon: "inbox",
                children: [
                    {
                        text: "Programs",
                        i18n: "global.navigation.learner.sidebar.approvals.programs, PROGRAM__PLURAL",
                        dgat: "global.navigation.learner.sidebar.approvals.programs",
                        analytics: "global.navigation.learner.sidebar.approvals.programs",
                        routerLink: "/manager/approvals/program"
                    },
                    {
                        text: "Resources",
                        i18n: "global.navigation.learner.sidebar.approvals.resources, RESOURCE__PLURAL",
                        dgat: "global.navigation.learner.sidebar.approvals.resources",
                        analytics: "global.navigation.learner.sidebar.approvals.resources",
                        routerLink: "/manager/approvals/resource"
                    }
                ]
            },
            {
                headerTitle: "Permissions",
                headerTitleI18n: "global.navigation.learner.sidebar.permissions, PERMISSION__PLURAL",
                text: "Permissions",
                i18n: "global.navigation.learner.sidebar.permissions, PERMISSION__PLURAL",
                dgat: "global.navigation.learner.sidebar.permissions",
                analytics: "global.navigation.learner.sidebar.permissions",
                icon: "lock-closed",
                routerLink: "/user/permissions"
            },
            {
                headerTitle: "Account",
                headerTitleI18n: "global.navigation.learner.sidebar.account, ACCOUNT",
                text: "Account",
                i18n: "global.navigation.learner.sidebar.account, ACCOUNT",
                dgat: "global.navigation.learner.sidebar.account",
                analytics: "global.navigation.learner.sidebar.account",
                image: "data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='0.5' y='0.5' width='23' height='23' rx='11.5' fill='%23F1E6FF'/%3E%3Crect x='0.5' y='0.5' width='23' height='23' rx='11.5' stroke='%23D3B1FF'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M9.75 9C9.75 7.75736 10.7574 6.75 12 6.75C13.2426 6.75 14.25 7.75736 14.25 9C14.25 10.2426 13.2426 11.25 12 11.25C10.7574 11.25 9.75 10.2426 9.75 9Z' fill='%236800EE'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M7.87562 16.0527C7.91429 13.8078 9.74599 12 12 12C14.2541 12 16.0858 13.8079 16.1244 16.0528C16.1269 16.2017 16.0412 16.338 15.9058 16.4001C14.7164 16.9459 13.3933 17.25 12.0002 17.25C10.6069 17.25 9.28372 16.9458 8.09416 16.3999C7.95883 16.3378 7.87306 16.2015 7.87562 16.0527Z' fill='%236800EE'/%3E%3C/svg%3E%0A",
                children: [
                    {
                        text: "Settings",
                        i18n: "global.navigation.learner.sidebar.account.settings, SETTING__PLURAL",
                        dgat: "global.navigation.learner.sidebar.account.settings",
                        analytics: "global.navigation.learner.sidebar.account.settings",
                        routerLink: "/user/settings"
                    },
                    {
                        text: "Logout",
                        i18n: "global.navigation.learner.sidebar.account.logout, ACCOUNT__LOGOUT",
                        dgat: "global.navigation.learner.sidebar.account.logout",
                        analytics: "global.navigation.learner.sidebar.account.logout",
                        routerLink: "/user/logout"
                    }
                ]
            }
        ]
    }
};
var admin$1 = {
    brand: {
        routerLink: "/admin",
        mark: {
            url: "data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' fill='%230062E3' xmlns='http://www.w3.org/2000/svg' %3E%3Cpath class='logo' fill-rule='evenodd' clip-rule='evenodd' d='M28.2624 15.1156L20.2595 10.6838L19.9913 10.5263C19.7677 10.4363 19.5219 10.3913 19.276 10.3913C19.0301 10.3913 18.7842 10.4363 18.5606 10.5263L18.2477 10.7063L16.9958 11.4037C16.9735 11.4262 16.9735 11.4486 16.9958 11.4711L17.51 11.7411L20.5278 13.4059L22.3161 14.3957C22.3161 14.3957 19.6783 14.5082 17.2417 15.9255C16.7946 16.1954 16.2805 16.3304 15.7663 16.3304H15.6545C15.1404 16.3304 14.6262 16.1954 14.1792 15.9255C11.7425 14.5082 9.10472 14.3957 9.10472 14.3957L15.6993 10.7288L18.0465 9.40145C18.2924 9.26647 19.1418 8.72656 20.1031 9.01901C20.5278 9.13149 21.2431 9.53643 21.8244 9.87388C22.2938 10.1438 22.875 10.0539 23.2327 9.62642C23.4115 9.40145 23.5009 9.15399 23.5009 8.88403C23.5009 8.50159 23.3221 8.14164 22.9644 7.91668C22.2044 7.44425 21.1537 6.88183 20.3043 6.74685C18.1135 6.36441 16.7276 7.44425 15.6769 8.00666C14.8721 7.35426 13.2403 6.38691 11.0719 6.74685C10.2001 6.90433 9.17179 7.44425 8.41174 7.91668C7.83052 8.27662 7.6964 9.0865 8.14348 9.60392C8.36703 9.85139 8.67999 9.98637 8.99295 9.98637C9.19414 9.98637 9.37297 9.94137 9.55181 9.82889C10.133 9.49144 10.8484 9.0865 11.2731 8.97402C12.4132 8.65907 13.3968 9.40145 13.3968 9.40145L3.0914 15.1156C2.82315 15.2506 2.66667 15.543 2.66667 15.8355V17.2528C2.66667 17.5452 2.82315 17.8152 3.0914 17.9727C3.35965 18.1076 3.42672 18.1976 3.42672 18.7151C3.42672 19.6149 2.82315 24.5417 9.21649 24.5417C14.9616 24.5417 14.2462 18.895 15.6769 18.9175C17.1299 18.895 16.4146 24.5417 22.1373 24.5417C28.5307 24.5417 27.9271 19.6149 27.9271 18.7151C27.9271 18.1976 27.9718 18.1301 28.24 17.9727C28.5083 17.8377 28.6648 17.5452 28.6648 17.2528V15.8355C28.6871 15.5205 28.5083 15.2506 28.2624 15.1156ZM12.1896 21.0997C11.5637 22.427 10.4683 22.6295 8.88118 22.562C7.6964 22.517 6.60103 22.1345 6.04218 21.4821C5.23742 20.5598 5.32684 17.7927 5.6398 17.1853C6.24336 16.0155 11.7872 16.3754 12.5249 17.8602C12.6144 18.0177 13.1062 19.1875 12.1896 21.0997ZM25.3116 21.4821C24.7528 22.1121 23.6574 22.4945 22.4726 22.562C20.9078 22.6295 19.8125 22.427 19.1642 21.0997C18.2477 19.1875 18.7394 18.0177 18.8065 17.8602C19.5442 16.3754 25.1104 16.0155 25.6917 17.1853C26.027 17.8152 26.1164 20.5823 25.3116 21.4821Z' /%3E%3C/svg%3E",
            altText: "Degreed logo"
        },
        logo: {
            url: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='268' height='54' viewBox='0 0 134 27' fill='none'%3E%3Cpath d='M27.344 18.1522C26.3963 18.9499 25.2299 19.4576 23.9176 19.4576C22.0222 19.5301 20.7099 19.3125 19.9809 17.717C18.8874 15.4688 19.4706 14.0909 19.5435 13.8733C20.4183 12.1327 27.1253 11.6976 27.7814 13.0756C28.2188 13.8008 28.3647 17.1369 27.344 18.1522ZM11.6701 17.717C10.9411 19.3125 9.62883 19.5301 7.73337 19.4576C6.49404 19.4576 5.2547 19.0225 4.30698 18.1522C3.35925 17.0643 3.43215 13.8008 3.79666 13.0756C4.52568 11.6976 11.1598 12.1327 12.0346 13.8733C12.1804 14.0909 12.7636 15.4688 11.6701 17.717ZM30.9162 10.6098L21.2932 5.38809L21.0015 5.17052C20.4183 4.95295 19.8351 4.95295 19.3248 5.17052L18.9603 5.38809L17.4293 6.25837V6.33089L18.0126 6.62099L21.6577 8.57911L23.7718 9.73949C21.6577 9.88453 19.5435 10.5372 17.721 11.5526C17.2106 11.8427 16.5545 12.0602 15.9713 12.0602H15.8255C15.1694 12.0602 14.5862 11.9152 14.0759 11.5526C12.1804 10.5372 10.1391 9.88453 8.02498 9.73949L15.8984 5.38809L18.7416 3.79258C19.4706 3.28492 20.3454 3.13987 21.2203 3.35744C21.9493 3.64754 22.6054 3.93763 23.2615 4.37277C23.5531 4.51782 23.8447 4.59034 24.1363 4.51781C24.4279 4.44529 24.6466 4.30025 24.8654 4.08268C25.0841 3.86511 25.157 3.50249 25.157 3.2124C25.157 2.77726 24.9383 2.34212 24.5008 2.05203C23.5531 1.39932 22.4596 0.964178 21.2932 0.674086C18.6687 0.238946 16.9919 1.47184 15.7526 2.19707C14.2217 0.96418 12.1804 0.383993 10.212 0.674086C9.04561 0.964178 8.02498 1.39932 7.00435 2.05203C6.42114 2.48717 6.20243 3.28492 6.63984 3.86511C6.63984 3.93763 6.71274 3.93763 6.71274 4.01015C7.00435 4.30025 7.36886 4.44529 7.73337 4.44529C7.95208 4.44529 8.17079 4.37277 8.38949 4.22772C9.04561 3.86511 9.70173 3.50249 10.4307 3.2124C11.3056 2.99483 12.2533 3.2124 12.9823 3.72006L0.807678 10.6098C0.51607 10.7548 0.297363 11.1174 0.297363 11.48V13.1481C0.297363 13.5107 0.51607 13.8733 0.807678 14.0183C1.09929 14.1634 1.17219 14.3084 1.17219 14.8886C1.17219 15.9765 0.443168 21.7783 8.09788 21.7783C14.9507 21.7783 14.1488 15.1062 15.8255 15.1062C17.5022 15.1062 16.7003 21.7783 23.5531 21.7783C31.2078 21.7783 30.4788 15.9765 30.4788 14.8886C30.4788 14.3084 30.5517 14.1634 30.8433 14.0183C31.2078 13.8733 31.4265 13.5107 31.4265 13.1481V11.48C31.4994 11.1174 31.2807 10.7548 30.9162 10.6098Z' fill='%230062E3'/%3E%3Cpath d='M70.1374 14.8887C70.2103 14.236 70.5019 13.6558 71.0122 13.2206C71.7413 12.6405 72.6161 12.3504 73.5638 12.4229C74.4386 12.3504 75.3135 12.6405 75.9696 13.2206C76.4799 13.6558 76.7715 14.3085 76.8444 14.9612V15.759C76.8444 16.4117 76.6257 17.0644 76.1883 17.572C76.1154 17.6446 76.0425 17.7896 75.8967 17.8621C75.6051 18.1522 75.1677 18.3698 74.8031 18.5148C74.3657 18.6599 73.8554 18.7324 73.3451 18.7324C72.4703 18.8049 71.5954 18.5148 70.9393 17.8621C70.8664 17.7896 70.7206 17.7171 70.6477 17.572C70.2103 16.9919 69.9916 16.2666 70.0645 15.5414C70.0645 15.3238 70.0645 15.1063 70.1374 14.8887ZM79.6876 10.2472H77.2818C77.2089 10.2472 77.136 10.3197 77.0631 10.3922C76.9902 10.4648 76.9902 10.5373 76.9902 10.6098V11.7702C76.5528 11.19 75.8967 10.6823 75.2406 10.3922C74.4386 10.1021 73.6367 9.9571 72.7619 9.9571C71.6684 9.9571 70.6477 10.1747 69.7 10.6823C68.8252 11.1175 68.1691 11.8427 67.6587 12.713C67.1484 13.5833 66.9297 14.5986 66.9297 15.6139C66.9297 16.5567 67.1484 17.4995 67.5129 18.3698L67.6587 18.5148C68.0962 19.3126 68.8252 19.9653 69.6271 20.473C69.9916 20.6905 70.429 20.8356 70.8664 20.9806C71.3768 21.1257 71.8871 21.1982 72.4703 21.1257C73.0535 21.1257 73.6367 21.0532 74.2199 20.9806C74.5115 20.9081 74.8031 20.7631 75.0947 20.6905C75.8238 20.4004 76.4799 19.8928 76.9902 19.3126V21.0532C76.9902 21.5608 76.8444 22.0685 76.5528 22.5036C76.2612 22.9388 75.8238 23.3014 75.3135 23.5189C74.9489 23.664 74.5844 23.809 74.2199 23.809C73.9283 23.809 73.7096 23.8816 73.418 23.8816C71.8142 23.8816 70.7935 23.4464 70.2832 22.5036C70.2832 22.4311 70.2103 22.3586 70.1374 22.3586H67.5858C67.44 22.3586 67.2942 22.5036 67.2942 22.6487V22.7212C67.5858 23.809 68.242 24.6793 69.1897 25.332C70.5019 26.0573 71.96 26.3473 73.4909 26.2748C74.6573 26.3473 75.8238 26.0572 76.9173 25.6221C76.9902 25.6221 76.9902 25.5496 77.0631 25.5496C77.5734 25.332 78.0108 25.0419 78.3753 24.6793C79.396 23.7365 79.9792 22.4311 80.0521 21.0532C80.125 20.618 80.125 20.1829 80.125 19.8203V10.6098C80.0521 10.3922 79.9063 10.2472 79.6876 10.2472ZM130.427 16.1216C130.427 16.9193 130.136 17.7171 129.553 18.2247C129.261 18.5148 128.824 18.8049 128.386 18.95C127.949 19.095 127.438 19.2401 127.001 19.2401C126.126 19.3126 125.178 18.95 124.595 18.3698C123.939 17.7171 123.648 16.7743 123.72 15.8315C123.648 14.8887 123.939 13.9459 124.595 13.2206C125.324 12.5679 126.199 12.2778 127.147 12.3504C128.022 12.2778 128.969 12.6405 129.553 13.2206C129.844 13.5107 130.063 13.8734 130.209 14.236C130.354 14.6711 130.427 15.0337 130.427 15.4689V16.1216ZM133.198 6.25842H130.719C130.646 6.25842 130.573 6.25842 130.5 6.33094C130.427 6.40347 130.427 6.47599 130.427 6.54852V11.6251C129.407 10.3922 127.876 9.73954 126.272 9.81206C125.178 9.81206 124.158 10.0296 123.21 10.6098C122.335 11.1175 121.606 11.8427 121.169 12.713C120.659 13.6558 120.44 14.7436 120.513 15.8315C120.513 16.9193 120.731 17.9347 121.169 18.8775C121.606 19.7477 122.262 20.4004 123.137 20.9081C124.012 21.4158 124.96 21.6333 125.98 21.6333C126.928 21.6333 127.803 21.4883 128.605 21.1257C129.407 20.8356 130.063 20.2554 130.5 19.6027V20.9806C130.5 21.1982 130.646 21.3432 130.865 21.3432H133.271C133.489 21.3432 133.635 21.1982 133.635 20.9806V6.62104C133.635 6.54852 133.635 6.40347 133.562 6.40347C133.416 6.33095 133.343 6.25842 133.198 6.25842ZM108.921 14.5986C108.994 13.8734 109.359 13.2206 109.942 12.858C110.598 12.3504 111.4 12.1328 112.202 12.1328C113.077 12.0603 113.879 12.2778 114.608 12.7855C115.191 13.2206 115.555 13.8734 115.482 14.5986H108.921ZM116.941 11.4076C115.628 10.3922 113.952 9.81206 112.275 9.9571C111.108 9.9571 109.942 10.1747 108.848 10.7549C107.901 11.2625 107.099 11.9878 106.588 12.9306C106.078 13.8734 105.787 14.9612 105.787 16.0491C105.714 17.6446 106.297 19.1676 107.463 20.2554C108.775 21.3432 110.452 21.8509 112.202 21.7784C113.66 21.8509 115.118 21.5608 116.43 20.8356C117.378 20.2554 118.034 19.3851 118.326 18.2973C118.399 18.1522 118.326 18.0072 118.18 18.0072H115.628C115.555 18.0072 115.41 18.0797 115.41 18.1522C114.972 19.0225 113.952 19.5302 112.421 19.5302C111.837 19.5302 111.181 19.3851 110.598 19.1676C110.088 18.95 109.723 18.5874 109.359 18.1522C109.067 17.7171 108.921 17.2094 108.921 16.7018H118.18C118.326 16.7018 118.399 16.6292 118.471 16.5567C118.544 16.4842 118.617 16.3391 118.617 16.2666V15.6864C118.69 14.0909 118.034 12.5679 116.941 11.4076ZM94.4138 14.5986C94.4867 13.8734 94.8512 13.2206 95.4344 12.858C96.0905 12.3504 96.8925 12.1328 97.6944 12.1328C98.5692 12.0603 99.3711 12.2778 100.1 12.7855C100.683 13.2206 101.048 13.8734 100.975 14.5986H94.4138ZM102.36 11.4076C101.048 10.3922 99.3711 9.81206 97.6944 9.9571C96.5279 9.9571 95.3615 10.1747 94.268 10.7549C93.3203 11.2625 92.5183 11.9878 92.008 12.9306C91.4977 13.8734 91.2061 14.9612 91.2061 16.0491C91.1332 17.6446 91.7164 19.1676 92.8829 20.2554C94.1951 21.3432 95.8718 21.8509 97.6215 21.7784C99.0795 21.8509 100.538 21.5608 101.85 20.8356C102.798 20.2554 103.454 19.3851 103.745 18.2973C103.818 18.1522 103.745 18.0072 103.599 18.0072H101.048C100.975 18.0072 100.829 18.0797 100.829 18.1522C100.392 19.0225 99.3711 19.5302 97.8402 19.5302C97.257 19.5302 96.6009 19.3851 96.0176 19.1676C95.5073 18.95 95.1428 18.5874 94.7783 18.1522C94.4867 17.7171 94.3409 17.2094 94.3409 16.7018H103.599C103.745 16.7018 103.818 16.6292 103.891 16.5567C103.964 16.4842 104.037 16.3391 104.037 16.2666V15.6864C104.11 14.0909 103.527 12.5679 102.36 11.4076ZM89.8939 10.1022C88.29 10.1022 86.832 10.8274 85.8114 12.0603V10.6098C85.8114 10.5373 85.8114 10.4648 85.7384 10.3922C85.6655 10.3197 85.5926 10.3197 85.5197 10.2472H83.114C82.8953 10.2472 82.7495 10.3922 82.7495 10.6098V21.0532C82.7495 21.2707 82.8953 21.4158 83.114 21.4158H85.5926C85.8114 21.4158 85.9572 21.2707 85.9572 21.0532V15.5414C85.9572 14.8162 86.3217 14.0909 86.9049 13.5833C87.6339 13.0031 88.5816 12.6405 89.5294 12.713H89.9668C90.1855 12.713 90.4042 12.5679 90.4042 12.3504V10.4648C90.4042 10.3922 90.3313 10.2472 90.2584 10.1747C90.1855 10.1022 90.1126 10.0296 89.9668 10.0296H89.8939V10.1022ZM55.4112 14.6711C55.4841 13.9459 55.8486 13.2932 56.4318 12.9306C57.0879 12.4229 57.8899 12.2053 58.6918 12.2053C59.5666 12.1328 60.3685 12.3504 61.0976 12.858C61.6808 13.2932 61.9724 13.9459 61.9724 14.6711H55.4112ZM63.4304 11.4076C62.1182 10.3197 60.5143 9.81206 58.8376 9.88458C57.6712 9.88458 56.5047 10.1022 55.4112 10.6823C54.4635 11.19 53.6616 11.9152 53.1512 12.858C52.6409 13.8008 52.3493 14.8887 52.3493 15.9765C52.2764 17.572 52.8596 19.095 54.0261 20.1829C55.3383 21.2707 57.015 21.7784 58.7647 21.7059C60.2227 21.7784 61.6808 21.4883 62.993 20.7631C63.9407 20.1829 64.5969 19.3126 64.8885 18.2247C64.9614 18.0797 64.8156 17.9347 64.7427 17.9347H62.1911C62.1182 17.9347 61.9724 18.0072 61.9724 18.0797C61.535 18.95 60.5143 19.4576 58.9105 19.4576C58.3273 19.4576 57.6712 19.3126 57.0879 19.095C56.5776 18.8775 56.2131 18.5148 55.8486 18.0797C55.557 17.6446 55.4112 17.1369 55.4112 16.6292H64.5969C64.7427 16.6292 64.8156 16.5567 64.8885 16.4842C64.9614 16.4117 65.0343 16.2666 65.0343 16.1941V15.6864C65.1072 14.0909 64.524 12.5679 63.4304 11.4076ZM47.1733 16.1216C47.1733 16.4842 47.1004 16.9193 46.9546 17.2819C46.8088 17.6446 46.5901 18.0072 46.2984 18.2973C46.0068 18.5874 45.5694 18.8775 45.132 19.0225C44.6946 19.1675 44.1843 19.3126 43.674 19.3126C42.7991 19.3851 41.8514 19.0225 41.2682 18.4423C40.6121 17.7896 40.3205 16.8468 40.3934 15.9765C40.3205 15.0337 40.6121 14.0909 41.2682 13.3657C41.9972 12.713 42.872 12.4229 43.8198 12.4954C44.6946 12.4229 45.6423 12.7855 46.2255 13.3657C46.5172 13.6558 46.7359 14.0184 46.8817 14.381C47.0275 14.7436 47.1004 15.1788 47.1004 15.6139L47.1733 16.1216ZM49.9435 6.33094H47.4649C47.2462 6.33094 47.1004 6.47599 47.1004 6.69356V11.7702C46.0797 10.5373 44.4759 9.88458 42.872 9.9571C41.7785 9.9571 40.7579 10.1747 39.8102 10.7549C38.9353 11.2625 38.2063 11.9878 37.7689 12.858C36.8212 14.8162 36.8212 17.0644 37.7689 19.0225C38.2063 19.8928 38.8624 20.5455 39.7373 21.0532C40.6121 21.5608 41.5598 21.7784 42.5804 21.7784C43.5282 21.7784 44.403 21.6333 45.2049 21.2707C46.0068 20.9806 46.663 20.4004 47.1004 19.7477V21.1257C47.1004 21.3432 47.2462 21.4883 47.4649 21.4883H49.8706C50.0894 21.4883 50.2352 21.3432 50.2352 21.1257V6.69356C50.2352 6.62104 50.1622 6.54852 50.1622 6.47599C50.1622 6.33095 50.0164 6.33094 49.9435 6.33094Z' fill='%23353C42'/%3E%3C/svg%3E",
            altText: "Degreed logo"
        },
        colors: {
            background: "#ffffff",
            text: "var(--apollo-color-neutral-800)",
            highlight: "var(--apollo-color-blue-800)",
            separator: "var(--apollo-color-neutral-200)"
        },
        text: "Degreed Logo",
        analytics: "global.navigation.admin.brand",
        i18n: "global.navigation.admin.brand, A11Y__DEGREED_LOGO",
        dgat: "global.navigation.admin.brand"
    },
    features: {
        beta: {
            enabled: true,
            visible: true,
            text: "Beta",
            i18n: "global.navigation.admin.features.beta, GENERIC__BETA",
            dgat: "global.navigation.admin.features.beta"
        },
        footerBranding: {
            enabled: true,
            visible: true,
            text: "Powered by",
            i18n: "global.navigation.admin.features.footer-branding, BRAND__POWERED_BY",
            dgat: "global.navigation.admin.features.footer-branding"
        },
        sidebarBranding: {
            enabled: true,
            visible: true,
            text: "Powered by",
            i18n: "global.navigation.admin.features.sidebar-branding, BRAND__POWERED_BY",
            dgat: "global.navigation.admin.features.sidebar-branding"
        },
        switcher: {
            enabled: true,
            visible: true,
            text: "Show Learner View",
            i18n: "global.navigation.admin.features.show-learner-view, LEARNER__SHOW_VIEW",
            dgat: "global.navigation.admin.features.show-learner-view",
            analytics: "global.navigation.admin.features.show-learner-view",
            routerLink: "/user/manage"
        }
    },
    navigation: {
        top: [
            {
                headerTitle: "Learning",
                headerTitleI18n: "global.navigation.admin.sidebar.learning, GENERIC__LEARNING",
                text: "Learning",
                i18n: "global.navigation.admin.sidebar.learning, GENERIC__LEARNING",
                dgat: "global.navigation.admin.sidebar.learning",
                analytics: "global.navigation.admin.sidebar.learning",
                icon: "book-open",
                children: [
                    {
                        text: "Marketplace",
                        i18n: "global.navigation.admin.sidebar.learning.marketplace, PROGRAM__MARKETPLACE__SIMPLE",
                        dgat: "global.navigation.admin.sidebar.learning.marketplace",
                        analytics: "global.navigation.admin.sidebar.learning.marketplace",
                        routerLink: "/admin/programs"
                    },
                    {
                        text: "Academies",
                        i18n: "global.navigation.admin.sidebar.learning.academies, ACADEMY__PLURAL",
                        dgat: "global.navigation.admin.sidebar.learning.academies",
                        analytics: "global.navigation.admin.sidebar.learning.academies",
                        routerLink: "/admin/academies"
                    }
                ]
            },
            {
                headerTitle: "People",
                headerTitleI18n: "global.navigation.admin.sidebar.people, GENERIC__PEOPLE",
                text: "People",
                i18n: "global.navigation.admin.sidebar.people, GENERIC__PEOPLE",
                dgat: "global.navigation.admin.sidebar.people",
                analytics: "global.navigation.admin.sidebar.people",
                icon: "users",
                routerLink: "/admin/people"
            },
            {
                headerTitle: "Licenses",
                headerTitleI18n: "global.navigation.admin.sidebar.licenses, LICENSE__PLURAL",
                text: "Licenses",
                i18n: "global.navigation.admin.sidebar.licenses, LICENSE__PLURAL",
                dgat: "global.navigation.admin.sidebar.licenses",
                analytics: "global.navigation.admin.sidebar.licenses",
                icon: "identification",
                routerLink: "/admin/licenses"
            },
            {
                headerTitle: "Incentives",
                headerTitleI18n: "global.navigation.admin.sidebar.incentives, INCENTIVE__PLURAL",
                text: "Incentives",
                i18n: "global.navigation.admin.sidebar.incentives, INCENTIVE__PLURAL",
                dgat: "global.navigation.admin.sidebar.incentives",
                analytics: "global.navigation.admin.sidebar.incentives",
                icon: "trophy",
                routerLink: "/admin/investments/incentives"
            },
            {
                headerTitle: "Approvals",
                headerTitleI18n: "global.navigation.admin.sidebar.approvals, APPROVAL__PLURAL",
                text: "Approvals",
                i18n: "global.navigation.admin.sidebar.approvals, APPROVAL__PLURAL",
                dgat: "global.navigation.admin.sidebar.approvals",
                analytics: "global.navigation.admin.sidebar.approvals",
                icon: "inbox",
                children: [
                    {
                        text: "Programs",
                        i18n: "global.navigation.admin.sidebar.approvals.programs, PROGRAM__PLURAL",
                        dgat: "global.navigation.admin.sidebar.approvals.programs",
                        analytics: "global.navigation.admin.sidebar.approvals.programs",
                        routerLink: "/admin/approvals/program"
                    },
                    {
                        text: "Resources",
                        i18n: "global.navigation.admin.sidebar.approvals.resources, RESOURCE__PLURAL",
                        dgat: "global.navigation.admin.sidebar.approvals.resources",
                        analytics: "global.navigation.learner.sidebar.approvals.resources",
                        routerLink: "/admin/approvals/resource"
                    }
                ]
            },
            {
                headerTitle: "Reports",
                headerTitleI18n: "global.navigation.admin.sidebar.reports, REPORT__PLURAL",
                text: "Reports",
                i18n: "global.navigation.admin.sidebar.reports, REPORT__PLURAL",
                dgat: "global.navigation.admin.sidebar.reports",
                analytics: "global.navigation.admin.sidebar.reports",
                icon: "document-chart-bar",
                routerLink: "/admin/reports"
            },
            {
                headerTitle: "Admin Settings",
                headerTitleI18n: "global.navigation.admin.sidebar.admin-settings, ADMIN__SETTING__PLURAL",
                text: "Admin Settings",
                i18n: "global.navigation.admin.sidebar.admin-settings, ADMIN__SETTING__PLURAL",
                dgat: "global.navigation.admin.sidebar.admin-settings",
                analytics: "global.navigation.admin.sidebar.admin-settings",
                icon: "cog-6-tooth",
                routerLink: "/admin/prepayment"
            },
            {
                headerTitle: "QA",
                headerTitleI18n: "global.navigation.admin.sidebar.qa, QA",
                text: "QA",
                i18n: "global.navigation.admin.sidebar.qa, QA",
                dgat: "global.navigation.admin.sidebar.qa",
                analytics: "global.navigation.admin.sidebar.qa",
                icon: "pencil-square",
                routerLink: "/admin/qa"
            },
            {
                headerTitle: "Developer Admin",
                headerTitleI18n: "global.navigation.admin.sidebar.developer-admin",
                text: "Developer Admin",
                i18n: "global.navigation.admin.sidebar.developer-admin",
                dgat: "global.navigation.admin.sidebar.developer-admin",
                analytics: "global.navigation.admin.sidebar.developer-admin",
                icon: "command-line",
                routerLink: "/admin/developer-admin"
            }
        ],
        bottom: []
    }
};
var AcmConfig = {
    learner: learner,
    admin: admin$1
};

var admin = {
    brand: {
        href: "/orgs/<orgId>",
        mark: {
            url: "data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' fill='%230062E3' xmlns='http://www.w3.org/2000/svg' %3E%3Cpath class='logo' fill-rule='evenodd' clip-rule='evenodd' d='M28.2624 15.1156L20.2595 10.6838L19.9913 10.5263C19.7677 10.4363 19.5219 10.3913 19.276 10.3913C19.0301 10.3913 18.7842 10.4363 18.5606 10.5263L18.2477 10.7063L16.9958 11.4037C16.9735 11.4262 16.9735 11.4486 16.9958 11.4711L17.51 11.7411L20.5278 13.4059L22.3161 14.3957C22.3161 14.3957 19.6783 14.5082 17.2417 15.9255C16.7946 16.1954 16.2805 16.3304 15.7663 16.3304H15.6545C15.1404 16.3304 14.6262 16.1954 14.1792 15.9255C11.7425 14.5082 9.10472 14.3957 9.10472 14.3957L15.6993 10.7288L18.0465 9.40145C18.2924 9.26647 19.1418 8.72656 20.1031 9.01901C20.5278 9.13149 21.2431 9.53643 21.8244 9.87388C22.2938 10.1438 22.875 10.0539 23.2327 9.62642C23.4115 9.40145 23.5009 9.15399 23.5009 8.88403C23.5009 8.50159 23.3221 8.14164 22.9644 7.91668C22.2044 7.44425 21.1537 6.88183 20.3043 6.74685C18.1135 6.36441 16.7276 7.44425 15.6769 8.00666C14.8721 7.35426 13.2403 6.38691 11.0719 6.74685C10.2001 6.90433 9.17179 7.44425 8.41174 7.91668C7.83052 8.27662 7.6964 9.0865 8.14348 9.60392C8.36703 9.85139 8.67999 9.98637 8.99295 9.98637C9.19414 9.98637 9.37297 9.94137 9.55181 9.82889C10.133 9.49144 10.8484 9.0865 11.2731 8.97402C12.4132 8.65907 13.3968 9.40145 13.3968 9.40145L3.0914 15.1156C2.82315 15.2506 2.66667 15.543 2.66667 15.8355V17.2528C2.66667 17.5452 2.82315 17.8152 3.0914 17.9727C3.35965 18.1076 3.42672 18.1976 3.42672 18.7151C3.42672 19.6149 2.82315 24.5417 9.21649 24.5417C14.9616 24.5417 14.2462 18.895 15.6769 18.9175C17.1299 18.895 16.4146 24.5417 22.1373 24.5417C28.5307 24.5417 27.9271 19.6149 27.9271 18.7151C27.9271 18.1976 27.9718 18.1301 28.24 17.9727C28.5083 17.8377 28.6648 17.5452 28.6648 17.2528V15.8355C28.6871 15.5205 28.5083 15.2506 28.2624 15.1156ZM12.1896 21.0997C11.5637 22.427 10.4683 22.6295 8.88118 22.562C7.6964 22.517 6.60103 22.1345 6.04218 21.4821C5.23742 20.5598 5.32684 17.7927 5.6398 17.1853C6.24336 16.0155 11.7872 16.3754 12.5249 17.8602C12.6144 18.0177 13.1062 19.1875 12.1896 21.0997ZM25.3116 21.4821C24.7528 22.1121 23.6574 22.4945 22.4726 22.562C20.9078 22.6295 19.8125 22.427 19.1642 21.0997C18.2477 19.1875 18.7394 18.0177 18.8065 17.8602C19.5442 16.3754 25.1104 16.0155 25.6917 17.1853C26.027 17.8152 26.1164 20.5823 25.3116 21.4821Z' /%3E%3C/svg%3E",
            altText: "Degreed logo"
        },
        logo: {
            url: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='268' height='54' viewBox='0 0 134 27' fill='none'%3E%3Cpath d='M27.344 18.1522C26.3963 18.9499 25.2299 19.4576 23.9176 19.4576C22.0222 19.5301 20.7099 19.3125 19.9809 17.717C18.8874 15.4688 19.4706 14.0909 19.5435 13.8733C20.4183 12.1327 27.1253 11.6976 27.7814 13.0756C28.2188 13.8008 28.3647 17.1369 27.344 18.1522ZM11.6701 17.717C10.9411 19.3125 9.62883 19.5301 7.73337 19.4576C6.49404 19.4576 5.2547 19.0225 4.30698 18.1522C3.35925 17.0643 3.43215 13.8008 3.79666 13.0756C4.52568 11.6976 11.1598 12.1327 12.0346 13.8733C12.1804 14.0909 12.7636 15.4688 11.6701 17.717ZM30.9162 10.6098L21.2932 5.38809L21.0015 5.17052C20.4183 4.95295 19.8351 4.95295 19.3248 5.17052L18.9603 5.38809L17.4293 6.25837V6.33089L18.0126 6.62099L21.6577 8.57911L23.7718 9.73949C21.6577 9.88453 19.5435 10.5372 17.721 11.5526C17.2106 11.8427 16.5545 12.0602 15.9713 12.0602H15.8255C15.1694 12.0602 14.5862 11.9152 14.0759 11.5526C12.1804 10.5372 10.1391 9.88453 8.02498 9.73949L15.8984 5.38809L18.7416 3.79258C19.4706 3.28492 20.3454 3.13987 21.2203 3.35744C21.9493 3.64754 22.6054 3.93763 23.2615 4.37277C23.5531 4.51782 23.8447 4.59034 24.1363 4.51781C24.4279 4.44529 24.6466 4.30025 24.8654 4.08268C25.0841 3.86511 25.157 3.50249 25.157 3.2124C25.157 2.77726 24.9383 2.34212 24.5008 2.05203C23.5531 1.39932 22.4596 0.964178 21.2932 0.674086C18.6687 0.238946 16.9919 1.47184 15.7526 2.19707C14.2217 0.96418 12.1804 0.383993 10.212 0.674086C9.04561 0.964178 8.02498 1.39932 7.00435 2.05203C6.42114 2.48717 6.20243 3.28492 6.63984 3.86511C6.63984 3.93763 6.71274 3.93763 6.71274 4.01015C7.00435 4.30025 7.36886 4.44529 7.73337 4.44529C7.95208 4.44529 8.17079 4.37277 8.38949 4.22772C9.04561 3.86511 9.70173 3.50249 10.4307 3.2124C11.3056 2.99483 12.2533 3.2124 12.9823 3.72006L0.807678 10.6098C0.51607 10.7548 0.297363 11.1174 0.297363 11.48V13.1481C0.297363 13.5107 0.51607 13.8733 0.807678 14.0183C1.09929 14.1634 1.17219 14.3084 1.17219 14.8886C1.17219 15.9765 0.443168 21.7783 8.09788 21.7783C14.9507 21.7783 14.1488 15.1062 15.8255 15.1062C17.5022 15.1062 16.7003 21.7783 23.5531 21.7783C31.2078 21.7783 30.4788 15.9765 30.4788 14.8886C30.4788 14.3084 30.5517 14.1634 30.8433 14.0183C31.2078 13.8733 31.4265 13.5107 31.4265 13.1481V11.48C31.4994 11.1174 31.2807 10.7548 30.9162 10.6098Z' fill='%230062E3'/%3E%3Cpath d='M70.1374 14.8887C70.2103 14.236 70.5019 13.6558 71.0122 13.2206C71.7413 12.6405 72.6161 12.3504 73.5638 12.4229C74.4386 12.3504 75.3135 12.6405 75.9696 13.2206C76.4799 13.6558 76.7715 14.3085 76.8444 14.9612V15.759C76.8444 16.4117 76.6257 17.0644 76.1883 17.572C76.1154 17.6446 76.0425 17.7896 75.8967 17.8621C75.6051 18.1522 75.1677 18.3698 74.8031 18.5148C74.3657 18.6599 73.8554 18.7324 73.3451 18.7324C72.4703 18.8049 71.5954 18.5148 70.9393 17.8621C70.8664 17.7896 70.7206 17.7171 70.6477 17.572C70.2103 16.9919 69.9916 16.2666 70.0645 15.5414C70.0645 15.3238 70.0645 15.1063 70.1374 14.8887ZM79.6876 10.2472H77.2818C77.2089 10.2472 77.136 10.3197 77.0631 10.3922C76.9902 10.4648 76.9902 10.5373 76.9902 10.6098V11.7702C76.5528 11.19 75.8967 10.6823 75.2406 10.3922C74.4386 10.1021 73.6367 9.9571 72.7619 9.9571C71.6684 9.9571 70.6477 10.1747 69.7 10.6823C68.8252 11.1175 68.1691 11.8427 67.6587 12.713C67.1484 13.5833 66.9297 14.5986 66.9297 15.6139C66.9297 16.5567 67.1484 17.4995 67.5129 18.3698L67.6587 18.5148C68.0962 19.3126 68.8252 19.9653 69.6271 20.473C69.9916 20.6905 70.429 20.8356 70.8664 20.9806C71.3768 21.1257 71.8871 21.1982 72.4703 21.1257C73.0535 21.1257 73.6367 21.0532 74.2199 20.9806C74.5115 20.9081 74.8031 20.7631 75.0947 20.6905C75.8238 20.4004 76.4799 19.8928 76.9902 19.3126V21.0532C76.9902 21.5608 76.8444 22.0685 76.5528 22.5036C76.2612 22.9388 75.8238 23.3014 75.3135 23.5189C74.9489 23.664 74.5844 23.809 74.2199 23.809C73.9283 23.809 73.7096 23.8816 73.418 23.8816C71.8142 23.8816 70.7935 23.4464 70.2832 22.5036C70.2832 22.4311 70.2103 22.3586 70.1374 22.3586H67.5858C67.44 22.3586 67.2942 22.5036 67.2942 22.6487V22.7212C67.5858 23.809 68.242 24.6793 69.1897 25.332C70.5019 26.0573 71.96 26.3473 73.4909 26.2748C74.6573 26.3473 75.8238 26.0572 76.9173 25.6221C76.9902 25.6221 76.9902 25.5496 77.0631 25.5496C77.5734 25.332 78.0108 25.0419 78.3753 24.6793C79.396 23.7365 79.9792 22.4311 80.0521 21.0532C80.125 20.618 80.125 20.1829 80.125 19.8203V10.6098C80.0521 10.3922 79.9063 10.2472 79.6876 10.2472ZM130.427 16.1216C130.427 16.9193 130.136 17.7171 129.553 18.2247C129.261 18.5148 128.824 18.8049 128.386 18.95C127.949 19.095 127.438 19.2401 127.001 19.2401C126.126 19.3126 125.178 18.95 124.595 18.3698C123.939 17.7171 123.648 16.7743 123.72 15.8315C123.648 14.8887 123.939 13.9459 124.595 13.2206C125.324 12.5679 126.199 12.2778 127.147 12.3504C128.022 12.2778 128.969 12.6405 129.553 13.2206C129.844 13.5107 130.063 13.8734 130.209 14.236C130.354 14.6711 130.427 15.0337 130.427 15.4689V16.1216ZM133.198 6.25842H130.719C130.646 6.25842 130.573 6.25842 130.5 6.33094C130.427 6.40347 130.427 6.47599 130.427 6.54852V11.6251C129.407 10.3922 127.876 9.73954 126.272 9.81206C125.178 9.81206 124.158 10.0296 123.21 10.6098C122.335 11.1175 121.606 11.8427 121.169 12.713C120.659 13.6558 120.44 14.7436 120.513 15.8315C120.513 16.9193 120.731 17.9347 121.169 18.8775C121.606 19.7477 122.262 20.4004 123.137 20.9081C124.012 21.4158 124.96 21.6333 125.98 21.6333C126.928 21.6333 127.803 21.4883 128.605 21.1257C129.407 20.8356 130.063 20.2554 130.5 19.6027V20.9806C130.5 21.1982 130.646 21.3432 130.865 21.3432H133.271C133.489 21.3432 133.635 21.1982 133.635 20.9806V6.62104C133.635 6.54852 133.635 6.40347 133.562 6.40347C133.416 6.33095 133.343 6.25842 133.198 6.25842ZM108.921 14.5986C108.994 13.8734 109.359 13.2206 109.942 12.858C110.598 12.3504 111.4 12.1328 112.202 12.1328C113.077 12.0603 113.879 12.2778 114.608 12.7855C115.191 13.2206 115.555 13.8734 115.482 14.5986H108.921ZM116.941 11.4076C115.628 10.3922 113.952 9.81206 112.275 9.9571C111.108 9.9571 109.942 10.1747 108.848 10.7549C107.901 11.2625 107.099 11.9878 106.588 12.9306C106.078 13.8734 105.787 14.9612 105.787 16.0491C105.714 17.6446 106.297 19.1676 107.463 20.2554C108.775 21.3432 110.452 21.8509 112.202 21.7784C113.66 21.8509 115.118 21.5608 116.43 20.8356C117.378 20.2554 118.034 19.3851 118.326 18.2973C118.399 18.1522 118.326 18.0072 118.18 18.0072H115.628C115.555 18.0072 115.41 18.0797 115.41 18.1522C114.972 19.0225 113.952 19.5302 112.421 19.5302C111.837 19.5302 111.181 19.3851 110.598 19.1676C110.088 18.95 109.723 18.5874 109.359 18.1522C109.067 17.7171 108.921 17.2094 108.921 16.7018H118.18C118.326 16.7018 118.399 16.6292 118.471 16.5567C118.544 16.4842 118.617 16.3391 118.617 16.2666V15.6864C118.69 14.0909 118.034 12.5679 116.941 11.4076ZM94.4138 14.5986C94.4867 13.8734 94.8512 13.2206 95.4344 12.858C96.0905 12.3504 96.8925 12.1328 97.6944 12.1328C98.5692 12.0603 99.3711 12.2778 100.1 12.7855C100.683 13.2206 101.048 13.8734 100.975 14.5986H94.4138ZM102.36 11.4076C101.048 10.3922 99.3711 9.81206 97.6944 9.9571C96.5279 9.9571 95.3615 10.1747 94.268 10.7549C93.3203 11.2625 92.5183 11.9878 92.008 12.9306C91.4977 13.8734 91.2061 14.9612 91.2061 16.0491C91.1332 17.6446 91.7164 19.1676 92.8829 20.2554C94.1951 21.3432 95.8718 21.8509 97.6215 21.7784C99.0795 21.8509 100.538 21.5608 101.85 20.8356C102.798 20.2554 103.454 19.3851 103.745 18.2973C103.818 18.1522 103.745 18.0072 103.599 18.0072H101.048C100.975 18.0072 100.829 18.0797 100.829 18.1522C100.392 19.0225 99.3711 19.5302 97.8402 19.5302C97.257 19.5302 96.6009 19.3851 96.0176 19.1676C95.5073 18.95 95.1428 18.5874 94.7783 18.1522C94.4867 17.7171 94.3409 17.2094 94.3409 16.7018H103.599C103.745 16.7018 103.818 16.6292 103.891 16.5567C103.964 16.4842 104.037 16.3391 104.037 16.2666V15.6864C104.11 14.0909 103.527 12.5679 102.36 11.4076ZM89.8939 10.1022C88.29 10.1022 86.832 10.8274 85.8114 12.0603V10.6098C85.8114 10.5373 85.8114 10.4648 85.7384 10.3922C85.6655 10.3197 85.5926 10.3197 85.5197 10.2472H83.114C82.8953 10.2472 82.7495 10.3922 82.7495 10.6098V21.0532C82.7495 21.2707 82.8953 21.4158 83.114 21.4158H85.5926C85.8114 21.4158 85.9572 21.2707 85.9572 21.0532V15.5414C85.9572 14.8162 86.3217 14.0909 86.9049 13.5833C87.6339 13.0031 88.5816 12.6405 89.5294 12.713H89.9668C90.1855 12.713 90.4042 12.5679 90.4042 12.3504V10.4648C90.4042 10.3922 90.3313 10.2472 90.2584 10.1747C90.1855 10.1022 90.1126 10.0296 89.9668 10.0296H89.8939V10.1022ZM55.4112 14.6711C55.4841 13.9459 55.8486 13.2932 56.4318 12.9306C57.0879 12.4229 57.8899 12.2053 58.6918 12.2053C59.5666 12.1328 60.3685 12.3504 61.0976 12.858C61.6808 13.2932 61.9724 13.9459 61.9724 14.6711H55.4112ZM63.4304 11.4076C62.1182 10.3197 60.5143 9.81206 58.8376 9.88458C57.6712 9.88458 56.5047 10.1022 55.4112 10.6823C54.4635 11.19 53.6616 11.9152 53.1512 12.858C52.6409 13.8008 52.3493 14.8887 52.3493 15.9765C52.2764 17.572 52.8596 19.095 54.0261 20.1829C55.3383 21.2707 57.015 21.7784 58.7647 21.7059C60.2227 21.7784 61.6808 21.4883 62.993 20.7631C63.9407 20.1829 64.5969 19.3126 64.8885 18.2247C64.9614 18.0797 64.8156 17.9347 64.7427 17.9347H62.1911C62.1182 17.9347 61.9724 18.0072 61.9724 18.0797C61.535 18.95 60.5143 19.4576 58.9105 19.4576C58.3273 19.4576 57.6712 19.3126 57.0879 19.095C56.5776 18.8775 56.2131 18.5148 55.8486 18.0797C55.557 17.6446 55.4112 17.1369 55.4112 16.6292H64.5969C64.7427 16.6292 64.8156 16.5567 64.8885 16.4842C64.9614 16.4117 65.0343 16.2666 65.0343 16.1941V15.6864C65.1072 14.0909 64.524 12.5679 63.4304 11.4076ZM47.1733 16.1216C47.1733 16.4842 47.1004 16.9193 46.9546 17.2819C46.8088 17.6446 46.5901 18.0072 46.2984 18.2973C46.0068 18.5874 45.5694 18.8775 45.132 19.0225C44.6946 19.1675 44.1843 19.3126 43.674 19.3126C42.7991 19.3851 41.8514 19.0225 41.2682 18.4423C40.6121 17.7896 40.3205 16.8468 40.3934 15.9765C40.3205 15.0337 40.6121 14.0909 41.2682 13.3657C41.9972 12.713 42.872 12.4229 43.8198 12.4954C44.6946 12.4229 45.6423 12.7855 46.2255 13.3657C46.5172 13.6558 46.7359 14.0184 46.8817 14.381C47.0275 14.7436 47.1004 15.1788 47.1004 15.6139L47.1733 16.1216ZM49.9435 6.33094H47.4649C47.2462 6.33094 47.1004 6.47599 47.1004 6.69356V11.7702C46.0797 10.5373 44.4759 9.88458 42.872 9.9571C41.7785 9.9571 40.7579 10.1747 39.8102 10.7549C38.9353 11.2625 38.2063 11.9878 37.7689 12.858C36.8212 14.8162 36.8212 17.0644 37.7689 19.0225C38.2063 19.8928 38.8624 20.5455 39.7373 21.0532C40.6121 21.5608 41.5598 21.7784 42.5804 21.7784C43.5282 21.7784 44.403 21.6333 45.2049 21.2707C46.0068 20.9806 46.663 20.4004 47.1004 19.7477V21.1257C47.1004 21.3432 47.2462 21.4883 47.4649 21.4883H49.8706C50.0894 21.4883 50.2352 21.3432 50.2352 21.1257V6.69356C50.2352 6.62104 50.1622 6.54852 50.1622 6.47599C50.1622 6.33095 50.0164 6.33094 49.9435 6.33094Z' fill='%23353C42'/%3E%3C/svg%3E",
            altText: "Degreed logo"
        },
        colors: {
            background: "#ffffff",
            text: "var(--apollo-color-neutral-800)",
            highlight: "var(--apollo-color-blue-800)",
            separator: "var(--apollo-color-neutral-200)"
        },
        text: "Degreed Logo",
        analytics: "global.navigation.admin.brand",
        i18n: "global.navigation.admin.brand",
        dgat: "global.navigation.admin.brand"
    },
    features: {
        beta: {
            enabled: false,
            visible: false,
            text: "Beta",
            i18n: "global.navigation.admin.features.beta",
            dgat: "global.navigation.admin.features.beta"
        },
        admin: {
            enabled: true,
            visible: true,
            text: "Admin",
            i18n: "global.navigation.admin.features.admin, Core_RoleAdmin",
            dgat: "global.navigation.admin.features.admin"
        },
        footerBranding: {
            enabled: true,
            visible: true,
            text: "Powered by",
            i18n: "global.navigation.admin.features.footer-branding, Core_PoweredBy",
            dgat: "global.navigation.admin.features.footer-branding"
        },
        sidebarBranding: {
            enabled: true,
            visible: true,
            text: "Powered by",
            i18n: "global.navigation.admin.features.sidebar-branding, Core_PoweredBy",
            dgat: "global.navigation.admin.features.sidebar-branding"
        },
        switcher: {
            enabled: true,
            visible: true,
            text: "Show Learner View",
            i18n: "global.navigation.admin.features.show-learner-view",
            dgat: "global.navigation.admin.features.show-learner-view",
            analytics: "global.navigation.admin.features.show-learner-view",
            href: "/<user>/dashboard"
        },
        search: {
            enabled: false,
            visible: false
        },
        addContent: {
            enabled: false,
            visible: false
        }
    },
    navigation: {
        top: [
            {
                headerTitle: "Insights",
                headerTitleI18n: "global.navigation.admin.sidebar.dashboard, OrganizationsController_Insights",
                text: "Insights",
                i18n: "global.navigation.admin.sidebar.dashboard, OrganizationsController_Insights",
                dgat: "global.navigation.admin.sidebar.dashboard",
                analytics: "global.navigation.admin.sidebar.dashboard",
                icon: "presentation-chart-line",
                children: [
                    {
                        text: "Learning",
                        i18n: "global.navigation.admin.sidebar.dashboard.learning, OrgSettingsNav_Learning",
                        dgat: "global.navigation.admin.sidebar.dashboard.learning",
                        analytics: "global.navigation.admin.sidebar.dashboard.learning",
                        href: "/orgs/<orgId>/insights/learning"
                    },
                    {
                        text: "Skills",
                        i18n: "global.navigation.admin.sidebar.dashboard.skills, Core_Skills",
                        dgat: "global.navigation.admin.sidebar.dashboard.skills",
                        analytics: "global.navigation.admin.sidebar.dashboard.skills",
                        href: "/orgs/<orgId>/insights/skills"
                    },
                    {
                        text: "Skill Trends",
                        i18n: "global.navigation.admin.sidebar.dashboard.skill-trends, InsightsNav_SkillTrends",
                        dgat: "global.navigation.admin.sidebar.dashboard.skill-trends",
                        analytics: "global.navigation.admin.sidebar.dashboard.skill-trends",
                        href: "/orgs/<orgId>/insights/skill-trends"
                    }
                ]
            },
            {
                headerTitle: "People",
                headerTitleI18n: "global.navigation.admin.sidebar.people, OrganizationsController_People",
                text: "People",
                i18n: "global.navigation.admin.sidebar.people",
                dgat: "global.navigation.admin.sidebar.people",
                analytics: "global.navigation.admin.sidebar.people",
                icon: "users",
                children: [
                    {
                        text: "Users",
                        i18n: "global.navigation.admin.sidebar.people.users, Core_Users",
                        dgat: "global.navigation.admin.sidebar.people.users",
                        analytics: "global.navigation.admin.sidebar.people.users",
                        href: "/orgs/<orgId>/members/users"
                    },
                    {
                        text: "Groups",
                        i18n: "global.navigation.admin.sidebar.people.groups, Core_Groups",
                        dgat: "global.navigation.admin.sidebar.people.groups",
                        analytics: "global.navigation.admin.sidebar.people.groups",
                        href: "/orgs/<orgId>/groups"
                    },
                    {
                        text: "Segments",
                        i18n: "global.navigation.admin.sidebar.people.segments, OrganizationsController_Segments",
                        dgat: "global.navigation.admin.sidebar.people.segments",
                        analytics: "global.navigation.admin.sidebar.people.segments",
                        href: "/orgs/<orgId>/members/segments"
                    },
                    {
                        text: "User Attributes",
                        i18n: "global.navigation.admin.sidebar.people.user-attributes, Attributes_UserAttributes",
                        dgat: "global.navigation.admin.sidebar.people.user-attributes",
                        analytics: "global.navigation.admin.sidebar.people.user-attributes",
                        href: "/orgs/<orgId>/members/attributes"
                    },
                    {
                        text: "Permissions",
                        i18n: "global.navigation.admin.sidebar.people.permissions, OrgSettingsNav_Permissions",
                        dgat: "global.navigation.admin.sidebar.people.permissions",
                        analytics: "global.navigation.admin.sidebar.people.permissions",
                        href: "/orgs/<orgId>/settings/permissions"
                    }
                ]
            },
            {
                headerTitle: "Catalog",
                headerTitleI18n: "global.navigation.admin.sidebar.catalog, Channel_CatalogNav",
                text: "Catalog",
                i18n: "global.navigation.admin.sidebar.catalog, Channel_CatalogNav",
                dgat: "global.navigation.admin.catalog",
                analytics: "global.navigation.admin.catalog",
                icon: "book-open",
                children: [
                    {
                        text: "Content",
                        i18n: "global.navigation.admin.sidebar.catalog.content, Core_Content",
                        dgat: "global.navigation.admin.sidebar.catalog.content",
                        analytics: "global.navigation.admin.sidebar.catalog.content",
                        href: "/orgs/<orgId>/content"
                    },
                    {
                        text: "Academies",
                        i18n: "global.navigation.admin.sidebar.catalog.academies, Core_Academies",
                        dgat: "global.navigation.admin.sidebar.catalog.academies",
                        analytics: "global.navigation.admin.sidebar.catalog.academies",
                        href: "<learnInSSOUrl>#/admin/academies?lxpAdmin=true"
                    },
                    {
                        text: "Pathways",
                        i18n: "global.navigation.admin.sidebar.catalog.pathways, OrganizationsController_Pathways",
                        dgat: "global.navigation.admin.sidebar.catalog.pathways",
                        analytics: "global.navigation.admin.sidebar.catalog.pathways",
                        href: "/orgs/<orgId>/pathways"
                    },
                    {
                        text: "Plans",
                        i18n: "global.navigation.admin.sidebar.catalog.plans, OrganizationsController_Plans",
                        dgat: "global.navigation.admin.sidebar.catalog.plans",
                        analytics: "global.navigation.admin.sidebar.catalog.plans",
                        href: "/orgs/<orgId>/plans"
                    },
                    {
                        text: "Skill-Dev",
                        i18n: "global.navigation.admin.sidebar.catalog.skill-dev, OrganizationsController_JobRoles",
                        dgat: "global.navigation.admin.sidebar.catalog.skill-dev",
                        analytics: "global.navigation.admin.sidebar.catalog.skill-dev",
                        href: "/orgs/<orgId>/skill-dev"
                    }
                ]
            },
            {
                headerTitle: "Skills",
                headerTitleI18n: "global.navigation.admin.sidebar.skills, Core_Skills",
                text: "Skills",
                i18n: "global.navigation.admin.sidebar.skills, Core_Skills",
                dgat: "global.navigation.admin.sidebar.skills",
                analytics: "global.navigation.admin.sidebar.skills",
                icon: "tag",
                children: [
                    {
                        text: "Dashboard",
                        i18n: "global.navigation.admin.sidebar.skills.dashboard, NavigationSvc_DashboardTitle",
                        dgat: "global.navigation.admin.sidebar.skills.dashboard",
                        analytics: "global.navigation.admin.sidebar.skills.dashboard",
                        href: "/orgs/<orgId>/skills-platform/dashboard"
                    },
                    {
                        text: "Inventory",
                        i18n: "global.navigation.admin.sidebar.skills.inventory, Core_Inventory",
                        dgat: "global.navigation.admin.sidebar.skills.inventory",
                        analytics: "global.navigation.admin.sidebar.skills.inventory",
                        href: "/orgs/<orgId>/skills-platform/skill-inventory"
                    },
                    {
                        text: "Scales",
                        i18n: "global.navigation.admin.sidebar.skills.scales",
                        dgat: "global.navigation.admin.sidebar.skills.scales",
                        analytics: "global.navigation.admin.sidebar.skills.scales",
                        routerLink: "/scales"
                    },
                    {
                        text: "Org Skills",
                        i18n: "global.navigation.admin.sidebar.skills.skill-list",
                        dgat: "global.navigation.admin.sidebar.skills.skill-list",
                        analytics: "global.navigation.admin.sidebar.skills.skill-list",
                        href: "/orgs/<orgId>/skills/list"
                    },
                    {
                        text: "Roles",
                        i18n: "global.navigation.admin.sidebar.skills.roles, OrgSkillsNav_Roles",
                        dgat: "global.navigation.admin.sidebar.skills.roles",
                        analytics: "global.navigation.admin.sidebar.skills.roles",
                        href: "/orgs/<orgId>/skills/roles"
                    },
                    {
                        text: "Skill Standards",
                        i18n: "global.navigation.admin.sidebar.skills.skill-standards, SkillStd_SkillStandards",
                        dgat: "global.navigation.admin.sidebar.skills.skill-standards",
                        analytics: "global.navigation.admin.sidebar.skills.skill-standards",
                        href: "/orgs/<orgId>/skills/skillstandards"
                    },
                    {
                        text: "Publish",
                        i18n: "global.navigation.admin.sidebar.skills.publish",
                        dgat: "global.navigation.admin.sidebar.skills.publish",
                        analytics: "global.navigation.admin.sidebar.skills.publish",
                        href: "/orgs/<orgId>/skills-platform/publish-skills"
                    },
                    {
                        text: "Settings",
                        i18n: "global.navigation.admin.sidebar.skills.settings, Core_Settings",
                        dgat: "global.navigation.admin.sidebar.skills.settings",
                        analytics: "global.navigation.admin.sidebar.skills.settings",
                        href: "/orgs/<orgId>/skills/settings"
                    }
                ]
            },
            {
                headerTitle: "Content Marketplace",
                headerTitleI18n: "global.navigation.admin.sidebar.content-marketplace, Core_Marketplace",
                text: "Content Marketplace",
                i18n: "global.navigation.admin.sidebar.content-marketplace, Core_Marketplace",
                dgat: "global.navigation.admin.sidebar.content-marketplace",
                analytics: "global.navigation.admin.sidebar.content-marketplace",
                icon: "building-storefront",
                href: "<learnInSSOUrl>#/admin/programs"
            },
            {
                headerTitle: "Automations",
                headerTitleI18n: "global.navigation.admin.sidebar.automations, Automation_Automations",
                text: "Automations",
                i18n: "global.navigation.admin.sidebar.automations, Automation_Automations",
                dgat: "global.navigation.admin.sidebar.automations",
                analytics: "global.navigation.admin.sidebar.automations",
                icon: "bolt",
                href: "/orgs/<orgId>/automations"
            },
            {
                headerTitle: "Reporting",
                headerTitleI18n: "global.navigation.admin.sidebar.reporting, OrganizationsController_Reporting",
                text: "Reporting",
                i18n: "global.navigation.admin.sidebar.reporting, OrganizationsController_Reporting",
                dgat: "global.navigation.admin.sidebar.reporting",
                analytics: "global.navigation.admin.sidebar.reporting",
                icon: "document-chart-bar",
                children: [
                    {
                        text: "Reports",
                        i18n: "global.navigation.admin.sidebar.reporting.reports, ReportingInApp_Reports",
                        dgat: "global.navigation.admin.sidebar.reporting.reports",
                        analytics: "global.navigation.admin.sidebar.reporting.reports",
                        href: "/orgs/<orgId>/reporting"
                    },
                    {
                        text: "Presets",
                        i18n: "global.navigation.admin.sidebar.reporting.presets, ReportingInApp_SavedPresets",
                        dgat: "global.navigation.admin.sidebar.reporting.presets",
                        analytics: "global.navigation.admin.sidebar.reporting.presets",
                        href: "/orgs/<orgId>/reporting/presets"
                    },
                    {
                        text: "Categories",
                        i18n: "global.navigation.admin.sidebar.reporting.categories, ReportingInApp_Categories",
                        dgat: "global.navigation.admin.sidebar.reporting.categories",
                        analytics: "global.navigation.admin.sidebar.reporting.categories",
                        href: "/orgs/<orgId>/reporting/create"
                    },
                    {
                        text: "FTP",
                        i18n: "global.navigation.admin.sidebar.reporting.ftp, OrgManage_ReportSchedule_FTP",
                        dgat: "global.navigation.admin.sidebar.reporting.ftp",
                        analytics: "global.navigation.admin.sidebar.reporting.ftp",
                        href: "/orgs/<orgId>/reporting/reportSchedule"
                    },
                    {
                        text: "Configurations",
                        i18n: "global.navigation.admin.sidebar.reporting.configurations, Reporting_Transmitters_Configurations",
                        dgat: "global.navigation.admin.sidebar.reporting.configurations",
                        analytics: "global.navigation.admin.sidebar.reporting.configurations",
                        href: "/orgs/<orgId>/reporting/configurations"
                    },
                    {
                        text: "Segments",
                        i18n: "global.navigation.admin.sidebar.reporting.segments, ReportingInApp_Segments",
                        dgat: "global.navigation.admin.sidebar.reporting.segments",
                        analytics: "global.navigation.admin.sidebar.reporting.segments",
                        href: "/orgs/<orgId>/reporting/segments"
                    },
                    {
                        text: "Advanced Analytics",
                        i18n: "global.navigation.admin.sidebar.reporting.advanced-analytics",
                        dgat: "global.navigation.admin.sidebar.reporting.advanced-analytics",
                        analytics: "global.navigation.admin.sidebar.reporting.advanced-analytics",
                        href: "/analytics?tag=1",
                        target: "_blank"
                    }
                ]
            },
            {
                headerTitle: "Integrations",
                headerTitleI18n: "global.navigation.admin.sidebar.integrations",
                text: "Integrations",
                i18n: "global.navigation.admin.sidebar.integrations",
                dgat: "global.navigation.admin.sidebar.integrations",
                analytics: "global.navigation.admin.sidebar.integrations",
                icon: "puzzle-piece",
                children: [
                    {
                        text: "Connected",
                        i18n: "global.navigation.admin.sidebar.integrations.connected, Core_Connected",
                        dgat: "global.navigation.admin.sidebar.integrations.connected",
                        analytics: "global.navigation.admin.sidebar.integrations.connected",
                        href: "/orgs/<orgId>/settings/integrationProviders"
                    },
                    {
                        text: "Directory",
                        i18n: "global.navigation.admin.sidebar.integrations.directory, Core_Directory",
                        dgat: "global.navigation.admin.sidebar.integrations.directory",
                        analytics: "global.navigation.admin.sidebar.integrations.directory",
                        href: "https://integrations.degreed.com/?host=degreedstg.staging.degreed.dev",
                        target: "_blank"
                    },
                    {
                        text: "API Keys",
                        i18n: "global.navigation.admin.sidebar.integrations.api-keys, Integrations_APIKeys",
                        dgat: "global.navigation.admin.sidebar.integrations.api-keys",
                        analytics: "global.navigation.admin.sidebar.integrations.api-keys",
                        href: "/orgs/<orgId>/settings/manageCredentials"
                    },
                    {
                        text: "File Upload",
                        i18n: "global.navigation.admin.sidebar.integrations.file-upload, OrganizationsController_FileUpload",
                        dgat: "global.navigation.admin.sidebar.integrations.file-upload",
                        analytics: "global.navigation.admin.sidebar.integrations.file-upload",
                        href: "/orgs/<orgId>/fileupload/uploadFile"
                    },
                    {
                        text: "File Log",
                        i18n: "global.navigation.admin.sidebar.integrations.file-log, OrganizationsController_FileLog",
                        dgat: "global.navigation.admin.sidebar.integrations.file-log",
                        analytics: "global.navigation.admin.sidebar.integrations.file-log",
                        href: "/orgs/<orgId>/fileupload/fileLog"
                    },
                    {
                        text: "Webooks",
                        i18n: "global.navigation.admin.sidebar.integrations.webhooks, Webhooks_Heading",
                        dgat: "global.navigation.admin.sidebar.integrations.webhooks",
                        analytics: "global.navigation.admin.sidebar.integrations.webhooks",
                        href: "/orgs/<orgId>/webhooks"
                    }
                ]
            },
            {
                headerTitle: "Settings",
                headerTitleI18n: "global.navigation.admin.sidebar.settings, Core_Settings",
                text: "Settings",
                i18n: "global.navigation.admin.sidebar.settings, Core_Settings",
                dgat: "global.navigation.admin.sidebar.settings",
                analytics: "global.navigation.admin.sidebar.settings",
                icon: "cog-6-tooth",
                children: [
                    {
                        text: "Branding",
                        i18n: "global.navigation.admin.sidebar.settings.branding, OrgSettingsNav_Branding",
                        dgat: "global.navigation.admin.sidebar.settings.branding",
                        analytics: "global.navigation.admin.sidebar.settings.branding",
                        href: "/orgs/<orgId>/settings/branding"
                    },
                    {
                        text: "Home",
                        i18n: "global.navigation.admin.sidebar.settings.home, Core_Home",
                        dgat: "global.navigation.admin.sidebar.settings.home",
                        analytics: "global.navigation.admin.sidebar.settings.home",
                        href: "/orgs/<orgId>/settings/home"
                    },
                    {
                        text: "Help Menu",
                        i18n: "global.navigation.admin.sidebar.settings.help-menu, OrgSettingsNav_HelpMenu",
                        dgat: "global.navigation.admin.sidebar.settings.help-menu",
                        analytics: "global.navigation.admin.sidebar.settings.help-menu",
                        href: "/orgs/<orgId>/settings/helpMenu"
                    },
                    {
                        text: "Communication",
                        i18n: "global.navigation.admin.sidebar.settings.communication, User_Communications",
                        dgat: "global.navigation.admin.sidebar.settings.communication",
                        analytics: "global.navigation.admin.sidebar.settings.communication",
                        href: "/orgs/<orgId>/settings/communications"
                    },
                    {
                        text: "FAQ",
                        i18n: "global.navigation.admin.sidebar.settings.faq, OrganizationsController_FAQ",
                        dgat: "global.navigation.admin.sidebar.settings.faq",
                        analytics: "global.navigation.admin.sidebar.settings.faq",
                        href: "/orgs/<orgId>/settings/faq"
                    },
                    {
                        text: "Messaging",
                        i18n: "global.navigation.admin.sidebar.settings.messaging, OrganizationsController_Messaging",
                        dgat: "global.navigation.admin.sidebar.settings.messaging",
                        analytics: "global.navigation.admin.sidebar.settings.messaging",
                        href: "/orgs/<orgId>/settings/messaging"
                    },
                    {
                        text: "Security",
                        i18n: "global.navigation.admin.sidebar.settings.security, OrgSettings_Security_PageTitle",
                        dgat: "global.navigation.admin.sidebar.settings.security",
                        analytics: "global.navigation.admin.sidebar.settings.security",
                        href: "/orgs/<orgId>/settings/security"
                    }
                ]
            },
            {
                headerTitle: "Extended Enterprise",
                headerTitleI18n: "global.navigation.admin.sidebar.extended-enterprise, OrgManage_ExtendedEnterprise",
                text: "Extended Enterprise",
                i18n: "global.navigation.admin.sidebar.extended-enterprise, OrgManage_ExtendedEnterprise",
                dgat: "global.navigation.admin.sidebar.extended-enterprise",
                analytics: "global.navigation.admin.sidebar.extended-enterprise",
                icon: "building-office-2",
                href: "/channel"
            },
            {
                headerTitle: "Help",
                headerTitleI18n: "global.navigation.admin.sidebar.help, Core_Help",
                text: "Help",
                i18n: "global.navigation.admin.sidebar.help, Core_Help",
                dgat: "global.navigation.admin.sidebar.help",
                analytics: "global.navigation.admin.sidebar.help",
                icon: "lifebuoy",
                children: [
                    {
                        text: "Knowledge Center",
                        i18n: "global.navigation.admin.sidebar.help.knowledge-center, FeedbackPartial_KnowledgeCenter",
                        dgat: "global.navigation.admin.sidebar.help.knowledge-center",
                        analytics: "global.navigation.admin.sidebar.help.knowledge-center",
                        href: "/orgs/<orgId>/settings/helpMenu",
                        target: "_blank"
                    },
                    {
                        text: "Privacy Policy",
                        i18n: "global.navigation.admin.sidebar.help.privacy-policy, FeedbackPartial_PrivacyPolicy",
                        dgat: "global.navigation.admin.sidebar.help.privacy-policy",
                        analytics: "global.navigation.admin.sidebar.help.privacy-policy",
                        href: "/about/privacy",
                        target: "_blank"
                    },
                    {
                        text: "Cookie Notice",
                        i18n: "global.navigation.admin.sidebar.help.cookie-notice, OrgSettings_ShowCookiePolicyLink_Name",
                        dgat: "global.navigation.admin.sidebar.help.cookie-notice",
                        analytics: "global.navigation.admin.sidebar.help.cookie-notice",
                        href: "/api/about/cookienotice",
                        target: "_blank"
                    },
                    {
                        text: "Frequently Asked Questions",
                        i18n: "global.navigation.admin.sidebar.help.faq, OrgSettings_OrgSupportInfoFaq_Name",
                        dgat: "global.navigation.admin.sidebar.help.faq",
                        analytics: "global.navigation.admin.sidebar.help.faq",
                        href: "/orgs/<orgId>/settings/faq",
                        target: "_blank",
                        includeSeparator: true
                    },
                    {
                        text: "",
                        dgat: "global.navigation.admin.sidebar.help.custom-link",
                        analytics: "global.navigation.admin.sidebar.help.custom-link",
                        href: "#"
                    },
                    {
                        text: "",
                        dgat: "global.navigation.admin.sidebar.help.support-phone",
                        analytics: "global.navigation.admin.sidebar.help.support-phone",
                        icon: "phone",
                        href: "#",
                        includeSeparator: true
                    },
                    {
                        text: "",
                        dgat: "global.navigation.admin.sidebar.help.support-email",
                        analytics: "global.navigation.admin.sidebar.help.support-email",
                        icon: "envelope",
                        href: "#"
                    }
                ]
            }
        ],
        bottom: []
    }
};
var SkillsPlatformConfig = {
    admin: admin
};

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
/**
 * Custom Hook to load Apollo Layout configuration for ACM
 */ var useApolloLayout_Acm = function(options) {
    var lang = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en";
    var i18n = useTranslations(lang, options.translate);
    var lxpOptions = useLxpOptions(options);
    var loadConfiguration = useCallback(function() {
        // LXP to ACM config does not contain a learner aspect.
        // Only use this configuration if the user is an LXP admin and is navigating to ACM's admin view.
        return options.isLxpAdmin && options.isAdminPath ? LxpToAcmConfig : AcmConfig;
    }, [
        options.isLxpAdmin,
        options.isAdminPath
    ]);
    var _useState = _sliced_to_array(useState(function() {
        return initApolloSkeleton(loadConfiguration(), options);
    }), 2), response = _useState[0], setResponse = _useState[1];
    // When ACM options are ready, update the layout aspect
    useEffect(function() {
        if (lxpOptions && i18n.translations) {
            var _lxpOptions_branding, _lxpOptions_authUser;
            var updated = loadConfiguration();
            updated = updateVisibility(updated);
            updated = updatei18n(updated, i18n.t);
            updated = updateUser(updated, lxpOptions.authUser);
            updated = updateNavigationBranding(updated, (_lxpOptions_branding = lxpOptions.branding) === null || _lxpOptions_branding === void 0 ? void 0 : _lxpOptions_branding.navigation);
            updated = updateWithFilters(updated, {
                lxp: lxpOptions,
                acm: options
            });
            updated = updateHelpMenu(updated, (_lxpOptions_authUser = lxpOptions.authUser) === null || _lxpOptions_authUser === void 0 ? void 0 : _lxpOptions_authUser.defaultOrgId, lxpOptions.supportInfo);
            var showApolloLayout = options.isFeatureFlagOn.ACMLayout && (!options.isLxpAdmin || options.isFeatureFlagOn.LXPAdminLayout);
            var layoutAspect = options.isAdminPath ? updated === null || updated === void 0 ? void 0 : updated.admin : updated === null || updated === void 0 ? void 0 : updated.learner;
            setResponse({
                layoutAspect: layoutAspect,
                showApolloLayout: showApolloLayout
            });
        }
    }, [
        options,
        lxpOptions,
        i18n.t,
        i18n.translations,
        loadConfiguration
    ]);
    return response;
};
/**
 * Custom Hook to load Apollo Layout configuration for Skills Platform
 */ var useApolloLayout_SkaaS = function(lang, options) {
    var i18n = useTranslations(lang);
    var lxpOptions = useLxpOptions(options); // async loading of LXP options
    var _useState = _sliced_to_array(useState(function() {
        return SkillsPlatformConfig;
    }), 1), configuration = _useState[0];
    var _useState1 = _sliced_to_array(useState(function() {
        return initApolloSkeleton(configuration, options);
    }), 2), response = _useState1[0], setResponse = _useState1[1];
    // When Skills Platfroms options are ready, update the layout aspect
    useEffect(function() {
        if (lxpOptions && i18n.translations) {
            var _lxpOptions_branding, _lxpOptions_authUser;
            var updated = configuration;
            updated = updateVisibility(updated);
            updated = updatei18n(updated, i18n.t);
            updated = updateUser(updated, lxpOptions.authUser);
            updated = updateNavigationBranding(updated, (_lxpOptions_branding = lxpOptions.branding) === null || _lxpOptions_branding === void 0 ? void 0 : _lxpOptions_branding.navigation);
            updated = updateWithFilters(updated, {
                lxp: lxpOptions
            });
            updated = updateHelpMenu(updated, (_lxpOptions_authUser = lxpOptions.authUser) === null || _lxpOptions_authUser === void 0 ? void 0 : _lxpOptions_authUser.defaultOrgId, lxpOptions.supportInfo);
            var showApolloLayout = useApolloLayout();
            var layoutAspect = options.isAdminPath ? updated === null || updated === void 0 ? void 0 : updated.admin : updated === null || updated === void 0 ? void 0 : updated.learner;
            setResponse({
                layoutAspect: layoutAspect,
                showApolloLayout: showApolloLayout
            });
        }
    }, [
        options.isAdminPath,
        lxpOptions,
        configuration,
        i18n.t,
        i18n.translations
    ]);
    return response;
};
/**
 * Load authenticated user, org info, branding, and featureFlags from LXP endpoints
 */ var useLxpOptions = function(param) {
    var isLxpApiEnabled = param.isLxpApiEnabled, featureFlags = param.featureFlags, orgId = param.orgId;
    var _useState = _sliced_to_array(useState(null), 2), options = _useState[0], setOptions = _useState[1];
    useEffect(function() {
        var fetchLxpPermissions = function() {
            var _ref = _async_to_generator(function() {
                var _ref, authUser, supportInfo, organizationId, orgInfo, branding;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                loadLxpPermissions(isLxpApiEnabled)
                            ];
                        case 1:
                            _ref = _state.sent(), authUser = _ref.authUser, supportInfo = _ref.supportInfo;
                            organizationId = orgId || authUser.defaultOrgId;
                            orgInfo = authUser.orgInfo.find(function(x) {
                                return x.organizationId === organizationId;
                            }) || initOrgInfo();
                            return [
                                4,
                                loadBranding(authUser, orgInfo, isLxpApiEnabled)
                            ];
                        case 2:
                            branding = _state.sent();
                            if (featureFlags.apollo) {
                                // Initialize Apollo lookup feature flags for future access
                                configureApolloWithFeatureFlags(function(key) {
                                    var apolloFlags = featureFlags.apollo;
                                    return apolloFlags[key];
                                });
                            }
                            // Publish full set of LxP options that were loaded asynchronously.
                            setOptions({
                                authUser: authUser,
                                orgInfo: orgInfo,
                                supportInfo: supportInfo,
                                featureFlags: featureFlags,
                                branding: branding
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchLxpPermissions() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchLxpPermissions();
    }, [
        orgId,
        isLxpApiEnabled,
        featureFlags
    ]);
    return options;
};
/**
 * Build correct initial Layout without navigation items...
 * since those are async filtered and updated later
 */ var initApolloSkeleton = function(configuration, options) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var updated = updatei18n(configuration, function(val) {
        return val;
    });
    var isAdmin = options.isAdminPath || options.isLxpAdmin;
    var layoutAspect = isAdmin ? updated === null || updated === void 0 ? void 0 : updated.admin : updated === null || updated === void 0 ? void 0 : updated.learner;
    return d$1({
        layoutAspect: _object_spread_props(_object_spread({}, layoutAspect), {
            navigation: {
                top: []
            }
        }),
        showApolloLayout: true
    });
};

export { CalendarProvider, CurrencyCode, FEATURE_FLAGS, FeatureFlagExperiments, LAYOUT_FEATURE_FLAG_KEYS, LanguagePreference, buildFeatureFlagsFrom, configureApolloWithFeatureFlags, contextService, getGroupNames, initFeatureFlags, initOrgInfo, loadFeatureFlags, loadLxpPermissions, sameOriginRequestInit, updateHelpMenu, updateNavigationBranding, updateUser, updateVisibility, updateWithFilters, updatei18n, useApolloLayout, useApolloLayout_Acm, useApolloLayout_Admin_V2, useApolloLayout_Admin_V3, useApolloLayout_Learner_V2, useApolloLayout_Learner_V3, useApolloLayout_Refresh, useApolloLayout_SkaaS, useLxpOptions };
